function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec87a"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec87a"] = parcelRequire;
}
parcelRequire.register("aR5t2", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $7e73185800a5dd7b$export$ffb0004e005737fa, (v) => $7e73185800a5dd7b$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $7e73185800a5dd7b$export$34b9dba7ce09269b, (v) => $7e73185800a5dd7b$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $7e73185800a5dd7b$export$25062201e9e25d76, (v) => $7e73185800a5dd7b$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7e73185800a5dd7b$export$ffb0004e005737fa;
var $7e73185800a5dd7b$export$34b9dba7ce09269b;
var $7e73185800a5dd7b$export$25062201e9e25d76;
"use strict";

var $5vDX4 = parcelRequire("5vDX4");
var $7e73185800a5dd7b$var$k = Symbol.for("react.element"), $7e73185800a5dd7b$var$l = Symbol.for("react.fragment"), $7e73185800a5dd7b$var$m = Object.prototype.hasOwnProperty, $7e73185800a5dd7b$var$n = $5vDX4.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $7e73185800a5dd7b$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7e73185800a5dd7b$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$7e73185800a5dd7b$var$m.call(a, b) && !$7e73185800a5dd7b$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $7e73185800a5dd7b$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $7e73185800a5dd7b$var$n.current
    };
}
$7e73185800a5dd7b$export$ffb0004e005737fa = $7e73185800a5dd7b$var$l;
$7e73185800a5dd7b$export$34b9dba7ce09269b = $7e73185800a5dd7b$var$q;
$7e73185800a5dd7b$export$25062201e9e25d76 = $7e73185800a5dd7b$var$q;

});
parcelRequire.register("5vDX4", function(module, exports) {
"use strict";

module.exports = (parcelRequire("guG0E"));

});
parcelRequire.register("guG0E", function(module, exports) {

$parcel$export(module.exports, "Children", () => $c02008e88195fe9e$export$dca3b0875bd9a954, (v) => $c02008e88195fe9e$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $c02008e88195fe9e$export$16fa2f45be04daa8, (v) => $c02008e88195fe9e$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $c02008e88195fe9e$export$ffb0004e005737fa, (v) => $c02008e88195fe9e$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $c02008e88195fe9e$export$e2c29f18771995cb, (v) => $c02008e88195fe9e$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $c02008e88195fe9e$export$221d75b3f55bb0bd, (v) => $c02008e88195fe9e$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $c02008e88195fe9e$export$5f8d39834fd61797, (v) => $c02008e88195fe9e$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $c02008e88195fe9e$export$74bf444e3cd11ea5, (v) => $c02008e88195fe9e$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $c02008e88195fe9e$export$ae55be85d98224ed, (v) => $c02008e88195fe9e$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $c02008e88195fe9e$export$e530037191fcd5d7, (v) => $c02008e88195fe9e$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $c02008e88195fe9e$export$fd42f52fd3ae1109, (v) => $c02008e88195fe9e$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $c02008e88195fe9e$export$c8a8987d4410bf2d, (v) => $c02008e88195fe9e$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $c02008e88195fe9e$export$d38cd72104c1f0e9, (v) => $c02008e88195fe9e$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $c02008e88195fe9e$export$7d1e3a5e95ceca43, (v) => $c02008e88195fe9e$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $c02008e88195fe9e$export$257a8862b851cb5b, (v) => $c02008e88195fe9e$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $c02008e88195fe9e$export$a8257692ac88316c, (v) => $c02008e88195fe9e$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $c02008e88195fe9e$export$488013bae63b21da, (v) => $c02008e88195fe9e$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $c02008e88195fe9e$export$7c73462e0d25e514, (v) => $c02008e88195fe9e$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $c02008e88195fe9e$export$7568632d0d33d16d, (v) => $c02008e88195fe9e$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $c02008e88195fe9e$export$88948ce120ea2619, (v) => $c02008e88195fe9e$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $c02008e88195fe9e$export$35808ee640e87ca7, (v) => $c02008e88195fe9e$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $c02008e88195fe9e$export$fae74005e78b1a27, (v) => $c02008e88195fe9e$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $c02008e88195fe9e$export$dc8fbce3eb94dc1e, (v) => $c02008e88195fe9e$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $c02008e88195fe9e$export$6a7bc4e911dc01cf, (v) => $c02008e88195fe9e$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $c02008e88195fe9e$export$6d9c69b0de29b591, (v) => $c02008e88195fe9e$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $c02008e88195fe9e$export$f680877a34711e37, (v) => $c02008e88195fe9e$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $c02008e88195fe9e$export$d5a552a76deda3c2, (v) => $c02008e88195fe9e$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $c02008e88195fe9e$export$aaabe4eda9ed9969, (v) => $c02008e88195fe9e$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $c02008e88195fe9e$export$e5c5a5f917a5871c, (v) => $c02008e88195fe9e$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $c02008e88195fe9e$export$1538c33de8887b59, (v) => $c02008e88195fe9e$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $c02008e88195fe9e$export$13e3392192263954, (v) => $c02008e88195fe9e$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $c02008e88195fe9e$export$b8f5890fc79d6aca, (v) => $c02008e88195fe9e$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $c02008e88195fe9e$export$60241385465d0a34, (v) => $c02008e88195fe9e$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $c02008e88195fe9e$export$306c0aa65ff9ec16, (v) => $c02008e88195fe9e$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $c02008e88195fe9e$export$7b286972b8d8ccbf, (v) => $c02008e88195fe9e$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $c02008e88195fe9e$export$83d89fbfd8236492, (v) => $c02008e88195fe9e$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c02008e88195fe9e$export$dca3b0875bd9a954;
var $c02008e88195fe9e$export$16fa2f45be04daa8;
var $c02008e88195fe9e$export$ffb0004e005737fa;
var $c02008e88195fe9e$export$e2c29f18771995cb;
var $c02008e88195fe9e$export$221d75b3f55bb0bd;
var $c02008e88195fe9e$export$5f8d39834fd61797;
var $c02008e88195fe9e$export$74bf444e3cd11ea5;
var $c02008e88195fe9e$export$ae55be85d98224ed;
var $c02008e88195fe9e$export$e530037191fcd5d7;
var $c02008e88195fe9e$export$fd42f52fd3ae1109;
var $c02008e88195fe9e$export$c8a8987d4410bf2d;
var $c02008e88195fe9e$export$d38cd72104c1f0e9;
var $c02008e88195fe9e$export$7d1e3a5e95ceca43;
var $c02008e88195fe9e$export$257a8862b851cb5b;
var $c02008e88195fe9e$export$a8257692ac88316c;
var $c02008e88195fe9e$export$488013bae63b21da;
var $c02008e88195fe9e$export$7c73462e0d25e514;
var $c02008e88195fe9e$export$7568632d0d33d16d;
var $c02008e88195fe9e$export$88948ce120ea2619;
var $c02008e88195fe9e$export$35808ee640e87ca7;
var $c02008e88195fe9e$export$fae74005e78b1a27;
var $c02008e88195fe9e$export$dc8fbce3eb94dc1e;
var $c02008e88195fe9e$export$6a7bc4e911dc01cf;
var $c02008e88195fe9e$export$6d9c69b0de29b591;
var $c02008e88195fe9e$export$f680877a34711e37;
var $c02008e88195fe9e$export$d5a552a76deda3c2;
var $c02008e88195fe9e$export$aaabe4eda9ed9969;
var $c02008e88195fe9e$export$e5c5a5f917a5871c;
var $c02008e88195fe9e$export$1538c33de8887b59;
var $c02008e88195fe9e$export$13e3392192263954;
var $c02008e88195fe9e$export$b8f5890fc79d6aca;
var $c02008e88195fe9e$export$60241385465d0a34;
var $c02008e88195fe9e$export$306c0aa65ff9ec16;
var $c02008e88195fe9e$export$7b286972b8d8ccbf;
var $c02008e88195fe9e$export$83d89fbfd8236492;
"use strict";
var $c02008e88195fe9e$var$l = Symbol.for("react.element"), $c02008e88195fe9e$var$n = Symbol.for("react.portal"), $c02008e88195fe9e$var$p = Symbol.for("react.fragment"), $c02008e88195fe9e$var$q = Symbol.for("react.strict_mode"), $c02008e88195fe9e$var$r = Symbol.for("react.profiler"), $c02008e88195fe9e$var$t = Symbol.for("react.provider"), $c02008e88195fe9e$var$u = Symbol.for("react.context"), $c02008e88195fe9e$var$v = Symbol.for("react.forward_ref"), $c02008e88195fe9e$var$w = Symbol.for("react.suspense"), $c02008e88195fe9e$var$x = Symbol.for("react.memo"), $c02008e88195fe9e$var$y = Symbol.for("react.lazy"), $c02008e88195fe9e$var$z = Symbol.iterator;
function $c02008e88195fe9e$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c02008e88195fe9e$var$z && a[$c02008e88195fe9e$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c02008e88195fe9e$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c02008e88195fe9e$var$C = Object.assign, $c02008e88195fe9e$var$D = {};
function $c02008e88195fe9e$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c02008e88195fe9e$var$D;
    this.updater = e || $c02008e88195fe9e$var$B;
}
$c02008e88195fe9e$var$E.prototype.isReactComponent = {};
$c02008e88195fe9e$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c02008e88195fe9e$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c02008e88195fe9e$var$F() {}
$c02008e88195fe9e$var$F.prototype = $c02008e88195fe9e$var$E.prototype;
function $c02008e88195fe9e$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c02008e88195fe9e$var$D;
    this.updater = e || $c02008e88195fe9e$var$B;
}
var $c02008e88195fe9e$var$H = $c02008e88195fe9e$var$G.prototype = new $c02008e88195fe9e$var$F;
$c02008e88195fe9e$var$H.constructor = $c02008e88195fe9e$var$G;
$c02008e88195fe9e$var$C($c02008e88195fe9e$var$H, $c02008e88195fe9e$var$E.prototype);
$c02008e88195fe9e$var$H.isPureReactComponent = !0;
var $c02008e88195fe9e$var$I = Array.isArray, $c02008e88195fe9e$var$J = Object.prototype.hasOwnProperty, $c02008e88195fe9e$var$K = {
    current: null
}, $c02008e88195fe9e$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c02008e88195fe9e$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c02008e88195fe9e$var$J.call(b, d) && !$c02008e88195fe9e$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c02008e88195fe9e$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c02008e88195fe9e$var$K.current
    };
}
function $c02008e88195fe9e$var$N(a, b) {
    return {
        $$typeof: $c02008e88195fe9e$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c02008e88195fe9e$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c02008e88195fe9e$var$l;
}
function $c02008e88195fe9e$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c02008e88195fe9e$var$P = /\/+/g;
function $c02008e88195fe9e$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c02008e88195fe9e$var$escape("" + a.key) : b.toString(36);
}
function $c02008e88195fe9e$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c02008e88195fe9e$var$l:
                case $c02008e88195fe9e$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c02008e88195fe9e$var$Q(h, 0) : d, $c02008e88195fe9e$var$I(c) ? (e = "", null != a && (e = a.replace($c02008e88195fe9e$var$P, "$&/") + "/"), $c02008e88195fe9e$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c02008e88195fe9e$var$O(c) && (c = $c02008e88195fe9e$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c02008e88195fe9e$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c02008e88195fe9e$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c02008e88195fe9e$var$Q(k, g);
        h += $c02008e88195fe9e$var$R(k, b, e, f, c);
    }
    else if (f = $c02008e88195fe9e$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c02008e88195fe9e$var$Q(k, g++), h += $c02008e88195fe9e$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c02008e88195fe9e$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c02008e88195fe9e$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c02008e88195fe9e$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c02008e88195fe9e$var$U = {
    current: null
}, $c02008e88195fe9e$var$V = {
    transition: null
}, $c02008e88195fe9e$var$W = {
    ReactCurrentDispatcher: $c02008e88195fe9e$var$U,
    ReactCurrentBatchConfig: $c02008e88195fe9e$var$V,
    ReactCurrentOwner: $c02008e88195fe9e$var$K
};
$c02008e88195fe9e$export$dca3b0875bd9a954 = {
    map: $c02008e88195fe9e$var$S,
    forEach: function(a, b, e) {
        $c02008e88195fe9e$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $c02008e88195fe9e$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c02008e88195fe9e$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c02008e88195fe9e$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c02008e88195fe9e$export$16fa2f45be04daa8 = $c02008e88195fe9e$var$E;
$c02008e88195fe9e$export$ffb0004e005737fa = $c02008e88195fe9e$var$p;
$c02008e88195fe9e$export$e2c29f18771995cb = $c02008e88195fe9e$var$r;
$c02008e88195fe9e$export$221d75b3f55bb0bd = $c02008e88195fe9e$var$G;
$c02008e88195fe9e$export$5f8d39834fd61797 = $c02008e88195fe9e$var$q;
$c02008e88195fe9e$export$74bf444e3cd11ea5 = $c02008e88195fe9e$var$w;
$c02008e88195fe9e$export$ae55be85d98224ed = $c02008e88195fe9e$var$W;
$c02008e88195fe9e$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c02008e88195fe9e$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c02008e88195fe9e$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c02008e88195fe9e$var$J.call(b, f) && !$c02008e88195fe9e$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c02008e88195fe9e$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c02008e88195fe9e$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c02008e88195fe9e$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c02008e88195fe9e$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c02008e88195fe9e$export$c8a8987d4410bf2d = $c02008e88195fe9e$var$M;
$c02008e88195fe9e$export$d38cd72104c1f0e9 = function(a) {
    var b = $c02008e88195fe9e$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c02008e88195fe9e$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c02008e88195fe9e$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c02008e88195fe9e$var$v,
        render: a
    };
};
$c02008e88195fe9e$export$a8257692ac88316c = $c02008e88195fe9e$var$O;
$c02008e88195fe9e$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c02008e88195fe9e$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c02008e88195fe9e$var$T
    };
};
$c02008e88195fe9e$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c02008e88195fe9e$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c02008e88195fe9e$export$7568632d0d33d16d = function(a) {
    var b = $c02008e88195fe9e$var$V.transition;
    $c02008e88195fe9e$var$V.transition = {};
    try {
        a();
    } finally{
        $c02008e88195fe9e$var$V.transition = b;
    }
};
$c02008e88195fe9e$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$c02008e88195fe9e$export$35808ee640e87ca7 = function(a, b) {
    return $c02008e88195fe9e$var$U.current.useCallback(a, b);
};
$c02008e88195fe9e$export$fae74005e78b1a27 = function(a) {
    return $c02008e88195fe9e$var$U.current.useContext(a);
};
$c02008e88195fe9e$export$dc8fbce3eb94dc1e = function() {};
$c02008e88195fe9e$export$6a7bc4e911dc01cf = function(a) {
    return $c02008e88195fe9e$var$U.current.useDeferredValue(a);
};
$c02008e88195fe9e$export$6d9c69b0de29b591 = function(a, b) {
    return $c02008e88195fe9e$var$U.current.useEffect(a, b);
};
$c02008e88195fe9e$export$f680877a34711e37 = function() {
    return $c02008e88195fe9e$var$U.current.useId();
};
$c02008e88195fe9e$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c02008e88195fe9e$var$U.current.useImperativeHandle(a, b, e);
};
$c02008e88195fe9e$export$aaabe4eda9ed9969 = function(a, b) {
    return $c02008e88195fe9e$var$U.current.useInsertionEffect(a, b);
};
$c02008e88195fe9e$export$e5c5a5f917a5871c = function(a, b) {
    return $c02008e88195fe9e$var$U.current.useLayoutEffect(a, b);
};
$c02008e88195fe9e$export$1538c33de8887b59 = function(a, b) {
    return $c02008e88195fe9e$var$U.current.useMemo(a, b);
};
$c02008e88195fe9e$export$13e3392192263954 = function(a, b, e) {
    return $c02008e88195fe9e$var$U.current.useReducer(a, b, e);
};
$c02008e88195fe9e$export$b8f5890fc79d6aca = function(a) {
    return $c02008e88195fe9e$var$U.current.useRef(a);
};
$c02008e88195fe9e$export$60241385465d0a34 = function(a) {
    return $c02008e88195fe9e$var$U.current.useState(a);
};
$c02008e88195fe9e$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c02008e88195fe9e$var$U.current.useSyncExternalStore(a, b, e);
};
$c02008e88195fe9e$export$7b286972b8d8ccbf = function() {
    return $c02008e88195fe9e$var$U.current.useTransition();
};
$c02008e88195fe9e$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("a4UIc", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $756644e23111daff$export$ae55be85d98224ed, (v) => $756644e23111daff$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $756644e23111daff$export$d39a5bbd09211389, (v) => $756644e23111daff$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $756644e23111daff$export$882461b6382ed46c, (v) => $756644e23111daff$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $756644e23111daff$export$466bfc07425424d5, (v) => $756644e23111daff$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $756644e23111daff$export$cd75ccfd720a3cd4, (v) => $756644e23111daff$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $756644e23111daff$export$fa8d919ba61d84db, (v) => $756644e23111daff$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $756644e23111daff$export$757ceba2d55c277e, (v) => $756644e23111daff$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $756644e23111daff$export$b3890eb0ae9dca99, (v) => $756644e23111daff$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $756644e23111daff$export$502457920280e6be, (v) => $756644e23111daff$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $756644e23111daff$export$c78a37762a8d58e1, (v) => $756644e23111daff$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $756644e23111daff$export$dc54d992c10e8a18, (v) => $756644e23111daff$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $756644e23111daff$export$83d89fbfd8236492, (v) => $756644e23111daff$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $756644e23111daff$export$ae55be85d98224ed;
var $756644e23111daff$export$d39a5bbd09211389;
var $756644e23111daff$export$882461b6382ed46c;
var $756644e23111daff$export$466bfc07425424d5;
var $756644e23111daff$export$cd75ccfd720a3cd4;
var $756644e23111daff$export$fa8d919ba61d84db;
var $756644e23111daff$export$757ceba2d55c277e;
var $756644e23111daff$export$b3890eb0ae9dca99;
var $756644e23111daff$export$502457920280e6be;
var $756644e23111daff$export$c78a37762a8d58e1;
var $756644e23111daff$export$dc54d992c10e8a18;
var $756644e23111daff$export$83d89fbfd8236492;
"use strict";

var $5vDX4 = parcelRequire("5vDX4");

var $azdYD = parcelRequire("azdYD");
function $756644e23111daff$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $756644e23111daff$var$da = new Set, $756644e23111daff$var$ea = {};
function $756644e23111daff$var$fa(a, b) {
    $756644e23111daff$var$ha(a, b);
    $756644e23111daff$var$ha(a + "Capture", b);
}
function $756644e23111daff$var$ha(a, b) {
    $756644e23111daff$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$756644e23111daff$var$da.add(b[a]);
}
var $756644e23111daff$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $756644e23111daff$var$ja = Object.prototype.hasOwnProperty, $756644e23111daff$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $756644e23111daff$var$la = {}, $756644e23111daff$var$ma = {};
function $756644e23111daff$var$oa(a) {
    if ($756644e23111daff$var$ja.call($756644e23111daff$var$ma, a)) return !0;
    if ($756644e23111daff$var$ja.call($756644e23111daff$var$la, a)) return !1;
    if ($756644e23111daff$var$ka.test(a)) return $756644e23111daff$var$ma[a] = !0;
    $756644e23111daff$var$la[a] = !0;
    return !1;
}
function $756644e23111daff$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $756644e23111daff$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $756644e23111daff$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $756644e23111daff$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $756644e23111daff$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $756644e23111daff$var$z[a] = new $756644e23111daff$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $756644e23111daff$var$z[b] = new $756644e23111daff$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $756644e23111daff$var$z[a] = new $756644e23111daff$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $756644e23111daff$var$z[a] = new $756644e23111daff$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $756644e23111daff$var$z[a] = new $756644e23111daff$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $756644e23111daff$var$z[a] = new $756644e23111daff$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $756644e23111daff$var$z[a] = new $756644e23111daff$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $756644e23111daff$var$z[a] = new $756644e23111daff$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $756644e23111daff$var$z[a] = new $756644e23111daff$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $756644e23111daff$var$ra = /[\-:]([a-z])/g;
function $756644e23111daff$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($756644e23111daff$var$ra, $756644e23111daff$var$sa);
    $756644e23111daff$var$z[b] = new $756644e23111daff$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($756644e23111daff$var$ra, $756644e23111daff$var$sa);
    $756644e23111daff$var$z[b] = new $756644e23111daff$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($756644e23111daff$var$ra, $756644e23111daff$var$sa);
    $756644e23111daff$var$z[b] = new $756644e23111daff$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $756644e23111daff$var$z[a] = new $756644e23111daff$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$756644e23111daff$var$z.xlinkHref = new $756644e23111daff$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $756644e23111daff$var$z[a] = new $756644e23111daff$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $756644e23111daff$var$ta(a, b, c, d) {
    var e = $756644e23111daff$var$z.hasOwnProperty(b) ? $756644e23111daff$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $756644e23111daff$var$qa(b, c, e, d) && (c = null), d || null === e ? $756644e23111daff$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $756644e23111daff$var$ua = $5vDX4.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $756644e23111daff$var$va = Symbol.for("react.element"), $756644e23111daff$var$wa = Symbol.for("react.portal"), $756644e23111daff$var$ya = Symbol.for("react.fragment"), $756644e23111daff$var$za = Symbol.for("react.strict_mode"), $756644e23111daff$var$Aa = Symbol.for("react.profiler"), $756644e23111daff$var$Ba = Symbol.for("react.provider"), $756644e23111daff$var$Ca = Symbol.for("react.context"), $756644e23111daff$var$Da = Symbol.for("react.forward_ref"), $756644e23111daff$var$Ea = Symbol.for("react.suspense"), $756644e23111daff$var$Fa = Symbol.for("react.suspense_list"), $756644e23111daff$var$Ga = Symbol.for("react.memo"), $756644e23111daff$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $756644e23111daff$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $756644e23111daff$var$Ja = Symbol.iterator;
function $756644e23111daff$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $756644e23111daff$var$Ja && a[$756644e23111daff$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $756644e23111daff$var$A = Object.assign, $756644e23111daff$var$La;
function $756644e23111daff$var$Ma(a) {
    if (void 0 === $756644e23111daff$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $756644e23111daff$var$La = b && b[1] || "";
    }
    return "\n" + $756644e23111daff$var$La + a;
}
var $756644e23111daff$var$Na = !1;
function $756644e23111daff$var$Oa(a, b) {
    if (!a || $756644e23111daff$var$Na) return "";
    $756644e23111daff$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $756644e23111daff$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $756644e23111daff$var$Ma(a) : "";
}
function $756644e23111daff$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $756644e23111daff$var$Ma(a.type);
        case 16:
            return $756644e23111daff$var$Ma("Lazy");
        case 13:
            return $756644e23111daff$var$Ma("Suspense");
        case 19:
            return $756644e23111daff$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $756644e23111daff$var$Oa(a.type, !1), a;
        case 11:
            return a = $756644e23111daff$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $756644e23111daff$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $756644e23111daff$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $756644e23111daff$var$ya:
            return "Fragment";
        case $756644e23111daff$var$wa:
            return "Portal";
        case $756644e23111daff$var$Aa:
            return "Profiler";
        case $756644e23111daff$var$za:
            return "StrictMode";
        case $756644e23111daff$var$Ea:
            return "Suspense";
        case $756644e23111daff$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $756644e23111daff$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $756644e23111daff$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $756644e23111daff$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $756644e23111daff$var$Ga:
            return b = a.displayName || null, null !== b ? b : $756644e23111daff$var$Qa(a.type) || "Memo";
        case $756644e23111daff$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $756644e23111daff$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $756644e23111daff$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $756644e23111daff$var$Qa(b);
        case 8:
            return b === $756644e23111daff$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $756644e23111daff$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $756644e23111daff$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $756644e23111daff$var$Ua(a) {
    var b = $756644e23111daff$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $756644e23111daff$var$Va(a) {
    a._valueTracker || (a._valueTracker = $756644e23111daff$var$Ua(a));
}
function $756644e23111daff$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $756644e23111daff$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $756644e23111daff$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $756644e23111daff$var$Ya(a, b) {
    var c = b.checked;
    return $756644e23111daff$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $756644e23111daff$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $756644e23111daff$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $756644e23111daff$var$ab(a, b) {
    b = b.checked;
    null != b && $756644e23111daff$var$ta(a, "checked", b, !1);
}
function $756644e23111daff$var$bb(a, b) {
    $756644e23111daff$var$ab(a, b);
    var c = $756644e23111daff$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $756644e23111daff$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $756644e23111daff$var$cb(a, b.type, $756644e23111daff$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $756644e23111daff$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $756644e23111daff$var$cb(a, b, c) {
    if ("number" !== b || $756644e23111daff$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $756644e23111daff$var$eb = Array.isArray;
function $756644e23111daff$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $756644e23111daff$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $756644e23111daff$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($756644e23111daff$var$p(91));
    return $756644e23111daff$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $756644e23111daff$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($756644e23111daff$var$p(92));
            if ($756644e23111daff$var$eb(c)) {
                if (1 < c.length) throw Error($756644e23111daff$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $756644e23111daff$var$Sa(c)
    };
}
function $756644e23111daff$var$ib(a, b) {
    var c = $756644e23111daff$var$Sa(b.value), d = $756644e23111daff$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $756644e23111daff$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $756644e23111daff$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $756644e23111daff$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $756644e23111daff$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $756644e23111daff$var$mb, $756644e23111daff$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $756644e23111daff$var$mb = $756644e23111daff$var$mb || document.createElement("div");
        $756644e23111daff$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $756644e23111daff$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $756644e23111daff$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $756644e23111daff$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $756644e23111daff$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($756644e23111daff$var$pb).forEach(function(a) {
    $756644e23111daff$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $756644e23111daff$var$pb[b] = $756644e23111daff$var$pb[a];
    });
});
function $756644e23111daff$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $756644e23111daff$var$pb.hasOwnProperty(a) && $756644e23111daff$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $756644e23111daff$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $756644e23111daff$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $756644e23111daff$var$tb = $756644e23111daff$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $756644e23111daff$var$ub(a, b) {
    if (b) {
        if ($756644e23111daff$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($756644e23111daff$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($756644e23111daff$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($756644e23111daff$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($756644e23111daff$var$p(62));
    }
}
function $756644e23111daff$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $756644e23111daff$var$wb = null;
function $756644e23111daff$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $756644e23111daff$var$yb = null, $756644e23111daff$var$zb = null, $756644e23111daff$var$Ab = null;
function $756644e23111daff$var$Bb(a) {
    if (a = $756644e23111daff$var$Cb(a)) {
        if ("function" !== typeof $756644e23111daff$var$yb) throw Error($756644e23111daff$var$p(280));
        var b = a.stateNode;
        b && (b = $756644e23111daff$var$Db(b), $756644e23111daff$var$yb(a.stateNode, a.type, b));
    }
}
function $756644e23111daff$var$Eb(a) {
    $756644e23111daff$var$zb ? $756644e23111daff$var$Ab ? $756644e23111daff$var$Ab.push(a) : $756644e23111daff$var$Ab = [
        a
    ] : $756644e23111daff$var$zb = a;
}
function $756644e23111daff$var$Fb() {
    if ($756644e23111daff$var$zb) {
        var a = $756644e23111daff$var$zb, b = $756644e23111daff$var$Ab;
        $756644e23111daff$var$Ab = $756644e23111daff$var$zb = null;
        $756644e23111daff$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$756644e23111daff$var$Bb(b[a]);
    }
}
function $756644e23111daff$var$Gb(a, b) {
    return a(b);
}
function $756644e23111daff$var$Hb() {}
var $756644e23111daff$var$Ib = !1;
function $756644e23111daff$var$Jb(a, b, c) {
    if ($756644e23111daff$var$Ib) return a(b, c);
    $756644e23111daff$var$Ib = !0;
    try {
        return $756644e23111daff$var$Gb(a, b, c);
    } finally{
        if ($756644e23111daff$var$Ib = !1, null !== $756644e23111daff$var$zb || null !== $756644e23111daff$var$Ab) $756644e23111daff$var$Hb(), $756644e23111daff$var$Fb();
    }
}
function $756644e23111daff$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $756644e23111daff$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($756644e23111daff$var$p(231, b, typeof c));
    return c;
}
var $756644e23111daff$var$Lb = !1;
if ($756644e23111daff$var$ia) try {
    var $756644e23111daff$var$Mb = {};
    Object.defineProperty($756644e23111daff$var$Mb, "passive", {
        get: function() {
            $756644e23111daff$var$Lb = !0;
        }
    });
    window.addEventListener("test", $756644e23111daff$var$Mb, $756644e23111daff$var$Mb);
    window.removeEventListener("test", $756644e23111daff$var$Mb, $756644e23111daff$var$Mb);
} catch (a) {
    $756644e23111daff$var$Lb = !1;
}
function $756644e23111daff$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $756644e23111daff$var$Ob = !1, $756644e23111daff$var$Pb = null, $756644e23111daff$var$Qb = !1, $756644e23111daff$var$Rb = null, $756644e23111daff$var$Sb = {
    onError: function(a) {
        $756644e23111daff$var$Ob = !0;
        $756644e23111daff$var$Pb = a;
    }
};
function $756644e23111daff$var$Tb(a, b, c, d, e, f, g, h, k) {
    $756644e23111daff$var$Ob = !1;
    $756644e23111daff$var$Pb = null;
    $756644e23111daff$var$Nb.apply($756644e23111daff$var$Sb, arguments);
}
function $756644e23111daff$var$Ub(a, b, c, d, e, f, g, h, k) {
    $756644e23111daff$var$Tb.apply(this, arguments);
    if ($756644e23111daff$var$Ob) {
        if ($756644e23111daff$var$Ob) {
            var l = $756644e23111daff$var$Pb;
            $756644e23111daff$var$Ob = !1;
            $756644e23111daff$var$Pb = null;
        } else throw Error($756644e23111daff$var$p(198));
        $756644e23111daff$var$Qb || ($756644e23111daff$var$Qb = !0, $756644e23111daff$var$Rb = l);
    }
}
function $756644e23111daff$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $756644e23111daff$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $756644e23111daff$var$Xb(a) {
    if ($756644e23111daff$var$Vb(a) !== a) throw Error($756644e23111daff$var$p(188));
}
function $756644e23111daff$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $756644e23111daff$var$Vb(a);
        if (null === b) throw Error($756644e23111daff$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $756644e23111daff$var$Xb(e), a;
                if (f === d) return $756644e23111daff$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($756644e23111daff$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($756644e23111daff$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($756644e23111daff$var$p(190));
    }
    if (3 !== c.tag) throw Error($756644e23111daff$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $756644e23111daff$var$Zb(a) {
    a = $756644e23111daff$var$Yb(a);
    return null !== a ? $756644e23111daff$var$$b(a) : null;
}
function $756644e23111daff$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $756644e23111daff$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $756644e23111daff$var$ac = $azdYD.unstable_scheduleCallback, $756644e23111daff$var$bc = $azdYD.unstable_cancelCallback, $756644e23111daff$var$cc = $azdYD.unstable_shouldYield, $756644e23111daff$var$dc = $azdYD.unstable_requestPaint, $756644e23111daff$var$B = $azdYD.unstable_now, $756644e23111daff$var$ec = $azdYD.unstable_getCurrentPriorityLevel, $756644e23111daff$var$fc = $azdYD.unstable_ImmediatePriority, $756644e23111daff$var$gc = $azdYD.unstable_UserBlockingPriority, $756644e23111daff$var$hc = $azdYD.unstable_NormalPriority, $756644e23111daff$var$ic = $azdYD.unstable_LowPriority, $756644e23111daff$var$jc = $azdYD.unstable_IdlePriority, $756644e23111daff$var$kc = null, $756644e23111daff$var$lc = null;
function $756644e23111daff$var$mc(a) {
    if ($756644e23111daff$var$lc && "function" === typeof $756644e23111daff$var$lc.onCommitFiberRoot) try {
        $756644e23111daff$var$lc.onCommitFiberRoot($756644e23111daff$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $756644e23111daff$var$oc = Math.clz32 ? Math.clz32 : $756644e23111daff$var$nc, $756644e23111daff$var$pc = Math.log, $756644e23111daff$var$qc = Math.LN2;
function $756644e23111daff$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($756644e23111daff$var$pc(a) / $756644e23111daff$var$qc | 0) | 0;
}
var $756644e23111daff$var$rc = 64, $756644e23111daff$var$sc = 4194304;
function $756644e23111daff$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $756644e23111daff$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $756644e23111daff$var$tc(h) : (f &= g, 0 !== f && (d = $756644e23111daff$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $756644e23111daff$var$tc(g) : 0 !== f && (d = $756644e23111daff$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $756644e23111daff$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $756644e23111daff$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $756644e23111daff$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $756644e23111daff$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $756644e23111daff$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $756644e23111daff$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $756644e23111daff$var$yc() {
    var a = $756644e23111daff$var$rc;
    $756644e23111daff$var$rc <<= 1;
    0 === ($756644e23111daff$var$rc & 4194240) && ($756644e23111daff$var$rc = 64);
    return a;
}
function $756644e23111daff$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $756644e23111daff$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $756644e23111daff$var$oc(b);
    a[b] = c;
}
function $756644e23111daff$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $756644e23111daff$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $756644e23111daff$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $756644e23111daff$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $756644e23111daff$var$C = 0;
function $756644e23111daff$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $756644e23111daff$var$Ec, $756644e23111daff$var$Fc, $756644e23111daff$var$Gc, $756644e23111daff$var$Hc, $756644e23111daff$var$Ic, $756644e23111daff$var$Jc = !1, $756644e23111daff$var$Kc = [], $756644e23111daff$var$Lc = null, $756644e23111daff$var$Mc = null, $756644e23111daff$var$Nc = null, $756644e23111daff$var$Oc = new Map, $756644e23111daff$var$Pc = new Map, $756644e23111daff$var$Qc = [], $756644e23111daff$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $756644e23111daff$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $756644e23111daff$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $756644e23111daff$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $756644e23111daff$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $756644e23111daff$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $756644e23111daff$var$Pc.delete(b.pointerId);
    }
}
function $756644e23111daff$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $756644e23111daff$var$Cb(b), null !== b && $756644e23111daff$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $756644e23111daff$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $756644e23111daff$var$Lc = $756644e23111daff$var$Tc($756644e23111daff$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $756644e23111daff$var$Mc = $756644e23111daff$var$Tc($756644e23111daff$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $756644e23111daff$var$Nc = $756644e23111daff$var$Tc($756644e23111daff$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $756644e23111daff$var$Oc.set(f, $756644e23111daff$var$Tc($756644e23111daff$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $756644e23111daff$var$Pc.set(f, $756644e23111daff$var$Tc($756644e23111daff$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $756644e23111daff$var$Vc(a) {
    var b = $756644e23111daff$var$Wc(a.target);
    if (null !== b) {
        var c = $756644e23111daff$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $756644e23111daff$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $756644e23111daff$var$Ic(a.priority, function() {
                        $756644e23111daff$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $756644e23111daff$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $756644e23111daff$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $756644e23111daff$var$wb = d;
            c.target.dispatchEvent(d);
            $756644e23111daff$var$wb = null;
        } else return b = $756644e23111daff$var$Cb(c), null !== b && $756644e23111daff$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $756644e23111daff$var$Zc(a, b, c) {
    $756644e23111daff$var$Xc(a) && c.delete(b);
}
function $756644e23111daff$var$$c() {
    $756644e23111daff$var$Jc = !1;
    null !== $756644e23111daff$var$Lc && $756644e23111daff$var$Xc($756644e23111daff$var$Lc) && ($756644e23111daff$var$Lc = null);
    null !== $756644e23111daff$var$Mc && $756644e23111daff$var$Xc($756644e23111daff$var$Mc) && ($756644e23111daff$var$Mc = null);
    null !== $756644e23111daff$var$Nc && $756644e23111daff$var$Xc($756644e23111daff$var$Nc) && ($756644e23111daff$var$Nc = null);
    $756644e23111daff$var$Oc.forEach($756644e23111daff$var$Zc);
    $756644e23111daff$var$Pc.forEach($756644e23111daff$var$Zc);
}
function $756644e23111daff$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $756644e23111daff$var$Jc || ($756644e23111daff$var$Jc = !0, $azdYD.unstable_scheduleCallback($azdYD.unstable_NormalPriority, $756644e23111daff$var$$c)));
}
function $756644e23111daff$var$bd(a) {
    function b(b) {
        return $756644e23111daff$var$ad(b, a);
    }
    if (0 < $756644e23111daff$var$Kc.length) {
        $756644e23111daff$var$ad($756644e23111daff$var$Kc[0], a);
        for(var c = 1; c < $756644e23111daff$var$Kc.length; c++){
            var d = $756644e23111daff$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $756644e23111daff$var$Lc && $756644e23111daff$var$ad($756644e23111daff$var$Lc, a);
    null !== $756644e23111daff$var$Mc && $756644e23111daff$var$ad($756644e23111daff$var$Mc, a);
    null !== $756644e23111daff$var$Nc && $756644e23111daff$var$ad($756644e23111daff$var$Nc, a);
    $756644e23111daff$var$Oc.forEach(b);
    $756644e23111daff$var$Pc.forEach(b);
    for(c = 0; c < $756644e23111daff$var$Qc.length; c++)d = $756644e23111daff$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $756644e23111daff$var$Qc.length && (c = $756644e23111daff$var$Qc[0], null === c.blockedOn);)$756644e23111daff$var$Vc(c), null === c.blockedOn && $756644e23111daff$var$Qc.shift();
}
var $756644e23111daff$var$cd = $756644e23111daff$var$ua.ReactCurrentBatchConfig, $756644e23111daff$var$dd = !0;
function $756644e23111daff$var$ed(a, b, c, d) {
    var e = $756644e23111daff$var$C, f = $756644e23111daff$var$cd.transition;
    $756644e23111daff$var$cd.transition = null;
    try {
        $756644e23111daff$var$C = 1, $756644e23111daff$var$fd(a, b, c, d);
    } finally{
        $756644e23111daff$var$C = e, $756644e23111daff$var$cd.transition = f;
    }
}
function $756644e23111daff$var$gd(a, b, c, d) {
    var e = $756644e23111daff$var$C, f = $756644e23111daff$var$cd.transition;
    $756644e23111daff$var$cd.transition = null;
    try {
        $756644e23111daff$var$C = 4, $756644e23111daff$var$fd(a, b, c, d);
    } finally{
        $756644e23111daff$var$C = e, $756644e23111daff$var$cd.transition = f;
    }
}
function $756644e23111daff$var$fd(a, b, c, d) {
    if ($756644e23111daff$var$dd) {
        var e = $756644e23111daff$var$Yc(a, b, c, d);
        if (null === e) $756644e23111daff$var$hd(a, b, d, $756644e23111daff$var$id, c), $756644e23111daff$var$Sc(a, d);
        else if ($756644e23111daff$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($756644e23111daff$var$Sc(a, d), b & 4 && -1 < $756644e23111daff$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $756644e23111daff$var$Cb(e);
                null !== f && $756644e23111daff$var$Ec(f);
                f = $756644e23111daff$var$Yc(a, b, c, d);
                null === f && $756644e23111daff$var$hd(a, b, d, $756644e23111daff$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $756644e23111daff$var$hd(a, b, d, null, c);
    }
}
var $756644e23111daff$var$id = null;
function $756644e23111daff$var$Yc(a, b, c, d) {
    $756644e23111daff$var$id = null;
    a = $756644e23111daff$var$xb(d);
    a = $756644e23111daff$var$Wc(a);
    if (null !== a) {
        if (b = $756644e23111daff$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $756644e23111daff$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $756644e23111daff$var$id = a;
    return null;
}
function $756644e23111daff$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($756644e23111daff$var$ec()){
                case $756644e23111daff$var$fc:
                    return 1;
                case $756644e23111daff$var$gc:
                    return 4;
                case $756644e23111daff$var$hc:
                case $756644e23111daff$var$ic:
                    return 16;
                case $756644e23111daff$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $756644e23111daff$var$kd = null, $756644e23111daff$var$ld = null, $756644e23111daff$var$md = null;
function $756644e23111daff$var$nd() {
    if ($756644e23111daff$var$md) return $756644e23111daff$var$md;
    var a, b = $756644e23111daff$var$ld, c = b.length, d, e = "value" in $756644e23111daff$var$kd ? $756644e23111daff$var$kd.value : $756644e23111daff$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $756644e23111daff$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $756644e23111daff$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $756644e23111daff$var$pd() {
    return !0;
}
function $756644e23111daff$var$qd() {
    return !1;
}
function $756644e23111daff$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $756644e23111daff$var$pd : $756644e23111daff$var$qd;
        this.isPropagationStopped = $756644e23111daff$var$qd;
        return this;
    }
    $756644e23111daff$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $756644e23111daff$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $756644e23111daff$var$pd);
        },
        persist: function() {},
        isPersistent: $756644e23111daff$var$pd
    });
    return b;
}
var $756644e23111daff$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $756644e23111daff$var$td = $756644e23111daff$var$rd($756644e23111daff$var$sd), $756644e23111daff$var$ud = $756644e23111daff$var$A({}, $756644e23111daff$var$sd, {
    view: 0,
    detail: 0
}), $756644e23111daff$var$vd = $756644e23111daff$var$rd($756644e23111daff$var$ud), $756644e23111daff$var$wd, $756644e23111daff$var$xd, $756644e23111daff$var$yd, $756644e23111daff$var$Ad = $756644e23111daff$var$A({}, $756644e23111daff$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $756644e23111daff$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $756644e23111daff$var$yd && ($756644e23111daff$var$yd && "mousemove" === a.type ? ($756644e23111daff$var$wd = a.screenX - $756644e23111daff$var$yd.screenX, $756644e23111daff$var$xd = a.screenY - $756644e23111daff$var$yd.screenY) : $756644e23111daff$var$xd = $756644e23111daff$var$wd = 0, $756644e23111daff$var$yd = a);
        return $756644e23111daff$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $756644e23111daff$var$xd;
    }
}), $756644e23111daff$var$Bd = $756644e23111daff$var$rd($756644e23111daff$var$Ad), $756644e23111daff$var$Cd = $756644e23111daff$var$A({}, $756644e23111daff$var$Ad, {
    dataTransfer: 0
}), $756644e23111daff$var$Dd = $756644e23111daff$var$rd($756644e23111daff$var$Cd), $756644e23111daff$var$Ed = $756644e23111daff$var$A({}, $756644e23111daff$var$ud, {
    relatedTarget: 0
}), $756644e23111daff$var$Fd = $756644e23111daff$var$rd($756644e23111daff$var$Ed), $756644e23111daff$var$Gd = $756644e23111daff$var$A({}, $756644e23111daff$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $756644e23111daff$var$Hd = $756644e23111daff$var$rd($756644e23111daff$var$Gd), $756644e23111daff$var$Id = $756644e23111daff$var$A({}, $756644e23111daff$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $756644e23111daff$var$Jd = $756644e23111daff$var$rd($756644e23111daff$var$Id), $756644e23111daff$var$Kd = $756644e23111daff$var$A({}, $756644e23111daff$var$sd, {
    data: 0
}), $756644e23111daff$var$Ld = $756644e23111daff$var$rd($756644e23111daff$var$Kd), $756644e23111daff$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $756644e23111daff$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $756644e23111daff$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $756644e23111daff$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $756644e23111daff$var$Od[a]) ? !!b[a] : !1;
}
function $756644e23111daff$var$zd() {
    return $756644e23111daff$var$Pd;
}
var $756644e23111daff$var$Qd = $756644e23111daff$var$A({}, $756644e23111daff$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $756644e23111daff$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $756644e23111daff$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $756644e23111daff$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $756644e23111daff$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $756644e23111daff$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $756644e23111daff$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $756644e23111daff$var$Rd = $756644e23111daff$var$rd($756644e23111daff$var$Qd), $756644e23111daff$var$Sd = $756644e23111daff$var$A({}, $756644e23111daff$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $756644e23111daff$var$Td = $756644e23111daff$var$rd($756644e23111daff$var$Sd), $756644e23111daff$var$Ud = $756644e23111daff$var$A({}, $756644e23111daff$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $756644e23111daff$var$zd
}), $756644e23111daff$var$Vd = $756644e23111daff$var$rd($756644e23111daff$var$Ud), $756644e23111daff$var$Wd = $756644e23111daff$var$A({}, $756644e23111daff$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $756644e23111daff$var$Xd = $756644e23111daff$var$rd($756644e23111daff$var$Wd), $756644e23111daff$var$Yd = $756644e23111daff$var$A({}, $756644e23111daff$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $756644e23111daff$var$Zd = $756644e23111daff$var$rd($756644e23111daff$var$Yd), $756644e23111daff$var$$d = [
    9,
    13,
    27,
    32
], $756644e23111daff$var$ae = $756644e23111daff$var$ia && "CompositionEvent" in window, $756644e23111daff$var$be = null;
$756644e23111daff$var$ia && "documentMode" in document && ($756644e23111daff$var$be = document.documentMode);
var $756644e23111daff$var$ce = $756644e23111daff$var$ia && "TextEvent" in window && !$756644e23111daff$var$be, $756644e23111daff$var$de = $756644e23111daff$var$ia && (!$756644e23111daff$var$ae || $756644e23111daff$var$be && 8 < $756644e23111daff$var$be && 11 >= $756644e23111daff$var$be), $756644e23111daff$var$ee = String.fromCharCode(32), $756644e23111daff$var$fe = !1;
function $756644e23111daff$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $756644e23111daff$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $756644e23111daff$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $756644e23111daff$var$ie = !1;
function $756644e23111daff$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $756644e23111daff$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $756644e23111daff$var$fe = !0;
            return $756644e23111daff$var$ee;
        case "textInput":
            return a = b.data, a === $756644e23111daff$var$ee && $756644e23111daff$var$fe ? null : a;
        default:
            return null;
    }
}
function $756644e23111daff$var$ke(a, b) {
    if ($756644e23111daff$var$ie) return "compositionend" === a || !$756644e23111daff$var$ae && $756644e23111daff$var$ge(a, b) ? (a = $756644e23111daff$var$nd(), $756644e23111daff$var$md = $756644e23111daff$var$ld = $756644e23111daff$var$kd = null, $756644e23111daff$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $756644e23111daff$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $756644e23111daff$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $756644e23111daff$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$756644e23111daff$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $756644e23111daff$var$ne(a, b, c, d) {
    $756644e23111daff$var$Eb(d);
    b = $756644e23111daff$var$oe(b, "onChange");
    0 < b.length && (c = new $756644e23111daff$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $756644e23111daff$var$pe = null, $756644e23111daff$var$qe = null;
function $756644e23111daff$var$re(a) {
    $756644e23111daff$var$se(a, 0);
}
function $756644e23111daff$var$te(a) {
    var b = $756644e23111daff$var$ue(a);
    if ($756644e23111daff$var$Wa(b)) return a;
}
function $756644e23111daff$var$ve(a, b) {
    if ("change" === a) return b;
}
var $756644e23111daff$var$we = !1;
if ($756644e23111daff$var$ia) {
    var $756644e23111daff$var$xe;
    if ($756644e23111daff$var$ia) {
        var $756644e23111daff$var$ye = "oninput" in document;
        if (!$756644e23111daff$var$ye) {
            var $756644e23111daff$var$ze = document.createElement("div");
            $756644e23111daff$var$ze.setAttribute("oninput", "return;");
            $756644e23111daff$var$ye = "function" === typeof $756644e23111daff$var$ze.oninput;
        }
        $756644e23111daff$var$xe = $756644e23111daff$var$ye;
    } else $756644e23111daff$var$xe = !1;
    $756644e23111daff$var$we = $756644e23111daff$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $756644e23111daff$var$Ae() {
    $756644e23111daff$var$pe && ($756644e23111daff$var$pe.detachEvent("onpropertychange", $756644e23111daff$var$Be), $756644e23111daff$var$qe = $756644e23111daff$var$pe = null);
}
function $756644e23111daff$var$Be(a) {
    if ("value" === a.propertyName && $756644e23111daff$var$te($756644e23111daff$var$qe)) {
        var b = [];
        $756644e23111daff$var$ne(b, $756644e23111daff$var$qe, a, $756644e23111daff$var$xb(a));
        $756644e23111daff$var$Jb($756644e23111daff$var$re, b);
    }
}
function $756644e23111daff$var$Ce(a, b, c) {
    "focusin" === a ? ($756644e23111daff$var$Ae(), $756644e23111daff$var$pe = b, $756644e23111daff$var$qe = c, $756644e23111daff$var$pe.attachEvent("onpropertychange", $756644e23111daff$var$Be)) : "focusout" === a && $756644e23111daff$var$Ae();
}
function $756644e23111daff$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $756644e23111daff$var$te($756644e23111daff$var$qe);
}
function $756644e23111daff$var$Ee(a, b) {
    if ("click" === a) return $756644e23111daff$var$te(b);
}
function $756644e23111daff$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $756644e23111daff$var$te(b);
}
function $756644e23111daff$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $756644e23111daff$var$He = "function" === typeof Object.is ? Object.is : $756644e23111daff$var$Ge;
function $756644e23111daff$var$Ie(a, b) {
    if ($756644e23111daff$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$756644e23111daff$var$ja.call(b, e) || !$756644e23111daff$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $756644e23111daff$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $756644e23111daff$var$Ke(a, b) {
    var c = $756644e23111daff$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $756644e23111daff$var$Je(c);
    }
}
function $756644e23111daff$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $756644e23111daff$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $756644e23111daff$var$Me() {
    for(var a = window, b = $756644e23111daff$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $756644e23111daff$var$Xa(a.document);
    }
    return b;
}
function $756644e23111daff$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $756644e23111daff$var$Oe(a) {
    var b = $756644e23111daff$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $756644e23111daff$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $756644e23111daff$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $756644e23111daff$var$Ke(c, f);
                var g = $756644e23111daff$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $756644e23111daff$var$Pe = $756644e23111daff$var$ia && "documentMode" in document && 11 >= document.documentMode, $756644e23111daff$var$Qe = null, $756644e23111daff$var$Re = null, $756644e23111daff$var$Se = null, $756644e23111daff$var$Te = !1;
function $756644e23111daff$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $756644e23111daff$var$Te || null == $756644e23111daff$var$Qe || $756644e23111daff$var$Qe !== $756644e23111daff$var$Xa(d) || (d = $756644e23111daff$var$Qe, "selectionStart" in d && $756644e23111daff$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $756644e23111daff$var$Se && $756644e23111daff$var$Ie($756644e23111daff$var$Se, d) || ($756644e23111daff$var$Se = d, d = $756644e23111daff$var$oe($756644e23111daff$var$Re, "onSelect"), 0 < d.length && (b = new $756644e23111daff$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $756644e23111daff$var$Qe)));
}
function $756644e23111daff$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $756644e23111daff$var$We = {
    animationend: $756644e23111daff$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $756644e23111daff$var$Ve("Animation", "AnimationIteration"),
    animationstart: $756644e23111daff$var$Ve("Animation", "AnimationStart"),
    transitionend: $756644e23111daff$var$Ve("Transition", "TransitionEnd")
}, $756644e23111daff$var$Xe = {}, $756644e23111daff$var$Ye = {};
$756644e23111daff$var$ia && ($756644e23111daff$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $756644e23111daff$var$We.animationend.animation, delete $756644e23111daff$var$We.animationiteration.animation, delete $756644e23111daff$var$We.animationstart.animation), "TransitionEvent" in window || delete $756644e23111daff$var$We.transitionend.transition);
function $756644e23111daff$var$Ze(a) {
    if ($756644e23111daff$var$Xe[a]) return $756644e23111daff$var$Xe[a];
    if (!$756644e23111daff$var$We[a]) return a;
    var b = $756644e23111daff$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $756644e23111daff$var$Ye) return $756644e23111daff$var$Xe[a] = b[c];
    return a;
}
var $756644e23111daff$var$$e = $756644e23111daff$var$Ze("animationend"), $756644e23111daff$var$af = $756644e23111daff$var$Ze("animationiteration"), $756644e23111daff$var$bf = $756644e23111daff$var$Ze("animationstart"), $756644e23111daff$var$cf = $756644e23111daff$var$Ze("transitionend"), $756644e23111daff$var$df = new Map, $756644e23111daff$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $756644e23111daff$var$ff(a, b) {
    $756644e23111daff$var$df.set(a, b);
    $756644e23111daff$var$fa(b, [
        a
    ]);
}
for(var $756644e23111daff$var$gf = 0; $756644e23111daff$var$gf < $756644e23111daff$var$ef.length; $756644e23111daff$var$gf++){
    var $756644e23111daff$var$hf = $756644e23111daff$var$ef[$756644e23111daff$var$gf], $756644e23111daff$var$jf = $756644e23111daff$var$hf.toLowerCase(), $756644e23111daff$var$kf = $756644e23111daff$var$hf[0].toUpperCase() + $756644e23111daff$var$hf.slice(1);
    $756644e23111daff$var$ff($756644e23111daff$var$jf, "on" + $756644e23111daff$var$kf);
}
$756644e23111daff$var$ff($756644e23111daff$var$$e, "onAnimationEnd");
$756644e23111daff$var$ff($756644e23111daff$var$af, "onAnimationIteration");
$756644e23111daff$var$ff($756644e23111daff$var$bf, "onAnimationStart");
$756644e23111daff$var$ff("dblclick", "onDoubleClick");
$756644e23111daff$var$ff("focusin", "onFocus");
$756644e23111daff$var$ff("focusout", "onBlur");
$756644e23111daff$var$ff($756644e23111daff$var$cf, "onTransitionEnd");
$756644e23111daff$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$756644e23111daff$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$756644e23111daff$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$756644e23111daff$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$756644e23111daff$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$756644e23111daff$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$756644e23111daff$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$756644e23111daff$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$756644e23111daff$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$756644e23111daff$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $756644e23111daff$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $756644e23111daff$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($756644e23111daff$var$lf));
function $756644e23111daff$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $756644e23111daff$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $756644e23111daff$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $756644e23111daff$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $756644e23111daff$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($756644e23111daff$var$Qb) throw a = $756644e23111daff$var$Rb, $756644e23111daff$var$Qb = !1, $756644e23111daff$var$Rb = null, a;
}
function $756644e23111daff$var$D(a, b) {
    var c = b[$756644e23111daff$var$of];
    void 0 === c && (c = b[$756644e23111daff$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($756644e23111daff$var$pf(b, a, 2, !1), c.add(d));
}
function $756644e23111daff$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $756644e23111daff$var$pf(c, a, d, b);
}
var $756644e23111daff$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $756644e23111daff$var$sf(a) {
    if (!a[$756644e23111daff$var$rf]) {
        a[$756644e23111daff$var$rf] = !0;
        $756644e23111daff$var$da.forEach(function(b) {
            "selectionchange" !== b && ($756644e23111daff$var$mf.has(b) || $756644e23111daff$var$qf(b, !1, a), $756644e23111daff$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$756644e23111daff$var$rf] || (b[$756644e23111daff$var$rf] = !0, $756644e23111daff$var$qf("selectionchange", !1, b));
    }
}
function $756644e23111daff$var$pf(a, b, c, d) {
    switch($756644e23111daff$var$jd(b)){
        case 1:
            var e = $756644e23111daff$var$ed;
            break;
        case 4:
            e = $756644e23111daff$var$gd;
            break;
        default:
            e = $756644e23111daff$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$756644e23111daff$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $756644e23111daff$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $756644e23111daff$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $756644e23111daff$var$Jb(function() {
        var d = f, e = $756644e23111daff$var$xb(c), g = [];
        a: {
            var h = $756644e23111daff$var$df.get(a);
            if (void 0 !== h) {
                var k = $756644e23111daff$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $756644e23111daff$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $756644e23111daff$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $756644e23111daff$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $756644e23111daff$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $756644e23111daff$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $756644e23111daff$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $756644e23111daff$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $756644e23111daff$var$Vd;
                        break;
                    case $756644e23111daff$var$$e:
                    case $756644e23111daff$var$af:
                    case $756644e23111daff$var$bf:
                        k = $756644e23111daff$var$Hd;
                        break;
                    case $756644e23111daff$var$cf:
                        k = $756644e23111daff$var$Xd;
                        break;
                    case "scroll":
                        k = $756644e23111daff$var$vd;
                        break;
                    case "wheel":
                        k = $756644e23111daff$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $756644e23111daff$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $756644e23111daff$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $756644e23111daff$var$Kb(w, x), null != F && t.push($756644e23111daff$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $756644e23111daff$var$wb && (n = c.relatedTarget || c.fromElement) && ($756644e23111daff$var$Wc(n) || n[$756644e23111daff$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $756644e23111daff$var$Wc(n) : null, null !== n && (J = $756644e23111daff$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $756644e23111daff$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $756644e23111daff$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $756644e23111daff$var$ue(k);
                        u = null == n ? h : $756644e23111daff$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $756644e23111daff$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $756644e23111daff$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $756644e23111daff$var$vf(F))u++;
                            for(; 0 < w - u;)t = $756644e23111daff$var$vf(t), w--;
                            for(; 0 < u - w;)x = $756644e23111daff$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $756644e23111daff$var$vf(t);
                                x = $756644e23111daff$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $756644e23111daff$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $756644e23111daff$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $756644e23111daff$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $756644e23111daff$var$ve;
                else if ($756644e23111daff$var$me(h)) {
                    if ($756644e23111daff$var$we) na = $756644e23111daff$var$Fe;
                    else {
                        na = $756644e23111daff$var$De;
                        var xa = $756644e23111daff$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $756644e23111daff$var$Ee);
                if (na && (na = na(a, d))) {
                    $756644e23111daff$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $756644e23111daff$var$cb(h, "number", h.value);
            }
            xa = d ? $756644e23111daff$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($756644e23111daff$var$me(xa) || "true" === xa.contentEditable) $756644e23111daff$var$Qe = xa, $756644e23111daff$var$Re = d, $756644e23111daff$var$Se = null;
                    break;
                case "focusout":
                    $756644e23111daff$var$Se = $756644e23111daff$var$Re = $756644e23111daff$var$Qe = null;
                    break;
                case "mousedown":
                    $756644e23111daff$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $756644e23111daff$var$Te = !1;
                    $756644e23111daff$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($756644e23111daff$var$Pe) break;
                case "keydown":
                case "keyup":
                    $756644e23111daff$var$Ue(g, c, e);
            }
            var $a;
            if ($756644e23111daff$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $756644e23111daff$var$ie ? $756644e23111daff$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($756644e23111daff$var$de && "ko" !== c.locale && ($756644e23111daff$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $756644e23111daff$var$ie && ($a = $756644e23111daff$var$nd()) : ($756644e23111daff$var$kd = e, $756644e23111daff$var$ld = "value" in $756644e23111daff$var$kd ? $756644e23111daff$var$kd.value : $756644e23111daff$var$kd.textContent, $756644e23111daff$var$ie = !0)), xa = $756644e23111daff$var$oe(d, ba), 0 < xa.length && (ba = new $756644e23111daff$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $756644e23111daff$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $756644e23111daff$var$ce ? $756644e23111daff$var$je(a, c) : $756644e23111daff$var$ke(a, c)) d = $756644e23111daff$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $756644e23111daff$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $756644e23111daff$var$se(g, b);
    });
}
function $756644e23111daff$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $756644e23111daff$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $756644e23111daff$var$Kb(a, c), null != f && d.unshift($756644e23111daff$var$tf(a, f, e)), f = $756644e23111daff$var$Kb(a, b), null != f && d.push($756644e23111daff$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $756644e23111daff$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $756644e23111daff$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $756644e23111daff$var$Kb(c, f), null != k && g.unshift($756644e23111daff$var$tf(c, k, h))) : e || (k = $756644e23111daff$var$Kb(c, f), null != k && g.push($756644e23111daff$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $756644e23111daff$var$xf = /\r\n?/g, $756644e23111daff$var$yf = /\u0000|\uFFFD/g;
function $756644e23111daff$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($756644e23111daff$var$xf, "\n").replace($756644e23111daff$var$yf, "");
}
function $756644e23111daff$var$Af(a, b, c) {
    b = $756644e23111daff$var$zf(b);
    if ($756644e23111daff$var$zf(a) !== b && c) throw Error($756644e23111daff$var$p(425));
}
function $756644e23111daff$var$Bf() {}
var $756644e23111daff$var$Cf = null, $756644e23111daff$var$Df = null;
function $756644e23111daff$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $756644e23111daff$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $756644e23111daff$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $756644e23111daff$var$Hf = "function" === typeof Promise ? Promise : void 0, $756644e23111daff$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $756644e23111daff$var$Hf ? function(a) {
    return $756644e23111daff$var$Hf.resolve(null).then(a).catch($756644e23111daff$var$If);
} : $756644e23111daff$var$Ff;
function $756644e23111daff$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $756644e23111daff$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $756644e23111daff$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $756644e23111daff$var$bd(b);
}
function $756644e23111daff$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $756644e23111daff$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $756644e23111daff$var$Nf = Math.random().toString(36).slice(2), $756644e23111daff$var$Of = "__reactFiber$" + $756644e23111daff$var$Nf, $756644e23111daff$var$Pf = "__reactProps$" + $756644e23111daff$var$Nf, $756644e23111daff$var$uf = "__reactContainer$" + $756644e23111daff$var$Nf, $756644e23111daff$var$of = "__reactEvents$" + $756644e23111daff$var$Nf, $756644e23111daff$var$Qf = "__reactListeners$" + $756644e23111daff$var$Nf, $756644e23111daff$var$Rf = "__reactHandles$" + $756644e23111daff$var$Nf;
function $756644e23111daff$var$Wc(a) {
    var b = a[$756644e23111daff$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$756644e23111daff$var$uf] || c[$756644e23111daff$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $756644e23111daff$var$Mf(a); null !== a;){
                if (c = a[$756644e23111daff$var$Of]) return c;
                a = $756644e23111daff$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $756644e23111daff$var$Cb(a) {
    a = a[$756644e23111daff$var$Of] || a[$756644e23111daff$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $756644e23111daff$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($756644e23111daff$var$p(33));
}
function $756644e23111daff$var$Db(a) {
    return a[$756644e23111daff$var$Pf] || null;
}
var $756644e23111daff$var$Sf = [], $756644e23111daff$var$Tf = -1;
function $756644e23111daff$var$Uf(a) {
    return {
        current: a
    };
}
function $756644e23111daff$var$E(a) {
    0 > $756644e23111daff$var$Tf || (a.current = $756644e23111daff$var$Sf[$756644e23111daff$var$Tf], $756644e23111daff$var$Sf[$756644e23111daff$var$Tf] = null, $756644e23111daff$var$Tf--);
}
function $756644e23111daff$var$G(a, b) {
    $756644e23111daff$var$Tf++;
    $756644e23111daff$var$Sf[$756644e23111daff$var$Tf] = a.current;
    a.current = b;
}
var $756644e23111daff$var$Vf = {}, $756644e23111daff$var$H = $756644e23111daff$var$Uf($756644e23111daff$var$Vf), $756644e23111daff$var$Wf = $756644e23111daff$var$Uf(!1), $756644e23111daff$var$Xf = $756644e23111daff$var$Vf;
function $756644e23111daff$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $756644e23111daff$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $756644e23111daff$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $756644e23111daff$var$$f() {
    $756644e23111daff$var$E($756644e23111daff$var$Wf);
    $756644e23111daff$var$E($756644e23111daff$var$H);
}
function $756644e23111daff$var$ag(a, b, c) {
    if ($756644e23111daff$var$H.current !== $756644e23111daff$var$Vf) throw Error($756644e23111daff$var$p(168));
    $756644e23111daff$var$G($756644e23111daff$var$H, b);
    $756644e23111daff$var$G($756644e23111daff$var$Wf, c);
}
function $756644e23111daff$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($756644e23111daff$var$p(108, $756644e23111daff$var$Ra(a) || "Unknown", e));
    return $756644e23111daff$var$A({}, c, d);
}
function $756644e23111daff$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $756644e23111daff$var$Vf;
    $756644e23111daff$var$Xf = $756644e23111daff$var$H.current;
    $756644e23111daff$var$G($756644e23111daff$var$H, a);
    $756644e23111daff$var$G($756644e23111daff$var$Wf, $756644e23111daff$var$Wf.current);
    return !0;
}
function $756644e23111daff$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($756644e23111daff$var$p(169));
    c ? (a = $756644e23111daff$var$bg(a, b, $756644e23111daff$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $756644e23111daff$var$E($756644e23111daff$var$Wf), $756644e23111daff$var$E($756644e23111daff$var$H), $756644e23111daff$var$G($756644e23111daff$var$H, a)) : $756644e23111daff$var$E($756644e23111daff$var$Wf);
    $756644e23111daff$var$G($756644e23111daff$var$Wf, c);
}
var $756644e23111daff$var$eg = null, $756644e23111daff$var$fg = !1, $756644e23111daff$var$gg = !1;
function $756644e23111daff$var$hg(a) {
    null === $756644e23111daff$var$eg ? $756644e23111daff$var$eg = [
        a
    ] : $756644e23111daff$var$eg.push(a);
}
function $756644e23111daff$var$ig(a) {
    $756644e23111daff$var$fg = !0;
    $756644e23111daff$var$hg(a);
}
function $756644e23111daff$var$jg() {
    if (!$756644e23111daff$var$gg && null !== $756644e23111daff$var$eg) {
        $756644e23111daff$var$gg = !0;
        var a = 0, b = $756644e23111daff$var$C;
        try {
            var c = $756644e23111daff$var$eg;
            for($756644e23111daff$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $756644e23111daff$var$eg = null;
            $756644e23111daff$var$fg = !1;
        } catch (e) {
            throw null !== $756644e23111daff$var$eg && ($756644e23111daff$var$eg = $756644e23111daff$var$eg.slice(a + 1)), $756644e23111daff$var$ac($756644e23111daff$var$fc, $756644e23111daff$var$jg), e;
        } finally{
            $756644e23111daff$var$C = b, $756644e23111daff$var$gg = !1;
        }
    }
    return null;
}
var $756644e23111daff$var$kg = [], $756644e23111daff$var$lg = 0, $756644e23111daff$var$mg = null, $756644e23111daff$var$ng = 0, $756644e23111daff$var$og = [], $756644e23111daff$var$pg = 0, $756644e23111daff$var$qg = null, $756644e23111daff$var$rg = 1, $756644e23111daff$var$sg = "";
function $756644e23111daff$var$tg(a, b) {
    $756644e23111daff$var$kg[$756644e23111daff$var$lg++] = $756644e23111daff$var$ng;
    $756644e23111daff$var$kg[$756644e23111daff$var$lg++] = $756644e23111daff$var$mg;
    $756644e23111daff$var$mg = a;
    $756644e23111daff$var$ng = b;
}
function $756644e23111daff$var$ug(a, b, c) {
    $756644e23111daff$var$og[$756644e23111daff$var$pg++] = $756644e23111daff$var$rg;
    $756644e23111daff$var$og[$756644e23111daff$var$pg++] = $756644e23111daff$var$sg;
    $756644e23111daff$var$og[$756644e23111daff$var$pg++] = $756644e23111daff$var$qg;
    $756644e23111daff$var$qg = a;
    var d = $756644e23111daff$var$rg;
    a = $756644e23111daff$var$sg;
    var e = 32 - $756644e23111daff$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $756644e23111daff$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $756644e23111daff$var$rg = 1 << 32 - $756644e23111daff$var$oc(b) + e | c << e | d;
        $756644e23111daff$var$sg = f + a;
    } else $756644e23111daff$var$rg = 1 << f | c << e | d, $756644e23111daff$var$sg = a;
}
function $756644e23111daff$var$vg(a) {
    null !== a.return && ($756644e23111daff$var$tg(a, 1), $756644e23111daff$var$ug(a, 1, 0));
}
function $756644e23111daff$var$wg(a) {
    for(; a === $756644e23111daff$var$mg;)$756644e23111daff$var$mg = $756644e23111daff$var$kg[--$756644e23111daff$var$lg], $756644e23111daff$var$kg[$756644e23111daff$var$lg] = null, $756644e23111daff$var$ng = $756644e23111daff$var$kg[--$756644e23111daff$var$lg], $756644e23111daff$var$kg[$756644e23111daff$var$lg] = null;
    for(; a === $756644e23111daff$var$qg;)$756644e23111daff$var$qg = $756644e23111daff$var$og[--$756644e23111daff$var$pg], $756644e23111daff$var$og[$756644e23111daff$var$pg] = null, $756644e23111daff$var$sg = $756644e23111daff$var$og[--$756644e23111daff$var$pg], $756644e23111daff$var$og[$756644e23111daff$var$pg] = null, $756644e23111daff$var$rg = $756644e23111daff$var$og[--$756644e23111daff$var$pg], $756644e23111daff$var$og[$756644e23111daff$var$pg] = null;
}
var $756644e23111daff$var$xg = null, $756644e23111daff$var$yg = null, $756644e23111daff$var$I = !1, $756644e23111daff$var$zg = null;
function $756644e23111daff$var$Ag(a, b) {
    var c = $756644e23111daff$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $756644e23111daff$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $756644e23111daff$var$xg = a, $756644e23111daff$var$yg = $756644e23111daff$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $756644e23111daff$var$xg = a, $756644e23111daff$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $756644e23111daff$var$qg ? {
                id: $756644e23111daff$var$rg,
                overflow: $756644e23111daff$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $756644e23111daff$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $756644e23111daff$var$xg = a, $756644e23111daff$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $756644e23111daff$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $756644e23111daff$var$Eg(a) {
    if ($756644e23111daff$var$I) {
        var b = $756644e23111daff$var$yg;
        if (b) {
            var c = b;
            if (!$756644e23111daff$var$Cg(a, b)) {
                if ($756644e23111daff$var$Dg(a)) throw Error($756644e23111daff$var$p(418));
                b = $756644e23111daff$var$Lf(c.nextSibling);
                var d = $756644e23111daff$var$xg;
                b && $756644e23111daff$var$Cg(a, b) ? $756644e23111daff$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $756644e23111daff$var$I = !1, $756644e23111daff$var$xg = a);
            }
        } else {
            if ($756644e23111daff$var$Dg(a)) throw Error($756644e23111daff$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $756644e23111daff$var$I = !1;
            $756644e23111daff$var$xg = a;
        }
    }
}
function $756644e23111daff$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $756644e23111daff$var$xg = a;
}
function $756644e23111daff$var$Gg(a) {
    if (a !== $756644e23111daff$var$xg) return !1;
    if (!$756644e23111daff$var$I) return $756644e23111daff$var$Fg(a), $756644e23111daff$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$756644e23111daff$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $756644e23111daff$var$yg)) {
        if ($756644e23111daff$var$Dg(a)) throw $756644e23111daff$var$Hg(), Error($756644e23111daff$var$p(418));
        for(; b;)$756644e23111daff$var$Ag(a, b), b = $756644e23111daff$var$Lf(b.nextSibling);
    }
    $756644e23111daff$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($756644e23111daff$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $756644e23111daff$var$yg = $756644e23111daff$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $756644e23111daff$var$yg = null;
        }
    } else $756644e23111daff$var$yg = $756644e23111daff$var$xg ? $756644e23111daff$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $756644e23111daff$var$Hg() {
    for(var a = $756644e23111daff$var$yg; a;)a = $756644e23111daff$var$Lf(a.nextSibling);
}
function $756644e23111daff$var$Ig() {
    $756644e23111daff$var$yg = $756644e23111daff$var$xg = null;
    $756644e23111daff$var$I = !1;
}
function $756644e23111daff$var$Jg(a) {
    null === $756644e23111daff$var$zg ? $756644e23111daff$var$zg = [
        a
    ] : $756644e23111daff$var$zg.push(a);
}
var $756644e23111daff$var$Kg = $756644e23111daff$var$ua.ReactCurrentBatchConfig;
function $756644e23111daff$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $756644e23111daff$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $756644e23111daff$var$Mg = $756644e23111daff$var$Uf(null), $756644e23111daff$var$Ng = null, $756644e23111daff$var$Og = null, $756644e23111daff$var$Pg = null;
function $756644e23111daff$var$Qg() {
    $756644e23111daff$var$Pg = $756644e23111daff$var$Og = $756644e23111daff$var$Ng = null;
}
function $756644e23111daff$var$Rg(a) {
    var b = $756644e23111daff$var$Mg.current;
    $756644e23111daff$var$E($756644e23111daff$var$Mg);
    a._currentValue = b;
}
function $756644e23111daff$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $756644e23111daff$var$Tg(a, b) {
    $756644e23111daff$var$Ng = a;
    $756644e23111daff$var$Pg = $756644e23111daff$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($756644e23111daff$var$Ug = !0), a.firstContext = null);
}
function $756644e23111daff$var$Vg(a) {
    var b = a._currentValue;
    if ($756644e23111daff$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $756644e23111daff$var$Og) {
            if (null === $756644e23111daff$var$Ng) throw Error($756644e23111daff$var$p(308));
            $756644e23111daff$var$Og = a;
            $756644e23111daff$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $756644e23111daff$var$Og = $756644e23111daff$var$Og.next = a;
    }
    return b;
}
var $756644e23111daff$var$Wg = null;
function $756644e23111daff$var$Xg(a) {
    null === $756644e23111daff$var$Wg ? $756644e23111daff$var$Wg = [
        a
    ] : $756644e23111daff$var$Wg.push(a);
}
function $756644e23111daff$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $756644e23111daff$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $756644e23111daff$var$Zg(a, d);
}
function $756644e23111daff$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $756644e23111daff$var$$g = !1;
function $756644e23111daff$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $756644e23111daff$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $756644e23111daff$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $756644e23111daff$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($756644e23111daff$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $756644e23111daff$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $756644e23111daff$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $756644e23111daff$var$Zg(a, c);
}
function $756644e23111daff$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $756644e23111daff$var$Cc(a, c);
    }
}
function $756644e23111daff$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $756644e23111daff$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $756644e23111daff$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $756644e23111daff$var$A({}, q, r);
                            break a;
                        case 2:
                            $756644e23111daff$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $756644e23111daff$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $756644e23111daff$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($756644e23111daff$var$p(191, e));
            e.call(d);
        }
    }
}
var $756644e23111daff$var$jh = (new $5vDX4.Component).refs;
function $756644e23111daff$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $756644e23111daff$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $756644e23111daff$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $756644e23111daff$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $756644e23111daff$var$L(), e = $756644e23111daff$var$lh(a), f = $756644e23111daff$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $756644e23111daff$var$dh(a, f, e);
        null !== b && ($756644e23111daff$var$mh(b, a, e, d), $756644e23111daff$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $756644e23111daff$var$L(), e = $756644e23111daff$var$lh(a), f = $756644e23111daff$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $756644e23111daff$var$dh(a, f, e);
        null !== b && ($756644e23111daff$var$mh(b, a, e, d), $756644e23111daff$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $756644e23111daff$var$L(), d = $756644e23111daff$var$lh(a), e = $756644e23111daff$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $756644e23111daff$var$dh(a, e, d);
        null !== b && ($756644e23111daff$var$mh(b, a, d, c), $756644e23111daff$var$eh(b, a, d));
    }
};
function $756644e23111daff$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$756644e23111daff$var$Ie(c, d) || !$756644e23111daff$var$Ie(e, f) : !0;
}
function $756644e23111daff$var$ph(a, b, c) {
    var d = !1, e = $756644e23111daff$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $756644e23111daff$var$Vg(f) : (e = $756644e23111daff$var$Zf(b) ? $756644e23111daff$var$Xf : $756644e23111daff$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $756644e23111daff$var$Yf(a, e) : $756644e23111daff$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $756644e23111daff$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $756644e23111daff$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $756644e23111daff$var$nh.enqueueReplaceState(b, b.state, null);
}
function $756644e23111daff$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $756644e23111daff$var$jh;
    $756644e23111daff$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $756644e23111daff$var$Vg(f) : (f = $756644e23111daff$var$Zf(b) ? $756644e23111daff$var$Xf : $756644e23111daff$var$H.current, e.context = $756644e23111daff$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($756644e23111daff$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $756644e23111daff$var$nh.enqueueReplaceState(e, e.state, null), $756644e23111daff$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $756644e23111daff$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($756644e23111daff$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($756644e23111daff$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $756644e23111daff$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($756644e23111daff$var$p(284));
        if (!c._owner) throw Error($756644e23111daff$var$p(290, a));
    }
    return a;
}
function $756644e23111daff$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($756644e23111daff$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $756644e23111daff$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $756644e23111daff$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $756644e23111daff$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $756644e23111daff$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $756644e23111daff$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $756644e23111daff$var$Ha && $756644e23111daff$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $756644e23111daff$var$sh(a, b, c), d.return = a, d;
        d = $756644e23111daff$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $756644e23111daff$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $756644e23111daff$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $756644e23111daff$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $756644e23111daff$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $756644e23111daff$var$va:
                    return c = $756644e23111daff$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $756644e23111daff$var$sh(a, null, b), c.return = a, c;
                case $756644e23111daff$var$wa:
                    return b = $756644e23111daff$var$zh(b, a.mode, c), b.return = a, b;
                case $756644e23111daff$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($756644e23111daff$var$eb(b) || $756644e23111daff$var$Ka(b)) return b = $756644e23111daff$var$Ah(b, a.mode, c, null), b.return = a, b;
            $756644e23111daff$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $756644e23111daff$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $756644e23111daff$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $756644e23111daff$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($756644e23111daff$var$eb(c) || $756644e23111daff$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $756644e23111daff$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $756644e23111daff$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $756644e23111daff$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $756644e23111daff$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($756644e23111daff$var$eb(d) || $756644e23111daff$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $756644e23111daff$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $756644e23111daff$var$I && $756644e23111daff$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $756644e23111daff$var$I && $756644e23111daff$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $756644e23111daff$var$I && $756644e23111daff$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $756644e23111daff$var$Ka(h);
        if ("function" !== typeof l) throw Error($756644e23111daff$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($756644e23111daff$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $756644e23111daff$var$I && $756644e23111daff$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $756644e23111daff$var$I && $756644e23111daff$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $756644e23111daff$var$I && $756644e23111daff$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $756644e23111daff$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $756644e23111daff$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $756644e23111daff$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $756644e23111daff$var$Ha && $756644e23111daff$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $756644e23111daff$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $756644e23111daff$var$ya ? (d = $756644e23111daff$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $756644e23111daff$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $756644e23111daff$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $756644e23111daff$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $756644e23111daff$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $756644e23111daff$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($756644e23111daff$var$eb(f)) return n(a, d, f, h);
            if ($756644e23111daff$var$Ka(f)) return t(a, d, f, h);
            $756644e23111daff$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $756644e23111daff$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $756644e23111daff$var$Bh = $756644e23111daff$var$vh(!0), $756644e23111daff$var$Ch = $756644e23111daff$var$vh(!1), $756644e23111daff$var$Dh = {}, $756644e23111daff$var$Eh = $756644e23111daff$var$Uf($756644e23111daff$var$Dh), $756644e23111daff$var$Fh = $756644e23111daff$var$Uf($756644e23111daff$var$Dh), $756644e23111daff$var$Gh = $756644e23111daff$var$Uf($756644e23111daff$var$Dh);
function $756644e23111daff$var$Hh(a) {
    if (a === $756644e23111daff$var$Dh) throw Error($756644e23111daff$var$p(174));
    return a;
}
function $756644e23111daff$var$Ih(a, b) {
    $756644e23111daff$var$G($756644e23111daff$var$Gh, b);
    $756644e23111daff$var$G($756644e23111daff$var$Fh, a);
    $756644e23111daff$var$G($756644e23111daff$var$Eh, $756644e23111daff$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $756644e23111daff$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $756644e23111daff$var$lb(b, a);
    }
    $756644e23111daff$var$E($756644e23111daff$var$Eh);
    $756644e23111daff$var$G($756644e23111daff$var$Eh, b);
}
function $756644e23111daff$var$Jh() {
    $756644e23111daff$var$E($756644e23111daff$var$Eh);
    $756644e23111daff$var$E($756644e23111daff$var$Fh);
    $756644e23111daff$var$E($756644e23111daff$var$Gh);
}
function $756644e23111daff$var$Kh(a) {
    $756644e23111daff$var$Hh($756644e23111daff$var$Gh.current);
    var b = $756644e23111daff$var$Hh($756644e23111daff$var$Eh.current);
    var c = $756644e23111daff$var$lb(b, a.type);
    b !== c && ($756644e23111daff$var$G($756644e23111daff$var$Fh, a), $756644e23111daff$var$G($756644e23111daff$var$Eh, c));
}
function $756644e23111daff$var$Lh(a) {
    $756644e23111daff$var$Fh.current === a && ($756644e23111daff$var$E($756644e23111daff$var$Eh), $756644e23111daff$var$E($756644e23111daff$var$Fh));
}
var $756644e23111daff$var$M = $756644e23111daff$var$Uf(0);
function $756644e23111daff$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $756644e23111daff$var$Nh = [];
function $756644e23111daff$var$Oh() {
    for(var a = 0; a < $756644e23111daff$var$Nh.length; a++)$756644e23111daff$var$Nh[a]._workInProgressVersionPrimary = null;
    $756644e23111daff$var$Nh.length = 0;
}
var $756644e23111daff$var$Ph = $756644e23111daff$var$ua.ReactCurrentDispatcher, $756644e23111daff$var$Qh = $756644e23111daff$var$ua.ReactCurrentBatchConfig, $756644e23111daff$var$Rh = 0, $756644e23111daff$var$N = null, $756644e23111daff$var$O = null, $756644e23111daff$var$P = null, $756644e23111daff$var$Sh = !1, $756644e23111daff$var$Th = !1, $756644e23111daff$var$Uh = 0, $756644e23111daff$var$Vh = 0;
function $756644e23111daff$var$Q() {
    throw Error($756644e23111daff$var$p(321));
}
function $756644e23111daff$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$756644e23111daff$var$He(a[c], b[c])) return !1;
    return !0;
}
function $756644e23111daff$var$Xh(a, b, c, d, e, f) {
    $756644e23111daff$var$Rh = f;
    $756644e23111daff$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $756644e23111daff$var$Ph.current = null === a || null === a.memoizedState ? $756644e23111daff$var$Yh : $756644e23111daff$var$Zh;
    a = c(d, e);
    if ($756644e23111daff$var$Th) {
        f = 0;
        do {
            $756644e23111daff$var$Th = !1;
            $756644e23111daff$var$Uh = 0;
            if (25 <= f) throw Error($756644e23111daff$var$p(301));
            f += 1;
            $756644e23111daff$var$P = $756644e23111daff$var$O = null;
            b.updateQueue = null;
            $756644e23111daff$var$Ph.current = $756644e23111daff$var$$h;
            a = c(d, e);
        }while ($756644e23111daff$var$Th);
    }
    $756644e23111daff$var$Ph.current = $756644e23111daff$var$ai;
    b = null !== $756644e23111daff$var$O && null !== $756644e23111daff$var$O.next;
    $756644e23111daff$var$Rh = 0;
    $756644e23111daff$var$P = $756644e23111daff$var$O = $756644e23111daff$var$N = null;
    $756644e23111daff$var$Sh = !1;
    if (b) throw Error($756644e23111daff$var$p(300));
    return a;
}
function $756644e23111daff$var$bi() {
    var a = 0 !== $756644e23111daff$var$Uh;
    $756644e23111daff$var$Uh = 0;
    return a;
}
function $756644e23111daff$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $756644e23111daff$var$P ? $756644e23111daff$var$N.memoizedState = $756644e23111daff$var$P = a : $756644e23111daff$var$P = $756644e23111daff$var$P.next = a;
    return $756644e23111daff$var$P;
}
function $756644e23111daff$var$di() {
    if (null === $756644e23111daff$var$O) {
        var a = $756644e23111daff$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $756644e23111daff$var$O.next;
    var b = null === $756644e23111daff$var$P ? $756644e23111daff$var$N.memoizedState : $756644e23111daff$var$P.next;
    if (null !== b) $756644e23111daff$var$P = b, $756644e23111daff$var$O = a;
    else {
        if (null === a) throw Error($756644e23111daff$var$p(310));
        $756644e23111daff$var$O = a;
        a = {
            memoizedState: $756644e23111daff$var$O.memoizedState,
            baseState: $756644e23111daff$var$O.baseState,
            baseQueue: $756644e23111daff$var$O.baseQueue,
            queue: $756644e23111daff$var$O.queue,
            next: null
        };
        null === $756644e23111daff$var$P ? $756644e23111daff$var$N.memoizedState = $756644e23111daff$var$P = a : $756644e23111daff$var$P = $756644e23111daff$var$P.next = a;
    }
    return $756644e23111daff$var$P;
}
function $756644e23111daff$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $756644e23111daff$var$fi(a) {
    var b = $756644e23111daff$var$di(), c = b.queue;
    if (null === c) throw Error($756644e23111daff$var$p(311));
    c.lastRenderedReducer = a;
    var d = $756644e23111daff$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($756644e23111daff$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $756644e23111daff$var$N.lanes |= m;
                $756644e23111daff$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $756644e23111daff$var$He(d, b.memoizedState) || ($756644e23111daff$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $756644e23111daff$var$N.lanes |= f, $756644e23111daff$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $756644e23111daff$var$gi(a) {
    var b = $756644e23111daff$var$di(), c = b.queue;
    if (null === c) throw Error($756644e23111daff$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $756644e23111daff$var$He(f, b.memoizedState) || ($756644e23111daff$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $756644e23111daff$var$hi() {}
function $756644e23111daff$var$ii(a, b) {
    var c = $756644e23111daff$var$N, d = $756644e23111daff$var$di(), e = b(), f = !$756644e23111daff$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $756644e23111daff$var$Ug = !0);
    d = d.queue;
    $756644e23111daff$var$ji($756644e23111daff$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $756644e23111daff$var$P && $756644e23111daff$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $756644e23111daff$var$li(9, $756644e23111daff$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $756644e23111daff$var$R) throw Error($756644e23111daff$var$p(349));
        0 !== ($756644e23111daff$var$Rh & 30) || $756644e23111daff$var$ni(c, b, e);
    }
    return e;
}
function $756644e23111daff$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $756644e23111daff$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $756644e23111daff$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $756644e23111daff$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $756644e23111daff$var$oi(b) && $756644e23111daff$var$pi(a);
}
function $756644e23111daff$var$ki(a, b, c) {
    return c(function() {
        $756644e23111daff$var$oi(b) && $756644e23111daff$var$pi(a);
    });
}
function $756644e23111daff$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$756644e23111daff$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $756644e23111daff$var$pi(a) {
    var b = $756644e23111daff$var$Zg(a, 1);
    null !== b && $756644e23111daff$var$mh(b, a, 1, -1);
}
function $756644e23111daff$var$qi(a) {
    var b = $756644e23111daff$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $756644e23111daff$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $756644e23111daff$var$ri.bind(null, $756644e23111daff$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $756644e23111daff$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $756644e23111daff$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $756644e23111daff$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $756644e23111daff$var$si() {
    return $756644e23111daff$var$di().memoizedState;
}
function $756644e23111daff$var$ti(a, b, c, d) {
    var e = $756644e23111daff$var$ci();
    $756644e23111daff$var$N.flags |= a;
    e.memoizedState = $756644e23111daff$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $756644e23111daff$var$ui(a, b, c, d) {
    var e = $756644e23111daff$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $756644e23111daff$var$O) {
        var g = $756644e23111daff$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $756644e23111daff$var$Wh(d, g.deps)) {
            e.memoizedState = $756644e23111daff$var$li(b, c, f, d);
            return;
        }
    }
    $756644e23111daff$var$N.flags |= a;
    e.memoizedState = $756644e23111daff$var$li(1 | b, c, f, d);
}
function $756644e23111daff$var$vi(a, b) {
    return $756644e23111daff$var$ti(8390656, 8, a, b);
}
function $756644e23111daff$var$ji(a, b) {
    return $756644e23111daff$var$ui(2048, 8, a, b);
}
function $756644e23111daff$var$wi(a, b) {
    return $756644e23111daff$var$ui(4, 2, a, b);
}
function $756644e23111daff$var$xi(a, b) {
    return $756644e23111daff$var$ui(4, 4, a, b);
}
function $756644e23111daff$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $756644e23111daff$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $756644e23111daff$var$ui(4, 4, $756644e23111daff$var$yi.bind(null, b, a), c);
}
function $756644e23111daff$var$Ai() {}
function $756644e23111daff$var$Bi(a, b) {
    var c = $756644e23111daff$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $756644e23111daff$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $756644e23111daff$var$Ci(a, b) {
    var c = $756644e23111daff$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $756644e23111daff$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $756644e23111daff$var$Di(a, b, c) {
    if (0 === ($756644e23111daff$var$Rh & 21)) return a.baseState && (a.baseState = !1, $756644e23111daff$var$Ug = !0), a.memoizedState = c;
    $756644e23111daff$var$He(c, b) || (c = $756644e23111daff$var$yc(), $756644e23111daff$var$N.lanes |= c, $756644e23111daff$var$hh |= c, a.baseState = !0);
    return b;
}
function $756644e23111daff$var$Ei(a, b) {
    var c = $756644e23111daff$var$C;
    $756644e23111daff$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $756644e23111daff$var$Qh.transition;
    $756644e23111daff$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $756644e23111daff$var$C = c, $756644e23111daff$var$Qh.transition = d;
    }
}
function $756644e23111daff$var$Fi() {
    return $756644e23111daff$var$di().memoizedState;
}
function $756644e23111daff$var$Gi(a, b, c) {
    var d = $756644e23111daff$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($756644e23111daff$var$Hi(a)) $756644e23111daff$var$Ii(b, c);
    else if (c = $756644e23111daff$var$Yg(a, b, c, d), null !== c) {
        var e = $756644e23111daff$var$L();
        $756644e23111daff$var$mh(c, a, d, e);
        $756644e23111daff$var$Ji(c, b, d);
    }
}
function $756644e23111daff$var$ri(a, b, c) {
    var d = $756644e23111daff$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($756644e23111daff$var$Hi(a)) $756644e23111daff$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($756644e23111daff$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $756644e23111daff$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $756644e23111daff$var$Yg(a, b, e, d);
        null !== c && (e = $756644e23111daff$var$L(), $756644e23111daff$var$mh(c, a, d, e), $756644e23111daff$var$Ji(c, b, d));
    }
}
function $756644e23111daff$var$Hi(a) {
    var b = a.alternate;
    return a === $756644e23111daff$var$N || null !== b && b === $756644e23111daff$var$N;
}
function $756644e23111daff$var$Ii(a, b) {
    $756644e23111daff$var$Th = $756644e23111daff$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $756644e23111daff$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $756644e23111daff$var$Cc(a, c);
    }
}
var $756644e23111daff$var$ai = {
    readContext: $756644e23111daff$var$Vg,
    useCallback: $756644e23111daff$var$Q,
    useContext: $756644e23111daff$var$Q,
    useEffect: $756644e23111daff$var$Q,
    useImperativeHandle: $756644e23111daff$var$Q,
    useInsertionEffect: $756644e23111daff$var$Q,
    useLayoutEffect: $756644e23111daff$var$Q,
    useMemo: $756644e23111daff$var$Q,
    useReducer: $756644e23111daff$var$Q,
    useRef: $756644e23111daff$var$Q,
    useState: $756644e23111daff$var$Q,
    useDebugValue: $756644e23111daff$var$Q,
    useDeferredValue: $756644e23111daff$var$Q,
    useTransition: $756644e23111daff$var$Q,
    useMutableSource: $756644e23111daff$var$Q,
    useSyncExternalStore: $756644e23111daff$var$Q,
    useId: $756644e23111daff$var$Q,
    unstable_isNewReconciler: !1
}, $756644e23111daff$var$Yh = {
    readContext: $756644e23111daff$var$Vg,
    useCallback: function(a, b) {
        $756644e23111daff$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $756644e23111daff$var$Vg,
    useEffect: $756644e23111daff$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $756644e23111daff$var$ti(4194308, 4, $756644e23111daff$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $756644e23111daff$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $756644e23111daff$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $756644e23111daff$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $756644e23111daff$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $756644e23111daff$var$Gi.bind(null, $756644e23111daff$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $756644e23111daff$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $756644e23111daff$var$qi,
    useDebugValue: $756644e23111daff$var$Ai,
    useDeferredValue: function(a) {
        return $756644e23111daff$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $756644e23111daff$var$qi(!1), b = a[0];
        a = $756644e23111daff$var$Ei.bind(null, a[1]);
        $756644e23111daff$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $756644e23111daff$var$N, e = $756644e23111daff$var$ci();
        if ($756644e23111daff$var$I) {
            if (void 0 === c) throw Error($756644e23111daff$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $756644e23111daff$var$R) throw Error($756644e23111daff$var$p(349));
            0 !== ($756644e23111daff$var$Rh & 30) || $756644e23111daff$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $756644e23111daff$var$vi($756644e23111daff$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $756644e23111daff$var$li(9, $756644e23111daff$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $756644e23111daff$var$ci(), b = $756644e23111daff$var$R.identifierPrefix;
        if ($756644e23111daff$var$I) {
            var c = $756644e23111daff$var$sg;
            var d = $756644e23111daff$var$rg;
            c = (d & ~(1 << 32 - $756644e23111daff$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $756644e23111daff$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $756644e23111daff$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $756644e23111daff$var$Zh = {
    readContext: $756644e23111daff$var$Vg,
    useCallback: $756644e23111daff$var$Bi,
    useContext: $756644e23111daff$var$Vg,
    useEffect: $756644e23111daff$var$ji,
    useImperativeHandle: $756644e23111daff$var$zi,
    useInsertionEffect: $756644e23111daff$var$wi,
    useLayoutEffect: $756644e23111daff$var$xi,
    useMemo: $756644e23111daff$var$Ci,
    useReducer: $756644e23111daff$var$fi,
    useRef: $756644e23111daff$var$si,
    useState: function() {
        return $756644e23111daff$var$fi($756644e23111daff$var$ei);
    },
    useDebugValue: $756644e23111daff$var$Ai,
    useDeferredValue: function(a) {
        var b = $756644e23111daff$var$di();
        return $756644e23111daff$var$Di(b, $756644e23111daff$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $756644e23111daff$var$fi($756644e23111daff$var$ei)[0], b = $756644e23111daff$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $756644e23111daff$var$hi,
    useSyncExternalStore: $756644e23111daff$var$ii,
    useId: $756644e23111daff$var$Fi,
    unstable_isNewReconciler: !1
}, $756644e23111daff$var$$h = {
    readContext: $756644e23111daff$var$Vg,
    useCallback: $756644e23111daff$var$Bi,
    useContext: $756644e23111daff$var$Vg,
    useEffect: $756644e23111daff$var$ji,
    useImperativeHandle: $756644e23111daff$var$zi,
    useInsertionEffect: $756644e23111daff$var$wi,
    useLayoutEffect: $756644e23111daff$var$xi,
    useMemo: $756644e23111daff$var$Ci,
    useReducer: $756644e23111daff$var$gi,
    useRef: $756644e23111daff$var$si,
    useState: function() {
        return $756644e23111daff$var$gi($756644e23111daff$var$ei);
    },
    useDebugValue: $756644e23111daff$var$Ai,
    useDeferredValue: function(a) {
        var b = $756644e23111daff$var$di();
        return null === $756644e23111daff$var$O ? b.memoizedState = a : $756644e23111daff$var$Di(b, $756644e23111daff$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $756644e23111daff$var$gi($756644e23111daff$var$ei)[0], b = $756644e23111daff$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $756644e23111daff$var$hi,
    useSyncExternalStore: $756644e23111daff$var$ii,
    useId: $756644e23111daff$var$Fi,
    unstable_isNewReconciler: !1
};
function $756644e23111daff$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $756644e23111daff$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $756644e23111daff$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $756644e23111daff$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $756644e23111daff$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $756644e23111daff$var$Oi(a, b, c) {
    c = $756644e23111daff$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $756644e23111daff$var$Pi || ($756644e23111daff$var$Pi = !0, $756644e23111daff$var$Qi = d);
        $756644e23111daff$var$Mi(a, b);
    };
    return c;
}
function $756644e23111daff$var$Ri(a, b, c) {
    c = $756644e23111daff$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $756644e23111daff$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $756644e23111daff$var$Mi(a, b);
        "function" !== typeof d && (null === $756644e23111daff$var$Si ? $756644e23111daff$var$Si = new Set([
            this
        ]) : $756644e23111daff$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $756644e23111daff$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $756644e23111daff$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $756644e23111daff$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $756644e23111daff$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $756644e23111daff$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $756644e23111daff$var$ch(-1, 1), b.tag = 2, $756644e23111daff$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $756644e23111daff$var$Xi = $756644e23111daff$var$ua.ReactCurrentOwner, $756644e23111daff$var$Ug = !1;
function $756644e23111daff$var$Yi(a, b, c, d) {
    b.child = null === a ? $756644e23111daff$var$Ch(b, null, c, d) : $756644e23111daff$var$Bh(b, a.child, c, d);
}
function $756644e23111daff$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $756644e23111daff$var$Tg(b, e);
    d = $756644e23111daff$var$Xh(a, b, c, d, f, e);
    c = $756644e23111daff$var$bi();
    if (null !== a && !$756644e23111daff$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $756644e23111daff$var$$i(a, b, e);
    $756644e23111daff$var$I && c && $756644e23111daff$var$vg(b);
    b.flags |= 1;
    $756644e23111daff$var$Yi(a, b, d, e);
    return b.child;
}
function $756644e23111daff$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$756644e23111daff$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $756644e23111daff$var$cj(a, b, f, d, e);
        a = $756644e23111daff$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $756644e23111daff$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $756644e23111daff$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $756644e23111daff$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $756644e23111daff$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($756644e23111daff$var$Ie(f, d) && a.ref === b.ref) {
            if ($756644e23111daff$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($756644e23111daff$var$Ug = !0);
            else return b.lanes = a.lanes, $756644e23111daff$var$$i(a, b, e);
        }
    }
    return $756644e23111daff$var$dj(a, b, c, d, e);
}
function $756644e23111daff$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $756644e23111daff$var$G($756644e23111daff$var$fj, $756644e23111daff$var$gj), $756644e23111daff$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $756644e23111daff$var$G($756644e23111daff$var$fj, $756644e23111daff$var$gj), $756644e23111daff$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $756644e23111daff$var$G($756644e23111daff$var$fj, $756644e23111daff$var$gj);
            $756644e23111daff$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $756644e23111daff$var$G($756644e23111daff$var$fj, $756644e23111daff$var$gj), $756644e23111daff$var$gj |= d;
    $756644e23111daff$var$Yi(a, b, e, c);
    return b.child;
}
function $756644e23111daff$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $756644e23111daff$var$dj(a, b, c, d, e) {
    var f = $756644e23111daff$var$Zf(c) ? $756644e23111daff$var$Xf : $756644e23111daff$var$H.current;
    f = $756644e23111daff$var$Yf(b, f);
    $756644e23111daff$var$Tg(b, e);
    c = $756644e23111daff$var$Xh(a, b, c, d, f, e);
    d = $756644e23111daff$var$bi();
    if (null !== a && !$756644e23111daff$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $756644e23111daff$var$$i(a, b, e);
    $756644e23111daff$var$I && d && $756644e23111daff$var$vg(b);
    b.flags |= 1;
    $756644e23111daff$var$Yi(a, b, c, e);
    return b.child;
}
function $756644e23111daff$var$ij(a, b, c, d, e) {
    if ($756644e23111daff$var$Zf(c)) {
        var f = !0;
        $756644e23111daff$var$cg(b);
    } else f = !1;
    $756644e23111daff$var$Tg(b, e);
    if (null === b.stateNode) $756644e23111daff$var$jj(a, b), $756644e23111daff$var$ph(b, c, d), $756644e23111daff$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $756644e23111daff$var$Vg(l) : (l = $756644e23111daff$var$Zf(c) ? $756644e23111daff$var$Xf : $756644e23111daff$var$H.current, l = $756644e23111daff$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $756644e23111daff$var$qh(b, g, d, l);
        $756644e23111daff$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $756644e23111daff$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $756644e23111daff$var$Wf.current || $756644e23111daff$var$$g ? ("function" === typeof m && ($756644e23111daff$var$kh(b, c, m, d), k = b.memoizedState), (h = $756644e23111daff$var$$g || $756644e23111daff$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $756644e23111daff$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $756644e23111daff$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $756644e23111daff$var$Vg(k) : (k = $756644e23111daff$var$Zf(c) ? $756644e23111daff$var$Xf : $756644e23111daff$var$H.current, k = $756644e23111daff$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $756644e23111daff$var$qh(b, g, d, k);
        $756644e23111daff$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $756644e23111daff$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $756644e23111daff$var$Wf.current || $756644e23111daff$var$$g ? ("function" === typeof y && ($756644e23111daff$var$kh(b, c, y, d), n = b.memoizedState), (l = $756644e23111daff$var$$g || $756644e23111daff$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $756644e23111daff$var$kj(a, b, c, d, f, e);
}
function $756644e23111daff$var$kj(a, b, c, d, e, f) {
    $756644e23111daff$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $756644e23111daff$var$dg(b, c, !1), $756644e23111daff$var$$i(a, b, f);
    d = b.stateNode;
    $756644e23111daff$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $756644e23111daff$var$Bh(b, a.child, null, f), b.child = $756644e23111daff$var$Bh(b, null, h, f)) : $756644e23111daff$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $756644e23111daff$var$dg(b, c, !0);
    return b.child;
}
function $756644e23111daff$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $756644e23111daff$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $756644e23111daff$var$ag(a, b.context, !1);
    $756644e23111daff$var$Ih(a, b.containerInfo);
}
function $756644e23111daff$var$mj(a, b, c, d, e) {
    $756644e23111daff$var$Ig();
    $756644e23111daff$var$Jg(e);
    b.flags |= 256;
    $756644e23111daff$var$Yi(a, b, c, d);
    return b.child;
}
var $756644e23111daff$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $756644e23111daff$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $756644e23111daff$var$pj(a, b, c) {
    var d = b.pendingProps, e = $756644e23111daff$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $756644e23111daff$var$G($756644e23111daff$var$M, e & 1);
    if (null === a) {
        $756644e23111daff$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $756644e23111daff$var$qj(g, d, 0, null), a = $756644e23111daff$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $756644e23111daff$var$oj(c), b.memoizedState = $756644e23111daff$var$nj, a) : $756644e23111daff$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $756644e23111daff$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $756644e23111daff$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $756644e23111daff$var$wh(h, f) : (f = $756644e23111daff$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $756644e23111daff$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $756644e23111daff$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $756644e23111daff$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $756644e23111daff$var$rj(a, b) {
    b = $756644e23111daff$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $756644e23111daff$var$tj(a, b, c, d) {
    null !== d && $756644e23111daff$var$Jg(d);
    $756644e23111daff$var$Bh(b, a.child, null, c);
    a = $756644e23111daff$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $756644e23111daff$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $756644e23111daff$var$Li(Error($756644e23111daff$var$p(422))), $756644e23111daff$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $756644e23111daff$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $756644e23111daff$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $756644e23111daff$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $756644e23111daff$var$oj(g);
        b.memoizedState = $756644e23111daff$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $756644e23111daff$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($756644e23111daff$var$p(419));
        d = $756644e23111daff$var$Li(f, d, void 0);
        return $756644e23111daff$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($756644e23111daff$var$Ug || h) {
        d = $756644e23111daff$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $756644e23111daff$var$Zg(a, e), $756644e23111daff$var$mh(d, a, e, -1));
        }
        $756644e23111daff$var$uj();
        d = $756644e23111daff$var$Li(Error($756644e23111daff$var$p(421)));
        return $756644e23111daff$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $756644e23111daff$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $756644e23111daff$var$yg = $756644e23111daff$var$Lf(e.nextSibling);
    $756644e23111daff$var$xg = b;
    $756644e23111daff$var$I = !0;
    $756644e23111daff$var$zg = null;
    null !== a && ($756644e23111daff$var$og[$756644e23111daff$var$pg++] = $756644e23111daff$var$rg, $756644e23111daff$var$og[$756644e23111daff$var$pg++] = $756644e23111daff$var$sg, $756644e23111daff$var$og[$756644e23111daff$var$pg++] = $756644e23111daff$var$qg, $756644e23111daff$var$rg = a.id, $756644e23111daff$var$sg = a.overflow, $756644e23111daff$var$qg = b);
    b = $756644e23111daff$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $756644e23111daff$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $756644e23111daff$var$Sg(a.return, b, c);
}
function $756644e23111daff$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $756644e23111daff$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $756644e23111daff$var$Yi(a, b, d.children, c);
    d = $756644e23111daff$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $756644e23111daff$var$wj(a, c, b);
            else if (19 === a.tag) $756644e23111daff$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $756644e23111daff$var$G($756644e23111daff$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $756644e23111daff$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $756644e23111daff$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $756644e23111daff$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $756644e23111daff$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $756644e23111daff$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $756644e23111daff$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $756644e23111daff$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $756644e23111daff$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($756644e23111daff$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $756644e23111daff$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $756644e23111daff$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $756644e23111daff$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $756644e23111daff$var$lj(b);
            $756644e23111daff$var$Ig();
            break;
        case 5:
            $756644e23111daff$var$Kh(b);
            break;
        case 1:
            $756644e23111daff$var$Zf(b.type) && $756644e23111daff$var$cg(b);
            break;
        case 4:
            $756644e23111daff$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $756644e23111daff$var$G($756644e23111daff$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $756644e23111daff$var$G($756644e23111daff$var$M, $756644e23111daff$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $756644e23111daff$var$pj(a, b, c);
                $756644e23111daff$var$G($756644e23111daff$var$M, $756644e23111daff$var$M.current & 1);
                a = $756644e23111daff$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $756644e23111daff$var$G($756644e23111daff$var$M, $756644e23111daff$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $756644e23111daff$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $756644e23111daff$var$G($756644e23111daff$var$M, $756644e23111daff$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $756644e23111daff$var$ej(a, b, c);
    }
    return $756644e23111daff$var$$i(a, b, c);
}
var $756644e23111daff$var$Aj, $756644e23111daff$var$Bj, $756644e23111daff$var$Cj, $756644e23111daff$var$Dj;
$756644e23111daff$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$756644e23111daff$var$Bj = function() {};
$756644e23111daff$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $756644e23111daff$var$Hh($756644e23111daff$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $756644e23111daff$var$Ya(a, e);
                d = $756644e23111daff$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $756644e23111daff$var$A({}, e, {
                    value: void 0
                });
                d = $756644e23111daff$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $756644e23111daff$var$gb(a, e);
                d = $756644e23111daff$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $756644e23111daff$var$Bf);
        }
        $756644e23111daff$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($756644e23111daff$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($756644e23111daff$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $756644e23111daff$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$756644e23111daff$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $756644e23111daff$var$Ej(a, b) {
    if (!$756644e23111daff$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $756644e23111daff$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $756644e23111daff$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $756644e23111daff$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $756644e23111daff$var$S(b), null;
        case 1:
            return $756644e23111daff$var$Zf(b.type) && $756644e23111daff$var$$f(), $756644e23111daff$var$S(b), null;
        case 3:
            d = b.stateNode;
            $756644e23111daff$var$Jh();
            $756644e23111daff$var$E($756644e23111daff$var$Wf);
            $756644e23111daff$var$E($756644e23111daff$var$H);
            $756644e23111daff$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $756644e23111daff$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $756644e23111daff$var$zg && ($756644e23111daff$var$Gj($756644e23111daff$var$zg), $756644e23111daff$var$zg = null));
            $756644e23111daff$var$Bj(a, b);
            $756644e23111daff$var$S(b);
            return null;
        case 5:
            $756644e23111daff$var$Lh(b);
            var e = $756644e23111daff$var$Hh($756644e23111daff$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $756644e23111daff$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($756644e23111daff$var$p(166));
                    $756644e23111daff$var$S(b);
                    return null;
                }
                a = $756644e23111daff$var$Hh($756644e23111daff$var$Eh.current);
                if ($756644e23111daff$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$756644e23111daff$var$Of] = b;
                    d[$756644e23111daff$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $756644e23111daff$var$D("cancel", d);
                            $756644e23111daff$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $756644e23111daff$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $756644e23111daff$var$lf.length; e++)$756644e23111daff$var$D($756644e23111daff$var$lf[e], d);
                            break;
                        case "source":
                            $756644e23111daff$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $756644e23111daff$var$D("error", d);
                            $756644e23111daff$var$D("load", d);
                            break;
                        case "details":
                            $756644e23111daff$var$D("toggle", d);
                            break;
                        case "input":
                            $756644e23111daff$var$Za(d, f);
                            $756644e23111daff$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $756644e23111daff$var$D("invalid", d);
                            break;
                        case "textarea":
                            $756644e23111daff$var$hb(d, f), $756644e23111daff$var$D("invalid", d);
                    }
                    $756644e23111daff$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $756644e23111daff$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $756644e23111daff$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $756644e23111daff$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $756644e23111daff$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $756644e23111daff$var$Va(d);
                            $756644e23111daff$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $756644e23111daff$var$Va(d);
                            $756644e23111daff$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $756644e23111daff$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $756644e23111daff$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$756644e23111daff$var$Of] = b;
                    a[$756644e23111daff$var$Pf] = d;
                    $756644e23111daff$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $756644e23111daff$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $756644e23111daff$var$D("cancel", a);
                                $756644e23111daff$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $756644e23111daff$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $756644e23111daff$var$lf.length; e++)$756644e23111daff$var$D($756644e23111daff$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $756644e23111daff$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $756644e23111daff$var$D("error", a);
                                $756644e23111daff$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $756644e23111daff$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $756644e23111daff$var$Za(a, d);
                                e = $756644e23111daff$var$Ya(a, d);
                                $756644e23111daff$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $756644e23111daff$var$A({}, d, {
                                    value: void 0
                                });
                                $756644e23111daff$var$D("invalid", a);
                                break;
                            case "textarea":
                                $756644e23111daff$var$hb(a, d);
                                e = $756644e23111daff$var$gb(a, d);
                                $756644e23111daff$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $756644e23111daff$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $756644e23111daff$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $756644e23111daff$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $756644e23111daff$var$ob(a, k) : "number" === typeof k && $756644e23111daff$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($756644e23111daff$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $756644e23111daff$var$D("scroll", a) : null != k && $756644e23111daff$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $756644e23111daff$var$Va(a);
                                $756644e23111daff$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $756644e23111daff$var$Va(a);
                                $756644e23111daff$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $756644e23111daff$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $756644e23111daff$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $756644e23111daff$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $756644e23111daff$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $756644e23111daff$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $756644e23111daff$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($756644e23111daff$var$p(166));
                c = $756644e23111daff$var$Hh($756644e23111daff$var$Gh.current);
                $756644e23111daff$var$Hh($756644e23111daff$var$Eh.current);
                if ($756644e23111daff$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$756644e23111daff$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $756644e23111daff$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $756644e23111daff$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $756644e23111daff$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$756644e23111daff$var$Of] = b, b.stateNode = d;
            }
            $756644e23111daff$var$S(b);
            return null;
        case 13:
            $756644e23111daff$var$E($756644e23111daff$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($756644e23111daff$var$I && null !== $756644e23111daff$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $756644e23111daff$var$Hg(), $756644e23111daff$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $756644e23111daff$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($756644e23111daff$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($756644e23111daff$var$p(317));
                        f[$756644e23111daff$var$Of] = b;
                    } else $756644e23111daff$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $756644e23111daff$var$S(b);
                    f = !1;
                } else null !== $756644e23111daff$var$zg && ($756644e23111daff$var$Gj($756644e23111daff$var$zg), $756644e23111daff$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($756644e23111daff$var$M.current & 1) ? 0 === $756644e23111daff$var$T && ($756644e23111daff$var$T = 3) : $756644e23111daff$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $756644e23111daff$var$S(b);
            return null;
        case 4:
            return $756644e23111daff$var$Jh(), $756644e23111daff$var$Bj(a, b), null === a && $756644e23111daff$var$sf(b.stateNode.containerInfo), $756644e23111daff$var$S(b), null;
        case 10:
            return $756644e23111daff$var$Rg(b.type._context), $756644e23111daff$var$S(b), null;
        case 17:
            return $756644e23111daff$var$Zf(b.type) && $756644e23111daff$var$$f(), $756644e23111daff$var$S(b), null;
        case 19:
            $756644e23111daff$var$E($756644e23111daff$var$M);
            f = b.memoizedState;
            if (null === f) return $756644e23111daff$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $756644e23111daff$var$Ej(f, !1);
                else {
                    if (0 !== $756644e23111daff$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $756644e23111daff$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $756644e23111daff$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $756644e23111daff$var$G($756644e23111daff$var$M, $756644e23111daff$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $756644e23111daff$var$B() > $756644e23111daff$var$Hj && (b.flags |= 128, d = !0, $756644e23111daff$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $756644e23111daff$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $756644e23111daff$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$756644e23111daff$var$I) return $756644e23111daff$var$S(b), null;
                    } else 2 * $756644e23111daff$var$B() - f.renderingStartTime > $756644e23111daff$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $756644e23111daff$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $756644e23111daff$var$B(), b.sibling = null, c = $756644e23111daff$var$M.current, $756644e23111daff$var$G($756644e23111daff$var$M, d ? c & 1 | 2 : c & 1), b;
            $756644e23111daff$var$S(b);
            return null;
        case 22:
        case 23:
            return $756644e23111daff$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($756644e23111daff$var$gj & 1073741824) && ($756644e23111daff$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $756644e23111daff$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($756644e23111daff$var$p(156, b.tag));
}
function $756644e23111daff$var$Jj(a, b) {
    $756644e23111daff$var$wg(b);
    switch(b.tag){
        case 1:
            return $756644e23111daff$var$Zf(b.type) && $756644e23111daff$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $756644e23111daff$var$Jh(), $756644e23111daff$var$E($756644e23111daff$var$Wf), $756644e23111daff$var$E($756644e23111daff$var$H), $756644e23111daff$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $756644e23111daff$var$Lh(b), null;
        case 13:
            $756644e23111daff$var$E($756644e23111daff$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($756644e23111daff$var$p(340));
                $756644e23111daff$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $756644e23111daff$var$E($756644e23111daff$var$M), null;
        case 4:
            return $756644e23111daff$var$Jh(), null;
        case 10:
            return $756644e23111daff$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $756644e23111daff$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $756644e23111daff$var$Kj = !1, $756644e23111daff$var$U = !1, $756644e23111daff$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $756644e23111daff$var$V = null;
function $756644e23111daff$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $756644e23111daff$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $756644e23111daff$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $756644e23111daff$var$W(a, b, d);
    }
}
var $756644e23111daff$var$Oj = !1;
function $756644e23111daff$var$Pj(a, b) {
    $756644e23111daff$var$Cf = $756644e23111daff$var$dd;
    a = $756644e23111daff$var$Me();
    if ($756644e23111daff$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $756644e23111daff$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $756644e23111daff$var$dd = !1;
    for($756644e23111daff$var$V = b; null !== $756644e23111daff$var$V;)if (b = $756644e23111daff$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $756644e23111daff$var$V = a;
    else for(; null !== $756644e23111daff$var$V;){
        b = $756644e23111daff$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $756644e23111daff$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($756644e23111daff$var$p(163));
            }
        } catch (F) {
            $756644e23111daff$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $756644e23111daff$var$V = a;
            break;
        }
        $756644e23111daff$var$V = b.return;
    }
    n = $756644e23111daff$var$Oj;
    $756644e23111daff$var$Oj = !1;
    return n;
}
function $756644e23111daff$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $756644e23111daff$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $756644e23111daff$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $756644e23111daff$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $756644e23111daff$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $756644e23111daff$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$756644e23111daff$var$Of], delete b[$756644e23111daff$var$Pf], delete b[$756644e23111daff$var$of], delete b[$756644e23111daff$var$Qf], delete b[$756644e23111daff$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $756644e23111daff$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $756644e23111daff$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $756644e23111daff$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $756644e23111daff$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $756644e23111daff$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($756644e23111daff$var$Wj(a, b, c), a = a.sibling; null !== a;)$756644e23111daff$var$Wj(a, b, c), a = a.sibling;
}
function $756644e23111daff$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($756644e23111daff$var$Xj(a, b, c), a = a.sibling; null !== a;)$756644e23111daff$var$Xj(a, b, c), a = a.sibling;
}
var $756644e23111daff$var$X = null, $756644e23111daff$var$Yj = !1;
function $756644e23111daff$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$756644e23111daff$var$ak(a, b, c), c = c.sibling;
}
function $756644e23111daff$var$ak(a, b, c) {
    if ($756644e23111daff$var$lc && "function" === typeof $756644e23111daff$var$lc.onCommitFiberUnmount) try {
        $756644e23111daff$var$lc.onCommitFiberUnmount($756644e23111daff$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $756644e23111daff$var$U || $756644e23111daff$var$Mj(c, b);
        case 6:
            var d = $756644e23111daff$var$X, e = $756644e23111daff$var$Yj;
            $756644e23111daff$var$X = null;
            $756644e23111daff$var$Zj(a, b, c);
            $756644e23111daff$var$X = d;
            $756644e23111daff$var$Yj = e;
            null !== $756644e23111daff$var$X && ($756644e23111daff$var$Yj ? (a = $756644e23111daff$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $756644e23111daff$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $756644e23111daff$var$X && ($756644e23111daff$var$Yj ? (a = $756644e23111daff$var$X, c = c.stateNode, 8 === a.nodeType ? $756644e23111daff$var$Kf(a.parentNode, c) : 1 === a.nodeType && $756644e23111daff$var$Kf(a, c), $756644e23111daff$var$bd(a)) : $756644e23111daff$var$Kf($756644e23111daff$var$X, c.stateNode));
            break;
        case 4:
            d = $756644e23111daff$var$X;
            e = $756644e23111daff$var$Yj;
            $756644e23111daff$var$X = c.stateNode.containerInfo;
            $756644e23111daff$var$Yj = !0;
            $756644e23111daff$var$Zj(a, b, c);
            $756644e23111daff$var$X = d;
            $756644e23111daff$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$756644e23111daff$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $756644e23111daff$var$Nj(c, b, g) : 0 !== (f & 4) && $756644e23111daff$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $756644e23111daff$var$Zj(a, b, c);
            break;
        case 1:
            if (!$756644e23111daff$var$U && ($756644e23111daff$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $756644e23111daff$var$W(c, b, h);
            }
            $756644e23111daff$var$Zj(a, b, c);
            break;
        case 21:
            $756644e23111daff$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($756644e23111daff$var$U = (d = $756644e23111daff$var$U) || null !== c.memoizedState, $756644e23111daff$var$Zj(a, b, c), $756644e23111daff$var$U = d) : $756644e23111daff$var$Zj(a, b, c);
            break;
        default:
            $756644e23111daff$var$Zj(a, b, c);
    }
}
function $756644e23111daff$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $756644e23111daff$var$Lj);
        b.forEach(function(b) {
            var d = $756644e23111daff$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $756644e23111daff$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $756644e23111daff$var$X = h.stateNode;
                        $756644e23111daff$var$Yj = !1;
                        break a;
                    case 3:
                        $756644e23111daff$var$X = h.stateNode.containerInfo;
                        $756644e23111daff$var$Yj = !0;
                        break a;
                    case 4:
                        $756644e23111daff$var$X = h.stateNode.containerInfo;
                        $756644e23111daff$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $756644e23111daff$var$X) throw Error($756644e23111daff$var$p(160));
            $756644e23111daff$var$ak(f, g, e);
            $756644e23111daff$var$X = null;
            $756644e23111daff$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $756644e23111daff$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$756644e23111daff$var$ek(b, a), b = b.sibling;
}
function $756644e23111daff$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $756644e23111daff$var$dk(b, a);
            $756644e23111daff$var$fk(a);
            if (d & 4) {
                try {
                    $756644e23111daff$var$Qj(3, a, a.return), $756644e23111daff$var$Rj(3, a);
                } catch (t) {
                    $756644e23111daff$var$W(a, a.return, t);
                }
                try {
                    $756644e23111daff$var$Qj(5, a, a.return);
                } catch (t) {
                    $756644e23111daff$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $756644e23111daff$var$dk(b, a);
            $756644e23111daff$var$fk(a);
            d & 512 && null !== c && $756644e23111daff$var$Mj(c, c.return);
            break;
        case 5:
            $756644e23111daff$var$dk(b, a);
            $756644e23111daff$var$fk(a);
            d & 512 && null !== c && $756644e23111daff$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $756644e23111daff$var$ob(e, "");
                } catch (t) {
                    $756644e23111daff$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $756644e23111daff$var$ab(e, f);
                    $756644e23111daff$var$vb(h, g);
                    var l = $756644e23111daff$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $756644e23111daff$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $756644e23111daff$var$nb(e, q) : "children" === m ? $756644e23111daff$var$ob(e, q) : $756644e23111daff$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $756644e23111daff$var$bb(e, f);
                            break;
                        case "textarea":
                            $756644e23111daff$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $756644e23111daff$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $756644e23111daff$var$fb(e, !!f.multiple, f.defaultValue, !0) : $756644e23111daff$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$756644e23111daff$var$Pf] = f;
                } catch (t) {
                    $756644e23111daff$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $756644e23111daff$var$dk(b, a);
            $756644e23111daff$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($756644e23111daff$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $756644e23111daff$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $756644e23111daff$var$dk(b, a);
            $756644e23111daff$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $756644e23111daff$var$bd(b.containerInfo);
            } catch (t) {
                $756644e23111daff$var$W(a, a.return, t);
            }
            break;
        case 4:
            $756644e23111daff$var$dk(b, a);
            $756644e23111daff$var$fk(a);
            break;
        case 13:
            $756644e23111daff$var$dk(b, a);
            $756644e23111daff$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($756644e23111daff$var$gk = $756644e23111daff$var$B()));
            d & 4 && $756644e23111daff$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($756644e23111daff$var$U = (l = $756644e23111daff$var$U) || m, $756644e23111daff$var$dk(b, a), $756644e23111daff$var$U = l) : $756644e23111daff$var$dk(b, a);
            $756644e23111daff$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($756644e23111daff$var$V = a, m = a.child; null !== m;){
                    for(q = $756644e23111daff$var$V = m; null !== $756644e23111daff$var$V;){
                        r = $756644e23111daff$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $756644e23111daff$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $756644e23111daff$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $756644e23111daff$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $756644e23111daff$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $756644e23111daff$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $756644e23111daff$var$V = y) : $756644e23111daff$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $756644e23111daff$var$rb("display", g));
                            } catch (t) {
                                $756644e23111daff$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $756644e23111daff$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $756644e23111daff$var$dk(b, a);
            $756644e23111daff$var$fk(a);
            d & 4 && $756644e23111daff$var$bk(a);
            break;
        case 21:
            break;
        default:
            $756644e23111daff$var$dk(b, a), $756644e23111daff$var$fk(a);
    }
}
function $756644e23111daff$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($756644e23111daff$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($756644e23111daff$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($756644e23111daff$var$ob(e, ""), d.flags &= -33);
                    var f = $756644e23111daff$var$Vj(a);
                    $756644e23111daff$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $756644e23111daff$var$Vj(a);
                    $756644e23111daff$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($756644e23111daff$var$p(161));
            }
        } catch (k) {
            $756644e23111daff$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $756644e23111daff$var$ik(a, b, c) {
    $756644e23111daff$var$V = a;
    $756644e23111daff$var$jk(a, b, c);
}
function $756644e23111daff$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $756644e23111daff$var$V;){
        var e = $756644e23111daff$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $756644e23111daff$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $756644e23111daff$var$U;
                h = $756644e23111daff$var$Kj;
                var l = $756644e23111daff$var$U;
                $756644e23111daff$var$Kj = g;
                if (($756644e23111daff$var$U = k) && !l) for($756644e23111daff$var$V = e; null !== $756644e23111daff$var$V;)g = $756644e23111daff$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $756644e23111daff$var$kk(e) : null !== k ? (k.return = g, $756644e23111daff$var$V = k) : $756644e23111daff$var$kk(e);
                for(; null !== f;)$756644e23111daff$var$V = f, $756644e23111daff$var$jk(f, b, c), f = f.sibling;
                $756644e23111daff$var$V = e;
                $756644e23111daff$var$Kj = h;
                $756644e23111daff$var$U = l;
            }
            $756644e23111daff$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $756644e23111daff$var$V = f) : $756644e23111daff$var$lk(a, b, c);
    }
}
function $756644e23111daff$var$lk(a) {
    for(; null !== $756644e23111daff$var$V;){
        var b = $756644e23111daff$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $756644e23111daff$var$U || $756644e23111daff$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$756644e23111daff$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $756644e23111daff$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $756644e23111daff$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $756644e23111daff$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $756644e23111daff$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($756644e23111daff$var$p(163));
                }
                $756644e23111daff$var$U || b.flags & 512 && $756644e23111daff$var$Sj(b);
            } catch (r) {
                $756644e23111daff$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $756644e23111daff$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $756644e23111daff$var$V = c;
            break;
        }
        $756644e23111daff$var$V = b.return;
    }
}
function $756644e23111daff$var$hk(a) {
    for(; null !== $756644e23111daff$var$V;){
        var b = $756644e23111daff$var$V;
        if (b === a) {
            $756644e23111daff$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $756644e23111daff$var$V = c;
            break;
        }
        $756644e23111daff$var$V = b.return;
    }
}
function $756644e23111daff$var$kk(a) {
    for(; null !== $756644e23111daff$var$V;){
        var b = $756644e23111daff$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $756644e23111daff$var$Rj(4, b);
                    } catch (k) {
                        $756644e23111daff$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $756644e23111daff$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $756644e23111daff$var$Sj(b);
                    } catch (k) {
                        $756644e23111daff$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $756644e23111daff$var$Sj(b);
                    } catch (k) {
                        $756644e23111daff$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $756644e23111daff$var$W(b, b.return, k);
        }
        if (b === a) {
            $756644e23111daff$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $756644e23111daff$var$V = h;
            break;
        }
        $756644e23111daff$var$V = b.return;
    }
}
var $756644e23111daff$var$mk = Math.ceil, $756644e23111daff$var$nk = $756644e23111daff$var$ua.ReactCurrentDispatcher, $756644e23111daff$var$ok = $756644e23111daff$var$ua.ReactCurrentOwner, $756644e23111daff$var$pk = $756644e23111daff$var$ua.ReactCurrentBatchConfig, $756644e23111daff$var$K = 0, $756644e23111daff$var$R = null, $756644e23111daff$var$Y = null, $756644e23111daff$var$Z = 0, $756644e23111daff$var$gj = 0, $756644e23111daff$var$fj = $756644e23111daff$var$Uf(0), $756644e23111daff$var$T = 0, $756644e23111daff$var$qk = null, $756644e23111daff$var$hh = 0, $756644e23111daff$var$rk = 0, $756644e23111daff$var$sk = 0, $756644e23111daff$var$tk = null, $756644e23111daff$var$uk = null, $756644e23111daff$var$gk = 0, $756644e23111daff$var$Hj = Infinity, $756644e23111daff$var$vk = null, $756644e23111daff$var$Pi = !1, $756644e23111daff$var$Qi = null, $756644e23111daff$var$Si = null, $756644e23111daff$var$wk = !1, $756644e23111daff$var$xk = null, $756644e23111daff$var$yk = 0, $756644e23111daff$var$zk = 0, $756644e23111daff$var$Ak = null, $756644e23111daff$var$Bk = -1, $756644e23111daff$var$Ck = 0;
function $756644e23111daff$var$L() {
    return 0 !== ($756644e23111daff$var$K & 6) ? $756644e23111daff$var$B() : -1 !== $756644e23111daff$var$Bk ? $756644e23111daff$var$Bk : $756644e23111daff$var$Bk = $756644e23111daff$var$B();
}
function $756644e23111daff$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($756644e23111daff$var$K & 2) && 0 !== $756644e23111daff$var$Z) return $756644e23111daff$var$Z & -$756644e23111daff$var$Z;
    if (null !== $756644e23111daff$var$Kg.transition) return 0 === $756644e23111daff$var$Ck && ($756644e23111daff$var$Ck = $756644e23111daff$var$yc()), $756644e23111daff$var$Ck;
    a = $756644e23111daff$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $756644e23111daff$var$jd(a.type);
    return a;
}
function $756644e23111daff$var$mh(a, b, c, d) {
    if (50 < $756644e23111daff$var$zk) throw $756644e23111daff$var$zk = 0, $756644e23111daff$var$Ak = null, Error($756644e23111daff$var$p(185));
    $756644e23111daff$var$Ac(a, c, d);
    if (0 === ($756644e23111daff$var$K & 2) || a !== $756644e23111daff$var$R) a === $756644e23111daff$var$R && (0 === ($756644e23111daff$var$K & 2) && ($756644e23111daff$var$rk |= c), 4 === $756644e23111daff$var$T && $756644e23111daff$var$Dk(a, $756644e23111daff$var$Z)), $756644e23111daff$var$Ek(a, d), 1 === c && 0 === $756644e23111daff$var$K && 0 === (b.mode & 1) && ($756644e23111daff$var$Hj = $756644e23111daff$var$B() + 500, $756644e23111daff$var$fg && $756644e23111daff$var$jg());
}
function $756644e23111daff$var$Ek(a, b) {
    var c = a.callbackNode;
    $756644e23111daff$var$wc(a, b);
    var d = $756644e23111daff$var$uc(a, a === $756644e23111daff$var$R ? $756644e23111daff$var$Z : 0);
    if (0 === d) null !== c && $756644e23111daff$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $756644e23111daff$var$bc(c);
        if (1 === b) 0 === a.tag ? $756644e23111daff$var$ig($756644e23111daff$var$Fk.bind(null, a)) : $756644e23111daff$var$hg($756644e23111daff$var$Fk.bind(null, a)), $756644e23111daff$var$Jf(function() {
            0 === ($756644e23111daff$var$K & 6) && $756644e23111daff$var$jg();
        }), c = null;
        else {
            switch($756644e23111daff$var$Dc(d)){
                case 1:
                    c = $756644e23111daff$var$fc;
                    break;
                case 4:
                    c = $756644e23111daff$var$gc;
                    break;
                case 16:
                    c = $756644e23111daff$var$hc;
                    break;
                case 536870912:
                    c = $756644e23111daff$var$jc;
                    break;
                default:
                    c = $756644e23111daff$var$hc;
            }
            c = $756644e23111daff$var$Gk(c, $756644e23111daff$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $756644e23111daff$var$Hk(a, b) {
    $756644e23111daff$var$Bk = -1;
    $756644e23111daff$var$Ck = 0;
    if (0 !== ($756644e23111daff$var$K & 6)) throw Error($756644e23111daff$var$p(327));
    var c = a.callbackNode;
    if ($756644e23111daff$var$Ik() && a.callbackNode !== c) return null;
    var d = $756644e23111daff$var$uc(a, a === $756644e23111daff$var$R ? $756644e23111daff$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $756644e23111daff$var$Jk(a, d);
    else {
        b = d;
        var e = $756644e23111daff$var$K;
        $756644e23111daff$var$K |= 2;
        var f = $756644e23111daff$var$Kk();
        if ($756644e23111daff$var$R !== a || $756644e23111daff$var$Z !== b) $756644e23111daff$var$vk = null, $756644e23111daff$var$Hj = $756644e23111daff$var$B() + 500, $756644e23111daff$var$Lk(a, b);
        for(;;)try {
            $756644e23111daff$var$Mk();
            break;
        } catch (h) {
            $756644e23111daff$var$Nk(a, h);
        }
        $756644e23111daff$var$Qg();
        $756644e23111daff$var$nk.current = f;
        $756644e23111daff$var$K = e;
        null !== $756644e23111daff$var$Y ? b = 0 : ($756644e23111daff$var$R = null, $756644e23111daff$var$Z = 0, b = $756644e23111daff$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $756644e23111daff$var$xc(a), 0 !== e && (d = e, b = $756644e23111daff$var$Ok(a, e)));
        if (1 === b) throw c = $756644e23111daff$var$qk, $756644e23111daff$var$Lk(a, 0), $756644e23111daff$var$Dk(a, d), $756644e23111daff$var$Ek(a, $756644e23111daff$var$B()), c;
        if (6 === b) $756644e23111daff$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$756644e23111daff$var$Pk(e) && (b = $756644e23111daff$var$Jk(a, d), 2 === b && (f = $756644e23111daff$var$xc(a), 0 !== f && (d = f, b = $756644e23111daff$var$Ok(a, f))), 1 === b)) throw c = $756644e23111daff$var$qk, $756644e23111daff$var$Lk(a, 0), $756644e23111daff$var$Dk(a, d), $756644e23111daff$var$Ek(a, $756644e23111daff$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($756644e23111daff$var$p(345));
                case 2:
                    $756644e23111daff$var$Qk(a, $756644e23111daff$var$uk, $756644e23111daff$var$vk);
                    break;
                case 3:
                    $756644e23111daff$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $756644e23111daff$var$gk + 500 - $756644e23111daff$var$B(), 10 < b)) {
                        if (0 !== $756644e23111daff$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $756644e23111daff$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $756644e23111daff$var$Ff($756644e23111daff$var$Qk.bind(null, a, $756644e23111daff$var$uk, $756644e23111daff$var$vk), b);
                        break;
                    }
                    $756644e23111daff$var$Qk(a, $756644e23111daff$var$uk, $756644e23111daff$var$vk);
                    break;
                case 4:
                    $756644e23111daff$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $756644e23111daff$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $756644e23111daff$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $756644e23111daff$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $756644e23111daff$var$Ff($756644e23111daff$var$Qk.bind(null, a, $756644e23111daff$var$uk, $756644e23111daff$var$vk), d);
                        break;
                    }
                    $756644e23111daff$var$Qk(a, $756644e23111daff$var$uk, $756644e23111daff$var$vk);
                    break;
                case 5:
                    $756644e23111daff$var$Qk(a, $756644e23111daff$var$uk, $756644e23111daff$var$vk);
                    break;
                default:
                    throw Error($756644e23111daff$var$p(329));
            }
        }
    }
    $756644e23111daff$var$Ek(a, $756644e23111daff$var$B());
    return a.callbackNode === c ? $756644e23111daff$var$Hk.bind(null, a) : null;
}
function $756644e23111daff$var$Ok(a, b) {
    var c = $756644e23111daff$var$tk;
    a.current.memoizedState.isDehydrated && ($756644e23111daff$var$Lk(a, b).flags |= 256);
    a = $756644e23111daff$var$Jk(a, b);
    2 !== a && (b = $756644e23111daff$var$uk, $756644e23111daff$var$uk = c, null !== b && $756644e23111daff$var$Gj(b));
    return a;
}
function $756644e23111daff$var$Gj(a) {
    null === $756644e23111daff$var$uk ? $756644e23111daff$var$uk = a : $756644e23111daff$var$uk.push.apply($756644e23111daff$var$uk, a);
}
function $756644e23111daff$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$756644e23111daff$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $756644e23111daff$var$Dk(a, b) {
    b &= ~$756644e23111daff$var$sk;
    b &= ~$756644e23111daff$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $756644e23111daff$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $756644e23111daff$var$Fk(a) {
    if (0 !== ($756644e23111daff$var$K & 6)) throw Error($756644e23111daff$var$p(327));
    $756644e23111daff$var$Ik();
    var b = $756644e23111daff$var$uc(a, 0);
    if (0 === (b & 1)) return $756644e23111daff$var$Ek(a, $756644e23111daff$var$B()), null;
    var c = $756644e23111daff$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $756644e23111daff$var$xc(a);
        0 !== d && (b = d, c = $756644e23111daff$var$Ok(a, d));
    }
    if (1 === c) throw c = $756644e23111daff$var$qk, $756644e23111daff$var$Lk(a, 0), $756644e23111daff$var$Dk(a, b), $756644e23111daff$var$Ek(a, $756644e23111daff$var$B()), c;
    if (6 === c) throw Error($756644e23111daff$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $756644e23111daff$var$Qk(a, $756644e23111daff$var$uk, $756644e23111daff$var$vk);
    $756644e23111daff$var$Ek(a, $756644e23111daff$var$B());
    return null;
}
function $756644e23111daff$var$Rk(a, b) {
    var c = $756644e23111daff$var$K;
    $756644e23111daff$var$K |= 1;
    try {
        return a(b);
    } finally{
        $756644e23111daff$var$K = c, 0 === $756644e23111daff$var$K && ($756644e23111daff$var$Hj = $756644e23111daff$var$B() + 500, $756644e23111daff$var$fg && $756644e23111daff$var$jg());
    }
}
function $756644e23111daff$var$Sk(a) {
    null !== $756644e23111daff$var$xk && 0 === $756644e23111daff$var$xk.tag && 0 === ($756644e23111daff$var$K & 6) && $756644e23111daff$var$Ik();
    var b = $756644e23111daff$var$K;
    $756644e23111daff$var$K |= 1;
    var c = $756644e23111daff$var$pk.transition, d = $756644e23111daff$var$C;
    try {
        if ($756644e23111daff$var$pk.transition = null, $756644e23111daff$var$C = 1, a) return a();
    } finally{
        $756644e23111daff$var$C = d, $756644e23111daff$var$pk.transition = c, $756644e23111daff$var$K = b, 0 === ($756644e23111daff$var$K & 6) && $756644e23111daff$var$jg();
    }
}
function $756644e23111daff$var$Ij() {
    $756644e23111daff$var$gj = $756644e23111daff$var$fj.current;
    $756644e23111daff$var$E($756644e23111daff$var$fj);
}
function $756644e23111daff$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $756644e23111daff$var$Gf(c));
    if (null !== $756644e23111daff$var$Y) for(c = $756644e23111daff$var$Y.return; null !== c;){
        var d = c;
        $756644e23111daff$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $756644e23111daff$var$$f();
                break;
            case 3:
                $756644e23111daff$var$Jh();
                $756644e23111daff$var$E($756644e23111daff$var$Wf);
                $756644e23111daff$var$E($756644e23111daff$var$H);
                $756644e23111daff$var$Oh();
                break;
            case 5:
                $756644e23111daff$var$Lh(d);
                break;
            case 4:
                $756644e23111daff$var$Jh();
                break;
            case 13:
                $756644e23111daff$var$E($756644e23111daff$var$M);
                break;
            case 19:
                $756644e23111daff$var$E($756644e23111daff$var$M);
                break;
            case 10:
                $756644e23111daff$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $756644e23111daff$var$Ij();
        }
        c = c.return;
    }
    $756644e23111daff$var$R = a;
    $756644e23111daff$var$Y = a = $756644e23111daff$var$wh(a.current, null);
    $756644e23111daff$var$Z = $756644e23111daff$var$gj = b;
    $756644e23111daff$var$T = 0;
    $756644e23111daff$var$qk = null;
    $756644e23111daff$var$sk = $756644e23111daff$var$rk = $756644e23111daff$var$hh = 0;
    $756644e23111daff$var$uk = $756644e23111daff$var$tk = null;
    if (null !== $756644e23111daff$var$Wg) {
        for(b = 0; b < $756644e23111daff$var$Wg.length; b++)if (c = $756644e23111daff$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $756644e23111daff$var$Wg = null;
    }
    return a;
}
function $756644e23111daff$var$Nk(a, b) {
    do {
        var c = $756644e23111daff$var$Y;
        try {
            $756644e23111daff$var$Qg();
            $756644e23111daff$var$Ph.current = $756644e23111daff$var$ai;
            if ($756644e23111daff$var$Sh) {
                for(var d = $756644e23111daff$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $756644e23111daff$var$Sh = !1;
            }
            $756644e23111daff$var$Rh = 0;
            $756644e23111daff$var$P = $756644e23111daff$var$O = $756644e23111daff$var$N = null;
            $756644e23111daff$var$Th = !1;
            $756644e23111daff$var$Uh = 0;
            $756644e23111daff$var$ok.current = null;
            if (null === c || null === c.return) {
                $756644e23111daff$var$T = 1;
                $756644e23111daff$var$qk = b;
                $756644e23111daff$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $756644e23111daff$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $756644e23111daff$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $756644e23111daff$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $756644e23111daff$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $756644e23111daff$var$Ti(f, l, b);
                            $756644e23111daff$var$uj();
                            break a;
                        }
                        k = Error($756644e23111daff$var$p(426));
                    }
                } else if ($756644e23111daff$var$I && h.mode & 1) {
                    var J = $756644e23111daff$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $756644e23111daff$var$Wi(J, g, h, f, b);
                        $756644e23111daff$var$Jg($756644e23111daff$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $756644e23111daff$var$Ki(k, h);
                4 !== $756644e23111daff$var$T && ($756644e23111daff$var$T = 2);
                null === $756644e23111daff$var$tk ? $756644e23111daff$var$tk = [
                    f
                ] : $756644e23111daff$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $756644e23111daff$var$Oi(f, k, b);
                            $756644e23111daff$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $756644e23111daff$var$Si || !$756644e23111daff$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $756644e23111daff$var$Ri(f, h, b);
                                $756644e23111daff$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $756644e23111daff$var$Tk(c);
        } catch (na) {
            b = na;
            $756644e23111daff$var$Y === c && null !== c && ($756644e23111daff$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $756644e23111daff$var$Kk() {
    var a = $756644e23111daff$var$nk.current;
    $756644e23111daff$var$nk.current = $756644e23111daff$var$ai;
    return null === a ? $756644e23111daff$var$ai : a;
}
function $756644e23111daff$var$uj() {
    if (0 === $756644e23111daff$var$T || 3 === $756644e23111daff$var$T || 2 === $756644e23111daff$var$T) $756644e23111daff$var$T = 4;
    null === $756644e23111daff$var$R || 0 === ($756644e23111daff$var$hh & 268435455) && 0 === ($756644e23111daff$var$rk & 268435455) || $756644e23111daff$var$Dk($756644e23111daff$var$R, $756644e23111daff$var$Z);
}
function $756644e23111daff$var$Jk(a, b) {
    var c = $756644e23111daff$var$K;
    $756644e23111daff$var$K |= 2;
    var d = $756644e23111daff$var$Kk();
    if ($756644e23111daff$var$R !== a || $756644e23111daff$var$Z !== b) $756644e23111daff$var$vk = null, $756644e23111daff$var$Lk(a, b);
    for(;;)try {
        $756644e23111daff$var$Uk();
        break;
    } catch (e) {
        $756644e23111daff$var$Nk(a, e);
    }
    $756644e23111daff$var$Qg();
    $756644e23111daff$var$K = c;
    $756644e23111daff$var$nk.current = d;
    if (null !== $756644e23111daff$var$Y) throw Error($756644e23111daff$var$p(261));
    $756644e23111daff$var$R = null;
    $756644e23111daff$var$Z = 0;
    return $756644e23111daff$var$T;
}
function $756644e23111daff$var$Uk() {
    for(; null !== $756644e23111daff$var$Y;)$756644e23111daff$var$Vk($756644e23111daff$var$Y);
}
function $756644e23111daff$var$Mk() {
    for(; null !== $756644e23111daff$var$Y && !$756644e23111daff$var$cc();)$756644e23111daff$var$Vk($756644e23111daff$var$Y);
}
function $756644e23111daff$var$Vk(a) {
    var b = $756644e23111daff$var$Wk(a.alternate, a, $756644e23111daff$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $756644e23111daff$var$Tk(a) : $756644e23111daff$var$Y = b;
    $756644e23111daff$var$ok.current = null;
}
function $756644e23111daff$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $756644e23111daff$var$Fj(c, b, $756644e23111daff$var$gj), null !== c) {
                $756644e23111daff$var$Y = c;
                return;
            }
        } else {
            c = $756644e23111daff$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $756644e23111daff$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $756644e23111daff$var$T = 6;
                $756644e23111daff$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $756644e23111daff$var$Y = b;
            return;
        }
        $756644e23111daff$var$Y = b = a;
    }while (null !== b);
    0 === $756644e23111daff$var$T && ($756644e23111daff$var$T = 5);
}
function $756644e23111daff$var$Qk(a, b, c) {
    var d = $756644e23111daff$var$C, e = $756644e23111daff$var$pk.transition;
    try {
        $756644e23111daff$var$pk.transition = null, $756644e23111daff$var$C = 1, $756644e23111daff$var$Xk(a, b, c, d);
    } finally{
        $756644e23111daff$var$pk.transition = e, $756644e23111daff$var$C = d;
    }
    return null;
}
function $756644e23111daff$var$Xk(a, b, c, d) {
    do $756644e23111daff$var$Ik();
    while (null !== $756644e23111daff$var$xk);
    if (0 !== ($756644e23111daff$var$K & 6)) throw Error($756644e23111daff$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($756644e23111daff$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $756644e23111daff$var$Bc(a, f);
    a === $756644e23111daff$var$R && ($756644e23111daff$var$Y = $756644e23111daff$var$R = null, $756644e23111daff$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $756644e23111daff$var$wk || ($756644e23111daff$var$wk = !0, $756644e23111daff$var$Gk($756644e23111daff$var$hc, function() {
        $756644e23111daff$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $756644e23111daff$var$pk.transition;
        $756644e23111daff$var$pk.transition = null;
        var g = $756644e23111daff$var$C;
        $756644e23111daff$var$C = 1;
        var h = $756644e23111daff$var$K;
        $756644e23111daff$var$K |= 4;
        $756644e23111daff$var$ok.current = null;
        $756644e23111daff$var$Pj(a, c);
        $756644e23111daff$var$ek(c, a);
        $756644e23111daff$var$Oe($756644e23111daff$var$Df);
        $756644e23111daff$var$dd = !!$756644e23111daff$var$Cf;
        $756644e23111daff$var$Df = $756644e23111daff$var$Cf = null;
        a.current = c;
        $756644e23111daff$var$ik(c, a, e);
        $756644e23111daff$var$dc();
        $756644e23111daff$var$K = h;
        $756644e23111daff$var$C = g;
        $756644e23111daff$var$pk.transition = f;
    } else a.current = c;
    $756644e23111daff$var$wk && ($756644e23111daff$var$wk = !1, $756644e23111daff$var$xk = a, $756644e23111daff$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($756644e23111daff$var$Si = null);
    $756644e23111daff$var$mc(c.stateNode, d);
    $756644e23111daff$var$Ek(a, $756644e23111daff$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($756644e23111daff$var$Pi) throw $756644e23111daff$var$Pi = !1, a = $756644e23111daff$var$Qi, $756644e23111daff$var$Qi = null, a;
    0 !== ($756644e23111daff$var$yk & 1) && 0 !== a.tag && $756644e23111daff$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $756644e23111daff$var$Ak ? $756644e23111daff$var$zk++ : ($756644e23111daff$var$zk = 0, $756644e23111daff$var$Ak = a) : $756644e23111daff$var$zk = 0;
    $756644e23111daff$var$jg();
    return null;
}
function $756644e23111daff$var$Ik() {
    if (null !== $756644e23111daff$var$xk) {
        var a = $756644e23111daff$var$Dc($756644e23111daff$var$yk), b = $756644e23111daff$var$pk.transition, c = $756644e23111daff$var$C;
        try {
            $756644e23111daff$var$pk.transition = null;
            $756644e23111daff$var$C = 16 > a ? 16 : a;
            if (null === $756644e23111daff$var$xk) var d = !1;
            else {
                a = $756644e23111daff$var$xk;
                $756644e23111daff$var$xk = null;
                $756644e23111daff$var$yk = 0;
                if (0 !== ($756644e23111daff$var$K & 6)) throw Error($756644e23111daff$var$p(331));
                var e = $756644e23111daff$var$K;
                $756644e23111daff$var$K |= 4;
                for($756644e23111daff$var$V = a.current; null !== $756644e23111daff$var$V;){
                    var f = $756644e23111daff$var$V, g = f.child;
                    if (0 !== ($756644e23111daff$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($756644e23111daff$var$V = l; null !== $756644e23111daff$var$V;){
                                    var m = $756644e23111daff$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $756644e23111daff$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $756644e23111daff$var$V = q;
                                    else for(; null !== $756644e23111daff$var$V;){
                                        m = $756644e23111daff$var$V;
                                        var r = m.sibling, y = m.return;
                                        $756644e23111daff$var$Tj(m);
                                        if (m === l) {
                                            $756644e23111daff$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $756644e23111daff$var$V = r;
                                            break;
                                        }
                                        $756644e23111daff$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $756644e23111daff$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $756644e23111daff$var$V = g;
                    else b: for(; null !== $756644e23111daff$var$V;){
                        f = $756644e23111daff$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $756644e23111daff$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $756644e23111daff$var$V = x;
                            break b;
                        }
                        $756644e23111daff$var$V = f.return;
                    }
                }
                var w = a.current;
                for($756644e23111daff$var$V = w; null !== $756644e23111daff$var$V;){
                    g = $756644e23111daff$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $756644e23111daff$var$V = u;
                    else b: for(g = w; null !== $756644e23111daff$var$V;){
                        h = $756644e23111daff$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $756644e23111daff$var$Rj(9, h);
                            }
                        } catch (na) {
                            $756644e23111daff$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $756644e23111daff$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $756644e23111daff$var$V = F;
                            break b;
                        }
                        $756644e23111daff$var$V = h.return;
                    }
                }
                $756644e23111daff$var$K = e;
                $756644e23111daff$var$jg();
                if ($756644e23111daff$var$lc && "function" === typeof $756644e23111daff$var$lc.onPostCommitFiberRoot) try {
                    $756644e23111daff$var$lc.onPostCommitFiberRoot($756644e23111daff$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $756644e23111daff$var$C = c, $756644e23111daff$var$pk.transition = b;
        }
    }
    return !1;
}
function $756644e23111daff$var$Yk(a, b, c) {
    b = $756644e23111daff$var$Ki(c, b);
    b = $756644e23111daff$var$Oi(a, b, 1);
    a = $756644e23111daff$var$dh(a, b, 1);
    b = $756644e23111daff$var$L();
    null !== a && ($756644e23111daff$var$Ac(a, 1, b), $756644e23111daff$var$Ek(a, b));
}
function $756644e23111daff$var$W(a, b, c) {
    if (3 === a.tag) $756644e23111daff$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $756644e23111daff$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $756644e23111daff$var$Si || !$756644e23111daff$var$Si.has(d))) {
                a = $756644e23111daff$var$Ki(c, a);
                a = $756644e23111daff$var$Ri(b, a, 1);
                b = $756644e23111daff$var$dh(b, a, 1);
                a = $756644e23111daff$var$L();
                null !== b && ($756644e23111daff$var$Ac(b, 1, a), $756644e23111daff$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $756644e23111daff$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $756644e23111daff$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $756644e23111daff$var$R === a && ($756644e23111daff$var$Z & c) === c && (4 === $756644e23111daff$var$T || 3 === $756644e23111daff$var$T && ($756644e23111daff$var$Z & 130023424) === $756644e23111daff$var$Z && 500 > $756644e23111daff$var$B() - $756644e23111daff$var$gk ? $756644e23111daff$var$Lk(a, 0) : $756644e23111daff$var$sk |= c);
    $756644e23111daff$var$Ek(a, b);
}
function $756644e23111daff$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $756644e23111daff$var$sc, $756644e23111daff$var$sc <<= 1, 0 === ($756644e23111daff$var$sc & 130023424) && ($756644e23111daff$var$sc = 4194304)));
    var c = $756644e23111daff$var$L();
    a = $756644e23111daff$var$Zg(a, b);
    null !== a && ($756644e23111daff$var$Ac(a, b, c), $756644e23111daff$var$Ek(a, c));
}
function $756644e23111daff$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $756644e23111daff$var$Zk(a, c);
}
function $756644e23111daff$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($756644e23111daff$var$p(314));
    }
    null !== d && d.delete(b);
    $756644e23111daff$var$Zk(a, c);
}
var $756644e23111daff$var$Wk;
$756644e23111daff$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $756644e23111daff$var$Wf.current) $756644e23111daff$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $756644e23111daff$var$Ug = !1, $756644e23111daff$var$zj(a, b, c);
            $756644e23111daff$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $756644e23111daff$var$Ug = !1, $756644e23111daff$var$I && 0 !== (b.flags & 1048576) && $756644e23111daff$var$ug(b, $756644e23111daff$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $756644e23111daff$var$jj(a, b);
            a = b.pendingProps;
            var e = $756644e23111daff$var$Yf(b, $756644e23111daff$var$H.current);
            $756644e23111daff$var$Tg(b, c);
            e = $756644e23111daff$var$Xh(null, b, d, a, e, c);
            var f = $756644e23111daff$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $756644e23111daff$var$Zf(d) ? (f = !0, $756644e23111daff$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $756644e23111daff$var$ah(b), e.updater = $756644e23111daff$var$nh, b.stateNode = e, e._reactInternals = b, $756644e23111daff$var$rh(b, d, a, c), b = $756644e23111daff$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $756644e23111daff$var$I && f && $756644e23111daff$var$vg(b), $756644e23111daff$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $756644e23111daff$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $756644e23111daff$var$$k(d);
                a = $756644e23111daff$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $756644e23111daff$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $756644e23111daff$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $756644e23111daff$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $756644e23111daff$var$aj(null, b, d, $756644e23111daff$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($756644e23111daff$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $756644e23111daff$var$Lg(d, e), $756644e23111daff$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $756644e23111daff$var$Lg(d, e), $756644e23111daff$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $756644e23111daff$var$lj(b);
                if (null === a) throw Error($756644e23111daff$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $756644e23111daff$var$bh(a, b);
                $756644e23111daff$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $756644e23111daff$var$Ki(Error($756644e23111daff$var$p(423)), b);
                        b = $756644e23111daff$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $756644e23111daff$var$Ki(Error($756644e23111daff$var$p(424)), b);
                        b = $756644e23111daff$var$mj(a, b, d, c, e);
                        break a;
                    } else for($756644e23111daff$var$yg = $756644e23111daff$var$Lf(b.stateNode.containerInfo.firstChild), $756644e23111daff$var$xg = b, $756644e23111daff$var$I = !0, $756644e23111daff$var$zg = null, c = $756644e23111daff$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $756644e23111daff$var$Ig();
                    if (d === e) {
                        b = $756644e23111daff$var$$i(a, b, c);
                        break a;
                    }
                    $756644e23111daff$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $756644e23111daff$var$Kh(b), null === a && $756644e23111daff$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $756644e23111daff$var$Ef(d, e) ? g = null : null !== f && $756644e23111daff$var$Ef(d, f) && (b.flags |= 32), $756644e23111daff$var$hj(a, b), $756644e23111daff$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $756644e23111daff$var$Eg(b), null;
        case 13:
            return $756644e23111daff$var$pj(a, b, c);
        case 4:
            return $756644e23111daff$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $756644e23111daff$var$Bh(b, null, d, c) : $756644e23111daff$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $756644e23111daff$var$Lg(d, e), $756644e23111daff$var$Zi(a, b, d, e, c);
        case 7:
            return $756644e23111daff$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $756644e23111daff$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $756644e23111daff$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $756644e23111daff$var$G($756644e23111daff$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($756644e23111daff$var$He(f.value, g)) {
                        if (f.children === e.children && !$756644e23111daff$var$Wf.current) {
                            b = $756644e23111daff$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $756644e23111daff$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $756644e23111daff$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($756644e23111daff$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $756644e23111daff$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $756644e23111daff$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $756644e23111daff$var$Tg(b, c), e = $756644e23111daff$var$Vg(e), d = d(e), b.flags |= 1, $756644e23111daff$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $756644e23111daff$var$Lg(d, b.pendingProps), e = $756644e23111daff$var$Lg(d.type, e), $756644e23111daff$var$aj(a, b, d, e, c);
        case 15:
            return $756644e23111daff$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $756644e23111daff$var$Lg(d, e), $756644e23111daff$var$jj(a, b), b.tag = 1, $756644e23111daff$var$Zf(d) ? (a = !0, $756644e23111daff$var$cg(b)) : a = !1, $756644e23111daff$var$Tg(b, c), $756644e23111daff$var$ph(b, d, e), $756644e23111daff$var$rh(b, d, e, c), $756644e23111daff$var$kj(null, b, d, !0, a, c);
        case 19:
            return $756644e23111daff$var$yj(a, b, c);
        case 22:
            return $756644e23111daff$var$ej(a, b, c);
    }
    throw Error($756644e23111daff$var$p(156, b.tag));
};
function $756644e23111daff$var$Gk(a, b) {
    return $756644e23111daff$var$ac(a, b);
}
function $756644e23111daff$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $756644e23111daff$var$Bg(a, b, c, d) {
    return new $756644e23111daff$var$al(a, b, c, d);
}
function $756644e23111daff$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $756644e23111daff$var$$k(a) {
    if ("function" === typeof a) return $756644e23111daff$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $756644e23111daff$var$Da) return 11;
        if (a === $756644e23111daff$var$Ga) return 14;
    }
    return 2;
}
function $756644e23111daff$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $756644e23111daff$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $756644e23111daff$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $756644e23111daff$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $756644e23111daff$var$ya:
            return $756644e23111daff$var$Ah(c.children, e, f, b);
        case $756644e23111daff$var$za:
            g = 8;
            e |= 8;
            break;
        case $756644e23111daff$var$Aa:
            return a = $756644e23111daff$var$Bg(12, c, b, e | 2), a.elementType = $756644e23111daff$var$Aa, a.lanes = f, a;
        case $756644e23111daff$var$Ea:
            return a = $756644e23111daff$var$Bg(13, c, b, e), a.elementType = $756644e23111daff$var$Ea, a.lanes = f, a;
        case $756644e23111daff$var$Fa:
            return a = $756644e23111daff$var$Bg(19, c, b, e), a.elementType = $756644e23111daff$var$Fa, a.lanes = f, a;
        case $756644e23111daff$var$Ia:
            return $756644e23111daff$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $756644e23111daff$var$Ba:
                    g = 10;
                    break a;
                case $756644e23111daff$var$Ca:
                    g = 9;
                    break a;
                case $756644e23111daff$var$Da:
                    g = 11;
                    break a;
                case $756644e23111daff$var$Ga:
                    g = 14;
                    break a;
                case $756644e23111daff$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($756644e23111daff$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $756644e23111daff$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $756644e23111daff$var$Ah(a, b, c, d) {
    a = $756644e23111daff$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $756644e23111daff$var$qj(a, b, c, d) {
    a = $756644e23111daff$var$Bg(22, a, d, b);
    a.elementType = $756644e23111daff$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $756644e23111daff$var$xh(a, b, c) {
    a = $756644e23111daff$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $756644e23111daff$var$zh(a, b, c) {
    b = $756644e23111daff$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $756644e23111daff$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $756644e23111daff$var$zc(0);
    this.expirationTimes = $756644e23111daff$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $756644e23111daff$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $756644e23111daff$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $756644e23111daff$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $756644e23111daff$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $756644e23111daff$var$ah(f);
    return a;
}
function $756644e23111daff$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $756644e23111daff$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $756644e23111daff$var$el(a) {
    if (!a) return $756644e23111daff$var$Vf;
    a = a._reactInternals;
    a: {
        if ($756644e23111daff$var$Vb(a) !== a || 1 !== a.tag) throw Error($756644e23111daff$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($756644e23111daff$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($756644e23111daff$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($756644e23111daff$var$Zf(c)) return $756644e23111daff$var$bg(a, c, b);
    }
    return b;
}
function $756644e23111daff$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $756644e23111daff$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $756644e23111daff$var$el(null);
    c = a.current;
    d = $756644e23111daff$var$L();
    e = $756644e23111daff$var$lh(c);
    f = $756644e23111daff$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $756644e23111daff$var$dh(c, f, e);
    a.current.lanes = e;
    $756644e23111daff$var$Ac(a, e, d);
    $756644e23111daff$var$Ek(a, d);
    return a;
}
function $756644e23111daff$var$gl(a, b, c, d) {
    var e = b.current, f = $756644e23111daff$var$L(), g = $756644e23111daff$var$lh(e);
    c = $756644e23111daff$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $756644e23111daff$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $756644e23111daff$var$dh(e, b, g);
    null !== a && ($756644e23111daff$var$mh(a, e, g, f), $756644e23111daff$var$eh(a, e, g));
    return g;
}
function $756644e23111daff$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $756644e23111daff$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $756644e23111daff$var$jl(a, b) {
    $756644e23111daff$var$il(a, b);
    (a = a.alternate) && $756644e23111daff$var$il(a, b);
}
function $756644e23111daff$var$kl() {
    return null;
}
var $756644e23111daff$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $756644e23111daff$var$ml(a) {
    this._internalRoot = a;
}
$756644e23111daff$var$nl.prototype.render = $756644e23111daff$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($756644e23111daff$var$p(409));
    $756644e23111daff$var$gl(a, b, null, null);
};
$756644e23111daff$var$nl.prototype.unmount = $756644e23111daff$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $756644e23111daff$var$Sk(function() {
            $756644e23111daff$var$gl(null, a, null, null);
        });
        b[$756644e23111daff$var$uf] = null;
    }
};
function $756644e23111daff$var$nl(a) {
    this._internalRoot = a;
}
$756644e23111daff$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $756644e23111daff$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $756644e23111daff$var$Qc.length && 0 !== b && b < $756644e23111daff$var$Qc[c].priority; c++);
        $756644e23111daff$var$Qc.splice(c, 0, a);
        0 === c && $756644e23111daff$var$Vc(a);
    }
};
function $756644e23111daff$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $756644e23111daff$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $756644e23111daff$var$ql() {}
function $756644e23111daff$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $756644e23111daff$var$hl(g);
                f.call(a);
            };
        }
        var g = $756644e23111daff$var$fl(b, d, a, 0, null, !1, !1, "", $756644e23111daff$var$ql);
        a._reactRootContainer = g;
        a[$756644e23111daff$var$uf] = g.current;
        $756644e23111daff$var$sf(8 === a.nodeType ? a.parentNode : a);
        $756644e23111daff$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $756644e23111daff$var$hl(k);
            h.call(a);
        };
    }
    var k = $756644e23111daff$var$cl(a, 0, !1, null, null, !1, !1, "", $756644e23111daff$var$ql);
    a._reactRootContainer = k;
    a[$756644e23111daff$var$uf] = k.current;
    $756644e23111daff$var$sf(8 === a.nodeType ? a.parentNode : a);
    $756644e23111daff$var$Sk(function() {
        $756644e23111daff$var$gl(b, k, c, d);
    });
    return k;
}
function $756644e23111daff$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $756644e23111daff$var$hl(g);
                h.call(a);
            };
        }
        $756644e23111daff$var$gl(b, g, a, e);
    } else g = $756644e23111daff$var$rl(c, b, a, e, d);
    return $756644e23111daff$var$hl(g);
}
$756644e23111daff$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $756644e23111daff$var$tc(b.pendingLanes);
                0 !== c && ($756644e23111daff$var$Cc(b, c | 1), $756644e23111daff$var$Ek(b, $756644e23111daff$var$B()), 0 === ($756644e23111daff$var$K & 6) && ($756644e23111daff$var$Hj = $756644e23111daff$var$B() + 500, $756644e23111daff$var$jg()));
            }
            break;
        case 13:
            $756644e23111daff$var$Sk(function() {
                var b = $756644e23111daff$var$Zg(a, 1);
                if (null !== b) {
                    var c = $756644e23111daff$var$L();
                    $756644e23111daff$var$mh(b, a, 1, c);
                }
            }), $756644e23111daff$var$jl(a, 1);
    }
};
$756644e23111daff$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $756644e23111daff$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $756644e23111daff$var$L();
            $756644e23111daff$var$mh(b, a, 134217728, c);
        }
        $756644e23111daff$var$jl(a, 134217728);
    }
};
$756644e23111daff$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $756644e23111daff$var$lh(a), c = $756644e23111daff$var$Zg(a, b);
        if (null !== c) {
            var d = $756644e23111daff$var$L();
            $756644e23111daff$var$mh(c, a, b, d);
        }
        $756644e23111daff$var$jl(a, b);
    }
};
$756644e23111daff$var$Hc = function() {
    return $756644e23111daff$var$C;
};
$756644e23111daff$var$Ic = function(a, b) {
    var c = $756644e23111daff$var$C;
    try {
        return $756644e23111daff$var$C = a, b();
    } finally{
        $756644e23111daff$var$C = c;
    }
};
$756644e23111daff$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $756644e23111daff$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $756644e23111daff$var$Db(d);
                        if (!e) throw Error($756644e23111daff$var$p(90));
                        $756644e23111daff$var$Wa(d);
                        $756644e23111daff$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $756644e23111daff$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $756644e23111daff$var$fb(a, !!c.multiple, b, !1);
    }
};
$756644e23111daff$var$Gb = $756644e23111daff$var$Rk;
$756644e23111daff$var$Hb = $756644e23111daff$var$Sk;
var $756644e23111daff$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $756644e23111daff$var$Cb,
        $756644e23111daff$var$ue,
        $756644e23111daff$var$Db,
        $756644e23111daff$var$Eb,
        $756644e23111daff$var$Fb,
        $756644e23111daff$var$Rk
    ]
}, $756644e23111daff$var$ul = {
    findFiberByHostInstance: $756644e23111daff$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $756644e23111daff$var$vl = {
    bundleType: $756644e23111daff$var$ul.bundleType,
    version: $756644e23111daff$var$ul.version,
    rendererPackageName: $756644e23111daff$var$ul.rendererPackageName,
    rendererConfig: $756644e23111daff$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $756644e23111daff$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $756644e23111daff$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $756644e23111daff$var$ul.findFiberByHostInstance || $756644e23111daff$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $756644e23111daff$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$756644e23111daff$var$wl.isDisabled && $756644e23111daff$var$wl.supportsFiber) try {
        $756644e23111daff$var$kc = $756644e23111daff$var$wl.inject($756644e23111daff$var$vl), $756644e23111daff$var$lc = $756644e23111daff$var$wl;
    } catch (a) {}
}
$756644e23111daff$export$ae55be85d98224ed = $756644e23111daff$var$tl;
$756644e23111daff$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$756644e23111daff$var$ol(b)) throw Error($756644e23111daff$var$p(200));
    return $756644e23111daff$var$dl(a, b, null, c);
};
$756644e23111daff$export$882461b6382ed46c = function(a, b) {
    if (!$756644e23111daff$var$ol(a)) throw Error($756644e23111daff$var$p(299));
    var c = !1, d = "", e = $756644e23111daff$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $756644e23111daff$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$756644e23111daff$var$uf] = b.current;
    $756644e23111daff$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $756644e23111daff$var$ml(b);
};
$756644e23111daff$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($756644e23111daff$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($756644e23111daff$var$p(268, a));
    }
    a = $756644e23111daff$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$756644e23111daff$export$cd75ccfd720a3cd4 = function(a) {
    return $756644e23111daff$var$Sk(a);
};
$756644e23111daff$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$756644e23111daff$var$pl(b)) throw Error($756644e23111daff$var$p(200));
    return $756644e23111daff$var$sl(null, a, b, !0, c);
};
$756644e23111daff$export$757ceba2d55c277e = function(a, b, c) {
    if (!$756644e23111daff$var$ol(a)) throw Error($756644e23111daff$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $756644e23111daff$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $756644e23111daff$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$756644e23111daff$var$uf] = b.current;
    $756644e23111daff$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $756644e23111daff$var$nl(b);
};
$756644e23111daff$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$756644e23111daff$var$pl(b)) throw Error($756644e23111daff$var$p(200));
    return $756644e23111daff$var$sl(null, a, b, !1, c);
};
$756644e23111daff$export$502457920280e6be = function(a) {
    if (!$756644e23111daff$var$pl(a)) throw Error($756644e23111daff$var$p(40));
    return a._reactRootContainer ? ($756644e23111daff$var$Sk(function() {
        $756644e23111daff$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$756644e23111daff$var$uf] = null;
        });
    }), !0) : !1;
};
$756644e23111daff$export$c78a37762a8d58e1 = $756644e23111daff$var$Rk;
$756644e23111daff$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$756644e23111daff$var$pl(c)) throw Error($756644e23111daff$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($756644e23111daff$var$p(38));
    return $756644e23111daff$var$sl(a, b, c, !1, d);
};
$756644e23111daff$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("azdYD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kWMpb"));

});
parcelRequire.register("kWMpb", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $f3fec5b00403820f$export$c4744153514ff05d, (v) => $f3fec5b00403820f$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $f3fec5b00403820f$export$3e506c1ccc9cc1a7, (v) => $f3fec5b00403820f$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $f3fec5b00403820f$export$e26fe2ed2fa76875, (v) => $f3fec5b00403820f$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $f3fec5b00403820f$export$502329bbf4b505b1, (v) => $f3fec5b00403820f$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $f3fec5b00403820f$export$6e3807111c4874c4, (v) => $f3fec5b00403820f$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $f3fec5b00403820f$export$c27134553091fb3a, (v) => $f3fec5b00403820f$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $f3fec5b00403820f$export$33ee1acdc04fd2a2, (v) => $f3fec5b00403820f$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $f3fec5b00403820f$export$b00a404bbd5edef2, (v) => $f3fec5b00403820f$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $f3fec5b00403820f$export$8352ce38b91d0c62, (v) => $f3fec5b00403820f$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $f3fec5b00403820f$export$d66a1c1c77bd778b, (v) => $f3fec5b00403820f$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $f3fec5b00403820f$export$d3dfb8e4810cb555, (v) => $f3fec5b00403820f$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $f3fec5b00403820f$export$839f9183b0465a69, (v) => $f3fec5b00403820f$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $f3fec5b00403820f$export$72fdf0e06517287b, (v) => $f3fec5b00403820f$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $f3fec5b00403820f$export$4b844e58a3e414b4, (v) => $f3fec5b00403820f$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $f3fec5b00403820f$export$816d2913ae6b83b1, (v) => $f3fec5b00403820f$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $f3fec5b00403820f$export$61bcfe829111a1d0, (v) => $f3fec5b00403820f$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $f3fec5b00403820f$export$7ee8c9beb337bc3f, (v) => $f3fec5b00403820f$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $f3fec5b00403820f$export$b5836b71941fa3ed, (v) => $f3fec5b00403820f$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $f3fec5b00403820f$export$cf845f2c119da08a, (v) => $f3fec5b00403820f$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f3fec5b00403820f$export$c4744153514ff05d;
var $f3fec5b00403820f$export$3e506c1ccc9cc1a7;
var $f3fec5b00403820f$export$e26fe2ed2fa76875;
var $f3fec5b00403820f$export$502329bbf4b505b1;
var $f3fec5b00403820f$export$6e3807111c4874c4;
var $f3fec5b00403820f$export$c27134553091fb3a;
var $f3fec5b00403820f$export$33ee1acdc04fd2a2;
var $f3fec5b00403820f$export$b00a404bbd5edef2;
var $f3fec5b00403820f$export$8352ce38b91d0c62;
var $f3fec5b00403820f$export$d66a1c1c77bd778b;
var $f3fec5b00403820f$export$d3dfb8e4810cb555;
var $f3fec5b00403820f$export$839f9183b0465a69;
var $f3fec5b00403820f$export$72fdf0e06517287b;
var $f3fec5b00403820f$export$4b844e58a3e414b4;
var $f3fec5b00403820f$export$816d2913ae6b83b1;
var $f3fec5b00403820f$export$61bcfe829111a1d0;
var $f3fec5b00403820f$export$7ee8c9beb337bc3f;
var $f3fec5b00403820f$export$b5836b71941fa3ed;
var $f3fec5b00403820f$export$cf845f2c119da08a;
"use strict";
function $f3fec5b00403820f$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f3fec5b00403820f$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f3fec5b00403820f$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f3fec5b00403820f$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f3fec5b00403820f$var$g(C, c)) n < e && 0 > $f3fec5b00403820f$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f3fec5b00403820f$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f3fec5b00403820f$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f3fec5b00403820f$var$l = performance;
    $f3fec5b00403820f$export$c4744153514ff05d = function() {
        return $f3fec5b00403820f$var$l.now();
    };
} else {
    var $f3fec5b00403820f$var$p = Date, $f3fec5b00403820f$var$q = $f3fec5b00403820f$var$p.now();
    $f3fec5b00403820f$export$c4744153514ff05d = function() {
        return $f3fec5b00403820f$var$p.now() - $f3fec5b00403820f$var$q;
    };
}
var $f3fec5b00403820f$var$r = [], $f3fec5b00403820f$var$t = [], $f3fec5b00403820f$var$u = 1, $f3fec5b00403820f$var$v = null, $f3fec5b00403820f$var$y = 3, $f3fec5b00403820f$var$z = !1, $f3fec5b00403820f$var$A = !1, $f3fec5b00403820f$var$B = !1, $f3fec5b00403820f$var$D = "function" === typeof setTimeout ? setTimeout : null, $f3fec5b00403820f$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f3fec5b00403820f$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f3fec5b00403820f$var$G(a) {
    for(var b = $f3fec5b00403820f$var$h($f3fec5b00403820f$var$t); null !== b;){
        if (null === b.callback) $f3fec5b00403820f$var$k($f3fec5b00403820f$var$t);
        else if (b.startTime <= a) $f3fec5b00403820f$var$k($f3fec5b00403820f$var$t), b.sortIndex = b.expirationTime, $f3fec5b00403820f$var$f($f3fec5b00403820f$var$r, b);
        else break;
        b = $f3fec5b00403820f$var$h($f3fec5b00403820f$var$t);
    }
}
function $f3fec5b00403820f$var$H(a) {
    $f3fec5b00403820f$var$B = !1;
    $f3fec5b00403820f$var$G(a);
    if (!$f3fec5b00403820f$var$A) {
        if (null !== $f3fec5b00403820f$var$h($f3fec5b00403820f$var$r)) $f3fec5b00403820f$var$A = !0, $f3fec5b00403820f$var$I($f3fec5b00403820f$var$J);
        else {
            var b = $f3fec5b00403820f$var$h($f3fec5b00403820f$var$t);
            null !== b && $f3fec5b00403820f$var$K($f3fec5b00403820f$var$H, b.startTime - a);
        }
    }
}
function $f3fec5b00403820f$var$J(a, b) {
    $f3fec5b00403820f$var$A = !1;
    $f3fec5b00403820f$var$B && ($f3fec5b00403820f$var$B = !1, $f3fec5b00403820f$var$E($f3fec5b00403820f$var$L), $f3fec5b00403820f$var$L = -1);
    $f3fec5b00403820f$var$z = !0;
    var c = $f3fec5b00403820f$var$y;
    try {
        $f3fec5b00403820f$var$G(b);
        for($f3fec5b00403820f$var$v = $f3fec5b00403820f$var$h($f3fec5b00403820f$var$r); null !== $f3fec5b00403820f$var$v && (!($f3fec5b00403820f$var$v.expirationTime > b) || a && !$f3fec5b00403820f$var$M());){
            var d = $f3fec5b00403820f$var$v.callback;
            if ("function" === typeof d) {
                $f3fec5b00403820f$var$v.callback = null;
                $f3fec5b00403820f$var$y = $f3fec5b00403820f$var$v.priorityLevel;
                var e = d($f3fec5b00403820f$var$v.expirationTime <= b);
                b = $f3fec5b00403820f$export$c4744153514ff05d();
                "function" === typeof e ? $f3fec5b00403820f$var$v.callback = e : $f3fec5b00403820f$var$v === $f3fec5b00403820f$var$h($f3fec5b00403820f$var$r) && $f3fec5b00403820f$var$k($f3fec5b00403820f$var$r);
                $f3fec5b00403820f$var$G(b);
            } else $f3fec5b00403820f$var$k($f3fec5b00403820f$var$r);
            $f3fec5b00403820f$var$v = $f3fec5b00403820f$var$h($f3fec5b00403820f$var$r);
        }
        if (null !== $f3fec5b00403820f$var$v) var w = !0;
        else {
            var m = $f3fec5b00403820f$var$h($f3fec5b00403820f$var$t);
            null !== m && $f3fec5b00403820f$var$K($f3fec5b00403820f$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f3fec5b00403820f$var$v = null, $f3fec5b00403820f$var$y = c, $f3fec5b00403820f$var$z = !1;
    }
}
var $f3fec5b00403820f$var$N = !1, $f3fec5b00403820f$var$O = null, $f3fec5b00403820f$var$L = -1, $f3fec5b00403820f$var$P = 5, $f3fec5b00403820f$var$Q = -1;
function $f3fec5b00403820f$var$M() {
    return $f3fec5b00403820f$export$c4744153514ff05d() - $f3fec5b00403820f$var$Q < $f3fec5b00403820f$var$P ? !1 : !0;
}
function $f3fec5b00403820f$var$R() {
    if (null !== $f3fec5b00403820f$var$O) {
        var a = $f3fec5b00403820f$export$c4744153514ff05d();
        $f3fec5b00403820f$var$Q = a;
        var b = !0;
        try {
            b = $f3fec5b00403820f$var$O(!0, a);
        } finally{
            b ? $f3fec5b00403820f$var$S() : ($f3fec5b00403820f$var$N = !1, $f3fec5b00403820f$var$O = null);
        }
    } else $f3fec5b00403820f$var$N = !1;
}
var $f3fec5b00403820f$var$S;
if ("function" === typeof $f3fec5b00403820f$var$F) $f3fec5b00403820f$var$S = function() {
    $f3fec5b00403820f$var$F($f3fec5b00403820f$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f3fec5b00403820f$var$T = new MessageChannel, $f3fec5b00403820f$var$U = $f3fec5b00403820f$var$T.port2;
    $f3fec5b00403820f$var$T.port1.onmessage = $f3fec5b00403820f$var$R;
    $f3fec5b00403820f$var$S = function() {
        $f3fec5b00403820f$var$U.postMessage(null);
    };
} else $f3fec5b00403820f$var$S = function() {
    $f3fec5b00403820f$var$D($f3fec5b00403820f$var$R, 0);
};
function $f3fec5b00403820f$var$I(a) {
    $f3fec5b00403820f$var$O = a;
    $f3fec5b00403820f$var$N || ($f3fec5b00403820f$var$N = !0, $f3fec5b00403820f$var$S());
}
function $f3fec5b00403820f$var$K(a, b) {
    $f3fec5b00403820f$var$L = $f3fec5b00403820f$var$D(function() {
        a($f3fec5b00403820f$export$c4744153514ff05d());
    }, b);
}
$f3fec5b00403820f$export$3e506c1ccc9cc1a7 = 5;
$f3fec5b00403820f$export$e26fe2ed2fa76875 = 1;
$f3fec5b00403820f$export$502329bbf4b505b1 = 4;
$f3fec5b00403820f$export$6e3807111c4874c4 = 3;
$f3fec5b00403820f$export$c27134553091fb3a = null;
$f3fec5b00403820f$export$33ee1acdc04fd2a2 = 2;
$f3fec5b00403820f$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f3fec5b00403820f$export$8352ce38b91d0c62 = function() {
    $f3fec5b00403820f$var$A || $f3fec5b00403820f$var$z || ($f3fec5b00403820f$var$A = !0, $f3fec5b00403820f$var$I($f3fec5b00403820f$var$J));
};
$f3fec5b00403820f$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f3fec5b00403820f$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f3fec5b00403820f$export$d3dfb8e4810cb555 = function() {
    return $f3fec5b00403820f$var$y;
};
$f3fec5b00403820f$export$839f9183b0465a69 = function() {
    return $f3fec5b00403820f$var$h($f3fec5b00403820f$var$r);
};
$f3fec5b00403820f$export$72fdf0e06517287b = function(a) {
    switch($f3fec5b00403820f$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f3fec5b00403820f$var$y;
    }
    var c = $f3fec5b00403820f$var$y;
    $f3fec5b00403820f$var$y = b;
    try {
        return a();
    } finally{
        $f3fec5b00403820f$var$y = c;
    }
};
$f3fec5b00403820f$export$4b844e58a3e414b4 = function() {};
$f3fec5b00403820f$export$816d2913ae6b83b1 = function() {};
$f3fec5b00403820f$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f3fec5b00403820f$var$y;
    $f3fec5b00403820f$var$y = a;
    try {
        return b();
    } finally{
        $f3fec5b00403820f$var$y = c;
    }
};
$f3fec5b00403820f$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f3fec5b00403820f$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f3fec5b00403820f$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f3fec5b00403820f$var$f($f3fec5b00403820f$var$t, a), null === $f3fec5b00403820f$var$h($f3fec5b00403820f$var$r) && a === $f3fec5b00403820f$var$h($f3fec5b00403820f$var$t) && ($f3fec5b00403820f$var$B ? ($f3fec5b00403820f$var$E($f3fec5b00403820f$var$L), $f3fec5b00403820f$var$L = -1) : $f3fec5b00403820f$var$B = !0, $f3fec5b00403820f$var$K($f3fec5b00403820f$var$H, c - d))) : (a.sortIndex = e, $f3fec5b00403820f$var$f($f3fec5b00403820f$var$r, a), $f3fec5b00403820f$var$A || $f3fec5b00403820f$var$z || ($f3fec5b00403820f$var$A = !0, $f3fec5b00403820f$var$I($f3fec5b00403820f$var$J)));
    return a;
};
$f3fec5b00403820f$export$b5836b71941fa3ed = $f3fec5b00403820f$var$M;
$f3fec5b00403820f$export$cf845f2c119da08a = function(a) {
    var b = $f3fec5b00403820f$var$y;
    return function() {
        var c = $f3fec5b00403820f$var$y;
        $f3fec5b00403820f$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f3fec5b00403820f$var$y = c;
        }
    };
};

});



parcelRequire.register("fb4ur", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $b0cb5db95e233016$export$a7c73072b1a182ae, (v) => $b0cb5db95e233016$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $b0cb5db95e233016$export$9f27bc3417b4524d, (v) => $b0cb5db95e233016$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $b0cb5db95e233016$export$db77ccec0bb4ccac, (v) => $b0cb5db95e233016$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $b0cb5db95e233016$export$8392c0c9d3dcbd35, (v) => $b0cb5db95e233016$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $b0cb5db95e233016$export$ffb0004e005737fa, (v) => $b0cb5db95e233016$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $b0cb5db95e233016$export$b624eff549462981, (v) => $b0cb5db95e233016$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $b0cb5db95e233016$export$7897aa7841a5380c, (v) => $b0cb5db95e233016$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $b0cb5db95e233016$export$602eac185826482c, (v) => $b0cb5db95e233016$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $b0cb5db95e233016$export$e2c29f18771995cb, (v) => $b0cb5db95e233016$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $b0cb5db95e233016$export$5f8d39834fd61797, (v) => $b0cb5db95e233016$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $b0cb5db95e233016$export$74bf444e3cd11ea5, (v) => $b0cb5db95e233016$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $b0cb5db95e233016$export$998bcd577473dd93, (v) => $b0cb5db95e233016$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $b0cb5db95e233016$export$92387174baf9b227, (v) => $b0cb5db95e233016$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $b0cb5db95e233016$export$ec112efeb987d9c6, (v) => $b0cb5db95e233016$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $b0cb5db95e233016$export$b706b080d889d2c9, (v) => $b0cb5db95e233016$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $b0cb5db95e233016$export$5be5a87408f70ddc, (v) => $b0cb5db95e233016$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $b0cb5db95e233016$export$45a5e7f76e0caa8d, (v) => $b0cb5db95e233016$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $b0cb5db95e233016$export$455c2e768291efa6, (v) => $b0cb5db95e233016$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $b0cb5db95e233016$export$9522e17588c12572, (v) => $b0cb5db95e233016$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $b0cb5db95e233016$export$2110ac352bb060b9, (v) => $b0cb5db95e233016$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $b0cb5db95e233016$export$56885ab8b9c456ab, (v) => $b0cb5db95e233016$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $b0cb5db95e233016$export$d927fcb6adf8f9de, (v) => $b0cb5db95e233016$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $b0cb5db95e233016$export$b82d16f27459e05a, (v) => $b0cb5db95e233016$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $b0cb5db95e233016$export$522c17b4f5e123e8, (v) => $b0cb5db95e233016$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $b0cb5db95e233016$export$1aabd8a0274ecfd6, (v) => $b0cb5db95e233016$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $b0cb5db95e233016$export$3d6c20d97e46b957, (v) => $b0cb5db95e233016$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $b0cb5db95e233016$export$9b621391a187a31a, (v) => $b0cb5db95e233016$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $b0cb5db95e233016$export$f5bbd400c2f4426f, (v) => $b0cb5db95e233016$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b0cb5db95e233016$export$a7c73072b1a182ae;
var $b0cb5db95e233016$export$9f27bc3417b4524d;
var $b0cb5db95e233016$export$db77ccec0bb4ccac;
var $b0cb5db95e233016$export$8392c0c9d3dcbd35;
var $b0cb5db95e233016$export$ffb0004e005737fa;
var $b0cb5db95e233016$export$b624eff549462981;
var $b0cb5db95e233016$export$7897aa7841a5380c;
var $b0cb5db95e233016$export$602eac185826482c;
var $b0cb5db95e233016$export$e2c29f18771995cb;
var $b0cb5db95e233016$export$5f8d39834fd61797;
var $b0cb5db95e233016$export$74bf444e3cd11ea5;
var $b0cb5db95e233016$export$998bcd577473dd93;
var $b0cb5db95e233016$export$92387174baf9b227;
var $b0cb5db95e233016$export$ec112efeb987d9c6;
var $b0cb5db95e233016$export$b706b080d889d2c9;
var $b0cb5db95e233016$export$5be5a87408f70ddc;
var $b0cb5db95e233016$export$45a5e7f76e0caa8d;
var $b0cb5db95e233016$export$455c2e768291efa6;
var $b0cb5db95e233016$export$9522e17588c12572;
var $b0cb5db95e233016$export$2110ac352bb060b9;
var $b0cb5db95e233016$export$56885ab8b9c456ab;
var $b0cb5db95e233016$export$d927fcb6adf8f9de;
var $b0cb5db95e233016$export$b82d16f27459e05a;
var $b0cb5db95e233016$export$522c17b4f5e123e8;
var $b0cb5db95e233016$export$1aabd8a0274ecfd6;
var $b0cb5db95e233016$export$3d6c20d97e46b957;
var $b0cb5db95e233016$export$9b621391a187a31a;
var $b0cb5db95e233016$export$f5bbd400c2f4426f;
"use strict";
var $b0cb5db95e233016$var$b = Symbol.for("react.element"), $b0cb5db95e233016$var$c = Symbol.for("react.portal"), $b0cb5db95e233016$var$d = Symbol.for("react.fragment"), $b0cb5db95e233016$var$e = Symbol.for("react.strict_mode"), $b0cb5db95e233016$var$f = Symbol.for("react.profiler"), $b0cb5db95e233016$var$g = Symbol.for("react.provider"), $b0cb5db95e233016$var$h = Symbol.for("react.context"), $b0cb5db95e233016$var$k = Symbol.for("react.server_context"), $b0cb5db95e233016$var$l = Symbol.for("react.forward_ref"), $b0cb5db95e233016$var$m = Symbol.for("react.suspense"), $b0cb5db95e233016$var$n = Symbol.for("react.suspense_list"), $b0cb5db95e233016$var$p = Symbol.for("react.memo"), $b0cb5db95e233016$var$q = Symbol.for("react.lazy"), $b0cb5db95e233016$var$t = Symbol.for("react.offscreen"), $b0cb5db95e233016$var$u;
$b0cb5db95e233016$var$u = Symbol.for("react.module.reference");
function $b0cb5db95e233016$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $b0cb5db95e233016$var$b:
                switch(a = a.type, a){
                    case $b0cb5db95e233016$var$d:
                    case $b0cb5db95e233016$var$f:
                    case $b0cb5db95e233016$var$e:
                    case $b0cb5db95e233016$var$m:
                    case $b0cb5db95e233016$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $b0cb5db95e233016$var$k:
                            case $b0cb5db95e233016$var$h:
                            case $b0cb5db95e233016$var$l:
                            case $b0cb5db95e233016$var$q:
                            case $b0cb5db95e233016$var$p:
                            case $b0cb5db95e233016$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $b0cb5db95e233016$var$c:
                return r;
        }
    }
}
$b0cb5db95e233016$export$a7c73072b1a182ae = $b0cb5db95e233016$var$h;
$b0cb5db95e233016$export$9f27bc3417b4524d = $b0cb5db95e233016$var$g;
$b0cb5db95e233016$export$db77ccec0bb4ccac = $b0cb5db95e233016$var$b;
$b0cb5db95e233016$export$8392c0c9d3dcbd35 = $b0cb5db95e233016$var$l;
$b0cb5db95e233016$export$ffb0004e005737fa = $b0cb5db95e233016$var$d;
$b0cb5db95e233016$export$b624eff549462981 = $b0cb5db95e233016$var$q;
$b0cb5db95e233016$export$7897aa7841a5380c = $b0cb5db95e233016$var$p;
$b0cb5db95e233016$export$602eac185826482c = $b0cb5db95e233016$var$c;
$b0cb5db95e233016$export$e2c29f18771995cb = $b0cb5db95e233016$var$f;
$b0cb5db95e233016$export$5f8d39834fd61797 = $b0cb5db95e233016$var$e;
$b0cb5db95e233016$export$74bf444e3cd11ea5 = $b0cb5db95e233016$var$m;
$b0cb5db95e233016$export$998bcd577473dd93 = $b0cb5db95e233016$var$n;
$b0cb5db95e233016$export$92387174baf9b227 = function() {
    return !1;
};
$b0cb5db95e233016$export$ec112efeb987d9c6 = function() {
    return !1;
};
$b0cb5db95e233016$export$b706b080d889d2c9 = function(a) {
    return $b0cb5db95e233016$var$v(a) === $b0cb5db95e233016$var$h;
};
$b0cb5db95e233016$export$5be5a87408f70ddc = function(a) {
    return $b0cb5db95e233016$var$v(a) === $b0cb5db95e233016$var$g;
};
$b0cb5db95e233016$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b0cb5db95e233016$var$b;
};
$b0cb5db95e233016$export$455c2e768291efa6 = function(a) {
    return $b0cb5db95e233016$var$v(a) === $b0cb5db95e233016$var$l;
};
$b0cb5db95e233016$export$9522e17588c12572 = function(a) {
    return $b0cb5db95e233016$var$v(a) === $b0cb5db95e233016$var$d;
};
$b0cb5db95e233016$export$2110ac352bb060b9 = function(a) {
    return $b0cb5db95e233016$var$v(a) === $b0cb5db95e233016$var$q;
};
$b0cb5db95e233016$export$56885ab8b9c456ab = function(a) {
    return $b0cb5db95e233016$var$v(a) === $b0cb5db95e233016$var$p;
};
$b0cb5db95e233016$export$d927fcb6adf8f9de = function(a) {
    return $b0cb5db95e233016$var$v(a) === $b0cb5db95e233016$var$c;
};
$b0cb5db95e233016$export$b82d16f27459e05a = function(a) {
    return $b0cb5db95e233016$var$v(a) === $b0cb5db95e233016$var$f;
};
$b0cb5db95e233016$export$522c17b4f5e123e8 = function(a) {
    return $b0cb5db95e233016$var$v(a) === $b0cb5db95e233016$var$e;
};
$b0cb5db95e233016$export$1aabd8a0274ecfd6 = function(a) {
    return $b0cb5db95e233016$var$v(a) === $b0cb5db95e233016$var$m;
};
$b0cb5db95e233016$export$3d6c20d97e46b957 = function(a) {
    return $b0cb5db95e233016$var$v(a) === $b0cb5db95e233016$var$n;
};
$b0cb5db95e233016$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $b0cb5db95e233016$var$d || a === $b0cb5db95e233016$var$f || a === $b0cb5db95e233016$var$e || a === $b0cb5db95e233016$var$m || a === $b0cb5db95e233016$var$n || a === $b0cb5db95e233016$var$t || "object" === typeof a && null !== a && (a.$$typeof === $b0cb5db95e233016$var$q || a.$$typeof === $b0cb5db95e233016$var$p || a.$$typeof === $b0cb5db95e233016$var$g || a.$$typeof === $b0cb5db95e233016$var$h || a.$$typeof === $b0cb5db95e233016$var$l || a.$$typeof === $b0cb5db95e233016$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$b0cb5db95e233016$export$f5bbd400c2f4426f = $b0cb5db95e233016$var$v;

});

parcelRequire.register("asr8F", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $79d19215c0446b57$export$2b8d127b894957b9, (v) => $79d19215c0446b57$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $79d19215c0446b57$export$cea3a54a6425200c, (v) => $79d19215c0446b57$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $79d19215c0446b57$export$a7c73072b1a182ae, (v) => $79d19215c0446b57$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $79d19215c0446b57$export$9f27bc3417b4524d, (v) => $79d19215c0446b57$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $79d19215c0446b57$export$db77ccec0bb4ccac, (v) => $79d19215c0446b57$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $79d19215c0446b57$export$8392c0c9d3dcbd35, (v) => $79d19215c0446b57$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $79d19215c0446b57$export$ffb0004e005737fa, (v) => $79d19215c0446b57$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $79d19215c0446b57$export$b624eff549462981, (v) => $79d19215c0446b57$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $79d19215c0446b57$export$7897aa7841a5380c, (v) => $79d19215c0446b57$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $79d19215c0446b57$export$602eac185826482c, (v) => $79d19215c0446b57$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $79d19215c0446b57$export$e2c29f18771995cb, (v) => $79d19215c0446b57$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $79d19215c0446b57$export$5f8d39834fd61797, (v) => $79d19215c0446b57$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $79d19215c0446b57$export$74bf444e3cd11ea5, (v) => $79d19215c0446b57$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $79d19215c0446b57$export$92387174baf9b227, (v) => $79d19215c0446b57$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $79d19215c0446b57$export$ec112efeb987d9c6, (v) => $79d19215c0446b57$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $79d19215c0446b57$export$b706b080d889d2c9, (v) => $79d19215c0446b57$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $79d19215c0446b57$export$5be5a87408f70ddc, (v) => $79d19215c0446b57$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $79d19215c0446b57$export$45a5e7f76e0caa8d, (v) => $79d19215c0446b57$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $79d19215c0446b57$export$455c2e768291efa6, (v) => $79d19215c0446b57$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $79d19215c0446b57$export$9522e17588c12572, (v) => $79d19215c0446b57$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $79d19215c0446b57$export$2110ac352bb060b9, (v) => $79d19215c0446b57$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $79d19215c0446b57$export$56885ab8b9c456ab, (v) => $79d19215c0446b57$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $79d19215c0446b57$export$d927fcb6adf8f9de, (v) => $79d19215c0446b57$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $79d19215c0446b57$export$b82d16f27459e05a, (v) => $79d19215c0446b57$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $79d19215c0446b57$export$522c17b4f5e123e8, (v) => $79d19215c0446b57$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $79d19215c0446b57$export$1aabd8a0274ecfd6, (v) => $79d19215c0446b57$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $79d19215c0446b57$export$9b621391a187a31a, (v) => $79d19215c0446b57$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $79d19215c0446b57$export$f5bbd400c2f4426f, (v) => $79d19215c0446b57$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $79d19215c0446b57$export$2b8d127b894957b9;
var $79d19215c0446b57$export$cea3a54a6425200c;
var $79d19215c0446b57$export$a7c73072b1a182ae;
var $79d19215c0446b57$export$9f27bc3417b4524d;
var $79d19215c0446b57$export$db77ccec0bb4ccac;
var $79d19215c0446b57$export$8392c0c9d3dcbd35;
var $79d19215c0446b57$export$ffb0004e005737fa;
var $79d19215c0446b57$export$b624eff549462981;
var $79d19215c0446b57$export$7897aa7841a5380c;
var $79d19215c0446b57$export$602eac185826482c;
var $79d19215c0446b57$export$e2c29f18771995cb;
var $79d19215c0446b57$export$5f8d39834fd61797;
var $79d19215c0446b57$export$74bf444e3cd11ea5;
var $79d19215c0446b57$export$92387174baf9b227;
var $79d19215c0446b57$export$ec112efeb987d9c6;
var $79d19215c0446b57$export$b706b080d889d2c9;
var $79d19215c0446b57$export$5be5a87408f70ddc;
var $79d19215c0446b57$export$45a5e7f76e0caa8d;
var $79d19215c0446b57$export$455c2e768291efa6;
var $79d19215c0446b57$export$9522e17588c12572;
var $79d19215c0446b57$export$2110ac352bb060b9;
var $79d19215c0446b57$export$56885ab8b9c456ab;
var $79d19215c0446b57$export$d927fcb6adf8f9de;
var $79d19215c0446b57$export$b82d16f27459e05a;
var $79d19215c0446b57$export$522c17b4f5e123e8;
var $79d19215c0446b57$export$1aabd8a0274ecfd6;
var $79d19215c0446b57$export$9b621391a187a31a;
var $79d19215c0446b57$export$f5bbd400c2f4426f;
"use strict";
var $79d19215c0446b57$var$b = "function" === typeof Symbol && Symbol.for, $79d19215c0446b57$var$c = $79d19215c0446b57$var$b ? Symbol.for("react.element") : 60103, $79d19215c0446b57$var$d = $79d19215c0446b57$var$b ? Symbol.for("react.portal") : 60106, $79d19215c0446b57$var$e = $79d19215c0446b57$var$b ? Symbol.for("react.fragment") : 60107, $79d19215c0446b57$var$f = $79d19215c0446b57$var$b ? Symbol.for("react.strict_mode") : 60108, $79d19215c0446b57$var$g = $79d19215c0446b57$var$b ? Symbol.for("react.profiler") : 60114, $79d19215c0446b57$var$h = $79d19215c0446b57$var$b ? Symbol.for("react.provider") : 60109, $79d19215c0446b57$var$k = $79d19215c0446b57$var$b ? Symbol.for("react.context") : 60110, $79d19215c0446b57$var$l = $79d19215c0446b57$var$b ? Symbol.for("react.async_mode") : 60111, $79d19215c0446b57$var$m = $79d19215c0446b57$var$b ? Symbol.for("react.concurrent_mode") : 60111, $79d19215c0446b57$var$n = $79d19215c0446b57$var$b ? Symbol.for("react.forward_ref") : 60112, $79d19215c0446b57$var$p = $79d19215c0446b57$var$b ? Symbol.for("react.suspense") : 60113, $79d19215c0446b57$var$q = $79d19215c0446b57$var$b ? Symbol.for("react.suspense_list") : 60120, $79d19215c0446b57$var$r = $79d19215c0446b57$var$b ? Symbol.for("react.memo") : 60115, $79d19215c0446b57$var$t = $79d19215c0446b57$var$b ? Symbol.for("react.lazy") : 60116, $79d19215c0446b57$var$v = $79d19215c0446b57$var$b ? Symbol.for("react.block") : 60121, $79d19215c0446b57$var$w = $79d19215c0446b57$var$b ? Symbol.for("react.fundamental") : 60117, $79d19215c0446b57$var$x = $79d19215c0446b57$var$b ? Symbol.for("react.responder") : 60118, $79d19215c0446b57$var$y = $79d19215c0446b57$var$b ? Symbol.for("react.scope") : 60119;
function $79d19215c0446b57$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $79d19215c0446b57$var$c:
                switch(a = a.type, a){
                    case $79d19215c0446b57$var$l:
                    case $79d19215c0446b57$var$m:
                    case $79d19215c0446b57$var$e:
                    case $79d19215c0446b57$var$g:
                    case $79d19215c0446b57$var$f:
                    case $79d19215c0446b57$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $79d19215c0446b57$var$k:
                            case $79d19215c0446b57$var$n:
                            case $79d19215c0446b57$var$t:
                            case $79d19215c0446b57$var$r:
                            case $79d19215c0446b57$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $79d19215c0446b57$var$d:
                return u;
        }
    }
}
function $79d19215c0446b57$var$A(a) {
    return $79d19215c0446b57$var$z(a) === $79d19215c0446b57$var$m;
}
$79d19215c0446b57$export$2b8d127b894957b9 = $79d19215c0446b57$var$l;
$79d19215c0446b57$export$cea3a54a6425200c = $79d19215c0446b57$var$m;
$79d19215c0446b57$export$a7c73072b1a182ae = $79d19215c0446b57$var$k;
$79d19215c0446b57$export$9f27bc3417b4524d = $79d19215c0446b57$var$h;
$79d19215c0446b57$export$db77ccec0bb4ccac = $79d19215c0446b57$var$c;
$79d19215c0446b57$export$8392c0c9d3dcbd35 = $79d19215c0446b57$var$n;
$79d19215c0446b57$export$ffb0004e005737fa = $79d19215c0446b57$var$e;
$79d19215c0446b57$export$b624eff549462981 = $79d19215c0446b57$var$t;
$79d19215c0446b57$export$7897aa7841a5380c = $79d19215c0446b57$var$r;
$79d19215c0446b57$export$602eac185826482c = $79d19215c0446b57$var$d;
$79d19215c0446b57$export$e2c29f18771995cb = $79d19215c0446b57$var$g;
$79d19215c0446b57$export$5f8d39834fd61797 = $79d19215c0446b57$var$f;
$79d19215c0446b57$export$74bf444e3cd11ea5 = $79d19215c0446b57$var$p;
$79d19215c0446b57$export$92387174baf9b227 = function(a) {
    return $79d19215c0446b57$var$A(a) || $79d19215c0446b57$var$z(a) === $79d19215c0446b57$var$l;
};
$79d19215c0446b57$export$ec112efeb987d9c6 = $79d19215c0446b57$var$A;
$79d19215c0446b57$export$b706b080d889d2c9 = function(a) {
    return $79d19215c0446b57$var$z(a) === $79d19215c0446b57$var$k;
};
$79d19215c0446b57$export$5be5a87408f70ddc = function(a) {
    return $79d19215c0446b57$var$z(a) === $79d19215c0446b57$var$h;
};
$79d19215c0446b57$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $79d19215c0446b57$var$c;
};
$79d19215c0446b57$export$455c2e768291efa6 = function(a) {
    return $79d19215c0446b57$var$z(a) === $79d19215c0446b57$var$n;
};
$79d19215c0446b57$export$9522e17588c12572 = function(a) {
    return $79d19215c0446b57$var$z(a) === $79d19215c0446b57$var$e;
};
$79d19215c0446b57$export$2110ac352bb060b9 = function(a) {
    return $79d19215c0446b57$var$z(a) === $79d19215c0446b57$var$t;
};
$79d19215c0446b57$export$56885ab8b9c456ab = function(a) {
    return $79d19215c0446b57$var$z(a) === $79d19215c0446b57$var$r;
};
$79d19215c0446b57$export$d927fcb6adf8f9de = function(a) {
    return $79d19215c0446b57$var$z(a) === $79d19215c0446b57$var$d;
};
$79d19215c0446b57$export$b82d16f27459e05a = function(a) {
    return $79d19215c0446b57$var$z(a) === $79d19215c0446b57$var$g;
};
$79d19215c0446b57$export$522c17b4f5e123e8 = function(a) {
    return $79d19215c0446b57$var$z(a) === $79d19215c0446b57$var$f;
};
$79d19215c0446b57$export$1aabd8a0274ecfd6 = function(a) {
    return $79d19215c0446b57$var$z(a) === $79d19215c0446b57$var$p;
};
$79d19215c0446b57$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $79d19215c0446b57$var$e || a === $79d19215c0446b57$var$m || a === $79d19215c0446b57$var$g || a === $79d19215c0446b57$var$f || a === $79d19215c0446b57$var$p || a === $79d19215c0446b57$var$q || "object" === typeof a && null !== a && (a.$$typeof === $79d19215c0446b57$var$t || a.$$typeof === $79d19215c0446b57$var$r || a.$$typeof === $79d19215c0446b57$var$h || a.$$typeof === $79d19215c0446b57$var$k || a.$$typeof === $79d19215c0446b57$var$n || a.$$typeof === $79d19215c0446b57$var$w || a.$$typeof === $79d19215c0446b57$var$x || a.$$typeof === $79d19215c0446b57$var$y || a.$$typeof === $79d19215c0446b57$var$v);
};
$79d19215c0446b57$export$f5bbd400c2f4426f = $79d19215c0446b57$var$z;

});

parcelRequire.register("3OwKu", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $2c6f71ddee5868db$export$306c0aa65ff9ec16, (v) => $2c6f71ddee5868db$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2c6f71ddee5868db$export$306c0aa65ff9ec16;
"use strict";

var $5vDX4 = parcelRequire("5vDX4");
function $2c6f71ddee5868db$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $2c6f71ddee5868db$var$objectIs = "function" === typeof Object.is ? Object.is : $2c6f71ddee5868db$var$is, $2c6f71ddee5868db$var$useState = $5vDX4.useState, $2c6f71ddee5868db$var$useEffect = $5vDX4.useEffect, $2c6f71ddee5868db$var$useLayoutEffect = $5vDX4.useLayoutEffect, $2c6f71ddee5868db$var$useDebugValue = $5vDX4.useDebugValue;
function $2c6f71ddee5868db$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $2c6f71ddee5868db$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $2c6f71ddee5868db$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $2c6f71ddee5868db$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $2c6f71ddee5868db$var$useEffect(function() {
        $2c6f71ddee5868db$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $2c6f71ddee5868db$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $2c6f71ddee5868db$var$useDebugValue(value);
    return value;
}
function $2c6f71ddee5868db$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$2c6f71ddee5868db$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $2c6f71ddee5868db$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $2c6f71ddee5868db$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2c6f71ddee5868db$var$useSyncExternalStore$1 : $2c6f71ddee5868db$var$useSyncExternalStore$2;
$2c6f71ddee5868db$export$306c0aa65ff9ec16 = void 0 !== $5vDX4.useSyncExternalStore ? $5vDX4.useSyncExternalStore : $2c6f71ddee5868db$var$shim;

});

parcelRequire.register("2EGCf", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $1ef05fda14f4964a$export$bf730a2d8bf68b42, (v) => $1ef05fda14f4964a$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1ef05fda14f4964a$export$bf730a2d8bf68b42;
"use strict";

var $5vDX4 = parcelRequire("5vDX4");

var $9uAjU = parcelRequire("9uAjU");
function $1ef05fda14f4964a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $1ef05fda14f4964a$var$objectIs = "function" === typeof Object.is ? Object.is : $1ef05fda14f4964a$var$is, $1ef05fda14f4964a$var$useSyncExternalStore = $9uAjU.useSyncExternalStore, $1ef05fda14f4964a$var$useRef = $5vDX4.useRef, $1ef05fda14f4964a$var$useEffect = $5vDX4.useEffect, $1ef05fda14f4964a$var$useMemo = $5vDX4.useMemo, $1ef05fda14f4964a$var$useDebugValue = $5vDX4.useDebugValue;
$1ef05fda14f4964a$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $1ef05fda14f4964a$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $1ef05fda14f4964a$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($1ef05fda14f4964a$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $1ef05fda14f4964a$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $1ef05fda14f4964a$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $1ef05fda14f4964a$var$useDebugValue(value);
    return value;
};

});
parcelRequire.register("9uAjU", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3OwKu"));

});


parcelRequire.register("kEzJs", function(module, exports) {

$parcel$export(module.exports, "default", () => $179654af16f5b664$export$2e2bcd8739ae039);

var $ibHwF = parcelRequire("ibHwF");

var $5UhSy = parcelRequire("5UhSy");
var $179654af16f5b664$export$2e2bcd8739ae039 = (0, $5UhSy.default).addTool("store", (0, $ibHwF.default)());

});
parcelRequire.register("ibHwF", function(module, exports) {

$parcel$export(module.exports, "default", () => $10350a83aac056c0$export$2e2bcd8739ae039);

var $5zFOX = parcelRequire("5zFOX");

var $h8jtS = parcelRequire("h8jtS");

var $cZBeu = parcelRequire("cZBeu");

var $5i9lw = parcelRequire("5i9lw");

var $hMIKI = parcelRequire("hMIKI");

var $gM2lt = parcelRequire("gM2lt");

var $xggRE = parcelRequire("xggRE");
const $10350a83aac056c0$var$DEVTOOLS_KEY = "__REDUX_DEVTOOLS_EXTENSION_COMPOSE__";
function $10350a83aac056c0$export$2e2bcd8739ae039(state = (0, $gM2lt.default)) {
    const reducer = (0, $xggRE.default)((0, $hMIKI.default));
    const composeEnhancers = window[$10350a83aac056c0$var$DEVTOOLS_KEY] || (0, $5zFOX.compose);
    const enhancer = composeEnhancers((0, $5zFOX.applyMiddleware)((0, $h8jtS.default), (0, $cZBeu.middleware), (0, $5i9lw.middleware)));
    return (0, $5zFOX.createStore)(reducer, state, enhancer);
}

});
parcelRequire.register("5zFOX", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $40f0a961ffd163fb$export$f51a9068ac82ea43);
$parcel$export(module.exports, "bindActionCreators", () => $40f0a961ffd163fb$export$aea084d96e84da92);
$parcel$export(module.exports, "compose", () => $40f0a961ffd163fb$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $40f0a961ffd163fb$export$9ff26e0402cc7b7);

var $2Jz0T = parcelRequire("2Jz0T");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $40f0a961ffd163fb$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $40f0a961ffd163fb$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $40f0a961ffd163fb$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $40f0a961ffd163fb$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $40f0a961ffd163fb$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $40f0a961ffd163fb$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $40f0a961ffd163fb$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $40f0a961ffd163fb$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $40f0a961ffd163fb$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($40f0a961ffd163fb$var$isDate(val)) return "date";
    if ($40f0a961ffd163fb$var$isError(val)) return "error";
    var constructorName = $40f0a961ffd163fb$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $40f0a961ffd163fb$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $40f0a961ffd163fb$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $40f0a961ffd163fb$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $40f0a961ffd163fb$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $40f0a961ffd163fb$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(1));
        return enhancer($40f0a961ffd163fb$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$40f0a961ffd163fb$var$isPlainObject(action)) throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $40f0a961ffd163fb$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$40f0a961ffd163fb$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $40f0a961ffd163fb$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$40f0a961ffd163fb$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $40f0a961ffd163fb$export$8928921ea2d3b126 = $40f0a961ffd163fb$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $40f0a961ffd163fb$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $40f0a961ffd163fb$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $40f0a961ffd163fb$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$40f0a961ffd163fb$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $40f0a961ffd163fb$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $40f0a961ffd163fb$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $40f0a961ffd163fb$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $40f0a961ffd163fb$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $40f0a961ffd163fb$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $40f0a961ffd163fb$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $40f0a961ffd163fb$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $40f0a961ffd163fb$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $40f0a961ffd163fb$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $40f0a961ffd163fb$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $40f0a961ffd163fb$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $40f0a961ffd163fb$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $40f0a961ffd163fb$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($40f0a961ffd163fb$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $40f0a961ffd163fb$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $2Jz0T.default)((0, $2Jz0T.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRequire.register("2Jz0T", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fdaf1a867302304$export$2e2bcd8739ae039);

var $hQadu = parcelRequire("hQadu");
function $1fdaf1a867302304$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1fdaf1a867302304$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1fdaf1a867302304$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $hQadu.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1fdaf1a867302304$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRequire.register("hQadu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfcf37ca2b89efde$export$2e2bcd8739ae039);

var $l5kLP = parcelRequire("l5kLP");
function $cfcf37ca2b89efde$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $l5kLP.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRequire.register("l5kLP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59a2d29c1b400f8$export$2e2bcd8739ae039);

var $tI7VU = parcelRequire("tI7VU");

var $8yXIV = parcelRequire("8yXIV");
function $f59a2d29c1b400f8$export$2e2bcd8739ae039(t) {
    var i = (0, $8yXIV.default)(t, "string");
    return "symbol" == (0, $tI7VU.default)(i) ? i : i + "";
}

});
parcelRequire.register("tI7VU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0594f03dd2ec591c$export$2e2bcd8739ae039);
function $0594f03dd2ec591c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $0594f03dd2ec591c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0594f03dd2ec591c$export$2e2bcd8739ae039(o);
}

});

parcelRequire.register("8yXIV", function(module, exports) {

$parcel$export(module.exports, "default", () => $63bfd3906f33de18$export$2e2bcd8739ae039);

var $tI7VU = parcelRequire("tI7VU");
function $63bfd3906f33de18$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $tI7VU.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $tI7VU.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRequire.register("h8jtS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7924b87dc1ebd78$export$2e2bcd8739ae039);

var $e3T4k = parcelRequire("e3T4k");

var $5wyQR = parcelRequire("5wyQR");
/* eslint-disable no-constant-condition */ /**
 * A redux middleware which adds support for async actions and action
 * sequences.
 */ var $c7924b87dc1ebd78$var$reduxMiddleware = function reduxMiddleware(_ref) {
    var dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if ($c7924b87dc1ebd78$var$isIterator(action)) {
                if ($c7924b87dc1ebd78$var$supportsAsyncIteration(action)) return $c7924b87dc1ebd78$var$consumeAsyncIterator(dispatch, action);
                 // Yes, this is phrased oddly. TypeScript insisted.
                if (!$c7924b87dc1ebd78$var$supportsAsyncIteration(action)) return $c7924b87dc1ebd78$var$consumeSyncIterator(dispatch, action);
            }
            return next(action);
        };
    };
}; // This produces the set of all things which can be dispatched.
// Consume the async iterator. Every yielded value is dispatched and the
// return value is resolved and returned from `dispatch(...)`.
var $c7924b87dc1ebd78$var$consumeAsyncIterator = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($e3T4k)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5wyQR))).mark(function _callee(dispatch, iterator) {
        var prevDispatchResult, result;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5wyQR))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 3;
                    return iterator.next(prevDispatchResult);
                case 3:
                    result = _context.sent;
                    if (!result.done) {
                        _context.next = 6;
                        break;
                    }
                    return _context.abrupt("return", result.value);
                case 6:
                    _context.next = 8;
                    return dispatch(result.value);
                case 8:
                    prevDispatchResult = _context.sent;
                    _context.next = 0;
                    break;
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function consumeAsyncIterator(_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $c7924b87dc1ebd78$var$consumeSyncIterator = function consumeSyncIterator(dispatch, iterator) {
    var prevDispatchResult;
    while(true){
        var result = iterator.next(prevDispatchResult);
        if (result.done) return result.value;
        prevDispatchResult = dispatch(result.value);
    }
};
var $c7924b87dc1ebd78$var$supportsAsyncIteration = function supportsAsyncIteration(iterator) {
    return Symbol.asyncIterator in iterator;
};
var $c7924b87dc1ebd78$var$isIterator = function isIterator(value) {
    return value && typeof value.next === "function" && typeof value.throw === "function" && typeof value.return === "function";
}; // Pull the return type out of an async iterator.
var $c7924b87dc1ebd78$export$2e2bcd8739ae039 = $c7924b87dc1ebd78$var$reduxMiddleware;

});
parcelRequire.register("e3T4k", function(module, exports) {
function $a3cc10010114816d$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $a3cc10010114816d$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $a3cc10010114816d$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $a3cc10010114816d$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $a3cc10010114816d$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("5wyQR", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $405af9bb31c542bf$var$runtime = (parcelRequire("eNSll"))();
module.exports = $405af9bb31c542bf$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $405af9bb31c542bf$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $405af9bb31c542bf$var$runtime;
    else Function("r", "regeneratorRuntime = r")($405af9bb31c542bf$var$runtime);
}

});
parcelRequire.register("eNSll", function(module, exports) {

var $6D4qB = parcelRequire("6D4qB");

var $7wYml = parcelRequire("7wYml");

var $4elU8 = parcelRequire("4elU8");

var $c9JOb = parcelRequire("c9JOb");

var $4nd4E = parcelRequire("4nd4E");

var $eivwb = parcelRequire("eivwb");

var $9MsUs = parcelRequire("9MsUs");
function $ac6fcbbfdca0245a$var$_regeneratorRuntime() {
    "use strict";
    var r = $7wYml(), e = r.m($ac6fcbbfdca0245a$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $9MsUs(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $ac6fcbbfdca0245a$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $6D4qB(r, e);
            },
            AsyncIterator: $4nd4E,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $c9JOb : $4elU8)(a(r), e, t, o, u);
            },
            keys: $eivwb,
            values: $9MsUs
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $ac6fcbbfdca0245a$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("6D4qB", function(module, exports) {
function $4d39d1e93db01fe8$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $4d39d1e93db01fe8$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("7wYml", function(module, exports) {

var $aRSKy = parcelRequire("aRSKy");
function $016a3b3878f2858d$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $aRSKy(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($aRSKy(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $aRSKy(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $aRSKy(u, "constructor", GeneratorFunctionPrototype), $aRSKy(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $aRSKy(GeneratorFunctionPrototype, o, "GeneratorFunction"), $aRSKy(u), $aRSKy(u, o, "Generator"), $aRSKy(u, n, function() {
        return this;
    }), $aRSKy(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $016a3b3878f2858d$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $016a3b3878f2858d$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("aRSKy", function(module, exports) {
function $020abb24526b9287$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $020abb24526b9287$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        function o(r, n) {
            $020abb24526b9287$var$_regeneratorDefine(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        }
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $020abb24526b9287$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $020abb24526b9287$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("4elU8", function(module, exports) {

var $c9JOb = parcelRequire("c9JOb");
function $314975fece12f515$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $c9JOb(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $314975fece12f515$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("c9JOb", function(module, exports) {

var $7wYml = parcelRequire("7wYml");

var $4nd4E = parcelRequire("4nd4E");
function $8d99dbe35b22400c$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $4nd4E($7wYml().w(r, e, t, o), n || Promise);
}
module.exports = $8d99dbe35b22400c$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("4nd4E", function(module, exports) {

var $6D4qB = parcelRequire("6D4qB");

var $aRSKy = parcelRequire("aRSKy");
function $32f373a51131e007$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $6D4qB ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($aRSKy($32f373a51131e007$var$AsyncIterator.prototype), $aRSKy($32f373a51131e007$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $aRSKy(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $32f373a51131e007$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("eivwb", function(module, exports) {
function $a68b31f875f037d3$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $a68b31f875f037d3$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("9MsUs", function(module, exports) {

var $9zrNF = parcelRequire("9zrNF");
var $71ef0596efedea6d$var$_typeof = $9zrNF.default;
function $71ef0596efedea6d$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($71ef0596efedea6d$var$_typeof(e) + " is not iterable");
}
module.exports = $71ef0596efedea6d$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("9zrNF", function(module, exports) {
function $6f7cf2723a1fe3b1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $6f7cf2723a1fe3b1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $6f7cf2723a1fe3b1$var$_typeof(o);
}
module.exports = $6f7cf2723a1fe3b1$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRequire.register("cZBeu", function(module, exports) {

$parcel$export(module.exports, "middleware", () => $a21f193ab6b5bf9b$export$5a7767152ae0305f);
parcelRequire("3jRC4");
var $3NpDV = parcelRequire("3NpDV");
function $a21f193ab6b5bf9b$export$5a7767152ae0305f(store) {
    return (next)=>(action)=>{
            const dispatchReturnValue = next(action);
            const state = store.getState();
            $3NpDV.run(state);
            return dispatchReturnValue;
        };
}

});
parcelRequire.register("3jRC4", function(module, exports) {

$parcel$export(module.exports, "devices", () => (parcelRequire("hvrSc")));
$parcel$export(module.exports, "connections", () => (parcelRequire("5lVTw")));
$parcel$export(module.exports, "tracks", () => (parcelRequire("yJV7z")));
$parcel$export(module.exports, "chat", () => (parcelRequire("gmvC5")));
$parcel$export(module.exports, "gc", () => (parcelRequire("3NpDV")));
$parcel$export(module.exports, "settings", () => (parcelRequire("9fjTl")));

var $hvrSc = parcelRequire("hvrSc");

var $5lVTw = parcelRequire("5lVTw");

var $yJV7z = parcelRequire("yJV7z");

var $gmvC5 = parcelRequire("gmvC5");

var $3NpDV = parcelRequire("3NpDV");

var $9fjTl = parcelRequire("9fjTl");

});
parcelRequire.register("hvrSc", function(module, exports) {

$parcel$export(module.exports, "requestMediaDevices", () => $73082fb4e55eb1a8$export$9b9a1128715870c5);
$parcel$export(module.exports, "GumError", () => $73082fb4e55eb1a8$export$2fafb16f25820c3c);
$parcel$export(module.exports, "shareScreen", () => $73082fb4e55eb1a8$export$82d5b8a6870919e);
$parcel$export(module.exports, "observe", () => $73082fb4e55eb1a8$export$d1203567a167490e);

var $5ZlB8 = parcelRequire("5ZlB8");

var $7W5YA = parcelRequire("7W5YA");

var $kXV5G = parcelRequire("kXV5G");

var $fRjbn = parcelRequire("fRjbn");
const $73082fb4e55eb1a8$var$logger = new (0, $fRjbn.default)("devices");
// Put the tracks somewhere useful.
function $73082fb4e55eb1a8$var$addTracksToContext(tracks) {
    tracks.forEach((track)=>{
        (0, $7W5YA.default).tracks.set(track.id, track);
    });
}
// Send the new tracks to every open WebRTC connection.
function $73082fb4e55eb1a8$var$sendTracksToAllParticipants(tracks, source) {
    Array.from((0, $7W5YA.default).connections.values()).forEach((conn)=>{
        tracks.forEach((track)=>conn.addTrack(track, source));
    });
}
// Turns a track into something you'd trust in Redux.
function $73082fb4e55eb1a8$var$getTrackMetadata(track) {
    const settings = track.getSettings();
    return {
        trackId: track.id,
        kind: track.kind,
        enabled: track.enabled,
        deviceId: settings.deviceId ?? null,
        groupId: settings.groupId ?? null,
        facingMode: settings.facingMode ?? null
    };
}
async function $73082fb4e55eb1a8$export$9b9a1128715870c5(query) {
    const constraints = {};
    if (query.audio) constraints.audio = query.audio;
    if (query.video) constraints.video = {
        // Prefer videos in 16:9 aspect ratio.
        height: {
            ideal: 720
        },
        width: {
            ideal: 1280
        },
        ...Object(query.video)
    };
    $73082fb4e55eb1a8$var$logger.debug("Requesting new tracks:", constraints);
    let stream;
    try {
        // TODO: Handle cases where users don't have both audio & video.
        stream = await (0, $5ZlB8.default).getUserMedia(constraints);
    } catch (error) {
        $73082fb4e55eb1a8$var$logger.error("Media access denied:", error?.name, error);
        throw new $73082fb4e55eb1a8$export$2fafb16f25820c3c(error);
    }
    const tracks = stream.getTracks();
    tracks.forEach($73082fb4e55eb1a8$var$removeTrackWhenEnded);
    $73082fb4e55eb1a8$var$addTracksToContext(tracks);
    $73082fb4e55eb1a8$var$sendTracksToAllParticipants(tracks, (0, $kXV5G.TrackSource).Device);
    return stream.getTracks().map($73082fb4e55eb1a8$var$getTrackMetadata);
}
async function $73082fb4e55eb1a8$export$82d5b8a6870919e() {
    const stream = await (0, $5ZlB8.default).getDisplayMedia({
        audio: true,
        video: true
    });
    const tracks = stream.getTracks();
    tracks.forEach($73082fb4e55eb1a8$var$removeTrackWhenEnded);
    $73082fb4e55eb1a8$var$addTracksToContext(tracks);
    $73082fb4e55eb1a8$var$sendTracksToAllParticipants(tracks, (0, $kXV5G.TrackSource).Display);
    return stream.getTracks().map($73082fb4e55eb1a8$var$getTrackMetadata);
}

/**
 * The 'track.onended' event only fires for certain events generally outside
 * your control, like unplugging the camera or pressing the browser's built-in
 * "Stop sharing" button on a screen share.
 *
 * Because of the way RTP transceivers operate, it is impractical to transmit
 * the "ended" event to the remote peer without risking damage to inbound
 * tracks as well. Thus, this event only happens for local tracks.
 *
 * See this article for more details:
 * https://blog.mozilla.org/webrtc/rtcrtptransceiver-explored/
 */ function $73082fb4e55eb1a8$var$removeTrackWhenEnded(track) {
    track.onended = async function removeTrackFromRedux() {
        $73082fb4e55eb1a8$var$logger.warn("Track ended unexpectedly:", track.id);
        const { default: sdk } = await (parcelRequire("1TaNK"));
        sdk.tracks.remove({
            trackId: track.id,
            peerId: (0, $kXV5G.MY_PARTICIPANT_ID)
        });
    };
}
async function* $73082fb4e55eb1a8$export$d1203567a167490e() {
    function waitForChange() {
        return new Promise((resolve)=>{
            (0, $5ZlB8.default).ondevicechange = resolve;
        });
    }
    while(true)yield waitForChange();
}
class $73082fb4e55eb1a8$export$2fafb16f25820c3c extends Error {
    constructor(error){
        super(error?.message);
        switch(error?.name){
            case "NotAllowedError":
                this.type = (0, $kXV5G.DeviceError).NotAllowed;
                break;
            default:
                this.type = (0, $kXV5G.DeviceError).Unknown;
                break;
        }
    }
}

});
parcelRequire.register("5ZlB8", function(module, exports) {

$parcel$export(module.exports, "DeviceKind", () => $45c367243b4ce6b0$export$bc150ea4a36814ed);
$parcel$export(module.exports, "default", () => $45c367243b4ce6b0$export$2e2bcd8739ae039);
var $45c367243b4ce6b0$var$f = Object.defineProperty;
var $45c367243b4ce6b0$var$p = (e, t, n)=>t in e ? $45c367243b4ce6b0$var$f(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : e[t] = n;
var $45c367243b4ce6b0$var$r = (e, t, n)=>($45c367243b4ce6b0$var$p(e, typeof t != "symbol" ? t + "" : t, n), n);
function $45c367243b4ce6b0$export$d3854de3e3b5b97c() {
    return typeof navigator < "u" && !!navigator.mediaDevices;
}
function $45c367243b4ce6b0$var$c() {
    if (!$45c367243b4ce6b0$export$d3854de3e3b5b97c()) throw new Error("The media devices API isn't supported here.");
    return navigator.mediaDevices;
}
async function $45c367243b4ce6b0$var$g() {
    return (await $45c367243b4ce6b0$var$c().enumerateDevices()).filter($45c367243b4ce6b0$var$h).map($45c367243b4ce6b0$var$m);
}
function $45c367243b4ce6b0$var$h(e) {
    return e.deviceId !== "default";
}
function $45c367243b4ce6b0$var$m(e) {
    return {
        label: e.label || null,
        kind: e.kind,
        deviceId: e.deviceId || null,
        groupId: e.groupId || null
    };
}
var $45c367243b4ce6b0$export$bc150ea4a36814ed = /* @__PURE__ */ ((e)=>(e.VideoInput = "videoinput", e.AudioInput = "audioinput", e.AudioOutput = "audiooutput", e))($45c367243b4ce6b0$export$bc150ea4a36814ed || {});
async function $45c367243b4ce6b0$var$I(e) {
    return $45c367243b4ce6b0$var$c().getUserMedia(e);
}
class $45c367243b4ce6b0$var$y {
    constructor(){
        $45c367243b4ce6b0$var$r(this, "_knownDevices", []);
        $45c367243b4ce6b0$var$r(this, "_gainedScreenAccessOnce", !1);
        /**
     * Specifies a function to be called whenever the list of available devices
     * changes.
     *
     * Note: this is different from the native event. It passes the changeset
     * and full list of devices as a parameter.
     */ $45c367243b4ce6b0$var$r(this, "ondevicechange", null);
        /**
     * Request a live media stream from audio and/or video devices. Streams are
     * configurable through constraints.
     * See: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
     */ $45c367243b4ce6b0$var$r(this, "getUserMedia", async (t)=>{
            const n = await $45c367243b4ce6b0$var$I(t);
            return this.enumerateDevices(), n;
        });
        /**
     * Ask the user to share their screen. Resolves with a media stream carrying
     * video, and potentially audio from the application window.
     * See: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia
     */ $45c367243b4ce6b0$var$r(this, "getDisplayMedia", async (t)=>{
            const n = await $45c367243b4ce6b0$var$c().getDisplayMedia(t);
            return this._gainedScreenAccessOnce || (this._gainedScreenAccessOnce = !0, this.enumerateDevices()), n;
        });
        /**
     * Lists every available hardware device, including microphones, cameras,
     * and speakers (depending on browser support). May contain redacted
     * information depending on application permissions.
     */ $45c367243b4ce6b0$var$r(this, "enumerateDevices", async ()=>{
            const t = await $45c367243b4ce6b0$var$g();
            return this._checkForDeviceChanges(t), t;
        });
        /**
     * Returns an object containing every media constraint supported by the
     * browser.
     * See: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getSupportedConstraints
     */ $45c367243b4ce6b0$var$r(this, "getSupportedConstraints", ()=>$45c367243b4ce6b0$var$c().getSupportedConstraints());
        $45c367243b4ce6b0$export$d3854de3e3b5b97c() && $45c367243b4ce6b0$var$c().addEventListener("devicechange", ()=>this.ondevicechange ? this.enumerateDevices() : Promise.resolve());
    }
    _checkForDeviceChanges(t) {
        var a;
        const n = this._knownDevices;
        this._knownDevices = t;
        const i = this._calculateDeviceDiff(t, n);
        i.length && ((a = this.ondevicechange) == null || a.call(this, {
            changes: i,
            devices: t
        }));
    }
    /**
   * Note: The device enumeration API may return null values for device IDs
   * and labels. To avoid creating erroneous "Device Added" notifications,
   * a best effort should be made to detect when devices are identical.
   *
   * Order is significant. Preferred devices are listed first, which helps
   * correlate devices from permissioned requests with unpermissioned
   * requests.
   */ _calculateDeviceDiff(t, n) {
        const i = n.slice(), a = [], l = t.filter((s)=>{
            const d = i.findIndex((u)=>$45c367243b4ce6b0$var$_(s, u));
            if (d > -1) {
                const [u] = i.splice(d, 1);
                if (s.label !== u.label) {
                    const v = {
                        type: "update",
                        newInfo: s,
                        oldInfo: u
                    };
                    a.push(v);
                }
            }
            return d === -1;
        });
        return [
            ...a,
            // A device was just removed.
            ...i.map((s)=>({
                    type: "remove",
                    device: s
                })),
            // A device was just plugged in.
            ...l.map((s)=>({
                    type: "add",
                    device: s
                }))
        ];
    }
}
function $45c367243b4ce6b0$var$_(e, t) {
    if (t.deviceId) return e.deviceId === t.deviceId;
    function n(i) {
        return `${i.kind}:${i.groupId}`;
    }
    return n(e) === n(t);
}
var $45c367243b4ce6b0$export$485547b05523629 = /* @__PURE__ */ ((e)=>(e.Add = "add", e.Remove = "remove", e.Update = "update", e))($45c367243b4ce6b0$export$485547b05523629 || {});
const $45c367243b4ce6b0$export$2e2bcd8739ae039 = new $45c367243b4ce6b0$var$y();

});

parcelRequire.register("7W5YA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6438f80ec66fcbd9$export$2e2bcd8739ae039);

var $5UhSy = parcelRequire("5UhSy");
// Video centric apps deal with a lot of stateful objects. Things like media
// stream tracks, audio contexts, recorders, etc. None of those can exist in
// redux (state must be JSON serializable). But it has to go somewhere. So
// we put it here.
//
// For example, if you needed to associate a video track with a meeting
// member, you'd set the MediaStreamTrack here from inside the action creator.
// Then, from the reducer, you'd reference it by plain ID.
//
// Now as you can imagine, global mutable state isn't ideal. Here are some
// rules to keep things sane.
//
// THE RULES:
// 1. Never mutate state outside a redux action.
// 2. Never read state directly. Use/write a selector function in this folder.
// 3. Don't remove an object from state if redux is still referencing it.
// 4. Only store here what cannot be stored in redux.
const $6438f80ec66fcbd9$var$context = {
    tracks: new Map(),
    connections: new Map(),
    p2p: null
};
var $6438f80ec66fcbd9$export$2e2bcd8739ae039 = (0, $5UhSy.default).addTool("context", $6438f80ec66fcbd9$var$context);

});
parcelRequire.register("5UhSy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a746e67d961172d4$export$2e2bcd8739ae039);
/**
 * A collection of app-specific debugging tools. Use `tinker()` to explore app
 * state and dispatch high-level actions.
 *
 * The tools are not defined here to avoid creating import cycles,
 * particularly with the SDK.
 *
 * Set `ENABLE_DEBUGGING=true` to forcibly enable this in production.
 */ class $a746e67d961172d4$export$7f057a3df1330f04 {
    addTool(name, value) {
        this.tools[name] = value;
        return value;
    }
    enabled() {
        return true;
    }
    exposeAsGlobal() {
        Object.defineProperty(globalThis, "tinker", {
            configurable: true,
            value: this.getTools
        });
    }
    constructor(){
        this.tools = {};
        this.getTools = ()=>{
            return this.tools;
        };
    }
}
const $a746e67d961172d4$var$tinker = new $a746e67d961172d4$export$7f057a3df1330f04();
if ($a746e67d961172d4$var$tinker.enabled()) $a746e67d961172d4$var$tinker.exposeAsGlobal();
var $a746e67d961172d4$export$2e2bcd8739ae039 = $a746e67d961172d4$var$tinker;

});


parcelRequire.register("kXV5G", function(module, exports) {

$parcel$export(module.exports, "APP_NAME", () => $dcf401e852f73914$export$5b6c28c7dca07ad7);
$parcel$export(module.exports, "MY_PARTICIPANT_ID", () => $dcf401e852f73914$export$21e8832cceec3591);
$parcel$export(module.exports, "SERVER_ADDRESS", () => $dcf401e852f73914$export$9dc86f3b876e96ef);
$parcel$export(module.exports, "ICE_SERVERS", () => $dcf401e852f73914$export$1868f682b36474f4);
$parcel$export(module.exports, "TrackKind", () => $dcf401e852f73914$export$7d02d0c32b364ae);
$parcel$export(module.exports, "TrackSource", () => $dcf401e852f73914$export$cbf5c0994e5bc5f2);
$parcel$export(module.exports, "RtcDescriptionType", () => $dcf401e852f73914$export$45d41903875f7e85);
$parcel$export(module.exports, "RtcSignalingState", () => $dcf401e852f73914$export$4fbe1be28564b141);
$parcel$export(module.exports, "ConnectionState", () => $dcf401e852f73914$export$cd9c3c6bf535afc9);
$parcel$export(module.exports, "Routes", () => $dcf401e852f73914$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "EventType", () => $dcf401e852f73914$export$3d7865934588d77e);
$parcel$export(module.exports, "DeviceError", () => $dcf401e852f73914$export$64c9f614187c1e59);
// Never displayed to the user. Mainly used for logs.
const $dcf401e852f73914$export$5b6c28c7dca07ad7 = "farnsworth";
const $dcf401e852f73914$export$21e8832cceec3591 = "self";
const $dcf401e852f73914$export$9dc86f3b876e96ef = "/dns4/bootstrap.farnsworth.video/tcp/30000/wss/p2p/bafzbeiaxrhr2wl2ur2uyzxxjyzm3azoa2bsgntuddc5t7x3g777owz5dvi";
const $dcf401e852f73914$export$1868f682b36474f4 = ("stun:stun.l.google.com:19302" ?? "").split(";").filter(Boolean).map((tuple)=>{
    const [url, credentialType, username, credential] = tuple.split(",");
    const server = {
        urls: url
    };
    if (credentialType) Object.assign(server, {
        credentialType: credentialType,
        username: username,
        credential: credential
    });
    return server;
});
var $dcf401e852f73914$export$7d02d0c32b364ae;
(function(TrackKind) {
    TrackKind["Audio"] = "audio";
    TrackKind["Video"] = "video";
})($dcf401e852f73914$export$7d02d0c32b364ae || ($dcf401e852f73914$export$7d02d0c32b364ae = {}));
var $dcf401e852f73914$export$cbf5c0994e5bc5f2;
(function(TrackSource) {
    TrackSource[/** A webcam or physical microphone. */ "Device"] = "device";
    TrackSource[/** A shared screen or browser tab. */ "Display"] = "display";
})($dcf401e852f73914$export$cbf5c0994e5bc5f2 || ($dcf401e852f73914$export$cbf5c0994e5bc5f2 = {}));
var $dcf401e852f73914$export$45d41903875f7e85;
(function(RtcDescriptionType) {
    RtcDescriptionType["Offer"] = "offer";
})($dcf401e852f73914$export$45d41903875f7e85 || ($dcf401e852f73914$export$45d41903875f7e85 = {}));
var $dcf401e852f73914$export$4fbe1be28564b141;
(function(RtcSignalingState) {
    RtcSignalingState["Stable"] = "stable";
    RtcSignalingState["HaveLocalOffer"] = "have-local-offer";
})($dcf401e852f73914$export$4fbe1be28564b141 || ($dcf401e852f73914$export$4fbe1be28564b141 = {}));
var $dcf401e852f73914$export$cd9c3c6bf535afc9;
(function(ConnectionState) {
    ConnectionState["Connecting"] = "connecting";
    ConnectionState["Connected"] = "connected";
    ConnectionState["Disconnected"] = "disconnected";
    ConnectionState["Failed"] = "failed";
})($dcf401e852f73914$export$cd9c3c6bf535afc9 || ($dcf401e852f73914$export$cd9c3c6bf535afc9 = {}));
var $dcf401e852f73914$export$3565eb3d00ca5a74;
(function(Routes) {
    Routes[/** Alone, no active call. */ "Home"] = "/";
    Routes[/** Actively calling another user. */ "Call"] = "/call/:peerId";
})($dcf401e852f73914$export$3565eb3d00ca5a74 || ($dcf401e852f73914$export$3565eb3d00ca5a74 = {}));
var $dcf401e852f73914$export$3d7865934588d77e;
(function(EventType) {
    EventType[/** Pause a media track. */ "Pause"] = "pause";
    EventType[/** Resume a media track. */ "Resume"] = "resume";
    EventType[/** Send a chat message. */ "ChatMessage"] = "chat-message";
})($dcf401e852f73914$export$3d7865934588d77e || ($dcf401e852f73914$export$3d7865934588d77e = {}));
var $dcf401e852f73914$export$64c9f614187c1e59;
(function(DeviceError) {
    DeviceError[/** The user, browser, or operating system won't allow us access. */ "NotAllowed"] = "not-allowed";
    DeviceError[/** We don't know what went wrong. */ "Unknown"] = "unknown";
})($dcf401e852f73914$export$64c9f614187c1e59 || ($dcf401e852f73914$export$64c9f614187c1e59 = {}));

});

parcelRequire.register("fRjbn", function(module, exports) {

$parcel$export(module.exports, "default", () => $088f899867d97f0c$export$2e2bcd8739ae039);

var $jjmHV = parcelRequire("jjmHV");

var $kXV5G = parcelRequire("kXV5G");
// Enable app debugging by default.
if (!localStorage.getItem("debug")) (0, (/*@__PURE__*/$parcel$interopDefault($jjmHV))).enable(`${(0, $kXV5G.APP_NAME)}:*`);
class $088f899867d97f0c$export$2e2bcd8739ae039 {
    /**
   * The context is used to filter logs. Usually named after the module's
   * class or the file name.
   */ constructor(context){
        this.debug = (0, (/*@__PURE__*/$parcel$interopDefault($jjmHV)))(`${(0, $kXV5G.APP_NAME)}:${context}`);
        this.warn = (0, (/*@__PURE__*/$parcel$interopDefault($jjmHV)))(`${(0, $kXV5G.APP_NAME)}:${context}:WARN`);
        this.error = (0, (/*@__PURE__*/$parcel$interopDefault($jjmHV)))(`${(0, $kXV5G.APP_NAME)}:${context}:ERROR`);
    }
}

});
parcelRequire.register("jjmHV", function(module, exports) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ 
var $bvigH = parcelRequire("bvigH");
module.exports.formatArgs = $e0f167e794255431$var$formatArgs;
module.exports.save = $e0f167e794255431$var$save;
module.exports.load = $e0f167e794255431$var$load;
module.exports.useColors = $e0f167e794255431$var$useColors;
module.exports.storage = $e0f167e794255431$var$localstorage();
module.exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
    };
})();
/**
 * Colors.
 */ module.exports.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function $e0f167e794255431$var$useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function $e0f167e794255431$var$formatArgs(args) {
    args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === "%%") return;
        index++;
        if (match === "%c") // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ module.exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function $e0f167e794255431$var$save(namespaces) {
    try {
        if (namespaces) module.exports.storage.setItem("debug", namespaces);
        else module.exports.storage.removeItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function $e0f167e794255431$var$load() {
    let r;
    try {
        r = module.exports.storage.getItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $bvigH !== "undefined" && "env" in $bvigH) r = undefined;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function $e0f167e794255431$var$localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}

module.exports = (parcelRequire("6EKru"))(module.exports);
const { formatters: $e0f167e794255431$var$formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ $e0f167e794255431$var$formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return "[UnexpectedJSONParseError]: " + error.message;
    }
};

});
parcelRequire.register("bvigH", function(module, exports) {
// shim for using process in browser
var $8600c2b1592eca3b$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $8600c2b1592eca3b$var$cachedSetTimeout;
var $8600c2b1592eca3b$var$cachedClearTimeout;
function $8600c2b1592eca3b$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $8600c2b1592eca3b$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $8600c2b1592eca3b$var$cachedSetTimeout = setTimeout;
        else $8600c2b1592eca3b$var$cachedSetTimeout = $8600c2b1592eca3b$var$defaultSetTimout;
    } catch (e) {
        $8600c2b1592eca3b$var$cachedSetTimeout = $8600c2b1592eca3b$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $8600c2b1592eca3b$var$cachedClearTimeout = clearTimeout;
        else $8600c2b1592eca3b$var$cachedClearTimeout = $8600c2b1592eca3b$var$defaultClearTimeout;
    } catch (e) {
        $8600c2b1592eca3b$var$cachedClearTimeout = $8600c2b1592eca3b$var$defaultClearTimeout;
    }
})();
function $8600c2b1592eca3b$var$runTimeout(fun) {
    if ($8600c2b1592eca3b$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($8600c2b1592eca3b$var$cachedSetTimeout === $8600c2b1592eca3b$var$defaultSetTimout || !$8600c2b1592eca3b$var$cachedSetTimeout) && setTimeout) {
        $8600c2b1592eca3b$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8600c2b1592eca3b$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $8600c2b1592eca3b$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $8600c2b1592eca3b$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $8600c2b1592eca3b$var$runClearTimeout(marker) {
    if ($8600c2b1592eca3b$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($8600c2b1592eca3b$var$cachedClearTimeout === $8600c2b1592eca3b$var$defaultClearTimeout || !$8600c2b1592eca3b$var$cachedClearTimeout) && clearTimeout) {
        $8600c2b1592eca3b$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8600c2b1592eca3b$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $8600c2b1592eca3b$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $8600c2b1592eca3b$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $8600c2b1592eca3b$var$queue = [];
var $8600c2b1592eca3b$var$draining = false;
var $8600c2b1592eca3b$var$currentQueue;
var $8600c2b1592eca3b$var$queueIndex = -1;
function $8600c2b1592eca3b$var$cleanUpNextTick() {
    if (!$8600c2b1592eca3b$var$draining || !$8600c2b1592eca3b$var$currentQueue) return;
    $8600c2b1592eca3b$var$draining = false;
    if ($8600c2b1592eca3b$var$currentQueue.length) $8600c2b1592eca3b$var$queue = $8600c2b1592eca3b$var$currentQueue.concat($8600c2b1592eca3b$var$queue);
    else $8600c2b1592eca3b$var$queueIndex = -1;
    if ($8600c2b1592eca3b$var$queue.length) $8600c2b1592eca3b$var$drainQueue();
}
function $8600c2b1592eca3b$var$drainQueue() {
    if ($8600c2b1592eca3b$var$draining) return;
    var timeout = $8600c2b1592eca3b$var$runTimeout($8600c2b1592eca3b$var$cleanUpNextTick);
    $8600c2b1592eca3b$var$draining = true;
    var len = $8600c2b1592eca3b$var$queue.length;
    while(len){
        $8600c2b1592eca3b$var$currentQueue = $8600c2b1592eca3b$var$queue;
        $8600c2b1592eca3b$var$queue = [];
        while(++$8600c2b1592eca3b$var$queueIndex < len)if ($8600c2b1592eca3b$var$currentQueue) $8600c2b1592eca3b$var$currentQueue[$8600c2b1592eca3b$var$queueIndex].run();
        $8600c2b1592eca3b$var$queueIndex = -1;
        len = $8600c2b1592eca3b$var$queue.length;
    }
    $8600c2b1592eca3b$var$currentQueue = null;
    $8600c2b1592eca3b$var$draining = false;
    $8600c2b1592eca3b$var$runClearTimeout(timeout);
}
$8600c2b1592eca3b$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $8600c2b1592eca3b$var$queue.push(new $8600c2b1592eca3b$var$Item(fun, args));
    if ($8600c2b1592eca3b$var$queue.length === 1 && !$8600c2b1592eca3b$var$draining) $8600c2b1592eca3b$var$runTimeout($8600c2b1592eca3b$var$drainQueue);
};
// v8 likes predictible objects
function $8600c2b1592eca3b$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$8600c2b1592eca3b$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$8600c2b1592eca3b$var$process.title = "browser";
$8600c2b1592eca3b$var$process.browser = true;
$8600c2b1592eca3b$var$process.env = {};
$8600c2b1592eca3b$var$process.argv = [];
$8600c2b1592eca3b$var$process.version = ""; // empty string to avoid regexp issues
$8600c2b1592eca3b$var$process.versions = {};
function $8600c2b1592eca3b$var$noop() {}
$8600c2b1592eca3b$var$process.on = $8600c2b1592eca3b$var$noop;
$8600c2b1592eca3b$var$process.addListener = $8600c2b1592eca3b$var$noop;
$8600c2b1592eca3b$var$process.once = $8600c2b1592eca3b$var$noop;
$8600c2b1592eca3b$var$process.off = $8600c2b1592eca3b$var$noop;
$8600c2b1592eca3b$var$process.removeListener = $8600c2b1592eca3b$var$noop;
$8600c2b1592eca3b$var$process.removeAllListeners = $8600c2b1592eca3b$var$noop;
$8600c2b1592eca3b$var$process.emit = $8600c2b1592eca3b$var$noop;
$8600c2b1592eca3b$var$process.prependListener = $8600c2b1592eca3b$var$noop;
$8600c2b1592eca3b$var$process.prependOnceListener = $8600c2b1592eca3b$var$noop;
$8600c2b1592eca3b$var$process.listeners = function(name) {
    return [];
};
$8600c2b1592eca3b$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$8600c2b1592eca3b$var$process.cwd = function() {
    return "/";
};
$8600c2b1592eca3b$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$8600c2b1592eca3b$var$process.umask = function() {
    return 0;
};

});

parcelRequire.register("6EKru", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ 
function $4d8a810276d49664$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("cbIIL"));
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== "string") // Anything else let's inspect with %O
            args.unshift("%O");
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === "%%") return "%";
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === "function") {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, "enabled", {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === "function") createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        let i;
        const split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
        const len = split.length;
        for(i = 0; i < len; i++){
            if (!split[i]) continue;
            namespaces = split[i].replace(/\*/g, ".*?");
            if (namespaces[0] === "-") createDebug.skips.push(new RegExp("^" + namespaces.slice(1) + "$"));
            else createDebug.names.push(new RegExp("^" + namespaces + "$"));
        }
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names.map(toNamespace),
            ...createDebug.skips.map(toNamespace).map((namespace)=>"-" + namespace)
        ].join(",");
        createDebug.enable("");
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        if (name[name.length - 1] === "*") return true;
        let i;
        let len;
        for(i = 0, len = createDebug.skips.length; i < len; i++){
            if (createDebug.skips[i].test(name)) return false;
        }
        for(i = 0, len = createDebug.names.length; i < len; i++){
            if (createDebug.names[i].test(name)) return true;
        }
        return false;
    }
    /**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/ function toNamespace(regexp) {
        return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $4d8a810276d49664$var$setup;

});
parcelRequire.register("cbIIL", function(module, exports) {
/**
 * Helpers.
 */ var $8df933c84dc2e30e$var$s = 1000;
var $8df933c84dc2e30e$var$m = $8df933c84dc2e30e$var$s * 60;
var $8df933c84dc2e30e$var$h = $8df933c84dc2e30e$var$m * 60;
var $8df933c84dc2e30e$var$d = $8df933c84dc2e30e$var$h * 24;
var $8df933c84dc2e30e$var$w = $8df933c84dc2e30e$var$d * 7;
var $8df933c84dc2e30e$var$y = $8df933c84dc2e30e$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) return $8df933c84dc2e30e$var$parse(val);
    else if (type === "number" && isFinite(val)) return options.long ? $8df933c84dc2e30e$var$fmtLong(val) : $8df933c84dc2e30e$var$fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $8df933c84dc2e30e$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * $8df933c84dc2e30e$var$y;
        case "weeks":
        case "week":
        case "w":
            return n * $8df933c84dc2e30e$var$w;
        case "days":
        case "day":
        case "d":
            return n * $8df933c84dc2e30e$var$d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * $8df933c84dc2e30e$var$h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * $8df933c84dc2e30e$var$m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * $8df933c84dc2e30e$var$s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $8df933c84dc2e30e$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $8df933c84dc2e30e$var$d) return Math.round(ms / $8df933c84dc2e30e$var$d) + "d";
    if (msAbs >= $8df933c84dc2e30e$var$h) return Math.round(ms / $8df933c84dc2e30e$var$h) + "h";
    if (msAbs >= $8df933c84dc2e30e$var$m) return Math.round(ms / $8df933c84dc2e30e$var$m) + "m";
    if (msAbs >= $8df933c84dc2e30e$var$s) return Math.round(ms / $8df933c84dc2e30e$var$s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $8df933c84dc2e30e$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $8df933c84dc2e30e$var$d) return $8df933c84dc2e30e$var$plural(ms, msAbs, $8df933c84dc2e30e$var$d, "day");
    if (msAbs >= $8df933c84dc2e30e$var$h) return $8df933c84dc2e30e$var$plural(ms, msAbs, $8df933c84dc2e30e$var$h, "hour");
    if (msAbs >= $8df933c84dc2e30e$var$m) return $8df933c84dc2e30e$var$plural(ms, msAbs, $8df933c84dc2e30e$var$m, "minute");
    if (msAbs >= $8df933c84dc2e30e$var$s) return $8df933c84dc2e30e$var$plural(ms, msAbs, $8df933c84dc2e30e$var$s, "second");
    return ms + " ms";
}
/**
 * Pluralization helper.
 */ function $8df933c84dc2e30e$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
}

});




parcelRequire.register("1TaNK", function(module, exports) {

module.exports = import("./" + (parcelRequire("cyZqS")).resolve("107vV")).then(()=>parcelRequire("iDBjT"));

});


parcelRequire.register("5lVTw", function(module, exports) {

$parcel$export(module.exports, "SIGNALING_PROTOCOL", () => $04239cbad9f2bb12$export$3e0f51ae69c26797);
$parcel$export(module.exports, "getConnectionById", () => $04239cbad9f2bb12$export$c88efb7d88b738e7);
$parcel$export(module.exports, "listen", () => $04239cbad9f2bb12$export$63174c828edd6ff8);
$parcel$export(module.exports, "dial", () => $04239cbad9f2bb12$export$65e66d587c664fab);
$parcel$export(module.exports, "close", () => $04239cbad9f2bb12$export$8360e631d277ea4d);

var $aZLwC = parcelRequire("aZLwC");

var $kBs7x = parcelRequire("kBs7x");

var $7W5YA = parcelRequire("7W5YA");
parcelRequire("g3TU4");
var $aIGPP = parcelRequire("aIGPP");
parcelRequire("7CLZx");
var $l5xaL = parcelRequire("l5xaL");

var $1bh1r = parcelRequire("1bh1r");
const $04239cbad9f2bb12$export$3e0f51ae69c26797 = "/webrtc/signal";
function $04239cbad9f2bb12$export$c88efb7d88b738e7(peerId) {
    const conn = (0, $7W5YA.default).connections.get(peerId);
    (0, $kBs7x.default)(conn, `No such connection (id="${peerId}")`);
    return conn;
}

async function $04239cbad9f2bb12$export$63174c828edd6ff8(addr) {
    const [p2p, { default: sdk }] = await Promise.all([
        (0, $1bh1r.default)(addr),
        // Delayed import to avoid problems with circular dependencies.
        (parcelRequire("1TaNK"))
    ]);
    p2p.handle($04239cbad9f2bb12$export$3e0f51ae69c26797, async ({ connection: connection, stream: stream })=>{
        const mgr = await (0, $l5xaL.default).create({
            localId: (0, $7W5YA.default).p2p.peerId.toB58String(),
            remoteId: connection.remotePeer.toB58String(),
            signaler: (0, $aIGPP.default).from(stream)
        });
        (0, $7W5YA.default).connections.set(mgr.remoteId, mgr);
        sdk.connections.accept(mgr.remoteId);
    });
    await p2p.start();
    return {
        id: p2p.peerId.toB58String(),
        relayAddr: addr
    };
}
async function $04239cbad9f2bb12$export$65e66d587c664fab(addr) {
    (0, $kBs7x.default)((0, $7W5YA.default).p2p, "libp2p is not ready.");
    const connection = await (0, $7W5YA.default).p2p.dialProtocol(addr, $04239cbad9f2bb12$export$3e0f51ae69c26797);
    const mgr = await (0, $l5xaL.default).create({
        localId: (0, $7W5YA.default).p2p.peerId.toB58String(),
        remoteId: (0, $aZLwC.multiaddr)(addr).getPeerId(),
        signaler: (0, $aIGPP.default).from(connection.stream)
    });
    (0, $7W5YA.default).connections.set(mgr.remoteId, mgr);
    return {
        peerId: mgr.remoteId
    };
}
function $04239cbad9f2bb12$export$8360e631d277ea4d(peerId) {
    $04239cbad9f2bb12$export$c88efb7d88b738e7(peerId).close();
    (0, $7W5YA.default).connections.delete(peerId);
    return peerId;
}

});
parcelRequire.register("aZLwC", function(module, exports) {
"use strict";

var $5j4Si = parcelRequire("5j4Si");

var $eLYQN = parcelRequire("eLYQN");

var $b7PIr = parcelRequire("b7PIr");

var $1uqWk = parcelRequire("1uqWk");
var $80147765948ff6a6$require$CID = $1uqWk.CID;

var $fVtlC = parcelRequire("fVtlC");
var $80147765948ff6a6$require$base58btc = $fVtlC.base58btc;

var $20Lm5 = parcelRequire("20Lm5");
const $80147765948ff6a6$var$inspect = Symbol.for("nodejs.util.inspect.custom");

var $6rBCs = parcelRequire("6rBCs");
var $80147765948ff6a6$require$uint8ArrayToString = $6rBCs.toString;

var $ijWXY = parcelRequire("ijWXY");
var $80147765948ff6a6$require$uint8ArrayEquals = $ijWXY.equals;
/**
 * @typedef {(addr: Multiaddr) => Promise<string[]>} Resolver
 * @typedef {string | Multiaddr | Uint8Array | null} MultiaddrInput
 * @typedef {import('./types').MultiaddrObject} MultiaddrObject
 * @typedef {import('./types').Protocol} Protocol
 */ /** @type {Map<string, Resolver>} */ const $80147765948ff6a6$var$resolvers = new Map();
const $80147765948ff6a6$var$symbol = Symbol.for("@multiformats/js-multiaddr/multiaddr");
/**
 * Creates a [multiaddr](https://github.com/multiformats/multiaddr) from
 * a Uint8Array, String or another Multiaddr instance
 * public key.
 *
 */ class $80147765948ff6a6$var$Multiaddr {
    /**
   * @example
   * ```js
   * new Multiaddr('/ip4/127.0.0.1/tcp/4001')
   * // <Multiaddr 047f000001060fa1 - /ip4/127.0.0.1/tcp/4001>
   * ```
   *
   * @param {MultiaddrInput} [addr] - If String or Uint8Array, needs to adhere to the address format of a [multiaddr](https://github.com/multiformats/multiaddr#string-format)
   */ constructor(addr){
        // default
        if (addr == null) addr = "";
        // Define symbol
        Object.defineProperty(this, $80147765948ff6a6$var$symbol, {
            value: true
        });
        if (addr instanceof Uint8Array) /** @type {Uint8Array} - The raw bytes representing this multiaddress */ this.bytes = $5j4Si.fromBytes(addr);
        else if (typeof addr === "string") {
            if (addr.length > 0 && addr.charAt(0) !== "/") throw new Error(`multiaddr "${addr}" must start with a "/"`);
            this.bytes = $5j4Si.fromString(addr);
        } else if ($80147765948ff6a6$var$Multiaddr.isMultiaddr(addr)) this.bytes = $5j4Si.fromBytes(addr.bytes) // validate + copy buffer
        ;
        else throw new Error("addr must be a string, Buffer, or another Multiaddr");
    }
    /**
   * Returns Multiaddr as a String
   *
   * @example
   * ```js
   * new Multiaddr('/ip4/127.0.0.1/tcp/4001').toString()
   * // '/ip4/127.0.0.1/tcp/4001'
   * ```
   */ toString() {
        return $5j4Si.bytesToString(this.bytes);
    }
    /**
   * Returns Multiaddr as a JSON encoded object
   *
   * @example
   * ```js
   * JSON.stringify(new Multiaddr('/ip4/127.0.0.1/tcp/4001'))
   * // '/ip4/127.0.0.1/tcp/4001'
   * ```
   */ toJSON() {
        return this.toString();
    }
    /**
   * Returns Multiaddr as a convinient options object to be used with net.createConnection
   *
   * @example
   * ```js
   * new Multiaddr('/ip4/127.0.0.1/tcp/4001').toOptions()
   * // { family: 4, host: '127.0.0.1', transport: 'tcp', port: 4001 }
   * ```
   */ toOptions() {
        /** @type {MultiaddrObject} */ const opts = {};
        const parsed = this.toString().split("/");
        opts.family = parsed[1] === "ip4" ? 4 : 6;
        opts.host = parsed[2];
        opts.transport = parsed[3];
        opts.port = parseInt(parsed[4]);
        return opts;
    }
    /**
   * Returns the protocols the Multiaddr is defined with, as an array of objects, in
   * left-to-right order. Each object contains the protocol code, protocol name,
   * and the size of its address space in bits.
   * [See list of protocols](https://github.com/multiformats/multiaddr/blob/master/protocols.csv)
   *
   * @example
   * ```js
   * new Multiaddr('/ip4/127.0.0.1/tcp/4001').protos()
   * // [ { code: 4, size: 32, name: 'ip4' },
   * //   { code: 6, size: 16, name: 'tcp' } ]
   * ```
   *
   * @returns {Protocol[]} protocols - All the protocols the address is composed of
   */ protos() {
        return this.protoCodes().map((code)=>Object.assign({}, $eLYQN(code)));
    }
    /**
   * Returns the codes of the protocols in left-to-right order.
   * [See list of protocols](https://github.com/multiformats/multiaddr/blob/master/protocols.csv)
   *
   * @example
   * ```js
   * Multiaddr('/ip4/127.0.0.1/tcp/4001').protoCodes()
   * // [ 4, 6 ]
   * ```
   *
   * @returns {number[]} protocol codes
   */ protoCodes() {
        const codes = [];
        const buf = this.bytes;
        let i = 0;
        while(i < buf.length){
            const code = $b7PIr.decode(buf, i);
            const n = $b7PIr.decode.bytes;
            const p = $eLYQN(code);
            const size = $5j4Si.sizeForAddr(p, buf.slice(i + n));
            i += size + n;
            codes.push(code);
        }
        return codes;
    }
    /**
   * Returns the names of the protocols in left-to-right order.
   * [See list of protocols](https://github.com/multiformats/multiaddr/blob/master/protocols.csv)
   *
   * @example
   * ```js
   * new Multiaddr('/ip4/127.0.0.1/tcp/4001').protoNames()
   * // [ 'ip4', 'tcp' ]
   * ```
   *
   * @returns {string[]} protocol names
   */ protoNames() {
        return this.protos().map((proto)=>proto.name);
    }
    /**
   * Returns a tuple of parts
   *
   * @example
   * ```js
   * new Multiaddr("/ip4/127.0.0.1/tcp/4001").tuples()
   * // [ [ 4, <Buffer 7f 00 00 01> ], [ 6, <Buffer 0f a1> ] ]
   * ```
   */ tuples() {
        return $5j4Si.bytesToTuples(this.bytes);
    }
    /**
   * Returns a tuple of string/number parts
   * - tuples[][0] = code of protocol
   * - tuples[][1] = contents of address
   *
   * @example
   * ```js
   * new Multiaddr("/ip4/127.0.0.1/tcp/4001").stringTuples()
   * // [ [ 4, '127.0.0.1' ], [ 6, '4001' ] ]
   * ```
   */ stringTuples() {
        const t = $5j4Si.bytesToTuples(this.bytes);
        return $5j4Si.tuplesToStringTuples(t);
    }
    /**
   * Encapsulates a Multiaddr in another Multiaddr
   *
   * @example
   * ```js
   * const mh1 = new Multiaddr('/ip4/8.8.8.8/tcp/1080')
   * // <Multiaddr 0408080808060438 - /ip4/8.8.8.8/tcp/1080>
   *
   * const mh2 = new Multiaddr('/ip4/127.0.0.1/tcp/4001')
   * // <Multiaddr 047f000001060fa1 - /ip4/127.0.0.1/tcp/4001>
   *
   * const mh3 = mh1.encapsulate(mh2)
   * // <Multiaddr 0408080808060438047f000001060fa1 - /ip4/8.8.8.8/tcp/1080/ip4/127.0.0.1/tcp/4001>
   *
   * mh3.toString()
   * // '/ip4/8.8.8.8/tcp/1080/ip4/127.0.0.1/tcp/4001'
   * ```
   *
   * @param {MultiaddrInput} addr - Multiaddr to add into this Multiaddr
   */ encapsulate(addr) {
        addr = new $80147765948ff6a6$var$Multiaddr(addr);
        return new $80147765948ff6a6$var$Multiaddr(this.toString() + addr.toString());
    }
    /**
   * Decapsulates a Multiaddr from another Multiaddr
   *
   * @example
   * ```js
   * const mh1 = new Multiaddr('/ip4/8.8.8.8/tcp/1080')
   * // <Multiaddr 0408080808060438 - /ip4/8.8.8.8/tcp/1080>
   *
   * const mh2 = new Multiaddr('/ip4/127.0.0.1/tcp/4001')
   * // <Multiaddr 047f000001060fa1 - /ip4/127.0.0.1/tcp/4001>
   *
   * const mh3 = mh1.encapsulate(mh2)
   * // <Multiaddr 0408080808060438047f000001060fa1 - /ip4/8.8.8.8/tcp/1080/ip4/127.0.0.1/tcp/4001>
   *
   * mh3.decapsulate(mh2).toString()
   * // '/ip4/8.8.8.8/tcp/1080'
   * ```
   *
   * @param {Multiaddr | string} addr - Multiaddr to remove from this Multiaddr
   * @returns {Multiaddr}
   */ decapsulate(addr) {
        const addrString = addr.toString();
        const s = this.toString();
        const i = s.lastIndexOf(addrString);
        if (i < 0) throw new Error("Address " + this + " does not contain subaddress: " + addr);
        return new $80147765948ff6a6$var$Multiaddr(s.slice(0, i));
    }
    /**
   * A more reliable version of `decapsulate` if you are targeting a
   * specific code, such as 421 (the `p2p` protocol code). The last index of the code
   * will be removed from the `Multiaddr`, and a new instance will be returned.
   * If the code is not present, the original `Multiaddr` is returned.
   *
   * @example
   * ```js
   * const addr = new Multiaddr('/ip4/0.0.0.0/tcp/8080/p2p/QmcgpsyWgH8Y8ajJz1Cu72KnS5uo2Aa2LpzU7kinSupNKC')
   * // <Multiaddr 0400... - /ip4/0.0.0.0/tcp/8080/p2p/QmcgpsyWgH8Y8ajJz1Cu72KnS5uo2Aa2LpzU7kinSupNKC>
   *
   * addr.decapsulateCode(421).toString()
   * // '/ip4/0.0.0.0/tcp/8080'
   *
   * new Multiaddr('/ip4/127.0.0.1/tcp/8080').decapsulateCode(421).toString()
   * // '/ip4/127.0.0.1/tcp/8080'
   * ```
   *
   * @param {number} code - The code of the protocol to decapsulate from this Multiaddr
   * @returns {Multiaddr}
   */ decapsulateCode(code) {
        const tuples = this.tuples();
        for(let i = tuples.length - 1; i >= 0; i--){
            if (tuples[i][0] === code) return new $80147765948ff6a6$var$Multiaddr($5j4Si.tuplesToBytes(tuples.slice(0, i)));
        }
        return this;
    }
    /**
   * Extract the peerId if the multiaddr contains one
   *
   * @example
   * ```js
   * const mh1 = new Multiaddr('/ip4/8.8.8.8/tcp/1080/ipfs/QmValidBase58string')
   * // <Multiaddr 0408080808060438 - /ip4/8.8.8.8/tcp/1080/ipfs/QmValidBase58string>
   *
   * // should return QmValidBase58string or null if the id is missing or invalid
   * const peerId = mh1.getPeerId()
   * ```
   *
   * @returns {string | null} peerId - The id of the peer or null if invalid or missing from the ma
   */ getPeerId() {
        try {
            const tuples = this.stringTuples().filter((tuple)=>{
                if (tuple[0] === $eLYQN.names.ipfs.code) return true;
                return false;
            });
            // Get the last ipfs tuple ['ipfs', 'peerid string']
            const tuple = tuples.pop();
            if (tuple && tuple[1]) {
                const peerIdStr = tuple[1];
                // peer id is base58btc encoded string but not multibase encoded so add the `z`
                // prefix so we can validate that it is correctly encoded
                if (peerIdStr[0] === "Q" || peerIdStr[0] === "1") return $80147765948ff6a6$require$uint8ArrayToString($80147765948ff6a6$require$base58btc.decode(`z${peerIdStr}`), "base58btc");
                // try to parse peer id as CID
                return $80147765948ff6a6$require$uint8ArrayToString($80147765948ff6a6$require$CID.parse(peerIdStr).multihash.bytes, "base58btc");
            }
            return null;
        } catch (e) {
            return null;
        }
    }
    /**
   * Extract the path if the multiaddr contains one
   *
   * @example
   * ```js
   * const mh1 = new Multiaddr('/ip4/8.8.8.8/tcp/1080/unix/tmp/p2p.sock')
   * // <Multiaddr 0408080808060438 - /ip4/8.8.8.8/tcp/1080/unix/tmp/p2p.sock>
   *
   * // should return utf8 string or null if the id is missing or invalid
   * const path = mh1.getPath()
   * ```js
   *
   * @returns {string | null} path - The path of the multiaddr, or null if no path protocol is present
   */ getPath() {
        let path = null;
        try {
            path = this.stringTuples().filter((tuple)=>{
                const proto = $eLYQN(tuple[0]);
                if (proto.path) return true;
                return false;
            })[0][1];
            if (!path) path = null;
        } catch (e) {
            path = null;
        }
        return path;
    }
    /**
   * Checks if two Multiaddrs are the same
   *
   * @example
   * ```js
   * const mh1 = new Multiaddr('/ip4/8.8.8.8/tcp/1080')
   * // <Multiaddr 0408080808060438 - /ip4/8.8.8.8/tcp/1080>
   *
   * const mh2 = new Multiaddr('/ip4/127.0.0.1/tcp/4001')
   * // <Multiaddr 047f000001060fa1 - /ip4/127.0.0.1/tcp/4001>
   *
   * mh1.equals(mh1)
   * // true
   *
   * mh1.equals(mh2)
   * // false
   * ```
   *
   * @param {Multiaddr} addr
   * @returns {boolean}
   */ equals(addr) {
        return $80147765948ff6a6$require$uint8ArrayEquals(this.bytes, addr.bytes);
    }
    /**
   * Resolve multiaddr if containing resolvable hostname.
   *
   * @example
   * ```js
   * Multiaddr.resolvers.set('dnsaddr', resolverFunction)
   * const mh1 = new Multiaddr('/dnsaddr/bootstrap.libp2p.io/p2p/QmbLHAnMoJPWSCR5Zhtx6BHJX9KiKNN6tpvbUcqanj75Nb')
   * const resolvedMultiaddrs = await mh1.resolve()
   * // [
   * //   <Multiaddr 04934b5353060fa1a503221220c10f9319dac35c270a6b74cd644cb3acfc1f6efc8c821f8eb282599fd1814f64 - /ip4/147.75.83.83/tcp/4001/p2p/QmbLHAnMoJPWSCR5Zhtx6BHJX9KiKNN6tpvbUcqanj75Nb>,
   * //   <Multiaddr 04934b53530601bbde03a503221220c10f9319dac35c270a6b74cd644cb3acfc1f6efc8c821f8eb282599fd1814f64 - /ip4/147.75.83.83/tcp/443/wss/p2p/QmbLHAnMoJPWSCR5Zhtx6BHJX9KiKNN6tpvbUcqanj75Nb>,
   * //   <Multiaddr 04934b535391020fa1cc03a503221220c10f9319dac35c270a6b74cd644cb3acfc1f6efc8c821f8eb282599fd1814f64 - /ip4/147.75.83.83/udp/4001/quic/p2p/QmbLHAnMoJPWSCR5Zhtx6BHJX9KiKNN6tpvbUcqanj75Nb>
   * // ]
   * ```
   *
   * @returns {Promise<Array<Multiaddr>>}
   */ async resolve() {
        const resolvableProto = this.protos().find((p)=>p.resolvable);
        // Multiaddr is not resolvable?
        if (!resolvableProto) return [
            this
        ];
        const resolver = $80147765948ff6a6$var$resolvers.get(resolvableProto.name);
        if (!resolver) throw $20Lm5(new Error(`no available resolver for ${resolvableProto.name}`), "ERR_NO_AVAILABLE_RESOLVER");
        const addresses = await resolver(this);
        return addresses.map((a)=>new $80147765948ff6a6$var$Multiaddr(a));
    }
    /**
   * Gets a Multiaddrs node-friendly address object. Note that protocol information
   * is left out: in Node (and most network systems) the protocol is unknowable
   * given only the address.
   *
   * Has to be a ThinWaist Address, otherwise throws error
   *
   * @example
   * ```js
   * new Multiaddr('/ip4/127.0.0.1/tcp/4001').nodeAddress()
   * // {family: 4, address: '127.0.0.1', port: 4001}
   * ```
   *
   * @returns {{family: 4 | 6, address: string, port: number}}
   * @throws {Error} Throws error if Multiaddr is not a Thin Waist address
   */ nodeAddress() {
        const codes = this.protoCodes();
        const names = this.protoNames();
        const parts = this.toString().split("/").slice(1);
        if (parts.length < 4) throw new Error('multiaddr must have a valid format: "/{ip4, ip6, dns4, dns6}/{address}/{tcp, udp}/{port}".');
        else if (codes[0] !== 4 && codes[0] !== 41 && codes[0] !== 54 && codes[0] !== 55) throw new Error(`no protocol with name: "'${names[0]}'". Must have a valid family name: "{ip4, ip6, dns4, dns6}".`);
        else if (parts[2] !== "tcp" && parts[2] !== "udp") throw new Error(`no protocol with name: "'${names[1]}'". Must have a valid transport protocol: "{tcp, udp}".`);
        return {
            family: codes[0] === 41 || codes[0] === 55 ? 6 : 4,
            address: parts[1],
            port: parseInt(parts[3]) // tcp or udp port
        };
    }
    /**
   * Returns if a Multiaddr is a Thin Waist address or not.
   *
   * Thin Waist is if a Multiaddr adheres to the standard combination of:
   *
   * `{IPv4, IPv6}/{TCP, UDP}`
   *
   * @example
   * ```js
   * const mh1 = new Multiaddr('/ip4/127.0.0.1/tcp/4001')
   * // <Multiaddr 047f000001060fa1 - /ip4/127.0.0.1/tcp/4001>
   * const mh2 = new Multiaddr('/ip4/192.168.2.1/tcp/5001')
   * // <Multiaddr 04c0a80201061389 - /ip4/192.168.2.1/tcp/5001>
   * const mh3 = mh1.encapsulate(mh2)
   * // <Multiaddr 047f000001060fa104c0a80201061389 - /ip4/127.0.0.1/tcp/4001/ip4/192.168.2.1/tcp/5001>
   * const mh4 = new Multiaddr('/ip4/127.0.0.1/tcp/2000/wss/p2p-webrtc-star/p2p/QmcgpsyWgH8Y8ajJz1Cu72KnS5uo2Aa2LpzU7kinSooo2a')
   * // <Multiaddr 047f0000010607d0de039302a503221220d52ebb89d85b02a284948203a62ff28389c57c9f42beec4ec20db76a64835843 - /ip4/127.0.0.1/tcp/2000/wss/p2p-webrtc-star/p2p/QmcgpsyWgH8Y8ajJz1Cu72KnS5uo2Aa2LpzU7kinSooo2a>
   * mh1.isThinWaistAddress()
   * // true
   * mh2.isThinWaistAddress()
   * // true
   * mh3.isThinWaistAddress()
   * // false
   * mh4.isThinWaistAddress()
   * // false
   * ```
   *
   * @param {Multiaddr} [addr] - Defaults to using `this` instance
   */ isThinWaistAddress(addr) {
        const protos = (addr || this).protos();
        if (protos.length !== 2) return false;
        if (protos[0].code !== 4 && protos[0].code !== 41) return false;
        if (protos[1].code !== 6 && protos[1].code !== 273) return false;
        return true;
    }
    /**
   * Creates a Multiaddr from a node-friendly address object
   *
   * @example
   * ```js
   * Multiaddr.fromNodeAddress({address: '127.0.0.1', port: '4001'}, 'tcp')
   * // <Multiaddr 047f000001060fa1 - /ip4/127.0.0.1/tcp/4001>
   * ```
   *
   * @param {{family: 4 | 6, address: string, port: number}} addr
   * @param {string} transport
   */ static fromNodeAddress(addr, transport) {
        if (!addr) throw new Error("requires node address object");
        if (!transport) throw new Error("requires transport protocol");
        let ip;
        switch(addr.family){
            case 4:
                ip = "ip4";
                break;
            case 6:
                ip = "ip6";
                break;
            default:
                throw Error(`Invalid addr family. Got '${addr.family}' instead of 4 or 6`);
        }
        return new $80147765948ff6a6$var$Multiaddr("/" + [
            ip,
            addr.address,
            transport,
            addr.port
        ].join("/"));
    }
    /**
   * Returns if something is a Multiaddr that is a name
   *
   * @param {Multiaddr} addr
   * @returns {boolean} isName
   */ static isName(addr) {
        if (!$80147765948ff6a6$var$Multiaddr.isMultiaddr(addr)) return false;
        // if a part of the multiaddr is resolvable, then return true
        return addr.protos().some((proto)=>proto.resolvable);
    }
    /**
   * Check if object is a CID instance
   *
   * @param {any} value
   * @returns {value is Multiaddr}
   */ static isMultiaddr(value) {
        return value instanceof $80147765948ff6a6$var$Multiaddr || Boolean(value && value[$80147765948ff6a6$var$symbol]);
    }
    /**
   * Returns Multiaddr as a human-readable string.
   * For post Node.js v10.0.0.
   * https://nodejs.org/api/deprecations.html#deprecations_dep0079_custom_inspection_function_on_objects_via_inspect
   *
   * @example
   * ```js
   * console.log(new Multiaddr('/ip4/127.0.0.1/tcp/4001'))
   * // '<Multiaddr 047f000001060fa1 - /ip4/127.0.0.1/tcp/4001>'
   * ```
   *
   * @returns {string}
   */ [$80147765948ff6a6$var$inspect]() {
        return "<Multiaddr " + $80147765948ff6a6$require$uint8ArrayToString(this.bytes, "base16") + " - " + $5j4Si.bytesToString(this.bytes) + ">";
    }
    /**
   * Returns Multiaddr as a human-readable string.
   * Fallback for pre Node.js v10.0.0.
   * https://nodejs.org/api/deprecations.html#deprecations_dep0079_custom_inspection_function_on_objects_via_inspect
   *
   * @example
   * ```js
   * new Multiaddr('/ip4/127.0.0.1/tcp/4001').inspect()
   * // '<Multiaddr 047f000001060fa1 - /ip4/127.0.0.1/tcp/4001>'
   * ```
   *
   * @returns {string}
   */ inspect() {
        return "<Multiaddr " + $80147765948ff6a6$require$uint8ArrayToString(this.bytes, "base16") + " - " + $5j4Si.bytesToString(this.bytes) + ">";
    }
}
/**
 * Object containing table, names and codes of all supported protocols.
 * To get the protocol values from a Multiaddr, you can use
 * [`.protos()`](#multiaddrprotos),
 * [`.protoCodes()`](#multiaddrprotocodes) or
 * [`.protoNames()`](#multiaddrprotonames)
 *
 * @returns {{table: Array, names: Object, codes: Object}}
 */ $80147765948ff6a6$var$Multiaddr.protocols = $eLYQN;
$80147765948ff6a6$var$Multiaddr.resolvers = $80147765948ff6a6$var$resolvers;
/**
 * Static factory
 *
 * @param {MultiaddrInput} addr
 */ function $80147765948ff6a6$var$multiaddr(addr) {
    return new $80147765948ff6a6$var$Multiaddr(addr);
}
module.exports = {
    Multiaddr: $80147765948ff6a6$var$Multiaddr,
    multiaddr: $80147765948ff6a6$var$multiaddr,
    protocols: $eLYQN,
    resolvers: $80147765948ff6a6$var$resolvers
};

});
parcelRequire.register("5j4Si", function(module, exports) {
"use strict";

var $5a2W6 = parcelRequire("5a2W6");

var $eLYQN = parcelRequire("eLYQN");

var $b7PIr = parcelRequire("b7PIr");

var $8hEBV = parcelRequire("8hEBV");
var $3dd2821e2f51c592$require$uint8ArrayConcat = $8hEBV.concat;

var $6rBCs = parcelRequire("6rBCs");
var $3dd2821e2f51c592$require$uint8ArrayToString = $6rBCs.toString;
// export codec
module.exports = {
    stringToStringTuples: $3dd2821e2f51c592$var$stringToStringTuples,
    stringTuplesToString: $3dd2821e2f51c592$var$stringTuplesToString,
    tuplesToStringTuples: $3dd2821e2f51c592$var$tuplesToStringTuples,
    stringTuplesToTuples: $3dd2821e2f51c592$var$stringTuplesToTuples,
    bytesToTuples: $3dd2821e2f51c592$var$bytesToTuples,
    tuplesToBytes: $3dd2821e2f51c592$var$tuplesToBytes,
    bytesToString: $3dd2821e2f51c592$var$bytesToString,
    stringToBytes: $3dd2821e2f51c592$var$stringToBytes,
    fromString: $3dd2821e2f51c592$var$fromString,
    fromBytes: $3dd2821e2f51c592$var$fromBytes,
    validateBytes: $3dd2821e2f51c592$var$validateBytes,
    isValidBytes: $3dd2821e2f51c592$var$isValidBytes,
    cleanPath: $3dd2821e2f51c592$var$cleanPath,
    ParseError: $3dd2821e2f51c592$var$ParseError,
    protoFromTuple: $3dd2821e2f51c592$var$protoFromTuple,
    sizeForAddr: $3dd2821e2f51c592$var$sizeForAddr
};
// string -> [[str name, str addr]... ]
/**
 * @param {string} str
 */ function $3dd2821e2f51c592$var$stringToStringTuples(str) {
    const tuples = [];
    const parts = str.split("/").slice(1) // skip first empty elem
    ;
    if (parts.length === 1 && parts[0] === "") return [];
    for(let p = 0; p < parts.length; p++){
        const part = parts[p];
        const proto = $eLYQN(part);
        if (proto.size === 0) {
            tuples.push([
                part
            ]);
            continue;
        }
        p++ // advance addr part
        ;
        if (p >= parts.length) throw $3dd2821e2f51c592$var$ParseError("invalid address: " + str);
        // if it's a path proto, take the rest
        if (proto.path) {
            tuples.push([
                part,
                // TODO: should we need to check each path part to see if it's a proto?
                // This would allow for other protocols to be added after a unix path,
                // however it would have issues if the path had a protocol name in the path
                $3dd2821e2f51c592$var$cleanPath(parts.slice(p).join("/"))
            ]);
            break;
        }
        tuples.push([
            part,
            parts[p]
        ]);
    }
    return tuples;
}
// [[str name, str addr]... ] -> string
/**
 * @param {[number, string?][]} tuples
 */ function $3dd2821e2f51c592$var$stringTuplesToString(tuples) {
    /** @type {Array<string | undefined>} */ const parts = [];
    tuples.map((tup)=>{
        const proto = $3dd2821e2f51c592$var$protoFromTuple(tup);
        parts.push(proto.name);
        if (tup.length > 1) parts.push(tup[1]);
        return null;
    });
    return $3dd2821e2f51c592$var$cleanPath(parts.join("/"));
}
// [[str name, str addr]... ] -> [[int code, Uint8Array]... ]
/**
 * @param {Array<string[] | string >} tuples
 * @returns {[number , Uint8Array?][]}
 */ function $3dd2821e2f51c592$var$stringTuplesToTuples(tuples) {
    return tuples.map((tup)=>{
        if (!Array.isArray(tup)) tup = [
            tup
        ];
        const proto = $3dd2821e2f51c592$var$protoFromTuple(tup);
        if (tup.length > 1) return [
            proto.code,
            $5a2W6.toBytes(proto.code, tup[1])
        ];
        return [
            proto.code
        ];
    });
}
/**
 * Convert tuples to string tuples
 *
 * [[int code, Uint8Array]... ] -> [[int code, str addr]... ]
 *
 * @param {Array<[number, Uint8Array?]>} tuples
 * @returns {Array<[number, string?]>}
 */ function $3dd2821e2f51c592$var$tuplesToStringTuples(tuples) {
    return tuples.map((tup)=>{
        const proto = $3dd2821e2f51c592$var$protoFromTuple(tup);
        if (tup[1]) return [
            proto.code,
            $5a2W6.toString(proto.code, tup[1])
        ];
        return [
            proto.code
        ];
    });
}
// [[int code, Uint8Array ]... ] -> Uint8Array
/**
 * @param {[number, Uint8Array?][]} tuples
 */ function $3dd2821e2f51c592$var$tuplesToBytes(tuples) {
    return $3dd2821e2f51c592$var$fromBytes($3dd2821e2f51c592$require$uint8ArrayConcat(tuples.map((/** @type {any[]} */ tup)=>{
        const proto = $3dd2821e2f51c592$var$protoFromTuple(tup);
        let buf = Uint8Array.from($b7PIr.encode(proto.code));
        if (tup.length > 1) buf = $3dd2821e2f51c592$require$uint8ArrayConcat([
            buf,
            tup[1]
        ]) // add address buffer
        ;
        return buf;
    })));
}
/**
 * @param {import("./types").Protocol} p
 * @param {Uint8Array | number[]} addr
 */ function $3dd2821e2f51c592$var$sizeForAddr(p, addr) {
    if (p.size > 0) return p.size / 8;
    else if (p.size === 0) return 0;
    else {
        const size = $b7PIr.decode(addr);
        return size + $b7PIr.decode.bytes;
    }
}
/**
 *
 * @param {Uint8Array} buf
 * @returns {Array<[number, Uint8Array?]>}
 */ function $3dd2821e2f51c592$var$bytesToTuples(buf) {
    /** @type {Array<[number, Uint8Array?]>} */ const tuples = [];
    let i = 0;
    while(i < buf.length){
        const code = $b7PIr.decode(buf, i);
        const n = $b7PIr.decode.bytes;
        const p = $eLYQN(code);
        const size = $3dd2821e2f51c592$var$sizeForAddr(p, buf.slice(i + n));
        if (size === 0) {
            tuples.push([
                code
            ]);
            i += n;
            continue;
        }
        const addr = buf.slice(i + n, i + n + size);
        i += size + n;
        if (i > buf.length) throw $3dd2821e2f51c592$var$ParseError("Invalid address Uint8Array: " + $3dd2821e2f51c592$require$uint8ArrayToString(buf, "base16"));
        // ok, tuple seems good.
        tuples.push([
            code,
            addr
        ]);
    }
    return tuples;
}
// Uint8Array -> String
/**
 * @param {Uint8Array} buf
 */ function $3dd2821e2f51c592$var$bytesToString(buf) {
    const a = $3dd2821e2f51c592$var$bytesToTuples(buf);
    const b = $3dd2821e2f51c592$var$tuplesToStringTuples(a);
    return $3dd2821e2f51c592$var$stringTuplesToString(b);
}
// String -> Uint8Array
/**
 * @param {string} str
 */ function $3dd2821e2f51c592$var$stringToBytes(str) {
    str = $3dd2821e2f51c592$var$cleanPath(str);
    const a = $3dd2821e2f51c592$var$stringToStringTuples(str);
    const b = $3dd2821e2f51c592$var$stringTuplesToTuples(a);
    return $3dd2821e2f51c592$var$tuplesToBytes(b);
}
// String -> Uint8Array
/**
 * @param {string} str
 */ function $3dd2821e2f51c592$var$fromString(str) {
    return $3dd2821e2f51c592$var$stringToBytes(str);
}
// Uint8Array -> Uint8Array
/**
 * @param {Uint8Array} buf
 */ function $3dd2821e2f51c592$var$fromBytes(buf) {
    const err = $3dd2821e2f51c592$var$validateBytes(buf);
    if (err) throw err;
    return Uint8Array.from(buf) // copy
    ;
}
/**
 * @param {Uint8Array} buf
 */ function $3dd2821e2f51c592$var$validateBytes(buf) {
    try {
        $3dd2821e2f51c592$var$bytesToTuples(buf) // try to parse. will throw if breaks
        ;
    } catch (err) {
        return err;
    }
}
/**
 * @param {Uint8Array} buf
 */ function $3dd2821e2f51c592$var$isValidBytes(buf) {
    return $3dd2821e2f51c592$var$validateBytes(buf) === undefined;
}
/**
 * @param {string} str
 */ function $3dd2821e2f51c592$var$cleanPath(str) {
    return "/" + str.trim().split("/").filter((/** @type {any} */ a)=>a).join("/");
}
/**
 * @param {string} str
 */ function $3dd2821e2f51c592$var$ParseError(str) {
    return new Error("Error parsing address: " + str);
}
/**
 * @param {any[]} tup
 */ function $3dd2821e2f51c592$var$protoFromTuple(tup) {
    const proto = $eLYQN(tup[0]);
    return proto;
}

});
parcelRequire.register("5a2W6", function(module, exports) {
"use strict";

var $h1eaq = parcelRequire("h1eaq");

var $eLYQN = parcelRequire("eLYQN");

var $1uqWk = parcelRequire("1uqWk");
var $3c2029f91b329f1b$require$CID = $1uqWk.CID;

var $5LC6A = parcelRequire("5LC6A");
var $3c2029f91b329f1b$require$base32 = $5LC6A.base32;

var $fVtlC = parcelRequire("fVtlC");
var $3c2029f91b329f1b$require$base58btc = $fVtlC.base58btc;

var $3gYLQ = parcelRequire("3gYLQ");

var $b7PIr = parcelRequire("b7PIr");

var $6rBCs = parcelRequire("6rBCs");
var $3c2029f91b329f1b$require$uint8ArrayToString = $6rBCs.toString;

var $8cWjP = parcelRequire("8cWjP");
var $3c2029f91b329f1b$require$uint8ArrayFromString = $8cWjP.fromString;

var $8hEBV = parcelRequire("8hEBV");
var $3c2029f91b329f1b$require$uint8ArrayConcat = $8hEBV.concat;
module.exports = $3c2029f91b329f1b$var$Convert;
// converts (serializes) addresses
/**
 * @param {string} proto
 * @param {string | Uint8Array} a
 */ function $3c2029f91b329f1b$var$Convert(proto, a) {
    if (a instanceof Uint8Array) return $3c2029f91b329f1b$var$Convert.toString(proto, a);
    else return $3c2029f91b329f1b$var$Convert.toBytes(proto, a);
}
/**
 * Convert [code,Uint8Array] to string
 *
 * @param {number|string} proto
 * @param {Uint8Array} buf
 * @returns {string}
 */ $3c2029f91b329f1b$var$Convert.toString = function convertToString(proto, buf) {
    const protocol = $eLYQN(proto);
    switch(protocol.code){
        case 4:
        case 41:
            return $3c2029f91b329f1b$var$bytes2ip(buf);
        case 6:
        case 273:
        case 33:
        case 132:
            return $3c2029f91b329f1b$var$bytes2port(buf).toString();
        case 53:
        case 54:
        case 55:
        case 56:
        case 400:
        case 777:
            return $3c2029f91b329f1b$var$bytes2str(buf);
        case 421:
            return $3c2029f91b329f1b$var$bytes2mh(buf);
        case 444:
            return $3c2029f91b329f1b$var$bytes2onion(buf);
        case 445:
            return $3c2029f91b329f1b$var$bytes2onion(buf);
        default:
            return $3c2029f91b329f1b$require$uint8ArrayToString(buf, "base16") // no clue. convert to hex
            ;
    }
};
$3c2029f91b329f1b$var$Convert.toBytes = function convertToBytes(/** @type {string | number } */ proto, /** @type {string} */ str) {
    const protocol = $eLYQN(proto);
    switch(protocol.code){
        case 4:
            return $3c2029f91b329f1b$var$ip2bytes(str);
        case 41:
            return $3c2029f91b329f1b$var$ip2bytes(str);
        case 6:
        case 273:
        case 33:
        case 132:
            return $3c2029f91b329f1b$var$port2bytes(parseInt(str, 10));
        case 53:
        case 54:
        case 55:
        case 56:
        case 400:
        case 777:
            return $3c2029f91b329f1b$var$str2bytes(str);
        case 421:
            return $3c2029f91b329f1b$var$mh2bytes(str);
        case 444:
            return $3c2029f91b329f1b$var$onion2bytes(str);
        case 445:
            return $3c2029f91b329f1b$var$onion32bytes(str);
        default:
            return $3c2029f91b329f1b$require$uint8ArrayFromString(str, "base16") // no clue. convert from hex
            ;
    }
};
/**
 * @param {string} ipString
 */ function $3c2029f91b329f1b$var$ip2bytes(ipString) {
    if (!$h1eaq.isIP(ipString)) throw new Error("invalid ip address");
    return $h1eaq.toBytes(ipString);
}
/**
 * @param {Uint8Array} ipBuff
 */ function $3c2029f91b329f1b$var$bytes2ip(ipBuff) {
    const ipString = $h1eaq.toString(ipBuff);
    if (!ipString || !$h1eaq.isIP(ipString)) throw new Error("invalid ip address");
    return ipString;
}
/**
 * @param {number} port
 */ function $3c2029f91b329f1b$var$port2bytes(port) {
    const buf = new ArrayBuffer(2);
    const view = new DataView(buf);
    view.setUint16(0, port);
    return new Uint8Array(buf);
}
/**
 * @param {Uint8Array} buf
 */ function $3c2029f91b329f1b$var$bytes2port(buf) {
    const view = new DataView(buf.buffer);
    return view.getUint16(buf.byteOffset);
}
/**
 * @param {string} str
 */ function $3c2029f91b329f1b$var$str2bytes(str) {
    const buf = $3c2029f91b329f1b$require$uint8ArrayFromString(str);
    const size = Uint8Array.from($b7PIr.encode(buf.length));
    return $3c2029f91b329f1b$require$uint8ArrayConcat([
        size,
        buf
    ], size.length + buf.length);
}
/**
 * @param {Uint8Array} buf
 */ function $3c2029f91b329f1b$var$bytes2str(buf) {
    const size = $b7PIr.decode(buf);
    buf = buf.slice($b7PIr.decode.bytes);
    if (buf.length !== size) throw new Error("inconsistent lengths");
    return $3c2029f91b329f1b$require$uint8ArrayToString(buf);
}
/**
 * @param {string} hash - base58btc string
 */ function $3c2029f91b329f1b$var$mh2bytes(hash) {
    let mh;
    if (hash[0] === "Q" || hash[0] === "1") mh = $3gYLQ.decode($3c2029f91b329f1b$require$base58btc.decode(`z${hash}`)).bytes;
    else mh = $3c2029f91b329f1b$require$CID.parse(hash).multihash.bytes;
    // the address is a varint prefixed multihash string representation
    const size = Uint8Array.from($b7PIr.encode(mh.length));
    return $3c2029f91b329f1b$require$uint8ArrayConcat([
        size,
        mh
    ], size.length + mh.length);
}
/**
 * Converts bytes to bas58btc string
 *
 * @param {Uint8Array} buf
 * @returns {string} base58btc string
 */ function $3c2029f91b329f1b$var$bytes2mh(buf) {
    const size = $b7PIr.decode(buf);
    const address = buf.slice($b7PIr.decode.bytes);
    if (address.length !== size) throw new Error("inconsistent lengths");
    return $3c2029f91b329f1b$require$uint8ArrayToString(address, "base58btc");
}
/**
 * @param {string} str
 */ function $3c2029f91b329f1b$var$onion2bytes(str) {
    const addr = str.split(":");
    if (addr.length !== 2) throw new Error("failed to parse onion addr: " + addr + " does not contain a port number");
    if (addr[0].length !== 16) throw new Error("failed to parse onion addr: " + addr[0] + " not a Tor onion address.");
    // onion addresses do not include the multibase prefix, add it before decoding
    const buf = $3c2029f91b329f1b$require$base32.decode("b" + addr[0]);
    // onion port number
    const port = parseInt(addr[1], 10);
    if (port < 1 || port > 65536) throw new Error("Port number is not in range(1, 65536)");
    const portBuf = $3c2029f91b329f1b$var$port2bytes(port);
    return $3c2029f91b329f1b$require$uint8ArrayConcat([
        buf,
        portBuf
    ], buf.length + portBuf.length);
}
/**
 * @param {string} str
 */ function $3c2029f91b329f1b$var$onion32bytes(str) {
    const addr = str.split(":");
    if (addr.length !== 2) throw new Error("failed to parse onion addr: " + addr + " does not contain a port number");
    if (addr[0].length !== 56) throw new Error("failed to parse onion addr: " + addr[0] + " not a Tor onion3 address.");
    // onion addresses do not include the multibase prefix, add it before decoding
    const buf = $3c2029f91b329f1b$require$base32.decode("b" + addr[0]);
    // onion port number
    const port = parseInt(addr[1], 10);
    if (port < 1 || port > 65536) throw new Error("Port number is not in range(1, 65536)");
    const portBuf = $3c2029f91b329f1b$var$port2bytes(port);
    return $3c2029f91b329f1b$require$uint8ArrayConcat([
        buf,
        portBuf
    ], buf.length + portBuf.length);
}
/**
 * @param {Uint8Array} buf
 */ function $3c2029f91b329f1b$var$bytes2onion(buf) {
    const addrBytes = buf.slice(0, buf.length - 2);
    const portBytes = buf.slice(buf.length - 2);
    const addr = $3c2029f91b329f1b$require$uint8ArrayToString(addrBytes, "base32");
    const port = $3c2029f91b329f1b$var$bytes2port(portBytes);
    return addr + ":" + port;
}

});
parcelRequire.register("h1eaq", function(module, exports) {
"use strict";

var $glIOy = parcelRequire("glIOy");

var $6rBCs = parcelRequire("6rBCs");
var $c63d84fb44891490$require$uint8ArrayToString = $6rBCs.toString;
const $c63d84fb44891490$var$isIP = $glIOy;
const $c63d84fb44891490$var$isV4 = $glIOy.v4;
const $c63d84fb44891490$var$isV6 = $glIOy.v6;
// Copied from https://github.com/indutny/node-ip/blob/master/lib/ip.js#L7
// @ts-ignore - this is copied from the link above better to keep it the same
const $c63d84fb44891490$var$toBytes = function(ip, buff, offset) {
    offset = ~~offset;
    let result;
    if ($c63d84fb44891490$var$isV4(ip)) {
        result = buff || new Uint8Array(offset + 4);
        // @ts-ignore
        // eslint-disable-next-line array-callback-return
        ip.split(/\./g).map(function(byte) {
            result[offset++] = parseInt(byte, 10) & 0xff;
        });
    } else if ($c63d84fb44891490$var$isV6(ip)) {
        const sections = ip.split(":", 8);
        let i;
        for(i = 0; i < sections.length; i++){
            const isv4 = $c63d84fb44891490$var$isV4(sections[i]);
            let v4Buffer;
            if (isv4) {
                v4Buffer = $c63d84fb44891490$var$toBytes(sections[i]);
                sections[i] = $c63d84fb44891490$require$uint8ArrayToString(v4Buffer.slice(0, 2), "base16");
            }
            if (v4Buffer && ++i < 8) sections.splice(i, 0, $c63d84fb44891490$require$uint8ArrayToString(v4Buffer.slice(2, 4), "base16"));
        }
        if (sections[0] === "") while(sections.length < 8)sections.unshift("0");
        else if (sections[sections.length - 1] === "") while(sections.length < 8)sections.push("0");
        else if (sections.length < 8) {
            for(i = 0; i < sections.length && sections[i] !== ""; i++);
            const argv = [
                i,
                "1"
            ];
            for(i = 9 - sections.length; i > 0; i--)argv.push("0");
            sections.splice.apply(sections, argv);
        }
        result = buff || new Uint8Array(offset + 16);
        for(i = 0; i < sections.length; i++){
            const word = parseInt(sections[i], 16);
            result[offset++] = word >> 8 & 0xff;
            result[offset++] = word & 0xff;
        }
    }
    if (!result) throw Error("Invalid ip address: " + ip);
    return result;
};
// Copied from https://github.com/indutny/node-ip/blob/master/lib/ip.js#L63
// @ts-ignore - this is copied from the link above better to keep it the same
const $c63d84fb44891490$var$toString = function(buff, offset, length) {
    offset = ~~offset;
    length = length || buff.length - offset;
    const result = [];
    let string;
    const view = new DataView(buff.buffer);
    if (length === 4) {
        // IPv4
        for(let i = 0; i < length; i++)result.push(buff[offset + i]);
        string = result.join(".");
    } else if (length === 16) {
        // IPv6
        for(let i = 0; i < length; i += 2)result.push(view.getUint16(offset + i).toString(16));
        string = result.join(":");
        string = string.replace(/(^|:)0(:0)*:0(:|$)/, "$1::$3");
        string = string.replace(/:{3,4}/, "::");
    }
    return string;
};
module.exports = {
    isIP: $c63d84fb44891490$var$isIP,
    isV4: $c63d84fb44891490$var$isV4,
    isV6: $c63d84fb44891490$var$isV6,
    toBytes: $c63d84fb44891490$var$toBytes,
    toString: $c63d84fb44891490$var$toString
};

});
parcelRequire.register("glIOy", function(module, exports) {
"use strict";

var $fpA8v = parcelRequire("fpA8v");
const $be715eb6d3c5fa02$var$isIp = (string)=>$fpA8v({
        exact: true
    }).test(string);
$be715eb6d3c5fa02$var$isIp.v4 = (string)=>$fpA8v.v4({
        exact: true
    }).test(string);
$be715eb6d3c5fa02$var$isIp.v6 = (string)=>$fpA8v.v6({
        exact: true
    }).test(string);
$be715eb6d3c5fa02$var$isIp.version = (string)=>$be715eb6d3c5fa02$var$isIp(string) ? $be715eb6d3c5fa02$var$isIp.v4(string) ? 4 : 6 : undefined;
module.exports = $be715eb6d3c5fa02$var$isIp;

});
parcelRequire.register("fpA8v", function(module, exports) {
"use strict";
const $b38538b7e600eeae$var$word = "[a-fA-F\\d:]";
const $b38538b7e600eeae$var$b = (options)=>options && options.includeBoundaries ? `(?:(?<=\\s|^)(?=${$b38538b7e600eeae$var$word})|(?<=${$b38538b7e600eeae$var$word})(?=\\s|$))` : "";
const $b38538b7e600eeae$var$v4 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
const $b38538b7e600eeae$var$v6seg = "[a-fA-F\\d]{1,4}";
const $b38538b7e600eeae$var$v6 = `
(?:
(?:${$b38538b7e600eeae$var$v6seg}:){7}(?:${$b38538b7e600eeae$var$v6seg}|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:${$b38538b7e600eeae$var$v6seg}:){6}(?:${$b38538b7e600eeae$var$v4}|:${$b38538b7e600eeae$var$v6seg}|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:${$b38538b7e600eeae$var$v6seg}:){5}(?::${$b38538b7e600eeae$var$v4}|(?::${$b38538b7e600eeae$var$v6seg}){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:${$b38538b7e600eeae$var$v6seg}:){4}(?:(?::${$b38538b7e600eeae$var$v6seg}){0,1}:${$b38538b7e600eeae$var$v4}|(?::${$b38538b7e600eeae$var$v6seg}){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:${$b38538b7e600eeae$var$v6seg}:){3}(?:(?::${$b38538b7e600eeae$var$v6seg}){0,2}:${$b38538b7e600eeae$var$v4}|(?::${$b38538b7e600eeae$var$v6seg}){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:${$b38538b7e600eeae$var$v6seg}:){2}(?:(?::${$b38538b7e600eeae$var$v6seg}){0,3}:${$b38538b7e600eeae$var$v4}|(?::${$b38538b7e600eeae$var$v6seg}){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:${$b38538b7e600eeae$var$v6seg}:){1}(?:(?::${$b38538b7e600eeae$var$v6seg}){0,4}:${$b38538b7e600eeae$var$v4}|(?::${$b38538b7e600eeae$var$v6seg}){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::${$b38538b7e600eeae$var$v6seg}){0,5}:${$b38538b7e600eeae$var$v4}|(?::${$b38538b7e600eeae$var$v6seg}){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`.replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim();
// Pre-compile only the exact regexes because adding a global flag make regexes stateful
const $b38538b7e600eeae$var$v46Exact = new RegExp(`(?:^${$b38538b7e600eeae$var$v4}$)|(?:^${$b38538b7e600eeae$var$v6}$)`);
const $b38538b7e600eeae$var$v4exact = new RegExp(`^${$b38538b7e600eeae$var$v4}$`);
const $b38538b7e600eeae$var$v6exact = new RegExp(`^${$b38538b7e600eeae$var$v6}$`);
const $b38538b7e600eeae$var$ip = (options)=>options && options.exact ? $b38538b7e600eeae$var$v46Exact : new RegExp(`(?:${$b38538b7e600eeae$var$b(options)}${$b38538b7e600eeae$var$v4}${$b38538b7e600eeae$var$b(options)})|(?:${$b38538b7e600eeae$var$b(options)}${$b38538b7e600eeae$var$v6}${$b38538b7e600eeae$var$b(options)})`, "g");
$b38538b7e600eeae$var$ip.v4 = (options)=>options && options.exact ? $b38538b7e600eeae$var$v4exact : new RegExp(`${$b38538b7e600eeae$var$b(options)}${$b38538b7e600eeae$var$v4}${$b38538b7e600eeae$var$b(options)}`, "g");
$b38538b7e600eeae$var$ip.v6 = (options)=>options && options.exact ? $b38538b7e600eeae$var$v6exact : new RegExp(`${$b38538b7e600eeae$var$b(options)}${$b38538b7e600eeae$var$v6}${$b38538b7e600eeae$var$b(options)}`, "g");
module.exports = $b38538b7e600eeae$var$ip;

});


parcelRequire.register("6rBCs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2aboO = parcelRequire("2aboO");
function $4b127217d01a6830$var$toString(array, encoding = "utf8") {
    const base = $2aboO[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString("utf8");
    return base.encoder.encode(array).substring(1);
}
module.exports.toString = $4b127217d01a6830$var$toString;

});
parcelRequire.register("2aboO", function(module, exports) {
"use strict";

var $RyFKX = parcelRequire("RyFKX");

var $hHtcy = parcelRequire("hHtcy");
function $19355b96b5cbc004$var$createCodec(name, prefix, encode, decode) {
    return {
        name: name,
        prefix: prefix,
        encoder: {
            name: name,
            prefix: prefix,
            encode: encode
        },
        decoder: {
            decode: decode
        }
    };
}
const $19355b96b5cbc004$var$string = $19355b96b5cbc004$var$createCodec("utf8", "u", (buf)=>{
    const decoder = new TextDecoder("utf8");
    return "u" + decoder.decode(buf);
}, (str)=>{
    const encoder = new TextEncoder();
    return encoder.encode(str.substring(1));
});
const $19355b96b5cbc004$var$ascii = $19355b96b5cbc004$var$createCodec("ascii", "a", (buf)=>{
    let string = "a";
    for(let i = 0; i < buf.length; i++)string += String.fromCharCode(buf[i]);
    return string;
}, (str)=>{
    str = str.substring(1);
    const buf = $hHtcy.allocUnsafe(str.length);
    for(let i = 0; i < str.length; i++)buf[i] = str.charCodeAt(i);
    return buf;
});
const $19355b96b5cbc004$var$BASES = {
    utf8: $19355b96b5cbc004$var$string,
    "utf-8": $19355b96b5cbc004$var$string,
    hex: $RyFKX.bases.base16,
    latin1: $19355b96b5cbc004$var$ascii,
    ascii: $19355b96b5cbc004$var$ascii,
    binary: $19355b96b5cbc004$var$ascii,
    ...$RyFKX.bases
};
module.exports = $19355b96b5cbc004$var$BASES;

});
parcelRequire.register("RyFKX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cQhVd = parcelRequire("cQhVd");

var $jGIGh = parcelRequire("jGIGh");

var $3Smh8 = parcelRequire("3Smh8");

var $2I9Y8 = parcelRequire("2I9Y8");

var $12xKA = parcelRequire("12xKA");

var $5LC6A = parcelRequire("5LC6A");

var $cx6XH = parcelRequire("cx6XH");

var $fVtlC = parcelRequire("fVtlC");

var $eXQx4 = parcelRequire("eXQx4");

var $ktQxr = parcelRequire("ktQxr");

var $gTOvd = parcelRequire("gTOvd");

var $klyrn = parcelRequire("klyrn");

var $ivgzQ = parcelRequire("ivgzQ");

var $bfP2x = parcelRequire("bfP2x");
parcelRequire("7fz6M");

var $1uqWk = parcelRequire("1uqWk");

var $8mTe0 = parcelRequire("8mTe0");

var $3gYLQ = parcelRequire("3gYLQ");

var $43cDd = parcelRequire("43cDd");

var $14nA8 = parcelRequire("14nA8");
const $0a0fd8960af7c876$var$bases = {
    ...$cQhVd,
    ...$jGIGh,
    ...$3Smh8,
    ...$2I9Y8,
    ...$12xKA,
    ...$5LC6A,
    ...$cx6XH,
    ...$fVtlC,
    ...$eXQx4,
    ...$ktQxr
};
const $0a0fd8960af7c876$var$hashes = {
    ...$gTOvd,
    ...$klyrn
};
const $0a0fd8960af7c876$var$codecs = {
    raw: $ivgzQ,
    json: $bfP2x
};
module.exports.CID = $1uqWk.CID;
module.exports.hasher = $8mTe0;
module.exports.digest = $3gYLQ;
module.exports.varint = $43cDd;
module.exports.bytes = $14nA8;
module.exports.bases = $0a0fd8960af7c876$var$bases;
module.exports.codecs = $0a0fd8960af7c876$var$codecs;
module.exports.hashes = $0a0fd8960af7c876$var$hashes;

});
parcelRequire.register("cQhVd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f9hHm = parcelRequire("f9hHm");

var $14nA8 = parcelRequire("14nA8");
const $95983e48f4f7e3f3$var$identity = $f9hHm.from({
    prefix: "\x00",
    name: "identity",
    encode: (buf)=>$14nA8.toString(buf),
    decode: (str)=>$14nA8.fromString(str)
});
module.exports.identity = $95983e48f4f7e3f3$var$identity;

});
parcelRequire.register("f9hHm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5zP6U = parcelRequire("5zP6U");

var $14nA8 = parcelRequire("14nA8");
class $b0756ccc0fdd105b$var$Encoder {
    constructor(name, prefix, baseEncode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
    }
    encode(bytes) {
        if (bytes instanceof Uint8Array) return `${this.prefix}${this.baseEncode(bytes)}`;
        else throw Error("Unknown type, must be binary type");
    }
}
class $b0756ccc0fdd105b$var$Decoder {
    constructor(name, prefix, baseDecode){
        this.name = name;
        this.prefix = prefix;
        if (prefix.codePointAt(0) === undefined) throw new Error("Invalid prefix character");
        this.prefixCodePoint = prefix.codePointAt(0);
        this.baseDecode = baseDecode;
    }
    decode(text) {
        if (typeof text === "string") {
            if (text.codePointAt(0) !== this.prefixCodePoint) throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
            return this.baseDecode(text.slice(this.prefix.length));
        } else throw Error("Can only multibase decode strings");
    }
    or(decoder) {
        return $b0756ccc0fdd105b$var$or(this, decoder);
    }
}
class $b0756ccc0fdd105b$var$ComposedDecoder {
    constructor(decoders){
        this.decoders = decoders;
    }
    or(decoder) {
        return $b0756ccc0fdd105b$var$or(this, decoder);
    }
    decode(input) {
        const prefix = input[0];
        const decoder = this.decoders[prefix];
        if (decoder) return decoder.decode(input);
        else throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
    }
}
const $b0756ccc0fdd105b$var$or = (left, right)=>new $b0756ccc0fdd105b$var$ComposedDecoder({
        ...left.decoders || {
            [left.prefix]: left
        },
        ...right.decoders || {
            [right.prefix]: right
        }
    });
class $b0756ccc0fdd105b$var$Codec {
    constructor(name, prefix, baseEncode, baseDecode){
        this.name = name;
        this.prefix = prefix;
        this.baseEncode = baseEncode;
        this.baseDecode = baseDecode;
        this.encoder = new $b0756ccc0fdd105b$var$Encoder(name, prefix, baseEncode);
        this.decoder = new $b0756ccc0fdd105b$var$Decoder(name, prefix, baseDecode);
    }
    encode(input) {
        return this.encoder.encode(input);
    }
    decode(input) {
        return this.decoder.decode(input);
    }
}
const $b0756ccc0fdd105b$var$from = ({ name: name, prefix: prefix, encode: encode, decode: decode })=>new $b0756ccc0fdd105b$var$Codec(name, prefix, encode, decode);
const $b0756ccc0fdd105b$var$baseX = ({ prefix: prefix, name: name, alphabet: alphabet })=>{
    const { encode: encode, decode: decode } = $5zP6U(alphabet, name);
    return $b0756ccc0fdd105b$var$from({
        prefix: prefix,
        name: name,
        encode: encode,
        decode: (text)=>$14nA8.coerce(decode(text))
    });
};
const $b0756ccc0fdd105b$var$decode = (string, alphabet, bitsPerChar, name)=>{
    const codes = {};
    for(let i = 0; i < alphabet.length; ++i)codes[alphabet[i]] = i;
    let end = string.length;
    while(string[end - 1] === "=")--end;
    const out = new Uint8Array(end * bitsPerChar / 8 | 0);
    let bits = 0;
    let buffer = 0;
    let written = 0;
    for(let i = 0; i < end; ++i){
        const value = codes[string[i]];
        if (value === undefined) throw new SyntaxError(`Non-${name} character`);
        buffer = buffer << bitsPerChar | value;
        bits += bitsPerChar;
        if (bits >= 8) {
            bits -= 8;
            out[written++] = 255 & buffer >> bits;
        }
    }
    if (bits >= bitsPerChar || 255 & buffer << 8 - bits) throw new SyntaxError("Unexpected end of data");
    return out;
};
const $b0756ccc0fdd105b$var$encode = (data, alphabet, bitsPerChar)=>{
    const pad = alphabet[alphabet.length - 1] === "=";
    const mask = (1 << bitsPerChar) - 1;
    let out = "";
    let bits = 0;
    let buffer = 0;
    for(let i = 0; i < data.length; ++i){
        buffer = buffer << 8 | data[i];
        bits += 8;
        while(bits > bitsPerChar){
            bits -= bitsPerChar;
            out += alphabet[mask & buffer >> bits];
        }
    }
    if (bits) out += alphabet[mask & buffer << bitsPerChar - bits];
    if (pad) while(out.length * bitsPerChar & 7)out += "=";
    return out;
};
const $b0756ccc0fdd105b$var$rfc4648 = ({ name: name, prefix: prefix, bitsPerChar: bitsPerChar, alphabet: alphabet })=>{
    return $b0756ccc0fdd105b$var$from({
        prefix: prefix,
        name: name,
        encode (input) {
            return $b0756ccc0fdd105b$var$encode(input, alphabet, bitsPerChar);
        },
        decode (input) {
            return $b0756ccc0fdd105b$var$decode(input, alphabet, bitsPerChar, name);
        }
    });
};
module.exports.Codec = $b0756ccc0fdd105b$var$Codec;
module.exports.baseX = $b0756ccc0fdd105b$var$baseX;
module.exports.from = $b0756ccc0fdd105b$var$from;
module.exports.or = $b0756ccc0fdd105b$var$or;
module.exports.rfc4648 = $b0756ccc0fdd105b$var$rfc4648;

});
parcelRequire.register("5zP6U", function(module, exports) {
"use strict";
function $40f7de17e3c855b6$var$base(ALPHABET, name) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256);
    var iFACTOR = Math.log(256) / Math.log(BASE);
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        while(pbegin !== pend){
            var carry = source[pbegin];
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        if (source[psz] === " ") return;
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        var size = (source.length - psz) * FACTOR + 1 >>> 0;
        var b256 = new Uint8Array(size);
        while(source[psz]){
            var carry = BASE_MAP[source.charCodeAt(psz)];
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        if (source[psz] === " ") return;
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error(`Non-${name} character`);
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
var $40f7de17e3c855b6$var$src = $40f7de17e3c855b6$var$base;
var $40f7de17e3c855b6$var$_brrp__multiformats_scope_baseX = $40f7de17e3c855b6$var$src;
module.exports = $40f7de17e3c855b6$var$_brrp__multiformats_scope_baseX;

});

parcelRequire.register("14nA8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $0c787508bd9d759e$var$empty = new Uint8Array(0);
const $0c787508bd9d759e$var$toHex = (d)=>d.reduce((hex, byte)=>hex + byte.toString(16).padStart(2, "0"), "");
const $0c787508bd9d759e$var$fromHex = (hex)=>{
    const hexes = hex.match(/../g);
    return hexes ? new Uint8Array(hexes.map((b)=>parseInt(b, 16))) : $0c787508bd9d759e$var$empty;
};
const $0c787508bd9d759e$var$equals = (aa, bb)=>{
    if (aa === bb) return true;
    if (aa.byteLength !== bb.byteLength) return false;
    for(let ii = 0; ii < aa.byteLength; ii++){
        if (aa[ii] !== bb[ii]) return false;
    }
    return true;
};
const $0c787508bd9d759e$var$coerce = (o)=>{
    if (o instanceof Uint8Array && o.constructor.name === "Uint8Array") return o;
    if (o instanceof ArrayBuffer) return new Uint8Array(o);
    if (ArrayBuffer.isView(o)) return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
    throw new Error("Unknown type, must be binary type");
};
const $0c787508bd9d759e$var$isBinary = (o)=>o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const $0c787508bd9d759e$var$fromString = (str)=>new TextEncoder().encode(str);
const $0c787508bd9d759e$var$toString = (b)=>new TextDecoder().decode(b);
module.exports.coerce = $0c787508bd9d759e$var$coerce;
module.exports.empty = $0c787508bd9d759e$var$empty;
module.exports.equals = $0c787508bd9d759e$var$equals;
module.exports.fromHex = $0c787508bd9d759e$var$fromHex;
module.exports.fromString = $0c787508bd9d759e$var$fromString;
module.exports.isBinary = $0c787508bd9d759e$var$isBinary;
module.exports.toHex = $0c787508bd9d759e$var$toHex;
module.exports.toString = $0c787508bd9d759e$var$toString;

});



parcelRequire.register("jGIGh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f9hHm = parcelRequire("f9hHm");
const $e5549942bd803f4a$var$base2 = $f9hHm.rfc4648({
    prefix: "0",
    name: "base2",
    alphabet: "01",
    bitsPerChar: 1
});
module.exports.base2 = $e5549942bd803f4a$var$base2;

});

parcelRequire.register("3Smh8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f9hHm = parcelRequire("f9hHm");
const $2d27b1a8299ec7c5$var$base8 = $f9hHm.rfc4648({
    prefix: "7",
    name: "base8",
    alphabet: "01234567",
    bitsPerChar: 3
});
module.exports.base8 = $2d27b1a8299ec7c5$var$base8;

});

parcelRequire.register("2I9Y8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f9hHm = parcelRequire("f9hHm");
const $1f976c6feb21bd62$var$base10 = $f9hHm.baseX({
    prefix: "9",
    name: "base10",
    alphabet: "0123456789"
});
module.exports.base10 = $1f976c6feb21bd62$var$base10;

});

parcelRequire.register("12xKA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f9hHm = parcelRequire("f9hHm");
const $0c20287c442795e3$var$base16 = $f9hHm.rfc4648({
    prefix: "f",
    name: "base16",
    alphabet: "0123456789abcdef",
    bitsPerChar: 4
});
const $0c20287c442795e3$var$base16upper = $f9hHm.rfc4648({
    prefix: "F",
    name: "base16upper",
    alphabet: "0123456789ABCDEF",
    bitsPerChar: 4
});
module.exports.base16 = $0c20287c442795e3$var$base16;
module.exports.base16upper = $0c20287c442795e3$var$base16upper;

});

parcelRequire.register("5LC6A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f9hHm = parcelRequire("f9hHm");
const $432ee67107f1ac37$var$base32 = $f9hHm.rfc4648({
    prefix: "b",
    name: "base32",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567",
    bitsPerChar: 5
});
const $432ee67107f1ac37$var$base32upper = $f9hHm.rfc4648({
    prefix: "B",
    name: "base32upper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    bitsPerChar: 5
});
const $432ee67107f1ac37$var$base32pad = $f9hHm.rfc4648({
    prefix: "c",
    name: "base32pad",
    alphabet: "abcdefghijklmnopqrstuvwxyz234567=",
    bitsPerChar: 5
});
const $432ee67107f1ac37$var$base32padupper = $f9hHm.rfc4648({
    prefix: "C",
    name: "base32padupper",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",
    bitsPerChar: 5
});
const $432ee67107f1ac37$var$base32hex = $f9hHm.rfc4648({
    prefix: "v",
    name: "base32hex",
    alphabet: "0123456789abcdefghijklmnopqrstuv",
    bitsPerChar: 5
});
const $432ee67107f1ac37$var$base32hexupper = $f9hHm.rfc4648({
    prefix: "V",
    name: "base32hexupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV",
    bitsPerChar: 5
});
const $432ee67107f1ac37$var$base32hexpad = $f9hHm.rfc4648({
    prefix: "t",
    name: "base32hexpad",
    alphabet: "0123456789abcdefghijklmnopqrstuv=",
    bitsPerChar: 5
});
const $432ee67107f1ac37$var$base32hexpadupper = $f9hHm.rfc4648({
    prefix: "T",
    name: "base32hexpadupper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUV=",
    bitsPerChar: 5
});
const $432ee67107f1ac37$var$base32z = $f9hHm.rfc4648({
    prefix: "h",
    name: "base32z",
    alphabet: "ybndrfg8ejkmcpqxot1uwisza345h769",
    bitsPerChar: 5
});
module.exports.base32 = $432ee67107f1ac37$var$base32;
module.exports.base32hex = $432ee67107f1ac37$var$base32hex;
module.exports.base32hexpad = $432ee67107f1ac37$var$base32hexpad;
module.exports.base32hexpadupper = $432ee67107f1ac37$var$base32hexpadupper;
module.exports.base32hexupper = $432ee67107f1ac37$var$base32hexupper;
module.exports.base32pad = $432ee67107f1ac37$var$base32pad;
module.exports.base32padupper = $432ee67107f1ac37$var$base32padupper;
module.exports.base32upper = $432ee67107f1ac37$var$base32upper;
module.exports.base32z = $432ee67107f1ac37$var$base32z;

});

parcelRequire.register("cx6XH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f9hHm = parcelRequire("f9hHm");
const $91fdf79abf9e7265$var$base36 = $f9hHm.baseX({
    prefix: "k",
    name: "base36",
    alphabet: "0123456789abcdefghijklmnopqrstuvwxyz"
});
const $91fdf79abf9e7265$var$base36upper = $f9hHm.baseX({
    prefix: "K",
    name: "base36upper",
    alphabet: "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
});
module.exports.base36 = $91fdf79abf9e7265$var$base36;
module.exports.base36upper = $91fdf79abf9e7265$var$base36upper;

});

parcelRequire.register("fVtlC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f9hHm = parcelRequire("f9hHm");
const $b982f1b7d75b95c3$var$base58btc = $f9hHm.baseX({
    name: "base58btc",
    prefix: "z",
    alphabet: "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
});
const $b982f1b7d75b95c3$var$base58flickr = $f9hHm.baseX({
    name: "base58flickr",
    prefix: "Z",
    alphabet: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
});
module.exports.base58btc = $b982f1b7d75b95c3$var$base58btc;
module.exports.base58flickr = $b982f1b7d75b95c3$var$base58flickr;

});

parcelRequire.register("eXQx4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f9hHm = parcelRequire("f9hHm");
const $ae4f53390dee6c83$var$base64 = $f9hHm.rfc4648({
    prefix: "m",
    name: "base64",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    bitsPerChar: 6
});
const $ae4f53390dee6c83$var$base64pad = $f9hHm.rfc4648({
    prefix: "M",
    name: "base64pad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    bitsPerChar: 6
});
const $ae4f53390dee6c83$var$base64url = $f9hHm.rfc4648({
    prefix: "u",
    name: "base64url",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
    bitsPerChar: 6
});
const $ae4f53390dee6c83$var$base64urlpad = $f9hHm.rfc4648({
    prefix: "U",
    name: "base64urlpad",
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",
    bitsPerChar: 6
});
module.exports.base64 = $ae4f53390dee6c83$var$base64;
module.exports.base64pad = $ae4f53390dee6c83$var$base64pad;
module.exports.base64url = $ae4f53390dee6c83$var$base64url;
module.exports.base64urlpad = $ae4f53390dee6c83$var$base64urlpad;

});

parcelRequire.register("ktQxr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f9hHm = parcelRequire("f9hHm");
const $ee8f451bedca6df0$var$alphabet = Array.from("\uD83D\uDE80\uD83E\uDE90☄\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09☀\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02❤\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09☺\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E✌✨\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D❣\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33✋\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13⭐✅\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6✔\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90☹\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20☝\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B⚽\uD83E\uDD19☕\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81⚡\uD83C\uDF1E\uD83C\uDF88❌✊\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C✈\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74▶➡❓\uD83D\uDC8E\uD83D\uDCB8⬇\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A⚠\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37☎\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51❄\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42");
const $ee8f451bedca6df0$var$alphabetBytesToChars = $ee8f451bedca6df0$var$alphabet.reduce((p, c, i)=>{
    p[i] = c;
    return p;
}, []);
const $ee8f451bedca6df0$var$alphabetCharsToBytes = $ee8f451bedca6df0$var$alphabet.reduce((p, c, i)=>{
    p[c.codePointAt(0)] = i;
    return p;
}, []);
function $ee8f451bedca6df0$var$encode(data) {
    return data.reduce((p, c)=>{
        p += $ee8f451bedca6df0$var$alphabetBytesToChars[c];
        return p;
    }, "");
}
function $ee8f451bedca6df0$var$decode(str) {
    const byts = [];
    for (const char of str){
        const byt = $ee8f451bedca6df0$var$alphabetCharsToBytes[char.codePointAt(0)];
        if (byt === undefined) throw new Error(`Non-base256emoji character: ${char}`);
        byts.push(byt);
    }
    return new Uint8Array(byts);
}
const $ee8f451bedca6df0$var$base256emoji = $f9hHm.from({
    prefix: "\uD83D\uDE80",
    name: "base256emoji",
    encode: $ee8f451bedca6df0$var$encode,
    decode: $ee8f451bedca6df0$var$decode
});
module.exports.base256emoji = $ee8f451bedca6df0$var$base256emoji;

});

parcelRequire.register("gTOvd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8mTe0 = parcelRequire("8mTe0");
const $c4d8f5259495e7b0$var$sha = (name)=>async (data)=>new Uint8Array(await crypto.subtle.digest(name, data));
const $c4d8f5259495e7b0$var$sha256 = $8mTe0.from({
    name: "sha2-256",
    code: 18,
    encode: $c4d8f5259495e7b0$var$sha("SHA-256")
});
const $c4d8f5259495e7b0$var$sha512 = $8mTe0.from({
    name: "sha2-512",
    code: 19,
    encode: $c4d8f5259495e7b0$var$sha("SHA-512")
});
module.exports.sha256 = $c4d8f5259495e7b0$var$sha256;
module.exports.sha512 = $c4d8f5259495e7b0$var$sha512;

});
parcelRequire.register("8mTe0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3gYLQ = parcelRequire("3gYLQ");
const $617b375849074397$var$from = ({ name: name, code: code, encode: encode })=>new $617b375849074397$var$Hasher(name, code, encode);
class $617b375849074397$var$Hasher {
    constructor(name, code, encode){
        this.name = name;
        this.code = code;
        this.encode = encode;
    }
    digest(input) {
        if (input instanceof Uint8Array) {
            const result = this.encode(input);
            return result instanceof Uint8Array ? $3gYLQ.create(this.code, result) : result.then((digest$1)=>$3gYLQ.create(this.code, digest$1));
        } else throw Error("Unknown type, must be binary type");
    }
}
module.exports.Hasher = $617b375849074397$var$Hasher;
module.exports.from = $617b375849074397$var$from;

});
parcelRequire.register("3gYLQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $14nA8 = parcelRequire("14nA8");

var $43cDd = parcelRequire("43cDd");
const $26220189f981a86f$var$create = (code, digest)=>{
    const size = digest.byteLength;
    const sizeOffset = $43cDd.encodingLength(code);
    const digestOffset = sizeOffset + $43cDd.encodingLength(size);
    const bytes = new Uint8Array(digestOffset + size);
    $43cDd.encodeTo(code, bytes, 0);
    $43cDd.encodeTo(size, bytes, sizeOffset);
    bytes.set(digest, digestOffset);
    return new $26220189f981a86f$var$Digest(code, size, digest, bytes);
};
const $26220189f981a86f$var$decode = (multihash)=>{
    const bytes$1 = $14nA8.coerce(multihash);
    const [code, sizeOffset] = $43cDd.decode(bytes$1);
    const [size, digestOffset] = $43cDd.decode(bytes$1.subarray(sizeOffset));
    const digest = bytes$1.subarray(sizeOffset + digestOffset);
    if (digest.byteLength !== size) throw new Error("Incorrect length");
    return new $26220189f981a86f$var$Digest(code, size, digest, bytes$1);
};
const $26220189f981a86f$var$equals = (a, b)=>{
    if (a === b) return true;
    else return a.code === b.code && a.size === b.size && $14nA8.equals(a.bytes, b.bytes);
};
class $26220189f981a86f$var$Digest {
    constructor(code, size, digest, bytes){
        this.code = code;
        this.size = size;
        this.digest = digest;
        this.bytes = bytes;
    }
}
module.exports.Digest = $26220189f981a86f$var$Digest;
module.exports.create = $26220189f981a86f$var$create;
module.exports.decode = $26220189f981a86f$var$decode;
module.exports.equals = $26220189f981a86f$var$equals;

});
parcelRequire.register("43cDd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8ET1e = parcelRequire("8ET1e");
const $2f313d98ae6885a0$var$decode = (data, offset = 0)=>{
    const code = $8ET1e.decode(data, offset);
    return [
        code,
        $8ET1e.decode.bytes
    ];
};
const $2f313d98ae6885a0$var$encodeTo = (int, target, offset = 0)=>{
    $8ET1e.encode(int, target, offset);
    return target;
};
const $2f313d98ae6885a0$var$encodingLength = (int)=>{
    return $8ET1e.encodingLength(int);
};
module.exports.decode = $2f313d98ae6885a0$var$decode;
module.exports.encodeTo = $2f313d98ae6885a0$var$encodeTo;
module.exports.encodingLength = $2f313d98ae6885a0$var$encodingLength;

});
parcelRequire.register("8ET1e", function(module, exports) {
"use strict";
var $64dcbcc203c609a2$var$encode_1 = $64dcbcc203c609a2$var$encode;
var $64dcbcc203c609a2$var$MSB = 128, $64dcbcc203c609a2$var$REST = 127, $64dcbcc203c609a2$var$MSBALL = ~$64dcbcc203c609a2$var$REST, $64dcbcc203c609a2$var$INT = Math.pow(2, 31);
function $64dcbcc203c609a2$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $64dcbcc203c609a2$var$INT){
        out[offset++] = num & 255 | $64dcbcc203c609a2$var$MSB;
        num /= 128;
    }
    while(num & $64dcbcc203c609a2$var$MSBALL){
        out[offset++] = num & 255 | $64dcbcc203c609a2$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $64dcbcc203c609a2$var$encode.bytes = offset - oldOffset + 1;
    return out;
}
var $64dcbcc203c609a2$var$decode = $64dcbcc203c609a2$var$read;
var $64dcbcc203c609a2$var$MSB$1 = 128, $64dcbcc203c609a2$var$REST$1 = 127;
function $64dcbcc203c609a2$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $64dcbcc203c609a2$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $64dcbcc203c609a2$var$REST$1) << shift : (b & $64dcbcc203c609a2$var$REST$1) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $64dcbcc203c609a2$var$MSB$1);
    $64dcbcc203c609a2$var$read.bytes = counter - offset;
    return res;
}
var $64dcbcc203c609a2$var$N1 = Math.pow(2, 7);
var $64dcbcc203c609a2$var$N2 = Math.pow(2, 14);
var $64dcbcc203c609a2$var$N3 = Math.pow(2, 21);
var $64dcbcc203c609a2$var$N4 = Math.pow(2, 28);
var $64dcbcc203c609a2$var$N5 = Math.pow(2, 35);
var $64dcbcc203c609a2$var$N6 = Math.pow(2, 42);
var $64dcbcc203c609a2$var$N7 = Math.pow(2, 49);
var $64dcbcc203c609a2$var$N8 = Math.pow(2, 56);
var $64dcbcc203c609a2$var$N9 = Math.pow(2, 63);
var $64dcbcc203c609a2$var$length = function(value) {
    return value < $64dcbcc203c609a2$var$N1 ? 1 : value < $64dcbcc203c609a2$var$N2 ? 2 : value < $64dcbcc203c609a2$var$N3 ? 3 : value < $64dcbcc203c609a2$var$N4 ? 4 : value < $64dcbcc203c609a2$var$N5 ? 5 : value < $64dcbcc203c609a2$var$N6 ? 6 : value < $64dcbcc203c609a2$var$N7 ? 7 : value < $64dcbcc203c609a2$var$N8 ? 8 : value < $64dcbcc203c609a2$var$N9 ? 9 : 10;
};
var $64dcbcc203c609a2$var$varint = {
    encode: $64dcbcc203c609a2$var$encode_1,
    decode: $64dcbcc203c609a2$var$decode,
    encodingLength: $64dcbcc203c609a2$var$length
};
var $64dcbcc203c609a2$var$_brrp_varint = $64dcbcc203c609a2$var$varint;
var $64dcbcc203c609a2$var$varint$1 = $64dcbcc203c609a2$var$_brrp_varint;
module.exports = $64dcbcc203c609a2$var$varint$1;

});





parcelRequire.register("klyrn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $14nA8 = parcelRequire("14nA8");

var $3gYLQ = parcelRequire("3gYLQ");
const $ed007bfea72f5b2c$var$code = 0;
const $ed007bfea72f5b2c$var$name = "identity";
const $ed007bfea72f5b2c$var$encode = $14nA8.coerce;
const $ed007bfea72f5b2c$var$digest = (input)=>$3gYLQ.create($ed007bfea72f5b2c$var$code, $ed007bfea72f5b2c$var$encode(input));
const $ed007bfea72f5b2c$var$identity = {
    code: $ed007bfea72f5b2c$var$code,
    name: $ed007bfea72f5b2c$var$name,
    encode: $ed007bfea72f5b2c$var$encode,
    digest: $ed007bfea72f5b2c$var$digest
};
module.exports.identity = $ed007bfea72f5b2c$var$identity;

});

parcelRequire.register("ivgzQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $14nA8 = parcelRequire("14nA8");
const $d787fb1a6bf648f4$var$name = "raw";
const $d787fb1a6bf648f4$var$code = 85;
const $d787fb1a6bf648f4$var$encode = (node)=>$14nA8.coerce(node);
const $d787fb1a6bf648f4$var$decode = (data)=>$14nA8.coerce(data);
module.exports.code = $d787fb1a6bf648f4$var$code;
module.exports.decode = $d787fb1a6bf648f4$var$decode;
module.exports.encode = $d787fb1a6bf648f4$var$encode;
module.exports.name = $d787fb1a6bf648f4$var$name;

});

parcelRequire.register("bfP2x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $8318afe91c25204d$var$textEncoder = new TextEncoder();
const $8318afe91c25204d$var$textDecoder = new TextDecoder();
const $8318afe91c25204d$var$name = "json";
const $8318afe91c25204d$var$code = 512;
const $8318afe91c25204d$var$encode = (node)=>$8318afe91c25204d$var$textEncoder.encode(JSON.stringify(node));
const $8318afe91c25204d$var$decode = (data)=>JSON.parse($8318afe91c25204d$var$textDecoder.decode(data));
module.exports.code = $8318afe91c25204d$var$code;
module.exports.decode = $8318afe91c25204d$var$decode;
module.exports.encode = $8318afe91c25204d$var$encode;
module.exports.name = $8318afe91c25204d$var$name;

});

parcelRequire.register("7fz6M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1uqWk = parcelRequire("1uqWk");

var $43cDd = parcelRequire("43cDd");

var $14nA8 = parcelRequire("14nA8");

var $8mTe0 = parcelRequire("8mTe0");

var $3gYLQ = parcelRequire("3gYLQ");
module.exports.CID = $1uqWk.CID;
module.exports.varint = $43cDd;
module.exports.bytes = $14nA8;
module.exports.hasher = $8mTe0;
module.exports.digest = $3gYLQ;

});
parcelRequire.register("1uqWk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $43cDd = parcelRequire("43cDd");

var $3gYLQ = parcelRequire("3gYLQ");

var $fVtlC = parcelRequire("fVtlC");

var $5LC6A = parcelRequire("5LC6A");

var $14nA8 = parcelRequire("14nA8");
class $115d7d77ee70e6ac$var$CID {
    constructor(version, code, multihash, bytes){
        this.code = code;
        this.version = version;
        this.multihash = multihash;
        this.bytes = bytes;
        this.byteOffset = bytes.byteOffset;
        this.byteLength = bytes.byteLength;
        this.asCID = this;
        this._baseCache = new Map();
        Object.defineProperties(this, {
            byteOffset: $115d7d77ee70e6ac$var$hidden,
            byteLength: $115d7d77ee70e6ac$var$hidden,
            code: $115d7d77ee70e6ac$var$readonly,
            version: $115d7d77ee70e6ac$var$readonly,
            multihash: $115d7d77ee70e6ac$var$readonly,
            bytes: $115d7d77ee70e6ac$var$readonly,
            _baseCache: $115d7d77ee70e6ac$var$hidden,
            asCID: $115d7d77ee70e6ac$var$hidden
        });
    }
    toV0() {
        switch(this.version){
            case 0:
                return this;
            default:
                {
                    const { code: code, multihash: multihash } = this;
                    if (code !== $115d7d77ee70e6ac$var$DAG_PB_CODE) throw new Error("Cannot convert a non dag-pb CID to CIDv0");
                    if (multihash.code !== $115d7d77ee70e6ac$var$SHA_256_CODE) throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
                    return $115d7d77ee70e6ac$var$CID.createV0(multihash);
                }
        }
    }
    toV1() {
        switch(this.version){
            case 0:
                {
                    const { code: code, digest: digest$1 } = this.multihash;
                    const multihash = $3gYLQ.create(code, digest$1);
                    return $115d7d77ee70e6ac$var$CID.createV1(this.code, multihash);
                }
            case 1:
                return this;
            default:
                throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
        }
    }
    equals(other) {
        return other && this.code === other.code && this.version === other.version && $3gYLQ.equals(this.multihash, other.multihash);
    }
    toString(base) {
        const { bytes: bytes, version: version, _baseCache: _baseCache } = this;
        switch(version){
            case 0:
                return $115d7d77ee70e6ac$var$toStringV0(bytes, _baseCache, base || $fVtlC.base58btc.encoder);
            default:
                return $115d7d77ee70e6ac$var$toStringV1(bytes, _baseCache, base || $5LC6A.base32.encoder);
        }
    }
    toJSON() {
        return {
            code: this.code,
            version: this.version,
            hash: this.multihash.bytes
        };
    }
    get [Symbol.toStringTag]() {
        return "CID";
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return "CID(" + this.toString() + ")";
    }
    static isCID(value) {
        $115d7d77ee70e6ac$var$deprecate(/^0\.0/, $115d7d77ee70e6ac$var$IS_CID_DEPRECATION);
        return !!(value && (value[$115d7d77ee70e6ac$var$cidSymbol] || value.asCID === value));
    }
    get toBaseEncodedString() {
        throw new Error("Deprecated, use .toString()");
    }
    get codec() {
        throw new Error('"codec" property is deprecated, use integer "code" property instead');
    }
    get buffer() {
        throw new Error("Deprecated .buffer property, use .bytes to get Uint8Array instead");
    }
    get multibaseName() {
        throw new Error('"multibaseName" property is deprecated');
    }
    get prefix() {
        throw new Error('"prefix" property is deprecated');
    }
    static asCID(value) {
        if (value instanceof $115d7d77ee70e6ac$var$CID) return value;
        else if (value != null && value.asCID === value) {
            const { version: version, code: code, multihash: multihash, bytes: bytes } = value;
            return new $115d7d77ee70e6ac$var$CID(version, code, multihash, bytes || $115d7d77ee70e6ac$var$encodeCID(version, code, multihash.bytes));
        } else if (value != null && value[$115d7d77ee70e6ac$var$cidSymbol] === true) {
            const { version: version, multihash: multihash, code: code } = value;
            const digest$1 = $3gYLQ.decode(multihash);
            return $115d7d77ee70e6ac$var$CID.create(version, code, digest$1);
        } else return null;
    }
    static create(version, code, digest) {
        if (typeof code !== "number") throw new Error("String codecs are no longer supported");
        switch(version){
            case 0:
                if (code !== $115d7d77ee70e6ac$var$DAG_PB_CODE) throw new Error(`Version 0 CID must use dag-pb (code: ${$115d7d77ee70e6ac$var$DAG_PB_CODE}) block encoding`);
                else return new $115d7d77ee70e6ac$var$CID(version, code, digest, digest.bytes);
            case 1:
                {
                    const bytes = $115d7d77ee70e6ac$var$encodeCID(version, code, digest.bytes);
                    return new $115d7d77ee70e6ac$var$CID(version, code, digest, bytes);
                }
            default:
                throw new Error("Invalid version");
        }
    }
    static createV0(digest) {
        return $115d7d77ee70e6ac$var$CID.create(0, $115d7d77ee70e6ac$var$DAG_PB_CODE, digest);
    }
    static createV1(code, digest) {
        return $115d7d77ee70e6ac$var$CID.create(1, code, digest);
    }
    static decode(bytes) {
        const [cid, remainder] = $115d7d77ee70e6ac$var$CID.decodeFirst(bytes);
        if (remainder.length) throw new Error("Incorrect length");
        return cid;
    }
    static decodeFirst(bytes$1) {
        const specs = $115d7d77ee70e6ac$var$CID.inspectBytes(bytes$1);
        const prefixSize = specs.size - specs.multihashSize;
        const multihashBytes = $14nA8.coerce(bytes$1.subarray(prefixSize, prefixSize + specs.multihashSize));
        if (multihashBytes.byteLength !== specs.multihashSize) throw new Error("Incorrect length");
        const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
        const digest$1 = new $3gYLQ.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
        const cid = specs.version === 0 ? $115d7d77ee70e6ac$var$CID.createV0(digest$1) : $115d7d77ee70e6ac$var$CID.createV1(specs.codec, digest$1);
        return [
            cid,
            bytes$1.subarray(specs.size)
        ];
    }
    static inspectBytes(initialBytes) {
        let offset = 0;
        const next = ()=>{
            const [i, length] = $43cDd.decode(initialBytes.subarray(offset));
            offset += length;
            return i;
        };
        let version = next();
        let codec = $115d7d77ee70e6ac$var$DAG_PB_CODE;
        if (version === 18) {
            version = 0;
            offset = 0;
        } else if (version === 1) codec = next();
        if (version !== 0 && version !== 1) throw new RangeError(`Invalid CID version ${version}`);
        const prefixSize = offset;
        const multihashCode = next();
        const digestSize = next();
        const size = offset + digestSize;
        const multihashSize = size - prefixSize;
        return {
            version: version,
            codec: codec,
            multihashCode: multihashCode,
            digestSize: digestSize,
            multihashSize: multihashSize,
            size: size
        };
    }
    static parse(source, base) {
        const [prefix, bytes] = $115d7d77ee70e6ac$var$parseCIDtoBytes(source, base);
        const cid = $115d7d77ee70e6ac$var$CID.decode(bytes);
        cid._baseCache.set(prefix, source);
        return cid;
    }
}
const $115d7d77ee70e6ac$var$parseCIDtoBytes = (source, base)=>{
    switch(source[0]){
        case "Q":
            {
                const decoder = base || $fVtlC.base58btc;
                return [
                    $fVtlC.base58btc.prefix,
                    decoder.decode(`${$fVtlC.base58btc.prefix}${source}`)
                ];
            }
        case $fVtlC.base58btc.prefix:
            {
                const decoder = base || $fVtlC.base58btc;
                return [
                    $fVtlC.base58btc.prefix,
                    decoder.decode(source)
                ];
            }
        case $5LC6A.base32.prefix:
            {
                const decoder = base || $5LC6A.base32;
                return [
                    $5LC6A.base32.prefix,
                    decoder.decode(source)
                ];
            }
        default:
            if (base == null) throw Error("To parse non base32 or base58btc encoded CID multibase decoder must be provided");
            return [
                source[0],
                base.decode(source)
            ];
    }
};
const $115d7d77ee70e6ac$var$toStringV0 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    if (prefix !== $fVtlC.base58btc.prefix) throw Error(`Cannot string encode V0 in ${base.name} encoding`);
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes).slice(1);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $115d7d77ee70e6ac$var$toStringV1 = (bytes, cache, base)=>{
    const { prefix: prefix } = base;
    const cid = cache.get(prefix);
    if (cid == null) {
        const cid = base.encode(bytes);
        cache.set(prefix, cid);
        return cid;
    } else return cid;
};
const $115d7d77ee70e6ac$var$DAG_PB_CODE = 112;
const $115d7d77ee70e6ac$var$SHA_256_CODE = 18;
const $115d7d77ee70e6ac$var$encodeCID = (version, code, multihash)=>{
    const codeOffset = $43cDd.encodingLength(version);
    const hashOffset = codeOffset + $43cDd.encodingLength(code);
    const bytes = new Uint8Array(hashOffset + multihash.byteLength);
    $43cDd.encodeTo(version, bytes, 0);
    $43cDd.encodeTo(code, bytes, codeOffset);
    bytes.set(multihash, hashOffset);
    return bytes;
};
const $115d7d77ee70e6ac$var$cidSymbol = Symbol.for("@ipld/js-cid/CID");
const $115d7d77ee70e6ac$var$readonly = {
    writable: false,
    configurable: false,
    enumerable: true
};
const $115d7d77ee70e6ac$var$hidden = {
    writable: false,
    enumerable: false,
    configurable: false
};
const $115d7d77ee70e6ac$var$version = "0.0.0-dev";
const $115d7d77ee70e6ac$var$deprecate = (range, message)=>{
    if (range.test($115d7d77ee70e6ac$var$version)) console.warn(message);
    else throw new Error(message);
};
const $115d7d77ee70e6ac$var$IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;
module.exports.CID = $115d7d77ee70e6ac$var$CID;

});



parcelRequire.register("hHtcy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $euGjA = parcelRequire("euGjA");
function $ce2d1aa3934fe0c7$var$alloc(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.alloc != null) return $euGjA.asUint8Array(globalThis.Buffer.alloc(size));
    return new Uint8Array(size);
}
function $ce2d1aa3934fe0c7$var$allocUnsafe(size = 0) {
    if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) return $euGjA.asUint8Array(globalThis.Buffer.allocUnsafe(size));
    return new Uint8Array(size);
}
module.exports.alloc = $ce2d1aa3934fe0c7$var$alloc;
module.exports.allocUnsafe = $ce2d1aa3934fe0c7$var$allocUnsafe;

});
parcelRequire.register("euGjA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $a8d4b0e395cd633e$var$asUint8Array(buf) {
    if (globalThis.Buffer != null) return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    return buf;
}
module.exports.asUint8Array = $a8d4b0e395cd633e$var$asUint8Array;

});





parcelRequire.register("eLYQN", function(module, exports) {
"use strict";
/** @typedef {import("./types").Protocol} Protocol */ /**
 * Protocols
 *
 * @param {number | string} proto
 * @returns {Protocol}
 */ function $02c686d73fa0d1b4$var$Protocols(proto) {
    if (typeof proto === "number") {
        if ($02c686d73fa0d1b4$var$Protocols.codes[proto]) return $02c686d73fa0d1b4$var$Protocols.codes[proto];
        throw new Error("no protocol with code: " + proto);
    } else if (typeof proto === "string") {
        if ($02c686d73fa0d1b4$var$Protocols.names[proto]) return $02c686d73fa0d1b4$var$Protocols.names[proto];
        throw new Error("no protocol with name: " + proto);
    }
    throw new Error("invalid protocol id type: " + proto);
}
const $02c686d73fa0d1b4$var$V = -1;
$02c686d73fa0d1b4$var$Protocols.lengthPrefixedVarSize = $02c686d73fa0d1b4$var$V;
$02c686d73fa0d1b4$var$Protocols.V = $02c686d73fa0d1b4$var$V;
/** @type {Array<[number, number, string, (string|boolean)?, string?]>} */ $02c686d73fa0d1b4$var$Protocols.table = [
    [
        4,
        32,
        "ip4"
    ],
    [
        6,
        16,
        "tcp"
    ],
    [
        33,
        16,
        "dccp"
    ],
    [
        41,
        128,
        "ip6"
    ],
    [
        42,
        $02c686d73fa0d1b4$var$V,
        "ip6zone"
    ],
    [
        53,
        $02c686d73fa0d1b4$var$V,
        "dns",
        "resolvable"
    ],
    [
        54,
        $02c686d73fa0d1b4$var$V,
        "dns4",
        "resolvable"
    ],
    [
        55,
        $02c686d73fa0d1b4$var$V,
        "dns6",
        "resolvable"
    ],
    [
        56,
        $02c686d73fa0d1b4$var$V,
        "dnsaddr",
        "resolvable"
    ],
    [
        132,
        16,
        "sctp"
    ],
    [
        273,
        16,
        "udp"
    ],
    [
        275,
        0,
        "p2p-webrtc-star"
    ],
    [
        276,
        0,
        "p2p-webrtc-direct"
    ],
    [
        277,
        0,
        "p2p-stardust"
    ],
    [
        290,
        0,
        "p2p-circuit"
    ],
    [
        301,
        0,
        "udt"
    ],
    [
        302,
        0,
        "utp"
    ],
    [
        400,
        $02c686d73fa0d1b4$var$V,
        "unix",
        false,
        "path"
    ],
    // `ipfs` is added before `p2p` for legacy support.
    // All text representations will default to `p2p`, but `ipfs` will
    // still be supported
    [
        421,
        $02c686d73fa0d1b4$var$V,
        "ipfs"
    ],
    // `p2p` is the preferred name for 421, and is now the default
    [
        421,
        $02c686d73fa0d1b4$var$V,
        "p2p"
    ],
    [
        443,
        0,
        "https"
    ],
    [
        444,
        96,
        "onion"
    ],
    [
        445,
        296,
        "onion3"
    ],
    [
        446,
        $02c686d73fa0d1b4$var$V,
        "garlic64"
    ],
    [
        460,
        0,
        "quic"
    ],
    [
        477,
        0,
        "ws"
    ],
    [
        478,
        0,
        "wss"
    ],
    [
        479,
        0,
        "p2p-websocket-star"
    ],
    [
        480,
        0,
        "http"
    ],
    [
        777,
        $02c686d73fa0d1b4$var$V,
        "memory"
    ]
];
/** @type {Record<string,Protocol>} */ $02c686d73fa0d1b4$var$Protocols.names = {};
/** @type {Record<number,Protocol>} */ $02c686d73fa0d1b4$var$Protocols.codes = {};
// populate tables
$02c686d73fa0d1b4$var$Protocols.table.map((row)=>{
    const proto = $02c686d73fa0d1b4$var$p.apply(null, row);
    $02c686d73fa0d1b4$var$Protocols.codes[proto.code] = proto;
    $02c686d73fa0d1b4$var$Protocols.names[proto.name] = proto;
    return null;
});
$02c686d73fa0d1b4$var$Protocols.object = $02c686d73fa0d1b4$var$p;
/**
 *
 * Create a protocol
 *
 * @param {number} code
 * @param {number} size
 * @param {string} name
 * @param {any} [resolvable]
 * @param {any} [path]
 * @returns {Protocol}
 */ function $02c686d73fa0d1b4$var$p(code, size, name, resolvable, path) {
    return {
        code: code,
        size: size,
        name: name,
        resolvable: Boolean(resolvable),
        path: Boolean(path)
    };
}
module.exports = $02c686d73fa0d1b4$var$Protocols;

});

parcelRequire.register("b7PIr", function(module, exports) {



module.exports = {
    encode: (parcelRequire("1UKQt")),
    decode: (parcelRequire("kXsyV")),
    encodingLength: (parcelRequire("l17Fe"))
};

});
parcelRequire.register("1UKQt", function(module, exports) {
module.exports = $164f5be65e6c513b$var$encode;
var $164f5be65e6c513b$var$MSB = 0x80, $164f5be65e6c513b$var$REST = 0x7F, $164f5be65e6c513b$var$MSBALL = ~$164f5be65e6c513b$var$REST, $164f5be65e6c513b$var$INT = Math.pow(2, 31);
function $164f5be65e6c513b$var$encode(num, out, offset) {
    if (Number.MAX_SAFE_INTEGER && num > Number.MAX_SAFE_INTEGER) {
        $164f5be65e6c513b$var$encode.bytes = 0;
        throw new RangeError("Could not encode varint");
    }
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $164f5be65e6c513b$var$INT){
        out[offset++] = num & 0xFF | $164f5be65e6c513b$var$MSB;
        num /= 128;
    }
    while(num & $164f5be65e6c513b$var$MSBALL){
        out[offset++] = num & 0xFF | $164f5be65e6c513b$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $164f5be65e6c513b$var$encode.bytes = offset - oldOffset + 1;
    return out;
}

});

parcelRequire.register("kXsyV", function(module, exports) {
module.exports = $f41f7930b47c1f60$var$read;
var $f41f7930b47c1f60$var$MSB = 0x80, $f41f7930b47c1f60$var$REST = 0x7F;
function $f41f7930b47c1f60$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l || shift > 49) {
            $f41f7930b47c1f60$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $f41f7930b47c1f60$var$REST) << shift : (b & $f41f7930b47c1f60$var$REST) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $f41f7930b47c1f60$var$MSB);
    $f41f7930b47c1f60$var$read.bytes = counter - offset;
    return res;
}

});

parcelRequire.register("l17Fe", function(module, exports) {
var $f4cfa2e6c0f8f497$var$N1 = Math.pow(2, 7);
var $f4cfa2e6c0f8f497$var$N2 = Math.pow(2, 14);
var $f4cfa2e6c0f8f497$var$N3 = Math.pow(2, 21);
var $f4cfa2e6c0f8f497$var$N4 = Math.pow(2, 28);
var $f4cfa2e6c0f8f497$var$N5 = Math.pow(2, 35);
var $f4cfa2e6c0f8f497$var$N6 = Math.pow(2, 42);
var $f4cfa2e6c0f8f497$var$N7 = Math.pow(2, 49);
var $f4cfa2e6c0f8f497$var$N8 = Math.pow(2, 56);
var $f4cfa2e6c0f8f497$var$N9 = Math.pow(2, 63);
module.exports = function(value) {
    return value < $f4cfa2e6c0f8f497$var$N1 ? 1 : value < $f4cfa2e6c0f8f497$var$N2 ? 2 : value < $f4cfa2e6c0f8f497$var$N3 ? 3 : value < $f4cfa2e6c0f8f497$var$N4 ? 4 : value < $f4cfa2e6c0f8f497$var$N5 ? 5 : value < $f4cfa2e6c0f8f497$var$N6 ? 6 : value < $f4cfa2e6c0f8f497$var$N7 ? 7 : value < $f4cfa2e6c0f8f497$var$N8 ? 8 : value < $f4cfa2e6c0f8f497$var$N9 ? 9 : 10;
};

});


parcelRequire.register("8cWjP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2aboO = parcelRequire("2aboO");

var $euGjA = parcelRequire("euGjA");
function $5f9cae9b51ed8ec4$var$fromString(string, encoding = "utf8") {
    const base = $2aboO[encoding];
    if (!base) throw new Error(`Unsupported encoding "${encoding}"`);
    if ((encoding === "utf8" || encoding === "utf-8") && globalThis.Buffer != null && globalThis.Buffer.from != null) return $euGjA.asUint8Array(globalThis.Buffer.from(string, "utf-8"));
    return base.decoder.decode(`${base.prefix}${string}`);
}
module.exports.fromString = $5f9cae9b51ed8ec4$var$fromString;

});

parcelRequire.register("8hEBV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hHtcy = parcelRequire("hHtcy");

var $euGjA = parcelRequire("euGjA");
function $607f69affc28cfa1$var$concat(arrays, length) {
    if (!length) length = arrays.reduce((acc, curr)=>acc + curr.length, 0);
    const output = $hHtcy.allocUnsafe(length);
    let offset = 0;
    for (const arr of arrays){
        output.set(arr, offset);
        offset += arr.length;
    }
    return $euGjA.asUint8Array(output);
}
module.exports.concat = $607f69affc28cfa1$var$concat;

});



parcelRequire.register("20Lm5", function(module, exports) {
"use strict";
/**
 * @typedef {{ [key: string]: any }} Extensions
 * @typedef {Error} Err
 * @property {string} message
 */ /**
 *
 * @param {Error} obj
 * @param {Extensions} props
 * @returns {Error & Extensions}
 */ function $177050a0ba9c196f$var$assign(obj, props) {
    for(const key in props)Object.defineProperty(obj, key, {
        value: props[key],
        enumerable: true,
        configurable: true
    });
    return obj;
}
/**
 *
 * @param {any} err - An Error
 * @param {string|Extensions} code - A string code or props to set on the error
 * @param {Extensions} [props] - Props to set on the error
 * @returns {Error & Extensions}
 */ function $177050a0ba9c196f$var$createError(err, code, props) {
    if (!err || typeof err === "string") throw new TypeError("Please pass an Error to err-code");
    if (!props) props = {};
    if (typeof code === "object") {
        props = code;
        code = "";
    }
    if (code) props.code = code;
    try {
        return $177050a0ba9c196f$var$assign(err, props);
    } catch (_) {
        props.message = err.message;
        props.stack = err.stack;
        const ErrClass = function() {};
        ErrClass.prototype = Object.create(Object.getPrototypeOf(err));
        // @ts-ignore
        const output = $177050a0ba9c196f$var$assign(new ErrClass(), props);
        return output;
    }
}
module.exports = $177050a0ba9c196f$var$createError;

});

parcelRequire.register("ijWXY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $037128392311bdb5$var$equals(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.equals = $037128392311bdb5$var$equals;

});


parcelRequire.register("kBs7x", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d7dc519ecb99c66$export$2e2bcd8739ae039);
/**
 * Throw an error if the value is falsy. Use this to provide better error
 * messages around expected conditions.
 *
 * Also provides TypeScript type narrowing.
 */ function $0d7dc519ecb99c66$export$2e2bcd8739ae039(value, msg) {
    if (!value) {
        const error = new Error(msg);
        error.name = "Assertion";
        throw error;
    }
}

});

parcelRequire.register("g3TU4", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("aIGPP")).default);

var $aIGPP = parcelRequire("aIGPP");

});
parcelRequire.register("aIGPP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cdd74141a3788c5$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $d8Blz = parcelRequire("d8Blz");

var $39TYQ = parcelRequire("39TYQ");
class $9cdd74141a3788c5$export$2e2bcd8739ae039 {
    static from(stream) {
        return new $9cdd74141a3788c5$export$2e2bcd8739ae039(stream);
    }
    constructor(stream){
        this.messageQueue = new (0, $39TYQ.default)();
        this.stream = stream;
        this.connectionClosePromise = (0, (/*@__PURE__*/$parcel$interopDefault($d8Blz)))(this.messageQueue, $9cdd74141a3788c5$var$json.encode, this.stream);
    }
    /** Permanently closes the libp2p stream. */ close() {
        this.stream.close();
    }
    /** Send arbitrary JSON to the other side. */ async send(data) {
        this.messageQueue.append(data);
    }
    /**
   * Invokes the callback for every new message.
   * WARNING: Don't subscribe more than once.
   */ subscribe(callback) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($d8Blz)))(this.stream, $9cdd74141a3788c5$var$json.decode, async (stream)=>{
            for await (const value of stream)callback(value);
        });
    }
    /**
   * Close the message queue and wait for the pipes to drain.
   */ drain() {
        this.messageQueue.end();
        return this.connectionClosePromise;
    }
}
// Stream-oriented JSON encoding/decoding.
const $9cdd74141a3788c5$var$json = {
    async *encode (stream) {
        for await (const value of stream)yield JSON.stringify(value);
    },
    async *decode (stream) {
        for await (const value of stream)yield JSON.parse(value);
    }
};

});
parcelRequire.register("d8Blz", function(module, exports) {
const $9908fe046d9addb9$var$rawPipe = (...fns)=>{
    let res;
    while(fns.length)res = fns.shift()(res);
    return res;
};
const $9908fe046d9addb9$var$isIterable = (obj)=>obj && (typeof obj[Symbol.asyncIterator] === "function" || typeof obj[Symbol.iterator] === "function" || typeof obj.next === "function" // Probably, right?
    );
const $9908fe046d9addb9$var$isDuplex = (obj)=>obj && typeof obj.sink === "function" && $9908fe046d9addb9$var$isIterable(obj.source);
const $9908fe046d9addb9$var$duplexPipelineFn = (duplex)=>(source)=>{
        duplex.sink(source) // TODO: error on sink side is unhandled rejection - this is the same as pull streams
        ;
        return duplex.source;
    };
const $9908fe046d9addb9$var$pipe = (...fns)=>{
    // Duplex at start: wrap in function and return duplex source
    if ($9908fe046d9addb9$var$isDuplex(fns[0])) {
        const duplex = fns[0];
        fns[0] = ()=>duplex.source;
    // Iterable at start: wrap in function
    } else if ($9908fe046d9addb9$var$isIterable(fns[0])) {
        const source = fns[0];
        fns[0] = ()=>source;
    }
    if (fns.length > 1) // Duplex at end: use duplex sink
    {
        if ($9908fe046d9addb9$var$isDuplex(fns[fns.length - 1])) fns[fns.length - 1] = fns[fns.length - 1].sink;
    }
    if (fns.length > 2) {
        // Duplex in the middle, consume source with duplex sink and return duplex source
        for(let i = 1; i < fns.length - 1; i++)if ($9908fe046d9addb9$var$isDuplex(fns[i])) fns[i] = $9908fe046d9addb9$var$duplexPipelineFn(fns[i]);
    }
    return $9908fe046d9addb9$var$rawPipe(...fns);
};
module.exports = $9908fe046d9addb9$var$pipe;
module.exports.pipe = $9908fe046d9addb9$var$pipe;
module.exports.rawPipe = $9908fe046d9addb9$var$rawPipe;
module.exports.isIterable = $9908fe046d9addb9$var$isIterable;
module.exports.isDuplex = $9908fe046d9addb9$var$isDuplex;

});

parcelRequire.register("39TYQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b93508c7daf4603$export$2e2bcd8739ae039);

var $aBCUe = parcelRequire("aBCUe");
class $8b93508c7daf4603$export$2e2bcd8739ae039 {
    static of(data) {
        const queue = new $8b93508c7daf4603$export$2e2bcd8739ae039();
        data.forEach((value)=>queue.append(value));
        queue.end();
        return queue;
    }
    async *[Symbol.asyncIterator]() {
        while(true)try {
            yield await this.drawNextItem();
        } catch (error) {
            // Deferred promises don't contain execution code, they are purely
            // used as value containers. The only way they can reject is
            // intentionally through `.end()`.
            return;
        }
    }
    drawNextItem() {
        // The iterator is slower than the supply.
        if (this.ready.length) return this.ready.shift().promise;
        // The iterator is faster than the supply.
        const request = (0, $aBCUe.default)();
        this.pending.push(request);
        return request.promise;
    }
    /**
   * Append an item to the iterator's queue.
   */ append(value) {
        if (this.pending.length) {
            const request = this.pending.shift();
            request.resolve(value);
        } else {
            const item = (0, $aBCUe.default)();
            item.resolve(value);
            this.ready.push(item);
        }
    }
    /**
   * Once the queue runs out of resources, gracefully close the iterator.
   */ end() {
        const error = new Error("AsyncQueue: ended gracefully");
        if (this.pending.length) {
            const request = this.pending.shift();
            request.reject(error);
        } else {
            const termination = (0, $aBCUe.default)();
            termination.reject(error);
            this.ready.push(termination);
        }
    }
    constructor(){
        // Queue of items ready to be consumed. This is used when we're filling
        // values before the iterator requests them.
        this.ready = [];
        // Queue of demands by the iterator. Used when we're running behind, and
        // there aren't enough values to satisfy the iterator's requests.
        this.pending = [];
    }
}

});
parcelRequire.register("aBCUe", function(module, exports) {

$parcel$export(module.exports, "default", () => $36b8dace436c1afe$export$2e2bcd8739ae039);
function $36b8dace436c1afe$export$2e2bcd8739ae039() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        resolve: resolve,
        promise: promise,
        reject: reject
    };
}

});




parcelRequire.register("7CLZx", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("l5xaL")).default);

var $l5xaL = parcelRequire("l5xaL");

});
parcelRequire.register("l5xaL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e934e88a5ec6ba3$export$2e2bcd8739ae039);

var $kXV5G = parcelRequire("kXV5G");

var $fRjbn = parcelRequire("fRjbn");

var $2qq78 = parcelRequire("2qq78");

var $fYH48 = parcelRequire("fYH48");
const $4e934e88a5ec6ba3$var$logger = new (0, $fRjbn.default)("ConnectionManager");


class $4e934e88a5ec6ba3$export$2e2bcd8739ae039 {
    static async create(config) {
        const mgr = new $4e934e88a5ec6ba3$export$2e2bcd8739ae039({
            ...config,
            webrtcSettings: await (0, $fYH48.default)()
        });
        return mgr;
    }
    constructor({ localId: localId, remoteId: remoteId, signaler: signaler, webrtcSettings: webrtcSettings }){
        this.makingOffer = false;
        this.ignoreIceErrors = false;
        this.emitTrackAddedEvent = async ({ track: track, streams: streams })=>{
            $4e934e88a5ec6ba3$var$logger.debug(`Incoming remote ${track.kind} track`);
            const source = streams.length === 1 ? (0, $kXV5G.TrackSource).Display : (0, $kXV5G.TrackSource).Device;
            const [stream] = streams;
            stream.onremovetrack = this.emitTrackRemovedEvent;
            const { default: sdk } = await (parcelRequire("1TaNK"));
            sdk.tracks.add({
                peerId: this.remoteId,
                source: source,
                track: track
            });
        };
        this.emitTrackRemovedEvent = async (event)=>{
            $4e934e88a5ec6ba3$var$logger.debug("Remote track was removed:", event.track.id);
            const { default: sdk } = await (parcelRequire("1TaNK"));
            sdk.tracks.remove({
                trackId: event.track.id,
                peerId: this.remoteId
            });
        };
        this.sendIceCandidate = ({ candidate: candidate })=>{
            const msg = {
                type: $4e934e88a5ec6ba3$export$80edbf15fa61a4db.IceCandidate,
                payload: candidate
            };
            $4e934e88a5ec6ba3$var$logger.debug("Sending ICE candidate:", candidate?.candidate);
            this.signaler.send(msg);
        };
        this.updateLocalSession = async ()=>{
            // Used to detect conflicts (two people calling each other).
            this.makingOffer = true;
            try {
                await this.pc.setLocalDescription();
            } finally{
                this.makingOffer = false;
            }
            const payload = this.pc.localDescription;
            const msg = {
                type: $4e934e88a5ec6ba3$export$80edbf15fa61a4db.SessionDescription,
                payload: payload
            };
            $4e934e88a5ec6ba3$var$logger.debug(`Sending session description '${payload.type}'`);
            this.signaler.send(msg);
        };
        this.processMessage = async (message)=>{
            if (!message) return; // Sanity check the message.
            switch(message.type){
                case $4e934e88a5ec6ba3$export$80edbf15fa61a4db.SessionDescription:
                    $4e934e88a5ec6ba3$var$logger.debug(`Receiving session description '${message.payload.type}'`);
                    return this.processRemoteSessionDescription(message.payload);
                case $4e934e88a5ec6ba3$export$80edbf15fa61a4db.IceCandidate:
                    try {
                        $4e934e88a5ec6ba3$var$logger.debug("Receiving ICE candidate:", message.payload?.candidate);
                        await this.pc.addIceCandidate(message.payload);
                    } catch (error) {
                        if (this.ignoreIceErrors) $4e934e88a5ec6ba3$var$logger.warn("Ignoring ICE error (follows offer conflict)", error);
                        else throw error;
                    }
            }
        };
        this.signaler = signaler;
        this.remoteId = remoteId;
        // 'polite' determines who backs down in a signaling conflict.
        this.polite = localId < remoteId;
        $4e934e88a5ec6ba3$var$logger.debug("Opening WebRTC connection:", `${localId} => ${remoteId}`);
        $4e934e88a5ec6ba3$var$logger.debug(`Signaling mode is '${this.polite ? "polite" : "impolite"}'`);
        this.signaler.subscribe(this.processMessage);
        this.pc = new RTCPeerConnection(webrtcSettings);
        this.pc.ontrack = this.emitTrackAddedEvent;
        this.pc.onicecandidate = this.sendIceCandidate;
        this.pc.onnegotiationneeded = this.updateLocalSession;
        // Side effect: logs connection state changes.
        $4e934e88a5ec6ba3$export$5dfff15a8f7e3931.observe(this.pc);
        // Side effect: triggers connection setup. Register event handlers first.
        this.messenger = new (0, $2qq78.default)({
            pc: this.pc,
            remoteId: remoteId
        });
    }
    /**
   * Send an audio/video track to the remote peer, received under
   * `pc.ontrack`.
   */ addTrack(track, source) {
        const sender = this.pc.getSenders().find((sender)=>sender.track === track);
        // The track is already shared.
        if (sender) return;
        $4e934e88a5ec6ba3$var$logger.debug(`Adding ${track.kind} track`);
        // Let me explain my genius. Since there isn't a way to communicate
        // arbitrary data with a new track, the receiving side has no idea what it
        // goes to. It could be a webcam or a chrome tab and they'd both look just
        // as opaque. Data channel messages are limited too, as the messages
        // might not make it through and we don't have consistent track IDs
        // anyway.
        //
        // But we have a secret weapon. You can associate a variable number of
        // media streams with each track. We don't have to *use* those streams,
        // the other side just has to count them. We predefine each count with
        // a track type and voila! Now we know what the track is for.
        if (source === (0, $kXV5G.TrackSource).Display) this.pc.addTrack(track, new MediaStream());
        else this.pc.addTrack(track, new MediaStream(), new MediaStream());
    }
    /**
   * Detatches a track from the WebRTC connection. If we aren't already
   * sending the track, this is a no-op.
   */ removeTrack(track) {
        const sender = this.pc.getSenders().find((sender)=>sender.track === track);
        if (sender) {
            $4e934e88a5ec6ba3$var$logger.debug("Removing track:", track.id);
            this.pc.removeTrack(sender);
        }
    }
    /**
   * Permanently closes the peer connection. The 'close' event fires on the
   * remote data channel.
   */ close() {
        $4e934e88a5ec6ba3$var$logger.debug("Closing peer connection");
        this.messenger.close();
        this.signaler.close();
        this.pc.close();
    }
    async processRemoteSessionDescription(desc) {
        const conflictingOffer = desc.type === (0, $kXV5G.RtcDescriptionType).Offer && (this.makingOffer || this.pc.signalingState !== (0, $kXV5G.RtcSignalingState).Stable);
        // The "polite" peer will rollback their offer and turn into a receiver.
        if (conflictingOffer) {
            $4e934e88a5ec6ba3$var$logger.warn("Received conflicting offer");
            if (!this.polite) {
                this.ignoreIceErrors = true;
                $4e934e88a5ec6ba3$var$logger.debug("Ignoring conflict (impolite mode)");
                return;
            } else $4e934e88a5ec6ba3$var$logger.debug("Resolving conflict, generating answer (polite mode)");
        }
        await this.pc.setRemoteDescription(desc);
        if (desc.type === (0, $kXV5G.RtcDescriptionType).Offer) {
            await this.pc.setLocalDescription();
            const msg = {
                type: $4e934e88a5ec6ba3$export$80edbf15fa61a4db.SessionDescription,
                payload: this.pc.localDescription
            };
            $4e934e88a5ec6ba3$var$logger.debug(`Answering other peer's offer`);
            this.signaler.send(msg);
        }
    }
}
class $4e934e88a5ec6ba3$export$5dfff15a8f7e3931 {
    static observe(pc) {
        return new $4e934e88a5ec6ba3$export$5dfff15a8f7e3931(pc);
    }
    constructor(pc){
        this.successStates = new Set([
            "connected",
            "completed"
        ]);
        this.observeIceConnectionState = ()=>{
            this.logIceConnectionState(this.oldIceConnectionState, this.pc.iceConnectionState);
            this.oldIceConnectionState = this.pc.iceConnectionState;
        };
        this.pc = pc;
        this.oldIceConnectionState = this.pc.iceConnectionState;
        this.pc.addEventListener("iceconnectionstatechange", this.observeIceConnectionState);
    }
    logIceConnectionState(previous, current) {
        switch(current){
            case "checking":
                return $4e934e88a5ec6ba3$var$logger.debug("Testing remote candidates...");
            case "disconnected":
                return $4e934e88a5ec6ba3$var$logger.warn(`Disconnected.`);
            case "failed":
                return $4e934e88a5ec6ba3$var$logger.error("Connection failed.");
            case "closed":
                return $4e934e88a5ec6ba3$var$logger.debug("Connection closed.");
        }
        // Under rare circumstances, it's possible to transition from 'checking'
        // directly to 'completed', skipping 'connected'. Don't log twice.
        if (!this.successStates.has(previous) && this.successStates.has(current)) $4e934e88a5ec6ba3$var$logger.debug("Connection successful.");
    }
}
var $4e934e88a5ec6ba3$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["IceCandidate"] = "ice-candidate";
    MessageType["SessionDescription"] = "session-description";
})($4e934e88a5ec6ba3$export$80edbf15fa61a4db || ($4e934e88a5ec6ba3$export$80edbf15fa61a4db = {}));

});
parcelRequire.register("2qq78", function(module, exports) {

$parcel$export(module.exports, "default", () => $05314ecf9aad5c0e$export$2e2bcd8739ae039);

var $b5FWc = parcelRequire("b5FWc");
var $bpJYv = parcelRequire("bpJYv");

var $fRjbn = parcelRequire("fRjbn");

var $2Gzy9 = parcelRequire("2Gzy9");
Object.assign(globalThis, {
    encode: $bpJYv.encode,
    decode: $b5FWc.decode
});
const $05314ecf9aad5c0e$var$MIME_TYPE = "application/msgpack";
const $05314ecf9aad5c0e$var$logger = new (0, $fRjbn.default)("DataChannelMessenger");


class $05314ecf9aad5c0e$export$2e2bcd8739ae039 {
    constructor({ pc: pc, remoteId: remoteId }){
        this.messageQueue = [];
        this.closedLocally = false;
        this.drainMessageQueue = ()=>{
            if (this.messageQueue.length) $05314ecf9aad5c0e$var$logger.debug("Channel is open. Draining message queue.");
            const messages = this.messageQueue.splice(0);
            messages.forEach((packet)=>this.channel.send(packet));
        };
        this.processMessage = async ({ data: data })=>{
            if (typeof data === "string") // All messages should be binary, encoded via MsgPack.
            return $05314ecf9aad5c0e$var$logger.error(`Inbound message was a string: "${data}"`);
            const envelope = this.parseIntoEnvelope(data);
            if (!envelope) return;
            $05314ecf9aad5c0e$var$logger.debug(`Received message (${envelope.data.type}):`, envelope.data);
            await this.appEvents.handleEvent(envelope.data);
        };
        this.parseIntoEnvelope = (data)=>{
            try {
                // Validate the packet.
                const envelope = (0, $b5FWc.decode)(data);
                // Validate the envelope.
                if (!envelope || typeof envelope !== "object" || !$05314ecf9aad5c0e$var$MessageClass.hasOwnProperty(Object(envelope).type)) {
                    $05314ecf9aad5c0e$var$logger.error("Received malformed envelope:", envelope);
                    return null;
                }
                const payload = Object(envelope).data;
                // Validate the message.
                if (!payload || typeof payload !== "object" || typeof Object(payload).type !== "string") {
                    $05314ecf9aad5c0e$var$logger.error("Received malformed payload:", envelope);
                    return null;
                }
                return envelope;
            } catch (error) {
                $05314ecf9aad5c0e$var$logger.error("Could not parse message:", error);
                return null;
            }
        };
        this.signalConnectionOpen = async ()=>{
            const { default: sdk } = await (parcelRequire("1TaNK"));
            sdk.connections.markConnected(this.remoteId);
            this.drainMessageQueue();
        };
        this.signalConnectionClosed = async ()=>{
            if (this.closedLocally) return;
            const { default: sdk } = await (parcelRequire("1TaNK"));
            sdk.connections.close(this.remoteId);
        };
        this.remoteId = remoteId;
        this.channel = pc.createDataChannel("app", {
            protocol: $05314ecf9aad5c0e$var$MIME_TYPE,
            negotiated: true,
            id: 0
        });
        // Prefer messages in `ArrayBuffer` instead of `Blob`.
        this.channel.binaryType = "arraybuffer";
        this.channel.onmessage = this.processMessage;
        this.channel.onopen = this.signalConnectionOpen;
        this.channel.onclose = this.signalConnectionClosed;
        this.appEvents = new (0, $2Gzy9.default)({
            remoteId: remoteId
        });
    }
    /**
   * Permanently closes the data channel. Does not issue a 'close' event
   * because the caller is already aware.
   */ close() {
        this.closedLocally = true;
        this.channel.close();
    }
    /** Send an arbitrary event object to the other client. */ sendEvent(event) {
        $05314ecf9aad5c0e$var$logger.debug(`Sending event (${event.type}):`, event);
        const envelope = {
            type: $05314ecf9aad5c0e$var$MessageClass.Notification,
            data: event
        };
        const packet = (0, $bpJYv.encode)(envelope);
        this.queueOutboundPacket(packet);
    }
    // Buffers messages in a queue until the socket opens. Note: if the socket
    // closes, all messages are lost. There is currently no way to transfer
    // messages to a new data channel.
    queueOutboundPacket(packet) {
        if (this.channel.readyState === "open") this.channel.send(packet);
        else {
            $05314ecf9aad5c0e$var$logger.debug(`Queuing packet while socket opens (readyState=${this.channel.readyState}).`);
            this.messageQueue.push(packet);
        }
    }
}
var /**
 * Inbound messages may have different 'message modes' which determine how the
 * message is processed.
 */ $05314ecf9aad5c0e$var$MessageClass;
(function(MessageClass) {
    MessageClass[MessageClass[/** Fire and forget. No response necessary. */ "Notification"] = 0] = "Notification";
})($05314ecf9aad5c0e$var$MessageClass || ($05314ecf9aad5c0e$var$MessageClass = {}));

});
parcelRequire.register("b5FWc", function(module, exports) {

$parcel$export(module.exports, "decode", () => $2a27736bd02ff0f8$export$2f872c0f2117be69);

var $3WD5Y = parcelRequire("3WD5Y");
var $2a27736bd02ff0f8$export$ca6ec972f712a9eb = {};
function $2a27736bd02ff0f8$export$2f872c0f2117be69(buffer, options) {
    if (options === void 0) options = $2a27736bd02ff0f8$export$ca6ec972f712a9eb;
    var decoder = new (0, $3WD5Y.Decoder)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
    return decoder.decode(buffer);
}
function $2a27736bd02ff0f8$export$43cc91859d9fdc54(buffer, options) {
    if (options === void 0) options = $2a27736bd02ff0f8$export$ca6ec972f712a9eb;
    var decoder = new (0, $3WD5Y.Decoder)(options.extensionCodec, options.context, options.maxStrLength, options.maxBinLength, options.maxArrayLength, options.maxMapLength, options.maxExtLength);
    return decoder.decodeMulti(buffer);
}

});
parcelRequire.register("3WD5Y", function(module, exports) {

$parcel$export(module.exports, "Decoder", () => $cad12591a8a2a73b$export$f9de6ca0bc043724);

var $a9m1I = parcelRequire("a9m1I");

var $kUjay = parcelRequire("kUjay");

var $eGB97 = parcelRequire("eGB97");

var $64fzU = parcelRequire("64fzU");

var $blTUw = parcelRequire("blTUw");

var $5fQ2g = parcelRequire("5fQ2g");

var $9fIVZ = parcelRequire("9fIVZ");
var $cad12591a8a2a73b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cad12591a8a2a73b$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $cad12591a8a2a73b$var$__asyncValues = undefined && undefined.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $cad12591a8a2a73b$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $cad12591a8a2a73b$var$__await ? (this.v = v, this) : new $cad12591a8a2a73b$var$__await(v);
};
var $cad12591a8a2a73b$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $cad12591a8a2a73b$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $cad12591a8a2a73b$var$isValidMapKeyType = function(key) {
    var keyType = typeof key;
    return keyType === "string" || keyType === "number";
};
var $cad12591a8a2a73b$var$HEAD_BYTE_REQUIRED = -1;
var $cad12591a8a2a73b$var$EMPTY_VIEW = new DataView(new ArrayBuffer(0));
var $cad12591a8a2a73b$var$EMPTY_BYTES = new Uint8Array($cad12591a8a2a73b$var$EMPTY_VIEW.buffer);
var $cad12591a8a2a73b$export$449c37eaf7093493 = function() {
    try {
        // IE11: The spec says it should throw RangeError,
        // IE11: but in IE11 it throws TypeError.
        $cad12591a8a2a73b$var$EMPTY_VIEW.getInt8(0);
    } catch (e) {
        return e.constructor;
    }
    throw new Error("never reached");
}();
var $cad12591a8a2a73b$var$MORE_DATA = new $cad12591a8a2a73b$export$449c37eaf7093493("Insufficient data");
var $cad12591a8a2a73b$var$sharedCachedKeyDecoder = new (0, $5fQ2g.CachedKeyDecoder)();
var $cad12591a8a2a73b$export$f9de6ca0bc043724 = /** @class */ function() {
    function Decoder(extensionCodec, context, maxStrLength, maxBinLength, maxArrayLength, maxMapLength, maxExtLength, keyDecoder) {
        if (extensionCodec === void 0) extensionCodec = (0, $kUjay.ExtensionCodec).defaultCodec;
        if (context === void 0) context = undefined;
        if (maxStrLength === void 0) maxStrLength = (0, $eGB97.UINT32_MAX);
        if (maxBinLength === void 0) maxBinLength = (0, $eGB97.UINT32_MAX);
        if (maxArrayLength === void 0) maxArrayLength = (0, $eGB97.UINT32_MAX);
        if (maxMapLength === void 0) maxMapLength = (0, $eGB97.UINT32_MAX);
        if (maxExtLength === void 0) maxExtLength = (0, $eGB97.UINT32_MAX);
        if (keyDecoder === void 0) keyDecoder = $cad12591a8a2a73b$var$sharedCachedKeyDecoder;
        this.extensionCodec = extensionCodec;
        this.context = context;
        this.maxStrLength = maxStrLength;
        this.maxBinLength = maxBinLength;
        this.maxArrayLength = maxArrayLength;
        this.maxMapLength = maxMapLength;
        this.maxExtLength = maxExtLength;
        this.keyDecoder = keyDecoder;
        this.totalPos = 0;
        this.pos = 0;
        this.view = $cad12591a8a2a73b$var$EMPTY_VIEW;
        this.bytes = $cad12591a8a2a73b$var$EMPTY_BYTES;
        this.headByte = $cad12591a8a2a73b$var$HEAD_BYTE_REQUIRED;
        this.stack = [];
    }
    Decoder.prototype.reinitializeState = function() {
        this.totalPos = 0;
        this.headByte = $cad12591a8a2a73b$var$HEAD_BYTE_REQUIRED;
        this.stack.length = 0;
    // view, bytes, and pos will be re-initialized in setBuffer()
    };
    Decoder.prototype.setBuffer = function(buffer) {
        this.bytes = (0, $blTUw.ensureUint8Array)(buffer);
        this.view = (0, $blTUw.createDataView)(this.bytes);
        this.pos = 0;
    };
    Decoder.prototype.appendBuffer = function(buffer) {
        if (this.headByte === $cad12591a8a2a73b$var$HEAD_BYTE_REQUIRED && !this.hasRemaining(1)) this.setBuffer(buffer);
        else {
            var remainingData = this.bytes.subarray(this.pos);
            var newData = (0, $blTUw.ensureUint8Array)(buffer);
            // concat remainingData + newData
            var newBuffer = new Uint8Array(remainingData.length + newData.length);
            newBuffer.set(remainingData);
            newBuffer.set(newData, remainingData.length);
            this.setBuffer(newBuffer);
        }
    };
    Decoder.prototype.hasRemaining = function(size) {
        return this.view.byteLength - this.pos >= size;
    };
    Decoder.prototype.createExtraByteError = function(posToShow) {
        var _a = this, view = _a.view, pos = _a.pos;
        return new RangeError("Extra ".concat(view.byteLength - pos, " of ").concat(view.byteLength, " byte(s) found at buffer[").concat(posToShow, "]"));
    };
    /**
     * @throws {@link DecodeError}
     * @throws {@link RangeError}
     */ Decoder.prototype.decode = function(buffer) {
        this.reinitializeState();
        this.setBuffer(buffer);
        var object = this.doDecodeSync();
        if (this.hasRemaining(1)) throw this.createExtraByteError(this.pos);
        return object;
    };
    Decoder.prototype.decodeMulti = function(buffer) {
        return $cad12591a8a2a73b$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    this.reinitializeState();
                    this.setBuffer(buffer);
                    _a.label = 1;
                case 1:
                    if (!this.hasRemaining(1)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        this.doDecodeSync()
                    ];
                case 2:
                    _a.sent();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    Decoder.prototype.decodeAsync = function(stream) {
        var stream_1, stream_1_1;
        var e_1, _a;
        return $cad12591a8a2a73b$var$__awaiter(this, void 0, void 0, function() {
            var decoded, object, buffer, e_1_1, _b, headByte, pos, totalPos;
            return $cad12591a8a2a73b$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        decoded = false;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            6,
                            7,
                            12
                        ]);
                        stream_1 = $cad12591a8a2a73b$var$__asyncValues(stream);
                        _c.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            stream_1.next()
                        ];
                    case 3:
                        if (!(stream_1_1 = _c.sent(), !stream_1_1.done)) return [
                            3 /*break*/ ,
                            5
                        ];
                        buffer = stream_1_1.value;
                        if (decoded) throw this.createExtraByteError(this.totalPos);
                        this.appendBuffer(buffer);
                        try {
                            object = this.doDecodeSync();
                            decoded = true;
                        } catch (e) {
                            if (!(e instanceof $cad12591a8a2a73b$export$449c37eaf7093493)) throw e; // rethrow
                        // fallthrough
                        }
                        this.totalPos += this.pos;
                        _c.label = 4;
                    case 4:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 6:
                        e_1_1 = _c.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 7:
                        _c.trys.push([
                            7,
                            ,
                            10,
                            11
                        ]);
                        if (!(stream_1_1 && !stream_1_1.done && (_a = stream_1.return))) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(stream_1)
                        ];
                    case 8:
                        _c.sent();
                        _c.label = 9;
                    case 9:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        if (e_1) throw e_1.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 11:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 12:
                        if (decoded) {
                            if (this.hasRemaining(1)) throw this.createExtraByteError(this.totalPos);
                            return [
                                2 /*return*/ ,
                                object
                            ];
                        }
                        _b = this, headByte = _b.headByte, pos = _b.pos, totalPos = _b.totalPos;
                        throw new RangeError("Insufficient data in parsing ".concat((0, $a9m1I.prettyByte)(headByte), " at ").concat(totalPos, " (").concat(pos, " in the current buffer)"));
                }
            });
        });
    };
    Decoder.prototype.decodeArrayStream = function(stream) {
        return this.decodeMultiAsync(stream, true);
    };
    Decoder.prototype.decodeStream = function(stream) {
        return this.decodeMultiAsync(stream, false);
    };
    Decoder.prototype.decodeMultiAsync = function(stream, isArray) {
        return $cad12591a8a2a73b$var$__asyncGenerator(this, arguments, function decodeMultiAsync_1() {
            var isArrayHeaderRequired, arrayItemsLeft, stream_2, stream_2_1, buffer, e_2, e_3_1;
            var e_3, _a;
            return $cad12591a8a2a73b$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        isArrayHeaderRequired = isArray;
                        arrayItemsLeft = -1;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            13,
                            14,
                            19
                        ]);
                        stream_2 = $cad12591a8a2a73b$var$__asyncValues(stream);
                        _b.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            $cad12591a8a2a73b$var$__await(stream_2.next())
                        ];
                    case 3:
                        if (!(stream_2_1 = _b.sent(), !stream_2_1.done)) return [
                            3 /*break*/ ,
                            12
                        ];
                        buffer = stream_2_1.value;
                        if (isArray && arrayItemsLeft === 0) throw this.createExtraByteError(this.totalPos);
                        this.appendBuffer(buffer);
                        if (isArrayHeaderRequired) {
                            arrayItemsLeft = this.readArraySize();
                            isArrayHeaderRequired = false;
                            this.complete();
                        }
                        _b.label = 4;
                    case 4:
                        _b.trys.push([
                            4,
                            9,
                            ,
                            10
                        ]);
                        _b.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            $cad12591a8a2a73b$var$__await(this.doDecodeSync())
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            _b.sent()
                        ];
                    case 7:
                        _b.sent();
                        if (--arrayItemsLeft === 0) return [
                            3 /*break*/ ,
                            8
                        ];
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        e_2 = _b.sent();
                        if (!(e_2 instanceof $cad12591a8a2a73b$export$449c37eaf7093493)) throw e_2; // rethrow
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 10:
                        this.totalPos += this.pos;
                        _b.label = 11;
                    case 11:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 12:
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 13:
                        e_3_1 = _b.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 14:
                        _b.trys.push([
                            14,
                            ,
                            17,
                            18
                        ]);
                        if (!(stream_2_1 && !stream_2_1.done && (_a = stream_2.return))) return [
                            3 /*break*/ ,
                            16
                        ];
                        return [
                            4 /*yield*/ ,
                            $cad12591a8a2a73b$var$__await(_a.call(stream_2))
                        ];
                    case 15:
                        _b.sent();
                        _b.label = 16;
                    case 16:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 17:
                        if (e_3) throw e_3.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 18:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 19:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Decoder.prototype.doDecodeSync = function() {
        DECODE: while(true){
            var headByte = this.readHeadByte();
            var object = void 0;
            if (headByte >= 0xe0) // negative fixint (111x xxxx) 0xe0 - 0xff
            object = headByte - 0x100;
            else if (headByte < 0xc0) {
                if (headByte < 0x80) // positive fixint (0xxx xxxx) 0x00 - 0x7f
                object = headByte;
                else if (headByte < 0x90) {
                    // fixmap (1000 xxxx) 0x80 - 0x8f
                    var size = headByte - 0x80;
                    if (size !== 0) {
                        this.pushMapState(size);
                        this.complete();
                        continue DECODE;
                    } else object = {};
                } else if (headByte < 0xa0) {
                    // fixarray (1001 xxxx) 0x90 - 0x9f
                    var size = headByte - 0x90;
                    if (size !== 0) {
                        this.pushArrayState(size);
                        this.complete();
                        continue DECODE;
                    } else object = [];
                } else {
                    // fixstr (101x xxxx) 0xa0 - 0xbf
                    var byteLength = headByte - 0xa0;
                    object = this.decodeUtf8String(byteLength, 0);
                }
            } else if (headByte === 0xc0) // nil
            object = null;
            else if (headByte === 0xc2) // false
            object = false;
            else if (headByte === 0xc3) // true
            object = true;
            else if (headByte === 0xca) // float 32
            object = this.readF32();
            else if (headByte === 0xcb) // float 64
            object = this.readF64();
            else if (headByte === 0xcc) // uint 8
            object = this.readU8();
            else if (headByte === 0xcd) // uint 16
            object = this.readU16();
            else if (headByte === 0xce) // uint 32
            object = this.readU32();
            else if (headByte === 0xcf) // uint 64
            object = this.readU64();
            else if (headByte === 0xd0) // int 8
            object = this.readI8();
            else if (headByte === 0xd1) // int 16
            object = this.readI16();
            else if (headByte === 0xd2) // int 32
            object = this.readI32();
            else if (headByte === 0xd3) // int 64
            object = this.readI64();
            else if (headByte === 0xd9) {
                // str 8
                var byteLength = this.lookU8();
                object = this.decodeUtf8String(byteLength, 1);
            } else if (headByte === 0xda) {
                // str 16
                var byteLength = this.lookU16();
                object = this.decodeUtf8String(byteLength, 2);
            } else if (headByte === 0xdb) {
                // str 32
                var byteLength = this.lookU32();
                object = this.decodeUtf8String(byteLength, 4);
            } else if (headByte === 0xdc) {
                // array 16
                var size = this.readU16();
                if (size !== 0) {
                    this.pushArrayState(size);
                    this.complete();
                    continue DECODE;
                } else object = [];
            } else if (headByte === 0xdd) {
                // array 32
                var size = this.readU32();
                if (size !== 0) {
                    this.pushArrayState(size);
                    this.complete();
                    continue DECODE;
                } else object = [];
            } else if (headByte === 0xde) {
                // map 16
                var size = this.readU16();
                if (size !== 0) {
                    this.pushMapState(size);
                    this.complete();
                    continue DECODE;
                } else object = {};
            } else if (headByte === 0xdf) {
                // map 32
                var size = this.readU32();
                if (size !== 0) {
                    this.pushMapState(size);
                    this.complete();
                    continue DECODE;
                } else object = {};
            } else if (headByte === 0xc4) {
                // bin 8
                var size = this.lookU8();
                object = this.decodeBinary(size, 1);
            } else if (headByte === 0xc5) {
                // bin 16
                var size = this.lookU16();
                object = this.decodeBinary(size, 2);
            } else if (headByte === 0xc6) {
                // bin 32
                var size = this.lookU32();
                object = this.decodeBinary(size, 4);
            } else if (headByte === 0xd4) // fixext 1
            object = this.decodeExtension(1, 0);
            else if (headByte === 0xd5) // fixext 2
            object = this.decodeExtension(2, 0);
            else if (headByte === 0xd6) // fixext 4
            object = this.decodeExtension(4, 0);
            else if (headByte === 0xd7) // fixext 8
            object = this.decodeExtension(8, 0);
            else if (headByte === 0xd8) // fixext 16
            object = this.decodeExtension(16, 0);
            else if (headByte === 0xc7) {
                // ext 8
                var size = this.lookU8();
                object = this.decodeExtension(size, 1);
            } else if (headByte === 0xc8) {
                // ext 16
                var size = this.lookU16();
                object = this.decodeExtension(size, 2);
            } else if (headByte === 0xc9) {
                // ext 32
                var size = this.lookU32();
                object = this.decodeExtension(size, 4);
            } else throw new (0, $9fIVZ.DecodeError)("Unrecognized type byte: ".concat((0, $a9m1I.prettyByte)(headByte)));
            this.complete();
            var stack = this.stack;
            while(stack.length > 0){
                // arrays and maps
                var state = stack[stack.length - 1];
                if (state.type === 0 /* State.ARRAY */ ) {
                    state.array[state.position] = object;
                    state.position++;
                    if (state.position === state.size) {
                        stack.pop();
                        object = state.array;
                    } else continue DECODE;
                } else if (state.type === 1 /* State.MAP_KEY */ ) {
                    if (!$cad12591a8a2a73b$var$isValidMapKeyType(object)) throw new (0, $9fIVZ.DecodeError)("The type of key must be string or number but " + typeof object);
                    if (object === "__proto__") throw new (0, $9fIVZ.DecodeError)("The key __proto__ is not allowed");
                    state.key = object;
                    state.type = 2 /* State.MAP_VALUE */ ;
                    continue DECODE;
                } else {
                    // it must be `state.type === State.MAP_VALUE` here
                    state.map[state.key] = object;
                    state.readCount++;
                    if (state.readCount === state.size) {
                        stack.pop();
                        object = state.map;
                    } else {
                        state.key = null;
                        state.type = 1 /* State.MAP_KEY */ ;
                        continue DECODE;
                    }
                }
            }
            return object;
        }
    };
    Decoder.prototype.readHeadByte = function() {
        if (this.headByte === $cad12591a8a2a73b$var$HEAD_BYTE_REQUIRED) this.headByte = this.readU8();
        return this.headByte;
    };
    Decoder.prototype.complete = function() {
        this.headByte = $cad12591a8a2a73b$var$HEAD_BYTE_REQUIRED;
    };
    Decoder.prototype.readArraySize = function() {
        var headByte = this.readHeadByte();
        switch(headByte){
            case 0xdc:
                return this.readU16();
            case 0xdd:
                return this.readU32();
            default:
                if (headByte < 0xa0) return headByte - 0x90;
                else throw new (0, $9fIVZ.DecodeError)("Unrecognized array type byte: ".concat((0, $a9m1I.prettyByte)(headByte)));
        }
    };
    Decoder.prototype.pushMapState = function(size) {
        if (size > this.maxMapLength) throw new (0, $9fIVZ.DecodeError)("Max length exceeded: map length (".concat(size, ") > maxMapLengthLength (").concat(this.maxMapLength, ")"));
        this.stack.push({
            type: 1 /* State.MAP_KEY */ ,
            size: size,
            key: null,
            readCount: 0,
            map: {}
        });
    };
    Decoder.prototype.pushArrayState = function(size) {
        if (size > this.maxArrayLength) throw new (0, $9fIVZ.DecodeError)("Max length exceeded: array length (".concat(size, ") > maxArrayLength (").concat(this.maxArrayLength, ")"));
        this.stack.push({
            type: 0 /* State.ARRAY */ ,
            size: size,
            array: new Array(size),
            position: 0
        });
    };
    Decoder.prototype.decodeUtf8String = function(byteLength, headerOffset) {
        var _a;
        if (byteLength > this.maxStrLength) throw new (0, $9fIVZ.DecodeError)("Max length exceeded: UTF-8 byte length (".concat(byteLength, ") > maxStrLength (").concat(this.maxStrLength, ")"));
        if (this.bytes.byteLength < this.pos + headerOffset + byteLength) throw $cad12591a8a2a73b$var$MORE_DATA;
        var offset = this.pos + headerOffset;
        var object;
        if (this.stateIsMapKey() && ((_a = this.keyDecoder) === null || _a === void 0 ? void 0 : _a.canBeCached(byteLength))) object = this.keyDecoder.decode(this.bytes, offset, byteLength);
        else if (byteLength > (0, $64fzU.TEXT_DECODER_THRESHOLD)) object = (0, $64fzU.utf8DecodeTD)(this.bytes, offset, byteLength);
        else object = (0, $64fzU.utf8DecodeJs)(this.bytes, offset, byteLength);
        this.pos += headerOffset + byteLength;
        return object;
    };
    Decoder.prototype.stateIsMapKey = function() {
        if (this.stack.length > 0) {
            var state = this.stack[this.stack.length - 1];
            return state.type === 1 /* State.MAP_KEY */ ;
        }
        return false;
    };
    Decoder.prototype.decodeBinary = function(byteLength, headOffset) {
        if (byteLength > this.maxBinLength) throw new (0, $9fIVZ.DecodeError)("Max length exceeded: bin length (".concat(byteLength, ") > maxBinLength (").concat(this.maxBinLength, ")"));
        if (!this.hasRemaining(byteLength + headOffset)) throw $cad12591a8a2a73b$var$MORE_DATA;
        var offset = this.pos + headOffset;
        var object = this.bytes.subarray(offset, offset + byteLength);
        this.pos += headOffset + byteLength;
        return object;
    };
    Decoder.prototype.decodeExtension = function(size, headOffset) {
        if (size > this.maxExtLength) throw new (0, $9fIVZ.DecodeError)("Max length exceeded: ext length (".concat(size, ") > maxExtLength (").concat(this.maxExtLength, ")"));
        var extType = this.view.getInt8(this.pos + headOffset);
        var data = this.decodeBinary(size, headOffset + 1 /* extType */ );
        return this.extensionCodec.decode(data, extType, this.context);
    };
    Decoder.prototype.lookU8 = function() {
        return this.view.getUint8(this.pos);
    };
    Decoder.prototype.lookU16 = function() {
        return this.view.getUint16(this.pos);
    };
    Decoder.prototype.lookU32 = function() {
        return this.view.getUint32(this.pos);
    };
    Decoder.prototype.readU8 = function() {
        var value = this.view.getUint8(this.pos);
        this.pos++;
        return value;
    };
    Decoder.prototype.readI8 = function() {
        var value = this.view.getInt8(this.pos);
        this.pos++;
        return value;
    };
    Decoder.prototype.readU16 = function() {
        var value = this.view.getUint16(this.pos);
        this.pos += 2;
        return value;
    };
    Decoder.prototype.readI16 = function() {
        var value = this.view.getInt16(this.pos);
        this.pos += 2;
        return value;
    };
    Decoder.prototype.readU32 = function() {
        var value = this.view.getUint32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readI32 = function() {
        var value = this.view.getInt32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readU64 = function() {
        var value = (0, $eGB97.getUint64)(this.view, this.pos);
        this.pos += 8;
        return value;
    };
    Decoder.prototype.readI64 = function() {
        var value = (0, $eGB97.getInt64)(this.view, this.pos);
        this.pos += 8;
        return value;
    };
    Decoder.prototype.readF32 = function() {
        var value = this.view.getFloat32(this.pos);
        this.pos += 4;
        return value;
    };
    Decoder.prototype.readF64 = function() {
        var value = this.view.getFloat64(this.pos);
        this.pos += 8;
        return value;
    };
    return Decoder;
}();

});
parcelRequire.register("a9m1I", function(module, exports) {

$parcel$export(module.exports, "prettyByte", () => $12e15e1f23eb2866$export$78406e843f5312da);
function $12e15e1f23eb2866$export$78406e843f5312da(byte) {
    return "".concat(byte < 0 ? "-" : "", "0x").concat(Math.abs(byte).toString(16).padStart(2, "0"));
}

});

parcelRequire.register("kUjay", function(module, exports) {

$parcel$export(module.exports, "ExtensionCodec", () => $cf1712a597413194$export$12677a794dbd89d7);
// ExtensionCodec to handle MessagePack extensions

var $f51rG = parcelRequire("f51rG");

var $ltLLK = parcelRequire("ltLLK");
var $cf1712a597413194$export$12677a794dbd89d7 = /** @class */ function() {
    function ExtensionCodec() {
        // built-in extensions
        this.builtInEncoders = [];
        this.builtInDecoders = [];
        // custom extensions
        this.encoders = [];
        this.decoders = [];
        this.register((0, $ltLLK.timestampExtension));
    }
    ExtensionCodec.prototype.register = function(_a) {
        var type = _a.type, encode = _a.encode, decode = _a.decode;
        if (type >= 0) {
            // custom extensions
            this.encoders[type] = encode;
            this.decoders[type] = decode;
        } else {
            // built-in extensions
            var index = 1 + type;
            this.builtInEncoders[index] = encode;
            this.builtInDecoders[index] = decode;
        }
    };
    ExtensionCodec.prototype.tryToEncode = function(object, context) {
        // built-in extensions
        for(var i = 0; i < this.builtInEncoders.length; i++){
            var encodeExt = this.builtInEncoders[i];
            if (encodeExt != null) {
                var data = encodeExt(object, context);
                if (data != null) {
                    var type = -1 - i;
                    return new (0, $f51rG.ExtData)(type, data);
                }
            }
        }
        // custom extensions
        for(var i = 0; i < this.encoders.length; i++){
            var encodeExt = this.encoders[i];
            if (encodeExt != null) {
                var data = encodeExt(object, context);
                if (data != null) {
                    var type = i;
                    return new (0, $f51rG.ExtData)(type, data);
                }
            }
        }
        if (object instanceof (0, $f51rG.ExtData)) // to keep ExtData as is
        return object;
        return null;
    };
    ExtensionCodec.prototype.decode = function(data, type, context) {
        var decodeExt = type < 0 ? this.builtInDecoders[-1 - type] : this.decoders[type];
        if (decodeExt) return decodeExt(data, type, context);
        else // decode() does not fail, returns ExtData instead.
        return new (0, $f51rG.ExtData)(type, data);
    };
    ExtensionCodec.defaultCodec = new ExtensionCodec();
    return ExtensionCodec;
}();

});
parcelRequire.register("f51rG", function(module, exports) {

$parcel$export(module.exports, "ExtData", () => $16c18c48ba38f73b$export$bcbeb236456bc779);
/**
 * ExtData is used to handle Extension Types that are not registered to ExtensionCodec.
 */ var $16c18c48ba38f73b$export$bcbeb236456bc779 = /** @class */ function() {
    function ExtData(type, data) {
        this.type = type;
        this.data = data;
    }
    return ExtData;
}();

});

parcelRequire.register("ltLLK", function(module, exports) {

$parcel$export(module.exports, "timestampExtension", () => $21c80ff2332e3943$export$8654479533463da1);
// https://github.com/msgpack/msgpack/blob/master/spec.md#timestamp-extension-type

var $9fIVZ = parcelRequire("9fIVZ");

var $eGB97 = parcelRequire("eGB97");
var $21c80ff2332e3943$export$f18369fc203f4e13 = -1;
var $21c80ff2332e3943$var$TIMESTAMP32_MAX_SEC = 4294967295; // 32-bit unsigned int
var $21c80ff2332e3943$var$TIMESTAMP64_MAX_SEC = 17179869183; // 34-bit unsigned int
function $21c80ff2332e3943$export$2fd05b828dd81159(_a) {
    var sec = _a.sec, nsec = _a.nsec;
    if (sec >= 0 && nsec >= 0 && sec <= $21c80ff2332e3943$var$TIMESTAMP64_MAX_SEC) {
        // Here sec >= 0 && nsec >= 0
        if (nsec === 0 && sec <= $21c80ff2332e3943$var$TIMESTAMP32_MAX_SEC) {
            // timestamp 32 = { sec32 (unsigned) }
            var rv = new Uint8Array(4);
            var view = new DataView(rv.buffer);
            view.setUint32(0, sec);
            return rv;
        } else {
            // timestamp 64 = { nsec30 (unsigned), sec34 (unsigned) }
            var secHigh = sec / 0x100000000;
            var secLow = sec & 0xffffffff;
            var rv = new Uint8Array(8);
            var view = new DataView(rv.buffer);
            // nsec30 | secHigh2
            view.setUint32(0, nsec << 2 | secHigh & 0x3);
            // secLow32
            view.setUint32(4, secLow);
            return rv;
        }
    } else {
        // timestamp 96 = { nsec32 (unsigned), sec64 (signed) }
        var rv = new Uint8Array(12);
        var view = new DataView(rv.buffer);
        view.setUint32(0, nsec);
        (0, $eGB97.setInt64)(view, 4, sec);
        return rv;
    }
}
function $21c80ff2332e3943$export$221d97b3b00b03c2(date) {
    var msec = date.getTime();
    var sec = Math.floor(msec / 1e3);
    var nsec = (msec - sec * 1e3) * 1e6;
    // Normalizes { sec, nsec } to ensure nsec is unsigned.
    var nsecInSec = Math.floor(nsec / 1e9);
    return {
        sec: sec + nsecInSec,
        nsec: nsec - nsecInSec * 1e9
    };
}
function $21c80ff2332e3943$export$32420f352fe0fc83(object) {
    if (object instanceof Date) {
        var timeSpec = $21c80ff2332e3943$export$221d97b3b00b03c2(object);
        return $21c80ff2332e3943$export$2fd05b828dd81159(timeSpec);
    } else return null;
}
function $21c80ff2332e3943$export$abfc8800a5159711(data) {
    var view = new DataView(data.buffer, data.byteOffset, data.byteLength);
    // data may be 32, 64, or 96 bits
    switch(data.byteLength){
        case 4:
            // timestamp 32 = { sec32 }
            var sec = view.getUint32(0);
            var nsec = 0;
            return {
                sec: sec,
                nsec: nsec
            };
        case 8:
            // timestamp 64 = { nsec30, sec34 }
            var nsec30AndSecHigh2 = view.getUint32(0);
            var secLow32 = view.getUint32(4);
            var sec = (nsec30AndSecHigh2 & 0x3) * 0x100000000 + secLow32;
            var nsec = nsec30AndSecHigh2 >>> 2;
            return {
                sec: sec,
                nsec: nsec
            };
        case 12:
            // timestamp 96 = { nsec32 (unsigned), sec64 (signed) }
            var sec = (0, $eGB97.getInt64)(view, 4);
            var nsec = view.getUint32(0);
            return {
                sec: sec,
                nsec: nsec
            };
        default:
            throw new (0, $9fIVZ.DecodeError)("Unrecognized data size for timestamp (expected 4, 8, or 12): ".concat(data.length));
    }
}
function $21c80ff2332e3943$export$80b8ff9315e4298f(data) {
    var timeSpec = $21c80ff2332e3943$export$abfc8800a5159711(data);
    return new Date(timeSpec.sec * 1e3 + timeSpec.nsec / 1e6);
}
var $21c80ff2332e3943$export$8654479533463da1 = {
    type: $21c80ff2332e3943$export$f18369fc203f4e13,
    encode: $21c80ff2332e3943$export$32420f352fe0fc83,
    decode: $21c80ff2332e3943$export$80b8ff9315e4298f
};

});
parcelRequire.register("9fIVZ", function(module, exports) {

$parcel$export(module.exports, "DecodeError", () => $a53d5dcb9a636d90$export$ef3eed12d06c0285);
var $a53d5dcb9a636d90$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a53d5dcb9a636d90$export$ef3eed12d06c0285 = /** @class */ function(_super) {
    $a53d5dcb9a636d90$var$__extends(DecodeError, _super);
    function DecodeError(message) {
        var _this = _super.call(this, message) || this;
        // fix the prototype chain in a cross-platform way
        var proto = Object.create(DecodeError.prototype);
        Object.setPrototypeOf(_this, proto);
        Object.defineProperty(_this, "name", {
            configurable: true,
            enumerable: false,
            value: DecodeError.name
        });
        return _this;
    }
    return DecodeError;
}(Error);

});

parcelRequire.register("eGB97", function(module, exports) {

$parcel$export(module.exports, "UINT32_MAX", () => $6daab2d0f19a8f73$export$3314b2c271c86d70);
$parcel$export(module.exports, "setUint64", () => $6daab2d0f19a8f73$export$20f71c4c8b0f96c3);
$parcel$export(module.exports, "setInt64", () => $6daab2d0f19a8f73$export$8532a5209571c04a);
$parcel$export(module.exports, "getInt64", () => $6daab2d0f19a8f73$export$69825c7adcc820c6);
$parcel$export(module.exports, "getUint64", () => $6daab2d0f19a8f73$export$59a2dbf579ff9568);
// Integer Utility
var $6daab2d0f19a8f73$export$3314b2c271c86d70 = 4294967295;
function $6daab2d0f19a8f73$export$20f71c4c8b0f96c3(view, offset, value) {
    var high = value / 4294967296;
    var low = value; // high bits are truncated by DataView
    view.setUint32(offset, high);
    view.setUint32(offset + 4, low);
}
function $6daab2d0f19a8f73$export$8532a5209571c04a(view, offset, value) {
    var high = Math.floor(value / 4294967296);
    var low = value; // high bits are truncated by DataView
    view.setUint32(offset, high);
    view.setUint32(offset + 4, low);
}
function $6daab2d0f19a8f73$export$69825c7adcc820c6(view, offset) {
    var high = view.getInt32(offset);
    var low = view.getUint32(offset + 4);
    return high * 4294967296 + low;
}
function $6daab2d0f19a8f73$export$59a2dbf579ff9568(view, offset) {
    var high = view.getUint32(offset);
    var low = view.getUint32(offset + 4);
    return high * 4294967296 + low;
}

});



parcelRequire.register("64fzU", function(module, exports) {

$parcel$export(module.exports, "utf8Count", () => $eff576fe2671dffc$export$b61de95301265227);
$parcel$export(module.exports, "utf8EncodeJs", () => $eff576fe2671dffc$export$1042e4338f1ef853);
$parcel$export(module.exports, "TEXT_ENCODER_THRESHOLD", () => $eff576fe2671dffc$export$ed34c0622b397238);
$parcel$export(module.exports, "utf8EncodeTE", () => $eff576fe2671dffc$export$34cfdc82d430524);
$parcel$export(module.exports, "utf8DecodeJs", () => $eff576fe2671dffc$export$551117984c2adf4f);
$parcel$export(module.exports, "TEXT_DECODER_THRESHOLD", () => $eff576fe2671dffc$export$d866281c5a66d1ef);
$parcel$export(module.exports, "utf8DecodeTD", () => $eff576fe2671dffc$export$6ed79e41309992dc);

var $eGB97 = parcelRequire("eGB97");

var $bvigH = parcelRequire("bvigH");
var $eff576fe2671dffc$var$_a, $eff576fe2671dffc$var$_b, $eff576fe2671dffc$var$_c;
var $eff576fe2671dffc$var$TEXT_ENCODING_AVAILABLE = (typeof $bvigH === "undefined" || (($eff576fe2671dffc$var$_a = $bvigH === null || $bvigH === void 0 ? void 0 : $bvigH.env) === null || $eff576fe2671dffc$var$_a === void 0 ? void 0 : $eff576fe2671dffc$var$_a["TEXT_ENCODING"]) !== "never") && typeof TextEncoder !== "undefined" && typeof TextDecoder !== "undefined";
function $eff576fe2671dffc$export$b61de95301265227(str) {
    var strLength = str.length;
    var byteLength = 0;
    var pos = 0;
    while(pos < strLength){
        var value = str.charCodeAt(pos++);
        if ((value & 0xffffff80) === 0) {
            // 1-byte
            byteLength++;
            continue;
        } else if ((value & 0xfffff800) === 0) // 2-bytes
        byteLength += 2;
        else {
            // handle surrogate pair
            if (value >= 0xd800 && value <= 0xdbff) // high surrogate
            {
                if (pos < strLength) {
                    var extra = str.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
            }
            if ((value & 0xffff0000) === 0) // 3-byte
            byteLength += 3;
            else // 4-byte
            byteLength += 4;
        }
    }
    return byteLength;
}
function $eff576fe2671dffc$export$1042e4338f1ef853(str, output, outputOffset) {
    var strLength = str.length;
    var offset = outputOffset;
    var pos = 0;
    while(pos < strLength){
        var value = str.charCodeAt(pos++);
        if ((value & 0xffffff80) === 0) {
            // 1-byte
            output[offset++] = value;
            continue;
        } else if ((value & 0xfffff800) === 0) // 2-bytes
        output[offset++] = value >> 6 & 0x1f | 0xc0;
        else {
            // handle surrogate pair
            if (value >= 0xd800 && value <= 0xdbff) // high surrogate
            {
                if (pos < strLength) {
                    var extra = str.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
            }
            if ((value & 0xffff0000) === 0) {
                // 3-byte
                output[offset++] = value >> 12 & 0x0f | 0xe0;
                output[offset++] = value >> 6 & 0x3f | 0x80;
            } else {
                // 4-byte
                output[offset++] = value >> 18 & 0x07 | 0xf0;
                output[offset++] = value >> 12 & 0x3f | 0x80;
                output[offset++] = value >> 6 & 0x3f | 0x80;
            }
        }
        output[offset++] = value & 0x3f | 0x80;
    }
}
var $eff576fe2671dffc$var$sharedTextEncoder = $eff576fe2671dffc$var$TEXT_ENCODING_AVAILABLE ? new TextEncoder() : undefined;
var $eff576fe2671dffc$export$ed34c0622b397238 = !$eff576fe2671dffc$var$TEXT_ENCODING_AVAILABLE ? (0, $eGB97.UINT32_MAX) : typeof $bvigH !== "undefined" && (($eff576fe2671dffc$var$_b = $bvigH === null || $bvigH === void 0 ? void 0 : $bvigH.env) === null || $eff576fe2671dffc$var$_b === void 0 ? void 0 : $eff576fe2671dffc$var$_b["TEXT_ENCODING"]) !== "force" ? 200 : 0;
function $eff576fe2671dffc$var$utf8EncodeTEencode(str, output, outputOffset) {
    output.set($eff576fe2671dffc$var$sharedTextEncoder.encode(str), outputOffset);
}
function $eff576fe2671dffc$var$utf8EncodeTEencodeInto(str, output, outputOffset) {
    $eff576fe2671dffc$var$sharedTextEncoder.encodeInto(str, output.subarray(outputOffset));
}
var $eff576fe2671dffc$export$34cfdc82d430524 = ($eff576fe2671dffc$var$sharedTextEncoder === null || $eff576fe2671dffc$var$sharedTextEncoder === void 0 ? void 0 : $eff576fe2671dffc$var$sharedTextEncoder.encodeInto) ? $eff576fe2671dffc$var$utf8EncodeTEencodeInto : $eff576fe2671dffc$var$utf8EncodeTEencode;
var $eff576fe2671dffc$var$CHUNK_SIZE = 4096;
function $eff576fe2671dffc$export$551117984c2adf4f(bytes, inputOffset, byteLength) {
    var offset = inputOffset;
    var end = offset + byteLength;
    var units = [];
    var result = "";
    while(offset < end){
        var byte1 = bytes[offset++];
        if ((byte1 & 0x80) === 0) // 1 byte
        units.push(byte1);
        else if ((byte1 & 0xe0) === 0xc0) {
            // 2 bytes
            var byte2 = bytes[offset++] & 0x3f;
            units.push((byte1 & 0x1f) << 6 | byte2);
        } else if ((byte1 & 0xf0) === 0xe0) {
            // 3 bytes
            var byte2 = bytes[offset++] & 0x3f;
            var byte3 = bytes[offset++] & 0x3f;
            units.push((byte1 & 0x1f) << 12 | byte2 << 6 | byte3);
        } else if ((byte1 & 0xf8) === 0xf0) {
            // 4 bytes
            var byte2 = bytes[offset++] & 0x3f;
            var byte3 = bytes[offset++] & 0x3f;
            var byte4 = bytes[offset++] & 0x3f;
            var unit = (byte1 & 0x07) << 0x12 | byte2 << 0x0c | byte3 << 0x06 | byte4;
            if (unit > 0xffff) {
                unit -= 0x10000;
                units.push(unit >>> 10 & 0x3ff | 0xd800);
                unit = 0xdc00 | unit & 0x3ff;
            }
            units.push(unit);
        } else units.push(byte1);
        if (units.length >= $eff576fe2671dffc$var$CHUNK_SIZE) {
            result += String.fromCharCode.apply(String, units);
            units.length = 0;
        }
    }
    if (units.length > 0) result += String.fromCharCode.apply(String, units);
    return result;
}
var $eff576fe2671dffc$var$sharedTextDecoder = $eff576fe2671dffc$var$TEXT_ENCODING_AVAILABLE ? new TextDecoder() : null;
var $eff576fe2671dffc$export$d866281c5a66d1ef = !$eff576fe2671dffc$var$TEXT_ENCODING_AVAILABLE ? (0, $eGB97.UINT32_MAX) : typeof $bvigH !== "undefined" && (($eff576fe2671dffc$var$_c = $bvigH === null || $bvigH === void 0 ? void 0 : $bvigH.env) === null || $eff576fe2671dffc$var$_c === void 0 ? void 0 : $eff576fe2671dffc$var$_c["TEXT_DECODER"]) !== "force" ? 200 : 0;
function $eff576fe2671dffc$export$6ed79e41309992dc(bytes, inputOffset, byteLength) {
    var stringBytes = bytes.subarray(inputOffset, inputOffset + byteLength);
    return $eff576fe2671dffc$var$sharedTextDecoder.decode(stringBytes);
}

});

parcelRequire.register("blTUw", function(module, exports) {

$parcel$export(module.exports, "ensureUint8Array", () => $38df7d0a362f0312$export$f8d669c2a17882f2);
$parcel$export(module.exports, "createDataView", () => $38df7d0a362f0312$export$7277868462c1ba02);
function $38df7d0a362f0312$export$f8d669c2a17882f2(buffer) {
    if (buffer instanceof Uint8Array) return buffer;
    else if (ArrayBuffer.isView(buffer)) return new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    else if (buffer instanceof ArrayBuffer) return new Uint8Array(buffer);
    else // ArrayLike<number>
    return Uint8Array.from(buffer);
}
function $38df7d0a362f0312$export$7277868462c1ba02(buffer) {
    if (buffer instanceof ArrayBuffer) return new DataView(buffer);
    var bufferView = $38df7d0a362f0312$export$f8d669c2a17882f2(buffer);
    return new DataView(bufferView.buffer, bufferView.byteOffset, bufferView.byteLength);
}

});

parcelRequire.register("5fQ2g", function(module, exports) {

$parcel$export(module.exports, "CachedKeyDecoder", () => $0237b09e39cc050b$export$529b830450faf29c);

var $64fzU = parcelRequire("64fzU");
var $0237b09e39cc050b$var$DEFAULT_MAX_KEY_LENGTH = 16;
var $0237b09e39cc050b$var$DEFAULT_MAX_LENGTH_PER_KEY = 16;
var $0237b09e39cc050b$export$529b830450faf29c = /** @class */ function() {
    function CachedKeyDecoder(maxKeyLength, maxLengthPerKey) {
        if (maxKeyLength === void 0) maxKeyLength = $0237b09e39cc050b$var$DEFAULT_MAX_KEY_LENGTH;
        if (maxLengthPerKey === void 0) maxLengthPerKey = $0237b09e39cc050b$var$DEFAULT_MAX_LENGTH_PER_KEY;
        this.maxKeyLength = maxKeyLength;
        this.maxLengthPerKey = maxLengthPerKey;
        this.hit = 0;
        this.miss = 0;
        // avoid `new Array(N)`, which makes a sparse array,
        // because a sparse array is typically slower than a non-sparse array.
        this.caches = [];
        for(var i = 0; i < this.maxKeyLength; i++)this.caches.push([]);
    }
    CachedKeyDecoder.prototype.canBeCached = function(byteLength) {
        return byteLength > 0 && byteLength <= this.maxKeyLength;
    };
    CachedKeyDecoder.prototype.find = function(bytes, inputOffset, byteLength) {
        var records = this.caches[byteLength - 1];
        FIND_CHUNK: for(var _i = 0, records_1 = records; _i < records_1.length; _i++){
            var record = records_1[_i];
            var recordBytes = record.bytes;
            for(var j = 0; j < byteLength; j++){
                if (recordBytes[j] !== bytes[inputOffset + j]) continue FIND_CHUNK;
            }
            return record.str;
        }
        return null;
    };
    CachedKeyDecoder.prototype.store = function(bytes, value) {
        var records = this.caches[bytes.length - 1];
        var record = {
            bytes: bytes,
            str: value
        };
        if (records.length >= this.maxLengthPerKey) // `records` are full!
        // Set `record` to an arbitrary position.
        records[Math.random() * records.length | 0] = record;
        else records.push(record);
    };
    CachedKeyDecoder.prototype.decode = function(bytes, inputOffset, byteLength) {
        var cachedValue = this.find(bytes, inputOffset, byteLength);
        if (cachedValue != null) {
            this.hit++;
            return cachedValue;
        }
        this.miss++;
        var str = (0, $64fzU.utf8DecodeJs)(bytes, inputOffset, byteLength);
        // Ensure to copy a slice of bytes because the byte may be NodeJS Buffer and Buffer#slice() returns a reference to its internal ArrayBuffer.
        var slicedCopyOfBytes = Uint8Array.prototype.slice.call(bytes, inputOffset, inputOffset + byteLength);
        this.store(slicedCopyOfBytes, str);
        return str;
    };
    return CachedKeyDecoder;
}();

});



parcelRequire.register("bpJYv", function(module, exports) {

$parcel$export(module.exports, "encode", () => $44cb84e919b2606d$export$c564cdbbe6da493);

var $df33J = parcelRequire("df33J");
var $44cb84e919b2606d$var$defaultEncodeOptions = {};
function $44cb84e919b2606d$export$c564cdbbe6da493(value, options) {
    if (options === void 0) options = $44cb84e919b2606d$var$defaultEncodeOptions;
    var encoder = new (0, $df33J.Encoder)(options.extensionCodec, options.context, options.maxDepth, options.initialBufferSize, options.sortKeys, options.forceFloat32, options.ignoreUndefined, options.forceIntegerToFloat);
    return encoder.encodeSharedRef(value);
}

});
parcelRequire.register("df33J", function(module, exports) {

$parcel$export(module.exports, "Encoder", () => $8affa4a537ce33d9$export$a50aceb0e02a00aa);

var $64fzU = parcelRequire("64fzU");

var $kUjay = parcelRequire("kUjay");

var $eGB97 = parcelRequire("eGB97");

var $blTUw = parcelRequire("blTUw");
var $8affa4a537ce33d9$export$2c6de1218fe0e46d = 100;
var $8affa4a537ce33d9$export$29659805a45f979c = 2048;
var $8affa4a537ce33d9$export$a50aceb0e02a00aa = /** @class */ function() {
    function Encoder(extensionCodec, context, maxDepth, initialBufferSize, sortKeys, forceFloat32, ignoreUndefined, forceIntegerToFloat) {
        if (extensionCodec === void 0) extensionCodec = (0, $kUjay.ExtensionCodec).defaultCodec;
        if (context === void 0) context = undefined;
        if (maxDepth === void 0) maxDepth = $8affa4a537ce33d9$export$2c6de1218fe0e46d;
        if (initialBufferSize === void 0) initialBufferSize = $8affa4a537ce33d9$export$29659805a45f979c;
        if (sortKeys === void 0) sortKeys = false;
        if (forceFloat32 === void 0) forceFloat32 = false;
        if (ignoreUndefined === void 0) ignoreUndefined = false;
        if (forceIntegerToFloat === void 0) forceIntegerToFloat = false;
        this.extensionCodec = extensionCodec;
        this.context = context;
        this.maxDepth = maxDepth;
        this.initialBufferSize = initialBufferSize;
        this.sortKeys = sortKeys;
        this.forceFloat32 = forceFloat32;
        this.ignoreUndefined = ignoreUndefined;
        this.forceIntegerToFloat = forceIntegerToFloat;
        this.pos = 0;
        this.view = new DataView(new ArrayBuffer(this.initialBufferSize));
        this.bytes = new Uint8Array(this.view.buffer);
    }
    Encoder.prototype.reinitializeState = function() {
        this.pos = 0;
    };
    /**
     * This is almost equivalent to {@link Encoder#encode}, but it returns an reference of the encoder's internal buffer and thus much faster than {@link Encoder#encode}.
     *
     * @returns Encodes the object and returns a shared reference the encoder's internal buffer.
     */ Encoder.prototype.encodeSharedRef = function(object) {
        this.reinitializeState();
        this.doEncode(object, 1);
        return this.bytes.subarray(0, this.pos);
    };
    /**
     * @returns Encodes the object and returns a copy of the encoder's internal buffer.
     */ Encoder.prototype.encode = function(object) {
        this.reinitializeState();
        this.doEncode(object, 1);
        return this.bytes.slice(0, this.pos);
    };
    Encoder.prototype.doEncode = function(object, depth) {
        if (depth > this.maxDepth) throw new Error("Too deep objects in depth ".concat(depth));
        if (object == null) this.encodeNil();
        else if (typeof object === "boolean") this.encodeBoolean(object);
        else if (typeof object === "number") this.encodeNumber(object);
        else if (typeof object === "string") this.encodeString(object);
        else this.encodeObject(object, depth);
    };
    Encoder.prototype.ensureBufferSizeToWrite = function(sizeToWrite) {
        var requiredSize = this.pos + sizeToWrite;
        if (this.view.byteLength < requiredSize) this.resizeBuffer(requiredSize * 2);
    };
    Encoder.prototype.resizeBuffer = function(newSize) {
        var newBuffer = new ArrayBuffer(newSize);
        var newBytes = new Uint8Array(newBuffer);
        var newView = new DataView(newBuffer);
        newBytes.set(this.bytes);
        this.view = newView;
        this.bytes = newBytes;
    };
    Encoder.prototype.encodeNil = function() {
        this.writeU8(0xc0);
    };
    Encoder.prototype.encodeBoolean = function(object) {
        if (object === false) this.writeU8(0xc2);
        else this.writeU8(0xc3);
    };
    Encoder.prototype.encodeNumber = function(object) {
        if (Number.isSafeInteger(object) && !this.forceIntegerToFloat) {
            if (object >= 0) {
                if (object < 0x80) // positive fixint
                this.writeU8(object);
                else if (object < 0x100) {
                    // uint 8
                    this.writeU8(0xcc);
                    this.writeU8(object);
                } else if (object < 0x10000) {
                    // uint 16
                    this.writeU8(0xcd);
                    this.writeU16(object);
                } else if (object < 0x100000000) {
                    // uint 32
                    this.writeU8(0xce);
                    this.writeU32(object);
                } else {
                    // uint 64
                    this.writeU8(0xcf);
                    this.writeU64(object);
                }
            } else {
                if (object >= -32) // negative fixint
                this.writeU8(0xe0 | object + 0x20);
                else if (object >= -128) {
                    // int 8
                    this.writeU8(0xd0);
                    this.writeI8(object);
                } else if (object >= -32768) {
                    // int 16
                    this.writeU8(0xd1);
                    this.writeI16(object);
                } else if (object >= -2147483648) {
                    // int 32
                    this.writeU8(0xd2);
                    this.writeI32(object);
                } else {
                    // int 64
                    this.writeU8(0xd3);
                    this.writeI64(object);
                }
            }
        } else // non-integer numbers
        if (this.forceFloat32) {
            // float 32
            this.writeU8(0xca);
            this.writeF32(object);
        } else {
            // float 64
            this.writeU8(0xcb);
            this.writeF64(object);
        }
    };
    Encoder.prototype.writeStringHeader = function(byteLength) {
        if (byteLength < 32) // fixstr
        this.writeU8(0xa0 + byteLength);
        else if (byteLength < 0x100) {
            // str 8
            this.writeU8(0xd9);
            this.writeU8(byteLength);
        } else if (byteLength < 0x10000) {
            // str 16
            this.writeU8(0xda);
            this.writeU16(byteLength);
        } else if (byteLength < 0x100000000) {
            // str 32
            this.writeU8(0xdb);
            this.writeU32(byteLength);
        } else throw new Error("Too long string: ".concat(byteLength, " bytes in UTF-8"));
    };
    Encoder.prototype.encodeString = function(object) {
        var maxHeaderSize = 5;
        var strLength = object.length;
        if (strLength > (0, $64fzU.TEXT_ENCODER_THRESHOLD)) {
            var byteLength = (0, $64fzU.utf8Count)(object);
            this.ensureBufferSizeToWrite(maxHeaderSize + byteLength);
            this.writeStringHeader(byteLength);
            (0, $64fzU.utf8EncodeTE)(object, this.bytes, this.pos);
            this.pos += byteLength;
        } else {
            var byteLength = (0, $64fzU.utf8Count)(object);
            this.ensureBufferSizeToWrite(maxHeaderSize + byteLength);
            this.writeStringHeader(byteLength);
            (0, $64fzU.utf8EncodeJs)(object, this.bytes, this.pos);
            this.pos += byteLength;
        }
    };
    Encoder.prototype.encodeObject = function(object, depth) {
        // try to encode objects with custom codec first of non-primitives
        var ext = this.extensionCodec.tryToEncode(object, this.context);
        if (ext != null) this.encodeExtension(ext);
        else if (Array.isArray(object)) this.encodeArray(object, depth);
        else if (ArrayBuffer.isView(object)) this.encodeBinary(object);
        else if (typeof object === "object") this.encodeMap(object, depth);
        else // symbol, function and other special object come here unless extensionCodec handles them.
        throw new Error("Unrecognized object: ".concat(Object.prototype.toString.apply(object)));
    };
    Encoder.prototype.encodeBinary = function(object) {
        var size = object.byteLength;
        if (size < 0x100) {
            // bin 8
            this.writeU8(0xc4);
            this.writeU8(size);
        } else if (size < 0x10000) {
            // bin 16
            this.writeU8(0xc5);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // bin 32
            this.writeU8(0xc6);
            this.writeU32(size);
        } else throw new Error("Too large binary: ".concat(size));
        var bytes = (0, $blTUw.ensureUint8Array)(object);
        this.writeU8a(bytes);
    };
    Encoder.prototype.encodeArray = function(object, depth) {
        var size = object.length;
        if (size < 16) // fixarray
        this.writeU8(0x90 + size);
        else if (size < 0x10000) {
            // array 16
            this.writeU8(0xdc);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // array 32
            this.writeU8(0xdd);
            this.writeU32(size);
        } else throw new Error("Too large array: ".concat(size));
        for(var _i = 0, object_1 = object; _i < object_1.length; _i++){
            var item = object_1[_i];
            this.doEncode(item, depth + 1);
        }
    };
    Encoder.prototype.countWithoutUndefined = function(object, keys) {
        var count = 0;
        for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
            var key = keys_1[_i];
            if (object[key] !== undefined) count++;
        }
        return count;
    };
    Encoder.prototype.encodeMap = function(object, depth) {
        var keys = Object.keys(object);
        if (this.sortKeys) keys.sort();
        var size = this.ignoreUndefined ? this.countWithoutUndefined(object, keys) : keys.length;
        if (size < 16) // fixmap
        this.writeU8(0x80 + size);
        else if (size < 0x10000) {
            // map 16
            this.writeU8(0xde);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // map 32
            this.writeU8(0xdf);
            this.writeU32(size);
        } else throw new Error("Too large map object: ".concat(size));
        for(var _i = 0, keys_2 = keys; _i < keys_2.length; _i++){
            var key = keys_2[_i];
            var value = object[key];
            if (!(this.ignoreUndefined && value === undefined)) {
                this.encodeString(key);
                this.doEncode(value, depth + 1);
            }
        }
    };
    Encoder.prototype.encodeExtension = function(ext) {
        var size = ext.data.length;
        if (size === 1) // fixext 1
        this.writeU8(0xd4);
        else if (size === 2) // fixext 2
        this.writeU8(0xd5);
        else if (size === 4) // fixext 4
        this.writeU8(0xd6);
        else if (size === 8) // fixext 8
        this.writeU8(0xd7);
        else if (size === 16) // fixext 16
        this.writeU8(0xd8);
        else if (size < 0x100) {
            // ext 8
            this.writeU8(0xc7);
            this.writeU8(size);
        } else if (size < 0x10000) {
            // ext 16
            this.writeU8(0xc8);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // ext 32
            this.writeU8(0xc9);
            this.writeU32(size);
        } else throw new Error("Too large extension object: ".concat(size));
        this.writeI8(ext.type);
        this.writeU8a(ext.data);
    };
    Encoder.prototype.writeU8 = function(value) {
        this.ensureBufferSizeToWrite(1);
        this.view.setUint8(this.pos, value);
        this.pos++;
    };
    Encoder.prototype.writeU8a = function(values) {
        var size = values.length;
        this.ensureBufferSizeToWrite(size);
        this.bytes.set(values, this.pos);
        this.pos += size;
    };
    Encoder.prototype.writeI8 = function(value) {
        this.ensureBufferSizeToWrite(1);
        this.view.setInt8(this.pos, value);
        this.pos++;
    };
    Encoder.prototype.writeU16 = function(value) {
        this.ensureBufferSizeToWrite(2);
        this.view.setUint16(this.pos, value);
        this.pos += 2;
    };
    Encoder.prototype.writeI16 = function(value) {
        this.ensureBufferSizeToWrite(2);
        this.view.setInt16(this.pos, value);
        this.pos += 2;
    };
    Encoder.prototype.writeU32 = function(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setUint32(this.pos, value);
        this.pos += 4;
    };
    Encoder.prototype.writeI32 = function(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setInt32(this.pos, value);
        this.pos += 4;
    };
    Encoder.prototype.writeF32 = function(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setFloat32(this.pos, value);
        this.pos += 4;
    };
    Encoder.prototype.writeF64 = function(value) {
        this.ensureBufferSizeToWrite(8);
        this.view.setFloat64(this.pos, value);
        this.pos += 8;
    };
    Encoder.prototype.writeU64 = function(value) {
        this.ensureBufferSizeToWrite(8);
        (0, $eGB97.setUint64)(this.view, this.pos, value);
        this.pos += 8;
    };
    Encoder.prototype.writeI64 = function(value) {
        this.ensureBufferSizeToWrite(8);
        (0, $eGB97.setInt64)(this.view, this.pos, value);
        this.pos += 8;
    };
    return Encoder;
}();

});


parcelRequire.register("2Gzy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca668be8d6e4b443$export$2e2bcd8739ae039);

var $kXV5G = parcelRequire("kXV5G");

class $ca668be8d6e4b443$export$2e2bcd8739ae039 {
    constructor(config){
        this.remoteId = config.remoteId;
    }
    async handleEvent(event) {
        const { default: sdk } = await (parcelRequire("1TaNK"));
        switch(event.type){
            case (0, $kXV5G.EventType).Pause:
                return sdk.tracks.markPaused(event.payload.kind);
            case (0, $kXV5G.EventType).Resume:
                return sdk.tracks.markResumed(event.payload.kind);
            case (0, $kXV5G.EventType).ChatMessage:
                return sdk.chat.receiveMessage({
                    ...event.payload,
                    // Prevent senders from forging author IDs.
                    author: this.remoteId
                });
        }
    }
}

});


parcelRequire.register("fYH48", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf38a4dca63b22b$export$2e2bcd8739ae039);
parcelRequire("3jRC4");
var $9fjTl = parcelRequire("9fjTl");

var $kXV5G = parcelRequire("kXV5G");
async function $ebf38a4dca63b22b$export$2e2bcd8739ae039() {
    const { forceTurnRelay: forceTurnRelay, disableDefaultIceServers: disableDefaultIceServers, customIceServers: customIceServers } = await $9fjTl.load();
    return {
        iceTransportPolicy: forceTurnRelay ? "relay" : "all",
        iceServers: [].concat(customIceServers).concat(disableDefaultIceServers ? [] : (0, $kXV5G.ICE_SERVERS))
    };
}

});



parcelRequire.register("1bh1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $766f3e4125110881$export$2e2bcd8739ae039);

var $5lHKx = parcelRequire("5lHKx");

var $eh5zb = parcelRequire("eh5zb");

var $01L0M = parcelRequire("01L0M");

var $hslgQ = parcelRequire("hslgQ");

var $jvgiY = parcelRequire("jvgiY");

var $ksmXv = parcelRequire("ksmXv");

var $edPLI = parcelRequire("edPLI");

var $kBs7x = parcelRequire("kBs7x");

var $7W5YA = parcelRequire("7W5YA");

var $gJdz0 = parcelRequire("gJdz0");

var $fRjbn = parcelRequire("fRjbn");
const $766f3e4125110881$var$logger = new (0, $fRjbn.default)("libp2p");
async function $766f3e4125110881$export$2e2bcd8739ae039(signalingServer) {
    (0, $kBs7x.default)(!(0, $7W5YA.default).p2p, "libp2p is already initialized.");
    const p2p = await (0, (/*@__PURE__*/$parcel$interopDefault($5lHKx))).create({
        peerId: await $766f3e4125110881$export$e023550be58f303d(),
        addresses: {
            listen: [
                `${signalingServer}/p2p-circuit`
            ]
        },
        modules: {
            transport: [
                (0, (/*@__PURE__*/$parcel$interopDefault($hslgQ)))
            ],
            connEncryption: [
                (0, $eh5zb.NOISE)
            ],
            streamMuxer: [
                (0, (/*@__PURE__*/$parcel$interopDefault($01L0M)))
            ]
        },
        config: {
            transport: {
                [$766f3e4125110881$var$ModuleId.WebSockets]: {
                    filter: $jvgiY.all
                }
            }
        }
    });
    // Other effects depend on this singleton.
    (0, $7W5YA.default).p2p = p2p;
    return p2p;
}
async function $766f3e4125110881$export$e023550be58f303d() {
    const persistedPeerId = await (0, (/*@__PURE__*/$parcel$interopDefault($edPLI))).getItem((0, $gJdz0.default).PeerId);
    const peerId = persistedPeerId ? await (0, (/*@__PURE__*/$parcel$interopDefault($ksmXv))).createFromJSON(persistedPeerId) : await (0, (/*@__PURE__*/$parcel$interopDefault($ksmXv))).create();
    if (persistedPeerId) $766f3e4125110881$var$logger.debug("Restored peer ID:", peerId.toB58String());
    else {
        $766f3e4125110881$var$logger.debug("Created a new peer ID:", peerId.toB58String());
        await (0, (/*@__PURE__*/$parcel$interopDefault($edPLI))).setItem((0, $gJdz0.default).PeerId, peerId.toJSON());
    }
    return peerId;
}
const $766f3e4125110881$var$ModuleId = {
    WebSockets: (0, (/*@__PURE__*/$parcel$interopDefault($hslgQ))).prototype[Symbol.toStringTag]
};

});
parcelRequire.register("5lHKx", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $3e50d9ab5d717d43$var$log = Object.assign($jjmHV("libp2p"), {
    error: $jjmHV("libp2p:err")
});

var $7QXK1 = parcelRequire("7QXK1");
var $3e50d9ab5d717d43$require$EventEmitter = $7QXK1.EventEmitter;

var $20Lm5 = parcelRequire("20Lm5");

var $ksmXv = parcelRequire("ksmXv");

var $aZLwC = parcelRequire("aZLwC");
var $3e50d9ab5d717d43$require$Multiaddr = $aZLwC.Multiaddr;

var $glVMO = parcelRequire("glVMO");

var $hDYYu = parcelRequire("hDYYu");

var $gbbbW = parcelRequire("gbbbW");

var $1uW4V = parcelRequire("1uW4V");
var $3e50d9ab5d717d43$require$validateConfig = $1uW4V.validate;

var $8yAh4 = parcelRequire("8yAh4");
var $3e50d9ab5d717d43$require$codes = $8yAh4.codes;
var $3e50d9ab5d717d43$require$messages = $8yAh4.messages;

var $g1JQx = parcelRequire("g1JQx");

var $bSGgH = parcelRequire("bSGgH");

var $3W561 = parcelRequire("3W561");

var $lgnQl = parcelRequire("lgnQl");

var $ku8FQ = parcelRequire("ku8FQ");

var $dGANx = parcelRequire("dGANx");

var $dAY1M = parcelRequire("dAY1M");

var $g1vns = parcelRequire("g1vns");

var $90XFO = parcelRequire("90XFO");

var $h4D4e = parcelRequire("h4D4e");

var $4v27J = parcelRequire("4v27J");

var $7FGtw = parcelRequire("7FGtw");

var $E0Rc9 = parcelRequire("E0Rc9");

var $4S67D = parcelRequire("4S67D");

var $1KymX = parcelRequire("1KymX");

var $eEP47 = parcelRequire("eEP47");

var $l51qt = parcelRequire("l51qt");

var $68Jl5 = parcelRequire("68Jl5");
var $3e50d9ab5d717d43$require$updateSelfPeerRecord = $68Jl5.updateSelfPeerRecord;
/**
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxedStream} MuxedStream
 * @typedef {import('libp2p-interfaces/src/transport/types').TransportFactory<any, any>} TransportFactory
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxerFactory} MuxerFactory
 * @typedef {import('libp2p-interfaces/src/content-routing/types').ContentRouting} ContentRoutingModule
 * @typedef {import('libp2p-interfaces/src/peer-discovery/types').PeerDiscoveryFactory} PeerDiscoveryFactory
 * @typedef {import('libp2p-interfaces/src/peer-routing/types').PeerRouting} PeerRoutingModule
 * @typedef {import('libp2p-interfaces/src/crypto/types').Crypto} Crypto
 * @typedef {import('libp2p-interfaces/src/pubsub')} Pubsub
 * @typedef {import('libp2p-interfaces/src/pubsub').PubsubOptions} PubsubOptions
 * @typedef {import('interface-datastore').Datastore} Datastore
 * @typedef {import('./pnet')} Protector
 * @typedef {Object} PersistentPeerStoreOptions
 * @property {number} [threshold]
 */ /**
 * @typedef {Object} HandlerProps
 * @property {Connection} connection
 * @property {MuxedStream} stream
 * @property {string} protocol
 *
 * @typedef {Object} DhtOptions
 * @property {boolean} [enabled = false]
 * @property {number} [kBucketSize = 20]
 * @property {boolean} [clientMode]
 * @property {import('libp2p-interfaces/src/types').DhtSelectors} [selectors]
 * @property {import('libp2p-interfaces/src/types').DhtValidators} [validators]
 *
 * @typedef {Object} KeychainOptions
 * @property {Datastore} [datastore]
 *
 * @typedef {Object} PeerStoreOptions
 * @property {boolean} persistence
 *
 * @typedef {Object} PubsubLocalOptions
 * @property {boolean} enabled
 *
 * @typedef {Object} MetricsOptions
 * @property {boolean} enabled
 *
 * @typedef {Object} RelayOptions
 * @property {boolean} [enabled = true]
 * @property {import('./circuit').RelayAdvertiseOptions} [advertise]
 * @property {import('./circuit').HopOptions} [hop]
 * @property {import('./circuit').AutoRelayOptions} [autoRelay]
 *
 * @typedef {Object} Libp2pConfig
 * @property {DhtOptions} [dht] dht module options
 * @property {import('./nat-manager').NatManagerOptions} [nat]
 * @property {Record<string, Object|boolean>} [peerDiscovery]
 * @property {PubsubLocalOptions & PubsubOptions} [pubsub] pubsub module options
 * @property {RelayOptions} [relay]
 * @property {Record<string, Object>} [transport] transport options indexed by transport key
 *
 * @typedef {Object} Libp2pModules
 * @property {TransportFactory[]} transport
 * @property {MuxerFactory[]} streamMuxer
 * @property {Crypto[]} connEncryption
 * @property {PeerDiscoveryFactory[]} [peerDiscovery]
 * @property {PeerRoutingModule[]} [peerRouting]
 * @property {ContentRoutingModule[]} [contentRouting]
 * @property {Object} [dht]
 * @property {{new(...args: any[]): Pubsub}} [pubsub]
 * @property {Protector} [connProtector]
 *
 * @typedef {Object} Libp2pOptions
 * @property {Libp2pModules} modules libp2p modules to use
 * @property {import('./address-manager').AddressManagerOptions} [addresses]
 * @property {import('./connection-manager').ConnectionManagerOptions} [connectionManager]
 * @property {Datastore} [datastore]
 * @property {import('./dialer').DialerOptions} [dialer]
 * @property {import('./identify/index').HostProperties} [host] libp2p host
 * @property {KeychainOptions & import('./keychain/index').KeychainOptions} [keychain]
 * @property {MetricsOptions & import('./metrics').MetricsOptions} [metrics]
 * @property {import('./peer-routing').PeerRoutingOptions} [peerRouting]
 * @property {PeerStoreOptions & PersistentPeerStoreOptions} [peerStore]
 * @property {import('./transport-manager').TransportManagerOptions} [transportManager]
 * @property {Libp2pConfig} [config]
 *
 * @typedef {Object} constructorOptions
 * @property {PeerId} peerId
 *
 * @typedef {Object} CreateOptions
 * @property {PeerId} [peerId]
 *
 * @extends {EventEmitter}
 * @fires Libp2p#error Emitted when an error occurs
 * @fires Libp2p#peer:discovery Emitted when a peer is discovered
 */ class $3e50d9ab5d717d43$var$Libp2p extends $3e50d9ab5d717d43$require$EventEmitter {
    /**
   * Like `new Libp2p(options)` except it will create a `PeerId`
   * instance if one is not provided in options.
   *
   * @param {Libp2pOptions & CreateOptions} options - Libp2p configuration options
   * @returns {Promise<Libp2p>}
   */ static async create(options) {
        if (options.peerId) // @ts-ignore 'Libp2pOptions & CreateOptions' is not assignable to 'Libp2pOptions & constructorOptions'
        return new $3e50d9ab5d717d43$var$Libp2p(options);
        const peerId = await $ksmXv.create();
        options.peerId = peerId;
        // @ts-ignore 'Libp2pOptions & CreateOptions' is not assignable to 'Libp2pOptions & constructorOptions'
        return new $3e50d9ab5d717d43$var$Libp2p(options);
    }
    /**
   * Libp2p node.
   *
   * @class
   * @param {Libp2pOptions & constructorOptions} _options
   */ constructor(_options){
        super();
        // validateConfig will ensure the config is correct,
        // and add default values where appropriate
        this._options = $3e50d9ab5d717d43$require$validateConfig(_options);
        /** @type {PeerId} */ this.peerId = this._options.peerId;
        this.datastore = this._options.datastore;
        // Create Metrics
        if (this._options.metrics.enabled) {
            const metrics = new $g1vns({
                ...this._options.metrics
            });
            this.metrics = metrics;
        }
        this.peerStore = this.datastore && this._options.peerStore.persistence ? new $E0Rc9({
            peerId: this.peerId,
            datastore: this.datastore,
            ...this._options.peerStore
        }) : new $4v27J({
            peerId: this.peerId
        });
        // Addresses {listen, announce, noAnnounce}
        this.addresses = this._options.addresses;
        this.addressManager = new $g1JQx(this.peerId, this._options.addresses);
        // when addresses change, update our peer record
        this.addressManager.on("change:addresses", ()=>{
            $3e50d9ab5d717d43$require$updateSelfPeerRecord(this).catch((err)=>{
                $3e50d9ab5d717d43$var$log.error("Error updating self peer record", err);
            });
        });
        this._modules = this._options.modules;
        this._config = this._options.config;
        this._transport = [] // Transport instances/references
        ;
        this._discovery = new Map() // Discovery service instances/references
        ;
        // Create the Connection Manager
        this.connectionManager = new $bSGgH(this, {
            ...this._options.connectionManager
        });
        this._autodialler = new $3W561(this, {
            enabled: this._config.peerDiscovery.autoDial,
            minConnections: this._options.connectionManager.minConnections,
            autoDialInterval: this._options.connectionManager.autoDialInterval
        });
        // Create keychain
        if (this._options.keychain && this._options.keychain.datastore) {
            $3e50d9ab5d717d43$var$log("creating keychain");
            const keychainOpts = $dAY1M.generateOptions();
            this.keychain = new $dAY1M(this._options.keychain.datastore, {
                ...keychainOpts,
                ...this._options.keychain
            });
            $3e50d9ab5d717d43$var$log("keychain constructed");
        }
        // Setup the Upgrader
        this.upgrader = new $h4D4e({
            localPeer: this.peerId,
            metrics: this.metrics,
            onConnection: (connection)=>this.connectionManager.onConnect(connection),
            onConnectionEnd: (connection)=>this.connectionManager.onDisconnect(connection)
        });
        // Setup the transport manager
        this.transportManager = new $90XFO({
            libp2p: this,
            upgrader: this.upgrader,
            faultTolerance: this._options.transportManager.faultTolerance
        });
        // Create the Nat Manager
        this.natManager = new $l51qt({
            peerId: this.peerId,
            addressManager: this.addressManager,
            transportManager: this.transportManager,
            // @ts-ignore Nat typedef is not understood as Object
            ...this._options.config.nat
        });
        // Create the Registrar
        this.registrar = new $4S67D({
            peerStore: this.peerStore,
            connectionManager: this.connectionManager
        });
        this.handle = this.handle.bind(this);
        this.registrar.handle = this.handle;
        // Attach crypto channels
        if (!this._modules.connEncryption || !this._modules.connEncryption.length) throw $20Lm5(new Error($3e50d9ab5d717d43$require$messages.CONN_ENCRYPTION_REQUIRED), $3e50d9ab5d717d43$require$codes.CONN_ENCRYPTION_REQUIRED);
        const cryptos = this._modules.connEncryption;
        cryptos.forEach((crypto)=>{
            this.upgrader.cryptos.set(crypto.protocol, crypto);
        });
        this.dialer = new $dGANx({
            transportManager: this.transportManager,
            peerStore: this.peerStore,
            metrics: this.metrics,
            ...this._options.dialer
        });
        this._modules.transport.forEach((Transport)=>{
            const key = Transport.prototype[Symbol.toStringTag];
            const transportOptions = this._config.transport[key];
            this.transportManager.add(key, Transport, transportOptions);
        });
        if (this._config.relay.enabled) {
            // @ts-ignore Circuit prototype
            this.transportManager.add($lgnQl.prototype[Symbol.toStringTag], $lgnQl);
            this.relay = new $ku8FQ(this);
        }
        // Attach stream multiplexers
        if (this._modules.streamMuxer) {
            const muxers = this._modules.streamMuxer;
            muxers.forEach((muxer)=>{
                this.upgrader.muxers.set(muxer.multicodec, muxer);
            });
            // Add the identify service since we can multiplex
            this.identifyService = new $eEP47({
                libp2p: this
            });
            this.handle(Object.values($eEP47.getProtocolStr(this)), this.identifyService.handleMessage);
        }
        // Attach private network protector
        if (this._modules.connProtector) this.upgrader.protector = this._modules.connProtector;
        else if (globalThis.process !== undefined && globalThis.process.env && globalThis.process.env.LIBP2P_FORCE_PNET) throw new Error("Private network is enforced, but no protector was provided");
        // dht provided components (peerRouting, contentRouting, dht)
        if (this._modules.dht) {
            const DHT = this._modules.dht;
            // @ts-ignore TODO: types need fixing - DHT is an `object` which has no `create` method
            this._dht = DHT.create({
                libp2p: this,
                ...this._config.dht
            });
        }
        // Create pubsub if provided
        if (this._modules.pubsub) {
            const Pubsub = this._modules.pubsub;
            // using pubsub adapter with *DEPRECATED* handlers functionality
            /** @type {Pubsub} */ this.pubsub = $7FGtw(Pubsub, this, this._config.pubsub);
        }
        // Attach remaining APIs
        // peer and content routing will automatically get modules from _modules and _dht
        this.peerRouting = new $glVMO(this);
        this.contentRouting = new $hDYYu(this);
        // Mount default protocols
        $1KymX.mount(this);
        this._onDiscoveryPeer = this._onDiscoveryPeer.bind(this);
    }
    /**
   * Overrides EventEmitter.emit to conditionally emit errors
   * if there is a handler. If not, errors will be logged.
   *
   * @param {string} eventName
   * @param  {...any} args
   * @returns {boolean}
   */ emit(eventName, ...args) {
        // TODO: do we still need this?
        // @ts-ignore _events does not exist in libp2p
        if (eventName === "error" && !this._events.error) {
            $3e50d9ab5d717d43$var$log.error(args);
            return false;
        } else return super.emit(eventName, ...args);
    }
    /**
   * Starts the libp2p node and all its subsystems
   *
   * @returns {Promise<void>}
   */ async start() {
        $3e50d9ab5d717d43$var$log("libp2p is starting");
        try {
            await this._onStarting();
            await this._onDidStart();
            $3e50d9ab5d717d43$var$log("libp2p has started");
        } catch (/** @type {any} */ err) {
            this.emit("error", err);
            $3e50d9ab5d717d43$var$log.error("An error occurred starting libp2p", err);
            await this.stop();
            throw err;
        }
    }
    /**
   * Stop the libp2p node by closing its listeners and open connections
   *
   * @async
   * @returns {Promise<void>}
   */ async stop() {
        $3e50d9ab5d717d43$var$log("libp2p is stopping");
        try {
            this._isStarted = false;
            this.relay && this.relay.stop();
            this.peerRouting.stop();
            this._autodialler.stop();
            await (this._dht && this._dht.stop());
            for (const service of this._discovery.values())service.removeListener("peer", this._onDiscoveryPeer);
            await Promise.all(Array.from(this._discovery.values(), (s)=>s.stop()));
            this._discovery = new Map();
            await this.peerStore.stop();
            await this.connectionManager.stop();
            await Promise.all([
                this.pubsub && this.pubsub.stop(),
                this.metrics && this.metrics.stop()
            ]);
            await this.natManager.stop();
            await this.transportManager.close();
            $1KymX.unmount(this);
            this.dialer.destroy();
        } catch (/** @type {any} */ err) {
            if (err) {
                $3e50d9ab5d717d43$var$log.error(err);
                this.emit("error", err);
            }
        }
        $3e50d9ab5d717d43$var$log("libp2p has stopped");
    }
    /**
   * Load keychain keys from the datastore.
   * Imports the private key as 'self', if needed.
   *
   * @async
   * @returns {Promise<void>}
   */ async loadKeychain() {
        if (!this.keychain) return;
        try {
            await this.keychain.findKeyByName("self");
        } catch (/** @type {any} */ err) {
            await this.keychain.importPeer("self", this.peerId);
        }
    }
    isStarted() {
        return this._isStarted;
    }
    /**
   * Gets a Map of the current connections. The keys are the stringified
   * `PeerId` of the peer. The value is an array of Connections to that peer.
   *
   * @returns {Map<string, Connection[]>}
   */ get connections() {
        return this.connectionManager.connections;
    }
    /**
   * Dials to the provided peer. If successful, the known metadata of the
   * peer will be added to the nodes `peerStore`
   *
   * @param {PeerId|Multiaddr|string} peer - The peer to dial
   * @param {object} [options]
   * @param {AbortSignal} [options.signal]
   * @returns {Promise<Connection>}
   */ dial(peer, options) {
        return this._dial(peer, options);
    }
    /**
   * Dials to the provided peer and tries to handshake with the given protocols in order.
   * If successful, the known metadata of the peer will be added to the nodes `peerStore`,
   * and the `MuxedStream` will be returned together with the successful negotiated protocol.
   *
   * @async
   * @param {PeerId|Multiaddr|string} peer - The peer to dial
   * @param {string[]|string} protocols
   * @param {object} [options]
   * @param {AbortSignal} [options.signal]
   */ async dialProtocol(peer, protocols, options) {
        if (!protocols || !protocols.length) throw $20Lm5(new Error("no protocols were provided to open a stream"), $3e50d9ab5d717d43$require$codes.ERR_INVALID_PROTOCOLS_FOR_STREAM);
        const connection = await this._dial(peer, options);
        return connection.newStream(protocols);
    }
    /**
   * @async
   * @param {PeerId|Multiaddr|string} peer - The peer to dial
   * @param {object} [options]
   * @returns {Promise<Connection>}
   */ async _dial(peer, options) {
        const { id: id, multiaddrs: multiaddrs } = $gbbbW(peer);
        if (id.equals(this.peerId)) throw $20Lm5(new Error("Cannot dial self"), $3e50d9ab5d717d43$require$codes.ERR_DIALED_SELF);
        let connection = this.connectionManager.get(id);
        if (!connection) connection = await this.dialer.connectToPeer(peer, options);
        else if (multiaddrs) this.peerStore.addressBook.add(id, multiaddrs);
        return connection;
    }
    /**
   * Get a deduplicated list of peer advertising multiaddrs by concatenating
   * the listen addresses used by transports with any configured
   * announce addresses as well as observed addresses reported by peers.
   *
   * If Announce addrs are specified, configured listen addresses will be
   * ignored though observed addresses will still be included.
   *
   * @returns {Multiaddr[]}
   */ get multiaddrs() {
        let addrs = this.addressManager.getAnnounceAddrs().map((ma)=>ma.toString());
        if (!addrs.length) // no configured announce addrs, add configured listen addresses
        addrs = this.transportManager.getAddrs().map((ma)=>ma.toString());
        addrs = addrs.concat(this.addressManager.getObservedAddrs().map((ma)=>ma.toString()));
        const announceFilter = this._options.addresses.announceFilter;
        // dedupe multiaddrs
        const addrSet = new Set(addrs);
        // Create advertising list
        return announceFilter(Array.from(addrSet).map((str)=>new $3e50d9ab5d717d43$require$Multiaddr(str)));
    }
    /**
   * Disconnects all connections to the given `peer`
   *
   * @param {PeerId|Multiaddr|string} peer - the peer to close connections to
   * @returns {Promise<void>}
   */ async hangUp(peer) {
        const { id: id } = $gbbbW(peer);
        const connections = this.connectionManager.connections.get(id.toB58String());
        if (!connections) return;
        await Promise.all(connections.map((connection)=>{
            return connection.close();
        }));
    }
    /**
   * Pings the given peer in order to obtain the operation latency.
   *
   * @param {PeerId|Multiaddr|string} peer - The peer to ping
   * @returns {Promise<number>}
   */ ping(peer) {
        const { id: id, multiaddrs: multiaddrs } = $gbbbW(peer);
        // If received multiaddr, ping it
        if (multiaddrs) return $1KymX(this, multiaddrs[0]);
        return $1KymX(this, id);
    }
    /**
   * Registers the `handler` for each protocol
   *
   * @param {string[]|string} protocols
   * @param {(props: HandlerProps) => void} handler
   */ handle(protocols, handler) {
        protocols = Array.isArray(protocols) ? protocols : [
            protocols
        ];
        protocols.forEach((protocol)=>{
            this.upgrader.protocols.set(protocol, handler);
        });
        // Add new protocols to self protocols in the Protobook
        this.peerStore.protoBook.add(this.peerId, protocols);
    }
    /**
   * Removes the handler for each protocol. The protocol
   * will no longer be supported on streams.
   *
   * @param {string[]|string} protocols
   */ unhandle(protocols) {
        protocols = Array.isArray(protocols) ? protocols : [
            protocols
        ];
        protocols.forEach((protocol)=>{
            this.upgrader.protocols.delete(protocol);
        });
        // Remove protocols from self protocols in the Protobook
        this.peerStore.protoBook.remove(this.peerId, protocols);
    }
    async _onStarting() {
        // Listen on the provided transports for the provided addresses
        const addrs = this.addressManager.getListenAddrs();
        await this.transportManager.listen(addrs);
        // Manage your NATs
        this.natManager.start();
        // Start PeerStore
        await this.peerStore.start();
        if (this._config.pubsub.enabled) this.pubsub && this.pubsub.start();
        // DHT subsystem
        if (this._config.dht.enabled) {
            this._dht && await this._dht.start();
            // TODO: this should be modified once random-walk is used as
            // the other discovery modules
            this._dht.on("peer", this._onDiscoveryPeer);
        }
        // Start metrics if present
        this.metrics && this.metrics.start();
    }
    /**
   * Called when libp2p has started and before it returns
   *
   * @private
   */ async _onDidStart() {
        this._isStarted = true;
        this.peerStore.on("peer", (peerId)=>{
            this.emit("peer:discovery", peerId);
            this._maybeConnect(peerId);
        });
        // Once we start, emit any peers we may have already discovered
        // TODO: this should be removed, as we already discovered these peers in the past
        for (const peer of this.peerStore.peers.values())this.emit("peer:discovery", peer.id);
        this.connectionManager.start();
        this._autodialler.start();
        // Peer discovery
        await this._setupPeerDiscovery();
        // Relay
        this.relay && this.relay.start();
        this.peerRouting.start();
    }
    /**
   * Called whenever peer discovery services emit `peer` events.
   * Known peers may be emitted.
   *
   * @private
   * @param {{ id: PeerId, multiaddrs: Multiaddr[], protocols: string[] }} peer
   */ _onDiscoveryPeer(peer) {
        if (peer.id.toB58String() === this.peerId.toB58String()) {
            $3e50d9ab5d717d43$var$log.error(new Error($3e50d9ab5d717d43$require$codes.ERR_DISCOVERED_SELF));
            return;
        }
        peer.multiaddrs && this.peerStore.addressBook.add(peer.id, peer.multiaddrs);
        peer.protocols && this.peerStore.protoBook.set(peer.id, peer.protocols);
    }
    /**
   * Will dial to the given `peerId` if the current number of
   * connected peers is less than the configured `ConnectionManager`
   * minConnections.
   *
   * @private
   * @param {PeerId} peerId
   */ async _maybeConnect(peerId) {
        // If auto dialing is on and we have no connection to the peer, check if we should dial
        if (this._config.peerDiscovery.autoDial === true && !this.connectionManager.get(peerId)) {
            const minConnections = this._options.connectionManager.minConnections || 0;
            if (minConnections > this.connectionManager.size) {
                $3e50d9ab5d717d43$var$log("connecting to discovered peer %s", peerId.toB58String());
                try {
                    await this.dialer.connectToPeer(peerId);
                } catch (/** @type {any} */ err) {
                    $3e50d9ab5d717d43$var$log.error(`could not connect to discovered peer ${peerId.toB58String()} with ${err}`);
                }
            }
        }
    }
    /**
   * Initializes and starts peer discovery services
   *
   * @async
   * @private
   */ async _setupPeerDiscovery() {
        /**
     * @param {PeerDiscoveryFactory} DiscoveryService
     */ const setupService = (DiscoveryService)=>{
            let config = {
                enabled: true // on by default
            };
            if (DiscoveryService.tag && this._config.peerDiscovery && this._config.peerDiscovery[DiscoveryService.tag]) // @ts-ignore PeerDiscovery not understood as an Object for spread
            config = {
                ...config,
                ...this._config.peerDiscovery[DiscoveryService.tag]
            };
            if (config.enabled && !this._discovery.has(DiscoveryService.tag)) {
                let discoveryService;
                if (typeof DiscoveryService === "function") // @ts-ignore DiscoveryService has no constructor type inferred
                discoveryService = new DiscoveryService(Object.assign({}, config, {
                    peerId: this.peerId,
                    libp2p: this
                }));
                else discoveryService = DiscoveryService;
                discoveryService.on("peer", this._onDiscoveryPeer);
                this._discovery.set(DiscoveryService.tag, discoveryService);
            }
        };
        // Discovery modules
        for (const DiscoveryService of this._modules.peerDiscovery || [])setupService(DiscoveryService);
        // Transport modules with discovery
        for (const Transport of this.transportManager.getTransports())// @ts-ignore Transport interface does not include discovery
        if (Transport.discovery) // @ts-ignore Transport interface does not include discovery
        setupService(Transport.discovery);
        await Promise.all(Array.from(this._discovery.values(), (d)=>d.start()));
    }
}
module.exports = $3e50d9ab5d717d43$var$Libp2p;

});
parcelRequire.register("7QXK1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5b7bbb1fb1d8540b$var$R = typeof Reflect === "object" ? Reflect : null;
var $5b7bbb1fb1d8540b$var$ReflectApply = $5b7bbb1fb1d8540b$var$R && typeof $5b7bbb1fb1d8540b$var$R.apply === "function" ? $5b7bbb1fb1d8540b$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5b7bbb1fb1d8540b$var$ReflectOwnKeys;
if ($5b7bbb1fb1d8540b$var$R && typeof $5b7bbb1fb1d8540b$var$R.ownKeys === "function") $5b7bbb1fb1d8540b$var$ReflectOwnKeys = $5b7bbb1fb1d8540b$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5b7bbb1fb1d8540b$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5b7bbb1fb1d8540b$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5b7bbb1fb1d8540b$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5b7bbb1fb1d8540b$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5b7bbb1fb1d8540b$var$EventEmitter() {
    $5b7bbb1fb1d8540b$var$EventEmitter.init.call(this);
}
module.exports = $5b7bbb1fb1d8540b$var$EventEmitter;
module.exports.once = $5b7bbb1fb1d8540b$var$once;
// Backwards-compat with node 0.10.x
$5b7bbb1fb1d8540b$var$EventEmitter.EventEmitter = $5b7bbb1fb1d8540b$var$EventEmitter;
$5b7bbb1fb1d8540b$var$EventEmitter.prototype._events = undefined;
$5b7bbb1fb1d8540b$var$EventEmitter.prototype._eventsCount = 0;
$5b7bbb1fb1d8540b$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5b7bbb1fb1d8540b$var$defaultMaxListeners = 10;
function $5b7bbb1fb1d8540b$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5b7bbb1fb1d8540b$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5b7bbb1fb1d8540b$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5b7bbb1fb1d8540b$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5b7bbb1fb1d8540b$var$defaultMaxListeners = arg;
    }
});
$5b7bbb1fb1d8540b$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5b7bbb1fb1d8540b$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5b7bbb1fb1d8540b$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5b7bbb1fb1d8540b$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5b7bbb1fb1d8540b$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5b7bbb1fb1d8540b$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5b7bbb1fb1d8540b$var$_getMaxListeners(this);
};
$5b7bbb1fb1d8540b$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5b7bbb1fb1d8540b$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5b7bbb1fb1d8540b$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5b7bbb1fb1d8540b$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5b7bbb1fb1d8540b$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5b7bbb1fb1d8540b$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5b7bbb1fb1d8540b$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5b7bbb1fb1d8540b$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5b7bbb1fb1d8540b$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5b7bbb1fb1d8540b$var$_addListener(this, type, listener, false);
};
$5b7bbb1fb1d8540b$var$EventEmitter.prototype.on = $5b7bbb1fb1d8540b$var$EventEmitter.prototype.addListener;
$5b7bbb1fb1d8540b$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5b7bbb1fb1d8540b$var$_addListener(this, type, listener, true);
};
function $5b7bbb1fb1d8540b$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5b7bbb1fb1d8540b$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5b7bbb1fb1d8540b$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5b7bbb1fb1d8540b$var$EventEmitter.prototype.once = function once(type, listener) {
    $5b7bbb1fb1d8540b$var$checkListener(listener);
    this.on(type, $5b7bbb1fb1d8540b$var$_onceWrap(this, type, listener));
    return this;
};
$5b7bbb1fb1d8540b$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5b7bbb1fb1d8540b$var$checkListener(listener);
    this.prependListener(type, $5b7bbb1fb1d8540b$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5b7bbb1fb1d8540b$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5b7bbb1fb1d8540b$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5b7bbb1fb1d8540b$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5b7bbb1fb1d8540b$var$EventEmitter.prototype.off = $5b7bbb1fb1d8540b$var$EventEmitter.prototype.removeListener;
$5b7bbb1fb1d8540b$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5b7bbb1fb1d8540b$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5b7bbb1fb1d8540b$var$unwrapListeners(evlistener) : $5b7bbb1fb1d8540b$var$arrayClone(evlistener, evlistener.length);
}
$5b7bbb1fb1d8540b$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5b7bbb1fb1d8540b$var$_listeners(this, type, true);
};
$5b7bbb1fb1d8540b$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5b7bbb1fb1d8540b$var$_listeners(this, type, false);
};
$5b7bbb1fb1d8540b$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5b7bbb1fb1d8540b$var$listenerCount.call(emitter, type);
};
$5b7bbb1fb1d8540b$var$EventEmitter.prototype.listenerCount = $5b7bbb1fb1d8540b$var$listenerCount;
function $5b7bbb1fb1d8540b$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5b7bbb1fb1d8540b$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5b7bbb1fb1d8540b$var$ReflectOwnKeys(this._events) : [];
};
function $5b7bbb1fb1d8540b$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5b7bbb1fb1d8540b$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5b7bbb1fb1d8540b$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5b7bbb1fb1d8540b$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5b7bbb1fb1d8540b$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5b7bbb1fb1d8540b$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5b7bbb1fb1d8540b$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5b7bbb1fb1d8540b$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5b7bbb1fb1d8540b$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRequire.register("ksmXv", function(module, exports) {
/*
 * Id is an object representation of a peer Id. a peer Id is a multihash
 */ "use strict";

var $1uqWk = parcelRequire("1uqWk");
var $ee483b4831ac066c$require$CID = $1uqWk.CID;

var $5LC6A = parcelRequire("5LC6A");

var $cx6XH = parcelRequire("cx6XH");

var $fVtlC = parcelRequire("fVtlC");

var $eXQx4 = parcelRequire("eXQx4");

var $fVtlC = parcelRequire("fVtlC");
var $ee483b4831ac066c$require$base58btc = $fVtlC.base58btc;

var $5LC6A = parcelRequire("5LC6A");
var $ee483b4831ac066c$require$base32 = $5LC6A.base32;

var $12xKA = parcelRequire("12xKA");
var $ee483b4831ac066c$require$base16 = $12xKA.base16;

var $3gYLQ = parcelRequire("3gYLQ");

var $iCaRA = parcelRequire("iCaRA");

var $jhePu = parcelRequire("jhePu");

var $b9NeK = parcelRequire("b9NeK");
var $ee483b4831ac066c$require$PeerIdProto = $b9NeK.PeerIdProto;

var $ijWXY = parcelRequire("ijWXY");
var $ee483b4831ac066c$require$uint8ArrayEquals = $ijWXY.equals;

var $8cWjP = parcelRequire("8cWjP");
var $ee483b4831ac066c$require$uint8ArrayFromString = $8cWjP.fromString;

var $6rBCs = parcelRequire("6rBCs");
var $ee483b4831ac066c$require$uint8ArrayToString = $6rBCs.toString;

var $klyrn = parcelRequire("klyrn");
var $ee483b4831ac066c$require$identity = $klyrn.identity;
const bases = {
    ...$5LC6A,
    ...$cx6XH,
    ...$fVtlC,
    ...$eXQx4
};
const baseDecoder = Object.keys(bases).reduce((acc, curr)=>acc.or(bases[curr]), $ee483b4831ac066c$require$base32.decoder);
// these values are from https://github.com/multiformats/multicodec/blob/master/table.csv
const DAG_PB_CODE = 0x70;
const LIBP2P_KEY_CODE = 0x72;
class PeerId {
    constructor(id, privKey, pubKey){
        if (!(id instanceof Uint8Array)) throw new Error("invalid id provided");
        if (privKey && pubKey && !$ee483b4831ac066c$require$uint8ArrayEquals(privKey.public.bytes, pubKey.bytes)) throw new Error("inconsistent arguments");
        this._id = id;
        this._idB58String = $ee483b4831ac066c$require$base58btc.encode(this.id).substring(1);
        this._privKey = privKey;
        this._pubKey = pubKey;
    }
    get id() {
        return this._id;
    }
    set id(val) {
        throw new Error("Id is immutable");
    }
    get privKey() {
        return this._privKey;
    }
    set privKey(privKey) {
        this._privKey = privKey;
    }
    get pubKey() {
        if (this._pubKey) return this._pubKey;
        if (this._privKey) return this._privKey.public;
        try {
            const decoded = $3gYLQ.decode(this.id);
            if (decoded.code === $ee483b4831ac066c$require$identity.code) this._pubKey = $iCaRA.unmarshalPublicKey(decoded.digest);
        } catch (_) {
        // Ignore, there is no valid public key
        }
        return this._pubKey;
    }
    set pubKey(pubKey) {
        this._pubKey = pubKey;
    }
    // Return the protobuf version of the public key, matching go ipfs formatting
    marshalPubKey() {
        if (this.pubKey) return $iCaRA.marshalPublicKey(this.pubKey);
    }
    // Return the protobuf version of the private key, matching go ipfs formatting
    marshalPrivKey() {
        if (this.privKey) return $iCaRA.marshalPrivateKey(this.privKey);
    }
    // Return the protobuf version of the peer-id
    marshal(excludePriv) {
        return $ee483b4831ac066c$require$PeerIdProto.encode({
            id: this.toBytes(),
            pubKey: this.marshalPubKey(),
            privKey: excludePriv ? null : this.marshalPrivKey()
        }).finish();
    }
    toPrint() {
        let pid = this.toB58String();
        // All sha256 nodes start with Qm
        // We can skip the Qm to make the peer.ID more useful
        if (pid.startsWith("Qm")) pid = pid.slice(2);
        let maxRunes = 6;
        if (pid.length < maxRunes) maxRunes = pid.length;
        return "<peer.ID " + pid.substr(0, maxRunes) + ">";
    }
    // return the jsonified version of the key, matching the formatting
    // of go-ipfs for its config file
    toJSON() {
        return {
            id: this.toB58String(),
            privKey: toB64Opt(this.marshalPrivKey()),
            pubKey: toB64Opt(this.marshalPubKey())
        };
    }
    // encode/decode functions
    toHexString() {
        return $ee483b4831ac066c$require$base16.encode(this.id).substring(1);
    }
    toBytes() {
        return this.id;
    }
    toB58String() {
        return this._idB58String;
    }
    // return self-describing String representation
    // in default format from RFC 0001: https://github.com/libp2p/specs/pull/209
    toString() {
        if (!this._idCIDString) {
            const cid = $ee483b4831ac066c$require$CID.createV1(LIBP2P_KEY_CODE, $3gYLQ.decode(this.id));
            Object.defineProperty(this, "_idCIDString", {
                value: cid.toString(),
                enumerable: false
            });
        }
        return this._idCIDString;
    }
    /**
   * Checks the equality of `this` peer against a given PeerId.
   *
   * @param {Uint8Array|PeerId} id
   * @returns {boolean}
   */ equals(id) {
        if (id instanceof Uint8Array) return $ee483b4831ac066c$require$uint8ArrayEquals(this.id, id);
        else if (id.id) return $ee483b4831ac066c$require$uint8ArrayEquals(this.id, id.id);
        else throw new Error("not valid Id");
    }
    /**
   * Checks the equality of `this` peer against a given PeerId.
   *
   * @deprecated Use `.equals`
   * @param {Uint8Array|PeerId} id
   * @returns {boolean}
   */ isEqual(id) {
        return this.equals(id);
    }
    /*
   * Check if this PeerId instance is valid (privKey -> pubKey -> Id)
   */ isValid() {
        // TODO: needs better checking
        return Boolean(this.privKey && this.privKey.public && this.privKey.public.bytes && this.pubKey.bytes instanceof Uint8Array && $ee483b4831ac066c$require$uint8ArrayEquals(this.privKey.public.bytes, this.pubKey.bytes));
    }
    /**
   * Check if the PeerId has an inline public key.
   *
   * @returns {boolean}
   */ hasInlinePublicKey() {
        try {
            const decoded = $3gYLQ.decode(this.id);
            if (decoded.code === $ee483b4831ac066c$require$identity.code) return true;
        } catch (_) {
        // Ignore, there is no valid public key
        }
        return false;
    }
}
const PeerIdWithIs = $jhePu(PeerId, {
    className: "PeerId",
    symbolName: "@libp2p/js-peer-id/PeerId"
});
exports = module.exports = PeerIdWithIs;
const computeDigest = (pubKey)=>{
    if (pubKey.bytes.length <= 42) return $3gYLQ.create($ee483b4831ac066c$require$identity.code, pubKey.bytes).bytes;
    else return pubKey.hash();
};
const computePeerId = async (privKey, pubKey)=>{
    const digest = await computeDigest(pubKey);
    return new PeerIdWithIs(digest, privKey, pubKey);
};
// generation
exports.create = async (opts)=>{
    opts = opts || {};
    opts.bits = opts.bits || 2048;
    opts.keyType = opts.keyType || "RSA";
    const key = await $iCaRA.generateKeyPair(opts.keyType, opts.bits);
    return computePeerId(key, key.public);
};
exports.createFromHexString = (str)=>{
    return new PeerIdWithIs($ee483b4831ac066c$require$base16.decode("f" + str));
};
exports.createFromBytes = (buf)=>{
    try {
        const cid = $ee483b4831ac066c$require$CID.decode(buf);
        if (!validMulticodec(cid)) throw new Error("Supplied PeerID CID is invalid");
        return exports.createFromCID(cid);
    } catch  {
        const digest = $3gYLQ.decode(buf);
        if (digest.code !== $ee483b4831ac066c$require$identity.code) throw new Error("Supplied PeerID CID is invalid");
        return new PeerIdWithIs(buf);
    }
};
exports.createFromB58String = (str)=>{
    return exports.createFromBytes($ee483b4831ac066c$require$base58btc.decode("z" + str));
};
const validMulticodec = (cid)=>{
    // supported: 'libp2p-key' (CIDv1) and 'dag-pb' (CIDv0 converted to CIDv1)
    return cid.code === LIBP2P_KEY_CODE || cid.code === DAG_PB_CODE;
};
exports.createFromCID = (cid)=>{
    cid = $ee483b4831ac066c$require$CID.asCID(cid);
    if (!cid || !validMulticodec(cid)) throw new Error("Supplied PeerID CID is invalid");
    return new PeerIdWithIs(cid.multihash.bytes);
};
// Public Key input will be a Uint8Array
exports.createFromPubKey = async (key)=>{
    let buf = key;
    if (typeof buf === "string") buf = $ee483b4831ac066c$require$uint8ArrayFromString(key, "base64pad");
    if (!(buf instanceof Uint8Array)) throw new Error("Supplied key is neither a base64 string nor a Uint8Array");
    const pubKey = await $iCaRA.unmarshalPublicKey(buf);
    return computePeerId(undefined, pubKey);
};
// Private key input will be a string
exports.createFromPrivKey = async (key)=>{
    if (typeof key === "string") key = $ee483b4831ac066c$require$uint8ArrayFromString(key, "base64pad");
    if (!(key instanceof Uint8Array)) throw new Error("Supplied key is neither a base64 string nor a Uint8Array");
    const privKey = await $iCaRA.unmarshalPrivateKey(key);
    return computePeerId(privKey, privKey.public);
};
exports.createFromJSON = async (obj)=>{
    const id = $ee483b4831ac066c$require$base58btc.decode("z" + obj.id);
    const rawPrivKey = obj.privKey && $ee483b4831ac066c$require$uint8ArrayFromString(obj.privKey, "base64pad");
    const rawPubKey = obj.pubKey && $ee483b4831ac066c$require$uint8ArrayFromString(obj.pubKey, "base64pad");
    const pub = rawPubKey && await $iCaRA.unmarshalPublicKey(rawPubKey);
    if (!rawPrivKey) return new PeerIdWithIs(id, undefined, pub);
    const privKey = await $iCaRA.unmarshalPrivateKey(rawPrivKey);
    const privDigest = await computeDigest(privKey.public);
    let pubDigest;
    if (pub) pubDigest = await computeDigest(pub);
    if (pub && !$ee483b4831ac066c$require$uint8ArrayEquals(privDigest, pubDigest)) throw new Error("Public and private key do not match");
    if (id && !$ee483b4831ac066c$require$uint8ArrayEquals(privDigest, id)) throw new Error("Id and private key do not match");
    return new PeerIdWithIs(id, privKey, pub);
};
exports.createFromProtobuf = async (buf)=>{
    if (typeof buf === "string") buf = $ee483b4831ac066c$require$uint8ArrayFromString(buf, "base16");
    let { id, privKey, pubKey } = $ee483b4831ac066c$require$PeerIdProto.decode(buf);
    privKey = privKey ? await $iCaRA.unmarshalPrivateKey(privKey) : false;
    pubKey = pubKey ? await $iCaRA.unmarshalPublicKey(pubKey) : false;
    let pubDigest;
    let privDigest;
    if (privKey) privDigest = await computeDigest(privKey.public);
    if (pubKey) pubDigest = await computeDigest(pubKey);
    if (privKey) {
        if (pubKey) {
            if (!$ee483b4831ac066c$require$uint8ArrayEquals(privDigest, pubDigest)) throw new Error("Public and private key do not match");
        }
        return new PeerIdWithIs(privDigest, privKey, privKey.public);
    }
    // TODO: val id and pubDigest
    if (pubKey) return new PeerIdWithIs(pubDigest, undefined, pubKey);
    if (id) return new PeerIdWithIs(id);
    throw new Error("Protobuf did not contain any usable key material");
};
exports.parse = (str)=>{
    if (str.charAt(0) === "1" || str.charAt(0) === "Q") // identity hash ed25519 key or sha2-256 hash of rsa public key
    // base58btc encoded either way
    str = `z${str}`;
    return exports.createFromBytes(baseDecoder.decode(str));
};
exports.isPeerId = (peerId)=>{
    return Boolean(typeof peerId === "object" && peerId._id && peerId._idB58String);
};
function toB64Opt(val) {
    if (val) return $ee483b4831ac066c$require$uint8ArrayToString(val, "base64pad");
}

});
parcelRequire.register("iCaRA", function(module, exports) {
"use strict";

var $6pYeq = parcelRequire("6pYeq");
parcelRequire("ehQqu");
parcelRequire("40sm5");

var $hSPkV = parcelRequire("hSPkV");

var $20Lm5 = parcelRequire("20Lm5");

var $8cWjP = parcelRequire("8cWjP");
var $d8d433d917acfc43$require$uint8ArrayFromString = $8cWjP.fromString;

var $ceNEu = parcelRequire("ceNEu");




const $d8d433d917acfc43$var$supportedKeys = {
    rsa: (parcelRequire("1B3jR")),
    ed25519: (parcelRequire("cBXX4")),
    secp256k1: (parcelRequire("5edhd"))($6pYeq, (parcelRequire("3b0KS")))
};
const $d8d433d917acfc43$var$ErrMissingSecp256K1 = {
    message: "secp256k1 support requires libp2p-crypto-secp256k1 package",
    code: "ERR_MISSING_PACKAGE"
};
function $d8d433d917acfc43$var$typeToKey(type) {
    const key = $d8d433d917acfc43$var$supportedKeys[type.toLowerCase()];
    if (!key) {
        const supported = Object.keys($d8d433d917acfc43$var$supportedKeys).join(" / ");
        throw $20Lm5(new Error(`invalid or unsupported key type ${type}. Must be ${supported}`), "ERR_UNSUPPORTED_KEY_TYPE");
    }
    return key;
}
// Generates a keypair of the given type and bitsize
const $d8d433d917acfc43$var$generateKeyPair = async (type, bits)=>{
    return $d8d433d917acfc43$var$typeToKey(type).generateKeyPair(bits);
};
// Generates a keypair of the given type and bitsize
// seed is a 32 byte uint8array
const $d8d433d917acfc43$var$generateKeyPairFromSeed = async (type, seed, bits)=>{
    const key = $d8d433d917acfc43$var$typeToKey(type);
    if (type.toLowerCase() !== "ed25519") throw $20Lm5(new Error("Seed key derivation is unimplemented for RSA or secp256k1"), "ERR_UNSUPPORTED_KEY_DERIVATION_TYPE");
    return key.generateKeyPairFromSeed(seed, bits);
};
// Converts a protobuf serialized public key into its
// representative object
const $d8d433d917acfc43$var$unmarshalPublicKey = (buf)=>{
    const decoded = $6pYeq.PublicKey.decode(buf);
    const data = decoded.Data;
    switch(decoded.Type){
        case $6pYeq.KeyType.RSA:
            return $d8d433d917acfc43$var$supportedKeys.rsa.unmarshalRsaPublicKey(data);
        case $6pYeq.KeyType.Ed25519:
            return $d8d433d917acfc43$var$supportedKeys.ed25519.unmarshalEd25519PublicKey(data);
        case $6pYeq.KeyType.Secp256k1:
            if ($d8d433d917acfc43$var$supportedKeys.secp256k1) return $d8d433d917acfc43$var$supportedKeys.secp256k1.unmarshalSecp256k1PublicKey(data);
            else throw $20Lm5(new Error($d8d433d917acfc43$var$ErrMissingSecp256K1.message), $d8d433d917acfc43$var$ErrMissingSecp256K1.code);
        default:
            $d8d433d917acfc43$var$typeToKey(decoded.Type) // throws because type is not supported
            ;
    }
};
// Converts a public key object into a protobuf serialized public key
const $d8d433d917acfc43$var$marshalPublicKey = (key, type)=>{
    type = (type || "rsa").toLowerCase();
    $d8d433d917acfc43$var$typeToKey(type) // check type
    ;
    return key.bytes;
};
// Converts a protobuf serialized private key into its
// representative object
const $d8d433d917acfc43$var$unmarshalPrivateKey = async (buf)=>{
    const decoded = $6pYeq.PrivateKey.decode(buf);
    const data = decoded.Data;
    switch(decoded.Type){
        case $6pYeq.KeyType.RSA:
            return $d8d433d917acfc43$var$supportedKeys.rsa.unmarshalRsaPrivateKey(data);
        case $6pYeq.KeyType.Ed25519:
            return $d8d433d917acfc43$var$supportedKeys.ed25519.unmarshalEd25519PrivateKey(data);
        case $6pYeq.KeyType.Secp256k1:
            if ($d8d433d917acfc43$var$supportedKeys.secp256k1) return $d8d433d917acfc43$var$supportedKeys.secp256k1.unmarshalSecp256k1PrivateKey(data);
            else throw $20Lm5(new Error($d8d433d917acfc43$var$ErrMissingSecp256K1.message), $d8d433d917acfc43$var$ErrMissingSecp256K1.code);
        default:
            $d8d433d917acfc43$var$typeToKey(decoded.Type) // throws because type is not supported
            ;
    }
};
// Converts a private key object into a protobuf serialized private key
const $d8d433d917acfc43$var$marshalPrivateKey = (key, type)=>{
    type = (type || "rsa").toLowerCase();
    $d8d433d917acfc43$var$typeToKey(type) // check type
    ;
    return key.bytes;
};
/**
 *
 * @param {string} encryptedKey
 * @param {string} password
 */ const $d8d433d917acfc43$var$importKey = async (encryptedKey, password)=>{
    try {
        const key = await $ceNEu.import(encryptedKey, password);
        return $d8d433d917acfc43$var$unmarshalPrivateKey(key);
    } catch (_) {
    // Ignore and try the old pem decrypt
    }
    // Only rsa supports pem right now
    const key = $hSPkV.pki.decryptRsaPrivateKey(encryptedKey, password);
    if (key === null) throw $20Lm5(new Error("Cannot read the key, most likely the password is wrong or not a RSA key"), "ERR_CANNOT_DECRYPT_PEM");
    let der = $hSPkV.asn1.toDer($hSPkV.pki.privateKeyToAsn1(key));
    der = $d8d433d917acfc43$require$uint8ArrayFromString(der.getBytes(), "ascii");
    return $d8d433d917acfc43$var$supportedKeys.rsa.unmarshalRsaPrivateKey(der);
};


module.exports = {
    supportedKeys: $d8d433d917acfc43$var$supportedKeys,
    keysPBM: $6pYeq,
    keyStretcher: (parcelRequire("kNd4X")),
    generateEphemeralKeyPair: (parcelRequire("9an9r")),
    generateKeyPair: $d8d433d917acfc43$var$generateKeyPair,
    generateKeyPairFromSeed: $d8d433d917acfc43$var$generateKeyPairFromSeed,
    unmarshalPublicKey: $d8d433d917acfc43$var$unmarshalPublicKey,
    marshalPublicKey: $d8d433d917acfc43$var$marshalPublicKey,
    unmarshalPrivateKey: $d8d433d917acfc43$var$unmarshalPrivateKey,
    marshalPrivateKey: $d8d433d917acfc43$var$marshalPrivateKey,
    import: $d8d433d917acfc43$var$importKey
};

});
parcelRequire.register("6pYeq", function(module, exports) {
/*eslint-disable*/ "use strict";

var $liRmU = parcelRequire("liRmU");
// Common aliases
var $4ac3cca2aac7fb7f$var$$Reader = $liRmU.Reader, $4ac3cca2aac7fb7f$var$$Writer = $liRmU.Writer, $4ac3cca2aac7fb7f$var$$util = $liRmU.util;
// Exported root namespace
var $4ac3cca2aac7fb7f$var$$root = $liRmU.roots["libp2p-crypto-keys"] || ($liRmU.roots["libp2p-crypto-keys"] = {});
/**
 * KeyType enum.
 * @exports KeyType
 * @enum {number}
 * @property {number} RSA=0 RSA value
 * @property {number} Ed25519=1 Ed25519 value
 * @property {number} Secp256k1=2 Secp256k1 value
 */ $4ac3cca2aac7fb7f$var$$root.KeyType = function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "RSA"] = 0;
    values[valuesById[1] = "Ed25519"] = 1;
    values[valuesById[2] = "Secp256k1"] = 2;
    return values;
}();
$4ac3cca2aac7fb7f$var$$root.PublicKey = function() {
    /**
     * Properties of a PublicKey.
     * @exports IPublicKey
     * @interface IPublicKey
     * @property {KeyType} Type PublicKey Type
     * @property {Uint8Array} Data PublicKey Data
     */ /**
     * Constructs a new PublicKey.
     * @exports PublicKey
     * @classdesc Represents a PublicKey.
     * @implements IPublicKey
     * @constructor
     * @param {IPublicKey=} [p] Properties to set
     */ function PublicKey(p) {
        if (p) {
            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }
    }
    /**
     * PublicKey Type.
     * @member {KeyType} Type
     * @memberof PublicKey
     * @instance
     */ PublicKey.prototype.Type = 0;
    /**
     * PublicKey Data.
     * @member {Uint8Array} Data
     * @memberof PublicKey
     * @instance
     */ PublicKey.prototype.Data = $4ac3cca2aac7fb7f$var$$util.newBuffer([]);
    /**
     * Encodes the specified PublicKey message. Does not implicitly {@link PublicKey.verify|verify} messages.
     * @function encode
     * @memberof PublicKey
     * @static
     * @param {IPublicKey} m PublicKey message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ PublicKey.encode = function encode(m, w) {
        if (!w) w = $4ac3cca2aac7fb7f$var$$Writer.create();
        w.uint32(8).int32(m.Type);
        w.uint32(18).bytes(m.Data);
        return w;
    };
    /**
     * Decodes a PublicKey message from the specified reader or buffer.
     * @function decode
     * @memberof PublicKey
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {PublicKey} PublicKey
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ PublicKey.decode = function decode(r, l) {
        if (!(r instanceof $4ac3cca2aac7fb7f$var$$Reader)) r = $4ac3cca2aac7fb7f$var$$Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l, m = new $4ac3cca2aac7fb7f$var$$root.PublicKey();
        while(r.pos < c){
            var t = r.uint32();
            switch(t >>> 3){
                case 1:
                    m.Type = r.int32();
                    break;
                case 2:
                    m.Data = r.bytes();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
            }
        }
        if (!m.hasOwnProperty("Type")) throw $4ac3cca2aac7fb7f$var$$util.ProtocolError("missing required 'Type'", {
            instance: m
        });
        if (!m.hasOwnProperty("Data")) throw $4ac3cca2aac7fb7f$var$$util.ProtocolError("missing required 'Data'", {
            instance: m
        });
        return m;
    };
    /**
     * Creates a PublicKey message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicKey
     * @static
     * @param {Object.<string,*>} d Plain object
     * @returns {PublicKey} PublicKey
     */ PublicKey.fromObject = function fromObject(d) {
        if (d instanceof $4ac3cca2aac7fb7f$var$$root.PublicKey) return d;
        var m = new $4ac3cca2aac7fb7f$var$$root.PublicKey();
        switch(d.Type){
            case "RSA":
            case 0:
                m.Type = 0;
                break;
            case "Ed25519":
            case 1:
                m.Type = 1;
                break;
            case "Secp256k1":
            case 2:
                m.Type = 2;
                break;
        }
        if (d.Data != null) {
            if (typeof d.Data === "string") $4ac3cca2aac7fb7f$var$$util.base64.decode(d.Data, m.Data = $4ac3cca2aac7fb7f$var$$util.newBuffer($4ac3cca2aac7fb7f$var$$util.base64.length(d.Data)), 0);
            else if (d.Data.length) m.Data = d.Data;
        }
        return m;
    };
    /**
     * Creates a plain object from a PublicKey message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicKey
     * @static
     * @param {PublicKey} m PublicKey
     * @param {$protobuf.IConversionOptions} [o] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ PublicKey.toObject = function toObject(m, o) {
        if (!o) o = {};
        var d = {};
        if (o.defaults) {
            d.Type = o.enums === String ? "RSA" : 0;
            if (o.bytes === String) d.Data = "";
            else {
                d.Data = [];
                if (o.bytes !== Array) d.Data = $4ac3cca2aac7fb7f$var$$util.newBuffer(d.Data);
            }
        }
        if (m.Type != null && m.hasOwnProperty("Type")) d.Type = o.enums === String ? $4ac3cca2aac7fb7f$var$$root.KeyType[m.Type] : m.Type;
        if (m.Data != null && m.hasOwnProperty("Data")) d.Data = o.bytes === String ? $4ac3cca2aac7fb7f$var$$util.base64.encode(m.Data, 0, m.Data.length) : o.bytes === Array ? Array.prototype.slice.call(m.Data) : m.Data;
        return d;
    };
    /**
     * Converts this PublicKey to JSON.
     * @function toJSON
     * @memberof PublicKey
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ PublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
    };
    return PublicKey;
}();
$4ac3cca2aac7fb7f$var$$root.PrivateKey = function() {
    /**
     * Properties of a PrivateKey.
     * @exports IPrivateKey
     * @interface IPrivateKey
     * @property {KeyType} Type PrivateKey Type
     * @property {Uint8Array} Data PrivateKey Data
     */ /**
     * Constructs a new PrivateKey.
     * @exports PrivateKey
     * @classdesc Represents a PrivateKey.
     * @implements IPrivateKey
     * @constructor
     * @param {IPrivateKey=} [p] Properties to set
     */ function PrivateKey(p) {
        if (p) {
            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }
    }
    /**
     * PrivateKey Type.
     * @member {KeyType} Type
     * @memberof PrivateKey
     * @instance
     */ PrivateKey.prototype.Type = 0;
    /**
     * PrivateKey Data.
     * @member {Uint8Array} Data
     * @memberof PrivateKey
     * @instance
     */ PrivateKey.prototype.Data = $4ac3cca2aac7fb7f$var$$util.newBuffer([]);
    /**
     * Encodes the specified PrivateKey message. Does not implicitly {@link PrivateKey.verify|verify} messages.
     * @function encode
     * @memberof PrivateKey
     * @static
     * @param {IPrivateKey} m PrivateKey message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ PrivateKey.encode = function encode(m, w) {
        if (!w) w = $4ac3cca2aac7fb7f$var$$Writer.create();
        w.uint32(8).int32(m.Type);
        w.uint32(18).bytes(m.Data);
        return w;
    };
    /**
     * Decodes a PrivateKey message from the specified reader or buffer.
     * @function decode
     * @memberof PrivateKey
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {PrivateKey} PrivateKey
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ PrivateKey.decode = function decode(r, l) {
        if (!(r instanceof $4ac3cca2aac7fb7f$var$$Reader)) r = $4ac3cca2aac7fb7f$var$$Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l, m = new $4ac3cca2aac7fb7f$var$$root.PrivateKey();
        while(r.pos < c){
            var t = r.uint32();
            switch(t >>> 3){
                case 1:
                    m.Type = r.int32();
                    break;
                case 2:
                    m.Data = r.bytes();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
            }
        }
        if (!m.hasOwnProperty("Type")) throw $4ac3cca2aac7fb7f$var$$util.ProtocolError("missing required 'Type'", {
            instance: m
        });
        if (!m.hasOwnProperty("Data")) throw $4ac3cca2aac7fb7f$var$$util.ProtocolError("missing required 'Data'", {
            instance: m
        });
        return m;
    };
    /**
     * Creates a PrivateKey message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PrivateKey
     * @static
     * @param {Object.<string,*>} d Plain object
     * @returns {PrivateKey} PrivateKey
     */ PrivateKey.fromObject = function fromObject(d) {
        if (d instanceof $4ac3cca2aac7fb7f$var$$root.PrivateKey) return d;
        var m = new $4ac3cca2aac7fb7f$var$$root.PrivateKey();
        switch(d.Type){
            case "RSA":
            case 0:
                m.Type = 0;
                break;
            case "Ed25519":
            case 1:
                m.Type = 1;
                break;
            case "Secp256k1":
            case 2:
                m.Type = 2;
                break;
        }
        if (d.Data != null) {
            if (typeof d.Data === "string") $4ac3cca2aac7fb7f$var$$util.base64.decode(d.Data, m.Data = $4ac3cca2aac7fb7f$var$$util.newBuffer($4ac3cca2aac7fb7f$var$$util.base64.length(d.Data)), 0);
            else if (d.Data.length) m.Data = d.Data;
        }
        return m;
    };
    /**
     * Creates a plain object from a PrivateKey message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PrivateKey
     * @static
     * @param {PrivateKey} m PrivateKey
     * @param {$protobuf.IConversionOptions} [o] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ PrivateKey.toObject = function toObject(m, o) {
        if (!o) o = {};
        var d = {};
        if (o.defaults) {
            d.Type = o.enums === String ? "RSA" : 0;
            if (o.bytes === String) d.Data = "";
            else {
                d.Data = [];
                if (o.bytes !== Array) d.Data = $4ac3cca2aac7fb7f$var$$util.newBuffer(d.Data);
            }
        }
        if (m.Type != null && m.hasOwnProperty("Type")) d.Type = o.enums === String ? $4ac3cca2aac7fb7f$var$$root.KeyType[m.Type] : m.Type;
        if (m.Data != null && m.hasOwnProperty("Data")) d.Data = o.bytes === String ? $4ac3cca2aac7fb7f$var$$util.base64.encode(m.Data, 0, m.Data.length) : o.bytes === Array ? Array.prototype.slice.call(m.Data) : m.Data;
        return d;
    };
    /**
     * Converts this PrivateKey to JSON.
     * @function toJSON
     * @memberof PrivateKey
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ PrivateKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
    };
    return PrivateKey;
}();
module.exports = $4ac3cca2aac7fb7f$var$$root;

});
parcelRequire.register("liRmU", function(module, exports) {
// minimal library entry point.
"use strict";

module.exports = (parcelRequire("jnG30"));

});
parcelRequire.register("jnG30", function(module, exports) {
"use strict";
var $e1c0c80ad2f6eb3d$var$protobuf = module.exports;
/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */ $e1c0c80ad2f6eb3d$var$protobuf.build = "minimal";

// Serialization
$e1c0c80ad2f6eb3d$var$protobuf.Writer = (parcelRequire("3Nz2z"));

$e1c0c80ad2f6eb3d$var$protobuf.BufferWriter = (parcelRequire("4Zfu9"));

$e1c0c80ad2f6eb3d$var$protobuf.Reader = (parcelRequire("2nTXx"));

$e1c0c80ad2f6eb3d$var$protobuf.BufferReader = (parcelRequire("7BzCD"));

// Utility
$e1c0c80ad2f6eb3d$var$protobuf.util = (parcelRequire("de64B"));

$e1c0c80ad2f6eb3d$var$protobuf.rpc = (parcelRequire("kprOF"));

$e1c0c80ad2f6eb3d$var$protobuf.roots = (parcelRequire("8fPpg"));
$e1c0c80ad2f6eb3d$var$protobuf.configure = $e1c0c80ad2f6eb3d$var$configure;
/* istanbul ignore next */ /**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */ function $e1c0c80ad2f6eb3d$var$configure() {
    $e1c0c80ad2f6eb3d$var$protobuf.util._configure();
    $e1c0c80ad2f6eb3d$var$protobuf.Writer._configure($e1c0c80ad2f6eb3d$var$protobuf.BufferWriter);
    $e1c0c80ad2f6eb3d$var$protobuf.Reader._configure($e1c0c80ad2f6eb3d$var$protobuf.BufferReader);
}
// Set up buffer utility according to the environment
$e1c0c80ad2f6eb3d$var$configure();

});
parcelRequire.register("3Nz2z", function(module, exports) {
"use strict";
module.exports = $2c4120feeee6f04e$var$Writer;

var $de64B = parcelRequire("de64B");
var $2c4120feeee6f04e$var$BufferWriter; // cyclic
var $2c4120feeee6f04e$var$LongBits = $de64B.LongBits, $2c4120feeee6f04e$var$base64 = $de64B.base64, $2c4120feeee6f04e$var$utf8 = $de64B.utf8;
/**
 * Constructs a new writer operation instance.
 * @classdesc Scheduled writer operation.
 * @constructor
 * @param {function(*, Uint8Array, number)} fn Function to call
 * @param {number} len Value byte length
 * @param {*} val Value to write
 * @ignore
 */ function $2c4120feeee6f04e$var$Op(fn, len, val) {
    /**
     * Function to call.
     * @type {function(Uint8Array, number, *)}
     */ this.fn = fn;
    /**
     * Value byte length.
     * @type {number}
     */ this.len = len;
    /**
     * Next operation.
     * @type {Writer.Op|undefined}
     */ this.next = undefined;
    /**
     * Value to write.
     * @type {*}
     */ this.val = val; // type varies
}
/* istanbul ignore next */ function $2c4120feeee6f04e$var$noop() {} // eslint-disable-line no-empty-function
/**
 * Constructs a new writer state instance.
 * @classdesc Copied writer state.
 * @memberof Writer
 * @constructor
 * @param {Writer} writer Writer to copy state from
 * @ignore
 */ function $2c4120feeee6f04e$var$State(writer) {
    /**
     * Current head.
     * @type {Writer.Op}
     */ this.head = writer.head;
    /**
     * Current tail.
     * @type {Writer.Op}
     */ this.tail = writer.tail;
    /**
     * Current buffer length.
     * @type {number}
     */ this.len = writer.len;
    /**
     * Next state.
     * @type {State|null}
     */ this.next = writer.states;
}
/**
 * Constructs a new writer instance.
 * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 */ function $2c4120feeee6f04e$var$Writer() {
    /**
     * Current length.
     * @type {number}
     */ this.len = 0;
    /**
     * Operations head.
     * @type {Object}
     */ this.head = new $2c4120feeee6f04e$var$Op($2c4120feeee6f04e$var$noop, 0, 0);
    /**
     * Operations tail
     * @type {Object}
     */ this.tail = this.head;
    /**
     * Linked forked states.
     * @type {Object|null}
     */ this.states = null;
// When a value is written, the writer calculates its byte length and puts it into a linked
// list of operations to perform when finish() is called. This both allows us to allocate
// buffers of the exact required size and reduces the amount of work we have to do compared
// to first calculating over objects and then encoding over objects. In our case, the encoding
// part is just a linked list walk calling operations with already prepared values.
}
var $2c4120feeee6f04e$var$create = function create() {
    return $de64B.Buffer ? function create_buffer_setup() {
        return ($2c4120feeee6f04e$var$Writer.create = function create_buffer() {
            return new $2c4120feeee6f04e$var$BufferWriter();
        })();
    } : function create_array() {
        return new $2c4120feeee6f04e$var$Writer();
    };
};
/**
 * Creates a new writer.
 * @function
 * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
 */ $2c4120feeee6f04e$var$Writer.create = $2c4120feeee6f04e$var$create();
/**
 * Allocates a buffer of the specified size.
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ $2c4120feeee6f04e$var$Writer.alloc = function alloc(size) {
    return new $de64B.Array(size);
};
// Use Uint8Array buffer pool in the browser, just like node does with buffers
/* istanbul ignore else */ if ($de64B.Array !== Array) $2c4120feeee6f04e$var$Writer.alloc = $de64B.pool($2c4120feeee6f04e$var$Writer.alloc, $de64B.Array.prototype.subarray);
/**
 * Pushes a new operation to the queue.
 * @param {function(Uint8Array, number, *)} fn Function to call
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @returns {Writer} `this`
 * @private
 */ $2c4120feeee6f04e$var$Writer.prototype._push = function push(fn, len, val) {
    this.tail = this.tail.next = new $2c4120feeee6f04e$var$Op(fn, len, val);
    this.len += len;
    return this;
};
function $2c4120feeee6f04e$var$writeByte(val, buf, pos) {
    buf[pos] = val & 255;
}
function $2c4120feeee6f04e$var$writeVarint32(val, buf, pos) {
    while(val > 127){
        buf[pos++] = val & 127 | 128;
        val >>>= 7;
    }
    buf[pos] = val;
}
/**
 * Constructs a new varint writer operation instance.
 * @classdesc Scheduled varint writer operation.
 * @extends Op
 * @constructor
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @ignore
 */ function $2c4120feeee6f04e$var$VarintOp(len, val) {
    this.len = len;
    this.next = undefined;
    this.val = val;
}
$2c4120feeee6f04e$var$VarintOp.prototype = Object.create($2c4120feeee6f04e$var$Op.prototype);
$2c4120feeee6f04e$var$VarintOp.prototype.fn = $2c4120feeee6f04e$var$writeVarint32;
/**
 * Writes an unsigned 32 bit value as a varint.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2c4120feeee6f04e$var$Writer.prototype.uint32 = function write_uint32(value) {
    // here, the call to this.push has been inlined and a varint specific Op subclass is used.
    // uint32 is by far the most frequently used operation and benefits significantly from this.
    this.len += (this.tail = this.tail.next = new $2c4120feeee6f04e$var$VarintOp((value = value >>> 0) < 128 ? 1 : value < 16384 ? 2 : value < 2097152 ? 3 : value < 268435456 ? 4 : 5, value)).len;
    return this;
};
/**
 * Writes a signed 32 bit value as a varint.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2c4120feeee6f04e$var$Writer.prototype.int32 = function write_int32(value) {
    return value < 0 ? this._push($2c4120feeee6f04e$var$writeVarint64, 10, $2c4120feeee6f04e$var$LongBits.fromNumber(value)) // 10 bytes per spec
     : this.uint32(value);
};
/**
 * Writes a 32 bit value as a varint, zig-zag encoded.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2c4120feeee6f04e$var$Writer.prototype.sint32 = function write_sint32(value) {
    return this.uint32((value << 1 ^ value >> 31) >>> 0);
};
function $2c4120feeee6f04e$var$writeVarint64(val, buf, pos) {
    while(val.hi){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = (val.lo >>> 7 | val.hi << 25) >>> 0;
        val.hi >>>= 7;
    }
    while(val.lo > 127){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = val.lo >>> 7;
    }
    buf[pos++] = val.lo;
}
/**
 * Writes an unsigned 64 bit value as a varint.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2c4120feeee6f04e$var$Writer.prototype.uint64 = function write_uint64(value) {
    var bits = $2c4120feeee6f04e$var$LongBits.from(value);
    return this._push($2c4120feeee6f04e$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a signed 64 bit value as a varint.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2c4120feeee6f04e$var$Writer.prototype.int64 = $2c4120feeee6f04e$var$Writer.prototype.uint64;
/**
 * Writes a signed 64 bit value as a varint, zig-zag encoded.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2c4120feeee6f04e$var$Writer.prototype.sint64 = function write_sint64(value) {
    var bits = $2c4120feeee6f04e$var$LongBits.from(value).zzEncode();
    return this._push($2c4120feeee6f04e$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a boolish value as a varint.
 * @param {boolean} value Value to write
 * @returns {Writer} `this`
 */ $2c4120feeee6f04e$var$Writer.prototype.bool = function write_bool(value) {
    return this._push($2c4120feeee6f04e$var$writeByte, 1, value ? 1 : 0);
};
function $2c4120feeee6f04e$var$writeFixed32(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
/**
 * Writes an unsigned 32 bit value as fixed 32 bits.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2c4120feeee6f04e$var$Writer.prototype.fixed32 = function write_fixed32(value) {
    return this._push($2c4120feeee6f04e$var$writeFixed32, 4, value >>> 0);
};
/**
 * Writes a signed 32 bit value as fixed 32 bits.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2c4120feeee6f04e$var$Writer.prototype.sfixed32 = $2c4120feeee6f04e$var$Writer.prototype.fixed32;
/**
 * Writes an unsigned 64 bit value as fixed 64 bits.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2c4120feeee6f04e$var$Writer.prototype.fixed64 = function write_fixed64(value) {
    var bits = $2c4120feeee6f04e$var$LongBits.from(value);
    return this._push($2c4120feeee6f04e$var$writeFixed32, 4, bits.lo)._push($2c4120feeee6f04e$var$writeFixed32, 4, bits.hi);
};
/**
 * Writes a signed 64 bit value as fixed 64 bits.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $2c4120feeee6f04e$var$Writer.prototype.sfixed64 = $2c4120feeee6f04e$var$Writer.prototype.fixed64;
/**
 * Writes a float (32 bit).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2c4120feeee6f04e$var$Writer.prototype.float = function write_float(value) {
    return this._push($de64B.float.writeFloatLE, 4, value);
};
/**
 * Writes a double (64 bit float).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $2c4120feeee6f04e$var$Writer.prototype.double = function write_double(value) {
    return this._push($de64B.float.writeDoubleLE, 8, value);
};
var $2c4120feeee6f04e$var$writeBytes = $de64B.Array.prototype.set ? function writeBytes_set(val, buf, pos) {
    buf.set(val, pos); // also works for plain array values
} : function writeBytes_for(val, buf, pos) {
    for(var i = 0; i < val.length; ++i)buf[pos + i] = val[i];
};
/**
 * Writes a sequence of bytes.
 * @param {Uint8Array|string} value Buffer or base64 encoded string to write
 * @returns {Writer} `this`
 */ $2c4120feeee6f04e$var$Writer.prototype.bytes = function write_bytes(value) {
    var len = value.length >>> 0;
    if (!len) return this._push($2c4120feeee6f04e$var$writeByte, 1, 0);
    if ($de64B.isString(value)) {
        var buf = $2c4120feeee6f04e$var$Writer.alloc(len = $2c4120feeee6f04e$var$base64.length(value));
        $2c4120feeee6f04e$var$base64.decode(value, buf, 0);
        value = buf;
    }
    return this.uint32(len)._push($2c4120feeee6f04e$var$writeBytes, len, value);
};
/**
 * Writes a string.
 * @param {string} value Value to write
 * @returns {Writer} `this`
 */ $2c4120feeee6f04e$var$Writer.prototype.string = function write_string(value) {
    var len = $2c4120feeee6f04e$var$utf8.length(value);
    return len ? this.uint32(len)._push($2c4120feeee6f04e$var$utf8.write, len, value) : this._push($2c4120feeee6f04e$var$writeByte, 1, 0);
};
/**
 * Forks this writer's state by pushing it to a stack.
 * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
 * @returns {Writer} `this`
 */ $2c4120feeee6f04e$var$Writer.prototype.fork = function fork() {
    this.states = new $2c4120feeee6f04e$var$State(this);
    this.head = this.tail = new $2c4120feeee6f04e$var$Op($2c4120feeee6f04e$var$noop, 0, 0);
    this.len = 0;
    return this;
};
/**
 * Resets this instance to the last state.
 * @returns {Writer} `this`
 */ $2c4120feeee6f04e$var$Writer.prototype.reset = function reset() {
    if (this.states) {
        this.head = this.states.head;
        this.tail = this.states.tail;
        this.len = this.states.len;
        this.states = this.states.next;
    } else {
        this.head = this.tail = new $2c4120feeee6f04e$var$Op($2c4120feeee6f04e$var$noop, 0, 0);
        this.len = 0;
    }
    return this;
};
/**
 * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
 * @returns {Writer} `this`
 */ $2c4120feeee6f04e$var$Writer.prototype.ldelim = function ldelim() {
    var head = this.head, tail = this.tail, len = this.len;
    this.reset().uint32(len);
    if (len) {
        this.tail.next = head.next; // skip noop
        this.tail = tail;
        this.len += len;
    }
    return this;
};
/**
 * Finishes the write operation.
 * @returns {Uint8Array} Finished buffer
 */ $2c4120feeee6f04e$var$Writer.prototype.finish = function finish() {
    var head = this.head.next, buf = this.constructor.alloc(this.len), pos = 0;
    while(head){
        head.fn(head.val, buf, pos);
        pos += head.len;
        head = head.next;
    }
    // this.head = this.tail = null;
    return buf;
};
$2c4120feeee6f04e$var$Writer._configure = function(BufferWriter_) {
    $2c4120feeee6f04e$var$BufferWriter = BufferWriter_;
    $2c4120feeee6f04e$var$Writer.create = $2c4120feeee6f04e$var$create();
    $2c4120feeee6f04e$var$BufferWriter._configure();
};

});
parcelRequire.register("de64B", function(module, exports) {
"use strict";
var $9a114b2a81c14d04$var$util = module.exports;

// used to return a Promise where callback is omitted
$9a114b2a81c14d04$var$util.asPromise = (parcelRequire("lGMgJ"));

// converts to / from base64 encoded strings
$9a114b2a81c14d04$var$util.base64 = (parcelRequire("fmPkM"));

// base class of rpc.Service
$9a114b2a81c14d04$var$util.EventEmitter = (parcelRequire("3vhN0"));

// float handling accross browsers
$9a114b2a81c14d04$var$util.float = (parcelRequire("bbIFy"));

// requires modules optionally and hides the call from bundlers
$9a114b2a81c14d04$var$util.inquire = (parcelRequire("fKmJP"));

// converts to / from utf8 encoded strings
$9a114b2a81c14d04$var$util.utf8 = (parcelRequire("lXpXb"));

// provides a node-like buffer pool in the browser
$9a114b2a81c14d04$var$util.pool = (parcelRequire("3UUzx"));

// utility to work with the low and high bits of a 64 bit value
$9a114b2a81c14d04$var$util.LongBits = (parcelRequire("41ZL7"));
/**
 * Whether running within node or not.
 * @memberof util
 * @type {boolean}
 */ $9a114b2a81c14d04$var$util.isNode = Boolean(typeof $parcel$global !== "undefined" && $parcel$global && $parcel$global.process && $parcel$global.process.versions && $parcel$global.process.versions.node);
/**
 * Global object reference.
 * @memberof util
 * @type {Object}
 */ $9a114b2a81c14d04$var$util.global = $9a114b2a81c14d04$var$util.isNode && $parcel$global || typeof window !== "undefined" && window || typeof self !== "undefined" && self || module.exports; // eslint-disable-line no-invalid-this
/**
 * An immuable empty array.
 * @memberof util
 * @type {Array.<*>}
 * @const
 */ $9a114b2a81c14d04$var$util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes
/**
 * An immutable empty object.
 * @type {Object}
 * @const
 */ $9a114b2a81c14d04$var$util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes
/**
 * Tests if the specified value is an integer.
 * @function
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is an integer
 */ $9a114b2a81c14d04$var$util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
/**
 * Tests if the specified value is a string.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a string
 */ $9a114b2a81c14d04$var$util.isString = function isString(value) {
    return typeof value === "string" || value instanceof String;
};
/**
 * Tests if the specified value is a non-null object.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a non-null object
 */ $9a114b2a81c14d04$var$util.isObject = function isObject(value) {
    return value && typeof value === "object";
};
/**
 * Checks if a property on a message is considered to be present.
 * This is an alias of {@link util.isSet}.
 * @function
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $9a114b2a81c14d04$var$util.isset = /**
 * Checks if a property on a message is considered to be present.
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $9a114b2a81c14d04$var$util.isSet = function isSet(obj, prop) {
    var value = obj[prop];
    if (value != null && obj.hasOwnProperty(prop)) return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    return false;
};
/**
 * Any compatible Buffer instance.
 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
 * @interface Buffer
 * @extends Uint8Array
 */ /**
 * Node's Buffer class if available.
 * @type {Constructor<Buffer>}
 */ $9a114b2a81c14d04$var$util.Buffer = function() {
    try {
        var Buffer = $9a114b2a81c14d04$var$util.inquire("buffer").Buffer;
        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
// Internal alias of or polyfull for Buffer.from.
$9a114b2a81c14d04$var$util._Buffer_from = null;
// Internal alias of or polyfill for Buffer.allocUnsafe.
$9a114b2a81c14d04$var$util._Buffer_allocUnsafe = null;
/**
 * Creates a new buffer of whatever type supported by the environment.
 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
 * @returns {Uint8Array|Buffer} Buffer
 */ $9a114b2a81c14d04$var$util.newBuffer = function newBuffer(sizeOrArray) {
    /* istanbul ignore next */ return typeof sizeOrArray === "number" ? $9a114b2a81c14d04$var$util.Buffer ? $9a114b2a81c14d04$var$util._Buffer_allocUnsafe(sizeOrArray) : new $9a114b2a81c14d04$var$util.Array(sizeOrArray) : $9a114b2a81c14d04$var$util.Buffer ? $9a114b2a81c14d04$var$util._Buffer_from(sizeOrArray) : typeof Uint8Array === "undefined" ? sizeOrArray : new Uint8Array(sizeOrArray);
};
/**
 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
 * @type {Constructor<Uint8Array>}
 */ $9a114b2a81c14d04$var$util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */  : Array;
/**
 * Any compatible Long instance.
 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
 * @interface Long
 * @property {number} low Low bits
 * @property {number} high High bits
 * @property {boolean} unsigned Whether unsigned or not
 */ /**
 * Long.js's Long class if available.
 * @type {Constructor<Long>}
 */ $9a114b2a81c14d04$var$util.Long = /* istanbul ignore next */ $9a114b2a81c14d04$var$util.global.dcodeIO && /* istanbul ignore next */ $9a114b2a81c14d04$var$util.global.dcodeIO.Long || /* istanbul ignore next */ $9a114b2a81c14d04$var$util.global.Long || $9a114b2a81c14d04$var$util.inquire("long");
/**
 * Regular expression used to verify 2 bit (`bool`) map keys.
 * @type {RegExp}
 * @const
 */ $9a114b2a81c14d04$var$util.key2Re = /^true|false|0|1$/;
/**
 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $9a114b2a81c14d04$var$util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
/**
 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $9a114b2a81c14d04$var$util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
/**
 * Converts a number or long to an 8 characters long hash string.
 * @param {Long|number} value Value to convert
 * @returns {string} Hash
 */ $9a114b2a81c14d04$var$util.longToHash = function longToHash(value) {
    return value ? $9a114b2a81c14d04$var$util.LongBits.from(value).toHash() : $9a114b2a81c14d04$var$util.LongBits.zeroHash;
};
/**
 * Converts an 8 characters long hash string to a long or number.
 * @param {string} hash Hash
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long|number} Original value
 */ $9a114b2a81c14d04$var$util.longFromHash = function longFromHash(hash, unsigned) {
    var bits = $9a114b2a81c14d04$var$util.LongBits.fromHash(hash);
    if ($9a114b2a81c14d04$var$util.Long) return $9a114b2a81c14d04$var$util.Long.fromBits(bits.lo, bits.hi, unsigned);
    return bits.toNumber(Boolean(unsigned));
};
/**
 * Merges the properties of the source object into the destination object.
 * @memberof util
 * @param {Object.<string,*>} dst Destination object
 * @param {Object.<string,*>} src Source object
 * @param {boolean} [ifNotSet=false] Merges only if the key is not already set
 * @returns {Object.<string,*>} Destination object
 */ function $9a114b2a81c14d04$var$merge(dst, src, ifNotSet) {
    for(var keys = Object.keys(src), i = 0; i < keys.length; ++i)if (dst[keys[i]] === undefined || !ifNotSet) dst[keys[i]] = src[keys[i]];
    return dst;
}
$9a114b2a81c14d04$var$util.merge = $9a114b2a81c14d04$var$merge;
/**
 * Converts the first character of a string to lower case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $9a114b2a81c14d04$var$util.lcFirst = function lcFirst(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
};
/**
 * Creates a custom error constructor.
 * @memberof util
 * @param {string} name Error name
 * @returns {Constructor<Error>} Custom error constructor
 */ function $9a114b2a81c14d04$var$newError(name) {
    function CustomError(message, properties) {
        if (!(this instanceof CustomError)) return new CustomError(message, properties);
        // Error.call(this, message);
        // ^ just returns a new error instance because the ctor can be called as a function
        Object.defineProperty(this, "message", {
            get: function() {
                return message;
            }
        });
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, CustomError);
        else Object.defineProperty(this, "stack", {
            value: new Error().stack || ""
        });
        if (properties) $9a114b2a81c14d04$var$merge(this, properties);
    }
    (CustomError.prototype = Object.create(Error.prototype)).constructor = CustomError;
    Object.defineProperty(CustomError.prototype, "name", {
        get: function() {
            return name;
        }
    });
    CustomError.prototype.toString = function toString() {
        return this.name + ": " + this.message;
    };
    return CustomError;
}
$9a114b2a81c14d04$var$util.newError = $9a114b2a81c14d04$var$newError;
/**
 * Constructs a new protocol error.
 * @classdesc Error subclass indicating a protocol specifc error.
 * @memberof util
 * @extends Error
 * @template T extends Message<T>
 * @constructor
 * @param {string} message Error message
 * @param {Object.<string,*>} [properties] Additional properties
 * @example
 * try {
 *     MyMessage.decode(someBuffer); // throws if required fields are missing
 * } catch (e) {
 *     if (e instanceof ProtocolError && e.instance)
 *         console.log("decoded so far: " + JSON.stringify(e.instance));
 * }
 */ $9a114b2a81c14d04$var$util.ProtocolError = $9a114b2a81c14d04$var$newError("ProtocolError");
/**
 * So far decoded message instance.
 * @name util.ProtocolError#instance
 * @type {Message<T>}
 */ /**
 * A OneOf getter as returned by {@link util.oneOfGetter}.
 * @typedef OneOfGetter
 * @type {function}
 * @returns {string|undefined} Set field name, if any
 */ /**
 * Builds a getter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfGetter} Unbound getter
 */ $9a114b2a81c14d04$var$util.oneOfGetter = function getOneOf(fieldNames) {
    var fieldMap = {};
    for(var i = 0; i < fieldNames.length; ++i)fieldMap[fieldNames[i]] = 1;
    /**
     * @returns {string|undefined} Set field name, if any
     * @this Object
     * @ignore
     */ return function() {
        for(var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null) return keys[i];
    };
};
/**
 * A OneOf setter as returned by {@link util.oneOfSetter}.
 * @typedef OneOfSetter
 * @type {function}
 * @param {string|undefined} value Field name
 * @returns {undefined}
 */ /**
 * Builds a setter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfSetter} Unbound setter
 */ $9a114b2a81c14d04$var$util.oneOfSetter = function setOneOf(fieldNames) {
    /**
     * @param {string} name Field name
     * @returns {undefined}
     * @this Object
     * @ignore
     */ return function(name) {
        for(var i = 0; i < fieldNames.length; ++i)if (fieldNames[i] !== name) delete this[fieldNames[i]];
    };
};
/**
 * Default conversion options used for {@link Message#toJSON} implementations.
 *
 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
 *
 * - Longs become strings
 * - Enums become string keys
 * - Bytes become base64 encoded strings
 * - (Sub-)Messages become plain objects
 * - Maps become plain objects with all string keys
 * - Repeated fields become arrays
 * - NaN and Infinity for float and double fields become strings
 *
 * @type {IConversionOptions}
 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
 */ $9a114b2a81c14d04$var$util.toJSONOptions = {
    longs: String,
    enums: String,
    bytes: String,
    json: true
};
// Sets up buffer utility according to the environment (called in index-minimal)
$9a114b2a81c14d04$var$util._configure = function() {
    var Buffer = $9a114b2a81c14d04$var$util.Buffer;
    /* istanbul ignore if */ if (!Buffer) {
        $9a114b2a81c14d04$var$util._Buffer_from = $9a114b2a81c14d04$var$util._Buffer_allocUnsafe = null;
        return;
    }
    // because node 4.x buffers are incompatible & immutable
    // see: https://github.com/dcodeIO/protobuf.js/pull/665
    $9a114b2a81c14d04$var$util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from || /* istanbul ignore next */ function Buffer_from(value, encoding) {
        return new Buffer(value, encoding);
    };
    $9a114b2a81c14d04$var$util._Buffer_allocUnsafe = Buffer.allocUnsafe || /* istanbul ignore next */ function Buffer_allocUnsafe(size) {
        return new Buffer(size);
    };
};

});
parcelRequire.register("lGMgJ", function(module, exports) {
"use strict";
module.exports = $fca2f66dfaa58e5f$var$asPromise;
/**
 * Callback as used by {@link util.asPromise}.
 * @typedef asPromiseCallback
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {...*} params Additional arguments
 * @returns {undefined}
 */ /**
 * Returns a promise from a node-style callback function.
 * @memberof util
 * @param {asPromiseCallback} fn Function to call
 * @param {*} ctx Function context
 * @param {...*} params Function arguments
 * @returns {Promise<*>} Promisified function
 */ function $fca2f66dfaa58e5f$var$asPromise(fn, ctx /*, varargs */ ) {
    var params = new Array(arguments.length - 1), offset = 0, index = 2, pending = true;
    while(index < arguments.length)params[offset++] = arguments[index++];
    return new Promise(function executor(resolve, reject) {
        params[offset] = function callback(err /*, varargs */ ) {
            if (pending) {
                pending = false;
                if (err) reject(err);
                else {
                    var params = new Array(arguments.length - 1), offset = 0;
                    while(offset < params.length)params[offset++] = arguments[offset];
                    resolve.apply(null, params);
                }
            }
        };
        try {
            fn.apply(ctx || null, params);
        } catch (err) {
            if (pending) {
                pending = false;
                reject(err);
            }
        }
    });
}

});

parcelRequire.register("fmPkM", function(module, exports) {
"use strict";
/**
 * A minimal base64 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $b300bafe172d4b81$var$base64 = module.exports;
/**
 * Calculates the byte length of a base64 encoded string.
 * @param {string} string Base64 encoded string
 * @returns {number} Byte length
 */ $b300bafe172d4b81$var$base64.length = function length(string) {
    var p = string.length;
    if (!p) return 0;
    var n = 0;
    while(--p % 4 > 1 && string.charAt(p) === "=")++n;
    return Math.ceil(string.length * 3) / 4 - n;
};
// Base64 encoding table
var $b300bafe172d4b81$var$b64 = new Array(64);
// Base64 decoding table
var $b300bafe172d4b81$var$s64 = new Array(123);
// 65..90, 97..122, 48..57, 43, 47
for(var $b300bafe172d4b81$var$i = 0; $b300bafe172d4b81$var$i < 64;)$b300bafe172d4b81$var$s64[$b300bafe172d4b81$var$b64[$b300bafe172d4b81$var$i] = $b300bafe172d4b81$var$i < 26 ? $b300bafe172d4b81$var$i + 65 : $b300bafe172d4b81$var$i < 52 ? $b300bafe172d4b81$var$i + 71 : $b300bafe172d4b81$var$i < 62 ? $b300bafe172d4b81$var$i - 4 : $b300bafe172d4b81$var$i - 59 | 43] = $b300bafe172d4b81$var$i++;
/**
 * Encodes a buffer to a base64 encoded string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} Base64 encoded string
 */ $b300bafe172d4b81$var$base64.encode = function encode(buffer, start, end) {
    var parts = null, chunk = [];
    var i = 0, j = 0, t; // temporary
    while(start < end){
        var b = buffer[start++];
        switch(j){
            case 0:
                chunk[i++] = $b300bafe172d4b81$var$b64[b >> 2];
                t = (b & 3) << 4;
                j = 1;
                break;
            case 1:
                chunk[i++] = $b300bafe172d4b81$var$b64[t | b >> 4];
                t = (b & 15) << 2;
                j = 2;
                break;
            case 2:
                chunk[i++] = $b300bafe172d4b81$var$b64[t | b >> 6];
                chunk[i++] = $b300bafe172d4b81$var$b64[b & 63];
                j = 0;
                break;
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (j) {
        chunk[i++] = $b300bafe172d4b81$var$b64[t];
        chunk[i++] = 61;
        if (j === 1) chunk[i++] = 61;
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
var $b300bafe172d4b81$var$invalidEncoding = "invalid encoding";
/**
 * Decodes a base64 encoded string to a buffer.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Number of bytes written
 * @throws {Error} If encoding is invalid
 */ $b300bafe172d4b81$var$base64.decode = function decode(string, buffer, offset) {
    var start = offset;
    var j = 0, t; // temporary
    for(var i = 0; i < string.length;){
        var c = string.charCodeAt(i++);
        if (c === 61 && j > 1) break;
        if ((c = $b300bafe172d4b81$var$s64[c]) === undefined) throw Error($b300bafe172d4b81$var$invalidEncoding);
        switch(j){
            case 0:
                t = c;
                j = 1;
                break;
            case 1:
                buffer[offset++] = t << 2 | (c & 48) >> 4;
                t = c;
                j = 2;
                break;
            case 2:
                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
                t = c;
                j = 3;
                break;
            case 3:
                buffer[offset++] = (t & 3) << 6 | c;
                j = 0;
                break;
        }
    }
    if (j === 1) throw Error($b300bafe172d4b81$var$invalidEncoding);
    return offset - start;
};
/**
 * Tests if the specified string appears to be base64 encoded.
 * @param {string} string String to test
 * @returns {boolean} `true` if probably base64 encoded, otherwise false
 */ $b300bafe172d4b81$var$base64.test = function test(string) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
};

});

parcelRequire.register("3vhN0", function(module, exports) {
"use strict";
module.exports = $28d210f38e8851af$var$EventEmitter;
/**
 * Constructs a new event emitter instance.
 * @classdesc A minimal event emitter.
 * @memberof util
 * @constructor
 */ function $28d210f38e8851af$var$EventEmitter() {
    /**
     * Registered listeners.
     * @type {Object.<string,*>}
     * @private
     */ this._listeners = Object.create(null);
}
/**
 * Event listener as used by {@link util.EventEmitter}.
 * @typedef EventEmitterListener
 * @type {function}
 * @param {...*} args Arguments
 * @returns {undefined}
 */ /**
 * Registers an event listener.
 * @param {string} evt Event name
 * @param {EventEmitterListener} fn Listener
 * @param {*} [ctx] Listener context
 * @returns {this} `this`
 */ $28d210f38e8851af$var$EventEmitter.prototype.on = function on(evt, fn, ctx) {
    (this._listeners[evt] || (this._listeners[evt] = [])).push({
        fn: fn,
        ctx: ctx || this
    });
    return this;
};
/**
 * Removes an event listener or any matching listeners if arguments are omitted.
 * @param {string} [evt] Event name. Removes all listeners if omitted.
 * @param {EventEmitterListener} [fn] Listener to remove. Removes all listeners of `evt` if omitted.
 * @returns {this} `this`
 */ $28d210f38e8851af$var$EventEmitter.prototype.off = function off(evt, fn) {
    if (evt === undefined) this._listeners = Object.create(null);
    else if (fn === undefined) this._listeners[evt] = [];
    else {
        var listeners = this._listeners[evt];
        if (!listeners) return this;
        for(var i = 0; i < listeners.length;)if (listeners[i].fn === fn) listeners.splice(i, 1);
        else ++i;
    }
    return this;
};
/**
 * Emits an event by calling its listeners with the specified arguments.
 * @param {string} evt Event name
 * @param {...*} args Arguments
 * @returns {this} `this`
 */ $28d210f38e8851af$var$EventEmitter.prototype.emit = function emit(evt) {
    var listeners = this._listeners[evt];
    if (listeners) {
        var args = [], i = 1;
        for(; i < arguments.length;)args.push(arguments[i++]);
        for(i = 0; i < listeners.length;)listeners[i].fn.apply(listeners[i++].ctx, args);
    }
    return this;
};

});

parcelRequire.register("bbIFy", function(module, exports) {
"use strict";
module.exports = $82535f2e1f489aa7$var$factory($82535f2e1f489aa7$var$factory);
/**
 * Reads / writes floats / doubles from / to buffers.
 * @name util.float
 * @namespace
 */ /**
 * Writes a 32 bit float to a buffer using little endian byte order.
 * @name util.float.writeFloatLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 32 bit float to a buffer using big endian byte order.
 * @name util.float.writeFloatBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 32 bit float from a buffer using little endian byte order.
 * @name util.float.readFloatLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 32 bit float from a buffer using big endian byte order.
 * @name util.float.readFloatBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Writes a 64 bit double to a buffer using little endian byte order.
 * @name util.float.writeDoubleLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 64 bit double to a buffer using big endian byte order.
 * @name util.float.writeDoubleBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 64 bit double from a buffer using little endian byte order.
 * @name util.float.readDoubleLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 64 bit double from a buffer using big endian byte order.
 * @name util.float.readDoubleBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ // Factory function for the purpose of node-based testing in modified global environments
function $82535f2e1f489aa7$var$factory(exports) {
    // float: typed array
    if (typeof Float32Array !== "undefined") (function() {
        var f32 = new Float32Array([
            -0
        ]), f8b = new Uint8Array(f32.buffer), le = f8b[3] === 128;
        function writeFloat_f32_cpy(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
        }
        function writeFloat_f32_rev(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[3];
            buf[pos + 1] = f8b[2];
            buf[pos + 2] = f8b[1];
            buf[pos + 3] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
        /* istanbul ignore next */ exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;
        function readFloat_f32_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            return f32[0];
        }
        function readFloat_f32_rev(buf, pos) {
            f8b[3] = buf[pos];
            f8b[2] = buf[pos + 1];
            f8b[1] = buf[pos + 2];
            f8b[0] = buf[pos + 3];
            return f32[0];
        }
        /* istanbul ignore next */ exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
        /* istanbul ignore next */ exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
    // float: ieee754
    })();
    else (function() {
        function writeFloat_ieee754(writeUint, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
            else if (isNaN(val)) writeUint(2143289344, buf, pos);
            else if (val > 3.4028234663852886e+38) writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
            else if (val < 1.1754943508222875e-38) writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
            else {
                var exponent = Math.floor(Math.log(val) / Math.LN2), mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
                writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
            }
        }
        exports.writeFloatLE = writeFloat_ieee754.bind(null, $82535f2e1f489aa7$var$writeUintLE);
        exports.writeFloatBE = writeFloat_ieee754.bind(null, $82535f2e1f489aa7$var$writeUintBE);
        function readFloat_ieee754(readUint, buf, pos) {
            var uint = readUint(buf, pos), sign = (uint >> 31) * 2 + 1, exponent = uint >>> 23 & 255, mantissa = uint & 8388607;
            return exponent === 255 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 1.401298464324817e-45 * mantissa : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
        }
        exports.readFloatLE = readFloat_ieee754.bind(null, $82535f2e1f489aa7$var$readUintLE);
        exports.readFloatBE = readFloat_ieee754.bind(null, $82535f2e1f489aa7$var$readUintBE);
    })();
    // double: typed array
    if (typeof Float64Array !== "undefined") (function() {
        var f64 = new Float64Array([
            -0
        ]), f8b = new Uint8Array(f64.buffer), le = f8b[7] === 128;
        function writeDouble_f64_cpy(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
            buf[pos + 4] = f8b[4];
            buf[pos + 5] = f8b[5];
            buf[pos + 6] = f8b[6];
            buf[pos + 7] = f8b[7];
        }
        function writeDouble_f64_rev(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[7];
            buf[pos + 1] = f8b[6];
            buf[pos + 2] = f8b[5];
            buf[pos + 3] = f8b[4];
            buf[pos + 4] = f8b[3];
            buf[pos + 5] = f8b[2];
            buf[pos + 6] = f8b[1];
            buf[pos + 7] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
        /* istanbul ignore next */ exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;
        function readDouble_f64_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            f8b[4] = buf[pos + 4];
            f8b[5] = buf[pos + 5];
            f8b[6] = buf[pos + 6];
            f8b[7] = buf[pos + 7];
            return f64[0];
        }
        function readDouble_f64_rev(buf, pos) {
            f8b[7] = buf[pos];
            f8b[6] = buf[pos + 1];
            f8b[5] = buf[pos + 2];
            f8b[4] = buf[pos + 3];
            f8b[3] = buf[pos + 4];
            f8b[2] = buf[pos + 5];
            f8b[1] = buf[pos + 6];
            f8b[0] = buf[pos + 7];
            return f64[0];
        }
        /* istanbul ignore next */ exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
        /* istanbul ignore next */ exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;
    // double: ieee754
    })();
    else (function() {
        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) {
                writeUint(0, buf, pos + off0);
                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
            } else if (isNaN(val)) {
                writeUint(0, buf, pos + off0);
                writeUint(2146959360, buf, pos + off1);
            } else if (val > 1.7976931348623157e+308) {
                writeUint(0, buf, pos + off0);
                writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
            } else {
                var mantissa;
                if (val < 2.2250738585072014e-308) {
                    mantissa = val / 5e-324;
                    writeUint(mantissa >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
                } else {
                    var exponent = Math.floor(Math.log(val) / Math.LN2);
                    if (exponent === 1024) exponent = 1023;
                    mantissa = val * Math.pow(2, -exponent);
                    writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
                }
            }
        }
        exports.writeDoubleLE = writeDouble_ieee754.bind(null, $82535f2e1f489aa7$var$writeUintLE, 0, 4);
        exports.writeDoubleBE = writeDouble_ieee754.bind(null, $82535f2e1f489aa7$var$writeUintBE, 4, 0);
        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
            var lo = readUint(buf, pos + off0), hi = readUint(buf, pos + off1);
            var sign = (hi >> 31) * 2 + 1, exponent = hi >>> 20 & 2047, mantissa = 4294967296 * (hi & 1048575) + lo;
            return exponent === 2047 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 5e-324 * mantissa : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
        }
        exports.readDoubleLE = readDouble_ieee754.bind(null, $82535f2e1f489aa7$var$readUintLE, 0, 4);
        exports.readDoubleBE = readDouble_ieee754.bind(null, $82535f2e1f489aa7$var$readUintBE, 4, 0);
    })();
    return exports;
}
// uint helpers
function $82535f2e1f489aa7$var$writeUintLE(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
function $82535f2e1f489aa7$var$writeUintBE(val, buf, pos) {
    buf[pos] = val >>> 24;
    buf[pos + 1] = val >>> 16 & 255;
    buf[pos + 2] = val >>> 8 & 255;
    buf[pos + 3] = val & 255;
}
function $82535f2e1f489aa7$var$readUintLE(buf, pos) {
    return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16 | buf[pos + 3] << 24) >>> 0;
}
function $82535f2e1f489aa7$var$readUintBE(buf, pos) {
    return (buf[pos] << 24 | buf[pos + 1] << 16 | buf[pos + 2] << 8 | buf[pos + 3]) >>> 0;
}

});

parcelRequire.register("fKmJP", function(module, exports) {
"use strict";
module.exports = $b76cca3cfcf8c859$var$inquire;
/**
 * Requires a module only if available.
 * @memberof util
 * @param {string} moduleName Module to require
 * @returns {?Object} Required module if available and not empty, otherwise `null`
 * @deprecated Legacy optional require helper. Will be removed in a future release.
 */ function $b76cca3cfcf8c859$var$inquire(moduleName) {
    try {
        var mod = require(moduleName);
        if (mod && (mod.length || Object.keys(mod).length)) return mod;
        return null;
    } catch (err) {
        // ignore
        return null;
    }
} /*
// maybe worth a shot to prevent renaming issues:
// see: https://github.com/webpack/webpack/blob/master/lib/dependencies/CommonJsRequireDependencyParserPlugin.js
// triggers on:
// - expression require.cache
// - expression require (???)
// - call require
// - call require:commonjs:item
// - call require:commonjs:context

Object.defineProperty(Function.prototype, "__self", { get: function() { return this; } });
var r = require.__self;
delete Function.prototype.__self;
*/ 

});

parcelRequire.register("lXpXb", function(module, exports) {
"use strict";
/**
 * A minimal UTF8 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $ffc33d7f5e892b5c$var$utf8 = module.exports, $ffc33d7f5e892b5c$var$replacementChar = "�";
/**
 * Calculates the UTF8 byte length of a string.
 * @param {string} string String
 * @returns {number} Byte length
 */ $ffc33d7f5e892b5c$var$utf8.length = function utf8_length(string) {
    var len = 0, c = 0;
    for(var i = 0; i < string.length; ++i){
        c = string.charCodeAt(i);
        if (c < 128) len += 1;
        else if (c < 2048) len += 2;
        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
            ++i;
            len += 4;
        } else len += 3;
    }
    return len;
};
/**
 * Reads UTF8 bytes as a string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} String read
 */ $ffc33d7f5e892b5c$var$utf8.read = function utf8_read(buffer, start, end) {
    if (end - start < 1) return "";
    var str = "";
    for(var i = start; i < end;){
        var t = buffer[i++];
        if (t <= 0x7F) str += String.fromCharCode(t);
        else if (t >= 0xC0 && t < 0xE0) {
            var c2 = (t & 0x1F) << 6 | buffer[i++] & 0x3F;
            str += c2 >= 0x80 ? String.fromCharCode(c2) : $ffc33d7f5e892b5c$var$replacementChar;
        } else if (t >= 0xE0 && t < 0xF0) {
            var c3 = (t & 0xF) << 12 | (buffer[i++] & 0x3F) << 6 | buffer[i++] & 0x3F;
            str += c3 >= 0x800 ? String.fromCharCode(c3) : $ffc33d7f5e892b5c$var$replacementChar;
        } else if (t >= 0xF0) {
            var t2 = (t & 7) << 18 | (buffer[i++] & 0x3F) << 12 | (buffer[i++] & 0x3F) << 6 | buffer[i++] & 0x3F;
            if (t2 < 0x10000 || t2 > 0x10FFFF) str += $ffc33d7f5e892b5c$var$replacementChar;
            else {
                t2 -= 0x10000;
                str += String.fromCharCode(0xD800 + (t2 >> 10));
                str += String.fromCharCode(0xDC00 + (t2 & 0x3FF));
            }
        }
    }
    return str;
};
/**
 * Writes a string as UTF8 bytes.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Bytes written
 */ $ffc33d7f5e892b5c$var$utf8.write = function utf8_write(string, buffer, offset) {
    var start = offset, c1, c2; // character 2
    for(var i = 0; i < string.length; ++i){
        c1 = string.charCodeAt(i);
        if (c1 < 128) buffer[offset++] = c1;
        else if (c1 < 2048) {
            buffer[offset++] = c1 >> 6 | 192;
            buffer[offset++] = c1 & 63 | 128;
        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
            ++i;
            buffer[offset++] = c1 >> 18 | 240;
            buffer[offset++] = c1 >> 12 & 63 | 128;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        } else {
            buffer[offset++] = c1 >> 12 | 224;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        }
    }
    return offset - start;
};

});

parcelRequire.register("3UUzx", function(module, exports) {
"use strict";
module.exports = $2da27c1ec4d0ee87$var$pool;
/**
 * An allocator as used by {@link util.pool}.
 * @typedef PoolAllocator
 * @type {function}
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ /**
 * A slicer as used by {@link util.pool}.
 * @typedef PoolSlicer
 * @type {function}
 * @param {number} start Start offset
 * @param {number} end End offset
 * @returns {Uint8Array} Buffer slice
 * @this {Uint8Array}
 */ /**
 * A general purpose buffer pool.
 * @memberof util
 * @function
 * @param {PoolAllocator} alloc Allocator
 * @param {PoolSlicer} slice Slicer
 * @param {number} [size=8192] Slab size
 * @returns {PoolAllocator} Pooled allocator
 */ function $2da27c1ec4d0ee87$var$pool(alloc, slice, size) {
    var SIZE = size || 8192;
    var MAX = SIZE >>> 1;
    var slab = null;
    var offset = SIZE;
    return function pool_alloc(size) {
        if (size < 1 || size > MAX) return alloc(size);
        if (offset + size > SIZE) {
            slab = alloc(SIZE);
            offset = 0;
        }
        var buf = slice.call(slab, offset, offset += size);
        if (offset & 7) offset = (offset | 7) + 1;
        return buf;
    };
}

});

parcelRequire.register("41ZL7", function(module, exports) {
"use strict";
module.exports = $2ef72976bb971c52$var$LongBits;

var $de64B = parcelRequire("de64B");
/**
 * Constructs new long bits.
 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
 * @memberof util
 * @constructor
 * @param {number} lo Low 32 bits, unsigned
 * @param {number} hi High 32 bits, unsigned
 */ function $2ef72976bb971c52$var$LongBits(lo, hi) {
    // note that the casts below are theoretically unnecessary as of today, but older statically
    // generated converter code might still call the ctor with signed 32bits. kept for compat.
    /**
     * Low bits.
     * @type {number}
     */ this.lo = lo >>> 0;
    /**
     * High bits.
     * @type {number}
     */ this.hi = hi >>> 0;
}
/**
 * Zero bits.
 * @memberof util.LongBits
 * @type {util.LongBits}
 */ var $2ef72976bb971c52$var$zero = $2ef72976bb971c52$var$LongBits.zero = new $2ef72976bb971c52$var$LongBits(0, 0);
$2ef72976bb971c52$var$zero.toNumber = function() {
    return 0;
};
$2ef72976bb971c52$var$zero.zzEncode = $2ef72976bb971c52$var$zero.zzDecode = function() {
    return this;
};
$2ef72976bb971c52$var$zero.length = function() {
    return 1;
};
/**
 * Zero hash.
 * @memberof util.LongBits
 * @type {string}
 */ var $2ef72976bb971c52$var$zeroHash = $2ef72976bb971c52$var$LongBits.zeroHash = "\x00\x00\x00\x00\x00\x00\x00\x00";
/**
 * Constructs new long bits from the specified number.
 * @param {number} value Value
 * @returns {util.LongBits} Instance
 */ $2ef72976bb971c52$var$LongBits.fromNumber = function fromNumber(value) {
    if (value === 0) return $2ef72976bb971c52$var$zero;
    var sign = value < 0;
    if (sign) value = -value;
    var lo = value >>> 0, hi = (value - lo) / 4294967296 >>> 0;
    if (sign) {
        hi = ~hi >>> 0;
        lo = ~lo >>> 0;
        if (++lo > 4294967295) {
            lo = 0;
            if (++hi > 4294967295) hi = 0;
        }
    }
    return new $2ef72976bb971c52$var$LongBits(lo, hi);
};
/**
 * Constructs new long bits from a number, long or string.
 * @param {Long|number|string} value Value
 * @returns {util.LongBits} Instance
 */ $2ef72976bb971c52$var$LongBits.from = function from(value) {
    if (typeof value === "number") return $2ef72976bb971c52$var$LongBits.fromNumber(value);
    if ($de64B.isString(value)) {
        /* istanbul ignore else */ if ($de64B.Long) value = $de64B.Long.fromString(value);
        else return $2ef72976bb971c52$var$LongBits.fromNumber(parseInt(value, 10));
    }
    return value.low || value.high ? new $2ef72976bb971c52$var$LongBits(value.low >>> 0, value.high >>> 0) : $2ef72976bb971c52$var$zero;
};
/**
 * Converts this long bits to a possibly unsafe JavaScript number.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {number} Possibly unsafe number
 */ $2ef72976bb971c52$var$LongBits.prototype.toNumber = function toNumber(unsigned) {
    if (!unsigned && this.hi >>> 31) {
        var lo = ~this.lo + 1 >>> 0, hi = ~this.hi >>> 0;
        if (!lo) hi = hi + 1 >>> 0;
        return -(lo + hi * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
};
/**
 * Converts this long bits to a long.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long} Long
 */ $2ef72976bb971c52$var$LongBits.prototype.toLong = function toLong(unsigned) {
    return $de64B.Long ? new $de64B.Long(this.lo | 0, this.hi | 0, Boolean(unsigned)) : {
        low: this.lo | 0,
        high: this.hi | 0,
        unsigned: Boolean(unsigned)
    };
};
var $2ef72976bb971c52$var$charCodeAt = String.prototype.charCodeAt;
/**
 * Constructs new long bits from the specified 8 characters long hash.
 * @param {string} hash Hash
 * @returns {util.LongBits} Bits
 */ $2ef72976bb971c52$var$LongBits.fromHash = function fromHash(hash) {
    if (hash === $2ef72976bb971c52$var$zeroHash) return $2ef72976bb971c52$var$zero;
    return new $2ef72976bb971c52$var$LongBits(($2ef72976bb971c52$var$charCodeAt.call(hash, 0) | $2ef72976bb971c52$var$charCodeAt.call(hash, 1) << 8 | $2ef72976bb971c52$var$charCodeAt.call(hash, 2) << 16 | $2ef72976bb971c52$var$charCodeAt.call(hash, 3) << 24) >>> 0, ($2ef72976bb971c52$var$charCodeAt.call(hash, 4) | $2ef72976bb971c52$var$charCodeAt.call(hash, 5) << 8 | $2ef72976bb971c52$var$charCodeAt.call(hash, 6) << 16 | $2ef72976bb971c52$var$charCodeAt.call(hash, 7) << 24) >>> 0);
};
/**
 * Converts this long bits to a 8 characters long hash.
 * @returns {string} Hash
 */ $2ef72976bb971c52$var$LongBits.prototype.toHash = function toHash() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
};
/**
 * Zig-zag encodes this long bits.
 * @returns {util.LongBits} `this`
 */ $2ef72976bb971c52$var$LongBits.prototype.zzEncode = function zzEncode() {
    var mask = this.hi >> 31;
    this.hi = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    this.lo = (this.lo << 1 ^ mask) >>> 0;
    return this;
};
/**
 * Zig-zag decodes this long bits.
 * @returns {util.LongBits} `this`
 */ $2ef72976bb971c52$var$LongBits.prototype.zzDecode = function zzDecode() {
    var mask = -(this.lo & 1);
    this.lo = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    this.hi = (this.hi >>> 1 ^ mask) >>> 0;
    return this;
};
/**
 * Calculates the length of this longbits when encoded as a varint.
 * @returns {number} Length
 */ $2ef72976bb971c52$var$LongBits.prototype.length = function length() {
    var part0 = this.lo, part1 = (this.lo >>> 28 | this.hi << 4) >>> 0, part2 = this.hi >>> 24;
    return part2 === 0 ? part1 === 0 ? part0 < 16384 ? part0 < 128 ? 1 : 2 : part0 < 2097152 ? 3 : 4 : part1 < 16384 ? part1 < 128 ? 5 : 6 : part1 < 2097152 ? 7 : 8 : part2 < 128 ? 9 : 10;
};

});



parcelRequire.register("4Zfu9", function(module, exports) {
"use strict";
module.exports = $3a18defeb88a9e71$var$BufferWriter;

var $3Nz2z = parcelRequire("3Nz2z");
($3a18defeb88a9e71$var$BufferWriter.prototype = Object.create($3Nz2z.prototype)).constructor = $3a18defeb88a9e71$var$BufferWriter;

var $de64B = parcelRequire("de64B");
/**
 * Constructs a new buffer writer instance.
 * @classdesc Wire format writer using node buffers.
 * @extends Writer
 * @constructor
 */ function $3a18defeb88a9e71$var$BufferWriter() {
    $3Nz2z.call(this);
}
$3a18defeb88a9e71$var$BufferWriter._configure = function() {
    /**
     * Allocates a buffer of the specified size.
     * @function
     * @param {number} size Buffer size
     * @returns {Buffer} Buffer
     */ $3a18defeb88a9e71$var$BufferWriter.alloc = $de64B._Buffer_allocUnsafe;
    $3a18defeb88a9e71$var$BufferWriter.writeBytesBuffer = $de64B.Buffer && $de64B.Buffer.prototype instanceof Uint8Array && $de64B.Buffer.prototype.set.name === "set" ? function writeBytesBuffer_set(val, buf, pos) {
        buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
    // also works for plain array values
    } : function writeBytesBuffer_copy(val, buf, pos) {
        if (val.copy) val.copy(buf, pos, 0, val.length);
        else for(var i = 0; i < val.length;)buf[pos++] = val[i++];
    };
};
/**
 * @override
 */ $3a18defeb88a9e71$var$BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
    if ($de64B.isString(value)) value = $de64B._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len) this._push($3a18defeb88a9e71$var$BufferWriter.writeBytesBuffer, len, value);
    return this;
};
function $3a18defeb88a9e71$var$writeStringBuffer(val, buf, pos) {
    if (val.length < 40) $de64B.utf8.write(val, buf, pos);
    else if (buf.utf8Write) buf.utf8Write(val, pos);
    else buf.write(val, pos);
}
/**
 * @override
 */ $3a18defeb88a9e71$var$BufferWriter.prototype.string = function write_string_buffer(value) {
    var len = $de64B.Buffer.byteLength(value);
    this.uint32(len);
    if (len) this._push($3a18defeb88a9e71$var$writeStringBuffer, len, value);
    return this;
};
/**
 * Finishes the write operation.
 * @name BufferWriter#finish
 * @function
 * @returns {Buffer} Finished buffer
 */ $3a18defeb88a9e71$var$BufferWriter._configure();

});

parcelRequire.register("2nTXx", function(module, exports) {
"use strict";
module.exports = $1bc923147a9e3525$var$Reader;

var $de64B = parcelRequire("de64B");
var $1bc923147a9e3525$var$BufferReader; // cyclic
var $1bc923147a9e3525$var$LongBits = $de64B.LongBits, $1bc923147a9e3525$var$utf8 = $de64B.utf8;
/* istanbul ignore next */ function $1bc923147a9e3525$var$indexOutOfRange(reader, writeLength) {
    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
}
/**
 * Constructs a new reader instance using the specified buffer.
 * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 * @param {Uint8Array} buffer Buffer to read from
 */ function $1bc923147a9e3525$var$Reader(buffer) {
    /**
     * Read buffer.
     * @type {Uint8Array}
     */ this.buf = buffer;
    /**
     * Read buffer position.
     * @type {number}
     */ this.pos = 0;
    /**
     * Read buffer length.
     * @type {number}
     */ this.len = buffer.length;
}
var $1bc923147a9e3525$var$create_array = typeof Uint8Array !== "undefined" ? function create_typed_array(buffer) {
    if (buffer instanceof Uint8Array || Array.isArray(buffer)) return new $1bc923147a9e3525$var$Reader(buffer);
    throw Error("illegal buffer");
} : function create_array(buffer) {
    if (Array.isArray(buffer)) return new $1bc923147a9e3525$var$Reader(buffer);
    throw Error("illegal buffer");
};
var $1bc923147a9e3525$var$create = function create() {
    return $de64B.Buffer ? function create_buffer_setup(buffer) {
        return ($1bc923147a9e3525$var$Reader.create = function create_buffer(buffer) {
            return $de64B.Buffer.isBuffer(buffer) ? new $1bc923147a9e3525$var$BufferReader(buffer) : $1bc923147a9e3525$var$create_array(buffer);
        })(buffer);
    } : $1bc923147a9e3525$var$create_array;
};
/**
 * Creates a new reader using the specified buffer.
 * @function
 * @param {Uint8Array|Buffer} buffer Buffer to read from
 * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
 * @throws {Error} If `buffer` is not a valid buffer
 */ $1bc923147a9e3525$var$Reader.create = $1bc923147a9e3525$var$create();
$1bc923147a9e3525$var$Reader.prototype._slice = $de64B.Array.prototype.subarray || /* istanbul ignore next */ $de64B.Array.prototype.slice;
/**
 * Reads a varint as an unsigned 32 bit value.
 * @function
 * @returns {number} Value read
 */ $1bc923147a9e3525$var$Reader.prototype.uint32 = function read_uint32_setup() {
    var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
    return function read_uint32() {
        value = (this.buf[this.pos] & 127) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 7) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 15) << 28) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        /* istanbul ignore if */ if ((this.pos += 5) > this.len) {
            this.pos = this.len;
            throw $1bc923147a9e3525$var$indexOutOfRange(this, 10);
        }
        return value;
    };
}();
/**
 * Reads a varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $1bc923147a9e3525$var$Reader.prototype.int32 = function read_int32() {
    return this.uint32() | 0;
};
/**
 * Reads a zig-zag encoded varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $1bc923147a9e3525$var$Reader.prototype.sint32 = function read_sint32() {
    var value = this.uint32();
    return value >>> 1 ^ -(value & 1) | 0;
};
/* eslint-disable no-invalid-this */ function $1bc923147a9e3525$var$readLongVarint() {
    // tends to deopt with local vars for octet etc.
    var bits = new $1bc923147a9e3525$var$LongBits(0, 0);
    var i = 0;
    if (this.len - this.pos > 4) {
        for(; i < 4; ++i){
            // 1st..4th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 5th
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >> 4) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
        i = 0;
    } else {
        for(; i < 3; ++i){
            /* istanbul ignore if */ if (this.pos >= this.len) throw $1bc923147a9e3525$var$indexOutOfRange(this);
            // 1st..3th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 4th
        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
        return bits;
    }
    if (this.len - this.pos > 4) for(; i < 5; ++i){
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    else for(; i < 5; ++i){
        /* istanbul ignore if */ if (this.pos >= this.len) throw $1bc923147a9e3525$var$indexOutOfRange(this);
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    /* istanbul ignore next */ throw Error("invalid varint encoding");
}
/* eslint-enable no-invalid-this */ /**
 * Reads a varint as a signed 64 bit value.
 * @name Reader#int64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as an unsigned 64 bit value.
 * @name Reader#uint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a zig-zag encoded varint as a signed 64 bit value.
 * @name Reader#sint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as a boolean.
 * @returns {boolean} Value read
 */ $1bc923147a9e3525$var$Reader.prototype.bool = function read_bool() {
    return this.uint32() !== 0;
};
function $1bc923147a9e3525$var$readFixed32_end(buf, end) {
    return (buf[end - 4] | buf[end - 3] << 8 | buf[end - 2] << 16 | buf[end - 1] << 24) >>> 0;
}
/**
 * Reads fixed 32 bits as an unsigned 32 bit integer.
 * @returns {number} Value read
 */ $1bc923147a9e3525$var$Reader.prototype.fixed32 = function read_fixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $1bc923147a9e3525$var$indexOutOfRange(this, 4);
    return $1bc923147a9e3525$var$readFixed32_end(this.buf, this.pos += 4);
};
/**
 * Reads fixed 32 bits as a signed 32 bit integer.
 * @returns {number} Value read
 */ $1bc923147a9e3525$var$Reader.prototype.sfixed32 = function read_sfixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $1bc923147a9e3525$var$indexOutOfRange(this, 4);
    return $1bc923147a9e3525$var$readFixed32_end(this.buf, this.pos += 4) | 0;
};
/* eslint-disable no-invalid-this */ function $1bc923147a9e3525$var$readFixed64() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $1bc923147a9e3525$var$indexOutOfRange(this, 8);
    return new $1bc923147a9e3525$var$LongBits($1bc923147a9e3525$var$readFixed32_end(this.buf, this.pos += 4), $1bc923147a9e3525$var$readFixed32_end(this.buf, this.pos += 4));
}
/* eslint-enable no-invalid-this */ /**
 * Reads fixed 64 bits.
 * @name Reader#fixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads zig-zag encoded fixed 64 bits.
 * @name Reader#sfixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a float (32 bit) as a number.
 * @function
 * @returns {number} Value read
 */ $1bc923147a9e3525$var$Reader.prototype.float = function read_float() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $1bc923147a9e3525$var$indexOutOfRange(this, 4);
    var value = $de64B.float.readFloatLE(this.buf, this.pos);
    this.pos += 4;
    return value;
};
/**
 * Reads a double (64 bit float) as a number.
 * @function
 * @returns {number} Value read
 */ $1bc923147a9e3525$var$Reader.prototype.double = function read_double() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $1bc923147a9e3525$var$indexOutOfRange(this, 4);
    var value = $de64B.float.readDoubleLE(this.buf, this.pos);
    this.pos += 8;
    return value;
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @returns {Uint8Array} Value read
 */ $1bc923147a9e3525$var$Reader.prototype.bytes = function read_bytes() {
    var length = this.uint32(), start = this.pos, end = this.pos + length;
    /* istanbul ignore if */ if (end > this.len) throw $1bc923147a9e3525$var$indexOutOfRange(this, length);
    this.pos += length;
    if (Array.isArray(this.buf)) return this.buf.slice(start, end);
    return start === end // fix for IE 10/Win8 and others' subarray returning array of size 1
     ? new this.buf.constructor(0) : this._slice.call(this.buf, start, end);
};
/**
 * Reads a string preceeded by its byte length as a varint.
 * @returns {string} Value read
 */ $1bc923147a9e3525$var$Reader.prototype.string = function read_string() {
    var bytes = this.bytes();
    return $1bc923147a9e3525$var$utf8.read(bytes, 0, bytes.length);
};
/**
 * Skips the specified number of bytes if specified, otherwise skips a varint.
 * @param {number} [length] Length if known, otherwise a varint is assumed
 * @returns {Reader} `this`
 */ $1bc923147a9e3525$var$Reader.prototype.skip = function skip(length) {
    if (typeof length === "number") {
        /* istanbul ignore if */ if (this.pos + length > this.len) throw $1bc923147a9e3525$var$indexOutOfRange(this, length);
        this.pos += length;
    } else do {
        /* istanbul ignore if */ if (this.pos >= this.len) throw $1bc923147a9e3525$var$indexOutOfRange(this);
    }while (this.buf[this.pos++] & 128);
    return this;
};
/**
 * Skips the next element of the specified wire type.
 * @param {number} wireType Wire type received
 * @returns {Reader} `this`
 */ $1bc923147a9e3525$var$Reader.prototype.skipType = function(wireType) {
    switch(wireType){
        case 0:
            this.skip();
            break;
        case 1:
            this.skip(8);
            break;
        case 2:
            this.skip(this.uint32());
            break;
        case 3:
            while((wireType = this.uint32() & 7) !== 4)this.skipType(wireType);
            break;
        case 5:
            this.skip(4);
            break;
        /* istanbul ignore next */ default:
            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
    }
    return this;
};
$1bc923147a9e3525$var$Reader._configure = function(BufferReader_) {
    $1bc923147a9e3525$var$BufferReader = BufferReader_;
    $1bc923147a9e3525$var$Reader.create = $1bc923147a9e3525$var$create();
    $1bc923147a9e3525$var$BufferReader._configure();
    var fn = $de64B.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
    $de64B.merge($1bc923147a9e3525$var$Reader.prototype, {
        int64: function read_int64() {
            return $1bc923147a9e3525$var$readLongVarint.call(this)[fn](false);
        },
        uint64: function read_uint64() {
            return $1bc923147a9e3525$var$readLongVarint.call(this)[fn](true);
        },
        sint64: function read_sint64() {
            return $1bc923147a9e3525$var$readLongVarint.call(this).zzDecode()[fn](false);
        },
        fixed64: function read_fixed64() {
            return $1bc923147a9e3525$var$readFixed64.call(this)[fn](true);
        },
        sfixed64: function read_sfixed64() {
            return $1bc923147a9e3525$var$readFixed64.call(this)[fn](false);
        }
    });
};

});

parcelRequire.register("7BzCD", function(module, exports) {
"use strict";
module.exports = $58979eedd05c48da$var$BufferReader;

var $2nTXx = parcelRequire("2nTXx");
($58979eedd05c48da$var$BufferReader.prototype = Object.create($2nTXx.prototype)).constructor = $58979eedd05c48da$var$BufferReader;

var $de64B = parcelRequire("de64B");
/**
 * Constructs a new buffer reader instance.
 * @classdesc Wire format reader using node buffers.
 * @extends Reader
 * @constructor
 * @param {Buffer} buffer Buffer to read from
 */ function $58979eedd05c48da$var$BufferReader(buffer) {
    $2nTXx.call(this, buffer);
/**
     * Read buffer.
     * @name BufferReader#buf
     * @type {Buffer}
     */ }
$58979eedd05c48da$var$BufferReader._configure = function() {
    /* istanbul ignore else */ if ($de64B.Buffer) $58979eedd05c48da$var$BufferReader.prototype._slice = $de64B.Buffer.prototype.slice;
};
/**
 * @override
 */ $58979eedd05c48da$var$BufferReader.prototype.string = function read_string_buffer() {
    var len = this.uint32(); // modifies pos
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @name BufferReader#bytes
 * @function
 * @returns {Buffer} Value read
 */ $58979eedd05c48da$var$BufferReader._configure();

});

parcelRequire.register("kprOF", function(module, exports) {
"use strict";
/**
 * Streaming RPC helpers.
 * @namespace
 */ var $edbbb8258cce12f0$var$rpc = module.exports;

/**
 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
 * @typedef RPCImpl
 * @type {function}
 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
 * @param {Uint8Array} requestData Request data
 * @param {RPCImplCallback} callback Callback function
 * @returns {undefined}
 * @example
 * function rpcImpl(method, requestData, callback) {
 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
 *         throw Error("no such method");
 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
 *         callback(err, responseData);
 *     });
 * }
 */ /**
 * Node-style callback as used by {@link RPCImpl}.
 * @typedef RPCImplCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
 * @returns {undefined}
 */ $edbbb8258cce12f0$var$rpc.Service = (parcelRequire("kHQnk"));

});
parcelRequire.register("kHQnk", function(module, exports) {
"use strict";
module.exports = $f130736baba108ab$var$Service;

var $de64B = parcelRequire("de64B");
// Extends EventEmitter
($f130736baba108ab$var$Service.prototype = Object.create($de64B.EventEmitter.prototype)).constructor = $f130736baba108ab$var$Service;
/**
 * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
 *
 * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
 * @typedef rpc.ServiceMethodCallback
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {TRes} [response] Response message
 * @returns {undefined}
 */ /**
 * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
 * @typedef rpc.ServiceMethod
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
 * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
 */ /**
 * Constructs a new RPC service instance.
 * @classdesc An RPC service as returned by {@link Service#create}.
 * @exports rpc.Service
 * @extends util.EventEmitter
 * @constructor
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 */ function $f130736baba108ab$var$Service(rpcImpl, requestDelimited, responseDelimited) {
    if (typeof rpcImpl !== "function") throw TypeError("rpcImpl must be a function");
    $de64B.EventEmitter.call(this);
    /**
     * RPC implementation. Becomes `null` once the service is ended.
     * @type {RPCImpl|null}
     */ this.rpcImpl = rpcImpl;
    /**
     * Whether requests are length-delimited.
     * @type {boolean}
     */ this.requestDelimited = Boolean(requestDelimited);
    /**
     * Whether responses are length-delimited.
     * @type {boolean}
     */ this.responseDelimited = Boolean(responseDelimited);
}
/**
 * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
 * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
 * @param {Constructor<TReq>} requestCtor Request constructor
 * @param {Constructor<TRes>} responseCtor Response constructor
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
 * @returns {undefined}
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 */ $f130736baba108ab$var$Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
    if (!request) throw TypeError("request must be specified");
    var self = this;
    if (!callback) return $de64B.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);
    if (!self.rpcImpl) {
        setTimeout(function() {
            callback(Error("already ended"));
        }, 0);
        return undefined;
    }
    try {
        return self.rpcImpl(method, requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(), function rpcCallback(err, response) {
            if (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            if (response === null) {
                self.end(/* endedByRPC */ true);
                return undefined;
            }
            if (!(response instanceof responseCtor)) try {
                response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
            } catch (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            self.emit("data", response, method);
            return callback(null, response);
        });
    } catch (err) {
        self.emit("error", err, method);
        setTimeout(function() {
            callback(err);
        }, 0);
        return undefined;
    }
};
/**
 * Ends this service and emits the `end` event.
 * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
 * @returns {rpc.Service} `this`
 */ $f130736baba108ab$var$Service.prototype.end = function end(endedByRPC) {
    if (this.rpcImpl) {
        if (!endedByRPC) this.rpcImpl(null, null, null);
        this.rpcImpl = null;
        this.emit("end").off();
    }
    return this;
};

});


parcelRequire.register("8fPpg", function(module, exports) {
"use strict";
module.exports = {}; /**
 * Named roots.
 * This is where pbjs stores generated structures (the option `-r, --root` specifies a name).
 * Can also be used manually to make roots available accross modules.
 * @name roots
 * @type {Object.<string,Root>}
 * @example
 * // pbjs -r myroot -o compiled.js ...
 *
 * // in another module:
 * require("./compiled.js");
 *
 * // in any subsequent module:
 * var root = protobuf.roots["myroot"];
 */ 

});




parcelRequire.register("ehQqu", function(module, exports) {
/**
 * Javascript implementation of Abstract Syntax Notation Number One.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2015 Digital Bazaar, Inc.
 *
 * An API for storing data using the Abstract Syntax Notation Number One
 * format using DER (Distinguished Encoding Rules) encoding. This encoding is
 * commonly used to store data for PKI, i.e. X.509 Certificates, and this
 * implementation exists for that purpose.
 *
 * Abstract Syntax Notation Number One (ASN.1) is used to define the abstract
 * syntax of information without restricting the way the information is encoded
 * for transmission. It provides a standard that allows for open systems
 * communication. ASN.1 defines the syntax of information data and a number of
 * simple data types as well as a notation for describing them and specifying
 * values for them.
 *
 * The RSA algorithm creates public and private keys that are often stored in
 * X.509 or PKCS#X formats -- which use ASN.1 (encoded in DER format). This
 * class provides the most basic functionality required to store and load DSA
 * keys that are encoded according to ASN.1.
 *
 * The most common binary encodings for ASN.1 are BER (Basic Encoding Rules)
 * and DER (Distinguished Encoding Rules). DER is just a subset of BER that
 * has stricter requirements for how data must be encoded.
 *
 * Each ASN.1 structure has a tag (a byte identifying the ASN.1 structure type)
 * and a byte array for the value of this ASN1 structure which may be data or a
 * list of ASN.1 structures.
 *
 * Each ASN.1 structure using BER is (Tag-Length-Value):
 *
 * | byte 0 | bytes X | bytes Y |
 * |--------|---------|----------
 * |  tag   | length  |  value  |
 *
 * ASN.1 allows for tags to be of "High-tag-number form" which allows a tag to
 * be two or more octets, but that is not supported by this class. A tag is
 * only 1 byte. Bits 1-5 give the tag number (ie the data type within a
 * particular 'class'), 6 indicates whether or not the ASN.1 value is
 * constructed from other ASN.1 values, and bits 7 and 8 give the 'class'. If
 * bits 7 and 8 are both zero, the class is UNIVERSAL. If only bit 7 is set,
 * then the class is APPLICATION. If only bit 8 is set, then the class is
 * CONTEXT_SPECIFIC. If both bits 7 and 8 are set, then the class is PRIVATE.
 * The tag numbers for the data types for the class UNIVERSAL are listed below:
 *
 * UNIVERSAL 0 Reserved for use by the encoding rules
 * UNIVERSAL 1 Boolean type
 * UNIVERSAL 2 Integer type
 * UNIVERSAL 3 Bitstring type
 * UNIVERSAL 4 Octetstring type
 * UNIVERSAL 5 Null type
 * UNIVERSAL 6 Object identifier type
 * UNIVERSAL 7 Object descriptor type
 * UNIVERSAL 8 External type and Instance-of type
 * UNIVERSAL 9 Real type
 * UNIVERSAL 10 Enumerated type
 * UNIVERSAL 11 Embedded-pdv type
 * UNIVERSAL 12 UTF8String type
 * UNIVERSAL 13 Relative object identifier type
 * UNIVERSAL 14-15 Reserved for future editions
 * UNIVERSAL 16 Sequence and Sequence-of types
 * UNIVERSAL 17 Set and Set-of types
 * UNIVERSAL 18-22, 25-30 Character string types
 * UNIVERSAL 23-24 Time types
 *
 * The length of an ASN.1 structure is specified after the tag identifier.
 * There is a definite form and an indefinite form. The indefinite form may
 * be used if the encoding is constructed and not all immediately available.
 * The indefinite form is encoded using a length byte with only the 8th bit
 * set. The end of the constructed object is marked using end-of-contents
 * octets (two zero bytes).
 *
 * The definite form looks like this:
 *
 * The length may take up 1 or more bytes, it depends on the length of the
 * value of the ASN.1 structure. DER encoding requires that if the ASN.1
 * structure has a value that has a length greater than 127, more than 1 byte
 * will be used to store its length, otherwise just one byte will be used.
 * This is strict.
 *
 * In the case that the length of the ASN.1 value is less than 127, 1 octet
 * (byte) is used to store the "short form" length. The 8th bit has a value of
 * 0 indicating the length is "short form" and not "long form" and bits 7-1
 * give the length of the data. (The 8th bit is the left-most, most significant
 * bit: also known as big endian or network format).
 *
 * In the case that the length of the ASN.1 value is greater than 127, 2 to
 * 127 octets (bytes) are used to store the "long form" length. The first
 * byte's 8th bit is set to 1 to indicate the length is "long form." Bits 7-1
 * give the number of additional octets. All following octets are in base 256
 * with the most significant digit first (typical big-endian binary unsigned
 * integer storage). So, for instance, if the length of a value was 257, the
 * first byte would be set to:
 *
 * 10000010 = 130 = 0x82.
 *
 * This indicates there are 2 octets (base 256) for the length. The second and
 * third bytes (the octets just mentioned) would store the length in base 256:
 *
 * octet 2: 00000001 = 1 * 256^1 = 256
 * octet 3: 00000001 = 1 * 256^0 = 1
 * total = 257
 *
 * The algorithm for converting a js integer value of 257 to base-256 is:
 *
 * var value = 257;
 * var bytes = [];
 * bytes[0] = (value >>> 8) & 0xFF; // most significant byte first
 * bytes[1] = value & 0xFF;        // least significant byte last
 *
 * On the ASN.1 UNIVERSAL Object Identifier (OID) type:
 *
 * An OID can be written like: "value1.value2.value3...valueN"
 *
 * The DER encoding rules:
 *
 * The first byte has the value 40 * value1 + value2.
 * The following bytes, if any, encode the remaining values. Each value is
 * encoded in base 128, most significant digit first (big endian), with as
 * few digits as possible, and the most significant bit of each byte set
 * to 1 except the last in each value's encoding. For example: Given the
 * OID "1.2.840.113549", its DER encoding is (remember each byte except the
 * last one in each encoding is OR'd with 0x80):
 *
 * byte 1: 40 * 1 + 2 = 42 = 0x2A.
 * bytes 2-3: 128 * 6 + 72 = 840 = 6 72 = 6 72 = 0x0648 = 0x8648
 * bytes 4-6: 16384 * 6 + 128 * 119 + 13 = 6 119 13 = 0x06770D = 0x86F70D
 *
 * The final value is: 0x2A864886F70D.
 * The full OID (including ASN.1 tag and length of 6 bytes) is:
 * 0x06062A864886F70D
 */ 
var $hSPkV = parcelRequire("hSPkV");
parcelRequire("3lPw4");
parcelRequire("inNg9");
/* ASN.1 API */ var $a66b51f6d40f99a9$var$asn1 = module.exports = $hSPkV.asn1 = $hSPkV.asn1 || {};
/**
 * ASN.1 classes.
 */ $a66b51f6d40f99a9$var$asn1.Class = {
    UNIVERSAL: 0x00,
    APPLICATION: 0x40,
    CONTEXT_SPECIFIC: 0x80,
    PRIVATE: 0xC0
};
/**
 * ASN.1 types. Not all types are supported by this implementation, only
 * those necessary to implement a simple PKI are implemented.
 */ $a66b51f6d40f99a9$var$asn1.Type = {
    NONE: 0,
    BOOLEAN: 1,
    INTEGER: 2,
    BITSTRING: 3,
    OCTETSTRING: 4,
    NULL: 5,
    OID: 6,
    ODESC: 7,
    EXTERNAL: 8,
    REAL: 9,
    ENUMERATED: 10,
    EMBEDDED: 11,
    UTF8: 12,
    ROID: 13,
    SEQUENCE: 16,
    SET: 17,
    PRINTABLESTRING: 19,
    IA5STRING: 22,
    UTCTIME: 23,
    GENERALIZEDTIME: 24,
    BMPSTRING: 30
};
/**
 * Sets the default maximum recursion depth when parsing ASN.1 structures.
 */ $a66b51f6d40f99a9$var$asn1.maxDepth = 256;
/**
 * Creates a new asn1 object.
 *
 * @param tagClass the tag class for the object.
 * @param type the data type (tag number) for the object.
 * @param constructed true if the asn1 object is in constructed form.
 * @param value the value for the object, if it is not constructed.
 * @param [options] the options to use:
 *          [bitStringContents] the plain BIT STRING content including padding
 *            byte.
 *
 * @return the asn1 object.
 */ $a66b51f6d40f99a9$var$asn1.create = function(tagClass, type, constructed, value, options) {
    /* An asn1 object has a tagClass, a type, a constructed flag, and a
    value. The value's type depends on the constructed flag. If
    constructed, it will contain a list of other asn1 objects. If not,
    it will contain the ASN.1 value as an array of bytes formatted
    according to the ASN.1 data type. */ // remove undefined values
    if ($hSPkV.util.isArray(value)) {
        var tmp = [];
        for(var i = 0; i < value.length; ++i)if (value[i] !== undefined) tmp.push(value[i]);
        value = tmp;
    }
    var obj = {
        tagClass: tagClass,
        type: type,
        constructed: constructed,
        composed: constructed || $hSPkV.util.isArray(value),
        value: value
    };
    if (options && "bitStringContents" in options) {
        // TODO: copy byte buffer if it's a buffer not a string
        obj.bitStringContents = options.bitStringContents;
        // TODO: add readonly flag to avoid this overhead
        // save copy to detect changes
        obj.original = $a66b51f6d40f99a9$var$asn1.copy(obj);
    }
    return obj;
};
/**
 * Copies an asn1 object.
 *
 * @param obj the asn1 object.
 * @param [options] copy options:
 *          [excludeBitStringContents] true to not copy bitStringContents
 *
 * @return the a copy of the asn1 object.
 */ $a66b51f6d40f99a9$var$asn1.copy = function(obj, options) {
    var copy;
    if ($hSPkV.util.isArray(obj)) {
        copy = [];
        for(var i = 0; i < obj.length; ++i)copy.push($a66b51f6d40f99a9$var$asn1.copy(obj[i], options));
        return copy;
    }
    if (typeof obj === "string") // TODO: copy byte buffer if it's a buffer not a string
    return obj;
    copy = {
        tagClass: obj.tagClass,
        type: obj.type,
        constructed: obj.constructed,
        composed: obj.composed,
        value: $a66b51f6d40f99a9$var$asn1.copy(obj.value, options)
    };
    if (options && !options.excludeBitStringContents) // TODO: copy byte buffer if it's a buffer not a string
    copy.bitStringContents = obj.bitStringContents;
    return copy;
};
/**
 * Compares asn1 objects for equality.
 *
 * Note this function does not run in constant time.
 *
 * @param obj1 the first asn1 object.
 * @param obj2 the second asn1 object.
 * @param [options] compare options:
 *          [includeBitStringContents] true to compare bitStringContents
 *
 * @return true if the asn1 objects are equal.
 */ $a66b51f6d40f99a9$var$asn1.equals = function(obj1, obj2, options) {
    if ($hSPkV.util.isArray(obj1)) {
        if (!$hSPkV.util.isArray(obj2)) return false;
        if (obj1.length !== obj2.length) return false;
        for(var i = 0; i < obj1.length; ++i){
            if (!$a66b51f6d40f99a9$var$asn1.equals(obj1[i], obj2[i])) return false;
        }
        return true;
    }
    if (typeof obj1 !== typeof obj2) return false;
    if (typeof obj1 === "string") return obj1 === obj2;
    var equal = obj1.tagClass === obj2.tagClass && obj1.type === obj2.type && obj1.constructed === obj2.constructed && obj1.composed === obj2.composed && $a66b51f6d40f99a9$var$asn1.equals(obj1.value, obj2.value);
    if (options && options.includeBitStringContents) equal = equal && obj1.bitStringContents === obj2.bitStringContents;
    return equal;
};
/**
 * Gets the length of a BER-encoded ASN.1 value.
 *
 * In case the length is not specified, undefined is returned.
 *
 * @param b the BER-encoded ASN.1 byte buffer, starting with the first
 *          length byte.
 *
 * @return the length of the BER-encoded ASN.1 value or undefined.
 */ $a66b51f6d40f99a9$var$asn1.getBerValueLength = function(b) {
    // TODO: move this function and related DER/BER functions to a der.js
    // file; better abstract ASN.1 away from der/ber.
    var b2 = b.getByte();
    if (b2 === 0x80) return undefined;
    // see if the length is "short form" or "long form" (bit 8 set)
    var length;
    var longForm = b2 & 0x80;
    if (!longForm) // length is just the first byte
    length = b2;
    else // the number of bytes the length is specified in bits 7 through 1
    // and each length byte is in big-endian base-256
    length = b.getInt((b2 & 0x7F) << 3);
    return length;
};
/**
 * Check if the byte buffer has enough bytes. Throws an Error if not.
 *
 * @param bytes the byte buffer to parse from.
 * @param remaining the bytes remaining in the current parsing state.
 * @param n the number of bytes the buffer must have.
 */ function $a66b51f6d40f99a9$var$_checkBufferLength(bytes, remaining, n) {
    if (n > remaining) {
        var error = new Error("Too few bytes to parse DER.");
        error.available = bytes.length();
        error.remaining = remaining;
        error.requested = n;
        throw error;
    }
}
/**
 * Gets the length of a BER-encoded ASN.1 value.
 *
 * In case the length is not specified, undefined is returned.
 *
 * @param bytes the byte buffer to parse from.
 * @param remaining the bytes remaining in the current parsing state.
 *
 * @return the length of the BER-encoded ASN.1 value or undefined.
 */ var $a66b51f6d40f99a9$var$_getValueLength = function(bytes, remaining) {
    // TODO: move this function and related DER/BER functions to a der.js
    // file; better abstract ASN.1 away from der/ber.
    // fromDer already checked that this byte exists
    var b2 = bytes.getByte();
    remaining--;
    if (b2 === 0x80) return undefined;
    // see if the length is "short form" or "long form" (bit 8 set)
    var length;
    var longForm = b2 & 0x80;
    if (!longForm) // length is just the first byte
    length = b2;
    else {
        // the number of bytes the length is specified in bits 7 through 1
        // and each length byte is in big-endian base-256
        var longFormBytes = b2 & 0x7F;
        $a66b51f6d40f99a9$var$_checkBufferLength(bytes, remaining, longFormBytes);
        length = bytes.getInt(longFormBytes << 3);
    }
    // FIXME: this will only happen for 32 bit getInt with high bit set
    if (length < 0) throw new Error("Negative length: " + length);
    return length;
};
/**
 * Parses an asn1 object from a byte buffer in DER format.
 *
 * @param bytes the byte buffer to parse from.
 * @param [strict] true to be strict when checking value lengths, false to
 *          allow truncated values (default: true).
 * @param [options] object with options or boolean strict flag
 *          [strict] true to be strict when checking value lengths, false to
 *            allow truncated values (default: true).
 *          [parseAllBytes] true to ensure all bytes are parsed
 *            (default: true)
 *          [decodeBitStrings] true to attempt to decode the content of
 *            BIT STRINGs (not OCTET STRINGs) using strict mode. Note that
 *            without schema support to understand the data context this can
 *            erroneously decode values that happen to be valid ASN.1. This
 *            flag will be deprecated or removed as soon as schema support is
 *            available. (default: true)
 *          [maxDepth] override asn1.maxDepth recursion limit
 *            (default: asn1.maxDepth)
 *
 * @throws Will throw an error for various malformed input conditions.
 *
 * @return the parsed asn1 object.
 */ $a66b51f6d40f99a9$var$asn1.fromDer = function(bytes, options) {
    if (options === undefined) options = {
        strict: true,
        parseAllBytes: true,
        decodeBitStrings: true
    };
    if (typeof options === "boolean") options = {
        strict: options,
        parseAllBytes: true,
        decodeBitStrings: true
    };
    if (!("strict" in options)) options.strict = true;
    if (!("parseAllBytes" in options)) options.parseAllBytes = true;
    if (!("decodeBitStrings" in options)) options.decodeBitStrings = true;
    if (!("maxDepth" in options)) options.maxDepth = $a66b51f6d40f99a9$var$asn1.maxDepth;
    // wrap in buffer if needed
    if (typeof bytes === "string") bytes = $hSPkV.util.createBuffer(bytes);
    var byteCount = bytes.length();
    var value = $a66b51f6d40f99a9$var$_fromDer(bytes, bytes.length(), 0, options);
    if (options.parseAllBytes && bytes.length() !== 0) {
        var error = new Error("Unparsed DER bytes remain after ASN.1 parsing.");
        error.byteCount = byteCount;
        error.remaining = bytes.length();
        throw error;
    }
    return value;
};
/**
 * Internal function to parse an asn1 object from a byte buffer in DER format.
 *
 * @param bytes the byte buffer to parse from.
 * @param remaining the number of bytes remaining for this chunk.
 * @param depth the current parsing depth.
 * @param options object with same options as fromDer().
 *
 * @return the parsed asn1 object.
 */ function $a66b51f6d40f99a9$var$_fromDer(bytes, remaining, depth, options) {
    // check depth limit
    if (depth >= options.maxDepth) throw new Error("ASN.1 parsing error: Max depth exceeded.");
    // temporary storage for consumption calculations
    var start;
    // minimum length for ASN.1 DER structure is 2
    $a66b51f6d40f99a9$var$_checkBufferLength(bytes, remaining, 2);
    // get the first byte
    var b1 = bytes.getByte();
    // consumed one byte
    remaining--;
    // get the tag class
    var tagClass = b1 & 0xC0;
    // get the type (bits 1-5)
    var type = b1 & 0x1F;
    // get the variable value length and adjust remaining bytes
    start = bytes.length();
    var length = $a66b51f6d40f99a9$var$_getValueLength(bytes, remaining);
    remaining -= start - bytes.length();
    // ensure there are enough bytes to get the value
    if (length !== undefined && length > remaining) {
        if (options.strict) {
            var error = new Error("Too few bytes to read ASN.1 value.");
            error.available = bytes.length();
            error.remaining = remaining;
            error.requested = length;
            throw error;
        }
        // Note: be lenient with truncated values and use remaining state bytes
        length = remaining;
    }
    // value storage
    var value;
    // possible BIT STRING contents storage
    var bitStringContents;
    // constructed flag is bit 6 (32 = 0x20) of the first byte
    var constructed = (b1 & 0x20) === 0x20;
    if (constructed) {
        // parse child asn1 objects from the value
        value = [];
        if (length === undefined) // asn1 object of indefinite length, read until end tag
        for(;;){
            $a66b51f6d40f99a9$var$_checkBufferLength(bytes, remaining, 2);
            if (bytes.bytes(2) === String.fromCharCode(0, 0)) {
                bytes.getBytes(2);
                remaining -= 2;
                break;
            }
            start = bytes.length();
            value.push($a66b51f6d40f99a9$var$_fromDer(bytes, remaining, depth + 1, options));
            remaining -= start - bytes.length();
        }
        else // parsing asn1 object of definite length
        while(length > 0){
            start = bytes.length();
            value.push($a66b51f6d40f99a9$var$_fromDer(bytes, length, depth + 1, options));
            remaining -= start - bytes.length();
            length -= start - bytes.length();
        }
    }
    // if a BIT STRING, save the contents including padding
    if (value === undefined && tagClass === $a66b51f6d40f99a9$var$asn1.Class.UNIVERSAL && type === $a66b51f6d40f99a9$var$asn1.Type.BITSTRING) bitStringContents = bytes.bytes(length);
    // determine if a non-constructed value should be decoded as a composed
    // value that contains other ASN.1 objects. BIT STRINGs (and OCTET STRINGs)
    // can be used this way.
    if (value === undefined && options.decodeBitStrings && tagClass === $a66b51f6d40f99a9$var$asn1.Class.UNIVERSAL && // FIXME: OCTET STRINGs not yet supported here
    // .. other parts of forge expect to decode OCTET STRINGs manually
    type === $a66b51f6d40f99a9$var$asn1.Type.BITSTRING /*|| type === asn1.Type.OCTETSTRING*/  && length > 1) {
        // save read position
        var savedRead = bytes.read;
        var savedRemaining = remaining;
        var unused = 0;
        if (type === $a66b51f6d40f99a9$var$asn1.Type.BITSTRING) {
            /* The first octet gives the number of bits by which the length of the
        bit string is less than the next multiple of eight (this is called
        the "number of unused bits").

        The second and following octets give the value of the bit string
        converted to an octet string. */ $a66b51f6d40f99a9$var$_checkBufferLength(bytes, remaining, 1);
            unused = bytes.getByte();
            remaining--;
        }
        // if all bits are used, maybe the BIT/OCTET STRING holds ASN.1 objs
        if (unused === 0) try {
            // attempt to parse child asn1 object from the value
            // (stored in array to signal composed value)
            start = bytes.length();
            var subOptions = {
                // enforce strict mode to avoid parsing ASN.1 from plain data
                strict: true,
                decodeBitStrings: true
            };
            var composed = $a66b51f6d40f99a9$var$_fromDer(bytes, remaining, depth + 1, subOptions);
            var used = start - bytes.length();
            remaining -= used;
            if (type == $a66b51f6d40f99a9$var$asn1.Type.BITSTRING) used++;
            // if the data all decoded and the class indicates UNIVERSAL or
            // CONTEXT_SPECIFIC then assume we've got an encapsulated ASN.1 object
            var tc = composed.tagClass;
            if (used === length && (tc === $a66b51f6d40f99a9$var$asn1.Class.UNIVERSAL || tc === $a66b51f6d40f99a9$var$asn1.Class.CONTEXT_SPECIFIC)) value = [
                composed
            ];
        } catch (ex) {}
        if (value === undefined) {
            // restore read position
            bytes.read = savedRead;
            remaining = savedRemaining;
        }
    }
    if (value === undefined) {
        // asn1 not constructed or composed, get raw value
        // TODO: do DER to OID conversion and vice-versa in .toDer?
        if (length === undefined) {
            if (options.strict) throw new Error("Non-constructed ASN.1 object of indefinite length.");
            // be lenient and use remaining state bytes
            length = remaining;
        }
        if (type === $a66b51f6d40f99a9$var$asn1.Type.BMPSTRING) {
            value = "";
            for(; length > 0; length -= 2){
                $a66b51f6d40f99a9$var$_checkBufferLength(bytes, remaining, 2);
                value += String.fromCharCode(bytes.getInt16());
                remaining -= 2;
            }
        } else {
            value = bytes.getBytes(length);
            remaining -= length;
        }
    }
    // add BIT STRING contents if available
    var asn1Options = bitStringContents === undefined ? null : {
        bitStringContents: bitStringContents
    };
    // create and return asn1 object
    return $a66b51f6d40f99a9$var$asn1.create(tagClass, type, constructed, value, asn1Options);
}
/**
 * Converts the given asn1 object to a buffer of bytes in DER format.
 *
 * @param asn1 the asn1 object to convert to bytes.
 *
 * @return the buffer of bytes.
 */ $a66b51f6d40f99a9$var$asn1.toDer = function(obj) {
    var bytes = $hSPkV.util.createBuffer();
    // build the first byte
    var b1 = obj.tagClass | obj.type;
    // for storing the ASN.1 value
    var value = $hSPkV.util.createBuffer();
    // use BIT STRING contents if available and data not changed
    var useBitStringContents = false;
    if ("bitStringContents" in obj) {
        useBitStringContents = true;
        if (obj.original) useBitStringContents = $a66b51f6d40f99a9$var$asn1.equals(obj, obj.original);
    }
    if (useBitStringContents) value.putBytes(obj.bitStringContents);
    else if (obj.composed) {
        // if composed, use each child asn1 object's DER bytes as value
        // turn on 6th bit (0x20 = 32) to indicate asn1 is constructed
        // from other asn1 objects
        if (obj.constructed) b1 |= 0x20;
        else // type is a bit string, add unused bits of 0x00
        value.putByte(0x00);
        // add all of the child DER bytes together
        for(var i = 0; i < obj.value.length; ++i)if (obj.value[i] !== undefined) value.putBuffer($a66b51f6d40f99a9$var$asn1.toDer(obj.value[i]));
    } else {
        // use asn1.value directly
        if (obj.type === $a66b51f6d40f99a9$var$asn1.Type.BMPSTRING) for(var i = 0; i < obj.value.length; ++i)value.putInt16(obj.value.charCodeAt(i));
        else // ensure integer is minimally-encoded
        // TODO: should all leading bytes be stripped vs just one?
        // .. ex '00 00 01' => '01'?
        if (obj.type === $a66b51f6d40f99a9$var$asn1.Type.INTEGER && obj.value.length > 1 && // leading 0x00 for positive integer
        (obj.value.charCodeAt(0) === 0 && (obj.value.charCodeAt(1) & 0x80) === 0 || // leading 0xFF for negative integer
        obj.value.charCodeAt(0) === 0xFF && (obj.value.charCodeAt(1) & 0x80) === 0x80)) value.putBytes(obj.value.substr(1));
        else value.putBytes(obj.value);
    }
    // add tag byte
    bytes.putByte(b1);
    // use "short form" encoding
    if (value.length() <= 127) // one byte describes the length
    // bit 8 = 0 and bits 7-1 = length
    bytes.putByte(value.length() & 0x7F);
    else {
        // use "long form" encoding
        // 2 to 127 bytes describe the length
        // first byte: bit 8 = 1 and bits 7-1 = # of additional bytes
        // other bytes: length in base 256, big-endian
        var len = value.length();
        var lenBytes = "";
        do {
            lenBytes += String.fromCharCode(len & 0xFF);
            len = len >>> 8;
        }while (len > 0);
        // set first byte to # bytes used to store the length and turn on
        // bit 8 to indicate long-form length is used
        bytes.putByte(lenBytes.length | 0x80);
        // concatenate length bytes in reverse since they were generated
        // little endian and we need big endian
        for(var i = lenBytes.length - 1; i >= 0; --i)bytes.putByte(lenBytes.charCodeAt(i));
    }
    // concatenate value bytes
    bytes.putBuffer(value);
    return bytes;
};
/**
 * Converts an OID dot-separated string to a byte buffer. The byte buffer
 * contains only the DER-encoded value, not any tag or length bytes.
 *
 * @param oid the OID dot-separated string.
 *
 * @return the byte buffer.
 */ $a66b51f6d40f99a9$var$asn1.oidToDer = function(oid) {
    // split OID into individual values
    var values = oid.split(".");
    var bytes = $hSPkV.util.createBuffer();
    // first byte is 40 * value1 + value2
    bytes.putByte(40 * parseInt(values[0], 10) + parseInt(values[1], 10));
    // other bytes are each value in base 128 with 8th bit set except for
    // the last byte for each value
    var last, valueBytes, value, b;
    for(var i = 2; i < values.length; ++i){
        // produce value bytes in reverse because we don't know how many
        // bytes it will take to store the value
        last = true;
        valueBytes = [];
        value = parseInt(values[i], 10);
        // TODO: Change bitwise logic to allow larger values.
        if (value > 0xffffffff) throw new Error("OID value too large; max is 32-bits.");
        do {
            b = value & 0x7F;
            value = value >>> 7;
            // if value is not last, then turn on 8th bit
            if (!last) b |= 0x80;
            valueBytes.push(b);
            last = false;
        }while (value > 0);
        // add value bytes in reverse (needs to be in big endian)
        for(var n = valueBytes.length - 1; n >= 0; --n)bytes.putByte(valueBytes[n]);
    }
    return bytes;
};
/**
 * Converts a DER-encoded byte buffer to an OID dot-separated string. The
 * byte buffer should contain only the DER-encoded value, not any tag or
 * length bytes.
 *
 * @param bytes the byte buffer.
 *
 * @return the OID dot-separated string.
 */ $a66b51f6d40f99a9$var$asn1.derToOid = function(bytes) {
    var oid;
    // wrap in buffer if needed
    if (typeof bytes === "string") bytes = $hSPkV.util.createBuffer(bytes);
    // first byte is 40 * value1 + value2
    var b = bytes.getByte();
    oid = Math.floor(b / 40) + "." + b % 40;
    // other bytes are each value in base 128 with 8th bit set except for
    // the last byte for each value
    var value = 0;
    while(bytes.length() > 0){
        // error if 7b shift would exceed Number.MAX_SAFE_INTEGER
        // (Number.MAX_SAFE_INTEGER / 128)
        if (value > 0x3fffffffffff) throw new Error("OID value too large; max is 53-bits.");
        b = bytes.getByte();
        value = value * 128;
        // not the last byte for the value
        if (b & 0x80) value += b & 0x7F;
        else {
            // last byte
            oid += "." + (value + b);
            value = 0;
        }
    }
    return oid;
};
/**
 * Converts a UTCTime value to a date.
 *
 * Note: GeneralizedTime has 4 digits for the year and is used for X.509
 * dates past 2049. Parsing that structure hasn't been implemented yet.
 *
 * @param utc the UTCTime value to convert.
 *
 * @return the date.
 */ $a66b51f6d40f99a9$var$asn1.utcTimeToDate = function(utc) {
    /* The following formats can be used:

    YYMMDDhhmmZ
    YYMMDDhhmm+hh'mm'
    YYMMDDhhmm-hh'mm'
    YYMMDDhhmmssZ
    YYMMDDhhmmss+hh'mm'
    YYMMDDhhmmss-hh'mm'

    Where:

    YY is the least significant two digits of the year
    MM is the month (01 to 12)
    DD is the day (01 to 31)
    hh is the hour (00 to 23)
    mm are the minutes (00 to 59)
    ss are the seconds (00 to 59)
    Z indicates that local time is GMT, + indicates that local time is
    later than GMT, and - indicates that local time is earlier than GMT
    hh' is the absolute value of the offset from GMT in hours
    mm' is the absolute value of the offset from GMT in minutes */ var date = new Date();
    // if YY >= 50 use 19xx, if YY < 50 use 20xx
    var year = parseInt(utc.substr(0, 2), 10);
    year = year >= 50 ? 1900 + year : 2000 + year;
    var MM = parseInt(utc.substr(2, 2), 10) - 1; // use 0-11 for month
    var DD = parseInt(utc.substr(4, 2), 10);
    var hh = parseInt(utc.substr(6, 2), 10);
    var mm = parseInt(utc.substr(8, 2), 10);
    var ss = 0;
    // not just YYMMDDhhmmZ
    if (utc.length > 11) {
        // get character after minutes
        var c = utc.charAt(10);
        var end = 10;
        // see if seconds are present
        if (c !== "+" && c !== "-") {
            // get seconds
            ss = parseInt(utc.substr(10, 2), 10);
            end += 2;
        }
    }
    // update date
    date.setUTCFullYear(year, MM, DD);
    date.setUTCHours(hh, mm, ss, 0);
    if (end) {
        // get +/- after end of time
        c = utc.charAt(end);
        if (c === "+" || c === "-") {
            // get hours+minutes offset
            var hhoffset = parseInt(utc.substr(end + 1, 2), 10);
            var mmoffset = parseInt(utc.substr(end + 4, 2), 10);
            // calculate offset in milliseconds
            var offset = hhoffset * 60 + mmoffset;
            offset *= 60000;
            // apply offset
            if (c === "+") date.setTime(+date - offset);
            else date.setTime(+date + offset);
        }
    }
    return date;
};
/**
 * Converts a GeneralizedTime value to a date.
 *
 * @param gentime the GeneralizedTime value to convert.
 *
 * @return the date.
 */ $a66b51f6d40f99a9$var$asn1.generalizedTimeToDate = function(gentime) {
    /* The following formats can be used:

    YYYYMMDDHHMMSS
    YYYYMMDDHHMMSS.fff
    YYYYMMDDHHMMSSZ
    YYYYMMDDHHMMSS.fffZ
    YYYYMMDDHHMMSS+hh'mm'
    YYYYMMDDHHMMSS.fff+hh'mm'
    YYYYMMDDHHMMSS-hh'mm'
    YYYYMMDDHHMMSS.fff-hh'mm'

    Where:

    YYYY is the year
    MM is the month (01 to 12)
    DD is the day (01 to 31)
    hh is the hour (00 to 23)
    mm are the minutes (00 to 59)
    ss are the seconds (00 to 59)
    .fff is the second fraction, accurate to three decimal places
    Z indicates that local time is GMT, + indicates that local time is
    later than GMT, and - indicates that local time is earlier than GMT
    hh' is the absolute value of the offset from GMT in hours
    mm' is the absolute value of the offset from GMT in minutes */ var date = new Date();
    var YYYY = parseInt(gentime.substr(0, 4), 10);
    var MM = parseInt(gentime.substr(4, 2), 10) - 1; // use 0-11 for month
    var DD = parseInt(gentime.substr(6, 2), 10);
    var hh = parseInt(gentime.substr(8, 2), 10);
    var mm = parseInt(gentime.substr(10, 2), 10);
    var ss = parseInt(gentime.substr(12, 2), 10);
    var fff = 0;
    var offset = 0;
    var isUTC = false;
    if (gentime.charAt(gentime.length - 1) === "Z") isUTC = true;
    var end = gentime.length - 5, c = gentime.charAt(end);
    if (c === "+" || c === "-") {
        // get hours+minutes offset
        var hhoffset = parseInt(gentime.substr(end + 1, 2), 10);
        var mmoffset = parseInt(gentime.substr(end + 4, 2), 10);
        // calculate offset in milliseconds
        offset = hhoffset * 60 + mmoffset;
        offset *= 60000;
        // apply offset
        if (c === "+") offset *= -1;
        isUTC = true;
    }
    // check for second fraction
    if (gentime.charAt(14) === ".") fff = parseFloat(gentime.substr(14), 10) * 1000;
    if (isUTC) {
        date.setUTCFullYear(YYYY, MM, DD);
        date.setUTCHours(hh, mm, ss, fff);
        // apply offset
        date.setTime(+date + offset);
    } else {
        date.setFullYear(YYYY, MM, DD);
        date.setHours(hh, mm, ss, fff);
    }
    return date;
};
/**
 * Converts a date to a UTCTime value.
 *
 * Note: GeneralizedTime has 4 digits for the year and is used for X.509
 * dates past 2049. Converting to a GeneralizedTime hasn't been
 * implemented yet.
 *
 * @param date the date to convert.
 *
 * @return the UTCTime value.
 */ $a66b51f6d40f99a9$var$asn1.dateToUtcTime = function(date) {
    // TODO: validate; currently assumes proper format
    if (typeof date === "string") return date;
    var rval = "";
    // create format YYMMDDhhmmssZ
    var format = [];
    format.push(("" + date.getUTCFullYear()).substr(2));
    format.push("" + (date.getUTCMonth() + 1));
    format.push("" + date.getUTCDate());
    format.push("" + date.getUTCHours());
    format.push("" + date.getUTCMinutes());
    format.push("" + date.getUTCSeconds());
    // ensure 2 digits are used for each format entry
    for(var i = 0; i < format.length; ++i){
        if (format[i].length < 2) rval += "0";
        rval += format[i];
    }
    rval += "Z";
    return rval;
};
/**
 * Converts a date to a GeneralizedTime value.
 *
 * @param date the date to convert.
 *
 * @return the GeneralizedTime value as a string.
 */ $a66b51f6d40f99a9$var$asn1.dateToGeneralizedTime = function(date) {
    // TODO: validate; currently assumes proper format
    if (typeof date === "string") return date;
    var rval = "";
    // create format YYYYMMDDHHMMSSZ
    var format = [];
    format.push("" + date.getUTCFullYear());
    format.push("" + (date.getUTCMonth() + 1));
    format.push("" + date.getUTCDate());
    format.push("" + date.getUTCHours());
    format.push("" + date.getUTCMinutes());
    format.push("" + date.getUTCSeconds());
    // ensure 2 digits are used for each format entry
    for(var i = 0; i < format.length; ++i){
        if (format[i].length < 2) rval += "0";
        rval += format[i];
    }
    rval += "Z";
    return rval;
};
/**
 * Converts a javascript integer to a DER-encoded byte buffer to be used
 * as the value for an INTEGER type.
 *
 * @param x the integer.
 *
 * @return the byte buffer.
 */ $a66b51f6d40f99a9$var$asn1.integerToDer = function(x) {
    var rval = $hSPkV.util.createBuffer();
    if (x >= -128 && x < 0x80) return rval.putSignedInt(x, 8);
    if (x >= -32768 && x < 0x8000) return rval.putSignedInt(x, 16);
    if (x >= -8388608 && x < 0x800000) return rval.putSignedInt(x, 24);
    if (x >= -2147483648 && x < 0x80000000) return rval.putSignedInt(x, 32);
    var error = new Error("Integer too large; max is 32-bits.");
    error.integer = x;
    throw error;
};
/**
 * Converts a DER-encoded byte buffer to a javascript integer. This is
 * typically used to decode the value of an INTEGER type.
 *
 * @param bytes the byte buffer.
 *
 * @return the integer.
 */ $a66b51f6d40f99a9$var$asn1.derToInteger = function(bytes) {
    // wrap in buffer if needed
    if (typeof bytes === "string") bytes = $hSPkV.util.createBuffer(bytes);
    var n = bytes.length() * 8;
    if (n > 32) throw new Error("Integer too large; max is 32-bits.");
    return bytes.getSignedInt(n);
};
/**
 * Validates that the given ASN.1 object is at least a super set of the
 * given ASN.1 structure. Only tag classes and types are checked. An
 * optional map may also be provided to capture ASN.1 values while the
 * structure is checked.
 *
 * To capture an ASN.1 value, set an object in the validator's 'capture'
 * parameter to the key to use in the capture map. To capture the full
 * ASN.1 object, specify 'captureAsn1'. To capture BIT STRING bytes, including
 * the leading unused bits counter byte, specify 'captureBitStringContents'.
 * To capture BIT STRING bytes, without the leading unused bits counter byte,
 * specify 'captureBitStringValue'.
 *
 * Objects in the validator may set a field 'optional' to true to indicate
 * that it isn't necessary to pass validation.
 *
 * @param obj the ASN.1 object to validate.
 * @param v the ASN.1 structure validator.
 * @param capture an optional map to capture values in.
 * @param errors an optional array for storing validation errors.
 *
 * @return true on success, false on failure.
 */ $a66b51f6d40f99a9$var$asn1.validate = function(obj, v, capture, errors) {
    var rval = false;
    // ensure tag class and type are the same if specified
    if ((obj.tagClass === v.tagClass || typeof v.tagClass === "undefined") && (obj.type === v.type || typeof v.type === "undefined")) {
        // ensure constructed flag is the same if specified
        if (obj.constructed === v.constructed || typeof v.constructed === "undefined") {
            rval = true;
            // handle sub values
            if (v.value && $hSPkV.util.isArray(v.value)) {
                var j = 0;
                for(var i = 0; rval && i < v.value.length; ++i){
                    var schemaItem = v.value[i];
                    rval = !!schemaItem.optional;
                    // current child in the object
                    var objChild = obj.value[j];
                    // if there is no child left to match
                    if (!objChild) {
                        // if optional, ok (rval already true), else fail below
                        if (!schemaItem.optional) {
                            rval = false;
                            if (errors) errors.push("[" + v.name + "] " + 'Missing required element. Expected tag class "' + schemaItem.tagClass + '", type "' + schemaItem.type + '"');
                        }
                        continue;
                    }
                    // If schema explicitly specifies tagClass/type, do a quick structural check
                    // to avoid unnecessary recursion/side-effects when tags clearly don't match.
                    var schemaHasTag = typeof schemaItem.tagClass !== "undefined" && typeof schemaItem.type !== "undefined";
                    if (schemaHasTag && (objChild.tagClass !== schemaItem.tagClass || objChild.type !== schemaItem.type)) {
                        // Tags do not match.
                        if (schemaItem.optional) {
                            // Skip this schema element (don't consume objChild; don't call recursive validate).
                            rval = true;
                            continue;
                        } else {
                            // Required schema item mismatched - fail.
                            rval = false;
                            if (errors) errors.push("[" + v.name + "] " + "Tag mismatch. Expected (" + schemaItem.tagClass + "," + schemaItem.type + "), got (" + objChild.tagClass + "," + objChild.type + ")");
                            break;
                        }
                    }
                    // Tags are compatible (or schema did not declare tags) - dive into recursive validate.
                    var childRval = $a66b51f6d40f99a9$var$asn1.validate(objChild, schemaItem, capture, errors);
                    if (childRval) {
                        // consume this child
                        ++j;
                        rval = true;
                    } else if (schemaItem.optional) // validation failed but element is optional => skip schema item (don't consume child)
                    rval = true;
                    else {
                        // required item failed
                        rval = false;
                        break;
                    }
                }
            }
            if (rval && capture) {
                if (v.capture) capture[v.capture] = obj.value;
                if (v.captureAsn1) capture[v.captureAsn1] = obj;
                if (v.captureBitStringContents && "bitStringContents" in obj) capture[v.captureBitStringContents] = obj.bitStringContents;
                if (v.captureBitStringValue && "bitStringContents" in obj) {
                    var value;
                    if (obj.bitStringContents.length < 2) capture[v.captureBitStringValue] = "";
                    else {
                        // FIXME: support unused bits with data shifting
                        var unused = obj.bitStringContents.charCodeAt(0);
                        if (unused !== 0) throw new Error("captureBitStringValue only supported for zero unused bits");
                        capture[v.captureBitStringValue] = obj.bitStringContents.slice(1);
                    }
                }
            }
        } else if (errors) errors.push("[" + v.name + "] " + 'Expected constructed "' + v.constructed + '", got "' + obj.constructed + '"');
    } else if (errors) {
        if (obj.tagClass !== v.tagClass) errors.push("[" + v.name + "] " + 'Expected tag class "' + v.tagClass + '", got "' + obj.tagClass + '"');
        if (obj.type !== v.type) errors.push("[" + v.name + "] " + 'Expected type "' + v.type + '", got "' + obj.type + '"');
    }
    return rval;
};
// regex for testing for non-latin characters
var $a66b51f6d40f99a9$var$_nonLatinRegex = /[^\\u0000-\\u00ff]/;
/**
 * Pretty prints an ASN.1 object to a string.
 *
 * @param obj the object to write out.
 * @param level the level in the tree.
 * @param indentation the indentation to use.
 *
 * @return the string.
 */ $a66b51f6d40f99a9$var$asn1.prettyPrint = function(obj, level, indentation) {
    var rval = "";
    // set default level and indentation
    level = level || 0;
    indentation = indentation || 2;
    // start new line for deep levels
    if (level > 0) rval += "\n";
    // create indent
    var indent = "";
    for(var i = 0; i < level * indentation; ++i)indent += " ";
    // print class:type
    rval += indent + "Tag: ";
    switch(obj.tagClass){
        case $a66b51f6d40f99a9$var$asn1.Class.UNIVERSAL:
            rval += "Universal:";
            break;
        case $a66b51f6d40f99a9$var$asn1.Class.APPLICATION:
            rval += "Application:";
            break;
        case $a66b51f6d40f99a9$var$asn1.Class.CONTEXT_SPECIFIC:
            rval += "Context-Specific:";
            break;
        case $a66b51f6d40f99a9$var$asn1.Class.PRIVATE:
            rval += "Private:";
            break;
    }
    if (obj.tagClass === $a66b51f6d40f99a9$var$asn1.Class.UNIVERSAL) {
        rval += obj.type;
        // known types
        switch(obj.type){
            case $a66b51f6d40f99a9$var$asn1.Type.NONE:
                rval += " (None)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.BOOLEAN:
                rval += " (Boolean)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.INTEGER:
                rval += " (Integer)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.BITSTRING:
                rval += " (Bit string)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.OCTETSTRING:
                rval += " (Octet string)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.NULL:
                rval += " (Null)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.OID:
                rval += " (Object Identifier)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.ODESC:
                rval += " (Object Descriptor)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.EXTERNAL:
                rval += " (External or Instance of)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.REAL:
                rval += " (Real)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.ENUMERATED:
                rval += " (Enumerated)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.EMBEDDED:
                rval += " (Embedded PDV)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.UTF8:
                rval += " (UTF8)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.ROID:
                rval += " (Relative Object Identifier)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.SEQUENCE:
                rval += " (Sequence)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.SET:
                rval += " (Set)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.PRINTABLESTRING:
                rval += " (Printable String)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.IA5String:
                rval += " (IA5String (ASCII))";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.UTCTIME:
                rval += " (UTC time)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.GENERALIZEDTIME:
                rval += " (Generalized time)";
                break;
            case $a66b51f6d40f99a9$var$asn1.Type.BMPSTRING:
                rval += " (BMP String)";
                break;
        }
    } else rval += obj.type;
    rval += "\n";
    rval += indent + "Constructed: " + obj.constructed + "\n";
    if (obj.composed) {
        var subvalues = 0;
        var sub = "";
        for(var i = 0; i < obj.value.length; ++i)if (obj.value[i] !== undefined) {
            subvalues += 1;
            sub += $a66b51f6d40f99a9$var$asn1.prettyPrint(obj.value[i], level + 1, indentation);
            if (i + 1 < obj.value.length) sub += ",";
        }
        rval += indent + "Sub values: " + subvalues + sub;
    } else {
        rval += indent + "Value: ";
        if (obj.type === $a66b51f6d40f99a9$var$asn1.Type.OID) {
            var oid = $a66b51f6d40f99a9$var$asn1.derToOid(obj.value);
            rval += oid;
            if ($hSPkV.pki && $hSPkV.pki.oids) {
                if (oid in $hSPkV.pki.oids) rval += " (" + $hSPkV.pki.oids[oid] + ") ";
            }
        }
        if (obj.type === $a66b51f6d40f99a9$var$asn1.Type.INTEGER) try {
            rval += $a66b51f6d40f99a9$var$asn1.derToInteger(obj.value);
        } catch (ex) {
            rval += "0x" + $hSPkV.util.bytesToHex(obj.value);
        }
        else if (obj.type === $a66b51f6d40f99a9$var$asn1.Type.BITSTRING) {
            // TODO: shift bits as needed to display without padding
            if (obj.value.length > 1) // remove unused bits field
            rval += "0x" + $hSPkV.util.bytesToHex(obj.value.slice(1));
            else rval += "(none)";
            // show unused bit count
            if (obj.value.length > 0) {
                var unused = obj.value.charCodeAt(0);
                if (unused == 1) rval += " (1 unused bit shown)";
                else if (unused > 1) rval += " (" + unused + " unused bits shown)";
            }
        } else if (obj.type === $a66b51f6d40f99a9$var$asn1.Type.OCTETSTRING) {
            if (!$a66b51f6d40f99a9$var$_nonLatinRegex.test(obj.value)) rval += "(" + obj.value + ") ";
            rval += "0x" + $hSPkV.util.bytesToHex(obj.value);
        } else if (obj.type === $a66b51f6d40f99a9$var$asn1.Type.UTF8) try {
            rval += $hSPkV.util.decodeUtf8(obj.value);
        } catch (e) {
            if (e.message === "URI malformed") rval += "0x" + $hSPkV.util.bytesToHex(obj.value) + " (malformed UTF8)";
            else throw e;
        }
        else if (obj.type === $a66b51f6d40f99a9$var$asn1.Type.PRINTABLESTRING || obj.type === $a66b51f6d40f99a9$var$asn1.Type.IA5String) rval += obj.value;
        else if ($a66b51f6d40f99a9$var$_nonLatinRegex.test(obj.value)) rval += "0x" + $hSPkV.util.bytesToHex(obj.value);
        else if (obj.value.length === 0) rval += "[null]";
        else rval += obj.value;
    }
    return rval;
};

});
parcelRequire.register("hSPkV", function(module, exports) {
/**
 * Node.js module for Forge.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2016 Digital Bazaar, Inc.
 */ module.exports = {
    // default options
    options: {
        usePureJavaScript: false
    }
};

});

parcelRequire.register("3lPw4", function(module, exports) {
/**
 * Utility functions for web applications.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2018 Digital Bazaar, Inc.
 */ 
var $7jzxY = parcelRequire("7jzxY");

var $7jzxY = parcelRequire("7jzxY");
var $270b4b57bda3418f$require$Buffer = $7jzxY.Buffer;

var $hSPkV = parcelRequire("hSPkV");

var $iF7DX = parcelRequire("iF7DX");
/* Utilities API */ var $270b4b57bda3418f$var$util = module.exports = $hSPkV.util = $hSPkV.util || {};
// define setImmediate and nextTick
(function() {
    typeof $7jzxY !== "undefined" && $7jzxY.nextTick;
    // polyfill nextTick with native setImmediate
    if (typeof setImmediate === "function") {
        $270b4b57bda3418f$var$util.setImmediate = function() {
            return setImmediate.apply(undefined, arguments);
        };
        $270b4b57bda3418f$var$util.nextTick = function(callback) {
            return setImmediate(callback);
        };
        return;
    }
    /* Note: A polyfill upgrade pattern is used here to allow combining
  polyfills. For example, MutationObserver is fast, but blocks UI updates,
  so it needs to allow UI updates periodically, so it falls back on
  postMessage or setTimeout. */ // polyfill with setTimeout
    $270b4b57bda3418f$var$util.setImmediate = function(callback) {
        setTimeout(callback, 0);
    };
    // upgrade polyfill to use postMessage
    if (typeof window !== "undefined" && typeof window.postMessage === "function") {
        var msg = "forge.setImmediate";
        var callbacks = [];
        $270b4b57bda3418f$var$util.setImmediate = function(callback) {
            callbacks.push(callback);
            // only send message when one hasn't been sent in
            // the current turn of the event loop
            if (callbacks.length === 1) window.postMessage(msg, "*");
        };
        function handler(event) {
            if (event.source === window && event.data === msg) {
                event.stopPropagation();
                var copy = callbacks.slice();
                callbacks.length = 0;
                copy.forEach(function(callback) {
                    callback();
                });
            }
        }
        window.addEventListener("message", handler, true);
    }
    // upgrade polyfill to use MutationObserver
    if (typeof MutationObserver !== "undefined") {
        // polyfill with MutationObserver
        var now = Date.now();
        var attr = true;
        var div = document.createElement("div");
        var callbacks = [];
        new MutationObserver(function() {
            var copy = callbacks.slice();
            callbacks.length = 0;
            copy.forEach(function(callback) {
                callback();
            });
        }).observe(div, {
            attributes: true
        });
        var oldSetImmediate = $270b4b57bda3418f$var$util.setImmediate;
        $270b4b57bda3418f$var$util.setImmediate = function(callback) {
            if (Date.now() - now > 15) {
                now = Date.now();
                oldSetImmediate(callback);
            } else {
                callbacks.push(callback);
                // only trigger observer when it hasn't been triggered in
                // the current turn of the event loop
                if (callbacks.length === 1) div.setAttribute("a", attr = !attr);
            }
        };
    }
    $270b4b57bda3418f$var$util.nextTick = $270b4b57bda3418f$var$util.setImmediate;
})();
// check if running under Node.js
$270b4b57bda3418f$var$util.isNodejs = typeof $7jzxY !== "undefined" && $7jzxY.versions && $7jzxY.versions.node;
// 'self' will also work in Web Workers (instance of WorkerGlobalScope) while
// it will point to `window` in the main thread.
// To remain compatible with older browsers, we fall back to 'window' if 'self'
// is not available.
$270b4b57bda3418f$var$util.globalScope = function() {
    if ($270b4b57bda3418f$var$util.isNodejs) return $parcel$global;
    return typeof self === "undefined" ? window : self;
}();
// define isArray
$270b4b57bda3418f$var$util.isArray = Array.isArray || function(x) {
    return Object.prototype.toString.call(x) === "[object Array]";
};
// define isArrayBuffer
$270b4b57bda3418f$var$util.isArrayBuffer = function(x) {
    return typeof ArrayBuffer !== "undefined" && x instanceof ArrayBuffer;
};
// define isArrayBufferView
$270b4b57bda3418f$var$util.isArrayBufferView = function(x) {
    return x && $270b4b57bda3418f$var$util.isArrayBuffer(x.buffer) && x.byteLength !== undefined;
};
/**
 * Ensure a bits param is 8, 16, 24, or 32. Used to validate input for
 * algorithms where bit manipulation, JavaScript limitations, and/or algorithm
 * design only allow for byte operations of a limited size.
 *
 * @param n number of bits.
 *
 * Throw Error if n invalid.
 */ function $270b4b57bda3418f$var$_checkBitsParam(n) {
    if (!(n === 8 || n === 16 || n === 24 || n === 32)) throw new Error("Only 8, 16, 24, or 32 bits supported: " + n);
}
// TODO: set ByteBuffer to best available backing
$270b4b57bda3418f$var$util.ByteBuffer = $270b4b57bda3418f$var$ByteStringBuffer;
/** Buffer w/BinaryString backing */ /**
 * Constructor for a binary string backed byte buffer.
 *
 * @param [b] the bytes to wrap (either encoded as string, one byte per
 *          character, or as an ArrayBuffer or Typed Array).
 */ function $270b4b57bda3418f$var$ByteStringBuffer(b) {
    // TODO: update to match DataBuffer API
    // the data in this buffer
    this.data = "";
    // the pointer for reading from this buffer
    this.read = 0;
    if (typeof b === "string") this.data = b;
    else if ($270b4b57bda3418f$var$util.isArrayBuffer(b) || $270b4b57bda3418f$var$util.isArrayBufferView(b)) {
        if (typeof $270b4b57bda3418f$require$Buffer !== "undefined" && b instanceof $270b4b57bda3418f$require$Buffer) this.data = b.toString("binary");
        else {
            // convert native buffer to forge buffer
            // FIXME: support native buffers internally instead
            var arr = new Uint8Array(b);
            try {
                this.data = String.fromCharCode.apply(null, arr);
            } catch (e) {
                for(var i = 0; i < arr.length; ++i)this.putByte(arr[i]);
            }
        }
    } else if (b instanceof $270b4b57bda3418f$var$ByteStringBuffer || typeof b === "object" && typeof b.data === "string" && typeof b.read === "number") {
        // copy existing buffer
        this.data = b.data;
        this.read = b.read;
    }
    // used for v8 optimization
    this._constructedStringLength = 0;
}
$270b4b57bda3418f$var$util.ByteStringBuffer = $270b4b57bda3418f$var$ByteStringBuffer;
/* Note: This is an optimization for V8-based browsers. When V8 concatenates
  a string, the strings are only joined logically using a "cons string" or
  "constructed/concatenated string". These containers keep references to one
  another and can result in very large memory usage. For example, if a 2MB
  string is constructed by concatenating 4 bytes together at a time, the
  memory usage will be ~44MB; so ~22x increase. The strings are only joined
  together when an operation requiring their joining takes place, such as
  substr(). This function is called when adding data to this buffer to ensure
  these types of strings are periodically joined to reduce the memory
  footprint. */ var $270b4b57bda3418f$var$_MAX_CONSTRUCTED_STRING_LENGTH = 4096;
$270b4b57bda3418f$var$util.ByteStringBuffer.prototype._optimizeConstructedString = function(x) {
    this._constructedStringLength += x;
    if (this._constructedStringLength > $270b4b57bda3418f$var$_MAX_CONSTRUCTED_STRING_LENGTH) {
        // this substr() should cause the constructed string to join
        this.data.substr(0, 1);
        this._constructedStringLength = 0;
    }
};
/**
 * Gets the number of bytes in this buffer.
 *
 * @return the number of bytes in this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.length = function() {
    return this.data.length - this.read;
};
/**
 * Gets whether or not this buffer is empty.
 *
 * @return true if this buffer is empty, false if not.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.isEmpty = function() {
    return this.length() <= 0;
};
/**
 * Puts a byte in this buffer.
 *
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.putByte = function(b) {
    return this.putBytes(String.fromCharCode(b));
};
/**
 * Puts a byte in this buffer N times.
 *
 * @param b the byte to put.
 * @param n the number of bytes of value b to put.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.fillWithByte = function(b, n) {
    b = String.fromCharCode(b);
    var d = this.data;
    while(n > 0){
        if (n & 1) d += b;
        n >>>= 1;
        if (n > 0) b += b;
    }
    this.data = d;
    this._optimizeConstructedString(n);
    return this;
};
/**
 * Puts bytes in this buffer.
 *
 * @param bytes the bytes (as a binary encoded string) to put.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.putBytes = function(bytes) {
    this.data += bytes;
    this._optimizeConstructedString(bytes.length);
    return this;
};
/**
 * Puts a UTF-16 encoded string into this buffer.
 *
 * @param str the string to put.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.putString = function(str) {
    return this.putBytes($270b4b57bda3418f$var$util.encodeUtf8(str));
};
/**
 * Puts a 16-bit integer in this buffer in big-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.putInt16 = function(i) {
    return this.putBytes(String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
};
/**
 * Puts a 24-bit integer in this buffer in big-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.putInt24 = function(i) {
    return this.putBytes(String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
};
/**
 * Puts a 32-bit integer in this buffer in big-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.putInt32 = function(i) {
    return this.putBytes(String.fromCharCode(i >> 24 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
};
/**
 * Puts a 16-bit integer in this buffer in little-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.putInt16Le = function(i) {
    return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF));
};
/**
 * Puts a 24-bit integer in this buffer in little-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.putInt24Le = function(i) {
    return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF));
};
/**
 * Puts a 32-bit integer in this buffer in little-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.putInt32Le = function(i) {
    return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 24 & 0xFF));
};
/**
 * Puts an n-bit integer in this buffer in big-endian order.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.putInt = function(i, n) {
    $270b4b57bda3418f$var$_checkBitsParam(n);
    var bytes = "";
    do {
        n -= 8;
        bytes += String.fromCharCode(i >> n & 0xFF);
    }while (n > 0);
    return this.putBytes(bytes);
};
/**
 * Puts a signed n-bit integer in this buffer in big-endian order. Two's
 * complement representation is used.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.putSignedInt = function(i, n) {
    // putInt checks n
    if (i < 0) i += 2 << n - 1;
    return this.putInt(i, n);
};
/**
 * Puts the given buffer into this buffer.
 *
 * @param buffer the buffer to put into this one.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.putBuffer = function(buffer) {
    return this.putBytes(buffer.getBytes());
};
/**
 * Gets a byte from this buffer and advances the read pointer by 1.
 *
 * @return the byte.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.getByte = function() {
    return this.data.charCodeAt(this.read++);
};
/**
 * Gets a uint16 from this buffer in big-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.getInt16 = function() {
    var rval = this.data.charCodeAt(this.read) << 8 ^ this.data.charCodeAt(this.read + 1);
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in big-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.getInt24 = function() {
    var rval = this.data.charCodeAt(this.read) << 16 ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2);
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in big-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.getInt32 = function() {
    var rval = this.data.charCodeAt(this.read) << 24 ^ this.data.charCodeAt(this.read + 1) << 16 ^ this.data.charCodeAt(this.read + 2) << 8 ^ this.data.charCodeAt(this.read + 3);
    this.read += 4;
    return rval;
};
/**
 * Gets a uint16 from this buffer in little-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.getInt16Le = function() {
    var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8;
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in little-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.getInt24Le = function() {
    var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16;
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in little-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.getInt32Le = function() {
    var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16 ^ this.data.charCodeAt(this.read + 3) << 24;
    this.read += 4;
    return rval;
};
/**
 * Gets an n-bit integer from this buffer in big-endian order and advances the
 * read pointer by ceil(n/8).
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.getInt = function(n) {
    $270b4b57bda3418f$var$_checkBitsParam(n);
    var rval = 0;
    do {
        // TODO: Use (rval * 0x100) if adding support for 33 to 53 bits.
        rval = (rval << 8) + this.data.charCodeAt(this.read++);
        n -= 8;
    }while (n > 0);
    return rval;
};
/**
 * Gets a signed n-bit integer from this buffer in big-endian order, using
 * two's complement, and advances the read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.getSignedInt = function(n) {
    // getInt checks n
    var x = this.getInt(n);
    var max = 2 << n - 2;
    if (x >= max) x -= max << 1;
    return x;
};
/**
 * Reads bytes out as a binary encoded string and clears them from the
 * buffer. Note that the resulting string is binary encoded (in node.js this
 * encoding is referred to as `binary`, it is *not* `utf8`).
 *
 * @param count the number of bytes to read, undefined or null for all.
 *
 * @return a binary encoded string of bytes.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.getBytes = function(count) {
    var rval;
    if (count) {
        // read count bytes
        count = Math.min(this.length(), count);
        rval = this.data.slice(this.read, this.read + count);
        this.read += count;
    } else if (count === 0) rval = "";
    else {
        // read all bytes, optimize to only copy when needed
        rval = this.read === 0 ? this.data : this.data.slice(this.read);
        this.clear();
    }
    return rval;
};
/**
 * Gets a binary encoded string of the bytes from this buffer without
 * modifying the read pointer.
 *
 * @param count the number of bytes to get, omit to get all.
 *
 * @return a string full of binary encoded characters.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.bytes = function(count) {
    return typeof count === "undefined" ? this.data.slice(this.read) : this.data.slice(this.read, this.read + count);
};
/**
 * Gets a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 *
 * @return the byte.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.at = function(i) {
    return this.data.charCodeAt(this.read + i);
};
/**
 * Puts a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.setAt = function(i, b) {
    this.data = this.data.substr(0, this.read + i) + String.fromCharCode(b) + this.data.substr(this.read + i + 1);
    return this;
};
/**
 * Gets the last byte without modifying the read pointer.
 *
 * @return the last byte.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.last = function() {
    return this.data.charCodeAt(this.data.length - 1);
};
/**
 * Creates a copy of this buffer.
 *
 * @return the copy.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.copy = function() {
    var c = $270b4b57bda3418f$var$util.createBuffer(this.data);
    c.read = this.read;
    return c;
};
/**
 * Compacts this buffer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.compact = function() {
    if (this.read > 0) {
        this.data = this.data.slice(this.read);
        this.read = 0;
    }
    return this;
};
/**
 * Clears this buffer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.clear = function() {
    this.data = "";
    this.read = 0;
    return this;
};
/**
 * Shortens this buffer by trimming bytes off of the end of this buffer.
 *
 * @param count the number of bytes to trim off.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.truncate = function(count) {
    var len = Math.max(0, this.length() - count);
    this.data = this.data.substr(this.read, len);
    this.read = 0;
    return this;
};
/**
 * Converts this buffer to a hexadecimal string.
 *
 * @return a hexadecimal string.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.toHex = function() {
    var rval = "";
    for(var i = this.read; i < this.data.length; ++i){
        var b = this.data.charCodeAt(i);
        if (b < 16) rval += "0";
        rval += b.toString(16);
    }
    return rval;
};
/**
 * Converts this buffer to a UTF-16 string (standard JavaScript string).
 *
 * @return a UTF-16 string.
 */ $270b4b57bda3418f$var$util.ByteStringBuffer.prototype.toString = function() {
    return $270b4b57bda3418f$var$util.decodeUtf8(this.bytes());
};
/** End Buffer w/BinaryString backing */ /** Buffer w/UInt8Array backing */ /**
 * FIXME: Experimental. Do not use yet.
 *
 * Constructor for an ArrayBuffer-backed byte buffer.
 *
 * The buffer may be constructed from a string, an ArrayBuffer, DataView, or a
 * TypedArray.
 *
 * If a string is given, its encoding should be provided as an option,
 * otherwise it will default to 'binary'. A 'binary' string is encoded such
 * that each character is one byte in length and size.
 *
 * If an ArrayBuffer, DataView, or TypedArray is given, it will be used
 * *directly* without any copying. Note that, if a write to the buffer requires
 * more space, the buffer will allocate a new backing ArrayBuffer to
 * accommodate. The starting read and write offsets for the buffer may be
 * given as options.
 *
 * @param [b] the initial bytes for this buffer.
 * @param options the options to use:
 *          [readOffset] the starting read offset to use (default: 0).
 *          [writeOffset] the starting write offset to use (default: the
 *            length of the first parameter).
 *          [growSize] the minimum amount, in bytes, to grow the buffer by to
 *            accommodate writes (default: 1024).
 *          [encoding] the encoding ('binary', 'utf8', 'utf16', 'hex') for the
 *            first parameter, if it is a string (default: 'binary').
 */ function $270b4b57bda3418f$var$DataBuffer(b, options) {
    // default options
    options = options || {};
    // pointers for read from/write to buffer
    this.read = options.readOffset || 0;
    this.growSize = options.growSize || 1024;
    var isArrayBuffer = $270b4b57bda3418f$var$util.isArrayBuffer(b);
    var isArrayBufferView = $270b4b57bda3418f$var$util.isArrayBufferView(b);
    if (isArrayBuffer || isArrayBufferView) {
        // use ArrayBuffer directly
        if (isArrayBuffer) this.data = new DataView(b);
        else // TODO: adjust read/write offset based on the type of view
        // or specify that this must be done in the options ... that the
        // offsets are byte-based
        this.data = new DataView(b.buffer, b.byteOffset, b.byteLength);
        this.write = "writeOffset" in options ? options.writeOffset : this.data.byteLength;
        return;
    }
    // initialize to empty array buffer and add any given bytes using putBytes
    this.data = new DataView(new ArrayBuffer(0));
    this.write = 0;
    if (b !== null && b !== undefined) this.putBytes(b);
    if ("writeOffset" in options) this.write = options.writeOffset;
}
$270b4b57bda3418f$var$util.DataBuffer = $270b4b57bda3418f$var$DataBuffer;
/**
 * Gets the number of bytes in this buffer.
 *
 * @return the number of bytes in this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.length = function() {
    return this.write - this.read;
};
/**
 * Gets whether or not this buffer is empty.
 *
 * @return true if this buffer is empty, false if not.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.isEmpty = function() {
    return this.length() <= 0;
};
/**
 * Ensures this buffer has enough empty space to accommodate the given number
 * of bytes. An optional parameter may be given that indicates a minimum
 * amount to grow the buffer if necessary. If the parameter is not given,
 * the buffer will be grown by some previously-specified default amount
 * or heuristic.
 *
 * @param amount the number of bytes to accommodate.
 * @param [growSize] the minimum amount, in bytes, to grow the buffer by if
 *          necessary.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.accommodate = function(amount, growSize) {
    if (this.length() >= amount) return this;
    growSize = Math.max(growSize || this.growSize, amount);
    // grow buffer
    var src = new Uint8Array(this.data.buffer, this.data.byteOffset, this.data.byteLength);
    var dst = new Uint8Array(this.length() + growSize);
    dst.set(src);
    this.data = new DataView(dst.buffer);
    return this;
};
/**
 * Puts a byte in this buffer.
 *
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.putByte = function(b) {
    this.accommodate(1);
    this.data.setUint8(this.write++, b);
    return this;
};
/**
 * Puts a byte in this buffer N times.
 *
 * @param b the byte to put.
 * @param n the number of bytes of value b to put.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.fillWithByte = function(b, n) {
    this.accommodate(n);
    for(var i = 0; i < n; ++i)this.data.setUint8(b);
    return this;
};
/**
 * Puts bytes in this buffer. The bytes may be given as a string, an
 * ArrayBuffer, a DataView, or a TypedArray.
 *
 * @param bytes the bytes to put.
 * @param [encoding] the encoding for the first parameter ('binary', 'utf8',
 *          'utf16', 'hex'), if it is a string (default: 'binary').
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.putBytes = function(bytes, encoding) {
    if ($270b4b57bda3418f$var$util.isArrayBufferView(bytes)) {
        var src = new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
        var len = src.byteLength - src.byteOffset;
        this.accommodate(len);
        var dst = new Uint8Array(this.data.buffer, this.write);
        dst.set(src);
        this.write += len;
        return this;
    }
    if ($270b4b57bda3418f$var$util.isArrayBuffer(bytes)) {
        var src = new Uint8Array(bytes);
        this.accommodate(src.byteLength);
        var dst = new Uint8Array(this.data.buffer);
        dst.set(src, this.write);
        this.write += src.byteLength;
        return this;
    }
    // bytes is a util.DataBuffer or equivalent
    if (bytes instanceof $270b4b57bda3418f$var$util.DataBuffer || typeof bytes === "object" && typeof bytes.read === "number" && typeof bytes.write === "number" && $270b4b57bda3418f$var$util.isArrayBufferView(bytes.data)) {
        var src = new Uint8Array(bytes.data.byteLength, bytes.read, bytes.length());
        this.accommodate(src.byteLength);
        var dst = new Uint8Array(bytes.data.byteLength, this.write);
        dst.set(src);
        this.write += src.byteLength;
        return this;
    }
    if (bytes instanceof $270b4b57bda3418f$var$util.ByteStringBuffer) {
        // copy binary string and process as the same as a string parameter below
        bytes = bytes.data;
        encoding = "binary";
    }
    // string conversion
    encoding = encoding || "binary";
    if (typeof bytes === "string") {
        var view;
        // decode from string
        if (encoding === "hex") {
            this.accommodate(Math.ceil(bytes.length / 2));
            view = new Uint8Array(this.data.buffer, this.write);
            this.write += $270b4b57bda3418f$var$util.binary.hex.decode(bytes, view, this.write);
            return this;
        }
        if (encoding === "base64") {
            this.accommodate(Math.ceil(bytes.length / 4) * 3);
            view = new Uint8Array(this.data.buffer, this.write);
            this.write += $270b4b57bda3418f$var$util.binary.base64.decode(bytes, view, this.write);
            return this;
        }
        // encode text as UTF-8 bytes
        if (encoding === "utf8") {
            // encode as UTF-8 then decode string as raw binary
            bytes = $270b4b57bda3418f$var$util.encodeUtf8(bytes);
            encoding = "binary";
        }
        // decode string as raw binary
        if (encoding === "binary" || encoding === "raw") {
            // one byte per character
            this.accommodate(bytes.length);
            view = new Uint8Array(this.data.buffer, this.write);
            this.write += $270b4b57bda3418f$var$util.binary.raw.decode(view);
            return this;
        }
        // encode text as UTF-16 bytes
        if (encoding === "utf16") {
            // two bytes per character
            this.accommodate(bytes.length * 2);
            view = new Uint16Array(this.data.buffer, this.write);
            this.write += $270b4b57bda3418f$var$util.text.utf16.encode(view);
            return this;
        }
        throw new Error("Invalid encoding: " + encoding);
    }
    throw Error("Invalid parameter: " + bytes);
};
/**
 * Puts the given buffer into this buffer.
 *
 * @param buffer the buffer to put into this one.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.putBuffer = function(buffer) {
    this.putBytes(buffer);
    buffer.clear();
    return this;
};
/**
 * Puts a string into this buffer.
 *
 * @param str the string to put.
 * @param [encoding] the encoding for the string (default: 'utf16').
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.putString = function(str) {
    return this.putBytes(str, "utf16");
};
/**
 * Puts a 16-bit integer in this buffer in big-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.putInt16 = function(i) {
    this.accommodate(2);
    this.data.setInt16(this.write, i);
    this.write += 2;
    return this;
};
/**
 * Puts a 24-bit integer in this buffer in big-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.putInt24 = function(i) {
    this.accommodate(3);
    this.data.setInt16(this.write, i >> 8 & 0xFFFF);
    this.data.setInt8(this.write, i >> 16 & 0xFF);
    this.write += 3;
    return this;
};
/**
 * Puts a 32-bit integer in this buffer in big-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.putInt32 = function(i) {
    this.accommodate(4);
    this.data.setInt32(this.write, i);
    this.write += 4;
    return this;
};
/**
 * Puts a 16-bit integer in this buffer in little-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.putInt16Le = function(i) {
    this.accommodate(2);
    this.data.setInt16(this.write, i, true);
    this.write += 2;
    return this;
};
/**
 * Puts a 24-bit integer in this buffer in little-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.putInt24Le = function(i) {
    this.accommodate(3);
    this.data.setInt8(this.write, i >> 16 & 0xFF);
    this.data.setInt16(this.write, i >> 8 & 0xFFFF, true);
    this.write += 3;
    return this;
};
/**
 * Puts a 32-bit integer in this buffer in little-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.putInt32Le = function(i) {
    this.accommodate(4);
    this.data.setInt32(this.write, i, true);
    this.write += 4;
    return this;
};
/**
 * Puts an n-bit integer in this buffer in big-endian order.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.putInt = function(i, n) {
    $270b4b57bda3418f$var$_checkBitsParam(n);
    this.accommodate(n / 8);
    do {
        n -= 8;
        this.data.setInt8(this.write++, i >> n & 0xFF);
    }while (n > 0);
    return this;
};
/**
 * Puts a signed n-bit integer in this buffer in big-endian order. Two's
 * complement representation is used.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.putSignedInt = function(i, n) {
    $270b4b57bda3418f$var$_checkBitsParam(n);
    this.accommodate(n / 8);
    if (i < 0) i += 2 << n - 1;
    return this.putInt(i, n);
};
/**
 * Gets a byte from this buffer and advances the read pointer by 1.
 *
 * @return the byte.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.getByte = function() {
    return this.data.getInt8(this.read++);
};
/**
 * Gets a uint16 from this buffer in big-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.getInt16 = function() {
    var rval = this.data.getInt16(this.read);
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in big-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.getInt24 = function() {
    var rval = this.data.getInt16(this.read) << 8 ^ this.data.getInt8(this.read + 2);
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in big-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.getInt32 = function() {
    var rval = this.data.getInt32(this.read);
    this.read += 4;
    return rval;
};
/**
 * Gets a uint16 from this buffer in little-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.getInt16Le = function() {
    var rval = this.data.getInt16(this.read, true);
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in little-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.getInt24Le = function() {
    var rval = this.data.getInt8(this.read) ^ this.data.getInt16(this.read + 1, true) << 8;
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in little-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.getInt32Le = function() {
    var rval = this.data.getInt32(this.read, true);
    this.read += 4;
    return rval;
};
/**
 * Gets an n-bit integer from this buffer in big-endian order and advances the
 * read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.getInt = function(n) {
    $270b4b57bda3418f$var$_checkBitsParam(n);
    var rval = 0;
    do {
        // TODO: Use (rval * 0x100) if adding support for 33 to 53 bits.
        rval = (rval << 8) + this.data.getInt8(this.read++);
        n -= 8;
    }while (n > 0);
    return rval;
};
/**
 * Gets a signed n-bit integer from this buffer in big-endian order, using
 * two's complement, and advances the read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.getSignedInt = function(n) {
    // getInt checks n
    var x = this.getInt(n);
    var max = 2 << n - 2;
    if (x >= max) x -= max << 1;
    return x;
};
/**
 * Reads bytes out as a binary encoded string and clears them from the
 * buffer.
 *
 * @param count the number of bytes to read, undefined or null for all.
 *
 * @return a binary encoded string of bytes.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.getBytes = function(count) {
    // TODO: deprecate this method, it is poorly named and
    // this.toString('binary') replaces it
    // add a toTypedArray()/toArrayBuffer() function
    var rval;
    if (count) {
        // read count bytes
        count = Math.min(this.length(), count);
        rval = this.data.slice(this.read, this.read + count);
        this.read += count;
    } else if (count === 0) rval = "";
    else {
        // read all bytes, optimize to only copy when needed
        rval = this.read === 0 ? this.data : this.data.slice(this.read);
        this.clear();
    }
    return rval;
};
/**
 * Gets a binary encoded string of the bytes from this buffer without
 * modifying the read pointer.
 *
 * @param count the number of bytes to get, omit to get all.
 *
 * @return a string full of binary encoded characters.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.bytes = function(count) {
    // TODO: deprecate this method, it is poorly named, add "getString()"
    return typeof count === "undefined" ? this.data.slice(this.read) : this.data.slice(this.read, this.read + count);
};
/**
 * Gets a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 *
 * @return the byte.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.at = function(i) {
    return this.data.getUint8(this.read + i);
};
/**
 * Puts a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.setAt = function(i, b) {
    this.data.setUint8(i, b);
    return this;
};
/**
 * Gets the last byte without modifying the read pointer.
 *
 * @return the last byte.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.last = function() {
    return this.data.getUint8(this.write - 1);
};
/**
 * Creates a copy of this buffer.
 *
 * @return the copy.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.copy = function() {
    return new $270b4b57bda3418f$var$util.DataBuffer(this);
};
/**
 * Compacts this buffer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.compact = function() {
    if (this.read > 0) {
        var src = new Uint8Array(this.data.buffer, this.read);
        var dst = new Uint8Array(src.byteLength);
        dst.set(src);
        this.data = new DataView(dst);
        this.write -= this.read;
        this.read = 0;
    }
    return this;
};
/**
 * Clears this buffer.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.clear = function() {
    this.data = new DataView(new ArrayBuffer(0));
    this.read = this.write = 0;
    return this;
};
/**
 * Shortens this buffer by trimming bytes off of the end of this buffer.
 *
 * @param count the number of bytes to trim off.
 *
 * @return this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.truncate = function(count) {
    this.write = Math.max(0, this.length() - count);
    this.read = Math.min(this.read, this.write);
    return this;
};
/**
 * Converts this buffer to a hexadecimal string.
 *
 * @return a hexadecimal string.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.toHex = function() {
    var rval = "";
    for(var i = this.read; i < this.data.byteLength; ++i){
        var b = this.data.getUint8(i);
        if (b < 16) rval += "0";
        rval += b.toString(16);
    }
    return rval;
};
/**
 * Converts this buffer to a string, using the given encoding. If no
 * encoding is given, 'utf8' (UTF-8) is used.
 *
 * @param [encoding] the encoding to use: 'binary', 'utf8', 'utf16', 'hex',
 *          'base64' (default: 'utf8').
 *
 * @return a string representation of the bytes in this buffer.
 */ $270b4b57bda3418f$var$util.DataBuffer.prototype.toString = function(encoding) {
    var view = new Uint8Array(this.data, this.read, this.length());
    encoding = encoding || "utf8";
    // encode to string
    if (encoding === "binary" || encoding === "raw") return $270b4b57bda3418f$var$util.binary.raw.encode(view);
    if (encoding === "hex") return $270b4b57bda3418f$var$util.binary.hex.encode(view);
    if (encoding === "base64") return $270b4b57bda3418f$var$util.binary.base64.encode(view);
    // decode to text
    if (encoding === "utf8") return $270b4b57bda3418f$var$util.text.utf8.decode(view);
    if (encoding === "utf16") return $270b4b57bda3418f$var$util.text.utf16.decode(view);
    throw new Error("Invalid encoding: " + encoding);
};
/** End Buffer w/UInt8Array backing */ /**
 * Creates a buffer that stores bytes. A value may be given to populate the
 * buffer with data. This value can either be string of encoded bytes or a
 * regular string of characters. When passing a string of binary encoded
 * bytes, the encoding `raw` should be given. This is also the default. When
 * passing a string of characters, the encoding `utf8` should be given.
 *
 * @param [input] a string with encoded bytes to store in the buffer.
 * @param [encoding] (default: 'raw', other: 'utf8').
 */ $270b4b57bda3418f$var$util.createBuffer = function(input, encoding) {
    // TODO: deprecate, use new ByteBuffer() instead
    encoding = encoding || "raw";
    if (input !== undefined && encoding === "utf8") input = $270b4b57bda3418f$var$util.encodeUtf8(input);
    return new $270b4b57bda3418f$var$util.ByteBuffer(input);
};
/**
 * Fills a string with a particular value. If you want the string to be a byte
 * string, pass in String.fromCharCode(theByte).
 *
 * @param c the character to fill the string with, use String.fromCharCode
 *          to fill the string with a byte value.
 * @param n the number of characters of value c to fill with.
 *
 * @return the filled string.
 */ $270b4b57bda3418f$var$util.fillString = function(c, n) {
    var s = "";
    while(n > 0){
        if (n & 1) s += c;
        n >>>= 1;
        if (n > 0) c += c;
    }
    return s;
};
/**
 * Performs a per byte XOR between two byte strings and returns the result as a
 * string of bytes.
 *
 * @param s1 first string of bytes.
 * @param s2 second string of bytes.
 * @param n the number of bytes to XOR.
 *
 * @return the XOR'd result.
 */ $270b4b57bda3418f$var$util.xorBytes = function(s1, s2, n) {
    var s3 = "";
    var b = "";
    var t = "";
    var i = 0;
    var c = 0;
    for(; n > 0; --n, ++i){
        b = s1.charCodeAt(i) ^ s2.charCodeAt(i);
        if (c >= 10) {
            s3 += t;
            t = "";
            c = 0;
        }
        t += String.fromCharCode(b);
        ++c;
    }
    s3 += t;
    return s3;
};
/**
 * Converts a hex string into a 'binary' encoded string of bytes.
 *
 * @param hex the hexadecimal string to convert.
 *
 * @return the binary-encoded string of bytes.
 */ $270b4b57bda3418f$var$util.hexToBytes = function(hex) {
    // TODO: deprecate: "Deprecated. Use util.binary.hex.decode instead."
    var rval = "";
    var i = 0;
    if (hex.length & true) {
        // odd number of characters, convert first character alone
        i = 1;
        rval += String.fromCharCode(parseInt(hex[0], 16));
    }
    // convert 2 characters (1 byte) at a time
    for(; i < hex.length; i += 2)rval += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    return rval;
};
/**
 * Converts a 'binary' encoded string of bytes to hex.
 *
 * @param bytes the byte string to convert.
 *
 * @return the string of hexadecimal characters.
 */ $270b4b57bda3418f$var$util.bytesToHex = function(bytes) {
    // TODO: deprecate: "Deprecated. Use util.binary.hex.encode instead."
    return $270b4b57bda3418f$var$util.createBuffer(bytes).toHex();
};
/**
 * Converts an 32-bit integer to 4-big-endian byte string.
 *
 * @param i the integer.
 *
 * @return the byte string.
 */ $270b4b57bda3418f$var$util.int32ToBytes = function(i) {
    return String.fromCharCode(i >> 24 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF);
};
// base64 characters, reverse mapping
var $270b4b57bda3418f$var$_base64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var $270b4b57bda3418f$var$_base64Idx = [
    /*43 -43 = 0*/ /*'+',  1,  2,  3,'/' */ 62,
    -1,
    -1,
    -1,
    63,
    /*'0','1','2','3','4','5','6','7','8','9' */ 52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    /*15, 16, 17,'=', 19, 20, 21 */ -1,
    -1,
    -1,
    64,
    -1,
    -1,
    -1,
    /*65 - 43 = 22*/ /*'A','B','C','D','E','F','G','H','I','J','K','L','M', */ 0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    /*'N','O','P','Q','R','S','T','U','V','W','X','Y','Z' */ 13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    /*91 - 43 = 48 */ /*48, 49, 50, 51, 52, 53 */ -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    /*97 - 43 = 54*/ /*'a','b','c','d','e','f','g','h','i','j','k','l','m' */ 26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    /*'n','o','p','q','r','s','t','u','v','w','x','y','z' */ 39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51
];
// base58 characters (Bitcoin alphabet)
var $270b4b57bda3418f$var$_base58 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
/**
 * Base64 encodes a 'binary' encoded string of bytes.
 *
 * @param input the binary encoded string of bytes to base64-encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the base64-encoded output.
 */ $270b4b57bda3418f$var$util.encode64 = function(input, maxline) {
    // TODO: deprecate: "Deprecated. Use util.binary.base64.encode instead."
    var line = "";
    var output = "";
    var chr1, chr2, chr3;
    var i = 0;
    while(i < input.length){
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        // encode 4 character group
        line += $270b4b57bda3418f$var$_base64.charAt(chr1 >> 2);
        line += $270b4b57bda3418f$var$_base64.charAt((chr1 & 3) << 4 | chr2 >> 4);
        if (isNaN(chr2)) line += "==";
        else {
            line += $270b4b57bda3418f$var$_base64.charAt((chr2 & 15) << 2 | chr3 >> 6);
            line += isNaN(chr3) ? "=" : $270b4b57bda3418f$var$_base64.charAt(chr3 & 63);
        }
        if (maxline && line.length > maxline) {
            output += line.substr(0, maxline) + "\r\n";
            line = line.substr(maxline);
        }
    }
    output += line;
    return output;
};
/**
 * Base64 decodes a string into a 'binary' encoded string of bytes.
 *
 * @param input the base64-encoded input.
 *
 * @return the binary encoded string.
 */ $270b4b57bda3418f$var$util.decode64 = function(input) {
    // TODO: deprecate: "Deprecated. Use util.binary.base64.decode instead."
    // remove all non-base64 characters
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    var output = "";
    var enc1, enc2, enc3, enc4;
    var i = 0;
    while(i < input.length){
        enc1 = $270b4b57bda3418f$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc2 = $270b4b57bda3418f$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc3 = $270b4b57bda3418f$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc4 = $270b4b57bda3418f$var$_base64Idx[input.charCodeAt(i++) - 43];
        output += String.fromCharCode(enc1 << 2 | enc2 >> 4);
        if (enc3 !== 64) {
            // decoded at least 2 bytes
            output += String.fromCharCode((enc2 & 15) << 4 | enc3 >> 2);
            if (enc4 !== 64) // decoded 3 bytes
            output += String.fromCharCode((enc3 & 3) << 6 | enc4);
        }
    }
    return output;
};
/**
 * Encodes the given string of characters (a standard JavaScript
 * string) as a binary encoded string where the bytes represent
 * a UTF-8 encoded string of characters. Non-ASCII characters will be
 * encoded as multiple bytes according to UTF-8.
 *
 * @param str a standard string of characters to encode.
 *
 * @return the binary encoded string.
 */ $270b4b57bda3418f$var$util.encodeUtf8 = function(str) {
    return unescape(encodeURIComponent(str));
};
/**
 * Decodes a binary encoded string that contains bytes that
 * represent a UTF-8 encoded string of characters -- into a
 * string of characters (a standard JavaScript string).
 *
 * @param str the binary encoded string to decode.
 *
 * @return the resulting standard string of characters.
 */ $270b4b57bda3418f$var$util.decodeUtf8 = function(str) {
    return decodeURIComponent(escape(str));
};
// binary encoding/decoding tools
// FIXME: Experimental. Do not use yet.
$270b4b57bda3418f$var$util.binary = {
    raw: {},
    hex: {},
    base64: {},
    base58: {},
    baseN: {
        encode: $iF7DX.encode,
        decode: $iF7DX.decode
    }
};
/**
 * Encodes a Uint8Array as a binary-encoded string. This encoding uses
 * a value between 0 and 255 for each character.
 *
 * @param bytes the Uint8Array to encode.
 *
 * @return the binary-encoded string.
 */ $270b4b57bda3418f$var$util.binary.raw.encode = function(bytes) {
    return String.fromCharCode.apply(null, bytes);
};
/**
 * Decodes a binary-encoded string to a Uint8Array. This encoding uses
 * a value between 0 and 255 for each character.
 *
 * @param str the binary-encoded string to decode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $270b4b57bda3418f$var$util.binary.raw.decode = function(str, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(str.length);
    offset = offset || 0;
    var j = offset;
    for(var i = 0; i < str.length; ++i)out[j++] = str.charCodeAt(i);
    return output ? j - offset : out;
};
/**
 * Encodes a 'binary' string, ArrayBuffer, DataView, TypedArray, or
 * ByteBuffer as a string of hexadecimal characters.
 *
 * @param bytes the bytes to convert.
 *
 * @return the string of hexadecimal characters.
 */ $270b4b57bda3418f$var$util.binary.hex.encode = $270b4b57bda3418f$var$util.bytesToHex;
/**
 * Decodes a hex-encoded string to a Uint8Array.
 *
 * @param hex the hexadecimal string to convert.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $270b4b57bda3418f$var$util.binary.hex.decode = function(hex, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(Math.ceil(hex.length / 2));
    offset = offset || 0;
    var i = 0, j = offset;
    if (hex.length & 1) {
        // odd number of characters, convert first character alone
        i = 1;
        out[j++] = parseInt(hex[0], 16);
    }
    // convert 2 characters (1 byte) at a time
    for(; i < hex.length; i += 2)out[j++] = parseInt(hex.substr(i, 2), 16);
    return output ? j - offset : out;
};
/**
 * Base64-encodes a Uint8Array.
 *
 * @param input the Uint8Array to encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the base64-encoded output string.
 */ $270b4b57bda3418f$var$util.binary.base64.encode = function(input, maxline) {
    var line = "";
    var output = "";
    var chr1, chr2, chr3;
    var i = 0;
    while(i < input.byteLength){
        chr1 = input[i++];
        chr2 = input[i++];
        chr3 = input[i++];
        // encode 4 character group
        line += $270b4b57bda3418f$var$_base64.charAt(chr1 >> 2);
        line += $270b4b57bda3418f$var$_base64.charAt((chr1 & 3) << 4 | chr2 >> 4);
        if (isNaN(chr2)) line += "==";
        else {
            line += $270b4b57bda3418f$var$_base64.charAt((chr2 & 15) << 2 | chr3 >> 6);
            line += isNaN(chr3) ? "=" : $270b4b57bda3418f$var$_base64.charAt(chr3 & 63);
        }
        if (maxline && line.length > maxline) {
            output += line.substr(0, maxline) + "\r\n";
            line = line.substr(maxline);
        }
    }
    output += line;
    return output;
};
/**
 * Decodes a base64-encoded string to a Uint8Array.
 *
 * @param input the base64-encoded input string.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $270b4b57bda3418f$var$util.binary.base64.decode = function(input, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(Math.ceil(input.length / 4) * 3);
    // remove all non-base64 characters
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    offset = offset || 0;
    var enc1, enc2, enc3, enc4;
    var i = 0, j = offset;
    while(i < input.length){
        enc1 = $270b4b57bda3418f$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc2 = $270b4b57bda3418f$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc3 = $270b4b57bda3418f$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc4 = $270b4b57bda3418f$var$_base64Idx[input.charCodeAt(i++) - 43];
        out[j++] = enc1 << 2 | enc2 >> 4;
        if (enc3 !== 64) {
            // decoded at least 2 bytes
            out[j++] = (enc2 & 15) << 4 | enc3 >> 2;
            if (enc4 !== 64) // decoded 3 bytes
            out[j++] = (enc3 & 3) << 6 | enc4;
        }
    }
    // make sure result is the exact decoded length
    return output ? j - offset : out.subarray(0, j);
};
// add support for base58 encoding/decoding with Bitcoin alphabet
$270b4b57bda3418f$var$util.binary.base58.encode = function(input, maxline) {
    return $270b4b57bda3418f$var$util.binary.baseN.encode(input, $270b4b57bda3418f$var$_base58, maxline);
};
$270b4b57bda3418f$var$util.binary.base58.decode = function(input, maxline) {
    return $270b4b57bda3418f$var$util.binary.baseN.decode(input, $270b4b57bda3418f$var$_base58, maxline);
};
// text encoding/decoding tools
// FIXME: Experimental. Do not use yet.
$270b4b57bda3418f$var$util.text = {
    utf8: {},
    utf16: {}
};
/**
 * Encodes the given string as UTF-8 in a Uint8Array.
 *
 * @param str the string to encode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $270b4b57bda3418f$var$util.text.utf8.encode = function(str, output, offset) {
    str = $270b4b57bda3418f$var$util.encodeUtf8(str);
    var out = output;
    if (!out) out = new Uint8Array(str.length);
    offset = offset || 0;
    var j = offset;
    for(var i = 0; i < str.length; ++i)out[j++] = str.charCodeAt(i);
    return output ? j - offset : out;
};
/**
 * Decodes the UTF-8 contents from a Uint8Array.
 *
 * @param bytes the Uint8Array to decode.
 *
 * @return the resulting string.
 */ $270b4b57bda3418f$var$util.text.utf8.decode = function(bytes) {
    return $270b4b57bda3418f$var$util.decodeUtf8(String.fromCharCode.apply(null, bytes));
};
/**
 * Encodes the given string as UTF-16 in a Uint8Array.
 *
 * @param str the string to encode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $270b4b57bda3418f$var$util.text.utf16.encode = function(str, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(str.length * 2);
    var view = new Uint16Array(out.buffer);
    offset = offset || 0;
    var j = offset;
    var k = offset;
    for(var i = 0; i < str.length; ++i){
        view[k++] = str.charCodeAt(i);
        j += 2;
    }
    return output ? j - offset : out;
};
/**
 * Decodes the UTF-16 contents from a Uint8Array.
 *
 * @param bytes the Uint8Array to decode.
 *
 * @return the resulting string.
 */ $270b4b57bda3418f$var$util.text.utf16.decode = function(bytes) {
    return String.fromCharCode.apply(null, new Uint16Array(bytes.buffer));
};
/**
 * Deflates the given data using a flash interface.
 *
 * @param api the flash interface.
 * @param bytes the data.
 * @param raw true to return only raw deflate data, false to include zlib
 *          header and trailer.
 *
 * @return the deflated data as a string.
 */ $270b4b57bda3418f$var$util.deflate = function(api, bytes, raw) {
    bytes = $270b4b57bda3418f$var$util.decode64(api.deflate($270b4b57bda3418f$var$util.encode64(bytes)).rval);
    // strip zlib header and trailer if necessary
    if (raw) {
        // zlib header is 2 bytes (CMF,FLG) where FLG indicates that
        // there is a 4-byte DICT (alder-32) block before the data if
        // its 5th bit is set
        var start = 2;
        var flg = bytes.charCodeAt(1);
        if (flg & 0x20) start = 6;
        // zlib trailer is 4 bytes of adler-32
        bytes = bytes.substring(start, bytes.length - 4);
    }
    return bytes;
};
/**
 * Inflates the given data using a flash interface.
 *
 * @param api the flash interface.
 * @param bytes the data.
 * @param raw true if the incoming data has no zlib header or trailer and is
 *          raw DEFLATE data.
 *
 * @return the inflated data as a string, null on error.
 */ $270b4b57bda3418f$var$util.inflate = function(api, bytes, raw) {
    // TODO: add zlib header and trailer if necessary/possible
    var rval = api.inflate($270b4b57bda3418f$var$util.encode64(bytes)).rval;
    return rval === null ? null : $270b4b57bda3418f$var$util.decode64(rval);
};
/**
 * Sets a storage object.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param obj the storage object, null to remove.
 */ var $270b4b57bda3418f$var$_setStorageObject = function(api, id, obj) {
    if (!api) throw new Error("WebStorage not available.");
    var rval;
    if (obj === null) rval = api.removeItem(id);
    else {
        // json-encode and base64-encode object
        obj = $270b4b57bda3418f$var$util.encode64(JSON.stringify(obj));
        rval = api.setItem(id, obj);
    }
    // handle potential flash error
    if (typeof rval !== "undefined" && rval.rval !== true) {
        var error = new Error(rval.error.message);
        error.id = rval.error.id;
        error.name = rval.error.name;
        throw error;
    }
};
/**
 * Gets a storage object.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 *
 * @return the storage object entry or null if none exists.
 */ var $270b4b57bda3418f$var$_getStorageObject = function(api, id) {
    if (!api) throw new Error("WebStorage not available.");
    // get the existing entry
    var rval = api.getItem(id);
    /* Note: We check api.init because we can't do (api == localStorage)
    on IE because of "Class doesn't support Automation" exception. Only
    the flash api has an init method so this works too, but we need a
    better solution in the future. */ // flash returns item wrapped in an object, handle special case
    if (api.init) {
        if (rval.rval === null) {
            if (rval.error) {
                var error = new Error(rval.error.message);
                error.id = rval.error.id;
                error.name = rval.error.name;
                throw error;
            }
            // no error, but also no item
            rval = null;
        } else rval = rval.rval;
    }
    // handle decoding
    if (rval !== null) // base64-decode and json-decode data
    rval = JSON.parse($270b4b57bda3418f$var$util.decode64(rval));
    return rval;
};
/**
 * Stores an item in local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param data the data for the item (any javascript object/primitive).
 */ var $270b4b57bda3418f$var$_setItem = function(api, id, key, data) {
    // get storage object
    var obj = $270b4b57bda3418f$var$_getStorageObject(api, id);
    if (obj === null) // create a new storage object
    obj = {};
    // update key
    obj[key] = data;
    // set storage object
    $270b4b57bda3418f$var$_setStorageObject(api, id, obj);
};
/**
 * Gets an item from local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 *
 * @return the item.
 */ var $270b4b57bda3418f$var$_getItem = function(api, id, key) {
    // get storage object
    var rval = $270b4b57bda3418f$var$_getStorageObject(api, id);
    if (rval !== null) // return data at key
    rval = key in rval ? rval[key] : null;
    return rval;
};
/**
 * Removes an item from local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 */ var $270b4b57bda3418f$var$_removeItem = function(api, id, key) {
    // get storage object
    var obj = $270b4b57bda3418f$var$_getStorageObject(api, id);
    if (obj !== null && key in obj) {
        // remove key
        delete obj[key];
        // see if entry has no keys remaining
        var empty = true;
        for(var prop in obj){
            empty = false;
            break;
        }
        if (empty) // remove entry entirely if no keys are left
        obj = null;
        // set storage object
        $270b4b57bda3418f$var$_setStorageObject(api, id, obj);
    }
};
/**
 * Clears the local disk storage identified by the given ID.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 */ var $270b4b57bda3418f$var$_clearItems = function(api, id) {
    $270b4b57bda3418f$var$_setStorageObject(api, id, null);
};
/**
 * Calls a storage function.
 *
 * @param func the function to call.
 * @param args the arguments for the function.
 * @param location the location argument.
 *
 * @return the return value from the function.
 */ var $270b4b57bda3418f$var$_callStorageFunction = function(func, args, location) {
    var rval = null;
    // default storage types
    if (typeof location === "undefined") location = [
        "web",
        "flash"
    ];
    // apply storage types in order of preference
    var type;
    var done = false;
    var exception = null;
    for(var idx in location){
        type = location[idx];
        try {
            if (type === "flash" || type === "both") {
                if (args[0] === null) throw new Error("Flash local storage not available.");
                rval = func.apply(this, args);
                done = type === "flash";
            }
            if (type === "web" || type === "both") {
                args[0] = localStorage;
                rval = func.apply(this, args);
                done = true;
            }
        } catch (ex) {
            exception = ex;
        }
        if (done) break;
    }
    if (!done) throw exception;
    return rval;
};
/**
 * Stores an item on local disk.
 *
 * The available types of local storage include 'flash', 'web', and 'both'.
 *
 * The type 'flash' refers to flash local storage (SharedObject). In order
 * to use flash local storage, the 'api' parameter must be valid. The type
 * 'web' refers to WebStorage, if supported by the browser. The type 'both'
 * refers to storing using both 'flash' and 'web', not just one or the
 * other.
 *
 * The location array should list the storage types to use in order of
 * preference:
 *
 * ['flash']: flash only storage
 * ['web']: web only storage
 * ['both']: try to store in both
 * ['flash','web']: store in flash first, but if not available, 'web'
 * ['web','flash']: store in web first, but if not available, 'flash'
 *
 * The location array defaults to: ['web', 'flash']
 *
 * @param api the flash interface, null to use only WebStorage.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param data the data for the item (any javascript object/primitive).
 * @param location an array with the preferred types of storage to use.
 */ $270b4b57bda3418f$var$util.setItem = function(api, id, key, data, location) {
    $270b4b57bda3418f$var$_callStorageFunction($270b4b57bda3418f$var$_setItem, arguments, location);
};
/**
 * Gets an item on local disk.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface, null to use only WebStorage.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param location an array with the preferred types of storage to use.
 *
 * @return the item.
 */ $270b4b57bda3418f$var$util.getItem = function(api, id, key, location) {
    return $270b4b57bda3418f$var$_callStorageFunction($270b4b57bda3418f$var$_getItem, arguments, location);
};
/**
 * Removes an item on local disk.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param location an array with the preferred types of storage to use.
 */ $270b4b57bda3418f$var$util.removeItem = function(api, id, key, location) {
    $270b4b57bda3418f$var$_callStorageFunction($270b4b57bda3418f$var$_removeItem, arguments, location);
};
/**
 * Clears the local disk storage identified by the given ID.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface if flash is available.
 * @param id the storage ID to use.
 * @param location an array with the preferred types of storage to use.
 */ $270b4b57bda3418f$var$util.clearItems = function(api, id, location) {
    $270b4b57bda3418f$var$_callStorageFunction($270b4b57bda3418f$var$_clearItems, arguments, location);
};
/**
 * Check if an object is empty.
 *
 * Taken from:
 * http://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object-from-json/679937#679937
 *
 * @param object the object to check.
 */ $270b4b57bda3418f$var$util.isEmpty = function(obj) {
    for(var prop in obj){
        if (obj.hasOwnProperty(prop)) return false;
    }
    return true;
};
/**
 * Format with simple printf-style interpolation.
 *
 * %%: literal '%'
 * %s,%o: convert next argument into a string.
 *
 * @param format the string to format.
 * @param ... arguments to interpolate into the format string.
 */ $270b4b57bda3418f$var$util.format = function(format) {
    var re = /%./g;
    // current match
    var match;
    // current part
    var part;
    // current arg index
    var argi = 0;
    // collected parts to recombine later
    var parts = [];
    // last index found
    var last = 0;
    // loop while matches remain
    while(match = re.exec(format)){
        part = format.substring(last, re.lastIndex - 2);
        // don't add empty strings (ie, parts between %s%s)
        if (part.length > 0) parts.push(part);
        last = re.lastIndex;
        // switch on % code
        var code = match[0][1];
        switch(code){
            case "s":
            case "o":
                // check if enough arguments were given
                if (argi < arguments.length) parts.push(arguments[argi++ + 1]);
                else parts.push("<?>");
                break;
            // FIXME: do proper formatting for numbers, etc
            //case 'f':
            //case 'd':
            case "%":
                parts.push("%");
                break;
            default:
                parts.push("<%" + code + "?>");
        }
    }
    // add trailing part of format string
    parts.push(format.substring(last));
    return parts.join("");
};
/**
 * Formats a number.
 *
 * http://snipplr.com/view/5945/javascript-numberformat--ported-from-php/
 */ $270b4b57bda3418f$var$util.formatNumber = function(number, decimals, dec_point, thousands_sep) {
    // http://kevin.vanzonneveld.net
    // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +     bugfix by: Michael White (http://crestidg.com)
    // +     bugfix by: Benjamin Lupton
    // +     bugfix by: Allan Jensen (http://www.winternet.no)
    // +    revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // *     example 1: number_format(1234.5678, 2, '.', '');
    // *     returns 1: 1234.57
    var n = number, c = isNaN(decimals = Math.abs(decimals)) ? 2 : decimals;
    var d = dec_point === undefined ? "," : dec_point;
    var t = thousands_sep === undefined ? "." : thousands_sep, s = n < 0 ? "-" : "";
    var i = parseInt(n = Math.abs(+n || 0).toFixed(c), 10) + "";
    var j = i.length > 3 ? i.length % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};
/**
 * Formats a byte size.
 *
 * http://snipplr.com/view/5949/format-humanize-file-byte-size-presentation-in-javascript/
 */ $270b4b57bda3418f$var$util.formatSize = function(size) {
    if (size >= 1073741824) size = $270b4b57bda3418f$var$util.formatNumber(size / 1073741824, 2, ".", "") + " GiB";
    else if (size >= 1048576) size = $270b4b57bda3418f$var$util.formatNumber(size / 1048576, 2, ".", "") + " MiB";
    else if (size >= 1024) size = $270b4b57bda3418f$var$util.formatNumber(size / 1024, 0) + " KiB";
    else size = $270b4b57bda3418f$var$util.formatNumber(size, 0) + " bytes";
    return size;
};
/**
 * Converts an IPv4 or IPv6 string representation into bytes (in network order).
 *
 * @param ip the IPv4 or IPv6 address to convert.
 *
 * @return the 4-byte IPv6 or 16-byte IPv6 address or null if the address can't
 *         be parsed.
 */ $270b4b57bda3418f$var$util.bytesFromIP = function(ip) {
    if (ip.indexOf(".") !== -1) return $270b4b57bda3418f$var$util.bytesFromIPv4(ip);
    if (ip.indexOf(":") !== -1) return $270b4b57bda3418f$var$util.bytesFromIPv6(ip);
    return null;
};
/**
 * Converts an IPv4 string representation into bytes (in network order).
 *
 * @param ip the IPv4 address to convert.
 *
 * @return the 4-byte address or null if the address can't be parsed.
 */ $270b4b57bda3418f$var$util.bytesFromIPv4 = function(ip) {
    ip = ip.split(".");
    if (ip.length !== 4) return null;
    var b = $270b4b57bda3418f$var$util.createBuffer();
    for(var i = 0; i < ip.length; ++i){
        var num = parseInt(ip[i], 10);
        if (isNaN(num)) return null;
        b.putByte(num);
    }
    return b.getBytes();
};
/**
 * Converts an IPv6 string representation into bytes (in network order).
 *
 * @param ip the IPv6 address to convert.
 *
 * @return the 16-byte address or null if the address can't be parsed.
 */ $270b4b57bda3418f$var$util.bytesFromIPv6 = function(ip) {
    var blanks = 0;
    ip = ip.split(":").filter(function(e) {
        if (e.length === 0) ++blanks;
        return true;
    });
    var zeros = (8 - ip.length + blanks) * 2;
    var b = $270b4b57bda3418f$var$util.createBuffer();
    for(var i = 0; i < 8; ++i){
        if (!ip[i] || ip[i].length === 0) {
            b.fillWithByte(0, zeros);
            zeros = 0;
            continue;
        }
        var bytes = $270b4b57bda3418f$var$util.hexToBytes(ip[i]);
        if (bytes.length < 2) b.putByte(0);
        b.putBytes(bytes);
    }
    return b.getBytes();
};
/**
 * Converts 4-bytes into an IPv4 string representation or 16-bytes into
 * an IPv6 string representation. The bytes must be in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv4 or IPv6 string representation if 4 or 16 bytes,
 *         respectively, are given, otherwise null.
 */ $270b4b57bda3418f$var$util.bytesToIP = function(bytes) {
    if (bytes.length === 4) return $270b4b57bda3418f$var$util.bytesToIPv4(bytes);
    if (bytes.length === 16) return $270b4b57bda3418f$var$util.bytesToIPv6(bytes);
    return null;
};
/**
 * Converts 4-bytes into an IPv4 string representation. The bytes must be
 * in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv4 string representation or null for an invalid # of bytes.
 */ $270b4b57bda3418f$var$util.bytesToIPv4 = function(bytes) {
    if (bytes.length !== 4) return null;
    var ip = [];
    for(var i = 0; i < bytes.length; ++i)ip.push(bytes.charCodeAt(i));
    return ip.join(".");
};
/**
 * Converts 16-bytes into an IPv16 string representation. The bytes must be
 * in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv16 string representation or null for an invalid # of bytes.
 */ $270b4b57bda3418f$var$util.bytesToIPv6 = function(bytes) {
    if (bytes.length !== 16) return null;
    var ip = [];
    var zeroGroups = [];
    var zeroMaxGroup = 0;
    for(var i = 0; i < bytes.length; i += 2){
        var hex = $270b4b57bda3418f$var$util.bytesToHex(bytes[i] + bytes[i + 1]);
        // canonicalize zero representation
        while(hex[0] === "0" && hex !== "0")hex = hex.substr(1);
        if (hex === "0") {
            var last = zeroGroups[zeroGroups.length - 1];
            var idx = ip.length;
            if (!last || idx !== last.end + 1) zeroGroups.push({
                start: idx,
                end: idx
            });
            else {
                last.end = idx;
                if (last.end - last.start > zeroGroups[zeroMaxGroup].end - zeroGroups[zeroMaxGroup].start) zeroMaxGroup = zeroGroups.length - 1;
            }
        }
        ip.push(hex);
    }
    if (zeroGroups.length > 0) {
        var group = zeroGroups[zeroMaxGroup];
        // only shorten group of length > 0
        if (group.end - group.start > 0) {
            ip.splice(group.start, group.end - group.start + 1, "");
            if (group.start === 0) ip.unshift("");
            if (group.end === 7) ip.push("");
        }
    }
    return ip.join(":");
};
/**
 * Estimates the number of processes that can be run concurrently. If
 * creating Web Workers, keep in mind that the main JavaScript process needs
 * its own core.
 *
 * @param options the options to use:
 *          update true to force an update (not use the cached value).
 * @param callback(err, max) called once the operation completes.
 */ $270b4b57bda3418f$var$util.estimateCores = function(options, callback) {
    if (typeof options === "function") {
        callback = options;
        options = {};
    }
    options = options || {};
    if ("cores" in $270b4b57bda3418f$var$util && !options.update) return callback(null, $270b4b57bda3418f$var$util.cores);
    if (typeof navigator !== "undefined" && "hardwareConcurrency" in navigator && navigator.hardwareConcurrency > 0) {
        $270b4b57bda3418f$var$util.cores = navigator.hardwareConcurrency;
        return callback(null, $270b4b57bda3418f$var$util.cores);
    }
    if (typeof Worker === "undefined") {
        // workers not available
        $270b4b57bda3418f$var$util.cores = 1;
        return callback(null, $270b4b57bda3418f$var$util.cores);
    }
    if (typeof Blob === "undefined") {
        // can't estimate, default to 2
        $270b4b57bda3418f$var$util.cores = 2;
        return callback(null, $270b4b57bda3418f$var$util.cores);
    }
    // create worker concurrency estimation code as blob
    var blobUrl = URL.createObjectURL(new Blob([
        "(",
        (function() {
            self.addEventListener("message", function(e) {
                // run worker for 4 ms
                var st = Date.now();
                var et = st + 4;
                while(Date.now() < et);
                self.postMessage({
                    st: st,
                    et: et
                });
            });
        }).toString(),
        ")()"
    ], {
        type: "application/javascript"
    }));
    // take 5 samples using 16 workers
    sample([], 5, 16);
    function sample(max, samples, numWorkers) {
        if (samples === 0) {
            // get overlap average
            var avg = Math.floor(max.reduce(function(avg, x) {
                return avg + x;
            }, 0) / max.length);
            $270b4b57bda3418f$var$util.cores = Math.max(1, avg);
            URL.revokeObjectURL(blobUrl);
            return callback(null, $270b4b57bda3418f$var$util.cores);
        }
        map(numWorkers, function(err, results) {
            max.push(reduce(numWorkers, results));
            sample(max, samples - 1, numWorkers);
        });
    }
    function map(numWorkers, callback) {
        var workers = [];
        var results = [];
        for(var i = 0; i < numWorkers; ++i){
            var worker = new Worker(blobUrl);
            worker.addEventListener("message", function(e) {
                results.push(e.data);
                if (results.length === numWorkers) {
                    for(var i = 0; i < numWorkers; ++i)workers[i].terminate();
                    callback(null, results);
                }
            });
            workers.push(worker);
        }
        for(var i = 0; i < numWorkers; ++i)workers[i].postMessage(i);
    }
    function reduce(numWorkers, results) {
        // find overlapping time windows
        var overlaps = [];
        for(var n = 0; n < numWorkers; ++n){
            var r1 = results[n];
            var overlap = overlaps[n] = [];
            for(var i = 0; i < numWorkers; ++i){
                if (n === i) continue;
                var r2 = results[i];
                if (r1.st > r2.st && r1.st < r2.et || r2.st > r1.st && r2.st < r1.et) overlap.push(i);
            }
        }
        // get maximum overlaps ... don't include overlapping worker itself
        // as the main JS process was also being scheduled during the work and
        // would have to be subtracted from the estimate anyway
        return overlaps.reduce(function(max, overlap) {
            return Math.max(max, overlap.length);
        }, 0);
    }
};

});
parcelRequire.register("7jzxY", function(module, exports) {
"use strict";

});

parcelRequire.register("iF7DX", function(module, exports) {
/**
 * Base-N/Base-X encoding/decoding functions.
 *
 * Original implementation from base-x:
 * https://github.com/cryptocoinjs/base-x
 *
 * Which is MIT licensed:
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ 
var $7jzxY = parcelRequire("7jzxY");
var $d961fc23b1ee864a$require$Buffer = $7jzxY.Buffer;
var $d961fc23b1ee864a$var$api = {};
module.exports = $d961fc23b1ee864a$var$api;
// baseN alphabet indexes
var $d961fc23b1ee864a$var$_reverseAlphabets = {};
/**
 * BaseN-encodes a Uint8Array using the given alphabet.
 *
 * @param input the Uint8Array to encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the baseN-encoded output string.
 */ $d961fc23b1ee864a$var$api.encode = function(input, alphabet, maxline) {
    if (typeof alphabet !== "string") throw new TypeError('"alphabet" must be a string.');
    if (maxline !== undefined && typeof maxline !== "number") throw new TypeError('"maxline" must be a number.');
    var output = "";
    if (!(input instanceof Uint8Array)) // assume forge byte buffer
    output = $d961fc23b1ee864a$var$_encodeWithByteBuffer(input, alphabet);
    else {
        var i = 0;
        var base = alphabet.length;
        var first = alphabet.charAt(0);
        var digits = [
            0
        ];
        for(i = 0; i < input.length; ++i){
            for(var j = 0, carry = input[i]; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % base;
                carry = carry / base | 0;
            }
            while(carry > 0){
                digits.push(carry % base);
                carry = carry / base | 0;
            }
        }
        // deal with leading zeros
        for(i = 0; input[i] === 0 && i < input.length - 1; ++i)output += first;
        // convert digits to a string
        for(i = digits.length - 1; i >= 0; --i)output += alphabet[digits[i]];
    }
    if (maxline) {
        var regex = new RegExp(".{1," + maxline + "}", "g");
        output = output.match(regex).join("\r\n");
    }
    return output;
};
/**
 * Decodes a baseN-encoded (using the given alphabet) string to a
 * Uint8Array.
 *
 * @param input the baseN-encoded input string.
 *
 * @return the Uint8Array.
 */ $d961fc23b1ee864a$var$api.decode = function(input, alphabet) {
    if (typeof input !== "string") throw new TypeError('"input" must be a string.');
    if (typeof alphabet !== "string") throw new TypeError('"alphabet" must be a string.');
    var table = $d961fc23b1ee864a$var$_reverseAlphabets[alphabet];
    if (!table) {
        // compute reverse alphabet
        table = $d961fc23b1ee864a$var$_reverseAlphabets[alphabet] = [];
        for(var i = 0; i < alphabet.length; ++i)table[alphabet.charCodeAt(i)] = i;
    }
    // remove whitespace characters
    input = input.replace(/\s/g, "");
    var base = alphabet.length;
    var first = alphabet.charAt(0);
    var bytes = [
        0
    ];
    for(var i = 0; i < input.length; i++){
        var value = table[input.charCodeAt(i)];
        if (value === undefined) return;
        for(var j = 0, carry = value; j < bytes.length; ++j){
            carry += bytes[j] * base;
            bytes[j] = carry & 0xff;
            carry >>= 8;
        }
        while(carry > 0){
            bytes.push(carry & 0xff);
            carry >>= 8;
        }
    }
    // deal with leading zeros
    for(var k = 0; input[k] === first && k < input.length - 1; ++k)bytes.push(0);
    if (typeof $d961fc23b1ee864a$require$Buffer !== "undefined") return $d961fc23b1ee864a$require$Buffer.from(bytes.reverse());
    return new Uint8Array(bytes.reverse());
};
function $d961fc23b1ee864a$var$_encodeWithByteBuffer(input, alphabet) {
    var i = 0;
    var base = alphabet.length;
    var first = alphabet.charAt(0);
    var digits = [
        0
    ];
    for(i = 0; i < input.length(); ++i){
        for(var j = 0, carry = input.at(i); j < digits.length; ++j){
            carry += digits[j] << 8;
            digits[j] = carry % base;
            carry = carry / base | 0;
        }
        while(carry > 0){
            digits.push(carry % base);
            carry = carry / base | 0;
        }
    }
    var output = "";
    // deal with leading zeros
    for(i = 0; input.at(i) === 0 && i < input.length() - 1; ++i)output += first;
    // convert digits to a string
    for(i = digits.length - 1; i >= 0; --i)output += alphabet[digits[i]];
    return output;
}

});


parcelRequire.register("inNg9", function(module, exports) {
/**
 * Object IDs for ASN.1.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 */ 
var $hSPkV = parcelRequire("hSPkV");
$hSPkV.pki = $hSPkV.pki || {};
var $d62095e3d1e5d91d$var$oids = module.exports = $hSPkV.pki.oids = $hSPkV.oids = $hSPkV.oids || {};
// set id to name mapping and name to id mapping
function $d62095e3d1e5d91d$var$_IN(id, name) {
    $d62095e3d1e5d91d$var$oids[id] = name;
    $d62095e3d1e5d91d$var$oids[name] = id;
}
// set id to name mapping only
function $d62095e3d1e5d91d$var$_I_(id, name) {
    $d62095e3d1e5d91d$var$oids[id] = name;
}
// algorithm OIDs
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.1.1", "rsaEncryption");
// Note: md2 & md4 not implemented
//_IN('1.2.840.113549.1.1.2', 'md2WithRSAEncryption');
//_IN('1.2.840.113549.1.1.3', 'md4WithRSAEncryption');
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.1.4", "md5WithRSAEncryption");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.1.5", "sha1WithRSAEncryption");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.1.7", "RSAES-OAEP");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.1.8", "mgf1");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.1.9", "pSpecified");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.1.10", "RSASSA-PSS");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.1.11", "sha256WithRSAEncryption");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.1.12", "sha384WithRSAEncryption");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.1.13", "sha512WithRSAEncryption");
// Edwards-curve Digital Signature Algorithm (EdDSA) Ed25519
$d62095e3d1e5d91d$var$_IN("1.3.101.112", "EdDSA25519");
$d62095e3d1e5d91d$var$_IN("1.2.840.10040.4.3", "dsa-with-sha1");
$d62095e3d1e5d91d$var$_IN("1.3.14.3.2.7", "desCBC");
$d62095e3d1e5d91d$var$_IN("1.3.14.3.2.26", "sha1");
// Deprecated equivalent of sha1WithRSAEncryption
$d62095e3d1e5d91d$var$_IN("1.3.14.3.2.29", "sha1WithRSASignature");
$d62095e3d1e5d91d$var$_IN("2.16.840.1.101.3.4.2.1", "sha256");
$d62095e3d1e5d91d$var$_IN("2.16.840.1.101.3.4.2.2", "sha384");
$d62095e3d1e5d91d$var$_IN("2.16.840.1.101.3.4.2.3", "sha512");
$d62095e3d1e5d91d$var$_IN("2.16.840.1.101.3.4.2.4", "sha224");
$d62095e3d1e5d91d$var$_IN("2.16.840.1.101.3.4.2.5", "sha512-224");
$d62095e3d1e5d91d$var$_IN("2.16.840.1.101.3.4.2.6", "sha512-256");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.2.2", "md2");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.2.5", "md5");
// pkcs#7 content types
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.7.1", "data");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.7.2", "signedData");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.7.3", "envelopedData");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.7.4", "signedAndEnvelopedData");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.7.5", "digestedData");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.7.6", "encryptedData");
// pkcs#9 oids
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.9.1", "emailAddress");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.9.2", "unstructuredName");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.9.3", "contentType");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.9.4", "messageDigest");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.9.5", "signingTime");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.9.6", "counterSignature");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.9.7", "challengePassword");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.9.8", "unstructuredAddress");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.9.14", "extensionRequest");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.9.20", "friendlyName");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.9.21", "localKeyId");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.9.22.1", "x509Certificate");
// pkcs#12 safe bags
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.12.10.1.1", "keyBag");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.12.10.1.2", "pkcs8ShroudedKeyBag");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.12.10.1.3", "certBag");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.12.10.1.4", "crlBag");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.12.10.1.5", "secretBag");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.12.10.1.6", "safeContentsBag");
// password-based-encryption for pkcs#12
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.5.13", "pkcs5PBES2");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.5.12", "pkcs5PBKDF2");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.12.1.1", "pbeWithSHAAnd128BitRC4");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.12.1.2", "pbeWithSHAAnd40BitRC4");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.12.1.3", "pbeWithSHAAnd3-KeyTripleDES-CBC");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.12.1.4", "pbeWithSHAAnd2-KeyTripleDES-CBC");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.12.1.5", "pbeWithSHAAnd128BitRC2-CBC");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.1.12.1.6", "pbewithSHAAnd40BitRC2-CBC");
// hmac OIDs
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.2.7", "hmacWithSHA1");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.2.8", "hmacWithSHA224");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.2.9", "hmacWithSHA256");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.2.10", "hmacWithSHA384");
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.2.11", "hmacWithSHA512");
// symmetric key algorithm oids
$d62095e3d1e5d91d$var$_IN("1.2.840.113549.3.7", "des-EDE3-CBC");
$d62095e3d1e5d91d$var$_IN("2.16.840.1.101.3.4.1.2", "aes128-CBC");
$d62095e3d1e5d91d$var$_IN("2.16.840.1.101.3.4.1.22", "aes192-CBC");
$d62095e3d1e5d91d$var$_IN("2.16.840.1.101.3.4.1.42", "aes256-CBC");
// certificate issuer/subject OIDs
$d62095e3d1e5d91d$var$_IN("2.5.4.3", "commonName");
$d62095e3d1e5d91d$var$_IN("2.5.4.4", "surname");
$d62095e3d1e5d91d$var$_IN("2.5.4.5", "serialNumber");
$d62095e3d1e5d91d$var$_IN("2.5.4.6", "countryName");
$d62095e3d1e5d91d$var$_IN("2.5.4.7", "localityName");
$d62095e3d1e5d91d$var$_IN("2.5.4.8", "stateOrProvinceName");
$d62095e3d1e5d91d$var$_IN("2.5.4.9", "streetAddress");
$d62095e3d1e5d91d$var$_IN("2.5.4.10", "organizationName");
$d62095e3d1e5d91d$var$_IN("2.5.4.11", "organizationalUnitName");
$d62095e3d1e5d91d$var$_IN("2.5.4.12", "title");
$d62095e3d1e5d91d$var$_IN("2.5.4.13", "description");
$d62095e3d1e5d91d$var$_IN("2.5.4.15", "businessCategory");
$d62095e3d1e5d91d$var$_IN("2.5.4.17", "postalCode");
$d62095e3d1e5d91d$var$_IN("2.5.4.42", "givenName");
$d62095e3d1e5d91d$var$_IN("2.5.4.65", "pseudonym");
$d62095e3d1e5d91d$var$_IN("1.3.6.1.4.1.311.60.2.1.2", "jurisdictionOfIncorporationStateOrProvinceName");
$d62095e3d1e5d91d$var$_IN("1.3.6.1.4.1.311.60.2.1.3", "jurisdictionOfIncorporationCountryName");
// X.509 extension OIDs
$d62095e3d1e5d91d$var$_IN("2.16.840.1.113730.1.1", "nsCertType");
$d62095e3d1e5d91d$var$_IN("2.16.840.1.113730.1.13", "nsComment"); // deprecated in theory; still widely used
$d62095e3d1e5d91d$var$_I_("2.5.29.1", "authorityKeyIdentifier"); // deprecated, use .35
$d62095e3d1e5d91d$var$_I_("2.5.29.2", "keyAttributes"); // obsolete use .37 or .15
$d62095e3d1e5d91d$var$_I_("2.5.29.3", "certificatePolicies"); // deprecated, use .32
$d62095e3d1e5d91d$var$_I_("2.5.29.4", "keyUsageRestriction"); // obsolete use .37 or .15
$d62095e3d1e5d91d$var$_I_("2.5.29.5", "policyMapping"); // deprecated use .33
$d62095e3d1e5d91d$var$_I_("2.5.29.6", "subtreesConstraint"); // obsolete use .30
$d62095e3d1e5d91d$var$_I_("2.5.29.7", "subjectAltName"); // deprecated use .17
$d62095e3d1e5d91d$var$_I_("2.5.29.8", "issuerAltName"); // deprecated use .18
$d62095e3d1e5d91d$var$_I_("2.5.29.9", "subjectDirectoryAttributes");
$d62095e3d1e5d91d$var$_I_("2.5.29.10", "basicConstraints"); // deprecated use .19
$d62095e3d1e5d91d$var$_I_("2.5.29.11", "nameConstraints"); // deprecated use .30
$d62095e3d1e5d91d$var$_I_("2.5.29.12", "policyConstraints"); // deprecated use .36
$d62095e3d1e5d91d$var$_I_("2.5.29.13", "basicConstraints"); // deprecated use .19
$d62095e3d1e5d91d$var$_IN("2.5.29.14", "subjectKeyIdentifier");
$d62095e3d1e5d91d$var$_IN("2.5.29.15", "keyUsage");
$d62095e3d1e5d91d$var$_I_("2.5.29.16", "privateKeyUsagePeriod");
$d62095e3d1e5d91d$var$_IN("2.5.29.17", "subjectAltName");
$d62095e3d1e5d91d$var$_IN("2.5.29.18", "issuerAltName");
$d62095e3d1e5d91d$var$_IN("2.5.29.19", "basicConstraints");
$d62095e3d1e5d91d$var$_I_("2.5.29.20", "cRLNumber");
$d62095e3d1e5d91d$var$_I_("2.5.29.21", "cRLReason");
$d62095e3d1e5d91d$var$_I_("2.5.29.22", "expirationDate");
$d62095e3d1e5d91d$var$_I_("2.5.29.23", "instructionCode");
$d62095e3d1e5d91d$var$_I_("2.5.29.24", "invalidityDate");
$d62095e3d1e5d91d$var$_I_("2.5.29.25", "cRLDistributionPoints"); // deprecated use .31
$d62095e3d1e5d91d$var$_I_("2.5.29.26", "issuingDistributionPoint"); // deprecated use .28
$d62095e3d1e5d91d$var$_I_("2.5.29.27", "deltaCRLIndicator");
$d62095e3d1e5d91d$var$_I_("2.5.29.28", "issuingDistributionPoint");
$d62095e3d1e5d91d$var$_I_("2.5.29.29", "certificateIssuer");
$d62095e3d1e5d91d$var$_I_("2.5.29.30", "nameConstraints");
$d62095e3d1e5d91d$var$_IN("2.5.29.31", "cRLDistributionPoints");
$d62095e3d1e5d91d$var$_IN("2.5.29.32", "certificatePolicies");
$d62095e3d1e5d91d$var$_I_("2.5.29.33", "policyMappings");
$d62095e3d1e5d91d$var$_I_("2.5.29.34", "policyConstraints"); // deprecated use .36
$d62095e3d1e5d91d$var$_IN("2.5.29.35", "authorityKeyIdentifier");
$d62095e3d1e5d91d$var$_I_("2.5.29.36", "policyConstraints");
$d62095e3d1e5d91d$var$_IN("2.5.29.37", "extKeyUsage");
$d62095e3d1e5d91d$var$_I_("2.5.29.46", "freshestCRL");
$d62095e3d1e5d91d$var$_I_("2.5.29.54", "inhibitAnyPolicy");
// extKeyUsage purposes
$d62095e3d1e5d91d$var$_IN("1.3.6.1.4.1.11129.2.4.2", "timestampList");
$d62095e3d1e5d91d$var$_IN("1.3.6.1.5.5.7.1.1", "authorityInfoAccess");
$d62095e3d1e5d91d$var$_IN("1.3.6.1.5.5.7.3.1", "serverAuth");
$d62095e3d1e5d91d$var$_IN("1.3.6.1.5.5.7.3.2", "clientAuth");
$d62095e3d1e5d91d$var$_IN("1.3.6.1.5.5.7.3.3", "codeSigning");
$d62095e3d1e5d91d$var$_IN("1.3.6.1.5.5.7.3.4", "emailProtection");
$d62095e3d1e5d91d$var$_IN("1.3.6.1.5.5.7.3.8", "timeStamping");

});


parcelRequire.register("40sm5", function(module, exports) {
/**
 * Password-based encryption functions.
 *
 * @author Dave Longley
 * @author Stefan Siegl <stesie@brokenpipe.de>
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * An EncryptedPrivateKeyInfo:
 *
 * EncryptedPrivateKeyInfo ::= SEQUENCE {
 *   encryptionAlgorithm  EncryptionAlgorithmIdentifier,
 *   encryptedData        EncryptedData }
 *
 * EncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
 *
 * EncryptedData ::= OCTET STRING
 */ 
var $hSPkV = parcelRequire("hSPkV");
parcelRequire("8ju3Y");
parcelRequire("ehQqu");
parcelRequire("5i9iX");
parcelRequire("jCulq");
parcelRequire("inNg9");
parcelRequire("6mmjF");
parcelRequire("954gi");
parcelRequire("eJAQ9");
parcelRequire("c6w1L");
parcelRequire("9Je9a");
parcelRequire("3lPw4");
if (typeof $2ead283f9cfaa956$var$BigInteger === "undefined") var $2ead283f9cfaa956$var$BigInteger = $hSPkV.jsbn.BigInteger;
// shortcut for asn.1 API
var $2ead283f9cfaa956$var$asn1 = $hSPkV.asn1;
/* Password-based encryption implementation. */ var $2ead283f9cfaa956$var$pki = $hSPkV.pki = $hSPkV.pki || {};
module.exports = $2ead283f9cfaa956$var$pki.pbe = $hSPkV.pbe = $hSPkV.pbe || {};
var $2ead283f9cfaa956$var$oids = $2ead283f9cfaa956$var$pki.oids;
// validator for an EncryptedPrivateKeyInfo structure
// Note: Currently only works w/algorithm params
var $2ead283f9cfaa956$var$encryptedPrivateKeyValidator = {
    name: "EncryptedPrivateKeyInfo",
    tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
    type: $2ead283f9cfaa956$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "EncryptedPrivateKeyInfo.encryptionAlgorithm",
            tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
            type: $2ead283f9cfaa956$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
                    type: $2ead283f9cfaa956$var$asn1.Type.OID,
                    constructed: false,
                    capture: "encryptionOid"
                },
                {
                    name: "AlgorithmIdentifier.parameters",
                    tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
                    type: $2ead283f9cfaa956$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "encryptionParams"
                }
            ]
        },
        {
            // encryptedData
            name: "EncryptedPrivateKeyInfo.encryptedData",
            tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
            type: $2ead283f9cfaa956$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "encryptedData"
        }
    ]
};
// validator for a PBES2Algorithms structure
// Note: Currently only works w/PBKDF2 + AES encryption schemes
var $2ead283f9cfaa956$var$PBES2AlgorithmsValidator = {
    name: "PBES2Algorithms",
    tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
    type: $2ead283f9cfaa956$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "PBES2Algorithms.keyDerivationFunc",
            tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
            type: $2ead283f9cfaa956$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "PBES2Algorithms.keyDerivationFunc.oid",
                    tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
                    type: $2ead283f9cfaa956$var$asn1.Type.OID,
                    constructed: false,
                    capture: "kdfOid"
                },
                {
                    name: "PBES2Algorithms.params",
                    tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
                    type: $2ead283f9cfaa956$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: "PBES2Algorithms.params.salt",
                            tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
                            type: $2ead283f9cfaa956$var$asn1.Type.OCTETSTRING,
                            constructed: false,
                            capture: "kdfSalt"
                        },
                        {
                            name: "PBES2Algorithms.params.iterationCount",
                            tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
                            type: $2ead283f9cfaa956$var$asn1.Type.INTEGER,
                            constructed: false,
                            capture: "kdfIterationCount"
                        },
                        {
                            name: "PBES2Algorithms.params.keyLength",
                            tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
                            type: $2ead283f9cfaa956$var$asn1.Type.INTEGER,
                            constructed: false,
                            optional: true,
                            capture: "keyLength"
                        },
                        {
                            // prf
                            name: "PBES2Algorithms.params.prf",
                            tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
                            type: $2ead283f9cfaa956$var$asn1.Type.SEQUENCE,
                            constructed: true,
                            optional: true,
                            value: [
                                {
                                    name: "PBES2Algorithms.params.prf.algorithm",
                                    tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
                                    type: $2ead283f9cfaa956$var$asn1.Type.OID,
                                    constructed: false,
                                    capture: "prfOid"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            name: "PBES2Algorithms.encryptionScheme",
            tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
            type: $2ead283f9cfaa956$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "PBES2Algorithms.encryptionScheme.oid",
                    tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
                    type: $2ead283f9cfaa956$var$asn1.Type.OID,
                    constructed: false,
                    capture: "encOid"
                },
                {
                    name: "PBES2Algorithms.encryptionScheme.iv",
                    tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
                    type: $2ead283f9cfaa956$var$asn1.Type.OCTETSTRING,
                    constructed: false,
                    capture: "encIv"
                }
            ]
        }
    ]
};
var $2ead283f9cfaa956$var$pkcs12PbeParamsValidator = {
    name: "pkcs-12PbeParams",
    tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
    type: $2ead283f9cfaa956$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "pkcs-12PbeParams.salt",
            tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
            type: $2ead283f9cfaa956$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "salt"
        },
        {
            name: "pkcs-12PbeParams.iterations",
            tagClass: $2ead283f9cfaa956$var$asn1.Class.UNIVERSAL,
            type: $2ead283f9cfaa956$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "iterations"
        }
    ]
};
/**
 * Encrypts a ASN.1 PrivateKeyInfo object, producing an EncryptedPrivateKeyInfo.
 *
 * PBES2Algorithms ALGORITHM-IDENTIFIER ::=
 *   { {PBES2-params IDENTIFIED BY id-PBES2}, ...}
 *
 * id-PBES2 OBJECT IDENTIFIER ::= {pkcs-5 13}
 *
 * PBES2-params ::= SEQUENCE {
 *   keyDerivationFunc AlgorithmIdentifier {{PBES2-KDFs}},
 *   encryptionScheme AlgorithmIdentifier {{PBES2-Encs}}
 * }
 *
 * PBES2-KDFs ALGORITHM-IDENTIFIER ::=
 *   { {PBKDF2-params IDENTIFIED BY id-PBKDF2}, ... }
 *
 * PBES2-Encs ALGORITHM-IDENTIFIER ::= { ... }
 *
 * PBKDF2-params ::= SEQUENCE {
 *   salt CHOICE {
 *     specified OCTET STRING,
 *     otherSource AlgorithmIdentifier {{PBKDF2-SaltSources}}
 *   },
 *   iterationCount INTEGER (1..MAX),
 *   keyLength INTEGER (1..MAX) OPTIONAL,
 *   prf AlgorithmIdentifier {{PBKDF2-PRFs}} DEFAULT algid-hmacWithSHA1
 * }
 *
 * @param obj the ASN.1 PrivateKeyInfo object.
 * @param password the password to encrypt with.
 * @param options:
 *          algorithm the encryption algorithm to use
 *            ('aes128', 'aes192', 'aes256', '3des'), defaults to 'aes128'.
 *          count the iteration count to use.
 *          saltSize the salt size to use.
 *          prfAlgorithm the PRF message digest algorithm to use
 *            ('sha1', 'sha224', 'sha256', 'sha384', 'sha512')
 *
 * @return the ASN.1 EncryptedPrivateKeyInfo.
 */ $2ead283f9cfaa956$var$pki.encryptPrivateKeyInfo = function(obj, password, options) {
    // set default options
    options = options || {};
    options.saltSize = options.saltSize || 8;
    options.count = options.count || 2048;
    options.algorithm = options.algorithm || "aes128";
    options.prfAlgorithm = options.prfAlgorithm || "sha1";
    // generate PBE params
    var salt = $hSPkV.random.getBytesSync(options.saltSize);
    var count = options.count;
    var countBytes = $2ead283f9cfaa956$var$asn1.integerToDer(count);
    var dkLen;
    var encryptionAlgorithm;
    var encryptedData;
    if (options.algorithm.indexOf("aes") === 0 || options.algorithm === "des") {
        // do PBES2
        var ivLen, encOid, cipherFn;
        switch(options.algorithm){
            case "aes128":
                dkLen = 16;
                ivLen = 16;
                encOid = $2ead283f9cfaa956$var$oids["aes128-CBC"];
                cipherFn = $hSPkV.aes.createEncryptionCipher;
                break;
            case "aes192":
                dkLen = 24;
                ivLen = 16;
                encOid = $2ead283f9cfaa956$var$oids["aes192-CBC"];
                cipherFn = $hSPkV.aes.createEncryptionCipher;
                break;
            case "aes256":
                dkLen = 32;
                ivLen = 16;
                encOid = $2ead283f9cfaa956$var$oids["aes256-CBC"];
                cipherFn = $hSPkV.aes.createEncryptionCipher;
                break;
            case "des":
                dkLen = 8;
                ivLen = 8;
                encOid = $2ead283f9cfaa956$var$oids["desCBC"];
                cipherFn = $hSPkV.des.createEncryptionCipher;
                break;
            default:
                var error = new Error("Cannot encrypt private key. Unknown encryption algorithm.");
                error.algorithm = options.algorithm;
                throw error;
        }
        // get PRF message digest
        var prfAlgorithm = "hmacWith" + options.prfAlgorithm.toUpperCase();
        var md = $2ead283f9cfaa956$var$prfAlgorithmToMessageDigest(prfAlgorithm);
        // encrypt private key using pbe SHA-1 and AES/DES
        var dk = $hSPkV.pkcs5.pbkdf2(password, salt, count, dkLen, md);
        var iv = $hSPkV.random.getBytesSync(ivLen);
        var cipher = cipherFn(dk);
        cipher.start(iv);
        cipher.update($2ead283f9cfaa956$var$asn1.toDer(obj));
        cipher.finish();
        encryptedData = cipher.output.getBytes();
        // get PBKDF2-params
        var params = $2ead283f9cfaa956$var$createPbkdf2Params(salt, countBytes, dkLen, prfAlgorithm);
        encryptionAlgorithm = $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.SEQUENCE, true, [
            $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.OID, false, $2ead283f9cfaa956$var$asn1.oidToDer($2ead283f9cfaa956$var$oids["pkcs5PBES2"]).getBytes()),
            $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.SEQUENCE, true, [
                // keyDerivationFunc
                $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.SEQUENCE, true, [
                    $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.OID, false, $2ead283f9cfaa956$var$asn1.oidToDer($2ead283f9cfaa956$var$oids["pkcs5PBKDF2"]).getBytes()),
                    // PBKDF2-params
                    params
                ]),
                // encryptionScheme
                $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.SEQUENCE, true, [
                    $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.OID, false, $2ead283f9cfaa956$var$asn1.oidToDer(encOid).getBytes()),
                    // iv
                    $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.OCTETSTRING, false, iv)
                ])
            ])
        ]);
    } else if (options.algorithm === "3des") {
        // Do PKCS12 PBE
        dkLen = 24;
        var saltBytes = new $hSPkV.util.ByteBuffer(salt);
        var dk = $2ead283f9cfaa956$var$pki.pbe.generatePkcs12Key(password, saltBytes, 1, count, dkLen);
        var iv = $2ead283f9cfaa956$var$pki.pbe.generatePkcs12Key(password, saltBytes, 2, count, dkLen);
        var cipher = $hSPkV.des.createEncryptionCipher(dk);
        cipher.start(iv);
        cipher.update($2ead283f9cfaa956$var$asn1.toDer(obj));
        cipher.finish();
        encryptedData = cipher.output.getBytes();
        encryptionAlgorithm = $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.SEQUENCE, true, [
            $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.OID, false, $2ead283f9cfaa956$var$asn1.oidToDer($2ead283f9cfaa956$var$oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]).getBytes()),
            // pkcs-12PbeParams
            $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.SEQUENCE, true, [
                // salt
                $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.OCTETSTRING, false, salt),
                // iteration count
                $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.INTEGER, false, countBytes.getBytes())
            ])
        ]);
    } else {
        var error = new Error("Cannot encrypt private key. Unknown encryption algorithm.");
        error.algorithm = options.algorithm;
        throw error;
    }
    // EncryptedPrivateKeyInfo
    var rval = $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.SEQUENCE, true, [
        // encryptionAlgorithm
        encryptionAlgorithm,
        // encryptedData
        $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.OCTETSTRING, false, encryptedData)
    ]);
    return rval;
};
/**
 * Decrypts a ASN.1 PrivateKeyInfo object.
 *
 * @param obj the ASN.1 EncryptedPrivateKeyInfo object.
 * @param password the password to decrypt with.
 *
 * @return the ASN.1 PrivateKeyInfo on success, null on failure.
 */ $2ead283f9cfaa956$var$pki.decryptPrivateKeyInfo = function(obj, password) {
    var rval = null;
    // get PBE params
    var capture = {};
    var errors = [];
    if (!$2ead283f9cfaa956$var$asn1.validate(obj, $2ead283f9cfaa956$var$encryptedPrivateKeyValidator, capture, errors)) {
        var error = new Error("Cannot read encrypted private key. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        error.errors = errors;
        throw error;
    }
    // get cipher
    var oid = $2ead283f9cfaa956$var$asn1.derToOid(capture.encryptionOid);
    var cipher = $2ead283f9cfaa956$var$pki.pbe.getCipher(oid, capture.encryptionParams, password);
    // get encrypted data
    var encrypted = $hSPkV.util.createBuffer(capture.encryptedData);
    cipher.update(encrypted);
    if (cipher.finish()) rval = $2ead283f9cfaa956$var$asn1.fromDer(cipher.output);
    return rval;
};
/**
 * Converts a EncryptedPrivateKeyInfo to PEM format.
 *
 * @param epki the EncryptedPrivateKeyInfo.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted encrypted private key.
 */ $2ead283f9cfaa956$var$pki.encryptedPrivateKeyToPem = function(epki, maxline) {
    // convert to DER, then PEM-encode
    var msg = {
        type: "ENCRYPTED PRIVATE KEY",
        body: $2ead283f9cfaa956$var$asn1.toDer(epki).getBytes()
    };
    return $hSPkV.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Converts a PEM-encoded EncryptedPrivateKeyInfo to ASN.1 format. Decryption
 * is not performed.
 *
 * @param pem the EncryptedPrivateKeyInfo in PEM-format.
 *
 * @return the ASN.1 EncryptedPrivateKeyInfo.
 */ $2ead283f9cfaa956$var$pki.encryptedPrivateKeyFromPem = function(pem) {
    var msg = $hSPkV.pem.decode(pem)[0];
    if (msg.type !== "ENCRYPTED PRIVATE KEY") {
        var error = new Error('Could not convert encrypted private key from PEM; PEM header type is "ENCRYPTED PRIVATE KEY".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert encrypted private key from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    return $2ead283f9cfaa956$var$asn1.fromDer(msg.body);
};
/**
 * Encrypts an RSA private key. By default, the key will be wrapped in
 * a PrivateKeyInfo and encrypted to produce a PKCS#8 EncryptedPrivateKeyInfo.
 * This is the standard, preferred way to encrypt a private key.
 *
 * To produce a non-standard PEM-encrypted private key that uses encapsulated
 * headers to indicate the encryption algorithm (old-style non-PKCS#8 OpenSSL
 * private key encryption), set the 'legacy' option to true. Note: Using this
 * option will cause the iteration count to be forced to 1.
 *
 * Note: The 'des' algorithm is supported, but it is not considered to be
 * secure because it only uses a single 56-bit key. If possible, it is highly
 * recommended that a different algorithm be used.
 *
 * @param rsaKey the RSA key to encrypt.
 * @param password the password to use.
 * @param options:
 *          algorithm: the encryption algorithm to use
 *            ('aes128', 'aes192', 'aes256', '3des', 'des').
 *          count: the iteration count to use.
 *          saltSize: the salt size to use.
 *          legacy: output an old non-PKCS#8 PEM-encrypted+encapsulated
 *            headers (DEK-Info) private key.
 *
 * @return the PEM-encoded ASN.1 EncryptedPrivateKeyInfo.
 */ $2ead283f9cfaa956$var$pki.encryptRsaPrivateKey = function(rsaKey, password, options) {
    // standard PKCS#8
    options = options || {};
    if (!options.legacy) {
        // encrypt PrivateKeyInfo
        var rval = $2ead283f9cfaa956$var$pki.wrapRsaPrivateKey($2ead283f9cfaa956$var$pki.privateKeyToAsn1(rsaKey));
        rval = $2ead283f9cfaa956$var$pki.encryptPrivateKeyInfo(rval, password, options);
        return $2ead283f9cfaa956$var$pki.encryptedPrivateKeyToPem(rval);
    }
    // legacy non-PKCS#8
    var algorithm;
    var iv;
    var dkLen;
    var cipherFn;
    switch(options.algorithm){
        case "aes128":
            algorithm = "AES-128-CBC";
            dkLen = 16;
            iv = $hSPkV.random.getBytesSync(16);
            cipherFn = $hSPkV.aes.createEncryptionCipher;
            break;
        case "aes192":
            algorithm = "AES-192-CBC";
            dkLen = 24;
            iv = $hSPkV.random.getBytesSync(16);
            cipherFn = $hSPkV.aes.createEncryptionCipher;
            break;
        case "aes256":
            algorithm = "AES-256-CBC";
            dkLen = 32;
            iv = $hSPkV.random.getBytesSync(16);
            cipherFn = $hSPkV.aes.createEncryptionCipher;
            break;
        case "3des":
            algorithm = "DES-EDE3-CBC";
            dkLen = 24;
            iv = $hSPkV.random.getBytesSync(8);
            cipherFn = $hSPkV.des.createEncryptionCipher;
            break;
        case "des":
            algorithm = "DES-CBC";
            dkLen = 8;
            iv = $hSPkV.random.getBytesSync(8);
            cipherFn = $hSPkV.des.createEncryptionCipher;
            break;
        default:
            var error = new Error('Could not encrypt RSA private key; unsupported encryption algorithm "' + options.algorithm + '".');
            error.algorithm = options.algorithm;
            throw error;
    }
    // encrypt private key using OpenSSL legacy key derivation
    var dk = $hSPkV.pbe.opensslDeriveBytes(password, iv.substr(0, 8), dkLen);
    var cipher = cipherFn(dk);
    cipher.start(iv);
    cipher.update($2ead283f9cfaa956$var$asn1.toDer($2ead283f9cfaa956$var$pki.privateKeyToAsn1(rsaKey)));
    cipher.finish();
    var msg = {
        type: "RSA PRIVATE KEY",
        procType: {
            version: "4",
            type: "ENCRYPTED"
        },
        dekInfo: {
            algorithm: algorithm,
            parameters: $hSPkV.util.bytesToHex(iv).toUpperCase()
        },
        body: cipher.output.getBytes()
    };
    return $hSPkV.pem.encode(msg);
};
/**
 * Decrypts an RSA private key.
 *
 * @param pem the PEM-formatted EncryptedPrivateKeyInfo to decrypt.
 * @param password the password to use.
 *
 * @return the RSA key on success, null on failure.
 */ $2ead283f9cfaa956$var$pki.decryptRsaPrivateKey = function(pem, password) {
    var rval = null;
    var msg = $hSPkV.pem.decode(pem)[0];
    if (msg.type !== "ENCRYPTED PRIVATE KEY" && msg.type !== "PRIVATE KEY" && msg.type !== "RSA PRIVATE KEY") {
        var error = new Error('Could not convert private key from PEM; PEM header type is not "ENCRYPTED PRIVATE KEY", "PRIVATE KEY", or "RSA PRIVATE KEY".');
        error.headerType = error;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") {
        var dkLen;
        var cipherFn;
        switch(msg.dekInfo.algorithm){
            case "DES-CBC":
                dkLen = 8;
                cipherFn = $hSPkV.des.createDecryptionCipher;
                break;
            case "DES-EDE3-CBC":
                dkLen = 24;
                cipherFn = $hSPkV.des.createDecryptionCipher;
                break;
            case "AES-128-CBC":
                dkLen = 16;
                cipherFn = $hSPkV.aes.createDecryptionCipher;
                break;
            case "AES-192-CBC":
                dkLen = 24;
                cipherFn = $hSPkV.aes.createDecryptionCipher;
                break;
            case "AES-256-CBC":
                dkLen = 32;
                cipherFn = $hSPkV.aes.createDecryptionCipher;
                break;
            case "RC2-40-CBC":
                dkLen = 5;
                cipherFn = function(key) {
                    return $hSPkV.rc2.createDecryptionCipher(key, 40);
                };
                break;
            case "RC2-64-CBC":
                dkLen = 8;
                cipherFn = function(key) {
                    return $hSPkV.rc2.createDecryptionCipher(key, 64);
                };
                break;
            case "RC2-128-CBC":
                dkLen = 16;
                cipherFn = function(key) {
                    return $hSPkV.rc2.createDecryptionCipher(key, 128);
                };
                break;
            default:
                var error = new Error('Could not decrypt private key; unsupported encryption algorithm "' + msg.dekInfo.algorithm + '".');
                error.algorithm = msg.dekInfo.algorithm;
                throw error;
        }
        // use OpenSSL legacy key derivation
        var iv = $hSPkV.util.hexToBytes(msg.dekInfo.parameters);
        var dk = $hSPkV.pbe.opensslDeriveBytes(password, iv.substr(0, 8), dkLen);
        var cipher = cipherFn(dk);
        cipher.start(iv);
        cipher.update($hSPkV.util.createBuffer(msg.body));
        if (cipher.finish()) rval = cipher.output.getBytes();
        else return rval;
    } else rval = msg.body;
    if (msg.type === "ENCRYPTED PRIVATE KEY") rval = $2ead283f9cfaa956$var$pki.decryptPrivateKeyInfo($2ead283f9cfaa956$var$asn1.fromDer(rval), password);
    else // decryption already performed above
    rval = $2ead283f9cfaa956$var$asn1.fromDer(rval);
    if (rval !== null) rval = $2ead283f9cfaa956$var$pki.privateKeyFromAsn1(rval);
    return rval;
};
/**
 * Derives a PKCS#12 key.
 *
 * @param password the password to derive the key material from, null or
 *          undefined for none.
 * @param salt the salt, as a ByteBuffer, to use.
 * @param id the PKCS#12 ID byte (1 = key material, 2 = IV, 3 = MAC).
 * @param iter the iteration count.
 * @param n the number of bytes to derive from the password.
 * @param md the message digest to use, defaults to SHA-1.
 *
 * @return a ByteBuffer with the bytes derived from the password.
 */ $2ead283f9cfaa956$var$pki.pbe.generatePkcs12Key = function(password, salt, id, iter, n, md) {
    var j, l;
    if (typeof md === "undefined" || md === null) {
        if (!("sha1" in $hSPkV.md)) throw new Error('"sha1" hash algorithm unavailable.');
        md = $hSPkV.md.sha1.create();
    }
    var u = md.digestLength;
    var v = md.blockLength;
    var result = new $hSPkV.util.ByteBuffer();
    /* Convert password to Unicode byte buffer + trailing 0-byte. */ var passBuf = new $hSPkV.util.ByteBuffer();
    if (password !== null && password !== undefined) {
        for(l = 0; l < password.length; l++)passBuf.putInt16(password.charCodeAt(l));
        passBuf.putInt16(0);
    }
    /* Length of salt and password in BYTES. */ var p = passBuf.length();
    var s = salt.length();
    /* 1. Construct a string, D (the "diversifier"), by concatenating
        v copies of ID. */ var D = new $hSPkV.util.ByteBuffer();
    D.fillWithByte(id, v);
    /* 2. Concatenate copies of the salt together to create a string S of length
        v * ceil(s / v) bytes (the final copy of the salt may be truncated
        to create S).
        Note that if the salt is the empty string, then so is S. */ var Slen = v * Math.ceil(s / v);
    var S = new $hSPkV.util.ByteBuffer();
    for(l = 0; l < Slen; l++)S.putByte(salt.at(l % s));
    /* 3. Concatenate copies of the password together to create a string P of
        length v * ceil(p / v) bytes (the final copy of the password may be
        truncated to create P).
        Note that if the password is the empty string, then so is P. */ var Plen = v * Math.ceil(p / v);
    var P = new $hSPkV.util.ByteBuffer();
    for(l = 0; l < Plen; l++)P.putByte(passBuf.at(l % p));
    /* 4. Set I=S||P to be the concatenation of S and P. */ var I = S;
    I.putBuffer(P);
    /* 5. Set c=ceil(n / u). */ var c = Math.ceil(n / u);
    /* 6. For i=1, 2, ..., c, do the following: */ for(var i = 1; i <= c; i++){
        /* a) Set Ai=H^r(D||I). (l.e. the rth hash of D||I, H(H(H(...H(D||I)))) */ var buf = new $hSPkV.util.ByteBuffer();
        buf.putBytes(D.bytes());
        buf.putBytes(I.bytes());
        for(var round = 0; round < iter; round++){
            md.start();
            md.update(buf.getBytes());
            buf = md.digest();
        }
        /* b) Concatenate copies of Ai to create a string B of length v bytes (the
          final copy of Ai may be truncated to create B). */ var B = new $hSPkV.util.ByteBuffer();
        for(l = 0; l < v; l++)B.putByte(buf.at(l % u));
        /* c) Treating I as a concatenation I0, I1, ..., Ik-1 of v-byte blocks,
          where k=ceil(s / v) + ceil(p / v), modify I by setting
          Ij=(Ij+B+1) mod 2v for each j.  */ var k = Math.ceil(s / v) + Math.ceil(p / v);
        var Inew = new $hSPkV.util.ByteBuffer();
        for(j = 0; j < k; j++){
            var chunk = new $hSPkV.util.ByteBuffer(I.getBytes(v));
            var x = 0x1ff;
            for(l = B.length() - 1; l >= 0; l--){
                x = x >> 8;
                x += B.at(l) + chunk.at(l);
                chunk.setAt(l, x & 0xff);
            }
            Inew.putBuffer(chunk);
        }
        I = Inew;
        /* Add Ai to A. */ result.putBuffer(buf);
    }
    result.truncate(result.length() - n);
    return result;
};
/**
 * Get new Forge cipher object instance.
 *
 * @param oid the OID (in string notation).
 * @param params the ASN.1 params object.
 * @param password the password to decrypt with.
 *
 * @return new cipher object instance.
 */ $2ead283f9cfaa956$var$pki.pbe.getCipher = function(oid, params, password) {
    switch(oid){
        case $2ead283f9cfaa956$var$pki.oids["pkcs5PBES2"]:
            return $2ead283f9cfaa956$var$pki.pbe.getCipherForPBES2(oid, params, password);
        case $2ead283f9cfaa956$var$pki.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
        case $2ead283f9cfaa956$var$pki.oids["pbewithSHAAnd40BitRC2-CBC"]:
            return $2ead283f9cfaa956$var$pki.pbe.getCipherForPKCS12PBE(oid, params, password);
        default:
            var error = new Error("Cannot read encrypted PBE data block. Unsupported OID.");
            error.oid = oid;
            error.supportedOids = [
                "pkcs5PBES2",
                "pbeWithSHAAnd3-KeyTripleDES-CBC",
                "pbewithSHAAnd40BitRC2-CBC"
            ];
            throw error;
    }
};
/**
 * Get new Forge cipher object instance according to PBES2 params block.
 *
 * The returned cipher instance is already started using the IV
 * from PBES2 parameter block.
 *
 * @param oid the PKCS#5 PBKDF2 OID (in string notation).
 * @param params the ASN.1 PBES2-params object.
 * @param password the password to decrypt with.
 *
 * @return new cipher object instance.
 */ $2ead283f9cfaa956$var$pki.pbe.getCipherForPBES2 = function(oid, params, password) {
    // get PBE params
    var capture = {};
    var errors = [];
    if (!$2ead283f9cfaa956$var$asn1.validate(params, $2ead283f9cfaa956$var$PBES2AlgorithmsValidator, capture, errors)) {
        var error = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        error.errors = errors;
        throw error;
    }
    // check oids
    oid = $2ead283f9cfaa956$var$asn1.derToOid(capture.kdfOid);
    if (oid !== $2ead283f9cfaa956$var$pki.oids["pkcs5PBKDF2"]) {
        var error = new Error("Cannot read encrypted private key. Unsupported key derivation function OID.");
        error.oid = oid;
        error.supportedOids = [
            "pkcs5PBKDF2"
        ];
        throw error;
    }
    oid = $2ead283f9cfaa956$var$asn1.derToOid(capture.encOid);
    if (oid !== $2ead283f9cfaa956$var$pki.oids["aes128-CBC"] && oid !== $2ead283f9cfaa956$var$pki.oids["aes192-CBC"] && oid !== $2ead283f9cfaa956$var$pki.oids["aes256-CBC"] && oid !== $2ead283f9cfaa956$var$pki.oids["des-EDE3-CBC"] && oid !== $2ead283f9cfaa956$var$pki.oids["desCBC"]) {
        var error = new Error("Cannot read encrypted private key. Unsupported encryption scheme OID.");
        error.oid = oid;
        error.supportedOids = [
            "aes128-CBC",
            "aes192-CBC",
            "aes256-CBC",
            "des-EDE3-CBC",
            "desCBC"
        ];
        throw error;
    }
    // set PBE params
    var salt = capture.kdfSalt;
    var count = $hSPkV.util.createBuffer(capture.kdfIterationCount);
    count = count.getInt(count.length() << 3);
    var dkLen;
    var cipherFn;
    switch($2ead283f9cfaa956$var$pki.oids[oid]){
        case "aes128-CBC":
            dkLen = 16;
            cipherFn = $hSPkV.aes.createDecryptionCipher;
            break;
        case "aes192-CBC":
            dkLen = 24;
            cipherFn = $hSPkV.aes.createDecryptionCipher;
            break;
        case "aes256-CBC":
            dkLen = 32;
            cipherFn = $hSPkV.aes.createDecryptionCipher;
            break;
        case "des-EDE3-CBC":
            dkLen = 24;
            cipherFn = $hSPkV.des.createDecryptionCipher;
            break;
        case "desCBC":
            dkLen = 8;
            cipherFn = $hSPkV.des.createDecryptionCipher;
            break;
    }
    // get PRF message digest
    var md = $2ead283f9cfaa956$var$prfOidToMessageDigest(capture.prfOid);
    // decrypt private key using pbe with chosen PRF and AES/DES
    var dk = $hSPkV.pkcs5.pbkdf2(password, salt, count, dkLen, md);
    var iv = capture.encIv;
    var cipher = cipherFn(dk);
    cipher.start(iv);
    return cipher;
};
/**
 * Get new Forge cipher object instance for PKCS#12 PBE.
 *
 * The returned cipher instance is already started using the key & IV
 * derived from the provided password and PKCS#12 PBE salt.
 *
 * @param oid The PKCS#12 PBE OID (in string notation).
 * @param params The ASN.1 PKCS#12 PBE-params object.
 * @param password The password to decrypt with.
 *
 * @return the new cipher object instance.
 */ $2ead283f9cfaa956$var$pki.pbe.getCipherForPKCS12PBE = function(oid, params, password) {
    // get PBE params
    var capture = {};
    var errors = [];
    if (!$2ead283f9cfaa956$var$asn1.validate(params, $2ead283f9cfaa956$var$pkcs12PbeParamsValidator, capture, errors)) {
        var error = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        error.errors = errors;
        throw error;
    }
    var salt = $hSPkV.util.createBuffer(capture.salt);
    var count = $hSPkV.util.createBuffer(capture.iterations);
    count = count.getInt(count.length() << 3);
    var dkLen, dIvLen, cipherFn;
    switch(oid){
        case $2ead283f9cfaa956$var$pki.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
            dkLen = 24;
            dIvLen = 8;
            cipherFn = $hSPkV.des.startDecrypting;
            break;
        case $2ead283f9cfaa956$var$pki.oids["pbewithSHAAnd40BitRC2-CBC"]:
            dkLen = 5;
            dIvLen = 8;
            cipherFn = function(key, iv) {
                var cipher = $hSPkV.rc2.createDecryptionCipher(key, 40);
                cipher.start(iv, null);
                return cipher;
            };
            break;
        default:
            var error = new Error("Cannot read PKCS #12 PBE data block. Unsupported OID.");
            error.oid = oid;
            throw error;
    }
    // get PRF message digest
    var md = $2ead283f9cfaa956$var$prfOidToMessageDigest(capture.prfOid);
    var key = $2ead283f9cfaa956$var$pki.pbe.generatePkcs12Key(password, salt, 1, count, dkLen, md);
    md.start();
    var iv = $2ead283f9cfaa956$var$pki.pbe.generatePkcs12Key(password, salt, 2, count, dIvLen, md);
    return cipherFn(key, iv);
};
/**
 * OpenSSL's legacy key derivation function.
 *
 * See: http://www.openssl.org/docs/crypto/EVP_BytesToKey.html
 *
 * @param password the password to derive the key from.
 * @param salt the salt to use, null for none.
 * @param dkLen the number of bytes needed for the derived key.
 * @param [options] the options to use:
 *          [md] an optional message digest object to use.
 */ $2ead283f9cfaa956$var$pki.pbe.opensslDeriveBytes = function(password, salt, dkLen, md) {
    if (typeof md === "undefined" || md === null) {
        if (!("md5" in $hSPkV.md)) throw new Error('"md5" hash algorithm unavailable.');
        md = $hSPkV.md.md5.create();
    }
    if (salt === null) salt = "";
    var digests = [
        $2ead283f9cfaa956$var$hash(md, password + salt)
    ];
    for(var length = 16, i = 1; length < dkLen; ++i, length += 16)digests.push($2ead283f9cfaa956$var$hash(md, digests[i - 1] + password + salt));
    return digests.join("").substr(0, dkLen);
};
function $2ead283f9cfaa956$var$hash(md, bytes) {
    return md.start().update(bytes).digest().getBytes();
}
function $2ead283f9cfaa956$var$prfOidToMessageDigest(prfOid) {
    // get PRF algorithm, default to SHA-1
    var prfAlgorithm;
    if (!prfOid) prfAlgorithm = "hmacWithSHA1";
    else {
        prfAlgorithm = $2ead283f9cfaa956$var$pki.oids[$2ead283f9cfaa956$var$asn1.derToOid(prfOid)];
        if (!prfAlgorithm) {
            var error = new Error("Unsupported PRF OID.");
            error.oid = prfOid;
            error.supported = [
                "hmacWithSHA1",
                "hmacWithSHA224",
                "hmacWithSHA256",
                "hmacWithSHA384",
                "hmacWithSHA512"
            ];
            throw error;
        }
    }
    return $2ead283f9cfaa956$var$prfAlgorithmToMessageDigest(prfAlgorithm);
}
function $2ead283f9cfaa956$var$prfAlgorithmToMessageDigest(prfAlgorithm) {
    var factory = $hSPkV.md;
    switch(prfAlgorithm){
        case "hmacWithSHA224":
            factory = $hSPkV.md.sha512;
        case "hmacWithSHA1":
        case "hmacWithSHA256":
        case "hmacWithSHA384":
        case "hmacWithSHA512":
            prfAlgorithm = prfAlgorithm.substr(8).toLowerCase();
            break;
        default:
            var error = new Error("Unsupported PRF algorithm.");
            error.algorithm = prfAlgorithm;
            error.supported = [
                "hmacWithSHA1",
                "hmacWithSHA224",
                "hmacWithSHA256",
                "hmacWithSHA384",
                "hmacWithSHA512"
            ];
            throw error;
    }
    if (!factory || !(prfAlgorithm in factory)) throw new Error("Unknown hash algorithm: " + prfAlgorithm);
    return factory[prfAlgorithm].create();
}
function $2ead283f9cfaa956$var$createPbkdf2Params(salt, countBytes, dkLen, prfAlgorithm) {
    var params = $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.SEQUENCE, true, [
        // salt
        $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.OCTETSTRING, false, salt),
        // iteration count
        $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.INTEGER, false, countBytes.getBytes())
    ]);
    // when PRF algorithm is not SHA-1 default, add key length and PRF algorithm
    if (prfAlgorithm !== "hmacWithSHA1") params.value.push(// key length
    $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.INTEGER, false, $hSPkV.util.hexToBytes(dkLen.toString(16))), // AlgorithmIdentifier
    $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.SEQUENCE, true, [
        // algorithm
        $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.OID, false, $2ead283f9cfaa956$var$asn1.oidToDer($2ead283f9cfaa956$var$pki.oids[prfAlgorithm]).getBytes()),
        // parameters (null)
        $2ead283f9cfaa956$var$asn1.create($2ead283f9cfaa956$var$asn1.Class.UNIVERSAL, $2ead283f9cfaa956$var$asn1.Type.NULL, false, "")
    ]));
    return params;
}

});
parcelRequire.register("8ju3Y", function(module, exports) {
/**
 * Advanced Encryption Standard (AES) implementation.
 *
 * This implementation is based on the public domain library 'jscrypto' which
 * was written by:
 *
 * Emily Stark (estark@stanford.edu)
 * Mike Hamburg (mhamburg@stanford.edu)
 * Dan Boneh (dabo@cs.stanford.edu)
 *
 * Parts of this code are based on the OpenSSL implementation of AES:
 * http://www.openssl.org
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $hSPkV = parcelRequire("hSPkV");
parcelRequire("70wgw");
parcelRequire("gmtg3");
parcelRequire("3lPw4");
/* AES API */ module.exports = $hSPkV.aes = $hSPkV.aes || {};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('AES-<mode>', key);
 * cipher.start({iv: iv});
 *
 * Creates an AES cipher object to encrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as a string of bytes, an array of bytes,
 * a byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $hSPkV.aes.startEncrypting = function(key, iv, output, mode) {
    var cipher = $60d76afb9d7c069c$var$_createCipher({
        key: key,
        output: output,
        decrypt: false,
        mode: mode
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('AES-<mode>', key);
 *
 * Creates an AES cipher object to encrypt data using the given symmetric key.
 *
 * The key may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $hSPkV.aes.createEncryptionCipher = function(key, mode) {
    return $60d76afb9d7c069c$var$_createCipher({
        key: key,
        output: null,
        decrypt: false,
        mode: mode
    });
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('AES-<mode>', key);
 * decipher.start({iv: iv});
 *
 * Creates an AES cipher object to decrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as a string of bytes, an array of bytes,
 * a byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $hSPkV.aes.startDecrypting = function(key, iv, output, mode) {
    var cipher = $60d76afb9d7c069c$var$_createCipher({
        key: key,
        output: output,
        decrypt: true,
        mode: mode
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('AES-<mode>', key);
 *
 * Creates an AES cipher object to decrypt data using the given symmetric key.
 *
 * The key may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $hSPkV.aes.createDecryptionCipher = function(key, mode) {
    return $60d76afb9d7c069c$var$_createCipher({
        key: key,
        output: null,
        decrypt: true,
        mode: mode
    });
};
/**
 * Creates a new AES cipher algorithm object.
 *
 * @param name the name of the algorithm.
 * @param mode the mode factory function.
 *
 * @return the AES algorithm object.
 */ $hSPkV.aes.Algorithm = function(name, mode) {
    if (!$60d76afb9d7c069c$var$init) $60d76afb9d7c069c$var$initialize();
    var self = this;
    self.name = name;
    self.mode = new mode({
        blockSize: 16,
        cipher: {
            encrypt: function(inBlock, outBlock) {
                return $60d76afb9d7c069c$var$_updateBlock(self._w, inBlock, outBlock, false);
            },
            decrypt: function(inBlock, outBlock) {
                return $60d76afb9d7c069c$var$_updateBlock(self._w, inBlock, outBlock, true);
            }
        }
    });
    self._init = false;
};
/**
 * Initializes this AES algorithm by expanding its key.
 *
 * @param options the options to use.
 *          key the key to use with this algorithm.
 *          decrypt true if the algorithm should be initialized for decryption,
 *            false for encryption.
 */ $hSPkV.aes.Algorithm.prototype.initialize = function(options) {
    if (this._init) return;
    var key = options.key;
    var tmp;
    /* Note: The key may be a string of bytes, an array of bytes, a byte
    buffer, or an array of 32-bit integers. If the key is in bytes, then
    it must be 16, 24, or 32 bytes in length. If it is in 32-bit
    integers, it must be 4, 6, or 8 integers long. */ if (typeof key === "string" && (key.length === 16 || key.length === 24 || key.length === 32)) // convert key string into byte buffer
    key = $hSPkV.util.createBuffer(key);
    else if ($hSPkV.util.isArray(key) && (key.length === 16 || key.length === 24 || key.length === 32)) {
        // convert key integer array into byte buffer
        tmp = key;
        key = $hSPkV.util.createBuffer();
        for(var i = 0; i < tmp.length; ++i)key.putByte(tmp[i]);
    }
    // convert key byte buffer into 32-bit integer array
    if (!$hSPkV.util.isArray(key)) {
        tmp = key;
        key = [];
        // key lengths of 16, 24, 32 bytes allowed
        var len = tmp.length();
        if (len === 16 || len === 24 || len === 32) {
            len = len >>> 2;
            for(var i = 0; i < len; ++i)key.push(tmp.getInt32());
        }
    }
    // key must be an array of 32-bit integers by now
    if (!$hSPkV.util.isArray(key) || !(key.length === 4 || key.length === 6 || key.length === 8)) throw new Error("Invalid key parameter.");
    // encryption operation is always used for these modes
    var mode = this.mode.name;
    var encryptOp = [
        "CFB",
        "OFB",
        "CTR",
        "GCM"
    ].indexOf(mode) !== -1;
    // do key expansion
    this._w = $60d76afb9d7c069c$var$_expandKey(key, options.decrypt && !encryptOp);
    this._init = true;
};
/**
 * Expands a key. Typically only used for testing.
 *
 * @param key the symmetric key to expand, as an array of 32-bit words.
 * @param decrypt true to expand for decryption, false for encryption.
 *
 * @return the expanded key.
 */ $hSPkV.aes._expandKey = function(key, decrypt) {
    if (!$60d76afb9d7c069c$var$init) $60d76afb9d7c069c$var$initialize();
    return $60d76afb9d7c069c$var$_expandKey(key, decrypt);
};
/**
 * Updates a single block. Typically only used for testing.
 *
 * @param w the expanded key to use.
 * @param input an array of block-size 32-bit words.
 * @param output an array of block-size 32-bit words.
 * @param decrypt true to decrypt, false to encrypt.
 */ $hSPkV.aes._updateBlock = $60d76afb9d7c069c$var$_updateBlock;
/** Register AES algorithms **/ $60d76afb9d7c069c$var$registerAlgorithm("AES-ECB", $hSPkV.cipher.modes.ecb);
$60d76afb9d7c069c$var$registerAlgorithm("AES-CBC", $hSPkV.cipher.modes.cbc);
$60d76afb9d7c069c$var$registerAlgorithm("AES-CFB", $hSPkV.cipher.modes.cfb);
$60d76afb9d7c069c$var$registerAlgorithm("AES-OFB", $hSPkV.cipher.modes.ofb);
$60d76afb9d7c069c$var$registerAlgorithm("AES-CTR", $hSPkV.cipher.modes.ctr);
$60d76afb9d7c069c$var$registerAlgorithm("AES-GCM", $hSPkV.cipher.modes.gcm);
function $60d76afb9d7c069c$var$registerAlgorithm(name, mode) {
    var factory = function() {
        return new $hSPkV.aes.Algorithm(name, mode);
    };
    $hSPkV.cipher.registerAlgorithm(name, factory);
}
/** AES implementation **/ var $60d76afb9d7c069c$var$init = false; // not yet initialized
var $60d76afb9d7c069c$var$Nb = 4; // number of words comprising the state (AES = 4)
var $60d76afb9d7c069c$var$sbox; // non-linear substitution table used in key expansion
var $60d76afb9d7c069c$var$isbox; // inversion of sbox
var $60d76afb9d7c069c$var$rcon; // round constant word array
var $60d76afb9d7c069c$var$mix; // mix-columns table
var $60d76afb9d7c069c$var$imix; // inverse mix-columns table
/**
 * Performs initialization, ie: precomputes tables to optimize for speed.
 *
 * One way to understand how AES works is to imagine that 'addition' and
 * 'multiplication' are interfaces that require certain mathematical
 * properties to hold true (ie: they are associative) but they might have
 * different implementations and produce different kinds of results ...
 * provided that their mathematical properties remain true. AES defines
 * its own methods of addition and multiplication but keeps some important
 * properties the same, ie: associativity and distributivity. The
 * explanation below tries to shed some light on how AES defines addition
 * and multiplication of bytes and 32-bit words in order to perform its
 * encryption and decryption algorithms.
 *
 * The basics:
 *
 * The AES algorithm views bytes as binary representations of polynomials
 * that have either 1 or 0 as the coefficients. It defines the addition
 * or subtraction of two bytes as the XOR operation. It also defines the
 * multiplication of two bytes as a finite field referred to as GF(2^8)
 * (Note: 'GF' means "Galois Field" which is a field that contains a finite
 * number of elements so GF(2^8) has 256 elements).
 *
 * This means that any two bytes can be represented as binary polynomials;
 * when they multiplied together and modularly reduced by an irreducible
 * polynomial of the 8th degree, the results are the field GF(2^8). The
 * specific irreducible polynomial that AES uses in hexadecimal is 0x11b.
 * This multiplication is associative with 0x01 as the identity:
 *
 * (b * 0x01 = GF(b, 0x01) = b).
 *
 * The operation GF(b, 0x02) can be performed at the byte level by left
 * shifting b once and then XOR'ing it (to perform the modular reduction)
 * with 0x11b if b is >= 128. Repeated application of the multiplication
 * of 0x02 can be used to implement the multiplication of any two bytes.
 *
 * For instance, multiplying 0x57 and 0x13, denoted as GF(0x57, 0x13), can
 * be performed by factoring 0x13 into 0x01, 0x02, and 0x10. Then these
 * factors can each be multiplied by 0x57 and then added together. To do
 * the multiplication, values for 0x57 multiplied by each of these 3 factors
 * can be precomputed and stored in a table. To add them, the values from
 * the table are XOR'd together.
 *
 * AES also defines addition and multiplication of words, that is 4-byte
 * numbers represented as polynomials of 3 degrees where the coefficients
 * are the values of the bytes.
 *
 * The word [a0, a1, a2, a3] is a polynomial a3x^3 + a2x^2 + a1x + a0.
 *
 * Addition is performed by XOR'ing like powers of x. Multiplication
 * is performed in two steps, the first is an algebraic expansion as
 * you would do normally (where addition is XOR). But the result is
 * a polynomial larger than 3 degrees and thus it cannot fit in a word. So
 * next the result is modularly reduced by an AES-specific polynomial of
 * degree 4 which will always produce a polynomial of less than 4 degrees
 * such that it will fit in a word. In AES, this polynomial is x^4 + 1.
 *
 * The modular product of two polynomials 'a' and 'b' is thus:
 *
 * d(x) = d3x^3 + d2x^2 + d1x + d0
 * with
 * d0 = GF(a0, b0) ^ GF(a3, b1) ^ GF(a2, b2) ^ GF(a1, b3)
 * d1 = GF(a1, b0) ^ GF(a0, b1) ^ GF(a3, b2) ^ GF(a2, b3)
 * d2 = GF(a2, b0) ^ GF(a1, b1) ^ GF(a0, b2) ^ GF(a3, b3)
 * d3 = GF(a3, b0) ^ GF(a2, b1) ^ GF(a1, b2) ^ GF(a0, b3)
 *
 * As a matrix:
 *
 * [d0] = [a0 a3 a2 a1][b0]
 * [d1]   [a1 a0 a3 a2][b1]
 * [d2]   [a2 a1 a0 a3][b2]
 * [d3]   [a3 a2 a1 a0][b3]
 *
 * Special polynomials defined by AES (0x02 == {02}):
 * a(x)    = {03}x^3 + {01}x^2 + {01}x + {02}
 * a^-1(x) = {0b}x^3 + {0d}x^2 + {09}x + {0e}.
 *
 * These polynomials are used in the MixColumns() and InverseMixColumns()
 * operations, respectively, to cause each element in the state to affect
 * the output (referred to as diffusing).
 *
 * RotWord() uses: a0 = a1 = a2 = {00} and a3 = {01}, which is the
 * polynomial x3.
 *
 * The ShiftRows() method modifies the last 3 rows in the state (where
 * the state is 4 words with 4 bytes per word) by shifting bytes cyclically.
 * The 1st byte in the second row is moved to the end of the row. The 1st
 * and 2nd bytes in the third row are moved to the end of the row. The 1st,
 * 2nd, and 3rd bytes are moved in the fourth row.
 *
 * More details on how AES arithmetic works:
 *
 * In the polynomial representation of binary numbers, XOR performs addition
 * and subtraction and multiplication in GF(2^8) denoted as GF(a, b)
 * corresponds with the multiplication of polynomials modulo an irreducible
 * polynomial of degree 8. In other words, for AES, GF(a, b) will multiply
 * polynomial 'a' with polynomial 'b' and then do a modular reduction by
 * an AES-specific irreducible polynomial of degree 8.
 *
 * A polynomial is irreducible if its only divisors are one and itself. For
 * the AES algorithm, this irreducible polynomial is:
 *
 * m(x) = x^8 + x^4 + x^3 + x + 1,
 *
 * or {01}{1b} in hexadecimal notation, where each coefficient is a bit:
 * 100011011 = 283 = 0x11b.
 *
 * For example, GF(0x57, 0x83) = 0xc1 because
 *
 * 0x57 = 87  = 01010111 = x^6 + x^4 + x^2 + x + 1
 * 0x85 = 131 = 10000101 = x^7 + x + 1
 *
 * (x^6 + x^4 + x^2 + x + 1) * (x^7 + x + 1)
 * =  x^13 + x^11 + x^9 + x^8 + x^7 +
 *    x^7 + x^5 + x^3 + x^2 + x +
 *    x^6 + x^4 + x^2 + x + 1
 * =  x^13 + x^11 + x^9 + x^8 + x^6 + x^5 + x^4 + x^3 + 1 = y
 *    y modulo (x^8 + x^4 + x^3 + x + 1)
 * =  x^7 + x^6 + 1.
 *
 * The modular reduction by m(x) guarantees the result will be a binary
 * polynomial of less than degree 8, so that it can fit in a byte.
 *
 * The operation to multiply a binary polynomial b with x (the polynomial
 * x in binary representation is 00000010) is:
 *
 * b_7x^8 + b_6x^7 + b_5x^6 + b_4x^5 + b_3x^4 + b_2x^3 + b_1x^2 + b_0x^1
 *
 * To get GF(b, x) we must reduce that by m(x). If b_7 is 0 (that is the
 * most significant bit is 0 in b) then the result is already reduced. If
 * it is 1, then we can reduce it by subtracting m(x) via an XOR.
 *
 * It follows that multiplication by x (00000010 or 0x02) can be implemented
 * by performing a left shift followed by a conditional bitwise XOR with
 * 0x1b. This operation on bytes is denoted by xtime(). Multiplication by
 * higher powers of x can be implemented by repeated application of xtime().
 *
 * By adding intermediate results, multiplication by any constant can be
 * implemented. For instance:
 *
 * GF(0x57, 0x13) = 0xfe because:
 *
 * xtime(b) = (b & 128) ? (b << 1 ^ 0x11b) : (b << 1)
 *
 * Note: We XOR with 0x11b instead of 0x1b because in javascript our
 * datatype for b can be larger than 1 byte, so a left shift will not
 * automatically eliminate bits that overflow a byte ... by XOR'ing the
 * overflow bit with 1 (the extra one from 0x11b) we zero it out.
 *
 * GF(0x57, 0x02) = xtime(0x57) = 0xae
 * GF(0x57, 0x04) = xtime(0xae) = 0x47
 * GF(0x57, 0x08) = xtime(0x47) = 0x8e
 * GF(0x57, 0x10) = xtime(0x8e) = 0x07
 *
 * GF(0x57, 0x13) = GF(0x57, (0x01 ^ 0x02 ^ 0x10))
 *
 * And by the distributive property (since XOR is addition and GF() is
 * multiplication):
 *
 * = GF(0x57, 0x01) ^ GF(0x57, 0x02) ^ GF(0x57, 0x10)
 * = 0x57 ^ 0xae ^ 0x07
 * = 0xfe.
 */ function $60d76afb9d7c069c$var$initialize() {
    $60d76afb9d7c069c$var$init = true;
    /* Populate the Rcon table. These are the values given by
    [x^(i-1),{00},{00},{00}] where x^(i-1) are powers of x (and x = 0x02)
    in the field of GF(2^8), where i starts at 1.

    rcon[0] = [0x00, 0x00, 0x00, 0x00]
    rcon[1] = [0x01, 0x00, 0x00, 0x00] 2^(1-1) = 2^0 = 1
    rcon[2] = [0x02, 0x00, 0x00, 0x00] 2^(2-1) = 2^1 = 2
    ...
    rcon[9]  = [0x1B, 0x00, 0x00, 0x00] 2^(9-1)  = 2^8 = 0x1B
    rcon[10] = [0x36, 0x00, 0x00, 0x00] 2^(10-1) = 2^9 = 0x36

    We only store the first byte because it is the only one used.
  */ $60d76afb9d7c069c$var$rcon = [
        0x00,
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1B,
        0x36
    ];
    // compute xtime table which maps i onto GF(i, 0x02)
    var xtime = new Array(256);
    for(var i = 0; i < 128; ++i){
        xtime[i] = i << 1;
        xtime[i + 128] = i + 128 << 1 ^ 0x11B;
    }
    // compute all other tables
    $60d76afb9d7c069c$var$sbox = new Array(256);
    $60d76afb9d7c069c$var$isbox = new Array(256);
    $60d76afb9d7c069c$var$mix = new Array(4);
    $60d76afb9d7c069c$var$imix = new Array(4);
    for(var i = 0; i < 4; ++i){
        $60d76afb9d7c069c$var$mix[i] = new Array(256);
        $60d76afb9d7c069c$var$imix[i] = new Array(256);
    }
    var e = 0, ei = 0, e2, e4, e8, sx, sx2, me, ime;
    for(var i = 0; i < 256; ++i){
        /* We need to generate the SubBytes() sbox and isbox tables so that
      we can perform byte substitutions. This requires us to traverse
      all of the elements in GF, find their multiplicative inverses,
      and apply to each the following affine transformation:

      bi' = bi ^ b(i + 4) mod 8 ^ b(i + 5) mod 8 ^ b(i + 6) mod 8 ^
            b(i + 7) mod 8 ^ ci
      for 0 <= i < 8, where bi is the ith bit of the byte, and ci is the
      ith bit of a byte c with the value {63} or {01100011}.

      It is possible to traverse every possible value in a Galois field
      using what is referred to as a 'generator'. There are many
      generators (128 out of 256): 3,5,6,9,11,82 to name a few. To fully
      traverse GF we iterate 255 times, multiplying by our generator
      each time.

      On each iteration we can determine the multiplicative inverse for
      the current element.

      Suppose there is an element in GF 'e'. For a given generator 'g',
      e = g^x. The multiplicative inverse of e is g^(255 - x). It turns
      out that if use the inverse of a generator as another generator
      it will produce all of the corresponding multiplicative inverses
      at the same time. For this reason, we choose 5 as our inverse
      generator because it only requires 2 multiplies and 1 add and its
      inverse, 82, requires relatively few operations as well.

      In order to apply the affine transformation, the multiplicative
      inverse 'ei' of 'e' can be repeatedly XOR'd (4 times) with a
      bit-cycling of 'ei'. To do this 'ei' is first stored in 's' and
      'x'. Then 's' is left shifted and the high bit of 's' is made the
      low bit. The resulting value is stored in 's'. Then 'x' is XOR'd
      with 's' and stored in 'x'. On each subsequent iteration the same
      operation is performed. When 4 iterations are complete, 'x' is
      XOR'd with 'c' (0x63) and the transformed value is stored in 'x'.
      For example:

      s = 01000001
      x = 01000001

      iteration 1: s = 10000010, x ^= s
      iteration 2: s = 00000101, x ^= s
      iteration 3: s = 00001010, x ^= s
      iteration 4: s = 00010100, x ^= s
      x ^= 0x63

      This can be done with a loop where s = (s << 1) | (s >> 7). However,
      it can also be done by using a single 16-bit (in this case 32-bit)
      number 'sx'. Since XOR is an associative operation, we can set 'sx'
      to 'ei' and then XOR it with 'sx' left-shifted 1,2,3, and 4 times.
      The most significant bits will flow into the high 8 bit positions
      and be correctly XOR'd with one another. All that remains will be
      to cycle the high 8 bits by XOR'ing them all with the lower 8 bits
      afterwards.

      At the same time we're populating sbox and isbox we can precompute
      the multiplication we'll need to do to do MixColumns() later.
    */ // apply affine transformation
        sx = ei ^ ei << 1 ^ ei << 2 ^ ei << 3 ^ ei << 4;
        sx = sx >> 8 ^ sx & 255 ^ 0x63;
        // update tables
        $60d76afb9d7c069c$var$sbox[e] = sx;
        $60d76afb9d7c069c$var$isbox[sx] = e;
        /* Mixing columns is done using matrix multiplication. The columns
      that are to be mixed are each a single word in the current state.
      The state has Nb columns (4 columns). Therefore each column is a
      4 byte word. So to mix the columns in a single column 'c' where
      its rows are r0, r1, r2, and r3, we use the following matrix
      multiplication:

      [2 3 1 1]*[r0,c]=[r'0,c]
      [1 2 3 1] [r1,c] [r'1,c]
      [1 1 2 3] [r2,c] [r'2,c]
      [3 1 1 2] [r3,c] [r'3,c]

      r0, r1, r2, and r3 are each 1 byte of one of the words in the
      state (a column). To do matrix multiplication for each mixed
      column c' we multiply the corresponding row from the left matrix
      with the corresponding column from the right matrix. In total, we
      get 4 equations:

      r0,c' = 2*r0,c + 3*r1,c + 1*r2,c + 1*r3,c
      r1,c' = 1*r0,c + 2*r1,c + 3*r2,c + 1*r3,c
      r2,c' = 1*r0,c + 1*r1,c + 2*r2,c + 3*r3,c
      r3,c' = 3*r0,c + 1*r1,c + 1*r2,c + 2*r3,c

      As usual, the multiplication is as previously defined and the
      addition is XOR. In order to optimize mixing columns we can store
      the multiplication results in tables. If you think of the whole
      column as a word (it might help to visualize by mentally rotating
      the equations above by counterclockwise 90 degrees) then you can
      see that it would be useful to map the multiplications performed on
      each byte (r0, r1, r2, r3) onto a word as well. For instance, we
      could map 2*r0,1*r0,1*r0,3*r0 onto a word by storing 2*r0 in the
      highest 8 bits and 3*r0 in the lowest 8 bits (with the other two
      respectively in the middle). This means that a table can be
      constructed that uses r0 as an index to the word. We can do the
      same with r1, r2, and r3, creating a total of 4 tables.

      To construct a full c', we can just look up each byte of c in
      their respective tables and XOR the results together.

      Also, to build each table we only have to calculate the word
      for 2,1,1,3 for every byte ... which we can do on each iteration
      of this loop since we will iterate over every byte. After we have
      calculated 2,1,1,3 we can get the results for the other tables
      by cycling the byte at the end to the beginning. For instance
      we can take the result of table 2,1,1,3 and produce table 3,2,1,1
      by moving the right most byte to the left most position just like
      how you can imagine the 3 moved out of 2,1,1,3 and to the front
      to produce 3,2,1,1.

      There is another optimization in that the same multiples of
      the current element we need in order to advance our generator
      to the next iteration can be reused in performing the 2,1,1,3
      calculation. We also calculate the inverse mix column tables,
      with e,9,d,b being the inverse of 2,1,1,3.

      When we're done, and we need to actually mix columns, the first
      byte of each state word should be put through mix[0] (2,1,1,3),
      the second through mix[1] (3,2,1,1) and so forth. Then they should
      be XOR'd together to produce the fully mixed column.
    */ // calculate mix and imix table values
        sx2 = xtime[sx];
        e2 = xtime[e];
        e4 = xtime[e2];
        e8 = xtime[e4];
        me = sx2 << 24 ^ // 2
        sx << 16 ^ // 1
        sx << 8 ^ // 1
        (sx ^ sx2); // 3
        ime = (e2 ^ e4 ^ e8) << 24 ^ // E (14)
        (e ^ e8) << 16 ^ // 9
        (e ^ e4 ^ e8) << 8 ^ // D (13)
        (e ^ e2 ^ e8); // B (11)
        // produce each of the mix tables by rotating the 2,1,1,3 value
        for(var n = 0; n < 4; ++n){
            $60d76afb9d7c069c$var$mix[n][e] = me;
            $60d76afb9d7c069c$var$imix[n][sx] = ime;
            // cycle the right most byte to the left most position
            // ie: 2,1,1,3 becomes 3,2,1,1
            me = me << 24 | me >>> 8;
            ime = ime << 24 | ime >>> 8;
        }
        // get next element and inverse
        if (e === 0) // 1 is the inverse of 1
        e = ei = 1;
        else {
            // e = 2e + 2*2*2*(10e)) = multiply e by 82 (chosen generator)
            // ei = ei + 2*2*ei = multiply ei by 5 (inverse generator)
            e = e2 ^ xtime[xtime[xtime[e2 ^ e8]]];
            ei ^= xtime[xtime[ei]];
        }
    }
}
/**
 * Generates a key schedule using the AES key expansion algorithm.
 *
 * The AES algorithm takes the Cipher Key, K, and performs a Key Expansion
 * routine to generate a key schedule. The Key Expansion generates a total
 * of Nb*(Nr + 1) words: the algorithm requires an initial set of Nb words,
 * and each of the Nr rounds requires Nb words of key data. The resulting
 * key schedule consists of a linear array of 4-byte words, denoted [wi ],
 * with i in the range 0 <= i < Nb(Nr + 1).
 *
 * KeyExpansion(byte key[4*Nk], word w[Nb*(Nr+1)], Nk)
 * AES-128 (Nb=4, Nk=4, Nr=10)
 * AES-192 (Nb=4, Nk=6, Nr=12)
 * AES-256 (Nb=4, Nk=8, Nr=14)
 * Note: Nr=Nk+6.
 *
 * Nb is the number of columns (32-bit words) comprising the State (or
 * number of bytes in a block). For AES, Nb=4.
 *
 * @param key the key to schedule (as an array of 32-bit words).
 * @param decrypt true to modify the key schedule to decrypt, false not to.
 *
 * @return the generated key schedule.
 */ function $60d76afb9d7c069c$var$_expandKey(key, decrypt) {
    // copy the key's words to initialize the key schedule
    var w = key.slice(0);
    /* RotWord() will rotate a word, moving the first byte to the last
    byte's position (shifting the other bytes left).

    We will be getting the value of Rcon at i / Nk. 'i' will iterate
    from Nk to (Nb * Nr+1). Nk = 4 (4 byte key), Nb = 4 (4 words in
    a block), Nr = Nk + 6 (10). Therefore 'i' will iterate from
    4 to 44 (exclusive). Each time we iterate 4 times, i / Nk will
    increase by 1. We use a counter iNk to keep track of this.
   */ // go through the rounds expanding the key
    var temp, iNk = 1;
    var Nk = w.length;
    var Nr1 = Nk + 6 + 1;
    var end = $60d76afb9d7c069c$var$Nb * Nr1;
    for(var i = Nk; i < end; ++i){
        temp = w[i - 1];
        if (i % Nk === 0) {
            // temp = SubWord(RotWord(temp)) ^ Rcon[i / Nk]
            temp = $60d76afb9d7c069c$var$sbox[temp >>> 16 & 255] << 24 ^ $60d76afb9d7c069c$var$sbox[temp >>> 8 & 255] << 16 ^ $60d76afb9d7c069c$var$sbox[temp & 255] << 8 ^ $60d76afb9d7c069c$var$sbox[temp >>> 24] ^ $60d76afb9d7c069c$var$rcon[iNk] << 24;
            iNk++;
        } else if (Nk > 6 && i % Nk === 4) // temp = SubWord(temp)
        temp = $60d76afb9d7c069c$var$sbox[temp >>> 24] << 24 ^ $60d76afb9d7c069c$var$sbox[temp >>> 16 & 255] << 16 ^ $60d76afb9d7c069c$var$sbox[temp >>> 8 & 255] << 8 ^ $60d76afb9d7c069c$var$sbox[temp & 255];
        w[i] = w[i - Nk] ^ temp;
    }
    /* When we are updating a cipher block we always use the code path for
     encryption whether we are decrypting or not (to shorten code and
     simplify the generation of look up tables). However, because there
     are differences in the decryption algorithm, other than just swapping
     in different look up tables, we must transform our key schedule to
     account for these changes:

     1. The decryption algorithm gets its key rounds in reverse order.
     2. The decryption algorithm adds the round key before mixing columns
       instead of afterwards.

     We don't need to modify our key schedule to handle the first case,
     we can just traverse the key schedule in reverse order when decrypting.

     The second case requires a little work.

     The tables we built for performing rounds will take an input and then
     perform SubBytes() and MixColumns() or, for the decrypt version,
     InvSubBytes() and InvMixColumns(). But the decrypt algorithm requires
     us to AddRoundKey() before InvMixColumns(). This means we'll need to
     apply some transformations to the round key to inverse-mix its columns
     so they'll be correct for moving AddRoundKey() to after the state has
     had its columns inverse-mixed.

     To inverse-mix the columns of the state when we're decrypting we use a
     lookup table that will apply InvSubBytes() and InvMixColumns() at the
     same time. However, the round key's bytes are not inverse-substituted
     in the decryption algorithm. To get around this problem, we can first
     substitute the bytes in the round key so that when we apply the
     transformation via the InvSubBytes()+InvMixColumns() table, it will
     undo our substitution leaving us with the original value that we
     want -- and then inverse-mix that value.

     This change will correctly alter our key schedule so that we can XOR
     each round key with our already transformed decryption state. This
     allows us to use the same code path as the encryption algorithm.

     We make one more change to the decryption key. Since the decryption
     algorithm runs in reverse from the encryption algorithm, we reverse
     the order of the round keys to avoid having to iterate over the key
     schedule backwards when running the encryption algorithm later in
     decryption mode. In addition to reversing the order of the round keys,
     we also swap each round key's 2nd and 4th rows. See the comments
     section where rounds are performed for more details about why this is
     done. These changes are done inline with the other substitution
     described above.
  */ if (decrypt) {
        var tmp;
        var m0 = $60d76afb9d7c069c$var$imix[0];
        var m1 = $60d76afb9d7c069c$var$imix[1];
        var m2 = $60d76afb9d7c069c$var$imix[2];
        var m3 = $60d76afb9d7c069c$var$imix[3];
        var wnew = w.slice(0);
        end = w.length;
        for(var i = 0, wi = end - $60d76afb9d7c069c$var$Nb; i < end; i += $60d76afb9d7c069c$var$Nb, wi -= $60d76afb9d7c069c$var$Nb){
            // do not sub the first or last round key (round keys are Nb
            // words) as no column mixing is performed before they are added,
            // but do change the key order
            if (i === 0 || i === end - $60d76afb9d7c069c$var$Nb) {
                wnew[i] = w[wi];
                wnew[i + 1] = w[wi + 3];
                wnew[i + 2] = w[wi + 2];
                wnew[i + 3] = w[wi + 1];
            } else // substitute each round key byte because the inverse-mix
            // table will inverse-substitute it (effectively cancel the
            // substitution because round key bytes aren't sub'd in
            // decryption mode) and swap indexes 3 and 1
            for(var n = 0; n < $60d76afb9d7c069c$var$Nb; ++n){
                tmp = w[wi + n];
                wnew[i + (3 & -n)] = m0[$60d76afb9d7c069c$var$sbox[tmp >>> 24]] ^ m1[$60d76afb9d7c069c$var$sbox[tmp >>> 16 & 255]] ^ m2[$60d76afb9d7c069c$var$sbox[tmp >>> 8 & 255]] ^ m3[$60d76afb9d7c069c$var$sbox[tmp & 255]];
            }
        }
        w = wnew;
    }
    return w;
}
/**
 * Updates a single block (16 bytes) using AES. The update will either
 * encrypt or decrypt the block.
 *
 * @param w the key schedule.
 * @param input the input block (an array of 32-bit words).
 * @param output the updated output block.
 * @param decrypt true to decrypt the block, false to encrypt it.
 */ function $60d76afb9d7c069c$var$_updateBlock(w, input, output, decrypt) {
    /*
  Cipher(byte in[4*Nb], byte out[4*Nb], word w[Nb*(Nr+1)])
  begin
    byte state[4,Nb]
    state = in
    AddRoundKey(state, w[0, Nb-1])
    for round = 1 step 1 to Nr-1
      SubBytes(state)
      ShiftRows(state)
      MixColumns(state)
      AddRoundKey(state, w[round*Nb, (round+1)*Nb-1])
    end for
    SubBytes(state)
    ShiftRows(state)
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    out = state
  end

  InvCipher(byte in[4*Nb], byte out[4*Nb], word w[Nb*(Nr+1)])
  begin
    byte state[4,Nb]
    state = in
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    for round = Nr-1 step -1 downto 1
      InvShiftRows(state)
      InvSubBytes(state)
      AddRoundKey(state, w[round*Nb, (round+1)*Nb-1])
      InvMixColumns(state)
    end for
    InvShiftRows(state)
    InvSubBytes(state)
    AddRoundKey(state, w[0, Nb-1])
    out = state
  end
  */ // Encrypt: AddRoundKey(state, w[0, Nb-1])
    // Decrypt: AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    var Nr = w.length / 4 - 1;
    var m0, m1, m2, m3, sub;
    if (decrypt) {
        m0 = $60d76afb9d7c069c$var$imix[0];
        m1 = $60d76afb9d7c069c$var$imix[1];
        m2 = $60d76afb9d7c069c$var$imix[2];
        m3 = $60d76afb9d7c069c$var$imix[3];
        sub = $60d76afb9d7c069c$var$isbox;
    } else {
        m0 = $60d76afb9d7c069c$var$mix[0];
        m1 = $60d76afb9d7c069c$var$mix[1];
        m2 = $60d76afb9d7c069c$var$mix[2];
        m3 = $60d76afb9d7c069c$var$mix[3];
        sub = $60d76afb9d7c069c$var$sbox;
    }
    var a, b, c, d, a2, b2, c2;
    a = input[0] ^ w[0];
    b = input[decrypt ? 3 : 1] ^ w[1];
    c = input[2] ^ w[2];
    d = input[decrypt ? 1 : 3] ^ w[3];
    var i = 3;
    /* In order to share code we follow the encryption algorithm when both
    encrypting and decrypting. To account for the changes required in the
    decryption algorithm, we use different lookup tables when decrypting
    and use a modified key schedule to account for the difference in the
    order of transformations applied when performing rounds. We also get
    key rounds in reverse order (relative to encryption). */ for(var round = 1; round < Nr; ++round){
        /* As described above, we'll be using table lookups to perform the
      column mixing. Each column is stored as a word in the state (the
      array 'input' has one column as a word at each index). In order to
      mix a column, we perform these transformations on each row in c,
      which is 1 byte in each word. The new column for c0 is c'0:

               m0      m1      m2      m3
      r0,c'0 = 2*r0,c0 + 3*r1,c0 + 1*r2,c0 + 1*r3,c0
      r1,c'0 = 1*r0,c0 + 2*r1,c0 + 3*r2,c0 + 1*r3,c0
      r2,c'0 = 1*r0,c0 + 1*r1,c0 + 2*r2,c0 + 3*r3,c0
      r3,c'0 = 3*r0,c0 + 1*r1,c0 + 1*r2,c0 + 2*r3,c0

      So using mix tables where c0 is a word with r0 being its upper
      8 bits and r3 being its lower 8 bits:

      m0[c0 >> 24] will yield this word: [2*r0,1*r0,1*r0,3*r0]
      ...
      m3[c0 & 255] will yield this word: [1*r3,1*r3,3*r3,2*r3]

      Therefore to mix the columns in each word in the state we
      do the following (& 255 omitted for brevity):
      c'0,r0 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r1 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r2 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r3 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]

      However, before mixing, the algorithm requires us to perform
      ShiftRows(). The ShiftRows() transformation cyclically shifts the
      last 3 rows of the state over different offsets. The first row
      (r = 0) is not shifted.

      s'_r,c = s_r,(c + shift(r, Nb) mod Nb
      for 0 < r < 4 and 0 <= c < Nb and
      shift(1, 4) = 1
      shift(2, 4) = 2
      shift(3, 4) = 3.

      This causes the first byte in r = 1 to be moved to the end of
      the row, the first 2 bytes in r = 2 to be moved to the end of
      the row, the first 3 bytes in r = 3 to be moved to the end of
      the row:

      r1: [c0 c1 c2 c3] => [c1 c2 c3 c0]
      r2: [c0 c1 c2 c3]    [c2 c3 c0 c1]
      r3: [c0 c1 c2 c3]    [c3 c0 c1 c2]

      We can make these substitutions inline with our column mixing to
      generate an updated set of equations to produce each word in the
      state (note the columns have changed positions):

      c0 c1 c2 c3 => c0 c1 c2 c3
      c0 c1 c2 c3    c1 c2 c3 c0  (cycled 1 byte)
      c0 c1 c2 c3    c2 c3 c0 c1  (cycled 2 bytes)
      c0 c1 c2 c3    c3 c0 c1 c2  (cycled 3 bytes)

      Therefore:

      c'0 = 2*r0,c0 + 3*r1,c1 + 1*r2,c2 + 1*r3,c3
      c'0 = 1*r0,c0 + 2*r1,c1 + 3*r2,c2 + 1*r3,c3
      c'0 = 1*r0,c0 + 1*r1,c1 + 2*r2,c2 + 3*r3,c3
      c'0 = 3*r0,c0 + 1*r1,c1 + 1*r2,c2 + 2*r3,c3

      c'1 = 2*r0,c1 + 3*r1,c2 + 1*r2,c3 + 1*r3,c0
      c'1 = 1*r0,c1 + 2*r1,c2 + 3*r2,c3 + 1*r3,c0
      c'1 = 1*r0,c1 + 1*r1,c2 + 2*r2,c3 + 3*r3,c0
      c'1 = 3*r0,c1 + 1*r1,c2 + 1*r2,c3 + 2*r3,c0

      ... and so forth for c'2 and c'3. The important distinction is
      that the columns are cycling, with c0 being used with the m0
      map when calculating c0, but c1 being used with the m0 map when
      calculating c1 ... and so forth.

      When performing the inverse we transform the mirror image and
      skip the bottom row, instead of the top one, and move upwards:

      c3 c2 c1 c0 => c0 c3 c2 c1  (cycled 3 bytes) *same as encryption
      c3 c2 c1 c0    c1 c0 c3 c2  (cycled 2 bytes)
      c3 c2 c1 c0    c2 c1 c0 c3  (cycled 1 byte)  *same as encryption
      c3 c2 c1 c0    c3 c2 c1 c0

      If you compare the resulting matrices for ShiftRows()+MixColumns()
      and for InvShiftRows()+InvMixColumns() the 2nd and 4th columns are
      different (in encrypt mode vs. decrypt mode). So in order to use
      the same code to handle both encryption and decryption, we will
      need to do some mapping.

      If in encryption mode we let a=c0, b=c1, c=c2, d=c3, and r<N> be
      a row number in the state, then the resulting matrix in encryption
      mode for applying the above transformations would be:

      r1: a b c d
      r2: b c d a
      r3: c d a b
      r4: d a b c

      If we did the same in decryption mode we would get:

      r1: a d c b
      r2: b a d c
      r3: c b a d
      r4: d c b a

      If instead we swap d and b (set b=c3 and d=c1), then we get:

      r1: a b c d
      r2: d a b c
      r3: c d a b
      r4: b c d a

      Now the 1st and 3rd rows are the same as the encryption matrix. All
      we need to do then to make the mapping exactly the same is to swap
      the 2nd and 4th rows when in decryption mode. To do this without
      having to do it on each iteration, we swapped the 2nd and 4th rows
      in the decryption key schedule. We also have to do the swap above
      when we first pull in the input and when we set the final output. */ a2 = m0[a >>> 24] ^ m1[b >>> 16 & 255] ^ m2[c >>> 8 & 255] ^ m3[d & 255] ^ w[++i];
        b2 = m0[b >>> 24] ^ m1[c >>> 16 & 255] ^ m2[d >>> 8 & 255] ^ m3[a & 255] ^ w[++i];
        c2 = m0[c >>> 24] ^ m1[d >>> 16 & 255] ^ m2[a >>> 8 & 255] ^ m3[b & 255] ^ w[++i];
        d = m0[d >>> 24] ^ m1[a >>> 16 & 255] ^ m2[b >>> 8 & 255] ^ m3[c & 255] ^ w[++i];
        a = a2;
        b = b2;
        c = c2;
    }
    /*
    Encrypt:
    SubBytes(state)
    ShiftRows(state)
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])

    Decrypt:
    InvShiftRows(state)
    InvSubBytes(state)
    AddRoundKey(state, w[0, Nb-1])
   */ // Note: rows are shifted inline
    output[0] = sub[a >>> 24] << 24 ^ sub[b >>> 16 & 255] << 16 ^ sub[c >>> 8 & 255] << 8 ^ sub[d & 255] ^ w[++i];
    output[decrypt ? 3 : 1] = sub[b >>> 24] << 24 ^ sub[c >>> 16 & 255] << 16 ^ sub[d >>> 8 & 255] << 8 ^ sub[a & 255] ^ w[++i];
    output[2] = sub[c >>> 24] << 24 ^ sub[d >>> 16 & 255] << 16 ^ sub[a >>> 8 & 255] << 8 ^ sub[b & 255] ^ w[++i];
    output[decrypt ? 1 : 3] = sub[d >>> 24] << 24 ^ sub[a >>> 16 & 255] << 16 ^ sub[b >>> 8 & 255] << 8 ^ sub[c & 255] ^ w[++i];
}
/**
 * Deprecated. Instead, use:
 *
 * forge.cipher.createCipher('AES-<mode>', key);
 * forge.cipher.createDecipher('AES-<mode>', key);
 *
 * Creates a deprecated AES cipher object. This object's mode will default to
 * CBC (cipher-block-chaining).
 *
 * The key and iv may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param options the options to use.
 *          key the symmetric key to use.
 *          output the buffer to write to.
 *          decrypt true for decryption, false for encryption.
 *          mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ function $60d76afb9d7c069c$var$_createCipher(options) {
    options = options || {};
    var mode = (options.mode || "CBC").toUpperCase();
    var algorithm = "AES-" + mode;
    var cipher;
    if (options.decrypt) cipher = $hSPkV.cipher.createDecipher(algorithm, options.key);
    else cipher = $hSPkV.cipher.createCipher(algorithm, options.key);
    // backwards compatible start API
    var start = cipher.start;
    cipher.start = function(iv, options) {
        // backwards compatibility: support second arg as output buffer
        var output = null;
        if (options instanceof $hSPkV.util.ByteBuffer) {
            output = options;
            options = {};
        }
        options = options || {};
        options.output = output;
        options.iv = iv;
        start.call(cipher, options);
    };
    return cipher;
}

});
parcelRequire.register("70wgw", function(module, exports) {
/**
 * Cipher base API.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $hSPkV = parcelRequire("hSPkV");
parcelRequire("3lPw4");
module.exports = $hSPkV.cipher = $hSPkV.cipher || {};
// registered algorithms
$hSPkV.cipher.algorithms = $hSPkV.cipher.algorithms || {};
/**
 * Creates a cipher object that can be used to encrypt data using the given
 * algorithm and key. The algorithm may be provided as a string value for a
 * previously registered algorithm or it may be given as a cipher algorithm
 * API object.
 *
 * @param algorithm the algorithm to use, either a string or an algorithm API
 *          object.
 * @param key the key to use, as a binary-encoded string of bytes or a
 *          byte buffer.
 *
 * @return the cipher.
 */ $hSPkV.cipher.createCipher = function(algorithm, key) {
    var api = algorithm;
    if (typeof api === "string") {
        api = $hSPkV.cipher.getAlgorithm(api);
        if (api) api = api();
    }
    if (!api) throw new Error("Unsupported algorithm: " + algorithm);
    // assume block cipher
    return new $hSPkV.cipher.BlockCipher({
        algorithm: api,
        key: key,
        decrypt: false
    });
};
/**
 * Creates a decipher object that can be used to decrypt data using the given
 * algorithm and key. The algorithm may be provided as a string value for a
 * previously registered algorithm or it may be given as a cipher algorithm
 * API object.
 *
 * @param algorithm the algorithm to use, either a string or an algorithm API
 *          object.
 * @param key the key to use, as a binary-encoded string of bytes or a
 *          byte buffer.
 *
 * @return the cipher.
 */ $hSPkV.cipher.createDecipher = function(algorithm, key) {
    var api = algorithm;
    if (typeof api === "string") {
        api = $hSPkV.cipher.getAlgorithm(api);
        if (api) api = api();
    }
    if (!api) throw new Error("Unsupported algorithm: " + algorithm);
    // assume block cipher
    return new $hSPkV.cipher.BlockCipher({
        algorithm: api,
        key: key,
        decrypt: true
    });
};
/**
 * Registers an algorithm by name. If the name was already registered, the
 * algorithm API object will be overwritten.
 *
 * @param name the name of the algorithm.
 * @param algorithm the algorithm API object.
 */ $hSPkV.cipher.registerAlgorithm = function(name, algorithm) {
    name = name.toUpperCase();
    $hSPkV.cipher.algorithms[name] = algorithm;
};
/**
 * Gets a registered algorithm by name.
 *
 * @param name the name of the algorithm.
 *
 * @return the algorithm, if found, null if not.
 */ $hSPkV.cipher.getAlgorithm = function(name) {
    name = name.toUpperCase();
    if (name in $hSPkV.cipher.algorithms) return $hSPkV.cipher.algorithms[name];
    return null;
};
var $51a18fb854f0ccba$var$BlockCipher = $hSPkV.cipher.BlockCipher = function(options) {
    this.algorithm = options.algorithm;
    this.mode = this.algorithm.mode;
    this.blockSize = this.mode.blockSize;
    this._finish = false;
    this._input = null;
    this.output = null;
    this._op = options.decrypt ? this.mode.decrypt : this.mode.encrypt;
    this._decrypt = options.decrypt;
    this.algorithm.initialize(options);
};
/**
 * Starts or restarts the encryption or decryption process, whichever
 * was previously configured.
 *
 * For non-GCM mode, the IV may be a binary-encoded string of bytes, an array
 * of bytes, a byte buffer, or an array of 32-bit integers. If the IV is in
 * bytes, then it must be Nb (16) bytes in length. If the IV is given in as
 * 32-bit integers, then it must be 4 integers long.
 *
 * Note: an IV is not required or used in ECB mode.
 *
 * For GCM-mode, the IV must be given as a binary-encoded string of bytes or
 * a byte buffer. The number of bytes should be 12 (96 bits) as recommended
 * by NIST SP-800-38D but another length may be given.
 *
 * @param options the options to use:
 *          iv the initialization vector to use as a binary-encoded string of
 *            bytes, null to reuse the last ciphered block from a previous
 *            update() (this "residue" method is for legacy support only).
 *          additionalData additional authentication data as a binary-encoded
 *            string of bytes, for 'GCM' mode, (default: none).
 *          tagLength desired length of authentication tag, in bits, for
 *            'GCM' mode (0-128, default: 128).
 *          tag the authentication tag to check if decrypting, as a
 *             binary-encoded string of bytes.
 *          output the output the buffer to write to, null to create one.
 */ $51a18fb854f0ccba$var$BlockCipher.prototype.start = function(options) {
    options = options || {};
    var opts = {};
    for(var key in options)opts[key] = options[key];
    opts.decrypt = this._decrypt;
    this._finish = false;
    this._input = $hSPkV.util.createBuffer();
    this.output = options.output || $hSPkV.util.createBuffer();
    this.mode.start(opts);
};
/**
 * Updates the next block according to the cipher mode.
 *
 * @param input the buffer to read from.
 */ $51a18fb854f0ccba$var$BlockCipher.prototype.update = function(input) {
    if (input) // input given, so empty it into the input buffer
    this._input.putBuffer(input);
    // do cipher operation until it needs more input and not finished
    while(!this._op.call(this.mode, this._input, this.output, this._finish) && !this._finish);
    // free consumed memory from input buffer
    this._input.compact();
};
/**
 * Finishes encrypting or decrypting.
 *
 * @param pad a padding function to use in CBC mode, null for default,
 *          signature(blockSize, buffer, decrypt).
 *
 * @return true if successful, false on error.
 */ $51a18fb854f0ccba$var$BlockCipher.prototype.finish = function(pad) {
    // backwards-compatibility w/deprecated padding API
    // Note: will overwrite padding functions even after another start() call
    if (pad && (this.mode.name === "ECB" || this.mode.name === "CBC")) {
        this.mode.pad = function(input) {
            return pad(this.blockSize, input, false);
        };
        this.mode.unpad = function(output) {
            return pad(this.blockSize, output, true);
        };
    }
    // build options for padding and afterFinish functions
    var options = {};
    options.decrypt = this._decrypt;
    // get # of bytes that won't fill a block
    options.overflow = this._input.length() % this.blockSize;
    if (!this._decrypt && this.mode.pad) {
        if (!this.mode.pad(this._input, options)) return false;
    }
    // do final update
    this._finish = true;
    this.update();
    if (this._decrypt && this.mode.unpad) {
        if (!this.mode.unpad(this.output, options)) return false;
    }
    if (this.mode.afterFinish) {
        if (!this.mode.afterFinish(this.output, options)) return false;
    }
    return true;
};

});

parcelRequire.register("gmtg3", function(module, exports) {
/**
 * Supported cipher modes.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $hSPkV = parcelRequire("hSPkV");
parcelRequire("3lPw4");
$hSPkV.cipher = $hSPkV.cipher || {};
// supported cipher modes
var $be95657534b2d7d9$var$modes = module.exports = $hSPkV.cipher.modes = $hSPkV.cipher.modes || {};
/** Electronic codebook (ECB) (Don't use this; it's not secure) **/ $be95657534b2d7d9$var$modes.ecb = function(options) {
    options = options || {};
    this.name = "ECB";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
};
$be95657534b2d7d9$var$modes.ecb.prototype.start = function(options) {};
$be95657534b2d7d9$var$modes.ecb.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = input.getInt32();
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // write output
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i]);
};
$be95657534b2d7d9$var$modes.ecb.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = input.getInt32();
    // decrypt block
    this.cipher.decrypt(this._inBlock, this._outBlock);
    // write output
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i]);
};
$be95657534b2d7d9$var$modes.ecb.prototype.pad = function(input, options) {
    // add PKCS#7 padding to block (each pad byte is the
    // value of the number of pad bytes)
    var padding = input.length() === this.blockSize ? this.blockSize : this.blockSize - input.length();
    input.fillWithByte(padding, padding);
    return true;
};
$be95657534b2d7d9$var$modes.ecb.prototype.unpad = function(output, options) {
    // check for error: input data not a multiple of blockSize
    if (options.overflow > 0) return false;
    // ensure padding byte count is valid
    var len = output.length();
    var count = output.at(len - 1);
    if (count > this.blockSize << 2) return false;
    // trim off padding bytes
    output.truncate(count);
    return true;
};
/** Cipher-block Chaining (CBC) **/ $be95657534b2d7d9$var$modes.cbc = function(options) {
    options = options || {};
    this.name = "CBC";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
};
$be95657534b2d7d9$var$modes.cbc.prototype.start = function(options) {
    // Note: legacy support for using IV residue (has security flaws)
    // if IV is null, reuse block from previous processing
    if (options.iv === null) {
        // must have a previous block
        if (!this._prev) throw new Error("Invalid IV parameter.");
        this._iv = this._prev.slice(0);
    } else if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    else {
        // save IV as "previous" block
        this._iv = $be95657534b2d7d9$var$transformIV(options.iv, this.blockSize);
        this._prev = this._iv.slice(0);
    }
};
$be95657534b2d7d9$var$modes.cbc.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    // CBC XOR's IV (or previous block) with plaintext
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._prev[i] ^ input.getInt32();
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // write output, save previous block
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i]);
    this._prev = this._outBlock;
};
$be95657534b2d7d9$var$modes.cbc.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = input.getInt32();
    // decrypt block
    this.cipher.decrypt(this._inBlock, this._outBlock);
    // write output, save previous ciphered block
    // CBC XOR's IV (or previous block) with ciphertext
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._prev[i] ^ this._outBlock[i]);
    this._prev = this._inBlock.slice(0);
};
$be95657534b2d7d9$var$modes.cbc.prototype.pad = function(input, options) {
    // add PKCS#7 padding to block (each pad byte is the
    // value of the number of pad bytes)
    var padding = input.length() === this.blockSize ? this.blockSize : this.blockSize - input.length();
    input.fillWithByte(padding, padding);
    return true;
};
$be95657534b2d7d9$var$modes.cbc.prototype.unpad = function(output, options) {
    // check for error: input data not a multiple of blockSize
    if (options.overflow > 0) return false;
    // ensure padding byte count is valid
    var len = output.length();
    var count = output.at(len - 1);
    if (count > this.blockSize << 2) return false;
    // trim off padding bytes
    output.truncate(count);
    return true;
};
/** Cipher feedback (CFB) **/ $be95657534b2d7d9$var$modes.cfb = function(options) {
    options = options || {};
    this.name = "CFB";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialBlock = new Array(this._ints);
    this._partialOutput = $hSPkV.util.createBuffer();
    this._partialBytes = 0;
};
$be95657534b2d7d9$var$modes.cfb.prototype.start = function(options) {
    if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    // use IV as first input
    this._iv = $be95657534b2d7d9$var$transformIV(options.iv, this.blockSize);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
};
$be95657534b2d7d9$var$modes.cfb.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output, write input as output
        for(var i = 0; i < this._ints; ++i){
            this._inBlock[i] = input.getInt32() ^ this._outBlock[i];
            output.putInt32(this._inBlock[i]);
        }
        return;
    }
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
    // XOR input with output, write input as partial output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i){
        this._partialBlock[i] = input.getInt32() ^ this._outBlock[i];
        this._partialOutput.putInt32(this._partialBlock[i]);
    }
    if (partialBytes > 0) // block still incomplete, restore input buffer
    input.read -= this.blockSize;
    else // block complete, update input block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._partialBlock[i];
    // skip any previous partial bytes
    if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
    if (partialBytes > 0 && !finish) {
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
};
$be95657534b2d7d9$var$modes.cfb.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block (CFB always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output, write input as output
        for(var i = 0; i < this._ints; ++i){
            this._inBlock[i] = input.getInt32();
            output.putInt32(this._inBlock[i] ^ this._outBlock[i]);
        }
        return;
    }
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
    // XOR input with output, write input as partial output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i){
        this._partialBlock[i] = input.getInt32();
        this._partialOutput.putInt32(this._partialBlock[i] ^ this._outBlock[i]);
    }
    if (partialBytes > 0) // block still incomplete, restore input buffer
    input.read -= this.blockSize;
    else // block complete, update input block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._partialBlock[i];
    // skip any previous partial bytes
    if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
    if (partialBytes > 0 && !finish) {
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
};
/** Output feedback (OFB) **/ $be95657534b2d7d9$var$modes.ofb = function(options) {
    options = options || {};
    this.name = "OFB";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialOutput = $hSPkV.util.createBuffer();
    this._partialBytes = 0;
};
$be95657534b2d7d9$var$modes.ofb.prototype.start = function(options) {
    if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    // use IV as first input
    this._iv = $be95657534b2d7d9$var$transformIV(options.iv, this.blockSize);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
};
$be95657534b2d7d9$var$modes.ofb.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (input.length() === 0) return true;
    // encrypt block (OFB always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output and update next input
        for(var i = 0; i < this._ints; ++i){
            output.putInt32(input.getInt32() ^ this._outBlock[i]);
            this._inBlock[i] = this._outBlock[i];
        }
        return;
    }
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
    // XOR input with output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i)this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
    if (partialBytes > 0) // block still incomplete, restore input buffer
    input.read -= this.blockSize;
    else // block complete, update input block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._outBlock[i];
    // skip any previous partial bytes
    if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
    if (partialBytes > 0 && !finish) {
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
};
$be95657534b2d7d9$var$modes.ofb.prototype.decrypt = $be95657534b2d7d9$var$modes.ofb.prototype.encrypt;
/** Counter (CTR) **/ $be95657534b2d7d9$var$modes.ctr = function(options) {
    options = options || {};
    this.name = "CTR";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialOutput = $hSPkV.util.createBuffer();
    this._partialBytes = 0;
};
$be95657534b2d7d9$var$modes.ctr.prototype.start = function(options) {
    if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    // use IV as first input
    this._iv = $be95657534b2d7d9$var$transformIV(options.iv, this.blockSize);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
};
$be95657534b2d7d9$var$modes.ctr.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block (CTR always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) // XOR input with output
    for(var i = 0; i < this._ints; ++i)output.putInt32(input.getInt32() ^ this._outBlock[i]);
    else {
        // handle partial block
        var partialBytes = (this.blockSize - inputLength) % this.blockSize;
        if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
        // XOR input with output
        this._partialOutput.clear();
        for(var i = 0; i < this._ints; ++i)this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
        if (partialBytes > 0) // block still incomplete, restore input buffer
        input.read -= this.blockSize;
        // skip any previous partial bytes
        if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
        if (partialBytes > 0 && !finish) {
            output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
            this._partialBytes = partialBytes;
            return true;
        }
        output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
        this._partialBytes = 0;
    }
    // block complete, increment counter (input block)
    $be95657534b2d7d9$var$inc32(this._inBlock);
};
$be95657534b2d7d9$var$modes.ctr.prototype.decrypt = $be95657534b2d7d9$var$modes.ctr.prototype.encrypt;
/** Galois/Counter Mode (GCM) **/ $be95657534b2d7d9$var$modes.gcm = function(options) {
    options = options || {};
    this.name = "GCM";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
    this._partialOutput = $hSPkV.util.createBuffer();
    this._partialBytes = 0;
    // R is actually this value concatenated with 120 more zero bits, but
    // we only XOR against R so the other zeros have no effect -- we just
    // apply this value to the first integer in a block
    this._R = 0xE1000000;
};
$be95657534b2d7d9$var$modes.gcm.prototype.start = function(options) {
    if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    // ensure IV is a byte buffer
    var iv = $hSPkV.util.createBuffer(options.iv);
    // no ciphered data processed yet
    this._cipherLength = 0;
    // default additional data is none
    var additionalData;
    if ("additionalData" in options) additionalData = $hSPkV.util.createBuffer(options.additionalData);
    else additionalData = $hSPkV.util.createBuffer();
    // default tag length is 128 bits
    if ("tagLength" in options) this._tagLength = options.tagLength;
    else this._tagLength = 128;
    // if tag is given, ensure tag matches tag length
    this._tag = null;
    if (options.decrypt) {
        // save tag to check later
        this._tag = $hSPkV.util.createBuffer(options.tag).getBytes();
        if (this._tag.length !== this._tagLength / 8) throw new Error("Authentication tag does not match tag length.");
    }
    // create tmp storage for hash calculation
    this._hashBlock = new Array(this._ints);
    // no tag generated yet
    this.tag = null;
    // generate hash subkey
    // (apply block cipher to "zero" block)
    this._hashSubkey = new Array(this._ints);
    this.cipher.encrypt([
        0,
        0,
        0,
        0
    ], this._hashSubkey);
    // generate table M
    // use 4-bit tables (32 component decomposition of a 16 byte value)
    // 8-bit tables take more space and are known to have security
    // vulnerabilities (in native implementations)
    this.componentBits = 4;
    this._m = this.generateHashTable(this._hashSubkey, this.componentBits);
    // Note: support IV length different from 96 bits? (only supporting
    // 96 bits is recommended by NIST SP-800-38D)
    // generate J_0
    var ivLength = iv.length();
    if (ivLength === 12) // 96-bit IV
    this._j0 = [
        iv.getInt32(),
        iv.getInt32(),
        iv.getInt32(),
        1
    ];
    else {
        // IV is NOT 96-bits
        this._j0 = [
            0,
            0,
            0,
            0
        ];
        while(iv.length() > 0)this._j0 = this.ghash(this._hashSubkey, this._j0, [
            iv.getInt32(),
            iv.getInt32(),
            iv.getInt32(),
            iv.getInt32()
        ]);
        this._j0 = this.ghash(this._hashSubkey, this._j0, [
            0,
            0
        ].concat($be95657534b2d7d9$var$from64To32(ivLength * 8)));
    }
    // generate ICB (initial counter block)
    this._inBlock = this._j0.slice(0);
    $be95657534b2d7d9$var$inc32(this._inBlock);
    this._partialBytes = 0;
    // consume authentication data
    additionalData = $hSPkV.util.createBuffer(additionalData);
    // save additional data length as a BE 64-bit number
    this._aDataLength = $be95657534b2d7d9$var$from64To32(additionalData.length() * 8);
    // pad additional data to 128 bit (16 byte) block size
    var overflow = additionalData.length() % this.blockSize;
    if (overflow) additionalData.fillWithByte(0, this.blockSize - overflow);
    this._s = [
        0,
        0,
        0,
        0
    ];
    while(additionalData.length() > 0)this._s = this.ghash(this._hashSubkey, this._s, [
        additionalData.getInt32(),
        additionalData.getInt32(),
        additionalData.getInt32(),
        additionalData.getInt32()
    ]);
};
$be95657534b2d7d9$var$modes.gcm.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output
        for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i] ^= input.getInt32());
        this._cipherLength += this.blockSize;
    } else {
        // handle partial block
        var partialBytes = (this.blockSize - inputLength) % this.blockSize;
        if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
        // XOR input with output
        this._partialOutput.clear();
        for(var i = 0; i < this._ints; ++i)this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
        if (partialBytes <= 0 || finish) {
            // handle overflow prior to hashing
            if (finish) {
                // get block overflow
                var overflow = inputLength % this.blockSize;
                this._cipherLength += overflow;
                // truncate for hash function
                this._partialOutput.truncate(this.blockSize - overflow);
            } else this._cipherLength += this.blockSize;
            // get output block for hashing
            for(var i = 0; i < this._ints; ++i)this._outBlock[i] = this._partialOutput.getInt32();
            this._partialOutput.read -= this.blockSize;
        }
        // skip any previous partial bytes
        if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
        if (partialBytes > 0 && !finish) {
            // block still incomplete, restore input buffer, get partial output,
            // and return early
            input.read -= this.blockSize;
            output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
            this._partialBytes = partialBytes;
            return true;
        }
        output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
        this._partialBytes = 0;
    }
    // update hash block S
    this._s = this.ghash(this._hashSubkey, this._s, this._outBlock);
    // increment counter (input block)
    $be95657534b2d7d9$var$inc32(this._inBlock);
};
$be95657534b2d7d9$var$modes.gcm.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    var inputLength = input.length();
    if (inputLength < this.blockSize && !(finish && inputLength > 0)) return true;
    // encrypt block (GCM always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // increment counter (input block)
    $be95657534b2d7d9$var$inc32(this._inBlock);
    // update hash block S
    this._hashBlock[0] = input.getInt32();
    this._hashBlock[1] = input.getInt32();
    this._hashBlock[2] = input.getInt32();
    this._hashBlock[3] = input.getInt32();
    this._s = this.ghash(this._hashSubkey, this._s, this._hashBlock);
    // XOR hash input with output
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i] ^ this._hashBlock[i]);
    // increment cipher data length
    if (inputLength < this.blockSize) this._cipherLength += inputLength % this.blockSize;
    else this._cipherLength += this.blockSize;
};
$be95657534b2d7d9$var$modes.gcm.prototype.afterFinish = function(output, options) {
    var rval = true;
    // handle overflow
    if (options.decrypt && options.overflow) output.truncate(this.blockSize - options.overflow);
    // handle authentication tag
    this.tag = $hSPkV.util.createBuffer();
    // concatenate additional data length with cipher length
    var lengths = this._aDataLength.concat($be95657534b2d7d9$var$from64To32(this._cipherLength * 8));
    // include lengths in hash
    this._s = this.ghash(this._hashSubkey, this._s, lengths);
    // do GCTR(J_0, S)
    var tag = [];
    this.cipher.encrypt(this._j0, tag);
    for(var i = 0; i < this._ints; ++i)this.tag.putInt32(this._s[i] ^ tag[i]);
    // trim tag to length
    this.tag.truncate(this.tag.length() % (this._tagLength / 8));
    // check authentication tag
    if (options.decrypt && this.tag.bytes() !== this._tag) rval = false;
    return rval;
};
/**
 * See NIST SP-800-38D 6.3 (Algorithm 1). This function performs Galois
 * field multiplication. The field, GF(2^128), is defined by the polynomial:
 *
 * x^128 + x^7 + x^2 + x + 1
 *
 * Which is represented in little-endian binary form as: 11100001 (0xe1). When
 * the value of a coefficient is 1, a bit is set. The value R, is the
 * concatenation of this value and 120 zero bits, yielding a 128-bit value
 * which matches the block size.
 *
 * This function will multiply two elements (vectors of bytes), X and Y, in
 * the field GF(2^128). The result is initialized to zero. For each bit of
 * X (out of 128), x_i, if x_i is set, then the result is multiplied (XOR'd)
 * by the current value of Y. For each bit, the value of Y will be raised by
 * a power of x (multiplied by the polynomial x). This can be achieved by
 * shifting Y once to the right. If the current value of Y, prior to being
 * multiplied by x, has 0 as its LSB, then it is a 127th degree polynomial.
 * Otherwise, we must divide by R after shifting to find the remainder.
 *
 * @param x the first block to multiply by the second.
 * @param y the second block to multiply by the first.
 *
 * @return the block result of the multiplication.
 */ $be95657534b2d7d9$var$modes.gcm.prototype.multiply = function(x, y) {
    var z_i = [
        0,
        0,
        0,
        0
    ];
    var v_i = y.slice(0);
    // calculate Z_128 (block has 128 bits)
    for(var i = 0; i < 128; ++i){
        // if x_i is 0, Z_{i+1} = Z_i (unchanged)
        // else Z_{i+1} = Z_i ^ V_i
        // get x_i by finding 32-bit int position, then left shift 1 by remainder
        var x_i = x[i / 32 | 0] & 1 << 31 - i % 32;
        if (x_i) {
            z_i[0] ^= v_i[0];
            z_i[1] ^= v_i[1];
            z_i[2] ^= v_i[2];
            z_i[3] ^= v_i[3];
        }
        // if LSB(V_i) is 1, V_i = V_i >> 1
        // else V_i = (V_i >> 1) ^ R
        this.pow(v_i, v_i);
    }
    return z_i;
};
$be95657534b2d7d9$var$modes.gcm.prototype.pow = function(x, out) {
    // if LSB(x) is 1, x = x >>> 1
    // else x = (x >>> 1) ^ R
    var lsb = x[3] & 1;
    // always do x >>> 1:
    // starting with the rightmost integer, shift each integer to the right
    // one bit, pulling in the bit from the integer to the left as its top
    // most bit (do this for the last 3 integers)
    for(var i = 3; i > 0; --i)out[i] = x[i] >>> 1 | (x[i - 1] & 1) << 31;
    // shift the first integer normally
    out[0] = x[0] >>> 1;
    // if lsb was not set, then polynomial had a degree of 127 and doesn't
    // need to divided; otherwise, XOR with R to find the remainder; we only
    // need to XOR the first integer since R technically ends w/120 zero bits
    if (lsb) out[0] ^= this._R;
};
$be95657534b2d7d9$var$modes.gcm.prototype.tableMultiply = function(x) {
    // assumes 4-bit tables are used
    var z = [
        0,
        0,
        0,
        0
    ];
    for(var i = 0; i < 32; ++i){
        var idx = i / 8 | 0;
        var x_i = x[idx] >>> (7 - i % 8) * 4 & 0xF;
        var ah = this._m[i][x_i];
        z[0] ^= ah[0];
        z[1] ^= ah[1];
        z[2] ^= ah[2];
        z[3] ^= ah[3];
    }
    return z;
};
/**
 * A continuing version of the GHASH algorithm that operates on a single
 * block. The hash block, last hash value (Ym) and the new block to hash
 * are given.
 *
 * @param h the hash block.
 * @param y the previous value for Ym, use [0, 0, 0, 0] for a new hash.
 * @param x the block to hash.
 *
 * @return the hashed value (Ym).
 */ $be95657534b2d7d9$var$modes.gcm.prototype.ghash = function(h, y, x) {
    y[0] ^= x[0];
    y[1] ^= x[1];
    y[2] ^= x[2];
    y[3] ^= x[3];
    return this.tableMultiply(y);
//return this.multiply(y, h);
};
/**
 * Precomputes a table for multiplying against the hash subkey. This
 * mechanism provides a substantial speed increase over multiplication
 * performed without a table. The table-based multiplication this table is
 * for solves X * H by multiplying each component of X by H and then
 * composing the results together using XOR.
 *
 * This function can be used to generate tables with different bit sizes
 * for the components, however, this implementation assumes there are
 * 32 components of X (which is a 16 byte vector), therefore each component
 * takes 4-bits (so the table is constructed with bits=4).
 *
 * @param h the hash subkey.
 * @param bits the bit size for a component.
 */ $be95657534b2d7d9$var$modes.gcm.prototype.generateHashTable = function(h, bits) {
    // TODO: There are further optimizations that would use only the
    // first table M_0 (or some variant) along with a remainder table;
    // this can be explored in the future
    var multiplier = 8 / bits;
    var perInt = 4 * multiplier;
    var size = 16 * multiplier;
    var m = new Array(size);
    for(var i = 0; i < size; ++i){
        var tmp = [
            0,
            0,
            0,
            0
        ];
        var idx = i / perInt | 0;
        var shft = (perInt - 1 - i % perInt) * bits;
        tmp[idx] = 1 << bits - 1 << shft;
        m[i] = this.generateSubHashTable(this.multiply(tmp, h), bits);
    }
    return m;
};
/**
 * Generates a table for multiplying against the hash subkey for one
 * particular component (out of all possible component values).
 *
 * @param mid the pre-multiplied value for the middle key of the table.
 * @param bits the bit size for a component.
 */ $be95657534b2d7d9$var$modes.gcm.prototype.generateSubHashTable = function(mid, bits) {
    // compute the table quickly by minimizing the number of
    // POW operations -- they only need to be performed for powers of 2,
    // all other entries can be composed from those powers using XOR
    var size = 1 << bits;
    var half = size >>> 1;
    var m = new Array(size);
    m[half] = mid.slice(0);
    var i = half >>> 1;
    while(i > 0){
        // raise m0[2 * i] and store in m0[i]
        this.pow(m[2 * i], m[i] = []);
        i >>= 1;
    }
    i = 2;
    while(i < half){
        for(var j = 1; j < i; ++j){
            var m_i = m[i];
            var m_j = m[j];
            m[i + j] = [
                m_i[0] ^ m_j[0],
                m_i[1] ^ m_j[1],
                m_i[2] ^ m_j[2],
                m_i[3] ^ m_j[3]
            ];
        }
        i *= 2;
    }
    m[0] = [
        0,
        0,
        0,
        0
    ];
    /* Note: We could avoid storing these by doing composition during multiply
  calculate top half using composition by speed is preferred. */ for(i = half + 1; i < size; ++i){
        var c = m[i ^ half];
        m[i] = [
            mid[0] ^ c[0],
            mid[1] ^ c[1],
            mid[2] ^ c[2],
            mid[3] ^ c[3]
        ];
    }
    return m;
};
/** Utility functions */ function $be95657534b2d7d9$var$transformIV(iv, blockSize) {
    if (typeof iv === "string") // convert iv string into byte buffer
    iv = $hSPkV.util.createBuffer(iv);
    if ($hSPkV.util.isArray(iv) && iv.length > 4) {
        // convert iv byte array into byte buffer
        var tmp = iv;
        iv = $hSPkV.util.createBuffer();
        for(var i = 0; i < tmp.length; ++i)iv.putByte(tmp[i]);
    }
    if (iv.length() < blockSize) throw new Error("Invalid IV length; got " + iv.length() + " bytes and expected " + blockSize + " bytes.");
    if (!$hSPkV.util.isArray(iv)) {
        // convert iv byte buffer into 32-bit integer array
        var ints = [];
        var blocks = blockSize / 4;
        for(var i = 0; i < blocks; ++i)ints.push(iv.getInt32());
        iv = ints;
    }
    return iv;
}
function $be95657534b2d7d9$var$inc32(block) {
    // increment last 32 bits of block only
    block[block.length - 1] = block[block.length - 1] + 1 & 0xFFFFFFFF;
}
function $be95657534b2d7d9$var$from64To32(num) {
    // convert 64-bit number to two BE Int32s
    return [
        num / 0x100000000 | 0,
        num & 0xFFFFFFFF
    ];
}

});


parcelRequire.register("5i9iX", function(module, exports) {
/**
 * DES (Data Encryption Standard) implementation.
 *
 * This implementation supports DES as well as 3DES-EDE in ECB and CBC mode.
 * It is based on the BSD-licensed implementation by Paul Tero:
 *
 * Paul Tero, July 2001
 * http://www.tero.co.uk/des/
 *
 * Optimised for performance with large blocks by
 * Michael Hayworth, November 2001
 * http://www.netdealing.com
 *
 * THIS SOFTWARE IS PROVIDED "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED.  IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
 * OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
 * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
 * SUCH DAMAGE.
 *
 * @author Stefan Siegl
 * @author Dave Longley
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 * Copyright (c) 2012-2014 Digital Bazaar, Inc.
 */ 
var $hSPkV = parcelRequire("hSPkV");
parcelRequire("70wgw");
parcelRequire("gmtg3");
parcelRequire("3lPw4");
/* DES API */ module.exports = $hSPkV.des = $hSPkV.des || {};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('DES-<mode>', key);
 * cipher.start({iv: iv});
 *
 * Creates an DES cipher object to encrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as binary-encoded strings of bytes or
 * byte buffers.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC' if IV is
 *          given, 'ECB' if null).
 *
 * @return the cipher.
 */ $hSPkV.des.startEncrypting = function(key, iv, output, mode) {
    var cipher = $3da5d9eeca3cfd94$var$_createCipher({
        key: key,
        output: output,
        decrypt: false,
        mode: mode || (iv === null ? "ECB" : "CBC")
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('DES-<mode>', key);
 *
 * Creates an DES cipher object to encrypt data using the given symmetric key.
 *
 * The key may be given as a binary-encoded string of bytes or a byte buffer.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $hSPkV.des.createEncryptionCipher = function(key, mode) {
    return $3da5d9eeca3cfd94$var$_createCipher({
        key: key,
        output: null,
        decrypt: false,
        mode: mode
    });
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('DES-<mode>', key);
 * decipher.start({iv: iv});
 *
 * Creates an DES cipher object to decrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as binary-encoded strings of bytes or
 * byte buffers.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC' if IV is
 *          given, 'ECB' if null).
 *
 * @return the cipher.
 */ $hSPkV.des.startDecrypting = function(key, iv, output, mode) {
    var cipher = $3da5d9eeca3cfd94$var$_createCipher({
        key: key,
        output: output,
        decrypt: true,
        mode: mode || (iv === null ? "ECB" : "CBC")
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('DES-<mode>', key);
 *
 * Creates an DES cipher object to decrypt data using the given symmetric key.
 *
 * The key may be given as a binary-encoded string of bytes or a byte buffer.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $hSPkV.des.createDecryptionCipher = function(key, mode) {
    return $3da5d9eeca3cfd94$var$_createCipher({
        key: key,
        output: null,
        decrypt: true,
        mode: mode
    });
};
/**
 * Creates a new DES cipher algorithm object.
 *
 * @param name the name of the algorithm.
 * @param mode the mode factory function.
 *
 * @return the DES algorithm object.
 */ $hSPkV.des.Algorithm = function(name, mode) {
    var self = this;
    self.name = name;
    self.mode = new mode({
        blockSize: 8,
        cipher: {
            encrypt: function(inBlock, outBlock) {
                return $3da5d9eeca3cfd94$var$_updateBlock(self._keys, inBlock, outBlock, false);
            },
            decrypt: function(inBlock, outBlock) {
                return $3da5d9eeca3cfd94$var$_updateBlock(self._keys, inBlock, outBlock, true);
            }
        }
    });
    self._init = false;
};
/**
 * Initializes this DES algorithm by expanding its key.
 *
 * @param options the options to use.
 *          key the key to use with this algorithm.
 *          decrypt true if the algorithm should be initialized for decryption,
 *            false for encryption.
 */ $hSPkV.des.Algorithm.prototype.initialize = function(options) {
    if (this._init) return;
    var key = $hSPkV.util.createBuffer(options.key);
    if (this.name.indexOf("3DES") === 0) {
        if (key.length() !== 24) throw new Error("Invalid Triple-DES key size: " + key.length() * 8);
    }
    // do key expansion to 16 or 48 subkeys (single or triple DES)
    this._keys = $3da5d9eeca3cfd94$var$_createKeys(key);
    this._init = true;
};
/** Register DES algorithms **/ $3da5d9eeca3cfd94$var$registerAlgorithm("DES-ECB", $hSPkV.cipher.modes.ecb);
$3da5d9eeca3cfd94$var$registerAlgorithm("DES-CBC", $hSPkV.cipher.modes.cbc);
$3da5d9eeca3cfd94$var$registerAlgorithm("DES-CFB", $hSPkV.cipher.modes.cfb);
$3da5d9eeca3cfd94$var$registerAlgorithm("DES-OFB", $hSPkV.cipher.modes.ofb);
$3da5d9eeca3cfd94$var$registerAlgorithm("DES-CTR", $hSPkV.cipher.modes.ctr);
$3da5d9eeca3cfd94$var$registerAlgorithm("3DES-ECB", $hSPkV.cipher.modes.ecb);
$3da5d9eeca3cfd94$var$registerAlgorithm("3DES-CBC", $hSPkV.cipher.modes.cbc);
$3da5d9eeca3cfd94$var$registerAlgorithm("3DES-CFB", $hSPkV.cipher.modes.cfb);
$3da5d9eeca3cfd94$var$registerAlgorithm("3DES-OFB", $hSPkV.cipher.modes.ofb);
$3da5d9eeca3cfd94$var$registerAlgorithm("3DES-CTR", $hSPkV.cipher.modes.ctr);
function $3da5d9eeca3cfd94$var$registerAlgorithm(name, mode) {
    var factory = function() {
        return new $hSPkV.des.Algorithm(name, mode);
    };
    $hSPkV.cipher.registerAlgorithm(name, factory);
}
/** DES implementation **/ var $3da5d9eeca3cfd94$var$spfunction1 = [
    0x1010400,
    0,
    0x10000,
    0x1010404,
    0x1010004,
    0x10404,
    0x4,
    0x10000,
    0x400,
    0x1010400,
    0x1010404,
    0x400,
    0x1000404,
    0x1010004,
    0x1000000,
    0x4,
    0x404,
    0x1000400,
    0x1000400,
    0x10400,
    0x10400,
    0x1010000,
    0x1010000,
    0x1000404,
    0x10004,
    0x1000004,
    0x1000004,
    0x10004,
    0,
    0x404,
    0x10404,
    0x1000000,
    0x10000,
    0x1010404,
    0x4,
    0x1010000,
    0x1010400,
    0x1000000,
    0x1000000,
    0x400,
    0x1010004,
    0x10000,
    0x10400,
    0x1000004,
    0x400,
    0x4,
    0x1000404,
    0x10404,
    0x1010404,
    0x10004,
    0x1010000,
    0x1000404,
    0x1000004,
    0x404,
    0x10404,
    0x1010400,
    0x404,
    0x1000400,
    0x1000400,
    0,
    0x10004,
    0x10400,
    0,
    0x1010004
];
var $3da5d9eeca3cfd94$var$spfunction2 = [
    -2146402272,
    -2147450880,
    0x8000,
    0x108020,
    0x100000,
    0x20,
    -2146435040,
    -2147450848,
    -2147483616,
    -2146402272,
    -2146402304,
    -2147483648,
    -2147450880,
    0x100000,
    0x20,
    -2146435040,
    0x108000,
    0x100020,
    -2147450848,
    0,
    -2147483648,
    0x8000,
    0x108020,
    -2146435072,
    0x100020,
    -2147483616,
    0,
    0x108000,
    0x8020,
    -2146402304,
    -2146435072,
    0x8020,
    0,
    0x108020,
    -2146435040,
    0x100000,
    -2147450848,
    -2146435072,
    -2146402304,
    0x8000,
    -2146435072,
    -2147450880,
    0x20,
    -2146402272,
    0x108020,
    0x20,
    0x8000,
    -2147483648,
    0x8020,
    -2146402304,
    0x100000,
    -2147483616,
    0x100020,
    -2147450848,
    -2147483616,
    0x100020,
    0x108000,
    0,
    -2147450880,
    0x8020,
    -2147483648,
    -2146435040,
    -2146402272,
    0x108000
];
var $3da5d9eeca3cfd94$var$spfunction3 = [
    0x208,
    0x8020200,
    0,
    0x8020008,
    0x8000200,
    0,
    0x20208,
    0x8000200,
    0x20008,
    0x8000008,
    0x8000008,
    0x20000,
    0x8020208,
    0x20008,
    0x8020000,
    0x208,
    0x8000000,
    0x8,
    0x8020200,
    0x200,
    0x20200,
    0x8020000,
    0x8020008,
    0x20208,
    0x8000208,
    0x20200,
    0x20000,
    0x8000208,
    0x8,
    0x8020208,
    0x200,
    0x8000000,
    0x8020200,
    0x8000000,
    0x20008,
    0x208,
    0x20000,
    0x8020200,
    0x8000200,
    0,
    0x200,
    0x20008,
    0x8020208,
    0x8000200,
    0x8000008,
    0x200,
    0,
    0x8020008,
    0x8000208,
    0x20000,
    0x8000000,
    0x8020208,
    0x8,
    0x20208,
    0x20200,
    0x8000008,
    0x8020000,
    0x8000208,
    0x208,
    0x8020000,
    0x20208,
    0x8,
    0x8020008,
    0x20200
];
var $3da5d9eeca3cfd94$var$spfunction4 = [
    0x802001,
    0x2081,
    0x2081,
    0x80,
    0x802080,
    0x800081,
    0x800001,
    0x2001,
    0,
    0x802000,
    0x802000,
    0x802081,
    0x81,
    0,
    0x800080,
    0x800001,
    0x1,
    0x2000,
    0x800000,
    0x802001,
    0x80,
    0x800000,
    0x2001,
    0x2080,
    0x800081,
    0x1,
    0x2080,
    0x800080,
    0x2000,
    0x802080,
    0x802081,
    0x81,
    0x800080,
    0x800001,
    0x802000,
    0x802081,
    0x81,
    0,
    0,
    0x802000,
    0x2080,
    0x800080,
    0x800081,
    0x1,
    0x802001,
    0x2081,
    0x2081,
    0x80,
    0x802081,
    0x81,
    0x1,
    0x2000,
    0x800001,
    0x2001,
    0x802080,
    0x800081,
    0x2001,
    0x2080,
    0x800000,
    0x802001,
    0x80,
    0x800000,
    0x2000,
    0x802080
];
var $3da5d9eeca3cfd94$var$spfunction5 = [
    0x100,
    0x2080100,
    0x2080000,
    0x42000100,
    0x80000,
    0x100,
    0x40000000,
    0x2080000,
    0x40080100,
    0x80000,
    0x2000100,
    0x40080100,
    0x42000100,
    0x42080000,
    0x80100,
    0x40000000,
    0x2000000,
    0x40080000,
    0x40080000,
    0,
    0x40000100,
    0x42080100,
    0x42080100,
    0x2000100,
    0x42080000,
    0x40000100,
    0,
    0x42000000,
    0x2080100,
    0x2000000,
    0x42000000,
    0x80100,
    0x80000,
    0x42000100,
    0x100,
    0x2000000,
    0x40000000,
    0x2080000,
    0x42000100,
    0x40080100,
    0x2000100,
    0x40000000,
    0x42080000,
    0x2080100,
    0x40080100,
    0x100,
    0x2000000,
    0x42080000,
    0x42080100,
    0x80100,
    0x42000000,
    0x42080100,
    0x2080000,
    0,
    0x40080000,
    0x42000000,
    0x80100,
    0x2000100,
    0x40000100,
    0x80000,
    0,
    0x40080000,
    0x2080100,
    0x40000100
];
var $3da5d9eeca3cfd94$var$spfunction6 = [
    0x20000010,
    0x20400000,
    0x4000,
    0x20404010,
    0x20400000,
    0x10,
    0x20404010,
    0x400000,
    0x20004000,
    0x404010,
    0x400000,
    0x20000010,
    0x400010,
    0x20004000,
    0x20000000,
    0x4010,
    0,
    0x400010,
    0x20004010,
    0x4000,
    0x404000,
    0x20004010,
    0x10,
    0x20400010,
    0x20400010,
    0,
    0x404010,
    0x20404000,
    0x4010,
    0x404000,
    0x20404000,
    0x20000000,
    0x20004000,
    0x10,
    0x20400010,
    0x404000,
    0x20404010,
    0x400000,
    0x4010,
    0x20000010,
    0x400000,
    0x20004000,
    0x20000000,
    0x4010,
    0x20000010,
    0x20404010,
    0x404000,
    0x20400000,
    0x404010,
    0x20404000,
    0,
    0x20400010,
    0x10,
    0x4000,
    0x20400000,
    0x404010,
    0x4000,
    0x400010,
    0x20004010,
    0,
    0x20404000,
    0x20000000,
    0x400010,
    0x20004010
];
var $3da5d9eeca3cfd94$var$spfunction7 = [
    0x200000,
    0x4200002,
    0x4000802,
    0,
    0x800,
    0x4000802,
    0x200802,
    0x4200800,
    0x4200802,
    0x200000,
    0,
    0x4000002,
    0x2,
    0x4000000,
    0x4200002,
    0x802,
    0x4000800,
    0x200802,
    0x200002,
    0x4000800,
    0x4000002,
    0x4200000,
    0x4200800,
    0x200002,
    0x4200000,
    0x800,
    0x802,
    0x4200802,
    0x200800,
    0x2,
    0x4000000,
    0x200800,
    0x4000000,
    0x200800,
    0x200000,
    0x4000802,
    0x4000802,
    0x4200002,
    0x4200002,
    0x2,
    0x200002,
    0x4000000,
    0x4000800,
    0x200000,
    0x4200800,
    0x802,
    0x200802,
    0x4200800,
    0x802,
    0x4000002,
    0x4200802,
    0x4200000,
    0x200800,
    0,
    0x2,
    0x4200802,
    0,
    0x200802,
    0x4200000,
    0x800,
    0x4000002,
    0x4000800,
    0x800,
    0x200002
];
var $3da5d9eeca3cfd94$var$spfunction8 = [
    0x10001040,
    0x1000,
    0x40000,
    0x10041040,
    0x10000000,
    0x10001040,
    0x40,
    0x10000000,
    0x40040,
    0x10040000,
    0x10041040,
    0x41000,
    0x10041000,
    0x41040,
    0x1000,
    0x40,
    0x10040000,
    0x10000040,
    0x10001000,
    0x1040,
    0x41000,
    0x40040,
    0x10040040,
    0x10041000,
    0x1040,
    0,
    0,
    0x10040040,
    0x10000040,
    0x10001000,
    0x41040,
    0x40000,
    0x41040,
    0x40000,
    0x10041000,
    0x1000,
    0x40,
    0x10040040,
    0x1000,
    0x41040,
    0x10001000,
    0x40,
    0x10000040,
    0x10040000,
    0x10040040,
    0x10000000,
    0x40000,
    0x10001040,
    0,
    0x10041040,
    0x40040,
    0x10000040,
    0x10040000,
    0x10001000,
    0x10001040,
    0,
    0x10041040,
    0x41000,
    0x41000,
    0x1040,
    0x1040,
    0x40040,
    0x10000000,
    0x10041000
];
/**
 * Create necessary sub keys.
 *
 * @param key the 64-bit or 192-bit key.
 *
 * @return the expanded keys.
 */ function $3da5d9eeca3cfd94$var$_createKeys(key) {
    var pc2bytes0 = [
        0,
        0x4,
        0x20000000,
        0x20000004,
        0x10000,
        0x10004,
        0x20010000,
        0x20010004,
        0x200,
        0x204,
        0x20000200,
        0x20000204,
        0x10200,
        0x10204,
        0x20010200,
        0x20010204
    ], pc2bytes1 = [
        0,
        0x1,
        0x100000,
        0x100001,
        0x4000000,
        0x4000001,
        0x4100000,
        0x4100001,
        0x100,
        0x101,
        0x100100,
        0x100101,
        0x4000100,
        0x4000101,
        0x4100100,
        0x4100101
    ], pc2bytes2 = [
        0,
        0x8,
        0x800,
        0x808,
        0x1000000,
        0x1000008,
        0x1000800,
        0x1000808,
        0,
        0x8,
        0x800,
        0x808,
        0x1000000,
        0x1000008,
        0x1000800,
        0x1000808
    ], pc2bytes3 = [
        0,
        0x200000,
        0x8000000,
        0x8200000,
        0x2000,
        0x202000,
        0x8002000,
        0x8202000,
        0x20000,
        0x220000,
        0x8020000,
        0x8220000,
        0x22000,
        0x222000,
        0x8022000,
        0x8222000
    ], pc2bytes4 = [
        0,
        0x40000,
        0x10,
        0x40010,
        0,
        0x40000,
        0x10,
        0x40010,
        0x1000,
        0x41000,
        0x1010,
        0x41010,
        0x1000,
        0x41000,
        0x1010,
        0x41010
    ], pc2bytes5 = [
        0,
        0x400,
        0x20,
        0x420,
        0,
        0x400,
        0x20,
        0x420,
        0x2000000,
        0x2000400,
        0x2000020,
        0x2000420,
        0x2000000,
        0x2000400,
        0x2000020,
        0x2000420
    ], pc2bytes6 = [
        0,
        0x10000000,
        0x80000,
        0x10080000,
        0x2,
        0x10000002,
        0x80002,
        0x10080002,
        0,
        0x10000000,
        0x80000,
        0x10080000,
        0x2,
        0x10000002,
        0x80002,
        0x10080002
    ], pc2bytes7 = [
        0,
        0x10000,
        0x800,
        0x10800,
        0x20000000,
        0x20010000,
        0x20000800,
        0x20010800,
        0x20000,
        0x30000,
        0x20800,
        0x30800,
        0x20020000,
        0x20030000,
        0x20020800,
        0x20030800
    ], pc2bytes8 = [
        0,
        0x40000,
        0,
        0x40000,
        0x2,
        0x40002,
        0x2,
        0x40002,
        0x2000000,
        0x2040000,
        0x2000000,
        0x2040000,
        0x2000002,
        0x2040002,
        0x2000002,
        0x2040002
    ], pc2bytes9 = [
        0,
        0x10000000,
        0x8,
        0x10000008,
        0,
        0x10000000,
        0x8,
        0x10000008,
        0x400,
        0x10000400,
        0x408,
        0x10000408,
        0x400,
        0x10000400,
        0x408,
        0x10000408
    ], pc2bytes10 = [
        0,
        0x20,
        0,
        0x20,
        0x100000,
        0x100020,
        0x100000,
        0x100020,
        0x2000,
        0x2020,
        0x2000,
        0x2020,
        0x102000,
        0x102020,
        0x102000,
        0x102020
    ], pc2bytes11 = [
        0,
        0x1000000,
        0x200,
        0x1000200,
        0x200000,
        0x1200000,
        0x200200,
        0x1200200,
        0x4000000,
        0x5000000,
        0x4000200,
        0x5000200,
        0x4200000,
        0x5200000,
        0x4200200,
        0x5200200
    ], pc2bytes12 = [
        0,
        0x1000,
        0x8000000,
        0x8001000,
        0x80000,
        0x81000,
        0x8080000,
        0x8081000,
        0x10,
        0x1010,
        0x8000010,
        0x8001010,
        0x80010,
        0x81010,
        0x8080010,
        0x8081010
    ], pc2bytes13 = [
        0,
        0x4,
        0x100,
        0x104,
        0,
        0x4,
        0x100,
        0x104,
        0x1,
        0x5,
        0x101,
        0x105,
        0x1,
        0x5,
        0x101,
        0x105
    ];
    // how many iterations (1 for des, 3 for triple des)
    // changed by Paul 16/6/2007 to use Triple DES for 9+ byte keys
    var iterations = key.length() > 8 ? 3 : 1;
    // stores the return keys
    var keys = [];
    // now define the left shifts which need to be done
    var shifts = [
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0
    ];
    var n = 0, tmp;
    for(var j = 0; j < iterations; j++){
        var left = key.getInt32();
        var right = key.getInt32();
        tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
        right ^= tmp;
        left ^= tmp << 4;
        tmp = (right >>> -16 ^ left) & 0x0000ffff;
        left ^= tmp;
        right ^= tmp << -16;
        tmp = (left >>> 2 ^ right) & 0x33333333;
        right ^= tmp;
        left ^= tmp << 2;
        tmp = (right >>> -16 ^ left) & 0x0000ffff;
        left ^= tmp;
        right ^= tmp << -16;
        tmp = (left >>> 1 ^ right) & 0x55555555;
        right ^= tmp;
        left ^= tmp << 1;
        tmp = (right >>> 8 ^ left) & 0x00ff00ff;
        left ^= tmp;
        right ^= tmp << 8;
        tmp = (left >>> 1 ^ right) & 0x55555555;
        right ^= tmp;
        left ^= tmp << 1;
        // right needs to be shifted and OR'd with last four bits of left
        tmp = left << 8 | right >>> 20 & 0x000000f0;
        // left needs to be put upside down
        left = right << 24 | right << 8 & 0xff0000 | right >>> 8 & 0xff00 | right >>> 24 & 0xf0;
        right = tmp;
        // now go through and perform these shifts on the left and right keys
        for(var i = 0; i < shifts.length; ++i){
            //shift the keys either one or two bits to the left
            if (shifts[i]) {
                left = left << 2 | left >>> 26;
                right = right << 2 | right >>> 26;
            } else {
                left = left << 1 | left >>> 27;
                right = right << 1 | right >>> 27;
            }
            left &= -15;
            right &= -15;
            // now apply PC-2, in such a way that E is easier when encrypting or
            // decrypting this conversion will look like PC-2 except only the last 6
            // bits of each byte are used rather than 48 consecutive bits and the
            // order of lines will be according to how the S selection functions will
            // be applied: S2, S4, S6, S8, S1, S3, S5, S7
            var lefttmp = pc2bytes0[left >>> 28] | pc2bytes1[left >>> 24 & 0xf] | pc2bytes2[left >>> 20 & 0xf] | pc2bytes3[left >>> 16 & 0xf] | pc2bytes4[left >>> 12 & 0xf] | pc2bytes5[left >>> 8 & 0xf] | pc2bytes6[left >>> 4 & 0xf];
            var righttmp = pc2bytes7[right >>> 28] | pc2bytes8[right >>> 24 & 0xf] | pc2bytes9[right >>> 20 & 0xf] | pc2bytes10[right >>> 16 & 0xf] | pc2bytes11[right >>> 12 & 0xf] | pc2bytes12[right >>> 8 & 0xf] | pc2bytes13[right >>> 4 & 0xf];
            tmp = (righttmp >>> 16 ^ lefttmp) & 0x0000ffff;
            keys[n++] = lefttmp ^ tmp;
            keys[n++] = righttmp ^ tmp << 16;
        }
    }
    return keys;
}
/**
 * Updates a single block (1 byte) using DES. The update will either
 * encrypt or decrypt the block.
 *
 * @param keys the expanded keys.
 * @param input the input block (an array of 32-bit words).
 * @param output the updated output block.
 * @param decrypt true to decrypt the block, false to encrypt it.
 */ function $3da5d9eeca3cfd94$var$_updateBlock(keys, input, output, decrypt) {
    // set up loops for single or triple DES
    var iterations = keys.length === 32 ? 3 : 9;
    var looping;
    if (iterations === 3) looping = decrypt ? [
        30,
        -2,
        -2
    ] : [
        0,
        32,
        2
    ];
    else looping = decrypt ? [
        94,
        62,
        -2,
        32,
        64,
        2,
        30,
        -2,
        -2
    ] : [
        0,
        32,
        2,
        62,
        30,
        -2,
        64,
        96,
        2
    ];
    var tmp;
    var left = input[0];
    var right = input[1];
    // first each 64 bit chunk of the message must be permuted according to IP
    tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
    right ^= tmp;
    left ^= tmp << 4;
    tmp = (left >>> 16 ^ right) & 0x0000ffff;
    right ^= tmp;
    left ^= tmp << 16;
    tmp = (right >>> 2 ^ left) & 0x33333333;
    left ^= tmp;
    right ^= tmp << 2;
    tmp = (right >>> 8 ^ left) & 0x00ff00ff;
    left ^= tmp;
    right ^= tmp << 8;
    tmp = (left >>> 1 ^ right) & 0x55555555;
    right ^= tmp;
    left ^= tmp << 1;
    // rotate left 1 bit
    left = left << 1 | left >>> 31;
    right = right << 1 | right >>> 31;
    for(var j = 0; j < iterations; j += 3){
        var endloop = looping[j + 1];
        var loopinc = looping[j + 2];
        // now go through and perform the encryption or decryption
        for(var i = looping[j]; i != endloop; i += loopinc){
            var right1 = right ^ keys[i];
            var right2 = (right >>> 4 | right << 28) ^ keys[i + 1];
            // passing these bytes through the S selection functions
            tmp = left;
            left = right;
            right = tmp ^ ($3da5d9eeca3cfd94$var$spfunction2[right1 >>> 24 & 0x3f] | $3da5d9eeca3cfd94$var$spfunction4[right1 >>> 16 & 0x3f] | $3da5d9eeca3cfd94$var$spfunction6[right1 >>> 8 & 0x3f] | $3da5d9eeca3cfd94$var$spfunction8[right1 & 0x3f] | $3da5d9eeca3cfd94$var$spfunction1[right2 >>> 24 & 0x3f] | $3da5d9eeca3cfd94$var$spfunction3[right2 >>> 16 & 0x3f] | $3da5d9eeca3cfd94$var$spfunction5[right2 >>> 8 & 0x3f] | $3da5d9eeca3cfd94$var$spfunction7[right2 & 0x3f]);
        }
        // unreverse left and right
        tmp = left;
        left = right;
        right = tmp;
    }
    // rotate right 1 bit
    left = left >>> 1 | left << 31;
    right = right >>> 1 | right << 31;
    // now perform IP-1, which is IP in the opposite direction
    tmp = (left >>> 1 ^ right) & 0x55555555;
    right ^= tmp;
    left ^= tmp << 1;
    tmp = (right >>> 8 ^ left) & 0x00ff00ff;
    left ^= tmp;
    right ^= tmp << 8;
    tmp = (right >>> 2 ^ left) & 0x33333333;
    left ^= tmp;
    right ^= tmp << 2;
    tmp = (left >>> 16 ^ right) & 0x0000ffff;
    right ^= tmp;
    left ^= tmp << 16;
    tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
    right ^= tmp;
    left ^= tmp << 4;
    output[0] = left;
    output[1] = right;
}
/**
 * Deprecated. Instead, use:
 *
 * forge.cipher.createCipher('DES-<mode>', key);
 * forge.cipher.createDecipher('DES-<mode>', key);
 *
 * Creates a deprecated DES cipher object. This object's mode will default to
 * CBC (cipher-block-chaining).
 *
 * The key may be given as a binary-encoded string of bytes or a byte buffer.
 *
 * @param options the options to use.
 *          key the symmetric key to use (64 or 192 bits).
 *          output the buffer to write to.
 *          decrypt true for decryption, false for encryption.
 *          mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ function $3da5d9eeca3cfd94$var$_createCipher(options) {
    options = options || {};
    var mode = (options.mode || "CBC").toUpperCase();
    var algorithm = "DES-" + mode;
    var cipher;
    if (options.decrypt) cipher = $hSPkV.cipher.createDecipher(algorithm, options.key);
    else cipher = $hSPkV.cipher.createCipher(algorithm, options.key);
    // backwards compatible start API
    var start = cipher.start;
    cipher.start = function(iv, options) {
        // backwards compatibility: support second arg as output buffer
        var output = null;
        if (options instanceof $hSPkV.util.ByteBuffer) {
            output = options;
            options = {};
        }
        options = options || {};
        options.output = output;
        options.iv = iv;
        start.call(cipher, options);
    };
    return cipher;
}

});

parcelRequire.register("jCulq", function(module, exports) {
/**
 * Node.js module for Forge message digests.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2017 Digital Bazaar, Inc.
 */ 
var $hSPkV = parcelRequire("hSPkV");
module.exports = $hSPkV.md = $hSPkV.md || {};
$hSPkV.md.algorithms = $hSPkV.md.algorithms || {};

});

parcelRequire.register("6mmjF", function(module, exports) {
/**
 * Password-Based Key-Derivation Function #2 implementation.
 *
 * See RFC 2898 for details.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 */ 
var $7jzxY = parcelRequire("7jzxY");
var $4a161bac646edaba$require$Buffer = $7jzxY.Buffer;

var $hSPkV = parcelRequire("hSPkV");
parcelRequire("p6mmH");
parcelRequire("jCulq");
parcelRequire("3lPw4");
var $4a161bac646edaba$var$pkcs5 = $hSPkV.pkcs5 = $hSPkV.pkcs5 || {};
var $4a161bac646edaba$var$crypto;

if ($hSPkV.util.isNodejs && !$hSPkV.options.usePureJavaScript) $4a161bac646edaba$var$crypto = (parcelRequire("7jzxY"));
/**
 * Derives a key from a password.
 *
 * @param p the password as a binary-encoded string of bytes.
 * @param s the salt as a binary-encoded string of bytes.
 * @param c the iteration count, a positive integer.
 * @param dkLen the intended length, in bytes, of the derived key,
 *          (max: 2^32 - 1) * hash length of the PRF.
 * @param [md] the message digest (or algorithm identifier as a string) to use
 *          in the PRF, defaults to SHA-1.
 * @param [callback(err, key)] presence triggers asynchronous version, called
 *          once the operation completes.
 *
 * @return the derived key, as a binary-encoded string of bytes, for the
 *           synchronous version (if no callback is specified).
 */ module.exports = $hSPkV.pbkdf2 = $4a161bac646edaba$var$pkcs5.pbkdf2 = function(p, s, c, dkLen, md, callback) {
    if (typeof md === "function") {
        callback = md;
        md = null;
    }
    // use native implementation if possible and not disabled, note that
    // some node versions only support SHA-1, others allow digest to be changed
    if ($hSPkV.util.isNodejs && !$hSPkV.options.usePureJavaScript && $4a161bac646edaba$var$crypto.pbkdf2 && (md === null || typeof md !== "object") && ($4a161bac646edaba$var$crypto.pbkdf2Sync.length > 4 || !md || md === "sha1")) {
        if (typeof md !== "string") // default prf to SHA-1
        md = "sha1";
        p = $4a161bac646edaba$require$Buffer.from(p, "binary");
        s = $4a161bac646edaba$require$Buffer.from(s, "binary");
        if (!callback) {
            if ($4a161bac646edaba$var$crypto.pbkdf2Sync.length === 4) return $4a161bac646edaba$var$crypto.pbkdf2Sync(p, s, c, dkLen).toString("binary");
            return $4a161bac646edaba$var$crypto.pbkdf2Sync(p, s, c, dkLen, md).toString("binary");
        }
        if ($4a161bac646edaba$var$crypto.pbkdf2Sync.length === 4) return $4a161bac646edaba$var$crypto.pbkdf2(p, s, c, dkLen, function(err, key) {
            if (err) return callback(err);
            callback(null, key.toString("binary"));
        });
        return $4a161bac646edaba$var$crypto.pbkdf2(p, s, c, dkLen, md, function(err, key) {
            if (err) return callback(err);
            callback(null, key.toString("binary"));
        });
    }
    if (typeof md === "undefined" || md === null) // default prf to SHA-1
    md = "sha1";
    if (typeof md === "string") {
        if (!(md in $hSPkV.md.algorithms)) throw new Error("Unknown hash algorithm: " + md);
        md = $hSPkV.md[md].create();
    }
    var hLen = md.digestLength;
    /* 1. If dkLen > (2^32 - 1) * hLen, output "derived key too long" and
    stop. */ if (dkLen > 0xFFFFFFFF * hLen) {
        var err = new Error("Derived key is too long.");
        if (callback) return callback(err);
        throw err;
    }
    /* 2. Let len be the number of hLen-octet blocks in the derived key,
    rounding up, and let r be the number of octets in the last
    block:

    len = CEIL(dkLen / hLen),
    r = dkLen - (len - 1) * hLen. */ var len = Math.ceil(dkLen / hLen);
    var r = dkLen - (len - 1) * hLen;
    /* 3. For each block of the derived key apply the function F defined
    below to the password P, the salt S, the iteration count c, and
    the block index to compute the block:

    T_1 = F(P, S, c, 1),
    T_2 = F(P, S, c, 2),
    ...
    T_len = F(P, S, c, len),

    where the function F is defined as the exclusive-or sum of the
    first c iterates of the underlying pseudorandom function PRF
    applied to the password P and the concatenation of the salt S
    and the block index i:

    F(P, S, c, i) = u_1 XOR u_2 XOR ... XOR u_c

    where

    u_1 = PRF(P, S || INT(i)),
    u_2 = PRF(P, u_1),
    ...
    u_c = PRF(P, u_{c-1}).

    Here, INT(i) is a four-octet encoding of the integer i, most
    significant octet first. */ var prf = $hSPkV.hmac.create();
    prf.start(md, p);
    var dk = "";
    var xor, u_c, u_c1;
    // sync version
    if (!callback) {
        for(var i = 1; i <= len; ++i){
            // PRF(P, S || INT(i)) (first iteration)
            prf.start(null, null);
            prf.update(s);
            prf.update($hSPkV.util.int32ToBytes(i));
            xor = u_c1 = prf.digest().getBytes();
            // PRF(P, u_{c-1}) (other iterations)
            for(var j = 2; j <= c; ++j){
                prf.start(null, null);
                prf.update(u_c1);
                u_c = prf.digest().getBytes();
                // F(p, s, c, i)
                xor = $hSPkV.util.xorBytes(xor, u_c, hLen);
                u_c1 = u_c;
            }
            /* 4. Concatenate the blocks and extract the first dkLen octets to
        produce a derived key DK:

        DK = T_1 || T_2 ||  ...  || T_len<0..r-1> */ dk += i < len ? xor : xor.substr(0, r);
        }
        /* 5. Output the derived key DK. */ return dk;
    }
    // async version
    var i = 1, j;
    function outer() {
        if (i > len) // done
        return callback(null, dk);
        // PRF(P, S || INT(i)) (first iteration)
        prf.start(null, null);
        prf.update(s);
        prf.update($hSPkV.util.int32ToBytes(i));
        xor = u_c1 = prf.digest().getBytes();
        // PRF(P, u_{c-1}) (other iterations)
        j = 2;
        inner();
    }
    function inner() {
        if (j <= c) {
            prf.start(null, null);
            prf.update(u_c1);
            u_c = prf.digest().getBytes();
            // F(p, s, c, i)
            xor = $hSPkV.util.xorBytes(xor, u_c, hLen);
            u_c1 = u_c;
            ++j;
            return $hSPkV.util.setImmediate(inner);
        }
        /* 4. Concatenate the blocks and extract the first dkLen octets to
      produce a derived key DK:

      DK = T_1 || T_2 ||  ...  || T_len<0..r-1> */ dk += i < len ? xor : xor.substr(0, r);
        ++i;
        outer();
    }
    outer();
};

});
parcelRequire.register("p6mmH", function(module, exports) {
/**
 * Hash-based Message Authentication Code implementation. Requires a message
 * digest object that can be obtained, for example, from forge.md.sha1 or
 * forge.md.md5.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2012 Digital Bazaar, Inc. All rights reserved.
 */ 
var $hSPkV = parcelRequire("hSPkV");
parcelRequire("jCulq");
parcelRequire("3lPw4");
/* HMAC API */ var $04b744d2ef0c8232$var$hmac = module.exports = $hSPkV.hmac = $hSPkV.hmac || {};
/**
 * Creates an HMAC object that uses the given message digest object.
 *
 * @return an HMAC object.
 */ $04b744d2ef0c8232$var$hmac.create = function() {
    // the hmac key to use
    var _key = null;
    // the message digest to use
    var _md = null;
    // the inner padding
    var _ipadding = null;
    // the outer padding
    var _opadding = null;
    // hmac context
    var ctx = {};
    /**
   * Starts or restarts the HMAC with the given key and message digest.
   *
   * @param md the message digest to use, null to reuse the previous one,
   *           a string to use builtin 'sha1', 'md5', 'sha256'.
   * @param key the key to use as a string, array of bytes, byte buffer,
   *           or null to reuse the previous key.
   */ ctx.start = function(md, key) {
        if (md !== null) {
            if (typeof md === "string") {
                // create builtin message digest
                md = md.toLowerCase();
                if (md in $hSPkV.md.algorithms) _md = $hSPkV.md.algorithms[md].create();
                else throw new Error('Unknown hash algorithm "' + md + '"');
            } else // store message digest
            _md = md;
        }
        if (key === null) // reuse previous key
        key = _key;
        else {
            if (typeof key === "string") // convert string into byte buffer
            key = $hSPkV.util.createBuffer(key);
            else if ($hSPkV.util.isArray(key)) {
                // convert byte array into byte buffer
                var tmp = key;
                key = $hSPkV.util.createBuffer();
                for(var i = 0; i < tmp.length; ++i)key.putByte(tmp[i]);
            }
            // if key is longer than blocksize, hash it
            var keylen = key.length();
            if (keylen > _md.blockLength) {
                _md.start();
                _md.update(key.bytes());
                key = _md.digest();
            }
            // mix key into inner and outer padding
            // ipadding = [0x36 * blocksize] ^ key
            // opadding = [0x5C * blocksize] ^ key
            _ipadding = $hSPkV.util.createBuffer();
            _opadding = $hSPkV.util.createBuffer();
            keylen = key.length();
            for(var i = 0; i < keylen; ++i){
                var tmp = key.at(i);
                _ipadding.putByte(0x36 ^ tmp);
                _opadding.putByte(0x5C ^ tmp);
            }
            // if key is shorter than blocksize, add additional padding
            if (keylen < _md.blockLength) {
                var tmp = _md.blockLength - keylen;
                for(var i = 0; i < tmp; ++i){
                    _ipadding.putByte(0x36);
                    _opadding.putByte(0x5C);
                }
            }
            _key = key;
            _ipadding = _ipadding.bytes();
            _opadding = _opadding.bytes();
        }
        // digest is done like so: hash(opadding | hash(ipadding | message))
        // prepare to do inner hash
        // hash(ipadding | message)
        _md.start();
        _md.update(_ipadding);
    };
    /**
   * Updates the HMAC with the given message bytes.
   *
   * @param bytes the bytes to update with.
   */ ctx.update = function(bytes) {
        _md.update(bytes);
    };
    /**
   * Produces the Message Authentication Code (MAC).
   *
   * @return a byte buffer containing the digest value.
   */ ctx.getMac = function() {
        // digest is done like so: hash(opadding | hash(ipadding | message))
        // here we do the outer hashing
        var inner = _md.digest().bytes();
        _md.start();
        _md.update(_opadding);
        _md.update(inner);
        return _md.digest();
    };
    // alias for getMac
    ctx.digest = ctx.getMac;
    return ctx;
};

});


parcelRequire.register("954gi", function(module, exports) {
/**
 * Javascript implementation of basic PEM (Privacy Enhanced Mail) algorithms.
 *
 * See: RFC 1421.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2013-2014 Digital Bazaar, Inc.
 *
 * A Forge PEM object has the following fields:
 *
 * type: identifies the type of message (eg: "RSA PRIVATE KEY").
 *
 * procType: identifies the type of processing performed on the message,
 *   it has two subfields: version and type, eg: 4,ENCRYPTED.
 *
 * contentDomain: identifies the type of content in the message, typically
 *   only uses the value: "RFC822".
 *
 * dekInfo: identifies the message encryption algorithm and mode and includes
 *   any parameters for the algorithm, it has two subfields: algorithm and
 *   parameters, eg: DES-CBC,F8143EDE5960C597.
 *
 * headers: contains all other PEM encapsulated headers -- where order is
 *   significant (for pairing data like recipient ID + key info).
 *
 * body: the binary-encoded body.
 */ 
var $hSPkV = parcelRequire("hSPkV");
parcelRequire("3lPw4");
// shortcut for pem API
var $69c7e30646384431$var$pem = module.exports = $hSPkV.pem = $hSPkV.pem || {};
/**
 * Encodes (serializes) the given PEM object.
 *
 * @param msg the PEM message object to encode.
 * @param options the options to use:
 *          maxline the maximum characters per line for the body, (default: 64).
 *
 * @return the PEM-formatted string.
 */ $69c7e30646384431$var$pem.encode = function(msg, options) {
    options = options || {};
    var rval = "-----BEGIN " + msg.type + "-----\r\n";
    // encode special headers
    var header;
    if (msg.procType) {
        header = {
            name: "Proc-Type",
            values: [
                String(msg.procType.version),
                msg.procType.type
            ]
        };
        rval += $69c7e30646384431$var$foldHeader(header);
    }
    if (msg.contentDomain) {
        header = {
            name: "Content-Domain",
            values: [
                msg.contentDomain
            ]
        };
        rval += $69c7e30646384431$var$foldHeader(header);
    }
    if (msg.dekInfo) {
        header = {
            name: "DEK-Info",
            values: [
                msg.dekInfo.algorithm
            ]
        };
        if (msg.dekInfo.parameters) header.values.push(msg.dekInfo.parameters);
        rval += $69c7e30646384431$var$foldHeader(header);
    }
    if (msg.headers) // encode all other headers
    for(var i = 0; i < msg.headers.length; ++i)rval += $69c7e30646384431$var$foldHeader(msg.headers[i]);
    // terminate header
    if (msg.procType) rval += "\r\n";
    // add body
    rval += $hSPkV.util.encode64(msg.body, options.maxline || 64) + "\r\n";
    rval += "-----END " + msg.type + "-----\r\n";
    return rval;
};
/**
 * Decodes (deserializes) all PEM messages found in the given string.
 *
 * @param str the PEM-formatted string to decode.
 *
 * @return the PEM message objects in an array.
 */ $69c7e30646384431$var$pem.decode = function(str) {
    var rval = [];
    // split string into PEM messages (be lenient w/EOF on BEGIN line)
    var rMessage = /\s*-----BEGIN ([A-Z0-9- ]+)-----\r?\n?([\x21-\x7e\s]+?(?:\r?\n\r?\n))?([:A-Za-z0-9+\/=\s]+?)-----END \1-----/g;
    var rHeader = /([\x21-\x7e]+):\s*([\x21-\x7e\s^:]+)/;
    var rCRLF = /\r?\n/;
    var match;
    while(true){
        match = rMessage.exec(str);
        if (!match) break;
        // accept "NEW CERTIFICATE REQUEST" as "CERTIFICATE REQUEST"
        // https://datatracker.ietf.org/doc/html/rfc7468#section-7
        var type = match[1];
        if (type === "NEW CERTIFICATE REQUEST") type = "CERTIFICATE REQUEST";
        var msg = {
            type: type,
            procType: null,
            contentDomain: null,
            dekInfo: null,
            headers: [],
            body: $hSPkV.util.decode64(match[3])
        };
        rval.push(msg);
        // no headers
        if (!match[2]) continue;
        // parse headers
        var lines = match[2].split(rCRLF);
        var li = 0;
        while(match && li < lines.length){
            // get line, trim any rhs whitespace
            var line = lines[li].replace(/\s+$/, "");
            // RFC2822 unfold any following folded lines
            for(var nl = li + 1; nl < lines.length; ++nl){
                var next = lines[nl];
                if (!/\s/.test(next[0])) break;
                line += next;
                li = nl;
            }
            // parse header
            match = line.match(rHeader);
            if (match) {
                var header = {
                    name: match[1],
                    values: []
                };
                var values = match[2].split(",");
                for(var vi = 0; vi < values.length; ++vi)header.values.push($69c7e30646384431$var$ltrim(values[vi]));
                // Proc-Type must be the first header
                if (!msg.procType) {
                    if (header.name !== "Proc-Type") throw new Error('Invalid PEM formatted message. The first encapsulated header must be "Proc-Type".');
                    else if (header.values.length !== 2) throw new Error('Invalid PEM formatted message. The "Proc-Type" header must have two subfields.');
                    msg.procType = {
                        version: values[0],
                        type: values[1]
                    };
                } else if (!msg.contentDomain && header.name === "Content-Domain") // special-case Content-Domain
                msg.contentDomain = values[0] || "";
                else if (!msg.dekInfo && header.name === "DEK-Info") {
                    // special-case DEK-Info
                    if (header.values.length === 0) throw new Error('Invalid PEM formatted message. The "DEK-Info" header must have at least one subfield.');
                    msg.dekInfo = {
                        algorithm: values[0],
                        parameters: values[1] || null
                    };
                } else msg.headers.push(header);
            }
            ++li;
        }
        if (msg.procType === "ENCRYPTED" && !msg.dekInfo) throw new Error('Invalid PEM formatted message. The "DEK-Info" header must be present if "Proc-Type" is "ENCRYPTED".');
    }
    if (rval.length === 0) throw new Error("Invalid PEM formatted message.");
    return rval;
};
function $69c7e30646384431$var$foldHeader(header) {
    var rval = header.name + ": ";
    // ensure values with CRLF are folded
    var values = [];
    var insertSpace = function(match, $1) {
        return " " + $1;
    };
    for(var i = 0; i < header.values.length; ++i)values.push(header.values[i].replace(/^(\S+\r\n)/, insertSpace));
    rval += values.join(",") + "\r\n";
    // do folding
    var length = 0;
    var candidate = -1;
    for(var i = 0; i < rval.length; ++i, ++length){
        if (length > 65 && candidate !== -1) {
            var insert = rval[candidate];
            if (insert === ",") {
                ++candidate;
                rval = rval.substr(0, candidate) + "\r\n " + rval.substr(candidate);
            } else rval = rval.substr(0, candidate) + "\r\n" + insert + rval.substr(candidate + 1);
            length = i - candidate - 1;
            candidate = -1;
            ++i;
        } else if (rval[i] === " " || rval[i] === "	" || rval[i] === ",") candidate = i;
    }
    return rval;
}
function $69c7e30646384431$var$ltrim(str) {
    return str.replace(/^\s+/, "");
}

});

parcelRequire.register("eJAQ9", function(module, exports) {
/**
 * An API for getting cryptographically-secure random bytes. The bytes are
 * generated using the Fortuna algorithm devised by Bruce Schneier and
 * Niels Ferguson.
 *
 * Getting strong random bytes is not yet easy to do in javascript. The only
 * truish random entropy that can be collected is from the mouse, keyboard, or
 * from timing with respect to page loads, etc. This generator makes a poor
 * attempt at providing random bytes when those sources haven't yet provided
 * enough entropy to initially seed or to reseed the PRNG.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2009-2014 Digital Bazaar, Inc.
 */ 
var $hSPkV = parcelRequire("hSPkV");
parcelRequire("8ju3Y");
parcelRequire("5aTar");
parcelRequire("81B0t");
parcelRequire("3lPw4");
(function() {
    // forge.random already defined
    if ($hSPkV.random && $hSPkV.random.getBytes) {
        module.exports = $hSPkV.random;
        return;
    }
    (function(jQuery1) {
        // the default prng plugin, uses AES-128
        var prng_aes = {};
        var _prng_aes_output = new Array(4);
        var _prng_aes_buffer = $hSPkV.util.createBuffer();
        prng_aes.formatKey = function(key) {
            // convert the key into 32-bit integers
            var tmp = $hSPkV.util.createBuffer(key);
            key = new Array(4);
            key[0] = tmp.getInt32();
            key[1] = tmp.getInt32();
            key[2] = tmp.getInt32();
            key[3] = tmp.getInt32();
            // return the expanded key
            return $hSPkV.aes._expandKey(key, false);
        };
        prng_aes.formatSeed = function(seed) {
            // convert seed into 32-bit integers
            var tmp = $hSPkV.util.createBuffer(seed);
            seed = new Array(4);
            seed[0] = tmp.getInt32();
            seed[1] = tmp.getInt32();
            seed[2] = tmp.getInt32();
            seed[3] = tmp.getInt32();
            return seed;
        };
        prng_aes.cipher = function(key, seed) {
            $hSPkV.aes._updateBlock(key, seed, _prng_aes_output, false);
            _prng_aes_buffer.putInt32(_prng_aes_output[0]);
            _prng_aes_buffer.putInt32(_prng_aes_output[1]);
            _prng_aes_buffer.putInt32(_prng_aes_output[2]);
            _prng_aes_buffer.putInt32(_prng_aes_output[3]);
            return _prng_aes_buffer.getBytes();
        };
        prng_aes.increment = function(seed) {
            // FIXME: do we care about carry or signed issues?
            ++seed[3];
            return seed;
        };
        prng_aes.md = $hSPkV.md.sha256;
        /**
 * Creates a new PRNG.
 */ function spawnPrng() {
            var ctx = $hSPkV.prng.create(prng_aes);
            /**
   * Gets random bytes. If a native secure crypto API is unavailable, this
   * method tries to make the bytes more unpredictable by drawing from data that
   * can be collected from the user of the browser, eg: mouse movement.
   *
   * If a callback is given, this method will be called asynchronously.
   *
   * @param count the number of random bytes to get.
   * @param [callback(err, bytes)] called once the operation completes.
   *
   * @return the random bytes in a string.
   */ ctx.getBytes = function(count, callback) {
                return ctx.generate(count, callback);
            };
            /**
   * Gets random bytes asynchronously. If a native secure crypto API is
   * unavailable, this method tries to make the bytes more unpredictable by
   * drawing from data that can be collected from the user of the browser,
   * eg: mouse movement.
   *
   * @param count the number of random bytes to get.
   *
   * @return the random bytes in a string.
   */ ctx.getBytesSync = function(count) {
                return ctx.generate(count);
            };
            return ctx;
        }
        // create default prng context
        var _ctx = spawnPrng();
        // add other sources of entropy only if window.crypto.getRandomValues is not
        // available -- otherwise this source will be automatically used by the prng
        var getRandomValues = null;
        var globalScope = $hSPkV.util.globalScope;
        var _crypto = globalScope.crypto || globalScope.msCrypto;
        if (_crypto && _crypto.getRandomValues) getRandomValues = function(arr) {
            return _crypto.getRandomValues(arr);
        };
        if ($hSPkV.options.usePureJavaScript || !$hSPkV.util.isNodejs && !getRandomValues) {
            typeof window === "undefined" || window.document;
            // get load time entropy
            _ctx.collectInt(+new Date(), 32);
            // add some entropy from navigator object
            if (typeof navigator !== "undefined") {
                var _navBytes = "";
                for(var key in navigator)try {
                    if (typeof navigator[key] == "string") _navBytes += navigator[key];
                } catch (e) {
                /* Some navigator keys might not be accessible, e.g. the geolocation
          attribute throws an exception if touched in Mozilla chrome://
          context.

          Silently ignore this and just don't use this as a source of
          entropy. */ }
                _ctx.collect(_navBytes);
                _navBytes = null;
            }
            // add mouse and keyboard collectors if jquery is available
            if (jQuery1) {
                // set up mouse entropy capture
                jQuery1().mousemove(function(e) {
                    // add mouse coords
                    _ctx.collectInt(e.clientX, 16);
                    _ctx.collectInt(e.clientY, 16);
                });
                // set up keyboard entropy capture
                jQuery1().keypress(function(e) {
                    _ctx.collectInt(e.charCode, 8);
                });
            }
        }
        /* Random API */ if (!$hSPkV.random) $hSPkV.random = _ctx;
        else // extend forge.random with _ctx
        for(var key in _ctx)$hSPkV.random[key] = _ctx[key];
        // expose spawn PRNG
        $hSPkV.random.createInstance = spawnPrng;
        module.exports = $hSPkV.random;
    })(typeof jQuery !== "undefined" ? jQuery : null);
})();

});
parcelRequire.register("5aTar", function(module, exports) {
/**
 * Secure Hash Algorithm with 256-bit digest (SHA-256) implementation.
 *
 * See FIPS 180-2 for details.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2015 Digital Bazaar, Inc.
 */ 
var $hSPkV = parcelRequire("hSPkV");
parcelRequire("jCulq");
parcelRequire("3lPw4");
var $3c48ae085ac4ee0e$var$sha256 = module.exports = $hSPkV.sha256 = $hSPkV.sha256 || {};
$hSPkV.md.sha256 = $hSPkV.md.algorithms.sha256 = $3c48ae085ac4ee0e$var$sha256;
/**
 * Creates a SHA-256 message digest object.
 *
 * @return a message digest object.
 */ $3c48ae085ac4ee0e$var$sha256.create = function() {
    // do initialization as necessary
    if (!$3c48ae085ac4ee0e$var$_initialized) $3c48ae085ac4ee0e$var$_init();
    // SHA-256 state contains eight 32-bit integers
    var _state = null;
    // input buffer
    var _input = $hSPkV.util.createBuffer();
    // used for word storage
    var _w = new Array(64);
    // message digest object
    var md = {
        algorithm: "sha256",
        blockLength: 64,
        digestLength: 32,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 8
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength64 for backwards-compatibility)
        md.fullMessageLength = md.messageLength64 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $hSPkV.util.createBuffer();
        _state = {
            h0: 0x6A09E667,
            h1: 0xBB67AE85,
            h2: 0x3C6EF372,
            h3: 0xA54FF53A,
            h4: 0x510E527F,
            h5: 0x9B05688C,
            h6: 0x1F83D9AB,
            h7: 0x5BE0CD19
        };
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === "utf8") msg = $hSPkV.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $3c48ae085ac4ee0e$var$_update(_state, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate SHA-256 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 448 mod 512. In other words,
    the data to be digested must be a multiple of 512 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 8 bytes (64
    bits), that means that the last segment of the data must have 56 bytes
    (448 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 448 mod 512 because
    512 - 128 = 448.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 448 mod 512, then 512 padding bits must be added. */ var finalBlock = $hSPkV.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($3c48ae085ac4ee0e$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in big-endian order; since length
        // is stored in bytes we multiply by 8 and add carry from next int
        var next, carry;
        var bits = md.fullMessageLength[0] * 8;
        for(var i = 0; i < md.fullMessageLength.length - 1; ++i){
            next = md.fullMessageLength[i + 1] * 8;
            carry = next / 0x100000000 >>> 0;
            bits += carry;
            finalBlock.putInt32(bits >>> 0);
            bits = next >>> 0;
        }
        finalBlock.putInt32(bits);
        var s2 = {
            h0: _state.h0,
            h1: _state.h1,
            h2: _state.h2,
            h3: _state.h3,
            h4: _state.h4,
            h5: _state.h5,
            h6: _state.h6,
            h7: _state.h7
        };
        $3c48ae085ac4ee0e$var$_update(s2, _w, finalBlock);
        var rval = $hSPkV.util.createBuffer();
        rval.putInt32(s2.h0);
        rval.putInt32(s2.h1);
        rval.putInt32(s2.h2);
        rval.putInt32(s2.h3);
        rval.putInt32(s2.h4);
        rval.putInt32(s2.h5);
        rval.putInt32(s2.h6);
        rval.putInt32(s2.h7);
        return rval;
    };
    return md;
};
// sha-256 padding bytes not initialized yet
var $3c48ae085ac4ee0e$var$_padding = null;
var $3c48ae085ac4ee0e$var$_initialized = false;
// table of constants
var $3c48ae085ac4ee0e$var$_k = null;
/**
 * Initializes the constant tables.
 */ function $3c48ae085ac4ee0e$var$_init() {
    // create padding
    $3c48ae085ac4ee0e$var$_padding = String.fromCharCode(128);
    $3c48ae085ac4ee0e$var$_padding += $hSPkV.util.fillString(String.fromCharCode(0x00), 64);
    // create K table for SHA-256
    $3c48ae085ac4ee0e$var$_k = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    // now initialized
    $3c48ae085ac4ee0e$var$_initialized = true;
}
/**
 * Updates a SHA-256 state with the given byte buffer.
 *
 * @param s the SHA-256 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $3c48ae085ac4ee0e$var$_update(s, w, bytes) {
    // consume 512 bit (64 byte) chunks
    var t1, t2, s0, s1, ch, maj, i, a, b, c, d, e, f, g, h;
    var len = bytes.length();
    while(len >= 64){
        // the w array will be populated with sixteen 32-bit big-endian words
        // and then extended into 64 32-bit words according to SHA-256
        for(i = 0; i < 16; ++i)w[i] = bytes.getInt32();
        for(; i < 64; ++i){
            // XOR word 2 words ago rot right 17, rot right 19, shft right 10
            t1 = w[i - 2];
            t1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            // XOR word 15 words ago rot right 7, rot right 18, shft right 3
            t2 = w[i - 15];
            t2 = (t2 >>> 7 | t2 << 25) ^ (t2 >>> 18 | t2 << 14) ^ t2 >>> 3;
            // sum(t1, word 7 ago, t2, word 16 ago) modulo 2^32
            w[i] = t1 + w[i - 7] + t2 + w[i - 16] | 0;
        }
        // initialize hash value for this chunk
        a = s.h0;
        b = s.h1;
        c = s.h2;
        d = s.h3;
        e = s.h4;
        f = s.h5;
        g = s.h6;
        h = s.h7;
        // round function
        for(i = 0; i < 64; ++i){
            // Sum1(e)
            s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
            // Ch(e, f, g) (optimized the same way as SHA-1)
            ch = g ^ e & (f ^ g);
            // Sum0(a)
            s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
            // Maj(a, b, c) (optimized the same way as SHA-1)
            maj = a & b | c & (a ^ b);
            // main algorithm
            t1 = h + s1 + ch + $3c48ae085ac4ee0e$var$_k[i] + w[i];
            t2 = s0 + maj;
            h = g;
            g = f;
            f = e;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            // can't truncate with `| 0`
            e = d + t1 >>> 0;
            d = c;
            c = b;
            b = a;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            // can't truncate with `| 0`
            a = t1 + t2 >>> 0;
        }
        // update hash state
        s.h0 = s.h0 + a | 0;
        s.h1 = s.h1 + b | 0;
        s.h2 = s.h2 + c | 0;
        s.h3 = s.h3 + d | 0;
        s.h4 = s.h4 + e | 0;
        s.h5 = s.h5 + f | 0;
        s.h6 = s.h6 + g | 0;
        s.h7 = s.h7 + h | 0;
        len -= 64;
    }
}

});

parcelRequire.register("81B0t", function(module, exports) {
/**
 * A javascript implementation of a cryptographically-secure
 * Pseudo Random Number Generator (PRNG). The Fortuna algorithm is followed
 * here though the use of SHA-256 is not enforced; when generating an
 * a PRNG context, the hashing algorithm and block cipher used for
 * the generator are specified via a plugin.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $7jzxY = parcelRequire("7jzxY");

var $hSPkV = parcelRequire("hSPkV");
parcelRequire("3lPw4");
var $5d7b1f751b6f72ba$var$_crypto = null;

if ($hSPkV.util.isNodejs && !$hSPkV.options.usePureJavaScript && !$7jzxY.versions["node-webkit"]) $5d7b1f751b6f72ba$var$_crypto = (parcelRequire("7jzxY"));
/* PRNG API */ var $5d7b1f751b6f72ba$var$prng = module.exports = $hSPkV.prng = $hSPkV.prng || {};
/**
 * Creates a new PRNG context.
 *
 * A PRNG plugin must be passed in that will provide:
 *
 * 1. A function that initializes the key and seed of a PRNG context. It
 *   will be given a 16 byte key and a 16 byte seed. Any key expansion
 *   or transformation of the seed from a byte string into an array of
 *   integers (or similar) should be performed.
 * 2. The cryptographic function used by the generator. It takes a key and
 *   a seed.
 * 3. A seed increment function. It takes the seed and returns seed + 1.
 * 4. An api to create a message digest.
 *
 * For an example, see random.js.
 *
 * @param plugin the PRNG plugin to use.
 */ $5d7b1f751b6f72ba$var$prng.create = function(plugin) {
    var ctx = {
        plugin: plugin,
        key: null,
        seed: null,
        time: null,
        // number of reseeds so far
        reseeds: 0,
        // amount of data generated so far
        generated: 0,
        // no initial key bytes
        keyBytes: ""
    };
    // create 32 entropy pools (each is a message digest)
    var md = plugin.md;
    var pools = new Array(32);
    for(var i = 0; i < 32; ++i)pools[i] = md.create();
    ctx.pools = pools;
    // entropy pools are written to cyclically, starting at index 0
    ctx.pool = 0;
    /**
   * Generates random bytes. The bytes may be generated synchronously or
   * asynchronously. Web workers must use the asynchronous interface or
   * else the behavior is undefined.
   *
   * @param count the number of random bytes to generate.
   * @param [callback(err, bytes)] called once the operation completes.
   *
   * @return count random bytes as a string.
   */ ctx.generate = function(count, callback) {
        // do synchronously
        if (!callback) return ctx.generateSync(count);
        // simple generator using counter-based CBC
        var cipher = ctx.plugin.cipher;
        var increment = ctx.plugin.increment;
        var formatKey = ctx.plugin.formatKey;
        var formatSeed = ctx.plugin.formatSeed;
        var b = $hSPkV.util.createBuffer();
        // paranoid deviation from Fortuna:
        // reset key for every request to protect previously
        // generated random bytes should the key be discovered;
        // there is no 100ms based reseeding because of this
        // forced reseed for every `generate` call
        ctx.key = null;
        generate();
        function generate(err) {
            if (err) return callback(err);
            // sufficient bytes generated
            if (b.length() >= count) return callback(null, b.getBytes(count));
            // if amount of data generated is greater than 1 MiB, trigger reseed
            if (ctx.generated > 0xfffff) ctx.key = null;
            if (ctx.key === null) // prevent stack overflow
            return $hSPkV.util.nextTick(function() {
                _reseed(generate);
            });
            // generate the random bytes
            var bytes = cipher(ctx.key, ctx.seed);
            ctx.generated += bytes.length;
            b.putBytes(bytes);
            // generate bytes for a new key and seed
            ctx.key = formatKey(cipher(ctx.key, increment(ctx.seed)));
            ctx.seed = formatSeed(cipher(ctx.key, ctx.seed));
            $hSPkV.util.setImmediate(generate);
        }
    };
    /**
   * Generates random bytes synchronously.
   *
   * @param count the number of random bytes to generate.
   *
   * @return count random bytes as a string.
   */ ctx.generateSync = function(count) {
        // simple generator using counter-based CBC
        var cipher = ctx.plugin.cipher;
        var increment = ctx.plugin.increment;
        var formatKey = ctx.plugin.formatKey;
        var formatSeed = ctx.plugin.formatSeed;
        // paranoid deviation from Fortuna:
        // reset key for every request to protect previously
        // generated random bytes should the key be discovered;
        // there is no 100ms based reseeding because of this
        // forced reseed for every `generateSync` call
        ctx.key = null;
        var b = $hSPkV.util.createBuffer();
        while(b.length() < count){
            // if amount of data generated is greater than 1 MiB, trigger reseed
            if (ctx.generated > 0xfffff) ctx.key = null;
            if (ctx.key === null) _reseedSync();
            // generate the random bytes
            var bytes = cipher(ctx.key, ctx.seed);
            ctx.generated += bytes.length;
            b.putBytes(bytes);
            // generate bytes for a new key and seed
            ctx.key = formatKey(cipher(ctx.key, increment(ctx.seed)));
            ctx.seed = formatSeed(cipher(ctx.key, ctx.seed));
        }
        return b.getBytes(count);
    };
    /**
   * Private function that asynchronously reseeds a generator.
   *
   * @param callback(err) called once the operation completes.
   */ function _reseed(callback) {
        if (ctx.pools[0].messageLength >= 32) {
            _seed();
            return callback();
        }
        // not enough seed data...
        var needed = 32 - ctx.pools[0].messageLength << 5;
        ctx.seedFile(needed, function(err, bytes) {
            if (err) return callback(err);
            ctx.collect(bytes);
            _seed();
            callback();
        });
    }
    /**
   * Private function that synchronously reseeds a generator.
   */ function _reseedSync() {
        if (ctx.pools[0].messageLength >= 32) return _seed();
        // not enough seed data...
        var needed = 32 - ctx.pools[0].messageLength << 5;
        ctx.collect(ctx.seedFileSync(needed));
        _seed();
    }
    /**
   * Private function that seeds a generator once enough bytes are available.
   */ function _seed() {
        // update reseed count
        ctx.reseeds = ctx.reseeds === 0xffffffff ? 0 : ctx.reseeds + 1;
        // goal is to update `key` via:
        // key = hash(key + s)
        //   where 's' is all collected entropy from selected pools, then...
        // create a plugin-based message digest
        var md = ctx.plugin.md.create();
        // consume current key bytes
        md.update(ctx.keyBytes);
        // digest the entropy of pools whose index k meet the
        // condition 'n mod 2^k == 0' where n is the number of reseeds
        var _2powK = 1;
        for(var k = 0; k < 32; ++k){
            if (ctx.reseeds % _2powK === 0) {
                md.update(ctx.pools[k].digest().getBytes());
                ctx.pools[k].start();
            }
            _2powK = _2powK << 1;
        }
        // get digest for key bytes
        ctx.keyBytes = md.digest().getBytes();
        // paranoid deviation from Fortuna:
        // update `seed` via `seed = hash(key)`
        // instead of initializing to zero once and only
        // ever incrementing it
        md.start();
        md.update(ctx.keyBytes);
        var seedBytes = md.digest().getBytes();
        // update state
        ctx.key = ctx.plugin.formatKey(ctx.keyBytes);
        ctx.seed = ctx.plugin.formatSeed(seedBytes);
        ctx.generated = 0;
    }
    /**
   * The built-in default seedFile. This seedFile is used when entropy
   * is needed immediately.
   *
   * @param needed the number of bytes that are needed.
   *
   * @return the random bytes.
   */ function defaultSeedFile(needed) {
        // use window.crypto.getRandomValues strong source of entropy if available
        var getRandomValues = null;
        var globalScope = $hSPkV.util.globalScope;
        var _crypto = globalScope.crypto || globalScope.msCrypto;
        if (_crypto && _crypto.getRandomValues) getRandomValues = function(arr) {
            return _crypto.getRandomValues(arr);
        };
        var b = $hSPkV.util.createBuffer();
        if (getRandomValues) while(b.length() < needed){
            // max byte length is 65536 before QuotaExceededError is thrown
            // http://www.w3.org/TR/WebCryptoAPI/#RandomSource-method-getRandomValues
            var count = Math.max(1, Math.min(needed - b.length(), 65536) / 4);
            var entropy = new Uint32Array(Math.floor(count));
            try {
                getRandomValues(entropy);
                for(var i = 0; i < entropy.length; ++i)b.putInt32(entropy[i]);
            } catch (e) {
                /* only ignore QuotaExceededError */ if (!(typeof QuotaExceededError !== "undefined" && e instanceof QuotaExceededError)) throw e;
            }
        }
        // be sad and add some weak random data
        if (b.length() < needed) {
            /* Draws from Park-Miller "minimal standard" 31 bit PRNG,
      implemented with David G. Carta's optimization: with 32 bit math
      and without division (Public Domain). */ var hi, lo, next;
            var seed = Math.floor(Math.random() * 0x010000);
            while(b.length() < needed){
                lo = 16807 * (seed & 0xFFFF);
                hi = 16807 * (seed >> 16);
                lo += (hi & 0x7FFF) << 16;
                lo += hi >> 15;
                lo = (lo & 0x7FFFFFFF) + (lo >> 31);
                seed = lo & 0xFFFFFFFF;
                // consume lower 3 bytes of seed
                for(var i = 0; i < 3; ++i){
                    // throw in more pseudo random
                    next = seed >>> (i << 3);
                    next ^= Math.floor(Math.random() * 0x0100);
                    b.putByte(next & 0xFF);
                }
            }
        }
        return b.getBytes(needed);
    }
    // initialize seed file APIs
    if ($5d7b1f751b6f72ba$var$_crypto) {
        // use nodejs async API
        ctx.seedFile = function(needed, callback) {
            $5d7b1f751b6f72ba$var$_crypto.randomBytes(needed, function(err, bytes) {
                if (err) return callback(err);
                callback(null, bytes.toString());
            });
        };
        // use nodejs sync API
        ctx.seedFileSync = function(needed) {
            return $5d7b1f751b6f72ba$var$_crypto.randomBytes(needed).toString();
        };
    } else {
        ctx.seedFile = function(needed, callback) {
            try {
                callback(null, defaultSeedFile(needed));
            } catch (e) {
                callback(e);
            }
        };
        ctx.seedFileSync = defaultSeedFile;
    }
    /**
   * Adds entropy to a prng ctx's accumulator.
   *
   * @param bytes the bytes of entropy as a string.
   */ ctx.collect = function(bytes) {
        // iterate over pools distributing entropy cyclically
        var count = bytes.length;
        for(var i = 0; i < count; ++i){
            ctx.pools[ctx.pool].update(bytes.substr(i, 1));
            ctx.pool = ctx.pool === 31 ? 0 : ctx.pool + 1;
        }
    };
    /**
   * Collects an integer of n bits.
   *
   * @param i the integer entropy.
   * @param n the number of bits in the integer.
   */ ctx.collectInt = function(i, n) {
        var bytes = "";
        for(var x = 0; x < n; x += 8)bytes += String.fromCharCode(i >> x & 0xFF);
        ctx.collect(bytes);
    };
    /**
   * Registers a Web Worker to receive immediate entropy from the main thread.
   * This method is required until Web Workers can access the native crypto
   * API. This method should be called twice for each created worker, once in
   * the main thread, and once in the worker itself.
   *
   * @param worker the worker to register.
   */ ctx.registerWorker = function(worker) {
        // worker receives random bytes
        if (worker === self) ctx.seedFile = function(needed, callback) {
            function listener(e) {
                var data = e.data;
                if (data.forge && data.forge.prng) {
                    self.removeEventListener("message", listener);
                    callback(data.forge.prng.err, data.forge.prng.bytes);
                }
            }
            self.addEventListener("message", listener);
            self.postMessage({
                forge: {
                    prng: {
                        needed: needed
                    }
                }
            });
        };
        else {
            // main thread sends random bytes upon request
            var listener = function(e) {
                var data = e.data;
                if (data.forge && data.forge.prng) ctx.seedFile(data.forge.prng.needed, function(err, bytes) {
                    worker.postMessage({
                        forge: {
                            prng: {
                                err: err,
                                bytes: bytes
                            }
                        }
                    });
                });
            };
            // TODO: do we need to remove the event listener when the worker dies?
            worker.addEventListener("message", listener);
        }
    };
    return ctx;
};

});


parcelRequire.register("c6w1L", function(module, exports) {
/**
 * RC2 implementation.
 *
 * @author Stefan Siegl
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * Information on the RC2 cipher is available from RFC #2268,
 * http://www.ietf.org/rfc/rfc2268.txt
 */ 
var $hSPkV = parcelRequire("hSPkV");
parcelRequire("3lPw4");
var $8cfee393c52de8b7$var$piTable = [
    0xd9,
    0x78,
    0xf9,
    0xc4,
    0x19,
    0xdd,
    0xb5,
    0xed,
    0x28,
    0xe9,
    0xfd,
    0x79,
    0x4a,
    0xa0,
    0xd8,
    0x9d,
    0xc6,
    0x7e,
    0x37,
    0x83,
    0x2b,
    0x76,
    0x53,
    0x8e,
    0x62,
    0x4c,
    0x64,
    0x88,
    0x44,
    0x8b,
    0xfb,
    0xa2,
    0x17,
    0x9a,
    0x59,
    0xf5,
    0x87,
    0xb3,
    0x4f,
    0x13,
    0x61,
    0x45,
    0x6d,
    0x8d,
    0x09,
    0x81,
    0x7d,
    0x32,
    0xbd,
    0x8f,
    0x40,
    0xeb,
    0x86,
    0xb7,
    0x7b,
    0x0b,
    0xf0,
    0x95,
    0x21,
    0x22,
    0x5c,
    0x6b,
    0x4e,
    0x82,
    0x54,
    0xd6,
    0x65,
    0x93,
    0xce,
    0x60,
    0xb2,
    0x1c,
    0x73,
    0x56,
    0xc0,
    0x14,
    0xa7,
    0x8c,
    0xf1,
    0xdc,
    0x12,
    0x75,
    0xca,
    0x1f,
    0x3b,
    0xbe,
    0xe4,
    0xd1,
    0x42,
    0x3d,
    0xd4,
    0x30,
    0xa3,
    0x3c,
    0xb6,
    0x26,
    0x6f,
    0xbf,
    0x0e,
    0xda,
    0x46,
    0x69,
    0x07,
    0x57,
    0x27,
    0xf2,
    0x1d,
    0x9b,
    0xbc,
    0x94,
    0x43,
    0x03,
    0xf8,
    0x11,
    0xc7,
    0xf6,
    0x90,
    0xef,
    0x3e,
    0xe7,
    0x06,
    0xc3,
    0xd5,
    0x2f,
    0xc8,
    0x66,
    0x1e,
    0xd7,
    0x08,
    0xe8,
    0xea,
    0xde,
    0x80,
    0x52,
    0xee,
    0xf7,
    0x84,
    0xaa,
    0x72,
    0xac,
    0x35,
    0x4d,
    0x6a,
    0x2a,
    0x96,
    0x1a,
    0xd2,
    0x71,
    0x5a,
    0x15,
    0x49,
    0x74,
    0x4b,
    0x9f,
    0xd0,
    0x5e,
    0x04,
    0x18,
    0xa4,
    0xec,
    0xc2,
    0xe0,
    0x41,
    0x6e,
    0x0f,
    0x51,
    0xcb,
    0xcc,
    0x24,
    0x91,
    0xaf,
    0x50,
    0xa1,
    0xf4,
    0x70,
    0x39,
    0x99,
    0x7c,
    0x3a,
    0x85,
    0x23,
    0xb8,
    0xb4,
    0x7a,
    0xfc,
    0x02,
    0x36,
    0x5b,
    0x25,
    0x55,
    0x97,
    0x31,
    0x2d,
    0x5d,
    0xfa,
    0x98,
    0xe3,
    0x8a,
    0x92,
    0xae,
    0x05,
    0xdf,
    0x29,
    0x10,
    0x67,
    0x6c,
    0xba,
    0xc9,
    0xd3,
    0x00,
    0xe6,
    0xcf,
    0xe1,
    0x9e,
    0xa8,
    0x2c,
    0x63,
    0x16,
    0x01,
    0x3f,
    0x58,
    0xe2,
    0x89,
    0xa9,
    0x0d,
    0x38,
    0x34,
    0x1b,
    0xab,
    0x33,
    0xff,
    0xb0,
    0xbb,
    0x48,
    0x0c,
    0x5f,
    0xb9,
    0xb1,
    0xcd,
    0x2e,
    0xc5,
    0xf3,
    0xdb,
    0x47,
    0xe5,
    0xa5,
    0x9c,
    0x77,
    0x0a,
    0xa6,
    0x20,
    0x68,
    0xfe,
    0x7f,
    0xc1,
    0xad
];
var $8cfee393c52de8b7$var$s = [
    1,
    2,
    3,
    5
];
/**
 * Rotate a word left by given number of bits.
 *
 * Bits that are shifted out on the left are put back in on the right
 * hand side.
 *
 * @param word The word to shift left.
 * @param bits The number of bits to shift by.
 * @return The rotated word.
 */ var $8cfee393c52de8b7$var$rol = function(word, bits) {
    return word << bits & 0xffff | (word & 0xffff) >> 16 - bits;
};
/**
 * Rotate a word right by given number of bits.
 *
 * Bits that are shifted out on the right are put back in on the left
 * hand side.
 *
 * @param word The word to shift right.
 * @param bits The number of bits to shift by.
 * @return The rotated word.
 */ var $8cfee393c52de8b7$var$ror = function(word, bits) {
    return (word & 0xffff) >> bits | word << 16 - bits & 0xffff;
};
/* RC2 API */ module.exports = $hSPkV.rc2 = $hSPkV.rc2 || {};
/**
 * Perform RC2 key expansion as per RFC #2268, section 2.
 *
 * @param key variable-length user key (between 1 and 128 bytes)
 * @param effKeyBits number of effective key bits (default: 128)
 * @return the expanded RC2 key (ByteBuffer of 128 bytes)
 */ $hSPkV.rc2.expandKey = function(key, effKeyBits) {
    if (typeof key === "string") key = $hSPkV.util.createBuffer(key);
    effKeyBits = effKeyBits || 128;
    /* introduce variables that match the names used in RFC #2268 */ var L = key;
    var T = key.length();
    var T1 = effKeyBits;
    var T8 = Math.ceil(T1 / 8);
    var TM = 0xff >> (T1 & 0x07);
    var i;
    for(i = T; i < 128; i++)L.putByte($8cfee393c52de8b7$var$piTable[L.at(i - 1) + L.at(i - T) & 0xff]);
    L.setAt(128 - T8, $8cfee393c52de8b7$var$piTable[L.at(128 - T8) & TM]);
    for(i = 127 - T8; i >= 0; i--)L.setAt(i, $8cfee393c52de8b7$var$piTable[L.at(i + 1) ^ L.at(i + T8)]);
    return L;
};
/**
 * Creates a RC2 cipher object.
 *
 * @param key the symmetric key to use (as base for key generation).
 * @param bits the number of effective key bits.
 * @param encrypt false for decryption, true for encryption.
 *
 * @return the cipher.
 */ var $8cfee393c52de8b7$var$createCipher = function(key, bits, encrypt) {
    var _finish = false, _input = null, _output = null, _iv = null;
    var mixRound, mashRound;
    var i, j, K = [];
    /* Expand key and fill into K[] Array */ key = $hSPkV.rc2.expandKey(key, bits);
    for(i = 0; i < 64; i++)K.push(key.getInt16Le());
    if (encrypt) {
        /**
     * Perform one mixing round "in place".
     *
     * @param R Array of four words to perform mixing on.
     */ mixRound = function(R) {
            for(i = 0; i < 4; i++){
                R[i] += K[j] + (R[(i + 3) % 4] & R[(i + 2) % 4]) + (~R[(i + 3) % 4] & R[(i + 1) % 4]);
                R[i] = $8cfee393c52de8b7$var$rol(R[i], $8cfee393c52de8b7$var$s[i]);
                j++;
            }
        };
        /**
     * Perform one mashing round "in place".
     *
     * @param R Array of four words to perform mashing on.
     */ mashRound = function(R) {
            for(i = 0; i < 4; i++)R[i] += K[R[(i + 3) % 4] & 63];
        };
    } else {
        /**
     * Perform one r-mixing round "in place".
     *
     * @param R Array of four words to perform mixing on.
     */ mixRound = function(R) {
            for(i = 3; i >= 0; i--){
                R[i] = $8cfee393c52de8b7$var$ror(R[i], $8cfee393c52de8b7$var$s[i]);
                R[i] -= K[j] + (R[(i + 3) % 4] & R[(i + 2) % 4]) + (~R[(i + 3) % 4] & R[(i + 1) % 4]);
                j--;
            }
        };
        /**
     * Perform one r-mashing round "in place".
     *
     * @param R Array of four words to perform mashing on.
     */ mashRound = function(R) {
            for(i = 3; i >= 0; i--)R[i] -= K[R[(i + 3) % 4] & 63];
        };
    }
    /**
   * Run the specified cipher execution plan.
   *
   * This function takes four words from the input buffer, applies the IV on
   * it (if requested) and runs the provided execution plan.
   *
   * The plan must be put together in form of a array of arrays.  Where the
   * outer one is simply a list of steps to perform and the inner one needs
   * to have two elements: the first one telling how many rounds to perform,
   * the second one telling what to do (i.e. the function to call).
   *
   * @param {Array} plan The plan to execute.
   */ var runPlan = function(plan) {
        var R = [];
        /* Get data from input buffer and fill the four words into R */ for(i = 0; i < 4; i++){
            var val = _input.getInt16Le();
            if (_iv !== null) {
                if (encrypt) /* We're encrypting, apply the IV first. */ val ^= _iv.getInt16Le();
                else /* We're decryption, keep cipher text for next block. */ _iv.putInt16Le(val);
            }
            R.push(val & 0xffff);
        }
        /* Reset global "j" variable as per spec. */ j = encrypt ? 0 : 63;
        /* Run execution plan. */ for(var ptr = 0; ptr < plan.length; ptr++)for(var ctr = 0; ctr < plan[ptr][0]; ctr++)plan[ptr][1](R);
        /* Write back result to output buffer. */ for(i = 0; i < 4; i++){
            if (_iv !== null) {
                if (encrypt) /* We're encrypting in CBC-mode, feed back encrypted bytes into
             IV buffer to carry it forward to next block. */ _iv.putInt16Le(R[i]);
                else R[i] ^= _iv.getInt16Le();
            }
            _output.putInt16Le(R[i]);
        }
    };
    /* Create cipher object */ var cipher = null;
    cipher = {
        /**
     * Starts or restarts the encryption or decryption process, whichever
     * was previously configured.
     *
     * To use the cipher in CBC mode, iv may be given either as a string
     * of bytes, or as a byte buffer.  For ECB mode, give null as iv.
     *
     * @param iv the initialization vector to use, null for ECB mode.
     * @param output the output the buffer to write to, null to create one.
     */ start: function(iv, output) {
            if (iv) /* CBC mode */ {
                if (typeof iv === "string") iv = $hSPkV.util.createBuffer(iv);
            }
            _finish = false;
            _input = $hSPkV.util.createBuffer();
            _output = output || new $hSPkV.util.createBuffer();
            _iv = iv;
            cipher.output = _output;
        },
        /**
     * Updates the next block.
     *
     * @param input the buffer to read from.
     */ update: function(input) {
            if (!_finish) // not finishing, so fill the input buffer with more input
            _input.putBuffer(input);
            while(_input.length() >= 8)runPlan([
                [
                    5,
                    mixRound
                ],
                [
                    1,
                    mashRound
                ],
                [
                    6,
                    mixRound
                ],
                [
                    1,
                    mashRound
                ],
                [
                    5,
                    mixRound
                ]
            ]);
        },
        /**
     * Finishes encrypting or decrypting.
     *
     * @param pad a padding function to use, null for PKCS#7 padding,
     *           signature(blockSize, buffer, decrypt).
     *
     * @return true if successful, false on error.
     */ finish: function(pad) {
            var rval = true;
            if (encrypt) {
                if (pad) rval = pad(8, _input, !encrypt);
                else {
                    // add PKCS#7 padding to block (each pad byte is the
                    // value of the number of pad bytes)
                    var padding = _input.length() === 8 ? 8 : 8 - _input.length();
                    _input.fillWithByte(padding, padding);
                }
            }
            if (rval) {
                // do final update
                _finish = true;
                cipher.update();
            }
            if (!encrypt) {
                // check for error: input data not a multiple of block size
                rval = _input.length() === 0;
                if (rval) {
                    if (pad) rval = pad(8, _output, !encrypt);
                    else {
                        // ensure padding byte count is valid
                        var len = _output.length();
                        var count = _output.at(len - 1);
                        if (count > len) rval = false;
                        else // trim off padding bytes
                        _output.truncate(count);
                    }
                }
            }
            return rval;
        }
    };
    return cipher;
};
/**
 * Creates an RC2 cipher object to encrypt data in ECB or CBC mode using the
 * given symmetric key. The output will be stored in the 'output' member
 * of the returned cipher.
 *
 * The key and iv may be given as a string of bytes or a byte buffer.
 * The cipher is initialized to use 128 effective key bits.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 *
 * @return the cipher.
 */ $hSPkV.rc2.startEncrypting = function(key, iv, output) {
    var cipher = $hSPkV.rc2.createEncryptionCipher(key, 128);
    cipher.start(iv, output);
    return cipher;
};
/**
 * Creates an RC2 cipher object to encrypt data in ECB or CBC mode using the
 * given symmetric key.
 *
 * The key may be given as a string of bytes or a byte buffer.
 *
 * To start encrypting call start() on the cipher with an iv and optional
 * output buffer.
 *
 * @param key the symmetric key to use.
 *
 * @return the cipher.
 */ $hSPkV.rc2.createEncryptionCipher = function(key, bits) {
    return $8cfee393c52de8b7$var$createCipher(key, bits, true);
};
/**
 * Creates an RC2 cipher object to decrypt data in ECB or CBC mode using the
 * given symmetric key. The output will be stored in the 'output' member
 * of the returned cipher.
 *
 * The key and iv may be given as a string of bytes or a byte buffer.
 * The cipher is initialized to use 128 effective key bits.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 *
 * @return the cipher.
 */ $hSPkV.rc2.startDecrypting = function(key, iv, output) {
    var cipher = $hSPkV.rc2.createDecryptionCipher(key, 128);
    cipher.start(iv, output);
    return cipher;
};
/**
 * Creates an RC2 cipher object to decrypt data in ECB or CBC mode using the
 * given symmetric key.
 *
 * The key may be given as a string of bytes or a byte buffer.
 *
 * To start decrypting call start() on the cipher with an iv and optional
 * output buffer.
 *
 * @param key the symmetric key to use.
 *
 * @return the cipher.
 */ $hSPkV.rc2.createDecryptionCipher = function(key, bits) {
    return $8cfee393c52de8b7$var$createCipher(key, bits, false);
};

});

parcelRequire.register("9Je9a", function(module, exports) {
/**
 * Javascript implementation of basic RSA algorithms.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 *
 * The only algorithm currently supported for PKI is RSA.
 *
 * An RSA key is often stored in ASN.1 DER format. The SubjectPublicKeyInfo
 * ASN.1 structure is composed of an algorithm of type AlgorithmIdentifier
 * and a subjectPublicKey of type bit string.
 *
 * The AlgorithmIdentifier contains an Object Identifier (OID) and parameters
 * for the algorithm, if any. In the case of RSA, there aren't any.
 *
 * SubjectPublicKeyInfo ::= SEQUENCE {
 *   algorithm AlgorithmIdentifier,
 *   subjectPublicKey BIT STRING
 * }
 *
 * AlgorithmIdentifer ::= SEQUENCE {
 *   algorithm OBJECT IDENTIFIER,
 *   parameters ANY DEFINED BY algorithm OPTIONAL
 * }
 *
 * For an RSA public key, the subjectPublicKey is:
 *
 * RSAPublicKey ::= SEQUENCE {
 *   modulus            INTEGER,    -- n
 *   publicExponent     INTEGER     -- e
 * }
 *
 * PrivateKeyInfo ::= SEQUENCE {
 *   version                   Version,
 *   privateKeyAlgorithm       PrivateKeyAlgorithmIdentifier,
 *   privateKey                PrivateKey,
 *   attributes           [0]  IMPLICIT Attributes OPTIONAL
 * }
 *
 * Version ::= INTEGER
 * PrivateKeyAlgorithmIdentifier ::= AlgorithmIdentifier
 * PrivateKey ::= OCTET STRING
 * Attributes ::= SET OF Attribute
 *
 * An RSA private key as the following structure:
 *
 * RSAPrivateKey ::= SEQUENCE {
 *   version Version,
 *   modulus INTEGER, -- n
 *   publicExponent INTEGER, -- e
 *   privateExponent INTEGER, -- d
 *   prime1 INTEGER, -- p
 *   prime2 INTEGER, -- q
 *   exponent1 INTEGER, -- d mod (p-1)
 *   exponent2 INTEGER, -- d mod (q-1)
 *   coefficient INTEGER -- (inverse of q) mod p
 * }
 *
 * Version ::= INTEGER
 *
 * The OID for the RSA key algorithm is: 1.2.840.113549.1.1.1
 */ 
var $hSPkV = parcelRequire("hSPkV");
parcelRequire("ehQqu");
parcelRequire("cHVVU");
parcelRequire("inNg9");
parcelRequire("dImdE");
parcelRequire("9NNan");
parcelRequire("eJAQ9");
parcelRequire("3lPw4");
if (typeof $71534a487cb5581d$var$BigInteger === "undefined") var $71534a487cb5581d$var$BigInteger = $hSPkV.jsbn.BigInteger;

var $71534a487cb5581d$var$_crypto = $hSPkV.util.isNodejs ? (parcelRequire("7jzxY")) : null;
// shortcut for asn.1 API
var $71534a487cb5581d$var$asn1 = $hSPkV.asn1;
// shortcut for util API
var $71534a487cb5581d$var$util = $hSPkV.util;
/*
 * RSA encryption and decryption, see RFC 2313.
 */ $hSPkV.pki = $hSPkV.pki || {};
module.exports = $hSPkV.pki.rsa = $hSPkV.rsa = $hSPkV.rsa || {};
var $71534a487cb5581d$var$pki = $hSPkV.pki;
// for finding primes, which are 30k+i for i = 1, 7, 11, 13, 17, 19, 23, 29
var $71534a487cb5581d$var$GCD_30_DELTA = [
    6,
    4,
    2,
    4,
    2,
    4,
    6,
    2
];
// validator for a PrivateKeyInfo structure
var $71534a487cb5581d$var$privateKeyValidator = {
    // PrivateKeyInfo
    name: "PrivateKeyInfo",
    tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
    type: $71534a487cb5581d$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // Version (INTEGER)
            name: "PrivateKeyInfo.version",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyVersion"
        },
        {
            // privateKeyAlgorithm
            name: "PrivateKeyInfo.privateKeyAlgorithm",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
                    type: $71534a487cb5581d$var$asn1.Type.OID,
                    constructed: false,
                    capture: "privateKeyOid"
                }
            ]
        },
        {
            // PrivateKey
            name: "PrivateKeyInfo",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "privateKey"
        }
    ]
};
// validator for an RSA private key
var $71534a487cb5581d$var$rsaPrivateKeyValidator = {
    // RSAPrivateKey
    name: "RSAPrivateKey",
    tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
    type: $71534a487cb5581d$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // Version (INTEGER)
            name: "RSAPrivateKey.version",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyVersion"
        },
        {
            // modulus (n)
            name: "RSAPrivateKey.modulus",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyModulus"
        },
        {
            // publicExponent (e)
            name: "RSAPrivateKey.publicExponent",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyPublicExponent"
        },
        {
            // privateExponent (d)
            name: "RSAPrivateKey.privateExponent",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyPrivateExponent"
        },
        {
            // prime1 (p)
            name: "RSAPrivateKey.prime1",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyPrime1"
        },
        {
            // prime2 (q)
            name: "RSAPrivateKey.prime2",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyPrime2"
        },
        {
            // exponent1 (d mod (p-1))
            name: "RSAPrivateKey.exponent1",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyExponent1"
        },
        {
            // exponent2 (d mod (q-1))
            name: "RSAPrivateKey.exponent2",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyExponent2"
        },
        {
            // coefficient ((inverse of q) mod p)
            name: "RSAPrivateKey.coefficient",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyCoefficient"
        }
    ]
};
// validator for an RSA public key
var $71534a487cb5581d$var$rsaPublicKeyValidator = {
    // RSAPublicKey
    name: "RSAPublicKey",
    tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
    type: $71534a487cb5581d$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // modulus (n)
            name: "RSAPublicKey.modulus",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "publicKeyModulus"
        },
        {
            // publicExponent (e)
            name: "RSAPublicKey.exponent",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "publicKeyExponent"
        }
    ]
};
// validator for an SubjectPublicKeyInfo structure
// Note: Currently only works with an RSA public key
var $71534a487cb5581d$var$publicKeyValidator = $hSPkV.pki.rsa.publicKeyValidator = {
    name: "SubjectPublicKeyInfo",
    tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
    type: $71534a487cb5581d$var$asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: "subjectPublicKeyInfo",
    value: [
        {
            name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
                    type: $71534a487cb5581d$var$asn1.Type.OID,
                    constructed: false,
                    capture: "publicKeyOid"
                }
            ]
        },
        {
            // subjectPublicKey
            name: "SubjectPublicKeyInfo.subjectPublicKey",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.BITSTRING,
            constructed: false,
            value: [
                {
                    // RSAPublicKey
                    name: "SubjectPublicKeyInfo.subjectPublicKey.RSAPublicKey",
                    tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
                    type: $71534a487cb5581d$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    optional: true,
                    captureAsn1: "rsaPublicKey"
                }
            ]
        }
    ]
};
// validator for a DigestInfo structure
var $71534a487cb5581d$var$digestInfoValidator = {
    name: "DigestInfo",
    tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
    type: $71534a487cb5581d$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "DigestInfo.DigestAlgorithm",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "DigestInfo.DigestAlgorithm.algorithmIdentifier",
                    tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
                    type: $71534a487cb5581d$var$asn1.Type.OID,
                    constructed: false,
                    capture: "algorithmIdentifier"
                },
                {
                    // NULL parameters
                    name: "DigestInfo.DigestAlgorithm.parameters",
                    tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
                    type: $71534a487cb5581d$var$asn1.Type.NULL,
                    // captured only to check existence for md2 and md5
                    capture: "parameters",
                    optional: true,
                    constructed: false
                }
            ]
        },
        {
            // digest
            name: "DigestInfo.digest",
            tagClass: $71534a487cb5581d$var$asn1.Class.UNIVERSAL,
            type: $71534a487cb5581d$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "digest"
        }
    ]
};
/**
 * Wrap digest in DigestInfo object.
 *
 * This function implements EMSA-PKCS1-v1_5-ENCODE as per RFC 3447.
 *
 * DigestInfo ::= SEQUENCE {
 *   digestAlgorithm DigestAlgorithmIdentifier,
 *   digest Digest
 * }
 *
 * DigestAlgorithmIdentifier ::= AlgorithmIdentifier
 * Digest ::= OCTET STRING
 *
 * @param md the message digest object with the hash to sign.
 *
 * @return the encoded message (ready for RSA encryption)
 */ var $71534a487cb5581d$var$emsaPkcs1v15encode = function(md) {
    // get the oid for the algorithm
    var oid;
    if (md.algorithm in $71534a487cb5581d$var$pki.oids) oid = $71534a487cb5581d$var$pki.oids[md.algorithm];
    else {
        var error = new Error("Unknown message digest algorithm.");
        error.algorithm = md.algorithm;
        throw error;
    }
    var oidBytes = $71534a487cb5581d$var$asn1.oidToDer(oid).getBytes();
    // create the digest info
    var digestInfo = $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.SEQUENCE, true, []);
    var digestAlgorithm = $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.SEQUENCE, true, []);
    digestAlgorithm.value.push($71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.OID, false, oidBytes));
    digestAlgorithm.value.push($71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.NULL, false, ""));
    var digest = $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.OCTETSTRING, false, md.digest().getBytes());
    digestInfo.value.push(digestAlgorithm);
    digestInfo.value.push(digest);
    // encode digest info
    return $71534a487cb5581d$var$asn1.toDer(digestInfo).getBytes();
};
/**
 * Performs x^c mod n (RSA encryption or decryption operation).
 *
 * @param x the number to raise and mod.
 * @param key the key to use.
 * @param pub true if the key is public, false if private.
 *
 * @return the result of x^c mod n.
 */ var $71534a487cb5581d$var$_modPow = function(x, key, pub) {
    if (pub) return x.modPow(key.e, key.n);
    if (!key.p || !key.q) // allow calculation without CRT params (slow)
    return x.modPow(key.d, key.n);
    // pre-compute dP, dQ, and qInv if necessary
    if (!key.dP) key.dP = key.d.mod(key.p.subtract($71534a487cb5581d$var$BigInteger.ONE));
    if (!key.dQ) key.dQ = key.d.mod(key.q.subtract($71534a487cb5581d$var$BigInteger.ONE));
    if (!key.qInv) key.qInv = key.q.modInverse(key.p);
    /* Chinese remainder theorem (CRT) states:

    Suppose n1, n2, ..., nk are positive integers which are pairwise
    coprime (n1 and n2 have no common factors other than 1). For any
    integers x1, x2, ..., xk there exists an integer x solving the
    system of simultaneous congruences (where ~= means modularly
    congruent so a ~= b mod n means a mod n = b mod n):

    x ~= x1 mod n1
    x ~= x2 mod n2
    ...
    x ~= xk mod nk

    This system of congruences has a single simultaneous solution x
    between 0 and n - 1. Furthermore, each xk solution and x itself
    is congruent modulo the product n = n1*n2*...*nk.
    So x1 mod n = x2 mod n = xk mod n = x mod n.

    The single simultaneous solution x can be solved with the following
    equation:

    x = sum(xi*ri*si) mod n where ri = n/ni and si = ri^-1 mod ni.

    Where x is less than n, xi = x mod ni.

    For RSA we are only concerned with k = 2. The modulus n = pq, where
    p and q are coprime. The RSA decryption algorithm is:

    y = x^d mod n

    Given the above:

    x1 = x^d mod p
    r1 = n/p = q
    s1 = q^-1 mod p
    x2 = x^d mod q
    r2 = n/q = p
    s2 = p^-1 mod q

    So y = (x1r1s1 + x2r2s2) mod n
         = ((x^d mod p)q(q^-1 mod p) + (x^d mod q)p(p^-1 mod q)) mod n

    According to Fermat's Little Theorem, if the modulus P is prime,
    for any integer A not evenly divisible by P, A^(P-1) ~= 1 mod P.
    Since A is not divisible by P it follows that if:
    N ~= M mod (P - 1), then A^N mod P = A^M mod P. Therefore:

    A^N mod P = A^(M mod (P - 1)) mod P. (The latter takes less effort
    to calculate). In order to calculate x^d mod p more quickly the
    exponent d mod (p - 1) is stored in the RSA private key (the same
    is done for x^d mod q). These values are referred to as dP and dQ
    respectively. Therefore we now have:

    y = ((x^dP mod p)q(q^-1 mod p) + (x^dQ mod q)p(p^-1 mod q)) mod n

    Since we'll be reducing x^dP by modulo p (same for q) we can also
    reduce x by p (and q respectively) before hand. Therefore, let

    xp = ((x mod p)^dP mod p), and
    xq = ((x mod q)^dQ mod q), yielding:

    y = (xp*q*(q^-1 mod p) + xq*p*(p^-1 mod q)) mod n

    This can be further reduced to a simple algorithm that only
    requires 1 inverse (the q inverse is used) to be used and stored.
    The algorithm is called Garner's algorithm. If qInv is the
    inverse of q, we simply calculate:

    y = (qInv*(xp - xq) mod p) * q + xq

    However, there are two further complications. First, we need to
    ensure that xp > xq to prevent signed BigIntegers from being used
    so we add p until this is true (since we will be mod'ing with
    p anyway). Then, there is a known timing attack on algorithms
    using the CRT. To mitigate this risk, "cryptographic blinding"
    should be used. This requires simply generating a random number r
    between 0 and n-1 and its inverse and multiplying x by r^e before
    calculating y and then multiplying y by r^-1 afterwards. Note that
    r must be coprime with n (gcd(r, n) === 1) in order to have an
    inverse.
  */ // cryptographic blinding
    var r;
    do r = new $71534a487cb5581d$var$BigInteger($hSPkV.util.bytesToHex($hSPkV.random.getBytes(key.n.bitLength() / 8)), 16);
    while (r.compareTo(key.n) >= 0 || !r.gcd(key.n).equals($71534a487cb5581d$var$BigInteger.ONE));
    x = x.multiply(r.modPow(key.e, key.n)).mod(key.n);
    // calculate xp and xq
    var xp = x.mod(key.p).modPow(key.dP, key.p);
    var xq = x.mod(key.q).modPow(key.dQ, key.q);
    // xp must be larger than xq to avoid signed bit usage
    while(xp.compareTo(xq) < 0)xp = xp.add(key.p);
    // do last step
    var y = xp.subtract(xq).multiply(key.qInv).mod(key.p).multiply(key.q).add(xq);
    // remove effect of random for cryptographic blinding
    y = y.multiply(r.modInverse(key.n)).mod(key.n);
    return y;
};
/**
 * NOTE: THIS METHOD IS DEPRECATED, use 'sign' on a private key object or
 * 'encrypt' on a public key object instead.
 *
 * Performs RSA encryption.
 *
 * The parameter bt controls whether to put padding bytes before the
 * message passed in. Set bt to either true or false to disable padding
 * completely (in order to handle e.g. EMSA-PSS encoding separately before),
 * signaling whether the encryption operation is a public key operation
 * (i.e. encrypting data) or not, i.e. private key operation (data signing).
 *
 * For PKCS#1 v1.5 padding pass in the block type to use, i.e. either 0x01
 * (for signing) or 0x02 (for encryption). The key operation mode (private
 * or public) is derived from this flag in that case).
 *
 * @param m the message to encrypt as a byte string.
 * @param key the RSA key to use.
 * @param bt for PKCS#1 v1.5 padding, the block type to use
 *   (0x01 for private key, 0x02 for public),
 *   to disable padding: true = public key, false = private key.
 *
 * @return the encrypted bytes as a string.
 */ $71534a487cb5581d$var$pki.rsa.encrypt = function(m, key, bt) {
    var pub = bt;
    var eb;
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    if (bt !== false && bt !== true) {
        // legacy, default to PKCS#1 v1.5 padding
        pub = bt === 0x02;
        eb = $71534a487cb5581d$var$_encodePkcs1_v1_5(m, key, bt);
    } else {
        eb = $hSPkV.util.createBuffer();
        eb.putBytes(m);
    }
    // load encryption block as big integer 'x'
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var x = new $71534a487cb5581d$var$BigInteger(eb.toHex(), 16);
    // do RSA encryption
    var y = $71534a487cb5581d$var$_modPow(x, key, pub);
    // convert y into the encrypted data byte string, if y is shorter in
    // bytes than k, then prepend zero bytes to fill up ed
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var yhex = y.toString(16);
    var ed = $hSPkV.util.createBuffer();
    var zeros = k - Math.ceil(yhex.length / 2);
    while(zeros > 0){
        ed.putByte(0x00);
        --zeros;
    }
    ed.putBytes($hSPkV.util.hexToBytes(yhex));
    return ed.getBytes();
};
/**
 * NOTE: THIS METHOD IS DEPRECATED, use 'decrypt' on a private key object or
 * 'verify' on a public key object instead.
 *
 * Performs RSA decryption.
 *
 * The parameter ml controls whether to apply PKCS#1 v1.5 padding
 * or not.  Set ml = false to disable padding removal completely
 * (in order to handle e.g. EMSA-PSS later on) and simply pass back
 * the RSA encryption block.
 *
 * @param ed the encrypted data to decrypt in as a byte string.
 * @param key the RSA key to use.
 * @param pub true for a public key operation, false for private.
 * @param ml the message length, if known, false to disable padding.
 *
 * @return the decrypted message as a byte string.
 */ $71534a487cb5581d$var$pki.rsa.decrypt = function(ed, key, pub, ml) {
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    // error if the length of the encrypted data ED is not k
    if (ed.length !== k) {
        var error = new Error("Encrypted message length is invalid.");
        error.length = ed.length;
        error.expected = k;
        throw error;
    }
    // convert encrypted data into a big integer
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var y = new $71534a487cb5581d$var$BigInteger($hSPkV.util.createBuffer(ed).toHex(), 16);
    // y must be less than the modulus or it wasn't the result of
    // a previous mod operation (encryption) using that modulus
    if (y.compareTo(key.n) >= 0) throw new Error("Encrypted message is invalid.");
    // do RSA decryption
    var x = $71534a487cb5581d$var$_modPow(y, key, pub);
    // create the encryption block, if x is shorter in bytes than k, then
    // prepend zero bytes to fill up eb
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var xhex = x.toString(16);
    var eb = $hSPkV.util.createBuffer();
    var zeros = k - Math.ceil(xhex.length / 2);
    while(zeros > 0){
        eb.putByte(0x00);
        --zeros;
    }
    eb.putBytes($hSPkV.util.hexToBytes(xhex));
    if (ml !== false) // legacy, default to PKCS#1 v1.5 padding
    return $71534a487cb5581d$var$_decodePkcs1_v1_5(eb.getBytes(), key, pub);
    // return message
    return eb.getBytes();
};
/**
 * Creates an RSA key-pair generation state object. It is used to allow
 * key-generation to be performed in steps. It also allows for a UI to
 * display progress updates.
 *
 * @param bits the size for the private key in bits, defaults to 2048.
 * @param e the public exponent to use, defaults to 65537 (0x10001).
 * @param [options] the options to use.
 *          prng a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync".
 *          algorithm the algorithm to use (default: 'PRIMEINC').
 *
 * @return the state object to use to generate the key-pair.
 */ $71534a487cb5581d$var$pki.rsa.createKeyPairGenerationState = function(bits, e, options) {
    // TODO: migrate step-based prime generation code to forge.prime
    // set default bits
    if (typeof bits === "string") bits = parseInt(bits, 10);
    bits = bits || 2048;
    // create prng with api that matches BigInteger secure random
    options = options || {};
    var prng = options.prng || $hSPkV.random;
    var rng = {
        // x is an array to fill with bytes
        nextBytes: function(x) {
            var b = prng.getBytesSync(x.length);
            for(var i = 0; i < x.length; ++i)x[i] = b.charCodeAt(i);
        }
    };
    var algorithm = options.algorithm || "PRIMEINC";
    // create PRIMEINC algorithm state
    var rval;
    if (algorithm === "PRIMEINC") {
        rval = {
            algorithm: algorithm,
            state: 0,
            bits: bits,
            rng: rng,
            eInt: e || 65537,
            e: new $71534a487cb5581d$var$BigInteger(null),
            p: null,
            q: null,
            qBits: bits >> 1,
            pBits: bits - (bits >> 1),
            pqState: 0,
            num: null,
            keys: null
        };
        rval.e.fromInt(rval.eInt);
    } else throw new Error("Invalid key generation algorithm: " + algorithm);
    return rval;
};
/**
 * Attempts to runs the key-generation algorithm for at most n seconds
 * (approximately) using the given state. When key-generation has completed,
 * the keys will be stored in state.keys.
 *
 * To use this function to update a UI while generating a key or to prevent
 * causing browser lockups/warnings, set "n" to a value other than 0. A
 * simple pattern for generating a key and showing a progress indicator is:
 *
 * var state = pki.rsa.createKeyPairGenerationState(2048);
 * var step = function() {
 *   // step key-generation, run algorithm for 100 ms, repeat
 *   if(!forge.pki.rsa.stepKeyPairGenerationState(state, 100)) {
 *     setTimeout(step, 1);
 *   } else {
 *     // key-generation complete
 *     // TODO: turn off progress indicator here
 *     // TODO: use the generated key-pair in "state.keys"
 *   }
 * };
 * // TODO: turn on progress indicator here
 * setTimeout(step, 0);
 *
 * @param state the state to use.
 * @param n the maximum number of milliseconds to run the algorithm for, 0
 *          to run the algorithm to completion.
 *
 * @return true if the key-generation completed, false if not.
 */ $71534a487cb5581d$var$pki.rsa.stepKeyPairGenerationState = function(state, n) {
    // set default algorithm if not set
    if (!("algorithm" in state)) state.algorithm = "PRIMEINC";
    // TODO: migrate step-based prime generation code to forge.prime
    // TODO: abstract as PRIMEINC algorithm
    // do key generation (based on Tom Wu's rsa.js, see jsbn.js license)
    // with some minor optimizations and designed to run in steps
    // local state vars
    var THIRTY = new $71534a487cb5581d$var$BigInteger(null);
    THIRTY.fromInt(30);
    var deltaIdx = 0;
    var op_or = function(x, y) {
        return x | y;
    };
    // keep stepping until time limit is reached or done
    var t1 = +new Date();
    var t2;
    var total = 0;
    while(state.keys === null && (n <= 0 || total < n)){
        // generate p or q
        if (state.state === 0) {
            /* Note: All primes are of the form:

        30k+i, for i < 30 and gcd(30, i)=1, where there are 8 values for i

        When we generate a random number, we always align it at 30k + 1. Each
        time the number is determined not to be prime we add to get to the
        next 'i', eg: if the number was at 30k + 1 we add 6. */ var bits = state.p === null ? state.pBits : state.qBits;
            var bits1 = bits - 1;
            // get a random number
            if (state.pqState === 0) {
                state.num = new $71534a487cb5581d$var$BigInteger(bits, state.rng);
                // force MSB set
                if (!state.num.testBit(bits1)) state.num.bitwiseTo($71534a487cb5581d$var$BigInteger.ONE.shiftLeft(bits1), op_or, state.num);
                // align number on 30k+1 boundary
                state.num.dAddOffset(31 - state.num.mod(THIRTY).byteValue(), 0);
                deltaIdx = 0;
                ++state.pqState;
            } else if (state.pqState === 1) {
                // try to make the number a prime
                if (state.num.bitLength() > bits) // overflow, try again
                state.pqState = 0;
                else if (state.num.isProbablePrime($71534a487cb5581d$var$_getMillerRabinTests(state.num.bitLength()))) ++state.pqState;
                else // get next potential prime
                state.num.dAddOffset($71534a487cb5581d$var$GCD_30_DELTA[deltaIdx++ % 8], 0);
            } else if (state.pqState === 2) // ensure number is coprime with e
            state.pqState = state.num.subtract($71534a487cb5581d$var$BigInteger.ONE).gcd(state.e).compareTo($71534a487cb5581d$var$BigInteger.ONE) === 0 ? 3 : 0;
            else if (state.pqState === 3) {
                // store p or q
                state.pqState = 0;
                if (state.p === null) state.p = state.num;
                else state.q = state.num;
                // advance state if both p and q are ready
                if (state.p !== null && state.q !== null) ++state.state;
                state.num = null;
            }
        } else if (state.state === 1) {
            // ensure p is larger than q (swap them if not)
            if (state.p.compareTo(state.q) < 0) {
                state.num = state.p;
                state.p = state.q;
                state.q = state.num;
            }
            ++state.state;
        } else if (state.state === 2) {
            // compute phi: (p - 1)(q - 1) (Euler's totient function)
            state.p1 = state.p.subtract($71534a487cb5581d$var$BigInteger.ONE);
            state.q1 = state.q.subtract($71534a487cb5581d$var$BigInteger.ONE);
            state.phi = state.p1.multiply(state.q1);
            ++state.state;
        } else if (state.state === 3) {
            // ensure e and phi are coprime
            if (state.phi.gcd(state.e).compareTo($71534a487cb5581d$var$BigInteger.ONE) === 0) // phi and e are coprime, advance
            ++state.state;
            else {
                // phi and e aren't coprime, so generate a new p and q
                state.p = null;
                state.q = null;
                state.state = 0;
            }
        } else if (state.state === 4) {
            // create n, ensure n is has the right number of bits
            state.n = state.p.multiply(state.q);
            // ensure n is right number of bits
            if (state.n.bitLength() === state.bits) // success, advance
            ++state.state;
            else {
                // failed, get new q
                state.q = null;
                state.state = 0;
            }
        } else if (state.state === 5) {
            // set keys
            var d = state.e.modInverse(state.phi);
            state.keys = {
                privateKey: $71534a487cb5581d$var$pki.rsa.setPrivateKey(state.n, state.e, d, state.p, state.q, d.mod(state.p1), d.mod(state.q1), state.q.modInverse(state.p)),
                publicKey: $71534a487cb5581d$var$pki.rsa.setPublicKey(state.n, state.e)
            };
        }
        // update timing
        t2 = +new Date();
        total += t2 - t1;
        t1 = t2;
    }
    return state.keys !== null;
};
/**
 * Generates an RSA public-private key pair in a single call.
 *
 * To generate a key-pair in steps (to allow for progress updates and to
 * prevent blocking or warnings in slow browsers) then use the key-pair
 * generation state functions.
 *
 * To generate a key-pair asynchronously (either through web-workers, if
 * available, or by breaking up the work on the main thread), pass a
 * callback function.
 *
 * @param [bits] the size for the private key in bits, defaults to 2048.
 * @param [e] the public exponent to use, defaults to 65537.
 * @param [options] options for key-pair generation, if given then 'bits'
 *            and 'e' must *not* be given:
 *          bits the size for the private key in bits, (default: 2048).
 *          e the public exponent to use, (default: 65537 (0x10001)).
 *          workerScript the worker script URL.
 *          workers the number of web workers (if supported) to use,
 *            (default: 2).
 *          workLoad the size of the work load, ie: number of possible prime
 *            numbers for each web worker to check per work assignment,
 *            (default: 100).
 *          prng a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync". Disables use of native APIs.
 *          algorithm the algorithm to use (default: 'PRIMEINC').
 * @param [callback(err, keypair)] called once the operation completes.
 *
 * @return an object with privateKey and publicKey properties.
 */ $71534a487cb5581d$var$pki.rsa.generateKeyPair = function(bits, e, options, callback) {
    // (bits), (options), (callback)
    if (arguments.length === 1) {
        if (typeof bits === "object") {
            options = bits;
            bits = undefined;
        } else if (typeof bits === "function") {
            callback = bits;
            bits = undefined;
        }
    } else if (arguments.length === 2) {
        // (bits, e), (bits, options), (bits, callback), (options, callback)
        if (typeof bits === "number") {
            if (typeof e === "function") {
                callback = e;
                e = undefined;
            } else if (typeof e !== "number") {
                options = e;
                e = undefined;
            }
        } else {
            options = bits;
            callback = e;
            bits = undefined;
            e = undefined;
        }
    } else if (arguments.length === 3) {
        // (bits, e, options), (bits, e, callback), (bits, options, callback)
        if (typeof e === "number") {
            if (typeof options === "function") {
                callback = options;
                options = undefined;
            }
        } else {
            callback = options;
            options = e;
            e = undefined;
        }
    }
    options = options || {};
    if (bits === undefined) bits = options.bits || 2048;
    if (e === undefined) e = options.e || 0x10001;
    // use native code if permitted, available, and parameters are acceptable
    if (!$hSPkV.options.usePureJavaScript && !options.prng && bits >= 256 && bits <= 16384 && (e === 0x10001 || e === 3)) {
        if (callback) {
            // try native async
            if ($71534a487cb5581d$var$_detectNodeCrypto("generateKeyPair")) return $71534a487cb5581d$var$_crypto.generateKeyPair("rsa", {
                modulusLength: bits,
                publicExponent: e,
                publicKeyEncoding: {
                    type: "spki",
                    format: "pem"
                },
                privateKeyEncoding: {
                    type: "pkcs8",
                    format: "pem"
                }
            }, function(err, pub, priv) {
                if (err) return callback(err);
                callback(null, {
                    privateKey: $71534a487cb5581d$var$pki.privateKeyFromPem(priv),
                    publicKey: $71534a487cb5581d$var$pki.publicKeyFromPem(pub)
                });
            });
            if ($71534a487cb5581d$var$_detectSubtleCrypto("generateKey") && $71534a487cb5581d$var$_detectSubtleCrypto("exportKey")) // use standard native generateKey
            return $71534a487cb5581d$var$util.globalScope.crypto.subtle.generateKey({
                name: "RSASSA-PKCS1-v1_5",
                modulusLength: bits,
                publicExponent: $71534a487cb5581d$var$_intToUint8Array(e),
                hash: {
                    name: "SHA-256"
                }
            }, true, [
                "sign",
                "verify"
            ]).then(function(pair) {
                return $71534a487cb5581d$var$util.globalScope.crypto.subtle.exportKey("pkcs8", pair.privateKey);
            // avoiding catch(function(err) {...}) to support IE <= 8
            }).then(undefined, function(err) {
                callback(err);
            }).then(function(pkcs8) {
                if (pkcs8) {
                    var privateKey = $71534a487cb5581d$var$pki.privateKeyFromAsn1($71534a487cb5581d$var$asn1.fromDer($hSPkV.util.createBuffer(pkcs8)));
                    callback(null, {
                        privateKey: privateKey,
                        publicKey: $71534a487cb5581d$var$pki.setRsaPublicKey(privateKey.n, privateKey.e)
                    });
                }
            });
            if ($71534a487cb5581d$var$_detectSubtleMsCrypto("generateKey") && $71534a487cb5581d$var$_detectSubtleMsCrypto("exportKey")) {
                var genOp = $71534a487cb5581d$var$util.globalScope.msCrypto.subtle.generateKey({
                    name: "RSASSA-PKCS1-v1_5",
                    modulusLength: bits,
                    publicExponent: $71534a487cb5581d$var$_intToUint8Array(e),
                    hash: {
                        name: "SHA-256"
                    }
                }, true, [
                    "sign",
                    "verify"
                ]);
                genOp.oncomplete = function(e) {
                    var pair = e.target.result;
                    var exportOp = $71534a487cb5581d$var$util.globalScope.msCrypto.subtle.exportKey("pkcs8", pair.privateKey);
                    exportOp.oncomplete = function(e) {
                        var pkcs8 = e.target.result;
                        var privateKey = $71534a487cb5581d$var$pki.privateKeyFromAsn1($71534a487cb5581d$var$asn1.fromDer($hSPkV.util.createBuffer(pkcs8)));
                        callback(null, {
                            privateKey: privateKey,
                            publicKey: $71534a487cb5581d$var$pki.setRsaPublicKey(privateKey.n, privateKey.e)
                        });
                    };
                    exportOp.onerror = function(err) {
                        callback(err);
                    };
                };
                genOp.onerror = function(err) {
                    callback(err);
                };
                return;
            }
        } else // try native sync
        if ($71534a487cb5581d$var$_detectNodeCrypto("generateKeyPairSync")) {
            var keypair = $71534a487cb5581d$var$_crypto.generateKeyPairSync("rsa", {
                modulusLength: bits,
                publicExponent: e,
                publicKeyEncoding: {
                    type: "spki",
                    format: "pem"
                },
                privateKeyEncoding: {
                    type: "pkcs8",
                    format: "pem"
                }
            });
            return {
                privateKey: $71534a487cb5581d$var$pki.privateKeyFromPem(keypair.privateKey),
                publicKey: $71534a487cb5581d$var$pki.publicKeyFromPem(keypair.publicKey)
            };
        }
    }
    // use JavaScript implementation
    var state = $71534a487cb5581d$var$pki.rsa.createKeyPairGenerationState(bits, e, options);
    if (!callback) {
        $71534a487cb5581d$var$pki.rsa.stepKeyPairGenerationState(state, 0);
        return state.keys;
    }
    $71534a487cb5581d$var$_generateKeyPair(state, options, callback);
};
/**
 * Sets an RSA public key from BigIntegers modulus and exponent.
 *
 * @param n the modulus.
 * @param e the exponent.
 *
 * @return the public key.
 */ $71534a487cb5581d$var$pki.setRsaPublicKey = $71534a487cb5581d$var$pki.rsa.setPublicKey = function(n, e) {
    var key = {
        n: n,
        e: e
    };
    /**
   * Encrypts the given data with this public key. Newer applications
   * should use the 'RSA-OAEP' decryption scheme, 'RSAES-PKCS1-V1_5' is for
   * legacy applications.
   *
   * @param data the byte string to encrypt.
   * @param scheme the encryption scheme to use:
   *          'RSAES-PKCS1-V1_5' (default),
   *          'RSA-OAEP',
   *          'RAW', 'NONE', or null to perform raw RSA encryption,
   *          an object with an 'encode' property set to a function
   *          with the signature 'function(data, key)' that returns
   *          a binary-encoded string representing the encoded data.
   * @param schemeOptions any scheme-specific options.
   *
   * @return the encrypted byte string.
   */ key.encrypt = function(data, scheme, schemeOptions) {
        if (typeof scheme === "string") scheme = scheme.toUpperCase();
        else if (scheme === undefined) scheme = "RSAES-PKCS1-V1_5";
        if (scheme === "RSAES-PKCS1-V1_5") scheme = {
            encode: function(m, key, pub) {
                return $71534a487cb5581d$var$_encodePkcs1_v1_5(m, key, 0x02).getBytes();
            }
        };
        else if (scheme === "RSA-OAEP" || scheme === "RSAES-OAEP") scheme = {
            encode: function(m, key) {
                return $hSPkV.pkcs1.encode_rsa_oaep(key, m, schemeOptions);
            }
        };
        else if ([
            "RAW",
            "NONE",
            "NULL",
            null
        ].indexOf(scheme) !== -1) scheme = {
            encode: function(e) {
                return e;
            }
        };
        else if (typeof scheme === "string") throw new Error('Unsupported encryption scheme: "' + scheme + '".');
        // do scheme-based encoding then rsa encryption
        var e = scheme.encode(data, key, true);
        return $71534a487cb5581d$var$pki.rsa.encrypt(e, key, true);
    };
    /**
   * Verifies the given signature against the given digest.
   *
   * PKCS#1 supports multiple (currently two) signature schemes:
   * RSASSA-PKCS1-V1_5 and RSASSA-PSS.
   *
   * By default this implementation uses the "old scheme", i.e.
   * RSASSA-PKCS1-V1_5, in which case once RSA-decrypted, the
   * signature is an OCTET STRING that holds a DigestInfo.
   *
   * DigestInfo ::= SEQUENCE {
   *   digestAlgorithm DigestAlgorithmIdentifier,
   *   digest Digest
   * }
   * DigestAlgorithmIdentifier ::= AlgorithmIdentifier
   * Digest ::= OCTET STRING
   *
   * To perform PSS signature verification, provide an instance
   * of Forge PSS object as the scheme parameter.
   *
   * @param digest the message digest hash to compare against the signature,
   *          as a binary-encoded string.
   * @param signature the signature to verify, as a binary-encoded string.
   * @param scheme signature verification scheme to use:
   *          'RSASSA-PKCS1-V1_5' or undefined for RSASSA PKCS#1 v1.5,
   *          a Forge PSS object for RSASSA-PSS,
   *          'NONE' or null for none, DigestInfo will not be expected, but
   *            PKCS#1 v1.5 padding will still be used.
   * @param options optional verify options
   *          _parseAllDigestBytes testing flag to control parsing of all
   *            digest bytes. Unsupported and not for general usage.
   *            (default: true)
   *          _skipPaddingChecks testing flag to skip some padding checks to
   *            test other checks. Unsupported and not for general usage.
   *            (default: false)
   *
   * @return true if the signature was verified, false if not.
   */ key.verify = function(digest, signature, scheme, options) {
        if (typeof scheme === "string") scheme = scheme.toUpperCase();
        else if (scheme === undefined) scheme = "RSASSA-PKCS1-V1_5";
        if (options === undefined) options = {
            _parseAllDigestBytes: true,
            _skipPaddingChecks: false
        };
        if (!("_parseAllDigestBytes" in options)) options._parseAllDigestBytes = true;
        if (!("_skipPaddingChecks" in options)) options._skipPaddingChecks = false;
        if (scheme === "RSASSA-PKCS1-V1_5") scheme = {
            verify: function(digest, d) {
                // remove padding
                d = $71534a487cb5581d$var$_decodePkcs1_v1_5(d, key, true, undefined, options);
                // d is ASN.1 BER-encoded DigestInfo
                var obj = $71534a487cb5581d$var$asn1.fromDer(d, {
                    parseAllBytes: options._parseAllDigestBytes
                });
                // validate DigestInfo structure and element count
                var capture = {};
                var errors = [];
                if (!$71534a487cb5581d$var$asn1.validate(obj, $71534a487cb5581d$var$digestInfoValidator, capture, errors) || obj.value.length !== 2) {
                    var error = new Error("ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value.");
                    error.errors = errors;
                    throw error;
                }
                // check hash algorithm identifier
                // see PKCS1-v1-5DigestAlgorithms in RFC 8017
                // FIXME: add support to validator for strict value choices
                var oid = $71534a487cb5581d$var$asn1.derToOid(capture.algorithmIdentifier);
                if (!(oid === $hSPkV.oids.md2 || oid === $hSPkV.oids.md5 || oid === $hSPkV.oids.sha1 || oid === $hSPkV.oids.sha224 || oid === $hSPkV.oids.sha256 || oid === $hSPkV.oids.sha384 || oid === $hSPkV.oids.sha512 || oid === $hSPkV.oids["sha512-224"] || oid === $hSPkV.oids["sha512-256"])) {
                    var error = new Error("Unknown RSASSA-PKCS1-v1_5 DigestAlgorithm identifier.");
                    error.oid = oid;
                    throw error;
                }
                // special check for md2 and md5 that NULL parameters exist
                if (oid === $hSPkV.oids.md2 || oid === $hSPkV.oids.md5) {
                    if (!("parameters" in capture)) throw new Error("ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value. Missing algorithm identifier NULL parameters.");
                }
                // compare the given digest to the decrypted one
                return digest === capture.digest;
            }
        };
        else if (scheme === "NONE" || scheme === "NULL" || scheme === null) scheme = {
            verify: function(digest, d) {
                // remove padding
                d = $71534a487cb5581d$var$_decodePkcs1_v1_5(d, key, true, undefined, options);
                return digest === d;
            }
        };
        // do rsa decryption w/o any decoding, then verify -- which does decoding
        var d = $71534a487cb5581d$var$pki.rsa.decrypt(signature, key, true, false);
        return scheme.verify(digest, d, key.n.bitLength());
    };
    return key;
};
/**
 * Sets an RSA private key from BigIntegers modulus, exponent, primes,
 * prime exponents, and modular multiplicative inverse.
 *
 * @param n the modulus.
 * @param e the public exponent.
 * @param d the private exponent ((inverse of e) mod n).
 * @param p the first prime.
 * @param q the second prime.
 * @param dP exponent1 (d mod (p-1)).
 * @param dQ exponent2 (d mod (q-1)).
 * @param qInv ((inverse of q) mod p)
 *
 * @return the private key.
 */ $71534a487cb5581d$var$pki.setRsaPrivateKey = $71534a487cb5581d$var$pki.rsa.setPrivateKey = function(n, e, d, p, q, dP, dQ, qInv) {
    var key = {
        n: n,
        e: e,
        d: d,
        p: p,
        q: q,
        dP: dP,
        dQ: dQ,
        qInv: qInv
    };
    /**
   * Decrypts the given data with this private key. The decryption scheme
   * must match the one used to encrypt the data.
   *
   * @param data the byte string to decrypt.
   * @param scheme the decryption scheme to use:
   *          'RSAES-PKCS1-V1_5' (default),
   *          'RSA-OAEP',
   *          'RAW', 'NONE', or null to perform raw RSA decryption.
   * @param schemeOptions any scheme-specific options.
   *
   * @return the decrypted byte string.
   */ key.decrypt = function(data, scheme, schemeOptions) {
        if (typeof scheme === "string") scheme = scheme.toUpperCase();
        else if (scheme === undefined) scheme = "RSAES-PKCS1-V1_5";
        // do rsa decryption w/o any decoding
        var d = $71534a487cb5581d$var$pki.rsa.decrypt(data, key, false, false);
        if (scheme === "RSAES-PKCS1-V1_5") scheme = {
            decode: $71534a487cb5581d$var$_decodePkcs1_v1_5
        };
        else if (scheme === "RSA-OAEP" || scheme === "RSAES-OAEP") scheme = {
            decode: function(d, key) {
                return $hSPkV.pkcs1.decode_rsa_oaep(key, d, schemeOptions);
            }
        };
        else if ([
            "RAW",
            "NONE",
            "NULL",
            null
        ].indexOf(scheme) !== -1) scheme = {
            decode: function(d) {
                return d;
            }
        };
        else throw new Error('Unsupported encryption scheme: "' + scheme + '".');
        // decode according to scheme
        return scheme.decode(d, key, false);
    };
    /**
   * Signs the given digest, producing a signature.
   *
   * PKCS#1 supports multiple (currently two) signature schemes:
   * RSASSA-PKCS1-V1_5 and RSASSA-PSS.
   *
   * By default this implementation uses the "old scheme", i.e.
   * RSASSA-PKCS1-V1_5. In order to generate a PSS signature, provide
   * an instance of Forge PSS object as the scheme parameter.
   *
   * @param md the message digest object with the hash to sign.
   * @param scheme the signature scheme to use:
   *          'RSASSA-PKCS1-V1_5' or undefined for RSASSA PKCS#1 v1.5,
   *          a Forge PSS object for RSASSA-PSS,
   *          'NONE' or null for none, DigestInfo will not be used but
   *            PKCS#1 v1.5 padding will still be used.
   *
   * @return the signature as a byte string.
   */ key.sign = function(md, scheme) {
        /* Note: The internal implementation of RSA operations is being
      transitioned away from a PKCS#1 v1.5 hard-coded scheme. Some legacy
      code like the use of an encoding block identifier 'bt' will eventually
      be removed. */ // private key operation
        var bt = false;
        if (typeof scheme === "string") scheme = scheme.toUpperCase();
        if (scheme === undefined || scheme === "RSASSA-PKCS1-V1_5") {
            scheme = {
                encode: $71534a487cb5581d$var$emsaPkcs1v15encode
            };
            bt = 0x01;
        } else if (scheme === "NONE" || scheme === "NULL" || scheme === null) {
            scheme = {
                encode: function() {
                    return md;
                }
            };
            bt = 0x01;
        }
        // encode and then encrypt
        var d = scheme.encode(md, key.n.bitLength());
        return $71534a487cb5581d$var$pki.rsa.encrypt(d, key, bt);
    };
    return key;
};
/**
 * Wraps an RSAPrivateKey ASN.1 object in an ASN.1 PrivateKeyInfo object.
 *
 * @param rsaKey the ASN.1 RSAPrivateKey.
 *
 * @return the ASN.1 PrivateKeyInfo.
 */ $71534a487cb5581d$var$pki.wrapRsaPrivateKey = function(rsaKey) {
    // PrivateKeyInfo
    return $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.SEQUENCE, true, [
        // version (0)
        $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.INTEGER, false, $71534a487cb5581d$var$asn1.integerToDer(0).getBytes()),
        // privateKeyAlgorithm
        $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.SEQUENCE, true, [
            $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.OID, false, $71534a487cb5581d$var$asn1.oidToDer($71534a487cb5581d$var$pki.oids.rsaEncryption).getBytes()),
            $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.NULL, false, "")
        ]),
        // PrivateKey
        $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.OCTETSTRING, false, $71534a487cb5581d$var$asn1.toDer(rsaKey).getBytes())
    ]);
};
/**
 * Converts a private key from an ASN.1 object.
 *
 * @param obj the ASN.1 representation of a PrivateKeyInfo containing an
 *          RSAPrivateKey or an RSAPrivateKey.
 *
 * @return the private key.
 */ $71534a487cb5581d$var$pki.privateKeyFromAsn1 = function(obj) {
    // get PrivateKeyInfo
    var capture = {};
    var errors = [];
    if ($71534a487cb5581d$var$asn1.validate(obj, $71534a487cb5581d$var$privateKeyValidator, capture, errors)) obj = $71534a487cb5581d$var$asn1.fromDer($hSPkV.util.createBuffer(capture.privateKey));
    // get RSAPrivateKey
    capture = {};
    errors = [];
    if (!$71534a487cb5581d$var$asn1.validate(obj, $71534a487cb5581d$var$rsaPrivateKeyValidator, capture, errors)) {
        var error = new Error("Cannot read private key. ASN.1 object does not contain an RSAPrivateKey.");
        error.errors = errors;
        throw error;
    }
    // Note: Version is currently ignored.
    // capture.privateKeyVersion
    // FIXME: inefficient, get a BigInteger that uses byte strings
    var n, e, d, p, q, dP, dQ, qInv;
    n = $hSPkV.util.createBuffer(capture.privateKeyModulus).toHex();
    e = $hSPkV.util.createBuffer(capture.privateKeyPublicExponent).toHex();
    d = $hSPkV.util.createBuffer(capture.privateKeyPrivateExponent).toHex();
    p = $hSPkV.util.createBuffer(capture.privateKeyPrime1).toHex();
    q = $hSPkV.util.createBuffer(capture.privateKeyPrime2).toHex();
    dP = $hSPkV.util.createBuffer(capture.privateKeyExponent1).toHex();
    dQ = $hSPkV.util.createBuffer(capture.privateKeyExponent2).toHex();
    qInv = $hSPkV.util.createBuffer(capture.privateKeyCoefficient).toHex();
    // set private key
    return $71534a487cb5581d$var$pki.setRsaPrivateKey(new $71534a487cb5581d$var$BigInteger(n, 16), new $71534a487cb5581d$var$BigInteger(e, 16), new $71534a487cb5581d$var$BigInteger(d, 16), new $71534a487cb5581d$var$BigInteger(p, 16), new $71534a487cb5581d$var$BigInteger(q, 16), new $71534a487cb5581d$var$BigInteger(dP, 16), new $71534a487cb5581d$var$BigInteger(dQ, 16), new $71534a487cb5581d$var$BigInteger(qInv, 16));
};
/**
 * Converts a private key to an ASN.1 RSAPrivateKey.
 *
 * @param key the private key.
 *
 * @return the ASN.1 representation of an RSAPrivateKey.
 */ $71534a487cb5581d$var$pki.privateKeyToAsn1 = $71534a487cb5581d$var$pki.privateKeyToRSAPrivateKey = function(key) {
    // RSAPrivateKey
    return $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.SEQUENCE, true, [
        // version (0 = only 2 primes, 1 multiple primes)
        $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.INTEGER, false, $71534a487cb5581d$var$asn1.integerToDer(0).getBytes()),
        // modulus (n)
        $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.INTEGER, false, $71534a487cb5581d$var$_bnToBytes(key.n)),
        // publicExponent (e)
        $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.INTEGER, false, $71534a487cb5581d$var$_bnToBytes(key.e)),
        // privateExponent (d)
        $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.INTEGER, false, $71534a487cb5581d$var$_bnToBytes(key.d)),
        // privateKeyPrime1 (p)
        $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.INTEGER, false, $71534a487cb5581d$var$_bnToBytes(key.p)),
        // privateKeyPrime2 (q)
        $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.INTEGER, false, $71534a487cb5581d$var$_bnToBytes(key.q)),
        // privateKeyExponent1 (dP)
        $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.INTEGER, false, $71534a487cb5581d$var$_bnToBytes(key.dP)),
        // privateKeyExponent2 (dQ)
        $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.INTEGER, false, $71534a487cb5581d$var$_bnToBytes(key.dQ)),
        // coefficient (qInv)
        $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.INTEGER, false, $71534a487cb5581d$var$_bnToBytes(key.qInv))
    ]);
};
/**
 * Converts a public key from an ASN.1 SubjectPublicKeyInfo or RSAPublicKey.
 *
 * @param obj the asn1 representation of a SubjectPublicKeyInfo or RSAPublicKey.
 *
 * @return the public key.
 */ $71534a487cb5581d$var$pki.publicKeyFromAsn1 = function(obj) {
    // get SubjectPublicKeyInfo
    var capture = {};
    var errors = [];
    if ($71534a487cb5581d$var$asn1.validate(obj, $71534a487cb5581d$var$publicKeyValidator, capture, errors)) {
        // get oid
        var oid = $71534a487cb5581d$var$asn1.derToOid(capture.publicKeyOid);
        if (oid !== $71534a487cb5581d$var$pki.oids.rsaEncryption) {
            var error = new Error("Cannot read public key. Unknown OID.");
            error.oid = oid;
            throw error;
        }
        obj = capture.rsaPublicKey;
    }
    // get RSA params
    errors = [];
    if (!$71534a487cb5581d$var$asn1.validate(obj, $71534a487cb5581d$var$rsaPublicKeyValidator, capture, errors)) {
        var error = new Error("Cannot read public key. ASN.1 object does not contain an RSAPublicKey.");
        error.errors = errors;
        throw error;
    }
    // FIXME: inefficient, get a BigInteger that uses byte strings
    var n = $hSPkV.util.createBuffer(capture.publicKeyModulus).toHex();
    var e = $hSPkV.util.createBuffer(capture.publicKeyExponent).toHex();
    // set public key
    return $71534a487cb5581d$var$pki.setRsaPublicKey(new $71534a487cb5581d$var$BigInteger(n, 16), new $71534a487cb5581d$var$BigInteger(e, 16));
};
/**
 * Converts a public key to an ASN.1 SubjectPublicKeyInfo.
 *
 * @param key the public key.
 *
 * @return the asn1 representation of a SubjectPublicKeyInfo.
 */ $71534a487cb5581d$var$pki.publicKeyToAsn1 = $71534a487cb5581d$var$pki.publicKeyToSubjectPublicKeyInfo = function(key) {
    // SubjectPublicKeyInfo
    return $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.SEQUENCE, true, [
        // AlgorithmIdentifier
        $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.OID, false, $71534a487cb5581d$var$asn1.oidToDer($71534a487cb5581d$var$pki.oids.rsaEncryption).getBytes()),
            // parameters (null)
            $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.NULL, false, "")
        ]),
        // subjectPublicKey
        $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.BITSTRING, false, [
            $71534a487cb5581d$var$pki.publicKeyToRSAPublicKey(key)
        ])
    ]);
};
/**
 * Converts a public key to an ASN.1 RSAPublicKey.
 *
 * @param key the public key.
 *
 * @return the asn1 representation of a RSAPublicKey.
 */ $71534a487cb5581d$var$pki.publicKeyToRSAPublicKey = function(key) {
    // RSAPublicKey
    return $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.SEQUENCE, true, [
        // modulus (n)
        $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.INTEGER, false, $71534a487cb5581d$var$_bnToBytes(key.n)),
        // publicExponent (e)
        $71534a487cb5581d$var$asn1.create($71534a487cb5581d$var$asn1.Class.UNIVERSAL, $71534a487cb5581d$var$asn1.Type.INTEGER, false, $71534a487cb5581d$var$_bnToBytes(key.e))
    ]);
};
/**
 * Encodes a message using PKCS#1 v1.5 padding.
 *
 * @param m the message to encode.
 * @param key the RSA key to use.
 * @param bt the block type to use, i.e. either 0x01 (for signing) or 0x02
 *          (for encryption).
 *
 * @return the padded byte buffer.
 */ function $71534a487cb5581d$var$_encodePkcs1_v1_5(m, key, bt) {
    var eb = $hSPkV.util.createBuffer();
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    /* use PKCS#1 v1.5 padding */ if (m.length > k - 11) {
        var error = new Error("Message is too long for PKCS#1 v1.5 padding.");
        error.length = m.length;
        error.max = k - 11;
        throw error;
    }
    /* A block type BT, a padding string PS, and the data D shall be
    formatted into an octet string EB, the encryption block:

    EB = 00 || BT || PS || 00 || D

    The block type BT shall be a single octet indicating the structure of
    the encryption block. For this version of the document it shall have
    value 00, 01, or 02. For a private-key operation, the block type
    shall be 00 or 01. For a public-key operation, it shall be 02.

    The padding string PS shall consist of k-3-||D|| octets. For block
    type 00, the octets shall have value 00; for block type 01, they
    shall have value FF; and for block type 02, they shall be
    pseudorandomly generated and nonzero. This makes the length of the
    encryption block EB equal to k. */ // build the encryption block
    eb.putByte(0x00);
    eb.putByte(bt);
    // create the padding
    var padNum = k - 3 - m.length;
    var padByte;
    // private key op
    if (bt === 0x00 || bt === 0x01) {
        padByte = bt === 0x00 ? 0x00 : 0xFF;
        for(var i = 0; i < padNum; ++i)eb.putByte(padByte);
    } else // public key op
    // pad with random non-zero values
    while(padNum > 0){
        var numZeros = 0;
        var padBytes = $hSPkV.random.getBytes(padNum);
        for(var i = 0; i < padNum; ++i){
            padByte = padBytes.charCodeAt(i);
            if (padByte === 0) ++numZeros;
            else eb.putByte(padByte);
        }
        padNum = numZeros;
    }
    // zero followed by message
    eb.putByte(0x00);
    eb.putBytes(m);
    return eb;
}
/**
 * Decodes a message using PKCS#1 v1.5 padding.
 *
 * @param em the message to decode.
 * @param key the RSA key to use.
 * @param pub true if the key is a public key, false if it is private.
 * @param ml the message length, if specified.
 * @param options testing options.
 *
 * @return the decoded bytes.
 */ function $71534a487cb5581d$var$_decodePkcs1_v1_5(em, key, pub, ml, options) {
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    /* It is an error if any of the following conditions occurs:

    1. The encryption block EB cannot be parsed unambiguously.
    2. The padding string PS consists of fewer than eight octets
      or is inconsistent with the block type BT.
    3. The decryption process is a public-key operation and the block
      type BT is not 00 or 01, or the decryption process is a
      private-key operation and the block type is not 02.
   */ // parse the encryption block
    var eb = $hSPkV.util.createBuffer(em);
    var first = eb.getByte();
    var bt = eb.getByte();
    if (first !== 0x00 || pub && bt !== 0x00 && bt !== 0x01 || !pub && bt !== 0x02 || pub && bt === 0x00 && typeof ml === "undefined") throw new Error("Encryption block is invalid.");
    var padNum = 0;
    if (bt === 0x00) {
        // check all padding bytes for 0x00
        padNum = k - 3 - ml;
        for(var i = 0; i < padNum; ++i){
            if (eb.getByte() !== 0x00) throw new Error("Encryption block is invalid.");
        }
    } else if (bt === 0x01) {
        // find the first byte that isn't 0xFF, should be after all padding
        padNum = 0;
        while(eb.length() > 1){
            if (eb.getByte() !== 0xFF) {
                --eb.read;
                break;
            }
            ++padNum;
        }
        // RFC 2313 8.1 note 6
        if (padNum < 8 && !(options ? options._skipPaddingChecks : false)) throw new Error("Encryption block is invalid.");
    } else if (bt === 0x02) {
        // look for 0x00 byte
        padNum = 0;
        while(eb.length() > 1){
            if (eb.getByte() === 0x00) {
                --eb.read;
                break;
            }
            ++padNum;
        }
        // RFC 2313 8.1 note 6
        if (padNum < 8 && !(options ? options._skipPaddingChecks : false)) throw new Error("Encryption block is invalid.");
    }
    // zero must be 0x00 and padNum must be (k - 3 - message length)
    var zero = eb.getByte();
    if (zero !== 0x00 || padNum !== k - 3 - eb.length()) throw new Error("Encryption block is invalid.");
    return eb.getBytes();
}
/**
 * Runs the key-generation algorithm asynchronously, either in the background
 * via Web Workers, or using the main thread and setImmediate.
 *
 * @param state the key-pair generation state.
 * @param [options] options for key-pair generation:
 *          workerScript the worker script URL.
 *          workers the number of web workers (if supported) to use,
 *            (default: 2, -1 to use estimated cores minus one).
 *          workLoad the size of the work load, ie: number of possible prime
 *            numbers for each web worker to check per work assignment,
 *            (default: 100).
 * @param callback(err, keypair) called once the operation completes.
 */ function $71534a487cb5581d$var$_generateKeyPair(state, options, callback) {
    if (typeof options === "function") {
        callback = options;
        options = {};
    }
    options = options || {};
    var opts = {
        algorithm: {
            name: options.algorithm || "PRIMEINC",
            options: {
                workers: options.workers || 2,
                workLoad: options.workLoad || 100,
                workerScript: options.workerScript
            }
        }
    };
    if ("prng" in options) opts.prng = options.prng;
    generate();
    function generate() {
        // find p and then q (done in series to simplify)
        getPrime(state.pBits, function(err, num) {
            if (err) return callback(err);
            state.p = num;
            if (state.q !== null) return finish(err, state.q);
            getPrime(state.qBits, finish);
        });
    }
    function getPrime(bits, callback) {
        $hSPkV.prime.generateProbablePrime(bits, opts, callback);
    }
    function finish(err, num) {
        if (err) return callback(err);
        // set q
        state.q = num;
        // ensure p is larger than q (swap them if not)
        if (state.p.compareTo(state.q) < 0) {
            var tmp = state.p;
            state.p = state.q;
            state.q = tmp;
        }
        // ensure p is coprime with e
        if (state.p.subtract($71534a487cb5581d$var$BigInteger.ONE).gcd(state.e).compareTo($71534a487cb5581d$var$BigInteger.ONE) !== 0) {
            state.p = null;
            generate();
            return;
        }
        // ensure q is coprime with e
        if (state.q.subtract($71534a487cb5581d$var$BigInteger.ONE).gcd(state.e).compareTo($71534a487cb5581d$var$BigInteger.ONE) !== 0) {
            state.q = null;
            getPrime(state.qBits, finish);
            return;
        }
        // compute phi: (p - 1)(q - 1) (Euler's totient function)
        state.p1 = state.p.subtract($71534a487cb5581d$var$BigInteger.ONE);
        state.q1 = state.q.subtract($71534a487cb5581d$var$BigInteger.ONE);
        state.phi = state.p1.multiply(state.q1);
        // ensure e and phi are coprime
        if (state.phi.gcd(state.e).compareTo($71534a487cb5581d$var$BigInteger.ONE) !== 0) {
            // phi and e aren't coprime, so generate a new p and q
            state.p = state.q = null;
            generate();
            return;
        }
        // create n, ensure n is has the right number of bits
        state.n = state.p.multiply(state.q);
        if (state.n.bitLength() !== state.bits) {
            // failed, get new q
            state.q = null;
            getPrime(state.qBits, finish);
            return;
        }
        // set keys
        var d = state.e.modInverse(state.phi);
        state.keys = {
            privateKey: $71534a487cb5581d$var$pki.rsa.setPrivateKey(state.n, state.e, d, state.p, state.q, d.mod(state.p1), d.mod(state.q1), state.q.modInverse(state.p)),
            publicKey: $71534a487cb5581d$var$pki.rsa.setPublicKey(state.n, state.e)
        };
        callback(null, state.keys);
    }
}
/**
 * Converts a positive BigInteger into 2's-complement big-endian bytes.
 *
 * @param b the big integer to convert.
 *
 * @return the bytes.
 */ function $71534a487cb5581d$var$_bnToBytes(b) {
    // prepend 0x00 if first byte >= 0x80
    var hex = b.toString(16);
    if (hex[0] >= "8") hex = "00" + hex;
    var bytes = $hSPkV.util.hexToBytes(hex);
    // ensure integer is minimally-encoded
    if (bytes.length > 1 && // leading 0x00 for positive integer
    (bytes.charCodeAt(0) === 0 && (bytes.charCodeAt(1) & 0x80) === 0 || // leading 0xFF for negative integer
    bytes.charCodeAt(0) === 0xFF && (bytes.charCodeAt(1) & 0x80) === 0x80)) return bytes.substr(1);
    return bytes;
}
/**
 * Returns the required number of Miller-Rabin tests to generate a
 * prime with an error probability of (1/2)^80.
 *
 * See Handbook of Applied Cryptography Chapter 4, Table 4.4.
 *
 * @param bits the bit size.
 *
 * @return the required number of iterations.
 */ function $71534a487cb5581d$var$_getMillerRabinTests(bits) {
    if (bits <= 100) return 27;
    if (bits <= 150) return 18;
    if (bits <= 200) return 15;
    if (bits <= 250) return 12;
    if (bits <= 300) return 9;
    if (bits <= 350) return 8;
    if (bits <= 400) return 7;
    if (bits <= 500) return 6;
    if (bits <= 600) return 5;
    if (bits <= 800) return 4;
    if (bits <= 1250) return 3;
    return 2;
}
/**
 * Performs feature detection on the Node crypto interface.
 *
 * @param fn the feature (function) to detect.
 *
 * @return true if detected, false if not.
 */ function $71534a487cb5581d$var$_detectNodeCrypto(fn) {
    return $hSPkV.util.isNodejs && typeof $71534a487cb5581d$var$_crypto[fn] === "function";
}
/**
 * Performs feature detection on the SubtleCrypto interface.
 *
 * @param fn the feature (function) to detect.
 *
 * @return true if detected, false if not.
 */ function $71534a487cb5581d$var$_detectSubtleCrypto(fn) {
    return typeof $71534a487cb5581d$var$util.globalScope !== "undefined" && typeof $71534a487cb5581d$var$util.globalScope.crypto === "object" && typeof $71534a487cb5581d$var$util.globalScope.crypto.subtle === "object" && typeof $71534a487cb5581d$var$util.globalScope.crypto.subtle[fn] === "function";
}
/**
 * Performs feature detection on the deprecated Microsoft Internet Explorer
 * outdated SubtleCrypto interface. This function should only be used after
 * checking for the modern, standard SubtleCrypto interface.
 *
 * @param fn the feature (function) to detect.
 *
 * @return true if detected, false if not.
 */ function $71534a487cb5581d$var$_detectSubtleMsCrypto(fn) {
    return typeof $71534a487cb5581d$var$util.globalScope !== "undefined" && typeof $71534a487cb5581d$var$util.globalScope.msCrypto === "object" && typeof $71534a487cb5581d$var$util.globalScope.msCrypto.subtle === "object" && typeof $71534a487cb5581d$var$util.globalScope.msCrypto.subtle[fn] === "function";
}
function $71534a487cb5581d$var$_intToUint8Array(x) {
    var bytes = $hSPkV.util.hexToBytes(x.toString(16));
    var buffer = new Uint8Array(bytes.length);
    for(var i = 0; i < bytes.length; ++i)buffer[i] = bytes.charCodeAt(i);
    return buffer;
}
function $71534a487cb5581d$var$_privateKeyFromJwk(jwk) {
    if (jwk.kty !== "RSA") throw new Error('Unsupported key algorithm "' + jwk.kty + '"; algorithm must be "RSA".');
    return $71534a487cb5581d$var$pki.setRsaPrivateKey($71534a487cb5581d$var$_base64ToBigInt(jwk.n), $71534a487cb5581d$var$_base64ToBigInt(jwk.e), $71534a487cb5581d$var$_base64ToBigInt(jwk.d), $71534a487cb5581d$var$_base64ToBigInt(jwk.p), $71534a487cb5581d$var$_base64ToBigInt(jwk.q), $71534a487cb5581d$var$_base64ToBigInt(jwk.dp), $71534a487cb5581d$var$_base64ToBigInt(jwk.dq), $71534a487cb5581d$var$_base64ToBigInt(jwk.qi));
}
function $71534a487cb5581d$var$_publicKeyFromJwk(jwk) {
    if (jwk.kty !== "RSA") throw new Error('Key algorithm must be "RSA".');
    return $71534a487cb5581d$var$pki.setRsaPublicKey($71534a487cb5581d$var$_base64ToBigInt(jwk.n), $71534a487cb5581d$var$_base64ToBigInt(jwk.e));
}
function $71534a487cb5581d$var$_base64ToBigInt(b64) {
    return new $71534a487cb5581d$var$BigInteger($hSPkV.util.bytesToHex($hSPkV.util.decode64(b64)), 16);
}

});
parcelRequire.register("cHVVU", function(module, exports) {
// Copyright (c) 2005  Tom Wu
// All Rights Reserved.
// See "LICENSE" for details.
// Basic JavaScript BN library - subset useful for RSA encryption.
/*
Licensing (LICENSE)
-------------------

This software is covered under the following copyright:
*/ /*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ /*
Address all questions regarding this license to:

  Tom Wu
  tjw@cs.Stanford.EDU
*/ 
var $hSPkV = parcelRequire("hSPkV");
module.exports = $hSPkV.jsbn = $hSPkV.jsbn || {};
// Bits per digit
var $940670746dd773e1$var$dbits;
// JavaScript engine analysis
var $940670746dd773e1$var$canary = 0xdeadbeefcafe;
var $940670746dd773e1$var$j_lm = ($940670746dd773e1$var$canary & 0xffffff) == 0xefcafe;
// (public) Constructor
function $940670746dd773e1$var$BigInteger(a, b, c) {
    this.data = [];
    if (a != null) {
        if ("number" == typeof a) this.fromNumber(a, b, c);
        else if (b == null && "string" != typeof a) this.fromString(a, 256);
        else this.fromString(a, b);
    }
}
$hSPkV.jsbn.BigInteger = $940670746dd773e1$var$BigInteger;
// return new, unset BigInteger
function $940670746dd773e1$var$nbi() {
    return new $940670746dd773e1$var$BigInteger(null);
}
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $940670746dd773e1$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this.data[i++] + w.data[j] + c;
        c = Math.floor(v / 0x4000000);
        w.data[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $940670746dd773e1$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this.data[i] & 0x7fff;
        var h = this.data[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w.data[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w.data[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $940670746dd773e1$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this.data[i] & 0x3fff;
        var h = this.data[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w.data[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w.data[j++] = l & 0xfffffff;
    }
    return c;
}
// node.js (no browser)
if (typeof navigator === "undefined") {
    $940670746dd773e1$var$BigInteger.prototype.am = $940670746dd773e1$var$am3;
    $940670746dd773e1$var$dbits = 28;
} else if ($940670746dd773e1$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    $940670746dd773e1$var$BigInteger.prototype.am = $940670746dd773e1$var$am2;
    $940670746dd773e1$var$dbits = 30;
} else if ($940670746dd773e1$var$j_lm && navigator.appName != "Netscape") {
    $940670746dd773e1$var$BigInteger.prototype.am = $940670746dd773e1$var$am1;
    $940670746dd773e1$var$dbits = 26;
} else {
    $940670746dd773e1$var$BigInteger.prototype.am = $940670746dd773e1$var$am3;
    $940670746dd773e1$var$dbits = 28;
}
$940670746dd773e1$var$BigInteger.prototype.DB = $940670746dd773e1$var$dbits;
$940670746dd773e1$var$BigInteger.prototype.DM = (1 << $940670746dd773e1$var$dbits) - 1;
$940670746dd773e1$var$BigInteger.prototype.DV = 1 << $940670746dd773e1$var$dbits;
var $940670746dd773e1$var$BI_FP = 52;
$940670746dd773e1$var$BigInteger.prototype.FV = Math.pow(2, $940670746dd773e1$var$BI_FP);
$940670746dd773e1$var$BigInteger.prototype.F1 = $940670746dd773e1$var$BI_FP - $940670746dd773e1$var$dbits;
$940670746dd773e1$var$BigInteger.prototype.F2 = 2 * $940670746dd773e1$var$dbits - $940670746dd773e1$var$BI_FP;
// Digit conversions
var $940670746dd773e1$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $940670746dd773e1$var$BI_RC = new Array();
var $940670746dd773e1$var$rr, $940670746dd773e1$var$vv;
$940670746dd773e1$var$rr = "0".charCodeAt(0);
for($940670746dd773e1$var$vv = 0; $940670746dd773e1$var$vv <= 9; ++$940670746dd773e1$var$vv)$940670746dd773e1$var$BI_RC[$940670746dd773e1$var$rr++] = $940670746dd773e1$var$vv;
$940670746dd773e1$var$rr = "a".charCodeAt(0);
for($940670746dd773e1$var$vv = 10; $940670746dd773e1$var$vv < 36; ++$940670746dd773e1$var$vv)$940670746dd773e1$var$BI_RC[$940670746dd773e1$var$rr++] = $940670746dd773e1$var$vv;
$940670746dd773e1$var$rr = "A".charCodeAt(0);
for($940670746dd773e1$var$vv = 10; $940670746dd773e1$var$vv < 36; ++$940670746dd773e1$var$vv)$940670746dd773e1$var$BI_RC[$940670746dd773e1$var$rr++] = $940670746dd773e1$var$vv;
function $940670746dd773e1$var$int2char(n) {
    return $940670746dd773e1$var$BI_RM.charAt(n);
}
function $940670746dd773e1$var$intAt(s, i) {
    var c = $940670746dd773e1$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $940670746dd773e1$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r.data[i] = this.data[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $940670746dd773e1$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this.data[0] = x;
    else if (x < -1) this.data[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $940670746dd773e1$var$nbv(i) {
    var r = $940670746dd773e1$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $940670746dd773e1$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 256) k = 8; // byte array
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else {
        this.fromRadix(s, b);
        return;
    }
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = k == 8 ? s[i] & 0xff : $940670746dd773e1$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this.data[this.t++] = x;
        else if (sh + k > this.DB) {
            this.data[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this.data[this.t++] = x >> this.DB - sh;
        } else this.data[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    if (k == 8 && (s[0] & 0x80) != 0) {
        this.s = -1;
        if (sh > 0) this.data[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
    }
    this.clamp();
    if (mi) $940670746dd773e1$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $940670746dd773e1$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this.data[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $940670746dd773e1$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else return this.toRadix(b);
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this.data[i] >> p) > 0) {
            m = true;
            r = $940670746dd773e1$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this.data[i] & (1 << p) - 1) << k - p;
                d |= this.data[--i] >> (p += this.DB - k);
            } else {
                d = this.data[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $940670746dd773e1$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $940670746dd773e1$var$bnNegate() {
    var r = $940670746dd773e1$var$nbi();
    $940670746dd773e1$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $940670746dd773e1$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $940670746dd773e1$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this.data[i] - a.data[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $940670746dd773e1$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $940670746dd773e1$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $940670746dd773e1$var$nbits(this.data[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $940670746dd773e1$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r.data[i + n] = this.data[i];
    for(i = n - 1; i >= 0; --i)r.data[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $940670746dd773e1$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r.data[i - n] = this.data[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $940670746dd773e1$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r.data[i + ds + 1] = this.data[i] >> cbs | c;
        c = (this.data[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r.data[i] = 0;
    r.data[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $940670746dd773e1$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r.data[0] = this.data[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r.data[i - ds - 1] |= (this.data[i] & bm) << cbs;
        r.data[i - ds] = this.data[i] >> bs;
    }
    if (bs > 0) r.data[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $940670746dd773e1$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this.data[i] - a.data[i];
        r.data[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r.data[i++] = this.DV + c;
    else if (c > 0) r.data[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $940670746dd773e1$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r.data[i] = 0;
    for(i = 0; i < y.t; ++i)r.data[i + x.t] = x.am(0, y.data[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $940670746dd773e1$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $940670746dd773e1$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r.data[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x.data[i], r, 2 * i, 0, 1);
        if ((r.data[i + x.t] += x.am(i + 1, 2 * x.data[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r.data[i + x.t] -= x.DV;
            r.data[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r.data[r.t - 1] += x.am(i, x.data[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $940670746dd773e1$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $940670746dd773e1$var$nbi();
    var y = $940670746dd773e1$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $940670746dd773e1$var$nbits(pm.data[pm.t - 1]); // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y.data[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y.data[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $940670746dd773e1$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r.data[r.t++] = 1;
        r.subTo(t, r);
    }
    $940670746dd773e1$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y); // "negative" y so we can replace sub with am later
    while(y.t < ys)y.data[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r.data[--i] == y0 ? this.DM : Math.floor(r.data[i] * d1 + (r.data[i - 1] + e) * d2);
        if ((r.data[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r.data[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $940670746dd773e1$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
    if (ts < 0) $940670746dd773e1$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $940670746dd773e1$var$bnMod(a) {
    var r = $940670746dd773e1$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($940670746dd773e1$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// Modular reduction using "classic" algorithm
function $940670746dd773e1$var$Classic(m) {
    this.m = m;
}
function $940670746dd773e1$var$cConvert(x) {
    if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
    else return x;
}
function $940670746dd773e1$var$cRevert(x) {
    return x;
}
function $940670746dd773e1$var$cReduce(x) {
    x.divRemTo(this.m, null, x);
}
function $940670746dd773e1$var$cMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
function $940670746dd773e1$var$cSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
$940670746dd773e1$var$Classic.prototype.convert = $940670746dd773e1$var$cConvert;
$940670746dd773e1$var$Classic.prototype.revert = $940670746dd773e1$var$cRevert;
$940670746dd773e1$var$Classic.prototype.reduce = $940670746dd773e1$var$cReduce;
$940670746dd773e1$var$Classic.prototype.mulTo = $940670746dd773e1$var$cMulTo;
$940670746dd773e1$var$Classic.prototype.sqrTo = $940670746dd773e1$var$cSqrTo;
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $940670746dd773e1$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this.data[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3; // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
// Montgomery reduction
function $940670746dd773e1$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $940670746dd773e1$var$montConvert(x) {
    var r = $940670746dd773e1$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($940670746dd773e1$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $940670746dd773e1$var$montRevert(x) {
    var r = $940670746dd773e1$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $940670746dd773e1$var$montReduce(x) {
    while(x.t <= this.mt2)x.data[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x.data[i]*mp mod DV
        var j = x.data[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x.data[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x.data[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x.data[j] >= x.DV){
            x.data[j] -= x.DV;
            x.data[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $940670746dd773e1$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $940670746dd773e1$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$940670746dd773e1$var$Montgomery.prototype.convert = $940670746dd773e1$var$montConvert;
$940670746dd773e1$var$Montgomery.prototype.revert = $940670746dd773e1$var$montRevert;
$940670746dd773e1$var$Montgomery.prototype.reduce = $940670746dd773e1$var$montReduce;
$940670746dd773e1$var$Montgomery.prototype.mulTo = $940670746dd773e1$var$montMulTo;
$940670746dd773e1$var$Montgomery.prototype.sqrTo = $940670746dd773e1$var$montSqrTo;
// (protected) true iff this is even
function $940670746dd773e1$var$bnpIsEven() {
    return (this.t > 0 ? this.data[0] & 1 : this.s) == 0;
}
// (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
function $940670746dd773e1$var$bnpExp(e, z) {
    if (e > 0xffffffff || e < 1) return $940670746dd773e1$var$BigInteger.ONE;
    var r = $940670746dd773e1$var$nbi(), r2 = $940670746dd773e1$var$nbi(), g = z.convert(this), i = $940670746dd773e1$var$nbits(e) - 1;
    g.copyTo(r);
    while(--i >= 0){
        z.sqrTo(r, r2);
        if ((e & 1 << i) > 0) z.mulTo(r2, g, r);
        else {
            var t = r;
            r = r2;
            r2 = t;
        }
    }
    return z.revert(r);
}
// (public) this^e % m, 0 <= e < 2^32
function $940670746dd773e1$var$bnModPowInt(e, m) {
    var z;
    if (e < 256 || m.isEven()) z = new $940670746dd773e1$var$Classic(m);
    else z = new $940670746dd773e1$var$Montgomery(m);
    return this.exp(e, z);
}
// protected
$940670746dd773e1$var$BigInteger.prototype.copyTo = $940670746dd773e1$var$bnpCopyTo;
$940670746dd773e1$var$BigInteger.prototype.fromInt = $940670746dd773e1$var$bnpFromInt;
$940670746dd773e1$var$BigInteger.prototype.fromString = $940670746dd773e1$var$bnpFromString;
$940670746dd773e1$var$BigInteger.prototype.clamp = $940670746dd773e1$var$bnpClamp;
$940670746dd773e1$var$BigInteger.prototype.dlShiftTo = $940670746dd773e1$var$bnpDLShiftTo;
$940670746dd773e1$var$BigInteger.prototype.drShiftTo = $940670746dd773e1$var$bnpDRShiftTo;
$940670746dd773e1$var$BigInteger.prototype.lShiftTo = $940670746dd773e1$var$bnpLShiftTo;
$940670746dd773e1$var$BigInteger.prototype.rShiftTo = $940670746dd773e1$var$bnpRShiftTo;
$940670746dd773e1$var$BigInteger.prototype.subTo = $940670746dd773e1$var$bnpSubTo;
$940670746dd773e1$var$BigInteger.prototype.multiplyTo = $940670746dd773e1$var$bnpMultiplyTo;
$940670746dd773e1$var$BigInteger.prototype.squareTo = $940670746dd773e1$var$bnpSquareTo;
$940670746dd773e1$var$BigInteger.prototype.divRemTo = $940670746dd773e1$var$bnpDivRemTo;
$940670746dd773e1$var$BigInteger.prototype.invDigit = $940670746dd773e1$var$bnpInvDigit;
$940670746dd773e1$var$BigInteger.prototype.isEven = $940670746dd773e1$var$bnpIsEven;
$940670746dd773e1$var$BigInteger.prototype.exp = $940670746dd773e1$var$bnpExp;
// public
$940670746dd773e1$var$BigInteger.prototype.toString = $940670746dd773e1$var$bnToString;
$940670746dd773e1$var$BigInteger.prototype.negate = $940670746dd773e1$var$bnNegate;
$940670746dd773e1$var$BigInteger.prototype.abs = $940670746dd773e1$var$bnAbs;
$940670746dd773e1$var$BigInteger.prototype.compareTo = $940670746dd773e1$var$bnCompareTo;
$940670746dd773e1$var$BigInteger.prototype.bitLength = $940670746dd773e1$var$bnBitLength;
$940670746dd773e1$var$BigInteger.prototype.mod = $940670746dd773e1$var$bnMod;
$940670746dd773e1$var$BigInteger.prototype.modPowInt = $940670746dd773e1$var$bnModPowInt;
// "constants"
$940670746dd773e1$var$BigInteger.ZERO = $940670746dd773e1$var$nbv(0);
$940670746dd773e1$var$BigInteger.ONE = $940670746dd773e1$var$nbv(1);
// jsbn2 lib
// Copyright (c) 2005-2009  Tom Wu
// All Rights Reserved.
// See "LICENSE" for details (See jsbn.js for LICENSE).
// Extended JavaScript BN functions, required for RSA private ops.
// Version 1.1: new BigInteger("0", 10) returns "proper" zero
// Version 1.2: square() API, isProbablePrime fix
// (public)
function $940670746dd773e1$var$bnClone() {
    var r = $940670746dd773e1$var$nbi();
    this.copyTo(r);
    return r;
}
// (public) return value as integer
function $940670746dd773e1$var$bnIntValue() {
    if (this.s < 0) {
        if (this.t == 1) return this.data[0] - this.DV;
        else if (this.t == 0) return -1;
    } else if (this.t == 1) return this.data[0];
    else if (this.t == 0) return 0;
    // assumes 16 < DB < 32
    return (this.data[1] & (1 << 32 - this.DB) - 1) << this.DB | this.data[0];
}
// (public) return value as byte
function $940670746dd773e1$var$bnByteValue() {
    return this.t == 0 ? this.s : this.data[0] << 24 >> 24;
}
// (public) return value as short (assumes DB>=16)
function $940670746dd773e1$var$bnShortValue() {
    return this.t == 0 ? this.s : this.data[0] << 16 >> 16;
}
// (protected) return x s.t. r^x < DV
function $940670746dd773e1$var$bnpChunkSize(r) {
    return Math.floor(Math.LN2 * this.DB / Math.log(r));
}
// (public) 0 if this == 0, 1 if this > 0
function $940670746dd773e1$var$bnSigNum() {
    if (this.s < 0) return -1;
    else if (this.t <= 0 || this.t == 1 && this.data[0] <= 0) return 0;
    else return 1;
}
// (protected) convert to radix string
function $940670746dd773e1$var$bnpToRadix(b) {
    if (b == null) b = 10;
    if (this.signum() == 0 || b < 2 || b > 36) return "0";
    var cs = this.chunkSize(b);
    var a = Math.pow(b, cs);
    var d = $940670746dd773e1$var$nbv(a), y = $940670746dd773e1$var$nbi(), z = $940670746dd773e1$var$nbi(), r = "";
    this.divRemTo(d, y, z);
    while(y.signum() > 0){
        r = (a + z.intValue()).toString(b).substr(1) + r;
        y.divRemTo(d, y, z);
    }
    return z.intValue().toString(b) + r;
}
// (protected) convert from radix string
function $940670746dd773e1$var$bnpFromRadix(s, b) {
    this.fromInt(0);
    if (b == null) b = 10;
    var cs = this.chunkSize(b);
    var d = Math.pow(b, cs), mi = false, j = 0, w = 0;
    for(var i = 0; i < s.length; ++i){
        var x = $940670746dd773e1$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
            continue;
        }
        w = b * w + x;
        if (++j >= cs) {
            this.dMultiply(d);
            this.dAddOffset(w, 0);
            j = 0;
            w = 0;
        }
    }
    if (j > 0) {
        this.dMultiply(Math.pow(b, j));
        this.dAddOffset(w, 0);
    }
    if (mi) $940670746dd773e1$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) alternate constructor
function $940670746dd773e1$var$bnpFromNumber(a, b, c) {
    if ("number" == typeof b) {
        // new BigInteger(int,int,RNG)
        if (a < 2) this.fromInt(1);
        else {
            this.fromNumber(a, c);
            if (!this.testBit(a - 1)) this.bitwiseTo($940670746dd773e1$var$BigInteger.ONE.shiftLeft(a - 1), $940670746dd773e1$var$op_or, this);
            if (this.isEven()) this.dAddOffset(1, 0); // force odd
            while(!this.isProbablePrime(b)){
                this.dAddOffset(2, 0);
                if (this.bitLength() > a) this.subTo($940670746dd773e1$var$BigInteger.ONE.shiftLeft(a - 1), this);
            }
        }
    } else {
        // new BigInteger(int,RNG)
        var x = new Array(), t = a & 7;
        x.length = (a >> 3) + 1;
        b.nextBytes(x);
        if (t > 0) x[0] &= (1 << t) - 1;
        else x[0] = 0;
        this.fromString(x, 256);
    }
}
// (public) convert to bigendian byte array
function $940670746dd773e1$var$bnToByteArray() {
    var i = this.t, r = new Array();
    r[0] = this.s;
    var p = this.DB - i * this.DB % 8, d, k = 0;
    if (i-- > 0) {
        if (p < this.DB && (d = this.data[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;
        while(i >= 0){
            if (p < 8) {
                d = (this.data[i] & (1 << p) - 1) << 8 - p;
                d |= this.data[--i] >> (p += this.DB - 8);
            } else {
                d = this.data[i] >> (p -= 8) & 0xff;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if ((d & 0x80) != 0) d |= -256;
            if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
            if (k > 0 || d != this.s) r[k++] = d;
        }
    }
    return r;
}
function $940670746dd773e1$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
function $940670746dd773e1$var$bnMin(a) {
    return this.compareTo(a) < 0 ? this : a;
}
function $940670746dd773e1$var$bnMax(a) {
    return this.compareTo(a) > 0 ? this : a;
}
// (protected) r = this op a (bitwise)
function $940670746dd773e1$var$bnpBitwiseTo(a, op, r) {
    var i, f, m = Math.min(a.t, this.t);
    for(i = 0; i < m; ++i)r.data[i] = op(this.data[i], a.data[i]);
    if (a.t < this.t) {
        f = a.s & this.DM;
        for(i = m; i < this.t; ++i)r.data[i] = op(this.data[i], f);
        r.t = this.t;
    } else {
        f = this.s & this.DM;
        for(i = m; i < a.t; ++i)r.data[i] = op(f, a.data[i]);
        r.t = a.t;
    }
    r.s = op(this.s, a.s);
    r.clamp();
}
// (public) this & a
function $940670746dd773e1$var$op_and(x, y) {
    return x & y;
}
function $940670746dd773e1$var$bnAnd(a) {
    var r = $940670746dd773e1$var$nbi();
    this.bitwiseTo(a, $940670746dd773e1$var$op_and, r);
    return r;
}
// (public) this | a
function $940670746dd773e1$var$op_or(x, y) {
    return x | y;
}
function $940670746dd773e1$var$bnOr(a) {
    var r = $940670746dd773e1$var$nbi();
    this.bitwiseTo(a, $940670746dd773e1$var$op_or, r);
    return r;
}
// (public) this ^ a
function $940670746dd773e1$var$op_xor(x, y) {
    return x ^ y;
}
function $940670746dd773e1$var$bnXor(a) {
    var r = $940670746dd773e1$var$nbi();
    this.bitwiseTo(a, $940670746dd773e1$var$op_xor, r);
    return r;
}
// (public) this & ~a
function $940670746dd773e1$var$op_andnot(x, y) {
    return x & ~y;
}
function $940670746dd773e1$var$bnAndNot(a) {
    var r = $940670746dd773e1$var$nbi();
    this.bitwiseTo(a, $940670746dd773e1$var$op_andnot, r);
    return r;
}
// (public) ~this
function $940670746dd773e1$var$bnNot() {
    var r = $940670746dd773e1$var$nbi();
    for(var i = 0; i < this.t; ++i)r.data[i] = this.DM & ~this.data[i];
    r.t = this.t;
    r.s = ~this.s;
    return r;
}
// (public) this << n
function $940670746dd773e1$var$bnShiftLeft(n) {
    var r = $940670746dd773e1$var$nbi();
    if (n < 0) this.rShiftTo(-n, r);
    else this.lShiftTo(n, r);
    return r;
}
// (public) this >> n
function $940670746dd773e1$var$bnShiftRight(n) {
    var r = $940670746dd773e1$var$nbi();
    if (n < 0) this.lShiftTo(-n, r);
    else this.rShiftTo(n, r);
    return r;
}
// return index of lowest 1-bit in x, x < 2^31
function $940670746dd773e1$var$lbit(x) {
    if (x == 0) return -1;
    var r = 0;
    if ((x & 0xffff) == 0) {
        x >>= 16;
        r += 16;
    }
    if ((x & 0xff) == 0) {
        x >>= 8;
        r += 8;
    }
    if ((x & 0xf) == 0) {
        x >>= 4;
        r += 4;
    }
    if ((x & 3) == 0) {
        x >>= 2;
        r += 2;
    }
    if ((x & 1) == 0) ++r;
    return r;
}
// (public) returns index of lowest 1-bit (or -1 if none)
function $940670746dd773e1$var$bnGetLowestSetBit() {
    for(var i = 0; i < this.t; ++i)if (this.data[i] != 0) return i * this.DB + $940670746dd773e1$var$lbit(this.data[i]);
    if (this.s < 0) return this.t * this.DB;
    return -1;
}
// return number of 1 bits in x
function $940670746dd773e1$var$cbit(x) {
    var r = 0;
    while(x != 0){
        x &= x - 1;
        ++r;
    }
    return r;
}
// (public) return number of set bits
function $940670746dd773e1$var$bnBitCount() {
    var r = 0, x = this.s & this.DM;
    for(var i = 0; i < this.t; ++i)r += $940670746dd773e1$var$cbit(this.data[i] ^ x);
    return r;
}
// (public) true iff nth bit is set
function $940670746dd773e1$var$bnTestBit(n) {
    var j = Math.floor(n / this.DB);
    if (j >= this.t) return this.s != 0;
    return (this.data[j] & 1 << n % this.DB) != 0;
}
// (protected) this op (1<<n)
function $940670746dd773e1$var$bnpChangeBit(n, op) {
    var r = $940670746dd773e1$var$BigInteger.ONE.shiftLeft(n);
    this.bitwiseTo(r, op, r);
    return r;
}
// (public) this | (1<<n)
function $940670746dd773e1$var$bnSetBit(n) {
    return this.changeBit(n, $940670746dd773e1$var$op_or);
}
// (public) this & ~(1<<n)
function $940670746dd773e1$var$bnClearBit(n) {
    return this.changeBit(n, $940670746dd773e1$var$op_andnot);
}
// (public) this ^ (1<<n)
function $940670746dd773e1$var$bnFlipBit(n) {
    return this.changeBit(n, $940670746dd773e1$var$op_xor);
}
// (protected) r = this + a
function $940670746dd773e1$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this.data[i] + a.data[i];
        r.data[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r.data[i++] = c;
    else if (c < -1) r.data[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $940670746dd773e1$var$bnAdd(a) {
    var r = $940670746dd773e1$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $940670746dd773e1$var$bnSubtract(a) {
    var r = $940670746dd773e1$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $940670746dd773e1$var$bnMultiply(a) {
    var r = $940670746dd773e1$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this^2
function $940670746dd773e1$var$bnSquare() {
    var r = $940670746dd773e1$var$nbi();
    this.squareTo(r);
    return r;
}
// (public) this / a
function $940670746dd773e1$var$bnDivide(a) {
    var r = $940670746dd773e1$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// (public) this % a
function $940670746dd773e1$var$bnRemainder(a) {
    var r = $940670746dd773e1$var$nbi();
    this.divRemTo(a, null, r);
    return r;
}
// (public) [this/a,this%a]
function $940670746dd773e1$var$bnDivideAndRemainder(a) {
    var q = $940670746dd773e1$var$nbi(), r = $940670746dd773e1$var$nbi();
    this.divRemTo(a, q, r);
    return new Array(q, r);
}
// (protected) this *= n, this >= 0, 1 < n < DV
function $940670746dd773e1$var$bnpDMultiply(n) {
    this.data[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
    ++this.t;
    this.clamp();
}
// (protected) this += n << w words, this >= 0
function $940670746dd773e1$var$bnpDAddOffset(n, w) {
    if (n == 0) return;
    while(this.t <= w)this.data[this.t++] = 0;
    this.data[w] += n;
    while(this.data[w] >= this.DV){
        this.data[w] -= this.DV;
        if (++w >= this.t) this.data[this.t++] = 0;
        ++this.data[w];
    }
}
// A "null" reducer
function $940670746dd773e1$var$NullExp() {}
function $940670746dd773e1$var$nNop(x) {
    return x;
}
function $940670746dd773e1$var$nMulTo(x, y, r) {
    x.multiplyTo(y, r);
}
function $940670746dd773e1$var$nSqrTo(x, r) {
    x.squareTo(r);
}
$940670746dd773e1$var$NullExp.prototype.convert = $940670746dd773e1$var$nNop;
$940670746dd773e1$var$NullExp.prototype.revert = $940670746dd773e1$var$nNop;
$940670746dd773e1$var$NullExp.prototype.mulTo = $940670746dd773e1$var$nMulTo;
$940670746dd773e1$var$NullExp.prototype.sqrTo = $940670746dd773e1$var$nSqrTo;
// (public) this^e
function $940670746dd773e1$var$bnPow(e) {
    return this.exp(e, new $940670746dd773e1$var$NullExp());
}
// (protected) r = lower n words of "this * a", a.t <= n
// "this" should be the larger one if appropriate.
function $940670746dd773e1$var$bnpMultiplyLowerTo(a, n, r) {
    var i = Math.min(this.t + a.t, n);
    r.s = 0; // assumes a,this >= 0
    r.t = i;
    while(i > 0)r.data[--i] = 0;
    var j;
    for(j = r.t - this.t; i < j; ++i)r.data[i + this.t] = this.am(0, a.data[i], r, i, 0, this.t);
    for(j = Math.min(a.t, n); i < j; ++i)this.am(0, a.data[i], r, i, 0, n - i);
    r.clamp();
}
// (protected) r = "this * a" without lower n words, n > 0
// "this" should be the larger one if appropriate.
function $940670746dd773e1$var$bnpMultiplyUpperTo(a, n, r) {
    --n;
    var i = r.t = this.t + a.t - n;
    r.s = 0; // assumes a,this >= 0
    while(--i >= 0)r.data[i] = 0;
    for(i = Math.max(n - this.t, 0); i < a.t; ++i)r.data[this.t + i - n] = this.am(n - i, a.data[i], r, 0, 0, this.t + i - n);
    r.clamp();
    r.drShiftTo(1, r);
}
// Barrett modular reduction
function $940670746dd773e1$var$Barrett(m) {
    // setup Barrett
    this.r2 = $940670746dd773e1$var$nbi();
    this.q3 = $940670746dd773e1$var$nbi();
    $940670746dd773e1$var$BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
    this.mu = this.r2.divide(m);
    this.m = m;
}
function $940670746dd773e1$var$barrettConvert(x) {
    if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
    else if (x.compareTo(this.m) < 0) return x;
    else {
        var r = $940670746dd773e1$var$nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    }
}
function $940670746dd773e1$var$barrettRevert(x) {
    return x;
}
// x = x mod m (HAC 14.42)
function $940670746dd773e1$var$barrettReduce(x) {
    x.drShiftTo(this.m.t - 1, this.r2);
    if (x.t > this.m.t + 1) {
        x.t = this.m.t + 1;
        x.clamp();
    }
    this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
    this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
    while(x.compareTo(this.r2) < 0)x.dAddOffset(1, this.m.t + 1);
    x.subTo(this.r2, x);
    while(x.compareTo(this.m) >= 0)x.subTo(this.m, x);
}
// r = x^2 mod m; x != r
function $940670746dd773e1$var$barrettSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = x*y mod m; x,y != r
function $940670746dd773e1$var$barrettMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$940670746dd773e1$var$Barrett.prototype.convert = $940670746dd773e1$var$barrettConvert;
$940670746dd773e1$var$Barrett.prototype.revert = $940670746dd773e1$var$barrettRevert;
$940670746dd773e1$var$Barrett.prototype.reduce = $940670746dd773e1$var$barrettReduce;
$940670746dd773e1$var$Barrett.prototype.mulTo = $940670746dd773e1$var$barrettMulTo;
$940670746dd773e1$var$Barrett.prototype.sqrTo = $940670746dd773e1$var$barrettSqrTo;
// (public) this^e % m (HAC 14.85)
function $940670746dd773e1$var$bnModPow(e, m) {
    var i = e.bitLength(), k, r = $940670746dd773e1$var$nbv(1), z;
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    if (i < 8) z = new $940670746dd773e1$var$Classic(m);
    else if (m.isEven()) z = new $940670746dd773e1$var$Barrett(m);
    else z = new $940670746dd773e1$var$Montgomery(m);
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $940670746dd773e1$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $940670746dd773e1$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $940670746dd773e1$var$nbi(), t;
    i = $940670746dd773e1$var$nbits(e.data[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e.data[j] >> i - k1 & km;
        else {
            w = (e.data[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e.data[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e.data[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    return z.revert(r);
}
// (public) gcd(this,a) (HAC 14.54)
function $940670746dd773e1$var$bnGCD(a) {
    var x = this.s < 0 ? this.negate() : this.clone();
    var y = a.s < 0 ? a.negate() : a.clone();
    if (x.compareTo(y) < 0) {
        var t = x;
        x = y;
        y = t;
    }
    var i = x.getLowestSetBit(), g = y.getLowestSetBit();
    if (g < 0) return x;
    if (i < g) g = i;
    if (g > 0) {
        x.rShiftTo(g, x);
        y.rShiftTo(g, y);
    }
    while(x.signum() > 0){
        if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
        if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
        if (x.compareTo(y) >= 0) {
            x.subTo(y, x);
            x.rShiftTo(1, x);
        } else {
            y.subTo(x, y);
            y.rShiftTo(1, y);
        }
    }
    if (g > 0) y.lShiftTo(g, y);
    return y;
}
// (protected) this % n, n < 2^26
function $940670746dd773e1$var$bnpModInt(n) {
    if (n <= 0) return 0;
    var d = this.DV % n, r = this.s < 0 ? n - 1 : 0;
    if (this.t > 0) {
        if (d == 0) r = this.data[0] % n;
        else for(var i = this.t - 1; i >= 0; --i)r = (d * r + this.data[i]) % n;
    }
    return r;
}
// (public) 1/this % m (HAC 14.61)
function $940670746dd773e1$var$bnModInverse(m) {
    // FORGE: jsbn fix
    // avoid infinite loop
    if (this.signum() == 0) // returning zero to align with similar behavior when no multiplicative
    // inverse module m is found.
    return $940670746dd773e1$var$BigInteger.ZERO;
    var ac = m.isEven();
    if (this.isEven() && ac || m.signum() == 0) return $940670746dd773e1$var$BigInteger.ZERO;
    var u = m.clone(), v = this.clone();
    var a = $940670746dd773e1$var$nbv(1), b = $940670746dd773e1$var$nbv(0), c = $940670746dd773e1$var$nbv(0), d = $940670746dd773e1$var$nbv(1);
    while(u.signum() != 0){
        while(u.isEven()){
            u.rShiftTo(1, u);
            if (ac) {
                if (!a.isEven() || !b.isEven()) {
                    a.addTo(this, a);
                    b.subTo(m, b);
                }
                a.rShiftTo(1, a);
            } else if (!b.isEven()) b.subTo(m, b);
            b.rShiftTo(1, b);
        }
        while(v.isEven()){
            v.rShiftTo(1, v);
            if (ac) {
                if (!c.isEven() || !d.isEven()) {
                    c.addTo(this, c);
                    d.subTo(m, d);
                }
                c.rShiftTo(1, c);
            } else if (!d.isEven()) d.subTo(m, d);
            d.rShiftTo(1, d);
        }
        if (u.compareTo(v) >= 0) {
            u.subTo(v, u);
            if (ac) a.subTo(c, a);
            b.subTo(d, b);
        } else {
            v.subTo(u, v);
            if (ac) c.subTo(a, c);
            d.subTo(b, d);
        }
    }
    if (v.compareTo($940670746dd773e1$var$BigInteger.ONE) != 0) return $940670746dd773e1$var$BigInteger.ZERO;
    if (d.compareTo(m) >= 0) return d.subtract(m);
    if (d.signum() < 0) d.addTo(m, d);
    else return d;
    if (d.signum() < 0) return d.add(m);
    else return d;
}
var $940670746dd773e1$var$lowprimes = [
    2,
    3,
    5,
    7,
    11,
    13,
    17,
    19,
    23,
    29,
    31,
    37,
    41,
    43,
    47,
    53,
    59,
    61,
    67,
    71,
    73,
    79,
    83,
    89,
    97,
    101,
    103,
    107,
    109,
    113,
    127,
    131,
    137,
    139,
    149,
    151,
    157,
    163,
    167,
    173,
    179,
    181,
    191,
    193,
    197,
    199,
    211,
    223,
    227,
    229,
    233,
    239,
    241,
    251,
    257,
    263,
    269,
    271,
    277,
    281,
    283,
    293,
    307,
    311,
    313,
    317,
    331,
    337,
    347,
    349,
    353,
    359,
    367,
    373,
    379,
    383,
    389,
    397,
    401,
    409,
    419,
    421,
    431,
    433,
    439,
    443,
    449,
    457,
    461,
    463,
    467,
    479,
    487,
    491,
    499,
    503,
    509,
    521,
    523,
    541,
    547,
    557,
    563,
    569,
    571,
    577,
    587,
    593,
    599,
    601,
    607,
    613,
    617,
    619,
    631,
    641,
    643,
    647,
    653,
    659,
    661,
    673,
    677,
    683,
    691,
    701,
    709,
    719,
    727,
    733,
    739,
    743,
    751,
    757,
    761,
    769,
    773,
    787,
    797,
    809,
    811,
    821,
    823,
    827,
    829,
    839,
    853,
    857,
    859,
    863,
    877,
    881,
    883,
    887,
    907,
    911,
    919,
    929,
    937,
    941,
    947,
    953,
    967,
    971,
    977,
    983,
    991,
    997
];
var $940670746dd773e1$var$lplim = 67108864 / $940670746dd773e1$var$lowprimes[$940670746dd773e1$var$lowprimes.length - 1];
// (public) test primality with certainty >= 1-.5^t
function $940670746dd773e1$var$bnIsProbablePrime(t) {
    var i, x = this.abs();
    if (x.t == 1 && x.data[0] <= $940670746dd773e1$var$lowprimes[$940670746dd773e1$var$lowprimes.length - 1]) {
        for(i = 0; i < $940670746dd773e1$var$lowprimes.length; ++i)if (x.data[0] == $940670746dd773e1$var$lowprimes[i]) return true;
        return false;
    }
    if (x.isEven()) return false;
    i = 1;
    while(i < $940670746dd773e1$var$lowprimes.length){
        var m = $940670746dd773e1$var$lowprimes[i], j = i + 1;
        while(j < $940670746dd773e1$var$lowprimes.length && m < $940670746dd773e1$var$lplim)m *= $940670746dd773e1$var$lowprimes[j++];
        m = x.modInt(m);
        while(i < j)if (m % $940670746dd773e1$var$lowprimes[i++] == 0) return false;
    }
    return x.millerRabin(t);
}
// (protected) true if probably prime (HAC 4.24, Miller-Rabin)
function $940670746dd773e1$var$bnpMillerRabin(t) {
    var n1 = this.subtract($940670746dd773e1$var$BigInteger.ONE);
    var k = n1.getLowestSetBit();
    if (k <= 0) return false;
    var r = n1.shiftRight(k);
    var prng = $940670746dd773e1$var$bnGetPrng();
    var a;
    for(var i = 0; i < t; ++i){
        // select witness 'a' at random from between 1 and n1
        do a = new $940670746dd773e1$var$BigInteger(this.bitLength(), prng);
        while (a.compareTo($940670746dd773e1$var$BigInteger.ONE) <= 0 || a.compareTo(n1) >= 0);
        var y = a.modPow(r, this);
        if (y.compareTo($940670746dd773e1$var$BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
            var j = 1;
            while(j++ < k && y.compareTo(n1) != 0){
                y = y.modPowInt(2, this);
                if (y.compareTo($940670746dd773e1$var$BigInteger.ONE) == 0) return false;
            }
            if (y.compareTo(n1) != 0) return false;
        }
    }
    return true;
}
// get pseudo random number generator
function $940670746dd773e1$var$bnGetPrng() {
    // create prng with api that matches BigInteger secure random
    return {
        // x is an array to fill with bytes
        nextBytes: function(x) {
            for(var i = 0; i < x.length; ++i)x[i] = Math.floor(Math.random() * 0x0100);
        }
    };
}
// protected
$940670746dd773e1$var$BigInteger.prototype.chunkSize = $940670746dd773e1$var$bnpChunkSize;
$940670746dd773e1$var$BigInteger.prototype.toRadix = $940670746dd773e1$var$bnpToRadix;
$940670746dd773e1$var$BigInteger.prototype.fromRadix = $940670746dd773e1$var$bnpFromRadix;
$940670746dd773e1$var$BigInteger.prototype.fromNumber = $940670746dd773e1$var$bnpFromNumber;
$940670746dd773e1$var$BigInteger.prototype.bitwiseTo = $940670746dd773e1$var$bnpBitwiseTo;
$940670746dd773e1$var$BigInteger.prototype.changeBit = $940670746dd773e1$var$bnpChangeBit;
$940670746dd773e1$var$BigInteger.prototype.addTo = $940670746dd773e1$var$bnpAddTo;
$940670746dd773e1$var$BigInteger.prototype.dMultiply = $940670746dd773e1$var$bnpDMultiply;
$940670746dd773e1$var$BigInteger.prototype.dAddOffset = $940670746dd773e1$var$bnpDAddOffset;
$940670746dd773e1$var$BigInteger.prototype.multiplyLowerTo = $940670746dd773e1$var$bnpMultiplyLowerTo;
$940670746dd773e1$var$BigInteger.prototype.multiplyUpperTo = $940670746dd773e1$var$bnpMultiplyUpperTo;
$940670746dd773e1$var$BigInteger.prototype.modInt = $940670746dd773e1$var$bnpModInt;
$940670746dd773e1$var$BigInteger.prototype.millerRabin = $940670746dd773e1$var$bnpMillerRabin;
// public
$940670746dd773e1$var$BigInteger.prototype.clone = $940670746dd773e1$var$bnClone;
$940670746dd773e1$var$BigInteger.prototype.intValue = $940670746dd773e1$var$bnIntValue;
$940670746dd773e1$var$BigInteger.prototype.byteValue = $940670746dd773e1$var$bnByteValue;
$940670746dd773e1$var$BigInteger.prototype.shortValue = $940670746dd773e1$var$bnShortValue;
$940670746dd773e1$var$BigInteger.prototype.signum = $940670746dd773e1$var$bnSigNum;
$940670746dd773e1$var$BigInteger.prototype.toByteArray = $940670746dd773e1$var$bnToByteArray;
$940670746dd773e1$var$BigInteger.prototype.equals = $940670746dd773e1$var$bnEquals;
$940670746dd773e1$var$BigInteger.prototype.min = $940670746dd773e1$var$bnMin;
$940670746dd773e1$var$BigInteger.prototype.max = $940670746dd773e1$var$bnMax;
$940670746dd773e1$var$BigInteger.prototype.and = $940670746dd773e1$var$bnAnd;
$940670746dd773e1$var$BigInteger.prototype.or = $940670746dd773e1$var$bnOr;
$940670746dd773e1$var$BigInteger.prototype.xor = $940670746dd773e1$var$bnXor;
$940670746dd773e1$var$BigInteger.prototype.andNot = $940670746dd773e1$var$bnAndNot;
$940670746dd773e1$var$BigInteger.prototype.not = $940670746dd773e1$var$bnNot;
$940670746dd773e1$var$BigInteger.prototype.shiftLeft = $940670746dd773e1$var$bnShiftLeft;
$940670746dd773e1$var$BigInteger.prototype.shiftRight = $940670746dd773e1$var$bnShiftRight;
$940670746dd773e1$var$BigInteger.prototype.getLowestSetBit = $940670746dd773e1$var$bnGetLowestSetBit;
$940670746dd773e1$var$BigInteger.prototype.bitCount = $940670746dd773e1$var$bnBitCount;
$940670746dd773e1$var$BigInteger.prototype.testBit = $940670746dd773e1$var$bnTestBit;
$940670746dd773e1$var$BigInteger.prototype.setBit = $940670746dd773e1$var$bnSetBit;
$940670746dd773e1$var$BigInteger.prototype.clearBit = $940670746dd773e1$var$bnClearBit;
$940670746dd773e1$var$BigInteger.prototype.flipBit = $940670746dd773e1$var$bnFlipBit;
$940670746dd773e1$var$BigInteger.prototype.add = $940670746dd773e1$var$bnAdd;
$940670746dd773e1$var$BigInteger.prototype.subtract = $940670746dd773e1$var$bnSubtract;
$940670746dd773e1$var$BigInteger.prototype.multiply = $940670746dd773e1$var$bnMultiply;
$940670746dd773e1$var$BigInteger.prototype.divide = $940670746dd773e1$var$bnDivide;
$940670746dd773e1$var$BigInteger.prototype.remainder = $940670746dd773e1$var$bnRemainder;
$940670746dd773e1$var$BigInteger.prototype.divideAndRemainder = $940670746dd773e1$var$bnDivideAndRemainder;
$940670746dd773e1$var$BigInteger.prototype.modPow = $940670746dd773e1$var$bnModPow;
$940670746dd773e1$var$BigInteger.prototype.modInverse = $940670746dd773e1$var$bnModInverse;
$940670746dd773e1$var$BigInteger.prototype.pow = $940670746dd773e1$var$bnPow;
$940670746dd773e1$var$BigInteger.prototype.gcd = $940670746dd773e1$var$bnGCD;
$940670746dd773e1$var$BigInteger.prototype.isProbablePrime = $940670746dd773e1$var$bnIsProbablePrime;
// JSBN-specific extension
$940670746dd773e1$var$BigInteger.prototype.square = $940670746dd773e1$var$bnSquare; // BigInteger interfaces not implemented in jsbn:
 // BigInteger(int signum, byte[] magnitude)
 // double doubleValue()
 // float floatValue()
 // int hashCode()
 // long longValue()
 // static BigInteger valueOf(long val)

});

parcelRequire.register("dImdE", function(module, exports) {
/**
 * Partial implementation of PKCS#1 v2.2: RSA-OEAP
 *
 * Modified but based on the following MIT and BSD licensed code:
 *
 * https://github.com/kjur/jsjws/blob/master/rsa.js:
 *
 * The 'jsjws'(JSON Web Signature JavaScript Library) License
 *
 * Copyright (c) 2012 Kenji Urushima
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 * http://webrsa.cvs.sourceforge.net/viewvc/webrsa/Client/RSAES-OAEP.js?content-type=text%2Fplain:
 *
 * RSAES-OAEP.js
 * $Id: RSAES-OAEP.js,v 1.1.1.1 2003/03/19 15:37:20 ellispritchard Exp $
 * JavaScript Implementation of PKCS #1 v2.1 RSA CRYPTOGRAPHY STANDARD (RSA Laboratories, June 14, 2002)
 * Copyright (C) Ellis Pritchard, Guardian Unlimited 2003.
 * Contact: ellis@nukinetics.com
 * Distributed under the BSD License.
 *
 * Official documentation: http://www.rsa.com/rsalabs/node.asp?id=2125
 *
 * @author Evan Jones (http://evanjones.ca/)
 * @author Dave Longley
 *
 * Copyright (c) 2013-2014 Digital Bazaar, Inc.
 */ 
var $hSPkV = parcelRequire("hSPkV");
parcelRequire("3lPw4");
parcelRequire("eJAQ9");
parcelRequire("fFF5Z");
// shortcut for PKCS#1 API
var $9fc09eaddade14b8$var$pkcs1 = module.exports = $hSPkV.pkcs1 = $hSPkV.pkcs1 || {};
/**
 * Encode the given RSAES-OAEP message (M) using key, with optional label (L)
 * and seed.
 *
 * This method does not perform RSA encryption, it only encodes the message
 * using RSAES-OAEP.
 *
 * @param key the RSA key to use.
 * @param message the message to encode.
 * @param options the options to use:
 *          label an optional label to use.
 *          seed the seed to use.
 *          md the message digest object to use, undefined for SHA-1.
 *          mgf1 optional mgf1 parameters:
 *            md the message digest object to use for MGF1.
 *
 * @return the encoded message bytes.
 */ $9fc09eaddade14b8$var$pkcs1.encode_rsa_oaep = function(key, message, options) {
    // parse arguments
    var label;
    var seed;
    var md;
    var mgf1Md;
    // legacy args (label, seed, md)
    if (typeof options === "string") {
        label = options;
        seed = arguments[3] || undefined;
        md = arguments[4] || undefined;
    } else if (options) {
        label = options.label || undefined;
        seed = options.seed || undefined;
        md = options.md || undefined;
        if (options.mgf1 && options.mgf1.md) mgf1Md = options.mgf1.md;
    }
    // default OAEP to SHA-1 message digest
    if (!md) md = $hSPkV.md.sha1.create();
    else md.start();
    // default MGF-1 to same as OAEP
    if (!mgf1Md) mgf1Md = md;
    // compute length in bytes and check output
    var keyLength = Math.ceil(key.n.bitLength() / 8);
    var maxLength = keyLength - 2 * md.digestLength - 2;
    if (message.length > maxLength) {
        var error = new Error("RSAES-OAEP input message length is too long.");
        error.length = message.length;
        error.maxLength = maxLength;
        throw error;
    }
    if (!label) label = "";
    md.update(label, "raw");
    var lHash = md.digest();
    var PS = "";
    var PS_length = maxLength - message.length;
    for(var i = 0; i < PS_length; i++)PS += "\x00";
    var DB = lHash.getBytes() + PS + "\x01" + message;
    if (!seed) seed = $hSPkV.random.getBytes(md.digestLength);
    else if (seed.length !== md.digestLength) {
        var error = new Error("Invalid RSAES-OAEP seed. The seed length must match the digest length.");
        error.seedLength = seed.length;
        error.digestLength = md.digestLength;
        throw error;
    }
    var dbMask = $9fc09eaddade14b8$var$rsa_mgf1(seed, keyLength - md.digestLength - 1, mgf1Md);
    var maskedDB = $hSPkV.util.xorBytes(DB, dbMask, DB.length);
    var seedMask = $9fc09eaddade14b8$var$rsa_mgf1(maskedDB, md.digestLength, mgf1Md);
    var maskedSeed = $hSPkV.util.xorBytes(seed, seedMask, seed.length);
    // return encoded message
    return "\x00" + maskedSeed + maskedDB;
};
/**
 * Decode the given RSAES-OAEP encoded message (EM) using key, with optional
 * label (L).
 *
 * This method does not perform RSA decryption, it only decodes the message
 * using RSAES-OAEP.
 *
 * @param key the RSA key to use.
 * @param em the encoded message to decode.
 * @param options the options to use:
 *          label an optional label to use.
 *          md the message digest object to use for OAEP, undefined for SHA-1.
 *          mgf1 optional mgf1 parameters:
 *            md the message digest object to use for MGF1.
 *
 * @return the decoded message bytes.
 */ $9fc09eaddade14b8$var$pkcs1.decode_rsa_oaep = function(key, em, options) {
    // parse args
    var label;
    var md;
    var mgf1Md;
    // legacy args
    if (typeof options === "string") {
        label = options;
        md = arguments[3] || undefined;
    } else if (options) {
        label = options.label || undefined;
        md = options.md || undefined;
        if (options.mgf1 && options.mgf1.md) mgf1Md = options.mgf1.md;
    }
    // compute length in bytes
    var keyLength = Math.ceil(key.n.bitLength() / 8);
    if (em.length !== keyLength) {
        var error = new Error("RSAES-OAEP encoded message length is invalid.");
        error.length = em.length;
        error.expectedLength = keyLength;
        throw error;
    }
    // default OAEP to SHA-1 message digest
    if (md === undefined) md = $hSPkV.md.sha1.create();
    else md.start();
    // default MGF-1 to same as OAEP
    if (!mgf1Md) mgf1Md = md;
    if (keyLength < 2 * md.digestLength + 2) throw new Error("RSAES-OAEP key is too short for the hash function.");
    if (!label) label = "";
    md.update(label, "raw");
    var lHash = md.digest().getBytes();
    // split the message into its parts
    var y = em.charAt(0);
    var maskedSeed = em.substring(1, md.digestLength + 1);
    var maskedDB = em.substring(1 + md.digestLength);
    var seedMask = $9fc09eaddade14b8$var$rsa_mgf1(maskedDB, md.digestLength, mgf1Md);
    var seed = $hSPkV.util.xorBytes(maskedSeed, seedMask, maskedSeed.length);
    var dbMask = $9fc09eaddade14b8$var$rsa_mgf1(seed, keyLength - md.digestLength - 1, mgf1Md);
    var db = $hSPkV.util.xorBytes(maskedDB, dbMask, maskedDB.length);
    var lHashPrime = db.substring(0, md.digestLength);
    // constant time check that all values match what is expected
    var error = y !== "\x00";
    // constant time check lHash vs lHashPrime
    for(var i = 0; i < md.digestLength; ++i)error |= lHash.charAt(i) !== lHashPrime.charAt(i);
    // "constant time" find the 0x1 byte separating the padding (zeros) from the
    // message
    // TODO: It must be possible to do this in a better/smarter way?
    var in_ps = 1;
    var index = md.digestLength;
    for(var j = md.digestLength; j < db.length; j++){
        var code = db.charCodeAt(j);
        var is_0 = code & 0x1 ^ 0x1;
        // non-zero if not 0 or 1 in the ps section
        var error_mask = in_ps ? 0xfffe : 0x0000;
        error |= code & error_mask;
        // latch in_ps to zero after we find 0x1
        in_ps = in_ps & is_0;
        index += in_ps;
    }
    if (error || db.charCodeAt(index) !== 0x1) throw new Error("Invalid RSAES-OAEP padding.");
    return db.substring(index + 1);
};
function $9fc09eaddade14b8$var$rsa_mgf1(seed, maskLength, hash) {
    // default to SHA-1 message digest
    if (!hash) hash = $hSPkV.md.sha1.create();
    var t = "";
    var count = Math.ceil(maskLength / hash.digestLength);
    for(var i = 0; i < count; ++i){
        var c = String.fromCharCode(i >> 24 & 0xFF, i >> 16 & 0xFF, i >> 8 & 0xFF, i & 0xFF);
        hash.start();
        hash.update(seed + c);
        t += hash.digest().getBytes();
    }
    return t.substring(0, maskLength);
}

});
parcelRequire.register("fFF5Z", function(module, exports) {
/**
 * Secure Hash Algorithm with 160-bit digest (SHA-1) implementation.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2015 Digital Bazaar, Inc.
 */ 
var $hSPkV = parcelRequire("hSPkV");
parcelRequire("jCulq");
parcelRequire("3lPw4");
var $b68a9017a4895ba5$var$sha1 = module.exports = $hSPkV.sha1 = $hSPkV.sha1 || {};
$hSPkV.md.sha1 = $hSPkV.md.algorithms.sha1 = $b68a9017a4895ba5$var$sha1;
/**
 * Creates a SHA-1 message digest object.
 *
 * @return a message digest object.
 */ $b68a9017a4895ba5$var$sha1.create = function() {
    // do initialization as necessary
    if (!$b68a9017a4895ba5$var$_initialized) $b68a9017a4895ba5$var$_init();
    // SHA-1 state contains five 32-bit integers
    var _state = null;
    // input buffer
    var _input = $hSPkV.util.createBuffer();
    // used for word storage
    var _w = new Array(80);
    // message digest object
    var md = {
        algorithm: "sha1",
        blockLength: 64,
        digestLength: 20,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 8
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength64 for backwards-compatibility)
        md.fullMessageLength = md.messageLength64 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $hSPkV.util.createBuffer();
        _state = {
            h0: 0x67452301,
            h1: 0xEFCDAB89,
            h2: 0x98BADCFE,
            h3: 0x10325476,
            h4: 0xC3D2E1F0
        };
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === "utf8") msg = $hSPkV.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $b68a9017a4895ba5$var$_update(_state, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate SHA-1 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 448 mod 512. In other words,
    the data to be digested must be a multiple of 512 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 8 bytes (64
    bits), that means that the last segment of the data must have 56 bytes
    (448 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 448 mod 512 because
    512 - 128 = 448.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 448 mod 512, then 512 padding bits must be added. */ var finalBlock = $hSPkV.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($b68a9017a4895ba5$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in big-endian order; since length
        // is stored in bytes we multiply by 8 and add carry from next int
        var next, carry;
        var bits = md.fullMessageLength[0] * 8;
        for(var i = 0; i < md.fullMessageLength.length - 1; ++i){
            next = md.fullMessageLength[i + 1] * 8;
            carry = next / 0x100000000 >>> 0;
            bits += carry;
            finalBlock.putInt32(bits >>> 0);
            bits = next >>> 0;
        }
        finalBlock.putInt32(bits);
        var s2 = {
            h0: _state.h0,
            h1: _state.h1,
            h2: _state.h2,
            h3: _state.h3,
            h4: _state.h4
        };
        $b68a9017a4895ba5$var$_update(s2, _w, finalBlock);
        var rval = $hSPkV.util.createBuffer();
        rval.putInt32(s2.h0);
        rval.putInt32(s2.h1);
        rval.putInt32(s2.h2);
        rval.putInt32(s2.h3);
        rval.putInt32(s2.h4);
        return rval;
    };
    return md;
};
// sha-1 padding bytes not initialized yet
var $b68a9017a4895ba5$var$_padding = null;
var $b68a9017a4895ba5$var$_initialized = false;
/**
 * Initializes the constant tables.
 */ function $b68a9017a4895ba5$var$_init() {
    // create padding
    $b68a9017a4895ba5$var$_padding = String.fromCharCode(128);
    $b68a9017a4895ba5$var$_padding += $hSPkV.util.fillString(String.fromCharCode(0x00), 64);
    // now initialized
    $b68a9017a4895ba5$var$_initialized = true;
}
/**
 * Updates a SHA-1 state with the given byte buffer.
 *
 * @param s the SHA-1 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $b68a9017a4895ba5$var$_update(s, w, bytes) {
    // consume 512 bit (64 byte) chunks
    var t, a, b, c, d, e, f, i;
    var len = bytes.length();
    while(len >= 64){
        // the w array will be populated with sixteen 32-bit big-endian words
        // and then extended into 80 32-bit words according to SHA-1 algorithm
        // and for 32-79 using Max Locktyukhin's optimization
        // initialize hash value for this chunk
        a = s.h0;
        b = s.h1;
        c = s.h2;
        d = s.h3;
        e = s.h4;
        // round 1
        for(i = 0; i < 16; ++i){
            t = bytes.getInt32();
            w[i] = t;
            f = d ^ b & (c ^ d);
            t = (a << 5 | a >>> 27) + f + e + 0x5A827999 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        for(; i < 20; ++i){
            t = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
            t = t << 1 | t >>> 31;
            w[i] = t;
            f = d ^ b & (c ^ d);
            t = (a << 5 | a >>> 27) + f + e + 0x5A827999 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // round 2
        for(; i < 32; ++i){
            t = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
            t = t << 1 | t >>> 31;
            w[i] = t;
            f = b ^ c ^ d;
            t = (a << 5 | a >>> 27) + f + e + 0x6ED9EBA1 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        for(; i < 40; ++i){
            t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
            t = t << 2 | t >>> 30;
            w[i] = t;
            f = b ^ c ^ d;
            t = (a << 5 | a >>> 27) + f + e + 0x6ED9EBA1 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // round 3
        for(; i < 60; ++i){
            t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
            t = t << 2 | t >>> 30;
            w[i] = t;
            f = b & c | d & (b ^ c);
            t = (a << 5 | a >>> 27) + f + e + 0x8F1BBCDC + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // round 4
        for(; i < 80; ++i){
            t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
            t = t << 2 | t >>> 30;
            w[i] = t;
            f = b ^ c ^ d;
            t = (a << 5 | a >>> 27) + f + e + 0xCA62C1D6 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // update hash state
        s.h0 = s.h0 + a | 0;
        s.h1 = s.h1 + b | 0;
        s.h2 = s.h2 + c | 0;
        s.h3 = s.h3 + d | 0;
        s.h4 = s.h4 + e | 0;
        len -= 64;
    }
}

});


parcelRequire.register("9NNan", function(module, exports) {
/**
 * Prime number generation API.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2014 Digital Bazaar, Inc.
 */ 
var $hSPkV = parcelRequire("hSPkV");
parcelRequire("3lPw4");
parcelRequire("cHVVU");
parcelRequire("eJAQ9");
(function() {
    // forge.prime already defined
    if ($hSPkV.prime) {
        module.exports = $hSPkV.prime;
        return;
    }
    /* PRIME API */ var prime = module.exports = $hSPkV.prime = $hSPkV.prime || {};
    var BigInteger = $hSPkV.jsbn.BigInteger;
    // primes are 30k+i for i = 1, 7, 11, 13, 17, 19, 23, 29
    var GCD_30_DELTA = [
        6,
        4,
        2,
        4,
        2,
        4,
        6,
        2
    ];
    var THIRTY = new BigInteger(null);
    THIRTY.fromInt(30);
    var op_or = function(x, y) {
        return x | y;
    };
    /**
 * Generates a random probable prime with the given number of bits.
 *
 * Alternative algorithms can be specified by name as a string or as an
 * object with custom options like so:
 *
 * {
 *   name: 'PRIMEINC',
 *   options: {
 *     maxBlockTime: <the maximum amount of time to block the main
 *       thread before allowing I/O other JS to run>,
 *     millerRabinTests: <the number of miller-rabin tests to run>,
 *     workerScript: <the worker script URL>,
 *     workers: <the number of web workers (if supported) to use,
 *       -1 to use estimated cores minus one>.
 *     workLoad: the size of the work load, ie: number of possible prime
 *       numbers for each web worker to check per work assignment,
 *       (default: 100).
 *   }
 * }
 *
 * @param bits the number of bits for the prime number.
 * @param options the options to use.
 *          [algorithm] the algorithm to use (default: 'PRIMEINC').
 *          [prng] a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync".
 *
 * @return callback(err, num) called once the operation completes.
 */ prime.generateProbablePrime = function(bits, options, callback) {
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        options = options || {};
        // default to PRIMEINC algorithm
        var algorithm = options.algorithm || "PRIMEINC";
        if (typeof algorithm === "string") algorithm = {
            name: algorithm
        };
        algorithm.options = algorithm.options || {};
        // create prng with api that matches BigInteger secure random
        var prng = options.prng || $hSPkV.random;
        var rng = {
            // x is an array to fill with bytes
            nextBytes: function(x) {
                var b = prng.getBytesSync(x.length);
                for(var i = 0; i < x.length; ++i)x[i] = b.charCodeAt(i);
            }
        };
        if (algorithm.name === "PRIMEINC") return primeincFindPrime(bits, rng, algorithm.options, callback);
        throw new Error("Invalid prime generation algorithm: " + algorithm.name);
    };
    function primeincFindPrime(bits, rng, options, callback) {
        if ("workers" in options) return primeincFindPrimeWithWorkers(bits, rng, options, callback);
        return primeincFindPrimeWithoutWorkers(bits, rng, options, callback);
    }
    function primeincFindPrimeWithoutWorkers(bits, rng, options, callback) {
        // initialize random number
        var num = generateRandom(bits, rng);
        /* Note: All primes are of the form 30k+i for i < 30 and gcd(30, i)=1. The
  number we are given is always aligned at 30k + 1. Each time the number is
  determined not to be prime we add to get to the next 'i', eg: if the number
  was at 30k + 1 we add 6. */ var deltaIdx = 0;
        // get required number of MR tests
        var mrTests = getMillerRabinTests(num.bitLength());
        if ("millerRabinTests" in options) mrTests = options.millerRabinTests;
        // find prime nearest to 'num' for maxBlockTime ms
        // 10 ms gives 5ms of leeway for other calculations before dropping
        // below 60fps (1000/60 == 16.67), but in reality, the number will
        // likely be higher due to an 'atomic' big int modPow
        var maxBlockTime = 10;
        if ("maxBlockTime" in options) maxBlockTime = options.maxBlockTime;
        _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback);
    }
    function _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback) {
        var start = +new Date();
        do {
            // overflow, regenerate random number
            if (num.bitLength() > bits) num = generateRandom(bits, rng);
            // do primality test
            if (num.isProbablePrime(mrTests)) return callback(null, num);
            // get next potential prime
            num.dAddOffset(GCD_30_DELTA[deltaIdx++ % 8], 0);
        }while (maxBlockTime < 0 || +new Date() - start < maxBlockTime);
        // keep trying later
        $hSPkV.util.setImmediate(function() {
            _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback);
        });
    }
    // NOTE: This algorithm is indeterminate in nature because workers
    // run in parallel looking at different segments of numbers. Even if this
    // algorithm is run twice with the same input from a predictable RNG, it
    // may produce different outputs.
    function primeincFindPrimeWithWorkers(bits, rng, options, callback) {
        // web workers unavailable
        if (typeof Worker === "undefined") return primeincFindPrimeWithoutWorkers(bits, rng, options, callback);
        // initialize random number
        var num = generateRandom(bits, rng);
        // use web workers to generate keys
        var numWorkers = options.workers;
        var workLoad = options.workLoad || 100;
        var range = workLoad * 30 / 8;
        var workerScript = options.workerScript || "forge/prime.worker.js";
        if (numWorkers === -1) return $hSPkV.util.estimateCores(function(err, cores) {
            if (err) // default to 2
            cores = 2;
            numWorkers = cores - 1;
            generate();
        });
        generate();
        function generate() {
            // require at least 1 worker
            numWorkers = Math.max(1, numWorkers);
            // TODO: consider optimizing by starting workers outside getPrime() ...
            // note that in order to clean up they will have to be made internally
            // asynchronous which may actually be slower
            // start workers immediately
            var workers = [];
            for(var i = 0; i < numWorkers; ++i)// FIXME: fix path or use blob URLs
            workers[i] = new Worker(workerScript);
            var running = numWorkers;
            // listen for requests from workers and assign ranges to find prime
            for(var i = 0; i < numWorkers; ++i)workers[i].addEventListener("message", workerMessage);
            /* Note: The distribution of random numbers is unknown. Therefore, each
    web worker is continuously allocated a range of numbers to check for a
    random number until one is found.

    Every 30 numbers will be checked just 8 times, because prime numbers
    have the form:

    30k+i, for i < 30 and gcd(30, i)=1 (there are 8 values of i for this)

    Therefore, if we want a web worker to run N checks before asking for
    a new range of numbers, each range must contain N*30/8 numbers.

    For 100 checks (workLoad), this is a range of 375. */ var found = false;
            function workerMessage(e) {
                // ignore message, prime already found
                if (found) return;
                --running;
                var data = e.data;
                if (data.found) {
                    // terminate all workers
                    for(var i = 0; i < workers.length; ++i)workers[i].terminate();
                    found = true;
                    return callback(null, new BigInteger(data.prime, 16));
                }
                // overflow, regenerate random number
                if (num.bitLength() > bits) num = generateRandom(bits, rng);
                // assign new range to check
                var hex = num.toString(16);
                // start prime search
                e.target.postMessage({
                    hex: hex,
                    workLoad: workLoad
                });
                num.dAddOffset(range, 0);
            }
        }
    }
    /**
 * Generates a random number using the given number of bits and RNG.
 *
 * @param bits the number of bits for the number.
 * @param rng the random number generator to use.
 *
 * @return the random number.
 */ function generateRandom(bits, rng) {
        var num = new BigInteger(bits, rng);
        // force MSB set
        var bits1 = bits - 1;
        if (!num.testBit(bits1)) num.bitwiseTo(BigInteger.ONE.shiftLeft(bits1), op_or, num);
        // align number on 30k+1 boundary
        num.dAddOffset(31 - num.mod(THIRTY).byteValue(), 0);
        return num;
    }
    /**
 * Returns the required number of Miller-Rabin tests to generate a
 * prime with an error probability of (1/2)^80.
 *
 * See Handbook of Applied Cryptography Chapter 4, Table 4.4.
 *
 * @param bits the bit size.
 *
 * @return the required number of iterations.
 */ function getMillerRabinTests(bits) {
        if (bits <= 100) return 27;
        if (bits <= 150) return 18;
        if (bits <= 200) return 15;
        if (bits <= 250) return 12;
        if (bits <= 300) return 9;
        if (bits <= 350) return 8;
        if (bits <= 400) return 7;
        if (bits <= 500) return 6;
        if (bits <= 600) return 5;
        if (bits <= 800) return 4;
        if (bits <= 1250) return 3;
        return 2;
    }
})();

});



parcelRequire.register("ceNEu", function(module, exports) {
"use strict";

var $eXQx4 = parcelRequire("eXQx4");
var $8e8d4eb11622efc5$require$base64 = $eXQx4.base64;

var $dFQ0T = parcelRequire("dFQ0T");
module.exports = {
    /**
   * Attempts to decrypt a base64 encoded PrivateKey string
   * with the given password. The privateKey must have been exported
   * using the same password and underlying cipher (aes-gcm)
   *
   * @param {string} privateKey - A base64 encoded encrypted key
   * @param {string} password
   * @returns {Promise<Uint8Array>} The private key protobuf
   */ import: async function(privateKey, password) {
        const encryptedKey = $8e8d4eb11622efc5$require$base64.decode(privateKey);
        const cipher = $dFQ0T.create();
        return await cipher.decrypt(encryptedKey, password);
    }
};

});
parcelRequire.register("dFQ0T", function(module, exports) {
"use strict";

var $8hEBV = parcelRequire("8hEBV");
var $9f47737dbcb00cbc$require$concat = $8hEBV.concat;

var $8cWjP = parcelRequire("8cWjP");
var $9f47737dbcb00cbc$require$fromString = $8cWjP.fromString;

var $0NrO2 = parcelRequire("0NrO2");
// Based off of code from https://github.com/luke-park/SecureCompatibleEncryptionExamples
/**
 *
 * @param {object} [options]
 * @param {string} [options.algorithm=AES-GCM]
 * @param {number} [options.nonceLength=12]
 * @param {number} [options.keyLength=16]
 * @param {string} [options.digest=sha256]
 * @param {number} [options.saltLength=16]
 * @param {number} [options.iterations=32767]
 * @returns {*}
 */ function $9f47737dbcb00cbc$var$create({ algorithm: algorithm = "AES-GCM", nonceLength: nonceLength = 12, keyLength: keyLength = 16, digest: digest = "SHA-256", saltLength: saltLength = 16, iterations: iterations = 32767 } = {}) {
    const crypto = $0NrO2.get();
    keyLength *= 8 // Browser crypto uses bits instead of bytes
    ;
    /**
   * Uses the provided password to derive a pbkdf2 key. The key
   * will then be used to encrypt the data.
   *
   * @param {Uint8Array} data - The data to decrypt
   * @param {string} password - A plain password
   * @returns {Promise<Uint8Array>}
   */ async function encrypt(data, password) {
        const salt = crypto.getRandomValues(new Uint8Array(saltLength));
        const nonce = crypto.getRandomValues(new Uint8Array(nonceLength));
        const aesGcm = {
            name: algorithm,
            iv: nonce
        };
        // Derive a key using PBKDF2.
        const deriveParams = {
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: digest
            }
        };
        const rawKey = await crypto.subtle.importKey("raw", $9f47737dbcb00cbc$require$fromString(password), {
            name: "PBKDF2"
        }, false, [
            "deriveKey",
            "deriveBits"
        ]);
        const cryptoKey = await crypto.subtle.deriveKey(deriveParams, rawKey, {
            name: algorithm,
            length: keyLength
        }, true, [
            "encrypt"
        ]);
        // Encrypt the string.
        const ciphertext = await crypto.subtle.encrypt(aesGcm, cryptoKey, data);
        return $9f47737dbcb00cbc$require$concat([
            salt,
            aesGcm.iv,
            new Uint8Array(ciphertext)
        ]);
    }
    /**
   * Uses the provided password to derive a pbkdf2 key. The key
   * will then be used to decrypt the data. The options used to create
   * this decryption cipher must be the same as those used to create
   * the encryption cipher.
   *
   * @param {Uint8Array} data - The data to decrypt
   * @param {string} password - A plain password
   * @returns {Promise<Uint8Array>}
   */ async function decrypt(data, password) {
        const salt = data.slice(0, saltLength);
        const nonce = data.slice(saltLength, saltLength + nonceLength);
        const ciphertext = data.slice(saltLength + nonceLength);
        const aesGcm = {
            name: algorithm,
            iv: nonce
        };
        // Derive the key using PBKDF2.
        const deriveParams = {
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: digest
            }
        };
        const rawKey = await crypto.subtle.importKey("raw", $9f47737dbcb00cbc$require$fromString(password), {
            name: "PBKDF2"
        }, false, [
            "deriveKey",
            "deriveBits"
        ]);
        const cryptoKey = await crypto.subtle.deriveKey(deriveParams, rawKey, {
            name: algorithm,
            length: keyLength
        }, true, [
            "decrypt"
        ]);
        // Decrypt the string.
        const plaintext = await crypto.subtle.decrypt(aesGcm, cryptoKey, ciphertext);
        return new Uint8Array(plaintext);
    }
    return {
        encrypt: encrypt,
        decrypt: decrypt
    };
}
module.exports = {
    create: $9f47737dbcb00cbc$var$create
};

});
parcelRequire.register("0NrO2", function(module, exports) {

$parcel$export(module.exports, "get", () => $00265b714d7d533e$export$3988ae62b71be9a3, (v) => $00265b714d7d533e$export$3988ae62b71be9a3 = v);
/* eslint-env browser */ // Check native crypto exists and is enabled (In insecure context `self.crypto`
// exists but `self.crypto.subtle` does not).
var $00265b714d7d533e$export$3988ae62b71be9a3;
"use strict";
$00265b714d7d533e$export$3988ae62b71be9a3 = (win = globalThis)=>{
    const nativeCrypto = win.crypto;
    if (!nativeCrypto || !nativeCrypto.subtle) throw Object.assign(new Error("Missing Web Crypto API. The most likely cause of this error is that this page is being accessed from an insecure context (i.e. not HTTPS). For more information and possible resolutions see https://github.com/libp2p/js-libp2p-crypto/blob/master/README.md#web-crypto-api"), {
        code: "ERR_MISSING_WEB_CRYPTO"
    });
    return nativeCrypto;
};

});



parcelRequire.register("1B3jR", function(module, exports) {
"use strict";

var $gTOvd = parcelRequire("gTOvd");
var $129bd24a5c2594db$require$sha256 = $gTOvd.sha256;

var $20Lm5 = parcelRequire("20Lm5");

var $ijWXY = parcelRequire("ijWXY");
var $129bd24a5c2594db$require$uint8ArrayEquals = $ijWXY.equals;

var $6rBCs = parcelRequire("6rBCs");
var $129bd24a5c2594db$require$uint8ArrayToString = $6rBCs.toString;
parcelRequire("7qptS");

var $hSPkV = parcelRequire("hSPkV");

var $aqP8j = parcelRequire("aqP8j");

var $6pYeq = parcelRequire("6pYeq");

var $cTBSA = parcelRequire("cTBSA");
class $129bd24a5c2594db$var$RsaPublicKey {
    constructor(key){
        this._key = key;
    }
    async verify(data, sig) {
        return $aqP8j.hashAndVerify(this._key, sig, data);
    }
    marshal() {
        return $aqP8j.utils.jwkToPkix(this._key);
    }
    get bytes() {
        return $6pYeq.PublicKey.encode({
            Type: $6pYeq.KeyType.RSA,
            Data: this.marshal()
        }).finish();
    }
    encrypt(bytes) {
        return $aqP8j.encrypt(this._key, bytes);
    }
    equals(key) {
        return $129bd24a5c2594db$require$uint8ArrayEquals(this.bytes, key.bytes);
    }
    async hash() {
        const { bytes: bytes } = await $129bd24a5c2594db$require$sha256.digest(this.bytes);
        return bytes;
    }
}
class $129bd24a5c2594db$var$RsaPrivateKey {
    // key       - Object of the jwk format
    // publicKey - Uint8Array of the spki format
    constructor(key, publicKey){
        this._key = key;
        this._publicKey = publicKey;
    }
    genSecret() {
        return $aqP8j.getRandomValues(16);
    }
    async sign(message) {
        return $aqP8j.hashAndSign(this._key, message);
    }
    get public() {
        if (!this._publicKey) throw $20Lm5(new Error("public key not provided"), "ERR_PUBKEY_NOT_PROVIDED");
        return new $129bd24a5c2594db$var$RsaPublicKey(this._publicKey);
    }
    decrypt(bytes) {
        return $aqP8j.decrypt(this._key, bytes);
    }
    marshal() {
        return $aqP8j.utils.jwkToPkcs1(this._key);
    }
    get bytes() {
        return $6pYeq.PrivateKey.encode({
            Type: $6pYeq.KeyType.RSA,
            Data: this.marshal()
        }).finish();
    }
    equals(key) {
        return $129bd24a5c2594db$require$uint8ArrayEquals(this.bytes, key.bytes);
    }
    async hash() {
        const { bytes: bytes } = await $129bd24a5c2594db$require$sha256.digest(this.bytes);
        return bytes;
    }
    /**
   * Gets the ID of the key.
   *
   * The key id is the base58 encoding of the SHA-256 multihash of its public key.
   * The public key is a protobuf encoding containing a type and the DER encoding
   * of the PKCS SubjectPublicKeyInfo.
   *
   * @returns {Promise<string>}
   */ async id() {
        const hash = await this.public.hash();
        return $129bd24a5c2594db$require$uint8ArrayToString(hash, "base58btc");
    }
    /**
   * Exports the key into a password protected PEM format
   *
   * @param {string} password - The password to read the encrypted PEM
   * @param {string} [format=pkcs-8] - The format in which to export as
   */ async export(password, format = "pkcs-8") {
        if (format === "pkcs-8") {
            const buffer = new $hSPkV.util.ByteBuffer(this.marshal());
            const asn1 = $hSPkV.asn1.fromDer(buffer);
            const privateKey = $hSPkV.pki.privateKeyFromAsn1(asn1);
            const options = {
                algorithm: "aes256",
                count: 10000,
                saltSize: 16,
                prfAlgorithm: "sha512"
            };
            return $hSPkV.pki.encryptRsaPrivateKey(privateKey, password, options);
        } else if (format === "libp2p-key") return $cTBSA.export(this.bytes, password);
        else throw $20Lm5(new Error(`export format '${format}' is not supported`), "ERR_INVALID_EXPORT_FORMAT");
    }
}
async function $129bd24a5c2594db$var$unmarshalRsaPrivateKey(bytes) {
    const jwk = $aqP8j.utils.pkcs1ToJwk(bytes);
    const keys = await $aqP8j.unmarshalPrivateKey(jwk);
    return new $129bd24a5c2594db$var$RsaPrivateKey(keys.privateKey, keys.publicKey);
}
function $129bd24a5c2594db$var$unmarshalRsaPublicKey(bytes) {
    const jwk = $aqP8j.utils.pkixToJwk(bytes);
    return new $129bd24a5c2594db$var$RsaPublicKey(jwk);
}
async function $129bd24a5c2594db$var$fromJwk(jwk) {
    const keys = await $aqP8j.unmarshalPrivateKey(jwk);
    return new $129bd24a5c2594db$var$RsaPrivateKey(keys.privateKey, keys.publicKey);
}
async function $129bd24a5c2594db$var$generateKeyPair(bits) {
    const keys = await $aqP8j.generateKey(bits);
    return new $129bd24a5c2594db$var$RsaPrivateKey(keys.privateKey, keys.publicKey);
}
module.exports = {
    RsaPublicKey: $129bd24a5c2594db$var$RsaPublicKey,
    RsaPrivateKey: $129bd24a5c2594db$var$RsaPrivateKey,
    unmarshalRsaPublicKey: $129bd24a5c2594db$var$unmarshalRsaPublicKey,
    unmarshalRsaPrivateKey: $129bd24a5c2594db$var$unmarshalRsaPrivateKey,
    generateKeyPair: $129bd24a5c2594db$var$generateKeyPair,
    fromJwk: $129bd24a5c2594db$var$fromJwk
};

});
parcelRequire.register("7qptS", function(module, exports) {
/**
 * Secure Hash Algorithm with a 1024-bit block size implementation.
 *
 * This includes: SHA-512, SHA-384, SHA-512/224, and SHA-512/256. For
 * SHA-256 (block size 512 bits), see sha256.js.
 *
 * See FIPS 180-4 for details.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2014-2015 Digital Bazaar, Inc.
 */ 
var $hSPkV = parcelRequire("hSPkV");
parcelRequire("jCulq");
parcelRequire("3lPw4");
var $567eba182b91134a$var$sha512 = module.exports = $hSPkV.sha512 = $hSPkV.sha512 || {};
// SHA-512
$hSPkV.md.sha512 = $hSPkV.md.algorithms.sha512 = $567eba182b91134a$var$sha512;
// SHA-384
var $567eba182b91134a$var$sha384 = $hSPkV.sha384 = $hSPkV.sha512.sha384 = $hSPkV.sha512.sha384 || {};
$567eba182b91134a$var$sha384.create = function() {
    return $567eba182b91134a$var$sha512.create("SHA-384");
};
$hSPkV.md.sha384 = $hSPkV.md.algorithms.sha384 = $567eba182b91134a$var$sha384;
// SHA-512/256
$hSPkV.sha512.sha256 = $hSPkV.sha512.sha256 || {
    create: function() {
        return $567eba182b91134a$var$sha512.create("SHA-512/256");
    }
};
$hSPkV.md["sha512/256"] = $hSPkV.md.algorithms["sha512/256"] = $hSPkV.sha512.sha256;
// SHA-512/224
$hSPkV.sha512.sha224 = $hSPkV.sha512.sha224 || {
    create: function() {
        return $567eba182b91134a$var$sha512.create("SHA-512/224");
    }
};
$hSPkV.md["sha512/224"] = $hSPkV.md.algorithms["sha512/224"] = $hSPkV.sha512.sha224;
/**
 * Creates a SHA-2 message digest object.
 *
 * @param algorithm the algorithm to use (SHA-512, SHA-384, SHA-512/224,
 *          SHA-512/256).
 *
 * @return a message digest object.
 */ $567eba182b91134a$var$sha512.create = function(algorithm) {
    // do initialization as necessary
    if (!$567eba182b91134a$var$_initialized) $567eba182b91134a$var$_init();
    if (typeof algorithm === "undefined") algorithm = "SHA-512";
    if (!(algorithm in $567eba182b91134a$var$_states)) throw new Error("Invalid SHA-512 algorithm: " + algorithm);
    // SHA-512 state contains eight 64-bit integers (each as two 32-bit ints)
    var _state = $567eba182b91134a$var$_states[algorithm];
    var _h = null;
    // input buffer
    var _input = $hSPkV.util.createBuffer();
    // used for 64-bit word storage
    var _w = new Array(80);
    for(var wi = 0; wi < 80; ++wi)_w[wi] = new Array(2);
    // determine digest length by algorithm name (default)
    var digestLength = 64;
    switch(algorithm){
        case "SHA-384":
            digestLength = 48;
            break;
        case "SHA-512/256":
            digestLength = 32;
            break;
        case "SHA-512/224":
            digestLength = 28;
            break;
    }
    // message digest object
    var md = {
        // SHA-512 => sha512
        algorithm: algorithm.replace("-", "").toLowerCase(),
        blockLength: 128,
        digestLength: digestLength,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 16
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength128 for backwards-compatibility)
        md.fullMessageLength = md.messageLength128 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $hSPkV.util.createBuffer();
        _h = new Array(_state.length);
        for(var i = 0; i < _state.length; ++i)_h[i] = _state[i].slice(0);
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === "utf8") msg = $hSPkV.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $567eba182b91134a$var$_update(_h, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate SHA-512 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 896 mod 1024. In other words,
    the data to be digested must be a multiple of 1024 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 16 bytes (128
    bits), that means that the last segment of the data must have 112 bytes
    (896 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 896 mod 1024 because
    1024 - 128 = 896.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 896 mod 1024, then 1024 padding bits must be added. */ var finalBlock = $hSPkV.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($567eba182b91134a$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in big-endian order; since length
        // is stored in bytes we multiply by 8 and add carry from next int
        var next, carry;
        var bits = md.fullMessageLength[0] * 8;
        for(var i = 0; i < md.fullMessageLength.length - 1; ++i){
            next = md.fullMessageLength[i + 1] * 8;
            carry = next / 0x100000000 >>> 0;
            bits += carry;
            finalBlock.putInt32(bits >>> 0);
            bits = next >>> 0;
        }
        finalBlock.putInt32(bits);
        var h = new Array(_h.length);
        for(var i = 0; i < _h.length; ++i)h[i] = _h[i].slice(0);
        $567eba182b91134a$var$_update(h, _w, finalBlock);
        var rval = $hSPkV.util.createBuffer();
        var hlen;
        if (algorithm === "SHA-512") hlen = h.length;
        else if (algorithm === "SHA-384") hlen = h.length - 2;
        else hlen = h.length - 4;
        for(var i = 0; i < hlen; ++i){
            rval.putInt32(h[i][0]);
            if (i !== hlen - 1 || algorithm !== "SHA-512/224") rval.putInt32(h[i][1]);
        }
        return rval;
    };
    return md;
};
// sha-512 padding bytes not initialized yet
var $567eba182b91134a$var$_padding = null;
var $567eba182b91134a$var$_initialized = false;
// table of constants
var $567eba182b91134a$var$_k = null;
// initial hash states
var $567eba182b91134a$var$_states = null;
/**
 * Initializes the constant tables.
 */ function $567eba182b91134a$var$_init() {
    // create padding
    $567eba182b91134a$var$_padding = String.fromCharCode(128);
    $567eba182b91134a$var$_padding += $hSPkV.util.fillString(String.fromCharCode(0x00), 128);
    // create K table for SHA-512
    $567eba182b91134a$var$_k = [
        [
            0x428a2f98,
            0xd728ae22
        ],
        [
            0x71374491,
            0x23ef65cd
        ],
        [
            0xb5c0fbcf,
            0xec4d3b2f
        ],
        [
            0xe9b5dba5,
            0x8189dbbc
        ],
        [
            0x3956c25b,
            0xf348b538
        ],
        [
            0x59f111f1,
            0xb605d019
        ],
        [
            0x923f82a4,
            0xaf194f9b
        ],
        [
            0xab1c5ed5,
            0xda6d8118
        ],
        [
            0xd807aa98,
            0xa3030242
        ],
        [
            0x12835b01,
            0x45706fbe
        ],
        [
            0x243185be,
            0x4ee4b28c
        ],
        [
            0x550c7dc3,
            0xd5ffb4e2
        ],
        [
            0x72be5d74,
            0xf27b896f
        ],
        [
            0x80deb1fe,
            0x3b1696b1
        ],
        [
            0x9bdc06a7,
            0x25c71235
        ],
        [
            0xc19bf174,
            0xcf692694
        ],
        [
            0xe49b69c1,
            0x9ef14ad2
        ],
        [
            0xefbe4786,
            0x384f25e3
        ],
        [
            0x0fc19dc6,
            0x8b8cd5b5
        ],
        [
            0x240ca1cc,
            0x77ac9c65
        ],
        [
            0x2de92c6f,
            0x592b0275
        ],
        [
            0x4a7484aa,
            0x6ea6e483
        ],
        [
            0x5cb0a9dc,
            0xbd41fbd4
        ],
        [
            0x76f988da,
            0x831153b5
        ],
        [
            0x983e5152,
            0xee66dfab
        ],
        [
            0xa831c66d,
            0x2db43210
        ],
        [
            0xb00327c8,
            0x98fb213f
        ],
        [
            0xbf597fc7,
            0xbeef0ee4
        ],
        [
            0xc6e00bf3,
            0x3da88fc2
        ],
        [
            0xd5a79147,
            0x930aa725
        ],
        [
            0x06ca6351,
            0xe003826f
        ],
        [
            0x14292967,
            0x0a0e6e70
        ],
        [
            0x27b70a85,
            0x46d22ffc
        ],
        [
            0x2e1b2138,
            0x5c26c926
        ],
        [
            0x4d2c6dfc,
            0x5ac42aed
        ],
        [
            0x53380d13,
            0x9d95b3df
        ],
        [
            0x650a7354,
            0x8baf63de
        ],
        [
            0x766a0abb,
            0x3c77b2a8
        ],
        [
            0x81c2c92e,
            0x47edaee6
        ],
        [
            0x92722c85,
            0x1482353b
        ],
        [
            0xa2bfe8a1,
            0x4cf10364
        ],
        [
            0xa81a664b,
            0xbc423001
        ],
        [
            0xc24b8b70,
            0xd0f89791
        ],
        [
            0xc76c51a3,
            0x0654be30
        ],
        [
            0xd192e819,
            0xd6ef5218
        ],
        [
            0xd6990624,
            0x5565a910
        ],
        [
            0xf40e3585,
            0x5771202a
        ],
        [
            0x106aa070,
            0x32bbd1b8
        ],
        [
            0x19a4c116,
            0xb8d2d0c8
        ],
        [
            0x1e376c08,
            0x5141ab53
        ],
        [
            0x2748774c,
            0xdf8eeb99
        ],
        [
            0x34b0bcb5,
            0xe19b48a8
        ],
        [
            0x391c0cb3,
            0xc5c95a63
        ],
        [
            0x4ed8aa4a,
            0xe3418acb
        ],
        [
            0x5b9cca4f,
            0x7763e373
        ],
        [
            0x682e6ff3,
            0xd6b2b8a3
        ],
        [
            0x748f82ee,
            0x5defb2fc
        ],
        [
            0x78a5636f,
            0x43172f60
        ],
        [
            0x84c87814,
            0xa1f0ab72
        ],
        [
            0x8cc70208,
            0x1a6439ec
        ],
        [
            0x90befffa,
            0x23631e28
        ],
        [
            0xa4506ceb,
            0xde82bde9
        ],
        [
            0xbef9a3f7,
            0xb2c67915
        ],
        [
            0xc67178f2,
            0xe372532b
        ],
        [
            0xca273ece,
            0xea26619c
        ],
        [
            0xd186b8c7,
            0x21c0c207
        ],
        [
            0xeada7dd6,
            0xcde0eb1e
        ],
        [
            0xf57d4f7f,
            0xee6ed178
        ],
        [
            0x06f067aa,
            0x72176fba
        ],
        [
            0x0a637dc5,
            0xa2c898a6
        ],
        [
            0x113f9804,
            0xbef90dae
        ],
        [
            0x1b710b35,
            0x131c471b
        ],
        [
            0x28db77f5,
            0x23047d84
        ],
        [
            0x32caab7b,
            0x40c72493
        ],
        [
            0x3c9ebe0a,
            0x15c9bebc
        ],
        [
            0x431d67c4,
            0x9c100d4c
        ],
        [
            0x4cc5d4be,
            0xcb3e42b6
        ],
        [
            0x597f299c,
            0xfc657e2a
        ],
        [
            0x5fcb6fab,
            0x3ad6faec
        ],
        [
            0x6c44198c,
            0x4a475817
        ]
    ];
    // initial hash states
    $567eba182b91134a$var$_states = {};
    $567eba182b91134a$var$_states["SHA-512"] = [
        [
            0x6a09e667,
            0xf3bcc908
        ],
        [
            0xbb67ae85,
            0x84caa73b
        ],
        [
            0x3c6ef372,
            0xfe94f82b
        ],
        [
            0xa54ff53a,
            0x5f1d36f1
        ],
        [
            0x510e527f,
            0xade682d1
        ],
        [
            0x9b05688c,
            0x2b3e6c1f
        ],
        [
            0x1f83d9ab,
            0xfb41bd6b
        ],
        [
            0x5be0cd19,
            0x137e2179
        ]
    ];
    $567eba182b91134a$var$_states["SHA-384"] = [
        [
            0xcbbb9d5d,
            0xc1059ed8
        ],
        [
            0x629a292a,
            0x367cd507
        ],
        [
            0x9159015a,
            0x3070dd17
        ],
        [
            0x152fecd8,
            0xf70e5939
        ],
        [
            0x67332667,
            0xffc00b31
        ],
        [
            0x8eb44a87,
            0x68581511
        ],
        [
            0xdb0c2e0d,
            0x64f98fa7
        ],
        [
            0x47b5481d,
            0xbefa4fa4
        ]
    ];
    $567eba182b91134a$var$_states["SHA-512/256"] = [
        [
            0x22312194,
            0xFC2BF72C
        ],
        [
            0x9F555FA3,
            0xC84C64C2
        ],
        [
            0x2393B86B,
            0x6F53B151
        ],
        [
            0x96387719,
            0x5940EABD
        ],
        [
            0x96283EE2,
            0xA88EFFE3
        ],
        [
            0xBE5E1E25,
            0x53863992
        ],
        [
            0x2B0199FC,
            0x2C85B8AA
        ],
        [
            0x0EB72DDC,
            0x81C52CA2
        ]
    ];
    $567eba182b91134a$var$_states["SHA-512/224"] = [
        [
            0x8C3D37C8,
            0x19544DA2
        ],
        [
            0x73E19966,
            0x89DCD4D6
        ],
        [
            0x1DFAB7AE,
            0x32FF9C82
        ],
        [
            0x679DD514,
            0x582F9FCF
        ],
        [
            0x0F6D2B69,
            0x7BD44DA8
        ],
        [
            0x77E36F73,
            0x04C48942
        ],
        [
            0x3F9D85A8,
            0x6A1D36C8
        ],
        [
            0x1112E6AD,
            0x91D692A1
        ]
    ];
    // now initialized
    $567eba182b91134a$var$_initialized = true;
}
/**
 * Updates a SHA-512 state with the given byte buffer.
 *
 * @param s the SHA-512 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $567eba182b91134a$var$_update(s, w, bytes) {
    // consume 512 bit (128 byte) chunks
    var t1_hi, t1_lo;
    var t2_hi, t2_lo;
    var s0_hi, s0_lo;
    var s1_hi, s1_lo;
    var ch_hi, ch_lo;
    var maj_hi, maj_lo;
    var a_hi, a_lo;
    var b_hi, b_lo;
    var c_hi, c_lo;
    var d_hi, d_lo;
    var e_hi, e_lo;
    var f_hi, f_lo;
    var g_hi, g_lo;
    var h_hi, h_lo;
    var i, hi, lo, w2, w7, w15, w16;
    var len = bytes.length();
    while(len >= 128){
        // the w array will be populated with sixteen 64-bit big-endian words
        // and then extended into 64 64-bit words according to SHA-512
        for(i = 0; i < 16; ++i){
            w[i][0] = bytes.getInt32() >>> 0;
            w[i][1] = bytes.getInt32() >>> 0;
        }
        for(; i < 80; ++i){
            // for word 2 words ago: ROTR 19(x) ^ ROTR 61(x) ^ SHR 6(x)
            w2 = w[i - 2];
            hi = w2[0];
            lo = w2[1];
            // high bits
            t1_hi = ((hi >>> 19 | lo << 13) ^ // ROTR 19
            (lo >>> 29 | hi << 3) ^ // ROTR 61/(swap + ROTR 29)
            hi >>> 6) >>> 0; // SHR 6
            // low bits
            t1_lo = ((hi << 13 | lo >>> 19) ^ // ROTR 19
            (lo << 3 | hi >>> 29) ^ // ROTR 61/(swap + ROTR 29)
            (hi << 26 | lo >>> 6)) >>> 0; // SHR 6
            // for word 15 words ago: ROTR 1(x) ^ ROTR 8(x) ^ SHR 7(x)
            w15 = w[i - 15];
            hi = w15[0];
            lo = w15[1];
            // high bits
            t2_hi = ((hi >>> 1 | lo << 31) ^ // ROTR 1
            (hi >>> 8 | lo << 24) ^ // ROTR 8
            hi >>> 7) >>> 0; // SHR 7
            // low bits
            t2_lo = ((hi << 31 | lo >>> 1) ^ // ROTR 1
            (hi << 24 | lo >>> 8) ^ // ROTR 8
            (hi << 25 | lo >>> 7)) >>> 0; // SHR 7
            // sum(t1, word 7 ago, t2, word 16 ago) modulo 2^64 (carry lo overflow)
            w7 = w[i - 7];
            w16 = w[i - 16];
            lo = t1_lo + w7[1] + t2_lo + w16[1];
            w[i][0] = t1_hi + w7[0] + t2_hi + w16[0] + (lo / 0x100000000 >>> 0) >>> 0;
            w[i][1] = lo >>> 0;
        }
        // initialize hash value for this chunk
        a_hi = s[0][0];
        a_lo = s[0][1];
        b_hi = s[1][0];
        b_lo = s[1][1];
        c_hi = s[2][0];
        c_lo = s[2][1];
        d_hi = s[3][0];
        d_lo = s[3][1];
        e_hi = s[4][0];
        e_lo = s[4][1];
        f_hi = s[5][0];
        f_lo = s[5][1];
        g_hi = s[6][0];
        g_lo = s[6][1];
        h_hi = s[7][0];
        h_lo = s[7][1];
        // round function
        for(i = 0; i < 80; ++i){
            // Sum1(e) = ROTR 14(e) ^ ROTR 18(e) ^ ROTR 41(e)
            s1_hi = ((e_hi >>> 14 | e_lo << 18) ^ // ROTR 14
            (e_hi >>> 18 | e_lo << 14) ^ // ROTR 18
            (e_lo >>> 9 | e_hi << 23)) >>> 0; // ROTR 41/(swap + ROTR 9)
            s1_lo = ((e_hi << 18 | e_lo >>> 14) ^ // ROTR 14
            (e_hi << 14 | e_lo >>> 18) ^ // ROTR 18
            (e_lo << 23 | e_hi >>> 9)) >>> 0; // ROTR 41/(swap + ROTR 9)
            // Ch(e, f, g) (optimized the same way as SHA-1)
            ch_hi = (g_hi ^ e_hi & (f_hi ^ g_hi)) >>> 0;
            ch_lo = (g_lo ^ e_lo & (f_lo ^ g_lo)) >>> 0;
            // Sum0(a) = ROTR 28(a) ^ ROTR 34(a) ^ ROTR 39(a)
            s0_hi = ((a_hi >>> 28 | a_lo << 4) ^ // ROTR 28
            (a_lo >>> 2 | a_hi << 30) ^ // ROTR 34/(swap + ROTR 2)
            (a_lo >>> 7 | a_hi << 25)) >>> 0; // ROTR 39/(swap + ROTR 7)
            s0_lo = ((a_hi << 4 | a_lo >>> 28) ^ // ROTR 28
            (a_lo << 30 | a_hi >>> 2) ^ // ROTR 34/(swap + ROTR 2)
            (a_lo << 25 | a_hi >>> 7)) >>> 0; // ROTR 39/(swap + ROTR 7)
            // Maj(a, b, c) (optimized the same way as SHA-1)
            maj_hi = (a_hi & b_hi | c_hi & (a_hi ^ b_hi)) >>> 0;
            maj_lo = (a_lo & b_lo | c_lo & (a_lo ^ b_lo)) >>> 0;
            // main algorithm
            // t1 = (h + s1 + ch + _k[i] + _w[i]) modulo 2^64 (carry lo overflow)
            lo = h_lo + s1_lo + ch_lo + $567eba182b91134a$var$_k[i][1] + w[i][1];
            t1_hi = h_hi + s1_hi + ch_hi + $567eba182b91134a$var$_k[i][0] + w[i][0] + (lo / 0x100000000 >>> 0) >>> 0;
            t1_lo = lo >>> 0;
            // t2 = s0 + maj modulo 2^64 (carry lo overflow)
            lo = s0_lo + maj_lo;
            t2_hi = s0_hi + maj_hi + (lo / 0x100000000 >>> 0) >>> 0;
            t2_lo = lo >>> 0;
            h_hi = g_hi;
            h_lo = g_lo;
            g_hi = f_hi;
            g_lo = f_lo;
            f_hi = e_hi;
            f_lo = e_lo;
            // e = (d + t1) modulo 2^64 (carry lo overflow)
            lo = d_lo + t1_lo;
            e_hi = d_hi + t1_hi + (lo / 0x100000000 >>> 0) >>> 0;
            e_lo = lo >>> 0;
            d_hi = c_hi;
            d_lo = c_lo;
            c_hi = b_hi;
            c_lo = b_lo;
            b_hi = a_hi;
            b_lo = a_lo;
            // a = (t1 + t2) modulo 2^64 (carry lo overflow)
            lo = t1_lo + t2_lo;
            a_hi = t1_hi + t2_hi + (lo / 0x100000000 >>> 0) >>> 0;
            a_lo = lo >>> 0;
        }
        // update hash state (additional modulo 2^64)
        lo = s[0][1] + a_lo;
        s[0][0] = s[0][0] + a_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[0][1] = lo >>> 0;
        lo = s[1][1] + b_lo;
        s[1][0] = s[1][0] + b_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[1][1] = lo >>> 0;
        lo = s[2][1] + c_lo;
        s[2][0] = s[2][0] + c_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[2][1] = lo >>> 0;
        lo = s[3][1] + d_lo;
        s[3][0] = s[3][0] + d_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[3][1] = lo >>> 0;
        lo = s[4][1] + e_lo;
        s[4][0] = s[4][0] + e_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[4][1] = lo >>> 0;
        lo = s[5][1] + f_lo;
        s[5][0] = s[5][0] + f_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[5][1] = lo >>> 0;
        lo = s[6][1] + g_lo;
        s[6][0] = s[6][0] + g_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[6][1] = lo >>> 0;
        lo = s[7][1] + h_lo;
        s[7][0] = s[7][0] + h_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[7][1] = lo >>> 0;
        len -= 128;
    }
}

});

parcelRequire.register("aqP8j", function(module, exports) {

$parcel$export(module.exports, "utils", () => $7983ff121727acfa$export$eab97d15b1788b8d, (v) => $7983ff121727acfa$export$eab97d15b1788b8d = v);
$parcel$export(module.exports, "generateKey", () => $7983ff121727acfa$export$3a7728e868aa3ebd, (v) => $7983ff121727acfa$export$3a7728e868aa3ebd = v);
$parcel$export(module.exports, "unmarshalPrivateKey", () => $7983ff121727acfa$export$11dd448d4d042aab, (v) => $7983ff121727acfa$export$11dd448d4d042aab = v);
$parcel$export(module.exports, "getRandomValues", () => $7983ff121727acfa$export$960b9ff25e7d4257, (v) => $7983ff121727acfa$export$960b9ff25e7d4257 = v);
$parcel$export(module.exports, "hashAndSign", () => $7983ff121727acfa$export$cc7d6a37d08cb106, (v) => $7983ff121727acfa$export$cc7d6a37d08cb106 = v);
$parcel$export(module.exports, "hashAndVerify", () => $7983ff121727acfa$export$619cff377ee92930, (v) => $7983ff121727acfa$export$619cff377ee92930 = v);
$parcel$export(module.exports, "encrypt", () => $7983ff121727acfa$export$5b0f6292f11d1d18, (v) => $7983ff121727acfa$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $7983ff121727acfa$export$e85a0c9a1067c5d3, (v) => $7983ff121727acfa$export$e85a0c9a1067c5d3 = v);
var $7983ff121727acfa$export$eab97d15b1788b8d;
var $7983ff121727acfa$export$3a7728e868aa3ebd;
// Takes a jwk key
var $7983ff121727acfa$export$11dd448d4d042aab;
var $7983ff121727acfa$export$960b9ff25e7d4257;
var $7983ff121727acfa$export$cc7d6a37d08cb106;
var $7983ff121727acfa$export$619cff377ee92930;
var $7983ff121727acfa$export$5b0f6292f11d1d18;
var $7983ff121727acfa$export$e85a0c9a1067c5d3;
"use strict";

var $0NrO2 = parcelRequire("0NrO2");

var $3b0KS = parcelRequire("3b0KS");

var $6rBCs = parcelRequire("6rBCs");
var $7983ff121727acfa$require$uint8ArrayToString = $6rBCs.toString;

var $8cWjP = parcelRequire("8cWjP");
var $7983ff121727acfa$require$uint8ArrayFromString = $8cWjP.fromString;

$7983ff121727acfa$export$eab97d15b1788b8d = (parcelRequire("7RygC"));
$7983ff121727acfa$export$3a7728e868aa3ebd = async function(bits) {
    const pair = await $0NrO2.get().subtle.generateKey({
        name: "RSASSA-PKCS1-v1_5",
        modulusLength: bits,
        publicExponent: new Uint8Array([
            0x01,
            0x00,
            0x01
        ]),
        hash: {
            name: "SHA-256"
        }
    }, true, [
        "sign",
        "verify"
    ]);
    const keys = await $7983ff121727acfa$var$exportKey(pair);
    return {
        privateKey: keys[0],
        publicKey: keys[1]
    };
};
$7983ff121727acfa$export$11dd448d4d042aab = async function(key) {
    const privateKey = await $0NrO2.get().subtle.importKey("jwk", key, {
        name: "RSASSA-PKCS1-v1_5",
        hash: {
            name: "SHA-256"
        }
    }, true, [
        "sign"
    ]);
    const pair = [
        privateKey,
        await $7983ff121727acfa$var$derivePublicFromPrivate(key)
    ];
    const keys = await $7983ff121727acfa$var$exportKey({
        privateKey: pair[0],
        publicKey: pair[1]
    });
    return {
        privateKey: keys[0],
        publicKey: keys[1]
    };
};
$7983ff121727acfa$export$960b9ff25e7d4257 = $3b0KS;
$7983ff121727acfa$export$cc7d6a37d08cb106 = async function(key, msg) {
    const privateKey = await $0NrO2.get().subtle.importKey("jwk", key, {
        name: "RSASSA-PKCS1-v1_5",
        hash: {
            name: "SHA-256"
        }
    }, false, [
        "sign"
    ]);
    const sig = await $0NrO2.get().subtle.sign({
        name: "RSASSA-PKCS1-v1_5"
    }, privateKey, Uint8Array.from(msg));
    return new Uint8Array(sig, sig.byteOffset, sig.byteLength);
};
$7983ff121727acfa$export$619cff377ee92930 = async function(key, sig, msg) {
    const publicKey = await $0NrO2.get().subtle.importKey("jwk", key, {
        name: "RSASSA-PKCS1-v1_5",
        hash: {
            name: "SHA-256"
        }
    }, false, [
        "verify"
    ]);
    return $0NrO2.get().subtle.verify({
        name: "RSASSA-PKCS1-v1_5"
    }, publicKey, sig, msg);
};
function $7983ff121727acfa$var$exportKey(pair) {
    return Promise.all([
        $0NrO2.get().subtle.exportKey("jwk", pair.privateKey),
        $0NrO2.get().subtle.exportKey("jwk", pair.publicKey)
    ]);
}
function $7983ff121727acfa$var$derivePublicFromPrivate(jwKey) {
    return $0NrO2.get().subtle.importKey("jwk", {
        kty: jwKey.kty,
        n: jwKey.n,
        e: jwKey.e
    }, {
        name: "RSASSA-PKCS1-v1_5",
        hash: {
            name: "SHA-256"
        }
    }, true, [
        "verify"
    ]);
}

var $11vKx = parcelRequire("11vKx");
var $7983ff121727acfa$require$jwk2pub = $11vKx.jwk2pub;
var $7983ff121727acfa$require$jwk2priv = $11vKx.jwk2priv;
function $7983ff121727acfa$var$convertKey(key, pub, msg, handle) {
    const fkey = pub ? $7983ff121727acfa$require$jwk2pub(key) : $7983ff121727acfa$require$jwk2priv(key);
    const fmsg = $7983ff121727acfa$require$uint8ArrayToString(Uint8Array.from(msg), "ascii");
    const fomsg = handle(fmsg, fkey);
    return $7983ff121727acfa$require$uint8ArrayFromString(fomsg, "ascii");
}
$7983ff121727acfa$export$5b0f6292f11d1d18 = function(key, msg) {
    return $7983ff121727acfa$var$convertKey(key, true, msg, (msg, key)=>key.encrypt(msg));
};
$7983ff121727acfa$export$e85a0c9a1067c5d3 = function(key, msg) {
    return $7983ff121727acfa$var$convertKey(key, false, msg, (msg, key)=>key.decrypt(msg));
};

});
parcelRequire.register("3b0KS", function(module, exports) {
"use strict";

var $6J93w = parcelRequire("6J93w");

var $20Lm5 = parcelRequire("20Lm5");
module.exports = function(length) {
    if (isNaN(length) || length <= 0) throw $20Lm5(new Error("random bytes length must be a Number bigger than 0"), "ERR_INVALID_LENGTH");
    return $6J93w(length);
};

});
parcelRequire.register("6J93w", function(module, exports) {
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
const $4e5df85d672966c5$var$MAX_BYTES = 65536;
/**
 * @param {number} size
 */ function $4e5df85d672966c5$var$randomBytes(size) {
    const bytes = new Uint8Array(size);
    let generated = 0;
    if (size > 0) {
        // getRandomValues fails on IE if size == 0
        if (size > $4e5df85d672966c5$var$MAX_BYTES) {
            while(generated < size)if (generated + $4e5df85d672966c5$var$MAX_BYTES > size) {
                crypto.getRandomValues(bytes.subarray(generated, generated + (size - generated)));
                generated += size - generated;
            } else {
                crypto.getRandomValues(bytes.subarray(generated, generated + $4e5df85d672966c5$var$MAX_BYTES));
                generated += $4e5df85d672966c5$var$MAX_BYTES;
            }
        } else crypto.getRandomValues(bytes);
    }
    return bytes;
}
module.exports = $4e5df85d672966c5$var$randomBytes;

});


parcelRequire.register("7RygC", function(module, exports) {

$parcel$export(module.exports, "pkcs1ToJwk", () => $5b981062291cc613$export$2c5c25417935aff2, (v) => $5b981062291cc613$export$2c5c25417935aff2 = v);
$parcel$export(module.exports, "jwkToPkcs1", () => $5b981062291cc613$export$d3c021755f04ee81, (v) => $5b981062291cc613$export$d3c021755f04ee81 = v);
$parcel$export(module.exports, "pkixToJwk", () => $5b981062291cc613$export$70fcaa90a80c2900, (v) => $5b981062291cc613$export$70fcaa90a80c2900 = v);
$parcel$export(module.exports, "jwkToPkix", () => $5b981062291cc613$export$1db1642be8afe525, (v) => $5b981062291cc613$export$1db1642be8afe525 = v);
// Convert a PKCS#1 in ASN1 DER format to a JWK key
var $5b981062291cc613$export$2c5c25417935aff2;
// Convert a JWK key into PKCS#1 in ASN1 DER format
var $5b981062291cc613$export$d3c021755f04ee81;
// Convert a PKCIX in ASN1 DER format to a JWK key
var $5b981062291cc613$export$70fcaa90a80c2900;
// Convert a JWK key to PKCIX in ASN1 DER format
var $5b981062291cc613$export$1db1642be8afe525;
"use strict";
parcelRequire("ehQqu");
parcelRequire("9Je9a");

var $hSPkV = parcelRequire("hSPkV");

var $lb3nT = parcelRequire("lb3nT");
var $5b981062291cc613$require$bigIntegerToUintBase64url = $lb3nT.bigIntegerToUintBase64url;
var $5b981062291cc613$require$base64urlToBigInteger = $lb3nT.base64urlToBigInteger;

var $8cWjP = parcelRequire("8cWjP");
var $5b981062291cc613$require$uint8ArrayFromString = $8cWjP.fromString;

var $6rBCs = parcelRequire("6rBCs");
var $5b981062291cc613$require$uint8ArrayToString = $6rBCs.toString;
$5b981062291cc613$export$2c5c25417935aff2 = function(bytes) {
    const asn1 = $hSPkV.asn1.fromDer($5b981062291cc613$require$uint8ArrayToString(bytes, "ascii"));
    const privateKey = $hSPkV.pki.privateKeyFromAsn1(asn1);
    // https://tools.ietf.org/html/rfc7518#section-6.3.1
    return {
        kty: "RSA",
        n: $5b981062291cc613$require$bigIntegerToUintBase64url(privateKey.n),
        e: $5b981062291cc613$require$bigIntegerToUintBase64url(privateKey.e),
        d: $5b981062291cc613$require$bigIntegerToUintBase64url(privateKey.d),
        p: $5b981062291cc613$require$bigIntegerToUintBase64url(privateKey.p),
        q: $5b981062291cc613$require$bigIntegerToUintBase64url(privateKey.q),
        dp: $5b981062291cc613$require$bigIntegerToUintBase64url(privateKey.dP),
        dq: $5b981062291cc613$require$bigIntegerToUintBase64url(privateKey.dQ),
        qi: $5b981062291cc613$require$bigIntegerToUintBase64url(privateKey.qInv),
        alg: "RS256",
        kid: "2011-04-29"
    };
};
$5b981062291cc613$export$d3c021755f04ee81 = function(jwk) {
    const asn1 = $hSPkV.pki.privateKeyToAsn1({
        n: $5b981062291cc613$require$base64urlToBigInteger(jwk.n),
        e: $5b981062291cc613$require$base64urlToBigInteger(jwk.e),
        d: $5b981062291cc613$require$base64urlToBigInteger(jwk.d),
        p: $5b981062291cc613$require$base64urlToBigInteger(jwk.p),
        q: $5b981062291cc613$require$base64urlToBigInteger(jwk.q),
        dP: $5b981062291cc613$require$base64urlToBigInteger(jwk.dp),
        dQ: $5b981062291cc613$require$base64urlToBigInteger(jwk.dq),
        qInv: $5b981062291cc613$require$base64urlToBigInteger(jwk.qi)
    });
    return $5b981062291cc613$require$uint8ArrayFromString($hSPkV.asn1.toDer(asn1).getBytes(), "ascii");
};
$5b981062291cc613$export$70fcaa90a80c2900 = function(bytes) {
    const asn1 = $hSPkV.asn1.fromDer($5b981062291cc613$require$uint8ArrayToString(bytes, "ascii"));
    const publicKey = $hSPkV.pki.publicKeyFromAsn1(asn1);
    return {
        kty: "RSA",
        n: $5b981062291cc613$require$bigIntegerToUintBase64url(publicKey.n),
        e: $5b981062291cc613$require$bigIntegerToUintBase64url(publicKey.e),
        alg: "RS256",
        kid: "2011-04-29"
    };
};
$5b981062291cc613$export$1db1642be8afe525 = function(jwk) {
    const asn1 = $hSPkV.pki.publicKeyToAsn1({
        n: $5b981062291cc613$require$base64urlToBigInteger(jwk.n),
        e: $5b981062291cc613$require$base64urlToBigInteger(jwk.e)
    });
    return $5b981062291cc613$require$uint8ArrayFromString($hSPkV.asn1.toDer(asn1).getBytes(), "ascii");
};

});
parcelRequire.register("lb3nT", function(module, exports) {

$parcel$export(module.exports, "bigIntegerToUintBase64url", () => $f6ad4025437f8114$export$975f12d8c59391f6, (v) => $f6ad4025437f8114$export$975f12d8c59391f6 = v);
$parcel$export(module.exports, "base64urlToBigInteger", () => $f6ad4025437f8114$export$560aa83c1da30c27, (v) => $f6ad4025437f8114$export$560aa83c1da30c27 = v);
$parcel$export(module.exports, "base64urlToBuffer", () => $f6ad4025437f8114$export$d203bea30aac4ae7, (v) => $f6ad4025437f8114$export$d203bea30aac4ae7 = v);
var $f6ad4025437f8114$export$975f12d8c59391f6;
// Convert a base64url encoded string to a BigInteger
var $f6ad4025437f8114$export$560aa83c1da30c27;
var $f6ad4025437f8114$export$d203bea30aac4ae7;
"use strict";
parcelRequire("3lPw4");
parcelRequire("cHVVU");

var $hSPkV = parcelRequire("hSPkV");

var $8cWjP = parcelRequire("8cWjP");
var $f6ad4025437f8114$require$uint8ArrayFromString = $8cWjP.fromString;

var $6rBCs = parcelRequire("6rBCs");
var $f6ad4025437f8114$require$uint8ArrayToString = $6rBCs.toString;

var $8hEBV = parcelRequire("8hEBV");
var $f6ad4025437f8114$require$uint8ArrayConcat = $8hEBV.concat;
$f6ad4025437f8114$export$975f12d8c59391f6 = (num, len)=>{
    // Call `.abs()` to convert to unsigned
    let buf = Uint8Array.from(num.abs().toByteArray()) // toByteArray converts to big endian
    ;
    // toByteArray() gives us back a signed array, which will include a leading 0
    // byte if the most significant bit of the number is 1:
    // https://docs.microsoft.com/en-us/windows/win32/seccertenroll/about-integer
    // Our number will always be positive so we should remove the leading padding.
    buf = buf[0] === 0 ? buf.slice(1) : buf;
    if (len != null) {
        if (buf.length > len) throw new Error("byte array longer than desired length");
        buf = $f6ad4025437f8114$require$uint8ArrayConcat([
            new Uint8Array(len - buf.length),
            buf
        ]);
    }
    return $f6ad4025437f8114$require$uint8ArrayToString(buf, "base64url");
};
$f6ad4025437f8114$export$560aa83c1da30c27 = (str)=>{
    const buf = $f6ad4025437f8114$export$d203bea30aac4ae7(str);
    return new $hSPkV.jsbn.BigInteger($f6ad4025437f8114$require$uint8ArrayToString(buf, "base16"), 16);
};
$f6ad4025437f8114$export$d203bea30aac4ae7 = (str, len)=>{
    let buf = $f6ad4025437f8114$require$uint8ArrayFromString(str, "base64urlpad");
    if (len != null) {
        if (buf.length > len) throw new Error("byte array longer than desired length");
        buf = $f6ad4025437f8114$require$uint8ArrayConcat([
            new Uint8Array(len - buf.length),
            buf
        ]);
    }
    return buf;
};

});


parcelRequire.register("11vKx", function(module, exports) {
"use strict";
parcelRequire("9Je9a");

var $hSPkV = parcelRequire("hSPkV");

var $lb3nT = parcelRequire("lb3nT");
var $0bee833c5d682732$require$base64urlToBigInteger = $lb3nT.base64urlToBigInteger;
function $0bee833c5d682732$var$convert(key, types) {
    return types.map((t)=>$0bee833c5d682732$require$base64urlToBigInteger(key[t]));
}
function $0bee833c5d682732$var$jwk2priv(key) {
    return $hSPkV.pki.setRsaPrivateKey(...$0bee833c5d682732$var$convert(key, [
        "n",
        "e",
        "d",
        "p",
        "q",
        "dp",
        "dq",
        "qi"
    ]));
}
function $0bee833c5d682732$var$jwk2pub(key) {
    return $hSPkV.pki.setRsaPublicKey(...$0bee833c5d682732$var$convert(key, [
        "n",
        "e"
    ]));
}
module.exports = {
    jwk2pub: $0bee833c5d682732$var$jwk2pub,
    jwk2priv: $0bee833c5d682732$var$jwk2priv
};

});


parcelRequire.register("cTBSA", function(module, exports) {
"use strict";

var $eXQx4 = parcelRequire("eXQx4");
var $9638012e0931d5b0$require$base64 = $eXQx4.base64;

var $dFQ0T = parcelRequire("dFQ0T");
module.exports = {
    /**
   * Exports the given PrivateKey as a base64 encoded string.
   * The PrivateKey is encrypted via a password derived PBKDF2 key
   * leveraging the aes-gcm cipher algorithm.
   *
   * @param {Uint8Array} privateKey - The PrivateKey protobuf
   * @param {string} password
   * @returns {Promise<string>} A base64 encoded string
   */ export: async function(privateKey, password) {
        const cipher = $dFQ0T.create();
        const encryptedKey = await cipher.encrypt(privateKey, password);
        return $9638012e0931d5b0$require$base64.encode(encryptedKey);
    }
};

});


parcelRequire.register("cBXX4", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $ijWXY = parcelRequire("ijWXY");
var $92e771e5968b2754$require$uint8ArrayEquals = $ijWXY.equals;

var $gTOvd = parcelRequire("gTOvd");
var $92e771e5968b2754$require$sha256 = $gTOvd.sha256;

var $fVtlC = parcelRequire("fVtlC");
var $92e771e5968b2754$require$base58btc = $fVtlC.base58btc;

var $klyrn = parcelRequire("klyrn");
var $92e771e5968b2754$require$identity = $klyrn.identity;

var $5y5v5 = parcelRequire("5y5v5");

var $6pYeq = parcelRequire("6pYeq");

var $cTBSA = parcelRequire("cTBSA");
class $92e771e5968b2754$var$Ed25519PublicKey {
    constructor(key){
        this._key = $92e771e5968b2754$var$ensureKey(key, $5y5v5.publicKeyLength);
    }
    async verify(data, sig) {
        return $5y5v5.hashAndVerify(this._key, sig, data);
    }
    marshal() {
        return this._key;
    }
    get bytes() {
        return $6pYeq.PublicKey.encode({
            Type: $6pYeq.KeyType.Ed25519,
            Data: this.marshal()
        }).finish();
    }
    equals(key) {
        return $92e771e5968b2754$require$uint8ArrayEquals(this.bytes, key.bytes);
    }
    async hash() {
        const { bytes: bytes } = await $92e771e5968b2754$require$sha256.digest(this.bytes);
        return bytes;
    }
}
class $92e771e5968b2754$var$Ed25519PrivateKey {
    // key       - 64 byte Uint8Array containing private key
    // publicKey - 32 byte Uint8Array containing public key
    constructor(key, publicKey){
        this._key = $92e771e5968b2754$var$ensureKey(key, $5y5v5.privateKeyLength);
        this._publicKey = $92e771e5968b2754$var$ensureKey(publicKey, $5y5v5.publicKeyLength);
    }
    async sign(message) {
        return $5y5v5.hashAndSign(this._key, message);
    }
    get public() {
        return new $92e771e5968b2754$var$Ed25519PublicKey(this._publicKey);
    }
    marshal() {
        return this._key;
    }
    get bytes() {
        return $6pYeq.PrivateKey.encode({
            Type: $6pYeq.KeyType.Ed25519,
            Data: this.marshal()
        }).finish();
    }
    equals(key) {
        return $92e771e5968b2754$require$uint8ArrayEquals(this.bytes, key.bytes);
    }
    async hash() {
        const { bytes: bytes } = await $92e771e5968b2754$require$sha256.digest(this.bytes);
        return bytes;
    }
    /**
   * Gets the ID of the key.
   *
   * The key id is the base58 encoding of the identity multihash containing its public key.
   * The public key is a protobuf encoding containing a type and the DER encoding
   * of the PKCS SubjectPublicKeyInfo.
   *
   * @returns {Promise<string>}
   */ async id() {
        const encoding = await $92e771e5968b2754$require$identity.digest(this.public.bytes);
        return $92e771e5968b2754$require$base58btc.encode(encoding.bytes).substring(1);
    }
    /**
   * Exports the key into a password protected `format`
   *
   * @param {string} password - The password to encrypt the key
   * @param {string} [format=libp2p-key] - The format in which to export as
   * @returns {Promise<Uint8Array>} The encrypted private key
   */ async export(password, format = "libp2p-key") {
        if (format === "libp2p-key") return $cTBSA.export(this.bytes, password);
        else throw $20Lm5(new Error(`export format '${format}' is not supported`), "ERR_INVALID_EXPORT_FORMAT");
    }
}
function $92e771e5968b2754$var$unmarshalEd25519PrivateKey(bytes) {
    // Try the old, redundant public key version
    if (bytes.length > $5y5v5.privateKeyLength) {
        bytes = $92e771e5968b2754$var$ensureKey(bytes, $5y5v5.privateKeyLength + $5y5v5.publicKeyLength);
        const privateKeyBytes = bytes.slice(0, $5y5v5.privateKeyLength);
        const publicKeyBytes = bytes.slice($5y5v5.privateKeyLength, bytes.length);
        return new $92e771e5968b2754$var$Ed25519PrivateKey(privateKeyBytes, publicKeyBytes);
    }
    bytes = $92e771e5968b2754$var$ensureKey(bytes, $5y5v5.privateKeyLength);
    const privateKeyBytes = bytes.slice(0, $5y5v5.privateKeyLength);
    const publicKeyBytes = bytes.slice($5y5v5.publicKeyLength);
    return new $92e771e5968b2754$var$Ed25519PrivateKey(privateKeyBytes, publicKeyBytes);
}
function $92e771e5968b2754$var$unmarshalEd25519PublicKey(bytes) {
    bytes = $92e771e5968b2754$var$ensureKey(bytes, $5y5v5.publicKeyLength);
    return new $92e771e5968b2754$var$Ed25519PublicKey(bytes);
}
async function $92e771e5968b2754$var$generateKeyPair() {
    const { privateKey: privateKey, publicKey: publicKey } = await $5y5v5.generateKey();
    return new $92e771e5968b2754$var$Ed25519PrivateKey(privateKey, publicKey);
}
async function $92e771e5968b2754$var$generateKeyPairFromSeed(seed) {
    const { privateKey: privateKey, publicKey: publicKey } = await $5y5v5.generateKeyFromSeed(seed);
    return new $92e771e5968b2754$var$Ed25519PrivateKey(privateKey, publicKey);
}
function $92e771e5968b2754$var$ensureKey(key, length) {
    key = Uint8Array.from(key || []);
    if (key.length !== length) throw $20Lm5(new Error(`Key must be a Uint8Array of length ${length}, got ${key.length}`), "ERR_INVALID_KEY_TYPE");
    return key;
}
module.exports = {
    Ed25519PublicKey: $92e771e5968b2754$var$Ed25519PublicKey,
    Ed25519PrivateKey: $92e771e5968b2754$var$Ed25519PrivateKey,
    unmarshalEd25519PrivateKey: $92e771e5968b2754$var$unmarshalEd25519PrivateKey,
    unmarshalEd25519PublicKey: $92e771e5968b2754$var$unmarshalEd25519PublicKey,
    generateKeyPair: $92e771e5968b2754$var$generateKeyPair,
    generateKeyPairFromSeed: $92e771e5968b2754$var$generateKeyPairFromSeed
};

});
parcelRequire.register("5y5v5", function(module, exports) {

$parcel$export(module.exports, "publicKeyLength", () => $40a464fb4a4e0989$export$5f4cfc08c63c83db, (v) => $40a464fb4a4e0989$export$5f4cfc08c63c83db = v);
$parcel$export(module.exports, "privateKeyLength", () => $40a464fb4a4e0989$export$646aa2db9f6f5fe, (v) => $40a464fb4a4e0989$export$646aa2db9f6f5fe = v);
$parcel$export(module.exports, "generateKey", () => $40a464fb4a4e0989$export$3a7728e868aa3ebd, (v) => $40a464fb4a4e0989$export$3a7728e868aa3ebd = v);
$parcel$export(module.exports, "generateKeyFromSeed", () => $40a464fb4a4e0989$export$47705f2da2f256b8, (v) => $40a464fb4a4e0989$export$47705f2da2f256b8 = v);
$parcel$export(module.exports, "hashAndSign", () => $40a464fb4a4e0989$export$cc7d6a37d08cb106, (v) => $40a464fb4a4e0989$export$cc7d6a37d08cb106 = v);
$parcel$export(module.exports, "hashAndVerify", () => $40a464fb4a4e0989$export$619cff377ee92930, (v) => $40a464fb4a4e0989$export$619cff377ee92930 = v);
var $40a464fb4a4e0989$export$5f4cfc08c63c83db;
var $40a464fb4a4e0989$export$646aa2db9f6f5fe;
var $40a464fb4a4e0989$export$3a7728e868aa3ebd;
/**
 * Generate keypair from a seed
 *
 * @param {Uint8Array} seed - seed should be a 32 byte uint8array
 * @returns
 */ var $40a464fb4a4e0989$export$47705f2da2f256b8;
var $40a464fb4a4e0989$export$cc7d6a37d08cb106;
var $40a464fb4a4e0989$export$619cff377ee92930;
"use strict";

var $ba3iX = parcelRequire("ba3iX");
const $40a464fb4a4e0989$var$PUBLIC_KEY_BYTE_LENGTH = 32;
const $40a464fb4a4e0989$var$PRIVATE_KEY_BYTE_LENGTH = 64 // private key is actually 32 bytes but for historical reasons we concat private and public keys
;
const $40a464fb4a4e0989$var$KEYS_BYTE_LENGTH = 32;
$40a464fb4a4e0989$export$5f4cfc08c63c83db = $40a464fb4a4e0989$var$PUBLIC_KEY_BYTE_LENGTH;
$40a464fb4a4e0989$export$646aa2db9f6f5fe = $40a464fb4a4e0989$var$PRIVATE_KEY_BYTE_LENGTH;
$40a464fb4a4e0989$export$3a7728e868aa3ebd = async function() {
    // the actual private key (32 bytes)
    const privateKeyRaw = $ba3iX.utils.randomPrivateKey();
    const publicKey = await $ba3iX.getPublicKey(privateKeyRaw);
    // concatenated the public key to the private key
    const privateKey = $40a464fb4a4e0989$var$concatKeys(privateKeyRaw, publicKey);
    return {
        privateKey: privateKey,
        publicKey: publicKey
    };
};
$40a464fb4a4e0989$export$47705f2da2f256b8 = async function(seed) {
    if (seed.length !== $40a464fb4a4e0989$var$KEYS_BYTE_LENGTH) throw new TypeError('"seed" must be 32 bytes in length.');
    else if (!(seed instanceof Uint8Array)) throw new TypeError('"seed" must be a node.js Buffer, or Uint8Array.');
    // based on node forges algorithm, the seed is used directly as private key
    const privateKeyRaw = seed;
    const publicKey = await $ba3iX.getPublicKey(privateKeyRaw);
    const privateKey = $40a464fb4a4e0989$var$concatKeys(privateKeyRaw, publicKey);
    return {
        privateKey: privateKey,
        publicKey: publicKey
    };
};
$40a464fb4a4e0989$export$cc7d6a37d08cb106 = function(privateKey, msg) {
    const privateKeyRaw = privateKey.slice(0, $40a464fb4a4e0989$var$KEYS_BYTE_LENGTH);
    return $ba3iX.sign(msg, privateKeyRaw);
};
$40a464fb4a4e0989$export$619cff377ee92930 = function(publicKey, sig, msg) {
    return $ba3iX.verify(sig, msg, publicKey);
};
function $40a464fb4a4e0989$var$concatKeys(privateKeyRaw, publicKey) {
    const privateKey = new Uint8Array($40a464fb4a4e0989$export$646aa2db9f6f5fe);
    for(let i = 0; i < $40a464fb4a4e0989$var$KEYS_BYTE_LENGTH; i++){
        privateKey[i] = privateKeyRaw[i];
        privateKey[$40a464fb4a4e0989$var$KEYS_BYTE_LENGTH + i] = publicKey[i];
    }
    return privateKey;
}

});
parcelRequire.register("ba3iX", function(module, exports) {

$parcel$export(module.exports, "utils", () => $82033121ab616fa7$export$eab97d15b1788b8d);
$parcel$export(module.exports, "getPublicKey", () => $82033121ab616fa7$export$889def73691f9837);
$parcel$export(module.exports, "sign", () => $82033121ab616fa7$export$c5552dfdbc7cec71);
$parcel$export(module.exports, "verify", () => $82033121ab616fa7$export$532244b5b8b0b4b6);
/*! noble-ed25519 - MIT License (c) 2019 Paul Miller (paulmillr.com) */ 
var $7jzxY = parcelRequire("7jzxY");
const $82033121ab616fa7$var$_0n = BigInt(0);
const $82033121ab616fa7$var$_1n = BigInt(1);
const $82033121ab616fa7$var$_2n = BigInt(2);
const $82033121ab616fa7$var$_8n = BigInt(8);
const $82033121ab616fa7$var$CU_O = BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989");
const $82033121ab616fa7$export$8ff8607b70325343 = Object.freeze({
    a: BigInt(-1),
    d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
    P: BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"),
    l: $82033121ab616fa7$var$CU_O,
    n: $82033121ab616fa7$var$CU_O,
    h: BigInt(8),
    Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
    Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960")
});
const $82033121ab616fa7$var$POW_2_256 = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000");
const $82033121ab616fa7$var$SQRT_M1 = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
const $82033121ab616fa7$var$SQRT_D = BigInt("6853475219497561581579357271197624642482790079785650197046958215289687604742");
const $82033121ab616fa7$var$SQRT_AD_MINUS_ONE = BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
const $82033121ab616fa7$var$INVSQRT_A_MINUS_D = BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
const $82033121ab616fa7$var$ONE_MINUS_D_SQ = BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
const $82033121ab616fa7$var$D_MINUS_ONE_SQ = BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
class $82033121ab616fa7$export$c82dbe8d384844da {
    constructor(x, y, z, t){
        this.x = x;
        this.y = y;
        this.z = z;
        this.t = t;
    }
    static fromAffine(p) {
        if (!(p instanceof $82033121ab616fa7$export$baf26146a414f24a)) throw new TypeError("ExtendedPoint#fromAffine: expected Point");
        if (p.equals($82033121ab616fa7$export$baf26146a414f24a.ZERO)) return $82033121ab616fa7$export$c82dbe8d384844da.ZERO;
        return new $82033121ab616fa7$export$c82dbe8d384844da(p.x, p.y, $82033121ab616fa7$var$_1n, $82033121ab616fa7$var$mod(p.x * p.y));
    }
    static toAffineBatch(points) {
        const toInv = $82033121ab616fa7$var$invertBatch(points.map((p)=>p.z));
        return points.map((p, i)=>p.toAffine(toInv[i]));
    }
    static normalizeZ(points) {
        return this.toAffineBatch(points).map(this.fromAffine);
    }
    equals(other) {
        $82033121ab616fa7$var$assertExtPoint(other);
        const { x: X1, y: Y1, z: Z1 } = this;
        const { x: X2, y: Y2, z: Z2 } = other;
        const X1Z2 = $82033121ab616fa7$var$mod(X1 * Z2);
        const X2Z1 = $82033121ab616fa7$var$mod(X2 * Z1);
        const Y1Z2 = $82033121ab616fa7$var$mod(Y1 * Z2);
        const Y2Z1 = $82033121ab616fa7$var$mod(Y2 * Z1);
        return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
    }
    negate() {
        return new $82033121ab616fa7$export$c82dbe8d384844da($82033121ab616fa7$var$mod(-this.x), this.y, this.z, $82033121ab616fa7$var$mod(-this.t));
    }
    double() {
        const { x: X1, y: Y1, z: Z1 } = this;
        const { a: a } = $82033121ab616fa7$export$8ff8607b70325343;
        const M = $82033121ab616fa7$var$mod;
        const A = M(X1 * X1);
        const B = M(Y1 * Y1);
        const C = M($82033121ab616fa7$var$_2n * M(Z1 * Z1));
        const D = M(a * A);
        const x1y1 = X1 + Y1;
        const E = M(M(x1y1 * x1y1) - A - B);
        const G = D + B;
        const F = G - C;
        const H = D - B;
        const X3 = M(E * F);
        const Y3 = M(G * H);
        const T3 = M(E * H);
        const Z3 = M(F * G);
        return new $82033121ab616fa7$export$c82dbe8d384844da(X3, Y3, Z3, T3);
    }
    add(other) {
        const { x: X1, y: Y1, z: Z1, t: T1 } = this;
        $82033121ab616fa7$var$assertExtPoint(other);
        const { x: X2, y: Y2, z: Z2, t: T2 } = other;
        const { a: a, d: d } = $82033121ab616fa7$export$8ff8607b70325343;
        const M = $82033121ab616fa7$var$mod;
        const A = M(X1 * X2);
        const B = M(Y1 * Y2);
        const C = M(T1 * d * T2);
        const D = M(Z1 * Z2);
        const E = M((X1 + Y1) * (X2 + Y2) - A - B);
        const F = M(D - C);
        const G = M(D + C);
        const H = M(B - a * A);
        const X3 = M(E * F);
        const Y3 = M(G * H);
        const T3 = M(E * H);
        const Z3 = M(F * G);
        return new $82033121ab616fa7$export$c82dbe8d384844da(X3, Y3, Z3, T3);
    }
    subtract(other) {
        return this.add(other.negate());
    }
    precomputeWindow(W) {
        const windows = 1 + 256 / W;
        const points = [];
        let p = this;
        let base = p;
        for(let window = 0; window < windows; window++){
            base = p;
            points.push(base);
            for(let i = 1; i < 2 ** (W - 1); i++){
                base = base.add(p);
                points.push(base);
            }
            p = base.double();
        }
        return points;
    }
    wNAF(n, affinePoint) {
        if (!affinePoint && this.equals($82033121ab616fa7$export$c82dbe8d384844da.BASE)) affinePoint = $82033121ab616fa7$export$baf26146a414f24a.BASE;
        const W = affinePoint && affinePoint._WINDOW_SIZE || 1;
        if (256 % W) throw new Error("Point#wNAF: Invalid precomputation window, must be power of 2");
        let precomputes = affinePoint && $82033121ab616fa7$var$pointPrecomputes.get(affinePoint);
        if (!precomputes) {
            precomputes = this.precomputeWindow(W);
            if (affinePoint && W !== 1) {
                precomputes = $82033121ab616fa7$export$c82dbe8d384844da.normalizeZ(precomputes);
                $82033121ab616fa7$var$pointPrecomputes.set(affinePoint, precomputes);
            }
        }
        let p = $82033121ab616fa7$export$c82dbe8d384844da.ZERO;
        let f = $82033121ab616fa7$export$c82dbe8d384844da.BASE;
        const windows = 1 + 256 / W;
        const windowSize = 2 ** (W - 1);
        const mask = BigInt(2 ** W - 1);
        const maxNumber = 2 ** W;
        const shiftBy = BigInt(W);
        for(let window = 0; window < windows; window++){
            const offset = window * windowSize;
            let wbits = Number(n & mask);
            n >>= shiftBy;
            if (wbits > windowSize) {
                wbits -= maxNumber;
                n += $82033121ab616fa7$var$_1n;
            }
            const offset1 = offset;
            const offset2 = offset + Math.abs(wbits) - 1;
            const cond1 = window % 2 !== 0;
            const cond2 = wbits < 0;
            if (wbits === 0) f = f.add($82033121ab616fa7$var$constTimeNegate(cond1, precomputes[offset1]));
            else p = p.add($82033121ab616fa7$var$constTimeNegate(cond2, precomputes[offset2]));
        }
        return $82033121ab616fa7$export$c82dbe8d384844da.normalizeZ([
            p,
            f
        ])[0];
    }
    multiply(scalar, affinePoint) {
        return this.wNAF($82033121ab616fa7$var$normalizeScalar(scalar, $82033121ab616fa7$export$8ff8607b70325343.l), affinePoint);
    }
    multiplyUnsafe(scalar) {
        let n = $82033121ab616fa7$var$normalizeScalar(scalar, $82033121ab616fa7$export$8ff8607b70325343.l, false);
        const G = $82033121ab616fa7$export$c82dbe8d384844da.BASE;
        const P0 = $82033121ab616fa7$export$c82dbe8d384844da.ZERO;
        if (n === $82033121ab616fa7$var$_0n) return P0;
        if (this.equals(P0) || n === $82033121ab616fa7$var$_1n) return this;
        if (this.equals(G)) return this.wNAF(n);
        let p = P0;
        let d = this;
        while(n > $82033121ab616fa7$var$_0n){
            if (n & $82033121ab616fa7$var$_1n) p = p.add(d);
            d = d.double();
            n >>= $82033121ab616fa7$var$_1n;
        }
        return p;
    }
    isSmallOrder() {
        return this.multiplyUnsafe($82033121ab616fa7$export$8ff8607b70325343.h).equals($82033121ab616fa7$export$c82dbe8d384844da.ZERO);
    }
    isTorsionFree() {
        let p = this.multiplyUnsafe($82033121ab616fa7$export$8ff8607b70325343.l / $82033121ab616fa7$var$_2n).double();
        if ($82033121ab616fa7$export$8ff8607b70325343.l % $82033121ab616fa7$var$_2n) p = p.add(this);
        return p.equals($82033121ab616fa7$export$c82dbe8d384844da.ZERO);
    }
    toAffine(invZ) {
        const { x: x, y: y, z: z } = this;
        const is0 = this.equals($82033121ab616fa7$export$c82dbe8d384844da.ZERO);
        if (invZ == null) invZ = is0 ? $82033121ab616fa7$var$_8n : $82033121ab616fa7$var$invert(z);
        const ax = $82033121ab616fa7$var$mod(x * invZ);
        const ay = $82033121ab616fa7$var$mod(y * invZ);
        const zz = $82033121ab616fa7$var$mod(z * invZ);
        if (is0) return $82033121ab616fa7$export$baf26146a414f24a.ZERO;
        if (zz !== $82033121ab616fa7$var$_1n) throw new Error("invZ was invalid");
        return new $82033121ab616fa7$export$baf26146a414f24a(ax, ay);
    }
    fromRistrettoBytes() {
        $82033121ab616fa7$var$legacyRist();
    }
    toRistrettoBytes() {
        $82033121ab616fa7$var$legacyRist();
    }
    fromRistrettoHash() {
        $82033121ab616fa7$var$legacyRist();
    }
}
$82033121ab616fa7$export$c82dbe8d384844da.BASE = new $82033121ab616fa7$export$c82dbe8d384844da($82033121ab616fa7$export$8ff8607b70325343.Gx, $82033121ab616fa7$export$8ff8607b70325343.Gy, $82033121ab616fa7$var$_1n, $82033121ab616fa7$var$mod($82033121ab616fa7$export$8ff8607b70325343.Gx * $82033121ab616fa7$export$8ff8607b70325343.Gy));
$82033121ab616fa7$export$c82dbe8d384844da.ZERO = new $82033121ab616fa7$export$c82dbe8d384844da($82033121ab616fa7$var$_0n, $82033121ab616fa7$var$_1n, $82033121ab616fa7$var$_1n, $82033121ab616fa7$var$_0n);
function $82033121ab616fa7$var$constTimeNegate(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
function $82033121ab616fa7$var$assertExtPoint(other) {
    if (!(other instanceof $82033121ab616fa7$export$c82dbe8d384844da)) throw new TypeError("ExtendedPoint expected");
}
function $82033121ab616fa7$var$assertRstPoint(other) {
    if (!(other instanceof $82033121ab616fa7$export$5e87c4f36f27816d)) throw new TypeError("RistrettoPoint expected");
}
function $82033121ab616fa7$var$legacyRist() {
    throw new Error("Legacy method: switch to RistrettoPoint");
}
class $82033121ab616fa7$export$5e87c4f36f27816d {
    constructor(ep){
        this.ep = ep;
    }
    static calcElligatorRistrettoMap(r0) {
        const { d: d } = $82033121ab616fa7$export$8ff8607b70325343;
        const r = $82033121ab616fa7$var$mod($82033121ab616fa7$var$SQRT_M1 * r0 * r0);
        const Ns = $82033121ab616fa7$var$mod((r + $82033121ab616fa7$var$_1n) * $82033121ab616fa7$var$ONE_MINUS_D_SQ);
        let c = BigInt(-1);
        const D = $82033121ab616fa7$var$mod((c - d * r) * $82033121ab616fa7$var$mod(r + d));
        let { isValid: Ns_D_is_sq, value: s } = $82033121ab616fa7$var$uvRatio(Ns, D);
        let s_ = $82033121ab616fa7$var$mod(s * r0);
        if (!$82033121ab616fa7$var$edIsNegative(s_)) s_ = $82033121ab616fa7$var$mod(-s_);
        if (!Ns_D_is_sq) s = s_;
        if (!Ns_D_is_sq) c = r;
        const Nt = $82033121ab616fa7$var$mod(c * (r - $82033121ab616fa7$var$_1n) * $82033121ab616fa7$var$D_MINUS_ONE_SQ - D);
        const s2 = s * s;
        const W0 = $82033121ab616fa7$var$mod((s + s) * D);
        const W1 = $82033121ab616fa7$var$mod(Nt * $82033121ab616fa7$var$SQRT_AD_MINUS_ONE);
        const W2 = $82033121ab616fa7$var$mod($82033121ab616fa7$var$_1n - s2);
        const W3 = $82033121ab616fa7$var$mod($82033121ab616fa7$var$_1n + s2);
        return new $82033121ab616fa7$export$c82dbe8d384844da($82033121ab616fa7$var$mod(W0 * W3), $82033121ab616fa7$var$mod(W2 * W1), $82033121ab616fa7$var$mod(W1 * W3), $82033121ab616fa7$var$mod(W0 * W2));
    }
    static hashToCurve(hex) {
        hex = $82033121ab616fa7$var$ensureBytes(hex, 64);
        const r1 = $82033121ab616fa7$var$bytes255ToNumberLE(hex.slice(0, 32));
        const R1 = this.calcElligatorRistrettoMap(r1);
        const r2 = $82033121ab616fa7$var$bytes255ToNumberLE(hex.slice(32, 64));
        const R2 = this.calcElligatorRistrettoMap(r2);
        return new $82033121ab616fa7$export$5e87c4f36f27816d(R1.add(R2));
    }
    static fromHex(hex) {
        hex = $82033121ab616fa7$var$ensureBytes(hex, 32);
        const { a: a, d: d } = $82033121ab616fa7$export$8ff8607b70325343;
        const emsg = "RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint";
        const s = $82033121ab616fa7$var$bytes255ToNumberLE(hex);
        if (!$82033121ab616fa7$var$equalBytes($82033121ab616fa7$var$numberTo32BytesLE(s), hex) || $82033121ab616fa7$var$edIsNegative(s)) throw new Error(emsg);
        const s2 = $82033121ab616fa7$var$mod(s * s);
        const u1 = $82033121ab616fa7$var$mod($82033121ab616fa7$var$_1n + a * s2);
        const u2 = $82033121ab616fa7$var$mod($82033121ab616fa7$var$_1n - a * s2);
        const u1_2 = $82033121ab616fa7$var$mod(u1 * u1);
        const u2_2 = $82033121ab616fa7$var$mod(u2 * u2);
        const v = $82033121ab616fa7$var$mod(a * d * u1_2 - u2_2);
        const { isValid: isValid, value: I } = $82033121ab616fa7$var$invertSqrt($82033121ab616fa7$var$mod(v * u2_2));
        const Dx = $82033121ab616fa7$var$mod(I * u2);
        const Dy = $82033121ab616fa7$var$mod(I * Dx * v);
        let x = $82033121ab616fa7$var$mod((s + s) * Dx);
        if ($82033121ab616fa7$var$edIsNegative(x)) x = $82033121ab616fa7$var$mod(-x);
        const y = $82033121ab616fa7$var$mod(u1 * Dy);
        const t = $82033121ab616fa7$var$mod(x * y);
        if (!isValid || $82033121ab616fa7$var$edIsNegative(t) || y === $82033121ab616fa7$var$_0n) throw new Error(emsg);
        return new $82033121ab616fa7$export$5e87c4f36f27816d(new $82033121ab616fa7$export$c82dbe8d384844da(x, y, $82033121ab616fa7$var$_1n, t));
    }
    toRawBytes() {
        let { x: x, y: y, z: z, t: t } = this.ep;
        const u1 = $82033121ab616fa7$var$mod($82033121ab616fa7$var$mod(z + y) * $82033121ab616fa7$var$mod(z - y));
        const u2 = $82033121ab616fa7$var$mod(x * y);
        const u2sq = $82033121ab616fa7$var$mod(u2 * u2);
        const { value: invsqrt } = $82033121ab616fa7$var$invertSqrt($82033121ab616fa7$var$mod(u1 * u2sq));
        const D1 = $82033121ab616fa7$var$mod(invsqrt * u1);
        const D2 = $82033121ab616fa7$var$mod(invsqrt * u2);
        const zInv = $82033121ab616fa7$var$mod(D1 * D2 * t);
        let D;
        if ($82033121ab616fa7$var$edIsNegative(t * zInv)) {
            let _x = $82033121ab616fa7$var$mod(y * $82033121ab616fa7$var$SQRT_M1);
            let _y = $82033121ab616fa7$var$mod(x * $82033121ab616fa7$var$SQRT_M1);
            x = _x;
            y = _y;
            D = $82033121ab616fa7$var$mod(D1 * $82033121ab616fa7$var$INVSQRT_A_MINUS_D);
        } else D = D2;
        if ($82033121ab616fa7$var$edIsNegative(x * zInv)) y = $82033121ab616fa7$var$mod(-y);
        let s = $82033121ab616fa7$var$mod((z - y) * D);
        if ($82033121ab616fa7$var$edIsNegative(s)) s = $82033121ab616fa7$var$mod(-s);
        return $82033121ab616fa7$var$numberTo32BytesLE(s);
    }
    toHex() {
        return $82033121ab616fa7$export$58b867e287a802c8(this.toRawBytes());
    }
    toString() {
        return this.toHex();
    }
    equals(other) {
        $82033121ab616fa7$var$assertRstPoint(other);
        const a = this.ep;
        const b = other.ep;
        const one = $82033121ab616fa7$var$mod(a.x * b.y) === $82033121ab616fa7$var$mod(a.y * b.x);
        const two = $82033121ab616fa7$var$mod(a.y * b.y) === $82033121ab616fa7$var$mod(a.x * b.x);
        return one || two;
    }
    add(other) {
        $82033121ab616fa7$var$assertRstPoint(other);
        return new $82033121ab616fa7$export$5e87c4f36f27816d(this.ep.add(other.ep));
    }
    subtract(other) {
        $82033121ab616fa7$var$assertRstPoint(other);
        return new $82033121ab616fa7$export$5e87c4f36f27816d(this.ep.subtract(other.ep));
    }
    multiply(scalar) {
        return new $82033121ab616fa7$export$5e87c4f36f27816d(this.ep.multiply(scalar));
    }
    multiplyUnsafe(scalar) {
        return new $82033121ab616fa7$export$5e87c4f36f27816d(this.ep.multiplyUnsafe(scalar));
    }
}
$82033121ab616fa7$export$5e87c4f36f27816d.BASE = new $82033121ab616fa7$export$5e87c4f36f27816d($82033121ab616fa7$export$c82dbe8d384844da.BASE);
$82033121ab616fa7$export$5e87c4f36f27816d.ZERO = new $82033121ab616fa7$export$5e87c4f36f27816d($82033121ab616fa7$export$c82dbe8d384844da.ZERO);
const $82033121ab616fa7$var$pointPrecomputes = new WeakMap();
class $82033121ab616fa7$export$baf26146a414f24a {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    _setWindowSize(windowSize) {
        this._WINDOW_SIZE = windowSize;
        $82033121ab616fa7$var$pointPrecomputes.delete(this);
    }
    static fromHex(hex, strict = true) {
        const { d: d, P: P } = $82033121ab616fa7$export$8ff8607b70325343;
        hex = $82033121ab616fa7$var$ensureBytes(hex, 32);
        const normed = hex.slice();
        normed[31] = hex[31] & -129;
        const y = $82033121ab616fa7$var$bytesToNumberLE(normed);
        if (strict && y >= P) throw new Error("Expected 0 < hex < P");
        if (!strict && y >= $82033121ab616fa7$var$POW_2_256) throw new Error("Expected 0 < hex < 2**256");
        const y2 = $82033121ab616fa7$var$mod(y * y);
        const u = $82033121ab616fa7$var$mod(y2 - $82033121ab616fa7$var$_1n);
        const v = $82033121ab616fa7$var$mod(d * y2 + $82033121ab616fa7$var$_1n);
        let { isValid: isValid, value: x } = $82033121ab616fa7$var$uvRatio(u, v);
        if (!isValid) throw new Error("Point.fromHex: invalid y coordinate");
        const isXOdd = (x & $82033121ab616fa7$var$_1n) === $82033121ab616fa7$var$_1n;
        const isLastByteOdd = (hex[31] & 0x80) !== 0;
        if (isLastByteOdd !== isXOdd) x = $82033121ab616fa7$var$mod(-x);
        return new $82033121ab616fa7$export$baf26146a414f24a(x, y);
    }
    static async fromPrivateKey(privateKey) {
        return (await $82033121ab616fa7$var$getExtendedPublicKey(privateKey)).point;
    }
    toRawBytes() {
        const bytes = $82033121ab616fa7$var$numberTo32BytesLE(this.y);
        bytes[31] |= this.x & $82033121ab616fa7$var$_1n ? 0x80 : 0;
        return bytes;
    }
    toHex() {
        return $82033121ab616fa7$export$58b867e287a802c8(this.toRawBytes());
    }
    toX25519() {
        const { y: y } = this;
        const u = $82033121ab616fa7$var$mod(($82033121ab616fa7$var$_1n + y) * $82033121ab616fa7$var$invert($82033121ab616fa7$var$_1n - y));
        return $82033121ab616fa7$var$numberTo32BytesLE(u);
    }
    isTorsionFree() {
        return $82033121ab616fa7$export$c82dbe8d384844da.fromAffine(this).isTorsionFree();
    }
    equals(other) {
        return this.x === other.x && this.y === other.y;
    }
    negate() {
        return new $82033121ab616fa7$export$baf26146a414f24a($82033121ab616fa7$var$mod(-this.x), this.y);
    }
    add(other) {
        return $82033121ab616fa7$export$c82dbe8d384844da.fromAffine(this).add($82033121ab616fa7$export$c82dbe8d384844da.fromAffine(other)).toAffine();
    }
    subtract(other) {
        return this.add(other.negate());
    }
    multiply(scalar) {
        return $82033121ab616fa7$export$c82dbe8d384844da.fromAffine(this).multiply(scalar, this).toAffine();
    }
}
$82033121ab616fa7$export$baf26146a414f24a.BASE = new $82033121ab616fa7$export$baf26146a414f24a($82033121ab616fa7$export$8ff8607b70325343.Gx, $82033121ab616fa7$export$8ff8607b70325343.Gy);
$82033121ab616fa7$export$baf26146a414f24a.ZERO = new $82033121ab616fa7$export$baf26146a414f24a($82033121ab616fa7$var$_0n, $82033121ab616fa7$var$_1n);
class $82033121ab616fa7$export$848620f5f2f26e86 {
    constructor(r, s){
        this.r = r;
        this.s = s;
        this.assertValidity();
    }
    static fromHex(hex) {
        const bytes = $82033121ab616fa7$var$ensureBytes(hex, 64);
        const r = $82033121ab616fa7$export$baf26146a414f24a.fromHex(bytes.slice(0, 32), false);
        const s = $82033121ab616fa7$var$bytesToNumberLE(bytes.slice(32, 64));
        return new $82033121ab616fa7$export$848620f5f2f26e86(r, s);
    }
    assertValidity() {
        const { r: r, s: s } = this;
        if (!(r instanceof $82033121ab616fa7$export$baf26146a414f24a)) throw new Error("Expected Point instance");
        $82033121ab616fa7$var$normalizeScalar(s, $82033121ab616fa7$export$8ff8607b70325343.l, false);
        return this;
    }
    toRawBytes() {
        const u8 = new Uint8Array(64);
        u8.set(this.r.toRawBytes());
        u8.set($82033121ab616fa7$var$numberTo32BytesLE(this.s), 32);
        return u8;
    }
    toHex() {
        return $82033121ab616fa7$export$58b867e287a802c8(this.toRawBytes());
    }
}
function $82033121ab616fa7$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $82033121ab616fa7$var$abytes(item) {
    if (!$82033121ab616fa7$var$isBytes(item)) throw new Error("Uint8Array expected");
}
function $82033121ab616fa7$var$concatBytes(...arrays) {
    arrays.every($82033121ab616fa7$var$abytes);
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
const $82033121ab616fa7$var$hexes = Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $82033121ab616fa7$export$58b867e287a802c8(bytes) {
    $82033121ab616fa7$var$abytes(bytes);
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $82033121ab616fa7$var$hexes[bytes[i]];
    return hex;
}
const $82033121ab616fa7$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $82033121ab616fa7$var$asciiToBase16(ch) {
    if (ch >= $82033121ab616fa7$var$asciis._0 && ch <= $82033121ab616fa7$var$asciis._9) return ch - $82033121ab616fa7$var$asciis._0;
    if (ch >= $82033121ab616fa7$var$asciis.A && ch <= $82033121ab616fa7$var$asciis.F) return ch - ($82033121ab616fa7$var$asciis.A - 10);
    if (ch >= $82033121ab616fa7$var$asciis.a && ch <= $82033121ab616fa7$var$asciis.f) return ch - ($82033121ab616fa7$var$asciis.a - 10);
    return;
}
function $82033121ab616fa7$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $82033121ab616fa7$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $82033121ab616fa7$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
function $82033121ab616fa7$var$numberTo32BytesBE(num) {
    const length = 32;
    const hex = num.toString(16).padStart(length * 2, "0");
    return $82033121ab616fa7$export$31c96b9df38bc8d4(hex);
}
function $82033121ab616fa7$var$numberTo32BytesLE(num) {
    return $82033121ab616fa7$var$numberTo32BytesBE(num).reverse();
}
function $82033121ab616fa7$var$edIsNegative(num) {
    return ($82033121ab616fa7$var$mod(num) & $82033121ab616fa7$var$_1n) === $82033121ab616fa7$var$_1n;
}
function $82033121ab616fa7$var$bytesToNumberLE(uint8a) {
    $82033121ab616fa7$var$abytes(uint8a);
    return BigInt("0x" + $82033121ab616fa7$export$58b867e287a802c8(Uint8Array.from(uint8a).reverse()));
}
const $82033121ab616fa7$var$MAX_255B = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $82033121ab616fa7$var$bytes255ToNumberLE(bytes) {
    return $82033121ab616fa7$var$mod($82033121ab616fa7$var$bytesToNumberLE(bytes) & $82033121ab616fa7$var$MAX_255B);
}
function $82033121ab616fa7$var$mod(a, b = $82033121ab616fa7$export$8ff8607b70325343.P) {
    const res = a % b;
    return res >= $82033121ab616fa7$var$_0n ? res : b + res;
}
function $82033121ab616fa7$var$invert(number, modulo = $82033121ab616fa7$export$8ff8607b70325343.P) {
    if (number === $82033121ab616fa7$var$_0n || modulo <= $82033121ab616fa7$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    let a = $82033121ab616fa7$var$mod(number, modulo);
    let b = modulo;
    let x = $82033121ab616fa7$var$_0n, y = $82033121ab616fa7$var$_1n, u = $82033121ab616fa7$var$_1n, v = $82033121ab616fa7$var$_0n;
    while(a !== $82033121ab616fa7$var$_0n){
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $82033121ab616fa7$var$_1n) throw new Error("invert: does not exist");
    return $82033121ab616fa7$var$mod(x, modulo);
}
function $82033121ab616fa7$var$invertBatch(nums, p = $82033121ab616fa7$export$8ff8607b70325343.P) {
    const tmp = new Array(nums.length);
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (num === $82033121ab616fa7$var$_0n) return acc;
        tmp[i] = acc;
        return $82033121ab616fa7$var$mod(acc * num, p);
    }, $82033121ab616fa7$var$_1n);
    const inverted = $82033121ab616fa7$var$invert(lastMultiplied, p);
    nums.reduceRight((acc, num, i)=>{
        if (num === $82033121ab616fa7$var$_0n) return acc;
        tmp[i] = $82033121ab616fa7$var$mod(acc * tmp[i], p);
        return $82033121ab616fa7$var$mod(acc * num, p);
    }, inverted);
    return tmp;
}
function $82033121ab616fa7$var$pow2(x, power) {
    const { P: P } = $82033121ab616fa7$export$8ff8607b70325343;
    let res = x;
    while(power-- > $82033121ab616fa7$var$_0n){
        res *= res;
        res %= P;
    }
    return res;
}
function $82033121ab616fa7$var$pow_2_252_3(x) {
    const { P: P } = $82033121ab616fa7$export$8ff8607b70325343;
    const _5n = BigInt(5);
    const _10n = BigInt(10);
    const _20n = BigInt(20);
    const _40n = BigInt(40);
    const _80n = BigInt(80);
    const x2 = x * x % P;
    const b2 = x2 * x % P;
    const b4 = $82033121ab616fa7$var$pow2(b2, $82033121ab616fa7$var$_2n) * b2 % P;
    const b5 = $82033121ab616fa7$var$pow2(b4, $82033121ab616fa7$var$_1n) * x % P;
    const b10 = $82033121ab616fa7$var$pow2(b5, _5n) * b5 % P;
    const b20 = $82033121ab616fa7$var$pow2(b10, _10n) * b10 % P;
    const b40 = $82033121ab616fa7$var$pow2(b20, _20n) * b20 % P;
    const b80 = $82033121ab616fa7$var$pow2(b40, _40n) * b40 % P;
    const b160 = $82033121ab616fa7$var$pow2(b80, _80n) * b80 % P;
    const b240 = $82033121ab616fa7$var$pow2(b160, _80n) * b80 % P;
    const b250 = $82033121ab616fa7$var$pow2(b240, _10n) * b10 % P;
    const pow_p_5_8 = $82033121ab616fa7$var$pow2(b250, $82033121ab616fa7$var$_2n) * x % P;
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $82033121ab616fa7$var$uvRatio(u, v) {
    const v3 = $82033121ab616fa7$var$mod(v * v * v);
    const v7 = $82033121ab616fa7$var$mod(v3 * v3 * v);
    const pow = $82033121ab616fa7$var$pow_2_252_3(u * v7).pow_p_5_8;
    let x = $82033121ab616fa7$var$mod(u * v3 * pow);
    const vx2 = $82033121ab616fa7$var$mod(v * x * x);
    const root1 = x;
    const root2 = $82033121ab616fa7$var$mod(x * $82033121ab616fa7$var$SQRT_M1);
    const useRoot1 = vx2 === u;
    const useRoot2 = vx2 === $82033121ab616fa7$var$mod(-u);
    const noRoot = vx2 === $82033121ab616fa7$var$mod(-u * $82033121ab616fa7$var$SQRT_M1);
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2;
    if ($82033121ab616fa7$var$edIsNegative(x)) x = $82033121ab616fa7$var$mod(-x);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
function $82033121ab616fa7$var$invertSqrt(number) {
    return $82033121ab616fa7$var$uvRatio($82033121ab616fa7$var$_1n, number);
}
function $82033121ab616fa7$var$modlLE(hash) {
    return $82033121ab616fa7$var$mod($82033121ab616fa7$var$bytesToNumberLE(hash), $82033121ab616fa7$export$8ff8607b70325343.l);
}
function $82033121ab616fa7$var$equalBytes(b1, b2) {
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++){
        if (b1[i] !== b2[i]) return false;
    }
    return true;
}
function $82033121ab616fa7$var$ensureBytes(hex, expectedLength) {
    const bytes = $82033121ab616fa7$var$isBytes(hex) ? Uint8Array.from(hex) : $82033121ab616fa7$export$31c96b9df38bc8d4(hex);
    if (typeof expectedLength === "number" && bytes.length !== expectedLength) throw new Error(`Expected ${expectedLength} bytes`);
    return bytes;
}
function $82033121ab616fa7$var$normalizeScalar(num, max, strict = true) {
    if (!max) throw new TypeError("Specify max value");
    if (typeof num === "number" && Number.isSafeInteger(num)) num = BigInt(num);
    if (typeof num === "bigint" && num < max) {
        if (strict) {
            if ($82033121ab616fa7$var$_0n < num) return num;
        } else {
            if ($82033121ab616fa7$var$_0n <= num) return num;
        }
    }
    throw new TypeError("Expected valid scalar: 0 < scalar < max");
}
function $82033121ab616fa7$var$adjustBytes25519(bytes) {
    bytes[0] &= 248;
    bytes[31] &= 127;
    bytes[31] |= 64;
    return bytes;
}
function $82033121ab616fa7$var$decodeScalar25519(n) {
    return $82033121ab616fa7$var$bytesToNumberLE($82033121ab616fa7$var$adjustBytes25519($82033121ab616fa7$var$ensureBytes(n, 32)));
}
function $82033121ab616fa7$var$checkPrivateKey(key) {
    key = typeof key === "bigint" || typeof key === "number" ? $82033121ab616fa7$var$numberTo32BytesBE($82033121ab616fa7$var$normalizeScalar(key, $82033121ab616fa7$var$POW_2_256)) : $82033121ab616fa7$var$ensureBytes(key);
    if (key.length !== 32) throw new Error(`Expected 32 bytes`);
    return key;
}
function $82033121ab616fa7$var$getKeyFromHash(hashed) {
    const head = $82033121ab616fa7$var$adjustBytes25519(hashed.slice(0, 32));
    const prefix = hashed.slice(32, 64);
    const scalar = $82033121ab616fa7$var$modlLE(head);
    const point = $82033121ab616fa7$export$baf26146a414f24a.BASE.multiply(scalar);
    const pointBytes = point.toRawBytes();
    return {
        head: head,
        prefix: prefix,
        scalar: scalar,
        point: point,
        pointBytes: pointBytes
    };
}
let $82033121ab616fa7$var$_sha512Sync;
function $82033121ab616fa7$var$sha512s(...m) {
    if (typeof $82033121ab616fa7$var$_sha512Sync !== "function") throw new Error("utils.sha512Sync must be set to use sync methods");
    return $82033121ab616fa7$var$_sha512Sync(...m);
}
async function $82033121ab616fa7$var$getExtendedPublicKey(key) {
    return $82033121ab616fa7$var$getKeyFromHash(await $82033121ab616fa7$export$eab97d15b1788b8d.sha512($82033121ab616fa7$var$checkPrivateKey(key)));
}
function $82033121ab616fa7$var$getExtendedPublicKeySync(key) {
    return $82033121ab616fa7$var$getKeyFromHash($82033121ab616fa7$var$sha512s($82033121ab616fa7$var$checkPrivateKey(key)));
}
async function $82033121ab616fa7$export$889def73691f9837(privateKey) {
    return (await $82033121ab616fa7$var$getExtendedPublicKey(privateKey)).pointBytes;
}
function $82033121ab616fa7$var$getPublicKeySync(privateKey) {
    return $82033121ab616fa7$var$getExtendedPublicKeySync(privateKey).pointBytes;
}
async function $82033121ab616fa7$export$c5552dfdbc7cec71(message, privateKey) {
    message = $82033121ab616fa7$var$ensureBytes(message);
    const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = await $82033121ab616fa7$var$getExtendedPublicKey(privateKey);
    const r = $82033121ab616fa7$var$modlLE(await $82033121ab616fa7$export$eab97d15b1788b8d.sha512(prefix, message));
    const R = $82033121ab616fa7$export$baf26146a414f24a.BASE.multiply(r);
    const k = $82033121ab616fa7$var$modlLE(await $82033121ab616fa7$export$eab97d15b1788b8d.sha512(R.toRawBytes(), pointBytes, message));
    const s = $82033121ab616fa7$var$mod(r + k * scalar, $82033121ab616fa7$export$8ff8607b70325343.l);
    return new $82033121ab616fa7$export$848620f5f2f26e86(R, s).toRawBytes();
}
function $82033121ab616fa7$var$signSync(message, privateKey) {
    message = $82033121ab616fa7$var$ensureBytes(message);
    const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = $82033121ab616fa7$var$getExtendedPublicKeySync(privateKey);
    const r = $82033121ab616fa7$var$modlLE($82033121ab616fa7$var$sha512s(prefix, message));
    const R = $82033121ab616fa7$export$baf26146a414f24a.BASE.multiply(r);
    const k = $82033121ab616fa7$var$modlLE($82033121ab616fa7$var$sha512s(R.toRawBytes(), pointBytes, message));
    const s = $82033121ab616fa7$var$mod(r + k * scalar, $82033121ab616fa7$export$8ff8607b70325343.l);
    return new $82033121ab616fa7$export$848620f5f2f26e86(R, s).toRawBytes();
}
function $82033121ab616fa7$var$prepareVerification(sig, message, publicKey) {
    message = $82033121ab616fa7$var$ensureBytes(message);
    if (!(publicKey instanceof $82033121ab616fa7$export$baf26146a414f24a)) publicKey = $82033121ab616fa7$export$baf26146a414f24a.fromHex(publicKey, false);
    const { r: r, s: s } = sig instanceof $82033121ab616fa7$export$848620f5f2f26e86 ? sig.assertValidity() : $82033121ab616fa7$export$848620f5f2f26e86.fromHex(sig);
    const SB = $82033121ab616fa7$export$c82dbe8d384844da.BASE.multiplyUnsafe(s);
    return {
        r: r,
        s: s,
        SB: SB,
        pub: publicKey,
        msg: message
    };
}
function $82033121ab616fa7$var$finishVerification(publicKey, r, SB, hashed) {
    const k = $82033121ab616fa7$var$modlLE(hashed);
    const kA = $82033121ab616fa7$export$c82dbe8d384844da.fromAffine(publicKey).multiplyUnsafe(k);
    const RkA = $82033121ab616fa7$export$c82dbe8d384844da.fromAffine(r).add(kA);
    return RkA.subtract(SB).multiplyUnsafe($82033121ab616fa7$export$8ff8607b70325343.h).equals($82033121ab616fa7$export$c82dbe8d384844da.ZERO);
}
async function $82033121ab616fa7$export$532244b5b8b0b4b6(sig, message, publicKey) {
    const { r: r, SB: SB, msg: msg, pub: pub } = $82033121ab616fa7$var$prepareVerification(sig, message, publicKey);
    const hashed = await $82033121ab616fa7$export$eab97d15b1788b8d.sha512(r.toRawBytes(), pub.toRawBytes(), msg);
    return $82033121ab616fa7$var$finishVerification(pub, r, SB, hashed);
}
function $82033121ab616fa7$var$verifySync(sig, message, publicKey) {
    const { r: r, SB: SB, msg: msg, pub: pub } = $82033121ab616fa7$var$prepareVerification(sig, message, publicKey);
    const hashed = $82033121ab616fa7$var$sha512s(r.toRawBytes(), pub.toRawBytes(), msg);
    return $82033121ab616fa7$var$finishVerification(pub, r, SB, hashed);
}
const $82033121ab616fa7$export$92d6409d68f0739a = {
    getExtendedPublicKey: $82033121ab616fa7$var$getExtendedPublicKeySync,
    getPublicKey: $82033121ab616fa7$var$getPublicKeySync,
    sign: $82033121ab616fa7$var$signSync,
    verify: $82033121ab616fa7$var$verifySync
};
async function $82033121ab616fa7$export$151f26f9d84a2c64(privateKey, publicKey) {
    const { head: head } = await $82033121ab616fa7$var$getExtendedPublicKey(privateKey);
    const u = $82033121ab616fa7$export$baf26146a414f24a.fromHex(publicKey).toX25519();
    return $82033121ab616fa7$export$8ca64f7d1491ac59.scalarMult(head, u);
}
$82033121ab616fa7$export$baf26146a414f24a.BASE._setWindowSize(8);
function $82033121ab616fa7$var$cswap(swap, x_2, x_3) {
    const dummy = $82033121ab616fa7$var$mod(swap * (x_2 - x_3));
    x_2 = $82033121ab616fa7$var$mod(x_2 - dummy);
    x_3 = $82033121ab616fa7$var$mod(x_3 + dummy);
    return [
        x_2,
        x_3
    ];
}
function $82033121ab616fa7$var$montgomeryLadder(pointU, scalar) {
    const { P: P } = $82033121ab616fa7$export$8ff8607b70325343;
    const u = $82033121ab616fa7$var$normalizeScalar(pointU, P);
    const k = $82033121ab616fa7$var$normalizeScalar(scalar, P);
    const a24 = BigInt(121665);
    const x_1 = u;
    let x_2 = $82033121ab616fa7$var$_1n;
    let z_2 = $82033121ab616fa7$var$_0n;
    let x_3 = u;
    let z_3 = $82033121ab616fa7$var$_1n;
    let swap = $82033121ab616fa7$var$_0n;
    let sw;
    for(let t = BigInt(254); t >= $82033121ab616fa7$var$_0n; t--){
        const k_t = k >> t & $82033121ab616fa7$var$_1n;
        swap ^= k_t;
        sw = $82033121ab616fa7$var$cswap(swap, x_2, x_3);
        x_2 = sw[0];
        x_3 = sw[1];
        sw = $82033121ab616fa7$var$cswap(swap, z_2, z_3);
        z_2 = sw[0];
        z_3 = sw[1];
        swap = k_t;
        const A = x_2 + z_2;
        const AA = $82033121ab616fa7$var$mod(A * A);
        const B = x_2 - z_2;
        const BB = $82033121ab616fa7$var$mod(B * B);
        const E = AA - BB;
        const C = x_3 + z_3;
        const D = x_3 - z_3;
        const DA = $82033121ab616fa7$var$mod(D * A);
        const CB = $82033121ab616fa7$var$mod(C * B);
        const dacb = DA + CB;
        const da_cb = DA - CB;
        x_3 = $82033121ab616fa7$var$mod(dacb * dacb);
        z_3 = $82033121ab616fa7$var$mod(x_1 * $82033121ab616fa7$var$mod(da_cb * da_cb));
        x_2 = $82033121ab616fa7$var$mod(AA * BB);
        z_2 = $82033121ab616fa7$var$mod(E * (AA + $82033121ab616fa7$var$mod(a24 * E)));
    }
    sw = $82033121ab616fa7$var$cswap(swap, x_2, x_3);
    x_2 = sw[0];
    x_3 = sw[1];
    sw = $82033121ab616fa7$var$cswap(swap, z_2, z_3);
    z_2 = sw[0];
    z_3 = sw[1];
    const { pow_p_5_8: pow_p_5_8, b2: b2 } = $82033121ab616fa7$var$pow_2_252_3(z_2);
    const xp2 = $82033121ab616fa7$var$mod($82033121ab616fa7$var$pow2(pow_p_5_8, BigInt(3)) * b2);
    return $82033121ab616fa7$var$mod(x_2 * xp2);
}
function $82033121ab616fa7$var$encodeUCoordinate(u) {
    return $82033121ab616fa7$var$numberTo32BytesLE($82033121ab616fa7$var$mod(u, $82033121ab616fa7$export$8ff8607b70325343.P));
}
function $82033121ab616fa7$var$decodeUCoordinate(uEnc) {
    const u = $82033121ab616fa7$var$ensureBytes(uEnc, 32);
    u[31] &= 127;
    return $82033121ab616fa7$var$bytesToNumberLE(u);
}
const $82033121ab616fa7$export$8ca64f7d1491ac59 = {
    BASE_POINT_U: "0900000000000000000000000000000000000000000000000000000000000000",
    scalarMult (privateKey, publicKey) {
        const u = $82033121ab616fa7$var$decodeUCoordinate(publicKey);
        const p = $82033121ab616fa7$var$decodeScalar25519(privateKey);
        const pu = $82033121ab616fa7$var$montgomeryLadder(u, p);
        if (pu === $82033121ab616fa7$var$_0n) throw new Error("Invalid private or public key received");
        return $82033121ab616fa7$var$encodeUCoordinate(pu);
    },
    scalarMultBase (privateKey) {
        return $82033121ab616fa7$export$8ca64f7d1491ac59.scalarMult(privateKey, $82033121ab616fa7$export$8ca64f7d1491ac59.BASE_POINT_U);
    }
};
const $82033121ab616fa7$var$crypto = {
    node: $7jzxY,
    web: typeof self === "object" && "crypto" in self ? self.crypto : undefined
};
const $82033121ab616fa7$export$eab97d15b1788b8d = {
    bytesToHex: $82033121ab616fa7$export$58b867e287a802c8,
    hexToBytes: $82033121ab616fa7$export$31c96b9df38bc8d4,
    concatBytes: $82033121ab616fa7$var$concatBytes,
    getExtendedPublicKey: $82033121ab616fa7$var$getExtendedPublicKey,
    mod: $82033121ab616fa7$var$mod,
    invert: $82033121ab616fa7$var$invert,
    TORSION_SUBGROUP: [
        "0100000000000000000000000000000000000000000000000000000000000000",
        "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
        "0000000000000000000000000000000000000000000000000000000000000080",
        "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
        "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
        "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
        "0000000000000000000000000000000000000000000000000000000000000000",
        "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
    ],
    hashToPrivateScalar: (hash)=>{
        hash = $82033121ab616fa7$var$ensureBytes(hash);
        if (hash.length < 40 || hash.length > 1024) throw new Error("Expected 40-1024 bytes of private key as per FIPS 186");
        return $82033121ab616fa7$var$mod($82033121ab616fa7$var$bytesToNumberLE(hash), $82033121ab616fa7$export$8ff8607b70325343.l - $82033121ab616fa7$var$_1n) + $82033121ab616fa7$var$_1n;
    },
    randomBytes: (bytesLength = 32)=>{
        if ($82033121ab616fa7$var$crypto.web) return $82033121ab616fa7$var$crypto.web.getRandomValues(new Uint8Array(bytesLength));
        else if ($82033121ab616fa7$var$crypto.node) {
            const { randomBytes: randomBytes } = $82033121ab616fa7$var$crypto.node;
            return new Uint8Array(randomBytes(bytesLength).buffer);
        } else throw new Error("The environment doesn't have randomBytes function");
    },
    randomPrivateKey: ()=>{
        return $82033121ab616fa7$export$eab97d15b1788b8d.randomBytes(32);
    },
    sha512: async (...messages)=>{
        const message = $82033121ab616fa7$var$concatBytes(...messages);
        if ($82033121ab616fa7$var$crypto.web) {
            const buffer = await $82033121ab616fa7$var$crypto.web.subtle.digest("SHA-512", message.buffer);
            return new Uint8Array(buffer);
        } else if ($82033121ab616fa7$var$crypto.node) return Uint8Array.from($82033121ab616fa7$var$crypto.node.createHash("sha512").update(message).digest());
        else throw new Error("The environment doesn't have sha512 function");
    },
    precompute (windowSize = 8, point = $82033121ab616fa7$export$baf26146a414f24a.BASE) {
        const cached = point.equals($82033121ab616fa7$export$baf26146a414f24a.BASE) ? point : new $82033121ab616fa7$export$baf26146a414f24a(point.x, point.y);
        cached._setWindowSize(windowSize);
        cached.multiply($82033121ab616fa7$var$_2n);
        return cached;
    },
    sha512Sync: undefined
};
Object.defineProperties($82033121ab616fa7$export$eab97d15b1788b8d, {
    sha512Sync: {
        configurable: false,
        get () {
            return $82033121ab616fa7$var$_sha512Sync;
        },
        set (val) {
            if (!$82033121ab616fa7$var$_sha512Sync) $82033121ab616fa7$var$_sha512Sync = val;
        }
    }
});

});



parcelRequire.register("5edhd", function(module, exports) {
"use strict";

var $gTOvd = parcelRequire("gTOvd");
var $3ce88f06b2a4677d$require$sha256 = $gTOvd.sha256;

var $20Lm5 = parcelRequire("20Lm5");

var $ijWXY = parcelRequire("ijWXY");
var $3ce88f06b2a4677d$require$uint8ArrayEquals = $ijWXY.equals;

var $6rBCs = parcelRequire("6rBCs");
var $3ce88f06b2a4677d$require$uint8ArrayToString = $6rBCs.toString;

var $cTBSA = parcelRequire("cTBSA");

module.exports = (keysProtobuf, randomBytes, crypto)=>{
    crypto = crypto || (parcelRequire("dCC2P"))();
    class Secp256k1PublicKey {
        constructor(key){
            crypto.validatePublicKey(key);
            this._key = key;
        }
        verify(data, sig) {
            return crypto.hashAndVerify(this._key, sig, data);
        }
        marshal() {
            return crypto.compressPublicKey(this._key);
        }
        get bytes() {
            return keysProtobuf.PublicKey.encode({
                Type: keysProtobuf.KeyType.Secp256k1,
                Data: this.marshal()
            }).finish();
        }
        equals(key) {
            return $3ce88f06b2a4677d$require$uint8ArrayEquals(this.bytes, key.bytes);
        }
        async hash() {
            const { bytes: bytes } = await $3ce88f06b2a4677d$require$sha256.digest(this.bytes);
            return bytes;
        }
    }
    class Secp256k1PrivateKey {
        constructor(key, publicKey){
            this._key = key;
            this._publicKey = publicKey || crypto.computePublicKey(key);
            crypto.validatePrivateKey(this._key);
            crypto.validatePublicKey(this._publicKey);
        }
        sign(message) {
            return crypto.hashAndSign(this._key, message);
        }
        get public() {
            return new Secp256k1PublicKey(this._publicKey);
        }
        marshal() {
            return this._key;
        }
        get bytes() {
            return keysProtobuf.PrivateKey.encode({
                Type: keysProtobuf.KeyType.Secp256k1,
                Data: this.marshal()
            }).finish();
        }
        equals(key) {
            return $3ce88f06b2a4677d$require$uint8ArrayEquals(this.bytes, key.bytes);
        }
        async hash() {
            const { bytes: bytes } = await $3ce88f06b2a4677d$require$sha256.digest(this.bytes);
            return bytes;
        }
        /**
     * Gets the ID of the key.
     *
     * The key id is the base58 encoding of the SHA-256 multihash of its public key.
     * The public key is a protobuf encoding containing a type and the DER encoding
     * of the PKCS SubjectPublicKeyInfo.
     *
     * @returns {Promise<string>}
     */ async id() {
            const hash = await this.public.hash();
            return $3ce88f06b2a4677d$require$uint8ArrayToString(hash, "base58btc");
        }
        /**
     * Exports the key into a password protected `format`
     *
     * @param {string} password - The password to encrypt the key
     * @param {string} [format=libp2p-key] - The format in which to export as
     * @returns {Promise<string>} The encrypted private key
     */ async export(password, format = "libp2p-key") {
            if (format === "libp2p-key") return $cTBSA.export(this.bytes, password);
            else throw $20Lm5(new Error(`export format '${format}' is not supported`), "ERR_INVALID_EXPORT_FORMAT");
        }
    }
    function unmarshalSecp256k1PrivateKey(bytes) {
        return new Secp256k1PrivateKey(bytes);
    }
    function unmarshalSecp256k1PublicKey(bytes) {
        return new Secp256k1PublicKey(bytes);
    }
    async function generateKeyPair() {
        const privateKeyBytes = await crypto.generateKey();
        return new Secp256k1PrivateKey(privateKeyBytes);
    }
    return {
        Secp256k1PublicKey: Secp256k1PublicKey,
        Secp256k1PrivateKey: Secp256k1PrivateKey,
        unmarshalSecp256k1PrivateKey: unmarshalSecp256k1PrivateKey,
        unmarshalSecp256k1PublicKey: unmarshalSecp256k1PublicKey,
        generateKeyPair: generateKeyPair
    };
};

});
parcelRequire.register("dCC2P", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $hNyF7 = parcelRequire("hNyF7");

var $gTOvd = parcelRequire("gTOvd");
var $9eac55d393b17948$require$sha256 = $gTOvd.sha256;
module.exports = ()=>{
    const privateKeyLength = 32;
    function generateKey() {
        return $hNyF7.utils.randomPrivateKey();
    }
    /**
   * Hash and sign message with private key
   *
   * @param {number | bigint | (string | Uint8Array)} key
   * @param {Uint8Array} msg
   */ async function hashAndSign(key, msg) {
        const { digest: digest } = await $9eac55d393b17948$require$sha256.digest(msg);
        try {
            return await $hNyF7.sign(digest, key);
        } catch (err) {
            throw $20Lm5(err, "ERR_INVALID_INPUT");
        }
    }
    /**
   * Hash message and verify signature with public key
   *
   * @param {secp.Point | (string | Uint8Array)} key
   * @param {(string | Uint8Array) | secp.Signature} sig
   * @param {Uint8Array} msg
   */ async function hashAndVerify(key, sig, msg) {
        try {
            const { digest: digest } = await $9eac55d393b17948$require$sha256.digest(msg);
            return $hNyF7.verify(sig, digest, key);
        } catch (err) {
            throw $20Lm5(err, "ERR_INVALID_INPUT");
        }
    }
    function compressPublicKey(key) {
        const point = $hNyF7.Point.fromHex(key).toRawBytes(true);
        return point;
    }
    function decompressPublicKey(key) {
        const point = $hNyF7.Point.fromHex(key).toRawBytes(false);
        return point;
    }
    function validatePrivateKey(key) {
        try {
            $hNyF7.getPublicKey(key, true);
        } catch (err) {
            throw $20Lm5(err, "ERR_INVALID_PRIVATE_KEY");
        }
    }
    function validatePublicKey(key) {
        try {
            $hNyF7.Point.fromHex(key);
        } catch (err) {
            throw $20Lm5(err, "ERR_INVALID_PUBLIC_KEY");
        }
    }
    function computePublicKey(privateKey) {
        try {
            return $hNyF7.getPublicKey(privateKey, true);
        } catch (err) {
            throw $20Lm5(err, "ERR_INVALID_PRIVATE_KEY");
        }
    }
    return {
        generateKey: generateKey,
        privateKeyLength: privateKeyLength,
        hashAndSign: hashAndSign,
        hashAndVerify: hashAndVerify,
        compressPublicKey: compressPublicKey,
        decompressPublicKey: decompressPublicKey,
        validatePrivateKey: validatePrivateKey,
        validatePublicKey: validatePublicKey,
        computePublicKey: computePublicKey
    };
};

});
parcelRequire.register("hNyF7", function(module, exports) {

$parcel$export(module.exports, "Point", () => $cf51e6787616c60f$export$baf26146a414f24a);
$parcel$export(module.exports, "utils", () => $cf51e6787616c60f$export$eab97d15b1788b8d);
$parcel$export(module.exports, "getPublicKey", () => $cf51e6787616c60f$export$889def73691f9837);
$parcel$export(module.exports, "sign", () => $cf51e6787616c60f$export$c5552dfdbc7cec71);
$parcel$export(module.exports, "verify", () => $cf51e6787616c60f$export$532244b5b8b0b4b6);
/*! noble-secp256k1 - MIT License (c) 2019 Paul Miller (paulmillr.com) */ 
var $7jzxY = parcelRequire("7jzxY");
const $cf51e6787616c60f$var$_0n = BigInt(0);
const $cf51e6787616c60f$var$_1n = BigInt(1);
const $cf51e6787616c60f$var$_2n = BigInt(2);
const $cf51e6787616c60f$var$_3n = BigInt(3);
const $cf51e6787616c60f$var$_8n = BigInt(8);
const $cf51e6787616c60f$export$8ff8607b70325343 = Object.freeze({
    a: $cf51e6787616c60f$var$_0n,
    b: BigInt(7),
    P: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"),
    n: BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
    h: $cf51e6787616c60f$var$_1n,
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee")
});
const $cf51e6787616c60f$var$divNearest = (a, b)=>(a + b / $cf51e6787616c60f$var$_2n) / b;
const $cf51e6787616c60f$var$endo = {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar (k) {
        const { n: n } = $cf51e6787616c60f$export$8ff8607b70325343;
        const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
        const b1 = -$cf51e6787616c60f$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
        const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
        const b2 = a1;
        const POW_2_128 = BigInt("0x100000000000000000000000000000000");
        const c1 = $cf51e6787616c60f$var$divNearest(b2 * k, n);
        const c2 = $cf51e6787616c60f$var$divNearest(-b1 * k, n);
        let k1 = $cf51e6787616c60f$var$mod(k - c1 * a1 - c2 * a2, n);
        let k2 = $cf51e6787616c60f$var$mod(-c1 * b1 - c2 * b2, n);
        const k1neg = k1 > POW_2_128;
        const k2neg = k2 > POW_2_128;
        if (k1neg) k1 = n - k1;
        if (k2neg) k2 = n - k2;
        if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalarEndo: Endomorphism failed, k=" + k);
        return {
            k1neg: k1neg,
            k1: k1,
            k2neg: k2neg,
            k2: k2
        };
    }
};
const $cf51e6787616c60f$var$fieldLen = 32;
const $cf51e6787616c60f$var$groupLen = 32;
const $cf51e6787616c60f$var$hashLen = 32;
const $cf51e6787616c60f$var$compressedLen = $cf51e6787616c60f$var$fieldLen + 1;
const $cf51e6787616c60f$var$uncompressedLen = 2 * $cf51e6787616c60f$var$fieldLen + 1;
function $cf51e6787616c60f$var$weierstrass(x) {
    const { a: a, b: b } = $cf51e6787616c60f$export$8ff8607b70325343;
    const x2 = $cf51e6787616c60f$var$mod(x * x);
    const x3 = $cf51e6787616c60f$var$mod(x2 * x);
    return $cf51e6787616c60f$var$mod(x3 + a * x + b);
}
const $cf51e6787616c60f$var$USE_ENDOMORPHISM = $cf51e6787616c60f$export$8ff8607b70325343.a === $cf51e6787616c60f$var$_0n;
class $cf51e6787616c60f$var$ShaError extends Error {
    constructor(message){
        super(message);
    }
}
function $cf51e6787616c60f$var$assertJacPoint(other) {
    if (!(other instanceof $cf51e6787616c60f$var$JacobianPoint)) throw new TypeError("JacobianPoint expected");
}
class $cf51e6787616c60f$var$JacobianPoint {
    constructor(x, y, z){
        this.x = x;
        this.y = y;
        this.z = z;
    }
    static fromAffine(p) {
        if (!(p instanceof $cf51e6787616c60f$export$baf26146a414f24a)) throw new TypeError("JacobianPoint#fromAffine: expected Point");
        if (p.equals($cf51e6787616c60f$export$baf26146a414f24a.ZERO)) return $cf51e6787616c60f$var$JacobianPoint.ZERO;
        return new $cf51e6787616c60f$var$JacobianPoint(p.x, p.y, $cf51e6787616c60f$var$_1n);
    }
    static toAffineBatch(points) {
        const toInv = $cf51e6787616c60f$var$invertBatch(points.map((p)=>p.z));
        return points.map((p, i)=>p.toAffine(toInv[i]));
    }
    static normalizeZ(points) {
        return $cf51e6787616c60f$var$JacobianPoint.toAffineBatch(points).map($cf51e6787616c60f$var$JacobianPoint.fromAffine);
    }
    equals(other) {
        $cf51e6787616c60f$var$assertJacPoint(other);
        const { x: X1, y: Y1, z: Z1 } = this;
        const { x: X2, y: Y2, z: Z2 } = other;
        const Z1Z1 = $cf51e6787616c60f$var$mod(Z1 * Z1);
        const Z2Z2 = $cf51e6787616c60f$var$mod(Z2 * Z2);
        const U1 = $cf51e6787616c60f$var$mod(X1 * Z2Z2);
        const U2 = $cf51e6787616c60f$var$mod(X2 * Z1Z1);
        const S1 = $cf51e6787616c60f$var$mod($cf51e6787616c60f$var$mod(Y1 * Z2) * Z2Z2);
        const S2 = $cf51e6787616c60f$var$mod($cf51e6787616c60f$var$mod(Y2 * Z1) * Z1Z1);
        return U1 === U2 && S1 === S2;
    }
    negate() {
        return new $cf51e6787616c60f$var$JacobianPoint(this.x, $cf51e6787616c60f$var$mod(-this.y), this.z);
    }
    double() {
        const { x: X1, y: Y1, z: Z1 } = this;
        const A = $cf51e6787616c60f$var$mod(X1 * X1);
        const B = $cf51e6787616c60f$var$mod(Y1 * Y1);
        const C = $cf51e6787616c60f$var$mod(B * B);
        const x1b = X1 + B;
        const D = $cf51e6787616c60f$var$mod($cf51e6787616c60f$var$_2n * ($cf51e6787616c60f$var$mod(x1b * x1b) - A - C));
        const E = $cf51e6787616c60f$var$mod($cf51e6787616c60f$var$_3n * A);
        const F = $cf51e6787616c60f$var$mod(E * E);
        const X3 = $cf51e6787616c60f$var$mod(F - $cf51e6787616c60f$var$_2n * D);
        const Y3 = $cf51e6787616c60f$var$mod(E * (D - X3) - $cf51e6787616c60f$var$_8n * C);
        const Z3 = $cf51e6787616c60f$var$mod($cf51e6787616c60f$var$_2n * Y1 * Z1);
        return new $cf51e6787616c60f$var$JacobianPoint(X3, Y3, Z3);
    }
    add(other) {
        $cf51e6787616c60f$var$assertJacPoint(other);
        const { x: X1, y: Y1, z: Z1 } = this;
        const { x: X2, y: Y2, z: Z2 } = other;
        if (X2 === $cf51e6787616c60f$var$_0n || Y2 === $cf51e6787616c60f$var$_0n) return this;
        if (X1 === $cf51e6787616c60f$var$_0n || Y1 === $cf51e6787616c60f$var$_0n) return other;
        const Z1Z1 = $cf51e6787616c60f$var$mod(Z1 * Z1);
        const Z2Z2 = $cf51e6787616c60f$var$mod(Z2 * Z2);
        const U1 = $cf51e6787616c60f$var$mod(X1 * Z2Z2);
        const U2 = $cf51e6787616c60f$var$mod(X2 * Z1Z1);
        const S1 = $cf51e6787616c60f$var$mod($cf51e6787616c60f$var$mod(Y1 * Z2) * Z2Z2);
        const S2 = $cf51e6787616c60f$var$mod($cf51e6787616c60f$var$mod(Y2 * Z1) * Z1Z1);
        const H = $cf51e6787616c60f$var$mod(U2 - U1);
        const r = $cf51e6787616c60f$var$mod(S2 - S1);
        if (H === $cf51e6787616c60f$var$_0n) {
            if (r === $cf51e6787616c60f$var$_0n) return this.double();
            else return $cf51e6787616c60f$var$JacobianPoint.ZERO;
        }
        const HH = $cf51e6787616c60f$var$mod(H * H);
        const HHH = $cf51e6787616c60f$var$mod(H * HH);
        const V = $cf51e6787616c60f$var$mod(U1 * HH);
        const X3 = $cf51e6787616c60f$var$mod(r * r - HHH - $cf51e6787616c60f$var$_2n * V);
        const Y3 = $cf51e6787616c60f$var$mod(r * (V - X3) - S1 * HHH);
        const Z3 = $cf51e6787616c60f$var$mod(Z1 * Z2 * H);
        return new $cf51e6787616c60f$var$JacobianPoint(X3, Y3, Z3);
    }
    subtract(other) {
        return this.add(other.negate());
    }
    multiplyUnsafe(scalar) {
        const P0 = $cf51e6787616c60f$var$JacobianPoint.ZERO;
        if (typeof scalar === "bigint" && scalar === $cf51e6787616c60f$var$_0n) return P0;
        let n = $cf51e6787616c60f$var$normalizeScalar(scalar);
        if (n === $cf51e6787616c60f$var$_1n) return this;
        if (!$cf51e6787616c60f$var$USE_ENDOMORPHISM) {
            let p = P0;
            let d = this;
            while(n > $cf51e6787616c60f$var$_0n){
                if (n & $cf51e6787616c60f$var$_1n) p = p.add(d);
                d = d.double();
                n >>= $cf51e6787616c60f$var$_1n;
            }
            return p;
        }
        let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = $cf51e6787616c60f$var$endo.splitScalar(n);
        let k1p = P0;
        let k2p = P0;
        let d = this;
        while(k1 > $cf51e6787616c60f$var$_0n || k2 > $cf51e6787616c60f$var$_0n){
            if (k1 & $cf51e6787616c60f$var$_1n) k1p = k1p.add(d);
            if (k2 & $cf51e6787616c60f$var$_1n) k2p = k2p.add(d);
            d = d.double();
            k1 >>= $cf51e6787616c60f$var$_1n;
            k2 >>= $cf51e6787616c60f$var$_1n;
        }
        if (k1neg) k1p = k1p.negate();
        if (k2neg) k2p = k2p.negate();
        k2p = new $cf51e6787616c60f$var$JacobianPoint($cf51e6787616c60f$var$mod(k2p.x * $cf51e6787616c60f$var$endo.beta), k2p.y, k2p.z);
        return k1p.add(k2p);
    }
    precomputeWindow(W) {
        const windows = $cf51e6787616c60f$var$USE_ENDOMORPHISM ? 128 / W + 1 : 256 / W + 1;
        const points = [];
        let p = this;
        let base = p;
        for(let window = 0; window < windows; window++){
            base = p;
            points.push(base);
            for(let i = 1; i < 2 ** (W - 1); i++){
                base = base.add(p);
                points.push(base);
            }
            p = base.double();
        }
        return points;
    }
    wNAF(n, affinePoint) {
        if (!affinePoint && this.equals($cf51e6787616c60f$var$JacobianPoint.BASE)) affinePoint = $cf51e6787616c60f$export$baf26146a414f24a.BASE;
        const W = affinePoint && affinePoint._WINDOW_SIZE || 1;
        if (256 % W) throw new Error("Point#wNAF: Invalid precomputation window, must be power of 2");
        let precomputes = affinePoint && $cf51e6787616c60f$var$pointPrecomputes.get(affinePoint);
        if (!precomputes) {
            precomputes = this.precomputeWindow(W);
            if (affinePoint && W !== 1) {
                precomputes = $cf51e6787616c60f$var$JacobianPoint.normalizeZ(precomputes);
                $cf51e6787616c60f$var$pointPrecomputes.set(affinePoint, precomputes);
            }
        }
        let p = $cf51e6787616c60f$var$JacobianPoint.ZERO;
        let f = $cf51e6787616c60f$var$JacobianPoint.BASE;
        const windows = 1 + ($cf51e6787616c60f$var$USE_ENDOMORPHISM ? 128 / W : 256 / W);
        const windowSize = 2 ** (W - 1);
        const mask = BigInt(2 ** W - 1);
        const maxNumber = 2 ** W;
        const shiftBy = BigInt(W);
        for(let window = 0; window < windows; window++){
            const offset = window * windowSize;
            let wbits = Number(n & mask);
            n >>= shiftBy;
            if (wbits > windowSize) {
                wbits -= maxNumber;
                n += $cf51e6787616c60f$var$_1n;
            }
            const offset1 = offset;
            const offset2 = offset + Math.abs(wbits) - 1;
            const cond1 = window % 2 !== 0;
            const cond2 = wbits < 0;
            if (wbits === 0) f = f.add($cf51e6787616c60f$var$constTimeNegate(cond1, precomputes[offset1]));
            else p = p.add($cf51e6787616c60f$var$constTimeNegate(cond2, precomputes[offset2]));
        }
        return {
            p: p,
            f: f
        };
    }
    multiply(scalar, affinePoint) {
        let n = $cf51e6787616c60f$var$normalizeScalar(scalar);
        let point;
        let fake;
        if ($cf51e6787616c60f$var$USE_ENDOMORPHISM) {
            const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = $cf51e6787616c60f$var$endo.splitScalar(n);
            let { p: k1p, f: f1p } = this.wNAF(k1, affinePoint);
            let { p: k2p, f: f2p } = this.wNAF(k2, affinePoint);
            k1p = $cf51e6787616c60f$var$constTimeNegate(k1neg, k1p);
            k2p = $cf51e6787616c60f$var$constTimeNegate(k2neg, k2p);
            k2p = new $cf51e6787616c60f$var$JacobianPoint($cf51e6787616c60f$var$mod(k2p.x * $cf51e6787616c60f$var$endo.beta), k2p.y, k2p.z);
            point = k1p.add(k2p);
            fake = f1p.add(f2p);
        } else {
            const { p: p, f: f } = this.wNAF(n, affinePoint);
            point = p;
            fake = f;
        }
        return $cf51e6787616c60f$var$JacobianPoint.normalizeZ([
            point,
            fake
        ])[0];
    }
    toAffine(invZ) {
        const { x: x, y: y, z: z } = this;
        const is0 = this.equals($cf51e6787616c60f$var$JacobianPoint.ZERO);
        if (invZ == null) invZ = is0 ? $cf51e6787616c60f$var$_8n : $cf51e6787616c60f$var$invert(z);
        const iz1 = invZ;
        const iz2 = $cf51e6787616c60f$var$mod(iz1 * iz1);
        const iz3 = $cf51e6787616c60f$var$mod(iz2 * iz1);
        const ax = $cf51e6787616c60f$var$mod(x * iz2);
        const ay = $cf51e6787616c60f$var$mod(y * iz3);
        const zz = $cf51e6787616c60f$var$mod(z * iz1);
        if (is0) return $cf51e6787616c60f$export$baf26146a414f24a.ZERO;
        if (zz !== $cf51e6787616c60f$var$_1n) throw new Error("invZ was invalid");
        return new $cf51e6787616c60f$export$baf26146a414f24a(ax, ay);
    }
}
$cf51e6787616c60f$var$JacobianPoint.BASE = new $cf51e6787616c60f$var$JacobianPoint($cf51e6787616c60f$export$8ff8607b70325343.Gx, $cf51e6787616c60f$export$8ff8607b70325343.Gy, $cf51e6787616c60f$var$_1n);
$cf51e6787616c60f$var$JacobianPoint.ZERO = new $cf51e6787616c60f$var$JacobianPoint($cf51e6787616c60f$var$_0n, $cf51e6787616c60f$var$_1n, $cf51e6787616c60f$var$_0n);
function $cf51e6787616c60f$var$constTimeNegate(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
const $cf51e6787616c60f$var$pointPrecomputes = new WeakMap();
class $cf51e6787616c60f$export$baf26146a414f24a {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    _setWindowSize(windowSize) {
        this._WINDOW_SIZE = windowSize;
        $cf51e6787616c60f$var$pointPrecomputes.delete(this);
    }
    hasEvenY() {
        return this.y % $cf51e6787616c60f$var$_2n === $cf51e6787616c60f$var$_0n;
    }
    static fromCompressedHex(bytes) {
        const isShort = bytes.length === 32;
        const x = $cf51e6787616c60f$var$bytesToNumber(isShort ? bytes : bytes.subarray(1));
        if (!$cf51e6787616c60f$var$isValidFieldElement(x)) throw new Error("Point is not on curve");
        const y2 = $cf51e6787616c60f$var$weierstrass(x);
        let y = $cf51e6787616c60f$var$sqrtMod(y2);
        const isYOdd = (y & $cf51e6787616c60f$var$_1n) === $cf51e6787616c60f$var$_1n;
        if (isShort) {
            if (isYOdd) y = $cf51e6787616c60f$var$mod(-y);
        } else {
            const isFirstByteOdd = (bytes[0] & 1) === 1;
            if (isFirstByteOdd !== isYOdd) y = $cf51e6787616c60f$var$mod(-y);
        }
        const point = new $cf51e6787616c60f$export$baf26146a414f24a(x, y);
        point.assertValidity();
        return point;
    }
    static fromUncompressedHex(bytes) {
        const x = $cf51e6787616c60f$var$bytesToNumber(bytes.subarray(1, $cf51e6787616c60f$var$fieldLen + 1));
        const y = $cf51e6787616c60f$var$bytesToNumber(bytes.subarray($cf51e6787616c60f$var$fieldLen + 1, $cf51e6787616c60f$var$fieldLen * 2 + 1));
        const point = new $cf51e6787616c60f$export$baf26146a414f24a(x, y);
        point.assertValidity();
        return point;
    }
    static fromHex(hex) {
        const bytes = $cf51e6787616c60f$var$ensureBytes(hex);
        const len = bytes.length;
        const header = bytes[0];
        if (len === $cf51e6787616c60f$var$fieldLen) return this.fromCompressedHex(bytes);
        if (len === $cf51e6787616c60f$var$compressedLen && (header === 0x02 || header === 0x03)) return this.fromCompressedHex(bytes);
        if (len === $cf51e6787616c60f$var$uncompressedLen && header === 0x04) return this.fromUncompressedHex(bytes);
        throw new Error(`Point.fromHex: received invalid point. Expected 32-${$cf51e6787616c60f$var$compressedLen} compressed bytes or ${$cf51e6787616c60f$var$uncompressedLen} uncompressed bytes, not ${len}`);
    }
    static fromPrivateKey(privateKey) {
        return $cf51e6787616c60f$export$baf26146a414f24a.BASE.multiply($cf51e6787616c60f$var$normalizePrivateKey(privateKey));
    }
    static fromSignature(msgHash, signature, recovery) {
        const { r: r, s: s } = $cf51e6787616c60f$var$normalizeSignature(signature);
        if (![
            0,
            1,
            2,
            3
        ].includes(recovery)) throw new Error("Cannot recover: invalid recovery bit");
        const h = $cf51e6787616c60f$var$truncateHash($cf51e6787616c60f$var$ensureBytes(msgHash));
        const { n: n } = $cf51e6787616c60f$export$8ff8607b70325343;
        const radj = recovery === 2 || recovery === 3 ? r + n : r;
        const rinv = $cf51e6787616c60f$var$invert(radj, n);
        const u1 = $cf51e6787616c60f$var$mod(-h * rinv, n);
        const u2 = $cf51e6787616c60f$var$mod(s * rinv, n);
        const prefix = recovery & 1 ? "03" : "02";
        const R = $cf51e6787616c60f$export$baf26146a414f24a.fromHex(prefix + $cf51e6787616c60f$var$numTo32bStr(radj));
        const Q = $cf51e6787616c60f$export$baf26146a414f24a.BASE.multiplyAndAddUnsafe(R, u1, u2);
        if (!Q) throw new Error("Cannot recover signature: point at infinify");
        Q.assertValidity();
        return Q;
    }
    toRawBytes(isCompressed = false) {
        return $cf51e6787616c60f$export$31c96b9df38bc8d4(this.toHex(isCompressed));
    }
    toHex(isCompressed = false) {
        const x = $cf51e6787616c60f$var$numTo32bStr(this.x);
        if (isCompressed) {
            const prefix = this.hasEvenY() ? "02" : "03";
            return `${prefix}${x}`;
        } else return `04${x}${$cf51e6787616c60f$var$numTo32bStr(this.y)}`;
    }
    toHexX() {
        return this.toHex(true).slice(2);
    }
    toRawX() {
        return this.toRawBytes(true).slice(1);
    }
    assertValidity() {
        const msg = "Point is not on elliptic curve";
        const { x: x, y: y } = this;
        if (!$cf51e6787616c60f$var$isValidFieldElement(x) || !$cf51e6787616c60f$var$isValidFieldElement(y)) throw new Error(msg);
        const left = $cf51e6787616c60f$var$mod(y * y);
        const right = $cf51e6787616c60f$var$weierstrass(x);
        if ($cf51e6787616c60f$var$mod(left - right) !== $cf51e6787616c60f$var$_0n) throw new Error(msg);
    }
    equals(other) {
        return this.x === other.x && this.y === other.y;
    }
    negate() {
        return new $cf51e6787616c60f$export$baf26146a414f24a(this.x, $cf51e6787616c60f$var$mod(-this.y));
    }
    double() {
        return $cf51e6787616c60f$var$JacobianPoint.fromAffine(this).double().toAffine();
    }
    add(other) {
        return $cf51e6787616c60f$var$JacobianPoint.fromAffine(this).add($cf51e6787616c60f$var$JacobianPoint.fromAffine(other)).toAffine();
    }
    subtract(other) {
        return this.add(other.negate());
    }
    multiply(scalar) {
        return $cf51e6787616c60f$var$JacobianPoint.fromAffine(this).multiply(scalar, this).toAffine();
    }
    multiplyAndAddUnsafe(Q, a, b) {
        const P = $cf51e6787616c60f$var$JacobianPoint.fromAffine(this);
        const aP = a === $cf51e6787616c60f$var$_0n || a === $cf51e6787616c60f$var$_1n || this !== $cf51e6787616c60f$export$baf26146a414f24a.BASE ? P.multiplyUnsafe(a) : P.multiply(a);
        const bQ = $cf51e6787616c60f$var$JacobianPoint.fromAffine(Q).multiplyUnsafe(b);
        const sum = aP.add(bQ);
        return sum.equals($cf51e6787616c60f$var$JacobianPoint.ZERO) ? undefined : sum.toAffine();
    }
}
$cf51e6787616c60f$export$baf26146a414f24a.BASE = new $cf51e6787616c60f$export$baf26146a414f24a($cf51e6787616c60f$export$8ff8607b70325343.Gx, $cf51e6787616c60f$export$8ff8607b70325343.Gy);
$cf51e6787616c60f$export$baf26146a414f24a.ZERO = new $cf51e6787616c60f$export$baf26146a414f24a($cf51e6787616c60f$var$_0n, $cf51e6787616c60f$var$_0n);
function $cf51e6787616c60f$var$sliceDER(s) {
    return Number.parseInt(s[0], 16) >= 8 ? "00" + s : s;
}
function $cf51e6787616c60f$var$parseDERInt(data) {
    if (data.length < 2 || data[0] !== 0x02) throw new Error(`Invalid signature integer tag: ${$cf51e6787616c60f$export$58b867e287a802c8(data)}`);
    const len = data[1];
    const res = data.subarray(2, len + 2);
    if (!len || res.length !== len) throw new Error(`Invalid signature integer: wrong length`);
    if (res[0] === 0x00 && res[1] <= 0x7f) throw new Error("Invalid signature integer: trailing length");
    return {
        data: $cf51e6787616c60f$var$bytesToNumber(res),
        left: data.subarray(len + 2)
    };
}
function $cf51e6787616c60f$var$parseDERSignature(data) {
    if (data.length < 2 || data[0] != 0x30) throw new Error(`Invalid signature tag: ${$cf51e6787616c60f$export$58b867e287a802c8(data)}`);
    if (data[1] !== data.length - 2) throw new Error("Invalid signature: incorrect length");
    const { data: r, left: sBytes } = $cf51e6787616c60f$var$parseDERInt(data.subarray(2));
    const { data: s, left: rBytesLeft } = $cf51e6787616c60f$var$parseDERInt(sBytes);
    if (rBytesLeft.length) throw new Error(`Invalid signature: left bytes after parsing: ${$cf51e6787616c60f$export$58b867e287a802c8(rBytesLeft)}`);
    return {
        r: r,
        s: s
    };
}
class $cf51e6787616c60f$export$848620f5f2f26e86 {
    constructor(r, s){
        this.r = r;
        this.s = s;
        this.assertValidity();
    }
    static fromCompact(hex) {
        const arr = $cf51e6787616c60f$var$isBytes(hex);
        const name = "Signature.fromCompact";
        if (typeof hex !== "string" && !arr) throw new TypeError(`${name}: Expected string or Uint8Array`);
        const str = arr ? $cf51e6787616c60f$export$58b867e287a802c8(hex) : hex;
        if (str.length !== 128) throw new Error(`${name}: Expected 64-byte hex`);
        return new $cf51e6787616c60f$export$848620f5f2f26e86($cf51e6787616c60f$var$hexToNumber(str.slice(0, 64)), $cf51e6787616c60f$var$hexToNumber(str.slice(64, 128)));
    }
    static fromDER(hex) {
        const arr = $cf51e6787616c60f$var$isBytes(hex);
        if (typeof hex !== "string" && !arr) throw new TypeError(`Signature.fromDER: Expected string or Uint8Array`);
        const { r: r, s: s } = $cf51e6787616c60f$var$parseDERSignature(arr ? hex : $cf51e6787616c60f$export$31c96b9df38bc8d4(hex));
        return new $cf51e6787616c60f$export$848620f5f2f26e86(r, s);
    }
    static fromHex(hex) {
        return this.fromDER(hex);
    }
    assertValidity() {
        const { r: r, s: s } = this;
        if (!$cf51e6787616c60f$var$isWithinCurveOrder(r)) throw new Error("Invalid Signature: r must be 0 < r < n");
        if (!$cf51e6787616c60f$var$isWithinCurveOrder(s)) throw new Error("Invalid Signature: s must be 0 < s < n");
    }
    hasHighS() {
        const HALF = $cf51e6787616c60f$export$8ff8607b70325343.n >> $cf51e6787616c60f$var$_1n;
        return this.s > HALF;
    }
    normalizeS() {
        return this.hasHighS() ? new $cf51e6787616c60f$export$848620f5f2f26e86(this.r, $cf51e6787616c60f$var$mod(-this.s, $cf51e6787616c60f$export$8ff8607b70325343.n)) : this;
    }
    toDERRawBytes() {
        return $cf51e6787616c60f$export$31c96b9df38bc8d4(this.toDERHex());
    }
    toDERHex() {
        const sHex = $cf51e6787616c60f$var$sliceDER($cf51e6787616c60f$var$numberToHexUnpadded(this.s));
        const rHex = $cf51e6787616c60f$var$sliceDER($cf51e6787616c60f$var$numberToHexUnpadded(this.r));
        const sHexL = sHex.length / 2;
        const rHexL = rHex.length / 2;
        const sLen = $cf51e6787616c60f$var$numberToHexUnpadded(sHexL);
        const rLen = $cf51e6787616c60f$var$numberToHexUnpadded(rHexL);
        const length = $cf51e6787616c60f$var$numberToHexUnpadded(rHexL + sHexL + 4);
        return `30${length}02${rLen}${rHex}02${sLen}${sHex}`;
    }
    toRawBytes() {
        return this.toDERRawBytes();
    }
    toHex() {
        return this.toDERHex();
    }
    toCompactRawBytes() {
        return $cf51e6787616c60f$export$31c96b9df38bc8d4(this.toCompactHex());
    }
    toCompactHex() {
        return $cf51e6787616c60f$var$numTo32bStr(this.r) + $cf51e6787616c60f$var$numTo32bStr(this.s);
    }
}
function $cf51e6787616c60f$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === "Uint8Array";
}
function $cf51e6787616c60f$var$abytes(item) {
    if (!$cf51e6787616c60f$var$isBytes(item)) throw new Error("Uint8Array expected");
}
function $cf51e6787616c60f$var$concatBytes(...arrays) {
    arrays.every($cf51e6787616c60f$var$abytes);
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
const $cf51e6787616c60f$var$hexes = Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $cf51e6787616c60f$export$58b867e287a802c8(bytes) {
    $cf51e6787616c60f$var$abytes(bytes);
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $cf51e6787616c60f$var$hexes[bytes[i]];
    return hex;
}
const $cf51e6787616c60f$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $cf51e6787616c60f$var$asciiToBase16(ch) {
    if (ch >= $cf51e6787616c60f$var$asciis._0 && ch <= $cf51e6787616c60f$var$asciis._9) return ch - $cf51e6787616c60f$var$asciis._0;
    if (ch >= $cf51e6787616c60f$var$asciis.A && ch <= $cf51e6787616c60f$var$asciis.F) return ch - ($cf51e6787616c60f$var$asciis.A - 10);
    if (ch >= $cf51e6787616c60f$var$asciis.a && ch <= $cf51e6787616c60f$var$asciis.f) return ch - ($cf51e6787616c60f$var$asciis.a - 10);
    return;
}
function $cf51e6787616c60f$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $cf51e6787616c60f$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $cf51e6787616c60f$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
const $cf51e6787616c60f$var$POW_2_256 = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000");
function $cf51e6787616c60f$var$numTo32bStr(num) {
    if (typeof num !== "bigint") throw new Error("Expected bigint");
    if (!($cf51e6787616c60f$var$_0n <= num && num < $cf51e6787616c60f$var$POW_2_256)) throw new Error("Expected number 0 <= n < 2^256");
    return num.toString(16).padStart(64, "0");
}
function $cf51e6787616c60f$var$numTo32b(num) {
    const b = $cf51e6787616c60f$export$31c96b9df38bc8d4($cf51e6787616c60f$var$numTo32bStr(num));
    if (b.length !== 32) throw new Error("Error: expected 32 bytes");
    return b;
}
function $cf51e6787616c60f$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function $cf51e6787616c60f$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToNumber: expected string, got " + typeof hex);
    return BigInt(`0x${hex}`);
}
function $cf51e6787616c60f$var$bytesToNumber(bytes) {
    return $cf51e6787616c60f$var$hexToNumber($cf51e6787616c60f$export$58b867e287a802c8(bytes));
}
function $cf51e6787616c60f$var$ensureBytes(hex) {
    return $cf51e6787616c60f$var$isBytes(hex) ? Uint8Array.from(hex) : $cf51e6787616c60f$export$31c96b9df38bc8d4(hex);
}
function $cf51e6787616c60f$var$normalizeScalar(num) {
    if (typeof num === "number" && Number.isSafeInteger(num) && num > 0) return BigInt(num);
    if (typeof num === "bigint" && $cf51e6787616c60f$var$isWithinCurveOrder(num)) return num;
    throw new TypeError("Expected valid private scalar: 0 < scalar < curve.n");
}
function $cf51e6787616c60f$var$mod(a, b = $cf51e6787616c60f$export$8ff8607b70325343.P) {
    const result = a % b;
    return result >= $cf51e6787616c60f$var$_0n ? result : b + result;
}
function $cf51e6787616c60f$var$pow2(x, power) {
    const { P: P } = $cf51e6787616c60f$export$8ff8607b70325343;
    let res = x;
    while(power-- > $cf51e6787616c60f$var$_0n){
        res *= res;
        res %= P;
    }
    return res;
}
function $cf51e6787616c60f$var$sqrtMod(x) {
    const { P: P } = $cf51e6787616c60f$export$8ff8607b70325343;
    const _6n = BigInt(6);
    const _11n = BigInt(11);
    const _22n = BigInt(22);
    const _23n = BigInt(23);
    const _44n = BigInt(44);
    const _88n = BigInt(88);
    const b2 = x * x * x % P;
    const b3 = b2 * b2 * x % P;
    const b6 = $cf51e6787616c60f$var$pow2(b3, $cf51e6787616c60f$var$_3n) * b3 % P;
    const b9 = $cf51e6787616c60f$var$pow2(b6, $cf51e6787616c60f$var$_3n) * b3 % P;
    const b11 = $cf51e6787616c60f$var$pow2(b9, $cf51e6787616c60f$var$_2n) * b2 % P;
    const b22 = $cf51e6787616c60f$var$pow2(b11, _11n) * b11 % P;
    const b44 = $cf51e6787616c60f$var$pow2(b22, _22n) * b22 % P;
    const b88 = $cf51e6787616c60f$var$pow2(b44, _44n) * b44 % P;
    const b176 = $cf51e6787616c60f$var$pow2(b88, _88n) * b88 % P;
    const b220 = $cf51e6787616c60f$var$pow2(b176, _44n) * b44 % P;
    const b223 = $cf51e6787616c60f$var$pow2(b220, $cf51e6787616c60f$var$_3n) * b3 % P;
    const t1 = $cf51e6787616c60f$var$pow2(b223, _23n) * b22 % P;
    const t2 = $cf51e6787616c60f$var$pow2(t1, _6n) * b2 % P;
    const rt = $cf51e6787616c60f$var$pow2(t2, $cf51e6787616c60f$var$_2n);
    const xc = rt * rt % P;
    if (xc !== x) throw new Error("Cannot find square root");
    return rt;
}
function $cf51e6787616c60f$var$invert(number, modulo = $cf51e6787616c60f$export$8ff8607b70325343.P) {
    if (number === $cf51e6787616c60f$var$_0n || modulo <= $cf51e6787616c60f$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    let a = $cf51e6787616c60f$var$mod(number, modulo);
    let b = modulo;
    let x = $cf51e6787616c60f$var$_0n, y = $cf51e6787616c60f$var$_1n, u = $cf51e6787616c60f$var$_1n, v = $cf51e6787616c60f$var$_0n;
    while(a !== $cf51e6787616c60f$var$_0n){
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $cf51e6787616c60f$var$_1n) throw new Error("invert: does not exist");
    return $cf51e6787616c60f$var$mod(x, modulo);
}
function $cf51e6787616c60f$var$invertBatch(nums, p = $cf51e6787616c60f$export$8ff8607b70325343.P) {
    const scratch = new Array(nums.length);
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (num === $cf51e6787616c60f$var$_0n) return acc;
        scratch[i] = acc;
        return $cf51e6787616c60f$var$mod(acc * num, p);
    }, $cf51e6787616c60f$var$_1n);
    const inverted = $cf51e6787616c60f$var$invert(lastMultiplied, p);
    nums.reduceRight((acc, num, i)=>{
        if (num === $cf51e6787616c60f$var$_0n) return acc;
        scratch[i] = $cf51e6787616c60f$var$mod(acc * scratch[i], p);
        return $cf51e6787616c60f$var$mod(acc * num, p);
    }, inverted);
    return scratch;
}
function $cf51e6787616c60f$var$bits2int_2(bytes) {
    const delta = bytes.length * 8 - $cf51e6787616c60f$var$groupLen * 8;
    const num = $cf51e6787616c60f$var$bytesToNumber(bytes);
    return delta > 0 ? num >> BigInt(delta) : num;
}
function $cf51e6787616c60f$var$truncateHash(hash, truncateOnly = false) {
    const h = $cf51e6787616c60f$var$bits2int_2(hash);
    if (truncateOnly) return h;
    const { n: n } = $cf51e6787616c60f$export$8ff8607b70325343;
    return h >= n ? h - n : h;
}
let $cf51e6787616c60f$var$_sha256Sync;
let $cf51e6787616c60f$var$_hmacSha256Sync;
class $cf51e6787616c60f$var$HmacDrbg {
    constructor(hashLen, qByteLen){
        this.hashLen = hashLen;
        this.qByteLen = qByteLen;
        if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
        if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
        this.v = new Uint8Array(hashLen).fill(1);
        this.k = new Uint8Array(hashLen).fill(0);
        this.counter = 0;
    }
    hmac(...values) {
        return $cf51e6787616c60f$export$eab97d15b1788b8d.hmacSha256(this.k, ...values);
    }
    hmacSync(...values) {
        return $cf51e6787616c60f$var$_hmacSha256Sync(this.k, ...values);
    }
    checkSync() {
        if (typeof $cf51e6787616c60f$var$_hmacSha256Sync !== "function") throw new $cf51e6787616c60f$var$ShaError("hmacSha256Sync needs to be set");
    }
    incr() {
        if (this.counter >= 1000) throw new Error("Tried 1,000 k values for sign(), all were invalid");
        this.counter += 1;
    }
    async reseed(seed = new Uint8Array()) {
        this.k = await this.hmac(this.v, Uint8Array.from([
            0x00
        ]), seed);
        this.v = await this.hmac(this.v);
        if (seed.length === 0) return;
        this.k = await this.hmac(this.v, Uint8Array.from([
            0x01
        ]), seed);
        this.v = await this.hmac(this.v);
    }
    reseedSync(seed = new Uint8Array()) {
        this.checkSync();
        this.k = this.hmacSync(this.v, Uint8Array.from([
            0x00
        ]), seed);
        this.v = this.hmacSync(this.v);
        if (seed.length === 0) return;
        this.k = this.hmacSync(this.v, Uint8Array.from([
            0x01
        ]), seed);
        this.v = this.hmacSync(this.v);
    }
    async generate() {
        this.incr();
        let len = 0;
        const out = [];
        while(len < this.qByteLen){
            this.v = await this.hmac(this.v);
            const sl = this.v.slice();
            out.push(sl);
            len += this.v.length;
        }
        return $cf51e6787616c60f$var$concatBytes(...out);
    }
    generateSync() {
        this.checkSync();
        this.incr();
        let len = 0;
        const out = [];
        while(len < this.qByteLen){
            this.v = this.hmacSync(this.v);
            const sl = this.v.slice();
            out.push(sl);
            len += this.v.length;
        }
        return $cf51e6787616c60f$var$concatBytes(...out);
    }
}
function $cf51e6787616c60f$var$isWithinCurveOrder(num) {
    return $cf51e6787616c60f$var$_0n < num && num < $cf51e6787616c60f$export$8ff8607b70325343.n;
}
function $cf51e6787616c60f$var$isValidFieldElement(num) {
    return $cf51e6787616c60f$var$_0n < num && num < $cf51e6787616c60f$export$8ff8607b70325343.P;
}
function $cf51e6787616c60f$var$kmdToSig(kBytes, m, d, lowS = true) {
    const { n: n } = $cf51e6787616c60f$export$8ff8607b70325343;
    const k = $cf51e6787616c60f$var$truncateHash(kBytes, true);
    if (!$cf51e6787616c60f$var$isWithinCurveOrder(k)) return;
    const kinv = $cf51e6787616c60f$var$invert(k, n);
    const q = $cf51e6787616c60f$export$baf26146a414f24a.BASE.multiply(k);
    const r = $cf51e6787616c60f$var$mod(q.x, n);
    if (r === $cf51e6787616c60f$var$_0n) return;
    const s = $cf51e6787616c60f$var$mod(kinv * $cf51e6787616c60f$var$mod(m + d * r, n), n);
    if (s === $cf51e6787616c60f$var$_0n) return;
    let sig = new $cf51e6787616c60f$export$848620f5f2f26e86(r, s);
    let recovery = (q.x === sig.r ? 0 : 2) | Number(q.y & $cf51e6787616c60f$var$_1n);
    if (lowS && sig.hasHighS()) {
        sig = sig.normalizeS();
        recovery ^= 1;
    }
    return {
        sig: sig,
        recovery: recovery
    };
}
function $cf51e6787616c60f$var$normalizePrivateKey(key) {
    let num;
    if (typeof key === "bigint") num = key;
    else if (typeof key === "number" && Number.isSafeInteger(key) && key > 0) num = BigInt(key);
    else if (typeof key === "string") {
        if (key.length !== 2 * $cf51e6787616c60f$var$groupLen) throw new Error("Expected 32 bytes of private key");
        num = $cf51e6787616c60f$var$hexToNumber(key);
    } else if ($cf51e6787616c60f$var$isBytes(key)) {
        if (key.length !== $cf51e6787616c60f$var$groupLen) throw new Error("Expected 32 bytes of private key");
        num = $cf51e6787616c60f$var$bytesToNumber(key);
    } else throw new TypeError("Expected valid private key");
    if (!$cf51e6787616c60f$var$isWithinCurveOrder(num)) throw new Error("Expected private key: 0 < key < n");
    return num;
}
function $cf51e6787616c60f$var$normalizePublicKey(publicKey) {
    if (publicKey instanceof $cf51e6787616c60f$export$baf26146a414f24a) {
        publicKey.assertValidity();
        return publicKey;
    } else return $cf51e6787616c60f$export$baf26146a414f24a.fromHex(publicKey);
}
function $cf51e6787616c60f$var$normalizeSignature(signature) {
    if (signature instanceof $cf51e6787616c60f$export$848620f5f2f26e86) {
        signature.assertValidity();
        return signature;
    }
    try {
        return $cf51e6787616c60f$export$848620f5f2f26e86.fromDER(signature);
    } catch (error) {
        return $cf51e6787616c60f$export$848620f5f2f26e86.fromCompact(signature);
    }
}
function $cf51e6787616c60f$export$889def73691f9837(privateKey, isCompressed = false) {
    return $cf51e6787616c60f$export$baf26146a414f24a.fromPrivateKey(privateKey).toRawBytes(isCompressed);
}
function $cf51e6787616c60f$export$952dd09fbe0232b7(msgHash, signature, recovery, isCompressed = false) {
    return $cf51e6787616c60f$export$baf26146a414f24a.fromSignature(msgHash, signature, recovery).toRawBytes(isCompressed);
}
function $cf51e6787616c60f$var$isProbPub(item) {
    const arr = $cf51e6787616c60f$var$isBytes(item);
    const str = typeof item === "string";
    const len = (arr || str) && item.length;
    if (arr) return len === $cf51e6787616c60f$var$compressedLen || len === $cf51e6787616c60f$var$uncompressedLen;
    if (str) return len === $cf51e6787616c60f$var$compressedLen * 2 || len === $cf51e6787616c60f$var$uncompressedLen * 2;
    if (item instanceof $cf51e6787616c60f$export$baf26146a414f24a) return true;
    return false;
}
function $cf51e6787616c60f$export$151f26f9d84a2c64(privateA, publicB, isCompressed = false) {
    if ($cf51e6787616c60f$var$isProbPub(privateA)) throw new TypeError("getSharedSecret: first arg must be private key");
    if (!$cf51e6787616c60f$var$isProbPub(publicB)) throw new TypeError("getSharedSecret: second arg must be public key");
    const b = $cf51e6787616c60f$var$normalizePublicKey(publicB);
    b.assertValidity();
    return b.multiply($cf51e6787616c60f$var$normalizePrivateKey(privateA)).toRawBytes(isCompressed);
}
function $cf51e6787616c60f$var$bits2int(bytes) {
    const slice = bytes.length > $cf51e6787616c60f$var$fieldLen ? bytes.slice(0, $cf51e6787616c60f$var$fieldLen) : bytes;
    return $cf51e6787616c60f$var$bytesToNumber(slice);
}
function $cf51e6787616c60f$var$bits2octets(bytes) {
    const z1 = $cf51e6787616c60f$var$bits2int(bytes);
    const z2 = $cf51e6787616c60f$var$mod(z1, $cf51e6787616c60f$export$8ff8607b70325343.n);
    return $cf51e6787616c60f$var$int2octets(z2 < $cf51e6787616c60f$var$_0n ? z1 : z2);
}
function $cf51e6787616c60f$var$int2octets(num) {
    return $cf51e6787616c60f$var$numTo32b(num);
}
function $cf51e6787616c60f$var$initSigArgs(msgHash, privateKey, extraEntropy) {
    if (msgHash == null) throw new Error(`sign: expected valid message hash, not "${msgHash}"`);
    const h1 = $cf51e6787616c60f$var$ensureBytes(msgHash);
    const d = $cf51e6787616c60f$var$normalizePrivateKey(privateKey);
    const seedArgs = [
        $cf51e6787616c60f$var$int2octets(d),
        $cf51e6787616c60f$var$bits2octets(h1)
    ];
    if (extraEntropy != null) {
        if (extraEntropy === true) extraEntropy = $cf51e6787616c60f$export$eab97d15b1788b8d.randomBytes($cf51e6787616c60f$var$fieldLen);
        const e = $cf51e6787616c60f$var$ensureBytes(extraEntropy);
        if (e.length !== $cf51e6787616c60f$var$fieldLen) throw new Error(`sign: Expected ${$cf51e6787616c60f$var$fieldLen} bytes of extra data`);
        seedArgs.push(e);
    }
    const seed = $cf51e6787616c60f$var$concatBytes(...seedArgs);
    const m = $cf51e6787616c60f$var$bits2int(h1);
    return {
        seed: seed,
        m: m,
        d: d
    };
}
function $cf51e6787616c60f$var$finalizeSig(recSig, opts) {
    const { sig: sig, recovery: recovery } = recSig;
    const { der: der, recovered: recovered } = Object.assign({
        canonical: true,
        der: true
    }, opts);
    const hashed = der ? sig.toDERRawBytes() : sig.toCompactRawBytes();
    return recovered ? [
        hashed,
        recovery
    ] : hashed;
}
async function $cf51e6787616c60f$export$c5552dfdbc7cec71(msgHash, privKey, opts = {}) {
    const { seed: seed, m: m, d: d } = $cf51e6787616c60f$var$initSigArgs(msgHash, privKey, opts.extraEntropy);
    const drbg = new $cf51e6787616c60f$var$HmacDrbg($cf51e6787616c60f$var$hashLen, $cf51e6787616c60f$var$groupLen);
    await drbg.reseed(seed);
    let sig;
    while(!(sig = $cf51e6787616c60f$var$kmdToSig(await drbg.generate(), m, d, opts.canonical)))await drbg.reseed();
    return $cf51e6787616c60f$var$finalizeSig(sig, opts);
}
function $cf51e6787616c60f$export$6ff6692656050317(msgHash, privKey, opts = {}) {
    const { seed: seed, m: m, d: d } = $cf51e6787616c60f$var$initSigArgs(msgHash, privKey, opts.extraEntropy);
    const drbg = new $cf51e6787616c60f$var$HmacDrbg($cf51e6787616c60f$var$hashLen, $cf51e6787616c60f$var$groupLen);
    drbg.reseedSync(seed);
    let sig;
    while(!(sig = $cf51e6787616c60f$var$kmdToSig(drbg.generateSync(), m, d, opts.canonical)))drbg.reseedSync();
    return $cf51e6787616c60f$var$finalizeSig(sig, opts);
}
const $cf51e6787616c60f$var$vopts = {
    strict: true
};
function $cf51e6787616c60f$export$532244b5b8b0b4b6(signature, msgHash, publicKey, opts = $cf51e6787616c60f$var$vopts) {
    let sig;
    try {
        sig = $cf51e6787616c60f$var$normalizeSignature(signature);
        msgHash = $cf51e6787616c60f$var$ensureBytes(msgHash);
    } catch (error) {
        return false;
    }
    const { r: r, s: s } = sig;
    if (opts.strict && sig.hasHighS()) return false;
    const h = $cf51e6787616c60f$var$truncateHash(msgHash);
    let P;
    try {
        P = $cf51e6787616c60f$var$normalizePublicKey(publicKey);
    } catch (error) {
        return false;
    }
    const { n: n } = $cf51e6787616c60f$export$8ff8607b70325343;
    const sinv = $cf51e6787616c60f$var$invert(s, n);
    const u1 = $cf51e6787616c60f$var$mod(h * sinv, n);
    const u2 = $cf51e6787616c60f$var$mod(r * sinv, n);
    const R = $cf51e6787616c60f$export$baf26146a414f24a.BASE.multiplyAndAddUnsafe(P, u1, u2);
    if (!R) return false;
    const v = $cf51e6787616c60f$var$mod(R.x, n);
    return v === r;
}
function $cf51e6787616c60f$var$schnorrChallengeFinalize(ch) {
    return $cf51e6787616c60f$var$mod($cf51e6787616c60f$var$bytesToNumber(ch), $cf51e6787616c60f$export$8ff8607b70325343.n);
}
class $cf51e6787616c60f$var$SchnorrSignature {
    constructor(r, s){
        this.r = r;
        this.s = s;
        this.assertValidity();
    }
    static fromHex(hex) {
        const bytes = $cf51e6787616c60f$var$ensureBytes(hex);
        if (bytes.length !== 64) throw new TypeError(`SchnorrSignature.fromHex: expected 64 bytes, not ${bytes.length}`);
        const r = $cf51e6787616c60f$var$bytesToNumber(bytes.subarray(0, 32));
        const s = $cf51e6787616c60f$var$bytesToNumber(bytes.subarray(32, 64));
        return new $cf51e6787616c60f$var$SchnorrSignature(r, s);
    }
    assertValidity() {
        const { r: r, s: s } = this;
        if (!$cf51e6787616c60f$var$isValidFieldElement(r) || !$cf51e6787616c60f$var$isWithinCurveOrder(s)) throw new Error("Invalid signature");
    }
    toHex() {
        return $cf51e6787616c60f$var$numTo32bStr(this.r) + $cf51e6787616c60f$var$numTo32bStr(this.s);
    }
    toRawBytes() {
        return $cf51e6787616c60f$export$31c96b9df38bc8d4(this.toHex());
    }
}
function $cf51e6787616c60f$var$schnorrGetPublicKey(privateKey) {
    return $cf51e6787616c60f$export$baf26146a414f24a.fromPrivateKey(privateKey).toRawX();
}
class $cf51e6787616c60f$var$InternalSchnorrSignature {
    constructor(message, privateKey, auxRand = $cf51e6787616c60f$export$eab97d15b1788b8d.randomBytes()){
        if (message == null) throw new TypeError(`sign: Expected valid message, not "${message}"`);
        this.m = $cf51e6787616c60f$var$ensureBytes(message);
        const { x: x, scalar: scalar } = this.getScalar($cf51e6787616c60f$var$normalizePrivateKey(privateKey));
        this.px = x;
        this.d = scalar;
        this.rand = $cf51e6787616c60f$var$ensureBytes(auxRand);
        if (this.rand.length !== 32) throw new TypeError("sign: Expected 32 bytes of aux randomness");
    }
    getScalar(priv) {
        const point = $cf51e6787616c60f$export$baf26146a414f24a.fromPrivateKey(priv);
        const scalar = point.hasEvenY() ? priv : $cf51e6787616c60f$export$8ff8607b70325343.n - priv;
        return {
            point: point,
            scalar: scalar,
            x: point.toRawX()
        };
    }
    initNonce(d, t0h) {
        return $cf51e6787616c60f$var$numTo32b(d ^ $cf51e6787616c60f$var$bytesToNumber(t0h));
    }
    finalizeNonce(k0h) {
        const k0 = $cf51e6787616c60f$var$mod($cf51e6787616c60f$var$bytesToNumber(k0h), $cf51e6787616c60f$export$8ff8607b70325343.n);
        if (k0 === $cf51e6787616c60f$var$_0n) throw new Error("sign: Creation of signature failed. k is zero");
        const { point: R, x: rx, scalar: k } = this.getScalar(k0);
        return {
            R: R,
            rx: rx,
            k: k
        };
    }
    finalizeSig(R, k, e, d) {
        return new $cf51e6787616c60f$var$SchnorrSignature(R.x, $cf51e6787616c60f$var$mod(k + e * d, $cf51e6787616c60f$export$8ff8607b70325343.n)).toRawBytes();
    }
    error() {
        throw new Error("sign: Invalid signature produced");
    }
    async calc() {
        const { m: m, d: d, px: px, rand: rand } = this;
        const tag = $cf51e6787616c60f$export$eab97d15b1788b8d.taggedHash;
        const t = this.initNonce(d, await tag($cf51e6787616c60f$var$TAGS.aux, rand));
        const { R: R, rx: rx, k: k } = this.finalizeNonce(await tag($cf51e6787616c60f$var$TAGS.nonce, t, px, m));
        const e = $cf51e6787616c60f$var$schnorrChallengeFinalize(await tag($cf51e6787616c60f$var$TAGS.challenge, rx, px, m));
        const sig = this.finalizeSig(R, k, e, d);
        if (!await $cf51e6787616c60f$var$schnorrVerify(sig, m, px)) this.error();
        return sig;
    }
    calcSync() {
        const { m: m, d: d, px: px, rand: rand } = this;
        const tag = $cf51e6787616c60f$export$eab97d15b1788b8d.taggedHashSync;
        const t = this.initNonce(d, tag($cf51e6787616c60f$var$TAGS.aux, rand));
        const { R: R, rx: rx, k: k } = this.finalizeNonce(tag($cf51e6787616c60f$var$TAGS.nonce, t, px, m));
        const e = $cf51e6787616c60f$var$schnorrChallengeFinalize(tag($cf51e6787616c60f$var$TAGS.challenge, rx, px, m));
        const sig = this.finalizeSig(R, k, e, d);
        if (!$cf51e6787616c60f$var$schnorrVerifySync(sig, m, px)) this.error();
        return sig;
    }
}
async function $cf51e6787616c60f$var$schnorrSign(msg, privKey, auxRand) {
    return new $cf51e6787616c60f$var$InternalSchnorrSignature(msg, privKey, auxRand).calc();
}
function $cf51e6787616c60f$var$schnorrSignSync(msg, privKey, auxRand) {
    return new $cf51e6787616c60f$var$InternalSchnorrSignature(msg, privKey, auxRand).calcSync();
}
function $cf51e6787616c60f$var$initSchnorrVerify(signature, message, publicKey) {
    const raw = signature instanceof $cf51e6787616c60f$var$SchnorrSignature;
    const sig = raw ? signature : $cf51e6787616c60f$var$SchnorrSignature.fromHex(signature);
    if (raw) sig.assertValidity();
    return {
        ...sig,
        m: $cf51e6787616c60f$var$ensureBytes(message),
        P: $cf51e6787616c60f$var$normalizePublicKey(publicKey)
    };
}
function $cf51e6787616c60f$var$finalizeSchnorrVerify(r, P, s, e) {
    const R = $cf51e6787616c60f$export$baf26146a414f24a.BASE.multiplyAndAddUnsafe(P, $cf51e6787616c60f$var$normalizePrivateKey(s), $cf51e6787616c60f$var$mod(-e, $cf51e6787616c60f$export$8ff8607b70325343.n));
    if (!R || !R.hasEvenY() || R.x !== r) return false;
    return true;
}
async function $cf51e6787616c60f$var$schnorrVerify(signature, message, publicKey) {
    try {
        const { r: r, s: s, m: m, P: P } = $cf51e6787616c60f$var$initSchnorrVerify(signature, message, publicKey);
        const e = $cf51e6787616c60f$var$schnorrChallengeFinalize(await $cf51e6787616c60f$export$eab97d15b1788b8d.taggedHash($cf51e6787616c60f$var$TAGS.challenge, $cf51e6787616c60f$var$numTo32b(r), P.toRawX(), m));
        return $cf51e6787616c60f$var$finalizeSchnorrVerify(r, P, s, e);
    } catch (error) {
        return false;
    }
}
function $cf51e6787616c60f$var$schnorrVerifySync(signature, message, publicKey) {
    try {
        const { r: r, s: s, m: m, P: P } = $cf51e6787616c60f$var$initSchnorrVerify(signature, message, publicKey);
        const e = $cf51e6787616c60f$var$schnorrChallengeFinalize($cf51e6787616c60f$export$eab97d15b1788b8d.taggedHashSync($cf51e6787616c60f$var$TAGS.challenge, $cf51e6787616c60f$var$numTo32b(r), P.toRawX(), m));
        return $cf51e6787616c60f$var$finalizeSchnorrVerify(r, P, s, e);
    } catch (error) {
        if (error instanceof $cf51e6787616c60f$var$ShaError) throw error;
        return false;
    }
}
const $cf51e6787616c60f$export$1f2401df071be9f = {
    Signature: $cf51e6787616c60f$var$SchnorrSignature,
    getPublicKey: $cf51e6787616c60f$var$schnorrGetPublicKey,
    sign: $cf51e6787616c60f$var$schnorrSign,
    verify: $cf51e6787616c60f$var$schnorrVerify,
    signSync: $cf51e6787616c60f$var$schnorrSignSync,
    verifySync: $cf51e6787616c60f$var$schnorrVerifySync
};
$cf51e6787616c60f$export$baf26146a414f24a.BASE._setWindowSize(8);
const $cf51e6787616c60f$var$crypto = {
    node: $7jzxY,
    web: typeof self === "object" && "crypto" in self ? self.crypto : undefined
};
const $cf51e6787616c60f$var$TAGS = {
    challenge: "BIP0340/challenge",
    aux: "BIP0340/aux",
    nonce: "BIP0340/nonce"
};
const $cf51e6787616c60f$var$TAGGED_HASH_PREFIXES = {};
const $cf51e6787616c60f$export$eab97d15b1788b8d = {
    bytesToHex: $cf51e6787616c60f$export$58b867e287a802c8,
    hexToBytes: $cf51e6787616c60f$export$31c96b9df38bc8d4,
    concatBytes: $cf51e6787616c60f$var$concatBytes,
    mod: $cf51e6787616c60f$var$mod,
    invert: $cf51e6787616c60f$var$invert,
    isValidPrivateKey (privateKey) {
        try {
            $cf51e6787616c60f$var$normalizePrivateKey(privateKey);
            return true;
        } catch (error) {
            return false;
        }
    },
    _bigintTo32Bytes: $cf51e6787616c60f$var$numTo32b,
    _normalizePrivateKey: $cf51e6787616c60f$var$normalizePrivateKey,
    hashToPrivateKey: (hash)=>{
        hash = $cf51e6787616c60f$var$ensureBytes(hash);
        const minLen = $cf51e6787616c60f$var$groupLen + 8;
        if (hash.length < minLen || hash.length > 1024) throw new Error(`Expected valid bytes of private key as per FIPS 186`);
        const num = $cf51e6787616c60f$var$mod($cf51e6787616c60f$var$bytesToNumber(hash), $cf51e6787616c60f$export$8ff8607b70325343.n - $cf51e6787616c60f$var$_1n) + $cf51e6787616c60f$var$_1n;
        return $cf51e6787616c60f$var$numTo32b(num);
    },
    randomBytes: (bytesLength = 32)=>{
        if ($cf51e6787616c60f$var$crypto.web) return $cf51e6787616c60f$var$crypto.web.getRandomValues(new Uint8Array(bytesLength));
        else if ($cf51e6787616c60f$var$crypto.node) {
            const { randomBytes: randomBytes } = $cf51e6787616c60f$var$crypto.node;
            return Uint8Array.from(randomBytes(bytesLength));
        } else throw new Error("The environment doesn't have randomBytes function");
    },
    randomPrivateKey: ()=>$cf51e6787616c60f$export$eab97d15b1788b8d.hashToPrivateKey($cf51e6787616c60f$export$eab97d15b1788b8d.randomBytes($cf51e6787616c60f$var$groupLen + 8)),
    precompute (windowSize = 8, point = $cf51e6787616c60f$export$baf26146a414f24a.BASE) {
        const cached = point === $cf51e6787616c60f$export$baf26146a414f24a.BASE ? point : new $cf51e6787616c60f$export$baf26146a414f24a(point.x, point.y);
        cached._setWindowSize(windowSize);
        cached.multiply($cf51e6787616c60f$var$_3n);
        return cached;
    },
    sha256: async (...messages)=>{
        if ($cf51e6787616c60f$var$crypto.web) {
            const buffer = await $cf51e6787616c60f$var$crypto.web.subtle.digest("SHA-256", $cf51e6787616c60f$var$concatBytes(...messages));
            return new Uint8Array(buffer);
        } else if ($cf51e6787616c60f$var$crypto.node) {
            const { createHash: createHash } = $cf51e6787616c60f$var$crypto.node;
            const hash = createHash("sha256");
            messages.forEach((m)=>hash.update(m));
            return Uint8Array.from(hash.digest());
        } else throw new Error("The environment doesn't have sha256 function");
    },
    hmacSha256: async (key, ...messages)=>{
        if ($cf51e6787616c60f$var$crypto.web) {
            const ckey = await $cf51e6787616c60f$var$crypto.web.subtle.importKey("raw", key, {
                name: "HMAC",
                hash: {
                    name: "SHA-256"
                }
            }, false, [
                "sign"
            ]);
            const message = $cf51e6787616c60f$var$concatBytes(...messages);
            const buffer = await $cf51e6787616c60f$var$crypto.web.subtle.sign("HMAC", ckey, message);
            return new Uint8Array(buffer);
        } else if ($cf51e6787616c60f$var$crypto.node) {
            const { createHmac: createHmac } = $cf51e6787616c60f$var$crypto.node;
            const hash = createHmac("sha256", key);
            messages.forEach((m)=>hash.update(m));
            return Uint8Array.from(hash.digest());
        } else throw new Error("The environment doesn't have hmac-sha256 function");
    },
    sha256Sync: undefined,
    hmacSha256Sync: undefined,
    taggedHash: async (tag, ...messages)=>{
        let tagP = $cf51e6787616c60f$var$TAGGED_HASH_PREFIXES[tag];
        if (tagP === undefined) {
            const tagH = await $cf51e6787616c60f$export$eab97d15b1788b8d.sha256(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
            tagP = $cf51e6787616c60f$var$concatBytes(tagH, tagH);
            $cf51e6787616c60f$var$TAGGED_HASH_PREFIXES[tag] = tagP;
        }
        return $cf51e6787616c60f$export$eab97d15b1788b8d.sha256(tagP, ...messages);
    },
    taggedHashSync: (tag, ...messages)=>{
        if (typeof $cf51e6787616c60f$var$_sha256Sync !== "function") throw new $cf51e6787616c60f$var$ShaError("sha256Sync is undefined, you need to set it");
        let tagP = $cf51e6787616c60f$var$TAGGED_HASH_PREFIXES[tag];
        if (tagP === undefined) {
            const tagH = $cf51e6787616c60f$var$_sha256Sync(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
            tagP = $cf51e6787616c60f$var$concatBytes(tagH, tagH);
            $cf51e6787616c60f$var$TAGGED_HASH_PREFIXES[tag] = tagP;
        }
        return $cf51e6787616c60f$var$_sha256Sync(tagP, ...messages);
    },
    _JacobianPoint: $cf51e6787616c60f$var$JacobianPoint
};
Object.defineProperties($cf51e6787616c60f$export$eab97d15b1788b8d, {
    sha256Sync: {
        configurable: false,
        get () {
            return $cf51e6787616c60f$var$_sha256Sync;
        },
        set (val) {
            if (!$cf51e6787616c60f$var$_sha256Sync) $cf51e6787616c60f$var$_sha256Sync = val;
        }
    },
    hmacSha256Sync: {
        configurable: false,
        get () {
            return $cf51e6787616c60f$var$_hmacSha256Sync;
        },
        set (val) {
            if (!$cf51e6787616c60f$var$_hmacSha256Sync) $cf51e6787616c60f$var$_hmacSha256Sync = val;
        }
    }
});

});



parcelRequire.register("kNd4X", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $8hEBV = parcelRequire("8hEBV");
var $f232877aaf0d0659$require$uint8ArrayConcat = $8hEBV.concat;

var $8cWjP = parcelRequire("8cWjP");
var $f232877aaf0d0659$require$uint8ArrayFromString = $8cWjP.fromString;

var $eREVT = parcelRequire("eREVT");
const $f232877aaf0d0659$var$cipherMap = {
    "AES-128": {
        ivSize: 16,
        keySize: 16
    },
    "AES-256": {
        ivSize: 16,
        keySize: 32
    },
    Blowfish: {
        ivSize: 8,
        cipherKeySize: 32
    }
};
// Generates a set of keys for each party by stretching the shared key.
// (myIV, theirIV, myCipherKey, theirCipherKey, myMACKey, theirMACKey)
module.exports = async (cipherType, hash, secret)=>{
    const cipher = $f232877aaf0d0659$var$cipherMap[cipherType];
    if (!cipher) {
        const allowed = Object.keys($f232877aaf0d0659$var$cipherMap).join(" / ");
        throw $20Lm5(new Error(`unknown cipher type '${cipherType}'. Must be ${allowed}`), "ERR_INVALID_CIPHER_TYPE");
    }
    if (!hash) throw $20Lm5(new Error("missing hash type"), "ERR_MISSING_HASH_TYPE");
    const cipherKeySize = cipher.keySize;
    const ivSize = cipher.ivSize;
    const hmacKeySize = 20;
    const seed = $f232877aaf0d0659$require$uint8ArrayFromString("key expansion");
    const resultLength = 2 * (ivSize + cipherKeySize + hmacKeySize);
    const m = await $eREVT.create(hash, secret);
    let a = await m.digest(seed);
    const result = [];
    let j = 0;
    while(j < resultLength){
        const b = await m.digest($f232877aaf0d0659$require$uint8ArrayConcat([
            a,
            seed
        ]));
        let todo = b.length;
        if (j + todo > resultLength) todo = resultLength - j;
        result.push(b);
        j += todo;
        a = await m.digest(a);
    }
    const half = resultLength / 2;
    const resultBuffer = $f232877aaf0d0659$require$uint8ArrayConcat(result);
    const r1 = resultBuffer.slice(0, half);
    const r2 = resultBuffer.slice(half, resultLength);
    const createKey = (res)=>({
            iv: res.slice(0, ivSize),
            cipherKey: res.slice(ivSize, ivSize + cipherKeySize),
            macKey: res.slice(ivSize + cipherKeySize)
        });
    return {
        k1: createKey(r1),
        k2: createKey(r2)
    };
};

});
parcelRequire.register("eREVT", function(module, exports) {

$parcel$export(module.exports, "create", () => $ad25c451f4fae960$export$185802fd694ee1f5, (v) => $ad25c451f4fae960$export$185802fd694ee1f5 = v);
var $ad25c451f4fae960$export$185802fd694ee1f5;
"use strict";

var $0NrO2 = parcelRequire("0NrO2");

var $dqk77 = parcelRequire("dqk77");
const $ad25c451f4fae960$var$hashTypes = {
    SHA1: "SHA-1",
    SHA256: "SHA-256",
    SHA512: "SHA-512"
};
const $ad25c451f4fae960$var$sign = async (key, data)=>{
    const buf = await $0NrO2.get().subtle.sign({
        name: "HMAC"
    }, key, data);
    return new Uint8Array(buf, buf.byteOffset, buf.byteLength);
};
$ad25c451f4fae960$export$185802fd694ee1f5 = async function(hashType, secret) {
    const hash = $ad25c451f4fae960$var$hashTypes[hashType];
    const key = await $0NrO2.get().subtle.importKey("raw", secret, {
        name: "HMAC",
        hash: {
            name: hash
        }
    }, false, [
        "sign"
    ]);
    return {
        async digest (data) {
            return $ad25c451f4fae960$var$sign(key, data);
        },
        length: $dqk77[hashType]
    };
};

});
parcelRequire.register("dqk77", function(module, exports) {
"use strict";
module.exports = {
    SHA1: 20,
    SHA256: 32,
    SHA512: 64
};

});



parcelRequire.register("9an9r", function(module, exports) {
"use strict";

var $hV2R5 = parcelRequire("hV2R5");
// Generates an ephemeral public key and returns a function that will compute
// the shared secret key.
//
// Focuses only on ECDH now, but can be made more general in the future.
module.exports = async (curve)=>$hV2R5.generateEphmeralKeyPair(curve) // eslint-disable-line require-await
;

});
parcelRequire.register("hV2R5", function(module, exports) {

$parcel$export(module.exports, "generateEphmeralKeyPair", () => $d0b9f981e41f594e$export$8c9e061ef03ebfb1, (v) => $d0b9f981e41f594e$export$8c9e061ef03ebfb1 = v);
var $d0b9f981e41f594e$export$8c9e061ef03ebfb1;
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $0NrO2 = parcelRequire("0NrO2");

var $lb3nT = parcelRequire("lb3nT");
var $d0b9f981e41f594e$require$base64urlToBuffer = $lb3nT.base64urlToBuffer;

var $gy4do = parcelRequire("gy4do");

var $6rBCs = parcelRequire("6rBCs");
var $d0b9f981e41f594e$require$uint8ArrayToString = $6rBCs.toString;

var $8hEBV = parcelRequire("8hEBV");
var $d0b9f981e41f594e$require$uint8ArrayConcat = $8hEBV.concat;

var $ijWXY = parcelRequire("ijWXY");
var $d0b9f981e41f594e$require$uint8ArrayEquals = $ijWXY.equals;
const $d0b9f981e41f594e$var$bits = {
    "P-256": 256,
    "P-384": 384,
    "P-521": 521
};
$d0b9f981e41f594e$export$8c9e061ef03ebfb1 = async function(curve) {
    $gy4do(Object.keys($d0b9f981e41f594e$var$bits), curve);
    const pair = await $0NrO2.get().subtle.generateKey({
        name: "ECDH",
        namedCurve: curve
    }, true, [
        "deriveBits"
    ]);
    // forcePrivate is used for testing only
    const genSharedKey = async (theirPub, forcePrivate)=>{
        let privateKey;
        if (forcePrivate) privateKey = await $0NrO2.get().subtle.importKey("jwk", $d0b9f981e41f594e$var$unmarshalPrivateKey(curve, forcePrivate), {
            name: "ECDH",
            namedCurve: curve
        }, false, [
            "deriveBits"
        ]);
        else privateKey = pair.privateKey;
        const keys = [
            await $0NrO2.get().subtle.importKey("jwk", $d0b9f981e41f594e$var$unmarshalPublicKey(curve, theirPub), {
                name: "ECDH",
                namedCurve: curve
            }, false, []),
            privateKey
        ];
        const buffer = await $0NrO2.get().subtle.deriveBits({
            name: "ECDH",
            namedCurve: curve,
            public: keys[0]
        }, keys[1], $d0b9f981e41f594e$var$bits[curve]);
        return new Uint8Array(buffer, buffer.byteOffset, buffer.byteLength);
    };
    const publicKey = await $0NrO2.get().subtle.exportKey("jwk", pair.publicKey);
    return {
        key: $d0b9f981e41f594e$var$marshalPublicKey(publicKey),
        genSharedKey: genSharedKey
    };
};
const $d0b9f981e41f594e$var$curveLengths = {
    "P-256": 32,
    "P-384": 48,
    "P-521": 66
};
// Marshal converts a jwk encodec ECDH public key into the
// form specified in section 4.3.6 of ANSI X9.62. (This is the format
// go-ipfs uses)
function $d0b9f981e41f594e$var$marshalPublicKey(jwk) {
    const byteLen = $d0b9f981e41f594e$var$curveLengths[jwk.crv];
    return $d0b9f981e41f594e$require$uint8ArrayConcat([
        Uint8Array.from([
            4
        ]),
        $d0b9f981e41f594e$require$base64urlToBuffer(jwk.x, byteLen),
        $d0b9f981e41f594e$require$base64urlToBuffer(jwk.y, byteLen)
    ], 1 + byteLen * 2);
}
// Unmarshal converts a point, serialized by Marshal, into an jwk encoded key
function $d0b9f981e41f594e$var$unmarshalPublicKey(curve, key) {
    const byteLen = $d0b9f981e41f594e$var$curveLengths[curve];
    if ($d0b9f981e41f594e$require$uint8ArrayEquals(!key.slice(0, 1), Uint8Array.from([
        4
    ]))) throw $20Lm5(new Error("Cannot unmarshal public key - invalid key format"), "ERR_INVALID_KEY_FORMAT");
    return {
        kty: "EC",
        crv: curve,
        x: $d0b9f981e41f594e$require$uint8ArrayToString(key.slice(1, byteLen + 1), "base64url"),
        y: $d0b9f981e41f594e$require$uint8ArrayToString(key.slice(1 + byteLen), "base64url"),
        ext: true
    };
}
const $d0b9f981e41f594e$var$unmarshalPrivateKey = (curve, key)=>({
        ...$d0b9f981e41f594e$var$unmarshalPublicKey(curve, key.public),
        d: $d0b9f981e41f594e$require$uint8ArrayToString(key.private, "base64url")
    });

});
parcelRequire.register("gy4do", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");
module.exports = function(curveTypes, type) {
    if (!curveTypes.includes(type)) {
        const names = curveTypes.join(" / ");
        throw $20Lm5(new Error(`Unknown curve: ${type}. Must be ${names}`), "ERR_INVALID_CURVE");
    }
};

});




parcelRequire.register("jhePu", function(module, exports) {
"use strict";
function $e08b1babe6c10c61$var$withIs(Class, { className: className, symbolName: symbolName }) {
    const symbol = Symbol.for(symbolName);
    const ClassIsWrapper = {
        // The code below assigns the class wrapper to an object to trick
        // JavaScript engines to show the name of the extended class when
        // logging an instances.
        // We are assigning an anonymous class (class wrapper) to the object
        // with key `className` to keep the correct name.
        // If this is not supported it falls back to logging `ClassIsWrapper`.
        [className]: class extends Class {
            constructor(...args){
                super(...args);
                Object.defineProperty(this, symbol, {
                    value: true
                });
            }
            get [Symbol.toStringTag]() {
                return className;
            }
        }
    }[className];
    ClassIsWrapper[`is${className}`] = (obj)=>!!(obj && obj[symbol]);
    return ClassIsWrapper;
}
function $e08b1babe6c10c61$var$withIsProto(Class, { className: className, symbolName: symbolName, withoutNew: withoutNew }) {
    const symbol = Symbol.for(symbolName);
    /* eslint-disable object-shorthand */ const ClassIsWrapper = {
        [className]: function(...args) {
            if (withoutNew && !(this instanceof ClassIsWrapper)) return new ClassIsWrapper(...args);
            const _this = Class.call(this, ...args) || this;
            if (_this && !_this[symbol]) Object.defineProperty(_this, symbol, {
                value: true
            });
            return _this;
        }
    }[className];
    /* eslint-enable object-shorthand */ ClassIsWrapper.prototype = Object.create(Class.prototype);
    ClassIsWrapper.prototype.constructor = ClassIsWrapper;
    Object.defineProperty(ClassIsWrapper.prototype, Symbol.toStringTag, {
        get () {
            return className;
        }
    });
    ClassIsWrapper[`is${className}`] = (obj)=>!!(obj && obj[symbol]);
    return ClassIsWrapper;
}
module.exports = $e08b1babe6c10c61$var$withIs;
module.exports.proto = $e08b1babe6c10c61$var$withIsProto;

});

parcelRequire.register("b9NeK", function(module, exports) {
/*eslint-disable*/ "use strict";

var $liRmU = parcelRequire("liRmU");
// Common aliases
var $81f6ba63cca128cc$var$$Reader = $liRmU.Reader, $81f6ba63cca128cc$var$$Writer = $liRmU.Writer, $81f6ba63cca128cc$var$$util = $liRmU.util;
// Exported root namespace
var $81f6ba63cca128cc$var$$root = $liRmU.roots["libp2p-peer-id"] || ($liRmU.roots["libp2p-peer-id"] = {});
$81f6ba63cca128cc$var$$root.PeerIdProto = function() {
    /**
     * Properties of a PeerIdProto.
     * @exports IPeerIdProto
     * @interface IPeerIdProto
     * @property {Uint8Array} id PeerIdProto id
     * @property {Uint8Array|null} [pubKey] PeerIdProto pubKey
     * @property {Uint8Array|null} [privKey] PeerIdProto privKey
     */ /**
     * Constructs a new PeerIdProto.
     * @exports PeerIdProto
     * @classdesc Represents a PeerIdProto.
     * @implements IPeerIdProto
     * @constructor
     * @param {IPeerIdProto=} [p] Properties to set
     */ function PeerIdProto(p) {
        if (p) {
            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }
    }
    /**
     * PeerIdProto id.
     * @member {Uint8Array} id
     * @memberof PeerIdProto
     * @instance
     */ PeerIdProto.prototype.id = $81f6ba63cca128cc$var$$util.newBuffer([]);
    /**
     * PeerIdProto pubKey.
     * @member {Uint8Array} pubKey
     * @memberof PeerIdProto
     * @instance
     */ PeerIdProto.prototype.pubKey = $81f6ba63cca128cc$var$$util.newBuffer([]);
    /**
     * PeerIdProto privKey.
     * @member {Uint8Array} privKey
     * @memberof PeerIdProto
     * @instance
     */ PeerIdProto.prototype.privKey = $81f6ba63cca128cc$var$$util.newBuffer([]);
    /**
     * Encodes the specified PeerIdProto message. Does not implicitly {@link PeerIdProto.verify|verify} messages.
     * @function encode
     * @memberof PeerIdProto
     * @static
     * @param {IPeerIdProto} m PeerIdProto message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ PeerIdProto.encode = function encode(m, w) {
        if (!w) w = $81f6ba63cca128cc$var$$Writer.create();
        w.uint32(10).bytes(m.id);
        if (m.pubKey != null && Object.hasOwnProperty.call(m, "pubKey")) w.uint32(18).bytes(m.pubKey);
        if (m.privKey != null && Object.hasOwnProperty.call(m, "privKey")) w.uint32(26).bytes(m.privKey);
        return w;
    };
    /**
     * Decodes a PeerIdProto message from the specified reader or buffer.
     * @function decode
     * @memberof PeerIdProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {PeerIdProto} PeerIdProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ PeerIdProto.decode = function decode(r, l) {
        if (!(r instanceof $81f6ba63cca128cc$var$$Reader)) r = $81f6ba63cca128cc$var$$Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l, m = new $81f6ba63cca128cc$var$$root.PeerIdProto();
        while(r.pos < c){
            var t = r.uint32();
            switch(t >>> 3){
                case 1:
                    m.id = r.bytes();
                    break;
                case 2:
                    m.pubKey = r.bytes();
                    break;
                case 3:
                    m.privKey = r.bytes();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
            }
        }
        if (!m.hasOwnProperty("id")) throw $81f6ba63cca128cc$var$$util.ProtocolError("missing required 'id'", {
            instance: m
        });
        return m;
    };
    /**
     * Creates a PeerIdProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PeerIdProto
     * @static
     * @param {Object.<string,*>} d Plain object
     * @returns {PeerIdProto} PeerIdProto
     */ PeerIdProto.fromObject = function fromObject(d) {
        if (d instanceof $81f6ba63cca128cc$var$$root.PeerIdProto) return d;
        var m = new $81f6ba63cca128cc$var$$root.PeerIdProto();
        if (d.id != null) {
            if (typeof d.id === "string") $81f6ba63cca128cc$var$$util.base64.decode(d.id, m.id = $81f6ba63cca128cc$var$$util.newBuffer($81f6ba63cca128cc$var$$util.base64.length(d.id)), 0);
            else if (d.id.length) m.id = d.id;
        }
        if (d.pubKey != null) {
            if (typeof d.pubKey === "string") $81f6ba63cca128cc$var$$util.base64.decode(d.pubKey, m.pubKey = $81f6ba63cca128cc$var$$util.newBuffer($81f6ba63cca128cc$var$$util.base64.length(d.pubKey)), 0);
            else if (d.pubKey.length) m.pubKey = d.pubKey;
        }
        if (d.privKey != null) {
            if (typeof d.privKey === "string") $81f6ba63cca128cc$var$$util.base64.decode(d.privKey, m.privKey = $81f6ba63cca128cc$var$$util.newBuffer($81f6ba63cca128cc$var$$util.base64.length(d.privKey)), 0);
            else if (d.privKey.length) m.privKey = d.privKey;
        }
        return m;
    };
    /**
     * Creates a plain object from a PeerIdProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PeerIdProto
     * @static
     * @param {PeerIdProto} m PeerIdProto
     * @param {$protobuf.IConversionOptions} [o] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ PeerIdProto.toObject = function toObject(m, o) {
        if (!o) o = {};
        var d = {};
        if (o.defaults) {
            if (o.bytes === String) d.id = "";
            else {
                d.id = [];
                if (o.bytes !== Array) d.id = $81f6ba63cca128cc$var$$util.newBuffer(d.id);
            }
            if (o.bytes === String) d.pubKey = "";
            else {
                d.pubKey = [];
                if (o.bytes !== Array) d.pubKey = $81f6ba63cca128cc$var$$util.newBuffer(d.pubKey);
            }
            if (o.bytes === String) d.privKey = "";
            else {
                d.privKey = [];
                if (o.bytes !== Array) d.privKey = $81f6ba63cca128cc$var$$util.newBuffer(d.privKey);
            }
        }
        if (m.id != null && m.hasOwnProperty("id")) d.id = o.bytes === String ? $81f6ba63cca128cc$var$$util.base64.encode(m.id, 0, m.id.length) : o.bytes === Array ? Array.prototype.slice.call(m.id) : m.id;
        if (m.pubKey != null && m.hasOwnProperty("pubKey")) d.pubKey = o.bytes === String ? $81f6ba63cca128cc$var$$util.base64.encode(m.pubKey, 0, m.pubKey.length) : o.bytes === Array ? Array.prototype.slice.call(m.pubKey) : m.pubKey;
        if (m.privKey != null && m.hasOwnProperty("privKey")) d.privKey = o.bytes === String ? $81f6ba63cca128cc$var$$util.base64.encode(m.privKey, 0, m.privKey.length) : o.bytes === Array ? Array.prototype.slice.call(m.privKey) : m.privKey;
        return d;
    };
    /**
     * Converts this PeerIdProto to JSON.
     * @function toJSON
     * @memberof PeerIdProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ PeerIdProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
    };
    return PeerIdProto;
}();
module.exports = $81f6ba63cca128cc$var$$root;

});


parcelRequire.register("glVMO", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $be7b6ea54fdc5f56$var$log = Object.assign($jjmHV("libp2p:peer-routing"), {
    error: $jjmHV("libp2p:peer-routing:err")
});

var $20Lm5 = parcelRequire("20Lm5");

var $8yAh4 = parcelRequire("8yAh4");

var $50Bas = parcelRequire("50Bas");
var $be7b6ea54fdc5f56$require$storeAddresses = $50Bas.storeAddresses;
var $be7b6ea54fdc5f56$require$uniquePeers = $50Bas.uniquePeers;
var $be7b6ea54fdc5f56$require$requirePeers = $50Bas.requirePeers;

var $bNgl1 = parcelRequire("bNgl1");
var $be7b6ea54fdc5f56$require$TimeoutController = $bNgl1.TimeoutController;

var $60sqQ = parcelRequire("60sqQ");

var $d8Blz = parcelRequire("d8Blz");
var $be7b6ea54fdc5f56$require$pipe = $d8Blz.pipe;

var $5UoOr = parcelRequire("5UoOr");

var $2nS4J = parcelRequire("2nS4J");

var $eJwl5 = parcelRequire("eJwl5");

var $GP82a = parcelRequire("GP82a");
var $be7b6ea54fdc5f56$require$setDelayedInterval = $GP82a.setDelayedInterval;
var $be7b6ea54fdc5f56$require$clearDelayedInterval = $GP82a.clearDelayedInterval;

var $4W1MV = parcelRequire("4W1MV");
var $be7b6ea54fdc5f56$require$DHTPeerRouting = $4W1MV.DHTPeerRouting;

var $7QXK1 = parcelRequire("7QXK1");
var $be7b6ea54fdc5f56$require$setMaxListeners = $7QXK1.setMaxListeners;
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 * @typedef {import('libp2p-interfaces/src/peer-routing/types').PeerRouting} PeerRoutingModule
 */ /**
 * @typedef {Object} RefreshManagerOptions
 * @property {boolean} [enabled = true] - Whether to enable the Refresh manager
 * @property {number} [bootDelay = 6e5] - Boot delay to start the Refresh Manager (in ms)
 * @property {number} [interval = 10e3] - Interval between each Refresh Manager run (in ms)
 * @property {number} [timeout = 10e3] - How long to let each refresh run (in ms)
 *
 * @typedef {Object} PeerRoutingOptions
 * @property {RefreshManagerOptions} [refreshManager]
 */ class $be7b6ea54fdc5f56$var$PeerRouting {
    /**
   * @class
   * @param {import('./')} libp2p
   */ constructor(libp2p){
        this._peerId = libp2p.peerId;
        this._peerStore = libp2p.peerStore;
        /** @type {PeerRoutingModule[]} */ this._routers = libp2p._modules.peerRouting || [];
        // If we have the dht, add it to the available peer routers
        if (libp2p._dht && libp2p._config.dht.enabled) this._routers.push(new $be7b6ea54fdc5f56$require$DHTPeerRouting(libp2p._dht));
        this._refreshManagerOptions = libp2p._options.peerRouting.refreshManager;
        this._findClosestPeersTask = this._findClosestPeersTask.bind(this);
    }
    /**
   * Start peer routing service.
   */ start() {
        if (!this._routers.length || this._timeoutId || !this._refreshManagerOptions.enabled) return;
        this._timeoutId = $be7b6ea54fdc5f56$require$setDelayedInterval(this._findClosestPeersTask, this._refreshManagerOptions.interval, this._refreshManagerOptions.bootDelay);
    }
    /**
   * Recurrent task to find closest peers and add their addresses to the Address Book.
   */ async _findClosestPeersTask() {
        try {
            // nb getClosestPeers adds the addresses to the address book
            await $2nS4J(this.getClosestPeers(this._peerId.id, {
                timeout: this._refreshManagerOptions.timeout || 10e3
            }));
        } catch (/** @type {any} */ err) {
            $be7b6ea54fdc5f56$var$log.error(err);
        }
    }
    /**
   * Stop peer routing service.
   */ stop() {
        $be7b6ea54fdc5f56$require$clearDelayedInterval(this._timeoutId);
    }
    /**
   * Iterates over all peer routers in parallel to find the given peer.
   *
   * @param {PeerId} id - The id of the peer to find
   * @param {object} [options]
   * @param {number} [options.timeout] - How long the query should run
   * @returns {Promise<{ id: PeerId, multiaddrs: Multiaddr[] }>}
   */ async findPeer(id, options) {
        if (!this._routers.length) throw $20Lm5(new Error("No peer routers available"), $8yAh4.codes.ERR_NO_ROUTERS_AVAILABLE);
        if (id.toB58String() === this._peerId.toB58String()) throw $20Lm5(new Error("Should not try to find self"), $8yAh4.codes.ERR_FIND_SELF);
        const output = await $be7b6ea54fdc5f56$require$pipe($60sqQ(...this._routers.map((router)=>(async function*() {
                try {
                    yield await router.findPeer(id, options);
                } catch (err) {
                    $be7b6ea54fdc5f56$var$log.error(err);
                }
            })())), (source)=>$eJwl5(source, Boolean), (source)=>$be7b6ea54fdc5f56$require$storeAddresses(source, this._peerStore), (source)=>$5UoOr(source));
        if (output) return output;
        throw $20Lm5(new Error($8yAh4.messages.NOT_FOUND), $8yAh4.codes.ERR_NOT_FOUND);
    }
    /**
   * Attempt to find the closest peers on the network to the given key.
   *
   * @param {Uint8Array} key - A CID like key
   * @param {Object} [options]
   * @param {number} [options.timeout=30e3] - How long the query can take
   * @param {AbortSignal} [options.signal] - An AbortSignal to abort the request
   * @returns {AsyncIterable<{ id: PeerId, multiaddrs: Multiaddr[] }>}
   */ async *getClosestPeers(key, options = {
        timeout: 30e3
    }) {
        if (!this._routers.length) throw $20Lm5(new Error("No peer routers available"), $8yAh4.codes.ERR_NO_ROUTERS_AVAILABLE);
        if (options.timeout) {
            const controller = new $be7b6ea54fdc5f56$require$TimeoutController(options.timeout);
            // this controller will potentially be used while dialing lots of
            // peers so prevent MaxListenersExceededWarning appearing in the console
            $be7b6ea54fdc5f56$require$setMaxListeners && $be7b6ea54fdc5f56$require$setMaxListeners(Infinity, controller.signal);
            options.signal = controller.signal;
        }
        yield* $be7b6ea54fdc5f56$require$pipe($60sqQ(...this._routers.map((router)=>router.getClosestPeers(key, options))), (source)=>$be7b6ea54fdc5f56$require$storeAddresses(source, this._peerStore), (source)=>$be7b6ea54fdc5f56$require$uniquePeers(source), (source)=>$be7b6ea54fdc5f56$require$requirePeers(source));
    }
}
module.exports = $be7b6ea54fdc5f56$var$PeerRouting;

});
parcelRequire.register("8yAh4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $63ada307dca0c6d6$export$defe85febe8b728c, (v) => $63ada307dca0c6d6$export$defe85febe8b728c = v);
$parcel$export(module.exports, "codes", () => $63ada307dca0c6d6$export$e45cb6485273080e, (v) => $63ada307dca0c6d6$export$e45cb6485273080e = v);
var $63ada307dca0c6d6$export$defe85febe8b728c;
var $63ada307dca0c6d6$export$e45cb6485273080e;
"use strict";
$63ada307dca0c6d6$export$defe85febe8b728c = {
    NOT_STARTED_YET: "The libp2p node is not started yet",
    DHT_DISABLED: "DHT is not available",
    CONN_ENCRYPTION_REQUIRED: "At least one connection encryption module is required",
    NOT_FOUND: "Not found"
};
$63ada307dca0c6d6$export$e45cb6485273080e = {
    DHT_DISABLED: "ERR_DHT_DISABLED",
    PUBSUB_NOT_STARTED: "ERR_PUBSUB_NOT_STARTED",
    DHT_NOT_STARTED: "ERR_DHT_NOT_STARTED",
    CONN_ENCRYPTION_REQUIRED: "ERR_CONN_ENCRYPTION_REQUIRED",
    ERR_INVALID_PROTOCOLS_FOR_STREAM: "ERR_INVALID_PROTOCOLS_FOR_STREAM",
    ERR_CONNECTION_ENDED: "ERR_CONNECTION_ENDED",
    ERR_CONNECTION_FAILED: "ERR_CONNECTION_FAILED",
    ERR_NODE_NOT_STARTED: "ERR_NODE_NOT_STARTED",
    ERR_ALREADY_ABORTED: "ERR_ALREADY_ABORTED",
    ERR_TOO_MANY_ADDRESSES: "ERR_TOO_MANY_ADDRESSES",
    ERR_NO_VALID_ADDRESSES: "ERR_NO_VALID_ADDRESSES",
    ERR_RELAYED_DIAL: "ERR_RELAYED_DIAL",
    ERR_DIALED_SELF: "ERR_DIALED_SELF",
    ERR_DISCOVERED_SELF: "ERR_DISCOVERED_SELF",
    ERR_DUPLICATE_TRANSPORT: "ERR_DUPLICATE_TRANSPORT",
    ERR_ENCRYPTION_FAILED: "ERR_ENCRYPTION_FAILED",
    ERR_HOP_REQUEST_FAILED: "ERR_HOP_REQUEST_FAILED",
    ERR_INVALID_KEY: "ERR_INVALID_KEY",
    ERR_INVALID_MESSAGE: "ERR_INVALID_MESSAGE",
    ERR_INVALID_PARAMETERS: "ERR_INVALID_PARAMETERS",
    ERR_INVALID_PEER: "ERR_INVALID_PEER",
    ERR_MUXER_UNAVAILABLE: "ERR_MUXER_UNAVAILABLE",
    ERR_NOT_FOUND: "ERR_NOT_FOUND",
    ERR_TIMEOUT: "ERR_TIMEOUT",
    ERR_TRANSPORT_UNAVAILABLE: "ERR_TRANSPORT_UNAVAILABLE",
    ERR_TRANSPORT_DIAL_FAILED: "ERR_TRANSPORT_DIAL_FAILED",
    ERR_UNSUPPORTED_PROTOCOL: "ERR_UNSUPPORTED_PROTOCOL",
    ERR_INVALID_MULTIADDR: "ERR_INVALID_MULTIADDR",
    ERR_SIGNATURE_NOT_VALID: "ERR_SIGNATURE_NOT_VALID",
    ERR_FIND_SELF: "ERR_FIND_SELF",
    ERR_NO_ROUTERS_AVAILABLE: "ERR_NO_ROUTERS_AVAILABLE",
    ERR_CONNECTION_NOT_MULTIPLEXED: "ERR_CONNECTION_NOT_MULTIPLEXED",
    ERR_NO_DIAL_TOKENS: "ERR_NO_DIAL_TOKENS",
    ERR_KEYCHAIN_REQUIRED: "ERR_KEYCHAIN_REQUIRED",
    ERR_INVALID_CMS: "ERR_INVALID_CMS",
    ERR_MISSING_KEYS: "ERR_MISSING_KEYS",
    ERR_NO_KEY: "ERR_NO_KEY",
    ERR_INVALID_KEY_NAME: "ERR_INVALID_KEY_NAME",
    ERR_INVALID_KEY_TYPE: "ERR_INVALID_KEY_TYPE",
    ERR_KEY_ALREADY_EXISTS: "ERR_KEY_ALREADY_EXISTS",
    ERR_INVALID_KEY_SIZE: "ERR_INVALID_KEY_SIZE",
    ERR_KEY_NOT_FOUND: "ERR_KEY_NOT_FOUND",
    ERR_OLD_KEY_NAME_INVALID: "ERR_OLD_KEY_NAME_INVALID",
    ERR_NEW_KEY_NAME_INVALID: "ERR_NEW_KEY_NAME_INVALID",
    ERR_PASSWORD_REQUIRED: "ERR_PASSWORD_REQUIRED",
    ERR_PEM_REQUIRED: "ERR_PEM_REQUIRED",
    ERR_CANNOT_READ_KEY: "ERR_CANNOT_READ_KEY",
    ERR_MISSING_PRIVATE_KEY: "ERR_MISSING_PRIVATE_KEY",
    ERR_INVALID_OLD_PASS_TYPE: "ERR_INVALID_OLD_PASS_TYPE",
    ERR_INVALID_NEW_PASS_TYPE: "ERR_INVALID_NEW_PASS_TYPE",
    ERR_INVALID_PASS_LENGTH: "ERR_INVALID_PASS_LENGTH",
    ERR_NOT_IMPLEMENTED: "ERR_NOT_IMPLEMENTED",
    ERR_WRONG_PING_ACK: "ERR_WRONG_PING_ACK"
};

});

parcelRequire.register("50Bas", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $eJwl5 = parcelRequire("eJwl5");

var $l8Jiq = parcelRequire("l8Jiq");

var $g7lyh = parcelRequire("g7lyh");
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 */ /**
 * Store the multiaddrs from every peer in the passed peer store
 *
 * @param {AsyncIterable<{ id: PeerId, multiaddrs: Multiaddr[] }>} source
 * @param {import('../peer-store')} peerStore
 */ function $3a59c8908bc3d9db$var$storeAddresses(source, peerStore) {
    return $l8Jiq(source, (peer)=>{
        // ensure we have the addresses for a given peer
        peerStore.addressBook.add(peer.id, peer.multiaddrs);
        return peer;
    });
}
/**
 * Filter peers by unique peer id
 *
 * @param {AsyncIterable<{ id: PeerId, multiaddrs: Multiaddr[] }>} source
 */ function $3a59c8908bc3d9db$var$uniquePeers(source) {
    /** @type Set<string> */ const seen = new Set();
    return $eJwl5(source, (peer)=>{
        // dedupe by peer id
        if (seen.has(peer.id.toString())) return false;
        seen.add(peer.id.toString());
        return true;
    });
}
/**
 * Require at least `min` peers to be yielded from `source`
 *
 * @param {AsyncIterable<{ id: PeerId, multiaddrs: Multiaddr[] }>} source
 * @param {number} min
 */ async function* $3a59c8908bc3d9db$var$requirePeers(source, min = 1) {
    let seen = 0;
    for await (const peer of source){
        seen++;
        yield peer;
    }
    if (seen < min) throw $20Lm5(new Error("not found"), "NOT_FOUND");
}
/**
 * If `max` is passed, only take that number of peers from the source
 * otherwise take all the peers
 *
 * @param {AsyncIterable<{ id: PeerId, multiaddrs: Multiaddr[] }>} source
 * @param {number} [max]
 */ function $3a59c8908bc3d9db$var$maybeLimitSource(source, max) {
    if (max) return $g7lyh(source, max);
    return source;
}
module.exports = {
    storeAddresses: $3a59c8908bc3d9db$var$storeAddresses,
    uniquePeers: $3a59c8908bc3d9db$var$uniquePeers,
    requirePeers: $3a59c8908bc3d9db$var$requirePeers,
    maybeLimitSource: $3a59c8908bc3d9db$var$maybeLimitSource
};

});
parcelRequire.register("eJwl5", function(module, exports) {
"use strict";
/**
 * Filters the passed (async) iterable by using the filter function
 *
 * @template T
 * @param {AsyncIterable<T>|Iterable<T>} source
 * @param {function(T):boolean|Promise<boolean>} fn
 */ const $02c49e5cf30a83b3$var$filter = async function*(source, fn) {
    for await (const entry of source)if (await fn(entry)) yield entry;
};
module.exports = $02c49e5cf30a83b3$var$filter;

});

parcelRequire.register("l8Jiq", function(module, exports) {
"use strict";
/**
 * Takes an (async) iterable and returns one with each item mapped by the passed
 * function.
 *
 * @template I,O
 * @param {AsyncIterable<I>|Iterable<I>} source
 * @param {function(I):O|Promise<O>} func
 * @returns {AsyncIterable<O>}
 */ const $f63d7b3a22dc8548$var$map = async function*(source, func) {
    for await (const val of source)yield func(val);
};
module.exports = $f63d7b3a22dc8548$var$map;

});

parcelRequire.register("g7lyh", function(module, exports) {
"use strict";
/**
 * Stop iteration after n items have been received.
 *
 * @template T
 * @param {AsyncIterable<T>|Iterable<T>} source
 * @param {number} limit
 * @returns {AsyncIterable<T>}
 */ const $bbbe048f052b4a6c$var$take = async function*(source, limit) {
    let items = 0;
    if (limit < 1) return;
    for await (const entry of source){
        yield entry;
        items++;
        if (items === limit) return;
    }
};
module.exports = $bbbe048f052b4a6c$var$take;

});


parcelRequire.register("bNgl1", function(module, exports) {
"use strict";

var $7EsPD = parcelRequire("7EsPD");
var $8960f1b83b514793$require$AbortController = $7EsPD.AbortController;

var $fOCk5 = parcelRequire("fOCk5");
class $8960f1b83b514793$var$TimeoutController extends $8960f1b83b514793$require$AbortController {
    /**
   * @constructor
   * @param {number} ms milliseconds
   */ constructor(ms){
        super();
        this._ms = ms;
        this._timer = $fOCk5(()=>this.abort(), ms);
        // Patch for safari not supported extending built in classes
        Object.setPrototypeOf(this, $8960f1b83b514793$var$TimeoutController.prototype);
    }
    /**
   * Aborts the controller and clears the timer
   */ abort() {
        this._timer.clear();
        return super.abort();
    }
    /**
   * Clears the timer
   */ clear() {
        this._timer.clear();
    }
    /**
   * Resets the timer
   */ reset() {
        this._timer.clear();
        this._timer = $fOCk5(()=>this.abort(), this._ms);
    }
}
module.exports = {
    TimeoutController: $8960f1b83b514793$var$TimeoutController
};

});
parcelRequire.register("7EsPD", function(module, exports) {

$parcel$export(module.exports, "AbortController", () => $5922a23d8928ed44$export$48f7e099c149af88, (v) => $5922a23d8928ed44$export$48f7e099c149af88 = v);
var $5922a23d8928ed44$export$e42c54032314dc1d;
var $5922a23d8928ed44$export$48f7e099c149af88;
"use strict";
let $5922a23d8928ed44$var$impl;

if (globalThis.AbortController && globalThis.AbortSignal) $5922a23d8928ed44$var$impl = globalThis;
else $5922a23d8928ed44$var$impl = (parcelRequire("6TRZ8"));
$5922a23d8928ed44$export$e42c54032314dc1d = $5922a23d8928ed44$var$impl.AbortSignal;
$5922a23d8928ed44$export$48f7e099c149af88 = $5922a23d8928ed44$var$impl.AbortController;

});
parcelRequire.register("6TRZ8", function(module, exports) {
/*globals self, window */ "use strict";
/*eslint-disable @mysticatea/prettier */ const { AbortController: $5061c171e2b6d8f2$var$AbortController, AbortSignal: $5061c171e2b6d8f2$var$AbortSignal } = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : /* otherwise */ undefined;
/*eslint-enable @mysticatea/prettier */ module.exports = $5061c171e2b6d8f2$var$AbortController;
module.exports.AbortSignal = $5061c171e2b6d8f2$var$AbortSignal;
module.exports.default = $5061c171e2b6d8f2$var$AbortController;

});


parcelRequire.register("fOCk5", function(module, exports) {
"use strict";

var $9AxXx = parcelRequire("9AxXx");
class $b83940ae8361b663$var$Retimer {
    constructor(callback, timeout, args){
        const that = this;
        this._started = $9AxXx();
        this._rescheduled = 0;
        this._scheduled = timeout;
        this._args = args;
        this._triggered = false;
        this._timerWrapper = ()=>{
            if (that._rescheduled > 0) {
                that._scheduled = that._rescheduled - ($9AxXx() - that._started);
                that._schedule(that._scheduled);
            } else {
                that._triggered = true;
                callback.apply(null, that._args);
            }
        };
        this._timer = setTimeout(this._timerWrapper, timeout);
    }
    reschedule(timeout) {
        if (!timeout) timeout = this._scheduled;
        const now = $9AxXx();
        if (now + timeout - (this._started + this._scheduled) < 0) {
            clearTimeout(this._timer);
            this._schedule(timeout);
        } else if (!this._triggered) {
            this._started = now;
            this._rescheduled = timeout;
        } else this._schedule(timeout);
    }
    _schedule(timeout) {
        this._triggered = false;
        this._started = $9AxXx();
        this._rescheduled = 0;
        this._scheduled = timeout;
        this._timer = setTimeout(this._timerWrapper, timeout);
    }
    clear() {
        clearTimeout(this._timer);
    }
}
function $b83940ae8361b663$var$retimer() {
    if (typeof arguments[0] !== "function") throw new Error("callback needed");
    if (typeof arguments[1] !== "number") throw new Error("timeout needed");
    let args;
    if (arguments.length > 0) {
        args = new Array(arguments.length - 2);
        /* eslint-disable no-var */ for(var i = 0; i < args.length; i++)args[i] = arguments[i + 2];
    }
    return new $b83940ae8361b663$var$Retimer(arguments[0], arguments[1], args);
}
module.exports = $b83940ae8361b663$var$retimer;

});
parcelRequire.register("9AxXx", function(module, exports) {
"use strict";
module.exports = function getTime() {
    return Date.now();
};

});



parcelRequire.register("60sqQ", function(module, exports) {
"use strict";

var $5htNF = parcelRequire("5htNF");
/**
 * Treat one or more iterables as a single iterable.
 *
 * Nb. sources are iterated over in parallel so the
 * order of emitted items is not guaranteed.
 *
 * @template T
 * @param {...AsyncIterable<T>|Iterable<T>} sources
 * @returns {AsyncIterable<T>}
 */ const $45f8cc2843f6069a$var$merge = async function*(...sources) {
    const output = $5htNF();
    setTimeout(async ()=>{
        try {
            await Promise.all(sources.map(async (source)=>{
                for await (const item of source)output.push(item);
            }));
            output.end();
        } catch (/** @type {any} */ err) {
            output.end(err);
        }
    }, 0);
    yield* output;
};
module.exports = $45f8cc2843f6069a$var$merge;

});
parcelRequire.register("5htNF", function(module, exports) {

var $bUCRD = parcelRequire("bUCRD");
module.exports = (options)=>{
    options = options || {};
    let onEnd;
    if (typeof options === "function") {
        onEnd = options;
        options = {};
    } else onEnd = options.onEnd;
    let buffer = new $bUCRD();
    let pushable, onNext, ended;
    const waitNext = ()=>{
        if (!buffer.isEmpty()) {
            if (options.writev) {
                let next;
                const values = [];
                while(!buffer.isEmpty()){
                    next = buffer.shift();
                    if (next.error) throw next.error;
                    values.push(next.value);
                }
                return {
                    done: next.done,
                    value: values
                };
            }
            const next = buffer.shift();
            if (next.error) throw next.error;
            return next;
        }
        if (ended) return {
            done: true
        };
        return new Promise((resolve, reject)=>{
            onNext = (next)=>{
                onNext = null;
                if (next.error) reject(next.error);
                else if (options.writev && !next.done) resolve({
                    done: next.done,
                    value: [
                        next.value
                    ]
                });
                else resolve(next);
                return pushable;
            };
        });
    };
    const bufferNext = (next)=>{
        if (onNext) return onNext(next);
        buffer.push(next);
        return pushable;
    };
    const bufferError = (err)=>{
        buffer = new $bUCRD();
        if (onNext) return onNext({
            error: err
        });
        buffer.push({
            error: err
        });
        return pushable;
    };
    const push = (value)=>{
        if (ended) return pushable;
        return bufferNext({
            done: false,
            value: value
        });
    };
    const end = (err)=>{
        if (ended) return pushable;
        ended = true;
        return err ? bufferError(err) : bufferNext({
            done: true
        });
    };
    const _return = ()=>{
        buffer = new $bUCRD();
        end();
        return {
            done: true
        };
    };
    const _throw = (err)=>{
        end(err);
        return {
            done: true
        };
    };
    pushable = {
        [Symbol.asyncIterator] () {
            return this;
        },
        next: waitNext,
        return: _return,
        throw: _throw,
        push: push,
        end: end
    };
    if (!onEnd) return pushable;
    const _pushable = pushable;
    pushable = {
        [Symbol.asyncIterator] () {
            return this;
        },
        next () {
            return _pushable.next();
        },
        throw (err) {
            _pushable.throw(err);
            if (onEnd) {
                onEnd(err);
                onEnd = null;
            }
            return {
                done: true
            };
        },
        return () {
            _pushable.return();
            if (onEnd) {
                onEnd();
                onEnd = null;
            }
            return {
                done: true
            };
        },
        push: push,
        end (err) {
            _pushable.end(err);
            if (onEnd) {
                onEnd(err);
                onEnd = null;
            }
            return pushable;
        }
    };
    return pushable;
};

});
parcelRequire.register("bUCRD", function(module, exports) {

var $boAcJ = parcelRequire("boAcJ");
module.exports = class FastFIFO {
    constructor(hwm){
        this.hwm = hwm || 16;
        this.head = new $boAcJ(this.hwm);
        this.tail = this.head;
        this.length = 0;
    }
    clear() {
        this.head = this.tail;
        this.head.clear();
        this.length = 0;
    }
    push(val) {
        this.length++;
        if (!this.head.push(val)) {
            const prev = this.head;
            this.head = prev.next = new $boAcJ(2 * this.head.buffer.length);
            this.head.push(val);
        }
    }
    shift() {
        if (this.length !== 0) this.length--;
        const val = this.tail.shift();
        if (val === undefined && this.tail.next) {
            const next = this.tail.next;
            this.tail.next = null;
            this.tail = next;
            return this.tail.shift();
        }
        return val;
    }
    peek() {
        const val = this.tail.peek();
        if (val === undefined && this.tail.next) return this.tail.next.peek();
        return val;
    }
    isEmpty() {
        return this.length === 0;
    }
};

});
parcelRequire.register("boAcJ", function(module, exports) {
module.exports = class FixedFIFO {
    constructor(hwm){
        if (!(hwm > 0) || (hwm - 1 & hwm) !== 0) throw new Error("Max size for a FixedFIFO should be a power of two");
        this.buffer = new Array(hwm);
        this.mask = hwm - 1;
        this.top = 0;
        this.btm = 0;
        this.next = null;
    }
    clear() {
        this.top = this.btm = 0;
        this.next = null;
        this.buffer.fill(undefined);
    }
    push(data) {
        if (this.buffer[this.top] !== undefined) return false;
        this.buffer[this.top] = data;
        this.top = this.top + 1 & this.mask;
        return true;
    }
    shift() {
        const last = this.buffer[this.btm];
        if (last === undefined) return undefined;
        this.buffer[this.btm] = undefined;
        this.btm = this.btm + 1 & this.mask;
        return last;
    }
    peek() {
        return this.buffer[this.btm];
    }
    isEmpty() {
        return this.buffer[this.btm] === undefined;
    }
};

});




parcelRequire.register("5UoOr", function(module, exports) {
"use strict";
/**
 * Returns the first result from an (async) iterable, unless empty, in which
 * case returns `undefined`.
 *
 * @template T
 * @param {AsyncIterable<T>|Iterable<T>} source
 */ const $44d56dfcb8387b75$var$first = async (source)=>{
    for await (const entry of source)return entry;
    return undefined;
};
module.exports = $44d56dfcb8387b75$var$first;

});

parcelRequire.register("2nS4J", function(module, exports) {
"use strict";
/**
 * Drains an (async) iterable discarding its' content and does not return
 * anything.
 *
 * @template T
 * @param {AsyncIterable<T>|Iterable<T>} source
 * @returns {Promise<void>}
 */ const $1bc7acfe899e4e17$var$drain = async (source)=>{
    for await (const _ of source); // eslint-disable-line no-unused-vars,no-empty
};
module.exports = $1bc7acfe899e4e17$var$drain;

});

parcelRequire.register("GP82a", function(module, exports) {
"use strict";
const $080b956de59786cc$var$intervals = new Map();
const $080b956de59786cc$var$_generateId = ()=>`${Date.now()}:${Math.floor(Math.random() * 1000000)}`;
/**
 * Run a given task each {interval} ms
 *
 * @param {() => Promise} task
 * @param {number} interval
 * @param {string} id
 */ async function $080b956de59786cc$var$_runPeriodically(task, interval, id) {
    while($080b956de59786cc$var$intervals.get(id)){
        try {
            await task();
        } catch (err) {
            // Throw global context error if handler throws
            setTimeout(()=>{
                throw err;
            }, 1);
            break;
        }
        if (!$080b956de59786cc$var$intervals.get(id)) break;
        await new Promise((resolve)=>{
            const _timeout = setTimeout(resolve, interval);
            $080b956de59786cc$var$intervals.set(id, _timeout);
        });
    }
}
/**
 * Asynchronous setInterval that is properly delayed using promises and can be delayed on boot.
 *
 * @param {() => Promise} task
 * @param {number} interval
 * @param {number} [delay = interval]
 * @returns {string}
 */ function $080b956de59786cc$var$setDelayedInterval(task, interval, delay) {
    delay = delay || interval;
    const id = $080b956de59786cc$var$_generateId();
    const _timeout = setTimeout(()=>{
        $080b956de59786cc$var$_runPeriodically(task, interval, id);
    }, delay);
    $080b956de59786cc$var$intervals.set(id, _timeout);
    return id;
}
/**
 * Clear delayed interval.
 *
 * @param {string} id
 */ function $080b956de59786cc$var$clearDelayedInterval(id) {
    const _timeout = $080b956de59786cc$var$intervals.get(id);
    if (_timeout) {
        clearTimeout(_timeout);
        $080b956de59786cc$var$intervals.delete(id);
    }
}
module.exports = {
    setDelayedInterval: $080b956de59786cc$var$setDelayedInterval,
    clearDelayedInterval: $080b956de59786cc$var$clearDelayedInterval
};

});

parcelRequire.register("4W1MV", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $8yAh4 = parcelRequire("8yAh4");
var $397df74f0acbc34e$require$messages = $8yAh4.messages;
var $397df74f0acbc34e$require$codes = $8yAh4.codes;
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('libp2p-interfaces/src/peer-routing/types').PeerRouting} PeerRoutingModule
 */ /**
 * Wrapper class to convert events into returned values
 *
 * @implements {PeerRoutingModule}
 */ class $397df74f0acbc34e$var$DHTPeerRouting {
    /**
   * @param {import('libp2p-kad-dht').DHT} dht
   */ constructor(dht){
        this._dht = dht;
    }
    /**
   * @param {PeerId} peerId
   * @param {any} options
   */ async findPeer(peerId, options = {}) {
        for await (const event of this._dht.findPeer(peerId, options)){
            if (event.name === "FINAL_PEER") return event.peer;
        }
        throw $20Lm5(new Error($397df74f0acbc34e$require$messages.NOT_FOUND), $397df74f0acbc34e$require$codes.ERR_NOT_FOUND);
    }
    /**
   * @param {Uint8Array} key
   * @param {any} options
   */ async *getClosestPeers(key, options = {}) {
        for await (const event of this._dht.getClosestPeers(key, options))if (event.name === "PEER_RESPONSE") yield* event.closer;
    }
}
module.exports = {
    DHTPeerRouting: $397df74f0acbc34e$var$DHTPeerRouting
};

});


parcelRequire.register("hDYYu", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $8yAh4 = parcelRequire("8yAh4");
var $cd85607694cf02ad$require$messages = $8yAh4.messages;
var $cd85607694cf02ad$require$codes = $8yAh4.codes;

var $50Bas = parcelRequire("50Bas");
var $cd85607694cf02ad$require$storeAddresses = $50Bas.storeAddresses;
var $cd85607694cf02ad$require$uniquePeers = $50Bas.uniquePeers;
var $cd85607694cf02ad$require$requirePeers = $50Bas.requirePeers;
var $cd85607694cf02ad$require$maybeLimitSource = $50Bas.maybeLimitSource;

var $2nS4J = parcelRequire("2nS4J");

var $60sqQ = parcelRequire("60sqQ");

var $d8Blz = parcelRequire("d8Blz");
var $cd85607694cf02ad$require$pipe = $d8Blz.pipe;

var $bav9p = parcelRequire("bav9p");
var $cd85607694cf02ad$require$DHTContentRouting = $bav9p.DHTContentRouting;
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 * @typedef {import('multiformats/cid').CID} CID
 * @typedef {import('libp2p-interfaces/src/content-routing/types').ContentRouting} ContentRoutingModule
 */ /**
 * @typedef {Object} GetData
 * @property {PeerId} from
 * @property {Uint8Array} val
 */ class $cd85607694cf02ad$var$ContentRouting {
    /**
   * @class
   * @param {import('..')} libp2p
   */ constructor(libp2p){
        this.libp2p = libp2p;
        /** @type {ContentRoutingModule[]} */ this.routers = libp2p._modules.contentRouting || [];
        this.dht = libp2p._dht;
        // If we have the dht, add it to the available content routers
        if (this.dht && libp2p._config.dht.enabled) this.routers.push(new $cd85607694cf02ad$require$DHTContentRouting(this.dht));
    }
    /**
   * Iterates over all content routers in parallel to find providers of the given key.
   *
   * @param {CID} key - The CID key of the content to find
   * @param {object} [options]
   * @param {number} [options.timeout] - How long the query should run
   * @param {number} [options.maxNumProviders] - maximum number of providers to find
   * @returns {AsyncIterable<{ id: PeerId, multiaddrs: Multiaddr[] }>}
   */ async *findProviders(key, options = {}) {
        if (!this.routers.length) throw $20Lm5(new Error("No content this.routers available"), $cd85607694cf02ad$require$codes.ERR_NO_ROUTERS_AVAILABLE);
        yield* $cd85607694cf02ad$require$pipe($60sqQ(...this.routers.map((router)=>router.findProviders(key, options))), (source)=>$cd85607694cf02ad$require$storeAddresses(source, this.libp2p.peerStore), (source)=>$cd85607694cf02ad$require$uniquePeers(source), (source)=>$cd85607694cf02ad$require$maybeLimitSource(source, options.maxNumProviders), (source)=>$cd85607694cf02ad$require$requirePeers(source));
    }
    /**
   * Iterates over all content routers in parallel to notify it is
   * a provider of the given key.
   *
   * @param {CID} key - The CID key of the content to find
   * @returns {Promise<void>}
   */ async provide(key) {
        if (!this.routers.length) throw $20Lm5(new Error("No content routers available"), $cd85607694cf02ad$require$codes.ERR_NO_ROUTERS_AVAILABLE);
        await Promise.all(this.routers.map((router)=>router.provide(key)));
    }
    /**
   * Store the given key/value pair in the DHT.
   *
   * @param {Uint8Array} key
   * @param {Uint8Array} value
   * @param {Object} [options] - put options
   * @param {number} [options.minPeers] - minimum number of peers required to successfully put
   * @returns {Promise<void>}
   */ async put(key, value, options) {
        if (!this.libp2p.isStarted() || !this.dht.isStarted) throw $20Lm5(new Error($cd85607694cf02ad$require$messages.NOT_STARTED_YET), $cd85607694cf02ad$require$codes.DHT_NOT_STARTED);
        await $2nS4J(this.dht.put(key, value, options));
    }
    /**
   * Get the value to the given key.
   * Times out after 1 minute by default.
   *
   * @param {Uint8Array} key
   * @param {Object} [options] - get options
   * @param {number} [options.timeout] - optional timeout (default: 60000)
   * @returns {Promise<GetData>}
   */ async get(key, options) {
        if (!this.libp2p.isStarted() || !this.dht.isStarted) throw $20Lm5(new Error($cd85607694cf02ad$require$messages.NOT_STARTED_YET), $cd85607694cf02ad$require$codes.DHT_NOT_STARTED);
        for await (const event of this.dht.get(key, options)){
            if (event.name === "VALUE") return {
                from: event.peerId,
                val: event.value
            };
        }
        throw $20Lm5(new Error($cd85607694cf02ad$require$messages.NOT_FOUND), $cd85607694cf02ad$require$codes.ERR_NOT_FOUND);
    }
    /**
   * Get the `n` values to the given key without sorting.
   *
   * @param {Uint8Array} key
   * @param {number} nVals
   * @param {Object} [options] - get options
   * @param {number} [options.timeout] - optional timeout (default: 60000)
   */ async *getMany(key, nVals, options) {
        if (!this.libp2p.isStarted() || !this.dht.isStarted) throw $20Lm5(new Error($cd85607694cf02ad$require$messages.NOT_STARTED_YET), $cd85607694cf02ad$require$codes.DHT_NOT_STARTED);
        if (!nVals) return;
        let gotValues = 0;
        for await (const event of this.dht.get(key, options))if (event.name === "VALUE") {
            yield {
                from: event.peerId,
                val: event.value
            };
            gotValues++;
            if (gotValues === nVals) break;
        }
        if (gotValues === 0) throw $20Lm5(new Error($cd85607694cf02ad$require$messages.NOT_FOUND), $cd85607694cf02ad$require$codes.ERR_NOT_FOUND);
    }
}
module.exports = $cd85607694cf02ad$var$ContentRouting;

});
parcelRequire.register("bav9p", function(module, exports) {
"use strict";

var $2nS4J = parcelRequire("2nS4J");
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('libp2p-interfaces/src/content-routing/types').ContentRouting} ContentRoutingModule
 * @typedef {import('multiformats/cid').CID} CID
 */ /**
 * Wrapper class to convert events into returned values
 *
 * @implements {ContentRoutingModule}
 */ class $8218cacbb6cca7ef$var$DHTContentRouting {
    /**
   * @param {import('libp2p-kad-dht').DHT} dht
   */ constructor(dht){
        this._dht = dht;
    }
    /**
   * @param {CID} cid
   */ async provide(cid) {
        await $2nS4J(this._dht.provide(cid));
    }
    /**
   * @param {CID} cid
   * @param {*} options
   */ async *findProviders(cid, options) {
        for await (const event of this._dht.findProviders(cid, options))if (event.name === "PROVIDER") yield* event.providers;
    }
}
module.exports = {
    DHTContentRouting: $8218cacbb6cca7ef$var$DHTContentRouting
};

});


parcelRequire.register("gbbbW", function(module, exports) {
"use strict";

var $ksmXv = parcelRequire("ksmXv");

var $aZLwC = parcelRequire("aZLwC");
var $bc765ad871a6c60e$require$Multiaddr = $aZLwC.Multiaddr;

var $20Lm5 = parcelRequire("20Lm5");

var $8yAh4 = parcelRequire("8yAh4");
var $bc765ad871a6c60e$require$codes = $8yAh4.codes;
/**
 * Converts the given `peer` to a `Peer` object.
 * If a multiaddr is received, the addressBook is updated.
 *
 * @param {PeerId|Multiaddr|string} peer
 * @returns {{ id: PeerId, multiaddrs: Multiaddr[]|undefined }}
 */ function $bc765ad871a6c60e$var$getPeer(peer) {
    if (typeof peer === "string") peer = new $bc765ad871a6c60e$require$Multiaddr(peer);
    let addr;
    if ($bc765ad871a6c60e$require$Multiaddr.isMultiaddr(peer)) {
        addr = peer;
        const idStr = peer.getPeerId();
        if (!idStr) throw $20Lm5(new Error(`${peer} does not have a valid peer type`), $bc765ad871a6c60e$require$codes.ERR_INVALID_MULTIADDR);
        try {
            peer = $ksmXv.createFromB58String(idStr);
        } catch (/** @type {any} */ err) {
            throw $20Lm5(new Error(`${peer} is not a valid peer type`), $bc765ad871a6c60e$require$codes.ERR_INVALID_MULTIADDR);
        }
    }
    return {
        id: peer,
        multiaddrs: addr ? [
            addr
        ] : undefined
    };
}
module.exports = $bc765ad871a6c60e$var$getPeer;

});

parcelRequire.register("1uW4V", function(module, exports) {

$parcel$export(module.exports, "validate", () => $1175a4f228e6a4d9$export$a22775fa5e2eebd9, (v) => $1175a4f228e6a4d9$export$a22775fa5e2eebd9 = v);
/**
 * @param {Libp2pOptions} opts
 * @returns {DefaultConfig & Libp2pOptions & constructorOptions}
 */ var $1175a4f228e6a4d9$export$a22775fa5e2eebd9;
"use strict";

var $8pyvD = parcelRequire("8pyvD");

var $lHxnk = parcelRequire("lHxnk");
var $1175a4f228e6a4d9$require$dnsaddrResolver = $lHxnk.dnsaddrResolver;

var $h6RaR = parcelRequire("h6RaR");

var $hBHKi = parcelRequire("hBHKi");
var $1175a4f228e6a4d9$require$AGENT_VERSION = $hBHKi.AGENT_VERSION;

var $9gQk1 = parcelRequire("9gQk1");

var $lFIT7 = parcelRequire("lFIT7");
var $1175a4f228e6a4d9$require$publicAddressesFirst = $lFIT7.publicAddressesFirst;

var $90XFO = parcelRequire("90XFO");
var $1175a4f228e6a4d9$require$FaultTolerance = $90XFO.FaultTolerance;
/**
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 * @typedef {import('.').Libp2pOptions} Libp2pOptions
 * @typedef {import('.').constructorOptions} constructorOptions
 */ const $1175a4f228e6a4d9$var$DefaultConfig = {
    addresses: {
        listen: [],
        announce: [],
        noAnnounce: [],
        announceFilter: (/** @type {Multiaddr[]} */ multiaddrs)=>multiaddrs
    },
    connectionManager: {
        minConnections: 25
    },
    transportManager: {
        faultTolerance: $1175a4f228e6a4d9$require$FaultTolerance.FATAL_ALL
    },
    dialer: {
        maxParallelDials: $h6RaR.MAX_PARALLEL_DIALS,
        maxDialsPerPeer: $h6RaR.MAX_PER_PEER_DIALS,
        dialTimeout: $h6RaR.DIAL_TIMEOUT,
        resolvers: {
            dnsaddr: $1175a4f228e6a4d9$require$dnsaddrResolver
        },
        addressSorter: $1175a4f228e6a4d9$require$publicAddressesFirst
    },
    host: {
        agentVersion: $1175a4f228e6a4d9$require$AGENT_VERSION
    },
    metrics: {
        enabled: false
    },
    peerStore: {
        persistence: false,
        threshold: 5
    },
    peerRouting: {
        refreshManager: {
            enabled: true,
            interval: 6e5,
            bootDelay: 10e3
        }
    },
    config: {
        protocolPrefix: "ipfs",
        dht: {
            enabled: false,
            kBucketSize: 20
        },
        nat: {
            enabled: true,
            ttl: 7200,
            keepAlive: true,
            gateway: null,
            externalIp: null,
            pmp: {
                enabled: false
            }
        },
        peerDiscovery: {
            autoDial: true
        },
        pubsub: {
            enabled: true
        },
        relay: {
            enabled: true,
            advertise: {
                bootDelay: $9gQk1.ADVERTISE_BOOT_DELAY,
                enabled: false,
                ttl: $9gQk1.ADVERTISE_TTL
            },
            hop: {
                enabled: false,
                active: false
            },
            autoRelay: {
                enabled: false,
                maxListeners: 2
            }
        },
        transport: {}
    }
};
$1175a4f228e6a4d9$export$a22775fa5e2eebd9 = (opts)=>{
    /** @type {DefaultConfig & Libp2pOptions & constructorOptions} */ const resultingOptions = $8pyvD($1175a4f228e6a4d9$var$DefaultConfig, opts);
    if (resultingOptions.modules.transport.length < 1) throw new Error("'options.modules.transport' must contain at least 1 transport");
    return resultingOptions;
};

});
parcelRequire.register("8pyvD", function(module, exports) {
"use strict";

var $an1wk = parcelRequire("an1wk");
const { hasOwnProperty: $61fb6d5ddb5bb6be$var$hasOwnProperty } = Object.prototype;
const { propertyIsEnumerable: $61fb6d5ddb5bb6be$var$propertyIsEnumerable } = Object;
const $61fb6d5ddb5bb6be$var$defineProperty = (object, name, value)=>Object.defineProperty(object, name, {
        value: value,
        writable: true,
        enumerable: true,
        configurable: true
    });
const $61fb6d5ddb5bb6be$var$globalThis = module.exports;
const $61fb6d5ddb5bb6be$var$defaultMergeOptions = {
    concatArrays: false,
    ignoreUndefined: false
};
const $61fb6d5ddb5bb6be$var$getEnumerableOwnPropertyKeys = (value)=>{
    const keys = [];
    for(const key in value)if ($61fb6d5ddb5bb6be$var$hasOwnProperty.call(value, key)) keys.push(key);
    /* istanbul ignore else  */ if (Object.getOwnPropertySymbols) {
        const symbols = Object.getOwnPropertySymbols(value);
        for (const symbol of symbols)if ($61fb6d5ddb5bb6be$var$propertyIsEnumerable.call(value, symbol)) keys.push(symbol);
    }
    return keys;
};
function $61fb6d5ddb5bb6be$var$clone(value) {
    if (Array.isArray(value)) return $61fb6d5ddb5bb6be$var$cloneArray(value);
    if ($an1wk(value)) return $61fb6d5ddb5bb6be$var$cloneOptionObject(value);
    return value;
}
function $61fb6d5ddb5bb6be$var$cloneArray(array) {
    const result = array.slice(0, 0);
    $61fb6d5ddb5bb6be$var$getEnumerableOwnPropertyKeys(array).forEach((key)=>{
        $61fb6d5ddb5bb6be$var$defineProperty(result, key, $61fb6d5ddb5bb6be$var$clone(array[key]));
    });
    return result;
}
function $61fb6d5ddb5bb6be$var$cloneOptionObject(object) {
    const result = Object.getPrototypeOf(object) === null ? Object.create(null) : {};
    $61fb6d5ddb5bb6be$var$getEnumerableOwnPropertyKeys(object).forEach((key)=>{
        $61fb6d5ddb5bb6be$var$defineProperty(result, key, $61fb6d5ddb5bb6be$var$clone(object[key]));
    });
    return result;
}
/**
 * @param {*} merged already cloned
 * @param {*} source something to merge
 * @param {string[]} keys keys to merge
 * @param {Object} config Config Object
 * @returns {*} cloned Object
 */ const $61fb6d5ddb5bb6be$var$mergeKeys = (merged, source, keys, config)=>{
    keys.forEach((key)=>{
        if (typeof source[key] === "undefined" && config.ignoreUndefined) return;
        // Do not recurse into prototype chain of merged
        if (key in merged && merged[key] !== Object.getPrototypeOf(merged)) $61fb6d5ddb5bb6be$var$defineProperty(merged, key, $61fb6d5ddb5bb6be$var$merge(merged[key], source[key], config));
        else $61fb6d5ddb5bb6be$var$defineProperty(merged, key, $61fb6d5ddb5bb6be$var$clone(source[key]));
    });
    return merged;
};
/**
 * @param {*} merged already cloned
 * @param {*} source something to merge
 * @param {Object} config Config Object
 * @returns {*} cloned Object
 *
 * see [Array.prototype.concat ( ...arguments )](http://www.ecma-international.org/ecma-262/6.0/#sec-array.prototype.concat)
 */ const $61fb6d5ddb5bb6be$var$concatArrays = (merged, source, config)=>{
    let result = merged.slice(0, 0);
    let resultIndex = 0;
    [
        merged,
        source
    ].forEach((array)=>{
        const indices = [];
        // `result.concat(array)` with cloning
        for(let k = 0; k < array.length; k++){
            if (!$61fb6d5ddb5bb6be$var$hasOwnProperty.call(array, k)) continue;
            indices.push(String(k));
            if (array === merged) // Already cloned
            $61fb6d5ddb5bb6be$var$defineProperty(result, resultIndex++, array[k]);
            else $61fb6d5ddb5bb6be$var$defineProperty(result, resultIndex++, $61fb6d5ddb5bb6be$var$clone(array[k]));
        }
        // Merge non-index keys
        result = $61fb6d5ddb5bb6be$var$mergeKeys(result, array, $61fb6d5ddb5bb6be$var$getEnumerableOwnPropertyKeys(array).filter((key)=>!indices.includes(key)), config);
    });
    return result;
};
/**
 * @param {*} merged already cloned
 * @param {*} source something to merge
 * @param {Object} config Config Object
 * @returns {*} cloned Object
 */ function $61fb6d5ddb5bb6be$var$merge(merged, source, config) {
    if (config.concatArrays && Array.isArray(merged) && Array.isArray(source)) return $61fb6d5ddb5bb6be$var$concatArrays(merged, source, config);
    if (!$an1wk(source) || !$an1wk(merged)) return $61fb6d5ddb5bb6be$var$clone(source);
    return $61fb6d5ddb5bb6be$var$mergeKeys(merged, source, $61fb6d5ddb5bb6be$var$getEnumerableOwnPropertyKeys(source), config);
}
module.exports = function(...options) {
    const config = $61fb6d5ddb5bb6be$var$merge($61fb6d5ddb5bb6be$var$clone($61fb6d5ddb5bb6be$var$defaultMergeOptions), this !== $61fb6d5ddb5bb6be$var$globalThis && this || {}, $61fb6d5ddb5bb6be$var$defaultMergeOptions);
    let merged = {
        _: {}
    };
    for (const option of options){
        if (option === undefined) continue;
        if (!$an1wk(option)) throw new TypeError("`" + option + "` is not an Option Object");
        merged = $61fb6d5ddb5bb6be$var$merge(merged, {
            _: option
        }, config);
    }
    return merged._;
};

});
parcelRequire.register("an1wk", function(module, exports) {
"use strict";
module.exports = (value)=>{
    if (Object.prototype.toString.call(value) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
};

});


parcelRequire.register("lHxnk", function(module, exports) {
"use strict";

var $eLYQN = parcelRequire("eLYQN");
const { code: $fcc780c088a9f1b3$var$dnsaddrCode } = $eLYQN("dnsaddr");

/**
 * @typedef {import('..').Multiaddr} Multiaddr
 */ /**
 * Resolver for dnsaddr addresses.
 *
 * @param {Multiaddr} addr
 * @returns {Promise<string[]>}
 */ async function $fcc780c088a9f1b3$var$dnsaddrResolver(addr) {
    const Resolver = (parcelRequire("hVHsE"));
    const resolver = new Resolver();
    const peerId = addr.getPeerId();
    const [, hostname] = addr.stringTuples().find(([proto])=>proto === $fcc780c088a9f1b3$var$dnsaddrCode) || [];
    const records = await resolver.resolveTxt(`_dnsaddr.${hostname}`);
    let addresses = records.flat().map((a)=>a.split("=")[1]);
    if (peerId) addresses = addresses.filter((entry)=>entry.includes(peerId));
    return addresses;
}
module.exports = {
    dnsaddrResolver: $fcc780c088a9f1b3$var$dnsaddrResolver
};

});
parcelRequire.register("hVHsE", function(module, exports) {
"use strict";

var $dZWos = parcelRequire("dZWos");
module.exports = $dZWos;

});
parcelRequire.register("dZWos", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $a30e4491d6ccfea0$var$log = $jjmHV("dns-over-http-resolver");
$a30e4491d6ccfea0$var$log.error = $jjmHV("dns-over-http-resolver:error");

var $1Og9p = parcelRequire("1Og9p");

var $f2QJs = parcelRequire("f2QJs");
/**
 * DNS over HTTP resolver.
 * Uses a list of servers to resolve DNS records with HTTP requests.
 */ class $a30e4491d6ccfea0$var$Resolver {
    /**
   * @class
   * @param {object} [properties]
   * @param {number} [properties.maxCache = 100] - maximum number of cached dns records.
   */ constructor({ maxCache: maxCache = 100 } = {}){
        this._cache = new $1Og9p({
            max: maxCache
        });
        this._servers = [
            "https://cloudflare-dns.com/dns-query",
            "https://dns.google/resolve"
        ];
    }
    /**
   * Get an array of the IP addresses currently configured for DNS resolution.
   * These addresses are formatted according to RFC 5952. It can include a custom port.
   *
   * @returns {Array<string>}
   */ getServers() {
        return this._servers;
    }
    /**
   * Get a shuffled array of the IP addresses currently configured for DNS resolution.
   * These addresses are formatted according to RFC 5952. It can include a custom port.
   *
   * @returns {Array<string>}
   */ _getShuffledServers() {
        const newServers = [].concat(this._servers);
        for(let i = newServers.length - 1; i > 0; i--){
            const j = Math.floor(Math.random() * i);
            const temp = newServers[i];
            newServers[i] = newServers[j];
            newServers[j] = temp;
        }
        return newServers;
    }
    /**
   * Sets the IP address and port of servers to be used when performing DNS resolution.
   *
   * @param {Array<string>} servers - array of RFC 5952 formatted addresses.
   */ setServers(servers) {
        this._servers = servers;
    }
    /**
   * Uses the DNS protocol to resolve the given host name into the appropriate DNS record.
   *
   * @param {string} hostname - host name to resolve.
   * @param {string} [rrType = 'A'] - resource record type.
   * @returns {Promise<*>}
   */ resolve(hostname, rrType = "A") {
        switch(rrType){
            case "A":
                return this.resolve4(hostname);
            case "AAAA":
                return this.resolve6(hostname);
            case "TXT":
                return this.resolveTxt(hostname);
            default:
                throw new Error(`${rrType} is not supported`);
        }
    }
    /**
   * Uses the DNS protocol to resolve the given host name into IPv4 addresses.
   *
   * @param {string} hostname - host name to resolve.
   * @returns {Promise<Array<string>>}
   */ async resolve4(hostname) {
        const recordType = "A";
        const cached = this._cache.get($f2QJs.getCacheKey(hostname, recordType));
        if (cached) return cached;
        for (const server of this._getShuffledServers())try {
            const response = await $f2QJs.fetch($f2QJs.buildResource({
                serverResolver: server,
                hostname: hostname,
                recordType: recordType
            }));
            const d = await response.json();
            const data = d.Answer.map((a)=>a.data);
            const ttl = Math.min(d.Answer.map((a)=>a.TTL));
            this._cache.set($f2QJs.getCacheKey(hostname, recordType), data, {
                ttl: ttl
            });
            return data;
        } catch (err) {
            $a30e4491d6ccfea0$var$log.error(`${server} could not resolve ${hostname} record ${recordType}`);
        }
        throw new Error(`Could not resolve ${hostname} record ${recordType}`);
    }
    /**
   * Uses the DNS protocol to resolve the given host name into IPv6 addresses.
   *
   * @param {string} hostname - host name to resolve.
   * @returns {Promise<Array<string>>}
   */ async resolve6(hostname) {
        const recordType = "AAAA";
        const cached = this._cache.get($f2QJs.getCacheKey(hostname, recordType));
        if (cached) return cached;
        for (const server of this._getShuffledServers())try {
            const response = await $f2QJs.fetch($f2QJs.buildResource({
                serverResolver: server,
                hostname: hostname,
                recordType: recordType
            }));
            const d = await response.json();
            const data = d.Answer.map((a)=>a.data);
            const ttl = Math.min(d.Answer.map((a)=>a.TTL));
            this._cache.set($f2QJs.getCacheKey(hostname, recordType), data, {
                ttl: ttl
            });
            return data;
        } catch (err) {
            $a30e4491d6ccfea0$var$log.error(`${server} could not resolve ${hostname} record ${recordType}`);
        }
        throw new Error(`Could not resolve ${hostname} record ${recordType}`);
    }
    /**
   * Uses the DNS protocol to resolve the given host name into a Text record.
   *
   * @param {string} hostname - host name to resolve.
   * @returns {Promise<Array<Array<string>>>}
   */ async resolveTxt(hostname) {
        const recordType = "TXT";
        const cached = this._cache.get($f2QJs.getCacheKey(hostname, recordType));
        if (cached) return cached;
        for (const server of this._getShuffledServers())try {
            const response = await $f2QJs.fetch($f2QJs.buildResource({
                serverResolver: server,
                hostname: hostname,
                recordType: recordType
            }));
            const d = await response.json();
            const data = d.Answer.map((a)=>[
                    a.data.replace(/['"]+/g, "")
                ]);
            const ttl = Math.min(d.Answer.map((a)=>a.TTL));
            this._cache.set($f2QJs.getCacheKey(hostname, recordType), data, {
                ttl: ttl
            });
            return data;
        } catch (err) {
            $a30e4491d6ccfea0$var$log.error(`${server} could not resolve ${hostname} record ${recordType}`);
        }
        throw new Error(`Could not resolve ${hostname} record ${recordType}`);
    }
}
$a30e4491d6ccfea0$var$Resolver.Resolver = $a30e4491d6ccfea0$var$Resolver;
module.exports = $a30e4491d6ccfea0$var$Resolver;

});
parcelRequire.register("1Og9p", function(module, exports) {
"use strict";
module.exports = $1516fd2398a799c3$var$Receptacle;

var $kPIxk = parcelRequire("kPIxk");
var $1516fd2398a799c3$var$cache = $1516fd2398a799c3$var$Receptacle.prototype;
var $1516fd2398a799c3$var$counter = new Date() % 1e9;
function $1516fd2398a799c3$var$getUID() {
    return (Math.random() * 1e9 >>> 0) + $1516fd2398a799c3$var$counter++;
}
/**
 * Creates a cache with a maximum key size.
 *
 * @constructor
 * @param {Object} options
 * @param {Number} [options.max=Infinity] the maximum number of keys allowed in the cache (lru).
 * @param {Array} [options.items=[]] the default items in the cache.
 */ function $1516fd2398a799c3$var$Receptacle(options) {
    options = options || {};
    this.id = options.id || $1516fd2398a799c3$var$getUID();
    this.max = options.max || Infinity;
    this.items = options.items || [];
    this._lookup = {};
    this.size = this.items.length;
    this.lastModified = new Date(options.lastModified || new Date());
    // Setup initial timers and indexes for the cache.
    for(var item, ttl, i = this.items.length; i--;){
        item = this.items[i];
        ttl = new Date(item.expires) - new Date();
        this._lookup[item.key] = item;
        if (ttl > 0) this.expire(item.key, ttl);
        else if (ttl <= 0) this.delete(item.key);
    }
}
/**
 * Tests if a key is currently in the cache.
 * Does not check if slot is empty.
 *
 * @param {String} key - the key to retrieve from the cache.
 * @return {Boolean}
 */ $1516fd2398a799c3$var$cache.has = function(key) {
    return key in this._lookup;
};
/**
 * Retrieves a key from the cache and marks it as recently used.
 *
 * @param {String} key - the key to retrieve from the cache.
 * @return {*}
 */ $1516fd2398a799c3$var$cache.get = function(key) {
    if (!this.has(key)) return null;
    var record = this._lookup[key];
    // Update expiry for "refresh" keys
    if (record.refresh) this.expire(key, record.refresh);
    // Move to front of the line.
    this.items.splice(this.items.indexOf(record), 1);
    this.items.push(record);
    return record.value;
};
/**
 * Retrieves user meta data for a cached item.
 *
 * @param {String} key - the key to retrieve meta data from the cache.
 * @return {*}
 */ $1516fd2398a799c3$var$cache.meta = function(key) {
    if (!this.has(key)) return null;
    var record = this._lookup[key];
    if (!("meta" in record)) return null;
    return record.meta;
};
/**
 * Puts a key into the cache with an optional expiry time.
 *
 * @param {String} key - the key for the value in the cache.
 * @param {*} value - the value to place at the key.
 * @param {Number} [options.ttl] - a time after which the key will be removed.
 * @return {Receptacle}
 */ $1516fd2398a799c3$var$cache.set = function(key, value, options) {
    var oldRecord = this._lookup[key];
    var record = this._lookup[key] = {
        key: key,
        value: value
    };
    // Mark cache as modified.
    this.lastModified = new Date();
    if (oldRecord) {
        // Replace an old key.
        clearTimeout(oldRecord.timeout);
        this.items.splice(this.items.indexOf(oldRecord), 1, record);
    } else {
        // Remove least used item if needed.
        if (this.size >= this.max) this.delete(this.items[0].key);
        // Add a new key.
        this.items.push(record);
        this.size++;
    }
    if (options) {
        // Setup key expiry.
        if ("ttl" in options) this.expire(key, options.ttl);
        // Store user options in the record.
        if ("meta" in options) record.meta = options.meta;
        // Mark a auto refresh key.
        if (options.refresh) record.refresh = options.ttl;
    }
    return this;
};
/**
 * Deletes an item from the cache.
 *
 * @param {String} key - the key to remove.
 * @return {Receptacle}
 */ $1516fd2398a799c3$var$cache.delete = function(key) {
    var record = this._lookup[key];
    if (!record) return false;
    this.lastModified = new Date();
    this.items.splice(this.items.indexOf(record), 1);
    clearTimeout(record.timeout);
    delete this._lookup[key];
    this.size--;
    return this;
};
/**
 * Utility to register a key that will be removed after some time.
 *
 * @param {String} key - the key to remove.
 * @param {Number} [ms] - the timeout before removal.
 * @return {Receptacle}
 */ $1516fd2398a799c3$var$cache.expire = function(key, ttl) {
    var ms = ttl || 0;
    var record = this._lookup[key];
    if (!record) return this;
    if (typeof ms === "string") ms = $kPIxk(ttl);
    if (typeof ms !== "number") throw new TypeError("Expiration time must be a string or number.");
    clearTimeout(record.timeout);
    record.timeout = setTimeout(this.delete.bind(this, record.key), ms);
    record.expires = Number(new Date()) + ms;
    return this;
};
/**
 * Deletes all items from the cache.
 * @return {Receptacle}
 */ $1516fd2398a799c3$var$cache.clear = function() {
    for(var i = this.items.length; i--;)this.delete(this.items[i].key);
    return this;
};
/**
 * Fixes serialization issues in polyfilled environments.
 * Ensures non-cyclical serialized object.
 */ $1516fd2398a799c3$var$cache.toJSON = function() {
    var items = new Array(this.items.length);
    var item;
    for(var i = items.length; i--;){
        item = this.items[i];
        items[i] = {
            key: item.key,
            meta: item.meta,
            value: item.value,
            expires: item.expires,
            refresh: item.refresh
        };
    }
    return {
        id: this.id,
        max: isFinite(this.max) ? this.max : undefined,
        lastModified: this.lastModified,
        items: items
    };
};

});
parcelRequire.register("kPIxk", function(module, exports) {
/**
 * Helpers.
 */ var $f2ab1e1dc0b74534$var$s = 1000;
var $f2ab1e1dc0b74534$var$m = $f2ab1e1dc0b74534$var$s * 60;
var $f2ab1e1dc0b74534$var$h = $f2ab1e1dc0b74534$var$m * 60;
var $f2ab1e1dc0b74534$var$d = $f2ab1e1dc0b74534$var$h * 24;
var $f2ab1e1dc0b74534$var$w = $f2ab1e1dc0b74534$var$d * 7;
var $f2ab1e1dc0b74534$var$y = $f2ab1e1dc0b74534$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) return $f2ab1e1dc0b74534$var$parse(val);
    else if (type === "number" && isFinite(val)) return options.long ? $f2ab1e1dc0b74534$var$fmtLong(val) : $f2ab1e1dc0b74534$var$fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $f2ab1e1dc0b74534$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * $f2ab1e1dc0b74534$var$y;
        case "weeks":
        case "week":
        case "w":
            return n * $f2ab1e1dc0b74534$var$w;
        case "days":
        case "day":
        case "d":
            return n * $f2ab1e1dc0b74534$var$d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * $f2ab1e1dc0b74534$var$h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * $f2ab1e1dc0b74534$var$m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * $f2ab1e1dc0b74534$var$s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $f2ab1e1dc0b74534$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $f2ab1e1dc0b74534$var$d) return Math.round(ms / $f2ab1e1dc0b74534$var$d) + "d";
    if (msAbs >= $f2ab1e1dc0b74534$var$h) return Math.round(ms / $f2ab1e1dc0b74534$var$h) + "h";
    if (msAbs >= $f2ab1e1dc0b74534$var$m) return Math.round(ms / $f2ab1e1dc0b74534$var$m) + "m";
    if (msAbs >= $f2ab1e1dc0b74534$var$s) return Math.round(ms / $f2ab1e1dc0b74534$var$s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $f2ab1e1dc0b74534$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $f2ab1e1dc0b74534$var$d) return $f2ab1e1dc0b74534$var$plural(ms, msAbs, $f2ab1e1dc0b74534$var$d, "day");
    if (msAbs >= $f2ab1e1dc0b74534$var$h) return $f2ab1e1dc0b74534$var$plural(ms, msAbs, $f2ab1e1dc0b74534$var$h, "hour");
    if (msAbs >= $f2ab1e1dc0b74534$var$m) return $f2ab1e1dc0b74534$var$plural(ms, msAbs, $f2ab1e1dc0b74534$var$m, "minute");
    if (msAbs >= $f2ab1e1dc0b74534$var$s) return $f2ab1e1dc0b74534$var$plural(ms, msAbs, $f2ab1e1dc0b74534$var$s, "second");
    return ms + " ms";
}
/**
 * Pluralization helper.
 */ function $f2ab1e1dc0b74534$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
}

});


parcelRequire.register("f2QJs", function(module, exports) {
"use strict";

var $atB4X = parcelRequire("atB4X");
var $af3ff273239e270a$require$nativeFetch = $atB4X.default;
var $af3ff273239e270a$require$Headers = $atB4X.Headers;
/**
 * Build fetch resource for request.
 *
 * @param {object} properties
 * @param {string} properties.serverResolver
 * @param {string} properties.hostname
 * @param {string} properties.recordType
 * @returns {string}
 */ function $af3ff273239e270a$var$buildResource({ serverResolver: serverResolver, hostname: hostname, recordType: recordType }) {
    return `${serverResolver}?name=${hostname}&type=${recordType}`;
}
/**
 * Use fetch to find the record.
 *
 * @param {object} resource
 * @returns {Promise}
 */ function $af3ff273239e270a$var$fetch(resource) {
    return $af3ff273239e270a$require$nativeFetch(resource, {
        headers: new $af3ff273239e270a$require$Headers({
            accept: "application/dns-json"
        })
    });
}
/**
 * Creates cache key composed by recordType and hostname.
 *
 * @param {string} hostname
 * @param {string} recordType
 * @returns {string}
 */ function $af3ff273239e270a$var$getCacheKey(hostname, recordType) {
    return `${recordType}_${hostname}`;
}
module.exports = {
    buildResource: $af3ff273239e270a$var$buildResource,
    fetch: $af3ff273239e270a$var$fetch,
    getCacheKey: $af3ff273239e270a$var$getCacheKey
};

});
parcelRequire.register("atB4X", function(module, exports) {
"use strict";




if (globalThis.fetch && globalThis.Headers && globalThis.Request && globalThis.Response) module.exports = {
    default: globalThis.fetch,
    Headers: globalThis.Headers,
    Request: globalThis.Request,
    Response: globalThis.Response
};
else module.exports = {
    default: (parcelRequire("dLuOI")).default,
    Headers: (parcelRequire("dLuOI")).Headers,
    Request: (parcelRequire("dLuOI")).Request,
    Response: (parcelRequire("dLuOI")).Response
};

});
parcelRequire.register("dLuOI", function(module, exports) {
"use strict";
// ref: https://github.com/tc39/proposal-global
var getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
};
var globalObject = getGlobal();
module.exports = exports = globalObject.fetch;
// Needed for TypeScript and Webpack.
if (globalObject.fetch) exports.default = globalObject.fetch.bind(globalObject);
exports.Headers = globalObject.Headers;
exports.Request = globalObject.Request;
exports.Response = globalObject.Response;

});






parcelRequire.register("h6RaR", function(module, exports) {
"use strict";
module.exports = {
    DIAL_TIMEOUT: 30e3,
    MAX_PARALLEL_DIALS: 100,
    MAX_PER_PEER_DIALS: 4,
    MAX_ADDRS_TO_DIAL: 25,
    METRICS: {
        computeThrottleMaxQueueSize: 1000,
        computeThrottleTimeout: 2000,
        movingAverageIntervals: [
            60000,
            300000,
            900000 // 15 minutes
        ],
        maxOldPeersRetention: 50
    }
};

});

parcelRequire.register("hBHKi", function(module, exports) {

$parcel$export(module.exports, "AGENT_VERSION", () => $cd17d361e2d7f151$export$e3ca982d1170a9de, (v) => $cd17d361e2d7f151$export$e3ca982d1170a9de = v);
$parcel$export(module.exports, "MULTICODEC_IDENTIFY", () => $cd17d361e2d7f151$export$dfa4030181b80780, (v) => $cd17d361e2d7f151$export$dfa4030181b80780 = v);
$parcel$export(module.exports, "MULTICODEC_IDENTIFY_PUSH", () => $cd17d361e2d7f151$export$1bc830b12dcbc094, (v) => $cd17d361e2d7f151$export$1bc830b12dcbc094 = v);
$parcel$export(module.exports, "IDENTIFY_PROTOCOL_VERSION", () => $cd17d361e2d7f151$export$5fea085f12e5db8, (v) => $cd17d361e2d7f151$export$5fea085f12e5db8 = v);
$parcel$export(module.exports, "MULTICODEC_IDENTIFY_PROTOCOL_NAME", () => $cd17d361e2d7f151$export$8d0145e2a13c62cc, (v) => $cd17d361e2d7f151$export$8d0145e2a13c62cc = v);
$parcel$export(module.exports, "MULTICODEC_IDENTIFY_PUSH_PROTOCOL_NAME", () => $cd17d361e2d7f151$export$e3a25b5822821cd7, (v) => $cd17d361e2d7f151$export$e3a25b5822821cd7 = v);
$parcel$export(module.exports, "MULTICODEC_IDENTIFY_PROTOCOL_VERSION", () => $cd17d361e2d7f151$export$b9a3369bea701005, (v) => $cd17d361e2d7f151$export$b9a3369bea701005 = v);
$parcel$export(module.exports, "MULTICODEC_IDENTIFY_PUSH_PROTOCOL_VERSION", () => $cd17d361e2d7f151$export$f98421b55600d17b, (v) => $cd17d361e2d7f151$export$f98421b55600d17b = v);
var $cd17d361e2d7f151$export$f9f4c8b229485833// deprecated
;
var $cd17d361e2d7f151$export$e3ca982d1170a9de;
var $cd17d361e2d7f151$export$dfa4030181b80780// deprecated
;
var $cd17d361e2d7f151$export$1bc830b12dcbc094// deprecated
;
var $cd17d361e2d7f151$export$5fea085f12e5db8;
var $cd17d361e2d7f151$export$8d0145e2a13c62cc;
var $cd17d361e2d7f151$export$e3a25b5822821cd7;
var $cd17d361e2d7f151$export$b9a3369bea701005;
var $cd17d361e2d7f151$export$f98421b55600d17b;
"use strict";

var $hUdce = parcelRequire("hUdce");
var $cd17d361e2d7f151$require$libp2pVersion = $hUdce.version;
$cd17d361e2d7f151$export$f9f4c8b229485833 = "ipfs/0.1.0";
$cd17d361e2d7f151$export$e3ca982d1170a9de = `js-libp2p/${$cd17d361e2d7f151$require$libp2pVersion}`;
$cd17d361e2d7f151$export$dfa4030181b80780 = "/ipfs/id/1.0.0";
$cd17d361e2d7f151$export$1bc830b12dcbc094 = "/ipfs/id/push/1.0.0";
$cd17d361e2d7f151$export$5fea085f12e5db8 = "0.1.0";
$cd17d361e2d7f151$export$8d0145e2a13c62cc = "id";
$cd17d361e2d7f151$export$e3a25b5822821cd7 = "id/push";
$cd17d361e2d7f151$export$b9a3369bea701005 = "1.0.0";
$cd17d361e2d7f151$export$f98421b55600d17b = "1.0.0";

});
parcelRequire.register("hUdce", function(module, exports) {
module.exports = JSON.parse('{"name":"libp2p","version":"0.35.8","description":"JavaScript implementation of libp2p, a modular peer to peer network stack","leadMaintainer":"Jacob Heun <jacobheun@gmail.com>","main":"src/index.js","types":"dist/src/index.d.ts","typesVersions":{"*":{"src/*":["dist/src/*","dist/src/*/index"]}},"files":["dist","src"],"scripts":{"lint":"aegir lint","build":"aegir build","build:proto":"npm run build:proto:circuit && npm run build:proto:identify && npm run build:proto:plaintext && npm run build:proto:address-book && npm run build:proto:proto-book && npm run build:proto:peer-record && npm run build:proto:envelope","build:proto:circuit":"pbjs -t static-module -w commonjs -r libp2p-circuit --force-number --no-verify --no-delimited --no-create --no-beautify --no-defaults --lint eslint-disable -o src/circuit/protocol/index.js ./src/circuit/protocol/index.proto","build:proto:identify":"pbjs -t static-module -w commonjs -r libp2p-identify --force-number --no-verify --no-delimited --no-create --no-beautify --no-defaults --lint eslint-disable -o src/identify/message.js ./src/identify/message.proto","build:proto:plaintext":"pbjs -t static-module -w commonjs -r libp2p-plaintext --force-number --no-verify --no-delimited --no-create --no-beautify --no-defaults --lint eslint-disable -o src/insecure/proto.js ./src/insecure/proto.proto","build:proto:address-book":"pbjs -t static-module -w commonjs -r libp2p-address-book --force-number --no-verify --no-delimited --no-create --no-beautify --no-defaults --lint eslint-disable -o src/peer-store/persistent/pb/address-book.js ./src/peer-store/persistent/pb/address-book.proto","build:proto:proto-book":"pbjs -t static-module -w commonjs -r libp2p-proto-book --force-number --no-verify --no-delimited --no-create --no-beautify --no-defaults --lint eslint-disable -o src/peer-store/persistent/pb/proto-book.js ./src/peer-store/persistent/pb/proto-book.proto","build:proto:peer-record":"pbjs -t static-module -w commonjs -r libp2p-peer-record --force-number --no-verify --no-delimited --no-create --no-beautify --no-defaults --lint eslint-disable -o src/record/peer-record/peer-record.js ./src/record/peer-record/peer-record.proto","build:proto:envelope":"pbjs -t static-module -w commonjs -r libp2p-envelope --force-number --no-verify --no-delimited --no-create --no-beautify --no-defaults --lint eslint-disable -o src/record/envelope/envelope.js ./src/record/envelope/envelope.proto","build:proto-types":"npm run build:proto-types:circuit && npm run build:proto-types:identify && npm run build:proto-types:plaintext && npm run build:proto-types:address-book && npm run build:proto-types:proto-book && npm run build:proto-types:peer-record && npm run build:proto-types:envelope","build:proto-types:circuit":"pbts -o src/circuit/protocol/index.d.ts src/circuit/protocol/index.js","build:proto-types:identify":"pbts -o src/identify/message.d.ts src/identify/message.js","build:proto-types:plaintext":"pbts -o src/insecure/proto.d.ts src/insecure/proto.js","build:proto-types:address-book":"pbts -o src/peer-store/persistent/pb/address-book.d.ts src/peer-store/persistent/pb/address-book.js","build:proto-types:proto-book":"pbts -o src/peer-store/persistent/pb/proto-book.d.ts src/peer-store/persistent/pb/proto-book.js","build:proto-types:peer-record":"pbts -o src/record/peer-record/peer-record.d.ts src/record/peer-record/peer-record.js","build:proto-types:envelope":"pbts -o src/record/envelope/envelope.d.ts src/record/envelope/envelope.js","test":"aegir test","test:ts":"aegir build --no-bundle && npm run test --prefix test/ts-use","test:node":"aegir test -t node -f \\"./test/**/*.{node,spec}.js\\"","test:browser":"aegir test -t browser","test:examples":"cd examples && npm run test:all","test:interop":"LIBP2P_JS=$PWD npx aegir test -t node -f ./node_modules/libp2p-interop/test/*","prepare":"aegir build --no-bundle","release":"aegir release -t node -t browser","release-minor":"aegir release --type minor -t node -t browser","release-major":"aegir release --type major -t node -t browser","coverage":"nyc --reporter=text --reporter=lcov npm run test:node"},"repository":{"type":"git","url":"https://github.com/libp2p/js-libp2p.git"},"keywords":["libp2p","network","p2p","peer","peer-to-peer","IPFS"],"bugs":{"url":"https://github.com/libp2p/js-libp2p/issues"},"homepage":"https://libp2p.io","license":"MIT","engines":{"node":">=15.0.0"},"browser":{"nat-api":false},"eslintConfig":{"extends":"ipfs","ignorePatterns":["!.aegir.js","test/ts-use","*.d.ts"]},"dependencies":{"@vascosantos/moving-average":"^1.1.0","abort-controller":"^3.0.0","abortable-iterator":"^3.0.0","aggregate-error":"^3.1.0","any-signal":"^2.1.1","bignumber.js":"^9.0.1","class-is":"^1.1.0","debug":"^4.3.1","err-code":"^3.0.0","es6-promisify":"^7.0.0","events":"^3.3.0","hashlru":"^2.3.0","interface-datastore":"^6.0.2","it-all":"^1.0.4","it-buffer":"^0.1.2","it-drain":"^1.0.3","it-filter":"^1.0.1","it-first":"^1.0.4","it-handshake":"^2.0.0","it-length-prefixed":"^5.0.2","it-map":"^1.0.4","it-merge":"^1.0.0","it-pipe":"^1.1.0","it-take":"^1.0.0","libp2p-crypto":"^0.21.0","libp2p-interfaces":"^2.0.1","libp2p-utils":"^0.4.0","mafmt":"^10.0.0","merge-options":"^3.0.4","multiaddr":"^10.0.0","multiformats":"^9.0.0","multistream-select":"^2.0.0","mutable-proxy":"^1.0.0","nat-api":"^0.3.1","node-forge":"^0.10.0","p-any":"^3.0.0","p-fifo":"^1.0.0","p-retry":"^4.4.0","p-settle":"^4.1.1","peer-id":"^0.16.0","private-ip":"^2.1.0","protobufjs":"^6.10.2","retimer":"^3.0.0","sanitize-filename":"^1.6.3","set-delayed-interval":"^1.0.0","streaming-iterables":"^6.0.0","timeout-abort-controller":"^2.0.0","uint8arrays":"^3.0.0","varint":"^6.0.0","wherearewe":"^1.0.0","xsalsa20":"^1.1.0"},"devDependencies":{"@chainsafe/libp2p-noise":"^5.0.0","@nodeutils/defaults-deep":"^1.1.0","@types/es6-promisify":"^6.0.0","@types/node":"^16.0.1","@types/node-forge":"^0.10.1","@types/varint":"^6.0.0","aegir":"^36.0.0","buffer":"^6.0.3","datastore-core":"^6.0.7","delay":"^5.0.0","into-stream":"^6.0.0","ipfs-http-client":"^54.0.2","it-concat":"^2.0.0","it-pair":"^1.0.0","it-pushable":"^1.4.0","libp2p":".","libp2p-bootstrap":"^0.14.0","libp2p-delegated-content-routing":"^0.11.0","libp2p-delegated-peer-routing":"^0.11.1","libp2p-floodsub":"^0.28.0","libp2p-gossipsub":"^0.12.1","libp2p-interfaces-compliance-tests":"^2.0.1","libp2p-interop":"^0.5.0","libp2p-kad-dht":"^0.27.1","libp2p-mdns":"^0.18.0","libp2p-mplex":"^0.10.1","libp2p-tcp":"^0.17.0","libp2p-webrtc-star":"^0.25.0","libp2p-websockets":"^0.16.0","nock":"^13.0.3","p-defer":"^3.0.0","p-times":"^3.0.0","p-wait-for":"^3.2.0","rimraf":"^3.0.2","sinon":"^12.0.1","util":"^0.12.3"},"contributors":["Vasco Santos <vasco.santos@moxy.studio>","David Dias <daviddias.p@gmail.com>","Jacob Heun <jacobheun@gmail.com>","Alex Potsides <alex@achingbrain.net>","Alan Shaw <alan@tableflip.io>","Cayman <caymannava@gmail.com>","Pedro Teixeira <i@pgte.me>","Friedel Ziegelmayer <dignifiedquire@gmail.com>","Maciej Kr\xfcger <mkg20001@gmail.com>","Hugo Dias <mail@hugodias.me>","dirkmc <dirkmdev@gmail.com>","Volker Mische <volker.mische@gmail.com>","Chris Dostert <chrisdostert@users.noreply.github.com>","zeim839 <50573884+zeim839@users.noreply.github.com>","Robert Kiel <robert.kiel@hoprnet.org>","Richard Littauer <richard.littauer@gmail.com>","a1300 <matthias-knopp@gmx.net>","Ryan Bell <ryan@piing.net>","ᴠɪᴄᴛᴏʀ ʙᴊᴇʟᴋʜᴏʟᴍ <victorbjelkholm@gmail.com>","Andrew Nesbitt <andrewnez@gmail.com>","Franck Royer <franck@royer.one>","Thomas Eizinger <thomas@eizinger.io>","V\xedt Habada <vithabada93@gmail.com>","Giovanni T. Parra <fiatjaf@gmail.com>","acolytec3 <17355484+acolytec3@users.noreply.github.com>","Alan Smithee <ggnore.alan.smithee@gmail.com>","Elven <mon.samuel@qq.com>","Samlior <samlior@foxmail.com>","Didrik Nordstr\xf6m <didrik.nordstrom@gmail.com>","Aditya Bose <13054902+adbose@users.noreply.github.com>","TJKoury <TJKoury@gmail.com>","TheStarBoys <41286328+TheStarBoys@users.noreply.github.com>","Tiago Alves <alvesjtiago@gmail.com>","Tim Daubensch\xfctz <tim@daubenschuetz.de>","XiaoZhang <zxinmyth@gmail.com>","Yusef Napora <yusef@napora.org>","Zane Starr <zcstarr@gmail.com>","ebinks <elizabethjbinks@gmail.com>","greenSnot <greenSnot@users.noreply.github.com>","isan_rivkin <isanrivkin@gmail.com>","mayerwin <mayerwin@users.noreply.github.com>","mcclure <andi.m.mcclure@gmail.com>","patrickwoodhead <91056047+patrickwoodhead@users.noreply.github.com>","phillmac <phillmac@users.noreply.github.com>","robertkiel <robert.kiel@validitylabs.org>","shresthagrawal <34920931+shresthagrawal@users.noreply.github.com>","swedneck <40505480+swedneck@users.noreply.github.com>","tuyennhv <vutuyen2636@gmail.com>","S\xf6nke Hahn <soenkehahn@gmail.com>","Aleksei <vozhdb@gmail.com>","Bernd Strehl <bernd.strehl@gmail.com>","Chris Bratlien <chrisbratlien@gmail.com>","Cindy Wu <ciindy.wu@gmail.com>","Daijiro Wachi <daijiro.wachi@gmail.com>","Diogo Silva <fsdiogo@gmail.com>","Dmitriy Ryajov <dryajov@gmail.com>","Ethan Lam <elmemphis2000@gmail.com>","Fei Liu <liu.feiwood@gmail.com>","Felipe Martins <felipebrasil93@gmail.com>","Florian-Merle <florian.david.merle@gmail.com>","Francis Gulotta <wizard@roborooter.com>","Guy Sviry <32539816+guysv@users.noreply.github.com>","Henrique Dias <hacdias@gmail.com>","Irakli Gozalishvili <rfobic@gmail.com>","Joel Gustafson <joelg@mit.edu>","John Rees <johnrees@users.noreply.github.com>","Jo\xe3o Santos <joaosantos15@users.noreply.github.com>","Julien Bouquillon <contact@revolunet.com>","Kevin Kwok <antimatter15@gmail.com>","Kevin Lacker <lacker@gmail.com>","Lars Gierth <lgierth@users.noreply.github.com>","Leask Wong <i@leaskh.com>","Marcin Tojek <mtojek@users.noreply.github.com>","Marston Connell <34043723+TheMarstonConnell@users.noreply.github.com>","Michael Burns <5170+mburns@users.noreply.github.com>","Miguel Mota <miguelmota2@gmail.com>","Nuno Nogueira <nunofmn@gmail.com>","Philipp Muens <raute1337@gmx.de>","RasmusErik Voel Jensen <github@solsort.com>","Smite Chow <xiaopengyou@live.com>","Soeren <nikorpoulsen@gmail.com>"]}');

});


parcelRequire.register("9gQk1", function(module, exports) {
"use strict";
const $6bfe31b43082b1fe$var$minute = 60000;
module.exports = {
    ADVERTISE_BOOT_DELAY: 15 * $6bfe31b43082b1fe$var$minute,
    ADVERTISE_TTL: 30 * $6bfe31b43082b1fe$var$minute,
    CIRCUIT_PROTO_CODE: 290,
    HOP_METADATA_KEY: "hop_relay",
    HOP_METADATA_VALUE: "true",
    RELAY_RENDEZVOUS_NS: "/libp2p/relay" // Relay HOP relay service namespace for discovery
};

});

parcelRequire.register("lFIT7", function(module, exports) {

$parcel$export(module.exports, "publicAddressesFirst", () => $fc703f1d7e2064d2$export$9326e5a88d7bae9c, (v) => $fc703f1d7e2064d2$export$9326e5a88d7bae9c = v);
var $fc703f1d7e2064d2$export$9326e5a88d7bae9c;
"use strict";

var $8dFJ1 = parcelRequire("8dFJ1");
/**
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 */ /**
 * @typedef {Object} Address
 * @property {Multiaddr} multiaddr peer multiaddr.
 * @property {boolean} isCertified obtained from a signed peer record.
 */ /**
 * Compare function for array.sort().
 * This sort aims to move the private adresses to the end of the array.
 * In case of equality, a certified address will come first.
 *
 * @param {Address} a
 * @param {Address} b
 * @returns {number}
 */ function $fc703f1d7e2064d2$var$addressesPublicFirstCompareFunction(a, b) {
    const isAPrivate = $8dFJ1(a.multiaddr);
    const isBPrivate = $8dFJ1(b.multiaddr);
    if (isAPrivate && !isBPrivate) return 1;
    else if (!isAPrivate && isBPrivate) return -1;
    // Check certified?
    if (a.isCertified && !b.isCertified) return -1;
    else if (!a.isCertified && b.isCertified) return 1;
    return 0;
}
/**
 * Sort given addresses by putting public addresses first.
 * In case of equality, a certified address will come first.
 *
 * @param {Array<Address>} addresses
 * @returns {Array<Address>}
 */ function $fc703f1d7e2064d2$var$publicAddressesFirst(addresses) {
    return [
        ...addresses
    ].sort($fc703f1d7e2064d2$var$addressesPublicFirstCompareFunction);
}
$fc703f1d7e2064d2$export$9326e5a88d7bae9c = $fc703f1d7e2064d2$var$publicAddressesFirst;

});
parcelRequire.register("8dFJ1", function(module, exports) {
"use strict";

var $6bVKo = parcelRequire("6bVKo");
/**
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 */ /**
 * Check if a given multiaddr has a private address.
 *
 * @param {Multiaddr} ma
 * @returns {boolean}
 */ function $5fbfe75bda34102d$var$isPrivate(ma) {
    const { address: address } = ma.nodeAddress();
    return $6bVKo(address);
}
module.exports = $5fbfe75bda34102d$var$isPrivate;

});
parcelRequire.register("6bVKo", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4Q2o7")).default;

});
parcelRequire.register("4Q2o7", function(module, exports) {
"use strict";
var $385ddef4271f1598$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3KePv = parcelRequire("3KePv");

const $385ddef4271f1598$var$ip_regex_1 = $385ddef4271f1598$var$__importDefault((parcelRequire("fpA8v")));

const $385ddef4271f1598$var$is_ip_1 = $385ddef4271f1598$var$__importDefault((parcelRequire("glIOy")));

var $bQHUQ = parcelRequire("bQHUQ");
const $385ddef4271f1598$var$PRIVATE_IP_RANGES = [
    "0.0.0.0/8",
    "10.0.0.0/8",
    "100.64.0.0/10",
    "127.0.0.0/8",
    "169.254.0.0/16",
    "172.16.0.0/12",
    "192.0.0.0/24",
    "192.0.0.0/29",
    "192.0.0.8/32",
    "192.0.0.9/32",
    "192.0.0.10/32",
    "192.0.0.170/32",
    "192.0.0.171/32",
    "192.0.2.0/24",
    "192.31.196.0/24",
    "192.52.193.0/24",
    "192.88.99.0/24",
    "192.168.0.0/16",
    "192.175.48.0/24",
    "198.18.0.0/15",
    "198.51.100.0/24",
    "203.0.113.0/24",
    "240.0.0.0/4",
    "255.255.255.255/32"
];
const $385ddef4271f1598$var$NETMASK_RANGES = $385ddef4271f1598$var$PRIVATE_IP_RANGES.map((ip_range)=>new $3KePv.Netmask(ip_range));
function $385ddef4271f1598$var$ipv4_check(ip_addr) {
    for (let r of $385ddef4271f1598$var$NETMASK_RANGES){
        if (r.contains(ip_addr)) return true;
    }
    return false;
}
function $385ddef4271f1598$var$ipv6_check(ip_addr) {
    return /^::$/.test(ip_addr) || /^::1$/.test(ip_addr) || /^::f{4}:([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})$/.test(ip_addr) || /^::f{4}:0.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})$/.test(ip_addr) || /^64:ff9b::([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})$/.test(ip_addr) || /^100::([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4})$/.test(ip_addr) || /^2001::([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4})$/.test(ip_addr) || /^2001:2[0-9a-fA-F]:([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4})$/.test(ip_addr) || /^2001:db8:([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4})$/.test(ip_addr) || /^2002:([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4}):?([0-9a-fA-F]{0,4})$/.test(ip_addr) || /^f[c-d]([0-9a-fA-F]{2,2}):/i.test(ip_addr) || /^fe[8-9a-bA-B][0-9a-fA-F]:/i.test(ip_addr) || /^ff([0-9a-fA-F]{2,2}):/i.test(ip_addr);
}
module.exports.default = (ip)=>{
    if ((0, $bQHUQ.isValid)(ip)) {
        const parsed = (0, $bQHUQ.parse)(ip);
        if (parsed.kind() === "ipv4") return $385ddef4271f1598$var$ipv4_check(parsed.toNormalizedString());
        else if (parsed.kind() === "ipv6") return $385ddef4271f1598$var$ipv6_check(ip);
    } else if ((0, $385ddef4271f1598$var$is_ip_1.default)(ip) && $385ddef4271f1598$var$ip_regex_1.default.v6().test(ip)) return $385ddef4271f1598$var$ipv6_check(ip);
    return undefined;
};

});
parcelRequire.register("3KePv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.long2ip = module.exports.ip2long = module.exports.Netmask = void 0;

var $jm6yz = parcelRequire("jm6yz");
Object.defineProperty(module.exports, "ip2long", {
    enumerable: true,
    get: function() {
        return $jm6yz.ip2long;
    }
});
Object.defineProperty(module.exports, "long2ip", {
    enumerable: true,
    get: function() {
        return $jm6yz.long2ip;
    }
});

var $hJBPm = parcelRequire("hJBPm");
class $2ba12bd4248fc57a$var$Netmask {
    constructor(net, mask){
        if (typeof net !== "string") throw new Error("Missing `net' parameter");
        // Detect IPv6: check the address part (before any /) for ':'
        const addrPart = net.indexOf("/") !== -1 ? net.substring(0, net.indexOf("/")) : net;
        if (addrPart.indexOf(":") !== -1) this._impl = new $hJBPm.Netmask6Impl(net, mask);
        else this._impl = new $jm6yz.Netmask4Impl(net, mask);
        this.base = this._impl.base;
        this.mask = this._impl.mask;
        this.hostmask = this._impl.hostmask;
        this.bitmask = this._impl.bitmask;
        this.size = this._impl.size;
        this.first = this._impl.first;
        this.last = this._impl.last;
        this.broadcast = this._impl.broadcast;
        if (this._impl instanceof $jm6yz.Netmask4Impl) {
            this.maskLong = this._impl.maskLong;
            this.netLong = this._impl.netLong;
        } else {
            this.maskLong = 0;
            this.netLong = 0;
        }
    }
    contains(ip) {
        if (typeof ip === "string") {
            // If it has a '/', it's a CIDR block — wrap it
            if (ip.indexOf("/") > 0) ip = new $2ba12bd4248fc57a$var$Netmask(ip);
            else if (ip.indexOf(":") === -1 && ip.split(".").length !== 4) ip = new $2ba12bd4248fc57a$var$Netmask(ip);
        }
        if (ip instanceof $2ba12bd4248fc57a$var$Netmask) return this.contains(ip.base) && this.contains(ip.broadcast || ip.last);
        // Plain IP string — delegate to impl
        return this._impl.contains(ip);
    }
    next(count = 1) {
        const nextImpl = this._impl.next(count);
        const result = new $2ba12bd4248fc57a$var$Netmask(nextImpl.base, nextImpl.bitmask);
        return result;
    }
    /** @deprecated */ forEach(fn) {
        this._impl.forEach(fn);
    }
    toString() {
        return this._impl.toString();
    }
}
module.exports.Netmask = $2ba12bd4248fc57a$var$Netmask;

});
parcelRequire.register("jm6yz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Netmask4Impl = void 0;
module.exports.ip2long = $e175286399ea97aa$var$ip2long;
module.exports.long2ip = $e175286399ea97aa$var$long2ip;
function $e175286399ea97aa$var$long2ip(long) {
    const a = (long & -16777216) >>> 24;
    const b = (long & 16711680) >>> 16;
    const c = (long & 65280) >>> 8;
    const d = long & 0xff;
    return [
        a,
        b,
        c,
        d
    ].join(".");
}
const $e175286399ea97aa$var$chr0 = "0".charCodeAt(0);
const $e175286399ea97aa$var$chra = "a".charCodeAt(0);
const $e175286399ea97aa$var$chrA = "A".charCodeAt(0);
function $e175286399ea97aa$var$parseNum(s) {
    let n = 0;
    let base = 10;
    let dmax = "9";
    let i = 0;
    if (s.length > 1 && s[i] === "0") {
        if (s[i + 1] === "x" || s[i + 1] === "X") {
            i += 2;
            base = 16;
        } else if ("0" <= s[i + 1] && s[i + 1] <= "9") {
            i++;
            base = 8;
            dmax = "7";
        }
    }
    const start = i;
    while(i < s.length){
        if ("0" <= s[i] && s[i] <= dmax) n = n * base + (s.charCodeAt(i) - $e175286399ea97aa$var$chr0) >>> 0;
        else if (base === 16) {
            if ("a" <= s[i] && s[i] <= "f") n = n * base + (10 + s.charCodeAt(i) - $e175286399ea97aa$var$chra) >>> 0;
            else if ("A" <= s[i] && s[i] <= "F") n = n * base + (10 + s.charCodeAt(i) - $e175286399ea97aa$var$chrA) >>> 0;
            else break;
        } else break;
        if (n > 0xFFFFFFFF) throw new Error("too large");
        i++;
    }
    if (i === start) throw new Error("empty octet");
    return [
        n,
        i
    ];
}
function $e175286399ea97aa$var$ip2long(ip) {
    const b = [];
    for(let i = 0; i <= 3; i++){
        if (ip.length === 0) break;
        if (i > 0) {
            if (ip[0] !== ".") throw new Error("Invalid IP");
            ip = ip.substring(1);
        }
        const [n, c] = $e175286399ea97aa$var$parseNum(ip);
        ip = ip.substring(c);
        b.push(n);
    }
    if (ip.length !== 0) throw new Error("Invalid IP");
    switch(b.length){
        case 1:
            if (b[0] > 0xFFFFFFFF) throw new Error("Invalid IP");
            return b[0] >>> 0;
        case 2:
            if (b[0] > 0xFF || b[1] > 0xFFFFFF) throw new Error("Invalid IP");
            return (b[0] << 24 | b[1]) >>> 0;
        case 3:
            if (b[0] > 0xFF || b[1] > 0xFF || b[2] > 0xFFFF) throw new Error("Invalid IP");
            return (b[0] << 24 | b[1] << 16 | b[2]) >>> 0;
        case 4:
            if (b[0] > 0xFF || b[1] > 0xFF || b[2] > 0xFF || b[3] > 0xFF) throw new Error("Invalid IP");
            return (b[0] << 24 | b[1] << 16 | b[2] << 8 | b[3]) >>> 0;
        default:
            throw new Error("Invalid IP");
    }
}
class $e175286399ea97aa$var$Netmask4Impl {
    constructor(net, mask){
        if (typeof net !== "string") throw new Error("Missing `net' parameter");
        let maskStr = mask;
        if (!maskStr) {
            const parts = net.split("/", 2);
            net = parts[0];
            maskStr = parts[1];
        }
        if (!maskStr) maskStr = 32;
        if (typeof maskStr === "string" && maskStr.indexOf(".") > -1) {
            try {
                this.maskLong = $e175286399ea97aa$var$ip2long(maskStr);
            } catch (error) {
                throw new Error("Invalid mask: " + maskStr);
            }
            this.bitmask = NaN;
            for(let i = 32; i >= 0; i--)if (this.maskLong === 0xffffffff << 32 - i >>> 0) {
                this.bitmask = i;
                break;
            }
        } else if (maskStr || maskStr === 0) {
            this.bitmask = parseInt(maskStr, 10);
            this.maskLong = 0;
            if (this.bitmask > 0) this.maskLong = 0xffffffff << 32 - this.bitmask >>> 0;
        } else throw new Error("Invalid mask: empty");
        try {
            this.netLong = ($e175286399ea97aa$var$ip2long(net) & this.maskLong) >>> 0;
        } catch (error) {
            throw new Error("Invalid net address: " + net);
        }
        if (!(this.bitmask <= 32)) throw new Error("Invalid mask for ip4: " + maskStr);
        this.size = Math.pow(2, 32 - this.bitmask);
        this.base = $e175286399ea97aa$var$long2ip(this.netLong);
        this.mask = $e175286399ea97aa$var$long2ip(this.maskLong);
        this.hostmask = $e175286399ea97aa$var$long2ip(~this.maskLong);
        this.first = this.bitmask <= 30 ? $e175286399ea97aa$var$long2ip(this.netLong + 1) : this.base;
        this.last = this.bitmask <= 30 ? $e175286399ea97aa$var$long2ip(this.netLong + this.size - 2) : $e175286399ea97aa$var$long2ip(this.netLong + this.size - 1);
        this.broadcast = this.bitmask <= 30 ? $e175286399ea97aa$var$long2ip(this.netLong + this.size - 1) : undefined;
    }
    contains(ip) {
        if (typeof ip === "string" && (ip.indexOf("/") > 0 || ip.split(".").length !== 4)) ip = new $e175286399ea97aa$var$Netmask4Impl(ip);
        if (ip instanceof $e175286399ea97aa$var$Netmask4Impl) return this.contains(ip.base) && this.contains(ip.broadcast || ip.last);
        else return ($e175286399ea97aa$var$ip2long(ip) & this.maskLong) >>> 0 === (this.netLong & this.maskLong) >>> 0;
    }
    next(count = 1) {
        return new $e175286399ea97aa$var$Netmask4Impl($e175286399ea97aa$var$long2ip(this.netLong + this.size * count), this.mask);
    }
    forEach(fn) {
        let long = $e175286399ea97aa$var$ip2long(this.first);
        const lastLong = $e175286399ea97aa$var$ip2long(this.last);
        let index = 0;
        while(long <= lastLong){
            fn($e175286399ea97aa$var$long2ip(long), long, index);
            index++;
            long++;
        }
    }
    toString() {
        return this.base + "/" + this.bitmask;
    }
}
module.exports.Netmask4Impl = $e175286399ea97aa$var$Netmask4Impl;

});

parcelRequire.register("hJBPm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Netmask6Impl = void 0;
module.exports.ip6bigint = $ce93fb5928453bd2$var$ip6bigint;
module.exports.bigint2ip6 = $ce93fb5928453bd2$var$bigint2ip6;

var $jm6yz = parcelRequire("jm6yz");
const $ce93fb5928453bd2$var$MAX_IPV6 = (1n << 128n) - 1n;
function $ce93fb5928453bd2$var$ip6bigint(ip) {
    // Strip zone ID (e.g. %eth0)
    const zoneIdx = ip.indexOf("%");
    if (zoneIdx !== -1) ip = ip.substring(0, zoneIdx);
    // Handle mixed IPv4-mapped (e.g. ::ffff:192.168.1.1)
    const lastColon = ip.lastIndexOf(":");
    if (lastColon !== -1 && ip.indexOf(".", lastColon) !== -1) {
        const ipv4Part = ip.substring(lastColon + 1);
        const ipv4Long = (0, $jm6yz.ip2long)(ipv4Part);
        // IPv4 part replaces last 2 groups (32 bits), expand prefix to 6 groups
        const ipv6Prefix = ip.substring(0, lastColon + 1) + "0:0";
        const prefixVal = $ce93fb5928453bd2$var$parseIPv6Pure(ipv6Prefix);
        return prefixVal & ~0xffffffffn | BigInt(ipv4Long);
    }
    return $ce93fb5928453bd2$var$parseIPv6Pure(ip);
}
function $ce93fb5928453bd2$var$parseIPv6Pure(ip) {
    const doubleColonIdx = ip.indexOf("::");
    let groups;
    if (doubleColonIdx !== -1) {
        const left = ip.substring(0, doubleColonIdx);
        const right = ip.substring(doubleColonIdx + 2);
        const leftGroups = left === "" ? [] : left.split(":");
        const rightGroups = right === "" ? [] : right.split(":");
        const missing = 8 - leftGroups.length - rightGroups.length;
        if (missing < 0) throw new Error("Invalid IPv6: too many groups");
        groups = [
            ...leftGroups,
            ...Array(missing).fill("0"),
            ...rightGroups
        ];
    } else groups = ip.split(":");
    if (groups.length !== 8) throw new Error("Invalid IPv6: expected 8 groups, got " + groups.length);
    let result = 0n;
    for(let i = 0; i < 8; i++){
        const g = groups[i];
        if (g.length === 0 || g.length > 4) throw new Error('Invalid IPv6: bad group "' + g + '"');
        const val = parseInt(g, 16);
        if (isNaN(val) || val < 0 || val > 0xffff) throw new Error('Invalid IPv6: bad group "' + g + '"');
        result = result << 16n | BigInt(val);
    }
    return result;
}
function $ce93fb5928453bd2$var$bigint2ip6(n) {
    if (n < 0n || n > $ce93fb5928453bd2$var$MAX_IPV6) throw new Error("Invalid IPv6 address value");
    const groups = [];
    for(let i = 0; i < 8; i++){
        groups.unshift(Number(n & 0xffffn));
        n >>= 16n;
    }
    // RFC 5952: find longest run of consecutive zero groups
    let bestStart = -1;
    let bestLen = 0;
    let curStart = -1;
    let curLen = 0;
    for(let i = 0; i < 8; i++)if (groups[i] === 0) {
        if (curStart === -1) {
            curStart = i;
            curLen = 1;
        } else curLen++;
    } else {
        if (curLen > bestLen && curLen >= 2) {
            bestStart = curStart;
            bestLen = curLen;
        }
        curStart = -1;
        curLen = 0;
    }
    if (curLen > bestLen && curLen >= 2) {
        bestStart = curStart;
        bestLen = curLen;
    }
    if (bestStart !== -1 && bestStart + bestLen === 8 && bestStart > 0) {
        const before = groups.slice(0, bestStart).map((g)=>g.toString(16));
        return before.join(":") + "::";
    } else if (bestStart === 0) {
        const after = groups.slice(bestLen).map((g)=>g.toString(16));
        return "::" + after.join(":");
    } else if (bestStart > 0) {
        const before = groups.slice(0, bestStart).map((g)=>g.toString(16));
        const after = groups.slice(bestStart + bestLen).map((g)=>g.toString(16));
        return before.join(":") + "::" + after.join(":");
    } else return groups.map((g)=>g.toString(16)).join(":");
}
class $ce93fb5928453bd2$var$Netmask6Impl {
    constructor(net, mask){
        if (typeof net !== "string") throw new Error("Missing `net' parameter");
        let prefixLen = mask;
        if (prefixLen === undefined || prefixLen === null) {
            const slashIdx = net.indexOf("/");
            if (slashIdx !== -1) {
                prefixLen = parseInt(net.substring(slashIdx + 1), 10);
                net = net.substring(0, slashIdx);
            } else prefixLen = 128;
        }
        if (isNaN(prefixLen) || prefixLen < 0 || prefixLen > 128) throw new Error("Invalid mask for IPv6: " + prefixLen);
        this.bitmask = prefixLen;
        if (this.bitmask === 0) this.maskBigint = 0n;
        else this.maskBigint = $ce93fb5928453bd2$var$MAX_IPV6 >> BigInt(128 - this.bitmask) << BigInt(128 - this.bitmask);
        try {
            this.netBigint = $ce93fb5928453bd2$var$ip6bigint(net) & this.maskBigint;
        } catch (error) {
            throw new Error("Invalid IPv6 net address: " + net);
        }
        this.size = Number(1n << BigInt(128 - this.bitmask));
        this.base = $ce93fb5928453bd2$var$bigint2ip6(this.netBigint);
        this.mask = $ce93fb5928453bd2$var$bigint2ip6(this.maskBigint);
        this.hostmask = $ce93fb5928453bd2$var$bigint2ip6(~this.maskBigint & $ce93fb5928453bd2$var$MAX_IPV6);
        this.first = this.base;
        this.last = $ce93fb5928453bd2$var$bigint2ip6(this.netBigint + (1n << BigInt(128 - this.bitmask)) - 1n);
        this.broadcast = undefined;
    }
    contains(ip) {
        if (typeof ip === "string") {
            if (ip.indexOf("/") > 0) ip = new $ce93fb5928453bd2$var$Netmask6Impl(ip);
        }
        if (ip instanceof $ce93fb5928453bd2$var$Netmask6Impl) return this.contains(ip.base) && this.contains(ip.last);
        else {
            const addr = $ce93fb5928453bd2$var$ip6bigint(ip);
            return (addr & this.maskBigint) === this.netBigint;
        }
    }
    next(count = 1) {
        const sizeBig = 1n << BigInt(128 - this.bitmask);
        return new $ce93fb5928453bd2$var$Netmask6Impl($ce93fb5928453bd2$var$bigint2ip6(this.netBigint + sizeBig * BigInt(count)), this.bitmask);
    }
    forEach(fn) {
        let addr = this.netBigint;
        const sizeBig = 1n << BigInt(128 - this.bitmask);
        const lastAddr = this.netBigint + sizeBig - 1n;
        let index = 0;
        while(addr <= lastAddr){
            fn($ce93fb5928453bd2$var$bigint2ip6(addr), Number(addr), index);
            index++;
            addr++;
        }
    }
    toString() {
        return this.base + "/" + this.bitmask;
    }
}
module.exports.Netmask6Impl = $ce93fb5928453bd2$var$Netmask6Impl;

});


parcelRequire.register("bQHUQ", function(module, exports) {
(function(root) {
    "use strict";
    // A list of regular expressions that match arbitrary IPv4 addresses,
    // for which a number of weird notations exist.
    // Note that an address like 0010.0xa5.1.1 is considered legal.
    const ipv4Part = "(0?\\d+|0x[a-f0-9]+)";
    const ipv4Regexes = {
        fourOctet: new RegExp(`^${ipv4Part}\\.${ipv4Part}\\.${ipv4Part}\\.${ipv4Part}$`, "i"),
        threeOctet: new RegExp(`^${ipv4Part}\\.${ipv4Part}\\.${ipv4Part}$`, "i"),
        twoOctet: new RegExp(`^${ipv4Part}\\.${ipv4Part}$`, "i"),
        longValue: new RegExp(`^${ipv4Part}$`, "i")
    };
    // Regular Expression for checking Octal numbers
    const octalRegex = new RegExp(`^0[0-7]+$`, "i");
    const hexRegex = new RegExp(`^0x[a-f0-9]+$`, "i");
    const zoneIndex = "%[0-9a-z]{1,}";
    // IPv6-matching regular expressions.
    // For IPv6, the task is simpler: it is enough to match the colon-delimited
    // hexadecimal IPv6 and a transitional variant with dotted-decimal IPv4 at
    // the end.
    const ipv6Part = "(?:[0-9a-f]+::?)+";
    const ipv6Regexes = {
        zoneIndex: new RegExp(zoneIndex, "i"),
        "native": new RegExp(`^(::)?(${ipv6Part})?([0-9a-f]+)?(::)?(${zoneIndex})?$`, "i"),
        deprecatedTransitional: new RegExp(`^(?:::)(${ipv4Part}\\.${ipv4Part}\\.${ipv4Part}\\.${ipv4Part}(${zoneIndex})?)$`, "i"),
        transitional: new RegExp(`^((?:${ipv6Part})|(?:::)(?:${ipv6Part})?)${ipv4Part}\\.${ipv4Part}\\.${ipv4Part}\\.${ipv4Part}(${zoneIndex})?$`, "i")
    };
    // Expand :: in an IPv6 address or address part consisting of `parts` groups.
    function expandIPv6(string, parts) {
        // More than one '::' means invalid address
        if (string.indexOf("::") !== string.lastIndexOf("::")) return null;
        let colonCount = 0;
        let lastColon = -1;
        let zoneId = (string.match(ipv6Regexes.zoneIndex) || [])[0];
        let replacement, replacementCount;
        // Remove zone index and save it for later
        if (zoneId) {
            zoneId = zoneId.substring(1);
            string = string.replace(/%.+$/, "");
        }
        // How many parts do we already have?
        while((lastColon = string.indexOf(":", lastColon + 1)) >= 0)colonCount++;
        // 0::0 is two parts more than ::
        if (string.substr(0, 2) === "::") colonCount--;
        if (string.substr(-2, 2) === "::") colonCount--;
        // The following loop would hang if colonCount > parts
        if (colonCount > parts) return null;
        // replacement = ':' + '0:' * (parts - colonCount)
        replacementCount = parts - colonCount;
        replacement = ":";
        while(replacementCount--)replacement += "0:";
        // Insert the missing zeroes
        string = string.replace("::", replacement);
        // Trim any garbage which may be hanging around if :: was at the edge in
        // the source string
        if (string[0] === ":") string = string.slice(1);
        if (string[string.length - 1] === ":") string = string.slice(0, -1);
        parts = function() {
            const ref = string.split(":");
            const results = [];
            for(let i = 0; i < ref.length; i++)results.push(parseInt(ref[i], 16));
            return results;
        }();
        return {
            parts: parts,
            zoneId: zoneId
        };
    }
    // A generic CIDR (Classless Inter-Domain Routing) RFC1518 range matcher.
    function matchCIDR(first, second, partSize, cidrBits) {
        if (first.length !== second.length) throw new Error("ipaddr: cannot match CIDR for objects with different lengths");
        let part = 0;
        let shift;
        while(cidrBits > 0){
            shift = partSize - cidrBits;
            if (shift < 0) shift = 0;
            if (first[part] >> shift !== second[part] >> shift) return false;
            cidrBits -= partSize;
            part += 1;
        }
        return true;
    }
    function parseIntAuto(string) {
        // Hexadecimal base 16 (0x#)
        if (hexRegex.test(string)) return parseInt(string, 16);
        // While octal representation is discouraged by ECMAScript 3
        // and forbidden by ECMAScript 5, we silently allow it to
        // work only if the rest of the string has numbers less than 8.
        if (string[0] === "0" && !isNaN(parseInt(string[1], 10))) {
            if (octalRegex.test(string)) return parseInt(string, 8);
            throw new Error(`ipaddr: cannot parse ${string} as octal`);
        }
        // Always include the base 10 radix!
        return parseInt(string, 10);
    }
    function padPart(part, length) {
        while(part.length < length)part = `0${part}`;
        return part;
    }
    const ipaddr = {};
    // An IPv4 address (RFC791).
    ipaddr.IPv4 = function() {
        // Constructs a new IPv4 address from an array of four octets
        // in network order (MSB first)
        // Verifies the input.
        function IPv4(octets) {
            if (octets.length !== 4) throw new Error("ipaddr: ipv4 octet count should be 4");
            let i, octet;
            for(i = 0; i < octets.length; i++){
                octet = octets[i];
                if (!(0 <= octet && octet <= 255)) throw new Error("ipaddr: ipv4 octet should fit in 8 bits");
            }
            this.octets = octets;
        }
        // Special IPv4 address ranges.
        // See also https://en.wikipedia.org/wiki/Reserved_IP_addresses
        IPv4.prototype.SpecialRanges = {
            unspecified: [
                [
                    new IPv4([
                        0,
                        0,
                        0,
                        0
                    ]),
                    8
                ]
            ],
            broadcast: [
                [
                    new IPv4([
                        255,
                        255,
                        255,
                        255
                    ]),
                    32
                ]
            ],
            // RFC3171
            multicast: [
                [
                    new IPv4([
                        224,
                        0,
                        0,
                        0
                    ]),
                    4
                ]
            ],
            // RFC3927
            linkLocal: [
                [
                    new IPv4([
                        169,
                        254,
                        0,
                        0
                    ]),
                    16
                ]
            ],
            // RFC5735
            loopback: [
                [
                    new IPv4([
                        127,
                        0,
                        0,
                        0
                    ]),
                    8
                ]
            ],
            // RFC6598
            carrierGradeNat: [
                [
                    new IPv4([
                        100,
                        64,
                        0,
                        0
                    ]),
                    10
                ]
            ],
            // RFC1918
            "private": [
                [
                    new IPv4([
                        10,
                        0,
                        0,
                        0
                    ]),
                    8
                ],
                [
                    new IPv4([
                        172,
                        16,
                        0,
                        0
                    ]),
                    12
                ],
                [
                    new IPv4([
                        192,
                        168,
                        0,
                        0
                    ]),
                    16
                ]
            ],
            // Reserved and testing-only ranges; RFCs 5735, 5737, 2544, 1700
            reserved: [
                [
                    new IPv4([
                        192,
                        0,
                        0,
                        0
                    ]),
                    24
                ],
                [
                    new IPv4([
                        192,
                        0,
                        2,
                        0
                    ]),
                    24
                ],
                [
                    new IPv4([
                        192,
                        88,
                        99,
                        0
                    ]),
                    24
                ],
                [
                    new IPv4([
                        198,
                        18,
                        0,
                        0
                    ]),
                    15
                ],
                [
                    new IPv4([
                        198,
                        51,
                        100,
                        0
                    ]),
                    24
                ],
                [
                    new IPv4([
                        203,
                        0,
                        113,
                        0
                    ]),
                    24
                ],
                [
                    new IPv4([
                        240,
                        0,
                        0,
                        0
                    ]),
                    4
                ]
            ],
            // RFC7534, RFC7535
            as112: [
                [
                    new IPv4([
                        192,
                        175,
                        48,
                        0
                    ]),
                    24
                ],
                [
                    new IPv4([
                        192,
                        31,
                        196,
                        0
                    ]),
                    24
                ]
            ],
            // RFC7450
            amt: [
                [
                    new IPv4([
                        192,
                        52,
                        193,
                        0
                    ]),
                    24
                ]
            ]
        };
        // The 'kind' method exists on both IPv4 and IPv6 classes.
        IPv4.prototype.kind = function() {
            return "ipv4";
        };
        // Checks if this address matches other one within given CIDR range.
        IPv4.prototype.match = function(other, cidrRange) {
            let ref;
            if (cidrRange === undefined) {
                ref = other;
                other = ref[0];
                cidrRange = ref[1];
            }
            if (other.kind() !== "ipv4") throw new Error("ipaddr: cannot match ipv4 address with non-ipv4 one");
            return matchCIDR(this.octets, other.octets, 8, cidrRange);
        };
        // returns a number of leading ones in IPv4 address, making sure that
        // the rest is a solid sequence of 0's (valid netmask)
        // returns either the CIDR length or null if mask is not valid
        IPv4.prototype.prefixLengthFromSubnetMask = function() {
            let cidr = 0;
            // non-zero encountered stop scanning for zeroes
            let stop = false;
            // number of zeroes in octet
            const zerotable = {
                0: 8,
                128: 7,
                192: 6,
                224: 5,
                240: 4,
                248: 3,
                252: 2,
                254: 1,
                255: 0
            };
            let i, octet, zeros;
            for(i = 3; i >= 0; i -= 1){
                octet = this.octets[i];
                if (octet in zerotable) {
                    zeros = zerotable[octet];
                    if (stop && zeros !== 0) return null;
                    if (zeros !== 8) stop = true;
                    cidr += zeros;
                } else return null;
            }
            return 32 - cidr;
        };
        // Checks if the address corresponds to one of the special ranges.
        IPv4.prototype.range = function() {
            return ipaddr.subnetMatch(this, this.SpecialRanges);
        };
        // Returns an array of byte-sized values in network order (MSB first)
        IPv4.prototype.toByteArray = function() {
            return this.octets.slice(0);
        };
        // Converts this IPv4 address to an IPv4-mapped IPv6 address.
        IPv4.prototype.toIPv4MappedAddress = function() {
            return ipaddr.IPv6.parse(`::ffff:${this.toString()}`);
        };
        // Symmetrical method strictly for aligning with the IPv6 methods.
        IPv4.prototype.toNormalizedString = function() {
            return this.toString();
        };
        // Returns the address in convenient, decimal-dotted format.
        IPv4.prototype.toString = function() {
            return this.octets.join(".");
        };
        return IPv4;
    }();
    // A utility function to return broadcast address given the IPv4 interface and prefix length in CIDR notation
    ipaddr.IPv4.broadcastAddressFromCIDR = function(string) {
        try {
            const cidr = this.parseCIDR(string);
            const ipInterfaceOctets = cidr[0].toByteArray();
            const subnetMaskOctets = this.subnetMaskFromPrefixLength(cidr[1]).toByteArray();
            const octets = [];
            let i = 0;
            while(i < 4){
                // Broadcast address is bitwise OR between ip interface and inverted mask
                octets.push(parseInt(ipInterfaceOctets[i], 10) | parseInt(subnetMaskOctets[i], 10) ^ 255);
                i++;
            }
            return new this(octets);
        } catch (e) {
            throw new Error("ipaddr: the address does not have IPv4 CIDR format");
        }
    };
    // Checks if a given string is formatted like IPv4 address.
    ipaddr.IPv4.isIPv4 = function(string) {
        return this.parser(string) !== null;
    };
    // Checks if a given string is a valid IPv4 address.
    ipaddr.IPv4.isValid = function(string) {
        try {
            new this(this.parser(string));
            return true;
        } catch (e) {
            return false;
        }
    };
    // Checks if a given string is a valid IPv4 address in CIDR notation.
    ipaddr.IPv4.isValidCIDR = function(string) {
        try {
            this.parseCIDR(string);
            return true;
        } catch (e) {
            return false;
        }
    };
    // Checks if a given string is a full four-part IPv4 Address.
    ipaddr.IPv4.isValidFourPartDecimal = function(string) {
        if (ipaddr.IPv4.isValid(string) && string.match(/^(0|[1-9]\d*)(\.(0|[1-9]\d*)){3}$/)) return true;
        else return false;
    };
    // Checks if a given string is a full four-part IPv4 Address with CIDR prefix.
    ipaddr.IPv4.isValidCIDRFourPartDecimal = function(string) {
        const match = string.match(/^(.+)\/(\d+)$/);
        if (!ipaddr.IPv4.isValidCIDR(string) || !match) return false;
        return ipaddr.IPv4.isValidFourPartDecimal(match[1]);
    };
    // A utility function to return network address given the IPv4 interface and prefix length in CIDR notation
    ipaddr.IPv4.networkAddressFromCIDR = function(string) {
        let cidr, i, ipInterfaceOctets, octets, subnetMaskOctets;
        try {
            cidr = this.parseCIDR(string);
            ipInterfaceOctets = cidr[0].toByteArray();
            subnetMaskOctets = this.subnetMaskFromPrefixLength(cidr[1]).toByteArray();
            octets = [];
            i = 0;
            while(i < 4){
                // Network address is bitwise AND between ip interface and mask
                octets.push(parseInt(ipInterfaceOctets[i], 10) & parseInt(subnetMaskOctets[i], 10));
                i++;
            }
            return new this(octets);
        } catch (e) {
            throw new Error("ipaddr: the address does not have IPv4 CIDR format");
        }
    };
    // Tries to parse and validate a string with IPv4 address.
    // Throws an error if it fails.
    ipaddr.IPv4.parse = function(string) {
        const parts = this.parser(string);
        if (parts === null) throw new Error("ipaddr: string is not formatted like an IPv4 Address");
        return new this(parts);
    };
    // Parses the string as an IPv4 Address with CIDR Notation.
    ipaddr.IPv4.parseCIDR = function(string) {
        let match;
        if (match = string.match(/^(.+)\/(\d+)$/)) {
            const maskLength = parseInt(match[2]);
            if (maskLength >= 0 && maskLength <= 32) {
                const parsed = [
                    this.parse(match[1]),
                    maskLength
                ];
                Object.defineProperty(parsed, "toString", {
                    value: function() {
                        return this.join("/");
                    }
                });
                return parsed;
            }
        }
        throw new Error("ipaddr: string is not formatted like an IPv4 CIDR range");
    };
    // Classful variants (like a.b, where a is an octet, and b is a 24-bit
    // value representing last three octets; this corresponds to a class C
    // address) are omitted due to classless nature of modern Internet.
    ipaddr.IPv4.parser = function(string) {
        let match, part, value;
        // parseInt recognizes all that octal & hexadecimal weirdness for us
        if (match = string.match(ipv4Regexes.fourOctet)) return function() {
            const ref = match.slice(1, 6);
            const results = [];
            for(let i = 0; i < ref.length; i++){
                part = ref[i];
                results.push(parseIntAuto(part));
            }
            return results;
        }();
        else if (match = string.match(ipv4Regexes.longValue)) {
            value = parseIntAuto(match[1]);
            if (value > 0xffffffff || value < 0) throw new Error("ipaddr: address outside defined range");
            return (function() {
                const results = [];
                let shift;
                for(shift = 0; shift <= 24; shift += 8)results.push(value >> shift & 0xff);
                return results;
            })().reverse();
        } else if (match = string.match(ipv4Regexes.twoOctet)) return function() {
            const ref = match.slice(1, 4);
            const results = [];
            value = parseIntAuto(ref[1]);
            if (value > 0xffffff || value < 0) throw new Error("ipaddr: address outside defined range");
            results.push(parseIntAuto(ref[0]));
            results.push(value >> 16 & 0xff);
            results.push(value >> 8 & 0xff);
            results.push(value & 0xff);
            return results;
        }();
        else if (match = string.match(ipv4Regexes.threeOctet)) return function() {
            const ref = match.slice(1, 5);
            const results = [];
            value = parseIntAuto(ref[2]);
            if (value > 0xffff || value < 0) throw new Error("ipaddr: address outside defined range");
            results.push(parseIntAuto(ref[0]));
            results.push(parseIntAuto(ref[1]));
            results.push(value >> 8 & 0xff);
            results.push(value & 0xff);
            return results;
        }();
        else return null;
    };
    // A utility function to return subnet mask in IPv4 format given the prefix length
    ipaddr.IPv4.subnetMaskFromPrefixLength = function(prefix) {
        prefix = parseInt(prefix);
        if (prefix < 0 || prefix > 32) throw new Error("ipaddr: invalid IPv4 prefix length");
        const octets = [
            0,
            0,
            0,
            0
        ];
        let j = 0;
        const filledOctetCount = Math.floor(prefix / 8);
        while(j < filledOctetCount){
            octets[j] = 255;
            j++;
        }
        if (filledOctetCount < 4) octets[filledOctetCount] = Math.pow(2, prefix % 8) - 1 << 8 - prefix % 8;
        return new this(octets);
    };
    // An IPv6 address (RFC2460)
    ipaddr.IPv6 = function() {
        // Constructs an IPv6 address from an array of eight 16 - bit parts
        // or sixteen 8 - bit parts in network order(MSB first).
        // Throws an error if the input is invalid.
        function IPv6(parts, zoneId) {
            let i, part;
            if (parts.length === 16) {
                this.parts = [];
                for(i = 0; i <= 14; i += 2)this.parts.push(parts[i] << 8 | parts[i + 1]);
            } else if (parts.length === 8) this.parts = parts;
            else throw new Error("ipaddr: ipv6 part count should be 8 or 16");
            for(i = 0; i < this.parts.length; i++){
                part = this.parts[i];
                if (!(0 <= part && part <= 0xffff)) throw new Error("ipaddr: ipv6 part should fit in 16 bits");
            }
            if (zoneId) this.zoneId = zoneId;
        }
        // Special IPv6 ranges
        IPv6.prototype.SpecialRanges = {
            // RFC4291, here and after
            unspecified: [
                new IPv6([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                128
            ],
            linkLocal: [
                new IPv6([
                    0xfe80,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                10
            ],
            multicast: [
                new IPv6([
                    0xff00,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                8
            ],
            loopback: [
                new IPv6([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ]),
                128
            ],
            uniqueLocal: [
                new IPv6([
                    0xfc00,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                7
            ],
            ipv4Mapped: [
                new IPv6([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0xffff,
                    0,
                    0
                ]),
                96
            ],
            // RFC3879
            deprecatedSiteLocal: [
                new IPv6([
                    0xfec0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                10
            ],
            // RFC6666
            discard: [
                new IPv6([
                    0x100,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                64
            ],
            // RFC6145
            rfc6145: [
                new IPv6([
                    0,
                    0,
                    0,
                    0,
                    0xffff,
                    0,
                    0,
                    0
                ]),
                96
            ],
            rfc6052: [
                // RFC6052
                [
                    new IPv6([
                        0x64,
                        0xff9b,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ]),
                    96
                ],
                // RFC8215
                [
                    new IPv6([
                        0x64,
                        0xff9b,
                        0x1,
                        0,
                        0,
                        0,
                        0,
                        0
                    ]),
                    48
                ]
            ],
            // RFC3056
            "6to4": [
                new IPv6([
                    0x2002,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                16
            ],
            // RFC6052, RFC6146
            teredo: [
                new IPv6([
                    0x2001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                32
            ],
            // RFC5180
            benchmarking: [
                new IPv6([
                    0x2001,
                    0x2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                48
            ],
            // RFC7450
            amt: [
                new IPv6([
                    0x2001,
                    0x3,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                32
            ],
            as112v6: [
                // RFC7535
                [
                    new IPv6([
                        0x2001,
                        0x4,
                        0x112,
                        0,
                        0,
                        0,
                        0,
                        0
                    ]),
                    48
                ],
                // RFC7534
                [
                    new IPv6([
                        0x2620,
                        0x4f,
                        0x8000,
                        0,
                        0,
                        0,
                        0,
                        0
                    ]),
                    48
                ]
            ],
            // RFC4843
            deprecatedOrchid: [
                new IPv6([
                    0x2001,
                    0x10,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                28
            ],
            // RFC7343
            orchid2: [
                new IPv6([
                    0x2001,
                    0x20,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                28
            ],
            // RFC9374
            droneRemoteIdProtocolEntityTags: [
                new IPv6([
                    0x2001,
                    0x30,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                28
            ],
            // RFC9602
            segmentRouting: [
                new IPv6([
                    0x5f00,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                16
            ],
            reserved: [
                // RFC3849
                [
                    new IPv6([
                        0x2001,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ]),
                    23
                ],
                // RFC2928
                [
                    new IPv6([
                        0x2001,
                        0xdb8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ]),
                    32
                ],
                // RFC9637
                [
                    new IPv6([
                        0x3fff,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ]),
                    20
                ]
            ]
        };
        // Checks if this address is an IPv4-mapped IPv6 address.
        IPv6.prototype.isIPv4MappedAddress = function() {
            return this.range() === "ipv4Mapped";
        };
        // The 'kind' method exists on both IPv4 and IPv6 classes.
        IPv6.prototype.kind = function() {
            return "ipv6";
        };
        // Checks if this address matches other one within given CIDR range.
        IPv6.prototype.match = function(other, cidrRange) {
            let ref;
            if (cidrRange === undefined) {
                ref = other;
                other = ref[0];
                cidrRange = ref[1];
            }
            if (other.kind() !== "ipv6") throw new Error("ipaddr: cannot match ipv6 address with non-ipv6 one");
            return matchCIDR(this.parts, other.parts, 16, cidrRange);
        };
        // returns a number of leading ones in IPv6 address, making sure that
        // the rest is a solid sequence of 0's (valid netmask)
        // returns either the CIDR length or null if mask is not valid
        IPv6.prototype.prefixLengthFromSubnetMask = function() {
            let cidr = 0;
            // non-zero encountered stop scanning for zeroes
            let stop = false;
            // number of zeroes in octet
            const zerotable = {
                0: 16,
                32768: 15,
                49152: 14,
                57344: 13,
                61440: 12,
                63488: 11,
                64512: 10,
                65024: 9,
                65280: 8,
                65408: 7,
                65472: 6,
                65504: 5,
                65520: 4,
                65528: 3,
                65532: 2,
                65534: 1,
                65535: 0
            };
            let part, zeros;
            for(let i = 7; i >= 0; i -= 1){
                part = this.parts[i];
                if (part in zerotable) {
                    zeros = zerotable[part];
                    if (stop && zeros !== 0) return null;
                    if (zeros !== 16) stop = true;
                    cidr += zeros;
                } else return null;
            }
            return 128 - cidr;
        };
        // Checks if the address corresponds to one of the special ranges.
        IPv6.prototype.range = function() {
            return ipaddr.subnetMatch(this, this.SpecialRanges);
        };
        // Returns an array of byte-sized values in network order (MSB first)
        IPv6.prototype.toByteArray = function() {
            let part;
            const bytes = [];
            const ref = this.parts;
            for(let i = 0; i < ref.length; i++){
                part = ref[i];
                bytes.push(part >> 8);
                bytes.push(part & 0xff);
            }
            return bytes;
        };
        // Returns the address in expanded format with all zeroes included, like
        // 2001:0db8:0008:0066:0000:0000:0000:0001
        IPv6.prototype.toFixedLengthString = function() {
            const addr = (function() {
                const results = [];
                for(let i = 0; i < this.parts.length; i++)results.push(padPart(this.parts[i].toString(16), 4));
                return results;
            }).call(this).join(":");
            let suffix = "";
            if (this.zoneId) suffix = `%${this.zoneId}`;
            return addr + suffix;
        };
        // Converts this address to IPv4 address if it is an IPv4-mapped IPv6 address.
        // Throws an error otherwise.
        IPv6.prototype.toIPv4Address = function() {
            if (!this.isIPv4MappedAddress()) throw new Error("ipaddr: trying to convert a generic ipv6 address to ipv4");
            const ref = this.parts.slice(-2);
            const high = ref[0];
            const low = ref[1];
            return new ipaddr.IPv4([
                high >> 8,
                high & 0xff,
                low >> 8,
                low & 0xff
            ]);
        };
        // Returns the address in expanded format with all zeroes included, like
        // 2001:db8:8:66:0:0:0:1
        //
        // Deprecated: use toFixedLengthString() instead.
        IPv6.prototype.toNormalizedString = function() {
            const addr = (function() {
                const results = [];
                for(let i = 0; i < this.parts.length; i++)results.push(this.parts[i].toString(16));
                return results;
            }).call(this).join(":");
            let suffix = "";
            if (this.zoneId) suffix = `%${this.zoneId}`;
            return addr + suffix;
        };
        // Returns the address in compact, human-readable format like
        // 2001:db8:8:66::1
        // in line with RFC 5952 (see https://tools.ietf.org/html/rfc5952#section-4)
        IPv6.prototype.toRFC5952String = function() {
            const regex = /((^|:)(0(:|$)){2,})/g;
            const string = this.toNormalizedString();
            let bestMatchIndex = 0;
            let bestMatchLength = -1;
            let match;
            while(match = regex.exec(string))if (match[0].length > bestMatchLength) {
                bestMatchIndex = match.index;
                bestMatchLength = match[0].length;
            }
            if (bestMatchLength < 0) return string;
            return `${string.substring(0, bestMatchIndex)}::${string.substring(bestMatchIndex + bestMatchLength)}`;
        };
        // Returns the address in compact, human-readable format like
        // 2001:db8:8:66::1
        // Calls toRFC5952String under the hood.
        IPv6.prototype.toString = function() {
            return this.toRFC5952String();
        };
        return IPv6;
    }();
    // A utility function to return broadcast address given the IPv6 interface and prefix length in CIDR notation
    ipaddr.IPv6.broadcastAddressFromCIDR = function(string) {
        try {
            const cidr = this.parseCIDR(string);
            const ipInterfaceOctets = cidr[0].toByteArray();
            const subnetMaskOctets = this.subnetMaskFromPrefixLength(cidr[1]).toByteArray();
            const octets = [];
            let i = 0;
            while(i < 16){
                // Broadcast address is bitwise OR between ip interface and inverted mask
                octets.push(parseInt(ipInterfaceOctets[i], 10) | parseInt(subnetMaskOctets[i], 10) ^ 255);
                i++;
            }
            return new this(octets);
        } catch (e) {
            throw new Error(`ipaddr: the address does not have IPv6 CIDR format (${e})`);
        }
    };
    // Checks if a given string is formatted like IPv6 address.
    ipaddr.IPv6.isIPv6 = function(string) {
        return this.parser(string) !== null;
    };
    // Checks to see if string is a valid IPv6 Address
    ipaddr.IPv6.isValid = function(string) {
        // Since IPv6.isValid is always called first, this shortcut
        // provides a substantial performance gain.
        if (typeof string === "string" && string.indexOf(":") === -1) return false;
        try {
            const addr = this.parser(string);
            new this(addr.parts, addr.zoneId);
            return true;
        } catch (e) {
            return false;
        }
    };
    // Checks if a given string is a valid IPv6 address in CIDR notation.
    ipaddr.IPv6.isValidCIDR = function(string) {
        // See note in IPv6.isValid
        if (typeof string === "string" && string.indexOf(":") === -1) return false;
        try {
            this.parseCIDR(string);
            return true;
        } catch (e) {
            return false;
        }
    };
    // A utility function to return network address given the IPv6 interface and prefix length in CIDR notation
    ipaddr.IPv6.networkAddressFromCIDR = function(string) {
        let cidr, i, ipInterfaceOctets, octets, subnetMaskOctets;
        try {
            cidr = this.parseCIDR(string);
            ipInterfaceOctets = cidr[0].toByteArray();
            subnetMaskOctets = this.subnetMaskFromPrefixLength(cidr[1]).toByteArray();
            octets = [];
            i = 0;
            while(i < 16){
                // Network address is bitwise AND between ip interface and mask
                octets.push(parseInt(ipInterfaceOctets[i], 10) & parseInt(subnetMaskOctets[i], 10));
                i++;
            }
            return new this(octets);
        } catch (e) {
            throw new Error(`ipaddr: the address does not have IPv6 CIDR format (${e})`);
        }
    };
    // Tries to parse and validate a string with IPv6 address.
    // Throws an error if it fails.
    ipaddr.IPv6.parse = function(string) {
        const addr = this.parser(string);
        if (addr.parts === null) throw new Error("ipaddr: string is not formatted like an IPv6 Address");
        return new this(addr.parts, addr.zoneId);
    };
    ipaddr.IPv6.parseCIDR = function(string) {
        let maskLength, match, parsed;
        if (match = string.match(/^(.+)\/(\d+)$/)) {
            maskLength = parseInt(match[2]);
            if (maskLength >= 0 && maskLength <= 128) {
                parsed = [
                    this.parse(match[1]),
                    maskLength
                ];
                Object.defineProperty(parsed, "toString", {
                    value: function() {
                        return this.join("/");
                    }
                });
                return parsed;
            }
        }
        throw new Error("ipaddr: string is not formatted like an IPv6 CIDR range");
    };
    // Parse an IPv6 address.
    ipaddr.IPv6.parser = function(string) {
        let addr, i, match, octet, octets, zoneId;
        if (match = string.match(ipv6Regexes.deprecatedTransitional)) return this.parser(`::ffff:${match[1]}`);
        if (ipv6Regexes.native.test(string)) return expandIPv6(string, 8);
        if (match = string.match(ipv6Regexes.transitional)) {
            zoneId = match[6] || "";
            addr = match[1];
            if (!match[1].endsWith("::")) addr = addr.slice(0, -1);
            addr = expandIPv6(addr + zoneId, 6);
            if (addr.parts) {
                octets = [
                    parseInt(match[2]),
                    parseInt(match[3]),
                    parseInt(match[4]),
                    parseInt(match[5])
                ];
                for(i = 0; i < octets.length; i++){
                    octet = octets[i];
                    if (!(0 <= octet && octet <= 255)) return null;
                }
                addr.parts.push(octets[0] << 8 | octets[1]);
                addr.parts.push(octets[2] << 8 | octets[3]);
                return {
                    parts: addr.parts,
                    zoneId: addr.zoneId
                };
            }
        }
        return null;
    };
    // A utility function to return subnet mask in IPv6 format given the prefix length
    ipaddr.IPv6.subnetMaskFromPrefixLength = function(prefix) {
        prefix = parseInt(prefix);
        if (prefix < 0 || prefix > 128) throw new Error("ipaddr: invalid IPv6 prefix length");
        const octets = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        let j = 0;
        const filledOctetCount = Math.floor(prefix / 8);
        while(j < filledOctetCount){
            octets[j] = 255;
            j++;
        }
        if (filledOctetCount < 16) octets[filledOctetCount] = Math.pow(2, prefix % 8) - 1 << 8 - prefix % 8;
        return new this(octets);
    };
    // Try to parse an array in network order (MSB first) for IPv4 and IPv6
    ipaddr.fromByteArray = function(bytes) {
        const length = bytes.length;
        if (length === 4) return new ipaddr.IPv4(bytes);
        else if (length === 16) return new ipaddr.IPv6(bytes);
        else throw new Error("ipaddr: the binary input is neither an IPv6 nor IPv4 address");
    };
    // Checks if the address is valid IP address
    ipaddr.isValid = function(string) {
        return ipaddr.IPv6.isValid(string) || ipaddr.IPv4.isValid(string);
    };
    // Checks if the address is valid IP address in CIDR notation
    ipaddr.isValidCIDR = function(string) {
        return ipaddr.IPv6.isValidCIDR(string) || ipaddr.IPv4.isValidCIDR(string);
    };
    // Attempts to parse an IP Address, first through IPv6 then IPv4.
    // Throws an error if it could not be parsed.
    ipaddr.parse = function(string) {
        if (ipaddr.IPv6.isValid(string)) return ipaddr.IPv6.parse(string);
        else if (ipaddr.IPv4.isValid(string)) return ipaddr.IPv4.parse(string);
        else throw new Error("ipaddr: the address has neither IPv6 nor IPv4 format");
    };
    // Attempt to parse CIDR notation, first through IPv6 then IPv4.
    // Throws an error if it could not be parsed.
    ipaddr.parseCIDR = function(string) {
        try {
            return ipaddr.IPv6.parseCIDR(string);
        } catch (e) {
            try {
                return ipaddr.IPv4.parseCIDR(string);
            } catch (e2) {
                throw new Error("ipaddr: the address has neither IPv6 nor IPv4 CIDR format");
            }
        }
    };
    // Parse an address and return plain IPv4 address if it is an IPv4-mapped address
    ipaddr.process = function(string) {
        const addr = this.parse(string);
        if (addr.kind() === "ipv6" && addr.isIPv4MappedAddress()) return addr.toIPv4Address();
        else return addr;
    };
    // An utility function to ease named range matching. See examples below.
    // rangeList can contain both IPv4 and IPv6 subnet entries and will not throw errors
    // on matching IPv4 addresses to IPv6 ranges or vice versa.
    ipaddr.subnetMatch = function(address, rangeList, defaultName) {
        let i, rangeName, rangeSubnets, subnet;
        if (defaultName === undefined || defaultName === null) defaultName = "unicast";
        for(rangeName in rangeList)if (Object.prototype.hasOwnProperty.call(rangeList, rangeName)) {
            rangeSubnets = rangeList[rangeName];
            // ECMA5 Array.isArray isn't available everywhere
            if (rangeSubnets[0] && !(rangeSubnets[0] instanceof Array)) rangeSubnets = [
                rangeSubnets
            ];
            for(i = 0; i < rangeSubnets.length; i++){
                subnet = rangeSubnets[i];
                if (address.kind() === subnet[0].kind() && address.match.apply(address, subnet)) return rangeName;
            }
        }
        return defaultName;
    };
    // Export for both the CommonJS and browser-like environment
    if (0, module.exports) module.exports = ipaddr;
    else root.ipaddr = ipaddr;
})(module.exports);

});





parcelRequire.register("90XFO", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $69026706a760f886$var$log = Object.assign($jjmHV("libp2p:transports"), {
    error: $jjmHV("libp2p:transports:err")
});

var $9Cq4d = parcelRequire("9Cq4d");

var $8yAh4 = parcelRequire("8yAh4");
var $69026706a760f886$require$codes = $8yAh4.codes;

var $20Lm5 = parcelRequire("20Lm5");

var $68Jl5 = parcelRequire("68Jl5");
var $69026706a760f886$require$updateSelfPeerRecord = $68Jl5.updateSelfPeerRecord;
/**
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('libp2p-interfaces/src/transport/types').TransportFactory<any, any>} TransportFactory
 * @typedef {import('libp2p-interfaces/src/transport/types').Transport<any, any>} Transport
 *
 * @typedef {Object} TransportManagerProperties
 * @property {import('./')} libp2p
 * @property {import('./upgrader')} upgrader
 *
 * @typedef {Object} TransportManagerOptions
 * @property {number} [faultTolerance = FAULT_TOLERANCE.FATAL_ALL] - Address listen error tolerance.
 */ class $69026706a760f886$var$TransportManager {
    /**
   * @class
   * @param {TransportManagerProperties & TransportManagerOptions} options
   */ constructor({ libp2p: libp2p, upgrader: upgrader, faultTolerance: faultTolerance = $69026706a760f886$var$FAULT_TOLERANCE.FATAL_ALL }){
        this.libp2p = libp2p;
        this.upgrader = upgrader;
        /** @type {Map<string, Transport>} */ this._transports = new Map();
        this._listeners = new Map();
        this._listenerOptions = new Map();
        this.faultTolerance = faultTolerance;
    }
    /**
   * Adds a `Transport` to the manager
   *
   * @param {string} key
   * @param {TransportFactory} Transport
   * @param {*} transportOptions - Additional options to pass to the transport
   * @returns {void}
   */ add(key, Transport, transportOptions = {}) {
        $69026706a760f886$var$log("adding %s", key);
        if (!key) throw $20Lm5(new Error(`Transport must have a valid key, was given '${key}'`), $69026706a760f886$require$codes.ERR_INVALID_KEY);
        if (this._transports.has(key)) throw $20Lm5(new Error("There is already a transport with this key"), $69026706a760f886$require$codes.ERR_DUPLICATE_TRANSPORT);
        const transport = new Transport({
            ...transportOptions,
            libp2p: this.libp2p,
            upgrader: this.upgrader
        });
        this._transports.set(key, transport);
        this._listenerOptions.set(key, transportOptions.listenerOptions || {});
        if (!this._listeners.has(key)) this._listeners.set(key, []);
    }
    /**
   * Stops all listeners
   *
   * @async
   */ async close() {
        const tasks = [];
        for (const [key, listeners] of this._listeners){
            $69026706a760f886$var$log("closing listeners for %s", key);
            while(listeners.length){
                const listener = listeners.pop();
                listener.removeAllListeners("listening");
                listener.removeAllListeners("close");
                tasks.push(listener.close());
            }
        }
        await Promise.all(tasks);
        $69026706a760f886$var$log("all listeners closed");
        for (const key of this._listeners.keys())this._listeners.set(key, []);
    }
    /**
   * Dials the given Multiaddr over it's supported transport
   *
   * @param {Multiaddr} ma
   * @param {*} options
   * @returns {Promise<Connection>}
   */ async dial(ma, options) {
        const transport = this.transportForMultiaddr(ma);
        if (!transport) throw $20Lm5(new Error(`No transport available for address ${String(ma)}`), $69026706a760f886$require$codes.ERR_TRANSPORT_UNAVAILABLE);
        try {
            return await transport.dial(ma, options);
        } catch (/** @type {any} */ err) {
            if (!err.code) err.code = $69026706a760f886$require$codes.ERR_TRANSPORT_DIAL_FAILED;
            throw err;
        }
    }
    /**
   * Returns all Multiaddr's the listeners are using
   *
   * @returns {Multiaddr[]}
   */ getAddrs() {
        /** @type {Multiaddr[]} */ let addrs = [];
        for (const listeners of this._listeners.values())for (const listener of listeners)addrs = [
            ...addrs,
            ...listener.getAddrs()
        ];
        return addrs;
    }
    /**
   * Returns all the transports instances.
   *
   * @returns {IterableIterator<Transport>}
   */ getTransports() {
        return this._transports.values();
    }
    /**
   * Finds a transport that matches the given Multiaddr
   *
   * @param {Multiaddr} ma
   * @returns {Transport|null}
   */ transportForMultiaddr(ma) {
        for (const transport of this._transports.values()){
            const addrs = transport.filter([
                ma
            ]);
            if (addrs.length) return transport;
        }
        return null;
    }
    /**
   * Starts listeners for each listen Multiaddr.
   *
   * @async
   * @param {Multiaddr[]} addrs - addresses to attempt to listen on
   */ async listen(addrs) {
        if (!addrs || addrs.length === 0) {
            $69026706a760f886$var$log("no addresses were provided for listening, this node is dial only");
            return;
        }
        const couldNotListen = [];
        for (const [key, transport] of this._transports.entries()){
            const supportedAddrs = transport.filter(addrs);
            const tasks = [];
            // For each supported multiaddr, create a listener
            for (const addr of supportedAddrs){
                $69026706a760f886$var$log("creating listener for %s on %s", key, addr);
                const listener = transport.createListener(this._listenerOptions.get(key));
                this._listeners.get(key).push(listener);
                // Track listen/close events
                listener.on("listening", ()=>$69026706a760f886$require$updateSelfPeerRecord(this.libp2p));
                listener.on("close", ()=>$69026706a760f886$require$updateSelfPeerRecord(this.libp2p));
                // We need to attempt to listen on everything
                tasks.push(listener.listen(addr));
            }
            // Keep track of transports we had no addresses for
            if (tasks.length === 0) {
                couldNotListen.push(key);
                continue;
            }
            const results = await $9Cq4d(tasks);
            // If we are listening on at least 1 address, succeed.
            // TODO: we should look at adding a retry (`p-retry`) here to better support
            // listening on remote addresses as they may be offline. We could then potentially
            // just wait for any (`p-any`) listener to succeed on each transport before returning
            const isListening = results.find((r)=>r.isFulfilled === true);
            if (!isListening && this.faultTolerance !== $69026706a760f886$var$FAULT_TOLERANCE.NO_FATAL) throw $20Lm5(new Error(`Transport (${key}) could not listen on any available address`), $69026706a760f886$require$codes.ERR_NO_VALID_ADDRESSES);
        }
        // If no transports were able to listen, throw an error. This likely
        // means we were given addresses we do not have transports for
        if (couldNotListen.length === this._transports.size) {
            const message = `no valid addresses were provided for transports [${couldNotListen}]`;
            if (this.faultTolerance === $69026706a760f886$var$FAULT_TOLERANCE.FATAL_ALL) throw $20Lm5(new Error(message), $69026706a760f886$require$codes.ERR_NO_VALID_ADDRESSES);
            $69026706a760f886$var$log(`libp2p in dial mode only: ${message}`);
        }
    }
    /**
   * Removes the given transport from the manager.
   * If a transport has any running listeners, they will be closed.
   *
   * @async
   * @param {string} key
   */ async remove(key) {
        $69026706a760f886$var$log("removing %s", key);
        if (this._listeners.has(key)) // Close any running listeners
        for (const listener of this._listeners.get(key)){
            listener.removeAllListeners("listening");
            listener.removeAllListeners("close");
            await listener.close();
        }
        this._transports.delete(key);
        this._listeners.delete(key);
    }
    /**
   * Removes all transports from the manager.
   * If any listeners are running, they will be closed.
   *
   * @async
   */ async removeAll() {
        const tasks = [];
        for (const key of this._transports.keys())tasks.push(this.remove(key));
        await Promise.all(tasks);
    }
}
/**
 * Enum Transport Manager Fault Tolerance values.
 * FATAL_ALL should be used for failing in any listen circumstance.
 * NO_FATAL should be used for not failing when not listening.
 *
 * @readonly
 * @enum {number}
 */ const $69026706a760f886$var$FAULT_TOLERANCE = {
    FATAL_ALL: 0,
    NO_FATAL: 1
};
$69026706a760f886$var$TransportManager.FaultTolerance = $69026706a760f886$var$FAULT_TOLERANCE;
module.exports = $69026706a760f886$var$TransportManager;

});
parcelRequire.register("9Cq4d", function(module, exports) {
"use strict";

var $gdtfK = parcelRequire("gdtfK");

var $iZs2G = parcelRequire("iZs2G");
module.exports = async (array, options = {})=>{
    const { concurrency: concurrency = Infinity } = options;
    const limit = $iZs2G(concurrency);
    return Promise.all(array.map((element)=>{
        if (element && typeof element.then === "function") return $gdtfK(element);
        if (typeof element === "function") return $gdtfK(limit(()=>element()));
        return $gdtfK(Promise.resolve(element));
    }));
};

});
parcelRequire.register("gdtfK", function(module, exports) {
"use strict";
const $bce48d46799e6f29$var$pReflect = async (promise)=>{
    try {
        const value = await promise;
        return {
            isFulfilled: true,
            isRejected: false,
            value: value
        };
    } catch (error) {
        return {
            isFulfilled: false,
            isRejected: true,
            reason: error
        };
    }
};
module.exports = $bce48d46799e6f29$var$pReflect;
// TODO: Remove this for the next major release
module.exports.default = $bce48d46799e6f29$var$pReflect;

});

parcelRequire.register("iZs2G", function(module, exports) {
"use strict";

var $hEbKw = parcelRequire("hEbKw");
const $dd33ad180147f526$var$pLimit = (concurrency)=>{
    if (!((Number.isInteger(concurrency) || concurrency === Infinity) && concurrency > 0)) return Promise.reject(new TypeError("Expected `concurrency` to be a number from 1 and up"));
    const queue = [];
    let activeCount = 0;
    const next = ()=>{
        activeCount--;
        if (queue.length > 0) queue.shift()();
    };
    const run = (fn, resolve, ...args)=>{
        activeCount++;
        const result = $hEbKw(fn, ...args);
        resolve(result);
        result.then(next, next);
    };
    const enqueue = (fn, resolve, ...args)=>{
        if (activeCount < concurrency) run(fn, resolve, ...args);
        else queue.push(run.bind(null, fn, resolve, ...args));
    };
    const generator = (fn, ...args)=>new Promise((resolve)=>enqueue(fn, resolve, ...args));
    Object.defineProperties(generator, {
        activeCount: {
            get: ()=>activeCount
        },
        pendingCount: {
            get: ()=>queue.length
        },
        clearQueue: {
            value: ()=>{
                queue.length = 0;
            }
        }
    });
    return generator;
};
module.exports = $dd33ad180147f526$var$pLimit;
module.exports.default = $dd33ad180147f526$var$pLimit;

});
parcelRequire.register("hEbKw", function(module, exports) {
"use strict";
const $cd8f4946f5c5d194$var$pTry = (fn, ...arguments_)=>new Promise((resolve)=>{
        resolve(fn(...arguments_));
    });
module.exports = $cd8f4946f5c5d194$var$pTry;
// TODO: remove this in the next major version
module.exports.default = $cd8f4946f5c5d194$var$pTry;

});



parcelRequire.register("68Jl5", function(module, exports) {

$parcel$export(module.exports, "updateSelfPeerRecord", () => $4786a8d6b0e74d01$export$6dc936cc43fc54b5, (v) => $4786a8d6b0e74d01$export$6dc936cc43fc54b5 = v);
var $4786a8d6b0e74d01$export$6dc936cc43fc54b5;
"use strict";

var $4kY1w = parcelRequire("4kY1w");

var $ewhIy = parcelRequire("ewhIy");
/**
 * @typedef {import('../')} Libp2p
 */ /**
 * Create (or update if existing) self peer record and store it in the AddressBook.
 *
 * @param {Libp2p} libp2p
 * @returns {Promise<void>}
 */ async function $4786a8d6b0e74d01$var$updateSelfPeerRecord(libp2p) {
    const peerRecord = new $ewhIy({
        peerId: libp2p.peerId,
        multiaddrs: libp2p.multiaddrs
    });
    const envelope = await $4kY1w.seal(peerRecord, libp2p.peerId);
    libp2p.peerStore.addressBook.consumePeerRecord(envelope);
}
$4786a8d6b0e74d01$export$6dc936cc43fc54b5 = $4786a8d6b0e74d01$var$updateSelfPeerRecord;

});
parcelRequire.register("4kY1w", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $8hEBV = parcelRequire("8hEBV");
var $32879721222859f5$require$uint8arraysConcat = $8hEBV.concat;

var $8cWjP = parcelRequire("8cWjP");
var $32879721222859f5$require$uint8arraysFromString = $8cWjP.fromString;

var $iCaRA = parcelRequire("iCaRA");

var $ksmXv = parcelRequire("ksmXv");

var $b7PIr = parcelRequire("b7PIr");

var $ijWXY = parcelRequire("ijWXY");
var $32879721222859f5$require$uint8arraysEquals = $ijWXY.equals;

var $8yAh4 = parcelRequire("8yAh4");
var $32879721222859f5$require$codes = $8yAh4.codes;

var $c8Foz = parcelRequire("c8Foz");
var $32879721222859f5$require$Protobuf = $c8Foz.Envelope;
/**
 * @typedef {import('libp2p-interfaces/src/record/types').Record} Record
 */ class $32879721222859f5$var$Envelope {
    /**
   * The Envelope is responsible for keeping an arbitrary signed record
   * by a libp2p peer.
   *
   * @class
   * @param {object} params
   * @param {PeerId} params.peerId
   * @param {Uint8Array} params.payloadType
   * @param {Uint8Array} params.payload - marshaled record
   * @param {Uint8Array} params.signature - signature of the domain string :: type hint :: payload.
   */ constructor({ peerId: peerId, payloadType: payloadType, payload: payload, signature: signature }){
        this.peerId = peerId;
        this.payloadType = payloadType;
        this.payload = payload;
        this.signature = signature;
        // Cache
        this._marshal = undefined;
    }
    /**
   * Marshal the envelope content.
   *
   * @returns {Uint8Array}
   */ marshal() {
        if (this._marshal) return this._marshal;
        const publicKey = $iCaRA.marshalPublicKey(this.peerId.pubKey);
        this._marshal = $32879721222859f5$require$Protobuf.encode({
            publicKey: publicKey,
            payloadType: this.payloadType,
            payload: this.payload,
            signature: this.signature
        }).finish();
        return this._marshal;
    }
    /**
   * Verifies if the other Envelope is identical to this one.
   *
   * @param {Envelope} other
   * @returns {boolean}
   */ equals(other) {
        return $32879721222859f5$require$uint8arraysEquals(this.peerId.pubKey.bytes, other.peerId.pubKey.bytes) && $32879721222859f5$require$uint8arraysEquals(this.payloadType, other.payloadType) && $32879721222859f5$require$uint8arraysEquals(this.payload, other.payload) && $32879721222859f5$require$uint8arraysEquals(this.signature, other.signature);
    }
    /**
   * Validate envelope data signature for the given domain.
   *
   * @param {string} domain
   * @returns {Promise<boolean>}
   */ validate(domain) {
        const signData = $32879721222859f5$var$formatSignaturePayload(domain, this.payloadType, this.payload);
        return this.peerId.pubKey.verify(signData, this.signature);
    }
}
/**
 * Helper function that prepares a Uint8Array to sign or verify a signature.
 *
 * @param {string} domain
 * @param {Uint8Array} payloadType
 * @param {Uint8Array} payload
 * @returns {Uint8Array}
 */ const $32879721222859f5$var$formatSignaturePayload = (domain, payloadType, payload)=>{
    // When signing, a peer will prepare a Uint8Array by concatenating the following:
    // - The length of the domain separation string string in bytes
    // - The domain separation string, encoded as UTF-8
    // - The length of the payload_type field in bytes
    // - The value of the payload_type field
    // - The length of the payload field in bytes
    // - The value of the payload field
    const domainUint8Array = $32879721222859f5$require$uint8arraysFromString(domain);
    const domainLength = $b7PIr.encode(domainUint8Array.byteLength);
    const payloadTypeLength = $b7PIr.encode(payloadType.length);
    const payloadLength = $b7PIr.encode(payload.length);
    return $32879721222859f5$require$uint8arraysConcat([
        new Uint8Array(domainLength),
        domainUint8Array,
        new Uint8Array(payloadTypeLength),
        payloadType,
        new Uint8Array(payloadLength),
        payload
    ]);
};
/**
 * Unmarshal a serialized Envelope protobuf message.
 *
 * @param {Uint8Array} data
 * @returns {Promise<Envelope>}
 */ $32879721222859f5$var$Envelope.createFromProtobuf = async (data)=>{
    const envelopeData = $32879721222859f5$require$Protobuf.decode(data);
    const peerId = await $ksmXv.createFromPubKey(envelopeData.publicKey);
    return new $32879721222859f5$var$Envelope({
        peerId: peerId,
        payloadType: envelopeData.payloadType,
        payload: envelopeData.payload,
        signature: envelopeData.signature
    });
};
/**
 * Seal marshals the given Record, places the marshaled bytes inside an Envelope
 * and signs it with the given peerId's private key.
 *
 * @async
 * @param {Record} record
 * @param {PeerId} peerId
 * @returns {Promise<Envelope>}
 */ $32879721222859f5$var$Envelope.seal = async (record, peerId)=>{
    const domain = record.domain;
    const payloadType = record.codec;
    const payload = record.marshal();
    const signData = $32879721222859f5$var$formatSignaturePayload(domain, payloadType, payload);
    const signature = await peerId.privKey.sign(signData);
    return new $32879721222859f5$var$Envelope({
        peerId: peerId,
        payloadType: payloadType,
        payload: payload,
        signature: signature
    });
};
/**
 * Open and certify a given marshalled envelope.
 * Data is unmarshalled and the signature validated for the given domain.
 *
 * @param {Uint8Array} data
 * @param {string} domain
 * @returns {Promise<Envelope>}
 */ $32879721222859f5$var$Envelope.openAndCertify = async (data, domain)=>{
    const envelope = await $32879721222859f5$var$Envelope.createFromProtobuf(data);
    const valid = await envelope.validate(domain);
    if (!valid) throw $20Lm5(new Error("envelope signature is not valid for the given domain"), $32879721222859f5$require$codes.ERR_SIGNATURE_NOT_VALID);
    return envelope;
};
module.exports = $32879721222859f5$var$Envelope;

});
parcelRequire.register("c8Foz", function(module, exports) {
/*eslint-disable*/ "use strict";

var $liRmU = parcelRequire("liRmU");
// Common aliases
var $8d6657a200280a7d$var$$Reader = $liRmU.Reader, $8d6657a200280a7d$var$$Writer = $liRmU.Writer, $8d6657a200280a7d$var$$util = $liRmU.util;
// Exported root namespace
var $8d6657a200280a7d$var$$root = $liRmU.roots["libp2p-envelope"] || ($liRmU.roots["libp2p-envelope"] = {});
$8d6657a200280a7d$var$$root.Envelope = function() {
    /**
     * Properties of an Envelope.
     * @exports IEnvelope
     * @interface IEnvelope
     * @property {Uint8Array|null} [publicKey] Envelope publicKey
     * @property {Uint8Array|null} [payloadType] Envelope payloadType
     * @property {Uint8Array|null} [payload] Envelope payload
     * @property {Uint8Array|null} [signature] Envelope signature
     */ /**
     * Constructs a new Envelope.
     * @exports Envelope
     * @classdesc Represents an Envelope.
     * @implements IEnvelope
     * @constructor
     * @param {IEnvelope=} [p] Properties to set
     */ function Envelope(p) {
        if (p) {
            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }
    }
    /**
     * Envelope publicKey.
     * @member {Uint8Array} publicKey
     * @memberof Envelope
     * @instance
     */ Envelope.prototype.publicKey = $8d6657a200280a7d$var$$util.newBuffer([]);
    /**
     * Envelope payloadType.
     * @member {Uint8Array} payloadType
     * @memberof Envelope
     * @instance
     */ Envelope.prototype.payloadType = $8d6657a200280a7d$var$$util.newBuffer([]);
    /**
     * Envelope payload.
     * @member {Uint8Array} payload
     * @memberof Envelope
     * @instance
     */ Envelope.prototype.payload = $8d6657a200280a7d$var$$util.newBuffer([]);
    /**
     * Envelope signature.
     * @member {Uint8Array} signature
     * @memberof Envelope
     * @instance
     */ Envelope.prototype.signature = $8d6657a200280a7d$var$$util.newBuffer([]);
    /**
     * Encodes the specified Envelope message. Does not implicitly {@link Envelope.verify|verify} messages.
     * @function encode
     * @memberof Envelope
     * @static
     * @param {IEnvelope} m Envelope message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ Envelope.encode = function encode(m, w) {
        if (!w) w = $8d6657a200280a7d$var$$Writer.create();
        if (m.publicKey != null && Object.hasOwnProperty.call(m, "publicKey")) w.uint32(10).bytes(m.publicKey);
        if (m.payloadType != null && Object.hasOwnProperty.call(m, "payloadType")) w.uint32(18).bytes(m.payloadType);
        if (m.payload != null && Object.hasOwnProperty.call(m, "payload")) w.uint32(26).bytes(m.payload);
        if (m.signature != null && Object.hasOwnProperty.call(m, "signature")) w.uint32(42).bytes(m.signature);
        return w;
    };
    /**
     * Decodes an Envelope message from the specified reader or buffer.
     * @function decode
     * @memberof Envelope
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {Envelope} Envelope
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ Envelope.decode = function decode(r, l) {
        if (!(r instanceof $8d6657a200280a7d$var$$Reader)) r = $8d6657a200280a7d$var$$Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l, m = new $8d6657a200280a7d$var$$root.Envelope();
        while(r.pos < c){
            var t = r.uint32();
            switch(t >>> 3){
                case 1:
                    m.publicKey = r.bytes();
                    break;
                case 2:
                    m.payloadType = r.bytes();
                    break;
                case 3:
                    m.payload = r.bytes();
                    break;
                case 5:
                    m.signature = r.bytes();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
            }
        }
        return m;
    };
    /**
     * Creates an Envelope message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Envelope
     * @static
     * @param {Object.<string,*>} d Plain object
     * @returns {Envelope} Envelope
     */ Envelope.fromObject = function fromObject(d) {
        if (d instanceof $8d6657a200280a7d$var$$root.Envelope) return d;
        var m = new $8d6657a200280a7d$var$$root.Envelope();
        if (d.publicKey != null) {
            if (typeof d.publicKey === "string") $8d6657a200280a7d$var$$util.base64.decode(d.publicKey, m.publicKey = $8d6657a200280a7d$var$$util.newBuffer($8d6657a200280a7d$var$$util.base64.length(d.publicKey)), 0);
            else if (d.publicKey.length) m.publicKey = d.publicKey;
        }
        if (d.payloadType != null) {
            if (typeof d.payloadType === "string") $8d6657a200280a7d$var$$util.base64.decode(d.payloadType, m.payloadType = $8d6657a200280a7d$var$$util.newBuffer($8d6657a200280a7d$var$$util.base64.length(d.payloadType)), 0);
            else if (d.payloadType.length) m.payloadType = d.payloadType;
        }
        if (d.payload != null) {
            if (typeof d.payload === "string") $8d6657a200280a7d$var$$util.base64.decode(d.payload, m.payload = $8d6657a200280a7d$var$$util.newBuffer($8d6657a200280a7d$var$$util.base64.length(d.payload)), 0);
            else if (d.payload.length) m.payload = d.payload;
        }
        if (d.signature != null) {
            if (typeof d.signature === "string") $8d6657a200280a7d$var$$util.base64.decode(d.signature, m.signature = $8d6657a200280a7d$var$$util.newBuffer($8d6657a200280a7d$var$$util.base64.length(d.signature)), 0);
            else if (d.signature.length) m.signature = d.signature;
        }
        return m;
    };
    /**
     * Creates a plain object from an Envelope message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Envelope
     * @static
     * @param {Envelope} m Envelope
     * @param {$protobuf.IConversionOptions} [o] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ Envelope.toObject = function toObject(m, o) {
        if (!o) o = {};
        var d = {};
        if (o.defaults) {
            if (o.bytes === String) d.publicKey = "";
            else {
                d.publicKey = [];
                if (o.bytes !== Array) d.publicKey = $8d6657a200280a7d$var$$util.newBuffer(d.publicKey);
            }
            if (o.bytes === String) d.payloadType = "";
            else {
                d.payloadType = [];
                if (o.bytes !== Array) d.payloadType = $8d6657a200280a7d$var$$util.newBuffer(d.payloadType);
            }
            if (o.bytes === String) d.payload = "";
            else {
                d.payload = [];
                if (o.bytes !== Array) d.payload = $8d6657a200280a7d$var$$util.newBuffer(d.payload);
            }
            if (o.bytes === String) d.signature = "";
            else {
                d.signature = [];
                if (o.bytes !== Array) d.signature = $8d6657a200280a7d$var$$util.newBuffer(d.signature);
            }
        }
        if (m.publicKey != null && m.hasOwnProperty("publicKey")) d.publicKey = o.bytes === String ? $8d6657a200280a7d$var$$util.base64.encode(m.publicKey, 0, m.publicKey.length) : o.bytes === Array ? Array.prototype.slice.call(m.publicKey) : m.publicKey;
        if (m.payloadType != null && m.hasOwnProperty("payloadType")) d.payloadType = o.bytes === String ? $8d6657a200280a7d$var$$util.base64.encode(m.payloadType, 0, m.payloadType.length) : o.bytes === Array ? Array.prototype.slice.call(m.payloadType) : m.payloadType;
        if (m.payload != null && m.hasOwnProperty("payload")) d.payload = o.bytes === String ? $8d6657a200280a7d$var$$util.base64.encode(m.payload, 0, m.payload.length) : o.bytes === Array ? Array.prototype.slice.call(m.payload) : m.payload;
        if (m.signature != null && m.hasOwnProperty("signature")) d.signature = o.bytes === String ? $8d6657a200280a7d$var$$util.base64.encode(m.signature, 0, m.signature.length) : o.bytes === Array ? Array.prototype.slice.call(m.signature) : m.signature;
        return d;
    };
    /**
     * Converts this Envelope to JSON.
     * @function toJSON
     * @memberof Envelope
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ Envelope.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
    };
    return Envelope;
}();
module.exports = $8d6657a200280a7d$var$$root;

});


parcelRequire.register("ewhIy", function(module, exports) {
"use strict";

var $aZLwC = parcelRequire("aZLwC");
var $a921cc305472e4b8$require$Multiaddr = $aZLwC.Multiaddr;

var $ksmXv = parcelRequire("ksmXv");

var $4ojZP = parcelRequire("4ojZP");

var $ehhYT = parcelRequire("ehhYT");
var $a921cc305472e4b8$require$Protobuf = $ehhYT.PeerRecord;

var $jd9M1 = parcelRequire("jd9M1");
var $a921cc305472e4b8$require$ENVELOPE_DOMAIN_PEER_RECORD = $jd9M1.ENVELOPE_DOMAIN_PEER_RECORD;
var $a921cc305472e4b8$require$ENVELOPE_PAYLOAD_TYPE_PEER_RECORD = $jd9M1.ENVELOPE_PAYLOAD_TYPE_PEER_RECORD;
/**
 * @typedef {import('../../peer-store/address-book.js').Address} Address
 * @typedef {import('libp2p-interfaces/src/record/types').Record} Record
 */ /**
 * @implements {Record}
 */ class $a921cc305472e4b8$var$PeerRecord {
    /**
   * The PeerRecord is used for distributing peer routing records across the network.
   * It contains the peer's reachable listen addresses.
   *
   * @class
   * @param {Object} params
   * @param {PeerId} params.peerId
   * @param {Multiaddr[]} params.multiaddrs - addresses of the associated peer.
   * @param {number} [params.seqNumber] - monotonically-increasing sequence counter that's used to order PeerRecords in time.
   */ constructor({ peerId: peerId, multiaddrs: multiaddrs = [], seqNumber: seqNumber = Date.now() }){
        this.domain = $a921cc305472e4b8$require$ENVELOPE_DOMAIN_PEER_RECORD;
        this.codec = $a921cc305472e4b8$require$ENVELOPE_PAYLOAD_TYPE_PEER_RECORD;
        this.peerId = peerId;
        this.multiaddrs = multiaddrs;
        this.seqNumber = seqNumber;
        // Cache
        this._marshal = undefined;
    }
    /**
   * Marshal a record to be used in an envelope.
   *
   * @returns {Uint8Array}
   */ marshal() {
        if (this._marshal) return this._marshal;
        this._marshal = $a921cc305472e4b8$require$Protobuf.encode({
            peerId: this.peerId.toBytes(),
            seq: this.seqNumber,
            addresses: this.multiaddrs.map((m)=>({
                    multiaddr: m.bytes
                }))
        }).finish();
        return this._marshal;
    }
    /**
   * Returns true if `this` record equals the `other`.
   *
   * @param {unknown} other
   * @returns {boolean}
   */ equals(other) {
        if (!(other instanceof $a921cc305472e4b8$var$PeerRecord)) return false;
        // Validate PeerId
        if (!this.peerId.equals(other.peerId)) return false;
        // Validate seqNumber
        if (this.seqNumber !== other.seqNumber) return false;
        // Validate multiaddrs
        if (!$4ojZP(this.multiaddrs, other.multiaddrs)) return false;
        return true;
    }
}
/**
 * Unmarshal Peer Record Protobuf.
 *
 * @param {Uint8Array} buf - marshaled peer record.
 * @returns {PeerRecord}
 */ $a921cc305472e4b8$var$PeerRecord.createFromProtobuf = (buf)=>{
    const peerRecord = $a921cc305472e4b8$require$Protobuf.decode(buf);
    const peerId = $ksmXv.createFromBytes(peerRecord.peerId);
    const multiaddrs = (peerRecord.addresses || []).map((a)=>new $a921cc305472e4b8$require$Multiaddr(a.multiaddr));
    const seqNumber = Number(peerRecord.seq);
    return new $a921cc305472e4b8$var$PeerRecord({
        peerId: peerId,
        multiaddrs: multiaddrs,
        seqNumber: seqNumber
    });
};
$a921cc305472e4b8$var$PeerRecord.DOMAIN = $a921cc305472e4b8$require$ENVELOPE_DOMAIN_PEER_RECORD;
module.exports = $a921cc305472e4b8$var$PeerRecord;

});
parcelRequire.register("4ojZP", function(module, exports) {
"use strict";
/**
 * Verify if two arrays of non primitive types with the "equals" function are equal.
 * Compatible with multiaddr, peer-id and others.
 *
 * @param {Array<*>} a
 * @param {Array<*>} b
 * @returns {boolean}
 */ function $3328ea27d998ef72$var$arrayEquals(a, b) {
    return a.length === b.length && b.sort() && a.sort().every((item, index)=>b[index].equals(item));
}
module.exports = $3328ea27d998ef72$var$arrayEquals;

});

parcelRequire.register("ehhYT", function(module, exports) {
/*eslint-disable*/ "use strict";

var $liRmU = parcelRequire("liRmU");
// Common aliases
var $a65099e23658adbb$var$$Reader = $liRmU.Reader, $a65099e23658adbb$var$$Writer = $liRmU.Writer, $a65099e23658adbb$var$$util = $liRmU.util;
// Exported root namespace
var $a65099e23658adbb$var$$root = $liRmU.roots["libp2p-peer-record"] || ($liRmU.roots["libp2p-peer-record"] = {});
$a65099e23658adbb$var$$root.PeerRecord = function() {
    /**
     * Properties of a PeerRecord.
     * @exports IPeerRecord
     * @interface IPeerRecord
     * @property {Uint8Array|null} [peerId] PeerRecord peerId
     * @property {number|null} [seq] PeerRecord seq
     * @property {Array.<PeerRecord.IAddressInfo>|null} [addresses] PeerRecord addresses
     */ /**
     * Constructs a new PeerRecord.
     * @exports PeerRecord
     * @classdesc Represents a PeerRecord.
     * @implements IPeerRecord
     * @constructor
     * @param {IPeerRecord=} [p] Properties to set
     */ function PeerRecord(p) {
        this.addresses = [];
        if (p) {
            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }
    }
    /**
     * PeerRecord peerId.
     * @member {Uint8Array} peerId
     * @memberof PeerRecord
     * @instance
     */ PeerRecord.prototype.peerId = $a65099e23658adbb$var$$util.newBuffer([]);
    /**
     * PeerRecord seq.
     * @member {number} seq
     * @memberof PeerRecord
     * @instance
     */ PeerRecord.prototype.seq = $a65099e23658adbb$var$$util.Long ? $a65099e23658adbb$var$$util.Long.fromBits(0, 0, true) : 0;
    /**
     * PeerRecord addresses.
     * @member {Array.<PeerRecord.IAddressInfo>} addresses
     * @memberof PeerRecord
     * @instance
     */ PeerRecord.prototype.addresses = $a65099e23658adbb$var$$util.emptyArray;
    /**
     * Encodes the specified PeerRecord message. Does not implicitly {@link PeerRecord.verify|verify} messages.
     * @function encode
     * @memberof PeerRecord
     * @static
     * @param {IPeerRecord} m PeerRecord message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ PeerRecord.encode = function encode(m, w) {
        if (!w) w = $a65099e23658adbb$var$$Writer.create();
        if (m.peerId != null && Object.hasOwnProperty.call(m, "peerId")) w.uint32(10).bytes(m.peerId);
        if (m.seq != null && Object.hasOwnProperty.call(m, "seq")) w.uint32(16).uint64(m.seq);
        if (m.addresses != null && m.addresses.length) for(var i = 0; i < m.addresses.length; ++i)$a65099e23658adbb$var$$root.PeerRecord.AddressInfo.encode(m.addresses[i], w.uint32(26).fork()).ldelim();
        return w;
    };
    /**
     * Decodes a PeerRecord message from the specified reader or buffer.
     * @function decode
     * @memberof PeerRecord
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {PeerRecord} PeerRecord
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ PeerRecord.decode = function decode(r, l) {
        if (!(r instanceof $a65099e23658adbb$var$$Reader)) r = $a65099e23658adbb$var$$Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l, m = new $a65099e23658adbb$var$$root.PeerRecord();
        while(r.pos < c){
            var t = r.uint32();
            switch(t >>> 3){
                case 1:
                    m.peerId = r.bytes();
                    break;
                case 2:
                    m.seq = r.uint64();
                    break;
                case 3:
                    if (!(m.addresses && m.addresses.length)) m.addresses = [];
                    m.addresses.push($a65099e23658adbb$var$$root.PeerRecord.AddressInfo.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
            }
        }
        return m;
    };
    /**
     * Creates a PeerRecord message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PeerRecord
     * @static
     * @param {Object.<string,*>} d Plain object
     * @returns {PeerRecord} PeerRecord
     */ PeerRecord.fromObject = function fromObject(d) {
        if (d instanceof $a65099e23658adbb$var$$root.PeerRecord) return d;
        var m = new $a65099e23658adbb$var$$root.PeerRecord();
        if (d.peerId != null) {
            if (typeof d.peerId === "string") $a65099e23658adbb$var$$util.base64.decode(d.peerId, m.peerId = $a65099e23658adbb$var$$util.newBuffer($a65099e23658adbb$var$$util.base64.length(d.peerId)), 0);
            else if (d.peerId.length) m.peerId = d.peerId;
        }
        if (d.seq != null) {
            if ($a65099e23658adbb$var$$util.Long) (m.seq = $a65099e23658adbb$var$$util.Long.fromValue(d.seq)).unsigned = true;
            else if (typeof d.seq === "string") m.seq = parseInt(d.seq, 10);
            else if (typeof d.seq === "number") m.seq = d.seq;
            else if (typeof d.seq === "object") m.seq = new $a65099e23658adbb$var$$util.LongBits(d.seq.low >>> 0, d.seq.high >>> 0).toNumber(true);
        }
        if (d.addresses) {
            if (!Array.isArray(d.addresses)) throw TypeError(".PeerRecord.addresses: array expected");
            m.addresses = [];
            for(var i = 0; i < d.addresses.length; ++i){
                if (typeof d.addresses[i] !== "object") throw TypeError(".PeerRecord.addresses: object expected");
                m.addresses[i] = $a65099e23658adbb$var$$root.PeerRecord.AddressInfo.fromObject(d.addresses[i]);
            }
        }
        return m;
    };
    /**
     * Creates a plain object from a PeerRecord message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PeerRecord
     * @static
     * @param {PeerRecord} m PeerRecord
     * @param {$protobuf.IConversionOptions} [o] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ PeerRecord.toObject = function toObject(m, o) {
        if (!o) o = {};
        var d = {};
        if (o.arrays || o.defaults) d.addresses = [];
        if (o.defaults) {
            if (o.bytes === String) d.peerId = "";
            else {
                d.peerId = [];
                if (o.bytes !== Array) d.peerId = $a65099e23658adbb$var$$util.newBuffer(d.peerId);
            }
            if ($a65099e23658adbb$var$$util.Long) {
                var n = new $a65099e23658adbb$var$$util.Long(0, 0, true);
                d.seq = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
            } else d.seq = o.longs === String ? "0" : 0;
        }
        if (m.peerId != null && m.hasOwnProperty("peerId")) d.peerId = o.bytes === String ? $a65099e23658adbb$var$$util.base64.encode(m.peerId, 0, m.peerId.length) : o.bytes === Array ? Array.prototype.slice.call(m.peerId) : m.peerId;
        if (m.seq != null && m.hasOwnProperty("seq")) {
            if (typeof m.seq === "number") d.seq = o.longs === String ? String(m.seq) : m.seq;
            else d.seq = o.longs === String ? $a65099e23658adbb$var$$util.Long.prototype.toString.call(m.seq) : o.longs === Number ? new $a65099e23658adbb$var$$util.LongBits(m.seq.low >>> 0, m.seq.high >>> 0).toNumber(true) : m.seq;
        }
        if (m.addresses && m.addresses.length) {
            d.addresses = [];
            for(var j = 0; j < m.addresses.length; ++j)d.addresses[j] = $a65099e23658adbb$var$$root.PeerRecord.AddressInfo.toObject(m.addresses[j], o);
        }
        return d;
    };
    /**
     * Converts this PeerRecord to JSON.
     * @function toJSON
     * @memberof PeerRecord
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ PeerRecord.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
    };
    PeerRecord.AddressInfo = function() {
        /**
         * Properties of an AddressInfo.
         * @memberof PeerRecord
         * @interface IAddressInfo
         * @property {Uint8Array|null} [multiaddr] AddressInfo multiaddr
         */ /**
         * Constructs a new AddressInfo.
         * @memberof PeerRecord
         * @classdesc Represents an AddressInfo.
         * @implements IAddressInfo
         * @constructor
         * @param {PeerRecord.IAddressInfo=} [p] Properties to set
         */ function AddressInfo(p) {
            if (p) {
                for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
            }
        }
        /**
         * AddressInfo multiaddr.
         * @member {Uint8Array} multiaddr
         * @memberof PeerRecord.AddressInfo
         * @instance
         */ AddressInfo.prototype.multiaddr = $a65099e23658adbb$var$$util.newBuffer([]);
        /**
         * Encodes the specified AddressInfo message. Does not implicitly {@link PeerRecord.AddressInfo.verify|verify} messages.
         * @function encode
         * @memberof PeerRecord.AddressInfo
         * @static
         * @param {PeerRecord.IAddressInfo} m AddressInfo message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ AddressInfo.encode = function encode(m, w) {
            if (!w) w = $a65099e23658adbb$var$$Writer.create();
            if (m.multiaddr != null && Object.hasOwnProperty.call(m, "multiaddr")) w.uint32(10).bytes(m.multiaddr);
            return w;
        };
        /**
         * Decodes an AddressInfo message from the specified reader or buffer.
         * @function decode
         * @memberof PeerRecord.AddressInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {PeerRecord.AddressInfo} AddressInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ AddressInfo.decode = function decode(r, l) {
            if (!(r instanceof $a65099e23658adbb$var$$Reader)) r = $a65099e23658adbb$var$$Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $a65099e23658adbb$var$$root.PeerRecord.AddressInfo();
            while(r.pos < c){
                var t = r.uint32();
                switch(t >>> 3){
                    case 1:
                        m.multiaddr = r.bytes();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };
        /**
         * Creates an AddressInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof PeerRecord.AddressInfo
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {PeerRecord.AddressInfo} AddressInfo
         */ AddressInfo.fromObject = function fromObject(d) {
            if (d instanceof $a65099e23658adbb$var$$root.PeerRecord.AddressInfo) return d;
            var m = new $a65099e23658adbb$var$$root.PeerRecord.AddressInfo();
            if (d.multiaddr != null) {
                if (typeof d.multiaddr === "string") $a65099e23658adbb$var$$util.base64.decode(d.multiaddr, m.multiaddr = $a65099e23658adbb$var$$util.newBuffer($a65099e23658adbb$var$$util.base64.length(d.multiaddr)), 0);
                else if (d.multiaddr.length) m.multiaddr = d.multiaddr;
            }
            return m;
        };
        /**
         * Creates a plain object from an AddressInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof PeerRecord.AddressInfo
         * @static
         * @param {PeerRecord.AddressInfo} m AddressInfo
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ AddressInfo.toObject = function toObject(m, o) {
            if (!o) o = {};
            var d = {};
            if (o.defaults) {
                if (o.bytes === String) d.multiaddr = "";
                else {
                    d.multiaddr = [];
                    if (o.bytes !== Array) d.multiaddr = $a65099e23658adbb$var$$util.newBuffer(d.multiaddr);
                }
            }
            if (m.multiaddr != null && m.hasOwnProperty("multiaddr")) d.multiaddr = o.bytes === String ? $a65099e23658adbb$var$$util.base64.encode(m.multiaddr, 0, m.multiaddr.length) : o.bytes === Array ? Array.prototype.slice.call(m.multiaddr) : m.multiaddr;
            return d;
        };
        /**
         * Converts this AddressInfo to JSON.
         * @function toJSON
         * @memberof PeerRecord.AddressInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ AddressInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
        };
        return AddressInfo;
    }();
    return PeerRecord;
}();
module.exports = $a65099e23658adbb$var$$root;

});

parcelRequire.register("jd9M1", function(module, exports) {
"use strict";
// The domain string used for peer records contained in a Envelope.
const $dfc6d00954b3b605$var$domain = "libp2p-peer-record";
// The type hint used to identify peer records in a Envelope.
// Defined in https://github.com/multiformats/multicodec/blob/master/table.csv
// with name "libp2p-peer-record"
const $dfc6d00954b3b605$var$payloadType = Uint8Array.from([
    3,
    1
]);
module.exports = {
    ENVELOPE_DOMAIN_PEER_RECORD: $dfc6d00954b3b605$var$domain,
    ENVELOPE_PAYLOAD_TYPE_PEER_RECORD: $dfc6d00954b3b605$var$payloadType
};

});





parcelRequire.register("g1JQx", function(module, exports) {
"use strict";

var $7QXK1 = parcelRequire("7QXK1");
var $bab04d77d898eb97$require$EventEmitter = $7QXK1.EventEmitter;

var $aZLwC = parcelRequire("aZLwC");
var $bab04d77d898eb97$require$Multiaddr = $aZLwC.Multiaddr;

var $ksmXv = parcelRequire("ksmXv");
/**
 * @typedef {Object} AddressManagerOptions
 * @property {string[]} [listen = []] - list of multiaddrs string representation to listen.
 * @property {string[]} [announce = []] - list of multiaddrs string representation to announce.
 */ /**
 * @fires AddressManager#change:addresses Emitted when a addresses change.
 */ class $bab04d77d898eb97$var$AddressManager extends $bab04d77d898eb97$require$EventEmitter {
    /**
   * Responsible for managing the peer addresses.
   * Peers can specify their listen and announce addresses.
   * The listen addresses will be used by the libp2p transports to listen for new connections,
   * while the announce addresses will be used for the peer addresses' to other peers in the network.
   *
   * @class
   * @param {PeerId} peerId - The Peer ID of the node
   * @param {object} [options]
   * @param {Array<string>} [options.listen = []] - list of multiaddrs string representation to listen.
   * @param {Array<string>} [options.announce = []] - list of multiaddrs string representation to announce.
   */ constructor(peerId, { listen: listen = [], announce: announce = [] } = {}){
        super();
        this.peerId = peerId;
        this.listen = new Set(listen.map((ma)=>ma.toString()));
        this.announce = new Set(announce.map((ma)=>ma.toString()));
        this.observed = new Set();
    }
    /**
   * Get peer listen multiaddrs.
   *
   * @returns {Multiaddr[]}
   */ getListenAddrs() {
        return Array.from(this.listen).map((a)=>new $bab04d77d898eb97$require$Multiaddr(a));
    }
    /**
   * Get peer announcing multiaddrs.
   *
   * @returns {Multiaddr[]}
   */ getAnnounceAddrs() {
        return Array.from(this.announce).map((a)=>new $bab04d77d898eb97$require$Multiaddr(a));
    }
    /**
   * Get observed multiaddrs.
   *
   * @returns {Array<Multiaddr>}
   */ getObservedAddrs() {
        return Array.from(this.observed).map((a)=>new $bab04d77d898eb97$require$Multiaddr(a));
    }
    /**
   * Add peer observed addresses
   *
   * @param {string | Multiaddr} addr
   */ addObservedAddr(addr) {
        let ma = new $bab04d77d898eb97$require$Multiaddr(addr);
        const remotePeer = ma.getPeerId();
        // strip our peer id if it has been passed
        if (remotePeer) {
            const remotePeerId = $ksmXv.createFromB58String(remotePeer);
            // use same encoding for comparison
            if (remotePeerId.equals(this.peerId)) ma = ma.decapsulate(new $bab04d77d898eb97$require$Multiaddr(`/p2p/${this.peerId}`));
        }
        const addrString = ma.toString();
        // do not trigger the change:addresses event if we already know about this address
        if (this.observed.has(addrString)) return;
        this.observed.add(addrString);
        this.emit("change:addresses");
    }
}
module.exports = $bab04d77d898eb97$var$AddressManager;

});

parcelRequire.register("bSGgH", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $8a658676066f30e7$var$log = Object.assign($jjmHV("libp2p:connection-manager"), {
    error: $jjmHV("libp2p:connection-manager:err")
});

var $20Lm5 = parcelRequire("20Lm5");

var $8pyvD = parcelRequire("8pyvD");

var $dDGll = parcelRequire("dDGll");

var $fOCk5 = parcelRequire("fOCk5");

var $7QXK1 = parcelRequire("7QXK1");
var $8a658676066f30e7$require$EventEmitter = $7QXK1.EventEmitter;

var $7A6cy = parcelRequire("7A6cy");

var $ksmXv = parcelRequire("ksmXv");

var $8yAh4 = parcelRequire("8yAh4");
const { codes: { ERR_INVALID_PARAMETERS: $8a658676066f30e7$var$ERR_INVALID_PARAMETERS } } = $8yAh4;
const $8a658676066f30e7$var$defaultOptions = {
    maxConnections: Infinity,
    minConnections: 0,
    maxData: Infinity,
    maxSentData: Infinity,
    maxReceivedData: Infinity,
    maxEventLoopDelay: Infinity,
    pollInterval: 2000,
    autoDialInterval: 10000,
    movingAverageInterval: 60000,
    defaultPeerValue: 1
};
const $8a658676066f30e7$var$METRICS_COMPONENT = "connection-manager";
const $8a658676066f30e7$var$METRICS_PEER_CONNECTIONS = "peer-connections";
const $8a658676066f30e7$var$METRICS_PEER_VALUES = "peer-values";
/**
 * @typedef {import('../')} Libp2p
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 */ /**
 * @typedef {Object} ConnectionManagerOptions
 * @property {number} [maxConnections = Infinity] - The maximum number of connections allowed.
 * @property {number} [minConnections = 0] - The minimum number of connections to avoid pruning.
 * @property {number} [maxData = Infinity] - The max data (in and out), per average interval to allow.
 * @property {number} [maxSentData = Infinity] - The max outgoing data, per average interval to allow.
 * @property {number} [maxReceivedData = Infinity] - The max incoming data, per average interval to allow.
 * @property {number} [maxEventLoopDelay = Infinity] - The upper limit the event loop can take to run.
 * @property {number} [pollInterval = 2000] - How often, in milliseconds, metrics and latency should be checked.
 * @property {number} [movingAverageInterval = 60000] - How often, in milliseconds, to compute averages.
 * @property {number} [defaultPeerValue = 1] - The value of the peer.
 * @property {boolean} [autoDial = true] - Should preemptively guarantee connections are above the low watermark.
 * @property {number} [autoDialInterval = 10000] - How often, in milliseconds, it should preemptively guarantee connections are above the low watermark.
 */ /**
 *
 * @fires ConnectionManager#peer:connect Emitted when a new peer is connected.
 * @fires ConnectionManager#peer:disconnect Emitted when a peer is disconnected.
 */ class $8a658676066f30e7$var$ConnectionManager extends $8a658676066f30e7$require$EventEmitter {
    /**
   * Responsible for managing known connections.
   *
   * @class
   * @param {Libp2p} libp2p
   * @param {ConnectionManagerOptions} options
   */ constructor(libp2p, options = {}){
        super();
        this._libp2p = libp2p;
        this._peerId = libp2p.peerId.toB58String();
        this._options = $8pyvD.call({
            ignoreUndefined: true
        }, $8a658676066f30e7$var$defaultOptions, options);
        if (this._options.maxConnections < this._options.minConnections) throw $20Lm5(new Error("Connection Manager maxConnections must be greater than minConnections"), $8a658676066f30e7$var$ERR_INVALID_PARAMETERS);
        $8a658676066f30e7$var$log("options: %j", this._options);
        /**
     * Map of peer identifiers to their peer value for pruning connections.
     *
     * @type {Map<string, number>}
     */ this._peerValues = $7A6cy($8a658676066f30e7$var$METRICS_COMPONENT, $8a658676066f30e7$var$METRICS_PEER_VALUES, this._libp2p.metrics);
        /**
     * Map of connections per peer
     *
     * @type {Map<string, Connection[]>}
     */ this.connections = $7A6cy($8a658676066f30e7$var$METRICS_COMPONENT, $8a658676066f30e7$var$METRICS_PEER_CONNECTIONS, this._libp2p.metrics);
        this._started = false;
        this._timer = null;
        this._checkMetrics = this._checkMetrics.bind(this);
        this._latencyMonitor = new $dDGll({
            latencyCheckIntervalMs: this._options.pollInterval,
            dataEmitIntervalMs: this._options.pollInterval
        });
    }
    /**
   * Get current number of open connections.
   */ get size() {
        return Array.from(this.connections.values()).reduce((accumulator, value)=>accumulator + value.length, 0);
    }
    /**
   * Starts the Connection Manager. If Metrics are not enabled on libp2p
   * only event loop and connection limits will be monitored.
   */ start() {
        if (this._libp2p.metrics) this._timer = this._timer || $fOCk5(this._checkMetrics, this._options.pollInterval);
        // latency monitor
        this._latencyMonitor.start();
        this._onLatencyMeasure = this._onLatencyMeasure.bind(this);
        this._latencyMonitor.on("data", this._onLatencyMeasure);
        this._started = true;
        $8a658676066f30e7$var$log("started");
    }
    /**
   * Stops the Connection Manager
   *
   * @async
   */ async stop() {
        this._timer && this._timer.clear();
        this._latencyMonitor.removeListener("data", this._onLatencyMeasure);
        this._latencyMonitor.stop();
        this._started = false;
        await this._close();
        $8a658676066f30e7$var$log("stopped");
    }
    /**
   * Cleans up the connections
   *
   * @async
   */ async _close() {
        // Close all connections we're tracking
        const tasks = [];
        for (const connectionList of this.connections.values())for (const connection of connectionList)tasks.push(connection.close());
        await Promise.all(tasks);
        this.connections.clear();
    }
    /**
   * Sets the value of the given peer. Peers with lower values
   * will be disconnected first.
   *
   * @param {PeerId} peerId
   * @param {number} value - A number between 0 and 1
   * @returns {void}
   */ setPeerValue(peerId, value) {
        if (value < 0 || value > 1) throw new Error("value should be a number between 0 and 1");
        this._peerValues.set(peerId.toB58String(), value);
    }
    /**
   * Checks the libp2p metrics to determine if any values have exceeded
   * the configured maximums.
   *
   * @private
   */ _checkMetrics() {
        if (this._libp2p.metrics) {
            const movingAverages = this._libp2p.metrics.global.movingAverages;
            // @ts-ignore moving averages object types
            const received = movingAverages.dataReceived[this._options.movingAverageInterval].movingAverage();
            this._checkMaxLimit("maxReceivedData", received);
            // @ts-ignore moving averages object types
            const sent = movingAverages.dataSent[this._options.movingAverageInterval].movingAverage();
            this._checkMaxLimit("maxSentData", sent);
            const total = received + sent;
            this._checkMaxLimit("maxData", total);
            $8a658676066f30e7$var$log("metrics update", total);
            this._timer = $fOCk5(this._checkMetrics, this._options.pollInterval);
        }
    }
    /**
   * Tracks the incoming connection and check the connection limit
   *
   * @param {Connection} connection
   * @returns {void}
   */ onConnect(connection) {
        const peerId = connection.remotePeer;
        const peerIdStr = peerId.toB58String();
        const storedConn = this.connections.get(peerIdStr);
        this.emit("peer:connect", connection);
        if (storedConn) storedConn.push(connection);
        else this.connections.set(peerIdStr, [
            connection
        ]);
        this._libp2p.peerStore.keyBook.set(peerId, peerId.pubKey);
        if (!this._peerValues.has(peerIdStr)) this._peerValues.set(peerIdStr, this._options.defaultPeerValue);
        this._checkMaxLimit("maxConnections", this.size);
    }
    /**
   * Removes the connection from tracking
   *
   * @param {Connection} connection
   * @returns {void}
   */ onDisconnect(connection) {
        const peerId = connection.remotePeer.toB58String();
        let storedConn = this.connections.get(peerId);
        if (storedConn && storedConn.length > 1) {
            storedConn = storedConn.filter((conn)=>conn.id !== connection.id);
            this.connections.set(peerId, storedConn);
        } else if (storedConn) {
            this.connections.delete(peerId);
            this._peerValues.delete(connection.remotePeer.toB58String());
            this.emit("peer:disconnect", connection);
            this._libp2p.metrics && this._libp2p.metrics.onPeerDisconnected(connection.remotePeer);
        }
    }
    /**
   * Get a connection with a peer.
   *
   * @param {PeerId} peerId
   * @returns {Connection|null}
   */ get(peerId) {
        const connections = this.getAll(peerId);
        if (connections.length) return connections[0];
        return null;
    }
    /**
   * Get all open connections with a peer.
   *
   * @param {PeerId} peerId
   * @returns {Connection[]}
   */ getAll(peerId) {
        if (!$ksmXv.isPeerId(peerId)) throw $20Lm5(new Error("peerId must be an instance of peer-id"), $8a658676066f30e7$var$ERR_INVALID_PARAMETERS);
        const id = peerId.toB58String();
        const connections = this.connections.get(id);
        // Return all open connections
        if (connections) return connections.filter((connection)=>connection.stat.status === "open");
        return [];
    }
    /**
   * If the event loop is slow, maybe close a connection
   *
   * @private
   * @param {*} summary - The LatencyMonitor summary
   */ _onLatencyMeasure(summary) {
        this._checkMaxLimit("maxEventLoopDelay", summary.avgMs);
    }
    /**
   * If the `value` of `name` has exceeded its limit, maybe close a connection
   *
   * @private
   * @param {string} name - The name of the field to check limits for
   * @param {number} value - The current value of the field
   */ _checkMaxLimit(name, value) {
        const limit = this._options[name];
        $8a658676066f30e7$var$log("checking limit of %s. current value: %d of %d", name, value, limit);
        if (value > limit) {
            $8a658676066f30e7$var$log("%s: limit exceeded: %s, %d", this._peerId, name, value);
            this._maybeDisconnectOne();
        }
    }
    /**
   * If we have more connections than our maximum, close a connection
   * to the lowest valued peer.
   *
   * @private
   */ _maybeDisconnectOne() {
        if (this._options.minConnections < this.connections.size) {
            const peerValues = Array.from(new Map([
                ...this._peerValues.entries()
            ].sort((a, b)=>a[1] - b[1])));
            $8a658676066f30e7$var$log("%s: sorted peer values: %j", this._peerId, peerValues);
            const disconnectPeer = peerValues[0];
            if (disconnectPeer) {
                const peerId = disconnectPeer[0];
                $8a658676066f30e7$var$log("%s: lowest value peer is %s", this._peerId, peerId);
                $8a658676066f30e7$var$log("%s: closing a connection to %j", this._peerId, peerId);
                for (const connections of this.connections.values())if (connections[0].remotePeer.toB58String() === peerId) {
                    connections[0].close();
                    break;
                }
            }
        }
    }
}
module.exports = $8a658676066f30e7$var$ConnectionManager;

});
parcelRequire.register("dDGll", function(module, exports) {
// @ts-nocheck
"use strict";

var $7QXK1 = parcelRequire("7QXK1");
var $9edfc361d12fa465$require$EventEmitter = $7QXK1.EventEmitter;

var $7lTce = parcelRequire("7lTce");

const $9edfc361d12fa465$var$debug = (parcelRequire("jjmHV"))("latency-monitor:LatencyMonitor");
/**
 * @typedef {Object} SummaryObject
 * @property {number} events How many events were called
 * @property {number} minMS What was the min time for a cb to be called
 * @property {number} maxMS What was the max time for a cb to be called
 * @property {number} avgMs What was the average time for a cb to be called
 * @property {number} lengthMs How long this interval was in ms
 *
 * @typedef {Object} LatencyMonitorOptions
 * @property {number} [latencyCheckIntervalMs=500] - How often to add a latency check event (ms)
 * @property {number} [dataEmitIntervalMs=5000] - How often to summarize latency check events. null or 0 disables event firing
 * @property {Function} [asyncTestFn] - What cb-style async function to use
 * @property {number} [latencyRandomPercentage=5] - What percent (+/-) of latencyCheckIntervalMs should we randomly use? This helps avoid alignment to other events.
 */ /**
 * A class to monitor latency of any async function which works in a browser or node. This works by periodically calling
 * the asyncTestFn and timing how long it takes the callback to be called. It can also periodically emit stats about this.
 * This can be disabled and stats can be pulled via setting dataEmitIntervalMs = 0.
 *
 * @extends {EventEmitter}
 *
 * The default implementation is an event loop latency monitor. This works by firing periodic events into the event loop
 * and timing how long it takes to get back.
 *
 * @example
 * const monitor = new LatencyMonitor();
 * monitor.on('data', (summary) => console.log('Event Loop Latency: %O', summary));
 *
 * @example
 * const monitor = new LatencyMonitor({latencyCheckIntervalMs: 1000, dataEmitIntervalMs: 60000, asyncTestFn:ping});
 * monitor.on('data', (summary) => console.log('Ping Pong Latency: %O', summary));
 */ class $9edfc361d12fa465$var$LatencyMonitor extends $9edfc361d12fa465$require$EventEmitter {
    /**
   * @class
   * @param {LatencyMonitorOptions} [options]
   */ constructor({ latencyCheckIntervalMs: latencyCheckIntervalMs, dataEmitIntervalMs: dataEmitIntervalMs, asyncTestFn: asyncTestFn, latencyRandomPercentage: latencyRandomPercentage } = {}){
        super();
        const that = this;
        // 0 isn't valid here, so its ok to use ||
        that.latencyCheckIntervalMs = latencyCheckIntervalMs || 500 // 0.5s
        ;
        that.latencyRandomPercentage = latencyRandomPercentage || 10;
        that._latecyCheckMultiply = 2 * (that.latencyRandomPercentage / 100.0) * that.latencyCheckIntervalMs;
        that._latecyCheckSubtract = that._latecyCheckMultiply / 2;
        that.dataEmitIntervalMs = dataEmitIntervalMs === null || dataEmitIntervalMs === 0 ? undefined : dataEmitIntervalMs || 5000 // 5s
        ;
        $9edfc361d12fa465$var$debug("latencyCheckIntervalMs: %s dataEmitIntervalMs: %s", that.latencyCheckIntervalMs, that.dataEmitIntervalMs);
        if (that.dataEmitIntervalMs) $9edfc361d12fa465$var$debug("Expecting ~%s events per summary", that.latencyCheckIntervalMs / that.dataEmitIntervalMs);
        else $9edfc361d12fa465$var$debug("Not emitting summaries");
        that.asyncTestFn = asyncTestFn // If there is no asyncFn, we measure latency
        ;
    }
    start() {
        // If process: use high resolution timer
        if (globalThis.process && globalThis.process.hrtime) {
            $9edfc361d12fa465$var$debug("Using process.hrtime for timing");
            this.now = globalThis.process.hrtime // eslint-disable-line no-undef
            ;
            this.getDeltaMS = (startTime)=>{
                const hrtime = this.now(startTime);
                return hrtime[0] * 1000 + hrtime[1] / 1000000;
            };
        // Let's try for a timer that only monotonically increases
        } else if (typeof window !== "undefined" && window.performance && window.performance.now) {
            $9edfc361d12fa465$var$debug("Using performance.now for timing");
            this.now = window.performance.now.bind(window.performance);
            this.getDeltaMS = (startTime)=>Math.round(this.now() - startTime);
        } else {
            $9edfc361d12fa465$var$debug("Using Date.now for timing");
            this.now = Date.now;
            this.getDeltaMS = (startTime)=>this.now() - startTime;
        }
        this._latencyData = this._initLatencyData();
        // We check for isBrowser because of browsers set max rates of timeouts when a page is hidden,
        // so we fall back to another library
        // See: http://stackoverflow.com/questions/6032429/chrome-timeouts-interval-suspended-in-background-tabs
        if ($9edfc361d12fa465$var$isBrowser()) {
            this._visibilityChangeEmitter = new $7lTce();
            this._visibilityChangeEmitter.on("visibilityChange", (pageInFocus)=>{
                if (pageInFocus) this._startTimers();
                else {
                    this._emitSummary();
                    this._stopTimers();
                }
            });
        }
        if (!this._visibilityChangeEmitter || this._visibilityChangeEmitter.isVisible()) this._startTimers();
    }
    stop() {
        this._stopTimers();
    }
    /**
   * Start internal timers
   *
   * @private
   */ _startTimers() {
        // Timer already started, ignore this
        if (this._checkLatencyID) return;
        this._checkLatency();
        if (this.dataEmitIntervalMs) {
            this._emitIntervalID = setInterval(()=>this._emitSummary(), this.dataEmitIntervalMs);
            if (typeof this._emitIntervalID.unref === "function") this._emitIntervalID.unref() // Doesn't block exit
            ;
        }
    }
    /**
   * Stop internal timers
   *
   * @private
   */ _stopTimers() {
        if (this._checkLatencyID) {
            clearTimeout(this._checkLatencyID);
            this._checkLatencyID = undefined;
        }
        if (this._emitIntervalID) {
            clearInterval(this._emitIntervalID);
            this._emitIntervalID = undefined;
        }
    }
    /**
   * Emit summary only if there were events. It might not have any events if it was forced via a page hidden/show
   *
   * @private
   */ _emitSummary() {
        const summary = this.getSummary();
        if (summary.events > 0) this.emit("data", summary);
    }
    /**
   * Calling this function will end the collection period. If a timing event was already fired and somewhere in the queue,
   * it will not count for this time period
   *
   * @returns {SummaryObject}
   */ getSummary() {
        // We might want to adjust for the number of expected events
        // Example: first 1 event it comes back, then such a long blocker that the next emit check comes
        // Then this fires - looks like no latency!!
        const latency = {
            events: this._latencyData.events,
            minMs: this._latencyData.minMs,
            maxMs: this._latencyData.maxMs,
            avgMs: this._latencyData.events ? this._latencyData.totalMs / this._latencyData.events : Number.POSITIVE_INFINITY,
            lengthMs: this.getDeltaMS(this._latencyData.startTime)
        };
        this._latencyData = this._initLatencyData() // Clear
        ;
        $9edfc361d12fa465$var$debug("Summary: %O", latency);
        return latency;
    }
    /**
   * Randomly calls an async fn every roughly latencyCheckIntervalMs (plus some randomness). If no async fn is found,
   * it will simply report on event loop latency.
   *
   * @private
   */ _checkLatency() {
        const that = this;
        // Randomness is needed to avoid alignment by accident to regular things in the event loop
        const randomness = Math.random() * that._latecyCheckMultiply - that._latecyCheckSubtract;
        // We use this to ensure that in case some overlap somehow, we don't take the wrong startTime/offset
        const localData = {
            deltaOffset: Math.ceil(that.latencyCheckIntervalMs + randomness),
            startTime: that.now()
        };
        const cb = ()=>{
            // We are already stopped, ignore this datapoint
            if (!this._checkLatencyID) return;
            const deltaMS = that.getDeltaMS(localData.startTime) - localData.deltaOffset;
            that._checkLatency() // Start again ASAP
            ;
            // Add the data point. If this gets complex, refactor it
            that._latencyData.events++;
            that._latencyData.minMs = Math.min(that._latencyData.minMs, deltaMS);
            that._latencyData.maxMs = Math.max(that._latencyData.maxMs, deltaMS);
            that._latencyData.totalMs += deltaMS;
            $9edfc361d12fa465$var$debug("MS: %s Data: %O", deltaMS, that._latencyData);
        };
        $9edfc361d12fa465$var$debug("localData: %O", localData);
        this._checkLatencyID = setTimeout(()=>{
            // This gets rid of including event loop
            if (that.asyncTestFn) {
                // Clear timing related things
                localData.deltaOffset = 0;
                localData.startTime = that.now();
                that.asyncTestFn(cb);
            } else {
                // setTimeout is not more accurate than 1ms, so this will ensure positive numbers. Add 1 to emitted data to remove.
                // This is not the best, but for now it'll be just fine. This isn't meant to be sub ms accurate.
                localData.deltaOffset -= 1;
                // If there is no function to test, we mean check latency which is a special case that is really cb => cb()
                // We avoid that for the few extra function all overheads. Also, we want to keep the timers different
                cb();
            }
        }, localData.deltaOffset);
        if (typeof this._checkLatencyID.unref === "function") this._checkLatencyID.unref() // Doesn't block exit
        ;
    }
    _initLatencyData() {
        return {
            startTime: this.now(),
            minMs: Number.POSITIVE_INFINITY,
            maxMs: Number.NEGATIVE_INFINITY,
            events: 0,
            totalMs: 0
        };
    }
}
function $9edfc361d12fa465$var$isBrowser() {
    return typeof window !== "undefined";
}
module.exports = $9edfc361d12fa465$var$LatencyMonitor;

});
parcelRequire.register("7lTce", function(module, exports) {
// @ts-nocheck
/* global document */ /**
 * This code is based on `latency-monitor` (https://github.com/mlucool/latency-monitor) by `mlucool` (https://github.com/mlucool), available under Apache License 2.0 (https://github.com/mlucool/latency-monitor/blob/master/LICENSE)
 */ "use strict";

var $7QXK1 = parcelRequire("7QXK1");
var $0161a2501b58a3f7$require$EventEmitter = $7QXK1.EventEmitter;

const $0161a2501b58a3f7$var$debug = (parcelRequire("jjmHV"))("latency-monitor:VisibilityChangeEmitter");
/**
 * Listen to page visibility change events (i.e. when the page is focused / blurred) by an event emitter.
 *
 * Warning: This does not work on all browsers, but should work on all modern browsers
 *
 * @example
 *
 *     const myVisibilityEmitter = new VisibilityChangeEmitter();
 *
 *     myVisibilityEmitter.on('visibilityChange', (pageInFocus) => {
 *        if ( pageInFocus ){
 *            // Page is in focus
 *            console.log('In focus');
 *        }
 *        else {
 *            // Page is blurred
 *            console.log('Out of focus');
 *        }
 *     });
 *     // To access the visibility state directly, call:
 *     console.log('Am I focused now? ' + myVisibilityEmitter.isVisible());
 */ class $0161a2501b58a3f7$var$VisibilityChangeEmitter extends $0161a2501b58a3f7$require$EventEmitter {
    /**
   * Creates a VisibilityChangeEmitter
   *
   * @class
   */ constructor(){
        super();
        if (typeof document === "undefined") {
            $0161a2501b58a3f7$var$debug('This is not a browser, no "document" found. Stopping.');
            return;
        }
        this._initializeVisibilityVarNames();
        this._addVisibilityChangeListener();
    }
    /**
   * document.hidden and document.visibilityChange are the two variables we need to check for;
   * Since these variables are named differently in different browsers, this function sets
   * the appropriate name based on the browser being used. Once executed, tha actual names of
   * document.hidden and document.visibilityChange are found in this._hidden and this._visibilityChange
   * respectively
   *
   * @private
   */ _initializeVisibilityVarNames() {
        let hidden;
        let visibilityChange;
        if (typeof document.hidden !== "undefined") {
            hidden = "hidden";
            visibilityChange = "visibilitychange";
        } else if (typeof document.mozHidden !== "undefined") {
            hidden = "mozHidden";
            visibilityChange = "mozvisibilitychange";
        } else if (typeof document.msHidden !== "undefined") {
            hidden = "msHidden";
            visibilityChange = "msvisibilitychange";
        } else if (typeof document.webkitHidden !== "undefined") {
            hidden = "webkitHidden";
            visibilityChange = "webkitvisibilitychange";
        }
        this._hidden = hidden;
        this._visibilityChange = visibilityChange;
    }
    /**
   * Adds an event listener on the document that listens to changes in document.visibilityChange
   * (or whatever name by which the visibilityChange variable is known in the browser)
   *
   * @private
   */ _addVisibilityChangeListener() {
        if (typeof document.addEventListener === "undefined" || typeof document[this._hidden] === "undefined") $0161a2501b58a3f7$var$debug("Checking page visibility requires a browser that supports the Page Visibility API.");
        else // Handle page visibility change
        document.addEventListener(this._visibilityChange, this._handleVisibilityChange.bind(this), false);
    }
    /**
   * The function returns ```true``` if the page is visible or ```false``` if the page is not visible and
   * ```undefined``` if the page visibility API is not supported by the browser.
   *
   * @returns {boolean | void} whether the page is now visible or not (undefined is unknown)
   */ isVisible() {
        if (this._hidden === undefined || document[this._hidden] === undefined) return undefined;
        return !document[this._hidden];
    }
    /**
   * The function that is called when document.visibilityChange has changed
   * It emits an event called visibilityChange and sends the value of document.hidden as a
   * parameter
   *
   * @private
   */ _handleVisibilityChange() {
        const visible = !document[this._hidden];
        $0161a2501b58a3f7$var$debug(visible ? "Page Visible" : "Page Hidden");
        // Emit the event
        this.emit("visibilityChange", visible);
    }
}
module.exports = $0161a2501b58a3f7$var$VisibilityChangeEmitter;

});


parcelRequire.register("7A6cy", function(module, exports) {
"use strict";
/**
 * @template K
 * @template V
 */ class $5850b4ac3ac6d066$var$TrackedMap extends Map {
    /**
   * @param {string} component
   * @param {string} name
   * @param {import('.')} metrics
   */ constructor(component, name, metrics){
        super();
        this._component = component;
        this._name = name;
        this._metrics = metrics;
        this._metrics.updateComponentMetric(this._component, this._name, this.size);
    }
    /**
   * @param {K} key
   * @param {V} value
   */ set(key, value) {
        super.set(key, value);
        this._metrics.updateComponentMetric(this._component, this._name, this.size);
        return this;
    }
    /**
   * @param {K} key
   */ delete(key) {
        const deleted = super.delete(key);
        this._metrics.updateComponentMetric(this._component, this._name, this.size);
        return deleted;
    }
    clear() {
        super.clear();
        this._metrics.updateComponentMetric(this._component, this._name, this.size);
    }
}
/**
 * @template K
 * @template V
 * @param {string} component
 * @param {string} name
 * @param {import('.')} [metrics]
 * @returns {Map<K, V>}
 */ module.exports = (component, name, metrics)=>{
    /** @type {Map<K, V>} */ let map;
    if (metrics) map = new $5850b4ac3ac6d066$var$TrackedMap(component, name, metrics);
    else map = new Map();
    return map;
};

});


parcelRequire.register("3W561", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");

var $8pyvD = parcelRequire("8pyvD");

var $fOCk5 = parcelRequire("fOCk5");
const $2ddabde187e99e77$var$log = Object.assign($jjmHV("libp2p:connection-manager:auto-dialler"), {
    error: $jjmHV("libp2p:connection-manager:auto-dialler:err")
});
const $2ddabde187e99e77$var$defaultOptions = {
    enabled: true,
    minConnections: 0,
    autoDialInterval: 10000
};
/**
 * @typedef {import('../index')} Libp2p
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 */ /**
 * @typedef {Object} AutoDiallerOptions
 * @property {boolean} [enabled = true] - Should preemptively guarantee connections are above the low watermark
 * @property {number} [minConnections = 0] - The minimum number of connections to avoid pruning
 * @property {number} [autoDialInterval = 10000] - How often, in milliseconds, it should preemptively guarantee connections are above the low watermark
 */ class $2ddabde187e99e77$var$AutoDialler {
    /**
   * Proactively tries to connect to known peers stored in the PeerStore.
   * It will keep the number of connections below the upper limit and sort
   * the peers to connect based on wether we know their keys and protocols.
   *
   * @class
   * @param {Libp2p} libp2p
   * @param {AutoDiallerOptions} options
   */ constructor(libp2p, options = {}){
        this._options = $8pyvD.call({
            ignoreUndefined: true
        }, $2ddabde187e99e77$var$defaultOptions, options);
        this._libp2p = libp2p;
        this._running = false;
        this._autoDialTimeout = null;
        this._autoDial = this._autoDial.bind(this);
        $2ddabde187e99e77$var$log("options: %j", this._options);
    }
    /**
   * Starts the auto dialer
   */ start() {
        if (!this._options.enabled) {
            $2ddabde187e99e77$var$log("not enabled");
            return;
        }
        this._running = true;
        this._autoDial().catch((err)=>{
            $2ddabde187e99e77$var$log.error("could start autodial", err);
        });
        $2ddabde187e99e77$var$log("started");
    }
    /**
   * Stops the auto dialler
   */ async stop() {
        if (!this._options.enabled) {
            $2ddabde187e99e77$var$log("not enabled");
            return;
        }
        this._running = false;
        this._autoDialTimeout && this._autoDialTimeout.clear();
        $2ddabde187e99e77$var$log("stopped");
    }
    async _autoDial() {
        const minConnections = this._options.minConnections;
        // Already has enough connections
        if (this._libp2p.connections.size >= minConnections) {
            this._autoDialTimeout = $fOCk5(this._autoDial, this._options.autoDialInterval);
            return;
        }
        // Sort peers on wether we know protocols of public keys for them
        const peers = Array.from(this._libp2p.peerStore.peers.values()).sort((a, b)=>{
            if (b.protocols && b.protocols.length && (!a.protocols || !a.protocols.length)) return 1;
            else if (b.id.pubKey && !a.id.pubKey) return 1;
            return -1;
        });
        for(let i = 0; this._running && i < peers.length && this._libp2p.connections.size < minConnections; i++)if (!this._libp2p.connectionManager.get(peers[i].id)) {
            $2ddabde187e99e77$var$log("connecting to a peerStore stored peer %s", peers[i].id.toB58String());
            try {
                await this._libp2p.dialer.connectToPeer(peers[i].id);
            } catch (/** @type {any} */ err) {
                $2ddabde187e99e77$var$log.error("could not connect to peerStore stored peer", err);
            }
        }
        // Connection Manager was stopped
        if (!this._running) return;
        this._autoDialTimeout = $fOCk5(this._autoDial, this._options.autoDialInterval);
    }
}
module.exports = $2ddabde187e99e77$var$AutoDialler;

});

parcelRequire.register("lgnQl", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $f7ad966570162170$var$log = Object.assign($jjmHV("libp2p:circuit"), {
    error: $jjmHV("libp2p:circuit:err")
});

var $20Lm5 = parcelRequire("20Lm5");

var $gwbn0 = parcelRequire("gwbn0");

var $aZLwC = parcelRequire("aZLwC");
var $f7ad966570162170$require$Multiaddr = $aZLwC.Multiaddr;

var $ksmXv = parcelRequire("ksmXv");

var $cJ5Wu = parcelRequire("cJ5Wu");
var $f7ad966570162170$require$CircuitPB = $cJ5Wu.CircuitRelay;

var $8yAh4 = parcelRequire("8yAh4");
var $f7ad966570162170$require$codes = $8yAh4.codes;

var $fgQnU = parcelRequire("fgQnU");

var $lSDqG = parcelRequire("lSDqG");
var $f7ad966570162170$require$multicodec = $lSDqG.relay;

var $iSHLb = parcelRequire("iSHLb");

var $jouFB = parcelRequire("jouFB");
var $f7ad966570162170$require$handleCanHop = $jouFB.handleCanHop;
var $f7ad966570162170$require$handleHop = $jouFB.handleHop;
var $f7ad966570162170$require$hop = $jouFB.hop;

var $1usg8 = parcelRequire("1usg8");
var $f7ad966570162170$require$handleStop = $1usg8.handleStop;

var $9OYXJ = parcelRequire("9OYXJ");
const $f7ad966570162170$var$transportSymbol = Symbol.for("@libp2p/js-libp2p-circuit/circuit");
/**
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxedStream} MuxedStream
 */ class $f7ad966570162170$var$Circuit {
    /**
   * Creates an instance of the Circuit Transport.
   *
   * @class
   * @param {object} options
   * @param {import('../')} options.libp2p
   * @param {import('../upgrader')} options.upgrader
   */ constructor({ libp2p: libp2p, upgrader: upgrader }){
        this._dialer = libp2p.dialer;
        this._registrar = libp2p.registrar;
        this._connectionManager = libp2p.connectionManager;
        this._upgrader = upgrader;
        this._options = libp2p._config.relay;
        this._libp2p = libp2p;
        this.peerId = libp2p.peerId;
        this._registrar.handle($f7ad966570162170$require$multicodec, this._onProtocol.bind(this));
    }
    /**
   * @param {Object} props
   * @param {Connection} props.connection
   * @param {MuxedStream} props.stream
   */ async _onProtocol({ connection: connection, stream: stream }) {
        /** @type {import('./circuit/stream-handler')} */ const streamHandler = new $9OYXJ({
            stream: stream
        });
        const request = await streamHandler.read();
        if (!request) return;
        const circuit = this;
        let virtualConnection;
        switch(request.type){
            case $f7ad966570162170$require$CircuitPB.Type.CAN_HOP:
                $f7ad966570162170$var$log("received CAN_HOP request from %s", connection.remotePeer.toB58String());
                await $f7ad966570162170$require$handleCanHop({
                    circuit: circuit,
                    connection: connection,
                    streamHandler: streamHandler
                });
                break;
            case $f7ad966570162170$require$CircuitPB.Type.HOP:
                $f7ad966570162170$var$log("received HOP request from %s", connection.remotePeer.toB58String());
                virtualConnection = await $f7ad966570162170$require$handleHop({
                    connection: connection,
                    request: request,
                    streamHandler: streamHandler,
                    circuit: circuit
                });
                break;
            case $f7ad966570162170$require$CircuitPB.Type.STOP:
                $f7ad966570162170$var$log("received STOP request from %s", connection.remotePeer.toB58String());
                virtualConnection = await $f7ad966570162170$require$handleStop({
                    connection: connection,
                    request: request,
                    streamHandler: streamHandler
                });
                break;
            default:
                $f7ad966570162170$var$log("Request of type %s not supported", request.type);
        }
        if (virtualConnection) {
            // @ts-ignore dst peer will not be undefined
            const remoteAddr = new $f7ad966570162170$require$Multiaddr(request.dstPeer.addrs[0]);
            // @ts-ignore src peer will not be undefined
            const localAddr = new $f7ad966570162170$require$Multiaddr(request.srcPeer.addrs[0]);
            const maConn = $fgQnU({
                stream: virtualConnection,
                remoteAddr: remoteAddr,
                localAddr: localAddr
            });
            const type = request.type === $f7ad966570162170$require$CircuitPB.Type.HOP ? "relay" : "inbound";
            $f7ad966570162170$var$log("new %s connection %s", type, maConn.remoteAddr);
            const conn = await this._upgrader.upgradeInbound(maConn);
            $f7ad966570162170$var$log("%s connection %s upgraded", type, maConn.remoteAddr);
            this.handler && this.handler(conn);
        }
    }
    /**
   * Dial a peer over a relay
   *
   * @param {Multiaddr} ma - the multiaddr of the peer to dial
   * @param {Object} options - dial options
   * @param {AbortSignal} [options.signal] - An optional abort signal
   * @returns {Promise<Connection>} - the connection
   */ async dial(ma, options) {
        // Check the multiaddr to see if it contains a relay and a destination peer
        const addrs = ma.toString().split("/p2p-circuit");
        const relayAddr = new $f7ad966570162170$require$Multiaddr(addrs[0]);
        const destinationAddr = new $f7ad966570162170$require$Multiaddr(addrs[addrs.length - 1]);
        const relayId = relayAddr.getPeerId();
        const destinationId = destinationAddr.getPeerId();
        if (!relayId || !destinationId) {
            const errMsg = "Circuit relay dial failed as addresses did not have peer id";
            $f7ad966570162170$var$log.error(errMsg);
            throw $20Lm5(new Error(errMsg), $f7ad966570162170$require$codes.ERR_RELAYED_DIAL);
        }
        const relayPeer = $ksmXv.createFromB58String(relayId);
        const destinationPeer = $ksmXv.createFromB58String(destinationId);
        let disconnectOnFailure = false;
        let relayConnection = this._connectionManager.get(relayPeer);
        if (!relayConnection) {
            relayConnection = await this._dialer.connectToPeer(relayAddr, options);
            disconnectOnFailure = true;
        }
        try {
            const virtualConnection = await $f7ad966570162170$require$hop({
                connection: relayConnection,
                request: {
                    type: $f7ad966570162170$require$CircuitPB.Type.HOP,
                    srcPeer: {
                        id: this.peerId.toBytes(),
                        addrs: this._libp2p.multiaddrs.map((addr)=>addr.bytes)
                    },
                    dstPeer: {
                        id: destinationPeer.toBytes(),
                        addrs: [
                            new $f7ad966570162170$require$Multiaddr(destinationAddr).bytes
                        ]
                    }
                }
            });
            const localAddr = relayAddr.encapsulate(`/p2p-circuit/p2p/${this.peerId.toB58String()}`);
            const maConn = $fgQnU({
                stream: virtualConnection,
                remoteAddr: ma,
                localAddr: localAddr
            });
            $f7ad966570162170$var$log("new outbound connection %s", maConn.remoteAddr);
            return this._upgrader.upgradeOutbound(maConn);
        } catch (/** @type {any} */ err) {
            $f7ad966570162170$var$log.error("Circuit relay dial failed", err);
            disconnectOnFailure && await relayConnection.close();
            throw err;
        }
    }
    /**
   * Create a listener
   *
   * @param {any} options
   * @param {Function} handler
   * @returns {import('libp2p-interfaces/src/transport/types').Listener}
   */ createListener(options, handler) {
        if (typeof options === "function") {
            handler = options;
            options = {};
        }
        // Called on successful HOP and STOP requests
        this.handler = handler;
        return $iSHLb(this._libp2p);
    }
    /**
   * Filter check for all Multiaddrs that this transport can dial on
   *
   * @param {Multiaddr[]} multiaddrs
   * @returns {Multiaddr[]}
   */ filter(multiaddrs) {
        multiaddrs = Array.isArray(multiaddrs) ? multiaddrs : [
            multiaddrs
        ];
        return multiaddrs.filter((ma)=>{
            return $gwbn0.Circuit.matches(ma);
        });
    }
    get [Symbol.toStringTag]() {
        return "Circuit";
    }
    /**
   * Checks if the given value is a Transport instance.
   *
   * @param {any} other
   * @returns {other is Transport}
   */ static isTransport(other) {
        return Boolean(other && other[$f7ad966570162170$var$transportSymbol]);
    }
}
module.exports = $f7ad966570162170$var$Circuit;

});
parcelRequire.register("gwbn0", function(module, exports) {
"use strict";

var $aZLwC = parcelRequire("aZLwC");
var $c068745aecfadfe8$require$Multiaddr = $aZLwC.Multiaddr;
/**
 * @typedef {import('./types').MatchesFunction} MatchesFunction
 * @typedef {import('./types').PartialMatchesFunction} PartialMatchesFunction
 * @typedef {import('./types').Mafmt} Mafmt
 */ /*
 * Valid combinations
 */ const $c068745aecfadfe8$var$DNS4 = $c068745aecfadfe8$var$base("dns4");
const $c068745aecfadfe8$var$DNS6 = $c068745aecfadfe8$var$base("dns6");
const $c068745aecfadfe8$var$DNSADDR = $c068745aecfadfe8$var$base("dnsaddr");
const $c068745aecfadfe8$var$DNS = $c068745aecfadfe8$var$or($c068745aecfadfe8$var$base("dns"), $c068745aecfadfe8$var$DNSADDR, $c068745aecfadfe8$var$DNS4, $c068745aecfadfe8$var$DNS6);
const $c068745aecfadfe8$var$IP = $c068745aecfadfe8$var$or($c068745aecfadfe8$var$base("ip4"), $c068745aecfadfe8$var$base("ip6"));
const $c068745aecfadfe8$var$TCP = $c068745aecfadfe8$var$or($c068745aecfadfe8$var$and($c068745aecfadfe8$var$IP, $c068745aecfadfe8$var$base("tcp")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$DNS, $c068745aecfadfe8$var$base("tcp")));
const $c068745aecfadfe8$var$UDP = $c068745aecfadfe8$var$and($c068745aecfadfe8$var$IP, $c068745aecfadfe8$var$base("udp"));
const $c068745aecfadfe8$var$UTP = $c068745aecfadfe8$var$and($c068745aecfadfe8$var$UDP, $c068745aecfadfe8$var$base("utp"));
const $c068745aecfadfe8$var$QUIC = $c068745aecfadfe8$var$and($c068745aecfadfe8$var$UDP, $c068745aecfadfe8$var$base("quic"));
const $c068745aecfadfe8$var$WebSockets = $c068745aecfadfe8$var$or($c068745aecfadfe8$var$and($c068745aecfadfe8$var$TCP, $c068745aecfadfe8$var$base("ws")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$DNS, $c068745aecfadfe8$var$base("ws")));
const $c068745aecfadfe8$var$WebSocketsSecure = $c068745aecfadfe8$var$or($c068745aecfadfe8$var$and($c068745aecfadfe8$var$TCP, $c068745aecfadfe8$var$base("wss")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$DNS, $c068745aecfadfe8$var$base("wss")));
const $c068745aecfadfe8$var$HTTP = $c068745aecfadfe8$var$or($c068745aecfadfe8$var$and($c068745aecfadfe8$var$TCP, $c068745aecfadfe8$var$base("http")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$IP, $c068745aecfadfe8$var$base("http")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$DNS, $c068745aecfadfe8$var$base("http")));
const $c068745aecfadfe8$var$HTTPS = $c068745aecfadfe8$var$or($c068745aecfadfe8$var$and($c068745aecfadfe8$var$TCP, $c068745aecfadfe8$var$base("https")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$IP, $c068745aecfadfe8$var$base("https")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$DNS, $c068745aecfadfe8$var$base("https")));
const $c068745aecfadfe8$var$WebRTCStar = $c068745aecfadfe8$var$or($c068745aecfadfe8$var$and($c068745aecfadfe8$var$WebSockets, $c068745aecfadfe8$var$base("p2p-webrtc-star"), $c068745aecfadfe8$var$base("p2p")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$WebSocketsSecure, $c068745aecfadfe8$var$base("p2p-webrtc-star"), $c068745aecfadfe8$var$base("p2p")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$WebSockets, $c068745aecfadfe8$var$base("p2p-webrtc-star")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$WebSocketsSecure, $c068745aecfadfe8$var$base("p2p-webrtc-star")));
const $c068745aecfadfe8$var$WebSocketStar = $c068745aecfadfe8$var$or($c068745aecfadfe8$var$and($c068745aecfadfe8$var$WebSockets, $c068745aecfadfe8$var$base("p2p-websocket-star"), $c068745aecfadfe8$var$base("p2p")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$WebSocketsSecure, $c068745aecfadfe8$var$base("p2p-websocket-star"), $c068745aecfadfe8$var$base("p2p")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$WebSockets, $c068745aecfadfe8$var$base("p2p-websocket-star")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$WebSocketsSecure, $c068745aecfadfe8$var$base("p2p-websocket-star")));
const $c068745aecfadfe8$var$WebRTCDirect = $c068745aecfadfe8$var$or($c068745aecfadfe8$var$and($c068745aecfadfe8$var$HTTP, $c068745aecfadfe8$var$base("p2p-webrtc-direct"), $c068745aecfadfe8$var$base("p2p")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$HTTPS, $c068745aecfadfe8$var$base("p2p-webrtc-direct"), $c068745aecfadfe8$var$base("p2p")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$HTTP, $c068745aecfadfe8$var$base("p2p-webrtc-direct")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$HTTPS, $c068745aecfadfe8$var$base("p2p-webrtc-direct")));
const $c068745aecfadfe8$var$Reliable = $c068745aecfadfe8$var$or($c068745aecfadfe8$var$WebSockets, $c068745aecfadfe8$var$WebSocketsSecure, $c068745aecfadfe8$var$HTTP, $c068745aecfadfe8$var$HTTPS, $c068745aecfadfe8$var$WebRTCStar, $c068745aecfadfe8$var$WebRTCDirect, $c068745aecfadfe8$var$TCP, $c068745aecfadfe8$var$UTP, $c068745aecfadfe8$var$QUIC, $c068745aecfadfe8$var$DNS);
// Unlike ws-star, stardust can run over any transport thus removing the requirement for websockets (but don't even think about running a stardust server over webrtc-star ;) )
const $c068745aecfadfe8$var$Stardust = $c068745aecfadfe8$var$or($c068745aecfadfe8$var$and($c068745aecfadfe8$var$Reliable, $c068745aecfadfe8$var$base("p2p-stardust"), $c068745aecfadfe8$var$base("p2p")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$Reliable, $c068745aecfadfe8$var$base("p2p-stardust")));
const $c068745aecfadfe8$var$_P2P = $c068745aecfadfe8$var$or($c068745aecfadfe8$var$and($c068745aecfadfe8$var$Reliable, $c068745aecfadfe8$var$base("p2p")), $c068745aecfadfe8$var$WebRTCStar, $c068745aecfadfe8$var$WebRTCDirect, $c068745aecfadfe8$var$base("p2p"));
const $c068745aecfadfe8$var$_Circuit = $c068745aecfadfe8$var$or($c068745aecfadfe8$var$and($c068745aecfadfe8$var$_P2P, $c068745aecfadfe8$var$base("p2p-circuit"), $c068745aecfadfe8$var$_P2P), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$_P2P, $c068745aecfadfe8$var$base("p2p-circuit")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$base("p2p-circuit"), $c068745aecfadfe8$var$_P2P), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$Reliable, $c068745aecfadfe8$var$base("p2p-circuit")), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$base("p2p-circuit"), $c068745aecfadfe8$var$Reliable), $c068745aecfadfe8$var$base("p2p-circuit"));
const $c068745aecfadfe8$var$CircuitRecursive = ()=>$c068745aecfadfe8$var$or($c068745aecfadfe8$var$and($c068745aecfadfe8$var$_Circuit, $c068745aecfadfe8$var$CircuitRecursive), $c068745aecfadfe8$var$_Circuit);
const $c068745aecfadfe8$var$Circuit = $c068745aecfadfe8$var$CircuitRecursive();
const $c068745aecfadfe8$var$P2P = $c068745aecfadfe8$var$or($c068745aecfadfe8$var$and($c068745aecfadfe8$var$Circuit, $c068745aecfadfe8$var$_P2P, $c068745aecfadfe8$var$Circuit), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$_P2P, $c068745aecfadfe8$var$Circuit), $c068745aecfadfe8$var$and($c068745aecfadfe8$var$Circuit, $c068745aecfadfe8$var$_P2P), $c068745aecfadfe8$var$Circuit, $c068745aecfadfe8$var$_P2P);
module.exports = {
    DNS: $c068745aecfadfe8$var$DNS,
    DNS4: $c068745aecfadfe8$var$DNS4,
    DNS6: $c068745aecfadfe8$var$DNS6,
    DNSADDR: $c068745aecfadfe8$var$DNSADDR,
    IP: $c068745aecfadfe8$var$IP,
    TCP: $c068745aecfadfe8$var$TCP,
    UDP: $c068745aecfadfe8$var$UDP,
    QUIC: $c068745aecfadfe8$var$QUIC,
    UTP: $c068745aecfadfe8$var$UTP,
    HTTP: $c068745aecfadfe8$var$HTTP,
    HTTPS: $c068745aecfadfe8$var$HTTPS,
    WebSockets: $c068745aecfadfe8$var$WebSockets,
    WebSocketsSecure: $c068745aecfadfe8$var$WebSocketsSecure,
    WebSocketStar: $c068745aecfadfe8$var$WebSocketStar,
    WebRTCStar: $c068745aecfadfe8$var$WebRTCStar,
    WebRTCDirect: $c068745aecfadfe8$var$WebRTCDirect,
    Reliable: $c068745aecfadfe8$var$Reliable,
    Stardust: $c068745aecfadfe8$var$Stardust,
    Circuit: $c068745aecfadfe8$var$Circuit,
    P2P: $c068745aecfadfe8$var$P2P,
    IPFS: $c068745aecfadfe8$var$P2P
};
/*
 * Validation funcs
 */ /**
 * @param {PartialMatchesFunction} partialMatch
 */ function $c068745aecfadfe8$var$makeMatchesFunction(partialMatch) {
    /**
   * @type {MatchesFunction}
   */ function matches(a) {
        if (!$c068745aecfadfe8$require$Multiaddr.isMultiaddr(a)) try {
            a = new $c068745aecfadfe8$require$Multiaddr(a);
        } catch (err) {
            return false // also if it's invalid it's propably not matching as well so return false
            ;
        }
        const out = partialMatch(a.protoNames());
        if (out === null) return false;
        if (out === true || out === false) return out;
        return out.length === 0;
    }
    return matches;
}
/**
 * @param {Array<Mafmt | (() => Mafmt)>} args
 * @returns {Mafmt}
 */ function $c068745aecfadfe8$var$and(...args) {
    /**
   * @type {PartialMatchesFunction}
   */ function partialMatch(a) {
        if (a.length < args.length) return null;
        /** @type {boolean | string[] | null} */ let out = a;
        args.some((arg)=>{
            out = typeof arg === "function" ? arg().partialMatch(a) : arg.partialMatch(a);
            if (Array.isArray(out)) a = out;
            if (out === null) return true;
            return false;
        });
        return out;
    }
    return {
        toString: function() {
            return "{ " + args.join(" ") + " }";
        },
        input: args,
        matches: $c068745aecfadfe8$var$makeMatchesFunction(partialMatch),
        partialMatch: partialMatch
    };
}
/**
 * @param {Array<Mafmt | (() => Mafmt)>} args
 * @returns {Mafmt}
 */ function $c068745aecfadfe8$var$or(...args) {
    /**
   * @type {PartialMatchesFunction}
   */ function partialMatch(a) {
        let out = null;
        args.some((arg)=>{
            const res = typeof arg === "function" ? arg().partialMatch(a) : arg.partialMatch(a);
            if (res) {
                out = res;
                return true;
            }
            return false;
        });
        return out;
    }
    const result = {
        toString: function() {
            return "{ " + args.join(" ") + " }";
        },
        input: args,
        matches: $c068745aecfadfe8$var$makeMatchesFunction(partialMatch),
        partialMatch: partialMatch
    };
    return result;
}
/**
 * @param {string} n
 * @returns {Mafmt}
 */ function $c068745aecfadfe8$var$base(n) {
    const name = n;
    /**
   * @type {MatchesFunction}
   */ function matches(a) {
        let ma;
        if (typeof a === "string" || a instanceof Uint8Array) try {
            ma = new $c068745aecfadfe8$require$Multiaddr(a);
        } catch (err) {
            return false // also if it's invalid it's probably not matching as well so return false
            ;
        }
        else ma = a;
        const pnames = ma.protoNames();
        if (pnames.length === 1 && pnames[0] === name) return true;
        return false;
    }
    /**
   * @type {PartialMatchesFunction}
   */ function partialMatch(protos) {
        if (protos.length === 0) return null;
        if (protos[0] === name) return protos.slice(1);
        return null;
    }
    return {
        toString: function() {
            return name;
        },
        matches: matches,
        partialMatch: partialMatch
    };
}

});

parcelRequire.register("cJ5Wu", function(module, exports) {
/*eslint-disable*/ "use strict";

var $liRmU = parcelRequire("liRmU");
// Common aliases
var $943e4c07921656a9$var$$Reader = $liRmU.Reader, $943e4c07921656a9$var$$Writer = $liRmU.Writer, $943e4c07921656a9$var$$util = $liRmU.util;
// Exported root namespace
var $943e4c07921656a9$var$$root = $liRmU.roots["libp2p-circuit"] || ($liRmU.roots["libp2p-circuit"] = {});
$943e4c07921656a9$var$$root.CircuitRelay = function() {
    /**
     * Properties of a CircuitRelay.
     * @exports ICircuitRelay
     * @interface ICircuitRelay
     * @property {CircuitRelay.Type|null} [type] CircuitRelay type
     * @property {CircuitRelay.IPeer|null} [srcPeer] CircuitRelay srcPeer
     * @property {CircuitRelay.IPeer|null} [dstPeer] CircuitRelay dstPeer
     * @property {CircuitRelay.Status|null} [code] CircuitRelay code
     */ /**
     * Constructs a new CircuitRelay.
     * @exports CircuitRelay
     * @classdesc Represents a CircuitRelay.
     * @implements ICircuitRelay
     * @constructor
     * @param {ICircuitRelay=} [p] Properties to set
     */ function CircuitRelay(p) {
        if (p) {
            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }
    }
    /**
     * CircuitRelay type.
     * @member {CircuitRelay.Type} type
     * @memberof CircuitRelay
     * @instance
     */ CircuitRelay.prototype.type = 1;
    /**
     * CircuitRelay srcPeer.
     * @member {CircuitRelay.IPeer|null|undefined} srcPeer
     * @memberof CircuitRelay
     * @instance
     */ CircuitRelay.prototype.srcPeer = null;
    /**
     * CircuitRelay dstPeer.
     * @member {CircuitRelay.IPeer|null|undefined} dstPeer
     * @memberof CircuitRelay
     * @instance
     */ CircuitRelay.prototype.dstPeer = null;
    /**
     * CircuitRelay code.
     * @member {CircuitRelay.Status} code
     * @memberof CircuitRelay
     * @instance
     */ CircuitRelay.prototype.code = 100;
    /**
     * Encodes the specified CircuitRelay message. Does not implicitly {@link CircuitRelay.verify|verify} messages.
     * @function encode
     * @memberof CircuitRelay
     * @static
     * @param {ICircuitRelay} m CircuitRelay message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ CircuitRelay.encode = function encode(m, w) {
        if (!w) w = $943e4c07921656a9$var$$Writer.create();
        if (m.type != null && Object.hasOwnProperty.call(m, "type")) w.uint32(8).int32(m.type);
        if (m.srcPeer != null && Object.hasOwnProperty.call(m, "srcPeer")) $943e4c07921656a9$var$$root.CircuitRelay.Peer.encode(m.srcPeer, w.uint32(18).fork()).ldelim();
        if (m.dstPeer != null && Object.hasOwnProperty.call(m, "dstPeer")) $943e4c07921656a9$var$$root.CircuitRelay.Peer.encode(m.dstPeer, w.uint32(26).fork()).ldelim();
        if (m.code != null && Object.hasOwnProperty.call(m, "code")) w.uint32(32).int32(m.code);
        return w;
    };
    /**
     * Decodes a CircuitRelay message from the specified reader or buffer.
     * @function decode
     * @memberof CircuitRelay
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {CircuitRelay} CircuitRelay
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ CircuitRelay.decode = function decode(r, l) {
        if (!(r instanceof $943e4c07921656a9$var$$Reader)) r = $943e4c07921656a9$var$$Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l, m = new $943e4c07921656a9$var$$root.CircuitRelay();
        while(r.pos < c){
            var t = r.uint32();
            switch(t >>> 3){
                case 1:
                    m.type = r.int32();
                    break;
                case 2:
                    m.srcPeer = $943e4c07921656a9$var$$root.CircuitRelay.Peer.decode(r, r.uint32());
                    break;
                case 3:
                    m.dstPeer = $943e4c07921656a9$var$$root.CircuitRelay.Peer.decode(r, r.uint32());
                    break;
                case 4:
                    m.code = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
            }
        }
        return m;
    };
    /**
     * Creates a CircuitRelay message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CircuitRelay
     * @static
     * @param {Object.<string,*>} d Plain object
     * @returns {CircuitRelay} CircuitRelay
     */ CircuitRelay.fromObject = function fromObject(d) {
        if (d instanceof $943e4c07921656a9$var$$root.CircuitRelay) return d;
        var m = new $943e4c07921656a9$var$$root.CircuitRelay();
        switch(d.type){
            case "HOP":
            case 1:
                m.type = 1;
                break;
            case "STOP":
            case 2:
                m.type = 2;
                break;
            case "STATUS":
            case 3:
                m.type = 3;
                break;
            case "CAN_HOP":
            case 4:
                m.type = 4;
                break;
        }
        if (d.srcPeer != null) {
            if (typeof d.srcPeer !== "object") throw TypeError(".CircuitRelay.srcPeer: object expected");
            m.srcPeer = $943e4c07921656a9$var$$root.CircuitRelay.Peer.fromObject(d.srcPeer);
        }
        if (d.dstPeer != null) {
            if (typeof d.dstPeer !== "object") throw TypeError(".CircuitRelay.dstPeer: object expected");
            m.dstPeer = $943e4c07921656a9$var$$root.CircuitRelay.Peer.fromObject(d.dstPeer);
        }
        switch(d.code){
            case "SUCCESS":
            case 100:
                m.code = 100;
                break;
            case "HOP_SRC_ADDR_TOO_LONG":
            case 220:
                m.code = 220;
                break;
            case "HOP_DST_ADDR_TOO_LONG":
            case 221:
                m.code = 221;
                break;
            case "HOP_SRC_MULTIADDR_INVALID":
            case 250:
                m.code = 250;
                break;
            case "HOP_DST_MULTIADDR_INVALID":
            case 251:
                m.code = 251;
                break;
            case "HOP_NO_CONN_TO_DST":
            case 260:
                m.code = 260;
                break;
            case "HOP_CANT_DIAL_DST":
            case 261:
                m.code = 261;
                break;
            case "HOP_CANT_OPEN_DST_STREAM":
            case 262:
                m.code = 262;
                break;
            case "HOP_CANT_SPEAK_RELAY":
            case 270:
                m.code = 270;
                break;
            case "HOP_CANT_RELAY_TO_SELF":
            case 280:
                m.code = 280;
                break;
            case "STOP_SRC_ADDR_TOO_LONG":
            case 320:
                m.code = 320;
                break;
            case "STOP_DST_ADDR_TOO_LONG":
            case 321:
                m.code = 321;
                break;
            case "STOP_SRC_MULTIADDR_INVALID":
            case 350:
                m.code = 350;
                break;
            case "STOP_DST_MULTIADDR_INVALID":
            case 351:
                m.code = 351;
                break;
            case "STOP_RELAY_REFUSED":
            case 390:
                m.code = 390;
                break;
            case "MALFORMED_MESSAGE":
            case 400:
                m.code = 400;
                break;
        }
        return m;
    };
    /**
     * Creates a plain object from a CircuitRelay message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CircuitRelay
     * @static
     * @param {CircuitRelay} m CircuitRelay
     * @param {$protobuf.IConversionOptions} [o] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ CircuitRelay.toObject = function toObject(m, o) {
        if (!o) o = {};
        var d = {};
        if (o.defaults) {
            d.type = o.enums === String ? "HOP" : 1;
            d.srcPeer = null;
            d.dstPeer = null;
            d.code = o.enums === String ? "SUCCESS" : 100;
        }
        if (m.type != null && m.hasOwnProperty("type")) d.type = o.enums === String ? $943e4c07921656a9$var$$root.CircuitRelay.Type[m.type] : m.type;
        if (m.srcPeer != null && m.hasOwnProperty("srcPeer")) d.srcPeer = $943e4c07921656a9$var$$root.CircuitRelay.Peer.toObject(m.srcPeer, o);
        if (m.dstPeer != null && m.hasOwnProperty("dstPeer")) d.dstPeer = $943e4c07921656a9$var$$root.CircuitRelay.Peer.toObject(m.dstPeer, o);
        if (m.code != null && m.hasOwnProperty("code")) d.code = o.enums === String ? $943e4c07921656a9$var$$root.CircuitRelay.Status[m.code] : m.code;
        return d;
    };
    /**
     * Converts this CircuitRelay to JSON.
     * @function toJSON
     * @memberof CircuitRelay
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ CircuitRelay.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
    };
    /**
     * Status enum.
     * @name CircuitRelay.Status
     * @enum {number}
     * @property {number} SUCCESS=100 SUCCESS value
     * @property {number} HOP_SRC_ADDR_TOO_LONG=220 HOP_SRC_ADDR_TOO_LONG value
     * @property {number} HOP_DST_ADDR_TOO_LONG=221 HOP_DST_ADDR_TOO_LONG value
     * @property {number} HOP_SRC_MULTIADDR_INVALID=250 HOP_SRC_MULTIADDR_INVALID value
     * @property {number} HOP_DST_MULTIADDR_INVALID=251 HOP_DST_MULTIADDR_INVALID value
     * @property {number} HOP_NO_CONN_TO_DST=260 HOP_NO_CONN_TO_DST value
     * @property {number} HOP_CANT_DIAL_DST=261 HOP_CANT_DIAL_DST value
     * @property {number} HOP_CANT_OPEN_DST_STREAM=262 HOP_CANT_OPEN_DST_STREAM value
     * @property {number} HOP_CANT_SPEAK_RELAY=270 HOP_CANT_SPEAK_RELAY value
     * @property {number} HOP_CANT_RELAY_TO_SELF=280 HOP_CANT_RELAY_TO_SELF value
     * @property {number} STOP_SRC_ADDR_TOO_LONG=320 STOP_SRC_ADDR_TOO_LONG value
     * @property {number} STOP_DST_ADDR_TOO_LONG=321 STOP_DST_ADDR_TOO_LONG value
     * @property {number} STOP_SRC_MULTIADDR_INVALID=350 STOP_SRC_MULTIADDR_INVALID value
     * @property {number} STOP_DST_MULTIADDR_INVALID=351 STOP_DST_MULTIADDR_INVALID value
     * @property {number} STOP_RELAY_REFUSED=390 STOP_RELAY_REFUSED value
     * @property {number} MALFORMED_MESSAGE=400 MALFORMED_MESSAGE value
     */ CircuitRelay.Status = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[100] = "SUCCESS"] = 100;
        values[valuesById[220] = "HOP_SRC_ADDR_TOO_LONG"] = 220;
        values[valuesById[221] = "HOP_DST_ADDR_TOO_LONG"] = 221;
        values[valuesById[250] = "HOP_SRC_MULTIADDR_INVALID"] = 250;
        values[valuesById[251] = "HOP_DST_MULTIADDR_INVALID"] = 251;
        values[valuesById[260] = "HOP_NO_CONN_TO_DST"] = 260;
        values[valuesById[261] = "HOP_CANT_DIAL_DST"] = 261;
        values[valuesById[262] = "HOP_CANT_OPEN_DST_STREAM"] = 262;
        values[valuesById[270] = "HOP_CANT_SPEAK_RELAY"] = 270;
        values[valuesById[280] = "HOP_CANT_RELAY_TO_SELF"] = 280;
        values[valuesById[320] = "STOP_SRC_ADDR_TOO_LONG"] = 320;
        values[valuesById[321] = "STOP_DST_ADDR_TOO_LONG"] = 321;
        values[valuesById[350] = "STOP_SRC_MULTIADDR_INVALID"] = 350;
        values[valuesById[351] = "STOP_DST_MULTIADDR_INVALID"] = 351;
        values[valuesById[390] = "STOP_RELAY_REFUSED"] = 390;
        values[valuesById[400] = "MALFORMED_MESSAGE"] = 400;
        return values;
    }();
    /**
     * Type enum.
     * @name CircuitRelay.Type
     * @enum {number}
     * @property {number} HOP=1 HOP value
     * @property {number} STOP=2 STOP value
     * @property {number} STATUS=3 STATUS value
     * @property {number} CAN_HOP=4 CAN_HOP value
     */ CircuitRelay.Type = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "HOP"] = 1;
        values[valuesById[2] = "STOP"] = 2;
        values[valuesById[3] = "STATUS"] = 3;
        values[valuesById[4] = "CAN_HOP"] = 4;
        return values;
    }();
    CircuitRelay.Peer = function() {
        /**
         * Properties of a Peer.
         * @memberof CircuitRelay
         * @interface IPeer
         * @property {Uint8Array} id Peer id
         * @property {Array.<Uint8Array>|null} [addrs] Peer addrs
         */ /**
         * Constructs a new Peer.
         * @memberof CircuitRelay
         * @classdesc Represents a Peer.
         * @implements IPeer
         * @constructor
         * @param {CircuitRelay.IPeer=} [p] Properties to set
         */ function Peer(p) {
            this.addrs = [];
            if (p) {
                for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
            }
        }
        /**
         * Peer id.
         * @member {Uint8Array} id
         * @memberof CircuitRelay.Peer
         * @instance
         */ Peer.prototype.id = $943e4c07921656a9$var$$util.newBuffer([]);
        /**
         * Peer addrs.
         * @member {Array.<Uint8Array>} addrs
         * @memberof CircuitRelay.Peer
         * @instance
         */ Peer.prototype.addrs = $943e4c07921656a9$var$$util.emptyArray;
        /**
         * Encodes the specified Peer message. Does not implicitly {@link CircuitRelay.Peer.verify|verify} messages.
         * @function encode
         * @memberof CircuitRelay.Peer
         * @static
         * @param {CircuitRelay.IPeer} m Peer message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ Peer.encode = function encode(m, w) {
            if (!w) w = $943e4c07921656a9$var$$Writer.create();
            w.uint32(10).bytes(m.id);
            if (m.addrs != null && m.addrs.length) for(var i = 0; i < m.addrs.length; ++i)w.uint32(18).bytes(m.addrs[i]);
            return w;
        };
        /**
         * Decodes a Peer message from the specified reader or buffer.
         * @function decode
         * @memberof CircuitRelay.Peer
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {CircuitRelay.Peer} Peer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ Peer.decode = function decode(r, l) {
            if (!(r instanceof $943e4c07921656a9$var$$Reader)) r = $943e4c07921656a9$var$$Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $943e4c07921656a9$var$$root.CircuitRelay.Peer();
            while(r.pos < c){
                var t = r.uint32();
                switch(t >>> 3){
                    case 1:
                        m.id = r.bytes();
                        break;
                    case 2:
                        if (!(m.addrs && m.addrs.length)) m.addrs = [];
                        m.addrs.push(r.bytes());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            if (!m.hasOwnProperty("id")) throw $943e4c07921656a9$var$$util.ProtocolError("missing required 'id'", {
                instance: m
            });
            return m;
        };
        /**
         * Creates a Peer message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof CircuitRelay.Peer
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {CircuitRelay.Peer} Peer
         */ Peer.fromObject = function fromObject(d) {
            if (d instanceof $943e4c07921656a9$var$$root.CircuitRelay.Peer) return d;
            var m = new $943e4c07921656a9$var$$root.CircuitRelay.Peer();
            if (d.id != null) {
                if (typeof d.id === "string") $943e4c07921656a9$var$$util.base64.decode(d.id, m.id = $943e4c07921656a9$var$$util.newBuffer($943e4c07921656a9$var$$util.base64.length(d.id)), 0);
                else if (d.id.length) m.id = d.id;
            }
            if (d.addrs) {
                if (!Array.isArray(d.addrs)) throw TypeError(".CircuitRelay.Peer.addrs: array expected");
                m.addrs = [];
                for(var i = 0; i < d.addrs.length; ++i){
                    if (typeof d.addrs[i] === "string") $943e4c07921656a9$var$$util.base64.decode(d.addrs[i], m.addrs[i] = $943e4c07921656a9$var$$util.newBuffer($943e4c07921656a9$var$$util.base64.length(d.addrs[i])), 0);
                    else if (d.addrs[i].length) m.addrs[i] = d.addrs[i];
                }
            }
            return m;
        };
        /**
         * Creates a plain object from a Peer message. Also converts values to other types if specified.
         * @function toObject
         * @memberof CircuitRelay.Peer
         * @static
         * @param {CircuitRelay.Peer} m Peer
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ Peer.toObject = function toObject(m, o) {
            if (!o) o = {};
            var d = {};
            if (o.arrays || o.defaults) d.addrs = [];
            if (o.defaults) {
                if (o.bytes === String) d.id = "";
                else {
                    d.id = [];
                    if (o.bytes !== Array) d.id = $943e4c07921656a9$var$$util.newBuffer(d.id);
                }
            }
            if (m.id != null && m.hasOwnProperty("id")) d.id = o.bytes === String ? $943e4c07921656a9$var$$util.base64.encode(m.id, 0, m.id.length) : o.bytes === Array ? Array.prototype.slice.call(m.id) : m.id;
            if (m.addrs && m.addrs.length) {
                d.addrs = [];
                for(var j = 0; j < m.addrs.length; ++j)d.addrs[j] = o.bytes === String ? $943e4c07921656a9$var$$util.base64.encode(m.addrs[j], 0, m.addrs[j].length) : o.bytes === Array ? Array.prototype.slice.call(m.addrs[j]) : m.addrs[j];
            }
            return d;
        };
        /**
         * Converts this Peer to JSON.
         * @function toJSON
         * @memberof CircuitRelay.Peer
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ Peer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
        };
        return Peer;
    }();
    return CircuitRelay;
}();
module.exports = $943e4c07921656a9$var$$root;

});

parcelRequire.register("fgQnU", function(module, exports) {
"use strict";

var $dB93l = parcelRequire("dB93l");
var $b1e0fc260a1740ad$require$abortable = $dB93l.source;

var $jjmHV = parcelRequire("jjmHV");
const $b1e0fc260a1740ad$var$log = $jjmHV("libp2p:stream:converter");
/**
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxedStream} MuxedStream
 *
 * @typedef {Object} Timeline
 * @property {number} open - connection opening timestamp.
 * @property {number} [upgraded] - connection upgraded timestamp.
 * @property {number} [close]
 */ /**
 * Convert a duplex iterable into a MultiaddrConnection.
 * https://github.com/libp2p/interface-transport#multiaddrconnection
 *
 * @param {object} streamProperties
 * @param {MuxedStream} streamProperties.stream
 * @param {Multiaddr} streamProperties.remoteAddr
 * @param {Multiaddr} streamProperties.localAddr
 * @param {object} [options]
 * @param {AbortSignal} [options.signal]
 * @returns {import('libp2p-interfaces/src/transport/types').MultiaddrConnection}
 */ function $b1e0fc260a1740ad$var$streamToMaConnection({ stream: stream, remoteAddr: remoteAddr, localAddr: localAddr }, options = {}) {
    const { sink: sink, source: source } = stream;
    const maConn = {
        /**
     * @param {Uint8Array} source
     */ async sink (source) {
            if (options.signal) // @ts-ignore ts infers source template will be a number
            source = $b1e0fc260a1740ad$require$abortable(source, options.signal);
            try {
                await sink(source);
            } catch (err) {
                // If aborted we can safely ignore
                if (err.type !== "aborted") // If the source errored the socket will already have been destroyed by
                // toIterable.duplex(). If the socket errored it will already be
                // destroyed. There's nothing to do here except log the error & return.
                $b1e0fc260a1740ad$var$log(err);
            }
            close();
        },
        source: options.signal ? $b1e0fc260a1740ad$require$abortable(source, options.signal) : source,
        conn: stream,
        localAddr: localAddr,
        remoteAddr: remoteAddr,
        /** @type {Timeline} */ timeline: {
            open: Date.now(),
            close: undefined
        },
        close () {
            sink(new Uint8Array(0));
            return close();
        }
    };
    function close() {
        if (!maConn.timeline.close) maConn.timeline.close = Date.now();
        return Promise.resolve();
    }
    return maConn;
}
module.exports = $b1e0fc260a1740ad$var$streamToMaConnection;

});
parcelRequire.register("dB93l", function(module, exports) {

var $fFtlq = parcelRequire("fFtlq");

var $31s08 = parcelRequire("31s08");
// Wrap an iterator to make it abortable, allow cleanup when aborted via onAbort
const $9e65c0d0aedfb7a6$var$toAbortableSource = (source, signal, options)=>$9e65c0d0aedfb7a6$var$toMultiAbortableSource(source, Array.isArray(signal) ? signal : [
        {
            signal: signal,
            options: options
        }
    ]);
const $9e65c0d0aedfb7a6$var$toMultiAbortableSource = (source, signals)=>{
    source = $fFtlq(source);
    signals = signals.map(({ signal: signal, options: options })=>({
            signal: signal,
            options: options || {}
        }));
    async function* abortable() {
        let nextAbortHandler;
        const abortHandler = ()=>{
            if (nextAbortHandler) nextAbortHandler();
        };
        for (const { signal: signal } of signals)signal.addEventListener("abort", abortHandler);
        while(true){
            let result;
            try {
                for (const { signal: signal, options: options } of signals)if (signal.aborted) {
                    const { abortMessage: abortMessage, abortCode: abortCode } = options;
                    throw new $31s08(abortMessage, abortCode);
                }
                const abort = new Promise((resolve, reject)=>{
                    nextAbortHandler = ()=>{
                        const { options: options } = signals.find(({ signal: signal })=>signal.aborted);
                        const { abortMessage: abortMessage, abortCode: abortCode } = options;
                        reject(new $31s08(abortMessage, abortCode));
                    };
                });
                // Race the iterator and the abort signals
                result = await Promise.race([
                    abort,
                    source.next()
                ]);
                nextAbortHandler = null;
            } catch (err) {
                for (const { signal: signal } of signals)signal.removeEventListener("abort", abortHandler);
                // Might not have been aborted by a known signal
                const aborter = signals.find(({ signal: signal })=>signal.aborted);
                const isKnownAborter = err.type === "aborted" && aborter;
                if (isKnownAborter && aborter.options.onAbort) // Do any custom abort handling for the iterator
                await aborter.options.onAbort(source);
                // End the iterator if it is a generator
                if (typeof source.return === "function") try {
                    const p = source.return();
                    if (p instanceof Promise) p.catch((err)=>{
                        if (aborter.options.onReturnError != null) aborter.options.onReturnError(err);
                    });
                } catch (err) {
                    if (aborter.options.onReturnError != null) aborter.options.onReturnError(err);
                }
                if (isKnownAborter && aborter.options.returnOnAbort) return;
                throw err;
            }
            if (result.done) break;
            yield result.value;
        }
        for (const { signal: signal } of signals)signal.removeEventListener("abort", abortHandler);
    }
    return abortable();
};
const $9e65c0d0aedfb7a6$var$toAbortableSink = (sink, signal, options)=>$9e65c0d0aedfb7a6$var$toMultiAbortableSink(sink, Array.isArray(signal) ? signal : [
        {
            signal: signal,
            options: options
        }
    ]);
const $9e65c0d0aedfb7a6$var$toMultiAbortableSink = (sink, signals)=>(source)=>sink($9e65c0d0aedfb7a6$var$toMultiAbortableSource(source, signals));
const $9e65c0d0aedfb7a6$var$toAbortableDuplex = (duplex, signal, options)=>$9e65c0d0aedfb7a6$var$toMultiAbortableDuplex(duplex, Array.isArray(signal) ? signal : [
        {
            signal: signal,
            options: options
        }
    ]);
const $9e65c0d0aedfb7a6$var$toMultiAbortableDuplex = (duplex, signals)=>({
        sink: $9e65c0d0aedfb7a6$var$toMultiAbortableSink(duplex.sink, signals),
        source: $9e65c0d0aedfb7a6$var$toMultiAbortableSource(duplex.source, signals)
    });
module.exports = $9e65c0d0aedfb7a6$var$toAbortableSource;
module.exports.AbortError = $31s08;
module.exports.source = $9e65c0d0aedfb7a6$var$toAbortableSource;
module.exports.sink = $9e65c0d0aedfb7a6$var$toAbortableSink;
module.exports.transform = $9e65c0d0aedfb7a6$var$toAbortableSink;
module.exports.duplex = $9e65c0d0aedfb7a6$var$toAbortableDuplex;

});
parcelRequire.register("fFtlq", function(module, exports) {
// If the passed object is an (async) iterable, then get the iterator
// If it's probably an iterator already (i.e. has next function) return it
// else throw
module.exports = function getIterator(obj) {
    if (obj) {
        if (typeof obj[Symbol.iterator] === "function") return obj[Symbol.iterator]();
        if (typeof obj[Symbol.asyncIterator] === "function") return obj[Symbol.asyncIterator]();
        if (typeof obj.next === "function") return obj // probably an iterator
        ;
    }
    throw new Error("argument is not an iterator or iterable");
};

});

parcelRequire.register("31s08", function(module, exports) {
module.exports = class AbortError extends Error {
    constructor(message, code){
        super(message || "The operation was aborted");
        this.type = "aborted";
        this.code = code || "ABORT_ERR";
    }
};

});



parcelRequire.register("lSDqG", function(module, exports) {
"use strict";
module.exports = {
    relay: "/libp2p/circuit/relay/0.1.0"
};

});

parcelRequire.register("iSHLb", function(module, exports) {
"use strict";

var $7QXK1 = parcelRequire("7QXK1");
var $dbef36fa7449983f$require$EventEmitter = $7QXK1.EventEmitter;

var $aZLwC = parcelRequire("aZLwC");
var $dbef36fa7449983f$require$Multiaddr = $aZLwC.Multiaddr;
/**
 * @typedef {import('libp2p-interfaces/src/transport/types').Listener} Listener
 */ /**
 * @param {import('../')} libp2p
 * @returns {Listener} a transport listener
 */ module.exports = (libp2p)=>{
    const listeningAddrs = new Map();
    /**
   * Add swarm handler and listen for incoming connections
   *
   * @param {Multiaddr} addr
   * @returns {Promise<void>}
   */ async function listen(addr) {
        const addrString = String(addr).split("/p2p-circuit").find((a)=>a !== "");
        const relayConn = await libp2p.dial(new $dbef36fa7449983f$require$Multiaddr(addrString));
        const relayedAddr = relayConn.remoteAddr.encapsulate("/p2p-circuit");
        listeningAddrs.set(relayConn.remotePeer.toB58String(), relayedAddr);
        listener.emit("listening");
    }
    /**
   * Get fixed up multiaddrs
   *
   * NOTE: This method will grab the peers multiaddrs and expand them such that:
   *
   * a) If it's an existing /p2p-circuit address for a specific relay i.e.
   * `/ip4/0.0.0.0/tcp/0/ipfs/QmRelay/p2p-circuit` this method will expand the
   * address to `/ip4/0.0.0.0/tcp/0/ipfs/QmRelay/p2p-circuit/ipfs/QmPeer` where
   * `QmPeer` is this peers id
   * b) If it's not a /p2p-circuit address, it will encapsulate the address as a /p2p-circuit
   * addr, such when dialing over a relay with this address, it will create the circuit using
   * the encapsulated transport address. This is useful when for example, a peer should only
   * be dialed over TCP rather than any other transport
   *
   * @returns {Multiaddr[]}
   */ function getAddrs() {
        const addrs = [];
        for (const addr of listeningAddrs.values())addrs.push(addr);
        return addrs;
    }
    /** @type Listener */ const listener = Object.assign(new $dbef36fa7449983f$require$EventEmitter(), {
        close: ()=>Promise.resolve(),
        listen: listen,
        getAddrs: getAddrs
    });
    // Remove listeningAddrs when a peer disconnects
    libp2p.connectionManager.on("peer:disconnect", (connection)=>{
        const deleted = listeningAddrs.delete(connection.remotePeer.toB58String());
        if (deleted) // Announce listen addresses change
        listener.emit("close");
    });
    return listener;
};

});

parcelRequire.register("jouFB", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $e1e80ca2059d9b07$var$log = Object.assign($jjmHV("libp2p:circuit:hop"), {
    error: $jjmHV("libp2p:circuit:hop:err")
});

var $20Lm5 = parcelRequire("20Lm5");

var $ksmXv = parcelRequire("ksmXv");

var $gC38j = parcelRequire("gC38j");
var $e1e80ca2059d9b07$require$validateAddrs = $gC38j.validateAddrs;

var $9OYXJ = parcelRequire("9OYXJ");

var $cJ5Wu = parcelRequire("cJ5Wu");
var $e1e80ca2059d9b07$require$CircuitPB = $cJ5Wu.CircuitRelay;

var $d8Blz = parcelRequire("d8Blz");
var $e1e80ca2059d9b07$require$pipe = $d8Blz.pipe;

var $8yAh4 = parcelRequire("8yAh4");
var $e1e80ca2059d9b07$require$Errors = $8yAh4.codes;

var $1usg8 = parcelRequire("1usg8");
var $e1e80ca2059d9b07$require$stop = $1usg8.stop;

var $lSDqG = parcelRequire("lSDqG");
/**
 * @typedef {import('../protocol').ICircuitRelay} ICircuitRelay
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxedStream} MuxedStream
 * @typedef {import('../transport')} Transport
 */ /**
 * @typedef {Object} HopRequest
 * @property {Connection} connection
 * @property {ICircuitRelay} request
 * @property {StreamHandler} streamHandler
 * @property {Transport} circuit
 */ /**
 * @param {HopRequest} options
 * @returns {Promise<void>}
 */ async function $e1e80ca2059d9b07$var$handleHop({ connection: connection, request: request, streamHandler: streamHandler, circuit: circuit }) {
    // Ensure hop is enabled
    if (!circuit._options.hop.enabled) {
        $e1e80ca2059d9b07$var$log("HOP request received but we are not acting as a relay");
        return streamHandler.end({
            type: $e1e80ca2059d9b07$require$CircuitPB.Type.STATUS,
            code: $e1e80ca2059d9b07$require$CircuitPB.Status.HOP_CANT_SPEAK_RELAY
        });
    }
    // Validate the HOP request has the required input
    try {
        $e1e80ca2059d9b07$require$validateAddrs(request, streamHandler);
    } catch (/** @type {any} */ err) {
        return $e1e80ca2059d9b07$var$log.error("invalid hop request via peer %s", connection.remotePeer.toB58String(), err);
    }
    if (!request.dstPeer) {
        $e1e80ca2059d9b07$var$log("HOP request received but we do not receive a dstPeer");
        return;
    }
    // Get the connection to the destination (stop) peer
    const destinationPeer = new $ksmXv(request.dstPeer.id);
    const destinationConnection = circuit._connectionManager.get(destinationPeer);
    if (!destinationConnection && !circuit._options.hop.active) {
        $e1e80ca2059d9b07$var$log("HOP request received but we are not connected to the destination peer");
        return streamHandler.end({
            type: $e1e80ca2059d9b07$require$CircuitPB.Type.STATUS,
            code: $e1e80ca2059d9b07$require$CircuitPB.Status.HOP_NO_CONN_TO_DST
        });
    }
    // TODO: Handle being an active relay
    if (!destinationConnection) return;
    // Handle the incoming HOP request by performing a STOP request
    const stopRequest = {
        type: $e1e80ca2059d9b07$require$CircuitPB.Type.STOP,
        dstPeer: request.dstPeer,
        srcPeer: request.srcPeer
    };
    let destinationStream;
    try {
        destinationStream = await $e1e80ca2059d9b07$require$stop({
            connection: destinationConnection,
            request: stopRequest
        });
    } catch (/** @type {any} */ err) {
        return $e1e80ca2059d9b07$var$log.error(err);
    }
    $e1e80ca2059d9b07$var$log("hop request from %s is valid", connection.remotePeer.toB58String());
    streamHandler.write({
        type: $e1e80ca2059d9b07$require$CircuitPB.Type.STATUS,
        code: $e1e80ca2059d9b07$require$CircuitPB.Status.SUCCESS
    });
    const sourceStream = streamHandler.rest();
    // Short circuit the two streams to create the relayed connection
    return $e1e80ca2059d9b07$require$pipe(sourceStream, destinationStream, sourceStream);
}
/**
 * Performs a HOP request to a relay peer, to request a connection to another
 * peer. A new, virtual, connection will be created between the two via the relay.
 *
 * @param {object} options
 * @param {Connection} options.connection - Connection to the relay
 * @param {ICircuitRelay} options.request
 * @returns {Promise<MuxedStream>}
 */ async function $e1e80ca2059d9b07$var$hop({ connection: connection, request: request }) {
    // Create a new stream to the relay
    const { stream: stream } = await connection.newStream([
        $lSDqG.relay
    ]);
    // Send the HOP request
    const streamHandler = new $9OYXJ({
        stream: stream
    });
    streamHandler.write(request);
    const response = await streamHandler.read();
    if (!response) throw $20Lm5(new Error("HOP request had no response"), $e1e80ca2059d9b07$require$Errors.ERR_HOP_REQUEST_FAILED);
    if (response.code === $e1e80ca2059d9b07$require$CircuitPB.Status.SUCCESS) {
        $e1e80ca2059d9b07$var$log("hop request was successful");
        return streamHandler.rest();
    }
    $e1e80ca2059d9b07$var$log("hop request failed with code %d, closing stream", response.code);
    streamHandler.close();
    throw $20Lm5(new Error(`HOP request failed with code ${response.code}`), $e1e80ca2059d9b07$require$Errors.ERR_HOP_REQUEST_FAILED);
}
/**
 * Performs a CAN_HOP request to a relay peer, in order to understand its capabilities.
 *
 * @param {object} options
 * @param {Connection} options.connection - Connection to the relay
 * @returns {Promise<boolean>}
 */ async function $e1e80ca2059d9b07$var$canHop({ connection: connection }) {
    // Create a new stream to the relay
    const { stream: stream } = await connection.newStream([
        $lSDqG.relay
    ]);
    // Send the HOP request
    const streamHandler = new $9OYXJ({
        stream: stream
    });
    streamHandler.write({
        type: $e1e80ca2059d9b07$require$CircuitPB.Type.CAN_HOP
    });
    const response = await streamHandler.read();
    await streamHandler.close();
    if (!response || response.code !== $e1e80ca2059d9b07$require$CircuitPB.Status.SUCCESS) return false;
    return true;
}
/**
 * Creates an unencoded CAN_HOP response based on the Circuits configuration
 *
 * @param {Object} options
 * @param {Connection} options.connection
 * @param {StreamHandler} options.streamHandler
 * @param {Transport} options.circuit
 * @private
 */ function $e1e80ca2059d9b07$var$handleCanHop({ connection: connection, streamHandler: streamHandler, circuit: circuit }) {
    const canHop = circuit._options.hop.enabled;
    $e1e80ca2059d9b07$var$log("can hop (%s) request from %s", canHop, connection.remotePeer.toB58String());
    streamHandler.end({
        type: $e1e80ca2059d9b07$require$CircuitPB.Type.STATUS,
        code: canHop ? $e1e80ca2059d9b07$require$CircuitPB.Status.SUCCESS : $e1e80ca2059d9b07$require$CircuitPB.Status.HOP_CANT_SPEAK_RELAY
    });
}
module.exports = {
    handleHop: $e1e80ca2059d9b07$var$handleHop,
    hop: $e1e80ca2059d9b07$var$hop,
    canHop: $e1e80ca2059d9b07$var$canHop,
    handleCanHop: $e1e80ca2059d9b07$var$handleCanHop
};

});
parcelRequire.register("gC38j", function(module, exports) {
"use strict";

var $aZLwC = parcelRequire("aZLwC");
var $c182a019812cc18f$require$Multiaddr = $aZLwC.Multiaddr;

var $cJ5Wu = parcelRequire("cJ5Wu");
var $c182a019812cc18f$require$CircuitRelay = $cJ5Wu.CircuitRelay;
/**
 * @typedef {import('./stream-handler')} StreamHandler
 * @typedef {import('../protocol').ICircuitRelay} ICircuitRelay
 */ /**
 * Write a response
 *
 * @param {StreamHandler} streamHandler
 * @param {import('../protocol').CircuitRelay.Status} status
 */ function $c182a019812cc18f$var$writeResponse(streamHandler, status) {
    streamHandler.write({
        type: $c182a019812cc18f$require$CircuitRelay.Type.STATUS,
        code: status
    });
}
/**
 * Validate incomming HOP/STOP message
 *
 * @param {ICircuitRelay} msg - A CircuitRelay unencoded protobuf message
 * @param {StreamHandler} streamHandler
 */ function $c182a019812cc18f$var$validateAddrs(msg, streamHandler) {
    try {
        if (msg.dstPeer && msg.dstPeer.addrs) msg.dstPeer.addrs.forEach((addr)=>{
            return new $c182a019812cc18f$require$Multiaddr(addr);
        });
    } catch (/** @type {any} */ err) {
        $c182a019812cc18f$var$writeResponse(streamHandler, msg.type === $c182a019812cc18f$require$CircuitRelay.Type.HOP ? $c182a019812cc18f$require$CircuitRelay.Status.HOP_DST_MULTIADDR_INVALID : $c182a019812cc18f$require$CircuitRelay.Status.STOP_DST_MULTIADDR_INVALID);
        throw err;
    }
    try {
        if (msg.srcPeer && msg.srcPeer.addrs) msg.srcPeer.addrs.forEach((addr)=>{
            return new $c182a019812cc18f$require$Multiaddr(addr);
        });
    } catch (/** @type {any} */ err) {
        $c182a019812cc18f$var$writeResponse(streamHandler, msg.type === $c182a019812cc18f$require$CircuitRelay.Type.HOP ? $c182a019812cc18f$require$CircuitRelay.Status.HOP_SRC_MULTIADDR_INVALID : $c182a019812cc18f$require$CircuitRelay.Status.STOP_SRC_MULTIADDR_INVALID);
        throw err;
    }
}
module.exports = {
    validateAddrs: $c182a019812cc18f$var$validateAddrs
};

});

parcelRequire.register("9OYXJ", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $7268126897536183$var$log = Object.assign($jjmHV("libp2p:circuit:stream-handler"), {
    error: $jjmHV("libp2p:circuit:stream-handler:err")
});

var $4zeIG = parcelRequire("4zeIG");

var $l2xaW = parcelRequire("l2xaW");

var $cJ5Wu = parcelRequire("cJ5Wu");
var $7268126897536183$require$CircuitRelay = $cJ5Wu.CircuitRelay;
/**
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxedStream} MuxedStream
 * @typedef {import('../protocol').ICircuitRelay} ICircuitRelay
 */ class $7268126897536183$var$StreamHandler {
    /**
   * Create a stream handler for connection
   *
   * @class
   * @param {object} options
   * @param {MuxedStream} options.stream - A duplex iterable
   * @param {number} [options.maxLength = 4096] - max bytes length of message
   */ constructor({ stream: stream, maxLength: maxLength = 4096 }){
        this.stream = stream;
        this.shake = $l2xaW(this.stream);
        // @ts-ignore options are not optional
        this.decoder = $4zeIG.decode.fromReader(this.shake.reader, {
            maxDataLength: maxLength
        });
    }
    /**
   * Read and decode message
   *
   * @async
   */ async read() {
        const msg = await this.decoder.next();
        if (msg.value) {
            const value = $7268126897536183$require$CircuitRelay.decode(msg.value.slice());
            $7268126897536183$var$log("read message type", value.type);
            return value;
        }
        $7268126897536183$var$log("read received no value, closing stream");
        // End the stream, we didn't get data
        this.close();
    }
    /**
   * Encode and write array of buffers
   *
   * @param {ICircuitRelay} msg - An unencoded CircuitRelay protobuf message
   * @returns {void}
   */ write(msg) {
        $7268126897536183$var$log("write message type %s", msg.type);
        // @ts-ignore lp.encode expects type type 'Buffer | BufferList', not 'Uint8Array'
        this.shake.write($4zeIG.encode.single($7268126897536183$require$CircuitRelay.encode(msg).finish()));
    }
    /**
   * Return the handshake rest stream and invalidate handler
   *
   * @returns {*} A duplex iterable
   */ rest() {
        this.shake.rest();
        return this.shake.stream;
    }
    /**
   * @param {ICircuitRelay} msg - An unencoded CircuitRelay protobuf message
   */ end(msg) {
        this.write(msg);
        this.close();
    }
    /**
   * Close the stream
   *
   * @returns {void}
   */ close() {
        $7268126897536183$var$log("closing the stream");
        this.rest().sink([]);
    }
}
module.exports = $7268126897536183$var$StreamHandler;

});
parcelRequire.register("4zeIG", function(module, exports) {

$parcel$export(module.exports, "encode", () => $3535d95734e709b2$export$c564cdbbe6da493, (v) => $3535d95734e709b2$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $3535d95734e709b2$export$2f872c0f2117be69, (v) => $3535d95734e709b2$export$2f872c0f2117be69 = v);
/**
 * @typedef {import('./types').EncoderOptions} EncoderOptions
 * @typedef {import('./types').DecoderOptions} DecoderOptions
 */ var $3535d95734e709b2$export$c564cdbbe6da493;
var $3535d95734e709b2$export$2f872c0f2117be69;
var $3535d95734e709b2$export$65baf1abb81aaa5e;
var $3535d95734e709b2$export$5e108bfef3c77b69;
var $3535d95734e709b2$export$35bd9bb185645302;
var $3535d95734e709b2$export$132aee334a4012c1;
"use strict";

$3535d95734e709b2$export$c564cdbbe6da493 = (parcelRequire("c1h3l"));

$3535d95734e709b2$export$2f872c0f2117be69 = (parcelRequire("9x9Ue"));

$3535d95734e709b2$export$65baf1abb81aaa5e = (parcelRequire("aWFUd"));

$3535d95734e709b2$export$5e108bfef3c77b69 = (parcelRequire("lS9qo"));

$3535d95734e709b2$export$35bd9bb185645302 = (parcelRequire("h7Oui"));

$3535d95734e709b2$export$132aee334a4012c1 = (parcelRequire("jvFkY"));

});
parcelRequire.register("c1h3l", function(module, exports) {
"use strict";

var $l7tTk = parcelRequire("l7tTk");
var $8c02ce660fdd7b72$require$Buffer = $l7tTk.Buffer;

var $hG3ux = parcelRequire("hG3ux");

var $aWFUd = parcelRequire("aWFUd");
const $8c02ce660fdd7b72$var$MIN_POOL_SIZE = 8 // Varint.encode(Number.MAX_SAFE_INTEGER).length
;
const $8c02ce660fdd7b72$var$DEFAULT_POOL_SIZE = 10240;
/**
 * @param {import('./types').EncoderOptions} [options]
 */ function $8c02ce660fdd7b72$var$encode(options) {
    options = options || {};
    const poolSize = Math.max(options.poolSize || $8c02ce660fdd7b72$var$DEFAULT_POOL_SIZE, options.minPoolSize || $8c02ce660fdd7b72$var$MIN_POOL_SIZE);
    const encodeLength = options.lengthEncoder || $aWFUd;
    /**
   * @param {AsyncIterable<BufferList>} source
   */ const encoder = async function*(source) {
        let pool = $8c02ce660fdd7b72$require$Buffer.alloc(poolSize);
        let poolOffset = 0;
        for await (const chunk of source){
            encodeLength(chunk.length, pool, poolOffset);
            const encodedLength = pool.slice(poolOffset, poolOffset + encodeLength.bytes);
            poolOffset += encodeLength.bytes;
            if (pool.length - poolOffset < $8c02ce660fdd7b72$var$MIN_POOL_SIZE) {
                pool = $8c02ce660fdd7b72$require$Buffer.alloc(poolSize);
                poolOffset = 0;
            }
            yield new $hG3ux().append(encodedLength).append(chunk);
        // yield Buffer.concat([encodedLength, chunk])
        }
    };
    return encoder;
}
/**
 * @param {BufferList | Buffer} chunk
 * @param {import('./types').EncoderOptions} [options]
 */ $8c02ce660fdd7b72$var$encode.single = (chunk, options)=>{
    options = options || {};
    const encodeLength = options.lengthEncoder || $aWFUd;
    return new $hG3ux([
        encodeLength(chunk.length),
        chunk.slice()
    ]);
};
module.exports = $8c02ce660fdd7b72$var$encode;
module.exports.MIN_POOL_SIZE = $8c02ce660fdd7b72$var$MIN_POOL_SIZE;
module.exports.DEFAULT_POOL_SIZE = $8c02ce660fdd7b72$var$DEFAULT_POOL_SIZE;

});
parcelRequire.register("l7tTk", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $f601703821e97caf$export$a143d493d941bafc, (v) => $f601703821e97caf$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $f601703821e97caf$export$f99ded8fe4b79145, (v) => $f601703821e97caf$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $f601703821e97caf$export$a143d493d941bafc;
var $f601703821e97caf$export$e4cf37d7f6fb9e0a;
var $f601703821e97caf$export$f99ded8fe4b79145;
var $f601703821e97caf$export$599f31c3813fae4d;
"use strict";

var $lGE4R = parcelRequire("lGE4R");

var $g6rU9 = parcelRequire("g6rU9");
const $f601703821e97caf$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$f601703821e97caf$export$a143d493d941bafc = $f601703821e97caf$var$Buffer;
$f601703821e97caf$export$e4cf37d7f6fb9e0a = $f601703821e97caf$var$SlowBuffer;
$f601703821e97caf$export$f99ded8fe4b79145 = 50;
const $f601703821e97caf$var$K_MAX_LENGTH = 0x7fffffff;
$f601703821e97caf$export$599f31c3813fae4d = $f601703821e97caf$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $f601703821e97caf$var$Buffer.TYPED_ARRAY_SUPPORT = $f601703821e97caf$var$typedArraySupport();
if (!$f601703821e97caf$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $f601703821e97caf$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($f601703821e97caf$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$f601703821e97caf$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($f601703821e97caf$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$f601703821e97caf$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $f601703821e97caf$var$createBuffer(length) {
    if (length > $f601703821e97caf$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $f601703821e97caf$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $f601703821e97caf$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $f601703821e97caf$var$allocUnsafe(arg);
    }
    return $f601703821e97caf$var$from(arg, encodingOrOffset, length);
}
$f601703821e97caf$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $f601703821e97caf$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $f601703821e97caf$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $f601703821e97caf$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($f601703821e97caf$var$isInstance(value, ArrayBuffer) || value && $f601703821e97caf$var$isInstance(value.buffer, ArrayBuffer)) return $f601703821e97caf$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($f601703821e97caf$var$isInstance(value, SharedArrayBuffer) || value && $f601703821e97caf$var$isInstance(value.buffer, SharedArrayBuffer))) return $f601703821e97caf$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $f601703821e97caf$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $f601703821e97caf$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $f601703821e97caf$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $f601703821e97caf$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $f601703821e97caf$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($f601703821e97caf$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($f601703821e97caf$var$Buffer, Uint8Array);
function $f601703821e97caf$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $f601703821e97caf$var$alloc(size, fill, encoding) {
    $f601703821e97caf$var$assertSize(size);
    if (size <= 0) return $f601703821e97caf$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $f601703821e97caf$var$createBuffer(size).fill(fill, encoding) : $f601703821e97caf$var$createBuffer(size).fill(fill);
    return $f601703821e97caf$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $f601703821e97caf$var$Buffer.alloc = function(size, fill, encoding) {
    return $f601703821e97caf$var$alloc(size, fill, encoding);
};
function $f601703821e97caf$var$allocUnsafe(size) {
    $f601703821e97caf$var$assertSize(size);
    return $f601703821e97caf$var$createBuffer(size < 0 ? 0 : $f601703821e97caf$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $f601703821e97caf$var$Buffer.allocUnsafe = function(size) {
    return $f601703821e97caf$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $f601703821e97caf$var$Buffer.allocUnsafeSlow = function(size) {
    return $f601703821e97caf$var$allocUnsafe(size);
};
function $f601703821e97caf$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$f601703821e97caf$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $f601703821e97caf$var$byteLength(string, encoding) | 0;
    let buf = $f601703821e97caf$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $f601703821e97caf$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $f601703821e97caf$var$checked(array.length) | 0;
    const buf = $f601703821e97caf$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $f601703821e97caf$var$fromArrayView(arrayView) {
    if ($f601703821e97caf$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $f601703821e97caf$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $f601703821e97caf$var$fromArrayLike(arrayView);
}
function $f601703821e97caf$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $f601703821e97caf$var$Buffer.prototype);
    return buf;
}
function $f601703821e97caf$var$fromObject(obj) {
    if ($f601703821e97caf$var$Buffer.isBuffer(obj)) {
        const len = $f601703821e97caf$var$checked(obj.length) | 0;
        const buf = $f601703821e97caf$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $f601703821e97caf$var$numberIsNaN(obj.length)) return $f601703821e97caf$var$createBuffer(0);
        return $f601703821e97caf$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $f601703821e97caf$var$fromArrayLike(obj.data);
}
function $f601703821e97caf$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $f601703821e97caf$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $f601703821e97caf$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $f601703821e97caf$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $f601703821e97caf$var$Buffer.alloc(+length);
}
$f601703821e97caf$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $f601703821e97caf$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$f601703821e97caf$var$Buffer.compare = function compare(a, b) {
    if ($f601703821e97caf$var$isInstance(a, Uint8Array)) a = $f601703821e97caf$var$Buffer.from(a, a.offset, a.byteLength);
    if ($f601703821e97caf$var$isInstance(b, Uint8Array)) b = $f601703821e97caf$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$f601703821e97caf$var$Buffer.isBuffer(a) || !$f601703821e97caf$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$f601703821e97caf$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$f601703821e97caf$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $f601703821e97caf$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $f601703821e97caf$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($f601703821e97caf$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$f601703821e97caf$var$Buffer.isBuffer(buf)) buf = $f601703821e97caf$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$f601703821e97caf$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $f601703821e97caf$var$byteLength(string, encoding) {
    if ($f601703821e97caf$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $f601703821e97caf$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $f601703821e97caf$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $f601703821e97caf$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $f601703821e97caf$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$f601703821e97caf$var$Buffer.byteLength = $f601703821e97caf$var$byteLength;
function $f601703821e97caf$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $f601703821e97caf$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $f601703821e97caf$var$utf8Slice(this, start, end);
        case "ascii":
            return $f601703821e97caf$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $f601703821e97caf$var$latin1Slice(this, start, end);
        case "base64":
            return $f601703821e97caf$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $f601703821e97caf$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$f601703821e97caf$var$Buffer.prototype._isBuffer = true;
function $f601703821e97caf$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$f601703821e97caf$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$f601703821e97caf$var$swap(this, i, i + 1);
    return this;
};
$f601703821e97caf$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $f601703821e97caf$var$swap(this, i, i + 3);
        $f601703821e97caf$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$f601703821e97caf$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $f601703821e97caf$var$swap(this, i, i + 7);
        $f601703821e97caf$var$swap(this, i + 1, i + 6);
        $f601703821e97caf$var$swap(this, i + 2, i + 5);
        $f601703821e97caf$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$f601703821e97caf$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $f601703821e97caf$var$utf8Slice(this, 0, length);
    return $f601703821e97caf$var$slowToString.apply(this, arguments);
};
$f601703821e97caf$var$Buffer.prototype.toLocaleString = $f601703821e97caf$var$Buffer.prototype.toString;
$f601703821e97caf$var$Buffer.prototype.equals = function equals(b) {
    if (!$f601703821e97caf$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $f601703821e97caf$var$Buffer.compare(this, b) === 0;
};
$f601703821e97caf$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $f601703821e97caf$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($f601703821e97caf$var$customInspectSymbol) $f601703821e97caf$var$Buffer.prototype[$f601703821e97caf$var$customInspectSymbol] = $f601703821e97caf$var$Buffer.prototype.inspect;
$f601703821e97caf$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($f601703821e97caf$var$isInstance(target, Uint8Array)) target = $f601703821e97caf$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$f601703821e97caf$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $f601703821e97caf$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($f601703821e97caf$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $f601703821e97caf$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($f601703821e97caf$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $f601703821e97caf$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $f601703821e97caf$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $f601703821e97caf$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$f601703821e97caf$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$f601703821e97caf$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $f601703821e97caf$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$f601703821e97caf$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $f601703821e97caf$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $f601703821e97caf$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($f601703821e97caf$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $f601703821e97caf$var$utf8Write(buf, string, offset, length) {
    return $f601703821e97caf$var$blitBuffer($f601703821e97caf$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $f601703821e97caf$var$asciiWrite(buf, string, offset, length) {
    return $f601703821e97caf$var$blitBuffer($f601703821e97caf$var$asciiToBytes(string), buf, offset, length);
}
function $f601703821e97caf$var$base64Write(buf, string, offset, length) {
    return $f601703821e97caf$var$blitBuffer($f601703821e97caf$var$base64ToBytes(string), buf, offset, length);
}
function $f601703821e97caf$var$ucs2Write(buf, string, offset, length) {
    return $f601703821e97caf$var$blitBuffer($f601703821e97caf$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$f601703821e97caf$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $f601703821e97caf$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $f601703821e97caf$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $f601703821e97caf$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $f601703821e97caf$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $f601703821e97caf$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$f601703821e97caf$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $f601703821e97caf$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $lGE4R.fromByteArray(buf);
    else return $lGE4R.fromByteArray(buf.slice(start, end));
}
function $f601703821e97caf$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $f601703821e97caf$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $f601703821e97caf$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $f601703821e97caf$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $f601703821e97caf$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $f601703821e97caf$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $f601703821e97caf$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $f601703821e97caf$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $f601703821e97caf$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $f601703821e97caf$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $f601703821e97caf$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$f601703821e97caf$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $f601703821e97caf$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $f601703821e97caf$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$f601703821e97caf$var$Buffer.prototype.readUintLE = $f601703821e97caf$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$f601703821e97caf$var$Buffer.prototype.readUintBE = $f601703821e97caf$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$f601703821e97caf$var$Buffer.prototype.readUint8 = $f601703821e97caf$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$f601703821e97caf$var$Buffer.prototype.readUint16LE = $f601703821e97caf$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$f601703821e97caf$var$Buffer.prototype.readUint16BE = $f601703821e97caf$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$f601703821e97caf$var$Buffer.prototype.readUint32LE = $f601703821e97caf$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$f601703821e97caf$var$Buffer.prototype.readUint32BE = $f601703821e97caf$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$f601703821e97caf$var$Buffer.prototype.readBigUInt64LE = $f601703821e97caf$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $f601703821e97caf$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f601703821e97caf$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$f601703821e97caf$var$Buffer.prototype.readBigUInt64BE = $f601703821e97caf$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $f601703821e97caf$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f601703821e97caf$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$f601703821e97caf$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f601703821e97caf$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f601703821e97caf$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$f601703821e97caf$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f601703821e97caf$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f601703821e97caf$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$f601703821e97caf$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$f601703821e97caf$var$Buffer.prototype.readBigInt64LE = $f601703821e97caf$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $f601703821e97caf$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f601703821e97caf$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$f601703821e97caf$var$Buffer.prototype.readBigInt64BE = $f601703821e97caf$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $f601703821e97caf$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f601703821e97caf$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$f601703821e97caf$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, 4, this.length);
    return $g6rU9.read(this, offset, true, 23, 4);
};
$f601703821e97caf$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, 4, this.length);
    return $g6rU9.read(this, offset, false, 23, 4);
};
$f601703821e97caf$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, 8, this.length);
    return $g6rU9.read(this, offset, true, 52, 8);
};
$f601703821e97caf$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkOffset(offset, 8, this.length);
    return $g6rU9.read(this, offset, false, 52, 8);
};
function $f601703821e97caf$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$f601703821e97caf$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$f601703821e97caf$var$Buffer.prototype.writeUintLE = $f601703821e97caf$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f601703821e97caf$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f601703821e97caf$var$Buffer.prototype.writeUintBE = $f601703821e97caf$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f601703821e97caf$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f601703821e97caf$var$Buffer.prototype.writeUint8 = $f601703821e97caf$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$f601703821e97caf$var$Buffer.prototype.writeUint16LE = $f601703821e97caf$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f601703821e97caf$var$Buffer.prototype.writeUint16BE = $f601703821e97caf$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f601703821e97caf$var$Buffer.prototype.writeUint32LE = $f601703821e97caf$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$f601703821e97caf$var$Buffer.prototype.writeUint32BE = $f601703821e97caf$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $f601703821e97caf$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $f601703821e97caf$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $f601703821e97caf$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $f601703821e97caf$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$f601703821e97caf$var$Buffer.prototype.writeBigUInt64LE = $f601703821e97caf$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $f601703821e97caf$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$f601703821e97caf$var$Buffer.prototype.writeBigUInt64BE = $f601703821e97caf$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $f601703821e97caf$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$f601703821e97caf$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f601703821e97caf$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f601703821e97caf$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f601703821e97caf$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f601703821e97caf$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$f601703821e97caf$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f601703821e97caf$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f601703821e97caf$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$f601703821e97caf$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$f601703821e97caf$var$Buffer.prototype.writeBigInt64LE = $f601703821e97caf$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $f601703821e97caf$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$f601703821e97caf$var$Buffer.prototype.writeBigInt64BE = $f601703821e97caf$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $f601703821e97caf$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $f601703821e97caf$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $f601703821e97caf$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $g6rU9.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$f601703821e97caf$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $f601703821e97caf$var$writeFloat(this, value, offset, true, noAssert);
};
$f601703821e97caf$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $f601703821e97caf$var$writeFloat(this, value, offset, false, noAssert);
};
function $f601703821e97caf$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f601703821e97caf$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $g6rU9.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$f601703821e97caf$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $f601703821e97caf$var$writeDouble(this, value, offset, true, noAssert);
};
$f601703821e97caf$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $f601703821e97caf$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$f601703821e97caf$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$f601703821e97caf$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$f601703821e97caf$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$f601703821e97caf$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $f601703821e97caf$var$Buffer.isBuffer(val) ? val : $f601703821e97caf$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $f601703821e97caf$var$errors = {};
function $f601703821e97caf$var$E(sym, getMessage, Base) {
    $f601703821e97caf$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$f601703821e97caf$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$f601703821e97caf$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$f601703821e97caf$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $f601703821e97caf$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $f601703821e97caf$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $f601703821e97caf$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $f601703821e97caf$var$checkBounds(buf, offset, byteLength) {
    $f601703821e97caf$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $f601703821e97caf$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $f601703821e97caf$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $f601703821e97caf$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $f601703821e97caf$var$checkBounds(buf, offset, byteLength);
}
function $f601703821e97caf$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $f601703821e97caf$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $f601703821e97caf$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $f601703821e97caf$var$validateNumber(value, type);
        throw new $f601703821e97caf$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $f601703821e97caf$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $f601703821e97caf$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $f601703821e97caf$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $f601703821e97caf$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($f601703821e97caf$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $f601703821e97caf$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $f601703821e97caf$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $f601703821e97caf$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $f601703821e97caf$var$base64ToBytes(str) {
    return $lGE4R.toByteArray($f601703821e97caf$var$base64clean(str));
}
function $f601703821e97caf$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $f601703821e97caf$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $f601703821e97caf$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $f601703821e97caf$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $f601703821e97caf$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $f601703821e97caf$var$BufferBigIntNotDefined : fn;
}
function $f601703821e97caf$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRequire.register("lGE4R", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $fc9c9bc263ac4462$export$d622b2ad8d90c771, (v) => $fc9c9bc263ac4462$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $fc9c9bc263ac4462$export$6100ba28696e12de, (v) => $fc9c9bc263ac4462$export$6100ba28696e12de = v);
var $fc9c9bc263ac4462$export$a48f0734ac7c2329;
var $fc9c9bc263ac4462$export$d622b2ad8d90c771;
var $fc9c9bc263ac4462$export$6100ba28696e12de;
"use strict";
$fc9c9bc263ac4462$export$a48f0734ac7c2329 = $fc9c9bc263ac4462$var$byteLength;
$fc9c9bc263ac4462$export$d622b2ad8d90c771 = $fc9c9bc263ac4462$var$toByteArray;
$fc9c9bc263ac4462$export$6100ba28696e12de = $fc9c9bc263ac4462$var$fromByteArray;
var $fc9c9bc263ac4462$var$lookup = [];
var $fc9c9bc263ac4462$var$revLookup = [];
var $fc9c9bc263ac4462$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $fc9c9bc263ac4462$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $fc9c9bc263ac4462$var$i = 0, $fc9c9bc263ac4462$var$len = $fc9c9bc263ac4462$var$code.length; $fc9c9bc263ac4462$var$i < $fc9c9bc263ac4462$var$len; ++$fc9c9bc263ac4462$var$i){
    $fc9c9bc263ac4462$var$lookup[$fc9c9bc263ac4462$var$i] = $fc9c9bc263ac4462$var$code[$fc9c9bc263ac4462$var$i];
    $fc9c9bc263ac4462$var$revLookup[$fc9c9bc263ac4462$var$code.charCodeAt($fc9c9bc263ac4462$var$i)] = $fc9c9bc263ac4462$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$fc9c9bc263ac4462$var$revLookup["-".charCodeAt(0)] = 62;
$fc9c9bc263ac4462$var$revLookup["_".charCodeAt(0)] = 63;
function $fc9c9bc263ac4462$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $fc9c9bc263ac4462$var$byteLength(b64) {
    var lens = $fc9c9bc263ac4462$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $fc9c9bc263ac4462$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $fc9c9bc263ac4462$var$toByteArray(b64) {
    var tmp;
    var lens = $fc9c9bc263ac4462$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $fc9c9bc263ac4462$var$Arr($fc9c9bc263ac4462$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $fc9c9bc263ac4462$var$revLookup[b64.charCodeAt(i)] << 18 | $fc9c9bc263ac4462$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $fc9c9bc263ac4462$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $fc9c9bc263ac4462$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $fc9c9bc263ac4462$var$revLookup[b64.charCodeAt(i)] << 2 | $fc9c9bc263ac4462$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $fc9c9bc263ac4462$var$revLookup[b64.charCodeAt(i)] << 10 | $fc9c9bc263ac4462$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $fc9c9bc263ac4462$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $fc9c9bc263ac4462$var$tripletToBase64(num) {
    return $fc9c9bc263ac4462$var$lookup[num >> 18 & 0x3F] + $fc9c9bc263ac4462$var$lookup[num >> 12 & 0x3F] + $fc9c9bc263ac4462$var$lookup[num >> 6 & 0x3F] + $fc9c9bc263ac4462$var$lookup[num & 0x3F];
}
function $fc9c9bc263ac4462$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($fc9c9bc263ac4462$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $fc9c9bc263ac4462$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($fc9c9bc263ac4462$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($fc9c9bc263ac4462$var$lookup[tmp >> 2] + $fc9c9bc263ac4462$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($fc9c9bc263ac4462$var$lookup[tmp >> 10] + $fc9c9bc263ac4462$var$lookup[tmp >> 4 & 0x3F] + $fc9c9bc263ac4462$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("g6rU9", function(module, exports) {

$parcel$export(module.exports, "read", () => $bb92da279ba3c503$export$aafa59e2e03f2942, (v) => $bb92da279ba3c503$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $bb92da279ba3c503$export$68d8715fc104d294, (v) => $bb92da279ba3c503$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $bb92da279ba3c503$export$aafa59e2e03f2942;
var $bb92da279ba3c503$export$68d8715fc104d294;
$bb92da279ba3c503$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$bb92da279ba3c503$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("hG3ux", function(module, exports) {
"use strict";

var $l7tTk = parcelRequire("l7tTk");
var $cde91148b62bdbc7$require$Buffer = $l7tTk.Buffer;
const $cde91148b62bdbc7$var$symbol = Symbol.for("BufferList");
function $cde91148b62bdbc7$var$BufferList(buf) {
    if (!(this instanceof $cde91148b62bdbc7$var$BufferList)) return new $cde91148b62bdbc7$var$BufferList(buf);
    $cde91148b62bdbc7$var$BufferList._init.call(this, buf);
}
$cde91148b62bdbc7$var$BufferList._init = function _init(buf) {
    Object.defineProperty(this, $cde91148b62bdbc7$var$symbol, {
        value: true
    });
    this._bufs = [];
    this.length = 0;
    if (buf) this.append(buf);
};
$cde91148b62bdbc7$var$BufferList.prototype._new = function _new(buf) {
    return new $cde91148b62bdbc7$var$BufferList(buf);
};
$cde91148b62bdbc7$var$BufferList.prototype._offset = function _offset(offset) {
    if (offset === 0) return [
        0,
        0
    ];
    let tot = 0;
    for(let i = 0; i < this._bufs.length; i++){
        const _t = tot + this._bufs[i].length;
        if (offset < _t || i === this._bufs.length - 1) return [
            i,
            offset - tot
        ];
        tot = _t;
    }
};
$cde91148b62bdbc7$var$BufferList.prototype._reverseOffset = function(blOffset) {
    const bufferId = blOffset[0];
    let offset = blOffset[1];
    for(let i = 0; i < bufferId; i++)offset += this._bufs[i].length;
    return offset;
};
$cde91148b62bdbc7$var$BufferList.prototype.get = function get(index) {
    if (index > this.length || index < 0) return undefined;
    const offset = this._offset(index);
    return this._bufs[offset[0]][offset[1]];
};
$cde91148b62bdbc7$var$BufferList.prototype.slice = function slice(start, end) {
    if (typeof start === "number" && start < 0) start += this.length;
    if (typeof end === "number" && end < 0) end += this.length;
    return this.copy(null, 0, start, end);
};
$cde91148b62bdbc7$var$BufferList.prototype.copy = function copy(dst, dstStart, srcStart, srcEnd) {
    if (typeof srcStart !== "number" || srcStart < 0) srcStart = 0;
    if (typeof srcEnd !== "number" || srcEnd > this.length) srcEnd = this.length;
    if (srcStart >= this.length) return dst || $cde91148b62bdbc7$require$Buffer.alloc(0);
    if (srcEnd <= 0) return dst || $cde91148b62bdbc7$require$Buffer.alloc(0);
    const copy = !!dst;
    const off = this._offset(srcStart);
    const len = srcEnd - srcStart;
    let bytes = len;
    let bufoff = copy && dstStart || 0;
    let start = off[1];
    // copy/slice everything
    if (srcStart === 0 && srcEnd === this.length) {
        if (!copy) // slice, but full concat if multiple buffers
        return this._bufs.length === 1 ? this._bufs[0] : $cde91148b62bdbc7$require$Buffer.concat(this._bufs, this.length);
        // copy, need to copy individual buffers
        for(let i = 0; i < this._bufs.length; i++){
            this._bufs[i].copy(dst, bufoff);
            bufoff += this._bufs[i].length;
        }
        return dst;
    }
    // easy, cheap case where it's a subset of one of the buffers
    if (bytes <= this._bufs[off[0]].length - start) return copy ? this._bufs[off[0]].copy(dst, dstStart, start, start + bytes) : this._bufs[off[0]].slice(start, start + bytes);
    if (!copy) // a slice, we need something to copy in to
    dst = $cde91148b62bdbc7$require$Buffer.allocUnsafe(len);
    for(let i = off[0]; i < this._bufs.length; i++){
        const l = this._bufs[i].length - start;
        if (bytes > l) {
            this._bufs[i].copy(dst, bufoff, start);
            bufoff += l;
        } else {
            this._bufs[i].copy(dst, bufoff, start, start + bytes);
            bufoff += l;
            break;
        }
        bytes -= l;
        if (start) start = 0;
    }
    // safeguard so that we don't return uninitialized memory
    if (dst.length > bufoff) return dst.slice(0, bufoff);
    return dst;
};
$cde91148b62bdbc7$var$BufferList.prototype.shallowSlice = function shallowSlice(start, end) {
    start = start || 0;
    end = typeof end !== "number" ? this.length : end;
    if (start < 0) start += this.length;
    if (end < 0) end += this.length;
    if (start === end) return this._new();
    const startOffset = this._offset(start);
    const endOffset = this._offset(end);
    const buffers = this._bufs.slice(startOffset[0], endOffset[0] + 1);
    if (endOffset[1] === 0) buffers.pop();
    else buffers[buffers.length - 1] = buffers[buffers.length - 1].slice(0, endOffset[1]);
    if (startOffset[1] !== 0) buffers[0] = buffers[0].slice(startOffset[1]);
    return this._new(buffers);
};
$cde91148b62bdbc7$var$BufferList.prototype.toString = function toString(encoding, start, end) {
    return this.slice(start, end).toString(encoding);
};
$cde91148b62bdbc7$var$BufferList.prototype.consume = function consume(bytes) {
    // first, normalize the argument, in accordance with how Buffer does it
    bytes = Math.trunc(bytes);
    // do nothing if not a positive number
    if (Number.isNaN(bytes) || bytes <= 0) return this;
    while(this._bufs.length)if (bytes >= this._bufs[0].length) {
        bytes -= this._bufs[0].length;
        this.length -= this._bufs[0].length;
        this._bufs.shift();
    } else {
        this._bufs[0] = this._bufs[0].slice(bytes);
        this.length -= bytes;
        break;
    }
    return this;
};
$cde91148b62bdbc7$var$BufferList.prototype.duplicate = function duplicate() {
    const copy = this._new();
    for(let i = 0; i < this._bufs.length; i++)copy.append(this._bufs[i]);
    return copy;
};
$cde91148b62bdbc7$var$BufferList.prototype.append = function append(buf) {
    if (buf == null) return this;
    if (buf.buffer) // append a view of the underlying ArrayBuffer
    this._appendBuffer($cde91148b62bdbc7$require$Buffer.from(buf.buffer, buf.byteOffset, buf.byteLength));
    else if (Array.isArray(buf)) for(let i = 0; i < buf.length; i++)this.append(buf[i]);
    else if (this._isBufferList(buf)) // unwrap argument into individual BufferLists
    for(let i = 0; i < buf._bufs.length; i++)this.append(buf._bufs[i]);
    else {
        // coerce number arguments to strings, since Buffer(number) does
        // uninitialized memory allocation
        if (typeof buf === "number") buf = buf.toString();
        this._appendBuffer($cde91148b62bdbc7$require$Buffer.from(buf));
    }
    return this;
};
$cde91148b62bdbc7$var$BufferList.prototype._appendBuffer = function appendBuffer(buf) {
    this._bufs.push(buf);
    this.length += buf.length;
};
$cde91148b62bdbc7$var$BufferList.prototype.indexOf = function(search, offset, encoding) {
    if (encoding === undefined && typeof offset === "string") {
        encoding = offset;
        offset = undefined;
    }
    if (typeof search === "function" || Array.isArray(search)) throw new TypeError('The "value" argument must be one of type string, Buffer, BufferList, or Uint8Array.');
    else if (typeof search === "number") search = $cde91148b62bdbc7$require$Buffer.from([
        search
    ]);
    else if (typeof search === "string") search = $cde91148b62bdbc7$require$Buffer.from(search, encoding);
    else if (this._isBufferList(search)) search = search.slice();
    else if (Array.isArray(search.buffer)) search = $cde91148b62bdbc7$require$Buffer.from(search.buffer, search.byteOffset, search.byteLength);
    else if (!$cde91148b62bdbc7$require$Buffer.isBuffer(search)) search = $cde91148b62bdbc7$require$Buffer.from(search);
    offset = Number(offset || 0);
    if (isNaN(offset)) offset = 0;
    if (offset < 0) offset = this.length + offset;
    if (offset < 0) offset = 0;
    if (search.length === 0) return offset > this.length ? this.length : offset;
    const blOffset = this._offset(offset);
    let blIndex = blOffset[0] // index of which internal buffer we're working on
    ;
    let buffOffset = blOffset[1] // offset of the internal buffer we're working on
    ;
    // scan over each buffer
    for(; blIndex < this._bufs.length; blIndex++){
        const buff = this._bufs[blIndex];
        while(buffOffset < buff.length){
            const availableWindow = buff.length - buffOffset;
            if (availableWindow >= search.length) {
                const nativeSearchResult = buff.indexOf(search, buffOffset);
                if (nativeSearchResult !== -1) return this._reverseOffset([
                    blIndex,
                    nativeSearchResult
                ]);
                buffOffset = buff.length - search.length + 1 // end of native search window
                ;
            } else {
                const revOffset = this._reverseOffset([
                    blIndex,
                    buffOffset
                ]);
                if (this._match(revOffset, search)) return revOffset;
                buffOffset++;
            }
        }
        buffOffset = 0;
    }
    return -1;
};
$cde91148b62bdbc7$var$BufferList.prototype._match = function(offset, search) {
    if (this.length - offset < search.length) return false;
    for(let searchOffset = 0; searchOffset < search.length; searchOffset++){
        if (this.get(offset + searchOffset) !== search[searchOffset]) return false;
    }
    return true;
};
(function() {
    const methods = {
        readDoubleBE: 8,
        readDoubleLE: 8,
        readFloatBE: 4,
        readFloatLE: 4,
        readInt32BE: 4,
        readInt32LE: 4,
        readUInt32BE: 4,
        readUInt32LE: 4,
        readInt16BE: 2,
        readInt16LE: 2,
        readUInt16BE: 2,
        readUInt16LE: 2,
        readInt8: 1,
        readUInt8: 1,
        readIntBE: null,
        readIntLE: null,
        readUIntBE: null,
        readUIntLE: null
    };
    for(const m in methods)(function(m) {
        if (methods[m] === null) $cde91148b62bdbc7$var$BufferList.prototype[m] = function(offset, byteLength) {
            return this.slice(offset, offset + byteLength)[m](0, byteLength);
        };
        else $cde91148b62bdbc7$var$BufferList.prototype[m] = function(offset = 0) {
            return this.slice(offset, offset + methods[m])[m](0);
        };
    })(m);
})();
// Used internally by the class and also as an indicator of this object being
// a `BufferList`. It's not possible to use `instanceof BufferList` in a browser
// environment because there could be multiple different copies of the
// BufferList class and some `BufferList`s might be `BufferList`s.
$cde91148b62bdbc7$var$BufferList.prototype._isBufferList = function _isBufferList(b) {
    return b instanceof $cde91148b62bdbc7$var$BufferList || $cde91148b62bdbc7$var$BufferList.isBufferList(b);
};
$cde91148b62bdbc7$var$BufferList.isBufferList = function isBufferList(b) {
    return b != null && b[$cde91148b62bdbc7$var$symbol];
};
module.exports = $cde91148b62bdbc7$var$BufferList;

});

parcelRequire.register("aWFUd", function(module, exports) {
"use strict";

var $b7PIr = parcelRequire("b7PIr");

var $l7tTk = parcelRequire("l7tTk");
var $7f7fd3bfbbaa4f19$require$Buffer = $l7tTk.Buffer;
/**
 * Encode the passed length `value` to the `target` buffer at the given `offset`
 *
 * @type {import('./types').LengthEncoderFunction}
 */ // @ts-ignore cannot declare expected bytes property
const $7f7fd3bfbbaa4f19$var$varintEncode = (value, target, offset)=>{
    const ret = $b7PIr.encode(value, target, offset);
    $7f7fd3bfbbaa4f19$var$varintEncode.bytes = $b7PIr.encode.bytes;
    // If no target, create Buffer from returned array
    return target || $7f7fd3bfbbaa4f19$require$Buffer.from(ret);
};
module.exports = $7f7fd3bfbbaa4f19$var$varintEncode;

});


parcelRequire.register("9x9Ue", function(module, exports) {
"use strict";

var $l7tTk = parcelRequire("l7tTk");
var $6f0ee13fa5c64258$require$Buffer = $l7tTk.Buffer;

var $hG3ux = parcelRequire("hG3ux");

var $lS9qo = parcelRequire("lS9qo");
// Maximum length of the length section of the message
const $6f0ee13fa5c64258$var$MAX_LENGTH_LENGTH = 8 // Varint.encode(Number.MAX_SAFE_INTEGER).length
;
// Maximum length of the data section of the message
const $6f0ee13fa5c64258$var$MAX_DATA_LENGTH = 4194304;
const $6f0ee13fa5c64258$var$Empty = $6f0ee13fa5c64258$require$Buffer.alloc(0);
const $6f0ee13fa5c64258$var$ReadModes = {
    LENGTH: "readLength",
    DATA: "readData"
};
const $6f0ee13fa5c64258$var$ReadHandlers = {
    /**
   * @param {BufferList} chunk
   * @param {BufferList} buffer
   * @param {import('./types').ReadState | undefined} state
   * @param {import('./types').DecoderOptions} options
   * @returns {import('./types').ReadResult}
   */ [$6f0ee13fa5c64258$var$ReadModes.LENGTH]: (chunk, buffer, state, options)=>{
        // console.log(ReadModes.LENGTH, chunk.length)
        buffer = buffer.append(chunk);
        let dataLength;
        try {
            dataLength = options.lengthDecoder(buffer);
        } catch (err) {
            if (buffer.length > options.maxLengthLength) throw Object.assign(err, {
                message: "message length too long",
                code: "ERR_MSG_LENGTH_TOO_LONG"
            });
            if (err instanceof RangeError) return {
                mode: $6f0ee13fa5c64258$var$ReadModes.LENGTH,
                buffer: buffer,
                chunk: undefined,
                state: undefined,
                data: undefined
            };
            throw err;
        }
        if (dataLength > options.maxDataLength) throw Object.assign(new Error("message data too long"), {
            code: "ERR_MSG_DATA_TOO_LONG"
        });
        chunk = buffer.shallowSlice(options.lengthDecoder.bytes);
        buffer = new $hG3ux();
        if (options.onLength) options.onLength(dataLength);
        if (dataLength <= 0) {
            if (options.onData) options.onData($6f0ee13fa5c64258$var$Empty);
            return {
                mode: $6f0ee13fa5c64258$var$ReadModes.LENGTH,
                chunk: chunk,
                buffer: buffer,
                data: $6f0ee13fa5c64258$var$Empty
            };
        }
        return {
            mode: $6f0ee13fa5c64258$var$ReadModes.DATA,
            chunk: chunk,
            buffer: buffer,
            state: {
                dataLength: dataLength
            },
            data: undefined
        };
    },
    /**
   * @param {BufferList} chunk
   * @param {BufferList} buffer
   * @param {import('./types').ReadState | undefined} state
   * @param {import('./types').DecoderOptions} options
   * @returns {import('./types').ReadResult}
   */ [$6f0ee13fa5c64258$var$ReadModes.DATA]: (chunk, buffer, state, options)=>{
        // console.log(ReadModes.DATA, chunk.length)
        buffer = buffer.append(chunk);
        if (!state) throw new Error("state is required");
        if (buffer.length < state.dataLength) return {
            mode: $6f0ee13fa5c64258$var$ReadModes.DATA,
            buffer: buffer,
            state: state,
            chunk: undefined,
            data: undefined
        };
        const { dataLength: dataLength } = state;
        const data = buffer.shallowSlice(0, dataLength);
        const nextChunk = buffer.length > dataLength ? buffer.shallowSlice(dataLength) : undefined;
        buffer = new $hG3ux();
        if (options.onData) options.onData(data);
        return {
            mode: $6f0ee13fa5c64258$var$ReadModes.LENGTH,
            chunk: nextChunk,
            buffer: buffer,
            state: undefined,
            data: data
        };
    }
};
/**
 * @param {any} [options]
 */ function $6f0ee13fa5c64258$var$decode(options) {
    options = options || {};
    /**
   * @type {import('./types').DecoderOptions}
   */ const opts = {
        lengthDecoder: options.lengthDecoder || $lS9qo,
        maxLengthLength: options.maxLengthLength || $6f0ee13fa5c64258$var$MAX_LENGTH_LENGTH,
        maxDataLength: options.maxDataLength || $6f0ee13fa5c64258$var$MAX_DATA_LENGTH,
        onLength: options.onLength,
        onData: options.onData
    };
    /**
   * @param {AsyncIterable<BufferList>} source
   */ const decoder = async function*(source) {
        let buffer = new $hG3ux();
        let mode = $6f0ee13fa5c64258$var$ReadModes.LENGTH // current parsing mode
        ;
        let state // accumulated state for the current mode
        ;
        for await (const chunk of source){
            /** @type {BufferList | undefined} */ let nextChunk = chunk;
            // Each chunk may contain multiple messages - keep calling handler for the
            // current parsing mode until all handlers have consumed the chunk.
            while(nextChunk){
                const result = $6f0ee13fa5c64258$var$ReadHandlers[mode](nextChunk, buffer, state, opts);
                mode = result.mode;
                nextChunk = result.chunk;
                buffer = result.buffer;
                state = result.state;
                if (result.data) yield result.data;
            }
        }
        if (buffer.length) throw Object.assign(new Error("unexpected end of input"), {
            code: "ERR_UNEXPECTED_EOF"
        });
    };
    return decoder;
}
/**
 * @param {*} reader
 * @param {import('./types').DecoderOptions} [options]
 * @returns
 */ $6f0ee13fa5c64258$var$decode.fromReader = (reader, options)=>{
    let byteLength = 1 // Read single byte chunks until the length is known
    ;
    const varByteSource = {
        [Symbol.asyncIterator] () {
            return this;
        },
        next: async ()=>{
            try {
                return await reader.next(byteLength);
            } catch (err) {
                if (err.code === "ERR_UNDER_READ") return {
                    done: true,
                    value: null
                };
                throw err;
            } finally{
                // Reset the byteLength so we continue to check for varints
                byteLength = 1;
            }
        }
    };
    /**
   * Once the length has been parsed, read chunk for that length
   *
   * @param {number} l
   */ const onLength = (l)=>{
        byteLength = l;
    };
    return $6f0ee13fa5c64258$var$decode({
        ...options || {},
        onLength: onLength
    })(varByteSource);
};
module.exports = $6f0ee13fa5c64258$var$decode;
module.exports.MAX_LENGTH_LENGTH = $6f0ee13fa5c64258$var$MAX_LENGTH_LENGTH;
module.exports.MAX_DATA_LENGTH = $6f0ee13fa5c64258$var$MAX_DATA_LENGTH;

});
parcelRequire.register("lS9qo", function(module, exports) {
"use strict";

var $b7PIr = parcelRequire("b7PIr");

var $l7tTk = parcelRequire("l7tTk");
var $fec5f3ab87688a40$require$Buffer = $l7tTk.Buffer;
/**
 * @param {any} bl
 */ const $fec5f3ab87688a40$var$toBufferProxy = (bl)=>new Proxy({}, {
        get: (_, prop)=>{
            // @ts-ignore magic
            return prop[0] === "l" ? bl[prop] : bl.get(parseInt(prop));
        }
    });
/**
 * @type {import('./types').LengthDecoderFunction}
 */ // @ts-ignore cannot declare expected bytes property
const $fec5f3ab87688a40$var$varintDecode = (data)=>{
    const len = $b7PIr.decode($fec5f3ab87688a40$require$Buffer.isBuffer(data) ? data : $fec5f3ab87688a40$var$toBufferProxy(data));
    $fec5f3ab87688a40$var$varintDecode.bytes = $b7PIr.decode.bytes;
    return len;
};
module.exports = $fec5f3ab87688a40$var$varintDecode;

});


parcelRequire.register("h7Oui", function(module, exports) {
"use strict";

var $l7tTk = parcelRequire("l7tTk");
var $c77a40e9b8cb8604$require$Buffer = $l7tTk.Buffer;
/**
 * @param {number} value
 * @param {Buffer} target
 * @param {number} offset
 */ const $c77a40e9b8cb8604$var$int32BEEncode = (value, target, offset)=>{
    target = target || $c77a40e9b8cb8604$require$Buffer.allocUnsafe(4);
    target.writeInt32BE(value, offset);
    return target;
};
$c77a40e9b8cb8604$var$int32BEEncode.bytes = 4 // Always because fixed length
;
module.exports = $c77a40e9b8cb8604$var$int32BEEncode;

});

parcelRequire.register("jvFkY", function(module, exports) {
"use strict";
/**
 * @param {import('buffer').Buffer} data
 */ const $e340fa4c7e53095c$var$int32BEDecode = (data)=>{
    if (data.length < 4) throw RangeError("Could not decode int32BE");
    return data.readInt32BE(0);
};
$e340fa4c7e53095c$var$int32BEDecode.bytes = 4 // Always because fixed length
;
module.exports = $e340fa4c7e53095c$var$int32BEDecode;

});


parcelRequire.register("l2xaW", function(module, exports) {
"use strict";

var $hO1wl = parcelRequire("hO1wl");

var $5htNF = parcelRequire("5htNF");

var $eoOla = parcelRequire("eoOla");
// Convert a duplex stream into a reader and writer and rest stream
module.exports = (stream)=>{
    const writer = $5htNF() // Write bytes on demand to the sink
    ;
    const reader = $hO1wl(stream.source) // Read bytes on demand from the source
    ;
    // Waits for a source to be passed to the rest stream's sink
    const sourcePromise = $eoOla();
    let sinkErr;
    const sinkPromise = stream.sink(async function*() {
        yield* writer;
        const source = await sourcePromise.promise;
        yield* source;
    }());
    sinkPromise.catch((err)=>{
        sinkErr = err;
    });
    const rest = {
        sink: (source)=>{
            if (sinkErr) return Promise.reject(sinkErr);
            sourcePromise.resolve(source);
            return sinkPromise;
        },
        source: reader
    };
    return {
        reader: reader,
        writer: writer,
        stream: rest,
        rest: ()=>writer.end(),
        write: writer.push,
        read: async ()=>{
            return (await reader.next()).value;
        }
    };
};

});
parcelRequire.register("hO1wl", function(module, exports) {

var $hG3ux = parcelRequire("hG3ux");
module.exports = (source)=>{
    const reader = async function*() {
        let bytes = yield // Allows us to receive 8 when reader.next(8) is called
        ;
        let bl = new $hG3ux();
        for await (const chunk of source){
            if (!bytes) {
                bytes = yield bl.append(chunk);
                bl = new $hG3ux();
                continue;
            }
            bl.append(chunk);
            while(bl.length >= bytes){
                const data = bl.shallowSlice(0, bytes);
                bl.consume(bytes);
                bytes = yield data;
                // If we no longer want a specific byte length, we yield the rest now
                if (!bytes) {
                    if (bl.length) {
                        bytes = yield bl;
                        bl = new $hG3ux();
                    }
                    break; // bytes is null and/or no more buffer to yield
                }
            }
        }
        // Consumer wants more bytes but the source has ended and our buffer
        // is not big enough to satisfy.
        if (bytes) throw Object.assign(new Error(`stream ended before ${bytes} bytes became available`), {
            code: "ERR_UNDER_READ",
            buffer: bl
        });
    }();
    reader.next();
    return reader;
};

});

parcelRequire.register("eoOla", function(module, exports) {
"use strict";
const $a7ba5b1efe578d91$var$pDefer = ()=>{
    const deferred = {};
    deferred.promise = new Promise((resolve, reject)=>{
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
};
module.exports = $a7ba5b1efe578d91$var$pDefer;

});



parcelRequire.register("1usg8", function(module, exports) {

$parcel$export(module.exports, "handleStop", () => $115e837e52704039$export$7f52871dfaa8f3f1, (v) => $115e837e52704039$export$7f52871dfaa8f3f1 = v);
$parcel$export(module.exports, "stop", () => $115e837e52704039$export$fa6813432f753b0d, (v) => $115e837e52704039$export$fa6813432f753b0d = v);
/**
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxedStream} MuxedStream
 * @typedef {import('../protocol').ICircuitRelay} ICircuitRelay
 */ /**
 * Handles incoming STOP requests
 *
 * @private
 * @param {Object} options
 * @param {Connection} options.connection
 * @param {ICircuitRelay} options.request - The CircuitRelay protobuf request (unencoded)
 * @param {StreamHandler} options.streamHandler
 * @returns {Promise<MuxedStream>|void} Resolves a duplex iterable
 */ var $115e837e52704039$export$7f52871dfaa8f3f1;
/**
 * Creates a STOP request
 *
 * @private
 * @param {Object} options
 * @param {Connection} options.connection
 * @param {ICircuitRelay} options.request - The CircuitRelay protobuf request (unencoded)
 * @returns {Promise<MuxedStream|void>} Resolves a duplex iterable
 */ var $115e837e52704039$export$fa6813432f753b0d;
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $115e837e52704039$var$log = Object.assign($jjmHV("libp2p:circuit:stop"), {
    error: $jjmHV("libp2p:circuit:stop:err")
});

var $cJ5Wu = parcelRequire("cJ5Wu");
var $115e837e52704039$require$CircuitPB = $cJ5Wu.CircuitRelay;

var $lSDqG = parcelRequire("lSDqG");

var $9OYXJ = parcelRequire("9OYXJ");

var $gC38j = parcelRequire("gC38j");
var $115e837e52704039$require$validateAddrs = $gC38j.validateAddrs;
$115e837e52704039$export$7f52871dfaa8f3f1 = function handleStop({ connection: connection, request: request, streamHandler: streamHandler }) {
    // Validate the STOP request has the required input
    try {
        $115e837e52704039$require$validateAddrs(request, streamHandler);
    } catch (/** @type {any} */ err) {
        return $115e837e52704039$var$log.error("invalid stop request via peer %s", connection.remotePeer.toB58String(), err);
    }
    // The request is valid
    $115e837e52704039$var$log("stop request is valid");
    streamHandler.write({
        type: $115e837e52704039$require$CircuitPB.Type.STATUS,
        code: $115e837e52704039$require$CircuitPB.Status.SUCCESS
    });
    return streamHandler.rest();
};
$115e837e52704039$export$fa6813432f753b0d = async function stop({ connection: connection, request: request }) {
    const { stream: stream } = await connection.newStream([
        $lSDqG.relay
    ]);
    $115e837e52704039$var$log("starting stop request to %s", connection.remotePeer.toB58String());
    const streamHandler = new $9OYXJ({
        stream: stream
    });
    streamHandler.write(request);
    const response = await streamHandler.read();
    if (!response) return streamHandler.close();
    if (response.code === $115e837e52704039$require$CircuitPB.Status.SUCCESS) {
        $115e837e52704039$var$log("stop request to %s was successful", connection.remotePeer.toB58String());
        return streamHandler.rest();
    }
    $115e837e52704039$var$log("stop request failed with code %d", response.code);
    streamHandler.close();
};

});



parcelRequire.register("ku8FQ", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $ee9d56748faedbcf$var$log = Object.assign($jjmHV("libp2p:relay"), {
    error: $jjmHV("libp2p:relay:err")
});

var $8yAh4 = parcelRequire("8yAh4");
var $ee9d56748faedbcf$require$codes = $8yAh4.codes;

var $GP82a = parcelRequire("GP82a");
var $ee9d56748faedbcf$require$setDelayedInterval = $GP82a.setDelayedInterval;
var $ee9d56748faedbcf$require$clearDelayedInterval = $GP82a.clearDelayedInterval;

var $dLGxN = parcelRequire("dLGxN");

var $gASbM = parcelRequire("gASbM");
var $ee9d56748faedbcf$require$namespaceToCid = $gASbM.namespaceToCid;

var $9gQk1 = parcelRequire("9gQk1");
var $ee9d56748faedbcf$require$RELAY_RENDEZVOUS_NS = $9gQk1.RELAY_RENDEZVOUS_NS;
/**
 * @typedef {import('../')} Libp2p
 *
 * @typedef {Object} RelayAdvertiseOptions
 * @property {number} [bootDelay = ADVERTISE_BOOT_DELAY]
 * @property {boolean} [enabled = true]
 * @property {number} [ttl = ADVERTISE_TTL]
 *
 * @typedef {Object} HopOptions
 * @property {boolean} [enabled = false]
 * @property {boolean} [active = false]
 *
 * @typedef {Object} AutoRelayOptions
 * @property {number} [maxListeners = 2] - maximum number of relays to listen.
 * @property {boolean} [enabled = false]
 */ class $ee9d56748faedbcf$var$Relay {
    /**
   * Creates an instance of Relay.
   *
   * @class
   * @param {Libp2p} libp2p
   */ constructor(libp2p){
        this._libp2p = libp2p;
        this._options = {
            ...libp2p._config.relay
        };
        // Create autoRelay if enabled
        this._autoRelay = this._options.autoRelay.enabled && new $dLGxN({
            libp2p: libp2p,
            ...this._options.autoRelay
        });
        this._advertiseService = this._advertiseService.bind(this);
    }
    /**
   * Start Relay service.
   *
   * @returns {void}
   */ start() {
        // Advertise service if HOP enabled
        const canHop = this._options.hop.enabled;
        if (canHop && this._options.advertise.enabled) this._timeout = $ee9d56748faedbcf$require$setDelayedInterval(this._advertiseService, this._options.advertise.ttl, this._options.advertise.bootDelay);
    }
    /**
   * Stop Relay service.
   *
   * @returns {void}
   */ stop() {
        $ee9d56748faedbcf$require$clearDelayedInterval(this._timeout);
    }
    /**
   * Advertise hop relay service in the network.
   *
   * @returns {Promise<void>}
   */ async _advertiseService() {
        try {
            const cid = await $ee9d56748faedbcf$require$namespaceToCid($ee9d56748faedbcf$require$RELAY_RENDEZVOUS_NS);
            await this._libp2p.contentRouting.provide(cid);
        } catch (/** @type {any} */ err) {
            if (err.code === $ee9d56748faedbcf$require$codes.ERR_NO_ROUTERS_AVAILABLE) {
                $ee9d56748faedbcf$var$log.error("a content router, such as a DHT, must be provided in order to advertise the relay service", err);
                // Stop the advertise
                this.stop();
            } else $ee9d56748faedbcf$var$log.error(err);
        }
    }
}
module.exports = $ee9d56748faedbcf$var$Relay;

});
parcelRequire.register("dLGxN", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $a060aa80caae7279$var$log = Object.assign($jjmHV("libp2p:auto-relay"), {
    error: $jjmHV("libp2p:auto-relay:err")
});

var $8cWjP = parcelRequire("8cWjP");
var $a060aa80caae7279$require$uint8ArrayFromString = $8cWjP.fromString;

var $6rBCs = parcelRequire("6rBCs");
var $a060aa80caae7279$require$uint8ArrayToString = $6rBCs.toString;

var $aZLwC = parcelRequire("aZLwC");
var $a060aa80caae7279$require$Multiaddr = $aZLwC.Multiaddr;

var $ksmXv = parcelRequire("ksmXv");

var $lSDqG = parcelRequire("lSDqG");
var $a060aa80caae7279$require$multicodec = $lSDqG.relay;

var $jouFB = parcelRequire("jouFB");
var $a060aa80caae7279$require$canHop = $jouFB.canHop;

var $gASbM = parcelRequire("gASbM");
var $a060aa80caae7279$require$namespaceToCid = $gASbM.namespaceToCid;

var $9gQk1 = parcelRequire("9gQk1");
var $a060aa80caae7279$require$CIRCUIT_PROTO_CODE = $9gQk1.CIRCUIT_PROTO_CODE;
var $a060aa80caae7279$require$HOP_METADATA_KEY = $9gQk1.HOP_METADATA_KEY;
var $a060aa80caae7279$require$HOP_METADATA_VALUE = $9gQk1.HOP_METADATA_VALUE;
var $a060aa80caae7279$require$RELAY_RENDEZVOUS_NS = $9gQk1.RELAY_RENDEZVOUS_NS;
/**
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('../peer-store/address-book').Address} Address
 */ /**
 * @typedef {Object} AutoRelayProperties
 * @property {import('../')} libp2p
 *
 * @typedef {Object} AutoRelayOptions
 * @property {number} [maxListeners = 1] - maximum number of relays to listen.
 * @property {(error: Error, msg?: string) => {}} [onError]
 */ class $a060aa80caae7279$var$AutoRelay {
    /**
   * Creates an instance of AutoRelay.
   *
   * @class
   * @param {AutoRelayProperties & AutoRelayOptions} props
   */ constructor({ libp2p: libp2p, maxListeners: maxListeners = 1, onError: onError }){
        this._libp2p = libp2p;
        this._peerId = libp2p.peerId;
        this._peerStore = libp2p.peerStore;
        this._connectionManager = libp2p.connectionManager;
        this._transportManager = libp2p.transportManager;
        this._addressSorter = libp2p.dialer.addressSorter;
        this.maxListeners = maxListeners;
        /**
     * @type {Set<string>}
     */ this._listenRelays = new Set();
        this._onProtocolChange = this._onProtocolChange.bind(this);
        this._onPeerDisconnected = this._onPeerDisconnected.bind(this);
        this._peerStore.on("change:protocols", this._onProtocolChange);
        this._connectionManager.on("peer:disconnect", this._onPeerDisconnected);
        /**
     * @param {Error} error
     * @param {string} [msg]
     */ this._onError = (error, msg)=>{
            $a060aa80caae7279$var$log.error(msg || error);
            onError && onError(error, msg);
        };
    }
    /**
   * Check if a peer supports the relay protocol.
   * If the protocol is not supported, check if it was supported before and remove it as a listen relay.
   * If the protocol is supported, check if the peer supports **HOP** and add it as a listener if
   * inside the threshold.
   *
   * @param {Object} props
   * @param {PeerId} props.peerId
   * @param {string[]} props.protocols
   * @returns {Promise<void>}
   */ async _onProtocolChange({ peerId: peerId, protocols: protocols }) {
        const id = peerId.toB58String();
        // Check if it has the protocol
        const hasProtocol = protocols.find((protocol)=>protocol === $a060aa80caae7279$require$multicodec);
        // If no protocol, check if we were keeping the peer before as a listenRelay
        if (!hasProtocol && this._listenRelays.has(id)) {
            this._removeListenRelay(id);
            return;
        } else if (!hasProtocol || this._listenRelays.has(id)) return;
        // If protocol, check if can hop, store info in the metadataBook and listen on it
        try {
            const connection = this._connectionManager.get(peerId);
            if (!connection) return;
            // Do not hop on a relayed connection
            if (connection.remoteAddr.protoCodes().includes($a060aa80caae7279$require$CIRCUIT_PROTO_CODE)) {
                $a060aa80caae7279$var$log(`relayed connection to ${id} will not be used to hop on`);
                return;
            }
            const supportsHop = await $a060aa80caae7279$require$canHop({
                connection: connection
            });
            if (supportsHop) {
                this._peerStore.metadataBook.set(peerId, $a060aa80caae7279$require$HOP_METADATA_KEY, $a060aa80caae7279$require$uint8ArrayFromString($a060aa80caae7279$require$HOP_METADATA_VALUE));
                await this._addListenRelay(connection, id);
            }
        } catch (/** @type {any} */ err) {
            this._onError(err);
        }
    }
    /**
   * Peer disconnects.
   *
   * @param {Connection} connection - connection to the peer
   * @returns {void}
   */ _onPeerDisconnected(connection) {
        const peerId = connection.remotePeer;
        const id = peerId.toB58String();
        // Not listening on this relay
        if (!this._listenRelays.has(id)) return;
        this._removeListenRelay(id);
    }
    /**
   * Attempt to listen on the given relay connection.
   *
   * @private
   * @param {Connection} connection - connection to the peer
   * @param {string} id - peer identifier string
   * @returns {Promise<void>}
   */ async _addListenRelay(connection, id) {
        // Check if already listening on enough relays
        if (this._listenRelays.size >= this.maxListeners) return;
        // Get peer known addresses and sort them per public addresses first
        const remoteAddrs = this._peerStore.addressBook.getMultiaddrsForPeer(connection.remotePeer, this._addressSorter);
        if (!remoteAddrs || !remoteAddrs.length) return;
        const listenAddr = `${remoteAddrs[0].toString()}/p2p-circuit`;
        this._listenRelays.add(id);
        // Attempt to listen on relay
        try {
            await this._transportManager.listen([
                new $a060aa80caae7279$require$Multiaddr(listenAddr)
            ]);
        // Announce multiaddrs will update on listen success by TransportManager event being triggered
        } catch (/** @type {any} */ err) {
            this._onError(err);
            this._listenRelays.delete(id);
        }
    }
    /**
   * Remove listen relay.
   *
   * @private
   * @param {string} id - peer identifier string.
   * @returns {void}
   */ _removeListenRelay(id) {
        if (this._listenRelays.delete(id)) // TODO: this should be responsibility of the connMgr
        this._listenOnAvailableHopRelays([
            id
        ]);
    }
    /**
   * Try to listen on available hop relay connections.
   * The following order will happen while we do not have enough relays.
   * 1. Check the metadata store for known relays, try to listen on the ones we are already connected.
   * 2. Dial and try to listen on the peers we know that support hop but are not connected.
   * 3. Search the network.
   *
   * @param {string[]} [peersToIgnore]
   * @returns {Promise<void>}
   */ async _listenOnAvailableHopRelays(peersToIgnore = []) {
        // TODO: The peer redial issue on disconnect should be handled by connection gating
        // Check if already listening on enough relays
        if (this._listenRelays.size >= this.maxListeners) return;
        const knownHopsToDial = [];
        // Check if we have known hop peers to use and attempt to listen on the already connected
        for (const [id, metadataMap] of this._peerStore.metadataBook.data.entries()){
            // Continue to next if listening on this or peer to ignore
            if (this._listenRelays.has(id) || peersToIgnore.includes(id)) continue;
            const supportsHop = metadataMap.get($a060aa80caae7279$require$HOP_METADATA_KEY);
            // Continue to next if it does not support Hop
            if (!supportsHop || $a060aa80caae7279$require$uint8ArrayToString(supportsHop) !== $a060aa80caae7279$require$HOP_METADATA_VALUE) continue;
            const peerId = $ksmXv.createFromB58String(id);
            const connection = this._connectionManager.get(peerId);
            // If not connected, store for possible later use.
            if (!connection) {
                knownHopsToDial.push(peerId);
                continue;
            }
            await this._addListenRelay(connection, id);
            // Check if already listening on enough relays
            if (this._listenRelays.size >= this.maxListeners) return;
        }
        // Try to listen on known peers that are not connected
        for (const peerId of knownHopsToDial){
            await this._tryToListenOnRelay(peerId);
            // Check if already listening on enough relays
            if (this._listenRelays.size >= this.maxListeners) return;
        }
        // Try to find relays to hop on the network
        try {
            const cid = await $a060aa80caae7279$require$namespaceToCid($a060aa80caae7279$require$RELAY_RENDEZVOUS_NS);
            for await (const provider of this._libp2p.contentRouting.findProviders(cid)){
                if (!provider.multiaddrs.length) continue;
                const peerId = provider.id;
                this._peerStore.addressBook.add(peerId, provider.multiaddrs);
                await this._tryToListenOnRelay(peerId);
                // Check if already listening on enough relays
                if (this._listenRelays.size >= this.maxListeners) return;
            }
        } catch (/** @type {any} */ err) {
            this._onError(err);
        }
    }
    /**
   * @param {PeerId} peerId
   */ async _tryToListenOnRelay(peerId) {
        try {
            const connection = await this._libp2p.dial(peerId);
            await this._addListenRelay(connection, peerId.toB58String());
        } catch (/** @type {any} */ err) {
            this._onError(err, `could not connect and listen on known hop relay ${peerId.toB58String()}`);
        }
    }
}
module.exports = $a060aa80caae7279$var$AutoRelay;

});
parcelRequire.register("gASbM", function(module, exports) {

$parcel$export(module.exports, "namespaceToCid", () => $c14a0af2ed15e8f2$export$1ea0a8d17508721, (v) => $c14a0af2ed15e8f2$export$1ea0a8d17508721 = v);
/**
 * Convert a namespace string into a cid.
 *
 * @param {string} namespace
 * @returns {Promise<CID>}
 */ var $c14a0af2ed15e8f2$export$1ea0a8d17508721;
"use strict";

var $1uqWk = parcelRequire("1uqWk");
var $c14a0af2ed15e8f2$require$CID = $1uqWk.CID;

var $gTOvd = parcelRequire("gTOvd");
var $c14a0af2ed15e8f2$require$sha256 = $gTOvd.sha256;
$c14a0af2ed15e8f2$export$1ea0a8d17508721 = async (namespace)=>{
    const bytes = new TextEncoder().encode(namespace);
    const hash = await $c14a0af2ed15e8f2$require$sha256.digest(bytes);
    return $c14a0af2ed15e8f2$require$CID.createV0(hash);
};

});



parcelRequire.register("dGANx", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $9f6bbdeed36edec4$var$log = Object.assign($jjmHV("libp2p:dialer"), {
    error: $jjmHV("libp2p:dialer:err")
});

var $20Lm5 = parcelRequire("20Lm5");

var $aZLwC = parcelRequire("aZLwC");
var $9f6bbdeed36edec4$require$Multiaddr = $aZLwC.Multiaddr;

var $bNgl1 = parcelRequire("bNgl1");
var $9f6bbdeed36edec4$require$TimeoutController = $bNgl1.TimeoutController;

var $dB93l = parcelRequire("dB93l");
var $9f6bbdeed36edec4$require$AbortError = $dB93l.AbortError;

var $61ajt = parcelRequire("61ajt");
var $9f6bbdeed36edec4$require$anySignal = $61ajt.anySignal;

var $7QXK1 = parcelRequire("7QXK1");
var $9f6bbdeed36edec4$require$setMaxListeners = $7QXK1.setMaxListeners;

var $gYviB = parcelRequire("gYviB");

var $lFIT7 = parcelRequire("lFIT7");
var $9f6bbdeed36edec4$require$publicAddressesFirst = $lFIT7.publicAddressesFirst;

var $gbbbW = parcelRequire("gbbbW");

var $7A6cy = parcelRequire("7A6cy");

var $8yAh4 = parcelRequire("8yAh4");
var $9f6bbdeed36edec4$require$codes = $8yAh4.codes;

var $h6RaR = parcelRequire("h6RaR");
var $9f6bbdeed36edec4$require$DIAL_TIMEOUT = $h6RaR.DIAL_TIMEOUT;
var $9f6bbdeed36edec4$require$MAX_PARALLEL_DIALS = $h6RaR.MAX_PARALLEL_DIALS;
var $9f6bbdeed36edec4$require$MAX_PER_PEER_DIALS = $h6RaR.MAX_PER_PEER_DIALS;
var $9f6bbdeed36edec4$require$MAX_ADDRS_TO_DIAL = $h6RaR.MAX_ADDRS_TO_DIAL;
const $9f6bbdeed36edec4$var$METRICS_COMPONENT = "dialler";
const $9f6bbdeed36edec4$var$METRICS_PENDING_DIALS = "pending-dials";
const $9f6bbdeed36edec4$var$METRICS_PENDING_DIAL_TARGETS = "pending-dial-targets";
/**
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('../peer-store')} PeerStore
 * @typedef {import('../peer-store/address-book').Address} Address
 * @typedef {import('../transport-manager')} TransportManager
 */ /**
 * @typedef {Object} DialerProperties
 * @property {PeerStore} peerStore
 * @property {TransportManager} transportManager
 *
 * @typedef {(addr:Multiaddr) => Promise<string[]>} Resolver
 *
 * @typedef {Object} DialerOptions
 * @property {(addresses: Address[]) => Address[]} [options.addressSorter = publicAddressesFirst] - Sort the known addresses of a peer before trying to dial.
 * @property {number} [maxParallelDials = MAX_PARALLEL_DIALS] - Number of max concurrent dials.
 * @property {number} [maxAddrsToDial = MAX_ADDRS_TO_DIAL] - Number of max addresses to dial for a given peer.
 * @property {number} [maxDialsPerPeer = MAX_PER_PEER_DIALS] - Number of max concurrent dials per peer.
 * @property {number} [dialTimeout = DIAL_TIMEOUT] - How long a dial attempt is allowed to take.
 * @property {Record<string, Resolver>} [resolvers = {}] - multiaddr resolvers to use when dialing
 * @property {import('../metrics')} [metrics]
 *
 * @typedef DialTarget
 * @property {string} id
 * @property {Multiaddr[]} addrs
 *
 * @typedef PendingDial
 * @property {import('./dial-request')} dialRequest
 * @property {import('timeout-abort-controller').TimeoutController} controller
 * @property {Promise<Connection>} promise
 * @property {function():void} destroy
 */ class $9f6bbdeed36edec4$var$Dialer {
    /**
   * @class
   * @param {DialerProperties & DialerOptions} options
   */ constructor({ transportManager: transportManager, peerStore: peerStore, addressSorter: addressSorter = $9f6bbdeed36edec4$require$publicAddressesFirst, maxParallelDials: maxParallelDials = $9f6bbdeed36edec4$require$MAX_PARALLEL_DIALS, maxAddrsToDial: maxAddrsToDial = $9f6bbdeed36edec4$require$MAX_ADDRS_TO_DIAL, dialTimeout: dialTimeout = $9f6bbdeed36edec4$require$DIAL_TIMEOUT, maxDialsPerPeer: maxDialsPerPeer = $9f6bbdeed36edec4$require$MAX_PER_PEER_DIALS, resolvers: resolvers = {}, metrics: metrics }){
        this.transportManager = transportManager;
        this.peerStore = peerStore;
        this.addressSorter = addressSorter;
        this.maxParallelDials = maxParallelDials;
        this.maxAddrsToDial = maxAddrsToDial;
        this.timeout = dialTimeout;
        this.maxDialsPerPeer = maxDialsPerPeer;
        this.tokens = [
            ...new Array(maxParallelDials)
        ].map((_, index)=>index);
        /** @type {Map<string, PendingDial>} */ this._pendingDials = $7A6cy($9f6bbdeed36edec4$var$METRICS_COMPONENT, $9f6bbdeed36edec4$var$METRICS_PENDING_DIALS, metrics);
        /** @type {Map<string, { resolve: (value: any) => void, reject: (err: Error) => void}>} */ this._pendingDialTargets = $7A6cy($9f6bbdeed36edec4$var$METRICS_COMPONENT, $9f6bbdeed36edec4$var$METRICS_PENDING_DIAL_TARGETS, metrics);
        for (const [key, value] of Object.entries(resolvers))$9f6bbdeed36edec4$require$Multiaddr.resolvers.set(key, value);
    }
    /**
   * Clears any pending dials
   */ destroy() {
        for (const dial of this._pendingDials.values())try {
            dial.controller.abort();
        } catch (/** @type {any} */ err) {
            $9f6bbdeed36edec4$var$log.error(err);
        }
        this._pendingDials.clear();
        for (const pendingTarget of this._pendingDialTargets.values())pendingTarget.reject(new $9f6bbdeed36edec4$require$AbortError("Dialer was destroyed"));
        this._pendingDialTargets.clear();
    }
    /**
   * Connects to a given `peer` by dialing all of its known addresses.
   * The dial to the first address that is successfully able to upgrade a connection
   * will be used.
   *
   * @param {PeerId|Multiaddr|string} peer - The peer to dial
   * @param {object} [options]
   * @param {AbortSignal} [options.signal] - An AbortController signal
   * @returns {Promise<Connection>}
   */ async connectToPeer(peer, options = {}) {
        const dialTarget = await this._createCancellableDialTarget(peer);
        if (!dialTarget.addrs.length) throw $20Lm5(new Error("The dial request has no valid addresses"), $9f6bbdeed36edec4$require$codes.ERR_NO_VALID_ADDRESSES);
        const pendingDial = this._pendingDials.get(dialTarget.id) || this._createPendingDial(dialTarget, options);
        try {
            const connection = await pendingDial.promise;
            $9f6bbdeed36edec4$var$log("dial succeeded to %s", dialTarget.id);
            return connection;
        } catch (/** @type {any} */ err) {
            // Error is a timeout
            if (pendingDial.controller.signal.aborted) err.code = $9f6bbdeed36edec4$require$codes.ERR_TIMEOUT;
            $9f6bbdeed36edec4$var$log.error(err);
            throw err;
        } finally{
            pendingDial.destroy();
        }
    }
    /**
   * Connects to a given `peer` by dialing all of its known addresses.
   * The dial to the first address that is successfully able to upgrade a connection
   * will be used.
   *
   * @param {PeerId|Multiaddr|string} peer - The peer to dial
   * @returns {Promise<DialTarget>}
   */ async _createCancellableDialTarget(peer) {
        // Make dial target promise cancellable
        const id = `${parseInt(String(Math.random() * 1e9), 10).toString() + Date.now()}`;
        const cancellablePromise = new Promise((resolve, reject)=>{
            this._pendingDialTargets.set(id, {
                resolve: resolve,
                reject: reject
            });
        });
        try {
            const dialTarget = await Promise.race([
                this._createDialTarget(peer),
                cancellablePromise
            ]);
            return dialTarget;
        } finally{
            this._pendingDialTargets.delete(id);
        }
    }
    /**
   * Creates a DialTarget. The DialTarget is used to create and track
   * the DialRequest to a given peer.
   * If a multiaddr is received it should be the first address attempted.
   * Multiaddrs not supported by the available transports will be filtered out.
   *
   * @private
   * @param {PeerId|Multiaddr|string} peer - A PeerId or Multiaddr
   * @returns {Promise<DialTarget>}
   */ async _createDialTarget(peer) {
        const { id: id, multiaddrs: multiaddrs } = $gbbbW(peer);
        if (multiaddrs) this.peerStore.addressBook.add(id, multiaddrs);
        let knownAddrs = this.peerStore.addressBook.getMultiaddrsForPeer(id, this.addressSorter) || [];
        // If received a multiaddr to dial, it should be the first to use
        // But, if we know other multiaddrs for the peer, we should try them too.
        if ($9f6bbdeed36edec4$require$Multiaddr.isMultiaddr(peer)) {
            knownAddrs = knownAddrs.filter((addr)=>!peer.equals(addr));
            knownAddrs.unshift(peer);
        }
        /** @type {Multiaddr[]} */ const addrs = [];
        for (const a of knownAddrs){
            const resolvedAddrs = await this._resolve(a);
            resolvedAddrs.forEach((ra)=>addrs.push(ra));
        }
        // Multiaddrs not supported by the available transports will be filtered out.
        const supportedAddrs = addrs.filter((a)=>this.transportManager.transportForMultiaddr(a));
        if (supportedAddrs.length > this.maxAddrsToDial) {
            this.peerStore.delete(id);
            throw $20Lm5(new Error("dial with more addresses than allowed"), $9f6bbdeed36edec4$require$codes.ERR_TOO_MANY_ADDRESSES);
        }
        return {
            id: id.toB58String(),
            addrs: supportedAddrs
        };
    }
    /**
   * Creates a PendingDial that wraps the underlying DialRequest
   *
   * @private
   * @param {DialTarget} dialTarget
   * @param {object} [options]
   * @param {AbortSignal} [options.signal] - An AbortController signal
   * @returns {PendingDial}
   */ _createPendingDial(dialTarget, options = {}) {
        /**
     * @param {Multiaddr} addr
     * @param {{ signal: { aborted: any; }; }} options
     */ const dialAction = (addr, options)=>{
            if (options.signal.aborted) throw $20Lm5(new Error("already aborted"), $9f6bbdeed36edec4$require$codes.ERR_ALREADY_ABORTED);
            return this.transportManager.dial(addr, options);
        };
        const dialRequest = new $gYviB({
            addrs: dialTarget.addrs,
            dialAction: dialAction,
            dialer: this
        });
        // Combine the timeout signal and options.signal, if provided
        const timeoutController = new $9f6bbdeed36edec4$require$TimeoutController(this.timeout);
        const signals = [
            timeoutController.signal
        ];
        options.signal && signals.push(options.signal);
        const signal = $9f6bbdeed36edec4$require$anySignal(signals);
        // this signal will potentially be used while dialing lots of
        // peers so prevent MaxListenersExceededWarning appearing in the console
        $9f6bbdeed36edec4$require$setMaxListeners && $9f6bbdeed36edec4$require$setMaxListeners(Infinity, signal);
        const pendingDial = {
            dialRequest: dialRequest,
            controller: timeoutController,
            promise: dialRequest.run({
                ...options,
                signal: signal
            }),
            destroy: ()=>{
                timeoutController.clear();
                this._pendingDials.delete(dialTarget.id);
            }
        };
        this._pendingDials.set(dialTarget.id, pendingDial);
        return pendingDial;
    }
    /**
   * @param {number} num
   */ getTokens(num) {
        const total = Math.min(num, this.maxDialsPerPeer, this.tokens.length);
        const tokens = this.tokens.splice(0, total);
        $9f6bbdeed36edec4$var$log("%d tokens request, returning %d, %d remaining", num, total, this.tokens.length);
        return tokens;
    }
    /**
   * @param {number} token
   */ releaseToken(token) {
        // Guard against duplicate releases
        if (this.tokens.indexOf(token) > -1) return;
        $9f6bbdeed36edec4$var$log("token %d released", token);
        this.tokens.push(token);
    }
    /**
   * Resolve multiaddr recursively.
   *
   * @param {Multiaddr} ma
   * @returns {Promise<Multiaddr[]>}
   */ async _resolve(ma) {
        // TODO: recursive logic should live in multiaddr once dns4/dns6 support is in place
        // Now only supporting resolve for dnsaddr
        const resolvableProto = ma.protoNames().includes("dnsaddr");
        // Multiaddr is not resolvable? End recursion!
        if (!resolvableProto) return [
            ma
        ];
        const resolvedMultiaddrs = await this._resolveRecord(ma);
        const recursiveMultiaddrs = await Promise.all(resolvedMultiaddrs.map((nm)=>{
            return this._resolve(nm);
        }));
        const addrs = recursiveMultiaddrs.flat();
        return addrs.reduce((array, newM)=>{
            if (!array.find((m)=>m.equals(newM))) array.push(newM);
            return array;
        }, /** @type  {Multiaddr[]} */ []);
    }
    /**
   * Resolve a given multiaddr. If this fails, an empty array will be returned
   *
   * @param {Multiaddr} ma
   * @returns {Promise<Multiaddr[]>}
   */ async _resolveRecord(ma) {
        try {
            ma = new $9f6bbdeed36edec4$require$Multiaddr(ma.toString()) // Use current multiaddr module
            ;
            const multiaddrs = await ma.resolve();
            return multiaddrs;
        } catch (_) {
            $9f6bbdeed36edec4$var$log.error(`multiaddr ${ma} could not be resolved`);
            return [];
        }
    }
}
module.exports = $9f6bbdeed36edec4$var$Dialer;

});
parcelRequire.register("61ajt", function(module, exports) {

var $7EsPD = parcelRequire("7EsPD");
var $461ad608fa34886a$require$AbortController = $7EsPD.AbortController;
/**
 * Takes an array of AbortSignals and returns a single signal.
 * If any signals are aborted, the returned signal will be aborted.
 * @param {Array<AbortSignal>} signals
 * @returns {AbortSignal}
 */ function $461ad608fa34886a$var$anySignal(signals) {
    const controller = new $461ad608fa34886a$require$AbortController();
    function onAbort() {
        controller.abort();
        for (const signal of signals){
            if (!signal || !signal.removeEventListener) continue;
            signal.removeEventListener("abort", onAbort);
        }
    }
    for (const signal of signals){
        if (!signal || !signal.addEventListener) continue;
        if (signal.aborted) {
            onAbort();
            break;
        }
        signal.addEventListener("abort", onAbort);
    }
    return controller.signal;
}
module.exports = $461ad608fa34886a$var$anySignal;
module.exports.anySignal = $461ad608fa34886a$var$anySignal;

});

parcelRequire.register("gYviB", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $61ajt = parcelRequire("61ajt");
var $c5ba874d3cdd3125$require$anySignal = $61ajt.anySignal;

var $bpxZd = parcelRequire("bpxZd");

var $ioI1Q = parcelRequire("ioI1Q");

var $7QXK1 = parcelRequire("7QXK1");
var $c5ba874d3cdd3125$require$setMaxListeners = $7QXK1.setMaxListeners;

var $8yAh4 = parcelRequire("8yAh4");
var $c5ba874d3cdd3125$require$codes = $8yAh4.codes;
/**
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('./')} Dialer
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 */ /**
 * @typedef {Object} DialOptions
 * @property {AbortSignal} signal
 *
 * @typedef {Object} DialRequestOptions
 * @property {Multiaddr[]} addrs
 * @property {(m: Multiaddr, options: DialOptions) => Promise<Connection>} dialAction
 * @property {Dialer} dialer
 */ class $c5ba874d3cdd3125$var$DialRequest {
    /**
   * Manages running the `dialAction` on multiple provided `addrs` in parallel
   * up to a maximum determined by the number of tokens returned
   * from `dialer.getTokens`. Once a DialRequest is created, it can be
   * started using `DialRequest.run(options)`. Once a single dial has succeeded,
   * all other dials in the request will be cancelled.
   *
   * @class
   * @param {DialRequestOptions} options
   */ constructor({ addrs: addrs, dialAction: dialAction, dialer: dialer }){
        this.addrs = addrs;
        this.dialer = dialer;
        this.dialAction = dialAction;
    }
    /**
   * @async
   * @param {object} [options]
   * @param {AbortSignal} [options.signal] - An AbortController signal
   * @returns {Promise<Connection>}
   */ async run(options = {}) {
        const tokens = this.dialer.getTokens(this.addrs.length);
        // If no tokens are available, throw
        if (tokens.length < 1) throw $20Lm5(new Error("No dial tokens available"), $c5ba874d3cdd3125$require$codes.ERR_NO_DIAL_TOKENS);
        const tokenHolder = new $bpxZd();
        tokens.forEach((token)=>tokenHolder.push(token));
        const dialAbortControllers = this.addrs.map(()=>{
            const controller = new AbortController();
            $c5ba874d3cdd3125$require$setMaxListeners && $c5ba874d3cdd3125$require$setMaxListeners(Infinity, controller.signal);
            return controller;
        });
        let completedDials = 0;
        try {
            return await $ioI1Q(this.addrs.map(async (addr, i)=>{
                const token = await tokenHolder.shift() // get token
                ;
                let conn;
                try {
                    const signal = dialAbortControllers[i].signal;
                    conn = await this.dialAction(addr, {
                        ...options,
                        signal: options.signal ? $c5ba874d3cdd3125$require$anySignal([
                            signal,
                            options.signal
                        ]) : signal
                    });
                    // Remove the successful AbortController so it is not aborted
                    dialAbortControllers.splice(i, 1);
                } finally{
                    completedDials++;
                    // If we have more or equal dials remaining than tokens, recycle the token, otherwise release it
                    if (this.addrs.length - completedDials >= tokens.length) tokenHolder.push(token);
                    else this.dialer.releaseToken(tokens.splice(tokens.indexOf(token), 1)[0]);
                }
                return conn;
            }));
        } finally{
            dialAbortControllers.map((c)=>c.abort()) // success/failure happened, abort everything else
            ;
            tokens.forEach((token)=>this.dialer.releaseToken(token)) // release tokens back to the dialer
            ;
        }
    }
}
module.exports = $c5ba874d3cdd3125$var$DialRequest;

});
parcelRequire.register("bpxZd", function(module, exports) {

var $bUCRD = parcelRequire("bUCRD");

var $eoOla = parcelRequire("eoOla");
module.exports = class PFifo {
    constructor(){
        this._buffer = new $bUCRD();
        this._waitingConsumers = new $bUCRD();
    }
    push(chunk) {
        const { promise: promise, resolve: resolve } = $eoOla();
        this._buffer.push({
            chunk: chunk,
            resolve: resolve
        });
        this._consume();
        return promise;
    }
    _consume() {
        while(!this._waitingConsumers.isEmpty() && !this._buffer.isEmpty()){
            const nextConsumer = this._waitingConsumers.shift();
            const nextChunk = this._buffer.shift();
            nextConsumer.resolve(nextChunk.chunk);
            nextChunk.resolve();
        }
    }
    shift() {
        const { promise: promise, resolve: resolve } = $eoOla();
        this._waitingConsumers.push({
            resolve: resolve
        });
        this._consume();
        return promise;
    }
    isEmpty() {
        return this._buffer.isEmpty();
    }
};

});

parcelRequire.register("ioI1Q", function(module, exports) {
"use strict";

var $32jmJ = parcelRequire("32jmJ");

var $9xjhY = parcelRequire("9xjhY");
module.exports = (iterable, options)=>{
    const anyCancelable = $32jmJ(iterable, {
        ...options,
        count: 1
    });
    return $9xjhY.fn(async (onCancel)=>{
        onCancel(()=>{
            anyCancelable.cancel();
        });
        const [value] = await anyCancelable;
        return value;
    })();
};
module.exports.AggregateError = $32jmJ.AggregateError;

});
parcelRequire.register("32jmJ", function(module, exports) {
"use strict";

var $gEUFK = parcelRequire("gEUFK");

var $9xjhY = parcelRequire("9xjhY");
class $236094a2b4c3494a$var$FilterError extends Error {
}
const $236094a2b4c3494a$var$pSome = (iterable, options)=>new $9xjhY((resolve, reject, onCancel)=>{
        const { count: count, filter: filter = ()=>true } = options;
        if (!Number.isFinite(count)) {
            reject(new TypeError(`Expected a finite number, got ${typeof options.count}`));
            return;
        }
        const values = [];
        const errors = [];
        let elementCount = 0;
        let isSettled = false;
        const completed = new Set();
        const maybeSettle = ()=>{
            if (values.length === count) {
                resolve(values);
                isSettled = true;
            }
            if (elementCount - errors.length < count) {
                reject(new $gEUFK(errors));
                isSettled = true;
            }
            return isSettled;
        };
        const cancelPending = ()=>{
            for (const promise of iterable)if (!completed.has(promise) && typeof promise.cancel === "function") promise.cancel();
        };
        onCancel(cancelPending);
        for (const element of iterable){
            elementCount++;
            (async ()=>{
                try {
                    const value = await element;
                    if (isSettled) return;
                    if (!filter(value)) throw new $236094a2b4c3494a$var$FilterError("Value does not satisfy filter");
                    values.push(value);
                } catch (error) {
                    errors.push(error);
                } finally{
                    completed.add(element);
                    if (!isSettled && maybeSettle()) cancelPending();
                }
            })();
        }
        if (count > elementCount) {
            reject(new RangeError(`Expected input to contain at least ${options.count} items, but contains ${elementCount} items`));
            cancelPending();
        }
    });
module.exports = $236094a2b4c3494a$var$pSome;
module.exports.AggregateError = $gEUFK;
module.exports.FilterError = $236094a2b4c3494a$var$FilterError;

});
parcelRequire.register("gEUFK", function(module, exports) {
"use strict";

var $nF4ay = parcelRequire("nF4ay");

var $6saKu = parcelRequire("6saKu");
const $c20c57b3bb40c1d7$var$cleanInternalStack = (stack)=>stack.replace(/\s+at .*aggregate-error\/index.js:\d+:\d+\)?/g, "");
class $c20c57b3bb40c1d7$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        errors = [
            ...errors
        ].map((error)=>{
            if (error instanceof Error) return error;
            if (error !== null && typeof error === "object") // Handle plain error objects with message property and/or possibly other metadata
            return Object.assign(new Error(error.message), error);
            return new Error(error);
        });
        let message = errors.map((error)=>{
            // The `stack` property is not standardized, so we can't assume it exists
            return typeof error.stack === "string" ? $c20c57b3bb40c1d7$var$cleanInternalStack($6saKu(error.stack)) : String(error);
        }).join("\n");
        message = "\n" + $nF4ay(message, 4);
        super(message);
        this.name = "AggregateError";
        Object.defineProperty(this, "_errors", {
            value: errors
        });
    }
    *[Symbol.iterator]() {
        for (const error of this._errors)yield error;
    }
}
module.exports = $c20c57b3bb40c1d7$var$AggregateError;

});
parcelRequire.register("nF4ay", function(module, exports) {
"use strict";
module.exports = (string, count = 1, options)=>{
    options = {
        indent: " ",
        includeEmptyLines: false,
        ...options
    };
    if (typeof string !== "string") throw new TypeError(`Expected \`input\` to be a \`string\`, got \`${typeof string}\``);
    if (typeof count !== "number") throw new TypeError(`Expected \`count\` to be a \`number\`, got \`${typeof count}\``);
    if (typeof options.indent !== "string") throw new TypeError(`Expected \`options.indent\` to be a \`string\`, got \`${typeof options.indent}\``);
    if (count === 0) return string;
    const regex = options.includeEmptyLines ? /^/gm : /^(?!\s*$)/gm;
    return string.replace(regex, options.indent.repeat(count));
};

});

parcelRequire.register("6saKu", function(module, exports) {
"use strict";

var $7jzxY = parcelRequire("7jzxY");
const $4b2db21a7468191f$var$extractPathRegex = /\s+at.*(?:\(|\s)(.*)\)?/;
const $4b2db21a7468191f$var$pathRegex = /^(?:(?:(?:node|(?:internal\/[\w/]*|.*node_modules\/(?:babel-polyfill|pirates)\/.*)?\w+)\.js:\d+:\d+)|native)/;
const $4b2db21a7468191f$var$homeDir = typeof $7jzxY.homedir === "undefined" ? "" : $7jzxY.homedir();
module.exports = (stack, options)=>{
    options = Object.assign({
        pretty: false
    }, options);
    return stack.replace(/\\/g, "/").split("\n").filter((line)=>{
        const pathMatches = line.match($4b2db21a7468191f$var$extractPathRegex);
        if (pathMatches === null || !pathMatches[1]) return true;
        const match = pathMatches[1];
        // Electron
        if (match.includes(".app/Contents/Resources/electron.asar") || match.includes(".app/Contents/Resources/default_app.asar")) return false;
        return !$4b2db21a7468191f$var$pathRegex.test(match);
    }).filter((line)=>line.trim() !== "").map((line)=>{
        if (options.pretty) return line.replace($4b2db21a7468191f$var$extractPathRegex, (m, p1)=>m.replace(p1, p1.replace($4b2db21a7468191f$var$homeDir, "~")));
        return line;
    }).join("\n");
};

});


parcelRequire.register("9xjhY", function(module, exports) {
"use strict";
class $6f1628827d9f936a$var$CancelError extends Error {
    constructor(reason){
        super(reason || "Promise was canceled");
        this.name = "CancelError";
    }
    get isCanceled() {
        return true;
    }
}
class $6f1628827d9f936a$var$PCancelable {
    static fn(userFn) {
        return (...arguments_)=>{
            return new $6f1628827d9f936a$var$PCancelable((resolve, reject, onCancel)=>{
                arguments_.push(onCancel);
                // eslint-disable-next-line promise/prefer-await-to-then
                userFn(...arguments_).then(resolve, reject);
            });
        };
    }
    constructor(executor){
        this._cancelHandlers = [];
        this._isPending = true;
        this._isCanceled = false;
        this._rejectOnCancel = true;
        this._promise = new Promise((resolve, reject)=>{
            this._reject = reject;
            const onResolve = (value)=>{
                if (!this._isCanceled || !onCancel.shouldReject) {
                    this._isPending = false;
                    resolve(value);
                }
            };
            const onReject = (error)=>{
                this._isPending = false;
                reject(error);
            };
            const onCancel = (handler)=>{
                if (!this._isPending) throw new Error("The `onCancel` handler was attached after the promise settled.");
                this._cancelHandlers.push(handler);
            };
            Object.defineProperties(onCancel, {
                shouldReject: {
                    get: ()=>this._rejectOnCancel,
                    set: (boolean)=>{
                        this._rejectOnCancel = boolean;
                    }
                }
            });
            return executor(onResolve, onReject, onCancel);
        });
    }
    then(onFulfilled, onRejected) {
        // eslint-disable-next-line promise/prefer-await-to-then
        return this._promise.then(onFulfilled, onRejected);
    }
    catch(onRejected) {
        return this._promise.catch(onRejected);
    }
    finally(onFinally) {
        return this._promise.finally(onFinally);
    }
    cancel(reason) {
        if (!this._isPending || this._isCanceled) return;
        this._isCanceled = true;
        if (this._cancelHandlers.length > 0) try {
            for (const handler of this._cancelHandlers)handler();
        } catch (error) {
            this._reject(error);
            return;
        }
        if (this._rejectOnCancel) this._reject(new $6f1628827d9f936a$var$CancelError(reason));
    }
    get isCanceled() {
        return this._isCanceled;
    }
}
Object.setPrototypeOf($6f1628827d9f936a$var$PCancelable.prototype, Promise.prototype);
module.exports = $6f1628827d9f936a$var$PCancelable;
module.exports.CancelError = $6f1628827d9f936a$var$CancelError;

});





parcelRequire.register("dAY1M", function(module, exports) {
/* eslint max-nested-callbacks: ["error", 5] */ "use strict";

var $jjmHV = parcelRequire("jjmHV");
const $9e5d33650d7bc1bb$var$log = Object.assign($jjmHV("libp2p:keychain"), {
    error: $jjmHV("libp2p:keychain:err")
});

var $5KtzH = parcelRequire("5KtzH");

var $8pyvD = parcelRequire("8pyvD");

var $jqljq = parcelRequire("jqljq");

var $e2ec8 = parcelRequire("e2ec8");
var $9e5d33650d7bc1bb$require$Key = $e2ec8.Key;

var $jkEBc = parcelRequire("jkEBc");

var $20Lm5 = parcelRequire("20Lm5");

var $8yAh4 = parcelRequire("8yAh4");
var $9e5d33650d7bc1bb$require$codes = $8yAh4.codes;

var $6rBCs = parcelRequire("6rBCs");
var $9e5d33650d7bc1bb$require$uint8ArrayToString = $6rBCs.toString;

var $8cWjP = parcelRequire("8cWjP");
var $9e5d33650d7bc1bb$require$uint8ArrayFromString = $8cWjP.fromString;
parcelRequire("acTBK");
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('interface-datastore').Datastore} Datastore
 */ /**
 * @typedef {Object} DekOptions
 * @property {string} hash
 * @property {string} salt
 * @property {number} iterationCount
 * @property {number} keyLength
 *
 * @typedef {Object} KeychainOptions
 * @property {string} [pass]
 * @property {DekOptions} [dek]
 */ /**
 * Information about a key.
 *
 * @typedef {Object} KeyInfo
 * @property {string} id - The universally unique key id.
 * @property {string} name - The local key name.
 */ const $9e5d33650d7bc1bb$var$keyPrefix = "/pkcs8/";
const $9e5d33650d7bc1bb$var$infoPrefix = "/info/";
const $9e5d33650d7bc1bb$var$privates = new WeakMap();
// NIST SP 800-132
const $9e5d33650d7bc1bb$var$NIST = {
    minKeyLength: 14,
    minSaltLength: 16,
    minIterationCount: 1000
};
const $9e5d33650d7bc1bb$var$defaultOptions = {
    // See https://cryptosense.com/parametesr-choice-for-pbkdf2/
    dek: {
        keyLength: 64,
        iterationCount: 10000,
        salt: "you should override this value with a crypto secure random number",
        hash: "sha2-512"
    }
};
/**
 * @param {string} name
 */ function $9e5d33650d7bc1bb$var$validateKeyName(name) {
    if (!name) return false;
    if (typeof name !== "string") return false;
    return name === $5KtzH(name.trim());
}
/**
 * Throws an error after a delay
 *
 * This assumes than an error indicates that the keychain is under attack. Delay returning an
 * error to make brute force attacks harder.
 *
 * @param {string|Error} err - The error
 * @returns {Promise<never>}
 * @private
 */ async function $9e5d33650d7bc1bb$var$throwDelayed(err) {
    const min = 200;
    const max = 1000;
    const delay = Math.random() * (max - min) + min;
    await new Promise((resolve)=>setTimeout(resolve, delay));
    throw err;
}
/**
 * Converts a key name into a datastore name.
 *
 * @param {string} name
 * @returns {Key}
 * @private
 */ function $9e5d33650d7bc1bb$var$DsName(name) {
    return new $9e5d33650d7bc1bb$require$Key($9e5d33650d7bc1bb$var$keyPrefix + name);
}
/**
 * Converts a key name into a datastore info name.
 *
 * @param {string} name
 * @returns {Key}
 * @private
 */ function $9e5d33650d7bc1bb$var$DsInfoName(name) {
    return new $9e5d33650d7bc1bb$require$Key($9e5d33650d7bc1bb$var$infoPrefix + name);
}
/**
 * Manages the lifecycle of a key. Keys are encrypted at rest using PKCS #8.
 *
 * A key in the store has two entries
 * - '/info/*key-name*', contains the KeyInfo for the key
 * - '/pkcs8/*key-name*', contains the PKCS #8 for the key
 *
 */ class $9e5d33650d7bc1bb$var$Keychain {
    /**
   * Creates a new instance of a key chain.
   *
   * @param {Datastore} store - where the key are.
   * @param {KeychainOptions} options
   * @class
   */ constructor(store, options){
        if (!store) throw new Error("store is required");
        this.store = store;
        this.opts = $8pyvD($9e5d33650d7bc1bb$var$defaultOptions, options);
        // Enforce NIST SP 800-132
        if (this.opts.pass && this.opts.pass.length < 20) throw new Error("pass must be least 20 characters");
        if (this.opts.dek.keyLength < $9e5d33650d7bc1bb$var$NIST.minKeyLength) throw new Error(`dek.keyLength must be least ${$9e5d33650d7bc1bb$var$NIST.minKeyLength} bytes`);
        if (this.opts.dek.salt.length < $9e5d33650d7bc1bb$var$NIST.minSaltLength) throw new Error(`dek.saltLength must be least ${$9e5d33650d7bc1bb$var$NIST.minSaltLength} bytes`);
        if (this.opts.dek.iterationCount < $9e5d33650d7bc1bb$var$NIST.minIterationCount) throw new Error(`dek.iterationCount must be least ${$9e5d33650d7bc1bb$var$NIST.minIterationCount}`);
        const dek = this.opts.pass ? $jqljq.pbkdf2(this.opts.pass, this.opts.dek.salt, this.opts.dek.iterationCount, this.opts.dek.keyLength, this.opts.dek.hash) : "";
        $9e5d33650d7bc1bb$var$privates.set(this, {
            dek: dek
        });
    }
    /**
   * Gets an object that can encrypt/decrypt protected data
   * using the Cryptographic Message Syntax (CMS).
   *
   * CMS describes an encapsulation syntax for data protection. It
   * is used to digitally sign, digest, authenticate, or encrypt
   * arbitrary message content.
   *
   * @returns {CMS}
   */ get cms() {
        return new $jkEBc(this, $9e5d33650d7bc1bb$var$privates.get(this).dek);
    }
    /**
   * Generates the options for a keychain.  A random salt is produced.
   *
   * @returns {Object}
   */ static generateOptions() {
        const options = Object.assign({}, $9e5d33650d7bc1bb$var$defaultOptions);
        const saltLength = Math.ceil($9e5d33650d7bc1bb$var$NIST.minSaltLength / 3) * 3 // no base64 padding
        ;
        options.dek.salt = $9e5d33650d7bc1bb$require$uint8ArrayToString($jqljq.randomBytes(saltLength), "base64");
        return options;
    }
    /**
   * Gets an object that can encrypt/decrypt protected data.
   * The default options for a keychain.
   *
   * @returns {Object}
   */ static get options() {
        return $9e5d33650d7bc1bb$var$defaultOptions;
    }
    /**
   * Create a new key.
   *
   * @param {string} name - The local key name; cannot already exist.
   * @param {string} type - One of the key types; 'rsa'.
   * @param {number} [size = 2048] - The key size in bits. Used for rsa keys only.
   * @returns {Promise<KeyInfo>}
   */ async createKey(name, type, size = 2048) {
        const self = this;
        if (!$9e5d33650d7bc1bb$var$validateKeyName(name) || name === "self") return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Invalid key name '${name}'`), $9e5d33650d7bc1bb$require$codes.ERR_INVALID_KEY_NAME));
        if (typeof type !== "string") return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Invalid key type '${type}'`), $9e5d33650d7bc1bb$require$codes.ERR_INVALID_KEY_TYPE));
        const dsname = $9e5d33650d7bc1bb$var$DsName(name);
        const exists = await self.store.has(dsname);
        if (exists) return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Key '${name}' already exists`), $9e5d33650d7bc1bb$require$codes.ERR_KEY_ALREADY_EXISTS));
        switch(type.toLowerCase()){
            case "rsa":
                if (!Number.isSafeInteger(size) || size < 2048) return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Invalid RSA key size ${size}`), $9e5d33650d7bc1bb$require$codes.ERR_INVALID_KEY_SIZE));
                break;
            default:
                break;
        }
        let keyInfo;
        try {
            // @ts-ignore Differences between several crypto return types need to be fixed in libp2p-crypto
            const keypair = await $jqljq.keys.generateKeyPair(type, size);
            const kid = await keypair.id();
            /** @type {string} */ const dek = $9e5d33650d7bc1bb$var$privates.get(this).dek;
            const pem = await keypair.export(dek);
            keyInfo = {
                name: name,
                id: kid
            };
            const batch = self.store.batch();
            batch.put(dsname, $9e5d33650d7bc1bb$require$uint8ArrayFromString(pem));
            batch.put($9e5d33650d7bc1bb$var$DsInfoName(name), $9e5d33650d7bc1bb$require$uint8ArrayFromString(JSON.stringify(keyInfo)));
            await batch.commit();
        } catch (/** @type {any} */ err) {
            return $9e5d33650d7bc1bb$var$throwDelayed(err);
        }
        return keyInfo;
    }
    /**
   * List all the keys.
   *
   * @returns {Promise<KeyInfo[]>}
   */ async listKeys() {
        const self = this;
        const query = {
            prefix: $9e5d33650d7bc1bb$var$infoPrefix
        };
        const info = [];
        for await (const value of self.store.query(query))info.push(JSON.parse($9e5d33650d7bc1bb$require$uint8ArrayToString(value.value)));
        return info;
    }
    /**
   * Find a key by it's id.
   *
   * @param {string} id - The universally unique key identifier.
   * @returns {Promise<KeyInfo|undefined>}
   */ async findKeyById(id) {
        try {
            const keys = await this.listKeys();
            return keys.find((k)=>k.id === id);
        } catch (/** @type {any} */ err) {
            return $9e5d33650d7bc1bb$var$throwDelayed(err);
        }
    }
    /**
   * Find a key by it's name.
   *
   * @param {string} name - The local key name.
   * @returns {Promise<KeyInfo>}
   */ async findKeyByName(name) {
        if (!$9e5d33650d7bc1bb$var$validateKeyName(name)) return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Invalid key name '${name}'`), $9e5d33650d7bc1bb$require$codes.ERR_INVALID_KEY_NAME));
        const dsname = $9e5d33650d7bc1bb$var$DsInfoName(name);
        try {
            const res = await this.store.get(dsname);
            return JSON.parse($9e5d33650d7bc1bb$require$uint8ArrayToString(res));
        } catch (/** @type {any} */ err) {
            return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Key '${name}' does not exist. ${err.message}`), $9e5d33650d7bc1bb$require$codes.ERR_KEY_NOT_FOUND));
        }
    }
    /**
   * Remove an existing key.
   *
   * @param {string} name - The local key name; must already exist.
   * @returns {Promise<KeyInfo>}
   */ async removeKey(name) {
        const self = this;
        if (!$9e5d33650d7bc1bb$var$validateKeyName(name) || name === "self") return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Invalid key name '${name}'`), $9e5d33650d7bc1bb$require$codes.ERR_INVALID_KEY_NAME));
        const dsname = $9e5d33650d7bc1bb$var$DsName(name);
        const keyInfo = await self.findKeyByName(name);
        const batch = self.store.batch();
        batch.delete(dsname);
        batch.delete($9e5d33650d7bc1bb$var$DsInfoName(name));
        await batch.commit();
        return keyInfo;
    }
    /**
   * Rename a key
   *
   * @param {string} oldName - The old local key name; must already exist.
   * @param {string} newName - The new local key name; must not already exist.
   * @returns {Promise<KeyInfo>}
   */ async renameKey(oldName, newName) {
        const self = this;
        if (!$9e5d33650d7bc1bb$var$validateKeyName(oldName) || oldName === "self") return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Invalid old key name '${oldName}'`), $9e5d33650d7bc1bb$require$codes.ERR_OLD_KEY_NAME_INVALID));
        if (!$9e5d33650d7bc1bb$var$validateKeyName(newName) || newName === "self") return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Invalid new key name '${newName}'`), $9e5d33650d7bc1bb$require$codes.ERR_NEW_KEY_NAME_INVALID));
        const oldDsname = $9e5d33650d7bc1bb$var$DsName(oldName);
        const newDsname = $9e5d33650d7bc1bb$var$DsName(newName);
        const oldInfoName = $9e5d33650d7bc1bb$var$DsInfoName(oldName);
        const newInfoName = $9e5d33650d7bc1bb$var$DsInfoName(newName);
        const exists = await self.store.has(newDsname);
        if (exists) return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Key '${newName}' already exists`), $9e5d33650d7bc1bb$require$codes.ERR_KEY_ALREADY_EXISTS));
        try {
            const pem = await self.store.get(oldDsname);
            const res = await self.store.get(oldInfoName);
            const keyInfo = JSON.parse($9e5d33650d7bc1bb$require$uint8ArrayToString(res));
            keyInfo.name = newName;
            const batch = self.store.batch();
            batch.put(newDsname, pem);
            batch.put(newInfoName, $9e5d33650d7bc1bb$require$uint8ArrayFromString(JSON.stringify(keyInfo)));
            batch.delete(oldDsname);
            batch.delete(oldInfoName);
            await batch.commit();
            return keyInfo;
        } catch (/** @type {any} */ err) {
            return $9e5d33650d7bc1bb$var$throwDelayed(err);
        }
    }
    /**
   * Export an existing key as a PEM encrypted PKCS #8 string
   *
   * @param {string} name - The local key name; must already exist.
   * @param {string} password - The password
   * @returns {Promise<string>}
   */ async exportKey(name, password) {
        if (!$9e5d33650d7bc1bb$var$validateKeyName(name)) return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Invalid key name '${name}'`), $9e5d33650d7bc1bb$require$codes.ERR_INVALID_KEY_NAME));
        if (!password) return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error("Password is required"), $9e5d33650d7bc1bb$require$codes.ERR_PASSWORD_REQUIRED));
        const dsname = $9e5d33650d7bc1bb$var$DsName(name);
        try {
            const res = await this.store.get(dsname);
            const pem = $9e5d33650d7bc1bb$require$uint8ArrayToString(res);
            /** @type {string} */ const dek = $9e5d33650d7bc1bb$var$privates.get(this).dek;
            const privateKey = await $jqljq.keys.import(pem, dek);
            return privateKey.export(password);
        } catch (/** @type {any} */ err) {
            return $9e5d33650d7bc1bb$var$throwDelayed(err);
        }
    }
    /**
   * Import a new key from a PEM encoded PKCS #8 string
   *
   * @param {string} name - The local key name; must not already exist.
   * @param {string} pem - The PEM encoded PKCS #8 string
   * @param {string} password - The password.
   * @returns {Promise<KeyInfo>}
   */ async importKey(name, pem, password) {
        const self = this;
        if (!$9e5d33650d7bc1bb$var$validateKeyName(name) || name === "self") return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Invalid key name '${name}'`), $9e5d33650d7bc1bb$require$codes.ERR_INVALID_KEY_NAME));
        if (!pem) return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error("PEM encoded key is required"), $9e5d33650d7bc1bb$require$codes.ERR_PEM_REQUIRED));
        const dsname = $9e5d33650d7bc1bb$var$DsName(name);
        const exists = await self.store.has(dsname);
        if (exists) return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Key '${name}' already exists`), $9e5d33650d7bc1bb$require$codes.ERR_KEY_ALREADY_EXISTS));
        let privateKey;
        try {
            privateKey = await $jqljq.keys.import(pem, password);
        } catch (/** @type {any} */ err) {
            return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error("Cannot read the key, most likely the password is wrong"), $9e5d33650d7bc1bb$require$codes.ERR_CANNOT_READ_KEY));
        }
        let kid;
        try {
            kid = await privateKey.id();
            /** @type {string} */ const dek = $9e5d33650d7bc1bb$var$privates.get(this).dek;
            pem = await privateKey.export(dek);
        } catch (/** @type {any} */ err) {
            return $9e5d33650d7bc1bb$var$throwDelayed(err);
        }
        const keyInfo = {
            name: name,
            id: kid
        };
        const batch = self.store.batch();
        batch.put(dsname, $9e5d33650d7bc1bb$require$uint8ArrayFromString(pem));
        batch.put($9e5d33650d7bc1bb$var$DsInfoName(name), $9e5d33650d7bc1bb$require$uint8ArrayFromString(JSON.stringify(keyInfo)));
        await batch.commit();
        return keyInfo;
    }
    /**
   * Import a peer key
   *
   * @param {string} name - The local key name; must not already exist.
   * @param {PeerId} peer - The PEM encoded PKCS #8 string
   * @returns {Promise<KeyInfo>}
   */ async importPeer(name, peer) {
        const self = this;
        if (!$9e5d33650d7bc1bb$var$validateKeyName(name)) return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Invalid key name '${name}'`), $9e5d33650d7bc1bb$require$codes.ERR_INVALID_KEY_NAME));
        if (!peer || !peer.privKey) return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error("Peer.privKey is required"), $9e5d33650d7bc1bb$require$codes.ERR_MISSING_PRIVATE_KEY));
        const privateKey = peer.privKey;
        const dsname = $9e5d33650d7bc1bb$var$DsName(name);
        const exists = await self.store.has(dsname);
        if (exists) return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Key '${name}' already exists`), $9e5d33650d7bc1bb$require$codes.ERR_KEY_ALREADY_EXISTS));
        try {
            const kid = await privateKey.id();
            /** @type {string} */ const dek = $9e5d33650d7bc1bb$var$privates.get(this).dek;
            const pem = await privateKey.export(dek);
            const keyInfo = {
                name: name,
                id: kid
            };
            const batch = self.store.batch();
            batch.put(dsname, $9e5d33650d7bc1bb$require$uint8ArrayFromString(pem));
            batch.put($9e5d33650d7bc1bb$var$DsInfoName(name), $9e5d33650d7bc1bb$require$uint8ArrayFromString(JSON.stringify(keyInfo)));
            await batch.commit();
            return keyInfo;
        } catch (/** @type {any} */ err) {
            return $9e5d33650d7bc1bb$var$throwDelayed(err);
        }
    }
    /**
   * Gets the private key as PEM encoded PKCS #8 string.
   *
   * @param {string} name
   * @returns {Promise<string>}
   */ async _getPrivateKey(name) {
        if (!$9e5d33650d7bc1bb$var$validateKeyName(name)) return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Invalid key name '${name}'`), $9e5d33650d7bc1bb$require$codes.ERR_INVALID_KEY_NAME));
        try {
            const dsname = $9e5d33650d7bc1bb$var$DsName(name);
            const res = await this.store.get(dsname);
            return $9e5d33650d7bc1bb$require$uint8ArrayToString(res);
        } catch (/** @type {any} */ err) {
            return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Key '${name}' does not exist. ${err.message}`), $9e5d33650d7bc1bb$require$codes.ERR_KEY_NOT_FOUND));
        }
    }
    /**
   * Rotate keychain password and re-encrypt all assosciated keys
   *
   * @param {string} oldPass - The old local keychain password
   * @param {string} newPass - The new local keychain password
   */ async rotateKeychainPass(oldPass, newPass) {
        if (typeof oldPass !== "string") return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Invalid old pass type '${typeof oldPass}'`), $9e5d33650d7bc1bb$require$codes.ERR_INVALID_OLD_PASS_TYPE));
        if (typeof newPass !== "string") return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Invalid new pass type '${typeof newPass}'`), $9e5d33650d7bc1bb$require$codes.ERR_INVALID_NEW_PASS_TYPE));
        if (newPass.length < 20) return $9e5d33650d7bc1bb$var$throwDelayed($20Lm5(new Error(`Invalid pass length ${newPass.length}`), $9e5d33650d7bc1bb$require$codes.ERR_INVALID_PASS_LENGTH));
        $9e5d33650d7bc1bb$var$log("recreating keychain");
        const oldDek = $9e5d33650d7bc1bb$var$privates.get(this).dek;
        this.opts.pass = newPass;
        const newDek = newPass ? $jqljq.pbkdf2(newPass, this.opts.dek.salt, this.opts.dek.iterationCount, this.opts.dek.keyLength, this.opts.dek.hash) : "";
        $9e5d33650d7bc1bb$var$privates.set(this, {
            dek: newDek
        });
        const keys = await this.listKeys();
        for (const key of keys){
            const res = await this.store.get($9e5d33650d7bc1bb$var$DsName(key.name));
            const pem = $9e5d33650d7bc1bb$require$uint8ArrayToString(res);
            const privateKey = await $jqljq.keys.import(pem, oldDek);
            const password = newDek.toString();
            const keyAsPEM = await privateKey.export(password);
            // Update stored key
            const batch = this.store.batch();
            const keyInfo = {
                name: key.name,
                id: key.id
            };
            batch.put($9e5d33650d7bc1bb$var$DsName(key.name), $9e5d33650d7bc1bb$require$uint8ArrayFromString(keyAsPEM));
            batch.put($9e5d33650d7bc1bb$var$DsInfoName(key.name), $9e5d33650d7bc1bb$require$uint8ArrayFromString(JSON.stringify(keyInfo)));
            await batch.commit();
        }
        $9e5d33650d7bc1bb$var$log("keychain reconstructed");
    }
}
module.exports = $9e5d33650d7bc1bb$var$Keychain;

});
parcelRequire.register("5KtzH", function(module, exports) {
/*jshint node:true*/ "use strict";

var $iWxS8 = parcelRequire("iWxS8");
var $42f8308c64a9c163$var$illegalRe = /[\/\?<>\\:\*\|"]/g;
var $42f8308c64a9c163$var$controlRe = /[\x00-\x1f\x80-\x9f]/g;
var $42f8308c64a9c163$var$reservedRe = /^\.+$/;
var $42f8308c64a9c163$var$windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;
/**
 * Strip trailing spaces and dots, which are not allowed on some Windows file
 * systems. Does not use a regex to avoid a quadratic ReDoS vulnerability
 * (CWE-1333).
 */ function $42f8308c64a9c163$var$replaceTrailingDotsAndSpaces(str, replacement) {
    var end = str.length;
    while(end > 0 && (str[end - 1] === "." || str[end - 1] === " "))end--;
    return end < str.length ? str.slice(0, end) + replacement : str;
}
function $42f8308c64a9c163$var$sanitize(input, replacement) {
    if (typeof input !== "string") throw new Error("Input must be string");
    var sanitized = input.replace($42f8308c64a9c163$var$illegalRe, replacement).replace($42f8308c64a9c163$var$controlRe, replacement).replace($42f8308c64a9c163$var$reservedRe, replacement).replace($42f8308c64a9c163$var$windowsReservedRe, replacement);
    sanitized = $42f8308c64a9c163$var$replaceTrailingDotsAndSpaces(sanitized, replacement);
    return $iWxS8(sanitized, 255);
}
module.exports = function(input, options) {
    var replacement = options && options.replacement || "";
    var output = $42f8308c64a9c163$var$sanitize(input, replacement);
    if (replacement === "") return output;
    return $42f8308c64a9c163$var$sanitize(output, "");
};

});
parcelRequire.register("iWxS8", function(module, exports) {
"use strict";

var $2Pbdl = parcelRequire("2Pbdl");

var $l58HZ = parcelRequire("l58HZ");
module.exports = $2Pbdl.bind(null, $l58HZ);

});
parcelRequire.register("2Pbdl", function(module, exports) {
"use strict";
function $20e90b1a280202ce$var$isHighSurrogate(codePoint) {
    return codePoint >= 0xd800 && codePoint <= 0xdbff;
}
function $20e90b1a280202ce$var$isLowSurrogate(codePoint) {
    return codePoint >= 0xdc00 && codePoint <= 0xdfff;
}
// Truncate string by size in bytes
module.exports = function truncate(getLength, string, byteLength) {
    if (typeof string !== "string") throw new Error("Input must be string");
    var charLength = string.length;
    var curByteLength = 0;
    var codePoint;
    var segment;
    for(var i = 0; i < charLength; i += 1){
        codePoint = string.charCodeAt(i);
        segment = string[i];
        if ($20e90b1a280202ce$var$isHighSurrogate(codePoint) && $20e90b1a280202ce$var$isLowSurrogate(string.charCodeAt(i + 1))) {
            i += 1;
            segment += string[i];
        }
        curByteLength += getLength(segment);
        if (curByteLength === byteLength) return string.slice(0, i + 1);
        else if (curByteLength > byteLength) return string.slice(0, i - segment.length + 1);
    }
    return string;
};

});

parcelRequire.register("l58HZ", function(module, exports) {
"use strict";
function $f590d1e891426904$var$isHighSurrogate(codePoint) {
    return codePoint >= 0xd800 && codePoint <= 0xdbff;
}
function $f590d1e891426904$var$isLowSurrogate(codePoint) {
    return codePoint >= 0xdc00 && codePoint <= 0xdfff;
}
// Truncate string by size in bytes
module.exports = function getByteLength(string) {
    if (typeof string !== "string") throw new Error("Input must be string");
    var charLength = string.length;
    var byteLength = 0;
    var codePoint = null;
    var prevCodePoint = null;
    for(var i = 0; i < charLength; i++){
        codePoint = string.charCodeAt(i);
        // handle 4-byte non-BMP chars
        // low surrogate
        if ($f590d1e891426904$var$isLowSurrogate(codePoint)) {
            // when parsing previous hi-surrogate, 3 is added to byteLength
            if (prevCodePoint != null && $f590d1e891426904$var$isHighSurrogate(prevCodePoint)) byteLength += 1;
            else byteLength += 3;
        } else if (codePoint <= 0x7f) byteLength += 1;
        else if (codePoint >= 0x80 && codePoint <= 0x7ff) byteLength += 2;
        else if (codePoint >= 0x800 && codePoint <= 0xffff) byteLength += 3;
        prevCodePoint = codePoint;
    }
    return byteLength;
};

});



parcelRequire.register("jqljq", function(module, exports) {

$parcel$export(module.exports, "keys", () => $e240fa35ba13ad90$export$ed97f33186d4b816, (v) => $e240fa35ba13ad90$export$ed97f33186d4b816 = v);
$parcel$export(module.exports, "randomBytes", () => $e240fa35ba13ad90$export$5f828d93ff035aa8, (v) => $e240fa35ba13ad90$export$5f828d93ff035aa8 = v);
$parcel$export(module.exports, "pbkdf2", () => $e240fa35ba13ad90$export$448fa22aedc9dbca, (v) => $e240fa35ba13ad90$export$448fa22aedc9dbca = v);
var $e240fa35ba13ad90$export$12e89174be25f9f0;
var $e240fa35ba13ad90$export$355af40f8ab02f34;
var $e240fa35ba13ad90$export$ed97f33186d4b816;
var $e240fa35ba13ad90$export$5f828d93ff035aa8;
var $e240fa35ba13ad90$export$448fa22aedc9dbca;
"use strict";

var $eREVT = parcelRequire("eREVT");

var $a0yHQ = parcelRequire("a0yHQ");

var $iCaRA = parcelRequire("iCaRA");
$e240fa35ba13ad90$export$12e89174be25f9f0 = $a0yHQ;
$e240fa35ba13ad90$export$355af40f8ab02f34 = $eREVT;
$e240fa35ba13ad90$export$ed97f33186d4b816 = $iCaRA;

$e240fa35ba13ad90$export$5f828d93ff035aa8 = (parcelRequire("3b0KS"));

$e240fa35ba13ad90$export$448fa22aedc9dbca = (parcelRequire("joLwM"));

});
parcelRequire.register("a0yHQ", function(module, exports) {

$parcel$export(module.exports, "create", () => $7494d361ca288c3a$export$185802fd694ee1f5, (v) => $7494d361ca288c3a$export$185802fd694ee1f5 = v);
var $7494d361ca288c3a$export$185802fd694ee1f5;
"use strict";

var $2BeSV = parcelRequire("2BeSV");

var $1L1rE = parcelRequire("1L1rE");
$7494d361ca288c3a$export$185802fd694ee1f5 = async function(key, iv) {
    const mode = $1L1rE(key);
    const cipher = $2BeSV.createCipheriv(mode, key, iv);
    const decipher = $2BeSV.createDecipheriv(mode, key, iv);
    const res = {
        async encrypt (data) {
            return cipher.update(data);
        },
        async decrypt (data) {
            return decipher.update(data);
        }
    };
    return res;
};

});
parcelRequire.register("2BeSV", function(module, exports) {
"use strict";
parcelRequire("8ju3Y");

var $hSPkV = parcelRequire("hSPkV");

var $6rBCs = parcelRequire("6rBCs");
var $1e4a954cb257bb8c$require$uint8ArrayToString = $6rBCs.toString;

var $8cWjP = parcelRequire("8cWjP");
var $1e4a954cb257bb8c$require$uint8ArrayFromString = $8cWjP.fromString;
module.exports = {
    createCipheriv: (mode, key, iv)=>{
        const cipher2 = $hSPkV.cipher.createCipher("AES-CTR", $1e4a954cb257bb8c$require$uint8ArrayToString(key, "ascii"));
        cipher2.start({
            iv: $1e4a954cb257bb8c$require$uint8ArrayToString(iv, "ascii")
        });
        return {
            update: (data)=>{
                cipher2.update($hSPkV.util.createBuffer($1e4a954cb257bb8c$require$uint8ArrayToString(data, "ascii")));
                return $1e4a954cb257bb8c$require$uint8ArrayFromString(cipher2.output.getBytes(), "ascii");
            }
        };
    },
    createDecipheriv: (mode, key, iv)=>{
        const cipher2 = $hSPkV.cipher.createDecipher("AES-CTR", $1e4a954cb257bb8c$require$uint8ArrayToString(key, "ascii"));
        cipher2.start({
            iv: $1e4a954cb257bb8c$require$uint8ArrayToString(iv, "ascii")
        });
        return {
            update: (data)=>{
                cipher2.update($hSPkV.util.createBuffer($1e4a954cb257bb8c$require$uint8ArrayToString(data, "ascii")));
                return $1e4a954cb257bb8c$require$uint8ArrayFromString(cipher2.output.getBytes(), "ascii");
            }
        };
    }
};

});

parcelRequire.register("1L1rE", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");
const $147b4d28bc5d8687$var$CIPHER_MODES = {
    16: "aes-128-ctr",
    32: "aes-256-ctr"
};
module.exports = function(key) {
    const mode = $147b4d28bc5d8687$var$CIPHER_MODES[key.length];
    if (!mode) {
        const modes = Object.entries($147b4d28bc5d8687$var$CIPHER_MODES).map(([k, v])=>`${k} (${v})`).join(" / ");
        throw $20Lm5(new Error(`Invalid key length ${key.length} bytes. Must be ${modes}`), "ERR_INVALID_KEY_LENGTH");
    }
    return mode;
};

});


parcelRequire.register("joLwM", function(module, exports) {
"use strict";

var $6mmjF = parcelRequire("6mmjF");

var $3lPw4 = parcelRequire("3lPw4");

var $20Lm5 = parcelRequire("20Lm5");
/**
 * Maps an IPFS hash name to its node-forge equivalent.
 *
 * See https://github.com/multiformats/multihash/blob/master/hashtable.csv
 *
 * @private
 */ const $e1f520392b2ca357$var$hashName = {
    sha1: "sha1",
    "sha2-256": "sha256",
    "sha2-512": "sha512"
};
/**
 * Computes the Password-Based Key Derivation Function 2.
 *
 * @param {string} password
 * @param {string} salt
 * @param {number} iterations
 * @param {number} keySize - (in bytes)
 * @param {string} hash - The hash name ('sha1', 'sha2-512, ...)
 * @returns {string} - A new password
 */ function $e1f520392b2ca357$var$pbkdf2(password, salt, iterations, keySize, hash) {
    const hasher = $e1f520392b2ca357$var$hashName[hash];
    if (!hasher) {
        const types = Object.keys($e1f520392b2ca357$var$hashName).join(" / ");
        throw $20Lm5(new Error(`Hash '${hash}' is unknown or not supported. Must be ${types}`), "ERR_UNSUPPORTED_HASH_TYPE");
    }
    const dek = $6mmjF(password, salt, iterations, keySize, hasher);
    return $3lPw4.encode64(dek);
}
module.exports = $e1f520392b2ca357$var$pbkdf2;

});


parcelRequire.register("e2ec8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hzw9B = parcelRequire("hzw9B");

var $6rBCs = parcelRequire("6rBCs");

var $8cWjP = parcelRequire("8cWjP");
const $a37c435adcdb9f61$var$pathSepS = "/";
const $a37c435adcdb9f61$var$pathSepB = new TextEncoder().encode($a37c435adcdb9f61$var$pathSepS);
const $a37c435adcdb9f61$var$pathSep = $a37c435adcdb9f61$var$pathSepB[0];
class $a37c435adcdb9f61$var$Key {
    constructor(s, clean){
        if (typeof s === "string") this._buf = $8cWjP.fromString(s);
        else if (s instanceof Uint8Array) this._buf = s;
        else throw new Error("Invalid key, should be String of Uint8Array");
        if (clean == null) clean = true;
        if (clean) this.clean();
        if (this._buf.byteLength === 0 || this._buf[0] !== $a37c435adcdb9f61$var$pathSep) throw new Error("Invalid key");
    }
    toString(encoding = "utf8") {
        return $6rBCs.toString(this._buf, encoding);
    }
    uint8Array() {
        return this._buf;
    }
    get [Symbol.toStringTag]() {
        return `Key(${this.toString()})`;
    }
    static withNamespaces(list) {
        return new $a37c435adcdb9f61$var$Key(list.join($a37c435adcdb9f61$var$pathSepS));
    }
    static random() {
        return new $a37c435adcdb9f61$var$Key($hzw9B.nanoid().replace(/-/g, ""));
    }
    static asKey(other) {
        if (other instanceof Uint8Array || typeof other === "string") return new $a37c435adcdb9f61$var$Key(other);
        if (other.uint8Array) return new $a37c435adcdb9f61$var$Key(other.uint8Array());
        return null;
    }
    clean() {
        if (!this._buf || this._buf.byteLength === 0) this._buf = $a37c435adcdb9f61$var$pathSepB;
        if (this._buf[0] !== $a37c435adcdb9f61$var$pathSep) {
            const bytes = new Uint8Array(this._buf.byteLength + 1);
            bytes.fill($a37c435adcdb9f61$var$pathSep, 0, 1);
            bytes.set(this._buf, 1);
            this._buf = bytes;
        }
        while(this._buf.byteLength > 1 && this._buf[this._buf.byteLength - 1] === $a37c435adcdb9f61$var$pathSep)this._buf = this._buf.subarray(0, -1);
    }
    less(key) {
        const list1 = this.list();
        const list2 = key.list();
        for(let i = 0; i < list1.length; i++){
            if (list2.length < i + 1) return false;
            const c1 = list1[i];
            const c2 = list2[i];
            if (c1 < c2) return true;
            else if (c1 > c2) return false;
        }
        return list1.length < list2.length;
    }
    reverse() {
        return $a37c435adcdb9f61$var$Key.withNamespaces(this.list().slice().reverse());
    }
    namespaces() {
        return this.list();
    }
    baseNamespace() {
        const ns = this.namespaces();
        return ns[ns.length - 1];
    }
    list() {
        return this.toString().split($a37c435adcdb9f61$var$pathSepS).slice(1);
    }
    type() {
        return $a37c435adcdb9f61$var$namespaceType(this.baseNamespace());
    }
    name() {
        return $a37c435adcdb9f61$var$namespaceValue(this.baseNamespace());
    }
    instance(s) {
        return new $a37c435adcdb9f61$var$Key(this.toString() + ":" + s);
    }
    path() {
        let p = this.parent().toString();
        if (!p.endsWith($a37c435adcdb9f61$var$pathSepS)) p += $a37c435adcdb9f61$var$pathSepS;
        p += this.type();
        return new $a37c435adcdb9f61$var$Key(p);
    }
    parent() {
        const list = this.list();
        if (list.length === 1) return new $a37c435adcdb9f61$var$Key($a37c435adcdb9f61$var$pathSepS);
        return new $a37c435adcdb9f61$var$Key(list.slice(0, -1).join($a37c435adcdb9f61$var$pathSepS));
    }
    child(key) {
        if (this.toString() === $a37c435adcdb9f61$var$pathSepS) return key;
        else if (key.toString() === $a37c435adcdb9f61$var$pathSepS) return this;
        return new $a37c435adcdb9f61$var$Key(this.toString() + key.toString(), false);
    }
    isAncestorOf(other) {
        if (other.toString() === this.toString()) return false;
        return other.toString().startsWith(this.toString());
    }
    isDecendantOf(other) {
        if (other.toString() === this.toString()) return false;
        return this.toString().startsWith(other.toString());
    }
    isTopLevel() {
        return this.list().length === 1;
    }
    concat(...keys) {
        return $a37c435adcdb9f61$var$Key.withNamespaces([
            ...this.namespaces(),
            ...$a37c435adcdb9f61$var$flatten(keys.map((key)=>key.namespaces()))
        ]);
    }
}
function $a37c435adcdb9f61$var$namespaceType(ns) {
    const parts = ns.split(":");
    if (parts.length < 2) return "";
    return parts.slice(0, -1).join(":");
}
function $a37c435adcdb9f61$var$namespaceValue(ns) {
    const parts = ns.split(":");
    return parts[parts.length - 1];
}
function $a37c435adcdb9f61$var$flatten(arr) {
    return [].concat(...arr);
}
module.exports.Key = $a37c435adcdb9f61$var$Key;

});
parcelRequire.register("hzw9B", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $ccaea5aa24ded98f$export$ac4959f4f1338dfc);

var $pjFxO = parcelRequire("pjFxO");
let $ccaea5aa24ded98f$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $ccaea5aa24ded98f$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step | 0;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $ccaea5aa24ded98f$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$ccaea5aa24ded98f$export$a5cee9e955a615e5(alphabet, size, $ccaea5aa24ded98f$export$4385e60b38654f68);
let $ccaea5aa24ded98f$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");

});
parcelRequire.register("pjFxO", function(module, exports) {
let $04c197c80f3cf420$export$2b646eea95309f00 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";

});



parcelRequire.register("jkEBc", function(module, exports) {
"use strict";
parcelRequire("9ti0P");
parcelRequire("8EmV9");

var $2xc86 = parcelRequire("2xc86");

var $kEvOj = parcelRequire("kEvOj");
var $e12f60ab93eb1660$require$certificateForKey = $kEvOj.certificateForKey;
var $e12f60ab93eb1660$require$findAsync = $kEvOj.findAsync;

var $20Lm5 = parcelRequire("20Lm5");

var $8cWjP = parcelRequire("8cWjP");
var $e12f60ab93eb1660$require$uint8ArrayFromString = $8cWjP.fromString;

var $6rBCs = parcelRequire("6rBCs");
var $e12f60ab93eb1660$require$uint8ArrayToString = $6rBCs.toString;

var $8yAh4 = parcelRequire("8yAh4");
var $e12f60ab93eb1660$require$codes = $8yAh4.codes;
const $e12f60ab93eb1660$var$privates = new WeakMap();
/**
 * Cryptographic Message Syntax (aka PKCS #7)
 *
 * CMS describes an encapsulation syntax for data protection. It
 * is used to digitally sign, digest, authenticate, or encrypt
 * arbitrary message content.
 *
 * See RFC 5652 for all the details.
 */ class $e12f60ab93eb1660$var$CMS {
    /**
   * Creates a new instance with a keychain
   *
   * @param {import('./index')} keychain - the available keys
   * @param {string} dek
   */ constructor(keychain, dek){
        if (!keychain) throw $20Lm5(new Error("keychain is required"), $e12f60ab93eb1660$require$codes.ERR_KEYCHAIN_REQUIRED);
        this.keychain = keychain;
        $e12f60ab93eb1660$var$privates.set(this, {
            dek: dek
        });
    }
    /**
   * Creates some protected data.
   *
   * The output Uint8Array contains the PKCS #7 message in DER.
   *
   * @param {string} name - The local key name.
   * @param {Uint8Array} plain - The data to encrypt.
   * @returns {Promise<Uint8Array>}
   */ async encrypt(name, plain) {
        if (!(plain instanceof Uint8Array)) throw $20Lm5(new Error("Plain data must be a Uint8Array"), $e12f60ab93eb1660$require$codes.ERR_INVALID_PARAMETERS);
        const key = await this.keychain.findKeyByName(name);
        const pem = await this.keychain._getPrivateKey(name);
        /** @type {string} */ const dek = $e12f60ab93eb1660$var$privates.get(this).dek;
        const privateKey = $2xc86.pki.decryptRsaPrivateKey(pem, dek);
        const certificate = await $e12f60ab93eb1660$require$certificateForKey(key, privateKey);
        // create a p7 enveloped message
        const p7 = $2xc86.pkcs7.createEnvelopedData();
        p7.addRecipient(certificate);
        p7.content = $2xc86.util.createBuffer(plain);
        p7.encrypt();
        // convert message to DER
        const der = $2xc86.asn1.toDer(p7.toAsn1()).getBytes();
        return $e12f60ab93eb1660$require$uint8ArrayFromString(der, "ascii");
    }
    /**
   * Reads some protected data.
   *
   * The keychain must contain one of the keys used to encrypt the data.  If none of the keys
   * exists, an Error is returned with the property 'missingKeys'.  It is array of key ids.
   *
   * @param {Uint8Array} cmsData - The CMS encrypted data to decrypt.
   * @returns {Promise<Uint8Array>}
   */ async decrypt(cmsData) {
        if (!(cmsData instanceof Uint8Array)) throw $20Lm5(new Error("CMS data is required"), $e12f60ab93eb1660$require$codes.ERR_INVALID_PARAMETERS);
        let cms;
        try {
            const buf = $2xc86.util.createBuffer($e12f60ab93eb1660$require$uint8ArrayToString(cmsData, "ascii"));
            const obj = $2xc86.asn1.fromDer(buf);
            // @ts-ignore not defined
            cms = $2xc86.pkcs7.messageFromAsn1(obj);
        } catch (/** @type {any} */ err) {
            throw $20Lm5(new Error("Invalid CMS: " + err.message), $e12f60ab93eb1660$require$codes.ERR_INVALID_CMS);
        }
        // Find a recipient whose key we hold. We only deal with recipient certs
        // issued by ipfs (O=ipfs).
        const recipients = cms.recipients// @ts-ignore cms types not defined
        .filter((r)=>r.issuer.find((a)=>a.shortName === "O" && a.value === "ipfs"))// @ts-ignore cms types not defined
        .filter((r)=>r.issuer.find((a)=>a.shortName === "CN"))// @ts-ignore cms types not defined
        .map((r)=>{
            return {
                recipient: r,
                // @ts-ignore cms types not defined
                keyId: r.issuer.find((a)=>a.shortName === "CN").value
            };
        });
        const r = await $e12f60ab93eb1660$require$findAsync(recipients, async (recipient)=>{
            try {
                const key = await this.keychain.findKeyById(recipient.keyId);
                if (key) return true;
            } catch (/** @type {any} */ err) {
                return false;
            }
            return false;
        });
        if (!r) {
            // @ts-ignore cms types not defined
            const missingKeys = recipients.map((r)=>r.keyId);
            throw $20Lm5(new Error("Decryption needs one of the key(s): " + missingKeys.join(", ")), $e12f60ab93eb1660$require$codes.ERR_MISSING_KEYS, {
                missingKeys: missingKeys
            });
        }
        const key = await this.keychain.findKeyById(r.keyId);
        if (!key) throw $20Lm5(new Error("No key available to decrypto"), $e12f60ab93eb1660$require$codes.ERR_NO_KEY);
        const pem = await this.keychain._getPrivateKey(key.name);
        const dek = $e12f60ab93eb1660$var$privates.get(this).dek;
        const privateKey = $2xc86.pki.decryptRsaPrivateKey(pem, dek);
        cms.decrypt(r.recipient, privateKey);
        return $e12f60ab93eb1660$require$uint8ArrayFromString(cms.content.getBytes(), "ascii");
    }
}
module.exports = $e12f60ab93eb1660$var$CMS;

});
parcelRequire.register("9ti0P", function(module, exports) {
/**
 * Javascript implementation of PKCS#7 v1.5.
 *
 * @author Stefan Siegl
 * @author Dave Longley
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 * Copyright (c) 2012-2015 Digital Bazaar, Inc.
 *
 * Currently this implementation only supports ContentType of EnvelopedData,
 * EncryptedData, or SignedData at the root level. The top level elements may
 * contain only a ContentInfo of ContentType Data, i.e. plain data. Further
 * nesting is not (yet) supported.
 *
 * The Forge validators for PKCS #7's ASN.1 structures are available from
 * a separate file pkcs7asn1.js, since those are referenced from other
 * PKCS standards like PKCS #12.
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("a7tnS");
parcelRequire("l46Tq");
parcelRequire("1UAMB");
parcelRequire("hzEKF");
parcelRequire("1x89g");
parcelRequire("hZ2Gb");
parcelRequire("eeWuT");
parcelRequire("e73pV");
parcelRequire("5uwlA");
// shortcut for ASN.1 API
var $6e54cb5e6e58069b$var$asn1 = $2xc86.asn1;
// shortcut for PKCS#7 API
var $6e54cb5e6e58069b$var$p7 = module.exports = $2xc86.pkcs7 = $2xc86.pkcs7 || {};
/**
 * Converts a PKCS#7 message from PEM format.
 *
 * @param pem the PEM-formatted PKCS#7 message.
 *
 * @return the PKCS#7 message.
 */ $6e54cb5e6e58069b$var$p7.messageFromPem = function(pem) {
    var msg = $2xc86.pem.decode(pem)[0];
    if (msg.type !== "PKCS7") {
        var error = new Error('Could not convert PKCS#7 message from PEM; PEM header type is not "PKCS#7".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert PKCS#7 message from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    var obj = $6e54cb5e6e58069b$var$asn1.fromDer(msg.body);
    return $6e54cb5e6e58069b$var$p7.messageFromAsn1(obj);
};
/**
 * Converts a PKCS#7 message to PEM format.
 *
 * @param msg The PKCS#7 message object
 * @param maxline The maximum characters per line, defaults to 64.
 *
 * @return The PEM-formatted PKCS#7 message.
 */ $6e54cb5e6e58069b$var$p7.messageToPem = function(msg, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var pemObj = {
        type: "PKCS7",
        body: $6e54cb5e6e58069b$var$asn1.toDer(msg.toAsn1()).getBytes()
    };
    return $2xc86.pem.encode(pemObj, {
        maxline: maxline
    });
};
/**
 * Converts a PKCS#7 message from an ASN.1 object.
 *
 * @param obj the ASN.1 representation of a ContentInfo.
 *
 * @return the PKCS#7 message.
 */ $6e54cb5e6e58069b$var$p7.messageFromAsn1 = function(obj) {
    // validate root level ContentInfo and capture data
    var capture = {};
    var errors = [];
    if (!$6e54cb5e6e58069b$var$asn1.validate(obj, $6e54cb5e6e58069b$var$p7.asn1.contentInfoValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#7 message. ASN.1 object is not an PKCS#7 ContentInfo.");
        error.errors = errors;
        throw error;
    }
    var contentType = $6e54cb5e6e58069b$var$asn1.derToOid(capture.contentType);
    var msg;
    switch(contentType){
        case $2xc86.pki.oids.envelopedData:
            msg = $6e54cb5e6e58069b$var$p7.createEnvelopedData();
            break;
        case $2xc86.pki.oids.encryptedData:
            msg = $6e54cb5e6e58069b$var$p7.createEncryptedData();
            break;
        case $2xc86.pki.oids.signedData:
            msg = $6e54cb5e6e58069b$var$p7.createSignedData();
            break;
        default:
            throw new Error("Cannot read PKCS#7 message. ContentType with OID " + contentType + " is not (yet) supported.");
    }
    msg.fromAsn1(capture.content.value[0]);
    return msg;
};
$6e54cb5e6e58069b$var$p7.createSignedData = function() {
    var msg = null;
    msg = {
        type: $2xc86.pki.oids.signedData,
        version: 1,
        certificates: [],
        crls: [],
        // TODO: add json-formatted signer stuff here?
        signers: [],
        // populated during sign()
        digestAlgorithmIdentifiers: [],
        contentInfo: null,
        signerInfos: [],
        fromAsn1: function(obj) {
            // validate SignedData content block and capture data.
            $6e54cb5e6e58069b$var$_fromAsn1(msg, obj, $6e54cb5e6e58069b$var$p7.asn1.signedDataValidator);
            msg.certificates = [];
            msg.crls = [];
            msg.digestAlgorithmIdentifiers = [];
            msg.contentInfo = null;
            msg.signerInfos = [];
            if (msg.rawCapture.certificates) {
                var certs = msg.rawCapture.certificates.value;
                for(var i = 0; i < certs.length; ++i)msg.certificates.push($2xc86.pki.certificateFromAsn1(certs[i]));
            }
        // TODO: parse crls
        },
        toAsn1: function() {
            // degenerate case with no content
            if (!msg.contentInfo) msg.sign();
            var certs = [];
            for(var i = 0; i < msg.certificates.length; ++i)certs.push($2xc86.pki.certificateToAsn1(msg.certificates[i]));
            var crls = [];
            // TODO: implement CRLs
            // [0] SignedData
            var signedData = $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SEQUENCE, true, [
                    // Version
                    $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.INTEGER, false, $6e54cb5e6e58069b$var$asn1.integerToDer(msg.version).getBytes()),
                    // DigestAlgorithmIdentifiers
                    $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SET, true, msg.digestAlgorithmIdentifiers),
                    // ContentInfo
                    msg.contentInfo
                ])
            ]);
            if (certs.length > 0) // [0] IMPLICIT ExtendedCertificatesAndCertificates OPTIONAL
            signedData.value[0].value.push($6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, certs));
            if (crls.length > 0) // [1] IMPLICIT CertificateRevocationLists OPTIONAL
            signedData.value[0].value.push($6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, crls));
            // SignerInfos
            signedData.value[0].value.push($6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SET, true, msg.signerInfos));
            // ContentInfo
            return $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SEQUENCE, true, [
                // ContentType
                $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OID, false, $6e54cb5e6e58069b$var$asn1.oidToDer(msg.type).getBytes()),
                // [0] SignedData
                signedData
            ]);
        },
        /**
     * Add (another) entity to list of signers.
     *
     * Note: If authenticatedAttributes are provided, then, per RFC 2315,
     * they must include at least two attributes: content type and
     * message digest. The message digest attribute value will be
     * auto-calculated during signing and will be ignored if provided.
     *
     * Here's an example of providing these two attributes:
     *
     * forge.pkcs7.createSignedData();
     * p7.addSigner({
     *   issuer: cert.issuer.attributes,
     *   serialNumber: cert.serialNumber,
     *   key: privateKey,
     *   digestAlgorithm: forge.pki.oids.sha1,
     *   authenticatedAttributes: [{
     *     type: forge.pki.oids.contentType,
     *     value: forge.pki.oids.data
     *   }, {
     *     type: forge.pki.oids.messageDigest
     *   }]
     * });
     *
     * TODO: Support [subjectKeyIdentifier] as signer's ID.
     *
     * @param signer the signer information:
     *          key the signer's private key.
     *          [certificate] a certificate containing the public key
     *            associated with the signer's private key; use this option as
     *            an alternative to specifying signer.issuer and
     *            signer.serialNumber.
     *          [issuer] the issuer attributes (eg: cert.issuer.attributes).
     *          [serialNumber] the signer's certificate's serial number in
     *           hexadecimal (eg: cert.serialNumber).
     *          [digestAlgorithm] the message digest OID, as a string, to use
     *            (eg: forge.pki.oids.sha1).
     *          [authenticatedAttributes] an optional array of attributes
     *            to also sign along with the content.
     */ addSigner: function(signer) {
            var issuer = signer.issuer;
            var serialNumber = signer.serialNumber;
            if (signer.certificate) {
                var cert = signer.certificate;
                if (typeof cert === "string") cert = $2xc86.pki.certificateFromPem(cert);
                issuer = cert.issuer.attributes;
                serialNumber = cert.serialNumber;
            }
            var key = signer.key;
            if (!key) throw new Error("Could not add PKCS#7 signer; no private key specified.");
            if (typeof key === "string") key = $2xc86.pki.privateKeyFromPem(key);
            // ensure OID known for digest algorithm
            var digestAlgorithm = signer.digestAlgorithm || $2xc86.pki.oids.sha1;
            switch(digestAlgorithm){
                case $2xc86.pki.oids.sha1:
                case $2xc86.pki.oids.sha256:
                case $2xc86.pki.oids.sha384:
                case $2xc86.pki.oids.sha512:
                case $2xc86.pki.oids.md5:
                    break;
                default:
                    throw new Error("Could not add PKCS#7 signer; unknown message digest algorithm: " + digestAlgorithm);
            }
            // if authenticatedAttributes is present, then the attributes
            // must contain at least PKCS #9 content-type and message-digest
            var authenticatedAttributes = signer.authenticatedAttributes || [];
            if (authenticatedAttributes.length > 0) {
                var contentType = false;
                var messageDigest = false;
                for(var i = 0; i < authenticatedAttributes.length; ++i){
                    var attr = authenticatedAttributes[i];
                    if (!contentType && attr.type === $2xc86.pki.oids.contentType) {
                        contentType = true;
                        if (messageDigest) break;
                        continue;
                    }
                    if (!messageDigest && attr.type === $2xc86.pki.oids.messageDigest) {
                        messageDigest = true;
                        if (contentType) break;
                        continue;
                    }
                }
                if (!contentType || !messageDigest) throw new Error("Invalid signer.authenticatedAttributes. If signer.authenticatedAttributes is specified, then it must contain at least two attributes, PKCS #9 content-type and PKCS #9 message-digest.");
            }
            msg.signers.push({
                key: key,
                version: 1,
                issuer: issuer,
                serialNumber: serialNumber,
                digestAlgorithm: digestAlgorithm,
                signatureAlgorithm: $2xc86.pki.oids.rsaEncryption,
                signature: null,
                authenticatedAttributes: authenticatedAttributes,
                unauthenticatedAttributes: []
            });
        },
        /**
     * Signs the content.
     * @param options Options to apply when signing:
     *    [detached] boolean. If signing should be done in detached mode. Defaults to false.
     */ sign: function(options) {
            options = options || {};
            // auto-generate content info
            if (typeof msg.content !== "object" || msg.contentInfo === null) {
                // use Data ContentInfo
                msg.contentInfo = $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SEQUENCE, true, [
                    // ContentType
                    $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OID, false, $6e54cb5e6e58069b$var$asn1.oidToDer($2xc86.pki.oids.data).getBytes())
                ]);
                // add actual content, if present
                if ("content" in msg) {
                    var content;
                    if (msg.content instanceof $2xc86.util.ByteBuffer) content = msg.content.bytes();
                    else if (typeof msg.content === "string") content = $2xc86.util.encodeUtf8(msg.content);
                    if (options.detached) msg.detachedContent = $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OCTETSTRING, false, content);
                    else msg.contentInfo.value.push(// [0] EXPLICIT content
                    $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OCTETSTRING, false, content)
                    ]));
                }
            }
            // no signers, return early (degenerate case for certificate container)
            if (msg.signers.length === 0) return;
            // generate digest algorithm identifiers
            var mds = addDigestAlgorithmIds();
            // generate signerInfos
            addSignerInfos(mds);
        },
        verify: function() {
            throw new Error("PKCS#7 signature verification not yet implemented.");
        },
        /**
     * Add a certificate.
     *
     * @param cert the certificate to add.
     */ addCertificate: function(cert) {
            // convert from PEM
            if (typeof cert === "string") cert = $2xc86.pki.certificateFromPem(cert);
            msg.certificates.push(cert);
        },
        /**
     * Add a certificate revokation list.
     *
     * @param crl the certificate revokation list to add.
     */ addCertificateRevokationList: function(crl) {
            throw new Error("PKCS#7 CRL support not yet implemented.");
        }
    };
    return msg;
    function addDigestAlgorithmIds() {
        var mds = {};
        for(var i = 0; i < msg.signers.length; ++i){
            var signer = msg.signers[i];
            var oid = signer.digestAlgorithm;
            if (!(oid in mds)) // content digest
            mds[oid] = $2xc86.md[$2xc86.pki.oids[oid]].create();
            if (signer.authenticatedAttributes.length === 0) // no custom attributes to digest; use content message digest
            signer.md = mds[oid];
            else // custom attributes to be digested; use own message digest
            // TODO: optimize to just copy message digest state if that
            // feature is ever supported with message digests
            signer.md = $2xc86.md[$2xc86.pki.oids[oid]].create();
        }
        // add unique digest algorithm identifiers
        msg.digestAlgorithmIdentifiers = [];
        for(var oid in mds)msg.digestAlgorithmIdentifiers.push(// AlgorithmIdentifier
        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OID, false, $6e54cb5e6e58069b$var$asn1.oidToDer(oid).getBytes()),
            // parameters (null)
            $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.NULL, false, "")
        ]));
        return mds;
    }
    function addSignerInfos(mds) {
        var content;
        if (msg.detachedContent) // Signature has been made in detached mode.
        content = msg.detachedContent;
        else {
            // Note: ContentInfo is a SEQUENCE with 2 values, second value is
            // the content field and is optional for a ContentInfo but required here
            // since signers are present
            // get ContentInfo content
            content = msg.contentInfo.value[1];
            // skip [0] EXPLICIT content wrapper
            content = content.value[0];
        }
        if (!content) throw new Error("Could not sign PKCS#7 message; there is no content to sign.");
        // get ContentInfo content type
        var contentType = $6e54cb5e6e58069b$var$asn1.derToOid(msg.contentInfo.value[0].value);
        // serialize content
        var bytes = $6e54cb5e6e58069b$var$asn1.toDer(content);
        // skip identifier and length per RFC 2315 9.3
        // skip identifier (1 byte)
        bytes.getByte();
        // read and discard length bytes
        $6e54cb5e6e58069b$var$asn1.getBerValueLength(bytes);
        bytes = bytes.getBytes();
        // digest content DER value bytes
        for(var oid in mds)mds[oid].start().update(bytes);
        // sign content
        var signingTime = new Date();
        for(var i = 0; i < msg.signers.length; ++i){
            var signer = msg.signers[i];
            if (signer.authenticatedAttributes.length === 0) {
                // if ContentInfo content type is not "Data", then
                // authenticatedAttributes must be present per RFC 2315
                if (contentType !== $2xc86.pki.oids.data) throw new Error("Invalid signer; authenticatedAttributes must be present when the ContentInfo content type is not PKCS#7 Data.");
            } else {
                // process authenticated attributes
                // [0] IMPLICIT
                signer.authenticatedAttributesAsn1 = $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, []);
                // per RFC 2315, attributes are to be digested using a SET container
                // not the above [0] IMPLICIT container
                var attrsAsn1 = $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SET, true, []);
                for(var ai = 0; ai < signer.authenticatedAttributes.length; ++ai){
                    var attr = signer.authenticatedAttributes[ai];
                    if (attr.type === $2xc86.pki.oids.messageDigest) // use content message digest as value
                    attr.value = mds[signer.digestAlgorithm].digest();
                    else if (attr.type === $2xc86.pki.oids.signingTime) // auto-populate signing time if not already set
                    {
                        if (!attr.value) attr.value = signingTime;
                    }
                    // convert to ASN.1 and push onto Attributes SET (for signing) and
                    // onto authenticatedAttributesAsn1 to complete SignedData ASN.1
                    // TODO: optimize away duplication
                    attrsAsn1.value.push($6e54cb5e6e58069b$var$_attributeToAsn1(attr));
                    signer.authenticatedAttributesAsn1.value.push($6e54cb5e6e58069b$var$_attributeToAsn1(attr));
                }
                // DER-serialize and digest SET OF attributes only
                bytes = $6e54cb5e6e58069b$var$asn1.toDer(attrsAsn1).getBytes();
                signer.md.start().update(bytes);
            }
            // sign digest
            signer.signature = signer.key.sign(signer.md, "RSASSA-PKCS1-V1_5");
        }
        // add signer info
        msg.signerInfos = $6e54cb5e6e58069b$var$_signersToAsn1(msg.signers);
    }
};
/**
 * Creates an empty PKCS#7 message of type EncryptedData.
 *
 * @return the message.
 */ $6e54cb5e6e58069b$var$p7.createEncryptedData = function() {
    var msg = null;
    msg = {
        type: $2xc86.pki.oids.encryptedData,
        version: 0,
        encryptedContent: {
            algorithm: $2xc86.pki.oids["aes256-CBC"]
        },
        /**
     * Reads an EncryptedData content block (in ASN.1 format)
     *
     * @param obj The ASN.1 representation of the EncryptedData content block
     */ fromAsn1: function(obj) {
            // Validate EncryptedData content block and capture data.
            $6e54cb5e6e58069b$var$_fromAsn1(msg, obj, $6e54cb5e6e58069b$var$p7.asn1.encryptedDataValidator);
        },
        /**
     * Decrypt encrypted content
     *
     * @param key The (symmetric) key as a byte buffer
     */ decrypt: function(key) {
            if (key !== undefined) msg.encryptedContent.key = key;
            $6e54cb5e6e58069b$var$_decryptContent(msg);
        }
    };
    return msg;
};
/**
 * Creates an empty PKCS#7 message of type EnvelopedData.
 *
 * @return the message.
 */ $6e54cb5e6e58069b$var$p7.createEnvelopedData = function() {
    var msg = null;
    msg = {
        type: $2xc86.pki.oids.envelopedData,
        version: 0,
        recipients: [],
        encryptedContent: {
            algorithm: $2xc86.pki.oids["aes256-CBC"]
        },
        /**
     * Reads an EnvelopedData content block (in ASN.1 format)
     *
     * @param obj the ASN.1 representation of the EnvelopedData content block.
     */ fromAsn1: function(obj) {
            // validate EnvelopedData content block and capture data
            var capture = $6e54cb5e6e58069b$var$_fromAsn1(msg, obj, $6e54cb5e6e58069b$var$p7.asn1.envelopedDataValidator);
            msg.recipients = $6e54cb5e6e58069b$var$_recipientsFromAsn1(capture.recipientInfos.value);
        },
        toAsn1: function() {
            // ContentInfo
            return $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SEQUENCE, true, [
                // ContentType
                $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OID, false, $6e54cb5e6e58069b$var$asn1.oidToDer(msg.type).getBytes()),
                // [0] EnvelopedData
                $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                    $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SEQUENCE, true, [
                        // Version
                        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.INTEGER, false, $6e54cb5e6e58069b$var$asn1.integerToDer(msg.version).getBytes()),
                        // RecipientInfos
                        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SET, true, $6e54cb5e6e58069b$var$_recipientsToAsn1(msg.recipients)),
                        // EncryptedContentInfo
                        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SEQUENCE, true, $6e54cb5e6e58069b$var$_encryptedContentToAsn1(msg.encryptedContent))
                    ])
                ])
            ]);
        },
        /**
     * Find recipient by X.509 certificate's issuer.
     *
     * @param cert the certificate with the issuer to look for.
     *
     * @return the recipient object.
     */ findRecipient: function(cert) {
            var sAttr = cert.issuer.attributes;
            for(var i = 0; i < msg.recipients.length; ++i){
                var r = msg.recipients[i];
                var rAttr = r.issuer;
                if (r.serialNumber !== cert.serialNumber) continue;
                if (rAttr.length !== sAttr.length) continue;
                var match = true;
                for(var j = 0; j < sAttr.length; ++j)if (rAttr[j].type !== sAttr[j].type || rAttr[j].value !== sAttr[j].value) {
                    match = false;
                    break;
                }
                if (match) return r;
            }
            return null;
        },
        /**
     * Decrypt enveloped content
     *
     * @param recipient The recipient object related to the private key
     * @param privKey The (RSA) private key object
     */ decrypt: function(recipient, privKey) {
            if (msg.encryptedContent.key === undefined && recipient !== undefined && privKey !== undefined) switch(recipient.encryptedContent.algorithm){
                case $2xc86.pki.oids.rsaEncryption:
                case $2xc86.pki.oids.desCBC:
                    var key = privKey.decrypt(recipient.encryptedContent.content);
                    msg.encryptedContent.key = $2xc86.util.createBuffer(key);
                    break;
                default:
                    throw new Error("Unsupported asymmetric cipher, OID " + recipient.encryptedContent.algorithm);
            }
            $6e54cb5e6e58069b$var$_decryptContent(msg);
        },
        /**
     * Add (another) entity to list of recipients.
     *
     * @param cert The certificate of the entity to add.
     */ addRecipient: function(cert) {
            msg.recipients.push({
                version: 0,
                issuer: cert.issuer.attributes,
                serialNumber: cert.serialNumber,
                encryptedContent: {
                    // We simply assume rsaEncryption here, since forge.pki only
                    // supports RSA so far.  If the PKI module supports other
                    // ciphers one day, we need to modify this one as well.
                    algorithm: $2xc86.pki.oids.rsaEncryption,
                    key: cert.publicKey
                }
            });
        },
        /**
     * Encrypt enveloped content.
     *
     * This function supports two optional arguments, cipher and key, which
     * can be used to influence symmetric encryption.  Unless cipher is
     * provided, the cipher specified in encryptedContent.algorithm is used
     * (defaults to AES-256-CBC).  If no key is provided, encryptedContent.key
     * is (re-)used.  If that one's not set, a random key will be generated
     * automatically.
     *
     * @param [key] The key to be used for symmetric encryption.
     * @param [cipher] The OID of the symmetric cipher to use.
     */ encrypt: function(key, cipher) {
            // Part 1: Symmetric encryption
            if (msg.encryptedContent.content === undefined) {
                cipher = cipher || msg.encryptedContent.algorithm;
                key = key || msg.encryptedContent.key;
                var keyLen, ivLen, ciphFn;
                switch(cipher){
                    case $2xc86.pki.oids["aes128-CBC"]:
                        keyLen = 16;
                        ivLen = 16;
                        ciphFn = $2xc86.aes.createEncryptionCipher;
                        break;
                    case $2xc86.pki.oids["aes192-CBC"]:
                        keyLen = 24;
                        ivLen = 16;
                        ciphFn = $2xc86.aes.createEncryptionCipher;
                        break;
                    case $2xc86.pki.oids["aes256-CBC"]:
                        keyLen = 32;
                        ivLen = 16;
                        ciphFn = $2xc86.aes.createEncryptionCipher;
                        break;
                    case $2xc86.pki.oids["des-EDE3-CBC"]:
                        keyLen = 24;
                        ivLen = 8;
                        ciphFn = $2xc86.des.createEncryptionCipher;
                        break;
                    default:
                        throw new Error("Unsupported symmetric cipher, OID " + cipher);
                }
                if (key === undefined) key = $2xc86.util.createBuffer($2xc86.random.getBytes(keyLen));
                else if (key.length() != keyLen) throw new Error("Symmetric key has wrong length; got " + key.length() + " bytes, expected " + keyLen + ".");
                // Keep a copy of the key & IV in the object, so the caller can
                // use it for whatever reason.
                msg.encryptedContent.algorithm = cipher;
                msg.encryptedContent.key = key;
                msg.encryptedContent.parameter = $2xc86.util.createBuffer($2xc86.random.getBytes(ivLen));
                var ciph = ciphFn(key);
                ciph.start(msg.encryptedContent.parameter.copy());
                ciph.update(msg.content);
                // The finish function does PKCS#7 padding by default, therefore
                // no action required by us.
                if (!ciph.finish()) throw new Error("Symmetric encryption failed.");
                msg.encryptedContent.content = ciph.output;
            }
            // Part 2: asymmetric encryption for each recipient
            for(var i = 0; i < msg.recipients.length; ++i){
                var recipient = msg.recipients[i];
                // Nothing to do, encryption already done.
                if (recipient.encryptedContent.content !== undefined) continue;
                switch(recipient.encryptedContent.algorithm){
                    case $2xc86.pki.oids.rsaEncryption:
                        recipient.encryptedContent.content = recipient.encryptedContent.key.encrypt(msg.encryptedContent.key.data);
                        break;
                    default:
                        throw new Error("Unsupported asymmetric cipher, OID " + recipient.encryptedContent.algorithm);
                }
            }
        }
    };
    return msg;
};
/**
 * Converts a single recipient from an ASN.1 object.
 *
 * @param obj the ASN.1 RecipientInfo.
 *
 * @return the recipient object.
 */ function $6e54cb5e6e58069b$var$_recipientFromAsn1(obj) {
    // validate EnvelopedData content block and capture data
    var capture = {};
    var errors = [];
    if (!$6e54cb5e6e58069b$var$asn1.validate(obj, $6e54cb5e6e58069b$var$p7.asn1.recipientInfoValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#7 RecipientInfo. ASN.1 object is not an PKCS#7 RecipientInfo.");
        error.errors = errors;
        throw error;
    }
    return {
        version: capture.version.charCodeAt(0),
        issuer: $2xc86.pki.RDNAttributesAsArray(capture.issuer),
        serialNumber: $2xc86.util.createBuffer(capture.serial).toHex(),
        encryptedContent: {
            algorithm: $6e54cb5e6e58069b$var$asn1.derToOid(capture.encAlgorithm),
            parameter: capture.encParameter.value,
            content: capture.encKey
        }
    };
}
/**
 * Converts a single recipient object to an ASN.1 object.
 *
 * @param obj the recipient object.
 *
 * @return the ASN.1 RecipientInfo.
 */ function $6e54cb5e6e58069b$var$_recipientToAsn1(obj) {
    return $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SEQUENCE, true, [
        // Version
        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.INTEGER, false, $6e54cb5e6e58069b$var$asn1.integerToDer(obj.version).getBytes()),
        // IssuerAndSerialNumber
        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SEQUENCE, true, [
            // Name
            $2xc86.pki.distinguishedNameToAsn1({
                attributes: obj.issuer
            }),
            // Serial
            $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.INTEGER, false, $2xc86.util.hexToBytes(obj.serialNumber))
        ]),
        // KeyEncryptionAlgorithmIdentifier
        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SEQUENCE, true, [
            // Algorithm
            $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OID, false, $6e54cb5e6e58069b$var$asn1.oidToDer(obj.encryptedContent.algorithm).getBytes()),
            // Parameter, force NULL, only RSA supported for now.
            $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.NULL, false, "")
        ]),
        // EncryptedKey
        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OCTETSTRING, false, obj.encryptedContent.content)
    ]);
}
/**
 * Map a set of RecipientInfo ASN.1 objects to recipient objects.
 *
 * @param infos an array of ASN.1 representations RecipientInfo (i.e. SET OF).
 *
 * @return an array of recipient objects.
 */ function $6e54cb5e6e58069b$var$_recipientsFromAsn1(infos) {
    var ret = [];
    for(var i = 0; i < infos.length; ++i)ret.push($6e54cb5e6e58069b$var$_recipientFromAsn1(infos[i]));
    return ret;
}
/**
 * Map an array of recipient objects to ASN.1 RecipientInfo objects.
 *
 * @param recipients an array of recipientInfo objects.
 *
 * @return an array of ASN.1 RecipientInfos.
 */ function $6e54cb5e6e58069b$var$_recipientsToAsn1(recipients) {
    var ret = [];
    for(var i = 0; i < recipients.length; ++i)ret.push($6e54cb5e6e58069b$var$_recipientToAsn1(recipients[i]));
    return ret;
}
/**
 * Converts a single signer from an ASN.1 object.
 *
 * @param obj the ASN.1 representation of a SignerInfo.
 *
 * @return the signer object.
 */ function $6e54cb5e6e58069b$var$_signerFromAsn1(obj) {
    // validate EnvelopedData content block and capture data
    var capture = {};
    var errors = [];
    if (!$6e54cb5e6e58069b$var$asn1.validate(obj, $6e54cb5e6e58069b$var$p7.asn1.signerInfoValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#7 SignerInfo. ASN.1 object is not an PKCS#7 SignerInfo.");
        error.errors = errors;
        throw error;
    }
    var rval = {
        version: capture.version.charCodeAt(0),
        issuer: $2xc86.pki.RDNAttributesAsArray(capture.issuer),
        serialNumber: $2xc86.util.createBuffer(capture.serial).toHex(),
        digestAlgorithm: $6e54cb5e6e58069b$var$asn1.derToOid(capture.digestAlgorithm),
        signatureAlgorithm: $6e54cb5e6e58069b$var$asn1.derToOid(capture.signatureAlgorithm),
        signature: capture.signature,
        authenticatedAttributes: [],
        unauthenticatedAttributes: []
    };
    // TODO: convert attributes
    var authenticatedAttributes = capture.authenticatedAttributes || [];
    var unauthenticatedAttributes = capture.unauthenticatedAttributes || [];
    return rval;
}
/**
 * Converts a single signerInfo object to an ASN.1 object.
 *
 * @param obj the signerInfo object.
 *
 * @return the ASN.1 representation of a SignerInfo.
 */ function $6e54cb5e6e58069b$var$_signerToAsn1(obj) {
    // SignerInfo
    var rval = $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SEQUENCE, true, [
        // version
        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.INTEGER, false, $6e54cb5e6e58069b$var$asn1.integerToDer(obj.version).getBytes()),
        // issuerAndSerialNumber
        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SEQUENCE, true, [
            // name
            $2xc86.pki.distinguishedNameToAsn1({
                attributes: obj.issuer
            }),
            // serial
            $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.INTEGER, false, $2xc86.util.hexToBytes(obj.serialNumber))
        ]),
        // digestAlgorithm
        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OID, false, $6e54cb5e6e58069b$var$asn1.oidToDer(obj.digestAlgorithm).getBytes()),
            // parameters (null)
            $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.NULL, false, "")
        ])
    ]);
    // authenticatedAttributes (OPTIONAL)
    if (obj.authenticatedAttributesAsn1) // add ASN.1 previously generated during signing
    rval.value.push(obj.authenticatedAttributesAsn1);
    // digestEncryptionAlgorithm
    rval.value.push($6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SEQUENCE, true, [
        // algorithm
        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OID, false, $6e54cb5e6e58069b$var$asn1.oidToDer(obj.signatureAlgorithm).getBytes()),
        // parameters (null)
        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.NULL, false, "")
    ]));
    // encryptedDigest
    rval.value.push($6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OCTETSTRING, false, obj.signature));
    // unauthenticatedAttributes (OPTIONAL)
    if (obj.unauthenticatedAttributes.length > 0) {
        // [1] IMPLICIT
        var attrsAsn1 = $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, []);
        for(var i = 0; i < obj.unauthenticatedAttributes.length; ++i){
            var attr = obj.unauthenticatedAttributes[i];
            attrsAsn1.values.push($6e54cb5e6e58069b$var$_attributeToAsn1(attr));
        }
        rval.value.push(attrsAsn1);
    }
    return rval;
}
/**
 * Map a set of SignerInfo ASN.1 objects to an array of signer objects.
 *
 * @param signerInfoAsn1s an array of ASN.1 SignerInfos (i.e. SET OF).
 *
 * @return an array of signers objects.
 */ function $6e54cb5e6e58069b$var$_signersFromAsn1(signerInfoAsn1s) {
    var ret = [];
    for(var i = 0; i < signerInfoAsn1s.length; ++i)ret.push($6e54cb5e6e58069b$var$_signerFromAsn1(signerInfoAsn1s[i]));
    return ret;
}
/**
 * Map an array of signer objects to ASN.1 objects.
 *
 * @param signers an array of signer objects.
 *
 * @return an array of ASN.1 SignerInfos.
 */ function $6e54cb5e6e58069b$var$_signersToAsn1(signers) {
    var ret = [];
    for(var i = 0; i < signers.length; ++i)ret.push($6e54cb5e6e58069b$var$_signerToAsn1(signers[i]));
    return ret;
}
/**
 * Convert an attribute object to an ASN.1 Attribute.
 *
 * @param attr the attribute object.
 *
 * @return the ASN.1 Attribute.
 */ function $6e54cb5e6e58069b$var$_attributeToAsn1(attr) {
    var value;
    // TODO: generalize to support more attributes
    if (attr.type === $2xc86.pki.oids.contentType) value = $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OID, false, $6e54cb5e6e58069b$var$asn1.oidToDer(attr.value).getBytes());
    else if (attr.type === $2xc86.pki.oids.messageDigest) value = $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OCTETSTRING, false, attr.value.bytes());
    else if (attr.type === $2xc86.pki.oids.signingTime) {
        /* Note per RFC 2985: Dates between 1 January 1950 and 31 December 2049
      (inclusive) MUST be encoded as UTCTime. Any dates with year values
      before 1950 or after 2049 MUST be encoded as GeneralizedTime. [Further,]
      UTCTime values MUST be expressed in Greenwich Mean Time (Zulu) and MUST
      include seconds (i.e., times are YYMMDDHHMMSSZ), even where the
      number of seconds is zero.  Midnight (GMT) must be represented as
      "YYMMDD000000Z". */ // TODO: make these module-level constants
        var jan_1_1950 = new Date("1950-01-01T00:00:00Z");
        var jan_1_2050 = new Date("2050-01-01T00:00:00Z");
        var date = attr.value;
        if (typeof date === "string") {
            // try to parse date
            var timestamp = Date.parse(date);
            if (!isNaN(timestamp)) date = new Date(timestamp);
            else if (date.length === 13) // YYMMDDHHMMSSZ (13 chars for UTCTime)
            date = $6e54cb5e6e58069b$var$asn1.utcTimeToDate(date);
            else // assume generalized time
            date = $6e54cb5e6e58069b$var$asn1.generalizedTimeToDate(date);
        }
        if (date >= jan_1_1950 && date < jan_1_2050) value = $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.UTCTIME, false, $6e54cb5e6e58069b$var$asn1.dateToUtcTime(date));
        else value = $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.GENERALIZEDTIME, false, $6e54cb5e6e58069b$var$asn1.dateToGeneralizedTime(date));
    }
    // TODO: expose as common API call
    // create a RelativeDistinguishedName set
    // each value in the set is an AttributeTypeAndValue first
    // containing the type (an OID) and second the value
    return $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SEQUENCE, true, [
        // AttributeType
        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OID, false, $6e54cb5e6e58069b$var$asn1.oidToDer(attr.type).getBytes()),
        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SET, true, [
            // AttributeValue
            value
        ])
    ]);
}
/**
 * Map messages encrypted content to ASN.1 objects.
 *
 * @param ec The encryptedContent object of the message.
 *
 * @return ASN.1 representation of the encryptedContent object (SEQUENCE).
 */ function $6e54cb5e6e58069b$var$_encryptedContentToAsn1(ec) {
    return [
        // ContentType, always Data for the moment
        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OID, false, $6e54cb5e6e58069b$var$asn1.oidToDer($2xc86.pki.oids.data).getBytes()),
        // ContentEncryptionAlgorithmIdentifier
        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.SEQUENCE, true, [
            // Algorithm
            $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OID, false, $6e54cb5e6e58069b$var$asn1.oidToDer(ec.algorithm).getBytes()),
            // Parameters (IV)
            $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OCTETSTRING, false, ec.parameter.getBytes())
        ]),
        // [0] EncryptedContent
        $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
            $6e54cb5e6e58069b$var$asn1.create($6e54cb5e6e58069b$var$asn1.Class.UNIVERSAL, $6e54cb5e6e58069b$var$asn1.Type.OCTETSTRING, false, ec.content.getBytes())
        ])
    ];
}
/**
 * Reads the "common part" of an PKCS#7 content block (in ASN.1 format)
 *
 * This function reads the "common part" of the PKCS#7 content blocks
 * EncryptedData and EnvelopedData, i.e. version number and symmetrically
 * encrypted content block.
 *
 * The result of the ASN.1 validate and capture process is returned
 * to allow the caller to extract further data, e.g. the list of recipients
 * in case of a EnvelopedData object.
 *
 * @param msg the PKCS#7 object to read the data to.
 * @param obj the ASN.1 representation of the content block.
 * @param validator the ASN.1 structure validator object to use.
 *
 * @return the value map captured by validator object.
 */ function $6e54cb5e6e58069b$var$_fromAsn1(msg, obj, validator) {
    var capture = {};
    var errors = [];
    if (!$6e54cb5e6e58069b$var$asn1.validate(obj, validator, capture, errors)) {
        var error = new Error("Cannot read PKCS#7 message. ASN.1 object is not a supported PKCS#7 message.");
        error.errors = error;
        throw error;
    }
    // Check contentType, so far we only support (raw) Data.
    var contentType = $6e54cb5e6e58069b$var$asn1.derToOid(capture.contentType);
    if (contentType !== $2xc86.pki.oids.data) throw new Error("Unsupported PKCS#7 message. Only wrapped ContentType Data supported.");
    if (capture.encryptedContent) {
        var content = "";
        if ($2xc86.util.isArray(capture.encryptedContent)) for(var i = 0; i < capture.encryptedContent.length; ++i){
            if (capture.encryptedContent[i].type !== $6e54cb5e6e58069b$var$asn1.Type.OCTETSTRING) throw new Error("Malformed PKCS#7 message, expecting encrypted content constructed of only OCTET STRING objects.");
            content += capture.encryptedContent[i].value;
        }
        else content = capture.encryptedContent;
        msg.encryptedContent = {
            algorithm: $6e54cb5e6e58069b$var$asn1.derToOid(capture.encAlgorithm),
            parameter: $2xc86.util.createBuffer(capture.encParameter.value),
            content: $2xc86.util.createBuffer(content)
        };
    }
    if (capture.content) {
        var content = "";
        if ($2xc86.util.isArray(capture.content)) for(var i = 0; i < capture.content.length; ++i){
            if (capture.content[i].type !== $6e54cb5e6e58069b$var$asn1.Type.OCTETSTRING) throw new Error("Malformed PKCS#7 message, expecting content constructed of only OCTET STRING objects.");
            content += capture.content[i].value;
        }
        else content = capture.content;
        msg.content = $2xc86.util.createBuffer(content);
    }
    msg.version = capture.version.charCodeAt(0);
    msg.rawCapture = capture;
    return capture;
}
/**
 * Decrypt the symmetrically encrypted content block of the PKCS#7 message.
 *
 * Decryption is skipped in case the PKCS#7 message object already has a
 * (decrypted) content attribute.  The algorithm, key and cipher parameters
 * (probably the iv) are taken from the encryptedContent attribute of the
 * message object.
 *
 * @param The PKCS#7 message object.
 */ function $6e54cb5e6e58069b$var$_decryptContent(msg) {
    if (msg.encryptedContent.key === undefined) throw new Error("Symmetric key not available.");
    if (msg.content === undefined) {
        var ciph;
        switch(msg.encryptedContent.algorithm){
            case $2xc86.pki.oids["aes128-CBC"]:
            case $2xc86.pki.oids["aes192-CBC"]:
            case $2xc86.pki.oids["aes256-CBC"]:
                ciph = $2xc86.aes.createDecryptionCipher(msg.encryptedContent.key);
                break;
            case $2xc86.pki.oids["desCBC"]:
            case $2xc86.pki.oids["des-EDE3-CBC"]:
                ciph = $2xc86.des.createDecryptionCipher(msg.encryptedContent.key);
                break;
            default:
                throw new Error("Unsupported symmetric cipher, OID " + msg.encryptedContent.algorithm);
        }
        ciph.start(msg.encryptedContent.parameter);
        ciph.update(msg.encryptedContent.content);
        if (!ciph.finish()) throw new Error("Symmetric decryption failed.");
        msg.content = ciph.output;
    }
}

});
parcelRequire.register("2xc86", function(module, exports) {
/**
 * Node.js module for Forge.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2016 Digital Bazaar, Inc.
 */ module.exports = {
    // default options
    options: {
        usePureJavaScript: false
    }
};

});

parcelRequire.register("a7tnS", function(module, exports) {
/**
 * Advanced Encryption Standard (AES) implementation.
 *
 * This implementation is based on the public domain library 'jscrypto' which
 * was written by:
 *
 * Emily Stark (estark@stanford.edu)
 * Mike Hamburg (mhamburg@stanford.edu)
 * Dan Boneh (dabo@cs.stanford.edu)
 *
 * Parts of this code are based on the OpenSSL implementation of AES:
 * http://www.openssl.org
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("kM8NH");
parcelRequire("2D3xR");
parcelRequire("e73pV");
/* AES API */ module.exports = $2xc86.aes = $2xc86.aes || {};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('AES-<mode>', key);
 * cipher.start({iv: iv});
 *
 * Creates an AES cipher object to encrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as a string of bytes, an array of bytes,
 * a byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $2xc86.aes.startEncrypting = function(key, iv, output, mode) {
    var cipher = $75e159e0522d2fba$var$_createCipher({
        key: key,
        output: output,
        decrypt: false,
        mode: mode
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('AES-<mode>', key);
 *
 * Creates an AES cipher object to encrypt data using the given symmetric key.
 *
 * The key may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $2xc86.aes.createEncryptionCipher = function(key, mode) {
    return $75e159e0522d2fba$var$_createCipher({
        key: key,
        output: null,
        decrypt: false,
        mode: mode
    });
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('AES-<mode>', key);
 * decipher.start({iv: iv});
 *
 * Creates an AES cipher object to decrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as a string of bytes, an array of bytes,
 * a byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $2xc86.aes.startDecrypting = function(key, iv, output, mode) {
    var cipher = $75e159e0522d2fba$var$_createCipher({
        key: key,
        output: output,
        decrypt: true,
        mode: mode
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('AES-<mode>', key);
 *
 * Creates an AES cipher object to decrypt data using the given symmetric key.
 *
 * The key may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param key the symmetric key to use.
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $2xc86.aes.createDecryptionCipher = function(key, mode) {
    return $75e159e0522d2fba$var$_createCipher({
        key: key,
        output: null,
        decrypt: true,
        mode: mode
    });
};
/**
 * Creates a new AES cipher algorithm object.
 *
 * @param name the name of the algorithm.
 * @param mode the mode factory function.
 *
 * @return the AES algorithm object.
 */ $2xc86.aes.Algorithm = function(name, mode) {
    if (!$75e159e0522d2fba$var$init) $75e159e0522d2fba$var$initialize();
    var self = this;
    self.name = name;
    self.mode = new mode({
        blockSize: 16,
        cipher: {
            encrypt: function(inBlock, outBlock) {
                return $75e159e0522d2fba$var$_updateBlock(self._w, inBlock, outBlock, false);
            },
            decrypt: function(inBlock, outBlock) {
                return $75e159e0522d2fba$var$_updateBlock(self._w, inBlock, outBlock, true);
            }
        }
    });
    self._init = false;
};
/**
 * Initializes this AES algorithm by expanding its key.
 *
 * @param options the options to use.
 *          key the key to use with this algorithm.
 *          decrypt true if the algorithm should be initialized for decryption,
 *            false for encryption.
 */ $2xc86.aes.Algorithm.prototype.initialize = function(options) {
    if (this._init) return;
    var key = options.key;
    var tmp;
    /* Note: The key may be a string of bytes, an array of bytes, a byte
    buffer, or an array of 32-bit integers. If the key is in bytes, then
    it must be 16, 24, or 32 bytes in length. If it is in 32-bit
    integers, it must be 4, 6, or 8 integers long. */ if (typeof key === "string" && (key.length === 16 || key.length === 24 || key.length === 32)) // convert key string into byte buffer
    key = $2xc86.util.createBuffer(key);
    else if ($2xc86.util.isArray(key) && (key.length === 16 || key.length === 24 || key.length === 32)) {
        // convert key integer array into byte buffer
        tmp = key;
        key = $2xc86.util.createBuffer();
        for(var i = 0; i < tmp.length; ++i)key.putByte(tmp[i]);
    }
    // convert key byte buffer into 32-bit integer array
    if (!$2xc86.util.isArray(key)) {
        tmp = key;
        key = [];
        // key lengths of 16, 24, 32 bytes allowed
        var len = tmp.length();
        if (len === 16 || len === 24 || len === 32) {
            len = len >>> 2;
            for(var i = 0; i < len; ++i)key.push(tmp.getInt32());
        }
    }
    // key must be an array of 32-bit integers by now
    if (!$2xc86.util.isArray(key) || !(key.length === 4 || key.length === 6 || key.length === 8)) throw new Error("Invalid key parameter.");
    // encryption operation is always used for these modes
    var mode = this.mode.name;
    var encryptOp = [
        "CFB",
        "OFB",
        "CTR",
        "GCM"
    ].indexOf(mode) !== -1;
    // do key expansion
    this._w = $75e159e0522d2fba$var$_expandKey(key, options.decrypt && !encryptOp);
    this._init = true;
};
/**
 * Expands a key. Typically only used for testing.
 *
 * @param key the symmetric key to expand, as an array of 32-bit words.
 * @param decrypt true to expand for decryption, false for encryption.
 *
 * @return the expanded key.
 */ $2xc86.aes._expandKey = function(key, decrypt) {
    if (!$75e159e0522d2fba$var$init) $75e159e0522d2fba$var$initialize();
    return $75e159e0522d2fba$var$_expandKey(key, decrypt);
};
/**
 * Updates a single block. Typically only used for testing.
 *
 * @param w the expanded key to use.
 * @param input an array of block-size 32-bit words.
 * @param output an array of block-size 32-bit words.
 * @param decrypt true to decrypt, false to encrypt.
 */ $2xc86.aes._updateBlock = $75e159e0522d2fba$var$_updateBlock;
/** Register AES algorithms **/ $75e159e0522d2fba$var$registerAlgorithm("AES-ECB", $2xc86.cipher.modes.ecb);
$75e159e0522d2fba$var$registerAlgorithm("AES-CBC", $2xc86.cipher.modes.cbc);
$75e159e0522d2fba$var$registerAlgorithm("AES-CFB", $2xc86.cipher.modes.cfb);
$75e159e0522d2fba$var$registerAlgorithm("AES-OFB", $2xc86.cipher.modes.ofb);
$75e159e0522d2fba$var$registerAlgorithm("AES-CTR", $2xc86.cipher.modes.ctr);
$75e159e0522d2fba$var$registerAlgorithm("AES-GCM", $2xc86.cipher.modes.gcm);
function $75e159e0522d2fba$var$registerAlgorithm(name, mode) {
    var factory = function() {
        return new $2xc86.aes.Algorithm(name, mode);
    };
    $2xc86.cipher.registerAlgorithm(name, factory);
}
/** AES implementation **/ var $75e159e0522d2fba$var$init = false; // not yet initialized
var $75e159e0522d2fba$var$Nb = 4; // number of words comprising the state (AES = 4)
var $75e159e0522d2fba$var$sbox; // non-linear substitution table used in key expansion
var $75e159e0522d2fba$var$isbox; // inversion of sbox
var $75e159e0522d2fba$var$rcon; // round constant word array
var $75e159e0522d2fba$var$mix; // mix-columns table
var $75e159e0522d2fba$var$imix; // inverse mix-columns table
/**
 * Performs initialization, ie: precomputes tables to optimize for speed.
 *
 * One way to understand how AES works is to imagine that 'addition' and
 * 'multiplication' are interfaces that require certain mathematical
 * properties to hold true (ie: they are associative) but they might have
 * different implementations and produce different kinds of results ...
 * provided that their mathematical properties remain true. AES defines
 * its own methods of addition and multiplication but keeps some important
 * properties the same, ie: associativity and distributivity. The
 * explanation below tries to shed some light on how AES defines addition
 * and multiplication of bytes and 32-bit words in order to perform its
 * encryption and decryption algorithms.
 *
 * The basics:
 *
 * The AES algorithm views bytes as binary representations of polynomials
 * that have either 1 or 0 as the coefficients. It defines the addition
 * or subtraction of two bytes as the XOR operation. It also defines the
 * multiplication of two bytes as a finite field referred to as GF(2^8)
 * (Note: 'GF' means "Galois Field" which is a field that contains a finite
 * number of elements so GF(2^8) has 256 elements).
 *
 * This means that any two bytes can be represented as binary polynomials;
 * when they multiplied together and modularly reduced by an irreducible
 * polynomial of the 8th degree, the results are the field GF(2^8). The
 * specific irreducible polynomial that AES uses in hexadecimal is 0x11b.
 * This multiplication is associative with 0x01 as the identity:
 *
 * (b * 0x01 = GF(b, 0x01) = b).
 *
 * The operation GF(b, 0x02) can be performed at the byte level by left
 * shifting b once and then XOR'ing it (to perform the modular reduction)
 * with 0x11b if b is >= 128. Repeated application of the multiplication
 * of 0x02 can be used to implement the multiplication of any two bytes.
 *
 * For instance, multiplying 0x57 and 0x13, denoted as GF(0x57, 0x13), can
 * be performed by factoring 0x13 into 0x01, 0x02, and 0x10. Then these
 * factors can each be multiplied by 0x57 and then added together. To do
 * the multiplication, values for 0x57 multiplied by each of these 3 factors
 * can be precomputed and stored in a table. To add them, the values from
 * the table are XOR'd together.
 *
 * AES also defines addition and multiplication of words, that is 4-byte
 * numbers represented as polynomials of 3 degrees where the coefficients
 * are the values of the bytes.
 *
 * The word [a0, a1, a2, a3] is a polynomial a3x^3 + a2x^2 + a1x + a0.
 *
 * Addition is performed by XOR'ing like powers of x. Multiplication
 * is performed in two steps, the first is an algebriac expansion as
 * you would do normally (where addition is XOR). But the result is
 * a polynomial larger than 3 degrees and thus it cannot fit in a word. So
 * next the result is modularly reduced by an AES-specific polynomial of
 * degree 4 which will always produce a polynomial of less than 4 degrees
 * such that it will fit in a word. In AES, this polynomial is x^4 + 1.
 *
 * The modular product of two polynomials 'a' and 'b' is thus:
 *
 * d(x) = d3x^3 + d2x^2 + d1x + d0
 * with
 * d0 = GF(a0, b0) ^ GF(a3, b1) ^ GF(a2, b2) ^ GF(a1, b3)
 * d1 = GF(a1, b0) ^ GF(a0, b1) ^ GF(a3, b2) ^ GF(a2, b3)
 * d2 = GF(a2, b0) ^ GF(a1, b1) ^ GF(a0, b2) ^ GF(a3, b3)
 * d3 = GF(a3, b0) ^ GF(a2, b1) ^ GF(a1, b2) ^ GF(a0, b3)
 *
 * As a matrix:
 *
 * [d0] = [a0 a3 a2 a1][b0]
 * [d1]   [a1 a0 a3 a2][b1]
 * [d2]   [a2 a1 a0 a3][b2]
 * [d3]   [a3 a2 a1 a0][b3]
 *
 * Special polynomials defined by AES (0x02 == {02}):
 * a(x)    = {03}x^3 + {01}x^2 + {01}x + {02}
 * a^-1(x) = {0b}x^3 + {0d}x^2 + {09}x + {0e}.
 *
 * These polynomials are used in the MixColumns() and InverseMixColumns()
 * operations, respectively, to cause each element in the state to affect
 * the output (referred to as diffusing).
 *
 * RotWord() uses: a0 = a1 = a2 = {00} and a3 = {01}, which is the
 * polynomial x3.
 *
 * The ShiftRows() method modifies the last 3 rows in the state (where
 * the state is 4 words with 4 bytes per word) by shifting bytes cyclically.
 * The 1st byte in the second row is moved to the end of the row. The 1st
 * and 2nd bytes in the third row are moved to the end of the row. The 1st,
 * 2nd, and 3rd bytes are moved in the fourth row.
 *
 * More details on how AES arithmetic works:
 *
 * In the polynomial representation of binary numbers, XOR performs addition
 * and subtraction and multiplication in GF(2^8) denoted as GF(a, b)
 * corresponds with the multiplication of polynomials modulo an irreducible
 * polynomial of degree 8. In other words, for AES, GF(a, b) will multiply
 * polynomial 'a' with polynomial 'b' and then do a modular reduction by
 * an AES-specific irreducible polynomial of degree 8.
 *
 * A polynomial is irreducible if its only divisors are one and itself. For
 * the AES algorithm, this irreducible polynomial is:
 *
 * m(x) = x^8 + x^4 + x^3 + x + 1,
 *
 * or {01}{1b} in hexadecimal notation, where each coefficient is a bit:
 * 100011011 = 283 = 0x11b.
 *
 * For example, GF(0x57, 0x83) = 0xc1 because
 *
 * 0x57 = 87  = 01010111 = x^6 + x^4 + x^2 + x + 1
 * 0x85 = 131 = 10000101 = x^7 + x + 1
 *
 * (x^6 + x^4 + x^2 + x + 1) * (x^7 + x + 1)
 * =  x^13 + x^11 + x^9 + x^8 + x^7 +
 *    x^7 + x^5 + x^3 + x^2 + x +
 *    x^6 + x^4 + x^2 + x + 1
 * =  x^13 + x^11 + x^9 + x^8 + x^6 + x^5 + x^4 + x^3 + 1 = y
 *    y modulo (x^8 + x^4 + x^3 + x + 1)
 * =  x^7 + x^6 + 1.
 *
 * The modular reduction by m(x) guarantees the result will be a binary
 * polynomial of less than degree 8, so that it can fit in a byte.
 *
 * The operation to multiply a binary polynomial b with x (the polynomial
 * x in binary representation is 00000010) is:
 *
 * b_7x^8 + b_6x^7 + b_5x^6 + b_4x^5 + b_3x^4 + b_2x^3 + b_1x^2 + b_0x^1
 *
 * To get GF(b, x) we must reduce that by m(x). If b_7 is 0 (that is the
 * most significant bit is 0 in b) then the result is already reduced. If
 * it is 1, then we can reduce it by subtracting m(x) via an XOR.
 *
 * It follows that multiplication by x (00000010 or 0x02) can be implemented
 * by performing a left shift followed by a conditional bitwise XOR with
 * 0x1b. This operation on bytes is denoted by xtime(). Multiplication by
 * higher powers of x can be implemented by repeated application of xtime().
 *
 * By adding intermediate results, multiplication by any constant can be
 * implemented. For instance:
 *
 * GF(0x57, 0x13) = 0xfe because:
 *
 * xtime(b) = (b & 128) ? (b << 1 ^ 0x11b) : (b << 1)
 *
 * Note: We XOR with 0x11b instead of 0x1b because in javascript our
 * datatype for b can be larger than 1 byte, so a left shift will not
 * automatically eliminate bits that overflow a byte ... by XOR'ing the
 * overflow bit with 1 (the extra one from 0x11b) we zero it out.
 *
 * GF(0x57, 0x02) = xtime(0x57) = 0xae
 * GF(0x57, 0x04) = xtime(0xae) = 0x47
 * GF(0x57, 0x08) = xtime(0x47) = 0x8e
 * GF(0x57, 0x10) = xtime(0x8e) = 0x07
 *
 * GF(0x57, 0x13) = GF(0x57, (0x01 ^ 0x02 ^ 0x10))
 *
 * And by the distributive property (since XOR is addition and GF() is
 * multiplication):
 *
 * = GF(0x57, 0x01) ^ GF(0x57, 0x02) ^ GF(0x57, 0x10)
 * = 0x57 ^ 0xae ^ 0x07
 * = 0xfe.
 */ function $75e159e0522d2fba$var$initialize() {
    $75e159e0522d2fba$var$init = true;
    /* Populate the Rcon table. These are the values given by
    [x^(i-1),{00},{00},{00}] where x^(i-1) are powers of x (and x = 0x02)
    in the field of GF(2^8), where i starts at 1.

    rcon[0] = [0x00, 0x00, 0x00, 0x00]
    rcon[1] = [0x01, 0x00, 0x00, 0x00] 2^(1-1) = 2^0 = 1
    rcon[2] = [0x02, 0x00, 0x00, 0x00] 2^(2-1) = 2^1 = 2
    ...
    rcon[9]  = [0x1B, 0x00, 0x00, 0x00] 2^(9-1)  = 2^8 = 0x1B
    rcon[10] = [0x36, 0x00, 0x00, 0x00] 2^(10-1) = 2^9 = 0x36

    We only store the first byte because it is the only one used.
  */ $75e159e0522d2fba$var$rcon = [
        0x00,
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1B,
        0x36
    ];
    // compute xtime table which maps i onto GF(i, 0x02)
    var xtime = new Array(256);
    for(var i = 0; i < 128; ++i){
        xtime[i] = i << 1;
        xtime[i + 128] = i + 128 << 1 ^ 0x11B;
    }
    // compute all other tables
    $75e159e0522d2fba$var$sbox = new Array(256);
    $75e159e0522d2fba$var$isbox = new Array(256);
    $75e159e0522d2fba$var$mix = new Array(4);
    $75e159e0522d2fba$var$imix = new Array(4);
    for(var i = 0; i < 4; ++i){
        $75e159e0522d2fba$var$mix[i] = new Array(256);
        $75e159e0522d2fba$var$imix[i] = new Array(256);
    }
    var e = 0, ei = 0, e2, e4, e8, sx, sx2, me, ime;
    for(var i = 0; i < 256; ++i){
        /* We need to generate the SubBytes() sbox and isbox tables so that
      we can perform byte substitutions. This requires us to traverse
      all of the elements in GF, find their multiplicative inverses,
      and apply to each the following affine transformation:

      bi' = bi ^ b(i + 4) mod 8 ^ b(i + 5) mod 8 ^ b(i + 6) mod 8 ^
            b(i + 7) mod 8 ^ ci
      for 0 <= i < 8, where bi is the ith bit of the byte, and ci is the
      ith bit of a byte c with the value {63} or {01100011}.

      It is possible to traverse every possible value in a Galois field
      using what is referred to as a 'generator'. There are many
      generators (128 out of 256): 3,5,6,9,11,82 to name a few. To fully
      traverse GF we iterate 255 times, multiplying by our generator
      each time.

      On each iteration we can determine the multiplicative inverse for
      the current element.

      Suppose there is an element in GF 'e'. For a given generator 'g',
      e = g^x. The multiplicative inverse of e is g^(255 - x). It turns
      out that if use the inverse of a generator as another generator
      it will produce all of the corresponding multiplicative inverses
      at the same time. For this reason, we choose 5 as our inverse
      generator because it only requires 2 multiplies and 1 add and its
      inverse, 82, requires relatively few operations as well.

      In order to apply the affine transformation, the multiplicative
      inverse 'ei' of 'e' can be repeatedly XOR'd (4 times) with a
      bit-cycling of 'ei'. To do this 'ei' is first stored in 's' and
      'x'. Then 's' is left shifted and the high bit of 's' is made the
      low bit. The resulting value is stored in 's'. Then 'x' is XOR'd
      with 's' and stored in 'x'. On each subsequent iteration the same
      operation is performed. When 4 iterations are complete, 'x' is
      XOR'd with 'c' (0x63) and the transformed value is stored in 'x'.
      For example:

      s = 01000001
      x = 01000001

      iteration 1: s = 10000010, x ^= s
      iteration 2: s = 00000101, x ^= s
      iteration 3: s = 00001010, x ^= s
      iteration 4: s = 00010100, x ^= s
      x ^= 0x63

      This can be done with a loop where s = (s << 1) | (s >> 7). However,
      it can also be done by using a single 16-bit (in this case 32-bit)
      number 'sx'. Since XOR is an associative operation, we can set 'sx'
      to 'ei' and then XOR it with 'sx' left-shifted 1,2,3, and 4 times.
      The most significant bits will flow into the high 8 bit positions
      and be correctly XOR'd with one another. All that remains will be
      to cycle the high 8 bits by XOR'ing them all with the lower 8 bits
      afterwards.

      At the same time we're populating sbox and isbox we can precompute
      the multiplication we'll need to do to do MixColumns() later.
    */ // apply affine transformation
        sx = ei ^ ei << 1 ^ ei << 2 ^ ei << 3 ^ ei << 4;
        sx = sx >> 8 ^ sx & 255 ^ 0x63;
        // update tables
        $75e159e0522d2fba$var$sbox[e] = sx;
        $75e159e0522d2fba$var$isbox[sx] = e;
        /* Mixing columns is done using matrix multiplication. The columns
      that are to be mixed are each a single word in the current state.
      The state has Nb columns (4 columns). Therefore each column is a
      4 byte word. So to mix the columns in a single column 'c' where
      its rows are r0, r1, r2, and r3, we use the following matrix
      multiplication:

      [2 3 1 1]*[r0,c]=[r'0,c]
      [1 2 3 1] [r1,c] [r'1,c]
      [1 1 2 3] [r2,c] [r'2,c]
      [3 1 1 2] [r3,c] [r'3,c]

      r0, r1, r2, and r3 are each 1 byte of one of the words in the
      state (a column). To do matrix multiplication for each mixed
      column c' we multiply the corresponding row from the left matrix
      with the corresponding column from the right matrix. In total, we
      get 4 equations:

      r0,c' = 2*r0,c + 3*r1,c + 1*r2,c + 1*r3,c
      r1,c' = 1*r0,c + 2*r1,c + 3*r2,c + 1*r3,c
      r2,c' = 1*r0,c + 1*r1,c + 2*r2,c + 3*r3,c
      r3,c' = 3*r0,c + 1*r1,c + 1*r2,c + 2*r3,c

      As usual, the multiplication is as previously defined and the
      addition is XOR. In order to optimize mixing columns we can store
      the multiplication results in tables. If you think of the whole
      column as a word (it might help to visualize by mentally rotating
      the equations above by counterclockwise 90 degrees) then you can
      see that it would be useful to map the multiplications performed on
      each byte (r0, r1, r2, r3) onto a word as well. For instance, we
      could map 2*r0,1*r0,1*r0,3*r0 onto a word by storing 2*r0 in the
      highest 8 bits and 3*r0 in the lowest 8 bits (with the other two
      respectively in the middle). This means that a table can be
      constructed that uses r0 as an index to the word. We can do the
      same with r1, r2, and r3, creating a total of 4 tables.

      To construct a full c', we can just look up each byte of c in
      their respective tables and XOR the results together.

      Also, to build each table we only have to calculate the word
      for 2,1,1,3 for every byte ... which we can do on each iteration
      of this loop since we will iterate over every byte. After we have
      calculated 2,1,1,3 we can get the results for the other tables
      by cycling the byte at the end to the beginning. For instance
      we can take the result of table 2,1,1,3 and produce table 3,2,1,1
      by moving the right most byte to the left most position just like
      how you can imagine the 3 moved out of 2,1,1,3 and to the front
      to produce 3,2,1,1.

      There is another optimization in that the same multiples of
      the current element we need in order to advance our generator
      to the next iteration can be reused in performing the 2,1,1,3
      calculation. We also calculate the inverse mix column tables,
      with e,9,d,b being the inverse of 2,1,1,3.

      When we're done, and we need to actually mix columns, the first
      byte of each state word should be put through mix[0] (2,1,1,3),
      the second through mix[1] (3,2,1,1) and so forth. Then they should
      be XOR'd together to produce the fully mixed column.
    */ // calculate mix and imix table values
        sx2 = xtime[sx];
        e2 = xtime[e];
        e4 = xtime[e2];
        e8 = xtime[e4];
        me = sx2 << 24 ^ // 2
        sx << 16 ^ // 1
        sx << 8 ^ // 1
        (sx ^ sx2); // 3
        ime = (e2 ^ e4 ^ e8) << 24 ^ // E (14)
        (e ^ e8) << 16 ^ // 9
        (e ^ e4 ^ e8) << 8 ^ // D (13)
        (e ^ e2 ^ e8); // B (11)
        // produce each of the mix tables by rotating the 2,1,1,3 value
        for(var n = 0; n < 4; ++n){
            $75e159e0522d2fba$var$mix[n][e] = me;
            $75e159e0522d2fba$var$imix[n][sx] = ime;
            // cycle the right most byte to the left most position
            // ie: 2,1,1,3 becomes 3,2,1,1
            me = me << 24 | me >>> 8;
            ime = ime << 24 | ime >>> 8;
        }
        // get next element and inverse
        if (e === 0) // 1 is the inverse of 1
        e = ei = 1;
        else {
            // e = 2e + 2*2*2*(10e)) = multiply e by 82 (chosen generator)
            // ei = ei + 2*2*ei = multiply ei by 5 (inverse generator)
            e = e2 ^ xtime[xtime[xtime[e2 ^ e8]]];
            ei ^= xtime[xtime[ei]];
        }
    }
}
/**
 * Generates a key schedule using the AES key expansion algorithm.
 *
 * The AES algorithm takes the Cipher Key, K, and performs a Key Expansion
 * routine to generate a key schedule. The Key Expansion generates a total
 * of Nb*(Nr + 1) words: the algorithm requires an initial set of Nb words,
 * and each of the Nr rounds requires Nb words of key data. The resulting
 * key schedule consists of a linear array of 4-byte words, denoted [wi ],
 * with i in the range 0 <= i < Nb(Nr + 1).
 *
 * KeyExpansion(byte key[4*Nk], word w[Nb*(Nr+1)], Nk)
 * AES-128 (Nb=4, Nk=4, Nr=10)
 * AES-192 (Nb=4, Nk=6, Nr=12)
 * AES-256 (Nb=4, Nk=8, Nr=14)
 * Note: Nr=Nk+6.
 *
 * Nb is the number of columns (32-bit words) comprising the State (or
 * number of bytes in a block). For AES, Nb=4.
 *
 * @param key the key to schedule (as an array of 32-bit words).
 * @param decrypt true to modify the key schedule to decrypt, false not to.
 *
 * @return the generated key schedule.
 */ function $75e159e0522d2fba$var$_expandKey(key, decrypt) {
    // copy the key's words to initialize the key schedule
    var w = key.slice(0);
    /* RotWord() will rotate a word, moving the first byte to the last
    byte's position (shifting the other bytes left).

    We will be getting the value of Rcon at i / Nk. 'i' will iterate
    from Nk to (Nb * Nr+1). Nk = 4 (4 byte key), Nb = 4 (4 words in
    a block), Nr = Nk + 6 (10). Therefore 'i' will iterate from
    4 to 44 (exclusive). Each time we iterate 4 times, i / Nk will
    increase by 1. We use a counter iNk to keep track of this.
   */ // go through the rounds expanding the key
    var temp, iNk = 1;
    var Nk = w.length;
    var Nr1 = Nk + 6 + 1;
    var end = $75e159e0522d2fba$var$Nb * Nr1;
    for(var i = Nk; i < end; ++i){
        temp = w[i - 1];
        if (i % Nk === 0) {
            // temp = SubWord(RotWord(temp)) ^ Rcon[i / Nk]
            temp = $75e159e0522d2fba$var$sbox[temp >>> 16 & 255] << 24 ^ $75e159e0522d2fba$var$sbox[temp >>> 8 & 255] << 16 ^ $75e159e0522d2fba$var$sbox[temp & 255] << 8 ^ $75e159e0522d2fba$var$sbox[temp >>> 24] ^ $75e159e0522d2fba$var$rcon[iNk] << 24;
            iNk++;
        } else if (Nk > 6 && i % Nk === 4) // temp = SubWord(temp)
        temp = $75e159e0522d2fba$var$sbox[temp >>> 24] << 24 ^ $75e159e0522d2fba$var$sbox[temp >>> 16 & 255] << 16 ^ $75e159e0522d2fba$var$sbox[temp >>> 8 & 255] << 8 ^ $75e159e0522d2fba$var$sbox[temp & 255];
        w[i] = w[i - Nk] ^ temp;
    }
    /* When we are updating a cipher block we always use the code path for
     encryption whether we are decrypting or not (to shorten code and
     simplify the generation of look up tables). However, because there
     are differences in the decryption algorithm, other than just swapping
     in different look up tables, we must transform our key schedule to
     account for these changes:

     1. The decryption algorithm gets its key rounds in reverse order.
     2. The decryption algorithm adds the round key before mixing columns
       instead of afterwards.

     We don't need to modify our key schedule to handle the first case,
     we can just traverse the key schedule in reverse order when decrypting.

     The second case requires a little work.

     The tables we built for performing rounds will take an input and then
     perform SubBytes() and MixColumns() or, for the decrypt version,
     InvSubBytes() and InvMixColumns(). But the decrypt algorithm requires
     us to AddRoundKey() before InvMixColumns(). This means we'll need to
     apply some transformations to the round key to inverse-mix its columns
     so they'll be correct for moving AddRoundKey() to after the state has
     had its columns inverse-mixed.

     To inverse-mix the columns of the state when we're decrypting we use a
     lookup table that will apply InvSubBytes() and InvMixColumns() at the
     same time. However, the round key's bytes are not inverse-substituted
     in the decryption algorithm. To get around this problem, we can first
     substitute the bytes in the round key so that when we apply the
     transformation via the InvSubBytes()+InvMixColumns() table, it will
     undo our substitution leaving us with the original value that we
     want -- and then inverse-mix that value.

     This change will correctly alter our key schedule so that we can XOR
     each round key with our already transformed decryption state. This
     allows us to use the same code path as the encryption algorithm.

     We make one more change to the decryption key. Since the decryption
     algorithm runs in reverse from the encryption algorithm, we reverse
     the order of the round keys to avoid having to iterate over the key
     schedule backwards when running the encryption algorithm later in
     decryption mode. In addition to reversing the order of the round keys,
     we also swap each round key's 2nd and 4th rows. See the comments
     section where rounds are performed for more details about why this is
     done. These changes are done inline with the other substitution
     described above.
  */ if (decrypt) {
        var tmp;
        var m0 = $75e159e0522d2fba$var$imix[0];
        var m1 = $75e159e0522d2fba$var$imix[1];
        var m2 = $75e159e0522d2fba$var$imix[2];
        var m3 = $75e159e0522d2fba$var$imix[3];
        var wnew = w.slice(0);
        end = w.length;
        for(var i = 0, wi = end - $75e159e0522d2fba$var$Nb; i < end; i += $75e159e0522d2fba$var$Nb, wi -= $75e159e0522d2fba$var$Nb){
            // do not sub the first or last round key (round keys are Nb
            // words) as no column mixing is performed before they are added,
            // but do change the key order
            if (i === 0 || i === end - $75e159e0522d2fba$var$Nb) {
                wnew[i] = w[wi];
                wnew[i + 1] = w[wi + 3];
                wnew[i + 2] = w[wi + 2];
                wnew[i + 3] = w[wi + 1];
            } else // substitute each round key byte because the inverse-mix
            // table will inverse-substitute it (effectively cancel the
            // substitution because round key bytes aren't sub'd in
            // decryption mode) and swap indexes 3 and 1
            for(var n = 0; n < $75e159e0522d2fba$var$Nb; ++n){
                tmp = w[wi + n];
                wnew[i + (3 & -n)] = m0[$75e159e0522d2fba$var$sbox[tmp >>> 24]] ^ m1[$75e159e0522d2fba$var$sbox[tmp >>> 16 & 255]] ^ m2[$75e159e0522d2fba$var$sbox[tmp >>> 8 & 255]] ^ m3[$75e159e0522d2fba$var$sbox[tmp & 255]];
            }
        }
        w = wnew;
    }
    return w;
}
/**
 * Updates a single block (16 bytes) using AES. The update will either
 * encrypt or decrypt the block.
 *
 * @param w the key schedule.
 * @param input the input block (an array of 32-bit words).
 * @param output the updated output block.
 * @param decrypt true to decrypt the block, false to encrypt it.
 */ function $75e159e0522d2fba$var$_updateBlock(w, input, output, decrypt) {
    /*
  Cipher(byte in[4*Nb], byte out[4*Nb], word w[Nb*(Nr+1)])
  begin
    byte state[4,Nb]
    state = in
    AddRoundKey(state, w[0, Nb-1])
    for round = 1 step 1 to Nr-1
      SubBytes(state)
      ShiftRows(state)
      MixColumns(state)
      AddRoundKey(state, w[round*Nb, (round+1)*Nb-1])
    end for
    SubBytes(state)
    ShiftRows(state)
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    out = state
  end

  InvCipher(byte in[4*Nb], byte out[4*Nb], word w[Nb*(Nr+1)])
  begin
    byte state[4,Nb]
    state = in
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    for round = Nr-1 step -1 downto 1
      InvShiftRows(state)
      InvSubBytes(state)
      AddRoundKey(state, w[round*Nb, (round+1)*Nb-1])
      InvMixColumns(state)
    end for
    InvShiftRows(state)
    InvSubBytes(state)
    AddRoundKey(state, w[0, Nb-1])
    out = state
  end
  */ // Encrypt: AddRoundKey(state, w[0, Nb-1])
    // Decrypt: AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])
    var Nr = w.length / 4 - 1;
    var m0, m1, m2, m3, sub;
    if (decrypt) {
        m0 = $75e159e0522d2fba$var$imix[0];
        m1 = $75e159e0522d2fba$var$imix[1];
        m2 = $75e159e0522d2fba$var$imix[2];
        m3 = $75e159e0522d2fba$var$imix[3];
        sub = $75e159e0522d2fba$var$isbox;
    } else {
        m0 = $75e159e0522d2fba$var$mix[0];
        m1 = $75e159e0522d2fba$var$mix[1];
        m2 = $75e159e0522d2fba$var$mix[2];
        m3 = $75e159e0522d2fba$var$mix[3];
        sub = $75e159e0522d2fba$var$sbox;
    }
    var a, b, c, d, a2, b2, c2;
    a = input[0] ^ w[0];
    b = input[decrypt ? 3 : 1] ^ w[1];
    c = input[2] ^ w[2];
    d = input[decrypt ? 1 : 3] ^ w[3];
    var i = 3;
    /* In order to share code we follow the encryption algorithm when both
    encrypting and decrypting. To account for the changes required in the
    decryption algorithm, we use different lookup tables when decrypting
    and use a modified key schedule to account for the difference in the
    order of transformations applied when performing rounds. We also get
    key rounds in reverse order (relative to encryption). */ for(var round = 1; round < Nr; ++round){
        /* As described above, we'll be using table lookups to perform the
      column mixing. Each column is stored as a word in the state (the
      array 'input' has one column as a word at each index). In order to
      mix a column, we perform these transformations on each row in c,
      which is 1 byte in each word. The new column for c0 is c'0:

               m0      m1      m2      m3
      r0,c'0 = 2*r0,c0 + 3*r1,c0 + 1*r2,c0 + 1*r3,c0
      r1,c'0 = 1*r0,c0 + 2*r1,c0 + 3*r2,c0 + 1*r3,c0
      r2,c'0 = 1*r0,c0 + 1*r1,c0 + 2*r2,c0 + 3*r3,c0
      r3,c'0 = 3*r0,c0 + 1*r1,c0 + 1*r2,c0 + 2*r3,c0

      So using mix tables where c0 is a word with r0 being its upper
      8 bits and r3 being its lower 8 bits:

      m0[c0 >> 24] will yield this word: [2*r0,1*r0,1*r0,3*r0]
      ...
      m3[c0 & 255] will yield this word: [1*r3,1*r3,3*r3,2*r3]

      Therefore to mix the columns in each word in the state we
      do the following (& 255 omitted for brevity):
      c'0,r0 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r1 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r2 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]
      c'0,r3 = m0[c0 >> 24] ^ m1[c1 >> 16] ^ m2[c2 >> 8] ^ m3[c3]

      However, before mixing, the algorithm requires us to perform
      ShiftRows(). The ShiftRows() transformation cyclically shifts the
      last 3 rows of the state over different offsets. The first row
      (r = 0) is not shifted.

      s'_r,c = s_r,(c + shift(r, Nb) mod Nb
      for 0 < r < 4 and 0 <= c < Nb and
      shift(1, 4) = 1
      shift(2, 4) = 2
      shift(3, 4) = 3.

      This causes the first byte in r = 1 to be moved to the end of
      the row, the first 2 bytes in r = 2 to be moved to the end of
      the row, the first 3 bytes in r = 3 to be moved to the end of
      the row:

      r1: [c0 c1 c2 c3] => [c1 c2 c3 c0]
      r2: [c0 c1 c2 c3]    [c2 c3 c0 c1]
      r3: [c0 c1 c2 c3]    [c3 c0 c1 c2]

      We can make these substitutions inline with our column mixing to
      generate an updated set of equations to produce each word in the
      state (note the columns have changed positions):

      c0 c1 c2 c3 => c0 c1 c2 c3
      c0 c1 c2 c3    c1 c2 c3 c0  (cycled 1 byte)
      c0 c1 c2 c3    c2 c3 c0 c1  (cycled 2 bytes)
      c0 c1 c2 c3    c3 c0 c1 c2  (cycled 3 bytes)

      Therefore:

      c'0 = 2*r0,c0 + 3*r1,c1 + 1*r2,c2 + 1*r3,c3
      c'0 = 1*r0,c0 + 2*r1,c1 + 3*r2,c2 + 1*r3,c3
      c'0 = 1*r0,c0 + 1*r1,c1 + 2*r2,c2 + 3*r3,c3
      c'0 = 3*r0,c0 + 1*r1,c1 + 1*r2,c2 + 2*r3,c3

      c'1 = 2*r0,c1 + 3*r1,c2 + 1*r2,c3 + 1*r3,c0
      c'1 = 1*r0,c1 + 2*r1,c2 + 3*r2,c3 + 1*r3,c0
      c'1 = 1*r0,c1 + 1*r1,c2 + 2*r2,c3 + 3*r3,c0
      c'1 = 3*r0,c1 + 1*r1,c2 + 1*r2,c3 + 2*r3,c0

      ... and so forth for c'2 and c'3. The important distinction is
      that the columns are cycling, with c0 being used with the m0
      map when calculating c0, but c1 being used with the m0 map when
      calculating c1 ... and so forth.

      When performing the inverse we transform the mirror image and
      skip the bottom row, instead of the top one, and move upwards:

      c3 c2 c1 c0 => c0 c3 c2 c1  (cycled 3 bytes) *same as encryption
      c3 c2 c1 c0    c1 c0 c3 c2  (cycled 2 bytes)
      c3 c2 c1 c0    c2 c1 c0 c3  (cycled 1 byte)  *same as encryption
      c3 c2 c1 c0    c3 c2 c1 c0

      If you compare the resulting matrices for ShiftRows()+MixColumns()
      and for InvShiftRows()+InvMixColumns() the 2nd and 4th columns are
      different (in encrypt mode vs. decrypt mode). So in order to use
      the same code to handle both encryption and decryption, we will
      need to do some mapping.

      If in encryption mode we let a=c0, b=c1, c=c2, d=c3, and r<N> be
      a row number in the state, then the resulting matrix in encryption
      mode for applying the above transformations would be:

      r1: a b c d
      r2: b c d a
      r3: c d a b
      r4: d a b c

      If we did the same in decryption mode we would get:

      r1: a d c b
      r2: b a d c
      r3: c b a d
      r4: d c b a

      If instead we swap d and b (set b=c3 and d=c1), then we get:

      r1: a b c d
      r2: d a b c
      r3: c d a b
      r4: b c d a

      Now the 1st and 3rd rows are the same as the encryption matrix. All
      we need to do then to make the mapping exactly the same is to swap
      the 2nd and 4th rows when in decryption mode. To do this without
      having to do it on each iteration, we swapped the 2nd and 4th rows
      in the decryption key schedule. We also have to do the swap above
      when we first pull in the input and when we set the final output. */ a2 = m0[a >>> 24] ^ m1[b >>> 16 & 255] ^ m2[c >>> 8 & 255] ^ m3[d & 255] ^ w[++i];
        b2 = m0[b >>> 24] ^ m1[c >>> 16 & 255] ^ m2[d >>> 8 & 255] ^ m3[a & 255] ^ w[++i];
        c2 = m0[c >>> 24] ^ m1[d >>> 16 & 255] ^ m2[a >>> 8 & 255] ^ m3[b & 255] ^ w[++i];
        d = m0[d >>> 24] ^ m1[a >>> 16 & 255] ^ m2[b >>> 8 & 255] ^ m3[c & 255] ^ w[++i];
        a = a2;
        b = b2;
        c = c2;
    }
    /*
    Encrypt:
    SubBytes(state)
    ShiftRows(state)
    AddRoundKey(state, w[Nr*Nb, (Nr+1)*Nb-1])

    Decrypt:
    InvShiftRows(state)
    InvSubBytes(state)
    AddRoundKey(state, w[0, Nb-1])
   */ // Note: rows are shifted inline
    output[0] = sub[a >>> 24] << 24 ^ sub[b >>> 16 & 255] << 16 ^ sub[c >>> 8 & 255] << 8 ^ sub[d & 255] ^ w[++i];
    output[decrypt ? 3 : 1] = sub[b >>> 24] << 24 ^ sub[c >>> 16 & 255] << 16 ^ sub[d >>> 8 & 255] << 8 ^ sub[a & 255] ^ w[++i];
    output[2] = sub[c >>> 24] << 24 ^ sub[d >>> 16 & 255] << 16 ^ sub[a >>> 8 & 255] << 8 ^ sub[b & 255] ^ w[++i];
    output[decrypt ? 1 : 3] = sub[d >>> 24] << 24 ^ sub[a >>> 16 & 255] << 16 ^ sub[b >>> 8 & 255] << 8 ^ sub[c & 255] ^ w[++i];
}
/**
 * Deprecated. Instead, use:
 *
 * forge.cipher.createCipher('AES-<mode>', key);
 * forge.cipher.createDecipher('AES-<mode>', key);
 *
 * Creates a deprecated AES cipher object. This object's mode will default to
 * CBC (cipher-block-chaining).
 *
 * The key and iv may be given as a string of bytes, an array of bytes, a
 * byte buffer, or an array of 32-bit words.
 *
 * @param options the options to use.
 *          key the symmetric key to use.
 *          output the buffer to write to.
 *          decrypt true for decryption, false for encryption.
 *          mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ function $75e159e0522d2fba$var$_createCipher(options) {
    options = options || {};
    var mode = (options.mode || "CBC").toUpperCase();
    var algorithm = "AES-" + mode;
    var cipher;
    if (options.decrypt) cipher = $2xc86.cipher.createDecipher(algorithm, options.key);
    else cipher = $2xc86.cipher.createCipher(algorithm, options.key);
    // backwards compatible start API
    var start = cipher.start;
    cipher.start = function(iv, options) {
        // backwards compatibility: support second arg as output buffer
        var output = null;
        if (options instanceof $2xc86.util.ByteBuffer) {
            output = options;
            options = {};
        }
        options = options || {};
        options.output = output;
        options.iv = iv;
        start.call(cipher, options);
    };
    return cipher;
}

});
parcelRequire.register("kM8NH", function(module, exports) {
/**
 * Cipher base API.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("e73pV");
module.exports = $2xc86.cipher = $2xc86.cipher || {};
// registered algorithms
$2xc86.cipher.algorithms = $2xc86.cipher.algorithms || {};
/**
 * Creates a cipher object that can be used to encrypt data using the given
 * algorithm and key. The algorithm may be provided as a string value for a
 * previously registered algorithm or it may be given as a cipher algorithm
 * API object.
 *
 * @param algorithm the algorithm to use, either a string or an algorithm API
 *          object.
 * @param key the key to use, as a binary-encoded string of bytes or a
 *          byte buffer.
 *
 * @return the cipher.
 */ $2xc86.cipher.createCipher = function(algorithm, key) {
    var api = algorithm;
    if (typeof api === "string") {
        api = $2xc86.cipher.getAlgorithm(api);
        if (api) api = api();
    }
    if (!api) throw new Error("Unsupported algorithm: " + algorithm);
    // assume block cipher
    return new $2xc86.cipher.BlockCipher({
        algorithm: api,
        key: key,
        decrypt: false
    });
};
/**
 * Creates a decipher object that can be used to decrypt data using the given
 * algorithm and key. The algorithm may be provided as a string value for a
 * previously registered algorithm or it may be given as a cipher algorithm
 * API object.
 *
 * @param algorithm the algorithm to use, either a string or an algorithm API
 *          object.
 * @param key the key to use, as a binary-encoded string of bytes or a
 *          byte buffer.
 *
 * @return the cipher.
 */ $2xc86.cipher.createDecipher = function(algorithm, key) {
    var api = algorithm;
    if (typeof api === "string") {
        api = $2xc86.cipher.getAlgorithm(api);
        if (api) api = api();
    }
    if (!api) throw new Error("Unsupported algorithm: " + algorithm);
    // assume block cipher
    return new $2xc86.cipher.BlockCipher({
        algorithm: api,
        key: key,
        decrypt: true
    });
};
/**
 * Registers an algorithm by name. If the name was already registered, the
 * algorithm API object will be overwritten.
 *
 * @param name the name of the algorithm.
 * @param algorithm the algorithm API object.
 */ $2xc86.cipher.registerAlgorithm = function(name, algorithm) {
    name = name.toUpperCase();
    $2xc86.cipher.algorithms[name] = algorithm;
};
/**
 * Gets a registered algorithm by name.
 *
 * @param name the name of the algorithm.
 *
 * @return the algorithm, if found, null if not.
 */ $2xc86.cipher.getAlgorithm = function(name) {
    name = name.toUpperCase();
    if (name in $2xc86.cipher.algorithms) return $2xc86.cipher.algorithms[name];
    return null;
};
var $f1ff1df1e46d8cbc$var$BlockCipher = $2xc86.cipher.BlockCipher = function(options) {
    this.algorithm = options.algorithm;
    this.mode = this.algorithm.mode;
    this.blockSize = this.mode.blockSize;
    this._finish = false;
    this._input = null;
    this.output = null;
    this._op = options.decrypt ? this.mode.decrypt : this.mode.encrypt;
    this._decrypt = options.decrypt;
    this.algorithm.initialize(options);
};
/**
 * Starts or restarts the encryption or decryption process, whichever
 * was previously configured.
 *
 * For non-GCM mode, the IV may be a binary-encoded string of bytes, an array
 * of bytes, a byte buffer, or an array of 32-bit integers. If the IV is in
 * bytes, then it must be Nb (16) bytes in length. If the IV is given in as
 * 32-bit integers, then it must be 4 integers long.
 *
 * Note: an IV is not required or used in ECB mode.
 *
 * For GCM-mode, the IV must be given as a binary-encoded string of bytes or
 * a byte buffer. The number of bytes should be 12 (96 bits) as recommended
 * by NIST SP-800-38D but another length may be given.
 *
 * @param options the options to use:
 *          iv the initialization vector to use as a binary-encoded string of
 *            bytes, null to reuse the last ciphered block from a previous
 *            update() (this "residue" method is for legacy support only).
 *          additionalData additional authentication data as a binary-encoded
 *            string of bytes, for 'GCM' mode, (default: none).
 *          tagLength desired length of authentication tag, in bits, for
 *            'GCM' mode (0-128, default: 128).
 *          tag the authentication tag to check if decrypting, as a
 *             binary-encoded string of bytes.
 *          output the output the buffer to write to, null to create one.
 */ $f1ff1df1e46d8cbc$var$BlockCipher.prototype.start = function(options) {
    options = options || {};
    var opts = {};
    for(var key in options)opts[key] = options[key];
    opts.decrypt = this._decrypt;
    this._finish = false;
    this._input = $2xc86.util.createBuffer();
    this.output = options.output || $2xc86.util.createBuffer();
    this.mode.start(opts);
};
/**
 * Updates the next block according to the cipher mode.
 *
 * @param input the buffer to read from.
 */ $f1ff1df1e46d8cbc$var$BlockCipher.prototype.update = function(input) {
    if (input) // input given, so empty it into the input buffer
    this._input.putBuffer(input);
    // do cipher operation until it needs more input and not finished
    while(!this._op.call(this.mode, this._input, this.output, this._finish) && !this._finish);
    // free consumed memory from input buffer
    this._input.compact();
};
/**
 * Finishes encrypting or decrypting.
 *
 * @param pad a padding function to use in CBC mode, null for default,
 *          signature(blockSize, buffer, decrypt).
 *
 * @return true if successful, false on error.
 */ $f1ff1df1e46d8cbc$var$BlockCipher.prototype.finish = function(pad) {
    // backwards-compatibility w/deprecated padding API
    // Note: will overwrite padding functions even after another start() call
    if (pad && (this.mode.name === "ECB" || this.mode.name === "CBC")) {
        this.mode.pad = function(input) {
            return pad(this.blockSize, input, false);
        };
        this.mode.unpad = function(output) {
            return pad(this.blockSize, output, true);
        };
    }
    // build options for padding and afterFinish functions
    var options = {};
    options.decrypt = this._decrypt;
    // get # of bytes that won't fill a block
    options.overflow = this._input.length() % this.blockSize;
    if (!this._decrypt && this.mode.pad) {
        if (!this.mode.pad(this._input, options)) return false;
    }
    // do final update
    this._finish = true;
    this.update();
    if (this._decrypt && this.mode.unpad) {
        if (!this.mode.unpad(this.output, options)) return false;
    }
    if (this.mode.afterFinish) {
        if (!this.mode.afterFinish(this.output, options)) return false;
    }
    return true;
};

});
parcelRequire.register("e73pV", function(module, exports) {
/**
 * Utility functions for web applications.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2018 Digital Bazaar, Inc.
 */ 
var $7jzxY = parcelRequire("7jzxY");

var $7jzxY = parcelRequire("7jzxY");
var $a4645eb3af0af756$require$Buffer = $7jzxY.Buffer;

var $2xc86 = parcelRequire("2xc86");

var $8l6KK = parcelRequire("8l6KK");
/* Utilities API */ var $a4645eb3af0af756$var$util = module.exports = $2xc86.util = $2xc86.util || {};
// define setImmediate and nextTick
(function() {
    typeof $7jzxY !== "undefined" && $7jzxY.nextTick;
    // polyfill nextTick with native setImmediate
    if (typeof setImmediate === "function") {
        $a4645eb3af0af756$var$util.setImmediate = function() {
            return setImmediate.apply(undefined, arguments);
        };
        $a4645eb3af0af756$var$util.nextTick = function(callback) {
            return setImmediate(callback);
        };
        return;
    }
    /* Note: A polyfill upgrade pattern is used here to allow combining
  polyfills. For example, MutationObserver is fast, but blocks UI updates,
  so it needs to allow UI updates periodically, so it falls back on
  postMessage or setTimeout. */ // polyfill with setTimeout
    $a4645eb3af0af756$var$util.setImmediate = function(callback) {
        setTimeout(callback, 0);
    };
    // upgrade polyfill to use postMessage
    if (typeof window !== "undefined" && typeof window.postMessage === "function") {
        var msg = "forge.setImmediate";
        var callbacks = [];
        $a4645eb3af0af756$var$util.setImmediate = function(callback) {
            callbacks.push(callback);
            // only send message when one hasn't been sent in
            // the current turn of the event loop
            if (callbacks.length === 1) window.postMessage(msg, "*");
        };
        function handler(event) {
            if (event.source === window && event.data === msg) {
                event.stopPropagation();
                var copy = callbacks.slice();
                callbacks.length = 0;
                copy.forEach(function(callback) {
                    callback();
                });
            }
        }
        window.addEventListener("message", handler, true);
    }
    // upgrade polyfill to use MutationObserver
    if (typeof MutationObserver !== "undefined") {
        // polyfill with MutationObserver
        var now = Date.now();
        var attr = true;
        var div = document.createElement("div");
        var callbacks = [];
        new MutationObserver(function() {
            var copy = callbacks.slice();
            callbacks.length = 0;
            copy.forEach(function(callback) {
                callback();
            });
        }).observe(div, {
            attributes: true
        });
        var oldSetImmediate = $a4645eb3af0af756$var$util.setImmediate;
        $a4645eb3af0af756$var$util.setImmediate = function(callback) {
            if (Date.now() - now > 15) {
                now = Date.now();
                oldSetImmediate(callback);
            } else {
                callbacks.push(callback);
                // only trigger observer when it hasn't been triggered in
                // the current turn of the event loop
                if (callbacks.length === 1) div.setAttribute("a", attr = !attr);
            }
        };
    }
    $a4645eb3af0af756$var$util.nextTick = $a4645eb3af0af756$var$util.setImmediate;
})();
// check if running under Node.js
$a4645eb3af0af756$var$util.isNodejs = typeof $7jzxY !== "undefined" && $7jzxY.versions && $7jzxY.versions.node;
// 'self' will also work in Web Workers (instance of WorkerGlobalScope) while
// it will point to `window` in the main thread.
// To remain compatible with older browsers, we fall back to 'window' if 'self'
// is not available.
$a4645eb3af0af756$var$util.globalScope = function() {
    if ($a4645eb3af0af756$var$util.isNodejs) return $parcel$global;
    return typeof self === "undefined" ? window : self;
}();
// define isArray
$a4645eb3af0af756$var$util.isArray = Array.isArray || function(x) {
    return Object.prototype.toString.call(x) === "[object Array]";
};
// define isArrayBuffer
$a4645eb3af0af756$var$util.isArrayBuffer = function(x) {
    return typeof ArrayBuffer !== "undefined" && x instanceof ArrayBuffer;
};
// define isArrayBufferView
$a4645eb3af0af756$var$util.isArrayBufferView = function(x) {
    return x && $a4645eb3af0af756$var$util.isArrayBuffer(x.buffer) && x.byteLength !== undefined;
};
/**
 * Ensure a bits param is 8, 16, 24, or 32. Used to validate input for
 * algorithms where bit manipulation, JavaScript limitations, and/or algorithm
 * design only allow for byte operations of a limited size.
 *
 * @param n number of bits.
 *
 * Throw Error if n invalid.
 */ function $a4645eb3af0af756$var$_checkBitsParam(n) {
    if (!(n === 8 || n === 16 || n === 24 || n === 32)) throw new Error("Only 8, 16, 24, or 32 bits supported: " + n);
}
// TODO: set ByteBuffer to best available backing
$a4645eb3af0af756$var$util.ByteBuffer = $a4645eb3af0af756$var$ByteStringBuffer;
/** Buffer w/BinaryString backing */ /**
 * Constructor for a binary string backed byte buffer.
 *
 * @param [b] the bytes to wrap (either encoded as string, one byte per
 *          character, or as an ArrayBuffer or Typed Array).
 */ function $a4645eb3af0af756$var$ByteStringBuffer(b) {
    // TODO: update to match DataBuffer API
    // the data in this buffer
    this.data = "";
    // the pointer for reading from this buffer
    this.read = 0;
    if (typeof b === "string") this.data = b;
    else if ($a4645eb3af0af756$var$util.isArrayBuffer(b) || $a4645eb3af0af756$var$util.isArrayBufferView(b)) {
        if (typeof $a4645eb3af0af756$require$Buffer !== "undefined" && b instanceof $a4645eb3af0af756$require$Buffer) this.data = b.toString("binary");
        else {
            // convert native buffer to forge buffer
            // FIXME: support native buffers internally instead
            var arr = new Uint8Array(b);
            try {
                this.data = String.fromCharCode.apply(null, arr);
            } catch (e) {
                for(var i = 0; i < arr.length; ++i)this.putByte(arr[i]);
            }
        }
    } else if (b instanceof $a4645eb3af0af756$var$ByteStringBuffer || typeof b === "object" && typeof b.data === "string" && typeof b.read === "number") {
        // copy existing buffer
        this.data = b.data;
        this.read = b.read;
    }
    // used for v8 optimization
    this._constructedStringLength = 0;
}
$a4645eb3af0af756$var$util.ByteStringBuffer = $a4645eb3af0af756$var$ByteStringBuffer;
/* Note: This is an optimization for V8-based browsers. When V8 concatenates
  a string, the strings are only joined logically using a "cons string" or
  "constructed/concatenated string". These containers keep references to one
  another and can result in very large memory usage. For example, if a 2MB
  string is constructed by concatenating 4 bytes together at a time, the
  memory usage will be ~44MB; so ~22x increase. The strings are only joined
  together when an operation requiring their joining takes place, such as
  substr(). This function is called when adding data to this buffer to ensure
  these types of strings are periodically joined to reduce the memory
  footprint. */ var $a4645eb3af0af756$var$_MAX_CONSTRUCTED_STRING_LENGTH = 4096;
$a4645eb3af0af756$var$util.ByteStringBuffer.prototype._optimizeConstructedString = function(x) {
    this._constructedStringLength += x;
    if (this._constructedStringLength > $a4645eb3af0af756$var$_MAX_CONSTRUCTED_STRING_LENGTH) {
        // this substr() should cause the constructed string to join
        this.data.substr(0, 1);
        this._constructedStringLength = 0;
    }
};
/**
 * Gets the number of bytes in this buffer.
 *
 * @return the number of bytes in this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.length = function() {
    return this.data.length - this.read;
};
/**
 * Gets whether or not this buffer is empty.
 *
 * @return true if this buffer is empty, false if not.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.isEmpty = function() {
    return this.length() <= 0;
};
/**
 * Puts a byte in this buffer.
 *
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.putByte = function(b) {
    return this.putBytes(String.fromCharCode(b));
};
/**
 * Puts a byte in this buffer N times.
 *
 * @param b the byte to put.
 * @param n the number of bytes of value b to put.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.fillWithByte = function(b, n) {
    b = String.fromCharCode(b);
    var d = this.data;
    while(n > 0){
        if (n & 1) d += b;
        n >>>= 1;
        if (n > 0) b += b;
    }
    this.data = d;
    this._optimizeConstructedString(n);
    return this;
};
/**
 * Puts bytes in this buffer.
 *
 * @param bytes the bytes (as a binary encoded string) to put.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.putBytes = function(bytes) {
    this.data += bytes;
    this._optimizeConstructedString(bytes.length);
    return this;
};
/**
 * Puts a UTF-16 encoded string into this buffer.
 *
 * @param str the string to put.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.putString = function(str) {
    return this.putBytes($a4645eb3af0af756$var$util.encodeUtf8(str));
};
/**
 * Puts a 16-bit integer in this buffer in big-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.putInt16 = function(i) {
    return this.putBytes(String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
};
/**
 * Puts a 24-bit integer in this buffer in big-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.putInt24 = function(i) {
    return this.putBytes(String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
};
/**
 * Puts a 32-bit integer in this buffer in big-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.putInt32 = function(i) {
    return this.putBytes(String.fromCharCode(i >> 24 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF));
};
/**
 * Puts a 16-bit integer in this buffer in little-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.putInt16Le = function(i) {
    return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF));
};
/**
 * Puts a 24-bit integer in this buffer in little-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.putInt24Le = function(i) {
    return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF));
};
/**
 * Puts a 32-bit integer in this buffer in little-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.putInt32Le = function(i) {
    return this.putBytes(String.fromCharCode(i & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 24 & 0xFF));
};
/**
 * Puts an n-bit integer in this buffer in big-endian order.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.putInt = function(i, n) {
    $a4645eb3af0af756$var$_checkBitsParam(n);
    var bytes = "";
    do {
        n -= 8;
        bytes += String.fromCharCode(i >> n & 0xFF);
    }while (n > 0);
    return this.putBytes(bytes);
};
/**
 * Puts a signed n-bit integer in this buffer in big-endian order. Two's
 * complement representation is used.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.putSignedInt = function(i, n) {
    // putInt checks n
    if (i < 0) i += 2 << n - 1;
    return this.putInt(i, n);
};
/**
 * Puts the given buffer into this buffer.
 *
 * @param buffer the buffer to put into this one.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.putBuffer = function(buffer) {
    return this.putBytes(buffer.getBytes());
};
/**
 * Gets a byte from this buffer and advances the read pointer by 1.
 *
 * @return the byte.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.getByte = function() {
    return this.data.charCodeAt(this.read++);
};
/**
 * Gets a uint16 from this buffer in big-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.getInt16 = function() {
    var rval = this.data.charCodeAt(this.read) << 8 ^ this.data.charCodeAt(this.read + 1);
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in big-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.getInt24 = function() {
    var rval = this.data.charCodeAt(this.read) << 16 ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2);
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in big-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.getInt32 = function() {
    var rval = this.data.charCodeAt(this.read) << 24 ^ this.data.charCodeAt(this.read + 1) << 16 ^ this.data.charCodeAt(this.read + 2) << 8 ^ this.data.charCodeAt(this.read + 3);
    this.read += 4;
    return rval;
};
/**
 * Gets a uint16 from this buffer in little-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.getInt16Le = function() {
    var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8;
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in little-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.getInt24Le = function() {
    var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16;
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in little-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.getInt32Le = function() {
    var rval = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16 ^ this.data.charCodeAt(this.read + 3) << 24;
    this.read += 4;
    return rval;
};
/**
 * Gets an n-bit integer from this buffer in big-endian order and advances the
 * read pointer by ceil(n/8).
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.getInt = function(n) {
    $a4645eb3af0af756$var$_checkBitsParam(n);
    var rval = 0;
    do {
        // TODO: Use (rval * 0x100) if adding support for 33 to 53 bits.
        rval = (rval << 8) + this.data.charCodeAt(this.read++);
        n -= 8;
    }while (n > 0);
    return rval;
};
/**
 * Gets a signed n-bit integer from this buffer in big-endian order, using
 * two's complement, and advances the read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.getSignedInt = function(n) {
    // getInt checks n
    var x = this.getInt(n);
    var max = 2 << n - 2;
    if (x >= max) x -= max << 1;
    return x;
};
/**
 * Reads bytes out as a binary encoded string and clears them from the
 * buffer. Note that the resulting string is binary encoded (in node.js this
 * encoding is referred to as `binary`, it is *not* `utf8`).
 *
 * @param count the number of bytes to read, undefined or null for all.
 *
 * @return a binary encoded string of bytes.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.getBytes = function(count) {
    var rval;
    if (count) {
        // read count bytes
        count = Math.min(this.length(), count);
        rval = this.data.slice(this.read, this.read + count);
        this.read += count;
    } else if (count === 0) rval = "";
    else {
        // read all bytes, optimize to only copy when needed
        rval = this.read === 0 ? this.data : this.data.slice(this.read);
        this.clear();
    }
    return rval;
};
/**
 * Gets a binary encoded string of the bytes from this buffer without
 * modifying the read pointer.
 *
 * @param count the number of bytes to get, omit to get all.
 *
 * @return a string full of binary encoded characters.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.bytes = function(count) {
    return typeof count === "undefined" ? this.data.slice(this.read) : this.data.slice(this.read, this.read + count);
};
/**
 * Gets a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 *
 * @return the byte.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.at = function(i) {
    return this.data.charCodeAt(this.read + i);
};
/**
 * Puts a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.setAt = function(i, b) {
    this.data = this.data.substr(0, this.read + i) + String.fromCharCode(b) + this.data.substr(this.read + i + 1);
    return this;
};
/**
 * Gets the last byte without modifying the read pointer.
 *
 * @return the last byte.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.last = function() {
    return this.data.charCodeAt(this.data.length - 1);
};
/**
 * Creates a copy of this buffer.
 *
 * @return the copy.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.copy = function() {
    var c = $a4645eb3af0af756$var$util.createBuffer(this.data);
    c.read = this.read;
    return c;
};
/**
 * Compacts this buffer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.compact = function() {
    if (this.read > 0) {
        this.data = this.data.slice(this.read);
        this.read = 0;
    }
    return this;
};
/**
 * Clears this buffer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.clear = function() {
    this.data = "";
    this.read = 0;
    return this;
};
/**
 * Shortens this buffer by triming bytes off of the end of this buffer.
 *
 * @param count the number of bytes to trim off.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.truncate = function(count) {
    var len = Math.max(0, this.length() - count);
    this.data = this.data.substr(this.read, len);
    this.read = 0;
    return this;
};
/**
 * Converts this buffer to a hexadecimal string.
 *
 * @return a hexadecimal string.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.toHex = function() {
    var rval = "";
    for(var i = this.read; i < this.data.length; ++i){
        var b = this.data.charCodeAt(i);
        if (b < 16) rval += "0";
        rval += b.toString(16);
    }
    return rval;
};
/**
 * Converts this buffer to a UTF-16 string (standard JavaScript string).
 *
 * @return a UTF-16 string.
 */ $a4645eb3af0af756$var$util.ByteStringBuffer.prototype.toString = function() {
    return $a4645eb3af0af756$var$util.decodeUtf8(this.bytes());
};
/** End Buffer w/BinaryString backing */ /** Buffer w/UInt8Array backing */ /**
 * FIXME: Experimental. Do not use yet.
 *
 * Constructor for an ArrayBuffer-backed byte buffer.
 *
 * The buffer may be constructed from a string, an ArrayBuffer, DataView, or a
 * TypedArray.
 *
 * If a string is given, its encoding should be provided as an option,
 * otherwise it will default to 'binary'. A 'binary' string is encoded such
 * that each character is one byte in length and size.
 *
 * If an ArrayBuffer, DataView, or TypedArray is given, it will be used
 * *directly* without any copying. Note that, if a write to the buffer requires
 * more space, the buffer will allocate a new backing ArrayBuffer to
 * accommodate. The starting read and write offsets for the buffer may be
 * given as options.
 *
 * @param [b] the initial bytes for this buffer.
 * @param options the options to use:
 *          [readOffset] the starting read offset to use (default: 0).
 *          [writeOffset] the starting write offset to use (default: the
 *            length of the first parameter).
 *          [growSize] the minimum amount, in bytes, to grow the buffer by to
 *            accommodate writes (default: 1024).
 *          [encoding] the encoding ('binary', 'utf8', 'utf16', 'hex') for the
 *            first parameter, if it is a string (default: 'binary').
 */ function $a4645eb3af0af756$var$DataBuffer(b, options) {
    // default options
    options = options || {};
    // pointers for read from/write to buffer
    this.read = options.readOffset || 0;
    this.growSize = options.growSize || 1024;
    var isArrayBuffer = $a4645eb3af0af756$var$util.isArrayBuffer(b);
    var isArrayBufferView = $a4645eb3af0af756$var$util.isArrayBufferView(b);
    if (isArrayBuffer || isArrayBufferView) {
        // use ArrayBuffer directly
        if (isArrayBuffer) this.data = new DataView(b);
        else // TODO: adjust read/write offset based on the type of view
        // or specify that this must be done in the options ... that the
        // offsets are byte-based
        this.data = new DataView(b.buffer, b.byteOffset, b.byteLength);
        this.write = "writeOffset" in options ? options.writeOffset : this.data.byteLength;
        return;
    }
    // initialize to empty array buffer and add any given bytes using putBytes
    this.data = new DataView(new ArrayBuffer(0));
    this.write = 0;
    if (b !== null && b !== undefined) this.putBytes(b);
    if ("writeOffset" in options) this.write = options.writeOffset;
}
$a4645eb3af0af756$var$util.DataBuffer = $a4645eb3af0af756$var$DataBuffer;
/**
 * Gets the number of bytes in this buffer.
 *
 * @return the number of bytes in this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.length = function() {
    return this.write - this.read;
};
/**
 * Gets whether or not this buffer is empty.
 *
 * @return true if this buffer is empty, false if not.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.isEmpty = function() {
    return this.length() <= 0;
};
/**
 * Ensures this buffer has enough empty space to accommodate the given number
 * of bytes. An optional parameter may be given that indicates a minimum
 * amount to grow the buffer if necessary. If the parameter is not given,
 * the buffer will be grown by some previously-specified default amount
 * or heuristic.
 *
 * @param amount the number of bytes to accommodate.
 * @param [growSize] the minimum amount, in bytes, to grow the buffer by if
 *          necessary.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.accommodate = function(amount, growSize) {
    if (this.length() >= amount) return this;
    growSize = Math.max(growSize || this.growSize, amount);
    // grow buffer
    var src = new Uint8Array(this.data.buffer, this.data.byteOffset, this.data.byteLength);
    var dst = new Uint8Array(this.length() + growSize);
    dst.set(src);
    this.data = new DataView(dst.buffer);
    return this;
};
/**
 * Puts a byte in this buffer.
 *
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.putByte = function(b) {
    this.accommodate(1);
    this.data.setUint8(this.write++, b);
    return this;
};
/**
 * Puts a byte in this buffer N times.
 *
 * @param b the byte to put.
 * @param n the number of bytes of value b to put.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.fillWithByte = function(b, n) {
    this.accommodate(n);
    for(var i = 0; i < n; ++i)this.data.setUint8(b);
    return this;
};
/**
 * Puts bytes in this buffer. The bytes may be given as a string, an
 * ArrayBuffer, a DataView, or a TypedArray.
 *
 * @param bytes the bytes to put.
 * @param [encoding] the encoding for the first parameter ('binary', 'utf8',
 *          'utf16', 'hex'), if it is a string (default: 'binary').
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.putBytes = function(bytes, encoding) {
    if ($a4645eb3af0af756$var$util.isArrayBufferView(bytes)) {
        var src = new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
        var len = src.byteLength - src.byteOffset;
        this.accommodate(len);
        var dst = new Uint8Array(this.data.buffer, this.write);
        dst.set(src);
        this.write += len;
        return this;
    }
    if ($a4645eb3af0af756$var$util.isArrayBuffer(bytes)) {
        var src = new Uint8Array(bytes);
        this.accommodate(src.byteLength);
        var dst = new Uint8Array(this.data.buffer);
        dst.set(src, this.write);
        this.write += src.byteLength;
        return this;
    }
    // bytes is a util.DataBuffer or equivalent
    if (bytes instanceof $a4645eb3af0af756$var$util.DataBuffer || typeof bytes === "object" && typeof bytes.read === "number" && typeof bytes.write === "number" && $a4645eb3af0af756$var$util.isArrayBufferView(bytes.data)) {
        var src = new Uint8Array(bytes.data.byteLength, bytes.read, bytes.length());
        this.accommodate(src.byteLength);
        var dst = new Uint8Array(bytes.data.byteLength, this.write);
        dst.set(src);
        this.write += src.byteLength;
        return this;
    }
    if (bytes instanceof $a4645eb3af0af756$var$util.ByteStringBuffer) {
        // copy binary string and process as the same as a string parameter below
        bytes = bytes.data;
        encoding = "binary";
    }
    // string conversion
    encoding = encoding || "binary";
    if (typeof bytes === "string") {
        var view;
        // decode from string
        if (encoding === "hex") {
            this.accommodate(Math.ceil(bytes.length / 2));
            view = new Uint8Array(this.data.buffer, this.write);
            this.write += $a4645eb3af0af756$var$util.binary.hex.decode(bytes, view, this.write);
            return this;
        }
        if (encoding === "base64") {
            this.accommodate(Math.ceil(bytes.length / 4) * 3);
            view = new Uint8Array(this.data.buffer, this.write);
            this.write += $a4645eb3af0af756$var$util.binary.base64.decode(bytes, view, this.write);
            return this;
        }
        // encode text as UTF-8 bytes
        if (encoding === "utf8") {
            // encode as UTF-8 then decode string as raw binary
            bytes = $a4645eb3af0af756$var$util.encodeUtf8(bytes);
            encoding = "binary";
        }
        // decode string as raw binary
        if (encoding === "binary" || encoding === "raw") {
            // one byte per character
            this.accommodate(bytes.length);
            view = new Uint8Array(this.data.buffer, this.write);
            this.write += $a4645eb3af0af756$var$util.binary.raw.decode(view);
            return this;
        }
        // encode text as UTF-16 bytes
        if (encoding === "utf16") {
            // two bytes per character
            this.accommodate(bytes.length * 2);
            view = new Uint16Array(this.data.buffer, this.write);
            this.write += $a4645eb3af0af756$var$util.text.utf16.encode(view);
            return this;
        }
        throw new Error("Invalid encoding: " + encoding);
    }
    throw Error("Invalid parameter: " + bytes);
};
/**
 * Puts the given buffer into this buffer.
 *
 * @param buffer the buffer to put into this one.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.putBuffer = function(buffer) {
    this.putBytes(buffer);
    buffer.clear();
    return this;
};
/**
 * Puts a string into this buffer.
 *
 * @param str the string to put.
 * @param [encoding] the encoding for the string (default: 'utf16').
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.putString = function(str) {
    return this.putBytes(str, "utf16");
};
/**
 * Puts a 16-bit integer in this buffer in big-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.putInt16 = function(i) {
    this.accommodate(2);
    this.data.setInt16(this.write, i);
    this.write += 2;
    return this;
};
/**
 * Puts a 24-bit integer in this buffer in big-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.putInt24 = function(i) {
    this.accommodate(3);
    this.data.setInt16(this.write, i >> 8 & 0xFFFF);
    this.data.setInt8(this.write, i >> 16 & 0xFF);
    this.write += 3;
    return this;
};
/**
 * Puts a 32-bit integer in this buffer in big-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.putInt32 = function(i) {
    this.accommodate(4);
    this.data.setInt32(this.write, i);
    this.write += 4;
    return this;
};
/**
 * Puts a 16-bit integer in this buffer in little-endian order.
 *
 * @param i the 16-bit integer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.putInt16Le = function(i) {
    this.accommodate(2);
    this.data.setInt16(this.write, i, true);
    this.write += 2;
    return this;
};
/**
 * Puts a 24-bit integer in this buffer in little-endian order.
 *
 * @param i the 24-bit integer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.putInt24Le = function(i) {
    this.accommodate(3);
    this.data.setInt8(this.write, i >> 16 & 0xFF);
    this.data.setInt16(this.write, i >> 8 & 0xFFFF, true);
    this.write += 3;
    return this;
};
/**
 * Puts a 32-bit integer in this buffer in little-endian order.
 *
 * @param i the 32-bit integer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.putInt32Le = function(i) {
    this.accommodate(4);
    this.data.setInt32(this.write, i, true);
    this.write += 4;
    return this;
};
/**
 * Puts an n-bit integer in this buffer in big-endian order.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.putInt = function(i, n) {
    $a4645eb3af0af756$var$_checkBitsParam(n);
    this.accommodate(n / 8);
    do {
        n -= 8;
        this.data.setInt8(this.write++, i >> n & 0xFF);
    }while (n > 0);
    return this;
};
/**
 * Puts a signed n-bit integer in this buffer in big-endian order. Two's
 * complement representation is used.
 *
 * @param i the n-bit integer.
 * @param n the number of bits in the integer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.putSignedInt = function(i, n) {
    $a4645eb3af0af756$var$_checkBitsParam(n);
    this.accommodate(n / 8);
    if (i < 0) i += 2 << n - 1;
    return this.putInt(i, n);
};
/**
 * Gets a byte from this buffer and advances the read pointer by 1.
 *
 * @return the byte.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.getByte = function() {
    return this.data.getInt8(this.read++);
};
/**
 * Gets a uint16 from this buffer in big-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.getInt16 = function() {
    var rval = this.data.getInt16(this.read);
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in big-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.getInt24 = function() {
    var rval = this.data.getInt16(this.read) << 8 ^ this.data.getInt8(this.read + 2);
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in big-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.getInt32 = function() {
    var rval = this.data.getInt32(this.read);
    this.read += 4;
    return rval;
};
/**
 * Gets a uint16 from this buffer in little-endian order and advances the read
 * pointer by 2.
 *
 * @return the uint16.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.getInt16Le = function() {
    var rval = this.data.getInt16(this.read, true);
    this.read += 2;
    return rval;
};
/**
 * Gets a uint24 from this buffer in little-endian order and advances the read
 * pointer by 3.
 *
 * @return the uint24.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.getInt24Le = function() {
    var rval = this.data.getInt8(this.read) ^ this.data.getInt16(this.read + 1, true) << 8;
    this.read += 3;
    return rval;
};
/**
 * Gets a uint32 from this buffer in little-endian order and advances the read
 * pointer by 4.
 *
 * @return the word.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.getInt32Le = function() {
    var rval = this.data.getInt32(this.read, true);
    this.read += 4;
    return rval;
};
/**
 * Gets an n-bit integer from this buffer in big-endian order and advances the
 * read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.getInt = function(n) {
    $a4645eb3af0af756$var$_checkBitsParam(n);
    var rval = 0;
    do {
        // TODO: Use (rval * 0x100) if adding support for 33 to 53 bits.
        rval = (rval << 8) + this.data.getInt8(this.read++);
        n -= 8;
    }while (n > 0);
    return rval;
};
/**
 * Gets a signed n-bit integer from this buffer in big-endian order, using
 * two's complement, and advances the read pointer by n/8.
 *
 * @param n the number of bits in the integer (8, 16, 24, or 32).
 *
 * @return the integer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.getSignedInt = function(n) {
    // getInt checks n
    var x = this.getInt(n);
    var max = 2 << n - 2;
    if (x >= max) x -= max << 1;
    return x;
};
/**
 * Reads bytes out as a binary encoded string and clears them from the
 * buffer.
 *
 * @param count the number of bytes to read, undefined or null for all.
 *
 * @return a binary encoded string of bytes.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.getBytes = function(count) {
    // TODO: deprecate this method, it is poorly named and
    // this.toString('binary') replaces it
    // add a toTypedArray()/toArrayBuffer() function
    var rval;
    if (count) {
        // read count bytes
        count = Math.min(this.length(), count);
        rval = this.data.slice(this.read, this.read + count);
        this.read += count;
    } else if (count === 0) rval = "";
    else {
        // read all bytes, optimize to only copy when needed
        rval = this.read === 0 ? this.data : this.data.slice(this.read);
        this.clear();
    }
    return rval;
};
/**
 * Gets a binary encoded string of the bytes from this buffer without
 * modifying the read pointer.
 *
 * @param count the number of bytes to get, omit to get all.
 *
 * @return a string full of binary encoded characters.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.bytes = function(count) {
    // TODO: deprecate this method, it is poorly named, add "getString()"
    return typeof count === "undefined" ? this.data.slice(this.read) : this.data.slice(this.read, this.read + count);
};
/**
 * Gets a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 *
 * @return the byte.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.at = function(i) {
    return this.data.getUint8(this.read + i);
};
/**
 * Puts a byte at the given index without modifying the read pointer.
 *
 * @param i the byte index.
 * @param b the byte to put.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.setAt = function(i, b) {
    this.data.setUint8(i, b);
    return this;
};
/**
 * Gets the last byte without modifying the read pointer.
 *
 * @return the last byte.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.last = function() {
    return this.data.getUint8(this.write - 1);
};
/**
 * Creates a copy of this buffer.
 *
 * @return the copy.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.copy = function() {
    return new $a4645eb3af0af756$var$util.DataBuffer(this);
};
/**
 * Compacts this buffer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.compact = function() {
    if (this.read > 0) {
        var src = new Uint8Array(this.data.buffer, this.read);
        var dst = new Uint8Array(src.byteLength);
        dst.set(src);
        this.data = new DataView(dst);
        this.write -= this.read;
        this.read = 0;
    }
    return this;
};
/**
 * Clears this buffer.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.clear = function() {
    this.data = new DataView(new ArrayBuffer(0));
    this.read = this.write = 0;
    return this;
};
/**
 * Shortens this buffer by triming bytes off of the end of this buffer.
 *
 * @param count the number of bytes to trim off.
 *
 * @return this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.truncate = function(count) {
    this.write = Math.max(0, this.length() - count);
    this.read = Math.min(this.read, this.write);
    return this;
};
/**
 * Converts this buffer to a hexadecimal string.
 *
 * @return a hexadecimal string.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.toHex = function() {
    var rval = "";
    for(var i = this.read; i < this.data.byteLength; ++i){
        var b = this.data.getUint8(i);
        if (b < 16) rval += "0";
        rval += b.toString(16);
    }
    return rval;
};
/**
 * Converts this buffer to a string, using the given encoding. If no
 * encoding is given, 'utf8' (UTF-8) is used.
 *
 * @param [encoding] the encoding to use: 'binary', 'utf8', 'utf16', 'hex',
 *          'base64' (default: 'utf8').
 *
 * @return a string representation of the bytes in this buffer.
 */ $a4645eb3af0af756$var$util.DataBuffer.prototype.toString = function(encoding) {
    var view = new Uint8Array(this.data, this.read, this.length());
    encoding = encoding || "utf8";
    // encode to string
    if (encoding === "binary" || encoding === "raw") return $a4645eb3af0af756$var$util.binary.raw.encode(view);
    if (encoding === "hex") return $a4645eb3af0af756$var$util.binary.hex.encode(view);
    if (encoding === "base64") return $a4645eb3af0af756$var$util.binary.base64.encode(view);
    // decode to text
    if (encoding === "utf8") return $a4645eb3af0af756$var$util.text.utf8.decode(view);
    if (encoding === "utf16") return $a4645eb3af0af756$var$util.text.utf16.decode(view);
    throw new Error("Invalid encoding: " + encoding);
};
/** End Buffer w/UInt8Array backing */ /**
 * Creates a buffer that stores bytes. A value may be given to populate the
 * buffer with data. This value can either be string of encoded bytes or a
 * regular string of characters. When passing a string of binary encoded
 * bytes, the encoding `raw` should be given. This is also the default. When
 * passing a string of characters, the encoding `utf8` should be given.
 *
 * @param [input] a string with encoded bytes to store in the buffer.
 * @param [encoding] (default: 'raw', other: 'utf8').
 */ $a4645eb3af0af756$var$util.createBuffer = function(input, encoding) {
    // TODO: deprecate, use new ByteBuffer() instead
    encoding = encoding || "raw";
    if (input !== undefined && encoding === "utf8") input = $a4645eb3af0af756$var$util.encodeUtf8(input);
    return new $a4645eb3af0af756$var$util.ByteBuffer(input);
};
/**
 * Fills a string with a particular value. If you want the string to be a byte
 * string, pass in String.fromCharCode(theByte).
 *
 * @param c the character to fill the string with, use String.fromCharCode
 *          to fill the string with a byte value.
 * @param n the number of characters of value c to fill with.
 *
 * @return the filled string.
 */ $a4645eb3af0af756$var$util.fillString = function(c, n) {
    var s = "";
    while(n > 0){
        if (n & 1) s += c;
        n >>>= 1;
        if (n > 0) c += c;
    }
    return s;
};
/**
 * Performs a per byte XOR between two byte strings and returns the result as a
 * string of bytes.
 *
 * @param s1 first string of bytes.
 * @param s2 second string of bytes.
 * @param n the number of bytes to XOR.
 *
 * @return the XOR'd result.
 */ $a4645eb3af0af756$var$util.xorBytes = function(s1, s2, n) {
    var s3 = "";
    var b = "";
    var t = "";
    var i = 0;
    var c = 0;
    for(; n > 0; --n, ++i){
        b = s1.charCodeAt(i) ^ s2.charCodeAt(i);
        if (c >= 10) {
            s3 += t;
            t = "";
            c = 0;
        }
        t += String.fromCharCode(b);
        ++c;
    }
    s3 += t;
    return s3;
};
/**
 * Converts a hex string into a 'binary' encoded string of bytes.
 *
 * @param hex the hexadecimal string to convert.
 *
 * @return the binary-encoded string of bytes.
 */ $a4645eb3af0af756$var$util.hexToBytes = function(hex) {
    // TODO: deprecate: "Deprecated. Use util.binary.hex.decode instead."
    var rval = "";
    var i = 0;
    if (hex.length & true) {
        // odd number of characters, convert first character alone
        i = 1;
        rval += String.fromCharCode(parseInt(hex[0], 16));
    }
    // convert 2 characters (1 byte) at a time
    for(; i < hex.length; i += 2)rval += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    return rval;
};
/**
 * Converts a 'binary' encoded string of bytes to hex.
 *
 * @param bytes the byte string to convert.
 *
 * @return the string of hexadecimal characters.
 */ $a4645eb3af0af756$var$util.bytesToHex = function(bytes) {
    // TODO: deprecate: "Deprecated. Use util.binary.hex.encode instead."
    return $a4645eb3af0af756$var$util.createBuffer(bytes).toHex();
};
/**
 * Converts an 32-bit integer to 4-big-endian byte string.
 *
 * @param i the integer.
 *
 * @return the byte string.
 */ $a4645eb3af0af756$var$util.int32ToBytes = function(i) {
    return String.fromCharCode(i >> 24 & 0xFF) + String.fromCharCode(i >> 16 & 0xFF) + String.fromCharCode(i >> 8 & 0xFF) + String.fromCharCode(i & 0xFF);
};
// base64 characters, reverse mapping
var $a4645eb3af0af756$var$_base64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var $a4645eb3af0af756$var$_base64Idx = [
    /*43 -43 = 0*/ /*'+',  1,  2,  3,'/' */ 62,
    -1,
    -1,
    -1,
    63,
    /*'0','1','2','3','4','5','6','7','8','9' */ 52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    /*15, 16, 17,'=', 19, 20, 21 */ -1,
    -1,
    -1,
    64,
    -1,
    -1,
    -1,
    /*65 - 43 = 22*/ /*'A','B','C','D','E','F','G','H','I','J','K','L','M', */ 0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    /*'N','O','P','Q','R','S','T','U','V','W','X','Y','Z' */ 13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    /*91 - 43 = 48 */ /*48, 49, 50, 51, 52, 53 */ -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    /*97 - 43 = 54*/ /*'a','b','c','d','e','f','g','h','i','j','k','l','m' */ 26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    /*'n','o','p','q','r','s','t','u','v','w','x','y','z' */ 39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51
];
// base58 characters (Bitcoin alphabet)
var $a4645eb3af0af756$var$_base58 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
/**
 * Base64 encodes a 'binary' encoded string of bytes.
 *
 * @param input the binary encoded string of bytes to base64-encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the base64-encoded output.
 */ $a4645eb3af0af756$var$util.encode64 = function(input, maxline) {
    // TODO: deprecate: "Deprecated. Use util.binary.base64.encode instead."
    var line = "";
    var output = "";
    var chr1, chr2, chr3;
    var i = 0;
    while(i < input.length){
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        // encode 4 character group
        line += $a4645eb3af0af756$var$_base64.charAt(chr1 >> 2);
        line += $a4645eb3af0af756$var$_base64.charAt((chr1 & 3) << 4 | chr2 >> 4);
        if (isNaN(chr2)) line += "==";
        else {
            line += $a4645eb3af0af756$var$_base64.charAt((chr2 & 15) << 2 | chr3 >> 6);
            line += isNaN(chr3) ? "=" : $a4645eb3af0af756$var$_base64.charAt(chr3 & 63);
        }
        if (maxline && line.length > maxline) {
            output += line.substr(0, maxline) + "\r\n";
            line = line.substr(maxline);
        }
    }
    output += line;
    return output;
};
/**
 * Base64 decodes a string into a 'binary' encoded string of bytes.
 *
 * @param input the base64-encoded input.
 *
 * @return the binary encoded string.
 */ $a4645eb3af0af756$var$util.decode64 = function(input) {
    // TODO: deprecate: "Deprecated. Use util.binary.base64.decode instead."
    // remove all non-base64 characters
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    var output = "";
    var enc1, enc2, enc3, enc4;
    var i = 0;
    while(i < input.length){
        enc1 = $a4645eb3af0af756$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc2 = $a4645eb3af0af756$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc3 = $a4645eb3af0af756$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc4 = $a4645eb3af0af756$var$_base64Idx[input.charCodeAt(i++) - 43];
        output += String.fromCharCode(enc1 << 2 | enc2 >> 4);
        if (enc3 !== 64) {
            // decoded at least 2 bytes
            output += String.fromCharCode((enc2 & 15) << 4 | enc3 >> 2);
            if (enc4 !== 64) // decoded 3 bytes
            output += String.fromCharCode((enc3 & 3) << 6 | enc4);
        }
    }
    return output;
};
/**
 * Encodes the given string of characters (a standard JavaScript
 * string) as a binary encoded string where the bytes represent
 * a UTF-8 encoded string of characters. Non-ASCII characters will be
 * encoded as multiple bytes according to UTF-8.
 *
 * @param str a standard string of characters to encode.
 *
 * @return the binary encoded string.
 */ $a4645eb3af0af756$var$util.encodeUtf8 = function(str) {
    return unescape(encodeURIComponent(str));
};
/**
 * Decodes a binary encoded string that contains bytes that
 * represent a UTF-8 encoded string of characters -- into a
 * string of characters (a standard JavaScript string).
 *
 * @param str the binary encoded string to decode.
 *
 * @return the resulting standard string of characters.
 */ $a4645eb3af0af756$var$util.decodeUtf8 = function(str) {
    return decodeURIComponent(escape(str));
};
// binary encoding/decoding tools
// FIXME: Experimental. Do not use yet.
$a4645eb3af0af756$var$util.binary = {
    raw: {},
    hex: {},
    base64: {},
    base58: {},
    baseN: {
        encode: $8l6KK.encode,
        decode: $8l6KK.decode
    }
};
/**
 * Encodes a Uint8Array as a binary-encoded string. This encoding uses
 * a value between 0 and 255 for each character.
 *
 * @param bytes the Uint8Array to encode.
 *
 * @return the binary-encoded string.
 */ $a4645eb3af0af756$var$util.binary.raw.encode = function(bytes) {
    return String.fromCharCode.apply(null, bytes);
};
/**
 * Decodes a binary-encoded string to a Uint8Array. This encoding uses
 * a value between 0 and 255 for each character.
 *
 * @param str the binary-encoded string to decode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $a4645eb3af0af756$var$util.binary.raw.decode = function(str, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(str.length);
    offset = offset || 0;
    var j = offset;
    for(var i = 0; i < str.length; ++i)out[j++] = str.charCodeAt(i);
    return output ? j - offset : out;
};
/**
 * Encodes a 'binary' string, ArrayBuffer, DataView, TypedArray, or
 * ByteBuffer as a string of hexadecimal characters.
 *
 * @param bytes the bytes to convert.
 *
 * @return the string of hexadecimal characters.
 */ $a4645eb3af0af756$var$util.binary.hex.encode = $a4645eb3af0af756$var$util.bytesToHex;
/**
 * Decodes a hex-encoded string to a Uint8Array.
 *
 * @param hex the hexadecimal string to convert.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $a4645eb3af0af756$var$util.binary.hex.decode = function(hex, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(Math.ceil(hex.length / 2));
    offset = offset || 0;
    var i = 0, j = offset;
    if (hex.length & 1) {
        // odd number of characters, convert first character alone
        i = 1;
        out[j++] = parseInt(hex[0], 16);
    }
    // convert 2 characters (1 byte) at a time
    for(; i < hex.length; i += 2)out[j++] = parseInt(hex.substr(i, 2), 16);
    return output ? j - offset : out;
};
/**
 * Base64-encodes a Uint8Array.
 *
 * @param input the Uint8Array to encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the base64-encoded output string.
 */ $a4645eb3af0af756$var$util.binary.base64.encode = function(input, maxline) {
    var line = "";
    var output = "";
    var chr1, chr2, chr3;
    var i = 0;
    while(i < input.byteLength){
        chr1 = input[i++];
        chr2 = input[i++];
        chr3 = input[i++];
        // encode 4 character group
        line += $a4645eb3af0af756$var$_base64.charAt(chr1 >> 2);
        line += $a4645eb3af0af756$var$_base64.charAt((chr1 & 3) << 4 | chr2 >> 4);
        if (isNaN(chr2)) line += "==";
        else {
            line += $a4645eb3af0af756$var$_base64.charAt((chr2 & 15) << 2 | chr3 >> 6);
            line += isNaN(chr3) ? "=" : $a4645eb3af0af756$var$_base64.charAt(chr3 & 63);
        }
        if (maxline && line.length > maxline) {
            output += line.substr(0, maxline) + "\r\n";
            line = line.substr(maxline);
        }
    }
    output += line;
    return output;
};
/**
 * Decodes a base64-encoded string to a Uint8Array.
 *
 * @param input the base64-encoded input string.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $a4645eb3af0af756$var$util.binary.base64.decode = function(input, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(Math.ceil(input.length / 4) * 3);
    // remove all non-base64 characters
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    offset = offset || 0;
    var enc1, enc2, enc3, enc4;
    var i = 0, j = offset;
    while(i < input.length){
        enc1 = $a4645eb3af0af756$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc2 = $a4645eb3af0af756$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc3 = $a4645eb3af0af756$var$_base64Idx[input.charCodeAt(i++) - 43];
        enc4 = $a4645eb3af0af756$var$_base64Idx[input.charCodeAt(i++) - 43];
        out[j++] = enc1 << 2 | enc2 >> 4;
        if (enc3 !== 64) {
            // decoded at least 2 bytes
            out[j++] = (enc2 & 15) << 4 | enc3 >> 2;
            if (enc4 !== 64) // decoded 3 bytes
            out[j++] = (enc3 & 3) << 6 | enc4;
        }
    }
    // make sure result is the exact decoded length
    return output ? j - offset : out.subarray(0, j);
};
// add support for base58 encoding/decoding with Bitcoin alphabet
$a4645eb3af0af756$var$util.binary.base58.encode = function(input, maxline) {
    return $a4645eb3af0af756$var$util.binary.baseN.encode(input, $a4645eb3af0af756$var$_base58, maxline);
};
$a4645eb3af0af756$var$util.binary.base58.decode = function(input, maxline) {
    return $a4645eb3af0af756$var$util.binary.baseN.decode(input, $a4645eb3af0af756$var$_base58, maxline);
};
// text encoding/decoding tools
// FIXME: Experimental. Do not use yet.
$a4645eb3af0af756$var$util.text = {
    utf8: {},
    utf16: {}
};
/**
 * Encodes the given string as UTF-8 in a Uint8Array.
 *
 * @param str the string to encode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $a4645eb3af0af756$var$util.text.utf8.encode = function(str, output, offset) {
    str = $a4645eb3af0af756$var$util.encodeUtf8(str);
    var out = output;
    if (!out) out = new Uint8Array(str.length);
    offset = offset || 0;
    var j = offset;
    for(var i = 0; i < str.length; ++i)out[j++] = str.charCodeAt(i);
    return output ? j - offset : out;
};
/**
 * Decodes the UTF-8 contents from a Uint8Array.
 *
 * @param bytes the Uint8Array to decode.
 *
 * @return the resulting string.
 */ $a4645eb3af0af756$var$util.text.utf8.decode = function(bytes) {
    return $a4645eb3af0af756$var$util.decodeUtf8(String.fromCharCode.apply(null, bytes));
};
/**
 * Encodes the given string as UTF-16 in a Uint8Array.
 *
 * @param str the string to encode.
 * @param [output] an optional Uint8Array to write the output to; if it
 *          is too small, an exception will be thrown.
 * @param [offset] the start offset for writing to the output (default: 0).
 *
 * @return the Uint8Array or the number of bytes written if output was given.
 */ $a4645eb3af0af756$var$util.text.utf16.encode = function(str, output, offset) {
    var out = output;
    if (!out) out = new Uint8Array(str.length * 2);
    var view = new Uint16Array(out.buffer);
    offset = offset || 0;
    var j = offset;
    var k = offset;
    for(var i = 0; i < str.length; ++i){
        view[k++] = str.charCodeAt(i);
        j += 2;
    }
    return output ? j - offset : out;
};
/**
 * Decodes the UTF-16 contents from a Uint8Array.
 *
 * @param bytes the Uint8Array to decode.
 *
 * @return the resulting string.
 */ $a4645eb3af0af756$var$util.text.utf16.decode = function(bytes) {
    return String.fromCharCode.apply(null, new Uint16Array(bytes.buffer));
};
/**
 * Deflates the given data using a flash interface.
 *
 * @param api the flash interface.
 * @param bytes the data.
 * @param raw true to return only raw deflate data, false to include zlib
 *          header and trailer.
 *
 * @return the deflated data as a string.
 */ $a4645eb3af0af756$var$util.deflate = function(api, bytes, raw) {
    bytes = $a4645eb3af0af756$var$util.decode64(api.deflate($a4645eb3af0af756$var$util.encode64(bytes)).rval);
    // strip zlib header and trailer if necessary
    if (raw) {
        // zlib header is 2 bytes (CMF,FLG) where FLG indicates that
        // there is a 4-byte DICT (alder-32) block before the data if
        // its 5th bit is set
        var start = 2;
        var flg = bytes.charCodeAt(1);
        if (flg & 0x20) start = 6;
        // zlib trailer is 4 bytes of adler-32
        bytes = bytes.substring(start, bytes.length - 4);
    }
    return bytes;
};
/**
 * Inflates the given data using a flash interface.
 *
 * @param api the flash interface.
 * @param bytes the data.
 * @param raw true if the incoming data has no zlib header or trailer and is
 *          raw DEFLATE data.
 *
 * @return the inflated data as a string, null on error.
 */ $a4645eb3af0af756$var$util.inflate = function(api, bytes, raw) {
    // TODO: add zlib header and trailer if necessary/possible
    var rval = api.inflate($a4645eb3af0af756$var$util.encode64(bytes)).rval;
    return rval === null ? null : $a4645eb3af0af756$var$util.decode64(rval);
};
/**
 * Sets a storage object.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param obj the storage object, null to remove.
 */ var $a4645eb3af0af756$var$_setStorageObject = function(api, id, obj) {
    if (!api) throw new Error("WebStorage not available.");
    var rval;
    if (obj === null) rval = api.removeItem(id);
    else {
        // json-encode and base64-encode object
        obj = $a4645eb3af0af756$var$util.encode64(JSON.stringify(obj));
        rval = api.setItem(id, obj);
    }
    // handle potential flash error
    if (typeof rval !== "undefined" && rval.rval !== true) {
        var error = new Error(rval.error.message);
        error.id = rval.error.id;
        error.name = rval.error.name;
        throw error;
    }
};
/**
 * Gets a storage object.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 *
 * @return the storage object entry or null if none exists.
 */ var $a4645eb3af0af756$var$_getStorageObject = function(api, id) {
    if (!api) throw new Error("WebStorage not available.");
    // get the existing entry
    var rval = api.getItem(id);
    /* Note: We check api.init because we can't do (api == localStorage)
    on IE because of "Class doesn't support Automation" exception. Only
    the flash api has an init method so this works too, but we need a
    better solution in the future. */ // flash returns item wrapped in an object, handle special case
    if (api.init) {
        if (rval.rval === null) {
            if (rval.error) {
                var error = new Error(rval.error.message);
                error.id = rval.error.id;
                error.name = rval.error.name;
                throw error;
            }
            // no error, but also no item
            rval = null;
        } else rval = rval.rval;
    }
    // handle decoding
    if (rval !== null) // base64-decode and json-decode data
    rval = JSON.parse($a4645eb3af0af756$var$util.decode64(rval));
    return rval;
};
/**
 * Stores an item in local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param data the data for the item (any javascript object/primitive).
 */ var $a4645eb3af0af756$var$_setItem = function(api, id, key, data) {
    // get storage object
    var obj = $a4645eb3af0af756$var$_getStorageObject(api, id);
    if (obj === null) // create a new storage object
    obj = {};
    // update key
    obj[key] = data;
    // set storage object
    $a4645eb3af0af756$var$_setStorageObject(api, id, obj);
};
/**
 * Gets an item from local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 *
 * @return the item.
 */ var $a4645eb3af0af756$var$_getItem = function(api, id, key) {
    // get storage object
    var rval = $a4645eb3af0af756$var$_getStorageObject(api, id);
    if (rval !== null) // return data at key
    rval = key in rval ? rval[key] : null;
    return rval;
};
/**
 * Removes an item from local storage.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 */ var $a4645eb3af0af756$var$_removeItem = function(api, id, key) {
    // get storage object
    var obj = $a4645eb3af0af756$var$_getStorageObject(api, id);
    if (obj !== null && key in obj) {
        // remove key
        delete obj[key];
        // see if entry has no keys remaining
        var empty = true;
        for(var prop in obj){
            empty = false;
            break;
        }
        if (empty) // remove entry entirely if no keys are left
        obj = null;
        // set storage object
        $a4645eb3af0af756$var$_setStorageObject(api, id, obj);
    }
};
/**
 * Clears the local disk storage identified by the given ID.
 *
 * @param api the storage interface.
 * @param id the storage ID to use.
 */ var $a4645eb3af0af756$var$_clearItems = function(api, id) {
    $a4645eb3af0af756$var$_setStorageObject(api, id, null);
};
/**
 * Calls a storage function.
 *
 * @param func the function to call.
 * @param args the arguments for the function.
 * @param location the location argument.
 *
 * @return the return value from the function.
 */ var $a4645eb3af0af756$var$_callStorageFunction = function(func, args, location) {
    var rval = null;
    // default storage types
    if (typeof location === "undefined") location = [
        "web",
        "flash"
    ];
    // apply storage types in order of preference
    var type;
    var done = false;
    var exception = null;
    for(var idx in location){
        type = location[idx];
        try {
            if (type === "flash" || type === "both") {
                if (args[0] === null) throw new Error("Flash local storage not available.");
                rval = func.apply(this, args);
                done = type === "flash";
            }
            if (type === "web" || type === "both") {
                args[0] = localStorage;
                rval = func.apply(this, args);
                done = true;
            }
        } catch (ex) {
            exception = ex;
        }
        if (done) break;
    }
    if (!done) throw exception;
    return rval;
};
/**
 * Stores an item on local disk.
 *
 * The available types of local storage include 'flash', 'web', and 'both'.
 *
 * The type 'flash' refers to flash local storage (SharedObject). In order
 * to use flash local storage, the 'api' parameter must be valid. The type
 * 'web' refers to WebStorage, if supported by the browser. The type 'both'
 * refers to storing using both 'flash' and 'web', not just one or the
 * other.
 *
 * The location array should list the storage types to use in order of
 * preference:
 *
 * ['flash']: flash only storage
 * ['web']: web only storage
 * ['both']: try to store in both
 * ['flash','web']: store in flash first, but if not available, 'web'
 * ['web','flash']: store in web first, but if not available, 'flash'
 *
 * The location array defaults to: ['web', 'flash']
 *
 * @param api the flash interface, null to use only WebStorage.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param data the data for the item (any javascript object/primitive).
 * @param location an array with the preferred types of storage to use.
 */ $a4645eb3af0af756$var$util.setItem = function(api, id, key, data, location) {
    $a4645eb3af0af756$var$_callStorageFunction($a4645eb3af0af756$var$_setItem, arguments, location);
};
/**
 * Gets an item on local disk.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface, null to use only WebStorage.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param location an array with the preferred types of storage to use.
 *
 * @return the item.
 */ $a4645eb3af0af756$var$util.getItem = function(api, id, key, location) {
    return $a4645eb3af0af756$var$_callStorageFunction($a4645eb3af0af756$var$_getItem, arguments, location);
};
/**
 * Removes an item on local disk.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface.
 * @param id the storage ID to use.
 * @param key the key for the item.
 * @param location an array with the preferred types of storage to use.
 */ $a4645eb3af0af756$var$util.removeItem = function(api, id, key, location) {
    $a4645eb3af0af756$var$_callStorageFunction($a4645eb3af0af756$var$_removeItem, arguments, location);
};
/**
 * Clears the local disk storage identified by the given ID.
 *
 * Set setItem() for details on storage types.
 *
 * @param api the flash interface if flash is available.
 * @param id the storage ID to use.
 * @param location an array with the preferred types of storage to use.
 */ $a4645eb3af0af756$var$util.clearItems = function(api, id, location) {
    $a4645eb3af0af756$var$_callStorageFunction($a4645eb3af0af756$var$_clearItems, arguments, location);
};
/**
 * Parses the scheme, host, and port from an http(s) url.
 *
 * @param str the url string.
 *
 * @return the parsed url object or null if the url is invalid.
 */ $a4645eb3af0af756$var$util.parseUrl = function(str) {
    // FIXME: this regex looks a bit broken
    var regex = /^(https?):\/\/([^:&^\/]*):?(\d*)(.*)$/g;
    regex.lastIndex = 0;
    var m = regex.exec(str);
    var url = m === null ? null : {
        full: str,
        scheme: m[1],
        host: m[2],
        port: m[3],
        path: m[4]
    };
    if (url) {
        url.fullHost = url.host;
        if (url.port) {
            if (url.port !== 80 && url.scheme === "http") url.fullHost += ":" + url.port;
            else if (url.port !== 443 && url.scheme === "https") url.fullHost += ":" + url.port;
        } else if (url.scheme === "http") url.port = 80;
        else if (url.scheme === "https") url.port = 443;
        url.full = url.scheme + "://" + url.fullHost;
    }
    return url;
};
/* Storage for query variables */ var $a4645eb3af0af756$var$_queryVariables = null;
/**
 * Returns the window location query variables. Query is parsed on the first
 * call and the same object is returned on subsequent calls. The mapping
 * is from keys to an array of values. Parameters without values will have
 * an object key set but no value added to the value array. Values are
 * unescaped.
 *
 * ...?k1=v1&k2=v2:
 * {
 *   "k1": ["v1"],
 *   "k2": ["v2"]
 * }
 *
 * ...?k1=v1&k1=v2:
 * {
 *   "k1": ["v1", "v2"]
 * }
 *
 * ...?k1=v1&k2:
 * {
 *   "k1": ["v1"],
 *   "k2": []
 * }
 *
 * ...?k1=v1&k1:
 * {
 *   "k1": ["v1"]
 * }
 *
 * ...?k1&k1:
 * {
 *   "k1": []
 * }
 *
 * @param query the query string to parse (optional, default to cached
 *          results from parsing window location search query).
 *
 * @return object mapping keys to variables.
 */ $a4645eb3af0af756$var$util.getQueryVariables = function(query) {
    var parse = function(q) {
        var rval = {};
        var kvpairs = q.split("&");
        for(var i = 0; i < kvpairs.length; i++){
            var pos = kvpairs[i].indexOf("=");
            var key;
            var val;
            if (pos > 0) {
                key = kvpairs[i].substring(0, pos);
                val = kvpairs[i].substring(pos + 1);
            } else {
                key = kvpairs[i];
                val = null;
            }
            if (!(key in rval)) rval[key] = [];
            // disallow overriding object prototype keys
            if (!(key in Object.prototype) && val !== null) rval[key].push(unescape(val));
        }
        return rval;
    };
    var rval;
    if (typeof query === "undefined") {
        // set cached variables if needed
        if ($a4645eb3af0af756$var$_queryVariables === null) {
            if (typeof window !== "undefined" && window.location && window.location.search) // parse window search query
            $a4645eb3af0af756$var$_queryVariables = parse(window.location.search.substring(1));
            else // no query variables available
            $a4645eb3af0af756$var$_queryVariables = {};
        }
        rval = $a4645eb3af0af756$var$_queryVariables;
    } else // parse given query
    rval = parse(query);
    return rval;
};
/**
 * Parses a fragment into a path and query. This method will take a URI
 * fragment and break it up as if it were the main URI. For example:
 *    /bar/baz?a=1&b=2
 * results in:
 *    {
 *       path: ["bar", "baz"],
 *       query: {"k1": ["v1"], "k2": ["v2"]}
 *    }
 *
 * @return object with a path array and query object.
 */ $a4645eb3af0af756$var$util.parseFragment = function(fragment) {
    // default to whole fragment
    var fp = fragment;
    var fq = "";
    // split into path and query if possible at the first '?'
    var pos = fragment.indexOf("?");
    if (pos > 0) {
        fp = fragment.substring(0, pos);
        fq = fragment.substring(pos + 1);
    }
    // split path based on '/' and ignore first element if empty
    var path = fp.split("/");
    if (path.length > 0 && path[0] === "") path.shift();
    // convert query into object
    var query = fq === "" ? {} : $a4645eb3af0af756$var$util.getQueryVariables(fq);
    return {
        pathString: fp,
        queryString: fq,
        path: path,
        query: query
    };
};
/**
 * Makes a request out of a URI-like request string. This is intended to
 * be used where a fragment id (after a URI '#') is parsed as a URI with
 * path and query parts. The string should have a path beginning and
 * delimited by '/' and optional query parameters following a '?'. The
 * query should be a standard URL set of key value pairs delimited by
 * '&'. For backwards compatibility the initial '/' on the path is not
 * required. The request object has the following API, (fully described
 * in the method code):
 *    {
 *       path: <the path string part>.
 *       query: <the query string part>,
 *       getPath(i): get part or all of the split path array,
 *       getQuery(k, i): get part or all of a query key array,
 *       getQueryLast(k, _default): get last element of a query key array.
 *    }
 *
 * @return object with request parameters.
 */ $a4645eb3af0af756$var$util.makeRequest = function(reqString) {
    var frag = $a4645eb3af0af756$var$util.parseFragment(reqString);
    var req = {
        // full path string
        path: frag.pathString,
        // full query string
        query: frag.queryString,
        /**
     * Get path or element in path.
     *
     * @param i optional path index.
     *
     * @return path or part of path if i provided.
     */ getPath: function(i) {
            return typeof i === "undefined" ? frag.path : frag.path[i];
        },
        /**
     * Get query, values for a key, or value for a key index.
     *
     * @param k optional query key.
     * @param i optional query key index.
     *
     * @return query, values for a key, or value for a key index.
     */ getQuery: function(k, i) {
            var rval;
            if (typeof k === "undefined") rval = frag.query;
            else {
                rval = frag.query[k];
                if (rval && typeof i !== "undefined") rval = rval[i];
            }
            return rval;
        },
        getQueryLast: function(k, _default) {
            var rval;
            var vals = req.getQuery(k);
            if (vals) rval = vals[vals.length - 1];
            else rval = _default;
            return rval;
        }
    };
    return req;
};
/**
 * Makes a URI out of a path, an object with query parameters, and a
 * fragment. Uses jQuery.param() internally for query string creation.
 * If the path is an array, it will be joined with '/'.
 *
 * @param path string path or array of strings.
 * @param query object with query parameters. (optional)
 * @param fragment fragment string. (optional)
 *
 * @return string object with request parameters.
 */ $a4645eb3af0af756$var$util.makeLink = function(path, query, fragment) {
    // join path parts if needed
    path = jQuery.isArray(path) ? path.join("/") : path;
    var qstr = jQuery.param(query || {});
    fragment = fragment || "";
    return path + (qstr.length > 0 ? "?" + qstr : "") + (fragment.length > 0 ? "#" + fragment : "");
};
/**
 * Check if an object is empty.
 *
 * Taken from:
 * http://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object-from-json/679937#679937
 *
 * @param object the object to check.
 */ $a4645eb3af0af756$var$util.isEmpty = function(obj) {
    for(var prop in obj){
        if (obj.hasOwnProperty(prop)) return false;
    }
    return true;
};
/**
 * Format with simple printf-style interpolation.
 *
 * %%: literal '%'
 * %s,%o: convert next argument into a string.
 *
 * @param format the string to format.
 * @param ... arguments to interpolate into the format string.
 */ $a4645eb3af0af756$var$util.format = function(format) {
    var re = /%./g;
    // current match
    var match;
    // current part
    var part;
    // current arg index
    var argi = 0;
    // collected parts to recombine later
    var parts = [];
    // last index found
    var last = 0;
    // loop while matches remain
    while(match = re.exec(format)){
        part = format.substring(last, re.lastIndex - 2);
        // don't add empty strings (ie, parts between %s%s)
        if (part.length > 0) parts.push(part);
        last = re.lastIndex;
        // switch on % code
        var code = match[0][1];
        switch(code){
            case "s":
            case "o":
                // check if enough arguments were given
                if (argi < arguments.length) parts.push(arguments[argi++ + 1]);
                else parts.push("<?>");
                break;
            // FIXME: do proper formating for numbers, etc
            //case 'f':
            //case 'd':
            case "%":
                parts.push("%");
                break;
            default:
                parts.push("<%" + code + "?>");
        }
    }
    // add trailing part of format string
    parts.push(format.substring(last));
    return parts.join("");
};
/**
 * Formats a number.
 *
 * http://snipplr.com/view/5945/javascript-numberformat--ported-from-php/
 */ $a4645eb3af0af756$var$util.formatNumber = function(number, decimals, dec_point, thousands_sep) {
    // http://kevin.vanzonneveld.net
    // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +     bugfix by: Michael White (http://crestidg.com)
    // +     bugfix by: Benjamin Lupton
    // +     bugfix by: Allan Jensen (http://www.winternet.no)
    // +    revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // *     example 1: number_format(1234.5678, 2, '.', '');
    // *     returns 1: 1234.57
    var n = number, c = isNaN(decimals = Math.abs(decimals)) ? 2 : decimals;
    var d = dec_point === undefined ? "," : dec_point;
    var t = thousands_sep === undefined ? "." : thousands_sep, s = n < 0 ? "-" : "";
    var i = parseInt(n = Math.abs(+n || 0).toFixed(c), 10) + "";
    var j = i.length > 3 ? i.length % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};
/**
 * Formats a byte size.
 *
 * http://snipplr.com/view/5949/format-humanize-file-byte-size-presentation-in-javascript/
 */ $a4645eb3af0af756$var$util.formatSize = function(size) {
    if (size >= 1073741824) size = $a4645eb3af0af756$var$util.formatNumber(size / 1073741824, 2, ".", "") + " GiB";
    else if (size >= 1048576) size = $a4645eb3af0af756$var$util.formatNumber(size / 1048576, 2, ".", "") + " MiB";
    else if (size >= 1024) size = $a4645eb3af0af756$var$util.formatNumber(size / 1024, 0) + " KiB";
    else size = $a4645eb3af0af756$var$util.formatNumber(size, 0) + " bytes";
    return size;
};
/**
 * Converts an IPv4 or IPv6 string representation into bytes (in network order).
 *
 * @param ip the IPv4 or IPv6 address to convert.
 *
 * @return the 4-byte IPv6 or 16-byte IPv6 address or null if the address can't
 *         be parsed.
 */ $a4645eb3af0af756$var$util.bytesFromIP = function(ip) {
    if (ip.indexOf(".") !== -1) return $a4645eb3af0af756$var$util.bytesFromIPv4(ip);
    if (ip.indexOf(":") !== -1) return $a4645eb3af0af756$var$util.bytesFromIPv6(ip);
    return null;
};
/**
 * Converts an IPv4 string representation into bytes (in network order).
 *
 * @param ip the IPv4 address to convert.
 *
 * @return the 4-byte address or null if the address can't be parsed.
 */ $a4645eb3af0af756$var$util.bytesFromIPv4 = function(ip) {
    ip = ip.split(".");
    if (ip.length !== 4) return null;
    var b = $a4645eb3af0af756$var$util.createBuffer();
    for(var i = 0; i < ip.length; ++i){
        var num = parseInt(ip[i], 10);
        if (isNaN(num)) return null;
        b.putByte(num);
    }
    return b.getBytes();
};
/**
 * Converts an IPv6 string representation into bytes (in network order).
 *
 * @param ip the IPv6 address to convert.
 *
 * @return the 16-byte address or null if the address can't be parsed.
 */ $a4645eb3af0af756$var$util.bytesFromIPv6 = function(ip) {
    var blanks = 0;
    ip = ip.split(":").filter(function(e) {
        if (e.length === 0) ++blanks;
        return true;
    });
    var zeros = (8 - ip.length + blanks) * 2;
    var b = $a4645eb3af0af756$var$util.createBuffer();
    for(var i = 0; i < 8; ++i){
        if (!ip[i] || ip[i].length === 0) {
            b.fillWithByte(0, zeros);
            zeros = 0;
            continue;
        }
        var bytes = $a4645eb3af0af756$var$util.hexToBytes(ip[i]);
        if (bytes.length < 2) b.putByte(0);
        b.putBytes(bytes);
    }
    return b.getBytes();
};
/**
 * Converts 4-bytes into an IPv4 string representation or 16-bytes into
 * an IPv6 string representation. The bytes must be in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv4 or IPv6 string representation if 4 or 16 bytes,
 *         respectively, are given, otherwise null.
 */ $a4645eb3af0af756$var$util.bytesToIP = function(bytes) {
    if (bytes.length === 4) return $a4645eb3af0af756$var$util.bytesToIPv4(bytes);
    if (bytes.length === 16) return $a4645eb3af0af756$var$util.bytesToIPv6(bytes);
    return null;
};
/**
 * Converts 4-bytes into an IPv4 string representation. The bytes must be
 * in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv4 string representation or null for an invalid # of bytes.
 */ $a4645eb3af0af756$var$util.bytesToIPv4 = function(bytes) {
    if (bytes.length !== 4) return null;
    var ip = [];
    for(var i = 0; i < bytes.length; ++i)ip.push(bytes.charCodeAt(i));
    return ip.join(".");
};
/**
 * Converts 16-bytes into an IPv16 string representation. The bytes must be
 * in network order.
 *
 * @param bytes the bytes to convert.
 *
 * @return the IPv16 string representation or null for an invalid # of bytes.
 */ $a4645eb3af0af756$var$util.bytesToIPv6 = function(bytes) {
    if (bytes.length !== 16) return null;
    var ip = [];
    var zeroGroups = [];
    var zeroMaxGroup = 0;
    for(var i = 0; i < bytes.length; i += 2){
        var hex = $a4645eb3af0af756$var$util.bytesToHex(bytes[i] + bytes[i + 1]);
        // canonicalize zero representation
        while(hex[0] === "0" && hex !== "0")hex = hex.substr(1);
        if (hex === "0") {
            var last = zeroGroups[zeroGroups.length - 1];
            var idx = ip.length;
            if (!last || idx !== last.end + 1) zeroGroups.push({
                start: idx,
                end: idx
            });
            else {
                last.end = idx;
                if (last.end - last.start > zeroGroups[zeroMaxGroup].end - zeroGroups[zeroMaxGroup].start) zeroMaxGroup = zeroGroups.length - 1;
            }
        }
        ip.push(hex);
    }
    if (zeroGroups.length > 0) {
        var group = zeroGroups[zeroMaxGroup];
        // only shorten group of length > 0
        if (group.end - group.start > 0) {
            ip.splice(group.start, group.end - group.start + 1, "");
            if (group.start === 0) ip.unshift("");
            if (group.end === 7) ip.push("");
        }
    }
    return ip.join(":");
};
/**
 * Estimates the number of processes that can be run concurrently. If
 * creating Web Workers, keep in mind that the main JavaScript process needs
 * its own core.
 *
 * @param options the options to use:
 *          update true to force an update (not use the cached value).
 * @param callback(err, max) called once the operation completes.
 */ $a4645eb3af0af756$var$util.estimateCores = function(options, callback) {
    if (typeof options === "function") {
        callback = options;
        options = {};
    }
    options = options || {};
    if ("cores" in $a4645eb3af0af756$var$util && !options.update) return callback(null, $a4645eb3af0af756$var$util.cores);
    if (typeof navigator !== "undefined" && "hardwareConcurrency" in navigator && navigator.hardwareConcurrency > 0) {
        $a4645eb3af0af756$var$util.cores = navigator.hardwareConcurrency;
        return callback(null, $a4645eb3af0af756$var$util.cores);
    }
    if (typeof Worker === "undefined") {
        // workers not available
        $a4645eb3af0af756$var$util.cores = 1;
        return callback(null, $a4645eb3af0af756$var$util.cores);
    }
    if (typeof Blob === "undefined") {
        // can't estimate, default to 2
        $a4645eb3af0af756$var$util.cores = 2;
        return callback(null, $a4645eb3af0af756$var$util.cores);
    }
    // create worker concurrency estimation code as blob
    var blobUrl = URL.createObjectURL(new Blob([
        "(",
        (function() {
            self.addEventListener("message", function(e) {
                // run worker for 4 ms
                var st = Date.now();
                var et = st + 4;
                while(Date.now() < et);
                self.postMessage({
                    st: st,
                    et: et
                });
            });
        }).toString(),
        ")()"
    ], {
        type: "application/javascript"
    }));
    // take 5 samples using 16 workers
    sample([], 5, 16);
    function sample(max, samples, numWorkers) {
        if (samples === 0) {
            // get overlap average
            var avg = Math.floor(max.reduce(function(avg, x) {
                return avg + x;
            }, 0) / max.length);
            $a4645eb3af0af756$var$util.cores = Math.max(1, avg);
            URL.revokeObjectURL(blobUrl);
            return callback(null, $a4645eb3af0af756$var$util.cores);
        }
        map(numWorkers, function(err, results) {
            max.push(reduce(numWorkers, results));
            sample(max, samples - 1, numWorkers);
        });
    }
    function map(numWorkers, callback) {
        var workers = [];
        var results = [];
        for(var i = 0; i < numWorkers; ++i){
            var worker = new Worker(blobUrl);
            worker.addEventListener("message", function(e) {
                results.push(e.data);
                if (results.length === numWorkers) {
                    for(var i = 0; i < numWorkers; ++i)workers[i].terminate();
                    callback(null, results);
                }
            });
            workers.push(worker);
        }
        for(var i = 0; i < numWorkers; ++i)workers[i].postMessage(i);
    }
    function reduce(numWorkers, results) {
        // find overlapping time windows
        var overlaps = [];
        for(var n = 0; n < numWorkers; ++n){
            var r1 = results[n];
            var overlap = overlaps[n] = [];
            for(var i = 0; i < numWorkers; ++i){
                if (n === i) continue;
                var r2 = results[i];
                if (r1.st > r2.st && r1.st < r2.et || r2.st > r1.st && r2.st < r1.et) overlap.push(i);
            }
        }
        // get maximum overlaps ... don't include overlapping worker itself
        // as the main JS process was also being scheduled during the work and
        // would have to be subtracted from the estimate anyway
        return overlaps.reduce(function(max, overlap) {
            return Math.max(max, overlap.length);
        }, 0);
    }
};

});
parcelRequire.register("8l6KK", function(module, exports) {
/**
 * Base-N/Base-X encoding/decoding functions.
 *
 * Original implementation from base-x:
 * https://github.com/cryptocoinjs/base-x
 *
 * Which is MIT licensed:
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
 * DEALINGS IN THE SOFTWARE.
 */ 
var $7jzxY = parcelRequire("7jzxY");
var $612585ec69121a58$require$Buffer = $7jzxY.Buffer;
var $612585ec69121a58$var$api = {};
module.exports = $612585ec69121a58$var$api;
// baseN alphabet indexes
var $612585ec69121a58$var$_reverseAlphabets = {};
/**
 * BaseN-encodes a Uint8Array using the given alphabet.
 *
 * @param input the Uint8Array to encode.
 * @param maxline the maximum number of encoded characters per line to use,
 *          defaults to none.
 *
 * @return the baseN-encoded output string.
 */ $612585ec69121a58$var$api.encode = function(input, alphabet, maxline) {
    if (typeof alphabet !== "string") throw new TypeError('"alphabet" must be a string.');
    if (maxline !== undefined && typeof maxline !== "number") throw new TypeError('"maxline" must be a number.');
    var output = "";
    if (!(input instanceof Uint8Array)) // assume forge byte buffer
    output = $612585ec69121a58$var$_encodeWithByteBuffer(input, alphabet);
    else {
        var i = 0;
        var base = alphabet.length;
        var first = alphabet.charAt(0);
        var digits = [
            0
        ];
        for(i = 0; i < input.length; ++i){
            for(var j = 0, carry = input[i]; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % base;
                carry = carry / base | 0;
            }
            while(carry > 0){
                digits.push(carry % base);
                carry = carry / base | 0;
            }
        }
        // deal with leading zeros
        for(i = 0; input[i] === 0 && i < input.length - 1; ++i)output += first;
        // convert digits to a string
        for(i = digits.length - 1; i >= 0; --i)output += alphabet[digits[i]];
    }
    if (maxline) {
        var regex = new RegExp(".{1," + maxline + "}", "g");
        output = output.match(regex).join("\r\n");
    }
    return output;
};
/**
 * Decodes a baseN-encoded (using the given alphabet) string to a
 * Uint8Array.
 *
 * @param input the baseN-encoded input string.
 *
 * @return the Uint8Array.
 */ $612585ec69121a58$var$api.decode = function(input, alphabet) {
    if (typeof input !== "string") throw new TypeError('"input" must be a string.');
    if (typeof alphabet !== "string") throw new TypeError('"alphabet" must be a string.');
    var table = $612585ec69121a58$var$_reverseAlphabets[alphabet];
    if (!table) {
        // compute reverse alphabet
        table = $612585ec69121a58$var$_reverseAlphabets[alphabet] = [];
        for(var i = 0; i < alphabet.length; ++i)table[alphabet.charCodeAt(i)] = i;
    }
    // remove whitespace characters
    input = input.replace(/\s/g, "");
    var base = alphabet.length;
    var first = alphabet.charAt(0);
    var bytes = [
        0
    ];
    for(var i = 0; i < input.length; i++){
        var value = table[input.charCodeAt(i)];
        if (value === undefined) return;
        for(var j = 0, carry = value; j < bytes.length; ++j){
            carry += bytes[j] * base;
            bytes[j] = carry & 0xff;
            carry >>= 8;
        }
        while(carry > 0){
            bytes.push(carry & 0xff);
            carry >>= 8;
        }
    }
    // deal with leading zeros
    for(var k = 0; input[k] === first && k < input.length - 1; ++k)bytes.push(0);
    if (typeof $612585ec69121a58$require$Buffer !== "undefined") return $612585ec69121a58$require$Buffer.from(bytes.reverse());
    return new Uint8Array(bytes.reverse());
};
function $612585ec69121a58$var$_encodeWithByteBuffer(input, alphabet) {
    var i = 0;
    var base = alphabet.length;
    var first = alphabet.charAt(0);
    var digits = [
        0
    ];
    for(i = 0; i < input.length(); ++i){
        for(var j = 0, carry = input.at(i); j < digits.length; ++j){
            carry += digits[j] << 8;
            digits[j] = carry % base;
            carry = carry / base | 0;
        }
        while(carry > 0){
            digits.push(carry % base);
            carry = carry / base | 0;
        }
    }
    var output = "";
    // deal with leading zeros
    for(i = 0; input.at(i) === 0 && i < input.length() - 1; ++i)output += first;
    // convert digits to a string
    for(i = digits.length - 1; i >= 0; --i)output += alphabet[digits[i]];
    return output;
}

});



parcelRequire.register("2D3xR", function(module, exports) {
/**
 * Supported cipher modes.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("e73pV");
$2xc86.cipher = $2xc86.cipher || {};
// supported cipher modes
var $1ea1f94900f99165$var$modes = module.exports = $2xc86.cipher.modes = $2xc86.cipher.modes || {};
/** Electronic codebook (ECB) (Don't use this; it's not secure) **/ $1ea1f94900f99165$var$modes.ecb = function(options) {
    options = options || {};
    this.name = "ECB";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
};
$1ea1f94900f99165$var$modes.ecb.prototype.start = function(options) {};
$1ea1f94900f99165$var$modes.ecb.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = input.getInt32();
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // write output
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i]);
};
$1ea1f94900f99165$var$modes.ecb.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = input.getInt32();
    // decrypt block
    this.cipher.decrypt(this._inBlock, this._outBlock);
    // write output
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i]);
};
$1ea1f94900f99165$var$modes.ecb.prototype.pad = function(input, options) {
    // add PKCS#7 padding to block (each pad byte is the
    // value of the number of pad bytes)
    var padding = input.length() === this.blockSize ? this.blockSize : this.blockSize - input.length();
    input.fillWithByte(padding, padding);
    return true;
};
$1ea1f94900f99165$var$modes.ecb.prototype.unpad = function(output, options) {
    // check for error: input data not a multiple of blockSize
    if (options.overflow > 0) return false;
    // ensure padding byte count is valid
    var len = output.length();
    var count = output.at(len - 1);
    if (count > this.blockSize << 2) return false;
    // trim off padding bytes
    output.truncate(count);
    return true;
};
/** Cipher-block Chaining (CBC) **/ $1ea1f94900f99165$var$modes.cbc = function(options) {
    options = options || {};
    this.name = "CBC";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
};
$1ea1f94900f99165$var$modes.cbc.prototype.start = function(options) {
    // Note: legacy support for using IV residue (has security flaws)
    // if IV is null, reuse block from previous processing
    if (options.iv === null) {
        // must have a previous block
        if (!this._prev) throw new Error("Invalid IV parameter.");
        this._iv = this._prev.slice(0);
    } else if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    else {
        // save IV as "previous" block
        this._iv = $1ea1f94900f99165$var$transformIV(options.iv, this.blockSize);
        this._prev = this._iv.slice(0);
    }
};
$1ea1f94900f99165$var$modes.cbc.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    // CBC XOR's IV (or previous block) with plaintext
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._prev[i] ^ input.getInt32();
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // write output, save previous block
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i]);
    this._prev = this._outBlock;
};
$1ea1f94900f99165$var$modes.cbc.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    if (input.length() < this.blockSize && !(finish && input.length() > 0)) return true;
    // get next block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = input.getInt32();
    // decrypt block
    this.cipher.decrypt(this._inBlock, this._outBlock);
    // write output, save previous ciphered block
    // CBC XOR's IV (or previous block) with ciphertext
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._prev[i] ^ this._outBlock[i]);
    this._prev = this._inBlock.slice(0);
};
$1ea1f94900f99165$var$modes.cbc.prototype.pad = function(input, options) {
    // add PKCS#7 padding to block (each pad byte is the
    // value of the number of pad bytes)
    var padding = input.length() === this.blockSize ? this.blockSize : this.blockSize - input.length();
    input.fillWithByte(padding, padding);
    return true;
};
$1ea1f94900f99165$var$modes.cbc.prototype.unpad = function(output, options) {
    // check for error: input data not a multiple of blockSize
    if (options.overflow > 0) return false;
    // ensure padding byte count is valid
    var len = output.length();
    var count = output.at(len - 1);
    if (count > this.blockSize << 2) return false;
    // trim off padding bytes
    output.truncate(count);
    return true;
};
/** Cipher feedback (CFB) **/ $1ea1f94900f99165$var$modes.cfb = function(options) {
    options = options || {};
    this.name = "CFB";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialBlock = new Array(this._ints);
    this._partialOutput = $2xc86.util.createBuffer();
    this._partialBytes = 0;
};
$1ea1f94900f99165$var$modes.cfb.prototype.start = function(options) {
    if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    // use IV as first input
    this._iv = $1ea1f94900f99165$var$transformIV(options.iv, this.blockSize);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
};
$1ea1f94900f99165$var$modes.cfb.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output, write input as output
        for(var i = 0; i < this._ints; ++i){
            this._inBlock[i] = input.getInt32() ^ this._outBlock[i];
            output.putInt32(this._inBlock[i]);
        }
        return;
    }
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
    // XOR input with output, write input as partial output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i){
        this._partialBlock[i] = input.getInt32() ^ this._outBlock[i];
        this._partialOutput.putInt32(this._partialBlock[i]);
    }
    if (partialBytes > 0) // block still incomplete, restore input buffer
    input.read -= this.blockSize;
    else // block complete, update input block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._partialBlock[i];
    // skip any previous partial bytes
    if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
    if (partialBytes > 0 && !finish) {
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
};
$1ea1f94900f99165$var$modes.cfb.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block (CFB always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output, write input as output
        for(var i = 0; i < this._ints; ++i){
            this._inBlock[i] = input.getInt32();
            output.putInt32(this._inBlock[i] ^ this._outBlock[i]);
        }
        return;
    }
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
    // XOR input with output, write input as partial output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i){
        this._partialBlock[i] = input.getInt32();
        this._partialOutput.putInt32(this._partialBlock[i] ^ this._outBlock[i]);
    }
    if (partialBytes > 0) // block still incomplete, restore input buffer
    input.read -= this.blockSize;
    else // block complete, update input block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._partialBlock[i];
    // skip any previous partial bytes
    if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
    if (partialBytes > 0 && !finish) {
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
};
/** Output feedback (OFB) **/ $1ea1f94900f99165$var$modes.ofb = function(options) {
    options = options || {};
    this.name = "OFB";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialOutput = $2xc86.util.createBuffer();
    this._partialBytes = 0;
};
$1ea1f94900f99165$var$modes.ofb.prototype.start = function(options) {
    if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    // use IV as first input
    this._iv = $1ea1f94900f99165$var$transformIV(options.iv, this.blockSize);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
};
$1ea1f94900f99165$var$modes.ofb.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (input.length() === 0) return true;
    // encrypt block (OFB always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output and update next input
        for(var i = 0; i < this._ints; ++i){
            output.putInt32(input.getInt32() ^ this._outBlock[i]);
            this._inBlock[i] = this._outBlock[i];
        }
        return;
    }
    // handle partial block
    var partialBytes = (this.blockSize - inputLength) % this.blockSize;
    if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
    // XOR input with output
    this._partialOutput.clear();
    for(var i = 0; i < this._ints; ++i)this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
    if (partialBytes > 0) // block still incomplete, restore input buffer
    input.read -= this.blockSize;
    else // block complete, update input block
    for(var i = 0; i < this._ints; ++i)this._inBlock[i] = this._outBlock[i];
    // skip any previous partial bytes
    if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
    if (partialBytes > 0 && !finish) {
        output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
        this._partialBytes = partialBytes;
        return true;
    }
    output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
    this._partialBytes = 0;
};
$1ea1f94900f99165$var$modes.ofb.prototype.decrypt = $1ea1f94900f99165$var$modes.ofb.prototype.encrypt;
/** Counter (CTR) **/ $1ea1f94900f99165$var$modes.ctr = function(options) {
    options = options || {};
    this.name = "CTR";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = null;
    this._outBlock = new Array(this._ints);
    this._partialOutput = $2xc86.util.createBuffer();
    this._partialBytes = 0;
};
$1ea1f94900f99165$var$modes.ctr.prototype.start = function(options) {
    if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    // use IV as first input
    this._iv = $1ea1f94900f99165$var$transformIV(options.iv, this.blockSize);
    this._inBlock = this._iv.slice(0);
    this._partialBytes = 0;
};
$1ea1f94900f99165$var$modes.ctr.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block (CTR always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) // XOR input with output
    for(var i = 0; i < this._ints; ++i)output.putInt32(input.getInt32() ^ this._outBlock[i]);
    else {
        // handle partial block
        var partialBytes = (this.blockSize - inputLength) % this.blockSize;
        if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
        // XOR input with output
        this._partialOutput.clear();
        for(var i = 0; i < this._ints; ++i)this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
        if (partialBytes > 0) // block still incomplete, restore input buffer
        input.read -= this.blockSize;
        // skip any previous partial bytes
        if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
        if (partialBytes > 0 && !finish) {
            output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
            this._partialBytes = partialBytes;
            return true;
        }
        output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
        this._partialBytes = 0;
    }
    // block complete, increment counter (input block)
    $1ea1f94900f99165$var$inc32(this._inBlock);
};
$1ea1f94900f99165$var$modes.ctr.prototype.decrypt = $1ea1f94900f99165$var$modes.ctr.prototype.encrypt;
/** Galois/Counter Mode (GCM) **/ $1ea1f94900f99165$var$modes.gcm = function(options) {
    options = options || {};
    this.name = "GCM";
    this.cipher = options.cipher;
    this.blockSize = options.blockSize || 16;
    this._ints = this.blockSize / 4;
    this._inBlock = new Array(this._ints);
    this._outBlock = new Array(this._ints);
    this._partialOutput = $2xc86.util.createBuffer();
    this._partialBytes = 0;
    // R is actually this value concatenated with 120 more zero bits, but
    // we only XOR against R so the other zeros have no effect -- we just
    // apply this value to the first integer in a block
    this._R = 0xE1000000;
};
$1ea1f94900f99165$var$modes.gcm.prototype.start = function(options) {
    if (!("iv" in options)) throw new Error("Invalid IV parameter.");
    // ensure IV is a byte buffer
    var iv = $2xc86.util.createBuffer(options.iv);
    // no ciphered data processed yet
    this._cipherLength = 0;
    // default additional data is none
    var additionalData;
    if ("additionalData" in options) additionalData = $2xc86.util.createBuffer(options.additionalData);
    else additionalData = $2xc86.util.createBuffer();
    // default tag length is 128 bits
    if ("tagLength" in options) this._tagLength = options.tagLength;
    else this._tagLength = 128;
    // if tag is given, ensure tag matches tag length
    this._tag = null;
    if (options.decrypt) {
        // save tag to check later
        this._tag = $2xc86.util.createBuffer(options.tag).getBytes();
        if (this._tag.length !== this._tagLength / 8) throw new Error("Authentication tag does not match tag length.");
    }
    // create tmp storage for hash calculation
    this._hashBlock = new Array(this._ints);
    // no tag generated yet
    this.tag = null;
    // generate hash subkey
    // (apply block cipher to "zero" block)
    this._hashSubkey = new Array(this._ints);
    this.cipher.encrypt([
        0,
        0,
        0,
        0
    ], this._hashSubkey);
    // generate table M
    // use 4-bit tables (32 component decomposition of a 16 byte value)
    // 8-bit tables take more space and are known to have security
    // vulnerabilities (in native implementations)
    this.componentBits = 4;
    this._m = this.generateHashTable(this._hashSubkey, this.componentBits);
    // Note: support IV length different from 96 bits? (only supporting
    // 96 bits is recommended by NIST SP-800-38D)
    // generate J_0
    var ivLength = iv.length();
    if (ivLength === 12) // 96-bit IV
    this._j0 = [
        iv.getInt32(),
        iv.getInt32(),
        iv.getInt32(),
        1
    ];
    else {
        // IV is NOT 96-bits
        this._j0 = [
            0,
            0,
            0,
            0
        ];
        while(iv.length() > 0)this._j0 = this.ghash(this._hashSubkey, this._j0, [
            iv.getInt32(),
            iv.getInt32(),
            iv.getInt32(),
            iv.getInt32()
        ]);
        this._j0 = this.ghash(this._hashSubkey, this._j0, [
            0,
            0
        ].concat($1ea1f94900f99165$var$from64To32(ivLength * 8)));
    }
    // generate ICB (initial counter block)
    this._inBlock = this._j0.slice(0);
    $1ea1f94900f99165$var$inc32(this._inBlock);
    this._partialBytes = 0;
    // consume authentication data
    additionalData = $2xc86.util.createBuffer(additionalData);
    // save additional data length as a BE 64-bit number
    this._aDataLength = $1ea1f94900f99165$var$from64To32(additionalData.length() * 8);
    // pad additional data to 128 bit (16 byte) block size
    var overflow = additionalData.length() % this.blockSize;
    if (overflow) additionalData.fillWithByte(0, this.blockSize - overflow);
    this._s = [
        0,
        0,
        0,
        0
    ];
    while(additionalData.length() > 0)this._s = this.ghash(this._hashSubkey, this._s, [
        additionalData.getInt32(),
        additionalData.getInt32(),
        additionalData.getInt32(),
        additionalData.getInt32()
    ]);
};
$1ea1f94900f99165$var$modes.gcm.prototype.encrypt = function(input, output, finish) {
    // not enough input to encrypt
    var inputLength = input.length();
    if (inputLength === 0) return true;
    // encrypt block
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // handle full block
    if (this._partialBytes === 0 && inputLength >= this.blockSize) {
        // XOR input with output
        for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i] ^= input.getInt32());
        this._cipherLength += this.blockSize;
    } else {
        // handle partial block
        var partialBytes = (this.blockSize - inputLength) % this.blockSize;
        if (partialBytes > 0) partialBytes = this.blockSize - partialBytes;
        // XOR input with output
        this._partialOutput.clear();
        for(var i = 0; i < this._ints; ++i)this._partialOutput.putInt32(input.getInt32() ^ this._outBlock[i]);
        if (partialBytes <= 0 || finish) {
            // handle overflow prior to hashing
            if (finish) {
                // get block overflow
                var overflow = inputLength % this.blockSize;
                this._cipherLength += overflow;
                // truncate for hash function
                this._partialOutput.truncate(this.blockSize - overflow);
            } else this._cipherLength += this.blockSize;
            // get output block for hashing
            for(var i = 0; i < this._ints; ++i)this._outBlock[i] = this._partialOutput.getInt32();
            this._partialOutput.read -= this.blockSize;
        }
        // skip any previous partial bytes
        if (this._partialBytes > 0) this._partialOutput.getBytes(this._partialBytes);
        if (partialBytes > 0 && !finish) {
            // block still incomplete, restore input buffer, get partial output,
            // and return early
            input.read -= this.blockSize;
            output.putBytes(this._partialOutput.getBytes(partialBytes - this._partialBytes));
            this._partialBytes = partialBytes;
            return true;
        }
        output.putBytes(this._partialOutput.getBytes(inputLength - this._partialBytes));
        this._partialBytes = 0;
    }
    // update hash block S
    this._s = this.ghash(this._hashSubkey, this._s, this._outBlock);
    // increment counter (input block)
    $1ea1f94900f99165$var$inc32(this._inBlock);
};
$1ea1f94900f99165$var$modes.gcm.prototype.decrypt = function(input, output, finish) {
    // not enough input to decrypt
    var inputLength = input.length();
    if (inputLength < this.blockSize && !(finish && inputLength > 0)) return true;
    // encrypt block (GCM always uses encryption mode)
    this.cipher.encrypt(this._inBlock, this._outBlock);
    // increment counter (input block)
    $1ea1f94900f99165$var$inc32(this._inBlock);
    // update hash block S
    this._hashBlock[0] = input.getInt32();
    this._hashBlock[1] = input.getInt32();
    this._hashBlock[2] = input.getInt32();
    this._hashBlock[3] = input.getInt32();
    this._s = this.ghash(this._hashSubkey, this._s, this._hashBlock);
    // XOR hash input with output
    for(var i = 0; i < this._ints; ++i)output.putInt32(this._outBlock[i] ^ this._hashBlock[i]);
    // increment cipher data length
    if (inputLength < this.blockSize) this._cipherLength += inputLength % this.blockSize;
    else this._cipherLength += this.blockSize;
};
$1ea1f94900f99165$var$modes.gcm.prototype.afterFinish = function(output, options) {
    var rval = true;
    // handle overflow
    if (options.decrypt && options.overflow) output.truncate(this.blockSize - options.overflow);
    // handle authentication tag
    this.tag = $2xc86.util.createBuffer();
    // concatenate additional data length with cipher length
    var lengths = this._aDataLength.concat($1ea1f94900f99165$var$from64To32(this._cipherLength * 8));
    // include lengths in hash
    this._s = this.ghash(this._hashSubkey, this._s, lengths);
    // do GCTR(J_0, S)
    var tag = [];
    this.cipher.encrypt(this._j0, tag);
    for(var i = 0; i < this._ints; ++i)this.tag.putInt32(this._s[i] ^ tag[i]);
    // trim tag to length
    this.tag.truncate(this.tag.length() % (this._tagLength / 8));
    // check authentication tag
    if (options.decrypt && this.tag.bytes() !== this._tag) rval = false;
    return rval;
};
/**
 * See NIST SP-800-38D 6.3 (Algorithm 1). This function performs Galois
 * field multiplication. The field, GF(2^128), is defined by the polynomial:
 *
 * x^128 + x^7 + x^2 + x + 1
 *
 * Which is represented in little-endian binary form as: 11100001 (0xe1). When
 * the value of a coefficient is 1, a bit is set. The value R, is the
 * concatenation of this value and 120 zero bits, yielding a 128-bit value
 * which matches the block size.
 *
 * This function will multiply two elements (vectors of bytes), X and Y, in
 * the field GF(2^128). The result is initialized to zero. For each bit of
 * X (out of 128), x_i, if x_i is set, then the result is multiplied (XOR'd)
 * by the current value of Y. For each bit, the value of Y will be raised by
 * a power of x (multiplied by the polynomial x). This can be achieved by
 * shifting Y once to the right. If the current value of Y, prior to being
 * multiplied by x, has 0 as its LSB, then it is a 127th degree polynomial.
 * Otherwise, we must divide by R after shifting to find the remainder.
 *
 * @param x the first block to multiply by the second.
 * @param y the second block to multiply by the first.
 *
 * @return the block result of the multiplication.
 */ $1ea1f94900f99165$var$modes.gcm.prototype.multiply = function(x, y) {
    var z_i = [
        0,
        0,
        0,
        0
    ];
    var v_i = y.slice(0);
    // calculate Z_128 (block has 128 bits)
    for(var i = 0; i < 128; ++i){
        // if x_i is 0, Z_{i+1} = Z_i (unchanged)
        // else Z_{i+1} = Z_i ^ V_i
        // get x_i by finding 32-bit int position, then left shift 1 by remainder
        var x_i = x[i / 32 | 0] & 1 << 31 - i % 32;
        if (x_i) {
            z_i[0] ^= v_i[0];
            z_i[1] ^= v_i[1];
            z_i[2] ^= v_i[2];
            z_i[3] ^= v_i[3];
        }
        // if LSB(V_i) is 1, V_i = V_i >> 1
        // else V_i = (V_i >> 1) ^ R
        this.pow(v_i, v_i);
    }
    return z_i;
};
$1ea1f94900f99165$var$modes.gcm.prototype.pow = function(x, out) {
    // if LSB(x) is 1, x = x >>> 1
    // else x = (x >>> 1) ^ R
    var lsb = x[3] & 1;
    // always do x >>> 1:
    // starting with the rightmost integer, shift each integer to the right
    // one bit, pulling in the bit from the integer to the left as its top
    // most bit (do this for the last 3 integers)
    for(var i = 3; i > 0; --i)out[i] = x[i] >>> 1 | (x[i - 1] & 1) << 31;
    // shift the first integer normally
    out[0] = x[0] >>> 1;
    // if lsb was not set, then polynomial had a degree of 127 and doesn't
    // need to divided; otherwise, XOR with R to find the remainder; we only
    // need to XOR the first integer since R technically ends w/120 zero bits
    if (lsb) out[0] ^= this._R;
};
$1ea1f94900f99165$var$modes.gcm.prototype.tableMultiply = function(x) {
    // assumes 4-bit tables are used
    var z = [
        0,
        0,
        0,
        0
    ];
    for(var i = 0; i < 32; ++i){
        var idx = i / 8 | 0;
        var x_i = x[idx] >>> (7 - i % 8) * 4 & 0xF;
        var ah = this._m[i][x_i];
        z[0] ^= ah[0];
        z[1] ^= ah[1];
        z[2] ^= ah[2];
        z[3] ^= ah[3];
    }
    return z;
};
/**
 * A continuing version of the GHASH algorithm that operates on a single
 * block. The hash block, last hash value (Ym) and the new block to hash
 * are given.
 *
 * @param h the hash block.
 * @param y the previous value for Ym, use [0, 0, 0, 0] for a new hash.
 * @param x the block to hash.
 *
 * @return the hashed value (Ym).
 */ $1ea1f94900f99165$var$modes.gcm.prototype.ghash = function(h, y, x) {
    y[0] ^= x[0];
    y[1] ^= x[1];
    y[2] ^= x[2];
    y[3] ^= x[3];
    return this.tableMultiply(y);
//return this.multiply(y, h);
};
/**
 * Precomputes a table for multiplying against the hash subkey. This
 * mechanism provides a substantial speed increase over multiplication
 * performed without a table. The table-based multiplication this table is
 * for solves X * H by multiplying each component of X by H and then
 * composing the results together using XOR.
 *
 * This function can be used to generate tables with different bit sizes
 * for the components, however, this implementation assumes there are
 * 32 components of X (which is a 16 byte vector), therefore each component
 * takes 4-bits (so the table is constructed with bits=4).
 *
 * @param h the hash subkey.
 * @param bits the bit size for a component.
 */ $1ea1f94900f99165$var$modes.gcm.prototype.generateHashTable = function(h, bits) {
    // TODO: There are further optimizations that would use only the
    // first table M_0 (or some variant) along with a remainder table;
    // this can be explored in the future
    var multiplier = 8 / bits;
    var perInt = 4 * multiplier;
    var size = 16 * multiplier;
    var m = new Array(size);
    for(var i = 0; i < size; ++i){
        var tmp = [
            0,
            0,
            0,
            0
        ];
        var idx = i / perInt | 0;
        var shft = (perInt - 1 - i % perInt) * bits;
        tmp[idx] = 1 << bits - 1 << shft;
        m[i] = this.generateSubHashTable(this.multiply(tmp, h), bits);
    }
    return m;
};
/**
 * Generates a table for multiplying against the hash subkey for one
 * particular component (out of all possible component values).
 *
 * @param mid the pre-multiplied value for the middle key of the table.
 * @param bits the bit size for a component.
 */ $1ea1f94900f99165$var$modes.gcm.prototype.generateSubHashTable = function(mid, bits) {
    // compute the table quickly by minimizing the number of
    // POW operations -- they only need to be performed for powers of 2,
    // all other entries can be composed from those powers using XOR
    var size = 1 << bits;
    var half = size >>> 1;
    var m = new Array(size);
    m[half] = mid.slice(0);
    var i = half >>> 1;
    while(i > 0){
        // raise m0[2 * i] and store in m0[i]
        this.pow(m[2 * i], m[i] = []);
        i >>= 1;
    }
    i = 2;
    while(i < half){
        for(var j = 1; j < i; ++j){
            var m_i = m[i];
            var m_j = m[j];
            m[i + j] = [
                m_i[0] ^ m_j[0],
                m_i[1] ^ m_j[1],
                m_i[2] ^ m_j[2],
                m_i[3] ^ m_j[3]
            ];
        }
        i *= 2;
    }
    m[0] = [
        0,
        0,
        0,
        0
    ];
    /* Note: We could avoid storing these by doing composition during multiply
  calculate top half using composition by speed is preferred. */ for(i = half + 1; i < size; ++i){
        var c = m[i ^ half];
        m[i] = [
            mid[0] ^ c[0],
            mid[1] ^ c[1],
            mid[2] ^ c[2],
            mid[3] ^ c[3]
        ];
    }
    return m;
};
/** Utility functions */ function $1ea1f94900f99165$var$transformIV(iv, blockSize) {
    if (typeof iv === "string") // convert iv string into byte buffer
    iv = $2xc86.util.createBuffer(iv);
    if ($2xc86.util.isArray(iv) && iv.length > 4) {
        // convert iv byte array into byte buffer
        var tmp = iv;
        iv = $2xc86.util.createBuffer();
        for(var i = 0; i < tmp.length; ++i)iv.putByte(tmp[i]);
    }
    if (iv.length() < blockSize) throw new Error("Invalid IV length; got " + iv.length() + " bytes and expected " + blockSize + " bytes.");
    if (!$2xc86.util.isArray(iv)) {
        // convert iv byte buffer into 32-bit integer array
        var ints = [];
        var blocks = blockSize / 4;
        for(var i = 0; i < blocks; ++i)ints.push(iv.getInt32());
        iv = ints;
    }
    return iv;
}
function $1ea1f94900f99165$var$inc32(block) {
    // increment last 32 bits of block only
    block[block.length - 1] = block[block.length - 1] + 1 & 0xFFFFFFFF;
}
function $1ea1f94900f99165$var$from64To32(num) {
    // convert 64-bit number to two BE Int32s
    return [
        num / 0x100000000 | 0,
        num & 0xFFFFFFFF
    ];
}

});


parcelRequire.register("l46Tq", function(module, exports) {
/**
 * Javascript implementation of Abstract Syntax Notation Number One.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2015 Digital Bazaar, Inc.
 *
 * An API for storing data using the Abstract Syntax Notation Number One
 * format using DER (Distinguished Encoding Rules) encoding. This encoding is
 * commonly used to store data for PKI, i.e. X.509 Certificates, and this
 * implementation exists for that purpose.
 *
 * Abstract Syntax Notation Number One (ASN.1) is used to define the abstract
 * syntax of information without restricting the way the information is encoded
 * for transmission. It provides a standard that allows for open systems
 * communication. ASN.1 defines the syntax of information data and a number of
 * simple data types as well as a notation for describing them and specifying
 * values for them.
 *
 * The RSA algorithm creates public and private keys that are often stored in
 * X.509 or PKCS#X formats -- which use ASN.1 (encoded in DER format). This
 * class provides the most basic functionality required to store and load DSA
 * keys that are encoded according to ASN.1.
 *
 * The most common binary encodings for ASN.1 are BER (Basic Encoding Rules)
 * and DER (Distinguished Encoding Rules). DER is just a subset of BER that
 * has stricter requirements for how data must be encoded.
 *
 * Each ASN.1 structure has a tag (a byte identifying the ASN.1 structure type)
 * and a byte array for the value of this ASN1 structure which may be data or a
 * list of ASN.1 structures.
 *
 * Each ASN.1 structure using BER is (Tag-Length-Value):
 *
 * | byte 0 | bytes X | bytes Y |
 * |--------|---------|----------
 * |  tag   | length  |  value  |
 *
 * ASN.1 allows for tags to be of "High-tag-number form" which allows a tag to
 * be two or more octets, but that is not supported by this class. A tag is
 * only 1 byte. Bits 1-5 give the tag number (ie the data type within a
 * particular 'class'), 6 indicates whether or not the ASN.1 value is
 * constructed from other ASN.1 values, and bits 7 and 8 give the 'class'. If
 * bits 7 and 8 are both zero, the class is UNIVERSAL. If only bit 7 is set,
 * then the class is APPLICATION. If only bit 8 is set, then the class is
 * CONTEXT_SPECIFIC. If both bits 7 and 8 are set, then the class is PRIVATE.
 * The tag numbers for the data types for the class UNIVERSAL are listed below:
 *
 * UNIVERSAL 0 Reserved for use by the encoding rules
 * UNIVERSAL 1 Boolean type
 * UNIVERSAL 2 Integer type
 * UNIVERSAL 3 Bitstring type
 * UNIVERSAL 4 Octetstring type
 * UNIVERSAL 5 Null type
 * UNIVERSAL 6 Object identifier type
 * UNIVERSAL 7 Object descriptor type
 * UNIVERSAL 8 External type and Instance-of type
 * UNIVERSAL 9 Real type
 * UNIVERSAL 10 Enumerated type
 * UNIVERSAL 11 Embedded-pdv type
 * UNIVERSAL 12 UTF8String type
 * UNIVERSAL 13 Relative object identifier type
 * UNIVERSAL 14-15 Reserved for future editions
 * UNIVERSAL 16 Sequence and Sequence-of types
 * UNIVERSAL 17 Set and Set-of types
 * UNIVERSAL 18-22, 25-30 Character string types
 * UNIVERSAL 23-24 Time types
 *
 * The length of an ASN.1 structure is specified after the tag identifier.
 * There is a definite form and an indefinite form. The indefinite form may
 * be used if the encoding is constructed and not all immediately available.
 * The indefinite form is encoded using a length byte with only the 8th bit
 * set. The end of the constructed object is marked using end-of-contents
 * octets (two zero bytes).
 *
 * The definite form looks like this:
 *
 * The length may take up 1 or more bytes, it depends on the length of the
 * value of the ASN.1 structure. DER encoding requires that if the ASN.1
 * structure has a value that has a length greater than 127, more than 1 byte
 * will be used to store its length, otherwise just one byte will be used.
 * This is strict.
 *
 * In the case that the length of the ASN.1 value is less than 127, 1 octet
 * (byte) is used to store the "short form" length. The 8th bit has a value of
 * 0 indicating the length is "short form" and not "long form" and bits 7-1
 * give the length of the data. (The 8th bit is the left-most, most significant
 * bit: also known as big endian or network format).
 *
 * In the case that the length of the ASN.1 value is greater than 127, 2 to
 * 127 octets (bytes) are used to store the "long form" length. The first
 * byte's 8th bit is set to 1 to indicate the length is "long form." Bits 7-1
 * give the number of additional octets. All following octets are in base 256
 * with the most significant digit first (typical big-endian binary unsigned
 * integer storage). So, for instance, if the length of a value was 257, the
 * first byte would be set to:
 *
 * 10000010 = 130 = 0x82.
 *
 * This indicates there are 2 octets (base 256) for the length. The second and
 * third bytes (the octets just mentioned) would store the length in base 256:
 *
 * octet 2: 00000001 = 1 * 256^1 = 256
 * octet 3: 00000001 = 1 * 256^0 = 1
 * total = 257
 *
 * The algorithm for converting a js integer value of 257 to base-256 is:
 *
 * var value = 257;
 * var bytes = [];
 * bytes[0] = (value >>> 8) & 0xFF; // most significant byte first
 * bytes[1] = value & 0xFF;        // least significant byte last
 *
 * On the ASN.1 UNIVERSAL Object Identifier (OID) type:
 *
 * An OID can be written like: "value1.value2.value3...valueN"
 *
 * The DER encoding rules:
 *
 * The first byte has the value 40 * value1 + value2.
 * The following bytes, if any, encode the remaining values. Each value is
 * encoded in base 128, most significant digit first (big endian), with as
 * few digits as possible, and the most significant bit of each byte set
 * to 1 except the last in each value's encoding. For example: Given the
 * OID "1.2.840.113549", its DER encoding is (remember each byte except the
 * last one in each encoding is OR'd with 0x80):
 *
 * byte 1: 40 * 1 + 2 = 42 = 0x2A.
 * bytes 2-3: 128 * 6 + 72 = 840 = 6 72 = 6 72 = 0x0648 = 0x8648
 * bytes 4-6: 16384 * 6 + 128 * 119 + 13 = 6 119 13 = 0x06770D = 0x86F70D
 *
 * The final value is: 0x2A864886F70D.
 * The full OID (including ASN.1 tag and length of 6 bytes) is:
 * 0x06062A864886F70D
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("e73pV");
parcelRequire("hzEKF");
/* ASN.1 API */ var $f55f5179da2fdd93$var$asn1 = module.exports = $2xc86.asn1 = $2xc86.asn1 || {};
/**
 * ASN.1 classes.
 */ $f55f5179da2fdd93$var$asn1.Class = {
    UNIVERSAL: 0x00,
    APPLICATION: 0x40,
    CONTEXT_SPECIFIC: 0x80,
    PRIVATE: 0xC0
};
/**
 * ASN.1 types. Not all types are supported by this implementation, only
 * those necessary to implement a simple PKI are implemented.
 */ $f55f5179da2fdd93$var$asn1.Type = {
    NONE: 0,
    BOOLEAN: 1,
    INTEGER: 2,
    BITSTRING: 3,
    OCTETSTRING: 4,
    NULL: 5,
    OID: 6,
    ODESC: 7,
    EXTERNAL: 8,
    REAL: 9,
    ENUMERATED: 10,
    EMBEDDED: 11,
    UTF8: 12,
    ROID: 13,
    SEQUENCE: 16,
    SET: 17,
    PRINTABLESTRING: 19,
    IA5STRING: 22,
    UTCTIME: 23,
    GENERALIZEDTIME: 24,
    BMPSTRING: 30
};
/**
 * Creates a new asn1 object.
 *
 * @param tagClass the tag class for the object.
 * @param type the data type (tag number) for the object.
 * @param constructed true if the asn1 object is in constructed form.
 * @param value the value for the object, if it is not constructed.
 * @param [options] the options to use:
 *          [bitStringContents] the plain BIT STRING content including padding
 *            byte.
 *
 * @return the asn1 object.
 */ $f55f5179da2fdd93$var$asn1.create = function(tagClass, type, constructed, value, options) {
    /* An asn1 object has a tagClass, a type, a constructed flag, and a
    value. The value's type depends on the constructed flag. If
    constructed, it will contain a list of other asn1 objects. If not,
    it will contain the ASN.1 value as an array of bytes formatted
    according to the ASN.1 data type. */ // remove undefined values
    if ($2xc86.util.isArray(value)) {
        var tmp = [];
        for(var i = 0; i < value.length; ++i)if (value[i] !== undefined) tmp.push(value[i]);
        value = tmp;
    }
    var obj = {
        tagClass: tagClass,
        type: type,
        constructed: constructed,
        composed: constructed || $2xc86.util.isArray(value),
        value: value
    };
    if (options && "bitStringContents" in options) {
        // TODO: copy byte buffer if it's a buffer not a string
        obj.bitStringContents = options.bitStringContents;
        // TODO: add readonly flag to avoid this overhead
        // save copy to detect changes
        obj.original = $f55f5179da2fdd93$var$asn1.copy(obj);
    }
    return obj;
};
/**
 * Copies an asn1 object.
 *
 * @param obj the asn1 object.
 * @param [options] copy options:
 *          [excludeBitStringContents] true to not copy bitStringContents
 *
 * @return the a copy of the asn1 object.
 */ $f55f5179da2fdd93$var$asn1.copy = function(obj, options) {
    var copy;
    if ($2xc86.util.isArray(obj)) {
        copy = [];
        for(var i = 0; i < obj.length; ++i)copy.push($f55f5179da2fdd93$var$asn1.copy(obj[i], options));
        return copy;
    }
    if (typeof obj === "string") // TODO: copy byte buffer if it's a buffer not a string
    return obj;
    copy = {
        tagClass: obj.tagClass,
        type: obj.type,
        constructed: obj.constructed,
        composed: obj.composed,
        value: $f55f5179da2fdd93$var$asn1.copy(obj.value, options)
    };
    if (options && !options.excludeBitStringContents) // TODO: copy byte buffer if it's a buffer not a string
    copy.bitStringContents = obj.bitStringContents;
    return copy;
};
/**
 * Compares asn1 objects for equality.
 *
 * Note this function does not run in constant time.
 *
 * @param obj1 the first asn1 object.
 * @param obj2 the second asn1 object.
 * @param [options] compare options:
 *          [includeBitStringContents] true to compare bitStringContents
 *
 * @return true if the asn1 objects are equal.
 */ $f55f5179da2fdd93$var$asn1.equals = function(obj1, obj2, options) {
    if ($2xc86.util.isArray(obj1)) {
        if (!$2xc86.util.isArray(obj2)) return false;
        if (obj1.length !== obj2.length) return false;
        for(var i = 0; i < obj1.length; ++i){
            if (!$f55f5179da2fdd93$var$asn1.equals(obj1[i], obj2[i])) return false;
        }
        return true;
    }
    if (typeof obj1 !== typeof obj2) return false;
    if (typeof obj1 === "string") return obj1 === obj2;
    var equal = obj1.tagClass === obj2.tagClass && obj1.type === obj2.type && obj1.constructed === obj2.constructed && obj1.composed === obj2.composed && $f55f5179da2fdd93$var$asn1.equals(obj1.value, obj2.value);
    if (options && options.includeBitStringContents) equal = equal && obj1.bitStringContents === obj2.bitStringContents;
    return equal;
};
/**
 * Gets the length of a BER-encoded ASN.1 value.
 *
 * In case the length is not specified, undefined is returned.
 *
 * @param b the BER-encoded ASN.1 byte buffer, starting with the first
 *          length byte.
 *
 * @return the length of the BER-encoded ASN.1 value or undefined.
 */ $f55f5179da2fdd93$var$asn1.getBerValueLength = function(b) {
    // TODO: move this function and related DER/BER functions to a der.js
    // file; better abstract ASN.1 away from der/ber.
    var b2 = b.getByte();
    if (b2 === 0x80) return undefined;
    // see if the length is "short form" or "long form" (bit 8 set)
    var length;
    var longForm = b2 & 0x80;
    if (!longForm) // length is just the first byte
    length = b2;
    else // the number of bytes the length is specified in bits 7 through 1
    // and each length byte is in big-endian base-256
    length = b.getInt((b2 & 0x7F) << 3);
    return length;
};
/**
 * Check if the byte buffer has enough bytes. Throws an Error if not.
 *
 * @param bytes the byte buffer to parse from.
 * @param remaining the bytes remaining in the current parsing state.
 * @param n the number of bytes the buffer must have.
 */ function $f55f5179da2fdd93$var$_checkBufferLength(bytes, remaining, n) {
    if (n > remaining) {
        var error = new Error("Too few bytes to parse DER.");
        error.available = bytes.length();
        error.remaining = remaining;
        error.requested = n;
        throw error;
    }
}
/**
 * Gets the length of a BER-encoded ASN.1 value.
 *
 * In case the length is not specified, undefined is returned.
 *
 * @param bytes the byte buffer to parse from.
 * @param remaining the bytes remaining in the current parsing state.
 *
 * @return the length of the BER-encoded ASN.1 value or undefined.
 */ var $f55f5179da2fdd93$var$_getValueLength = function(bytes, remaining) {
    // TODO: move this function and related DER/BER functions to a der.js
    // file; better abstract ASN.1 away from der/ber.
    // fromDer already checked that this byte exists
    var b2 = bytes.getByte();
    remaining--;
    if (b2 === 0x80) return undefined;
    // see if the length is "short form" or "long form" (bit 8 set)
    var length;
    var longForm = b2 & 0x80;
    if (!longForm) // length is just the first byte
    length = b2;
    else {
        // the number of bytes the length is specified in bits 7 through 1
        // and each length byte is in big-endian base-256
        var longFormBytes = b2 & 0x7F;
        $f55f5179da2fdd93$var$_checkBufferLength(bytes, remaining, longFormBytes);
        length = bytes.getInt(longFormBytes << 3);
    }
    // FIXME: this will only happen for 32 bit getInt with high bit set
    if (length < 0) throw new Error("Negative length: " + length);
    return length;
};
/**
 * Parses an asn1 object from a byte buffer in DER format.
 *
 * @param bytes the byte buffer to parse from.
 * @param [strict] true to be strict when checking value lengths, false to
 *          allow truncated values (default: true).
 * @param [options] object with options or boolean strict flag
 *          [strict] true to be strict when checking value lengths, false to
 *            allow truncated values (default: true).
 *          [decodeBitStrings] true to attempt to decode the content of
 *            BIT STRINGs (not OCTET STRINGs) using strict mode. Note that
 *            without schema support to understand the data context this can
 *            erroneously decode values that happen to be valid ASN.1. This
 *            flag will be deprecated or removed as soon as schema support is
 *            available. (default: true)
 *
 * @return the parsed asn1 object.
 */ $f55f5179da2fdd93$var$asn1.fromDer = function(bytes, options) {
    if (options === undefined) options = {
        strict: true,
        decodeBitStrings: true
    };
    if (typeof options === "boolean") options = {
        strict: options,
        decodeBitStrings: true
    };
    if (!("strict" in options)) options.strict = true;
    if (!("decodeBitStrings" in options)) options.decodeBitStrings = true;
    // wrap in buffer if needed
    if (typeof bytes === "string") bytes = $2xc86.util.createBuffer(bytes);
    return $f55f5179da2fdd93$var$_fromDer(bytes, bytes.length(), 0, options);
};
/**
 * Internal function to parse an asn1 object from a byte buffer in DER format.
 *
 * @param bytes the byte buffer to parse from.
 * @param remaining the number of bytes remaining for this chunk.
 * @param depth the current parsing depth.
 * @param options object with same options as fromDer().
 *
 * @return the parsed asn1 object.
 */ function $f55f5179da2fdd93$var$_fromDer(bytes, remaining, depth, options) {
    // temporary storage for consumption calculations
    var start;
    // minimum length for ASN.1 DER structure is 2
    $f55f5179da2fdd93$var$_checkBufferLength(bytes, remaining, 2);
    // get the first byte
    var b1 = bytes.getByte();
    // consumed one byte
    remaining--;
    // get the tag class
    var tagClass = b1 & 0xC0;
    // get the type (bits 1-5)
    var type = b1 & 0x1F;
    // get the variable value length and adjust remaining bytes
    start = bytes.length();
    var length = $f55f5179da2fdd93$var$_getValueLength(bytes, remaining);
    remaining -= start - bytes.length();
    // ensure there are enough bytes to get the value
    if (length !== undefined && length > remaining) {
        if (options.strict) {
            var error = new Error("Too few bytes to read ASN.1 value.");
            error.available = bytes.length();
            error.remaining = remaining;
            error.requested = length;
            throw error;
        }
        // Note: be lenient with truncated values and use remaining state bytes
        length = remaining;
    }
    // value storage
    var value;
    // possible BIT STRING contents storage
    var bitStringContents;
    // constructed flag is bit 6 (32 = 0x20) of the first byte
    var constructed = (b1 & 0x20) === 0x20;
    if (constructed) {
        // parse child asn1 objects from the value
        value = [];
        if (length === undefined) // asn1 object of indefinite length, read until end tag
        for(;;){
            $f55f5179da2fdd93$var$_checkBufferLength(bytes, remaining, 2);
            if (bytes.bytes(2) === String.fromCharCode(0, 0)) {
                bytes.getBytes(2);
                remaining -= 2;
                break;
            }
            start = bytes.length();
            value.push($f55f5179da2fdd93$var$_fromDer(bytes, remaining, depth + 1, options));
            remaining -= start - bytes.length();
        }
        else // parsing asn1 object of definite length
        while(length > 0){
            start = bytes.length();
            value.push($f55f5179da2fdd93$var$_fromDer(bytes, length, depth + 1, options));
            remaining -= start - bytes.length();
            length -= start - bytes.length();
        }
    }
    // if a BIT STRING, save the contents including padding
    if (value === undefined && tagClass === $f55f5179da2fdd93$var$asn1.Class.UNIVERSAL && type === $f55f5179da2fdd93$var$asn1.Type.BITSTRING) bitStringContents = bytes.bytes(length);
    // determine if a non-constructed value should be decoded as a composed
    // value that contains other ASN.1 objects. BIT STRINGs (and OCTET STRINGs)
    // can be used this way.
    if (value === undefined && options.decodeBitStrings && tagClass === $f55f5179da2fdd93$var$asn1.Class.UNIVERSAL && // FIXME: OCTET STRINGs not yet supported here
    // .. other parts of forge expect to decode OCTET STRINGs manually
    type === $f55f5179da2fdd93$var$asn1.Type.BITSTRING /*|| type === asn1.Type.OCTETSTRING*/  && length > 1) {
        // save read position
        var savedRead = bytes.read;
        var savedRemaining = remaining;
        var unused = 0;
        if (type === $f55f5179da2fdd93$var$asn1.Type.BITSTRING) {
            /* The first octet gives the number of bits by which the length of the
        bit string is less than the next multiple of eight (this is called
        the "number of unused bits").

        The second and following octets give the value of the bit string
        converted to an octet string. */ $f55f5179da2fdd93$var$_checkBufferLength(bytes, remaining, 1);
            unused = bytes.getByte();
            remaining--;
        }
        // if all bits are used, maybe the BIT/OCTET STRING holds ASN.1 objs
        if (unused === 0) try {
            // attempt to parse child asn1 object from the value
            // (stored in array to signal composed value)
            start = bytes.length();
            var subOptions = {
                // enforce strict mode to avoid parsing ASN.1 from plain data
                verbose: options.verbose,
                strict: true,
                decodeBitStrings: true
            };
            var composed = $f55f5179da2fdd93$var$_fromDer(bytes, remaining, depth + 1, subOptions);
            var used = start - bytes.length();
            remaining -= used;
            if (type == $f55f5179da2fdd93$var$asn1.Type.BITSTRING) used++;
            // if the data all decoded and the class indicates UNIVERSAL or
            // CONTEXT_SPECIFIC then assume we've got an encapsulated ASN.1 object
            var tc = composed.tagClass;
            if (used === length && (tc === $f55f5179da2fdd93$var$asn1.Class.UNIVERSAL || tc === $f55f5179da2fdd93$var$asn1.Class.CONTEXT_SPECIFIC)) value = [
                composed
            ];
        } catch (ex) {}
        if (value === undefined) {
            // restore read position
            bytes.read = savedRead;
            remaining = savedRemaining;
        }
    }
    if (value === undefined) {
        // asn1 not constructed or composed, get raw value
        // TODO: do DER to OID conversion and vice-versa in .toDer?
        if (length === undefined) {
            if (options.strict) throw new Error("Non-constructed ASN.1 object of indefinite length.");
            // be lenient and use remaining state bytes
            length = remaining;
        }
        if (type === $f55f5179da2fdd93$var$asn1.Type.BMPSTRING) {
            value = "";
            for(; length > 0; length -= 2){
                $f55f5179da2fdd93$var$_checkBufferLength(bytes, remaining, 2);
                value += String.fromCharCode(bytes.getInt16());
                remaining -= 2;
            }
        } else value = bytes.getBytes(length);
    }
    // add BIT STRING contents if available
    var asn1Options = bitStringContents === undefined ? null : {
        bitStringContents: bitStringContents
    };
    // create and return asn1 object
    return $f55f5179da2fdd93$var$asn1.create(tagClass, type, constructed, value, asn1Options);
}
/**
 * Converts the given asn1 object to a buffer of bytes in DER format.
 *
 * @param asn1 the asn1 object to convert to bytes.
 *
 * @return the buffer of bytes.
 */ $f55f5179da2fdd93$var$asn1.toDer = function(obj) {
    var bytes = $2xc86.util.createBuffer();
    // build the first byte
    var b1 = obj.tagClass | obj.type;
    // for storing the ASN.1 value
    var value = $2xc86.util.createBuffer();
    // use BIT STRING contents if available and data not changed
    var useBitStringContents = false;
    if ("bitStringContents" in obj) {
        useBitStringContents = true;
        if (obj.original) useBitStringContents = $f55f5179da2fdd93$var$asn1.equals(obj, obj.original);
    }
    if (useBitStringContents) value.putBytes(obj.bitStringContents);
    else if (obj.composed) {
        // if composed, use each child asn1 object's DER bytes as value
        // turn on 6th bit (0x20 = 32) to indicate asn1 is constructed
        // from other asn1 objects
        if (obj.constructed) b1 |= 0x20;
        else // type is a bit string, add unused bits of 0x00
        value.putByte(0x00);
        // add all of the child DER bytes together
        for(var i = 0; i < obj.value.length; ++i)if (obj.value[i] !== undefined) value.putBuffer($f55f5179da2fdd93$var$asn1.toDer(obj.value[i]));
    } else {
        // use asn1.value directly
        if (obj.type === $f55f5179da2fdd93$var$asn1.Type.BMPSTRING) for(var i = 0; i < obj.value.length; ++i)value.putInt16(obj.value.charCodeAt(i));
        else // ensure integer is minimally-encoded
        // TODO: should all leading bytes be stripped vs just one?
        // .. ex '00 00 01' => '01'?
        if (obj.type === $f55f5179da2fdd93$var$asn1.Type.INTEGER && obj.value.length > 1 && // leading 0x00 for positive integer
        (obj.value.charCodeAt(0) === 0 && (obj.value.charCodeAt(1) & 0x80) === 0 || // leading 0xFF for negative integer
        obj.value.charCodeAt(0) === 0xFF && (obj.value.charCodeAt(1) & 0x80) === 0x80)) value.putBytes(obj.value.substr(1));
        else value.putBytes(obj.value);
    }
    // add tag byte
    bytes.putByte(b1);
    // use "short form" encoding
    if (value.length() <= 127) // one byte describes the length
    // bit 8 = 0 and bits 7-1 = length
    bytes.putByte(value.length() & 0x7F);
    else {
        // use "long form" encoding
        // 2 to 127 bytes describe the length
        // first byte: bit 8 = 1 and bits 7-1 = # of additional bytes
        // other bytes: length in base 256, big-endian
        var len = value.length();
        var lenBytes = "";
        do {
            lenBytes += String.fromCharCode(len & 0xFF);
            len = len >>> 8;
        }while (len > 0);
        // set first byte to # bytes used to store the length and turn on
        // bit 8 to indicate long-form length is used
        bytes.putByte(lenBytes.length | 0x80);
        // concatenate length bytes in reverse since they were generated
        // little endian and we need big endian
        for(var i = lenBytes.length - 1; i >= 0; --i)bytes.putByte(lenBytes.charCodeAt(i));
    }
    // concatenate value bytes
    bytes.putBuffer(value);
    return bytes;
};
/**
 * Converts an OID dot-separated string to a byte buffer. The byte buffer
 * contains only the DER-encoded value, not any tag or length bytes.
 *
 * @param oid the OID dot-separated string.
 *
 * @return the byte buffer.
 */ $f55f5179da2fdd93$var$asn1.oidToDer = function(oid) {
    // split OID into individual values
    var values = oid.split(".");
    var bytes = $2xc86.util.createBuffer();
    // first byte is 40 * value1 + value2
    bytes.putByte(40 * parseInt(values[0], 10) + parseInt(values[1], 10));
    // other bytes are each value in base 128 with 8th bit set except for
    // the last byte for each value
    var last, valueBytes, value, b;
    for(var i = 2; i < values.length; ++i){
        // produce value bytes in reverse because we don't know how many
        // bytes it will take to store the value
        last = true;
        valueBytes = [];
        value = parseInt(values[i], 10);
        do {
            b = value & 0x7F;
            value = value >>> 7;
            // if value is not last, then turn on 8th bit
            if (!last) b |= 0x80;
            valueBytes.push(b);
            last = false;
        }while (value > 0);
        // add value bytes in reverse (needs to be in big endian)
        for(var n = valueBytes.length - 1; n >= 0; --n)bytes.putByte(valueBytes[n]);
    }
    return bytes;
};
/**
 * Converts a DER-encoded byte buffer to an OID dot-separated string. The
 * byte buffer should contain only the DER-encoded value, not any tag or
 * length bytes.
 *
 * @param bytes the byte buffer.
 *
 * @return the OID dot-separated string.
 */ $f55f5179da2fdd93$var$asn1.derToOid = function(bytes) {
    var oid;
    // wrap in buffer if needed
    if (typeof bytes === "string") bytes = $2xc86.util.createBuffer(bytes);
    // first byte is 40 * value1 + value2
    var b = bytes.getByte();
    oid = Math.floor(b / 40) + "." + b % 40;
    // other bytes are each value in base 128 with 8th bit set except for
    // the last byte for each value
    var value = 0;
    while(bytes.length() > 0){
        b = bytes.getByte();
        value = value << 7;
        // not the last byte for the value
        if (b & 0x80) value += b & 0x7F;
        else {
            // last byte
            oid += "." + (value + b);
            value = 0;
        }
    }
    return oid;
};
/**
 * Converts a UTCTime value to a date.
 *
 * Note: GeneralizedTime has 4 digits for the year and is used for X.509
 * dates past 2049. Parsing that structure hasn't been implemented yet.
 *
 * @param utc the UTCTime value to convert.
 *
 * @return the date.
 */ $f55f5179da2fdd93$var$asn1.utcTimeToDate = function(utc) {
    /* The following formats can be used:

    YYMMDDhhmmZ
    YYMMDDhhmm+hh'mm'
    YYMMDDhhmm-hh'mm'
    YYMMDDhhmmssZ
    YYMMDDhhmmss+hh'mm'
    YYMMDDhhmmss-hh'mm'

    Where:

    YY is the least significant two digits of the year
    MM is the month (01 to 12)
    DD is the day (01 to 31)
    hh is the hour (00 to 23)
    mm are the minutes (00 to 59)
    ss are the seconds (00 to 59)
    Z indicates that local time is GMT, + indicates that local time is
    later than GMT, and - indicates that local time is earlier than GMT
    hh' is the absolute value of the offset from GMT in hours
    mm' is the absolute value of the offset from GMT in minutes */ var date = new Date();
    // if YY >= 50 use 19xx, if YY < 50 use 20xx
    var year = parseInt(utc.substr(0, 2), 10);
    year = year >= 50 ? 1900 + year : 2000 + year;
    var MM = parseInt(utc.substr(2, 2), 10) - 1; // use 0-11 for month
    var DD = parseInt(utc.substr(4, 2), 10);
    var hh = parseInt(utc.substr(6, 2), 10);
    var mm = parseInt(utc.substr(8, 2), 10);
    var ss = 0;
    // not just YYMMDDhhmmZ
    if (utc.length > 11) {
        // get character after minutes
        var c = utc.charAt(10);
        var end = 10;
        // see if seconds are present
        if (c !== "+" && c !== "-") {
            // get seconds
            ss = parseInt(utc.substr(10, 2), 10);
            end += 2;
        }
    }
    // update date
    date.setUTCFullYear(year, MM, DD);
    date.setUTCHours(hh, mm, ss, 0);
    if (end) {
        // get +/- after end of time
        c = utc.charAt(end);
        if (c === "+" || c === "-") {
            // get hours+minutes offset
            var hhoffset = parseInt(utc.substr(end + 1, 2), 10);
            var mmoffset = parseInt(utc.substr(end + 4, 2), 10);
            // calculate offset in milliseconds
            var offset = hhoffset * 60 + mmoffset;
            offset *= 60000;
            // apply offset
            if (c === "+") date.setTime(+date - offset);
            else date.setTime(+date + offset);
        }
    }
    return date;
};
/**
 * Converts a GeneralizedTime value to a date.
 *
 * @param gentime the GeneralizedTime value to convert.
 *
 * @return the date.
 */ $f55f5179da2fdd93$var$asn1.generalizedTimeToDate = function(gentime) {
    /* The following formats can be used:

    YYYYMMDDHHMMSS
    YYYYMMDDHHMMSS.fff
    YYYYMMDDHHMMSSZ
    YYYYMMDDHHMMSS.fffZ
    YYYYMMDDHHMMSS+hh'mm'
    YYYYMMDDHHMMSS.fff+hh'mm'
    YYYYMMDDHHMMSS-hh'mm'
    YYYYMMDDHHMMSS.fff-hh'mm'

    Where:

    YYYY is the year
    MM is the month (01 to 12)
    DD is the day (01 to 31)
    hh is the hour (00 to 23)
    mm are the minutes (00 to 59)
    ss are the seconds (00 to 59)
    .fff is the second fraction, accurate to three decimal places
    Z indicates that local time is GMT, + indicates that local time is
    later than GMT, and - indicates that local time is earlier than GMT
    hh' is the absolute value of the offset from GMT in hours
    mm' is the absolute value of the offset from GMT in minutes */ var date = new Date();
    var YYYY = parseInt(gentime.substr(0, 4), 10);
    var MM = parseInt(gentime.substr(4, 2), 10) - 1; // use 0-11 for month
    var DD = parseInt(gentime.substr(6, 2), 10);
    var hh = parseInt(gentime.substr(8, 2), 10);
    var mm = parseInt(gentime.substr(10, 2), 10);
    var ss = parseInt(gentime.substr(12, 2), 10);
    var fff = 0;
    var offset = 0;
    var isUTC = false;
    if (gentime.charAt(gentime.length - 1) === "Z") isUTC = true;
    var end = gentime.length - 5, c = gentime.charAt(end);
    if (c === "+" || c === "-") {
        // get hours+minutes offset
        var hhoffset = parseInt(gentime.substr(end + 1, 2), 10);
        var mmoffset = parseInt(gentime.substr(end + 4, 2), 10);
        // calculate offset in milliseconds
        offset = hhoffset * 60 + mmoffset;
        offset *= 60000;
        // apply offset
        if (c === "+") offset *= -1;
        isUTC = true;
    }
    // check for second fraction
    if (gentime.charAt(14) === ".") fff = parseFloat(gentime.substr(14), 10) * 1000;
    if (isUTC) {
        date.setUTCFullYear(YYYY, MM, DD);
        date.setUTCHours(hh, mm, ss, fff);
        // apply offset
        date.setTime(+date + offset);
    } else {
        date.setFullYear(YYYY, MM, DD);
        date.setHours(hh, mm, ss, fff);
    }
    return date;
};
/**
 * Converts a date to a UTCTime value.
 *
 * Note: GeneralizedTime has 4 digits for the year and is used for X.509
 * dates past 2049. Converting to a GeneralizedTime hasn't been
 * implemented yet.
 *
 * @param date the date to convert.
 *
 * @return the UTCTime value.
 */ $f55f5179da2fdd93$var$asn1.dateToUtcTime = function(date) {
    // TODO: validate; currently assumes proper format
    if (typeof date === "string") return date;
    var rval = "";
    // create format YYMMDDhhmmssZ
    var format = [];
    format.push(("" + date.getUTCFullYear()).substr(2));
    format.push("" + (date.getUTCMonth() + 1));
    format.push("" + date.getUTCDate());
    format.push("" + date.getUTCHours());
    format.push("" + date.getUTCMinutes());
    format.push("" + date.getUTCSeconds());
    // ensure 2 digits are used for each format entry
    for(var i = 0; i < format.length; ++i){
        if (format[i].length < 2) rval += "0";
        rval += format[i];
    }
    rval += "Z";
    return rval;
};
/**
 * Converts a date to a GeneralizedTime value.
 *
 * @param date the date to convert.
 *
 * @return the GeneralizedTime value as a string.
 */ $f55f5179da2fdd93$var$asn1.dateToGeneralizedTime = function(date) {
    // TODO: validate; currently assumes proper format
    if (typeof date === "string") return date;
    var rval = "";
    // create format YYYYMMDDHHMMSSZ
    var format = [];
    format.push("" + date.getUTCFullYear());
    format.push("" + (date.getUTCMonth() + 1));
    format.push("" + date.getUTCDate());
    format.push("" + date.getUTCHours());
    format.push("" + date.getUTCMinutes());
    format.push("" + date.getUTCSeconds());
    // ensure 2 digits are used for each format entry
    for(var i = 0; i < format.length; ++i){
        if (format[i].length < 2) rval += "0";
        rval += format[i];
    }
    rval += "Z";
    return rval;
};
/**
 * Converts a javascript integer to a DER-encoded byte buffer to be used
 * as the value for an INTEGER type.
 *
 * @param x the integer.
 *
 * @return the byte buffer.
 */ $f55f5179da2fdd93$var$asn1.integerToDer = function(x) {
    var rval = $2xc86.util.createBuffer();
    if (x >= -128 && x < 0x80) return rval.putSignedInt(x, 8);
    if (x >= -32768 && x < 0x8000) return rval.putSignedInt(x, 16);
    if (x >= -8388608 && x < 0x800000) return rval.putSignedInt(x, 24);
    if (x >= -2147483648 && x < 0x80000000) return rval.putSignedInt(x, 32);
    var error = new Error("Integer too large; max is 32-bits.");
    error.integer = x;
    throw error;
};
/**
 * Converts a DER-encoded byte buffer to a javascript integer. This is
 * typically used to decode the value of an INTEGER type.
 *
 * @param bytes the byte buffer.
 *
 * @return the integer.
 */ $f55f5179da2fdd93$var$asn1.derToInteger = function(bytes) {
    // wrap in buffer if needed
    if (typeof bytes === "string") bytes = $2xc86.util.createBuffer(bytes);
    var n = bytes.length() * 8;
    if (n > 32) throw new Error("Integer too large; max is 32-bits.");
    return bytes.getSignedInt(n);
};
/**
 * Validates that the given ASN.1 object is at least a super set of the
 * given ASN.1 structure. Only tag classes and types are checked. An
 * optional map may also be provided to capture ASN.1 values while the
 * structure is checked.
 *
 * To capture an ASN.1 value, set an object in the validator's 'capture'
 * parameter to the key to use in the capture map. To capture the full
 * ASN.1 object, specify 'captureAsn1'. To capture BIT STRING bytes, including
 * the leading unused bits counter byte, specify 'captureBitStringContents'.
 * To capture BIT STRING bytes, without the leading unused bits counter byte,
 * specify 'captureBitStringValue'.
 *
 * Objects in the validator may set a field 'optional' to true to indicate
 * that it isn't necessary to pass validation.
 *
 * @param obj the ASN.1 object to validate.
 * @param v the ASN.1 structure validator.
 * @param capture an optional map to capture values in.
 * @param errors an optional array for storing validation errors.
 *
 * @return true on success, false on failure.
 */ $f55f5179da2fdd93$var$asn1.validate = function(obj, v, capture, errors) {
    var rval = false;
    // ensure tag class and type are the same if specified
    if ((obj.tagClass === v.tagClass || typeof v.tagClass === "undefined") && (obj.type === v.type || typeof v.type === "undefined")) {
        // ensure constructed flag is the same if specified
        if (obj.constructed === v.constructed || typeof v.constructed === "undefined") {
            rval = true;
            // handle sub values
            if (v.value && $2xc86.util.isArray(v.value)) {
                var j = 0;
                for(var i = 0; rval && i < v.value.length; ++i){
                    rval = v.value[i].optional || false;
                    if (obj.value[j]) {
                        rval = $f55f5179da2fdd93$var$asn1.validate(obj.value[j], v.value[i], capture, errors);
                        if (rval) ++j;
                        else if (v.value[i].optional) rval = true;
                    }
                    if (!rval && errors) errors.push("[" + v.name + "] " + 'Tag class "' + v.tagClass + '", type "' + v.type + '" expected value length "' + v.value.length + '", got "' + obj.value.length + '"');
                }
            }
            if (rval && capture) {
                if (v.capture) capture[v.capture] = obj.value;
                if (v.captureAsn1) capture[v.captureAsn1] = obj;
                if (v.captureBitStringContents && "bitStringContents" in obj) capture[v.captureBitStringContents] = obj.bitStringContents;
                if (v.captureBitStringValue && "bitStringContents" in obj) {
                    var value;
                    if (obj.bitStringContents.length < 2) capture[v.captureBitStringValue] = "";
                    else {
                        // FIXME: support unused bits with data shifting
                        var unused = obj.bitStringContents.charCodeAt(0);
                        if (unused !== 0) throw new Error("captureBitStringValue only supported for zero unused bits");
                        capture[v.captureBitStringValue] = obj.bitStringContents.slice(1);
                    }
                }
            }
        } else if (errors) errors.push("[" + v.name + "] " + 'Expected constructed "' + v.constructed + '", got "' + obj.constructed + '"');
    } else if (errors) {
        if (obj.tagClass !== v.tagClass) errors.push("[" + v.name + "] " + 'Expected tag class "' + v.tagClass + '", got "' + obj.tagClass + '"');
        if (obj.type !== v.type) errors.push("[" + v.name + "] " + 'Expected type "' + v.type + '", got "' + obj.type + '"');
    }
    return rval;
};
// regex for testing for non-latin characters
var $f55f5179da2fdd93$var$_nonLatinRegex = /[^\\u0000-\\u00ff]/;
/**
 * Pretty prints an ASN.1 object to a string.
 *
 * @param obj the object to write out.
 * @param level the level in the tree.
 * @param indentation the indentation to use.
 *
 * @return the string.
 */ $f55f5179da2fdd93$var$asn1.prettyPrint = function(obj, level, indentation) {
    var rval = "";
    // set default level and indentation
    level = level || 0;
    indentation = indentation || 2;
    // start new line for deep levels
    if (level > 0) rval += "\n";
    // create indent
    var indent = "";
    for(var i = 0; i < level * indentation; ++i)indent += " ";
    // print class:type
    rval += indent + "Tag: ";
    switch(obj.tagClass){
        case $f55f5179da2fdd93$var$asn1.Class.UNIVERSAL:
            rval += "Universal:";
            break;
        case $f55f5179da2fdd93$var$asn1.Class.APPLICATION:
            rval += "Application:";
            break;
        case $f55f5179da2fdd93$var$asn1.Class.CONTEXT_SPECIFIC:
            rval += "Context-Specific:";
            break;
        case $f55f5179da2fdd93$var$asn1.Class.PRIVATE:
            rval += "Private:";
            break;
    }
    if (obj.tagClass === $f55f5179da2fdd93$var$asn1.Class.UNIVERSAL) {
        rval += obj.type;
        // known types
        switch(obj.type){
            case $f55f5179da2fdd93$var$asn1.Type.NONE:
                rval += " (None)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.BOOLEAN:
                rval += " (Boolean)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.INTEGER:
                rval += " (Integer)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.BITSTRING:
                rval += " (Bit string)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.OCTETSTRING:
                rval += " (Octet string)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.NULL:
                rval += " (Null)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.OID:
                rval += " (Object Identifier)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.ODESC:
                rval += " (Object Descriptor)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.EXTERNAL:
                rval += " (External or Instance of)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.REAL:
                rval += " (Real)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.ENUMERATED:
                rval += " (Enumerated)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.EMBEDDED:
                rval += " (Embedded PDV)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.UTF8:
                rval += " (UTF8)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.ROID:
                rval += " (Relative Object Identifier)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.SEQUENCE:
                rval += " (Sequence)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.SET:
                rval += " (Set)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.PRINTABLESTRING:
                rval += " (Printable String)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.IA5String:
                rval += " (IA5String (ASCII))";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.UTCTIME:
                rval += " (UTC time)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.GENERALIZEDTIME:
                rval += " (Generalized time)";
                break;
            case $f55f5179da2fdd93$var$asn1.Type.BMPSTRING:
                rval += " (BMP String)";
                break;
        }
    } else rval += obj.type;
    rval += "\n";
    rval += indent + "Constructed: " + obj.constructed + "\n";
    if (obj.composed) {
        var subvalues = 0;
        var sub = "";
        for(var i = 0; i < obj.value.length; ++i)if (obj.value[i] !== undefined) {
            subvalues += 1;
            sub += $f55f5179da2fdd93$var$asn1.prettyPrint(obj.value[i], level + 1, indentation);
            if (i + 1 < obj.value.length) sub += ",";
        }
        rval += indent + "Sub values: " + subvalues + sub;
    } else {
        rval += indent + "Value: ";
        if (obj.type === $f55f5179da2fdd93$var$asn1.Type.OID) {
            var oid = $f55f5179da2fdd93$var$asn1.derToOid(obj.value);
            rval += oid;
            if ($2xc86.pki && $2xc86.pki.oids) {
                if (oid in $2xc86.pki.oids) rval += " (" + $2xc86.pki.oids[oid] + ") ";
            }
        }
        if (obj.type === $f55f5179da2fdd93$var$asn1.Type.INTEGER) try {
            rval += $f55f5179da2fdd93$var$asn1.derToInteger(obj.value);
        } catch (ex) {
            rval += "0x" + $2xc86.util.bytesToHex(obj.value);
        }
        else if (obj.type === $f55f5179da2fdd93$var$asn1.Type.BITSTRING) {
            // TODO: shift bits as needed to display without padding
            if (obj.value.length > 1) // remove unused bits field
            rval += "0x" + $2xc86.util.bytesToHex(obj.value.slice(1));
            else rval += "(none)";
            // show unused bit count
            if (obj.value.length > 0) {
                var unused = obj.value.charCodeAt(0);
                if (unused == 1) rval += " (1 unused bit shown)";
                else if (unused > 1) rval += " (" + unused + " unused bits shown)";
            }
        } else if (obj.type === $f55f5179da2fdd93$var$asn1.Type.OCTETSTRING) {
            if (!$f55f5179da2fdd93$var$_nonLatinRegex.test(obj.value)) rval += "(" + obj.value + ") ";
            rval += "0x" + $2xc86.util.bytesToHex(obj.value);
        } else if (obj.type === $f55f5179da2fdd93$var$asn1.Type.UTF8) rval += $2xc86.util.decodeUtf8(obj.value);
        else if (obj.type === $f55f5179da2fdd93$var$asn1.Type.PRINTABLESTRING || obj.type === $f55f5179da2fdd93$var$asn1.Type.IA5String) rval += obj.value;
        else if ($f55f5179da2fdd93$var$_nonLatinRegex.test(obj.value)) rval += "0x" + $2xc86.util.bytesToHex(obj.value);
        else if (obj.value.length === 0) rval += "[null]";
        else rval += obj.value;
    }
    return rval;
};

});
parcelRequire.register("hzEKF", function(module, exports) {
/**
 * Object IDs for ASN.1.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 */ 
var $2xc86 = parcelRequire("2xc86");
$2xc86.pki = $2xc86.pki || {};
var $ccb550f9dbb419c2$var$oids = module.exports = $2xc86.pki.oids = $2xc86.oids = $2xc86.oids || {};
// set id to name mapping and name to id mapping
function $ccb550f9dbb419c2$var$_IN(id, name) {
    $ccb550f9dbb419c2$var$oids[id] = name;
    $ccb550f9dbb419c2$var$oids[name] = id;
}
// set id to name mapping only
function $ccb550f9dbb419c2$var$_I_(id, name) {
    $ccb550f9dbb419c2$var$oids[id] = name;
}
// algorithm OIDs
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.1.1", "rsaEncryption");
// Note: md2 & md4 not implemented
//_IN('1.2.840.113549.1.1.2', 'md2WithRSAEncryption');
//_IN('1.2.840.113549.1.1.3', 'md4WithRSAEncryption');
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.1.4", "md5WithRSAEncryption");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.1.5", "sha1WithRSAEncryption");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.1.7", "RSAES-OAEP");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.1.8", "mgf1");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.1.9", "pSpecified");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.1.10", "RSASSA-PSS");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.1.11", "sha256WithRSAEncryption");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.1.12", "sha384WithRSAEncryption");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.1.13", "sha512WithRSAEncryption");
// Edwards-curve Digital Signature Algorithm (EdDSA) Ed25519
$ccb550f9dbb419c2$var$_IN("1.3.101.112", "EdDSA25519");
$ccb550f9dbb419c2$var$_IN("1.2.840.10040.4.3", "dsa-with-sha1");
$ccb550f9dbb419c2$var$_IN("1.3.14.3.2.7", "desCBC");
$ccb550f9dbb419c2$var$_IN("1.3.14.3.2.26", "sha1");
$ccb550f9dbb419c2$var$_IN("2.16.840.1.101.3.4.2.1", "sha256");
$ccb550f9dbb419c2$var$_IN("2.16.840.1.101.3.4.2.2", "sha384");
$ccb550f9dbb419c2$var$_IN("2.16.840.1.101.3.4.2.3", "sha512");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.2.5", "md5");
// pkcs#7 content types
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.7.1", "data");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.7.2", "signedData");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.7.3", "envelopedData");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.7.4", "signedAndEnvelopedData");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.7.5", "digestedData");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.7.6", "encryptedData");
// pkcs#9 oids
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.9.1", "emailAddress");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.9.2", "unstructuredName");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.9.3", "contentType");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.9.4", "messageDigest");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.9.5", "signingTime");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.9.6", "counterSignature");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.9.7", "challengePassword");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.9.8", "unstructuredAddress");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.9.14", "extensionRequest");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.9.20", "friendlyName");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.9.21", "localKeyId");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.9.22.1", "x509Certificate");
// pkcs#12 safe bags
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.12.10.1.1", "keyBag");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.12.10.1.2", "pkcs8ShroudedKeyBag");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.12.10.1.3", "certBag");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.12.10.1.4", "crlBag");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.12.10.1.5", "secretBag");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.12.10.1.6", "safeContentsBag");
// password-based-encryption for pkcs#12
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.5.13", "pkcs5PBES2");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.5.12", "pkcs5PBKDF2");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.12.1.1", "pbeWithSHAAnd128BitRC4");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.12.1.2", "pbeWithSHAAnd40BitRC4");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.12.1.3", "pbeWithSHAAnd3-KeyTripleDES-CBC");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.12.1.4", "pbeWithSHAAnd2-KeyTripleDES-CBC");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.12.1.5", "pbeWithSHAAnd128BitRC2-CBC");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.1.12.1.6", "pbewithSHAAnd40BitRC2-CBC");
// hmac OIDs
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.2.7", "hmacWithSHA1");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.2.8", "hmacWithSHA224");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.2.9", "hmacWithSHA256");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.2.10", "hmacWithSHA384");
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.2.11", "hmacWithSHA512");
// symmetric key algorithm oids
$ccb550f9dbb419c2$var$_IN("1.2.840.113549.3.7", "des-EDE3-CBC");
$ccb550f9dbb419c2$var$_IN("2.16.840.1.101.3.4.1.2", "aes128-CBC");
$ccb550f9dbb419c2$var$_IN("2.16.840.1.101.3.4.1.22", "aes192-CBC");
$ccb550f9dbb419c2$var$_IN("2.16.840.1.101.3.4.1.42", "aes256-CBC");
// certificate issuer/subject OIDs
$ccb550f9dbb419c2$var$_IN("2.5.4.3", "commonName");
$ccb550f9dbb419c2$var$_IN("2.5.4.5", "serialName");
$ccb550f9dbb419c2$var$_IN("2.5.4.6", "countryName");
$ccb550f9dbb419c2$var$_IN("2.5.4.7", "localityName");
$ccb550f9dbb419c2$var$_IN("2.5.4.8", "stateOrProvinceName");
$ccb550f9dbb419c2$var$_IN("2.5.4.9", "streetAddress");
$ccb550f9dbb419c2$var$_IN("2.5.4.10", "organizationName");
$ccb550f9dbb419c2$var$_IN("2.5.4.11", "organizationalUnitName");
$ccb550f9dbb419c2$var$_IN("2.5.4.13", "description");
$ccb550f9dbb419c2$var$_IN("2.5.4.15", "businessCategory");
$ccb550f9dbb419c2$var$_IN("2.5.4.17", "postalCode");
$ccb550f9dbb419c2$var$_IN("1.3.6.1.4.1.311.60.2.1.2", "jurisdictionOfIncorporationStateOrProvinceName");
$ccb550f9dbb419c2$var$_IN("1.3.6.1.4.1.311.60.2.1.3", "jurisdictionOfIncorporationCountryName");
// X.509 extension OIDs
$ccb550f9dbb419c2$var$_IN("2.16.840.1.113730.1.1", "nsCertType");
$ccb550f9dbb419c2$var$_IN("2.16.840.1.113730.1.13", "nsComment"); // deprecated in theory; still widely used
$ccb550f9dbb419c2$var$_I_("2.5.29.1", "authorityKeyIdentifier"); // deprecated, use .35
$ccb550f9dbb419c2$var$_I_("2.5.29.2", "keyAttributes"); // obsolete use .37 or .15
$ccb550f9dbb419c2$var$_I_("2.5.29.3", "certificatePolicies"); // deprecated, use .32
$ccb550f9dbb419c2$var$_I_("2.5.29.4", "keyUsageRestriction"); // obsolete use .37 or .15
$ccb550f9dbb419c2$var$_I_("2.5.29.5", "policyMapping"); // deprecated use .33
$ccb550f9dbb419c2$var$_I_("2.5.29.6", "subtreesConstraint"); // obsolete use .30
$ccb550f9dbb419c2$var$_I_("2.5.29.7", "subjectAltName"); // deprecated use .17
$ccb550f9dbb419c2$var$_I_("2.5.29.8", "issuerAltName"); // deprecated use .18
$ccb550f9dbb419c2$var$_I_("2.5.29.9", "subjectDirectoryAttributes");
$ccb550f9dbb419c2$var$_I_("2.5.29.10", "basicConstraints"); // deprecated use .19
$ccb550f9dbb419c2$var$_I_("2.5.29.11", "nameConstraints"); // deprecated use .30
$ccb550f9dbb419c2$var$_I_("2.5.29.12", "policyConstraints"); // deprecated use .36
$ccb550f9dbb419c2$var$_I_("2.5.29.13", "basicConstraints"); // deprecated use .19
$ccb550f9dbb419c2$var$_IN("2.5.29.14", "subjectKeyIdentifier");
$ccb550f9dbb419c2$var$_IN("2.5.29.15", "keyUsage");
$ccb550f9dbb419c2$var$_I_("2.5.29.16", "privateKeyUsagePeriod");
$ccb550f9dbb419c2$var$_IN("2.5.29.17", "subjectAltName");
$ccb550f9dbb419c2$var$_IN("2.5.29.18", "issuerAltName");
$ccb550f9dbb419c2$var$_IN("2.5.29.19", "basicConstraints");
$ccb550f9dbb419c2$var$_I_("2.5.29.20", "cRLNumber");
$ccb550f9dbb419c2$var$_I_("2.5.29.21", "cRLReason");
$ccb550f9dbb419c2$var$_I_("2.5.29.22", "expirationDate");
$ccb550f9dbb419c2$var$_I_("2.5.29.23", "instructionCode");
$ccb550f9dbb419c2$var$_I_("2.5.29.24", "invalidityDate");
$ccb550f9dbb419c2$var$_I_("2.5.29.25", "cRLDistributionPoints"); // deprecated use .31
$ccb550f9dbb419c2$var$_I_("2.5.29.26", "issuingDistributionPoint"); // deprecated use .28
$ccb550f9dbb419c2$var$_I_("2.5.29.27", "deltaCRLIndicator");
$ccb550f9dbb419c2$var$_I_("2.5.29.28", "issuingDistributionPoint");
$ccb550f9dbb419c2$var$_I_("2.5.29.29", "certificateIssuer");
$ccb550f9dbb419c2$var$_I_("2.5.29.30", "nameConstraints");
$ccb550f9dbb419c2$var$_IN("2.5.29.31", "cRLDistributionPoints");
$ccb550f9dbb419c2$var$_IN("2.5.29.32", "certificatePolicies");
$ccb550f9dbb419c2$var$_I_("2.5.29.33", "policyMappings");
$ccb550f9dbb419c2$var$_I_("2.5.29.34", "policyConstraints"); // deprecated use .36
$ccb550f9dbb419c2$var$_IN("2.5.29.35", "authorityKeyIdentifier");
$ccb550f9dbb419c2$var$_I_("2.5.29.36", "policyConstraints");
$ccb550f9dbb419c2$var$_IN("2.5.29.37", "extKeyUsage");
$ccb550f9dbb419c2$var$_I_("2.5.29.46", "freshestCRL");
$ccb550f9dbb419c2$var$_I_("2.5.29.54", "inhibitAnyPolicy");
// extKeyUsage purposes
$ccb550f9dbb419c2$var$_IN("1.3.6.1.4.1.11129.2.4.2", "timestampList");
$ccb550f9dbb419c2$var$_IN("1.3.6.1.5.5.7.1.1", "authorityInfoAccess");
$ccb550f9dbb419c2$var$_IN("1.3.6.1.5.5.7.3.1", "serverAuth");
$ccb550f9dbb419c2$var$_IN("1.3.6.1.5.5.7.3.2", "clientAuth");
$ccb550f9dbb419c2$var$_IN("1.3.6.1.5.5.7.3.3", "codeSigning");
$ccb550f9dbb419c2$var$_IN("1.3.6.1.5.5.7.3.4", "emailProtection");
$ccb550f9dbb419c2$var$_IN("1.3.6.1.5.5.7.3.8", "timeStamping");

});


parcelRequire.register("1UAMB", function(module, exports) {
/**
 * DES (Data Encryption Standard) implementation.
 *
 * This implementation supports DES as well as 3DES-EDE in ECB and CBC mode.
 * It is based on the BSD-licensed implementation by Paul Tero:
 *
 * Paul Tero, July 2001
 * http://www.tero.co.uk/des/
 *
 * Optimised for performance with large blocks by
 * Michael Hayworth, November 2001
 * http://www.netdealing.com
 *
 * THIS SOFTWARE IS PROVIDED "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED.  IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
 * OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
 * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
 * SUCH DAMAGE.
 *
 * @author Stefan Siegl
 * @author Dave Longley
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 * Copyright (c) 2012-2014 Digital Bazaar, Inc.
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("kM8NH");
parcelRequire("2D3xR");
parcelRequire("e73pV");
/* DES API */ module.exports = $2xc86.des = $2xc86.des || {};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('DES-<mode>', key);
 * cipher.start({iv: iv});
 *
 * Creates an DES cipher object to encrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as binary-encoded strings of bytes or
 * byte buffers.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC' if IV is
 *          given, 'ECB' if null).
 *
 * @return the cipher.
 */ $2xc86.des.startEncrypting = function(key, iv, output, mode) {
    var cipher = $16478db66600d911$var$_createCipher({
        key: key,
        output: output,
        decrypt: false,
        mode: mode || (iv === null ? "ECB" : "CBC")
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var cipher = forge.cipher.createCipher('DES-<mode>', key);
 *
 * Creates an DES cipher object to encrypt data using the given symmetric key.
 *
 * The key may be given as a binary-encoded string of bytes or a byte buffer.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $2xc86.des.createEncryptionCipher = function(key, mode) {
    return $16478db66600d911$var$_createCipher({
        key: key,
        output: null,
        decrypt: false,
        mode: mode
    });
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('DES-<mode>', key);
 * decipher.start({iv: iv});
 *
 * Creates an DES cipher object to decrypt data using the given symmetric key.
 * The output will be stored in the 'output' member of the returned cipher.
 *
 * The key and iv may be given as binary-encoded strings of bytes or
 * byte buffers.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 * @param mode the cipher mode to use (default: 'CBC' if IV is
 *          given, 'ECB' if null).
 *
 * @return the cipher.
 */ $2xc86.des.startDecrypting = function(key, iv, output, mode) {
    var cipher = $16478db66600d911$var$_createCipher({
        key: key,
        output: output,
        decrypt: true,
        mode: mode || (iv === null ? "ECB" : "CBC")
    });
    cipher.start(iv);
    return cipher;
};
/**
 * Deprecated. Instead, use:
 *
 * var decipher = forge.cipher.createDecipher('DES-<mode>', key);
 *
 * Creates an DES cipher object to decrypt data using the given symmetric key.
 *
 * The key may be given as a binary-encoded string of bytes or a byte buffer.
 *
 * @param key the symmetric key to use (64 or 192 bits).
 * @param mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ $2xc86.des.createDecryptionCipher = function(key, mode) {
    return $16478db66600d911$var$_createCipher({
        key: key,
        output: null,
        decrypt: true,
        mode: mode
    });
};
/**
 * Creates a new DES cipher algorithm object.
 *
 * @param name the name of the algorithm.
 * @param mode the mode factory function.
 *
 * @return the DES algorithm object.
 */ $2xc86.des.Algorithm = function(name, mode) {
    var self = this;
    self.name = name;
    self.mode = new mode({
        blockSize: 8,
        cipher: {
            encrypt: function(inBlock, outBlock) {
                return $16478db66600d911$var$_updateBlock(self._keys, inBlock, outBlock, false);
            },
            decrypt: function(inBlock, outBlock) {
                return $16478db66600d911$var$_updateBlock(self._keys, inBlock, outBlock, true);
            }
        }
    });
    self._init = false;
};
/**
 * Initializes this DES algorithm by expanding its key.
 *
 * @param options the options to use.
 *          key the key to use with this algorithm.
 *          decrypt true if the algorithm should be initialized for decryption,
 *            false for encryption.
 */ $2xc86.des.Algorithm.prototype.initialize = function(options) {
    if (this._init) return;
    var key = $2xc86.util.createBuffer(options.key);
    if (this.name.indexOf("3DES") === 0) {
        if (key.length() !== 24) throw new Error("Invalid Triple-DES key size: " + key.length() * 8);
    }
    // do key expansion to 16 or 48 subkeys (single or triple DES)
    this._keys = $16478db66600d911$var$_createKeys(key);
    this._init = true;
};
/** Register DES algorithms **/ $16478db66600d911$var$registerAlgorithm("DES-ECB", $2xc86.cipher.modes.ecb);
$16478db66600d911$var$registerAlgorithm("DES-CBC", $2xc86.cipher.modes.cbc);
$16478db66600d911$var$registerAlgorithm("DES-CFB", $2xc86.cipher.modes.cfb);
$16478db66600d911$var$registerAlgorithm("DES-OFB", $2xc86.cipher.modes.ofb);
$16478db66600d911$var$registerAlgorithm("DES-CTR", $2xc86.cipher.modes.ctr);
$16478db66600d911$var$registerAlgorithm("3DES-ECB", $2xc86.cipher.modes.ecb);
$16478db66600d911$var$registerAlgorithm("3DES-CBC", $2xc86.cipher.modes.cbc);
$16478db66600d911$var$registerAlgorithm("3DES-CFB", $2xc86.cipher.modes.cfb);
$16478db66600d911$var$registerAlgorithm("3DES-OFB", $2xc86.cipher.modes.ofb);
$16478db66600d911$var$registerAlgorithm("3DES-CTR", $2xc86.cipher.modes.ctr);
function $16478db66600d911$var$registerAlgorithm(name, mode) {
    var factory = function() {
        return new $2xc86.des.Algorithm(name, mode);
    };
    $2xc86.cipher.registerAlgorithm(name, factory);
}
/** DES implementation **/ var $16478db66600d911$var$spfunction1 = [
    0x1010400,
    0,
    0x10000,
    0x1010404,
    0x1010004,
    0x10404,
    0x4,
    0x10000,
    0x400,
    0x1010400,
    0x1010404,
    0x400,
    0x1000404,
    0x1010004,
    0x1000000,
    0x4,
    0x404,
    0x1000400,
    0x1000400,
    0x10400,
    0x10400,
    0x1010000,
    0x1010000,
    0x1000404,
    0x10004,
    0x1000004,
    0x1000004,
    0x10004,
    0,
    0x404,
    0x10404,
    0x1000000,
    0x10000,
    0x1010404,
    0x4,
    0x1010000,
    0x1010400,
    0x1000000,
    0x1000000,
    0x400,
    0x1010004,
    0x10000,
    0x10400,
    0x1000004,
    0x400,
    0x4,
    0x1000404,
    0x10404,
    0x1010404,
    0x10004,
    0x1010000,
    0x1000404,
    0x1000004,
    0x404,
    0x10404,
    0x1010400,
    0x404,
    0x1000400,
    0x1000400,
    0,
    0x10004,
    0x10400,
    0,
    0x1010004
];
var $16478db66600d911$var$spfunction2 = [
    -2146402272,
    -2147450880,
    0x8000,
    0x108020,
    0x100000,
    0x20,
    -2146435040,
    -2147450848,
    -2147483616,
    -2146402272,
    -2146402304,
    -2147483648,
    -2147450880,
    0x100000,
    0x20,
    -2146435040,
    0x108000,
    0x100020,
    -2147450848,
    0,
    -2147483648,
    0x8000,
    0x108020,
    -2146435072,
    0x100020,
    -2147483616,
    0,
    0x108000,
    0x8020,
    -2146402304,
    -2146435072,
    0x8020,
    0,
    0x108020,
    -2146435040,
    0x100000,
    -2147450848,
    -2146435072,
    -2146402304,
    0x8000,
    -2146435072,
    -2147450880,
    0x20,
    -2146402272,
    0x108020,
    0x20,
    0x8000,
    -2147483648,
    0x8020,
    -2146402304,
    0x100000,
    -2147483616,
    0x100020,
    -2147450848,
    -2147483616,
    0x100020,
    0x108000,
    0,
    -2147450880,
    0x8020,
    -2147483648,
    -2146435040,
    -2146402272,
    0x108000
];
var $16478db66600d911$var$spfunction3 = [
    0x208,
    0x8020200,
    0,
    0x8020008,
    0x8000200,
    0,
    0x20208,
    0x8000200,
    0x20008,
    0x8000008,
    0x8000008,
    0x20000,
    0x8020208,
    0x20008,
    0x8020000,
    0x208,
    0x8000000,
    0x8,
    0x8020200,
    0x200,
    0x20200,
    0x8020000,
    0x8020008,
    0x20208,
    0x8000208,
    0x20200,
    0x20000,
    0x8000208,
    0x8,
    0x8020208,
    0x200,
    0x8000000,
    0x8020200,
    0x8000000,
    0x20008,
    0x208,
    0x20000,
    0x8020200,
    0x8000200,
    0,
    0x200,
    0x20008,
    0x8020208,
    0x8000200,
    0x8000008,
    0x200,
    0,
    0x8020008,
    0x8000208,
    0x20000,
    0x8000000,
    0x8020208,
    0x8,
    0x20208,
    0x20200,
    0x8000008,
    0x8020000,
    0x8000208,
    0x208,
    0x8020000,
    0x20208,
    0x8,
    0x8020008,
    0x20200
];
var $16478db66600d911$var$spfunction4 = [
    0x802001,
    0x2081,
    0x2081,
    0x80,
    0x802080,
    0x800081,
    0x800001,
    0x2001,
    0,
    0x802000,
    0x802000,
    0x802081,
    0x81,
    0,
    0x800080,
    0x800001,
    0x1,
    0x2000,
    0x800000,
    0x802001,
    0x80,
    0x800000,
    0x2001,
    0x2080,
    0x800081,
    0x1,
    0x2080,
    0x800080,
    0x2000,
    0x802080,
    0x802081,
    0x81,
    0x800080,
    0x800001,
    0x802000,
    0x802081,
    0x81,
    0,
    0,
    0x802000,
    0x2080,
    0x800080,
    0x800081,
    0x1,
    0x802001,
    0x2081,
    0x2081,
    0x80,
    0x802081,
    0x81,
    0x1,
    0x2000,
    0x800001,
    0x2001,
    0x802080,
    0x800081,
    0x2001,
    0x2080,
    0x800000,
    0x802001,
    0x80,
    0x800000,
    0x2000,
    0x802080
];
var $16478db66600d911$var$spfunction5 = [
    0x100,
    0x2080100,
    0x2080000,
    0x42000100,
    0x80000,
    0x100,
    0x40000000,
    0x2080000,
    0x40080100,
    0x80000,
    0x2000100,
    0x40080100,
    0x42000100,
    0x42080000,
    0x80100,
    0x40000000,
    0x2000000,
    0x40080000,
    0x40080000,
    0,
    0x40000100,
    0x42080100,
    0x42080100,
    0x2000100,
    0x42080000,
    0x40000100,
    0,
    0x42000000,
    0x2080100,
    0x2000000,
    0x42000000,
    0x80100,
    0x80000,
    0x42000100,
    0x100,
    0x2000000,
    0x40000000,
    0x2080000,
    0x42000100,
    0x40080100,
    0x2000100,
    0x40000000,
    0x42080000,
    0x2080100,
    0x40080100,
    0x100,
    0x2000000,
    0x42080000,
    0x42080100,
    0x80100,
    0x42000000,
    0x42080100,
    0x2080000,
    0,
    0x40080000,
    0x42000000,
    0x80100,
    0x2000100,
    0x40000100,
    0x80000,
    0,
    0x40080000,
    0x2080100,
    0x40000100
];
var $16478db66600d911$var$spfunction6 = [
    0x20000010,
    0x20400000,
    0x4000,
    0x20404010,
    0x20400000,
    0x10,
    0x20404010,
    0x400000,
    0x20004000,
    0x404010,
    0x400000,
    0x20000010,
    0x400010,
    0x20004000,
    0x20000000,
    0x4010,
    0,
    0x400010,
    0x20004010,
    0x4000,
    0x404000,
    0x20004010,
    0x10,
    0x20400010,
    0x20400010,
    0,
    0x404010,
    0x20404000,
    0x4010,
    0x404000,
    0x20404000,
    0x20000000,
    0x20004000,
    0x10,
    0x20400010,
    0x404000,
    0x20404010,
    0x400000,
    0x4010,
    0x20000010,
    0x400000,
    0x20004000,
    0x20000000,
    0x4010,
    0x20000010,
    0x20404010,
    0x404000,
    0x20400000,
    0x404010,
    0x20404000,
    0,
    0x20400010,
    0x10,
    0x4000,
    0x20400000,
    0x404010,
    0x4000,
    0x400010,
    0x20004010,
    0,
    0x20404000,
    0x20000000,
    0x400010,
    0x20004010
];
var $16478db66600d911$var$spfunction7 = [
    0x200000,
    0x4200002,
    0x4000802,
    0,
    0x800,
    0x4000802,
    0x200802,
    0x4200800,
    0x4200802,
    0x200000,
    0,
    0x4000002,
    0x2,
    0x4000000,
    0x4200002,
    0x802,
    0x4000800,
    0x200802,
    0x200002,
    0x4000800,
    0x4000002,
    0x4200000,
    0x4200800,
    0x200002,
    0x4200000,
    0x800,
    0x802,
    0x4200802,
    0x200800,
    0x2,
    0x4000000,
    0x200800,
    0x4000000,
    0x200800,
    0x200000,
    0x4000802,
    0x4000802,
    0x4200002,
    0x4200002,
    0x2,
    0x200002,
    0x4000000,
    0x4000800,
    0x200000,
    0x4200800,
    0x802,
    0x200802,
    0x4200800,
    0x802,
    0x4000002,
    0x4200802,
    0x4200000,
    0x200800,
    0,
    0x2,
    0x4200802,
    0,
    0x200802,
    0x4200000,
    0x800,
    0x4000002,
    0x4000800,
    0x800,
    0x200002
];
var $16478db66600d911$var$spfunction8 = [
    0x10001040,
    0x1000,
    0x40000,
    0x10041040,
    0x10000000,
    0x10001040,
    0x40,
    0x10000000,
    0x40040,
    0x10040000,
    0x10041040,
    0x41000,
    0x10041000,
    0x41040,
    0x1000,
    0x40,
    0x10040000,
    0x10000040,
    0x10001000,
    0x1040,
    0x41000,
    0x40040,
    0x10040040,
    0x10041000,
    0x1040,
    0,
    0,
    0x10040040,
    0x10000040,
    0x10001000,
    0x41040,
    0x40000,
    0x41040,
    0x40000,
    0x10041000,
    0x1000,
    0x40,
    0x10040040,
    0x1000,
    0x41040,
    0x10001000,
    0x40,
    0x10000040,
    0x10040000,
    0x10040040,
    0x10000000,
    0x40000,
    0x10001040,
    0,
    0x10041040,
    0x40040,
    0x10000040,
    0x10040000,
    0x10001000,
    0x10001040,
    0,
    0x10041040,
    0x41000,
    0x41000,
    0x1040,
    0x1040,
    0x40040,
    0x10000000,
    0x10041000
];
/**
 * Create necessary sub keys.
 *
 * @param key the 64-bit or 192-bit key.
 *
 * @return the expanded keys.
 */ function $16478db66600d911$var$_createKeys(key) {
    var pc2bytes0 = [
        0,
        0x4,
        0x20000000,
        0x20000004,
        0x10000,
        0x10004,
        0x20010000,
        0x20010004,
        0x200,
        0x204,
        0x20000200,
        0x20000204,
        0x10200,
        0x10204,
        0x20010200,
        0x20010204
    ], pc2bytes1 = [
        0,
        0x1,
        0x100000,
        0x100001,
        0x4000000,
        0x4000001,
        0x4100000,
        0x4100001,
        0x100,
        0x101,
        0x100100,
        0x100101,
        0x4000100,
        0x4000101,
        0x4100100,
        0x4100101
    ], pc2bytes2 = [
        0,
        0x8,
        0x800,
        0x808,
        0x1000000,
        0x1000008,
        0x1000800,
        0x1000808,
        0,
        0x8,
        0x800,
        0x808,
        0x1000000,
        0x1000008,
        0x1000800,
        0x1000808
    ], pc2bytes3 = [
        0,
        0x200000,
        0x8000000,
        0x8200000,
        0x2000,
        0x202000,
        0x8002000,
        0x8202000,
        0x20000,
        0x220000,
        0x8020000,
        0x8220000,
        0x22000,
        0x222000,
        0x8022000,
        0x8222000
    ], pc2bytes4 = [
        0,
        0x40000,
        0x10,
        0x40010,
        0,
        0x40000,
        0x10,
        0x40010,
        0x1000,
        0x41000,
        0x1010,
        0x41010,
        0x1000,
        0x41000,
        0x1010,
        0x41010
    ], pc2bytes5 = [
        0,
        0x400,
        0x20,
        0x420,
        0,
        0x400,
        0x20,
        0x420,
        0x2000000,
        0x2000400,
        0x2000020,
        0x2000420,
        0x2000000,
        0x2000400,
        0x2000020,
        0x2000420
    ], pc2bytes6 = [
        0,
        0x10000000,
        0x80000,
        0x10080000,
        0x2,
        0x10000002,
        0x80002,
        0x10080002,
        0,
        0x10000000,
        0x80000,
        0x10080000,
        0x2,
        0x10000002,
        0x80002,
        0x10080002
    ], pc2bytes7 = [
        0,
        0x10000,
        0x800,
        0x10800,
        0x20000000,
        0x20010000,
        0x20000800,
        0x20010800,
        0x20000,
        0x30000,
        0x20800,
        0x30800,
        0x20020000,
        0x20030000,
        0x20020800,
        0x20030800
    ], pc2bytes8 = [
        0,
        0x40000,
        0,
        0x40000,
        0x2,
        0x40002,
        0x2,
        0x40002,
        0x2000000,
        0x2040000,
        0x2000000,
        0x2040000,
        0x2000002,
        0x2040002,
        0x2000002,
        0x2040002
    ], pc2bytes9 = [
        0,
        0x10000000,
        0x8,
        0x10000008,
        0,
        0x10000000,
        0x8,
        0x10000008,
        0x400,
        0x10000400,
        0x408,
        0x10000408,
        0x400,
        0x10000400,
        0x408,
        0x10000408
    ], pc2bytes10 = [
        0,
        0x20,
        0,
        0x20,
        0x100000,
        0x100020,
        0x100000,
        0x100020,
        0x2000,
        0x2020,
        0x2000,
        0x2020,
        0x102000,
        0x102020,
        0x102000,
        0x102020
    ], pc2bytes11 = [
        0,
        0x1000000,
        0x200,
        0x1000200,
        0x200000,
        0x1200000,
        0x200200,
        0x1200200,
        0x4000000,
        0x5000000,
        0x4000200,
        0x5000200,
        0x4200000,
        0x5200000,
        0x4200200,
        0x5200200
    ], pc2bytes12 = [
        0,
        0x1000,
        0x8000000,
        0x8001000,
        0x80000,
        0x81000,
        0x8080000,
        0x8081000,
        0x10,
        0x1010,
        0x8000010,
        0x8001010,
        0x80010,
        0x81010,
        0x8080010,
        0x8081010
    ], pc2bytes13 = [
        0,
        0x4,
        0x100,
        0x104,
        0,
        0x4,
        0x100,
        0x104,
        0x1,
        0x5,
        0x101,
        0x105,
        0x1,
        0x5,
        0x101,
        0x105
    ];
    // how many iterations (1 for des, 3 for triple des)
    // changed by Paul 16/6/2007 to use Triple DES for 9+ byte keys
    var iterations = key.length() > 8 ? 3 : 1;
    // stores the return keys
    var keys = [];
    // now define the left shifts which need to be done
    var shifts = [
        0,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1,
        1,
        1,
        0
    ];
    var n = 0, tmp;
    for(var j = 0; j < iterations; j++){
        var left = key.getInt32();
        var right = key.getInt32();
        tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
        right ^= tmp;
        left ^= tmp << 4;
        tmp = (right >>> -16 ^ left) & 0x0000ffff;
        left ^= tmp;
        right ^= tmp << -16;
        tmp = (left >>> 2 ^ right) & 0x33333333;
        right ^= tmp;
        left ^= tmp << 2;
        tmp = (right >>> -16 ^ left) & 0x0000ffff;
        left ^= tmp;
        right ^= tmp << -16;
        tmp = (left >>> 1 ^ right) & 0x55555555;
        right ^= tmp;
        left ^= tmp << 1;
        tmp = (right >>> 8 ^ left) & 0x00ff00ff;
        left ^= tmp;
        right ^= tmp << 8;
        tmp = (left >>> 1 ^ right) & 0x55555555;
        right ^= tmp;
        left ^= tmp << 1;
        // right needs to be shifted and OR'd with last four bits of left
        tmp = left << 8 | right >>> 20 & 0x000000f0;
        // left needs to be put upside down
        left = right << 24 | right << 8 & 0xff0000 | right >>> 8 & 0xff00 | right >>> 24 & 0xf0;
        right = tmp;
        // now go through and perform these shifts on the left and right keys
        for(var i = 0; i < shifts.length; ++i){
            //shift the keys either one or two bits to the left
            if (shifts[i]) {
                left = left << 2 | left >>> 26;
                right = right << 2 | right >>> 26;
            } else {
                left = left << 1 | left >>> 27;
                right = right << 1 | right >>> 27;
            }
            left &= -15;
            right &= -15;
            // now apply PC-2, in such a way that E is easier when encrypting or
            // decrypting this conversion will look like PC-2 except only the last 6
            // bits of each byte are used rather than 48 consecutive bits and the
            // order of lines will be according to how the S selection functions will
            // be applied: S2, S4, S6, S8, S1, S3, S5, S7
            var lefttmp = pc2bytes0[left >>> 28] | pc2bytes1[left >>> 24 & 0xf] | pc2bytes2[left >>> 20 & 0xf] | pc2bytes3[left >>> 16 & 0xf] | pc2bytes4[left >>> 12 & 0xf] | pc2bytes5[left >>> 8 & 0xf] | pc2bytes6[left >>> 4 & 0xf];
            var righttmp = pc2bytes7[right >>> 28] | pc2bytes8[right >>> 24 & 0xf] | pc2bytes9[right >>> 20 & 0xf] | pc2bytes10[right >>> 16 & 0xf] | pc2bytes11[right >>> 12 & 0xf] | pc2bytes12[right >>> 8 & 0xf] | pc2bytes13[right >>> 4 & 0xf];
            tmp = (righttmp >>> 16 ^ lefttmp) & 0x0000ffff;
            keys[n++] = lefttmp ^ tmp;
            keys[n++] = righttmp ^ tmp << 16;
        }
    }
    return keys;
}
/**
 * Updates a single block (1 byte) using DES. The update will either
 * encrypt or decrypt the block.
 *
 * @param keys the expanded keys.
 * @param input the input block (an array of 32-bit words).
 * @param output the updated output block.
 * @param decrypt true to decrypt the block, false to encrypt it.
 */ function $16478db66600d911$var$_updateBlock(keys, input, output, decrypt) {
    // set up loops for single or triple DES
    var iterations = keys.length === 32 ? 3 : 9;
    var looping;
    if (iterations === 3) looping = decrypt ? [
        30,
        -2,
        -2
    ] : [
        0,
        32,
        2
    ];
    else looping = decrypt ? [
        94,
        62,
        -2,
        32,
        64,
        2,
        30,
        -2,
        -2
    ] : [
        0,
        32,
        2,
        62,
        30,
        -2,
        64,
        96,
        2
    ];
    var tmp;
    var left = input[0];
    var right = input[1];
    // first each 64 bit chunk of the message must be permuted according to IP
    tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
    right ^= tmp;
    left ^= tmp << 4;
    tmp = (left >>> 16 ^ right) & 0x0000ffff;
    right ^= tmp;
    left ^= tmp << 16;
    tmp = (right >>> 2 ^ left) & 0x33333333;
    left ^= tmp;
    right ^= tmp << 2;
    tmp = (right >>> 8 ^ left) & 0x00ff00ff;
    left ^= tmp;
    right ^= tmp << 8;
    tmp = (left >>> 1 ^ right) & 0x55555555;
    right ^= tmp;
    left ^= tmp << 1;
    // rotate left 1 bit
    left = left << 1 | left >>> 31;
    right = right << 1 | right >>> 31;
    for(var j = 0; j < iterations; j += 3){
        var endloop = looping[j + 1];
        var loopinc = looping[j + 2];
        // now go through and perform the encryption or decryption
        for(var i = looping[j]; i != endloop; i += loopinc){
            var right1 = right ^ keys[i];
            var right2 = (right >>> 4 | right << 28) ^ keys[i + 1];
            // passing these bytes through the S selection functions
            tmp = left;
            left = right;
            right = tmp ^ ($16478db66600d911$var$spfunction2[right1 >>> 24 & 0x3f] | $16478db66600d911$var$spfunction4[right1 >>> 16 & 0x3f] | $16478db66600d911$var$spfunction6[right1 >>> 8 & 0x3f] | $16478db66600d911$var$spfunction8[right1 & 0x3f] | $16478db66600d911$var$spfunction1[right2 >>> 24 & 0x3f] | $16478db66600d911$var$spfunction3[right2 >>> 16 & 0x3f] | $16478db66600d911$var$spfunction5[right2 >>> 8 & 0x3f] | $16478db66600d911$var$spfunction7[right2 & 0x3f]);
        }
        // unreverse left and right
        tmp = left;
        left = right;
        right = tmp;
    }
    // rotate right 1 bit
    left = left >>> 1 | left << 31;
    right = right >>> 1 | right << 31;
    // now perform IP-1, which is IP in the opposite direction
    tmp = (left >>> 1 ^ right) & 0x55555555;
    right ^= tmp;
    left ^= tmp << 1;
    tmp = (right >>> 8 ^ left) & 0x00ff00ff;
    left ^= tmp;
    right ^= tmp << 8;
    tmp = (right >>> 2 ^ left) & 0x33333333;
    left ^= tmp;
    right ^= tmp << 2;
    tmp = (left >>> 16 ^ right) & 0x0000ffff;
    right ^= tmp;
    left ^= tmp << 16;
    tmp = (left >>> 4 ^ right) & 0x0f0f0f0f;
    right ^= tmp;
    left ^= tmp << 4;
    output[0] = left;
    output[1] = right;
}
/**
 * Deprecated. Instead, use:
 *
 * forge.cipher.createCipher('DES-<mode>', key);
 * forge.cipher.createDecipher('DES-<mode>', key);
 *
 * Creates a deprecated DES cipher object. This object's mode will default to
 * CBC (cipher-block-chaining).
 *
 * The key may be given as a binary-encoded string of bytes or a byte buffer.
 *
 * @param options the options to use.
 *          key the symmetric key to use (64 or 192 bits).
 *          output the buffer to write to.
 *          decrypt true for decryption, false for encryption.
 *          mode the cipher mode to use (default: 'CBC').
 *
 * @return the cipher.
 */ function $16478db66600d911$var$_createCipher(options) {
    options = options || {};
    var mode = (options.mode || "CBC").toUpperCase();
    var algorithm = "DES-" + mode;
    var cipher;
    if (options.decrypt) cipher = $2xc86.cipher.createDecipher(algorithm, options.key);
    else cipher = $2xc86.cipher.createCipher(algorithm, options.key);
    // backwards compatible start API
    var start = cipher.start;
    cipher.start = function(iv, options) {
        // backwards compatibility: support second arg as output buffer
        var output = null;
        if (options instanceof $2xc86.util.ByteBuffer) {
            output = options;
            options = {};
        }
        options = options || {};
        options.output = output;
        options.iv = iv;
        start.call(cipher, options);
    };
    return cipher;
}

});

parcelRequire.register("1x89g", function(module, exports) {
/**
 * Javascript implementation of basic PEM (Privacy Enhanced Mail) algorithms.
 *
 * See: RFC 1421.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2013-2014 Digital Bazaar, Inc.
 *
 * A Forge PEM object has the following fields:
 *
 * type: identifies the type of message (eg: "RSA PRIVATE KEY").
 *
 * procType: identifies the type of processing performed on the message,
 *   it has two subfields: version and type, eg: 4,ENCRYPTED.
 *
 * contentDomain: identifies the type of content in the message, typically
 *   only uses the value: "RFC822".
 *
 * dekInfo: identifies the message encryption algorithm and mode and includes
 *   any parameters for the algorithm, it has two subfields: algorithm and
 *   parameters, eg: DES-CBC,F8143EDE5960C597.
 *
 * headers: contains all other PEM encapsulated headers -- where order is
 *   significant (for pairing data like recipient ID + key info).
 *
 * body: the binary-encoded body.
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("e73pV");
// shortcut for pem API
var $11df31a448f6e0e6$var$pem = module.exports = $2xc86.pem = $2xc86.pem || {};
/**
 * Encodes (serializes) the given PEM object.
 *
 * @param msg the PEM message object to encode.
 * @param options the options to use:
 *          maxline the maximum characters per line for the body, (default: 64).
 *
 * @return the PEM-formatted string.
 */ $11df31a448f6e0e6$var$pem.encode = function(msg, options) {
    options = options || {};
    var rval = "-----BEGIN " + msg.type + "-----\r\n";
    // encode special headers
    var header;
    if (msg.procType) {
        header = {
            name: "Proc-Type",
            values: [
                String(msg.procType.version),
                msg.procType.type
            ]
        };
        rval += $11df31a448f6e0e6$var$foldHeader(header);
    }
    if (msg.contentDomain) {
        header = {
            name: "Content-Domain",
            values: [
                msg.contentDomain
            ]
        };
        rval += $11df31a448f6e0e6$var$foldHeader(header);
    }
    if (msg.dekInfo) {
        header = {
            name: "DEK-Info",
            values: [
                msg.dekInfo.algorithm
            ]
        };
        if (msg.dekInfo.parameters) header.values.push(msg.dekInfo.parameters);
        rval += $11df31a448f6e0e6$var$foldHeader(header);
    }
    if (msg.headers) // encode all other headers
    for(var i = 0; i < msg.headers.length; ++i)rval += $11df31a448f6e0e6$var$foldHeader(msg.headers[i]);
    // terminate header
    if (msg.procType) rval += "\r\n";
    // add body
    rval += $2xc86.util.encode64(msg.body, options.maxline || 64) + "\r\n";
    rval += "-----END " + msg.type + "-----\r\n";
    return rval;
};
/**
 * Decodes (deserializes) all PEM messages found in the given string.
 *
 * @param str the PEM-formatted string to decode.
 *
 * @return the PEM message objects in an array.
 */ $11df31a448f6e0e6$var$pem.decode = function(str) {
    var rval = [];
    // split string into PEM messages (be lenient w/EOF on BEGIN line)
    var rMessage = /\s*-----BEGIN ([A-Z0-9- ]+)-----\r?\n?([\x21-\x7e\s]+?(?:\r?\n\r?\n))?([:A-Za-z0-9+\/=\s]+?)-----END \1-----/g;
    var rHeader = /([\x21-\x7e]+):\s*([\x21-\x7e\s^:]+)/;
    var rCRLF = /\r?\n/;
    var match;
    while(true){
        match = rMessage.exec(str);
        if (!match) break;
        var msg = {
            type: match[1],
            procType: null,
            contentDomain: null,
            dekInfo: null,
            headers: [],
            body: $2xc86.util.decode64(match[3])
        };
        rval.push(msg);
        // no headers
        if (!match[2]) continue;
        // parse headers
        var lines = match[2].split(rCRLF);
        var li = 0;
        while(match && li < lines.length){
            // get line, trim any rhs whitespace
            var line = lines[li].replace(/\s+$/, "");
            // RFC2822 unfold any following folded lines
            for(var nl = li + 1; nl < lines.length; ++nl){
                var next = lines[nl];
                if (!/\s/.test(next[0])) break;
                line += next;
                li = nl;
            }
            // parse header
            match = line.match(rHeader);
            if (match) {
                var header = {
                    name: match[1],
                    values: []
                };
                var values = match[2].split(",");
                for(var vi = 0; vi < values.length; ++vi)header.values.push($11df31a448f6e0e6$var$ltrim(values[vi]));
                // Proc-Type must be the first header
                if (!msg.procType) {
                    if (header.name !== "Proc-Type") throw new Error('Invalid PEM formatted message. The first encapsulated header must be "Proc-Type".');
                    else if (header.values.length !== 2) throw new Error('Invalid PEM formatted message. The "Proc-Type" header must have two subfields.');
                    msg.procType = {
                        version: values[0],
                        type: values[1]
                    };
                } else if (!msg.contentDomain && header.name === "Content-Domain") // special-case Content-Domain
                msg.contentDomain = values[0] || "";
                else if (!msg.dekInfo && header.name === "DEK-Info") {
                    // special-case DEK-Info
                    if (header.values.length === 0) throw new Error('Invalid PEM formatted message. The "DEK-Info" header must have at least one subfield.');
                    msg.dekInfo = {
                        algorithm: values[0],
                        parameters: values[1] || null
                    };
                } else msg.headers.push(header);
            }
            ++li;
        }
        if (msg.procType === "ENCRYPTED" && !msg.dekInfo) throw new Error('Invalid PEM formatted message. The "DEK-Info" header must be present if "Proc-Type" is "ENCRYPTED".');
    }
    if (rval.length === 0) throw new Error("Invalid PEM formatted message.");
    return rval;
};
function $11df31a448f6e0e6$var$foldHeader(header) {
    var rval = header.name + ": ";
    // ensure values with CRLF are folded
    var values = [];
    var insertSpace = function(match, $1) {
        return " " + $1;
    };
    for(var i = 0; i < header.values.length; ++i)values.push(header.values[i].replace(/^(\S+\r\n)/, insertSpace));
    rval += values.join(",") + "\r\n";
    // do folding
    var length = 0;
    var candidate = -1;
    for(var i = 0; i < rval.length; ++i, ++length){
        if (length > 65 && candidate !== -1) {
            var insert = rval[candidate];
            if (insert === ",") {
                ++candidate;
                rval = rval.substr(0, candidate) + "\r\n " + rval.substr(candidate);
            } else rval = rval.substr(0, candidate) + "\r\n" + insert + rval.substr(candidate + 1);
            length = i - candidate - 1;
            candidate = -1;
            ++i;
        } else if (rval[i] === " " || rval[i] === "	" || rval[i] === ",") candidate = i;
    }
    return rval;
}
function $11df31a448f6e0e6$var$ltrim(str) {
    return str.replace(/^\s+/, "");
}

});

parcelRequire.register("hZ2Gb", function(module, exports) {
/**
 * Javascript implementation of ASN.1 validators for PKCS#7 v1.5.
 *
 * @author Dave Longley
 * @author Stefan Siegl
 *
 * Copyright (c) 2012-2015 Digital Bazaar, Inc.
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * The ASN.1 representation of PKCS#7 is as follows
 * (see RFC #2315 for details, http://www.ietf.org/rfc/rfc2315.txt):
 *
 * A PKCS#7 message consists of a ContentInfo on root level, which may
 * contain any number of further ContentInfo nested into it.
 *
 * ContentInfo ::= SEQUENCE {
 *   contentType                ContentType,
 *   content               [0]  EXPLICIT ANY DEFINED BY contentType OPTIONAL
 * }
 *
 * ContentType ::= OBJECT IDENTIFIER
 *
 * EnvelopedData ::= SEQUENCE {
 *   version                    Version,
 *   recipientInfos             RecipientInfos,
 *   encryptedContentInfo       EncryptedContentInfo
 * }
 *
 * EncryptedData ::= SEQUENCE {
 *   version                    Version,
 *   encryptedContentInfo       EncryptedContentInfo
 * }
 *
 * id-signedData OBJECT IDENTIFIER ::= { iso(1) member-body(2)
 *   us(840) rsadsi(113549) pkcs(1) pkcs7(7) 2 }
 *
 * SignedData ::= SEQUENCE {
 *   version           INTEGER,
 *   digestAlgorithms  DigestAlgorithmIdentifiers,
 *   contentInfo       ContentInfo,
 *   certificates      [0] IMPLICIT Certificates OPTIONAL,
 *   crls              [1] IMPLICIT CertificateRevocationLists OPTIONAL,
 *   signerInfos       SignerInfos
 * }
 *
 * SignerInfos ::= SET OF SignerInfo
 *
 * SignerInfo ::= SEQUENCE {
 *   version                    Version,
 *   issuerAndSerialNumber      IssuerAndSerialNumber,
 *   digestAlgorithm            DigestAlgorithmIdentifier,
 *   authenticatedAttributes    [0] IMPLICIT Attributes OPTIONAL,
 *   digestEncryptionAlgorithm  DigestEncryptionAlgorithmIdentifier,
 *   encryptedDigest            EncryptedDigest,
 *   unauthenticatedAttributes  [1] IMPLICIT Attributes OPTIONAL
 * }
 *
 * EncryptedDigest ::= OCTET STRING
 *
 * Attributes ::= SET OF Attribute
 *
 * Attribute ::= SEQUENCE {
 *   attrType    OBJECT IDENTIFIER,
 *   attrValues  SET OF AttributeValue
 * }
 *
 * AttributeValue ::= ANY
 *
 * Version ::= INTEGER
 *
 * RecipientInfos ::= SET OF RecipientInfo
 *
 * EncryptedContentInfo ::= SEQUENCE {
 *   contentType                 ContentType,
 *   contentEncryptionAlgorithm  ContentEncryptionAlgorithmIdentifier,
 *   encryptedContent       [0]  IMPLICIT EncryptedContent OPTIONAL
 * }
 *
 * ContentEncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
 *
 * The AlgorithmIdentifier contains an Object Identifier (OID) and parameters
 * for the algorithm, if any. In the case of AES and DES3, there is only one,
 * the IV.
 *
 * AlgorithmIdentifer ::= SEQUENCE {
 *    algorithm OBJECT IDENTIFIER,
 *    parameters ANY DEFINED BY algorithm OPTIONAL
 * }
 *
 * EncryptedContent ::= OCTET STRING
 *
 * RecipientInfo ::= SEQUENCE {
 *   version                     Version,
 *   issuerAndSerialNumber       IssuerAndSerialNumber,
 *   keyEncryptionAlgorithm      KeyEncryptionAlgorithmIdentifier,
 *   encryptedKey                EncryptedKey
 * }
 *
 * IssuerAndSerialNumber ::= SEQUENCE {
 *   issuer                      Name,
 *   serialNumber                CertificateSerialNumber
 * }
 *
 * CertificateSerialNumber ::= INTEGER
 *
 * KeyEncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
 *
 * EncryptedKey ::= OCTET STRING
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("l46Tq");
parcelRequire("e73pV");
// shortcut for ASN.1 API
var $d17a363daaa59e15$var$asn1 = $2xc86.asn1;
// shortcut for PKCS#7 API
var $d17a363daaa59e15$var$p7v = module.exports = $2xc86.pkcs7asn1 = $2xc86.pkcs7asn1 || {};
$2xc86.pkcs7 = $2xc86.pkcs7 || {};
$2xc86.pkcs7.asn1 = $d17a363daaa59e15$var$p7v;
var $d17a363daaa59e15$var$contentInfoValidator = {
    name: "ContentInfo",
    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
    type: $d17a363daaa59e15$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "ContentInfo.ContentType",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.OID,
            constructed: false,
            capture: "contentType"
        },
        {
            name: "ContentInfo.content",
            tagClass: $d17a363daaa59e15$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            constructed: true,
            optional: true,
            captureAsn1: "content"
        }
    ]
};
$d17a363daaa59e15$var$p7v.contentInfoValidator = $d17a363daaa59e15$var$contentInfoValidator;
var $d17a363daaa59e15$var$encryptedContentInfoValidator = {
    name: "EncryptedContentInfo",
    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
    type: $d17a363daaa59e15$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "EncryptedContentInfo.contentType",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.OID,
            constructed: false,
            capture: "contentType"
        },
        {
            name: "EncryptedContentInfo.contentEncryptionAlgorithm",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "EncryptedContentInfo.contentEncryptionAlgorithm.algorithm",
                    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
                    type: $d17a363daaa59e15$var$asn1.Type.OID,
                    constructed: false,
                    capture: "encAlgorithm"
                },
                {
                    name: "EncryptedContentInfo.contentEncryptionAlgorithm.parameter",
                    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
                    captureAsn1: "encParameter"
                }
            ]
        },
        {
            name: "EncryptedContentInfo.encryptedContent",
            tagClass: $d17a363daaa59e15$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            /* The PKCS#7 structure output by OpenSSL somewhat differs from what
     * other implementations do generate.
     *
     * OpenSSL generates a structure like this:
     * SEQUENCE {
     *    ...
     *    [0]
     *       26 DA 67 D2 17 9C 45 3C B1 2A A8 59 2F 29 33 38
     *       C3 C3 DF 86 71 74 7A 19 9F 40 D0 29 BE 85 90 45
     *       ...
     * }
     *
     * Whereas other implementations (and this PKCS#7 module) generate:
     * SEQUENCE {
     *    ...
     *    [0] {
     *       OCTET STRING
     *          26 DA 67 D2 17 9C 45 3C B1 2A A8 59 2F 29 33 38
     *          C3 C3 DF 86 71 74 7A 19 9F 40 D0 29 BE 85 90 45
     *          ...
     *    }
     * }
     *
     * In order to support both, we just capture the context specific
     * field here.  The OCTET STRING bit is removed below.
     */ capture: "encryptedContent",
            captureAsn1: "encryptedContentAsn1"
        }
    ]
};
$d17a363daaa59e15$var$p7v.envelopedDataValidator = {
    name: "EnvelopedData",
    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
    type: $d17a363daaa59e15$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "EnvelopedData.Version",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "version"
        },
        {
            name: "EnvelopedData.RecipientInfos",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.SET,
            constructed: true,
            captureAsn1: "recipientInfos"
        }
    ].concat($d17a363daaa59e15$var$encryptedContentInfoValidator)
};
$d17a363daaa59e15$var$p7v.encryptedDataValidator = {
    name: "EncryptedData",
    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
    type: $d17a363daaa59e15$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "EncryptedData.Version",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "version"
        }
    ].concat($d17a363daaa59e15$var$encryptedContentInfoValidator)
};
var $d17a363daaa59e15$var$signerValidator = {
    name: "SignerInfo",
    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
    type: $d17a363daaa59e15$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "SignerInfo.version",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.INTEGER,
            constructed: false
        },
        {
            name: "SignerInfo.issuerAndSerialNumber",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "SignerInfo.issuerAndSerialNumber.issuer",
                    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
                    type: $d17a363daaa59e15$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "issuer"
                },
                {
                    name: "SignerInfo.issuerAndSerialNumber.serialNumber",
                    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
                    type: $d17a363daaa59e15$var$asn1.Type.INTEGER,
                    constructed: false,
                    capture: "serial"
                }
            ]
        },
        {
            name: "SignerInfo.digestAlgorithm",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "SignerInfo.digestAlgorithm.algorithm",
                    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
                    type: $d17a363daaa59e15$var$asn1.Type.OID,
                    constructed: false,
                    capture: "digestAlgorithm"
                },
                {
                    name: "SignerInfo.digestAlgorithm.parameter",
                    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
                    constructed: false,
                    captureAsn1: "digestParameter",
                    optional: true
                }
            ]
        },
        {
            name: "SignerInfo.authenticatedAttributes",
            tagClass: $d17a363daaa59e15$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            constructed: true,
            optional: true,
            capture: "authenticatedAttributes"
        },
        {
            name: "SignerInfo.digestEncryptionAlgorithm",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.SEQUENCE,
            constructed: true,
            capture: "signatureAlgorithm"
        },
        {
            name: "SignerInfo.encryptedDigest",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "signature"
        },
        {
            name: "SignerInfo.unauthenticatedAttributes",
            tagClass: $d17a363daaa59e15$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 1,
            constructed: true,
            optional: true,
            capture: "unauthenticatedAttributes"
        }
    ]
};
$d17a363daaa59e15$var$p7v.signedDataValidator = {
    name: "SignedData",
    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
    type: $d17a363daaa59e15$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "SignedData.Version",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "version"
        },
        {
            name: "SignedData.DigestAlgorithms",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.SET,
            constructed: true,
            captureAsn1: "digestAlgorithms"
        },
        $d17a363daaa59e15$var$contentInfoValidator,
        {
            name: "SignedData.Certificates",
            tagClass: $d17a363daaa59e15$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            optional: true,
            captureAsn1: "certificates"
        },
        {
            name: "SignedData.CertificateRevocationLists",
            tagClass: $d17a363daaa59e15$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 1,
            optional: true,
            captureAsn1: "crls"
        },
        {
            name: "SignedData.SignerInfos",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.SET,
            capture: "signerInfos",
            optional: true,
            value: [
                $d17a363daaa59e15$var$signerValidator
            ]
        }
    ]
};
$d17a363daaa59e15$var$p7v.recipientInfoValidator = {
    name: "RecipientInfo",
    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
    type: $d17a363daaa59e15$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "RecipientInfo.version",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "version"
        },
        {
            name: "RecipientInfo.issuerAndSerial",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "RecipientInfo.issuerAndSerial.issuer",
                    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
                    type: $d17a363daaa59e15$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "issuer"
                },
                {
                    name: "RecipientInfo.issuerAndSerial.serialNumber",
                    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
                    type: $d17a363daaa59e15$var$asn1.Type.INTEGER,
                    constructed: false,
                    capture: "serial"
                }
            ]
        },
        {
            name: "RecipientInfo.keyEncryptionAlgorithm",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "RecipientInfo.keyEncryptionAlgorithm.algorithm",
                    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
                    type: $d17a363daaa59e15$var$asn1.Type.OID,
                    constructed: false,
                    capture: "encAlgorithm"
                },
                {
                    name: "RecipientInfo.keyEncryptionAlgorithm.parameter",
                    tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
                    constructed: false,
                    captureAsn1: "encParameter"
                }
            ]
        },
        {
            name: "RecipientInfo.encryptedKey",
            tagClass: $d17a363daaa59e15$var$asn1.Class.UNIVERSAL,
            type: $d17a363daaa59e15$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "encKey"
        }
    ]
};

});

parcelRequire.register("eeWuT", function(module, exports) {
/**
 * An API for getting cryptographically-secure random bytes. The bytes are
 * generated using the Fortuna algorithm devised by Bruce Schneier and
 * Niels Ferguson.
 *
 * Getting strong random bytes is not yet easy to do in javascript. The only
 * truish random entropy that can be collected is from the mouse, keyboard, or
 * from timing with respect to page loads, etc. This generator makes a poor
 * attempt at providing random bytes when those sources haven't yet provided
 * enough entropy to initially seed or to reseed the PRNG.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2009-2014 Digital Bazaar, Inc.
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("a7tnS");
parcelRequire("kS1H5");
parcelRequire("cnhkf");
parcelRequire("e73pV");
(function() {
    // forge.random already defined
    if ($2xc86.random && $2xc86.random.getBytes) {
        module.exports = $2xc86.random;
        return;
    }
    (function(jQuery1) {
        // the default prng plugin, uses AES-128
        var prng_aes = {};
        var _prng_aes_output = new Array(4);
        var _prng_aes_buffer = $2xc86.util.createBuffer();
        prng_aes.formatKey = function(key) {
            // convert the key into 32-bit integers
            var tmp = $2xc86.util.createBuffer(key);
            key = new Array(4);
            key[0] = tmp.getInt32();
            key[1] = tmp.getInt32();
            key[2] = tmp.getInt32();
            key[3] = tmp.getInt32();
            // return the expanded key
            return $2xc86.aes._expandKey(key, false);
        };
        prng_aes.formatSeed = function(seed) {
            // convert seed into 32-bit integers
            var tmp = $2xc86.util.createBuffer(seed);
            seed = new Array(4);
            seed[0] = tmp.getInt32();
            seed[1] = tmp.getInt32();
            seed[2] = tmp.getInt32();
            seed[3] = tmp.getInt32();
            return seed;
        };
        prng_aes.cipher = function(key, seed) {
            $2xc86.aes._updateBlock(key, seed, _prng_aes_output, false);
            _prng_aes_buffer.putInt32(_prng_aes_output[0]);
            _prng_aes_buffer.putInt32(_prng_aes_output[1]);
            _prng_aes_buffer.putInt32(_prng_aes_output[2]);
            _prng_aes_buffer.putInt32(_prng_aes_output[3]);
            return _prng_aes_buffer.getBytes();
        };
        prng_aes.increment = function(seed) {
            // FIXME: do we care about carry or signed issues?
            ++seed[3];
            return seed;
        };
        prng_aes.md = $2xc86.md.sha256;
        /**
 * Creates a new PRNG.
 */ function spawnPrng() {
            var ctx = $2xc86.prng.create(prng_aes);
            /**
   * Gets random bytes. If a native secure crypto API is unavailable, this
   * method tries to make the bytes more unpredictable by drawing from data that
   * can be collected from the user of the browser, eg: mouse movement.
   *
   * If a callback is given, this method will be called asynchronously.
   *
   * @param count the number of random bytes to get.
   * @param [callback(err, bytes)] called once the operation completes.
   *
   * @return the random bytes in a string.
   */ ctx.getBytes = function(count, callback) {
                return ctx.generate(count, callback);
            };
            /**
   * Gets random bytes asynchronously. If a native secure crypto API is
   * unavailable, this method tries to make the bytes more unpredictable by
   * drawing from data that can be collected from the user of the browser,
   * eg: mouse movement.
   *
   * @param count the number of random bytes to get.
   *
   * @return the random bytes in a string.
   */ ctx.getBytesSync = function(count) {
                return ctx.generate(count);
            };
            return ctx;
        }
        // create default prng context
        var _ctx = spawnPrng();
        // add other sources of entropy only if window.crypto.getRandomValues is not
        // available -- otherwise this source will be automatically used by the prng
        var getRandomValues = null;
        var globalScope = $2xc86.util.globalScope;
        var _crypto = globalScope.crypto || globalScope.msCrypto;
        if (_crypto && _crypto.getRandomValues) getRandomValues = function(arr) {
            return _crypto.getRandomValues(arr);
        };
        if ($2xc86.options.usePureJavaScript || !$2xc86.util.isNodejs && !getRandomValues) {
            typeof window === "undefined" || window.document;
            // get load time entropy
            _ctx.collectInt(+new Date(), 32);
            // add some entropy from navigator object
            if (typeof navigator !== "undefined") {
                var _navBytes = "";
                for(var key in navigator)try {
                    if (typeof navigator[key] == "string") _navBytes += navigator[key];
                } catch (e) {
                /* Some navigator keys might not be accessible, e.g. the geolocation
          attribute throws an exception if touched in Mozilla chrome://
          context.

          Silently ignore this and just don't use this as a source of
          entropy. */ }
                _ctx.collect(_navBytes);
                _navBytes = null;
            }
            // add mouse and keyboard collectors if jquery is available
            if (jQuery1) {
                // set up mouse entropy capture
                jQuery1().mousemove(function(e) {
                    // add mouse coords
                    _ctx.collectInt(e.clientX, 16);
                    _ctx.collectInt(e.clientY, 16);
                });
                // set up keyboard entropy capture
                jQuery1().keypress(function(e) {
                    _ctx.collectInt(e.charCode, 8);
                });
            }
        }
        /* Random API */ if (!$2xc86.random) $2xc86.random = _ctx;
        else // extend forge.random with _ctx
        for(var key in _ctx)$2xc86.random[key] = _ctx[key];
        // expose spawn PRNG
        $2xc86.random.createInstance = spawnPrng;
        module.exports = $2xc86.random;
    })(typeof jQuery !== "undefined" ? jQuery : null);
})();

});
parcelRequire.register("kS1H5", function(module, exports) {
/**
 * Secure Hash Algorithm with 256-bit digest (SHA-256) implementation.
 *
 * See FIPS 180-2 for details.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2015 Digital Bazaar, Inc.
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("eeecL");
parcelRequire("e73pV");
var $f31a2a3348cec4a2$var$sha256 = module.exports = $2xc86.sha256 = $2xc86.sha256 || {};
$2xc86.md.sha256 = $2xc86.md.algorithms.sha256 = $f31a2a3348cec4a2$var$sha256;
/**
 * Creates a SHA-256 message digest object.
 *
 * @return a message digest object.
 */ $f31a2a3348cec4a2$var$sha256.create = function() {
    // do initialization as necessary
    if (!$f31a2a3348cec4a2$var$_initialized) $f31a2a3348cec4a2$var$_init();
    // SHA-256 state contains eight 32-bit integers
    var _state = null;
    // input buffer
    var _input = $2xc86.util.createBuffer();
    // used for word storage
    var _w = new Array(64);
    // message digest object
    var md = {
        algorithm: "sha256",
        blockLength: 64,
        digestLength: 32,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 8
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength64 for backwards-compatibility)
        md.fullMessageLength = md.messageLength64 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $2xc86.util.createBuffer();
        _state = {
            h0: 0x6A09E667,
            h1: 0xBB67AE85,
            h2: 0x3C6EF372,
            h3: 0xA54FF53A,
            h4: 0x510E527F,
            h5: 0x9B05688C,
            h6: 0x1F83D9AB,
            h7: 0x5BE0CD19
        };
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === "utf8") msg = $2xc86.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $f31a2a3348cec4a2$var$_update(_state, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate SHA-256 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 448 mod 512. In other words,
    the data to be digested must be a multiple of 512 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 8 bytes (64
    bits), that means that the last segment of the data must have 56 bytes
    (448 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 448 mod 512 because
    512 - 128 = 448.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 448 mod 512, then 512 padding bits must be added. */ var finalBlock = $2xc86.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($f31a2a3348cec4a2$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in big-endian order; since length
        // is stored in bytes we multiply by 8 and add carry from next int
        var next, carry;
        var bits = md.fullMessageLength[0] * 8;
        for(var i = 0; i < md.fullMessageLength.length - 1; ++i){
            next = md.fullMessageLength[i + 1] * 8;
            carry = next / 0x100000000 >>> 0;
            bits += carry;
            finalBlock.putInt32(bits >>> 0);
            bits = next >>> 0;
        }
        finalBlock.putInt32(bits);
        var s2 = {
            h0: _state.h0,
            h1: _state.h1,
            h2: _state.h2,
            h3: _state.h3,
            h4: _state.h4,
            h5: _state.h5,
            h6: _state.h6,
            h7: _state.h7
        };
        $f31a2a3348cec4a2$var$_update(s2, _w, finalBlock);
        var rval = $2xc86.util.createBuffer();
        rval.putInt32(s2.h0);
        rval.putInt32(s2.h1);
        rval.putInt32(s2.h2);
        rval.putInt32(s2.h3);
        rval.putInt32(s2.h4);
        rval.putInt32(s2.h5);
        rval.putInt32(s2.h6);
        rval.putInt32(s2.h7);
        return rval;
    };
    return md;
};
// sha-256 padding bytes not initialized yet
var $f31a2a3348cec4a2$var$_padding = null;
var $f31a2a3348cec4a2$var$_initialized = false;
// table of constants
var $f31a2a3348cec4a2$var$_k = null;
/**
 * Initializes the constant tables.
 */ function $f31a2a3348cec4a2$var$_init() {
    // create padding
    $f31a2a3348cec4a2$var$_padding = String.fromCharCode(128);
    $f31a2a3348cec4a2$var$_padding += $2xc86.util.fillString(String.fromCharCode(0x00), 64);
    // create K table for SHA-256
    $f31a2a3348cec4a2$var$_k = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    // now initialized
    $f31a2a3348cec4a2$var$_initialized = true;
}
/**
 * Updates a SHA-256 state with the given byte buffer.
 *
 * @param s the SHA-256 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $f31a2a3348cec4a2$var$_update(s, w, bytes) {
    // consume 512 bit (64 byte) chunks
    var t1, t2, s0, s1, ch, maj, i, a, b, c, d, e, f, g, h;
    var len = bytes.length();
    while(len >= 64){
        // the w array will be populated with sixteen 32-bit big-endian words
        // and then extended into 64 32-bit words according to SHA-256
        for(i = 0; i < 16; ++i)w[i] = bytes.getInt32();
        for(; i < 64; ++i){
            // XOR word 2 words ago rot right 17, rot right 19, shft right 10
            t1 = w[i - 2];
            t1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            // XOR word 15 words ago rot right 7, rot right 18, shft right 3
            t2 = w[i - 15];
            t2 = (t2 >>> 7 | t2 << 25) ^ (t2 >>> 18 | t2 << 14) ^ t2 >>> 3;
            // sum(t1, word 7 ago, t2, word 16 ago) modulo 2^32
            w[i] = t1 + w[i - 7] + t2 + w[i - 16] | 0;
        }
        // initialize hash value for this chunk
        a = s.h0;
        b = s.h1;
        c = s.h2;
        d = s.h3;
        e = s.h4;
        f = s.h5;
        g = s.h6;
        h = s.h7;
        // round function
        for(i = 0; i < 64; ++i){
            // Sum1(e)
            s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
            // Ch(e, f, g) (optimized the same way as SHA-1)
            ch = g ^ e & (f ^ g);
            // Sum0(a)
            s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
            // Maj(a, b, c) (optimized the same way as SHA-1)
            maj = a & b | c & (a ^ b);
            // main algorithm
            t1 = h + s1 + ch + $f31a2a3348cec4a2$var$_k[i] + w[i];
            t2 = s0 + maj;
            h = g;
            g = f;
            f = e;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            // can't truncate with `| 0`
            e = d + t1 >>> 0;
            d = c;
            c = b;
            b = a;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            // can't truncate with `| 0`
            a = t1 + t2 >>> 0;
        }
        // update hash state
        s.h0 = s.h0 + a | 0;
        s.h1 = s.h1 + b | 0;
        s.h2 = s.h2 + c | 0;
        s.h3 = s.h3 + d | 0;
        s.h4 = s.h4 + e | 0;
        s.h5 = s.h5 + f | 0;
        s.h6 = s.h6 + g | 0;
        s.h7 = s.h7 + h | 0;
        len -= 64;
    }
}

});
parcelRequire.register("eeecL", function(module, exports) {
/**
 * Node.js module for Forge message digests.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2017 Digital Bazaar, Inc.
 */ 
var $2xc86 = parcelRequire("2xc86");
module.exports = $2xc86.md = $2xc86.md || {};
$2xc86.md.algorithms = $2xc86.md.algorithms || {};

});


parcelRequire.register("cnhkf", function(module, exports) {
/**
 * A javascript implementation of a cryptographically-secure
 * Pseudo Random Number Generator (PRNG). The Fortuna algorithm is followed
 * here though the use of SHA-256 is not enforced; when generating an
 * a PRNG context, the hashing algorithm and block cipher used for
 * the generator are specified via a plugin.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 */ 
var $7jzxY = parcelRequire("7jzxY");

var $2xc86 = parcelRequire("2xc86");
parcelRequire("e73pV");
var $9025128614e53554$var$_crypto = null;

if ($2xc86.util.isNodejs && !$2xc86.options.usePureJavaScript && !$7jzxY.versions["node-webkit"]) $9025128614e53554$var$_crypto = (parcelRequire("7jzxY"));
/* PRNG API */ var $9025128614e53554$var$prng = module.exports = $2xc86.prng = $2xc86.prng || {};
/**
 * Creates a new PRNG context.
 *
 * A PRNG plugin must be passed in that will provide:
 *
 * 1. A function that initializes the key and seed of a PRNG context. It
 *   will be given a 16 byte key and a 16 byte seed. Any key expansion
 *   or transformation of the seed from a byte string into an array of
 *   integers (or similar) should be performed.
 * 2. The cryptographic function used by the generator. It takes a key and
 *   a seed.
 * 3. A seed increment function. It takes the seed and returns seed + 1.
 * 4. An api to create a message digest.
 *
 * For an example, see random.js.
 *
 * @param plugin the PRNG plugin to use.
 */ $9025128614e53554$var$prng.create = function(plugin) {
    var ctx = {
        plugin: plugin,
        key: null,
        seed: null,
        time: null,
        // number of reseeds so far
        reseeds: 0,
        // amount of data generated so far
        generated: 0,
        // no initial key bytes
        keyBytes: ""
    };
    // create 32 entropy pools (each is a message digest)
    var md = plugin.md;
    var pools = new Array(32);
    for(var i = 0; i < 32; ++i)pools[i] = md.create();
    ctx.pools = pools;
    // entropy pools are written to cyclically, starting at index 0
    ctx.pool = 0;
    /**
   * Generates random bytes. The bytes may be generated synchronously or
   * asynchronously. Web workers must use the asynchronous interface or
   * else the behavior is undefined.
   *
   * @param count the number of random bytes to generate.
   * @param [callback(err, bytes)] called once the operation completes.
   *
   * @return count random bytes as a string.
   */ ctx.generate = function(count, callback) {
        // do synchronously
        if (!callback) return ctx.generateSync(count);
        // simple generator using counter-based CBC
        var cipher = ctx.plugin.cipher;
        var increment = ctx.plugin.increment;
        var formatKey = ctx.plugin.formatKey;
        var formatSeed = ctx.plugin.formatSeed;
        var b = $2xc86.util.createBuffer();
        // paranoid deviation from Fortuna:
        // reset key for every request to protect previously
        // generated random bytes should the key be discovered;
        // there is no 100ms based reseeding because of this
        // forced reseed for every `generate` call
        ctx.key = null;
        generate();
        function generate(err) {
            if (err) return callback(err);
            // sufficient bytes generated
            if (b.length() >= count) return callback(null, b.getBytes(count));
            // if amount of data generated is greater than 1 MiB, trigger reseed
            if (ctx.generated > 0xfffff) ctx.key = null;
            if (ctx.key === null) // prevent stack overflow
            return $2xc86.util.nextTick(function() {
                _reseed(generate);
            });
            // generate the random bytes
            var bytes = cipher(ctx.key, ctx.seed);
            ctx.generated += bytes.length;
            b.putBytes(bytes);
            // generate bytes for a new key and seed
            ctx.key = formatKey(cipher(ctx.key, increment(ctx.seed)));
            ctx.seed = formatSeed(cipher(ctx.key, ctx.seed));
            $2xc86.util.setImmediate(generate);
        }
    };
    /**
   * Generates random bytes synchronously.
   *
   * @param count the number of random bytes to generate.
   *
   * @return count random bytes as a string.
   */ ctx.generateSync = function(count) {
        // simple generator using counter-based CBC
        var cipher = ctx.plugin.cipher;
        var increment = ctx.plugin.increment;
        var formatKey = ctx.plugin.formatKey;
        var formatSeed = ctx.plugin.formatSeed;
        // paranoid deviation from Fortuna:
        // reset key for every request to protect previously
        // generated random bytes should the key be discovered;
        // there is no 100ms based reseeding because of this
        // forced reseed for every `generateSync` call
        ctx.key = null;
        var b = $2xc86.util.createBuffer();
        while(b.length() < count){
            // if amount of data generated is greater than 1 MiB, trigger reseed
            if (ctx.generated > 0xfffff) ctx.key = null;
            if (ctx.key === null) _reseedSync();
            // generate the random bytes
            var bytes = cipher(ctx.key, ctx.seed);
            ctx.generated += bytes.length;
            b.putBytes(bytes);
            // generate bytes for a new key and seed
            ctx.key = formatKey(cipher(ctx.key, increment(ctx.seed)));
            ctx.seed = formatSeed(cipher(ctx.key, ctx.seed));
        }
        return b.getBytes(count);
    };
    /**
   * Private function that asynchronously reseeds a generator.
   *
   * @param callback(err) called once the operation completes.
   */ function _reseed(callback) {
        if (ctx.pools[0].messageLength >= 32) {
            _seed();
            return callback();
        }
        // not enough seed data...
        var needed = 32 - ctx.pools[0].messageLength << 5;
        ctx.seedFile(needed, function(err, bytes) {
            if (err) return callback(err);
            ctx.collect(bytes);
            _seed();
            callback();
        });
    }
    /**
   * Private function that synchronously reseeds a generator.
   */ function _reseedSync() {
        if (ctx.pools[0].messageLength >= 32) return _seed();
        // not enough seed data...
        var needed = 32 - ctx.pools[0].messageLength << 5;
        ctx.collect(ctx.seedFileSync(needed));
        _seed();
    }
    /**
   * Private function that seeds a generator once enough bytes are available.
   */ function _seed() {
        // update reseed count
        ctx.reseeds = ctx.reseeds === 0xffffffff ? 0 : ctx.reseeds + 1;
        // goal is to update `key` via:
        // key = hash(key + s)
        //   where 's' is all collected entropy from selected pools, then...
        // create a plugin-based message digest
        var md = ctx.plugin.md.create();
        // consume current key bytes
        md.update(ctx.keyBytes);
        // digest the entropy of pools whose index k meet the
        // condition 'n mod 2^k == 0' where n is the number of reseeds
        var _2powK = 1;
        for(var k = 0; k < 32; ++k){
            if (ctx.reseeds % _2powK === 0) {
                md.update(ctx.pools[k].digest().getBytes());
                ctx.pools[k].start();
            }
            _2powK = _2powK << 1;
        }
        // get digest for key bytes
        ctx.keyBytes = md.digest().getBytes();
        // paranoid deviation from Fortuna:
        // update `seed` via `seed = hash(key)`
        // instead of initializing to zero once and only
        // ever incrementing it
        md.start();
        md.update(ctx.keyBytes);
        var seedBytes = md.digest().getBytes();
        // update state
        ctx.key = ctx.plugin.formatKey(ctx.keyBytes);
        ctx.seed = ctx.plugin.formatSeed(seedBytes);
        ctx.generated = 0;
    }
    /**
   * The built-in default seedFile. This seedFile is used when entropy
   * is needed immediately.
   *
   * @param needed the number of bytes that are needed.
   *
   * @return the random bytes.
   */ function defaultSeedFile(needed) {
        // use window.crypto.getRandomValues strong source of entropy if available
        var getRandomValues = null;
        var globalScope = $2xc86.util.globalScope;
        var _crypto = globalScope.crypto || globalScope.msCrypto;
        if (_crypto && _crypto.getRandomValues) getRandomValues = function(arr) {
            return _crypto.getRandomValues(arr);
        };
        var b = $2xc86.util.createBuffer();
        if (getRandomValues) while(b.length() < needed){
            // max byte length is 65536 before QuotaExceededError is thrown
            // http://www.w3.org/TR/WebCryptoAPI/#RandomSource-method-getRandomValues
            var count = Math.max(1, Math.min(needed - b.length(), 65536) / 4);
            var entropy = new Uint32Array(Math.floor(count));
            try {
                getRandomValues(entropy);
                for(var i = 0; i < entropy.length; ++i)b.putInt32(entropy[i]);
            } catch (e) {
                /* only ignore QuotaExceededError */ if (!(typeof QuotaExceededError !== "undefined" && e instanceof QuotaExceededError)) throw e;
            }
        }
        // be sad and add some weak random data
        if (b.length() < needed) {
            /* Draws from Park-Miller "minimal standard" 31 bit PRNG,
      implemented with David G. Carta's optimization: with 32 bit math
      and without division (Public Domain). */ var hi, lo, next;
            var seed = Math.floor(Math.random() * 0x010000);
            while(b.length() < needed){
                lo = 16807 * (seed & 0xFFFF);
                hi = 16807 * (seed >> 16);
                lo += (hi & 0x7FFF) << 16;
                lo += hi >> 15;
                lo = (lo & 0x7FFFFFFF) + (lo >> 31);
                seed = lo & 0xFFFFFFFF;
                // consume lower 3 bytes of seed
                for(var i = 0; i < 3; ++i){
                    // throw in more pseudo random
                    next = seed >>> (i << 3);
                    next ^= Math.floor(Math.random() * 0x0100);
                    b.putByte(String.fromCharCode(next & 0xFF));
                }
            }
        }
        return b.getBytes(needed);
    }
    // initialize seed file APIs
    if ($9025128614e53554$var$_crypto) {
        // use nodejs async API
        ctx.seedFile = function(needed, callback) {
            $9025128614e53554$var$_crypto.randomBytes(needed, function(err, bytes) {
                if (err) return callback(err);
                callback(null, bytes.toString());
            });
        };
        // use nodejs sync API
        ctx.seedFileSync = function(needed) {
            return $9025128614e53554$var$_crypto.randomBytes(needed).toString();
        };
    } else {
        ctx.seedFile = function(needed, callback) {
            try {
                callback(null, defaultSeedFile(needed));
            } catch (e) {
                callback(e);
            }
        };
        ctx.seedFileSync = defaultSeedFile;
    }
    /**
   * Adds entropy to a prng ctx's accumulator.
   *
   * @param bytes the bytes of entropy as a string.
   */ ctx.collect = function(bytes) {
        // iterate over pools distributing entropy cyclically
        var count = bytes.length;
        for(var i = 0; i < count; ++i){
            ctx.pools[ctx.pool].update(bytes.substr(i, 1));
            ctx.pool = ctx.pool === 31 ? 0 : ctx.pool + 1;
        }
    };
    /**
   * Collects an integer of n bits.
   *
   * @param i the integer entropy.
   * @param n the number of bits in the integer.
   */ ctx.collectInt = function(i, n) {
        var bytes = "";
        for(var x = 0; x < n; x += 8)bytes += String.fromCharCode(i >> x & 0xFF);
        ctx.collect(bytes);
    };
    /**
   * Registers a Web Worker to receive immediate entropy from the main thread.
   * This method is required until Web Workers can access the native crypto
   * API. This method should be called twice for each created worker, once in
   * the main thread, and once in the worker itself.
   *
   * @param worker the worker to register.
   */ ctx.registerWorker = function(worker) {
        // worker receives random bytes
        if (worker === self) ctx.seedFile = function(needed, callback) {
            function listener(e) {
                var data = e.data;
                if (data.forge && data.forge.prng) {
                    self.removeEventListener("message", listener);
                    callback(data.forge.prng.err, data.forge.prng.bytes);
                }
            }
            self.addEventListener("message", listener);
            self.postMessage({
                forge: {
                    prng: {
                        needed: needed
                    }
                }
            });
        };
        else {
            // main thread sends random bytes upon request
            var listener = function(e) {
                var data = e.data;
                if (data.forge && data.forge.prng) ctx.seedFile(data.forge.prng.needed, function(err, bytes) {
                    worker.postMessage({
                        forge: {
                            prng: {
                                err: err,
                                bytes: bytes
                            }
                        }
                    });
                });
            };
            // TODO: do we need to remove the event listener when the worker dies?
            worker.addEventListener("message", listener);
        }
    };
    return ctx;
};

});


parcelRequire.register("5uwlA", function(module, exports) {
/**
 * Javascript implementation of X.509 and related components (such as
 * Certification Signing Requests) of a Public Key Infrastructure.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 *
 * The ASN.1 representation of an X.509v3 certificate is as follows
 * (see RFC 2459):
 *
 * Certificate ::= SEQUENCE {
 *   tbsCertificate       TBSCertificate,
 *   signatureAlgorithm   AlgorithmIdentifier,
 *   signatureValue       BIT STRING
 * }
 *
 * TBSCertificate ::= SEQUENCE {
 *   version         [0]  EXPLICIT Version DEFAULT v1,
 *   serialNumber         CertificateSerialNumber,
 *   signature            AlgorithmIdentifier,
 *   issuer               Name,
 *   validity             Validity,
 *   subject              Name,
 *   subjectPublicKeyInfo SubjectPublicKeyInfo,
 *   issuerUniqueID  [1]  IMPLICIT UniqueIdentifier OPTIONAL,
 *                        -- If present, version shall be v2 or v3
 *   subjectUniqueID [2]  IMPLICIT UniqueIdentifier OPTIONAL,
 *                        -- If present, version shall be v2 or v3
 *   extensions      [3]  EXPLICIT Extensions OPTIONAL
 *                        -- If present, version shall be v3
 * }
 *
 * Version ::= INTEGER  { v1(0), v2(1), v3(2) }
 *
 * CertificateSerialNumber ::= INTEGER
 *
 * Name ::= CHOICE {
 *   // only one possible choice for now
 *   RDNSequence
 * }
 *
 * RDNSequence ::= SEQUENCE OF RelativeDistinguishedName
 *
 * RelativeDistinguishedName ::= SET OF AttributeTypeAndValue
 *
 * AttributeTypeAndValue ::= SEQUENCE {
 *   type     AttributeType,
 *   value    AttributeValue
 * }
 * AttributeType ::= OBJECT IDENTIFIER
 * AttributeValue ::= ANY DEFINED BY AttributeType
 *
 * Validity ::= SEQUENCE {
 *   notBefore      Time,
 *   notAfter       Time
 * }
 *
 * Time ::= CHOICE {
 *   utcTime        UTCTime,
 *   generalTime    GeneralizedTime
 * }
 *
 * UniqueIdentifier ::= BIT STRING
 *
 * SubjectPublicKeyInfo ::= SEQUENCE {
 *   algorithm            AlgorithmIdentifier,
 *   subjectPublicKey     BIT STRING
 * }
 *
 * Extensions ::= SEQUENCE SIZE (1..MAX) OF Extension
 *
 * Extension ::= SEQUENCE {
 *   extnID      OBJECT IDENTIFIER,
 *   critical    BOOLEAN DEFAULT FALSE,
 *   extnValue   OCTET STRING
 * }
 *
 * The only key algorithm currently supported for PKI is RSA.
 *
 * RSASSA-PSS signatures are described in RFC 3447 and RFC 4055.
 *
 * PKCS#10 v1.7 describes certificate signing requests:
 *
 * CertificationRequestInfo:
 *
 * CertificationRequestInfo ::= SEQUENCE {
 *   version       INTEGER { v1(0) } (v1,...),
 *   subject       Name,
 *   subjectPKInfo SubjectPublicKeyInfo{{ PKInfoAlgorithms }},
 *   attributes    [0] Attributes{{ CRIAttributes }}
 * }
 *
 * Attributes { ATTRIBUTE:IOSet } ::= SET OF Attribute{{ IOSet }}
 *
 * CRIAttributes  ATTRIBUTE  ::= {
 *   ... -- add any locally defined attributes here -- }
 *
 * Attribute { ATTRIBUTE:IOSet } ::= SEQUENCE {
 *   type   ATTRIBUTE.&id({IOSet}),
 *   values SET SIZE(1..MAX) OF ATTRIBUTE.&Type({IOSet}{@type})
 * }
 *
 * CertificationRequest ::= SEQUENCE {
 *   certificationRequestInfo CertificationRequestInfo,
 *   signatureAlgorithm AlgorithmIdentifier{{ SignatureAlgorithms }},
 *   signature          BIT STRING
 * }
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("a7tnS");
parcelRequire("l46Tq");
parcelRequire("1UAMB");
parcelRequire("eeecL");
parcelRequire("lLb7o");
parcelRequire("hzEKF");
parcelRequire("1x89g");
parcelRequire("cQQSG");
parcelRequire("96KyE");
parcelRequire("e73pV");
// shortcut for asn.1 API
var $3ff8d88cacdb42a4$var$asn1 = $2xc86.asn1;
/* Public Key Infrastructure (PKI) implementation. */ var $3ff8d88cacdb42a4$var$pki = module.exports = $2xc86.pki = $2xc86.pki || {};
var $3ff8d88cacdb42a4$var$oids = $3ff8d88cacdb42a4$var$pki.oids;
// short name OID mappings
var $3ff8d88cacdb42a4$var$_shortNames = {};
$3ff8d88cacdb42a4$var$_shortNames["CN"] = $3ff8d88cacdb42a4$var$oids["commonName"];
$3ff8d88cacdb42a4$var$_shortNames["commonName"] = "CN";
$3ff8d88cacdb42a4$var$_shortNames["C"] = $3ff8d88cacdb42a4$var$oids["countryName"];
$3ff8d88cacdb42a4$var$_shortNames["countryName"] = "C";
$3ff8d88cacdb42a4$var$_shortNames["L"] = $3ff8d88cacdb42a4$var$oids["localityName"];
$3ff8d88cacdb42a4$var$_shortNames["localityName"] = "L";
$3ff8d88cacdb42a4$var$_shortNames["ST"] = $3ff8d88cacdb42a4$var$oids["stateOrProvinceName"];
$3ff8d88cacdb42a4$var$_shortNames["stateOrProvinceName"] = "ST";
$3ff8d88cacdb42a4$var$_shortNames["O"] = $3ff8d88cacdb42a4$var$oids["organizationName"];
$3ff8d88cacdb42a4$var$_shortNames["organizationName"] = "O";
$3ff8d88cacdb42a4$var$_shortNames["OU"] = $3ff8d88cacdb42a4$var$oids["organizationalUnitName"];
$3ff8d88cacdb42a4$var$_shortNames["organizationalUnitName"] = "OU";
$3ff8d88cacdb42a4$var$_shortNames["E"] = $3ff8d88cacdb42a4$var$oids["emailAddress"];
$3ff8d88cacdb42a4$var$_shortNames["emailAddress"] = "E";
// validator for an SubjectPublicKeyInfo structure
// Note: Currently only works with an RSA public key
var $3ff8d88cacdb42a4$var$publicKeyValidator = $2xc86.pki.rsa.publicKeyValidator;
// validator for an X.509v3 certificate
var $3ff8d88cacdb42a4$var$x509CertificateValidator = {
    name: "Certificate",
    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
    type: $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "Certificate.TBSCertificate",
            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
            type: $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE,
            constructed: true,
            captureAsn1: "tbsCertificate",
            value: [
                {
                    name: "Certificate.TBSCertificate.version",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC,
                    type: 0,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "Certificate.TBSCertificate.version.integer",
                            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                            type: $3ff8d88cacdb42a4$var$asn1.Type.INTEGER,
                            constructed: false,
                            capture: "certVersion"
                        }
                    ]
                },
                {
                    name: "Certificate.TBSCertificate.serialNumber",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                    type: $3ff8d88cacdb42a4$var$asn1.Type.INTEGER,
                    constructed: false,
                    capture: "certSerialNumber"
                },
                {
                    name: "Certificate.TBSCertificate.signature",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                    type: $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: "Certificate.TBSCertificate.signature.algorithm",
                            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                            type: $3ff8d88cacdb42a4$var$asn1.Type.OID,
                            constructed: false,
                            capture: "certinfoSignatureOid"
                        },
                        {
                            name: "Certificate.TBSCertificate.signature.parameters",
                            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                            optional: true,
                            captureAsn1: "certinfoSignatureParams"
                        }
                    ]
                },
                {
                    name: "Certificate.TBSCertificate.issuer",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                    type: $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "certIssuer"
                },
                {
                    name: "Certificate.TBSCertificate.validity",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                    type: $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    // Note: UTC and generalized times may both appear so the capture
                    // names are based on their detected order, the names used below
                    // are only for the common case, which validity time really means
                    // "notBefore" and which means "notAfter" will be determined by order
                    value: [
                        {
                            // notBefore (Time) (UTC time case)
                            name: "Certificate.TBSCertificate.validity.notBefore (utc)",
                            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                            type: $3ff8d88cacdb42a4$var$asn1.Type.UTCTIME,
                            constructed: false,
                            optional: true,
                            capture: "certValidity1UTCTime"
                        },
                        {
                            // notBefore (Time) (generalized time case)
                            name: "Certificate.TBSCertificate.validity.notBefore (generalized)",
                            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                            type: $3ff8d88cacdb42a4$var$asn1.Type.GENERALIZEDTIME,
                            constructed: false,
                            optional: true,
                            capture: "certValidity2GeneralizedTime"
                        },
                        {
                            // notAfter (Time) (only UTC time is supported)
                            name: "Certificate.TBSCertificate.validity.notAfter (utc)",
                            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                            type: $3ff8d88cacdb42a4$var$asn1.Type.UTCTIME,
                            constructed: false,
                            optional: true,
                            capture: "certValidity3UTCTime"
                        },
                        {
                            // notAfter (Time) (only UTC time is supported)
                            name: "Certificate.TBSCertificate.validity.notAfter (generalized)",
                            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                            type: $3ff8d88cacdb42a4$var$asn1.Type.GENERALIZEDTIME,
                            constructed: false,
                            optional: true,
                            capture: "certValidity4GeneralizedTime"
                        }
                    ]
                },
                {
                    // Name (subject) (RDNSequence)
                    name: "Certificate.TBSCertificate.subject",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                    type: $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "certSubject"
                },
                // SubjectPublicKeyInfo
                $3ff8d88cacdb42a4$var$publicKeyValidator,
                {
                    // issuerUniqueID (optional)
                    name: "Certificate.TBSCertificate.issuerUniqueID",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC,
                    type: 1,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "Certificate.TBSCertificate.issuerUniqueID.id",
                            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                            type: $3ff8d88cacdb42a4$var$asn1.Type.BITSTRING,
                            constructed: false,
                            // TODO: support arbitrary bit length ids
                            captureBitStringValue: "certIssuerUniqueId"
                        }
                    ]
                },
                {
                    // subjectUniqueID (optional)
                    name: "Certificate.TBSCertificate.subjectUniqueID",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC,
                    type: 2,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "Certificate.TBSCertificate.subjectUniqueID.id",
                            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                            type: $3ff8d88cacdb42a4$var$asn1.Type.BITSTRING,
                            constructed: false,
                            // TODO: support arbitrary bit length ids
                            captureBitStringValue: "certSubjectUniqueId"
                        }
                    ]
                },
                {
                    // Extensions (optional)
                    name: "Certificate.TBSCertificate.extensions",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC,
                    type: 3,
                    constructed: true,
                    captureAsn1: "certExtensions",
                    optional: true
                }
            ]
        },
        {
            // AlgorithmIdentifier (signature algorithm)
            name: "Certificate.signatureAlgorithm",
            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
            type: $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    // algorithm
                    name: "Certificate.signatureAlgorithm.algorithm",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                    type: $3ff8d88cacdb42a4$var$asn1.Type.OID,
                    constructed: false,
                    capture: "certSignatureOid"
                },
                {
                    name: "Certificate.TBSCertificate.signature.parameters",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                    optional: true,
                    captureAsn1: "certSignatureParams"
                }
            ]
        },
        {
            // SignatureValue
            name: "Certificate.signatureValue",
            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
            type: $3ff8d88cacdb42a4$var$asn1.Type.BITSTRING,
            constructed: false,
            captureBitStringValue: "certSignature"
        }
    ]
};
var $3ff8d88cacdb42a4$var$rsassaPssParameterValidator = {
    name: "rsapss",
    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
    type: $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "rsapss.hashAlgorithm",
            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            constructed: true,
            value: [
                {
                    name: "rsapss.hashAlgorithm.AlgorithmIdentifier",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                    type: $3ff8d88cacdb42a4$var$asn1.Class.SEQUENCE,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "rsapss.hashAlgorithm.AlgorithmIdentifier.algorithm",
                            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                            type: $3ff8d88cacdb42a4$var$asn1.Type.OID,
                            constructed: false,
                            capture: "hashOid"
                        }
                    ]
                }
            ]
        },
        {
            name: "rsapss.maskGenAlgorithm",
            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 1,
            constructed: true,
            value: [
                {
                    name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                    type: $3ff8d88cacdb42a4$var$asn1.Class.SEQUENCE,
                    constructed: true,
                    optional: true,
                    value: [
                        {
                            name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.algorithm",
                            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                            type: $3ff8d88cacdb42a4$var$asn1.Type.OID,
                            constructed: false,
                            capture: "maskGenOid"
                        },
                        {
                            name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params",
                            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                            type: $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE,
                            constructed: true,
                            value: [
                                {
                                    name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params.algorithm",
                                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                                    type: $3ff8d88cacdb42a4$var$asn1.Type.OID,
                                    constructed: false,
                                    capture: "maskGenHashOid"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            name: "rsapss.saltLength",
            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 2,
            optional: true,
            value: [
                {
                    name: "rsapss.saltLength.saltLength",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                    type: $3ff8d88cacdb42a4$var$asn1.Class.INTEGER,
                    constructed: false,
                    capture: "saltLength"
                }
            ]
        },
        {
            name: "rsapss.trailerField",
            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 3,
            optional: true,
            value: [
                {
                    name: "rsapss.trailer.trailer",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                    type: $3ff8d88cacdb42a4$var$asn1.Class.INTEGER,
                    constructed: false,
                    capture: "trailer"
                }
            ]
        }
    ]
};
// validator for a CertificationRequestInfo structure
var $3ff8d88cacdb42a4$var$certificationRequestInfoValidator = {
    name: "CertificationRequestInfo",
    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
    type: $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: "certificationRequestInfo",
    value: [
        {
            name: "CertificationRequestInfo.integer",
            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
            type: $3ff8d88cacdb42a4$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "certificationRequestInfoVersion"
        },
        {
            // Name (subject) (RDNSequence)
            name: "CertificationRequestInfo.subject",
            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
            type: $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE,
            constructed: true,
            captureAsn1: "certificationRequestInfoSubject"
        },
        // SubjectPublicKeyInfo
        $3ff8d88cacdb42a4$var$publicKeyValidator,
        {
            name: "CertificationRequestInfo.attributes",
            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC,
            type: 0,
            constructed: true,
            optional: true,
            capture: "certificationRequestInfoAttributes",
            value: [
                {
                    name: "CertificationRequestInfo.attributes",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                    type: $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: "CertificationRequestInfo.attributes.type",
                            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                            type: $3ff8d88cacdb42a4$var$asn1.Type.OID,
                            constructed: false
                        },
                        {
                            name: "CertificationRequestInfo.attributes.value",
                            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                            type: $3ff8d88cacdb42a4$var$asn1.Type.SET,
                            constructed: true
                        }
                    ]
                }
            ]
        }
    ]
};
// validator for a CertificationRequest structure
var $3ff8d88cacdb42a4$var$certificationRequestValidator = {
    name: "CertificationRequest",
    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
    type: $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: "csr",
    value: [
        $3ff8d88cacdb42a4$var$certificationRequestInfoValidator,
        {
            // AlgorithmIdentifier (signature algorithm)
            name: "CertificationRequest.signatureAlgorithm",
            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
            type: $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    // algorithm
                    name: "CertificationRequest.signatureAlgorithm.algorithm",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                    type: $3ff8d88cacdb42a4$var$asn1.Type.OID,
                    constructed: false,
                    capture: "csrSignatureOid"
                },
                {
                    name: "CertificationRequest.signatureAlgorithm.parameters",
                    tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
                    optional: true,
                    captureAsn1: "csrSignatureParams"
                }
            ]
        },
        {
            // signature
            name: "CertificationRequest.signature",
            tagClass: $3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL,
            type: $3ff8d88cacdb42a4$var$asn1.Type.BITSTRING,
            constructed: false,
            captureBitStringValue: "csrSignature"
        }
    ]
};
/**
 * Converts an RDNSequence of ASN.1 DER-encoded RelativeDistinguishedName
 * sets into an array with objects that have type and value properties.
 *
 * @param rdn the RDNSequence to convert.
 * @param md a message digest to append type and value to if provided.
 */ $3ff8d88cacdb42a4$var$pki.RDNAttributesAsArray = function(rdn, md) {
    var rval = [];
    // each value in 'rdn' in is a SET of RelativeDistinguishedName
    var set, attr, obj;
    for(var si = 0; si < rdn.value.length; ++si){
        // get the RelativeDistinguishedName set
        set = rdn.value[si];
        // each value in the SET is an AttributeTypeAndValue sequence
        // containing first a type (an OID) and second a value (defined by
        // the OID)
        for(var i = 0; i < set.value.length; ++i){
            obj = {};
            attr = set.value[i];
            obj.type = $3ff8d88cacdb42a4$var$asn1.derToOid(attr.value[0].value);
            obj.value = attr.value[1].value;
            obj.valueTagClass = attr.value[1].type;
            // if the OID is known, get its name and short name
            if (obj.type in $3ff8d88cacdb42a4$var$oids) {
                obj.name = $3ff8d88cacdb42a4$var$oids[obj.type];
                if (obj.name in $3ff8d88cacdb42a4$var$_shortNames) obj.shortName = $3ff8d88cacdb42a4$var$_shortNames[obj.name];
            }
            if (md) {
                md.update(obj.type);
                md.update(obj.value);
            }
            rval.push(obj);
        }
    }
    return rval;
};
/**
 * Converts ASN.1 CRIAttributes into an array with objects that have type and
 * value properties.
 *
 * @param attributes the CRIAttributes to convert.
 */ $3ff8d88cacdb42a4$var$pki.CRIAttributesAsArray = function(attributes) {
    var rval = [];
    // each value in 'attributes' in is a SEQUENCE with an OID and a SET
    for(var si = 0; si < attributes.length; ++si){
        // get the attribute sequence
        var seq = attributes[si];
        // each value in the SEQUENCE containing first a type (an OID) and
        // second a set of values (defined by the OID)
        var type = $3ff8d88cacdb42a4$var$asn1.derToOid(seq.value[0].value);
        var values = seq.value[1].value;
        for(var vi = 0; vi < values.length; ++vi){
            var obj = {};
            obj.type = type;
            obj.value = values[vi].value;
            obj.valueTagClass = values[vi].type;
            // if the OID is known, get its name and short name
            if (obj.type in $3ff8d88cacdb42a4$var$oids) {
                obj.name = $3ff8d88cacdb42a4$var$oids[obj.type];
                if (obj.name in $3ff8d88cacdb42a4$var$_shortNames) obj.shortName = $3ff8d88cacdb42a4$var$_shortNames[obj.name];
            }
            // parse extensions
            if (obj.type === $3ff8d88cacdb42a4$var$oids.extensionRequest) {
                obj.extensions = [];
                for(var ei = 0; ei < obj.value.length; ++ei)obj.extensions.push($3ff8d88cacdb42a4$var$pki.certificateExtensionFromAsn1(obj.value[ei]));
            }
            rval.push(obj);
        }
    }
    return rval;
};
/**
 * Gets an issuer or subject attribute from its name, type, or short name.
 *
 * @param obj the issuer or subject object.
 * @param options a short name string or an object with:
 *          shortName the short name for the attribute.
 *          name the name for the attribute.
 *          type the type for the attribute.
 *
 * @return the attribute.
 */ function $3ff8d88cacdb42a4$var$_getAttribute(obj, options) {
    if (typeof options === "string") options = {
        shortName: options
    };
    var rval = null;
    var attr;
    for(var i = 0; rval === null && i < obj.attributes.length; ++i){
        attr = obj.attributes[i];
        if (options.type && options.type === attr.type) rval = attr;
        else if (options.name && options.name === attr.name) rval = attr;
        else if (options.shortName && options.shortName === attr.shortName) rval = attr;
    }
    return rval;
}
/**
 * Converts signature parameters from ASN.1 structure.
 *
 * Currently only RSASSA-PSS supported.  The PKCS#1 v1.5 signature scheme had
 * no parameters.
 *
 * RSASSA-PSS-params  ::=  SEQUENCE  {
 *   hashAlgorithm      [0] HashAlgorithm DEFAULT
 *                             sha1Identifier,
 *   maskGenAlgorithm   [1] MaskGenAlgorithm DEFAULT
 *                             mgf1SHA1Identifier,
 *   saltLength         [2] INTEGER DEFAULT 20,
 *   trailerField       [3] INTEGER DEFAULT 1
 * }
 *
 * HashAlgorithm  ::=  AlgorithmIdentifier
 *
 * MaskGenAlgorithm  ::=  AlgorithmIdentifier
 *
 * AlgorithmIdentifer ::= SEQUENCE {
 *   algorithm OBJECT IDENTIFIER,
 *   parameters ANY DEFINED BY algorithm OPTIONAL
 * }
 *
 * @param oid The OID specifying the signature algorithm
 * @param obj The ASN.1 structure holding the parameters
 * @param fillDefaults Whether to use return default values where omitted
 * @return signature parameter object
 */ var $3ff8d88cacdb42a4$var$_readSignatureParameters = function(oid, obj, fillDefaults) {
    var params = {};
    if (oid !== $3ff8d88cacdb42a4$var$oids["RSASSA-PSS"]) return params;
    if (fillDefaults) params = {
        hash: {
            algorithmOid: $3ff8d88cacdb42a4$var$oids["sha1"]
        },
        mgf: {
            algorithmOid: $3ff8d88cacdb42a4$var$oids["mgf1"],
            hash: {
                algorithmOid: $3ff8d88cacdb42a4$var$oids["sha1"]
            }
        },
        saltLength: 20
    };
    var capture = {};
    var errors = [];
    if (!$3ff8d88cacdb42a4$var$asn1.validate(obj, $3ff8d88cacdb42a4$var$rsassaPssParameterValidator, capture, errors)) {
        var error = new Error("Cannot read RSASSA-PSS parameter block.");
        error.errors = errors;
        throw error;
    }
    if (capture.hashOid !== undefined) {
        params.hash = params.hash || {};
        params.hash.algorithmOid = $3ff8d88cacdb42a4$var$asn1.derToOid(capture.hashOid);
    }
    if (capture.maskGenOid !== undefined) {
        params.mgf = params.mgf || {};
        params.mgf.algorithmOid = $3ff8d88cacdb42a4$var$asn1.derToOid(capture.maskGenOid);
        params.mgf.hash = params.mgf.hash || {};
        params.mgf.hash.algorithmOid = $3ff8d88cacdb42a4$var$asn1.derToOid(capture.maskGenHashOid);
    }
    if (capture.saltLength !== undefined) params.saltLength = capture.saltLength.charCodeAt(0);
    return params;
};
/**
 * Converts an X.509 certificate from PEM format.
 *
 * Note: If the certificate is to be verified then compute hash should
 * be set to true. This will scan the TBSCertificate part of the ASN.1
 * object while it is converted so it doesn't need to be converted back
 * to ASN.1-DER-encoding later.
 *
 * @param pem the PEM-formatted certificate.
 * @param computeHash true to compute the hash for verification.
 * @param strict true to be strict when checking ASN.1 value lengths, false to
 *          allow truncated values (default: true).
 *
 * @return the certificate.
 */ $3ff8d88cacdb42a4$var$pki.certificateFromPem = function(pem, computeHash, strict) {
    var msg = $2xc86.pem.decode(pem)[0];
    if (msg.type !== "CERTIFICATE" && msg.type !== "X509 CERTIFICATE" && msg.type !== "TRUSTED CERTIFICATE") {
        var error = new Error('Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert certificate from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    var obj = $3ff8d88cacdb42a4$var$asn1.fromDer(msg.body, strict);
    return $3ff8d88cacdb42a4$var$pki.certificateFromAsn1(obj, computeHash);
};
/**
 * Converts an X.509 certificate to PEM format.
 *
 * @param cert the certificate.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted certificate.
 */ $3ff8d88cacdb42a4$var$pki.certificateToPem = function(cert, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: "CERTIFICATE",
        body: $3ff8d88cacdb42a4$var$asn1.toDer($3ff8d88cacdb42a4$var$pki.certificateToAsn1(cert)).getBytes()
    };
    return $2xc86.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Converts an RSA public key from PEM format.
 *
 * @param pem the PEM-formatted public key.
 *
 * @return the public key.
 */ $3ff8d88cacdb42a4$var$pki.publicKeyFromPem = function(pem) {
    var msg = $2xc86.pem.decode(pem)[0];
    if (msg.type !== "PUBLIC KEY" && msg.type !== "RSA PUBLIC KEY") {
        var error = new Error('Could not convert public key from PEM; PEM header type is not "PUBLIC KEY" or "RSA PUBLIC KEY".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert public key from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    var obj = $3ff8d88cacdb42a4$var$asn1.fromDer(msg.body);
    return $3ff8d88cacdb42a4$var$pki.publicKeyFromAsn1(obj);
};
/**
 * Converts an RSA public key to PEM format (using a SubjectPublicKeyInfo).
 *
 * @param key the public key.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted public key.
 */ $3ff8d88cacdb42a4$var$pki.publicKeyToPem = function(key, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: "PUBLIC KEY",
        body: $3ff8d88cacdb42a4$var$asn1.toDer($3ff8d88cacdb42a4$var$pki.publicKeyToAsn1(key)).getBytes()
    };
    return $2xc86.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Converts an RSA public key to PEM format (using an RSAPublicKey).
 *
 * @param key the public key.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted public key.
 */ $3ff8d88cacdb42a4$var$pki.publicKeyToRSAPublicKeyPem = function(key, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: "RSA PUBLIC KEY",
        body: $3ff8d88cacdb42a4$var$asn1.toDer($3ff8d88cacdb42a4$var$pki.publicKeyToRSAPublicKey(key)).getBytes()
    };
    return $2xc86.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Gets a fingerprint for the given public key.
 *
 * @param options the options to use.
 *          [md] the message digest object to use (defaults to forge.md.sha1).
 *          [type] the type of fingerprint, such as 'RSAPublicKey',
 *            'SubjectPublicKeyInfo' (defaults to 'RSAPublicKey').
 *          [encoding] an alternative output encoding, such as 'hex'
 *            (defaults to none, outputs a byte buffer).
 *          [delimiter] the delimiter to use between bytes for 'hex' encoded
 *            output, eg: ':' (defaults to none).
 *
 * @return the fingerprint as a byte buffer or other encoding based on options.
 */ $3ff8d88cacdb42a4$var$pki.getPublicKeyFingerprint = function(key, options) {
    options = options || {};
    var md = options.md || $2xc86.md.sha1.create();
    var type = options.type || "RSAPublicKey";
    var bytes;
    switch(type){
        case "RSAPublicKey":
            bytes = $3ff8d88cacdb42a4$var$asn1.toDer($3ff8d88cacdb42a4$var$pki.publicKeyToRSAPublicKey(key)).getBytes();
            break;
        case "SubjectPublicKeyInfo":
            bytes = $3ff8d88cacdb42a4$var$asn1.toDer($3ff8d88cacdb42a4$var$pki.publicKeyToAsn1(key)).getBytes();
            break;
        default:
            throw new Error('Unknown fingerprint type "' + options.type + '".');
    }
    // hash public key bytes
    md.start();
    md.update(bytes);
    var digest = md.digest();
    if (options.encoding === "hex") {
        var hex = digest.toHex();
        if (options.delimiter) return hex.match(/.{2}/g).join(options.delimiter);
        return hex;
    } else if (options.encoding === "binary") return digest.getBytes();
    else if (options.encoding) throw new Error('Unknown encoding "' + options.encoding + '".');
    return digest;
};
/**
 * Converts a PKCS#10 certification request (CSR) from PEM format.
 *
 * Note: If the certification request is to be verified then compute hash
 * should be set to true. This will scan the CertificationRequestInfo part of
 * the ASN.1 object while it is converted so it doesn't need to be converted
 * back to ASN.1-DER-encoding later.
 *
 * @param pem the PEM-formatted certificate.
 * @param computeHash true to compute the hash for verification.
 * @param strict true to be strict when checking ASN.1 value lengths, false to
 *          allow truncated values (default: true).
 *
 * @return the certification request (CSR).
 */ $3ff8d88cacdb42a4$var$pki.certificationRequestFromPem = function(pem, computeHash, strict) {
    var msg = $2xc86.pem.decode(pem)[0];
    if (msg.type !== "CERTIFICATE REQUEST") {
        var error = new Error('Could not convert certification request from PEM; PEM header type is not "CERTIFICATE REQUEST".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert certification request from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    var obj = $3ff8d88cacdb42a4$var$asn1.fromDer(msg.body, strict);
    return $3ff8d88cacdb42a4$var$pki.certificationRequestFromAsn1(obj, computeHash);
};
/**
 * Converts a PKCS#10 certification request (CSR) to PEM format.
 *
 * @param csr the certification request.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted certification request.
 */ $3ff8d88cacdb42a4$var$pki.certificationRequestToPem = function(csr, maxline) {
    // convert to ASN.1, then DER, then PEM-encode
    var msg = {
        type: "CERTIFICATE REQUEST",
        body: $3ff8d88cacdb42a4$var$asn1.toDer($3ff8d88cacdb42a4$var$pki.certificationRequestToAsn1(csr)).getBytes()
    };
    return $2xc86.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Creates an empty X.509v3 RSA certificate.
 *
 * @return the certificate.
 */ $3ff8d88cacdb42a4$var$pki.createCertificate = function() {
    var cert = {};
    cert.version = 0x02;
    cert.serialNumber = "00";
    cert.signatureOid = null;
    cert.signature = null;
    cert.siginfo = {};
    cert.siginfo.algorithmOid = null;
    cert.validity = {};
    cert.validity.notBefore = new Date();
    cert.validity.notAfter = new Date();
    cert.issuer = {};
    cert.issuer.getField = function(sn) {
        return $3ff8d88cacdb42a4$var$_getAttribute(cert.issuer, sn);
    };
    cert.issuer.addField = function(attr) {
        $3ff8d88cacdb42a4$var$_fillMissingFields([
            attr
        ]);
        cert.issuer.attributes.push(attr);
    };
    cert.issuer.attributes = [];
    cert.issuer.hash = null;
    cert.subject = {};
    cert.subject.getField = function(sn) {
        return $3ff8d88cacdb42a4$var$_getAttribute(cert.subject, sn);
    };
    cert.subject.addField = function(attr) {
        $3ff8d88cacdb42a4$var$_fillMissingFields([
            attr
        ]);
        cert.subject.attributes.push(attr);
    };
    cert.subject.attributes = [];
    cert.subject.hash = null;
    cert.extensions = [];
    cert.publicKey = null;
    cert.md = null;
    /**
   * Sets the subject of this certificate.
   *
   * @param attrs the array of subject attributes to use.
   * @param uniqueId an optional a unique ID to use.
   */ cert.setSubject = function(attrs, uniqueId) {
        // set new attributes, clear hash
        $3ff8d88cacdb42a4$var$_fillMissingFields(attrs);
        cert.subject.attributes = attrs;
        delete cert.subject.uniqueId;
        if (uniqueId) // TODO: support arbitrary bit length ids
        cert.subject.uniqueId = uniqueId;
        cert.subject.hash = null;
    };
    /**
   * Sets the issuer of this certificate.
   *
   * @param attrs the array of issuer attributes to use.
   * @param uniqueId an optional a unique ID to use.
   */ cert.setIssuer = function(attrs, uniqueId) {
        // set new attributes, clear hash
        $3ff8d88cacdb42a4$var$_fillMissingFields(attrs);
        cert.issuer.attributes = attrs;
        delete cert.issuer.uniqueId;
        if (uniqueId) // TODO: support arbitrary bit length ids
        cert.issuer.uniqueId = uniqueId;
        cert.issuer.hash = null;
    };
    /**
   * Sets the extensions of this certificate.
   *
   * @param exts the array of extensions to use.
   */ cert.setExtensions = function(exts) {
        for(var i = 0; i < exts.length; ++i)$3ff8d88cacdb42a4$var$_fillMissingExtensionFields(exts[i], {
            cert: cert
        });
        // set new extensions
        cert.extensions = exts;
    };
    /**
   * Gets an extension by its name or id.
   *
   * @param options the name to use or an object with:
   *          name the name to use.
   *          id the id to use.
   *
   * @return the extension or null if not found.
   */ cert.getExtension = function(options) {
        if (typeof options === "string") options = {
            name: options
        };
        var rval = null;
        var ext;
        for(var i = 0; rval === null && i < cert.extensions.length; ++i){
            ext = cert.extensions[i];
            if (options.id && ext.id === options.id) rval = ext;
            else if (options.name && ext.name === options.name) rval = ext;
        }
        return rval;
    };
    /**
   * Signs this certificate using the given private key.
   *
   * @param key the private key to sign with.
   * @param md the message digest object to use (defaults to forge.md.sha1).
   */ cert.sign = function(key, md) {
        // TODO: get signature OID from private key
        cert.md = md || $2xc86.md.sha1.create();
        var algorithmOid = $3ff8d88cacdb42a4$var$oids[cert.md.algorithm + "WithRSAEncryption"];
        if (!algorithmOid) {
            var error = new Error("Could not compute certificate digest. Unknown message digest algorithm OID.");
            error.algorithm = cert.md.algorithm;
            throw error;
        }
        cert.signatureOid = cert.siginfo.algorithmOid = algorithmOid;
        // get TBSCertificate, convert to DER
        cert.tbsCertificate = $3ff8d88cacdb42a4$var$pki.getTBSCertificate(cert);
        var bytes = $3ff8d88cacdb42a4$var$asn1.toDer(cert.tbsCertificate);
        // digest and sign
        cert.md.update(bytes.getBytes());
        cert.signature = key.sign(cert.md);
    };
    /**
   * Attempts verify the signature on the passed certificate using this
   * certificate's public key.
   *
   * @param child the certificate to verify.
   *
   * @return true if verified, false if not.
   */ cert.verify = function(child) {
        var rval = false;
        if (!cert.issued(child)) {
            var issuer = child.issuer;
            var subject = cert.subject;
            var error = new Error("The parent certificate did not issue the given child certificate; the child certificate's issuer does not match the parent's subject.");
            error.expectedIssuer = issuer.attributes;
            error.actualIssuer = subject.attributes;
            throw error;
        }
        var md = child.md;
        if (md === null) {
            // check signature OID for supported signature types
            if (child.signatureOid in $3ff8d88cacdb42a4$var$oids) {
                var oid = $3ff8d88cacdb42a4$var$oids[child.signatureOid];
                switch(oid){
                    case "sha1WithRSAEncryption":
                        md = $2xc86.md.sha1.create();
                        break;
                    case "md5WithRSAEncryption":
                        md = $2xc86.md.md5.create();
                        break;
                    case "sha256WithRSAEncryption":
                        md = $2xc86.md.sha256.create();
                        break;
                    case "sha384WithRSAEncryption":
                        md = $2xc86.md.sha384.create();
                        break;
                    case "sha512WithRSAEncryption":
                        md = $2xc86.md.sha512.create();
                        break;
                    case "RSASSA-PSS":
                        md = $2xc86.md.sha256.create();
                        break;
                }
            }
            if (md === null) {
                var error = new Error("Could not compute certificate digest. Unknown signature OID.");
                error.signatureOid = child.signatureOid;
                throw error;
            }
            // produce DER formatted TBSCertificate and digest it
            var tbsCertificate = child.tbsCertificate || $3ff8d88cacdb42a4$var$pki.getTBSCertificate(child);
            var bytes = $3ff8d88cacdb42a4$var$asn1.toDer(tbsCertificate);
            md.update(bytes.getBytes());
        }
        if (md !== null) {
            var scheme;
            switch(child.signatureOid){
                case $3ff8d88cacdb42a4$var$oids.sha1WithRSAEncryption:
                    scheme = undefined; /* use PKCS#1 v1.5 padding scheme */ 
                    break;
                case $3ff8d88cacdb42a4$var$oids["RSASSA-PSS"]:
                    var hash, mgf;
                    /* initialize mgf */ hash = $3ff8d88cacdb42a4$var$oids[child.signatureParameters.mgf.hash.algorithmOid];
                    if (hash === undefined || $2xc86.md[hash] === undefined) {
                        var error = new Error("Unsupported MGF hash function.");
                        error.oid = child.signatureParameters.mgf.hash.algorithmOid;
                        error.name = hash;
                        throw error;
                    }
                    mgf = $3ff8d88cacdb42a4$var$oids[child.signatureParameters.mgf.algorithmOid];
                    if (mgf === undefined || $2xc86.mgf[mgf] === undefined) {
                        var error = new Error("Unsupported MGF function.");
                        error.oid = child.signatureParameters.mgf.algorithmOid;
                        error.name = mgf;
                        throw error;
                    }
                    mgf = $2xc86.mgf[mgf].create($2xc86.md[hash].create());
                    /* initialize hash function */ hash = $3ff8d88cacdb42a4$var$oids[child.signatureParameters.hash.algorithmOid];
                    if (hash === undefined || $2xc86.md[hash] === undefined) throw {
                        message: "Unsupported RSASSA-PSS hash function.",
                        oid: child.signatureParameters.hash.algorithmOid,
                        name: hash
                    };
                    scheme = $2xc86.pss.create($2xc86.md[hash].create(), mgf, child.signatureParameters.saltLength);
                    break;
            }
            // verify signature on cert using public key
            rval = cert.publicKey.verify(md.digest().getBytes(), child.signature, scheme);
        }
        return rval;
    };
    /**
   * Returns true if this certificate's issuer matches the passed
   * certificate's subject. Note that no signature check is performed.
   *
   * @param parent the certificate to check.
   *
   * @return true if this certificate's issuer matches the passed certificate's
   *         subject.
   */ cert.isIssuer = function(parent) {
        var rval = false;
        var i = cert.issuer;
        var s = parent.subject;
        // compare hashes if present
        if (i.hash && s.hash) rval = i.hash === s.hash;
        else if (i.attributes.length === s.attributes.length) {
            // all attributes are the same so issuer matches subject
            rval = true;
            var iattr, sattr;
            for(var n = 0; rval && n < i.attributes.length; ++n){
                iattr = i.attributes[n];
                sattr = s.attributes[n];
                if (iattr.type !== sattr.type || iattr.value !== sattr.value) // attribute mismatch
                rval = false;
            }
        }
        return rval;
    };
    /**
   * Returns true if this certificate's subject matches the issuer of the
   * given certificate). Note that not signature check is performed.
   *
   * @param child the certificate to check.
   *
   * @return true if this certificate's subject matches the passed
   *         certificate's issuer.
   */ cert.issued = function(child) {
        return child.isIssuer(cert);
    };
    /**
   * Generates the subjectKeyIdentifier for this certificate as byte buffer.
   *
   * @return the subjectKeyIdentifier for this certificate as byte buffer.
   */ cert.generateSubjectKeyIdentifier = function() {
        /* See: 4.2.1.2 section of the the RFC3280, keyIdentifier is either:

      (1) The keyIdentifier is composed of the 160-bit SHA-1 hash of the
        value of the BIT STRING subjectPublicKey (excluding the tag,
        length, and number of unused bits).

      (2) The keyIdentifier is composed of a four bit type field with
        the value 0100 followed by the least significant 60 bits of the
        SHA-1 hash of the value of the BIT STRING subjectPublicKey
        (excluding the tag, length, and number of unused bit string bits).
    */ // skipping the tag, length, and number of unused bits is the same
        // as just using the RSAPublicKey (for RSA keys, which are the
        // only ones supported)
        return $3ff8d88cacdb42a4$var$pki.getPublicKeyFingerprint(cert.publicKey, {
            type: "RSAPublicKey"
        });
    };
    /**
   * Verifies the subjectKeyIdentifier extension value for this certificate
   * against its public key. If no extension is found, false will be
   * returned.
   *
   * @return true if verified, false if not.
   */ cert.verifySubjectKeyIdentifier = function() {
        var oid = $3ff8d88cacdb42a4$var$oids["subjectKeyIdentifier"];
        for(var i = 0; i < cert.extensions.length; ++i){
            var ext = cert.extensions[i];
            if (ext.id === oid) {
                var ski = cert.generateSubjectKeyIdentifier().getBytes();
                return $2xc86.util.hexToBytes(ext.subjectKeyIdentifier) === ski;
            }
        }
        return false;
    };
    return cert;
};
/**
 * Converts an X.509v3 RSA certificate from an ASN.1 object.
 *
 * Note: If the certificate is to be verified then compute hash should
 * be set to true. There is currently no implementation for converting
 * a certificate back to ASN.1 so the TBSCertificate part of the ASN.1
 * object needs to be scanned before the cert object is created.
 *
 * @param obj the asn1 representation of an X.509v3 RSA certificate.
 * @param computeHash true to compute the hash for verification.
 *
 * @return the certificate.
 */ $3ff8d88cacdb42a4$var$pki.certificateFromAsn1 = function(obj, computeHash) {
    // validate certificate and capture data
    var capture = {};
    var errors = [];
    if (!$3ff8d88cacdb42a4$var$asn1.validate(obj, $3ff8d88cacdb42a4$var$x509CertificateValidator, capture, errors)) {
        var error = new Error("Cannot read X.509 certificate. ASN.1 object is not an X509v3 Certificate.");
        error.errors = errors;
        throw error;
    }
    // get oid
    var oid = $3ff8d88cacdb42a4$var$asn1.derToOid(capture.publicKeyOid);
    if (oid !== $3ff8d88cacdb42a4$var$pki.oids.rsaEncryption) throw new Error("Cannot read public key. OID is not RSA.");
    // create certificate
    var cert = $3ff8d88cacdb42a4$var$pki.createCertificate();
    cert.version = capture.certVersion ? capture.certVersion.charCodeAt(0) : 0;
    var serial = $2xc86.util.createBuffer(capture.certSerialNumber);
    cert.serialNumber = serial.toHex();
    cert.signatureOid = $2xc86.asn1.derToOid(capture.certSignatureOid);
    cert.signatureParameters = $3ff8d88cacdb42a4$var$_readSignatureParameters(cert.signatureOid, capture.certSignatureParams, true);
    cert.siginfo.algorithmOid = $2xc86.asn1.derToOid(capture.certinfoSignatureOid);
    cert.siginfo.parameters = $3ff8d88cacdb42a4$var$_readSignatureParameters(cert.siginfo.algorithmOid, capture.certinfoSignatureParams, false);
    cert.signature = capture.certSignature;
    var validity = [];
    if (capture.certValidity1UTCTime !== undefined) validity.push($3ff8d88cacdb42a4$var$asn1.utcTimeToDate(capture.certValidity1UTCTime));
    if (capture.certValidity2GeneralizedTime !== undefined) validity.push($3ff8d88cacdb42a4$var$asn1.generalizedTimeToDate(capture.certValidity2GeneralizedTime));
    if (capture.certValidity3UTCTime !== undefined) validity.push($3ff8d88cacdb42a4$var$asn1.utcTimeToDate(capture.certValidity3UTCTime));
    if (capture.certValidity4GeneralizedTime !== undefined) validity.push($3ff8d88cacdb42a4$var$asn1.generalizedTimeToDate(capture.certValidity4GeneralizedTime));
    if (validity.length > 2) throw new Error("Cannot read notBefore/notAfter validity times; more than two times were provided in the certificate.");
    if (validity.length < 2) throw new Error("Cannot read notBefore/notAfter validity times; they were not provided as either UTCTime or GeneralizedTime.");
    cert.validity.notBefore = validity[0];
    cert.validity.notAfter = validity[1];
    // keep TBSCertificate to preserve signature when exporting
    cert.tbsCertificate = capture.tbsCertificate;
    if (computeHash) {
        // check signature OID for supported signature types
        cert.md = null;
        if (cert.signatureOid in $3ff8d88cacdb42a4$var$oids) {
            var oid = $3ff8d88cacdb42a4$var$oids[cert.signatureOid];
            switch(oid){
                case "sha1WithRSAEncryption":
                    cert.md = $2xc86.md.sha1.create();
                    break;
                case "md5WithRSAEncryption":
                    cert.md = $2xc86.md.md5.create();
                    break;
                case "sha256WithRSAEncryption":
                    cert.md = $2xc86.md.sha256.create();
                    break;
                case "sha384WithRSAEncryption":
                    cert.md = $2xc86.md.sha384.create();
                    break;
                case "sha512WithRSAEncryption":
                    cert.md = $2xc86.md.sha512.create();
                    break;
                case "RSASSA-PSS":
                    cert.md = $2xc86.md.sha256.create();
                    break;
            }
        }
        if (cert.md === null) {
            var error = new Error("Could not compute certificate digest. Unknown signature OID.");
            error.signatureOid = cert.signatureOid;
            throw error;
        }
        // produce DER formatted TBSCertificate and digest it
        var bytes = $3ff8d88cacdb42a4$var$asn1.toDer(cert.tbsCertificate);
        cert.md.update(bytes.getBytes());
    }
    // handle issuer, build issuer message digest
    var imd = $2xc86.md.sha1.create();
    cert.issuer.getField = function(sn) {
        return $3ff8d88cacdb42a4$var$_getAttribute(cert.issuer, sn);
    };
    cert.issuer.addField = function(attr) {
        $3ff8d88cacdb42a4$var$_fillMissingFields([
            attr
        ]);
        cert.issuer.attributes.push(attr);
    };
    cert.issuer.attributes = $3ff8d88cacdb42a4$var$pki.RDNAttributesAsArray(capture.certIssuer, imd);
    if (capture.certIssuerUniqueId) cert.issuer.uniqueId = capture.certIssuerUniqueId;
    cert.issuer.hash = imd.digest().toHex();
    // handle subject, build subject message digest
    var smd = $2xc86.md.sha1.create();
    cert.subject.getField = function(sn) {
        return $3ff8d88cacdb42a4$var$_getAttribute(cert.subject, sn);
    };
    cert.subject.addField = function(attr) {
        $3ff8d88cacdb42a4$var$_fillMissingFields([
            attr
        ]);
        cert.subject.attributes.push(attr);
    };
    cert.subject.attributes = $3ff8d88cacdb42a4$var$pki.RDNAttributesAsArray(capture.certSubject, smd);
    if (capture.certSubjectUniqueId) cert.subject.uniqueId = capture.certSubjectUniqueId;
    cert.subject.hash = smd.digest().toHex();
    // handle extensions
    if (capture.certExtensions) cert.extensions = $3ff8d88cacdb42a4$var$pki.certificateExtensionsFromAsn1(capture.certExtensions);
    else cert.extensions = [];
    // convert RSA public key from ASN.1
    cert.publicKey = $3ff8d88cacdb42a4$var$pki.publicKeyFromAsn1(capture.subjectPublicKeyInfo);
    return cert;
};
/**
 * Converts an ASN.1 extensions object (with extension sequences as its
 * values) into an array of extension objects with types and values.
 *
 * Supported extensions:
 *
 * id-ce-keyUsage OBJECT IDENTIFIER ::=  { id-ce 15 }
 * KeyUsage ::= BIT STRING {
 *   digitalSignature        (0),
 *   nonRepudiation          (1),
 *   keyEncipherment         (2),
 *   dataEncipherment        (3),
 *   keyAgreement            (4),
 *   keyCertSign             (5),
 *   cRLSign                 (6),
 *   encipherOnly            (7),
 *   decipherOnly            (8)
 * }
 *
 * id-ce-basicConstraints OBJECT IDENTIFIER ::=  { id-ce 19 }
 * BasicConstraints ::= SEQUENCE {
 *   cA                      BOOLEAN DEFAULT FALSE,
 *   pathLenConstraint       INTEGER (0..MAX) OPTIONAL
 * }
 *
 * subjectAltName EXTENSION ::= {
 *   SYNTAX GeneralNames
 *   IDENTIFIED BY id-ce-subjectAltName
 * }
 *
 * GeneralNames ::= SEQUENCE SIZE (1..MAX) OF GeneralName
 *
 * GeneralName ::= CHOICE {
 *   otherName      [0] INSTANCE OF OTHER-NAME,
 *   rfc822Name     [1] IA5String,
 *   dNSName        [2] IA5String,
 *   x400Address    [3] ORAddress,
 *   directoryName  [4] Name,
 *   ediPartyName   [5] EDIPartyName,
 *   uniformResourceIdentifier [6] IA5String,
 *   IPAddress      [7] OCTET STRING,
 *   registeredID   [8] OBJECT IDENTIFIER
 * }
 *
 * OTHER-NAME ::= TYPE-IDENTIFIER
 *
 * EDIPartyName ::= SEQUENCE {
 *   nameAssigner [0] DirectoryString {ub-name} OPTIONAL,
 *   partyName    [1] DirectoryString {ub-name}
 * }
 *
 * @param exts the extensions ASN.1 with extension sequences to parse.
 *
 * @return the array.
 */ $3ff8d88cacdb42a4$var$pki.certificateExtensionsFromAsn1 = function(exts) {
    var rval = [];
    for(var i = 0; i < exts.value.length; ++i){
        // get extension sequence
        var extseq = exts.value[i];
        for(var ei = 0; ei < extseq.value.length; ++ei)rval.push($3ff8d88cacdb42a4$var$pki.certificateExtensionFromAsn1(extseq.value[ei]));
    }
    return rval;
};
/**
 * Parses a single certificate extension from ASN.1.
 *
 * @param ext the extension in ASN.1 format.
 *
 * @return the parsed extension as an object.
 */ $3ff8d88cacdb42a4$var$pki.certificateExtensionFromAsn1 = function(ext) {
    // an extension has:
    // [0] extnID      OBJECT IDENTIFIER
    // [1] critical    BOOLEAN DEFAULT FALSE
    // [2] extnValue   OCTET STRING
    var e = {};
    e.id = $3ff8d88cacdb42a4$var$asn1.derToOid(ext.value[0].value);
    e.critical = false;
    if (ext.value[1].type === $3ff8d88cacdb42a4$var$asn1.Type.BOOLEAN) {
        e.critical = ext.value[1].value.charCodeAt(0) !== 0x00;
        e.value = ext.value[2].value;
    } else e.value = ext.value[1].value;
    // if the oid is known, get its name
    if (e.id in $3ff8d88cacdb42a4$var$oids) {
        e.name = $3ff8d88cacdb42a4$var$oids[e.id];
        // handle key usage
        if (e.name === "keyUsage") {
            // get value as BIT STRING
            var ev = $3ff8d88cacdb42a4$var$asn1.fromDer(e.value);
            var b2 = 0x00;
            var b3 = 0x00;
            if (ev.value.length > 1) {
                // skip first byte, just indicates unused bits which
                // will be padded with 0s anyway
                // get bytes with flag bits
                b2 = ev.value.charCodeAt(1);
                b3 = ev.value.length > 2 ? ev.value.charCodeAt(2) : 0;
            }
            // set flags
            e.digitalSignature = (b2 & 0x80) === 0x80;
            e.nonRepudiation = (b2 & 0x40) === 0x40;
            e.keyEncipherment = (b2 & 0x20) === 0x20;
            e.dataEncipherment = (b2 & 0x10) === 0x10;
            e.keyAgreement = (b2 & 0x08) === 0x08;
            e.keyCertSign = (b2 & 0x04) === 0x04;
            e.cRLSign = (b2 & 0x02) === 0x02;
            e.encipherOnly = (b2 & 0x01) === 0x01;
            e.decipherOnly = (b3 & 0x80) === 0x80;
        } else if (e.name === "basicConstraints") {
            // handle basic constraints
            // get value as SEQUENCE
            var ev = $3ff8d88cacdb42a4$var$asn1.fromDer(e.value);
            // get cA BOOLEAN flag (defaults to false)
            if (ev.value.length > 0 && ev.value[0].type === $3ff8d88cacdb42a4$var$asn1.Type.BOOLEAN) e.cA = ev.value[0].value.charCodeAt(0) !== 0x00;
            else e.cA = false;
            // get path length constraint
            var value = null;
            if (ev.value.length > 0 && ev.value[0].type === $3ff8d88cacdb42a4$var$asn1.Type.INTEGER) value = ev.value[0].value;
            else if (ev.value.length > 1) value = ev.value[1].value;
            if (value !== null) e.pathLenConstraint = $3ff8d88cacdb42a4$var$asn1.derToInteger(value);
        } else if (e.name === "extKeyUsage") {
            // handle extKeyUsage
            // value is a SEQUENCE of OIDs
            var ev = $3ff8d88cacdb42a4$var$asn1.fromDer(e.value);
            for(var vi = 0; vi < ev.value.length; ++vi){
                var oid = $3ff8d88cacdb42a4$var$asn1.derToOid(ev.value[vi].value);
                if (oid in $3ff8d88cacdb42a4$var$oids) e[$3ff8d88cacdb42a4$var$oids[oid]] = true;
                else e[oid] = true;
            }
        } else if (e.name === "nsCertType") {
            // handle nsCertType
            // get value as BIT STRING
            var ev = $3ff8d88cacdb42a4$var$asn1.fromDer(e.value);
            var b2 = 0x00;
            if (ev.value.length > 1) // skip first byte, just indicates unused bits which
            // will be padded with 0s anyway
            // get bytes with flag bits
            b2 = ev.value.charCodeAt(1);
            // set flags
            e.client = (b2 & 0x80) === 0x80;
            e.server = (b2 & 0x40) === 0x40;
            e.email = (b2 & 0x20) === 0x20;
            e.objsign = (b2 & 0x10) === 0x10;
            e.reserved = (b2 & 0x08) === 0x08;
            e.sslCA = (b2 & 0x04) === 0x04;
            e.emailCA = (b2 & 0x02) === 0x02;
            e.objCA = (b2 & 0x01) === 0x01;
        } else if (e.name === "subjectAltName" || e.name === "issuerAltName") {
            // handle subjectAltName/issuerAltName
            e.altNames = [];
            // ev is a SYNTAX SEQUENCE
            var gn;
            var ev = $3ff8d88cacdb42a4$var$asn1.fromDer(e.value);
            for(var n = 0; n < ev.value.length; ++n){
                // get GeneralName
                gn = ev.value[n];
                var altName = {
                    type: gn.type,
                    value: gn.value
                };
                e.altNames.push(altName);
                // Note: Support for types 1,2,6,7,8
                switch(gn.type){
                    // rfc822Name
                    case 1:
                    // dNSName
                    case 2:
                    // uniformResourceIdentifier (URI)
                    case 6:
                        break;
                    // IPAddress
                    case 7:
                        // convert to IPv4/IPv6 string representation
                        altName.ip = $2xc86.util.bytesToIP(gn.value);
                        break;
                    // registeredID
                    case 8:
                        altName.oid = $3ff8d88cacdb42a4$var$asn1.derToOid(gn.value);
                        break;
                    default:
                }
            }
        } else if (e.name === "subjectKeyIdentifier") {
            // value is an OCTETSTRING w/the hash of the key-type specific
            // public key structure (eg: RSAPublicKey)
            var ev = $3ff8d88cacdb42a4$var$asn1.fromDer(e.value);
            e.subjectKeyIdentifier = $2xc86.util.bytesToHex(ev.value);
        }
    }
    return e;
};
/**
 * Converts a PKCS#10 certification request (CSR) from an ASN.1 object.
 *
 * Note: If the certification request is to be verified then compute hash
 * should be set to true. There is currently no implementation for converting
 * a certificate back to ASN.1 so the CertificationRequestInfo part of the
 * ASN.1 object needs to be scanned before the csr object is created.
 *
 * @param obj the asn1 representation of a PKCS#10 certification request (CSR).
 * @param computeHash true to compute the hash for verification.
 *
 * @return the certification request (CSR).
 */ $3ff8d88cacdb42a4$var$pki.certificationRequestFromAsn1 = function(obj, computeHash) {
    // validate certification request and capture data
    var capture = {};
    var errors = [];
    if (!$3ff8d88cacdb42a4$var$asn1.validate(obj, $3ff8d88cacdb42a4$var$certificationRequestValidator, capture, errors)) {
        var error = new Error("Cannot read PKCS#10 certificate request. ASN.1 object is not a PKCS#10 CertificationRequest.");
        error.errors = errors;
        throw error;
    }
    // get oid
    var oid = $3ff8d88cacdb42a4$var$asn1.derToOid(capture.publicKeyOid);
    if (oid !== $3ff8d88cacdb42a4$var$pki.oids.rsaEncryption) throw new Error("Cannot read public key. OID is not RSA.");
    // create certification request
    var csr = $3ff8d88cacdb42a4$var$pki.createCertificationRequest();
    csr.version = capture.csrVersion ? capture.csrVersion.charCodeAt(0) : 0;
    csr.signatureOid = $2xc86.asn1.derToOid(capture.csrSignatureOid);
    csr.signatureParameters = $3ff8d88cacdb42a4$var$_readSignatureParameters(csr.signatureOid, capture.csrSignatureParams, true);
    csr.siginfo.algorithmOid = $2xc86.asn1.derToOid(capture.csrSignatureOid);
    csr.siginfo.parameters = $3ff8d88cacdb42a4$var$_readSignatureParameters(csr.siginfo.algorithmOid, capture.csrSignatureParams, false);
    csr.signature = capture.csrSignature;
    // keep CertificationRequestInfo to preserve signature when exporting
    csr.certificationRequestInfo = capture.certificationRequestInfo;
    if (computeHash) {
        // check signature OID for supported signature types
        csr.md = null;
        if (csr.signatureOid in $3ff8d88cacdb42a4$var$oids) {
            var oid = $3ff8d88cacdb42a4$var$oids[csr.signatureOid];
            switch(oid){
                case "sha1WithRSAEncryption":
                    csr.md = $2xc86.md.sha1.create();
                    break;
                case "md5WithRSAEncryption":
                    csr.md = $2xc86.md.md5.create();
                    break;
                case "sha256WithRSAEncryption":
                    csr.md = $2xc86.md.sha256.create();
                    break;
                case "sha384WithRSAEncryption":
                    csr.md = $2xc86.md.sha384.create();
                    break;
                case "sha512WithRSAEncryption":
                    csr.md = $2xc86.md.sha512.create();
                    break;
                case "RSASSA-PSS":
                    csr.md = $2xc86.md.sha256.create();
                    break;
            }
        }
        if (csr.md === null) {
            var error = new Error("Could not compute certification request digest. Unknown signature OID.");
            error.signatureOid = csr.signatureOid;
            throw error;
        }
        // produce DER formatted CertificationRequestInfo and digest it
        var bytes = $3ff8d88cacdb42a4$var$asn1.toDer(csr.certificationRequestInfo);
        csr.md.update(bytes.getBytes());
    }
    // handle subject, build subject message digest
    var smd = $2xc86.md.sha1.create();
    csr.subject.getField = function(sn) {
        return $3ff8d88cacdb42a4$var$_getAttribute(csr.subject, sn);
    };
    csr.subject.addField = function(attr) {
        $3ff8d88cacdb42a4$var$_fillMissingFields([
            attr
        ]);
        csr.subject.attributes.push(attr);
    };
    csr.subject.attributes = $3ff8d88cacdb42a4$var$pki.RDNAttributesAsArray(capture.certificationRequestInfoSubject, smd);
    csr.subject.hash = smd.digest().toHex();
    // convert RSA public key from ASN.1
    csr.publicKey = $3ff8d88cacdb42a4$var$pki.publicKeyFromAsn1(capture.subjectPublicKeyInfo);
    // convert attributes from ASN.1
    csr.getAttribute = function(sn) {
        return $3ff8d88cacdb42a4$var$_getAttribute(csr, sn);
    };
    csr.addAttribute = function(attr) {
        $3ff8d88cacdb42a4$var$_fillMissingFields([
            attr
        ]);
        csr.attributes.push(attr);
    };
    csr.attributes = $3ff8d88cacdb42a4$var$pki.CRIAttributesAsArray(capture.certificationRequestInfoAttributes || []);
    return csr;
};
/**
 * Creates an empty certification request (a CSR or certificate signing
 * request). Once created, its public key and attributes can be set and then
 * it can be signed.
 *
 * @return the empty certification request.
 */ $3ff8d88cacdb42a4$var$pki.createCertificationRequest = function() {
    var csr = {};
    csr.version = 0x00;
    csr.signatureOid = null;
    csr.signature = null;
    csr.siginfo = {};
    csr.siginfo.algorithmOid = null;
    csr.subject = {};
    csr.subject.getField = function(sn) {
        return $3ff8d88cacdb42a4$var$_getAttribute(csr.subject, sn);
    };
    csr.subject.addField = function(attr) {
        $3ff8d88cacdb42a4$var$_fillMissingFields([
            attr
        ]);
        csr.subject.attributes.push(attr);
    };
    csr.subject.attributes = [];
    csr.subject.hash = null;
    csr.publicKey = null;
    csr.attributes = [];
    csr.getAttribute = function(sn) {
        return $3ff8d88cacdb42a4$var$_getAttribute(csr, sn);
    };
    csr.addAttribute = function(attr) {
        $3ff8d88cacdb42a4$var$_fillMissingFields([
            attr
        ]);
        csr.attributes.push(attr);
    };
    csr.md = null;
    /**
   * Sets the subject of this certification request.
   *
   * @param attrs the array of subject attributes to use.
   */ csr.setSubject = function(attrs) {
        // set new attributes
        $3ff8d88cacdb42a4$var$_fillMissingFields(attrs);
        csr.subject.attributes = attrs;
        csr.subject.hash = null;
    };
    /**
   * Sets the attributes of this certification request.
   *
   * @param attrs the array of attributes to use.
   */ csr.setAttributes = function(attrs) {
        // set new attributes
        $3ff8d88cacdb42a4$var$_fillMissingFields(attrs);
        csr.attributes = attrs;
    };
    /**
   * Signs this certification request using the given private key.
   *
   * @param key the private key to sign with.
   * @param md the message digest object to use (defaults to forge.md.sha1).
   */ csr.sign = function(key, md) {
        // TODO: get signature OID from private key
        csr.md = md || $2xc86.md.sha1.create();
        var algorithmOid = $3ff8d88cacdb42a4$var$oids[csr.md.algorithm + "WithRSAEncryption"];
        if (!algorithmOid) {
            var error = new Error("Could not compute certification request digest. Unknown message digest algorithm OID.");
            error.algorithm = csr.md.algorithm;
            throw error;
        }
        csr.signatureOid = csr.siginfo.algorithmOid = algorithmOid;
        // get CertificationRequestInfo, convert to DER
        csr.certificationRequestInfo = $3ff8d88cacdb42a4$var$pki.getCertificationRequestInfo(csr);
        var bytes = $3ff8d88cacdb42a4$var$asn1.toDer(csr.certificationRequestInfo);
        // digest and sign
        csr.md.update(bytes.getBytes());
        csr.signature = key.sign(csr.md);
    };
    /**
   * Attempts verify the signature on the passed certification request using
   * its public key.
   *
   * A CSR that has been exported to a file in PEM format can be verified using
   * OpenSSL using this command:
   *
   * openssl req -in <the-csr-pem-file> -verify -noout -text
   *
   * @return true if verified, false if not.
   */ csr.verify = function() {
        var rval = false;
        var md = csr.md;
        if (md === null) {
            // check signature OID for supported signature types
            if (csr.signatureOid in $3ff8d88cacdb42a4$var$oids) {
                // TODO: create DRY `OID to md` function
                var oid = $3ff8d88cacdb42a4$var$oids[csr.signatureOid];
                switch(oid){
                    case "sha1WithRSAEncryption":
                        md = $2xc86.md.sha1.create();
                        break;
                    case "md5WithRSAEncryption":
                        md = $2xc86.md.md5.create();
                        break;
                    case "sha256WithRSAEncryption":
                        md = $2xc86.md.sha256.create();
                        break;
                    case "sha384WithRSAEncryption":
                        md = $2xc86.md.sha384.create();
                        break;
                    case "sha512WithRSAEncryption":
                        md = $2xc86.md.sha512.create();
                        break;
                    case "RSASSA-PSS":
                        md = $2xc86.md.sha256.create();
                        break;
                }
            }
            if (md === null) {
                var error = new Error("Could not compute certification request digest. Unknown signature OID.");
                error.signatureOid = csr.signatureOid;
                throw error;
            }
            // produce DER formatted CertificationRequestInfo and digest it
            var cri = csr.certificationRequestInfo || $3ff8d88cacdb42a4$var$pki.getCertificationRequestInfo(csr);
            var bytes = $3ff8d88cacdb42a4$var$asn1.toDer(cri);
            md.update(bytes.getBytes());
        }
        if (md !== null) {
            var scheme;
            switch(csr.signatureOid){
                case $3ff8d88cacdb42a4$var$oids.sha1WithRSAEncryption:
                    break;
                case $3ff8d88cacdb42a4$var$oids["RSASSA-PSS"]:
                    var hash, mgf;
                    /* initialize mgf */ hash = $3ff8d88cacdb42a4$var$oids[csr.signatureParameters.mgf.hash.algorithmOid];
                    if (hash === undefined || $2xc86.md[hash] === undefined) {
                        var error = new Error("Unsupported MGF hash function.");
                        error.oid = csr.signatureParameters.mgf.hash.algorithmOid;
                        error.name = hash;
                        throw error;
                    }
                    mgf = $3ff8d88cacdb42a4$var$oids[csr.signatureParameters.mgf.algorithmOid];
                    if (mgf === undefined || $2xc86.mgf[mgf] === undefined) {
                        var error = new Error("Unsupported MGF function.");
                        error.oid = csr.signatureParameters.mgf.algorithmOid;
                        error.name = mgf;
                        throw error;
                    }
                    mgf = $2xc86.mgf[mgf].create($2xc86.md[hash].create());
                    /* initialize hash function */ hash = $3ff8d88cacdb42a4$var$oids[csr.signatureParameters.hash.algorithmOid];
                    if (hash === undefined || $2xc86.md[hash] === undefined) {
                        var error = new Error("Unsupported RSASSA-PSS hash function.");
                        error.oid = csr.signatureParameters.hash.algorithmOid;
                        error.name = hash;
                        throw error;
                    }
                    scheme = $2xc86.pss.create($2xc86.md[hash].create(), mgf, csr.signatureParameters.saltLength);
                    break;
            }
            // verify signature on csr using its public key
            rval = csr.publicKey.verify(md.digest().getBytes(), csr.signature, scheme);
        }
        return rval;
    };
    return csr;
};
/**
 * Converts an X.509 subject or issuer to an ASN.1 RDNSequence.
 *
 * @param obj the subject or issuer (distinguished name).
 *
 * @return the ASN.1 RDNSequence.
 */ function $3ff8d88cacdb42a4$var$_dnToAsn1(obj) {
    // create an empty RDNSequence
    var rval = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, []);
    // iterate over attributes
    var attr, set;
    var attrs = obj.attributes;
    for(var i = 0; i < attrs.length; ++i){
        attr = attrs[i];
        var value = attr.value;
        // reuse tag class for attribute value if available
        var valueTagClass = $3ff8d88cacdb42a4$var$asn1.Type.PRINTABLESTRING;
        if ("valueTagClass" in attr) {
            valueTagClass = attr.valueTagClass;
            if (valueTagClass === $3ff8d88cacdb42a4$var$asn1.Type.UTF8) value = $2xc86.util.encodeUtf8(value);
        // FIXME: handle more encodings
        }
        // create a RelativeDistinguishedName set
        // each value in the set is an AttributeTypeAndValue first
        // containing the type (an OID) and second the value
        set = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SET, true, [
            $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, [
                // AttributeType
                $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.OID, false, $3ff8d88cacdb42a4$var$asn1.oidToDer(attr.type).getBytes()),
                // AttributeValue
                $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, valueTagClass, false, value)
            ])
        ]);
        rval.value.push(set);
    }
    return rval;
}
/**
 * Gets all printable attributes (typically of an issuer or subject) in a
 * simplified JSON format for display.
 *
 * @param attrs the attributes.
 *
 * @return the JSON for display.
 */ function $3ff8d88cacdb42a4$var$_getAttributesAsJson(attrs) {
    var rval = {};
    for(var i = 0; i < attrs.length; ++i){
        var attr = attrs[i];
        if (attr.shortName && (attr.valueTagClass === $3ff8d88cacdb42a4$var$asn1.Type.UTF8 || attr.valueTagClass === $3ff8d88cacdb42a4$var$asn1.Type.PRINTABLESTRING || attr.valueTagClass === $3ff8d88cacdb42a4$var$asn1.Type.IA5STRING)) {
            var value = attr.value;
            if (attr.valueTagClass === $3ff8d88cacdb42a4$var$asn1.Type.UTF8) value = $2xc86.util.encodeUtf8(attr.value);
            if (!(attr.shortName in rval)) rval[attr.shortName] = value;
            else if ($2xc86.util.isArray(rval[attr.shortName])) rval[attr.shortName].push(value);
            else rval[attr.shortName] = [
                rval[attr.shortName],
                value
            ];
        }
    }
    return rval;
}
/**
 * Fills in missing fields in attributes.
 *
 * @param attrs the attributes to fill missing fields in.
 */ function $3ff8d88cacdb42a4$var$_fillMissingFields(attrs) {
    var attr;
    for(var i = 0; i < attrs.length; ++i){
        attr = attrs[i];
        // populate missing name
        if (typeof attr.name === "undefined") {
            if (attr.type && attr.type in $3ff8d88cacdb42a4$var$pki.oids) attr.name = $3ff8d88cacdb42a4$var$pki.oids[attr.type];
            else if (attr.shortName && attr.shortName in $3ff8d88cacdb42a4$var$_shortNames) attr.name = $3ff8d88cacdb42a4$var$pki.oids[$3ff8d88cacdb42a4$var$_shortNames[attr.shortName]];
        }
        // populate missing type (OID)
        if (typeof attr.type === "undefined") {
            if (attr.name && attr.name in $3ff8d88cacdb42a4$var$pki.oids) attr.type = $3ff8d88cacdb42a4$var$pki.oids[attr.name];
            else {
                var error = new Error("Attribute type not specified.");
                error.attribute = attr;
                throw error;
            }
        }
        // populate missing shortname
        if (typeof attr.shortName === "undefined") {
            if (attr.name && attr.name in $3ff8d88cacdb42a4$var$_shortNames) attr.shortName = $3ff8d88cacdb42a4$var$_shortNames[attr.name];
        }
        // convert extensions to value
        if (attr.type === $3ff8d88cacdb42a4$var$oids.extensionRequest) {
            attr.valueConstructed = true;
            attr.valueTagClass = $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE;
            if (!attr.value && attr.extensions) {
                attr.value = [];
                for(var ei = 0; ei < attr.extensions.length; ++ei)attr.value.push($3ff8d88cacdb42a4$var$pki.certificateExtensionToAsn1($3ff8d88cacdb42a4$var$_fillMissingExtensionFields(attr.extensions[ei])));
            }
        }
        if (typeof attr.value === "undefined") {
            var error = new Error("Attribute value not specified.");
            error.attribute = attr;
            throw error;
        }
    }
}
/**
 * Fills in missing fields in certificate extensions.
 *
 * @param e the extension.
 * @param [options] the options to use.
 *          [cert] the certificate the extensions are for.
 *
 * @return the extension.
 */ function $3ff8d88cacdb42a4$var$_fillMissingExtensionFields(e, options) {
    options = options || {};
    // populate missing name
    if (typeof e.name === "undefined") {
        if (e.id && e.id in $3ff8d88cacdb42a4$var$pki.oids) e.name = $3ff8d88cacdb42a4$var$pki.oids[e.id];
    }
    // populate missing id
    if (typeof e.id === "undefined") {
        if (e.name && e.name in $3ff8d88cacdb42a4$var$pki.oids) e.id = $3ff8d88cacdb42a4$var$pki.oids[e.name];
        else {
            var error = new Error("Extension ID not specified.");
            error.extension = e;
            throw error;
        }
    }
    if (typeof e.value !== "undefined") return e;
    // handle missing value:
    // value is a BIT STRING
    if (e.name === "keyUsage") {
        // build flags
        var unused = 0;
        var b2 = 0x00;
        var b3 = 0x00;
        if (e.digitalSignature) {
            b2 |= 0x80;
            unused = 7;
        }
        if (e.nonRepudiation) {
            b2 |= 0x40;
            unused = 6;
        }
        if (e.keyEncipherment) {
            b2 |= 0x20;
            unused = 5;
        }
        if (e.dataEncipherment) {
            b2 |= 0x10;
            unused = 4;
        }
        if (e.keyAgreement) {
            b2 |= 0x08;
            unused = 3;
        }
        if (e.keyCertSign) {
            b2 |= 0x04;
            unused = 2;
        }
        if (e.cRLSign) {
            b2 |= 0x02;
            unused = 1;
        }
        if (e.encipherOnly) {
            b2 |= 0x01;
            unused = 0;
        }
        if (e.decipherOnly) {
            b3 |= 0x80;
            unused = 7;
        }
        // create bit string
        var value = String.fromCharCode(unused);
        if (b3 !== 0) value += String.fromCharCode(b2) + String.fromCharCode(b3);
        else if (b2 !== 0) value += String.fromCharCode(b2);
        e.value = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.BITSTRING, false, value);
    } else if (e.name === "basicConstraints") {
        // basicConstraints is a SEQUENCE
        e.value = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, []);
        // cA BOOLEAN flag defaults to false
        if (e.cA) e.value.value.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.BOOLEAN, false, String.fromCharCode(0xFF)));
        if ("pathLenConstraint" in e) e.value.value.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.INTEGER, false, $3ff8d88cacdb42a4$var$asn1.integerToDer(e.pathLenConstraint).getBytes()));
    } else if (e.name === "extKeyUsage") {
        // extKeyUsage is a SEQUENCE of OIDs
        e.value = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, []);
        var seq = e.value.value;
        for(var key in e){
            if (e[key] !== true) continue;
            // key is name in OID map
            if (key in $3ff8d88cacdb42a4$var$oids) seq.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.OID, false, $3ff8d88cacdb42a4$var$asn1.oidToDer($3ff8d88cacdb42a4$var$oids[key]).getBytes()));
            else if (key.indexOf(".") !== -1) // assume key is an OID
            seq.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.OID, false, $3ff8d88cacdb42a4$var$asn1.oidToDer(key).getBytes()));
        }
    } else if (e.name === "nsCertType") {
        // nsCertType is a BIT STRING
        // build flags
        var unused = 0;
        var b2 = 0x00;
        if (e.client) {
            b2 |= 0x80;
            unused = 7;
        }
        if (e.server) {
            b2 |= 0x40;
            unused = 6;
        }
        if (e.email) {
            b2 |= 0x20;
            unused = 5;
        }
        if (e.objsign) {
            b2 |= 0x10;
            unused = 4;
        }
        if (e.reserved) {
            b2 |= 0x08;
            unused = 3;
        }
        if (e.sslCA) {
            b2 |= 0x04;
            unused = 2;
        }
        if (e.emailCA) {
            b2 |= 0x02;
            unused = 1;
        }
        if (e.objCA) {
            b2 |= 0x01;
            unused = 0;
        }
        // create bit string
        var value = String.fromCharCode(unused);
        if (b2 !== 0) value += String.fromCharCode(b2);
        e.value = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.BITSTRING, false, value);
    } else if (e.name === "subjectAltName" || e.name === "issuerAltName") {
        // SYNTAX SEQUENCE
        e.value = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, []);
        var altName;
        for(var n = 0; n < e.altNames.length; ++n){
            altName = e.altNames[n];
            var value = altName.value;
            // handle IP
            if (altName.type === 7 && altName.ip) {
                value = $2xc86.util.bytesFromIP(altName.ip);
                if (value === null) {
                    var error = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.');
                    error.extension = e;
                    throw error;
                }
            } else if (altName.type === 8) {
                // handle OID
                if (altName.oid) value = $3ff8d88cacdb42a4$var$asn1.oidToDer($3ff8d88cacdb42a4$var$asn1.oidToDer(altName.oid));
                else // deprecated ... convert value to OID
                value = $3ff8d88cacdb42a4$var$asn1.oidToDer(value);
            }
            e.value.value.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC, altName.type, false, value));
        }
    } else if (e.name === "nsComment" && options.cert) {
        // sanity check value is ASCII (req'd) and not too big
        if (!/^[\x00-\x7F]*$/.test(e.comment) || e.comment.length < 1 || e.comment.length > 128) throw new Error('Invalid "nsComment" content.');
        // IA5STRING opaque comment
        e.value = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.IA5STRING, false, e.comment);
    } else if (e.name === "subjectKeyIdentifier" && options.cert) {
        var ski = options.cert.generateSubjectKeyIdentifier();
        e.subjectKeyIdentifier = ski.toHex();
        // OCTETSTRING w/digest
        e.value = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.OCTETSTRING, false, ski.getBytes());
    } else if (e.name === "authorityKeyIdentifier" && options.cert) {
        // SYNTAX SEQUENCE
        e.value = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, []);
        var seq = e.value.value;
        if (e.keyIdentifier) {
            var keyIdentifier = e.keyIdentifier === true ? options.cert.generateSubjectKeyIdentifier().getBytes() : e.keyIdentifier;
            seq.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC, 0, false, keyIdentifier));
        }
        if (e.authorityCertIssuer) {
            var authorityCertIssuer = [
                $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC, 4, true, [
                    $3ff8d88cacdb42a4$var$_dnToAsn1(e.authorityCertIssuer === true ? options.cert.issuer : e.authorityCertIssuer)
                ])
            ];
            seq.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, authorityCertIssuer));
        }
        if (e.serialNumber) {
            var serialNumber = $2xc86.util.hexToBytes(e.serialNumber === true ? options.cert.serialNumber : e.serialNumber);
            seq.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC, 2, false, serialNumber));
        }
    } else if (e.name === "cRLDistributionPoints") {
        e.value = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, []);
        var seq = e.value.value;
        // Create sub SEQUENCE of DistributionPointName
        var subSeq = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, []);
        // Create fullName CHOICE
        var fullNameGeneralNames = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, []);
        var altName;
        for(var n = 0; n < e.altNames.length; ++n){
            altName = e.altNames[n];
            var value = altName.value;
            // handle IP
            if (altName.type === 7 && altName.ip) {
                value = $2xc86.util.bytesFromIP(altName.ip);
                if (value === null) {
                    var error = new Error('Extension "ip" value is not a valid IPv4 or IPv6 address.');
                    error.extension = e;
                    throw error;
                }
            } else if (altName.type === 8) {
                // handle OID
                if (altName.oid) value = $3ff8d88cacdb42a4$var$asn1.oidToDer($3ff8d88cacdb42a4$var$asn1.oidToDer(altName.oid));
                else // deprecated ... convert value to OID
                value = $3ff8d88cacdb42a4$var$asn1.oidToDer(value);
            }
            fullNameGeneralNames.value.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC, altName.type, false, value));
        }
        // Add to the parent SEQUENCE
        subSeq.value.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
            fullNameGeneralNames
        ]));
        seq.push(subSeq);
    }
    // ensure value has been defined by now
    if (typeof e.value === "undefined") {
        var error = new Error("Extension value not specified.");
        error.extension = e;
        throw error;
    }
    return e;
}
/**
 * Convert signature parameters object to ASN.1
 *
 * @param {String} oid Signature algorithm OID
 * @param params The signature parametrs object
 * @return ASN.1 object representing signature parameters
 */ function $3ff8d88cacdb42a4$var$_signatureParametersToAsn1(oid, params) {
    switch(oid){
        case $3ff8d88cacdb42a4$var$oids["RSASSA-PSS"]:
            var parts = [];
            if (params.hash.algorithmOid !== undefined) parts.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
                $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, [
                    $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.OID, false, $3ff8d88cacdb42a4$var$asn1.oidToDer(params.hash.algorithmOid).getBytes()),
                    $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.NULL, false, "")
                ])
            ]));
            if (params.mgf.algorithmOid !== undefined) parts.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, [
                $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, [
                    $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.OID, false, $3ff8d88cacdb42a4$var$asn1.oidToDer(params.mgf.algorithmOid).getBytes()),
                    $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, [
                        $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.OID, false, $3ff8d88cacdb42a4$var$asn1.oidToDer(params.mgf.hash.algorithmOid).getBytes()),
                        $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.NULL, false, "")
                    ])
                ])
            ]));
            if (params.saltLength !== undefined) parts.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC, 2, true, [
                $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.INTEGER, false, $3ff8d88cacdb42a4$var$asn1.integerToDer(params.saltLength).getBytes())
            ]));
            return $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, parts);
        default:
            return $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.NULL, false, "");
    }
}
/**
 * Converts a certification request's attributes to an ASN.1 set of
 * CRIAttributes.
 *
 * @param csr certification request.
 *
 * @return the ASN.1 set of CRIAttributes.
 */ function $3ff8d88cacdb42a4$var$_CRIAttributesToAsn1(csr) {
    // create an empty context-specific container
    var rval = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, []);
    // no attributes, return empty container
    if (csr.attributes.length === 0) return rval;
    // each attribute has a sequence with a type and a set of values
    var attrs = csr.attributes;
    for(var i = 0; i < attrs.length; ++i){
        var attr = attrs[i];
        var value = attr.value;
        // reuse tag class for attribute value if available
        var valueTagClass = $3ff8d88cacdb42a4$var$asn1.Type.UTF8;
        if ("valueTagClass" in attr) valueTagClass = attr.valueTagClass;
        if (valueTagClass === $3ff8d88cacdb42a4$var$asn1.Type.UTF8) value = $2xc86.util.encodeUtf8(value);
        var valueConstructed = false;
        if ("valueConstructed" in attr) valueConstructed = attr.valueConstructed;
        // FIXME: handle more encodings
        // create a RelativeDistinguishedName set
        // each value in the set is an AttributeTypeAndValue first
        // containing the type (an OID) and second the value
        var seq = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, [
            // AttributeType
            $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.OID, false, $3ff8d88cacdb42a4$var$asn1.oidToDer(attr.type).getBytes()),
            $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SET, true, [
                // AttributeValue
                $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, valueTagClass, valueConstructed, value)
            ])
        ]);
        rval.value.push(seq);
    }
    return rval;
}
var $3ff8d88cacdb42a4$var$jan_1_1950 = new Date("1950-01-01T00:00:00Z");
var $3ff8d88cacdb42a4$var$jan_1_2050 = new Date("2050-01-01T00:00:00Z");
/**
 * Converts a Date object to ASN.1
 * Handles the different format before and after 1st January 2050
 *
 * @param date date object.
 *
 * @return the ASN.1 object representing the date.
 */ function $3ff8d88cacdb42a4$var$_dateToAsn1(date) {
    if (date >= $3ff8d88cacdb42a4$var$jan_1_1950 && date < $3ff8d88cacdb42a4$var$jan_1_2050) return $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.UTCTIME, false, $3ff8d88cacdb42a4$var$asn1.dateToUtcTime(date));
    else return $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.GENERALIZEDTIME, false, $3ff8d88cacdb42a4$var$asn1.dateToGeneralizedTime(date));
}
/**
 * Gets the ASN.1 TBSCertificate part of an X.509v3 certificate.
 *
 * @param cert the certificate.
 *
 * @return the asn1 TBSCertificate.
 */ $3ff8d88cacdb42a4$var$pki.getTBSCertificate = function(cert) {
    // TBSCertificate
    var notBefore = $3ff8d88cacdb42a4$var$_dateToAsn1(cert.validity.notBefore);
    var notAfter = $3ff8d88cacdb42a4$var$_dateToAsn1(cert.validity.notAfter);
    var tbs = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, [
        // version
        $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC, 0, true, [
            // integer
            $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.INTEGER, false, $3ff8d88cacdb42a4$var$asn1.integerToDer(cert.version).getBytes())
        ]),
        // serialNumber
        $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.INTEGER, false, $2xc86.util.hexToBytes(cert.serialNumber)),
        // signature
        $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.OID, false, $3ff8d88cacdb42a4$var$asn1.oidToDer(cert.siginfo.algorithmOid).getBytes()),
            // parameters
            $3ff8d88cacdb42a4$var$_signatureParametersToAsn1(cert.siginfo.algorithmOid, cert.siginfo.parameters)
        ]),
        // issuer
        $3ff8d88cacdb42a4$var$_dnToAsn1(cert.issuer),
        // validity
        $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, [
            notBefore,
            notAfter
        ]),
        // subject
        $3ff8d88cacdb42a4$var$_dnToAsn1(cert.subject),
        // SubjectPublicKeyInfo
        $3ff8d88cacdb42a4$var$pki.publicKeyToAsn1(cert.publicKey)
    ]);
    if (cert.issuer.uniqueId) // issuerUniqueID (optional)
    tbs.value.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC, 1, true, [
        $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.BITSTRING, false, // TODO: support arbitrary bit length ids
        String.fromCharCode(0x00) + cert.issuer.uniqueId)
    ]));
    if (cert.subject.uniqueId) // subjectUniqueID (optional)
    tbs.value.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC, 2, true, [
        $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.BITSTRING, false, // TODO: support arbitrary bit length ids
        String.fromCharCode(0x00) + cert.subject.uniqueId)
    ]));
    if (cert.extensions.length > 0) // extensions (optional)
    tbs.value.push($3ff8d88cacdb42a4$var$pki.certificateExtensionsToAsn1(cert.extensions));
    return tbs;
};
/**
 * Gets the ASN.1 CertificationRequestInfo part of a
 * PKCS#10 CertificationRequest.
 *
 * @param csr the certification request.
 *
 * @return the asn1 CertificationRequestInfo.
 */ $3ff8d88cacdb42a4$var$pki.getCertificationRequestInfo = function(csr) {
    // CertificationRequestInfo
    var cri = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, [
        // version
        $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.INTEGER, false, $3ff8d88cacdb42a4$var$asn1.integerToDer(csr.version).getBytes()),
        // subject
        $3ff8d88cacdb42a4$var$_dnToAsn1(csr.subject),
        // SubjectPublicKeyInfo
        $3ff8d88cacdb42a4$var$pki.publicKeyToAsn1(csr.publicKey),
        // attributes
        $3ff8d88cacdb42a4$var$_CRIAttributesToAsn1(csr)
    ]);
    return cri;
};
/**
 * Converts a DistinguishedName (subject or issuer) to an ASN.1 object.
 *
 * @param dn the DistinguishedName.
 *
 * @return the asn1 representation of a DistinguishedName.
 */ $3ff8d88cacdb42a4$var$pki.distinguishedNameToAsn1 = function(dn) {
    return $3ff8d88cacdb42a4$var$_dnToAsn1(dn);
};
/**
 * Converts an X.509v3 RSA certificate to an ASN.1 object.
 *
 * @param cert the certificate.
 *
 * @return the asn1 representation of an X.509v3 RSA certificate.
 */ $3ff8d88cacdb42a4$var$pki.certificateToAsn1 = function(cert) {
    // prefer cached TBSCertificate over generating one
    var tbsCertificate = cert.tbsCertificate || $3ff8d88cacdb42a4$var$pki.getTBSCertificate(cert);
    // Certificate
    return $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, [
        // TBSCertificate
        tbsCertificate,
        // AlgorithmIdentifier (signature algorithm)
        $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.OID, false, $3ff8d88cacdb42a4$var$asn1.oidToDer(cert.signatureOid).getBytes()),
            // parameters
            $3ff8d88cacdb42a4$var$_signatureParametersToAsn1(cert.signatureOid, cert.signatureParameters)
        ]),
        // SignatureValue
        $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.BITSTRING, false, String.fromCharCode(0x00) + cert.signature)
    ]);
};
/**
 * Converts X.509v3 certificate extensions to ASN.1.
 *
 * @param exts the extensions to convert.
 *
 * @return the extensions in ASN.1 format.
 */ $3ff8d88cacdb42a4$var$pki.certificateExtensionsToAsn1 = function(exts) {
    // create top-level extension container
    var rval = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.CONTEXT_SPECIFIC, 3, true, []);
    // create extension sequence (stores a sequence for each extension)
    var seq = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, []);
    rval.value.push(seq);
    for(var i = 0; i < exts.length; ++i)seq.value.push($3ff8d88cacdb42a4$var$pki.certificateExtensionToAsn1(exts[i]));
    return rval;
};
/**
 * Converts a single certificate extension to ASN.1.
 *
 * @param ext the extension to convert.
 *
 * @return the extension in ASN.1 format.
 */ $3ff8d88cacdb42a4$var$pki.certificateExtensionToAsn1 = function(ext) {
    // create a sequence for each extension
    var extseq = $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, []);
    // extnID (OID)
    extseq.value.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.OID, false, $3ff8d88cacdb42a4$var$asn1.oidToDer(ext.id).getBytes()));
    // critical defaults to false
    if (ext.critical) // critical BOOLEAN DEFAULT FALSE
    extseq.value.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.BOOLEAN, false, String.fromCharCode(0xFF)));
    var value = ext.value;
    if (typeof ext.value !== "string") // value is asn.1
    value = $3ff8d88cacdb42a4$var$asn1.toDer(value).getBytes();
    // extnValue (OCTET STRING)
    extseq.value.push($3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.OCTETSTRING, false, value));
    return extseq;
};
/**
 * Converts a PKCS#10 certification request to an ASN.1 object.
 *
 * @param csr the certification request.
 *
 * @return the asn1 representation of a certification request.
 */ $3ff8d88cacdb42a4$var$pki.certificationRequestToAsn1 = function(csr) {
    // prefer cached CertificationRequestInfo over generating one
    var cri = csr.certificationRequestInfo || $3ff8d88cacdb42a4$var$pki.getCertificationRequestInfo(csr);
    // Certificate
    return $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, [
        // CertificationRequestInfo
        cri,
        // AlgorithmIdentifier (signature algorithm)
        $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.OID, false, $3ff8d88cacdb42a4$var$asn1.oidToDer(csr.signatureOid).getBytes()),
            // parameters
            $3ff8d88cacdb42a4$var$_signatureParametersToAsn1(csr.signatureOid, csr.signatureParameters)
        ]),
        // signature
        $3ff8d88cacdb42a4$var$asn1.create($3ff8d88cacdb42a4$var$asn1.Class.UNIVERSAL, $3ff8d88cacdb42a4$var$asn1.Type.BITSTRING, false, String.fromCharCode(0x00) + csr.signature)
    ]);
};
/**
 * Creates a CA store.
 *
 * @param certs an optional array of certificate objects or PEM-formatted
 *          certificate strings to add to the CA store.
 *
 * @return the CA store.
 */ $3ff8d88cacdb42a4$var$pki.createCaStore = function(certs) {
    // create CA store
    var caStore = {
        // stored certificates
        certs: {}
    };
    /**
   * Gets the certificate that issued the passed certificate or its
   * 'parent'.
   *
   * @param cert the certificate to get the parent for.
   *
   * @return the parent certificate or null if none was found.
   */ caStore.getIssuer = function(cert) {
        var rval = getBySubject(cert.issuer);
        // see if there are multiple matches
        /*if(forge.util.isArray(rval)) {
      // TODO: resolve multiple matches by checking
      // authorityKey/subjectKey/issuerUniqueID/other identifiers, etc.
      // FIXME: or alternatively do authority key mapping
      // if possible (X.509v1 certs can't work?)
      throw new Error('Resolving multiple issuer matches not implemented yet.');
    }*/ return rval;
    };
    /**
   * Adds a trusted certificate to the store.
   *
   * @param cert the certificate to add as a trusted certificate (either a
   *          pki.certificate object or a PEM-formatted certificate).
   */ caStore.addCertificate = function(cert) {
        // convert from pem if necessary
        if (typeof cert === "string") cert = $2xc86.pki.certificateFromPem(cert);
        ensureSubjectHasHash(cert.subject);
        if (!caStore.hasCertificate(cert)) {
            if (cert.subject.hash in caStore.certs) {
                // subject hash already exists, append to array
                var tmp = caStore.certs[cert.subject.hash];
                if (!$2xc86.util.isArray(tmp)) tmp = [
                    tmp
                ];
                tmp.push(cert);
                caStore.certs[cert.subject.hash] = tmp;
            } else caStore.certs[cert.subject.hash] = cert;
        }
    };
    /**
   * Checks to see if the given certificate is in the store.
   *
   * @param cert the certificate to check (either a pki.certificate or a
   *          PEM-formatted certificate).
   *
   * @return true if the certificate is in the store, false if not.
   */ caStore.hasCertificate = function(cert) {
        // convert from pem if necessary
        if (typeof cert === "string") cert = $2xc86.pki.certificateFromPem(cert);
        var match = getBySubject(cert.subject);
        if (!match) return false;
        if (!$2xc86.util.isArray(match)) match = [
            match
        ];
        // compare DER-encoding of certificates
        var der1 = $3ff8d88cacdb42a4$var$asn1.toDer($3ff8d88cacdb42a4$var$pki.certificateToAsn1(cert)).getBytes();
        for(var i = 0; i < match.length; ++i){
            var der2 = $3ff8d88cacdb42a4$var$asn1.toDer($3ff8d88cacdb42a4$var$pki.certificateToAsn1(match[i])).getBytes();
            if (der1 === der2) return true;
        }
        return false;
    };
    /**
   * Lists all of the certificates kept in the store.
   *
   * @return an array of all of the pki.certificate objects in the store.
   */ caStore.listAllCertificates = function() {
        var certList = [];
        for(var hash in caStore.certs)if (caStore.certs.hasOwnProperty(hash)) {
            var value = caStore.certs[hash];
            if (!$2xc86.util.isArray(value)) certList.push(value);
            else for(var i = 0; i < value.length; ++i)certList.push(value[i]);
        }
        return certList;
    };
    /**
   * Removes a certificate from the store.
   *
   * @param cert the certificate to remove (either a pki.certificate or a
   *          PEM-formatted certificate).
   *
   * @return the certificate that was removed or null if the certificate
   *           wasn't in store.
   */ caStore.removeCertificate = function(cert) {
        var result;
        // convert from pem if necessary
        if (typeof cert === "string") cert = $2xc86.pki.certificateFromPem(cert);
        ensureSubjectHasHash(cert.subject);
        if (!caStore.hasCertificate(cert)) return null;
        var match = getBySubject(cert.subject);
        if (!$2xc86.util.isArray(match)) {
            result = caStore.certs[cert.subject.hash];
            delete caStore.certs[cert.subject.hash];
            return result;
        }
        // compare DER-encoding of certificates
        var der1 = $3ff8d88cacdb42a4$var$asn1.toDer($3ff8d88cacdb42a4$var$pki.certificateToAsn1(cert)).getBytes();
        for(var i = 0; i < match.length; ++i){
            var der2 = $3ff8d88cacdb42a4$var$asn1.toDer($3ff8d88cacdb42a4$var$pki.certificateToAsn1(match[i])).getBytes();
            if (der1 === der2) {
                result = match[i];
                match.splice(i, 1);
            }
        }
        if (match.length === 0) delete caStore.certs[cert.subject.hash];
        return result;
    };
    function getBySubject(subject) {
        ensureSubjectHasHash(subject);
        return caStore.certs[subject.hash] || null;
    }
    function ensureSubjectHasHash(subject) {
        // produce subject hash if it doesn't exist
        if (!subject.hash) {
            var md = $2xc86.md.sha1.create();
            subject.attributes = $3ff8d88cacdb42a4$var$pki.RDNAttributesAsArray($3ff8d88cacdb42a4$var$_dnToAsn1(subject), md);
            subject.hash = md.digest().toHex();
        }
    }
    // auto-add passed in certs
    if (certs) // parse PEM-formatted certificates as necessary
    for(var i = 0; i < certs.length; ++i){
        var cert = certs[i];
        caStore.addCertificate(cert);
    }
    return caStore;
};
/**
 * Certificate verification errors, based on TLS.
 */ $3ff8d88cacdb42a4$var$pki.certificateError = {
    bad_certificate: "forge.pki.BadCertificate",
    unsupported_certificate: "forge.pki.UnsupportedCertificate",
    certificate_revoked: "forge.pki.CertificateRevoked",
    certificate_expired: "forge.pki.CertificateExpired",
    certificate_unknown: "forge.pki.CertificateUnknown",
    unknown_ca: "forge.pki.UnknownCertificateAuthority"
};
/**
 * Verifies a certificate chain against the given Certificate Authority store
 * with an optional custom verify callback.
 *
 * @param caStore a certificate store to verify against.
 * @param chain the certificate chain to verify, with the root or highest
 *          authority at the end (an array of certificates).
 * @param options a callback to be called for every certificate in the chain or
 *                  an object with:
 *                  verify a callback to be called for every certificate in the
 *                    chain
 *                  validityCheckDate the date against which the certificate
 *                    validity period should be checked. Pass null to not check
 *                    the validity period. By default, the current date is used.
 *
 * The verify callback has the following signature:
 *
 * verified - Set to true if certificate was verified, otherwise the
 *   pki.certificateError for why the certificate failed.
 * depth - The current index in the chain, where 0 is the end point's cert.
 * certs - The certificate chain, *NOTE* an empty chain indicates an anonymous
 *   end point.
 *
 * The function returns true on success and on failure either the appropriate
 * pki.certificateError or an object with 'error' set to the appropriate
 * pki.certificateError and 'message' set to a custom error message.
 *
 * @return true if successful, error thrown if not.
 */ $3ff8d88cacdb42a4$var$pki.verifyCertificateChain = function(caStore, chain, options) {
    /* From: RFC3280 - Internet X.509 Public Key Infrastructure Certificate
    Section 6: Certification Path Validation
    See inline parentheticals related to this particular implementation.

    The primary goal of path validation is to verify the binding between
    a subject distinguished name or a subject alternative name and subject
    public key, as represented in the end entity certificate, based on the
    public key of the trust anchor. This requires obtaining a sequence of
    certificates that support that binding. That sequence should be provided
    in the passed 'chain'. The trust anchor should be in the given CA
    store. The 'end entity' certificate is the certificate provided by the
    end point (typically a server) and is the first in the chain.

    To meet this goal, the path validation process verifies, among other
    things, that a prospective certification path (a sequence of n
    certificates or a 'chain') satisfies the following conditions:

    (a) for all x in {1, ..., n-1}, the subject of certificate x is
          the issuer of certificate x+1;

    (b) certificate 1 is issued by the trust anchor;

    (c) certificate n is the certificate to be validated; and

    (d) for all x in {1, ..., n}, the certificate was valid at the
          time in question.

    Note that here 'n' is index 0 in the chain and 1 is the last certificate
    in the chain and it must be signed by a certificate in the connection's
    CA store.

    The path validation process also determines the set of certificate
    policies that are valid for this path, based on the certificate policies
    extension, policy mapping extension, policy constraints extension, and
    inhibit any-policy extension.

    Note: Policy mapping extension not supported (Not Required).

    Note: If the certificate has an unsupported critical extension, then it
    must be rejected.

    Note: A certificate is self-issued if the DNs that appear in the subject
    and issuer fields are identical and are not empty.

    The path validation algorithm assumes the following seven inputs are
    provided to the path processing logic. What this specific implementation
    will use is provided parenthetically:

    (a) a prospective certification path of length n (the 'chain')
    (b) the current date/time: ('now').
    (c) user-initial-policy-set: A set of certificate policy identifiers
          naming the policies that are acceptable to the certificate user.
          The user-initial-policy-set contains the special value any-policy
          if the user is not concerned about certificate policy
          (Not implemented. Any policy is accepted).
    (d) trust anchor information, describing a CA that serves as a trust
          anchor for the certification path. The trust anchor information
          includes:

      (1)  the trusted issuer name,
      (2)  the trusted public key algorithm,
      (3)  the trusted public key, and
      (4)  optionally, the trusted public key parameters associated
             with the public key.

      (Trust anchors are provided via certificates in the CA store).

      The trust anchor information may be provided to the path processing
      procedure in the form of a self-signed certificate. The trusted anchor
      information is trusted because it was delivered to the path processing
      procedure by some trustworthy out-of-band procedure. If the trusted
      public key algorithm requires parameters, then the parameters are
      provided along with the trusted public key (No parameters used in this
      implementation).

    (e) initial-policy-mapping-inhibit, which indicates if policy mapping is
          allowed in the certification path.
          (Not implemented, no policy checking)

    (f) initial-explicit-policy, which indicates if the path must be valid
          for at least one of the certificate policies in the user-initial-
          policy-set.
          (Not implemented, no policy checking)

    (g) initial-any-policy-inhibit, which indicates whether the
          anyPolicy OID should be processed if it is included in a
          certificate.
          (Not implemented, so any policy is valid provided that it is
          not marked as critical) */ /* Basic Path Processing:

    For each certificate in the 'chain', the following is checked:

    1. The certificate validity period includes the current time.
    2. The certificate was signed by its parent (where the parent is either
       the next in the chain or from the CA store). Allow processing to
       continue to the next step if no parent is found but the certificate is
       in the CA store.
    3. TODO: The certificate has not been revoked.
    4. The certificate issuer name matches the parent's subject name.
    5. TODO: If the certificate is self-issued and not the final certificate
       in the chain, skip this step, otherwise verify that the subject name
       is within one of the permitted subtrees of X.500 distinguished names
       and that each of the alternative names in the subjectAltName extension
       (critical or non-critical) is within one of the permitted subtrees for
       that name type.
    6. TODO: If the certificate is self-issued and not the final certificate
       in the chain, skip this step, otherwise verify that the subject name
       is not within one of the excluded subtrees for X.500 distinguished
       names and none of the subjectAltName extension names are excluded for
       that name type.
    7. The other steps in the algorithm for basic path processing involve
       handling the policy extension which is not presently supported in this
       implementation. Instead, if a critical policy extension is found, the
       certificate is rejected as not supported.
    8. If the certificate is not the first or if its the only certificate in
       the chain (having no parent from the CA store or is self-signed) and it
       has a critical key usage extension, verify that the keyCertSign bit is
       set. If the key usage extension exists, verify that the basic
       constraints extension exists. If the basic constraints extension exists,
       verify that the cA flag is set. If pathLenConstraint is set, ensure that
       the number of certificates that precede in the chain (come earlier
       in the chain as implemented below), excluding the very first in the
       chain (typically the end-entity one), isn't greater than the
       pathLenConstraint. This constraint limits the number of intermediate
       CAs that may appear below a CA before only end-entity certificates
       may be issued. */ // if a verify callback is passed as the third parameter, package it within
    // the options object. This is to support a legacy function signature that
    // expected the verify callback as the third parameter.
    if (typeof options === "function") options = {
        verify: options
    };
    options = options || {};
    // copy cert chain references to another array to protect against changes
    // in verify callback
    chain = chain.slice(0);
    var certs = chain.slice(0);
    var validityCheckDate = options.validityCheckDate;
    // if no validityCheckDate is specified, default to the current date. Make
    // sure to maintain the value null because it indicates that the validity
    // period should not be checked.
    if (typeof validityCheckDate === "undefined") validityCheckDate = new Date();
    // verify each cert in the chain using its parent, where the parent
    // is either the next in the chain or from the CA store
    var first = true;
    var error = null;
    var depth = 0;
    do {
        var cert = chain.shift();
        var parent = null;
        var selfSigned = false;
        if (validityCheckDate) // 1. check valid time
        {
            if (validityCheckDate < cert.validity.notBefore || validityCheckDate > cert.validity.notAfter) error = {
                message: "Certificate is not valid yet or has expired.",
                error: $3ff8d88cacdb42a4$var$pki.certificateError.certificate_expired,
                notBefore: cert.validity.notBefore,
                notAfter: cert.validity.notAfter,
                // TODO: we might want to reconsider renaming 'now' to
                // 'validityCheckDate' should this API be changed in the future.
                now: validityCheckDate
            };
        }
        // 2. verify with parent from chain or CA store
        if (error === null) {
            parent = chain[0] || caStore.getIssuer(cert);
            if (parent === null) // check for self-signed cert
            {
                if (cert.isIssuer(cert)) {
                    selfSigned = true;
                    parent = cert;
                }
            }
            if (parent) {
                // FIXME: current CA store implementation might have multiple
                // certificates where the issuer can't be determined from the
                // certificate (happens rarely with, eg: old certificates) so normalize
                // by always putting parents into an array
                // TODO: there's may be an extreme degenerate case currently uncovered
                // where an old intermediate certificate seems to have a matching parent
                // but none of the parents actually verify ... but the intermediate
                // is in the CA and it should pass this check; needs investigation
                var parents = parent;
                if (!$2xc86.util.isArray(parents)) parents = [
                    parents
                ];
                // try to verify with each possible parent (typically only one)
                var verified = false;
                while(!verified && parents.length > 0){
                    parent = parents.shift();
                    try {
                        verified = parent.verify(cert);
                    } catch (ex) {
                    // failure to verify, don't care why, try next one
                    }
                }
                if (!verified) error = {
                    message: "Certificate signature is invalid.",
                    error: $3ff8d88cacdb42a4$var$pki.certificateError.bad_certificate
                };
            }
            if (error === null && (!parent || selfSigned) && !caStore.hasCertificate(cert)) // no parent issuer and certificate itself is not trusted
            error = {
                message: "Certificate is not trusted.",
                error: $3ff8d88cacdb42a4$var$pki.certificateError.unknown_ca
            };
        }
        // TODO: 3. check revoked
        // 4. check for matching issuer/subject
        if (error === null && parent && !cert.isIssuer(parent)) // parent is not issuer
        error = {
            message: "Certificate issuer is invalid.",
            error: $3ff8d88cacdb42a4$var$pki.certificateError.bad_certificate
        };
        // 5. TODO: check names with permitted names tree
        // 6. TODO: check names against excluded names tree
        // 7. check for unsupported critical extensions
        if (error === null) {
            // supported extensions
            var se = {
                keyUsage: true,
                basicConstraints: true
            };
            for(var i = 0; error === null && i < cert.extensions.length; ++i){
                var ext = cert.extensions[i];
                if (ext.critical && !(ext.name in se)) error = {
                    message: "Certificate has an unsupported critical extension.",
                    error: $3ff8d88cacdb42a4$var$pki.certificateError.unsupported_certificate
                };
            }
        }
        // 8. check for CA if cert is not first or is the only certificate
        // remaining in chain with no parent or is self-signed
        if (error === null && (!first || chain.length === 0 && (!parent || selfSigned))) {
            // first check keyUsage extension and then basic constraints
            var bcExt = cert.getExtension("basicConstraints");
            var keyUsageExt = cert.getExtension("keyUsage");
            if (keyUsageExt !== null) // keyCertSign must be true and there must be a basic
            // constraints extension
            {
                if (!keyUsageExt.keyCertSign || bcExt === null) // bad certificate
                error = {
                    message: "Certificate keyUsage or basicConstraints conflict or indicate that the certificate is not a CA. If the certificate is the only one in the chain or isn't the first then the certificate must be a valid CA.",
                    error: $3ff8d88cacdb42a4$var$pki.certificateError.bad_certificate
                };
            }
            // basic constraints cA flag must be set
            if (error === null && bcExt !== null && !bcExt.cA) // bad certificate
            error = {
                message: "Certificate basicConstraints indicates the certificate is not a CA.",
                error: $3ff8d88cacdb42a4$var$pki.certificateError.bad_certificate
            };
            // if error is not null and keyUsage is available, then we know it
            // has keyCertSign and there is a basic constraints extension too,
            // which means we can check pathLenConstraint (if it exists)
            if (error === null && keyUsageExt !== null && "pathLenConstraint" in bcExt) {
                // pathLen is the maximum # of intermediate CA certs that can be
                // found between the current certificate and the end-entity (depth 0)
                // certificate; this number does not include the end-entity (depth 0,
                // last in the chain) even if it happens to be a CA certificate itself
                var pathLen = depth - 1;
                if (pathLen > bcExt.pathLenConstraint) // pathLenConstraint violated, bad certificate
                error = {
                    message: "Certificate basicConstraints pathLenConstraint violated.",
                    error: $3ff8d88cacdb42a4$var$pki.certificateError.bad_certificate
                };
            }
        }
        // call application callback
        var vfd = error === null ? true : error.error;
        var ret = options.verify ? options.verify(vfd, depth, certs) : vfd;
        if (ret === true) // clear any set error
        error = null;
        else {
            // if passed basic tests, set default message and alert
            if (vfd === true) error = {
                message: "The application rejected the certificate.",
                error: $3ff8d88cacdb42a4$var$pki.certificateError.bad_certificate
            };
            // check for custom error info
            if (ret || ret === 0) {
                // set custom message and error
                if (typeof ret === "object" && !$2xc86.util.isArray(ret)) {
                    if (ret.message) error.message = ret.message;
                    if (ret.error) error.error = ret.error;
                } else if (typeof ret === "string") // set custom error
                error.error = ret;
            }
            // throw error
            throw error;
        }
        // no longer first cert in chain
        first = false;
        ++depth;
    }while (chain.length > 0);
    return true;
};

});
parcelRequire.register("lLb7o", function(module, exports) {
/**
 * Node.js module for Forge mask generation functions.
 *
 * @author Stefan Siegl
 *
 * Copyright 2012 Stefan Siegl <stesie@brokenpipe.de>
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("dm69m");
module.exports = $2xc86.mgf = $2xc86.mgf || {};
$2xc86.mgf.mgf1 = $2xc86.mgf1;

});
parcelRequire.register("dm69m", function(module, exports) {
/**
 * Javascript implementation of mask generation function MGF1.
 *
 * @author Stefan Siegl
 * @author Dave Longley
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 * Copyright (c) 2014 Digital Bazaar, Inc.
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("e73pV");
$2xc86.mgf = $2xc86.mgf || {};
var $9b9219af448a836a$var$mgf1 = module.exports = $2xc86.mgf.mgf1 = $2xc86.mgf1 = $2xc86.mgf1 || {};
/**
 * Creates a MGF1 mask generation function object.
 *
 * @param md the message digest API to use (eg: forge.md.sha1.create()).
 *
 * @return a mask generation function object.
 */ $9b9219af448a836a$var$mgf1.create = function(md) {
    var mgf = {
        /**
     * Generate mask of specified length.
     *
     * @param {String} seed The seed for mask generation.
     * @param maskLen Number of bytes to generate.
     * @return {String} The generated mask.
     */ generate: function(seed, maskLen) {
            /* 2. Let T be the empty octet string. */ var t = new $2xc86.util.ByteBuffer();
            /* 3. For counter from 0 to ceil(maskLen / hLen), do the following: */ var len = Math.ceil(maskLen / md.digestLength);
            for(var i = 0; i < len; i++){
                /* a. Convert counter to an octet string C of length 4 octets */ var c = new $2xc86.util.ByteBuffer();
                c.putInt32(i);
                /* b. Concatenate the hash of the seed mgfSeed and C to the octet
         * string T: */ md.start();
                md.update(seed + c.getBytes());
                t.putBuffer(md.digest());
            }
            /* Output the leading maskLen octets of T as the octet string mask. */ t.truncate(t.length() - maskLen);
            return t.getBytes();
        }
    };
    return mgf;
};

});


parcelRequire.register("cQQSG", function(module, exports) {
/**
 * Javascript implementation of PKCS#1 PSS signature padding.
 *
 * @author Stefan Siegl
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("eeWuT");
parcelRequire("e73pV");
// shortcut for PSS API
var $95b35c7153f4c92d$var$pss = module.exports = $2xc86.pss = $2xc86.pss || {};
/**
 * Creates a PSS signature scheme object.
 *
 * There are several ways to provide a salt for encoding:
 *
 * 1. Specify the saltLength only and the built-in PRNG will generate it.
 * 2. Specify the saltLength and a custom PRNG with 'getBytesSync' defined that
 *   will be used.
 * 3. Specify the salt itself as a forge.util.ByteBuffer.
 *
 * @param options the options to use:
 *          md the message digest object to use, a forge md instance.
 *          mgf the mask generation function to use, a forge mgf instance.
 *          [saltLength] the length of the salt in octets.
 *          [prng] the pseudo-random number generator to use to produce a salt.
 *          [salt] the salt to use when encoding.
 *
 * @return a signature scheme object.
 */ $95b35c7153f4c92d$var$pss.create = function(options) {
    // backwards compatibility w/legacy args: hash, mgf, sLen
    if (arguments.length === 3) options = {
        md: arguments[0],
        mgf: arguments[1],
        saltLength: arguments[2]
    };
    var hash = options.md;
    var mgf = options.mgf;
    var hLen = hash.digestLength;
    var salt_ = options.salt || null;
    if (typeof salt_ === "string") // assume binary-encoded string
    salt_ = $2xc86.util.createBuffer(salt_);
    var sLen;
    if ("saltLength" in options) sLen = options.saltLength;
    else if (salt_ !== null) sLen = salt_.length();
    else throw new Error("Salt length not specified or specific salt not given.");
    if (salt_ !== null && salt_.length() !== sLen) throw new Error("Given salt length does not match length of given salt.");
    var prng = options.prng || $2xc86.random;
    var pssobj = {};
    /**
   * Encodes a PSS signature.
   *
   * This function implements EMSA-PSS-ENCODE as per RFC 3447, section 9.1.1.
   *
   * @param md the message digest object with the hash to sign.
   * @param modsBits the length of the RSA modulus in bits.
   *
   * @return the encoded message as a binary-encoded string of length
   *           ceil((modBits - 1) / 8).
   */ pssobj.encode = function(md, modBits) {
        var i;
        var emBits = modBits - 1;
        var emLen = Math.ceil(emBits / 8);
        /* 2. Let mHash = Hash(M), an octet string of length hLen. */ var mHash = md.digest().getBytes();
        /* 3. If emLen < hLen + sLen + 2, output "encoding error" and stop. */ if (emLen < hLen + sLen + 2) throw new Error("Message is too long to encrypt.");
        /* 4. Generate a random octet string salt of length sLen; if sLen = 0,
     *    then salt is the empty string. */ var salt;
        if (salt_ === null) salt = prng.getBytesSync(sLen);
        else salt = salt_.bytes();
        /* 5. Let M' = (0x)00 00 00 00 00 00 00 00 || mHash || salt; */ var m_ = new $2xc86.util.ByteBuffer();
        m_.fillWithByte(0, 8);
        m_.putBytes(mHash);
        m_.putBytes(salt);
        /* 6. Let H = Hash(M'), an octet string of length hLen. */ hash.start();
        hash.update(m_.getBytes());
        var h = hash.digest().getBytes();
        /* 7. Generate an octet string PS consisting of emLen - sLen - hLen - 2
     *    zero octets.  The length of PS may be 0. */ var ps = new $2xc86.util.ByteBuffer();
        ps.fillWithByte(0, emLen - sLen - hLen - 2);
        /* 8. Let DB = PS || 0x01 || salt; DB is an octet string of length
     *    emLen - hLen - 1. */ ps.putByte(0x01);
        ps.putBytes(salt);
        var db = ps.getBytes();
        /* 9. Let dbMask = MGF(H, emLen - hLen - 1). */ var maskLen = emLen - hLen - 1;
        var dbMask = mgf.generate(h, maskLen);
        /* 10. Let maskedDB = DB \xor dbMask. */ var maskedDB = "";
        for(i = 0; i < maskLen; i++)maskedDB += String.fromCharCode(db.charCodeAt(i) ^ dbMask.charCodeAt(i));
        /* 11. Set the leftmost 8emLen - emBits bits of the leftmost octet in
     *     maskedDB to zero. */ var mask = 0xFF00 >> 8 * emLen - emBits & 0xFF;
        maskedDB = String.fromCharCode(maskedDB.charCodeAt(0) & ~mask) + maskedDB.substr(1);
        /* 12. Let EM = maskedDB || H || 0xbc.
     * 13. Output EM. */ return maskedDB + h + String.fromCharCode(0xbc);
    };
    /**
   * Verifies a PSS signature.
   *
   * This function implements EMSA-PSS-VERIFY as per RFC 3447, section 9.1.2.
   *
   * @param mHash the message digest hash, as a binary-encoded string, to
   *         compare against the signature.
   * @param em the encoded message, as a binary-encoded string
   *          (RSA decryption result).
   * @param modsBits the length of the RSA modulus in bits.
   *
   * @return true if the signature was verified, false if not.
   */ pssobj.verify = function(mHash, em, modBits) {
        var i;
        var emBits = modBits - 1;
        var emLen = Math.ceil(emBits / 8);
        /* c. Convert the message representative m to an encoded message EM
     *    of length emLen = ceil((modBits - 1) / 8) octets, where modBits
     *    is the length in bits of the RSA modulus n */ em = em.substr(-emLen);
        /* 3. If emLen < hLen + sLen + 2, output "inconsistent" and stop. */ if (emLen < hLen + sLen + 2) throw new Error("Inconsistent parameters to PSS signature verification.");
        /* 4. If the rightmost octet of EM does not have hexadecimal value
     *    0xbc, output "inconsistent" and stop. */ if (em.charCodeAt(emLen - 1) !== 0xbc) throw new Error("Encoded message does not end in 0xBC.");
        /* 5. Let maskedDB be the leftmost emLen - hLen - 1 octets of EM, and
     *    let H be the next hLen octets. */ var maskLen = emLen - hLen - 1;
        var maskedDB = em.substr(0, maskLen);
        var h = em.substr(maskLen, hLen);
        /* 6. If the leftmost 8emLen - emBits bits of the leftmost octet in
     *    maskedDB are not all equal to zero, output "inconsistent" and stop. */ var mask = 0xFF00 >> 8 * emLen - emBits & 0xFF;
        if ((maskedDB.charCodeAt(0) & mask) !== 0) throw new Error("Bits beyond keysize not zero as expected.");
        /* 7. Let dbMask = MGF(H, emLen - hLen - 1). */ var dbMask = mgf.generate(h, maskLen);
        /* 8. Let DB = maskedDB \xor dbMask. */ var db = "";
        for(i = 0; i < maskLen; i++)db += String.fromCharCode(maskedDB.charCodeAt(i) ^ dbMask.charCodeAt(i));
        /* 9. Set the leftmost 8emLen - emBits bits of the leftmost octet
     * in DB to zero. */ db = String.fromCharCode(db.charCodeAt(0) & ~mask) + db.substr(1);
        /* 10. If the emLen - hLen - sLen - 2 leftmost octets of DB are not zero
     * or if the octet at position emLen - hLen - sLen - 1 (the leftmost
     * position is "position 1") does not have hexadecimal value 0x01,
     * output "inconsistent" and stop. */ var checkLen = emLen - hLen - sLen - 2;
        for(i = 0; i < checkLen; i++){
            if (db.charCodeAt(i) !== 0x00) throw new Error("Leftmost octets not zero as expected");
        }
        if (db.charCodeAt(checkLen) !== 0x01) throw new Error("Inconsistent PSS signature, 0x01 marker not found");
        /* 11. Let salt be the last sLen octets of DB. */ var salt = db.substr(-sLen);
        /* 12.  Let M' = (0x)00 00 00 00 00 00 00 00 || mHash || salt */ var m_ = new $2xc86.util.ByteBuffer();
        m_.fillWithByte(0, 8);
        m_.putBytes(mHash);
        m_.putBytes(salt);
        /* 13. Let H' = Hash(M'), an octet string of length hLen. */ hash.start();
        hash.update(m_.getBytes());
        var h_ = hash.digest().getBytes();
        /* 14. If H = H', output "consistent." Otherwise, output "inconsistent." */ return h === h_;
    };
    return pssobj;
};

});

parcelRequire.register("96KyE", function(module, exports) {
/**
 * Javascript implementation of basic RSA algorithms.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2014 Digital Bazaar, Inc.
 *
 * The only algorithm currently supported for PKI is RSA.
 *
 * An RSA key is often stored in ASN.1 DER format. The SubjectPublicKeyInfo
 * ASN.1 structure is composed of an algorithm of type AlgorithmIdentifier
 * and a subjectPublicKey of type bit string.
 *
 * The AlgorithmIdentifier contains an Object Identifier (OID) and parameters
 * for the algorithm, if any. In the case of RSA, there aren't any.
 *
 * SubjectPublicKeyInfo ::= SEQUENCE {
 *   algorithm AlgorithmIdentifier,
 *   subjectPublicKey BIT STRING
 * }
 *
 * AlgorithmIdentifer ::= SEQUENCE {
 *   algorithm OBJECT IDENTIFIER,
 *   parameters ANY DEFINED BY algorithm OPTIONAL
 * }
 *
 * For an RSA public key, the subjectPublicKey is:
 *
 * RSAPublicKey ::= SEQUENCE {
 *   modulus            INTEGER,    -- n
 *   publicExponent     INTEGER     -- e
 * }
 *
 * PrivateKeyInfo ::= SEQUENCE {
 *   version                   Version,
 *   privateKeyAlgorithm       PrivateKeyAlgorithmIdentifier,
 *   privateKey                PrivateKey,
 *   attributes           [0]  IMPLICIT Attributes OPTIONAL
 * }
 *
 * Version ::= INTEGER
 * PrivateKeyAlgorithmIdentifier ::= AlgorithmIdentifier
 * PrivateKey ::= OCTET STRING
 * Attributes ::= SET OF Attribute
 *
 * An RSA private key as the following structure:
 *
 * RSAPrivateKey ::= SEQUENCE {
 *   version Version,
 *   modulus INTEGER, -- n
 *   publicExponent INTEGER, -- e
 *   privateExponent INTEGER, -- d
 *   prime1 INTEGER, -- p
 *   prime2 INTEGER, -- q
 *   exponent1 INTEGER, -- d mod (p-1)
 *   exponent2 INTEGER, -- d mod (q-1)
 *   coefficient INTEGER -- (inverse of q) mod p
 * }
 *
 * Version ::= INTEGER
 *
 * The OID for the RSA key algorithm is: 1.2.840.113549.1.1.1
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("l46Tq");
parcelRequire("ft6fW");
parcelRequire("hzEKF");
parcelRequire("gzHst");
parcelRequire("LFqV4");
parcelRequire("eeWuT");
parcelRequire("e73pV");
if (typeof $6a18ca0a0efbbad9$var$BigInteger === "undefined") var $6a18ca0a0efbbad9$var$BigInteger = $2xc86.jsbn.BigInteger;

var $6a18ca0a0efbbad9$var$_crypto = $2xc86.util.isNodejs ? (parcelRequire("7jzxY")) : null;
// shortcut for asn.1 API
var $6a18ca0a0efbbad9$var$asn1 = $2xc86.asn1;
// shortcut for util API
var $6a18ca0a0efbbad9$var$util = $2xc86.util;
/*
 * RSA encryption and decryption, see RFC 2313.
 */ $2xc86.pki = $2xc86.pki || {};
module.exports = $2xc86.pki.rsa = $2xc86.rsa = $2xc86.rsa || {};
var $6a18ca0a0efbbad9$var$pki = $2xc86.pki;
// for finding primes, which are 30k+i for i = 1, 7, 11, 13, 17, 19, 23, 29
var $6a18ca0a0efbbad9$var$GCD_30_DELTA = [
    6,
    4,
    2,
    4,
    2,
    4,
    6,
    2
];
// validator for a PrivateKeyInfo structure
var $6a18ca0a0efbbad9$var$privateKeyValidator = {
    // PrivateKeyInfo
    name: "PrivateKeyInfo",
    tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
    type: $6a18ca0a0efbbad9$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // Version (INTEGER)
            name: "PrivateKeyInfo.version",
            tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
            type: $6a18ca0a0efbbad9$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyVersion"
        },
        {
            // privateKeyAlgorithm
            name: "PrivateKeyInfo.privateKeyAlgorithm",
            tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
            type: $6a18ca0a0efbbad9$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
                    type: $6a18ca0a0efbbad9$var$asn1.Type.OID,
                    constructed: false,
                    capture: "privateKeyOid"
                }
            ]
        },
        {
            // PrivateKey
            name: "PrivateKeyInfo",
            tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
            type: $6a18ca0a0efbbad9$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "privateKey"
        }
    ]
};
// validator for an RSA private key
var $6a18ca0a0efbbad9$var$rsaPrivateKeyValidator = {
    // RSAPrivateKey
    name: "RSAPrivateKey",
    tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
    type: $6a18ca0a0efbbad9$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // Version (INTEGER)
            name: "RSAPrivateKey.version",
            tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
            type: $6a18ca0a0efbbad9$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyVersion"
        },
        {
            // modulus (n)
            name: "RSAPrivateKey.modulus",
            tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
            type: $6a18ca0a0efbbad9$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyModulus"
        },
        {
            // publicExponent (e)
            name: "RSAPrivateKey.publicExponent",
            tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
            type: $6a18ca0a0efbbad9$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyPublicExponent"
        },
        {
            // privateExponent (d)
            name: "RSAPrivateKey.privateExponent",
            tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
            type: $6a18ca0a0efbbad9$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyPrivateExponent"
        },
        {
            // prime1 (p)
            name: "RSAPrivateKey.prime1",
            tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
            type: $6a18ca0a0efbbad9$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyPrime1"
        },
        {
            // prime2 (q)
            name: "RSAPrivateKey.prime2",
            tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
            type: $6a18ca0a0efbbad9$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyPrime2"
        },
        {
            // exponent1 (d mod (p-1))
            name: "RSAPrivateKey.exponent1",
            tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
            type: $6a18ca0a0efbbad9$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyExponent1"
        },
        {
            // exponent2 (d mod (q-1))
            name: "RSAPrivateKey.exponent2",
            tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
            type: $6a18ca0a0efbbad9$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyExponent2"
        },
        {
            // coefficient ((inverse of q) mod p)
            name: "RSAPrivateKey.coefficient",
            tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
            type: $6a18ca0a0efbbad9$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyCoefficient"
        }
    ]
};
// validator for an RSA public key
var $6a18ca0a0efbbad9$var$rsaPublicKeyValidator = {
    // RSAPublicKey
    name: "RSAPublicKey",
    tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
    type: $6a18ca0a0efbbad9$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // modulus (n)
            name: "RSAPublicKey.modulus",
            tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
            type: $6a18ca0a0efbbad9$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "publicKeyModulus"
        },
        {
            // publicExponent (e)
            name: "RSAPublicKey.exponent",
            tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
            type: $6a18ca0a0efbbad9$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "publicKeyExponent"
        }
    ]
};
// validator for an SubjectPublicKeyInfo structure
// Note: Currently only works with an RSA public key
var $6a18ca0a0efbbad9$var$publicKeyValidator = $2xc86.pki.rsa.publicKeyValidator = {
    name: "SubjectPublicKeyInfo",
    tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
    type: $6a18ca0a0efbbad9$var$asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: "subjectPublicKeyInfo",
    value: [
        {
            name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
            tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
            type: $6a18ca0a0efbbad9$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
                    type: $6a18ca0a0efbbad9$var$asn1.Type.OID,
                    constructed: false,
                    capture: "publicKeyOid"
                }
            ]
        },
        {
            // subjectPublicKey
            name: "SubjectPublicKeyInfo.subjectPublicKey",
            tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
            type: $6a18ca0a0efbbad9$var$asn1.Type.BITSTRING,
            constructed: false,
            value: [
                {
                    // RSAPublicKey
                    name: "SubjectPublicKeyInfo.subjectPublicKey.RSAPublicKey",
                    tagClass: $6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL,
                    type: $6a18ca0a0efbbad9$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    optional: true,
                    captureAsn1: "rsaPublicKey"
                }
            ]
        }
    ]
};
/**
 * Wrap digest in DigestInfo object.
 *
 * This function implements EMSA-PKCS1-v1_5-ENCODE as per RFC 3447.
 *
 * DigestInfo ::= SEQUENCE {
 *   digestAlgorithm DigestAlgorithmIdentifier,
 *   digest Digest
 * }
 *
 * DigestAlgorithmIdentifier ::= AlgorithmIdentifier
 * Digest ::= OCTET STRING
 *
 * @param md the message digest object with the hash to sign.
 *
 * @return the encoded message (ready for RSA encrytion)
 */ var $6a18ca0a0efbbad9$var$emsaPkcs1v15encode = function(md) {
    // get the oid for the algorithm
    var oid;
    if (md.algorithm in $6a18ca0a0efbbad9$var$pki.oids) oid = $6a18ca0a0efbbad9$var$pki.oids[md.algorithm];
    else {
        var error = new Error("Unknown message digest algorithm.");
        error.algorithm = md.algorithm;
        throw error;
    }
    var oidBytes = $6a18ca0a0efbbad9$var$asn1.oidToDer(oid).getBytes();
    // create the digest info
    var digestInfo = $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.SEQUENCE, true, []);
    var digestAlgorithm = $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.SEQUENCE, true, []);
    digestAlgorithm.value.push($6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.OID, false, oidBytes));
    digestAlgorithm.value.push($6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.NULL, false, ""));
    var digest = $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.OCTETSTRING, false, md.digest().getBytes());
    digestInfo.value.push(digestAlgorithm);
    digestInfo.value.push(digest);
    // encode digest info
    return $6a18ca0a0efbbad9$var$asn1.toDer(digestInfo).getBytes();
};
/**
 * Performs x^c mod n (RSA encryption or decryption operation).
 *
 * @param x the number to raise and mod.
 * @param key the key to use.
 * @param pub true if the key is public, false if private.
 *
 * @return the result of x^c mod n.
 */ var $6a18ca0a0efbbad9$var$_modPow = function(x, key, pub) {
    if (pub) return x.modPow(key.e, key.n);
    if (!key.p || !key.q) // allow calculation without CRT params (slow)
    return x.modPow(key.d, key.n);
    // pre-compute dP, dQ, and qInv if necessary
    if (!key.dP) key.dP = key.d.mod(key.p.subtract($6a18ca0a0efbbad9$var$BigInteger.ONE));
    if (!key.dQ) key.dQ = key.d.mod(key.q.subtract($6a18ca0a0efbbad9$var$BigInteger.ONE));
    if (!key.qInv) key.qInv = key.q.modInverse(key.p);
    /* Chinese remainder theorem (CRT) states:

    Suppose n1, n2, ..., nk are positive integers which are pairwise
    coprime (n1 and n2 have no common factors other than 1). For any
    integers x1, x2, ..., xk there exists an integer x solving the
    system of simultaneous congruences (where ~= means modularly
    congruent so a ~= b mod n means a mod n = b mod n):

    x ~= x1 mod n1
    x ~= x2 mod n2
    ...
    x ~= xk mod nk

    This system of congruences has a single simultaneous solution x
    between 0 and n - 1. Furthermore, each xk solution and x itself
    is congruent modulo the product n = n1*n2*...*nk.
    So x1 mod n = x2 mod n = xk mod n = x mod n.

    The single simultaneous solution x can be solved with the following
    equation:

    x = sum(xi*ri*si) mod n where ri = n/ni and si = ri^-1 mod ni.

    Where x is less than n, xi = x mod ni.

    For RSA we are only concerned with k = 2. The modulus n = pq, where
    p and q are coprime. The RSA decryption algorithm is:

    y = x^d mod n

    Given the above:

    x1 = x^d mod p
    r1 = n/p = q
    s1 = q^-1 mod p
    x2 = x^d mod q
    r2 = n/q = p
    s2 = p^-1 mod q

    So y = (x1r1s1 + x2r2s2) mod n
         = ((x^d mod p)q(q^-1 mod p) + (x^d mod q)p(p^-1 mod q)) mod n

    According to Fermat's Little Theorem, if the modulus P is prime,
    for any integer A not evenly divisible by P, A^(P-1) ~= 1 mod P.
    Since A is not divisible by P it follows that if:
    N ~= M mod (P - 1), then A^N mod P = A^M mod P. Therefore:

    A^N mod P = A^(M mod (P - 1)) mod P. (The latter takes less effort
    to calculate). In order to calculate x^d mod p more quickly the
    exponent d mod (p - 1) is stored in the RSA private key (the same
    is done for x^d mod q). These values are referred to as dP and dQ
    respectively. Therefore we now have:

    y = ((x^dP mod p)q(q^-1 mod p) + (x^dQ mod q)p(p^-1 mod q)) mod n

    Since we'll be reducing x^dP by modulo p (same for q) we can also
    reduce x by p (and q respectively) before hand. Therefore, let

    xp = ((x mod p)^dP mod p), and
    xq = ((x mod q)^dQ mod q), yielding:

    y = (xp*q*(q^-1 mod p) + xq*p*(p^-1 mod q)) mod n

    This can be further reduced to a simple algorithm that only
    requires 1 inverse (the q inverse is used) to be used and stored.
    The algorithm is called Garner's algorithm. If qInv is the
    inverse of q, we simply calculate:

    y = (qInv*(xp - xq) mod p) * q + xq

    However, there are two further complications. First, we need to
    ensure that xp > xq to prevent signed BigIntegers from being used
    so we add p until this is true (since we will be mod'ing with
    p anyway). Then, there is a known timing attack on algorithms
    using the CRT. To mitigate this risk, "cryptographic blinding"
    should be used. This requires simply generating a random number r
    between 0 and n-1 and its inverse and multiplying x by r^e before
    calculating y and then multiplying y by r^-1 afterwards. Note that
    r must be coprime with n (gcd(r, n) === 1) in order to have an
    inverse.
  */ // cryptographic blinding
    var r;
    do r = new $6a18ca0a0efbbad9$var$BigInteger($2xc86.util.bytesToHex($2xc86.random.getBytes(key.n.bitLength() / 8)), 16);
    while (r.compareTo(key.n) >= 0 || !r.gcd(key.n).equals($6a18ca0a0efbbad9$var$BigInteger.ONE));
    x = x.multiply(r.modPow(key.e, key.n)).mod(key.n);
    // calculate xp and xq
    var xp = x.mod(key.p).modPow(key.dP, key.p);
    var xq = x.mod(key.q).modPow(key.dQ, key.q);
    // xp must be larger than xq to avoid signed bit usage
    while(xp.compareTo(xq) < 0)xp = xp.add(key.p);
    // do last step
    var y = xp.subtract(xq).multiply(key.qInv).mod(key.p).multiply(key.q).add(xq);
    // remove effect of random for cryptographic blinding
    y = y.multiply(r.modInverse(key.n)).mod(key.n);
    return y;
};
/**
 * NOTE: THIS METHOD IS DEPRECATED, use 'sign' on a private key object or
 * 'encrypt' on a public key object instead.
 *
 * Performs RSA encryption.
 *
 * The parameter bt controls whether to put padding bytes before the
 * message passed in. Set bt to either true or false to disable padding
 * completely (in order to handle e.g. EMSA-PSS encoding seperately before),
 * signaling whether the encryption operation is a public key operation
 * (i.e. encrypting data) or not, i.e. private key operation (data signing).
 *
 * For PKCS#1 v1.5 padding pass in the block type to use, i.e. either 0x01
 * (for signing) or 0x02 (for encryption). The key operation mode (private
 * or public) is derived from this flag in that case).
 *
 * @param m the message to encrypt as a byte string.
 * @param key the RSA key to use.
 * @param bt for PKCS#1 v1.5 padding, the block type to use
 *   (0x01 for private key, 0x02 for public),
 *   to disable padding: true = public key, false = private key.
 *
 * @return the encrypted bytes as a string.
 */ $6a18ca0a0efbbad9$var$pki.rsa.encrypt = function(m, key, bt) {
    var pub = bt;
    var eb;
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    if (bt !== false && bt !== true) {
        // legacy, default to PKCS#1 v1.5 padding
        pub = bt === 0x02;
        eb = $6a18ca0a0efbbad9$var$_encodePkcs1_v1_5(m, key, bt);
    } else {
        eb = $2xc86.util.createBuffer();
        eb.putBytes(m);
    }
    // load encryption block as big integer 'x'
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var x = new $6a18ca0a0efbbad9$var$BigInteger(eb.toHex(), 16);
    // do RSA encryption
    var y = $6a18ca0a0efbbad9$var$_modPow(x, key, pub);
    // convert y into the encrypted data byte string, if y is shorter in
    // bytes than k, then prepend zero bytes to fill up ed
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var yhex = y.toString(16);
    var ed = $2xc86.util.createBuffer();
    var zeros = k - Math.ceil(yhex.length / 2);
    while(zeros > 0){
        ed.putByte(0x00);
        --zeros;
    }
    ed.putBytes($2xc86.util.hexToBytes(yhex));
    return ed.getBytes();
};
/**
 * NOTE: THIS METHOD IS DEPRECATED, use 'decrypt' on a private key object or
 * 'verify' on a public key object instead.
 *
 * Performs RSA decryption.
 *
 * The parameter ml controls whether to apply PKCS#1 v1.5 padding
 * or not.  Set ml = false to disable padding removal completely
 * (in order to handle e.g. EMSA-PSS later on) and simply pass back
 * the RSA encryption block.
 *
 * @param ed the encrypted data to decrypt in as a byte string.
 * @param key the RSA key to use.
 * @param pub true for a public key operation, false for private.
 * @param ml the message length, if known, false to disable padding.
 *
 * @return the decrypted message as a byte string.
 */ $6a18ca0a0efbbad9$var$pki.rsa.decrypt = function(ed, key, pub, ml) {
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    // error if the length of the encrypted data ED is not k
    if (ed.length !== k) {
        var error = new Error("Encrypted message length is invalid.");
        error.length = ed.length;
        error.expected = k;
        throw error;
    }
    // convert encrypted data into a big integer
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var y = new $6a18ca0a0efbbad9$var$BigInteger($2xc86.util.createBuffer(ed).toHex(), 16);
    // y must be less than the modulus or it wasn't the result of
    // a previous mod operation (encryption) using that modulus
    if (y.compareTo(key.n) >= 0) throw new Error("Encrypted message is invalid.");
    // do RSA decryption
    var x = $6a18ca0a0efbbad9$var$_modPow(y, key, pub);
    // create the encryption block, if x is shorter in bytes than k, then
    // prepend zero bytes to fill up eb
    // FIXME: hex conversion inefficient, get BigInteger w/byte strings
    var xhex = x.toString(16);
    var eb = $2xc86.util.createBuffer();
    var zeros = k - Math.ceil(xhex.length / 2);
    while(zeros > 0){
        eb.putByte(0x00);
        --zeros;
    }
    eb.putBytes($2xc86.util.hexToBytes(xhex));
    if (ml !== false) // legacy, default to PKCS#1 v1.5 padding
    return $6a18ca0a0efbbad9$var$_decodePkcs1_v1_5(eb.getBytes(), key, pub);
    // return message
    return eb.getBytes();
};
/**
 * Creates an RSA key-pair generation state object. It is used to allow
 * key-generation to be performed in steps. It also allows for a UI to
 * display progress updates.
 *
 * @param bits the size for the private key in bits, defaults to 2048.
 * @param e the public exponent to use, defaults to 65537 (0x10001).
 * @param [options] the options to use.
 *          prng a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync".
 *          algorithm the algorithm to use (default: 'PRIMEINC').
 *
 * @return the state object to use to generate the key-pair.
 */ $6a18ca0a0efbbad9$var$pki.rsa.createKeyPairGenerationState = function(bits, e, options) {
    // TODO: migrate step-based prime generation code to forge.prime
    // set default bits
    if (typeof bits === "string") bits = parseInt(bits, 10);
    bits = bits || 2048;
    // create prng with api that matches BigInteger secure random
    options = options || {};
    var prng = options.prng || $2xc86.random;
    var rng = {
        // x is an array to fill with bytes
        nextBytes: function(x) {
            var b = prng.getBytesSync(x.length);
            for(var i = 0; i < x.length; ++i)x[i] = b.charCodeAt(i);
        }
    };
    var algorithm = options.algorithm || "PRIMEINC";
    // create PRIMEINC algorithm state
    var rval;
    if (algorithm === "PRIMEINC") {
        rval = {
            algorithm: algorithm,
            state: 0,
            bits: bits,
            rng: rng,
            eInt: e || 65537,
            e: new $6a18ca0a0efbbad9$var$BigInteger(null),
            p: null,
            q: null,
            qBits: bits >> 1,
            pBits: bits - (bits >> 1),
            pqState: 0,
            num: null,
            keys: null
        };
        rval.e.fromInt(rval.eInt);
    } else throw new Error("Invalid key generation algorithm: " + algorithm);
    return rval;
};
/**
 * Attempts to runs the key-generation algorithm for at most n seconds
 * (approximately) using the given state. When key-generation has completed,
 * the keys will be stored in state.keys.
 *
 * To use this function to update a UI while generating a key or to prevent
 * causing browser lockups/warnings, set "n" to a value other than 0. A
 * simple pattern for generating a key and showing a progress indicator is:
 *
 * var state = pki.rsa.createKeyPairGenerationState(2048);
 * var step = function() {
 *   // step key-generation, run algorithm for 100 ms, repeat
 *   if(!forge.pki.rsa.stepKeyPairGenerationState(state, 100)) {
 *     setTimeout(step, 1);
 *   } else {
 *     // key-generation complete
 *     // TODO: turn off progress indicator here
 *     // TODO: use the generated key-pair in "state.keys"
 *   }
 * };
 * // TODO: turn on progress indicator here
 * setTimeout(step, 0);
 *
 * @param state the state to use.
 * @param n the maximum number of milliseconds to run the algorithm for, 0
 *          to run the algorithm to completion.
 *
 * @return true if the key-generation completed, false if not.
 */ $6a18ca0a0efbbad9$var$pki.rsa.stepKeyPairGenerationState = function(state, n) {
    // set default algorithm if not set
    if (!("algorithm" in state)) state.algorithm = "PRIMEINC";
    // TODO: migrate step-based prime generation code to forge.prime
    // TODO: abstract as PRIMEINC algorithm
    // do key generation (based on Tom Wu's rsa.js, see jsbn.js license)
    // with some minor optimizations and designed to run in steps
    // local state vars
    var THIRTY = new $6a18ca0a0efbbad9$var$BigInteger(null);
    THIRTY.fromInt(30);
    var deltaIdx = 0;
    var op_or = function(x, y) {
        return x | y;
    };
    // keep stepping until time limit is reached or done
    var t1 = +new Date();
    var t2;
    var total = 0;
    while(state.keys === null && (n <= 0 || total < n)){
        // generate p or q
        if (state.state === 0) {
            /* Note: All primes are of the form:

        30k+i, for i < 30 and gcd(30, i)=1, where there are 8 values for i

        When we generate a random number, we always align it at 30k + 1. Each
        time the number is determined not to be prime we add to get to the
        next 'i', eg: if the number was at 30k + 1 we add 6. */ var bits = state.p === null ? state.pBits : state.qBits;
            var bits1 = bits - 1;
            // get a random number
            if (state.pqState === 0) {
                state.num = new $6a18ca0a0efbbad9$var$BigInteger(bits, state.rng);
                // force MSB set
                if (!state.num.testBit(bits1)) state.num.bitwiseTo($6a18ca0a0efbbad9$var$BigInteger.ONE.shiftLeft(bits1), op_or, state.num);
                // align number on 30k+1 boundary
                state.num.dAddOffset(31 - state.num.mod(THIRTY).byteValue(), 0);
                deltaIdx = 0;
                ++state.pqState;
            } else if (state.pqState === 1) {
                // try to make the number a prime
                if (state.num.bitLength() > bits) // overflow, try again
                state.pqState = 0;
                else if (state.num.isProbablePrime($6a18ca0a0efbbad9$var$_getMillerRabinTests(state.num.bitLength()))) ++state.pqState;
                else // get next potential prime
                state.num.dAddOffset($6a18ca0a0efbbad9$var$GCD_30_DELTA[deltaIdx++ % 8], 0);
            } else if (state.pqState === 2) // ensure number is coprime with e
            state.pqState = state.num.subtract($6a18ca0a0efbbad9$var$BigInteger.ONE).gcd(state.e).compareTo($6a18ca0a0efbbad9$var$BigInteger.ONE) === 0 ? 3 : 0;
            else if (state.pqState === 3) {
                // store p or q
                state.pqState = 0;
                if (state.p === null) state.p = state.num;
                else state.q = state.num;
                // advance state if both p and q are ready
                if (state.p !== null && state.q !== null) ++state.state;
                state.num = null;
            }
        } else if (state.state === 1) {
            // ensure p is larger than q (swap them if not)
            if (state.p.compareTo(state.q) < 0) {
                state.num = state.p;
                state.p = state.q;
                state.q = state.num;
            }
            ++state.state;
        } else if (state.state === 2) {
            // compute phi: (p - 1)(q - 1) (Euler's totient function)
            state.p1 = state.p.subtract($6a18ca0a0efbbad9$var$BigInteger.ONE);
            state.q1 = state.q.subtract($6a18ca0a0efbbad9$var$BigInteger.ONE);
            state.phi = state.p1.multiply(state.q1);
            ++state.state;
        } else if (state.state === 3) {
            // ensure e and phi are coprime
            if (state.phi.gcd(state.e).compareTo($6a18ca0a0efbbad9$var$BigInteger.ONE) === 0) // phi and e are coprime, advance
            ++state.state;
            else {
                // phi and e aren't coprime, so generate a new p and q
                state.p = null;
                state.q = null;
                state.state = 0;
            }
        } else if (state.state === 4) {
            // create n, ensure n is has the right number of bits
            state.n = state.p.multiply(state.q);
            // ensure n is right number of bits
            if (state.n.bitLength() === state.bits) // success, advance
            ++state.state;
            else {
                // failed, get new q
                state.q = null;
                state.state = 0;
            }
        } else if (state.state === 5) {
            // set keys
            var d = state.e.modInverse(state.phi);
            state.keys = {
                privateKey: $6a18ca0a0efbbad9$var$pki.rsa.setPrivateKey(state.n, state.e, d, state.p, state.q, d.mod(state.p1), d.mod(state.q1), state.q.modInverse(state.p)),
                publicKey: $6a18ca0a0efbbad9$var$pki.rsa.setPublicKey(state.n, state.e)
            };
        }
        // update timing
        t2 = +new Date();
        total += t2 - t1;
        t1 = t2;
    }
    return state.keys !== null;
};
/**
 * Generates an RSA public-private key pair in a single call.
 *
 * To generate a key-pair in steps (to allow for progress updates and to
 * prevent blocking or warnings in slow browsers) then use the key-pair
 * generation state functions.
 *
 * To generate a key-pair asynchronously (either through web-workers, if
 * available, or by breaking up the work on the main thread), pass a
 * callback function.
 *
 * @param [bits] the size for the private key in bits, defaults to 2048.
 * @param [e] the public exponent to use, defaults to 65537.
 * @param [options] options for key-pair generation, if given then 'bits'
 *            and 'e' must *not* be given:
 *          bits the size for the private key in bits, (default: 2048).
 *          e the public exponent to use, (default: 65537 (0x10001)).
 *          workerScript the worker script URL.
 *          workers the number of web workers (if supported) to use,
 *            (default: 2).
 *          workLoad the size of the work load, ie: number of possible prime
 *            numbers for each web worker to check per work assignment,
 *            (default: 100).
 *          prng a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync". Disables use of native APIs.
 *          algorithm the algorithm to use (default: 'PRIMEINC').
 * @param [callback(err, keypair)] called once the operation completes.
 *
 * @return an object with privateKey and publicKey properties.
 */ $6a18ca0a0efbbad9$var$pki.rsa.generateKeyPair = function(bits, e, options, callback) {
    // (bits), (options), (callback)
    if (arguments.length === 1) {
        if (typeof bits === "object") {
            options = bits;
            bits = undefined;
        } else if (typeof bits === "function") {
            callback = bits;
            bits = undefined;
        }
    } else if (arguments.length === 2) {
        // (bits, e), (bits, options), (bits, callback), (options, callback)
        if (typeof bits === "number") {
            if (typeof e === "function") {
                callback = e;
                e = undefined;
            } else if (typeof e !== "number") {
                options = e;
                e = undefined;
            }
        } else {
            options = bits;
            callback = e;
            bits = undefined;
            e = undefined;
        }
    } else if (arguments.length === 3) {
        // (bits, e, options), (bits, e, callback), (bits, options, callback)
        if (typeof e === "number") {
            if (typeof options === "function") {
                callback = options;
                options = undefined;
            }
        } else {
            callback = options;
            options = e;
            e = undefined;
        }
    }
    options = options || {};
    if (bits === undefined) bits = options.bits || 2048;
    if (e === undefined) e = options.e || 0x10001;
    // use native code if permitted, available, and parameters are acceptable
    if (!$2xc86.options.usePureJavaScript && !options.prng && bits >= 256 && bits <= 16384 && (e === 0x10001 || e === 3)) {
        if (callback) {
            // try native async
            if ($6a18ca0a0efbbad9$var$_detectNodeCrypto("generateKeyPair")) return $6a18ca0a0efbbad9$var$_crypto.generateKeyPair("rsa", {
                modulusLength: bits,
                publicExponent: e,
                publicKeyEncoding: {
                    type: "spki",
                    format: "pem"
                },
                privateKeyEncoding: {
                    type: "pkcs8",
                    format: "pem"
                }
            }, function(err, pub, priv) {
                if (err) return callback(err);
                callback(null, {
                    privateKey: $6a18ca0a0efbbad9$var$pki.privateKeyFromPem(priv),
                    publicKey: $6a18ca0a0efbbad9$var$pki.publicKeyFromPem(pub)
                });
            });
            if ($6a18ca0a0efbbad9$var$_detectSubtleCrypto("generateKey") && $6a18ca0a0efbbad9$var$_detectSubtleCrypto("exportKey")) // use standard native generateKey
            return $6a18ca0a0efbbad9$var$util.globalScope.crypto.subtle.generateKey({
                name: "RSASSA-PKCS1-v1_5",
                modulusLength: bits,
                publicExponent: $6a18ca0a0efbbad9$var$_intToUint8Array(e),
                hash: {
                    name: "SHA-256"
                }
            }, true, [
                "sign",
                "verify"
            ]).then(function(pair) {
                return $6a18ca0a0efbbad9$var$util.globalScope.crypto.subtle.exportKey("pkcs8", pair.privateKey);
            // avoiding catch(function(err) {...}) to support IE <= 8
            }).then(undefined, function(err) {
                callback(err);
            }).then(function(pkcs8) {
                if (pkcs8) {
                    var privateKey = $6a18ca0a0efbbad9$var$pki.privateKeyFromAsn1($6a18ca0a0efbbad9$var$asn1.fromDer($2xc86.util.createBuffer(pkcs8)));
                    callback(null, {
                        privateKey: privateKey,
                        publicKey: $6a18ca0a0efbbad9$var$pki.setRsaPublicKey(privateKey.n, privateKey.e)
                    });
                }
            });
            if ($6a18ca0a0efbbad9$var$_detectSubtleMsCrypto("generateKey") && $6a18ca0a0efbbad9$var$_detectSubtleMsCrypto("exportKey")) {
                var genOp = $6a18ca0a0efbbad9$var$util.globalScope.msCrypto.subtle.generateKey({
                    name: "RSASSA-PKCS1-v1_5",
                    modulusLength: bits,
                    publicExponent: $6a18ca0a0efbbad9$var$_intToUint8Array(e),
                    hash: {
                        name: "SHA-256"
                    }
                }, true, [
                    "sign",
                    "verify"
                ]);
                genOp.oncomplete = function(e) {
                    var pair = e.target.result;
                    var exportOp = $6a18ca0a0efbbad9$var$util.globalScope.msCrypto.subtle.exportKey("pkcs8", pair.privateKey);
                    exportOp.oncomplete = function(e) {
                        var pkcs8 = e.target.result;
                        var privateKey = $6a18ca0a0efbbad9$var$pki.privateKeyFromAsn1($6a18ca0a0efbbad9$var$asn1.fromDer($2xc86.util.createBuffer(pkcs8)));
                        callback(null, {
                            privateKey: privateKey,
                            publicKey: $6a18ca0a0efbbad9$var$pki.setRsaPublicKey(privateKey.n, privateKey.e)
                        });
                    };
                    exportOp.onerror = function(err) {
                        callback(err);
                    };
                };
                genOp.onerror = function(err) {
                    callback(err);
                };
                return;
            }
        } else // try native sync
        if ($6a18ca0a0efbbad9$var$_detectNodeCrypto("generateKeyPairSync")) {
            var keypair = $6a18ca0a0efbbad9$var$_crypto.generateKeyPairSync("rsa", {
                modulusLength: bits,
                publicExponent: e,
                publicKeyEncoding: {
                    type: "spki",
                    format: "pem"
                },
                privateKeyEncoding: {
                    type: "pkcs8",
                    format: "pem"
                }
            });
            return {
                privateKey: $6a18ca0a0efbbad9$var$pki.privateKeyFromPem(keypair.privateKey),
                publicKey: $6a18ca0a0efbbad9$var$pki.publicKeyFromPem(keypair.publicKey)
            };
        }
    }
    // use JavaScript implementation
    var state = $6a18ca0a0efbbad9$var$pki.rsa.createKeyPairGenerationState(bits, e, options);
    if (!callback) {
        $6a18ca0a0efbbad9$var$pki.rsa.stepKeyPairGenerationState(state, 0);
        return state.keys;
    }
    $6a18ca0a0efbbad9$var$_generateKeyPair(state, options, callback);
};
/**
 * Sets an RSA public key from BigIntegers modulus and exponent.
 *
 * @param n the modulus.
 * @param e the exponent.
 *
 * @return the public key.
 */ $6a18ca0a0efbbad9$var$pki.setRsaPublicKey = $6a18ca0a0efbbad9$var$pki.rsa.setPublicKey = function(n, e) {
    var key = {
        n: n,
        e: e
    };
    /**
   * Encrypts the given data with this public key. Newer applications
   * should use the 'RSA-OAEP' decryption scheme, 'RSAES-PKCS1-V1_5' is for
   * legacy applications.
   *
   * @param data the byte string to encrypt.
   * @param scheme the encryption scheme to use:
   *          'RSAES-PKCS1-V1_5' (default),
   *          'RSA-OAEP',
   *          'RAW', 'NONE', or null to perform raw RSA encryption,
   *          an object with an 'encode' property set to a function
   *          with the signature 'function(data, key)' that returns
   *          a binary-encoded string representing the encoded data.
   * @param schemeOptions any scheme-specific options.
   *
   * @return the encrypted byte string.
   */ key.encrypt = function(data, scheme, schemeOptions) {
        if (typeof scheme === "string") scheme = scheme.toUpperCase();
        else if (scheme === undefined) scheme = "RSAES-PKCS1-V1_5";
        if (scheme === "RSAES-PKCS1-V1_5") scheme = {
            encode: function(m, key, pub) {
                return $6a18ca0a0efbbad9$var$_encodePkcs1_v1_5(m, key, 0x02).getBytes();
            }
        };
        else if (scheme === "RSA-OAEP" || scheme === "RSAES-OAEP") scheme = {
            encode: function(m, key) {
                return $2xc86.pkcs1.encode_rsa_oaep(key, m, schemeOptions);
            }
        };
        else if ([
            "RAW",
            "NONE",
            "NULL",
            null
        ].indexOf(scheme) !== -1) scheme = {
            encode: function(e) {
                return e;
            }
        };
        else if (typeof scheme === "string") throw new Error('Unsupported encryption scheme: "' + scheme + '".');
        // do scheme-based encoding then rsa encryption
        var e = scheme.encode(data, key, true);
        return $6a18ca0a0efbbad9$var$pki.rsa.encrypt(e, key, true);
    };
    /**
   * Verifies the given signature against the given digest.
   *
   * PKCS#1 supports multiple (currently two) signature schemes:
   * RSASSA-PKCS1-V1_5 and RSASSA-PSS.
   *
   * By default this implementation uses the "old scheme", i.e.
   * RSASSA-PKCS1-V1_5, in which case once RSA-decrypted, the
   * signature is an OCTET STRING that holds a DigestInfo.
   *
   * DigestInfo ::= SEQUENCE {
   *   digestAlgorithm DigestAlgorithmIdentifier,
   *   digest Digest
   * }
   * DigestAlgorithmIdentifier ::= AlgorithmIdentifier
   * Digest ::= OCTET STRING
   *
   * To perform PSS signature verification, provide an instance
   * of Forge PSS object as the scheme parameter.
   *
   * @param digest the message digest hash to compare against the signature,
   *          as a binary-encoded string.
   * @param signature the signature to verify, as a binary-encoded string.
   * @param scheme signature verification scheme to use:
   *          'RSASSA-PKCS1-V1_5' or undefined for RSASSA PKCS#1 v1.5,
   *          a Forge PSS object for RSASSA-PSS,
   *          'NONE' or null for none, DigestInfo will not be expected, but
   *            PKCS#1 v1.5 padding will still be used.
   *
   * @return true if the signature was verified, false if not.
   */ key.verify = function(digest, signature, scheme) {
        if (typeof scheme === "string") scheme = scheme.toUpperCase();
        else if (scheme === undefined) scheme = "RSASSA-PKCS1-V1_5";
        if (scheme === "RSASSA-PKCS1-V1_5") scheme = {
            verify: function(digest, d) {
                // remove padding
                d = $6a18ca0a0efbbad9$var$_decodePkcs1_v1_5(d, key, true);
                // d is ASN.1 BER-encoded DigestInfo
                var obj = $6a18ca0a0efbbad9$var$asn1.fromDer(d);
                // compare the given digest to the decrypted one
                return digest === obj.value[1].value;
            }
        };
        else if (scheme === "NONE" || scheme === "NULL" || scheme === null) scheme = {
            verify: function(digest, d) {
                // remove padding
                d = $6a18ca0a0efbbad9$var$_decodePkcs1_v1_5(d, key, true);
                return digest === d;
            }
        };
        // do rsa decryption w/o any decoding, then verify -- which does decoding
        var d = $6a18ca0a0efbbad9$var$pki.rsa.decrypt(signature, key, true, false);
        return scheme.verify(digest, d, key.n.bitLength());
    };
    return key;
};
/**
 * Sets an RSA private key from BigIntegers modulus, exponent, primes,
 * prime exponents, and modular multiplicative inverse.
 *
 * @param n the modulus.
 * @param e the public exponent.
 * @param d the private exponent ((inverse of e) mod n).
 * @param p the first prime.
 * @param q the second prime.
 * @param dP exponent1 (d mod (p-1)).
 * @param dQ exponent2 (d mod (q-1)).
 * @param qInv ((inverse of q) mod p)
 *
 * @return the private key.
 */ $6a18ca0a0efbbad9$var$pki.setRsaPrivateKey = $6a18ca0a0efbbad9$var$pki.rsa.setPrivateKey = function(n, e, d, p, q, dP, dQ, qInv) {
    var key = {
        n: n,
        e: e,
        d: d,
        p: p,
        q: q,
        dP: dP,
        dQ: dQ,
        qInv: qInv
    };
    /**
   * Decrypts the given data with this private key. The decryption scheme
   * must match the one used to encrypt the data.
   *
   * @param data the byte string to decrypt.
   * @param scheme the decryption scheme to use:
   *          'RSAES-PKCS1-V1_5' (default),
   *          'RSA-OAEP',
   *          'RAW', 'NONE', or null to perform raw RSA decryption.
   * @param schemeOptions any scheme-specific options.
   *
   * @return the decrypted byte string.
   */ key.decrypt = function(data, scheme, schemeOptions) {
        if (typeof scheme === "string") scheme = scheme.toUpperCase();
        else if (scheme === undefined) scheme = "RSAES-PKCS1-V1_5";
        // do rsa decryption w/o any decoding
        var d = $6a18ca0a0efbbad9$var$pki.rsa.decrypt(data, key, false, false);
        if (scheme === "RSAES-PKCS1-V1_5") scheme = {
            decode: $6a18ca0a0efbbad9$var$_decodePkcs1_v1_5
        };
        else if (scheme === "RSA-OAEP" || scheme === "RSAES-OAEP") scheme = {
            decode: function(d, key) {
                return $2xc86.pkcs1.decode_rsa_oaep(key, d, schemeOptions);
            }
        };
        else if ([
            "RAW",
            "NONE",
            "NULL",
            null
        ].indexOf(scheme) !== -1) scheme = {
            decode: function(d) {
                return d;
            }
        };
        else throw new Error('Unsupported encryption scheme: "' + scheme + '".');
        // decode according to scheme
        return scheme.decode(d, key, false);
    };
    /**
   * Signs the given digest, producing a signature.
   *
   * PKCS#1 supports multiple (currently two) signature schemes:
   * RSASSA-PKCS1-V1_5 and RSASSA-PSS.
   *
   * By default this implementation uses the "old scheme", i.e.
   * RSASSA-PKCS1-V1_5. In order to generate a PSS signature, provide
   * an instance of Forge PSS object as the scheme parameter.
   *
   * @param md the message digest object with the hash to sign.
   * @param scheme the signature scheme to use:
   *          'RSASSA-PKCS1-V1_5' or undefined for RSASSA PKCS#1 v1.5,
   *          a Forge PSS object for RSASSA-PSS,
   *          'NONE' or null for none, DigestInfo will not be used but
   *            PKCS#1 v1.5 padding will still be used.
   *
   * @return the signature as a byte string.
   */ key.sign = function(md, scheme) {
        /* Note: The internal implementation of RSA operations is being
      transitioned away from a PKCS#1 v1.5 hard-coded scheme. Some legacy
      code like the use of an encoding block identifier 'bt' will eventually
      be removed. */ // private key operation
        var bt = false;
        if (typeof scheme === "string") scheme = scheme.toUpperCase();
        if (scheme === undefined || scheme === "RSASSA-PKCS1-V1_5") {
            scheme = {
                encode: $6a18ca0a0efbbad9$var$emsaPkcs1v15encode
            };
            bt = 0x01;
        } else if (scheme === "NONE" || scheme === "NULL" || scheme === null) {
            scheme = {
                encode: function() {
                    return md;
                }
            };
            bt = 0x01;
        }
        // encode and then encrypt
        var d = scheme.encode(md, key.n.bitLength());
        return $6a18ca0a0efbbad9$var$pki.rsa.encrypt(d, key, bt);
    };
    return key;
};
/**
 * Wraps an RSAPrivateKey ASN.1 object in an ASN.1 PrivateKeyInfo object.
 *
 * @param rsaKey the ASN.1 RSAPrivateKey.
 *
 * @return the ASN.1 PrivateKeyInfo.
 */ $6a18ca0a0efbbad9$var$pki.wrapRsaPrivateKey = function(rsaKey) {
    // PrivateKeyInfo
    return $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.SEQUENCE, true, [
        // version (0)
        $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.INTEGER, false, $6a18ca0a0efbbad9$var$asn1.integerToDer(0).getBytes()),
        // privateKeyAlgorithm
        $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.SEQUENCE, true, [
            $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.OID, false, $6a18ca0a0efbbad9$var$asn1.oidToDer($6a18ca0a0efbbad9$var$pki.oids.rsaEncryption).getBytes()),
            $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.NULL, false, "")
        ]),
        // PrivateKey
        $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.OCTETSTRING, false, $6a18ca0a0efbbad9$var$asn1.toDer(rsaKey).getBytes())
    ]);
};
/**
 * Converts a private key from an ASN.1 object.
 *
 * @param obj the ASN.1 representation of a PrivateKeyInfo containing an
 *          RSAPrivateKey or an RSAPrivateKey.
 *
 * @return the private key.
 */ $6a18ca0a0efbbad9$var$pki.privateKeyFromAsn1 = function(obj) {
    // get PrivateKeyInfo
    var capture = {};
    var errors = [];
    if ($6a18ca0a0efbbad9$var$asn1.validate(obj, $6a18ca0a0efbbad9$var$privateKeyValidator, capture, errors)) obj = $6a18ca0a0efbbad9$var$asn1.fromDer($2xc86.util.createBuffer(capture.privateKey));
    // get RSAPrivateKey
    capture = {};
    errors = [];
    if (!$6a18ca0a0efbbad9$var$asn1.validate(obj, $6a18ca0a0efbbad9$var$rsaPrivateKeyValidator, capture, errors)) {
        var error = new Error("Cannot read private key. ASN.1 object does not contain an RSAPrivateKey.");
        error.errors = errors;
        throw error;
    }
    // Note: Version is currently ignored.
    // capture.privateKeyVersion
    // FIXME: inefficient, get a BigInteger that uses byte strings
    var n, e, d, p, q, dP, dQ, qInv;
    n = $2xc86.util.createBuffer(capture.privateKeyModulus).toHex();
    e = $2xc86.util.createBuffer(capture.privateKeyPublicExponent).toHex();
    d = $2xc86.util.createBuffer(capture.privateKeyPrivateExponent).toHex();
    p = $2xc86.util.createBuffer(capture.privateKeyPrime1).toHex();
    q = $2xc86.util.createBuffer(capture.privateKeyPrime2).toHex();
    dP = $2xc86.util.createBuffer(capture.privateKeyExponent1).toHex();
    dQ = $2xc86.util.createBuffer(capture.privateKeyExponent2).toHex();
    qInv = $2xc86.util.createBuffer(capture.privateKeyCoefficient).toHex();
    // set private key
    return $6a18ca0a0efbbad9$var$pki.setRsaPrivateKey(new $6a18ca0a0efbbad9$var$BigInteger(n, 16), new $6a18ca0a0efbbad9$var$BigInteger(e, 16), new $6a18ca0a0efbbad9$var$BigInteger(d, 16), new $6a18ca0a0efbbad9$var$BigInteger(p, 16), new $6a18ca0a0efbbad9$var$BigInteger(q, 16), new $6a18ca0a0efbbad9$var$BigInteger(dP, 16), new $6a18ca0a0efbbad9$var$BigInteger(dQ, 16), new $6a18ca0a0efbbad9$var$BigInteger(qInv, 16));
};
/**
 * Converts a private key to an ASN.1 RSAPrivateKey.
 *
 * @param key the private key.
 *
 * @return the ASN.1 representation of an RSAPrivateKey.
 */ $6a18ca0a0efbbad9$var$pki.privateKeyToAsn1 = $6a18ca0a0efbbad9$var$pki.privateKeyToRSAPrivateKey = function(key) {
    // RSAPrivateKey
    return $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.SEQUENCE, true, [
        // version (0 = only 2 primes, 1 multiple primes)
        $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.INTEGER, false, $6a18ca0a0efbbad9$var$asn1.integerToDer(0).getBytes()),
        // modulus (n)
        $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.INTEGER, false, $6a18ca0a0efbbad9$var$_bnToBytes(key.n)),
        // publicExponent (e)
        $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.INTEGER, false, $6a18ca0a0efbbad9$var$_bnToBytes(key.e)),
        // privateExponent (d)
        $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.INTEGER, false, $6a18ca0a0efbbad9$var$_bnToBytes(key.d)),
        // privateKeyPrime1 (p)
        $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.INTEGER, false, $6a18ca0a0efbbad9$var$_bnToBytes(key.p)),
        // privateKeyPrime2 (q)
        $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.INTEGER, false, $6a18ca0a0efbbad9$var$_bnToBytes(key.q)),
        // privateKeyExponent1 (dP)
        $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.INTEGER, false, $6a18ca0a0efbbad9$var$_bnToBytes(key.dP)),
        // privateKeyExponent2 (dQ)
        $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.INTEGER, false, $6a18ca0a0efbbad9$var$_bnToBytes(key.dQ)),
        // coefficient (qInv)
        $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.INTEGER, false, $6a18ca0a0efbbad9$var$_bnToBytes(key.qInv))
    ]);
};
/**
 * Converts a public key from an ASN.1 SubjectPublicKeyInfo or RSAPublicKey.
 *
 * @param obj the asn1 representation of a SubjectPublicKeyInfo or RSAPublicKey.
 *
 * @return the public key.
 */ $6a18ca0a0efbbad9$var$pki.publicKeyFromAsn1 = function(obj) {
    // get SubjectPublicKeyInfo
    var capture = {};
    var errors = [];
    if ($6a18ca0a0efbbad9$var$asn1.validate(obj, $6a18ca0a0efbbad9$var$publicKeyValidator, capture, errors)) {
        // get oid
        var oid = $6a18ca0a0efbbad9$var$asn1.derToOid(capture.publicKeyOid);
        if (oid !== $6a18ca0a0efbbad9$var$pki.oids.rsaEncryption) {
            var error = new Error("Cannot read public key. Unknown OID.");
            error.oid = oid;
            throw error;
        }
        obj = capture.rsaPublicKey;
    }
    // get RSA params
    errors = [];
    if (!$6a18ca0a0efbbad9$var$asn1.validate(obj, $6a18ca0a0efbbad9$var$rsaPublicKeyValidator, capture, errors)) {
        var error = new Error("Cannot read public key. ASN.1 object does not contain an RSAPublicKey.");
        error.errors = errors;
        throw error;
    }
    // FIXME: inefficient, get a BigInteger that uses byte strings
    var n = $2xc86.util.createBuffer(capture.publicKeyModulus).toHex();
    var e = $2xc86.util.createBuffer(capture.publicKeyExponent).toHex();
    // set public key
    return $6a18ca0a0efbbad9$var$pki.setRsaPublicKey(new $6a18ca0a0efbbad9$var$BigInteger(n, 16), new $6a18ca0a0efbbad9$var$BigInteger(e, 16));
};
/**
 * Converts a public key to an ASN.1 SubjectPublicKeyInfo.
 *
 * @param key the public key.
 *
 * @return the asn1 representation of a SubjectPublicKeyInfo.
 */ $6a18ca0a0efbbad9$var$pki.publicKeyToAsn1 = $6a18ca0a0efbbad9$var$pki.publicKeyToSubjectPublicKeyInfo = function(key) {
    // SubjectPublicKeyInfo
    return $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.SEQUENCE, true, [
        // AlgorithmIdentifier
        $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.SEQUENCE, true, [
            // algorithm
            $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.OID, false, $6a18ca0a0efbbad9$var$asn1.oidToDer($6a18ca0a0efbbad9$var$pki.oids.rsaEncryption).getBytes()),
            // parameters (null)
            $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.NULL, false, "")
        ]),
        // subjectPublicKey
        $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.BITSTRING, false, [
            $6a18ca0a0efbbad9$var$pki.publicKeyToRSAPublicKey(key)
        ])
    ]);
};
/**
 * Converts a public key to an ASN.1 RSAPublicKey.
 *
 * @param key the public key.
 *
 * @return the asn1 representation of a RSAPublicKey.
 */ $6a18ca0a0efbbad9$var$pki.publicKeyToRSAPublicKey = function(key) {
    // RSAPublicKey
    return $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.SEQUENCE, true, [
        // modulus (n)
        $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.INTEGER, false, $6a18ca0a0efbbad9$var$_bnToBytes(key.n)),
        // publicExponent (e)
        $6a18ca0a0efbbad9$var$asn1.create($6a18ca0a0efbbad9$var$asn1.Class.UNIVERSAL, $6a18ca0a0efbbad9$var$asn1.Type.INTEGER, false, $6a18ca0a0efbbad9$var$_bnToBytes(key.e))
    ]);
};
/**
 * Encodes a message using PKCS#1 v1.5 padding.
 *
 * @param m the message to encode.
 * @param key the RSA key to use.
 * @param bt the block type to use, i.e. either 0x01 (for signing) or 0x02
 *          (for encryption).
 *
 * @return the padded byte buffer.
 */ function $6a18ca0a0efbbad9$var$_encodePkcs1_v1_5(m, key, bt) {
    var eb = $2xc86.util.createBuffer();
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    /* use PKCS#1 v1.5 padding */ if (m.length > k - 11) {
        var error = new Error("Message is too long for PKCS#1 v1.5 padding.");
        error.length = m.length;
        error.max = k - 11;
        throw error;
    }
    /* A block type BT, a padding string PS, and the data D shall be
    formatted into an octet string EB, the encryption block:

    EB = 00 || BT || PS || 00 || D

    The block type BT shall be a single octet indicating the structure of
    the encryption block. For this version of the document it shall have
    value 00, 01, or 02. For a private-key operation, the block type
    shall be 00 or 01. For a public-key operation, it shall be 02.

    The padding string PS shall consist of k-3-||D|| octets. For block
    type 00, the octets shall have value 00; for block type 01, they
    shall have value FF; and for block type 02, they shall be
    pseudorandomly generated and nonzero. This makes the length of the
    encryption block EB equal to k. */ // build the encryption block
    eb.putByte(0x00);
    eb.putByte(bt);
    // create the padding
    var padNum = k - 3 - m.length;
    var padByte;
    // private key op
    if (bt === 0x00 || bt === 0x01) {
        padByte = bt === 0x00 ? 0x00 : 0xFF;
        for(var i = 0; i < padNum; ++i)eb.putByte(padByte);
    } else // public key op
    // pad with random non-zero values
    while(padNum > 0){
        var numZeros = 0;
        var padBytes = $2xc86.random.getBytes(padNum);
        for(var i = 0; i < padNum; ++i){
            padByte = padBytes.charCodeAt(i);
            if (padByte === 0) ++numZeros;
            else eb.putByte(padByte);
        }
        padNum = numZeros;
    }
    // zero followed by message
    eb.putByte(0x00);
    eb.putBytes(m);
    return eb;
}
/**
 * Decodes a message using PKCS#1 v1.5 padding.
 *
 * @param em the message to decode.
 * @param key the RSA key to use.
 * @param pub true if the key is a public key, false if it is private.
 * @param ml the message length, if specified.
 *
 * @return the decoded bytes.
 */ function $6a18ca0a0efbbad9$var$_decodePkcs1_v1_5(em, key, pub, ml) {
    // get the length of the modulus in bytes
    var k = Math.ceil(key.n.bitLength() / 8);
    /* It is an error if any of the following conditions occurs:

    1. The encryption block EB cannot be parsed unambiguously.
    2. The padding string PS consists of fewer than eight octets
      or is inconsisent with the block type BT.
    3. The decryption process is a public-key operation and the block
      type BT is not 00 or 01, or the decryption process is a
      private-key operation and the block type is not 02.
   */ // parse the encryption block
    var eb = $2xc86.util.createBuffer(em);
    var first = eb.getByte();
    var bt = eb.getByte();
    if (first !== 0x00 || pub && bt !== 0x00 && bt !== 0x01 || !pub && bt != 0x02 || pub && bt === 0x00 && typeof ml === "undefined") throw new Error("Encryption block is invalid.");
    var padNum = 0;
    if (bt === 0x00) {
        // check all padding bytes for 0x00
        padNum = k - 3 - ml;
        for(var i = 0; i < padNum; ++i){
            if (eb.getByte() !== 0x00) throw new Error("Encryption block is invalid.");
        }
    } else if (bt === 0x01) {
        // find the first byte that isn't 0xFF, should be after all padding
        padNum = 0;
        while(eb.length() > 1){
            if (eb.getByte() !== 0xFF) {
                --eb.read;
                break;
            }
            ++padNum;
        }
    } else if (bt === 0x02) {
        // look for 0x00 byte
        padNum = 0;
        while(eb.length() > 1){
            if (eb.getByte() === 0x00) {
                --eb.read;
                break;
            }
            ++padNum;
        }
    }
    // zero must be 0x00 and padNum must be (k - 3 - message length)
    var zero = eb.getByte();
    if (zero !== 0x00 || padNum !== k - 3 - eb.length()) throw new Error("Encryption block is invalid.");
    return eb.getBytes();
}
/**
 * Runs the key-generation algorithm asynchronously, either in the background
 * via Web Workers, or using the main thread and setImmediate.
 *
 * @param state the key-pair generation state.
 * @param [options] options for key-pair generation:
 *          workerScript the worker script URL.
 *          workers the number of web workers (if supported) to use,
 *            (default: 2, -1 to use estimated cores minus one).
 *          workLoad the size of the work load, ie: number of possible prime
 *            numbers for each web worker to check per work assignment,
 *            (default: 100).
 * @param callback(err, keypair) called once the operation completes.
 */ function $6a18ca0a0efbbad9$var$_generateKeyPair(state, options, callback) {
    if (typeof options === "function") {
        callback = options;
        options = {};
    }
    options = options || {};
    var opts = {
        algorithm: {
            name: options.algorithm || "PRIMEINC",
            options: {
                workers: options.workers || 2,
                workLoad: options.workLoad || 100,
                workerScript: options.workerScript
            }
        }
    };
    if ("prng" in options) opts.prng = options.prng;
    generate();
    function generate() {
        // find p and then q (done in series to simplify)
        getPrime(state.pBits, function(err, num) {
            if (err) return callback(err);
            state.p = num;
            if (state.q !== null) return finish(err, state.q);
            getPrime(state.qBits, finish);
        });
    }
    function getPrime(bits, callback) {
        $2xc86.prime.generateProbablePrime(bits, opts, callback);
    }
    function finish(err, num) {
        if (err) return callback(err);
        // set q
        state.q = num;
        // ensure p is larger than q (swap them if not)
        if (state.p.compareTo(state.q) < 0) {
            var tmp = state.p;
            state.p = state.q;
            state.q = tmp;
        }
        // ensure p is coprime with e
        if (state.p.subtract($6a18ca0a0efbbad9$var$BigInteger.ONE).gcd(state.e).compareTo($6a18ca0a0efbbad9$var$BigInteger.ONE) !== 0) {
            state.p = null;
            generate();
            return;
        }
        // ensure q is coprime with e
        if (state.q.subtract($6a18ca0a0efbbad9$var$BigInteger.ONE).gcd(state.e).compareTo($6a18ca0a0efbbad9$var$BigInteger.ONE) !== 0) {
            state.q = null;
            getPrime(state.qBits, finish);
            return;
        }
        // compute phi: (p - 1)(q - 1) (Euler's totient function)
        state.p1 = state.p.subtract($6a18ca0a0efbbad9$var$BigInteger.ONE);
        state.q1 = state.q.subtract($6a18ca0a0efbbad9$var$BigInteger.ONE);
        state.phi = state.p1.multiply(state.q1);
        // ensure e and phi are coprime
        if (state.phi.gcd(state.e).compareTo($6a18ca0a0efbbad9$var$BigInteger.ONE) !== 0) {
            // phi and e aren't coprime, so generate a new p and q
            state.p = state.q = null;
            generate();
            return;
        }
        // create n, ensure n is has the right number of bits
        state.n = state.p.multiply(state.q);
        if (state.n.bitLength() !== state.bits) {
            // failed, get new q
            state.q = null;
            getPrime(state.qBits, finish);
            return;
        }
        // set keys
        var d = state.e.modInverse(state.phi);
        state.keys = {
            privateKey: $6a18ca0a0efbbad9$var$pki.rsa.setPrivateKey(state.n, state.e, d, state.p, state.q, d.mod(state.p1), d.mod(state.q1), state.q.modInverse(state.p)),
            publicKey: $6a18ca0a0efbbad9$var$pki.rsa.setPublicKey(state.n, state.e)
        };
        callback(null, state.keys);
    }
}
/**
 * Converts a positive BigInteger into 2's-complement big-endian bytes.
 *
 * @param b the big integer to convert.
 *
 * @return the bytes.
 */ function $6a18ca0a0efbbad9$var$_bnToBytes(b) {
    // prepend 0x00 if first byte >= 0x80
    var hex = b.toString(16);
    if (hex[0] >= "8") hex = "00" + hex;
    var bytes = $2xc86.util.hexToBytes(hex);
    // ensure integer is minimally-encoded
    if (bytes.length > 1 && // leading 0x00 for positive integer
    (bytes.charCodeAt(0) === 0 && (bytes.charCodeAt(1) & 0x80) === 0 || // leading 0xFF for negative integer
    bytes.charCodeAt(0) === 0xFF && (bytes.charCodeAt(1) & 0x80) === 0x80)) return bytes.substr(1);
    return bytes;
}
/**
 * Returns the required number of Miller-Rabin tests to generate a
 * prime with an error probability of (1/2)^80.
 *
 * See Handbook of Applied Cryptography Chapter 4, Table 4.4.
 *
 * @param bits the bit size.
 *
 * @return the required number of iterations.
 */ function $6a18ca0a0efbbad9$var$_getMillerRabinTests(bits) {
    if (bits <= 100) return 27;
    if (bits <= 150) return 18;
    if (bits <= 200) return 15;
    if (bits <= 250) return 12;
    if (bits <= 300) return 9;
    if (bits <= 350) return 8;
    if (bits <= 400) return 7;
    if (bits <= 500) return 6;
    if (bits <= 600) return 5;
    if (bits <= 800) return 4;
    if (bits <= 1250) return 3;
    return 2;
}
/**
 * Performs feature detection on the Node crypto interface.
 *
 * @param fn the feature (function) to detect.
 *
 * @return true if detected, false if not.
 */ function $6a18ca0a0efbbad9$var$_detectNodeCrypto(fn) {
    return $2xc86.util.isNodejs && typeof $6a18ca0a0efbbad9$var$_crypto[fn] === "function";
}
/**
 * Performs feature detection on the SubtleCrypto interface.
 *
 * @param fn the feature (function) to detect.
 *
 * @return true if detected, false if not.
 */ function $6a18ca0a0efbbad9$var$_detectSubtleCrypto(fn) {
    return typeof $6a18ca0a0efbbad9$var$util.globalScope !== "undefined" && typeof $6a18ca0a0efbbad9$var$util.globalScope.crypto === "object" && typeof $6a18ca0a0efbbad9$var$util.globalScope.crypto.subtle === "object" && typeof $6a18ca0a0efbbad9$var$util.globalScope.crypto.subtle[fn] === "function";
}
/**
 * Performs feature detection on the deprecated Microsoft Internet Explorer
 * outdated SubtleCrypto interface. This function should only be used after
 * checking for the modern, standard SubtleCrypto interface.
 *
 * @param fn the feature (function) to detect.
 *
 * @return true if detected, false if not.
 */ function $6a18ca0a0efbbad9$var$_detectSubtleMsCrypto(fn) {
    return typeof $6a18ca0a0efbbad9$var$util.globalScope !== "undefined" && typeof $6a18ca0a0efbbad9$var$util.globalScope.msCrypto === "object" && typeof $6a18ca0a0efbbad9$var$util.globalScope.msCrypto.subtle === "object" && typeof $6a18ca0a0efbbad9$var$util.globalScope.msCrypto.subtle[fn] === "function";
}
function $6a18ca0a0efbbad9$var$_intToUint8Array(x) {
    var bytes = $2xc86.util.hexToBytes(x.toString(16));
    var buffer = new Uint8Array(bytes.length);
    for(var i = 0; i < bytes.length; ++i)buffer[i] = bytes.charCodeAt(i);
    return buffer;
}
function $6a18ca0a0efbbad9$var$_privateKeyFromJwk(jwk) {
    if (jwk.kty !== "RSA") throw new Error('Unsupported key algorithm "' + jwk.kty + '"; algorithm must be "RSA".');
    return $6a18ca0a0efbbad9$var$pki.setRsaPrivateKey($6a18ca0a0efbbad9$var$_base64ToBigInt(jwk.n), $6a18ca0a0efbbad9$var$_base64ToBigInt(jwk.e), $6a18ca0a0efbbad9$var$_base64ToBigInt(jwk.d), $6a18ca0a0efbbad9$var$_base64ToBigInt(jwk.p), $6a18ca0a0efbbad9$var$_base64ToBigInt(jwk.q), $6a18ca0a0efbbad9$var$_base64ToBigInt(jwk.dp), $6a18ca0a0efbbad9$var$_base64ToBigInt(jwk.dq), $6a18ca0a0efbbad9$var$_base64ToBigInt(jwk.qi));
}
function $6a18ca0a0efbbad9$var$_publicKeyFromJwk(jwk) {
    if (jwk.kty !== "RSA") throw new Error('Key algorithm must be "RSA".');
    return $6a18ca0a0efbbad9$var$pki.setRsaPublicKey($6a18ca0a0efbbad9$var$_base64ToBigInt(jwk.n), $6a18ca0a0efbbad9$var$_base64ToBigInt(jwk.e));
}
function $6a18ca0a0efbbad9$var$_base64ToBigInt(b64) {
    return new $6a18ca0a0efbbad9$var$BigInteger($2xc86.util.bytesToHex($2xc86.util.decode64(b64)), 16);
}

});
parcelRequire.register("ft6fW", function(module, exports) {
// Copyright (c) 2005  Tom Wu
// All Rights Reserved.
// See "LICENSE" for details.
// Basic JavaScript BN library - subset useful for RSA encryption.
/*
Licensing (LICENSE)
-------------------

This software is covered under the following copyright:
*/ /*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ /*
Address all questions regarding this license to:

  Tom Wu
  tjw@cs.Stanford.EDU
*/ 
var $2xc86 = parcelRequire("2xc86");
module.exports = $2xc86.jsbn = $2xc86.jsbn || {};
// Bits per digit
var $b42e6ac2b62f6e80$var$dbits;
// JavaScript engine analysis
var $b42e6ac2b62f6e80$var$canary = 0xdeadbeefcafe;
var $b42e6ac2b62f6e80$var$j_lm = ($b42e6ac2b62f6e80$var$canary & 0xffffff) == 0xefcafe;
// (public) Constructor
function $b42e6ac2b62f6e80$var$BigInteger(a, b, c) {
    this.data = [];
    if (a != null) {
        if ("number" == typeof a) this.fromNumber(a, b, c);
        else if (b == null && "string" != typeof a) this.fromString(a, 256);
        else this.fromString(a, b);
    }
}
$2xc86.jsbn.BigInteger = $b42e6ac2b62f6e80$var$BigInteger;
// return new, unset BigInteger
function $b42e6ac2b62f6e80$var$nbi() {
    return new $b42e6ac2b62f6e80$var$BigInteger(null);
}
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $b42e6ac2b62f6e80$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this.data[i++] + w.data[j] + c;
        c = Math.floor(v / 0x4000000);
        w.data[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $b42e6ac2b62f6e80$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this.data[i] & 0x7fff;
        var h = this.data[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w.data[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w.data[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $b42e6ac2b62f6e80$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this.data[i] & 0x3fff;
        var h = this.data[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w.data[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w.data[j++] = l & 0xfffffff;
    }
    return c;
}
// node.js (no browser)
if (typeof navigator === "undefined") {
    $b42e6ac2b62f6e80$var$BigInteger.prototype.am = $b42e6ac2b62f6e80$var$am3;
    $b42e6ac2b62f6e80$var$dbits = 28;
} else if ($b42e6ac2b62f6e80$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    $b42e6ac2b62f6e80$var$BigInteger.prototype.am = $b42e6ac2b62f6e80$var$am2;
    $b42e6ac2b62f6e80$var$dbits = 30;
} else if ($b42e6ac2b62f6e80$var$j_lm && navigator.appName != "Netscape") {
    $b42e6ac2b62f6e80$var$BigInteger.prototype.am = $b42e6ac2b62f6e80$var$am1;
    $b42e6ac2b62f6e80$var$dbits = 26;
} else {
    $b42e6ac2b62f6e80$var$BigInteger.prototype.am = $b42e6ac2b62f6e80$var$am3;
    $b42e6ac2b62f6e80$var$dbits = 28;
}
$b42e6ac2b62f6e80$var$BigInteger.prototype.DB = $b42e6ac2b62f6e80$var$dbits;
$b42e6ac2b62f6e80$var$BigInteger.prototype.DM = (1 << $b42e6ac2b62f6e80$var$dbits) - 1;
$b42e6ac2b62f6e80$var$BigInteger.prototype.DV = 1 << $b42e6ac2b62f6e80$var$dbits;
var $b42e6ac2b62f6e80$var$BI_FP = 52;
$b42e6ac2b62f6e80$var$BigInteger.prototype.FV = Math.pow(2, $b42e6ac2b62f6e80$var$BI_FP);
$b42e6ac2b62f6e80$var$BigInteger.prototype.F1 = $b42e6ac2b62f6e80$var$BI_FP - $b42e6ac2b62f6e80$var$dbits;
$b42e6ac2b62f6e80$var$BigInteger.prototype.F2 = 2 * $b42e6ac2b62f6e80$var$dbits - $b42e6ac2b62f6e80$var$BI_FP;
// Digit conversions
var $b42e6ac2b62f6e80$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $b42e6ac2b62f6e80$var$BI_RC = new Array();
var $b42e6ac2b62f6e80$var$rr, $b42e6ac2b62f6e80$var$vv;
$b42e6ac2b62f6e80$var$rr = "0".charCodeAt(0);
for($b42e6ac2b62f6e80$var$vv = 0; $b42e6ac2b62f6e80$var$vv <= 9; ++$b42e6ac2b62f6e80$var$vv)$b42e6ac2b62f6e80$var$BI_RC[$b42e6ac2b62f6e80$var$rr++] = $b42e6ac2b62f6e80$var$vv;
$b42e6ac2b62f6e80$var$rr = "a".charCodeAt(0);
for($b42e6ac2b62f6e80$var$vv = 10; $b42e6ac2b62f6e80$var$vv < 36; ++$b42e6ac2b62f6e80$var$vv)$b42e6ac2b62f6e80$var$BI_RC[$b42e6ac2b62f6e80$var$rr++] = $b42e6ac2b62f6e80$var$vv;
$b42e6ac2b62f6e80$var$rr = "A".charCodeAt(0);
for($b42e6ac2b62f6e80$var$vv = 10; $b42e6ac2b62f6e80$var$vv < 36; ++$b42e6ac2b62f6e80$var$vv)$b42e6ac2b62f6e80$var$BI_RC[$b42e6ac2b62f6e80$var$rr++] = $b42e6ac2b62f6e80$var$vv;
function $b42e6ac2b62f6e80$var$int2char(n) {
    return $b42e6ac2b62f6e80$var$BI_RM.charAt(n);
}
function $b42e6ac2b62f6e80$var$intAt(s, i) {
    var c = $b42e6ac2b62f6e80$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $b42e6ac2b62f6e80$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r.data[i] = this.data[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $b42e6ac2b62f6e80$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this.data[0] = x;
    else if (x < -1) this.data[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $b42e6ac2b62f6e80$var$nbv(i) {
    var r = $b42e6ac2b62f6e80$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $b42e6ac2b62f6e80$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 256) k = 8; // byte array
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else {
        this.fromRadix(s, b);
        return;
    }
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = k == 8 ? s[i] & 0xff : $b42e6ac2b62f6e80$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this.data[this.t++] = x;
        else if (sh + k > this.DB) {
            this.data[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this.data[this.t++] = x >> this.DB - sh;
        } else this.data[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    if (k == 8 && (s[0] & 0x80) != 0) {
        this.s = -1;
        if (sh > 0) this.data[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
    }
    this.clamp();
    if (mi) $b42e6ac2b62f6e80$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $b42e6ac2b62f6e80$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this.data[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $b42e6ac2b62f6e80$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else return this.toRadix(b);
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this.data[i] >> p) > 0) {
            m = true;
            r = $b42e6ac2b62f6e80$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this.data[i] & (1 << p) - 1) << k - p;
                d |= this.data[--i] >> (p += this.DB - k);
            } else {
                d = this.data[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $b42e6ac2b62f6e80$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $b42e6ac2b62f6e80$var$bnNegate() {
    var r = $b42e6ac2b62f6e80$var$nbi();
    $b42e6ac2b62f6e80$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $b42e6ac2b62f6e80$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $b42e6ac2b62f6e80$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this.data[i] - a.data[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $b42e6ac2b62f6e80$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $b42e6ac2b62f6e80$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $b42e6ac2b62f6e80$var$nbits(this.data[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $b42e6ac2b62f6e80$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r.data[i + n] = this.data[i];
    for(i = n - 1; i >= 0; --i)r.data[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $b42e6ac2b62f6e80$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r.data[i - n] = this.data[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $b42e6ac2b62f6e80$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r.data[i + ds + 1] = this.data[i] >> cbs | c;
        c = (this.data[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r.data[i] = 0;
    r.data[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $b42e6ac2b62f6e80$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r.data[0] = this.data[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r.data[i - ds - 1] |= (this.data[i] & bm) << cbs;
        r.data[i - ds] = this.data[i] >> bs;
    }
    if (bs > 0) r.data[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $b42e6ac2b62f6e80$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this.data[i] - a.data[i];
        r.data[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r.data[i++] = this.DV + c;
    else if (c > 0) r.data[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $b42e6ac2b62f6e80$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r.data[i] = 0;
    for(i = 0; i < y.t; ++i)r.data[i + x.t] = x.am(0, y.data[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $b42e6ac2b62f6e80$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $b42e6ac2b62f6e80$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r.data[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x.data[i], r, 2 * i, 0, 1);
        if ((r.data[i + x.t] += x.am(i + 1, 2 * x.data[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r.data[i + x.t] -= x.DV;
            r.data[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r.data[r.t - 1] += x.am(i, x.data[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $b42e6ac2b62f6e80$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $b42e6ac2b62f6e80$var$nbi();
    var y = $b42e6ac2b62f6e80$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $b42e6ac2b62f6e80$var$nbits(pm.data[pm.t - 1]); // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y.data[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y.data[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $b42e6ac2b62f6e80$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r.data[r.t++] = 1;
        r.subTo(t, r);
    }
    $b42e6ac2b62f6e80$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y); // "negative" y so we can replace sub with am later
    while(y.t < ys)y.data[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r.data[--i] == y0 ? this.DM : Math.floor(r.data[i] * d1 + (r.data[i - 1] + e) * d2);
        if ((r.data[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r.data[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $b42e6ac2b62f6e80$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
    if (ts < 0) $b42e6ac2b62f6e80$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $b42e6ac2b62f6e80$var$bnMod(a) {
    var r = $b42e6ac2b62f6e80$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($b42e6ac2b62f6e80$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// Modular reduction using "classic" algorithm
function $b42e6ac2b62f6e80$var$Classic(m) {
    this.m = m;
}
function $b42e6ac2b62f6e80$var$cConvert(x) {
    if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
    else return x;
}
function $b42e6ac2b62f6e80$var$cRevert(x) {
    return x;
}
function $b42e6ac2b62f6e80$var$cReduce(x) {
    x.divRemTo(this.m, null, x);
}
function $b42e6ac2b62f6e80$var$cMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
function $b42e6ac2b62f6e80$var$cSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
$b42e6ac2b62f6e80$var$Classic.prototype.convert = $b42e6ac2b62f6e80$var$cConvert;
$b42e6ac2b62f6e80$var$Classic.prototype.revert = $b42e6ac2b62f6e80$var$cRevert;
$b42e6ac2b62f6e80$var$Classic.prototype.reduce = $b42e6ac2b62f6e80$var$cReduce;
$b42e6ac2b62f6e80$var$Classic.prototype.mulTo = $b42e6ac2b62f6e80$var$cMulTo;
$b42e6ac2b62f6e80$var$Classic.prototype.sqrTo = $b42e6ac2b62f6e80$var$cSqrTo;
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $b42e6ac2b62f6e80$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this.data[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3; // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
// Montgomery reduction
function $b42e6ac2b62f6e80$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $b42e6ac2b62f6e80$var$montConvert(x) {
    var r = $b42e6ac2b62f6e80$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($b42e6ac2b62f6e80$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $b42e6ac2b62f6e80$var$montRevert(x) {
    var r = $b42e6ac2b62f6e80$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $b42e6ac2b62f6e80$var$montReduce(x) {
    while(x.t <= this.mt2)x.data[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x.data[i]*mp mod DV
        var j = x.data[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x.data[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x.data[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x.data[j] >= x.DV){
            x.data[j] -= x.DV;
            x.data[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $b42e6ac2b62f6e80$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $b42e6ac2b62f6e80$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$b42e6ac2b62f6e80$var$Montgomery.prototype.convert = $b42e6ac2b62f6e80$var$montConvert;
$b42e6ac2b62f6e80$var$Montgomery.prototype.revert = $b42e6ac2b62f6e80$var$montRevert;
$b42e6ac2b62f6e80$var$Montgomery.prototype.reduce = $b42e6ac2b62f6e80$var$montReduce;
$b42e6ac2b62f6e80$var$Montgomery.prototype.mulTo = $b42e6ac2b62f6e80$var$montMulTo;
$b42e6ac2b62f6e80$var$Montgomery.prototype.sqrTo = $b42e6ac2b62f6e80$var$montSqrTo;
// (protected) true iff this is even
function $b42e6ac2b62f6e80$var$bnpIsEven() {
    return (this.t > 0 ? this.data[0] & 1 : this.s) == 0;
}
// (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
function $b42e6ac2b62f6e80$var$bnpExp(e, z) {
    if (e > 0xffffffff || e < 1) return $b42e6ac2b62f6e80$var$BigInteger.ONE;
    var r = $b42e6ac2b62f6e80$var$nbi(), r2 = $b42e6ac2b62f6e80$var$nbi(), g = z.convert(this), i = $b42e6ac2b62f6e80$var$nbits(e) - 1;
    g.copyTo(r);
    while(--i >= 0){
        z.sqrTo(r, r2);
        if ((e & 1 << i) > 0) z.mulTo(r2, g, r);
        else {
            var t = r;
            r = r2;
            r2 = t;
        }
    }
    return z.revert(r);
}
// (public) this^e % m, 0 <= e < 2^32
function $b42e6ac2b62f6e80$var$bnModPowInt(e, m) {
    var z;
    if (e < 256 || m.isEven()) z = new $b42e6ac2b62f6e80$var$Classic(m);
    else z = new $b42e6ac2b62f6e80$var$Montgomery(m);
    return this.exp(e, z);
}
// protected
$b42e6ac2b62f6e80$var$BigInteger.prototype.copyTo = $b42e6ac2b62f6e80$var$bnpCopyTo;
$b42e6ac2b62f6e80$var$BigInteger.prototype.fromInt = $b42e6ac2b62f6e80$var$bnpFromInt;
$b42e6ac2b62f6e80$var$BigInteger.prototype.fromString = $b42e6ac2b62f6e80$var$bnpFromString;
$b42e6ac2b62f6e80$var$BigInteger.prototype.clamp = $b42e6ac2b62f6e80$var$bnpClamp;
$b42e6ac2b62f6e80$var$BigInteger.prototype.dlShiftTo = $b42e6ac2b62f6e80$var$bnpDLShiftTo;
$b42e6ac2b62f6e80$var$BigInteger.prototype.drShiftTo = $b42e6ac2b62f6e80$var$bnpDRShiftTo;
$b42e6ac2b62f6e80$var$BigInteger.prototype.lShiftTo = $b42e6ac2b62f6e80$var$bnpLShiftTo;
$b42e6ac2b62f6e80$var$BigInteger.prototype.rShiftTo = $b42e6ac2b62f6e80$var$bnpRShiftTo;
$b42e6ac2b62f6e80$var$BigInteger.prototype.subTo = $b42e6ac2b62f6e80$var$bnpSubTo;
$b42e6ac2b62f6e80$var$BigInteger.prototype.multiplyTo = $b42e6ac2b62f6e80$var$bnpMultiplyTo;
$b42e6ac2b62f6e80$var$BigInteger.prototype.squareTo = $b42e6ac2b62f6e80$var$bnpSquareTo;
$b42e6ac2b62f6e80$var$BigInteger.prototype.divRemTo = $b42e6ac2b62f6e80$var$bnpDivRemTo;
$b42e6ac2b62f6e80$var$BigInteger.prototype.invDigit = $b42e6ac2b62f6e80$var$bnpInvDigit;
$b42e6ac2b62f6e80$var$BigInteger.prototype.isEven = $b42e6ac2b62f6e80$var$bnpIsEven;
$b42e6ac2b62f6e80$var$BigInteger.prototype.exp = $b42e6ac2b62f6e80$var$bnpExp;
// public
$b42e6ac2b62f6e80$var$BigInteger.prototype.toString = $b42e6ac2b62f6e80$var$bnToString;
$b42e6ac2b62f6e80$var$BigInteger.prototype.negate = $b42e6ac2b62f6e80$var$bnNegate;
$b42e6ac2b62f6e80$var$BigInteger.prototype.abs = $b42e6ac2b62f6e80$var$bnAbs;
$b42e6ac2b62f6e80$var$BigInteger.prototype.compareTo = $b42e6ac2b62f6e80$var$bnCompareTo;
$b42e6ac2b62f6e80$var$BigInteger.prototype.bitLength = $b42e6ac2b62f6e80$var$bnBitLength;
$b42e6ac2b62f6e80$var$BigInteger.prototype.mod = $b42e6ac2b62f6e80$var$bnMod;
$b42e6ac2b62f6e80$var$BigInteger.prototype.modPowInt = $b42e6ac2b62f6e80$var$bnModPowInt;
// "constants"
$b42e6ac2b62f6e80$var$BigInteger.ZERO = $b42e6ac2b62f6e80$var$nbv(0);
$b42e6ac2b62f6e80$var$BigInteger.ONE = $b42e6ac2b62f6e80$var$nbv(1);
// jsbn2 lib
//Copyright (c) 2005-2009  Tom Wu
//All Rights Reserved.
//See "LICENSE" for details (See jsbn.js for LICENSE).
//Extended JavaScript BN functions, required for RSA private ops.
//Version 1.1: new BigInteger("0", 10) returns "proper" zero
//(public)
function $b42e6ac2b62f6e80$var$bnClone() {
    var r = $b42e6ac2b62f6e80$var$nbi();
    this.copyTo(r);
    return r;
}
//(public) return value as integer
function $b42e6ac2b62f6e80$var$bnIntValue() {
    if (this.s < 0) {
        if (this.t == 1) return this.data[0] - this.DV;
        else if (this.t == 0) return -1;
    } else if (this.t == 1) return this.data[0];
    else if (this.t == 0) return 0;
    // assumes 16 < DB < 32
    return (this.data[1] & (1 << 32 - this.DB) - 1) << this.DB | this.data[0];
}
//(public) return value as byte
function $b42e6ac2b62f6e80$var$bnByteValue() {
    return this.t == 0 ? this.s : this.data[0] << 24 >> 24;
}
//(public) return value as short (assumes DB>=16)
function $b42e6ac2b62f6e80$var$bnShortValue() {
    return this.t == 0 ? this.s : this.data[0] << 16 >> 16;
}
//(protected) return x s.t. r^x < DV
function $b42e6ac2b62f6e80$var$bnpChunkSize(r) {
    return Math.floor(Math.LN2 * this.DB / Math.log(r));
}
//(public) 0 if this == 0, 1 if this > 0
function $b42e6ac2b62f6e80$var$bnSigNum() {
    if (this.s < 0) return -1;
    else if (this.t <= 0 || this.t == 1 && this.data[0] <= 0) return 0;
    else return 1;
}
//(protected) convert to radix string
function $b42e6ac2b62f6e80$var$bnpToRadix(b) {
    if (b == null) b = 10;
    if (this.signum() == 0 || b < 2 || b > 36) return "0";
    var cs = this.chunkSize(b);
    var a = Math.pow(b, cs);
    var d = $b42e6ac2b62f6e80$var$nbv(a), y = $b42e6ac2b62f6e80$var$nbi(), z = $b42e6ac2b62f6e80$var$nbi(), r = "";
    this.divRemTo(d, y, z);
    while(y.signum() > 0){
        r = (a + z.intValue()).toString(b).substr(1) + r;
        y.divRemTo(d, y, z);
    }
    return z.intValue().toString(b) + r;
}
//(protected) convert from radix string
function $b42e6ac2b62f6e80$var$bnpFromRadix(s, b) {
    this.fromInt(0);
    if (b == null) b = 10;
    var cs = this.chunkSize(b);
    var d = Math.pow(b, cs), mi = false, j = 0, w = 0;
    for(var i = 0; i < s.length; ++i){
        var x = $b42e6ac2b62f6e80$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
            continue;
        }
        w = b * w + x;
        if (++j >= cs) {
            this.dMultiply(d);
            this.dAddOffset(w, 0);
            j = 0;
            w = 0;
        }
    }
    if (j > 0) {
        this.dMultiply(Math.pow(b, j));
        this.dAddOffset(w, 0);
    }
    if (mi) $b42e6ac2b62f6e80$var$BigInteger.ZERO.subTo(this, this);
}
//(protected) alternate constructor
function $b42e6ac2b62f6e80$var$bnpFromNumber(a, b, c) {
    if ("number" == typeof b) {
        // new BigInteger(int,int,RNG)
        if (a < 2) this.fromInt(1);
        else {
            this.fromNumber(a, c);
            if (!this.testBit(a - 1)) this.bitwiseTo($b42e6ac2b62f6e80$var$BigInteger.ONE.shiftLeft(a - 1), $b42e6ac2b62f6e80$var$op_or, this);
            if (this.isEven()) this.dAddOffset(1, 0); // force odd
            while(!this.isProbablePrime(b)){
                this.dAddOffset(2, 0);
                if (this.bitLength() > a) this.subTo($b42e6ac2b62f6e80$var$BigInteger.ONE.shiftLeft(a - 1), this);
            }
        }
    } else {
        // new BigInteger(int,RNG)
        var x = new Array(), t = a & 7;
        x.length = (a >> 3) + 1;
        b.nextBytes(x);
        if (t > 0) x[0] &= (1 << t) - 1;
        else x[0] = 0;
        this.fromString(x, 256);
    }
}
//(public) convert to bigendian byte array
function $b42e6ac2b62f6e80$var$bnToByteArray() {
    var i = this.t, r = new Array();
    r[0] = this.s;
    var p = this.DB - i * this.DB % 8, d, k = 0;
    if (i-- > 0) {
        if (p < this.DB && (d = this.data[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;
        while(i >= 0){
            if (p < 8) {
                d = (this.data[i] & (1 << p) - 1) << 8 - p;
                d |= this.data[--i] >> (p += this.DB - 8);
            } else {
                d = this.data[i] >> (p -= 8) & 0xff;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if ((d & 0x80) != 0) d |= -256;
            if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
            if (k > 0 || d != this.s) r[k++] = d;
        }
    }
    return r;
}
function $b42e6ac2b62f6e80$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
function $b42e6ac2b62f6e80$var$bnMin(a) {
    return this.compareTo(a) < 0 ? this : a;
}
function $b42e6ac2b62f6e80$var$bnMax(a) {
    return this.compareTo(a) > 0 ? this : a;
}
//(protected) r = this op a (bitwise)
function $b42e6ac2b62f6e80$var$bnpBitwiseTo(a, op, r) {
    var i, f, m = Math.min(a.t, this.t);
    for(i = 0; i < m; ++i)r.data[i] = op(this.data[i], a.data[i]);
    if (a.t < this.t) {
        f = a.s & this.DM;
        for(i = m; i < this.t; ++i)r.data[i] = op(this.data[i], f);
        r.t = this.t;
    } else {
        f = this.s & this.DM;
        for(i = m; i < a.t; ++i)r.data[i] = op(f, a.data[i]);
        r.t = a.t;
    }
    r.s = op(this.s, a.s);
    r.clamp();
}
//(public) this & a
function $b42e6ac2b62f6e80$var$op_and(x, y) {
    return x & y;
}
function $b42e6ac2b62f6e80$var$bnAnd(a) {
    var r = $b42e6ac2b62f6e80$var$nbi();
    this.bitwiseTo(a, $b42e6ac2b62f6e80$var$op_and, r);
    return r;
}
//(public) this | a
function $b42e6ac2b62f6e80$var$op_or(x, y) {
    return x | y;
}
function $b42e6ac2b62f6e80$var$bnOr(a) {
    var r = $b42e6ac2b62f6e80$var$nbi();
    this.bitwiseTo(a, $b42e6ac2b62f6e80$var$op_or, r);
    return r;
}
//(public) this ^ a
function $b42e6ac2b62f6e80$var$op_xor(x, y) {
    return x ^ y;
}
function $b42e6ac2b62f6e80$var$bnXor(a) {
    var r = $b42e6ac2b62f6e80$var$nbi();
    this.bitwiseTo(a, $b42e6ac2b62f6e80$var$op_xor, r);
    return r;
}
//(public) this & ~a
function $b42e6ac2b62f6e80$var$op_andnot(x, y) {
    return x & ~y;
}
function $b42e6ac2b62f6e80$var$bnAndNot(a) {
    var r = $b42e6ac2b62f6e80$var$nbi();
    this.bitwiseTo(a, $b42e6ac2b62f6e80$var$op_andnot, r);
    return r;
}
//(public) ~this
function $b42e6ac2b62f6e80$var$bnNot() {
    var r = $b42e6ac2b62f6e80$var$nbi();
    for(var i = 0; i < this.t; ++i)r.data[i] = this.DM & ~this.data[i];
    r.t = this.t;
    r.s = ~this.s;
    return r;
}
//(public) this << n
function $b42e6ac2b62f6e80$var$bnShiftLeft(n) {
    var r = $b42e6ac2b62f6e80$var$nbi();
    if (n < 0) this.rShiftTo(-n, r);
    else this.lShiftTo(n, r);
    return r;
}
//(public) this >> n
function $b42e6ac2b62f6e80$var$bnShiftRight(n) {
    var r = $b42e6ac2b62f6e80$var$nbi();
    if (n < 0) this.lShiftTo(-n, r);
    else this.rShiftTo(n, r);
    return r;
}
//return index of lowest 1-bit in x, x < 2^31
function $b42e6ac2b62f6e80$var$lbit(x) {
    if (x == 0) return -1;
    var r = 0;
    if ((x & 0xffff) == 0) {
        x >>= 16;
        r += 16;
    }
    if ((x & 0xff) == 0) {
        x >>= 8;
        r += 8;
    }
    if ((x & 0xf) == 0) {
        x >>= 4;
        r += 4;
    }
    if ((x & 3) == 0) {
        x >>= 2;
        r += 2;
    }
    if ((x & 1) == 0) ++r;
    return r;
}
//(public) returns index of lowest 1-bit (or -1 if none)
function $b42e6ac2b62f6e80$var$bnGetLowestSetBit() {
    for(var i = 0; i < this.t; ++i)if (this.data[i] != 0) return i * this.DB + $b42e6ac2b62f6e80$var$lbit(this.data[i]);
    if (this.s < 0) return this.t * this.DB;
    return -1;
}
//return number of 1 bits in x
function $b42e6ac2b62f6e80$var$cbit(x) {
    var r = 0;
    while(x != 0){
        x &= x - 1;
        ++r;
    }
    return r;
}
//(public) return number of set bits
function $b42e6ac2b62f6e80$var$bnBitCount() {
    var r = 0, x = this.s & this.DM;
    for(var i = 0; i < this.t; ++i)r += $b42e6ac2b62f6e80$var$cbit(this.data[i] ^ x);
    return r;
}
//(public) true iff nth bit is set
function $b42e6ac2b62f6e80$var$bnTestBit(n) {
    var j = Math.floor(n / this.DB);
    if (j >= this.t) return this.s != 0;
    return (this.data[j] & 1 << n % this.DB) != 0;
}
//(protected) this op (1<<n)
function $b42e6ac2b62f6e80$var$bnpChangeBit(n, op) {
    var r = $b42e6ac2b62f6e80$var$BigInteger.ONE.shiftLeft(n);
    this.bitwiseTo(r, op, r);
    return r;
}
//(public) this | (1<<n)
function $b42e6ac2b62f6e80$var$bnSetBit(n) {
    return this.changeBit(n, $b42e6ac2b62f6e80$var$op_or);
}
//(public) this & ~(1<<n)
function $b42e6ac2b62f6e80$var$bnClearBit(n) {
    return this.changeBit(n, $b42e6ac2b62f6e80$var$op_andnot);
}
//(public) this ^ (1<<n)
function $b42e6ac2b62f6e80$var$bnFlipBit(n) {
    return this.changeBit(n, $b42e6ac2b62f6e80$var$op_xor);
}
//(protected) r = this + a
function $b42e6ac2b62f6e80$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this.data[i] + a.data[i];
        r.data[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a.data[i];
            r.data[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r.data[i++] = c;
    else if (c < -1) r.data[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
//(public) this + a
function $b42e6ac2b62f6e80$var$bnAdd(a) {
    var r = $b42e6ac2b62f6e80$var$nbi();
    this.addTo(a, r);
    return r;
}
//(public) this - a
function $b42e6ac2b62f6e80$var$bnSubtract(a) {
    var r = $b42e6ac2b62f6e80$var$nbi();
    this.subTo(a, r);
    return r;
}
//(public) this * a
function $b42e6ac2b62f6e80$var$bnMultiply(a) {
    var r = $b42e6ac2b62f6e80$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
//(public) this / a
function $b42e6ac2b62f6e80$var$bnDivide(a) {
    var r = $b42e6ac2b62f6e80$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
//(public) this % a
function $b42e6ac2b62f6e80$var$bnRemainder(a) {
    var r = $b42e6ac2b62f6e80$var$nbi();
    this.divRemTo(a, null, r);
    return r;
}
//(public) [this/a,this%a]
function $b42e6ac2b62f6e80$var$bnDivideAndRemainder(a) {
    var q = $b42e6ac2b62f6e80$var$nbi(), r = $b42e6ac2b62f6e80$var$nbi();
    this.divRemTo(a, q, r);
    return new Array(q, r);
}
//(protected) this *= n, this >= 0, 1 < n < DV
function $b42e6ac2b62f6e80$var$bnpDMultiply(n) {
    this.data[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
    ++this.t;
    this.clamp();
}
//(protected) this += n << w words, this >= 0
function $b42e6ac2b62f6e80$var$bnpDAddOffset(n, w) {
    if (n == 0) return;
    while(this.t <= w)this.data[this.t++] = 0;
    this.data[w] += n;
    while(this.data[w] >= this.DV){
        this.data[w] -= this.DV;
        if (++w >= this.t) this.data[this.t++] = 0;
        ++this.data[w];
    }
}
//A "null" reducer
function $b42e6ac2b62f6e80$var$NullExp() {}
function $b42e6ac2b62f6e80$var$nNop(x) {
    return x;
}
function $b42e6ac2b62f6e80$var$nMulTo(x, y, r) {
    x.multiplyTo(y, r);
}
function $b42e6ac2b62f6e80$var$nSqrTo(x, r) {
    x.squareTo(r);
}
$b42e6ac2b62f6e80$var$NullExp.prototype.convert = $b42e6ac2b62f6e80$var$nNop;
$b42e6ac2b62f6e80$var$NullExp.prototype.revert = $b42e6ac2b62f6e80$var$nNop;
$b42e6ac2b62f6e80$var$NullExp.prototype.mulTo = $b42e6ac2b62f6e80$var$nMulTo;
$b42e6ac2b62f6e80$var$NullExp.prototype.sqrTo = $b42e6ac2b62f6e80$var$nSqrTo;
//(public) this^e
function $b42e6ac2b62f6e80$var$bnPow(e) {
    return this.exp(e, new $b42e6ac2b62f6e80$var$NullExp());
}
//(protected) r = lower n words of "this * a", a.t <= n
//"this" should be the larger one if appropriate.
function $b42e6ac2b62f6e80$var$bnpMultiplyLowerTo(a, n, r) {
    var i = Math.min(this.t + a.t, n);
    r.s = 0; // assumes a,this >= 0
    r.t = i;
    while(i > 0)r.data[--i] = 0;
    var j;
    for(j = r.t - this.t; i < j; ++i)r.data[i + this.t] = this.am(0, a.data[i], r, i, 0, this.t);
    for(j = Math.min(a.t, n); i < j; ++i)this.am(0, a.data[i], r, i, 0, n - i);
    r.clamp();
}
//(protected) r = "this * a" without lower n words, n > 0
//"this" should be the larger one if appropriate.
function $b42e6ac2b62f6e80$var$bnpMultiplyUpperTo(a, n, r) {
    --n;
    var i = r.t = this.t + a.t - n;
    r.s = 0; // assumes a,this >= 0
    while(--i >= 0)r.data[i] = 0;
    for(i = Math.max(n - this.t, 0); i < a.t; ++i)r.data[this.t + i - n] = this.am(n - i, a.data[i], r, 0, 0, this.t + i - n);
    r.clamp();
    r.drShiftTo(1, r);
}
//Barrett modular reduction
function $b42e6ac2b62f6e80$var$Barrett(m) {
    // setup Barrett
    this.r2 = $b42e6ac2b62f6e80$var$nbi();
    this.q3 = $b42e6ac2b62f6e80$var$nbi();
    $b42e6ac2b62f6e80$var$BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
    this.mu = this.r2.divide(m);
    this.m = m;
}
function $b42e6ac2b62f6e80$var$barrettConvert(x) {
    if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
    else if (x.compareTo(this.m) < 0) return x;
    else {
        var r = $b42e6ac2b62f6e80$var$nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    }
}
function $b42e6ac2b62f6e80$var$barrettRevert(x) {
    return x;
}
//x = x mod m (HAC 14.42)
function $b42e6ac2b62f6e80$var$barrettReduce(x) {
    x.drShiftTo(this.m.t - 1, this.r2);
    if (x.t > this.m.t + 1) {
        x.t = this.m.t + 1;
        x.clamp();
    }
    this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
    this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
    while(x.compareTo(this.r2) < 0)x.dAddOffset(1, this.m.t + 1);
    x.subTo(this.r2, x);
    while(x.compareTo(this.m) >= 0)x.subTo(this.m, x);
}
//r = x^2 mod m; x != r
function $b42e6ac2b62f6e80$var$barrettSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
//r = x*y mod m; x,y != r
function $b42e6ac2b62f6e80$var$barrettMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$b42e6ac2b62f6e80$var$Barrett.prototype.convert = $b42e6ac2b62f6e80$var$barrettConvert;
$b42e6ac2b62f6e80$var$Barrett.prototype.revert = $b42e6ac2b62f6e80$var$barrettRevert;
$b42e6ac2b62f6e80$var$Barrett.prototype.reduce = $b42e6ac2b62f6e80$var$barrettReduce;
$b42e6ac2b62f6e80$var$Barrett.prototype.mulTo = $b42e6ac2b62f6e80$var$barrettMulTo;
$b42e6ac2b62f6e80$var$Barrett.prototype.sqrTo = $b42e6ac2b62f6e80$var$barrettSqrTo;
//(public) this^e % m (HAC 14.85)
function $b42e6ac2b62f6e80$var$bnModPow(e, m) {
    var i = e.bitLength(), k, r = $b42e6ac2b62f6e80$var$nbv(1), z;
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    if (i < 8) z = new $b42e6ac2b62f6e80$var$Classic(m);
    else if (m.isEven()) z = new $b42e6ac2b62f6e80$var$Barrett(m);
    else z = new $b42e6ac2b62f6e80$var$Montgomery(m);
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $b42e6ac2b62f6e80$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $b42e6ac2b62f6e80$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $b42e6ac2b62f6e80$var$nbi(), t;
    i = $b42e6ac2b62f6e80$var$nbits(e.data[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e.data[j] >> i - k1 & km;
        else {
            w = (e.data[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e.data[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e.data[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    return z.revert(r);
}
//(public) gcd(this,a) (HAC 14.54)
function $b42e6ac2b62f6e80$var$bnGCD(a) {
    var x = this.s < 0 ? this.negate() : this.clone();
    var y = a.s < 0 ? a.negate() : a.clone();
    if (x.compareTo(y) < 0) {
        var t = x;
        x = y;
        y = t;
    }
    var i = x.getLowestSetBit(), g = y.getLowestSetBit();
    if (g < 0) return x;
    if (i < g) g = i;
    if (g > 0) {
        x.rShiftTo(g, x);
        y.rShiftTo(g, y);
    }
    while(x.signum() > 0){
        if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
        if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
        if (x.compareTo(y) >= 0) {
            x.subTo(y, x);
            x.rShiftTo(1, x);
        } else {
            y.subTo(x, y);
            y.rShiftTo(1, y);
        }
    }
    if (g > 0) y.lShiftTo(g, y);
    return y;
}
//(protected) this % n, n < 2^26
function $b42e6ac2b62f6e80$var$bnpModInt(n) {
    if (n <= 0) return 0;
    var d = this.DV % n, r = this.s < 0 ? n - 1 : 0;
    if (this.t > 0) {
        if (d == 0) r = this.data[0] % n;
        else for(var i = this.t - 1; i >= 0; --i)r = (d * r + this.data[i]) % n;
    }
    return r;
}
//(public) 1/this % m (HAC 14.61)
function $b42e6ac2b62f6e80$var$bnModInverse(m) {
    var ac = m.isEven();
    if (this.isEven() && ac || m.signum() == 0) return $b42e6ac2b62f6e80$var$BigInteger.ZERO;
    var u = m.clone(), v = this.clone();
    var a = $b42e6ac2b62f6e80$var$nbv(1), b = $b42e6ac2b62f6e80$var$nbv(0), c = $b42e6ac2b62f6e80$var$nbv(0), d = $b42e6ac2b62f6e80$var$nbv(1);
    while(u.signum() != 0){
        while(u.isEven()){
            u.rShiftTo(1, u);
            if (ac) {
                if (!a.isEven() || !b.isEven()) {
                    a.addTo(this, a);
                    b.subTo(m, b);
                }
                a.rShiftTo(1, a);
            } else if (!b.isEven()) b.subTo(m, b);
            b.rShiftTo(1, b);
        }
        while(v.isEven()){
            v.rShiftTo(1, v);
            if (ac) {
                if (!c.isEven() || !d.isEven()) {
                    c.addTo(this, c);
                    d.subTo(m, d);
                }
                c.rShiftTo(1, c);
            } else if (!d.isEven()) d.subTo(m, d);
            d.rShiftTo(1, d);
        }
        if (u.compareTo(v) >= 0) {
            u.subTo(v, u);
            if (ac) a.subTo(c, a);
            b.subTo(d, b);
        } else {
            v.subTo(u, v);
            if (ac) c.subTo(a, c);
            d.subTo(b, d);
        }
    }
    if (v.compareTo($b42e6ac2b62f6e80$var$BigInteger.ONE) != 0) return $b42e6ac2b62f6e80$var$BigInteger.ZERO;
    if (d.compareTo(m) >= 0) return d.subtract(m);
    if (d.signum() < 0) d.addTo(m, d);
    else return d;
    if (d.signum() < 0) return d.add(m);
    else return d;
}
var $b42e6ac2b62f6e80$var$lowprimes = [
    2,
    3,
    5,
    7,
    11,
    13,
    17,
    19,
    23,
    29,
    31,
    37,
    41,
    43,
    47,
    53,
    59,
    61,
    67,
    71,
    73,
    79,
    83,
    89,
    97,
    101,
    103,
    107,
    109,
    113,
    127,
    131,
    137,
    139,
    149,
    151,
    157,
    163,
    167,
    173,
    179,
    181,
    191,
    193,
    197,
    199,
    211,
    223,
    227,
    229,
    233,
    239,
    241,
    251,
    257,
    263,
    269,
    271,
    277,
    281,
    283,
    293,
    307,
    311,
    313,
    317,
    331,
    337,
    347,
    349,
    353,
    359,
    367,
    373,
    379,
    383,
    389,
    397,
    401,
    409,
    419,
    421,
    431,
    433,
    439,
    443,
    449,
    457,
    461,
    463,
    467,
    479,
    487,
    491,
    499,
    503,
    509
];
var $b42e6ac2b62f6e80$var$lplim = 67108864 / $b42e6ac2b62f6e80$var$lowprimes[$b42e6ac2b62f6e80$var$lowprimes.length - 1];
//(public) test primality with certainty >= 1-.5^t
function $b42e6ac2b62f6e80$var$bnIsProbablePrime(t) {
    var i, x = this.abs();
    if (x.t == 1 && x.data[0] <= $b42e6ac2b62f6e80$var$lowprimes[$b42e6ac2b62f6e80$var$lowprimes.length - 1]) {
        for(i = 0; i < $b42e6ac2b62f6e80$var$lowprimes.length; ++i)if (x.data[0] == $b42e6ac2b62f6e80$var$lowprimes[i]) return true;
        return false;
    }
    if (x.isEven()) return false;
    i = 1;
    while(i < $b42e6ac2b62f6e80$var$lowprimes.length){
        var m = $b42e6ac2b62f6e80$var$lowprimes[i], j = i + 1;
        while(j < $b42e6ac2b62f6e80$var$lowprimes.length && m < $b42e6ac2b62f6e80$var$lplim)m *= $b42e6ac2b62f6e80$var$lowprimes[j++];
        m = x.modInt(m);
        while(i < j)if (m % $b42e6ac2b62f6e80$var$lowprimes[i++] == 0) return false;
    }
    return x.millerRabin(t);
}
//(protected) true if probably prime (HAC 4.24, Miller-Rabin)
function $b42e6ac2b62f6e80$var$bnpMillerRabin(t) {
    var n1 = this.subtract($b42e6ac2b62f6e80$var$BigInteger.ONE);
    var k = n1.getLowestSetBit();
    if (k <= 0) return false;
    var r = n1.shiftRight(k);
    var prng = $b42e6ac2b62f6e80$var$bnGetPrng();
    var a;
    for(var i = 0; i < t; ++i){
        // select witness 'a' at random from between 1 and n1
        do a = new $b42e6ac2b62f6e80$var$BigInteger(this.bitLength(), prng);
        while (a.compareTo($b42e6ac2b62f6e80$var$BigInteger.ONE) <= 0 || a.compareTo(n1) >= 0);
        var y = a.modPow(r, this);
        if (y.compareTo($b42e6ac2b62f6e80$var$BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
            var j = 1;
            while(j++ < k && y.compareTo(n1) != 0){
                y = y.modPowInt(2, this);
                if (y.compareTo($b42e6ac2b62f6e80$var$BigInteger.ONE) == 0) return false;
            }
            if (y.compareTo(n1) != 0) return false;
        }
    }
    return true;
}
// get pseudo random number generator
function $b42e6ac2b62f6e80$var$bnGetPrng() {
    // create prng with api that matches BigInteger secure random
    return {
        // x is an array to fill with bytes
        nextBytes: function(x) {
            for(var i = 0; i < x.length; ++i)x[i] = Math.floor(Math.random() * 0x0100);
        }
    };
}
//protected
$b42e6ac2b62f6e80$var$BigInteger.prototype.chunkSize = $b42e6ac2b62f6e80$var$bnpChunkSize;
$b42e6ac2b62f6e80$var$BigInteger.prototype.toRadix = $b42e6ac2b62f6e80$var$bnpToRadix;
$b42e6ac2b62f6e80$var$BigInteger.prototype.fromRadix = $b42e6ac2b62f6e80$var$bnpFromRadix;
$b42e6ac2b62f6e80$var$BigInteger.prototype.fromNumber = $b42e6ac2b62f6e80$var$bnpFromNumber;
$b42e6ac2b62f6e80$var$BigInteger.prototype.bitwiseTo = $b42e6ac2b62f6e80$var$bnpBitwiseTo;
$b42e6ac2b62f6e80$var$BigInteger.prototype.changeBit = $b42e6ac2b62f6e80$var$bnpChangeBit;
$b42e6ac2b62f6e80$var$BigInteger.prototype.addTo = $b42e6ac2b62f6e80$var$bnpAddTo;
$b42e6ac2b62f6e80$var$BigInteger.prototype.dMultiply = $b42e6ac2b62f6e80$var$bnpDMultiply;
$b42e6ac2b62f6e80$var$BigInteger.prototype.dAddOffset = $b42e6ac2b62f6e80$var$bnpDAddOffset;
$b42e6ac2b62f6e80$var$BigInteger.prototype.multiplyLowerTo = $b42e6ac2b62f6e80$var$bnpMultiplyLowerTo;
$b42e6ac2b62f6e80$var$BigInteger.prototype.multiplyUpperTo = $b42e6ac2b62f6e80$var$bnpMultiplyUpperTo;
$b42e6ac2b62f6e80$var$BigInteger.prototype.modInt = $b42e6ac2b62f6e80$var$bnpModInt;
$b42e6ac2b62f6e80$var$BigInteger.prototype.millerRabin = $b42e6ac2b62f6e80$var$bnpMillerRabin;
//public
$b42e6ac2b62f6e80$var$BigInteger.prototype.clone = $b42e6ac2b62f6e80$var$bnClone;
$b42e6ac2b62f6e80$var$BigInteger.prototype.intValue = $b42e6ac2b62f6e80$var$bnIntValue;
$b42e6ac2b62f6e80$var$BigInteger.prototype.byteValue = $b42e6ac2b62f6e80$var$bnByteValue;
$b42e6ac2b62f6e80$var$BigInteger.prototype.shortValue = $b42e6ac2b62f6e80$var$bnShortValue;
$b42e6ac2b62f6e80$var$BigInteger.prototype.signum = $b42e6ac2b62f6e80$var$bnSigNum;
$b42e6ac2b62f6e80$var$BigInteger.prototype.toByteArray = $b42e6ac2b62f6e80$var$bnToByteArray;
$b42e6ac2b62f6e80$var$BigInteger.prototype.equals = $b42e6ac2b62f6e80$var$bnEquals;
$b42e6ac2b62f6e80$var$BigInteger.prototype.min = $b42e6ac2b62f6e80$var$bnMin;
$b42e6ac2b62f6e80$var$BigInteger.prototype.max = $b42e6ac2b62f6e80$var$bnMax;
$b42e6ac2b62f6e80$var$BigInteger.prototype.and = $b42e6ac2b62f6e80$var$bnAnd;
$b42e6ac2b62f6e80$var$BigInteger.prototype.or = $b42e6ac2b62f6e80$var$bnOr;
$b42e6ac2b62f6e80$var$BigInteger.prototype.xor = $b42e6ac2b62f6e80$var$bnXor;
$b42e6ac2b62f6e80$var$BigInteger.prototype.andNot = $b42e6ac2b62f6e80$var$bnAndNot;
$b42e6ac2b62f6e80$var$BigInteger.prototype.not = $b42e6ac2b62f6e80$var$bnNot;
$b42e6ac2b62f6e80$var$BigInteger.prototype.shiftLeft = $b42e6ac2b62f6e80$var$bnShiftLeft;
$b42e6ac2b62f6e80$var$BigInteger.prototype.shiftRight = $b42e6ac2b62f6e80$var$bnShiftRight;
$b42e6ac2b62f6e80$var$BigInteger.prototype.getLowestSetBit = $b42e6ac2b62f6e80$var$bnGetLowestSetBit;
$b42e6ac2b62f6e80$var$BigInteger.prototype.bitCount = $b42e6ac2b62f6e80$var$bnBitCount;
$b42e6ac2b62f6e80$var$BigInteger.prototype.testBit = $b42e6ac2b62f6e80$var$bnTestBit;
$b42e6ac2b62f6e80$var$BigInteger.prototype.setBit = $b42e6ac2b62f6e80$var$bnSetBit;
$b42e6ac2b62f6e80$var$BigInteger.prototype.clearBit = $b42e6ac2b62f6e80$var$bnClearBit;
$b42e6ac2b62f6e80$var$BigInteger.prototype.flipBit = $b42e6ac2b62f6e80$var$bnFlipBit;
$b42e6ac2b62f6e80$var$BigInteger.prototype.add = $b42e6ac2b62f6e80$var$bnAdd;
$b42e6ac2b62f6e80$var$BigInteger.prototype.subtract = $b42e6ac2b62f6e80$var$bnSubtract;
$b42e6ac2b62f6e80$var$BigInteger.prototype.multiply = $b42e6ac2b62f6e80$var$bnMultiply;
$b42e6ac2b62f6e80$var$BigInteger.prototype.divide = $b42e6ac2b62f6e80$var$bnDivide;
$b42e6ac2b62f6e80$var$BigInteger.prototype.remainder = $b42e6ac2b62f6e80$var$bnRemainder;
$b42e6ac2b62f6e80$var$BigInteger.prototype.divideAndRemainder = $b42e6ac2b62f6e80$var$bnDivideAndRemainder;
$b42e6ac2b62f6e80$var$BigInteger.prototype.modPow = $b42e6ac2b62f6e80$var$bnModPow;
$b42e6ac2b62f6e80$var$BigInteger.prototype.modInverse = $b42e6ac2b62f6e80$var$bnModInverse;
$b42e6ac2b62f6e80$var$BigInteger.prototype.pow = $b42e6ac2b62f6e80$var$bnPow;
$b42e6ac2b62f6e80$var$BigInteger.prototype.gcd = $b42e6ac2b62f6e80$var$bnGCD;
$b42e6ac2b62f6e80$var$BigInteger.prototype.isProbablePrime = $b42e6ac2b62f6e80$var$bnIsProbablePrime; //BigInteger interfaces not implemented in jsbn:
 //BigInteger(int signum, byte[] magnitude)
 //double doubleValue()
 //float floatValue()
 //int hashCode()
 //long longValue()
 //static BigInteger valueOf(long val)

});

parcelRequire.register("gzHst", function(module, exports) {
/**
 * Partial implementation of PKCS#1 v2.2: RSA-OEAP
 *
 * Modified but based on the following MIT and BSD licensed code:
 *
 * https://github.com/kjur/jsjws/blob/master/rsa.js:
 *
 * The 'jsjws'(JSON Web Signature JavaScript Library) License
 *
 * Copyright (c) 2012 Kenji Urushima
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 * http://webrsa.cvs.sourceforge.net/viewvc/webrsa/Client/RSAES-OAEP.js?content-type=text%2Fplain:
 *
 * RSAES-OAEP.js
 * $Id: RSAES-OAEP.js,v 1.1.1.1 2003/03/19 15:37:20 ellispritchard Exp $
 * JavaScript Implementation of PKCS #1 v2.1 RSA CRYPTOGRAPHY STANDARD (RSA Laboratories, June 14, 2002)
 * Copyright (C) Ellis Pritchard, Guardian Unlimited 2003.
 * Contact: ellis@nukinetics.com
 * Distributed under the BSD License.
 *
 * Official documentation: http://www.rsa.com/rsalabs/node.asp?id=2125
 *
 * @author Evan Jones (http://evanjones.ca/)
 * @author Dave Longley
 *
 * Copyright (c) 2013-2014 Digital Bazaar, Inc.
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("e73pV");
parcelRequire("eeWuT");
parcelRequire("7PN5k");
// shortcut for PKCS#1 API
var $c111a022132f2584$var$pkcs1 = module.exports = $2xc86.pkcs1 = $2xc86.pkcs1 || {};
/**
 * Encode the given RSAES-OAEP message (M) using key, with optional label (L)
 * and seed.
 *
 * This method does not perform RSA encryption, it only encodes the message
 * using RSAES-OAEP.
 *
 * @param key the RSA key to use.
 * @param message the message to encode.
 * @param options the options to use:
 *          label an optional label to use.
 *          seed the seed to use.
 *          md the message digest object to use, undefined for SHA-1.
 *          mgf1 optional mgf1 parameters:
 *            md the message digest object to use for MGF1.
 *
 * @return the encoded message bytes.
 */ $c111a022132f2584$var$pkcs1.encode_rsa_oaep = function(key, message, options) {
    // parse arguments
    var label;
    var seed;
    var md;
    var mgf1Md;
    // legacy args (label, seed, md)
    if (typeof options === "string") {
        label = options;
        seed = arguments[3] || undefined;
        md = arguments[4] || undefined;
    } else if (options) {
        label = options.label || undefined;
        seed = options.seed || undefined;
        md = options.md || undefined;
        if (options.mgf1 && options.mgf1.md) mgf1Md = options.mgf1.md;
    }
    // default OAEP to SHA-1 message digest
    if (!md) md = $2xc86.md.sha1.create();
    else md.start();
    // default MGF-1 to same as OAEP
    if (!mgf1Md) mgf1Md = md;
    // compute length in bytes and check output
    var keyLength = Math.ceil(key.n.bitLength() / 8);
    var maxLength = keyLength - 2 * md.digestLength - 2;
    if (message.length > maxLength) {
        var error = new Error("RSAES-OAEP input message length is too long.");
        error.length = message.length;
        error.maxLength = maxLength;
        throw error;
    }
    if (!label) label = "";
    md.update(label, "raw");
    var lHash = md.digest();
    var PS = "";
    var PS_length = maxLength - message.length;
    for(var i = 0; i < PS_length; i++)PS += "\x00";
    var DB = lHash.getBytes() + PS + "\x01" + message;
    if (!seed) seed = $2xc86.random.getBytes(md.digestLength);
    else if (seed.length !== md.digestLength) {
        var error = new Error("Invalid RSAES-OAEP seed. The seed length must match the digest length.");
        error.seedLength = seed.length;
        error.digestLength = md.digestLength;
        throw error;
    }
    var dbMask = $c111a022132f2584$var$rsa_mgf1(seed, keyLength - md.digestLength - 1, mgf1Md);
    var maskedDB = $2xc86.util.xorBytes(DB, dbMask, DB.length);
    var seedMask = $c111a022132f2584$var$rsa_mgf1(maskedDB, md.digestLength, mgf1Md);
    var maskedSeed = $2xc86.util.xorBytes(seed, seedMask, seed.length);
    // return encoded message
    return "\x00" + maskedSeed + maskedDB;
};
/**
 * Decode the given RSAES-OAEP encoded message (EM) using key, with optional
 * label (L).
 *
 * This method does not perform RSA decryption, it only decodes the message
 * using RSAES-OAEP.
 *
 * @param key the RSA key to use.
 * @param em the encoded message to decode.
 * @param options the options to use:
 *          label an optional label to use.
 *          md the message digest object to use for OAEP, undefined for SHA-1.
 *          mgf1 optional mgf1 parameters:
 *            md the message digest object to use for MGF1.
 *
 * @return the decoded message bytes.
 */ $c111a022132f2584$var$pkcs1.decode_rsa_oaep = function(key, em, options) {
    // parse args
    var label;
    var md;
    var mgf1Md;
    // legacy args
    if (typeof options === "string") {
        label = options;
        md = arguments[3] || undefined;
    } else if (options) {
        label = options.label || undefined;
        md = options.md || undefined;
        if (options.mgf1 && options.mgf1.md) mgf1Md = options.mgf1.md;
    }
    // compute length in bytes
    var keyLength = Math.ceil(key.n.bitLength() / 8);
    if (em.length !== keyLength) {
        var error = new Error("RSAES-OAEP encoded message length is invalid.");
        error.length = em.length;
        error.expectedLength = keyLength;
        throw error;
    }
    // default OAEP to SHA-1 message digest
    if (md === undefined) md = $2xc86.md.sha1.create();
    else md.start();
    // default MGF-1 to same as OAEP
    if (!mgf1Md) mgf1Md = md;
    if (keyLength < 2 * md.digestLength + 2) throw new Error("RSAES-OAEP key is too short for the hash function.");
    if (!label) label = "";
    md.update(label, "raw");
    var lHash = md.digest().getBytes();
    // split the message into its parts
    var y = em.charAt(0);
    var maskedSeed = em.substring(1, md.digestLength + 1);
    var maskedDB = em.substring(1 + md.digestLength);
    var seedMask = $c111a022132f2584$var$rsa_mgf1(maskedDB, md.digestLength, mgf1Md);
    var seed = $2xc86.util.xorBytes(maskedSeed, seedMask, maskedSeed.length);
    var dbMask = $c111a022132f2584$var$rsa_mgf1(seed, keyLength - md.digestLength - 1, mgf1Md);
    var db = $2xc86.util.xorBytes(maskedDB, dbMask, maskedDB.length);
    var lHashPrime = db.substring(0, md.digestLength);
    // constant time check that all values match what is expected
    var error = y !== "\x00";
    // constant time check lHash vs lHashPrime
    for(var i = 0; i < md.digestLength; ++i)error |= lHash.charAt(i) !== lHashPrime.charAt(i);
    // "constant time" find the 0x1 byte separating the padding (zeros) from the
    // message
    // TODO: It must be possible to do this in a better/smarter way?
    var in_ps = 1;
    var index = md.digestLength;
    for(var j = md.digestLength; j < db.length; j++){
        var code = db.charCodeAt(j);
        var is_0 = code & 0x1 ^ 0x1;
        // non-zero if not 0 or 1 in the ps section
        var error_mask = in_ps ? 0xfffe : 0x0000;
        error |= code & error_mask;
        // latch in_ps to zero after we find 0x1
        in_ps = in_ps & is_0;
        index += in_ps;
    }
    if (error || db.charCodeAt(index) !== 0x1) throw new Error("Invalid RSAES-OAEP padding.");
    return db.substring(index + 1);
};
function $c111a022132f2584$var$rsa_mgf1(seed, maskLength, hash) {
    // default to SHA-1 message digest
    if (!hash) hash = $2xc86.md.sha1.create();
    var t = "";
    var count = Math.ceil(maskLength / hash.digestLength);
    for(var i = 0; i < count; ++i){
        var c = String.fromCharCode(i >> 24 & 0xFF, i >> 16 & 0xFF, i >> 8 & 0xFF, i & 0xFF);
        hash.start();
        hash.update(seed + c);
        t += hash.digest().getBytes();
    }
    return t.substring(0, maskLength);
}

});
parcelRequire.register("7PN5k", function(module, exports) {
/**
 * Secure Hash Algorithm with 160-bit digest (SHA-1) implementation.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2015 Digital Bazaar, Inc.
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("eeecL");
parcelRequire("e73pV");
var $5b435f0bf0415899$var$sha1 = module.exports = $2xc86.sha1 = $2xc86.sha1 || {};
$2xc86.md.sha1 = $2xc86.md.algorithms.sha1 = $5b435f0bf0415899$var$sha1;
/**
 * Creates a SHA-1 message digest object.
 *
 * @return a message digest object.
 */ $5b435f0bf0415899$var$sha1.create = function() {
    // do initialization as necessary
    if (!$5b435f0bf0415899$var$_initialized) $5b435f0bf0415899$var$_init();
    // SHA-1 state contains five 32-bit integers
    var _state = null;
    // input buffer
    var _input = $2xc86.util.createBuffer();
    // used for word storage
    var _w = new Array(80);
    // message digest object
    var md = {
        algorithm: "sha1",
        blockLength: 64,
        digestLength: 20,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 8
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength64 for backwards-compatibility)
        md.fullMessageLength = md.messageLength64 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $2xc86.util.createBuffer();
        _state = {
            h0: 0x67452301,
            h1: 0xEFCDAB89,
            h2: 0x98BADCFE,
            h3: 0x10325476,
            h4: 0xC3D2E1F0
        };
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === "utf8") msg = $2xc86.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $5b435f0bf0415899$var$_update(_state, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate SHA-1 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 448 mod 512. In other words,
    the data to be digested must be a multiple of 512 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 8 bytes (64
    bits), that means that the last segment of the data must have 56 bytes
    (448 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 448 mod 512 because
    512 - 128 = 448.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 448 mod 512, then 512 padding bits must be added. */ var finalBlock = $2xc86.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($5b435f0bf0415899$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in big-endian order; since length
        // is stored in bytes we multiply by 8 and add carry from next int
        var next, carry;
        var bits = md.fullMessageLength[0] * 8;
        for(var i = 0; i < md.fullMessageLength.length - 1; ++i){
            next = md.fullMessageLength[i + 1] * 8;
            carry = next / 0x100000000 >>> 0;
            bits += carry;
            finalBlock.putInt32(bits >>> 0);
            bits = next >>> 0;
        }
        finalBlock.putInt32(bits);
        var s2 = {
            h0: _state.h0,
            h1: _state.h1,
            h2: _state.h2,
            h3: _state.h3,
            h4: _state.h4
        };
        $5b435f0bf0415899$var$_update(s2, _w, finalBlock);
        var rval = $2xc86.util.createBuffer();
        rval.putInt32(s2.h0);
        rval.putInt32(s2.h1);
        rval.putInt32(s2.h2);
        rval.putInt32(s2.h3);
        rval.putInt32(s2.h4);
        return rval;
    };
    return md;
};
// sha-1 padding bytes not initialized yet
var $5b435f0bf0415899$var$_padding = null;
var $5b435f0bf0415899$var$_initialized = false;
/**
 * Initializes the constant tables.
 */ function $5b435f0bf0415899$var$_init() {
    // create padding
    $5b435f0bf0415899$var$_padding = String.fromCharCode(128);
    $5b435f0bf0415899$var$_padding += $2xc86.util.fillString(String.fromCharCode(0x00), 64);
    // now initialized
    $5b435f0bf0415899$var$_initialized = true;
}
/**
 * Updates a SHA-1 state with the given byte buffer.
 *
 * @param s the SHA-1 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $5b435f0bf0415899$var$_update(s, w, bytes) {
    // consume 512 bit (64 byte) chunks
    var t, a, b, c, d, e, f, i;
    var len = bytes.length();
    while(len >= 64){
        // the w array will be populated with sixteen 32-bit big-endian words
        // and then extended into 80 32-bit words according to SHA-1 algorithm
        // and for 32-79 using Max Locktyukhin's optimization
        // initialize hash value for this chunk
        a = s.h0;
        b = s.h1;
        c = s.h2;
        d = s.h3;
        e = s.h4;
        // round 1
        for(i = 0; i < 16; ++i){
            t = bytes.getInt32();
            w[i] = t;
            f = d ^ b & (c ^ d);
            t = (a << 5 | a >>> 27) + f + e + 0x5A827999 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        for(; i < 20; ++i){
            t = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
            t = t << 1 | t >>> 31;
            w[i] = t;
            f = d ^ b & (c ^ d);
            t = (a << 5 | a >>> 27) + f + e + 0x5A827999 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // round 2
        for(; i < 32; ++i){
            t = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
            t = t << 1 | t >>> 31;
            w[i] = t;
            f = b ^ c ^ d;
            t = (a << 5 | a >>> 27) + f + e + 0x6ED9EBA1 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        for(; i < 40; ++i){
            t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
            t = t << 2 | t >>> 30;
            w[i] = t;
            f = b ^ c ^ d;
            t = (a << 5 | a >>> 27) + f + e + 0x6ED9EBA1 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // round 3
        for(; i < 60; ++i){
            t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
            t = t << 2 | t >>> 30;
            w[i] = t;
            f = b & c | d & (b ^ c);
            t = (a << 5 | a >>> 27) + f + e + 0x8F1BBCDC + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // round 4
        for(; i < 80; ++i){
            t = w[i - 6] ^ w[i - 16] ^ w[i - 28] ^ w[i - 32];
            t = t << 2 | t >>> 30;
            w[i] = t;
            f = b ^ c ^ d;
            t = (a << 5 | a >>> 27) + f + e + 0xCA62C1D6 + t;
            e = d;
            d = c;
            // `>>> 0` necessary to avoid iOS/Safari 10 optimization bug
            c = (b << 30 | b >>> 2) >>> 0;
            b = a;
            a = t;
        }
        // update hash state
        s.h0 = s.h0 + a | 0;
        s.h1 = s.h1 + b | 0;
        s.h2 = s.h2 + c | 0;
        s.h3 = s.h3 + d | 0;
        s.h4 = s.h4 + e | 0;
        len -= 64;
    }
}

});


parcelRequire.register("LFqV4", function(module, exports) {
/**
 * Prime number generation API.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2014 Digital Bazaar, Inc.
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("e73pV");
parcelRequire("ft6fW");
parcelRequire("eeWuT");
(function() {
    // forge.prime already defined
    if ($2xc86.prime) {
        module.exports = $2xc86.prime;
        return;
    }
    /* PRIME API */ var prime = module.exports = $2xc86.prime = $2xc86.prime || {};
    var BigInteger = $2xc86.jsbn.BigInteger;
    // primes are 30k+i for i = 1, 7, 11, 13, 17, 19, 23, 29
    var GCD_30_DELTA = [
        6,
        4,
        2,
        4,
        2,
        4,
        6,
        2
    ];
    var THIRTY = new BigInteger(null);
    THIRTY.fromInt(30);
    var op_or = function(x, y) {
        return x | y;
    };
    /**
 * Generates a random probable prime with the given number of bits.
 *
 * Alternative algorithms can be specified by name as a string or as an
 * object with custom options like so:
 *
 * {
 *   name: 'PRIMEINC',
 *   options: {
 *     maxBlockTime: <the maximum amount of time to block the main
 *       thread before allowing I/O other JS to run>,
 *     millerRabinTests: <the number of miller-rabin tests to run>,
 *     workerScript: <the worker script URL>,
 *     workers: <the number of web workers (if supported) to use,
 *       -1 to use estimated cores minus one>.
 *     workLoad: the size of the work load, ie: number of possible prime
 *       numbers for each web worker to check per work assignment,
 *       (default: 100).
 *   }
 * }
 *
 * @param bits the number of bits for the prime number.
 * @param options the options to use.
 *          [algorithm] the algorithm to use (default: 'PRIMEINC').
 *          [prng] a custom crypto-secure pseudo-random number generator to use,
 *            that must define "getBytesSync".
 *
 * @return callback(err, num) called once the operation completes.
 */ prime.generateProbablePrime = function(bits, options, callback) {
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        options = options || {};
        // default to PRIMEINC algorithm
        var algorithm = options.algorithm || "PRIMEINC";
        if (typeof algorithm === "string") algorithm = {
            name: algorithm
        };
        algorithm.options = algorithm.options || {};
        // create prng with api that matches BigInteger secure random
        var prng = options.prng || $2xc86.random;
        var rng = {
            // x is an array to fill with bytes
            nextBytes: function(x) {
                var b = prng.getBytesSync(x.length);
                for(var i = 0; i < x.length; ++i)x[i] = b.charCodeAt(i);
            }
        };
        if (algorithm.name === "PRIMEINC") return primeincFindPrime(bits, rng, algorithm.options, callback);
        throw new Error("Invalid prime generation algorithm: " + algorithm.name);
    };
    function primeincFindPrime(bits, rng, options, callback) {
        if ("workers" in options) return primeincFindPrimeWithWorkers(bits, rng, options, callback);
        return primeincFindPrimeWithoutWorkers(bits, rng, options, callback);
    }
    function primeincFindPrimeWithoutWorkers(bits, rng, options, callback) {
        // initialize random number
        var num = generateRandom(bits, rng);
        /* Note: All primes are of the form 30k+i for i < 30 and gcd(30, i)=1. The
  number we are given is always aligned at 30k + 1. Each time the number is
  determined not to be prime we add to get to the next 'i', eg: if the number
  was at 30k + 1 we add 6. */ var deltaIdx = 0;
        // get required number of MR tests
        var mrTests = getMillerRabinTests(num.bitLength());
        if ("millerRabinTests" in options) mrTests = options.millerRabinTests;
        // find prime nearest to 'num' for maxBlockTime ms
        // 10 ms gives 5ms of leeway for other calculations before dropping
        // below 60fps (1000/60 == 16.67), but in reality, the number will
        // likely be higher due to an 'atomic' big int modPow
        var maxBlockTime = 10;
        if ("maxBlockTime" in options) maxBlockTime = options.maxBlockTime;
        _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback);
    }
    function _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback) {
        var start = +new Date();
        do {
            // overflow, regenerate random number
            if (num.bitLength() > bits) num = generateRandom(bits, rng);
            // do primality test
            if (num.isProbablePrime(mrTests)) return callback(null, num);
            // get next potential prime
            num.dAddOffset(GCD_30_DELTA[deltaIdx++ % 8], 0);
        }while (maxBlockTime < 0 || +new Date() - start < maxBlockTime);
        // keep trying later
        $2xc86.util.setImmediate(function() {
            _primeinc(num, bits, rng, deltaIdx, mrTests, maxBlockTime, callback);
        });
    }
    // NOTE: This algorithm is indeterminate in nature because workers
    // run in parallel looking at different segments of numbers. Even if this
    // algorithm is run twice with the same input from a predictable RNG, it
    // may produce different outputs.
    function primeincFindPrimeWithWorkers(bits, rng, options, callback) {
        // web workers unavailable
        if (typeof Worker === "undefined") return primeincFindPrimeWithoutWorkers(bits, rng, options, callback);
        // initialize random number
        var num = generateRandom(bits, rng);
        // use web workers to generate keys
        var numWorkers = options.workers;
        var workLoad = options.workLoad || 100;
        var range = workLoad * 30 / 8;
        var workerScript = options.workerScript || "forge/prime.worker.js";
        if (numWorkers === -1) return $2xc86.util.estimateCores(function(err, cores) {
            if (err) // default to 2
            cores = 2;
            numWorkers = cores - 1;
            generate();
        });
        generate();
        function generate() {
            // require at least 1 worker
            numWorkers = Math.max(1, numWorkers);
            // TODO: consider optimizing by starting workers outside getPrime() ...
            // note that in order to clean up they will have to be made internally
            // asynchronous which may actually be slower
            // start workers immediately
            var workers = [];
            for(var i = 0; i < numWorkers; ++i)// FIXME: fix path or use blob URLs
            workers[i] = new Worker(workerScript);
            var running = numWorkers;
            // listen for requests from workers and assign ranges to find prime
            for(var i = 0; i < numWorkers; ++i)workers[i].addEventListener("message", workerMessage);
            /* Note: The distribution of random numbers is unknown. Therefore, each
    web worker is continuously allocated a range of numbers to check for a
    random number until one is found.

    Every 30 numbers will be checked just 8 times, because prime numbers
    have the form:

    30k+i, for i < 30 and gcd(30, i)=1 (there are 8 values of i for this)

    Therefore, if we want a web worker to run N checks before asking for
    a new range of numbers, each range must contain N*30/8 numbers.

    For 100 checks (workLoad), this is a range of 375. */ var found = false;
            function workerMessage(e) {
                // ignore message, prime already found
                if (found) return;
                --running;
                var data = e.data;
                if (data.found) {
                    // terminate all workers
                    for(var i = 0; i < workers.length; ++i)workers[i].terminate();
                    found = true;
                    return callback(null, new BigInteger(data.prime, 16));
                }
                // overflow, regenerate random number
                if (num.bitLength() > bits) num = generateRandom(bits, rng);
                // assign new range to check
                var hex = num.toString(16);
                // start prime search
                e.target.postMessage({
                    hex: hex,
                    workLoad: workLoad
                });
                num.dAddOffset(range, 0);
            }
        }
    }
    /**
 * Generates a random number using the given number of bits and RNG.
 *
 * @param bits the number of bits for the number.
 * @param rng the random number generator to use.
 *
 * @return the random number.
 */ function generateRandom(bits, rng) {
        var num = new BigInteger(bits, rng);
        // force MSB set
        var bits1 = bits - 1;
        if (!num.testBit(bits1)) num.bitwiseTo(BigInteger.ONE.shiftLeft(bits1), op_or, num);
        // align number on 30k+1 boundary
        num.dAddOffset(31 - num.mod(THIRTY).byteValue(), 0);
        return num;
    }
    /**
 * Returns the required number of Miller-Rabin tests to generate a
 * prime with an error probability of (1/2)^80.
 *
 * See Handbook of Applied Cryptography Chapter 4, Table 4.4.
 *
 * @param bits the bit size.
 *
 * @return the required number of iterations.
 */ function getMillerRabinTests(bits) {
        if (bits <= 100) return 27;
        if (bits <= 150) return 18;
        if (bits <= 200) return 15;
        if (bits <= 250) return 12;
        if (bits <= 300) return 9;
        if (bits <= 350) return 8;
        if (bits <= 400) return 7;
        if (bits <= 500) return 6;
        if (bits <= 600) return 5;
        if (bits <= 800) return 4;
        if (bits <= 1250) return 3;
        return 2;
    }
})();

});




parcelRequire.register("8EmV9", function(module, exports) {
/**
 * Password-based encryption functions.
 *
 * @author Dave Longley
 * @author Stefan Siegl <stesie@brokenpipe.de>
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * An EncryptedPrivateKeyInfo:
 *
 * EncryptedPrivateKeyInfo ::= SEQUENCE {
 *   encryptionAlgorithm  EncryptionAlgorithmIdentifier,
 *   encryptedData        EncryptedData }
 *
 * EncryptionAlgorithmIdentifier ::= AlgorithmIdentifier
 *
 * EncryptedData ::= OCTET STRING
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("a7tnS");
parcelRequire("l46Tq");
parcelRequire("1UAMB");
parcelRequire("eeecL");
parcelRequire("hzEKF");
parcelRequire("dKibH");
parcelRequire("1x89g");
parcelRequire("eeWuT");
parcelRequire("4YY1H");
parcelRequire("96KyE");
parcelRequire("e73pV");
if (typeof $64c3d6c378f6df2f$var$BigInteger === "undefined") var $64c3d6c378f6df2f$var$BigInteger = $2xc86.jsbn.BigInteger;
// shortcut for asn.1 API
var $64c3d6c378f6df2f$var$asn1 = $2xc86.asn1;
/* Password-based encryption implementation. */ var $64c3d6c378f6df2f$var$pki = $2xc86.pki = $2xc86.pki || {};
module.exports = $64c3d6c378f6df2f$var$pki.pbe = $2xc86.pbe = $2xc86.pbe || {};
var $64c3d6c378f6df2f$var$oids = $64c3d6c378f6df2f$var$pki.oids;
// validator for an EncryptedPrivateKeyInfo structure
// Note: Currently only works w/algorithm params
var $64c3d6c378f6df2f$var$encryptedPrivateKeyValidator = {
    name: "EncryptedPrivateKeyInfo",
    tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
    type: $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "EncryptedPrivateKeyInfo.encryptionAlgorithm",
            tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
            type: $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
                    type: $64c3d6c378f6df2f$var$asn1.Type.OID,
                    constructed: false,
                    capture: "encryptionOid"
                },
                {
                    name: "AlgorithmIdentifier.parameters",
                    tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
                    type: $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    captureAsn1: "encryptionParams"
                }
            ]
        },
        {
            // encryptedData
            name: "EncryptedPrivateKeyInfo.encryptedData",
            tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
            type: $64c3d6c378f6df2f$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "encryptedData"
        }
    ]
};
// validator for a PBES2Algorithms structure
// Note: Currently only works w/PBKDF2 + AES encryption schemes
var $64c3d6c378f6df2f$var$PBES2AlgorithmsValidator = {
    name: "PBES2Algorithms",
    tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
    type: $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "PBES2Algorithms.keyDerivationFunc",
            tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
            type: $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "PBES2Algorithms.keyDerivationFunc.oid",
                    tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
                    type: $64c3d6c378f6df2f$var$asn1.Type.OID,
                    constructed: false,
                    capture: "kdfOid"
                },
                {
                    name: "PBES2Algorithms.params",
                    tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
                    type: $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE,
                    constructed: true,
                    value: [
                        {
                            name: "PBES2Algorithms.params.salt",
                            tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
                            type: $64c3d6c378f6df2f$var$asn1.Type.OCTETSTRING,
                            constructed: false,
                            capture: "kdfSalt"
                        },
                        {
                            name: "PBES2Algorithms.params.iterationCount",
                            tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
                            type: $64c3d6c378f6df2f$var$asn1.Type.INTEGER,
                            constructed: false,
                            capture: "kdfIterationCount"
                        },
                        {
                            name: "PBES2Algorithms.params.keyLength",
                            tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
                            type: $64c3d6c378f6df2f$var$asn1.Type.INTEGER,
                            constructed: false,
                            optional: true,
                            capture: "keyLength"
                        },
                        {
                            // prf
                            name: "PBES2Algorithms.params.prf",
                            tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
                            type: $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE,
                            constructed: true,
                            optional: true,
                            value: [
                                {
                                    name: "PBES2Algorithms.params.prf.algorithm",
                                    tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
                                    type: $64c3d6c378f6df2f$var$asn1.Type.OID,
                                    constructed: false,
                                    capture: "prfOid"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            name: "PBES2Algorithms.encryptionScheme",
            tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
            type: $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "PBES2Algorithms.encryptionScheme.oid",
                    tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
                    type: $64c3d6c378f6df2f$var$asn1.Type.OID,
                    constructed: false,
                    capture: "encOid"
                },
                {
                    name: "PBES2Algorithms.encryptionScheme.iv",
                    tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
                    type: $64c3d6c378f6df2f$var$asn1.Type.OCTETSTRING,
                    constructed: false,
                    capture: "encIv"
                }
            ]
        }
    ]
};
var $64c3d6c378f6df2f$var$pkcs12PbeParamsValidator = {
    name: "pkcs-12PbeParams",
    tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
    type: $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            name: "pkcs-12PbeParams.salt",
            tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
            type: $64c3d6c378f6df2f$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "salt"
        },
        {
            name: "pkcs-12PbeParams.iterations",
            tagClass: $64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL,
            type: $64c3d6c378f6df2f$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "iterations"
        }
    ]
};
/**
 * Encrypts a ASN.1 PrivateKeyInfo object, producing an EncryptedPrivateKeyInfo.
 *
 * PBES2Algorithms ALGORITHM-IDENTIFIER ::=
 *   { {PBES2-params IDENTIFIED BY id-PBES2}, ...}
 *
 * id-PBES2 OBJECT IDENTIFIER ::= {pkcs-5 13}
 *
 * PBES2-params ::= SEQUENCE {
 *   keyDerivationFunc AlgorithmIdentifier {{PBES2-KDFs}},
 *   encryptionScheme AlgorithmIdentifier {{PBES2-Encs}}
 * }
 *
 * PBES2-KDFs ALGORITHM-IDENTIFIER ::=
 *   { {PBKDF2-params IDENTIFIED BY id-PBKDF2}, ... }
 *
 * PBES2-Encs ALGORITHM-IDENTIFIER ::= { ... }
 *
 * PBKDF2-params ::= SEQUENCE {
 *   salt CHOICE {
 *     specified OCTET STRING,
 *     otherSource AlgorithmIdentifier {{PBKDF2-SaltSources}}
 *   },
 *   iterationCount INTEGER (1..MAX),
 *   keyLength INTEGER (1..MAX) OPTIONAL,
 *   prf AlgorithmIdentifier {{PBKDF2-PRFs}} DEFAULT algid-hmacWithSHA1
 * }
 *
 * @param obj the ASN.1 PrivateKeyInfo object.
 * @param password the password to encrypt with.
 * @param options:
 *          algorithm the encryption algorithm to use
 *            ('aes128', 'aes192', 'aes256', '3des'), defaults to 'aes128'.
 *          count the iteration count to use.
 *          saltSize the salt size to use.
 *          prfAlgorithm the PRF message digest algorithm to use
 *            ('sha1', 'sha224', 'sha256', 'sha384', 'sha512')
 *
 * @return the ASN.1 EncryptedPrivateKeyInfo.
 */ $64c3d6c378f6df2f$var$pki.encryptPrivateKeyInfo = function(obj, password, options) {
    // set default options
    options = options || {};
    options.saltSize = options.saltSize || 8;
    options.count = options.count || 2048;
    options.algorithm = options.algorithm || "aes128";
    options.prfAlgorithm = options.prfAlgorithm || "sha1";
    // generate PBE params
    var salt = $2xc86.random.getBytesSync(options.saltSize);
    var count = options.count;
    var countBytes = $64c3d6c378f6df2f$var$asn1.integerToDer(count);
    var dkLen;
    var encryptionAlgorithm;
    var encryptedData;
    if (options.algorithm.indexOf("aes") === 0 || options.algorithm === "des") {
        // do PBES2
        var ivLen, encOid, cipherFn;
        switch(options.algorithm){
            case "aes128":
                dkLen = 16;
                ivLen = 16;
                encOid = $64c3d6c378f6df2f$var$oids["aes128-CBC"];
                cipherFn = $2xc86.aes.createEncryptionCipher;
                break;
            case "aes192":
                dkLen = 24;
                ivLen = 16;
                encOid = $64c3d6c378f6df2f$var$oids["aes192-CBC"];
                cipherFn = $2xc86.aes.createEncryptionCipher;
                break;
            case "aes256":
                dkLen = 32;
                ivLen = 16;
                encOid = $64c3d6c378f6df2f$var$oids["aes256-CBC"];
                cipherFn = $2xc86.aes.createEncryptionCipher;
                break;
            case "des":
                dkLen = 8;
                ivLen = 8;
                encOid = $64c3d6c378f6df2f$var$oids["desCBC"];
                cipherFn = $2xc86.des.createEncryptionCipher;
                break;
            default:
                var error = new Error("Cannot encrypt private key. Unknown encryption algorithm.");
                error.algorithm = options.algorithm;
                throw error;
        }
        // get PRF message digest
        var prfAlgorithm = "hmacWith" + options.prfAlgorithm.toUpperCase();
        var md = $64c3d6c378f6df2f$var$prfAlgorithmToMessageDigest(prfAlgorithm);
        // encrypt private key using pbe SHA-1 and AES/DES
        var dk = $2xc86.pkcs5.pbkdf2(password, salt, count, dkLen, md);
        var iv = $2xc86.random.getBytesSync(ivLen);
        var cipher = cipherFn(dk);
        cipher.start(iv);
        cipher.update($64c3d6c378f6df2f$var$asn1.toDer(obj));
        cipher.finish();
        encryptedData = cipher.output.getBytes();
        // get PBKDF2-params
        var params = $64c3d6c378f6df2f$var$createPbkdf2Params(salt, countBytes, dkLen, prfAlgorithm);
        encryptionAlgorithm = $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE, true, [
            $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.OID, false, $64c3d6c378f6df2f$var$asn1.oidToDer($64c3d6c378f6df2f$var$oids["pkcs5PBES2"]).getBytes()),
            $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE, true, [
                // keyDerivationFunc
                $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE, true, [
                    $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.OID, false, $64c3d6c378f6df2f$var$asn1.oidToDer($64c3d6c378f6df2f$var$oids["pkcs5PBKDF2"]).getBytes()),
                    // PBKDF2-params
                    params
                ]),
                // encryptionScheme
                $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE, true, [
                    $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.OID, false, $64c3d6c378f6df2f$var$asn1.oidToDer(encOid).getBytes()),
                    // iv
                    $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.OCTETSTRING, false, iv)
                ])
            ])
        ]);
    } else if (options.algorithm === "3des") {
        // Do PKCS12 PBE
        dkLen = 24;
        var saltBytes = new $2xc86.util.ByteBuffer(salt);
        var dk = $64c3d6c378f6df2f$var$pki.pbe.generatePkcs12Key(password, saltBytes, 1, count, dkLen);
        var iv = $64c3d6c378f6df2f$var$pki.pbe.generatePkcs12Key(password, saltBytes, 2, count, dkLen);
        var cipher = $2xc86.des.createEncryptionCipher(dk);
        cipher.start(iv);
        cipher.update($64c3d6c378f6df2f$var$asn1.toDer(obj));
        cipher.finish();
        encryptedData = cipher.output.getBytes();
        encryptionAlgorithm = $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE, true, [
            $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.OID, false, $64c3d6c378f6df2f$var$asn1.oidToDer($64c3d6c378f6df2f$var$oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]).getBytes()),
            // pkcs-12PbeParams
            $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE, true, [
                // salt
                $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.OCTETSTRING, false, salt),
                // iteration count
                $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.INTEGER, false, countBytes.getBytes())
            ])
        ]);
    } else {
        var error = new Error("Cannot encrypt private key. Unknown encryption algorithm.");
        error.algorithm = options.algorithm;
        throw error;
    }
    // EncryptedPrivateKeyInfo
    var rval = $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE, true, [
        // encryptionAlgorithm
        encryptionAlgorithm,
        // encryptedData
        $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.OCTETSTRING, false, encryptedData)
    ]);
    return rval;
};
/**
 * Decrypts a ASN.1 PrivateKeyInfo object.
 *
 * @param obj the ASN.1 EncryptedPrivateKeyInfo object.
 * @param password the password to decrypt with.
 *
 * @return the ASN.1 PrivateKeyInfo on success, null on failure.
 */ $64c3d6c378f6df2f$var$pki.decryptPrivateKeyInfo = function(obj, password) {
    var rval = null;
    // get PBE params
    var capture = {};
    var errors = [];
    if (!$64c3d6c378f6df2f$var$asn1.validate(obj, $64c3d6c378f6df2f$var$encryptedPrivateKeyValidator, capture, errors)) {
        var error = new Error("Cannot read encrypted private key. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        error.errors = errors;
        throw error;
    }
    // get cipher
    var oid = $64c3d6c378f6df2f$var$asn1.derToOid(capture.encryptionOid);
    var cipher = $64c3d6c378f6df2f$var$pki.pbe.getCipher(oid, capture.encryptionParams, password);
    // get encrypted data
    var encrypted = $2xc86.util.createBuffer(capture.encryptedData);
    cipher.update(encrypted);
    if (cipher.finish()) rval = $64c3d6c378f6df2f$var$asn1.fromDer(cipher.output);
    return rval;
};
/**
 * Converts a EncryptedPrivateKeyInfo to PEM format.
 *
 * @param epki the EncryptedPrivateKeyInfo.
 * @param maxline the maximum characters per line, defaults to 64.
 *
 * @return the PEM-formatted encrypted private key.
 */ $64c3d6c378f6df2f$var$pki.encryptedPrivateKeyToPem = function(epki, maxline) {
    // convert to DER, then PEM-encode
    var msg = {
        type: "ENCRYPTED PRIVATE KEY",
        body: $64c3d6c378f6df2f$var$asn1.toDer(epki).getBytes()
    };
    return $2xc86.pem.encode(msg, {
        maxline: maxline
    });
};
/**
 * Converts a PEM-encoded EncryptedPrivateKeyInfo to ASN.1 format. Decryption
 * is not performed.
 *
 * @param pem the EncryptedPrivateKeyInfo in PEM-format.
 *
 * @return the ASN.1 EncryptedPrivateKeyInfo.
 */ $64c3d6c378f6df2f$var$pki.encryptedPrivateKeyFromPem = function(pem) {
    var msg = $2xc86.pem.decode(pem)[0];
    if (msg.type !== "ENCRYPTED PRIVATE KEY") {
        var error = new Error('Could not convert encrypted private key from PEM; PEM header type is "ENCRYPTED PRIVATE KEY".');
        error.headerType = msg.type;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") throw new Error("Could not convert encrypted private key from PEM; PEM is encrypted.");
    // convert DER to ASN.1 object
    return $64c3d6c378f6df2f$var$asn1.fromDer(msg.body);
};
/**
 * Encrypts an RSA private key. By default, the key will be wrapped in
 * a PrivateKeyInfo and encrypted to produce a PKCS#8 EncryptedPrivateKeyInfo.
 * This is the standard, preferred way to encrypt a private key.
 *
 * To produce a non-standard PEM-encrypted private key that uses encapsulated
 * headers to indicate the encryption algorithm (old-style non-PKCS#8 OpenSSL
 * private key encryption), set the 'legacy' option to true. Note: Using this
 * option will cause the iteration count to be forced to 1.
 *
 * Note: The 'des' algorithm is supported, but it is not considered to be
 * secure because it only uses a single 56-bit key. If possible, it is highly
 * recommended that a different algorithm be used.
 *
 * @param rsaKey the RSA key to encrypt.
 * @param password the password to use.
 * @param options:
 *          algorithm: the encryption algorithm to use
 *            ('aes128', 'aes192', 'aes256', '3des', 'des').
 *          count: the iteration count to use.
 *          saltSize: the salt size to use.
 *          legacy: output an old non-PKCS#8 PEM-encrypted+encapsulated
 *            headers (DEK-Info) private key.
 *
 * @return the PEM-encoded ASN.1 EncryptedPrivateKeyInfo.
 */ $64c3d6c378f6df2f$var$pki.encryptRsaPrivateKey = function(rsaKey, password, options) {
    // standard PKCS#8
    options = options || {};
    if (!options.legacy) {
        // encrypt PrivateKeyInfo
        var rval = $64c3d6c378f6df2f$var$pki.wrapRsaPrivateKey($64c3d6c378f6df2f$var$pki.privateKeyToAsn1(rsaKey));
        rval = $64c3d6c378f6df2f$var$pki.encryptPrivateKeyInfo(rval, password, options);
        return $64c3d6c378f6df2f$var$pki.encryptedPrivateKeyToPem(rval);
    }
    // legacy non-PKCS#8
    var algorithm;
    var iv;
    var dkLen;
    var cipherFn;
    switch(options.algorithm){
        case "aes128":
            algorithm = "AES-128-CBC";
            dkLen = 16;
            iv = $2xc86.random.getBytesSync(16);
            cipherFn = $2xc86.aes.createEncryptionCipher;
            break;
        case "aes192":
            algorithm = "AES-192-CBC";
            dkLen = 24;
            iv = $2xc86.random.getBytesSync(16);
            cipherFn = $2xc86.aes.createEncryptionCipher;
            break;
        case "aes256":
            algorithm = "AES-256-CBC";
            dkLen = 32;
            iv = $2xc86.random.getBytesSync(16);
            cipherFn = $2xc86.aes.createEncryptionCipher;
            break;
        case "3des":
            algorithm = "DES-EDE3-CBC";
            dkLen = 24;
            iv = $2xc86.random.getBytesSync(8);
            cipherFn = $2xc86.des.createEncryptionCipher;
            break;
        case "des":
            algorithm = "DES-CBC";
            dkLen = 8;
            iv = $2xc86.random.getBytesSync(8);
            cipherFn = $2xc86.des.createEncryptionCipher;
            break;
        default:
            var error = new Error('Could not encrypt RSA private key; unsupported encryption algorithm "' + options.algorithm + '".');
            error.algorithm = options.algorithm;
            throw error;
    }
    // encrypt private key using OpenSSL legacy key derivation
    var dk = $2xc86.pbe.opensslDeriveBytes(password, iv.substr(0, 8), dkLen);
    var cipher = cipherFn(dk);
    cipher.start(iv);
    cipher.update($64c3d6c378f6df2f$var$asn1.toDer($64c3d6c378f6df2f$var$pki.privateKeyToAsn1(rsaKey)));
    cipher.finish();
    var msg = {
        type: "RSA PRIVATE KEY",
        procType: {
            version: "4",
            type: "ENCRYPTED"
        },
        dekInfo: {
            algorithm: algorithm,
            parameters: $2xc86.util.bytesToHex(iv).toUpperCase()
        },
        body: cipher.output.getBytes()
    };
    return $2xc86.pem.encode(msg);
};
/**
 * Decrypts an RSA private key.
 *
 * @param pem the PEM-formatted EncryptedPrivateKeyInfo to decrypt.
 * @param password the password to use.
 *
 * @return the RSA key on success, null on failure.
 */ $64c3d6c378f6df2f$var$pki.decryptRsaPrivateKey = function(pem, password) {
    var rval = null;
    var msg = $2xc86.pem.decode(pem)[0];
    if (msg.type !== "ENCRYPTED PRIVATE KEY" && msg.type !== "PRIVATE KEY" && msg.type !== "RSA PRIVATE KEY") {
        var error = new Error('Could not convert private key from PEM; PEM header type is not "ENCRYPTED PRIVATE KEY", "PRIVATE KEY", or "RSA PRIVATE KEY".');
        error.headerType = error;
        throw error;
    }
    if (msg.procType && msg.procType.type === "ENCRYPTED") {
        var dkLen;
        var cipherFn;
        switch(msg.dekInfo.algorithm){
            case "DES-CBC":
                dkLen = 8;
                cipherFn = $2xc86.des.createDecryptionCipher;
                break;
            case "DES-EDE3-CBC":
                dkLen = 24;
                cipherFn = $2xc86.des.createDecryptionCipher;
                break;
            case "AES-128-CBC":
                dkLen = 16;
                cipherFn = $2xc86.aes.createDecryptionCipher;
                break;
            case "AES-192-CBC":
                dkLen = 24;
                cipherFn = $2xc86.aes.createDecryptionCipher;
                break;
            case "AES-256-CBC":
                dkLen = 32;
                cipherFn = $2xc86.aes.createDecryptionCipher;
                break;
            case "RC2-40-CBC":
                dkLen = 5;
                cipherFn = function(key) {
                    return $2xc86.rc2.createDecryptionCipher(key, 40);
                };
                break;
            case "RC2-64-CBC":
                dkLen = 8;
                cipherFn = function(key) {
                    return $2xc86.rc2.createDecryptionCipher(key, 64);
                };
                break;
            case "RC2-128-CBC":
                dkLen = 16;
                cipherFn = function(key) {
                    return $2xc86.rc2.createDecryptionCipher(key, 128);
                };
                break;
            default:
                var error = new Error('Could not decrypt private key; unsupported encryption algorithm "' + msg.dekInfo.algorithm + '".');
                error.algorithm = msg.dekInfo.algorithm;
                throw error;
        }
        // use OpenSSL legacy key derivation
        var iv = $2xc86.util.hexToBytes(msg.dekInfo.parameters);
        var dk = $2xc86.pbe.opensslDeriveBytes(password, iv.substr(0, 8), dkLen);
        var cipher = cipherFn(dk);
        cipher.start(iv);
        cipher.update($2xc86.util.createBuffer(msg.body));
        if (cipher.finish()) rval = cipher.output.getBytes();
        else return rval;
    } else rval = msg.body;
    if (msg.type === "ENCRYPTED PRIVATE KEY") rval = $64c3d6c378f6df2f$var$pki.decryptPrivateKeyInfo($64c3d6c378f6df2f$var$asn1.fromDer(rval), password);
    else // decryption already performed above
    rval = $64c3d6c378f6df2f$var$asn1.fromDer(rval);
    if (rval !== null) rval = $64c3d6c378f6df2f$var$pki.privateKeyFromAsn1(rval);
    return rval;
};
/**
 * Derives a PKCS#12 key.
 *
 * @param password the password to derive the key material from, null or
 *          undefined for none.
 * @param salt the salt, as a ByteBuffer, to use.
 * @param id the PKCS#12 ID byte (1 = key material, 2 = IV, 3 = MAC).
 * @param iter the iteration count.
 * @param n the number of bytes to derive from the password.
 * @param md the message digest to use, defaults to SHA-1.
 *
 * @return a ByteBuffer with the bytes derived from the password.
 */ $64c3d6c378f6df2f$var$pki.pbe.generatePkcs12Key = function(password, salt, id, iter, n, md) {
    var j, l;
    if (typeof md === "undefined" || md === null) {
        if (!("sha1" in $2xc86.md)) throw new Error('"sha1" hash algorithm unavailable.');
        md = $2xc86.md.sha1.create();
    }
    var u = md.digestLength;
    var v = md.blockLength;
    var result = new $2xc86.util.ByteBuffer();
    /* Convert password to Unicode byte buffer + trailing 0-byte. */ var passBuf = new $2xc86.util.ByteBuffer();
    if (password !== null && password !== undefined) {
        for(l = 0; l < password.length; l++)passBuf.putInt16(password.charCodeAt(l));
        passBuf.putInt16(0);
    }
    /* Length of salt and password in BYTES. */ var p = passBuf.length();
    var s = salt.length();
    /* 1. Construct a string, D (the "diversifier"), by concatenating
        v copies of ID. */ var D = new $2xc86.util.ByteBuffer();
    D.fillWithByte(id, v);
    /* 2. Concatenate copies of the salt together to create a string S of length
        v * ceil(s / v) bytes (the final copy of the salt may be trunacted
        to create S).
        Note that if the salt is the empty string, then so is S. */ var Slen = v * Math.ceil(s / v);
    var S = new $2xc86.util.ByteBuffer();
    for(l = 0; l < Slen; l++)S.putByte(salt.at(l % s));
    /* 3. Concatenate copies of the password together to create a string P of
        length v * ceil(p / v) bytes (the final copy of the password may be
        truncated to create P).
        Note that if the password is the empty string, then so is P. */ var Plen = v * Math.ceil(p / v);
    var P = new $2xc86.util.ByteBuffer();
    for(l = 0; l < Plen; l++)P.putByte(passBuf.at(l % p));
    /* 4. Set I=S||P to be the concatenation of S and P. */ var I = S;
    I.putBuffer(P);
    /* 5. Set c=ceil(n / u). */ var c = Math.ceil(n / u);
    /* 6. For i=1, 2, ..., c, do the following: */ for(var i = 1; i <= c; i++){
        /* a) Set Ai=H^r(D||I). (l.e. the rth hash of D||I, H(H(H(...H(D||I)))) */ var buf = new $2xc86.util.ByteBuffer();
        buf.putBytes(D.bytes());
        buf.putBytes(I.bytes());
        for(var round = 0; round < iter; round++){
            md.start();
            md.update(buf.getBytes());
            buf = md.digest();
        }
        /* b) Concatenate copies of Ai to create a string B of length v bytes (the
          final copy of Ai may be truncated to create B). */ var B = new $2xc86.util.ByteBuffer();
        for(l = 0; l < v; l++)B.putByte(buf.at(l % u));
        /* c) Treating I as a concatenation I0, I1, ..., Ik-1 of v-byte blocks,
          where k=ceil(s / v) + ceil(p / v), modify I by setting
          Ij=(Ij+B+1) mod 2v for each j.  */ var k = Math.ceil(s / v) + Math.ceil(p / v);
        var Inew = new $2xc86.util.ByteBuffer();
        for(j = 0; j < k; j++){
            var chunk = new $2xc86.util.ByteBuffer(I.getBytes(v));
            var x = 0x1ff;
            for(l = B.length() - 1; l >= 0; l--){
                x = x >> 8;
                x += B.at(l) + chunk.at(l);
                chunk.setAt(l, x & 0xff);
            }
            Inew.putBuffer(chunk);
        }
        I = Inew;
        /* Add Ai to A. */ result.putBuffer(buf);
    }
    result.truncate(result.length() - n);
    return result;
};
/**
 * Get new Forge cipher object instance.
 *
 * @param oid the OID (in string notation).
 * @param params the ASN.1 params object.
 * @param password the password to decrypt with.
 *
 * @return new cipher object instance.
 */ $64c3d6c378f6df2f$var$pki.pbe.getCipher = function(oid, params, password) {
    switch(oid){
        case $64c3d6c378f6df2f$var$pki.oids["pkcs5PBES2"]:
            return $64c3d6c378f6df2f$var$pki.pbe.getCipherForPBES2(oid, params, password);
        case $64c3d6c378f6df2f$var$pki.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
        case $64c3d6c378f6df2f$var$pki.oids["pbewithSHAAnd40BitRC2-CBC"]:
            return $64c3d6c378f6df2f$var$pki.pbe.getCipherForPKCS12PBE(oid, params, password);
        default:
            var error = new Error("Cannot read encrypted PBE data block. Unsupported OID.");
            error.oid = oid;
            error.supportedOids = [
                "pkcs5PBES2",
                "pbeWithSHAAnd3-KeyTripleDES-CBC",
                "pbewithSHAAnd40BitRC2-CBC"
            ];
            throw error;
    }
};
/**
 * Get new Forge cipher object instance according to PBES2 params block.
 *
 * The returned cipher instance is already started using the IV
 * from PBES2 parameter block.
 *
 * @param oid the PKCS#5 PBKDF2 OID (in string notation).
 * @param params the ASN.1 PBES2-params object.
 * @param password the password to decrypt with.
 *
 * @return new cipher object instance.
 */ $64c3d6c378f6df2f$var$pki.pbe.getCipherForPBES2 = function(oid, params, password) {
    // get PBE params
    var capture = {};
    var errors = [];
    if (!$64c3d6c378f6df2f$var$asn1.validate(params, $64c3d6c378f6df2f$var$PBES2AlgorithmsValidator, capture, errors)) {
        var error = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        error.errors = errors;
        throw error;
    }
    // check oids
    oid = $64c3d6c378f6df2f$var$asn1.derToOid(capture.kdfOid);
    if (oid !== $64c3d6c378f6df2f$var$pki.oids["pkcs5PBKDF2"]) {
        var error = new Error("Cannot read encrypted private key. Unsupported key derivation function OID.");
        error.oid = oid;
        error.supportedOids = [
            "pkcs5PBKDF2"
        ];
        throw error;
    }
    oid = $64c3d6c378f6df2f$var$asn1.derToOid(capture.encOid);
    if (oid !== $64c3d6c378f6df2f$var$pki.oids["aes128-CBC"] && oid !== $64c3d6c378f6df2f$var$pki.oids["aes192-CBC"] && oid !== $64c3d6c378f6df2f$var$pki.oids["aes256-CBC"] && oid !== $64c3d6c378f6df2f$var$pki.oids["des-EDE3-CBC"] && oid !== $64c3d6c378f6df2f$var$pki.oids["desCBC"]) {
        var error = new Error("Cannot read encrypted private key. Unsupported encryption scheme OID.");
        error.oid = oid;
        error.supportedOids = [
            "aes128-CBC",
            "aes192-CBC",
            "aes256-CBC",
            "des-EDE3-CBC",
            "desCBC"
        ];
        throw error;
    }
    // set PBE params
    var salt = capture.kdfSalt;
    var count = $2xc86.util.createBuffer(capture.kdfIterationCount);
    count = count.getInt(count.length() << 3);
    var dkLen;
    var cipherFn;
    switch($64c3d6c378f6df2f$var$pki.oids[oid]){
        case "aes128-CBC":
            dkLen = 16;
            cipherFn = $2xc86.aes.createDecryptionCipher;
            break;
        case "aes192-CBC":
            dkLen = 24;
            cipherFn = $2xc86.aes.createDecryptionCipher;
            break;
        case "aes256-CBC":
            dkLen = 32;
            cipherFn = $2xc86.aes.createDecryptionCipher;
            break;
        case "des-EDE3-CBC":
            dkLen = 24;
            cipherFn = $2xc86.des.createDecryptionCipher;
            break;
        case "desCBC":
            dkLen = 8;
            cipherFn = $2xc86.des.createDecryptionCipher;
            break;
    }
    // get PRF message digest
    var md = $64c3d6c378f6df2f$var$prfOidToMessageDigest(capture.prfOid);
    // decrypt private key using pbe with chosen PRF and AES/DES
    var dk = $2xc86.pkcs5.pbkdf2(password, salt, count, dkLen, md);
    var iv = capture.encIv;
    var cipher = cipherFn(dk);
    cipher.start(iv);
    return cipher;
};
/**
 * Get new Forge cipher object instance for PKCS#12 PBE.
 *
 * The returned cipher instance is already started using the key & IV
 * derived from the provided password and PKCS#12 PBE salt.
 *
 * @param oid The PKCS#12 PBE OID (in string notation).
 * @param params The ASN.1 PKCS#12 PBE-params object.
 * @param password The password to decrypt with.
 *
 * @return the new cipher object instance.
 */ $64c3d6c378f6df2f$var$pki.pbe.getCipherForPKCS12PBE = function(oid, params, password) {
    // get PBE params
    var capture = {};
    var errors = [];
    if (!$64c3d6c378f6df2f$var$asn1.validate(params, $64c3d6c378f6df2f$var$pkcs12PbeParamsValidator, capture, errors)) {
        var error = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
        error.errors = errors;
        throw error;
    }
    var salt = $2xc86.util.createBuffer(capture.salt);
    var count = $2xc86.util.createBuffer(capture.iterations);
    count = count.getInt(count.length() << 3);
    var dkLen, dIvLen, cipherFn;
    switch(oid){
        case $64c3d6c378f6df2f$var$pki.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
            dkLen = 24;
            dIvLen = 8;
            cipherFn = $2xc86.des.startDecrypting;
            break;
        case $64c3d6c378f6df2f$var$pki.oids["pbewithSHAAnd40BitRC2-CBC"]:
            dkLen = 5;
            dIvLen = 8;
            cipherFn = function(key, iv) {
                var cipher = $2xc86.rc2.createDecryptionCipher(key, 40);
                cipher.start(iv, null);
                return cipher;
            };
            break;
        default:
            var error = new Error("Cannot read PKCS #12 PBE data block. Unsupported OID.");
            error.oid = oid;
            throw error;
    }
    // get PRF message digest
    var md = $64c3d6c378f6df2f$var$prfOidToMessageDigest(capture.prfOid);
    var key = $64c3d6c378f6df2f$var$pki.pbe.generatePkcs12Key(password, salt, 1, count, dkLen, md);
    md.start();
    var iv = $64c3d6c378f6df2f$var$pki.pbe.generatePkcs12Key(password, salt, 2, count, dIvLen, md);
    return cipherFn(key, iv);
};
/**
 * OpenSSL's legacy key derivation function.
 *
 * See: http://www.openssl.org/docs/crypto/EVP_BytesToKey.html
 *
 * @param password the password to derive the key from.
 * @param salt the salt to use, null for none.
 * @param dkLen the number of bytes needed for the derived key.
 * @param [options] the options to use:
 *          [md] an optional message digest object to use.
 */ $64c3d6c378f6df2f$var$pki.pbe.opensslDeriveBytes = function(password, salt, dkLen, md) {
    if (typeof md === "undefined" || md === null) {
        if (!("md5" in $2xc86.md)) throw new Error('"md5" hash algorithm unavailable.');
        md = $2xc86.md.md5.create();
    }
    if (salt === null) salt = "";
    var digests = [
        $64c3d6c378f6df2f$var$hash(md, password + salt)
    ];
    for(var length = 16, i = 1; length < dkLen; ++i, length += 16)digests.push($64c3d6c378f6df2f$var$hash(md, digests[i - 1] + password + salt));
    return digests.join("").substr(0, dkLen);
};
function $64c3d6c378f6df2f$var$hash(md, bytes) {
    return md.start().update(bytes).digest().getBytes();
}
function $64c3d6c378f6df2f$var$prfOidToMessageDigest(prfOid) {
    // get PRF algorithm, default to SHA-1
    var prfAlgorithm;
    if (!prfOid) prfAlgorithm = "hmacWithSHA1";
    else {
        prfAlgorithm = $64c3d6c378f6df2f$var$pki.oids[$64c3d6c378f6df2f$var$asn1.derToOid(prfOid)];
        if (!prfAlgorithm) {
            var error = new Error("Unsupported PRF OID.");
            error.oid = prfOid;
            error.supported = [
                "hmacWithSHA1",
                "hmacWithSHA224",
                "hmacWithSHA256",
                "hmacWithSHA384",
                "hmacWithSHA512"
            ];
            throw error;
        }
    }
    return $64c3d6c378f6df2f$var$prfAlgorithmToMessageDigest(prfAlgorithm);
}
function $64c3d6c378f6df2f$var$prfAlgorithmToMessageDigest(prfAlgorithm) {
    var factory = $2xc86.md;
    switch(prfAlgorithm){
        case "hmacWithSHA224":
            factory = $2xc86.md.sha512;
        case "hmacWithSHA1":
        case "hmacWithSHA256":
        case "hmacWithSHA384":
        case "hmacWithSHA512":
            prfAlgorithm = prfAlgorithm.substr(8).toLowerCase();
            break;
        default:
            var error = new Error("Unsupported PRF algorithm.");
            error.algorithm = prfAlgorithm;
            error.supported = [
                "hmacWithSHA1",
                "hmacWithSHA224",
                "hmacWithSHA256",
                "hmacWithSHA384",
                "hmacWithSHA512"
            ];
            throw error;
    }
    if (!factory || !(prfAlgorithm in factory)) throw new Error("Unknown hash algorithm: " + prfAlgorithm);
    return factory[prfAlgorithm].create();
}
function $64c3d6c378f6df2f$var$createPbkdf2Params(salt, countBytes, dkLen, prfAlgorithm) {
    var params = $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE, true, [
        // salt
        $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.OCTETSTRING, false, salt),
        // iteration count
        $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.INTEGER, false, countBytes.getBytes())
    ]);
    // when PRF algorithm is not SHA-1 default, add key length and PRF algorithm
    if (prfAlgorithm !== "hmacWithSHA1") params.value.push(// key length
    $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.INTEGER, false, $2xc86.util.hexToBytes(dkLen.toString(16))), // AlgorithmIdentifier
    $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.SEQUENCE, true, [
        // algorithm
        $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.OID, false, $64c3d6c378f6df2f$var$asn1.oidToDer($64c3d6c378f6df2f$var$pki.oids[prfAlgorithm]).getBytes()),
        // parameters (null)
        $64c3d6c378f6df2f$var$asn1.create($64c3d6c378f6df2f$var$asn1.Class.UNIVERSAL, $64c3d6c378f6df2f$var$asn1.Type.NULL, false, "")
    ]));
    return params;
}

});
parcelRequire.register("dKibH", function(module, exports) {
/**
 * Password-Based Key-Derivation Function #2 implementation.
 *
 * See RFC 2898 for details.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2013 Digital Bazaar, Inc.
 */ 
var $7jzxY = parcelRequire("7jzxY");
var $02951fb57f9ab77e$require$Buffer = $7jzxY.Buffer;

var $2xc86 = parcelRequire("2xc86");
parcelRequire("kbGyS");
parcelRequire("eeecL");
parcelRequire("e73pV");
var $02951fb57f9ab77e$var$pkcs5 = $2xc86.pkcs5 = $2xc86.pkcs5 || {};
var $02951fb57f9ab77e$var$crypto;

if ($2xc86.util.isNodejs && !$2xc86.options.usePureJavaScript) $02951fb57f9ab77e$var$crypto = (parcelRequire("7jzxY"));
/**
 * Derives a key from a password.
 *
 * @param p the password as a binary-encoded string of bytes.
 * @param s the salt as a binary-encoded string of bytes.
 * @param c the iteration count, a positive integer.
 * @param dkLen the intended length, in bytes, of the derived key,
 *          (max: 2^32 - 1) * hash length of the PRF.
 * @param [md] the message digest (or algorithm identifier as a string) to use
 *          in the PRF, defaults to SHA-1.
 * @param [callback(err, key)] presence triggers asynchronous version, called
 *          once the operation completes.
 *
 * @return the derived key, as a binary-encoded string of bytes, for the
 *           synchronous version (if no callback is specified).
 */ module.exports = $2xc86.pbkdf2 = $02951fb57f9ab77e$var$pkcs5.pbkdf2 = function(p, s, c, dkLen, md, callback) {
    if (typeof md === "function") {
        callback = md;
        md = null;
    }
    // use native implementation if possible and not disabled, note that
    // some node versions only support SHA-1, others allow digest to be changed
    if ($2xc86.util.isNodejs && !$2xc86.options.usePureJavaScript && $02951fb57f9ab77e$var$crypto.pbkdf2 && (md === null || typeof md !== "object") && ($02951fb57f9ab77e$var$crypto.pbkdf2Sync.length > 4 || !md || md === "sha1")) {
        if (typeof md !== "string") // default prf to SHA-1
        md = "sha1";
        p = $02951fb57f9ab77e$require$Buffer.from(p, "binary");
        s = $02951fb57f9ab77e$require$Buffer.from(s, "binary");
        if (!callback) {
            if ($02951fb57f9ab77e$var$crypto.pbkdf2Sync.length === 4) return $02951fb57f9ab77e$var$crypto.pbkdf2Sync(p, s, c, dkLen).toString("binary");
            return $02951fb57f9ab77e$var$crypto.pbkdf2Sync(p, s, c, dkLen, md).toString("binary");
        }
        if ($02951fb57f9ab77e$var$crypto.pbkdf2Sync.length === 4) return $02951fb57f9ab77e$var$crypto.pbkdf2(p, s, c, dkLen, function(err, key) {
            if (err) return callback(err);
            callback(null, key.toString("binary"));
        });
        return $02951fb57f9ab77e$var$crypto.pbkdf2(p, s, c, dkLen, md, function(err, key) {
            if (err) return callback(err);
            callback(null, key.toString("binary"));
        });
    }
    if (typeof md === "undefined" || md === null) // default prf to SHA-1
    md = "sha1";
    if (typeof md === "string") {
        if (!(md in $2xc86.md.algorithms)) throw new Error("Unknown hash algorithm: " + md);
        md = $2xc86.md[md].create();
    }
    var hLen = md.digestLength;
    /* 1. If dkLen > (2^32 - 1) * hLen, output "derived key too long" and
    stop. */ if (dkLen > 0xFFFFFFFF * hLen) {
        var err = new Error("Derived key is too long.");
        if (callback) return callback(err);
        throw err;
    }
    /* 2. Let len be the number of hLen-octet blocks in the derived key,
    rounding up, and let r be the number of octets in the last
    block:

    len = CEIL(dkLen / hLen),
    r = dkLen - (len - 1) * hLen. */ var len = Math.ceil(dkLen / hLen);
    var r = dkLen - (len - 1) * hLen;
    /* 3. For each block of the derived key apply the function F defined
    below to the password P, the salt S, the iteration count c, and
    the block index to compute the block:

    T_1 = F(P, S, c, 1),
    T_2 = F(P, S, c, 2),
    ...
    T_len = F(P, S, c, len),

    where the function F is defined as the exclusive-or sum of the
    first c iterates of the underlying pseudorandom function PRF
    applied to the password P and the concatenation of the salt S
    and the block index i:

    F(P, S, c, i) = u_1 XOR u_2 XOR ... XOR u_c

    where

    u_1 = PRF(P, S || INT(i)),
    u_2 = PRF(P, u_1),
    ...
    u_c = PRF(P, u_{c-1}).

    Here, INT(i) is a four-octet encoding of the integer i, most
    significant octet first. */ var prf = $2xc86.hmac.create();
    prf.start(md, p);
    var dk = "";
    var xor, u_c, u_c1;
    // sync version
    if (!callback) {
        for(var i = 1; i <= len; ++i){
            // PRF(P, S || INT(i)) (first iteration)
            prf.start(null, null);
            prf.update(s);
            prf.update($2xc86.util.int32ToBytes(i));
            xor = u_c1 = prf.digest().getBytes();
            // PRF(P, u_{c-1}) (other iterations)
            for(var j = 2; j <= c; ++j){
                prf.start(null, null);
                prf.update(u_c1);
                u_c = prf.digest().getBytes();
                // F(p, s, c, i)
                xor = $2xc86.util.xorBytes(xor, u_c, hLen);
                u_c1 = u_c;
            }
            /* 4. Concatenate the blocks and extract the first dkLen octets to
        produce a derived key DK:

        DK = T_1 || T_2 ||  ...  || T_len<0..r-1> */ dk += i < len ? xor : xor.substr(0, r);
        }
        /* 5. Output the derived key DK. */ return dk;
    }
    // async version
    var i = 1, j;
    function outer() {
        if (i > len) // done
        return callback(null, dk);
        // PRF(P, S || INT(i)) (first iteration)
        prf.start(null, null);
        prf.update(s);
        prf.update($2xc86.util.int32ToBytes(i));
        xor = u_c1 = prf.digest().getBytes();
        // PRF(P, u_{c-1}) (other iterations)
        j = 2;
        inner();
    }
    function inner() {
        if (j <= c) {
            prf.start(null, null);
            prf.update(u_c1);
            u_c = prf.digest().getBytes();
            // F(p, s, c, i)
            xor = $2xc86.util.xorBytes(xor, u_c, hLen);
            u_c1 = u_c;
            ++j;
            return $2xc86.util.setImmediate(inner);
        }
        /* 4. Concatenate the blocks and extract the first dkLen octets to
      produce a derived key DK:

      DK = T_1 || T_2 ||  ...  || T_len<0..r-1> */ dk += i < len ? xor : xor.substr(0, r);
        ++i;
        outer();
    }
    outer();
};

});
parcelRequire.register("kbGyS", function(module, exports) {
/**
 * Hash-based Message Authentication Code implementation. Requires a message
 * digest object that can be obtained, for example, from forge.md.sha1 or
 * forge.md.md5.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2010-2012 Digital Bazaar, Inc. All rights reserved.
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("eeecL");
parcelRequire("e73pV");
/* HMAC API */ var $eb25d98b4104602e$var$hmac = module.exports = $2xc86.hmac = $2xc86.hmac || {};
/**
 * Creates an HMAC object that uses the given message digest object.
 *
 * @return an HMAC object.
 */ $eb25d98b4104602e$var$hmac.create = function() {
    // the hmac key to use
    var _key = null;
    // the message digest to use
    var _md = null;
    // the inner padding
    var _ipadding = null;
    // the outer padding
    var _opadding = null;
    // hmac context
    var ctx = {};
    /**
   * Starts or restarts the HMAC with the given key and message digest.
   *
   * @param md the message digest to use, null to reuse the previous one,
   *           a string to use builtin 'sha1', 'md5', 'sha256'.
   * @param key the key to use as a string, array of bytes, byte buffer,
   *           or null to reuse the previous key.
   */ ctx.start = function(md, key) {
        if (md !== null) {
            if (typeof md === "string") {
                // create builtin message digest
                md = md.toLowerCase();
                if (md in $2xc86.md.algorithms) _md = $2xc86.md.algorithms[md].create();
                else throw new Error('Unknown hash algorithm "' + md + '"');
            } else // store message digest
            _md = md;
        }
        if (key === null) // reuse previous key
        key = _key;
        else {
            if (typeof key === "string") // convert string into byte buffer
            key = $2xc86.util.createBuffer(key);
            else if ($2xc86.util.isArray(key)) {
                // convert byte array into byte buffer
                var tmp = key;
                key = $2xc86.util.createBuffer();
                for(var i = 0; i < tmp.length; ++i)key.putByte(tmp[i]);
            }
            // if key is longer than blocksize, hash it
            var keylen = key.length();
            if (keylen > _md.blockLength) {
                _md.start();
                _md.update(key.bytes());
                key = _md.digest();
            }
            // mix key into inner and outer padding
            // ipadding = [0x36 * blocksize] ^ key
            // opadding = [0x5C * blocksize] ^ key
            _ipadding = $2xc86.util.createBuffer();
            _opadding = $2xc86.util.createBuffer();
            keylen = key.length();
            for(var i = 0; i < keylen; ++i){
                var tmp = key.at(i);
                _ipadding.putByte(0x36 ^ tmp);
                _opadding.putByte(0x5C ^ tmp);
            }
            // if key is shorter than blocksize, add additional padding
            if (keylen < _md.blockLength) {
                var tmp = _md.blockLength - keylen;
                for(var i = 0; i < tmp; ++i){
                    _ipadding.putByte(0x36);
                    _opadding.putByte(0x5C);
                }
            }
            _key = key;
            _ipadding = _ipadding.bytes();
            _opadding = _opadding.bytes();
        }
        // digest is done like so: hash(opadding | hash(ipadding | message))
        // prepare to do inner hash
        // hash(ipadding | message)
        _md.start();
        _md.update(_ipadding);
    };
    /**
   * Updates the HMAC with the given message bytes.
   *
   * @param bytes the bytes to update with.
   */ ctx.update = function(bytes) {
        _md.update(bytes);
    };
    /**
   * Produces the Message Authentication Code (MAC).
   *
   * @return a byte buffer containing the digest value.
   */ ctx.getMac = function() {
        // digest is done like so: hash(opadding | hash(ipadding | message))
        // here we do the outer hashing
        var inner = _md.digest().bytes();
        _md.start();
        _md.update(_opadding);
        _md.update(inner);
        return _md.digest();
    };
    // alias for getMac
    ctx.digest = ctx.getMac;
    return ctx;
};

});


parcelRequire.register("4YY1H", function(module, exports) {
/**
 * RC2 implementation.
 *
 * @author Stefan Siegl
 *
 * Copyright (c) 2012 Stefan Siegl <stesie@brokenpipe.de>
 *
 * Information on the RC2 cipher is available from RFC #2268,
 * http://www.ietf.org/rfc/rfc2268.txt
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("e73pV");
var $3a0b540a7ed0df93$var$piTable = [
    0xd9,
    0x78,
    0xf9,
    0xc4,
    0x19,
    0xdd,
    0xb5,
    0xed,
    0x28,
    0xe9,
    0xfd,
    0x79,
    0x4a,
    0xa0,
    0xd8,
    0x9d,
    0xc6,
    0x7e,
    0x37,
    0x83,
    0x2b,
    0x76,
    0x53,
    0x8e,
    0x62,
    0x4c,
    0x64,
    0x88,
    0x44,
    0x8b,
    0xfb,
    0xa2,
    0x17,
    0x9a,
    0x59,
    0xf5,
    0x87,
    0xb3,
    0x4f,
    0x13,
    0x61,
    0x45,
    0x6d,
    0x8d,
    0x09,
    0x81,
    0x7d,
    0x32,
    0xbd,
    0x8f,
    0x40,
    0xeb,
    0x86,
    0xb7,
    0x7b,
    0x0b,
    0xf0,
    0x95,
    0x21,
    0x22,
    0x5c,
    0x6b,
    0x4e,
    0x82,
    0x54,
    0xd6,
    0x65,
    0x93,
    0xce,
    0x60,
    0xb2,
    0x1c,
    0x73,
    0x56,
    0xc0,
    0x14,
    0xa7,
    0x8c,
    0xf1,
    0xdc,
    0x12,
    0x75,
    0xca,
    0x1f,
    0x3b,
    0xbe,
    0xe4,
    0xd1,
    0x42,
    0x3d,
    0xd4,
    0x30,
    0xa3,
    0x3c,
    0xb6,
    0x26,
    0x6f,
    0xbf,
    0x0e,
    0xda,
    0x46,
    0x69,
    0x07,
    0x57,
    0x27,
    0xf2,
    0x1d,
    0x9b,
    0xbc,
    0x94,
    0x43,
    0x03,
    0xf8,
    0x11,
    0xc7,
    0xf6,
    0x90,
    0xef,
    0x3e,
    0xe7,
    0x06,
    0xc3,
    0xd5,
    0x2f,
    0xc8,
    0x66,
    0x1e,
    0xd7,
    0x08,
    0xe8,
    0xea,
    0xde,
    0x80,
    0x52,
    0xee,
    0xf7,
    0x84,
    0xaa,
    0x72,
    0xac,
    0x35,
    0x4d,
    0x6a,
    0x2a,
    0x96,
    0x1a,
    0xd2,
    0x71,
    0x5a,
    0x15,
    0x49,
    0x74,
    0x4b,
    0x9f,
    0xd0,
    0x5e,
    0x04,
    0x18,
    0xa4,
    0xec,
    0xc2,
    0xe0,
    0x41,
    0x6e,
    0x0f,
    0x51,
    0xcb,
    0xcc,
    0x24,
    0x91,
    0xaf,
    0x50,
    0xa1,
    0xf4,
    0x70,
    0x39,
    0x99,
    0x7c,
    0x3a,
    0x85,
    0x23,
    0xb8,
    0xb4,
    0x7a,
    0xfc,
    0x02,
    0x36,
    0x5b,
    0x25,
    0x55,
    0x97,
    0x31,
    0x2d,
    0x5d,
    0xfa,
    0x98,
    0xe3,
    0x8a,
    0x92,
    0xae,
    0x05,
    0xdf,
    0x29,
    0x10,
    0x67,
    0x6c,
    0xba,
    0xc9,
    0xd3,
    0x00,
    0xe6,
    0xcf,
    0xe1,
    0x9e,
    0xa8,
    0x2c,
    0x63,
    0x16,
    0x01,
    0x3f,
    0x58,
    0xe2,
    0x89,
    0xa9,
    0x0d,
    0x38,
    0x34,
    0x1b,
    0xab,
    0x33,
    0xff,
    0xb0,
    0xbb,
    0x48,
    0x0c,
    0x5f,
    0xb9,
    0xb1,
    0xcd,
    0x2e,
    0xc5,
    0xf3,
    0xdb,
    0x47,
    0xe5,
    0xa5,
    0x9c,
    0x77,
    0x0a,
    0xa6,
    0x20,
    0x68,
    0xfe,
    0x7f,
    0xc1,
    0xad
];
var $3a0b540a7ed0df93$var$s = [
    1,
    2,
    3,
    5
];
/**
 * Rotate a word left by given number of bits.
 *
 * Bits that are shifted out on the left are put back in on the right
 * hand side.
 *
 * @param word The word to shift left.
 * @param bits The number of bits to shift by.
 * @return The rotated word.
 */ var $3a0b540a7ed0df93$var$rol = function(word, bits) {
    return word << bits & 0xffff | (word & 0xffff) >> 16 - bits;
};
/**
 * Rotate a word right by given number of bits.
 *
 * Bits that are shifted out on the right are put back in on the left
 * hand side.
 *
 * @param word The word to shift right.
 * @param bits The number of bits to shift by.
 * @return The rotated word.
 */ var $3a0b540a7ed0df93$var$ror = function(word, bits) {
    return (word & 0xffff) >> bits | word << 16 - bits & 0xffff;
};
/* RC2 API */ module.exports = $2xc86.rc2 = $2xc86.rc2 || {};
/**
 * Perform RC2 key expansion as per RFC #2268, section 2.
 *
 * @param key variable-length user key (between 1 and 128 bytes)
 * @param effKeyBits number of effective key bits (default: 128)
 * @return the expanded RC2 key (ByteBuffer of 128 bytes)
 */ $2xc86.rc2.expandKey = function(key, effKeyBits) {
    if (typeof key === "string") key = $2xc86.util.createBuffer(key);
    effKeyBits = effKeyBits || 128;
    /* introduce variables that match the names used in RFC #2268 */ var L = key;
    var T = key.length();
    var T1 = effKeyBits;
    var T8 = Math.ceil(T1 / 8);
    var TM = 0xff >> (T1 & 0x07);
    var i;
    for(i = T; i < 128; i++)L.putByte($3a0b540a7ed0df93$var$piTable[L.at(i - 1) + L.at(i - T) & 0xff]);
    L.setAt(128 - T8, $3a0b540a7ed0df93$var$piTable[L.at(128 - T8) & TM]);
    for(i = 127 - T8; i >= 0; i--)L.setAt(i, $3a0b540a7ed0df93$var$piTable[L.at(i + 1) ^ L.at(i + T8)]);
    return L;
};
/**
 * Creates a RC2 cipher object.
 *
 * @param key the symmetric key to use (as base for key generation).
 * @param bits the number of effective key bits.
 * @param encrypt false for decryption, true for encryption.
 *
 * @return the cipher.
 */ var $3a0b540a7ed0df93$var$createCipher = function(key, bits, encrypt) {
    var _finish = false, _input = null, _output = null, _iv = null;
    var mixRound, mashRound;
    var i, j, K = [];
    /* Expand key and fill into K[] Array */ key = $2xc86.rc2.expandKey(key, bits);
    for(i = 0; i < 64; i++)K.push(key.getInt16Le());
    if (encrypt) {
        /**
     * Perform one mixing round "in place".
     *
     * @param R Array of four words to perform mixing on.
     */ mixRound = function(R) {
            for(i = 0; i < 4; i++){
                R[i] += K[j] + (R[(i + 3) % 4] & R[(i + 2) % 4]) + (~R[(i + 3) % 4] & R[(i + 1) % 4]);
                R[i] = $3a0b540a7ed0df93$var$rol(R[i], $3a0b540a7ed0df93$var$s[i]);
                j++;
            }
        };
        /**
     * Perform one mashing round "in place".
     *
     * @param R Array of four words to perform mashing on.
     */ mashRound = function(R) {
            for(i = 0; i < 4; i++)R[i] += K[R[(i + 3) % 4] & 63];
        };
    } else {
        /**
     * Perform one r-mixing round "in place".
     *
     * @param R Array of four words to perform mixing on.
     */ mixRound = function(R) {
            for(i = 3; i >= 0; i--){
                R[i] = $3a0b540a7ed0df93$var$ror(R[i], $3a0b540a7ed0df93$var$s[i]);
                R[i] -= K[j] + (R[(i + 3) % 4] & R[(i + 2) % 4]) + (~R[(i + 3) % 4] & R[(i + 1) % 4]);
                j--;
            }
        };
        /**
     * Perform one r-mashing round "in place".
     *
     * @param R Array of four words to perform mashing on.
     */ mashRound = function(R) {
            for(i = 3; i >= 0; i--)R[i] -= K[R[(i + 3) % 4] & 63];
        };
    }
    /**
   * Run the specified cipher execution plan.
   *
   * This function takes four words from the input buffer, applies the IV on
   * it (if requested) and runs the provided execution plan.
   *
   * The plan must be put together in form of a array of arrays.  Where the
   * outer one is simply a list of steps to perform and the inner one needs
   * to have two elements: the first one telling how many rounds to perform,
   * the second one telling what to do (i.e. the function to call).
   *
   * @param {Array} plan The plan to execute.
   */ var runPlan = function(plan) {
        var R = [];
        /* Get data from input buffer and fill the four words into R */ for(i = 0; i < 4; i++){
            var val = _input.getInt16Le();
            if (_iv !== null) {
                if (encrypt) /* We're encrypting, apply the IV first. */ val ^= _iv.getInt16Le();
                else /* We're decryption, keep cipher text for next block. */ _iv.putInt16Le(val);
            }
            R.push(val & 0xffff);
        }
        /* Reset global "j" variable as per spec. */ j = encrypt ? 0 : 63;
        /* Run execution plan. */ for(var ptr = 0; ptr < plan.length; ptr++)for(var ctr = 0; ctr < plan[ptr][0]; ctr++)plan[ptr][1](R);
        /* Write back result to output buffer. */ for(i = 0; i < 4; i++){
            if (_iv !== null) {
                if (encrypt) /* We're encrypting in CBC-mode, feed back encrypted bytes into
             IV buffer to carry it forward to next block. */ _iv.putInt16Le(R[i]);
                else R[i] ^= _iv.getInt16Le();
            }
            _output.putInt16Le(R[i]);
        }
    };
    /* Create cipher object */ var cipher = null;
    cipher = {
        /**
     * Starts or restarts the encryption or decryption process, whichever
     * was previously configured.
     *
     * To use the cipher in CBC mode, iv may be given either as a string
     * of bytes, or as a byte buffer.  For ECB mode, give null as iv.
     *
     * @param iv the initialization vector to use, null for ECB mode.
     * @param output the output the buffer to write to, null to create one.
     */ start: function(iv, output) {
            if (iv) /* CBC mode */ {
                if (typeof iv === "string") iv = $2xc86.util.createBuffer(iv);
            }
            _finish = false;
            _input = $2xc86.util.createBuffer();
            _output = output || new $2xc86.util.createBuffer();
            _iv = iv;
            cipher.output = _output;
        },
        /**
     * Updates the next block.
     *
     * @param input the buffer to read from.
     */ update: function(input) {
            if (!_finish) // not finishing, so fill the input buffer with more input
            _input.putBuffer(input);
            while(_input.length() >= 8)runPlan([
                [
                    5,
                    mixRound
                ],
                [
                    1,
                    mashRound
                ],
                [
                    6,
                    mixRound
                ],
                [
                    1,
                    mashRound
                ],
                [
                    5,
                    mixRound
                ]
            ]);
        },
        /**
     * Finishes encrypting or decrypting.
     *
     * @param pad a padding function to use, null for PKCS#7 padding,
     *           signature(blockSize, buffer, decrypt).
     *
     * @return true if successful, false on error.
     */ finish: function(pad) {
            var rval = true;
            if (encrypt) {
                if (pad) rval = pad(8, _input, !encrypt);
                else {
                    // add PKCS#7 padding to block (each pad byte is the
                    // value of the number of pad bytes)
                    var padding = _input.length() === 8 ? 8 : 8 - _input.length();
                    _input.fillWithByte(padding, padding);
                }
            }
            if (rval) {
                // do final update
                _finish = true;
                cipher.update();
            }
            if (!encrypt) {
                // check for error: input data not a multiple of block size
                rval = _input.length() === 0;
                if (rval) {
                    if (pad) rval = pad(8, _output, !encrypt);
                    else {
                        // ensure padding byte count is valid
                        var len = _output.length();
                        var count = _output.at(len - 1);
                        if (count > len) rval = false;
                        else // trim off padding bytes
                        _output.truncate(count);
                    }
                }
            }
            return rval;
        }
    };
    return cipher;
};
/**
 * Creates an RC2 cipher object to encrypt data in ECB or CBC mode using the
 * given symmetric key. The output will be stored in the 'output' member
 * of the returned cipher.
 *
 * The key and iv may be given as a string of bytes or a byte buffer.
 * The cipher is initialized to use 128 effective key bits.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 *
 * @return the cipher.
 */ $2xc86.rc2.startEncrypting = function(key, iv, output) {
    var cipher = $2xc86.rc2.createEncryptionCipher(key, 128);
    cipher.start(iv, output);
    return cipher;
};
/**
 * Creates an RC2 cipher object to encrypt data in ECB or CBC mode using the
 * given symmetric key.
 *
 * The key may be given as a string of bytes or a byte buffer.
 *
 * To start encrypting call start() on the cipher with an iv and optional
 * output buffer.
 *
 * @param key the symmetric key to use.
 *
 * @return the cipher.
 */ $2xc86.rc2.createEncryptionCipher = function(key, bits) {
    return $3a0b540a7ed0df93$var$createCipher(key, bits, true);
};
/**
 * Creates an RC2 cipher object to decrypt data in ECB or CBC mode using the
 * given symmetric key. The output will be stored in the 'output' member
 * of the returned cipher.
 *
 * The key and iv may be given as a string of bytes or a byte buffer.
 * The cipher is initialized to use 128 effective key bits.
 *
 * @param key the symmetric key to use.
 * @param iv the initialization vector to use.
 * @param output the buffer to write to, null to create one.
 *
 * @return the cipher.
 */ $2xc86.rc2.startDecrypting = function(key, iv, output) {
    var cipher = $2xc86.rc2.createDecryptionCipher(key, 128);
    cipher.start(iv, output);
    return cipher;
};
/**
 * Creates an RC2 cipher object to decrypt data in ECB or CBC mode using the
 * given symmetric key.
 *
 * The key may be given as a string of bytes or a byte buffer.
 *
 * To start decrypting call start() on the cipher with an iv and optional
 * output buffer.
 *
 * @param key the symmetric key to use.
 *
 * @return the cipher.
 */ $2xc86.rc2.createDecryptionCipher = function(key, bits) {
    return $3a0b540a7ed0df93$var$createCipher(key, bits, false);
};

});


parcelRequire.register("kEvOj", function(module, exports) {
// @ts-nocheck
"use strict";
parcelRequire("5uwlA");

var $2xc86 = parcelRequire("2xc86");
const $f09037f503d3485b$var$pki = $2xc86.pki;
/**
 * Gets a self-signed X.509 certificate for the key.
 *
 * The output Uint8Array contains the PKCS #7 message in DER.
 *
 * TODO: move to libp2p-crypto package
 *
 * @param {KeyInfo} key - The id and name of the key
 * @param {RsaPrivateKey} privateKey - The naked key
 * @returns {Uint8Array}
 */ const $f09037f503d3485b$var$certificateForKey = (key, privateKey)=>{
    const publicKey = $f09037f503d3485b$var$pki.setRsaPublicKey(privateKey.n, privateKey.e);
    const cert = $f09037f503d3485b$var$pki.createCertificate();
    cert.publicKey = publicKey;
    cert.serialNumber = "01";
    cert.validity.notBefore = new Date();
    cert.validity.notAfter = new Date();
    cert.validity.notAfter.setFullYear(cert.validity.notBefore.getFullYear() + 10);
    const attrs = [
        {
            name: "organizationName",
            value: "ipfs"
        },
        {
            shortName: "OU",
            value: "keystore"
        },
        {
            name: "commonName",
            value: key.id
        }
    ];
    cert.setSubject(attrs);
    cert.setIssuer(attrs);
    cert.setExtensions([
        {
            name: "basicConstraints",
            cA: true
        },
        {
            name: "keyUsage",
            keyCertSign: true,
            digitalSignature: true,
            nonRepudiation: true,
            keyEncipherment: true,
            dataEncipherment: true
        },
        {
            name: "extKeyUsage",
            serverAuth: true,
            clientAuth: true,
            codeSigning: true,
            emailProtection: true,
            timeStamping: true
        },
        {
            name: "nsCertType",
            client: true,
            server: true,
            email: true,
            objsign: true,
            sslCA: true,
            emailCA: true,
            objCA: true
        }
    ]);
    // self-sign certificate
    cert.sign(privateKey);
    return cert;
};
/**
 * Finds the first item in a collection that is matched in the
 * `asyncCompare` function.
 *
 * `asyncCompare` is an async function that must
 * resolve to either `true` or `false`.
 *
 * @param {Array} array
 * @param {function(*)} asyncCompare - An async function that returns a boolean
 */ async function $f09037f503d3485b$var$findAsync(array, asyncCompare) {
    const promises = array.map(asyncCompare);
    const results = await Promise.all(promises);
    const index = results.findIndex((result)=>result);
    return array[index];
}
module.exports = {
    certificateForKey: $f09037f503d3485b$var$certificateForKey,
    findAsync: $f09037f503d3485b$var$findAsync
};

});


parcelRequire.register("acTBK", function(module, exports) {
/**
 * Secure Hash Algorithm with a 1024-bit block size implementation.
 *
 * This includes: SHA-512, SHA-384, SHA-512/224, and SHA-512/256. For
 * SHA-256 (block size 512 bits), see sha256.js.
 *
 * See FIPS 180-4 for details.
 *
 * @author Dave Longley
 *
 * Copyright (c) 2014-2015 Digital Bazaar, Inc.
 */ 
var $2xc86 = parcelRequire("2xc86");
parcelRequire("eeecL");
parcelRequire("e73pV");
var $76e628ea786ce34d$var$sha512 = module.exports = $2xc86.sha512 = $2xc86.sha512 || {};
// SHA-512
$2xc86.md.sha512 = $2xc86.md.algorithms.sha512 = $76e628ea786ce34d$var$sha512;
// SHA-384
var $76e628ea786ce34d$var$sha384 = $2xc86.sha384 = $2xc86.sha512.sha384 = $2xc86.sha512.sha384 || {};
$76e628ea786ce34d$var$sha384.create = function() {
    return $76e628ea786ce34d$var$sha512.create("SHA-384");
};
$2xc86.md.sha384 = $2xc86.md.algorithms.sha384 = $76e628ea786ce34d$var$sha384;
// SHA-512/256
$2xc86.sha512.sha256 = $2xc86.sha512.sha256 || {
    create: function() {
        return $76e628ea786ce34d$var$sha512.create("SHA-512/256");
    }
};
$2xc86.md["sha512/256"] = $2xc86.md.algorithms["sha512/256"] = $2xc86.sha512.sha256;
// SHA-512/224
$2xc86.sha512.sha224 = $2xc86.sha512.sha224 || {
    create: function() {
        return $76e628ea786ce34d$var$sha512.create("SHA-512/224");
    }
};
$2xc86.md["sha512/224"] = $2xc86.md.algorithms["sha512/224"] = $2xc86.sha512.sha224;
/**
 * Creates a SHA-2 message digest object.
 *
 * @param algorithm the algorithm to use (SHA-512, SHA-384, SHA-512/224,
 *          SHA-512/256).
 *
 * @return a message digest object.
 */ $76e628ea786ce34d$var$sha512.create = function(algorithm) {
    // do initialization as necessary
    if (!$76e628ea786ce34d$var$_initialized) $76e628ea786ce34d$var$_init();
    if (typeof algorithm === "undefined") algorithm = "SHA-512";
    if (!(algorithm in $76e628ea786ce34d$var$_states)) throw new Error("Invalid SHA-512 algorithm: " + algorithm);
    // SHA-512 state contains eight 64-bit integers (each as two 32-bit ints)
    var _state = $76e628ea786ce34d$var$_states[algorithm];
    var _h = null;
    // input buffer
    var _input = $2xc86.util.createBuffer();
    // used for 64-bit word storage
    var _w = new Array(80);
    for(var wi = 0; wi < 80; ++wi)_w[wi] = new Array(2);
    // determine digest length by algorithm name (default)
    var digestLength = 64;
    switch(algorithm){
        case "SHA-384":
            digestLength = 48;
            break;
        case "SHA-512/256":
            digestLength = 32;
            break;
        case "SHA-512/224":
            digestLength = 28;
            break;
    }
    // message digest object
    var md = {
        // SHA-512 => sha512
        algorithm: algorithm.replace("-", "").toLowerCase(),
        blockLength: 128,
        digestLength: digestLength,
        // 56-bit length of message so far (does not including padding)
        messageLength: 0,
        // true message length
        fullMessageLength: null,
        // size of message length in bytes
        messageLengthSize: 16
    };
    /**
   * Starts the digest.
   *
   * @return this digest object.
   */ md.start = function() {
        // up to 56-bit message length for convenience
        md.messageLength = 0;
        // full message length (set md.messageLength128 for backwards-compatibility)
        md.fullMessageLength = md.messageLength128 = [];
        var int32s = md.messageLengthSize / 4;
        for(var i = 0; i < int32s; ++i)md.fullMessageLength.push(0);
        _input = $2xc86.util.createBuffer();
        _h = new Array(_state.length);
        for(var i = 0; i < _state.length; ++i)_h[i] = _state[i].slice(0);
        return md;
    };
    // start digest automatically for first time
    md.start();
    /**
   * Updates the digest with the given message input. The given input can
   * treated as raw input (no encoding will be applied) or an encoding of
   * 'utf8' maybe given to encode the input using UTF-8.
   *
   * @param msg the message input to update with.
   * @param encoding the encoding to use (default: 'raw', other: 'utf8').
   *
   * @return this digest object.
   */ md.update = function(msg, encoding) {
        if (encoding === "utf8") msg = $2xc86.util.encodeUtf8(msg);
        // update message length
        var len = msg.length;
        md.messageLength += len;
        len = [
            len / 0x100000000 >>> 0,
            len >>> 0
        ];
        for(var i = md.fullMessageLength.length - 1; i >= 0; --i){
            md.fullMessageLength[i] += len[1];
            len[1] = len[0] + (md.fullMessageLength[i] / 0x100000000 >>> 0);
            md.fullMessageLength[i] = md.fullMessageLength[i] >>> 0;
            len[0] = len[1] / 0x100000000 >>> 0;
        }
        // add bytes to input buffer
        _input.putBytes(msg);
        // process bytes
        $76e628ea786ce34d$var$_update(_h, _w, _input);
        // compact input buffer every 2K or if empty
        if (_input.read > 2048 || _input.length() === 0) _input.compact();
        return md;
    };
    /**
   * Produces the digest.
   *
   * @return a byte buffer containing the digest value.
   */ md.digest = function() {
        /* Note: Here we copy the remaining bytes in the input buffer and
    add the appropriate SHA-512 padding. Then we do the final update
    on a copy of the state so that if the user wants to get
    intermediate digests they can do so. */ /* Determine the number of bytes that must be added to the message
    to ensure its length is congruent to 896 mod 1024. In other words,
    the data to be digested must be a multiple of 1024 bits (or 128 bytes).
    This data includes the message, some padding, and the length of the
    message. Since the length of the message will be encoded as 16 bytes (128
    bits), that means that the last segment of the data must have 112 bytes
    (896 bits) of message and padding. Therefore, the length of the message
    plus the padding must be congruent to 896 mod 1024 because
    1024 - 128 = 896.

    In order to fill up the message length it must be filled with
    padding that begins with 1 bit followed by all 0 bits. Padding
    must *always* be present, so if the message length is already
    congruent to 896 mod 1024, then 1024 padding bits must be added. */ var finalBlock = $2xc86.util.createBuffer();
        finalBlock.putBytes(_input.bytes());
        // compute remaining size to be digested (include message length size)
        var remaining = md.fullMessageLength[md.fullMessageLength.length - 1] + md.messageLengthSize;
        // add padding for overflow blockSize - overflow
        // _padding starts with 1 byte with first bit is set (byte value 128), then
        // there may be up to (blockSize - 1) other pad bytes
        var overflow = remaining & md.blockLength - 1;
        finalBlock.putBytes($76e628ea786ce34d$var$_padding.substr(0, md.blockLength - overflow));
        // serialize message length in bits in big-endian order; since length
        // is stored in bytes we multiply by 8 and add carry from next int
        var next, carry;
        var bits = md.fullMessageLength[0] * 8;
        for(var i = 0; i < md.fullMessageLength.length - 1; ++i){
            next = md.fullMessageLength[i + 1] * 8;
            carry = next / 0x100000000 >>> 0;
            bits += carry;
            finalBlock.putInt32(bits >>> 0);
            bits = next >>> 0;
        }
        finalBlock.putInt32(bits);
        var h = new Array(_h.length);
        for(var i = 0; i < _h.length; ++i)h[i] = _h[i].slice(0);
        $76e628ea786ce34d$var$_update(h, _w, finalBlock);
        var rval = $2xc86.util.createBuffer();
        var hlen;
        if (algorithm === "SHA-512") hlen = h.length;
        else if (algorithm === "SHA-384") hlen = h.length - 2;
        else hlen = h.length - 4;
        for(var i = 0; i < hlen; ++i){
            rval.putInt32(h[i][0]);
            if (i !== hlen - 1 || algorithm !== "SHA-512/224") rval.putInt32(h[i][1]);
        }
        return rval;
    };
    return md;
};
// sha-512 padding bytes not initialized yet
var $76e628ea786ce34d$var$_padding = null;
var $76e628ea786ce34d$var$_initialized = false;
// table of constants
var $76e628ea786ce34d$var$_k = null;
// initial hash states
var $76e628ea786ce34d$var$_states = null;
/**
 * Initializes the constant tables.
 */ function $76e628ea786ce34d$var$_init() {
    // create padding
    $76e628ea786ce34d$var$_padding = String.fromCharCode(128);
    $76e628ea786ce34d$var$_padding += $2xc86.util.fillString(String.fromCharCode(0x00), 128);
    // create K table for SHA-512
    $76e628ea786ce34d$var$_k = [
        [
            0x428a2f98,
            0xd728ae22
        ],
        [
            0x71374491,
            0x23ef65cd
        ],
        [
            0xb5c0fbcf,
            0xec4d3b2f
        ],
        [
            0xe9b5dba5,
            0x8189dbbc
        ],
        [
            0x3956c25b,
            0xf348b538
        ],
        [
            0x59f111f1,
            0xb605d019
        ],
        [
            0x923f82a4,
            0xaf194f9b
        ],
        [
            0xab1c5ed5,
            0xda6d8118
        ],
        [
            0xd807aa98,
            0xa3030242
        ],
        [
            0x12835b01,
            0x45706fbe
        ],
        [
            0x243185be,
            0x4ee4b28c
        ],
        [
            0x550c7dc3,
            0xd5ffb4e2
        ],
        [
            0x72be5d74,
            0xf27b896f
        ],
        [
            0x80deb1fe,
            0x3b1696b1
        ],
        [
            0x9bdc06a7,
            0x25c71235
        ],
        [
            0xc19bf174,
            0xcf692694
        ],
        [
            0xe49b69c1,
            0x9ef14ad2
        ],
        [
            0xefbe4786,
            0x384f25e3
        ],
        [
            0x0fc19dc6,
            0x8b8cd5b5
        ],
        [
            0x240ca1cc,
            0x77ac9c65
        ],
        [
            0x2de92c6f,
            0x592b0275
        ],
        [
            0x4a7484aa,
            0x6ea6e483
        ],
        [
            0x5cb0a9dc,
            0xbd41fbd4
        ],
        [
            0x76f988da,
            0x831153b5
        ],
        [
            0x983e5152,
            0xee66dfab
        ],
        [
            0xa831c66d,
            0x2db43210
        ],
        [
            0xb00327c8,
            0x98fb213f
        ],
        [
            0xbf597fc7,
            0xbeef0ee4
        ],
        [
            0xc6e00bf3,
            0x3da88fc2
        ],
        [
            0xd5a79147,
            0x930aa725
        ],
        [
            0x06ca6351,
            0xe003826f
        ],
        [
            0x14292967,
            0x0a0e6e70
        ],
        [
            0x27b70a85,
            0x46d22ffc
        ],
        [
            0x2e1b2138,
            0x5c26c926
        ],
        [
            0x4d2c6dfc,
            0x5ac42aed
        ],
        [
            0x53380d13,
            0x9d95b3df
        ],
        [
            0x650a7354,
            0x8baf63de
        ],
        [
            0x766a0abb,
            0x3c77b2a8
        ],
        [
            0x81c2c92e,
            0x47edaee6
        ],
        [
            0x92722c85,
            0x1482353b
        ],
        [
            0xa2bfe8a1,
            0x4cf10364
        ],
        [
            0xa81a664b,
            0xbc423001
        ],
        [
            0xc24b8b70,
            0xd0f89791
        ],
        [
            0xc76c51a3,
            0x0654be30
        ],
        [
            0xd192e819,
            0xd6ef5218
        ],
        [
            0xd6990624,
            0x5565a910
        ],
        [
            0xf40e3585,
            0x5771202a
        ],
        [
            0x106aa070,
            0x32bbd1b8
        ],
        [
            0x19a4c116,
            0xb8d2d0c8
        ],
        [
            0x1e376c08,
            0x5141ab53
        ],
        [
            0x2748774c,
            0xdf8eeb99
        ],
        [
            0x34b0bcb5,
            0xe19b48a8
        ],
        [
            0x391c0cb3,
            0xc5c95a63
        ],
        [
            0x4ed8aa4a,
            0xe3418acb
        ],
        [
            0x5b9cca4f,
            0x7763e373
        ],
        [
            0x682e6ff3,
            0xd6b2b8a3
        ],
        [
            0x748f82ee,
            0x5defb2fc
        ],
        [
            0x78a5636f,
            0x43172f60
        ],
        [
            0x84c87814,
            0xa1f0ab72
        ],
        [
            0x8cc70208,
            0x1a6439ec
        ],
        [
            0x90befffa,
            0x23631e28
        ],
        [
            0xa4506ceb,
            0xde82bde9
        ],
        [
            0xbef9a3f7,
            0xb2c67915
        ],
        [
            0xc67178f2,
            0xe372532b
        ],
        [
            0xca273ece,
            0xea26619c
        ],
        [
            0xd186b8c7,
            0x21c0c207
        ],
        [
            0xeada7dd6,
            0xcde0eb1e
        ],
        [
            0xf57d4f7f,
            0xee6ed178
        ],
        [
            0x06f067aa,
            0x72176fba
        ],
        [
            0x0a637dc5,
            0xa2c898a6
        ],
        [
            0x113f9804,
            0xbef90dae
        ],
        [
            0x1b710b35,
            0x131c471b
        ],
        [
            0x28db77f5,
            0x23047d84
        ],
        [
            0x32caab7b,
            0x40c72493
        ],
        [
            0x3c9ebe0a,
            0x15c9bebc
        ],
        [
            0x431d67c4,
            0x9c100d4c
        ],
        [
            0x4cc5d4be,
            0xcb3e42b6
        ],
        [
            0x597f299c,
            0xfc657e2a
        ],
        [
            0x5fcb6fab,
            0x3ad6faec
        ],
        [
            0x6c44198c,
            0x4a475817
        ]
    ];
    // initial hash states
    $76e628ea786ce34d$var$_states = {};
    $76e628ea786ce34d$var$_states["SHA-512"] = [
        [
            0x6a09e667,
            0xf3bcc908
        ],
        [
            0xbb67ae85,
            0x84caa73b
        ],
        [
            0x3c6ef372,
            0xfe94f82b
        ],
        [
            0xa54ff53a,
            0x5f1d36f1
        ],
        [
            0x510e527f,
            0xade682d1
        ],
        [
            0x9b05688c,
            0x2b3e6c1f
        ],
        [
            0x1f83d9ab,
            0xfb41bd6b
        ],
        [
            0x5be0cd19,
            0x137e2179
        ]
    ];
    $76e628ea786ce34d$var$_states["SHA-384"] = [
        [
            0xcbbb9d5d,
            0xc1059ed8
        ],
        [
            0x629a292a,
            0x367cd507
        ],
        [
            0x9159015a,
            0x3070dd17
        ],
        [
            0x152fecd8,
            0xf70e5939
        ],
        [
            0x67332667,
            0xffc00b31
        ],
        [
            0x8eb44a87,
            0x68581511
        ],
        [
            0xdb0c2e0d,
            0x64f98fa7
        ],
        [
            0x47b5481d,
            0xbefa4fa4
        ]
    ];
    $76e628ea786ce34d$var$_states["SHA-512/256"] = [
        [
            0x22312194,
            0xFC2BF72C
        ],
        [
            0x9F555FA3,
            0xC84C64C2
        ],
        [
            0x2393B86B,
            0x6F53B151
        ],
        [
            0x96387719,
            0x5940EABD
        ],
        [
            0x96283EE2,
            0xA88EFFE3
        ],
        [
            0xBE5E1E25,
            0x53863992
        ],
        [
            0x2B0199FC,
            0x2C85B8AA
        ],
        [
            0x0EB72DDC,
            0x81C52CA2
        ]
    ];
    $76e628ea786ce34d$var$_states["SHA-512/224"] = [
        [
            0x8C3D37C8,
            0x19544DA2
        ],
        [
            0x73E19966,
            0x89DCD4D6
        ],
        [
            0x1DFAB7AE,
            0x32FF9C82
        ],
        [
            0x679DD514,
            0x582F9FCF
        ],
        [
            0x0F6D2B69,
            0x7BD44DA8
        ],
        [
            0x77E36F73,
            0x04C48942
        ],
        [
            0x3F9D85A8,
            0x6A1D36C8
        ],
        [
            0x1112E6AD,
            0x91D692A1
        ]
    ];
    // now initialized
    $76e628ea786ce34d$var$_initialized = true;
}
/**
 * Updates a SHA-512 state with the given byte buffer.
 *
 * @param s the SHA-512 state to update.
 * @param w the array to use to store words.
 * @param bytes the byte buffer to update with.
 */ function $76e628ea786ce34d$var$_update(s, w, bytes) {
    // consume 512 bit (128 byte) chunks
    var t1_hi, t1_lo;
    var t2_hi, t2_lo;
    var s0_hi, s0_lo;
    var s1_hi, s1_lo;
    var ch_hi, ch_lo;
    var maj_hi, maj_lo;
    var a_hi, a_lo;
    var b_hi, b_lo;
    var c_hi, c_lo;
    var d_hi, d_lo;
    var e_hi, e_lo;
    var f_hi, f_lo;
    var g_hi, g_lo;
    var h_hi, h_lo;
    var i, hi, lo, w2, w7, w15, w16;
    var len = bytes.length();
    while(len >= 128){
        // the w array will be populated with sixteen 64-bit big-endian words
        // and then extended into 64 64-bit words according to SHA-512
        for(i = 0; i < 16; ++i){
            w[i][0] = bytes.getInt32() >>> 0;
            w[i][1] = bytes.getInt32() >>> 0;
        }
        for(; i < 80; ++i){
            // for word 2 words ago: ROTR 19(x) ^ ROTR 61(x) ^ SHR 6(x)
            w2 = w[i - 2];
            hi = w2[0];
            lo = w2[1];
            // high bits
            t1_hi = ((hi >>> 19 | lo << 13) ^ // ROTR 19
            (lo >>> 29 | hi << 3) ^ // ROTR 61/(swap + ROTR 29)
            hi >>> 6) >>> 0; // SHR 6
            // low bits
            t1_lo = ((hi << 13 | lo >>> 19) ^ // ROTR 19
            (lo << 3 | hi >>> 29) ^ // ROTR 61/(swap + ROTR 29)
            (hi << 26 | lo >>> 6)) >>> 0; // SHR 6
            // for word 15 words ago: ROTR 1(x) ^ ROTR 8(x) ^ SHR 7(x)
            w15 = w[i - 15];
            hi = w15[0];
            lo = w15[1];
            // high bits
            t2_hi = ((hi >>> 1 | lo << 31) ^ // ROTR 1
            (hi >>> 8 | lo << 24) ^ // ROTR 8
            hi >>> 7) >>> 0; // SHR 7
            // low bits
            t2_lo = ((hi << 31 | lo >>> 1) ^ // ROTR 1
            (hi << 24 | lo >>> 8) ^ // ROTR 8
            (hi << 25 | lo >>> 7)) >>> 0; // SHR 7
            // sum(t1, word 7 ago, t2, word 16 ago) modulo 2^64 (carry lo overflow)
            w7 = w[i - 7];
            w16 = w[i - 16];
            lo = t1_lo + w7[1] + t2_lo + w16[1];
            w[i][0] = t1_hi + w7[0] + t2_hi + w16[0] + (lo / 0x100000000 >>> 0) >>> 0;
            w[i][1] = lo >>> 0;
        }
        // initialize hash value for this chunk
        a_hi = s[0][0];
        a_lo = s[0][1];
        b_hi = s[1][0];
        b_lo = s[1][1];
        c_hi = s[2][0];
        c_lo = s[2][1];
        d_hi = s[3][0];
        d_lo = s[3][1];
        e_hi = s[4][0];
        e_lo = s[4][1];
        f_hi = s[5][0];
        f_lo = s[5][1];
        g_hi = s[6][0];
        g_lo = s[6][1];
        h_hi = s[7][0];
        h_lo = s[7][1];
        // round function
        for(i = 0; i < 80; ++i){
            // Sum1(e) = ROTR 14(e) ^ ROTR 18(e) ^ ROTR 41(e)
            s1_hi = ((e_hi >>> 14 | e_lo << 18) ^ // ROTR 14
            (e_hi >>> 18 | e_lo << 14) ^ // ROTR 18
            (e_lo >>> 9 | e_hi << 23)) >>> 0; // ROTR 41/(swap + ROTR 9)
            s1_lo = ((e_hi << 18 | e_lo >>> 14) ^ // ROTR 14
            (e_hi << 14 | e_lo >>> 18) ^ // ROTR 18
            (e_lo << 23 | e_hi >>> 9)) >>> 0; // ROTR 41/(swap + ROTR 9)
            // Ch(e, f, g) (optimized the same way as SHA-1)
            ch_hi = (g_hi ^ e_hi & (f_hi ^ g_hi)) >>> 0;
            ch_lo = (g_lo ^ e_lo & (f_lo ^ g_lo)) >>> 0;
            // Sum0(a) = ROTR 28(a) ^ ROTR 34(a) ^ ROTR 39(a)
            s0_hi = ((a_hi >>> 28 | a_lo << 4) ^ // ROTR 28
            (a_lo >>> 2 | a_hi << 30) ^ // ROTR 34/(swap + ROTR 2)
            (a_lo >>> 7 | a_hi << 25)) >>> 0; // ROTR 39/(swap + ROTR 7)
            s0_lo = ((a_hi << 4 | a_lo >>> 28) ^ // ROTR 28
            (a_lo << 30 | a_hi >>> 2) ^ // ROTR 34/(swap + ROTR 2)
            (a_lo << 25 | a_hi >>> 7)) >>> 0; // ROTR 39/(swap + ROTR 7)
            // Maj(a, b, c) (optimized the same way as SHA-1)
            maj_hi = (a_hi & b_hi | c_hi & (a_hi ^ b_hi)) >>> 0;
            maj_lo = (a_lo & b_lo | c_lo & (a_lo ^ b_lo)) >>> 0;
            // main algorithm
            // t1 = (h + s1 + ch + _k[i] + _w[i]) modulo 2^64 (carry lo overflow)
            lo = h_lo + s1_lo + ch_lo + $76e628ea786ce34d$var$_k[i][1] + w[i][1];
            t1_hi = h_hi + s1_hi + ch_hi + $76e628ea786ce34d$var$_k[i][0] + w[i][0] + (lo / 0x100000000 >>> 0) >>> 0;
            t1_lo = lo >>> 0;
            // t2 = s0 + maj modulo 2^64 (carry lo overflow)
            lo = s0_lo + maj_lo;
            t2_hi = s0_hi + maj_hi + (lo / 0x100000000 >>> 0) >>> 0;
            t2_lo = lo >>> 0;
            h_hi = g_hi;
            h_lo = g_lo;
            g_hi = f_hi;
            g_lo = f_lo;
            f_hi = e_hi;
            f_lo = e_lo;
            // e = (d + t1) modulo 2^64 (carry lo overflow)
            lo = d_lo + t1_lo;
            e_hi = d_hi + t1_hi + (lo / 0x100000000 >>> 0) >>> 0;
            e_lo = lo >>> 0;
            d_hi = c_hi;
            d_lo = c_lo;
            c_hi = b_hi;
            c_lo = b_lo;
            b_hi = a_hi;
            b_lo = a_lo;
            // a = (t1 + t2) modulo 2^64 (carry lo overflow)
            lo = t1_lo + t2_lo;
            a_hi = t1_hi + t2_hi + (lo / 0x100000000 >>> 0) >>> 0;
            a_lo = lo >>> 0;
        }
        // update hash state (additional modulo 2^64)
        lo = s[0][1] + a_lo;
        s[0][0] = s[0][0] + a_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[0][1] = lo >>> 0;
        lo = s[1][1] + b_lo;
        s[1][0] = s[1][0] + b_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[1][1] = lo >>> 0;
        lo = s[2][1] + c_lo;
        s[2][0] = s[2][0] + c_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[2][1] = lo >>> 0;
        lo = s[3][1] + d_lo;
        s[3][0] = s[3][0] + d_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[3][1] = lo >>> 0;
        lo = s[4][1] + e_lo;
        s[4][0] = s[4][0] + e_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[4][1] = lo >>> 0;
        lo = s[5][1] + f_lo;
        s[5][0] = s[5][0] + f_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[5][1] = lo >>> 0;
        lo = s[6][1] + g_lo;
        s[6][0] = s[6][0] + g_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[6][1] = lo >>> 0;
        lo = s[7][1] + h_lo;
        s[7][0] = s[7][0] + h_hi + (lo / 0x100000000 >>> 0) >>> 0;
        s[7][1] = lo >>> 0;
        len -= 128;
    }
}

});


parcelRequire.register("g1vns", function(module, exports) {
// @ts-nocheck
"use strict";

var $8pyvD = parcelRequire("8pyvD");

var $d8Blz = parcelRequire("d8Blz");
var $baa5144014a650fb$require$pipe = $d8Blz.pipe;

var $9IZzN = parcelRequire("9IZzN");
var $baa5144014a650fb$require$tap = $9IZzN.tap;

var $3QBfn = parcelRequire("3QBfn");

var $h6RaR = parcelRequire("h6RaR");
var $baa5144014a650fb$require$defaultOptions = $h6RaR.METRICS;

var $fREKj = parcelRequire("fREKj");
const $baa5144014a650fb$var$initialCounters = [
    "dataReceived",
    "dataSent"
];
const $baa5144014a650fb$var$directionToEvent = {
    in: "dataReceived",
    out: "dataSent"
};
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('libp2p-interfaces/src/transport/types').MultiaddrConnection} MultiaddrConnection
 */ /**
 * @typedef MetricsOptions
 * @property {number} [computeThrottleMaxQueueSize = defaultOptions.computeThrottleMaxQueueSize]
 * @property {number} [computeThrottleTimeout = defaultOptions.computeThrottleTimeout]
 * @property {number[]} [movingAverageIntervals = defaultOptions.movingAverageIntervals]
 * @property {number} [maxOldPeersRetention = defaultOptions.maxOldPeersRetention]
 */ class $baa5144014a650fb$var$Metrics {
    /**
   * @class
   * @param {MetricsOptions} options
   */ constructor(options){
        this._options = $8pyvD($baa5144014a650fb$require$defaultOptions, options);
        this._globalStats = new $fREKj($baa5144014a650fb$var$initialCounters, this._options);
        this._peerStats = new Map();
        this._protocolStats = new Map();
        this._oldPeers = $3QBfn(this._options.maxOldPeersRetention);
        this._running = false;
        this._onMessage = this._onMessage.bind(this);
        this._componentMetrics = new Map();
    }
    /**
   * Must be called for stats to saved. Any data pushed for tracking
   * will be ignored.
   */ start() {
        this._running = true;
    }
    /**
   * Stops all averages timers and prevents new data from being tracked.
   * Once `stop` is called, `start` must be called to resume stats tracking.
   */ stop() {
        this._running = false;
        this._globalStats.stop();
        for (const stats of this._peerStats.values())stats.stop();
        for (const stats of this._protocolStats.values())stats.stop();
    }
    /**
   * Gets the global `Stats` object
   *
   * @returns {Stats}
   */ get global() {
        return this._globalStats;
    }
    /**
   * Returns a list of `PeerId` strings currently being tracked
   *
   * @returns {string[]}
   */ get peers() {
        return Array.from(this._peerStats.keys());
    }
    /**
   * @returns {Map}
   */ getComponentMetrics() {
        return this._componentMetrics;
    }
    updateComponentMetric(component, metric, value) {
        if (!this._componentMetrics.has(component)) this._componentMetrics.set(component, new Map());
        const map = this._componentMetrics.get(component);
        map.set(metric, value);
    }
    /**
   * Returns the `Stats` object for the given `PeerId` whether it
   * is a live peer, or in the disconnected peer LRU cache.
   *
   * @param {PeerId} peerId
   * @returns {Stats}
   */ forPeer(peerId) {
        const idString = peerId.toB58String();
        return this._peerStats.get(idString) || this._oldPeers.get(idString);
    }
    /**
   * Returns a list of all protocol strings currently being tracked.
   *
   * @returns {string[]}
   */ get protocols() {
        return Array.from(this._protocolStats.keys());
    }
    /**
   * Returns the `Stats` object for the given `protocol`.
   *
   * @param {string} protocol
   * @returns {Stats}
   */ forProtocol(protocol) {
        return this._protocolStats.get(protocol);
    }
    /**
   * Should be called when all connections to a given peer
   * have closed. The `Stats` collection for the peer will
   * be stopped and moved to an LRU for temporary retention.
   *
   * @param {PeerId} peerId
   */ onPeerDisconnected(peerId) {
        const idString = peerId.toB58String();
        const peerStats = this._peerStats.get(idString);
        if (peerStats) {
            peerStats.stop();
            this._peerStats.delete(idString);
            this._oldPeers.set(idString, peerStats);
        }
    }
    /**
   * Takes the metadata for a message and tracks it in the
   * appropriate categories. If the protocol is present, protocol
   * stats will also be tracked.
   *
   * @private
   * @param {object} params
   * @param {PeerId} params.remotePeer - Remote peer
   * @param {string} [params.protocol] - Protocol string the stream is running
   * @param {string} params.direction - One of ['in','out']
   * @param {number} params.dataLength - Size of the message
   * @returns {void}
   */ _onMessage({ remotePeer: remotePeer, protocol: protocol, direction: direction, dataLength: dataLength }) {
        if (!this._running) return;
        const key = $baa5144014a650fb$var$directionToEvent[direction];
        let peerStats = this.forPeer(remotePeer);
        if (!peerStats) {
            peerStats = new $fREKj($baa5144014a650fb$var$initialCounters, this._options);
            this._peerStats.set(remotePeer.toB58String(), peerStats);
        }
        // Peer and global stats
        peerStats.push(key, dataLength);
        this._globalStats.push(key, dataLength);
        // Protocol specific stats
        if (protocol) {
            let protocolStats = this.forProtocol(protocol);
            if (!protocolStats) {
                protocolStats = new $fREKj($baa5144014a650fb$var$initialCounters, this._options);
                this._protocolStats.set(protocol, protocolStats);
            }
            protocolStats.push(key, dataLength);
        }
    }
    /**
   * Replaces the `PeerId` string with the given `peerId`.
   * If stats are already being tracked for the given `peerId`, the
   * placeholder stats will be merged with the existing stats.
   *
   * @param {PeerId} placeholder - A peerId string
   * @param {PeerId} peerId
   * @returns {void}
   */ updatePlaceholder(placeholder, peerId) {
        if (!this._running) return;
        const placeholderStats = this.forPeer(placeholder);
        const peerIdString = peerId.toB58String();
        const existingStats = this.forPeer(peerId);
        let mergedStats = placeholderStats;
        // If we already have stats, merge the two
        if (existingStats) {
            // If existing, merge
            mergedStats = $baa5144014a650fb$var$Metrics.mergeStats(existingStats, mergedStats);
            // Attempt to delete from the old peers list just in case it was tracked there
            this._oldPeers.delete(peerIdString);
        }
        this._peerStats.delete(placeholder.toB58String());
        this._peerStats.set(peerIdString, mergedStats);
        mergedStats.start();
    }
    /**
   * Tracks data running through a given Duplex Iterable `stream`. If
   * the `peerId` is not provided, a placeholder string will be created and
   * returned. This allows lazy tracking of a peer when the peer is not yet known.
   * When the `PeerId` is known, `Metrics.updatePlaceholder` should be called
   * with the placeholder string returned from here, and the known `PeerId`.
   *
   * @param {Object} options
   * @param {MultiaddrConnection} options.stream - A duplex iterable stream
   * @param {PeerId} [options.remotePeer] - The id of the remote peer that's connected
   * @param {string} [options.protocol] - The protocol the stream is running
   * @returns {MultiaddrConnection} The peerId string or placeholder string
   */ trackStream({ stream: stream, remotePeer: remotePeer, protocol: protocol }) {
        const metrics = this;
        const _source = stream.source;
        stream.source = $baa5144014a650fb$require$tap((chunk)=>metrics._onMessage({
                remotePeer: remotePeer,
                protocol: protocol,
                direction: "in",
                dataLength: chunk.length
            }))(_source);
        const _sink = stream.sink;
        stream.sink = (source)=>{
            return $baa5144014a650fb$require$pipe(source, $baa5144014a650fb$require$tap((chunk)=>metrics._onMessage({
                    remotePeer: remotePeer,
                    protocol: protocol,
                    direction: "out",
                    dataLength: chunk.length
                })), _sink);
        };
        return stream;
    }
    /**
   * Merges `other` into `target`. `target` will be modified
   * and returned.
   *
   * @param {Stats} target
   * @param {Stats} other
   * @returns {Stats}
   */ static mergeStats(target, other) {
        target.stop();
        other.stop();
        // Merge queues
        target._queue = [
            ...target._queue,
            ...other._queue
        ];
        // TODO: how to merge moving averages?
        return target;
    }
}
module.exports = $baa5144014a650fb$var$Metrics;

});
parcelRequire.register("9IZzN", function(module, exports) {

$parcel$export(module.exports, "collect", () => $d7e0b3961e984021$export$bb44f104e3c54dae);
$parcel$export(module.exports, "consume", () => $d7e0b3961e984021$export$e11e6a155c5c4d9d);
$parcel$export(module.exports, "take", () => $d7e0b3961e984021$export$b7df5d561049483a);
$parcel$export(module.exports, "tap", () => $d7e0b3961e984021$export$3f23594af5f37336);

var $bvigH = parcelRequire("bvigH");
async function* $d7e0b3961e984021$var$_batch(size, iterable) {
    let dataBatch = [];
    for await (const data of iterable){
        dataBatch.push(data);
        if (dataBatch.length === size) {
            yield dataBatch;
            dataBatch = [];
        }
    }
    if (dataBatch.length > 0) yield dataBatch;
}
function* $d7e0b3961e984021$var$_syncBatch(size, iterable) {
    let dataBatch = [];
    for (const data of iterable){
        dataBatch.push(data);
        if (dataBatch.length === size) {
            yield dataBatch;
            dataBatch = [];
        }
    }
    if (dataBatch.length > 0) yield dataBatch;
}
function $d7e0b3961e984021$export$712ea50be43a7858(size, iterable) {
    if (iterable === undefined) return (curriedIterable)=>$d7e0b3961e984021$export$712ea50be43a7858(size, curriedIterable);
    if (iterable[Symbol.asyncIterator]) return $d7e0b3961e984021$var$_batch(size, iterable);
    return $d7e0b3961e984021$var$_syncBatch(size, iterable);
}
const $d7e0b3961e984021$var$TIMEOUT = Symbol("TIMEOUT");
const $d7e0b3961e984021$var$createTimer = (duration)=>{
    let timeoutId;
    return [
        new Promise((resolve)=>{
            timeoutId = setTimeout(()=>resolve($d7e0b3961e984021$var$TIMEOUT), duration);
        }),
        ()=>{
            clearTimeout(timeoutId);
        }
    ];
};
// Like `batch` but flushes early if the `timeout` is reached
// NOTE: The strategy is to only hold onto a single item for a maximum of `timeout` ms.
async function* $d7e0b3961e984021$var$_batchWithTimeout(size, timeout, iterable) {
    const iterator = iterable[Symbol.asyncIterator]();
    let pendingData;
    let batchData = [];
    let timer;
    let clearTimer;
    const startTimer = ()=>{
        deleteTimer();
        [timer, clearTimer] = $d7e0b3961e984021$var$createTimer(timeout);
    };
    const deleteTimer = ()=>{
        if (clearTimer) clearTimer();
        timer = undefined;
    };
    pendingData = iterator.next();
    while(true){
        const res = await (timer ? Promise.race([
            pendingData,
            timer
        ]) : pendingData);
        if (res === $d7e0b3961e984021$var$TIMEOUT || res.done) {
            // Flush early (before we reach the batch size)
            if (batchData.length) {
                yield batchData;
                batchData = [];
            }
            deleteTimer();
            // And exit appropriately
            if (res !== $d7e0b3961e984021$var$TIMEOUT) break;
            continue;
        }
        // Fetch next item early doors (before we potentially yield)
        pendingData = iterator.next();
        // Then handle the value
        batchData.push(res.value);
        if (batchData.length === 1) // Start timer once we have at least 1 item ready to go
        startTimer();
        if (batchData.length === size) {
            yield batchData;
            batchData = [];
            deleteTimer();
            continue;
        }
    }
}
function $d7e0b3961e984021$export$591742b29fccb1c7(size, timeout, iterable) {
    if (iterable === undefined) return (curriedIterable)=>$d7e0b3961e984021$export$591742b29fccb1c7(size, timeout, curriedIterable);
    if (iterable[Symbol.asyncIterator] && timeout !== Infinity) return $d7e0b3961e984021$var$_batchWithTimeout(size, timeout, iterable);
    // For sync iterables or an infinite timeout, the timeout is irrelevant so just fallback to regular `batch`.
    return $d7e0b3961e984021$export$712ea50be43a7858(size, iterable);
}
function $d7e0b3961e984021$export$6731da38428a8625(iterable) {
    if (typeof iterable.next === "function") return iterable;
    if (typeof iterable[Symbol.iterator] === "function") return iterable[Symbol.iterator]();
    if (typeof iterable[Symbol.asyncIterator] === "function") return iterable[Symbol.asyncIterator]();
    throw new TypeError('"values" does not to conform to any of the iterator or iterable protocols');
}
function $d7e0b3961e984021$var$defer() {
    let reject;
    let resolve;
    const promise = new Promise((resolveFunc, rejectFunc)=>{
        resolve = resolveFunc;
        reject = rejectFunc;
    });
    return {
        promise: promise,
        reject: reject,
        resolve: resolve
    };
}
function $d7e0b3961e984021$var$_buffer(size, iterable) {
    const iterator = $d7e0b3961e984021$export$6731da38428a8625(iterable);
    const resultQueue = [];
    const readQueue = [];
    let reading = false;
    let ended = false;
    function fulfillReadQueue() {
        while(readQueue.length > 0 && resultQueue.length > 0){
            const readDeferred = readQueue.shift();
            const { error: error, value: value } = resultQueue.shift();
            if (error) readDeferred.reject(error);
            else readDeferred.resolve({
                done: false,
                value: value
            });
        }
        while(readQueue.length > 0 && ended){
            const { resolve: resolve } = readQueue.shift();
            resolve({
                done: true,
                value: undefined
            });
        }
    }
    async function fillQueue() {
        if (ended) return;
        if (reading) return;
        if (resultQueue.length >= size) return;
        reading = true;
        try {
            const { done: done, value: value } = await iterator.next();
            if (done) ended = true;
            else resultQueue.push({
                value: value
            });
        } catch (error) {
            ended = true;
            resultQueue.push({
                error: error
            });
        }
        fulfillReadQueue();
        reading = false;
        fillQueue();
    }
    async function next() {
        if (resultQueue.length > 0) {
            const { error: error, value: value } = resultQueue.shift();
            if (error) throw error;
            fillQueue();
            return {
                done: false,
                value: value
            };
        }
        if (ended) return {
            done: true,
            value: undefined
        }; // stupid ts
        const deferred = $d7e0b3961e984021$var$defer();
        readQueue.push(deferred);
        fillQueue();
        return deferred.promise;
    }
    const asyncIterableIterator = {
        next: next,
        [Symbol.asyncIterator]: ()=>asyncIterableIterator
    };
    return asyncIterableIterator;
}
function* $d7e0b3961e984021$var$syncBuffer(size, iterable) {
    const valueQueue = [];
    let e;
    try {
        for (const value of iterable){
            valueQueue.push(value);
            if (valueQueue.length <= size) continue;
            yield valueQueue.shift();
        }
    } catch (error) {
        e = error;
    }
    for (const value of valueQueue)yield value;
    if (e) throw e;
}
function $d7e0b3961e984021$export$ab1029bcae9ddb4a(size, iterable) {
    if (iterable === undefined) return (curriedIterable)=>$d7e0b3961e984021$export$ab1029bcae9ddb4a(size, curriedIterable);
    if (size === 0) return iterable;
    if (iterable[Symbol.asyncIterator]) return $d7e0b3961e984021$var$_buffer(size, iterable);
    return $d7e0b3961e984021$var$syncBuffer(size, iterable);
}
async function $d7e0b3961e984021$var$_collect(iterable) {
    const values = [];
    for await (const value of iterable)values.push(value);
    return values;
}
function $d7e0b3961e984021$export$bb44f104e3c54dae(iterable) {
    if (iterable[Symbol.asyncIterator]) return $d7e0b3961e984021$var$_collect(iterable);
    return Array.from(iterable);
}
async function* $d7e0b3961e984021$var$_concat(iterables) {
    for await (const iterable of iterables)yield* iterable;
}
function* $d7e0b3961e984021$var$_syncConcat(iterables) {
    for (const iterable of iterables)yield* iterable;
}
function $d7e0b3961e984021$export$ee1b3e54f0441b22(...iterables) {
    const hasAnyAsync = iterables.find((itr)=>itr[Symbol.asyncIterator] !== undefined);
    if (hasAnyAsync) return $d7e0b3961e984021$var$_concat(iterables);
    else return $d7e0b3961e984021$var$_syncConcat(iterables);
}
async function $d7e0b3961e984021$var$_consume(iterable) {
    for await (const val of iterable);
}
function $d7e0b3961e984021$export$e11e6a155c5c4d9d(iterable) {
    if (iterable[Symbol.asyncIterator]) return $d7e0b3961e984021$var$_consume(iterable);
    for (const val of iterable);
}
async function* $d7e0b3961e984021$var$_filter(filterFunc, iterable) {
    for await (const data of iterable)if (await filterFunc(data)) yield data;
}
function $d7e0b3961e984021$export$3dea766d36a8935f(filterFunc, iterable) {
    if (iterable === undefined) return (curriedIterable)=>$d7e0b3961e984021$var$_filter(filterFunc, curriedIterable);
    return $d7e0b3961e984021$var$_filter(filterFunc, iterable);
}
async function* $d7e0b3961e984021$export$bffa455ba8c619a6(iterable) {
    for await (const maybeItr of iterable)if (maybeItr && typeof maybeItr !== "string" && (maybeItr[Symbol.iterator] || maybeItr[Symbol.asyncIterator])) yield* $d7e0b3961e984021$export$bffa455ba8c619a6(maybeItr);
    else yield maybeItr;
}
async function* $d7e0b3961e984021$var$_map(func, iterable) {
    for await (const val of iterable)yield await func(val);
}
function $d7e0b3961e984021$export$871de8747c9eaa88(func, iterable) {
    if (iterable === undefined) return (curriedIterable)=>$d7e0b3961e984021$var$_map(func, curriedIterable);
    return $d7e0b3961e984021$var$_map(func, iterable);
}
function $d7e0b3961e984021$export$5b8affa63fc6df16(func, iterable) {
    if (iterable === undefined) return (curriedIterable)=>$d7e0b3961e984021$export$5b8affa63fc6df16(func, curriedIterable);
    return $d7e0b3961e984021$export$3dea766d36a8935f((i)=>i !== undefined && i !== null, $d7e0b3961e984021$export$bffa455ba8c619a6($d7e0b3961e984021$export$871de8747c9eaa88(func, iterable)));
}
function $d7e0b3961e984021$var$_flatTransform(concurrency, func, iterable) {
    const iterator = $d7e0b3961e984021$export$6731da38428a8625(iterable);
    const resultQueue = [];
    const readQueue = [];
    let ended = false;
    let reading = false;
    let inflightCount = 0;
    let lastError = null;
    function fulfillReadQueue() {
        while(readQueue.length > 0 && resultQueue.length > 0){
            const { resolve: resolve } = readQueue.shift();
            const value = resultQueue.shift();
            resolve({
                done: false,
                value: value
            });
        }
        while(readQueue.length > 0 && inflightCount === 0 && ended){
            const { resolve: resolve, reject: reject } = readQueue.shift();
            if (lastError) {
                reject(lastError);
                lastError = null;
            } else resolve({
                done: true,
                value: undefined
            });
        }
    }
    async function fillQueue() {
        if (ended) {
            fulfillReadQueue();
            return;
        }
        if (reading) return;
        if (inflightCount + resultQueue.length >= concurrency) return;
        reading = true;
        inflightCount++;
        try {
            const { done: done, value: value } = await iterator.next();
            if (done) {
                ended = true;
                inflightCount--;
                fulfillReadQueue();
            } else mapAndQueue(value);
        } catch (error) {
            ended = true;
            inflightCount--;
            lastError = error;
            fulfillReadQueue();
        }
        reading = false;
        fillQueue();
    }
    async function mapAndQueue(itrValue) {
        try {
            const value = await func(itrValue);
            if (value && value[Symbol.asyncIterator]) for await (const asyncVal of value)resultQueue.push(asyncVal);
            else resultQueue.push(value);
        } catch (error) {
            ended = true;
            lastError = error;
        }
        inflightCount--;
        fulfillReadQueue();
        fillQueue();
    }
    async function next() {
        if (resultQueue.length === 0) {
            const deferred = $d7e0b3961e984021$var$defer();
            readQueue.push(deferred);
            fillQueue();
            return deferred.promise;
        }
        const value = resultQueue.shift();
        fillQueue();
        return {
            done: false,
            value: value
        };
    }
    const asyncIterableIterator = {
        next: next,
        [Symbol.asyncIterator]: ()=>asyncIterableIterator
    };
    return asyncIterableIterator;
}
function $d7e0b3961e984021$export$43e1ecefc1866db7(concurrency, func, iterable) {
    if (func === undefined) return (curriedFunc, curriedIterable)=>curriedIterable ? $d7e0b3961e984021$export$43e1ecefc1866db7(concurrency, curriedFunc, curriedIterable) : $d7e0b3961e984021$export$43e1ecefc1866db7(concurrency, curriedFunc);
    if (iterable === undefined) return (curriedIterable)=>$d7e0b3961e984021$export$43e1ecefc1866db7(concurrency, func, curriedIterable);
    return $d7e0b3961e984021$export$3dea766d36a8935f((i)=>i !== undefined && i !== null, $d7e0b3961e984021$export$bffa455ba8c619a6($d7e0b3961e984021$var$_flatTransform(concurrency, func, iterable)));
}
async function $d7e0b3961e984021$var$onceReadable(stream) {
    return new Promise((resolve)=>{
        stream.once("readable", ()=>{
            resolve();
        });
    });
}
async function* $d7e0b3961e984021$var$_fromStream(stream) {
    while(true){
        const data = stream.read();
        if (data !== null) {
            yield data;
            continue;
        }
        if (stream._readableState.ended) break;
        await $d7e0b3961e984021$var$onceReadable(stream);
    }
}
function $d7e0b3961e984021$export$2c6bc52bcd2a369b(stream) {
    if (typeof stream[Symbol.asyncIterator] === "function") return stream;
    return $d7e0b3961e984021$var$_fromStream(stream);
}
async function* $d7e0b3961e984021$export$4950aa0f605343fb(...iterables) {
    const sources = new Set(iterables.map($d7e0b3961e984021$export$6731da38428a8625));
    while(sources.size > 0)for (const iterator of sources){
        const nextVal = await iterator.next();
        if (nextVal.done) sources.delete(iterator);
        else yield nextVal.value;
    }
}
function $d7e0b3961e984021$export$43f28b24e1eb8181(firstFn, ...fns) {
    let previousFn = firstFn();
    for (const func of fns)previousFn = func(previousFn);
    return previousFn;
}
async function* $d7e0b3961e984021$var$_parallelMap(concurrency, func, iterable) {
    let transformError = null;
    const wrapFunc = (value)=>({
            value: func(value)
        });
    const stopOnError = async function*(source) {
        for await (const value of source){
            if (transformError) return;
            yield value;
        }
    };
    const output = $d7e0b3961e984021$export$43f28b24e1eb8181(()=>iterable, $d7e0b3961e984021$export$ab1029bcae9ddb4a(1), stopOnError, $d7e0b3961e984021$export$871de8747c9eaa88(wrapFunc), $d7e0b3961e984021$export$ab1029bcae9ddb4a(concurrency - 1));
    const itr = $d7e0b3961e984021$export$6731da38428a8625(output);
    while(true){
        const { value: value, done: done } = await itr.next();
        if (done) break;
        try {
            const val = await value.value;
            if (!transformError) yield val;
        } catch (error) {
            transformError = error;
        }
    }
    if (transformError) throw transformError;
}
function $d7e0b3961e984021$export$1e9f37662951ab82(concurrency, func, iterable) {
    if (func === undefined) return (curriedFunc, curriedIterable)=>$d7e0b3961e984021$export$1e9f37662951ab82(concurrency, curriedFunc, curriedIterable);
    if (iterable === undefined) return (curriedIterable)=>$d7e0b3961e984021$export$1e9f37662951ab82(concurrency, func, curriedIterable);
    if (concurrency === 1) return $d7e0b3961e984021$export$871de8747c9eaa88(func, iterable);
    return $d7e0b3961e984021$var$_parallelMap(concurrency, func, iterable);
}
function $d7e0b3961e984021$export$c5d1f7f641c93ec3(concurrency, func, iterable) {
    if (func === undefined) return (curriedFunc, curriedIterable)=>curriedIterable ? $d7e0b3961e984021$export$c5d1f7f641c93ec3(concurrency, curriedFunc, curriedIterable) : $d7e0b3961e984021$export$c5d1f7f641c93ec3(concurrency, curriedFunc);
    if (iterable === undefined) return (curriedIterable)=>$d7e0b3961e984021$export$c5d1f7f641c93ec3(concurrency, func, curriedIterable);
    return $d7e0b3961e984021$export$3dea766d36a8935f((i)=>i !== undefined && i !== null, $d7e0b3961e984021$export$bffa455ba8c619a6($d7e0b3961e984021$export$1e9f37662951ab82(concurrency, func, iterable)));
}
async function* $d7e0b3961e984021$export$7fe36455f4c1e391(...iterables) {
    const inputs = iterables.map($d7e0b3961e984021$export$6731da38428a8625);
    const concurrentWork = new Set();
    const values = new Map();
    let lastError = null;
    let errCb = null;
    let valueCb = null;
    const notifyError = (err)=>{
        lastError = err;
        if (errCb) errCb(err);
    };
    const notifyDone = (value)=>{
        if (valueCb) valueCb(value);
    };
    const waitForQueue = ()=>new Promise((resolve, reject)=>{
            if (lastError) reject(lastError);
            if (values.size > 0) return resolve();
            valueCb = resolve;
            errCb = reject;
        });
    const queueNext = (input)=>{
        const nextVal = Promise.resolve(input.next()).then(async ({ done: done, value: value })=>{
            if (!done) values.set(input, value);
            concurrentWork.delete(nextVal);
        });
        concurrentWork.add(nextVal);
        nextVal.then(notifyDone, notifyError);
    };
    for (const input of inputs)queueNext(input);
    while(true){
        // We technically don't have to check `values.size` as the for loop should have emptied it
        // However I haven't yet found specs verifying that behavior, only tests
        // the guard in waitForQueue() checking for values is in place for the same reason
        if (concurrentWork.size === 0 && values.size === 0) return;
        await waitForQueue();
        for (const [input, value] of values){
            values.delete(input);
            yield value;
            queueNext(input);
        }
    }
}
async function $d7e0b3961e984021$var$_reduce(func, start, iterable) {
    let value = start;
    for await (const nextItem of iterable)value = await func(value, nextItem);
    return value;
}
function $d7e0b3961e984021$export$533b26079ad0b4b(func, start, iterable) {
    if (start === undefined) return (curriedStart, curriedIterable)=>curriedIterable ? $d7e0b3961e984021$var$_reduce(func, curriedStart, curriedIterable) : $d7e0b3961e984021$export$533b26079ad0b4b(func, curriedStart);
    if (iterable === undefined) return (curriedIterable)=>$d7e0b3961e984021$export$533b26079ad0b4b(func, start, curriedIterable);
    return $d7e0b3961e984021$var$_reduce(func, start, iterable);
}
async function* $d7e0b3961e984021$var$_take(count, iterable) {
    let taken = 0;
    for await (const val of iterable){
        yield await val;
        taken++;
        if (taken >= count) break;
    }
}
function* $d7e0b3961e984021$var$_syncTake(count, iterable) {
    let taken = 0;
    for (const val of iterable){
        yield val;
        taken++;
        if (taken >= count) break;
    }
}
function $d7e0b3961e984021$export$b7df5d561049483a(count, iterable) {
    if (iterable === undefined) return (curriedIterable)=>$d7e0b3961e984021$export$b7df5d561049483a(count, curriedIterable);
    if (iterable[Symbol.asyncIterator]) return $d7e0b3961e984021$var$_take(count, iterable);
    return $d7e0b3961e984021$var$_syncTake(count, iterable);
}
async function* $d7e0b3961e984021$var$_asyncTap(func, iterable) {
    for await (const val of iterable){
        await func(val);
        yield val;
    }
}
function $d7e0b3961e984021$export$3f23594af5f37336(func, iterable) {
    if (iterable === undefined) return (curriedIterable)=>$d7e0b3961e984021$var$_asyncTap(func, curriedIterable);
    return $d7e0b3961e984021$var$_asyncTap(func, iterable);
}
const $d7e0b3961e984021$var$sleep = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
function $d7e0b3961e984021$var$_throttle(limit, interval, iterable) {
    if (!Number.isFinite(limit)) throw new TypeError("Expected `limit` to be a finite number");
    if (limit <= 0) throw new TypeError("Expected `limit` to be greater than 0");
    if (!Number.isFinite(interval)) throw new TypeError("Expected `interval` to be a finite number");
    return async function* __throttle() {
        let sent = 0;
        let time;
        for await (const val of iterable){
            if (sent < limit) {
                if (typeof time === "undefined") time = Date.now();
                sent++;
                yield val;
                continue;
            }
            // Only wait if the interval hasn't already passed while we were
            // yielding the previous values.
            const elapsedMs = Date.now() - time;
            const waitFor = interval - elapsedMs;
            if (waitFor > 0) await $d7e0b3961e984021$var$sleep(waitFor);
            time = Date.now();
            sent = 1;
            yield val;
        }
    }();
}
function $d7e0b3961e984021$export$de363e709c412c8a(limit, interval, iterable) {
    if (iterable === undefined) return (curriedIterable)=>$d7e0b3961e984021$var$_throttle(limit, interval, curriedIterable);
    return $d7e0b3961e984021$var$_throttle(limit, interval, iterable);
}
function $d7e0b3961e984021$var$addTime(a, b) {
    let seconds = a[0] + b[0];
    let nanoseconds = a[1] + b[1];
    if (nanoseconds >= 1000000000) {
        const remainder = nanoseconds % 1000000000;
        seconds += (nanoseconds - remainder) / 1000000000;
        nanoseconds = remainder;
    }
    return [
        seconds,
        nanoseconds
    ];
}
async function* $d7e0b3961e984021$var$_asyncTime(config, iterable) {
    const itr = iterable[Symbol.asyncIterator]();
    let total = [
        0,
        0
    ];
    while(true){
        const start = $bvigH.hrtime();
        const { value: value, done: done } = await itr.next();
        const delta = $bvigH.hrtime(start);
        total = $d7e0b3961e984021$var$addTime(total, delta);
        if (config.progress) config.progress(delta, total);
        if (done) {
            if (config.total) config.total(total);
            return value;
        }
        yield value;
    }
}
function* $d7e0b3961e984021$var$_syncTime(config, iterable) {
    const itr = iterable[Symbol.iterator]();
    let total = [
        0,
        0
    ];
    while(true){
        const start = $bvigH.hrtime();
        const { value: value, done: done } = itr.next();
        const delta = $bvigH.hrtime(start);
        total = $d7e0b3961e984021$var$addTime(total, delta);
        if (config.progress) config.progress(delta, total);
        if (done) {
            if (config.total) config.total(total);
            return value;
        }
        yield value;
    }
}
function $d7e0b3961e984021$export$2da9be4cfdb689b1(config = {}, iterable) {
    if (iterable === undefined) return (curriedIterable)=>$d7e0b3961e984021$export$2da9be4cfdb689b1(config, curriedIterable);
    if (iterable[Symbol.asyncIterator] !== undefined) return $d7e0b3961e984021$var$_asyncTime(config, iterable);
    else return $d7e0b3961e984021$var$_syncTime(config, iterable);
}
function $d7e0b3961e984021$var$_transform(concurrency, func, iterable) {
    const iterator = $d7e0b3961e984021$export$6731da38428a8625(iterable);
    const resultQueue = [];
    const readQueue = [];
    let ended = false;
    let reading = false;
    let inflightCount = 0;
    let lastError = null;
    function fulfillReadQueue() {
        while(readQueue.length > 0 && resultQueue.length > 0){
            const { resolve: resolve } = readQueue.shift();
            const value = resultQueue.shift();
            resolve({
                done: false,
                value: value
            });
        }
        while(readQueue.length > 0 && inflightCount === 0 && ended){
            const { resolve: resolve, reject: reject } = readQueue.shift();
            if (lastError) {
                reject(lastError);
                lastError = null;
            } else resolve({
                done: true,
                value: undefined
            });
        }
    }
    async function fillQueue() {
        if (ended) {
            fulfillReadQueue();
            return;
        }
        if (reading) return;
        if (inflightCount + resultQueue.length >= concurrency) return;
        reading = true;
        inflightCount++;
        try {
            const { done: done, value: value } = await iterator.next();
            if (done) {
                ended = true;
                inflightCount--;
                fulfillReadQueue();
            } else mapAndQueue(value);
        } catch (error) {
            ended = true;
            inflightCount--;
            lastError = error;
            fulfillReadQueue();
        }
        reading = false;
        fillQueue();
    }
    async function mapAndQueue(itrValue) {
        try {
            const value = await func(itrValue);
            resultQueue.push(value);
        } catch (error) {
            ended = true;
            lastError = error;
        }
        inflightCount--;
        fulfillReadQueue();
        fillQueue();
    }
    async function next() {
        if (resultQueue.length === 0) {
            const deferred = $d7e0b3961e984021$var$defer();
            readQueue.push(deferred);
            fillQueue();
            return deferred.promise;
        }
        const value = resultQueue.shift();
        fillQueue();
        return {
            done: false,
            value: value
        };
    }
    const asyncIterableIterator = {
        next: next,
        [Symbol.asyncIterator]: ()=>asyncIterableIterator
    };
    return asyncIterableIterator;
}
function $d7e0b3961e984021$export$51186ad6e864892a(concurrency, func, iterable) {
    if (func === undefined) return (curriedFunc, curriedIterable)=>curriedIterable ? $d7e0b3961e984021$export$51186ad6e864892a(concurrency, curriedFunc, curriedIterable) : $d7e0b3961e984021$export$51186ad6e864892a(concurrency, curriedFunc);
    if (iterable === undefined) return (curriedIterable)=>$d7e0b3961e984021$export$51186ad6e864892a(concurrency, func, curriedIterable);
    return $d7e0b3961e984021$var$_transform(concurrency, func, iterable);
}
async function $d7e0b3961e984021$var$_writeToStream(stream, iterable) {
    let lastError = null;
    let errCb = null;
    let drainCb = null;
    const notifyError = (err)=>{
        lastError = err;
        if (errCb) errCb(err);
    };
    const notifyDrain = ()=>{
        if (drainCb) drainCb();
    };
    const cleanup = ()=>{
        stream.removeListener("error", notifyError);
        stream.removeListener("drain", notifyDrain);
    };
    stream.once("error", notifyError);
    const waitForDrain = ()=>new Promise((resolve, reject)=>{
            if (lastError) return reject(lastError);
            stream.once("drain", notifyDrain);
            drainCb = resolve;
            errCb = reject;
        });
    for await (const value of iterable){
        if (stream.write(value) === false) await waitForDrain();
        if (lastError) break;
    }
    cleanup();
    if (lastError) throw lastError;
}
function $d7e0b3961e984021$export$df92035d47a0b6a3(stream, iterable) {
    if (iterable === undefined) return (curriedIterable)=>$d7e0b3961e984021$var$_writeToStream(stream, curriedIterable);
    return $d7e0b3961e984021$var$_writeToStream(stream, iterable);
}

});

parcelRequire.register("3QBfn", function(module, exports) {
"use strict";

var $4mQs9 = parcelRequire("4mQs9");
/**
 * Creates and returns a Least Recently Used Cache
 *
 * @param {number} maxSize
 * @returns {any}
 */ module.exports = (maxSize)=>{
    // @ts-ignore LRU expression is not callable
    const patched = $4mQs9(maxSize);
    patched.delete = patched.remove;
    return patched;
};

});
parcelRequire.register("4mQs9", function(module, exports) {
module.exports = function(max) {
    if (!max) throw Error("hashlru must have a max value, of type number, greater than 0");
    var size = 0, cache = Object.create(null), _cache = Object.create(null);
    function update(key, value) {
        cache[key] = value;
        size++;
        if (size >= max) {
            size = 0;
            _cache = cache;
            cache = Object.create(null);
        }
    }
    return {
        has: function(key) {
            return cache[key] !== undefined || _cache[key] !== undefined;
        },
        remove: function(key) {
            if (cache[key] !== undefined) cache[key] = undefined;
            if (_cache[key] !== undefined) _cache[key] = undefined;
        },
        get: function(key) {
            var v = cache[key];
            if (v !== undefined) return v;
            if ((v = _cache[key]) !== undefined) {
                update(key, v);
                return v;
            }
        },
        set: function(key, value) {
            if (cache[key] !== undefined) cache[key] = value;
            else update(key, value);
        },
        clear: function() {
            cache = Object.create(null);
            _cache = Object.create(null);
        }
    };
};

});


parcelRequire.register("fREKj", function(module, exports) {
// @ts-nocheck
"use strict";

var $7QXK1 = parcelRequire("7QXK1");
var $b8cb698d13982087$require$EventEmitter = $7QXK1.EventEmitter;

var $ic5c2 = parcelRequire("ic5c2");
var $b8cb698d13982087$require$Big = $ic5c2.BigNumber;

var $3RdyD = parcelRequire("3RdyD");

var $fOCk5 = parcelRequire("fOCk5");
/**
 * @typedef {import('@vascosantos/moving-average').IMovingAverage} IMovingAverage
 * @typedef {import('bignumber.js').BigNumber} Big
 */ class $b8cb698d13982087$var$Stats extends $b8cb698d13982087$require$EventEmitter {
    /**
   * A queue based manager for stat processing
   *
   * @class
   * @param {string[]} initialCounters
   * @param {any} options
   */ constructor(initialCounters, options){
        super();
        this._options = options;
        this._queue = [];
        /** @type {{ dataReceived: Big, dataSent: Big }} */ this._stats = {
            dataReceived: $b8cb698d13982087$require$Big(0),
            dataSent: $b8cb698d13982087$require$Big(0)
        };
        this._frequencyLastTime = Date.now();
        this._frequencyAccumulators = {};
        /** @type {{ dataReceived: IMovingAverage[], dataSent: IMovingAverage[] }} */ this._movingAverages = {};
        this._update = this._update.bind(this);
        const intervals = this._options.movingAverageIntervals;
        for(let i = 0; i < initialCounters.length; i++){
            const key = initialCounters[i];
            this._stats[key] = $b8cb698d13982087$require$Big(0);
            this._movingAverages[key] = {};
            for(let k = 0; k < intervals.length; k++){
                const interval = intervals[k];
                const ma = this._movingAverages[key][interval] = $3RdyD(interval);
                ma.push(this._frequencyLastTime, 0);
            }
        }
    }
    /**
   * Initializes the internal timer if there are items in the queue. This
   * should only need to be called if `Stats.stop` was previously called, as
   * `Stats.push` will also start the processing.
   *
   * @returns {void}
   */ start() {
        if (this._queue.length) this._resetComputeTimeout();
    }
    /**
   * Stops processing and computing of stats by clearing the internal
   * timer.
   *
   * @returns {void}
   */ stop() {
        if (this._timeout) {
            this._timeout.clear();
            this._timeout = null;
        }
    }
    /**
   * Returns a clone of the current stats.
   */ get snapshot() {
        return Object.assign({}, this._stats);
    }
    /**
   * Returns a clone of the internal movingAverages
   */ get movingAverages() {
        return Object.assign({}, this._movingAverages);
    }
    /**
   * Returns a plain JSON object of the stats
   *
   * @returns {*}
   */ toJSON() {
        const snapshot = this.snapshot;
        const movingAverages = this.movingAverages;
        const data = {
            dataReceived: snapshot.dataReceived.toString(),
            dataSent: snapshot.dataSent.toString(),
            movingAverages: {}
        };
        const counters = Object.keys(movingAverages);
        for (const key of counters){
            data.movingAverages[key] = {};
            for (const interval of Object.keys(movingAverages[key]))data.movingAverages[key][interval] = movingAverages[key][interval].movingAverage();
        }
        return data;
    }
    /**
   * Pushes the given operation data to the queue, along with the
   * current Timestamp, then resets the update timer.
   *
   * @param {string} counter
   * @param {number} inc
   * @returns {void}
   */ push(counter, inc) {
        this._queue.push([
            counter,
            inc,
            Date.now()
        ]);
        this._resetComputeTimeout();
    }
    /**
   * Resets the timeout for triggering updates.
   *
   * @private
   * @returns {void}
   */ _resetComputeTimeout() {
        this._timeout = $fOCk5(this._update, this._nextTimeout());
    }
    /**
   * Calculates and returns the timeout for the next update based on
   * the urgency of the update.
   *
   * @private
   * @returns {number}
   */ _nextTimeout() {
        // calculate the need for an update, depending on the queue length
        const urgency = this._queue.length / this._options.computeThrottleMaxQueueSize;
        const timeout = Math.max(this._options.computeThrottleTimeout * (1 - urgency), 0);
        return timeout;
    }
    /**
   * If there are items in the queue, they will will be processed and
   * the frequency for all items will be updated based on the Timestamp
   * of the last item in the queue. The `update` event will also be emitted
   * with the latest stats.
   *
   * If there are no items in the queue, no action is taken.
   *
   * @private
   * @returns {void}
   */ _update() {
        this._timeout = null;
        if (this._queue.length) {
            let last;
            for (last of this._queue)this._applyOp(last);
            this._queue = [];
            this._updateFrequency(last[2]) // contains timestamp of last op
            ;
            this.emit("update", this._stats);
        }
    }
    /**
   * For each key in the stats, the frequency and moving averages
   * will be updated via Stats._updateFrequencyFor based on the time
   * difference between calls to this method.
   *
   * @private
   * @param {Timestamp} latestTime
   * @returns {void}
   */ _updateFrequency(latestTime) {
        const timeDiff = latestTime - this._frequencyLastTime;
        Object.keys(this._stats).forEach((key)=>{
            this._updateFrequencyFor(key, timeDiff, latestTime);
        });
        this._frequencyLastTime = latestTime;
    }
    /**
   * Updates the `movingAverages` for the given `key` and also
   * resets the `frequencyAccumulator` for the `key`.
   *
   * @private
   * @param {string} key
   * @param {number} timeDiffMS - Time in milliseconds
   * @param {Timestamp} latestTime - Time in ticks
   * @returns {void}
   */ _updateFrequencyFor(key, timeDiffMS, latestTime) {
        const count = this._frequencyAccumulators[key] || 0;
        this._frequencyAccumulators[key] = 0;
        // if `timeDiff` is zero, `hz` becomes Infinity, so we fallback to 1ms
        const safeTimeDiff = timeDiffMS || 1;
        const hz = count / safeTimeDiff * 1000;
        let movingAverages = this._movingAverages[key];
        if (!movingAverages) movingAverages = this._movingAverages[key] = {};
        const intervals = this._options.movingAverageIntervals;
        for(let i = 0; i < intervals.length; i++){
            const movingAverageInterval = intervals[i];
            let movingAverage = movingAverages[movingAverageInterval];
            if (!movingAverage) movingAverage = movingAverages[movingAverageInterval] = $3RdyD(movingAverageInterval);
            movingAverage.push(latestTime, hz);
        }
    }
    /**
   * For the given operation, `op`, the stats and `frequencyAccumulator`
   * will be updated or initialized if they don't already exist.
   *
   * @private
   * @param {{string, number}[]} op
   * @throws {InvalidNumber}
   * @returns {void}
   */ _applyOp(op) {
        const key = op[0];
        const inc = op[1];
        if (typeof inc !== "number") throw new Error(`invalid increment number: ${inc}`);
        let n;
        if (!Object.prototype.hasOwnProperty.call(this._stats, key)) n = this._stats[key] = $b8cb698d13982087$require$Big(0);
        else n = this._stats[key];
        this._stats[key] = n.plus(inc);
        if (!this._frequencyAccumulators[key]) this._frequencyAccumulators[key] = 0;
        this._frequencyAccumulators[key] += inc;
    }
}
module.exports = $b8cb698d13982087$var$Stats;

});
parcelRequire.register("ic5c2", function(module, exports) {
(function(globalObject) {
    "use strict";
    /*
 *      bignumber.js v9.3.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            suffix: ""
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == "number") && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == "number") {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == "[object Array]") {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + "Invalid BigNumber: " + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // The index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne + (id === 2 && e > ne);
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "5e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == "object") {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == "object") {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != "object") throw Error(bignumberError + "Argument not an object: " + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
            }
            return (format.prefix || "") + str + (format.suffix || "");
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, "0");
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, "0");
                } else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(module.exports);

});

parcelRequire.register("3RdyD", function(module, exports) {
"use strict";
const exp = Math.exp;
exports = module.exports = function MovingAverage(timespan) {
    if (typeof timespan !== "number") throw new Error("must provide a timespan to the moving average constructor");
    if (timespan <= 0) throw new Error("must provide a timespan > 0 to the moving average constructor");
    let ma // moving average
    ;
    let v = 0 // variance
    ;
    let d = 0 // deviation
    ;
    let f = 0 // forecast
    ;
    let previousTime;
    let ret = {};
    function alpha(t, pt) {
        return 1 - exp(-(t - pt) / timespan);
    }
    ret.push = function push(time, value) {
        if (previousTime) {
            // calculate moving average
            const a = alpha(time, previousTime);
            const diff = value - ma;
            const incr = a * diff;
            ma = a * value + (1 - a) * ma;
            // calculate variance & deviation
            v = (1 - a) * (v + diff * incr);
            d = Math.sqrt(v);
            // calculate forecast
            f = ma + a * diff;
        } else ma = value;
        previousTime = time;
    };
    // Exponential Moving Average
    ret.movingAverage = function movingAverage() {
        return ma;
    };
    // Variance
    ret.variance = function variance() {
        return v;
    };
    ret.deviation = function deviation() {
        return d;
    };
    ret.forecast = function forecast() {
        return f;
    };
    return ret;
};

});



parcelRequire.register("h4D4e", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $c6e11d5a985737ce$var$log = Object.assign($jjmHV("libp2p:upgrader"), {
    error: $jjmHV("libp2p:upgrader:err")
});

var $20Lm5 = parcelRequire("20Lm5");

var $jN1oI = parcelRequire("jN1oI");

var $4n6xN = parcelRequire("4n6xN");
var $c6e11d5a985737ce$require$Connection = $4n6xN.Connection;

var $ksmXv = parcelRequire("ksmXv");

var $d8Blz = parcelRequire("d8Blz");
var $c6e11d5a985737ce$require$pipe = $d8Blz.pipe;

var $hAzSc = parcelRequire("hAzSc");

var $8yAh4 = parcelRequire("8yAh4");
var $c6e11d5a985737ce$require$codes = $8yAh4.codes;
/**
 * @typedef {import('libp2p-interfaces/src/transport/types').MultiaddrConnection} MultiaddrConnection
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxerFactory} MuxerFactory
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').Muxer} Muxer
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxedStream} MuxedStream
 * @typedef {import('libp2p-interfaces/src/crypto/types').Crypto} Crypto
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 */ /**
 * @typedef CryptoResult
 * @property {MultiaddrConnection} conn A duplex iterable
 * @property {PeerId} remotePeer
 * @property {string} protocol
 */ class $c6e11d5a985737ce$var$Upgrader {
    /**
   * @param {object} options
   * @param {PeerId} options.localPeer
   * @param {import('./metrics')} [options.metrics]
   * @param {Map<string, Crypto>} [options.cryptos]
   * @param {Map<string, MuxerFactory>} [options.muxers]
   * @param {(connection: Connection) => void} options.onConnection - Called when a connection is upgraded
   * @param {(connection: Connection) => void} options.onConnectionEnd
   */ constructor({ localPeer: localPeer, metrics: metrics, cryptos: cryptos = new Map(), muxers: muxers = new Map(), onConnectionEnd: onConnectionEnd = ()=>{}, onConnection: onConnection = ()=>{} }){
        this.localPeer = localPeer;
        this.metrics = metrics;
        this.cryptos = cryptos;
        this.muxers = muxers;
        /** @type {import("./pnet") | null} */ this.protector = null;
        this.protocols = new Map();
        this.onConnection = onConnection;
        this.onConnectionEnd = onConnectionEnd;
    }
    /**
   * Upgrades an inbound connection
   *
   * @async
   * @param {MultiaddrConnection} maConn
   * @returns {Promise<Connection>}
   */ async upgradeInbound(maConn) {
        let encryptedConn;
        let remotePeer;
        let upgradedConn;
        let Muxer;
        let cryptoProtocol;
        let setPeer;
        let proxyPeer;
        if (this.metrics) {
            ({ setTarget: setPeer, proxy: proxyPeer } = $hAzSc());
            const idString = (Math.random() * 1e9).toString(36) + Date.now();
            setPeer({
                toB58String: ()=>idString
            });
            maConn = this.metrics.trackStream({
                stream: maConn,
                remotePeer: proxyPeer
            });
        }
        $c6e11d5a985737ce$var$log("Starting the inbound connection upgrade");
        // Protect
        let protectedConn = maConn;
        if (this.protector) protectedConn = await this.protector.protect(maConn);
        try {
            // Encrypt the connection
            ({ conn: encryptedConn, remotePeer: remotePeer, protocol: cryptoProtocol } = await this._encryptInbound(this.localPeer, protectedConn, this.cryptos));
            // Multiplex the connection
            if (this.muxers.size) ({ stream: upgradedConn, Muxer: Muxer } = await this._multiplexInbound(encryptedConn, this.muxers));
            else upgradedConn = encryptedConn;
        } catch (/** @type {any} */ err) {
            $c6e11d5a985737ce$var$log.error("Failed to upgrade inbound connection", err);
            await maConn.close(err);
            throw err;
        }
        if (this.metrics) {
            this.metrics.updatePlaceholder(proxyPeer, remotePeer);
            setPeer(remotePeer);
        }
        $c6e11d5a985737ce$var$log("Successfully upgraded inbound connection");
        return this._createConnection({
            cryptoProtocol: cryptoProtocol,
            direction: "inbound",
            maConn: maConn,
            upgradedConn: upgradedConn,
            Muxer: Muxer,
            remotePeer: remotePeer
        });
    }
    /**
   * Upgrades an outbound connection
   *
   * @async
   * @param {MultiaddrConnection} maConn
   * @returns {Promise<Connection>}
   */ async upgradeOutbound(maConn) {
        const idStr = maConn.remoteAddr.getPeerId();
        if (!idStr) throw $20Lm5(new Error("outbound connection must have a peer id"), $c6e11d5a985737ce$require$codes.ERR_INVALID_MULTIADDR);
        const remotePeerId = $ksmXv.createFromB58String(idStr);
        let encryptedConn;
        let remotePeer;
        let upgradedConn;
        let cryptoProtocol;
        let Muxer;
        let setPeer;
        let proxyPeer;
        if (this.metrics) {
            ({ setTarget: setPeer, proxy: proxyPeer } = $hAzSc());
            const idString = (Math.random() * 1e9).toString(36) + Date.now();
            setPeer({
                toB58String: ()=>idString
            });
            maConn = this.metrics.trackStream({
                stream: maConn,
                remotePeer: proxyPeer
            });
        }
        $c6e11d5a985737ce$var$log("Starting the outbound connection upgrade");
        // Protect
        let protectedConn = maConn;
        if (this.protector) protectedConn = await this.protector.protect(maConn);
        try {
            // Encrypt the connection
            ({ conn: encryptedConn, remotePeer: remotePeer, protocol: cryptoProtocol } = await this._encryptOutbound(this.localPeer, protectedConn, remotePeerId, this.cryptos));
            // Multiplex the connection
            if (this.muxers.size) ({ stream: upgradedConn, Muxer: Muxer } = await this._multiplexOutbound(encryptedConn, this.muxers));
            else upgradedConn = encryptedConn;
        } catch (/** @type {any} */ err) {
            $c6e11d5a985737ce$var$log.error("Failed to upgrade outbound connection", err);
            await maConn.close(err);
            throw err;
        }
        if (this.metrics) {
            this.metrics.updatePlaceholder(proxyPeer, remotePeer);
            setPeer(remotePeer);
        }
        $c6e11d5a985737ce$var$log("Successfully upgraded outbound connection");
        return this._createConnection({
            cryptoProtocol: cryptoProtocol,
            direction: "outbound",
            maConn: maConn,
            upgradedConn: upgradedConn,
            Muxer: Muxer,
            remotePeer: remotePeer
        });
    }
    /**
   * A convenience method for generating a new `Connection`
   *
   * @private
   * @param {object} options
   * @param {string} options.cryptoProtocol - The crypto protocol that was negotiated
   * @param {'inbound' | 'outbound'} options.direction - One of ['inbound', 'outbound']
   * @param {MultiaddrConnection} options.maConn - The transport layer connection
   * @param {MuxedStream | MultiaddrConnection} options.upgradedConn - A duplex connection returned from multiplexer and/or crypto selection
   * @param {MuxerFactory} [options.Muxer] - The muxer to be used for muxing
   * @param {PeerId} options.remotePeer - The peer the connection is with
   * @returns {Connection}
   */ _createConnection({ cryptoProtocol: cryptoProtocol, direction: direction, maConn: maConn, upgradedConn: upgradedConn, Muxer: Muxer, remotePeer: remotePeer }) {
        /** @type {import("libp2p-interfaces/src/stream-muxer/types").Muxer} */ let muxer;
        /** @type {import("libp2p-interfaces/src/connection/connection").CreatedMuxedStream | undefined} */ let newStream;
        /** @type {Connection} */ let connection // eslint-disable-line prefer-const
        ;
        if (Muxer) {
            // Create the muxer
            muxer = new Muxer({
                // Run anytime a remote stream is created
                onStream: async (muxedStream)=>{
                    if (!connection) return;
                    const mss = new $jN1oI.Listener(muxedStream);
                    try {
                        const { stream: stream, protocol: protocol } = await mss.handle(Array.from(this.protocols.keys()));
                        $c6e11d5a985737ce$var$log("%s: incoming stream opened on %s", direction, protocol);
                        if (this.metrics) this.metrics.trackStream({
                            stream: stream,
                            remotePeer: remotePeer,
                            protocol: protocol
                        });
                        connection.addStream(muxedStream, {
                            protocol: protocol
                        });
                        this._onStream({
                            connection: connection,
                            stream: {
                                ...muxedStream,
                                ...stream
                            },
                            protocol: protocol
                        });
                    } catch (/** @type {any} */ err) {
                        $c6e11d5a985737ce$var$log.error(err);
                    }
                },
                // Run anytime a stream closes
                onStreamEnd: (muxedStream)=>{
                    connection.removeStream(muxedStream.id);
                }
            });
            newStream = async (protocols)=>{
                $c6e11d5a985737ce$var$log("%s: starting new stream on %s", direction, protocols);
                const muxedStream = muxer.newStream();
                const mss = new $jN1oI.Dialer(muxedStream);
                try {
                    const { stream: stream, protocol: protocol } = await mss.select(protocols);
                    if (this.metrics) this.metrics.trackStream({
                        stream: stream,
                        remotePeer: remotePeer,
                        protocol: protocol
                    });
                    return {
                        stream: {
                            ...muxedStream,
                            ...stream
                        },
                        protocol: protocol
                    };
                } catch (/** @type {any} */ err) {
                    $c6e11d5a985737ce$var$log.error("could not create new stream", err);
                    throw $20Lm5(err, $c6e11d5a985737ce$require$codes.ERR_UNSUPPORTED_PROTOCOL);
                }
            };
            // Pipe all data through the muxer
            $c6e11d5a985737ce$require$pipe(upgradedConn, muxer, upgradedConn).catch($c6e11d5a985737ce$var$log.error);
        }
        const _timeline = maConn.timeline;
        maConn.timeline = new Proxy(_timeline, {
            set: (...args)=>{
                if (connection && args[1] === "close" && args[2] && !_timeline.close) // Wait for close to finish before notifying of the closure
                (async ()=>{
                    try {
                        if (connection.stat.status === "open") await connection.close();
                    } catch (/** @type {any} */ err) {
                        $c6e11d5a985737ce$var$log.error(err);
                    } finally{
                        this.onConnectionEnd(connection);
                    }
                })();
                return Reflect.set(...args);
            }
        });
        maConn.timeline.upgraded = Date.now();
        const errConnectionNotMultiplexed = ()=>{
            throw $20Lm5(new Error("connection is not multiplexed"), $c6e11d5a985737ce$require$codes.ERR_CONNECTION_NOT_MULTIPLEXED);
        };
        // Create the connection
        connection = new $c6e11d5a985737ce$require$Connection({
            localAddr: maConn.localAddr,
            remoteAddr: maConn.remoteAddr,
            localPeer: this.localPeer,
            remotePeer: remotePeer,
            stat: {
                direction: direction,
                // @ts-ignore
                timeline: maConn.timeline,
                multiplexer: Muxer && Muxer.multicodec,
                encryption: cryptoProtocol
            },
            newStream: newStream || errConnectionNotMultiplexed,
            getStreams: ()=>muxer ? muxer.streams : errConnectionNotMultiplexed(),
            close: async ()=>{
                await maConn.close();
                // Ensure remaining streams are aborted
                if (muxer) muxer.streams.map((stream)=>stream.abort());
            }
        });
        this.onConnection(connection);
        return connection;
    }
    /**
   * Routes incoming streams to the correct handler
   *
   * @private
   * @param {object} options
   * @param {Connection} options.connection - The connection the stream belongs to
   * @param {MuxedStream} options.stream
   * @param {string} options.protocol
   */ _onStream({ connection: connection, stream: stream, protocol: protocol }) {
        const handler = this.protocols.get(protocol);
        handler({
            connection: connection,
            stream: stream,
            protocol: protocol
        });
    }
    /**
   * Attempts to encrypt the incoming `connection` with the provided `cryptos`.
   *
   * @private
   * @async
   * @param {PeerId} localPeer - The initiators PeerId
   * @param {*} connection
   * @param {Map<string, Crypto>} cryptos
   * @returns {Promise<CryptoResult>} An encrypted connection, remote peer `PeerId` and the protocol of the `Crypto` used
   */ async _encryptInbound(localPeer, connection, cryptos) {
        const mss = new $jN1oI.Listener(connection);
        const protocols = Array.from(cryptos.keys());
        $c6e11d5a985737ce$var$log("handling inbound crypto protocol selection", protocols);
        try {
            const { stream: stream, protocol: protocol } = await mss.handle(protocols);
            const crypto = cryptos.get(protocol);
            $c6e11d5a985737ce$var$log("encrypting inbound connection...");
            if (!crypto) throw new Error(`no crypto module found for ${protocol}`);
            return {
                ...await crypto.secureInbound(localPeer, stream),
                protocol: protocol
            };
        } catch (/** @type {any} */ err) {
            throw $20Lm5(err, $c6e11d5a985737ce$require$codes.ERR_ENCRYPTION_FAILED);
        }
    }
    /**
   * Attempts to encrypt the given `connection` with the provided `cryptos`.
   * The first `Crypto` module to succeed will be used
   *
   * @private
   * @async
   * @param {PeerId} localPeer - The initiators PeerId
   * @param {MultiaddrConnection} connection
   * @param {PeerId} remotePeerId
   * @param {Map<string, Crypto>} cryptos
   * @returns {Promise<CryptoResult>} An encrypted connection, remote peer `PeerId` and the protocol of the `Crypto` used
   */ async _encryptOutbound(localPeer, connection, remotePeerId, cryptos) {
        const mss = new $jN1oI.Dialer(connection);
        const protocols = Array.from(cryptos.keys());
        $c6e11d5a985737ce$var$log("selecting outbound crypto protocol", protocols);
        try {
            const { stream: stream, protocol: protocol } = await mss.select(protocols);
            const crypto = cryptos.get(protocol);
            $c6e11d5a985737ce$var$log("encrypting outbound connection to %j", remotePeerId);
            if (!crypto) throw new Error(`no crypto module found for ${protocol}`);
            return {
                ...await crypto.secureOutbound(localPeer, stream, remotePeerId),
                protocol: protocol
            };
        } catch (/** @type {any} */ err) {
            throw $20Lm5(err, $c6e11d5a985737ce$require$codes.ERR_ENCRYPTION_FAILED);
        }
    }
    /**
   * Selects one of the given muxers via multistream-select. That
   * muxer will be used for all future streams on the connection.
   *
   * @private
   * @async
   * @param {MultiaddrConnection} connection - A basic duplex connection to multiplex
   * @param {Map<string, MuxerFactory>} muxers - The muxers to attempt multiplexing with
   * @returns {Promise<{ stream: MuxedStream, Muxer?: MuxerFactory}>} A muxed connection
   */ async _multiplexOutbound(connection, muxers) {
        const dialer = new $jN1oI.Dialer(connection);
        const protocols = Array.from(muxers.keys());
        $c6e11d5a985737ce$var$log("outbound selecting muxer %s", protocols);
        try {
            const { stream: stream, protocol: protocol } = await dialer.select(protocols);
            $c6e11d5a985737ce$var$log("%s selected as muxer protocol", protocol);
            const Muxer = muxers.get(protocol);
            return {
                stream: stream,
                Muxer: Muxer
            };
        } catch (/** @type {any} */ err) {
            throw $20Lm5(err, $c6e11d5a985737ce$require$codes.ERR_MUXER_UNAVAILABLE);
        }
    }
    /**
   * Registers support for one of the given muxers via multistream-select. The
   * selected muxer will be used for all future streams on the connection.
   *
   * @private
   * @async
   * @param {MultiaddrConnection} connection - A basic duplex connection to multiplex
   * @param {Map<string, MuxerFactory>} muxers - The muxers to attempt multiplexing with
   * @returns {Promise<{ stream: MuxedStream, Muxer?: MuxerFactory}>} A muxed connection
   */ async _multiplexInbound(connection, muxers) {
        const listener = new $jN1oI.Listener(connection);
        const protocols = Array.from(muxers.keys());
        $c6e11d5a985737ce$var$log("inbound handling muxers %s", protocols);
        try {
            const { stream: stream, protocol: protocol } = await listener.handle(protocols);
            const Muxer = muxers.get(protocol);
            return {
                stream: stream,
                Muxer: Muxer
            };
        } catch (/** @type {any} */ err) {
            throw $20Lm5(err, $c6e11d5a985737ce$require$codes.ERR_MUXER_UNAVAILABLE);
        }
    }
}
module.exports = $c6e11d5a985737ce$var$Upgrader;

});
parcelRequire.register("jN1oI", function(module, exports) {

$parcel$export(module.exports, "Dialer", () => $e683ad720f3eace9$export$955ebc673ddb181b, (v) => $e683ad720f3eace9$export$955ebc673ddb181b = v);
$parcel$export(module.exports, "Listener", () => $e683ad720f3eace9$export$c92b1d5f43586026, (v) => $e683ad720f3eace9$export$c92b1d5f43586026 = v);
var $e683ad720f3eace9$export$43182d2709f4c8de;
var $e683ad720f3eace9$export$955ebc673ddb181b;
var $e683ad720f3eace9$export$c92b1d5f43586026;
"use strict";

var $hZFaa = parcelRequire("hZFaa");

var $StHbg = parcelRequire("StHbg");

var $4VxS3 = parcelRequire("4VxS3");

var $ajAm5 = parcelRequire("ajAm5");
var $e683ad720f3eace9$require$PROTOCOL_ID = $ajAm5.PROTOCOL_ID;
$e683ad720f3eace9$export$43182d2709f4c8de = $e683ad720f3eace9$require$PROTOCOL_ID;
class $e683ad720f3eace9$var$MultistreamSelect {
    constructor(stream){
        this._stream = stream;
        this._shaken = false;
    }
    // Perform the multistream-select handshake
    async _handshake() {
        if (this._shaken) return;
        const { stream: stream } = await $hZFaa(this._stream, $e683ad720f3eace9$require$PROTOCOL_ID);
        this._stream = stream;
        this._shaken = true;
    }
}
class $e683ad720f3eace9$var$Dialer extends $e683ad720f3eace9$var$MultistreamSelect {
    select(protocols) {
        return $hZFaa(this._stream, protocols, this._shaken ? null : $e683ad720f3eace9$require$PROTOCOL_ID);
    }
    async ls() {
        await this._handshake();
        const { stream: stream, protocols: protocols } = await $4VxS3(this._stream);
        this._stream = stream;
        return protocols;
    }
}
$e683ad720f3eace9$export$955ebc673ddb181b = $e683ad720f3eace9$var$Dialer;
class $e683ad720f3eace9$var$Listener extends $e683ad720f3eace9$var$MultistreamSelect {
    handle(protocols) {
        return $StHbg(this._stream, protocols);
    }
}
$e683ad720f3eace9$export$c92b1d5f43586026 = $e683ad720f3eace9$var$Listener;

});
parcelRequire.register("hZFaa", function(module, exports) {
"use strict";

const $d1981047af135542$var$log = (parcelRequire("jjmHV"))("mss:select");

var $20Lm5 = parcelRequire("20Lm5");

var $ehYYX = parcelRequire("ehYYX");

var $l2xaW = parcelRequire("l2xaW");
module.exports = async (stream, protocols, protocolId)=>{
    protocols = Array.isArray(protocols) ? [
        ...protocols
    ] : [
        protocols
    ];
    const { reader: reader, writer: writer, rest: rest, stream: shakeStream } = $l2xaW(stream);
    const protocol = protocols.shift();
    if (protocolId) {
        $d1981047af135542$var$log('select: write ["%s", "%s"]', protocolId, protocol);
        $ehYYX.writeAll(writer, [
            protocolId,
            protocol
        ]);
    } else {
        $d1981047af135542$var$log('select: write "%s"', protocol);
        $ehYYX.write(writer, protocol);
    }
    let response = (await $ehYYX.read(reader)).toString();
    $d1981047af135542$var$log('select: read "%s"', response);
    // Read the protocol response if we got the protocolId in return
    if (response === protocolId) {
        response = (await $ehYYX.read(reader)).toString();
        $d1981047af135542$var$log('select: read "%s"', response);
    }
    // We're done
    if (response === protocol) {
        rest();
        return {
            stream: shakeStream,
            protocol: protocol
        };
    }
    // We haven't gotten a valid ack, try the other protocols
    for (const protocol of protocols){
        $d1981047af135542$var$log('select: write "%s"', protocol);
        $ehYYX.write(writer, protocol);
        const response = (await $ehYYX.read(reader)).toString();
        $d1981047af135542$var$log('select: read "%s" for "%s"', response, protocol);
        if (response === protocol) {
            rest() // End our writer so others can start writing to stream
            ;
            return {
                stream: shakeStream,
                protocol: protocol
            };
        }
    }
    rest();
    throw $20Lm5(new Error("protocol selection failed"), "ERR_UNSUPPORTED_PROTOCOL");
};

});
parcelRequire.register("ehYYX", function(module, exports) {

$parcel$export(module.exports, "encode", () => $a671f501f885763b$export$c564cdbbe6da493, (v) => $a671f501f885763b$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "write", () => $a671f501f885763b$export$68d8715fc104d294, (v) => $a671f501f885763b$export$68d8715fc104d294 = v);
$parcel$export(module.exports, "writeAll", () => $a671f501f885763b$export$614ce64472726291, (v) => $a671f501f885763b$export$614ce64472726291 = v);
$parcel$export(module.exports, "read", () => $a671f501f885763b$export$aafa59e2e03f2942, (v) => $a671f501f885763b$export$aafa59e2e03f2942 = v);
var $a671f501f885763b$export$c564cdbbe6da493;
// `write` encodes and writes a single buffer
var $a671f501f885763b$export$68d8715fc104d294;
// `writeAll` behaves like `write`, except it encodes an array of items as a single write
var $a671f501f885763b$export$614ce64472726291;
var $a671f501f885763b$export$aafa59e2e03f2942;
"use strict";

var $hG3ux = parcelRequire("hG3ux");

var $4zeIG = parcelRequire("4zeIG");

var $d8Blz = parcelRequire("d8Blz");

var $20Lm5 = parcelRequire("20Lm5");

var $8cWjP = parcelRequire("8cWjP");
var $a671f501f885763b$require$uint8ArrayFromString = $8cWjP.fromString;

var $5UoOr = parcelRequire("5UoOr");
const $a671f501f885763b$var$NewLine = $a671f501f885763b$require$uint8ArrayFromString("\n");
$a671f501f885763b$export$c564cdbbe6da493 = (buffer)=>$4zeIG.encode.single(new $hG3ux([
        buffer,
        $a671f501f885763b$var$NewLine
    ]));
$a671f501f885763b$export$68d8715fc104d294 = (writer, buffer)=>writer.push($a671f501f885763b$export$c564cdbbe6da493(buffer));
$a671f501f885763b$export$614ce64472726291 = (writer, buffers)=>{
    writer.push(buffers.reduce((bl, buffer)=>bl.append($a671f501f885763b$export$c564cdbbe6da493(buffer)), new $hG3ux()));
};
$a671f501f885763b$export$aafa59e2e03f2942 = async (reader)=>{
    let byteLength = 1 // Read single byte chunks until the length is known
    ;
    const varByteSource = {
        [Symbol.asyncIterator] () {
            return this;
        },
        next: ()=>reader.next(byteLength)
    };
    // Once the length has been parsed, read chunk for that length
    const onLength = (l)=>{
        byteLength = l;
    };
    const buf = await $d8Blz(varByteSource, $4zeIG.decode({
        onLength: onLength
    }), $5UoOr);
    if (buf.get(buf.length - 1) !== $a671f501f885763b$var$NewLine[0]) throw $20Lm5(new Error("missing newline"), "ERR_INVALID_MULTISTREAM_SELECT_MESSAGE");
    return buf.shallowSlice(0, -1) // Remove newline
    ;
};

});


parcelRequire.register("StHbg", function(module, exports) {
"use strict";

const $0a3c14293271e5be$var$log = (parcelRequire("jjmHV"))("mss:handle");

var $hG3ux = parcelRequire("hG3ux");

var $ehYYX = parcelRequire("ehYYX");

var $l2xaW = parcelRequire("l2xaW");

var $ajAm5 = parcelRequire("ajAm5");
var $0a3c14293271e5be$require$PROTOCOL_ID = $ajAm5.PROTOCOL_ID;
module.exports = async (stream, protocols)=>{
    protocols = Array.isArray(protocols) ? protocols : [
        protocols
    ];
    const { writer: writer, reader: reader, rest: rest, stream: shakeStream } = $l2xaW(stream);
    while(true){
        const protocol = (await $ehYYX.read(reader)).toString();
        $0a3c14293271e5be$var$log('read "%s"', protocol);
        if (protocol === $0a3c14293271e5be$require$PROTOCOL_ID) {
            $0a3c14293271e5be$var$log('respond with "%s" for "%s"', $0a3c14293271e5be$require$PROTOCOL_ID, protocol);
            $ehYYX.write(writer, $0a3c14293271e5be$require$PROTOCOL_ID);
            continue;
        }
        if (protocols.includes(protocol)) {
            $ehYYX.write(writer, protocol);
            $0a3c14293271e5be$var$log('respond with "%s" for "%s"', protocol, protocol);
            rest();
            return {
                stream: shakeStream,
                protocol: protocol
            };
        }
        if (protocol === "ls") {
            // <varint-msg-len><varint-proto-name-len><proto-name>\n<varint-proto-name-len><proto-name>\n\n
            $ehYYX.write(writer, new $hG3ux(protocols.map((p)=>$ehYYX.encode(p))));
            $0a3c14293271e5be$var$log('respond with "%s" for %s', protocols, protocol);
            continue;
        }
        $ehYYX.write(writer, "na");
        $0a3c14293271e5be$var$log('respond with "na" for "%s"', protocol);
    }
};

});
parcelRequire.register("ajAm5", function(module, exports) {

$parcel$export(module.exports, "PROTOCOL_ID", () => $7827e1223ce91db0$export$43182d2709f4c8de, (v) => $7827e1223ce91db0$export$43182d2709f4c8de = v);
var $7827e1223ce91db0$export$43182d2709f4c8de;
"use strict";
$7827e1223ce91db0$export$43182d2709f4c8de = "/multistream/1.0.0";

});


parcelRequire.register("4VxS3", function(module, exports) {
"use strict";

var $hO1wl = parcelRequire("hO1wl");

const $3966c25580f4af5a$var$log = (parcelRequire("jjmHV"))("it-multistream-select:ls");

var $ehYYX = parcelRequire("ehYYX");

var $l2xaW = parcelRequire("l2xaW");

var $4zeIG = parcelRequire("4zeIG");

var $d8Blz = parcelRequire("d8Blz");
module.exports = async (stream)=>{
    const { reader: reader, writer: writer, rest: rest, stream: shakeStream } = $l2xaW(stream);
    $3966c25580f4af5a$var$log('write "ls"');
    $ehYYX.write(writer, "ls");
    rest();
    // Next message from remote will be (e.g. for 2 protocols):
    // <varint-msg-len><varint-proto-name-len><proto-name>\n<varint-proto-name-len><proto-name>\n
    const res = await $ehYYX.read(reader);
    // After reading response we have:
    // <varint-proto-name-len><proto-name>\n<varint-proto-name-len><proto-name>\n
    const protocolsReader = $hO1wl([
        res
    ]);
    const protocols = [];
    // Decode each of the protocols from the reader
    await $d8Blz(protocolsReader, $4zeIG.decode(), async (source)=>{
        for await (const protocol of source)// Remove the newline
        protocols.push(protocol.shallowSlice(0, -1).toString());
    });
    return {
        stream: shakeStream,
        protocols: protocols
    };
};

});


parcelRequire.register("4n6xN", function(module, exports) {

$parcel$export(module.exports, "Connection", () => $32ee62eec8ebcb54$export$98b66c25bb38499d, (v) => $32ee62eec8ebcb54$export$98b66c25bb38499d = v);
var $32ee62eec8ebcb54$export$98b66c25bb38499d;
"use strict";

$32ee62eec8ebcb54$export$98b66c25bb38499d = (parcelRequire("hYqqf"));

});
parcelRequire.register("hYqqf", function(module, exports) {
"use strict";

var $ksmXv = parcelRequire("ksmXv");

var $aZLwC = parcelRequire("aZLwC");
var $d15c89346c47ecbe$require$Multiaddr = $aZLwC.Multiaddr;

var $20Lm5 = parcelRequire("20Lm5");

var $1dJqc = parcelRequire("1dJqc");
var $d15c89346c47ecbe$require$OPEN = $1dJqc.OPEN;
var $d15c89346c47ecbe$require$CLOSING = $1dJqc.CLOSING;
var $d15c89346c47ecbe$require$CLOSED = $1dJqc.CLOSED;
const $d15c89346c47ecbe$var$connectionSymbol = Symbol.for("@libp2p/interface-connection/connection");
/**
 * @typedef {import('../stream-muxer/types').MuxedStream} MuxedStream
 * @typedef {import('./status').Status} Status
 */ /**
 * @typedef {Object} Timeline
 * @property {number} open - connection opening timestamp.
 * @property {number} [upgraded] - connection upgraded timestamp.
 * @property {number} [close]
 *
 * @typedef {Object} ConectionStat
 * @property {'inbound' | 'outbound'} direction - connection establishment direction
 * @property {Timeline} timeline - connection relevant events timestamp.
 * @property {string} [multiplexer] - connection multiplexing identifier.
 * @property {string} [encryption] - connection encryption method identifier.
 *
 * @typedef {(protocols: string|string[]) => Promise<{stream: MuxedStream, protocol: string}>} CreatedMuxedStream
 *
 * @typedef {Object} ConnectionOptions
 * @property {Multiaddr} [localAddr] - local multiaddr of the connection if known.
 * @property {Multiaddr} remoteAddr - remote multiaddr of the connection.
 * @property {PeerId} localPeer - local peer-id.
 * @property {PeerId} remotePeer - remote peer-id.
 * @property {CreatedMuxedStream} newStream - new stream muxer function.
 * @property {() => Promise<void>} close - close raw connection function.
 * @property {() => MuxedStream[]} getStreams - get streams from muxer function.
 * @property {ConectionStat} stat - metadata of the connection.
 *
 * @typedef {Object} StreamData
 * @property {string} protocol - the protocol used by the stream
 * @property {Object} [metadata] - metadata of the stream
 */ /**
 * An implementation of the js-libp2p connection.
 * Any libp2p transport should use an upgrader to return this connection.
 */ class $d15c89346c47ecbe$var$Connection {
    /**
   * An implementation of the js-libp2p connection.
   * Any libp2p transport should use an upgrader to return this connection.
   *
   * @class
   * @param {ConnectionOptions} options
   */ constructor({ localAddr: localAddr, remoteAddr: remoteAddr, localPeer: localPeer, remotePeer: remotePeer, newStream: newStream, close: close, getStreams: getStreams, stat: stat }){
        $d15c89346c47ecbe$var$validateArgs(localAddr, localPeer, remotePeer, newStream, close, getStreams, stat);
        /**
     * Connection identifier.
     */ this.id = parseInt(String(Math.random() * 1e9)).toString(36) + Date.now();
        /**
     * Observed multiaddr of the local peer
     */ this.localAddr = localAddr;
        /**
     * Observed multiaddr of the remote peer
     */ this.remoteAddr = remoteAddr;
        /**
     * Local peer id.
     */ this.localPeer = localPeer;
        /**
     * Remote peer id.
     */ this.remotePeer = remotePeer;
        /**
     * Connection metadata.
     *
     * @type {ConectionStat & {status: Status}}
     */ this._stat = {
            ...stat,
            status: $d15c89346c47ecbe$require$OPEN
        };
        /**
     * Reference to the new stream function of the multiplexer
     */ this._newStream = newStream;
        /**
     * Reference to the close function of the raw connection
     */ this._close = close;
        /**
     * Reference to the getStreams function of the muxer
     */ this._getStreams = getStreams;
        /**
     * Connection streams registry
     */ this.registry = new Map();
        /**
     * User provided tags
     *
     * @type {string[]}
     */ this.tags = [];
    }
    get [Symbol.toStringTag]() {
        return "Connection";
    }
    get [$d15c89346c47ecbe$var$connectionSymbol]() {
        return true;
    }
    /**
   * Checks if the given value is a `Connection` instance.
   *
   * @param {any} other
   * @returns {other is Connection}
   */ static isConnection(other) {
        return Boolean(other && other[$d15c89346c47ecbe$var$connectionSymbol]);
    }
    /**
   * Get connection metadata
   *
   * @this {Connection}
   */ get stat() {
        return this._stat;
    }
    /**
   * Get all the streams of the muxer.
   *
   * @this {Connection}
   */ get streams() {
        return this._getStreams();
    }
    /**
   * Create a new stream from this connection
   *
   * @param {string|string[]} protocols - intended protocol for the stream
   * @returns {Promise<{stream: MuxedStream, protocol: string}>} with muxed+multistream-selected stream and selected protocol
   */ async newStream(protocols) {
        if (this.stat.status === $d15c89346c47ecbe$require$CLOSING) throw $20Lm5(new Error("the connection is being closed"), "ERR_CONNECTION_BEING_CLOSED");
        if (this.stat.status === $d15c89346c47ecbe$require$CLOSED) throw $20Lm5(new Error("the connection is closed"), "ERR_CONNECTION_CLOSED");
        if (!Array.isArray(protocols)) protocols = [
            protocols
        ];
        const { stream: stream, protocol: protocol } = await this._newStream(protocols);
        this.addStream(stream, {
            protocol: protocol
        });
        return {
            stream: stream,
            protocol: protocol
        };
    }
    /**
   * Add a stream when it is opened to the registry.
   *
   * @param {MuxedStream} muxedStream - a muxed stream
   * @param {StreamData} data - the stream data to be registered
   * @returns {void}
   */ addStream(muxedStream, { protocol: protocol, metadata: metadata = {} }) {
        // Add metadata for the stream
        this.registry.set(muxedStream.id, {
            protocol: protocol,
            ...metadata
        });
    }
    /**
   * Remove stream registry after it is closed.
   *
   * @param {string} id - identifier of the stream
   */ removeStream(id) {
        this.registry.delete(id);
    }
    /**
   * Close the connection.
   *
   * @returns {Promise<void>}
   */ async close() {
        if (this.stat.status === $d15c89346c47ecbe$require$CLOSED) return;
        if (this._closing) return this._closing;
        this.stat.status = $d15c89346c47ecbe$require$CLOSING;
        // Close raw connection
        this._closing = await this._close();
        this._stat.timeline.close = Date.now();
        this.stat.status = $d15c89346c47ecbe$require$CLOSED;
    }
}
module.exports = $d15c89346c47ecbe$var$Connection;
/**
 * @param {Multiaddr|undefined} localAddr
 * @param {PeerId} localPeer
 * @param {PeerId} remotePeer
 * @param {(protocols: string | string[]) => Promise<{ stream: import("../stream-muxer/types").MuxedStream; protocol: string; }>} newStream
 * @param {() => Promise<void>} close
 * @param {() => import("../stream-muxer/types").MuxedStream[]} getStreams
 * @param {{ direction: any; timeline: any; multiplexer?: string | undefined; encryption?: string | undefined; }} stat
 */ function $d15c89346c47ecbe$var$validateArgs(localAddr, localPeer, remotePeer, newStream, close, getStreams, stat) {
    if (localAddr && !$d15c89346c47ecbe$require$Multiaddr.isMultiaddr(localAddr)) throw $20Lm5(new Error("localAddr must be an instance of multiaddr"), "ERR_INVALID_PARAMETERS");
    if (!$ksmXv.isPeerId(localPeer)) throw $20Lm5(new Error("localPeer must be an instance of peer-id"), "ERR_INVALID_PARAMETERS");
    if (!$ksmXv.isPeerId(remotePeer)) throw $20Lm5(new Error("remotePeer must be an instance of peer-id"), "ERR_INVALID_PARAMETERS");
    if (typeof newStream !== "function") throw $20Lm5(new Error("new stream must be a function"), "ERR_INVALID_PARAMETERS");
    if (typeof close !== "function") throw $20Lm5(new Error("close must be a function"), "ERR_INVALID_PARAMETERS");
    if (typeof getStreams !== "function") throw $20Lm5(new Error("getStreams must be a function"), "ERR_INVALID_PARAMETERS");
    if (!stat) throw $20Lm5(new Error("connection metadata object must be provided"), "ERR_INVALID_PARAMETERS");
    if (stat.direction !== "inbound" && stat.direction !== "outbound") throw $20Lm5(new Error('direction must be "inbound" or "outbound"'), "ERR_INVALID_PARAMETERS");
    if (!stat.timeline) throw $20Lm5(new Error("connection timeline object must be provided in the stat object"), "ERR_INVALID_PARAMETERS");
    if (!stat.timeline.open) throw $20Lm5(new Error("connection open timestamp must be provided"), "ERR_INVALID_PARAMETERS");
    if (!stat.timeline.upgraded) throw $20Lm5(new Error("connection upgraded timestamp must be provided"), "ERR_INVALID_PARAMETERS");
}

});
parcelRequire.register("1dJqc", function(module, exports) {
"use strict";
const $0e3a3d1ed88ea8bb$var$STATUS = {
    OPEN: /** @type {'open'} */ "open",
    CLOSING: /** @type {'closing'} */ "closing",
    CLOSED: /** @type {'closed'} */ "closed"
};
module.exports = $0e3a3d1ed88ea8bb$var$STATUS /**
 * @typedef {STATUS[keyof STATUS]} Status
 */ ;

});



parcelRequire.register("hAzSc", function(module, exports) {
"use strict";
function $cce1a01bcb8c3e25$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
module.exports = function mutableProxyFactory(defaultTarget) {
    var mutableHandler = void 0;
    var mutableTarget = void 0;
    function setTarget(target) {
        if (!(target instanceof Object)) throw new Error('Target "' + target + '" is not an object');
        mutableTarget = target;
    }
    function setHandler(handler) {
        Object.keys(handler).forEach(function(key) {
            var value = handler[key];
            if (typeof value !== "function") throw new Error('Trap "' + key + ": " + value + '" is not a function');
            if (!Reflect[key]) throw new Error('Trap "' + key + ": " + value + '" is not a valid trap');
        });
        mutableHandler = handler;
    }
    setTarget(function() {});
    if (defaultTarget) setTarget(defaultTarget);
    setHandler(Reflect);
    // Dynamically forward all the traps to the associated methods on the mutable handler
    var handler = new Proxy({}, {
        get: function get(target, property) {
            return function() {
                for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return mutableHandler[property].apply(null, [
                    mutableTarget
                ].concat($cce1a01bcb8c3e25$var$_toConsumableArray(args.slice(1))));
            };
        }
    });
    return {
        setTarget: setTarget,
        setHandler: setHandler,
        getTarget: function getTarget() {
            return mutableTarget;
        },
        getHandler: function getHandler() {
            return mutableHandler;
        },
        proxy: new Proxy(mutableTarget, handler)
    };
};

});


parcelRequire.register("4v27J", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $7QXK1 = parcelRequire("7QXK1");
var $346bb46bbefa1c2c$require$EventEmitter = $7QXK1.EventEmitter;

var $ksmXv = parcelRequire("ksmXv");

var $bVGQK = parcelRequire("bVGQK");

var $40lHE = parcelRequire("40lHE");

var $iETRa = parcelRequire("iETRa");

var $gjpo5 = parcelRequire("gjpo5");

var $8yAh4 = parcelRequire("8yAh4");
const { codes: { ERR_INVALID_PARAMETERS: $346bb46bbefa1c2c$var$ERR_INVALID_PARAMETERS } } = $8yAh4;
/**
 * @typedef {import('./address-book').Address} Address
 */ /**
 * @extends {EventEmitter}
 *
 * @fires PeerStore#peer Emitted when a new peer is added.
 * @fires PeerStore#change:protocols Emitted when a known peer supports a different set of protocols.
 * @fires PeerStore#change:multiaddrs Emitted when a known peer has a different set of multiaddrs.
 * @fires PeerStore#change:pubkey Emitted emitted when a peer's public key is known.
 * @fires PeerStore#change:metadata Emitted when the known metadata of a peer change.
 */ class $346bb46bbefa1c2c$var$PeerStore extends $346bb46bbefa1c2c$require$EventEmitter {
    /**
   * Peer object
   *
   * @typedef {Object} Peer
   * @property {PeerId} id peer's peer-id instance.
   * @property {Address[]} addresses peer's addresses containing its multiaddrs and metadata.
   * @property {string[]} protocols peer's supported protocols.
   * @property {Map<string, Uint8Array>|undefined} metadata peer's metadata map.
   */ /**
   * Responsible for managing known peers, as well as their addresses, protocols and metadata.
   *
   * @param {object} options
   * @param {PeerId} options.peerId
   * @class
   */ constructor({ peerId: peerId }){
        super();
        this._peerId = peerId;
        /**
     * AddressBook containing a map of peerIdStr to Address.
     */ this.addressBook = new $bVGQK(this);
        /**
     * KeyBook containing a map of peerIdStr to their PeerId with public keys.
     */ this.keyBook = new $40lHE(this);
        /**
     * MetadataBook containing a map of peerIdStr to their metadata Map.
     */ this.metadataBook = new $iETRa(this);
        /**
     * ProtoBook containing a map of peerIdStr to supported protocols.
     */ this.protoBook = new $gjpo5(this);
    }
    /**
   * Start the PeerStore.
   */ start() {}
    /**
   * Stop the PeerStore.
   */ stop() {}
    /**
   * Get all the stored information of every peer known.
   *
   * @returns {Map<string, Peer>}
   */ get peers() {
        const storedPeers = new Set([
            ...this.addressBook.data.keys(),
            ...this.keyBook.data.keys(),
            ...this.protoBook.data.keys(),
            ...this.metadataBook.data.keys()
        ]);
        // Remove self peer if present
        this._peerId && storedPeers.delete(this._peerId.toB58String());
        const peersData = new Map();
        storedPeers.forEach((idStr)=>{
            peersData.set(idStr, this.get($ksmXv.createFromB58String(idStr)));
        });
        return peersData;
    }
    /**
   * Delete the information of the given peer in every book.
   *
   * @param {PeerId} peerId
   * @returns {boolean} true if found and removed
   */ delete(peerId) {
        const addressesDeleted = this.addressBook.delete(peerId);
        const keyDeleted = this.keyBook.delete(peerId);
        const protocolsDeleted = this.protoBook.delete(peerId);
        const metadataDeleted = this.metadataBook.delete(peerId);
        return addressesDeleted || keyDeleted || protocolsDeleted || metadataDeleted;
    }
    /**
   * Get the stored information of a given peer.
   *
   * @param {PeerId} peerId
   * @returns {Peer|undefined}
   */ get(peerId) {
        if (!$ksmXv.isPeerId(peerId)) throw $20Lm5(new Error("peerId must be an instance of peer-id"), $346bb46bbefa1c2c$var$ERR_INVALID_PARAMETERS);
        const id = this.keyBook.data.get(peerId.toB58String());
        const addresses = this.addressBook.get(peerId);
        const metadata = this.metadataBook.get(peerId);
        const protocols = this.protoBook.get(peerId);
        if (!id && !addresses && !metadata && !protocols) return undefined;
        return {
            id: id || peerId,
            addresses: addresses || [],
            protocols: protocols || [],
            metadata: metadata
        };
    }
}
module.exports = $346bb46bbefa1c2c$var$PeerStore;

});
parcelRequire.register("bVGQK", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $023dc740a787d22e$var$log = Object.assign($jjmHV("libp2p:peer-store:address-book"), {
    error: $jjmHV("libp2p:peer-store:address-book:err")
});

var $20Lm5 = parcelRequire("20Lm5");

var $aZLwC = parcelRequire("aZLwC");
var $023dc740a787d22e$require$Multiaddr = $aZLwC.Multiaddr;

var $ksmXv = parcelRequire("ksmXv");

var $df9os = parcelRequire("df9os");

var $ewhIy = parcelRequire("ewhIy");

var $8yAh4 = parcelRequire("8yAh4");
const { codes: { ERR_INVALID_PARAMETERS: $023dc740a787d22e$var$ERR_INVALID_PARAMETERS } } = $8yAh4;

var $4kY1w = parcelRequire("4kY1w");
/**
 * @typedef {import('./')} PeerStore
 */ /**
 * @typedef {Object} Address
 * @property {Multiaddr} multiaddr peer multiaddr.
 * @property {boolean} isCertified obtained from a signed peer record.
 *
 * @typedef {Object} CertifiedRecord
 * @property {Uint8Array} raw raw envelope.
 * @property {number} seqNumber seq counter.
 *
 * @typedef {Object} Entry
 * @property {Address[]} addresses peer Addresses.
 * @property {CertifiedRecord} record certified peer record.
 */ /**
 * @extends {Book}
 */ class $023dc740a787d22e$var$AddressBook extends $df9os {
    /**
   * The AddressBook is responsible for keeping the known multiaddrs of a peer.
   *
   * @class
   * @param {PeerStore} peerStore
   */ constructor(peerStore){
        /**
     * PeerStore Event emitter, used by the AddressBook to emit:
     * "peer" - emitted when a peer is discovered by the node.
     * "change:multiaddrs" - emitted when the known multiaddrs of a peer change.
     */ super({
            peerStore: peerStore,
            eventName: "change:multiaddrs",
            eventProperty: "multiaddrs",
            eventTransformer: (data)=>{
                if (!data.addresses) return [];
                return data.addresses.map((/** @type {Address} */ address)=>address.multiaddr);
            }
        });
        /**
     * Map known peers to their known Address Entries.
     *
     * @type {Map<string, Entry>}
     */ this.data = new Map();
    }
    /**
   * ConsumePeerRecord adds addresses from a signed peer record contained in a record envelope.
   * This will return a boolean that indicates if the record was successfully processed and added
   * into the AddressBook.
   *
   * @param {Envelope} envelope
   * @returns {boolean}
   */ consumePeerRecord(envelope) {
        let peerRecord;
        try {
            peerRecord = $ewhIy.createFromProtobuf(envelope.payload);
        } catch (/** @type {any} */ err) {
            $023dc740a787d22e$var$log.error("invalid peer record received");
            return false;
        }
        // Verify peerId
        if (!peerRecord.peerId.equals(envelope.peerId)) {
            $023dc740a787d22e$var$log("signing key does not match PeerId in the PeerRecord");
            return false;
        }
        // ensure the record has multiaddrs
        if (!peerRecord.multiaddrs || !peerRecord.multiaddrs.length) return false;
        const peerId = peerRecord.peerId;
        const id = peerId.toB58String();
        const entry = this.data.get(id) || {
            record: undefined
        };
        const storedRecord = entry.record;
        // ensure seq is greater than, or equal to, the last received
        if (storedRecord && storedRecord.seqNumber >= peerRecord.seqNumber) return false;
        const addresses = this._toAddresses(peerRecord.multiaddrs, true);
        // Replace unsigned addresses by the new ones from the record
        // TODO: Once we have ttls for the addresses, we should merge these in.
        this._setData(peerId, {
            addresses: addresses,
            record: {
                raw: envelope.marshal(),
                seqNumber: peerRecord.seqNumber
            }
        });
        $023dc740a787d22e$var$log(`stored provided peer record for ${id}`);
        return true;
    }
    /**
   * Get the raw Envelope for a peer. Returns
   * undefined if no Envelope is found.
   *
   * @param {PeerId} peerId
   * @returns {Uint8Array|undefined}
   */ getRawEnvelope(peerId) {
        const entry = this.data.get(peerId.toB58String());
        if (!entry || !entry.record || !entry.record.raw) return undefined;
        return entry.record.raw;
    }
    /**
   * Get an Envelope containing a PeerRecord for the given peer.
   * Returns undefined if no record exists.
   *
   * @param {PeerId} peerId
   * @returns {Promise<Envelope|void>|undefined}
   */ getPeerRecord(peerId) {
        const raw = this.getRawEnvelope(peerId);
        if (!raw) return undefined;
        return $4kY1w.createFromProtobuf(raw);
    }
    /**
   * Set known multiaddrs of a provided peer.
   * This will replace previously stored multiaddrs, if available.
   * Replacing stored multiaddrs might result in losing obtained certified addresses.
   * If you are not sure, it's recommended to use `add` instead.
   *
   * @override
   * @param {PeerId} peerId
   * @param {Multiaddr[]} multiaddrs
   * @returns {AddressBook}
   */ set(peerId, multiaddrs) {
        if (!$ksmXv.isPeerId(peerId)) {
            $023dc740a787d22e$var$log.error("peerId must be an instance of peer-id to store data");
            throw $20Lm5(new Error("peerId must be an instance of peer-id"), $023dc740a787d22e$var$ERR_INVALID_PARAMETERS);
        }
        const addresses = this._toAddresses(multiaddrs);
        // Not replace multiaddrs
        if (!addresses.length) return this;
        const id = peerId.toB58String();
        const entry = this.data.get(id);
        // Already knows the peer
        if (entry && entry.addresses && entry.addresses.length === addresses.length) {
            const intersection = entry.addresses.filter((addr)=>addresses.some((newAddr)=>addr.multiaddr.equals(newAddr.multiaddr)));
            // Are new addresses equal to the old ones?
            // If yes, no changes needed!
            if (intersection.length === entry.addresses.length) {
                $023dc740a787d22e$var$log(`the addresses provided to store are equal to the already stored for ${id}`);
                return this;
            }
        }
        this._setData(peerId, {
            addresses: addresses,
            record: entry && entry.record
        });
        $023dc740a787d22e$var$log(`stored provided multiaddrs for ${id}`);
        // Notify the existance of a new peer
        if (!entry) this._ps.emit("peer", peerId);
        return this;
    }
    /**
   * Add known addresses of a provided peer.
   * If the peer is not known, it is set with the given addresses.
   *
   * @param {PeerId} peerId
   * @param {Multiaddr[]} multiaddrs
   * @returns {AddressBook}
   */ add(peerId, multiaddrs) {
        if (!$ksmXv.isPeerId(peerId)) {
            $023dc740a787d22e$var$log.error("peerId must be an instance of peer-id to store data");
            throw $20Lm5(new Error("peerId must be an instance of peer-id"), $023dc740a787d22e$var$ERR_INVALID_PARAMETERS);
        }
        const addresses = this._toAddresses(multiaddrs);
        const id = peerId.toB58String();
        // No addresses to be added
        if (!addresses.length) return this;
        const entry = this.data.get(id);
        if (entry && entry.addresses) {
            // Add recorded uniquely to the new array (Union)
            entry.addresses.forEach((addr)=>{
                if (!addresses.find((r)=>r.multiaddr.equals(addr.multiaddr))) addresses.push(addr);
            });
            // If the recorded length is equal to the new after the unique union
            // The content is the same, no need to update.
            if (entry.addresses.length === addresses.length) {
                $023dc740a787d22e$var$log(`the addresses provided to store are already stored for ${id}`);
                return this;
            }
        }
        this._setData(peerId, {
            addresses: addresses,
            record: entry && entry.record
        });
        $023dc740a787d22e$var$log(`added provided multiaddrs for ${id}`);
        // Notify the existance of a new peer
        if (!(entry && entry.addresses)) this._ps.emit("peer", peerId);
        return this;
    }
    /**
   * Get the known data of a provided peer.
   *
   * @override
   * @param {PeerId} peerId
   * @returns {Address[]|undefined}
   */ get(peerId) {
        if (!$ksmXv.isPeerId(peerId)) throw $20Lm5(new Error("peerId must be an instance of peer-id"), $023dc740a787d22e$var$ERR_INVALID_PARAMETERS);
        const entry = this.data.get(peerId.toB58String());
        return entry && entry.addresses ? [
            ...entry.addresses
        ] : undefined;
    }
    /**
   * Transforms received multiaddrs into Address.
   *
   * @private
   * @param {Multiaddr[]} multiaddrs
   * @param {boolean} [isCertified]
   * @returns {Address[]}
   */ _toAddresses(multiaddrs, isCertified = false) {
        if (!multiaddrs) {
            $023dc740a787d22e$var$log.error("multiaddrs must be provided to store data");
            throw $20Lm5(new Error("multiaddrs must be provided"), $023dc740a787d22e$var$ERR_INVALID_PARAMETERS);
        }
        // create Address for each address
        /** @type {Address[]} */ const addresses = [];
        multiaddrs.forEach((addr)=>{
            if (!$023dc740a787d22e$require$Multiaddr.isMultiaddr(addr)) {
                $023dc740a787d22e$var$log.error(`multiaddr ${addr} must be an instance of multiaddr`);
                throw $20Lm5(new Error(`multiaddr ${addr} must be an instance of multiaddr`), $023dc740a787d22e$var$ERR_INVALID_PARAMETERS);
            }
            // Guarantee no replicates
            if (!addresses.find((a)=>a.multiaddr.equals(addr))) addresses.push({
                multiaddr: addr,
                isCertified: isCertified
            });
        });
        return addresses;
    }
    /**
   * Get the known multiaddrs for a given peer. All returned multiaddrs
   * will include the encapsulated `PeerId` of the peer.
   * Returns `undefined` if there are no known multiaddrs for the given peer.
   *
   * @param {PeerId} peerId
   * @param {(addresses: Address[]) => Address[]} [addressSorter]
   * @returns {Multiaddr[]|undefined}
   */ getMultiaddrsForPeer(peerId, addressSorter = (ms)=>ms) {
        if (!$ksmXv.isPeerId(peerId)) throw $20Lm5(new Error("peerId must be an instance of peer-id"), $023dc740a787d22e$var$ERR_INVALID_PARAMETERS);
        const entry = this.data.get(peerId.toB58String());
        if (!entry || !entry.addresses) return undefined;
        return addressSorter(entry.addresses || []).map((address)=>{
            const multiaddr = address.multiaddr;
            const idString = multiaddr.getPeerId();
            if (idString && idString === peerId.toB58String()) return multiaddr;
            return multiaddr.encapsulate(`/p2p/${peerId.toB58String()}`);
        });
    }
}
module.exports = $023dc740a787d22e$var$AddressBook;

});
parcelRequire.register("df9os", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $ksmXv = parcelRequire("ksmXv");

var $8yAh4 = parcelRequire("8yAh4");
var $9a43f6672b523bed$require$codes = $8yAh4.codes;
/**
 * @param {any} data
 */ const $9a43f6672b523bed$var$passthrough = (data)=>data;
/**
 * @typedef {import('./')} PeerStore
 */ class $9a43f6672b523bed$var$Book {
    /**
   * The Book is the skeleton for the PeerStore books.
   *
   * @class
   * @param {Object} properties
   * @param {PeerStore} properties.peerStore - PeerStore instance.
   * @param {string} properties.eventName - Name of the event to emit by the PeerStore.
   * @param {string} properties.eventProperty - Name of the property to emit by the PeerStore.
   * @param {(data: any) => any[]} [properties.eventTransformer] - Transformer function of the provided data for being emitted.
   */ constructor({ peerStore: peerStore, eventName: eventName, eventProperty: eventProperty, eventTransformer: eventTransformer = $9a43f6672b523bed$var$passthrough }){
        this._ps = peerStore;
        this.eventName = eventName;
        this.eventProperty = eventProperty;
        this.eventTransformer = eventTransformer;
        /**
     * Map known peers to their data.
     *
     * @type {Map<string, any[]|any>}
     */ this.data = new Map();
    }
    /**
   * Set known data of a provided peer.
   *
   * @param {PeerId} peerId
   * @param {any[]|any} data
   */ set(peerId, data) {
        throw $20Lm5(new Error("set must be implemented by the subclass"), $9a43f6672b523bed$require$codes.ERR_NOT_IMPLEMENTED);
    }
    /**
   * Set data into the datastructure, persistence and emit it using the provided transformers.
   *
   * @protected
   * @param {PeerId} peerId - peerId of the data to store
   * @param {any} data - data to store.
   * @param {Object} [options] - storing options.
   * @param {boolean} [options.emit = true] - emit the provided data.
   * @returns {void}
   */ _setData(peerId, data, { emit: emit = true } = {}) {
        const b58key = peerId.toB58String();
        // Store data in memory
        this.data.set(b58key, data);
        // Emit event
        emit && this._emit(peerId, data);
    }
    /**
   * Emit data.
   *
   * @protected
   * @param {PeerId} peerId
   * @param {any} [data]
   */ _emit(peerId, data) {
        this._ps.emit(this.eventName, {
            peerId: peerId,
            [this.eventProperty]: this.eventTransformer(data)
        });
    }
    /**
   * Get the known data of a provided peer.
   * Returns `undefined` if there is no available data for the given peer.
   *
   * @param {PeerId} peerId
   * @returns {any[]|any|undefined}
   */ get(peerId) {
        if (!$ksmXv.isPeerId(peerId)) throw $20Lm5(new Error("peerId must be an instance of peer-id"), $9a43f6672b523bed$require$codes.ERR_INVALID_PARAMETERS);
        const rec = this.data.get(peerId.toB58String());
        // @ts-ignore
        return rec ? [
            ...rec
        ] : undefined;
    }
    /**
   * Deletes the provided peer from the book.
   *
   * @param {PeerId} peerId
   * @returns {boolean}
   */ delete(peerId) {
        if (!$ksmXv.isPeerId(peerId)) throw $20Lm5(new Error("peerId must be an instance of peer-id"), $9a43f6672b523bed$require$codes.ERR_INVALID_PARAMETERS);
        if (!this.data.delete(peerId.toB58String())) return false;
        this._emit(peerId, []);
        return true;
    }
}
module.exports = $9a43f6672b523bed$var$Book;

});


parcelRequire.register("40lHE", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $2ea7ff477cad9589$var$log = Object.assign($jjmHV("libp2p:peer-store:key-book"), {
    error: $jjmHV("libp2p:peer-store:key-book:err")
});

var $20Lm5 = parcelRequire("20Lm5");

var $ksmXv = parcelRequire("ksmXv");

var $df9os = parcelRequire("df9os");

var $8yAh4 = parcelRequire("8yAh4");
const { codes: { ERR_INVALID_PARAMETERS: $2ea7ff477cad9589$var$ERR_INVALID_PARAMETERS } } = $8yAh4;
/**
 * @typedef {import('./')} PeerStore
 * @typedef {import('libp2p-crypto').PublicKey} PublicKey
 */ /**
 * @extends {Book}
 */ class $2ea7ff477cad9589$var$KeyBook extends $df9os {
    /**
   * The KeyBook is responsible for keeping the known public keys of a peer.
   *
   * @class
   * @param {PeerStore} peerStore
   */ constructor(peerStore){
        super({
            peerStore: peerStore,
            eventName: "change:pubkey",
            eventProperty: "pubkey",
            eventTransformer: (data)=>data.pubKey
        });
        /**
     * Map known peers to their known Public Key.
     *
     * @type {Map<string, PeerId>}
     */ this.data = new Map();
    }
    /**
   * Set the Peer public key.
   *
   * @override
   * @param {PeerId} peerId
   * @param {PublicKey} publicKey
   * @returns {KeyBook}
   */ set(peerId, publicKey) {
        if (!$ksmXv.isPeerId(peerId)) {
            $2ea7ff477cad9589$var$log.error("peerId must be an instance of peer-id to store data");
            throw $20Lm5(new Error("peerId must be an instance of peer-id"), $2ea7ff477cad9589$var$ERR_INVALID_PARAMETERS);
        }
        const id = peerId.toB58String();
        const recPeerId = this.data.get(id);
        // If no record available, and this is valid
        if (!recPeerId && publicKey) {
            // This might be unecessary, but we want to store the PeerId
            // to avoid an async operation when reconstructing the PeerId
            peerId.pubKey = publicKey;
            this._setData(peerId, peerId);
            $2ea7ff477cad9589$var$log(`stored provided public key for ${id}`);
        }
        return this;
    }
    /**
   * Get Public key of the given PeerId, if stored.
   *
   * @override
   * @param {PeerId} peerId
   * @returns {PublicKey | undefined}
   */ get(peerId) {
        if (!$ksmXv.isPeerId(peerId)) throw $20Lm5(new Error("peerId must be an instance of peer-id"), $2ea7ff477cad9589$var$ERR_INVALID_PARAMETERS);
        const rec = this.data.get(peerId.toB58String());
        return rec ? rec.pubKey : undefined;
    }
}
module.exports = $2ea7ff477cad9589$var$KeyBook;

});

parcelRequire.register("iETRa", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $d9574a60bff57e0f$var$log = Object.assign($jjmHV("libp2p:peer-store:proto-book"), {
    error: $jjmHV("libp2p:peer-store:proto-book:err")
});

var $20Lm5 = parcelRequire("20Lm5");

var $ijWXY = parcelRequire("ijWXY");
var $d9574a60bff57e0f$require$uint8ArrayEquals = $ijWXY.equals;

var $ksmXv = parcelRequire("ksmXv");

var $df9os = parcelRequire("df9os");

var $8yAh4 = parcelRequire("8yAh4");
const { codes: { ERR_INVALID_PARAMETERS: $d9574a60bff57e0f$var$ERR_INVALID_PARAMETERS } } = $8yAh4;
/**
 * @typedef {import('./')} PeerStore
 */ /**
 * @extends {Book}
 *
 * @fires MetadataBook#change:metadata
 */ class $d9574a60bff57e0f$var$MetadataBook extends $df9os {
    /**
   * The MetadataBook is responsible for keeping the known supported
   * protocols of a peer.
   *
   * @class
   * @param {PeerStore} peerStore
   */ constructor(peerStore){
        /**
     * PeerStore Event emitter, used by the MetadataBook to emit:
     * "change:metadata" - emitted when the known metadata of a peer change.
     */ super({
            peerStore: peerStore,
            eventName: "change:metadata",
            eventProperty: "metadata"
        });
        /**
     * Map known peers to their known protocols.
     *
     * @type {Map<string, Map<string, Uint8Array>>}
     */ this.data = new Map();
    }
    /**
   * Set metadata key and value of a provided peer.
   *
   * @override
   * @param {PeerId} peerId
   * @param {string} key - metadata key
   * @param {Uint8Array} value - metadata value
   * @returns {MetadataBook}
   */ // @ts-ignore override with more then the parameters expected in Book
    set(peerId, key, value) {
        if (!$ksmXv.isPeerId(peerId)) {
            $d9574a60bff57e0f$var$log.error("peerId must be an instance of peer-id to store data");
            throw $20Lm5(new Error("peerId must be an instance of peer-id"), $d9574a60bff57e0f$var$ERR_INVALID_PARAMETERS);
        }
        if (typeof key !== "string" || !(value instanceof Uint8Array)) {
            $d9574a60bff57e0f$var$log.error("valid key and value must be provided to store data");
            throw $20Lm5(new Error("valid key and value must be provided"), $d9574a60bff57e0f$var$ERR_INVALID_PARAMETERS);
        }
        this._setValue(peerId, key, value);
        return this;
    }
    /**
   * Set data into the datastructure
   *
   * @param {PeerId} peerId
   * @param {string} key
   * @param {Uint8Array} value
   * @param {object} [opts]
   * @param {boolean} [opts.emit]
   */ _setValue(peerId, key, value, { emit: emit = true } = {}) {
        const id = peerId.toB58String();
        const rec = this.data.get(id) || new Map();
        const recMap = rec.get(key);
        // Already exists and is equal
        if (recMap && $d9574a60bff57e0f$require$uint8ArrayEquals(value, recMap)) {
            $d9574a60bff57e0f$var$log(`the metadata provided to store is equal to the already stored for ${id} on ${key}`);
            return;
        }
        rec.set(key, value);
        this.data.set(id, rec);
        emit && this._emit(peerId, key);
    }
    /**
   * Get the known data of a provided peer.
   *
   * @param {PeerId} peerId
   * @returns {Map<string, Uint8Array>|undefined}
   */ get(peerId) {
        if (!$ksmXv.isPeerId(peerId)) throw $20Lm5(new Error("peerId must be an instance of peer-id"), $d9574a60bff57e0f$var$ERR_INVALID_PARAMETERS);
        return this.data.get(peerId.toB58String());
    }
    /**
   * Get specific metadata value, if it exists
   *
   * @param {PeerId} peerId
   * @param {string} key
   * @returns {Uint8Array | undefined}
   */ getValue(peerId, key) {
        if (!$ksmXv.isPeerId(peerId)) throw $20Lm5(new Error("peerId must be an instance of peer-id"), $d9574a60bff57e0f$var$ERR_INVALID_PARAMETERS);
        const rec = this.data.get(peerId.toB58String());
        return rec && rec.get(key);
    }
    /**
   * Deletes the provided peer from the book.
   *
   * @param {PeerId} peerId
   * @returns {boolean}
   */ delete(peerId) {
        if (!$ksmXv.isPeerId(peerId)) throw $20Lm5(new Error("peerId must be an instance of peer-id"), $d9574a60bff57e0f$var$ERR_INVALID_PARAMETERS);
        if (!this.data.delete(peerId.toB58String())) return false;
        this._emit(peerId);
        return true;
    }
    /**
   * Deletes the provided peer metadata key from the book.
   *
   * @param {PeerId} peerId
   * @param {string} key
   * @returns {boolean}
   */ deleteValue(peerId, key) {
        if (!$ksmXv.isPeerId(peerId)) throw $20Lm5(new Error("peerId must be an instance of peer-id"), $d9574a60bff57e0f$var$ERR_INVALID_PARAMETERS);
        const rec = this.data.get(peerId.toB58String());
        if (!rec || !rec.delete(key)) return false;
        this._emit(peerId, key);
        return true;
    }
}
module.exports = $d9574a60bff57e0f$var$MetadataBook;

});

parcelRequire.register("gjpo5", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $be021d22d3829b09$var$log = Object.assign($jjmHV("libp2p:peer-store:proto-book"), {
    error: $jjmHV("libp2p:peer-store:proto-book:err")
});

var $20Lm5 = parcelRequire("20Lm5");

var $ksmXv = parcelRequire("ksmXv");

var $df9os = parcelRequire("df9os");

var $8yAh4 = parcelRequire("8yAh4");
const { codes: { ERR_INVALID_PARAMETERS: $be021d22d3829b09$var$ERR_INVALID_PARAMETERS } } = $8yAh4;
/**
 * @typedef {import('./')} PeerStore
 */ /**
 * @extends {Book}
 *
 * @fires ProtoBook#change:protocols
 */ class $be021d22d3829b09$var$ProtoBook extends $df9os {
    /**
   * The ProtoBook is responsible for keeping the known supported
   * protocols of a peer.
   *
   * @class
   * @param {PeerStore} peerStore
   */ constructor(peerStore){
        /**
     * PeerStore Event emitter, used by the ProtoBook to emit:
     * "change:protocols" - emitted when the known protocols of a peer change.
     */ super({
            peerStore: peerStore,
            eventName: "change:protocols",
            eventProperty: "protocols",
            eventTransformer: (data)=>Array.from(data)
        });
        /**
     * Map known peers to their known protocols.
     *
     * @type {Map<string, Set<string>>}
     */ this.data = new Map();
    }
    /**
   * Set known protocols of a provided peer.
   * If the peer was not known before, it will be added.
   *
   * @override
   * @param {PeerId} peerId
   * @param {string[]} protocols
   * @returns {ProtoBook}
   */ set(peerId, protocols) {
        if (!$ksmXv.isPeerId(peerId)) {
            $be021d22d3829b09$var$log.error("peerId must be an instance of peer-id to store data");
            throw $20Lm5(new Error("peerId must be an instance of peer-id"), $be021d22d3829b09$var$ERR_INVALID_PARAMETERS);
        }
        if (!protocols) {
            $be021d22d3829b09$var$log.error("protocols must be provided to store data");
            throw $20Lm5(new Error("protocols must be provided"), $be021d22d3829b09$var$ERR_INVALID_PARAMETERS);
        }
        const id = peerId.toB58String();
        const recSet = this.data.get(id);
        const newSet = new Set(protocols);
        /**
     * @param {Set<string>} a
     * @param {Set<string>} b
     */ const isSetEqual = (a, b)=>a.size === b.size && [
                ...a
            ].every((value)=>b.has(value));
        // Already knows the peer and the recorded protocols are the same?
        // If yes, no changes needed!
        if (recSet && isSetEqual(recSet, newSet)) {
            $be021d22d3829b09$var$log(`the protocols provided to store are equal to the already stored for ${id}`);
            return this;
        }
        this._setData(peerId, newSet);
        $be021d22d3829b09$var$log(`stored provided protocols for ${id}`);
        return this;
    }
    /**
   * Adds known protocols of a provided peer.
   * If the peer was not known before, it will be added.
   *
   * @param {PeerId} peerId
   * @param {string[]} protocols
   * @returns {ProtoBook}
   */ add(peerId, protocols) {
        if (!$ksmXv.isPeerId(peerId)) {
            $be021d22d3829b09$var$log.error("peerId must be an instance of peer-id to store data");
            throw $20Lm5(new Error("peerId must be an instance of peer-id"), $be021d22d3829b09$var$ERR_INVALID_PARAMETERS);
        }
        if (!protocols) {
            $be021d22d3829b09$var$log.error("protocols must be provided to store data");
            throw $20Lm5(new Error("protocols must be provided"), $be021d22d3829b09$var$ERR_INVALID_PARAMETERS);
        }
        const id = peerId.toB58String();
        const recSet = this.data.get(id) || new Set();
        const newSet = new Set([
            ...recSet,
            ...protocols
        ]) // Set Union
        ;
        // Any new protocol added?
        if (recSet.size === newSet.size) {
            $be021d22d3829b09$var$log(`the protocols provided to store are already stored for ${id}`);
            return this;
        }
        this._setData(peerId, newSet);
        $be021d22d3829b09$var$log(`added provided protocols for ${id}`);
        return this;
    }
    /**
   * Removes known protocols of a provided peer.
   * If the protocols did not exist before, nothing will be done.
   *
   * @param {PeerId} peerId
   * @param {string[]} protocols
   * @returns {ProtoBook}
   */ remove(peerId, protocols) {
        if (!$ksmXv.isPeerId(peerId)) {
            $be021d22d3829b09$var$log.error("peerId must be an instance of peer-id to store data");
            throw $20Lm5(new Error("peerId must be an instance of peer-id"), $be021d22d3829b09$var$ERR_INVALID_PARAMETERS);
        }
        if (!protocols) {
            $be021d22d3829b09$var$log.error("protocols must be provided to store data");
            throw $20Lm5(new Error("protocols must be provided"), $be021d22d3829b09$var$ERR_INVALID_PARAMETERS);
        }
        const id = peerId.toB58String();
        const recSet = this.data.get(id);
        if (recSet) {
            const newSet = new Set([
                ...recSet
            ].filter((p)=>!protocols.includes(p)));
            // Any protocol removed?
            if (recSet.size === newSet.size) return this;
            this._setData(peerId, newSet);
            $be021d22d3829b09$var$log(`removed provided protocols for ${id}`);
        }
        return this;
    }
}
module.exports = $be021d22d3829b09$var$ProtoBook;

});


parcelRequire.register("7FGtw", function(module, exports) {
"use strict";
// Pubsub adapter to keep API with handlers while not removed.
/**
 * @typedef {import('libp2p-interfaces/src/pubsub').InMessage} InMessage
 * @typedef {import('libp2p-interfaces/src/pubsub')} PubsubRouter
 */ /**
 * @param {{new(...args: any[]): PubsubRouter}} PubsubRouter
 * @param {import('.')} libp2p
 * @param {{ enabled: boolean; } & import(".").PubsubLocalOptions & import("libp2p-interfaces/src/pubsub").PubsubOptions} options
 */ function $595d4f6df1ab0d42$var$pubsubAdapter(PubsubRouter, libp2p, options) {
    /** @type {PubsubRouter & { _subscribeAdapter: PubsubRouter['subscribe'], _unsubscribeAdapter: PubsubRouter['unsubscribe'] }} */ // @ts-ignore we set the extra _subscribeAdapter and _unsubscribeAdapter properties afterwards
    const pubsub = new PubsubRouter(libp2p, options);
    pubsub._subscribeAdapter = pubsub.subscribe;
    pubsub._unsubscribeAdapter = pubsub.unsubscribe;
    /**
   * Subscribes to a given topic.
   *
   * @override
   * @param {string} topic
   * @param {(msg: InMessage) => void} [handler]
   * @returns {void}
   */ function subscribe(topic, handler) {
        // Bind provided handler
        handler && pubsub.on(topic, handler);
        pubsub._subscribeAdapter(topic);
    }
    /**
   * Unsubscribe from the given topic.
   *
   * @override
   * @param {string} topic
   * @param {(msg: InMessage) => void} [handler]
   * @returns {void}
   */ function unsubscribe(topic, handler) {
        if (!handler) pubsub.removeAllListeners(topic);
        else pubsub.removeListener(topic, handler);
        if (pubsub.listenerCount(topic) === 0) pubsub._unsubscribeAdapter(topic);
    }
    pubsub.subscribe = subscribe;
    pubsub.unsubscribe = unsubscribe;
    return pubsub;
}
module.exports = $595d4f6df1ab0d42$var$pubsubAdapter;

});

parcelRequire.register("E0Rc9", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $078466b88f051b25$var$log = Object.assign($jjmHV("libp2p:persistent-peer-store"), {
    error: $jjmHV("libp2p:persistent-peer-store:err")
});

var $e2ec8 = parcelRequire("e2ec8");
var $078466b88f051b25$require$Key = $e2ec8.Key;

var $aZLwC = parcelRequire("aZLwC");
var $078466b88f051b25$require$Multiaddr = $aZLwC.Multiaddr;

var $ksmXv = parcelRequire("ksmXv");

var $5LC6A = parcelRequire("5LC6A");
var $078466b88f051b25$require$base32 = $5LC6A.base32;

var $4v27J = parcelRequire("4v27J");

var $5MXvK = parcelRequire("5MXvK");
var $078466b88f051b25$require$NAMESPACE_ADDRESS = $5MXvK.NAMESPACE_ADDRESS;
var $078466b88f051b25$require$NAMESPACE_COMMON = $5MXvK.NAMESPACE_COMMON;
var $078466b88f051b25$require$NAMESPACE_KEYS = $5MXvK.NAMESPACE_KEYS;
var $078466b88f051b25$require$NAMESPACE_METADATA = $5MXvK.NAMESPACE_METADATA;
var $078466b88f051b25$require$NAMESPACE_PROTOCOL = $5MXvK.NAMESPACE_PROTOCOL;

var $94fFA = parcelRequire("94fFA");
var $078466b88f051b25$require$Addresses = $94fFA.Addresses;

var $iNjUP = parcelRequire("iNjUP");
var $078466b88f051b25$require$Protocols = $iNjUP.Protocols;
/**
 * @typedef {import('interface-datastore').Batch} Batch
 * @typedef {import('../address-book.js').Address} Address
 */ /**
 * @typedef {Object} PersistentPeerStoreProperties
 * @property {PeerId} peerId
 * @property {import('interface-datastore').Datastore} datastore
 *
 * @typedef {Object} PersistentPeerStoreOptions
 * @property {number} [threshold = 5] - Number of dirty peers allowed before commit data.
 */ /**
 * Responsible for managing the persistence of data in the PeerStore.
 */ class $078466b88f051b25$var$PersistentPeerStore extends $4v27J {
    /**
   * @class
   * @param {PersistentPeerStoreProperties & PersistentPeerStoreOptions} properties
   */ constructor({ peerId: peerId, datastore: datastore, threshold: threshold = 5 }){
        super({
            peerId: peerId
        });
        /**
     * Backend datastore used to persist data.
     */ this._datastore = datastore;
        /**
     * Peers modified after the latest data persisted.
     */ this._dirtyPeers = new Set();
        /**
     * Peers metadata changed mapping peer identifers to metadata changed.
     *
     * @type {Map<string, Set<string>>}
     */ this._dirtyMetadata = new Map();
        this.threshold = threshold;
        this._addDirtyPeer = this._addDirtyPeer.bind(this);
    }
    /**
   * Start Persistent PeerStore.
   *
   * @returns {Promise<void>}
   */ async start() {
        $078466b88f051b25$var$log("PeerStore is starting");
        // Handlers for dirty peers
        this.on("change:protocols", this._addDirtyPeer);
        this.on("change:multiaddrs", this._addDirtyPeer);
        this.on("change:pubkey", this._addDirtyPeerKey);
        this.on("change:metadata", this._addDirtyPeerMetadata);
        // Load data
        for await (const entry of this._datastore.query({
            prefix: $078466b88f051b25$require$NAMESPACE_COMMON
        }))await this._processDatastoreEntry(entry);
        $078466b88f051b25$var$log("PeerStore started");
    }
    /**
   * Stop Persistent PeerStore.
   *
   * @returns {Promise<void>}
   */ async stop() {
        $078466b88f051b25$var$log("PeerStore is stopping");
        this.removeAllListeners();
        await this._commitData();
        $078466b88f051b25$var$log("PeerStore stopped");
    }
    /**
   * Add modified peer to the dirty set
   *
   * @private
   * @param {Object} params
   * @param {PeerId} params.peerId
   */ _addDirtyPeer({ peerId: peerId }) {
        const peerIdstr = peerId.toB58String();
        $078466b88f051b25$var$log("add dirty peer", peerIdstr);
        this._dirtyPeers.add(peerIdstr);
        if (this._dirtyPeers.size >= this.threshold) // Commit current data
        this._commitData().catch((err)=>{
            $078466b88f051b25$var$log.error("error committing data", err);
        });
    }
    /**
   * Add modified peer key to the dirty set
   *
   * @private
   * @param {Object} params
   * @param {PeerId} params.peerId
   */ _addDirtyPeerKey({ peerId: peerId }) {
        // Not add if inline key available
        if (peerId.hasInlinePublicKey()) return;
        const peerIdstr = peerId.toB58String();
        $078466b88f051b25$var$log("add dirty peer key", peerIdstr);
        this._dirtyPeers.add(peerIdstr);
        if (this._dirtyPeers.size >= this.threshold) // Commit current data
        this._commitData().catch((err)=>{
            $078466b88f051b25$var$log.error("error committing data", err);
        });
    }
    /**
   * Add modified metadata peer to the set.
   *
   * @private
   * @param {Object} params
   * @param {PeerId} params.peerId
   * @param {string} params.metadata
   */ _addDirtyPeerMetadata({ peerId: peerId, metadata: metadata }) {
        const peerIdstr = peerId.toB58String();
        $078466b88f051b25$var$log("add dirty metadata peer", peerIdstr);
        this._dirtyPeers.add(peerIdstr);
        // Add dirty metadata key
        const mData = this._dirtyMetadata.get(peerIdstr) || new Set();
        mData.add(metadata);
        this._dirtyMetadata.set(peerIdstr, mData);
        if (this._dirtyPeers.size >= this.threshold) // Commit current data
        this._commitData().catch((err)=>{
            $078466b88f051b25$var$log.error("error committing data", err);
        });
    }
    /**
   * Add all the peers current data to a datastore batch and commit it.
   *
   * @private
   * @returns {Promise<void>}
   */ async _commitData() {
        const commitPeers = Array.from(this._dirtyPeers);
        if (!commitPeers.length) return;
        // Clear Dirty Peers set
        this._dirtyPeers.clear();
        $078466b88f051b25$var$log("create batch commit");
        const batch = this._datastore.batch();
        for (const peerIdStr of commitPeers){
            // PeerId
            const peerId = this.keyBook.data.get(peerIdStr) || $ksmXv.createFromB58String(peerIdStr);
            // Address Book
            this._batchAddressBook(peerId, batch);
            // Key Book
            !peerId.hasInlinePublicKey() && this._batchKeyBook(peerId, batch);
            // Metadata Book
            this._batchMetadataBook(peerId, batch);
            // Proto Book
            this._batchProtoBook(peerId, batch);
        }
        await batch.commit();
        $078466b88f051b25$var$log("batch committed");
    }
    /**
   * Add address book data of the peer to the batch.
   *
   * @private
   * @param {PeerId} peerId
   * @param {Batch} batch
   */ _batchAddressBook(peerId, batch) {
        const b32key = peerId.toString();
        const key = new $078466b88f051b25$require$Key(`${$078466b88f051b25$require$NAMESPACE_ADDRESS}${b32key}`);
        const entry = this.addressBook.data.get(peerId.toB58String());
        try {
            // Deleted from the book
            if (!entry) {
                batch.delete(key);
                return;
            }
            const encodedData = $078466b88f051b25$require$Addresses.encode({
                addrs: entry.addresses.map((address)=>({
                        multiaddr: address.multiaddr.bytes,
                        isCertified: address.isCertified
                    })),
                certifiedRecord: entry.record ? {
                    seq: entry.record.seqNumber,
                    raw: entry.record.raw
                } : undefined
            }).finish();
            batch.put(key, encodedData);
        } catch (/** @type {any} */ err) {
            $078466b88f051b25$var$log.error(err);
        }
    }
    /**
   * Add Key book data of the peer to the batch.
   *
   * @private
   * @param {PeerId} peerId
   * @param {Batch} batch
   */ _batchKeyBook(peerId, batch) {
        const b32key = peerId.toString();
        const key = new $078466b88f051b25$require$Key(`${$078466b88f051b25$require$NAMESPACE_KEYS}${b32key}`);
        try {
            // Deleted from the book
            if (!peerId.pubKey) {
                batch.delete(key);
                return;
            }
            const encodedData = peerId.marshalPubKey();
            batch.put(key, encodedData);
        } catch (/** @type {any} */ err) {
            $078466b88f051b25$var$log.error(err);
        }
    }
    /**
   * Add metadata book data of the peer to the batch.
   *
   * @private
   * @param {PeerId} peerId
   * @param {Batch} batch
   */ _batchMetadataBook(peerId, batch) {
        const b32key = peerId.toString();
        const dirtyMetada = this._dirtyMetadata.get(peerId.toB58String()) || [];
        try {
            dirtyMetada.forEach((/** @type {string} */ dirtyKey)=>{
                const key = new $078466b88f051b25$require$Key(`${$078466b88f051b25$require$NAMESPACE_METADATA}${b32key}/${dirtyKey}`);
                const dirtyValue = this.metadataBook.getValue(peerId, dirtyKey);
                if (dirtyValue) batch.put(key, dirtyValue);
                else batch.delete(key);
            });
        } catch (/** @type {any} */ err) {
            $078466b88f051b25$var$log.error(err);
        }
    }
    /**
   * Add proto book data of the peer to the batch.
   *
   * @private
   * @param {PeerId} peerId
   * @param {Batch} batch
   */ _batchProtoBook(peerId, batch) {
        const b32key = peerId.toString();
        const key = new $078466b88f051b25$require$Key(`${$078466b88f051b25$require$NAMESPACE_PROTOCOL}${b32key}`);
        const protocols = this.protoBook.get(peerId);
        try {
            // Deleted from the book
            if (!protocols) {
                batch.delete(key);
                return;
            }
            const encodedData = $078466b88f051b25$require$Protocols.encode({
                protocols: protocols
            }).finish();
            batch.put(key, encodedData);
        } catch (/** @type {any} */ err) {
            $078466b88f051b25$var$log.error(err);
        }
    }
    /**
   * Process datastore entry and add its data to the correct book.
   *
   * @private
   * @param {Object} params
   * @param {Key} params.key - datastore key
   * @param {Uint8Array} params.value - datastore value stored
   * @returns {Promise<void>}
   */ async _processDatastoreEntry({ key: key, value: value }) {
        try {
            const keyParts = key.toString().split("/");
            const peerId = $ksmXv.createFromBytes($078466b88f051b25$require$base32.decode(keyParts[3]));
            let decoded;
            switch(keyParts[2]){
                case "addrs":
                    decoded = $078466b88f051b25$require$Addresses.decode(value);
                    // @ts-ignore protected function
                    this.addressBook._setData(peerId, {
                        addresses: decoded.addrs.map((address)=>({
                                multiaddr: new $078466b88f051b25$require$Multiaddr(address.multiaddr),
                                isCertified: Boolean(address.isCertified)
                            })),
                        record: decoded.certifiedRecord ? {
                            raw: decoded.certifiedRecord.raw,
                            seqNumber: decoded.certifiedRecord.seq
                        } : undefined
                    }, {
                        emit: false
                    });
                    break;
                case "keys":
                    decoded = await $ksmXv.createFromPubKey(value);
                    // @ts-ignore protected function
                    this.keyBook._setData(decoded, decoded, {
                        emit: false
                    });
                    break;
                case "metadata":
                    this.metadataBook._setValue(peerId, keyParts[4], value, {
                        emit: false
                    });
                    break;
                case "protos":
                    decoded = $078466b88f051b25$require$Protocols.decode(value);
                    // @ts-ignore protected function
                    this.protoBook._setData(peerId, new Set(decoded.protocols), {
                        emit: false
                    });
                    break;
                default:
                    $078466b88f051b25$var$log("invalid data persisted for: ", key.toString());
            }
        } catch (/** @type {any} */ err) {
            $078466b88f051b25$var$log.error(err);
        }
    }
}
module.exports = $078466b88f051b25$var$PersistentPeerStore;

});
parcelRequire.register("5MXvK", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE_COMMON", () => $436f99183133e946$export$764853765bbb0b78, (v) => $436f99183133e946$export$764853765bbb0b78 = v);
$parcel$export(module.exports, "NAMESPACE_ADDRESS", () => $436f99183133e946$export$cd81f59aa6bc31b9, (v) => $436f99183133e946$export$cd81f59aa6bc31b9 = v);
$parcel$export(module.exports, "NAMESPACE_KEYS", () => $436f99183133e946$export$b5b1bdc22e734773, (v) => $436f99183133e946$export$b5b1bdc22e734773 = v);
$parcel$export(module.exports, "NAMESPACE_METADATA", () => $436f99183133e946$export$3f6d9535990b9fc3, (v) => $436f99183133e946$export$3f6d9535990b9fc3 = v);
$parcel$export(module.exports, "NAMESPACE_PROTOCOL", () => $436f99183133e946$export$ed878f07608c55e2, (v) => $436f99183133e946$export$ed878f07608c55e2 = v);
var $436f99183133e946$export$764853765bbb0b78;
// /peers/protos/<b32 peer id no padding>
var $436f99183133e946$export$cd81f59aa6bc31b9;
// /peers/keys/<b32 peer id no padding>
var $436f99183133e946$export$b5b1bdc22e734773;
// /peers/metadata/<b32 peer id no padding>/<key>
var $436f99183133e946$export$3f6d9535990b9fc3;
// /peers/addrs/<b32 peer id no padding>
var $436f99183133e946$export$ed878f07608c55e2;
"use strict";
$436f99183133e946$export$764853765bbb0b78 = "/peers/";
$436f99183133e946$export$cd81f59aa6bc31b9 = "/peers/addrs/";
$436f99183133e946$export$b5b1bdc22e734773 = "/peers/keys/";
$436f99183133e946$export$3f6d9535990b9fc3 = "/peers/metadata/";
$436f99183133e946$export$ed878f07608c55e2 = "/peers/protos/";

});

parcelRequire.register("94fFA", function(module, exports) {
/*eslint-disable*/ "use strict";

var $liRmU = parcelRequire("liRmU");
// Common aliases
var $69a0a47d0c20e1d5$var$$Reader = $liRmU.Reader, $69a0a47d0c20e1d5$var$$Writer = $liRmU.Writer, $69a0a47d0c20e1d5$var$$util = $liRmU.util;
// Exported root namespace
var $69a0a47d0c20e1d5$var$$root = $liRmU.roots["libp2p-address-book"] || ($liRmU.roots["libp2p-address-book"] = {});
$69a0a47d0c20e1d5$var$$root.Addresses = function() {
    /**
     * Properties of an Addresses.
     * @exports IAddresses
     * @interface IAddresses
     * @property {Array.<Addresses.IAddress>|null} [addrs] Addresses addrs
     * @property {Addresses.ICertifiedRecord|null} [certifiedRecord] Addresses certifiedRecord
     */ /**
     * Constructs a new Addresses.
     * @exports Addresses
     * @classdesc Represents an Addresses.
     * @implements IAddresses
     * @constructor
     * @param {IAddresses=} [p] Properties to set
     */ function Addresses(p) {
        this.addrs = [];
        if (p) {
            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }
    }
    /**
     * Addresses addrs.
     * @member {Array.<Addresses.IAddress>} addrs
     * @memberof Addresses
     * @instance
     */ Addresses.prototype.addrs = $69a0a47d0c20e1d5$var$$util.emptyArray;
    /**
     * Addresses certifiedRecord.
     * @member {Addresses.ICertifiedRecord|null|undefined} certifiedRecord
     * @memberof Addresses
     * @instance
     */ Addresses.prototype.certifiedRecord = null;
    /**
     * Encodes the specified Addresses message. Does not implicitly {@link Addresses.verify|verify} messages.
     * @function encode
     * @memberof Addresses
     * @static
     * @param {IAddresses} m Addresses message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ Addresses.encode = function encode(m, w) {
        if (!w) w = $69a0a47d0c20e1d5$var$$Writer.create();
        if (m.addrs != null && m.addrs.length) for(var i = 0; i < m.addrs.length; ++i)$69a0a47d0c20e1d5$var$$root.Addresses.Address.encode(m.addrs[i], w.uint32(10).fork()).ldelim();
        if (m.certifiedRecord != null && Object.hasOwnProperty.call(m, "certifiedRecord")) $69a0a47d0c20e1d5$var$$root.Addresses.CertifiedRecord.encode(m.certifiedRecord, w.uint32(18).fork()).ldelim();
        return w;
    };
    /**
     * Decodes an Addresses message from the specified reader or buffer.
     * @function decode
     * @memberof Addresses
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {Addresses} Addresses
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ Addresses.decode = function decode(r, l) {
        if (!(r instanceof $69a0a47d0c20e1d5$var$$Reader)) r = $69a0a47d0c20e1d5$var$$Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l, m = new $69a0a47d0c20e1d5$var$$root.Addresses();
        while(r.pos < c){
            var t = r.uint32();
            switch(t >>> 3){
                case 1:
                    if (!(m.addrs && m.addrs.length)) m.addrs = [];
                    m.addrs.push($69a0a47d0c20e1d5$var$$root.Addresses.Address.decode(r, r.uint32()));
                    break;
                case 2:
                    m.certifiedRecord = $69a0a47d0c20e1d5$var$$root.Addresses.CertifiedRecord.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
            }
        }
        return m;
    };
    /**
     * Creates an Addresses message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Addresses
     * @static
     * @param {Object.<string,*>} d Plain object
     * @returns {Addresses} Addresses
     */ Addresses.fromObject = function fromObject(d) {
        if (d instanceof $69a0a47d0c20e1d5$var$$root.Addresses) return d;
        var m = new $69a0a47d0c20e1d5$var$$root.Addresses();
        if (d.addrs) {
            if (!Array.isArray(d.addrs)) throw TypeError(".Addresses.addrs: array expected");
            m.addrs = [];
            for(var i = 0; i < d.addrs.length; ++i){
                if (typeof d.addrs[i] !== "object") throw TypeError(".Addresses.addrs: object expected");
                m.addrs[i] = $69a0a47d0c20e1d5$var$$root.Addresses.Address.fromObject(d.addrs[i]);
            }
        }
        if (d.certifiedRecord != null) {
            if (typeof d.certifiedRecord !== "object") throw TypeError(".Addresses.certifiedRecord: object expected");
            m.certifiedRecord = $69a0a47d0c20e1d5$var$$root.Addresses.CertifiedRecord.fromObject(d.certifiedRecord);
        }
        return m;
    };
    /**
     * Creates a plain object from an Addresses message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Addresses
     * @static
     * @param {Addresses} m Addresses
     * @param {$protobuf.IConversionOptions} [o] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ Addresses.toObject = function toObject(m, o) {
        if (!o) o = {};
        var d = {};
        if (o.arrays || o.defaults) d.addrs = [];
        if (o.defaults) d.certifiedRecord = null;
        if (m.addrs && m.addrs.length) {
            d.addrs = [];
            for(var j = 0; j < m.addrs.length; ++j)d.addrs[j] = $69a0a47d0c20e1d5$var$$root.Addresses.Address.toObject(m.addrs[j], o);
        }
        if (m.certifiedRecord != null && m.hasOwnProperty("certifiedRecord")) d.certifiedRecord = $69a0a47d0c20e1d5$var$$root.Addresses.CertifiedRecord.toObject(m.certifiedRecord, o);
        return d;
    };
    /**
     * Converts this Addresses to JSON.
     * @function toJSON
     * @memberof Addresses
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ Addresses.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
    };
    Addresses.Address = function() {
        /**
         * Properties of an Address.
         * @memberof Addresses
         * @interface IAddress
         * @property {Uint8Array|null} [multiaddr] Address multiaddr
         * @property {boolean|null} [isCertified] Address isCertified
         */ /**
         * Constructs a new Address.
         * @memberof Addresses
         * @classdesc Represents an Address.
         * @implements IAddress
         * @constructor
         * @param {Addresses.IAddress=} [p] Properties to set
         */ function Address(p) {
            if (p) {
                for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
            }
        }
        /**
         * Address multiaddr.
         * @member {Uint8Array} multiaddr
         * @memberof Addresses.Address
         * @instance
         */ Address.prototype.multiaddr = $69a0a47d0c20e1d5$var$$util.newBuffer([]);
        /**
         * Address isCertified.
         * @member {boolean} isCertified
         * @memberof Addresses.Address
         * @instance
         */ Address.prototype.isCertified = false;
        /**
         * Encodes the specified Address message. Does not implicitly {@link Addresses.Address.verify|verify} messages.
         * @function encode
         * @memberof Addresses.Address
         * @static
         * @param {Addresses.IAddress} m Address message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ Address.encode = function encode(m, w) {
            if (!w) w = $69a0a47d0c20e1d5$var$$Writer.create();
            if (m.multiaddr != null && Object.hasOwnProperty.call(m, "multiaddr")) w.uint32(10).bytes(m.multiaddr);
            if (m.isCertified != null && Object.hasOwnProperty.call(m, "isCertified")) w.uint32(16).bool(m.isCertified);
            return w;
        };
        /**
         * Decodes an Address message from the specified reader or buffer.
         * @function decode
         * @memberof Addresses.Address
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {Addresses.Address} Address
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ Address.decode = function decode(r, l) {
            if (!(r instanceof $69a0a47d0c20e1d5$var$$Reader)) r = $69a0a47d0c20e1d5$var$$Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $69a0a47d0c20e1d5$var$$root.Addresses.Address();
            while(r.pos < c){
                var t = r.uint32();
                switch(t >>> 3){
                    case 1:
                        m.multiaddr = r.bytes();
                        break;
                    case 2:
                        m.isCertified = r.bool();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };
        /**
         * Creates an Address message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Addresses.Address
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {Addresses.Address} Address
         */ Address.fromObject = function fromObject(d) {
            if (d instanceof $69a0a47d0c20e1d5$var$$root.Addresses.Address) return d;
            var m = new $69a0a47d0c20e1d5$var$$root.Addresses.Address();
            if (d.multiaddr != null) {
                if (typeof d.multiaddr === "string") $69a0a47d0c20e1d5$var$$util.base64.decode(d.multiaddr, m.multiaddr = $69a0a47d0c20e1d5$var$$util.newBuffer($69a0a47d0c20e1d5$var$$util.base64.length(d.multiaddr)), 0);
                else if (d.multiaddr.length) m.multiaddr = d.multiaddr;
            }
            if (d.isCertified != null) m.isCertified = Boolean(d.isCertified);
            return m;
        };
        /**
         * Creates a plain object from an Address message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Addresses.Address
         * @static
         * @param {Addresses.Address} m Address
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ Address.toObject = function toObject(m, o) {
            if (!o) o = {};
            var d = {};
            if (o.defaults) {
                if (o.bytes === String) d.multiaddr = "";
                else {
                    d.multiaddr = [];
                    if (o.bytes !== Array) d.multiaddr = $69a0a47d0c20e1d5$var$$util.newBuffer(d.multiaddr);
                }
                d.isCertified = false;
            }
            if (m.multiaddr != null && m.hasOwnProperty("multiaddr")) d.multiaddr = o.bytes === String ? $69a0a47d0c20e1d5$var$$util.base64.encode(m.multiaddr, 0, m.multiaddr.length) : o.bytes === Array ? Array.prototype.slice.call(m.multiaddr) : m.multiaddr;
            if (m.isCertified != null && m.hasOwnProperty("isCertified")) d.isCertified = m.isCertified;
            return d;
        };
        /**
         * Converts this Address to JSON.
         * @function toJSON
         * @memberof Addresses.Address
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ Address.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
        };
        return Address;
    }();
    Addresses.CertifiedRecord = function() {
        /**
         * Properties of a CertifiedRecord.
         * @memberof Addresses
         * @interface ICertifiedRecord
         * @property {number|null} [seq] CertifiedRecord seq
         * @property {Uint8Array|null} [raw] CertifiedRecord raw
         */ /**
         * Constructs a new CertifiedRecord.
         * @memberof Addresses
         * @classdesc Represents a CertifiedRecord.
         * @implements ICertifiedRecord
         * @constructor
         * @param {Addresses.ICertifiedRecord=} [p] Properties to set
         */ function CertifiedRecord(p) {
            if (p) {
                for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
            }
        }
        /**
         * CertifiedRecord seq.
         * @member {number} seq
         * @memberof Addresses.CertifiedRecord
         * @instance
         */ CertifiedRecord.prototype.seq = $69a0a47d0c20e1d5$var$$util.Long ? $69a0a47d0c20e1d5$var$$util.Long.fromBits(0, 0, true) : 0;
        /**
         * CertifiedRecord raw.
         * @member {Uint8Array} raw
         * @memberof Addresses.CertifiedRecord
         * @instance
         */ CertifiedRecord.prototype.raw = $69a0a47d0c20e1d5$var$$util.newBuffer([]);
        /**
         * Encodes the specified CertifiedRecord message. Does not implicitly {@link Addresses.CertifiedRecord.verify|verify} messages.
         * @function encode
         * @memberof Addresses.CertifiedRecord
         * @static
         * @param {Addresses.ICertifiedRecord} m CertifiedRecord message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CertifiedRecord.encode = function encode(m, w) {
            if (!w) w = $69a0a47d0c20e1d5$var$$Writer.create();
            if (m.seq != null && Object.hasOwnProperty.call(m, "seq")) w.uint32(8).uint64(m.seq);
            if (m.raw != null && Object.hasOwnProperty.call(m, "raw")) w.uint32(18).bytes(m.raw);
            return w;
        };
        /**
         * Decodes a CertifiedRecord message from the specified reader or buffer.
         * @function decode
         * @memberof Addresses.CertifiedRecord
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {Addresses.CertifiedRecord} CertifiedRecord
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CertifiedRecord.decode = function decode(r, l) {
            if (!(r instanceof $69a0a47d0c20e1d5$var$$Reader)) r = $69a0a47d0c20e1d5$var$$Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $69a0a47d0c20e1d5$var$$root.Addresses.CertifiedRecord();
            while(r.pos < c){
                var t = r.uint32();
                switch(t >>> 3){
                    case 1:
                        m.seq = r.uint64();
                        break;
                    case 2:
                        m.raw = r.bytes();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };
        /**
         * Creates a CertifiedRecord message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Addresses.CertifiedRecord
         * @static
         * @param {Object.<string,*>} d Plain object
         * @returns {Addresses.CertifiedRecord} CertifiedRecord
         */ CertifiedRecord.fromObject = function fromObject(d) {
            if (d instanceof $69a0a47d0c20e1d5$var$$root.Addresses.CertifiedRecord) return d;
            var m = new $69a0a47d0c20e1d5$var$$root.Addresses.CertifiedRecord();
            if (d.seq != null) {
                if ($69a0a47d0c20e1d5$var$$util.Long) (m.seq = $69a0a47d0c20e1d5$var$$util.Long.fromValue(d.seq)).unsigned = true;
                else if (typeof d.seq === "string") m.seq = parseInt(d.seq, 10);
                else if (typeof d.seq === "number") m.seq = d.seq;
                else if (typeof d.seq === "object") m.seq = new $69a0a47d0c20e1d5$var$$util.LongBits(d.seq.low >>> 0, d.seq.high >>> 0).toNumber(true);
            }
            if (d.raw != null) {
                if (typeof d.raw === "string") $69a0a47d0c20e1d5$var$$util.base64.decode(d.raw, m.raw = $69a0a47d0c20e1d5$var$$util.newBuffer($69a0a47d0c20e1d5$var$$util.base64.length(d.raw)), 0);
                else if (d.raw.length) m.raw = d.raw;
            }
            return m;
        };
        /**
         * Creates a plain object from a CertifiedRecord message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Addresses.CertifiedRecord
         * @static
         * @param {Addresses.CertifiedRecord} m CertifiedRecord
         * @param {$protobuf.IConversionOptions} [o] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CertifiedRecord.toObject = function toObject(m, o) {
            if (!o) o = {};
            var d = {};
            if (o.defaults) {
                if ($69a0a47d0c20e1d5$var$$util.Long) {
                    var n = new $69a0a47d0c20e1d5$var$$util.Long(0, 0, true);
                    d.seq = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else d.seq = o.longs === String ? "0" : 0;
                if (o.bytes === String) d.raw = "";
                else {
                    d.raw = [];
                    if (o.bytes !== Array) d.raw = $69a0a47d0c20e1d5$var$$util.newBuffer(d.raw);
                }
            }
            if (m.seq != null && m.hasOwnProperty("seq")) {
                if (typeof m.seq === "number") d.seq = o.longs === String ? String(m.seq) : m.seq;
                else d.seq = o.longs === String ? $69a0a47d0c20e1d5$var$$util.Long.prototype.toString.call(m.seq) : o.longs === Number ? new $69a0a47d0c20e1d5$var$$util.LongBits(m.seq.low >>> 0, m.seq.high >>> 0).toNumber(true) : m.seq;
            }
            if (m.raw != null && m.hasOwnProperty("raw")) d.raw = o.bytes === String ? $69a0a47d0c20e1d5$var$$util.base64.encode(m.raw, 0, m.raw.length) : o.bytes === Array ? Array.prototype.slice.call(m.raw) : m.raw;
            return d;
        };
        /**
         * Converts this CertifiedRecord to JSON.
         * @function toJSON
         * @memberof Addresses.CertifiedRecord
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CertifiedRecord.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
        };
        return CertifiedRecord;
    }();
    return Addresses;
}();
module.exports = $69a0a47d0c20e1d5$var$$root;

});

parcelRequire.register("iNjUP", function(module, exports) {
/*eslint-disable*/ "use strict";

var $liRmU = parcelRequire("liRmU");
// Common aliases
var $daec40718c3391f3$var$$Reader = $liRmU.Reader, $daec40718c3391f3$var$$Writer = $liRmU.Writer, $daec40718c3391f3$var$$util = $liRmU.util;
// Exported root namespace
var $daec40718c3391f3$var$$root = $liRmU.roots["libp2p-proto-book"] || ($liRmU.roots["libp2p-proto-book"] = {});
$daec40718c3391f3$var$$root.Protocols = function() {
    /**
     * Properties of a Protocols.
     * @exports IProtocols
     * @interface IProtocols
     * @property {Array.<string>|null} [protocols] Protocols protocols
     */ /**
     * Constructs a new Protocols.
     * @exports Protocols
     * @classdesc Represents a Protocols.
     * @implements IProtocols
     * @constructor
     * @param {IProtocols=} [p] Properties to set
     */ function Protocols(p) {
        this.protocols = [];
        if (p) {
            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }
    }
    /**
     * Protocols protocols.
     * @member {Array.<string>} protocols
     * @memberof Protocols
     * @instance
     */ Protocols.prototype.protocols = $daec40718c3391f3$var$$util.emptyArray;
    /**
     * Encodes the specified Protocols message. Does not implicitly {@link Protocols.verify|verify} messages.
     * @function encode
     * @memberof Protocols
     * @static
     * @param {IProtocols} m Protocols message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ Protocols.encode = function encode(m, w) {
        if (!w) w = $daec40718c3391f3$var$$Writer.create();
        if (m.protocols != null && m.protocols.length) for(var i = 0; i < m.protocols.length; ++i)w.uint32(10).string(m.protocols[i]);
        return w;
    };
    /**
     * Decodes a Protocols message from the specified reader or buffer.
     * @function decode
     * @memberof Protocols
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {Protocols} Protocols
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ Protocols.decode = function decode(r, l) {
        if (!(r instanceof $daec40718c3391f3$var$$Reader)) r = $daec40718c3391f3$var$$Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l, m = new $daec40718c3391f3$var$$root.Protocols();
        while(r.pos < c){
            var t = r.uint32();
            switch(t >>> 3){
                case 1:
                    if (!(m.protocols && m.protocols.length)) m.protocols = [];
                    m.protocols.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
            }
        }
        return m;
    };
    /**
     * Creates a Protocols message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Protocols
     * @static
     * @param {Object.<string,*>} d Plain object
     * @returns {Protocols} Protocols
     */ Protocols.fromObject = function fromObject(d) {
        if (d instanceof $daec40718c3391f3$var$$root.Protocols) return d;
        var m = new $daec40718c3391f3$var$$root.Protocols();
        if (d.protocols) {
            if (!Array.isArray(d.protocols)) throw TypeError(".Protocols.protocols: array expected");
            m.protocols = [];
            for(var i = 0; i < d.protocols.length; ++i)m.protocols[i] = String(d.protocols[i]);
        }
        return m;
    };
    /**
     * Creates a plain object from a Protocols message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Protocols
     * @static
     * @param {Protocols} m Protocols
     * @param {$protobuf.IConversionOptions} [o] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ Protocols.toObject = function toObject(m, o) {
        if (!o) o = {};
        var d = {};
        if (o.arrays || o.defaults) d.protocols = [];
        if (m.protocols && m.protocols.length) {
            d.protocols = [];
            for(var j = 0; j < m.protocols.length; ++j)d.protocols[j] = m.protocols[j];
        }
        return d;
    };
    /**
     * Converts this Protocols to JSON.
     * @function toJSON
     * @memberof Protocols
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ Protocols.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
    };
    return Protocols;
}();
module.exports = $daec40718c3391f3$var$$root;

});


parcelRequire.register("4S67D", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $38c0f44cdc014b4e$var$log = Object.assign($jjmHV("libp2p:registrar"), {
    error: $jjmHV("libp2p:registrar:err")
});

var $20Lm5 = parcelRequire("20Lm5");

var $8yAh4 = parcelRequire("8yAh4");
const { codes: { ERR_INVALID_PARAMETERS: $38c0f44cdc014b4e$var$ERR_INVALID_PARAMETERS } } = $8yAh4;

var $ha6Th = parcelRequire("ha6Th");
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('./peer-store')} PeerStore
 * @typedef {import('./connection-manager')} ConnectionManager
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('./').HandlerProps} HandlerProps
 */ /**
 *
 */ /**
 * Responsible for notifying registered protocols of events in the network.
 */ class $38c0f44cdc014b4e$var$Registrar {
    /**
   * @param {Object} props
   * @param {PeerStore} props.peerStore
   * @param {ConnectionManager} props.connectionManager
   * @class
   */ constructor({ peerStore: peerStore, connectionManager: connectionManager }){
        // Used on topology to listen for protocol changes
        this.peerStore = peerStore;
        this.connectionManager = connectionManager;
        /**
     * Map of topologies
     *
     * @type {Map<string, Topology>}
     */ this.topologies = new Map();
        /** @type {(protocols: string[]|string, handler: (props: HandlerProps) => void) => void} */ // @ts-ignore handle is not optional
        this._handle = undefined;
        this._onDisconnect = this._onDisconnect.bind(this);
        this.connectionManager.on("peer:disconnect", this._onDisconnect);
    }
    /**
   * @returns {(protocols: string[]|string, handler: (props: HandlerProps) => void) => void}
   */ get handle() {
        return this._handle;
    }
    /**
   * @param {(protocols: string[]|string, handler: (props: HandlerProps) => void) => void} handle
   */ set handle(handle) {
        this._handle = handle;
    }
    /**
   * Get a connection with a peer.
   *
   * @param {PeerId} peerId
   * @returns {Connection | null}
   */ getConnection(peerId) {
        return this.connectionManager.get(peerId);
    }
    /**
   * Register handlers for a set of multicodecs given
   *
   * @param {Topology} topology - protocol topology
   * @returns {string} registrar identifier
   */ register(topology) {
        if (!$ha6Th.isTopology(topology)) {
            $38c0f44cdc014b4e$var$log.error("topology must be an instance of interfaces/topology");
            throw $20Lm5(new Error("topology must be an instance of interfaces/topology"), $38c0f44cdc014b4e$var$ERR_INVALID_PARAMETERS);
        }
        // Create topology
        const id = (Math.random() * 1e9).toString(36) + Date.now();
        this.topologies.set(id, topology);
        // Set registrar
        topology.registrar = this;
        return id;
    }
    /**
   * Unregister topology.
   *
   * @param {string} id - registrar identifier
   * @returns {boolean} unregistered successfully
   */ unregister(id) {
        return this.topologies.delete(id);
    }
    /**
   * Remove a disconnected peer from the record
   *
   * @param {Connection} connection
   * @returns {void}
   */ _onDisconnect(connection) {
        for (const [, topology] of this.topologies)topology.disconnect(connection.remotePeer);
    }
}
module.exports = $38c0f44cdc014b4e$var$Registrar;

});
parcelRequire.register("ha6Th", function(module, exports) {
"use strict";
const $c7e8b72f9f81d247$var$noop = ()=>{};
const $c7e8b72f9f81d247$var$topologySymbol = Symbol.for("@libp2p/js-interfaces/topology");
/**
 * @typedef {import('peer-id')} PeerId
 */ /**
 * @typedef {Object} Options
 * @property {number} [min=0] - minimum needed connections.
 * @property {number} [max=Infinity] - maximum needed connections.
 * @property {Handlers} [handlers]
 *
 * @typedef {Object} Handlers
 * @property {(peerId: PeerId, conn: Connection) => void} [onConnect] - protocol "onConnect" handler
 * @property {(peerId: PeerId, error?:Error) => void} [onDisconnect] - protocol "onDisconnect" handler
 *
 * @typedef {import('../connection/connection')} Connection
 */ class $c7e8b72f9f81d247$var$Topology {
    /**
   * @param {Options} options
   */ constructor({ min: min = 0, max: max = Infinity, handlers: handlers = {} }){
        this.min = min;
        this.max = max;
        // Handlers
        this._onConnect = handlers.onConnect || $c7e8b72f9f81d247$var$noop;
        this._onDisconnect = handlers.onDisconnect || $c7e8b72f9f81d247$var$noop;
        /**
     * Set of peers that support the protocol.
     *
     * @type {Set<string>}
     */ this.peers = new Set();
    }
    get [Symbol.toStringTag]() {
        return "Topology";
    }
    get [$c7e8b72f9f81d247$var$topologySymbol]() {
        return true;
    }
    /**
   * Checks if the given value is a Topology instance.
   *
   * @param {any} other
   * @returns {other is Topology}
   */ static isTopology(other) {
        return Boolean(other && other[$c7e8b72f9f81d247$var$topologySymbol]);
    }
    /**
   * @param {any} registrar
   */ set registrar(registrar) {
        this._registrar = registrar;
    }
    /**
   * Notify about peer disconnected event.
   *
   * @param {PeerId} peerId
   * @returns {void}
   */ disconnect(peerId) {
        this._onDisconnect(peerId);
    }
}
module.exports = $c7e8b72f9f81d247$var$Topology;

});


parcelRequire.register("1KymX", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const log = Object.assign($jjmHV("libp2p:ping"), {
    error: $jjmHV("libp2p:ping:err")
});

var $20Lm5 = parcelRequire("20Lm5");

var $8yAh4 = parcelRequire("8yAh4");
var $1464bf534a495ad7$require$codes = $8yAh4.codes;

var $jqljq = parcelRequire("jqljq");

var $d8Blz = parcelRequire("d8Blz");
var $1464bf534a495ad7$require$pipe = $d8Blz.pipe;

var $9Jhre = parcelRequire("9Jhre");
var $1464bf534a495ad7$require$toBuffer = $9Jhre.toBuffer;

var $9IZzN = parcelRequire("9IZzN");
var $1464bf534a495ad7$require$collect = $9IZzN.collect;
var $1464bf534a495ad7$require$take = $9IZzN.take;

var $ijWXY = parcelRequire("ijWXY");
var $1464bf534a495ad7$require$equals = $ijWXY.equals;

var $8w9ZB = parcelRequire("8w9ZB");
var $1464bf534a495ad7$require$PROTOCOL_NAME = $8w9ZB.PROTOCOL_NAME;
var $1464bf534a495ad7$require$PING_LENGTH = $8w9ZB.PING_LENGTH;
var $1464bf534a495ad7$require$PROTOCOL_VERSION = $8w9ZB.PROTOCOL_VERSION;
/**
 * @typedef {import('../')} Libp2p
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxedStream} MuxedStream
 */ /**
 * Ping a given peer and wait for its response, getting the operation latency.
 *
 * @param {Libp2p} node
 * @param {PeerId|Multiaddr} peer
 * @returns {Promise<number>}
 */ async function ping(node, peer) {
    const protocol = `/${node._config.protocolPrefix}/${$1464bf534a495ad7$require$PROTOCOL_NAME}/${$1464bf534a495ad7$require$PROTOCOL_VERSION}`;
    // @ts-ignore multiaddr might not have toB58String
    log("dialing %s to %s", protocol, peer.toB58String ? peer.toB58String() : peer);
    const connection = await node.dial(peer);
    const { stream } = await connection.newStream(protocol);
    const start = Date.now();
    const data = $jqljq.randomBytes($1464bf534a495ad7$require$PING_LENGTH);
    const [result] = await $1464bf534a495ad7$require$pipe([
        data
    ], stream, (/** @type {MuxedStream} */ stream)=>$1464bf534a495ad7$require$take(1, stream), $1464bf534a495ad7$require$toBuffer, $1464bf534a495ad7$require$collect);
    const end = Date.now();
    if (!$1464bf534a495ad7$require$equals(data, result)) throw $20Lm5(new Error("Received wrong ping ack"), $1464bf534a495ad7$require$codes.ERR_WRONG_PING_ACK);
    return end - start;
}
/**
 * Subscribe ping protocol handler.
 *
 * @param {Libp2p} node
 */ function mount(node) {
    node.handle(`/${node._config.protocolPrefix}/${$1464bf534a495ad7$require$PROTOCOL_NAME}/${$1464bf534a495ad7$require$PROTOCOL_VERSION}`, ({ stream })=>$1464bf534a495ad7$require$pipe(stream, stream));
}
/**
 * Unsubscribe ping protocol handler.
 *
 * @param {Libp2p} node
 */ function unmount(node) {
    node.unhandle(`/${node._config.protocolPrefix}/${$1464bf534a495ad7$require$PROTOCOL_NAME}/${$1464bf534a495ad7$require$PROTOCOL_VERSION}`);
}
exports = module.exports = ping;
exports.mount = mount;
exports.unmount = unmount;

});
parcelRequire.register("9Jhre", function(module, exports) {
"use strict";

var $l7tTk = parcelRequire("l7tTk");
var $7155d7e9334abe14$require$Buffer = $l7tTk.Buffer;

var $hG3ux = parcelRequire("hG3ux");
module.exports = async function*(source) {
    for await (const b of source){
        if ($7155d7e9334abe14$require$Buffer.isBuffer(b)) yield b;
        else if ($hG3ux.isBufferList(b)) yield b.slice();
        else yield $7155d7e9334abe14$require$Buffer.from(b);
    }
};
module.exports.toBuffer = module.exports;
module.exports.toList = async function*(source) {
    for await (const b of source){
        if ($7155d7e9334abe14$require$Buffer.isBuffer(b)) yield new $hG3ux().append(b);
        else if ($hG3ux.isBufferList(b)) yield b;
        else yield new $hG3ux().append($7155d7e9334abe14$require$Buffer.from(b));
    }
};

});

parcelRequire.register("8w9ZB", function(module, exports) {
"use strict";
module.exports = {
    PROTOCOL: "/ipfs/ping/1.0.0",
    PING_LENGTH: 32,
    PROTOCOL_VERSION: "1.0.0",
    PROTOCOL_NAME: "ping"
};

});


parcelRequire.register("eEP47", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $aabc69a61ef5a5ed$var$log = Object.assign($jjmHV("libp2p:identify"), {
    error: $jjmHV("libp2p:identify:err")
});

var $20Lm5 = parcelRequire("20Lm5");

var $4zeIG = parcelRequire("4zeIG");

var $d8Blz = parcelRequire("d8Blz");
var $aabc69a61ef5a5ed$require$pipe = $d8Blz.pipe;

var $9IZzN = parcelRequire("9IZzN");
var $aabc69a61ef5a5ed$require$collect = $9IZzN.collect;
var $aabc69a61ef5a5ed$require$take = $9IZzN.take;
var $aabc69a61ef5a5ed$require$consume = $9IZzN.consume;

var $8cWjP = parcelRequire("8cWjP");
var $aabc69a61ef5a5ed$require$uint8ArrayFromString = $8cWjP.fromString;

var $ksmXv = parcelRequire("ksmXv");

var $aZLwC = parcelRequire("aZLwC");
var $aabc69a61ef5a5ed$require$Multiaddr = $aZLwC.Multiaddr;

var $9Jhre = parcelRequire("9Jhre");
var $aabc69a61ef5a5ed$require$toBuffer = $9Jhre.toBuffer;

var $f489q = parcelRequire("f489q");

var $4kY1w = parcelRequire("4kY1w");

var $ewhIy = parcelRequire("ewhIy");

var $hBHKi = parcelRequire("hBHKi");
var $aabc69a61ef5a5ed$require$MULTICODEC_IDENTIFY = $hBHKi.MULTICODEC_IDENTIFY;
var $aabc69a61ef5a5ed$require$MULTICODEC_IDENTIFY_PUSH = $hBHKi.MULTICODEC_IDENTIFY_PUSH;
var $aabc69a61ef5a5ed$require$IDENTIFY_PROTOCOL_VERSION = $hBHKi.IDENTIFY_PROTOCOL_VERSION;
var $aabc69a61ef5a5ed$require$MULTICODEC_IDENTIFY_PROTOCOL_NAME = $hBHKi.MULTICODEC_IDENTIFY_PROTOCOL_NAME;
var $aabc69a61ef5a5ed$require$MULTICODEC_IDENTIFY_PUSH_PROTOCOL_NAME = $hBHKi.MULTICODEC_IDENTIFY_PUSH_PROTOCOL_NAME;
var $aabc69a61ef5a5ed$require$MULTICODEC_IDENTIFY_PROTOCOL_VERSION = $hBHKi.MULTICODEC_IDENTIFY_PROTOCOL_VERSION;
var $aabc69a61ef5a5ed$require$MULTICODEC_IDENTIFY_PUSH_PROTOCOL_VERSION = $hBHKi.MULTICODEC_IDENTIFY_PUSH_PROTOCOL_VERSION;

var $8yAh4 = parcelRequire("8yAh4");
var $aabc69a61ef5a5ed$require$codes = $8yAh4.codes;
/**
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxedStream} MuxedStream
 */ /**
 * @typedef {Object} HostProperties
 * @property {string} agentVersion
 */ class $aabc69a61ef5a5ed$var$IdentifyService {
    /**
   * @param {import('../')} libp2p
   */ static getProtocolStr(libp2p) {
        return {
            identifyProtocolStr: `/${libp2p._config.protocolPrefix}/${$aabc69a61ef5a5ed$require$MULTICODEC_IDENTIFY_PROTOCOL_NAME}/${$aabc69a61ef5a5ed$require$MULTICODEC_IDENTIFY_PROTOCOL_VERSION}`,
            identifyPushProtocolStr: `/${libp2p._config.protocolPrefix}/${$aabc69a61ef5a5ed$require$MULTICODEC_IDENTIFY_PUSH_PROTOCOL_NAME}/${$aabc69a61ef5a5ed$require$MULTICODEC_IDENTIFY_PUSH_PROTOCOL_VERSION}`
        };
    }
    /**
   * @class
   * @param {Object} options
   * @param {import('../')} options.libp2p
   */ constructor({ libp2p: libp2p }){
        this._libp2p = libp2p;
        this.peerStore = libp2p.peerStore;
        this.addressManager = libp2p.addressManager;
        this.connectionManager = libp2p.connectionManager;
        this.peerId = libp2p.peerId;
        this.handleMessage = this.handleMessage.bind(this);
        const protocolStr = $aabc69a61ef5a5ed$var$IdentifyService.getProtocolStr(libp2p);
        this.identifyProtocolStr = protocolStr.identifyProtocolStr;
        this.identifyPushProtocolStr = protocolStr.identifyPushProtocolStr;
        // Store self host metadata
        this._host = {
            protocolVersion: `${libp2p._config.protocolPrefix}/${$aabc69a61ef5a5ed$require$IDENTIFY_PROTOCOL_VERSION}`,
            ...libp2p._options.host
        };
        this.peerStore.metadataBook.set(this.peerId, "AgentVersion", $aabc69a61ef5a5ed$require$uint8ArrayFromString(this._host.agentVersion));
        this.peerStore.metadataBook.set(this.peerId, "ProtocolVersion", $aabc69a61ef5a5ed$require$uint8ArrayFromString(this._host.protocolVersion));
        // When a new connection happens, trigger identify
        this.connectionManager.on("peer:connect", (connection)=>{
            this.identify(connection).catch($aabc69a61ef5a5ed$var$log.error);
        });
        // When self multiaddrs change, trigger identify-push
        this.peerStore.on("change:multiaddrs", ({ peerId: peerId })=>{
            if (peerId.toString() === this.peerId.toString()) this.pushToPeerStore();
        });
        // When self protocols change, trigger identify-push
        this.peerStore.on("change:protocols", ({ peerId: peerId })=>{
            if (peerId.toString() === this.peerId.toString()) this.pushToPeerStore();
        });
    }
    /**
   * Send an Identify Push update to the list of connections
   *
   * @param {Connection[]} connections
   * @returns {Promise<void[]>}
   */ async push(connections) {
        const signedPeerRecord = await this.peerStore.addressBook.getRawEnvelope(this.peerId);
        const listenAddrs = this._libp2p.multiaddrs.map((ma)=>ma.bytes);
        const protocols = this.peerStore.protoBook.get(this.peerId) || [];
        const pushes = connections.map(async (connection)=>{
            try {
                const { stream: stream } = await connection.newStream(this.identifyPushProtocolStr);
                await $aabc69a61ef5a5ed$require$pipe([
                    $f489q.Identify.encode({
                        listenAddrs: listenAddrs,
                        signedPeerRecord: signedPeerRecord,
                        protocols: protocols
                    }).finish()
                ], $4zeIG.encode(), stream, $aabc69a61ef5a5ed$require$consume);
            } catch (/** @type {any} */ err) {
                // Just log errors
                $aabc69a61ef5a5ed$var$log.error("could not push identify update to peer", err);
            }
        });
        return Promise.all(pushes);
    }
    /**
   * Calls `push` for all peers in the `peerStore` that are connected
   *
   * @returns {void}
   */ pushToPeerStore() {
        // Do not try to push if libp2p node is not running
        if (!this._libp2p.isStarted()) return;
        const connections = [];
        let connection;
        for (const peer of this.peerStore.peers.values())if (peer.protocols.includes(this.identifyPushProtocolStr) && (connection = this.connectionManager.get(peer.id))) connections.push(connection);
        this.push(connections);
    }
    /**
   * Requests the `Identify` message from peer associated with the given `connection`.
   * If the identified peer does not match the `PeerId` associated with the connection,
   * an error will be thrown.
   *
   * @async
   * @param {Connection} connection
   * @returns {Promise<void>}
   */ async identify(connection) {
        const { stream: stream } = await connection.newStream(this.identifyProtocolStr);
        const [data] = await $aabc69a61ef5a5ed$require$pipe([], stream, $4zeIG.decode(), $aabc69a61ef5a5ed$require$take(1), $aabc69a61ef5a5ed$require$toBuffer, $aabc69a61ef5a5ed$require$collect);
        if (!data) throw $20Lm5(new Error("No data could be retrieved"), $aabc69a61ef5a5ed$require$codes.ERR_CONNECTION_ENDED);
        let message;
        try {
            message = $f489q.Identify.decode(data);
        } catch (/** @type {any} */ err) {
            throw $20Lm5(err, $aabc69a61ef5a5ed$require$codes.ERR_INVALID_MESSAGE);
        }
        const { publicKey: publicKey, listenAddrs: listenAddrs, protocols: protocols, observedAddr: observedAddr, signedPeerRecord: signedPeerRecord } = message;
        const id = await $ksmXv.createFromPubKey(publicKey);
        if (connection.remotePeer.toB58String() !== id.toB58String()) throw $20Lm5(new Error("identified peer does not match the expected peer"), $aabc69a61ef5a5ed$require$codes.ERR_INVALID_PEER);
        // Get the observedAddr if there is one
        const cleanObservedAddr = $aabc69a61ef5a5ed$var$IdentifyService.getCleanMultiaddr(observedAddr);
        try {
            const envelope = await $4kY1w.openAndCertify(signedPeerRecord, $ewhIy.DOMAIN);
            if (this.peerStore.addressBook.consumePeerRecord(envelope)) {
                this.peerStore.protoBook.set(id, protocols);
                this.peerStore.metadataBook.set(id, "AgentVersion", $aabc69a61ef5a5ed$require$uint8ArrayFromString(message.agentVersion));
                this.peerStore.metadataBook.set(id, "ProtocolVersion", $aabc69a61ef5a5ed$require$uint8ArrayFromString(message.protocolVersion));
                return;
            }
        } catch (/** @type {any} */ err) {
            $aabc69a61ef5a5ed$var$log("received invalid envelope, discard it and fallback to listenAddrs is available", err);
        }
        // LEGACY: Update peers data in PeerStore
        try {
            this.peerStore.addressBook.set(id, listenAddrs.map((addr)=>new $aabc69a61ef5a5ed$require$Multiaddr(addr)));
        } catch (/** @type {any} */ err) {
            $aabc69a61ef5a5ed$var$log.error("received invalid addrs", err);
        }
        this.peerStore.protoBook.set(id, protocols);
        this.peerStore.metadataBook.set(id, "AgentVersion", $aabc69a61ef5a5ed$require$uint8ArrayFromString(message.agentVersion));
        this.peerStore.metadataBook.set(id, "ProtocolVersion", $aabc69a61ef5a5ed$require$uint8ArrayFromString(message.protocolVersion));
        // TODO: Add and score our observed addr
        $aabc69a61ef5a5ed$var$log("received observed address of %s", cleanObservedAddr);
    // this.addressManager.addObservedAddr(observedAddr)
    }
    /**
   * A handler to register with Libp2p to process identify messages.
   *
   * @param {Object} options
   * @param {Connection} options.connection
   * @param {MuxedStream} options.stream
   * @param {string} options.protocol
   * @returns {Promise<void>|undefined}
   */ handleMessage({ connection: connection, stream: stream, protocol: protocol }) {
        switch(protocol){
            case this.identifyProtocolStr:
                return this._handleIdentify({
                    connection: connection,
                    stream: stream
                });
            case this.identifyPushProtocolStr:
                return this._handlePush({
                    connection: connection,
                    stream: stream
                });
            default:
                $aabc69a61ef5a5ed$var$log.error("cannot handle unknown protocol %s", protocol);
        }
    }
    /**
   * Sends the `Identify` response with the Signed Peer Record
   * to the requesting peer over the given `connection`
   *
   * @private
   * @param {Object} options
   * @param {MuxedStream} options.stream
   * @param {Connection} options.connection
   * @returns {Promise<void>}
   */ async _handleIdentify({ connection: connection, stream: stream }) {
        let publicKey = new Uint8Array(0);
        if (this.peerId.pubKey) publicKey = this.peerId.pubKey.bytes;
        const signedPeerRecord = await this.peerStore.addressBook.getRawEnvelope(this.peerId);
        const protocols = this.peerStore.protoBook.get(this.peerId) || [];
        const message = $f489q.Identify.encode({
            protocolVersion: this._host.protocolVersion,
            agentVersion: this._host.agentVersion,
            publicKey: publicKey,
            listenAddrs: this._libp2p.multiaddrs.map((ma)=>ma.bytes),
            signedPeerRecord: signedPeerRecord,
            observedAddr: connection.remoteAddr.bytes,
            protocols: protocols
        }).finish();
        try {
            await $aabc69a61ef5a5ed$require$pipe([
                message
            ], $4zeIG.encode(), stream, $aabc69a61ef5a5ed$require$consume);
        } catch (/** @type {any} */ err) {
            $aabc69a61ef5a5ed$var$log.error("could not respond to identify request", err);
        }
    }
    /**
   * Reads the Identify Push message from the given `connection`
   *
   * @private
   * @param {object} options
   * @param {MuxedStream} options.stream
   * @param {Connection} options.connection
   * @returns {Promise<void>}
   */ async _handlePush({ connection: connection, stream: stream }) {
        let message;
        try {
            const [data] = await $aabc69a61ef5a5ed$require$pipe([], stream, $4zeIG.decode(), $aabc69a61ef5a5ed$require$take(1), $aabc69a61ef5a5ed$require$toBuffer, $aabc69a61ef5a5ed$require$collect);
            message = $f489q.Identify.decode(data);
        } catch (/** @type {any} */ err) {
            return $aabc69a61ef5a5ed$var$log.error("received invalid message", err);
        }
        const id = connection.remotePeer;
        try {
            const envelope = await $4kY1w.openAndCertify(message.signedPeerRecord, $ewhIy.DOMAIN);
            if (this.peerStore.addressBook.consumePeerRecord(envelope)) {
                this.peerStore.protoBook.set(id, message.protocols);
                return;
            }
        } catch (/** @type {any} */ err) {
            $aabc69a61ef5a5ed$var$log("received invalid envelope, discard it and fallback to listenAddrs is available", err);
        }
        // LEGACY: Update peers data in PeerStore
        try {
            this.peerStore.addressBook.set(id, message.listenAddrs.map((addr)=>new $aabc69a61ef5a5ed$require$Multiaddr(addr)));
        } catch (/** @type {any} */ err) {
            $aabc69a61ef5a5ed$var$log.error("received invalid addrs", err);
        }
        // Update the protocols
        this.peerStore.protoBook.set(id, message.protocols);
    }
    /**
   * Takes the `addr` and converts it to a Multiaddr if possible
   *
   * @param {Uint8Array | string} addr
   * @returns {Multiaddr|null}
   */ static getCleanMultiaddr(addr) {
        if (addr && addr.length > 0) try {
            return new $aabc69a61ef5a5ed$require$Multiaddr(addr);
        } catch (_) {
            return null;
        }
        return null;
    }
}
/**
 * The protocols the IdentifyService supports
 *
 * @property multicodecs
 */ const $aabc69a61ef5a5ed$var$multicodecs = {
    IDENTIFY: $aabc69a61ef5a5ed$require$MULTICODEC_IDENTIFY,
    IDENTIFY_PUSH: $aabc69a61ef5a5ed$require$MULTICODEC_IDENTIFY_PUSH
};
$aabc69a61ef5a5ed$var$IdentifyService.multicodecs = $aabc69a61ef5a5ed$var$multicodecs;
$aabc69a61ef5a5ed$var$IdentifyService.Messsage = $f489q;
module.exports = $aabc69a61ef5a5ed$var$IdentifyService;

});
parcelRequire.register("f489q", function(module, exports) {
/*eslint-disable*/ "use strict";

var $liRmU = parcelRequire("liRmU");
// Common aliases
var $af7d8d5b2ab0811c$var$$Reader = $liRmU.Reader, $af7d8d5b2ab0811c$var$$Writer = $liRmU.Writer, $af7d8d5b2ab0811c$var$$util = $liRmU.util;
// Exported root namespace
var $af7d8d5b2ab0811c$var$$root = $liRmU.roots["libp2p-identify"] || ($liRmU.roots["libp2p-identify"] = {});
$af7d8d5b2ab0811c$var$$root.Identify = function() {
    /**
     * Properties of an Identify.
     * @exports IIdentify
     * @interface IIdentify
     * @property {string|null} [protocolVersion] Identify protocolVersion
     * @property {string|null} [agentVersion] Identify agentVersion
     * @property {Uint8Array|null} [publicKey] Identify publicKey
     * @property {Array.<Uint8Array>|null} [listenAddrs] Identify listenAddrs
     * @property {Uint8Array|null} [observedAddr] Identify observedAddr
     * @property {Array.<string>|null} [protocols] Identify protocols
     * @property {Uint8Array|null} [signedPeerRecord] Identify signedPeerRecord
     */ /**
     * Constructs a new Identify.
     * @exports Identify
     * @classdesc Represents an Identify.
     * @implements IIdentify
     * @constructor
     * @param {IIdentify=} [p] Properties to set
     */ function Identify(p) {
        this.listenAddrs = [];
        this.protocols = [];
        if (p) {
            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }
    }
    /**
     * Identify protocolVersion.
     * @member {string} protocolVersion
     * @memberof Identify
     * @instance
     */ Identify.prototype.protocolVersion = "";
    /**
     * Identify agentVersion.
     * @member {string} agentVersion
     * @memberof Identify
     * @instance
     */ Identify.prototype.agentVersion = "";
    /**
     * Identify publicKey.
     * @member {Uint8Array} publicKey
     * @memberof Identify
     * @instance
     */ Identify.prototype.publicKey = $af7d8d5b2ab0811c$var$$util.newBuffer([]);
    /**
     * Identify listenAddrs.
     * @member {Array.<Uint8Array>} listenAddrs
     * @memberof Identify
     * @instance
     */ Identify.prototype.listenAddrs = $af7d8d5b2ab0811c$var$$util.emptyArray;
    /**
     * Identify observedAddr.
     * @member {Uint8Array} observedAddr
     * @memberof Identify
     * @instance
     */ Identify.prototype.observedAddr = $af7d8d5b2ab0811c$var$$util.newBuffer([]);
    /**
     * Identify protocols.
     * @member {Array.<string>} protocols
     * @memberof Identify
     * @instance
     */ Identify.prototype.protocols = $af7d8d5b2ab0811c$var$$util.emptyArray;
    /**
     * Identify signedPeerRecord.
     * @member {Uint8Array} signedPeerRecord
     * @memberof Identify
     * @instance
     */ Identify.prototype.signedPeerRecord = $af7d8d5b2ab0811c$var$$util.newBuffer([]);
    /**
     * Encodes the specified Identify message. Does not implicitly {@link Identify.verify|verify} messages.
     * @function encode
     * @memberof Identify
     * @static
     * @param {IIdentify} m Identify message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ Identify.encode = function encode(m, w) {
        if (!w) w = $af7d8d5b2ab0811c$var$$Writer.create();
        if (m.publicKey != null && Object.hasOwnProperty.call(m, "publicKey")) w.uint32(10).bytes(m.publicKey);
        if (m.listenAddrs != null && m.listenAddrs.length) for(var i = 0; i < m.listenAddrs.length; ++i)w.uint32(18).bytes(m.listenAddrs[i]);
        if (m.protocols != null && m.protocols.length) for(var i = 0; i < m.protocols.length; ++i)w.uint32(26).string(m.protocols[i]);
        if (m.observedAddr != null && Object.hasOwnProperty.call(m, "observedAddr")) w.uint32(34).bytes(m.observedAddr);
        if (m.protocolVersion != null && Object.hasOwnProperty.call(m, "protocolVersion")) w.uint32(42).string(m.protocolVersion);
        if (m.agentVersion != null && Object.hasOwnProperty.call(m, "agentVersion")) w.uint32(50).string(m.agentVersion);
        if (m.signedPeerRecord != null && Object.hasOwnProperty.call(m, "signedPeerRecord")) w.uint32(66).bytes(m.signedPeerRecord);
        return w;
    };
    /**
     * Decodes an Identify message from the specified reader or buffer.
     * @function decode
     * @memberof Identify
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {Identify} Identify
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ Identify.decode = function decode(r, l) {
        if (!(r instanceof $af7d8d5b2ab0811c$var$$Reader)) r = $af7d8d5b2ab0811c$var$$Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l, m = new $af7d8d5b2ab0811c$var$$root.Identify();
        while(r.pos < c){
            var t = r.uint32();
            switch(t >>> 3){
                case 5:
                    m.protocolVersion = r.string();
                    break;
                case 6:
                    m.agentVersion = r.string();
                    break;
                case 1:
                    m.publicKey = r.bytes();
                    break;
                case 2:
                    if (!(m.listenAddrs && m.listenAddrs.length)) m.listenAddrs = [];
                    m.listenAddrs.push(r.bytes());
                    break;
                case 4:
                    m.observedAddr = r.bytes();
                    break;
                case 3:
                    if (!(m.protocols && m.protocols.length)) m.protocols = [];
                    m.protocols.push(r.string());
                    break;
                case 8:
                    m.signedPeerRecord = r.bytes();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
            }
        }
        return m;
    };
    /**
     * Creates an Identify message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Identify
     * @static
     * @param {Object.<string,*>} d Plain object
     * @returns {Identify} Identify
     */ Identify.fromObject = function fromObject(d) {
        if (d instanceof $af7d8d5b2ab0811c$var$$root.Identify) return d;
        var m = new $af7d8d5b2ab0811c$var$$root.Identify();
        if (d.protocolVersion != null) m.protocolVersion = String(d.protocolVersion);
        if (d.agentVersion != null) m.agentVersion = String(d.agentVersion);
        if (d.publicKey != null) {
            if (typeof d.publicKey === "string") $af7d8d5b2ab0811c$var$$util.base64.decode(d.publicKey, m.publicKey = $af7d8d5b2ab0811c$var$$util.newBuffer($af7d8d5b2ab0811c$var$$util.base64.length(d.publicKey)), 0);
            else if (d.publicKey.length) m.publicKey = d.publicKey;
        }
        if (d.listenAddrs) {
            if (!Array.isArray(d.listenAddrs)) throw TypeError(".Identify.listenAddrs: array expected");
            m.listenAddrs = [];
            for(var i = 0; i < d.listenAddrs.length; ++i){
                if (typeof d.listenAddrs[i] === "string") $af7d8d5b2ab0811c$var$$util.base64.decode(d.listenAddrs[i], m.listenAddrs[i] = $af7d8d5b2ab0811c$var$$util.newBuffer($af7d8d5b2ab0811c$var$$util.base64.length(d.listenAddrs[i])), 0);
                else if (d.listenAddrs[i].length) m.listenAddrs[i] = d.listenAddrs[i];
            }
        }
        if (d.observedAddr != null) {
            if (typeof d.observedAddr === "string") $af7d8d5b2ab0811c$var$$util.base64.decode(d.observedAddr, m.observedAddr = $af7d8d5b2ab0811c$var$$util.newBuffer($af7d8d5b2ab0811c$var$$util.base64.length(d.observedAddr)), 0);
            else if (d.observedAddr.length) m.observedAddr = d.observedAddr;
        }
        if (d.protocols) {
            if (!Array.isArray(d.protocols)) throw TypeError(".Identify.protocols: array expected");
            m.protocols = [];
            for(var i = 0; i < d.protocols.length; ++i)m.protocols[i] = String(d.protocols[i]);
        }
        if (d.signedPeerRecord != null) {
            if (typeof d.signedPeerRecord === "string") $af7d8d5b2ab0811c$var$$util.base64.decode(d.signedPeerRecord, m.signedPeerRecord = $af7d8d5b2ab0811c$var$$util.newBuffer($af7d8d5b2ab0811c$var$$util.base64.length(d.signedPeerRecord)), 0);
            else if (d.signedPeerRecord.length) m.signedPeerRecord = d.signedPeerRecord;
        }
        return m;
    };
    /**
     * Creates a plain object from an Identify message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Identify
     * @static
     * @param {Identify} m Identify
     * @param {$protobuf.IConversionOptions} [o] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ Identify.toObject = function toObject(m, o) {
        if (!o) o = {};
        var d = {};
        if (o.arrays || o.defaults) {
            d.listenAddrs = [];
            d.protocols = [];
        }
        if (o.defaults) {
            if (o.bytes === String) d.publicKey = "";
            else {
                d.publicKey = [];
                if (o.bytes !== Array) d.publicKey = $af7d8d5b2ab0811c$var$$util.newBuffer(d.publicKey);
            }
            if (o.bytes === String) d.observedAddr = "";
            else {
                d.observedAddr = [];
                if (o.bytes !== Array) d.observedAddr = $af7d8d5b2ab0811c$var$$util.newBuffer(d.observedAddr);
            }
            d.protocolVersion = "";
            d.agentVersion = "";
            if (o.bytes === String) d.signedPeerRecord = "";
            else {
                d.signedPeerRecord = [];
                if (o.bytes !== Array) d.signedPeerRecord = $af7d8d5b2ab0811c$var$$util.newBuffer(d.signedPeerRecord);
            }
        }
        if (m.publicKey != null && m.hasOwnProperty("publicKey")) d.publicKey = o.bytes === String ? $af7d8d5b2ab0811c$var$$util.base64.encode(m.publicKey, 0, m.publicKey.length) : o.bytes === Array ? Array.prototype.slice.call(m.publicKey) : m.publicKey;
        if (m.listenAddrs && m.listenAddrs.length) {
            d.listenAddrs = [];
            for(var j = 0; j < m.listenAddrs.length; ++j)d.listenAddrs[j] = o.bytes === String ? $af7d8d5b2ab0811c$var$$util.base64.encode(m.listenAddrs[j], 0, m.listenAddrs[j].length) : o.bytes === Array ? Array.prototype.slice.call(m.listenAddrs[j]) : m.listenAddrs[j];
        }
        if (m.protocols && m.protocols.length) {
            d.protocols = [];
            for(var j = 0; j < m.protocols.length; ++j)d.protocols[j] = m.protocols[j];
        }
        if (m.observedAddr != null && m.hasOwnProperty("observedAddr")) d.observedAddr = o.bytes === String ? $af7d8d5b2ab0811c$var$$util.base64.encode(m.observedAddr, 0, m.observedAddr.length) : o.bytes === Array ? Array.prototype.slice.call(m.observedAddr) : m.observedAddr;
        if (m.protocolVersion != null && m.hasOwnProperty("protocolVersion")) d.protocolVersion = m.protocolVersion;
        if (m.agentVersion != null && m.hasOwnProperty("agentVersion")) d.agentVersion = m.agentVersion;
        if (m.signedPeerRecord != null && m.hasOwnProperty("signedPeerRecord")) d.signedPeerRecord = o.bytes === String ? $af7d8d5b2ab0811c$var$$util.base64.encode(m.signedPeerRecord, 0, m.signedPeerRecord.length) : o.bytes === Array ? Array.prototype.slice.call(m.signedPeerRecord) : m.signedPeerRecord;
        return d;
    };
    /**
     * Converts this Identify to JSON.
     * @function toJSON
     * @memberof Identify
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ Identify.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
    };
    return Identify;
}();
module.exports = $af7d8d5b2ab0811c$var$$root;

});


parcelRequire.register("l51qt", function(module, exports) {
"use strict";

var $7jzxY = parcelRequire("7jzxY");

var $jjmHV = parcelRequire("jjmHV");

var $edsUI = parcelRequire("edsUI");
var $f58b2bc124044cef$require$promisify = $edsUI.promisify;

var $aZLwC = parcelRequire("aZLwC");
var $f58b2bc124044cef$require$Multiaddr = $aZLwC.Multiaddr;
const $f58b2bc124044cef$var$log = Object.assign($jjmHV("libp2p:nat"), {
    error: $jjmHV("libp2p:nat:err")
});

var $3hUlt = parcelRequire("3hUlt");
var $f58b2bc124044cef$require$isBrowser = $3hUlt.isBrowser;

var $9SFN0 = parcelRequire("9SFN0");

var $6bVKo = parcelRequire("6bVKo");

var $hUdce = parcelRequire("hUdce");

var $20Lm5 = parcelRequire("20Lm5");

var $8yAh4 = parcelRequire("8yAh4");
const { codes: { ERR_INVALID_PARAMETERS: $f58b2bc124044cef$var$ERR_INVALID_PARAMETERS } } = $8yAh4;

var $3UNxX = parcelRequire("3UNxX");
const $f58b2bc124044cef$var$DEFAULT_TTL = 7200;
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('./transport-manager')} TransportManager
 * @typedef {import('./address-manager')} AddressManager
 */ /**
 * @typedef {Object} NatManagerProperties
 * @property {PeerId} peerId - The peer ID of the current node
 * @property {TransportManager} transportManager - A transport manager
 * @property {AddressManager} addressManager - An address manager
 *
 * @typedef {Object} NatManagerOptions
 * @property {boolean} enabled - Whether to enable the NAT manager
 * @property {string} [externalIp] - Pass a value to use instead of auto-detection
 * @property {string} [description] - A string value to use for the port mapping description on the gateway
 * @property {number} [ttl = DEFAULT_TTL] - How long UPnP port mappings should last for in seconds (minimum 1200)
 * @property {boolean} [keepAlive] - Whether to automatically refresh UPnP port mappings when their TTL is reached
 * @property {string} [gateway] - Pass a value to use instead of auto-detection
 * @property {object} [pmp] - PMP options
 * @property {boolean} [pmp.enabled] - Whether to enable PMP as well as UPnP
 */ function $f58b2bc124044cef$var$highPort(min = 1024, max = 65535) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
class $f58b2bc124044cef$var$NatManager {
    /**
   * @class
   * @param {NatManagerProperties & NatManagerOptions} options
   */ constructor({ peerId: peerId, addressManager: addressManager, transportManager: transportManager, ...options }){
        this._peerId = peerId;
        this._addressManager = addressManager;
        this._transportManager = transportManager;
        this._enabled = options.enabled;
        this._externalIp = options.externalIp;
        this._options = {
            description: options.description || `${$hUdce.name}@${$hUdce.version} ${this._peerId}`,
            ttl: options.ttl || $f58b2bc124044cef$var$DEFAULT_TTL,
            autoUpdate: options.keepAlive || true,
            gateway: options.gateway,
            enablePMP: Boolean(options.pmp && options.pmp.enabled)
        };
        if (this._options.ttl < $f58b2bc124044cef$var$DEFAULT_TTL) throw $20Lm5(new Error(`NatManager ttl should be at least ${$f58b2bc124044cef$var$DEFAULT_TTL} seconds`), $f58b2bc124044cef$var$ERR_INVALID_PARAMETERS);
    }
    /**
   * Starts the NAT manager
   */ start() {
        if ($f58b2bc124044cef$require$isBrowser || !this._enabled) return;
        // done async to not slow down startup
        this._start().catch((err)=>{
            // hole punching errors are non-fatal
            $f58b2bc124044cef$var$log.error(err);
        });
    }
    async _start() {
        const addrs = this._transportManager.getAddrs();
        for (const addr of addrs){
            // try to open uPnP ports for each thin waist address
            const { family: family, host: host, port: port, transport: transport } = addr.toOptions();
            if (!addr.isThinWaistAddress() || transport !== "tcp") continue;
            if ($3UNxX(addr)) continue;
            if (family !== 4) continue;
            const client = this._getClient();
            const publicIp = this._externalIp || await client.externalIp();
            // @ts-expect-error types are wrong
            if ($6bVKo(publicIp)) throw new Error(`${publicIp} is private - please set config.nat.externalIp to an externally routable IP or ensure you are not behind a double NAT`);
            const publicPort = $f58b2bc124044cef$var$highPort();
            $f58b2bc124044cef$var$log(`opening uPnP connection from ${publicIp}:${publicPort} to ${host}:${port}`);
            await client.map({
                publicPort: publicPort,
                privatePort: port,
                protocol: transport.toUpperCase()
            });
            this._addressManager.addObservedAddr($f58b2bc124044cef$require$Multiaddr.fromNodeAddress({
                family: 4,
                address: publicIp,
                port: publicPort
            }, transport));
        }
    }
    _getClient() {
        if (this._client) return this._client;
        const client = new $7jzxY(this._options);
        /** @type {(...any: any) => any} */ const map = $f58b2bc124044cef$require$promisify(client.map.bind(client));
        /** @type {(...any: any) => any} */ const destroy = $f58b2bc124044cef$require$promisify(client.destroy.bind(client));
        /** @type {(...any: any) => any} */ const externalIp = $f58b2bc124044cef$require$promisify(client.externalIp.bind(client));
        // these are all network operations so add a retry
        this._client = {
            /**
       * @param  {...any} args
       * @returns {Promise<void>}
       */ map: (...args)=>$9SFN0(()=>map(...args), {
                    onFailedAttempt: $f58b2bc124044cef$var$log.error,
                    unref: true
                }),
            /**
       * @param  {...any} args
       * @returns {Promise<void>}
       */ destroy: (...args)=>$9SFN0(()=>destroy(...args), {
                    onFailedAttempt: $f58b2bc124044cef$var$log.error,
                    unref: true
                }),
            /**
       * @param  {...any} args
       * @returns {Promise<string>}
       */ externalIp: (...args)=>$9SFN0(()=>externalIp(...args), {
                    onFailedAttempt: $f58b2bc124044cef$var$log.error,
                    unref: true
                })
        };
        return this._client;
    }
    /**
   * Stops the NAT manager
   *
   * @async
   */ async stop() {
        if ($f58b2bc124044cef$require$isBrowser || !this._client) return;
        try {
            await this._client.destroy();
            this._client = null;
        } catch (/** @type {any} */ err) {
            $f58b2bc124044cef$var$log.error(err);
        }
    }
}
module.exports = $f58b2bc124044cef$var$NatManager;

});
parcelRequire.register("edsUI", function(module, exports) {

$parcel$export(module.exports, "promisify", () => $0b949a4a3bb79f29$export$1d1d2ed6b55cf67f);
var $0b949a4a3bb79f29$var$customArgumentsToken = "__ES6-PROMISIFY--CUSTOM-ARGUMENTS__";
function $0b949a4a3bb79f29$export$1d1d2ed6b55cf67f(a) {
    if ("function" != typeof a) throw new TypeError("Argument to promisify must be a function");
    var b = a[$0b949a4a3bb79f29$var$customArgumentsToken], c = $0b949a4a3bb79f29$export$1d1d2ed6b55cf67f.Promise || Promise;
    if ("function" != typeof c) throw new Error("No Promise implementation found; do you need a polyfill?");
    return function() {
        for(var d = arguments.length, e = Array(d), f = 0; f < d; f++)e[f] = arguments[f];
        return new c((c, d)=>{
            e.push(function(a) {
                if (a) return d(a);
                for(var e = arguments.length, f = Array(1 < e ? e - 1 : 0), g = 1; g < e; g++)f[g - 1] = arguments[g];
                if (1 === f.length || !b) return c(f[0]);
                var h = {};
                f.forEach((a, c)=>{
                    var d = b[c];
                    d && (h[d] = a);
                }), c(h);
            }), a.apply(this, e);
        });
    };
}
$0b949a4a3bb79f29$export$1d1d2ed6b55cf67f.argumentNames = "__ES6-PROMISIFY--CUSTOM-ARGUMENTS__", $0b949a4a3bb79f29$export$1d1d2ed6b55cf67f.Promise = void 0;

});

parcelRequire.register("3hUlt", function(module, exports) {
"use strict";

var $47OAF = parcelRequire("47OAF");
const $264eaaa24b87bdaa$var$IS_ENV_WITH_DOM = typeof window === "object" && typeof document === "object" && document.nodeType === 9;
const $264eaaa24b87bdaa$var$IS_ELECTRON = $47OAF();
const $264eaaa24b87bdaa$var$IS_BROWSER = $264eaaa24b87bdaa$var$IS_ENV_WITH_DOM && !$264eaaa24b87bdaa$var$IS_ELECTRON;
const $264eaaa24b87bdaa$var$IS_ELECTRON_MAIN = $264eaaa24b87bdaa$var$IS_ELECTRON && !$264eaaa24b87bdaa$var$IS_ENV_WITH_DOM;
const $264eaaa24b87bdaa$var$IS_ELECTRON_RENDERER = $264eaaa24b87bdaa$var$IS_ELECTRON && $264eaaa24b87bdaa$var$IS_ENV_WITH_DOM;
const $264eaaa24b87bdaa$var$IS_NODE = typeof globalThis.process !== "undefined" && typeof globalThis.process.release !== "undefined" && globalThis.process.release.name === "node" && !$264eaaa24b87bdaa$var$IS_ELECTRON;
// @ts-ignore
// eslint-disable-next-line no-undef
const $264eaaa24b87bdaa$var$IS_WEBWORKER = typeof importScripts === "function" && typeof self !== "undefined" && typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope;
// defeat bundlers replacing process.env.NODE_ENV with "development" or whatever
const $264eaaa24b87bdaa$var$IS_TEST = typeof globalThis.process !== "undefined" && typeof globalThis.process.env !== "undefined" && globalThis.process.env["NODE" + (()=>"_")() + "ENV"] === "test";
const $264eaaa24b87bdaa$var$IS_REACT_NATIVE = typeof navigator !== "undefined" && navigator.product === "ReactNative";
module.exports = {
    isTest: $264eaaa24b87bdaa$var$IS_TEST,
    isElectron: $264eaaa24b87bdaa$var$IS_ELECTRON,
    isElectronMain: $264eaaa24b87bdaa$var$IS_ELECTRON_MAIN,
    isElectronRenderer: $264eaaa24b87bdaa$var$IS_ELECTRON_RENDERER,
    isNode: $264eaaa24b87bdaa$var$IS_NODE,
    /**
   * Detects browser main thread  **NOT** web worker or service worker
   */ isBrowser: $264eaaa24b87bdaa$var$IS_BROWSER,
    isWebWorker: $264eaaa24b87bdaa$var$IS_WEBWORKER,
    isEnvWithDom: $264eaaa24b87bdaa$var$IS_ENV_WITH_DOM,
    isReactNative: $264eaaa24b87bdaa$var$IS_REACT_NATIVE
};

});
parcelRequire.register("47OAF", function(module, exports) {
// https://github.com/electron/electron/issues/2288

var $bvigH = parcelRequire("bvigH");
function $300f0f0be1d65d7f$var$isElectron() {
    // Renderer process
    if (typeof window !== "undefined" && typeof window.process === "object" && window.process.type === "renderer") return true;
    // Main process
    if (typeof $bvigH !== "undefined" && typeof $bvigH.versions === "object" && !!$bvigH.versions.electron) return true;
    // Detect the user agent when the `nodeIntegration` option is set to false
    if (typeof navigator === "object" && typeof navigator.userAgent === "string" && navigator.userAgent.indexOf("Electron") >= 0) return true;
    return false;
}
module.exports = $300f0f0be1d65d7f$var$isElectron;

});


parcelRequire.register("9SFN0", function(module, exports) {
"use strict";

var $5bKSh = parcelRequire("5bKSh");
const $731992b898001f50$var$networkErrorMsgs = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "The Internet connection appears to be offline.",
    "Network request failed" // `cross-fetch`
];
class $731992b898001f50$var$AbortError extends Error {
    constructor(message){
        super();
        if (message instanceof Error) {
            this.originalError = message;
            ({ message: message } = message);
        } else {
            this.originalError = new Error(message);
            this.originalError.stack = this.stack;
        }
        this.name = "AbortError";
        this.message = message;
    }
}
const $731992b898001f50$var$decorateErrorWithCounts = (error, attemptNumber, options)=>{
    // Minus 1 from attemptNumber because the first attempt does not count as a retry
    const retriesLeft = options.retries - (attemptNumber - 1);
    error.attemptNumber = attemptNumber;
    error.retriesLeft = retriesLeft;
    return error;
};
const $731992b898001f50$var$isNetworkError = (errorMessage)=>$731992b898001f50$var$networkErrorMsgs.includes(errorMessage);
const $731992b898001f50$var$pRetry = (input, options)=>new Promise((resolve, reject)=>{
        options = {
            onFailedAttempt: ()=>{},
            retries: 10,
            ...options
        };
        const operation = $5bKSh.operation(options);
        operation.attempt(async (attemptNumber)=>{
            try {
                resolve(await input(attemptNumber));
            } catch (error) {
                if (!(error instanceof Error)) {
                    reject(new TypeError(`Non-error was thrown: "${error}". You should only throw errors.`));
                    return;
                }
                if (error instanceof $731992b898001f50$var$AbortError) {
                    operation.stop();
                    reject(error.originalError);
                } else if (error instanceof TypeError && !$731992b898001f50$var$isNetworkError(error.message)) {
                    operation.stop();
                    reject(error);
                } else {
                    $731992b898001f50$var$decorateErrorWithCounts(error, attemptNumber, options);
                    try {
                        await options.onFailedAttempt(error);
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (!operation.retry(error)) reject(operation.mainError());
                }
            }
        });
    });
module.exports = $731992b898001f50$var$pRetry;
// TODO: remove this in the next major version
module.exports.default = $731992b898001f50$var$pRetry;
module.exports.AbortError = $731992b898001f50$var$AbortError;

});
parcelRequire.register("5bKSh", function(module, exports) {

module.exports = (parcelRequire("lB2FE"));

});
parcelRequire.register("lB2FE", function(module, exports) {

$parcel$export(module.exports, "operation", () => $fb8f200a05e8bd63$export$7b8f6cec25af9dd, (v) => $fb8f200a05e8bd63$export$7b8f6cec25af9dd = v);
$parcel$export(module.exports, "timeouts", () => $fb8f200a05e8bd63$export$968081c158f72864, (v) => $fb8f200a05e8bd63$export$968081c158f72864 = v);
$parcel$export(module.exports, "createTimeout", () => $fb8f200a05e8bd63$export$6eae7cf7a129a986, (v) => $fb8f200a05e8bd63$export$6eae7cf7a129a986 = v);
$parcel$export(module.exports, "wrap", () => $fb8f200a05e8bd63$export$4997ffc0176396a6, (v) => $fb8f200a05e8bd63$export$4997ffc0176396a6 = v);
var $fb8f200a05e8bd63$export$7b8f6cec25af9dd;
var $fb8f200a05e8bd63$export$968081c158f72864;
var $fb8f200a05e8bd63$export$6eae7cf7a129a986;
var $fb8f200a05e8bd63$export$4997ffc0176396a6;

var $8TeTF = parcelRequire("8TeTF");
$fb8f200a05e8bd63$export$7b8f6cec25af9dd = function(options) {
    var timeouts = $fb8f200a05e8bd63$export$968081c158f72864(options);
    return new $8TeTF(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
$fb8f200a05e8bd63$export$968081c158f72864 = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error("minTimeout is greater than maxTimeout");
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
$fb8f200a05e8bd63$export$6eae7cf7a129a986 = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
$fb8f200a05e8bd63$export$4997ffc0176396a6 = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === "function") methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = $fb8f200a05e8bd63$export$7b8f6cec25af9dd(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRequire.register("8TeTF", function(module, exports) {
function $678f03fc789cbebe$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === "boolean") options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $678f03fc789cbebe$var$RetryOperation;
$678f03fc789cbebe$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$678f03fc789cbebe$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$678f03fc789cbebe$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error("RetryOperation timeout occurred"));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$678f03fc789cbebe$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$678f03fc789cbebe$var$RetryOperation.prototype.try = function(fn) {
    console.log("Using RetryOperation.try() is deprecated");
    this.attempt(fn);
};
$678f03fc789cbebe$var$RetryOperation.prototype.start = function(fn) {
    console.log("Using RetryOperation.start() is deprecated");
    this.attempt(fn);
};
$678f03fc789cbebe$var$RetryOperation.prototype.start = $678f03fc789cbebe$var$RetryOperation.prototype.try;
$678f03fc789cbebe$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$678f03fc789cbebe$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$678f03fc789cbebe$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRequire.register("3UNxX", function(module, exports) {
"use strict";

var $hnvY7 = parcelRequire("hnvY7");
/**
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 */ /**
 * Check if a given multiaddr is a loopback address.
 *
 * @param {Multiaddr} ma
 * @returns {boolean}
 */ function $2d9d08fe1cfda273$var$isLoopback(ma) {
    const { address: address } = ma.nodeAddress();
    return $hnvY7(address);
}
module.exports = $2d9d08fe1cfda273$var$isLoopback;

});
parcelRequire.register("hnvY7", function(module, exports) {
"use strict";
/**
 * Check if a given ip address is a loopback address
 *
 * @param {string} ip - ip address to check
 * @returns {boolean}
 */ function $ca6d61f137b2c90f$var$isLoopbackAddr(ip) {
    return /^127\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})$/i.test(ip) || /^::1$/.test(ip);
}
module.exports = $ca6d61f137b2c90f$var$isLoopbackAddr;

});




parcelRequire.register("eh5zb", function(module, exports) {
"use strict";
var $a646f899534f0b4e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a646f899534f0b4e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a646f899534f0b4e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NOISE = void 0;


$a646f899534f0b4e$var$__exportStar((parcelRequire("9pva0")), module.exports);
/**
 * Default configuration, it will generate new noise static key and enable noise pipes (IK handshake).
 */ module.exports.NOISE = new (parcelRequire("9pva0")).Noise();

});
parcelRequire.register("9pva0", function(module, exports) {
"use strict";
var $6d9e9eadb737f954$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6d9e9eadb737f954$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $6d9e9eadb737f954$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6d9e9eadb737f954$var$__createBinding(result, mod, k);
    }
    $6d9e9eadb737f954$var$__setModuleDefault(result, mod);
    return result;
};
var $6d9e9eadb737f954$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Noise = void 0;

const $6d9e9eadb737f954$var$x25519 = $6d9e9eadb737f954$var$__importStar((parcelRequire("f4nIP")));

var $l7tTk = parcelRequire("l7tTk");

const $6d9e9eadb737f954$var$it_pb_rpc_1 = $6d9e9eadb737f954$var$__importDefault((parcelRequire("8of1c")));

const $6d9e9eadb737f954$var$duplex_1 = $6d9e9eadb737f954$var$__importDefault((parcelRequire("dFwnx")));

const $6d9e9eadb737f954$var$it_buffer_1 = $6d9e9eadb737f954$var$__importDefault((parcelRequire("9Jhre")));

const $6d9e9eadb737f954$var$it_pipe_1 = $6d9e9eadb737f954$var$__importDefault((parcelRequire("d8Blz")));

var $4zeIG = parcelRequire("4zeIG");

var $kyJGt = parcelRequire("kyJGt");

var $4JPON = parcelRequire("4JPON");

var $aCOlY = parcelRequire("aCOlY");

var $2UZxa = parcelRequire("2UZxa");

var $evFdC = parcelRequire("evFdC");

var $leW0E = parcelRequire("leW0E");

var $6nNT2 = parcelRequire("6nNT2");

var $e4tcr = parcelRequire("e4tcr");

var $iuPHX = parcelRequire("iuPHX");
class $6d9e9eadb737f954$var$Noise {
    /**
     *
     * @param {bytes} staticNoiseKey - x25519 private key, reuse for faster handshakes
     * @param {bytes} earlyData
     */ constructor(staticNoiseKey, earlyData){
        this.protocol = "/noise";
        this.prologue = $l7tTk.Buffer.alloc(0);
        this.earlyData = earlyData !== null && earlyData !== void 0 ? earlyData : $l7tTk.Buffer.alloc(0);
        // disabled until properly specked
        this.useNoisePipes = false;
        if (staticNoiseKey) {
            // accepts x25519 private key of length 32
            const keyPair = $6d9e9eadb737f954$var$x25519.generateKeyPairFromSeed(staticNoiseKey);
            this.staticKeys = {
                privateKey: $l7tTk.Buffer.from(keyPair.secretKey.buffer, keyPair.secretKey.byteOffset, keyPair.secretKey.length),
                publicKey: $l7tTk.Buffer.from(keyPair.publicKey.buffer, keyPair.publicKey.byteOffset, keyPair.publicKey.length)
            };
        } else this.staticKeys = $2UZxa.generateKeypair();
    }
    /**
     * Encrypt outgoing data to the remote party (handshake as initiator)
     *
     * @param {PeerId} localPeer - PeerId of the receiving peer
     * @param {any} connection - streaming iterable duplex that will be encrypted
     * @param {PeerId} remotePeer - PeerId of the remote peer. Used to validate the integrity of the remote peer.
     * @returns {Promise<SecureOutbound>}
     */ async secureOutbound(localPeer, connection, remotePeer) {
        const wrappedConnection = $6d9e9eadb737f954$var$it_pb_rpc_1.default(connection, {
            lengthEncoder: $evFdC.uint16BEEncode,
            lengthDecoder: $evFdC.uint16BEDecode,
            maxDataLength: $iuPHX.NOISE_MSG_MAX_LENGTH_BYTES
        });
        const handshake = await this.performHandshake({
            connection: wrappedConnection,
            isInitiator: true,
            localPeer: localPeer,
            remotePeer: remotePeer
        });
        const conn = await this.createSecureConnection(wrappedConnection, handshake);
        return {
            conn: conn,
            remoteEarlyData: handshake.remoteEarlyData,
            remotePeer: handshake.remotePeer
        };
    }
    /**
     * Decrypt incoming data (handshake as responder).
     *
     * @param {PeerId} localPeer - PeerId of the receiving peer.
     * @param {any} connection - streaming iterable duplex that will be encryption.
     * @param {PeerId} remotePeer - optional PeerId of the initiating peer, if known. This may only exist during transport upgrades.
     * @returns {Promise<SecureOutbound>}
     */ async secureInbound(localPeer, connection, remotePeer) {
        const wrappedConnection = $6d9e9eadb737f954$var$it_pb_rpc_1.default(connection, {
            lengthEncoder: $evFdC.uint16BEEncode,
            lengthDecoder: $evFdC.uint16BEDecode,
            maxDataLength: $iuPHX.NOISE_MSG_MAX_LENGTH_BYTES
        });
        const handshake = await this.performHandshake({
            connection: wrappedConnection,
            isInitiator: false,
            localPeer: localPeer,
            remotePeer: remotePeer
        });
        const conn = await this.createSecureConnection(wrappedConnection, handshake);
        return {
            conn: conn,
            remoteEarlyData: handshake.remoteEarlyData,
            remotePeer: handshake.remotePeer
        };
    }
    /**
     * If Noise pipes supported, tries IK handshake first with XX as fallback if it fails.
     * If noise pipes disabled or remote peer static key is unknown, use XX.
     *
     * @param {HandshakeParams} params
     */ async performHandshake(params) {
        var _a;
        const payload = await $2UZxa.getPayload(params.localPeer, this.staticKeys.publicKey, this.earlyData);
        let tryIK = this.useNoisePipes;
        if (params.isInitiator && $6nNT2.KeyCache.load(params.remotePeer) === null) // if we are initiator and remote static key is unknown, don't try IK
        tryIK = false;
        // Try IK if acting as responder or initiator that has remote's static key.
        if (tryIK) {
            // Try IK first
            const { remotePeer: remotePeer, connection: connection, isInitiator: isInitiator } = params;
            const ikHandshake = new $4JPON.IKHandshake(isInitiator, payload, this.prologue, this.staticKeys, connection, // safe to cast as we did checks
            (_a = $6nNT2.KeyCache.load(params.remotePeer)) !== null && _a !== void 0 ? _a : $l7tTk.Buffer.alloc(32), remotePeer);
            try {
                return await this.performIKHandshake(ikHandshake);
            } catch (e) {
                // IK failed, go to XX fallback
                let ephemeralKeys;
                if (params.isInitiator) ephemeralKeys = ikHandshake.getLocalEphemeralKeys();
                return await this.performXXFallbackHandshake(params, payload, e.initialMsg, ephemeralKeys);
            }
        } else // run XX handshake
        return await this.performXXHandshake(params, payload);
    }
    async performXXFallbackHandshake(params, payload, initialMsg, ephemeralKeys) {
        const { isInitiator: isInitiator, remotePeer: remotePeer, connection: connection } = params;
        const handshake = new $aCOlY.XXFallbackHandshake(isInitiator, payload, this.prologue, this.staticKeys, connection, initialMsg, remotePeer, ephemeralKeys);
        try {
            await handshake.propose();
            await handshake.exchange();
            await handshake.finish();
        } catch (e) {
            $e4tcr.logger(e);
            const err = e;
            throw new Error(`Error occurred during XX Fallback handshake: ${err.message}`);
        }
        return handshake;
    }
    async performXXHandshake(params, payload) {
        const { isInitiator: isInitiator, remotePeer: remotePeer, connection: connection } = params;
        const handshake = new $kyJGt.XXHandshake(isInitiator, payload, this.prologue, this.staticKeys, connection, remotePeer);
        try {
            await handshake.propose();
            await handshake.exchange();
            await handshake.finish();
            if (this.useNoisePipes && handshake.remotePeer) $6nNT2.KeyCache.store(handshake.remotePeer, handshake.getRemoteStaticKey());
        } catch (e) {
            const err = e;
            throw new Error(`Error occurred during XX handshake: ${err.message}`);
        }
        return handshake;
    }
    async performIKHandshake(handshake) {
        await handshake.stage0();
        await handshake.stage1();
        return handshake;
    }
    async createSecureConnection(connection, handshake) {
        // Create encryption box/unbox wrapper
        const [secure, user] = $6d9e9eadb737f954$var$duplex_1.default();
        const network = connection.unwrap();
        await $6d9e9eadb737f954$var$it_pipe_1.default(secure, $6d9e9eadb737f954$var$it_buffer_1.default, $leW0E.encryptStream(handshake), $4zeIG.encode({
            lengthEncoder: $evFdC.uint16BEEncode
        }), network, $4zeIG.decode({
            lengthDecoder: $evFdC.uint16BEDecode
        }), $6d9e9eadb737f954$var$it_buffer_1.default, $leW0E.decryptStream(handshake), secure // pipe to the wrapper
        );
        return user;
    }
}
module.exports.Noise = $6d9e9eadb737f954$var$Noise;

});
parcelRequire.register("f4nIP", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sharedKey = module.exports.generateKeyPair = module.exports.generateKeyPairFromSeed = module.exports.scalarMultBase = module.exports.scalarMult = module.exports.SHARED_KEY_LENGTH = module.exports.SECRET_KEY_LENGTH = module.exports.PUBLIC_KEY_LENGTH = void 0;

var $aqwbR = parcelRequire("aqwbR");

var $eySe8 = parcelRequire("eySe8");
module.exports.PUBLIC_KEY_LENGTH = 32;
module.exports.SECRET_KEY_LENGTH = 32;
module.exports.SHARED_KEY_LENGTH = 32;
// Returns new zero-filled 16-element GF (Float64Array).
// If passed an array of numbers, prefills the returned
// array with them.
//
// We use Float64Array, because we need 48-bit numbers
// for this implementation.
function $af89a16ec719d952$var$gf(init) {
    const r = new Float64Array(16);
    if (init) for(let i = 0; i < init.length; i++)r[i] = init[i];
    return r;
}
// Base point.
const $af89a16ec719d952$var$_9 = new Uint8Array(32);
$af89a16ec719d952$var$_9[0] = 9;
const $af89a16ec719d952$var$_121665 = $af89a16ec719d952$var$gf([
    0xdb41,
    1
]);
function $af89a16ec719d952$var$car25519(o) {
    let c = 1;
    for(let i = 0; i < 16; i++){
        let v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $af89a16ec719d952$var$sel25519(p, q, b) {
    const c = ~(b - 1);
    for(let i = 0; i < 16; i++){
        const t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $af89a16ec719d952$var$pack25519(o, n) {
    const m = $af89a16ec719d952$var$gf();
    const t = $af89a16ec719d952$var$gf();
    for(let i = 0; i < 16; i++)t[i] = n[i];
    $af89a16ec719d952$var$car25519(t);
    $af89a16ec719d952$var$car25519(t);
    $af89a16ec719d952$var$car25519(t);
    for(let j = 0; j < 2; j++){
        m[0] = t[0] - 0xffed;
        for(let i = 1; i < 15; i++){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        const b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $af89a16ec719d952$var$sel25519(t, m, 1 - b);
    }
    for(let i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $af89a16ec719d952$var$unpack25519(o, n) {
    for(let i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $af89a16ec719d952$var$add(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] + b[i];
}
function $af89a16ec719d952$var$sub(o, a, b) {
    for(let i = 0; i < 16; i++)o[i] = a[i] - b[i];
}
function $af89a16ec719d952$var$mul(o, a, b) {
    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}
function $af89a16ec719d952$var$square(o, a) {
    $af89a16ec719d952$var$mul(o, a, a);
}
function $af89a16ec719d952$var$inv25519(o, inp) {
    const c = $af89a16ec719d952$var$gf();
    for(let i = 0; i < 16; i++)c[i] = inp[i];
    for(let i = 253; i >= 0; i--){
        $af89a16ec719d952$var$square(c, c);
        if (i !== 2 && i !== 4) $af89a16ec719d952$var$mul(c, c, inp);
    }
    for(let i = 0; i < 16; i++)o[i] = c[i];
}
function $af89a16ec719d952$var$scalarMult(n, p) {
    const z = new Uint8Array(32);
    const x = new Float64Array(80);
    const a = $af89a16ec719d952$var$gf(), b = $af89a16ec719d952$var$gf(), c = $af89a16ec719d952$var$gf(), d = $af89a16ec719d952$var$gf(), e = $af89a16ec719d952$var$gf(), f = $af89a16ec719d952$var$gf();
    for(let i = 0; i < 31; i++)z[i] = n[i];
    z[31] = n[31] & 127 | 64;
    z[0] &= 248;
    $af89a16ec719d952$var$unpack25519(x, p);
    for(let i = 0; i < 16; i++)b[i] = x[i];
    a[0] = d[0] = 1;
    for(let i = 254; i >= 0; --i){
        const r = z[i >>> 3] >>> (i & 7) & 1;
        $af89a16ec719d952$var$sel25519(a, b, r);
        $af89a16ec719d952$var$sel25519(c, d, r);
        $af89a16ec719d952$var$add(e, a, c);
        $af89a16ec719d952$var$sub(a, a, c);
        $af89a16ec719d952$var$add(c, b, d);
        $af89a16ec719d952$var$sub(b, b, d);
        $af89a16ec719d952$var$square(d, e);
        $af89a16ec719d952$var$square(f, a);
        $af89a16ec719d952$var$mul(a, c, a);
        $af89a16ec719d952$var$mul(c, b, e);
        $af89a16ec719d952$var$add(e, a, c);
        $af89a16ec719d952$var$sub(a, a, c);
        $af89a16ec719d952$var$square(b, a);
        $af89a16ec719d952$var$sub(c, d, f);
        $af89a16ec719d952$var$mul(a, c, $af89a16ec719d952$var$_121665);
        $af89a16ec719d952$var$add(a, a, d);
        $af89a16ec719d952$var$mul(c, c, a);
        $af89a16ec719d952$var$mul(a, d, f);
        $af89a16ec719d952$var$mul(d, b, x);
        $af89a16ec719d952$var$square(b, e);
        $af89a16ec719d952$var$sel25519(a, b, r);
        $af89a16ec719d952$var$sel25519(c, d, r);
    }
    for(let i = 0; i < 16; i++){
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
    }
    const x32 = x.subarray(32);
    const x16 = x.subarray(16);
    $af89a16ec719d952$var$inv25519(x32, x32);
    $af89a16ec719d952$var$mul(x16, x16, x32);
    const q = new Uint8Array(32);
    $af89a16ec719d952$var$pack25519(q, x16);
    return q;
}
module.exports.scalarMult = $af89a16ec719d952$var$scalarMult;
function $af89a16ec719d952$var$scalarMultBase(n) {
    return $af89a16ec719d952$var$scalarMult(n, $af89a16ec719d952$var$_9);
}
module.exports.scalarMultBase = $af89a16ec719d952$var$scalarMultBase;
function $af89a16ec719d952$var$generateKeyPairFromSeed(seed) {
    if (seed.length !== module.exports.SECRET_KEY_LENGTH) throw new Error(`x25519: seed must be ${module.exports.SECRET_KEY_LENGTH} bytes`);
    const secretKey = new Uint8Array(seed);
    const publicKey = $af89a16ec719d952$var$scalarMultBase(secretKey);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
}
module.exports.generateKeyPairFromSeed = $af89a16ec719d952$var$generateKeyPairFromSeed;
function $af89a16ec719d952$var$generateKeyPair(prng) {
    const seed = (0, $aqwbR.randomBytes)(32, prng);
    const result = $af89a16ec719d952$var$generateKeyPairFromSeed(seed);
    (0, $eySe8.wipe)(seed);
    return result;
}
module.exports.generateKeyPair = $af89a16ec719d952$var$generateKeyPair;
/**
 * Returns a shared key between our secret key and a peer's public key.
 *
 * Throws an error if the given keys are of wrong length.
 *
 * If rejectZero is true throws if the calculated shared key is all-zero.
 * From RFC 7748:
 *
 * > Protocol designers using Diffie-Hellman over the curves defined in
 * > this document must not assume "contributory behavior".  Specially,
 * > contributory behavior means that both parties' private keys
 * > contribute to the resulting shared key.  Since curve25519 and
 * > curve448 have cofactors of 8 and 4 (respectively), an input point of
 * > small order will eliminate any contribution from the other party's
 * > private key.  This situation can be detected by checking for the all-
 * > zero output, which implementations MAY do, as specified in Section 6.
 * > However, a large number of existing implementations do not do this.
 *
 * IMPORTANT: the returned key is a raw result of scalar multiplication.
 * To use it as a key material, hash it with a cryptographic hash function.
 */ function $af89a16ec719d952$var$sharedKey(mySecretKey, theirPublicKey, rejectZero = false) {
    if (mySecretKey.length !== module.exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect secret key length");
    if (theirPublicKey.length !== module.exports.PUBLIC_KEY_LENGTH) throw new Error("X25519: incorrect public key length");
    const result = $af89a16ec719d952$var$scalarMult(mySecretKey, theirPublicKey);
    if (rejectZero) {
        let zeros = 0;
        for(let i = 0; i < result.length; i++)zeros |= result[i];
        if (zeros === 0) throw new Error("X25519: invalid shared key");
    }
    return result;
}
module.exports.sharedKey = $af89a16ec719d952$var$sharedKey;

});
parcelRequire.register("aqwbR", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomStringForEntropy = module.exports.randomString = module.exports.randomUint32 = module.exports.randomBytes = module.exports.defaultRandomSource = void 0;

var $kYe9K = parcelRequire("kYe9K");

var $gE4xe = parcelRequire("gE4xe");

var $eySe8 = parcelRequire("eySe8");
module.exports.defaultRandomSource = new $kYe9K.SystemRandomSource();
function $79754d7030ccaf3f$var$randomBytes(length, prng = module.exports.defaultRandomSource) {
    return prng.randomBytes(length);
}
module.exports.randomBytes = $79754d7030ccaf3f$var$randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */ function $79754d7030ccaf3f$var$randomUint32(prng = module.exports.defaultRandomSource) {
    // Generate 4-byte random buffer.
    const buf = $79754d7030ccaf3f$var$randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    const result = (0, $gE4xe.readUint32LE)(buf);
    // Clean the buffer.
    (0, $eySe8.wipe)(buf);
    return result;
}
module.exports.randomUint32 = $79754d7030ccaf3f$var$randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */ const $79754d7030ccaf3f$var$ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $79754d7030ccaf3f$var$randomString(length, charset = $79754d7030ccaf3f$var$ALPHANUMERIC, prng = module.exports.defaultRandomSource) {
    if (charset.length < 2) throw new Error("randomString charset is too short");
    if (charset.length > 256) throw new Error("randomString charset is too long");
    let out = "";
    const charsLen = charset.length;
    const maxByte = 256 - 256 % charsLen;
    while(length > 0){
        const buf = $79754d7030ccaf3f$var$randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for(let i = 0; i < buf.length && length > 0; i++){
            const randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, $eySe8.wipe)(buf);
    }
    return out;
}
module.exports.randomString = $79754d7030ccaf3f$var$randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */ function $79754d7030ccaf3f$var$randomStringForEntropy(bits, charset = $79754d7030ccaf3f$var$ALPHANUMERIC, prng = module.exports.defaultRandomSource) {
    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return $79754d7030ccaf3f$var$randomString(length, charset, prng);
}
module.exports.randomStringForEntropy = $79754d7030ccaf3f$var$randomStringForEntropy;

});
parcelRequire.register("kYe9K", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SystemRandomSource = void 0;

var $eOZfA = parcelRequire("eOZfA");

var $irIj2 = parcelRequire("irIj2");
class $f4446463e4177880$var$SystemRandomSource {
    constructor(){
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new $eOZfA.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new $irIj2.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
    // No sources, we're out of options.
    }
    randomBytes(length) {
        if (!this.isAvailable) throw new Error("System random byte generator is not available.");
        return this._source.randomBytes(length);
    }
}
module.exports.SystemRandomSource = $f4446463e4177880$var$SystemRandomSource;

});
parcelRequire.register("eOZfA", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserRandomSource = void 0;
const $aca53f3ee56fc6f2$var$QUOTA = 65536;
class $aca53f3ee56fc6f2$var$BrowserRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        const browserCrypto = typeof self !== "undefined" ? self.crypto || self.msCrypto // IE11 has msCrypto
         : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Browser random byte generator is not available.");
        const out = new Uint8Array(length);
        for(let i = 0; i < out.length; i += $aca53f3ee56fc6f2$var$QUOTA)this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, $aca53f3ee56fc6f2$var$QUOTA)));
        return out;
    }
}
module.exports.BrowserRandomSource = $aca53f3ee56fc6f2$var$BrowserRandomSource;

});

parcelRequire.register("irIj2", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NodeRandomSource = void 0;

var $eySe8 = parcelRequire("eySe8");

class $d6dd1de1f383b78c$var$NodeRandomSource {
    constructor(){
        this.isAvailable = false;
        this.isInstantiated = false;
        {
            const nodeCrypto = (parcelRequire("7jzxY"));
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) throw new Error("Node.js random byte generator is not available.");
        // Get random bytes (result is Buffer).
        let buffer = this._crypto.randomBytes(length);
        // Make sure we got the length that we requested.
        if (buffer.length !== length) throw new Error("NodeRandomSource: got fewer bytes than requested");
        // Allocate output array.
        const out = new Uint8Array(length);
        // Copy bytes from buffer to output.
        for(let i = 0; i < out.length; i++)out[i] = buffer[i];
        // Cleanup.
        (0, $eySe8.wipe)(buffer);
        return out;
    }
}
module.exports.NodeRandomSource = $d6dd1de1f383b78c$var$NodeRandomSource;

});
parcelRequire.register("eySe8", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */ function $a99e4e017b518834$var$wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for(var i = 0; i < array.length; i++)array[i] = 0;
    return array;
}
module.exports.wipe = $a99e4e017b518834$var$wipe;

});



parcelRequire.register("gE4xe", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2ubVo = parcelRequire("2ubVo");
// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */ function $c1e3e64fa1cb8f11$var$readInt16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) << 16 >> 16;
}
module.exports.readInt16BE = $c1e3e64fa1cb8f11$var$readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */ function $c1e3e64fa1cb8f11$var$readUint16BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 0] << 8 | array[offset + 1]) >>> 0;
}
module.exports.readUint16BE = $c1e3e64fa1cb8f11$var$readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */ function $c1e3e64fa1cb8f11$var$readInt16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) << 16 >> 16;
}
module.exports.readInt16LE = $c1e3e64fa1cb8f11$var$readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */ function $c1e3e64fa1cb8f11$var$readUint16LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 1] << 8 | array[offset]) >>> 0;
}
module.exports.readUint16LE = $c1e3e64fa1cb8f11$var$readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $c1e3e64fa1cb8f11$var$writeUint16BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
module.exports.writeUint16BE = $c1e3e64fa1cb8f11$var$writeUint16BE;
module.exports.writeInt16BE = $c1e3e64fa1cb8f11$var$writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */ function $c1e3e64fa1cb8f11$var$writeUint16LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(2);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
module.exports.writeUint16LE = $c1e3e64fa1cb8f11$var$writeUint16LE;
module.exports.writeInt16LE = $c1e3e64fa1cb8f11$var$writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */ function $c1e3e64fa1cb8f11$var$readInt32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3];
}
module.exports.readInt32BE = $c1e3e64fa1cb8f11$var$readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */ function $c1e3e64fa1cb8f11$var$readUint32BE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset] << 24 | array[offset + 1] << 16 | array[offset + 2] << 8 | array[offset + 3]) >>> 0;
}
module.exports.readUint32BE = $c1e3e64fa1cb8f11$var$readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */ function $c1e3e64fa1cb8f11$var$readInt32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset];
}
module.exports.readInt32LE = $c1e3e64fa1cb8f11$var$readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */ function $c1e3e64fa1cb8f11$var$readUint32LE(array, offset) {
    if (offset === void 0) offset = 0;
    return (array[offset + 3] << 24 | array[offset + 2] << 16 | array[offset + 1] << 8 | array[offset]) >>> 0;
}
module.exports.readUint32LE = $c1e3e64fa1cb8f11$var$readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $c1e3e64fa1cb8f11$var$writeUint32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
module.exports.writeUint32BE = $c1e3e64fa1cb8f11$var$writeUint32BE;
module.exports.writeInt32BE = $c1e3e64fa1cb8f11$var$writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $c1e3e64fa1cb8f11$var$writeUint32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
module.exports.writeUint32LE = $c1e3e64fa1cb8f11$var$writeUint32LE;
module.exports.writeInt32LE = $c1e3e64fa1cb8f11$var$writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $c1e3e64fa1cb8f11$var$readInt64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $c1e3e64fa1cb8f11$var$readInt32BE(array, offset);
    var lo = $c1e3e64fa1cb8f11$var$readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
module.exports.readInt64BE = $c1e3e64fa1cb8f11$var$readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $c1e3e64fa1cb8f11$var$readUint64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var hi = $c1e3e64fa1cb8f11$var$readUint32BE(array, offset);
    var lo = $c1e3e64fa1cb8f11$var$readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
module.exports.readUint64BE = $c1e3e64fa1cb8f11$var$readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */ function $c1e3e64fa1cb8f11$var$readInt64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $c1e3e64fa1cb8f11$var$readInt32LE(array, offset);
    var hi = $c1e3e64fa1cb8f11$var$readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - (lo >> 31) * 0x100000000;
}
module.exports.readInt64LE = $c1e3e64fa1cb8f11$var$readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */ function $c1e3e64fa1cb8f11$var$readUint64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var lo = $c1e3e64fa1cb8f11$var$readUint32LE(array, offset);
    var hi = $c1e3e64fa1cb8f11$var$readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
module.exports.readUint64LE = $c1e3e64fa1cb8f11$var$readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $c1e3e64fa1cb8f11$var$writeUint64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $c1e3e64fa1cb8f11$var$writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    $c1e3e64fa1cb8f11$var$writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
module.exports.writeUint64BE = $c1e3e64fa1cb8f11$var$writeUint64BE;
module.exports.writeInt64BE = $c1e3e64fa1cb8f11$var$writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $c1e3e64fa1cb8f11$var$writeUint64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    $c1e3e64fa1cb8f11$var$writeUint32LE(value >>> 0, out, offset);
    $c1e3e64fa1cb8f11$var$writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
module.exports.writeUint64LE = $c1e3e64fa1cb8f11$var$writeUint64LE;
module.exports.writeInt64LE = $c1e3e64fa1cb8f11$var$writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $c1e3e64fa1cb8f11$var$readUintBE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintBE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintBE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
module.exports.readUintBE = $c1e3e64fa1cb8f11$var$readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */ function $c1e3e64fa1cb8f11$var$readUintLE(bitLength, array, offset) {
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("readUintLE supports only bitLengths divisible by 8");
    if (bitLength / 8 > array.length - offset) throw new Error("readUintLE: array is too short for the given bitLength");
    var result = 0;
    var mul = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
module.exports.readUintLE = $c1e3e64fa1cb8f11$var$readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $c1e3e64fa1cb8f11$var$writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintBE supports only bitLengths divisible by 8");
    if (!$2ubVo.isSafeInteger(value)) throw new Error("writeUintBE value must be an integer");
    var div = 1;
    for(var i = bitLength / 8 + offset - 1; i >= offset; i--){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
module.exports.writeUintBE = $c1e3e64fa1cb8f11$var$writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */ function $c1e3e64fa1cb8f11$var$writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) out = new Uint8Array(bitLength / 8);
    if (offset === void 0) offset = 0;
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) throw new Error("writeUintLE supports only bitLengths divisible by 8");
    if (!$2ubVo.isSafeInteger(value)) throw new Error("writeUintLE value must be an integer");
    var div = 1;
    for(var i = offset; i < offset + bitLength / 8; i++){
        out[i] = value / div & 0xff;
        div *= 256;
    }
    return out;
}
module.exports.writeUintLE = $c1e3e64fa1cb8f11$var$writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */ function $c1e3e64fa1cb8f11$var$readFloat32BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
module.exports.readFloat32BE = $c1e3e64fa1cb8f11$var$readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */ function $c1e3e64fa1cb8f11$var$readFloat32LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
module.exports.readFloat32LE = $c1e3e64fa1cb8f11$var$readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $c1e3e64fa1cb8f11$var$readFloat64BE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
module.exports.readFloat64BE = $c1e3e64fa1cb8f11$var$readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */ function $c1e3e64fa1cb8f11$var$readFloat64LE(array, offset) {
    if (offset === void 0) offset = 0;
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
module.exports.readFloat64LE = $c1e3e64fa1cb8f11$var$readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $c1e3e64fa1cb8f11$var$writeFloat32BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
module.exports.writeFloat32BE = $c1e3e64fa1cb8f11$var$writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */ function $c1e3e64fa1cb8f11$var$writeFloat32LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(4);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
module.exports.writeFloat32LE = $c1e3e64fa1cb8f11$var$writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $c1e3e64fa1cb8f11$var$writeFloat64BE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
module.exports.writeFloat64BE = $c1e3e64fa1cb8f11$var$writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */ function $c1e3e64fa1cb8f11$var$writeFloat64LE(value, out, offset) {
    if (out === void 0) out = new Uint8Array(8);
    if (offset === void 0) offset = 0;
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
module.exports.writeFloat64LE = $c1e3e64fa1cb8f11$var$writeFloat64LE;

});
parcelRequire.register("2ubVo", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Package int provides helper functions for integerss.
 */ // Shim using 16-bit pieces.
function $1cf7a222757db03a$var$imulShim(a, b) {
    var ah = a >>> 16 & 0xffff, al = a & 0xffff;
    var bh = b >>> 16 & 0xffff, bl = b & 0xffff;
    return al * bl + (ah * bl + al * bh << 16 >>> 0) | 0;
}
/** 32-bit integer multiplication.  */ // Use system Math.imul if available, otherwise use our shim.
module.exports.mul = Math.imul || $1cf7a222757db03a$var$imulShim;
/** 32-bit integer addition.  */ function $1cf7a222757db03a$var$add(a, b) {
    return a + b | 0;
}
module.exports.add = $1cf7a222757db03a$var$add;
/**  32-bit integer subtraction.  */ function $1cf7a222757db03a$var$sub(a, b) {
    return a - b | 0;
}
module.exports.sub = $1cf7a222757db03a$var$sub;
/** 32-bit integer left rotation */ function $1cf7a222757db03a$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
module.exports.rotl = $1cf7a222757db03a$var$rotl;
/** 32-bit integer left rotation */ function $1cf7a222757db03a$var$rotr(x, n) {
    return x << 32 - n | x >>> n;
}
module.exports.rotr = $1cf7a222757db03a$var$rotr;
function $1cf7a222757db03a$var$isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */ module.exports.isInteger = Number.isInteger || $1cf7a222757db03a$var$isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */ module.exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */ module.exports.isSafeInteger = function(n) {
    return module.exports.isInteger(n) && n >= -module.exports.MAX_SAFE_INTEGER && n <= module.exports.MAX_SAFE_INTEGER;
};

});




parcelRequire.register("8of1c", function(module, exports) {
"use strict";

var $6Hw7X = parcelRequire("6Hw7X");

var $l2xaW = parcelRequire("l2xaW");

var $4zeIG = parcelRequire("4zeIG");
module.exports = (duplex, opts = {})=>{
    const shake = $l2xaW(duplex);
    const lpReader = $4zeIG.decode.fromReader(shake.reader, opts);
    let isDone = false;
    const W = {
        read: async (bytes)=>{
            // just read
            const { value: value, done: done } = await shake.reader.next(bytes);
            if (done && value.length < bytes) throw new Error("Couldn't read enough bytes");
            isDone = done;
            if (!value) throw new Error("Value is null");
            return value;
        },
        readLP: async ()=>{
            // read, decode
            const { value: value, done: done } = await lpReader.next();
            isDone = done;
            if (!value) throw new Error("Value is null");
            return value;
        },
        readPB: async (proto)=>{
            // readLP, decode
            const value = await W.readLP();
            if (!value) throw new Error("Value is null");
            // Is this a buffer?
            const buf = $6Hw7X(value) ? value : value.slice();
            return proto.decode(buf);
        },
        write: (data)=>{
            // just write
            shake.writer.push(data);
        },
        writeLP: (data)=>{
            // encode, write
            W.write($4zeIG.encode.single(data, opts));
        },
        writePB: (data, proto)=>{
            // encode, writeLP
            W.writeLP(proto.encode(data));
        },
        pb: (proto)=>{
            return {
                read: ()=>W.readPB(proto),
                write: (d)=>W.writePB(d, proto)
            };
        },
        unwrap: ()=>{
            // returns vanilla duplex again, terminates all reads/writes from this object
            shake.rest();
            return shake.stream;
        }
    };
    return W;
};

});
parcelRequire.register("6Hw7X", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};

});


parcelRequire.register("dFwnx", function(module, exports) {

var $lcFNx = parcelRequire("lcFNx");
module.exports = function() {
    var a = $lcFNx();
    var b = $lcFNx();
    return [
        {
            source: a.source,
            sink: b.sink
        },
        {
            source: b.source,
            sink: a.sink
        }
    ];
};

});
parcelRequire.register("lcFNx", function(module, exports) {
"use strict";

var $fFtlq = parcelRequire("fFtlq");
// a pair of streams where one drains from the other
module.exports = function pair() {
    let _source, onSource;
    const sink = async (source)=>{
        if (_source) throw new Error("already piped");
        _source = $fFtlq(source);
        if (onSource) onSource(_source);
    };
    const source = {
        [Symbol.asyncIterator] () {
            return this;
        },
        next () {
            if (_source) return _source.next();
            return new Promise((resolve)=>{
                onSource = (source)=>{
                    onSource = null;
                    resolve(source.next());
                };
            });
        }
    };
    return {
        sink: sink,
        source: source
    };
};

});


parcelRequire.register("kyJGt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.XXHandshake = void 0;

var $l7tTk = parcelRequire("l7tTk");

var $RNdAr = parcelRequire("RNdAr");

var $2UZxa = parcelRequire("2UZxa");

var $e4tcr = parcelRequire("e4tcr");

var $evFdC = parcelRequire("evFdC");
class $ef7a6b865ca6bfef$var$XXHandshake {
    constructor(isInitiator, payload, prologue, staticKeypair, connection, remotePeer, handshake){
        this.isInitiator = isInitiator;
        this.payload = payload;
        this.prologue = prologue;
        this.staticKeypair = staticKeypair;
        this.connection = connection;
        if (remotePeer) this.remotePeer = remotePeer;
        this.xx = handshake !== null && handshake !== void 0 ? handshake : new $RNdAr.XX();
        this.session = this.xx.initSession(this.isInitiator, this.prologue, this.staticKeypair);
        this.remoteEarlyData = $l7tTk.Buffer.alloc(0);
    }
    // stage 0
    async propose() {
        $e4tcr.logLocalStaticKeys(this.session.hs.s);
        if (this.isInitiator) {
            $e4tcr.logger("Stage 0 - Initiator starting to send first message.");
            const messageBuffer = this.xx.sendMessage(this.session, $l7tTk.Buffer.alloc(0));
            this.connection.writeLP($evFdC.encode0(messageBuffer));
            $e4tcr.logger("Stage 0 - Initiator finished sending first message.");
            $e4tcr.logLocalEphemeralKeys(this.session.hs.e);
        } else {
            $e4tcr.logger("Stage 0 - Responder waiting to receive first message...");
            const receivedMessageBuffer = $evFdC.decode0((await this.connection.readLP()).slice());
            const { valid: valid } = this.xx.recvMessage(this.session, receivedMessageBuffer);
            if (!valid) throw new Error("xx handshake stage 0 validation fail");
            $e4tcr.logger("Stage 0 - Responder received first message.");
            $e4tcr.logRemoteEphemeralKey(this.session.hs.re);
        }
    }
    // stage 1
    async exchange() {
        if (this.isInitiator) {
            $e4tcr.logger("Stage 1 - Initiator waiting to receive first message from responder...");
            const receivedMessageBuffer = $evFdC.decode1((await this.connection.readLP()).slice());
            const { plaintext: plaintext, valid: valid } = this.xx.recvMessage(this.session, receivedMessageBuffer);
            if (!valid) throw new Error("xx handshake stage 1 validation fail");
            $e4tcr.logger("Stage 1 - Initiator received the message.");
            $e4tcr.logRemoteEphemeralKey(this.session.hs.re);
            $e4tcr.logRemoteStaticKey(this.session.hs.rs);
            $e4tcr.logger("Initiator going to check remote's signature...");
            try {
                const decodedPayload = await $2UZxa.decodePayload(plaintext);
                this.remotePeer = this.remotePeer || await $2UZxa.getPeerIdFromPayload(decodedPayload);
                this.remotePeer = await $2UZxa.verifySignedPayload(receivedMessageBuffer.ns, decodedPayload, this.remotePeer);
                this.setRemoteEarlyData(decodedPayload.data);
            } catch (e) {
                const err = e;
                throw new Error(`Error occurred while verifying signed payload: ${err.message}`);
            }
            $e4tcr.logger("All good with the signature!");
        } else {
            $e4tcr.logger("Stage 1 - Responder sending out first message with signed payload and static key.");
            const messageBuffer = this.xx.sendMessage(this.session, this.payload);
            this.connection.writeLP($evFdC.encode1(messageBuffer));
            $e4tcr.logger("Stage 1 - Responder sent the second handshake message with signed payload.");
            $e4tcr.logLocalEphemeralKeys(this.session.hs.e);
        }
    }
    // stage 2
    async finish() {
        if (this.isInitiator) {
            $e4tcr.logger("Stage 2 - Initiator sending third handshake message.");
            const messageBuffer = this.xx.sendMessage(this.session, this.payload);
            this.connection.writeLP($evFdC.encode2(messageBuffer));
            $e4tcr.logger("Stage 2 - Initiator sent message with signed payload.");
        } else {
            $e4tcr.logger("Stage 2 - Responder waiting for third handshake message...");
            const receivedMessageBuffer = $evFdC.decode2((await this.connection.readLP()).slice());
            const { plaintext: plaintext, valid: valid } = this.xx.recvMessage(this.session, receivedMessageBuffer);
            if (!valid) throw new Error("xx handshake stage 2 validation fail");
            $e4tcr.logger("Stage 2 - Responder received the message, finished handshake.");
            try {
                const decodedPayload = await $2UZxa.decodePayload(plaintext);
                this.remotePeer = this.remotePeer || await $2UZxa.getPeerIdFromPayload(decodedPayload);
                await $2UZxa.verifySignedPayload(this.session.hs.rs, decodedPayload, this.remotePeer);
                this.setRemoteEarlyData(decodedPayload.data);
            } catch (e) {
                const err = e;
                throw new Error(`Error occurred while verifying signed payload: ${err.message}`);
            }
        }
        $e4tcr.logCipherState(this.session);
    }
    encrypt(plaintext, session) {
        const cs = this.getCS(session);
        return this.xx.encryptWithAd(cs, $l7tTk.Buffer.alloc(0), plaintext);
    }
    decrypt(ciphertext, session) {
        const cs = this.getCS(session, false);
        return this.xx.decryptWithAd(cs, $l7tTk.Buffer.alloc(0), ciphertext);
    }
    getRemoteStaticKey() {
        return this.session.hs.rs;
    }
    getCS(session, encryption = true) {
        if (!session.cs1 || !session.cs2) throw new Error("Handshake not completed properly, cipher state does not exist.");
        if (this.isInitiator) return encryption ? session.cs1 : session.cs2;
        else return encryption ? session.cs2 : session.cs1;
    }
    setRemoteEarlyData(data) {
        if (data) this.remoteEarlyData = $l7tTk.Buffer.from(data.buffer, data.byteOffset, data.length);
    }
}
module.exports.XXHandshake = $ef7a6b865ca6bfef$var$XXHandshake;

});
parcelRequire.register("RNdAr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.XX = void 0;

var $l7tTk = parcelRequire("l7tTk");

var $2UZxa = parcelRequire("2UZxa");

var $4jLQO = parcelRequire("4jLQO");
class $0a1b210cae41d136$var$XX extends $4jLQO.AbstractHandshake {
    initializeInitiator(prologue, s, rs, psk) {
        const name = "Noise_XX_25519_ChaChaPoly_SHA256";
        const ss = this.initializeSymmetric(name);
        this.mixHash(ss, prologue);
        const re = $l7tTk.Buffer.alloc(32);
        return {
            ss: ss,
            s: s,
            rs: rs,
            psk: psk,
            re: re
        };
    }
    initializeResponder(prologue, s, rs, psk) {
        const name = "Noise_XX_25519_ChaChaPoly_SHA256";
        const ss = this.initializeSymmetric(name);
        this.mixHash(ss, prologue);
        const re = $l7tTk.Buffer.alloc(32);
        return {
            ss: ss,
            s: s,
            rs: rs,
            psk: psk,
            re: re
        };
    }
    writeMessageA(hs, payload, e) {
        const ns = $l7tTk.Buffer.alloc(0);
        if (e !== undefined) hs.e = e;
        else hs.e = $2UZxa.generateKeypair();
        const ne = hs.e.publicKey;
        this.mixHash(hs.ss, ne);
        const ciphertext = this.encryptAndHash(hs.ss, payload);
        return {
            ne: ne,
            ns: ns,
            ciphertext: ciphertext
        };
    }
    writeMessageB(hs, payload) {
        hs.e = $2UZxa.generateKeypair();
        const ne = hs.e.publicKey;
        this.mixHash(hs.ss, ne);
        this.mixKey(hs.ss, this.dh(hs.e.privateKey, hs.re));
        const spk = $l7tTk.Buffer.from(hs.s.publicKey);
        const ns = this.encryptAndHash(hs.ss, spk);
        this.mixKey(hs.ss, this.dh(hs.s.privateKey, hs.re));
        const ciphertext = this.encryptAndHash(hs.ss, payload);
        return {
            ne: ne,
            ns: ns,
            ciphertext: ciphertext
        };
    }
    writeMessageC(hs, payload) {
        const spk = $l7tTk.Buffer.from(hs.s.publicKey);
        const ns = this.encryptAndHash(hs.ss, spk);
        this.mixKey(hs.ss, this.dh(hs.s.privateKey, hs.re));
        const ciphertext = this.encryptAndHash(hs.ss, payload);
        const ne = this.createEmptyKey();
        const messageBuffer = {
            ne: ne,
            ns: ns,
            ciphertext: ciphertext
        };
        const { cs1: cs1, cs2: cs2 } = this.split(hs.ss);
        return {
            h: hs.ss.h,
            messageBuffer: messageBuffer,
            cs1: cs1,
            cs2: cs2
        };
    }
    readMessageA(hs, message) {
        if ($2UZxa.isValidPublicKey(message.ne)) hs.re = message.ne;
        this.mixHash(hs.ss, hs.re);
        return this.decryptAndHash(hs.ss, message.ciphertext);
    }
    readMessageB(hs, message) {
        if ($2UZxa.isValidPublicKey(message.ne)) hs.re = message.ne;
        this.mixHash(hs.ss, hs.re);
        if (!hs.e) throw new Error("Handshake state `e` param is missing.");
        this.mixKey(hs.ss, this.dh(hs.e.privateKey, hs.re));
        const { plaintext: ns, valid: valid1 } = this.decryptAndHash(hs.ss, message.ns);
        if (valid1 && ns.length === 32 && $2UZxa.isValidPublicKey(ns)) hs.rs = ns;
        this.mixKey(hs.ss, this.dh(hs.e.privateKey, hs.rs));
        const { plaintext: plaintext, valid: valid2 } = this.decryptAndHash(hs.ss, message.ciphertext);
        return {
            plaintext: plaintext,
            valid: valid1 && valid2
        };
    }
    readMessageC(hs, message) {
        const { plaintext: ns, valid: valid1 } = this.decryptAndHash(hs.ss, message.ns);
        if (valid1 && ns.length === 32 && $2UZxa.isValidPublicKey(ns)) hs.rs = ns;
        if (!hs.e) throw new Error("Handshake state `e` param is missing.");
        this.mixKey(hs.ss, this.dh(hs.e.privateKey, hs.rs));
        const { plaintext: plaintext, valid: valid2 } = this.decryptAndHash(hs.ss, message.ciphertext);
        const { cs1: cs1, cs2: cs2 } = this.split(hs.ss);
        return {
            h: hs.ss.h,
            plaintext: plaintext,
            valid: valid1 && valid2,
            cs1: cs1,
            cs2: cs2
        };
    }
    initSession(initiator, prologue, s) {
        const psk = this.createEmptyKey();
        const rs = $l7tTk.Buffer.alloc(32); // no static key yet
        let hs;
        if (initiator) hs = this.initializeInitiator(prologue, s, rs, psk);
        else hs = this.initializeResponder(prologue, s, rs, psk);
        return {
            hs: hs,
            i: initiator,
            mc: 0
        };
    }
    sendMessage(session, message, ephemeral) {
        let messageBuffer;
        if (session.mc === 0) messageBuffer = this.writeMessageA(session.hs, message, ephemeral);
        else if (session.mc === 1) messageBuffer = this.writeMessageB(session.hs, message);
        else if (session.mc === 2) {
            const { h: h, messageBuffer: resultingBuffer, cs1: cs1, cs2: cs2 } = this.writeMessageC(session.hs, message);
            messageBuffer = resultingBuffer;
            session.h = h;
            session.cs1 = cs1;
            session.cs2 = cs2;
        } else if (session.mc > 2) {
            if (session.i) {
                if (!session.cs1) throw new Error("CS1 (cipher state) is not defined");
                messageBuffer = this.writeMessageRegular(session.cs1, message);
            } else {
                if (!session.cs2) throw new Error("CS2 (cipher state) is not defined");
                messageBuffer = this.writeMessageRegular(session.cs2, message);
            }
        } else throw new Error("Session invalid.");
        session.mc++;
        return messageBuffer;
    }
    recvMessage(session, message) {
        let plaintext = $l7tTk.Buffer.alloc(0);
        let valid = false;
        if (session.mc === 0) ({ plaintext: plaintext, valid: valid } = this.readMessageA(session.hs, message));
        else if (session.mc === 1) ({ plaintext: plaintext, valid: valid } = this.readMessageB(session.hs, message));
        else if (session.mc === 2) {
            const { h: h, plaintext: resultingPlaintext, valid: resultingValid, cs1: cs1, cs2: cs2 } = this.readMessageC(session.hs, message);
            plaintext = resultingPlaintext;
            valid = resultingValid;
            session.h = h;
            session.cs1 = cs1;
            session.cs2 = cs2;
        }
        session.mc++;
        return {
            plaintext: plaintext,
            valid: valid
        };
    }
}
module.exports.XX = $0a1b210cae41d136$var$XX;

});
parcelRequire.register("2UZxa", function(module, exports) {
"use strict";
var $22008b1674ec9c5b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $22008b1674ec9c5b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $22008b1674ec9c5b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $22008b1674ec9c5b$var$__createBinding(result, mod, k);
    }
    $22008b1674ec9c5b$var$__setModuleDefault(result, mod);
    return result;
};
var $22008b1674ec9c5b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isValidPublicKey = module.exports.getHkdf = module.exports.verifySignedPayload = module.exports.getHandshakePayload = module.exports.decodePayload = module.exports.getPeerIdFromPayload = module.exports.signPayload = module.exports.createHandshakePayload = module.exports.getPayload = module.exports.generateKeypair = void 0;

var $fLRaB = parcelRequire("fLRaB");

var $7NVV1 = parcelRequire("7NVV1");

const $22008b1674ec9c5b$var$x25519 = $22008b1674ec9c5b$var$__importStar((parcelRequire("f4nIP")));

var $l7tTk = parcelRequire("l7tTk");

const $22008b1674ec9c5b$var$peer_id_1 = $22008b1674ec9c5b$var$__importDefault((parcelRequire("9ewRV")));

var $hN6NI = parcelRequire("hN6NI");

var $k0bfI = parcelRequire("k0bfI");

const $22008b1674ec9c5b$var$equals_1 = $22008b1674ec9c5b$var$__importDefault((parcelRequire("ebRvg")));
const $22008b1674ec9c5b$var$NoiseHandshakePayloadProto = $k0bfI.pb.NoiseHandshakePayload;
function $22008b1674ec9c5b$var$generateKeypair() {
    const keypair = $22008b1674ec9c5b$var$x25519.generateKeyPair();
    return {
        publicKey: $l7tTk.Buffer.from(keypair.publicKey.buffer, keypair.publicKey.byteOffset, keypair.publicKey.length),
        privateKey: $l7tTk.Buffer.from(keypair.secretKey.buffer, keypair.secretKey.byteOffset, keypair.secretKey.length)
    };
}
module.exports.generateKeypair = $22008b1674ec9c5b$var$generateKeypair;
async function $22008b1674ec9c5b$var$getPayload(localPeer, staticPublicKey, earlyData) {
    const signedPayload = await $22008b1674ec9c5b$var$signPayload(localPeer, $22008b1674ec9c5b$var$getHandshakePayload(staticPublicKey));
    const earlyDataPayload = earlyData !== null && earlyData !== void 0 ? earlyData : $l7tTk.Buffer.alloc(0);
    return $22008b1674ec9c5b$var$createHandshakePayload(localPeer.marshalPubKey(), signedPayload, earlyDataPayload);
}
module.exports.getPayload = $22008b1674ec9c5b$var$getPayload;
function $22008b1674ec9c5b$var$createHandshakePayload(libp2pPublicKey, signedPayload, earlyData) {
    const payloadInit = $22008b1674ec9c5b$var$NoiseHandshakePayloadProto.create({
        identityKey: $l7tTk.Buffer.from(libp2pPublicKey),
        identitySig: signedPayload,
        data: earlyData !== null && earlyData !== void 0 ? earlyData : null
    });
    return $l7tTk.Buffer.from($22008b1674ec9c5b$var$NoiseHandshakePayloadProto.encode(payloadInit).finish());
}
module.exports.createHandshakePayload = $22008b1674ec9c5b$var$createHandshakePayload;
async function $22008b1674ec9c5b$var$signPayload(peerId, payload) {
    return $l7tTk.Buffer.from(await peerId.privKey.sign(payload));
}
module.exports.signPayload = $22008b1674ec9c5b$var$signPayload;
async function $22008b1674ec9c5b$var$getPeerIdFromPayload(payload) {
    return await $22008b1674ec9c5b$var$peer_id_1.default.createFromPubKey($l7tTk.Buffer.from(payload.identityKey));
}
module.exports.getPeerIdFromPayload = $22008b1674ec9c5b$var$getPeerIdFromPayload;
function $22008b1674ec9c5b$var$decodePayload(payload) {
    return $22008b1674ec9c5b$var$NoiseHandshakePayloadProto.toObject($22008b1674ec9c5b$var$NoiseHandshakePayloadProto.decode($l7tTk.Buffer.from(payload)));
}
module.exports.decodePayload = $22008b1674ec9c5b$var$decodePayload;
function $22008b1674ec9c5b$var$getHandshakePayload(publicKey) {
    return $l7tTk.Buffer.concat([
        $l7tTk.Buffer.from("noise-libp2p-static-key:"),
        publicKey
    ]);
}
module.exports.getHandshakePayload = $22008b1674ec9c5b$var$getHandshakePayload;
async function $22008b1674ec9c5b$var$isValidPeerId(peerId, publicKeyProtobuf) {
    const generatedPeerId = await $22008b1674ec9c5b$var$peer_id_1.default.createFromPubKey(publicKeyProtobuf);
    return $22008b1674ec9c5b$var$equals_1.default(generatedPeerId.id, peerId);
}
/**
 * Verifies signed payload, throws on any irregularities.
 *
 * @param {bytes} noiseStaticKey - owner's noise static key
 * @param {bytes} payload - decoded payload
 * @param {PeerId} remotePeer - owner's libp2p peer ID
 * @returns {Promise<PeerId>} - peer ID of payload owner
 */ async function $22008b1674ec9c5b$var$verifySignedPayload(noiseStaticKey, payload, remotePeer) {
    const identityKey = $l7tTk.Buffer.from(payload.identityKey);
    if (!await $22008b1674ec9c5b$var$isValidPeerId(remotePeer.id, identityKey)) throw new Error("Peer ID doesn't match libp2p public key.");
    const generatedPayload = $22008b1674ec9c5b$var$getHandshakePayload(noiseStaticKey);
    // Unmarshaling from PublicKey protobuf
    const publicKey = $hN6NI.keys.unmarshalPublicKey(identityKey);
    // TODO remove this after libp2p-crypto ships proper types
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    if (!payload.identitySig || !publicKey.verify(generatedPayload, $l7tTk.Buffer.from(payload.identitySig))) throw new Error("Static key doesn't match to peer that signed payload!");
    return await $22008b1674ec9c5b$var$peer_id_1.default.createFromPubKey(identityKey);
}
module.exports.verifySignedPayload = $22008b1674ec9c5b$var$verifySignedPayload;
function $22008b1674ec9c5b$var$getHkdf(ck, ikm) {
    const hkdf = new $fLRaB.HKDF($7NVV1.SHA256, ikm, ck);
    const okmU8Array = hkdf.expand(96);
    const okm = $l7tTk.Buffer.from(okmU8Array.buffer, okmU8Array.byteOffset, okmU8Array.length);
    const k1 = okm.slice(0, 32);
    const k2 = okm.slice(32, 64);
    const k3 = okm.slice(64, 96);
    return [
        k1,
        k2,
        k3
    ];
}
module.exports.getHkdf = $22008b1674ec9c5b$var$getHkdf;
function $22008b1674ec9c5b$var$isValidPublicKey(pk) {
    if (!$l7tTk.Buffer.isBuffer(pk)) return false;
    if (pk.length !== 32) return false;
    return true;
}
module.exports.isValidPublicKey = $22008b1674ec9c5b$var$isValidPublicKey;

});
parcelRequire.register("fLRaB", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9QDmk = parcelRequire("9QDmk");

var $eySe8 = parcelRequire("eySe8");
/**
 * HMAC-based Extract-and-Expand Key Derivation Function.
 *
 * Implements HKDF from RFC5869.
 *
 * Expands the given master key with salt and info into
 * a limited stream of key material.
 */ var $b7b47d4490eb7c1e$var$HKDF = /** @class */ function() {
    /**
     * Create a new HKDF instance for the given hash function
     * with the master key, optional salt, and info.
     *
     * - Master key is a high-entropy secret key (not a password).
     * - Salt is a non-secret random value.
     * - Info is application- and/or context-specific information.
     */ function HKDF(hash, key, salt, info) {
        if (salt === void 0) salt = new Uint8Array(0);
        this._counter = new Uint8Array(1); // starts with zero
        this._hash = hash;
        this._info = info;
        // HKDF-Extract uses salt as HMAC key, and key as data.
        var okm = $9QDmk.hmac(this._hash, salt, key);
        // Initialize HMAC for expanding with extracted key.
        this._hmac = new $9QDmk.HMAC(hash, okm);
        // Allocate buffer.
        this._buffer = new Uint8Array(this._hmac.digestLength);
        this._bufpos = this._buffer.length;
    }
    // Fill buffer with new block of HKDF-Extract output.
    HKDF.prototype._fillBuffer = function() {
        // Increment counter.
        this._counter[0]++;
        var ctr = this._counter[0];
        // Check if counter overflowed.
        if (ctr === 0) throw new Error("hkdf: cannot expand more");
        // Prepare HMAC instance for new data with old key.
        this._hmac.reset();
        // Hash in previous output if it was generated
        // (i.e. counter is greater than 1).
        if (ctr > 1) this._hmac.update(this._buffer);
        // Hash in info if it exists.
        if (this._info) this._hmac.update(this._info);
        // Hash in the counter.
        this._hmac.update(this._counter);
        // Output result to buffer and clean HMAC instance.
        this._hmac.finish(this._buffer);
        // Reset buffer position.
        this._bufpos = 0;
    };
    /**
     * Expand returns next key material of the given length.
     *
     * It throws if expansion limit is reached (which is
     * 254 digests of the underlying HMAC function).
     */ HKDF.prototype.expand = function(length) {
        var out = new Uint8Array(length);
        for(var i = 0; i < out.length; i++){
            if (this._bufpos === this._buffer.length) this._fillBuffer();
            out[i] = this._buffer[this._bufpos++];
        }
        return out;
    };
    HKDF.prototype.clean = function() {
        this._hmac.clean();
        $eySe8.wipe(this._buffer);
        $eySe8.wipe(this._counter);
        this._bufpos = 0;
    };
    return HKDF;
}();
module.exports.HKDF = $b7b47d4490eb7c1e$var$HKDF; // TODO(dchest): maybe implement deriveKey?

});
parcelRequire.register("9QDmk", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j1ZfB = parcelRequire("j1ZfB");

var $kus2Y = parcelRequire("kus2Y");

var $eySe8 = parcelRequire("eySe8");
/**
 *  HMAC implements hash-based message authentication algorithm.
 */ var $72b78044d7fc47b1$var$HMAC = /** @class */ function() {
    /**
     * Constructs a new HMAC with the given Hash and secret key.
     */ function HMAC(hash, key) {
        this._finished = false; // true if HMAC was finalized
        // Initialize inner and outer hashes.
        this._inner = new hash();
        this._outer = new hash();
        // Set block and digest sizes for this HMAC
        // instance to values from the hash.
        this.blockSize = this._outer.blockSize;
        this.digestLength = this._outer.digestLength;
        // Pad temporary stores a key (or its hash) padded with zeroes.
        var pad = new Uint8Array(this.blockSize);
        if (key.length > this.blockSize) // If key is bigger than hash block size, it must be
        // hashed and this hash is used as a key instead.
        this._inner.update(key).finish(pad).clean();
        else // Otherwise, copy the key into pad.
        pad.set(key);
        // Now two different keys are derived from padded key
        // by xoring a different byte value to each.
        // To make inner hash key, xor byte 0x36 into pad.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        // Update inner hash with the result.
        this._inner.update(pad);
        // To make outer hash key, xor byte 0x5c into pad.
        // But since we already xored 0x36 there, we must
        // first undo this by xoring it again.
        for(var i = 0; i < pad.length; i++)pad[i] ^= 106;
        // Update outer hash with the result.
        this._outer.update(pad);
        // Save states of both hashes, so that we can quickly restore
        // them later in reset() without the need to remember the actual
        // key and perform this initialization again.
        if ($j1ZfB.isSerializableHash(this._inner) && $j1ZfB.isSerializableHash(this._outer)) {
            this._innerKeyedState = this._inner.saveState();
            this._outerKeyedState = this._outer.saveState();
        }
        // Clean pad.
        $eySe8.wipe(pad);
    }
    /**
     * Returns HMAC state to the state initialized with key
     * to make it possible to run HMAC over the other data with the same
     * key without creating a new instance.
     */ HMAC.prototype.reset = function() {
        if (!$j1ZfB.isSerializableHash(this._inner) || !$j1ZfB.isSerializableHash(this._outer)) throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
        // Restore keyed states of inner and outer hashes.
        this._inner.restoreState(this._innerKeyedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    /**
     * Cleans HMAC state.
     */ HMAC.prototype.clean = function() {
        if ($j1ZfB.isSerializableHash(this._inner)) this._inner.cleanSavedState(this._innerKeyedState);
        if ($j1ZfB.isSerializableHash(this._outer)) this._outer.cleanSavedState(this._outerKeyedState);
        this._inner.clean();
        this._outer.clean();
    };
    /**
     * Updates state with provided data.
     */ HMAC.prototype.update = function(data) {
        this._inner.update(data);
        return this;
    };
    /**
     * Finalizes HMAC and puts the result in out.
     */ HMAC.prototype.finish = function(out) {
        if (this._finished) {
            // If HMAC was finalized, outer hash is also finalized,
            // so it produces the same digest it produced when it
            // was finalized.
            this._outer.finish(out);
            return this;
        }
        // Finalize inner hash and store the result temporarily.
        this._inner.finish(out);
        // Update outer hash with digest of inner hash and and finalize it.
        this._outer.update(out.subarray(0, this.digestLength)).finish(out);
        this._finished = true;
        return this;
    };
    /**
     * Returns the computed message authentication code.
     */ HMAC.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Saves HMAC state.
     * This function is needed for PBKDF2 optimization.
     */ HMAC.prototype.saveState = function() {
        if (!$j1ZfB.isSerializableHash(this._inner)) throw new Error("hmac: can't saveState() because hash doesn't implement it");
        return this._inner.saveState();
    };
    HMAC.prototype.restoreState = function(savedState) {
        if (!$j1ZfB.isSerializableHash(this._inner) || !$j1ZfB.isSerializableHash(this._outer)) throw new Error("hmac: can't restoreState() because hash doesn't implement it");
        this._inner.restoreState(savedState);
        this._outer.restoreState(this._outerKeyedState);
        this._finished = false;
        return this;
    };
    HMAC.prototype.cleanSavedState = function(savedState) {
        if (!$j1ZfB.isSerializableHash(this._inner)) throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
        this._inner.cleanSavedState(savedState);
    };
    return HMAC;
}();
module.exports.HMAC = $72b78044d7fc47b1$var$HMAC;
/**
 * Returns HMAC using the given hash constructor for the key over data.
 */ function $72b78044d7fc47b1$var$hmac(hash, key, data) {
    var h = new $72b78044d7fc47b1$var$HMAC(hash, key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.hmac = $72b78044d7fc47b1$var$hmac;
/**
 * Returns true if two HMAC digests are equal.
 * Uses constant-time comparison to avoid leaking timing information.
 *
 * Example:
 *
 *    const receivedDigest = ...
 *    const realDigest = hmac(SHA256, key, data);
 *    if (!equal(receivedDigest, realDigest)) {
 *        throw new Error("Authentication error");
 *    }
 */ module.exports.equal = $kus2Y.equal;

});
parcelRequire.register("j1ZfB", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $ddad9f697fa4ff68$var$isSerializableHash(h) {
    return typeof h.saveState !== "undefined" && typeof h.restoreState !== "undefined" && typeof h.cleanSavedState !== "undefined";
}
module.exports.isSerializableHash = $ddad9f697fa4ff68$var$isSerializableHash; // TODO(dchest): figure out the standardized interface for XOF such as
 // SHAKE and BLAKE2X.

});

parcelRequire.register("kus2Y", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Package constant-time provides functions for performing algorithmically constant-time operations.
 */ /**
 * NOTE! Due to the inability to guarantee real constant time evaluation of
 * anything in JavaScript VM, this is module is the best effort.
 */ /**
 * Returns resultIfOne if subject is 1, or resultIfZero if subject is 0.
 *
 * Supports only 32-bit integers, so resultIfOne or resultIfZero are not
 * integers, they'll be converted to them with bitwise operations.
 */ function $eeac5d8323330b91$var$select(subject, resultIfOne, resultIfZero) {
    return ~(subject - 1) & resultIfOne | subject - 1 & resultIfZero;
}
module.exports.select = $eeac5d8323330b91$var$select;
/**
 * Returns 1 if a <= b, or 0 if not.
 * Arguments must be positive 32-bit integers less than or equal to 2^31 - 1.
 */ function $eeac5d8323330b91$var$lessOrEqual(a, b) {
    return (a | 0) - (b | 0) - 1 >>> 31 & 1;
}
module.exports.lessOrEqual = $eeac5d8323330b91$var$lessOrEqual;
/**
 * Returns 1 if a and b are of equal length and their contents
 * are equal, or 0 otherwise.
 *
 * Note that unlike in equal(), zero-length inputs are considered
 * the same, so this function will return 1.
 */ function $eeac5d8323330b91$var$compare(a, b) {
    if (a.length !== b.length) return 0;
    var result = 0;
    for(var i = 0; i < a.length; i++)result |= a[i] ^ b[i];
    return 1 & result - 1 >>> 8;
}
module.exports.compare = $eeac5d8323330b91$var$compare;
/**
 * Returns true if a and b are of equal non-zero length,
 * and their contents are equal, or false otherwise.
 *
 * Note that unlike in compare() zero-length inputs are considered
 * _not_ equal, so this function will return false.
 */ function $eeac5d8323330b91$var$equal(a, b) {
    if (a.length === 0 || b.length === 0) return false;
    return $eeac5d8323330b91$var$compare(a, b) !== 0;
}
module.exports.equal = $eeac5d8323330b91$var$equal;

});



parcelRequire.register("7NVV1", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gE4xe = parcelRequire("gE4xe");

var $eySe8 = parcelRequire("eySe8");
module.exports.DIGEST_LENGTH = 32;
module.exports.BLOCK_SIZE = 64;
/**
 * SHA2-256 cryptographic hash algorithm.
 */ var $5aea09764cdbc6f6$var$SHA256 = /** @class */ function() {
    function SHA256() {
        /** Length of hash output */ this.digestLength = module.exports.DIGEST_LENGTH;
        /** Block size */ this.blockSize = module.exports.BLOCK_SIZE;
        // Note: Int32Array is used instead of Uint32Array for performance reasons.
        this._state = new Int32Array(8); // hash state
        this._temp = new Int32Array(64); // temporary state
        this._buffer = new Uint8Array(128); // buffer for data to hash
        this._bufferLength = 0; // number of bytes in buffer
        this._bytesHashed = 0; // number of total bytes hashed
        this._finished = false; // indicates whether the hash was finalized
        this.reset();
    }
    SHA256.prototype._initState = function() {
        this._state[0] = 0x6a09e667;
        this._state[1] = 0xbb67ae85;
        this._state[2] = 0x3c6ef372;
        this._state[3] = 0xa54ff53a;
        this._state[4] = 0x510e527f;
        this._state[5] = 0x9b05688c;
        this._state[6] = 0x1f83d9ab;
        this._state[7] = 0x5be0cd19;
    };
    /**
     * Resets hash state making it possible
     * to re-use this instance to hash other data.
     */ SHA256.prototype.reset = function() {
        this._initState();
        this._bufferLength = 0;
        this._bytesHashed = 0;
        this._finished = false;
        return this;
    };
    /**
     * Cleans internal buffers and resets hash state.
     */ SHA256.prototype.clean = function() {
        $eySe8.wipe(this._buffer);
        $eySe8.wipe(this._temp);
        this.reset();
    };
    /**
     * Updates hash state with the given data.
     *
     * Throws error when trying to update already finalized hash:
     * instance must be reset to update it again.
     */ SHA256.prototype.update = function(data, dataLength) {
        if (dataLength === void 0) dataLength = data.length;
        if (this._finished) throw new Error("SHA256: can't update because hash was finished.");
        var dataPos = 0;
        this._bytesHashed += dataLength;
        if (this._bufferLength > 0) {
            while(this._bufferLength < this.blockSize && dataLength > 0){
                this._buffer[this._bufferLength++] = data[dataPos++];
                dataLength--;
            }
            if (this._bufferLength === this.blockSize) {
                $5aea09764cdbc6f6$var$hashBlocks(this._temp, this._state, this._buffer, 0, this.blockSize);
                this._bufferLength = 0;
            }
        }
        if (dataLength >= this.blockSize) {
            dataPos = $5aea09764cdbc6f6$var$hashBlocks(this._temp, this._state, data, dataPos, dataLength);
            dataLength %= this.blockSize;
        }
        while(dataLength > 0){
            this._buffer[this._bufferLength++] = data[dataPos++];
            dataLength--;
        }
        return this;
    };
    /**
     * Finalizes hash state and puts hash into out.
     * If hash was already finalized, puts the same value.
     */ SHA256.prototype.finish = function(out) {
        if (!this._finished) {
            var bytesHashed = this._bytesHashed;
            var left = this._bufferLength;
            var bitLenHi = bytesHashed / 0x20000000 | 0;
            var bitLenLo = bytesHashed << 3;
            var padLength = bytesHashed % 64 < 56 ? 64 : 128;
            this._buffer[left] = 0x80;
            for(var i = left + 1; i < padLength - 8; i++)this._buffer[i] = 0;
            $gE4xe.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
            $gE4xe.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
            $5aea09764cdbc6f6$var$hashBlocks(this._temp, this._state, this._buffer, 0, padLength);
            this._finished = true;
        }
        for(var i = 0; i < this.digestLength / 4; i++)$gE4xe.writeUint32BE(this._state[i], out, i * 4);
        return this;
    };
    /**
     * Returns the final hash digest.
     */ SHA256.prototype.digest = function() {
        var out = new Uint8Array(this.digestLength);
        this.finish(out);
        return out;
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Returns hash state to be used with restoreState().
     * Only chain value is saved, not buffers or other
     * state variables.
     */ SHA256.prototype.saveState = function() {
        if (this._finished) throw new Error("SHA256: cannot save finished state");
        return {
            state: new Int32Array(this._state),
            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
            bufferLength: this._bufferLength,
            bytesHashed: this._bytesHashed
        };
    };
    /**
     * Function useful for HMAC/PBKDF2 optimization.
     * Restores state saved by saveState() and sets bytesHashed
     * to the given value.
     */ SHA256.prototype.restoreState = function(savedState) {
        this._state.set(savedState.state);
        this._bufferLength = savedState.bufferLength;
        if (savedState.buffer) this._buffer.set(savedState.buffer);
        this._bytesHashed = savedState.bytesHashed;
        this._finished = false;
        return this;
    };
    /**
     * Cleans state returned by saveState().
     */ SHA256.prototype.cleanSavedState = function(savedState) {
        $eySe8.wipe(savedState.state);
        if (savedState.buffer) $eySe8.wipe(savedState.buffer);
        savedState.bufferLength = 0;
        savedState.bytesHashed = 0;
    };
    return SHA256;
}();
module.exports.SHA256 = $5aea09764cdbc6f6$var$SHA256;
// Constants
var $5aea09764cdbc6f6$var$K = new Int32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
function $5aea09764cdbc6f6$var$hashBlocks(w, v, p, pos, len) {
    while(len >= 64){
        var a = v[0];
        var b = v[1];
        var c = v[2];
        var d = v[3];
        var e = v[4];
        var f = v[5];
        var g = v[6];
        var h = v[7];
        for(var i = 0; i < 16; i++){
            var j = pos + i * 4;
            w[i] = $gE4xe.readUint32BE(p, j);
        }
        for(var i = 16; i < 64; i++){
            var u = w[i - 2];
            var t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
            u = w[i - 15];
            var t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
            w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
        }
        for(var i = 0; i < 64; i++){
            var t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + ($5aea09764cdbc6f6$var$K[i] + w[i] | 0) | 0) | 0;
            var t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
        }
        v[0] += a;
        v[1] += b;
        v[2] += c;
        v[3] += d;
        v[4] += e;
        v[5] += f;
        v[6] += g;
        v[7] += h;
        pos += 64;
        len -= 64;
    }
    return pos;
}
function $5aea09764cdbc6f6$var$hash(data) {
    var h = new $5aea09764cdbc6f6$var$SHA256();
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.hash = $5aea09764cdbc6f6$var$hash;

});

parcelRequire.register("9ewRV", function(module, exports) {
/*
 * Id is an object representation of a peer Id. a peer Id is a multihash
 */ "use strict";

var $1uqWk = parcelRequire("1uqWk");
var $6b8eeae72ed67d43$require$CID = $1uqWk.CID;

var $5LC6A = parcelRequire("5LC6A");

var $cx6XH = parcelRequire("cx6XH");

var $fVtlC = parcelRequire("fVtlC");

var $eXQx4 = parcelRequire("eXQx4");

var $fVtlC = parcelRequire("fVtlC");
var $6b8eeae72ed67d43$require$base58btc = $fVtlC.base58btc;

var $5LC6A = parcelRequire("5LC6A");
var $6b8eeae72ed67d43$require$base32 = $5LC6A.base32;

var $12xKA = parcelRequire("12xKA");
var $6b8eeae72ed67d43$require$base16 = $12xKA.base16;

var $3gYLQ = parcelRequire("3gYLQ");

var $avA5E = parcelRequire("avA5E");

var $jhePu = parcelRequire("jhePu");

var $dJXSQ = parcelRequire("dJXSQ");
var $6b8eeae72ed67d43$require$PeerIdProto = $dJXSQ.PeerIdProto;

var $ijWXY = parcelRequire("ijWXY");
var $6b8eeae72ed67d43$require$uint8ArrayEquals = $ijWXY.equals;

var $8cWjP = parcelRequire("8cWjP");
var $6b8eeae72ed67d43$require$uint8ArrayFromString = $8cWjP.fromString;

var $6rBCs = parcelRequire("6rBCs");
var $6b8eeae72ed67d43$require$uint8ArrayToString = $6rBCs.toString;

var $klyrn = parcelRequire("klyrn");
var $6b8eeae72ed67d43$require$identity = $klyrn.identity;
const bases = {
    ...$5LC6A,
    ...$cx6XH,
    ...$fVtlC,
    ...$eXQx4
};
const baseDecoder = Object.keys(bases).reduce((acc, curr)=>acc.or(bases[curr]), $6b8eeae72ed67d43$require$base32.decoder);
// these values are from https://github.com/multiformats/multicodec/blob/master/table.csv
const DAG_PB_CODE = 0x70;
const LIBP2P_KEY_CODE = 0x72;
class PeerId {
    constructor(id, privKey, pubKey){
        if (!(id instanceof Uint8Array)) throw new Error("invalid id provided");
        if (privKey && pubKey && !$6b8eeae72ed67d43$require$uint8ArrayEquals(privKey.public.bytes, pubKey.bytes)) throw new Error("inconsistent arguments");
        this._id = id;
        this._idB58String = $6b8eeae72ed67d43$require$base58btc.encode(this.id).substring(1);
        this._privKey = privKey;
        this._pubKey = pubKey;
    }
    get id() {
        return this._id;
    }
    set id(val) {
        throw new Error("Id is immutable");
    }
    get privKey() {
        return this._privKey;
    }
    set privKey(privKey) {
        this._privKey = privKey;
    }
    get pubKey() {
        if (this._pubKey) return this._pubKey;
        if (this._privKey) return this._privKey.public;
        try {
            const decoded = $3gYLQ.decode(this.id);
            if (decoded.code === $6b8eeae72ed67d43$require$identity.code) this._pubKey = $avA5E.unmarshalPublicKey(decoded.digest);
        } catch (_) {
        // Ignore, there is no valid public key
        }
        return this._pubKey;
    }
    set pubKey(pubKey) {
        this._pubKey = pubKey;
    }
    // Return the protobuf version of the public key, matching go ipfs formatting
    marshalPubKey() {
        if (this.pubKey) return $avA5E.marshalPublicKey(this.pubKey);
    }
    // Return the protobuf version of the private key, matching go ipfs formatting
    marshalPrivKey() {
        if (this.privKey) return $avA5E.marshalPrivateKey(this.privKey);
    }
    // Return the protobuf version of the peer-id
    marshal(excludePriv) {
        return $6b8eeae72ed67d43$require$PeerIdProto.encode({
            id: this.toBytes(),
            pubKey: this.marshalPubKey(),
            privKey: excludePriv ? null : this.marshalPrivKey()
        }).finish();
    }
    toPrint() {
        let pid = this.toB58String();
        // All sha256 nodes start with Qm
        // We can skip the Qm to make the peer.ID more useful
        if (pid.startsWith("Qm")) pid = pid.slice(2);
        let maxRunes = 6;
        if (pid.length < maxRunes) maxRunes = pid.length;
        return "<peer.ID " + pid.substr(0, maxRunes) + ">";
    }
    // return the jsonified version of the key, matching the formatting
    // of go-ipfs for its config file
    toJSON() {
        return {
            id: this.toB58String(),
            privKey: toB64Opt(this.marshalPrivKey()),
            pubKey: toB64Opt(this.marshalPubKey())
        };
    }
    // encode/decode functions
    toHexString() {
        return $6b8eeae72ed67d43$require$base16.encode(this.id).substring(1);
    }
    toBytes() {
        return this.id;
    }
    toB58String() {
        return this._idB58String;
    }
    // return self-describing String representation
    // in default format from RFC 0001: https://github.com/libp2p/specs/pull/209
    toString() {
        if (!this._idCIDString) {
            const cid = $6b8eeae72ed67d43$require$CID.createV1(LIBP2P_KEY_CODE, $3gYLQ.decode(this.id));
            Object.defineProperty(this, "_idCIDString", {
                value: cid.toString(),
                enumerable: false
            });
        }
        return this._idCIDString;
    }
    /**
   * Checks the equality of `this` peer against a given PeerId.
   *
   * @param {Uint8Array|PeerId} id
   * @returns {boolean}
   */ equals(id) {
        if (id instanceof Uint8Array) return $6b8eeae72ed67d43$require$uint8ArrayEquals(this.id, id);
        else if (id.id) return $6b8eeae72ed67d43$require$uint8ArrayEquals(this.id, id.id);
        else throw new Error("not valid Id");
    }
    /**
   * Checks the equality of `this` peer against a given PeerId.
   *
   * @deprecated Use `.equals`
   * @param {Uint8Array|PeerId} id
   * @returns {boolean}
   */ isEqual(id) {
        return this.equals(id);
    }
    /*
   * Check if this PeerId instance is valid (privKey -> pubKey -> Id)
   */ isValid() {
        // TODO: needs better checking
        return Boolean(this.privKey && this.privKey.public && this.privKey.public.bytes && this.pubKey.bytes instanceof Uint8Array && $6b8eeae72ed67d43$require$uint8ArrayEquals(this.privKey.public.bytes, this.pubKey.bytes));
    }
    /**
   * Check if the PeerId has an inline public key.
   *
   * @returns {boolean}
   */ hasInlinePublicKey() {
        try {
            const decoded = $3gYLQ.decode(this.id);
            if (decoded.code === $6b8eeae72ed67d43$require$identity.code) return true;
        } catch (_) {
        // Ignore, there is no valid public key
        }
        return false;
    }
}
const PeerIdWithIs = $jhePu(PeerId, {
    className: "PeerId",
    symbolName: "@libp2p/js-peer-id/PeerId"
});
exports = module.exports = PeerIdWithIs;
const computeDigest = (pubKey)=>{
    if (pubKey.bytes.length <= 42) return $3gYLQ.create($6b8eeae72ed67d43$require$identity.code, pubKey.bytes).bytes;
    else return pubKey.hash();
};
const computePeerId = async (privKey, pubKey)=>{
    const digest = await computeDigest(pubKey);
    return new PeerIdWithIs(digest, privKey, pubKey);
};
// generation
exports.create = async (opts)=>{
    opts = opts || {};
    opts.bits = opts.bits || 2048;
    opts.keyType = opts.keyType || "RSA";
    const key = await $avA5E.generateKeyPair(opts.keyType, opts.bits);
    return computePeerId(key, key.public);
};
exports.createFromHexString = (str)=>{
    return new PeerIdWithIs($6b8eeae72ed67d43$require$base16.decode("f" + str));
};
exports.createFromBytes = (buf)=>{
    try {
        const cid = $6b8eeae72ed67d43$require$CID.decode(buf);
        if (!validMulticodec(cid)) throw new Error("Supplied PeerID CID is invalid");
        return exports.createFromCID(cid);
    } catch  {
        const digest = $3gYLQ.decode(buf);
        if (digest.code !== $6b8eeae72ed67d43$require$identity.code) throw new Error("Supplied PeerID CID is invalid");
        return new PeerIdWithIs(buf);
    }
};
exports.createFromB58String = (str)=>{
    return exports.createFromBytes($6b8eeae72ed67d43$require$base58btc.decode("z" + str));
};
const validMulticodec = (cid)=>{
    // supported: 'libp2p-key' (CIDv1) and 'dag-pb' (CIDv0 converted to CIDv1)
    return cid.code === LIBP2P_KEY_CODE || cid.code === DAG_PB_CODE;
};
exports.createFromCID = (cid)=>{
    cid = $6b8eeae72ed67d43$require$CID.asCID(cid);
    if (!cid || !validMulticodec(cid)) throw new Error("Supplied PeerID CID is invalid");
    return new PeerIdWithIs(cid.multihash.bytes);
};
// Public Key input will be a Uint8Array
exports.createFromPubKey = async (key)=>{
    let buf = key;
    if (typeof buf === "string") buf = $6b8eeae72ed67d43$require$uint8ArrayFromString(key, "base64pad");
    if (!(buf instanceof Uint8Array)) throw new Error("Supplied key is neither a base64 string nor a Uint8Array");
    const pubKey = await $avA5E.unmarshalPublicKey(buf);
    return computePeerId(undefined, pubKey);
};
// Private key input will be a string
exports.createFromPrivKey = async (key)=>{
    if (typeof key === "string") key = $6b8eeae72ed67d43$require$uint8ArrayFromString(key, "base64pad");
    if (!(key instanceof Uint8Array)) throw new Error("Supplied key is neither a base64 string nor a Uint8Array");
    const privKey = await $avA5E.unmarshalPrivateKey(key);
    return computePeerId(privKey, privKey.public);
};
exports.createFromJSON = async (obj)=>{
    const id = $6b8eeae72ed67d43$require$base58btc.decode("z" + obj.id);
    const rawPrivKey = obj.privKey && $6b8eeae72ed67d43$require$uint8ArrayFromString(obj.privKey, "base64pad");
    const rawPubKey = obj.pubKey && $6b8eeae72ed67d43$require$uint8ArrayFromString(obj.pubKey, "base64pad");
    const pub = rawPubKey && await $avA5E.unmarshalPublicKey(rawPubKey);
    if (!rawPrivKey) return new PeerIdWithIs(id, undefined, pub);
    const privKey = await $avA5E.unmarshalPrivateKey(rawPrivKey);
    const privDigest = await computeDigest(privKey.public);
    let pubDigest;
    if (pub) pubDigest = await computeDigest(pub);
    if (pub && !$6b8eeae72ed67d43$require$uint8ArrayEquals(privDigest, pubDigest)) throw new Error("Public and private key do not match");
    if (id && !$6b8eeae72ed67d43$require$uint8ArrayEquals(privDigest, id)) throw new Error("Id and private key do not match");
    return new PeerIdWithIs(id, privKey, pub);
};
exports.createFromProtobuf = async (buf)=>{
    if (typeof buf === "string") buf = $6b8eeae72ed67d43$require$uint8ArrayFromString(buf, "base16");
    let { id, privKey, pubKey } = $6b8eeae72ed67d43$require$PeerIdProto.decode(buf);
    privKey = privKey ? await $avA5E.unmarshalPrivateKey(privKey) : false;
    pubKey = pubKey ? await $avA5E.unmarshalPublicKey(pubKey) : false;
    let pubDigest;
    let privDigest;
    if (privKey) privDigest = await computeDigest(privKey.public);
    if (pubKey) pubDigest = await computeDigest(pubKey);
    if (privKey) {
        if (pubKey) {
            if (!$6b8eeae72ed67d43$require$uint8ArrayEquals(privDigest, pubDigest)) throw new Error("Public and private key do not match");
        }
        return new PeerIdWithIs(privDigest, privKey, privKey.public);
    }
    // TODO: val id and pubDigest
    if (pubKey) return new PeerIdWithIs(pubDigest, undefined, pubKey);
    if (id) return new PeerIdWithIs(id);
    throw new Error("Protobuf did not contain any usable key material");
};
exports.parse = (str)=>{
    if (str.charAt(0) === "1" || str.charAt(0) === "Q") // identity hash ed25519 key or sha2-256 hash of rsa public key
    // base58btc encoded either way
    str = `z${str}`;
    return exports.createFromBytes(baseDecoder.decode(str));
};
exports.isPeerId = (peerId)=>{
    return Boolean(typeof peerId === "object" && peerId._id && peerId._idB58String);
};
function toB64Opt(val) {
    if (val) return $6b8eeae72ed67d43$require$uint8ArrayToString(val, "base64pad");
}

});
parcelRequire.register("avA5E", function(module, exports) {
"use strict";

var $kKjWz = parcelRequire("kKjWz");
parcelRequire("l46Tq");
parcelRequire("8EmV9");

var $2xc86 = parcelRequire("2xc86");

var $20Lm5 = parcelRequire("20Lm5");

var $8cWjP = parcelRequire("8cWjP");
var $7a68cb5d4b3a3ce5$require$uint8ArrayFromString = $8cWjP.fromString;

var $cxRIG = parcelRequire("cxRIG");




const $7a68cb5d4b3a3ce5$var$supportedKeys = {
    rsa: (parcelRequire("7YQRT")),
    ed25519: (parcelRequire("buPLK")),
    secp256k1: (parcelRequire("cVkJN"))($kKjWz, (parcelRequire("kPiMl")))
};
const $7a68cb5d4b3a3ce5$var$ErrMissingSecp256K1 = {
    message: "secp256k1 support requires libp2p-crypto-secp256k1 package",
    code: "ERR_MISSING_PACKAGE"
};
function $7a68cb5d4b3a3ce5$var$typeToKey(type) {
    const key = $7a68cb5d4b3a3ce5$var$supportedKeys[type.toLowerCase()];
    if (!key) {
        const supported = Object.keys($7a68cb5d4b3a3ce5$var$supportedKeys).join(" / ");
        throw $20Lm5(new Error(`invalid or unsupported key type ${type}. Must be ${supported}`), "ERR_UNSUPPORTED_KEY_TYPE");
    }
    return key;
}
// Generates a keypair of the given type and bitsize
const $7a68cb5d4b3a3ce5$var$generateKeyPair = async (type, bits)=>{
    return $7a68cb5d4b3a3ce5$var$typeToKey(type).generateKeyPair(bits);
};
// Generates a keypair of the given type and bitsize
// seed is a 32 byte uint8array
const $7a68cb5d4b3a3ce5$var$generateKeyPairFromSeed = async (type, seed, bits)=>{
    const key = $7a68cb5d4b3a3ce5$var$typeToKey(type);
    if (type.toLowerCase() !== "ed25519") throw $20Lm5(new Error("Seed key derivation is unimplemented for RSA or secp256k1"), "ERR_UNSUPPORTED_KEY_DERIVATION_TYPE");
    return key.generateKeyPairFromSeed(seed, bits);
};
// Converts a protobuf serialized public key into its
// representative object
const $7a68cb5d4b3a3ce5$var$unmarshalPublicKey = (buf)=>{
    const decoded = $kKjWz.PublicKey.decode(buf);
    const data = decoded.Data;
    switch(decoded.Type){
        case $kKjWz.KeyType.RSA:
            return $7a68cb5d4b3a3ce5$var$supportedKeys.rsa.unmarshalRsaPublicKey(data);
        case $kKjWz.KeyType.Ed25519:
            return $7a68cb5d4b3a3ce5$var$supportedKeys.ed25519.unmarshalEd25519PublicKey(data);
        case $kKjWz.KeyType.Secp256k1:
            if ($7a68cb5d4b3a3ce5$var$supportedKeys.secp256k1) return $7a68cb5d4b3a3ce5$var$supportedKeys.secp256k1.unmarshalSecp256k1PublicKey(data);
            else throw $20Lm5(new Error($7a68cb5d4b3a3ce5$var$ErrMissingSecp256K1.message), $7a68cb5d4b3a3ce5$var$ErrMissingSecp256K1.code);
        default:
            $7a68cb5d4b3a3ce5$var$typeToKey(decoded.Type) // throws because type is not supported
            ;
    }
};
// Converts a public key object into a protobuf serialized public key
const $7a68cb5d4b3a3ce5$var$marshalPublicKey = (key, type)=>{
    type = (type || "rsa").toLowerCase();
    $7a68cb5d4b3a3ce5$var$typeToKey(type) // check type
    ;
    return key.bytes;
};
// Converts a protobuf serialized private key into its
// representative object
const $7a68cb5d4b3a3ce5$var$unmarshalPrivateKey = async (buf)=>{
    const decoded = $kKjWz.PrivateKey.decode(buf);
    const data = decoded.Data;
    switch(decoded.Type){
        case $kKjWz.KeyType.RSA:
            return $7a68cb5d4b3a3ce5$var$supportedKeys.rsa.unmarshalRsaPrivateKey(data);
        case $kKjWz.KeyType.Ed25519:
            return $7a68cb5d4b3a3ce5$var$supportedKeys.ed25519.unmarshalEd25519PrivateKey(data);
        case $kKjWz.KeyType.Secp256k1:
            if ($7a68cb5d4b3a3ce5$var$supportedKeys.secp256k1) return $7a68cb5d4b3a3ce5$var$supportedKeys.secp256k1.unmarshalSecp256k1PrivateKey(data);
            else throw $20Lm5(new Error($7a68cb5d4b3a3ce5$var$ErrMissingSecp256K1.message), $7a68cb5d4b3a3ce5$var$ErrMissingSecp256K1.code);
        default:
            $7a68cb5d4b3a3ce5$var$typeToKey(decoded.Type) // throws because type is not supported
            ;
    }
};
// Converts a private key object into a protobuf serialized private key
const $7a68cb5d4b3a3ce5$var$marshalPrivateKey = (key, type)=>{
    type = (type || "rsa").toLowerCase();
    $7a68cb5d4b3a3ce5$var$typeToKey(type) // check type
    ;
    return key.bytes;
};
/**
 *
 * @param {string} encryptedKey
 * @param {string} password
 */ const $7a68cb5d4b3a3ce5$var$importKey = async (encryptedKey, password)=>{
    try {
        const key = await $cxRIG.import(encryptedKey, password);
        return $7a68cb5d4b3a3ce5$var$unmarshalPrivateKey(key);
    } catch (_) {
    // Ignore and try the old pem decrypt
    }
    // Only rsa supports pem right now
    const key = $2xc86.pki.decryptRsaPrivateKey(encryptedKey, password);
    if (key === null) throw $20Lm5(new Error("Cannot read the key, most likely the password is wrong or not a RSA key"), "ERR_CANNOT_DECRYPT_PEM");
    let der = $2xc86.asn1.toDer($2xc86.pki.privateKeyToAsn1(key));
    der = $7a68cb5d4b3a3ce5$require$uint8ArrayFromString(der.getBytes(), "ascii");
    return $7a68cb5d4b3a3ce5$var$supportedKeys.rsa.unmarshalRsaPrivateKey(der);
};


module.exports = {
    supportedKeys: $7a68cb5d4b3a3ce5$var$supportedKeys,
    keysPBM: $kKjWz,
    keyStretcher: (parcelRequire("aqUBP")),
    generateEphemeralKeyPair: (parcelRequire("lCVsW")),
    generateKeyPair: $7a68cb5d4b3a3ce5$var$generateKeyPair,
    generateKeyPairFromSeed: $7a68cb5d4b3a3ce5$var$generateKeyPairFromSeed,
    unmarshalPublicKey: $7a68cb5d4b3a3ce5$var$unmarshalPublicKey,
    marshalPublicKey: $7a68cb5d4b3a3ce5$var$marshalPublicKey,
    unmarshalPrivateKey: $7a68cb5d4b3a3ce5$var$unmarshalPrivateKey,
    marshalPrivateKey: $7a68cb5d4b3a3ce5$var$marshalPrivateKey,
    import: $7a68cb5d4b3a3ce5$var$importKey
};

});
parcelRequire.register("kKjWz", function(module, exports) {
/*eslint-disable*/ "use strict";

var $liRmU = parcelRequire("liRmU");
// Common aliases
var $f1a792ebf0e77b82$var$$Reader = $liRmU.Reader, $f1a792ebf0e77b82$var$$Writer = $liRmU.Writer, $f1a792ebf0e77b82$var$$util = $liRmU.util;
// Exported root namespace
var $f1a792ebf0e77b82$var$$root = $liRmU.roots["libp2p-crypto-keys"] || ($liRmU.roots["libp2p-crypto-keys"] = {});
/**
 * KeyType enum.
 * @exports KeyType
 * @enum {number}
 * @property {number} RSA=0 RSA value
 * @property {number} Ed25519=1 Ed25519 value
 * @property {number} Secp256k1=2 Secp256k1 value
 */ $f1a792ebf0e77b82$var$$root.KeyType = function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "RSA"] = 0;
    values[valuesById[1] = "Ed25519"] = 1;
    values[valuesById[2] = "Secp256k1"] = 2;
    return values;
}();
$f1a792ebf0e77b82$var$$root.PublicKey = function() {
    /**
     * Properties of a PublicKey.
     * @exports IPublicKey
     * @interface IPublicKey
     * @property {KeyType} Type PublicKey Type
     * @property {Uint8Array} Data PublicKey Data
     */ /**
     * Constructs a new PublicKey.
     * @exports PublicKey
     * @classdesc Represents a PublicKey.
     * @implements IPublicKey
     * @constructor
     * @param {IPublicKey=} [p] Properties to set
     */ function PublicKey(p) {
        if (p) {
            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }
    }
    /**
     * PublicKey Type.
     * @member {KeyType} Type
     * @memberof PublicKey
     * @instance
     */ PublicKey.prototype.Type = 0;
    /**
     * PublicKey Data.
     * @member {Uint8Array} Data
     * @memberof PublicKey
     * @instance
     */ PublicKey.prototype.Data = $f1a792ebf0e77b82$var$$util.newBuffer([]);
    /**
     * Encodes the specified PublicKey message. Does not implicitly {@link PublicKey.verify|verify} messages.
     * @function encode
     * @memberof PublicKey
     * @static
     * @param {IPublicKey} m PublicKey message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ PublicKey.encode = function encode(m, w) {
        if (!w) w = $f1a792ebf0e77b82$var$$Writer.create();
        w.uint32(8).int32(m.Type);
        w.uint32(18).bytes(m.Data);
        return w;
    };
    /**
     * Decodes a PublicKey message from the specified reader or buffer.
     * @function decode
     * @memberof PublicKey
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {PublicKey} PublicKey
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ PublicKey.decode = function decode(r, l) {
        if (!(r instanceof $f1a792ebf0e77b82$var$$Reader)) r = $f1a792ebf0e77b82$var$$Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l, m = new $f1a792ebf0e77b82$var$$root.PublicKey();
        while(r.pos < c){
            var t = r.uint32();
            switch(t >>> 3){
                case 1:
                    m.Type = r.int32();
                    break;
                case 2:
                    m.Data = r.bytes();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
            }
        }
        if (!m.hasOwnProperty("Type")) throw $f1a792ebf0e77b82$var$$util.ProtocolError("missing required 'Type'", {
            instance: m
        });
        if (!m.hasOwnProperty("Data")) throw $f1a792ebf0e77b82$var$$util.ProtocolError("missing required 'Data'", {
            instance: m
        });
        return m;
    };
    /**
     * Creates a PublicKey message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicKey
     * @static
     * @param {Object.<string,*>} d Plain object
     * @returns {PublicKey} PublicKey
     */ PublicKey.fromObject = function fromObject(d) {
        if (d instanceof $f1a792ebf0e77b82$var$$root.PublicKey) return d;
        var m = new $f1a792ebf0e77b82$var$$root.PublicKey();
        switch(d.Type){
            case "RSA":
            case 0:
                m.Type = 0;
                break;
            case "Ed25519":
            case 1:
                m.Type = 1;
                break;
            case "Secp256k1":
            case 2:
                m.Type = 2;
                break;
        }
        if (d.Data != null) {
            if (typeof d.Data === "string") $f1a792ebf0e77b82$var$$util.base64.decode(d.Data, m.Data = $f1a792ebf0e77b82$var$$util.newBuffer($f1a792ebf0e77b82$var$$util.base64.length(d.Data)), 0);
            else if (d.Data.length) m.Data = d.Data;
        }
        return m;
    };
    /**
     * Creates a plain object from a PublicKey message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicKey
     * @static
     * @param {PublicKey} m PublicKey
     * @param {$protobuf.IConversionOptions} [o] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ PublicKey.toObject = function toObject(m, o) {
        if (!o) o = {};
        var d = {};
        if (o.defaults) {
            d.Type = o.enums === String ? "RSA" : 0;
            if (o.bytes === String) d.Data = "";
            else {
                d.Data = [];
                if (o.bytes !== Array) d.Data = $f1a792ebf0e77b82$var$$util.newBuffer(d.Data);
            }
        }
        if (m.Type != null && m.hasOwnProperty("Type")) d.Type = o.enums === String ? $f1a792ebf0e77b82$var$$root.KeyType[m.Type] : m.Type;
        if (m.Data != null && m.hasOwnProperty("Data")) d.Data = o.bytes === String ? $f1a792ebf0e77b82$var$$util.base64.encode(m.Data, 0, m.Data.length) : o.bytes === Array ? Array.prototype.slice.call(m.Data) : m.Data;
        return d;
    };
    /**
     * Converts this PublicKey to JSON.
     * @function toJSON
     * @memberof PublicKey
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ PublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
    };
    return PublicKey;
}();
$f1a792ebf0e77b82$var$$root.PrivateKey = function() {
    /**
     * Properties of a PrivateKey.
     * @exports IPrivateKey
     * @interface IPrivateKey
     * @property {KeyType} Type PrivateKey Type
     * @property {Uint8Array} Data PrivateKey Data
     */ /**
     * Constructs a new PrivateKey.
     * @exports PrivateKey
     * @classdesc Represents a PrivateKey.
     * @implements IPrivateKey
     * @constructor
     * @param {IPrivateKey=} [p] Properties to set
     */ function PrivateKey(p) {
        if (p) {
            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }
    }
    /**
     * PrivateKey Type.
     * @member {KeyType} Type
     * @memberof PrivateKey
     * @instance
     */ PrivateKey.prototype.Type = 0;
    /**
     * PrivateKey Data.
     * @member {Uint8Array} Data
     * @memberof PrivateKey
     * @instance
     */ PrivateKey.prototype.Data = $f1a792ebf0e77b82$var$$util.newBuffer([]);
    /**
     * Encodes the specified PrivateKey message. Does not implicitly {@link PrivateKey.verify|verify} messages.
     * @function encode
     * @memberof PrivateKey
     * @static
     * @param {IPrivateKey} m PrivateKey message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ PrivateKey.encode = function encode(m, w) {
        if (!w) w = $f1a792ebf0e77b82$var$$Writer.create();
        w.uint32(8).int32(m.Type);
        w.uint32(18).bytes(m.Data);
        return w;
    };
    /**
     * Decodes a PrivateKey message from the specified reader or buffer.
     * @function decode
     * @memberof PrivateKey
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {PrivateKey} PrivateKey
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ PrivateKey.decode = function decode(r, l) {
        if (!(r instanceof $f1a792ebf0e77b82$var$$Reader)) r = $f1a792ebf0e77b82$var$$Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l, m = new $f1a792ebf0e77b82$var$$root.PrivateKey();
        while(r.pos < c){
            var t = r.uint32();
            switch(t >>> 3){
                case 1:
                    m.Type = r.int32();
                    break;
                case 2:
                    m.Data = r.bytes();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
            }
        }
        if (!m.hasOwnProperty("Type")) throw $f1a792ebf0e77b82$var$$util.ProtocolError("missing required 'Type'", {
            instance: m
        });
        if (!m.hasOwnProperty("Data")) throw $f1a792ebf0e77b82$var$$util.ProtocolError("missing required 'Data'", {
            instance: m
        });
        return m;
    };
    /**
     * Creates a PrivateKey message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PrivateKey
     * @static
     * @param {Object.<string,*>} d Plain object
     * @returns {PrivateKey} PrivateKey
     */ PrivateKey.fromObject = function fromObject(d) {
        if (d instanceof $f1a792ebf0e77b82$var$$root.PrivateKey) return d;
        var m = new $f1a792ebf0e77b82$var$$root.PrivateKey();
        switch(d.Type){
            case "RSA":
            case 0:
                m.Type = 0;
                break;
            case "Ed25519":
            case 1:
                m.Type = 1;
                break;
            case "Secp256k1":
            case 2:
                m.Type = 2;
                break;
        }
        if (d.Data != null) {
            if (typeof d.Data === "string") $f1a792ebf0e77b82$var$$util.base64.decode(d.Data, m.Data = $f1a792ebf0e77b82$var$$util.newBuffer($f1a792ebf0e77b82$var$$util.base64.length(d.Data)), 0);
            else if (d.Data.length) m.Data = d.Data;
        }
        return m;
    };
    /**
     * Creates a plain object from a PrivateKey message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PrivateKey
     * @static
     * @param {PrivateKey} m PrivateKey
     * @param {$protobuf.IConversionOptions} [o] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ PrivateKey.toObject = function toObject(m, o) {
        if (!o) o = {};
        var d = {};
        if (o.defaults) {
            d.Type = o.enums === String ? "RSA" : 0;
            if (o.bytes === String) d.Data = "";
            else {
                d.Data = [];
                if (o.bytes !== Array) d.Data = $f1a792ebf0e77b82$var$$util.newBuffer(d.Data);
            }
        }
        if (m.Type != null && m.hasOwnProperty("Type")) d.Type = o.enums === String ? $f1a792ebf0e77b82$var$$root.KeyType[m.Type] : m.Type;
        if (m.Data != null && m.hasOwnProperty("Data")) d.Data = o.bytes === String ? $f1a792ebf0e77b82$var$$util.base64.encode(m.Data, 0, m.Data.length) : o.bytes === Array ? Array.prototype.slice.call(m.Data) : m.Data;
        return d;
    };
    /**
     * Converts this PrivateKey to JSON.
     * @function toJSON
     * @memberof PrivateKey
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ PrivateKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
    };
    return PrivateKey;
}();
module.exports = $f1a792ebf0e77b82$var$$root;

});

parcelRequire.register("cxRIG", function(module, exports) {
"use strict";

var $eXQx4 = parcelRequire("eXQx4");
var $025b64138fefde1d$require$base64 = $eXQx4.base64;

var $5Xtie = parcelRequire("5Xtie");
module.exports = {
    /**
   * Attempts to decrypt a base64 encoded PrivateKey string
   * with the given password. The privateKey must have been exported
   * using the same password and underlying cipher (aes-gcm)
   *
   * @param {string} privateKey - A base64 encoded encrypted key
   * @param {string} password
   * @returns {Promise<Uint8Array>} The private key protobuf
   */ import: async function(privateKey, password) {
        const encryptedKey = $025b64138fefde1d$require$base64.decode(privateKey);
        const cipher = $5Xtie.create();
        return await cipher.decrypt(encryptedKey, password);
    }
};

});
parcelRequire.register("5Xtie", function(module, exports) {
"use strict";

var $8hEBV = parcelRequire("8hEBV");
var $45692f738bbab022$require$concat = $8hEBV.concat;

var $8cWjP = parcelRequire("8cWjP");
var $45692f738bbab022$require$fromString = $8cWjP.fromString;

var $j15Fm = parcelRequire("j15Fm");
// Based off of code from https://github.com/luke-park/SecureCompatibleEncryptionExamples
/**
 *
 * @param {object} [options]
 * @param {string} [options.algorithm=AES-GCM]
 * @param {number} [options.nonceLength=12]
 * @param {number} [options.keyLength=16]
 * @param {string} [options.digest=sha256]
 * @param {number} [options.saltLength=16]
 * @param {number} [options.iterations=32767]
 * @returns {*}
 */ function $45692f738bbab022$var$create({ algorithm: algorithm = "AES-GCM", nonceLength: nonceLength = 12, keyLength: keyLength = 16, digest: digest = "SHA-256", saltLength: saltLength = 16, iterations: iterations = 32767 } = {}) {
    const crypto = $j15Fm.get();
    keyLength *= 8 // Browser crypto uses bits instead of bytes
    ;
    /**
   * Uses the provided password to derive a pbkdf2 key. The key
   * will then be used to encrypt the data.
   *
   * @param {Uint8Array} data - The data to decrypt
   * @param {string} password - A plain password
   * @returns {Promise<Uint8Array>}
   */ async function encrypt(data, password) {
        const salt = crypto.getRandomValues(new Uint8Array(saltLength));
        const nonce = crypto.getRandomValues(new Uint8Array(nonceLength));
        const aesGcm = {
            name: algorithm,
            iv: nonce
        };
        // Derive a key using PBKDF2.
        const deriveParams = {
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: digest
            }
        };
        const rawKey = await crypto.subtle.importKey("raw", $45692f738bbab022$require$fromString(password), {
            name: "PBKDF2"
        }, false, [
            "deriveKey",
            "deriveBits"
        ]);
        const cryptoKey = await crypto.subtle.deriveKey(deriveParams, rawKey, {
            name: algorithm,
            length: keyLength
        }, true, [
            "encrypt"
        ]);
        // Encrypt the string.
        const ciphertext = await crypto.subtle.encrypt(aesGcm, cryptoKey, data);
        return $45692f738bbab022$require$concat([
            salt,
            aesGcm.iv,
            new Uint8Array(ciphertext)
        ]);
    }
    /**
   * Uses the provided password to derive a pbkdf2 key. The key
   * will then be used to decrypt the data. The options used to create
   * this decryption cipher must be the same as those used to create
   * the encryption cipher.
   *
   * @param {Uint8Array} data - The data to decrypt
   * @param {string} password - A plain password
   * @returns {Promise<Uint8Array>}
   */ async function decrypt(data, password) {
        const salt = data.slice(0, saltLength);
        const nonce = data.slice(saltLength, saltLength + nonceLength);
        const ciphertext = data.slice(saltLength + nonceLength);
        const aesGcm = {
            name: algorithm,
            iv: nonce
        };
        // Derive the key using PBKDF2.
        const deriveParams = {
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: digest
            }
        };
        const rawKey = await crypto.subtle.importKey("raw", $45692f738bbab022$require$fromString(password), {
            name: "PBKDF2"
        }, false, [
            "deriveKey",
            "deriveBits"
        ]);
        const cryptoKey = await crypto.subtle.deriveKey(deriveParams, rawKey, {
            name: algorithm,
            length: keyLength
        }, true, [
            "decrypt"
        ]);
        // Decrypt the string.
        const plaintext = await crypto.subtle.decrypt(aesGcm, cryptoKey, ciphertext);
        return new Uint8Array(plaintext);
    }
    return {
        encrypt: encrypt,
        decrypt: decrypt
    };
}
module.exports = {
    create: $45692f738bbab022$var$create
};

});
parcelRequire.register("j15Fm", function(module, exports) {

$parcel$export(module.exports, "get", () => $dd82817f996e7c24$export$3988ae62b71be9a3, (v) => $dd82817f996e7c24$export$3988ae62b71be9a3 = v);
/* eslint-env browser */ // Check native crypto exists and is enabled (In insecure context `self.crypto`
// exists but `self.crypto.subtle` does not).
var $dd82817f996e7c24$export$3988ae62b71be9a3;
"use strict";
$dd82817f996e7c24$export$3988ae62b71be9a3 = (win = globalThis)=>{
    const nativeCrypto = win.crypto;
    if (!nativeCrypto || !nativeCrypto.subtle) throw Object.assign(new Error("Missing Web Crypto API. The most likely cause of this error is that this page is being accessed from an insecure context (i.e. not HTTPS). For more information and possible resolutions see https://github.com/libp2p/js-libp2p-crypto/blob/master/README.md#web-crypto-api"), {
        code: "ERR_MISSING_WEB_CRYPTO"
    });
    return nativeCrypto;
};

});



parcelRequire.register("7YQRT", function(module, exports) {
"use strict";

var $gTOvd = parcelRequire("gTOvd");
var $5cf72586fdec9880$require$sha256 = $gTOvd.sha256;

var $20Lm5 = parcelRequire("20Lm5");

var $ijWXY = parcelRequire("ijWXY");
var $5cf72586fdec9880$require$uint8ArrayEquals = $ijWXY.equals;

var $6rBCs = parcelRequire("6rBCs");
var $5cf72586fdec9880$require$uint8ArrayToString = $6rBCs.toString;
parcelRequire("acTBK");

var $2xc86 = parcelRequire("2xc86");

var $FRL4i = parcelRequire("FRL4i");

var $kKjWz = parcelRequire("kKjWz");

var $jcqxm = parcelRequire("jcqxm");
class $5cf72586fdec9880$var$RsaPublicKey {
    constructor(key){
        this._key = key;
    }
    async verify(data, sig) {
        return $FRL4i.hashAndVerify(this._key, sig, data);
    }
    marshal() {
        return $FRL4i.utils.jwkToPkix(this._key);
    }
    get bytes() {
        return $kKjWz.PublicKey.encode({
            Type: $kKjWz.KeyType.RSA,
            Data: this.marshal()
        }).finish();
    }
    encrypt(bytes) {
        return $FRL4i.encrypt(this._key, bytes);
    }
    equals(key) {
        return $5cf72586fdec9880$require$uint8ArrayEquals(this.bytes, key.bytes);
    }
    async hash() {
        const { bytes: bytes } = await $5cf72586fdec9880$require$sha256.digest(this.bytes);
        return bytes;
    }
}
class $5cf72586fdec9880$var$RsaPrivateKey {
    // key       - Object of the jwk format
    // publicKey - Uint8Array of the spki format
    constructor(key, publicKey){
        this._key = key;
        this._publicKey = publicKey;
    }
    genSecret() {
        return $FRL4i.getRandomValues(16);
    }
    async sign(message) {
        return $FRL4i.hashAndSign(this._key, message);
    }
    get public() {
        if (!this._publicKey) throw $20Lm5(new Error("public key not provided"), "ERR_PUBKEY_NOT_PROVIDED");
        return new $5cf72586fdec9880$var$RsaPublicKey(this._publicKey);
    }
    decrypt(bytes) {
        return $FRL4i.decrypt(this._key, bytes);
    }
    marshal() {
        return $FRL4i.utils.jwkToPkcs1(this._key);
    }
    get bytes() {
        return $kKjWz.PrivateKey.encode({
            Type: $kKjWz.KeyType.RSA,
            Data: this.marshal()
        }).finish();
    }
    equals(key) {
        return $5cf72586fdec9880$require$uint8ArrayEquals(this.bytes, key.bytes);
    }
    async hash() {
        const { bytes: bytes } = await $5cf72586fdec9880$require$sha256.digest(this.bytes);
        return bytes;
    }
    /**
   * Gets the ID of the key.
   *
   * The key id is the base58 encoding of the SHA-256 multihash of its public key.
   * The public key is a protobuf encoding containing a type and the DER encoding
   * of the PKCS SubjectPublicKeyInfo.
   *
   * @returns {Promise<string>}
   */ async id() {
        const hash = await this.public.hash();
        return $5cf72586fdec9880$require$uint8ArrayToString(hash, "base58btc");
    }
    /**
   * Exports the key into a password protected PEM format
   *
   * @param {string} password - The password to read the encrypted PEM
   * @param {string} [format=pkcs-8] - The format in which to export as
   */ async export(password, format = "pkcs-8") {
        if (format === "pkcs-8") {
            const buffer = new $2xc86.util.ByteBuffer(this.marshal());
            const asn1 = $2xc86.asn1.fromDer(buffer);
            const privateKey = $2xc86.pki.privateKeyFromAsn1(asn1);
            const options = {
                algorithm: "aes256",
                count: 10000,
                saltSize: 16,
                prfAlgorithm: "sha512"
            };
            return $2xc86.pki.encryptRsaPrivateKey(privateKey, password, options);
        } else if (format === "libp2p-key") return $jcqxm.export(this.bytes, password);
        else throw $20Lm5(new Error(`export format '${format}' is not supported`), "ERR_INVALID_EXPORT_FORMAT");
    }
}
async function $5cf72586fdec9880$var$unmarshalRsaPrivateKey(bytes) {
    const jwk = $FRL4i.utils.pkcs1ToJwk(bytes);
    const keys = await $FRL4i.unmarshalPrivateKey(jwk);
    return new $5cf72586fdec9880$var$RsaPrivateKey(keys.privateKey, keys.publicKey);
}
function $5cf72586fdec9880$var$unmarshalRsaPublicKey(bytes) {
    const jwk = $FRL4i.utils.pkixToJwk(bytes);
    return new $5cf72586fdec9880$var$RsaPublicKey(jwk);
}
async function $5cf72586fdec9880$var$fromJwk(jwk) {
    const keys = await $FRL4i.unmarshalPrivateKey(jwk);
    return new $5cf72586fdec9880$var$RsaPrivateKey(keys.privateKey, keys.publicKey);
}
async function $5cf72586fdec9880$var$generateKeyPair(bits) {
    const keys = await $FRL4i.generateKey(bits);
    return new $5cf72586fdec9880$var$RsaPrivateKey(keys.privateKey, keys.publicKey);
}
module.exports = {
    RsaPublicKey: $5cf72586fdec9880$var$RsaPublicKey,
    RsaPrivateKey: $5cf72586fdec9880$var$RsaPrivateKey,
    unmarshalRsaPublicKey: $5cf72586fdec9880$var$unmarshalRsaPublicKey,
    unmarshalRsaPrivateKey: $5cf72586fdec9880$var$unmarshalRsaPrivateKey,
    generateKeyPair: $5cf72586fdec9880$var$generateKeyPair,
    fromJwk: $5cf72586fdec9880$var$fromJwk
};

});
parcelRequire.register("FRL4i", function(module, exports) {

$parcel$export(module.exports, "utils", () => $07dd87b3c05a7bf9$export$eab97d15b1788b8d, (v) => $07dd87b3c05a7bf9$export$eab97d15b1788b8d = v);
$parcel$export(module.exports, "generateKey", () => $07dd87b3c05a7bf9$export$3a7728e868aa3ebd, (v) => $07dd87b3c05a7bf9$export$3a7728e868aa3ebd = v);
$parcel$export(module.exports, "unmarshalPrivateKey", () => $07dd87b3c05a7bf9$export$11dd448d4d042aab, (v) => $07dd87b3c05a7bf9$export$11dd448d4d042aab = v);
$parcel$export(module.exports, "getRandomValues", () => $07dd87b3c05a7bf9$export$960b9ff25e7d4257, (v) => $07dd87b3c05a7bf9$export$960b9ff25e7d4257 = v);
$parcel$export(module.exports, "hashAndSign", () => $07dd87b3c05a7bf9$export$cc7d6a37d08cb106, (v) => $07dd87b3c05a7bf9$export$cc7d6a37d08cb106 = v);
$parcel$export(module.exports, "hashAndVerify", () => $07dd87b3c05a7bf9$export$619cff377ee92930, (v) => $07dd87b3c05a7bf9$export$619cff377ee92930 = v);
$parcel$export(module.exports, "encrypt", () => $07dd87b3c05a7bf9$export$5b0f6292f11d1d18, (v) => $07dd87b3c05a7bf9$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $07dd87b3c05a7bf9$export$e85a0c9a1067c5d3, (v) => $07dd87b3c05a7bf9$export$e85a0c9a1067c5d3 = v);
var $07dd87b3c05a7bf9$export$eab97d15b1788b8d;
var $07dd87b3c05a7bf9$export$3a7728e868aa3ebd;
// Takes a jwk key
var $07dd87b3c05a7bf9$export$11dd448d4d042aab;
var $07dd87b3c05a7bf9$export$960b9ff25e7d4257;
var $07dd87b3c05a7bf9$export$cc7d6a37d08cb106;
var $07dd87b3c05a7bf9$export$619cff377ee92930;
var $07dd87b3c05a7bf9$export$5b0f6292f11d1d18;
var $07dd87b3c05a7bf9$export$e85a0c9a1067c5d3;
"use strict";

var $j15Fm = parcelRequire("j15Fm");

var $kPiMl = parcelRequire("kPiMl");

var $6rBCs = parcelRequire("6rBCs");
var $07dd87b3c05a7bf9$require$uint8ArrayToString = $6rBCs.toString;

var $8cWjP = parcelRequire("8cWjP");
var $07dd87b3c05a7bf9$require$uint8ArrayFromString = $8cWjP.fromString;

$07dd87b3c05a7bf9$export$eab97d15b1788b8d = (parcelRequire("cqZhO"));
$07dd87b3c05a7bf9$export$3a7728e868aa3ebd = async function(bits) {
    const pair = await $j15Fm.get().subtle.generateKey({
        name: "RSASSA-PKCS1-v1_5",
        modulusLength: bits,
        publicExponent: new Uint8Array([
            0x01,
            0x00,
            0x01
        ]),
        hash: {
            name: "SHA-256"
        }
    }, true, [
        "sign",
        "verify"
    ]);
    const keys = await $07dd87b3c05a7bf9$var$exportKey(pair);
    return {
        privateKey: keys[0],
        publicKey: keys[1]
    };
};
$07dd87b3c05a7bf9$export$11dd448d4d042aab = async function(key) {
    const privateKey = await $j15Fm.get().subtle.importKey("jwk", key, {
        name: "RSASSA-PKCS1-v1_5",
        hash: {
            name: "SHA-256"
        }
    }, true, [
        "sign"
    ]);
    const pair = [
        privateKey,
        await $07dd87b3c05a7bf9$var$derivePublicFromPrivate(key)
    ];
    const keys = await $07dd87b3c05a7bf9$var$exportKey({
        privateKey: pair[0],
        publicKey: pair[1]
    });
    return {
        privateKey: keys[0],
        publicKey: keys[1]
    };
};
$07dd87b3c05a7bf9$export$960b9ff25e7d4257 = $kPiMl;
$07dd87b3c05a7bf9$export$cc7d6a37d08cb106 = async function(key, msg) {
    const privateKey = await $j15Fm.get().subtle.importKey("jwk", key, {
        name: "RSASSA-PKCS1-v1_5",
        hash: {
            name: "SHA-256"
        }
    }, false, [
        "sign"
    ]);
    const sig = await $j15Fm.get().subtle.sign({
        name: "RSASSA-PKCS1-v1_5"
    }, privateKey, Uint8Array.from(msg));
    return new Uint8Array(sig, sig.byteOffset, sig.byteLength);
};
$07dd87b3c05a7bf9$export$619cff377ee92930 = async function(key, sig, msg) {
    const publicKey = await $j15Fm.get().subtle.importKey("jwk", key, {
        name: "RSASSA-PKCS1-v1_5",
        hash: {
            name: "SHA-256"
        }
    }, false, [
        "verify"
    ]);
    return $j15Fm.get().subtle.verify({
        name: "RSASSA-PKCS1-v1_5"
    }, publicKey, sig, msg);
};
function $07dd87b3c05a7bf9$var$exportKey(pair) {
    return Promise.all([
        $j15Fm.get().subtle.exportKey("jwk", pair.privateKey),
        $j15Fm.get().subtle.exportKey("jwk", pair.publicKey)
    ]);
}
function $07dd87b3c05a7bf9$var$derivePublicFromPrivate(jwKey) {
    return $j15Fm.get().subtle.importKey("jwk", {
        kty: jwKey.kty,
        n: jwKey.n,
        e: jwKey.e
    }, {
        name: "RSASSA-PKCS1-v1_5",
        hash: {
            name: "SHA-256"
        }
    }, true, [
        "verify"
    ]);
}

var $4HdYf = parcelRequire("4HdYf");
var $07dd87b3c05a7bf9$require$jwk2pub = $4HdYf.jwk2pub;
var $07dd87b3c05a7bf9$require$jwk2priv = $4HdYf.jwk2priv;
function $07dd87b3c05a7bf9$var$convertKey(key, pub, msg, handle) {
    const fkey = pub ? $07dd87b3c05a7bf9$require$jwk2pub(key) : $07dd87b3c05a7bf9$require$jwk2priv(key);
    const fmsg = $07dd87b3c05a7bf9$require$uint8ArrayToString(Uint8Array.from(msg), "ascii");
    const fomsg = handle(fmsg, fkey);
    return $07dd87b3c05a7bf9$require$uint8ArrayFromString(fomsg, "ascii");
}
$07dd87b3c05a7bf9$export$5b0f6292f11d1d18 = function(key, msg) {
    return $07dd87b3c05a7bf9$var$convertKey(key, true, msg, (msg, key)=>key.encrypt(msg));
};
$07dd87b3c05a7bf9$export$e85a0c9a1067c5d3 = function(key, msg) {
    return $07dd87b3c05a7bf9$var$convertKey(key, false, msg, (msg, key)=>key.decrypt(msg));
};

});
parcelRequire.register("kPiMl", function(module, exports) {
"use strict";

var $6J93w = parcelRequire("6J93w");

var $20Lm5 = parcelRequire("20Lm5");
module.exports = function(length) {
    if (isNaN(length) || length <= 0) throw $20Lm5(new Error("random bytes length must be a Number bigger than 0"), "ERR_INVALID_LENGTH");
    return $6J93w(length);
};

});

parcelRequire.register("cqZhO", function(module, exports) {

$parcel$export(module.exports, "pkcs1ToJwk", () => $90d773e7637b6906$export$2c5c25417935aff2, (v) => $90d773e7637b6906$export$2c5c25417935aff2 = v);
$parcel$export(module.exports, "jwkToPkcs1", () => $90d773e7637b6906$export$d3c021755f04ee81, (v) => $90d773e7637b6906$export$d3c021755f04ee81 = v);
$parcel$export(module.exports, "pkixToJwk", () => $90d773e7637b6906$export$70fcaa90a80c2900, (v) => $90d773e7637b6906$export$70fcaa90a80c2900 = v);
$parcel$export(module.exports, "jwkToPkix", () => $90d773e7637b6906$export$1db1642be8afe525, (v) => $90d773e7637b6906$export$1db1642be8afe525 = v);
// Convert a PKCS#1 in ASN1 DER format to a JWK key
var $90d773e7637b6906$export$2c5c25417935aff2;
// Convert a JWK key into PKCS#1 in ASN1 DER format
var $90d773e7637b6906$export$d3c021755f04ee81;
// Convert a PKCIX in ASN1 DER format to a JWK key
var $90d773e7637b6906$export$70fcaa90a80c2900;
// Convert a JWK key to PKCIX in ASN1 DER format
var $90d773e7637b6906$export$1db1642be8afe525;
"use strict";
parcelRequire("l46Tq");
parcelRequire("96KyE");

var $2xc86 = parcelRequire("2xc86");

var $eLywY = parcelRequire("eLywY");
var $90d773e7637b6906$require$bigIntegerToUintBase64url = $eLywY.bigIntegerToUintBase64url;
var $90d773e7637b6906$require$base64urlToBigInteger = $eLywY.base64urlToBigInteger;

var $8cWjP = parcelRequire("8cWjP");
var $90d773e7637b6906$require$uint8ArrayFromString = $8cWjP.fromString;

var $6rBCs = parcelRequire("6rBCs");
var $90d773e7637b6906$require$uint8ArrayToString = $6rBCs.toString;
$90d773e7637b6906$export$2c5c25417935aff2 = function(bytes) {
    const asn1 = $2xc86.asn1.fromDer($90d773e7637b6906$require$uint8ArrayToString(bytes, "ascii"));
    const privateKey = $2xc86.pki.privateKeyFromAsn1(asn1);
    // https://tools.ietf.org/html/rfc7518#section-6.3.1
    return {
        kty: "RSA",
        n: $90d773e7637b6906$require$bigIntegerToUintBase64url(privateKey.n),
        e: $90d773e7637b6906$require$bigIntegerToUintBase64url(privateKey.e),
        d: $90d773e7637b6906$require$bigIntegerToUintBase64url(privateKey.d),
        p: $90d773e7637b6906$require$bigIntegerToUintBase64url(privateKey.p),
        q: $90d773e7637b6906$require$bigIntegerToUintBase64url(privateKey.q),
        dp: $90d773e7637b6906$require$bigIntegerToUintBase64url(privateKey.dP),
        dq: $90d773e7637b6906$require$bigIntegerToUintBase64url(privateKey.dQ),
        qi: $90d773e7637b6906$require$bigIntegerToUintBase64url(privateKey.qInv),
        alg: "RS256",
        kid: "2011-04-29"
    };
};
$90d773e7637b6906$export$d3c021755f04ee81 = function(jwk) {
    const asn1 = $2xc86.pki.privateKeyToAsn1({
        n: $90d773e7637b6906$require$base64urlToBigInteger(jwk.n),
        e: $90d773e7637b6906$require$base64urlToBigInteger(jwk.e),
        d: $90d773e7637b6906$require$base64urlToBigInteger(jwk.d),
        p: $90d773e7637b6906$require$base64urlToBigInteger(jwk.p),
        q: $90d773e7637b6906$require$base64urlToBigInteger(jwk.q),
        dP: $90d773e7637b6906$require$base64urlToBigInteger(jwk.dp),
        dQ: $90d773e7637b6906$require$base64urlToBigInteger(jwk.dq),
        qInv: $90d773e7637b6906$require$base64urlToBigInteger(jwk.qi)
    });
    return $90d773e7637b6906$require$uint8ArrayFromString($2xc86.asn1.toDer(asn1).getBytes(), "ascii");
};
$90d773e7637b6906$export$70fcaa90a80c2900 = function(bytes) {
    const asn1 = $2xc86.asn1.fromDer($90d773e7637b6906$require$uint8ArrayToString(bytes, "ascii"));
    const publicKey = $2xc86.pki.publicKeyFromAsn1(asn1);
    return {
        kty: "RSA",
        n: $90d773e7637b6906$require$bigIntegerToUintBase64url(publicKey.n),
        e: $90d773e7637b6906$require$bigIntegerToUintBase64url(publicKey.e),
        alg: "RS256",
        kid: "2011-04-29"
    };
};
$90d773e7637b6906$export$1db1642be8afe525 = function(jwk) {
    const asn1 = $2xc86.pki.publicKeyToAsn1({
        n: $90d773e7637b6906$require$base64urlToBigInteger(jwk.n),
        e: $90d773e7637b6906$require$base64urlToBigInteger(jwk.e)
    });
    return $90d773e7637b6906$require$uint8ArrayFromString($2xc86.asn1.toDer(asn1).getBytes(), "ascii");
};

});
parcelRequire.register("eLywY", function(module, exports) {

$parcel$export(module.exports, "bigIntegerToUintBase64url", () => $ac003d931544d3fe$export$975f12d8c59391f6, (v) => $ac003d931544d3fe$export$975f12d8c59391f6 = v);
$parcel$export(module.exports, "base64urlToBigInteger", () => $ac003d931544d3fe$export$560aa83c1da30c27, (v) => $ac003d931544d3fe$export$560aa83c1da30c27 = v);
$parcel$export(module.exports, "base64urlToBuffer", () => $ac003d931544d3fe$export$d203bea30aac4ae7, (v) => $ac003d931544d3fe$export$d203bea30aac4ae7 = v);
var $ac003d931544d3fe$export$975f12d8c59391f6;
// Convert a base64url encoded string to a BigInteger
var $ac003d931544d3fe$export$560aa83c1da30c27;
var $ac003d931544d3fe$export$d203bea30aac4ae7;
"use strict";
parcelRequire("e73pV");
parcelRequire("ft6fW");

var $2xc86 = parcelRequire("2xc86");

var $8cWjP = parcelRequire("8cWjP");
var $ac003d931544d3fe$require$uint8ArrayFromString = $8cWjP.fromString;

var $6rBCs = parcelRequire("6rBCs");
var $ac003d931544d3fe$require$uint8ArrayToString = $6rBCs.toString;

var $8hEBV = parcelRequire("8hEBV");
var $ac003d931544d3fe$require$uint8ArrayConcat = $8hEBV.concat;
$ac003d931544d3fe$export$975f12d8c59391f6 = (num, len)=>{
    // Call `.abs()` to convert to unsigned
    let buf = Uint8Array.from(num.abs().toByteArray()) // toByteArray converts to big endian
    ;
    // toByteArray() gives us back a signed array, which will include a leading 0
    // byte if the most significant bit of the number is 1:
    // https://docs.microsoft.com/en-us/windows/win32/seccertenroll/about-integer
    // Our number will always be positive so we should remove the leading padding.
    buf = buf[0] === 0 ? buf.slice(1) : buf;
    if (len != null) {
        if (buf.length > len) throw new Error("byte array longer than desired length");
        buf = $ac003d931544d3fe$require$uint8ArrayConcat([
            new Uint8Array(len - buf.length),
            buf
        ]);
    }
    return $ac003d931544d3fe$require$uint8ArrayToString(buf, "base64url");
};
$ac003d931544d3fe$export$560aa83c1da30c27 = (str)=>{
    const buf = $ac003d931544d3fe$export$d203bea30aac4ae7(str);
    return new $2xc86.jsbn.BigInteger($ac003d931544d3fe$require$uint8ArrayToString(buf, "base16"), 16);
};
$ac003d931544d3fe$export$d203bea30aac4ae7 = (str, len)=>{
    let buf = $ac003d931544d3fe$require$uint8ArrayFromString(str, "base64urlpad");
    if (len != null) {
        if (buf.length > len) throw new Error("byte array longer than desired length");
        buf = $ac003d931544d3fe$require$uint8ArrayConcat([
            new Uint8Array(len - buf.length),
            buf
        ]);
    }
    return buf;
};

});


parcelRequire.register("4HdYf", function(module, exports) {
"use strict";
parcelRequire("96KyE");

var $2xc86 = parcelRequire("2xc86");

var $eLywY = parcelRequire("eLywY");
var $36b603e6541760ce$require$base64urlToBigInteger = $eLywY.base64urlToBigInteger;
function $36b603e6541760ce$var$convert(key, types) {
    return types.map((t)=>$36b603e6541760ce$require$base64urlToBigInteger(key[t]));
}
function $36b603e6541760ce$var$jwk2priv(key) {
    return $2xc86.pki.setRsaPrivateKey(...$36b603e6541760ce$var$convert(key, [
        "n",
        "e",
        "d",
        "p",
        "q",
        "dp",
        "dq",
        "qi"
    ]));
}
function $36b603e6541760ce$var$jwk2pub(key) {
    return $2xc86.pki.setRsaPublicKey(...$36b603e6541760ce$var$convert(key, [
        "n",
        "e"
    ]));
}
module.exports = {
    jwk2pub: $36b603e6541760ce$var$jwk2pub,
    jwk2priv: $36b603e6541760ce$var$jwk2priv
};

});


parcelRequire.register("jcqxm", function(module, exports) {
"use strict";

var $eXQx4 = parcelRequire("eXQx4");
var $dfa3b90a8e11d349$require$base64 = $eXQx4.base64;

var $5Xtie = parcelRequire("5Xtie");
module.exports = {
    /**
   * Exports the given PrivateKey as a base64 encoded string.
   * The PrivateKey is encrypted via a password derived PBKDF2 key
   * leveraging the aes-gcm cipher algorithm.
   *
   * @param {Uint8Array} privateKey - The PrivateKey protobuf
   * @param {string} password
   * @returns {Promise<string>} A base64 encoded string
   */ export: async function(privateKey, password) {
        const cipher = $5Xtie.create();
        const encryptedKey = await cipher.encrypt(privateKey, password);
        return $dfa3b90a8e11d349$require$base64.encode(encryptedKey);
    }
};

});


parcelRequire.register("buPLK", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $ijWXY = parcelRequire("ijWXY");
var $85eaa74e199b062b$require$uint8ArrayEquals = $ijWXY.equals;

var $gTOvd = parcelRequire("gTOvd");
var $85eaa74e199b062b$require$sha256 = $gTOvd.sha256;

var $fVtlC = parcelRequire("fVtlC");
var $85eaa74e199b062b$require$base58btc = $fVtlC.base58btc;

var $klyrn = parcelRequire("klyrn");
var $85eaa74e199b062b$require$identity = $klyrn.identity;

var $ilyPZ = parcelRequire("ilyPZ");

var $kKjWz = parcelRequire("kKjWz");

var $jcqxm = parcelRequire("jcqxm");
class $85eaa74e199b062b$var$Ed25519PublicKey {
    constructor(key){
        this._key = $85eaa74e199b062b$var$ensureKey(key, $ilyPZ.publicKeyLength);
    }
    async verify(data, sig) {
        return $ilyPZ.hashAndVerify(this._key, sig, data);
    }
    marshal() {
        return this._key;
    }
    get bytes() {
        return $kKjWz.PublicKey.encode({
            Type: $kKjWz.KeyType.Ed25519,
            Data: this.marshal()
        }).finish();
    }
    equals(key) {
        return $85eaa74e199b062b$require$uint8ArrayEquals(this.bytes, key.bytes);
    }
    async hash() {
        const { bytes: bytes } = await $85eaa74e199b062b$require$sha256.digest(this.bytes);
        return bytes;
    }
}
class $85eaa74e199b062b$var$Ed25519PrivateKey {
    // key       - 64 byte Uint8Array containing private key
    // publicKey - 32 byte Uint8Array containing public key
    constructor(key, publicKey){
        this._key = $85eaa74e199b062b$var$ensureKey(key, $ilyPZ.privateKeyLength);
        this._publicKey = $85eaa74e199b062b$var$ensureKey(publicKey, $ilyPZ.publicKeyLength);
    }
    async sign(message) {
        return $ilyPZ.hashAndSign(this._key, message);
    }
    get public() {
        return new $85eaa74e199b062b$var$Ed25519PublicKey(this._publicKey);
    }
    marshal() {
        return this._key;
    }
    get bytes() {
        return $kKjWz.PrivateKey.encode({
            Type: $kKjWz.KeyType.Ed25519,
            Data: this.marshal()
        }).finish();
    }
    equals(key) {
        return $85eaa74e199b062b$require$uint8ArrayEquals(this.bytes, key.bytes);
    }
    async hash() {
        const { bytes: bytes } = await $85eaa74e199b062b$require$sha256.digest(this.bytes);
        return bytes;
    }
    /**
   * Gets the ID of the key.
   *
   * The key id is the base58 encoding of the identity multihash containing its public key.
   * The public key is a protobuf encoding containing a type and the DER encoding
   * of the PKCS SubjectPublicKeyInfo.
   *
   * @returns {Promise<string>}
   */ async id() {
        const encoding = await $85eaa74e199b062b$require$identity.digest(this.public.bytes);
        return $85eaa74e199b062b$require$base58btc.encode(encoding.bytes).substring(1);
    }
    /**
   * Exports the key into a password protected `format`
   *
   * @param {string} password - The password to encrypt the key
   * @param {string} [format=libp2p-key] - The format in which to export as
   * @returns {Promise<Uint8Array>} The encrypted private key
   */ async export(password, format = "libp2p-key") {
        if (format === "libp2p-key") return $jcqxm.export(this.bytes, password);
        else throw $20Lm5(new Error(`export format '${format}' is not supported`), "ERR_INVALID_EXPORT_FORMAT");
    }
}
function $85eaa74e199b062b$var$unmarshalEd25519PrivateKey(bytes) {
    // Try the old, redundant public key version
    if (bytes.length > $ilyPZ.privateKeyLength) {
        bytes = $85eaa74e199b062b$var$ensureKey(bytes, $ilyPZ.privateKeyLength + $ilyPZ.publicKeyLength);
        const privateKeyBytes = bytes.slice(0, $ilyPZ.privateKeyLength);
        const publicKeyBytes = bytes.slice($ilyPZ.privateKeyLength, bytes.length);
        return new $85eaa74e199b062b$var$Ed25519PrivateKey(privateKeyBytes, publicKeyBytes);
    }
    bytes = $85eaa74e199b062b$var$ensureKey(bytes, $ilyPZ.privateKeyLength);
    const privateKeyBytes = bytes.slice(0, $ilyPZ.privateKeyLength);
    const publicKeyBytes = bytes.slice($ilyPZ.publicKeyLength);
    return new $85eaa74e199b062b$var$Ed25519PrivateKey(privateKeyBytes, publicKeyBytes);
}
function $85eaa74e199b062b$var$unmarshalEd25519PublicKey(bytes) {
    bytes = $85eaa74e199b062b$var$ensureKey(bytes, $ilyPZ.publicKeyLength);
    return new $85eaa74e199b062b$var$Ed25519PublicKey(bytes);
}
async function $85eaa74e199b062b$var$generateKeyPair() {
    const { privateKey: privateKey, publicKey: publicKey } = await $ilyPZ.generateKey();
    return new $85eaa74e199b062b$var$Ed25519PrivateKey(privateKey, publicKey);
}
async function $85eaa74e199b062b$var$generateKeyPairFromSeed(seed) {
    const { privateKey: privateKey, publicKey: publicKey } = await $ilyPZ.generateKeyFromSeed(seed);
    return new $85eaa74e199b062b$var$Ed25519PrivateKey(privateKey, publicKey);
}
function $85eaa74e199b062b$var$ensureKey(key, length) {
    key = Uint8Array.from(key || []);
    if (key.length !== length) throw $20Lm5(new Error(`Key must be a Uint8Array of length ${length}, got ${key.length}`), "ERR_INVALID_KEY_TYPE");
    return key;
}
module.exports = {
    Ed25519PublicKey: $85eaa74e199b062b$var$Ed25519PublicKey,
    Ed25519PrivateKey: $85eaa74e199b062b$var$Ed25519PrivateKey,
    unmarshalEd25519PrivateKey: $85eaa74e199b062b$var$unmarshalEd25519PrivateKey,
    unmarshalEd25519PublicKey: $85eaa74e199b062b$var$unmarshalEd25519PublicKey,
    generateKeyPair: $85eaa74e199b062b$var$generateKeyPair,
    generateKeyPairFromSeed: $85eaa74e199b062b$var$generateKeyPairFromSeed
};

});
parcelRequire.register("ilyPZ", function(module, exports) {

$parcel$export(module.exports, "publicKeyLength", () => $d5b5363070b7703c$export$5f4cfc08c63c83db, (v) => $d5b5363070b7703c$export$5f4cfc08c63c83db = v);
$parcel$export(module.exports, "privateKeyLength", () => $d5b5363070b7703c$export$646aa2db9f6f5fe, (v) => $d5b5363070b7703c$export$646aa2db9f6f5fe = v);
$parcel$export(module.exports, "generateKey", () => $d5b5363070b7703c$export$3a7728e868aa3ebd, (v) => $d5b5363070b7703c$export$3a7728e868aa3ebd = v);
$parcel$export(module.exports, "generateKeyFromSeed", () => $d5b5363070b7703c$export$47705f2da2f256b8, (v) => $d5b5363070b7703c$export$47705f2da2f256b8 = v);
$parcel$export(module.exports, "hashAndSign", () => $d5b5363070b7703c$export$cc7d6a37d08cb106, (v) => $d5b5363070b7703c$export$cc7d6a37d08cb106 = v);
$parcel$export(module.exports, "hashAndVerify", () => $d5b5363070b7703c$export$619cff377ee92930, (v) => $d5b5363070b7703c$export$619cff377ee92930 = v);
var $d5b5363070b7703c$export$5f4cfc08c63c83db;
var $d5b5363070b7703c$export$646aa2db9f6f5fe;
var $d5b5363070b7703c$export$3a7728e868aa3ebd;
/**
 * Generate keypair from a seed
 *
 * @param {Uint8Array} seed - seed should be a 32 byte uint8array
 * @returns
 */ var $d5b5363070b7703c$export$47705f2da2f256b8;
var $d5b5363070b7703c$export$cc7d6a37d08cb106;
var $d5b5363070b7703c$export$619cff377ee92930;
"use strict";

var $23pl8 = parcelRequire("23pl8");
const $d5b5363070b7703c$var$PUBLIC_KEY_BYTE_LENGTH = 32;
const $d5b5363070b7703c$var$PRIVATE_KEY_BYTE_LENGTH = 64 // private key is actually 32 bytes but for historical reasons we concat private and public keys
;
const $d5b5363070b7703c$var$KEYS_BYTE_LENGTH = 32;
$d5b5363070b7703c$export$5f4cfc08c63c83db = $d5b5363070b7703c$var$PUBLIC_KEY_BYTE_LENGTH;
$d5b5363070b7703c$export$646aa2db9f6f5fe = $d5b5363070b7703c$var$PRIVATE_KEY_BYTE_LENGTH;
$d5b5363070b7703c$export$3a7728e868aa3ebd = async function() {
    // the actual private key (32 bytes)
    const privateKeyRaw = $23pl8.utils.randomPrivateKey();
    const publicKey = await $23pl8.getPublicKey(privateKeyRaw);
    // concatenated the public key to the private key
    const privateKey = $d5b5363070b7703c$var$concatKeys(privateKeyRaw, publicKey);
    return {
        privateKey: privateKey,
        publicKey: publicKey
    };
};
$d5b5363070b7703c$export$47705f2da2f256b8 = async function(seed) {
    if (seed.length !== $d5b5363070b7703c$var$KEYS_BYTE_LENGTH) throw new TypeError('"seed" must be 32 bytes in length.');
    else if (!(seed instanceof Uint8Array)) throw new TypeError('"seed" must be a node.js Buffer, or Uint8Array.');
    // based on node forges algorithm, the seed is used directly as private key
    const privateKeyRaw = seed;
    const publicKey = await $23pl8.getPublicKey(privateKeyRaw);
    const privateKey = $d5b5363070b7703c$var$concatKeys(privateKeyRaw, publicKey);
    return {
        privateKey: privateKey,
        publicKey: publicKey
    };
};
$d5b5363070b7703c$export$cc7d6a37d08cb106 = function(privateKey, msg) {
    const privateKeyRaw = privateKey.slice(0, $d5b5363070b7703c$var$KEYS_BYTE_LENGTH);
    return $23pl8.sign(msg, privateKeyRaw);
};
$d5b5363070b7703c$export$619cff377ee92930 = function(publicKey, sig, msg) {
    return $23pl8.verify(sig, msg, publicKey);
};
function $d5b5363070b7703c$var$concatKeys(privateKeyRaw, publicKey) {
    const privateKey = new Uint8Array($d5b5363070b7703c$export$646aa2db9f6f5fe);
    for(let i = 0; i < $d5b5363070b7703c$var$KEYS_BYTE_LENGTH; i++){
        privateKey[i] = privateKeyRaw[i];
        privateKey[$d5b5363070b7703c$var$KEYS_BYTE_LENGTH + i] = publicKey[i];
    }
    return privateKey;
}

});
parcelRequire.register("23pl8", function(module, exports) {
"use strict";
/*! noble-ed25519 - MIT License (c) Paul Miller (paulmillr.com) */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utils = exports.verify = exports.sign = exports.getPublicKey = exports.SignResult = exports.Signature = exports.Point = exports.ExtendedPoint = exports.CURVE = void 0;
const CURVE = {
    a: -1n,
    d: 37095705934669439343138083508754565189542113879843219016388785533085940283555n,
    P: 2n ** 255n - 19n,
    n: 2n ** 252n + 27742317777372353535851937790883648493n,
    h: 8n,
    Gx: 15112221349535400772501151409588531511454012693041857206046113283949847762202n,
    Gy: 46316835694926478169428394003475163141307993866256225615783033603165251855960n
};
exports.CURVE = CURVE;
const B32 = 32;
const SQRT_M1 = 19681161376707505956807079304988542015446066515923890162744021073123829784752n;
const SQRT_AD_MINUS_ONE = 25063068953384623474111414158702152701244531502492656460079210482610430750235n;
const INVSQRT_A_MINUS_D = 54469307008909316920995813868745141605393597292927456921205312896311721017578n;
const ONE_MINUS_D_SQ = 1159843021668779879193775521855586647937357759715417654439879720876111806838n;
const D_MINUS_ONE_SQ = 40440834346308536858101042469323190826248399146238708352240133220865137265952n;
class ExtendedPoint {
    constructor(x, y, z, t){
        this.x = x;
        this.y = y;
        this.z = z;
        this.t = t;
    }
    static fromAffine(p) {
        if (!(p instanceof Point)) throw new TypeError("ExtendedPoint#fromAffine: expected Point");
        if (p.equals(Point.ZERO)) return ExtendedPoint.ZERO;
        return new ExtendedPoint(p.x, p.y, 1n, mod(p.x * p.y));
    }
    static toAffineBatch(points) {
        const toInv = invertBatch(points.map((p)=>p.z));
        return points.map((p, i)=>p.toAffine(toInv[i]));
    }
    static normalizeZ(points) {
        return this.toAffineBatch(points).map(this.fromAffine);
    }
    static fromRistrettoHash(hash) {
        const r1 = bytes255ToNumberLE(hash.slice(0, B32));
        const R1 = this.calcElligatorRistrettoMap(r1);
        const r2 = bytes255ToNumberLE(hash.slice(B32, B32 * 2));
        const R2 = this.calcElligatorRistrettoMap(r2);
        return R1.add(R2);
    }
    static calcElligatorRistrettoMap(r0) {
        const { d } = CURVE;
        const r = mod(SQRT_M1 * r0 * r0);
        const Ns = mod((r + 1n) * ONE_MINUS_D_SQ);
        let c = -1n;
        const D = mod((c - d * r) * mod(r + d));
        let { isValid: Ns_D_is_sq, value: s } = uvRatio(Ns, D);
        let s_ = mod(s * r0);
        if (!edIsNegative(s_)) s_ = mod(-s_);
        if (!Ns_D_is_sq) s = s_;
        if (!Ns_D_is_sq) c = r;
        const Nt = mod(c * (r - 1n) * D_MINUS_ONE_SQ - D);
        const s2 = s * s;
        const W0 = mod((s + s) * D);
        const W1 = mod(Nt * SQRT_AD_MINUS_ONE);
        const W2 = mod(1n - s2);
        const W3 = mod(1n + s2);
        return new ExtendedPoint(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
    }
    static fromRistrettoBytes(bytes) {
        const { a, d } = CURVE;
        const emsg = "ExtendedPoint.fromRistrettoBytes: Cannot convert bytes to Ristretto Point";
        const s = bytes255ToNumberLE(bytes);
        if (!equalBytes(numberToBytesPadded(s, B32), bytes) || edIsNegative(s)) throw new Error(emsg);
        const s2 = mod(s * s);
        const u1 = mod(1n + a * s2);
        const u2 = mod(1n - a * s2);
        const u1_2 = mod(u1 * u1);
        const u2_2 = mod(u2 * u2);
        const v = mod(a * d * u1_2 - u2_2);
        const { isValid, value: I } = invertSqrt(mod(v * u2_2));
        const Dx = mod(I * u2);
        const Dy = mod(I * Dx * v);
        let x = mod((s + s) * Dx);
        if (edIsNegative(x)) x = mod(-x);
        const y = mod(u1 * Dy);
        const t = mod(x * y);
        if (!isValid || edIsNegative(t) || y === 0n) throw new Error(emsg);
        return new ExtendedPoint(x, y, 1n, t);
    }
    toRistrettoBytes() {
        let { x, y, z, t } = this;
        const u1 = mod((z + y) * (z - y));
        const u2 = mod(x * y);
        const { value: invsqrt } = invertSqrt(mod(u1 * u2 ** 2n));
        const D1 = mod(invsqrt * u1);
        const D2 = mod(invsqrt * u2);
        const zInv = mod(D1 * D2 * t);
        let D;
        if (edIsNegative(t * zInv)) {
            [x, y] = [
                mod(y * SQRT_M1),
                mod(x * SQRT_M1)
            ];
            D = mod(D1 * INVSQRT_A_MINUS_D);
        } else D = D2;
        if (edIsNegative(x * zInv)) y = mod(-y);
        let s = mod((z - y) * D);
        if (edIsNegative(s)) s = mod(-s);
        return numberToBytesPadded(s, B32);
    }
    equals(other) {
        const a = this;
        const b = other;
        const [T1, T2, Z1, Z2] = [
            a.t,
            b.t,
            a.z,
            b.z
        ];
        return mod(T1 * Z2) === mod(T2 * Z1);
    }
    negate() {
        return new ExtendedPoint(mod(-this.x), this.y, this.z, mod(-this.t));
    }
    double() {
        const X1 = this.x;
        const Y1 = this.y;
        const Z1 = this.z;
        const { a } = CURVE;
        const A = mod(X1 ** 2n);
        const B = mod(Y1 ** 2n);
        const C = mod(2n * Z1 ** 2n);
        const D = mod(a * A);
        const E = mod((X1 + Y1) ** 2n - A - B);
        const G = mod(D + B);
        const F = mod(G - C);
        const H = mod(D - B);
        const X3 = mod(E * F);
        const Y3 = mod(G * H);
        const T3 = mod(E * H);
        const Z3 = mod(F * G);
        return new ExtendedPoint(X3, Y3, Z3, T3);
    }
    add(other) {
        const X1 = this.x;
        const Y1 = this.y;
        const Z1 = this.z;
        const T1 = this.t;
        const X2 = other.x;
        const Y2 = other.y;
        const Z2 = other.z;
        const T2 = other.t;
        const A = mod((Y1 - X1) * (Y2 + X2));
        const B = mod((Y1 + X1) * (Y2 - X2));
        const F = mod(B - A);
        if (F === 0n) return this.double();
        const C = mod(Z1 * 2n * T2);
        const D = mod(T1 * 2n * Z2);
        const E = mod(D + C);
        const G = mod(B + A);
        const H = mod(D - C);
        const X3 = mod(E * F);
        const Y3 = mod(G * H);
        const T3 = mod(E * H);
        const Z3 = mod(F * G);
        return new ExtendedPoint(X3, Y3, Z3, T3);
    }
    subtract(other) {
        return this.add(other.negate());
    }
    multiplyUnsafe(scalar) {
        if (!isValidScalar(scalar)) throw new TypeError("Point#multiply: expected number or bigint");
        let n = mod(BigInt(scalar), CURVE.n);
        if (n === 1n) return this;
        let p = ExtendedPoint.ZERO;
        let d = this;
        while(n > 0n){
            if (n & 1n) p = p.add(d);
            d = d.double();
            n >>= 1n;
        }
        return p;
    }
    precomputeWindow(W) {
        const windows = 256 / W + 1;
        let points = [];
        let p = this;
        let base = p;
        for(let window = 0; window < windows; window++){
            base = p;
            points.push(base);
            for(let i = 1; i < 2 ** (W - 1); i++){
                base = base.add(p);
                points.push(base);
            }
            p = base.double();
        }
        return points;
    }
    wNAF(n, affinePoint) {
        if (!affinePoint && this.equals(ExtendedPoint.BASE)) affinePoint = Point.BASE;
        const W = affinePoint && affinePoint._WINDOW_SIZE || 1;
        if (256 % W) throw new Error("Point#wNAF: Invalid precomputation window, must be power of 2");
        let precomputes = affinePoint && pointPrecomputes.get(affinePoint);
        if (!precomputes) {
            precomputes = this.precomputeWindow(W);
            if (affinePoint && W !== 1) {
                precomputes = ExtendedPoint.normalizeZ(precomputes);
                pointPrecomputes.set(affinePoint, precomputes);
            }
        }
        let p = ExtendedPoint.ZERO;
        let f = ExtendedPoint.ZERO;
        const windows = 256 / W + 1;
        const windowSize = 2 ** (W - 1);
        const mask = BigInt(2 ** W - 1);
        const maxNumber = 2 ** W;
        const shiftBy = BigInt(W);
        for(let window = 0; window < windows; window++){
            const offset = window * windowSize;
            let wbits = Number(n & mask);
            n >>= shiftBy;
            if (wbits > windowSize) {
                wbits -= maxNumber;
                n += 1n;
            }
            if (wbits === 0) f = f.add(window % 2 ? precomputes[offset].negate() : precomputes[offset]);
            else {
                const cached = precomputes[offset + Math.abs(wbits) - 1];
                p = p.add(wbits < 0 ? cached.negate() : cached);
            }
        }
        return [
            p,
            f
        ];
    }
    multiply(scalar, affinePoint) {
        if (!isValidScalar(scalar)) throw new TypeError("Point#multiply: expected number or bigint");
        const n = mod(BigInt(scalar), CURVE.n);
        return ExtendedPoint.normalizeZ(this.wNAF(n, affinePoint))[0];
    }
    toAffine(invZ = invert(this.z)) {
        const x = mod(this.x * invZ);
        const y = mod(this.y * invZ);
        return new Point(x, y);
    }
}
exports.ExtendedPoint = ExtendedPoint;
ExtendedPoint.BASE = new ExtendedPoint(CURVE.Gx, CURVE.Gy, 1n, mod(CURVE.Gx * CURVE.Gy));
ExtendedPoint.ZERO = new ExtendedPoint(0n, 1n, 1n, 0n);
const pointPrecomputes = new WeakMap();
class Point {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    _setWindowSize(windowSize) {
        this._WINDOW_SIZE = windowSize;
        pointPrecomputes.delete(this);
    }
    static fromHex(hash) {
        const { d, P } = CURVE;
        const bytes = hash instanceof Uint8Array ? hash : hexToBytes(hash);
        if (bytes.length !== 32) throw new Error("Point.fromHex: expected 32 bytes");
        const last = bytes[31];
        const normedLast = last & -129;
        const isLastByteOdd = (last & 0x80) !== 0;
        const normed = Uint8Array.from(Array.from(bytes.slice(0, 31)).concat(normedLast));
        const y = bytesToNumberLE(normed);
        if (y >= P) throw new Error("Point.fromHex expects hex <= Fp");
        const y2 = mod(y * y);
        const u = mod(y2 - 1n);
        const v = mod(d * y2 + 1n);
        let { isValid, value: x } = uvRatio(u, v);
        if (!isValid) throw new Error("Point.fromHex: invalid y coordinate");
        const isXOdd = (x & 1n) === 1n;
        if (isLastByteOdd !== isXOdd) x = mod(-x);
        return new Point(x, y);
    }
    static async fromPrivateKey(privateKey) {
        const privBytes = await exports.utils.sha512(normalizePrivateKey(privateKey));
        return Point.BASE.multiply(encodePrivate(privBytes));
    }
    toRawBytes() {
        const hex = numberToHex(this.y);
        const u8 = new Uint8Array(B32);
        for(let i = hex.length - 2, j = 0; j < B32 && i >= 0; i -= 2, j++)u8[j] = Number.parseInt(hex[i] + hex[i + 1], 16);
        const mask = this.x & 1n ? 0x80 : 0;
        u8[B32 - 1] |= mask;
        return u8;
    }
    toHex() {
        return bytesToHex(this.toRawBytes());
    }
    toX25519() {
        return mod((1n + this.y) * invert(1n - this.y));
    }
    equals(other) {
        return this.x === other.x && this.y === other.y;
    }
    negate() {
        return new Point(mod(-this.x), this.y);
    }
    add(other) {
        return ExtendedPoint.fromAffine(this).add(ExtendedPoint.fromAffine(other)).toAffine();
    }
    subtract(other) {
        return this.add(other.negate());
    }
    multiply(scalar) {
        return ExtendedPoint.fromAffine(this).multiply(scalar, this).toAffine();
    }
}
exports.Point = Point;
Point.BASE = new Point(CURVE.Gx, CURVE.Gy);
Point.ZERO = new Point(0n, 1n);
class Signature {
    constructor(r, s){
        this.r = r;
        this.s = s;
    }
    static fromHex(hex) {
        hex = ensureBytes(hex);
        const r = Point.fromHex(hex.slice(0, 32));
        const s = bytesToNumberLE(hex.slice(32));
        if (!isWithinCurveOrder(s)) throw new Error("Signature.fromHex expects s <= CURVE.n");
        return new Signature(r, s);
    }
    toRawBytes() {
        const numberBytes = hexToBytes(numberToHex(this.s)).reverse();
        const sBytes = new Uint8Array(B32);
        sBytes.set(numberBytes);
        const res = new Uint8Array(B32 * 2);
        res.set(this.r.toRawBytes());
        res.set(sBytes, 32);
        return res;
    }
    toHex() {
        return bytesToHex(this.toRawBytes());
    }
}
exports.Signature = Signature;
exports.SignResult = Signature;
function concatBytes(...arrays) {
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
function bytesToHex(uint8a) {
    let hex = "";
    for(let i = 0; i < uint8a.length; i++)hex += uint8a[i].toString(16).padStart(2, "0");
    return hex;
}
function hexToBytes(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToBytes: expected string, got " + typeof hex);
    if (hex.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
    const array = new Uint8Array(hex.length / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        array[i] = Number.parseInt(hex.slice(j, j + 2), 16);
    }
    return array;
}
function numberToHex(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function numberToBytesPadded(num, length = B32) {
    const hex = numberToHex(num).padStart(length * 2, "0");
    return hexToBytes(hex).reverse();
}
function edIsNegative(num) {
    return (mod(num) & 1n) === 1n;
}
function isValidScalar(num) {
    if (typeof num === "bigint" && num > 0n) return true;
    if (typeof num === "number" && num > 0 && Number.isSafeInteger(num)) return true;
    return false;
}
function bytesToNumberLE(uint8a) {
    let value = 0n;
    for(let i = 0; i < uint8a.length; i++)value += BigInt(uint8a[i]) << 8n * BigInt(i);
    return value;
}
function bytes255ToNumberLE(bytes) {
    return mod(bytesToNumberLE(bytes) & 2n ** 255n - 1n);
}
function mod(a, b = CURVE.P) {
    const res = a % b;
    return res >= 0n ? res : b + res;
}
function invert(number, modulo = CURVE.P) {
    if (number === 0n || modulo <= 0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    let a = mod(number, modulo);
    let b = modulo;
    let [x, y, u, v] = [
        0n,
        1n,
        1n,
        0n
    ];
    while(a !== 0n){
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        [b, a] = [
            a,
            r
        ];
        [x, y] = [
            u,
            v
        ];
        [u, v] = [
            m,
            n
        ];
    }
    const gcd = b;
    if (gcd !== 1n) throw new Error("invert: does not exist");
    return mod(x, modulo);
}
function invertBatch(nums, n = CURVE.P) {
    const len = nums.length;
    const scratch = new Array(len);
    let acc = 1n;
    for(let i = 0; i < len; i++){
        if (nums[i] === 0n) continue;
        scratch[i] = acc;
        acc = mod(acc * nums[i], n);
    }
    acc = invert(acc, n);
    for(let i = len - 1; i >= 0; i--){
        if (nums[i] === 0n) continue;
        let tmp = mod(acc * nums[i], n);
        nums[i] = mod(acc * scratch[i], n);
        acc = tmp;
    }
    return nums;
}
function pow2(x, power) {
    const { P } = CURVE;
    let res = x;
    while(power-- > 0n){
        res *= res;
        res %= P;
    }
    return res;
}
function pow_2_252_3(x) {
    const { P } = CURVE;
    const x2 = x * x % P;
    const b2 = x2 * x % P;
    const b4 = pow2(b2, 2n) * b2 % P;
    const b5 = pow2(b4, 1n) * x % P;
    const b10 = pow2(b5, 5n) * b5 % P;
    const b20 = pow2(b10, 10n) * b10 % P;
    const b40 = pow2(b20, 20n) * b20 % P;
    const b80 = pow2(b40, 40n) * b40 % P;
    const b160 = pow2(b80, 80n) * b80 % P;
    const b240 = pow2(b160, 80n) * b80 % P;
    const b250 = pow2(b240, 10n) * b10 % P;
    const pow_p_5_8 = pow2(b250, 2n) * x % P;
    return pow_p_5_8;
}
function uvRatio(u, v) {
    const v3 = mod(v * v * v);
    const v7 = mod(v3 * v3 * v);
    let x = mod(u * v3 * pow_2_252_3(u * v7));
    const vx2 = mod(v * x * x);
    const root1 = x;
    const root2 = mod(x * SQRT_M1);
    const useRoot1 = vx2 === u;
    const useRoot2 = vx2 === mod(-u);
    const noRoot = vx2 === mod(-u * SQRT_M1);
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2;
    if (edIsNegative(x)) x = mod(-x);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
function invertSqrt(number) {
    return uvRatio(1n, number);
}
async function sha512ToNumberLE(...args) {
    const messageArray = concatBytes(...args);
    const hash = await exports.utils.sha512(messageArray);
    const value = bytesToNumberLE(hash);
    return mod(value, CURVE.n);
}
function keyPrefix(privateBytes) {
    return privateBytes.slice(B32);
}
function encodePrivate(privateBytes) {
    const last = B32 - 1;
    const head = privateBytes.slice(0, B32);
    head[0] &= 248;
    head[last] &= 127;
    head[last] |= 64;
    return mod(bytesToNumberLE(head), CURVE.n);
}
function equalBytes(b1, b2) {
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++){
        if (b1[i] !== b2[i]) return false;
    }
    return true;
}
function ensureBytes(hash) {
    return hash instanceof Uint8Array ? hash : hexToBytes(hash);
}
function isWithinCurveOrder(num) {
    return 0 < num && num < CURVE.n;
}
function normalizePrivateKey(key) {
    let num;
    if (typeof key === "bigint" || typeof key === "number" && Number.isSafeInteger(key)) {
        num = BigInt(key);
        if (num < 0n || num > 2n ** 256n) throw new Error("Expected 32 bytes of private key");
        key = num.toString(16).padStart(B32 * 2, "0");
    }
    if (typeof key === "string") {
        if (key.length !== 64) throw new Error("Expected 32 bytes of private key");
        return hexToBytes(key);
    } else if (key instanceof Uint8Array) {
        if (key.length !== 32) throw new Error("Expected 32 bytes of private key");
        return key;
    } else throw new TypeError("Expected valid private key");
}
async function getPublicKey(privateKey) {
    const key = await Point.fromPrivateKey(privateKey);
    return typeof privateKey === "string" ? key.toHex() : key.toRawBytes();
}
exports.getPublicKey = getPublicKey;
async function sign(hash, privateKey) {
    const privBytes = await exports.utils.sha512(normalizePrivateKey(privateKey));
    const p = encodePrivate(privBytes);
    const P = Point.BASE.multiply(p);
    const msg = ensureBytes(hash);
    const r = await sha512ToNumberLE(keyPrefix(privBytes), msg);
    const R = Point.BASE.multiply(r);
    const h = await sha512ToNumberLE(R.toRawBytes(), P.toRawBytes(), msg);
    const S = mod(r + h * p, CURVE.n);
    const sig = new Signature(R, S);
    return typeof hash === "string" ? sig.toHex() : sig.toRawBytes();
}
exports.sign = sign;
async function verify(signature, hash, publicKey) {
    hash = ensureBytes(hash);
    if (!(publicKey instanceof Point)) publicKey = Point.fromHex(publicKey);
    if (!(signature instanceof Signature)) signature = Signature.fromHex(signature);
    const hs = await sha512ToNumberLE(signature.r.toRawBytes(), publicKey.toRawBytes(), hash);
    const Ph = ExtendedPoint.fromAffine(publicKey).multiplyUnsafe(hs);
    const Gs = ExtendedPoint.BASE.multiply(signature.s);
    const RPh = ExtendedPoint.fromAffine(signature.r).add(Ph);
    return RPh.subtract(Gs).multiplyUnsafe(8n).equals(ExtendedPoint.ZERO);
}
exports.verify = verify;
Point.BASE._setWindowSize(8);
const crypto = (()=>{
    const webCrypto = typeof self === "object" && "crypto" in self ? self.crypto : undefined;
    const nodeRequire = typeof module.require === "function" && module.require.bind(module);
    return {
        node: nodeRequire && !webCrypto ? nodeRequire("crypto") : undefined,
        web: webCrypto
    };
})();
exports.utils = {
    TORSION_SUBGROUP: [
        "0100000000000000000000000000000000000000000000000000000000000000",
        "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
        "0000000000000000000000000000000000000000000000000000000000000080",
        "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
        "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
        "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
        "0000000000000000000000000000000000000000000000000000000000000000",
        "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
    ],
    randomBytes: (bytesLength = 32)=>{
        if (crypto.web) return crypto.web.getRandomValues(new Uint8Array(bytesLength));
        else if (crypto.node) {
            const { randomBytes } = crypto.node;
            return new Uint8Array(randomBytes(bytesLength).buffer);
        } else throw new Error("The environment doesn't have randomBytes function");
    },
    randomPrivateKey: ()=>{
        let i = 1024;
        while(i--){
            const b32 = exports.utils.randomBytes(32);
            const num = bytesToNumberLE(b32);
            if (num > 1n && num < CURVE.n) return b32;
        }
        throw new Error("Valid private key was not found in 1024 iterations. PRNG is broken");
    },
    sha512: async (message)=>{
        if (crypto.web) {
            const buffer = await crypto.web.subtle.digest("SHA-512", message.buffer);
            return new Uint8Array(buffer);
        } else if (crypto.node) return Uint8Array.from(crypto.node.createHash("sha512").update(message).digest());
        else throw new Error("The environment doesn't have sha512 function");
    },
    precompute (windowSize = 8, point = Point.BASE) {
        const cached = point.equals(Point.BASE) ? point : new Point(point.x, point.y);
        cached._setWindowSize(windowSize);
        cached.multiply(1n);
        return cached;
    }
};

});



parcelRequire.register("cVkJN", function(module, exports) {
"use strict";

var $gTOvd = parcelRequire("gTOvd");
var $968ae4f796793833$require$sha256 = $gTOvd.sha256;

var $20Lm5 = parcelRequire("20Lm5");

var $ijWXY = parcelRequire("ijWXY");
var $968ae4f796793833$require$uint8ArrayEquals = $ijWXY.equals;

var $6rBCs = parcelRequire("6rBCs");
var $968ae4f796793833$require$uint8ArrayToString = $6rBCs.toString;

var $jcqxm = parcelRequire("jcqxm");

module.exports = (keysProtobuf, randomBytes, crypto)=>{
    crypto = crypto || (parcelRequire("kzm8K"))();
    class Secp256k1PublicKey {
        constructor(key){
            crypto.validatePublicKey(key);
            this._key = key;
        }
        verify(data, sig) {
            return crypto.hashAndVerify(this._key, sig, data);
        }
        marshal() {
            return crypto.compressPublicKey(this._key);
        }
        get bytes() {
            return keysProtobuf.PublicKey.encode({
                Type: keysProtobuf.KeyType.Secp256k1,
                Data: this.marshal()
            }).finish();
        }
        equals(key) {
            return $968ae4f796793833$require$uint8ArrayEquals(this.bytes, key.bytes);
        }
        async hash() {
            const { bytes: bytes } = await $968ae4f796793833$require$sha256.digest(this.bytes);
            return bytes;
        }
    }
    class Secp256k1PrivateKey {
        constructor(key, publicKey){
            this._key = key;
            this._publicKey = publicKey || crypto.computePublicKey(key);
            crypto.validatePrivateKey(this._key);
            crypto.validatePublicKey(this._publicKey);
        }
        sign(message) {
            return crypto.hashAndSign(this._key, message);
        }
        get public() {
            return new Secp256k1PublicKey(this._publicKey);
        }
        marshal() {
            return this._key;
        }
        get bytes() {
            return keysProtobuf.PrivateKey.encode({
                Type: keysProtobuf.KeyType.Secp256k1,
                Data: this.marshal()
            }).finish();
        }
        equals(key) {
            return $968ae4f796793833$require$uint8ArrayEquals(this.bytes, key.bytes);
        }
        async hash() {
            const { bytes: bytes } = await $968ae4f796793833$require$sha256.digest(this.bytes);
            return bytes;
        }
        /**
     * Gets the ID of the key.
     *
     * The key id is the base58 encoding of the SHA-256 multihash of its public key.
     * The public key is a protobuf encoding containing a type and the DER encoding
     * of the PKCS SubjectPublicKeyInfo.
     *
     * @returns {Promise<string>}
     */ async id() {
            const hash = await this.public.hash();
            return $968ae4f796793833$require$uint8ArrayToString(hash, "base58btc");
        }
        /**
     * Exports the key into a password protected `format`
     *
     * @param {string} password - The password to encrypt the key
     * @param {string} [format=libp2p-key] - The format in which to export as
     * @returns {Promise<string>} The encrypted private key
     */ async export(password, format = "libp2p-key") {
            if (format === "libp2p-key") return $jcqxm.export(this.bytes, password);
            else throw $20Lm5(new Error(`export format '${format}' is not supported`), "ERR_INVALID_EXPORT_FORMAT");
        }
    }
    function unmarshalSecp256k1PrivateKey(bytes) {
        return new Secp256k1PrivateKey(bytes);
    }
    function unmarshalSecp256k1PublicKey(bytes) {
        return new Secp256k1PublicKey(bytes);
    }
    async function generateKeyPair() {
        const privateKeyBytes = await crypto.generateKey();
        return new Secp256k1PrivateKey(privateKeyBytes);
    }
    return {
        Secp256k1PublicKey: Secp256k1PublicKey,
        Secp256k1PrivateKey: Secp256k1PrivateKey,
        unmarshalSecp256k1PrivateKey: unmarshalSecp256k1PrivateKey,
        unmarshalSecp256k1PublicKey: unmarshalSecp256k1PublicKey,
        generateKeyPair: generateKeyPair
    };
};

});
parcelRequire.register("kzm8K", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $hDzBj = parcelRequire("hDzBj");

var $gTOvd = parcelRequire("gTOvd");
var $ef9840157b5698fa$require$sha256 = $gTOvd.sha256;
module.exports = ()=>{
    const privateKeyLength = 32;
    function generateKey() {
        return $hDzBj.utils.randomPrivateKey();
    }
    /**
   * Hash and sign message with private key
   *
   * @param {number | bigint | (string | Uint8Array)} key
   * @param {Uint8Array} msg
   */ async function hashAndSign(key, msg) {
        const { digest: digest } = await $ef9840157b5698fa$require$sha256.digest(msg);
        try {
            return await $hDzBj.sign(digest, key);
        } catch (err) {
            throw $20Lm5(err, "ERR_INVALID_INPUT");
        }
    }
    /**
   * Hash message and verify signature with public key
   *
   * @param {secp.Point | (string | Uint8Array)} key
   * @param {(string | Uint8Array) | secp.Signature} sig
   * @param {Uint8Array} msg
   */ async function hashAndVerify(key, sig, msg) {
        try {
            const { digest: digest } = await $ef9840157b5698fa$require$sha256.digest(msg);
            return $hDzBj.verify(sig, digest, key);
        } catch (err) {
            throw $20Lm5(err, "ERR_INVALID_INPUT");
        }
    }
    function compressPublicKey(key) {
        const point = $hDzBj.Point.fromHex(key).toRawBytes(true);
        return point;
    }
    function decompressPublicKey(key) {
        const point = $hDzBj.Point.fromHex(key).toRawBytes(false);
        return point;
    }
    function validatePrivateKey(key) {
        try {
            $hDzBj.getPublicKey(key, true);
        } catch (err) {
            throw $20Lm5(err, "ERR_INVALID_PRIVATE_KEY");
        }
    }
    function validatePublicKey(key) {
        try {
            $hDzBj.Point.fromHex(key);
        } catch (err) {
            throw $20Lm5(err, "ERR_INVALID_PUBLIC_KEY");
        }
    }
    function computePublicKey(privateKey) {
        try {
            return $hDzBj.getPublicKey(privateKey, true);
        } catch (err) {
            throw $20Lm5(err, "ERR_INVALID_PRIVATE_KEY");
        }
    }
    return {
        generateKey: generateKey,
        privateKeyLength: privateKeyLength,
        hashAndSign: hashAndSign,
        hashAndVerify: hashAndVerify,
        compressPublicKey: compressPublicKey,
        decompressPublicKey: decompressPublicKey,
        validatePrivateKey: validatePrivateKey,
        validatePublicKey: validatePublicKey,
        computePublicKey: computePublicKey
    };
};

});
parcelRequire.register("hDzBj", function(module, exports) {
"use strict";
/*! noble-secp256k1 - MIT License (c) Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utils = module.exports.schnorr = module.exports.verify = module.exports.signSync = module.exports.sign = module.exports.getSharedSecret = module.exports.recoverPublicKey = module.exports.getPublicKey = module.exports.SignResult = module.exports.Signature = module.exports.Point = module.exports.CURVE = void 0;
const $cd71b1c8a870839d$var$CURVE = {
    a: 0n,
    b: 7n,
    P: 2n ** 256n - 2n ** 32n - 977n,
    n: 2n ** 256n - 432420386565659656852420866394968145599n,
    h: 1n,
    Gx: 55066263022277343669578718895168534326250603453777594175500187360389116729240n,
    Gy: 32670510020758816978083085130507043184471273380659243275938904335757337482424n,
    beta: 0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501een
};
module.exports.CURVE = $cd71b1c8a870839d$var$CURVE;
function $cd71b1c8a870839d$var$weistrass(x) {
    const { a: a, b: b } = $cd71b1c8a870839d$var$CURVE;
    return $cd71b1c8a870839d$var$mod(x ** 3n + a * x + b);
}
const $cd71b1c8a870839d$var$USE_ENDOMORPHISM = $cd71b1c8a870839d$var$CURVE.a === 0n;
class $cd71b1c8a870839d$var$JacobianPoint {
    constructor(x, y, z){
        this.x = x;
        this.y = y;
        this.z = z;
    }
    static fromAffine(p) {
        if (!(p instanceof $cd71b1c8a870839d$var$Point)) throw new TypeError("JacobianPoint#fromAffine: expected Point");
        return new $cd71b1c8a870839d$var$JacobianPoint(p.x, p.y, 1n);
    }
    static toAffineBatch(points) {
        const toInv = $cd71b1c8a870839d$var$invertBatch(points.map((p)=>p.z));
        return points.map((p, i)=>p.toAffine(toInv[i]));
    }
    static normalizeZ(points) {
        return $cd71b1c8a870839d$var$JacobianPoint.toAffineBatch(points).map($cd71b1c8a870839d$var$JacobianPoint.fromAffine);
    }
    equals(other) {
        const a = this;
        const b = other;
        const az2 = $cd71b1c8a870839d$var$mod(a.z * a.z);
        const az3 = $cd71b1c8a870839d$var$mod(a.z * az2);
        const bz2 = $cd71b1c8a870839d$var$mod(b.z * b.z);
        const bz3 = $cd71b1c8a870839d$var$mod(b.z * bz2);
        return $cd71b1c8a870839d$var$mod(a.x * bz2) === $cd71b1c8a870839d$var$mod(az2 * b.x) && $cd71b1c8a870839d$var$mod(a.y * bz3) === $cd71b1c8a870839d$var$mod(az3 * b.y);
    }
    negate() {
        return new $cd71b1c8a870839d$var$JacobianPoint(this.x, $cd71b1c8a870839d$var$mod(-this.y), this.z);
    }
    double() {
        const X1 = this.x;
        const Y1 = this.y;
        const Z1 = this.z;
        const A = $cd71b1c8a870839d$var$mod(X1 ** 2n);
        const B = $cd71b1c8a870839d$var$mod(Y1 ** 2n);
        const C = $cd71b1c8a870839d$var$mod(B ** 2n);
        const D = $cd71b1c8a870839d$var$mod(2n * ($cd71b1c8a870839d$var$mod($cd71b1c8a870839d$var$mod((X1 + B) ** 2n)) - A - C));
        const E = $cd71b1c8a870839d$var$mod(3n * A);
        const F = $cd71b1c8a870839d$var$mod(E ** 2n);
        const X3 = $cd71b1c8a870839d$var$mod(F - 2n * D);
        const Y3 = $cd71b1c8a870839d$var$mod(E * (D - X3) - 8n * C);
        const Z3 = $cd71b1c8a870839d$var$mod(2n * Y1 * Z1);
        return new $cd71b1c8a870839d$var$JacobianPoint(X3, Y3, Z3);
    }
    add(other) {
        if (!(other instanceof $cd71b1c8a870839d$var$JacobianPoint)) throw new TypeError("JacobianPoint#add: expected JacobianPoint");
        const X1 = this.x;
        const Y1 = this.y;
        const Z1 = this.z;
        const X2 = other.x;
        const Y2 = other.y;
        const Z2 = other.z;
        if (X2 === 0n || Y2 === 0n) return this;
        if (X1 === 0n || Y1 === 0n) return other;
        const Z1Z1 = $cd71b1c8a870839d$var$mod(Z1 ** 2n);
        const Z2Z2 = $cd71b1c8a870839d$var$mod(Z2 ** 2n);
        const U1 = $cd71b1c8a870839d$var$mod(X1 * Z2Z2);
        const U2 = $cd71b1c8a870839d$var$mod(X2 * Z1Z1);
        const S1 = $cd71b1c8a870839d$var$mod(Y1 * Z2 * Z2Z2);
        const S2 = $cd71b1c8a870839d$var$mod($cd71b1c8a870839d$var$mod(Y2 * Z1) * Z1Z1);
        const H = $cd71b1c8a870839d$var$mod(U2 - U1);
        const r = $cd71b1c8a870839d$var$mod(S2 - S1);
        if (H === 0n) {
            if (r === 0n) return this.double();
            else return $cd71b1c8a870839d$var$JacobianPoint.ZERO;
        }
        const HH = $cd71b1c8a870839d$var$mod(H ** 2n);
        const HHH = $cd71b1c8a870839d$var$mod(H * HH);
        const V = $cd71b1c8a870839d$var$mod(U1 * HH);
        const X3 = $cd71b1c8a870839d$var$mod(r ** 2n - HHH - 2n * V);
        const Y3 = $cd71b1c8a870839d$var$mod(r * (V - X3) - S1 * HHH);
        const Z3 = $cd71b1c8a870839d$var$mod(Z1 * Z2 * H);
        return new $cd71b1c8a870839d$var$JacobianPoint(X3, Y3, Z3);
    }
    subtract(other) {
        return this.add(other.negate());
    }
    multiplyUnsafe(scalar) {
        if (!$cd71b1c8a870839d$var$isValidScalar(scalar)) throw new TypeError("Point#multiply: expected valid scalar");
        let n = $cd71b1c8a870839d$var$mod(BigInt(scalar), $cd71b1c8a870839d$var$CURVE.n);
        if (!$cd71b1c8a870839d$var$USE_ENDOMORPHISM) {
            let p = $cd71b1c8a870839d$var$JacobianPoint.ZERO;
            let d = this;
            while(n > 0n){
                if (n & 1n) p = p.add(d);
                d = d.double();
                n >>= 1n;
            }
            return p;
        }
        let [k1neg, k1, k2neg, k2] = $cd71b1c8a870839d$var$splitScalarEndo(n);
        let k1p = $cd71b1c8a870839d$var$JacobianPoint.ZERO;
        let k2p = $cd71b1c8a870839d$var$JacobianPoint.ZERO;
        let d = this;
        while(k1 > 0n || k2 > 0n){
            if (k1 & 1n) k1p = k1p.add(d);
            if (k2 & 1n) k2p = k2p.add(d);
            d = d.double();
            k1 >>= 1n;
            k2 >>= 1n;
        }
        if (k1neg) k1p = k1p.negate();
        if (k2neg) k2p = k2p.negate();
        k2p = new $cd71b1c8a870839d$var$JacobianPoint($cd71b1c8a870839d$var$mod(k2p.x * $cd71b1c8a870839d$var$CURVE.beta), k2p.y, k2p.z);
        return k1p.add(k2p);
    }
    precomputeWindow(W) {
        const windows = $cd71b1c8a870839d$var$USE_ENDOMORPHISM ? 128 / W + 1 : 256 / W + 1;
        let points = [];
        let p = this;
        let base = p;
        for(let window = 0; window < windows; window++){
            base = p;
            points.push(base);
            for(let i = 1; i < 2 ** (W - 1); i++){
                base = base.add(p);
                points.push(base);
            }
            p = base.double();
        }
        return points;
    }
    wNAF(n, affinePoint) {
        if (!affinePoint && this.equals($cd71b1c8a870839d$var$JacobianPoint.BASE)) affinePoint = $cd71b1c8a870839d$var$Point.BASE;
        const W = affinePoint && affinePoint._WINDOW_SIZE || 1;
        if (256 % W) throw new Error("Point#wNAF: Invalid precomputation window, must be power of 2");
        let precomputes = affinePoint && $cd71b1c8a870839d$var$pointPrecomputes.get(affinePoint);
        if (!precomputes) {
            precomputes = this.precomputeWindow(W);
            if (affinePoint && W !== 1) {
                precomputes = $cd71b1c8a870839d$var$JacobianPoint.normalizeZ(precomputes);
                $cd71b1c8a870839d$var$pointPrecomputes.set(affinePoint, precomputes);
            }
        }
        let p = $cd71b1c8a870839d$var$JacobianPoint.ZERO;
        let f = $cd71b1c8a870839d$var$JacobianPoint.ZERO;
        const windows = $cd71b1c8a870839d$var$USE_ENDOMORPHISM ? 128 / W + 1 : 256 / W + 1;
        const windowSize = 2 ** (W - 1);
        const mask = BigInt(2 ** W - 1);
        const maxNumber = 2 ** W;
        const shiftBy = BigInt(W);
        for(let window = 0; window < windows; window++){
            const offset = window * windowSize;
            let wbits = Number(n & mask);
            n >>= shiftBy;
            if (wbits > windowSize) {
                wbits -= maxNumber;
                n += 1n;
            }
            if (wbits === 0) f = f.add(window % 2 ? precomputes[offset].negate() : precomputes[offset]);
            else {
                const cached = precomputes[offset + Math.abs(wbits) - 1];
                p = p.add(wbits < 0 ? cached.negate() : cached);
            }
        }
        return [
            p,
            f
        ];
    }
    multiply(scalar, affinePoint) {
        if (!$cd71b1c8a870839d$var$isValidScalar(scalar)) throw new TypeError("Point#multiply: expected valid scalar");
        let n = $cd71b1c8a870839d$var$mod(BigInt(scalar), $cd71b1c8a870839d$var$CURVE.n);
        let point;
        let fake;
        if ($cd71b1c8a870839d$var$USE_ENDOMORPHISM) {
            const [k1neg, k1, k2neg, k2] = $cd71b1c8a870839d$var$splitScalarEndo(n);
            let k1p, k2p, f1p, f2p;
            [k1p, f1p] = this.wNAF(k1, affinePoint);
            [k2p, f2p] = this.wNAF(k2, affinePoint);
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new $cd71b1c8a870839d$var$JacobianPoint($cd71b1c8a870839d$var$mod(k2p.x * $cd71b1c8a870839d$var$CURVE.beta), k2p.y, k2p.z);
            [point, fake] = [
                k1p.add(k2p),
                f1p.add(f2p)
            ];
        } else [point, fake] = this.wNAF(n, affinePoint);
        return $cd71b1c8a870839d$var$JacobianPoint.normalizeZ([
            point,
            fake
        ])[0];
    }
    toAffine(invZ = $cd71b1c8a870839d$var$invert(this.z)) {
        const invZ2 = invZ ** 2n;
        const x = $cd71b1c8a870839d$var$mod(this.x * invZ2);
        const y = $cd71b1c8a870839d$var$mod(this.y * invZ2 * invZ);
        return new $cd71b1c8a870839d$var$Point(x, y);
    }
}
$cd71b1c8a870839d$var$JacobianPoint.BASE = new $cd71b1c8a870839d$var$JacobianPoint($cd71b1c8a870839d$var$CURVE.Gx, $cd71b1c8a870839d$var$CURVE.Gy, 1n);
$cd71b1c8a870839d$var$JacobianPoint.ZERO = new $cd71b1c8a870839d$var$JacobianPoint(0n, 1n, 0n);
const $cd71b1c8a870839d$var$pointPrecomputes = new WeakMap();
class $cd71b1c8a870839d$var$Point {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    _setWindowSize(windowSize) {
        this._WINDOW_SIZE = windowSize;
        $cd71b1c8a870839d$var$pointPrecomputes.delete(this);
    }
    static fromCompressedHex(bytes) {
        const isShort = bytes.length === 32;
        const x = $cd71b1c8a870839d$var$bytesToNumber(isShort ? bytes : bytes.slice(1));
        const y2 = $cd71b1c8a870839d$var$weistrass(x);
        let y = $cd71b1c8a870839d$var$sqrtMod(y2);
        const isYOdd = (y & 1n) === 1n;
        if (isShort) {
            if (isYOdd) y = $cd71b1c8a870839d$var$mod(-y);
        } else {
            const isFirstByteOdd = (bytes[0] & 1) === 1;
            if (isFirstByteOdd !== isYOdd) y = $cd71b1c8a870839d$var$mod(-y);
        }
        const point = new $cd71b1c8a870839d$var$Point(x, y);
        point.assertValidity();
        return point;
    }
    static fromUncompressedHex(bytes) {
        const x = $cd71b1c8a870839d$var$bytesToNumber(bytes.slice(1, 33));
        const y = $cd71b1c8a870839d$var$bytesToNumber(bytes.slice(33));
        const point = new $cd71b1c8a870839d$var$Point(x, y);
        point.assertValidity();
        return point;
    }
    static fromHex(hex) {
        const bytes = $cd71b1c8a870839d$var$ensureBytes(hex);
        const header = bytes[0];
        if (bytes.length === 32 || bytes.length === 33 && (header === 0x02 || header === 0x03)) return this.fromCompressedHex(bytes);
        if (bytes.length === 65 && header === 0x04) return this.fromUncompressedHex(bytes);
        throw new Error(`Point.fromHex: received invalid point. Expected 32-33 compressed bytes or 65 uncompressed bytes, not ${bytes.length}`);
    }
    static fromPrivateKey(privateKey) {
        return $cd71b1c8a870839d$var$Point.BASE.multiply($cd71b1c8a870839d$var$normalizePrivateKey(privateKey));
    }
    static fromSignature(msgHash, signature, recovery) {
        let h = msgHash instanceof Uint8Array ? $cd71b1c8a870839d$var$bytesToNumber(msgHash) : $cd71b1c8a870839d$var$hexToNumber(msgHash);
        const sig = $cd71b1c8a870839d$var$normalizeSignature(signature);
        const { r: r, s: s } = sig;
        if (recovery !== 0 && recovery !== 1) throw new Error("Cannot recover signature: invalid yParity bit");
        const prefix = 2 + (recovery & 1);
        const P_ = $cd71b1c8a870839d$var$Point.fromHex(`0${prefix}${$cd71b1c8a870839d$var$pad64(r)}`);
        const sP = $cd71b1c8a870839d$var$JacobianPoint.fromAffine(P_).multiplyUnsafe(s);
        const hG = $cd71b1c8a870839d$var$JacobianPoint.BASE.multiply(h);
        const rinv = $cd71b1c8a870839d$var$invert(r, $cd71b1c8a870839d$var$CURVE.n);
        const Q = sP.subtract(hG).multiplyUnsafe(rinv);
        const point = Q.toAffine();
        point.assertValidity();
        return point;
    }
    toRawBytes(isCompressed = false) {
        return $cd71b1c8a870839d$var$hexToBytes(this.toHex(isCompressed));
    }
    toHex(isCompressed = false) {
        const x = $cd71b1c8a870839d$var$pad64(this.x);
        if (isCompressed) return `${this.y & 1n ? "03" : "02"}${x}`;
        else return `04${x}${$cd71b1c8a870839d$var$pad64(this.y)}`;
    }
    toHexX() {
        return this.toHex(true).slice(2);
    }
    toRawX() {
        return this.toRawBytes(true).slice(1);
    }
    assertValidity() {
        const msg = "Point is not on elliptic curve";
        const { P: P } = $cd71b1c8a870839d$var$CURVE;
        const { x: x, y: y } = this;
        if (x === 0n || y === 0n || x >= P || y >= P) throw new Error(msg);
        const left = $cd71b1c8a870839d$var$mod(y * y);
        const right = $cd71b1c8a870839d$var$weistrass(x);
        if ((left - right) % P !== 0n) throw new Error(msg);
    }
    equals(other) {
        return this.x === other.x && this.y === other.y;
    }
    negate() {
        return new $cd71b1c8a870839d$var$Point(this.x, $cd71b1c8a870839d$var$mod(-this.y));
    }
    double() {
        return $cd71b1c8a870839d$var$JacobianPoint.fromAffine(this).double().toAffine();
    }
    add(other) {
        return $cd71b1c8a870839d$var$JacobianPoint.fromAffine(this).add($cd71b1c8a870839d$var$JacobianPoint.fromAffine(other)).toAffine();
    }
    subtract(other) {
        return this.add(other.negate());
    }
    multiply(scalar) {
        return $cd71b1c8a870839d$var$JacobianPoint.fromAffine(this).multiply(scalar, this).toAffine();
    }
}
module.exports.Point = $cd71b1c8a870839d$var$Point;
$cd71b1c8a870839d$var$Point.BASE = new $cd71b1c8a870839d$var$Point($cd71b1c8a870839d$var$CURVE.Gx, $cd71b1c8a870839d$var$CURVE.Gy);
$cd71b1c8a870839d$var$Point.ZERO = new $cd71b1c8a870839d$var$Point(0n, 0n);
function $cd71b1c8a870839d$var$sliceDer(s) {
    return Number.parseInt(s[0], 16) >= 8 ? "00" + s : s;
}
class $cd71b1c8a870839d$var$Signature {
    constructor(r, s){
        this.r = r;
        this.s = s;
    }
    static fromCompact(hex) {
        if (typeof hex !== "string" && !(hex instanceof Uint8Array)) throw new TypeError(`Signature.fromCompact: Expected string or Uint8Array`);
        const str = hex instanceof Uint8Array ? $cd71b1c8a870839d$var$bytesToHex(hex) : hex;
        if (str.length !== 128) throw new Error("Signature.fromCompact: Expected 64-byte hex");
        const sig = new $cd71b1c8a870839d$var$Signature($cd71b1c8a870839d$var$hexToNumber(str.slice(0, 64)), $cd71b1c8a870839d$var$hexToNumber(str.slice(64, 128)));
        sig.assertValidity();
        return sig;
    }
    static fromDER(hex) {
        const fn = "Signature.fromDER";
        if (typeof hex !== "string" && !(hex instanceof Uint8Array)) throw new TypeError(`${fn}: Expected string or Uint8Array`);
        const str = hex instanceof Uint8Array ? $cd71b1c8a870839d$var$bytesToHex(hex) : hex;
        const length = $cd71b1c8a870839d$var$parseByte(str.slice(2, 4));
        if (str.slice(0, 2) !== "30" || length !== str.length - 4 || str.slice(4, 6) !== "02") throw new Error(`${fn}: Invalid signature ${str}`);
        const rLen = $cd71b1c8a870839d$var$parseByte(str.slice(6, 8));
        const rEnd = 8 + rLen;
        const rr = str.slice(8, rEnd);
        if (rr.startsWith("00") && $cd71b1c8a870839d$var$parseByte(rr.slice(2, 4)) <= 0x7f) throw new Error(`${fn}: Invalid r with trailing length`);
        const r = $cd71b1c8a870839d$var$hexToNumber(rr);
        const separator = str.slice(rEnd, rEnd + 2);
        if (separator !== "02") throw new Error(`${fn}: Invalid r-s separator`);
        const sLen = $cd71b1c8a870839d$var$parseByte(str.slice(rEnd + 2, rEnd + 4));
        const diff = length - sLen - rLen - 10;
        if (diff > 0 || diff === -4) throw new Error(`${fn}: Invalid total length`);
        if (sLen > length - rLen - 4) throw new Error(`${fn}: Invalid s`);
        const sStart = rEnd + 4;
        const ss = str.slice(sStart, sStart + sLen);
        if (ss.startsWith("00") && $cd71b1c8a870839d$var$parseByte(ss.slice(2, 4)) <= 0x7f) throw new Error(`${fn}: Invalid s with trailing length`);
        const s = $cd71b1c8a870839d$var$hexToNumber(ss);
        const sig = new $cd71b1c8a870839d$var$Signature(r, s);
        sig.assertValidity();
        return sig;
    }
    static fromHex(hex) {
        return this.fromDER(hex);
    }
    assertValidity() {
        const { r: r, s: s } = this;
        if (!$cd71b1c8a870839d$var$isWithinCurveOrder(r)) throw new Error("Invalid Signature: r must be 0 < r < n");
        if (!$cd71b1c8a870839d$var$isWithinCurveOrder(s)) throw new Error("Invalid Signature: s must be 0 < s < n");
    }
    toDERRawBytes(isCompressed = false) {
        return $cd71b1c8a870839d$var$hexToBytes(this.toDERHex(isCompressed));
    }
    toDERHex(isCompressed = false) {
        const sHex = $cd71b1c8a870839d$var$sliceDer($cd71b1c8a870839d$var$numberToHex(this.s));
        if (isCompressed) return sHex;
        const rHex = $cd71b1c8a870839d$var$sliceDer($cd71b1c8a870839d$var$numberToHex(this.r));
        const rLen = $cd71b1c8a870839d$var$numberToHex(rHex.length / 2);
        const sLen = $cd71b1c8a870839d$var$numberToHex(sHex.length / 2);
        const length = $cd71b1c8a870839d$var$numberToHex(rHex.length / 2 + sHex.length / 2 + 4);
        return `30${length}02${rLen}${rHex}02${sLen}${sHex}`;
    }
    toRawBytes() {
        return this.toDERRawBytes();
    }
    toHex() {
        return this.toDERHex();
    }
    toCompactRawBytes() {
        return $cd71b1c8a870839d$var$hexToBytes(this.toCompactHex());
    }
    toCompactHex() {
        return $cd71b1c8a870839d$var$pad64(this.r) + $cd71b1c8a870839d$var$pad64(this.s);
    }
}
module.exports.Signature = $cd71b1c8a870839d$var$Signature;
module.exports.SignResult = $cd71b1c8a870839d$var$Signature;
function $cd71b1c8a870839d$var$concatBytes(...arrays) {
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
function $cd71b1c8a870839d$var$bytesToHex(uint8a) {
    let hex = "";
    for(let i = 0; i < uint8a.length; i++)hex += uint8a[i].toString(16).padStart(2, "0");
    return hex;
}
function $cd71b1c8a870839d$var$pad64(num) {
    return num.toString(16).padStart(64, "0");
}
function $cd71b1c8a870839d$var$pad32b(num) {
    return $cd71b1c8a870839d$var$hexToBytes($cd71b1c8a870839d$var$pad64(num));
}
function $cd71b1c8a870839d$var$numberToHex(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function $cd71b1c8a870839d$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToNumber: expected string, got " + typeof hex);
    return BigInt(`0x${hex}`);
}
function $cd71b1c8a870839d$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToBytes: expected string, got " + typeof hex);
    if (hex.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
    const array = new Uint8Array(hex.length / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        array[i] = Number.parseInt(hex.slice(j, j + 2), 16);
    }
    return array;
}
function $cd71b1c8a870839d$var$ensureBytes(hex) {
    return hex instanceof Uint8Array ? hex : $cd71b1c8a870839d$var$hexToBytes(hex);
}
function $cd71b1c8a870839d$var$bytesToNumber(bytes) {
    return $cd71b1c8a870839d$var$hexToNumber($cd71b1c8a870839d$var$bytesToHex(bytes));
}
function $cd71b1c8a870839d$var$parseByte(str) {
    return Number.parseInt(str, 16) * 2;
}
function $cd71b1c8a870839d$var$isValidScalar(num) {
    if (typeof num === "bigint" && num > 0n) return true;
    if (typeof num === "number" && num > 0 && Number.isSafeInteger(num)) return true;
    return false;
}
function $cd71b1c8a870839d$var$mod(a, b = $cd71b1c8a870839d$var$CURVE.P) {
    const result = a % b;
    return result >= 0 ? result : b + result;
}
function $cd71b1c8a870839d$var$pow2(x, power) {
    const { P: P } = $cd71b1c8a870839d$var$CURVE;
    let res = x;
    while(power-- > 0n){
        res *= res;
        res %= P;
    }
    return res;
}
function $cd71b1c8a870839d$var$sqrtMod(x) {
    const { P: P } = $cd71b1c8a870839d$var$CURVE;
    const b2 = x * x * x % P;
    const b3 = b2 * b2 * x % P;
    const b6 = $cd71b1c8a870839d$var$pow2(b3, 3n) * b3 % P;
    const b9 = $cd71b1c8a870839d$var$pow2(b6, 3n) * b3 % P;
    const b11 = $cd71b1c8a870839d$var$pow2(b9, 2n) * b2 % P;
    const b22 = $cd71b1c8a870839d$var$pow2(b11, 11n) * b11 % P;
    const b44 = $cd71b1c8a870839d$var$pow2(b22, 22n) * b22 % P;
    const b88 = $cd71b1c8a870839d$var$pow2(b44, 44n) * b44 % P;
    const b176 = $cd71b1c8a870839d$var$pow2(b88, 88n) * b88 % P;
    const b220 = $cd71b1c8a870839d$var$pow2(b176, 44n) * b44 % P;
    const b223 = $cd71b1c8a870839d$var$pow2(b220, 3n) * b3 % P;
    const t1 = $cd71b1c8a870839d$var$pow2(b223, 23n) * b22 % P;
    const t2 = $cd71b1c8a870839d$var$pow2(t1, 6n) * b2 % P;
    return $cd71b1c8a870839d$var$pow2(t2, 2n);
}
function $cd71b1c8a870839d$var$invert(number, modulo = $cd71b1c8a870839d$var$CURVE.P) {
    if (number === 0n || modulo <= 0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    let a = $cd71b1c8a870839d$var$mod(number, modulo);
    let b = modulo;
    let [x, y, u, v] = [
        0n,
        1n,
        1n,
        0n
    ];
    while(a !== 0n){
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        [b, a] = [
            a,
            r
        ];
        [x, y] = [
            u,
            v
        ];
        [u, v] = [
            m,
            n
        ];
    }
    const gcd = b;
    if (gcd !== 1n) throw new Error("invert: does not exist");
    return $cd71b1c8a870839d$var$mod(x, modulo);
}
function $cd71b1c8a870839d$var$invertBatch(nums, n = $cd71b1c8a870839d$var$CURVE.P) {
    const len = nums.length;
    const scratch = new Array(len);
    let acc = 1n;
    for(let i = 0; i < len; i++){
        if (nums[i] === 0n) continue;
        scratch[i] = acc;
        acc = $cd71b1c8a870839d$var$mod(acc * nums[i], n);
    }
    acc = $cd71b1c8a870839d$var$invert(acc, n);
    for(let i = len - 1; i >= 0; i--){
        if (nums[i] === 0n) continue;
        const tmp = $cd71b1c8a870839d$var$mod(acc * nums[i], n);
        nums[i] = $cd71b1c8a870839d$var$mod(acc * scratch[i], n);
        acc = tmp;
    }
    return nums;
}
const $cd71b1c8a870839d$var$divNearest = (a, b)=>(a + b / 2n) / b;
const $cd71b1c8a870839d$var$POW_2_128 = 2n ** 128n;
function $cd71b1c8a870839d$var$splitScalarEndo(k) {
    const { n: n } = $cd71b1c8a870839d$var$CURVE;
    const a1 = 0x3086d221a7d46bcde86c90e49284eb15n;
    const b1 = -0xe4437ed6010e88286f547fa90abfe4c3n;
    const a2 = 0x114ca50f7a8e2f3f657c1108d9d44cfd8n;
    const b2 = a1;
    const c1 = $cd71b1c8a870839d$var$divNearest(b2 * k, n);
    const c2 = $cd71b1c8a870839d$var$divNearest(-b1 * k, n);
    let k1 = $cd71b1c8a870839d$var$mod(k - c1 * a1 - c2 * a2, n);
    let k2 = $cd71b1c8a870839d$var$mod(-c1 * b1 - c2 * b2, n);
    const k1neg = k1 > $cd71b1c8a870839d$var$POW_2_128;
    const k2neg = k2 > $cd71b1c8a870839d$var$POW_2_128;
    if (k1neg) k1 = n - k1;
    if (k2neg) k2 = n - k2;
    if (k1 > $cd71b1c8a870839d$var$POW_2_128 || k2 > $cd71b1c8a870839d$var$POW_2_128) throw new Error("splitScalarEndo: Endomorphism failed");
    return [
        k1neg,
        k1,
        k2neg,
        k2
    ];
}
function $cd71b1c8a870839d$var$truncateHash(hash) {
    if (typeof hash !== "string") hash = $cd71b1c8a870839d$var$bytesToHex(hash);
    let msg = $cd71b1c8a870839d$var$hexToNumber(hash || "0");
    const byteLength = hash.length / 2;
    const delta = byteLength * 8 - 256;
    if (delta > 0) msg = msg >> BigInt(delta);
    if (msg >= $cd71b1c8a870839d$var$CURVE.n) msg -= $cd71b1c8a870839d$var$CURVE.n;
    return msg;
}
function $cd71b1c8a870839d$var$_abc6979(msgHash, privateKey) {
    if (msgHash == null) throw new Error(`sign: expected valid msgHash, not "${msgHash}"`);
    const num = typeof msgHash === "string" ? $cd71b1c8a870839d$var$hexToNumber(msgHash) : $cd71b1c8a870839d$var$bytesToNumber(msgHash);
    const h1 = $cd71b1c8a870839d$var$pad32b(num);
    const h1n = $cd71b1c8a870839d$var$bytesToNumber(h1);
    const x = $cd71b1c8a870839d$var$pad32b(privateKey);
    let v = new Uint8Array(32).fill(1);
    let k = new Uint8Array(32).fill(0);
    const b0 = Uint8Array.from([
        0x00
    ]);
    const b1 = Uint8Array.from([
        0x01
    ]);
    return [
        h1,
        h1n,
        x,
        v,
        k,
        b0,
        b1
    ];
}
async function $cd71b1c8a870839d$var$getQRSrfc6979(msgHash, privateKey) {
    const privKey = $cd71b1c8a870839d$var$normalizePrivateKey(privateKey);
    let [h1, h1n, x, v, k, b0, b1] = $cd71b1c8a870839d$var$_abc6979(msgHash, privKey);
    const hmac = module.exports.utils.hmacSha256;
    k = await hmac(k, v, b0, x, h1);
    v = await hmac(k, v);
    k = await hmac(k, v, b1, x, h1);
    v = await hmac(k, v);
    for(let i = 0; i < 1000; i++){
        v = await hmac(k, v);
        let qrs = $cd71b1c8a870839d$var$calcQRSFromK(v, h1n, privKey);
        if (qrs) return qrs;
        k = await hmac(k, v, b0);
        v = await hmac(k, v);
    }
    throw new TypeError("secp256k1: Tried 1,000 k values for sign(), all were invalid");
}
function $cd71b1c8a870839d$var$getQRSrfc6979Sync(msgHash, privateKey) {
    const privKey = $cd71b1c8a870839d$var$normalizePrivateKey(privateKey);
    let [h1, h1n, x, v, k, b0, b1] = $cd71b1c8a870839d$var$_abc6979(msgHash, privKey);
    const hmac = module.exports.utils.hmacSha256Sync;
    if (!hmac) throw new Error("utils.hmacSha256Sync is undefined, you need to set it");
    k = hmac(k, v, b0, x, h1);
    if (k instanceof Promise) throw new Error("To use sync sign(), ensure utils.hmacSha256 is sync");
    v = hmac(k, v);
    k = hmac(k, v, b1, x, h1);
    v = hmac(k, v);
    for(let i = 0; i < 1000; i++){
        v = hmac(k, v);
        let qrs = $cd71b1c8a870839d$var$calcQRSFromK(v, h1n, privKey);
        if (qrs) return qrs;
        k = hmac(k, v, b0);
        v = hmac(k, v);
    }
    throw new TypeError("secp256k1: Tried 1,000 k values for sign(), all were invalid");
}
function $cd71b1c8a870839d$var$isWithinCurveOrder(num) {
    return 0 < num && num < $cd71b1c8a870839d$var$CURVE.n;
}
function $cd71b1c8a870839d$var$calcQRSFromK(v, msg, priv) {
    const k = $cd71b1c8a870839d$var$bytesToNumber(v);
    if (!$cd71b1c8a870839d$var$isWithinCurveOrder(k)) return;
    const max = $cd71b1c8a870839d$var$CURVE.n;
    const q = $cd71b1c8a870839d$var$Point.BASE.multiply(k);
    const r = $cd71b1c8a870839d$var$mod(q.x, max);
    const s = $cd71b1c8a870839d$var$mod($cd71b1c8a870839d$var$invert(k, max) * (msg + r * priv), max);
    if (r === 0n || s === 0n) return;
    return [
        q,
        r,
        s
    ];
}
function $cd71b1c8a870839d$var$normalizePrivateKey(key) {
    let num;
    if (typeof key === "bigint") num = key;
    else if (typeof key === "number" && Number.isSafeInteger(key) && key > 0) num = BigInt(key);
    else if (typeof key === "string") {
        if (key.length !== 64) throw new Error("Expected 32 bytes of private key");
        num = $cd71b1c8a870839d$var$hexToNumber(key);
    } else if (key instanceof Uint8Array) {
        if (key.length !== 32) throw new Error("Expected 32 bytes of private key");
        num = $cd71b1c8a870839d$var$bytesToNumber(key);
    } else throw new TypeError("Expected valid private key");
    if (!$cd71b1c8a870839d$var$isWithinCurveOrder(num)) throw new Error("Expected private key: 0 < key < n");
    return num;
}
function $cd71b1c8a870839d$var$normalizePublicKey(publicKey) {
    if (publicKey instanceof $cd71b1c8a870839d$var$Point) {
        publicKey.assertValidity();
        return publicKey;
    } else return $cd71b1c8a870839d$var$Point.fromHex(publicKey);
}
function $cd71b1c8a870839d$var$normalizeSignature(signature) {
    if (signature instanceof $cd71b1c8a870839d$var$Signature) {
        signature.assertValidity();
        return signature;
    } else return $cd71b1c8a870839d$var$Signature.fromDER(signature);
}
function $cd71b1c8a870839d$var$getPublicKey(privateKey, isCompressed = false) {
    const point = $cd71b1c8a870839d$var$Point.fromPrivateKey(privateKey);
    if (typeof privateKey === "string") return point.toHex(isCompressed);
    return point.toRawBytes(isCompressed);
}
module.exports.getPublicKey = $cd71b1c8a870839d$var$getPublicKey;
function $cd71b1c8a870839d$var$recoverPublicKey(msgHash, signature, recovery) {
    const point = $cd71b1c8a870839d$var$Point.fromSignature(msgHash, signature, recovery);
    return typeof msgHash === "string" ? point.toHex() : point.toRawBytes();
}
module.exports.recoverPublicKey = $cd71b1c8a870839d$var$recoverPublicKey;
function $cd71b1c8a870839d$var$isPub(item) {
    const arr = item instanceof Uint8Array;
    const str = typeof item === "string";
    const len = (arr || str) && item.length;
    if (arr) return len === 33 || len === 65;
    if (str) return len === 66 || len === 130;
    if (item instanceof $cd71b1c8a870839d$var$Point) return true;
    return false;
}
function $cd71b1c8a870839d$var$getSharedSecret(privateA, publicB, isCompressed = false) {
    if ($cd71b1c8a870839d$var$isPub(privateA)) throw new TypeError("getSharedSecret: first arg must be private key");
    if (!$cd71b1c8a870839d$var$isPub(publicB)) throw new TypeError("getSharedSecret: second arg must be public key");
    const b = $cd71b1c8a870839d$var$normalizePublicKey(publicB);
    b.assertValidity();
    const shared = b.multiply($cd71b1c8a870839d$var$normalizePrivateKey(privateA));
    return typeof privateA === "string" ? shared.toHex(isCompressed) : shared.toRawBytes(isCompressed);
}
module.exports.getSharedSecret = $cd71b1c8a870839d$var$getSharedSecret;
function $cd71b1c8a870839d$var$QRSToSig(qrs, opts, str = false) {
    const [q, r, s] = qrs;
    let { canonical: canonical, der: der, recovered: recovered } = opts;
    let recovery = (q.x === r ? 0 : 2) | Number(q.y & 1n);
    let adjustedS = s;
    const HIGH_NUMBER = $cd71b1c8a870839d$var$CURVE.n >> 1n;
    if (s > HIGH_NUMBER && canonical) {
        adjustedS = $cd71b1c8a870839d$var$CURVE.n - s;
        recovery ^= 1;
    }
    const sig = new $cd71b1c8a870839d$var$Signature(r, adjustedS);
    sig.assertValidity();
    const hex = der === false ? sig.toCompactHex() : sig.toDERHex();
    const hashed = str ? hex : $cd71b1c8a870839d$var$hexToBytes(hex);
    return recovered ? [
        hashed,
        recovery
    ] : hashed;
}
async function $cd71b1c8a870839d$var$sign(msgHash, privKey, opts = {}) {
    return $cd71b1c8a870839d$var$QRSToSig(await $cd71b1c8a870839d$var$getQRSrfc6979(msgHash, privKey), opts, typeof msgHash === "string");
}
module.exports.sign = $cd71b1c8a870839d$var$sign;
function $cd71b1c8a870839d$var$signSync(msgHash, privKey, opts = {}) {
    return $cd71b1c8a870839d$var$QRSToSig($cd71b1c8a870839d$var$getQRSrfc6979Sync(msgHash, privKey), opts, typeof msgHash === "string");
}
module.exports.signSync = $cd71b1c8a870839d$var$signSync;
function $cd71b1c8a870839d$var$verify(signature, msgHash, publicKey) {
    const { n: n } = $cd71b1c8a870839d$var$CURVE;
    let sig;
    try {
        sig = $cd71b1c8a870839d$var$normalizeSignature(signature);
    } catch (error) {
        return false;
    }
    const { r: r, s: s } = sig;
    const h = $cd71b1c8a870839d$var$truncateHash(msgHash);
    if (h === 0n) return false;
    const pubKey = $cd71b1c8a870839d$var$JacobianPoint.fromAffine($cd71b1c8a870839d$var$normalizePublicKey(publicKey));
    const s1 = $cd71b1c8a870839d$var$invert(s, n);
    const u1 = $cd71b1c8a870839d$var$mod(h * s1, n);
    const u2 = $cd71b1c8a870839d$var$mod(r * s1, n);
    const Ghs1 = $cd71b1c8a870839d$var$JacobianPoint.BASE.multiply(u1);
    const Prs1 = pubKey.multiplyUnsafe(u2);
    const R = Ghs1.add(Prs1).toAffine();
    const v = $cd71b1c8a870839d$var$mod(R.x, n);
    return v === r;
}
module.exports.verify = $cd71b1c8a870839d$var$verify;
async function $cd71b1c8a870839d$var$taggedHash(tag, ...messages) {
    const tagB = new Uint8Array(tag.split("").map((c)=>c.charCodeAt(0)));
    const tagH = await module.exports.utils.sha256(tagB);
    const h = await module.exports.utils.sha256($cd71b1c8a870839d$var$concatBytes(tagH, tagH, ...messages));
    return $cd71b1c8a870839d$var$bytesToNumber(h);
}
async function $cd71b1c8a870839d$var$createChallenge(x, P, message) {
    const rx = $cd71b1c8a870839d$var$pad32b(x);
    const t = await $cd71b1c8a870839d$var$taggedHash("BIP0340/challenge", rx, P.toRawX(), message);
    return $cd71b1c8a870839d$var$mod(t, $cd71b1c8a870839d$var$CURVE.n);
}
function $cd71b1c8a870839d$var$hasEvenY(point) {
    return $cd71b1c8a870839d$var$mod(point.y, 2n) === 0n;
}
class $cd71b1c8a870839d$var$SchnorrSignature {
    constructor(r, s){
        this.r = r;
        this.s = s;
        if (r <= 0n || s <= 0n || r >= $cd71b1c8a870839d$var$CURVE.P || s >= $cd71b1c8a870839d$var$CURVE.n) throw new Error("Invalid signature");
    }
    static fromHex(hex) {
        const bytes = $cd71b1c8a870839d$var$ensureBytes(hex);
        if (bytes.length !== 64) throw new TypeError(`SchnorrSignature.fromHex: expected 64 bytes, not ${bytes.length}`);
        const r = $cd71b1c8a870839d$var$bytesToNumber(bytes.slice(0, 32));
        const s = $cd71b1c8a870839d$var$bytesToNumber(bytes.slice(32));
        return new $cd71b1c8a870839d$var$SchnorrSignature(r, s);
    }
    toHex() {
        return $cd71b1c8a870839d$var$pad64(this.r) + $cd71b1c8a870839d$var$pad64(this.s);
    }
    toRawBytes() {
        return $cd71b1c8a870839d$var$hexToBytes(this.toHex());
    }
}
function $cd71b1c8a870839d$var$schnorrGetPublicKey(privateKey) {
    const P = $cd71b1c8a870839d$var$Point.fromPrivateKey(privateKey);
    return typeof privateKey === "string" ? P.toHexX() : P.toRawX();
}
async function $cd71b1c8a870839d$var$schnorrSign(msgHash, privateKey, auxRand = module.exports.utils.randomBytes()) {
    if (msgHash == null) throw new TypeError(`sign: Expected valid message, not "${msgHash}"`);
    if (!privateKey) privateKey = 0n;
    const { n: n } = $cd71b1c8a870839d$var$CURVE;
    const m = $cd71b1c8a870839d$var$ensureBytes(msgHash);
    const d0 = $cd71b1c8a870839d$var$normalizePrivateKey(privateKey);
    const rand = $cd71b1c8a870839d$var$ensureBytes(auxRand);
    if (rand.length !== 32) throw new TypeError("sign: Expected 32 bytes of aux randomness");
    const P = $cd71b1c8a870839d$var$Point.fromPrivateKey(d0);
    const d = $cd71b1c8a870839d$var$hasEvenY(P) ? d0 : n - d0;
    const t0h = await $cd71b1c8a870839d$var$taggedHash("BIP0340/aux", rand);
    const t = d ^ t0h;
    const k0h = await $cd71b1c8a870839d$var$taggedHash("BIP0340/nonce", $cd71b1c8a870839d$var$pad32b(t), P.toRawX(), m);
    const k0 = $cd71b1c8a870839d$var$mod(k0h, n);
    if (k0 === 0n) throw new Error("sign: Creation of signature failed. k is zero");
    const R = $cd71b1c8a870839d$var$Point.fromPrivateKey(k0);
    const k = $cd71b1c8a870839d$var$hasEvenY(R) ? k0 : n - k0;
    const e = await $cd71b1c8a870839d$var$createChallenge(R.x, P, m);
    const sig = new $cd71b1c8a870839d$var$SchnorrSignature(R.x, $cd71b1c8a870839d$var$mod(k + e * d, n));
    const isValid = await $cd71b1c8a870839d$var$schnorrVerify(sig.toRawBytes(), m, P.toRawX());
    if (!isValid) throw new Error("sign: Invalid signature produced");
    return typeof msgHash === "string" ? sig.toHex() : sig.toRawBytes();
}
async function $cd71b1c8a870839d$var$schnorrVerify(signature, msgHash, publicKey) {
    const sig = signature instanceof $cd71b1c8a870839d$var$SchnorrSignature ? signature : $cd71b1c8a870839d$var$SchnorrSignature.fromHex(signature);
    const m = typeof msgHash === "string" ? $cd71b1c8a870839d$var$hexToBytes(msgHash) : msgHash;
    const P = $cd71b1c8a870839d$var$normalizePublicKey(publicKey);
    const e = await $cd71b1c8a870839d$var$createChallenge(sig.r, P, m);
    const sG = $cd71b1c8a870839d$var$Point.fromPrivateKey(sig.s);
    const eP = P.multiply(e);
    const R = sG.subtract(eP);
    if (R.equals($cd71b1c8a870839d$var$Point.BASE) || !$cd71b1c8a870839d$var$hasEvenY(R) || R.x !== sig.r) return false;
    return true;
}
module.exports.schnorr = {
    Signature: $cd71b1c8a870839d$var$SchnorrSignature,
    getPublicKey: $cd71b1c8a870839d$var$schnorrGetPublicKey,
    sign: $cd71b1c8a870839d$var$schnorrSign,
    verify: $cd71b1c8a870839d$var$schnorrVerify
};
$cd71b1c8a870839d$var$Point.BASE._setWindowSize(8);

const $cd71b1c8a870839d$var$crypto = (()=>{
    const webCrypto = typeof self === "object" && "crypto" in self ? self.crypto : undefined;
    const nodeRequire = true;
    return {
        node: nodeRequire && !webCrypto ? (parcelRequire("7jzxY")) : undefined,
        web: webCrypto
    };
})();
module.exports.utils = {
    isValidPrivateKey (privateKey) {
        try {
            $cd71b1c8a870839d$var$normalizePrivateKey(privateKey);
            return true;
        } catch (error) {
            return false;
        }
    },
    randomBytes: (bytesLength = 32)=>{
        if ($cd71b1c8a870839d$var$crypto.web) return $cd71b1c8a870839d$var$crypto.web.getRandomValues(new Uint8Array(bytesLength));
        else if ($cd71b1c8a870839d$var$crypto.node) {
            const { randomBytes: randomBytes } = $cd71b1c8a870839d$var$crypto.node;
            return new Uint8Array(randomBytes(bytesLength).buffer);
        } else throw new Error("The environment doesn't have randomBytes function");
    },
    randomPrivateKey: ()=>{
        let i = 8;
        while(i--){
            const b32 = module.exports.utils.randomBytes(32);
            const num = $cd71b1c8a870839d$var$bytesToNumber(b32);
            if ($cd71b1c8a870839d$var$isWithinCurveOrder(num) && num !== 1n) return b32;
        }
        throw new Error("Valid private key was not found in 8 iterations. PRNG is broken");
    },
    sha256: async (message)=>{
        if ($cd71b1c8a870839d$var$crypto.web) {
            const buffer = await $cd71b1c8a870839d$var$crypto.web.subtle.digest("SHA-256", message.buffer);
            return new Uint8Array(buffer);
        } else if ($cd71b1c8a870839d$var$crypto.node) {
            const { createHash: createHash } = $cd71b1c8a870839d$var$crypto.node;
            return Uint8Array.from(createHash("sha256").update(message).digest());
        } else throw new Error("The environment doesn't have sha256 function");
    },
    hmacSha256: async (key, ...messages)=>{
        if ($cd71b1c8a870839d$var$crypto.web) {
            const ckey = await $cd71b1c8a870839d$var$crypto.web.subtle.importKey("raw", key, {
                name: "HMAC",
                hash: {
                    name: "SHA-256"
                }
            }, false, [
                "sign"
            ]);
            const message = $cd71b1c8a870839d$var$concatBytes(...messages);
            const buffer = await $cd71b1c8a870839d$var$crypto.web.subtle.sign("HMAC", ckey, message);
            return new Uint8Array(buffer);
        } else if ($cd71b1c8a870839d$var$crypto.node) {
            const { createHmac: createHmac } = $cd71b1c8a870839d$var$crypto.node;
            const hash = createHmac("sha256", key);
            for (let message of messages)hash.update(message);
            return Uint8Array.from(hash.digest());
        } else throw new Error("The environment doesn't have hmac-sha256 function");
    },
    sha256Sync: undefined,
    hmacSha256Sync: undefined,
    precompute (windowSize = 8, point = $cd71b1c8a870839d$var$Point.BASE) {
        const cached = point === $cd71b1c8a870839d$var$Point.BASE ? point : new $cd71b1c8a870839d$var$Point(point.x, point.y);
        cached._setWindowSize(windowSize);
        cached.multiply(3n);
        return cached;
    }
};

});



parcelRequire.register("aqUBP", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $8hEBV = parcelRequire("8hEBV");
var $79883e770443aee0$require$uint8ArrayConcat = $8hEBV.concat;

var $8cWjP = parcelRequire("8cWjP");
var $79883e770443aee0$require$uint8ArrayFromString = $8cWjP.fromString;

var $1yc8l = parcelRequire("1yc8l");
const $79883e770443aee0$var$cipherMap = {
    "AES-128": {
        ivSize: 16,
        keySize: 16
    },
    "AES-256": {
        ivSize: 16,
        keySize: 32
    },
    Blowfish: {
        ivSize: 8,
        cipherKeySize: 32
    }
};
// Generates a set of keys for each party by stretching the shared key.
// (myIV, theirIV, myCipherKey, theirCipherKey, myMACKey, theirMACKey)
module.exports = async (cipherType, hash, secret)=>{
    const cipher = $79883e770443aee0$var$cipherMap[cipherType];
    if (!cipher) {
        const allowed = Object.keys($79883e770443aee0$var$cipherMap).join(" / ");
        throw $20Lm5(new Error(`unknown cipher type '${cipherType}'. Must be ${allowed}`), "ERR_INVALID_CIPHER_TYPE");
    }
    if (!hash) throw $20Lm5(new Error("missing hash type"), "ERR_MISSING_HASH_TYPE");
    const cipherKeySize = cipher.keySize;
    const ivSize = cipher.ivSize;
    const hmacKeySize = 20;
    const seed = $79883e770443aee0$require$uint8ArrayFromString("key expansion");
    const resultLength = 2 * (ivSize + cipherKeySize + hmacKeySize);
    const m = await $1yc8l.create(hash, secret);
    let a = await m.digest(seed);
    const result = [];
    let j = 0;
    while(j < resultLength){
        const b = await m.digest($79883e770443aee0$require$uint8ArrayConcat([
            a,
            seed
        ]));
        let todo = b.length;
        if (j + todo > resultLength) todo = resultLength - j;
        result.push(b);
        j += todo;
        a = await m.digest(a);
    }
    const half = resultLength / 2;
    const resultBuffer = $79883e770443aee0$require$uint8ArrayConcat(result);
    const r1 = resultBuffer.slice(0, half);
    const r2 = resultBuffer.slice(half, resultLength);
    const createKey = (res)=>({
            iv: res.slice(0, ivSize),
            cipherKey: res.slice(ivSize, ivSize + cipherKeySize),
            macKey: res.slice(ivSize + cipherKeySize)
        });
    return {
        k1: createKey(r1),
        k2: createKey(r2)
    };
};

});
parcelRequire.register("1yc8l", function(module, exports) {

$parcel$export(module.exports, "create", () => $121260e74c912cc6$export$185802fd694ee1f5, (v) => $121260e74c912cc6$export$185802fd694ee1f5 = v);
var $121260e74c912cc6$export$185802fd694ee1f5;
"use strict";

var $j15Fm = parcelRequire("j15Fm");

var $fY2xU = parcelRequire("fY2xU");
const $121260e74c912cc6$var$hashTypes = {
    SHA1: "SHA-1",
    SHA256: "SHA-256",
    SHA512: "SHA-512"
};
const $121260e74c912cc6$var$sign = async (key, data)=>{
    const buf = await $j15Fm.get().subtle.sign({
        name: "HMAC"
    }, key, data);
    return new Uint8Array(buf, buf.byteOffset, buf.byteLength);
};
$121260e74c912cc6$export$185802fd694ee1f5 = async function(hashType, secret) {
    const hash = $121260e74c912cc6$var$hashTypes[hashType];
    const key = await $j15Fm.get().subtle.importKey("raw", secret, {
        name: "HMAC",
        hash: {
            name: hash
        }
    }, false, [
        "sign"
    ]);
    return {
        async digest (data) {
            return $121260e74c912cc6$var$sign(key, data);
        },
        length: $fY2xU[hashType]
    };
};

});
parcelRequire.register("fY2xU", function(module, exports) {
"use strict";
module.exports = {
    SHA1: 20,
    SHA256: 32,
    SHA512: 64
};

});



parcelRequire.register("lCVsW", function(module, exports) {
"use strict";

var $as7vf = parcelRequire("as7vf");
// Generates an ephemeral public key and returns a function that will compute
// the shared secret key.
//
// Focuses only on ECDH now, but can be made more general in the future.
module.exports = async (curve)=>$as7vf.generateEphmeralKeyPair(curve) // eslint-disable-line require-await
;

});
parcelRequire.register("as7vf", function(module, exports) {

$parcel$export(module.exports, "generateEphmeralKeyPair", () => $79c256dd64c38bad$export$8c9e061ef03ebfb1, (v) => $79c256dd64c38bad$export$8c9e061ef03ebfb1 = v);
var $79c256dd64c38bad$export$8c9e061ef03ebfb1;
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $j15Fm = parcelRequire("j15Fm");

var $eLywY = parcelRequire("eLywY");
var $79c256dd64c38bad$require$base64urlToBuffer = $eLywY.base64urlToBuffer;

var $5G3NU = parcelRequire("5G3NU");

var $6rBCs = parcelRequire("6rBCs");
var $79c256dd64c38bad$require$uint8ArrayToString = $6rBCs.toString;

var $8hEBV = parcelRequire("8hEBV");
var $79c256dd64c38bad$require$uint8ArrayConcat = $8hEBV.concat;

var $ijWXY = parcelRequire("ijWXY");
var $79c256dd64c38bad$require$uint8ArrayEquals = $ijWXY.equals;
const $79c256dd64c38bad$var$bits = {
    "P-256": 256,
    "P-384": 384,
    "P-521": 521
};
$79c256dd64c38bad$export$8c9e061ef03ebfb1 = async function(curve) {
    $5G3NU(Object.keys($79c256dd64c38bad$var$bits), curve);
    const pair = await $j15Fm.get().subtle.generateKey({
        name: "ECDH",
        namedCurve: curve
    }, true, [
        "deriveBits"
    ]);
    // forcePrivate is used for testing only
    const genSharedKey = async (theirPub, forcePrivate)=>{
        let privateKey;
        if (forcePrivate) privateKey = await $j15Fm.get().subtle.importKey("jwk", $79c256dd64c38bad$var$unmarshalPrivateKey(curve, forcePrivate), {
            name: "ECDH",
            namedCurve: curve
        }, false, [
            "deriveBits"
        ]);
        else privateKey = pair.privateKey;
        const keys = [
            await $j15Fm.get().subtle.importKey("jwk", $79c256dd64c38bad$var$unmarshalPublicKey(curve, theirPub), {
                name: "ECDH",
                namedCurve: curve
            }, false, []),
            privateKey
        ];
        const buffer = await $j15Fm.get().subtle.deriveBits({
            name: "ECDH",
            namedCurve: curve,
            public: keys[0]
        }, keys[1], $79c256dd64c38bad$var$bits[curve]);
        return new Uint8Array(buffer, buffer.byteOffset, buffer.byteLength);
    };
    const publicKey = await $j15Fm.get().subtle.exportKey("jwk", pair.publicKey);
    return {
        key: $79c256dd64c38bad$var$marshalPublicKey(publicKey),
        genSharedKey: genSharedKey
    };
};
const $79c256dd64c38bad$var$curveLengths = {
    "P-256": 32,
    "P-384": 48,
    "P-521": 66
};
// Marshal converts a jwk encodec ECDH public key into the
// form specified in section 4.3.6 of ANSI X9.62. (This is the format
// go-ipfs uses)
function $79c256dd64c38bad$var$marshalPublicKey(jwk) {
    const byteLen = $79c256dd64c38bad$var$curveLengths[jwk.crv];
    return $79c256dd64c38bad$require$uint8ArrayConcat([
        Uint8Array.from([
            4
        ]),
        $79c256dd64c38bad$require$base64urlToBuffer(jwk.x, byteLen),
        $79c256dd64c38bad$require$base64urlToBuffer(jwk.y, byteLen)
    ], 1 + byteLen * 2);
}
// Unmarshal converts a point, serialized by Marshal, into an jwk encoded key
function $79c256dd64c38bad$var$unmarshalPublicKey(curve, key) {
    const byteLen = $79c256dd64c38bad$var$curveLengths[curve];
    if ($79c256dd64c38bad$require$uint8ArrayEquals(!key.slice(0, 1), Uint8Array.from([
        4
    ]))) throw $20Lm5(new Error("Cannot unmarshal public key - invalid key format"), "ERR_INVALID_KEY_FORMAT");
    return {
        kty: "EC",
        crv: curve,
        x: $79c256dd64c38bad$require$uint8ArrayToString(key.slice(1, byteLen + 1), "base64url"),
        y: $79c256dd64c38bad$require$uint8ArrayToString(key.slice(1 + byteLen), "base64url"),
        ext: true
    };
}
const $79c256dd64c38bad$var$unmarshalPrivateKey = (curve, key)=>({
        ...$79c256dd64c38bad$var$unmarshalPublicKey(curve, key.public),
        d: $79c256dd64c38bad$require$uint8ArrayToString(key.private, "base64url")
    });

});
parcelRequire.register("5G3NU", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");
module.exports = function(curveTypes, type) {
    if (!curveTypes.includes(type)) {
        const names = curveTypes.join(" / ");
        throw $20Lm5(new Error(`Unknown curve: ${type}. Must be ${names}`), "ERR_INVALID_CURVE");
    }
};

});




parcelRequire.register("dJXSQ", function(module, exports) {
/*eslint-disable*/ "use strict";

var $liRmU = parcelRequire("liRmU");
// Common aliases
var $0294dead4c89ba3d$var$$Reader = $liRmU.Reader, $0294dead4c89ba3d$var$$Writer = $liRmU.Writer, $0294dead4c89ba3d$var$$util = $liRmU.util;
// Exported root namespace
var $0294dead4c89ba3d$var$$root = $liRmU.roots["libp2p-peer-id"] || ($liRmU.roots["libp2p-peer-id"] = {});
$0294dead4c89ba3d$var$$root.PeerIdProto = function() {
    /**
     * Properties of a PeerIdProto.
     * @exports IPeerIdProto
     * @interface IPeerIdProto
     * @property {Uint8Array} id PeerIdProto id
     * @property {Uint8Array|null} [pubKey] PeerIdProto pubKey
     * @property {Uint8Array|null} [privKey] PeerIdProto privKey
     */ /**
     * Constructs a new PeerIdProto.
     * @exports PeerIdProto
     * @classdesc Represents a PeerIdProto.
     * @implements IPeerIdProto
     * @constructor
     * @param {IPeerIdProto=} [p] Properties to set
     */ function PeerIdProto(p) {
        if (p) {
            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }
    }
    /**
     * PeerIdProto id.
     * @member {Uint8Array} id
     * @memberof PeerIdProto
     * @instance
     */ PeerIdProto.prototype.id = $0294dead4c89ba3d$var$$util.newBuffer([]);
    /**
     * PeerIdProto pubKey.
     * @member {Uint8Array} pubKey
     * @memberof PeerIdProto
     * @instance
     */ PeerIdProto.prototype.pubKey = $0294dead4c89ba3d$var$$util.newBuffer([]);
    /**
     * PeerIdProto privKey.
     * @member {Uint8Array} privKey
     * @memberof PeerIdProto
     * @instance
     */ PeerIdProto.prototype.privKey = $0294dead4c89ba3d$var$$util.newBuffer([]);
    /**
     * Encodes the specified PeerIdProto message. Does not implicitly {@link PeerIdProto.verify|verify} messages.
     * @function encode
     * @memberof PeerIdProto
     * @static
     * @param {IPeerIdProto} m PeerIdProto message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ PeerIdProto.encode = function encode(m, w) {
        if (!w) w = $0294dead4c89ba3d$var$$Writer.create();
        w.uint32(10).bytes(m.id);
        if (m.pubKey != null && Object.hasOwnProperty.call(m, "pubKey")) w.uint32(18).bytes(m.pubKey);
        if (m.privKey != null && Object.hasOwnProperty.call(m, "privKey")) w.uint32(26).bytes(m.privKey);
        return w;
    };
    /**
     * Decodes a PeerIdProto message from the specified reader or buffer.
     * @function decode
     * @memberof PeerIdProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {PeerIdProto} PeerIdProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ PeerIdProto.decode = function decode(r, l) {
        if (!(r instanceof $0294dead4c89ba3d$var$$Reader)) r = $0294dead4c89ba3d$var$$Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l, m = new $0294dead4c89ba3d$var$$root.PeerIdProto();
        while(r.pos < c){
            var t = r.uint32();
            switch(t >>> 3){
                case 1:
                    m.id = r.bytes();
                    break;
                case 2:
                    m.pubKey = r.bytes();
                    break;
                case 3:
                    m.privKey = r.bytes();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
            }
        }
        if (!m.hasOwnProperty("id")) throw $0294dead4c89ba3d$var$$util.ProtocolError("missing required 'id'", {
            instance: m
        });
        return m;
    };
    /**
     * Creates a PeerIdProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PeerIdProto
     * @static
     * @param {Object.<string,*>} d Plain object
     * @returns {PeerIdProto} PeerIdProto
     */ PeerIdProto.fromObject = function fromObject(d) {
        if (d instanceof $0294dead4c89ba3d$var$$root.PeerIdProto) return d;
        var m = new $0294dead4c89ba3d$var$$root.PeerIdProto();
        if (d.id != null) {
            if (typeof d.id === "string") $0294dead4c89ba3d$var$$util.base64.decode(d.id, m.id = $0294dead4c89ba3d$var$$util.newBuffer($0294dead4c89ba3d$var$$util.base64.length(d.id)), 0);
            else if (d.id.length) m.id = d.id;
        }
        if (d.pubKey != null) {
            if (typeof d.pubKey === "string") $0294dead4c89ba3d$var$$util.base64.decode(d.pubKey, m.pubKey = $0294dead4c89ba3d$var$$util.newBuffer($0294dead4c89ba3d$var$$util.base64.length(d.pubKey)), 0);
            else if (d.pubKey.length) m.pubKey = d.pubKey;
        }
        if (d.privKey != null) {
            if (typeof d.privKey === "string") $0294dead4c89ba3d$var$$util.base64.decode(d.privKey, m.privKey = $0294dead4c89ba3d$var$$util.newBuffer($0294dead4c89ba3d$var$$util.base64.length(d.privKey)), 0);
            else if (d.privKey.length) m.privKey = d.privKey;
        }
        return m;
    };
    /**
     * Creates a plain object from a PeerIdProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PeerIdProto
     * @static
     * @param {PeerIdProto} m PeerIdProto
     * @param {$protobuf.IConversionOptions} [o] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ PeerIdProto.toObject = function toObject(m, o) {
        if (!o) o = {};
        var d = {};
        if (o.defaults) {
            if (o.bytes === String) d.id = "";
            else {
                d.id = [];
                if (o.bytes !== Array) d.id = $0294dead4c89ba3d$var$$util.newBuffer(d.id);
            }
            if (o.bytes === String) d.pubKey = "";
            else {
                d.pubKey = [];
                if (o.bytes !== Array) d.pubKey = $0294dead4c89ba3d$var$$util.newBuffer(d.pubKey);
            }
            if (o.bytes === String) d.privKey = "";
            else {
                d.privKey = [];
                if (o.bytes !== Array) d.privKey = $0294dead4c89ba3d$var$$util.newBuffer(d.privKey);
            }
        }
        if (m.id != null && m.hasOwnProperty("id")) d.id = o.bytes === String ? $0294dead4c89ba3d$var$$util.base64.encode(m.id, 0, m.id.length) : o.bytes === Array ? Array.prototype.slice.call(m.id) : m.id;
        if (m.pubKey != null && m.hasOwnProperty("pubKey")) d.pubKey = o.bytes === String ? $0294dead4c89ba3d$var$$util.base64.encode(m.pubKey, 0, m.pubKey.length) : o.bytes === Array ? Array.prototype.slice.call(m.pubKey) : m.pubKey;
        if (m.privKey != null && m.hasOwnProperty("privKey")) d.privKey = o.bytes === String ? $0294dead4c89ba3d$var$$util.base64.encode(m.privKey, 0, m.privKey.length) : o.bytes === Array ? Array.prototype.slice.call(m.privKey) : m.privKey;
        return d;
    };
    /**
     * Converts this PeerIdProto to JSON.
     * @function toJSON
     * @memberof PeerIdProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ PeerIdProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
    };
    return PeerIdProto;
}();
module.exports = $0294dead4c89ba3d$var$$root;

});


parcelRequire.register("hN6NI", function(module, exports) {

$parcel$export(module.exports, "keys", () => $cf3c49ce35d005f8$export$ed97f33186d4b816, (v) => $cf3c49ce35d005f8$export$ed97f33186d4b816 = v);
var $cf3c49ce35d005f8$export$12e89174be25f9f0;
var $cf3c49ce35d005f8$export$355af40f8ab02f34;
var $cf3c49ce35d005f8$export$ed97f33186d4b816;
var $cf3c49ce35d005f8$export$5f828d93ff035aa8;
var $cf3c49ce35d005f8$export$448fa22aedc9dbca;
"use strict";

var $1guLm = parcelRequire("1guLm");

var $lTiyZ = parcelRequire("lTiyZ");

var $hkckt = parcelRequire("hkckt");
$cf3c49ce35d005f8$export$12e89174be25f9f0 = $lTiyZ;
$cf3c49ce35d005f8$export$355af40f8ab02f34 = $1guLm;
$cf3c49ce35d005f8$export$ed97f33186d4b816 = $hkckt;

$cf3c49ce35d005f8$export$5f828d93ff035aa8 = (parcelRequire("4k49i"));

$cf3c49ce35d005f8$export$448fa22aedc9dbca = (parcelRequire("gj0Yu"));

});
parcelRequire.register("1guLm", function(module, exports) {

$parcel$export(module.exports, "create", () => $0ebf25ee46d97a37$export$185802fd694ee1f5, (v) => $0ebf25ee46d97a37$export$185802fd694ee1f5 = v);
var $0ebf25ee46d97a37$export$185802fd694ee1f5;
"use strict";

var $bpHqr = parcelRequire("bpHqr");

var $jV8CM = parcelRequire("jV8CM");
const $0ebf25ee46d97a37$var$hashTypes = {
    SHA1: "SHA-1",
    SHA256: "SHA-256",
    SHA512: "SHA-512"
};
const $0ebf25ee46d97a37$var$sign = async (key, data)=>{
    const buf = await $bpHqr.get().subtle.sign({
        name: "HMAC"
    }, key, data);
    return new Uint8Array(buf, buf.byteOffset, buf.byteLength);
};
$0ebf25ee46d97a37$export$185802fd694ee1f5 = async function(hashType, secret) {
    const hash = $0ebf25ee46d97a37$var$hashTypes[hashType];
    const key = await $bpHqr.get().subtle.importKey("raw", secret, {
        name: "HMAC",
        hash: {
            name: hash
        }
    }, false, [
        "sign"
    ]);
    return {
        async digest (data) {
            return $0ebf25ee46d97a37$var$sign(key, data);
        },
        length: $jV8CM[hashType]
    };
};

});
parcelRequire.register("bpHqr", function(module, exports) {

$parcel$export(module.exports, "get", () => $84f3b6e2b93a3c41$export$3988ae62b71be9a3, (v) => $84f3b6e2b93a3c41$export$3988ae62b71be9a3 = v);
/* eslint-env browser */ // Check native crypto exists and is enabled (In insecure context `self.crypto`
// exists but `self.crypto.subtle` does not).
var $84f3b6e2b93a3c41$export$3988ae62b71be9a3;
"use strict";
$84f3b6e2b93a3c41$export$3988ae62b71be9a3 = (win = self)=>{
    const nativeCrypto = win.crypto || win.msCrypto;
    if (!nativeCrypto || !nativeCrypto.subtle) throw Object.assign(new Error("Missing Web Crypto API. The most likely cause of this error is that this page is being accessed from an insecure context (i.e. not HTTPS). For more information and possible resolutions see https://github.com/libp2p/js-libp2p-crypto/blob/master/README.md#web-crypto-api"), {
        code: "ERR_MISSING_WEB_CRYPTO"
    });
    return nativeCrypto;
};

});

parcelRequire.register("jV8CM", function(module, exports) {
"use strict";
module.exports = {
    SHA1: 20,
    SHA256: 32,
    SHA512: 64
};

});


parcelRequire.register("lTiyZ", function(module, exports) {

$parcel$export(module.exports, "create", () => $fefd2256e311bbb1$export$185802fd694ee1f5, (v) => $fefd2256e311bbb1$export$185802fd694ee1f5 = v);
var $fefd2256e311bbb1$export$185802fd694ee1f5;
"use strict";

var $2Eijv = parcelRequire("2Eijv");

var $kzlF9 = parcelRequire("kzlF9");
$fefd2256e311bbb1$export$185802fd694ee1f5 = async function(key, iv) {
    const mode = $kzlF9(key);
    const cipher = $2Eijv.createCipheriv(mode, key, iv);
    const decipher = $2Eijv.createDecipheriv(mode, key, iv);
    const res = {
        async encrypt (data) {
            return cipher.update(data);
        },
        async decrypt (data) {
            return decipher.update(data);
        }
    };
    return res;
};

});
parcelRequire.register("2Eijv", function(module, exports) {
"use strict";
parcelRequire("a7tnS");

var $2xc86 = parcelRequire("2xc86");

var $6rBCs = parcelRequire("6rBCs");
var $1edd85e475e4664c$require$uint8ArrayToString = $6rBCs.toString;

var $8cWjP = parcelRequire("8cWjP");
var $1edd85e475e4664c$require$uint8ArrayFromString = $8cWjP.fromString;
module.exports = {
    createCipheriv: (mode, key, iv)=>{
        const cipher2 = $2xc86.cipher.createCipher("AES-CTR", $1edd85e475e4664c$require$uint8ArrayToString(key, "ascii"));
        cipher2.start({
            iv: $1edd85e475e4664c$require$uint8ArrayToString(iv, "ascii")
        });
        return {
            update: (data)=>{
                cipher2.update($2xc86.util.createBuffer($1edd85e475e4664c$require$uint8ArrayToString(data, "ascii")));
                return $1edd85e475e4664c$require$uint8ArrayFromString(cipher2.output.getBytes(), "ascii");
            }
        };
    },
    createDecipheriv: (mode, key, iv)=>{
        const cipher2 = $2xc86.cipher.createDecipher("AES-CTR", $1edd85e475e4664c$require$uint8ArrayToString(key, "ascii"));
        cipher2.start({
            iv: $1edd85e475e4664c$require$uint8ArrayToString(iv, "ascii")
        });
        return {
            update: (data)=>{
                cipher2.update($2xc86.util.createBuffer($1edd85e475e4664c$require$uint8ArrayToString(data, "ascii")));
                return $1edd85e475e4664c$require$uint8ArrayFromString(cipher2.output.getBytes(), "ascii");
            }
        };
    }
};

});

parcelRequire.register("kzlF9", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");
const $ef97e14b62ef69e0$var$CIPHER_MODES = {
    16: "aes-128-ctr",
    32: "aes-256-ctr"
};
module.exports = function(key) {
    const mode = $ef97e14b62ef69e0$var$CIPHER_MODES[key.length];
    if (!mode) {
        const modes = Object.entries($ef97e14b62ef69e0$var$CIPHER_MODES).map(([k, v])=>`${k} (${v})`).join(" / ");
        throw $20Lm5(new Error(`Invalid key length ${key.length} bytes. Must be ${modes}`), "ERR_INVALID_KEY_LENGTH");
    }
    return mode;
};

});


parcelRequire.register("hkckt", function(module, exports) {
"use strict";

var $95NDj = parcelRequire("95NDj");
parcelRequire("l46Tq");
parcelRequire("8EmV9");

var $2xc86 = parcelRequire("2xc86");

var $20Lm5 = parcelRequire("20Lm5");

var $8cWjP = parcelRequire("8cWjP");
var $c9cdde41ab66ab4f$require$uint8ArrayFromString = $8cWjP.fromString;

var $ans9D = parcelRequire("ans9D");




const $c9cdde41ab66ab4f$var$supportedKeys = {
    rsa: (parcelRequire("ec9zu")),
    ed25519: (parcelRequire("7XgpO")),
    secp256k1: (parcelRequire("hb6fy"))($95NDj, (parcelRequire("4k49i")))
};
const $c9cdde41ab66ab4f$var$ErrMissingSecp256K1 = {
    message: "secp256k1 support requires libp2p-crypto-secp256k1 package",
    code: "ERR_MISSING_PACKAGE"
};
function $c9cdde41ab66ab4f$var$typeToKey(type) {
    const key = $c9cdde41ab66ab4f$var$supportedKeys[type.toLowerCase()];
    if (!key) {
        const supported = Object.keys($c9cdde41ab66ab4f$var$supportedKeys).join(" / ");
        throw $20Lm5(new Error(`invalid or unsupported key type ${type}. Must be ${supported}`), "ERR_UNSUPPORTED_KEY_TYPE");
    }
    return key;
}
// Generates a keypair of the given type and bitsize
const $c9cdde41ab66ab4f$var$generateKeyPair = async (type, bits)=>{
    return $c9cdde41ab66ab4f$var$typeToKey(type).generateKeyPair(bits);
};
// Generates a keypair of the given type and bitsize
// seed is a 32 byte uint8array
const $c9cdde41ab66ab4f$var$generateKeyPairFromSeed = async (type, seed, bits)=>{
    const key = $c9cdde41ab66ab4f$var$typeToKey(type);
    if (type.toLowerCase() !== "ed25519") throw $20Lm5(new Error("Seed key derivation is unimplemented for RSA or secp256k1"), "ERR_UNSUPPORTED_KEY_DERIVATION_TYPE");
    return key.generateKeyPairFromSeed(seed, bits);
};
// Converts a protobuf serialized public key into its
// representative object
const $c9cdde41ab66ab4f$var$unmarshalPublicKey = (buf)=>{
    const decoded = $95NDj.PublicKey.decode(buf);
    const data = decoded.Data;
    switch(decoded.Type){
        case $95NDj.KeyType.RSA:
            return $c9cdde41ab66ab4f$var$supportedKeys.rsa.unmarshalRsaPublicKey(data);
        case $95NDj.KeyType.Ed25519:
            return $c9cdde41ab66ab4f$var$supportedKeys.ed25519.unmarshalEd25519PublicKey(data);
        case $95NDj.KeyType.Secp256k1:
            if ($c9cdde41ab66ab4f$var$supportedKeys.secp256k1) return $c9cdde41ab66ab4f$var$supportedKeys.secp256k1.unmarshalSecp256k1PublicKey(data);
            else throw $20Lm5(new Error($c9cdde41ab66ab4f$var$ErrMissingSecp256K1.message), $c9cdde41ab66ab4f$var$ErrMissingSecp256K1.code);
        default:
            $c9cdde41ab66ab4f$var$typeToKey(decoded.Type) // throws because type is not supported
            ;
    }
};
// Converts a public key object into a protobuf serialized public key
const $c9cdde41ab66ab4f$var$marshalPublicKey = (key, type)=>{
    type = (type || "rsa").toLowerCase();
    $c9cdde41ab66ab4f$var$typeToKey(type) // check type
    ;
    return key.bytes;
};
// Converts a protobuf serialized private key into its
// representative object
const $c9cdde41ab66ab4f$var$unmarshalPrivateKey = async (buf)=>{
    const decoded = $95NDj.PrivateKey.decode(buf);
    const data = decoded.Data;
    switch(decoded.Type){
        case $95NDj.KeyType.RSA:
            return $c9cdde41ab66ab4f$var$supportedKeys.rsa.unmarshalRsaPrivateKey(data);
        case $95NDj.KeyType.Ed25519:
            return $c9cdde41ab66ab4f$var$supportedKeys.ed25519.unmarshalEd25519PrivateKey(data);
        case $95NDj.KeyType.Secp256k1:
            if ($c9cdde41ab66ab4f$var$supportedKeys.secp256k1) return $c9cdde41ab66ab4f$var$supportedKeys.secp256k1.unmarshalSecp256k1PrivateKey(data);
            else throw $20Lm5(new Error($c9cdde41ab66ab4f$var$ErrMissingSecp256K1.message), $c9cdde41ab66ab4f$var$ErrMissingSecp256K1.code);
        default:
            $c9cdde41ab66ab4f$var$typeToKey(decoded.Type) // throws because type is not supported
            ;
    }
};
// Converts a private key object into a protobuf serialized private key
const $c9cdde41ab66ab4f$var$marshalPrivateKey = (key, type)=>{
    type = (type || "rsa").toLowerCase();
    $c9cdde41ab66ab4f$var$typeToKey(type) // check type
    ;
    return key.bytes;
};
/**
 *
 * @param {string} encryptedKey
 * @param {string} password
 */ const $c9cdde41ab66ab4f$var$importKey = async (encryptedKey, password)=>{
    try {
        const key = await $ans9D.import(encryptedKey, password);
        return $c9cdde41ab66ab4f$var$unmarshalPrivateKey(key);
    } catch (_) {
    // Ignore and try the old pem decrypt
    }
    // Only rsa supports pem right now
    const key = $2xc86.pki.decryptRsaPrivateKey(encryptedKey, password);
    if (key === null) throw $20Lm5(new Error("Cannot read the key, most likely the password is wrong or not a RSA key"), "ERR_CANNOT_DECRYPT_PEM");
    let der = $2xc86.asn1.toDer($2xc86.pki.privateKeyToAsn1(key));
    der = $c9cdde41ab66ab4f$require$uint8ArrayFromString(der.getBytes(), "ascii");
    return $c9cdde41ab66ab4f$var$supportedKeys.rsa.unmarshalRsaPrivateKey(der);
};


module.exports = {
    supportedKeys: $c9cdde41ab66ab4f$var$supportedKeys,
    keysPBM: $95NDj,
    keyStretcher: (parcelRequire("lLTE8")),
    generateEphemeralKeyPair: (parcelRequire("28g7q")),
    generateKeyPair: $c9cdde41ab66ab4f$var$generateKeyPair,
    generateKeyPairFromSeed: $c9cdde41ab66ab4f$var$generateKeyPairFromSeed,
    unmarshalPublicKey: $c9cdde41ab66ab4f$var$unmarshalPublicKey,
    marshalPublicKey: $c9cdde41ab66ab4f$var$marshalPublicKey,
    unmarshalPrivateKey: $c9cdde41ab66ab4f$var$unmarshalPrivateKey,
    marshalPrivateKey: $c9cdde41ab66ab4f$var$marshalPrivateKey,
    import: $c9cdde41ab66ab4f$var$importKey
};

});
parcelRequire.register("95NDj", function(module, exports) {
/*eslint-disable*/ "use strict";

var $liRmU = parcelRequire("liRmU");
// Common aliases
var $69eb14c388664356$var$$Reader = $liRmU.Reader, $69eb14c388664356$var$$Writer = $liRmU.Writer, $69eb14c388664356$var$$util = $liRmU.util;
// Exported root namespace
var $69eb14c388664356$var$$root = $liRmU.roots["libp2p-crypto-keys"] || ($liRmU.roots["libp2p-crypto-keys"] = {});
/**
 * KeyType enum.
 * @exports KeyType
 * @enum {number}
 * @property {number} RSA=0 RSA value
 * @property {number} Ed25519=1 Ed25519 value
 * @property {number} Secp256k1=2 Secp256k1 value
 */ $69eb14c388664356$var$$root.KeyType = function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "RSA"] = 0;
    values[valuesById[1] = "Ed25519"] = 1;
    values[valuesById[2] = "Secp256k1"] = 2;
    return values;
}();
$69eb14c388664356$var$$root.PublicKey = function() {
    /**
     * Properties of a PublicKey.
     * @exports IPublicKey
     * @interface IPublicKey
     * @property {KeyType} Type PublicKey Type
     * @property {Uint8Array} Data PublicKey Data
     */ /**
     * Constructs a new PublicKey.
     * @exports PublicKey
     * @classdesc Represents a PublicKey.
     * @implements IPublicKey
     * @constructor
     * @param {IPublicKey=} [p] Properties to set
     */ function PublicKey(p) {
        if (p) {
            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }
    }
    /**
     * PublicKey Type.
     * @member {KeyType} Type
     * @memberof PublicKey
     * @instance
     */ PublicKey.prototype.Type = 0;
    /**
     * PublicKey Data.
     * @member {Uint8Array} Data
     * @memberof PublicKey
     * @instance
     */ PublicKey.prototype.Data = $69eb14c388664356$var$$util.newBuffer([]);
    /**
     * Encodes the specified PublicKey message. Does not implicitly {@link PublicKey.verify|verify} messages.
     * @function encode
     * @memberof PublicKey
     * @static
     * @param {IPublicKey} m PublicKey message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ PublicKey.encode = function encode(m, w) {
        if (!w) w = $69eb14c388664356$var$$Writer.create();
        w.uint32(8).int32(m.Type);
        w.uint32(18).bytes(m.Data);
        return w;
    };
    /**
     * Decodes a PublicKey message from the specified reader or buffer.
     * @function decode
     * @memberof PublicKey
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {PublicKey} PublicKey
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ PublicKey.decode = function decode(r, l) {
        if (!(r instanceof $69eb14c388664356$var$$Reader)) r = $69eb14c388664356$var$$Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l, m = new $69eb14c388664356$var$$root.PublicKey();
        while(r.pos < c){
            var t = r.uint32();
            switch(t >>> 3){
                case 1:
                    m.Type = r.int32();
                    break;
                case 2:
                    m.Data = r.bytes();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
            }
        }
        if (!m.hasOwnProperty("Type")) throw $69eb14c388664356$var$$util.ProtocolError("missing required 'Type'", {
            instance: m
        });
        if (!m.hasOwnProperty("Data")) throw $69eb14c388664356$var$$util.ProtocolError("missing required 'Data'", {
            instance: m
        });
        return m;
    };
    /**
     * Creates a PublicKey message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublicKey
     * @static
     * @param {Object.<string,*>} d Plain object
     * @returns {PublicKey} PublicKey
     */ PublicKey.fromObject = function fromObject(d) {
        if (d instanceof $69eb14c388664356$var$$root.PublicKey) return d;
        var m = new $69eb14c388664356$var$$root.PublicKey();
        switch(d.Type){
            case "RSA":
            case 0:
                m.Type = 0;
                break;
            case "Ed25519":
            case 1:
                m.Type = 1;
                break;
            case "Secp256k1":
            case 2:
                m.Type = 2;
                break;
        }
        if (d.Data != null) {
            if (typeof d.Data === "string") $69eb14c388664356$var$$util.base64.decode(d.Data, m.Data = $69eb14c388664356$var$$util.newBuffer($69eb14c388664356$var$$util.base64.length(d.Data)), 0);
            else if (d.Data.length) m.Data = d.Data;
        }
        return m;
    };
    /**
     * Creates a plain object from a PublicKey message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublicKey
     * @static
     * @param {PublicKey} m PublicKey
     * @param {$protobuf.IConversionOptions} [o] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ PublicKey.toObject = function toObject(m, o) {
        if (!o) o = {};
        var d = {};
        if (o.defaults) {
            d.Type = o.enums === String ? "RSA" : 0;
            if (o.bytes === String) d.Data = "";
            else {
                d.Data = [];
                if (o.bytes !== Array) d.Data = $69eb14c388664356$var$$util.newBuffer(d.Data);
            }
        }
        if (m.Type != null && m.hasOwnProperty("Type")) d.Type = o.enums === String ? $69eb14c388664356$var$$root.KeyType[m.Type] : m.Type;
        if (m.Data != null && m.hasOwnProperty("Data")) d.Data = o.bytes === String ? $69eb14c388664356$var$$util.base64.encode(m.Data, 0, m.Data.length) : o.bytes === Array ? Array.prototype.slice.call(m.Data) : m.Data;
        return d;
    };
    /**
     * Converts this PublicKey to JSON.
     * @function toJSON
     * @memberof PublicKey
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ PublicKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
    };
    return PublicKey;
}();
$69eb14c388664356$var$$root.PrivateKey = function() {
    /**
     * Properties of a PrivateKey.
     * @exports IPrivateKey
     * @interface IPrivateKey
     * @property {KeyType} Type PrivateKey Type
     * @property {Uint8Array} Data PrivateKey Data
     */ /**
     * Constructs a new PrivateKey.
     * @exports PrivateKey
     * @classdesc Represents a PrivateKey.
     * @implements IPrivateKey
     * @constructor
     * @param {IPrivateKey=} [p] Properties to set
     */ function PrivateKey(p) {
        if (p) {
            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
        }
    }
    /**
     * PrivateKey Type.
     * @member {KeyType} Type
     * @memberof PrivateKey
     * @instance
     */ PrivateKey.prototype.Type = 0;
    /**
     * PrivateKey Data.
     * @member {Uint8Array} Data
     * @memberof PrivateKey
     * @instance
     */ PrivateKey.prototype.Data = $69eb14c388664356$var$$util.newBuffer([]);
    /**
     * Encodes the specified PrivateKey message. Does not implicitly {@link PrivateKey.verify|verify} messages.
     * @function encode
     * @memberof PrivateKey
     * @static
     * @param {IPrivateKey} m PrivateKey message or plain object to encode
     * @param {$protobuf.Writer} [w] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */ PrivateKey.encode = function encode(m, w) {
        if (!w) w = $69eb14c388664356$var$$Writer.create();
        w.uint32(8).int32(m.Type);
        w.uint32(18).bytes(m.Data);
        return w;
    };
    /**
     * Decodes a PrivateKey message from the specified reader or buffer.
     * @function decode
     * @memberof PrivateKey
     * @static
     * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
     * @param {number} [l] Message length if known beforehand
     * @returns {PrivateKey} PrivateKey
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */ PrivateKey.decode = function decode(r, l) {
        if (!(r instanceof $69eb14c388664356$var$$Reader)) r = $69eb14c388664356$var$$Reader.create(r);
        var c = l === undefined ? r.len : r.pos + l, m = new $69eb14c388664356$var$$root.PrivateKey();
        while(r.pos < c){
            var t = r.uint32();
            switch(t >>> 3){
                case 1:
                    m.Type = r.int32();
                    break;
                case 2:
                    m.Data = r.bytes();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
            }
        }
        if (!m.hasOwnProperty("Type")) throw $69eb14c388664356$var$$util.ProtocolError("missing required 'Type'", {
            instance: m
        });
        if (!m.hasOwnProperty("Data")) throw $69eb14c388664356$var$$util.ProtocolError("missing required 'Data'", {
            instance: m
        });
        return m;
    };
    /**
     * Creates a PrivateKey message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PrivateKey
     * @static
     * @param {Object.<string,*>} d Plain object
     * @returns {PrivateKey} PrivateKey
     */ PrivateKey.fromObject = function fromObject(d) {
        if (d instanceof $69eb14c388664356$var$$root.PrivateKey) return d;
        var m = new $69eb14c388664356$var$$root.PrivateKey();
        switch(d.Type){
            case "RSA":
            case 0:
                m.Type = 0;
                break;
            case "Ed25519":
            case 1:
                m.Type = 1;
                break;
            case "Secp256k1":
            case 2:
                m.Type = 2;
                break;
        }
        if (d.Data != null) {
            if (typeof d.Data === "string") $69eb14c388664356$var$$util.base64.decode(d.Data, m.Data = $69eb14c388664356$var$$util.newBuffer($69eb14c388664356$var$$util.base64.length(d.Data)), 0);
            else if (d.Data.length) m.Data = d.Data;
        }
        return m;
    };
    /**
     * Creates a plain object from a PrivateKey message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PrivateKey
     * @static
     * @param {PrivateKey} m PrivateKey
     * @param {$protobuf.IConversionOptions} [o] Conversion options
     * @returns {Object.<string,*>} Plain object
     */ PrivateKey.toObject = function toObject(m, o) {
        if (!o) o = {};
        var d = {};
        if (o.defaults) {
            d.Type = o.enums === String ? "RSA" : 0;
            if (o.bytes === String) d.Data = "";
            else {
                d.Data = [];
                if (o.bytes !== Array) d.Data = $69eb14c388664356$var$$util.newBuffer(d.Data);
            }
        }
        if (m.Type != null && m.hasOwnProperty("Type")) d.Type = o.enums === String ? $69eb14c388664356$var$$root.KeyType[m.Type] : m.Type;
        if (m.Data != null && m.hasOwnProperty("Data")) d.Data = o.bytes === String ? $69eb14c388664356$var$$util.base64.encode(m.Data, 0, m.Data.length) : o.bytes === Array ? Array.prototype.slice.call(m.Data) : m.Data;
        return d;
    };
    /**
     * Converts this PrivateKey to JSON.
     * @function toJSON
     * @memberof PrivateKey
     * @instance
     * @returns {Object.<string,*>} JSON object
     */ PrivateKey.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $liRmU.util.toJSONOptions);
    };
    return PrivateKey;
}();
module.exports = $69eb14c388664356$var$$root;

});

parcelRequire.register("ans9D", function(module, exports) {
"use strict";

var $eXQx4 = parcelRequire("eXQx4");
var $78e1e4382d305fa4$require$base64 = $eXQx4.base64;

var $agi5f = parcelRequire("agi5f");
module.exports = {
    /**
   * Attempts to decrypt a base64 encoded PrivateKey string
   * with the given password. The privateKey must have been exported
   * using the same password and underlying cipher (aes-gcm)
   *
   * @param {string} privateKey - A base64 encoded encrypted key
   * @param {string} password
   * @returns {Promise<Uint8Array>} The private key protobuf
   */ import: async function(privateKey, password) {
        const encryptedKey = $78e1e4382d305fa4$require$base64.decode(privateKey);
        const cipher = $agi5f.create();
        return await cipher.decrypt(encryptedKey, password);
    }
};

});
parcelRequire.register("agi5f", function(module, exports) {
"use strict";

var $8hEBV = parcelRequire("8hEBV");
var $77896d0dc0367394$require$concat = $8hEBV.concat;

var $8cWjP = parcelRequire("8cWjP");
var $77896d0dc0367394$require$fromString = $8cWjP.fromString;

var $bpHqr = parcelRequire("bpHqr");
// Based off of code from https://github.com/luke-park/SecureCompatibleEncryptionExamples
/**
 *
 * @param {object} [options]
 * @param {string} [options.algorithm=AES-GCM]
 * @param {number} [options.nonceLength=12]
 * @param {number} [options.keyLength=16]
 * @param {string} [options.digest=sha256]
 * @param {number} [options.saltLength=16]
 * @param {number} [options.iterations=32767]
 * @returns {*}
 */ function $77896d0dc0367394$var$create({ algorithm: algorithm = "AES-GCM", nonceLength: nonceLength = 12, keyLength: keyLength = 16, digest: digest = "SHA-256", saltLength: saltLength = 16, iterations: iterations = 32767 } = {}) {
    const crypto = $bpHqr.get();
    keyLength *= 8 // Browser crypto uses bits instead of bytes
    ;
    /**
   * Uses the provided password to derive a pbkdf2 key. The key
   * will then be used to encrypt the data.
   *
   * @param {Uint8Array} data - The data to decrypt
   * @param {string} password - A plain password
   * @returns {Promise<Uint8Array>}
   */ async function encrypt(data, password) {
        const salt = crypto.getRandomValues(new Uint8Array(saltLength));
        const nonce = crypto.getRandomValues(new Uint8Array(nonceLength));
        const aesGcm = {
            name: algorithm,
            iv: nonce
        };
        // Derive a key using PBKDF2.
        const deriveParams = {
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: digest
            }
        };
        const rawKey = await crypto.subtle.importKey("raw", $77896d0dc0367394$require$fromString(password), {
            name: "PBKDF2"
        }, false, [
            "deriveKey",
            "deriveBits"
        ]);
        const cryptoKey = await crypto.subtle.deriveKey(deriveParams, rawKey, {
            name: algorithm,
            length: keyLength
        }, true, [
            "encrypt"
        ]);
        // Encrypt the string.
        const ciphertext = await crypto.subtle.encrypt(aesGcm, cryptoKey, data);
        return $77896d0dc0367394$require$concat([
            salt,
            aesGcm.iv,
            new Uint8Array(ciphertext)
        ]);
    }
    /**
   * Uses the provided password to derive a pbkdf2 key. The key
   * will then be used to decrypt the data. The options used to create
   * this decryption cipher must be the same as those used to create
   * the encryption cipher.
   *
   * @param {Uint8Array} data - The data to decrypt
   * @param {string} password - A plain password
   * @returns {Promise<Uint8Array>}
   */ async function decrypt(data, password) {
        const salt = data.slice(0, saltLength);
        const nonce = data.slice(saltLength, saltLength + nonceLength);
        const ciphertext = data.slice(saltLength + nonceLength);
        const aesGcm = {
            name: algorithm,
            iv: nonce
        };
        // Derive the key using PBKDF2.
        const deriveParams = {
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: digest
            }
        };
        const rawKey = await crypto.subtle.importKey("raw", $77896d0dc0367394$require$fromString(password), {
            name: "PBKDF2"
        }, false, [
            "deriveKey",
            "deriveBits"
        ]);
        const cryptoKey = await crypto.subtle.deriveKey(deriveParams, rawKey, {
            name: algorithm,
            length: keyLength
        }, true, [
            "decrypt"
        ]);
        // Decrypt the string.
        const plaintext = await crypto.subtle.decrypt(aesGcm, cryptoKey, ciphertext);
        return new Uint8Array(plaintext);
    }
    return {
        encrypt: encrypt,
        decrypt: decrypt
    };
}
module.exports = {
    create: $77896d0dc0367394$var$create
};

});


parcelRequire.register("ec9zu", function(module, exports) {
"use strict";

var $gTOvd = parcelRequire("gTOvd");
var $a5599c58666164f1$require$sha256 = $gTOvd.sha256;

var $20Lm5 = parcelRequire("20Lm5");

var $ijWXY = parcelRequire("ijWXY");
var $a5599c58666164f1$require$uint8ArrayEquals = $ijWXY.equals;

var $6rBCs = parcelRequire("6rBCs");
var $a5599c58666164f1$require$uint8ArrayToString = $6rBCs.toString;
parcelRequire("acTBK");
parcelRequire("knsWb");

var $2xc86 = parcelRequire("2xc86");

var $5V3tR = parcelRequire("5V3tR");

var $95NDj = parcelRequire("95NDj");

var $j06ar = parcelRequire("j06ar");
class $a5599c58666164f1$var$RsaPublicKey {
    constructor(key){
        this._key = key;
    }
    async verify(data, sig) {
        return $5V3tR.hashAndVerify(this._key, sig, data);
    }
    marshal() {
        return $5V3tR.utils.jwkToPkix(this._key);
    }
    get bytes() {
        return $95NDj.PublicKey.encode({
            Type: $95NDj.KeyType.RSA,
            Data: this.marshal()
        }).finish();
    }
    encrypt(bytes) {
        return $5V3tR.encrypt(this._key, bytes);
    }
    equals(key) {
        return $a5599c58666164f1$require$uint8ArrayEquals(this.bytes, key.bytes);
    }
    async hash() {
        const { bytes: bytes } = await $a5599c58666164f1$require$sha256.digest(this.bytes);
        return bytes;
    }
}
class $a5599c58666164f1$var$RsaPrivateKey {
    // key       - Object of the jwk format
    // publicKey - Uint8Array of the spki format
    constructor(key, publicKey){
        this._key = key;
        this._publicKey = publicKey;
    }
    genSecret() {
        return $5V3tR.getRandomValues(16);
    }
    async sign(message) {
        return $5V3tR.hashAndSign(this._key, message);
    }
    get public() {
        if (!this._publicKey) throw $20Lm5(new Error("public key not provided"), "ERR_PUBKEY_NOT_PROVIDED");
        return new $a5599c58666164f1$var$RsaPublicKey(this._publicKey);
    }
    decrypt(bytes) {
        return $5V3tR.decrypt(this._key, bytes);
    }
    marshal() {
        return $5V3tR.utils.jwkToPkcs1(this._key);
    }
    get bytes() {
        return $95NDj.PrivateKey.encode({
            Type: $95NDj.KeyType.RSA,
            Data: this.marshal()
        }).finish();
    }
    equals(key) {
        return $a5599c58666164f1$require$uint8ArrayEquals(this.bytes, key.bytes);
    }
    async hash() {
        const { bytes: bytes } = await $a5599c58666164f1$require$sha256.digest(this.bytes);
        return bytes;
    }
    /**
   * Gets the ID of the key.
   *
   * The key id is the base58 encoding of the SHA-256 multihash of its public key.
   * The public key is a protobuf encoding containing a type and the DER encoding
   * of the PKCS SubjectPublicKeyInfo.
   *
   * @returns {Promise<string>}
   */ async id() {
        const hash = await this.public.hash();
        return $a5599c58666164f1$require$uint8ArrayToString(hash, "base58btc");
    }
    /**
   * Exports the key into a password protected PEM format
   *
   * @param {string} password - The password to read the encrypted PEM
   * @param {string} [format=pkcs-8] - The format in which to export as
   */ async export(password, format = "pkcs-8") {
        if (format === "pkcs-8") {
            const buffer = new $2xc86.util.ByteBuffer(this.marshal());
            const asn1 = $2xc86.asn1.fromDer(buffer);
            const privateKey = $2xc86.pki.privateKeyFromAsn1(asn1);
            const options = {
                algorithm: "aes256",
                count: 10000,
                saltSize: 16,
                prfAlgorithm: "sha512"
            };
            return $2xc86.pki.encryptRsaPrivateKey(privateKey, password, options);
        } else if (format === "libp2p-key") return $j06ar.export(this.bytes, password);
        else throw $20Lm5(new Error(`export format '${format}' is not supported`), "ERR_INVALID_EXPORT_FORMAT");
    }
}
async function $a5599c58666164f1$var$unmarshalRsaPrivateKey(bytes) {
    const jwk = $5V3tR.utils.pkcs1ToJwk(bytes);
    const keys = await $5V3tR.unmarshalPrivateKey(jwk);
    return new $a5599c58666164f1$var$RsaPrivateKey(keys.privateKey, keys.publicKey);
}
function $a5599c58666164f1$var$unmarshalRsaPublicKey(bytes) {
    const jwk = $5V3tR.utils.pkixToJwk(bytes);
    return new $a5599c58666164f1$var$RsaPublicKey(jwk);
}
async function $a5599c58666164f1$var$fromJwk(jwk) {
    const keys = await $5V3tR.unmarshalPrivateKey(jwk);
    return new $a5599c58666164f1$var$RsaPrivateKey(keys.privateKey, keys.publicKey);
}
async function $a5599c58666164f1$var$generateKeyPair(bits) {
    const keys = await $5V3tR.generateKey(bits);
    return new $a5599c58666164f1$var$RsaPrivateKey(keys.privateKey, keys.publicKey);
}
module.exports = {
    RsaPublicKey: $a5599c58666164f1$var$RsaPublicKey,
    RsaPrivateKey: $a5599c58666164f1$var$RsaPrivateKey,
    unmarshalRsaPublicKey: $a5599c58666164f1$var$unmarshalRsaPublicKey,
    unmarshalRsaPrivateKey: $a5599c58666164f1$var$unmarshalRsaPrivateKey,
    generateKeyPair: $a5599c58666164f1$var$generateKeyPair,
    fromJwk: $a5599c58666164f1$var$fromJwk
};

});
parcelRequire.register("knsWb", function(module, exports) {
/**
 * JavaScript implementation of Ed25519.
 *
 * Copyright (c) 2017-2019 Digital Bazaar, Inc.
 *
 * This implementation is based on the most excellent TweetNaCl which is
 * in the public domain. Many thanks to its contributors:
 *
 * https://github.com/dchest/tweetnacl-js
 */ 
var $7jzxY = parcelRequire("7jzxY");
var $ed5c67012cf04f85$require$Buffer = $7jzxY.Buffer;

var $2xc86 = parcelRequire("2xc86");
parcelRequire("ft6fW");
parcelRequire("eeWuT");
parcelRequire("acTBK");
parcelRequire("e73pV");

var $iNjQQ = parcelRequire("iNjQQ");
var $ed5c67012cf04f85$var$publicKeyValidator = $iNjQQ.publicKeyValidator;
var $ed5c67012cf04f85$var$privateKeyValidator = $iNjQQ.privateKeyValidator;
if (typeof $ed5c67012cf04f85$var$BigInteger === "undefined") var $ed5c67012cf04f85$var$BigInteger = $2xc86.jsbn.BigInteger;
var $ed5c67012cf04f85$var$ByteBuffer = $2xc86.util.ByteBuffer;
var $ed5c67012cf04f85$var$NativeBuffer = typeof $ed5c67012cf04f85$require$Buffer === "undefined" ? Uint8Array : $ed5c67012cf04f85$require$Buffer;
/*
 * Ed25519 algorithms, see RFC 8032:
 * https://tools.ietf.org/html/rfc8032
 */ $2xc86.pki = $2xc86.pki || {};
module.exports = $2xc86.pki.ed25519 = $2xc86.ed25519 = $2xc86.ed25519 || {};
var $ed5c67012cf04f85$var$ed25519 = $2xc86.ed25519;
$ed5c67012cf04f85$var$ed25519.constants = {};
$ed5c67012cf04f85$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH = 32;
$ed5c67012cf04f85$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH = 64;
$ed5c67012cf04f85$var$ed25519.constants.SEED_BYTE_LENGTH = 32;
$ed5c67012cf04f85$var$ed25519.constants.SIGN_BYTE_LENGTH = 64;
$ed5c67012cf04f85$var$ed25519.constants.HASH_BYTE_LENGTH = 64;
$ed5c67012cf04f85$var$ed25519.generateKeyPair = function(options) {
    options = options || {};
    var seed = options.seed;
    if (seed === undefined) // generate seed
    seed = $2xc86.random.getBytesSync($ed5c67012cf04f85$var$ed25519.constants.SEED_BYTE_LENGTH);
    else if (typeof seed === "string") {
        if (seed.length !== $ed5c67012cf04f85$var$ed25519.constants.SEED_BYTE_LENGTH) throw new TypeError('"seed" must be ' + $ed5c67012cf04f85$var$ed25519.constants.SEED_BYTE_LENGTH + " bytes in length.");
    } else if (!(seed instanceof Uint8Array)) throw new TypeError('"seed" must be a node.js Buffer, Uint8Array, or a binary string.');
    seed = $ed5c67012cf04f85$var$messageToNativeBuffer({
        message: seed,
        encoding: "binary"
    });
    var pk = new $ed5c67012cf04f85$var$NativeBuffer($ed5c67012cf04f85$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH);
    var sk = new $ed5c67012cf04f85$var$NativeBuffer($ed5c67012cf04f85$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH);
    for(var i = 0; i < 32; ++i)sk[i] = seed[i];
    $ed5c67012cf04f85$var$crypto_sign_keypair(pk, sk);
    return {
        publicKey: pk,
        privateKey: sk
    };
};
/**
 * Converts a private key from a RFC8410 ASN.1 encoding.
 *
 * @param obj - The asn1 representation of a private key.
 *
 * @returns {Object} keyInfo - The key information.
 * @returns {Buffer|Uint8Array} keyInfo.privateKeyBytes - 32 private key bytes.
 */ $ed5c67012cf04f85$var$ed25519.privateKeyFromAsn1 = function(obj) {
    var capture = {};
    var errors = [];
    var valid = $2xc86.asn1.validate(obj, $ed5c67012cf04f85$var$privateKeyValidator, capture, errors);
    if (!valid) {
        var error = new Error("Invalid Key.");
        error.errors = errors;
        throw error;
    }
    var oid = $2xc86.asn1.derToOid(capture.privateKeyOid);
    var ed25519Oid = $2xc86.oids.EdDSA25519;
    if (oid !== ed25519Oid) throw new Error('Invalid OID "' + oid + '"; OID must be "' + ed25519Oid + '".');
    var privateKey = capture.privateKey;
    // manually extract the private key bytes from nested octet string, see FIXME:
    // https://github.com/digitalbazaar/forge/blob/master/lib/asn1.js#L542
    var privateKeyBytes = $ed5c67012cf04f85$var$messageToNativeBuffer({
        message: $2xc86.asn1.fromDer(privateKey).value,
        encoding: "binary"
    });
    // TODO: RFC8410 specifies a format for encoding the public key bytes along
    // with the private key bytes. `publicKeyBytes` can be returned in the
    // future. https://tools.ietf.org/html/rfc8410#section-10.3
    return {
        privateKeyBytes: privateKeyBytes
    };
};
/**
 * Converts a public key from a RFC8410 ASN.1 encoding.
 *
 * @param obj - The asn1 representation of a public key.
 *
 * @return {Buffer|Uint8Array} - 32 public key bytes.
 */ $ed5c67012cf04f85$var$ed25519.publicKeyFromAsn1 = function(obj) {
    // get SubjectPublicKeyInfo
    var capture = {};
    var errors = [];
    var valid = $2xc86.asn1.validate(obj, $ed5c67012cf04f85$var$publicKeyValidator, capture, errors);
    if (!valid) {
        var error = new Error("Invalid Key.");
        error.errors = errors;
        throw error;
    }
    var oid = $2xc86.asn1.derToOid(capture.publicKeyOid);
    var ed25519Oid = $2xc86.oids.EdDSA25519;
    if (oid !== ed25519Oid) throw new Error('Invalid OID "' + oid + '"; OID must be "' + ed25519Oid + '".');
    var publicKeyBytes = capture.ed25519PublicKey;
    if (publicKeyBytes.length !== $ed5c67012cf04f85$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH) throw new Error("Key length is invalid.");
    return $ed5c67012cf04f85$var$messageToNativeBuffer({
        message: publicKeyBytes,
        encoding: "binary"
    });
};
$ed5c67012cf04f85$var$ed25519.publicKeyFromPrivateKey = function(options) {
    options = options || {};
    var privateKey = $ed5c67012cf04f85$var$messageToNativeBuffer({
        message: options.privateKey,
        encoding: "binary"
    });
    if (privateKey.length !== $ed5c67012cf04f85$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH) throw new TypeError('"options.privateKey" must have a byte length of ' + $ed5c67012cf04f85$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH);
    var pk = new $ed5c67012cf04f85$var$NativeBuffer($ed5c67012cf04f85$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH);
    for(var i = 0; i < pk.length; ++i)pk[i] = privateKey[32 + i];
    return pk;
};
$ed5c67012cf04f85$var$ed25519.sign = function(options) {
    options = options || {};
    var msg = $ed5c67012cf04f85$var$messageToNativeBuffer(options);
    var privateKey = $ed5c67012cf04f85$var$messageToNativeBuffer({
        message: options.privateKey,
        encoding: "binary"
    });
    if (privateKey.length === $ed5c67012cf04f85$var$ed25519.constants.SEED_BYTE_LENGTH) {
        var keyPair = $ed5c67012cf04f85$var$ed25519.generateKeyPair({
            seed: privateKey
        });
        privateKey = keyPair.privateKey;
    } else if (privateKey.length !== $ed5c67012cf04f85$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH) throw new TypeError('"options.privateKey" must have a byte length of ' + $ed5c67012cf04f85$var$ed25519.constants.SEED_BYTE_LENGTH + " or " + $ed5c67012cf04f85$var$ed25519.constants.PRIVATE_KEY_BYTE_LENGTH);
    var signedMsg = new $ed5c67012cf04f85$var$NativeBuffer($ed5c67012cf04f85$var$ed25519.constants.SIGN_BYTE_LENGTH + msg.length);
    $ed5c67012cf04f85$var$crypto_sign(signedMsg, msg, msg.length, privateKey);
    var sig = new $ed5c67012cf04f85$var$NativeBuffer($ed5c67012cf04f85$var$ed25519.constants.SIGN_BYTE_LENGTH);
    for(var i = 0; i < sig.length; ++i)sig[i] = signedMsg[i];
    return sig;
};
$ed5c67012cf04f85$var$ed25519.verify = function(options) {
    options = options || {};
    var msg = $ed5c67012cf04f85$var$messageToNativeBuffer(options);
    if (options.signature === undefined) throw new TypeError('"options.signature" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a binary string.');
    var sig = $ed5c67012cf04f85$var$messageToNativeBuffer({
        message: options.signature,
        encoding: "binary"
    });
    if (sig.length !== $ed5c67012cf04f85$var$ed25519.constants.SIGN_BYTE_LENGTH) throw new TypeError('"options.signature" must have a byte length of ' + $ed5c67012cf04f85$var$ed25519.constants.SIGN_BYTE_LENGTH);
    var publicKey = $ed5c67012cf04f85$var$messageToNativeBuffer({
        message: options.publicKey,
        encoding: "binary"
    });
    if (publicKey.length !== $ed5c67012cf04f85$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH) throw new TypeError('"options.publicKey" must have a byte length of ' + $ed5c67012cf04f85$var$ed25519.constants.PUBLIC_KEY_BYTE_LENGTH);
    var sm = new $ed5c67012cf04f85$var$NativeBuffer($ed5c67012cf04f85$var$ed25519.constants.SIGN_BYTE_LENGTH + msg.length);
    var m = new $ed5c67012cf04f85$var$NativeBuffer($ed5c67012cf04f85$var$ed25519.constants.SIGN_BYTE_LENGTH + msg.length);
    var i;
    for(i = 0; i < $ed5c67012cf04f85$var$ed25519.constants.SIGN_BYTE_LENGTH; ++i)sm[i] = sig[i];
    for(i = 0; i < msg.length; ++i)sm[i + $ed5c67012cf04f85$var$ed25519.constants.SIGN_BYTE_LENGTH] = msg[i];
    return $ed5c67012cf04f85$var$crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
};
function $ed5c67012cf04f85$var$messageToNativeBuffer(options) {
    var message = options.message;
    if (message instanceof Uint8Array || message instanceof $ed5c67012cf04f85$var$NativeBuffer) return message;
    var encoding = options.encoding;
    if (message === undefined) {
        if (options.md) {
            // TODO: more rigorous validation that `md` is a MessageDigest
            message = options.md.digest().getBytes();
            encoding = "binary";
        } else throw new TypeError('"options.message" or "options.md" not specified.');
    }
    if (typeof message === "string" && !encoding) throw new TypeError('"options.encoding" must be "binary" or "utf8".');
    if (typeof message === "string") {
        if (typeof $ed5c67012cf04f85$require$Buffer !== "undefined") return $ed5c67012cf04f85$require$Buffer.from(message, encoding);
        message = new $ed5c67012cf04f85$var$ByteBuffer(message, encoding);
    } else if (!(message instanceof $ed5c67012cf04f85$var$ByteBuffer)) throw new TypeError('"options.message" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a string with "options.encoding" specifying its encoding.');
    // convert to native buffer
    var buffer = new $ed5c67012cf04f85$var$NativeBuffer(message.length());
    for(var i = 0; i < buffer.length; ++i)buffer[i] = message.at(i);
    return buffer;
}
var $ed5c67012cf04f85$var$gf0 = $ed5c67012cf04f85$var$gf();
var $ed5c67012cf04f85$var$gf1 = $ed5c67012cf04f85$var$gf([
    1
]);
var $ed5c67012cf04f85$var$D = $ed5c67012cf04f85$var$gf([
    0x78a3,
    0x1359,
    0x4dca,
    0x75eb,
    0xd8ab,
    0x4141,
    0x0a4d,
    0x0070,
    0xe898,
    0x7779,
    0x4079,
    0x8cc7,
    0xfe73,
    0x2b6f,
    0x6cee,
    0x5203
]);
var $ed5c67012cf04f85$var$D2 = $ed5c67012cf04f85$var$gf([
    0xf159,
    0x26b2,
    0x9b94,
    0xebd6,
    0xb156,
    0x8283,
    0x149a,
    0x00e0,
    0xd130,
    0xeef3,
    0x80f2,
    0x198e,
    0xfce7,
    0x56df,
    0xd9dc,
    0x2406
]);
var $ed5c67012cf04f85$var$X = $ed5c67012cf04f85$var$gf([
    0xd51a,
    0x8f25,
    0x2d60,
    0xc956,
    0xa7b2,
    0x9525,
    0xc760,
    0x692c,
    0xdc5c,
    0xfdd6,
    0xe231,
    0xc0a4,
    0x53fe,
    0xcd6e,
    0x36d3,
    0x2169
]);
var $ed5c67012cf04f85$var$Y = $ed5c67012cf04f85$var$gf([
    0x6658,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666,
    0x6666
]);
var $ed5c67012cf04f85$var$L = new Float64Array([
    0xed,
    0xd3,
    0xf5,
    0x5c,
    0x1a,
    0x63,
    0x12,
    0x58,
    0xd6,
    0x9c,
    0xf7,
    0xa2,
    0xde,
    0xf9,
    0xde,
    0x14,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0x10
]);
var $ed5c67012cf04f85$var$I = $ed5c67012cf04f85$var$gf([
    0xa0b0,
    0x4a0e,
    0x1b27,
    0xc4ee,
    0xe478,
    0xad2f,
    0x1806,
    0x2f43,
    0xd7a7,
    0x3dfb,
    0x0099,
    0x2b4d,
    0xdf0b,
    0x4fc1,
    0x2480,
    0x2b83
]);
// TODO: update forge buffer implementation to use `Buffer` or `Uint8Array`,
// whichever is available, to improve performance
function $ed5c67012cf04f85$var$sha512(msg, msgLen) {
    // Note: `out` and `msg` are NativeBuffer
    var md = $2xc86.md.sha512.create();
    var buffer = new $ed5c67012cf04f85$var$ByteBuffer(msg);
    md.update(buffer.getBytes(msgLen), "binary");
    var hash = md.digest().getBytes();
    if (typeof $ed5c67012cf04f85$require$Buffer !== "undefined") return $ed5c67012cf04f85$require$Buffer.from(hash, "binary");
    var out = new $ed5c67012cf04f85$var$NativeBuffer($ed5c67012cf04f85$var$ed25519.constants.HASH_BYTE_LENGTH);
    for(var i = 0; i < 64; ++i)out[i] = hash.charCodeAt(i);
    return out;
}
function $ed5c67012cf04f85$var$crypto_sign_keypair(pk, sk) {
    var p = [
        $ed5c67012cf04f85$var$gf(),
        $ed5c67012cf04f85$var$gf(),
        $ed5c67012cf04f85$var$gf(),
        $ed5c67012cf04f85$var$gf()
    ];
    var i;
    var d = $ed5c67012cf04f85$var$sha512(sk, 32);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    $ed5c67012cf04f85$var$scalarbase(p, d);
    $ed5c67012cf04f85$var$pack(pk, p);
    for(i = 0; i < 32; ++i)sk[i + 32] = pk[i];
    return 0;
}
// Note: difference from C - smlen returned, not passed as argument.
function $ed5c67012cf04f85$var$crypto_sign(sm, m, n, sk) {
    var i, j, x = new Float64Array(64);
    var p = [
        $ed5c67012cf04f85$var$gf(),
        $ed5c67012cf04f85$var$gf(),
        $ed5c67012cf04f85$var$gf(),
        $ed5c67012cf04f85$var$gf()
    ];
    var d = $ed5c67012cf04f85$var$sha512(sk, 32);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    var smlen = n + 64;
    for(i = 0; i < n; ++i)sm[64 + i] = m[i];
    for(i = 0; i < 32; ++i)sm[32 + i] = d[32 + i];
    var r = $ed5c67012cf04f85$var$sha512(sm.subarray(32), n + 32);
    $ed5c67012cf04f85$var$reduce(r);
    $ed5c67012cf04f85$var$scalarbase(p, r);
    $ed5c67012cf04f85$var$pack(sm, p);
    for(i = 32; i < 64; ++i)sm[i] = sk[i];
    var h = $ed5c67012cf04f85$var$sha512(sm, n + 64);
    $ed5c67012cf04f85$var$reduce(h);
    for(i = 32; i < 64; ++i)x[i] = 0;
    for(i = 0; i < 32; ++i)x[i] = r[i];
    for(i = 0; i < 32; ++i)for(j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
    $ed5c67012cf04f85$var$modL(sm.subarray(32), x);
    return smlen;
}
function $ed5c67012cf04f85$var$crypto_sign_open(m, sm, n, pk) {
    var i, mlen;
    var t = new $ed5c67012cf04f85$var$NativeBuffer(32);
    var p = [
        $ed5c67012cf04f85$var$gf(),
        $ed5c67012cf04f85$var$gf(),
        $ed5c67012cf04f85$var$gf(),
        $ed5c67012cf04f85$var$gf()
    ], q = [
        $ed5c67012cf04f85$var$gf(),
        $ed5c67012cf04f85$var$gf(),
        $ed5c67012cf04f85$var$gf(),
        $ed5c67012cf04f85$var$gf()
    ];
    mlen = -1;
    if (n < 64) return -1;
    if ($ed5c67012cf04f85$var$unpackneg(q, pk)) return -1;
    for(i = 0; i < n; ++i)m[i] = sm[i];
    for(i = 0; i < 32; ++i)m[i + 32] = pk[i];
    var h = $ed5c67012cf04f85$var$sha512(m, n);
    $ed5c67012cf04f85$var$reduce(h);
    $ed5c67012cf04f85$var$scalarmult(p, q, h);
    $ed5c67012cf04f85$var$scalarbase(q, sm.subarray(32));
    $ed5c67012cf04f85$var$add(p, q);
    $ed5c67012cf04f85$var$pack(t, p);
    n -= 64;
    if ($ed5c67012cf04f85$var$crypto_verify_32(sm, 0, t, 0)) {
        for(i = 0; i < n; ++i)m[i] = 0;
        return -1;
    }
    for(i = 0; i < n; ++i)m[i] = sm[i + 64];
    mlen = n;
    return mlen;
}
function $ed5c67012cf04f85$var$modL(r, x) {
    var carry, i, j, k;
    for(i = 63; i >= 32; --i){
        carry = 0;
        for(j = i - 32, k = i - 12; j < k; ++j){
            x[j] += carry - 16 * x[i] * $ed5c67012cf04f85$var$L[j - (i - 32)];
            carry = x[j] + 128 >> 8;
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for(j = 0; j < 32; ++j){
        x[j] += carry - (x[31] >> 4) * $ed5c67012cf04f85$var$L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for(j = 0; j < 32; ++j)x[j] -= carry * $ed5c67012cf04f85$var$L[j];
    for(i = 0; i < 32; ++i){
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function $ed5c67012cf04f85$var$reduce(r) {
    var x = new Float64Array(64);
    for(var i = 0; i < 64; ++i){
        x[i] = r[i];
        r[i] = 0;
    }
    $ed5c67012cf04f85$var$modL(r, x);
}
function $ed5c67012cf04f85$var$add(p, q) {
    var a = $ed5c67012cf04f85$var$gf(), b = $ed5c67012cf04f85$var$gf(), c = $ed5c67012cf04f85$var$gf(), d = $ed5c67012cf04f85$var$gf(), e = $ed5c67012cf04f85$var$gf(), f = $ed5c67012cf04f85$var$gf(), g = $ed5c67012cf04f85$var$gf(), h = $ed5c67012cf04f85$var$gf(), t = $ed5c67012cf04f85$var$gf();
    $ed5c67012cf04f85$var$Z(a, p[1], p[0]);
    $ed5c67012cf04f85$var$Z(t, q[1], q[0]);
    $ed5c67012cf04f85$var$M(a, a, t);
    $ed5c67012cf04f85$var$A(b, p[0], p[1]);
    $ed5c67012cf04f85$var$A(t, q[0], q[1]);
    $ed5c67012cf04f85$var$M(b, b, t);
    $ed5c67012cf04f85$var$M(c, p[3], q[3]);
    $ed5c67012cf04f85$var$M(c, c, $ed5c67012cf04f85$var$D2);
    $ed5c67012cf04f85$var$M(d, p[2], q[2]);
    $ed5c67012cf04f85$var$A(d, d, d);
    $ed5c67012cf04f85$var$Z(e, b, a);
    $ed5c67012cf04f85$var$Z(f, d, c);
    $ed5c67012cf04f85$var$A(g, d, c);
    $ed5c67012cf04f85$var$A(h, b, a);
    $ed5c67012cf04f85$var$M(p[0], e, f);
    $ed5c67012cf04f85$var$M(p[1], h, g);
    $ed5c67012cf04f85$var$M(p[2], g, f);
    $ed5c67012cf04f85$var$M(p[3], e, h);
}
function $ed5c67012cf04f85$var$cswap(p, q, b) {
    for(var i = 0; i < 4; ++i)$ed5c67012cf04f85$var$sel25519(p[i], q[i], b);
}
function $ed5c67012cf04f85$var$pack(r, p) {
    var tx = $ed5c67012cf04f85$var$gf(), ty = $ed5c67012cf04f85$var$gf(), zi = $ed5c67012cf04f85$var$gf();
    $ed5c67012cf04f85$var$inv25519(zi, p[2]);
    $ed5c67012cf04f85$var$M(tx, p[0], zi);
    $ed5c67012cf04f85$var$M(ty, p[1], zi);
    $ed5c67012cf04f85$var$pack25519(r, ty);
    r[31] ^= $ed5c67012cf04f85$var$par25519(tx) << 7;
}
function $ed5c67012cf04f85$var$pack25519(o, n) {
    var i, j, b;
    var m = $ed5c67012cf04f85$var$gf(), t = $ed5c67012cf04f85$var$gf();
    for(i = 0; i < 16; ++i)t[i] = n[i];
    $ed5c67012cf04f85$var$car25519(t);
    $ed5c67012cf04f85$var$car25519(t);
    $ed5c67012cf04f85$var$car25519(t);
    for(j = 0; j < 2; ++j){
        m[0] = t[0] - 0xffed;
        for(i = 1; i < 15; ++i){
            m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
        b = m[15] >> 16 & 1;
        m[14] &= 0xffff;
        $ed5c67012cf04f85$var$sel25519(t, m, 1 - b);
    }
    for(i = 0; i < 16; i++){
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function $ed5c67012cf04f85$var$unpackneg(r, p) {
    var t = $ed5c67012cf04f85$var$gf(), chk = $ed5c67012cf04f85$var$gf(), num = $ed5c67012cf04f85$var$gf(), den = $ed5c67012cf04f85$var$gf(), den2 = $ed5c67012cf04f85$var$gf(), den4 = $ed5c67012cf04f85$var$gf(), den6 = $ed5c67012cf04f85$var$gf();
    $ed5c67012cf04f85$var$set25519(r[2], $ed5c67012cf04f85$var$gf1);
    $ed5c67012cf04f85$var$unpack25519(r[1], p);
    $ed5c67012cf04f85$var$S(num, r[1]);
    $ed5c67012cf04f85$var$M(den, num, $ed5c67012cf04f85$var$D);
    $ed5c67012cf04f85$var$Z(num, num, r[2]);
    $ed5c67012cf04f85$var$A(den, r[2], den);
    $ed5c67012cf04f85$var$S(den2, den);
    $ed5c67012cf04f85$var$S(den4, den2);
    $ed5c67012cf04f85$var$M(den6, den4, den2);
    $ed5c67012cf04f85$var$M(t, den6, num);
    $ed5c67012cf04f85$var$M(t, t, den);
    $ed5c67012cf04f85$var$pow2523(t, t);
    $ed5c67012cf04f85$var$M(t, t, num);
    $ed5c67012cf04f85$var$M(t, t, den);
    $ed5c67012cf04f85$var$M(t, t, den);
    $ed5c67012cf04f85$var$M(r[0], t, den);
    $ed5c67012cf04f85$var$S(chk, r[0]);
    $ed5c67012cf04f85$var$M(chk, chk, den);
    if ($ed5c67012cf04f85$var$neq25519(chk, num)) $ed5c67012cf04f85$var$M(r[0], r[0], $ed5c67012cf04f85$var$I);
    $ed5c67012cf04f85$var$S(chk, r[0]);
    $ed5c67012cf04f85$var$M(chk, chk, den);
    if ($ed5c67012cf04f85$var$neq25519(chk, num)) return -1;
    if ($ed5c67012cf04f85$var$par25519(r[0]) === p[31] >> 7) $ed5c67012cf04f85$var$Z(r[0], $ed5c67012cf04f85$var$gf0, r[0]);
    $ed5c67012cf04f85$var$M(r[3], r[0], r[1]);
    return 0;
}
function $ed5c67012cf04f85$var$unpack25519(o, n) {
    var i;
    for(i = 0; i < 16; ++i)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function $ed5c67012cf04f85$var$pow2523(o, i) {
    var c = $ed5c67012cf04f85$var$gf();
    var a;
    for(a = 0; a < 16; ++a)c[a] = i[a];
    for(a = 250; a >= 0; --a){
        $ed5c67012cf04f85$var$S(c, c);
        if (a !== 1) $ed5c67012cf04f85$var$M(c, c, i);
    }
    for(a = 0; a < 16; ++a)o[a] = c[a];
}
function $ed5c67012cf04f85$var$neq25519(a, b) {
    var c = new $ed5c67012cf04f85$var$NativeBuffer(32);
    var d = new $ed5c67012cf04f85$var$NativeBuffer(32);
    $ed5c67012cf04f85$var$pack25519(c, a);
    $ed5c67012cf04f85$var$pack25519(d, b);
    return $ed5c67012cf04f85$var$crypto_verify_32(c, 0, d, 0);
}
function $ed5c67012cf04f85$var$crypto_verify_32(x, xi, y, yi) {
    return $ed5c67012cf04f85$var$vn(x, xi, y, yi, 32);
}
function $ed5c67012cf04f85$var$vn(x, xi, y, yi, n) {
    var i, d = 0;
    for(i = 0; i < n; ++i)d |= x[xi + i] ^ y[yi + i];
    return (1 & d - 1 >>> 8) - 1;
}
function $ed5c67012cf04f85$var$par25519(a) {
    var d = new $ed5c67012cf04f85$var$NativeBuffer(32);
    $ed5c67012cf04f85$var$pack25519(d, a);
    return d[0] & 1;
}
function $ed5c67012cf04f85$var$scalarmult(p, q, s) {
    var b, i;
    $ed5c67012cf04f85$var$set25519(p[0], $ed5c67012cf04f85$var$gf0);
    $ed5c67012cf04f85$var$set25519(p[1], $ed5c67012cf04f85$var$gf1);
    $ed5c67012cf04f85$var$set25519(p[2], $ed5c67012cf04f85$var$gf1);
    $ed5c67012cf04f85$var$set25519(p[3], $ed5c67012cf04f85$var$gf0);
    for(i = 255; i >= 0; --i){
        b = s[i / 8 | 0] >> (i & 7) & 1;
        $ed5c67012cf04f85$var$cswap(p, q, b);
        $ed5c67012cf04f85$var$add(q, p);
        $ed5c67012cf04f85$var$add(p, p);
        $ed5c67012cf04f85$var$cswap(p, q, b);
    }
}
function $ed5c67012cf04f85$var$scalarbase(p, s) {
    var q = [
        $ed5c67012cf04f85$var$gf(),
        $ed5c67012cf04f85$var$gf(),
        $ed5c67012cf04f85$var$gf(),
        $ed5c67012cf04f85$var$gf()
    ];
    $ed5c67012cf04f85$var$set25519(q[0], $ed5c67012cf04f85$var$X);
    $ed5c67012cf04f85$var$set25519(q[1], $ed5c67012cf04f85$var$Y);
    $ed5c67012cf04f85$var$set25519(q[2], $ed5c67012cf04f85$var$gf1);
    $ed5c67012cf04f85$var$M(q[3], $ed5c67012cf04f85$var$X, $ed5c67012cf04f85$var$Y);
    $ed5c67012cf04f85$var$scalarmult(p, q, s);
}
function $ed5c67012cf04f85$var$set25519(r, a) {
    var i;
    for(i = 0; i < 16; i++)r[i] = a[i] | 0;
}
function $ed5c67012cf04f85$var$inv25519(o, i) {
    var c = $ed5c67012cf04f85$var$gf();
    var a;
    for(a = 0; a < 16; ++a)c[a] = i[a];
    for(a = 253; a >= 0; --a){
        $ed5c67012cf04f85$var$S(c, c);
        if (a !== 2 && a !== 4) $ed5c67012cf04f85$var$M(c, c, i);
    }
    for(a = 0; a < 16; ++a)o[a] = c[a];
}
function $ed5c67012cf04f85$var$car25519(o) {
    var i, v, c = 1;
    for(i = 0; i < 16; ++i){
        v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
    }
    o[0] += c - 1 + 37 * (c - 1);
}
function $ed5c67012cf04f85$var$sel25519(p, q, b) {
    var t, c = ~(b - 1);
    for(var i = 0; i < 16; ++i){
        t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function $ed5c67012cf04f85$var$gf(init) {
    var i, r = new Float64Array(16);
    if (init) for(i = 0; i < init.length; ++i)r[i] = init[i];
    return r;
}
function $ed5c67012cf04f85$var$A(o, a, b) {
    for(var i = 0; i < 16; ++i)o[i] = a[i] + b[i];
}
function $ed5c67012cf04f85$var$Z(o, a, b) {
    for(var i = 0; i < 16; ++i)o[i] = a[i] - b[i];
}
function $ed5c67012cf04f85$var$S(o, a) {
    $ed5c67012cf04f85$var$M(o, a, a);
}
function $ed5c67012cf04f85$var$M(o, a, b) {
    var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    v = a[0];
    t0 += v * b0;
    t1 += v * b1;
    t2 += v * b2;
    t3 += v * b3;
    t4 += v * b4;
    t5 += v * b5;
    t6 += v * b6;
    t7 += v * b7;
    t8 += v * b8;
    t9 += v * b9;
    t10 += v * b10;
    t11 += v * b11;
    t12 += v * b12;
    t13 += v * b13;
    t14 += v * b14;
    t15 += v * b15;
    v = a[1];
    t1 += v * b0;
    t2 += v * b1;
    t3 += v * b2;
    t4 += v * b3;
    t5 += v * b4;
    t6 += v * b5;
    t7 += v * b6;
    t8 += v * b7;
    t9 += v * b8;
    t10 += v * b9;
    t11 += v * b10;
    t12 += v * b11;
    t13 += v * b12;
    t14 += v * b13;
    t15 += v * b14;
    t16 += v * b15;
    v = a[2];
    t2 += v * b0;
    t3 += v * b1;
    t4 += v * b2;
    t5 += v * b3;
    t6 += v * b4;
    t7 += v * b5;
    t8 += v * b6;
    t9 += v * b7;
    t10 += v * b8;
    t11 += v * b9;
    t12 += v * b10;
    t13 += v * b11;
    t14 += v * b12;
    t15 += v * b13;
    t16 += v * b14;
    t17 += v * b15;
    v = a[3];
    t3 += v * b0;
    t4 += v * b1;
    t5 += v * b2;
    t6 += v * b3;
    t7 += v * b4;
    t8 += v * b5;
    t9 += v * b6;
    t10 += v * b7;
    t11 += v * b8;
    t12 += v * b9;
    t13 += v * b10;
    t14 += v * b11;
    t15 += v * b12;
    t16 += v * b13;
    t17 += v * b14;
    t18 += v * b15;
    v = a[4];
    t4 += v * b0;
    t5 += v * b1;
    t6 += v * b2;
    t7 += v * b3;
    t8 += v * b4;
    t9 += v * b5;
    t10 += v * b6;
    t11 += v * b7;
    t12 += v * b8;
    t13 += v * b9;
    t14 += v * b10;
    t15 += v * b11;
    t16 += v * b12;
    t17 += v * b13;
    t18 += v * b14;
    t19 += v * b15;
    v = a[5];
    t5 += v * b0;
    t6 += v * b1;
    t7 += v * b2;
    t8 += v * b3;
    t9 += v * b4;
    t10 += v * b5;
    t11 += v * b6;
    t12 += v * b7;
    t13 += v * b8;
    t14 += v * b9;
    t15 += v * b10;
    t16 += v * b11;
    t17 += v * b12;
    t18 += v * b13;
    t19 += v * b14;
    t20 += v * b15;
    v = a[6];
    t6 += v * b0;
    t7 += v * b1;
    t8 += v * b2;
    t9 += v * b3;
    t10 += v * b4;
    t11 += v * b5;
    t12 += v * b6;
    t13 += v * b7;
    t14 += v * b8;
    t15 += v * b9;
    t16 += v * b10;
    t17 += v * b11;
    t18 += v * b12;
    t19 += v * b13;
    t20 += v * b14;
    t21 += v * b15;
    v = a[7];
    t7 += v * b0;
    t8 += v * b1;
    t9 += v * b2;
    t10 += v * b3;
    t11 += v * b4;
    t12 += v * b5;
    t13 += v * b6;
    t14 += v * b7;
    t15 += v * b8;
    t16 += v * b9;
    t17 += v * b10;
    t18 += v * b11;
    t19 += v * b12;
    t20 += v * b13;
    t21 += v * b14;
    t22 += v * b15;
    v = a[8];
    t8 += v * b0;
    t9 += v * b1;
    t10 += v * b2;
    t11 += v * b3;
    t12 += v * b4;
    t13 += v * b5;
    t14 += v * b6;
    t15 += v * b7;
    t16 += v * b8;
    t17 += v * b9;
    t18 += v * b10;
    t19 += v * b11;
    t20 += v * b12;
    t21 += v * b13;
    t22 += v * b14;
    t23 += v * b15;
    v = a[9];
    t9 += v * b0;
    t10 += v * b1;
    t11 += v * b2;
    t12 += v * b3;
    t13 += v * b4;
    t14 += v * b5;
    t15 += v * b6;
    t16 += v * b7;
    t17 += v * b8;
    t18 += v * b9;
    t19 += v * b10;
    t20 += v * b11;
    t21 += v * b12;
    t22 += v * b13;
    t23 += v * b14;
    t24 += v * b15;
    v = a[10];
    t10 += v * b0;
    t11 += v * b1;
    t12 += v * b2;
    t13 += v * b3;
    t14 += v * b4;
    t15 += v * b5;
    t16 += v * b6;
    t17 += v * b7;
    t18 += v * b8;
    t19 += v * b9;
    t20 += v * b10;
    t21 += v * b11;
    t22 += v * b12;
    t23 += v * b13;
    t24 += v * b14;
    t25 += v * b15;
    v = a[11];
    t11 += v * b0;
    t12 += v * b1;
    t13 += v * b2;
    t14 += v * b3;
    t15 += v * b4;
    t16 += v * b5;
    t17 += v * b6;
    t18 += v * b7;
    t19 += v * b8;
    t20 += v * b9;
    t21 += v * b10;
    t22 += v * b11;
    t23 += v * b12;
    t24 += v * b13;
    t25 += v * b14;
    t26 += v * b15;
    v = a[12];
    t12 += v * b0;
    t13 += v * b1;
    t14 += v * b2;
    t15 += v * b3;
    t16 += v * b4;
    t17 += v * b5;
    t18 += v * b6;
    t19 += v * b7;
    t20 += v * b8;
    t21 += v * b9;
    t22 += v * b10;
    t23 += v * b11;
    t24 += v * b12;
    t25 += v * b13;
    t26 += v * b14;
    t27 += v * b15;
    v = a[13];
    t13 += v * b0;
    t14 += v * b1;
    t15 += v * b2;
    t16 += v * b3;
    t17 += v * b4;
    t18 += v * b5;
    t19 += v * b6;
    t20 += v * b7;
    t21 += v * b8;
    t22 += v * b9;
    t23 += v * b10;
    t24 += v * b11;
    t25 += v * b12;
    t26 += v * b13;
    t27 += v * b14;
    t28 += v * b15;
    v = a[14];
    t14 += v * b0;
    t15 += v * b1;
    t16 += v * b2;
    t17 += v * b3;
    t18 += v * b4;
    t19 += v * b5;
    t20 += v * b6;
    t21 += v * b7;
    t22 += v * b8;
    t23 += v * b9;
    t24 += v * b10;
    t25 += v * b11;
    t26 += v * b12;
    t27 += v * b13;
    t28 += v * b14;
    t29 += v * b15;
    v = a[15];
    t15 += v * b0;
    t16 += v * b1;
    t17 += v * b2;
    t18 += v * b3;
    t19 += v * b4;
    t20 += v * b5;
    t21 += v * b6;
    t22 += v * b7;
    t23 += v * b8;
    t24 += v * b9;
    t25 += v * b10;
    t26 += v * b11;
    t27 += v * b12;
    t28 += v * b13;
    t29 += v * b14;
    t30 += v * b15;
    t0 += 38 * t16;
    t1 += 38 * t17;
    t2 += 38 * t18;
    t3 += 38 * t19;
    t4 += 38 * t20;
    t5 += 38 * t21;
    t6 += 38 * t22;
    t7 += 38 * t23;
    t8 += 38 * t24;
    t9 += 38 * t25;
    t10 += 38 * t26;
    t11 += 38 * t27;
    t12 += 38 * t28;
    t13 += 38 * t29;
    t14 += 38 * t30;
    // t15 left as is
    // first car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    // second car
    c = 1;
    v = t0 + c + 65535;
    c = Math.floor(v / 65536);
    t0 = v - c * 65536;
    v = t1 + c + 65535;
    c = Math.floor(v / 65536);
    t1 = v - c * 65536;
    v = t2 + c + 65535;
    c = Math.floor(v / 65536);
    t2 = v - c * 65536;
    v = t3 + c + 65535;
    c = Math.floor(v / 65536);
    t3 = v - c * 65536;
    v = t4 + c + 65535;
    c = Math.floor(v / 65536);
    t4 = v - c * 65536;
    v = t5 + c + 65535;
    c = Math.floor(v / 65536);
    t5 = v - c * 65536;
    v = t6 + c + 65535;
    c = Math.floor(v / 65536);
    t6 = v - c * 65536;
    v = t7 + c + 65535;
    c = Math.floor(v / 65536);
    t7 = v - c * 65536;
    v = t8 + c + 65535;
    c = Math.floor(v / 65536);
    t8 = v - c * 65536;
    v = t9 + c + 65535;
    c = Math.floor(v / 65536);
    t9 = v - c * 65536;
    v = t10 + c + 65535;
    c = Math.floor(v / 65536);
    t10 = v - c * 65536;
    v = t11 + c + 65535;
    c = Math.floor(v / 65536);
    t11 = v - c * 65536;
    v = t12 + c + 65535;
    c = Math.floor(v / 65536);
    t12 = v - c * 65536;
    v = t13 + c + 65535;
    c = Math.floor(v / 65536);
    t13 = v - c * 65536;
    v = t14 + c + 65535;
    c = Math.floor(v / 65536);
    t14 = v - c * 65536;
    v = t15 + c + 65535;
    c = Math.floor(v / 65536);
    t15 = v - c * 65536;
    t0 += c - 1 + 37 * (c - 1);
    o[0] = t0;
    o[1] = t1;
    o[2] = t2;
    o[3] = t3;
    o[4] = t4;
    o[5] = t5;
    o[6] = t6;
    o[7] = t7;
    o[8] = t8;
    o[9] = t9;
    o[10] = t10;
    o[11] = t11;
    o[12] = t12;
    o[13] = t13;
    o[14] = t14;
    o[15] = t15;
}

});
parcelRequire.register("iNjQQ", function(module, exports) {

$parcel$export(module.exports, "privateKeyValidator", () => $daec33a424d3cb4b$export$fed72f95cdc10258, (v) => $daec33a424d3cb4b$export$fed72f95cdc10258 = v);
$parcel$export(module.exports, "publicKeyValidator", () => $daec33a424d3cb4b$export$16f1063872153885, (v) => $daec33a424d3cb4b$export$16f1063872153885 = v);
/**
 * Copyright (c) 2019 Digital Bazaar, Inc.
 */ var $daec33a424d3cb4b$export$fed72f95cdc10258;
var $daec33a424d3cb4b$export$16f1063872153885;

var $2xc86 = parcelRequire("2xc86");
parcelRequire("l46Tq");
var $daec33a424d3cb4b$var$asn1 = $2xc86.asn1;
$daec33a424d3cb4b$export$fed72f95cdc10258 = {
    // PrivateKeyInfo
    name: "PrivateKeyInfo",
    tagClass: $daec33a424d3cb4b$var$asn1.Class.UNIVERSAL,
    type: $daec33a424d3cb4b$var$asn1.Type.SEQUENCE,
    constructed: true,
    value: [
        {
            // Version (INTEGER)
            name: "PrivateKeyInfo.version",
            tagClass: $daec33a424d3cb4b$var$asn1.Class.UNIVERSAL,
            type: $daec33a424d3cb4b$var$asn1.Type.INTEGER,
            constructed: false,
            capture: "privateKeyVersion"
        },
        {
            // privateKeyAlgorithm
            name: "PrivateKeyInfo.privateKeyAlgorithm",
            tagClass: $daec33a424d3cb4b$var$asn1.Class.UNIVERSAL,
            type: $daec33a424d3cb4b$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $daec33a424d3cb4b$var$asn1.Class.UNIVERSAL,
                    type: $daec33a424d3cb4b$var$asn1.Type.OID,
                    constructed: false,
                    capture: "privateKeyOid"
                }
            ]
        },
        {
            // PrivateKey
            name: "PrivateKeyInfo",
            tagClass: $daec33a424d3cb4b$var$asn1.Class.UNIVERSAL,
            type: $daec33a424d3cb4b$var$asn1.Type.OCTETSTRING,
            constructed: false,
            capture: "privateKey"
        }
    ]
};
$daec33a424d3cb4b$export$16f1063872153885 = {
    name: "SubjectPublicKeyInfo",
    tagClass: $daec33a424d3cb4b$var$asn1.Class.UNIVERSAL,
    type: $daec33a424d3cb4b$var$asn1.Type.SEQUENCE,
    constructed: true,
    captureAsn1: "subjectPublicKeyInfo",
    value: [
        {
            name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
            tagClass: $daec33a424d3cb4b$var$asn1.Class.UNIVERSAL,
            type: $daec33a424d3cb4b$var$asn1.Type.SEQUENCE,
            constructed: true,
            value: [
                {
                    name: "AlgorithmIdentifier.algorithm",
                    tagClass: $daec33a424d3cb4b$var$asn1.Class.UNIVERSAL,
                    type: $daec33a424d3cb4b$var$asn1.Type.OID,
                    constructed: false,
                    capture: "publicKeyOid"
                }
            ]
        },
        // capture group for ed25519PublicKey
        {
            tagClass: $daec33a424d3cb4b$var$asn1.Class.UNIVERSAL,
            type: $daec33a424d3cb4b$var$asn1.Type.BITSTRING,
            constructed: false,
            composed: true,
            captureBitStringValue: "ed25519PublicKey"
        }
    ]
};

});


parcelRequire.register("5V3tR", function(module, exports) {

$parcel$export(module.exports, "utils", () => $44f4f9cb206bd54b$export$eab97d15b1788b8d, (v) => $44f4f9cb206bd54b$export$eab97d15b1788b8d = v);
$parcel$export(module.exports, "generateKey", () => $44f4f9cb206bd54b$export$3a7728e868aa3ebd, (v) => $44f4f9cb206bd54b$export$3a7728e868aa3ebd = v);
$parcel$export(module.exports, "unmarshalPrivateKey", () => $44f4f9cb206bd54b$export$11dd448d4d042aab, (v) => $44f4f9cb206bd54b$export$11dd448d4d042aab = v);
$parcel$export(module.exports, "getRandomValues", () => $44f4f9cb206bd54b$export$960b9ff25e7d4257, (v) => $44f4f9cb206bd54b$export$960b9ff25e7d4257 = v);
$parcel$export(module.exports, "hashAndSign", () => $44f4f9cb206bd54b$export$cc7d6a37d08cb106, (v) => $44f4f9cb206bd54b$export$cc7d6a37d08cb106 = v);
$parcel$export(module.exports, "hashAndVerify", () => $44f4f9cb206bd54b$export$619cff377ee92930, (v) => $44f4f9cb206bd54b$export$619cff377ee92930 = v);
$parcel$export(module.exports, "encrypt", () => $44f4f9cb206bd54b$export$5b0f6292f11d1d18, (v) => $44f4f9cb206bd54b$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $44f4f9cb206bd54b$export$e85a0c9a1067c5d3, (v) => $44f4f9cb206bd54b$export$e85a0c9a1067c5d3 = v);
var $44f4f9cb206bd54b$export$eab97d15b1788b8d;
var $44f4f9cb206bd54b$export$3a7728e868aa3ebd;
// Takes a jwk key
var $44f4f9cb206bd54b$export$11dd448d4d042aab;
var $44f4f9cb206bd54b$export$960b9ff25e7d4257;
var $44f4f9cb206bd54b$export$cc7d6a37d08cb106;
var $44f4f9cb206bd54b$export$619cff377ee92930;
var $44f4f9cb206bd54b$export$5b0f6292f11d1d18;
var $44f4f9cb206bd54b$export$e85a0c9a1067c5d3;
"use strict";

var $bpHqr = parcelRequire("bpHqr");

var $4k49i = parcelRequire("4k49i");

var $6rBCs = parcelRequire("6rBCs");
var $44f4f9cb206bd54b$require$uint8ArrayToString = $6rBCs.toString;

var $8cWjP = parcelRequire("8cWjP");
var $44f4f9cb206bd54b$require$uint8ArrayFromString = $8cWjP.fromString;

$44f4f9cb206bd54b$export$eab97d15b1788b8d = (parcelRequire("boizc"));
$44f4f9cb206bd54b$export$3a7728e868aa3ebd = async function(bits) {
    const pair = await $bpHqr.get().subtle.generateKey({
        name: "RSASSA-PKCS1-v1_5",
        modulusLength: bits,
        publicExponent: new Uint8Array([
            0x01,
            0x00,
            0x01
        ]),
        hash: {
            name: "SHA-256"
        }
    }, true, [
        "sign",
        "verify"
    ]);
    const keys = await $44f4f9cb206bd54b$var$exportKey(pair);
    return {
        privateKey: keys[0],
        publicKey: keys[1]
    };
};
$44f4f9cb206bd54b$export$11dd448d4d042aab = async function(key) {
    const privateKey = await $bpHqr.get().subtle.importKey("jwk", key, {
        name: "RSASSA-PKCS1-v1_5",
        hash: {
            name: "SHA-256"
        }
    }, true, [
        "sign"
    ]);
    const pair = [
        privateKey,
        await $44f4f9cb206bd54b$var$derivePublicFromPrivate(key)
    ];
    const keys = await $44f4f9cb206bd54b$var$exportKey({
        privateKey: pair[0],
        publicKey: pair[1]
    });
    return {
        privateKey: keys[0],
        publicKey: keys[1]
    };
};
$44f4f9cb206bd54b$export$960b9ff25e7d4257 = $4k49i;
$44f4f9cb206bd54b$export$cc7d6a37d08cb106 = async function(key, msg) {
    const privateKey = await $bpHqr.get().subtle.importKey("jwk", key, {
        name: "RSASSA-PKCS1-v1_5",
        hash: {
            name: "SHA-256"
        }
    }, false, [
        "sign"
    ]);
    const sig = await $bpHqr.get().subtle.sign({
        name: "RSASSA-PKCS1-v1_5"
    }, privateKey, Uint8Array.from(msg));
    return new Uint8Array(sig, sig.byteOffset, sig.byteLength);
};
$44f4f9cb206bd54b$export$619cff377ee92930 = async function(key, sig, msg) {
    const publicKey = await $bpHqr.get().subtle.importKey("jwk", key, {
        name: "RSASSA-PKCS1-v1_5",
        hash: {
            name: "SHA-256"
        }
    }, false, [
        "verify"
    ]);
    return $bpHqr.get().subtle.verify({
        name: "RSASSA-PKCS1-v1_5"
    }, publicKey, sig, msg);
};
function $44f4f9cb206bd54b$var$exportKey(pair) {
    return Promise.all([
        $bpHqr.get().subtle.exportKey("jwk", pair.privateKey),
        $bpHqr.get().subtle.exportKey("jwk", pair.publicKey)
    ]);
}
function $44f4f9cb206bd54b$var$derivePublicFromPrivate(jwKey) {
    return $bpHqr.get().subtle.importKey("jwk", {
        kty: jwKey.kty,
        n: jwKey.n,
        e: jwKey.e
    }, {
        name: "RSASSA-PKCS1-v1_5",
        hash: {
            name: "SHA-256"
        }
    }, true, [
        "verify"
    ]);
}

var $i50I1 = parcelRequire("i50I1");
var $44f4f9cb206bd54b$require$jwk2pub = $i50I1.jwk2pub;
var $44f4f9cb206bd54b$require$jwk2priv = $i50I1.jwk2priv;
function $44f4f9cb206bd54b$var$convertKey(key, pub, msg, handle) {
    const fkey = pub ? $44f4f9cb206bd54b$require$jwk2pub(key) : $44f4f9cb206bd54b$require$jwk2priv(key);
    const fmsg = $44f4f9cb206bd54b$require$uint8ArrayToString(Uint8Array.from(msg), "ascii");
    const fomsg = handle(fmsg, fkey);
    return $44f4f9cb206bd54b$require$uint8ArrayFromString(fomsg, "ascii");
}
$44f4f9cb206bd54b$export$5b0f6292f11d1d18 = function(key, msg) {
    return $44f4f9cb206bd54b$var$convertKey(key, true, msg, (msg, key)=>key.encrypt(msg));
};
$44f4f9cb206bd54b$export$e85a0c9a1067c5d3 = function(key, msg) {
    return $44f4f9cb206bd54b$var$convertKey(key, false, msg, (msg, key)=>key.decrypt(msg));
};

});
parcelRequire.register("4k49i", function(module, exports) {
"use strict";

var $6J93w = parcelRequire("6J93w");

var $20Lm5 = parcelRequire("20Lm5");
module.exports = function(length) {
    if (isNaN(length) || length <= 0) throw $20Lm5(new Error("random bytes length must be a Number bigger than 0"), "ERR_INVALID_LENGTH");
    return $6J93w(length);
};

});

parcelRequire.register("boizc", function(module, exports) {

$parcel$export(module.exports, "pkcs1ToJwk", () => $84b05692c95ce60b$export$2c5c25417935aff2, (v) => $84b05692c95ce60b$export$2c5c25417935aff2 = v);
$parcel$export(module.exports, "jwkToPkcs1", () => $84b05692c95ce60b$export$d3c021755f04ee81, (v) => $84b05692c95ce60b$export$d3c021755f04ee81 = v);
$parcel$export(module.exports, "pkixToJwk", () => $84b05692c95ce60b$export$70fcaa90a80c2900, (v) => $84b05692c95ce60b$export$70fcaa90a80c2900 = v);
$parcel$export(module.exports, "jwkToPkix", () => $84b05692c95ce60b$export$1db1642be8afe525, (v) => $84b05692c95ce60b$export$1db1642be8afe525 = v);
// Convert a PKCS#1 in ASN1 DER format to a JWK key
var $84b05692c95ce60b$export$2c5c25417935aff2;
// Convert a JWK key into PKCS#1 in ASN1 DER format
var $84b05692c95ce60b$export$d3c021755f04ee81;
// Convert a PKCIX in ASN1 DER format to a JWK key
var $84b05692c95ce60b$export$70fcaa90a80c2900;
// Convert a JWK key to PKCIX in ASN1 DER format
var $84b05692c95ce60b$export$1db1642be8afe525;
"use strict";
parcelRequire("l46Tq");
parcelRequire("96KyE");

var $2xc86 = parcelRequire("2xc86");

var $agoAr = parcelRequire("agoAr");
var $84b05692c95ce60b$require$bigIntegerToUintBase64url = $agoAr.bigIntegerToUintBase64url;
var $84b05692c95ce60b$require$base64urlToBigInteger = $agoAr.base64urlToBigInteger;

var $8cWjP = parcelRequire("8cWjP");
var $84b05692c95ce60b$require$uint8ArrayFromString = $8cWjP.fromString;

var $6rBCs = parcelRequire("6rBCs");
var $84b05692c95ce60b$require$uint8ArrayToString = $6rBCs.toString;
$84b05692c95ce60b$export$2c5c25417935aff2 = function(bytes) {
    const asn1 = $2xc86.asn1.fromDer($84b05692c95ce60b$require$uint8ArrayToString(bytes, "ascii"));
    const privateKey = $2xc86.pki.privateKeyFromAsn1(asn1);
    // https://tools.ietf.org/html/rfc7518#section-6.3.1
    return {
        kty: "RSA",
        n: $84b05692c95ce60b$require$bigIntegerToUintBase64url(privateKey.n),
        e: $84b05692c95ce60b$require$bigIntegerToUintBase64url(privateKey.e),
        d: $84b05692c95ce60b$require$bigIntegerToUintBase64url(privateKey.d),
        p: $84b05692c95ce60b$require$bigIntegerToUintBase64url(privateKey.p),
        q: $84b05692c95ce60b$require$bigIntegerToUintBase64url(privateKey.q),
        dp: $84b05692c95ce60b$require$bigIntegerToUintBase64url(privateKey.dP),
        dq: $84b05692c95ce60b$require$bigIntegerToUintBase64url(privateKey.dQ),
        qi: $84b05692c95ce60b$require$bigIntegerToUintBase64url(privateKey.qInv),
        alg: "RS256",
        kid: "2011-04-29"
    };
};
$84b05692c95ce60b$export$d3c021755f04ee81 = function(jwk) {
    const asn1 = $2xc86.pki.privateKeyToAsn1({
        n: $84b05692c95ce60b$require$base64urlToBigInteger(jwk.n),
        e: $84b05692c95ce60b$require$base64urlToBigInteger(jwk.e),
        d: $84b05692c95ce60b$require$base64urlToBigInteger(jwk.d),
        p: $84b05692c95ce60b$require$base64urlToBigInteger(jwk.p),
        q: $84b05692c95ce60b$require$base64urlToBigInteger(jwk.q),
        dP: $84b05692c95ce60b$require$base64urlToBigInteger(jwk.dp),
        dQ: $84b05692c95ce60b$require$base64urlToBigInteger(jwk.dq),
        qInv: $84b05692c95ce60b$require$base64urlToBigInteger(jwk.qi)
    });
    return $84b05692c95ce60b$require$uint8ArrayFromString($2xc86.asn1.toDer(asn1).getBytes(), "ascii");
};
$84b05692c95ce60b$export$70fcaa90a80c2900 = function(bytes) {
    const asn1 = $2xc86.asn1.fromDer($84b05692c95ce60b$require$uint8ArrayToString(bytes, "ascii"));
    const publicKey = $2xc86.pki.publicKeyFromAsn1(asn1);
    return {
        kty: "RSA",
        n: $84b05692c95ce60b$require$bigIntegerToUintBase64url(publicKey.n),
        e: $84b05692c95ce60b$require$bigIntegerToUintBase64url(publicKey.e),
        alg: "RS256",
        kid: "2011-04-29"
    };
};
$84b05692c95ce60b$export$1db1642be8afe525 = function(jwk) {
    const asn1 = $2xc86.pki.publicKeyToAsn1({
        n: $84b05692c95ce60b$require$base64urlToBigInteger(jwk.n),
        e: $84b05692c95ce60b$require$base64urlToBigInteger(jwk.e)
    });
    return $84b05692c95ce60b$require$uint8ArrayFromString($2xc86.asn1.toDer(asn1).getBytes(), "ascii");
};

});
parcelRequire.register("agoAr", function(module, exports) {

$parcel$export(module.exports, "bigIntegerToUintBase64url", () => $778e786d233a2ba5$export$975f12d8c59391f6, (v) => $778e786d233a2ba5$export$975f12d8c59391f6 = v);
$parcel$export(module.exports, "base64urlToBigInteger", () => $778e786d233a2ba5$export$560aa83c1da30c27, (v) => $778e786d233a2ba5$export$560aa83c1da30c27 = v);
$parcel$export(module.exports, "base64urlToBuffer", () => $778e786d233a2ba5$export$d203bea30aac4ae7, (v) => $778e786d233a2ba5$export$d203bea30aac4ae7 = v);
var $778e786d233a2ba5$export$975f12d8c59391f6;
// Convert a base64url encoded string to a BigInteger
var $778e786d233a2ba5$export$560aa83c1da30c27;
var $778e786d233a2ba5$export$d203bea30aac4ae7;
"use strict";
parcelRequire("e73pV");
parcelRequire("ft6fW");

var $2xc86 = parcelRequire("2xc86");

var $8cWjP = parcelRequire("8cWjP");
var $778e786d233a2ba5$require$uint8ArrayFromString = $8cWjP.fromString;

var $6rBCs = parcelRequire("6rBCs");
var $778e786d233a2ba5$require$uint8ArrayToString = $6rBCs.toString;

var $8hEBV = parcelRequire("8hEBV");
var $778e786d233a2ba5$require$uint8ArrayConcat = $8hEBV.concat;
$778e786d233a2ba5$export$975f12d8c59391f6 = (num, len)=>{
    // Call `.abs()` to convert to unsigned
    let buf = Uint8Array.from(num.abs().toByteArray()) // toByteArray converts to big endian
    ;
    // toByteArray() gives us back a signed array, which will include a leading 0
    // byte if the most significant bit of the number is 1:
    // https://docs.microsoft.com/en-us/windows/win32/seccertenroll/about-integer
    // Our number will always be positive so we should remove the leading padding.
    buf = buf[0] === 0 ? buf.slice(1) : buf;
    if (len != null) {
        if (buf.length > len) throw new Error("byte array longer than desired length");
        buf = $778e786d233a2ba5$require$uint8ArrayConcat([
            new Uint8Array(len - buf.length),
            buf
        ]);
    }
    return $778e786d233a2ba5$require$uint8ArrayToString(buf, "base64url");
};
$778e786d233a2ba5$export$560aa83c1da30c27 = (str)=>{
    const buf = $778e786d233a2ba5$export$d203bea30aac4ae7(str);
    return new $2xc86.jsbn.BigInteger($778e786d233a2ba5$require$uint8ArrayToString(buf, "base16"), 16);
};
$778e786d233a2ba5$export$d203bea30aac4ae7 = (str, len)=>{
    let buf = $778e786d233a2ba5$require$uint8ArrayFromString(str, "base64urlpad");
    if (len != null) {
        if (buf.length > len) throw new Error("byte array longer than desired length");
        buf = $778e786d233a2ba5$require$uint8ArrayConcat([
            new Uint8Array(len - buf.length),
            buf
        ]);
    }
    return buf;
};

});


parcelRequire.register("i50I1", function(module, exports) {
"use strict";
parcelRequire("96KyE");

var $2xc86 = parcelRequire("2xc86");

var $agoAr = parcelRequire("agoAr");
var $d2993e669cca50b4$require$base64urlToBigInteger = $agoAr.base64urlToBigInteger;
function $d2993e669cca50b4$var$convert(key, types) {
    return types.map((t)=>$d2993e669cca50b4$require$base64urlToBigInteger(key[t]));
}
function $d2993e669cca50b4$var$jwk2priv(key) {
    return $2xc86.pki.setRsaPrivateKey(...$d2993e669cca50b4$var$convert(key, [
        "n",
        "e",
        "d",
        "p",
        "q",
        "dp",
        "dq",
        "qi"
    ]));
}
function $d2993e669cca50b4$var$jwk2pub(key) {
    return $2xc86.pki.setRsaPublicKey(...$d2993e669cca50b4$var$convert(key, [
        "n",
        "e"
    ]));
}
module.exports = {
    jwk2pub: $d2993e669cca50b4$var$jwk2pub,
    jwk2priv: $d2993e669cca50b4$var$jwk2priv
};

});


parcelRequire.register("j06ar", function(module, exports) {
"use strict";

var $eXQx4 = parcelRequire("eXQx4");
var $dd52cd2352b90e71$require$base64 = $eXQx4.base64;

var $agi5f = parcelRequire("agi5f");
module.exports = {
    /**
   * Exports the given PrivateKey as a base64 encoded string.
   * The PrivateKey is encrypted via a password derived PBKDF2 key
   * leveraging the aes-gcm cipher algorithm.
   *
   * @param {Uint8Array} privateKey - The PrivateKey protobuf
   * @param {string} password
   * @returns {Promise<string>} A base64 encoded string
   */ export: async function(privateKey, password) {
        const cipher = $agi5f.create();
        const encryptedKey = await cipher.encrypt(privateKey, password);
        return $dd52cd2352b90e71$require$base64.encode(encryptedKey);
    }
};

});


parcelRequire.register("7XgpO", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $ijWXY = parcelRequire("ijWXY");
var $5caac6d5c12accec$require$uint8ArrayEquals = $ijWXY.equals;

var $gTOvd = parcelRequire("gTOvd");
var $5caac6d5c12accec$require$sha256 = $gTOvd.sha256;

var $fVtlC = parcelRequire("fVtlC");
var $5caac6d5c12accec$require$base58btc = $fVtlC.base58btc;

var $klyrn = parcelRequire("klyrn");
var $5caac6d5c12accec$require$identity = $klyrn.identity;

var $iAUx1 = parcelRequire("iAUx1");

var $95NDj = parcelRequire("95NDj");

var $j06ar = parcelRequire("j06ar");
class $5caac6d5c12accec$var$Ed25519PublicKey {
    constructor(key){
        this._key = $5caac6d5c12accec$var$ensureKey(key, $iAUx1.publicKeyLength);
    }
    async verify(data, sig) {
        return $iAUx1.hashAndVerify(this._key, sig, data);
    }
    marshal() {
        return this._key;
    }
    get bytes() {
        return $95NDj.PublicKey.encode({
            Type: $95NDj.KeyType.Ed25519,
            Data: this.marshal()
        }).finish();
    }
    equals(key) {
        return $5caac6d5c12accec$require$uint8ArrayEquals(this.bytes, key.bytes);
    }
    async hash() {
        const { bytes: bytes } = await $5caac6d5c12accec$require$sha256.digest(this.bytes);
        return bytes;
    }
}
class $5caac6d5c12accec$var$Ed25519PrivateKey {
    // key       - 64 byte Uint8Array containing private key
    // publicKey - 32 byte Uint8Array containing public key
    constructor(key, publicKey){
        this._key = $5caac6d5c12accec$var$ensureKey(key, $iAUx1.privateKeyLength);
        this._publicKey = $5caac6d5c12accec$var$ensureKey(publicKey, $iAUx1.publicKeyLength);
    }
    async sign(message) {
        return $iAUx1.hashAndSign(this._key, message);
    }
    get public() {
        return new $5caac6d5c12accec$var$Ed25519PublicKey(this._publicKey);
    }
    marshal() {
        return this._key;
    }
    get bytes() {
        return $95NDj.PrivateKey.encode({
            Type: $95NDj.KeyType.Ed25519,
            Data: this.marshal()
        }).finish();
    }
    equals(key) {
        return $5caac6d5c12accec$require$uint8ArrayEquals(this.bytes, key.bytes);
    }
    async hash() {
        const { bytes: bytes } = await $5caac6d5c12accec$require$sha256.digest(this.bytes);
        return bytes;
    }
    /**
   * Gets the ID of the key.
   *
   * The key id is the base58 encoding of the identity multihash containing its public key.
   * The public key is a protobuf encoding containing a type and the DER encoding
   * of the PKCS SubjectPublicKeyInfo.
   *
   * @returns {Promise<string>}
   */ async id() {
        const encoding = await $5caac6d5c12accec$require$identity.digest(this.public.bytes);
        return $5caac6d5c12accec$require$base58btc.encode(encoding.bytes).substring(1);
    }
    /**
   * Exports the key into a password protected `format`
   *
   * @param {string} password - The password to encrypt the key
   * @param {string} [format=libp2p-key] - The format in which to export as
   * @returns {Promise<Uint8Array>} The encrypted private key
   */ async export(password, format = "libp2p-key") {
        if (format === "libp2p-key") return $j06ar.export(this.bytes, password);
        else throw $20Lm5(new Error(`export format '${format}' is not supported`), "ERR_INVALID_EXPORT_FORMAT");
    }
}
function $5caac6d5c12accec$var$unmarshalEd25519PrivateKey(bytes) {
    // Try the old, redundant public key version
    if (bytes.length > $iAUx1.privateKeyLength) {
        bytes = $5caac6d5c12accec$var$ensureKey(bytes, $iAUx1.privateKeyLength + $iAUx1.publicKeyLength);
        const privateKeyBytes = bytes.slice(0, $iAUx1.privateKeyLength);
        const publicKeyBytes = bytes.slice($iAUx1.privateKeyLength, bytes.length);
        return new $5caac6d5c12accec$var$Ed25519PrivateKey(privateKeyBytes, publicKeyBytes);
    }
    bytes = $5caac6d5c12accec$var$ensureKey(bytes, $iAUx1.privateKeyLength);
    const privateKeyBytes = bytes.slice(0, $iAUx1.privateKeyLength);
    const publicKeyBytes = bytes.slice($iAUx1.publicKeyLength);
    return new $5caac6d5c12accec$var$Ed25519PrivateKey(privateKeyBytes, publicKeyBytes);
}
function $5caac6d5c12accec$var$unmarshalEd25519PublicKey(bytes) {
    bytes = $5caac6d5c12accec$var$ensureKey(bytes, $iAUx1.publicKeyLength);
    return new $5caac6d5c12accec$var$Ed25519PublicKey(bytes);
}
async function $5caac6d5c12accec$var$generateKeyPair() {
    const { privateKey: privateKey, publicKey: publicKey } = await $iAUx1.generateKey();
    return new $5caac6d5c12accec$var$Ed25519PrivateKey(privateKey, publicKey);
}
async function $5caac6d5c12accec$var$generateKeyPairFromSeed(seed) {
    const { privateKey: privateKey, publicKey: publicKey } = await $iAUx1.generateKeyFromSeed(seed);
    return new $5caac6d5c12accec$var$Ed25519PrivateKey(privateKey, publicKey);
}
function $5caac6d5c12accec$var$ensureKey(key, length) {
    key = Uint8Array.from(key || []);
    if (key.length !== length) throw $20Lm5(new Error(`Key must be a Uint8Array of length ${length}, got ${key.length}`), "ERR_INVALID_KEY_TYPE");
    return key;
}
module.exports = {
    Ed25519PublicKey: $5caac6d5c12accec$var$Ed25519PublicKey,
    Ed25519PrivateKey: $5caac6d5c12accec$var$Ed25519PrivateKey,
    unmarshalEd25519PrivateKey: $5caac6d5c12accec$var$unmarshalEd25519PrivateKey,
    unmarshalEd25519PublicKey: $5caac6d5c12accec$var$unmarshalEd25519PublicKey,
    generateKeyPair: $5caac6d5c12accec$var$generateKeyPair,
    generateKeyPairFromSeed: $5caac6d5c12accec$var$generateKeyPairFromSeed
};

});
parcelRequire.register("iAUx1", function(module, exports) {

$parcel$export(module.exports, "publicKeyLength", () => $d89770cbcf7234b5$export$5f4cfc08c63c83db, (v) => $d89770cbcf7234b5$export$5f4cfc08c63c83db = v);
$parcel$export(module.exports, "privateKeyLength", () => $d89770cbcf7234b5$export$646aa2db9f6f5fe, (v) => $d89770cbcf7234b5$export$646aa2db9f6f5fe = v);
$parcel$export(module.exports, "generateKey", () => $d89770cbcf7234b5$export$3a7728e868aa3ebd, (v) => $d89770cbcf7234b5$export$3a7728e868aa3ebd = v);
$parcel$export(module.exports, "generateKeyFromSeed", () => $d89770cbcf7234b5$export$47705f2da2f256b8, (v) => $d89770cbcf7234b5$export$47705f2da2f256b8 = v);
$parcel$export(module.exports, "hashAndSign", () => $d89770cbcf7234b5$export$cc7d6a37d08cb106, (v) => $d89770cbcf7234b5$export$cc7d6a37d08cb106 = v);
$parcel$export(module.exports, "hashAndVerify", () => $d89770cbcf7234b5$export$619cff377ee92930, (v) => $d89770cbcf7234b5$export$619cff377ee92930 = v);
var $d89770cbcf7234b5$export$5f4cfc08c63c83db;
var $d89770cbcf7234b5$export$646aa2db9f6f5fe;
var $d89770cbcf7234b5$export$3a7728e868aa3ebd;
// seed should be a 32 byte uint8array
var $d89770cbcf7234b5$export$47705f2da2f256b8;
var $d89770cbcf7234b5$export$cc7d6a37d08cb106;
var $d89770cbcf7234b5$export$619cff377ee92930;
"use strict";
parcelRequire("knsWb");

var $2xc86 = parcelRequire("2xc86");
$d89770cbcf7234b5$export$5f4cfc08c63c83db = $2xc86.pki.ed25519.constants.PUBLIC_KEY_BYTE_LENGTH;
$d89770cbcf7234b5$export$646aa2db9f6f5fe = $2xc86.pki.ed25519.constants.PRIVATE_KEY_BYTE_LENGTH;
$d89770cbcf7234b5$export$3a7728e868aa3ebd = async function() {
    return $2xc86.pki.ed25519.generateKeyPair();
};
$d89770cbcf7234b5$export$47705f2da2f256b8 = async function(seed) {
    return $2xc86.pki.ed25519.generateKeyPair({
        seed: seed
    });
};
$d89770cbcf7234b5$export$cc7d6a37d08cb106 = async function(key, msg) {
    return $2xc86.pki.ed25519.sign({
        message: msg,
        privateKey: key
    });
// return Uint8Array.from(nacl.sign.detached(msg, key))
};
$d89770cbcf7234b5$export$619cff377ee92930 = async function(key, sig, msg) {
    return $2xc86.pki.ed25519.verify({
        signature: sig,
        message: msg,
        publicKey: key
    });
};

});


parcelRequire.register("hb6fy", function(module, exports) {
"use strict";

var $gTOvd = parcelRequire("gTOvd");
var $c8184fd232ebcb6d$require$sha256 = $gTOvd.sha256;

var $20Lm5 = parcelRequire("20Lm5");

var $ijWXY = parcelRequire("ijWXY");
var $c8184fd232ebcb6d$require$uint8ArrayEquals = $ijWXY.equals;

var $6rBCs = parcelRequire("6rBCs");
var $c8184fd232ebcb6d$require$uint8ArrayToString = $6rBCs.toString;

var $j06ar = parcelRequire("j06ar");

module.exports = (keysProtobuf, randomBytes, crypto)=>{
    crypto = crypto || (parcelRequire("d8iOf"))(randomBytes);
    class Secp256k1PublicKey {
        constructor(key){
            crypto.validatePublicKey(key);
            this._key = key;
        }
        verify(data, sig) {
            return crypto.hashAndVerify(this._key, sig, data);
        }
        marshal() {
            return crypto.compressPublicKey(this._key);
        }
        get bytes() {
            return keysProtobuf.PublicKey.encode({
                Type: keysProtobuf.KeyType.Secp256k1,
                Data: this.marshal()
            }).finish();
        }
        equals(key) {
            return $c8184fd232ebcb6d$require$uint8ArrayEquals(this.bytes, key.bytes);
        }
        async hash() {
            const { bytes: bytes } = await $c8184fd232ebcb6d$require$sha256.digest(this.bytes);
            return bytes;
        }
    }
    class Secp256k1PrivateKey {
        constructor(key, publicKey){
            this._key = key;
            this._publicKey = publicKey || crypto.computePublicKey(key);
            crypto.validatePrivateKey(this._key);
            crypto.validatePublicKey(this._publicKey);
        }
        sign(message) {
            return crypto.hashAndSign(this._key, message);
        }
        get public() {
            return new Secp256k1PublicKey(this._publicKey);
        }
        marshal() {
            return this._key;
        }
        get bytes() {
            return keysProtobuf.PrivateKey.encode({
                Type: keysProtobuf.KeyType.Secp256k1,
                Data: this.marshal()
            }).finish();
        }
        equals(key) {
            return $c8184fd232ebcb6d$require$uint8ArrayEquals(this.bytes, key.bytes);
        }
        async hash() {
            const { bytes: bytes } = await $c8184fd232ebcb6d$require$sha256.digest(this.bytes);
            return bytes;
        }
        /**
     * Gets the ID of the key.
     *
     * The key id is the base58 encoding of the SHA-256 multihash of its public key.
     * The public key is a protobuf encoding containing a type and the DER encoding
     * of the PKCS SubjectPublicKeyInfo.
     *
     * @returns {Promise<string>}
     */ async id() {
            const hash = await this.public.hash();
            return $c8184fd232ebcb6d$require$uint8ArrayToString(hash, "base58btc");
        }
        /**
     * Exports the key into a password protected `format`
     *
     * @param {string} password - The password to encrypt the key
     * @param {string} [format=libp2p-key] - The format in which to export as
     * @returns {Promise<string>} The encrypted private key
     */ async export(password, format = "libp2p-key") {
            if (format === "libp2p-key") return $j06ar.export(this.bytes, password);
            else throw $20Lm5(new Error(`export format '${format}' is not supported`), "ERR_INVALID_EXPORT_FORMAT");
        }
    }
    function unmarshalSecp256k1PrivateKey(bytes) {
        return new Secp256k1PrivateKey(bytes);
    }
    function unmarshalSecp256k1PublicKey(bytes) {
        return new Secp256k1PublicKey(bytes);
    }
    async function generateKeyPair() {
        const privateKeyBytes = await crypto.generateKey();
        return new Secp256k1PrivateKey(privateKeyBytes);
    }
    return {
        Secp256k1PublicKey: Secp256k1PublicKey,
        Secp256k1PrivateKey: Secp256k1PrivateKey,
        unmarshalSecp256k1PrivateKey: unmarshalSecp256k1PrivateKey,
        unmarshalSecp256k1PublicKey: unmarshalSecp256k1PublicKey,
        generateKeyPair: generateKeyPair
    };
};

});
parcelRequire.register("d8iOf", function(module, exports) {
"use strict";

var $fQDEW = parcelRequire("fQDEW");

var $gTOvd = parcelRequire("gTOvd");
var $98fa9ce15159dc7e$require$sha256 = $gTOvd.sha256;
module.exports = (randomBytes)=>{
    const privateKeyLength = 32;
    function generateKey() {
        let privateKey;
        do privateKey = randomBytes(32);
        while (!$fQDEW.privateKeyVerify(privateKey));
        return privateKey;
    }
    async function hashAndSign(key, msg) {
        const { digest: digest } = await $98fa9ce15159dc7e$require$sha256.digest(msg);
        const sig = $fQDEW.ecdsaSign(digest, key);
        return $fQDEW.signatureExport(sig.signature);
    }
    async function hashAndVerify(key, sig, msg) {
        const { digest: digest } = await $98fa9ce15159dc7e$require$sha256.digest(msg);
        sig = $fQDEW.signatureImport(sig);
        return $fQDEW.ecdsaVerify(sig, digest, key);
    }
    function compressPublicKey(key) {
        if (!$fQDEW.publicKeyVerify(key)) throw new Error("Invalid public key");
        return $fQDEW.publicKeyConvert(key, true);
    }
    function decompressPublicKey(key) {
        return $fQDEW.publicKeyConvert(key, false);
    }
    function validatePrivateKey(key) {
        if (!$fQDEW.privateKeyVerify(key)) throw new Error("Invalid private key");
    }
    function validatePublicKey(key) {
        if (!$fQDEW.publicKeyVerify(key)) throw new Error("Invalid public key");
    }
    function computePublicKey(privateKey) {
        validatePrivateKey(privateKey);
        return $fQDEW.publicKeyCreate(privateKey);
    }
    return {
        generateKey: generateKey,
        privateKeyLength: privateKeyLength,
        hashAndSign: hashAndSign,
        hashAndVerify: hashAndVerify,
        compressPublicKey: compressPublicKey,
        decompressPublicKey: decompressPublicKey,
        validatePrivateKey: validatePrivateKey,
        validatePublicKey: validatePublicKey,
        computePublicKey: computePublicKey
    };
};

});
parcelRequire.register("fQDEW", function(module, exports) {


module.exports = (parcelRequire("fUkvk"))((parcelRequire("6AOIo")));

});
parcelRequire.register("fUkvk", function(module, exports) {
const $b94bfdb2a4d0865c$var$errors = {
    IMPOSSIBLE_CASE: "Impossible case. Please create issue.",
    TWEAK_ADD: "The tweak was out of range or the resulted private key is invalid",
    TWEAK_MUL: "The tweak was out of range or equal to zero",
    CONTEXT_RANDOMIZE_UNKNOW: "Unknow error on context randomization",
    SECKEY_INVALID: "Private Key is invalid",
    PUBKEY_PARSE: "Public Key could not be parsed",
    PUBKEY_SERIALIZE: "Public Key serialization error",
    PUBKEY_COMBINE: "The sum of the public keys is not valid",
    SIG_PARSE: "Signature could not be parsed",
    SIGN: "The nonce generation function failed, or the private key was invalid",
    RECOVER: "Public key could not be recover",
    ECDH: "Scalar was invalid (zero or overflow)"
};
function $b94bfdb2a4d0865c$var$assert(cond, msg) {
    if (!cond) throw new Error(msg);
}
function $b94bfdb2a4d0865c$var$isUint8Array(name, value, length) {
    $b94bfdb2a4d0865c$var$assert(value instanceof Uint8Array, `Expected ${name} to be an Uint8Array`);
    if (length !== undefined) {
        if (Array.isArray(length)) {
            const numbers = length.join(", ");
            const msg = `Expected ${name} to be an Uint8Array with length [${numbers}]`;
            $b94bfdb2a4d0865c$var$assert(length.includes(value.length), msg);
        } else {
            const msg = `Expected ${name} to be an Uint8Array with length ${length}`;
            $b94bfdb2a4d0865c$var$assert(value.length === length, msg);
        }
    }
}
function $b94bfdb2a4d0865c$var$isCompressed(value) {
    $b94bfdb2a4d0865c$var$assert($b94bfdb2a4d0865c$var$toTypeString(value) === "Boolean", "Expected compressed to be a Boolean");
}
function $b94bfdb2a4d0865c$var$getAssertedOutput(output = (len)=>new Uint8Array(len), length) {
    if (typeof output === "function") output = output(length);
    $b94bfdb2a4d0865c$var$isUint8Array("output", output, length);
    return output;
}
function $b94bfdb2a4d0865c$var$toTypeString(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
module.exports = (secp256k1)=>{
    return {
        contextRandomize (seed) {
            $b94bfdb2a4d0865c$var$assert(seed === null || seed instanceof Uint8Array, "Expected seed to be an Uint8Array or null");
            if (seed !== null) $b94bfdb2a4d0865c$var$isUint8Array("seed", seed, 32);
            switch(secp256k1.contextRandomize(seed)){
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.CONTEXT_RANDOMIZE_UNKNOW);
            }
        },
        privateKeyVerify (seckey) {
            $b94bfdb2a4d0865c$var$isUint8Array("private key", seckey, 32);
            return secp256k1.privateKeyVerify(seckey) === 0;
        },
        privateKeyNegate (seckey) {
            $b94bfdb2a4d0865c$var$isUint8Array("private key", seckey, 32);
            switch(secp256k1.privateKeyNegate(seckey)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.IMPOSSIBLE_CASE);
            }
        },
        privateKeyTweakAdd (seckey, tweak) {
            $b94bfdb2a4d0865c$var$isUint8Array("private key", seckey, 32);
            $b94bfdb2a4d0865c$var$isUint8Array("tweak", tweak, 32);
            switch(secp256k1.privateKeyTweakAdd(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.TWEAK_ADD);
            }
        },
        privateKeyTweakMul (seckey, tweak) {
            $b94bfdb2a4d0865c$var$isUint8Array("private key", seckey, 32);
            $b94bfdb2a4d0865c$var$isUint8Array("tweak", tweak, 32);
            switch(secp256k1.privateKeyTweakMul(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.TWEAK_MUL);
            }
        },
        publicKeyVerify (pubkey) {
            $b94bfdb2a4d0865c$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            return secp256k1.publicKeyVerify(pubkey) === 0;
        },
        publicKeyCreate (seckey, compressed = true, output) {
            $b94bfdb2a4d0865c$var$isUint8Array("private key", seckey, 32);
            $b94bfdb2a4d0865c$var$isCompressed(compressed);
            output = $b94bfdb2a4d0865c$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCreate(output, seckey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.SECKEY_INVALID);
                case 2:
                    throw new Error($b94bfdb2a4d0865c$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyConvert (pubkey, compressed = true, output) {
            $b94bfdb2a4d0865c$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b94bfdb2a4d0865c$var$isCompressed(compressed);
            output = $b94bfdb2a4d0865c$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyConvert(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b94bfdb2a4d0865c$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyNegate (pubkey, compressed = true, output) {
            $b94bfdb2a4d0865c$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b94bfdb2a4d0865c$var$isCompressed(compressed);
            output = $b94bfdb2a4d0865c$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyNegate(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b94bfdb2a4d0865c$var$errors.IMPOSSIBLE_CASE);
                case 3:
                    throw new Error($b94bfdb2a4d0865c$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyCombine (pubkeys, compressed = true, output) {
            $b94bfdb2a4d0865c$var$assert(Array.isArray(pubkeys), "Expected public keys to be an Array");
            $b94bfdb2a4d0865c$var$assert(pubkeys.length > 0, "Expected public keys array will have more than zero items");
            for (const pubkey of pubkeys)$b94bfdb2a4d0865c$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b94bfdb2a4d0865c$var$isCompressed(compressed);
            output = $b94bfdb2a4d0865c$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCombine(output, pubkeys)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b94bfdb2a4d0865c$var$errors.PUBKEY_COMBINE);
                case 3:
                    throw new Error($b94bfdb2a4d0865c$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyTweakAdd (pubkey, tweak, compressed = true, output) {
            $b94bfdb2a4d0865c$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b94bfdb2a4d0865c$var$isUint8Array("tweak", tweak, 32);
            $b94bfdb2a4d0865c$var$isCompressed(compressed);
            output = $b94bfdb2a4d0865c$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakAdd(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b94bfdb2a4d0865c$var$errors.TWEAK_ADD);
            }
        },
        publicKeyTweakMul (pubkey, tweak, compressed = true, output) {
            $b94bfdb2a4d0865c$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b94bfdb2a4d0865c$var$isUint8Array("tweak", tweak, 32);
            $b94bfdb2a4d0865c$var$isCompressed(compressed);
            output = $b94bfdb2a4d0865c$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakMul(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b94bfdb2a4d0865c$var$errors.TWEAK_MUL);
            }
        },
        signatureNormalize (sig) {
            $b94bfdb2a4d0865c$var$isUint8Array("signature", sig, 64);
            switch(secp256k1.signatureNormalize(sig)){
                case 0:
                    return sig;
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.SIG_PARSE);
            }
        },
        signatureExport (sig, output) {
            $b94bfdb2a4d0865c$var$isUint8Array("signature", sig, 64);
            output = $b94bfdb2a4d0865c$var$getAssertedOutput(output, 72);
            const obj = {
                output: output,
                outputlen: 72
            };
            switch(secp256k1.signatureExport(obj, sig)){
                case 0:
                    return output.slice(0, obj.outputlen);
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b94bfdb2a4d0865c$var$errors.IMPOSSIBLE_CASE);
            }
        },
        signatureImport (sig, output) {
            $b94bfdb2a4d0865c$var$isUint8Array("signature", sig);
            output = $b94bfdb2a4d0865c$var$getAssertedOutput(output, 64);
            switch(secp256k1.signatureImport(output, sig)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b94bfdb2a4d0865c$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaSign (msg32, seckey, options = {}, output) {
            $b94bfdb2a4d0865c$var$isUint8Array("message", msg32, 32);
            $b94bfdb2a4d0865c$var$isUint8Array("private key", seckey, 32);
            $b94bfdb2a4d0865c$var$assert($b94bfdb2a4d0865c$var$toTypeString(options) === "Object", "Expected options to be an Object");
            if (options.data !== undefined) $b94bfdb2a4d0865c$var$isUint8Array("options.data", options.data);
            if (options.noncefn !== undefined) $b94bfdb2a4d0865c$var$assert($b94bfdb2a4d0865c$var$toTypeString(options.noncefn) === "Function", "Expected options.noncefn to be a Function");
            output = $b94bfdb2a4d0865c$var$getAssertedOutput(output, 64);
            const obj = {
                signature: output,
                recid: null
            };
            switch(secp256k1.ecdsaSign(obj, msg32, seckey, options.data, options.noncefn)){
                case 0:
                    return obj;
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.SIGN);
                case 2:
                    throw new Error($b94bfdb2a4d0865c$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaVerify (sig, msg32, pubkey) {
            $b94bfdb2a4d0865c$var$isUint8Array("signature", sig, 64);
            $b94bfdb2a4d0865c$var$isUint8Array("message", msg32, 32);
            $b94bfdb2a4d0865c$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            switch(secp256k1.ecdsaVerify(sig, msg32, pubkey)){
                case 0:
                    return true;
                case 3:
                    return false;
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b94bfdb2a4d0865c$var$errors.PUBKEY_PARSE);
            }
        },
        ecdsaRecover (sig, recid, msg32, compressed = true, output) {
            $b94bfdb2a4d0865c$var$isUint8Array("signature", sig, 64);
            $b94bfdb2a4d0865c$var$assert($b94bfdb2a4d0865c$var$toTypeString(recid) === "Number" && recid >= 0 && recid <= 3, "Expected recovery id to be a Number within interval [0, 3]");
            $b94bfdb2a4d0865c$var$isUint8Array("message", msg32, 32);
            $b94bfdb2a4d0865c$var$isCompressed(compressed);
            output = $b94bfdb2a4d0865c$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.ecdsaRecover(output, sig, recid, msg32)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b94bfdb2a4d0865c$var$errors.RECOVER);
                case 3:
                    throw new Error($b94bfdb2a4d0865c$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdh (pubkey, seckey, options = {}, output) {
            $b94bfdb2a4d0865c$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b94bfdb2a4d0865c$var$isUint8Array("private key", seckey, 32);
            $b94bfdb2a4d0865c$var$assert($b94bfdb2a4d0865c$var$toTypeString(options) === "Object", "Expected options to be an Object");
            if (options.data !== undefined) $b94bfdb2a4d0865c$var$isUint8Array("options.data", options.data);
            if (options.hashfn !== undefined) {
                $b94bfdb2a4d0865c$var$assert($b94bfdb2a4d0865c$var$toTypeString(options.hashfn) === "Function", "Expected options.hashfn to be a Function");
                if (options.xbuf !== undefined) $b94bfdb2a4d0865c$var$isUint8Array("options.xbuf", options.xbuf, 32);
                if (options.ybuf !== undefined) $b94bfdb2a4d0865c$var$isUint8Array("options.ybuf", options.ybuf, 32);
                $b94bfdb2a4d0865c$var$isUint8Array("output", output);
            } else output = $b94bfdb2a4d0865c$var$getAssertedOutput(output, 32);
            switch(secp256k1.ecdh(output, pubkey, seckey, options.data, options.hashfn, options.xbuf, options.ybuf)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b94bfdb2a4d0865c$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b94bfdb2a4d0865c$var$errors.ECDH);
            }
        }
    };
};

});

parcelRequire.register("6AOIo", function(module, exports) {

var $29NXu = parcelRequire("29NXu");
var $4ccd71ceb95e3c9b$require$EC = $29NXu.ec;
const $4ccd71ceb95e3c9b$var$ec = new $4ccd71ceb95e3c9b$require$EC("secp256k1");
const $4ccd71ceb95e3c9b$var$ecparams = $4ccd71ceb95e3c9b$var$ec.curve;
// Hack, we can not use bn.js@5, while elliptic uses bn.js@4
// See https://github.com/indutny/elliptic/issues/191#issuecomment-569888758
const $4ccd71ceb95e3c9b$var$BN = $4ccd71ceb95e3c9b$var$ecparams.n.constructor;
function $4ccd71ceb95e3c9b$var$loadCompressedPublicKey(first, xbuf) {
    let x = new $4ccd71ceb95e3c9b$var$BN(xbuf);
    // overflow
    if (x.cmp($4ccd71ceb95e3c9b$var$ecparams.p) >= 0) return null;
    x = x.toRed($4ccd71ceb95e3c9b$var$ecparams.red);
    // compute corresponding Y
    let y = x.redSqr().redIMul(x).redIAdd($4ccd71ceb95e3c9b$var$ecparams.b).redSqrt();
    if (first === 0x03 !== y.isOdd()) y = y.redNeg();
    // x*x*x + b = y*y
    const x3 = x.redSqr().redIMul(x);
    if (!y.redSqr().redISub(x3.redIAdd($4ccd71ceb95e3c9b$var$ecparams.b)).isZero()) return null;
    return $4ccd71ceb95e3c9b$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $4ccd71ceb95e3c9b$var$loadUncompressedPublicKey(first, xbuf, ybuf) {
    let x = new $4ccd71ceb95e3c9b$var$BN(xbuf);
    let y = new $4ccd71ceb95e3c9b$var$BN(ybuf);
    // overflow
    if (x.cmp($4ccd71ceb95e3c9b$var$ecparams.p) >= 0 || y.cmp($4ccd71ceb95e3c9b$var$ecparams.p) >= 0) return null;
    x = x.toRed($4ccd71ceb95e3c9b$var$ecparams.red);
    y = y.toRed($4ccd71ceb95e3c9b$var$ecparams.red);
    // is odd flag
    if ((first === 0x06 || first === 0x07) && y.isOdd() !== (first === 0x07)) return null;
    // x*x*x + b = y*y
    const x3 = x.redSqr().redIMul(x);
    if (!y.redSqr().redISub(x3.redIAdd($4ccd71ceb95e3c9b$var$ecparams.b)).isZero()) return null;
    return $4ccd71ceb95e3c9b$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $4ccd71ceb95e3c9b$var$loadPublicKey(pubkey) {
    // length should be validated in interface
    const first = pubkey[0];
    switch(first){
        case 0x02:
        case 0x03:
            if (pubkey.length !== 33) return null;
            return $4ccd71ceb95e3c9b$var$loadCompressedPublicKey(first, pubkey.subarray(1, 33));
        case 0x04:
        case 0x06:
        case 0x07:
            if (pubkey.length !== 65) return null;
            return $4ccd71ceb95e3c9b$var$loadUncompressedPublicKey(first, pubkey.subarray(1, 33), pubkey.subarray(33, 65));
        default:
            return null;
    }
}
function $4ccd71ceb95e3c9b$var$savePublicKey(output, point) {
    const pubkey = point.encode(null, output.length === 33);
    // Loop should be faster because we do not need create extra Uint8Array
    // output.set(new Uint8Array(pubkey))
    for(let i = 0; i < output.length; ++i)output[i] = pubkey[i];
}
module.exports = {
    contextRandomize () {
        return 0;
    },
    privateKeyVerify (seckey) {
        const bn = new $4ccd71ceb95e3c9b$var$BN(seckey);
        return bn.cmp($4ccd71ceb95e3c9b$var$ecparams.n) < 0 && !bn.isZero() ? 0 : 1;
    },
    privateKeyNegate (seckey) {
        const bn = new $4ccd71ceb95e3c9b$var$BN(seckey);
        const negate = $4ccd71ceb95e3c9b$var$ecparams.n.sub(bn).umod($4ccd71ceb95e3c9b$var$ecparams.n).toArrayLike(Uint8Array, "be", 32);
        seckey.set(negate);
        return 0;
    },
    privateKeyTweakAdd (seckey, tweak) {
        const bn = new $4ccd71ceb95e3c9b$var$BN(tweak);
        if (bn.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0) return 1;
        bn.iadd(new $4ccd71ceb95e3c9b$var$BN(seckey));
        if (bn.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0) bn.isub($4ccd71ceb95e3c9b$var$ecparams.n);
        if (bn.isZero()) return 1;
        const tweaked = bn.toArrayLike(Uint8Array, "be", 32);
        seckey.set(tweaked);
        return 0;
    },
    privateKeyTweakMul (seckey, tweak) {
        let bn = new $4ccd71ceb95e3c9b$var$BN(tweak);
        if (bn.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0 || bn.isZero()) return 1;
        bn.imul(new $4ccd71ceb95e3c9b$var$BN(seckey));
        if (bn.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0) bn = bn.umod($4ccd71ceb95e3c9b$var$ecparams.n);
        const tweaked = bn.toArrayLike(Uint8Array, "be", 32);
        seckey.set(tweaked);
        return 0;
    },
    publicKeyVerify (pubkey) {
        const pair = $4ccd71ceb95e3c9b$var$loadPublicKey(pubkey);
        return pair === null ? 1 : 0;
    },
    publicKeyCreate (output, seckey) {
        const bn = new $4ccd71ceb95e3c9b$var$BN(seckey);
        if (bn.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0 || bn.isZero()) return 1;
        const point = $4ccd71ceb95e3c9b$var$ec.keyFromPrivate(seckey).getPublic();
        $4ccd71ceb95e3c9b$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyConvert (output, pubkey) {
        const pair = $4ccd71ceb95e3c9b$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        $4ccd71ceb95e3c9b$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyNegate (output, pubkey) {
        const pair = $4ccd71ceb95e3c9b$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        point.y = point.y.redNeg();
        $4ccd71ceb95e3c9b$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyCombine (output, pubkeys) {
        const pairs = new Array(pubkeys.length);
        for(let i = 0; i < pubkeys.length; ++i){
            pairs[i] = $4ccd71ceb95e3c9b$var$loadPublicKey(pubkeys[i]);
            if (pairs[i] === null) return 1;
        }
        let point = pairs[0].getPublic();
        for(let i = 1; i < pairs.length; ++i)point = point.add(pairs[i].pub);
        if (point.isInfinity()) return 2;
        $4ccd71ceb95e3c9b$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakAdd (output, pubkey, tweak) {
        const pair = $4ccd71ceb95e3c9b$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new $4ccd71ceb95e3c9b$var$BN(tweak);
        if (tweak.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0) return 2;
        const point = pair.getPublic().add($4ccd71ceb95e3c9b$var$ecparams.g.mul(tweak));
        if (point.isInfinity()) return 2;
        $4ccd71ceb95e3c9b$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakMul (output, pubkey, tweak) {
        const pair = $4ccd71ceb95e3c9b$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new $4ccd71ceb95e3c9b$var$BN(tweak);
        if (tweak.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0 || tweak.isZero()) return 2;
        const point = pair.getPublic().mul(tweak);
        $4ccd71ceb95e3c9b$var$savePublicKey(output, point);
        return 0;
    },
    signatureNormalize (sig) {
        const r = new $4ccd71ceb95e3c9b$var$BN(sig.subarray(0, 32));
        const s = new $4ccd71ceb95e3c9b$var$BN(sig.subarray(32, 64));
        if (r.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0 || s.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0) return 1;
        if (s.cmp($4ccd71ceb95e3c9b$var$ec.nh) === 1) sig.set($4ccd71ceb95e3c9b$var$ecparams.n.sub(s).toArrayLike(Uint8Array, "be", 32), 32);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureExport (obj, sig) {
        const sigR = sig.subarray(0, 32);
        const sigS = sig.subarray(32, 64);
        if (new $4ccd71ceb95e3c9b$var$BN(sigR).cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0) return 1;
        if (new $4ccd71ceb95e3c9b$var$BN(sigS).cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0) return 1;
        const { output: output } = obj;
        // Prepare R
        let r = output.subarray(4, 37);
        r[0] = 0x00;
        r.set(sigR, 1);
        let lenR = 33;
        let posR = 0;
        for(; lenR > 1 && r[posR] === 0x00 && !(r[posR + 1] & 0x80); --lenR, ++posR);
        r = r.subarray(posR);
        if (r[0] & 0x80) return 1;
        if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) return 1;
        // Prepare S
        let s = output.subarray(39, 72);
        s[0] = 0x00;
        s.set(sigS, 1);
        let lenS = 33;
        let posS = 0;
        for(; lenS > 1 && s[posS] === 0x00 && !(s[posS + 1] & 0x80); --lenS, ++posS);
        s = s.subarray(posS);
        if (s[0] & 0x80) return 1;
        if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) return 1;
        // Set output length for return
        obj.outputlen = 6 + lenR + lenS;
        // Output in specified format
        // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
        output[0] = 0x30;
        output[1] = obj.outputlen - 2;
        output[2] = 0x02;
        output[3] = r.length;
        output.set(r, 4);
        output[4 + lenR] = 0x02;
        output[5 + lenR] = s.length;
        output.set(s, 6 + lenR);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureImport (output, sig) {
        if (sig.length < 8) return 1;
        if (sig.length > 72) return 1;
        if (sig[0] !== 0x30) return 1;
        if (sig[1] !== sig.length - 2) return 1;
        if (sig[2] !== 0x02) return 1;
        const lenR = sig[3];
        if (lenR === 0) return 1;
        if (5 + lenR >= sig.length) return 1;
        if (sig[4 + lenR] !== 0x02) return 1;
        const lenS = sig[5 + lenR];
        if (lenS === 0) return 1;
        if (6 + lenR + lenS !== sig.length) return 1;
        if (sig[4] & 0x80) return 1;
        if (lenR > 1 && sig[4] === 0x00 && !(sig[5] & 0x80)) return 1;
        if (sig[lenR + 6] & 0x80) return 1;
        if (lenS > 1 && sig[lenR + 6] === 0x00 && !(sig[lenR + 7] & 0x80)) return 1;
        let sigR = sig.subarray(4, 4 + lenR);
        if (sigR.length === 33 && sigR[0] === 0x00) sigR = sigR.subarray(1);
        if (sigR.length > 32) return 1;
        let sigS = sig.subarray(6 + lenR);
        if (sigS.length === 33 && sigS[0] === 0x00) sigS = sigS.slice(1);
        if (sigS.length > 32) throw new Error("S length is too long");
        let r = new $4ccd71ceb95e3c9b$var$BN(sigR);
        if (r.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0) r = new $4ccd71ceb95e3c9b$var$BN(0);
        let s = new $4ccd71ceb95e3c9b$var$BN(sig.subarray(6 + lenR));
        if (s.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0) s = new $4ccd71ceb95e3c9b$var$BN(0);
        output.set(r.toArrayLike(Uint8Array, "be", 32), 0);
        output.set(s.toArrayLike(Uint8Array, "be", 32), 32);
        return 0;
    },
    ecdsaSign (obj, message, seckey, data, noncefn) {
        if (noncefn) {
            const _noncefn = noncefn;
            noncefn = (counter)=>{
                const nonce = _noncefn(message, seckey, null, data, counter);
                const isValid = nonce instanceof Uint8Array && nonce.length === 32;
                if (!isValid) throw new Error("This is the way");
                return new $4ccd71ceb95e3c9b$var$BN(nonce);
            };
        }
        const d = new $4ccd71ceb95e3c9b$var$BN(seckey);
        if (d.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0 || d.isZero()) return 1;
        let sig;
        try {
            sig = $4ccd71ceb95e3c9b$var$ec.sign(message, seckey, {
                canonical: true,
                k: noncefn,
                pers: data
            });
        } catch (err) {
            return 1;
        }
        obj.signature.set(sig.r.toArrayLike(Uint8Array, "be", 32), 0);
        obj.signature.set(sig.s.toArrayLike(Uint8Array, "be", 32), 32);
        obj.recid = sig.recoveryParam;
        return 0;
    },
    ecdsaVerify (sig, msg32, pubkey) {
        const sigObj = {
            r: sig.subarray(0, 32),
            s: sig.subarray(32, 64)
        };
        const sigr = new $4ccd71ceb95e3c9b$var$BN(sigObj.r);
        const sigs = new $4ccd71ceb95e3c9b$var$BN(sigObj.s);
        if (sigr.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0 || sigs.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0) return 1;
        if (sigs.cmp($4ccd71ceb95e3c9b$var$ec.nh) === 1 || sigr.isZero() || sigs.isZero()) return 3;
        const pair = $4ccd71ceb95e3c9b$var$loadPublicKey(pubkey);
        if (pair === null) return 2;
        const point = pair.getPublic();
        const isValid = $4ccd71ceb95e3c9b$var$ec.verify(msg32, sigObj, point);
        return isValid ? 0 : 3;
    },
    ecdsaRecover (output, sig, recid, msg32) {
        const sigObj = {
            r: sig.slice(0, 32),
            s: sig.slice(32, 64)
        };
        const sigr = new $4ccd71ceb95e3c9b$var$BN(sigObj.r);
        const sigs = new $4ccd71ceb95e3c9b$var$BN(sigObj.s);
        if (sigr.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0 || sigs.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0) return 1;
        if (sigr.isZero() || sigs.isZero()) return 2;
        // Can throw `throw new Error('Unable to find sencond key candinate');`
        let point;
        try {
            point = $4ccd71ceb95e3c9b$var$ec.recoverPubKey(msg32, sigObj, recid);
        } catch (err) {
            return 2;
        }
        $4ccd71ceb95e3c9b$var$savePublicKey(output, point);
        return 0;
    },
    ecdh (output, pubkey, seckey, data, hashfn, xbuf, ybuf) {
        const pair = $4ccd71ceb95e3c9b$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const scalar = new $4ccd71ceb95e3c9b$var$BN(seckey);
        if (scalar.cmp($4ccd71ceb95e3c9b$var$ecparams.n) >= 0 || scalar.isZero()) return 2;
        const point = pair.getPublic().mul(scalar);
        if (hashfn === undefined) {
            const data = point.encode(null, true);
            const sha256 = $4ccd71ceb95e3c9b$var$ec.hash().update(data).digest();
            for(let i = 0; i < 32; ++i)output[i] = sha256[i];
        } else {
            if (!xbuf) xbuf = new Uint8Array(32);
            const x = point.getX().toArray("be", 32);
            for(let i = 0; i < 32; ++i)xbuf[i] = x[i];
            if (!ybuf) ybuf = new Uint8Array(32);
            const y = point.getY().toArray("be", 32);
            for(let i = 0; i < 32; ++i)ybuf[i] = y[i];
            const hash = hashfn(xbuf, ybuf, data);
            const isValid = hash instanceof Uint8Array && hash.length === output.length;
            if (!isValid) return 2;
            output.set(hash);
        }
        return 0;
    }
};

});
parcelRequire.register("29NXu", function(module, exports) {
"use strict";
var $19232cc6a25b3a9f$var$elliptic = module.exports;

$19232cc6a25b3a9f$var$elliptic.version = (parcelRequire("iT5bY")).version;

$19232cc6a25b3a9f$var$elliptic.utils = (parcelRequire("2dyvx"));

$19232cc6a25b3a9f$var$elliptic.rand = (parcelRequire("dBRQ5"));

$19232cc6a25b3a9f$var$elliptic.curve = (parcelRequire("5LpFA"));

$19232cc6a25b3a9f$var$elliptic.curves = (parcelRequire("9HA7A"));

// Protocols
$19232cc6a25b3a9f$var$elliptic.ec = (parcelRequire("8Q7Wh"));

$19232cc6a25b3a9f$var$elliptic.eddsa = (parcelRequire("hsf1r"));

});
parcelRequire.register("iT5bY", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.6.1","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRequire.register("2dyvx", function(module, exports) {
"use strict";
var $19d7902c14a45891$var$utils = module.exports;

var $6hzdy = parcelRequire("6hzdy");

var $9gdNr = parcelRequire("9gdNr");

var $cn6Fj = parcelRequire("cn6Fj");
$19d7902c14a45891$var$utils.assert = $9gdNr;
$19d7902c14a45891$var$utils.toArray = $cn6Fj.toArray;
$19d7902c14a45891$var$utils.zero2 = $cn6Fj.zero2;
$19d7902c14a45891$var$utils.toHex = $cn6Fj.toHex;
$19d7902c14a45891$var$utils.encode = $cn6Fj.encode;
// Represent num in a w-NAF form
function $19d7902c14a45891$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$19d7902c14a45891$var$utils.getNAF = $19d7902c14a45891$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $19d7902c14a45891$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$19d7902c14a45891$var$utils.getJSF = $19d7902c14a45891$var$getJSF;
function $19d7902c14a45891$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$19d7902c14a45891$var$utils.cachedProperty = $19d7902c14a45891$var$cachedProperty;
function $19d7902c14a45891$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $19d7902c14a45891$var$utils.toArray(bytes, "hex") : bytes;
}
$19d7902c14a45891$var$utils.parseBytes = $19d7902c14a45891$var$parseBytes;
function $19d7902c14a45891$var$intFromLE(bytes) {
    return new $6hzdy(bytes, "hex", "le");
}
$19d7902c14a45891$var$utils.intFromLE = $19d7902c14a45891$var$intFromLE;

});
parcelRequire.register("6hzdy", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("7jzxY")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            i++;
        }
        // Clear words above the requested width so the result stays below 2 ** width
        for(; i < this.length; i++)this.words[i] = 0;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("9gdNr", function(module, exports) {
module.exports = $6be04f61e953a197$var$assert;
function $6be04f61e953a197$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$6be04f61e953a197$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRequire.register("cn6Fj", function(module, exports) {
"use strict";
var $901ccda2b9c94d87$var$utils = module.exports;
function $901ccda2b9c94d87$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$901ccda2b9c94d87$var$utils.toArray = $901ccda2b9c94d87$var$toArray;
function $901ccda2b9c94d87$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$901ccda2b9c94d87$var$utils.zero2 = $901ccda2b9c94d87$var$zero2;
function $901ccda2b9c94d87$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $901ccda2b9c94d87$var$zero2(msg[i].toString(16));
    return res;
}
$901ccda2b9c94d87$var$utils.toHex = $901ccda2b9c94d87$var$toHex;
$901ccda2b9c94d87$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $901ccda2b9c94d87$var$toHex(arr);
    else return arr;
};

});


parcelRequire.register("dBRQ5", function(module, exports) {
var $9e887e6547c66784$var$r;
module.exports = function rand(len) {
    if (!$9e887e6547c66784$var$r) $9e887e6547c66784$var$r = new $9e887e6547c66784$var$Rand(null);
    return $9e887e6547c66784$var$r.generate(len);
};
function $9e887e6547c66784$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $9e887e6547c66784$var$Rand;
$9e887e6547c66784$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$9e887e6547c66784$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $9e887e6547c66784$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $9e887e6547c66784$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $9e887e6547c66784$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $9e887e6547c66784$var$crypto = (parcelRequire("7jzxY"));
    if (typeof $9e887e6547c66784$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $9e887e6547c66784$var$Rand.prototype._rand = function _rand(n) {
        return $9e887e6547c66784$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRequire.register("5LpFA", function(module, exports) {
"use strict";
var $432541093244f7e5$var$curve = module.exports;

$432541093244f7e5$var$curve.base = (parcelRequire("dEr2o"));

$432541093244f7e5$var$curve.short = (parcelRequire("aPxQr"));

$432541093244f7e5$var$curve.mont = (parcelRequire("1GPwJ"));

$432541093244f7e5$var$curve.edwards = (parcelRequire("hwMub"));

});
parcelRequire.register("dEr2o", function(module, exports) {
"use strict";

var $6hzdy = parcelRequire("6hzdy");

var $2dyvx = parcelRequire("2dyvx");
var $9f03fbdf65068e71$var$getNAF = $2dyvx.getNAF;
var $9f03fbdf65068e71$var$getJSF = $2dyvx.getJSF;
var $9f03fbdf65068e71$var$assert = $2dyvx.assert;
function $9f03fbdf65068e71$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $6hzdy(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $6hzdy.red(conf.prime) : $6hzdy.mont(this.p);
    // Useful for many curves
    this.zero = new $6hzdy(0).toRed(this.red);
    this.one = new $6hzdy(1).toRed(this.red);
    this.two = new $6hzdy(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $6hzdy(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $9f03fbdf65068e71$var$BaseCurve;
$9f03fbdf65068e71$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$9f03fbdf65068e71$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$9f03fbdf65068e71$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $9f03fbdf65068e71$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $9f03fbdf65068e71$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$9f03fbdf65068e71$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $9f03fbdf65068e71$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $9f03fbdf65068e71$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$9f03fbdf65068e71$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $9f03fbdf65068e71$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $9f03fbdf65068e71$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $9f03fbdf65068e71$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $9f03fbdf65068e71$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$9f03fbdf65068e71$var$BaseCurve.BasePoint = $9f03fbdf65068e71$var$BasePoint;
$9f03fbdf65068e71$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$9f03fbdf65068e71$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$9f03fbdf65068e71$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $2dyvx.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $9f03fbdf65068e71$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $9f03fbdf65068e71$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$9f03fbdf65068e71$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$9f03fbdf65068e71$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$9f03fbdf65068e71$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $2dyvx.encode(this._encode(compact), enc);
};
$9f03fbdf65068e71$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$9f03fbdf65068e71$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$9f03fbdf65068e71$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$9f03fbdf65068e71$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$9f03fbdf65068e71$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$9f03fbdf65068e71$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRequire.register("aPxQr", function(module, exports) {
"use strict";

var $2dyvx = parcelRequire("2dyvx");

var $6hzdy = parcelRequire("6hzdy");

var $7hH44 = parcelRequire("7hH44");

var $dEr2o = parcelRequire("dEr2o");
var $7e28ebb2ae308297$var$assert = $2dyvx.assert;
function $7e28ebb2ae308297$var$ShortCurve(conf) {
    $dEr2o.call(this, "short", conf);
    this.a = new $6hzdy(conf.a, 16).toRed(this.red);
    this.b = new $6hzdy(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$7hH44($7e28ebb2ae308297$var$ShortCurve, $dEr2o);
module.exports = $7e28ebb2ae308297$var$ShortCurve;
$7e28ebb2ae308297$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $6hzdy(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $6hzdy(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $7e28ebb2ae308297$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $6hzdy(vec.a, 16),
            b: new $6hzdy(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$7e28ebb2ae308297$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $6hzdy.mont(num);
    var tinv = new $6hzdy(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $6hzdy(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$7e28ebb2ae308297$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $6hzdy(1);
    var y1 = new $6hzdy(0);
    var x2 = new $6hzdy(0);
    var y2 = new $6hzdy(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$7e28ebb2ae308297$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$7e28ebb2ae308297$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $6hzdy(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$7e28ebb2ae308297$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$7e28ebb2ae308297$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $7e28ebb2ae308297$var$Point(curve, x, y, isRed) {
    $dEr2o.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $6hzdy(x, 16);
        this.y = new $6hzdy(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$7hH44($7e28ebb2ae308297$var$Point, $dEr2o.BasePoint);
$7e28ebb2ae308297$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $7e28ebb2ae308297$var$Point(this, x, y, isRed);
};
$7e28ebb2ae308297$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $7e28ebb2ae308297$var$Point.fromJSON(this, obj, red);
};
$7e28ebb2ae308297$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$7e28ebb2ae308297$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$7e28ebb2ae308297$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$7e28ebb2ae308297$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$7e28ebb2ae308297$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$7e28ebb2ae308297$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$7e28ebb2ae308297$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$7e28ebb2ae308297$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$7e28ebb2ae308297$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$7e28ebb2ae308297$var$Point.prototype.mul = function mul(k) {
    k = new $6hzdy(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$7e28ebb2ae308297$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$7e28ebb2ae308297$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$7e28ebb2ae308297$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$7e28ebb2ae308297$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$7e28ebb2ae308297$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $7e28ebb2ae308297$var$JPoint(curve, x, y, z) {
    $dEr2o.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $6hzdy(0);
    } else {
        this.x = new $6hzdy(x, 16);
        this.y = new $6hzdy(y, 16);
        this.z = new $6hzdy(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$7hH44($7e28ebb2ae308297$var$JPoint, $dEr2o.BasePoint);
$7e28ebb2ae308297$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $7e28ebb2ae308297$var$JPoint(this, x, y, z);
};
$7e28ebb2ae308297$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$7e28ebb2ae308297$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$7e28ebb2ae308297$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$7e28ebb2ae308297$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$7e28ebb2ae308297$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$7e28ebb2ae308297$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$7e28ebb2ae308297$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$7e28ebb2ae308297$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$7e28ebb2ae308297$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$7e28ebb2ae308297$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$7e28ebb2ae308297$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $6hzdy(k, kbase);
    return this.curve._wnafMul(this, k);
};
$7e28ebb2ae308297$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$7e28ebb2ae308297$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$7e28ebb2ae308297$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$7e28ebb2ae308297$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});
parcelRequire.register("7hH44", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRequire.register("1GPwJ", function(module, exports) {
"use strict";

var $6hzdy = parcelRequire("6hzdy");

var $7hH44 = parcelRequire("7hH44");

var $dEr2o = parcelRequire("dEr2o");

var $2dyvx = parcelRequire("2dyvx");
function $13b1aed96788b918$var$MontCurve(conf) {
    $dEr2o.call(this, "mont", conf);
    this.a = new $6hzdy(conf.a, 16).toRed(this.red);
    this.b = new $6hzdy(conf.b, 16).toRed(this.red);
    this.i4 = new $6hzdy(4).toRed(this.red).redInvm();
    this.two = new $6hzdy(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$7hH44($13b1aed96788b918$var$MontCurve, $dEr2o);
module.exports = $13b1aed96788b918$var$MontCurve;
$13b1aed96788b918$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $13b1aed96788b918$var$Point(curve, x, z) {
    $dEr2o.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $6hzdy(x, 16);
        this.z = new $6hzdy(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$7hH44($13b1aed96788b918$var$Point, $dEr2o.BasePoint);
$13b1aed96788b918$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($2dyvx.toArray(bytes, enc), 1);
};
$13b1aed96788b918$var$MontCurve.prototype.point = function point(x, z) {
    return new $13b1aed96788b918$var$Point(this, x, z);
};
$13b1aed96788b918$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $13b1aed96788b918$var$Point.fromJSON(this, obj);
};
$13b1aed96788b918$var$Point.prototype.precompute = function precompute() {
// No-op
};
$13b1aed96788b918$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$13b1aed96788b918$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $13b1aed96788b918$var$Point(curve, obj[0], obj[1] || curve.one);
};
$13b1aed96788b918$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$13b1aed96788b918$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$13b1aed96788b918$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$13b1aed96788b918$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$13b1aed96788b918$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$13b1aed96788b918$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$13b1aed96788b918$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$13b1aed96788b918$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$13b1aed96788b918$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$13b1aed96788b918$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$13b1aed96788b918$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRequire.register("hwMub", function(module, exports) {
"use strict";

var $2dyvx = parcelRequire("2dyvx");

var $6hzdy = parcelRequire("6hzdy");

var $7hH44 = parcelRequire("7hH44");

var $dEr2o = parcelRequire("dEr2o");
var $cc2b091c2ab4208e$var$assert = $2dyvx.assert;
function $cc2b091c2ab4208e$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $dEr2o.call(this, "edwards", conf);
    this.a = new $6hzdy(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $6hzdy(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $6hzdy(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $cc2b091c2ab4208e$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$7hH44($cc2b091c2ab4208e$var$EdwardsCurve, $dEr2o);
module.exports = $cc2b091c2ab4208e$var$EdwardsCurve;
$cc2b091c2ab4208e$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$cc2b091c2ab4208e$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$cc2b091c2ab4208e$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$cc2b091c2ab4208e$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $6hzdy(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$cc2b091c2ab4208e$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $6hzdy(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$cc2b091c2ab4208e$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $cc2b091c2ab4208e$var$Point(curve, x, y, z, t) {
    $dEr2o.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $6hzdy(x, 16);
        this.y = new $6hzdy(y, 16);
        this.z = z ? new $6hzdy(z, 16) : this.curve.one;
        this.t = t && new $6hzdy(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$7hH44($cc2b091c2ab4208e$var$Point, $dEr2o.BasePoint);
$cc2b091c2ab4208e$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $cc2b091c2ab4208e$var$Point.fromJSON(this, obj);
};
$cc2b091c2ab4208e$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $cc2b091c2ab4208e$var$Point(this, x, y, z, t);
};
$cc2b091c2ab4208e$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $cc2b091c2ab4208e$var$Point(curve, obj[0], obj[1], obj[2]);
};
$cc2b091c2ab4208e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$cc2b091c2ab4208e$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$cc2b091c2ab4208e$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$cc2b091c2ab4208e$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$cc2b091c2ab4208e$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$cc2b091c2ab4208e$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$cc2b091c2ab4208e$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$cc2b091c2ab4208e$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$cc2b091c2ab4208e$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$cc2b091c2ab4208e$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$cc2b091c2ab4208e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$cc2b091c2ab4208e$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$cc2b091c2ab4208e$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$cc2b091c2ab4208e$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$cc2b091c2ab4208e$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$cc2b091c2ab4208e$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$cc2b091c2ab4208e$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$cc2b091c2ab4208e$var$Point.prototype.toP = $cc2b091c2ab4208e$var$Point.prototype.normalize;
$cc2b091c2ab4208e$var$Point.prototype.mixedAdd = $cc2b091c2ab4208e$var$Point.prototype.add;

});


parcelRequire.register("9HA7A", function(module, exports) {
"use strict";
var $71042623fc748ae0$var$curves = module.exports;

var $iOWkq = parcelRequire("iOWkq");

var $5LpFA = parcelRequire("5LpFA");

var $2dyvx = parcelRequire("2dyvx");
var $71042623fc748ae0$var$assert = $2dyvx.assert;
function $71042623fc748ae0$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $5LpFA.short(options);
    else if (options.type === "edwards") this.curve = new $5LpFA.edwards(options);
    else this.curve = new $5LpFA.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $71042623fc748ae0$var$assert(this.g.validate(), "Invalid curve");
    $71042623fc748ae0$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$71042623fc748ae0$var$curves.PresetCurve = $71042623fc748ae0$var$PresetCurve;
function $71042623fc748ae0$var$defineCurve(name, options) {
    Object.defineProperty($71042623fc748ae0$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $71042623fc748ae0$var$PresetCurve(options);
            Object.defineProperty($71042623fc748ae0$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$71042623fc748ae0$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $iOWkq.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$71042623fc748ae0$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $iOWkq.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$71042623fc748ae0$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $iOWkq.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$71042623fc748ae0$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $iOWkq.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$71042623fc748ae0$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $iOWkq.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$71042623fc748ae0$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $iOWkq.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$71042623fc748ae0$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $iOWkq.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $71042623fc748ae0$var$pre;

try {
    $71042623fc748ae0$var$pre = (parcelRequire("3VJSe"));
} catch (e) {
    $71042623fc748ae0$var$pre = undefined;
}
$71042623fc748ae0$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $iOWkq.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $71042623fc748ae0$var$pre
    ]
});

});
parcelRequire.register("iOWkq", function(module, exports) {
var $db3a2456b4b2dd6b$var$hash = module.exports;

$db3a2456b4b2dd6b$var$hash.utils = (parcelRequire("9xUi4"));

$db3a2456b4b2dd6b$var$hash.common = (parcelRequire("3Rp9f"));

$db3a2456b4b2dd6b$var$hash.sha = (parcelRequire("lPjPg"));

$db3a2456b4b2dd6b$var$hash.ripemd = (parcelRequire("4aLhO"));

$db3a2456b4b2dd6b$var$hash.hmac = (parcelRequire("8iqJh"));
// Proxy hash functions to the main object
$db3a2456b4b2dd6b$var$hash.sha1 = $db3a2456b4b2dd6b$var$hash.sha.sha1;
$db3a2456b4b2dd6b$var$hash.sha256 = $db3a2456b4b2dd6b$var$hash.sha.sha256;
$db3a2456b4b2dd6b$var$hash.sha224 = $db3a2456b4b2dd6b$var$hash.sha.sha224;
$db3a2456b4b2dd6b$var$hash.sha384 = $db3a2456b4b2dd6b$var$hash.sha.sha384;
$db3a2456b4b2dd6b$var$hash.sha512 = $db3a2456b4b2dd6b$var$hash.sha.sha512;
$db3a2456b4b2dd6b$var$hash.ripemd160 = $db3a2456b4b2dd6b$var$hash.ripemd.ripemd160;

});
parcelRequire.register("9xUi4", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $6f32dc391fbd2a68$export$69f1b2dcda23c5f8, (v) => $6f32dc391fbd2a68$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $6f32dc391fbd2a68$export$45b10814cc054894, (v) => $6f32dc391fbd2a68$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $6f32dc391fbd2a68$export$7ea66e3774a60b67, (v) => $6f32dc391fbd2a68$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $6f32dc391fbd2a68$export$34a52f00f601f6f1, (v) => $6f32dc391fbd2a68$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $6f32dc391fbd2a68$export$812b0cbd5e8a72ab, (v) => $6f32dc391fbd2a68$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $6f32dc391fbd2a68$export$f24f9e11d63bb314, (v) => $6f32dc391fbd2a68$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $6f32dc391fbd2a68$export$b71357c7e07ca1f1, (v) => $6f32dc391fbd2a68$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $6f32dc391fbd2a68$export$2e58a4b541fdcbe8, (v) => $6f32dc391fbd2a68$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $6f32dc391fbd2a68$export$183b950bde9faab8, (v) => $6f32dc391fbd2a68$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $6f32dc391fbd2a68$export$4785c77169fea59e, (v) => $6f32dc391fbd2a68$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $6f32dc391fbd2a68$export$242a185dfcffac5b, (v) => $6f32dc391fbd2a68$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $6f32dc391fbd2a68$export$58c04ae0ae31877d, (v) => $6f32dc391fbd2a68$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $6f32dc391fbd2a68$export$d058ca695f8c6f11, (v) => $6f32dc391fbd2a68$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $6f32dc391fbd2a68$export$a1efd7fc3e986367, (v) => $6f32dc391fbd2a68$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $6f32dc391fbd2a68$export$bbfea4a2b5abaab4, (v) => $6f32dc391fbd2a68$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $6f32dc391fbd2a68$export$97ad4afc7de86152, (v) => $6f32dc391fbd2a68$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $6f32dc391fbd2a68$export$ce4673d9a79f6a4b, (v) => $6f32dc391fbd2a68$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $6f32dc391fbd2a68$export$786cc99fc6eedc0b, (v) => $6f32dc391fbd2a68$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $6f32dc391fbd2a68$export$45c59b9a1848dd0, (v) => $6f32dc391fbd2a68$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $6f32dc391fbd2a68$export$50d8f613e76d3034, (v) => $6f32dc391fbd2a68$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $6f32dc391fbd2a68$export$b8e83683c60ee162, (v) => $6f32dc391fbd2a68$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $6f32dc391fbd2a68$export$aeeb51790d1bcc4a, (v) => $6f32dc391fbd2a68$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $6f32dc391fbd2a68$export$bb7c616f719ad9c, (v) => $6f32dc391fbd2a68$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $6f32dc391fbd2a68$export$4d63290824f9d7df, (v) => $6f32dc391fbd2a68$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $6f32dc391fbd2a68$export$2f64ceb90ef28ea1, (v) => $6f32dc391fbd2a68$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $6f32dc391fbd2a68$export$8d2089d465f6d10d, (v) => $6f32dc391fbd2a68$export$8d2089d465f6d10d = v);
var $6f32dc391fbd2a68$export$69f1b2dcda23c5f8;
var $6f32dc391fbd2a68$export$45b10814cc054894;
var $6f32dc391fbd2a68$export$7ea66e3774a60b67;
var $6f32dc391fbd2a68$export$34a52f00f601f6f1;
var $6f32dc391fbd2a68$export$812b0cbd5e8a72ab;
var $6f32dc391fbd2a68$export$f24f9e11d63bb314;
var $6f32dc391fbd2a68$export$b71357c7e07ca1f1;
var $6f32dc391fbd2a68$export$2e58a4b541fdcbe8;
var $6f32dc391fbd2a68$export$183b950bde9faab8;
var $6f32dc391fbd2a68$export$4785c77169fea59e;
var $6f32dc391fbd2a68$export$242a185dfcffac5b;
var $6f32dc391fbd2a68$export$58c04ae0ae31877d;
var $6f32dc391fbd2a68$export$d058ca695f8c6f11;
var $6f32dc391fbd2a68$export$a1efd7fc3e986367;
var $6f32dc391fbd2a68$export$bbfea4a2b5abaab4;
var $6f32dc391fbd2a68$export$97ad4afc7de86152;
var $6f32dc391fbd2a68$export$ce4673d9a79f6a4b;
var $6f32dc391fbd2a68$export$786cc99fc6eedc0b;
var $6f32dc391fbd2a68$export$45c59b9a1848dd0;
var $6f32dc391fbd2a68$export$50d8f613e76d3034;
var $6f32dc391fbd2a68$export$b8e83683c60ee162;
var $6f32dc391fbd2a68$export$aeeb51790d1bcc4a;
var $6f32dc391fbd2a68$export$bb7c616f719ad9c;
var $6f32dc391fbd2a68$export$4d63290824f9d7df;
var $6f32dc391fbd2a68$export$2f64ceb90ef28ea1;
var $6f32dc391fbd2a68$export$8d2089d465f6d10d;
"use strict";

var $9gdNr = parcelRequire("9gdNr");

var $7hH44 = parcelRequire("7hH44");
$6f32dc391fbd2a68$export$69f1b2dcda23c5f8 = $7hH44;
function $6f32dc391fbd2a68$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $6f32dc391fbd2a68$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($6f32dc391fbd2a68$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$6f32dc391fbd2a68$export$45b10814cc054894 = $6f32dc391fbd2a68$var$toArray;
function $6f32dc391fbd2a68$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $6f32dc391fbd2a68$var$zero2(msg[i].toString(16));
    return res;
}
$6f32dc391fbd2a68$export$7ea66e3774a60b67 = $6f32dc391fbd2a68$var$toHex;
function $6f32dc391fbd2a68$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$6f32dc391fbd2a68$export$34a52f00f601f6f1 = $6f32dc391fbd2a68$var$htonl;
function $6f32dc391fbd2a68$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $6f32dc391fbd2a68$var$htonl(w);
        res += $6f32dc391fbd2a68$var$zero8(w.toString(16));
    }
    return res;
}
$6f32dc391fbd2a68$export$812b0cbd5e8a72ab = $6f32dc391fbd2a68$var$toHex32;
function $6f32dc391fbd2a68$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$6f32dc391fbd2a68$export$f24f9e11d63bb314 = $6f32dc391fbd2a68$var$zero2;
function $6f32dc391fbd2a68$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$6f32dc391fbd2a68$export$b71357c7e07ca1f1 = $6f32dc391fbd2a68$var$zero8;
function $6f32dc391fbd2a68$var$join32(msg, start, end, endian) {
    var len = end - start;
    $9gdNr(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$6f32dc391fbd2a68$export$2e58a4b541fdcbe8 = $6f32dc391fbd2a68$var$join32;
function $6f32dc391fbd2a68$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$6f32dc391fbd2a68$export$183b950bde9faab8 = $6f32dc391fbd2a68$var$split32;
function $6f32dc391fbd2a68$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$6f32dc391fbd2a68$export$4785c77169fea59e = $6f32dc391fbd2a68$var$rotr32;
function $6f32dc391fbd2a68$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$6f32dc391fbd2a68$export$242a185dfcffac5b = $6f32dc391fbd2a68$var$rotl32;
function $6f32dc391fbd2a68$var$sum32(a, b) {
    return a + b >>> 0;
}
$6f32dc391fbd2a68$export$58c04ae0ae31877d = $6f32dc391fbd2a68$var$sum32;
function $6f32dc391fbd2a68$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$6f32dc391fbd2a68$export$d058ca695f8c6f11 = $6f32dc391fbd2a68$var$sum32_3;
function $6f32dc391fbd2a68$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$6f32dc391fbd2a68$export$a1efd7fc3e986367 = $6f32dc391fbd2a68$var$sum32_4;
function $6f32dc391fbd2a68$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$6f32dc391fbd2a68$export$bbfea4a2b5abaab4 = $6f32dc391fbd2a68$var$sum32_5;
function $6f32dc391fbd2a68$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$6f32dc391fbd2a68$export$97ad4afc7de86152 = $6f32dc391fbd2a68$var$sum64;
function $6f32dc391fbd2a68$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$6f32dc391fbd2a68$export$ce4673d9a79f6a4b = $6f32dc391fbd2a68$var$sum64_hi;
function $6f32dc391fbd2a68$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$6f32dc391fbd2a68$export$786cc99fc6eedc0b = $6f32dc391fbd2a68$var$sum64_lo;
function $6f32dc391fbd2a68$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$6f32dc391fbd2a68$export$45c59b9a1848dd0 = $6f32dc391fbd2a68$var$sum64_4_hi;
function $6f32dc391fbd2a68$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$6f32dc391fbd2a68$export$50d8f613e76d3034 = $6f32dc391fbd2a68$var$sum64_4_lo;
function $6f32dc391fbd2a68$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$6f32dc391fbd2a68$export$b8e83683c60ee162 = $6f32dc391fbd2a68$var$sum64_5_hi;
function $6f32dc391fbd2a68$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$6f32dc391fbd2a68$export$aeeb51790d1bcc4a = $6f32dc391fbd2a68$var$sum64_5_lo;
function $6f32dc391fbd2a68$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$6f32dc391fbd2a68$export$bb7c616f719ad9c = $6f32dc391fbd2a68$var$rotr64_hi;
function $6f32dc391fbd2a68$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$6f32dc391fbd2a68$export$4d63290824f9d7df = $6f32dc391fbd2a68$var$rotr64_lo;
function $6f32dc391fbd2a68$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$6f32dc391fbd2a68$export$2f64ceb90ef28ea1 = $6f32dc391fbd2a68$var$shr64_hi;
function $6f32dc391fbd2a68$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$6f32dc391fbd2a68$export$8d2089d465f6d10d = $6f32dc391fbd2a68$var$shr64_lo;

});

parcelRequire.register("3Rp9f", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $2cf9d43d910e5057$export$8687658379b577e6, (v) => $2cf9d43d910e5057$export$8687658379b577e6 = v);
var $2cf9d43d910e5057$export$8687658379b577e6;
"use strict";

var $9xUi4 = parcelRequire("9xUi4");

var $9gdNr = parcelRequire("9gdNr");
function $2cf9d43d910e5057$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$2cf9d43d910e5057$export$8687658379b577e6 = $2cf9d43d910e5057$var$BlockHash;
$2cf9d43d910e5057$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $9xUi4.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $9xUi4.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$2cf9d43d910e5057$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $9gdNr(this.pending === null);
    return this._digest(enc);
};
$2cf9d43d910e5057$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRequire.register("lPjPg", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $fe3dbd636e89600f$export$5091bdda49ba90f5, (v) => $fe3dbd636e89600f$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $fe3dbd636e89600f$export$97b70509d4e397ea, (v) => $fe3dbd636e89600f$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $fe3dbd636e89600f$export$bced8d2aada2d1c9, (v) => $fe3dbd636e89600f$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $fe3dbd636e89600f$export$612d47d55dedde45, (v) => $fe3dbd636e89600f$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $fe3dbd636e89600f$export$a888d2532e6dc7bb, (v) => $fe3dbd636e89600f$export$a888d2532e6dc7bb = v);
var $fe3dbd636e89600f$export$5091bdda49ba90f5;
var $fe3dbd636e89600f$export$97b70509d4e397ea;
var $fe3dbd636e89600f$export$bced8d2aada2d1c9;
var $fe3dbd636e89600f$export$612d47d55dedde45;
var $fe3dbd636e89600f$export$a888d2532e6dc7bb;
"use strict";

$fe3dbd636e89600f$export$5091bdda49ba90f5 = (parcelRequire("3gBaF"));

$fe3dbd636e89600f$export$97b70509d4e397ea = (parcelRequire("6KDGt"));

$fe3dbd636e89600f$export$bced8d2aada2d1c9 = (parcelRequire("fzhYn"));

$fe3dbd636e89600f$export$612d47d55dedde45 = (parcelRequire("lmi9k"));

$fe3dbd636e89600f$export$a888d2532e6dc7bb = (parcelRequire("cyFw4"));

});
parcelRequire.register("3gBaF", function(module, exports) {
"use strict";

var $9xUi4 = parcelRequire("9xUi4");

var $3Rp9f = parcelRequire("3Rp9f");

var $7Pmno = parcelRequire("7Pmno");
var $260fb3232d782d98$var$rotl32 = $9xUi4.rotl32;
var $260fb3232d782d98$var$sum32 = $9xUi4.sum32;
var $260fb3232d782d98$var$sum32_5 = $9xUi4.sum32_5;
var $260fb3232d782d98$var$ft_1 = $7Pmno.ft_1;
var $260fb3232d782d98$var$BlockHash = $3Rp9f.BlockHash;
var $260fb3232d782d98$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $260fb3232d782d98$var$SHA1() {
    if (!(this instanceof $260fb3232d782d98$var$SHA1)) return new $260fb3232d782d98$var$SHA1();
    $260fb3232d782d98$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$9xUi4.inherits($260fb3232d782d98$var$SHA1, $260fb3232d782d98$var$BlockHash);
module.exports = $260fb3232d782d98$var$SHA1;
$260fb3232d782d98$var$SHA1.blockSize = 512;
$260fb3232d782d98$var$SHA1.outSize = 160;
$260fb3232d782d98$var$SHA1.hmacStrength = 80;
$260fb3232d782d98$var$SHA1.padLength = 64;
$260fb3232d782d98$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $260fb3232d782d98$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $260fb3232d782d98$var$sum32_5($260fb3232d782d98$var$rotl32(a, 5), $260fb3232d782d98$var$ft_1(s, b, c, d), e, W[i], $260fb3232d782d98$var$sha1_K[s]);
        e = d;
        d = c;
        c = $260fb3232d782d98$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $260fb3232d782d98$var$sum32(this.h[0], a);
    this.h[1] = $260fb3232d782d98$var$sum32(this.h[1], b);
    this.h[2] = $260fb3232d782d98$var$sum32(this.h[2], c);
    this.h[3] = $260fb3232d782d98$var$sum32(this.h[3], d);
    this.h[4] = $260fb3232d782d98$var$sum32(this.h[4], e);
};
$260fb3232d782d98$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $9xUi4.toHex32(this.h, "big");
    else return $9xUi4.split32(this.h, "big");
};

});
parcelRequire.register("7Pmno", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $5b2ea7493627fff9$export$5a92649d7ddb9f63, (v) => $5b2ea7493627fff9$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $5b2ea7493627fff9$export$c6d0d020c3a6269, (v) => $5b2ea7493627fff9$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $5b2ea7493627fff9$export$eb90c27fca05f956, (v) => $5b2ea7493627fff9$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $5b2ea7493627fff9$export$14a4a98e063b1999, (v) => $5b2ea7493627fff9$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $5b2ea7493627fff9$export$d20cecfa1564c686, (v) => $5b2ea7493627fff9$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $5b2ea7493627fff9$export$44fd472a12fc6db, (v) => $5b2ea7493627fff9$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $5b2ea7493627fff9$export$1ed238bb6ea1dd47, (v) => $5b2ea7493627fff9$export$1ed238bb6ea1dd47 = v);
var $5b2ea7493627fff9$export$5a92649d7ddb9f63;
var $5b2ea7493627fff9$export$c6d0d020c3a6269;
var $5b2ea7493627fff9$export$eb90c27fca05f956;
var $5b2ea7493627fff9$export$cc992891a14496a1;
var $5b2ea7493627fff9$export$14a4a98e063b1999;
var $5b2ea7493627fff9$export$d20cecfa1564c686;
var $5b2ea7493627fff9$export$44fd472a12fc6db;
var $5b2ea7493627fff9$export$1ed238bb6ea1dd47;
"use strict";

var $9xUi4 = parcelRequire("9xUi4");
var $5b2ea7493627fff9$var$rotr32 = $9xUi4.rotr32;
function $5b2ea7493627fff9$var$ft_1(s, x, y, z) {
    if (s === 0) return $5b2ea7493627fff9$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $5b2ea7493627fff9$var$p32(x, y, z);
    if (s === 2) return $5b2ea7493627fff9$var$maj32(x, y, z);
}
$5b2ea7493627fff9$export$5a92649d7ddb9f63 = $5b2ea7493627fff9$var$ft_1;
function $5b2ea7493627fff9$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$5b2ea7493627fff9$export$c6d0d020c3a6269 = $5b2ea7493627fff9$var$ch32;
function $5b2ea7493627fff9$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$5b2ea7493627fff9$export$eb90c27fca05f956 = $5b2ea7493627fff9$var$maj32;
function $5b2ea7493627fff9$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$5b2ea7493627fff9$export$cc992891a14496a1 = $5b2ea7493627fff9$var$p32;
function $5b2ea7493627fff9$var$s0_256(x) {
    return $5b2ea7493627fff9$var$rotr32(x, 2) ^ $5b2ea7493627fff9$var$rotr32(x, 13) ^ $5b2ea7493627fff9$var$rotr32(x, 22);
}
$5b2ea7493627fff9$export$14a4a98e063b1999 = $5b2ea7493627fff9$var$s0_256;
function $5b2ea7493627fff9$var$s1_256(x) {
    return $5b2ea7493627fff9$var$rotr32(x, 6) ^ $5b2ea7493627fff9$var$rotr32(x, 11) ^ $5b2ea7493627fff9$var$rotr32(x, 25);
}
$5b2ea7493627fff9$export$d20cecfa1564c686 = $5b2ea7493627fff9$var$s1_256;
function $5b2ea7493627fff9$var$g0_256(x) {
    return $5b2ea7493627fff9$var$rotr32(x, 7) ^ $5b2ea7493627fff9$var$rotr32(x, 18) ^ x >>> 3;
}
$5b2ea7493627fff9$export$44fd472a12fc6db = $5b2ea7493627fff9$var$g0_256;
function $5b2ea7493627fff9$var$g1_256(x) {
    return $5b2ea7493627fff9$var$rotr32(x, 17) ^ $5b2ea7493627fff9$var$rotr32(x, 19) ^ x >>> 10;
}
$5b2ea7493627fff9$export$1ed238bb6ea1dd47 = $5b2ea7493627fff9$var$g1_256;

});


parcelRequire.register("6KDGt", function(module, exports) {
"use strict";

var $9xUi4 = parcelRequire("9xUi4");

var $fzhYn = parcelRequire("fzhYn");
function $4ea5d265238c137c$var$SHA224() {
    if (!(this instanceof $4ea5d265238c137c$var$SHA224)) return new $4ea5d265238c137c$var$SHA224();
    $fzhYn.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$9xUi4.inherits($4ea5d265238c137c$var$SHA224, $fzhYn);
module.exports = $4ea5d265238c137c$var$SHA224;
$4ea5d265238c137c$var$SHA224.blockSize = 512;
$4ea5d265238c137c$var$SHA224.outSize = 224;
$4ea5d265238c137c$var$SHA224.hmacStrength = 192;
$4ea5d265238c137c$var$SHA224.padLength = 64;
$4ea5d265238c137c$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $9xUi4.toHex32(this.h.slice(0, 7), "big");
    else return $9xUi4.split32(this.h.slice(0, 7), "big");
};

});
parcelRequire.register("fzhYn", function(module, exports) {
"use strict";

var $9xUi4 = parcelRequire("9xUi4");

var $3Rp9f = parcelRequire("3Rp9f");

var $7Pmno = parcelRequire("7Pmno");

var $9gdNr = parcelRequire("9gdNr");
var $b55810ebb857c496$var$sum32 = $9xUi4.sum32;
var $b55810ebb857c496$var$sum32_4 = $9xUi4.sum32_4;
var $b55810ebb857c496$var$sum32_5 = $9xUi4.sum32_5;
var $b55810ebb857c496$var$ch32 = $7Pmno.ch32;
var $b55810ebb857c496$var$maj32 = $7Pmno.maj32;
var $b55810ebb857c496$var$s0_256 = $7Pmno.s0_256;
var $b55810ebb857c496$var$s1_256 = $7Pmno.s1_256;
var $b55810ebb857c496$var$g0_256 = $7Pmno.g0_256;
var $b55810ebb857c496$var$g1_256 = $7Pmno.g1_256;
var $b55810ebb857c496$var$BlockHash = $3Rp9f.BlockHash;
var $b55810ebb857c496$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $b55810ebb857c496$var$SHA256() {
    if (!(this instanceof $b55810ebb857c496$var$SHA256)) return new $b55810ebb857c496$var$SHA256();
    $b55810ebb857c496$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $b55810ebb857c496$var$sha256_K;
    this.W = new Array(64);
}
$9xUi4.inherits($b55810ebb857c496$var$SHA256, $b55810ebb857c496$var$BlockHash);
module.exports = $b55810ebb857c496$var$SHA256;
$b55810ebb857c496$var$SHA256.blockSize = 512;
$b55810ebb857c496$var$SHA256.outSize = 256;
$b55810ebb857c496$var$SHA256.hmacStrength = 192;
$b55810ebb857c496$var$SHA256.padLength = 64;
$b55810ebb857c496$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $b55810ebb857c496$var$sum32_4($b55810ebb857c496$var$g1_256(W[i - 2]), W[i - 7], $b55810ebb857c496$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $9gdNr(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $b55810ebb857c496$var$sum32_5(h, $b55810ebb857c496$var$s1_256(e), $b55810ebb857c496$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $b55810ebb857c496$var$sum32($b55810ebb857c496$var$s0_256(a), $b55810ebb857c496$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $b55810ebb857c496$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $b55810ebb857c496$var$sum32(T1, T2);
    }
    this.h[0] = $b55810ebb857c496$var$sum32(this.h[0], a);
    this.h[1] = $b55810ebb857c496$var$sum32(this.h[1], b);
    this.h[2] = $b55810ebb857c496$var$sum32(this.h[2], c);
    this.h[3] = $b55810ebb857c496$var$sum32(this.h[3], d);
    this.h[4] = $b55810ebb857c496$var$sum32(this.h[4], e);
    this.h[5] = $b55810ebb857c496$var$sum32(this.h[5], f);
    this.h[6] = $b55810ebb857c496$var$sum32(this.h[6], g);
    this.h[7] = $b55810ebb857c496$var$sum32(this.h[7], h);
};
$b55810ebb857c496$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $9xUi4.toHex32(this.h, "big");
    else return $9xUi4.split32(this.h, "big");
};

});


parcelRequire.register("lmi9k", function(module, exports) {
"use strict";

var $9xUi4 = parcelRequire("9xUi4");

var $cyFw4 = parcelRequire("cyFw4");
function $f8c9bb281d48beea$var$SHA384() {
    if (!(this instanceof $f8c9bb281d48beea$var$SHA384)) return new $f8c9bb281d48beea$var$SHA384();
    $cyFw4.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$9xUi4.inherits($f8c9bb281d48beea$var$SHA384, $cyFw4);
module.exports = $f8c9bb281d48beea$var$SHA384;
$f8c9bb281d48beea$var$SHA384.blockSize = 1024;
$f8c9bb281d48beea$var$SHA384.outSize = 384;
$f8c9bb281d48beea$var$SHA384.hmacStrength = 192;
$f8c9bb281d48beea$var$SHA384.padLength = 128;
$f8c9bb281d48beea$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $9xUi4.toHex32(this.h.slice(0, 12), "big");
    else return $9xUi4.split32(this.h.slice(0, 12), "big");
};

});
parcelRequire.register("cyFw4", function(module, exports) {
"use strict";

var $9xUi4 = parcelRequire("9xUi4");

var $3Rp9f = parcelRequire("3Rp9f");

var $9gdNr = parcelRequire("9gdNr");
var $9248dd48f9cc554c$var$rotr64_hi = $9xUi4.rotr64_hi;
var $9248dd48f9cc554c$var$rotr64_lo = $9xUi4.rotr64_lo;
var $9248dd48f9cc554c$var$shr64_hi = $9xUi4.shr64_hi;
var $9248dd48f9cc554c$var$shr64_lo = $9xUi4.shr64_lo;
var $9248dd48f9cc554c$var$sum64 = $9xUi4.sum64;
var $9248dd48f9cc554c$var$sum64_hi = $9xUi4.sum64_hi;
var $9248dd48f9cc554c$var$sum64_lo = $9xUi4.sum64_lo;
var $9248dd48f9cc554c$var$sum64_4_hi = $9xUi4.sum64_4_hi;
var $9248dd48f9cc554c$var$sum64_4_lo = $9xUi4.sum64_4_lo;
var $9248dd48f9cc554c$var$sum64_5_hi = $9xUi4.sum64_5_hi;
var $9248dd48f9cc554c$var$sum64_5_lo = $9xUi4.sum64_5_lo;
var $9248dd48f9cc554c$var$BlockHash = $3Rp9f.BlockHash;
var $9248dd48f9cc554c$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $9248dd48f9cc554c$var$SHA512() {
    if (!(this instanceof $9248dd48f9cc554c$var$SHA512)) return new $9248dd48f9cc554c$var$SHA512();
    $9248dd48f9cc554c$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $9248dd48f9cc554c$var$sha512_K;
    this.W = new Array(160);
}
$9xUi4.inherits($9248dd48f9cc554c$var$SHA512, $9248dd48f9cc554c$var$BlockHash);
module.exports = $9248dd48f9cc554c$var$SHA512;
$9248dd48f9cc554c$var$SHA512.blockSize = 1024;
$9248dd48f9cc554c$var$SHA512.outSize = 512;
$9248dd48f9cc554c$var$SHA512.hmacStrength = 192;
$9248dd48f9cc554c$var$SHA512.padLength = 128;
$9248dd48f9cc554c$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $9248dd48f9cc554c$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $9248dd48f9cc554c$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $9248dd48f9cc554c$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $9248dd48f9cc554c$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $9248dd48f9cc554c$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $9248dd48f9cc554c$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$9248dd48f9cc554c$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $9gdNr(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $9248dd48f9cc554c$var$s1_512_hi(eh, el);
        var c1_lo = $9248dd48f9cc554c$var$s1_512_lo(eh, el);
        var c2_hi = $9248dd48f9cc554c$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $9248dd48f9cc554c$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $9248dd48f9cc554c$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $9248dd48f9cc554c$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $9248dd48f9cc554c$var$s0_512_hi(ah, al);
        c0_lo = $9248dd48f9cc554c$var$s0_512_lo(ah, al);
        c1_hi = $9248dd48f9cc554c$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $9248dd48f9cc554c$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $9248dd48f9cc554c$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $9248dd48f9cc554c$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $9248dd48f9cc554c$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $9248dd48f9cc554c$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $9248dd48f9cc554c$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $9248dd48f9cc554c$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $9248dd48f9cc554c$var$sum64(this.h, 0, ah, al);
    $9248dd48f9cc554c$var$sum64(this.h, 2, bh, bl);
    $9248dd48f9cc554c$var$sum64(this.h, 4, ch, cl);
    $9248dd48f9cc554c$var$sum64(this.h, 6, dh, dl);
    $9248dd48f9cc554c$var$sum64(this.h, 8, eh, el);
    $9248dd48f9cc554c$var$sum64(this.h, 10, fh, fl);
    $9248dd48f9cc554c$var$sum64(this.h, 12, gh, gl);
    $9248dd48f9cc554c$var$sum64(this.h, 14, hh, hl);
};
$9248dd48f9cc554c$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $9xUi4.toHex32(this.h, "big");
    else return $9xUi4.split32(this.h, "big");
};
function $9248dd48f9cc554c$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9248dd48f9cc554c$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9248dd48f9cc554c$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9248dd48f9cc554c$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9248dd48f9cc554c$var$s0_512_hi(xh, xl) {
    var c0_hi = $9248dd48f9cc554c$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $9248dd48f9cc554c$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $9248dd48f9cc554c$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9248dd48f9cc554c$var$s0_512_lo(xh, xl) {
    var c0_lo = $9248dd48f9cc554c$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $9248dd48f9cc554c$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $9248dd48f9cc554c$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9248dd48f9cc554c$var$s1_512_hi(xh, xl) {
    var c0_hi = $9248dd48f9cc554c$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $9248dd48f9cc554c$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $9248dd48f9cc554c$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9248dd48f9cc554c$var$s1_512_lo(xh, xl) {
    var c0_lo = $9248dd48f9cc554c$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $9248dd48f9cc554c$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $9248dd48f9cc554c$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9248dd48f9cc554c$var$g0_512_hi(xh, xl) {
    var c0_hi = $9248dd48f9cc554c$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $9248dd48f9cc554c$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $9248dd48f9cc554c$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9248dd48f9cc554c$var$g0_512_lo(xh, xl) {
    var c0_lo = $9248dd48f9cc554c$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $9248dd48f9cc554c$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $9248dd48f9cc554c$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9248dd48f9cc554c$var$g1_512_hi(xh, xl) {
    var c0_hi = $9248dd48f9cc554c$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $9248dd48f9cc554c$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $9248dd48f9cc554c$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $9248dd48f9cc554c$var$g1_512_lo(xh, xl) {
    var c0_lo = $9248dd48f9cc554c$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $9248dd48f9cc554c$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $9248dd48f9cc554c$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRequire.register("4aLhO", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $309cc6b10326896b$export$d1cea0ee4e3f0d3e, (v) => $309cc6b10326896b$export$d1cea0ee4e3f0d3e = v);
var $309cc6b10326896b$export$d1cea0ee4e3f0d3e;
"use strict";

var $9xUi4 = parcelRequire("9xUi4");

var $3Rp9f = parcelRequire("3Rp9f");
var $309cc6b10326896b$var$rotl32 = $9xUi4.rotl32;
var $309cc6b10326896b$var$sum32 = $9xUi4.sum32;
var $309cc6b10326896b$var$sum32_3 = $9xUi4.sum32_3;
var $309cc6b10326896b$var$sum32_4 = $9xUi4.sum32_4;
var $309cc6b10326896b$var$BlockHash = $3Rp9f.BlockHash;
function $309cc6b10326896b$var$RIPEMD160() {
    if (!(this instanceof $309cc6b10326896b$var$RIPEMD160)) return new $309cc6b10326896b$var$RIPEMD160();
    $309cc6b10326896b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$9xUi4.inherits($309cc6b10326896b$var$RIPEMD160, $309cc6b10326896b$var$BlockHash);
$309cc6b10326896b$export$d1cea0ee4e3f0d3e = $309cc6b10326896b$var$RIPEMD160;
$309cc6b10326896b$var$RIPEMD160.blockSize = 512;
$309cc6b10326896b$var$RIPEMD160.outSize = 160;
$309cc6b10326896b$var$RIPEMD160.hmacStrength = 192;
$309cc6b10326896b$var$RIPEMD160.padLength = 64;
$309cc6b10326896b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $309cc6b10326896b$var$sum32($309cc6b10326896b$var$rotl32($309cc6b10326896b$var$sum32_4(A, $309cc6b10326896b$var$f(j, B, C, D), msg[$309cc6b10326896b$var$r[j] + start], $309cc6b10326896b$var$K(j)), $309cc6b10326896b$var$s[j]), E);
        A = E;
        E = D;
        D = $309cc6b10326896b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $309cc6b10326896b$var$sum32($309cc6b10326896b$var$rotl32($309cc6b10326896b$var$sum32_4(Ah, $309cc6b10326896b$var$f(79 - j, Bh, Ch, Dh), msg[$309cc6b10326896b$var$rh[j] + start], $309cc6b10326896b$var$Kh(j)), $309cc6b10326896b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $309cc6b10326896b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $309cc6b10326896b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $309cc6b10326896b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $309cc6b10326896b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $309cc6b10326896b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $309cc6b10326896b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$309cc6b10326896b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $9xUi4.toHex32(this.h, "little");
    else return $9xUi4.split32(this.h, "little");
};
function $309cc6b10326896b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $309cc6b10326896b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $309cc6b10326896b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $309cc6b10326896b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $309cc6b10326896b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $309cc6b10326896b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $309cc6b10326896b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRequire.register("8iqJh", function(module, exports) {
"use strict";

var $9xUi4 = parcelRequire("9xUi4");

var $9gdNr = parcelRequire("9gdNr");
function $60a4bd115d907b82$var$Hmac(hash, key, enc) {
    if (!(this instanceof $60a4bd115d907b82$var$Hmac)) return new $60a4bd115d907b82$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($9xUi4.toArray(key, enc));
}
module.exports = $60a4bd115d907b82$var$Hmac;
$60a4bd115d907b82$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $9gdNr(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$60a4bd115d907b82$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$60a4bd115d907b82$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRequire.register("3VJSe", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRequire.register("8Q7Wh", function(module, exports) {
"use strict";

var $6hzdy = parcelRequire("6hzdy");

var $bR10N = parcelRequire("bR10N");

var $2dyvx = parcelRequire("2dyvx");

var $9HA7A = parcelRequire("9HA7A");

var $dBRQ5 = parcelRequire("dBRQ5");
var $66f9569510cd5982$var$assert = $2dyvx.assert;

var $9DECy = parcelRequire("9DECy");

var $dVJXf = parcelRequire("dVJXf");
function $66f9569510cd5982$var$EC(options) {
    if (!(this instanceof $66f9569510cd5982$var$EC)) return new $66f9569510cd5982$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $66f9569510cd5982$var$assert(Object.prototype.hasOwnProperty.call($9HA7A, options), "Unknown curve " + options);
        options = $9HA7A[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $9HA7A.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $66f9569510cd5982$var$EC;
$66f9569510cd5982$var$EC.prototype.keyPair = function keyPair(options) {
    return new $9DECy(this, options);
};
$66f9569510cd5982$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $9DECy.fromPrivate(this, priv, enc);
};
$66f9569510cd5982$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $9DECy.fromPublic(this, pub, enc);
};
$66f9569510cd5982$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $bR10N({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $dBRQ5(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $6hzdy(2));
    for(;;){
        var priv = new $6hzdy(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$66f9569510cd5982$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($6hzdy.isBN(msg) || typeof msg === "number") {
        msg = new $6hzdy(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === "object") {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $6hzdy(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $6hzdy(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== "number") bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$66f9569510cd5982$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== "string" && typeof msg !== "number" && !$6hzdy.isBN(msg)) {
        $66f9569510cd5982$var$assert(typeof msg === "object" && msg && typeof msg.length === "number", "Expected message to be an array-like, a hex string, or a BN instance");
        $66f9569510cd5982$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$66f9569510cd5982$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $66f9569510cd5982$var$assert(!msg.isNeg(), "Can not sign a negative message");
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Recheck nonce to be bijective to msg
    $66f9569510cd5982$var$assert(new $6hzdy(nonce).eq(msg), "Can not sign message");
    // Instantiate Hmac_DRBG
    var drbg = new $bR10N({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $6hzdy(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $6hzdy(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $dVJXf({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$66f9569510cd5982$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $dVJXf(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$66f9569510cd5982$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $66f9569510cd5982$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $dVJXf(signature, enc);
    var n = this.n;
    var e = new $6hzdy(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$66f9569510cd5982$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $dVJXf(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRequire.register("bR10N", function(module, exports) {
"use strict";

var $iOWkq = parcelRequire("iOWkq");

var $cn6Fj = parcelRequire("cn6Fj");

var $9gdNr = parcelRequire("9gdNr");
function $8a156de70a39a3bf$var$HmacDRBG(options) {
    if (!(this instanceof $8a156de70a39a3bf$var$HmacDRBG)) return new $8a156de70a39a3bf$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $cn6Fj.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $cn6Fj.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $cn6Fj.toArray(options.pers, options.persEnc || "hex");
    $9gdNr(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $8a156de70a39a3bf$var$HmacDRBG;
$8a156de70a39a3bf$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$8a156de70a39a3bf$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $iOWkq.hmac(this.hash, this.K);
};
$8a156de70a39a3bf$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$8a156de70a39a3bf$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $cn6Fj.toArray(entropy, entropyEnc);
    add = $cn6Fj.toArray(add, addEnc);
    $9gdNr(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$8a156de70a39a3bf$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $cn6Fj.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $cn6Fj.encode(res, enc);
};

});

parcelRequire.register("9DECy", function(module, exports) {
"use strict";

var $6hzdy = parcelRequire("6hzdy");

var $2dyvx = parcelRequire("2dyvx");
var $70474409d39b7239$var$assert = $2dyvx.assert;
function $70474409d39b7239$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $70474409d39b7239$var$KeyPair;
$70474409d39b7239$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $70474409d39b7239$var$KeyPair) return pub;
    return new $70474409d39b7239$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$70474409d39b7239$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $70474409d39b7239$var$KeyPair) return priv;
    return new $70474409d39b7239$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$70474409d39b7239$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$70474409d39b7239$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$70474409d39b7239$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$70474409d39b7239$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $6hzdy(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$70474409d39b7239$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $70474409d39b7239$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $70474409d39b7239$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$70474409d39b7239$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $70474409d39b7239$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$70474409d39b7239$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$70474409d39b7239$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$70474409d39b7239$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRequire.register("dVJXf", function(module, exports) {
"use strict";

var $6hzdy = parcelRequire("6hzdy");

var $2dyvx = parcelRequire("2dyvx");
var $a2443ed9c227f94f$var$assert = $2dyvx.assert;
function $a2443ed9c227f94f$var$Signature(options, enc) {
    if (options instanceof $a2443ed9c227f94f$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $a2443ed9c227f94f$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $6hzdy(options.r, 16);
    this.s = new $6hzdy(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $a2443ed9c227f94f$var$Signature;
function $a2443ed9c227f94f$var$Position() {
    this.place = 0;
}
function $a2443ed9c227f94f$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $a2443ed9c227f94f$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$a2443ed9c227f94f$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $2dyvx.toArray(data, enc);
    var p = new $a2443ed9c227f94f$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $a2443ed9c227f94f$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $a2443ed9c227f94f$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $a2443ed9c227f94f$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $6hzdy(r);
    this.s = new $6hzdy(s);
    this.recoveryParam = null;
    return true;
};
function $a2443ed9c227f94f$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$a2443ed9c227f94f$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $a2443ed9c227f94f$var$rmPadding(r);
    s = $a2443ed9c227f94f$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $a2443ed9c227f94f$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $a2443ed9c227f94f$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $a2443ed9c227f94f$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $2dyvx.encode(res, enc);
};

});


parcelRequire.register("hsf1r", function(module, exports) {
"use strict";

var $iOWkq = parcelRequire("iOWkq");

var $9HA7A = parcelRequire("9HA7A");

var $2dyvx = parcelRequire("2dyvx");
var $cb50b44f2b9d6be9$var$assert = $2dyvx.assert;
var $cb50b44f2b9d6be9$var$parseBytes = $2dyvx.parseBytes;

var $3ytQM = parcelRequire("3ytQM");

var $1eMNM = parcelRequire("1eMNM");
function $cb50b44f2b9d6be9$var$EDDSA(curve) {
    $cb50b44f2b9d6be9$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $cb50b44f2b9d6be9$var$EDDSA)) return new $cb50b44f2b9d6be9$var$EDDSA(curve);
    curve = $9HA7A[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $iOWkq.sha512;
}
module.exports = $cb50b44f2b9d6be9$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $cb50b44f2b9d6be9$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $cb50b44f2b9d6be9$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $cb50b44f2b9d6be9$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $cb50b44f2b9d6be9$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$cb50b44f2b9d6be9$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $2dyvx.intFromLE(hash.digest()).umod(this.curve.n);
};
$cb50b44f2b9d6be9$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $3ytQM.fromPublic(this, pub);
};
$cb50b44f2b9d6be9$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $3ytQM.fromSecret(this, secret);
};
$cb50b44f2b9d6be9$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $1eMNM) return sig;
    return new $1eMNM(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $cb50b44f2b9d6be9$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$cb50b44f2b9d6be9$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $2dyvx.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $2dyvx.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$cb50b44f2b9d6be9$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$cb50b44f2b9d6be9$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $2dyvx.intFromLE(bytes);
};
$cb50b44f2b9d6be9$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRequire.register("3ytQM", function(module, exports) {
"use strict";

var $2dyvx = parcelRequire("2dyvx");
var $296bb3bec6b975d9$var$assert = $2dyvx.assert;
var $296bb3bec6b975d9$var$parseBytes = $2dyvx.parseBytes;
var $296bb3bec6b975d9$var$cachedProperty = $2dyvx.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $296bb3bec6b975d9$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $296bb3bec6b975d9$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $296bb3bec6b975d9$var$parseBytes(params.pub);
}
$296bb3bec6b975d9$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $296bb3bec6b975d9$var$KeyPair) return pub;
    return new $296bb3bec6b975d9$var$KeyPair(eddsa, {
        pub: pub
    });
};
$296bb3bec6b975d9$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $296bb3bec6b975d9$var$KeyPair) return secret;
    return new $296bb3bec6b975d9$var$KeyPair(eddsa, {
        secret: secret
    });
};
$296bb3bec6b975d9$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$296bb3bec6b975d9$var$cachedProperty($296bb3bec6b975d9$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$296bb3bec6b975d9$var$cachedProperty($296bb3bec6b975d9$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$296bb3bec6b975d9$var$cachedProperty($296bb3bec6b975d9$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$296bb3bec6b975d9$var$cachedProperty($296bb3bec6b975d9$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$296bb3bec6b975d9$var$cachedProperty($296bb3bec6b975d9$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$296bb3bec6b975d9$var$cachedProperty($296bb3bec6b975d9$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$296bb3bec6b975d9$var$KeyPair.prototype.sign = function sign(message) {
    $296bb3bec6b975d9$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$296bb3bec6b975d9$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$296bb3bec6b975d9$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $296bb3bec6b975d9$var$assert(this._secret, "KeyPair is public only");
    return $2dyvx.encode(this.secret(), enc);
};
$296bb3bec6b975d9$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $2dyvx.encode(this.pubBytes(), enc);
};
module.exports = $296bb3bec6b975d9$var$KeyPair;

});

parcelRequire.register("1eMNM", function(module, exports) {
"use strict";

var $6hzdy = parcelRequire("6hzdy");

var $2dyvx = parcelRequire("2dyvx");
var $0e6cf44a3b1687a5$var$assert = $2dyvx.assert;
var $0e6cf44a3b1687a5$var$cachedProperty = $2dyvx.cachedProperty;
var $0e6cf44a3b1687a5$var$parseBytes = $2dyvx.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $0e6cf44a3b1687a5$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $0e6cf44a3b1687a5$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $0e6cf44a3b1687a5$var$assert(sig.length === eddsa.encodingLength * 2, "Signature has invalid size");
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $0e6cf44a3b1687a5$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $6hzdy) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$0e6cf44a3b1687a5$var$cachedProperty($0e6cf44a3b1687a5$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$0e6cf44a3b1687a5$var$cachedProperty($0e6cf44a3b1687a5$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$0e6cf44a3b1687a5$var$cachedProperty($0e6cf44a3b1687a5$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$0e6cf44a3b1687a5$var$cachedProperty($0e6cf44a3b1687a5$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$0e6cf44a3b1687a5$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$0e6cf44a3b1687a5$var$Signature.prototype.toHex = function toHex() {
    return $2dyvx.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $0e6cf44a3b1687a5$var$Signature;

});







parcelRequire.register("lLTE8", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $8hEBV = parcelRequire("8hEBV");
var $fd9926f0356962e7$require$uint8ArrayConcat = $8hEBV.concat;

var $8cWjP = parcelRequire("8cWjP");
var $fd9926f0356962e7$require$uint8ArrayFromString = $8cWjP.fromString;

var $1guLm = parcelRequire("1guLm");
const $fd9926f0356962e7$var$cipherMap = {
    "AES-128": {
        ivSize: 16,
        keySize: 16
    },
    "AES-256": {
        ivSize: 16,
        keySize: 32
    },
    Blowfish: {
        ivSize: 8,
        cipherKeySize: 32
    }
};
// Generates a set of keys for each party by stretching the shared key.
// (myIV, theirIV, myCipherKey, theirCipherKey, myMACKey, theirMACKey)
module.exports = async (cipherType, hash, secret)=>{
    const cipher = $fd9926f0356962e7$var$cipherMap[cipherType];
    if (!cipher) {
        const allowed = Object.keys($fd9926f0356962e7$var$cipherMap).join(" / ");
        throw $20Lm5(new Error(`unknown cipher type '${cipherType}'. Must be ${allowed}`), "ERR_INVALID_CIPHER_TYPE");
    }
    if (!hash) throw $20Lm5(new Error("missing hash type"), "ERR_MISSING_HASH_TYPE");
    const cipherKeySize = cipher.keySize;
    const ivSize = cipher.ivSize;
    const hmacKeySize = 20;
    const seed = $fd9926f0356962e7$require$uint8ArrayFromString("key expansion");
    const resultLength = 2 * (ivSize + cipherKeySize + hmacKeySize);
    const m = await $1guLm.create(hash, secret);
    let a = await m.digest(seed);
    const result = [];
    let j = 0;
    while(j < resultLength){
        const b = await m.digest($fd9926f0356962e7$require$uint8ArrayConcat([
            a,
            seed
        ]));
        let todo = b.length;
        if (j + todo > resultLength) todo = resultLength - j;
        result.push(b);
        j += todo;
        a = await m.digest(a);
    }
    const half = resultLength / 2;
    const resultBuffer = $fd9926f0356962e7$require$uint8ArrayConcat(result);
    const r1 = resultBuffer.slice(0, half);
    const r2 = resultBuffer.slice(half, resultLength);
    const createKey = (res)=>({
            iv: res.slice(0, ivSize),
            cipherKey: res.slice(ivSize, ivSize + cipherKeySize),
            macKey: res.slice(ivSize + cipherKeySize)
        });
    return {
        k1: createKey(r1),
        k2: createKey(r2)
    };
};

});

parcelRequire.register("28g7q", function(module, exports) {
"use strict";

var $7Otj4 = parcelRequire("7Otj4");
// Generates an ephemeral public key and returns a function that will compute
// the shared secret key.
//
// Focuses only on ECDH now, but can be made more general in the future.
module.exports = async (curve)=>$7Otj4.generateEphmeralKeyPair(curve) // eslint-disable-line require-await
;

});
parcelRequire.register("7Otj4", function(module, exports) {

$parcel$export(module.exports, "generateEphmeralKeyPair", () => $5b03ef99ca7b2f3a$export$8c9e061ef03ebfb1, (v) => $5b03ef99ca7b2f3a$export$8c9e061ef03ebfb1 = v);
var $5b03ef99ca7b2f3a$export$8c9e061ef03ebfb1;
"use strict";

var $20Lm5 = parcelRequire("20Lm5");

var $bpHqr = parcelRequire("bpHqr");

var $agoAr = parcelRequire("agoAr");
var $5b03ef99ca7b2f3a$require$base64urlToBuffer = $agoAr.base64urlToBuffer;

var $eHnUK = parcelRequire("eHnUK");

var $6rBCs = parcelRequire("6rBCs");
var $5b03ef99ca7b2f3a$require$uint8ArrayToString = $6rBCs.toString;

var $8hEBV = parcelRequire("8hEBV");
var $5b03ef99ca7b2f3a$require$uint8ArrayConcat = $8hEBV.concat;

var $ijWXY = parcelRequire("ijWXY");
var $5b03ef99ca7b2f3a$require$uint8ArrayEquals = $ijWXY.equals;
const $5b03ef99ca7b2f3a$var$bits = {
    "P-256": 256,
    "P-384": 384,
    "P-521": 521
};
$5b03ef99ca7b2f3a$export$8c9e061ef03ebfb1 = async function(curve) {
    $eHnUK(Object.keys($5b03ef99ca7b2f3a$var$bits), curve);
    const pair = await $bpHqr.get().subtle.generateKey({
        name: "ECDH",
        namedCurve: curve
    }, true, [
        "deriveBits"
    ]);
    // forcePrivate is used for testing only
    const genSharedKey = async (theirPub, forcePrivate)=>{
        let privateKey;
        if (forcePrivate) privateKey = await $bpHqr.get().subtle.importKey("jwk", $5b03ef99ca7b2f3a$var$unmarshalPrivateKey(curve, forcePrivate), {
            name: "ECDH",
            namedCurve: curve
        }, false, [
            "deriveBits"
        ]);
        else privateKey = pair.privateKey;
        const keys = [
            await $bpHqr.get().subtle.importKey("jwk", $5b03ef99ca7b2f3a$var$unmarshalPublicKey(curve, theirPub), {
                name: "ECDH",
                namedCurve: curve
            }, false, []),
            privateKey
        ];
        const buffer = await $bpHqr.get().subtle.deriveBits({
            name: "ECDH",
            namedCurve: curve,
            public: keys[0]
        }, keys[1], $5b03ef99ca7b2f3a$var$bits[curve]);
        return new Uint8Array(buffer, buffer.byteOffset, buffer.byteLength);
    };
    const publicKey = await $bpHqr.get().subtle.exportKey("jwk", pair.publicKey);
    return {
        key: $5b03ef99ca7b2f3a$var$marshalPublicKey(publicKey),
        genSharedKey: genSharedKey
    };
};
const $5b03ef99ca7b2f3a$var$curveLengths = {
    "P-256": 32,
    "P-384": 48,
    "P-521": 66
};
// Marshal converts a jwk encodec ECDH public key into the
// form specified in section 4.3.6 of ANSI X9.62. (This is the format
// go-ipfs uses)
function $5b03ef99ca7b2f3a$var$marshalPublicKey(jwk) {
    const byteLen = $5b03ef99ca7b2f3a$var$curveLengths[jwk.crv];
    return $5b03ef99ca7b2f3a$require$uint8ArrayConcat([
        Uint8Array.from([
            4
        ]),
        $5b03ef99ca7b2f3a$require$base64urlToBuffer(jwk.x, byteLen),
        $5b03ef99ca7b2f3a$require$base64urlToBuffer(jwk.y, byteLen)
    ], 1 + byteLen * 2);
}
// Unmarshal converts a point, serialized by Marshal, into an jwk encoded key
function $5b03ef99ca7b2f3a$var$unmarshalPublicKey(curve, key) {
    const byteLen = $5b03ef99ca7b2f3a$var$curveLengths[curve];
    if ($5b03ef99ca7b2f3a$require$uint8ArrayEquals(!key.slice(0, 1), Uint8Array.from([
        4
    ]))) throw $20Lm5(new Error("Cannot unmarshal public key - invalid key format"), "ERR_INVALID_KEY_FORMAT");
    return {
        kty: "EC",
        crv: curve,
        x: $5b03ef99ca7b2f3a$require$uint8ArrayToString(key.slice(1, byteLen + 1), "base64url"),
        y: $5b03ef99ca7b2f3a$require$uint8ArrayToString(key.slice(1 + byteLen), "base64url"),
        ext: true
    };
}
const $5b03ef99ca7b2f3a$var$unmarshalPrivateKey = (curve, key)=>({
        ...$5b03ef99ca7b2f3a$var$unmarshalPublicKey(curve, key.public),
        d: $5b03ef99ca7b2f3a$require$uint8ArrayToString(key.private, "base64url")
    });

});
parcelRequire.register("eHnUK", function(module, exports) {
"use strict";

var $20Lm5 = parcelRequire("20Lm5");
module.exports = function(curveTypes, type) {
    if (!curveTypes.includes(type)) {
        const names = curveTypes.join(" / ");
        throw $20Lm5(new Error(`Unknown curve: ${type}. Must be ${names}`), "ERR_INVALID_CURVE");
    }
};

});




parcelRequire.register("gj0Yu", function(module, exports) {
"use strict";

var $dKibH = parcelRequire("dKibH");

var $e73pV = parcelRequire("e73pV");

var $20Lm5 = parcelRequire("20Lm5");
/**
 * Maps an IPFS hash name to its node-forge equivalent.
 *
 * See https://github.com/multiformats/multihash/blob/master/hashtable.csv
 *
 * @private
 */ const $bdef2d3d85906c2a$var$hashName = {
    sha1: "sha1",
    "sha2-256": "sha256",
    "sha2-512": "sha512"
};
/**
 * Computes the Password-Based Key Derivation Function 2.
 *
 * @param {string} password
 * @param {string} salt
 * @param {number} iterations
 * @param {number} keySize - (in bytes)
 * @param {string} hash - The hash name ('sha1', 'sha2-512, ...)
 * @returns {string} - A new password
 */ function $bdef2d3d85906c2a$var$pbkdf2(password, salt, iterations, keySize, hash) {
    const hasher = $bdef2d3d85906c2a$var$hashName[hash];
    if (!hasher) {
        const types = Object.keys($bdef2d3d85906c2a$var$hashName).join(" / ");
        throw $20Lm5(new Error(`Hash '${hash}' is unknown or not supported. Must be ${types}`), "ERR_UNSUPPORTED_HASH_TYPE");
    }
    const dek = $dKibH(password, salt, iterations, keySize, hasher);
    return $e73pV.encode64(dek);
}
module.exports = $bdef2d3d85906c2a$var$pbkdf2;

});


parcelRequire.register("k0bfI", function(module, exports) {
"use strict";

/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/ (function(global, factory) {
    /* AMD */ if (typeof define === "function" && define.amd) define([
        "protobufjs/minimal"
    ], factory);
    else if (module && module.exports) module.exports = factory((parcelRequire("liRmU")));
})(this, function($protobuf) {
    "use strict";
    // Common aliases
    var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;
    // Exported root namespace
    var $root = $protobuf.roots["libp2p-noise"] || ($protobuf.roots["libp2p-noise"] = {});
    $root.pb = function() {
        /**
         * Namespace pb.
         * @exports pb
         * @namespace
         */ var pb = {};
        pb.NoiseHandshakePayload = function() {
            /**
             * Properties of a NoiseHandshakePayload.
             * @memberof pb
             * @interface INoiseHandshakePayload
             * @property {Uint8Array|null} [identityKey] NoiseHandshakePayload identityKey
             * @property {Uint8Array|null} [identitySig] NoiseHandshakePayload identitySig
             * @property {Uint8Array|null} [data] NoiseHandshakePayload data
             */ /**
             * Constructs a new NoiseHandshakePayload.
             * @memberof pb
             * @classdesc Represents a NoiseHandshakePayload.
             * @implements INoiseHandshakePayload
             * @constructor
             * @param {pb.INoiseHandshakePayload=} [properties] Properties to set
             */ function NoiseHandshakePayload(properties) {
                if (properties) {
                    for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
                }
            }
            /**
             * NoiseHandshakePayload identityKey.
             * @member {Uint8Array} identityKey
             * @memberof pb.NoiseHandshakePayload
             * @instance
             */ NoiseHandshakePayload.prototype.identityKey = $util.newBuffer([]);
            /**
             * NoiseHandshakePayload identitySig.
             * @member {Uint8Array} identitySig
             * @memberof pb.NoiseHandshakePayload
             * @instance
             */ NoiseHandshakePayload.prototype.identitySig = $util.newBuffer([]);
            /**
             * NoiseHandshakePayload data.
             * @member {Uint8Array} data
             * @memberof pb.NoiseHandshakePayload
             * @instance
             */ NoiseHandshakePayload.prototype.data = $util.newBuffer([]);
            /**
             * Creates a new NoiseHandshakePayload instance using the specified properties.
             * @function create
             * @memberof pb.NoiseHandshakePayload
             * @static
             * @param {pb.INoiseHandshakePayload=} [properties] Properties to set
             * @returns {pb.NoiseHandshakePayload} NoiseHandshakePayload instance
             */ NoiseHandshakePayload.create = function create(properties) {
                return new NoiseHandshakePayload(properties);
            };
            /**
             * Encodes the specified NoiseHandshakePayload message. Does not implicitly {@link pb.NoiseHandshakePayload.verify|verify} messages.
             * @function encode
             * @memberof pb.NoiseHandshakePayload
             * @static
             * @param {pb.INoiseHandshakePayload} message NoiseHandshakePayload message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */ NoiseHandshakePayload.encode = function encode(message, writer) {
                if (!writer) writer = $Writer.create();
                if (message.identityKey != null && Object.hasOwnProperty.call(message, "identityKey")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.identityKey);
                if (message.identitySig != null && Object.hasOwnProperty.call(message, "identitySig")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.identitySig);
                if (message.data != null && Object.hasOwnProperty.call(message, "data")) writer.uint32(/* id 3, wireType 2 =*/ 26).bytes(message.data);
                return writer;
            };
            /**
             * Encodes the specified NoiseHandshakePayload message, length delimited. Does not implicitly {@link pb.NoiseHandshakePayload.verify|verify} messages.
             * @function encodeDelimited
             * @memberof pb.NoiseHandshakePayload
             * @static
             * @param {pb.INoiseHandshakePayload} message NoiseHandshakePayload message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */ NoiseHandshakePayload.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };
            /**
             * Decodes a NoiseHandshakePayload message from the specified reader or buffer.
             * @function decode
             * @memberof pb.NoiseHandshakePayload
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {pb.NoiseHandshakePayload} NoiseHandshakePayload
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */ NoiseHandshakePayload.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.pb.NoiseHandshakePayload();
                while(reader.pos < end){
                    var tag = reader.uint32();
                    switch(tag >>> 3){
                        case 1:
                            message.identityKey = reader.bytes();
                            break;
                        case 2:
                            message.identitySig = reader.bytes();
                            break;
                        case 3:
                            message.data = reader.bytes();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                    }
                }
                return message;
            };
            /**
             * Decodes a NoiseHandshakePayload message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof pb.NoiseHandshakePayload
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {pb.NoiseHandshakePayload} NoiseHandshakePayload
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */ NoiseHandshakePayload.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader)) reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };
            /**
             * Verifies a NoiseHandshakePayload message.
             * @function verify
             * @memberof pb.NoiseHandshakePayload
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */ NoiseHandshakePayload.verify = function verify(message) {
                if (typeof message !== "object" || message === null) return "object expected";
                if (message.identityKey != null && message.hasOwnProperty("identityKey")) {
                    if (!(message.identityKey && typeof message.identityKey.length === "number" || $util.isString(message.identityKey))) return "identityKey: buffer expected";
                }
                if (message.identitySig != null && message.hasOwnProperty("identitySig")) {
                    if (!(message.identitySig && typeof message.identitySig.length === "number" || $util.isString(message.identitySig))) return "identitySig: buffer expected";
                }
                if (message.data != null && message.hasOwnProperty("data")) {
                    if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data))) return "data: buffer expected";
                }
                return null;
            };
            /**
             * Creates a NoiseHandshakePayload message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof pb.NoiseHandshakePayload
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {pb.NoiseHandshakePayload} NoiseHandshakePayload
             */ NoiseHandshakePayload.fromObject = function fromObject(object) {
                if (object instanceof $root.pb.NoiseHandshakePayload) return object;
                var message = new $root.pb.NoiseHandshakePayload();
                if (object.identityKey != null) {
                    if (typeof object.identityKey === "string") $util.base64.decode(object.identityKey, message.identityKey = $util.newBuffer($util.base64.length(object.identityKey)), 0);
                    else if (object.identityKey.length) message.identityKey = object.identityKey;
                }
                if (object.identitySig != null) {
                    if (typeof object.identitySig === "string") $util.base64.decode(object.identitySig, message.identitySig = $util.newBuffer($util.base64.length(object.identitySig)), 0);
                    else if (object.identitySig.length) message.identitySig = object.identitySig;
                }
                if (object.data != null) {
                    if (typeof object.data === "string") $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                    else if (object.data.length) message.data = object.data;
                }
                return message;
            };
            /**
             * Creates a plain object from a NoiseHandshakePayload message. Also converts values to other types if specified.
             * @function toObject
             * @memberof pb.NoiseHandshakePayload
             * @static
             * @param {pb.NoiseHandshakePayload} message NoiseHandshakePayload
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */ NoiseHandshakePayload.toObject = function toObject(message, options) {
                if (!options) options = {};
                var object = {};
                if (options.defaults) {
                    if (options.bytes === String) object.identityKey = "";
                    else {
                        object.identityKey = [];
                        if (options.bytes !== Array) object.identityKey = $util.newBuffer(object.identityKey);
                    }
                    if (options.bytes === String) object.identitySig = "";
                    else {
                        object.identitySig = [];
                        if (options.bytes !== Array) object.identitySig = $util.newBuffer(object.identitySig);
                    }
                    if (options.bytes === String) object.data = "";
                    else {
                        object.data = [];
                        if (options.bytes !== Array) object.data = $util.newBuffer(object.data);
                    }
                }
                if (message.identityKey != null && message.hasOwnProperty("identityKey")) object.identityKey = options.bytes === String ? $util.base64.encode(message.identityKey, 0, message.identityKey.length) : options.bytes === Array ? Array.prototype.slice.call(message.identityKey) : message.identityKey;
                if (message.identitySig != null && message.hasOwnProperty("identitySig")) object.identitySig = options.bytes === String ? $util.base64.encode(message.identitySig, 0, message.identitySig.length) : options.bytes === Array ? Array.prototype.slice.call(message.identitySig) : message.identitySig;
                if (message.data != null && message.hasOwnProperty("data")) object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
                return object;
            };
            /**
             * Converts this NoiseHandshakePayload to JSON.
             * @function toJSON
             * @memberof pb.NoiseHandshakePayload
             * @instance
             * @returns {Object.<string,*>} JSON object
             */ NoiseHandshakePayload.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };
            return NoiseHandshakePayload;
        }();
        return pb;
    }();
    return $root;
});

});

parcelRequire.register("ebRvg", function(module, exports) {
"use strict";
/**
 * Returns true if the two passed Uint8Arrays have the same content
 *
 * @param {Uint8Array} a
 * @param {Uint8Array} b
 */ function $a54b9869d52960ca$var$equals(a, b) {
    if (a === b) return true;
    if (a.byteLength !== b.byteLength) return false;
    for(let i = 0; i < a.byteLength; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports = $a54b9869d52960ca$var$equals;

});


parcelRequire.register("4jLQO", function(module, exports) {
"use strict";
var $324e0decdd18a9e4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $324e0decdd18a9e4$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $324e0decdd18a9e4$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $324e0decdd18a9e4$var$__createBinding(result, mod, k);
    }
    $324e0decdd18a9e4$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbstractHandshake = module.exports.MIN_NONCE = void 0;

var $l7tTk = parcelRequire("l7tTk");

const $324e0decdd18a9e4$var$x25519 = $324e0decdd18a9e4$var$__importStar((parcelRequire("f4nIP")));

const $324e0decdd18a9e4$var$SHA256 = $324e0decdd18a9e4$var$__importStar((parcelRequire("7NVV1")));

var $jcBna = parcelRequire("jcBna");

var $2UZxa = parcelRequire("2UZxa");

var $e4tcr = parcelRequire("e4tcr");
module.exports.MIN_NONCE = 0;
class $324e0decdd18a9e4$var$AbstractHandshake {
    encryptWithAd(cs, ad, plaintext) {
        const e = this.encrypt(cs.k, cs.n, ad, plaintext);
        this.setNonce(cs, this.incrementNonce(cs.n));
        return e;
    }
    decryptWithAd(cs, ad, ciphertext) {
        const { plaintext: plaintext, valid: valid } = this.decrypt(cs.k, cs.n, ad, ciphertext);
        this.setNonce(cs, this.incrementNonce(cs.n));
        return {
            plaintext: plaintext,
            valid: valid
        };
    }
    // Cipher state related
    hasKey(cs) {
        return !this.isEmptyKey(cs.k);
    }
    setNonce(cs, nonce) {
        cs.n = nonce;
    }
    createEmptyKey() {
        return $l7tTk.Buffer.alloc(32);
    }
    isEmptyKey(k) {
        const emptyKey = this.createEmptyKey();
        return emptyKey.equals(k);
    }
    incrementNonce(n) {
        return n + 1;
    }
    nonceToBytes(n) {
        const nonce = $l7tTk.Buffer.alloc(12);
        nonce.writeUInt32LE(n, 4);
        return nonce;
    }
    encrypt(k, n, ad, plaintext) {
        const nonce = this.nonceToBytes(n);
        const ctx = new $jcBna.ChaCha20Poly1305(k);
        const encryptedMessage = ctx.seal(nonce, plaintext, ad);
        return $l7tTk.Buffer.from(encryptedMessage.buffer, encryptedMessage.byteOffset, encryptedMessage.length);
    }
    encryptAndHash(ss, plaintext) {
        let ciphertext;
        if (this.hasKey(ss.cs)) ciphertext = this.encryptWithAd(ss.cs, ss.h, plaintext);
        else ciphertext = plaintext;
        this.mixHash(ss, ciphertext);
        return ciphertext;
    }
    decrypt(k, n, ad, ciphertext) {
        const nonce = this.nonceToBytes(n);
        const ctx = new $jcBna.ChaCha20Poly1305(k);
        const encryptedMessage = ctx.open(nonce, ciphertext, ad);
        if (encryptedMessage) return {
            plaintext: $l7tTk.Buffer.from(encryptedMessage.buffer, encryptedMessage.byteOffset, encryptedMessage.length),
            valid: true
        };
        else return {
            plaintext: $l7tTk.Buffer.from(""),
            valid: false
        };
    }
    decryptAndHash(ss, ciphertext) {
        let plaintext;
        let valid = true;
        if (this.hasKey(ss.cs)) ({ plaintext: plaintext, valid: valid } = this.decryptWithAd(ss.cs, ss.h, ciphertext));
        else plaintext = ciphertext;
        this.mixHash(ss, ciphertext);
        return {
            plaintext: plaintext,
            valid: valid
        };
    }
    dh(privateKey, publicKey) {
        try {
            const derivedU8 = $324e0decdd18a9e4$var$x25519.sharedKey(privateKey, publicKey);
            const derived = $l7tTk.Buffer.from(derivedU8.buffer, derivedU8.byteOffset, derivedU8.length);
            const result = $l7tTk.Buffer.alloc(32);
            derived.copy(result);
            return result;
        } catch (e) {
            $e4tcr.logger(e.message);
            return $l7tTk.Buffer.alloc(32);
        }
    }
    mixHash(ss, data) {
        ss.h = this.getHash(ss.h, data);
    }
    getHash(a, b) {
        const hash = $324e0decdd18a9e4$var$SHA256.hash($l7tTk.Buffer.from([
            ...a,
            ...b
        ]));
        return $l7tTk.Buffer.from(hash.buffer, hash.byteOffset, hash.length);
    }
    mixKey(ss, ikm) {
        const [ck, tempK] = $2UZxa.getHkdf(ss.ck, ikm);
        ss.cs = this.initializeKey(tempK);
        ss.ck = ck;
    }
    initializeKey(k) {
        const n = module.exports.MIN_NONCE;
        return {
            k: k,
            n: n
        };
    }
    // Symmetric state related
    initializeSymmetric(protocolName) {
        const protocolNameBytes = $l7tTk.Buffer.from(protocolName, "utf-8");
        const h = this.hashProtocolName(protocolNameBytes);
        const ck = h;
        const key = this.createEmptyKey();
        const cs = this.initializeKey(key);
        return {
            cs: cs,
            ck: ck,
            h: h
        };
    }
    hashProtocolName(protocolName) {
        if (protocolName.length <= 32) {
            const h = $l7tTk.Buffer.alloc(32);
            protocolName.copy(h);
            return h;
        } else return this.getHash(protocolName, $l7tTk.Buffer.alloc(0));
    }
    split(ss) {
        const [tempk1, tempk2] = $2UZxa.getHkdf(ss.ck, $l7tTk.Buffer.alloc(0));
        const cs1 = this.initializeKey(tempk1);
        const cs2 = this.initializeKey(tempk2);
        return {
            cs1: cs1,
            cs2: cs2
        };
    }
    writeMessageRegular(cs, payload) {
        const ciphertext = this.encryptWithAd(cs, $l7tTk.Buffer.alloc(0), payload);
        const ne = this.createEmptyKey();
        const ns = $l7tTk.Buffer.alloc(0);
        return {
            ne: ne,
            ns: ns,
            ciphertext: ciphertext
        };
    }
    readMessageRegular(cs, message) {
        return this.decryptWithAd(cs, $l7tTk.Buffer.alloc(0), message.ciphertext);
    }
}
module.exports.AbstractHandshake = $324e0decdd18a9e4$var$AbstractHandshake;

});
parcelRequire.register("jcBna", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5oUAK = parcelRequire("5oUAK");

var $hT0iR = parcelRequire("hT0iR");

var $eySe8 = parcelRequire("eySe8");

var $gE4xe = parcelRequire("gE4xe");

var $kus2Y = parcelRequire("kus2Y");
module.exports.KEY_LENGTH = 32;
module.exports.NONCE_LENGTH = 12;
module.exports.TAG_LENGTH = 16;
var $dfac20c212b1fbb0$var$ZEROS = new Uint8Array(16);
/**
 * ChaCha20-Poly1305 Authenticated Encryption with Associated Data.
 *
 * Defined in RFC7539.
 */ var $dfac20c212b1fbb0$var$ChaCha20Poly1305 = /** @class */ function() {
    /**
     * Creates a new instance with the given 32-byte key.
     */ function ChaCha20Poly1305(key) {
        this.nonceLength = module.exports.NONCE_LENGTH;
        this.tagLength = module.exports.TAG_LENGTH;
        if (key.length !== module.exports.KEY_LENGTH) throw new Error("ChaCha20Poly1305 needs 32-byte key");
        // Copy key.
        this._key = new Uint8Array(key);
    }
    /**
     * Encrypts and authenticates plaintext, authenticates associated data,
     * and returns sealed ciphertext, which includes authentication tag.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If dst is given (it must be the size of plaintext + the size of tag
     * length) the result will be put into it. Dst and plaintext must not
     * overlap.
     */ ChaCha20Poly1305.prototype.seal = function(nonce, plaintext, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        // We pass full counter, which has 12-byte nonce and 4-byte block counter,
        // and it will get incremented after generating the block, which is
        // exactly what we need: we only use the first 32 bytes of 64-byte
        // ChaCha block and discard the next 32 bytes.
        var authKey = new Uint8Array(32);
        $5oUAK.stream(this._key, counter, authKey, 4);
        // Allocate space for sealed ciphertext.
        var resultLength = plaintext.length + this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Encrypt plaintext.
        $5oUAK.streamXOR(this._key, counter, plaintext, result, 4);
        // Authenticate.
        // XXX: can "simplify" here: pass full result (which is already padded
        // due to zeroes prepared for tag), and ciphertext length instead of
        // subarray of result.
        this._authenticate(result.subarray(result.length - this.tagLength, result.length), authKey, result.subarray(0, result.length - this.tagLength), associatedData);
        // Cleanup.
        $eySe8.wipe(counter);
        return result;
    };
    /**
     * Authenticates sealed ciphertext (which includes authentication tag) and
     * associated data, decrypts ciphertext and returns decrypted plaintext.
     *
     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
     * and nonce.
     *
     * If authentication fails, it returns null.
     *
     * If dst is given (it must be of ciphertext length minus tag length),
     * the result will be put into it. Dst and plaintext must not overlap.
     */ ChaCha20Poly1305.prototype.open = function(nonce, sealed, associatedData, dst) {
        if (nonce.length > 16) throw new Error("ChaCha20Poly1305: incorrect nonce length");
        // Sealed ciphertext should at least contain tag.
        if (sealed.length < this.tagLength) // TODO(dchest): should we throw here instead?
        return null;
        // Allocate space for counter, and set nonce as last bytes of it.
        var counter = new Uint8Array(16);
        counter.set(nonce, counter.length - nonce.length);
        // Generate authentication key by taking first 32-bytes of stream.
        var authKey = new Uint8Array(32);
        $5oUAK.stream(this._key, counter, authKey, 4);
        // Authenticate.
        // XXX: can simplify and avoid allocation: since authenticate()
        // already allocates tag (from Poly1305.digest(), it can return)
        // it instead of copying to calculatedTag. But then in seal()
        // we'll need to copy it.
        var calculatedTag = new Uint8Array(this.tagLength);
        this._authenticate(calculatedTag, authKey, sealed.subarray(0, sealed.length - this.tagLength), associatedData);
        // Constant-time compare tags and return null if they differ.
        if (!$kus2Y.equal(calculatedTag, sealed.subarray(sealed.length - this.tagLength, sealed.length))) return null;
        // Allocate space for decrypted plaintext.
        var resultLength = sealed.length - this.tagLength;
        var result;
        if (dst) {
            if (dst.length !== resultLength) throw new Error("ChaCha20Poly1305: incorrect destination length");
            result = dst;
        } else result = new Uint8Array(resultLength);
        // Decrypt.
        $5oUAK.streamXOR(this._key, counter, sealed.subarray(0, sealed.length - this.tagLength), result, 4);
        // Cleanup.
        $eySe8.wipe(counter);
        return result;
    };
    ChaCha20Poly1305.prototype.clean = function() {
        $eySe8.wipe(this._key);
        return this;
    };
    ChaCha20Poly1305.prototype._authenticate = function(tagOut, authKey, ciphertext, associatedData) {
        // Initialize Poly1305 with authKey.
        var h = new $hT0iR.Poly1305(authKey);
        // Authenticate padded associated data.
        if (associatedData) {
            h.update(associatedData);
            if (associatedData.length % 16 > 0) h.update($dfac20c212b1fbb0$var$ZEROS.subarray(associatedData.length % 16));
        }
        // Authenticate padded ciphertext.
        h.update(ciphertext);
        if (ciphertext.length % 16 > 0) h.update($dfac20c212b1fbb0$var$ZEROS.subarray(ciphertext.length % 16));
        // Authenticate length of associated data.
        // XXX: can avoid allocation here?
        var length = new Uint8Array(8);
        if (associatedData) $gE4xe.writeUint64LE(associatedData.length, length);
        h.update(length);
        // Authenticate length of ciphertext.
        $gE4xe.writeUint64LE(ciphertext.length, length);
        h.update(length);
        // Get tag and copy it into tagOut.
        var tag = h.digest();
        for(var i = 0; i < tag.length; i++)tagOut[i] = tag[i];
        // Cleanup.
        h.clean();
        $eySe8.wipe(tag);
        $eySe8.wipe(length);
    };
    return ChaCha20Poly1305;
}();
module.exports.ChaCha20Poly1305 = $dfac20c212b1fbb0$var$ChaCha20Poly1305;

});
parcelRequire.register("5oUAK", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gE4xe = parcelRequire("gE4xe");

var $eySe8 = parcelRequire("eySe8");
// Number of ChaCha rounds (ChaCha20).
var $3eeb1793db9fe636$var$ROUNDS = 20;
// Applies the ChaCha core function to 16-byte input,
// 32-byte key key, and puts the result into 64-byte array out.
function $3eeb1793db9fe636$var$core(out, input, key) {
    var j0 = 0x61707865; // "expa"  -- ChaCha's "sigma" constant
    var j1 = 0x3320646E; // "nd 3"     for 32-byte keys
    var j2 = 0x79622D32; // "2-by"
    var j3 = 0x6B206574; // "te k"
    var j4 = key[3] << 24 | key[2] << 16 | key[1] << 8 | key[0];
    var j5 = key[7] << 24 | key[6] << 16 | key[5] << 8 | key[4];
    var j6 = key[11] << 24 | key[10] << 16 | key[9] << 8 | key[8];
    var j7 = key[15] << 24 | key[14] << 16 | key[13] << 8 | key[12];
    var j8 = key[19] << 24 | key[18] << 16 | key[17] << 8 | key[16];
    var j9 = key[23] << 24 | key[22] << 16 | key[21] << 8 | key[20];
    var j10 = key[27] << 24 | key[26] << 16 | key[25] << 8 | key[24];
    var j11 = key[31] << 24 | key[30] << 16 | key[29] << 8 | key[28];
    var j12 = input[3] << 24 | input[2] << 16 | input[1] << 8 | input[0];
    var j13 = input[7] << 24 | input[6] << 16 | input[5] << 8 | input[4];
    var j14 = input[11] << 24 | input[10] << 16 | input[9] << 8 | input[8];
    var j15 = input[15] << 24 | input[14] << 16 | input[13] << 8 | input[12];
    var x0 = j0;
    var x1 = j1;
    var x2 = j2;
    var x3 = j3;
    var x4 = j4;
    var x5 = j5;
    var x6 = j6;
    var x7 = j7;
    var x8 = j8;
    var x9 = j9;
    var x10 = j10;
    var x11 = j11;
    var x12 = j12;
    var x13 = j13;
    var x14 = j14;
    var x15 = j15;
    for(var i = 0; i < $3eeb1793db9fe636$var$ROUNDS; i += 2){
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 16 | x12 << 16;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 20 | x4 << 12;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 16 | x13 << 16;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 20 | x5 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 16 | x14 << 16;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 20 | x6 << 12;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 16 | x15 << 16;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 20 | x7 << 12;
        x2 = x2 + x6 | 0;
        x14 ^= x2;
        x14 = x14 >>> 24 | x14 << 8;
        x10 = x10 + x14 | 0;
        x6 ^= x10;
        x6 = x6 >>> 25 | x6 << 7;
        x3 = x3 + x7 | 0;
        x15 ^= x3;
        x15 = x15 >>> 24 | x15 << 8;
        x11 = x11 + x15 | 0;
        x7 ^= x11;
        x7 = x7 >>> 25 | x7 << 7;
        x1 = x1 + x5 | 0;
        x13 ^= x1;
        x13 = x13 >>> 24 | x13 << 8;
        x9 = x9 + x13 | 0;
        x5 ^= x9;
        x5 = x5 >>> 25 | x5 << 7;
        x0 = x0 + x4 | 0;
        x12 ^= x0;
        x12 = x12 >>> 24 | x12 << 8;
        x8 = x8 + x12 | 0;
        x4 ^= x8;
        x4 = x4 >>> 25 | x4 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 16 | x15 << 16;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 20 | x5 << 12;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 16 | x12 << 16;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 20 | x6 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 16 | x13 << 16;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 20 | x7 << 12;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 16 | x14 << 16;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 20 | x4 << 12;
        x2 = x2 + x7 | 0;
        x13 ^= x2;
        x13 = x13 >>> 24 | x13 << 8;
        x8 = x8 + x13 | 0;
        x7 ^= x8;
        x7 = x7 >>> 25 | x7 << 7;
        x3 = x3 + x4 | 0;
        x14 ^= x3;
        x14 = x14 >>> 24 | x14 << 8;
        x9 = x9 + x14 | 0;
        x4 ^= x9;
        x4 = x4 >>> 25 | x4 << 7;
        x1 = x1 + x6 | 0;
        x12 ^= x1;
        x12 = x12 >>> 24 | x12 << 8;
        x11 = x11 + x12 | 0;
        x6 ^= x11;
        x6 = x6 >>> 25 | x6 << 7;
        x0 = x0 + x5 | 0;
        x15 ^= x0;
        x15 = x15 >>> 24 | x15 << 8;
        x10 = x10 + x15 | 0;
        x5 ^= x10;
        x5 = x5 >>> 25 | x5 << 7;
    }
    $gE4xe.writeUint32LE(x0 + j0 | 0, out, 0);
    $gE4xe.writeUint32LE(x1 + j1 | 0, out, 4);
    $gE4xe.writeUint32LE(x2 + j2 | 0, out, 8);
    $gE4xe.writeUint32LE(x3 + j3 | 0, out, 12);
    $gE4xe.writeUint32LE(x4 + j4 | 0, out, 16);
    $gE4xe.writeUint32LE(x5 + j5 | 0, out, 20);
    $gE4xe.writeUint32LE(x6 + j6 | 0, out, 24);
    $gE4xe.writeUint32LE(x7 + j7 | 0, out, 28);
    $gE4xe.writeUint32LE(x8 + j8 | 0, out, 32);
    $gE4xe.writeUint32LE(x9 + j9 | 0, out, 36);
    $gE4xe.writeUint32LE(x10 + j10 | 0, out, 40);
    $gE4xe.writeUint32LE(x11 + j11 | 0, out, 44);
    $gE4xe.writeUint32LE(x12 + j12 | 0, out, 48);
    $gE4xe.writeUint32LE(x13 + j13 | 0, out, 52);
    $gE4xe.writeUint32LE(x14 + j14 | 0, out, 56);
    $gE4xe.writeUint32LE(x15 + j15 | 0, out, 60);
}
/**
 * Encrypt src with ChaCha20 stream generated for the given 32-byte key and
 * 8-byte (as in original implementation) or 12-byte (as in RFC7539) nonce and
 * write the result into dst and return it.
 *
 * dst and src may be the same, but otherwise must not overlap.
 *
 * If nonce is 12 bytes, users should not encrypt more than 256 GiB with the
 * same key and nonce, otherwise the stream will repeat. The function will
 * throw error if counter overflows to prevent this.
 *
 * If nonce is 8 bytes, the output is practically unlimited (2^70 bytes, which
 * is more than a million petabytes). However, it is not recommended to
 * generate 8-byte nonces randomly, as the chance of collision is high.
 *
 * Never use the same key and nonce to encrypt more than one message.
 *
 * If nonceInplaceCounterLength is not 0, the nonce is assumed to be a 16-byte
 * array with stream counter in first nonceInplaceCounterLength bytes and nonce
 * in the last remaining bytes. The counter will be incremented inplace for
 * each ChaCha block. This is useful if you need to encrypt one stream of data
 * in chunks.
 */ function $3eeb1793db9fe636$var$streamXOR(key, nonce, src, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    // We only support 256-bit keys.
    if (key.length !== 32) throw new Error("ChaCha: key size must be 32 bytes");
    if (dst.length < src.length) throw new Error("ChaCha: destination is shorter than source");
    var nc;
    var counterLength;
    if (nonceInplaceCounterLength === 0) {
        if (nonce.length !== 8 && nonce.length !== 12) throw new Error("ChaCha nonce must be 8 or 12 bytes");
        nc = new Uint8Array(16);
        // First counterLength bytes of nc are counter, starting with zero.
        counterLength = nc.length - nonce.length;
        // Last bytes of nc after counterLength are nonce, set them.
        nc.set(nonce, counterLength);
    } else {
        if (nonce.length !== 16) throw new Error("ChaCha nonce with counter must be 16 bytes");
        // This will update passed nonce with counter inplace.
        nc = nonce;
        counterLength = nonceInplaceCounterLength;
    }
    // Allocate temporary space for ChaCha block.
    var block = new Uint8Array(64);
    for(var i = 0; i < src.length; i += 64){
        // Generate a block.
        $3eeb1793db9fe636$var$core(block, nc, key);
        // XOR block bytes with src into dst.
        for(var j = i; j < i + 64 && j < src.length; j++)dst[j] = src[j] ^ block[j - i];
        // Increment counter.
        $3eeb1793db9fe636$var$incrementCounter(nc, 0, counterLength);
    }
    // Cleanup temporary space.
    $eySe8.wipe(block);
    if (nonceInplaceCounterLength === 0) // Cleanup counter.
    $eySe8.wipe(nc);
    return dst;
}
module.exports.streamXOR = $3eeb1793db9fe636$var$streamXOR;
/**
 * Generate ChaCha20 stream for the given 32-byte key and 8-byte or 12-byte
 * nonce and write it into dst and return it.
 *
 * Never use the same key and nonce to generate more than one stream.
 *
 * If nonceInplaceCounterLength is not 0, it behaves the same with respect to
 * the nonce as described in the streamXOR documentation.
 *
 * stream is like streamXOR with all-zero src.
 */ function $3eeb1793db9fe636$var$stream(key, nonce, dst, nonceInplaceCounterLength) {
    if (nonceInplaceCounterLength === void 0) nonceInplaceCounterLength = 0;
    $eySe8.wipe(dst);
    return $3eeb1793db9fe636$var$streamXOR(key, nonce, dst, dst, nonceInplaceCounterLength);
}
module.exports.stream = $3eeb1793db9fe636$var$stream;
function $3eeb1793db9fe636$var$incrementCounter(counter, pos, len) {
    var carry = 1;
    while(len--){
        carry = carry + (counter[pos] & 0xff) | 0;
        counter[pos] = carry & 0xff;
        carry >>>= 8;
        pos++;
    }
    if (carry > 0) throw new Error("ChaCha: counter overflow");
}

});

parcelRequire.register("hT0iR", function(module, exports) {
"use strict";
// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kus2Y = parcelRequire("kus2Y");

var $eySe8 = parcelRequire("eySe8");
module.exports.DIGEST_LENGTH = 16;
// Port of Andrew Moon's Poly1305-donna-16. Public domain.
// https://github.com/floodyberry/poly1305-donna
/**
 * Poly1305 computes 16-byte authenticator of message using
 * a one-time 32-byte key.
 *
 * Important: key should be used for only one message,
 * it should never repeat.
 */ var $d057cef36dfffdc3$var$Poly1305 = /** @class */ function() {
    function Poly1305(key) {
        this.digestLength = module.exports.DIGEST_LENGTH;
        this._buffer = new Uint8Array(16);
        this._r = new Uint16Array(10);
        this._h = new Uint16Array(10);
        this._pad = new Uint16Array(8);
        this._leftover = 0;
        this._fin = 0;
        this._finished = false;
        var t0 = key[0] | key[1] << 8;
        this._r[0] = t0 & 0x1fff;
        var t1 = key[2] | key[3] << 8;
        this._r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        var t2 = key[4] | key[5] << 8;
        this._r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        var t3 = key[6] | key[7] << 8;
        this._r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        var t4 = key[8] | key[9] << 8;
        this._r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this._r[5] = t4 >>> 1 & 0x1ffe;
        var t5 = key[10] | key[11] << 8;
        this._r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        var t6 = key[12] | key[13] << 8;
        this._r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        var t7 = key[14] | key[15] << 8;
        this._r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this._r[9] = t7 >>> 5 & 0x007f;
        this._pad[0] = key[16] | key[17] << 8;
        this._pad[1] = key[18] | key[19] << 8;
        this._pad[2] = key[20] | key[21] << 8;
        this._pad[3] = key[22] | key[23] << 8;
        this._pad[4] = key[24] | key[25] << 8;
        this._pad[5] = key[26] | key[27] << 8;
        this._pad[6] = key[28] | key[29] << 8;
        this._pad[7] = key[30] | key[31] << 8;
    }
    Poly1305.prototype._blocks = function(m, mpos, bytes) {
        var hibit = this._fin ? 0 : 2048;
        var h0 = this._h[0], h1 = this._h[1], h2 = this._h[2], h3 = this._h[3], h4 = this._h[4], h5 = this._h[5], h6 = this._h[6], h7 = this._h[7], h8 = this._h[8], h9 = this._h[9];
        var r0 = this._r[0], r1 = this._r[1], r2 = this._r[2], r3 = this._r[3], r4 = this._r[4], r5 = this._r[5], r6 = this._r[6], r7 = this._r[7], r8 = this._r[8], r9 = this._r[9];
        while(bytes >= 16){
            var t0 = m[mpos + 0] | m[mpos + 1] << 8;
            h0 += t0 & 0x1fff;
            var t1 = m[mpos + 2] | m[mpos + 3] << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            var t2 = m[mpos + 4] | m[mpos + 5] << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            var t3 = m[mpos + 6] | m[mpos + 7] << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            var t4 = m[mpos + 8] | m[mpos + 9] << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            var t5 = m[mpos + 10] | m[mpos + 11] << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            var t6 = m[mpos + 12] | m[mpos + 13] << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            var t7 = m[mpos + 14] | m[mpos + 15] << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            var c = 0;
            var d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            var d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            var d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            var d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            var d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            var d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            var d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            var d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            var d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            var d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this._h[0] = h0;
        this._h[1] = h1;
        this._h[2] = h2;
        this._h[3] = h3;
        this._h[4] = h4;
        this._h[5] = h5;
        this._h[6] = h6;
        this._h[7] = h7;
        this._h[8] = h8;
        this._h[9] = h9;
    };
    Poly1305.prototype.finish = function(mac, macpos) {
        if (macpos === void 0) macpos = 0;
        var g = new Uint16Array(10);
        var c;
        var mask;
        var f;
        var i;
        if (this._leftover) {
            i = this._leftover;
            this._buffer[i++] = 1;
            for(; i < 16; i++)this._buffer[i] = 0;
            this._fin = 1;
            this._blocks(this._buffer, 0, 16);
        }
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this._h[i] += c;
            c = this._h[i] >>> 13;
            this._h[i] &= 0x1fff;
        }
        this._h[0] += c * 5;
        c = this._h[0] >>> 13;
        this._h[0] &= 0x1fff;
        this._h[1] += c;
        c = this._h[1] >>> 13;
        this._h[1] &= 0x1fff;
        this._h[2] += c;
        g[0] = this._h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this._h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this._h[i] = this._h[i] & mask | g[i];
        this._h[0] = (this._h[0] | this._h[1] << 13) & 0xffff;
        this._h[1] = (this._h[1] >>> 3 | this._h[2] << 10) & 0xffff;
        this._h[2] = (this._h[2] >>> 6 | this._h[3] << 7) & 0xffff;
        this._h[3] = (this._h[3] >>> 9 | this._h[4] << 4) & 0xffff;
        this._h[4] = (this._h[4] >>> 12 | this._h[5] << 1 | this._h[6] << 14) & 0xffff;
        this._h[5] = (this._h[6] >>> 2 | this._h[7] << 11) & 0xffff;
        this._h[6] = (this._h[7] >>> 5 | this._h[8] << 8) & 0xffff;
        this._h[7] = (this._h[8] >>> 8 | this._h[9] << 5) & 0xffff;
        f = this._h[0] + this._pad[0];
        this._h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this._h[i] + this._pad[i] | 0) + (f >>> 16) | 0;
            this._h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this._h[0] >>> 0;
        mac[macpos + 1] = this._h[0] >>> 8;
        mac[macpos + 2] = this._h[1] >>> 0;
        mac[macpos + 3] = this._h[1] >>> 8;
        mac[macpos + 4] = this._h[2] >>> 0;
        mac[macpos + 5] = this._h[2] >>> 8;
        mac[macpos + 6] = this._h[3] >>> 0;
        mac[macpos + 7] = this._h[3] >>> 8;
        mac[macpos + 8] = this._h[4] >>> 0;
        mac[macpos + 9] = this._h[4] >>> 8;
        mac[macpos + 10] = this._h[5] >>> 0;
        mac[macpos + 11] = this._h[5] >>> 8;
        mac[macpos + 12] = this._h[6] >>> 0;
        mac[macpos + 13] = this._h[6] >>> 8;
        mac[macpos + 14] = this._h[7] >>> 0;
        mac[macpos + 15] = this._h[7] >>> 8;
        this._finished = true;
        return this;
    };
    Poly1305.prototype.update = function(m) {
        var mpos = 0;
        var bytes = m.length;
        var want;
        if (this._leftover) {
            want = 16 - this._leftover;
            if (want > bytes) want = bytes;
            for(var i = 0; i < want; i++)this._buffer[this._leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this._leftover += want;
            if (this._leftover < 16) return this;
            this._blocks(this._buffer, 0, 16);
            this._leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this._blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(var i = 0; i < bytes; i++)this._buffer[this._leftover + i] = m[mpos + i];
            this._leftover += bytes;
        }
        return this;
    };
    Poly1305.prototype.digest = function() {
        // TODO(dchest): it behaves differently than other hashes/HMAC,
        // because it throws when finished — others just return saved result.
        if (this._finished) throw new Error("Poly1305 was finished");
        var mac = new Uint8Array(16);
        this.finish(mac);
        return mac;
    };
    Poly1305.prototype.clean = function() {
        $eySe8.wipe(this._buffer);
        $eySe8.wipe(this._r);
        $eySe8.wipe(this._h);
        $eySe8.wipe(this._pad);
        this._leftover = 0;
        this._fin = 0;
        this._finished = true; // mark as finished even if not
        return this;
    };
    return Poly1305;
}();
module.exports.Poly1305 = $d057cef36dfffdc3$var$Poly1305;
/**
 * Returns 16-byte authenticator of data using a one-time 32-byte key.
 *
 * Important: key should be used for only one message, it should never repeat.
 */ function $d057cef36dfffdc3$var$oneTimeAuth(key, data) {
    var h = new $d057cef36dfffdc3$var$Poly1305(key);
    h.update(data);
    var digest = h.digest();
    h.clean();
    return digest;
}
module.exports.oneTimeAuth = $d057cef36dfffdc3$var$oneTimeAuth;
/**
 * Returns true if two authenticators are 16-byte long and equal.
 * Uses contant-time comparison to avoid leaking timing information.
 */ function $d057cef36dfffdc3$var$equal(a, b) {
    if (a.length !== module.exports.DIGEST_LENGTH || b.length !== module.exports.DIGEST_LENGTH) return false;
    return $kus2Y.equal(a, b);
}
module.exports.equal = $d057cef36dfffdc3$var$equal;

});


parcelRequire.register("e4tcr", function(module, exports) {
"use strict";
var $a3e816dfb2e431e3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.logCipherState = module.exports.logRemoteEphemeralKey = module.exports.logRemoteStaticKey = module.exports.logLocalEphemeralKeys = module.exports.logLocalStaticKeys = module.exports.logger = void 0;

const $a3e816dfb2e431e3$var$debug_1 = $a3e816dfb2e431e3$var$__importDefault((parcelRequire("jjmHV")));

var $iuPHX = parcelRequire("iuPHX");
module.exports.logger = $a3e816dfb2e431e3$var$debug_1.default("libp2p:noise");
let $a3e816dfb2e431e3$var$keyLogger;
if ($iuPHX.DUMP_SESSION_KEYS) $a3e816dfb2e431e3$var$keyLogger = module.exports.logger;
else $a3e816dfb2e431e3$var$keyLogger = ()=>{};
function $a3e816dfb2e431e3$var$logLocalStaticKeys(s) {
    $a3e816dfb2e431e3$var$keyLogger(`LOCAL_STATIC_PUBLIC_KEY ${s.publicKey.toString("hex")}`);
    $a3e816dfb2e431e3$var$keyLogger(`LOCAL_STATIC_PRIVATE_KEY ${s.privateKey.toString("hex")}`);
}
module.exports.logLocalStaticKeys = $a3e816dfb2e431e3$var$logLocalStaticKeys;
function $a3e816dfb2e431e3$var$logLocalEphemeralKeys(e) {
    if (e) {
        $a3e816dfb2e431e3$var$keyLogger(`LOCAL_PUBLIC_EPHEMERAL_KEY ${e.publicKey.toString("hex")}`);
        $a3e816dfb2e431e3$var$keyLogger(`LOCAL_PRIVATE_EPHEMERAL_KEY ${e.privateKey.toString("hex")}`);
    } else $a3e816dfb2e431e3$var$keyLogger("Missing local ephemeral keys.");
}
module.exports.logLocalEphemeralKeys = $a3e816dfb2e431e3$var$logLocalEphemeralKeys;
function $a3e816dfb2e431e3$var$logRemoteStaticKey(rs) {
    $a3e816dfb2e431e3$var$keyLogger(`REMOTE_STATIC_PUBLIC_KEY ${rs.toString("hex")}`);
}
module.exports.logRemoteStaticKey = $a3e816dfb2e431e3$var$logRemoteStaticKey;
function $a3e816dfb2e431e3$var$logRemoteEphemeralKey(re) {
    $a3e816dfb2e431e3$var$keyLogger(`REMOTE_EPHEMERAL_PUBLIC_KEY ${re.toString("hex")}`);
}
module.exports.logRemoteEphemeralKey = $a3e816dfb2e431e3$var$logRemoteEphemeralKey;
function $a3e816dfb2e431e3$var$logCipherState(session) {
    if (session.cs1 && session.cs2) {
        $a3e816dfb2e431e3$var$keyLogger(`CIPHER_STATE_1 ${session.cs1.n} ${session.cs1.k.toString("hex")}`);
        $a3e816dfb2e431e3$var$keyLogger(`CIPHER_STATE_2 ${session.cs2.n} ${session.cs2.k.toString("hex")}`);
    } else $a3e816dfb2e431e3$var$keyLogger("Missing cipher state.");
}
module.exports.logCipherState = $a3e816dfb2e431e3$var$logCipherState;

});
parcelRequire.register("iuPHX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DUMP_SESSION_KEYS = module.exports.NOISE_MSG_MAX_LENGTH_BYTES_WITHOUT_TAG = module.exports.NOISE_MSG_MAX_LENGTH_BYTES = void 0;
module.exports.NOISE_MSG_MAX_LENGTH_BYTES = 65535;
module.exports.NOISE_MSG_MAX_LENGTH_BYTES_WITHOUT_TAG = module.exports.NOISE_MSG_MAX_LENGTH_BYTES - 16;
module.exports.DUMP_SESSION_KEYS = undefined;

});




parcelRequire.register("evFdC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decode2 = module.exports.decode1 = module.exports.decode0 = module.exports.encode2 = module.exports.encode1 = module.exports.encode0 = module.exports.uint16BEDecode = module.exports.uint16BEEncode = void 0;

var $l7tTk = parcelRequire("l7tTk");
const $a903ef1901f03410$var$uint16BEEncode = (value, target, offset)=>{
    target = target || $l7tTk.Buffer.allocUnsafe(2);
    target.writeUInt16BE(value, offset);
    return target;
};
module.exports.uint16BEEncode = $a903ef1901f03410$var$uint16BEEncode;
module.exports.uint16BEEncode.bytes = 2;
const $a903ef1901f03410$var$uint16BEDecode = (data)=>{
    if (data.length < 2) throw RangeError("Could not decode int16BE");
    return data.readUInt16BE(0);
};
module.exports.uint16BEDecode = $a903ef1901f03410$var$uint16BEDecode;
module.exports.uint16BEDecode.bytes = 2;
// Note: IK and XX encoder usage is opposite (XX uses in stages encode0 where IK uses encode1)
function $a903ef1901f03410$var$encode0(message) {
    return $l7tTk.Buffer.concat([
        message.ne,
        message.ciphertext
    ]);
}
module.exports.encode0 = $a903ef1901f03410$var$encode0;
function $a903ef1901f03410$var$encode1(message) {
    return $l7tTk.Buffer.concat([
        message.ne,
        message.ns,
        message.ciphertext
    ]);
}
module.exports.encode1 = $a903ef1901f03410$var$encode1;
function $a903ef1901f03410$var$encode2(message) {
    return $l7tTk.Buffer.concat([
        message.ns,
        message.ciphertext
    ]);
}
module.exports.encode2 = $a903ef1901f03410$var$encode2;
function $a903ef1901f03410$var$decode0(input) {
    if (input.length < 32) throw new Error("Cannot decode stage 0 MessageBuffer: length less than 32 bytes.");
    return {
        ne: input.slice(0, 32),
        ciphertext: input.slice(32, input.length),
        ns: $l7tTk.Buffer.alloc(0)
    };
}
module.exports.decode0 = $a903ef1901f03410$var$decode0;
function $a903ef1901f03410$var$decode1(input) {
    if (input.length < 80) throw new Error("Cannot decode stage 1 MessageBuffer: length less than 80 bytes.");
    return {
        ne: input.slice(0, 32),
        ns: input.slice(32, 80),
        ciphertext: input.slice(80, input.length)
    };
}
module.exports.decode1 = $a903ef1901f03410$var$decode1;
function $a903ef1901f03410$var$decode2(input) {
    if (input.length < 48) throw new Error("Cannot decode stage 2 MessageBuffer: length less than 48 bytes.");
    return {
        ne: $l7tTk.Buffer.alloc(0),
        ns: input.slice(0, 48),
        ciphertext: input.slice(48, input.length)
    };
}
module.exports.decode2 = $a903ef1901f03410$var$decode2;

});


parcelRequire.register("4JPON", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IKHandshake = void 0;

var $lcBzT = parcelRequire("lcBzT");

var $l7tTk = parcelRequire("l7tTk");

var $evFdC = parcelRequire("evFdC");

var $2UZxa = parcelRequire("2UZxa");

var $daIRS = parcelRequire("daIRS");

var $e4tcr = parcelRequire("e4tcr");
class $37338f6fd866d466$var$IKHandshake {
    constructor(isInitiator, payload, prologue, staticKeypair, connection, remoteStaticKey, remotePeer, handshake){
        this.isInitiator = isInitiator;
        this.payload = $l7tTk.Buffer.from(payload);
        this.prologue = prologue;
        this.staticKeypair = staticKeypair;
        this.connection = connection;
        if (remotePeer) this.remotePeer = remotePeer;
        this.ik = handshake !== null && handshake !== void 0 ? handshake : new $lcBzT.IK();
        this.session = this.ik.initSession(this.isInitiator, this.prologue, this.staticKeypair, remoteStaticKey);
        this.remoteEarlyData = $l7tTk.Buffer.alloc(0);
    }
    async stage0() {
        $e4tcr.logLocalStaticKeys(this.session.hs.s);
        $e4tcr.logRemoteStaticKey(this.session.hs.rs);
        if (this.isInitiator) {
            $e4tcr.logger("IK Stage 0 - Initiator sending message...");
            const messageBuffer = this.ik.sendMessage(this.session, this.payload);
            this.connection.writeLP($evFdC.encode1(messageBuffer));
            $e4tcr.logger("IK Stage 0 - Initiator sent message.");
            $e4tcr.logLocalEphemeralKeys(this.session.hs.e);
        } else {
            $e4tcr.logger("IK Stage 0 - Responder receiving message...");
            const receivedMsg = await this.connection.readLP();
            try {
                const receivedMessageBuffer = $evFdC.decode1(receivedMsg.slice());
                const { plaintext: plaintext, valid: valid } = this.ik.recvMessage(this.session, receivedMessageBuffer);
                if (!valid) throw new Error("ik handshake stage 0 decryption validation fail");
                $e4tcr.logger("IK Stage 0 - Responder got message, going to verify payload.");
                const decodedPayload = await $2UZxa.decodePayload(plaintext);
                this.remotePeer = this.remotePeer || await $2UZxa.getPeerIdFromPayload(decodedPayload);
                await $2UZxa.verifySignedPayload(this.session.hs.rs, decodedPayload, this.remotePeer);
                this.setRemoteEarlyData(decodedPayload.data);
                $e4tcr.logger("IK Stage 0 - Responder successfully verified payload!");
                $e4tcr.logRemoteEphemeralKey(this.session.hs.re);
            } catch (e) {
                const err = e;
                $e4tcr.logger("Responder breaking up with IK handshake in stage 0.");
                throw new $daIRS.FailedIKError(receivedMsg, `Error occurred while verifying initiator's signed payload: ${err.message}`);
            }
        }
    }
    async stage1() {
        if (this.isInitiator) {
            $e4tcr.logger("IK Stage 1 - Initiator receiving message...");
            const receivedMsg = (await this.connection.readLP()).slice();
            const receivedMessageBuffer = $evFdC.decode0($l7tTk.Buffer.from(receivedMsg));
            const { plaintext: plaintext, valid: valid } = this.ik.recvMessage(this.session, receivedMessageBuffer);
            $e4tcr.logger("IK Stage 1 - Initiator got message, going to verify payload.");
            try {
                if (!valid) throw new Error("ik stage 1 decryption validation fail");
                const decodedPayload = await $2UZxa.decodePayload(plaintext);
                this.remotePeer = this.remotePeer || await $2UZxa.getPeerIdFromPayload(decodedPayload);
                await $2UZxa.verifySignedPayload(receivedMessageBuffer.ns.slice(0, 32), decodedPayload, this.remotePeer);
                this.setRemoteEarlyData(decodedPayload.data);
                $e4tcr.logger("IK Stage 1 - Initiator successfully verified payload!");
                $e4tcr.logRemoteEphemeralKey(this.session.hs.re);
            } catch (e) {
                const err = e;
                $e4tcr.logger("Initiator breaking up with IK handshake in stage 1.");
                throw new $daIRS.FailedIKError(receivedMsg, `Error occurred while verifying responder's signed payload: ${err.message}`);
            }
        } else {
            $e4tcr.logger("IK Stage 1 - Responder sending message...");
            const messageBuffer = this.ik.sendMessage(this.session, this.payload);
            this.connection.writeLP($evFdC.encode0(messageBuffer));
            $e4tcr.logger("IK Stage 1 - Responder sent message...");
            $e4tcr.logLocalEphemeralKeys(this.session.hs.e);
        }
        $e4tcr.logCipherState(this.session);
    }
    decrypt(ciphertext, session) {
        const cs = this.getCS(session, false);
        return this.ik.decryptWithAd(cs, $l7tTk.Buffer.alloc(0), ciphertext);
    }
    encrypt(plaintext, session) {
        const cs = this.getCS(session);
        return this.ik.encryptWithAd(cs, $l7tTk.Buffer.alloc(0), plaintext);
    }
    getLocalEphemeralKeys() {
        if (!this.session.hs.e) throw new Error("Ephemeral keys do not exist.");
        return this.session.hs.e;
    }
    getCS(session, encryption = true) {
        if (!session.cs1 || !session.cs2) throw new Error("Handshake not completed properly, cipher state does not exist.");
        if (this.isInitiator) return encryption ? session.cs1 : session.cs2;
        else return encryption ? session.cs2 : session.cs1;
    }
    setRemoteEarlyData(data) {
        if (data) this.remoteEarlyData = $l7tTk.Buffer.from(data.buffer, data.byteOffset, data.length);
    }
}
module.exports.IKHandshake = $37338f6fd866d466$var$IKHandshake;

});
parcelRequire.register("lcBzT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IK = void 0;

var $l7tTk = parcelRequire("l7tTk");

var $2UZxa = parcelRequire("2UZxa");

var $4jLQO = parcelRequire("4jLQO");
class $f6f7de2221381366$var$IK extends $4jLQO.AbstractHandshake {
    initSession(initiator, prologue, s, rs) {
        const psk = this.createEmptyKey();
        let hs;
        if (initiator) hs = this.initializeInitiator(prologue, s, rs, psk);
        else hs = this.initializeResponder(prologue, s, rs, psk);
        return {
            hs: hs,
            i: initiator,
            mc: 0
        };
    }
    sendMessage(session, message) {
        let messageBuffer;
        if (session.mc === 0) messageBuffer = this.writeMessageA(session.hs, message);
        else if (session.mc === 1) {
            const { messageBuffer: mb, h: h, cs1: cs1, cs2: cs2 } = this.writeMessageB(session.hs, message);
            messageBuffer = mb;
            session.h = h;
            session.cs1 = cs1;
            session.cs2 = cs2;
        } else if (session.mc > 1) {
            if (session.i) {
                if (!session.cs1) throw new Error("CS1 (cipher state) is not defined");
                messageBuffer = this.writeMessageRegular(session.cs1, message);
            } else {
                if (!session.cs2) throw new Error("CS2 (cipher state) is not defined");
                messageBuffer = this.writeMessageRegular(session.cs2, message);
            }
        } else throw new Error("Session invalid.");
        session.mc++;
        return messageBuffer;
    }
    recvMessage(session, message) {
        let plaintext = $l7tTk.Buffer.alloc(0);
        let valid = false;
        if (session.mc === 0) ({ plaintext: plaintext, valid: valid } = this.readMessageA(session.hs, message));
        if (session.mc === 1) {
            const { plaintext: pt, valid: v, h: h, cs1: cs1, cs2: cs2 } = this.readMessageB(session.hs, message);
            plaintext = pt;
            valid = v;
            session.h = h;
            session.cs1 = cs1;
            session.cs2 = cs2;
        }
        session.mc++;
        return {
            plaintext: plaintext,
            valid: valid
        };
    }
    writeMessageA(hs, payload) {
        hs.e = $2UZxa.generateKeypair();
        const ne = hs.e.publicKey;
        this.mixHash(hs.ss, ne);
        this.mixKey(hs.ss, this.dh(hs.e.privateKey, hs.rs));
        const spk = $l7tTk.Buffer.from(hs.s.publicKey);
        const ns = this.encryptAndHash(hs.ss, spk);
        this.mixKey(hs.ss, this.dh(hs.s.privateKey, hs.rs));
        const ciphertext = this.encryptAndHash(hs.ss, payload);
        return {
            ne: ne,
            ns: ns,
            ciphertext: ciphertext
        };
    }
    writeMessageB(hs, payload) {
        hs.e = $2UZxa.generateKeypair();
        const ne = hs.e.publicKey;
        this.mixHash(hs.ss, ne);
        this.mixKey(hs.ss, this.dh(hs.e.privateKey, hs.re));
        this.mixKey(hs.ss, this.dh(hs.e.privateKey, hs.rs));
        const ciphertext = this.encryptAndHash(hs.ss, payload);
        const ns = this.createEmptyKey();
        const messageBuffer = {
            ne: ne,
            ns: ns,
            ciphertext: ciphertext
        };
        const { cs1: cs1, cs2: cs2 } = this.split(hs.ss);
        return {
            messageBuffer: messageBuffer,
            cs1: cs1,
            cs2: cs2,
            h: hs.ss.h
        };
    }
    readMessageA(hs, message) {
        if ($2UZxa.isValidPublicKey(message.ne)) hs.re = message.ne;
        this.mixHash(hs.ss, hs.re);
        this.mixKey(hs.ss, this.dh(hs.s.privateKey, hs.re));
        const { plaintext: ns, valid: valid1 } = this.decryptAndHash(hs.ss, message.ns);
        if (valid1 && ns.length === 32 && $2UZxa.isValidPublicKey(ns)) hs.rs = ns;
        this.mixKey(hs.ss, this.dh(hs.s.privateKey, hs.rs));
        const { plaintext: plaintext, valid: valid2 } = this.decryptAndHash(hs.ss, message.ciphertext);
        return {
            plaintext: plaintext,
            valid: valid1 && valid2
        };
    }
    readMessageB(hs, message) {
        if ($2UZxa.isValidPublicKey(message.ne)) hs.re = message.ne;
        this.mixHash(hs.ss, hs.re);
        if (!hs.e) throw new Error("Handshake state should contain ephemeral key by now.");
        this.mixKey(hs.ss, this.dh(hs.e.privateKey, hs.re));
        this.mixKey(hs.ss, this.dh(hs.s.privateKey, hs.re));
        const { plaintext: plaintext, valid: valid } = this.decryptAndHash(hs.ss, message.ciphertext);
        const { cs1: cs1, cs2: cs2 } = this.split(hs.ss);
        return {
            h: hs.ss.h,
            valid: valid,
            plaintext: plaintext,
            cs1: cs1,
            cs2: cs2
        };
    }
    initializeInitiator(prologue, s, rs, psk) {
        const name = "Noise_IK_25519_ChaChaPoly_SHA256";
        const ss = this.initializeSymmetric(name);
        this.mixHash(ss, prologue);
        this.mixHash(ss, rs);
        const re = $l7tTk.Buffer.alloc(32);
        return {
            ss: ss,
            s: s,
            rs: rs,
            re: re,
            psk: psk
        };
    }
    initializeResponder(prologue, s, rs, psk) {
        const name = "Noise_IK_25519_ChaChaPoly_SHA256";
        const ss = this.initializeSymmetric(name);
        this.mixHash(ss, prologue);
        this.mixHash(ss, s.publicKey);
        const re = $l7tTk.Buffer.alloc(32);
        return {
            ss: ss,
            s: s,
            rs: rs,
            re: re,
            psk: psk
        };
    }
}
module.exports.IK = $f6f7de2221381366$var$IK;

});

parcelRequire.register("daIRS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FailedIKError = void 0;
class $996f0366964f5271$var$FailedIKError extends Error {
    constructor(initialMsg, message){
        super(message);
        this.initialMsg = initialMsg;
        this.name = "FailedIKhandshake";
    }
}
module.exports.FailedIKError = $996f0366964f5271$var$FailedIKError;

});


parcelRequire.register("aCOlY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.XXFallbackHandshake = void 0;

var $l7tTk = parcelRequire("l7tTk");

var $kyJGt = parcelRequire("kyJGt");

var $2UZxa = parcelRequire("2UZxa");

var $e4tcr = parcelRequire("e4tcr");

var $evFdC = parcelRequire("evFdC");
class $7bc483260871af4a$var$XXFallbackHandshake extends $kyJGt.XXHandshake {
    constructor(isInitiator, payload, prologue, staticKeypair, connection, initialMsg, remotePeer, ephemeralKeys, handshake){
        super(isInitiator, payload, prologue, staticKeypair, connection, remotePeer, handshake);
        if (ephemeralKeys) this.ephemeralKeys = ephemeralKeys;
        this.initialMsg = initialMsg;
    }
    // stage 0
    // eslint-disable-next-line require-await
    async propose() {
        if (this.isInitiator) {
            this.xx.sendMessage(this.session, $l7tTk.Buffer.alloc(0), this.ephemeralKeys);
            $e4tcr.logger("XX Fallback Stage 0 - Initialized state as the first message was sent by initiator.");
            $e4tcr.logLocalEphemeralKeys(this.session.hs.e);
        } else {
            $e4tcr.logger("XX Fallback Stage 0 - Responder decoding initial msg from IK.");
            const receivedMessageBuffer = $evFdC.decode0(this.initialMsg);
            const { valid: valid } = this.xx.recvMessage(this.session, {
                ne: receivedMessageBuffer.ne,
                ns: $l7tTk.Buffer.alloc(0),
                ciphertext: $l7tTk.Buffer.alloc(0)
            });
            if (!valid) throw new Error("xx fallback stage 0 decryption validation fail");
            $e4tcr.logger("XX Fallback Stage 0 - Responder used received message from IK.");
            $e4tcr.logRemoteEphemeralKey(this.session.hs.re);
        }
    }
    // stage 1
    async exchange() {
        if (this.isInitiator) {
            const receivedMessageBuffer = $evFdC.decode1(this.initialMsg);
            const { plaintext: plaintext, valid: valid } = this.xx.recvMessage(this.session, receivedMessageBuffer);
            if (!valid) throw new Error("xx fallback stage 1 decryption validation fail");
            $e4tcr.logger("XX Fallback Stage 1 - Initiator used received message from IK.");
            $e4tcr.logRemoteEphemeralKey(this.session.hs.re);
            $e4tcr.logRemoteStaticKey(this.session.hs.rs);
            $e4tcr.logger("Initiator going to check remote's signature...");
            try {
                const decodedPayload = await $2UZxa.decodePayload(plaintext);
                this.remotePeer = this.remotePeer || await $2UZxa.getPeerIdFromPayload(decodedPayload);
                await $2UZxa.verifySignedPayload(this.session.hs.rs, decodedPayload, this.remotePeer);
                this.setRemoteEarlyData(decodedPayload.data);
            } catch (e) {
                const err = e;
                throw new Error(`Error occurred while verifying signed payload from responder: ${err.message}`);
            }
            $e4tcr.logger("All good with the signature!");
        } else {
            $e4tcr.logger("XX Fallback Stage 1 - Responder start");
            await super.exchange();
            $e4tcr.logger("XX Fallback Stage 1 - Responder end");
        }
    }
}
module.exports.XXFallbackHandshake = $7bc483260871af4a$var$XXFallbackHandshake;

});

parcelRequire.register("leW0E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decryptStream = module.exports.encryptStream = void 0;

var $l7tTk = parcelRequire("l7tTk");

var $iuPHX = parcelRequire("iuPHX");
// Returns generator that encrypts payload from the user
function $f767e74055386762$var$encryptStream(handshake) {
    return async function*(source) {
        for await (const chunk of source){
            const chunkBuffer = $l7tTk.Buffer.from(chunk.buffer, chunk.byteOffset, chunk.length);
            for(let i = 0; i < chunkBuffer.length; i += $iuPHX.NOISE_MSG_MAX_LENGTH_BYTES_WITHOUT_TAG){
                let end = i + $iuPHX.NOISE_MSG_MAX_LENGTH_BYTES_WITHOUT_TAG;
                if (end > chunkBuffer.length) end = chunkBuffer.length;
                const data = handshake.encrypt(chunkBuffer.slice(i, end), handshake.session);
                yield data;
            }
        }
    };
}
module.exports.encryptStream = $f767e74055386762$var$encryptStream;
// Decrypt received payload to the user
function $f767e74055386762$var$decryptStream(handshake) {
    return async function*(source) {
        for await (const chunk of source){
            const chunkBuffer = $l7tTk.Buffer.from(chunk.buffer, chunk.byteOffset, chunk.length);
            for(let i = 0; i < chunkBuffer.length; i += $iuPHX.NOISE_MSG_MAX_LENGTH_BYTES){
                let end = i + $iuPHX.NOISE_MSG_MAX_LENGTH_BYTES;
                if (end > chunkBuffer.length) end = chunkBuffer.length;
                const chunk = chunkBuffer.slice(i, end);
                const { plaintext: decrypted, valid: valid } = await handshake.decrypt(chunk, handshake.session);
                if (!valid) throw new Error("Failed to validate decrypted chunk");
                yield decrypted;
            }
        }
    };
}
module.exports.decryptStream = $f767e74055386762$var$decryptStream;

});

parcelRequire.register("6nNT2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeyCache = void 0;
/**
 * Storage for static keys of previously connected peers.
 */ class $4a5b9689be0f686e$var$Keycache {
    constructor(){
        this.storage = new Map();
    }
    store(peerId, key) {
        this.storage.set(peerId.id, key);
    }
    load(peerId) {
        var _a;
        if (!peerId) return null;
        return (_a = this.storage.get(peerId.id)) !== null && _a !== void 0 ? _a : null;
    }
    resetStorage() {
        this.storage.clear();
    }
}
const $4a5b9689be0f686e$var$KeyCache = new $4a5b9689be0f686e$var$Keycache();
module.exports.KeyCache = $4a5b9689be0f686e$var$KeyCache;

});



parcelRequire.register("01L0M", function(module, exports) {
"use strict";

module.exports = (parcelRequire("d9T95"));

});
parcelRequire.register("d9T95", function(module, exports) {
"use strict";

var $d8Blz = parcelRequire("d8Blz");

var $5htNF = parcelRequire("5htNF");

const $9946e46799759e5d$var$log = (parcelRequire("jjmHV"))("libp2p:mplex");

var $dB93l = parcelRequire("dB93l");

var $cYTPa = parcelRequire("cYTPa");

var $4DFsa = parcelRequire("4DFsa");

var $6fcwq = parcelRequire("6fcwq");
var $9946e46799759e5d$require$MessageTypes = $6fcwq.MessageTypes;
var $9946e46799759e5d$require$MessageTypeNames = $6fcwq.MessageTypeNames;

var $eZutO = parcelRequire("eZutO");
class $9946e46799759e5d$var$Mplex {
    /**
   * @class
   * @param {object} options
   * @param {function(*)} options.onStream - Called whenever an inbound stream is created
   * @param {function(*)} options.onStreamEnd - Called whenever a stream ends
   * @param {AbortSignal} options.signal - An AbortController signal
   */ constructor(options){
        options = options || {};
        options = typeof options === "function" ? {
            onStream: options
        } : options;
        this._streamId = 0;
        this._streams = {
            /**
       * @type {Map<number, *>} Stream to ids map
       */ initiators: new Map(),
            /**
       * @type {Map<number, *>} Stream to ids map
       */ receivers: new Map()
        };
        this._options = options;
        /**
     * An iterable sink
     */ this.sink = this._createSink();
        /**
     * An iterable source
     */ this.source = this._createSource();
        /**
     * @property {Function} onStream
     */ this.onStream = options.onStream;
        /**
     * @property {Function} onStreamEnd
     */ this.onStreamEnd = options.onStreamEnd;
    }
    /**
   * Returns a Map of streams and their ids
   *
   * @returns {Map<number,*>}
   */ get streams() {
        // Inbound and Outbound streams may have the same ids, so we need to make those unique
        const streams = [];
        this._streams.initiators.forEach((stream)=>{
            streams.push(stream);
        });
        this._streams.receivers.forEach((stream)=>{
            streams.push(stream);
        });
        return streams;
    }
    /**
   * Initiate a new stream with the given name. If no name is
   * provided, the id of th stream will be used.
   *
   * @param {string} [name] - If name is not a string it will be cast to one
   * @returns {Stream}
   */ newStream(name) {
        const id = this._streamId++;
        name = name == null ? id.toString() : String(name);
        const registry = this._streams.initiators;
        return this._newStream({
            id: id,
            name: name,
            type: "initiator",
            registry: registry
        });
    }
    /**
   * Called whenever an inbound stream is created
   *
   * @private
   * @param {*} options
   * @param {number} options.id
   * @param {string} options.name
   * @returns {*} A muxed stream
   */ _newReceiverStream({ id: id, name: name }) {
        const registry = this._streams.receivers;
        return this._newStream({
            id: id,
            name: name,
            type: "receiver",
            registry: registry
        });
    }
    /**
   * Creates a new stream
   *
   * @private
   * @param {object} options
   * @param {number} options.id
   * @param {string} options.name
   * @param {string} options.type
   * @param {Map<number, *>} options.registry - A map of streams to their ids
   * @returns {*} A muxed stream
   */ _newStream({ id: id, name: name, type: type, registry: registry }) {
        if (registry.has(id)) throw new Error(`${type} stream ${id} already exists!`);
        $9946e46799759e5d$var$log("new %s stream %s %s", type, id, name);
        const send = (msg)=>{
            if ($9946e46799759e5d$var$log.enabled) $9946e46799759e5d$var$log("%s stream %s %s send", type, id, name, {
                ...msg,
                type: $9946e46799759e5d$require$MessageTypeNames[msg.type],
                data: msg.data && msg.data.slice()
            });
            return this.source.push(msg);
        };
        const onEnd = ()=>{
            $9946e46799759e5d$var$log("%s stream %s %s ended", type, id, name);
            registry.delete(id);
            this.onStreamEnd && this.onStreamEnd(stream);
        };
        const stream = $eZutO({
            id: id,
            name: name,
            send: send,
            type: type,
            onEnd: onEnd,
            maxMsgSize: this._options.maxMsgSize
        });
        registry.set(id, stream);
        return stream;
    }
    /**
   * Creates a sink with an abortable source. Incoming messages will
   * also have their size restricted. All messages will be varint decoded.
   *
   * @private
   * @returns {*} Returns an iterable sink
   */ _createSink() {
        return async (source)=>{
            if (this._options.signal) source = $dB93l(source, this._options.signal);
            try {
                await $d8Blz(source, $cYTPa.decode, $4DFsa(this._options.maxMsgSize), async (source)=>{
                    for await (const msgs of source)for (const msg of msgs)this._handleIncoming(msg);
                });
            } catch (err) {
                $9946e46799759e5d$var$log("error in sink", err);
                return this.source.end(err) // End the source with an error
                ;
            }
            this.source.end();
        };
    }
    /**
   * Creates a source that restricts outgoing message sizes
   * and varint encodes them.
   *
   * @private
   * @returns {*} An iterable source
   */ _createSource() {
        const onEnd = (err)=>{
            const { initiators: initiators, receivers: receivers } = this._streams;
            // Abort all the things!
            for (const s of initiators.values())s.abort(err);
            for (const s of receivers.values())s.abort(err);
        };
        const source = $5htNF({
            onEnd: onEnd,
            writev: true
        });
        return Object.assign($cYTPa.encode(source), {
            push: source.push,
            end: source.end,
            return: source.return
        });
    }
    /**
   * @private
   * @param {object} options
   * @param {number} options.id
   * @param {string} options.type
   * @param {Uint8Array|BufferList} options.data
   * @returns {void}
   */ _handleIncoming({ id: id, type: type, data: data }) {
        if ($9946e46799759e5d$var$log.enabled) $9946e46799759e5d$var$log("incoming message", {
            id: id,
            type: $9946e46799759e5d$require$MessageTypeNames[type],
            data: data.slice()
        });
        // Create a new stream?
        if (type === $9946e46799759e5d$require$MessageTypes.NEW_STREAM && this.onStream) {
            const stream = this._newReceiverStream({
                id: id,
                name: data.toString()
            });
            return this.onStream(stream);
        }
        const list = type & 1 ? this._streams.initiators : this._streams.receivers;
        const stream = list.get(id);
        if (!stream) return $9946e46799759e5d$var$log("missing stream %s", id);
        switch(type){
            case $9946e46799759e5d$require$MessageTypes.MESSAGE_INITIATOR:
            case $9946e46799759e5d$require$MessageTypes.MESSAGE_RECEIVER:
                stream.source.push(data);
                break;
            case $9946e46799759e5d$require$MessageTypes.CLOSE_INITIATOR:
            case $9946e46799759e5d$require$MessageTypes.CLOSE_RECEIVER:
                stream.close();
                break;
            case $9946e46799759e5d$require$MessageTypes.RESET_INITIATOR:
            case $9946e46799759e5d$require$MessageTypes.RESET_RECEIVER:
                stream.reset();
                break;
            default:
                $9946e46799759e5d$var$log("unknown message type %s", type);
        }
    }
}
$9946e46799759e5d$var$Mplex.multicodec = "/mplex/6.7.0";
module.exports = $9946e46799759e5d$var$Mplex;

});
parcelRequire.register("cYTPa", function(module, exports) {

$parcel$export(module.exports, "encode", () => $9736642b87a8cbf5$export$c564cdbbe6da493, (v) => $9736642b87a8cbf5$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $9736642b87a8cbf5$export$2f872c0f2117be69, (v) => $9736642b87a8cbf5$export$2f872c0f2117be69 = v);
var $9736642b87a8cbf5$export$c564cdbbe6da493;
var $9736642b87a8cbf5$export$2f872c0f2117be69;
"use strict";

$9736642b87a8cbf5$export$c564cdbbe6da493 = (parcelRequire("7htba"));

$9736642b87a8cbf5$export$2f872c0f2117be69 = (parcelRequire("d2pLt"));

});
parcelRequire.register("7htba", function(module, exports) {
"use strict";

var $b7PIr = parcelRequire("b7PIr");

var $hG3ux = parcelRequire("hG3ux");
const $54d0c151ec246214$var$POOL_SIZE = 10240;
class $54d0c151ec246214$var$Encoder {
    constructor(){
        this._pool = new Uint8Array($54d0c151ec246214$var$POOL_SIZE);
        this._poolOffset = 0;
    }
    /**
   * Encodes the given message and returns it and its header
   *
   * @param {*} msg - The message object to encode
   * @returns {Uint8Array|Uint8Array[]}
   */ write(msg) {
        const pool = this._pool;
        let offset = this._poolOffset;
        $b7PIr.encode(msg.id << 3 | msg.type, pool, offset);
        offset += $b7PIr.encode.bytes;
        $b7PIr.encode(msg.data ? msg.data.length : 0, pool, offset);
        offset += $b7PIr.encode.bytes;
        const header = pool.subarray(this._poolOffset, offset);
        if ($54d0c151ec246214$var$POOL_SIZE - offset < 100) {
            this._pool = new Uint8Array($54d0c151ec246214$var$POOL_SIZE);
            this._poolOffset = 0;
        } else this._poolOffset = offset;
        if (!msg.data) return header;
        return [
            header,
            msg.data
        ];
    }
}
const $54d0c151ec246214$var$encoder = new $54d0c151ec246214$var$Encoder();
// Encode one or more messages and yield a BufferList of encoded messages
module.exports = (source)=>(async function* encode() {
        for await (const msg of source)if (Array.isArray(msg)) yield new $hG3ux(msg.map((m)=>$54d0c151ec246214$var$encoder.write(m)));
        else yield new $hG3ux($54d0c151ec246214$var$encoder.write(msg));
    })();

});

parcelRequire.register("d2pLt", function(module, exports) {
"use strict";

var $b7PIr = parcelRequire("b7PIr");

var $hG3ux = parcelRequire("hG3ux");
// Decode a chunk and yield an _array_ of decoded messages
module.exports = (source)=>(async function* decode() {
        const decoder = new $97df729d341f78b0$var$Decoder();
        for await (const chunk of source){
            const msgs = decoder.write(chunk);
            if (msgs.length) yield msgs;
        }
    })();
class $97df729d341f78b0$var$Decoder {
    constructor(){
        this._buffer = new $hG3ux();
        // optimization to allow varint to take a BufferList (well a proxy to)
        this._bufferProxy = new Proxy({}, {
            get: (_, prop)=>prop[0] === "l" ? this._buffer[prop] : this._buffer.get(parseInt(prop))
        });
        this._headerInfo = null;
    }
    /**
   * @param {Uint8Array|BufferList} chunk
   * @returns {object[]} An array of message objects
   */ write(chunk) {
        if (!chunk || !chunk.length) return [];
        this._buffer.append(chunk);
        const msgs = [];
        while(this._buffer.length){
            if (!this._headerInfo) try {
                this._headerInfo = this._decodeHeader(this._bufferProxy);
            } catch (_) {
                break; // We haven't received enough data yet
            }
            const { id: id, type: type, length: length, offset: offset } = this._headerInfo;
            const bufferedDataLength = this._buffer.length - offset;
            if (bufferedDataLength < length) break; // not enough data yet
            msgs.push({
                id: id,
                type: type,
                data: this._buffer.shallowSlice(offset, offset + length)
            });
            this._buffer.consume(offset + length);
            this._headerInfo = null;
        }
        return msgs;
    }
    /**
   * Attempts to decode the message header from the buffer
   *
   * @private
   * @param {Uint8Array} data
   * @returns {*} message header (id, type, offset, length)
   */ _decodeHeader(data) {
        const h = $b7PIr.decode(data);
        let offset = $b7PIr.decode.bytes;
        const length = $b7PIr.decode(data, offset);
        offset += $b7PIr.decode.bytes;
        return {
            id: h >> 3,
            type: h & 7,
            offset: offset,
            length: length
        };
    }
}

});


parcelRequire.register("4DFsa", function(module, exports) {
"use strict";
const $360af5b9d4a0c37e$var$MAX_MSG_SIZE = 1048576 // 1MB
;
/**
 * Creates an iterable transform that restricts message sizes to
 * the given maximum size.
 *
 * @param {number} [max] - The maximum message size. Defaults to 1MB
 * @returns {*} An iterable transform.
 */ module.exports = (max)=>{
    max = max || $360af5b9d4a0c37e$var$MAX_MSG_SIZE;
    const checkSize = (msg)=>{
        if (msg.data && msg.data.length > max) throw Object.assign(new Error("message size too large!"), {
            code: "ERR_MSG_TOO_BIG"
        });
    };
    return (source)=>{
        return async function* restrictSize() {
            for await (const msg of source){
                if (Array.isArray(msg)) msg.forEach(checkSize);
                else checkSize(msg);
                yield msg;
            }
        }();
    };
};
module.exports.MAX_MSG_SIZE = $360af5b9d4a0c37e$var$MAX_MSG_SIZE;

});

parcelRequire.register("6fcwq", function(module, exports) {

$parcel$export(module.exports, "MessageTypes", () => $48bddb650c5c6fee$export$c8c3f3bdd88f8ff, (v) => $48bddb650c5c6fee$export$c8c3f3bdd88f8ff = v);
$parcel$export(module.exports, "InitiatorMessageTypes", () => $48bddb650c5c6fee$export$6687251fd0bf3be3, (v) => $48bddb650c5c6fee$export$6687251fd0bf3be3 = v);
$parcel$export(module.exports, "ReceiverMessageTypes", () => $48bddb650c5c6fee$export$59608d90c0e0ca1c, (v) => $48bddb650c5c6fee$export$59608d90c0e0ca1c = v);
$parcel$export(module.exports, "MessageTypeNames", () => $48bddb650c5c6fee$export$3f6f135651b3f105, (v) => $48bddb650c5c6fee$export$3f6f135651b3f105 = v);
var $48bddb650c5c6fee$export$c8c3f3bdd88f8ff;
var $48bddb650c5c6fee$export$6687251fd0bf3be3;
var $48bddb650c5c6fee$export$59608d90c0e0ca1c;
var $48bddb650c5c6fee$export$3f6f135651b3f105;
"use strict";
const $48bddb650c5c6fee$var$MessageTypes = Object.freeze({
    NEW_STREAM: 0,
    MESSAGE_RECEIVER: 1,
    MESSAGE_INITIATOR: 2,
    CLOSE_RECEIVER: 3,
    CLOSE_INITIATOR: 4,
    RESET_RECEIVER: 5,
    RESET_INITIATOR: 6
});
$48bddb650c5c6fee$export$c8c3f3bdd88f8ff = $48bddb650c5c6fee$var$MessageTypes;
$48bddb650c5c6fee$export$6687251fd0bf3be3 = Object.freeze({
    NEW_STREAM: $48bddb650c5c6fee$var$MessageTypes.NEW_STREAM,
    MESSAGE: $48bddb650c5c6fee$var$MessageTypes.MESSAGE_INITIATOR,
    CLOSE: $48bddb650c5c6fee$var$MessageTypes.CLOSE_INITIATOR,
    RESET: $48bddb650c5c6fee$var$MessageTypes.RESET_INITIATOR
});
$48bddb650c5c6fee$export$59608d90c0e0ca1c = Object.freeze({
    MESSAGE: $48bddb650c5c6fee$var$MessageTypes.MESSAGE_RECEIVER,
    CLOSE: $48bddb650c5c6fee$var$MessageTypes.CLOSE_RECEIVER,
    RESET: $48bddb650c5c6fee$var$MessageTypes.RESET_RECEIVER
});
$48bddb650c5c6fee$export$3f6f135651b3f105 = Object.freeze(Object.entries($48bddb650c5c6fee$var$MessageTypes).reduce((obj, e)=>{
    obj[e[1]] = e[0];
    return obj;
}, {}));

});

parcelRequire.register("eZutO", function(module, exports) {
"use strict";

var $dB93l = parcelRequire("dB93l");

const $ae9e67e0e65ecb87$var$log = (parcelRequire("jjmHV"))("libp2p:mplex:stream");

var $5htNF = parcelRequire("5htNF");

var $hG3ux = parcelRequire("hG3ux");

var $20Lm5 = parcelRequire("20Lm5");

var $4DFsa = parcelRequire("4DFsa");
var $ae9e67e0e65ecb87$require$MAX_MSG_SIZE = $4DFsa.MAX_MSG_SIZE;

var $6fcwq = parcelRequire("6fcwq");
var $ae9e67e0e65ecb87$require$InitiatorMessageTypes = $6fcwq.InitiatorMessageTypes;
var $ae9e67e0e65ecb87$require$ReceiverMessageTypes = $6fcwq.ReceiverMessageTypes;
const $ae9e67e0e65ecb87$var$ERR_MPLEX_STREAM_RESET = "ERR_MPLEX_STREAM_RESET";
const $ae9e67e0e65ecb87$var$ERR_MPLEX_STREAM_ABORT = "ERR_MPLEX_STREAM_ABORT";
/**
 * @param {object} options
 * @param {number} options.id
 * @param {string} options.name
 * @param {function(*)} options.send - Called to send data through the stream
 * @param {function(Error)} [options.onEnd] - Called whenever the stream ends
 * @param {string} [options.type] - One of ['initiator','receiver']. Defaults to 'initiator'
 * @param {number} [options.maxMsgSize] - Max size of an mplex message in bytes. Writes > size are automatically split. Defaults to 1MB
 * @returns {*} A muxed stream
 */ module.exports = ({ id: id, name: name, send: send, onEnd: onEnd = ()=>{}, type: type = "initiator", maxMsgSize: maxMsgSize = $ae9e67e0e65ecb87$require$MAX_MSG_SIZE })=>{
    const abortController = new AbortController();
    const resetController = new AbortController();
    const Types = type === "initiator" ? $ae9e67e0e65ecb87$require$InitiatorMessageTypes : $ae9e67e0e65ecb87$require$ReceiverMessageTypes;
    const externalId = type === "initiator" ? `i${id}` : `r${id}`;
    name = String(name == null ? id : name);
    let sourceEnded = false;
    let sinkEnded = false;
    let endErr;
    const onSourceEnd = (err)=>{
        if (sourceEnded) return;
        sourceEnded = true;
        $ae9e67e0e65ecb87$var$log("%s stream %s source end", type, name, err);
        if (err && !endErr) endErr = err;
        if (sinkEnded) {
            stream.timeline.close = Date.now();
            onEnd(endErr);
        }
    };
    const onSinkEnd = (err)=>{
        if (sinkEnded) return;
        sinkEnded = true;
        $ae9e67e0e65ecb87$var$log("%s stream %s sink end", type, name, err);
        if (err && !endErr) endErr = err;
        if (sourceEnded) {
            stream.timeline.close = Date.now();
            onEnd(endErr);
        }
    };
    const stream = {
        // Close for reading
        close: ()=>stream.source.end(),
        // Close for reading and writing (local error)
        abort: (err)=>{
            $ae9e67e0e65ecb87$var$log("%s stream %s abort", type, name, err);
            // End the source with the passed error
            stream.source.end(err);
            abortController.abort();
            onSinkEnd(err);
        },
        // Close immediately for reading and writing (remote error)
        reset: ()=>{
            const err = $20Lm5(new Error("stream reset"), $ae9e67e0e65ecb87$var$ERR_MPLEX_STREAM_RESET);
            resetController.abort();
            stream.source.end(err);
            onSinkEnd(err);
        },
        sink: async (source)=>{
            source = $dB93l(source, [
                {
                    signal: abortController.signal,
                    options: {
                        abortMessage: "stream aborted",
                        abortCode: $ae9e67e0e65ecb87$var$ERR_MPLEX_STREAM_ABORT
                    }
                },
                {
                    signal: resetController.signal,
                    options: {
                        abortMessage: "stream reset",
                        abortCode: $ae9e67e0e65ecb87$var$ERR_MPLEX_STREAM_RESET
                    }
                }
            ]);
            if (type === "initiator") send({
                id: id,
                type: Types.NEW_STREAM,
                data: name
            });
            try {
                for await (let data of source)while(data.length){
                    if (data.length <= maxMsgSize) {
                        send({
                            id: id,
                            type: Types.MESSAGE,
                            data: data
                        });
                        break;
                    }
                    data = $hG3ux.isBufferList(data) ? data : new $hG3ux(data);
                    send({
                        id: id,
                        type: Types.MESSAGE,
                        data: data.shallowSlice(0, maxMsgSize)
                    });
                    data.consume(maxMsgSize);
                }
            } catch (err) {
                // Send no more data if this stream was remotely reset
                if (err.code === $ae9e67e0e65ecb87$var$ERR_MPLEX_STREAM_RESET) $ae9e67e0e65ecb87$var$log("%s stream %s reset", type, name);
                else {
                    $ae9e67e0e65ecb87$var$log("%s stream %s error", type, name, err);
                    send({
                        id: id,
                        type: Types.RESET
                    });
                }
                stream.source.end(err);
                return onSinkEnd(err);
            }
            send({
                id: id,
                type: Types.CLOSE
            });
            onSinkEnd();
        },
        source: $5htNF(onSourceEnd),
        timeline: {
            open: Date.now(),
            close: null
        },
        id: externalId
    };
    return stream;
};

});



parcelRequire.register("hslgQ", function(module, exports) {
"use strict";

var $ly5x8 = parcelRequire("ly5x8");

var $jhePu = parcelRequire("jhePu");

var $aUiAo = parcelRequire("aUiAo");

var $dB93l = parcelRequire("dB93l");
var $cb558d1993f50954$require$AbortError = $dB93l.AbortError;

var $eoOla = parcelRequire("eoOla");

var $jjmHV = parcelRequire("jjmHV");
const $cb558d1993f50954$var$log = $jjmHV("libp2p:websockets");
$cb558d1993f50954$var$log.error = $jjmHV("libp2p:websockets:error");

var $35MYe = parcelRequire("35MYe");

var $4lWIX = parcelRequire("4lWIX");

var $juuse = parcelRequire("juuse");

var $jvgiY = parcelRequire("jvgiY");
/**
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 */ /**
 * @class WebSockets
 */ class $cb558d1993f50954$var$WebSockets {
    /**
   * @class
   * @param {object} options
   * @param {Upgrader} options.upgrader
   * @param {(multiaddrs: Array<Multiaddr>) => Array<Multiaddr>} options.filter - override transport addresses filter
   */ constructor({ upgrader: upgrader, filter: filter }){
        if (!upgrader) throw new Error("An upgrader must be provided. See https://github.com/libp2p/interface-transport#upgrader.");
        this._upgrader = upgrader;
        this._filter = filter;
    }
    /**
   * @async
   * @param {Multiaddr} ma
   * @param {object} [options]
   * @param {AbortSignal} [options.signal] - Used to abort dial requests
   * @returns {Connection} An upgraded Connection
   */ async dial(ma, options = {}) {
        $cb558d1993f50954$var$log("dialing %s", ma);
        const socket = await this._connect(ma, options);
        const maConn = $juuse(socket, {
            remoteAddr: ma,
            signal: options.signal
        });
        $cb558d1993f50954$var$log("new outbound connection %s", maConn.remoteAddr);
        const conn = await this._upgrader.upgradeOutbound(maConn);
        $cb558d1993f50954$var$log("outbound connection %s upgraded", maConn.remoteAddr);
        return conn;
    }
    /**
   * @private
   * @param {Multiaddr} ma
   * @param {object} [options]
   * @param {AbortSignal} [options.signal] - Used to abort dial requests
   * @returns {Promise<WebSocket>} Resolves a extended duplex iterable on top of a WebSocket
   */ async _connect(ma, options = {}) {
        if (options.signal && options.signal.aborted) throw new $cb558d1993f50954$require$AbortError();
        const cOpts = ma.toOptions();
        $cb558d1993f50954$var$log("dialing %s:%s", cOpts.host, cOpts.port);
        const errorPromise = $eoOla();
        const errfn = (err)=>{
            const msg = `connection error: ${err.message}`;
            $cb558d1993f50954$var$log.error(msg);
            errorPromise.reject(err);
        };
        const rawSocket = $ly5x8($aUiAo(ma), Object.assign({
            binary: true
        }, options));
        if (rawSocket.socket.on) rawSocket.socket.on("error", errfn);
        else rawSocket.socket.onerror = errfn;
        if (!options.signal) {
            await Promise.race([
                rawSocket.connected(),
                errorPromise.promise
            ]);
            $cb558d1993f50954$var$log("connected %s", ma);
            return rawSocket;
        }
        // Allow abort via signal during connect
        let onAbort;
        const abort = new Promise((resolve, reject)=>{
            onAbort = ()=>{
                reject(new $cb558d1993f50954$require$AbortError());
                // FIXME: https://github.com/libp2p/js-libp2p-websockets/issues/121
                setTimeout(()=>{
                    rawSocket.close();
                });
            };
            // Already aborted?
            if (options.signal.aborted) return onAbort();
            options.signal.addEventListener("abort", onAbort);
        });
        try {
            await Promise.race([
                abort,
                errorPromise.promise,
                rawSocket.connected()
            ]);
        } finally{
            options.signal.removeEventListener("abort", onAbort);
        }
        $cb558d1993f50954$var$log("connected %s", ma);
        return rawSocket;
    }
    /**
   * Creates a Websockets listener. The provided `handler` function will be called
   * anytime a new incoming Connection has been successfully upgraded via
   * `upgrader.upgradeInbound`.
   *
   * @param {object} [options]
   * @param {http.Server} [options.server] - A pre-created Node.js HTTP/S server.
   * @param {function (Connection)} handler
   * @returns {Listener} A Websockets listener
   */ createListener(options = {}, handler) {
        if (typeof options === "function") {
            handler = options;
            options = {};
        }
        return $4lWIX({
            handler: handler,
            upgrader: this._upgrader
        }, options);
    }
    /**
   * Takes a list of `Multiaddr`s and returns only valid Websockets addresses.
   * By default, in a browser environment only DNS+WSS multiaddr is accepted,
   * while in a Node.js environment DNS+{WS, WSS} multiaddrs are accepted.
   *
   * @param {Multiaddr[]} multiaddrs
   * @returns {Multiaddr[]} Valid Websockets multiaddrs
   */ filter(multiaddrs) {
        multiaddrs = Array.isArray(multiaddrs) ? multiaddrs : [
            multiaddrs
        ];
        if (this._filter) return this._filter(multiaddrs);
        // Browser
        if ($35MYe.isBrowser || $35MYe.isWebWorker) return $jvgiY.dnsWss(multiaddrs);
        return $jvgiY.all(multiaddrs);
    }
}
module.exports = $jhePu($cb558d1993f50954$var$WebSockets, {
    className: "WebSockets",
    symbolName: "@libp2p/js-libp2p-websockets/websockets"
});

});
parcelRequire.register("ly5x8", function(module, exports) {
"use strict";

var $ea6sm = parcelRequire("ea6sm");

var $3PzMu = parcelRequire("3PzMu");

var $5VRnk = parcelRequire("5VRnk");
module.exports = function(addr, opts = {}) {
    const location = typeof window === "undefined" ? {} : window.location;
    const url = $5VRnk(addr, location);
    const socket = new $ea6sm(url, opts.websocket);
    const stream = $3PzMu(socket, opts);
    stream.remoteAddress = url;
    stream.close = ()=>new Promise((resolve, reject)=>{
            socket.addEventListener("close", resolve);
            socket.close();
        });
    stream.destroy = ()=>{
        if (socket.terminate) socket.terminate();
        else socket.close();
    };
    stream.socket = socket;
    return stream;
};
module.exports.connect = module.exports;

});
parcelRequire.register("ea6sm", function(module, exports) {
/* eslint-env browser */ 
module.exports = typeof WebSocket === "undefined" ? (parcelRequire("7jzxY")) : WebSocket;

});

parcelRequire.register("3PzMu", function(module, exports) {

var $1Ia21 = parcelRequire("1Ia21");

var $cDfKU = parcelRequire("cDfKU");
module.exports = (socket, options)=>{
    options = options || {};
    if (options.binaryType) socket.binaryType = options.binaryType;
    else if (options.binary) socket.binaryType = "arraybuffer";
    const duplex = {
        sink: $cDfKU(socket, options),
        source: $1Ia21(socket, options),
        connected: ()=>duplex.source.connected()
    };
    return duplex;
};

});
parcelRequire.register("1Ia21", function(module, exports) {

var $l7tTk = parcelRequire("l7tTk");
var $13f1ae935f5af9be$require$Buffer = $l7tTk.Buffer;

var $1Gn6k = parcelRequire("1Gn6k");
var $13f1ae935f5af9be$require$EventIterator = $1Gn6k.EventIterator;
// copied from github.com/feross/buffer
// Some ArrayBuffers are not passing the instanceof check, so we need to do a bit more work :(
function $13f1ae935f5af9be$var$isArrayBuffer(obj) {
    return obj instanceof ArrayBuffer || obj != null && obj.constructor != null && obj.constructor.name === "ArrayBuffer" && typeof obj.byteLength === "number";
}
module.exports = (socket)=>{
    const removeListener = socket.removeEventListener || socket.removeListener;
    const source = async function*() {
        const messages = new $13f1ae935f5af9be$require$EventIterator(({ push: push, stop: stop, fail: fail })=>{
            socket.addEventListener("message", push);
            socket.addEventListener("error", fail);
            socket.addEventListener("close", stop);
            return ()=>{
                removeListener.call(socket, "message", push);
                removeListener.call(socket, "error", fail);
                removeListener.call(socket, "close", stop);
            };
        }, {
            highWaterMark: Infinity
        });
        for await (const { data: data } of messages)yield $13f1ae935f5af9be$var$isArrayBuffer(data) ? $13f1ae935f5af9be$require$Buffer.from(data) : data;
    }();
    let connected = socket.readyState === 1;
    let connError;
    socket.addEventListener("open", ()=>{
        connected = true;
        connError = null;
    });
    socket.addEventListener("close", ()=>{
        connected = false;
        connError = null;
    });
    socket.addEventListener("error", (err)=>{
        if (!connected) connError = err;
    });
    source.connected = ()=>new Promise((resolve, reject)=>{
            if (connected) return resolve();
            if (connError) return reject(connError);
            const cleanUp = (cont)=>{
                removeListener.call(socket, "open", onOpen);
                removeListener.call(socket, "error", onError);
                cont();
            };
            const onOpen = ()=>cleanUp(resolve);
            const onError = (err)=>cleanUp(()=>reject(err));
            socket.addEventListener("open", onOpen);
            socket.addEventListener("error", onError);
        });
    return source;
};

});
parcelRequire.register("1Gn6k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6gtp4 = parcelRequire("6gtp4");
module.exports.EventIterator = $6gtp4.EventIterator;
function $139ba217340b5b69$var$subscribe(event, options, evOptions) {
    return new $6gtp4.EventIterator(({ push: push })=>{
        this.addEventListener(event, push, options);
        return ()=>this.removeEventListener(event, push, options);
    }, evOptions);
}
module.exports.subscribe = $139ba217340b5b69$var$subscribe;
module.exports.default = $6gtp4.EventIterator;

});
parcelRequire.register("6gtp4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $48fb0b9b8f82357d$var$EventQueue {
    constructor(){
        this.pullQueue = [];
        this.pushQueue = [];
        this.eventHandlers = {};
        this.isPaused = false;
        this.isStopped = false;
    }
    push(value) {
        if (this.isStopped) return;
        const resolution = {
            value: value,
            done: false
        };
        if (this.pullQueue.length) {
            const placeholder = this.pullQueue.shift();
            if (placeholder) placeholder.resolve(resolution);
        } else {
            this.pushQueue.push(Promise.resolve(resolution));
            if (this.highWaterMark !== undefined && this.pushQueue.length >= this.highWaterMark && !this.isPaused) {
                this.isPaused = true;
                if (this.eventHandlers.highWater) this.eventHandlers.highWater();
                else if (console) console.warn(`EventIterator queue reached ${this.pushQueue.length} items`);
            }
        }
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        this.remove();
        for (const placeholder of this.pullQueue)placeholder.resolve({
            value: undefined,
            done: true
        });
        this.pullQueue.length = 0;
    }
    fail(error) {
        if (this.isStopped) return;
        this.isStopped = true;
        this.remove();
        if (this.pullQueue.length) {
            for (const placeholder of this.pullQueue)placeholder.reject(error);
            this.pullQueue.length = 0;
        } else {
            const rejection = Promise.reject(error);
            /* Attach error handler to avoid leaking an unhandled promise rejection. */ rejection.catch(()=>{});
            this.pushQueue.push(rejection);
        }
    }
    remove() {
        Promise.resolve().then(()=>{
            if (this.removeCallback) this.removeCallback();
        });
    }
    [Symbol.asyncIterator]() {
        return {
            next: (value)=>{
                const result = this.pushQueue.shift();
                if (result) {
                    if (this.lowWaterMark !== undefined && this.pushQueue.length <= this.lowWaterMark && this.isPaused) {
                        this.isPaused = false;
                        if (this.eventHandlers.lowWater) this.eventHandlers.lowWater();
                    }
                    return result;
                } else if (this.isStopped) return Promise.resolve({
                    value: undefined,
                    done: true
                });
                else return new Promise((resolve, reject)=>{
                    this.pullQueue.push({
                        resolve: resolve,
                        reject: reject
                    });
                });
            },
            return: ()=>{
                this.isStopped = true;
                this.pushQueue.length = 0;
                this.remove();
                return Promise.resolve({
                    value: undefined,
                    done: true
                });
            }
        };
    }
}
class $48fb0b9b8f82357d$var$EventIterator {
    constructor(listen, { highWaterMark: highWaterMark = 100, lowWaterMark: lowWaterMark = 1 } = {}){
        const queue = new $48fb0b9b8f82357d$var$EventQueue();
        queue.highWaterMark = highWaterMark;
        queue.lowWaterMark = lowWaterMark;
        queue.removeCallback = listen({
            push: (value)=>queue.push(value),
            stop: ()=>queue.stop(),
            fail: (error)=>queue.fail(error),
            on: (event, fn)=>{
                queue.eventHandlers[event] = fn;
            }
        }) || (()=>{});
        this[Symbol.asyncIterator] = ()=>queue[Symbol.asyncIterator]();
        Object.freeze(this);
    }
}
module.exports.EventIterator = $48fb0b9b8f82357d$var$EventIterator;
module.exports.default = $48fb0b9b8f82357d$var$EventIterator;

});



parcelRequire.register("cDfKU", function(module, exports) {

var $iA6fG = parcelRequire("iA6fG");
module.exports = (socket, options)=>{
    options = options || {};
    options.closeOnEnd = options.closeOnEnd !== false;
    return async (source)=>{
        for await (const data of source){
            try {
                await $iA6fG(socket);
            } catch (err) {
                if (err.message === "socket closed") break;
                throw err;
            }
            socket.send(data);
        }
        if (options.closeOnEnd && socket.readyState <= 1) return new Promise((resolve, reject)=>{
            socket.addEventListener("close", (event)=>{
                if (event.wasClean || event.code === 1006) resolve();
                else {
                    const err = Object.assign(new Error("ws error"), {
                        event: event
                    });
                    reject(err);
                }
            });
            setTimeout(()=>socket.close());
        });
    };
};

});
parcelRequire.register("iA6fG", function(module, exports) {
module.exports = async (socket)=>{
    // if the socket is closing or closed, return end
    if (socket.readyState >= 2) throw new Error("socket closed");
    // if open, return
    if (socket.readyState === 1) return;
    return new Promise((resolve, reject)=>{
        const remove = socket && (socket.removeEventListener || socket.removeListener);
        function cleanup() {
            if (typeof remove === "function") {
                remove.call(socket, "open", handleOpen);
                remove.call(socket, "error", handleErr);
            }
        }
        function handleOpen() {
            cleanup();
            resolve();
        }
        function handleErr(evt) {
            cleanup();
            reject(evt);
        }
        socket.addEventListener("open", handleOpen);
        socket.addEventListener("error", handleErr);
    });
};

});



parcelRequire.register("5VRnk", function(module, exports) {

var $6ZoD7 = parcelRequire("6ZoD7");
var $451badd76ee6da03$require$relative = $6ZoD7.relative;
const $451badd76ee6da03$var$map = {
    http: "ws",
    https: "wss"
};
const $451badd76ee6da03$var$def = "ws";
module.exports = (url, location)=>$451badd76ee6da03$require$relative(url, location, $451badd76ee6da03$var$map, $451badd76ee6da03$var$def);

});
parcelRequire.register("6ZoD7", function(module, exports) {
"use strict";

var $b9R0S = parcelRequire("b9R0S");
var $516b8b99663e680c$require$URLWithLegacySupport = $b9R0S.URLWithLegacySupport;
var $516b8b99663e680c$require$format = $b9R0S.format;
var $516b8b99663e680c$require$URLSearchParams = $b9R0S.URLSearchParams;
var $516b8b99663e680c$require$defaultBase = $b9R0S.defaultBase;

var $lC6AF = parcelRequire("lC6AF");
module.exports = {
    URL: $516b8b99663e680c$require$URLWithLegacySupport,
    URLSearchParams: $516b8b99663e680c$require$URLSearchParams,
    format: $516b8b99663e680c$require$format,
    relative: $lC6AF,
    defaultBase: $516b8b99663e680c$require$defaultBase
};

});
parcelRequire.register("b9R0S", function(module, exports) {
"use strict";
const $81f9a847d3a075ec$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
function $81f9a847d3a075ec$var$getDefaultBase() {
    if ($81f9a847d3a075ec$var$isReactNative) return "http://localhost";
    // in some environments i.e. cloudflare workers location is not available
    if (!self.location) return "";
    return self.location.protocol + "//" + self.location.host;
}
const $81f9a847d3a075ec$var$URL = self.URL;
const $81f9a847d3a075ec$var$defaultBase = $81f9a847d3a075ec$var$getDefaultBase();
class $81f9a847d3a075ec$var$URLWithLegacySupport {
    constructor(url = "", base = $81f9a847d3a075ec$var$defaultBase){
        this.super = new $81f9a847d3a075ec$var$URL(url, base);
        this.path = this.pathname + this.search;
        this.auth = this.username && this.password ? this.username + ":" + this.password : null;
        this.query = this.search && this.search.startsWith("?") ? this.search.slice(1) : null;
    }
    get hash() {
        return this.super.hash;
    }
    get host() {
        return this.super.host;
    }
    get hostname() {
        return this.super.hostname;
    }
    get href() {
        return this.super.href;
    }
    get origin() {
        return this.super.origin;
    }
    get password() {
        return this.super.password;
    }
    get pathname() {
        return this.super.pathname;
    }
    get port() {
        return this.super.port;
    }
    get protocol() {
        return this.super.protocol;
    }
    get search() {
        return this.super.search;
    }
    get searchParams() {
        return this.super.searchParams;
    }
    get username() {
        return this.super.username;
    }
    set hash(hash) {
        this.super.hash = hash;
    }
    set host(host) {
        this.super.host = host;
    }
    set hostname(hostname) {
        this.super.hostname = hostname;
    }
    set href(href) {
        this.super.href = href;
    }
    set password(password) {
        this.super.password = password;
    }
    set pathname(pathname) {
        this.super.pathname = pathname;
    }
    set port(port) {
        this.super.port = port;
    }
    set protocol(protocol) {
        this.super.protocol = protocol;
    }
    set search(search) {
        this.super.search = search;
    }
    set username(username) {
        this.super.username = username;
    }
    /**
   * @param {any} o
   */ static createObjectURL(o) {
        return $81f9a847d3a075ec$var$URL.createObjectURL(o);
    }
    /**
   * @param {string} o
   */ static revokeObjectURL(o) {
        $81f9a847d3a075ec$var$URL.revokeObjectURL(o);
    }
    toJSON() {
        return this.super.toJSON();
    }
    toString() {
        return this.super.toString();
    }
    format() {
        return this.toString();
    }
}
/**
 * @param {string | import('url').UrlObject} obj
 */ function $81f9a847d3a075ec$var$format(obj) {
    if (typeof obj === "string") {
        const url = new $81f9a847d3a075ec$var$URL(obj);
        return url.toString();
    }
    if (!(obj instanceof $81f9a847d3a075ec$var$URL)) {
        const userPass = // @ts-ignore its not supported in node but we normalise
        obj.username && obj.password ? `${obj.username}:${obj.password}@` : "";
        const auth = obj.auth ? obj.auth + "@" : "";
        const port = obj.port ? ":" + obj.port : "";
        const protocol = obj.protocol ? obj.protocol + "//" : "";
        const host = obj.host || "";
        const hostname = obj.hostname || "";
        const search = obj.search || (obj.query ? "?" + obj.query : "");
        const hash = obj.hash || "";
        const pathname = obj.pathname || "";
        // @ts-ignore - path is not supported in node but we normalise
        const path = obj.path || pathname + search;
        return `${protocol}${userPass || auth}${host || hostname + port}${path}${hash}`;
    }
}
module.exports = {
    URLWithLegacySupport: $81f9a847d3a075ec$var$URLWithLegacySupport,
    URLSearchParams: self.URLSearchParams,
    defaultBase: $81f9a847d3a075ec$var$defaultBase,
    format: $81f9a847d3a075ec$var$format
};

});

parcelRequire.register("lC6AF", function(module, exports) {
"use strict";

var $b9R0S = parcelRequire("b9R0S");
var $fbc2424ff4b6c581$require$URLWithLegacySupport = $b9R0S.URLWithLegacySupport;
var $fbc2424ff4b6c581$require$format = $b9R0S.format;
/**
 * @param {string | undefined} url
 * @param {any} [location]
 * @param {any} [protocolMap]
 * @param {any} [defaultProtocol]
 */ module.exports = (url, location = {}, protocolMap = {}, defaultProtocol)=>{
    let protocol = location.protocol ? location.protocol.replace(":", "") : "http";
    // Check protocol map
    protocol = (protocolMap[protocol] || defaultProtocol || protocol) + ":";
    let urlParsed;
    try {
        urlParsed = new $fbc2424ff4b6c581$require$URLWithLegacySupport(url);
    } catch (err) {
        urlParsed = {};
    }
    const base = Object.assign({}, location, {
        protocol: protocol || urlParsed.protocol,
        host: location.host || urlParsed.host
    });
    return new $fbc2424ff4b6c581$require$URLWithLegacySupport(url, $fbc2424ff4b6c581$require$format(base)).toString();
};

});




parcelRequire.register("aUiAo", function(module, exports) {

var $aZLwC = parcelRequire("aZLwC");
var $7f0d8d291fa508fc$require$Multiaddr = $aZLwC.Multiaddr;
const $7f0d8d291fa508fc$var$reduceValue = (_, v)=>v;
const $7f0d8d291fa508fc$var$tcpUri = (str, port, parts, opts)=>{
    // return tcp when explicitly requested
    if (opts && opts.assumeHttp === false) return `tcp://${str}:${port}`;
    // check if tcp is the last protocol in multiaddr
    let protocol = "tcp";
    let explicitPort = `:${port}`;
    const last = parts[parts.length - 1];
    if (last.protocol === "tcp") {
        // assume http and produce clean urls
        protocol = port === "443" ? "https" : "http";
        explicitPort = port === "443" || port === "80" ? "" : explicitPort;
    }
    return `${protocol}://${str}${explicitPort}`;
};
const $7f0d8d291fa508fc$var$Reducers = {
    ip4: $7f0d8d291fa508fc$var$reduceValue,
    ip6: (str, content, i, parts)=>parts.length === 1 && parts[0].protocol === "ip6" ? content : `[${content}]`,
    tcp: (str, content, i, parts, opts)=>parts.some((p)=>[
                "http",
                "https",
                "ws",
                "wss"
            ].includes(p.protocol)) ? `${str}:${content}` : $7f0d8d291fa508fc$var$tcpUri(str, content, parts, opts),
    udp: (str, content)=>`udp://${str}:${content}`,
    dnsaddr: $7f0d8d291fa508fc$var$reduceValue,
    dns4: $7f0d8d291fa508fc$var$reduceValue,
    dns6: $7f0d8d291fa508fc$var$reduceValue,
    ipfs: (str, content)=>`${str}/ipfs/${content}`,
    p2p: (str, content)=>`${str}/p2p/${content}`,
    http: (str)=>`http://${str}`,
    https: (str)=>`https://${str}`,
    ws: (str)=>`ws://${str}`,
    wss: (str)=>`wss://${str}`,
    "p2p-websocket-star": (str)=>`${str}/p2p-websocket-star`,
    "p2p-webrtc-star": (str)=>`${str}/p2p-webrtc-star`,
    "p2p-webrtc-direct": (str)=>`${str}/p2p-webrtc-direct`
};
module.exports = (multiaddr, opts)=>{
    const ma = new $7f0d8d291fa508fc$require$Multiaddr(multiaddr);
    const parts = multiaddr.toString().split("/").slice(1);
    return ma.tuples().map((tuple)=>({
            protocol: parts.shift(),
            content: tuple[1] ? parts.shift() : null
        })).reduce((str, part, i, parts)=>{
        const reduce = $7f0d8d291fa508fc$var$Reducers[part.protocol];
        if (!reduce) throw new Error(`Unsupported protocol ${part.protocol}`);
        return reduce(str, part.content, i, parts, opts);
    }, "");
};

});

parcelRequire.register("35MYe", function(module, exports) {

var $bvigH = parcelRequire("bvigH");
"use strict";

var $47OAF = parcelRequire("47OAF");
const $2407d34310a4b53f$var$IS_ENV_WITH_DOM = typeof window === "object" && typeof document === "object" && document.nodeType === 9;
// @ts-ignore
const $2407d34310a4b53f$var$IS_ELECTRON = $47OAF();
const $2407d34310a4b53f$var$IS_BROWSER = $2407d34310a4b53f$var$IS_ENV_WITH_DOM && !$2407d34310a4b53f$var$IS_ELECTRON;
const $2407d34310a4b53f$var$IS_ELECTRON_MAIN = $2407d34310a4b53f$var$IS_ELECTRON && !$2407d34310a4b53f$var$IS_ENV_WITH_DOM;
const $2407d34310a4b53f$var$IS_ELECTRON_RENDERER = $2407d34310a4b53f$var$IS_ELECTRON && $2407d34310a4b53f$var$IS_ENV_WITH_DOM;
const $2407d34310a4b53f$var$IS_NODE = typeof $bvigH !== "undefined" && typeof $bvigH.release !== "undefined" && $bvigH.release.name === "node" && !$2407d34310a4b53f$var$IS_ELECTRON;
// @ts-ignore - we either ignore worker scope or dom scope
const $2407d34310a4b53f$var$IS_WEBWORKER = typeof importScripts === "function" && typeof self !== "undefined" && typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope;
const $2407d34310a4b53f$var$IS_TEST = typeof $bvigH !== "undefined" && typeof $bvigH.env !== "undefined" && false;
const $2407d34310a4b53f$var$IS_REACT_NATIVE = typeof navigator !== "undefined" && navigator.product === "ReactNative";
module.exports = {
    isTest: $2407d34310a4b53f$var$IS_TEST,
    isElectron: $2407d34310a4b53f$var$IS_ELECTRON,
    isElectronMain: $2407d34310a4b53f$var$IS_ELECTRON_MAIN,
    isElectronRenderer: $2407d34310a4b53f$var$IS_ELECTRON_RENDERER,
    isNode: $2407d34310a4b53f$var$IS_NODE,
    /**
   * Detects browser main thread  **NOT** web worker or service worker
   */ isBrowser: $2407d34310a4b53f$var$IS_BROWSER,
    isWebWorker: $2407d34310a4b53f$var$IS_WEBWORKER,
    isEnvWithDom: $2407d34310a4b53f$var$IS_ENV_WITH_DOM,
    isReactNative: $2407d34310a4b53f$var$IS_REACT_NATIVE
};

});

parcelRequire.register("4lWIX", function(module, exports) {
"use strict";
module.exports = function() {
    throw new Error("WebSocket Servers can not be created in the browser!");
};

});

parcelRequire.register("juuse", function(module, exports) {
"use strict";

var $dB93l = parcelRequire("dB93l");

var $3SBTz = parcelRequire("3SBTz");
var $e308713d78e960f6$require$CLOSE_TIMEOUT = $3SBTz.CLOSE_TIMEOUT;

var $eAhbb = parcelRequire("eAhbb");

var $cEMkd = parcelRequire("cEMkd");

var $jjmHV = parcelRequire("jjmHV");
const $e308713d78e960f6$var$log = $jjmHV("libp2p:websockets:socket");
$e308713d78e960f6$var$log.error = $jjmHV("libp2p:websockets:socket:error");
// Convert a stream into a MultiaddrConnection
// https://github.com/libp2p/interface-transport#multiaddrconnection
module.exports = (stream, options = {})=>{
    const maConn = {
        async sink (source) {
            if (options.signal) source = $dB93l(source, options.signal);
            try {
                await stream.sink(async function*() {
                    for await (const chunk of source)// Convert BufferList to Buffer
                    yield chunk instanceof Uint8Array ? chunk : chunk.slice();
                }());
            } catch (err) {
                if (err.type !== "aborted") $e308713d78e960f6$var$log.error(err);
            }
        },
        source: options.signal ? $dB93l(stream.source, options.signal) : stream.source,
        conn: stream,
        localAddr: options.localAddr || (stream.localAddress && stream.localPort ? $eAhbb(stream.localAddress, stream.localPort) : undefined),
        // If the remote address was passed, use it - it may have the peer ID encapsulated
        remoteAddr: options.remoteAddr || $eAhbb(stream.remoteAddress, stream.remotePort),
        timeline: {
            open: Date.now()
        },
        async close () {
            const start = Date.now();
            try {
                await $cEMkd(stream.close(), $e308713d78e960f6$require$CLOSE_TIMEOUT);
            } catch (err) {
                const { host: host, port: port } = maConn.remoteAddr.toOptions();
                $e308713d78e960f6$var$log("timeout closing stream to %s:%s after %dms, destroying it manually", host, port, Date.now() - start);
                stream.destroy();
            } finally{
                maConn.timeline.close = Date.now();
            }
        }
    };
    stream.socket.once && stream.socket.once("close", ()=>{
        // In instances where `close` was not explicitly called,
        // such as an iterable stream ending, ensure we have set the close
        // timeline
        if (!maConn.timeline.close) maConn.timeline.close = Date.now();
    });
    return maConn;
};

});
parcelRequire.register("3SBTz", function(module, exports) {

$parcel$export(module.exports, "CODE_P2P", () => $2d33cf7c2239abdb$export$7202f4024d580f91, (v) => $2d33cf7c2239abdb$export$7202f4024d580f91 = v);
$parcel$export(module.exports, "CODE_CIRCUIT", () => $2d33cf7c2239abdb$export$4b636a0abcd5a041, (v) => $2d33cf7c2239abdb$export$4b636a0abcd5a041 = v);
$parcel$export(module.exports, "CODE_TCP", () => $2d33cf7c2239abdb$export$20a9d2d4ab4208f5, (v) => $2d33cf7c2239abdb$export$20a9d2d4ab4208f5 = v);
$parcel$export(module.exports, "CODE_WS", () => $2d33cf7c2239abdb$export$bd5c1eb5dd706b7f, (v) => $2d33cf7c2239abdb$export$bd5c1eb5dd706b7f = v);
$parcel$export(module.exports, "CODE_WSS", () => $2d33cf7c2239abdb$export$4500558fde3080ab, (v) => $2d33cf7c2239abdb$export$4500558fde3080ab = v);
$parcel$export(module.exports, "CLOSE_TIMEOUT", () => $2d33cf7c2239abdb$export$9487477798fae092, (v) => $2d33cf7c2239abdb$export$9487477798fae092 = v);
// p2p multi-address code
var $2d33cf7c2239abdb$export$7202f4024d580f91;
var $2d33cf7c2239abdb$export$4b636a0abcd5a041;
var $2d33cf7c2239abdb$export$20a9d2d4ab4208f5;
var $2d33cf7c2239abdb$export$bd5c1eb5dd706b7f;
var $2d33cf7c2239abdb$export$4500558fde3080ab;
// Time to wait for a connection to close gracefully before destroying it manually
var $2d33cf7c2239abdb$export$9487477798fae092;
"use strict";
$2d33cf7c2239abdb$export$7202f4024d580f91 = 421;
$2d33cf7c2239abdb$export$4b636a0abcd5a041 = 290;
$2d33cf7c2239abdb$export$20a9d2d4ab4208f5 = 6;
$2d33cf7c2239abdb$export$bd5c1eb5dd706b7f = 477;
$2d33cf7c2239abdb$export$4500558fde3080ab = 478;
$2d33cf7c2239abdb$export$9487477798fae092 = 2000;

});

parcelRequire.register("eAhbb", function(module, exports) {
"use strict";

var $jjmHV = parcelRequire("jjmHV");
const $a9e1c0f7fc698263$var$log = Object.assign($jjmHV("libp2p:ip-port-to-multiaddr"), {
    error: $jjmHV("libp2p:ip-port-to-multiaddr:err")
});

var $aZLwC = parcelRequire("aZLwC");
var $a9e1c0f7fc698263$require$Multiaddr = $aZLwC.Multiaddr;

var $20Lm5 = parcelRequire("20Lm5");
parcelRequire("5pm7R");
var $2ncQg = parcelRequire("2ncQg");
var $fHkx6 = parcelRequire("fHkx6");
var $a9e1c0f7fc698263$require$Address4 = $2ncQg.Address4;
var $a9e1c0f7fc698263$require$Address6 = $fHkx6.Address6;
const $a9e1c0f7fc698263$var$errors = {
    ERR_INVALID_IP_PARAMETER: "ERR_INVALID_IP_PARAMETER",
    ERR_INVALID_PORT_PARAMETER: "ERR_INVALID_PORT_PARAMETER",
    ERR_INVALID_IP: "ERR_INVALID_IP"
};
/**
 * Transform an IP, Port pair into a multiaddr
 *
 * @param {string} ip
 * @param {number|string} port
 */ function $a9e1c0f7fc698263$var$ipPortToMultiaddr(ip, port) {
    if (typeof ip !== "string") throw $20Lm5(new Error(`invalid ip provided: ${ip}`), $a9e1c0f7fc698263$var$errors.ERR_INVALID_IP_PARAMETER);
    if (typeof port === "string") port = parseInt(port);
    if (isNaN(port)) throw $20Lm5(new Error(`invalid port provided: ${port}`), $a9e1c0f7fc698263$var$errors.ERR_INVALID_PORT_PARAMETER);
    try {
        // Test valid IPv4
        new $a9e1c0f7fc698263$require$Address4(ip) // eslint-disable-line no-new
        ;
        return new $a9e1c0f7fc698263$require$Multiaddr(`/ip4/${ip}/tcp/${port}`);
    } catch  {}
    try {
        // Test valid IPv6
        const ip6 = new $a9e1c0f7fc698263$require$Address6(ip);
        return ip6.is4() ? new $a9e1c0f7fc698263$require$Multiaddr(`/ip4/${ip6.to4().correctForm()}/tcp/${port}`) : new $a9e1c0f7fc698263$require$Multiaddr(`/ip6/${ip}/tcp/${port}`);
    } catch (err) {
        const errMsg = `invalid ip:port for creating a multiaddr: ${ip}:${port}`;
        $a9e1c0f7fc698263$var$log.error(errMsg);
        throw $20Lm5(new Error(errMsg), $a9e1c0f7fc698263$var$errors.ERR_INVALID_IP);
    }
}
module.exports = $a9e1c0f7fc698263$var$ipPortToMultiaddr;
module.exports.Errors = $a9e1c0f7fc698263$var$errors;

});
parcelRequire.register("5pm7R", function(module, exports) {

$parcel$export(module.exports, "Address4", () => (parcelRequire("2ncQg")).Address4);
$parcel$export(module.exports, "Address6", () => (parcelRequire("fHkx6")).Address6);

var $2ncQg = parcelRequire("2ncQg");

var $fHkx6 = parcelRequire("fHkx6");

var $dOJdc = parcelRequire("dOJdc");

var $aXjPZ = parcelRequire("aXjPZ");
const $3f0073472aa7087e$export$81ac2a82f65cb090 = {
    helpers: $aXjPZ
};

});
parcelRequire.register("2ncQg", function(module, exports) {

$parcel$export(module.exports, "Address4", () => $1ba7b0e0d979af9f$export$603223336f6bcf12);
/* eslint-disable no-param-reassign */ 
var $bb87p = parcelRequire("bb87p");

var $bjVKo = parcelRequire("bjVKo");

var $dOJdc = parcelRequire("dOJdc");

var $k1YHG = parcelRequire("k1YHG");

var $lPVyw = parcelRequire("lPVyw");
class $1ba7b0e0d979af9f$export$603223336f6bcf12 {
    constructor(address){
        this.groups = $bjVKo.GROUPS;
        this.parsedAddress = [];
        this.parsedSubnet = "";
        this.subnet = "/32";
        this.subnetMask = 32;
        this.v4 = true;
        /**
         * Returns true if the address is correct, false otherwise
         * @memberof Address4
         * @instance
         * @returns {Boolean}
         */ this.isCorrect = $bb87p.isCorrect($bjVKo.BITS);
        /**
         * Returns true if the given address is in the subnet of the current address
         * @memberof Address4
         * @instance
         * @returns {boolean}
         */ this.isInSubnet = $bb87p.isInSubnet;
        this.address = address;
        const subnet = $bjVKo.RE_SUBNET_STRING.exec(address);
        if (subnet) {
            this.parsedSubnet = subnet[0].replace("/", "");
            this.subnetMask = parseInt(this.parsedSubnet, 10);
            this.subnet = `/${this.subnetMask}`;
            if (this.subnetMask < 0 || this.subnetMask > $bjVKo.BITS) throw new (0, $dOJdc.AddressError)("Invalid subnet mask.");
            address = address.replace($bjVKo.RE_SUBNET_STRING, "");
        }
        this.addressMinusSuffix = address;
        this.parsedAddress = this.parse(address);
    }
    static isValid(address) {
        try {
            // eslint-disable-next-line no-new
            new $1ba7b0e0d979af9f$export$603223336f6bcf12(address);
            return true;
        } catch (e) {
            return false;
        }
    }
    /*
     * Parses a v4 address
     */ parse(address) {
        const groups = address.split(".");
        if (!address.match($bjVKo.RE_ADDRESS)) throw new (0, $dOJdc.AddressError)("Invalid IPv4 address.");
        return groups;
    }
    /**
     * Returns the correct form of an address
     * @memberof Address4
     * @instance
     * @returns {String}
     */ correctForm() {
        return this.parsedAddress.map((part)=>parseInt(part, 10)).join(".");
    }
    /**
     * Converts a hex string to an IPv4 address object
     * @memberof Address4
     * @static
     * @param {string} hex - a hex string to convert
     * @returns {Address4}
     */ static fromHex(hex) {
        const padded = hex.replace(/:/g, "").padStart(8, "0");
        const groups = [];
        let i;
        for(i = 0; i < 8; i += 2){
            const h = padded.slice(i, i + 2);
            groups.push(parseInt(h, 16));
        }
        return new $1ba7b0e0d979af9f$export$603223336f6bcf12(groups.join("."));
    }
    /**
     * Converts an integer into a IPv4 address object
     * @memberof Address4
     * @static
     * @param {integer} integer - a number to convert
     * @returns {Address4}
     */ static fromInteger(integer) {
        return $1ba7b0e0d979af9f$export$603223336f6bcf12.fromHex(integer.toString(16));
    }
    /**
     * Return an address from in-addr.arpa form
     * @memberof Address4
     * @static
     * @param {string} arpaFormAddress - an 'in-addr.arpa' form ipv4 address
     * @returns {Adress4}
     * @example
     * var address = Address4.fromArpa(42.2.0.192.in-addr.arpa.)
     * address.correctForm(); // '192.0.2.42'
     */ static fromArpa(arpaFormAddress) {
        // remove ending ".in-addr.arpa." or just "."
        const leader = arpaFormAddress.replace(/(\.in-addr\.arpa)?\.$/, "");
        const address = leader.split(".").reverse().join(".");
        return new $1ba7b0e0d979af9f$export$603223336f6bcf12(address);
    }
    /**
     * Converts an IPv4 address object to a hex string
     * @memberof Address4
     * @instance
     * @returns {String}
     */ toHex() {
        return this.parsedAddress.map((part)=>(0, $lPVyw.sprintf)("%02x", parseInt(part, 10))).join(":");
    }
    /**
     * Converts an IPv4 address object to an array of bytes
     * @memberof Address4
     * @instance
     * @returns {Array}
     */ toArray() {
        return this.parsedAddress.map((part)=>parseInt(part, 10));
    }
    /**
     * Converts an IPv4 address object to an IPv6 address group
     * @memberof Address4
     * @instance
     * @returns {String}
     */ toGroup6() {
        const output = [];
        let i;
        for(i = 0; i < $bjVKo.GROUPS; i += 2){
            const hex = (0, $lPVyw.sprintf)("%02x%02x", parseInt(this.parsedAddress[i], 10), parseInt(this.parsedAddress[i + 1], 10));
            output.push((0, $lPVyw.sprintf)("%x", parseInt(hex, 16)));
        }
        return output.join(":");
    }
    /**
     * Returns the address as a BigInteger
     * @memberof Address4
     * @instance
     * @returns {BigInteger}
     */ bigInteger() {
        return new (0, $k1YHG.BigInteger)(this.parsedAddress.map((n)=>(0, $lPVyw.sprintf)("%02x", parseInt(n, 10))).join(""), 16);
    }
    /**
     * Helper function getting start address.
     * @memberof Address4
     * @instance
     * @returns {BigInteger}
     */ _startAddress() {
        return new (0, $k1YHG.BigInteger)(this.mask() + "0".repeat($bjVKo.BITS - this.subnetMask), 2);
    }
    /**
     * The first address in the range given by this address' subnet.
     * Often referred to as the Network Address.
     * @memberof Address4
     * @instance
     * @returns {Address4}
     */ startAddress() {
        return $1ba7b0e0d979af9f$export$603223336f6bcf12.fromBigInteger(this._startAddress());
    }
    /**
     * The first host address in the range given by this address's subnet ie
     * the first address after the Network Address
     * @memberof Address4
     * @instance
     * @returns {Address4}
     */ startAddressExclusive() {
        const adjust = new (0, $k1YHG.BigInteger)("1");
        return $1ba7b0e0d979af9f$export$603223336f6bcf12.fromBigInteger(this._startAddress().add(adjust));
    }
    /**
     * Helper function getting end address.
     * @memberof Address4
     * @instance
     * @returns {BigInteger}
     */ _endAddress() {
        return new (0, $k1YHG.BigInteger)(this.mask() + "1".repeat($bjVKo.BITS - this.subnetMask), 2);
    }
    /**
     * The last address in the range given by this address' subnet
     * Often referred to as the Broadcast
     * @memberof Address4
     * @instance
     * @returns {Address4}
     */ endAddress() {
        return $1ba7b0e0d979af9f$export$603223336f6bcf12.fromBigInteger(this._endAddress());
    }
    /**
     * The last host address in the range given by this address's subnet ie
     * the last address prior to the Broadcast Address
     * @memberof Address4
     * @instance
     * @returns {Address4}
     */ endAddressExclusive() {
        const adjust = new (0, $k1YHG.BigInteger)("1");
        return $1ba7b0e0d979af9f$export$603223336f6bcf12.fromBigInteger(this._endAddress().subtract(adjust));
    }
    /**
     * Converts a BigInteger to a v4 address object
     * @memberof Address4
     * @static
     * @param {BigInteger} bigInteger - a BigInteger to convert
     * @returns {Address4}
     */ static fromBigInteger(bigInteger) {
        return $1ba7b0e0d979af9f$export$603223336f6bcf12.fromInteger(parseInt(bigInteger.toString(), 10));
    }
    /**
     * Returns the first n bits of the address, defaulting to the
     * subnet mask
     * @memberof Address4
     * @instance
     * @returns {String}
     */ mask(mask) {
        if (mask === undefined) mask = this.subnetMask;
        return this.getBitsBase2(0, mask);
    }
    /**
     * Returns the bits in the given range as a base-2 string
     * @memberof Address4
     * @instance
     * @returns {string}
     */ getBitsBase2(start, end) {
        return this.binaryZeroPad().slice(start, end);
    }
    /**
     * Return the reversed ip6.arpa form of the address
     * @memberof Address4
     * @param {Object} options
     * @param {boolean} options.omitSuffix - omit the "in-addr.arpa" suffix
     * @instance
     * @returns {String}
     */ reverseForm(options) {
        if (!options) options = {};
        const reversed = this.correctForm().split(".").reverse().join(".");
        if (options.omitSuffix) return reversed;
        return (0, $lPVyw.sprintf)("%s.in-addr.arpa.", reversed);
    }
    /**
     * Returns true if the given address is a multicast address
     * @memberof Address4
     * @instance
     * @returns {boolean}
     */ isMulticast() {
        return this.isInSubnet(new $1ba7b0e0d979af9f$export$603223336f6bcf12("224.0.0.0/4"));
    }
    /**
     * Returns a zero-padded base-2 string representation of the address
     * @memberof Address4
     * @instance
     * @returns {string}
     */ binaryZeroPad() {
        return this.bigInteger().toString(2).padStart($bjVKo.BITS, "0");
    }
    /**
     * Groups an IPv4 address for inclusion at the end of an IPv6 address
     * @returns {String}
     */ groupForV6() {
        const segments = this.parsedAddress;
        return this.address.replace($bjVKo.RE_ADDRESS, (0, $lPVyw.sprintf)('<span class="hover-group group-v4 group-6">%s</span>.<span class="hover-group group-v4 group-7">%s</span>', segments.slice(0, 2).join("."), segments.slice(2, 4).join(".")));
    }
}

});
parcelRequire.register("bb87p", function(module, exports) {

$parcel$export(module.exports, "isInSubnet", () => $823704f96f032b85$export$1875986157ce9896);
$parcel$export(module.exports, "isCorrect", () => $823704f96f032b85$export$690755d01411b487);
function $823704f96f032b85$export$1875986157ce9896(address) {
    if (this.subnetMask < address.subnetMask) return false;
    if (this.mask(address.subnetMask) === address.mask()) return true;
    return false;
}
function $823704f96f032b85$export$690755d01411b487(defaultBits) {
    return function() {
        if (this.addressMinusSuffix !== this.correctForm()) return false;
        if (this.subnetMask === defaultBits && !this.parsedSubnet) return true;
        return this.parsedSubnet === String(this.subnetMask);
    };
}

});

parcelRequire.register("bjVKo", function(module, exports) {

$parcel$export(module.exports, "BITS", () => $83de437722340880$export$7668498dc56e7407);
$parcel$export(module.exports, "GROUPS", () => $83de437722340880$export$e55a77427f2a49c5);
$parcel$export(module.exports, "RE_ADDRESS", () => $83de437722340880$export$9349c57d095b41c9);
$parcel$export(module.exports, "RE_SUBNET_STRING", () => $83de437722340880$export$dcb0d7c78b7346c1);
const $83de437722340880$export$7668498dc56e7407 = 32;
const $83de437722340880$export$e55a77427f2a49c5 = 4;
const $83de437722340880$export$9349c57d095b41c9 = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/g;
const $83de437722340880$export$dcb0d7c78b7346c1 = /\/\d{1,2}$/;

});

parcelRequire.register("dOJdc", function(module, exports) {

$parcel$export(module.exports, "AddressError", () => $a0f303ff510322fa$export$804a92ba667853be);
class $a0f303ff510322fa$export$804a92ba667853be extends Error {
    constructor(message, parseMessage){
        super(message);
        this.name = "AddressError";
        if (parseMessage !== null) this.parseMessage = parseMessage;
    }
}

});

parcelRequire.register("k1YHG", function(module, exports) {
(function() {
    // Copyright (c) 2005  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.
    // Basic JavaScript BN library - subset useful for RSA encryption.
    // Bits per digit
    var dbits;
    // JavaScript engine analysis
    var canary = 0xdeadbeefcafe;
    var j_lm = (canary & 0xffffff) == 0xefcafe;
    // (public) Constructor
    function BigInteger(a, b, c) {
        if (a != null) {
            if ("number" == typeof a) this.fromNumber(a, b, c);
            else if (b == null && "string" != typeof a) this.fromString(a, 256);
            else this.fromString(a, b);
        }
    }
    // return new, unset BigInteger
    function nbi() {
        return new BigInteger(null);
    }
    // am: Compute w_j += (x*this_i), propagate carries,
    // c is initial carry, returns final carry.
    // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
    // We need to select the fastest one that works in this environment.
    // am1: use a single mult and divide to get the high bits,
    // max digit bits should be 26 because
    // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
    function am1(i, x, w, j, c, n) {
        while(--n >= 0){
            var v = x * this[i++] + w[j] + c;
            c = Math.floor(v / 0x4000000);
            w[j++] = v & 0x3ffffff;
        }
        return c;
    }
    // am2 avoids a big mult-and-extract completely.
    // Max digit bits should be <= 30 because we do bitwise ops
    // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
    function am2(i, x, w, j, c, n) {
        var xl = x & 0x7fff, xh = x >> 15;
        while(--n >= 0){
            var l = this[i] & 0x7fff;
            var h = this[i++] >> 15;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
            c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
            w[j++] = l & 0x3fffffff;
        }
        return c;
    }
    // Alternately, set max digit bits to 28 since some
    // browsers slow down when dealing with 32-bit numbers.
    function am3(i, x, w, j, c, n) {
        var xl = x & 0x3fff, xh = x >> 14;
        while(--n >= 0){
            var l = this[i] & 0x3fff;
            var h = this[i++] >> 14;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
            c = (l >> 28) + (m >> 14) + xh * h;
            w[j++] = l & 0xfffffff;
        }
        return c;
    }
    var inBrowser = typeof navigator !== "undefined";
    if (inBrowser && j_lm && navigator.appName == "Microsoft Internet Explorer") {
        BigInteger.prototype.am = am2;
        dbits = 30;
    } else if (inBrowser && j_lm && navigator.appName != "Netscape") {
        BigInteger.prototype.am = am1;
        dbits = 26;
    } else {
        BigInteger.prototype.am = am3;
        dbits = 28;
    }
    BigInteger.prototype.DB = dbits;
    BigInteger.prototype.DM = (1 << dbits) - 1;
    BigInteger.prototype.DV = 1 << dbits;
    var BI_FP = 52;
    BigInteger.prototype.FV = Math.pow(2, BI_FP);
    BigInteger.prototype.F1 = BI_FP - dbits;
    BigInteger.prototype.F2 = 2 * dbits - BI_FP;
    // Digit conversions
    var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
    var BI_RC = new Array();
    var rr, vv;
    rr = "0".charCodeAt(0);
    for(vv = 0; vv <= 9; ++vv)BI_RC[rr++] = vv;
    rr = "a".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
    rr = "A".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
    function int2char(n) {
        return BI_RM.charAt(n);
    }
    function intAt(s, i) {
        var c = BI_RC[s.charCodeAt(i)];
        return c == null ? -1 : c;
    }
    // (protected) copy this to r
    function bnpCopyTo(r) {
        for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
        r.t = this.t;
        r.s = this.s;
    }
    // (protected) set from integer value x, -DV <= x < DV
    function bnpFromInt(x) {
        this.t = 1;
        this.s = x < 0 ? -1 : 0;
        if (x > 0) this[0] = x;
        else if (x < -1) this[0] = x + this.DV;
        else this.t = 0;
    }
    // return bigint initialized to value
    function nbv(i) {
        var r = nbi();
        r.fromInt(i);
        return r;
    }
    // (protected) set from string and radix
    function bnpFromString(s, b) {
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 256) k = 8; // byte array
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else {
            this.fromRadix(s, b);
            return;
        }
        this.t = 0;
        this.s = 0;
        var i = s.length, mi = false, sh = 0;
        while(--i >= 0){
            var x = k == 8 ? s[i] & 0xff : intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-") mi = true;
                continue;
            }
            mi = false;
            if (sh == 0) this[this.t++] = x;
            else if (sh + k > this.DB) {
                this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
                this[this.t++] = x >> this.DB - sh;
            } else this[this.t - 1] |= x << sh;
            sh += k;
            if (sh >= this.DB) sh -= this.DB;
        }
        if (k == 8 && (s[0] & 0x80) != 0) {
            this.s = -1;
            if (sh > 0) this[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
        }
        this.clamp();
        if (mi) BigInteger.ZERO.subTo(this, this);
    }
    // (protected) clamp off excess high words
    function bnpClamp() {
        var c = this.s & this.DM;
        while(this.t > 0 && this[this.t - 1] == c)--this.t;
    }
    // (public) return string representation in given radix
    function bnToString(b) {
        if (this.s < 0) return "-" + this.negate().toString(b);
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else return this.toRadix(b);
        var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
        var p = this.DB - i * this.DB % k;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) > 0) {
                m = true;
                r = int2char(d);
            }
            while(i >= 0){
                if (p < k) {
                    d = (this[i] & (1 << p) - 1) << k - p;
                    d |= this[--i] >> (p += this.DB - k);
                } else {
                    d = this[i] >> (p -= k) & km;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if (d > 0) m = true;
                if (m) r += int2char(d);
            }
        }
        return m ? r : "0";
    }
    // (public) -this
    function bnNegate() {
        var r = nbi();
        BigInteger.ZERO.subTo(this, r);
        return r;
    }
    // (public) |this|
    function bnAbs() {
        return this.s < 0 ? this.negate() : this;
    }
    // (public) return + if this > a, - if this < a, 0 if equal
    function bnCompareTo(a) {
        var r = this.s - a.s;
        if (r != 0) return r;
        var i = this.t;
        r = i - a.t;
        if (r != 0) return this.s < 0 ? -r : r;
        while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
        return 0;
    }
    // returns bit length of the integer x
    function nbits(x) {
        var r = 1, t;
        if ((t = x >>> 16) != 0) {
            x = t;
            r += 16;
        }
        if ((t = x >> 8) != 0) {
            x = t;
            r += 8;
        }
        if ((t = x >> 4) != 0) {
            x = t;
            r += 4;
        }
        if ((t = x >> 2) != 0) {
            x = t;
            r += 2;
        }
        if ((t = x >> 1) != 0) {
            x = t;
            r += 1;
        }
        return r;
    }
    // (public) return the number of bits in "this"
    function bnBitLength() {
        if (this.t <= 0) return 0;
        return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
    }
    // (protected) r = this << n*DB
    function bnpDLShiftTo(n, r) {
        var i;
        for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
        for(i = n - 1; i >= 0; --i)r[i] = 0;
        r.t = this.t + n;
        r.s = this.s;
    }
    // (protected) r = this >> n*DB
    function bnpDRShiftTo(n, r) {
        for(var i = n; i < this.t; ++i)r[i - n] = this[i];
        r.t = Math.max(this.t - n, 0);
        r.s = this.s;
    }
    // (protected) r = this << n
    function bnpLShiftTo(n, r) {
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << cbs) - 1;
        var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
        for(i = this.t - 1; i >= 0; --i){
            r[i + ds + 1] = this[i] >> cbs | c;
            c = (this[i] & bm) << bs;
        }
        for(i = ds - 1; i >= 0; --i)r[i] = 0;
        r[ds] = c;
        r.t = this.t + ds + 1;
        r.s = this.s;
        r.clamp();
    }
    // (protected) r = this >> n
    function bnpRShiftTo(n, r) {
        r.s = this.s;
        var ds = Math.floor(n / this.DB);
        if (ds >= this.t) {
            r.t = 0;
            return;
        }
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << bs) - 1;
        r[0] = this[ds] >> bs;
        for(var i = ds + 1; i < this.t; ++i){
            r[i - ds - 1] |= (this[i] & bm) << cbs;
            r[i - ds] = this[i] >> bs;
        }
        if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
        r.t = this.t - ds;
        r.clamp();
    }
    // (protected) r = this - a
    function bnpSubTo(a, r) {
        var i = 0, c = 0, m = Math.min(a.t, this.t);
        while(i < m){
            c += this[i] - a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c -= a.s;
            while(i < this.t){
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        } else {
            c += this.s;
            while(i < a.t){
                c -= a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c -= a.s;
        }
        r.s = c < 0 ? -1 : 0;
        if (c < -1) r[i++] = this.DV + c;
        else if (c > 0) r[i++] = c;
        r.t = i;
        r.clamp();
    }
    // (protected) r = this * a, r != this,a (HAC 14.12)
    // "this" should be the larger one if appropriate.
    function bnpMultiplyTo(a, r) {
        var x = this.abs(), y = a.abs();
        var i = x.t;
        r.t = i + y.t;
        while(--i >= 0)r[i] = 0;
        for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
        r.s = 0;
        r.clamp();
        if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
    }
    // (protected) r = this^2, r != this (HAC 14.16)
    function bnpSquareTo(r) {
        var x = this.abs();
        var i = r.t = 2 * x.t;
        while(--i >= 0)r[i] = 0;
        for(i = 0; i < x.t - 1; ++i){
            var c = x.am(i, x[i], r, 2 * i, 0, 1);
            if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
                r[i + x.t] -= x.DV;
                r[i + x.t + 1] = 1;
            }
        }
        if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
        r.s = 0;
        r.clamp();
    }
    // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
    // r != q, this != m.  q or r may be null.
    function bnpDivRemTo(m, q, r) {
        var pm = m.abs();
        if (pm.t <= 0) return;
        var pt = this.abs();
        if (pt.t < pm.t) {
            if (q != null) q.fromInt(0);
            if (r != null) this.copyTo(r);
            return;
        }
        if (r == null) r = nbi();
        var y = nbi(), ts = this.s, ms = m.s;
        var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus
        if (nsh > 0) {
            pm.lShiftTo(nsh, y);
            pt.lShiftTo(nsh, r);
        } else {
            pm.copyTo(y);
            pt.copyTo(r);
        }
        var ys = y.t;
        var y0 = y[ys - 1];
        if (y0 == 0) return;
        var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
        var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
        var i = r.t, j = i - ys, t = q == null ? nbi() : q;
        y.dlShiftTo(j, t);
        if (r.compareTo(t) >= 0) {
            r[r.t++] = 1;
            r.subTo(t, r);
        }
        BigInteger.ONE.dlShiftTo(ys, t);
        t.subTo(y, y); // "negative" y so we can replace sub with am later
        while(y.t < ys)y[y.t++] = 0;
        while(--j >= 0){
            // Estimate quotient digit
            var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
            if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
                y.dlShiftTo(j, t);
                r.subTo(t, r);
                while(r[i] < --qd)r.subTo(t, r);
            }
        }
        if (q != null) {
            r.drShiftTo(ys, q);
            if (ts != ms) BigInteger.ZERO.subTo(q, q);
        }
        r.t = ys;
        r.clamp();
        if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
        if (ts < 0) BigInteger.ZERO.subTo(r, r);
    }
    // (public) this mod a
    function bnMod(a) {
        var r = nbi();
        this.abs().divRemTo(a, null, r);
        if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
        return r;
    }
    // Modular reduction using "classic" algorithm
    function Classic(m) {
        this.m = m;
    }
    function cConvert(x) {
        if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
        else return x;
    }
    function cRevert(x) {
        return x;
    }
    function cReduce(x) {
        x.divRemTo(this.m, null, x);
    }
    function cMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    function cSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    Classic.prototype.convert = cConvert;
    Classic.prototype.revert = cRevert;
    Classic.prototype.reduce = cReduce;
    Classic.prototype.mulTo = cMulTo;
    Classic.prototype.sqrTo = cSqrTo;
    // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
    // justification:
    //         xy == 1 (mod m)
    //         xy =  1+km
    //   xy(2-xy) = (1+km)(1-km)
    // x[y(2-xy)] = 1-k^2m^2
    // x[y(2-xy)] == 1 (mod m^2)
    // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
    // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
    // JS multiply "overflows" differently from C/C++, so care is needed here.
    function bnpInvDigit() {
        if (this.t < 1) return 0;
        var x = this[0];
        if ((x & 1) == 0) return 0;
        var y = x & 3; // y == 1/x mod 2^2
        y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
        y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
        y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
        // last step - calculate inverse mod DV directly;
        // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
        y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
        // we really want the negative inverse, and -DV < y < DV
        return y > 0 ? this.DV - y : -y;
    }
    // Montgomery reduction
    function Montgomery(m) {
        this.m = m;
        this.mp = m.invDigit();
        this.mpl = this.mp & 0x7fff;
        this.mph = this.mp >> 15;
        this.um = (1 << m.DB - 15) - 1;
        this.mt2 = 2 * m.t;
    }
    // xR mod m
    function montConvert(x) {
        var r = nbi();
        x.abs().dlShiftTo(this.m.t, r);
        r.divRemTo(this.m, null, r);
        if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
        return r;
    }
    // x/R mod m
    function montRevert(x) {
        var r = nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    }
    // x = x/R mod m (HAC 14.32)
    function montReduce(x) {
        while(x.t <= this.mt2)x[x.t++] = 0;
        for(var i = 0; i < this.m.t; ++i){
            // faster way of calculating u0 = x[i]*mp mod DV
            var j = x[i] & 0x7fff;
            var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
            // use am to combine the multiply-shift-add into one call
            j = i + this.m.t;
            x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
            // propagate carry
            while(x[j] >= x.DV){
                x[j] -= x.DV;
                x[++j]++;
            }
        }
        x.clamp();
        x.drShiftTo(this.m.t, x);
        if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
    }
    // r = "x^2/R mod m"; x != r
    function montSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    // r = "xy/R mod m"; x,y != r
    function montMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    Montgomery.prototype.convert = montConvert;
    Montgomery.prototype.revert = montRevert;
    Montgomery.prototype.reduce = montReduce;
    Montgomery.prototype.mulTo = montMulTo;
    Montgomery.prototype.sqrTo = montSqrTo;
    // (protected) true iff this is even
    function bnpIsEven() {
        return (this.t > 0 ? this[0] & 1 : this.s) == 0;
    }
    // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
    function bnpExp(e, z) {
        if (e > 0xffffffff || e < 1) return BigInteger.ONE;
        var r = nbi(), r2 = nbi(), g = z.convert(this), i = nbits(e) - 1;
        g.copyTo(r);
        while(--i >= 0){
            z.sqrTo(r, r2);
            if ((e & 1 << i) > 0) z.mulTo(r2, g, r);
            else {
                var t = r;
                r = r2;
                r2 = t;
            }
        }
        return z.revert(r);
    }
    // (public) this^e % m, 0 <= e < 2^32
    function bnModPowInt(e, m) {
        var z;
        if (e < 256 || m.isEven()) z = new Classic(m);
        else z = new Montgomery(m);
        return this.exp(e, z);
    }
    // protected
    BigInteger.prototype.copyTo = bnpCopyTo;
    BigInteger.prototype.fromInt = bnpFromInt;
    BigInteger.prototype.fromString = bnpFromString;
    BigInteger.prototype.clamp = bnpClamp;
    BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
    BigInteger.prototype.drShiftTo = bnpDRShiftTo;
    BigInteger.prototype.lShiftTo = bnpLShiftTo;
    BigInteger.prototype.rShiftTo = bnpRShiftTo;
    BigInteger.prototype.subTo = bnpSubTo;
    BigInteger.prototype.multiplyTo = bnpMultiplyTo;
    BigInteger.prototype.squareTo = bnpSquareTo;
    BigInteger.prototype.divRemTo = bnpDivRemTo;
    BigInteger.prototype.invDigit = bnpInvDigit;
    BigInteger.prototype.isEven = bnpIsEven;
    BigInteger.prototype.exp = bnpExp;
    // public
    BigInteger.prototype.toString = bnToString;
    BigInteger.prototype.negate = bnNegate;
    BigInteger.prototype.abs = bnAbs;
    BigInteger.prototype.compareTo = bnCompareTo;
    BigInteger.prototype.bitLength = bnBitLength;
    BigInteger.prototype.mod = bnMod;
    BigInteger.prototype.modPowInt = bnModPowInt;
    // "constants"
    BigInteger.ZERO = nbv(0);
    BigInteger.ONE = nbv(1);
    // Copyright (c) 2005-2009  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.
    // Extended JavaScript BN functions, required for RSA private ops.
    // Version 1.1: new BigInteger("0", 10) returns "proper" zero
    // Version 1.2: square() API, isProbablePrime fix
    // (public)
    function bnClone() {
        var r = nbi();
        this.copyTo(r);
        return r;
    }
    // (public) return value as integer
    function bnIntValue() {
        if (this.s < 0) {
            if (this.t == 1) return this[0] - this.DV;
            else if (this.t == 0) return -1;
        } else if (this.t == 1) return this[0];
        else if (this.t == 0) return 0;
        // assumes 16 < DB < 32
        return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
    }
    // (public) return value as byte
    function bnByteValue() {
        return this.t == 0 ? this.s : this[0] << 24 >> 24;
    }
    // (public) return value as short (assumes DB>=16)
    function bnShortValue() {
        return this.t == 0 ? this.s : this[0] << 16 >> 16;
    }
    // (protected) return x s.t. r^x < DV
    function bnpChunkSize(r) {
        return Math.floor(Math.LN2 * this.DB / Math.log(r));
    }
    // (public) 0 if this == 0, 1 if this > 0
    function bnSigNum() {
        if (this.s < 0) return -1;
        else if (this.t <= 0 || this.t == 1 && this[0] <= 0) return 0;
        else return 1;
    }
    // (protected) convert to radix string
    function bnpToRadix(b) {
        if (b == null) b = 10;
        if (this.signum() == 0 || b < 2 || b > 36) return "0";
        var cs = this.chunkSize(b);
        var a = Math.pow(b, cs);
        var d = nbv(a), y = nbi(), z = nbi(), r = "";
        this.divRemTo(d, y, z);
        while(y.signum() > 0){
            r = (a + z.intValue()).toString(b).substr(1) + r;
            y.divRemTo(d, y, z);
        }
        return z.intValue().toString(b) + r;
    }
    // (protected) convert from radix string
    function bnpFromRadix(s, b) {
        this.fromInt(0);
        if (b == null) b = 10;
        var cs = this.chunkSize(b);
        var d = Math.pow(b, cs), mi = false, j = 0, w = 0;
        for(var i = 0; i < s.length; ++i){
            var x = intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
                continue;
            }
            w = b * w + x;
            if (++j >= cs) {
                this.dMultiply(d);
                this.dAddOffset(w, 0);
                j = 0;
                w = 0;
            }
        }
        if (j > 0) {
            this.dMultiply(Math.pow(b, j));
            this.dAddOffset(w, 0);
        }
        if (mi) BigInteger.ZERO.subTo(this, this);
    }
    // (protected) alternate constructor
    function bnpFromNumber(a, b, c) {
        if ("number" == typeof b) {
            // new BigInteger(int,int,RNG)
            if (a < 2) this.fromInt(1);
            else {
                this.fromNumber(a, c);
                if (!this.testBit(a - 1)) this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
                if (this.isEven()) this.dAddOffset(1, 0); // force odd
                while(!this.isProbablePrime(b)){
                    this.dAddOffset(2, 0);
                    if (this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a - 1), this);
                }
            }
        } else {
            // new BigInteger(int,RNG)
            var x = new Array(), t = a & 7;
            x.length = (a >> 3) + 1;
            b.nextBytes(x);
            if (t > 0) x[0] &= (1 << t) - 1;
            else x[0] = 0;
            this.fromString(x, 256);
        }
    }
    // (public) convert to bigendian byte array
    function bnToByteArray() {
        var i = this.t, r = new Array();
        r[0] = this.s;
        var p = this.DB - i * this.DB % 8, d, k = 0;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;
            while(i >= 0){
                if (p < 8) {
                    d = (this[i] & (1 << p) - 1) << 8 - p;
                    d |= this[--i] >> (p += this.DB - 8);
                } else {
                    d = this[i] >> (p -= 8) & 0xff;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if ((d & 0x80) != 0) d |= -256;
                if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
                if (k > 0 || d != this.s) r[k++] = d;
            }
        }
        return r;
    }
    function bnEquals(a) {
        return this.compareTo(a) == 0;
    }
    function bnMin(a) {
        return this.compareTo(a) < 0 ? this : a;
    }
    function bnMax(a) {
        return this.compareTo(a) > 0 ? this : a;
    }
    // (protected) r = this op a (bitwise)
    function bnpBitwiseTo(a, op, r) {
        var i, f, m = Math.min(a.t, this.t);
        for(i = 0; i < m; ++i)r[i] = op(this[i], a[i]);
        if (a.t < this.t) {
            f = a.s & this.DM;
            for(i = m; i < this.t; ++i)r[i] = op(this[i], f);
            r.t = this.t;
        } else {
            f = this.s & this.DM;
            for(i = m; i < a.t; ++i)r[i] = op(f, a[i]);
            r.t = a.t;
        }
        r.s = op(this.s, a.s);
        r.clamp();
    }
    // (public) this & a
    function op_and(x, y) {
        return x & y;
    }
    function bnAnd(a) {
        var r = nbi();
        this.bitwiseTo(a, op_and, r);
        return r;
    }
    // (public) this | a
    function op_or(x, y) {
        return x | y;
    }
    function bnOr(a) {
        var r = nbi();
        this.bitwiseTo(a, op_or, r);
        return r;
    }
    // (public) this ^ a
    function op_xor(x, y) {
        return x ^ y;
    }
    function bnXor(a) {
        var r = nbi();
        this.bitwiseTo(a, op_xor, r);
        return r;
    }
    // (public) this & ~a
    function op_andnot(x, y) {
        return x & ~y;
    }
    function bnAndNot(a) {
        var r = nbi();
        this.bitwiseTo(a, op_andnot, r);
        return r;
    }
    // (public) ~this
    function bnNot() {
        var r = nbi();
        for(var i = 0; i < this.t; ++i)r[i] = this.DM & ~this[i];
        r.t = this.t;
        r.s = ~this.s;
        return r;
    }
    // (public) this << n
    function bnShiftLeft(n) {
        var r = nbi();
        if (n < 0) this.rShiftTo(-n, r);
        else this.lShiftTo(n, r);
        return r;
    }
    // (public) this >> n
    function bnShiftRight(n) {
        var r = nbi();
        if (n < 0) this.lShiftTo(-n, r);
        else this.rShiftTo(n, r);
        return r;
    }
    // return index of lowest 1-bit in x, x < 2^31
    function lbit(x) {
        if (x == 0) return -1;
        var r = 0;
        if ((x & 0xffff) == 0) {
            x >>= 16;
            r += 16;
        }
        if ((x & 0xff) == 0) {
            x >>= 8;
            r += 8;
        }
        if ((x & 0xf) == 0) {
            x >>= 4;
            r += 4;
        }
        if ((x & 3) == 0) {
            x >>= 2;
            r += 2;
        }
        if ((x & 1) == 0) ++r;
        return r;
    }
    // (public) returns index of lowest 1-bit (or -1 if none)
    function bnGetLowestSetBit() {
        for(var i = 0; i < this.t; ++i)if (this[i] != 0) return i * this.DB + lbit(this[i]);
        if (this.s < 0) return this.t * this.DB;
        return -1;
    }
    // return number of 1 bits in x
    function cbit(x) {
        var r = 0;
        while(x != 0){
            x &= x - 1;
            ++r;
        }
        return r;
    }
    // (public) return number of set bits
    function bnBitCount() {
        var r = 0, x = this.s & this.DM;
        for(var i = 0; i < this.t; ++i)r += cbit(this[i] ^ x);
        return r;
    }
    // (public) true iff nth bit is set
    function bnTestBit(n) {
        var j = Math.floor(n / this.DB);
        if (j >= this.t) return this.s != 0;
        return (this[j] & 1 << n % this.DB) != 0;
    }
    // (protected) this op (1<<n)
    function bnpChangeBit(n, op) {
        var r = BigInteger.ONE.shiftLeft(n);
        this.bitwiseTo(r, op, r);
        return r;
    }
    // (public) this | (1<<n)
    function bnSetBit(n) {
        return this.changeBit(n, op_or);
    }
    // (public) this & ~(1<<n)
    function bnClearBit(n) {
        return this.changeBit(n, op_andnot);
    }
    // (public) this ^ (1<<n)
    function bnFlipBit(n) {
        return this.changeBit(n, op_xor);
    }
    // (protected) r = this + a
    function bnpAddTo(a, r) {
        var i = 0, c = 0, m = Math.min(a.t, this.t);
        while(i < m){
            c += this[i] + a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c += a.s;
            while(i < this.t){
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        } else {
            c += this.s;
            while(i < a.t){
                c += a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += a.s;
        }
        r.s = c < 0 ? -1 : 0;
        if (c > 0) r[i++] = c;
        else if (c < -1) r[i++] = this.DV + c;
        r.t = i;
        r.clamp();
    }
    // (public) this + a
    function bnAdd(a) {
        var r = nbi();
        this.addTo(a, r);
        return r;
    }
    // (public) this - a
    function bnSubtract(a) {
        var r = nbi();
        this.subTo(a, r);
        return r;
    }
    // (public) this * a
    function bnMultiply(a) {
        var r = nbi();
        this.multiplyTo(a, r);
        return r;
    }
    // (public) this^2
    function bnSquare() {
        var r = nbi();
        this.squareTo(r);
        return r;
    }
    // (public) this / a
    function bnDivide(a) {
        var r = nbi();
        this.divRemTo(a, r, null);
        return r;
    }
    // (public) this % a
    function bnRemainder(a) {
        var r = nbi();
        this.divRemTo(a, null, r);
        return r;
    }
    // (public) [this/a,this%a]
    function bnDivideAndRemainder(a) {
        var q = nbi(), r = nbi();
        this.divRemTo(a, q, r);
        return new Array(q, r);
    }
    // (protected) this *= n, this >= 0, 1 < n < DV
    function bnpDMultiply(n) {
        this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
        ++this.t;
        this.clamp();
    }
    // (protected) this += n << w words, this >= 0
    function bnpDAddOffset(n, w) {
        if (n == 0) return;
        while(this.t <= w)this[this.t++] = 0;
        this[w] += n;
        while(this[w] >= this.DV){
            this[w] -= this.DV;
            if (++w >= this.t) this[this.t++] = 0;
            ++this[w];
        }
    }
    // A "null" reducer
    function NullExp() {}
    function nNop(x) {
        return x;
    }
    function nMulTo(x, y, r) {
        x.multiplyTo(y, r);
    }
    function nSqrTo(x, r) {
        x.squareTo(r);
    }
    NullExp.prototype.convert = nNop;
    NullExp.prototype.revert = nNop;
    NullExp.prototype.mulTo = nMulTo;
    NullExp.prototype.sqrTo = nSqrTo;
    // (public) this^e
    function bnPow(e) {
        return this.exp(e, new NullExp());
    }
    // (protected) r = lower n words of "this * a", a.t <= n
    // "this" should be the larger one if appropriate.
    function bnpMultiplyLowerTo(a, n, r) {
        var i = Math.min(this.t + a.t, n);
        r.s = 0; // assumes a,this >= 0
        r.t = i;
        while(i > 0)r[--i] = 0;
        var j;
        for(j = r.t - this.t; i < j; ++i)r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
        for(j = Math.min(a.t, n); i < j; ++i)this.am(0, a[i], r, i, 0, n - i);
        r.clamp();
    }
    // (protected) r = "this * a" without lower n words, n > 0
    // "this" should be the larger one if appropriate.
    function bnpMultiplyUpperTo(a, n, r) {
        --n;
        var i = r.t = this.t + a.t - n;
        r.s = 0; // assumes a,this >= 0
        while(--i >= 0)r[i] = 0;
        for(i = Math.max(n - this.t, 0); i < a.t; ++i)r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
        r.clamp();
        r.drShiftTo(1, r);
    }
    // Barrett modular reduction
    function Barrett(m) {
        // setup Barrett
        this.r2 = nbi();
        this.q3 = nbi();
        BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
        this.mu = this.r2.divide(m);
        this.m = m;
    }
    function barrettConvert(x) {
        if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
        else if (x.compareTo(this.m) < 0) return x;
        else {
            var r = nbi();
            x.copyTo(r);
            this.reduce(r);
            return r;
        }
    }
    function barrettRevert(x) {
        return x;
    }
    // x = x mod m (HAC 14.42)
    function barrettReduce(x) {
        x.drShiftTo(this.m.t - 1, this.r2);
        if (x.t > this.m.t + 1) {
            x.t = this.m.t + 1;
            x.clamp();
        }
        this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
        this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
        while(x.compareTo(this.r2) < 0)x.dAddOffset(1, this.m.t + 1);
        x.subTo(this.r2, x);
        while(x.compareTo(this.m) >= 0)x.subTo(this.m, x);
    }
    // r = x^2 mod m; x != r
    function barrettSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    // r = x*y mod m; x,y != r
    function barrettMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    Barrett.prototype.convert = barrettConvert;
    Barrett.prototype.revert = barrettRevert;
    Barrett.prototype.reduce = barrettReduce;
    Barrett.prototype.mulTo = barrettMulTo;
    Barrett.prototype.sqrTo = barrettSqrTo;
    // (public) this^e % m (HAC 14.85)
    function bnModPow(e, m) {
        var i = e.bitLength(), k, r = nbv(1), z;
        if (i <= 0) return r;
        else if (i < 18) k = 1;
        else if (i < 48) k = 3;
        else if (i < 144) k = 4;
        else if (i < 768) k = 5;
        else k = 6;
        if (i < 8) z = new Classic(m);
        else if (m.isEven()) z = new Barrett(m);
        else z = new Montgomery(m);
        // precomputation
        var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
        g[1] = z.convert(this);
        if (k > 1) {
            var g2 = nbi();
            z.sqrTo(g[1], g2);
            while(n <= km){
                g[n] = nbi();
                z.mulTo(g2, g[n - 2], g[n]);
                n += 2;
            }
        }
        var j = e.t - 1, w, is1 = true, r2 = nbi(), t;
        i = nbits(e[j]) - 1;
        while(j >= 0){
            if (i >= k1) w = e[j] >> i - k1 & km;
            else {
                w = (e[j] & (1 << i + 1) - 1) << k1 - i;
                if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
            }
            n = k;
            while((w & 1) == 0){
                w >>= 1;
                --n;
            }
            if ((i -= n) < 0) {
                i += this.DB;
                --j;
            }
            if (is1) {
                g[w].copyTo(r);
                is1 = false;
            } else {
                while(n > 1){
                    z.sqrTo(r, r2);
                    z.sqrTo(r2, r);
                    n -= 2;
                }
                if (n > 0) z.sqrTo(r, r2);
                else {
                    t = r;
                    r = r2;
                    r2 = t;
                }
                z.mulTo(r2, g[w], r);
            }
            while(j >= 0 && (e[j] & 1 << i) == 0){
                z.sqrTo(r, r2);
                t = r;
                r = r2;
                r2 = t;
                if (--i < 0) {
                    i = this.DB - 1;
                    --j;
                }
            }
        }
        return z.revert(r);
    }
    // (public) gcd(this,a) (HAC 14.54)
    function bnGCD(a) {
        var x = this.s < 0 ? this.negate() : this.clone();
        var y = a.s < 0 ? a.negate() : a.clone();
        if (x.compareTo(y) < 0) {
            var t = x;
            x = y;
            y = t;
        }
        var i = x.getLowestSetBit(), g = y.getLowestSetBit();
        if (g < 0) return x;
        if (i < g) g = i;
        if (g > 0) {
            x.rShiftTo(g, x);
            y.rShiftTo(g, y);
        }
        while(x.signum() > 0){
            if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
            if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
            if (x.compareTo(y) >= 0) {
                x.subTo(y, x);
                x.rShiftTo(1, x);
            } else {
                y.subTo(x, y);
                y.rShiftTo(1, y);
            }
        }
        if (g > 0) y.lShiftTo(g, y);
        return y;
    }
    // (protected) this % n, n < 2^26
    function bnpModInt(n) {
        if (n <= 0) return 0;
        var d = this.DV % n, r = this.s < 0 ? n - 1 : 0;
        if (this.t > 0) {
            if (d == 0) r = this[0] % n;
            else for(var i = this.t - 1; i >= 0; --i)r = (d * r + this[i]) % n;
        }
        return r;
    }
    // (public) 1/this % m (HAC 14.61)
    function bnModInverse(m) {
        var ac = m.isEven();
        if (this.isEven() && ac || m.signum() == 0) return BigInteger.ZERO;
        var u = m.clone(), v = this.clone();
        var a = nbv(1), b = nbv(0), c = nbv(0), d = nbv(1);
        while(u.signum() != 0){
            while(u.isEven()){
                u.rShiftTo(1, u);
                if (ac) {
                    if (!a.isEven() || !b.isEven()) {
                        a.addTo(this, a);
                        b.subTo(m, b);
                    }
                    a.rShiftTo(1, a);
                } else if (!b.isEven()) b.subTo(m, b);
                b.rShiftTo(1, b);
            }
            while(v.isEven()){
                v.rShiftTo(1, v);
                if (ac) {
                    if (!c.isEven() || !d.isEven()) {
                        c.addTo(this, c);
                        d.subTo(m, d);
                    }
                    c.rShiftTo(1, c);
                } else if (!d.isEven()) d.subTo(m, d);
                d.rShiftTo(1, d);
            }
            if (u.compareTo(v) >= 0) {
                u.subTo(v, u);
                if (ac) a.subTo(c, a);
                b.subTo(d, b);
            } else {
                v.subTo(u, v);
                if (ac) c.subTo(a, c);
                d.subTo(b, d);
            }
        }
        if (v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
        if (d.compareTo(m) >= 0) return d.subtract(m);
        if (d.signum() < 0) d.addTo(m, d);
        else return d;
        if (d.signum() < 0) return d.add(m);
        else return d;
    }
    var lowprimes = [
        2,
        3,
        5,
        7,
        11,
        13,
        17,
        19,
        23,
        29,
        31,
        37,
        41,
        43,
        47,
        53,
        59,
        61,
        67,
        71,
        73,
        79,
        83,
        89,
        97,
        101,
        103,
        107,
        109,
        113,
        127,
        131,
        137,
        139,
        149,
        151,
        157,
        163,
        167,
        173,
        179,
        181,
        191,
        193,
        197,
        199,
        211,
        223,
        227,
        229,
        233,
        239,
        241,
        251,
        257,
        263,
        269,
        271,
        277,
        281,
        283,
        293,
        307,
        311,
        313,
        317,
        331,
        337,
        347,
        349,
        353,
        359,
        367,
        373,
        379,
        383,
        389,
        397,
        401,
        409,
        419,
        421,
        431,
        433,
        439,
        443,
        449,
        457,
        461,
        463,
        467,
        479,
        487,
        491,
        499,
        503,
        509,
        521,
        523,
        541,
        547,
        557,
        563,
        569,
        571,
        577,
        587,
        593,
        599,
        601,
        607,
        613,
        617,
        619,
        631,
        641,
        643,
        647,
        653,
        659,
        661,
        673,
        677,
        683,
        691,
        701,
        709,
        719,
        727,
        733,
        739,
        743,
        751,
        757,
        761,
        769,
        773,
        787,
        797,
        809,
        811,
        821,
        823,
        827,
        829,
        839,
        853,
        857,
        859,
        863,
        877,
        881,
        883,
        887,
        907,
        911,
        919,
        929,
        937,
        941,
        947,
        953,
        967,
        971,
        977,
        983,
        991,
        997
    ];
    var lplim = 67108864 / lowprimes[lowprimes.length - 1];
    // (public) test primality with certainty >= 1-.5^t
    function bnIsProbablePrime(t) {
        var i, x = this.abs();
        if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
            for(i = 0; i < lowprimes.length; ++i)if (x[0] == lowprimes[i]) return true;
            return false;
        }
        if (x.isEven()) return false;
        i = 1;
        while(i < lowprimes.length){
            var m = lowprimes[i], j = i + 1;
            while(j < lowprimes.length && m < lplim)m *= lowprimes[j++];
            m = x.modInt(m);
            while(i < j)if (m % lowprimes[i++] == 0) return false;
        }
        return x.millerRabin(t);
    }
    // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
    function bnpMillerRabin(t) {
        var n1 = this.subtract(BigInteger.ONE);
        var k = n1.getLowestSetBit();
        if (k <= 0) return false;
        var r = n1.shiftRight(k);
        t = t + 1 >> 1;
        if (t > lowprimes.length) t = lowprimes.length;
        var a = nbi();
        for(var i = 0; i < t; ++i){
            //Pick bases at random, instead of starting at 2
            a.fromInt(lowprimes[Math.floor(Math.random() * lowprimes.length)]);
            var y = a.modPow(r, this);
            if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
                var j = 1;
                while(j++ < k && y.compareTo(n1) != 0){
                    y = y.modPowInt(2, this);
                    if (y.compareTo(BigInteger.ONE) == 0) return false;
                }
                if (y.compareTo(n1) != 0) return false;
            }
        }
        return true;
    }
    // protected
    BigInteger.prototype.chunkSize = bnpChunkSize;
    BigInteger.prototype.toRadix = bnpToRadix;
    BigInteger.prototype.fromRadix = bnpFromRadix;
    BigInteger.prototype.fromNumber = bnpFromNumber;
    BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
    BigInteger.prototype.changeBit = bnpChangeBit;
    BigInteger.prototype.addTo = bnpAddTo;
    BigInteger.prototype.dMultiply = bnpDMultiply;
    BigInteger.prototype.dAddOffset = bnpDAddOffset;
    BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
    BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
    BigInteger.prototype.modInt = bnpModInt;
    BigInteger.prototype.millerRabin = bnpMillerRabin;
    // public
    BigInteger.prototype.clone = bnClone;
    BigInteger.prototype.intValue = bnIntValue;
    BigInteger.prototype.byteValue = bnByteValue;
    BigInteger.prototype.shortValue = bnShortValue;
    BigInteger.prototype.signum = bnSigNum;
    BigInteger.prototype.toByteArray = bnToByteArray;
    BigInteger.prototype.equals = bnEquals;
    BigInteger.prototype.min = bnMin;
    BigInteger.prototype.max = bnMax;
    BigInteger.prototype.and = bnAnd;
    BigInteger.prototype.or = bnOr;
    BigInteger.prototype.xor = bnXor;
    BigInteger.prototype.andNot = bnAndNot;
    BigInteger.prototype.not = bnNot;
    BigInteger.prototype.shiftLeft = bnShiftLeft;
    BigInteger.prototype.shiftRight = bnShiftRight;
    BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
    BigInteger.prototype.bitCount = bnBitCount;
    BigInteger.prototype.testBit = bnTestBit;
    BigInteger.prototype.setBit = bnSetBit;
    BigInteger.prototype.clearBit = bnClearBit;
    BigInteger.prototype.flipBit = bnFlipBit;
    BigInteger.prototype.add = bnAdd;
    BigInteger.prototype.subtract = bnSubtract;
    BigInteger.prototype.multiply = bnMultiply;
    BigInteger.prototype.divide = bnDivide;
    BigInteger.prototype.remainder = bnRemainder;
    BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
    BigInteger.prototype.modPow = bnModPow;
    BigInteger.prototype.modInverse = bnModInverse;
    BigInteger.prototype.pow = bnPow;
    BigInteger.prototype.gcd = bnGCD;
    BigInteger.prototype.isProbablePrime = bnIsProbablePrime;
    // JSBN-specific extension
    BigInteger.prototype.square = bnSquare;
    // Expose the Barrett function
    BigInteger.prototype.Barrett = Barrett;
    // BigInteger interfaces not implemented in jsbn:
    // BigInteger(int signum, byte[] magnitude)
    // double doubleValue()
    // float floatValue()
    // int hashCode()
    // long longValue()
    // static BigInteger valueOf(long val)
    // Random number generator - requires a PRNG backend, e.g. prng4.js
    // For best results, put code like
    // <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>
    // in your main HTML document.
    var rng_state;
    var rng_pool;
    var rng_pptr;
    // Mix in a 32-bit integer into the pool
    function rng_seed_int(x) {
        rng_pool[rng_pptr++] ^= x & 255;
        rng_pool[rng_pptr++] ^= x >> 8 & 255;
        rng_pool[rng_pptr++] ^= x >> 16 & 255;
        rng_pool[rng_pptr++] ^= x >> 24 & 255;
        if (rng_pptr >= rng_psize) rng_pptr -= rng_psize;
    }
    // Mix in the current time (w/milliseconds) into the pool
    function rng_seed_time() {
        rng_seed_int(new Date().getTime());
    }
    // Initialize the pool with junk if needed.
    if (rng_pool == null) {
        rng_pool = new Array();
        rng_pptr = 0;
        var t;
        if (typeof window !== "undefined" && window.crypto) {
            if (window.crypto.getRandomValues) {
                // Use webcrypto if available
                var ua = new Uint8Array(32);
                window.crypto.getRandomValues(ua);
                for(t = 0; t < 32; ++t)rng_pool[rng_pptr++] = ua[t];
            } else if (navigator.appName == "Netscape" && navigator.appVersion < "5") {
                // Extract entropy (256 bits) from NS4 RNG if available
                var z = window.crypto.random(32);
                for(t = 0; t < z.length; ++t)rng_pool[rng_pptr++] = z.charCodeAt(t) & 255;
            }
        }
        while(rng_pptr < rng_psize){
            t = Math.floor(65536 * Math.random());
            rng_pool[rng_pptr++] = t >>> 8;
            rng_pool[rng_pptr++] = t & 255;
        }
        rng_pptr = 0;
        rng_seed_time();
    //rng_seed_int(window.screenX);
    //rng_seed_int(window.screenY);
    }
    function rng_get_byte() {
        if (rng_state == null) {
            rng_seed_time();
            rng_state = prng_newstate();
            rng_state.init(rng_pool);
            for(rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr)rng_pool[rng_pptr] = 0;
            rng_pptr = 0;
        //rng_pool = null;
        }
        // TODO: allow reseeding after first request
        return rng_state.next();
    }
    function rng_get_bytes(ba) {
        var i;
        for(i = 0; i < ba.length; ++i)ba[i] = rng_get_byte();
    }
    function SecureRandom() {}
    SecureRandom.prototype.nextBytes = rng_get_bytes;
    // prng4.js - uses Arcfour as a PRNG
    function Arcfour() {
        this.i = 0;
        this.j = 0;
        this.S = new Array();
    }
    // Initialize arcfour context from key, an array of ints, each from [0..255]
    function ARC4init(key) {
        var i, j, t;
        for(i = 0; i < 256; ++i)this.S[i] = i;
        j = 0;
        for(i = 0; i < 256; ++i){
            j = j + this.S[i] + key[i % key.length] & 255;
            t = this.S[i];
            this.S[i] = this.S[j];
            this.S[j] = t;
        }
        this.i = 0;
        this.j = 0;
    }
    function ARC4next() {
        var t;
        this.i = this.i + 1 & 255;
        this.j = this.j + this.S[this.i] & 255;
        t = this.S[this.i];
        this.S[this.i] = this.S[this.j];
        this.S[this.j] = t;
        return this.S[t + this.S[this.i] & 255];
    }
    Arcfour.prototype.init = ARC4init;
    Arcfour.prototype.next = ARC4next;
    // Plug in your RNG constructor here
    function prng_newstate() {
        return new Arcfour();
    }
    // Pool size must be a multiple of 4 and greater than 32.
    // An array of bytes the size of the pool will be passed to init()
    var rng_psize = 256;
    exports = module.exports = {
        default: BigInteger,
        BigInteger: BigInteger,
        SecureRandom: SecureRandom
    };
}).call(this);

});

parcelRequire.register("lPVyw", function(module, exports) {

$parcel$export(module.exports, "sprintf", () => $fe5b01c78d25deb4$export$63151d8bb18a49f9, (v) => $fe5b01c78d25deb4$export$63151d8bb18a49f9 = v);
/* global window, exports, define */ var $fe5b01c78d25deb4$export$63151d8bb18a49f9;
var $fe5b01c78d25deb4$export$790fb69b1a2884f9;
!function() {
    "use strict";
    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    };
    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments);
    }
    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [
            fmt
        ].concat(argv || []));
    }
    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = "", i, k, ph, pad, pad_character, pad_length, is_positive, sign;
        for(i = 0; i < tree_length; i++){
            if (typeof parse_tree[i] === "string") output += parse_tree[i];
            else if (typeof parse_tree[i] === "object") {
                ph = parse_tree[i] // convenience purposes only
                ;
                if (ph.keys) {
                    arg = argv[cursor];
                    for(k = 0; k < ph.keys.length; k++){
                        if (arg == undefined) throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k - 1]));
                        arg = arg[ph.keys[k]];
                    }
                } else if (ph.param_no) arg = argv[ph.param_no];
                else arg = argv[cursor++];
                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) arg = arg();
                if (re.numeric_arg.test(ph.type) && typeof arg !== "number" && isNaN(arg)) throw new TypeError(sprintf("[sprintf] expecting number but found %T", arg));
                if (re.number.test(ph.type)) is_positive = arg >= 0;
                switch(ph.type){
                    case "b":
                        arg = parseInt(arg, 10).toString(2);
                        break;
                    case "c":
                        arg = String.fromCharCode(parseInt(arg, 10));
                        break;
                    case "d":
                    case "i":
                        arg = parseInt(arg, 10);
                        break;
                    case "j":
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0);
                        break;
                    case "e":
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential();
                        break;
                    case "f":
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg);
                        break;
                    case "g":
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg);
                        break;
                    case "o":
                        arg = (parseInt(arg, 10) >>> 0).toString(8);
                        break;
                    case "s":
                        arg = String(arg);
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "t":
                        arg = String(!!arg);
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "T":
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase();
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "u":
                        arg = parseInt(arg, 10) >>> 0;
                        break;
                    case "v":
                        arg = arg.valueOf();
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "x":
                        arg = (parseInt(arg, 10) >>> 0).toString(16);
                        break;
                    case "X":
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase();
                        break;
                }
                if (re.json.test(ph.type)) output += arg;
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? "+" : "-";
                        arg = arg.toString().replace(re.sign, "");
                    } else sign = "";
                    pad_character = ph.pad_char ? ph.pad_char === "0" ? "0" : ph.pad_char.charAt(1) : " ";
                    pad_length = ph.width - (sign + arg).length;
                    pad = ph.width ? pad_length > 0 ? pad_character.repeat(pad_length) : "" : "";
                    output += ph.align ? sign + arg + pad : pad_character === "0" ? sign + pad + arg : pad + sign + arg;
                }
            }
        }
        return output;
    }
    var sprintf_cache = Object.create(null);
    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) return sprintf_cache[fmt];
        var _fmt = fmt, match, parse_tree = [], arg_names = 0;
        while(_fmt){
            if ((match = re.text.exec(_fmt)) !== null) parse_tree.push(match[0]);
            else if ((match = re.modulo.exec(_fmt)) !== null) parse_tree.push("%");
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1;
                    var field_list = [], replacement_field = match[2], field_match = [];
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1]);
                        while((replacement_field = replacement_field.substring(field_match[0].length)) !== ""){
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else throw new SyntaxError("[sprintf] failed to parse named argument key");
                        }
                    } else throw new SyntaxError("[sprintf] failed to parse named argument key");
                    match[2] = field_list;
                } else arg_names |= 2;
                if (arg_names === 3) throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
                parse_tree.push({
                    placeholder: match[0],
                    param_no: match[1],
                    keys: match[2],
                    sign: match[3],
                    pad_char: match[4],
                    align: match[5],
                    width: match[6],
                    precision: match[7],
                    type: match[8]
                });
            } else throw new SyntaxError("[sprintf] unexpected placeholder");
            _fmt = _fmt.substring(match[0].length);
        }
        return sprintf_cache[fmt] = parse_tree;
    }
    $fe5b01c78d25deb4$export$63151d8bb18a49f9 = sprintf;
    $fe5b01c78d25deb4$export$790fb69b1a2884f9 = vsprintf;
    if (typeof window !== "undefined") {
        window["sprintf"] = sprintf;
        window["vsprintf"] = vsprintf;
        if (typeof define === "function" && define["amd"]) define(function() {
            return {
                "sprintf": sprintf,
                "vsprintf": vsprintf
            };
        });
    }
/* eslint-enable quote-props */ }(); // eslint-disable-line

});


parcelRequire.register("fHkx6", function(module, exports) {

$parcel$export(module.exports, "Address6", () => $b6dacc9263616fda$export$14b1a06ebde39888);
/* eslint-disable prefer-destructuring */ /* eslint-disable no-param-reassign */ 
var $bb87p = parcelRequire("bb87p");

var $bjVKo = parcelRequire("bjVKo");

var $eZzde = parcelRequire("eZzde");

var $aXjPZ = parcelRequire("aXjPZ");

var $2ncQg = parcelRequire("2ncQg");

var $b5wtN = parcelRequire("b5wtN");

var $dOJdc = parcelRequire("dOJdc");

var $k1YHG = parcelRequire("k1YHG");

var $lPVyw = parcelRequire("lPVyw");
function $b6dacc9263616fda$var$assert(condition) {
    if (!condition) throw new Error("Assertion failed.");
}
function $b6dacc9263616fda$var$addCommas(number) {
    const r = /(\d+)(\d{3})/;
    while(r.test(number))number = number.replace(r, "$1,$2");
    return number;
}
function $b6dacc9263616fda$var$spanLeadingZeroes4(n) {
    n = n.replace(/^(0{1,})([1-9]+)$/, '<span class="parse-error">$1</span>$2');
    n = n.replace(/^(0{1,})(0)$/, '<span class="parse-error">$1</span>$2');
    return n;
}
/*
 * A helper function to compact an array
 */ function $b6dacc9263616fda$var$compact(address, slice) {
    const s1 = [];
    const s2 = [];
    let i;
    for(i = 0; i < address.length; i++){
        if (i < slice[0]) s1.push(address[i]);
        else if (i > slice[1]) s2.push(address[i]);
    }
    return s1.concat([
        "compact"
    ]).concat(s2);
}
function $b6dacc9263616fda$var$paddedHex(octet) {
    return (0, $lPVyw.sprintf)("%04x", parseInt(octet, 16));
}
function $b6dacc9263616fda$var$unsignByte(b) {
    // eslint-disable-next-line no-bitwise
    return b & 0xff;
}
class $b6dacc9263616fda$export$14b1a06ebde39888 {
    constructor(address, optionalGroups){
        this.addressMinusSuffix = "";
        this.parsedSubnet = "";
        this.subnet = "/128";
        this.subnetMask = 128;
        this.v4 = false;
        this.zone = "";
        // #region Attributes
        /**
         * Returns true if the given address is in the subnet of the current address
         * @memberof Address6
         * @instance
         * @returns {boolean}
         */ this.isInSubnet = $bb87p.isInSubnet;
        /**
         * Returns true if the address is correct, false otherwise
         * @memberof Address6
         * @instance
         * @returns {boolean}
         */ this.isCorrect = $bb87p.isCorrect($eZzde.BITS);
        if (optionalGroups === undefined) this.groups = $eZzde.GROUPS;
        else this.groups = optionalGroups;
        this.address = address;
        const subnet = $eZzde.RE_SUBNET_STRING.exec(address);
        if (subnet) {
            this.parsedSubnet = subnet[0].replace("/", "");
            this.subnetMask = parseInt(this.parsedSubnet, 10);
            this.subnet = `/${this.subnetMask}`;
            if (Number.isNaN(this.subnetMask) || this.subnetMask < 0 || this.subnetMask > $eZzde.BITS) throw new (0, $dOJdc.AddressError)("Invalid subnet mask.");
            address = address.replace($eZzde.RE_SUBNET_STRING, "");
        } else if (/\//.test(address)) throw new (0, $dOJdc.AddressError)("Invalid subnet mask.");
        const zone = $eZzde.RE_ZONE_STRING.exec(address);
        if (zone) {
            this.zone = zone[0];
            address = address.replace($eZzde.RE_ZONE_STRING, "");
        }
        this.addressMinusSuffix = address;
        this.parsedAddress = this.parse(this.addressMinusSuffix);
    }
    static isValid(address) {
        try {
            // eslint-disable-next-line no-new
            new $b6dacc9263616fda$export$14b1a06ebde39888(address);
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
     * Convert a BigInteger to a v6 address object
     * @memberof Address6
     * @static
     * @param {BigInteger} bigInteger - a BigInteger to convert
     * @returns {Address6}
     * @example
     * var bigInteger = new BigInteger('1000000000000');
     * var address = Address6.fromBigInteger(bigInteger);
     * address.correctForm(); // '::e8:d4a5:1000'
     */ static fromBigInteger(bigInteger) {
        const hex = bigInteger.toString(16).padStart(32, "0");
        const groups = [];
        let i;
        for(i = 0; i < $eZzde.GROUPS; i++)groups.push(hex.slice(i * 4, (i + 1) * 4));
        return new $b6dacc9263616fda$export$14b1a06ebde39888(groups.join(":"));
    }
    /**
     * Convert a URL (with optional port number) to an address object
     * @memberof Address6
     * @static
     * @param {string} url - a URL with optional port number
     * @example
     * var addressAndPort = Address6.fromURL('http://[ffff::]:8080/foo/');
     * addressAndPort.address.correctForm(); // 'ffff::'
     * addressAndPort.port; // 8080
     */ static fromURL(url) {
        let host;
        let port = null;
        let result;
        // If we have brackets parse them and find a port
        if (url.indexOf("[") !== -1 && url.indexOf("]:") !== -1) {
            result = $eZzde.RE_URL_WITH_PORT.exec(url);
            if (result === null) return {
                error: "failed to parse address with port",
                address: null,
                port: null
            };
            host = result[1];
            port = result[2];
        // If there's a URL extract the address
        } else if (url.indexOf("/") !== -1) {
            // Remove the protocol prefix
            url = url.replace(/^[a-z0-9]+:\/\//, "");
            // Parse the address
            result = $eZzde.RE_URL.exec(url);
            if (result === null) return {
                error: "failed to parse address from URL",
                address: null,
                port: null
            };
            host = result[1];
        // Otherwise just assign the URL to the host and let the library parse it
        } else host = url;
        // If there's a port convert it to an integer
        if (port) {
            port = parseInt(port, 10);
            // squelch out of range ports
            if (port < 0 || port > 65536) port = null;
        } else // Standardize `undefined` to `null`
        port = null;
        return {
            address: new $b6dacc9263616fda$export$14b1a06ebde39888(host),
            port: port
        };
    }
    /**
     * Create an IPv6-mapped address given an IPv4 address
     * @memberof Address6
     * @static
     * @param {string} address - An IPv4 address string
     * @returns {Address6}
     * @example
     * var address = Address6.fromAddress4('192.168.0.1');
     * address.correctForm(); // '::ffff:c0a8:1'
     * address.to4in6(); // '::ffff:192.168.0.1'
     */ static fromAddress4(address) {
        const address4 = new (0, $2ncQg.Address4)(address);
        const mask6 = $eZzde.BITS - ($bjVKo.BITS - address4.subnetMask);
        return new $b6dacc9263616fda$export$14b1a06ebde39888(`::ffff:${address4.correctForm()}/${mask6}`);
    }
    /**
     * Return an address from ip6.arpa form
     * @memberof Address6
     * @static
     * @param {string} arpaFormAddress - an 'ip6.arpa' form address
     * @returns {Adress6}
     * @example
     * var address = Address6.fromArpa(e.f.f.f.3.c.2.6.f.f.f.e.6.6.8.e.1.0.6.7.9.4.e.c.0.0.0.0.1.0.0.2.ip6.arpa.)
     * address.correctForm(); // '2001:0:ce49:7601:e866:efff:62c3:fffe'
     */ static fromArpa(arpaFormAddress) {
        // remove ending ".ip6.arpa." or just "."
        let address = arpaFormAddress.replace(/(\.ip6\.arpa)?\.$/, "");
        const semicolonAmount = 7;
        // correct ip6.arpa form with ending removed will be 63 characters
        if (address.length !== 63) throw new (0, $dOJdc.AddressError)("Invalid 'ip6.arpa' form.");
        const parts = address.split(".").reverse();
        for(let i = semicolonAmount; i > 0; i--){
            const insertIndex = i * 4;
            parts.splice(insertIndex, 0, ":");
        }
        address = parts.join("");
        return new $b6dacc9263616fda$export$14b1a06ebde39888(address);
    }
    /**
     * Return the Microsoft UNC transcription of the address
     * @memberof Address6
     * @instance
     * @returns {String} the Microsoft UNC transcription of the address
     */ microsoftTranscription() {
        return (0, $lPVyw.sprintf)("%s.ipv6-literal.net", this.correctForm().replace(/:/g, "-"));
    }
    /**
     * Return the first n bits of the address, defaulting to the subnet mask
     * @memberof Address6
     * @instance
     * @param {number} [mask=subnet] - the number of bits to mask
     * @returns {String} the first n bits of the address as a string
     */ mask(mask = this.subnetMask) {
        return this.getBitsBase2(0, mask);
    }
    /**
     * Return the number of possible subnets of a given size in the address
     * @memberof Address6
     * @instance
     * @param {number} [size=128] - the subnet size
     * @returns {String}
     */ // TODO: probably useful to have a numeric version of this too
    possibleSubnets(subnetSize = 128) {
        const availableBits = $eZzde.BITS - this.subnetMask;
        const subnetBits = Math.abs(subnetSize - $eZzde.BITS);
        const subnetPowers = availableBits - subnetBits;
        if (subnetPowers < 0) return "0";
        return $b6dacc9263616fda$var$addCommas(new (0, $k1YHG.BigInteger)("2", 10).pow(subnetPowers).toString(10));
    }
    /**
     * Helper function getting start address.
     * @memberof Address6
     * @instance
     * @returns {BigInteger}
     */ _startAddress() {
        return new (0, $k1YHG.BigInteger)(this.mask() + "0".repeat($eZzde.BITS - this.subnetMask), 2);
    }
    /**
     * The first address in the range given by this address' subnet
     * Often referred to as the Network Address.
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ startAddress() {
        return $b6dacc9263616fda$export$14b1a06ebde39888.fromBigInteger(this._startAddress());
    }
    /**
     * The first host address in the range given by this address's subnet ie
     * the first address after the Network Address
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ startAddressExclusive() {
        const adjust = new (0, $k1YHG.BigInteger)("1");
        return $b6dacc9263616fda$export$14b1a06ebde39888.fromBigInteger(this._startAddress().add(adjust));
    }
    /**
     * Helper function getting end address.
     * @memberof Address6
     * @instance
     * @returns {BigInteger}
     */ _endAddress() {
        return new (0, $k1YHG.BigInteger)(this.mask() + "1".repeat($eZzde.BITS - this.subnetMask), 2);
    }
    /**
     * The last address in the range given by this address' subnet
     * Often referred to as the Broadcast
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ endAddress() {
        return $b6dacc9263616fda$export$14b1a06ebde39888.fromBigInteger(this._endAddress());
    }
    /**
     * The last host address in the range given by this address's subnet ie
     * the last address prior to the Broadcast Address
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ endAddressExclusive() {
        const adjust = new (0, $k1YHG.BigInteger)("1");
        return $b6dacc9263616fda$export$14b1a06ebde39888.fromBigInteger(this._endAddress().subtract(adjust));
    }
    /**
     * Return the scope of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getScope() {
        let scope = $eZzde.SCOPES[this.getBits(12, 16).intValue()];
        if (this.getType() === "Global unicast" && scope !== "Link local") scope = "Global";
        return scope || "Unknown";
    }
    /**
     * Return the type of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getType() {
        for (const subnet of Object.keys($eZzde.TYPES)){
            if (this.isInSubnet(new $b6dacc9263616fda$export$14b1a06ebde39888(subnet))) return $eZzde.TYPES[subnet];
        }
        return "Global unicast";
    }
    /**
     * Return the bits in the given range as a BigInteger
     * @memberof Address6
     * @instance
     * @returns {BigInteger}
     */ getBits(start, end) {
        return new (0, $k1YHG.BigInteger)(this.getBitsBase2(start, end), 2);
    }
    /**
     * Return the bits in the given range as a base-2 string
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getBitsBase2(start, end) {
        return this.binaryZeroPad().slice(start, end);
    }
    /**
     * Return the bits in the given range as a base-16 string
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getBitsBase16(start, end) {
        const length = end - start;
        if (length % 4 !== 0) throw new Error("Length of bits to retrieve must be divisible by four");
        return this.getBits(start, end).toString(16).padStart(length / 4, "0");
    }
    /**
     * Return the bits that are set past the subnet mask length
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getBitsPastSubnet() {
        return this.getBitsBase2(this.subnetMask, $eZzde.BITS);
    }
    /**
     * Return the reversed ip6.arpa form of the address
     * @memberof Address6
     * @param {Object} options
     * @param {boolean} options.omitSuffix - omit the "ip6.arpa" suffix
     * @instance
     * @returns {String}
     */ reverseForm(options) {
        if (!options) options = {};
        const characters = Math.floor(this.subnetMask / 4);
        const reversed = this.canonicalForm().replace(/:/g, "").split("").slice(0, characters).reverse().join(".");
        if (characters > 0) {
            if (options.omitSuffix) return reversed;
            return (0, $lPVyw.sprintf)("%s.ip6.arpa.", reversed);
        }
        if (options.omitSuffix) return "";
        return "ip6.arpa.";
    }
    /**
     * Return the correct form of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ correctForm() {
        let i;
        let groups = [];
        let zeroCounter = 0;
        const zeroes = [];
        for(i = 0; i < this.parsedAddress.length; i++){
            const value = parseInt(this.parsedAddress[i], 16);
            if (value === 0) zeroCounter++;
            if (value !== 0 && zeroCounter > 0) {
                if (zeroCounter > 1) zeroes.push([
                    i - zeroCounter,
                    i - 1
                ]);
                zeroCounter = 0;
            }
        }
        // Do we end with a string of zeroes?
        if (zeroCounter > 1) zeroes.push([
            this.parsedAddress.length - zeroCounter,
            this.parsedAddress.length - 1
        ]);
        const zeroLengths = zeroes.map((n)=>n[1] - n[0] + 1);
        if (zeroes.length > 0) {
            const index = zeroLengths.indexOf(Math.max(...zeroLengths));
            groups = $b6dacc9263616fda$var$compact(this.parsedAddress, zeroes[index]);
        } else groups = this.parsedAddress;
        for(i = 0; i < groups.length; i++)if (groups[i] !== "compact") groups[i] = parseInt(groups[i], 16).toString(16);
        let correct = groups.join(":");
        correct = correct.replace(/^compact$/, "::");
        correct = correct.replace(/^compact|compact$/, ":");
        correct = correct.replace(/compact/, "");
        return correct;
    }
    /**
     * Return a zero-padded base-2 string representation of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     * @example
     * var address = new Address6('2001:4860:4001:803::1011');
     * address.binaryZeroPad();
     * // '0010000000000001010010000110000001000000000000010000100000000011
     * //  0000000000000000000000000000000000000000000000000001000000010001'
     */ binaryZeroPad() {
        return this.bigInteger().toString(2).padStart($eZzde.BITS, "0");
    }
    // TODO: Improve the semantics of this helper function
    parse4in6(address) {
        const groups = address.split(":");
        const lastGroup = groups.slice(-1)[0];
        const address4 = lastGroup.match($bjVKo.RE_ADDRESS);
        if (address4) {
            this.parsedAddress4 = address4[0];
            this.address4 = new (0, $2ncQg.Address4)(this.parsedAddress4);
            for(let i = 0; i < this.address4.groups; i++){
                if (/^0[0-9]+/.test(this.address4.parsedAddress[i])) throw new (0, $dOJdc.AddressError)("IPv4 addresses can't have leading zeroes.", address.replace($bjVKo.RE_ADDRESS, this.address4.parsedAddress.map($b6dacc9263616fda$var$spanLeadingZeroes4).join(".")));
            }
            this.v4 = true;
            groups[groups.length - 1] = this.address4.toGroup6();
            address = groups.join(":");
        }
        return address;
    }
    // TODO: Make private?
    parse(address) {
        address = this.parse4in6(address);
        const badCharacters = address.match($eZzde.RE_BAD_CHARACTERS);
        if (badCharacters) throw new (0, $dOJdc.AddressError)((0, $lPVyw.sprintf)("Bad character%s detected in address: %s", badCharacters.length > 1 ? "s" : "", badCharacters.join("")), address.replace($eZzde.RE_BAD_CHARACTERS, '<span class="parse-error">$1</span>'));
        const badAddress = address.match($eZzde.RE_BAD_ADDRESS);
        if (badAddress) throw new (0, $dOJdc.AddressError)((0, $lPVyw.sprintf)("Address failed regex: %s", badAddress.join("")), address.replace($eZzde.RE_BAD_ADDRESS, '<span class="parse-error">$1</span>'));
        let groups = [];
        const halves = address.split("::");
        if (halves.length === 2) {
            let first = halves[0].split(":");
            let last = halves[1].split(":");
            if (first.length === 1 && first[0] === "") first = [];
            if (last.length === 1 && last[0] === "") last = [];
            const remaining = this.groups - (first.length + last.length);
            if (!remaining) throw new (0, $dOJdc.AddressError)("Error parsing groups");
            this.elidedGroups = remaining;
            this.elisionBegin = first.length;
            this.elisionEnd = first.length + this.elidedGroups;
            groups = groups.concat(first);
            for(let i = 0; i < remaining; i++)groups.push("0");
            groups = groups.concat(last);
        } else if (halves.length === 1) {
            groups = address.split(":");
            this.elidedGroups = 0;
        } else throw new (0, $dOJdc.AddressError)("Too many :: groups found");
        groups = groups.map((group)=>(0, $lPVyw.sprintf)("%x", parseInt(group, 16)));
        if (groups.length !== this.groups) throw new (0, $dOJdc.AddressError)("Incorrect number of groups found");
        return groups;
    }
    /**
     * Return the canonical form of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ canonicalForm() {
        return this.parsedAddress.map($b6dacc9263616fda$var$paddedHex).join(":");
    }
    /**
     * Return the decimal form of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ decimal() {
        return this.parsedAddress.map((n)=>(0, $lPVyw.sprintf)("%05d", parseInt(n, 16))).join(":");
    }
    /**
     * Return the address as a BigInteger
     * @memberof Address6
     * @instance
     * @returns {BigInteger}
     */ bigInteger() {
        return new (0, $k1YHG.BigInteger)(this.parsedAddress.map($b6dacc9263616fda$var$paddedHex).join(""), 16);
    }
    /**
     * Return the last two groups of this address as an IPv4 address string
     * @memberof Address6
     * @instance
     * @returns {Address4}
     * @example
     * var address = new Address6('2001:4860:4001::1825:bf11');
     * address.to4().correctForm(); // '24.37.191.17'
     */ to4() {
        const binary = this.binaryZeroPad().split("");
        return (0, $2ncQg.Address4).fromHex(new (0, $k1YHG.BigInteger)(binary.slice(96, 128).join(""), 2).toString(16));
    }
    /**
     * Return the v4-in-v6 form of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ to4in6() {
        const address4 = this.to4();
        const address6 = new $b6dacc9263616fda$export$14b1a06ebde39888(this.parsedAddress.slice(0, 6).join(":"), 6);
        const correct = address6.correctForm();
        let infix = "";
        if (!/:$/.test(correct)) infix = ":";
        return correct + infix + address4.address;
    }
    /**
     * Return an object containing the Teredo properties of the address
     * @memberof Address6
     * @instance
     * @returns {Object}
     */ inspectTeredo() {
        /*
        - Bits 0 to 31 are set to the Teredo prefix (normally 2001:0000::/32).
        - Bits 32 to 63 embed the primary IPv4 address of the Teredo server that
          is used.
        - Bits 64 to 79 can be used to define some flags. Currently only the
          higher order bit is used; it is set to 1 if the Teredo client is
          located behind a cone NAT, 0 otherwise. For Microsoft's Windows Vista
          and Windows Server 2008 implementations, more bits are used. In those
          implementations, the format for these 16 bits is "CRAAAAUG AAAAAAAA",
          where "C" remains the "Cone" flag. The "R" bit is reserved for future
          use. The "U" bit is for the Universal/Local flag (set to 0). The "G" bit
          is Individual/Group flag (set to 0). The A bits are set to a 12-bit
          randomly generated number chosen by the Teredo client to introduce
          additional protection for the Teredo node against IPv6-based scanning
          attacks.
        - Bits 80 to 95 contains the obfuscated UDP port number. This is the
          port number that is mapped by the NAT to the Teredo client with all
          bits inverted.
        - Bits 96 to 127 contains the obfuscated IPv4 address. This is the
          public IPv4 address of the NAT with all bits inverted.
        */ const prefix = this.getBitsBase16(0, 32);
        const udpPort = this.getBits(80, 96).xor(new (0, $k1YHG.BigInteger)("ffff", 16)).toString();
        const server4 = (0, $2ncQg.Address4).fromHex(this.getBitsBase16(32, 64));
        const client4 = (0, $2ncQg.Address4).fromHex(this.getBits(96, 128).xor(new (0, $k1YHG.BigInteger)("ffffffff", 16)).toString(16));
        const flags = this.getBits(64, 80);
        const flagsBase2 = this.getBitsBase2(64, 80);
        const coneNat = flags.testBit(15);
        const reserved = flags.testBit(14);
        const groupIndividual = flags.testBit(8);
        const universalLocal = flags.testBit(9);
        const nonce = new (0, $k1YHG.BigInteger)(flagsBase2.slice(2, 6) + flagsBase2.slice(8, 16), 2).toString(10);
        return {
            prefix: (0, $lPVyw.sprintf)("%s:%s", prefix.slice(0, 4), prefix.slice(4, 8)),
            server4: server4.address,
            client4: client4.address,
            flags: flagsBase2,
            coneNat: coneNat,
            microsoft: {
                reserved: reserved,
                universalLocal: universalLocal,
                groupIndividual: groupIndividual,
                nonce: nonce
            },
            udpPort: udpPort
        };
    }
    /**
     * Return an object containing the 6to4 properties of the address
     * @memberof Address6
     * @instance
     * @returns {Object}
     */ inspect6to4() {
        /*
        - Bits 0 to 15 are set to the 6to4 prefix (2002::/16).
        - Bits 16 to 48 embed the IPv4 address of the 6to4 gateway that is used.
        */ const prefix = this.getBitsBase16(0, 16);
        const gateway = (0, $2ncQg.Address4).fromHex(this.getBitsBase16(16, 48));
        return {
            prefix: (0, $lPVyw.sprintf)("%s", prefix.slice(0, 4)),
            gateway: gateway.address
        };
    }
    /**
     * Return a v6 6to4 address from a v6 v4inv6 address
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ to6to4() {
        if (!this.is4()) return null;
        const addr6to4 = [
            "2002",
            this.getBitsBase16(96, 112),
            this.getBitsBase16(112, 128),
            "",
            "/16"
        ].join(":");
        return new $b6dacc9263616fda$export$14b1a06ebde39888(addr6to4);
    }
    /**
     * Return a byte array
     * @memberof Address6
     * @instance
     * @returns {Array}
     */ toByteArray() {
        const byteArray = this.bigInteger().toByteArray();
        // work around issue where `toByteArray` returns a leading 0 element
        if (byteArray.length === 17 && byteArray[0] === 0) return byteArray.slice(1);
        return byteArray;
    }
    /**
     * Return an unsigned byte array
     * @memberof Address6
     * @instance
     * @returns {Array}
     */ toUnsignedByteArray() {
        return this.toByteArray().map($b6dacc9263616fda$var$unsignByte);
    }
    /**
     * Convert a byte array to an Address6 object
     * @memberof Address6
     * @static
     * @returns {Address6}
     */ static fromByteArray(bytes) {
        return this.fromUnsignedByteArray(bytes.map($b6dacc9263616fda$var$unsignByte));
    }
    /**
     * Convert an unsigned byte array to an Address6 object
     * @memberof Address6
     * @static
     * @returns {Address6}
     */ static fromUnsignedByteArray(bytes) {
        const BYTE_MAX = new (0, $k1YHG.BigInteger)("256", 10);
        let result = new (0, $k1YHG.BigInteger)("0", 10);
        let multiplier = new (0, $k1YHG.BigInteger)("1", 10);
        for(let i = bytes.length - 1; i >= 0; i--){
            result = result.add(multiplier.multiply(new (0, $k1YHG.BigInteger)(bytes[i].toString(10), 10)));
            multiplier = multiplier.multiply(BYTE_MAX);
        }
        return $b6dacc9263616fda$export$14b1a06ebde39888.fromBigInteger(result);
    }
    /**
     * Returns true if the address is in the canonical form, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isCanonical() {
        return this.addressMinusSuffix === this.canonicalForm();
    }
    /**
     * Returns true if the address is a link local address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isLinkLocal() {
        // Zeroes are required, i.e. we can't check isInSubnet with 'fe80::/10'
        if (this.getBitsBase2(0, 64) === "1111111010000000000000000000000000000000000000000000000000000000") return true;
        return false;
    }
    /**
     * Returns true if the address is a multicast address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isMulticast() {
        return this.getType() === "Multicast";
    }
    /**
     * Returns true if the address is a v4-in-v6 address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ is4() {
        return this.v4;
    }
    /**
     * Returns true if the address is a Teredo address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isTeredo() {
        return this.isInSubnet(new $b6dacc9263616fda$export$14b1a06ebde39888("2001::/32"));
    }
    /**
     * Returns true if the address is a 6to4 address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ is6to4() {
        return this.isInSubnet(new $b6dacc9263616fda$export$14b1a06ebde39888("2002::/16"));
    }
    /**
     * Returns true if the address is a loopback address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isLoopback() {
        return this.getType() === "Loopback";
    }
    // #endregion
    // #region HTML
    /**
     * @returns {String} the address in link form with a default port of 80
     */ href(optionalPort) {
        if (optionalPort === undefined) optionalPort = "";
        else optionalPort = (0, $lPVyw.sprintf)(":%s", optionalPort);
        return (0, $lPVyw.sprintf)("http://[%s]%s/", this.correctForm(), optionalPort);
    }
    /**
     * @returns {String} a link suitable for conveying the address via a URL hash
     */ link(options) {
        if (!options) options = {};
        if (options.className === undefined) options.className = "";
        if (options.prefix === undefined) options.prefix = "/#address=";
        if (options.v4 === undefined) options.v4 = false;
        let formFunction = this.correctForm;
        if (options.v4) formFunction = this.to4in6;
        if (options.className) return (0, $lPVyw.sprintf)('<a href="%1$s%2$s" class="%3$s">%2$s</a>', options.prefix, formFunction.call(this), options.className);
        return (0, $lPVyw.sprintf)('<a href="%1$s%2$s">%2$s</a>', options.prefix, formFunction.call(this));
    }
    /**
     * Groups an address
     * @returns {String}
     */ group() {
        if (this.elidedGroups === 0) // The simple case
        return $aXjPZ.simpleGroup(this.address).join(":");
        $b6dacc9263616fda$var$assert(typeof this.elidedGroups === "number");
        $b6dacc9263616fda$var$assert(typeof this.elisionBegin === "number");
        // The elided case
        const output = [];
        const [left, right] = this.address.split("::");
        if (left.length) output.push(...$aXjPZ.simpleGroup(left));
        else output.push("");
        const classes = [
            "hover-group"
        ];
        for(let i = this.elisionBegin; i < this.elisionBegin + this.elidedGroups; i++)classes.push((0, $lPVyw.sprintf)("group-%d", i));
        output.push((0, $lPVyw.sprintf)('<span class="%s"></span>', classes.join(" ")));
        if (right.length) output.push(...$aXjPZ.simpleGroup(right, this.elisionEnd));
        else output.push("");
        if (this.is4()) {
            $b6dacc9263616fda$var$assert(this.address4 instanceof (0, $2ncQg.Address4));
            output.pop();
            output.push(this.address4.groupForV6());
        }
        return output.join(":");
    }
    // #endregion
    // #region Regular expressions
    /**
     * Generate a regular expression string that can be used to find or validate
     * all variations of this address
     * @memberof Address6
     * @instance
     * @param {boolean} substringSearch
     * @returns {string}
     */ regularExpressionString(substringSearch = false) {
        let output = [];
        // TODO: revisit why this is necessary
        const address6 = new $b6dacc9263616fda$export$14b1a06ebde39888(this.correctForm());
        if (address6.elidedGroups === 0) // The simple case
        output.push((0, $b5wtN.simpleRegularExpression)(address6.parsedAddress));
        else if (address6.elidedGroups === $eZzde.GROUPS) // A completely elided address
        output.push((0, $b5wtN.possibleElisions)($eZzde.GROUPS));
        else {
            // A partially elided address
            const halves = address6.address.split("::");
            if (halves[0].length) output.push((0, $b5wtN.simpleRegularExpression)(halves[0].split(":")));
            $b6dacc9263616fda$var$assert(typeof address6.elidedGroups === "number");
            output.push((0, $b5wtN.possibleElisions)(address6.elidedGroups, halves[0].length !== 0, halves[1].length !== 0));
            if (halves[1].length) output.push((0, $b5wtN.simpleRegularExpression)(halves[1].split(":")));
            output = [
                output.join(":")
            ];
        }
        if (!substringSearch) output = [
            "(?=^|",
            (0, $b5wtN.ADDRESS_BOUNDARY),
            "|[^\\w\\:])(",
            ...output,
            ")(?=[^\\w\\:]|",
            (0, $b5wtN.ADDRESS_BOUNDARY),
            "|$)"
        ];
        return output.join("");
    }
    /**
     * Generate a regular expression that can be used to find or validate all
     * variations of this address.
     * @memberof Address6
     * @instance
     * @param {boolean} substringSearch
     * @returns {RegExp}
     */ regularExpression(substringSearch = false) {
        return new RegExp(this.regularExpressionString(substringSearch), "i");
    }
}

});
parcelRequire.register("eZzde", function(module, exports) {

$parcel$export(module.exports, "BITS", () => $aea213a7befe6608$export$7668498dc56e7407);
$parcel$export(module.exports, "GROUPS", () => $aea213a7befe6608$export$e55a77427f2a49c5);
$parcel$export(module.exports, "SCOPES", () => $aea213a7befe6608$export$2f2e35d53068ed45);
$parcel$export(module.exports, "TYPES", () => $aea213a7befe6608$export$426db7a6155b7a80);
$parcel$export(module.exports, "RE_BAD_CHARACTERS", () => $aea213a7befe6608$export$2972bef79316a61f);
$parcel$export(module.exports, "RE_BAD_ADDRESS", () => $aea213a7befe6608$export$c0d1121b721fb0ce);
$parcel$export(module.exports, "RE_SUBNET_STRING", () => $aea213a7befe6608$export$dcb0d7c78b7346c1);
$parcel$export(module.exports, "RE_ZONE_STRING", () => $aea213a7befe6608$export$341f79376d6eb890);
$parcel$export(module.exports, "RE_URL", () => $aea213a7befe6608$export$dae246189a6e2355);
$parcel$export(module.exports, "RE_URL_WITH_PORT", () => $aea213a7befe6608$export$e7064104a0c4c5cf);
const $aea213a7befe6608$export$7668498dc56e7407 = 128;
const $aea213a7befe6608$export$e55a77427f2a49c5 = 8;
const $aea213a7befe6608$export$2f2e35d53068ed45 = {
    0: "Reserved",
    1: "Interface local",
    2: "Link local",
    4: "Admin local",
    5: "Site local",
    8: "Organization local",
    14: "Global",
    15: "Reserved"
};
const $aea213a7befe6608$export$426db7a6155b7a80 = {
    "ff01::1/128": "Multicast (All nodes on this interface)",
    "ff01::2/128": "Multicast (All routers on this interface)",
    "ff02::1/128": "Multicast (All nodes on this link)",
    "ff02::2/128": "Multicast (All routers on this link)",
    "ff05::2/128": "Multicast (All routers in this site)",
    "ff02::5/128": "Multicast (OSPFv3 AllSPF routers)",
    "ff02::6/128": "Multicast (OSPFv3 AllDR routers)",
    "ff02::9/128": "Multicast (RIP routers)",
    "ff02::a/128": "Multicast (EIGRP routers)",
    "ff02::d/128": "Multicast (PIM routers)",
    "ff02::16/128": "Multicast (MLDv2 reports)",
    "ff01::fb/128": "Multicast (mDNSv6)",
    "ff02::fb/128": "Multicast (mDNSv6)",
    "ff05::fb/128": "Multicast (mDNSv6)",
    "ff02::1:2/128": "Multicast (All DHCP servers and relay agents on this link)",
    "ff05::1:2/128": "Multicast (All DHCP servers and relay agents in this site)",
    "ff02::1:3/128": "Multicast (All DHCP servers on this link)",
    "ff05::1:3/128": "Multicast (All DHCP servers in this site)",
    "::/128": "Unspecified",
    "::1/128": "Loopback",
    "ff00::/8": "Multicast",
    "fe80::/10": "Link-local unicast"
};
const $aea213a7befe6608$export$2972bef79316a61f = /([^0-9a-f:/%])/gi;
const $aea213a7befe6608$export$c0d1121b721fb0ce = /([0-9a-f]{5,}|:{3,}|[^:]:$|^:[^:]|\/$)/gi;
const $aea213a7befe6608$export$dcb0d7c78b7346c1 = /\/\d{1,3}(?=%|$)/;
const $aea213a7befe6608$export$341f79376d6eb890 = /%.*$/;
const $aea213a7befe6608$export$dae246189a6e2355 = new RegExp(/^\[{0,1}([0-9a-f:]+)\]{0,1}/);
const $aea213a7befe6608$export$e7064104a0c4c5cf = new RegExp(/\[([0-9a-f:]+)\]:([0-9]{1,5})/);

});

parcelRequire.register("aXjPZ", function(module, exports) {

$parcel$export(module.exports, "spanAllZeroes", () => $7f9ecd6251e832cd$export$b77d85f54ad3b2e2);
$parcel$export(module.exports, "spanAll", () => $7f9ecd6251e832cd$export$f6c035181534a5b);
$parcel$export(module.exports, "spanLeadingZeroes", () => $7f9ecd6251e832cd$export$58b794beb1a65de3);
$parcel$export(module.exports, "simpleGroup", () => $7f9ecd6251e832cd$export$e565b33551a6f03);

var $lPVyw = parcelRequire("lPVyw");
function $7f9ecd6251e832cd$export$b77d85f54ad3b2e2(s) {
    return s.replace(/(0+)/g, '<span class="zero">$1</span>');
}
function $7f9ecd6251e832cd$export$f6c035181534a5b(s, offset = 0) {
    const letters = s.split("");
    return letters.map((n, i)=>(0, $lPVyw.sprintf)('<span class="digit value-%s position-%d">%s</span>', n, i + offset, $7f9ecd6251e832cd$export$b77d85f54ad3b2e2(n)) // XXX Use #base-2 .value-0 instead?
    ).join("");
}
function $7f9ecd6251e832cd$var$spanLeadingZeroesSimple(group) {
    return group.replace(/^(0+)/, '<span class="zero">$1</span>');
}
function $7f9ecd6251e832cd$export$58b794beb1a65de3(address) {
    const groups = address.split(":");
    return groups.map((g)=>$7f9ecd6251e832cd$var$spanLeadingZeroesSimple(g)).join(":");
}
function $7f9ecd6251e832cd$export$e565b33551a6f03(addressString, offset = 0) {
    const groups = addressString.split(":");
    return groups.map((g, i)=>{
        if (/group-v4/.test(g)) return g;
        return (0, $lPVyw.sprintf)('<span class="hover-group group-%d">%s</span>', i + offset, $7f9ecd6251e832cd$var$spanLeadingZeroesSimple(g));
    });
}

});

parcelRequire.register("b5wtN", function(module, exports) {

$parcel$export(module.exports, "ADDRESS_BOUNDARY", () => $81295b17a1c51ff7$export$c643d74c52ccbc2b);
$parcel$export(module.exports, "simpleRegularExpression", () => $81295b17a1c51ff7$export$efd1a332bd8a55b);
$parcel$export(module.exports, "possibleElisions", () => $81295b17a1c51ff7$export$4fb6ee22bccbc4a5);

var $eZzde = parcelRequire("eZzde");

var $lPVyw = parcelRequire("lPVyw");
function $81295b17a1c51ff7$export$5b52b7dc1f7b2233(possibilities) {
    return (0, $lPVyw.sprintf)("(%s)", possibilities.join("|"));
}
function $81295b17a1c51ff7$export$b98cf33810e5733c(group) {
    if (group.length < 4) return (0, $lPVyw.sprintf)("0{0,%d}%s", 4 - group.length, group);
    return group;
}
const $81295b17a1c51ff7$export$c643d74c52ccbc2b = "[^A-Fa-f0-9:]";
function $81295b17a1c51ff7$export$efd1a332bd8a55b(groups) {
    const zeroIndexes = [];
    groups.forEach((group, i)=>{
        const groupInteger = parseInt(group, 16);
        if (groupInteger === 0) zeroIndexes.push(i);
    });
    // You can technically elide a single 0, this creates the regular expressions
    // to match that eventuality
    const possibilities = zeroIndexes.map((zeroIndex)=>groups.map((group, i)=>{
            if (i === zeroIndex) {
                const elision = i === 0 || i === $eZzde.GROUPS - 1 ? ":" : "";
                return $81295b17a1c51ff7$export$5b52b7dc1f7b2233([
                    $81295b17a1c51ff7$export$b98cf33810e5733c(group),
                    elision
                ]);
            }
            return $81295b17a1c51ff7$export$b98cf33810e5733c(group);
        }).join(":"));
    // The simplest case
    possibilities.push(groups.map($81295b17a1c51ff7$export$b98cf33810e5733c).join(":"));
    return $81295b17a1c51ff7$export$5b52b7dc1f7b2233(possibilities);
}
function $81295b17a1c51ff7$export$4fb6ee22bccbc4a5(elidedGroups, moreLeft, moreRight) {
    const left = moreLeft ? "" : ":";
    const right = moreRight ? "" : ":";
    const possibilities = [];
    // 1. elision of everything (::)
    if (!moreLeft && !moreRight) possibilities.push("::");
    // 2. complete elision of the middle
    if (moreLeft && moreRight) possibilities.push("");
    if (moreRight && !moreLeft || !moreRight && moreLeft) // 3. complete elision of one side
    possibilities.push(":");
    // 4. elision from the left side
    possibilities.push((0, $lPVyw.sprintf)("%s(:0{1,4}){1,%d}", left, elidedGroups - 1));
    // 5. elision from the right side
    possibilities.push((0, $lPVyw.sprintf)("(0{1,4}:){1,%d}%s", elidedGroups - 1, right));
    // 6. no elision
    possibilities.push((0, $lPVyw.sprintf)("(0{1,4}:){%d}0{1,4}", elidedGroups - 1));
    // 7. elision (including sloppy elision) from the middle
    for(let groups = 1; groups < elidedGroups - 1; groups++)for(let position = 1; position < elidedGroups - groups; position++)possibilities.push((0, $lPVyw.sprintf)("(0{1,4}:){%d}:(0{1,4}:){%d}0{1,4}", position, elidedGroups - position - groups - 1));
    return $81295b17a1c51ff7$export$5b52b7dc1f7b2233(possibilities);
}

});




parcelRequire.register("cEMkd", function(module, exports) {
"use strict";
class $936eb4cd6a47e183$var$TimeoutError extends Error {
    constructor(message){
        super(message);
        this.name = "TimeoutError";
    }
}
const $936eb4cd6a47e183$var$pTimeout = (promise, milliseconds, fallback, options)=>{
    let timer;
    const cancelablePromise = new Promise((resolve, reject)=>{
        if (typeof milliseconds !== "number" || milliseconds < 0) throw new TypeError("Expected `milliseconds` to be a positive number");
        if (milliseconds === Infinity) {
            resolve(promise);
            return;
        }
        options = {
            customTimers: {
                setTimeout: setTimeout,
                clearTimeout: clearTimeout
            },
            ...options
        };
        timer = options.customTimers.setTimeout.call(undefined, ()=>{
            if (typeof fallback === "function") {
                try {
                    resolve(fallback());
                } catch (error) {
                    reject(error);
                }
                return;
            }
            const message = typeof fallback === "string" ? fallback : `Promise timed out after ${milliseconds} milliseconds`;
            const timeoutError = fallback instanceof Error ? fallback : new $936eb4cd6a47e183$var$TimeoutError(message);
            if (typeof promise.cancel === "function") promise.cancel();
            reject(timeoutError);
        }, milliseconds);
        (async ()=>{
            try {
                resolve(await promise);
            } catch (error) {
                reject(error);
            } finally{
                options.customTimers.clearTimeout.call(undefined, timer);
            }
        })();
    });
    cancelablePromise.clear = ()=>{
        clearTimeout(timer);
        timer = undefined;
    };
    return cancelablePromise;
};
module.exports = $936eb4cd6a47e183$var$pTimeout;
// TODO: Remove this for the next major release
module.exports.default = $936eb4cd6a47e183$var$pTimeout;
module.exports.TimeoutError = $936eb4cd6a47e183$var$TimeoutError;

});


parcelRequire.register("jvgiY", function(module, exports) {
"use strict";

var $gwbn0 = parcelRequire("gwbn0");

var $3SBTz = parcelRequire("3SBTz");
var $e32d8f69e8d7267f$require$CODE_CIRCUIT = $3SBTz.CODE_CIRCUIT;
var $e32d8f69e8d7267f$require$CODE_P2P = $3SBTz.CODE_P2P;
var $e32d8f69e8d7267f$require$CODE_TCP = $3SBTz.CODE_TCP;
var $e32d8f69e8d7267f$require$CODE_WS = $3SBTz.CODE_WS;
var $e32d8f69e8d7267f$require$CODE_WSS = $3SBTz.CODE_WSS;
module.exports = {
    all: (multiaddrs)=>multiaddrs.filter((ma)=>{
            if (ma.protoCodes().includes($e32d8f69e8d7267f$require$CODE_CIRCUIT)) return false;
            const testMa = ma.decapsulateCode($e32d8f69e8d7267f$require$CODE_P2P);
            return $gwbn0.WebSockets.matches(testMa) || $gwbn0.WebSocketsSecure.matches(testMa);
        }),
    dnsWss: (multiaddrs)=>multiaddrs.filter((ma)=>{
            if (ma.protoCodes().includes($e32d8f69e8d7267f$require$CODE_CIRCUIT)) return false;
            const testMa = ma.decapsulateCode($e32d8f69e8d7267f$require$CODE_P2P);
            return $gwbn0.WebSocketsSecure.matches(testMa) && $gwbn0.DNS.matches(testMa.decapsulateCode($e32d8f69e8d7267f$require$CODE_TCP).decapsulateCode($e32d8f69e8d7267f$require$CODE_WSS));
        }),
    dnsWsOrWss: (multiaddrs)=>multiaddrs.filter((ma)=>{
            if (ma.protoCodes().includes($e32d8f69e8d7267f$require$CODE_CIRCUIT)) return false;
            const testMa = ma.decapsulateCode($e32d8f69e8d7267f$require$CODE_P2P);
            // WS
            if ($gwbn0.WebSockets.matches(testMa)) return $gwbn0.DNS.matches(testMa.decapsulateCode($e32d8f69e8d7267f$require$CODE_TCP).decapsulateCode($e32d8f69e8d7267f$require$CODE_WS));
            // WSS
            return $gwbn0.WebSocketsSecure.matches(testMa) && $gwbn0.DNS.matches(testMa.decapsulateCode($e32d8f69e8d7267f$require$CODE_TCP).decapsulateCode($e32d8f69e8d7267f$require$CODE_WSS));
        })
};

});


parcelRequire.register("edPLI", function(module, exports) {
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/ (function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    "use strict";
                    var Mutation = global1.MutationObserver || global1.WebKitMutationObserver;
                    var scheduleDrain;
                    if (Mutation) {
                        var called = 0;
                        var observer = new Mutation(nextTick);
                        var element = global1.document.createTextNode("");
                        observer.observe(element, {
                            characterData: true
                        });
                        scheduleDrain = function() {
                            element.data = called = ++called % 2;
                        };
                    } else if (!global1.setImmediate && typeof global1.MessageChannel !== "undefined") {
                        var channel = new global1.MessageChannel();
                        channel.port1.onmessage = nextTick;
                        scheduleDrain = function() {
                            channel.port2.postMessage(0);
                        };
                    } else if ("document" in global1 && "onreadystatechange" in global1.document.createElement("script")) scheduleDrain = function() {
                        // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                        // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                        var scriptEl = global1.document.createElement("script");
                        scriptEl.onreadystatechange = function() {
                            nextTick();
                            scriptEl.onreadystatechange = null;
                            scriptEl.parentNode.removeChild(scriptEl);
                            scriptEl = null;
                        };
                        global1.document.documentElement.appendChild(scriptEl);
                    };
                    else scheduleDrain = function() {
                        setTimeout(nextTick, 0);
                    };
                    var draining;
                    var queue = [];
                    //named nextTick for less confusing stack traces
                    function nextTick() {
                        draining = true;
                        var i, oldQueue;
                        var len = queue.length;
                        while(len){
                            oldQueue = queue;
                            queue = [];
                            i = -1;
                            while(++i < len)oldQueue[i]();
                            len = queue.length;
                        }
                        draining = false;
                    }
                    module1.exports = immediate;
                    function immediate(task) {
                        if (queue.push(task) === 1 && !draining) scheduleDrain();
                    }
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {}
        ],
        2: [
            function(_dereq_, module1, exports) {
                "use strict";
                var immediate = _dereq_(1);
                /* istanbul ignore next */ function INTERNAL() {}
                var handlers = {};
                var REJECTED = [
                    "REJECTED"
                ];
                var FULFILLED = [
                    "FULFILLED"
                ];
                var PENDING = [
                    "PENDING"
                ];
                module1.exports = Promise1;
                function Promise1(resolver) {
                    if (typeof resolver !== "function") throw new TypeError("resolver must be a function");
                    this.state = PENDING;
                    this.queue = [];
                    this.outcome = void 0;
                    if (resolver !== INTERNAL) safelyResolveThenable(this, resolver);
                }
                Promise1.prototype["catch"] = function(onRejected) {
                    return this.then(null, onRejected);
                };
                Promise1.prototype.then = function(onFulfilled, onRejected) {
                    if (typeof onFulfilled !== "function" && this.state === FULFILLED || typeof onRejected !== "function" && this.state === REJECTED) return this;
                    var promise = new this.constructor(INTERNAL);
                    if (this.state !== PENDING) {
                        var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
                        unwrap(promise, resolver, this.outcome);
                    } else this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
                    return promise;
                };
                function QueueItem(promise, onFulfilled, onRejected) {
                    this.promise = promise;
                    if (typeof onFulfilled === "function") {
                        this.onFulfilled = onFulfilled;
                        this.callFulfilled = this.otherCallFulfilled;
                    }
                    if (typeof onRejected === "function") {
                        this.onRejected = onRejected;
                        this.callRejected = this.otherCallRejected;
                    }
                }
                QueueItem.prototype.callFulfilled = function(value) {
                    handlers.resolve(this.promise, value);
                };
                QueueItem.prototype.otherCallFulfilled = function(value) {
                    unwrap(this.promise, this.onFulfilled, value);
                };
                QueueItem.prototype.callRejected = function(value) {
                    handlers.reject(this.promise, value);
                };
                QueueItem.prototype.otherCallRejected = function(value) {
                    unwrap(this.promise, this.onRejected, value);
                };
                function unwrap(promise, func, value) {
                    immediate(function() {
                        var returnValue;
                        try {
                            returnValue = func(value);
                        } catch (e) {
                            return handlers.reject(promise, e);
                        }
                        if (returnValue === promise) handlers.reject(promise, new TypeError("Cannot resolve promise with itself"));
                        else handlers.resolve(promise, returnValue);
                    });
                }
                handlers.resolve = function(self1, value) {
                    var result = tryCatch(getThen, value);
                    if (result.status === "error") return handlers.reject(self1, result.value);
                    var thenable = result.value;
                    if (thenable) safelyResolveThenable(self1, thenable);
                    else {
                        self1.state = FULFILLED;
                        self1.outcome = value;
                        var i = -1;
                        var len = self1.queue.length;
                        while(++i < len)self1.queue[i].callFulfilled(value);
                    }
                    return self1;
                };
                handlers.reject = function(self1, error) {
                    self1.state = REJECTED;
                    self1.outcome = error;
                    var i = -1;
                    var len = self1.queue.length;
                    while(++i < len)self1.queue[i].callRejected(error);
                    return self1;
                };
                function getThen(obj) {
                    // Make sure we only access the accessor once as required by the spec
                    var then = obj && obj.then;
                    if (obj && (typeof obj === "object" || typeof obj === "function") && typeof then === "function") return function appyThen() {
                        then.apply(obj, arguments);
                    };
                }
                function safelyResolveThenable(self1, thenable) {
                    // Either fulfill, reject or reject with error
                    var called = false;
                    function onError(value) {
                        if (called) return;
                        called = true;
                        handlers.reject(self1, value);
                    }
                    function onSuccess(value) {
                        if (called) return;
                        called = true;
                        handlers.resolve(self1, value);
                    }
                    function tryToUnwrap() {
                        thenable(onSuccess, onError);
                    }
                    var result = tryCatch(tryToUnwrap);
                    if (result.status === "error") onError(result.value);
                }
                function tryCatch(func, value) {
                    var out = {};
                    try {
                        out.value = func(value);
                        out.status = "success";
                    } catch (e) {
                        out.status = "error";
                        out.value = e;
                    }
                    return out;
                }
                Promise1.resolve = resolve;
                function resolve(value) {
                    if (value instanceof this) return value;
                    return handlers.resolve(new this(INTERNAL), value);
                }
                Promise1.reject = reject;
                function reject(reason) {
                    var promise = new this(INTERNAL);
                    return handlers.reject(promise, reason);
                }
                Promise1.all = all;
                function all(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var values = new Array(len);
                    var resolved = 0;
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)allResolver(iterable[i], i);
                    return promise;
                    function allResolver(value, i) {
                        self1.resolve(value).then(resolveFromAll, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                        function resolveFromAll(outValue) {
                            values[i] = outValue;
                            if (++resolved === len && !called) {
                                called = true;
                                handlers.resolve(promise, values);
                            }
                        }
                    }
                }
                Promise1.race = race;
                function race(iterable) {
                    var self1 = this;
                    if (Object.prototype.toString.call(iterable) !== "[object Array]") return this.reject(new TypeError("must be an array"));
                    var len = iterable.length;
                    var called = false;
                    if (!len) return this.resolve([]);
                    var i = -1;
                    var promise = new this(INTERNAL);
                    while(++i < len)resolver(iterable[i]);
                    return promise;
                    function resolver(value) {
                        self1.resolve(value).then(function(response) {
                            if (!called) {
                                called = true;
                                handlers.resolve(promise, response);
                            }
                        }, function(error) {
                            if (!called) {
                                called = true;
                                handlers.reject(promise, error);
                            }
                        });
                    }
                }
            },
            {
                "1": 1
            }
        ],
        3: [
            function(_dereq_, module1, exports) {
                (function(global1) {
                    "use strict";
                    if (typeof global1.Promise !== "function") global1.Promise = _dereq_(2);
                }).call(this, typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
            },
            {
                "2": 2
            }
        ],
        4: [
            function(_dereq_, module1, exports) {
                "use strict";
                var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function getIDB() {
                    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */ try {
                        if (typeof indexedDB !== "undefined") return indexedDB;
                        if (typeof webkitIndexedDB !== "undefined") return webkitIndexedDB;
                        if (typeof mozIndexedDB !== "undefined") return mozIndexedDB;
                        if (typeof OIndexedDB !== "undefined") return OIndexedDB;
                        if (typeof msIndexedDB !== "undefined") return msIndexedDB;
                    } catch (e) {
                        return;
                    }
                }
                var idb = getIDB();
                function isIndexedDBValid() {
                    try {
                        // Initialize IndexedDB; fall back to vendor-prefixed versions
                        // if needed.
                        if (!idb || !idb.open) return false;
                        // We mimic PouchDB here;
                        //
                        // We test for openDatabase because IE Mobile identifies itself
                        // as Safari. Oh the lulz...
                        var isSafari = typeof openDatabase !== "undefined" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
                        var hasFetch = typeof fetch === "function" && fetch.toString().indexOf("[native code") !== -1;
                        // Safari <10.1 does not meet our requirements for IDB support
                        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
                        // Safari 10.1 shipped with fetch, we can use that to detect it.
                        // Note: this creates issues with `window.fetch` polyfills and
                        // overrides; see:
                        // https://github.com/localForage/localForage/issues/856
                        return (!isSafari || hasFetch) && typeof indexedDB !== "undefined" && // some outdated implementations of IDB that appear on Samsung
                        // and HTC Android devices <4.4 are missing IDBKeyRange
                        // See: https://github.com/mozilla/localForage/issues/128
                        // See: https://github.com/mozilla/localForage/issues/272
                        typeof IDBKeyRange !== "undefined";
                    } catch (e) {
                        return false;
                    }
                }
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                // Abstracts constructing a Blob object, so it also works in older
                // browsers that don't support the native Blob constructor. (i.e.
                // old QtWebKit versions, at least).
                function createBlob(parts, properties) {
                    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */ parts = parts || [];
                    properties = properties || {};
                    try {
                        return new Blob(parts, properties);
                    } catch (e) {
                        if (e.name !== "TypeError") throw e;
                        var Builder = typeof BlobBuilder !== "undefined" ? BlobBuilder : typeof MSBlobBuilder !== "undefined" ? MSBlobBuilder : typeof MozBlobBuilder !== "undefined" ? MozBlobBuilder : WebKitBlobBuilder;
                        var builder = new Builder();
                        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
                        return builder.getBlob(properties.type);
                    }
                }
                // This is CommonJS because lie is an external dependency, so Rollup
                // can just ignore it.
                if (typeof Promise === "undefined") // In the "nopromises" build this will just throw if you don't have
                // a global promise object, but it would throw anyway later.
                _dereq_(3);
                var Promise$1 = Promise;
                function executeCallback(promise, callback) {
                    if (callback) promise.then(function(result) {
                        callback(null, result);
                    }, function(error) {
                        callback(error);
                    });
                }
                function executeTwoCallbacks(promise, callback, errorCallback) {
                    if (typeof callback === "function") promise.then(callback);
                    if (typeof errorCallback === "function") promise["catch"](errorCallback);
                }
                function normalizeKey(key) {
                    // Cast the key to a string, as that's all we can set as a key.
                    if (typeof key !== "string") {
                        console.warn(key + " used as a key, but it is not a string.");
                        key = String(key);
                    }
                    return key;
                }
                function getCallback() {
                    if (arguments.length && typeof arguments[arguments.length - 1] === "function") return arguments[arguments.length - 1];
                }
                // Some code originally from async_storage.js in
                // [Gaia](https://github.com/mozilla-b2g/gaia).
                var DETECT_BLOB_SUPPORT_STORE = "local-forage-detect-blob-support";
                var supportsBlobs = void 0;
                var dbContexts = {};
                var toString = Object.prototype.toString;
                // Transaction Modes
                var READ_ONLY = "readonly";
                var READ_WRITE = "readwrite";
                // Transform a binary string to an array buffer, because otherwise
                // weird stuff happens when you try to work with the binary string directly.
                // It is known.
                // From http://stackoverflow.com/questions/14967647/ (continues on next line)
                // encode-decode-image-with-base64-breaks-image (2013-04-21)
                function _binStringToArrayBuffer(bin) {
                    var length = bin.length;
                    var buf = new ArrayBuffer(length);
                    var arr = new Uint8Array(buf);
                    for(var i = 0; i < length; i++)arr[i] = bin.charCodeAt(i);
                    return buf;
                }
                //
                // Blobs are not supported in all versions of IndexedDB, notably
                // Chrome <37 and Android <5. In those versions, storing a blob will throw.
                //
                // Various other blob bugs exist in Chrome v37-42 (inclusive).
                // Detecting them is expensive and confusing to users, and Chrome 37-42
                // is at very low usage worldwide, so we do a hacky userAgent check instead.
                //
                // content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
                // 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
                // FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
                //
                // Code borrowed from PouchDB. See:
                // https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
                //
                function _checkBlobSupportWithoutCaching(idb) {
                    return new Promise$1(function(resolve) {
                        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
                        var blob = createBlob([
                            ""
                        ]);
                        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, "key");
                        txn.onabort = function(e) {
                            // If the transaction aborts now its due to not being able to
                            // write to the database, likely due to the disk being full
                            e.preventDefault();
                            e.stopPropagation();
                            resolve(false);
                        };
                        txn.oncomplete = function() {
                            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                            var matchedEdge = navigator.userAgent.match(/Edge\//);
                            // MS Edge pretends to be Chrome 42:
                            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
                            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
                        };
                    })["catch"](function() {
                        return false; // error, so assume unsupported
                    });
                }
                function _checkBlobSupport(idb) {
                    if (typeof supportsBlobs === "boolean") return Promise$1.resolve(supportsBlobs);
                    return _checkBlobSupportWithoutCaching(idb).then(function(value) {
                        supportsBlobs = value;
                        return supportsBlobs;
                    });
                }
                function _deferReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Create a deferred object representing the current database operation.
                    var deferredOperation = {};
                    deferredOperation.promise = new Promise$1(function(resolve, reject) {
                        deferredOperation.resolve = resolve;
                        deferredOperation.reject = reject;
                    });
                    // Enqueue the deferred operation.
                    dbContext.deferredOperations.push(deferredOperation);
                    // Chain its promise to the database readiness.
                    if (!dbContext.dbReady) dbContext.dbReady = deferredOperation.promise;
                    else dbContext.dbReady = dbContext.dbReady.then(function() {
                        return deferredOperation.promise;
                    });
                }
                function _advanceReadiness(dbInfo) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Resolve its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.resolve();
                        return deferredOperation.promise;
                    }
                }
                function _rejectReadiness(dbInfo, err) {
                    var dbContext = dbContexts[dbInfo.name];
                    // Dequeue a deferred operation.
                    var deferredOperation = dbContext.deferredOperations.pop();
                    // Reject its promise (which is part of the database readiness
                    // chain of promises).
                    if (deferredOperation) {
                        deferredOperation.reject(err);
                        return deferredOperation.promise;
                    }
                }
                function _getConnection(dbInfo, upgradeNeeded) {
                    return new Promise$1(function(resolve, reject) {
                        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
                        if (dbInfo.db) {
                            if (upgradeNeeded) {
                                _deferReadiness(dbInfo);
                                dbInfo.db.close();
                            } else return resolve(dbInfo.db);
                        }
                        var dbArgs = [
                            dbInfo.name
                        ];
                        if (upgradeNeeded) dbArgs.push(dbInfo.version);
                        var openreq = idb.open.apply(idb, dbArgs);
                        if (upgradeNeeded) openreq.onupgradeneeded = function(e) {
                            var db = openreq.result;
                            try {
                                db.createObjectStore(dbInfo.storeName);
                                if (e.oldVersion <= 1) // Added when support for blob shims was added
                                db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                            } catch (ex) {
                                if (ex.name === "ConstraintError") console.warn('The database "' + dbInfo.name + '"' + " has been upgraded from version " + e.oldVersion + " to version " + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                                else throw ex;
                            }
                        };
                        openreq.onerror = function(e) {
                            e.preventDefault();
                            reject(openreq.error);
                        };
                        openreq.onsuccess = function() {
                            var db = openreq.result;
                            db.onversionchange = function(e) {
                                // Triggered when the database is modified (e.g. adding an objectStore) or
                                // deleted (even when initiated by other sessions in different tabs).
                                // Closing the connection here prevents those operations from being blocked.
                                // If the database is accessed again later by this instance, the connection
                                // will be reopened or the database recreated as needed.
                                e.target.close();
                            };
                            resolve(db);
                            _advanceReadiness(dbInfo);
                        };
                    });
                }
                function _getOriginalConnection(dbInfo) {
                    return _getConnection(dbInfo, false);
                }
                function _getUpgradedConnection(dbInfo) {
                    return _getConnection(dbInfo, true);
                }
                function _isUpgradeNeeded(dbInfo, defaultVersion) {
                    if (!dbInfo.db) return true;
                    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
                    var isDowngrade = dbInfo.version < dbInfo.db.version;
                    var isUpgrade = dbInfo.version > dbInfo.db.version;
                    if (isDowngrade) {
                        // If the version is not the default one
                        // then warn for impossible downgrade.
                        if (dbInfo.version !== defaultVersion) console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + " to version " + dbInfo.version + ".");
                        // Align the versions to prevent errors.
                        dbInfo.version = dbInfo.db.version;
                    }
                    if (isUpgrade || isNewStore) {
                        // If the store is new then increment the version (if needed).
                        // This will trigger an "upgradeneeded" event which is required
                        // for creating a store.
                        if (isNewStore) {
                            var incVersion = dbInfo.db.version + 1;
                            if (incVersion > dbInfo.version) dbInfo.version = incVersion;
                        }
                        return true;
                    }
                    return false;
                }
                // encode a blob for indexeddb engines that don't support blobs
                function _encodeBlob(blob) {
                    return new Promise$1(function(resolve, reject) {
                        var reader = new FileReader();
                        reader.onerror = reject;
                        reader.onloadend = function(e) {
                            var base64 = btoa(e.target.result || "");
                            resolve({
                                __local_forage_encoded_blob: true,
                                data: base64,
                                type: blob.type
                            });
                        };
                        reader.readAsBinaryString(blob);
                    });
                }
                // decode an encoded blob
                function _decodeBlob(encodedBlob) {
                    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
                    return createBlob([
                        arrayBuff
                    ], {
                        type: encodedBlob.type
                    });
                }
                // is this one of our fancy encoded blobs?
                function _isEncodedBlob(value) {
                    return value && value.__local_forage_encoded_blob;
                }
                // Specialize the default `ready()` function by making it dependent
                // on the current database operations. Thus, the driver will be actually
                // ready when it's been initialized (default) *and* there are no pending
                // operations on the database (initiated by some other instances).
                function _fullyReady(callback) {
                    var self1 = this;
                    var promise = self1._initReady().then(function() {
                        var dbContext = dbContexts[self1._dbInfo.name];
                        if (dbContext && dbContext.dbReady) return dbContext.dbReady;
                    });
                    executeTwoCallbacks(promise, callback, callback);
                    return promise;
                }
                // Try to establish a new db connection to replace the
                // current one which is broken (i.e. experiencing
                // InvalidStateError while creating a transaction).
                function _tryReconnect(dbInfo) {
                    _deferReadiness(dbInfo);
                    var dbContext = dbContexts[dbInfo.name];
                    var forages = dbContext.forages;
                    for(var i = 0; i < forages.length; i++){
                        var forage = forages[i];
                        if (forage._dbInfo.db) {
                            forage._dbInfo.db.close();
                            forage._dbInfo.db = null;
                        }
                    }
                    dbInfo.db = null;
                    return _getOriginalConnection(dbInfo).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        // store the latest db reference
                        // in case the db was upgraded
                        dbInfo.db = dbContext.db = db;
                        for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                    })["catch"](function(err) {
                        _rejectReadiness(dbInfo, err);
                        throw err;
                    });
                }
                // FF doesn't like Promises (micro-tasks) and IDDB store operations,
                // so we have to do it with callbacks
                function createTransaction(dbInfo, mode, callback, retries) {
                    if (retries === undefined) retries = 1;
                    try {
                        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
                        callback(null, tx);
                    } catch (err) {
                        if (retries > 0 && (!dbInfo.db || err.name === "InvalidStateError" || err.name === "NotFoundError")) return Promise$1.resolve().then(function() {
                            if (!dbInfo.db || err.name === "NotFoundError" && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                                // increase the db version, to create the new ObjectStore
                                if (dbInfo.db) dbInfo.version = dbInfo.db.version + 1;
                                // Reopen the database for upgrading.
                                return _getUpgradedConnection(dbInfo);
                            }
                        }).then(function() {
                            return _tryReconnect(dbInfo).then(function() {
                                createTransaction(dbInfo, mode, callback, retries - 1);
                            });
                        })["catch"](callback);
                        callback(err);
                    }
                }
                function createDbContext() {
                    return {
                        // Running localForages sharing a database.
                        forages: [],
                        // Shared database.
                        db: null,
                        // Database readiness (promise).
                        dbReady: null,
                        // Deferred operations on the database.
                        deferredOperations: []
                    };
                }
                // Open the IndexedDB database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    // Get the current context of the database;
                    var dbContext = dbContexts[dbInfo.name];
                    // ...or create a new context.
                    if (!dbContext) {
                        dbContext = createDbContext();
                        // Register the new context in the global container.
                        dbContexts[dbInfo.name] = dbContext;
                    }
                    // Register itself as a running localForage in the current context.
                    dbContext.forages.push(self1);
                    // Replace the default `ready()` function with the specialized one.
                    if (!self1._initReady) {
                        self1._initReady = self1.ready;
                        self1.ready = _fullyReady;
                    }
                    // Create an array of initialization states of the related localForages.
                    var initPromises = [];
                    function ignoreErrors() {
                        // Don't handle errors here,
                        // just makes sure related localForages aren't pending.
                        return Promise$1.resolve();
                    }
                    for(var j = 0; j < dbContext.forages.length; j++){
                        var forage = dbContext.forages[j];
                        if (forage !== self1) // Don't wait for itself...
                        initPromises.push(forage._initReady()["catch"](ignoreErrors));
                    }
                    // Take a snapshot of the related localForages.
                    var forages = dbContext.forages.slice(0);
                    // Initialize the connection process only when
                    // all the related localForages aren't pending.
                    return Promise$1.all(initPromises).then(function() {
                        dbInfo.db = dbContext.db;
                        // Get the connection or open a new one without upgrade.
                        return _getOriginalConnection(dbInfo);
                    }).then(function(db) {
                        dbInfo.db = db;
                        if (_isUpgradeNeeded(dbInfo, self1._defaultConfig.version)) // Reopen the database for upgrading.
                        return _getUpgradedConnection(dbInfo);
                        return db;
                    }).then(function(db) {
                        dbInfo.db = dbContext.db = db;
                        self1._dbInfo = dbInfo;
                        // Share the final connection amongst related localForages.
                        for(var k = 0; k < forages.length; k++){
                            var forage = forages[k];
                            if (forage !== self1) {
                                // Self is already up-to-date.
                                forage._dbInfo.db = dbInfo.db;
                                forage._dbInfo.version = dbInfo.version;
                            }
                        }
                    });
                }
                function getItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.get(key);
                                    req.onsuccess = function() {
                                        var value = req.result;
                                        if (value === undefined) value = null;
                                        if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                        resolve(value);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items stored in database.
                function iterate(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openCursor();
                                    var iterationNumber = 1;
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (cursor) {
                                            var value = cursor.value;
                                            if (_isEncodedBlob(value)) value = _decodeBlob(value);
                                            var result = iterator(value, cursor.key, iterationNumber++);
                                            // when the iterator callback returns any
                                            // (non-`undefined`) value, then we stop
                                            // the iteration immediately
                                            if (result !== void 0) resolve(result);
                                            else cursor["continue"]();
                                        } else resolve();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        var dbInfo;
                        self1.ready().then(function() {
                            dbInfo = self1._dbInfo;
                            if (toString.call(value) === "[object Blob]") return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                                if (blobSupport) return value;
                                return _encodeBlob(value);
                            });
                            return value;
                        }).then(function(value) {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // The reason we don't _save_ null is because IE 10 does
                                    // not support saving the `null` type in IndexedDB. How
                                    // ironic, given the bug below!
                                    // See: https://github.com/mozilla/localForage/issues/161
                                    if (value === null) value = undefined;
                                    var req = store.put(value, key);
                                    transaction.oncomplete = function() {
                                        // Cast to undefined so the value passed to
                                        // callback/promise is the same as what one would get out
                                        // of `getItem()` later. This leads to some weirdness
                                        // (setItem('foo', undefined) will return `null`), but
                                        // it's not my fault localStorage is our baseline and that
                                        // it's weird.
                                        if (value === undefined) value = null;
                                        resolve(value);
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function removeItem(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    // We use a Grunt task to make this safe for IE and some
                                    // versions of Android (including those used by Cordova).
                                    // Normally IE won't like `.delete()` and will insist on
                                    // using `['delete']()`, but we have a build step that
                                    // fixes this for us now.
                                    var req = store["delete"](key);
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onerror = function() {
                                        reject(req.error);
                                    };
                                    // The request will be also be aborted if we've exceeded our storage
                                    // space.
                                    transaction.onabort = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function clear(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_WRITE, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.clear();
                                    transaction.oncomplete = function() {
                                        resolve();
                                    };
                                    transaction.onabort = transaction.onerror = function() {
                                        var err = req.error ? req.error : req.transaction.error;
                                        reject(err);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function length(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.count();
                                    req.onsuccess = function() {
                                        resolve(req.result);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function key(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        if (n < 0) {
                            resolve(null);
                            return;
                        }
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var advanced = false;
                                    var req = store.openKeyCursor();
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            // this means there weren't enough keys
                                            resolve(null);
                                            return;
                                        }
                                        if (n === 0) // We have the first key, return it if that's what they
                                        // wanted.
                                        resolve(cursor.key);
                                        else if (!advanced) {
                                            // Otherwise, ask the cursor to skip ahead n
                                            // records.
                                            advanced = true;
                                            cursor.advance(n);
                                        } else // When we get here, we've got the nth key.
                                        resolve(cursor.key);
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            createTransaction(self1._dbInfo, READ_ONLY, function(err, transaction) {
                                if (err) return reject(err);
                                try {
                                    var store = transaction.objectStore(self1._dbInfo.storeName);
                                    var req = store.openKeyCursor();
                                    var keys = [];
                                    req.onsuccess = function() {
                                        var cursor = req.result;
                                        if (!cursor) {
                                            resolve(keys);
                                            return;
                                        }
                                        keys.push(cursor.key);
                                        cursor["continue"]();
                                    };
                                    req.onerror = function() {
                                        reject(req.error);
                                    };
                                } catch (e) {
                                    reject(e);
                                }
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else {
                        var isCurrentDb = options.name === currentConfig.name && self1._dbInfo.db;
                        var dbPromise = isCurrentDb ? Promise$1.resolve(self1._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            dbContext.db = db;
                            for(var i = 0; i < forages.length; i++)forages[i]._dbInfo.db = db;
                            return db;
                        });
                        if (!options.storeName) promise = dbPromise.then(function(db) {
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                            }
                            var dropDBPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.deleteDatabase(options.name);
                                req.onerror = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    reject(req.error);
                                };
                                req.onblocked = function() {
                                    // Closing all open connections in onversionchange handler should prevent this situation, but if
                                    // we do get here, it just means the request remains pending - eventually it will succeed or error
                                    console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    if (db) db.close();
                                    resolve(db);
                                };
                            });
                            return dropDBPromise.then(function(db) {
                                dbContext.db = db;
                                for(var i = 0; i < forages.length; i++){
                                    var _forage = forages[i];
                                    _advanceReadiness(_forage._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                        else promise = dbPromise.then(function(db) {
                            if (!db.objectStoreNames.contains(options.storeName)) return;
                            var newVersion = db.version + 1;
                            _deferReadiness(options);
                            var dbContext = dbContexts[options.name];
                            var forages = dbContext.forages;
                            db.close();
                            for(var i = 0; i < forages.length; i++){
                                var forage = forages[i];
                                forage._dbInfo.db = null;
                                forage._dbInfo.version = newVersion;
                            }
                            var dropObjectPromise = new Promise$1(function(resolve, reject) {
                                var req = idb.open(options.name, newVersion);
                                req.onerror = function(err) {
                                    var db = req.result;
                                    db.close();
                                    reject(err);
                                };
                                req.onupgradeneeded = function() {
                                    var db = req.result;
                                    db.deleteObjectStore(options.storeName);
                                };
                                req.onsuccess = function() {
                                    var db = req.result;
                                    db.close();
                                    resolve(db);
                                };
                            });
                            return dropObjectPromise.then(function(db) {
                                dbContext.db = db;
                                for(var j = 0; j < forages.length; j++){
                                    var _forage2 = forages[j];
                                    _forage2._dbInfo.db = db;
                                    _advanceReadiness(_forage2._dbInfo);
                                }
                            })["catch"](function(err) {
                                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {});
                                throw err;
                            });
                        });
                    }
                    executeCallback(promise, callback);
                    return promise;
                }
                var asyncStorage = {
                    _driver: "asyncStorage",
                    _initStorage: _initStorage,
                    _support: isIndexedDBValid(),
                    iterate: iterate,
                    getItem: getItem,
                    setItem: setItem,
                    removeItem: removeItem,
                    clear: clear,
                    length: length,
                    key: key,
                    keys: keys,
                    dropInstance: dropInstance
                };
                function isWebSQLValid() {
                    return typeof openDatabase === "function";
                }
                // Sadly, the best way to save binary data in WebSQL/localStorage is serializing
                // it to Base64, so this is how we store it to prevent very strange errors with less
                // verbose ways of binary <-> string data storage.
                var BASE_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
                var BLOB_TYPE_PREFIX = "~~local_forage_type~";
                var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
                var SERIALIZED_MARKER = "__lfsc__:";
                var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
                // OMG the serializations!
                var TYPE_ARRAYBUFFER = "arbf";
                var TYPE_BLOB = "blob";
                var TYPE_INT8ARRAY = "si08";
                var TYPE_UINT8ARRAY = "ui08";
                var TYPE_UINT8CLAMPEDARRAY = "uic8";
                var TYPE_INT16ARRAY = "si16";
                var TYPE_INT32ARRAY = "si32";
                var TYPE_UINT16ARRAY = "ur16";
                var TYPE_UINT32ARRAY = "ui32";
                var TYPE_FLOAT32ARRAY = "fl32";
                var TYPE_FLOAT64ARRAY = "fl64";
                var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
                var toString$1 = Object.prototype.toString;
                function stringToBuffer(serializedString) {
                    // Fill the string into a ArrayBuffer.
                    var bufferLength = serializedString.length * 0.75;
                    var len = serializedString.length;
                    var i;
                    var p = 0;
                    var encoded1, encoded2, encoded3, encoded4;
                    if (serializedString[serializedString.length - 1] === "=") {
                        bufferLength--;
                        if (serializedString[serializedString.length - 2] === "=") bufferLength--;
                    }
                    var buffer = new ArrayBuffer(bufferLength);
                    var bytes = new Uint8Array(buffer);
                    for(i = 0; i < len; i += 4){
                        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
                        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
                        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
                        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
                        /*jslint bitwise: true */ bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
                    }
                    return buffer;
                }
                // Converts a buffer to a string to store, serialized, in the backend
                // storage library.
                function bufferToString(buffer) {
                    // base64-arraybuffer
                    var bytes = new Uint8Array(buffer);
                    var base64String = "";
                    var i;
                    for(i = 0; i < bytes.length; i += 3){
                        /*jslint bitwise: true */ base64String += BASE_CHARS[bytes[i] >> 2];
                        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                        base64String += BASE_CHARS[bytes[i + 2] & 63];
                    }
                    if (bytes.length % 3 === 2) base64String = base64String.substring(0, base64String.length - 1) + "=";
                    else if (bytes.length % 3 === 1) base64String = base64String.substring(0, base64String.length - 2) + "==";
                    return base64String;
                }
                // Serialize a value, afterwards executing a callback (which usually
                // instructs the `setItem()` callback/promise to be executed). This is how
                // we store binary data with localStorage.
                function serialize(value, callback) {
                    var valueType = "";
                    if (value) valueType = toString$1.call(value);
                    // Cannot use `value instanceof ArrayBuffer` or such here, as these
                    // checks fail when running the tests using casper.js...
                    //
                    // TODO: See why those tests fail and use a better solution.
                    if (value && (valueType === "[object ArrayBuffer]" || value.buffer && toString$1.call(value.buffer) === "[object ArrayBuffer]")) {
                        // Convert binary arrays to a string and prefix the string with
                        // a special marker.
                        var buffer;
                        var marker = SERIALIZED_MARKER;
                        if (value instanceof ArrayBuffer) {
                            buffer = value;
                            marker += TYPE_ARRAYBUFFER;
                        } else {
                            buffer = value.buffer;
                            if (valueType === "[object Int8Array]") marker += TYPE_INT8ARRAY;
                            else if (valueType === "[object Uint8Array]") marker += TYPE_UINT8ARRAY;
                            else if (valueType === "[object Uint8ClampedArray]") marker += TYPE_UINT8CLAMPEDARRAY;
                            else if (valueType === "[object Int16Array]") marker += TYPE_INT16ARRAY;
                            else if (valueType === "[object Uint16Array]") marker += TYPE_UINT16ARRAY;
                            else if (valueType === "[object Int32Array]") marker += TYPE_INT32ARRAY;
                            else if (valueType === "[object Uint32Array]") marker += TYPE_UINT32ARRAY;
                            else if (valueType === "[object Float32Array]") marker += TYPE_FLOAT32ARRAY;
                            else if (valueType === "[object Float64Array]") marker += TYPE_FLOAT64ARRAY;
                            else callback(new Error("Failed to get type for BinaryArray"));
                        }
                        callback(marker + bufferToString(buffer));
                    } else if (valueType === "[object Blob]") {
                        // Conver the blob to a binaryArray and then to a string.
                        var fileReader = new FileReader();
                        fileReader.onload = function() {
                            // Backwards-compatible prefix for the blob type.
                            var str = BLOB_TYPE_PREFIX + value.type + "~" + bufferToString(this.result);
                            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
                        };
                        fileReader.readAsArrayBuffer(value);
                    } else try {
                        callback(JSON.stringify(value));
                    } catch (e) {
                        console.error("Couldn't convert value into a JSON string: ", value);
                        callback(null, e);
                    }
                }
                // Deserialize data we've inserted into a value column/field. We place
                // special markers into our strings to mark them as encoded; this isn't
                // as nice as a meta field, but it's the only sane thing we can do whilst
                // keeping localStorage support intact.
                //
                // Oftentimes this will just deserialize JSON content, but if we have a
                // special marker (SERIALIZED_MARKER, defined above), we will extract
                // some kind of arraybuffer/binary data/typed array out of the string.
                function deserialize(value) {
                    // If we haven't marked this string as being specially serialized (i.e.
                    // something other than serialized JSON), we can just return it and be
                    // done with it.
                    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) return JSON.parse(value);
                    // The following code deals with deserializing some kind of Blob or
                    // TypedArray. First we separate out the type of data we're dealing
                    // with from the data itself.
                    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
                    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
                    var blobType;
                    // Backwards-compatible blob type serialization strategy.
                    // DBs created with older versions of localForage will simply not have the blob type.
                    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
                        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
                        blobType = matcher[1];
                        serializedString = serializedString.substring(matcher[0].length);
                    }
                    var buffer = stringToBuffer(serializedString);
                    // Return the right type based on the code/type set during
                    // serialization.
                    switch(type){
                        case TYPE_ARRAYBUFFER:
                            return buffer;
                        case TYPE_BLOB:
                            return createBlob([
                                buffer
                            ], {
                                type: blobType
                            });
                        case TYPE_INT8ARRAY:
                            return new Int8Array(buffer);
                        case TYPE_UINT8ARRAY:
                            return new Uint8Array(buffer);
                        case TYPE_UINT8CLAMPEDARRAY:
                            return new Uint8ClampedArray(buffer);
                        case TYPE_INT16ARRAY:
                            return new Int16Array(buffer);
                        case TYPE_UINT16ARRAY:
                            return new Uint16Array(buffer);
                        case TYPE_INT32ARRAY:
                            return new Int32Array(buffer);
                        case TYPE_UINT32ARRAY:
                            return new Uint32Array(buffer);
                        case TYPE_FLOAT32ARRAY:
                            return new Float32Array(buffer);
                        case TYPE_FLOAT64ARRAY:
                            return new Float64Array(buffer);
                        default:
                            throw new Error("Unkown type: " + type);
                    }
                }
                var localforageSerializer = {
                    serialize: serialize,
                    deserialize: deserialize,
                    stringToBuffer: stringToBuffer,
                    bufferToString: bufferToString
                };
                /*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */ function createDbTable(t, dbInfo, callback, errorCallback) {
                    t.executeSql("CREATE TABLE IF NOT EXISTS " + dbInfo.storeName + " " + "(id INTEGER PRIMARY KEY, key unique, value)", [], callback, errorCallback);
                }
                // Open the WebSQL database (automatically creates one if one didn't
                // previously exist), using any options set in the config.
                function _initStorage$1(options) {
                    var self1 = this;
                    var dbInfo = {
                        db: null
                    };
                    if (options) for(var i in options)dbInfo[i] = typeof options[i] !== "string" ? options[i].toString() : options[i];
                    var dbInfoPromise = new Promise$1(function(resolve, reject) {
                        // Open the database; the openDatabase API will automatically
                        // create it for us if it doesn't exist.
                        try {
                            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
                        } catch (e) {
                            return reject(e);
                        }
                        // Create our key/value table if it doesn't exist.
                        dbInfo.db.transaction(function(t) {
                            createDbTable(t, dbInfo, function() {
                                self1._dbInfo = dbInfo;
                                resolve();
                            }, function(t, error) {
                                reject(error);
                            });
                        }, reject);
                    });
                    dbInfo.serializer = localforageSerializer;
                    return dbInfoPromise;
                }
                function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
                    t.executeSql(sqlStatement, args, callback, function(t, error) {
                        if (error.code === error.SYNTAX_ERR) t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [
                            dbInfo.storeName
                        ], function(t, results) {
                            if (!results.rows.length) // if the table is missing (was deleted)
                            // re-create it table and retry
                            createDbTable(t, dbInfo, function() {
                                t.executeSql(sqlStatement, args, callback, errorCallback);
                            }, errorCallback);
                            else errorCallback(t, error);
                        }, errorCallback);
                        else errorCallback(t, error);
                    }, errorCallback);
                }
                function getItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName + " WHERE key = ? LIMIT 1", [
                                    key
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).value : null;
                                    // Check to see if this is serialized content we need to
                                    // unpack.
                                    if (result) result = dbInfo.serializer.deserialize(result);
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function iterate$1(iterator, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName, [], function(t, results) {
                                    var rows = results.rows;
                                    var length = rows.length;
                                    for(var i = 0; i < length; i++){
                                        var item = rows.item(i);
                                        var result = item.value;
                                        // Check to see if this is serialized content
                                        // we need to unpack.
                                        if (result) result = dbInfo.serializer.deserialize(result);
                                        result = iterator(result, item.key, i + 1);
                                        // void(0) prevents problems with redefinition
                                        // of `undefined`.
                                        if (result !== void 0) {
                                            resolve(result);
                                            return;
                                        }
                                    }
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function _setItem(key, value, callback, retriesLeft) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            // The localStorage API doesn't return undefined values in an
                            // "expected" way, so undefined is always cast to null in all
                            // drivers. See: https://github.com/mozilla/localForage/pull/42
                            if (value === undefined) value = null;
                            // Save the original value to pass to the callback.
                            var originalValue = value;
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else dbInfo.db.transaction(function(t) {
                                    tryExecuteSql(t, dbInfo, "INSERT OR REPLACE INTO " + dbInfo.storeName + " " + "(key, value) VALUES (?, ?)", [
                                        key,
                                        value
                                    ], function() {
                                        resolve(originalValue);
                                    }, function(t, error) {
                                        reject(error);
                                    });
                                }, function(sqlError) {
                                    // The transaction failed; check
                                    // to see if it's a quota error.
                                    if (sqlError.code === sqlError.QUOTA_ERR) {
                                        // We reject the callback outright for now, but
                                        // it's worth trying to re-run the transaction.
                                        // Even if the user accepts the prompt to use
                                        // more storage on Safari, this error will
                                        // be called.
                                        //
                                        // Try to re-run the transaction.
                                        if (retriesLeft > 0) {
                                            resolve(_setItem.apply(self1, [
                                                key,
                                                originalValue,
                                                callback,
                                                retriesLeft - 1
                                            ]));
                                            return;
                                        }
                                        reject(sqlError);
                                    }
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function setItem$1(key, value, callback) {
                    return _setItem.apply(this, [
                        key,
                        value,
                        callback,
                        1
                    ]);
                }
                function removeItem$1(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName + " WHERE key = ?", [
                                    key
                                ], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Deletes every item in the table.
                // TODO: Find out if this resets the AUTO_INCREMENT number.
                function clear$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName, [], function() {
                                    resolve();
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Does a simple `COUNT(key)` to get the number of items stored in
                // localForage.
                function length$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                // Ahhh, SQL makes this one soooooo easy.
                                tryExecuteSql(t, dbInfo, "SELECT COUNT(key) as c FROM " + dbInfo.storeName, [], function(t, results) {
                                    var result = results.rows.item(0).c;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Return the key located at key index X; essentially gets the key from a
                // `WHERE id = ?`. This is the most efficient way I can think to implement
                // this rarely-used (in my experience) part of the API, but it can seem
                // inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
                // the ID of each key will change every time it's updated. Perhaps a stored
                // procedure for the `setItem()` SQL would solve this problem?
                // TODO: Don't change ID on `setItem()`.
                function key$1(n, callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName + " WHERE id = ? LIMIT 1", [
                                    n + 1
                                ], function(t, results) {
                                    var result = results.rows.length ? results.rows.item(0).key : null;
                                    resolve(result);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$1(callback) {
                    var self1 = this;
                    var promise = new Promise$1(function(resolve, reject) {
                        self1.ready().then(function() {
                            var dbInfo = self1._dbInfo;
                            dbInfo.db.transaction(function(t) {
                                tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName, [], function(t, results) {
                                    var keys = [];
                                    for(var i = 0; i < results.rows.length; i++)keys.push(results.rows.item(i).key);
                                    resolve(keys);
                                }, function(t, error) {
                                    reject(error);
                                });
                            });
                        })["catch"](reject);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // https://www.w3.org/TR/webdatabase/#databases
                // > There is no way to enumerate or delete the databases available for an origin from this API.
                function getAllStoreNames(db) {
                    return new Promise$1(function(resolve, reject) {
                        db.transaction(function(t) {
                            t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t, results) {
                                var storeNames = [];
                                for(var i = 0; i < results.rows.length; i++)storeNames.push(results.rows.item(i).name);
                                resolve({
                                    db: db,
                                    storeNames: storeNames
                                });
                            }, function(t, error) {
                                reject(error);
                            });
                        }, function(sqlError) {
                            reject(sqlError);
                        });
                    });
                }
                function dropInstance$1(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    var currentConfig = this.config();
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else promise = new Promise$1(function(resolve) {
                        var db;
                        if (options.name === currentConfig.name) // use the db reference of the current instance
                        db = self1._dbInfo.db;
                        else db = openDatabase(options.name, "", "", 0);
                        if (!options.storeName) // drop all database tables
                        resolve(getAllStoreNames(db));
                        else resolve({
                            db: db,
                            storeNames: [
                                options.storeName
                            ]
                        });
                    }).then(function(operationInfo) {
                        return new Promise$1(function(resolve, reject) {
                            operationInfo.db.transaction(function(t) {
                                function dropTable(storeName) {
                                    return new Promise$1(function(resolve, reject) {
                                        t.executeSql("DROP TABLE IF EXISTS " + storeName, [], function() {
                                            resolve();
                                        }, function(t, error) {
                                            reject(error);
                                        });
                                    });
                                }
                                var operations = [];
                                for(var i = 0, len = operationInfo.storeNames.length; i < len; i++)operations.push(dropTable(operationInfo.storeNames[i]));
                                Promise$1.all(operations).then(function() {
                                    resolve();
                                })["catch"](function(e) {
                                    reject(e);
                                });
                            }, function(sqlError) {
                                reject(sqlError);
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var webSQLStorage = {
                    _driver: "webSQLStorage",
                    _initStorage: _initStorage$1,
                    _support: isWebSQLValid(),
                    iterate: iterate$1,
                    getItem: getItem$1,
                    setItem: setItem$1,
                    removeItem: removeItem$1,
                    clear: clear$1,
                    length: length$1,
                    key: key$1,
                    keys: keys$1,
                    dropInstance: dropInstance$1
                };
                function isLocalStorageValid() {
                    try {
                        return typeof localStorage !== "undefined" && "setItem" in localStorage && // in IE8 typeof localStorage.setItem === 'object'
                        !!localStorage.setItem;
                    } catch (e) {
                        return false;
                    }
                }
                function _getKeyPrefix(options, defaultConfig) {
                    var keyPrefix = options.name + "/";
                    if (options.storeName !== defaultConfig.storeName) keyPrefix += options.storeName + "/";
                    return keyPrefix;
                }
                // Check if localStorage throws when saving an item
                function checkIfLocalStorageThrows() {
                    var localStorageTestKey = "_localforage_support_test";
                    try {
                        localStorage.setItem(localStorageTestKey, true);
                        localStorage.removeItem(localStorageTestKey);
                        return false;
                    } catch (e) {
                        return true;
                    }
                }
                // Check if localStorage is usable and allows to save an item
                // This method checks if localStorage is usable in Safari Private Browsing
                // mode, or in any other case where the available quota for localStorage
                // is 0 and there wasn't any saved items yet.
                function _isLocalStorageUsable() {
                    return !checkIfLocalStorageThrows() || localStorage.length > 0;
                }
                // Config the localStorage backend, using options set in the config.
                function _initStorage$2(options) {
                    var self1 = this;
                    var dbInfo = {};
                    if (options) for(var i in options)dbInfo[i] = options[i];
                    dbInfo.keyPrefix = _getKeyPrefix(options, self1._defaultConfig);
                    if (!_isLocalStorageUsable()) return Promise$1.reject();
                    self1._dbInfo = dbInfo;
                    dbInfo.serializer = localforageSerializer;
                    return Promise$1.resolve();
                }
                // Remove all keys from the datastore, effectively destroying all data in
                // the app's key/value store!
                function clear$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var keyPrefix = self1._dbInfo.keyPrefix;
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Retrieve an item from the store. Unlike the original async_storage
                // library in Gaia, we don't modify return values at all. If a key's value
                // is `undefined`, we pass that value to the callback function.
                function getItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result = localStorage.getItem(dbInfo.keyPrefix + key);
                        // If a result was found, parse it from the serialized
                        // string into a JS object. If result isn't truthy, the key
                        // is likely undefined and we'll pass it straight to the
                        // callback.
                        if (result) result = dbInfo.serializer.deserialize(result);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Iterate over all items in the store.
                function iterate$2(iterator, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var keyPrefix = dbInfo.keyPrefix;
                        var keyPrefixLength = keyPrefix.length;
                        var length = localStorage.length;
                        // We use a dedicated iterator instead of the `i` variable below
                        // so other keys we fetch in localStorage aren't counted in
                        // the `iterationNumber` argument passed to the `iterate()`
                        // callback.
                        //
                        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
                        var iterationNumber = 1;
                        for(var i = 0; i < length; i++){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) !== 0) continue;
                            var value = localStorage.getItem(key);
                            // If a result was found, parse it from the serialized
                            // string into a JS object. If result isn't truthy, the
                            // key is likely undefined and we'll pass it straight
                            // to the iterator.
                            if (value) value = dbInfo.serializer.deserialize(value);
                            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);
                            if (value !== void 0) return value;
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Same as localStorage's key() method, except takes a callback.
                function key$2(n, callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var result;
                        try {
                            result = localStorage.key(n);
                        } catch (error) {
                            result = null;
                        }
                        // Remove the prefix from the key, if a key is found.
                        if (result) result = result.substring(dbInfo.keyPrefix.length);
                        return result;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function keys$2(callback) {
                    var self1 = this;
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        var length = localStorage.length;
                        var keys = [];
                        for(var i = 0; i < length; i++){
                            var itemKey = localStorage.key(i);
                            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) keys.push(itemKey.substring(dbInfo.keyPrefix.length));
                        }
                        return keys;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Supply the number of keys in the datastore to the callback function.
                function length$2(callback) {
                    var self1 = this;
                    var promise = self1.keys().then(function(keys) {
                        return keys.length;
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Remove an item from the store, nice and simple.
                function removeItem$2(key, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        var dbInfo = self1._dbInfo;
                        localStorage.removeItem(dbInfo.keyPrefix + key);
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                // Set a key's value and run an optional callback once the value is set.
                // Unlike Gaia's implementation, the callback function is passed the value,
                // in case you want to operate on that value only after you're sure it
                // saved, or something like that.
                function setItem$2(key, value, callback) {
                    var self1 = this;
                    key = normalizeKey(key);
                    var promise = self1.ready().then(function() {
                        // Convert undefined values to null.
                        // https://github.com/mozilla/localForage/pull/42
                        if (value === undefined) value = null;
                        // Save the original value to pass to the callback.
                        var originalValue = value;
                        return new Promise$1(function(resolve, reject) {
                            var dbInfo = self1._dbInfo;
                            dbInfo.serializer.serialize(value, function(value, error) {
                                if (error) reject(error);
                                else try {
                                    localStorage.setItem(dbInfo.keyPrefix + key, value);
                                    resolve(originalValue);
                                } catch (e) {
                                    // localStorage capacity exceeded.
                                    // TODO: Make this a specific error/event.
                                    if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") reject(e);
                                    reject(e);
                                }
                            });
                        });
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                function dropInstance$2(options, callback) {
                    callback = getCallback.apply(this, arguments);
                    options = typeof options !== "function" && options || {};
                    if (!options.name) {
                        var currentConfig = this.config();
                        options.name = options.name || currentConfig.name;
                        options.storeName = options.storeName || currentConfig.storeName;
                    }
                    var self1 = this;
                    var promise;
                    if (!options.name) promise = Promise$1.reject("Invalid arguments");
                    else promise = new Promise$1(function(resolve) {
                        if (!options.storeName) resolve(options.name + "/");
                        else resolve(_getKeyPrefix(options, self1._defaultConfig));
                    }).then(function(keyPrefix) {
                        for(var i = localStorage.length - 1; i >= 0; i--){
                            var key = localStorage.key(i);
                            if (key.indexOf(keyPrefix) === 0) localStorage.removeItem(key);
                        }
                    });
                    executeCallback(promise, callback);
                    return promise;
                }
                var localStorageWrapper = {
                    _driver: "localStorageWrapper",
                    _initStorage: _initStorage$2,
                    _support: isLocalStorageValid(),
                    iterate: iterate$2,
                    getItem: getItem$2,
                    setItem: setItem$2,
                    removeItem: removeItem$2,
                    clear: clear$2,
                    length: length$2,
                    key: key$2,
                    keys: keys$2,
                    dropInstance: dropInstance$2
                };
                var sameValue = function sameValue(x, y) {
                    return x === y || typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y);
                };
                var includes = function includes(array, searchElement) {
                    var len = array.length;
                    var i = 0;
                    while(i < len){
                        if (sameValue(array[i], searchElement)) return true;
                        i++;
                    }
                    return false;
                };
                var isArray = Array.isArray || function(arg) {
                    return Object.prototype.toString.call(arg) === "[object Array]";
                };
                // Drivers are stored here when `defineDriver()` is called.
                // They are shared across all instances of localForage.
                var DefinedDrivers = {};
                var DriverSupport = {};
                var DefaultDrivers = {
                    INDEXEDDB: asyncStorage,
                    WEBSQL: webSQLStorage,
                    LOCALSTORAGE: localStorageWrapper
                };
                var DefaultDriverOrder = [
                    DefaultDrivers.INDEXEDDB._driver,
                    DefaultDrivers.WEBSQL._driver,
                    DefaultDrivers.LOCALSTORAGE._driver
                ];
                var OptionalDriverMethods = [
                    "dropInstance"
                ];
                var LibraryMethods = [
                    "clear",
                    "getItem",
                    "iterate",
                    "key",
                    "keys",
                    "length",
                    "removeItem",
                    "setItem"
                ].concat(OptionalDriverMethods);
                var DefaultConfig = {
                    description: "",
                    driver: DefaultDriverOrder.slice(),
                    name: "localforage",
                    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
                    // we can use without a prompt.
                    size: 4980736,
                    storeName: "keyvaluepairs",
                    version: 1.0
                };
                function callWhenReady(localForageInstance, libraryMethod) {
                    localForageInstance[libraryMethod] = function() {
                        var _args = arguments;
                        return localForageInstance.ready().then(function() {
                            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
                        });
                    };
                }
                function extend() {
                    for(var i = 1; i < arguments.length; i++){
                        var arg = arguments[i];
                        if (arg) {
                            for(var _key in arg)if (arg.hasOwnProperty(_key)) {
                                if (isArray(arg[_key])) arguments[0][_key] = arg[_key].slice();
                                else arguments[0][_key] = arg[_key];
                            }
                        }
                    }
                    return arguments[0];
                }
                var LocalForage = function() {
                    function LocalForage(options) {
                        _classCallCheck(this, LocalForage);
                        for(var driverTypeKey in DefaultDrivers)if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                            var driver = DefaultDrivers[driverTypeKey];
                            var driverName = driver._driver;
                            this[driverTypeKey] = driverName;
                            if (!DefinedDrivers[driverName]) // we don't need to wait for the promise,
                            // since the default drivers can be defined
                            // in a blocking manner
                            this.defineDriver(driver);
                        }
                        this._defaultConfig = extend({}, DefaultConfig);
                        this._config = extend({}, this._defaultConfig, options);
                        this._driverSet = null;
                        this._initDriver = null;
                        this._ready = false;
                        this._dbInfo = null;
                        this._wrapLibraryMethodsWithReady();
                        this.setDriver(this._config.driver)["catch"](function() {});
                    }
                    // Set any config values for localForage; can be called anytime before
                    // the first API call (e.g. `getItem`, `setItem`).
                    // We loop through options so we don't overwrite existing config
                    // values.
                    LocalForage.prototype.config = function config(options) {
                        // If the options argument is an object, we use it to set values.
                        // Otherwise, we return either a specified config value or all
                        // config values.
                        if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object") {
                            // If localforage is ready and fully initialized, we can't set
                            // any new configuration values. Instead, we return an error.
                            if (this._ready) return new Error("Can't call config() after localforage has been used.");
                            for(var i in options){
                                if (i === "storeName") options[i] = options[i].replace(/\W/g, "_");
                                if (i === "version" && typeof options[i] !== "number") return new Error("Database version must be a number.");
                                this._config[i] = options[i];
                            }
                            // after all config options are set and
                            // the driver option is used, try setting it
                            if ("driver" in options && options.driver) return this.setDriver(this._config.driver);
                            return true;
                        } else if (typeof options === "string") return this._config[options];
                        else return this._config;
                    };
                    // Used to define a custom driver, shared across all instances of
                    // localForage.
                    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
                        var promise = new Promise$1(function(resolve, reject) {
                            try {
                                var driverName = driverObject._driver;
                                var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                                // A driver name should be defined and not overlap with the
                                // library-defined, default drivers.
                                if (!driverObject._driver) {
                                    reject(complianceError);
                                    return;
                                }
                                var driverMethods = LibraryMethods.concat("_initStorage");
                                for(var i = 0, len = driverMethods.length; i < len; i++){
                                    var driverMethodName = driverMethods[i];
                                    // when the property is there,
                                    // it should be a method even when optional
                                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== "function") {
                                        reject(complianceError);
                                        return;
                                    }
                                }
                                var configureMissingMethods = function configureMissingMethods() {
                                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                                        return function() {
                                            var error = new Error("Method " + methodName + " is not implemented by the current driver");
                                            var promise = Promise$1.reject(error);
                                            executeCallback(promise, arguments[arguments.length - 1]);
                                            return promise;
                                        };
                                    };
                                    for(var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++){
                                        var optionalDriverMethod = OptionalDriverMethods[_i];
                                        if (!driverObject[optionalDriverMethod]) driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                                    }
                                };
                                configureMissingMethods();
                                var setDriverSupport = function setDriverSupport(support) {
                                    if (DefinedDrivers[driverName]) console.info("Redefining LocalForage driver: " + driverName);
                                    DefinedDrivers[driverName] = driverObject;
                                    DriverSupport[driverName] = support;
                                    // don't use a then, so that we can define
                                    // drivers that have simple _support methods
                                    // in a blocking manner
                                    resolve();
                                };
                                if ("_support" in driverObject) {
                                    if (driverObject._support && typeof driverObject._support === "function") driverObject._support().then(setDriverSupport, reject);
                                    else setDriverSupport(!!driverObject._support);
                                } else setDriverSupport(true);
                            } catch (e) {
                                reject(e);
                            }
                        });
                        executeTwoCallbacks(promise, callback, errorCallback);
                        return promise;
                    };
                    LocalForage.prototype.driver = function driver() {
                        return this._driver || null;
                    };
                    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
                        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error("Driver not found."));
                        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
                        return getDriverPromise;
                    };
                    LocalForage.prototype.getSerializer = function getSerializer(callback) {
                        var serializerPromise = Promise$1.resolve(localforageSerializer);
                        executeTwoCallbacks(serializerPromise, callback);
                        return serializerPromise;
                    };
                    LocalForage.prototype.ready = function ready(callback) {
                        var self1 = this;
                        var promise = self1._driverSet.then(function() {
                            if (self1._ready === null) self1._ready = self1._initDriver();
                            return self1._ready;
                        });
                        executeTwoCallbacks(promise, callback, callback);
                        return promise;
                    };
                    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
                        var self1 = this;
                        if (!isArray(drivers)) drivers = [
                            drivers
                        ];
                        var supportedDrivers = this._getSupportedDrivers(drivers);
                        function setDriverToConfig() {
                            self1._config.driver = self1.driver();
                        }
                        function extendSelfWithDriver(driver) {
                            self1._extend(driver);
                            setDriverToConfig();
                            self1._ready = self1._initStorage(self1._config);
                            return self1._ready;
                        }
                        function initDriver(supportedDrivers) {
                            return function() {
                                var currentDriverIndex = 0;
                                function driverPromiseLoop() {
                                    while(currentDriverIndex < supportedDrivers.length){
                                        var driverName = supportedDrivers[currentDriverIndex];
                                        currentDriverIndex++;
                                        self1._dbInfo = null;
                                        self1._ready = null;
                                        return self1.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                                    }
                                    setDriverToConfig();
                                    var error = new Error("No available storage method found.");
                                    self1._driverSet = Promise$1.reject(error);
                                    return self1._driverSet;
                                }
                                return driverPromiseLoop();
                            };
                        }
                        // There might be a driver initialization in progress
                        // so wait for it to finish in order to avoid a possible
                        // race condition to set _dbInfo
                        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                            return Promise$1.resolve();
                        }) : Promise$1.resolve();
                        this._driverSet = oldDriverSetDone.then(function() {
                            var driverName = supportedDrivers[0];
                            self1._dbInfo = null;
                            self1._ready = null;
                            return self1.getDriver(driverName).then(function(driver) {
                                self1._driver = driver._driver;
                                setDriverToConfig();
                                self1._wrapLibraryMethodsWithReady();
                                self1._initDriver = initDriver(supportedDrivers);
                            });
                        })["catch"](function() {
                            setDriverToConfig();
                            var error = new Error("No available storage method found.");
                            self1._driverSet = Promise$1.reject(error);
                            return self1._driverSet;
                        });
                        executeTwoCallbacks(this._driverSet, callback, errorCallback);
                        return this._driverSet;
                    };
                    LocalForage.prototype.supports = function supports(driverName) {
                        return !!DriverSupport[driverName];
                    };
                    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
                        extend(this, libraryMethodsAndProperties);
                    };
                    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
                        var supportedDrivers = [];
                        for(var i = 0, len = drivers.length; i < len; i++){
                            var driverName = drivers[i];
                            if (this.supports(driverName)) supportedDrivers.push(driverName);
                        }
                        return supportedDrivers;
                    };
                    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
                        // Add a stub for each driver API method that delays the call to the
                        // corresponding driver method until localForage is ready. These stubs
                        // will be replaced by the driver methods as soon as the driver is
                        // loaded, so there is no performance impact.
                        for(var i = 0, len = LibraryMethods.length; i < len; i++)callWhenReady(this, LibraryMethods[i]);
                    };
                    LocalForage.prototype.createInstance = function createInstance(options) {
                        return new LocalForage(options);
                    };
                    return LocalForage;
                }();
                // The actual localForage object that we expose as a module or via a
                // global. It's extended by pulling in one of our other libraries.
                var localforage_js = new LocalForage();
                module1.exports = localforage_js;
            },
            {
                "3": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});

});

parcelRequire.register("gJdz0", function(module, exports) {

$parcel$export(module.exports, "default", () => $506a7de3e51b12a4$export$2e2bcd8739ae039);
var $506a7de3e51b12a4$var$StorageKey;
(function(StorageKey) {
    StorageKey[/** Stores the libp2p pub/priv key pair. */ "PeerId"] = "farnsworth/peer-id";
    StorageKey[/** Stores WebRTC connection preferences.  */ "WebrtcSettings"] = "farnsworth/webrtc-settings";
})($506a7de3e51b12a4$var$StorageKey || ($506a7de3e51b12a4$var$StorageKey = {}));
var $506a7de3e51b12a4$export$2e2bcd8739ae039 = $506a7de3e51b12a4$var$StorageKey;

});



parcelRequire.register("yJV7z", function(module, exports) {

$parcel$export(module.exports, "add", () => $f58f8f1c0bddfa58$export$e16d8520af44a096);
$parcel$export(module.exports, "pause", () => $f58f8f1c0bddfa58$export$229c72e5fdee233b);
$parcel$export(module.exports, "resume", () => $f58f8f1c0bddfa58$export$fbb4d68fe60c1629);
$parcel$export(module.exports, "toggle", () => $f58f8f1c0bddfa58$export$e03c1c3201ee8bb7);
$parcel$export(module.exports, "sendLocalTracks", () => $f58f8f1c0bddfa58$export$251a134232031c51);

var $kBs7x = parcelRequire("kBs7x");

var $7W5YA = parcelRequire("7W5YA");

var $kXV5G = parcelRequire("kXV5G");

var $5X8kA = parcelRequire("5X8kA");
function $f58f8f1c0bddfa58$var$getTrackById(id) {
    const track = (0, $7W5YA.default).tracks.get(id);
    (0, $kBs7x.default)(track, `No such track (id="${id}")`);
    return track;
}
function $f58f8f1c0bddfa58$export$e16d8520af44a096({ track: track, peerId: peerId, source: source }) {
    (0, $7W5YA.default).tracks.set(track.id, track);
    return {
        peerId: peerId,
        track: {
            id: track.id,
            kind: track.kind,
            enabled: track.enabled,
            source: source
        }
    };
}
function $f58f8f1c0bddfa58$export$229c72e5fdee233b(trackId) {
    const track = $f58f8f1c0bddfa58$var$getTrackById(trackId);
    track.enabled = false;
    (0, $5X8kA.broadcastEvent)({
        type: (0, $kXV5G.EventType).Pause,
        payload: {
            kind: track.kind
        }
    });
    return trackId;
}
function $f58f8f1c0bddfa58$export$fbb4d68fe60c1629(trackId) {
    const track = $f58f8f1c0bddfa58$var$getTrackById(trackId);
    track.enabled = true;
    (0, $5X8kA.broadcastEvent)({
        type: (0, $kXV5G.EventType).Resume,
        payload: {
            kind: track.kind
        }
    });
    return trackId;
}
function $f58f8f1c0bddfa58$export$e03c1c3201ee8bb7(trackId) {
    const track = $f58f8f1c0bddfa58$var$getTrackById(trackId);
    const act = track.enabled ? $f58f8f1c0bddfa58$export$229c72e5fdee233b : $f58f8f1c0bddfa58$export$fbb4d68fe60c1629;
    return act(trackId);
}
function $f58f8f1c0bddfa58$export$251a134232031c51(state) {
    Object.entries(state.tracks).filter(([id])=>(0, $7W5YA.default).tracks.has(id)).filter(([, meta])=>meta.local).forEach(([id, meta])=>{
        const track = $f58f8f1c0bddfa58$var$getTrackById(id);
        Array.from((0, $7W5YA.default).connections.values()).forEach((conn)=>{
            conn.addTrack(track, meta.source);
        });
    });
}

});
parcelRequire.register("5X8kA", function(module, exports) {

$parcel$export(module.exports, "broadcastEvent", () => $bfb9b6cfce9ffd69$export$efa52ebd44f979f);

var $7W5YA = parcelRequire("7W5YA");
function $bfb9b6cfce9ffd69$export$efa52ebd44f979f(event) {
    Array.from((0, $7W5YA.default).connections.values()).forEach((conn)=>{
        conn.messenger.sendEvent(event);
    });
}

});


parcelRequire.register("gmvC5", function(module, exports) {

$parcel$export(module.exports, "sendMessage", () => $3b27d5e51c3b535f$export$465cb47180de50f0);

var $kXV5G = parcelRequire("kXV5G");

var $5lVTw = parcelRequire("5lVTw");
function $3b27d5e51c3b535f$export$465cb47180de50f0(envelope) {
    const conn = (0, $5lVTw.getConnectionById)(envelope.remoteId);
    conn.messenger.sendEvent({
        type: (0, $kXV5G.EventType).ChatMessage,
        payload: envelope.msg
    });
    return envelope;
}

});

parcelRequire.register("3NpDV", function(module, exports) {

$parcel$export(module.exports, "run", () => $7c1801b19ac2666e$export$889ea624f2cb2c57);
$parcel$export(module.exports, "discardUnusedTracks", () => $7c1801b19ac2666e$export$c2c31ffd26b73c14);
$parcel$export(module.exports, "discardUnusedConnections", () => $7c1801b19ac2666e$export$f3cf2e854812f6f7);

var $7W5YA = parcelRequire("7W5YA");

var $fRjbn = parcelRequire("fRjbn");
const $7c1801b19ac2666e$var$logger = new (0, $fRjbn.default)("gc");
function $7c1801b19ac2666e$export$889ea624f2cb2c57(state) {
    $7c1801b19ac2666e$export$c2c31ffd26b73c14(state);
    $7c1801b19ac2666e$export$f3cf2e854812f6f7(state);
}
function $7c1801b19ac2666e$export$c2c31ffd26b73c14(state) {
    Array.from((0, $7W5YA.default).tracks.values()).filter(function isOrphanTrack(track) {
        return !state.tracks.hasOwnProperty(track.id);
    }).forEach(function discardTrack(track) {
        $7c1801b19ac2666e$var$logger.debug("Deleting dereferenced track:", track.id);
        $7c1801b19ac2666e$var$removeTrackFromAllConnections(track);
        (0, $7W5YA.default).tracks.delete(track.id);
        track.stop();
    });
}
function $7c1801b19ac2666e$export$f3cf2e854812f6f7(state) {
    Array.from((0, $7W5YA.default).connections.entries()).filter(function isOrphanConnection([peerId]) {
        return !state.participants.hasOwnProperty(peerId);
    }).forEach(function discardConnection([peerId, conn]) {
        $7c1801b19ac2666e$var$logger.debug("Deleting dereferenced connection:", peerId);
        (0, $7W5YA.default).connections.delete(peerId);
        conn.close();
    });
}
// `.removeTrack(...)` is graceful. Even if we weren't sending the track, the
// function will handle it just fine.
function $7c1801b19ac2666e$var$removeTrackFromAllConnections(track) {
    Array.from((0, $7W5YA.default).connections.values()).forEach((conn)=>{
        conn.removeTrack(track);
    });
}

});

parcelRequire.register("9fjTl", function(module, exports) {

$parcel$export(module.exports, "load", () => $1da7e0595da2985a$export$11e63f7b0f3d9900);
$parcel$export(module.exports, "update", () => $1da7e0595da2985a$export$722fbec263ad908a);
$parcel$export(module.exports, "reset", () => $1da7e0595da2985a$export$aad8462122ac592b);

var $edPLI = parcelRequire("edPLI");

var $gJdz0 = parcelRequire("gJdz0");

var $gM2lt = parcelRequire("gM2lt");

var $fRjbn = parcelRequire("fRjbn");
const $1da7e0595da2985a$var$DEFAULT_SETTINGS = (0, $gM2lt.default).settings.webrtc;
const $1da7e0595da2985a$var$logger = new (0, $fRjbn.default)("settings");
async function $1da7e0595da2985a$export$11e63f7b0f3d9900() {
    const settings = await (0, (/*@__PURE__*/$parcel$interopDefault($edPLI))).getItem((0, $gJdz0.default).WebrtcSettings);
    if (!settings) return $1da7e0595da2985a$var$DEFAULT_SETTINGS;
    // Apply defaults as well. We may add new keys in the future.
    return {
        ...$1da7e0595da2985a$var$DEFAULT_SETTINGS,
        ...settings
    };
}
async function $1da7e0595da2985a$export$722fbec263ad908a(updates) {
    $1da7e0595da2985a$var$logger.debug("Updating WebRTC settings:", updates);
    const oldSettings = await $1da7e0595da2985a$export$11e63f7b0f3d9900();
    await (0, (/*@__PURE__*/$parcel$interopDefault($edPLI))).setItem((0, $gJdz0.default).WebrtcSettings, {
        ...oldSettings,
        ...updates
    });
}
async function $1da7e0595da2985a$export$aad8462122ac592b() {
    $1da7e0595da2985a$var$logger.debug("Clearing WebRTC settings.");
    await (0, (/*@__PURE__*/$parcel$interopDefault($edPLI))).removeItem((0, $gJdz0.default).WebrtcSettings);
}

});
parcelRequire.register("gM2lt", function(module, exports) {

$parcel$export(module.exports, "PanelView", () => $4b9cc31d1f7f56a5$export$155ca5d268e0664d);
$parcel$export(module.exports, "default", () => $4b9cc31d1f7f56a5$export$2e2bcd8739ae039);

var $kXV5G = parcelRequire("kXV5G");
var $4b9cc31d1f7f56a5$export$155ca5d268e0664d;
(function(PanelView) {
    PanelView[/** Panel is closed */ "None"] = "none";
    PanelView[/** Chat messages */ "Chat"] = "chat";
    PanelView[/** Device management and advanced settings */ "Settings"] = "settings";
})($4b9cc31d1f7f56a5$export$155ca5d268e0664d || ($4b9cc31d1f7f56a5$export$155ca5d268e0664d = {}));
const $4b9cc31d1f7f56a5$var$initialState = {
    route: {
        id: "/",
        pathName: "/",
        params: {}
    },
    relay: null,
    call: null,
    participants: {
        [(0, $kXV5G.MY_PARTICIPANT_ID)]: {
            isMe: true,
            trackIds: [],
            connection: {
                state: (0, $kXV5G.ConnectionState).Connected
            },
            chat: {
                history: []
            }
        }
    },
    tracks: {},
    sources: {
        error: null,
        changes: [],
        available: {
            audio: [],
            video: []
        }
    },
    phonebook: {
        open: false
    },
    chat: {
        unreadMessages: false
    },
    settings: {
        webrtc: {
            forceTurnRelay: false,
            disableDefaultIceServers: false,
            customIceServers: []
        }
    },
    panel: {
        lastView: $4b9cc31d1f7f56a5$export$155ca5d268e0664d.Chat,
        view: $4b9cc31d1f7f56a5$export$155ca5d268e0664d.None
    }
};
var $4b9cc31d1f7f56a5$export$2e2bcd8739ae039 = $4b9cc31d1f7f56a5$var$initialState;

});




parcelRequire.register("5i9lw", function(module, exports) {

$parcel$export(module.exports, "middleware", () => $5ab54987cd3ac17d$export$5a7767152ae0305f);
parcelRequire("3jRC4");
var $yJV7z = parcelRequire("yJV7z");
function $5ab54987cd3ac17d$export$5a7767152ae0305f(store) {
    return (next)=>(action)=>{
            const dispatchReturnValue = next(action);
            const state = store.getState();
            $yJV7z.sendLocalTracks(state);
            return dispatchReturnValue;
        };
}

});

parcelRequire.register("hMIKI", function(module, exports) {

$parcel$export(module.exports, "default", () => $09132acebb27ec90$export$2e2bcd8739ae039);

var $l8ESH = parcelRequire("l8ESH");

var $8P5Z0 = parcelRequire("8P5Z0");

var $4LAPt = parcelRequire("4LAPt");

var $kGFY6 = parcelRequire("kGFY6");

var $2BDcu = parcelRequire("2BDcu");

var $f4Yo8 = parcelRequire("f4Yo8");

var $bRnOP = parcelRequire("bRnOP");

var $4DHYq = parcelRequire("4DHYq");

var $JhVEw = parcelRequire("JhVEw");

var $3ORhH = parcelRequire("3ORhH");
var $09132acebb27ec90$export$2e2bcd8739ae039 = [
    (0, $3ORhH.default),
    (0, $8P5Z0.default),
    (0, $bRnOP.default),
    (0, $kGFY6.default),
    (0, $4LAPt.default),
    (0, $4DHYq.default),
    (0, $l8ESH.default),
    (0, $2BDcu.default),
    (0, $JhVEw.default),
    (0, $f4Yo8.default)
];

});
parcelRequire.register("l8ESH", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc1d7317bac9201d$export$2e2bcd8739ae039);

var $9M2QW = parcelRequire("9M2QW");

var $gM2lt = parcelRequire("gM2lt");
parcelRequire("kSNfV");
var $irnr8 = parcelRequire("irnr8");
var $fc1d7317bac9201d$export$2e2bcd8739ae039 = (0, $9M2QW.default)((0, $gM2lt.default), (handleAction)=>[
        handleAction($irnr8.open, (state)=>{
            state.phonebook.open = true;
        }),
        handleAction($irnr8.close, (state)=>{
            state.phonebook.open = false;
        }),
        handleAction($irnr8.toggle, (state)=>{
            state.phonebook.open = !state.phonebook.open;
        })
    ]);

});
parcelRequire.register("9M2QW", function(module, exports) {

$parcel$export(module.exports, "default", () => $71dacf4bdb8c8e87$export$2e2bcd8739ae039);

var $3n3B3 = parcelRequire("3n3B3");

var $ikPr1 = parcelRequire("ikPr1");

var $cyIYg = parcelRequire("cyIYg");

var $kdAjr = parcelRequire("kdAjr");

var $dyIqw = parcelRequire("dyIqw");
function $71dacf4bdb8c8e87$export$2e2bcd8739ae039(initialState, reducerFactory) {
    (0, $kdAjr.default)(typeof reducerFactory === "function", "createReducer(...) expects a function."); // Wait until the first time the reducer is called before constructing the
    // reducer map. It's a semi-common pattern to share constants between
    // actions and reducers, which means the two files may form a circular
    // dependency. By the time `createReducer(...)` is called, those actions
    // could be undefined.
    var lazilyCreateActionMap = (0, $cyIYg.default)(function() {
        var reducers = reducerFactory((0, $3n3B3.default));
        (0, $kdAjr.default)(typeof reducers !== "undefined", "createReducer(...) expects a list of action handlers (got undefined).");
        var actionMap = (0, $ikPr1.default)(reducers);
        return actionMap;
    });
    var reducer = function reducer() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
        var action = arguments.length > 1 ? arguments[1] : undefined;
        var actionMap = lazilyCreateActionMap();
        var handlers = actionMap.get(action.type);
        if (!handlers) return state;
        var reducersForActionType = (0, $dyIqw.isActionFailure)(action) ? handlers.error : (0, $dyIqw.isOptimisticAction)(action) ? handlers.optimistic : handlers.success;
        return reducersForActionType.reduce(function(state, reducer) {
            return reducer(state, action.payload);
        }, state);
    };
    return reducer;
} // `createReducer` has a circular type which makes the definition somewhat
 // tedious. We can't define `handleAction` without knowing how you're calling
 // `createReducer`, and we can't define how to call `createReducer` without
 // knowing the type for `handleAction`. The state and reducer types are
 // codependent.
 //
 // Lifting `handleAction` to a parametrized interface allows us to express the
 // type for the reducer parameter and in turn, `createReducer`.

});
parcelRequire.register("3n3B3", function(module, exports) {

$parcel$export(module.exports, "default", () => $27464f490d0090c6$export$2e2bcd8739ae039);

var $kdAjr = parcelRequire("kdAjr");

var $Bjwyt = parcelRequire("Bjwyt");

var $aRGRv = parcelRequire("aRGRv");
var $27464f490d0090c6$var$assertValidArguments = function assertValidArguments(actionCreator, reducer) {
    (0, $kdAjr.default)(actionCreator !== undefined, "handleAction(...) expects an action creator (given undefined).");
    (0, $kdAjr.default)(typeof reducer === "function", "handleAction(...) expects a reducer function.");
};
var $27464f490d0090c6$var$handleAction = function handleAction(actionCreator, reducer) {
    $27464f490d0090c6$var$assertValidArguments(actionCreator, reducer);
    return {
        actionType: (0, $Bjwyt.default)(actionCreator),
        reducerType: (0, $aRGRv.default).Success,
        reducer: reducer
    };
};
$27464f490d0090c6$var$handleAction.error = function(actionCreator, reducer) {
    $27464f490d0090c6$var$assertValidArguments(actionCreator, reducer);
    return {
        actionType: (0, $Bjwyt.default)(actionCreator),
        reducerType: (0, $aRGRv.default).Error,
        reducer: reducer
    };
};
$27464f490d0090c6$var$handleAction.optimistic = function(actionCreator, reducer) {
    $27464f490d0090c6$var$assertValidArguments(actionCreator, reducer);
    return {
        actionType: (0, $Bjwyt.default)(actionCreator),
        reducerType: (0, $aRGRv.default).Optimistic,
        reducer: reducer
    };
};
var $27464f490d0090c6$export$2e2bcd8739ae039 = $27464f490d0090c6$var$handleAction;

});
parcelRequire.register("kdAjr", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb81307556c464b8$export$2e2bcd8739ae039);
// Because package dependencies are a pain to maintain.
function $eb81307556c464b8$export$2e2bcd8739ae039(condition, message) {
    if (!condition) throw new Error(message);
}

});

parcelRequire.register("Bjwyt", function(module, exports) {

$parcel$export(module.exports, "default", () => $070299e44df9d500$export$2e2bcd8739ae039);
// `createAction(...)` coerces to its action constant. This utility function
// grabs that constant.

var $kLCxi = parcelRequire("kLCxi");

var $kdAjr = parcelRequire("kdAjr");
function $070299e44df9d500$export$2e2bcd8739ae039(actionCreator) {
    if (typeof actionCreator === "string") return actionCreator;
    if ((0, $kLCxi.ACTION_TYPE) in Object(actionCreator)) return actionCreator[0, $kLCxi.ACTION_TYPE];
    (0, $kdAjr.default)(typeof actionCreator === "function", "Expected an action creator or action type.");
    return String(actionCreator);
}

});
parcelRequire.register("kLCxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1e616dd71016624$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ACTION_TYPE", () => $f1e616dd71016624$export$406d74ad0c50bfb1);

var $gawS6 = parcelRequire("gawS6");

var $3erk0 = parcelRequire("3erk0");
function $f1e616dd71016624$export$2e2bcd8739ae039(actionType) {
    var _ref;
    return _ref = {}, (0, (/*@__PURE__*/$parcel$interopDefault($gawS6)))(_ref, $f1e616dd71016624$export$406d74ad0c50bfb1, actionType), (0, (/*@__PURE__*/$parcel$interopDefault($gawS6)))(_ref, "success", function success(payload) {
        return {
            type: actionType,
            payload: payload
        };
    }), (0, (/*@__PURE__*/$parcel$interopDefault($gawS6)))(_ref, "failure", function failure(error) {
        return {
            type: actionType,
            error: true,
            payload: error
        };
    }), (0, (/*@__PURE__*/$parcel$interopDefault($gawS6)))(_ref, "optimistic", function optimistic(payload) {
        return {
            type: actionType,
            payload: payload,
            meta: {
                phase: (0, $3erk0.default).Optimistic
            }
        };
    }), _ref;
}
var $f1e616dd71016624$export$406d74ad0c50bfb1 = Symbol("retreon:action-type");

});
parcelRequire.register("gawS6", function(module, exports) {

var $2Nj7a = parcelRequire("2Nj7a");
function $bc571422d086ed23$var$_defineProperty(e, r, t) {
    return (r = $2Nj7a(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $bc571422d086ed23$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("2Nj7a", function(module, exports) {

var $9zrNF = parcelRequire("9zrNF");
var $208efc1f055a68d1$var$_typeof = $9zrNF.default;

var $egqJ6 = parcelRequire("egqJ6");
function $208efc1f055a68d1$var$toPropertyKey(t) {
    var i = $egqJ6(t, "string");
    return "symbol" == $208efc1f055a68d1$var$_typeof(i) ? i : i + "";
}
module.exports = $208efc1f055a68d1$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("egqJ6", function(module, exports) {

var $9zrNF = parcelRequire("9zrNF");
var $a6274aa28e01a8f7$var$_typeof = $9zrNF.default;
function $a6274aa28e01a8f7$var$toPrimitive(t, r) {
    if ("object" != $a6274aa28e01a8f7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a6274aa28e01a8f7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $a6274aa28e01a8f7$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("3erk0", function(module, exports) {

$parcel$export(module.exports, "default", () => $25a7df6d18869ea3$export$2e2bcd8739ae039);
/**
 * `Phase` represents different phases of the same action. The specific use
 * case is optimistic updates: we need a way to distinguish an optimistic
 * action from a finished action of the same type.
 *
 * Technically for completeness there should be "Fulfilled" and "Rejected"
 * phases, but it's implicit with the lack of `Optimistic` and `error: true`.
 * There's value in keeping action objects as minimal as possible.
 *
 * If you're feeling bored, there's an interesting discussion about approaches
 * to optimistic actions on the FSA repo:
 * https://github.com/redux-utilities/flux-standard-action/issues/7
 * @private
 */ var $25a7df6d18869ea3$var$Phase;
(function(Phase) {
    Phase["Optimistic"] = "optimistic";
})($25a7df6d18869ea3$var$Phase || ($25a7df6d18869ea3$var$Phase = {}));
var $25a7df6d18869ea3$export$2e2bcd8739ae039 = $25a7df6d18869ea3$var$Phase;

});



parcelRequire.register("aRGRv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e901a1d6b1c5d94$export$2e2bcd8739ae039);
/**
 * `ReducerType` represents a different mode of the same action, such as
 * failed actions or optimistic types.
 * @private
 */ var $7e901a1d6b1c5d94$var$ReducerType;
(function(ReducerType) {
    ReducerType["Optimistic"] = "optimistic";
    ReducerType["Success"] = "success";
    ReducerType["Error"] = "error";
})($7e901a1d6b1c5d94$var$ReducerType || ($7e901a1d6b1c5d94$var$ReducerType = {}));
var $7e901a1d6b1c5d94$export$2e2bcd8739ae039 = $7e901a1d6b1c5d94$var$ReducerType;

});


parcelRequire.register("ikPr1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d591fe26ce2fadd0$export$2e2bcd8739ae039);

var $174Ox = parcelRequire("174Ox");

var $aRGRv = parcelRequire("aRGRv");
function $d591fe26ce2fadd0$export$2e2bcd8739ae039(reducerDefinitions) {
    var mapping = new Map();
    reducerDefinitions.forEach(function(_ref) {
        var actionType = _ref.actionType, reducer = _ref.reducer, reducerType = _ref.reducerType;
        if (!mapping.has(actionType)) mapping.set(actionType, {
            success: [],
            error: [],
            optimistic: []
        });
         // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var handlers = mapping.get(actionType);
        var immutableReducer = (0, $174Ox.produce)(reducer);
        if (reducerType === (0, $aRGRv.default).Success) handlers.success.push(immutableReducer);
        else if (reducerType === (0, $aRGRv.default).Error) handlers.error.push(immutableReducer);
        else if (reducerType === (0, $aRGRv.default).Optimistic) handlers.optimistic.push(immutableReducer);
    });
    return mapping;
}

});
parcelRequire.register("174Ox", function(module, exports) {

$parcel$export(module.exports, "produce", () => $0cfa2de6358329e5$export$b46cabe22e78bc00);
function $0cfa2de6358329e5$var$n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function $0cfa2de6358329e5$export$541ac630993a4c84(n) {
    return !!n && !!n[$0cfa2de6358329e5$var$Q];
}
function $0cfa2de6358329e5$export$16e3aed3edb85946(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === $0cfa2de6358329e5$var$Z;
    }(n) || Array.isArray(n) || !!n[$0cfa2de6358329e5$export$6ee2082928bcb0ee] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[$0cfa2de6358329e5$export$6ee2082928bcb0ee]) || $0cfa2de6358329e5$var$s(n) || $0cfa2de6358329e5$var$v(n));
}
function $0cfa2de6358329e5$export$22e8af3f75a010e3(t) {
    return $0cfa2de6358329e5$export$541ac630993a4c84(t) || $0cfa2de6358329e5$var$n(23, t), t[$0cfa2de6358329e5$var$Q].t;
}
function $0cfa2de6358329e5$var$i(n, r, t) {
    void 0 === t && (t = !1), 0 === $0cfa2de6358329e5$var$o(n) ? (t ? Object.keys : $0cfa2de6358329e5$var$nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function $0cfa2de6358329e5$var$o(n) {
    var r = n[$0cfa2de6358329e5$var$Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : $0cfa2de6358329e5$var$s(n) ? 2 : $0cfa2de6358329e5$var$v(n) ? 3 : 0;
}
function $0cfa2de6358329e5$var$u(n, r) {
    return 2 === $0cfa2de6358329e5$var$o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function $0cfa2de6358329e5$var$a(n, r) {
    return 2 === $0cfa2de6358329e5$var$o(n) ? n.get(r) : n[r];
}
function $0cfa2de6358329e5$var$f(n, r, t) {
    var e = $0cfa2de6358329e5$var$o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function $0cfa2de6358329e5$var$c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function $0cfa2de6358329e5$var$s(n) {
    return $0cfa2de6358329e5$var$X && n instanceof Map;
}
function $0cfa2de6358329e5$var$v(n) {
    return $0cfa2de6358329e5$var$q && n instanceof Set;
}
function $0cfa2de6358329e5$var$p(n) {
    return n.o || n.t;
}
function $0cfa2de6358329e5$var$l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = $0cfa2de6358329e5$var$rn(n);
    delete r[$0cfa2de6358329e5$var$Q];
    for(var t = $0cfa2de6358329e5$var$nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function $0cfa2de6358329e5$export$792f3d81ea979f55(n, e) {
    return void 0 === e && (e = !1), $0cfa2de6358329e5$var$y(n) || $0cfa2de6358329e5$export$541ac630993a4c84(n) || !$0cfa2de6358329e5$export$16e3aed3edb85946(n) || ($0cfa2de6358329e5$var$o(n) > 1 && (n.set = n.add = n.clear = n.delete = $0cfa2de6358329e5$var$h), Object.freeze(n), e && $0cfa2de6358329e5$var$i(n, function(n, r) {
        return $0cfa2de6358329e5$export$792f3d81ea979f55(r, !0);
    }, !0)), n;
}
function $0cfa2de6358329e5$var$h() {
    $0cfa2de6358329e5$var$n(2);
}
function $0cfa2de6358329e5$var$y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function $0cfa2de6358329e5$var$b(r) {
    var t = $0cfa2de6358329e5$var$tn[r];
    return t || $0cfa2de6358329e5$var$n(18, r), t;
}
function $0cfa2de6358329e5$var$m(n, r) {
    $0cfa2de6358329e5$var$tn[n] || ($0cfa2de6358329e5$var$tn[n] = r);
}
function $0cfa2de6358329e5$var$_() {
    return $0cfa2de6358329e5$var$U;
}
function $0cfa2de6358329e5$var$j(n, r) {
    r && ($0cfa2de6358329e5$var$b("Patches"), n.u = [], n.s = [], n.v = r);
}
function $0cfa2de6358329e5$var$g(n) {
    $0cfa2de6358329e5$var$O(n), n.p.forEach($0cfa2de6358329e5$var$S), n.p = null;
}
function $0cfa2de6358329e5$var$O(n) {
    n === $0cfa2de6358329e5$var$U && ($0cfa2de6358329e5$var$U = n.l);
}
function $0cfa2de6358329e5$var$w(n) {
    return $0cfa2de6358329e5$var$U = {
        p: [],
        l: $0cfa2de6358329e5$var$U,
        h: n,
        m: !0,
        _: 0
    };
}
function $0cfa2de6358329e5$var$S(n) {
    var r = n[$0cfa2de6358329e5$var$Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function $0cfa2de6358329e5$var$P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || $0cfa2de6358329e5$var$b("ES5").S(e, r, o), o ? (i[$0cfa2de6358329e5$var$Q].P && ($0cfa2de6358329e5$var$g(e), $0cfa2de6358329e5$var$n(4)), $0cfa2de6358329e5$export$16e3aed3edb85946(r) && (r = $0cfa2de6358329e5$var$M(e, r), e.l || $0cfa2de6358329e5$var$x(e, r)), e.u && $0cfa2de6358329e5$var$b("Patches").M(i[$0cfa2de6358329e5$var$Q].t, r, e.u, e.s)) : r = $0cfa2de6358329e5$var$M(e, i, []), $0cfa2de6358329e5$var$g(e), e.u && e.v(e.u, e.s), r !== $0cfa2de6358329e5$export$45b790e32b2810ee ? r : void 0;
}
function $0cfa2de6358329e5$var$M(n, r, t) {
    if ($0cfa2de6358329e5$var$y(r)) return r;
    var e = r[$0cfa2de6358329e5$var$Q];
    if (!e) return $0cfa2de6358329e5$var$i(r, function(i, o) {
        return $0cfa2de6358329e5$var$A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return $0cfa2de6358329e5$var$x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = $0cfa2de6358329e5$var$l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), $0cfa2de6358329e5$var$i(u, function(r, i) {
            return $0cfa2de6358329e5$var$A(n, e, o, r, i, t, a);
        }), $0cfa2de6358329e5$var$x(n, o, !1), t && n.u && $0cfa2de6358329e5$var$b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function $0cfa2de6358329e5$var$A(e, i, o, a, c, s, v) {
    if ($0cfa2de6358329e5$export$541ac630993a4c84(c)) {
        var p = $0cfa2de6358329e5$var$M(e, c, s && i && 3 !== i.i && !$0cfa2de6358329e5$var$u(i.R, a) ? s.concat(a) : void 0);
        if ($0cfa2de6358329e5$var$f(o, a, p), !$0cfa2de6358329e5$export$541ac630993a4c84(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if ($0cfa2de6358329e5$export$16e3aed3edb85946(c) && !$0cfa2de6358329e5$var$y(c)) {
        if (!e.h.D && e._ < 1) return;
        $0cfa2de6358329e5$var$M(e, c), i && i.A.l || $0cfa2de6358329e5$var$x(e, c);
    }
}
function $0cfa2de6358329e5$var$x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && $0cfa2de6358329e5$export$792f3d81ea979f55(r, t);
}
function $0cfa2de6358329e5$var$z(n, r) {
    var t = n[$0cfa2de6358329e5$var$Q];
    return (t ? $0cfa2de6358329e5$var$p(t) : n)[r];
}
function $0cfa2de6358329e5$var$I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function $0cfa2de6358329e5$var$k(n) {
    n.P || (n.P = !0, n.l && $0cfa2de6358329e5$var$k(n.l));
}
function $0cfa2de6358329e5$var$E(n) {
    n.o || (n.o = $0cfa2de6358329e5$var$l(n.t));
}
function $0cfa2de6358329e5$var$N(n, r, t) {
    var e = $0cfa2de6358329e5$var$s(r) ? $0cfa2de6358329e5$var$b("MapSet").F(r, t) : $0cfa2de6358329e5$var$v(r) ? $0cfa2de6358329e5$var$b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : $0cfa2de6358329e5$var$_(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = $0cfa2de6358329e5$var$en;
        t && (i = [
            e
        ], o = $0cfa2de6358329e5$var$on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : $0cfa2de6358329e5$var$b("ES5").J(r, t);
    return (t ? t.A : $0cfa2de6358329e5$var$_()).p.push(e), e;
}
function $0cfa2de6358329e5$export$97aac956da55dae9(e) {
    return $0cfa2de6358329e5$export$541ac630993a4c84(e) || $0cfa2de6358329e5$var$n(22, e), function n(r) {
        if (!$0cfa2de6358329e5$export$16e3aed3edb85946(r)) return r;
        var e, u = r[$0cfa2de6358329e5$var$Q], c = $0cfa2de6358329e5$var$o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !$0cfa2de6358329e5$var$b("ES5").K(u))) return u.t;
            u.I = !0, e = $0cfa2de6358329e5$var$D(r, c), u.I = !1;
        } else e = $0cfa2de6358329e5$var$D(r, c);
        return $0cfa2de6358329e5$var$i(e, function(r, t) {
            u && $0cfa2de6358329e5$var$a(u.t, r) === t || $0cfa2de6358329e5$var$f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function $0cfa2de6358329e5$var$D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return $0cfa2de6358329e5$var$l(n);
}
function $0cfa2de6358329e5$export$56771cf63ee491f5() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[$0cfa2de6358329e5$var$Q];
                return $0cfa2de6358329e5$var$en.get(r, n);
            },
            set: function(r) {
                var t = this[$0cfa2de6358329e5$var$Q];
                $0cfa2de6358329e5$var$en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][$0cfa2de6358329e5$var$Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && $0cfa2de6358329e5$var$k(t);
                    break;
                case 4:
                    o(t) && $0cfa2de6358329e5$var$k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = $0cfa2de6358329e5$var$nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== $0cfa2de6358329e5$var$Q) {
                var a = r[o];
                if (void 0 === a && !$0cfa2de6358329e5$var$u(r, o)) return !0;
                var f = t[o], s = f && f[$0cfa2de6358329e5$var$Q];
                if (s ? s.t !== a : !$0cfa2de6358329e5$var$c(f, a)) return !0;
            }
        }
        var v = !!r[$0cfa2de6358329e5$var$Q];
        return e.length !== $0cfa2de6358329e5$var$nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && $0cfa2de6358329e5$var$n(3, JSON.stringify($0cfa2de6358329e5$var$p(r)));
    }
    var s = {};
    $0cfa2de6358329e5$var$m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = $0cfa2de6358329e5$var$rn(r);
                delete o[$0cfa2de6358329e5$var$Q];
                for(var u = $0cfa2de6358329e5$var$nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : $0cfa2de6358329e5$var$_(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, $0cfa2de6358329e5$var$Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? $0cfa2de6358329e5$export$541ac630993a4c84(t) && t[$0cfa2de6358329e5$var$Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[$0cfa2de6358329e5$var$Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) $0cfa2de6358329e5$var$i(o, function(r) {
                            r !== $0cfa2de6358329e5$var$Q && (void 0 !== e[r] || $0cfa2de6358329e5$var$u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, $0cfa2de6358329e5$var$k(t)));
                        }), $0cfa2de6358329e5$var$i(e, function(n) {
                            void 0 !== o[n] || $0cfa2de6358329e5$var$u(o, n) || (f[n] = !1, $0cfa2de6358329e5$var$k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && ($0cfa2de6358329e5$var$k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function $0cfa2de6358329e5$export$d3a6659991a0696c() {
    function e(n) {
        if (!$0cfa2de6358329e5$export$16e3aed3edb85946(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if ($0cfa2de6358329e5$var$s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if ($0cfa2de6358329e5$var$v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return $0cfa2de6358329e5$var$u(n, $0cfa2de6358329e5$export$6ee2082928bcb0ee) && (r[$0cfa2de6358329e5$export$6ee2082928bcb0ee] = n[$0cfa2de6358329e5$export$6ee2082928bcb0ee]), r;
    }
    function f(n) {
        return $0cfa2de6358329e5$export$541ac630993a4c84(n) ? e(n) : n;
    }
    var c = "add";
    $0cfa2de6358329e5$var$m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = $0cfa2de6358329e5$var$o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || $0cfa2de6358329e5$var$n(24), "function" == typeof f && "prototype" === p && $0cfa2de6358329e5$var$n(24), "object" != typeof (f = $0cfa2de6358329e5$var$a(f, p)) && $0cfa2de6358329e5$var$n(15, i.join("/"));
                }
                var l = $0cfa2de6358329e5$var$o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                $0cfa2de6358329e5$var$n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        $0cfa2de6358329e5$var$n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        $0cfa2de6358329e5$var$i(n.R, function(n, i) {
                            var v = $0cfa2de6358329e5$var$a(o, n), p = $0cfa2de6358329e5$var$a(s, n), l = i ? $0cfa2de6358329e5$var$u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === $0cfa2de6358329e5$export$45b790e32b2810ee ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function $0cfa2de6358329e5$export$7d9f65390203b435() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if ($0cfa2de6358329e5$export$16e3aed3edb85946(r)) {
                var e = $0cfa2de6358329e5$var$N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && $0cfa2de6358329e5$var$n(3, JSON.stringify($0cfa2de6358329e5$var$p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[$0cfa2de6358329e5$var$Q] = {
                i: 2,
                l: r,
                A: r ? r.A : $0cfa2de6358329e5$var$_(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return $0cfa2de6358329e5$var$p(this[$0cfa2de6358329e5$var$Q]).size;
            }
        }), o.has = function(n) {
            return $0cfa2de6358329e5$var$p(this[$0cfa2de6358329e5$var$Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[$0cfa2de6358329e5$var$Q];
            return u(t), $0cfa2de6358329e5$var$p(t).has(n) && $0cfa2de6358329e5$var$p(t).get(n) === r || (e(t), $0cfa2de6358329e5$var$k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[$0cfa2de6358329e5$var$Q];
            return u(r), e(r), $0cfa2de6358329e5$var$k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[$0cfa2de6358329e5$var$Q];
            u(n), $0cfa2de6358329e5$var$p(n).size && (e(n), $0cfa2de6358329e5$var$k(n), n.R = new Map, $0cfa2de6358329e5$var$i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            $0cfa2de6358329e5$var$p(this[$0cfa2de6358329e5$var$Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[$0cfa2de6358329e5$var$Q];
            u(r);
            var i = $0cfa2de6358329e5$var$p(r).get(n);
            if (r.I || !$0cfa2de6358329e5$export$16e3aed3edb85946(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = $0cfa2de6358329e5$var$N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return $0cfa2de6358329e5$var$p(this[$0cfa2de6358329e5$var$Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[$0cfa2de6358329e5$var$V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[$0cfa2de6358329e5$var$V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[$0cfa2de6358329e5$var$V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[$0cfa2de6358329e5$var$Q] = {
                i: 3,
                l: r,
                A: r ? r.A : $0cfa2de6358329e5$var$_(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return $0cfa2de6358329e5$var$p(this[$0cfa2de6358329e5$var$Q]).size;
            }
        }), t.has = function(n) {
            var r = this[$0cfa2de6358329e5$var$Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[$0cfa2de6358329e5$var$Q];
            return u(r), this.has(n) || (o(r), $0cfa2de6358329e5$var$k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[$0cfa2de6358329e5$var$Q];
            return u(r), o(r), $0cfa2de6358329e5$var$k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[$0cfa2de6358329e5$var$Q];
            u(n), $0cfa2de6358329e5$var$p(n).size && (o(n), $0cfa2de6358329e5$var$k(n), n.o.clear());
        }, t.values = function() {
            var n = this[$0cfa2de6358329e5$var$Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[$0cfa2de6358329e5$var$Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[$0cfa2de6358329e5$var$V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    $0cfa2de6358329e5$var$m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function $0cfa2de6358329e5$export$cae049b67c7d1bc9() {
    $0cfa2de6358329e5$export$56771cf63ee491f5(), $0cfa2de6358329e5$export$7d9f65390203b435(), $0cfa2de6358329e5$export$d3a6659991a0696c();
}
function $0cfa2de6358329e5$export$c05b21e3257751e5(n) {
    return n;
}
function $0cfa2de6358329e5$export$20f911b3f8cf0b74(n) {
    return n;
}
var $0cfa2de6358329e5$var$G, $0cfa2de6358329e5$var$U, $0cfa2de6358329e5$var$W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), $0cfa2de6358329e5$var$X = "undefined" != typeof Map, $0cfa2de6358329e5$var$q = "undefined" != typeof Set, $0cfa2de6358329e5$var$B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, $0cfa2de6358329e5$export$45b790e32b2810ee = $0cfa2de6358329e5$var$W ? Symbol.for("immer-nothing") : (($0cfa2de6358329e5$var$G = {})["immer-nothing"] = !0, $0cfa2de6358329e5$var$G), $0cfa2de6358329e5$export$6ee2082928bcb0ee = $0cfa2de6358329e5$var$W ? Symbol.for("immer-draftable") : "__$immer_draftable", $0cfa2de6358329e5$var$Q = $0cfa2de6358329e5$var$W ? Symbol.for("immer-state") : "__$immer_state", $0cfa2de6358329e5$var$V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", $0cfa2de6358329e5$var$Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, $0cfa2de6358329e5$var$Z = "" + Object.prototype.constructor, $0cfa2de6358329e5$var$nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, $0cfa2de6358329e5$var$rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return $0cfa2de6358329e5$var$nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, $0cfa2de6358329e5$var$tn = {}, $0cfa2de6358329e5$var$en = {
    get: function(n, r) {
        if (r === $0cfa2de6358329e5$var$Q) return n;
        var e = $0cfa2de6358329e5$var$p(n);
        if (!$0cfa2de6358329e5$var$u(e, r)) return function(n, r, t) {
            var e, i = $0cfa2de6358329e5$var$I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !$0cfa2de6358329e5$export$16e3aed3edb85946(i) ? i : i === $0cfa2de6358329e5$var$z(n.t, r) ? ($0cfa2de6358329e5$var$E(n), n.o[r] = $0cfa2de6358329e5$var$N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in $0cfa2de6358329e5$var$p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys($0cfa2de6358329e5$var$p(n));
    },
    set: function(n, r, t) {
        var e = $0cfa2de6358329e5$var$I($0cfa2de6358329e5$var$p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = $0cfa2de6358329e5$var$z($0cfa2de6358329e5$var$p(n), r), o = null == i ? void 0 : i[$0cfa2de6358329e5$var$Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if ($0cfa2de6358329e5$var$c(t, i) && (void 0 !== t || $0cfa2de6358329e5$var$u(n.t, r))) return !0;
            $0cfa2de6358329e5$var$E(n), $0cfa2de6358329e5$var$k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== $0cfa2de6358329e5$var$z(n.t, r) || r in n.t ? (n.R[r] = !1, $0cfa2de6358329e5$var$E(n), $0cfa2de6358329e5$var$k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = $0cfa2de6358329e5$var$p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        $0cfa2de6358329e5$var$n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        $0cfa2de6358329e5$var$n(12);
    }
}, $0cfa2de6358329e5$var$on = {};
$0cfa2de6358329e5$var$i($0cfa2de6358329e5$var$en, function(n, r) {
    $0cfa2de6358329e5$var$on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), $0cfa2de6358329e5$var$on.deleteProperty = function(r, t) {
    return $0cfa2de6358329e5$var$on.set.call(this, r, t, void 0);
}, $0cfa2de6358329e5$var$on.set = function(r, t, e) {
    return $0cfa2de6358329e5$var$en.set.call(this, r[0], t, e, r[0]);
};
var $0cfa2de6358329e5$export$aaadc6ff0f822719 = function() {
    function e(r) {
        var e = this;
        this.O = $0cfa2de6358329e5$var$B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && $0cfa2de6358329e5$var$n(6), void 0 !== o && "function" != typeof o && $0cfa2de6358329e5$var$n(7), $0cfa2de6358329e5$export$16e3aed3edb85946(r)) {
                var c = $0cfa2de6358329e5$var$w(e), s = $0cfa2de6358329e5$var$N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? $0cfa2de6358329e5$var$g(c) : $0cfa2de6358329e5$var$O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return $0cfa2de6358329e5$var$j(c, o), $0cfa2de6358329e5$var$P(n, c);
                }, function(n) {
                    throw $0cfa2de6358329e5$var$g(c), n;
                }) : ($0cfa2de6358329e5$var$j(c, o), $0cfa2de6358329e5$var$P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === $0cfa2de6358329e5$export$45b790e32b2810ee && (f = void 0), e.D && $0cfa2de6358329e5$export$792f3d81ea979f55(f, !0), o) {
                    var p = [], l = [];
                    $0cfa2de6358329e5$var$b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            $0cfa2de6358329e5$var$n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        $0cfa2de6358329e5$export$16e3aed3edb85946(e) || $0cfa2de6358329e5$var$n(8), $0cfa2de6358329e5$export$541ac630993a4c84(e) && (e = $0cfa2de6358329e5$export$97aac956da55dae9(e));
        var i = $0cfa2de6358329e5$var$w(this), o = $0cfa2de6358329e5$var$N(this, e, void 0);
        return o[$0cfa2de6358329e5$var$Q].C = !0, $0cfa2de6358329e5$var$O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[$0cfa2de6358329e5$var$Q];
        var i = e.A;
        return $0cfa2de6358329e5$var$j(i, t), $0cfa2de6358329e5$var$P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !$0cfa2de6358329e5$var$B && $0cfa2de6358329e5$var$n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = $0cfa2de6358329e5$var$b("Patches").$;
        return $0cfa2de6358329e5$export$541ac630993a4c84(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), $0cfa2de6358329e5$var$an = new $0cfa2de6358329e5$export$aaadc6ff0f822719, $0cfa2de6358329e5$export$b46cabe22e78bc00 = $0cfa2de6358329e5$var$an.produce, $0cfa2de6358329e5$export$4da66d41c9492c78 = $0cfa2de6358329e5$var$an.produceWithPatches.bind($0cfa2de6358329e5$var$an), $0cfa2de6358329e5$export$573f26f60825c493 = $0cfa2de6358329e5$var$an.setAutoFreeze.bind($0cfa2de6358329e5$var$an), $0cfa2de6358329e5$export$36ccd207ae29b74e = $0cfa2de6358329e5$var$an.setUseProxies.bind($0cfa2de6358329e5$var$an), $0cfa2de6358329e5$export$a8b8e03e6bbe5473 = $0cfa2de6358329e5$var$an.applyPatches.bind($0cfa2de6358329e5$var$an), $0cfa2de6358329e5$export$3c3214997190395f = $0cfa2de6358329e5$var$an.createDraft.bind($0cfa2de6358329e5$var$an), $0cfa2de6358329e5$export$c60f5e69c521b528 = $0cfa2de6358329e5$var$an.finishDraft.bind($0cfa2de6358329e5$var$an);
var $0cfa2de6358329e5$export$2e2bcd8739ae039 = $0cfa2de6358329e5$export$b46cabe22e78bc00;

});


parcelRequire.register("cyIYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $924b8b501c50760b$export$2e2bcd8739ae039);
// Kind of like `memoize(...)` except it doesn't check parameter equality.
var $924b8b501c50760b$var$callOnce = function callOnce(fn) {
    var cache = {
        primed: false,
        value: null
    };
    var cachingLayer = function cachingLayer() {
        if (!cache.primed) {
            cache.value = fn.apply(void 0, arguments);
            cache.primed = true;
        }
        return cache.value;
    };
    return cachingLayer;
};
var $924b8b501c50760b$export$2e2bcd8739ae039 = $924b8b501c50760b$var$callOnce;

});

parcelRequire.register("dyIqw", function(module, exports) {

$parcel$export(module.exports, "isActionFailure", () => $9df0e993dcac49fd$export$5134492937cec4af);
$parcel$export(module.exports, "isOptimisticAction", () => $9df0e993dcac49fd$export$f23da1510c87a96e);

var $3erk0 = parcelRequire("3erk0");
var $9df0e993dcac49fd$export$a714e0ee55dbf5bf = function isActionSuccess(action) {
    var error = action.error, meta = action.meta;
    return error !== true && (!meta || meta.phase !== (0, $3erk0.default).Optimistic);
};
var $9df0e993dcac49fd$export$5134492937cec4af = function isActionFailure(action) {
    return action.error === true;
};
var $9df0e993dcac49fd$export$f23da1510c87a96e = function isOptimisticAction(action) {
    return Boolean(action.error !== true && action.meta && action.meta.phase === (0, $3erk0.default).Optimistic);
};

});


parcelRequire.register("kSNfV", function(module, exports) {

$parcel$export(module.exports, "devices", () => (parcelRequire("dfEa8")));
$parcel$export(module.exports, "connections", () => (parcelRequire("bqADM")));
$parcel$export(module.exports, "phonebook", () => (parcelRequire("irnr8")));
$parcel$export(module.exports, "tracks", () => (parcelRequire("i2IU1")));
$parcel$export(module.exports, "route", () => (parcelRequire("fTsmx")));
$parcel$export(module.exports, "chat", () => (parcelRequire("9A9St")));
$parcel$export(module.exports, "call", () => (parcelRequire("llqKM")));
$parcel$export(module.exports, "tools", () => (parcelRequire("1ncNq")));
$parcel$export(module.exports, "panel", () => (parcelRequire("g25kO")));
$parcel$export(module.exports, "settings", () => (parcelRequire("dJ6bv")));

var $dfEa8 = parcelRequire("dfEa8");

var $bqADM = parcelRequire("bqADM");

var $irnr8 = parcelRequire("irnr8");

var $i2IU1 = parcelRequire("i2IU1");

var $fTsmx = parcelRequire("fTsmx");

var $9A9St = parcelRequire("9A9St");

var $llqKM = parcelRequire("llqKM");

var $1ncNq = parcelRequire("1ncNq");

var $g25kO = parcelRequire("g25kO");

var $dJ6bv = parcelRequire("dJ6bv");

});
parcelRequire.register("dfEa8", function(module, exports) {

$parcel$export(module.exports, "requestMediaDevices", () => $1baa154fcfe75a4e$export$9b9a1128715870c5);
$parcel$export(module.exports, "shareScreen", () => $1baa154fcfe75a4e$export$82d5b8a6870919e);
$parcel$export(module.exports, "stopSharingScreen", () => $1baa154fcfe75a4e$export$126554ed079a6f76);
$parcel$export(module.exports, "list", () => $1baa154fcfe75a4e$export$8837f4fc672e936d);
$parcel$export(module.exports, "observe", () => $1baa154fcfe75a4e$export$d1203567a167490e);
$parcel$export(module.exports, "closeErrorModal", () => $1baa154fcfe75a4e$export$8a792017f1351665);

var $5ZlB8 = parcelRequire("5ZlB8");

var $jzztL = parcelRequire("jzztL");
parcelRequire("3jRC4");
var $hvrSc = parcelRequire("hvrSc");
const $1baa154fcfe75a4e$export$9b9a1128715870c5 = (0, $jzztL.default).async("devices/request-media-devices", $hvrSc.requestMediaDevices);
const $1baa154fcfe75a4e$export$82d5b8a6870919e = (0, $jzztL.default).async("devices/share-screen", $hvrSc.shareScreen);
const $1baa154fcfe75a4e$export$126554ed079a6f76 = (0, $jzztL.default)("devices/stop-sharing-screen");
const $1baa154fcfe75a4e$export$8837f4fc672e936d = (0, $jzztL.default).async("devices/list", (0, $5ZlB8.default).enumerateDevices);
async function* $1baa154fcfe75a4e$export$d1203567a167490e() {
    for await (const changeset of $hvrSc.observe())yield $1baa154fcfe75a4e$export$d1203567a167490e.actionFactory.success(changeset);
}
$1baa154fcfe75a4e$export$d1203567a167490e.actionFactory = (0, $jzztL.default).factory("devices/observe");
const $1baa154fcfe75a4e$export$8a792017f1351665 = (0, $jzztL.default)("devices/close-error-modal");

});
parcelRequire.register("jzztL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3fcce9f02886cf0$export$2e2bcd8739ae039);

var $5wyQR = parcelRequire("5wyQR");

var $1numH = parcelRequire("1numH");

var $5xSOf = parcelRequire("5xSOf");

var $bGB68 = parcelRequire("bGB68");

var $kLCxi = parcelRequire("kLCxi");
/**
 * Returns a function which generates actions of the given type.
 * @param type A unique name which describes the action.
 * @param effect Something to run when the action is invoked. Whatever it
 * returns becomes the action payload.
 * @example
 * createAction('settings/load-theme', () => {
 *   return localStorage.getItem('theme')
 * })
 */ // Synchronous action creator.
//
// Example:
// createAction('add-file', file => {
//   return { url: URL.createObjectURL(file) }
// })
function $e3fcce9f02886cf0$var$createAction(actionType, effect) {
    (0, $bGB68.default)(actionType);
    function executeEffectAndReturnAction(input) {
        // This action is free of side effects.
        if (effect === undefined) {
            if (input === undefined) return {
                type: actionType
            };
             // The caller explicitly provided a payload.
            return {
                type: actionType,
                payload: input
            };
        } // If given an effect, whatever it returns becomes the payload.
        return {
            type: actionType,
            payload: effect(input)
        };
    }
    return (0, $5xSOf.default)(actionType, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5wyQR))).mark(function _callee(input) {
        var action, _action;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5wyQR))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    action = executeEffectAndReturnAction(input);
                    _context.next = 4;
                    return action;
                case 4:
                    return _context.abrupt("return", action.payload);
                case 7:
                    _context.prev = 7;
                    _context.t0 = _context["catch"](0);
                    _action = {
                        type: actionType,
                        error: true,
                        payload: _context.t0
                    };
                    _context.next = 12;
                    return _action;
                case 12:
                    throw _context.t0;
                case 13:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
} // Asynchronous action creator.
//
// Example:
// createAction.async('update-profile-photo', async photo => {
//   await http.put('/users/self/profile-photo/', photo)
// })
$e3fcce9f02886cf0$var$createAction.async = (0, $1numH.default); // Advanced usage: action factory for generator functions.
$e3fcce9f02886cf0$var$createAction.factory = (0, $kLCxi.default); // If an effect is provided, we have to assume it can fail.
var $e3fcce9f02886cf0$export$2e2bcd8739ae039 = $e3fcce9f02886cf0$var$createAction;

});
parcelRequire.register("1numH", function(module, exports) {

$parcel$export(module.exports, "default", () => $100f7e541f1e5a4f$export$2e2bcd8739ae039);

var $6OW4h = parcelRequire("6OW4h");

var $3RJHU = parcelRequire("3RJHU");

var $5wyQR = parcelRequire("5wyQR");

var $3erk0 = parcelRequire("3erk0");

var $5xSOf = parcelRequire("5xSOf");

var $bGB68 = parcelRequire("bGB68");
function $100f7e541f1e5a4f$export$2e2bcd8739ae039(actionType, effect) {
    (0, $bGB68.default)(actionType);
    function createAsyncAction(_x) {
        return _createAsyncAction.apply(this, arguments);
    }
    function _createAsyncAction() {
        _createAsyncAction = (0, (/*@__PURE__*/$parcel$interopDefault($3RJHU)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5wyQR))).mark(function _callee(input) {
            var optimistic, payload;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5wyQR))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        optimistic = {
                            phase: (0, $3erk0.default).Optimistic
                        };
                        _context.next = 3;
                        return input === undefined ? {
                            type: actionType,
                            meta: optimistic
                        } : {
                            type: actionType,
                            payload: input,
                            meta: optimistic
                        };
                    case 3:
                        _context.prev = 3;
                        _context.next = 6;
                        return (0, (/*@__PURE__*/$parcel$interopDefault($6OW4h)))(effect(input));
                    case 6:
                        payload = _context.sent;
                        _context.next = 9;
                        return {
                            type: actionType,
                            payload: payload
                        };
                    case 9:
                        return _context.abrupt("return", payload);
                    case 12:
                        _context.prev = 12;
                        _context.t0 = _context["catch"](3);
                        _context.next = 16;
                        return {
                            type: actionType,
                            error: true,
                            payload: _context.t0
                        };
                    case 16:
                        throw _context.t0;
                    case 17:
                    case "end":
                        return _context.stop();
                }
            }, _callee, null, [
                [
                    3,
                    12
                ]
            ]);
        }));
        return _createAsyncAction.apply(this, arguments);
    }
    return (0, $5xSOf.default)(actionType, createAsyncAction);
}

});
parcelRequire.register("6OW4h", function(module, exports) {

var $6D4qB = parcelRequire("6D4qB");
function $4f7474b583d96c66$var$_awaitAsyncGenerator(e) {
    return new $6D4qB(e, 0);
}
module.exports = $4f7474b583d96c66$var$_awaitAsyncGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("3RJHU", function(module, exports) {

var $6D4qB = parcelRequire("6D4qB");
function $2d09c6d34e5d56c3$var$_wrapAsyncGenerator(e) {
    return function() {
        return new $2d09c6d34e5d56c3$var$AsyncGenerator(e.apply(this, arguments));
    };
}
function $2d09c6d34e5d56c3$var$AsyncGenerator(e) {
    var t, n;
    function resume(t, n) {
        try {
            var r = e[t](n), o = r.value, u = o instanceof $6D4qB;
            Promise.resolve(u ? o.v : o).then(function(n) {
                if (u) {
                    var i = "return" === t && o.k ? t : "next";
                    if (!o.k || n.done) return resume(i, n);
                    n = e[i](n).value;
                }
                settle(!!r.done, n);
            }, function(e) {
                resume("throw", e);
            });
        } catch (e) {
            settle(2, e);
        }
    }
    function settle(e, r) {
        2 === e ? t.reject(r) : t.resolve({
            value: r,
            done: e
        }), (t = t.next) ? resume(t.key, t.arg) : n = null;
    }
    this._invoke = function(e, r) {
        return new Promise(function(o, u) {
            var i = {
                key: e,
                arg: r,
                resolve: o,
                reject: u,
                next: null
            };
            n ? n = n.next = i : (t = n = i, resume(e, r));
        });
    }, "function" != typeof e["return"] && (this["return"] = void 0);
}
$2d09c6d34e5d56c3$var$AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
}, $2d09c6d34e5d56c3$var$AsyncGenerator.prototype.next = function(e) {
    return this._invoke("next", e);
}, $2d09c6d34e5d56c3$var$AsyncGenerator.prototype["throw"] = function(e) {
    return this._invoke("throw", e);
}, $2d09c6d34e5d56c3$var$AsyncGenerator.prototype["return"] = function(e) {
    return this._invoke("return", e);
};
module.exports = $2d09c6d34e5d56c3$var$_wrapAsyncGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("5xSOf", function(module, exports) {

$parcel$export(module.exports, "default", () => $409a8cd479e7eb63$export$2e2bcd8739ae039);
function $409a8cd479e7eb63$export$2e2bcd8739ae039(actionType, fn) {
    Object.defineProperty(fn, "toString", {
        value: function value() {
            return actionType;
        },
        configurable: false,
        writable: false
    });
    return fn;
}

});

parcelRequire.register("bGB68", function(module, exports) {

$parcel$export(module.exports, "default", () => $882064d060f6c535$export$2e2bcd8739ae039);

var $kdAjr = parcelRequire("kdAjr");
function $882064d060f6c535$export$2e2bcd8739ae039(actionType) {
    (0, $kdAjr.default)(typeof actionType === "string", "Action types must be strings.");
    return true;
}

});




parcelRequire.register("bqADM", function(module, exports) {

$parcel$export(module.exports, "listen", () => $c30ac121da65a532$export$63174c828edd6ff8);
$parcel$export(module.exports, "dial", () => $c30ac121da65a532$export$65e66d587c664fab);
$parcel$export(module.exports, "accept", () => $c30ac121da65a532$export$73f57eecff448cc8);
$parcel$export(module.exports, "close", () => $c30ac121da65a532$export$8360e631d277ea4d);
$parcel$export(module.exports, "markConnected", () => $c30ac121da65a532$export$8c36c0a443419c6d);

var $jzztL = parcelRequire("jzztL");
parcelRequire("3jRC4");
var $5lVTw = parcelRequire("5lVTw");
const $c30ac121da65a532$export$63174c828edd6ff8 = (0, $jzztL.default).async("connections/listen", $5lVTw.listen);
const $c30ac121da65a532$export$65e66d587c664fab = (0, $jzztL.default).async("connections/dial", $5lVTw.dial);
const $c30ac121da65a532$export$73f57eecff448cc8 = (0, $jzztL.default)("connections/accept");
const $c30ac121da65a532$export$8360e631d277ea4d = (0, $jzztL.default)("connections/close", $5lVTw.close);
const $c30ac121da65a532$export$8c36c0a443419c6d = (0, $jzztL.default)("connections/mark-connected");

});

parcelRequire.register("irnr8", function(module, exports) {

$parcel$export(module.exports, "open", () => $926e0529f31b2f8e$export$3ce6949f20cea765);
$parcel$export(module.exports, "close", () => $926e0529f31b2f8e$export$8360e631d277ea4d);
$parcel$export(module.exports, "toggle", () => $926e0529f31b2f8e$export$e03c1c3201ee8bb7);

var $jzztL = parcelRequire("jzztL");
const $926e0529f31b2f8e$export$3ce6949f20cea765 = (0, $jzztL.default)("phonebook/open");
const $926e0529f31b2f8e$export$8360e631d277ea4d = (0, $jzztL.default)("phonebook/close");
const $926e0529f31b2f8e$export$e03c1c3201ee8bb7 = (0, $jzztL.default)("phonebook/toggle");

});

parcelRequire.register("i2IU1", function(module, exports) {

$parcel$export(module.exports, "add", () => $a801a15f91d54266$export$e16d8520af44a096);
$parcel$export(module.exports, "pause", () => $a801a15f91d54266$export$229c72e5fdee233b);
$parcel$export(module.exports, "resume", () => $a801a15f91d54266$export$fbb4d68fe60c1629);
$parcel$export(module.exports, "toggle", () => $a801a15f91d54266$export$e03c1c3201ee8bb7);
$parcel$export(module.exports, "markPaused", () => $a801a15f91d54266$export$126ee5dd82518e32);
$parcel$export(module.exports, "markResumed", () => $a801a15f91d54266$export$3c2677cd8ecd596c);
$parcel$export(module.exports, "remove", () => $a801a15f91d54266$export$cd7f480d6b8286c3);

var $jzztL = parcelRequire("jzztL");
parcelRequire("3jRC4");
var $yJV7z = parcelRequire("yJV7z");
const $a801a15f91d54266$export$e16d8520af44a096 = (0, $jzztL.default)("tracks/add", $yJV7z.add);
const $a801a15f91d54266$export$229c72e5fdee233b = (0, $jzztL.default)("tracks/pause", $yJV7z.pause);
const $a801a15f91d54266$export$fbb4d68fe60c1629 = (0, $jzztL.default)("tracks/resume", $yJV7z.resume);
const $a801a15f91d54266$export$e03c1c3201ee8bb7 = (0, $jzztL.default)("tracks/toggle", $yJV7z.toggle);
const $a801a15f91d54266$export$126ee5dd82518e32 = (0, $jzztL.default)("tracks/mark-paused");
const $a801a15f91d54266$export$3c2677cd8ecd596c = (0, $jzztL.default)("tracks/mark-resumed");
const $a801a15f91d54266$export$cd7f480d6b8286c3 = (0, $jzztL.default)("tracks/mark-ended");

});

parcelRequire.register("fTsmx", function(module, exports) {

$parcel$export(module.exports, "change", () => $41f05bf4fbbb3c6f$export$d8a7b8f475ec0161);

var $jzztL = parcelRequire("jzztL");
const $41f05bf4fbbb3c6f$export$d8a7b8f475ec0161 = (0, $jzztL.default)("route/change");

});

parcelRequire.register("9A9St", function(module, exports) {

$parcel$export(module.exports, "sendMessage", () => $008443f12fa2a5dc$export$465cb47180de50f0);
$parcel$export(module.exports, "receiveMessage", () => $008443f12fa2a5dc$export$568a4bf360deab48);

var $jzztL = parcelRequire("jzztL");
parcelRequire("3jRC4");
var $gmvC5 = parcelRequire("gmvC5");
const $008443f12fa2a5dc$export$465cb47180de50f0 = (0, $jzztL.default)("chat/send-message", $gmvC5.sendMessage);
const $008443f12fa2a5dc$export$568a4bf360deab48 = (0, $jzztL.default)("chat/receive-message");

});

parcelRequire.register("llqKM", function(module, exports) {

$parcel$export(module.exports, "leave", () => $838c68a0c4207781$export$33993f1ec7a2167a);

var $jzztL = parcelRequire("jzztL");
const $838c68a0c4207781$export$33993f1ec7a2167a = (0, $jzztL.default)("call/leave");

});

parcelRequire.register("1ncNq", function(module, exports) {

$parcel$export(module.exports, "patch", () => $afab3819e8810252$export$b76953f99ab2be78);

var $jzztL = parcelRequire("jzztL");
const $afab3819e8810252$export$b76953f99ab2be78 = (0, $jzztL.default)("tools/patch");

});

parcelRequire.register("g25kO", function(module, exports) {

$parcel$export(module.exports, "open", () => $6b7f23e9b2b74ed7$export$3ce6949f20cea765);
$parcel$export(module.exports, "close", () => $6b7f23e9b2b74ed7$export$8360e631d277ea4d);
$parcel$export(module.exports, "toggle", () => $6b7f23e9b2b74ed7$export$e03c1c3201ee8bb7);
$parcel$export(module.exports, "showChat", () => $6b7f23e9b2b74ed7$export$1155d17a8c28ac57);
$parcel$export(module.exports, "showSettings", () => $6b7f23e9b2b74ed7$export$1e41efdeab2878cb);

var $jzztL = parcelRequire("jzztL");
const $6b7f23e9b2b74ed7$export$3ce6949f20cea765 = (0, $jzztL.default)("panel/open");
const $6b7f23e9b2b74ed7$export$8360e631d277ea4d = (0, $jzztL.default)("panel/close");
const $6b7f23e9b2b74ed7$export$e03c1c3201ee8bb7 = (0, $jzztL.default)("panel/toggle");
const $6b7f23e9b2b74ed7$export$1155d17a8c28ac57 = (0, $jzztL.default)("panel/show-chat");
const $6b7f23e9b2b74ed7$export$1e41efdeab2878cb = (0, $jzztL.default)("panel/show-settings");

});

parcelRequire.register("dJ6bv", function(module, exports) {

$parcel$export(module.exports, "load", () => $800f1a803ae47a6c$export$11e63f7b0f3d9900);
$parcel$export(module.exports, "update", () => $800f1a803ae47a6c$export$722fbec263ad908a);
$parcel$export(module.exports, "reset", () => $800f1a803ae47a6c$export$aad8462122ac592b);

var $jzztL = parcelRequire("jzztL");
parcelRequire("3jRC4");
var $9fjTl = parcelRequire("9fjTl");
const $800f1a803ae47a6c$export$11e63f7b0f3d9900 = (0, $jzztL.default).async("settings/load", $9fjTl.load);
const $800f1a803ae47a6c$export$722fbec263ad908a = (0, $jzztL.default).async("settings/update", $9fjTl.update);
const $800f1a803ae47a6c$export$aad8462122ac592b = (0, $jzztL.default).async("settings/reset", $9fjTl.reset);

});



parcelRequire.register("8P5Z0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5807b8d73d1f18ba$export$2e2bcd8739ae039);

var $9M2QW = parcelRequire("9M2QW");

var $gM2lt = parcelRequire("gM2lt");
parcelRequire("kSNfV");
var $i2IU1 = parcelRequire("i2IU1");
var $5807b8d73d1f18ba$export$2e2bcd8739ae039 = (0, $9M2QW.default)((0, $gM2lt.default), (handleAction)=>[
        handleAction($i2IU1.add, (state, { track: track, peerId: peerId })=>{
            state.participants[peerId].trackIds.push(track.id);
            state.tracks[track.id] = {
                kind: track.kind,
                source: track.source,
                enabled: track.enabled,
                local: false,
                groupId: null,
                deviceId: null,
                facingMode: null
            };
        }),
        handleAction($i2IU1.pause, (state, trackId)=>{
            state.tracks[trackId].enabled = false;
        }),
        handleAction($i2IU1.resume, (state, trackId)=>{
            state.tracks[trackId].enabled = true;
        }),
        handleAction($i2IU1.toggle, (state, trackId)=>{
            state.tracks[trackId].enabled = !state.tracks[trackId].enabled;
        }),
        handleAction($i2IU1.markPaused, (state, kind)=>{
            for (const track of Object.values(state.tracks))if (track.kind === kind && !track.local) track.enabled = false;
        }),
        handleAction($i2IU1.markResumed, (state, kind)=>{
            for (const track of Object.values(state.tracks))if (track.kind === kind && !track.local) track.enabled = true;
        }),
        // We only listen to this event on local tracks.
        handleAction($i2IU1.remove, (state, { trackId: trackId, peerId: peerId })=>{
            const participant = state.participants[peerId];
            participant.trackIds = participant.trackIds.filter((id)=>id !== trackId);
            delete state.tracks[trackId];
        })
    ]);

});

parcelRequire.register("4LAPt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b8e4081a60921ce$export$2e2bcd8739ae039);

var $9M2QW = parcelRequire("9M2QW");

var $gM2lt = parcelRequire("gM2lt");
parcelRequire("kSNfV");
var $fTsmx = parcelRequire("fTsmx");
var $8b8e4081a60921ce$export$2e2bcd8739ae039 = (0, $9M2QW.default)((0, $gM2lt.default), (handleAction)=>[
        handleAction($fTsmx.change, (state, route)=>{
            state.route = route;
        })
    ]);

});

parcelRequire.register("kGFY6", function(module, exports) {

$parcel$export(module.exports, "default", () => $12649539748668e3$export$2e2bcd8739ae039);

var $9M2QW = parcelRequire("9M2QW");

var $gM2lt = parcelRequire("gM2lt");
parcelRequire("kSNfV");
var $llqKM = parcelRequire("llqKM");
var $12649539748668e3$export$2e2bcd8739ae039 = (0, $9M2QW.default)((0, $gM2lt.default), (handleAction)=>[
        handleAction($llqKM.leave, (state, peerId)=>{
            state.participants[peerId].trackIds.forEach((trackId)=>{
                delete state.tracks[trackId];
            });
            delete state.participants[peerId];
            state.call = null;
            state.chat.unreadMessages = false;
            if (state.panel.view === (0, $gM2lt.PanelView).Chat) state.panel.view = (0, $gM2lt.PanelView).None;
        })
    ]);

});

parcelRequire.register("2BDcu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b0fda3f8f95aaaf$export$2e2bcd8739ae039);

var $9M2QW = parcelRequire("9M2QW");

var $gM2lt = parcelRequire("gM2lt");
parcelRequire("kSNfV");
var $9A9St = parcelRequire("9A9St");
var $6b0fda3f8f95aaaf$export$2e2bcd8739ae039 = (0, $9M2QW.default)((0, $gM2lt.default), (handleAction)=>[
        handleAction($9A9St.receiveMessage, (state, msg)=>{
            state.participants[msg.author].chat.history.push(msg);
            state.participants[msg.author].chat.history.sort($6b0fda3f8f95aaaf$var$sortMessagesByDate);
            if (state.panel.view !== (0, $gM2lt.PanelView).Chat) state.chat.unreadMessages = true;
        }),
        handleAction($9A9St.sendMessage, (state, { remoteId: remoteId, msg: msg })=>{
            state.participants[remoteId].chat.history.push(msg);
            state.participants[remoteId].chat.history.sort($6b0fda3f8f95aaaf$var$sortMessagesByDate);
        })
    ]);
/**
 * Chat messages are sorted by the date stamped by their senders. Of course,
 * this is not reliable as clocks can be wildly out of sync, but it's a good
 * enough measure. A future version might use causal history on message IDs.
 */ function $6b0fda3f8f95aaaf$var$sortMessagesByDate(m1, m2) {
    const d1 = new Date(m1.sentDate);
    const d2 = new Date(m2.sentDate);
    return d1.getTime() - d2.getTime();
}

});

parcelRequire.register("f4Yo8", function(module, exports) {

$parcel$export(module.exports, "default", () => $552d727142cc7e19$export$2e2bcd8739ae039);

var $9M2QW = parcelRequire("9M2QW");

var $gM2lt = parcelRequire("gM2lt");
parcelRequire("kSNfV");
var $1ncNq = parcelRequire("1ncNq");
var $552d727142cc7e19$export$2e2bcd8739ae039 = (0, $9M2QW.default)((0, $gM2lt.default), (handleAction)=>[
        handleAction($1ncNq.patch, (state, effect)=>{
            return effect(state);
        })
    ]);

});

parcelRequire.register("bRnOP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4875fd3c47f52c01$export$2e2bcd8739ae039);

var $5ZlB8 = parcelRequire("5ZlB8");

var $9M2QW = parcelRequire("9M2QW");

var $gM2lt = parcelRequire("gM2lt");
parcelRequire("kSNfV");
var $dfEa8 = parcelRequire("dfEa8");

var $kXV5G = parcelRequire("kXV5G");

var $hvrSc = parcelRequire("hvrSc");
var $4875fd3c47f52c01$export$2e2bcd8739ae039 = (0, $9M2QW.default)((0, $gM2lt.default), (handleAction)=>[
        // Some platforms have strict limits on concurrent tracks. For example,
        // mobile won't let you create more than 1 video at a time. This optimistic
        // handler removes the existing track, clearing resources for the new one.
        //
        // It would be neat to support more than one track concurrently on supported
        // platforms for a more graceful stream cutover, but that can be added in
        // the future.
        handleAction.optimistic($dfEa8.requestMediaDevices, (state, query)=>{
            if (query.audio) $4875fd3c47f52c01$var$removeLocalTracksOfKind((0, $kXV5G.TrackKind).Audio, state);
            if (query.video) $4875fd3c47f52c01$var$removeLocalTracksOfKind((0, $kXV5G.TrackKind).Video, state);
        }),
        handleAction.error($dfEa8.requestMediaDevices, (state, error)=>{
            if (error instanceof (0, $hvrSc.GumError)) state.sources.error = error.type;
        }),
        handleAction($dfEa8.requestMediaDevices, (state, newTracks)=>{
            newTracks.forEach((track)=>{
                state.participants[0, $kXV5G.MY_PARTICIPANT_ID].trackIds.push(track.trackId);
                state.tracks[track.trackId] = {
                    kind: track.kind,
                    source: (0, $kXV5G.TrackSource).Device,
                    enabled: track.enabled,
                    local: true,
                    groupId: track.groupId,
                    deviceId: track.deviceId,
                    facingMode: track.facingMode
                };
            });
        }),
        handleAction($dfEa8.closeErrorModal, (state)=>{
            state.sources.error = null;
        }),
        handleAction($dfEa8.list, (state, devices)=>{
            const kind = $4875fd3c47f52c01$var$createFilter(devices);
            state.sources.available.audio = kind((0, $5ZlB8.DeviceKind).AudioInput);
            state.sources.available.video = kind((0, $5ZlB8.DeviceKind).VideoInput);
        }),
        handleAction($dfEa8.observe.actionFactory, (state, { devices: devices, changes: changes })=>{
            const kind = $4875fd3c47f52c01$var$createFilter(devices);
            state.sources.available.audio = kind((0, $5ZlB8.DeviceKind).AudioInput);
            state.sources.available.video = kind((0, $5ZlB8.DeviceKind).VideoInput);
            state.sources.changes = changes;
        }),
        handleAction($dfEa8.shareScreen, (state, tracks)=>{
            tracks.forEach((track)=>{
                state.participants[0, $kXV5G.MY_PARTICIPANT_ID].trackIds.push(track.trackId);
                state.tracks[track.trackId] = {
                    kind: track.kind,
                    source: (0, $kXV5G.TrackSource).Display,
                    enabled: track.enabled,
                    local: true,
                    deviceId: track.deviceId,
                    groupId: track.groupId,
                    facingMode: null
                };
            });
        }),
        handleAction($dfEa8.stopSharingScreen, (state)=>{
            const participant = state.participants[0, $kXV5G.MY_PARTICIPANT_ID];
            // Poor man's _.partition(...).
            const [deviceTracks, displayTracks] = participant.trackIds.reduce(([device, display], trackId)=>state.tracks[trackId].source === (0, $kXV5G.TrackSource).Display ? [
                    device,
                    display.concat(trackId)
                ] : [
                    device.concat(trackId),
                    display
                ], [
                [],
                []
            ]);
            displayTracks.forEach((trackId)=>delete state.tracks[trackId]);
            participant.trackIds = deviceTracks;
        })
    ]);
function $4875fd3c47f52c01$var$createFilter(devices) {
    return function filterByKind(kind) {
        const deviceIds = new Set();
        // I've only seen this happen once, and it was on my laptop, which is
        // admittedly a bespoke frankenstein of obscure linux tweaks, and it truly
        // was a duplicate device. It should never happen in practice.
        function removeDuplicates(device) {
            const duplicate = deviceIds.has(device.deviceId);
            deviceIds.add(device.deviceId);
            return !duplicate;
        }
        return devices.filter((device)=>device.kind === kind).filter(removeDuplicates);
    };
}
function $4875fd3c47f52c01$var$removeLocalTracksOfKind(kind, state) {
    const self = state.participants[0, $kXV5G.MY_PARTICIPANT_ID];
    const myTracks = new Set(self.trackIds);
    // If we just added a video track but we've already got a video track,
    // close out the other one.
    self.trackIds.forEach((trackId)=>{
        const track = state.tracks[trackId];
        if (track.kind === kind && track.source === (0, $kXV5G.TrackSource).Device) {
            delete state.tracks[trackId];
            myTracks.delete(trackId);
        }
    });
    // Update our track list in case we had to remove any.
    self.trackIds = Array.from(myTracks);
}

});

parcelRequire.register("4DHYq", function(module, exports) {

$parcel$export(module.exports, "default", () => $73cd7029b8967312$export$2e2bcd8739ae039);

var $9M2QW = parcelRequire("9M2QW");
parcelRequire("kSNfV");
var $g25kO = parcelRequire("g25kO");

var $gM2lt = parcelRequire("gM2lt");
var $73cd7029b8967312$export$2e2bcd8739ae039 = (0, $9M2QW.default)((0, $gM2lt.default), (handleAction)=>[
        handleAction($g25kO.open, $73cd7029b8967312$var$openLastReasonableView),
        handleAction($g25kO.close, (state)=>{
            state.panel.view = (0, $gM2lt.PanelView).None;
        }),
        handleAction($g25kO.toggle, (state)=>{
            if (state.panel.view === (0, $gM2lt.PanelView).None) $73cd7029b8967312$var$openLastReasonableView(state);
            else state.panel.view = (0, $gM2lt.PanelView).None;
        }),
        handleAction($g25kO.showChat, (state)=>{
            state.panel.lastView = (0, $gM2lt.PanelView).Chat;
            state.panel.view = (0, $gM2lt.PanelView).Chat;
            state.chat.unreadMessages = false;
        }),
        handleAction($g25kO.showSettings, (state)=>{
            state.panel.lastView = (0, $gM2lt.PanelView).Settings;
            state.panel.view = (0, $gM2lt.PanelView).Settings;
        })
    ]);
// If you're not in a call, there aren't any chat messages to look at. Open
// the most reasonable view possible, which in that case means settings.
function $73cd7029b8967312$var$openLastReasonableView(state) {
    if (state.call === null) state.panel.view = (0, $gM2lt.PanelView).Settings;
    else state.panel.view = state.panel.lastView;
    if (state.panel.view === (0, $gM2lt.PanelView).Chat) state.chat.unreadMessages = false;
}

});

parcelRequire.register("JhVEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $08c16e27a7e18046$export$2e2bcd8739ae039);

var $9M2QW = parcelRequire("9M2QW");

var $gM2lt = parcelRequire("gM2lt");
parcelRequire("kSNfV");
var $dJ6bv = parcelRequire("dJ6bv");
var $08c16e27a7e18046$export$2e2bcd8739ae039 = (0, $9M2QW.default)((0, $gM2lt.default), (handleAction)=>[
        handleAction($dJ6bv.load, (state, settings)=>{
            state.settings.webrtc = settings;
        }),
        handleAction($dJ6bv.reset, (state)=>{
            state.settings.webrtc = (0, $gM2lt.default).settings.webrtc;
        }),
        handleAction.optimistic($dJ6bv.update, (state, overrides)=>{
            Object.assign(state.settings.webrtc, overrides);
        })
    ]);

});

parcelRequire.register("3ORhH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5fba8696d17a01f$export$2e2bcd8739ae039);

var $9M2QW = parcelRequire("9M2QW");

var $gM2lt = parcelRequire("gM2lt");
parcelRequire("kSNfV");
var $bqADM = parcelRequire("bqADM");

var $kXV5G = parcelRequire("kXV5G");
var $a5fba8696d17a01f$export$2e2bcd8739ae039 = (0, $9M2QW.default)((0, $gM2lt.default), (handleAction)=>[
        handleAction($bqADM.dial, (state, { peerId: peerId })=>{
            state.call = {
                peerId: peerId
            };
            state.participants[peerId] = {
                isMe: false,
                trackIds: [],
                chat: {
                    history: []
                },
                connection: {
                    state: (0, $kXV5G.ConnectionState).Connecting
                }
            };
        }),
        handleAction($bqADM.accept, (state, peerId)=>{
            state.call = {
                peerId: peerId
            };
            // Don't wipe out state on reconnection, just update the connection
            // state.
            if (state.participants[peerId]) {
                state.participants[peerId].connection.state = (0, $kXV5G.ConnectionState).Connecting;
                return;
            }
            state.participants[peerId] = {
                isMe: false,
                trackIds: [],
                chat: {
                    history: []
                },
                connection: {
                    state: (0, $kXV5G.ConnectionState).Connecting
                }
            };
        }),
        handleAction($bqADM.markConnected, (state, peerId)=>{
            state.participants[peerId].connection.state = (0, $kXV5G.ConnectionState).Connected;
        }),
        handleAction($bqADM.close, (state, peerId)=>{
            state.participants[peerId].connection.state = (0, $kXV5G.ConnectionState).Disconnected;
            state.participants[peerId].trackIds.splice(0).forEach((trackId)=>{
                delete state.tracks[trackId];
            });
        }),
        handleAction($bqADM.listen, (state, { id: id, relayAddr: relayAddr })=>{
            state.relay = {
                localId: id,
                server: relayAddr
            };
        })
    ]);

});


parcelRequire.register("xggRE", function(module, exports) {

$parcel$export(module.exports, "default", () => $66fdcf8c1c41ceb9$export$2e2bcd8739ae039);
/* eslint-disable @typescript-eslint/no-explicit-any */ function $66fdcf8c1c41ceb9$export$2e2bcd8739ae039(reducers) {
    return function aggregateReducer(state, action) {
        return reducers.reduce((state, reducer)=>reducer(state, action), state);
    };
}

});



var $33a4b0efc5f73897$exports = {};
"use strict";

$33a4b0efc5f73897$exports = (parcelRequire("aR5t2"));


var $9653adc0814ac645$export$882461b6382ed46c;
var $9653adc0814ac645$export$757ceba2d55c277e;
"use strict";
var $fc99b6663a8ce35f$exports = {};
"use strict";
function $fc99b6663a8ce35f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($fc99b6663a8ce35f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$fc99b6663a8ce35f$var$checkDCE();

$fc99b6663a8ce35f$exports = (parcelRequire("a4UIc"));


var $9653adc0814ac645$var$i;
$9653adc0814ac645$export$882461b6382ed46c = $fc99b6663a8ce35f$exports.createRoot;
$9653adc0814ac645$export$757ceba2d55c277e = $fc99b6663a8ce35f$exports.hydrateRoot;



var $5vDX4 = parcelRequire("5vDX4");
var $7727b9c471abe877$exports = {};
"use strict";

$7727b9c471abe877$exports = (parcelRequire("fb4ur"));



var $5vDX4 = parcelRequire("5vDX4");
var $d37cd40fedfa06dd$exports = {};
//
$d37cd40fedfa06dd$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $d301323d92539efe$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\x00\x00"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\x00");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $d301323d92539efe$export$2e2bcd8739ae039 = $d301323d92539efe$var$stylis_min;


var $ddad55a018761839$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $ddad55a018761839$export$2e2bcd8739ae039 = $ddad55a018761839$var$unitlessKeys;


function $dd7c3e85021f61f4$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


// eslint-disable-next-line no-undef
var $e981647efc96a49d$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $e981647efc96a49d$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $dd7c3e85021f61f4$export$2e2bcd8739ae039)(function(prop) {
    return $e981647efc96a49d$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});


var $d9f02effaba46552$exports = {};
"use strict";
var $c7c481f013c15e87$exports = {};
"use strict";

$c7c481f013c15e87$exports = (parcelRequire("asr8F"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $d9f02effaba46552$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $d9f02effaba46552$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $d9f02effaba46552$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $d9f02effaba46552$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $d9f02effaba46552$var$TYPE_STATICS = {};
$d9f02effaba46552$var$TYPE_STATICS[$c7c481f013c15e87$exports.ForwardRef] = $d9f02effaba46552$var$FORWARD_REF_STATICS;
$d9f02effaba46552$var$TYPE_STATICS[$c7c481f013c15e87$exports.Memo] = $d9f02effaba46552$var$MEMO_STATICS;
function $d9f02effaba46552$var$getStatics(component) {
    // React v16.11 and below
    if ($c7c481f013c15e87$exports.isMemo(component)) return $d9f02effaba46552$var$MEMO_STATICS;
     // React v16.12 and above
    return $d9f02effaba46552$var$TYPE_STATICS[component["$$typeof"]] || $d9f02effaba46552$var$REACT_STATICS;
}
var $d9f02effaba46552$var$defineProperty = Object.defineProperty;
var $d9f02effaba46552$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $d9f02effaba46552$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $d9f02effaba46552$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $d9f02effaba46552$var$getPrototypeOf = Object.getPrototypeOf;
var $d9f02effaba46552$var$objectPrototype = Object.prototype;
function $d9f02effaba46552$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($d9f02effaba46552$var$objectPrototype) {
            var inheritedComponent = $d9f02effaba46552$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $d9f02effaba46552$var$objectPrototype) $d9f02effaba46552$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $d9f02effaba46552$var$getOwnPropertyNames(sourceComponent);
        if ($d9f02effaba46552$var$getOwnPropertySymbols) keys = keys.concat($d9f02effaba46552$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $d9f02effaba46552$var$getStatics(targetComponent);
        var sourceStatics = $d9f02effaba46552$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$d9f02effaba46552$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $d9f02effaba46552$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $d9f02effaba46552$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$d9f02effaba46552$exports = $d9f02effaba46552$var$hoistNonReactStatics;



var $bvigH = parcelRequire("bvigH");
function $87bc0af96408f074$var$y() {
    return ($87bc0af96408f074$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $87bc0af96408f074$var$v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $87bc0af96408f074$var$g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $7727b9c471abe877$exports.typeOf)(t);
}, $87bc0af96408f074$var$S = Object.freeze([]), $87bc0af96408f074$var$w = Object.freeze({});
function $87bc0af96408f074$var$E(e) {
    return "function" == typeof e;
}
function $87bc0af96408f074$var$b(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $87bc0af96408f074$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $87bc0af96408f074$var$N = ("undefined" != typeof $bvigH && void 0 !== $bvigH.env && undefined, "data-styled"), $87bc0af96408f074$export$83d89fbfd8236492 = "5.3.11", $87bc0af96408f074$var$C = "undefined" != typeof window && "HTMLElement" in window, $87bc0af96408f074$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof $bvigH && void 0 !== $bvigH.env && false), $87bc0af96408f074$var$P = {}, $87bc0af96408f074$var$O = {};
function $87bc0af96408f074$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $87bc0af96408f074$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $87bc0af96408f074$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $87bc0af96408f074$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $87bc0af96408f074$var$T = new Map, $87bc0af96408f074$var$x = new Map, $87bc0af96408f074$var$k = 1, $87bc0af96408f074$var$V = function(e) {
    if ($87bc0af96408f074$var$T.has(e)) return $87bc0af96408f074$var$T.get(e);
    for(; $87bc0af96408f074$var$x.has($87bc0af96408f074$var$k);)$87bc0af96408f074$var$k++;
    var t = $87bc0af96408f074$var$k++;
    return $87bc0af96408f074$var$T.set(e, t), $87bc0af96408f074$var$x.set(t, e), t;
}, $87bc0af96408f074$var$B = function(e) {
    return $87bc0af96408f074$var$x.get(e);
}, $87bc0af96408f074$var$z = function(e, t) {
    t >= $87bc0af96408f074$var$k && ($87bc0af96408f074$var$k = t + 1), $87bc0af96408f074$var$T.set(e, t), $87bc0af96408f074$var$x.set(t, e);
}, $87bc0af96408f074$var$M = "style[" + $87bc0af96408f074$var$N + '][data-styled-version="5.3.11"]', $87bc0af96408f074$var$G = new RegExp("^" + $87bc0af96408f074$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $87bc0af96408f074$var$L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $87bc0af96408f074$var$F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($87bc0af96408f074$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($87bc0af96408f074$var$z(u, c), $87bc0af96408f074$var$L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $87bc0af96408f074$var$Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $87bc0af96408f074$var$q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($87bc0af96408f074$var$N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($87bc0af96408f074$var$N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = $87bc0af96408f074$var$Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $87bc0af96408f074$var$H = function() {
    function e(e) {
        var t = this.element = $87bc0af96408f074$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $87bc0af96408f074$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $87bc0af96408f074$var$$ = function() {
    function e(e) {
        var t = this.element = $87bc0af96408f074$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $87bc0af96408f074$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $87bc0af96408f074$var$U = $87bc0af96408f074$var$C, $87bc0af96408f074$var$J = {
    isServer: !$87bc0af96408f074$var$C,
    useCSSOMInjection: !$87bc0af96408f074$var$I
}, $87bc0af96408f074$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $87bc0af96408f074$var$w), void 0 === t && (t = {}), this.options = $87bc0af96408f074$var$y({}, $87bc0af96408f074$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $87bc0af96408f074$var$C && $87bc0af96408f074$var$U && ($87bc0af96408f074$var$U = !1, function(e) {
            for(var t = document.querySelectorAll($87bc0af96408f074$var$M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($87bc0af96408f074$var$N) && ($87bc0af96408f074$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $87bc0af96408f074$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($87bc0af96408f074$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $87bc0af96408f074$var$W(o) : r ? new $87bc0af96408f074$var$H(o) : new $87bc0af96408f074$var$$(o), new $87bc0af96408f074$var$j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($87bc0af96408f074$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($87bc0af96408f074$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($87bc0af96408f074$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $87bc0af96408f074$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $87bc0af96408f074$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $87bc0af96408f074$var$Z = /(a)(d)/gi, $87bc0af96408f074$var$K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $87bc0af96408f074$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $87bc0af96408f074$var$K(t % 52) + n;
    return ($87bc0af96408f074$var$K(t % 52) + n).replace($87bc0af96408f074$var$Z, "$1-$2");
}
var $87bc0af96408f074$var$ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $87bc0af96408f074$var$te = function(e) {
    return $87bc0af96408f074$var$ee(5381, e);
};
function $87bc0af96408f074$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($87bc0af96408f074$var$E(n) && !$87bc0af96408f074$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $87bc0af96408f074$var$re = $87bc0af96408f074$var$te("5.3.11"), $87bc0af96408f074$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $87bc0af96408f074$var$ne(e), this.componentId = t, this.baseHash = $87bc0af96408f074$var$ee($87bc0af96408f074$var$re, t), this.baseStyle = n, $87bc0af96408f074$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $87bc0af96408f074$var$_e(this.rules, e, t, n).join(""), i = $87bc0af96408f074$var$Q($87bc0af96408f074$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $87bc0af96408f074$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $87bc0af96408f074$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $87bc0af96408f074$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $87bc0af96408f074$var$Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $87bc0af96408f074$var$se = /^\s*\/\/.*$/gm, $87bc0af96408f074$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $87bc0af96408f074$var$ae(e) {
    var t, n, r, o, s = void 0 === e ? $87bc0af96408f074$var$w : e, i = s.options, a = void 0 === i ? $87bc0af96408f074$var$w : i, c = s.plugins, u = void 0 === c ? $87bc0af96408f074$var$S : c, l = new (0, $d301323d92539efe$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $87bc0af96408f074$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($87bc0af96408f074$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $87bc0af96408f074$var$D(15), $87bc0af96408f074$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $87bc0af96408f074$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).createContext(), $87bc0af96408f074$export$91317688fc694efa = $87bc0af96408f074$export$8c190ef828af4c86.Consumer, $87bc0af96408f074$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).createContext(), $87bc0af96408f074$var$de = ($87bc0af96408f074$var$le.Consumer, new $87bc0af96408f074$var$X), $87bc0af96408f074$var$he = $87bc0af96408f074$var$ae();
function $87bc0af96408f074$var$pe() {
    return (0, $5vDX4.useContext)($87bc0af96408f074$export$8c190ef828af4c86) || $87bc0af96408f074$var$de;
}
function $87bc0af96408f074$var$fe() {
    return (0, $5vDX4.useContext)($87bc0af96408f074$var$le) || $87bc0af96408f074$var$he;
}
function $87bc0af96408f074$export$a473771da2f0ff7c(e) {
    var t = (0, $5vDX4.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $87bc0af96408f074$var$pe(), u = (0, $5vDX4.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $5vDX4.useMemo)(function() {
        return $87bc0af96408f074$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $5vDX4.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($d37cd40fedfa06dd$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).createElement($87bc0af96408f074$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).createElement($87bc0af96408f074$var$le.Provider, {
        value: l
    }, (0, e.children)));
}
var $87bc0af96408f074$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $87bc0af96408f074$var$he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $87bc0af96408f074$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $87bc0af96408f074$var$he), this.name + e.hash;
    }, e;
}(), $87bc0af96408f074$var$ve = /([A-Z])/, $87bc0af96408f074$var$ge = /([A-Z])/g, $87bc0af96408f074$var$Se = /^ms-/, $87bc0af96408f074$var$we = function(e) {
    return "-" + e.toLowerCase();
};
function $87bc0af96408f074$var$Ee(e) {
    return $87bc0af96408f074$var$ve.test(e) ? e.replace($87bc0af96408f074$var$ge, $87bc0af96408f074$var$we).replace($87bc0af96408f074$var$Se, "-ms-") : e;
}
var $87bc0af96408f074$var$be = function(e) {
    return null == e || !1 === e || "" === e;
};
function $87bc0af96408f074$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $87bc0af96408f074$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($87bc0af96408f074$var$be(e)) return "";
    if ($87bc0af96408f074$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($87bc0af96408f074$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $87bc0af96408f074$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $87bc0af96408f074$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $87bc0af96408f074$var$g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$87bc0af96408f074$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $87bc0af96408f074$var$E(t[i]) ? s.push($87bc0af96408f074$var$Ee(i) + ":", t[i], ";") : $87bc0af96408f074$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($87bc0af96408f074$var$Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $ddad55a018761839$export$2e2bcd8739ae039) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $87bc0af96408f074$var$Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $87bc0af96408f074$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $87bc0af96408f074$var$E(e) || $87bc0af96408f074$var$g(e) ? $87bc0af96408f074$var$Ne($87bc0af96408f074$var$_e($87bc0af96408f074$var$v($87bc0af96408f074$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $87bc0af96408f074$var$Ne($87bc0af96408f074$var$_e($87bc0af96408f074$var$v(e, n)));
}
var $87bc0af96408f074$var$Ce = /invalid hook call/i, $87bc0af96408f074$var$Ie = new Set, $87bc0af96408f074$var$Pe = function(e, t) {
    var n, r, o, e1;
}, $87bc0af96408f074$var$Oe = function(e, t, n) {
    return void 0 === n && (n = $87bc0af96408f074$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $87bc0af96408f074$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $87bc0af96408f074$var$De = /(^-|-$)/g;
function $87bc0af96408f074$var$je(e) {
    return e.replace($87bc0af96408f074$var$Re, "-").replace($87bc0af96408f074$var$De, "");
}
var $87bc0af96408f074$var$Te = function(e) {
    return $87bc0af96408f074$var$Q($87bc0af96408f074$var$te(e) >>> 0);
};
function $87bc0af96408f074$var$xe(e) {
    return "string" == typeof e && true;
}
var $87bc0af96408f074$var$ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $87bc0af96408f074$var$Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $87bc0af96408f074$var$Be(e, t, n) {
    var r = e[n];
    $87bc0af96408f074$var$ke(t) && $87bc0af96408f074$var$ke(r) ? $87bc0af96408f074$var$ze(r, t) : e[n] = t;
}
function $87bc0af96408f074$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($87bc0af96408f074$var$ke(i)) for(var a in i)$87bc0af96408f074$var$Ve(a) && $87bc0af96408f074$var$Be(e, i[a], a);
    }
    return e;
}
var $87bc0af96408f074$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).createContext(), $87bc0af96408f074$export$b631efc24e9d5e2f = $87bc0af96408f074$export$2c657da244d00bd6.Consumer;
function $87bc0af96408f074$export$d8964aec282183a3(e) {
    var t = (0, $5vDX4.useContext)($87bc0af96408f074$export$2c657da244d00bd6), n = (0, $5vDX4.useMemo)(function() {
        return function(e, t) {
            if (!e) return $87bc0af96408f074$var$D(14);
            if ($87bc0af96408f074$var$E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $87bc0af96408f074$var$D(8) : t ? $87bc0af96408f074$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).createElement($87bc0af96408f074$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $87bc0af96408f074$var$Fe = {};
function $87bc0af96408f074$var$Ye(e, t, n) {
    var o = $87bc0af96408f074$export$7ba318d8d2f06c76(e), i = !$87bc0af96408f074$var$xe(e), a = t.attrs, c = void 0 === a ? $87bc0af96408f074$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $87bc0af96408f074$var$je(e);
        $87bc0af96408f074$var$Fe[n] = ($87bc0af96408f074$var$Fe[n] || 0) + 1;
        var r = n + "-" + $87bc0af96408f074$var$Te("5.3.11" + n + $87bc0af96408f074$var$Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $87bc0af96408f074$var$xe(e) ? "styled." + e : "Styled(" + $87bc0af96408f074$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $87bc0af96408f074$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $87bc0af96408f074$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $87bc0af96408f074$var$w);
                var r = $87bc0af96408f074$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $87bc0af96408f074$var$E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($87bc0af96408f074$var$Oe(t, (0, $5vDX4.useContext)($87bc0af96408f074$export$2c657da244d00bd6), a) || $87bc0af96408f074$var$w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $87bc0af96408f074$var$pe(), s = $87bc0af96408f074$var$fe(), i = t ? e.generateAndInjectStyles($87bc0af96408f074$var$w, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = $87bc0af96408f074$var$xe(b), N = v !== t ? $87bc0af96408f074$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $e981647efc96a49d$export$2e2bcd8739ae039), b) : !_ || (0, $e981647efc96a49d$export$2e2bcd8739ae039)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $87bc0af96408f074$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $5vDX4.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $87bc0af96408f074$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($87bc0af96408f074$var$xe(e) ? e : $87bc0af96408f074$var$je($87bc0af96408f074$var$b(e)));
        return $87bc0af96408f074$var$Ye(e, $87bc0af96408f074$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $87bc0af96408f074$var$ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($d9f02effaba46552$exports)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $87bc0af96408f074$var$qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $87bc0af96408f074$var$w), !(0, $7727b9c471abe877$exports.isValidElementType)(r)) return $87bc0af96408f074$var$D(1, String(r));
        var s = function() {
            return t(r, o, $87bc0af96408f074$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $87bc0af96408f074$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $87bc0af96408f074$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($87bc0af96408f074$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $87bc0af96408f074$var$qe[e] = $87bc0af96408f074$var$qe(e);
});
var $87bc0af96408f074$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $87bc0af96408f074$var$ne(e), $87bc0af96408f074$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($87bc0af96408f074$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $87bc0af96408f074$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $87bc0af96408f074$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $87bc0af96408f074$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $87bc0af96408f074$var$Te(JSON.stringify(i)), u = new $87bc0af96408f074$var$He(i, a);
    function d(e) {
        var t = $87bc0af96408f074$var$pe(), n = $87bc0af96408f074$var$fe(), o = (0, $5vDX4.useContext)($87bc0af96408f074$export$2c657da244d00bd6), d = (0, $5vDX4.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(d, e, t, o, n), (0, $5vDX4.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $87bc0af96408f074$var$P, n, o);
        else {
            var s = $87bc0af96408f074$var$y({}, t, {
                theme: $87bc0af96408f074$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).memo(d);
}
function $87bc0af96408f074$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $87bc0af96408f074$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $87bc0af96408f074$var$Te(o);
    return new $87bc0af96408f074$var$ye(s, o);
}
var $87bc0af96408f074$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $87bc0af96408f074$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $87bc0af96408f074$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $87bc0af96408f074$var$D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $87bc0af96408f074$var$D(2);
            var n = ((t = {})[$87bc0af96408f074$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $87bc0af96408f074$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).createElement("style", $87bc0af96408f074$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $87bc0af96408f074$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $87bc0af96408f074$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).createElement($87bc0af96408f074$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $87bc0af96408f074$var$D(3);
    }, e;
}(), $87bc0af96408f074$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).forwardRef(function(t, n) {
        var o = (0, $5vDX4.useContext)($87bc0af96408f074$export$2c657da244d00bd6), i = e.defaultProps, a = $87bc0af96408f074$var$Oe(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).createElement(e, $87bc0af96408f074$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($d9f02effaba46552$exports)))(t, e), t.displayName = "WithTheme(" + $87bc0af96408f074$var$b(e) + ")", t;
}, $87bc0af96408f074$export$93d4e7f90805808f = function() {
    return (0, $5vDX4.useContext)($87bc0af96408f074$export$2c657da244d00bd6);
}, $87bc0af96408f074$export$5c87cfe6c475f500 = {
    StyleSheet: $87bc0af96408f074$var$X,
    masterSheet: $87bc0af96408f074$var$de
};
var $87bc0af96408f074$export$2e2bcd8739ae039 = $87bc0af96408f074$var$qe;


// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $9uAjU = parcelRequire("9uAjU");
var $e53e44c496beab57$exports = {};
"use strict";

$e53e44c496beab57$exports = (parcelRequire("2EGCf"));





// Default to a dummy "batch" implementation that just runs the callback
function $59e5e8046f9d4ef2$var$defaultNoopBatch(callback) {
    callback();
}
let $59e5e8046f9d4ef2$var$batch = $59e5e8046f9d4ef2$var$defaultNoopBatch; // Allow injecting another batching function later
const $59e5e8046f9d4ef2$export$4b9874722d0da7bc = (newBatch)=>$59e5e8046f9d4ef2$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $59e5e8046f9d4ef2$export$fc47d4c0ba3bd2c6 = ()=>$59e5e8046f9d4ef2$var$batch;



var $5vDX4 = parcelRequire("5vDX4");

var $5vDX4 = parcelRequire("5vDX4");

var $5vDX4 = parcelRequire("5vDX4");
const $92b6d0f75c20f981$var$ContextKey = Symbol.for(`react-redux-context`);
const $92b6d0f75c20f981$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $92b6d0f75c20f981$var$getContext() {
    var _gT$ContextKey;
    if (!$5vDX4.createContext) return {};
    const contextMap = (_gT$ContextKey = $92b6d0f75c20f981$var$gT[$92b6d0f75c20f981$var$ContextKey]) != null ? _gT$ContextKey : $92b6d0f75c20f981$var$gT[$92b6d0f75c20f981$var$ContextKey] = new Map();
    let realContext = contextMap.get($5vDX4.createContext);
    if (!realContext) {
        realContext = $5vDX4.createContext(null);
        contextMap.set($5vDX4.createContext, realContext);
    }
    return realContext;
}
const $92b6d0f75c20f981$export$cc80c08dc91f1c00 = /*#__PURE__*/ $92b6d0f75c20f981$var$getContext();
var $92b6d0f75c20f981$export$2e2bcd8739ae039 = $92b6d0f75c20f981$export$cc80c08dc91f1c00;


function $6f03eb73ba3a082d$export$d4d6226d5fc61558(context = (0, $92b6d0f75c20f981$export$cc80c08dc91f1c00)) {
    return function useReduxContext() {
        const contextValue = (0, $5vDX4.useContext)(context);
        return contextValue;
    };
}
const $6f03eb73ba3a082d$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $6f03eb73ba3a082d$export$d4d6226d5fc61558();



const $c9dc3e921872773a$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};


let $3f0ec705bb09b961$var$useSyncExternalStoreWithSelector = (0, $c9dc3e921872773a$export$20656a4825650bd0);
const $3f0ec705bb09b961$export$e2e6e3f3f3b782e3 = (fn)=>{
    $3f0ec705bb09b961$var$useSyncExternalStoreWithSelector = fn;
};
const $3f0ec705bb09b961$var$refEquality = (a, b)=>a === b;
function $3f0ec705bb09b961$export$2b53f90d2bd1cbfb(context = (0, $92b6d0f75c20f981$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $92b6d0f75c20f981$export$cc80c08dc91f1c00) ? (0, $6f03eb73ba3a082d$export$c1275ca9a6fd3ec5) : (0, $6f03eb73ba3a082d$export$d4d6226d5fc61558)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $3f0ec705bb09b961$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $5vDX4.useRef)(true);
        const wrappedSelector = (0, $5vDX4.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $3f0ec705bb09b961$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $5vDX4.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $3f0ec705bb09b961$export$2105062e25df4afe = /*#__PURE__*/ $3f0ec705bb09b961$export$2b53f90d2bd1cbfb();


function $f704efeefabd94fb$export$2e2bcd8739ae039() {
    return $f704efeefabd94fb$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f704efeefabd94fb$export$2e2bcd8739ae039.apply(null, arguments);
}


function $496b39d067619c11$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}




var $5vDX4 = parcelRequire("5vDX4");


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $be594abf53816723$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $bb01027c8481c400$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $be594abf53816723$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $bb01027c8481c400$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $bb01027c8481c400$var$verify(mapStateToProps, "mapStateToProps");
    $bb01027c8481c400$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $bb01027c8481c400$var$verify(mergeProps, "mergeProps");
}


const $cbc5da8a4d514878$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $cbc5da8a4d514878$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $cbc5da8a4d514878$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $496b39d067619c11$export$2e2bcd8739ae039)(_ref, $cbc5da8a4d514878$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $cbc5da8a4d514878$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $894440c8b4be3e66$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f8fe203ab974d5a2$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $e9ebd7fc09d951ae$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $f8fe203ab974d5a2$export$2e2bcd8739ae039)(value)) (0, $be594abf53816723$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $e9e34a68f2e5f959$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $e9e34a68f2e5f959$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $e9e34a68f2e5f959$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $e9e34a68f2e5f959$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $e9e34a68f2e5f959$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $c386f32ce4e1060b$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $2992e9312a9e39d0$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $e9e34a68f2e5f959$export$710f7c60f68acd3e)((dispatch)=>(0, $894440c8b4be3e66$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $e9e34a68f2e5f959$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $e9e34a68f2e5f959$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : (0, $c386f32ce4e1060b$export$19ef7b929f7e2559)(mapDispatchToProps, "mapDispatchToProps");
}




function $20392390b64396f1$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $e9e34a68f2e5f959$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === "function" ? (0, $e9e34a68f2e5f959$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : (0, $c386f32ce4e1060b$export$19ef7b929f7e2559)(mapStateToProps, "mapStateToProps");
}





function $dd7d43488fb98197$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $f704efeefabd94fb$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $dd7d43488fb98197$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $dd7d43488fb98197$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$dd7d43488fb98197$export$691c327fc30bc857 : typeof mergeProps === "function" ? $dd7d43488fb98197$export$5b105939c84b5234(mergeProps) : (0, $c386f32ce4e1060b$export$19ef7b929f7e2559)(mergeProps, "mergeProps");
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $495f4f43864f1be0$var$createListenerCollection() {
    const batch = (0, $59e5e8046f9d4ef2$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $495f4f43864f1be0$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $495f4f43864f1be0$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $495f4f43864f1be0$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $495f4f43864f1be0$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $495f4f43864f1be0$var$nullListeners;
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $5vDX4 = parcelRequire("5vDX4");
const $60b0a8ed9d2d7b48$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $60b0a8ed9d2d7b48$export$700979bc83e7db82 = $60b0a8ed9d2d7b48$export$71594e8a50f746f4 ? $5vDX4.useLayoutEffect : $5vDX4.useEffect;


function $b95fe0d2334c8884$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $b95fe0d2334c8884$export$2e2bcd8739ae039(objA, objB) {
    if ($b95fe0d2334c8884$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$b95fe0d2334c8884$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $a57cd4cdcb5e12e6$var$_excluded = [
    "reactReduxForwardedRef"
];
let $a57cd4cdcb5e12e6$var$useSyncExternalStore = (0, $c9dc3e921872773a$export$20656a4825650bd0);
const $a57cd4cdcb5e12e6$export$36d45daa6a4925b8 = (fn)=>{
    $a57cd4cdcb5e12e6$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $a57cd4cdcb5e12e6$var$EMPTY_ARRAY = [
    null,
    0
];
const $a57cd4cdcb5e12e6$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $a57cd4cdcb5e12e6$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $a57cd4cdcb5e12e6$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $60b0a8ed9d2d7b48$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $a57cd4cdcb5e12e6$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $a57cd4cdcb5e12e6$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $a57cd4cdcb5e12e6$var$initStateUpdates = ()=>$a57cd4cdcb5e12e6$var$EMPTY_ARRAY;
function $a57cd4cdcb5e12e6$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $a57cd4cdcb5e12e6$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $a57cd4cdcb5e12e6$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $a57cd4cdcb5e12e6$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $b95fe0d2334c8884$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $b95fe0d2334c8884$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $b95fe0d2334c8884$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $92b6d0f75c20f981$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $20392390b64396f1$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $2992e9312a9e39d0$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $dd7d43488fb98197$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $5vDX4.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $496b39d067619c11$export$2e2bcd8739ae039)(props, $a57cd4cdcb5e12e6$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $5vDX4.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $7727b9c471abe877$exports.isContextConsumer)(/*#__PURE__*/ $5vDX4.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $5vDX4.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $5vDX4.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $cbc5da8a4d514878$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $5vDX4.useMemo(()=>{
                if (!shouldHandleStateChanges) return $a57cd4cdcb5e12e6$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $495f4f43864f1be0$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $5vDX4.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $f704efeefabd94fb$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $5vDX4.useRef();
            const lastWrapperProps = $5vDX4.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $5vDX4.useRef();
            const renderIsScheduled = $5vDX4.useRef(false);
            const isProcessingDispatch = $5vDX4.useRef(false);
            const isMounted = $5vDX4.useRef(false);
            const latestSubscriptionCallbackError = $5vDX4.useRef();
            (0, $60b0a8ed9d2d7b48$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $5vDX4.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $5vDX4.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $a57cd4cdcb5e12e6$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $a57cd4cdcb5e12e6$var$useIsomorphicLayoutEffectWithArgs($a57cd4cdcb5e12e6$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $a57cd4cdcb5e12e6$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $60b0a8ed9d2d7b48$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $5vDX4.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $5vDX4.createElement(WrappedComponent, (0, $f704efeefabd94fb$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $5vDX4.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $5vDX4.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $5vDX4.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $5vDX4.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $5vDX4.createElement(Connect, (0, $f704efeefabd94fb$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($d9f02effaba46552$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($d9f02effaba46552$exports)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $a57cd4cdcb5e12e6$export$2e2bcd8739ae039 = $a57cd4cdcb5e12e6$var$connect;



var $5vDX4 = parcelRequire("5vDX4");



function $45449cf8cc6ac673$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $5vDX4.useMemo(()=>{
        const subscription = (0, $495f4f43864f1be0$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $5vDX4.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $60b0a8ed9d2d7b48$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $92b6d0f75c20f981$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $5vDX4.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $45449cf8cc6ac673$export$2e2bcd8739ae039 = $45449cf8cc6ac673$var$Provider;







function $04840727292dc08c$export$671dba69185d0304(context = (0, $92b6d0f75c20f981$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $92b6d0f75c20f981$export$cc80c08dc91f1c00) ? (0, $6f03eb73ba3a082d$export$c1275ca9a6fd3ec5) : (0, $6f03eb73ba3a082d$export$d4d6226d5fc61558)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $04840727292dc08c$export$6ccbb43953eebf8 = /*#__PURE__*/ $04840727292dc08c$export$671dba69185d0304();


function $b4c9ee2d82e952c6$export$bc9b55530897c558(context = (0, $92b6d0f75c20f981$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $92b6d0f75c20f981$export$cc80c08dc91f1c00) ? (0, $04840727292dc08c$export$6ccbb43953eebf8) : (0, $04840727292dc08c$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $b4c9ee2d82e952c6$export$8ad76b76a4c905f8 = /*#__PURE__*/ $b4c9ee2d82e952c6$export$bc9b55530897c558();









(0, $3f0ec705bb09b961$export$e2e6e3f3f3b782e3)((0, $e53e44c496beab57$exports.useSyncExternalStoreWithSelector));
(0, $a57cd4cdcb5e12e6$export$36d45daa6a4925b8)((0, $9uAjU.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $59e5e8046f9d4ef2$export$4b9874722d0da7bc)((0, $fc99b6663a8ce35f$exports.unstable_batchedUpdates));



var $kEzJs = parcelRequire("kEzJs");
const $e3d2f960b7adbb55$export$4b610b199ad29569 = {
    background: "#282C34",
    foreground: "#ABB2BF",
    overlay: "#282C34CC",
    text: "#ABB2BF",
    black: "#282C34",
    primary: "#61AFEF",
    secondary: "#E06C75",
    tertiary: "#98C379",
    quaternary: "#E5C07B",
    danger: "#C678DD",
    info: "#56B6C2",
    white: "#ABB2BF",
    "primary-overlay": "#61AFEF33"
};
const $e3d2f960b7adbb55$export$d393aa634cc9c07 = {
    background: "#FAFAFA",
    foreground: "#383A42",
    overlay: "#FAFAFACC",
    text: "#383A42",
    black: "#696C77",
    tertiary: "#50A14F",
    quaternary: "#C18401",
    primary: "#4078F2",
    secondary: "#E45649",
    danger: "#A626A4",
    info: "#0184BC",
    white: "#A0A1A7",
    "primary-overlay": "#4078F233"
};
function $e3d2f960b7adbb55$export$8e6c2fd52e77e91(theme) {
    return `
    --color-background: ${theme.background};
    --color-foreground: ${theme.foreground};
    --color-text: ${theme.text};

    --color-black: ${theme.black};
    --color-white: ${theme.white};

    --color-primary: ${theme.primary};
    --color-secondary: ${theme.secondary};
    --color-tertiary: ${theme.tertiary};
    --color-quaternary: ${theme.quaternary};
    --color-danger: ${theme.danger};
    --color-info: ${theme.info};

    --color-overlay: ${theme.overlay};
    --color-primary-overlay: ${theme["primary-overlay"]};
  `;
}




var $5vDX4 = parcelRequire("5vDX4");


parcelRequire("kSNfV");
var $dfEa8 = parcelRequire("dfEa8");
var $bqADM = parcelRequire("bqADM");


var $5vDX4 = parcelRequire("5vDX4");


/**
 * Creates a single-cache memoizer. This is a tiny replacement for `reselect`.
 */ function $e60ee05ae62896b1$export$2e2bcd8739ae039(fn) {
    let lastVal;
    let cache;
    return (value)=>{
        if (value === lastVal) return cache;
        lastVal = value;
        cache = fn(value);
        return cache;
    };
}




var $5vDX4 = parcelRequire("5vDX4");


var $kBs7x = parcelRequire("kBs7x");

var $kXV5G = parcelRequire("kXV5G");


var $5vDX4 = parcelRequire("5vDX4");



var $7W5YA = parcelRequire("7W5YA");

// THIS FILE IS AUTO GENERATED
var $6400f20ad0e55ca0$export$a0f7048edafc45cd = [
    {
        "id": "ci",
        "name": "Circum Icons",
        "projectUrl": "https://circumicons.com/",
        "license": "MPL-2.0 license",
        "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
    },
    {
        "id": "fa",
        "name": "Font Awesome 5",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "fa6",
        "name": "Font Awesome 6",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "lu",
        "name": "Lucide",
        "projectUrl": "https://lucide.dev/",
        "license": "ISC",
        "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "hi2",
        "name": "Heroicons 2",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "sl",
        "name": "Simple Line Icons",
        "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
    },
    {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "tb",
        "name": "Tabler Icons",
        "projectUrl": "https://github.com/tabler/tabler-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "tfi",
        "name": "Themify Icons",
        "projectUrl": "https://github.com/lykmapipo/themify-icons",
        "license": "MIT",
        "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
    },
    {
        "id": "rx",
        "name": "Radix Icons",
        "projectUrl": "https://icons.radix-ui.com",
        "license": "MIT",
        "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
    },
    {
        "id": "pi",
        "name": "Phosphor Icons",
        "projectUrl": "https://github.com/phosphor-icons/core",
        "license": "MIT",
        "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
    },
    {
        "id": "lia",
        "name": "Icons8 Line Awesome",
        "projectUrl": "https://icons8.com/line-awesome",
        "license": "MIT",
        "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
    }
];


var $73230ffe7ccd121e$exports = {};

$parcel$export($73230ffe7ccd121e$exports, "GenIcon", () => $73230ffe7ccd121e$export$6fce6cce1e9a936d);

var $5vDX4 = parcelRequire("5vDX4");

var $5vDX4 = parcelRequire("5vDX4");
var $e70e435e3c8387e9$export$4a4ef469214f8641 = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var $e70e435e3c8387e9$export$a49f528ae1a4d0ed = (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).createContext && (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).createContext($e70e435e3c8387e9$export$4a4ef469214f8641);


var $73230ffe7ccd121e$var$__assign = undefined && undefined.__assign || function() {
    $73230ffe7ccd121e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $73230ffe7ccd121e$var$__assign.apply(this, arguments);
};
var $73230ffe7ccd121e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $73230ffe7ccd121e$var$Tree2Element(tree) {
    return tree && tree.map(function(node, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).createElement(node.tag, $73230ffe7ccd121e$var$__assign({
            key: i
        }, node.attr), $73230ffe7ccd121e$var$Tree2Element(node.child));
    });
}
function $73230ffe7ccd121e$export$6fce6cce1e9a936d(data) {
    // eslint-disable-next-line react/display-name
    return function(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).createElement($73230ffe7ccd121e$export$a188ecdd443fe91a, $73230ffe7ccd121e$var$__assign({
            attr: $73230ffe7ccd121e$var$__assign({}, data.attr)
        }, props), $73230ffe7ccd121e$var$Tree2Element(data.child));
    };
}
function $73230ffe7ccd121e$export$a188ecdd443fe91a(props) {
    var elem = function(conf) {
        var attr = props.attr, size = props.size, title = props.title, svgProps = $73230ffe7ccd121e$var$__rest(props, [
            "attr",
            "size",
            "title"
        ]);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).createElement("svg", $73230ffe7ccd121e$var$__assign({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: $73230ffe7ccd121e$var$__assign($73230ffe7ccd121e$var$__assign({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).createElement("title", null, title), props.children);
    };
    return (0, $e70e435e3c8387e9$export$a49f528ae1a4d0ed) !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).createElement((0, $e70e435e3c8387e9$export$a49f528ae1a4d0ed).Consumer, null, function(conf) {
        return elem(conf);
    }) : elem((0, $e70e435e3c8387e9$export$4a4ef469214f8641));
}





function $fce1e8bd42f10abc$export$267f6a665e00ab4f(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 12 18 12 15 21 9 3 6 12 2 12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$f15509c0f38da8af(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 15 17 21 7 21 12 15"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$8e5723405180c9a9(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12.01",
                    "y2": "16"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$dbcde33461007065(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12.01",
                    "y2": "16"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$e155fac140286da3(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "9",
                    "x2": "12",
                    "y2": "13"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "17",
                    "x2": "12.01",
                    "y2": "17"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$95a4188b594d565e(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "10",
                    "x2": "6",
                    "y2": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "6",
                    "x2": "3",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "14",
                    "x2": "3",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "18",
                    "x2": "6",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$2eb341b7ea186bea(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "10",
                    "x2": "3",
                    "y2": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "6",
                    "x2": "3",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "14",
                    "x2": "3",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "18",
                    "x2": "3",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$8917cc30b8759ee1(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "10",
                    "x2": "3",
                    "y2": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "6",
                    "x2": "3",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "14",
                    "x2": "3",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "18",
                    "x2": "3",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$97ded619a1b970b7(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "10",
                    "x2": "7",
                    "y2": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "6",
                    "x2": "3",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "14",
                    "x2": "3",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "18",
                    "x2": "7",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$f9204ad967d5d65e(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12",
                    "y2": "8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12H2a10 10 0 0 0 20 0h-3"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$a7e9a61a7dec6d79(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.31",
                    "y1": "8",
                    "x2": "20.05",
                    "y2": "17.94"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9.69",
                    "y1": "8",
                    "x2": "21.17",
                    "y2": "8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "7.38",
                    "y1": "12",
                    "x2": "13.12",
                    "y2": "2.06"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9.69",
                    "y1": "16",
                    "x2": "3.95",
                    "y2": "6.06"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.31",
                    "y1": "16",
                    "x2": "2.83",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16.62",
                    "y1": "12",
                    "x2": "10.88",
                    "y2": "21.94"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$b2485051e564fce1(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 8 21 21 3 21 3 8"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "3",
                    "width": "22",
                    "height": "5"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "12",
                    "x2": "14",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$dd3f3c5a1d53d77e(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 12 12 16 16 12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "16"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$1c4fa461fc2194d3(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "7",
                    "x2": "7",
                    "y2": "17"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 17 7 17 7 7"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$34909c4d498f141d(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "y1": "7",
                    "x2": "17",
                    "y2": "17"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 7 17 17 7 17"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$fe357b1c469bec96(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "5",
                    "x2": "12",
                    "y2": "19"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "19 12 12 19 5 12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$9004e83bb5a50648(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 8 8 12 12 16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "12",
                    "x2": "8",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$7d058c8fc42b3484(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "y1": "12",
                    "x2": "5",
                    "y2": "12"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 19 5 12 12 5"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$eba7d9ce28178b15(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 16 16 12 12 8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$a305b640abe8c4e(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "12",
                    "x2": "19",
                    "y2": "12"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 5 19 12 12 19"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$d80098591ae56d4d(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 12 12 8 8 12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12",
                    "y2": "8"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$5ee40d2503752d98(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "17",
                    "x2": "7",
                    "y2": "7"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 17 7 7 17 7"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$e2b35aa7c05e571c(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "y1": "17",
                    "x2": "17",
                    "y2": "7"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 7 17 7 17 17"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$de137450acf89135(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "19",
                    "x2": "12",
                    "y2": "5"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "5 12 12 5 19 12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$d06ac557cb156c7d(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$b16440d451f09912(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "8",
                    "r": "7"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8.21 13.89 7 23 12 20 17 23 15.79 13.88"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$13af84db5d19481e(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "20",
                    "x2": "18",
                    "y2": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "20",
                    "x2": "12",
                    "y2": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "20",
                    "x2": "6",
                    "y2": "14"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$563c74cc78537c0(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "20",
                    "x2": "12",
                    "y2": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "20",
                    "x2": "18",
                    "y2": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "20",
                    "x2": "6",
                    "y2": "16"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$77d74f3b256203a6(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "13",
                    "x2": "23",
                    "y2": "11"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "11 6 7 12 13 12 9 18"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$dbf8d6020cf07ed9(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "6",
                    "width": "18",
                    "height": "12",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "13",
                    "x2": "23",
                    "y2": "11"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$9bf443402bff5176(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13.73 21a2 2 0 0 1-3.46 0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.63 13A17.89 17.89 0 0 1 18 8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8a6 6 0 0 0-9.33-5"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$daf9245cff6c3210(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.73 21a2 2 0 0 1-3.46 0"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$5b16f71cb5b67dde(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$98a4866a23333521(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$898b357cbb3f5d73(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$44ad51dbc660c15f(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$4e077b34ae10f582(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$a30da76548081d26(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.27 6.96 12 12.01 20.73 6.96"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22.08",
                    "x2": "12",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$ce1c504ffe508904(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "7",
                    "width": "20",
                    "height": "14",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$10d5cacd9501bbfa(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "4",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "2",
                    "x2": "16",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "2",
                    "x2": "8",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "10",
                    "x2": "21",
                    "y2": "10"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$182c5362e9e947b9(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$a5d4befc3914f30d(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "4"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$3344d3255389e578(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "20",
                    "x2": "2.01",
                    "y2": "20"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$2a34cadb9c7fec6d(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11.08V12a10 10 0 1 1-5.93-9.14"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 4 12 14.01 9 11.01"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$10e5555822717586(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 11 12 14 22 4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$12b035227cf9389b(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "20 6 9 17 4 12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$ea5380252b30a193(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "6 9 12 15 18 9"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$b69eb2f9a0945674(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 18 9 12 15 6"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$a8d72316988d19f1(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 18 15 12 9 6"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$4bd212f78cb84d52(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "18 15 12 9 6 15"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$a3a94d20ee4ea213(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 13 12 18 17 13"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 6 12 11 17 6"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$c1724d494c6a158(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "11 17 6 12 11 7"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "18 17 13 12 18 7"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$fcbcb5f8e4c2cdc9(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "13 17 18 12 13 7"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "6 17 11 12 6 7"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$a9318b47104fc04c(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 11 12 6 7 11"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 18 12 13 7 18"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$689268c79dea320b(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21.17",
                    "y1": "8",
                    "x2": "12",
                    "y2": "8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3.95",
                    "y1": "6.06",
                    "x2": "8.54",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10.88",
                    "y1": "21.94",
                    "x2": "15.46",
                    "y2": "14"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$688d8c1a5580bd89(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$718f31b68f165ef9(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "2",
                    "width": "8",
                    "height": "4",
                    "rx": "1",
                    "ry": "1"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$b8ec2cad8fdf41a5(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 6 12 12 16 14"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$f8e48da087d8be8a(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "19",
                    "x2": "8",
                    "y2": "21"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "13",
                    "x2": "8",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "19",
                    "x2": "16",
                    "y2": "21"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "13",
                    "x2": "16",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "21",
                    "x2": "12",
                    "y2": "23"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "15",
                    "x2": "12",
                    "y2": "17"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$72cf629fb485b05b(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "13 11 9 17 15 17 11 23"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$dc6782f64d5d7013(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$712e01a64a6f77b9(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "13",
                    "x2": "16",
                    "y2": "21"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "13",
                    "x2": "8",
                    "y2": "21"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "15",
                    "x2": "12",
                    "y2": "23"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$85ca6c13dc79416(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "16",
                    "x2": "8.01",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "20",
                    "x2": "8.01",
                    "y2": "20"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12.01",
                    "y2": "18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12.01",
                    "y2": "22"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "16",
                    "x2": "16.01",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "20",
                    "x2": "16.01",
                    "y2": "20"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$df461c3a33a72420(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$c13019c948ecce83(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 18 22 12 16 6"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 6 2 12 8 18"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$f02be8db599c1e5e(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12",
                    "y2": "15.5"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 8.5 12 15.5 2 8.5"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "2 15.5 12 8.5 22 15.5"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "8.5"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$a950ee04ed5abdb0(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7.5 4.21 12 6.81 16.5 4.21"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7.5 19.79 7.5 14.6 3 12"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 12 16.5 14.6 16.5 19.79"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.27 6.96 12 12.01 20.73 6.96"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22.08",
                    "x2": "12",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$2711c7e04972826d(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h1a4 4 0 0 1 0 8h-1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "1",
                    "x2": "6",
                    "y2": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "1",
                    "x2": "10",
                    "y2": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "1",
                    "x2": "14",
                    "y2": "4"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$82d4ac863d8199c6(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$7936c63f41b1a738(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$37f1a632f3f1e184(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$d343a2f87ee72e20(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "9",
                    "width": "13",
                    "height": "13",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$530c7651f0e4ae78(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 10 4 15 9 20"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v7a4 4 0 0 1-4 4H4"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$e6e1cd3d1c9d6915(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 10 20 15 15 20"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v7a4 4 0 0 0 4 4h12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$4d34c0a7548c0109(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 15 9 20 4 15"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-7a4 4 0 0 0-4 4v12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$bb2c53af7dc04770(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 9 9 4 4 9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20h-7a4 4 0 0 1-4-4V4"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$2d36a8e2d41456f(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 15 15 20 20 15"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h7a4 4 0 0 1 4 4v12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$aed74f5f80ec8ca8(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 9 15 4 20 9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h7a4 4 0 0 0 4-4V4"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$805d9902e2ab469c(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 14 4 9 9 4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 20v-7a4 4 0 0 0-4-4H4"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$2d853753f202e10b(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 14 20 9 15 4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20v-7a4 4 0 0 1 4-4h12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$4848b5bec045556f(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "4",
                    "width": "16",
                    "height": "16",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "9",
                    "width": "6",
                    "height": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "1",
                    "x2": "9",
                    "y2": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "1",
                    "x2": "15",
                    "y2": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "20",
                    "x2": "9",
                    "y2": "23"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "20",
                    "x2": "15",
                    "y2": "23"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "9",
                    "x2": "23",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "14",
                    "x2": "23",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "9",
                    "x2": "4",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "14",
                    "x2": "4",
                    "y2": "14"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$5d6c3f93b1569306(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "4",
                    "width": "22",
                    "height": "16",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "10",
                    "x2": "23",
                    "y2": "10"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$9e0e87fd57502d8d(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.13 1L6 16a2 2 0 0 0 2 2h15"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 6.13L16 6a2 2 0 0 1 2 2v15"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$49dcd8c24ba6abdc(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "y1": "12",
                    "x2": "18",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "12",
                    "x2": "2",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "6",
                    "x2": "12",
                    "y2": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$93556a14caec4876(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "rx": "9",
                    "ry": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$1a0218dab79e6acd(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "9",
                    "x2": "12",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "9",
                    "x2": "18",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$d4210adab954a159(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$87a88561efeb5120(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "8"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$e2dff6a1006d5778(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "8"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$12ec33f352eb0e16(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "12",
                    "x2": "19",
                    "y2": "12"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$4eea32b38871a225(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "1",
                    "x2": "12",
                    "y2": "23"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$5cc2db742c978330(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 17 12 21 16 17"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "12",
                    "x2": "12",
                    "y2": "21"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$d455598edb9cdf88(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 10 12 15 17 10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "15",
                    "x2": "12",
                    "y2": "3"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$663255e234895e9b(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$b93929b4cf937656(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$72c1672405f8cac2(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$3160a2892d0a1e20(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20h9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$54abe8530fbf9c81(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$dd412c17c542d388(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 3 21 3 21 9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "14",
                    "x2": "21",
                    "y2": "3"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$83d97bd7471aa8d8(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$f601afa691591de3(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$f32046460092cd1d(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$d8fce91115a92d98(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "13 19 22 12 13 5 13 19"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "2 19 11 12 2 5 2 19"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$27382a65ccd06d6e(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "8",
                    "x2": "2",
                    "y2": "22"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17.5",
                    "y1": "15",
                    "x2": "9",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$afd3026aee940215(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$f7397199414900f2(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 2 14 8 20 8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "15",
                    "x2": "15",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$8e5e18b0d5d02ea1(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 2 14 8 20 8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "15",
                    "x2": "15",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$19d242ec0e154174(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "14 2 14 8 20 8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "13",
                    "x2": "8",
                    "y2": "13"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "17",
                    "x2": "8",
                    "y2": "17"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 9 9 9 8 9"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$dc61d91398194410(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "13 2 13 9 20 9"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$7f2e92e34dfb7902(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "2",
                    "width": "20",
                    "height": "20",
                    "rx": "2.18",
                    "ry": "2.18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "y1": "2",
                    "x2": "7",
                    "y2": "22"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "2",
                    "x2": "17",
                    "y2": "22"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "12",
                    "x2": "22",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "7",
                    "x2": "7",
                    "y2": "7"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "17",
                    "x2": "7",
                    "y2": "17"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "17",
                    "x2": "22",
                    "y2": "17"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "7",
                    "x2": "22",
                    "y2": "7"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$ebb93a1afb2fac1e(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$64fe6fee89cd58a9(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "22",
                    "x2": "4",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$f07ffcc4d8a2c8ce(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "14",
                    "x2": "15",
                    "y2": "14"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$eb2e7a79d02ed668(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "11",
                    "x2": "12",
                    "y2": "17"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "14",
                    "x2": "15",
                    "y2": "14"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$3b7b3b63ca44d1fb(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$ed9f7cf4f0026f09(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$2da71e1804b6f1aa(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16s-1.5-2-4-2-4 2-4 2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "9.01",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "15.01",
                    "y2": "9"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$fa0c86613abdbc41(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "20 12 20 22 4 22 4 12"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "7",
                    "width": "20",
                    "height": "5"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22",
                    "x2": "12",
                    "y2": "7"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$f17cfdf6fa84f40d(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "3",
                    "x2": "6",
                    "y2": "15"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9a9 9 0 0 1-9 9"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$57ae875db121999c(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1.05",
                    "y1": "12",
                    "x2": "7",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17.01",
                    "y1": "12",
                    "x2": "22.96",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$89028bc8fe9485e4(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 21V9a9 9 0 0 0 9 9"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$345bfaac6794bcf3(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "18",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6h3a2 2 0 0 1 2 2v7"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "9",
                    "x2": "6",
                    "y2": "21"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$b45303d4b027680(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$89ad6403022d3567(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$9532411a3b87e58c(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "12",
                    "x2": "22",
                    "y2": "12"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$c436bd52326ef6(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "7",
                    "height": "7"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "3",
                    "width": "7",
                    "height": "7"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "14",
                    "width": "7",
                    "height": "7"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "14",
                    "width": "7",
                    "height": "7"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$795bedee3407657b(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "y1": "12",
                    "x2": "2",
                    "y2": "12"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "16",
                    "x2": "6.01",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "16",
                    "x2": "10.01",
                    "y2": "16"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$a6234e125b97d4f9(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "9",
                    "x2": "20",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "15",
                    "x2": "20",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "3",
                    "x2": "8",
                    "y2": "21"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "3",
                    "x2": "14",
                    "y2": "21"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$1ccadd16d8cae7ff(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18v-6a9 9 0 0 1 18 0v6"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$967ac3e653e15c7c(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$42bfa0ad96d58c78(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "17",
                    "x2": "12.01",
                    "y2": "17"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$5a63c278e9612374(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$2dbad18710467f1a(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 22 9 12 15 12 15 22"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$a5e7deed97e8be52(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "8.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 15 16 10 5 21"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$8df41d1420605672(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "22 12 16 12 14 15 10 15 8 12 2 12"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$6d8c744810a836d(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "16",
                    "x2": "12",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12.01",
                    "y2": "8"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$ebdbf4f9f5cef570(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "2",
                    "width": "20",
                    "height": "20",
                    "rx": "5",
                    "ry": "5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17.5",
                    "y1": "6.5",
                    "x2": "17.51",
                    "y2": "6.5"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$f3e51bbe4b2254b7(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "y1": "4",
                    "x2": "10",
                    "y2": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "20",
                    "x2": "5",
                    "y2": "20"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "4",
                    "x2": "9",
                    "y2": "20"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$e1edceb9a27803ae(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$ead8715503aa206e(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 2 7 12 12 22 7 12 2"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "2 17 12 22 22 17"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "2 12 12 17 22 12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$c5159196dfb06325(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "9",
                    "x2": "21",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "21",
                    "x2": "9",
                    "y2": "9"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$4b89084dd540ab27(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "4.93",
                    "x2": "9.17",
                    "y2": "9.17"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.83",
                    "y1": "14.83",
                    "x2": "19.07",
                    "y2": "19.07"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.83",
                    "y1": "9.17",
                    "x2": "19.07",
                    "y2": "4.93"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.83",
                    "y1": "9.17",
                    "x2": "18.36",
                    "y2": "5.64"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "19.07",
                    "x2": "9.17",
                    "y2": "14.83"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$437fb001e3a1dc1(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$c2c3e635615f60e2(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$61316a66a2680992(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "9",
                    "width": "4",
                    "height": "12"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$f35e526aef9384c3(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "6",
                    "x2": "21",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "21",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "18",
                    "x2": "21",
                    "y2": "18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "6",
                    "x2": "3.01",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "12",
                    "x2": "3.01",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "18",
                    "x2": "3.01",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$a2a03a7f204c9a2b(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12",
                    "y2": "22"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "4.93",
                    "x2": "7.76",
                    "y2": "7.76"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16.24",
                    "y1": "16.24",
                    "x2": "19.07",
                    "y2": "19.07"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "12",
                    "x2": "6",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "12",
                    "x2": "22",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "19.07",
                    "x2": "7.76",
                    "y2": "16.24"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16.24",
                    "y1": "7.76",
                    "x2": "19.07",
                    "y2": "4.93"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$fc54281b4f076899(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "11",
                    "width": "18",
                    "height": "11",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11V7a5 5 0 0 1 10 0v4"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$ba59ace88551b501(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "10 17 15 12 10 7"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "12",
                    "x2": "3",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$fa648a1b1cd7252e(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 17 21 12 16 7"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "12",
                    "x2": "9",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$27a522d77d3d2d0(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "22,6 12,13 2,6"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$ab316e04c4fb96fa(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$8333c1459f09a858(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "2",
                    "x2": "8",
                    "y2": "18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "6",
                    "x2": "16",
                    "y2": "22"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$852110258456823(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 3 21 3 21 9"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 21 3 21 3 15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "3",
                    "x2": "14",
                    "y2": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "21",
                    "x2": "10",
                    "y2": "14"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$adff177e257c8166(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$abc08bc5980688a1(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "15",
                    "x2": "16",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "9.01",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "15.01",
                    "y2": "9"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$b50769225058330c(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "12",
                    "x2": "21",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "6",
                    "x2": "21",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "18",
                    "x2": "21",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$91d40ccadbcaa6dc(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$49a9e42c2a6ffece(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$2ea53e42be78e72b(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "19",
                    "x2": "12",
                    "y2": "23"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "23",
                    "x2": "16",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$348220c4b7f2d758(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10v2a7 7 0 0 1-14 0v-2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "19",
                    "x2": "12",
                    "y2": "23"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "23",
                    "x2": "16",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$52e68ba7bb634014(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "4 14 10 14 10 20"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "20 10 14 10 14 4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "10",
                    "x2": "21",
                    "y2": "3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "21",
                    "x2": "10",
                    "y2": "14"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$476509ebc2f26d6e(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$bba246dcbc7870e4(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$35534d1daae973a9(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$6a0f8a0147922bb7(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "12",
                    "x2": "19",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$105b514200bcb0d7(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "3",
                    "width": "20",
                    "height": "14",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "21",
                    "x2": "16",
                    "y2": "21"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "17",
                    "x2": "12",
                    "y2": "21"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$fd61d60a57b49c46(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$9abca6f764c0a1ca(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "12",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "12",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$e7d9baa187481367(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "19",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$5d53b998636c728f(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13l6 6"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$725c09aded7eb198(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "5 9 2 12 5 15"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "9 5 12 2 15 5"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "15 19 12 22 9 19"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "19 9 22 12 19 15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "2",
                    "y1": "12",
                    "x2": "22",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "22"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$b0938e003378ab3e(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18V5l12-2v13"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "16",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$af9f6bab4a948d5(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 19 21 12 17 5 21 12 2"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$16d74993c11e543(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "3 11 22 2 13 21 11 13 3 11"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$33b10801cd3af8ff(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$3081f0b32ed3dc59(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "16.5",
                    "y1": "9.4",
                    "x2": "7.5",
                    "y2": "4.21"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "3.27 6.96 12 12.01 20.73 6.96"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "22.08",
                    "x2": "12",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$c00bb0cc5868b468(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$cbd3dba13ee255b0(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "15",
                    "x2": "10",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "15",
                    "x2": "14",
                    "y2": "9"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$3d4a4fdeb949ce6f(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "4",
                    "width": "4",
                    "height": "16"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "4",
                    "width": "4",
                    "height": "16"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$3d8b351359898bf5(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19l7-7 3 3-7 7-3-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2l7.586 7.586"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$57628665534438ae(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "y1": "5",
                    "x2": "5",
                    "y2": "19"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "6.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "17.5",
                    "r": "2.5"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$5dafa2a769059963(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$efe11b9a623f0a7c(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "19 1 23 5 19 9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "5",
                    "x2": "23",
                    "y2": "5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$fb25afe8b8765154(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 2 16 8 22 8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "1",
                    "x2": "16",
                    "y2": "8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$cdce28fb1c312b97(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "1",
                    "x2": "17",
                    "y2": "7"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "1",
                    "x2": "23",
                    "y2": "7"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$95defb4444eec2fe(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "1",
                    "x2": "1",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$8f53edd09d52625d(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 7 23 1 17 1"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "16",
                    "y1": "8",
                    "x2": "23",
                    "y2": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$fbcc38cc432837ad(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$cf5c74f5c9e34b73(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.21 15.89A10 10 0 1 1 8 2.83"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12A10 10 0 0 0 12 2v10z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$63ac2a4ccaccfbd1(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "10 8 16 12 10 16 10 8"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$af6bc9d78ff8665b(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "5 3 19 12 5 21 5 3"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$23b33cecb582b8d5(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$ece0f5709a547496(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "12",
                    "x2": "16",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$689fe09b4199e823(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "5",
                    "x2": "12",
                    "y2": "19"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "12",
                    "x2": "19",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$a5bf41cb81ae473(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 10 12 14 16 10"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$2606d8589e7177aa(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.36 6.64a9 9 0 1 1-12.73 0"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$95dd116dec35b14(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "6 9 6 2 18 2 18 9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "14",
                    "width": "12",
                    "height": "8"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$b82f164df0732a68(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$1ca0fe7999deb8e7(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "1 4 1 10 7 10"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 20 23 14 17 14"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$2d21aa9a27745075(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 4 23 10 17 10"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "1 20 1 14 7 14"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$6f57f453a8536a97(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 1 21 5 17 9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11V9a4 4 0 0 1 4-4h14"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 23 3 19 7 15"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 13v2a4 4 0 0 1-4 4H3"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$d056b1c3d8b74afa(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 19 2 12 11 5 11 19"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "22 19 13 12 22 5 22 19"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$70f49501e9e85938(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "1 4 1 10 7 10"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.51 15a9 9 0 1 0 2.13-9.36L1 10"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$b2facb794a39aa57(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 4 23 10 17 10"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$7118af05ee41ff35(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11a9 9 0 0 1 9 9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4a16 16 0 0 1 16 16"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "19",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$1104f45674df9c12(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 21 17 13 7 13 7 21"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "7 3 7 8 15 8"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$97278c76d25f8f7c(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "4",
                    "x2": "8.12",
                    "y2": "15.88"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14.47",
                    "y1": "14.48",
                    "x2": "20",
                    "y2": "20"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8.12",
                    "y1": "8.12",
                    "x2": "12",
                    "y2": "12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$ec3b49c1346d2396(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "21",
                    "x2": "16.65",
                    "y2": "16.65"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$3ab14b0b4740d7e5(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "22",
                    "y1": "2",
                    "x2": "11",
                    "y2": "13"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "22 2 15 22 11 13 2 9 22 2"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$cede40f6fd34759f(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "2",
                    "width": "20",
                    "height": "8",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "14",
                    "width": "20",
                    "height": "8",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "6",
                    "x2": "6.01",
                    "y2": "6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "18",
                    "x2": "6.01",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$5a7e50116f3b6280(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$1a2d68aa2edcf6c8(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "5",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "12",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "19",
                    "r": "3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8.59",
                    "y1": "13.51",
                    "x2": "15.42",
                    "y2": "17.49"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15.41",
                    "y1": "6.51",
                    "x2": "8.59",
                    "y2": "10.49"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$884092218eeb6b2c(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 6 12 2 8 6"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$cb94a82ec553b02e(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$8514cd806705464b(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$4f5d42594a6c344f(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "3",
                    "y1": "6",
                    "x2": "21",
                    "y2": "6"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10a4 4 0 0 1-8 0"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$9a07702d62565b4e(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "21",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "21",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$41f2813d6fc8a26f(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 3 21 3 21 8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "20",
                    "x2": "21",
                    "y2": "3"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "21 16 21 21 16 21"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "15",
                    "x2": "21",
                    "y2": "21"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "4",
                    "x2": "9",
                    "y2": "9"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$fbf6091c5d0aeb56(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "3",
                    "x2": "9",
                    "y2": "21"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$89616b0dc34e6f79(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "19 20 9 12 19 4 19 20"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5",
                    "y1": "19",
                    "x2": "5",
                    "y2": "5"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$110e06cce8a5f711(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "5 4 15 12 5 20 5 4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "19",
                    "y1": "5",
                    "x2": "19",
                    "y2": "19"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$1d3569727e8ef180(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$6abd105ba43862d9(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.93",
                    "y1": "4.93",
                    "x2": "19.07",
                    "y2": "19.07"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$2f24368ca37a6c53(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "21",
                    "x2": "4",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "10",
                    "x2": "4",
                    "y2": "3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "21",
                    "x2": "12",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "8",
                    "x2": "12",
                    "y2": "3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "21",
                    "x2": "20",
                    "y2": "16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "12",
                    "x2": "20",
                    "y2": "3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "14",
                    "x2": "7",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "8",
                    "x2": "15",
                    "y2": "8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "16",
                    "x2": "23",
                    "y2": "16"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$22573315dbd4b066(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "2",
                    "width": "14",
                    "height": "20",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12.01",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$228e79cc490856f(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14s1.5 2 4 2 4-2 4-2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "9.01",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "15.01",
                    "y2": "9"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$6710316ad223d692(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "2",
                    "width": "16",
                    "height": "20",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "6",
                    "x2": "12.01",
                    "y2": "6"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$596dbbbe7ed59d47(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$3d417a135f5d8fd0(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$4eb91858b35e3dd6(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "9",
                    "width": "6",
                    "height": "6"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$132f6d87d53531ee(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "5"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "1",
                    "x2": "12",
                    "y2": "3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "21",
                    "x2": "12",
                    "y2": "23"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.22",
                    "y1": "4.22",
                    "x2": "5.64",
                    "y2": "5.64"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18.36",
                    "y1": "18.36",
                    "x2": "19.78",
                    "y2": "19.78"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "12",
                    "x2": "3",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "12",
                    "x2": "23",
                    "y2": "12"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.22",
                    "y1": "19.78",
                    "x2": "5.64",
                    "y2": "18.36"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18.36",
                    "y1": "5.64",
                    "x2": "19.78",
                    "y2": "4.22"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$f1a9fd2222396582(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18a5 5 0 0 0-10 0"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "2",
                    "x2": "12",
                    "y2": "9"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.22",
                    "y1": "10.22",
                    "x2": "5.64",
                    "y2": "11.64"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "18",
                    "x2": "3",
                    "y2": "18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "18",
                    "x2": "23",
                    "y2": "18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18.36",
                    "y1": "11.64",
                    "x2": "19.78",
                    "y2": "10.22"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "22",
                    "x2": "1",
                    "y2": "22"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 6 12 2 16 6"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$920bec0eaee4bc30(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18a5 5 0 0 0-10 0"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "9",
                    "x2": "12",
                    "y2": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4.22",
                    "y1": "10.22",
                    "x2": "5.64",
                    "y2": "11.64"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "18",
                    "x2": "3",
                    "y2": "18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "18",
                    "x2": "23",
                    "y2": "18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18.36",
                    "y1": "11.64",
                    "x2": "19.78",
                    "y2": "10.22"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "22",
                    "x2": "1",
                    "y2": "22"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 5 12 9 8 5"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$11489db666064400(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "2",
                    "width": "16",
                    "height": "20",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "18",
                    "x2": "12.01",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$5f4e44affcbbc4c0(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "7",
                    "y1": "7",
                    "x2": "7.01",
                    "y2": "7"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$d1792b6fedabf003(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "6"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$cb8a6df29ab3beda(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "4 17 10 11 4 5"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "19",
                    "x2": "20",
                    "y2": "19"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$5b457b75d920e5c1(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$efaae75895b388ae(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$ce560eeab2610ecf(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$4e4f04acb0afbbf1(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "5",
                    "width": "22",
                    "height": "14",
                    "rx": "7",
                    "ry": "7"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$9a1cab46f20a3451(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "5",
                    "width": "22",
                    "height": "14",
                    "rx": "7",
                    "ry": "7"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$5a8a3c19116af3f1(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$b45f06eb58143962(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "3 6 5 6 21 6"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "10",
                    "y1": "11",
                    "x2": "10",
                    "y2": "17"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "14",
                    "y1": "11",
                    "x2": "14",
                    "y2": "17"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$d150dffb65638cb4(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "3 6 5 6 21 6"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$2b6e5173960f7231(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "7",
                    "width": "3",
                    "height": "9"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "7",
                    "width": "3",
                    "height": "5"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$473b4c32cb9c123a(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 18 13.5 8.5 8.5 13.5 1 6"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 18 23 18 23 12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$fad9644d3e8957ad(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "23 6 13.5 15.5 8.5 10.5 1 18"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 6 23 6 23 12"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$4bec88612e1cf49a(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$83296ef4c01a23c2(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "3",
                    "width": "15",
                    "height": "13"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "16 8 20 8 23 11 23 16 16 16 16 8"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5.5",
                    "cy": "18.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18.5",
                    "cy": "18.5",
                    "r": "2.5"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$54e22194544dafeb(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "7",
                    "width": "20",
                    "height": "15",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 2 12 7 7 2"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$901b594beb98342(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$1a4a79d50651dc0c(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$6fd390f7231931c3(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "4 7 4 4 20 4 20 7"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "20",
                    "x2": "15",
                    "y2": "20"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "4",
                    "x2": "12",
                    "y2": "20"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$778ecbc768cf0497(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$21435156dc525c9c(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "4",
                    "y1": "21",
                    "x2": "20",
                    "y2": "21"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$51e31213368dc22f(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "11",
                    "width": "18",
                    "height": "11",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11V7a5 5 0 0 1 9.9-1"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$dda53dfc047e1e57(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 16 12 12 8 16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "12",
                    "x2": "12",
                    "y2": "21"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "16 16 12 12 8 16"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$21d8ed3329b3bc94(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 8 12 3 7 8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "3",
                    "x2": "12",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$982c731970b14d26(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7",
                    "r": "4"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "17 11 19 13 23 9"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$946a68f031019c38(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7",
                    "r": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "11",
                    "x2": "17",
                    "y2": "11"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$d29888d481fb4bb2(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7",
                    "r": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "20",
                    "y1": "8",
                    "x2": "20",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "11",
                    "x2": "17",
                    "y2": "11"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$b89e2f833f36ed1e(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "7",
                    "r": "4"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "8",
                    "x2": "23",
                    "y2": "13"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "8",
                    "x2": "18",
                    "y2": "13"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$db323b26626af533(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "7",
                    "r": "4"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$b91acdc2f2196abd(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "7",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 21v-2a4 4 0 0 0-3-3.87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3.13a4 4 0 0 1 0 7.75"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$2f017e47d1904bf5(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$4b873a4f38d0e312(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "23 7 16 12 23 17 23 7"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "5",
                    "width": "15",
                    "height": "14",
                    "rx": "2",
                    "ry": "2"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$89a19527ac4bea7a(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "5.5",
                    "cy": "11.5",
                    "r": "4.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18.5",
                    "cy": "11.5",
                    "r": "4.5"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "5.5",
                    "y1": "16",
                    "x2": "18.5",
                    "y2": "16"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$2562182dbe6f48f1(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.54 8.46a5 5 0 0 1 0 7.07"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$2aa37add4f006aa4(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$5211546efb69b8b1(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "23",
                    "y1": "9",
                    "x2": "17",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "17",
                    "y1": "9",
                    "x2": "23",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$c245550c7099bcea(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$ba9fedcf93fa9af0(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "7"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "12 9 12 12 13.5 13.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$f11e8a486cd09251(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.72 11.06A10.94 10.94 0 0 1 19 12.55"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.55a10.94 10.94 0 0 1 5.17-2.39"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.71 5.05A16 16 0 0 1 22.58 9"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.42 9a15.91 15.91 0 0 1 4.7-2.88"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.53 16.11a6 6 0 0 1 6.95 0"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "20",
                    "x2": "12.01",
                    "y2": "20"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$4f808f790823e5a5(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12.55a11 11 0 0 1 14.08 0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.42 9a16 16 0 0 1 21.16 0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.53 16.11a6 6 0 0 1 6.95 0"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "12",
                    "y1": "20",
                    "x2": "12.01",
                    "y2": "20"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$cddc74169eed0643(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$7b1b0eab235ada3f(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "9",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "15",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$c94b846d8eff96de(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "9",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "15",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$ac22140d9ac7df07(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "3",
                    "width": "18",
                    "height": "18",
                    "rx": "2",
                    "ry": "2"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "9",
                    "y1": "9",
                    "x2": "15",
                    "y2": "15"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "15",
                    "y1": "9",
                    "x2": "9",
                    "y2": "15"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$c7222af9b49907b4(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "line",
                "attr": {
                    "x1": "18",
                    "y1": "6",
                    "x2": "6",
                    "y2": "18"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "6",
                    "y1": "6",
                    "x2": "18",
                    "y2": "18"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$9f5af188e5de0552(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
                }
            },
            {
                "tag": "polygon",
                "attr": {
                    "points": "9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$feec27b6ec0ed725(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polyline",
                "attr": {
                    "points": "12.41 6.75 13 2 10.57 4.92"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "18.57 12.91 21 10 15.66 10"
                }
            },
            {
                "tag": "polyline",
                "attr": {
                    "points": "8 8 3 14 12 14 11 22 16 16"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "1",
                    "y1": "1",
                    "x2": "23",
                    "y2": "23"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$4d144bd0444c3a46(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "polygon",
                "attr": {
                    "points": "13 2 3 14 12 14 11 22 21 10 12 10 13 2"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$38f6b9da82fb823b(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "21",
                    "x2": "16.65",
                    "y2": "16.65"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "11",
                    "y1": "8",
                    "x2": "11",
                    "y2": "14"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "11",
                    "x2": "14",
                    "y2": "11"
                }
            }
        ]
    })(props);
}
function $fce1e8bd42f10abc$export$3d3849badba7351b(props) {
    return (0, $73230ffe7ccd121e$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "strokeWidth": "2",
            "strokeLinecap": "round",
            "strokeLinejoin": "round"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "11",
                    "r": "8"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "21",
                    "y1": "21",
                    "x2": "16.65",
                    "y2": "16.65"
                }
            },
            {
                "tag": "line",
                "attr": {
                    "x1": "8",
                    "y1": "11",
                    "x2": "14",
                    "y2": "11"
                }
            }
        ]
    })(props);
}


parcelRequire("5vDX4");

// Utilities for generating type-safe CSS.
function $4d8c71437fe75bbf$export$35e9368ef982300f(id) {
    return `var(--color-${id})`;
}
const $4d8c71437fe75bbf$export$872dd985a098dd45 = "3px";
const $4d8c71437fe75bbf$export$b5ef74bd35083b44 = {
    mobile: "576px"
};


const $455f75989e0bbb06$var$Center = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const $455f75989e0bbb06$var$Description = (0, $87bc0af96408f074$export$2e2bcd8739ae039).p`
  font-style: italic;

  // Always on a black background.
  color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("white")};
`;
const $455f75989e0bbb06$var$IconContainer = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
  color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("foreground")};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 4rem;
  height: 4rem;
  overflow: hidden;
`;
// Icon style template
const $455f75989e0bbb06$var$Icon = (0, $87bc0af96408f074$export$2e2bcd8739ae039).span`
  font-size: 2rem;
  padding: 1rem;
`;
function $455f75989e0bbb06$export$79f2fd0e106e6c8d() {
    return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($455f75989e0bbb06$var$Center, {
        children: [
            /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($455f75989e0bbb06$var$IconContainer, {
                children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($455f75989e0bbb06$var$Icon, {
                    as: (0, $fce1e8bd42f10abc$export$5dafa2a769059963)
                })
            }),
            /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($455f75989e0bbb06$var$Description, {
                children: "Connecting..."
            })
        ]
    });
}
function $455f75989e0bbb06$export$b7a9550aaaca2d17() {
    return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($455f75989e0bbb06$var$Center, {
        children: [
            /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($455f75989e0bbb06$var$IconContainer, {
                children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($455f75989e0bbb06$var$Icon, {
                    as: (0, $fce1e8bd42f10abc$export$abc08bc5980688a1)
                })
            }),
            /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($455f75989e0bbb06$var$Description, {
                children: "They gone."
            })
        ]
    });
}
function $455f75989e0bbb06$export$a234ecb63c7c0994() {
    return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($455f75989e0bbb06$var$Center, {
        children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($455f75989e0bbb06$var$IconContainer, {
            children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($455f75989e0bbb06$var$Icon, {
                as: (0, $fce1e8bd42f10abc$export$db323b26626af533)
            })
        })
    });
}



var $fRjbn = parcelRequire("fRjbn");

var $kXV5G = parcelRequire("kXV5G");
const $332b14833d10b5c3$var$logger = new (0, $fRjbn.default)("<MediaView>");
class $332b14833d10b5c3$export$a672cee52305f4bd extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    componentDidMount() {
        this.syncTracksToMediaStream();
    }
    componentDidUpdate({ videoTrackId: videoTrackId, videoEnabled: videoEnabled }) {
        if (videoTrackId && this.props.videoTrackId !== videoTrackId) this.resetMediaStream();
        else if (videoEnabled && !this.props.videoEnabled) this.resetMediaStream();
        this.syncTracksToMediaStream();
    }
    render() {
        const { isLocal: isLocal, sourceType: sourceType, facingMode: facingMode } = this.props;
        return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($332b14833d10b5c3$var$Container, {
            children: [
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($332b14833d10b5c3$var$VideoStream, {
                    "data-mirror": isLocal && facingMode !== "environment",
                    "data-screen": sourceType === (0, $kXV5G.TrackSource).Display,
                    ref: this.attachMediaStream,
                    onCanPlay: this.play,
                    onPlay: this.syncPlayState,
                    onPause: this.syncPlayState,
                    "data-test": "video-stream",
                    tabIndex: -1,
                    playsInline: true,
                    autoPlay: true
                }),
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($332b14833d10b5c3$var$Overlay, {
                    children: this.renderOverlay()
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.stream = new MediaStream();
        this.videoRef = null;
        this.state = {
            playing: false
        };
        this.syncPlayState = (event)=>{
            this.setState({
                playing: event.type === "play"
            });
        };
        this.renderOverlay = ()=>{
            const { videoTrackId: videoTrackId, connectionState: connectionState, isLocal: isLocal, videoEnabled: videoEnabled } = this.props;
            if (connectionState === (0, $kXV5G.ConnectionState).Connecting) return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($455f75989e0bbb06$export$79f2fd0e106e6c8d, {});
            if (connectionState === (0, $kXV5G.ConnectionState).Disconnected) return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($455f75989e0bbb06$export$b7a9550aaaca2d17, {});
            if (!videoTrackId || !videoEnabled) return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($455f75989e0bbb06$export$a234ecb63c7c0994, {});
            if (!this.state.playing && !isLocal) return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($455f75989e0bbb06$export$79f2fd0e106e6c8d, {});
            return null;
        };
        this.attachMediaStream = async (video)=>{
            this.videoRef = video;
            this.bindStreamToVideo();
        };
        // Ensures the media stream has the tracks described by props, and only
        // those tracks. Any extras will be removed.
        this.syncTracksToMediaStream = ()=>{
            const { audioTrackId: audioTrackId, videoTrackId: videoTrackId } = this.props;
            const trackIds = [
                audioTrackId,
                videoTrackId
            ].filter(this.supportsTrack);
            const tracks = trackIds.map((trackId)=>(0, $7W5YA.default).tracks.get(trackId));
            tracks.forEach((track)=>this.stream.addTrack(track));
            this.stream.getTracks().forEach((track)=>{
                if (!tracks.includes(track)) this.stream.removeTrack(track);
            });
            this.bindStreamToVideo();
        };
        this.supportsTrack = (trackId)=>{
            const { isLocal: isLocal, audioTrackId: audioTrackId, videoTrackId: videoTrackId, videoEnabled: videoEnabled } = this.props;
            if (!trackId) return false;
            // Exclude paused video tracks. They briefly show a janky frozen frame.
            if (trackId === videoTrackId && !videoEnabled) return false;
            // Filter out your own audio track from local streams. It's distracting.
            return isLocal ? trackId !== audioTrackId : true;
        };
        // Chrome bug: if a <video> has an attached media stream before the first
        // `getUserMedia(...)` call, the permission prompt never shows, it just
        // hangs. That's why we only attach the stream when it has tracks.
        this.bindStreamToVideo = ()=>{
            const tracks = this.stream.getTracks();
            if (!this.videoRef) return;
            // At least one track was added.
            if (!this.videoRef.srcObject && tracks.length > 0) this.videoRef.srcObject = this.stream;
            // All tracks were removed.
            if (this.videoRef.srcObject && tracks.length === 0) this.videoRef.srcObject = null;
        };
        // When you remove a video track from a media stream, the video freezes on
        // the last frame. You need a new stream to clear it out.
        this.resetMediaStream = ()=>{
            if (!this.videoRef) return;
            this.stream = new MediaStream();
            this.videoRef.srcObject = null;
        };
        this.play = async ()=>{
            try {
                await this.videoRef.play();
            } catch (error) {
                // Typically this happens due to autoplay policy. Usually browsers
                // give us a pass after the first successful `getUserMedia(...)`.
                // Unless you're seeing a bug, it should be safe to ignore.
                $332b14833d10b5c3$var$logger.warn("Could not play stream:", error.message);
            }
        };
    }
}
const $332b14833d10b5c3$var$Container = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: flex;
  flex-grow: 1;
  position: relative;
  max-height: 100%;
  overflow: hidden;
  background-color: black;
`;
const $332b14833d10b5c3$var$Overlay = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-grow: 1;
`;
const $332b14833d10b5c3$var$VideoStream = (0, $87bc0af96408f074$export$2e2bcd8739ae039).video`
  object-fit: cover;
  object-position: center;
  flex-grow: 1;
  overflow: hidden;

  &[data-screen='true'] {
    object-fit: contain;
  }

  // People are used to seeing their own faces in a mirror. Replicate the
  // effect for local video streams.
  &[data-mirror='true'] {
    transform: rotateY(180deg);
  }
`;
function $332b14833d10b5c3$export$c31df4bd766f9c35(state, props) {
    const videoTrack = state.tracks[props.videoTrackId];
    return {
        videoEnabled: videoTrack?.enabled ?? false,
        facingMode: videoTrack?.facingMode ?? null
    };
}
var $332b14833d10b5c3$export$2e2bcd8739ae039 = (0, $a57cd4cdcb5e12e6$export$2e2bcd8739ae039)($332b14833d10b5c3$export$c31df4bd766f9c35)($332b14833d10b5c3$export$a672cee52305f4bd);


class $1d7a8c577a5f4bbf$export$aada361ed1a6c65 extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    render() {
        const { audioTrackId: audioTrackId, videoTrackId: videoTrackId, connectionState: connectionState, sourceType: sourceType } = this.props;
        return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $332b14833d10b5c3$export$2e2bcd8739ae039), {
            isLocal: this.props.id === (0, $kXV5G.MY_PARTICIPANT_ID),
            audioTrackId: audioTrackId,
            videoTrackId: videoTrackId,
            connectionState: connectionState,
            sourceType: sourceType
        });
    }
}
function $1d7a8c577a5f4bbf$export$c31df4bd766f9c35(state, { id: id, sourceType: sourceType = (0, $kXV5G.TrackSource).Device }) {
    const participant = state.participants[id];
    (0, $kBs7x.default)(participant, "Bad participant ID.");
    const query = (kind)=>(id)=>{
            const track = state.tracks[id];
            return track.kind === kind && track.source === sourceType;
        };
    const audioTrackId = participant.trackIds.find(query((0, $kXV5G.TrackKind).Audio));
    const videoTrackId = participant.trackIds.find(query((0, $kXV5G.TrackKind).Video));
    return {
        audioTrackId: audioTrackId || null,
        videoTrackId: videoTrackId || null,
        connectionState: participant.connection.state
    };
}
var $1d7a8c577a5f4bbf$export$2e2bcd8739ae039 = (0, $a57cd4cdcb5e12e6$export$2e2bcd8739ae039)($1d7a8c577a5f4bbf$export$c31df4bd766f9c35)($1d7a8c577a5f4bbf$export$aada361ed1a6c65);




var $5vDX4 = parcelRequire("5vDX4");




parcelRequire("kSNfV");
var $irnr8 = parcelRequire("irnr8");
var $g25kO = parcelRequire("g25kO");
var $llqKM = parcelRequire("llqKM");
var $dfEa8 = parcelRequire("dfEa8");
var $i2IU1 = parcelRequire("i2IU1");
var $676c3e06695bc416$exports = {};

$parcel$export($676c3e06695bc416$exports, "Base", () => $676c3e06695bc416$export$ef88aa0d34c34520);
$parcel$export($676c3e06695bc416$exports, "Primary", () => $676c3e06695bc416$export$f82f6251c48c818a);
$parcel$export($676c3e06695bc416$exports, "Subtle", () => $676c3e06695bc416$export$e08a60472c492df4);


const $676c3e06695bc416$export$ef88aa0d34c34520 = (0, $87bc0af96408f074$export$2e2bcd8739ae039).button`
  appearance: none;
  border: none;
  color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("text")};
  background-color: transparent;
  padding: 0;
  margin: 0;
  outline-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary")};
`;
const $676c3e06695bc416$export$f82f6251c48c818a = (0, $87bc0af96408f074$export$2e2bcd8739ae039)($676c3e06695bc416$export$ef88aa0d34c34520)`
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary")};
  border-radius: ${$4d8c71437fe75bbf$export$872dd985a098dd45};
  color: white;
  font-weight: bold;
  padding: 0.5rem 1rem;

  :focus,
  :hover {
    filter: brightness(80%);
    outline: none;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  :active {
    filter: brightness(70%);
  }
`;
const $676c3e06695bc416$export$e08a60472c492df4 = (0, $87bc0af96408f074$export$2e2bcd8739ae039)($676c3e06695bc416$export$ef88aa0d34c34520)`
  color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary")};
  font-size: 100%;

  :focus,
  :hover {
    text-decoration: underline;
  }
`;




var $5vDX4 = parcelRequire("5vDX4");

const $f651d55577bee4ac$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $f651d55577bee4ac$export$2e2bcd8739ae039 = {
    randomUUID: $f651d55577bee4ac$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $f1d11267100952a9$var$getRandomValues;
const $f1d11267100952a9$var$rnds8 = new Uint8Array(16);
function $f1d11267100952a9$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$f1d11267100952a9$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $f1d11267100952a9$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$f1d11267100952a9$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $f1d11267100952a9$var$getRandomValues($f1d11267100952a9$var$rnds8);
}


var $69b191d341e766e9$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $23bacc45dd4012ee$var$validate(uuid) {
    return typeof uuid === "string" && (0, $69b191d341e766e9$export$2e2bcd8739ae039).test(uuid);
}
var $23bacc45dd4012ee$export$2e2bcd8739ae039 = $23bacc45dd4012ee$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $d11b103d8b128113$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$d11b103d8b128113$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $d11b103d8b128113$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return ($d11b103d8b128113$var$byteToHex[arr[offset + 0]] + $d11b103d8b128113$var$byteToHex[arr[offset + 1]] + $d11b103d8b128113$var$byteToHex[arr[offset + 2]] + $d11b103d8b128113$var$byteToHex[arr[offset + 3]] + "-" + $d11b103d8b128113$var$byteToHex[arr[offset + 4]] + $d11b103d8b128113$var$byteToHex[arr[offset + 5]] + "-" + $d11b103d8b128113$var$byteToHex[arr[offset + 6]] + $d11b103d8b128113$var$byteToHex[arr[offset + 7]] + "-" + $d11b103d8b128113$var$byteToHex[arr[offset + 8]] + $d11b103d8b128113$var$byteToHex[arr[offset + 9]] + "-" + $d11b103d8b128113$var$byteToHex[arr[offset + 10]] + $d11b103d8b128113$var$byteToHex[arr[offset + 11]] + $d11b103d8b128113$var$byteToHex[arr[offset + 12]] + $d11b103d8b128113$var$byteToHex[arr[offset + 13]] + $d11b103d8b128113$var$byteToHex[arr[offset + 14]] + $d11b103d8b128113$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $d11b103d8b128113$var$stringify(arr, offset = 0) {
    const uuid = $d11b103d8b128113$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $23bacc45dd4012ee$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $d11b103d8b128113$export$2e2bcd8739ae039 = $d11b103d8b128113$var$stringify;


function $f61e091c015ba9e0$var$v4(options, buf, offset) {
    if ((0, $f651d55577bee4ac$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $f651d55577bee4ac$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $f1d11267100952a9$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $d11b103d8b128113$export$8fb373d660548968)(rnds);
}
var $f61e091c015ba9e0$export$2e2bcd8739ae039 = $f61e091c015ba9e0$var$v4;



class $01cb4e49c552248c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    render() {
        const { children: children, value: value, className: className, ...others } = this.props;
        return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($01cb4e49c552248c$var$Container, {
            className: className,
            children: [
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($01cb4e49c552248c$var$Checkbox, {
                    ...others,
                    id: this.inputId,
                    checked: value,
                    type: "checkbox"
                }),
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($01cb4e49c552248c$var$Label, {
                    htmlFor: this.inputId,
                    children: children
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.inputId = (0, $f61e091c015ba9e0$export$2e2bcd8739ae039)();
    }
}
const $01cb4e49c552248c$var$SWITCH_SIZE = "0.8rem";
const $01cb4e49c552248c$var$Container = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: flex;
  position: relative;
  align-items: center;
  margin: 1rem 0;
`;
const $01cb4e49c552248c$var$Checkbox = (0, $87bc0af96408f074$export$2e2bcd8739ae039).input`
  appearance: none;
  display: flex;
  height: ${$01cb4e49c552248c$var$SWITCH_SIZE};
  width: calc(${$01cb4e49c552248c$var$SWITCH_SIZE} * 2);
  border-radius: calc(${$01cb4e49c552248c$var$SWITCH_SIZE} * 2);
  flex-shrink: 0;
  margin: 0;
  padding: 0.15rem;
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary")};
  box-sizing: content-box;
  transition: background-color 150ms;

  :disabled {
    background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("white")};
  }

  // Invisible space. Animates the knob rightward.
  ::before {
    content: '';
    flex-grow: 0;
    transition: flex-grow 150ms;
  }

  ::after {
    content: '';
    width: ${$01cb4e49c552248c$var$SWITCH_SIZE};
    border-radius: ${$01cb4e49c552248c$var$SWITCH_SIZE};
    background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
  }

  :checked {
    background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("tertiary")};

    ::before {
      flex-grow: 1;
    }
  }
`;
const $01cb4e49c552248c$var$Label = (0, $87bc0af96408f074$export$2e2bcd8739ae039).label`
  margin-left: 0.5rem;
`;




const $8d6d0d76d4dd3c2b$var$TextInput = (0, $87bc0af96408f074$export$2e2bcd8739ae039).input`
  appearance: none;
  padding: 0.5rem;
  border-radius: ${$4d8c71437fe75bbf$export$872dd985a098dd45};
  border: 1px solid ${$4d8c71437fe75bbf$export$35e9368ef982300f("foreground")};
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
  color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("foreground")};

  ::placeholder {
    font-style: italic;
  }

  :hover,
  :focus {
    border-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary")};
    outline: none;
  }
`;
var $8d6d0d76d4dd3c2b$export$2e2bcd8739ae039 = $8d6d0d76d4dd3c2b$var$TextInput;




// Hold my beer.
const $74fd50b6f7a2fb19$var$Dropdown = (0, $87bc0af96408f074$export$2e2bcd8739ae039).select`
  appearance: none;
  border-radius: ${$4d8c71437fe75bbf$export$872dd985a098dd45};
  border: 1px solid ${$4d8c71437fe75bbf$export$35e9368ef982300f("foreground")};
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
  box-sizing: border-box;
  padding: 0.5rem 0.25rem;
  color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("text")};
  font-size: 85%;

  :hover:not(:disabled),
  :focus:not(:disabled) {
    border-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary")};
    outline: none;
  }

  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
var $74fd50b6f7a2fb19$export$2e2bcd8739ae039 = $74fd50b6f7a2fb19$var$Dropdown;





var $kXV5G = parcelRequire("kXV5G");
class $1d5a385fc9ba0528$export$c7c44baae9d9f25f extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    static #_ = (()=>{
        this.defaultProps = {
            supportsScreenSharing: "getDisplayMedia" in Object(navigator.mediaDevices),
            micTrackId: null,
            camTrackId: null
        };
    })();
    render() {
        const { togglePhonebook: togglePhonebook, togglePanel: togglePanel, micEnabled: micEnabled, camEnabled: camEnabled, micTrackId: micTrackId, camTrackId: camTrackId, activeCall: activeCall, unreadMessages: unreadMessages, sharingScreen: sharingScreen, supportsScreenSharing: supportsScreenSharing } = this.props;
        return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($1d5a385fc9ba0528$var$Container, {
            children: [
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($1d5a385fc9ba0528$var$ControlGroup, {
                    "data-left": true,
                    children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($1d5a385fc9ba0528$var$Control, {
                        "data-test": "toggle-panel",
                        "data-unread": unreadMessages,
                        onClick: togglePanel,
                        title: "Toggle panel",
                        children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $fce1e8bd42f10abc$export$9abca6f764c0a1ca), {})
                    })
                }),
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($1d5a385fc9ba0528$var$ControlGroup, {
                    children: [
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($1d5a385fc9ba0528$var$Control, {
                            "data-test": "toggle-audio",
                            onClick: this.toggleAudio,
                            disabled: !micTrackId,
                            title: micEnabled ? "Mute microphone" : "Unmute microphone",
                            children: micEnabled ? /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $fce1e8bd42f10abc$export$348220c4b7f2d758), {}) : /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $fce1e8bd42f10abc$export$2ea53e42be78e72b), {})
                        }),
                        activeCall && /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($1d5a385fc9ba0528$var$Control, {
                            "data-test": "leave-call",
                            onClick: this.endCall,
                            children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($1d5a385fc9ba0528$var$EndCallIcon, {})
                        }),
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($1d5a385fc9ba0528$var$Control, {
                            "data-test": "toggle-video",
                            onClick: this.toggleVideo,
                            disabled: !camTrackId,
                            title: camEnabled ? "Disable camera" : "Enable camera",
                            children: camEnabled ? /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $fce1e8bd42f10abc$export$4b873a4f38d0e312), {}) : /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $fce1e8bd42f10abc$export$2f017e47d1904bf5), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($1d5a385fc9ba0528$var$ControlGroup, {
                    "data-right": true,
                    children: [
                        supportsScreenSharing && /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($1d5a385fc9ba0528$var$Control, {
                            "data-test": "toggle-screen-share",
                            "data-sharing": sharingScreen,
                            onClick: this.toggleScreenShare,
                            title: sharingScreen ? "Stop sharing" : "Share your screen",
                            children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $fce1e8bd42f10abc$export$f15509c0f38da8af), {})
                        }),
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($1d5a385fc9ba0528$var$Control, {
                            "data-test": "toggle-phonebook",
                            onClick: togglePhonebook,
                            title: "Toggle phonebook",
                            children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $fce1e8bd42f10abc$export$b91acdc2f2196abd), {})
                        })
                    ]
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.toggleAudio = ()=>{
            const { micEnabled: micEnabled, micTrackId: micTrackId } = this.props;
            if (micEnabled) this.props.pauseTrack(micTrackId);
            else this.props.resumeTrack(micTrackId);
        };
        this.toggleVideo = ()=>{
            const { camEnabled: camEnabled, camTrackId: camTrackId } = this.props;
            if (camEnabled) this.props.pauseTrack(camTrackId);
            else this.props.resumeTrack(camTrackId);
        };
        this.toggleScreenShare = ()=>{
            if (this.props.sharingScreen) this.props.stopSharingScreen();
            else this.props.shareScreen();
        };
        this.endCall = ()=>{
            this.props.leaveCall(this.props.activeCall);
        };
    }
}
const $1d5a385fc9ba0528$var$Container = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
`;
const $1d5a385fc9ba0528$var$ControlGroup = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;

  &[data-left] {
    justify-content: flex-start;
  }

  &[data-right] {
    justify-content: flex-end;
  }
`;
const $1d5a385fc9ba0528$var$Control = (0, $87bc0af96408f074$export$2e2bcd8739ae039)((0, $676c3e06695bc416$exports).Base)`
  font-size: 1.5rem;
  padding: 1rem;
  position: relative;

  :hover,
  :focus {
    background-color: rgba(0, 0, 0, 0.5);

    @media (prefers-color-scheme: light) {
      background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("foreground")};
      color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
    }
  }

  :active {
    filter: brightness(70%);
  }

  :disabled {
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
  }

  &[data-unread='true']::after {
    content: ' ';
    display: block;
    border-radius: 50%;
    width: 10px;
    height: 10px;
    background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("secondary")};
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
  }

  &[data-sharing='true'] {
    color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary")};

    :hover,
    :focus {
      color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
      background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary")};
    }
  }
`;
const $1d5a385fc9ba0528$var$EndCallIcon = (0, $87bc0af96408f074$export$2e2bcd8739ae039)((0, $fce1e8bd42f10abc$export$fbcc38cc432837ad))`
  color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("secondary")};
  transform: rotate(135deg);
  transform-origin: center;
`;
function $1d5a385fc9ba0528$export$c31df4bd766f9c35(state) {
    const participant = state.participants[0, $kXV5G.MY_PARTICIPANT_ID];
    const query = (kind)=>(id)=>{
            const track = state.tracks[id];
            return track.kind === kind && track.source === (0, $kXV5G.TrackSource).Device;
        };
    const micTrackId = participant.trackIds.find(query((0, $kXV5G.TrackKind).Audio));
    const camTrackId = participant.trackIds.find(query((0, $kXV5G.TrackKind).Video));
    const camEnabled = state.tracks[camTrackId]?.enabled ?? false;
    const micEnabled = state.tracks[micTrackId]?.enabled ?? false;
    const sharingScreen = Object.values(state.tracks).some((track)=>{
        return track.local && track.source === (0, $kXV5G.TrackSource).Display;
    });
    return {
        activeCall: state.call?.peerId ?? null,
        unreadMessages: state.chat.unreadMessages,
        sharingScreen: sharingScreen,
        micTrackId: micTrackId,
        micEnabled: micEnabled,
        camTrackId: camTrackId,
        camEnabled: camEnabled
    };
}
const $1d5a385fc9ba0528$var$mapDispatchToProps = {
    togglePhonebook: $irnr8.toggle,
    togglePanel: $g25kO.toggle,
    leaveCall: $llqKM.leave,
    shareScreen: $dfEa8.shareScreen,
    stopSharingScreen: $dfEa8.stopSharingScreen,
    pauseTrack: $i2IU1.pause,
    resumeTrack: $i2IU1.resume
};
var $1d5a385fc9ba0528$export$2e2bcd8739ae039 = (0, $a57cd4cdcb5e12e6$export$2e2bcd8739ae039)($1d5a385fc9ba0528$export$c31df4bd766f9c35, $1d5a385fc9ba0528$var$mapDispatchToProps)($1d5a385fc9ba0528$export$c7c44baae9d9f25f);




var $5vDX4 = parcelRequire("5vDX4");




/* eslint-disable @typescript-eslint/no-explicit-any, prefer-spread */ /**
 * A debounce function that doesn't carry the baggage of lodash, and twice as
 * simple.
 */ function $18ed3fdb667e58eb$export$2e2bcd8739ae039(delay, cb) {
    let timeout = null;
    function wrapper(...args) {
        clearTimeout(timeout);
        // Using `.concat(...)` instead of `...args` to avoid TypeScript errors.
        // If it works for you, feel free to change it back.
        timeout = setTimeout.apply(null, [
            cb,
            delay
        ].concat(args));
    }
    const callback = Object.assign(wrapper, {
        clear () {
            clearTimeout(timeout);
        }
    });
    return callback;
}



class $ed501738b80bb644$export$ae856c47c4ff73da extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    componentWillUnmount() {
        this.scheduleNoticeDismissal.clear();
    }
    render() {
        const { showCopySuccessMessage: showCopySuccessMessage } = this.state;
        if (!this.props.isOpen) return null;
        return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($ed501738b80bb644$var$Container, {
            children: [
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($ed501738b80bb644$var$Instructions, {
                    children: "Share this URL with the person you're trying to call."
                }),
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($ed501738b80bb644$var$InputGroup, {
                    children: [
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($ed501738b80bb644$var$Input, {
                            "data-test": "invite-code",
                            value: this.getInviteUrl(),
                            onFocus: this.selectAll,
                            readOnly: true,
                            autoFocus: true
                        }),
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($ed501738b80bb644$var$CopyButton, {
                            "data-success": showCopySuccessMessage,
                            "data-test": "copy-invite-code",
                            onClick: this.copy,
                            title: "Copy to clipboard",
                            children: showCopySuccessMessage ? /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $fce1e8bd42f10abc$export$12b035227cf9389b), {
                                "data-test": "icon-success",
                                "aria-label": "Copied"
                            }) : /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $fce1e8bd42f10abc$export$718f31b68f165ef9), {
                                "data-test": "icon-inactive",
                                "aria-label": "Copy to clipboard"
                            })
                        })
                    ]
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            showCopySuccessMessage: false
        };
        this.getInviteUrl = ()=>{
            return new URL(`#/call/${this.props.localId}`, location.origin).toString();
        };
        this.selectAll = (event)=>{
            event.currentTarget.select();
        };
        this.copy = async ()=>{
            const inviteUrl = this.getInviteUrl();
            await navigator.clipboard.writeText(inviteUrl);
            this.setState({
                showCopySuccessMessage: true
            });
            this.scheduleNoticeDismissal();
        };
        this.scheduleNoticeDismissal = (0, $18ed3fdb667e58eb$export$2e2bcd8739ae039)(2000, ()=>{
            this.setState({
                showCopySuccessMessage: false
            });
        });
    }
}
const $ed501738b80bb644$var$Container = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div.attrs({
    role: "dialog"
})`
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("overlay")};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
`;
const $ed501738b80bb644$var$Instructions = (0, $87bc0af96408f074$export$2e2bcd8739ae039).p`
  padding: 0;
  margin: 0;
  margin-bottom: 1rem;
`;
const $ed501738b80bb644$var$Input = (0, $87bc0af96408f074$export$2e2bcd8739ae039).input`
  flex-grow: 1;
  padding: 0.5rem 0.5rem;
  margin: 0;
  border-radius: ${$4d8c71437fe75bbf$export$872dd985a098dd45} 0 0 ${$4d8c71437fe75bbf$export$872dd985a098dd45};
  border: 1px solid ${$4d8c71437fe75bbf$export$35e9368ef982300f("foreground")};
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
  color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("text")};
  max-width: 30rem;
  border-right: none;
  box-sizing: border-box;

  :focus,
  :hover {
    border: 1px solid ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary")};
    border-right: none;
    outline: none;
  }
`;
const $ed501738b80bb644$var$CopyButton = (0, $87bc0af96408f074$export$2e2bcd8739ae039)((0, $676c3e06695bc416$exports).Base)`
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
  color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
  border: 1px solid ${$4d8c71437fe75bbf$export$35e9368ef982300f("foreground")};
  border-radius: 0 ${$4d8c71437fe75bbf$export$872dd985a098dd45} ${$4d8c71437fe75bbf$export$872dd985a098dd45} 0;
  padding: 0 0.5rem;
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("white")};

  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  :focus,
  :hover {
    border-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary")};
    outline: none;
  }

  &[data-success='true'] {
    background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("tertiary")};
    color: white;
  }
`;
const $ed501738b80bb644$var$InputGroup = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: flex;
  margin-bottom: 1rem;
  width: 100%;
  max-width: 30rem;
`;
function $ed501738b80bb644$export$c31df4bd766f9c35({ relay: relay, phonebook: phonebook }) {
    return {
        localId: relay?.localId ?? "",
        isOpen: phonebook.open
    };
}
var $ed501738b80bb644$export$2e2bcd8739ae039 = (0, $a57cd4cdcb5e12e6$export$2e2bcd8739ae039)($ed501738b80bb644$export$c31df4bd766f9c35)($ed501738b80bb644$export$ae856c47c4ff73da);



var $kXV5G = parcelRequire("kXV5G");



var $5vDX4 = parcelRequire("5vDX4");




var $gM2lt = parcelRequire("gM2lt");



var $5vDX4 = parcelRequire("5vDX4");



var $5vDX4 = parcelRequire("5vDX4");



var $kBs7x = parcelRequire("kBs7x");

class $576e387ad0dff0a4$export$f456b8d111b9cfc3 extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    componentDidUpdate({ messages: messages }) {
        if (messages.length < this.props.messages.length) this.scrollTarget?.scrollIntoView({
            behavior: "smooth"
        });
    }
    render() {
        const { messages: messages } = this.props;
        if (messages.length === 0) return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($576e387ad0dff0a4$var$NoMessages, {
            "data-test": "message-placeholder",
            children: "No messages."
        });
        return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($576e387ad0dff0a4$var$Container, {
            "aria-atomic": true,
            "aria-live": "polite",
            children: [
                messages.map(this.renderMessage),
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)("span", {
                    "data-test": "scroll-anchor",
                    ref: this.setScrollTarget
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.scrollTarget = null;
        this.renderMessage = (message)=>{
            const locales = navigator.languages.slice();
            const formatter = new Intl.DateTimeFormat(locales, {
                timeStyle: "short"
            });
            const date = new Date(message.sentDate);
            const writtenByMe = message.author === this.props.localId;
            return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($576e387ad0dff0a4$var$Message, {
                "data-local": writtenByMe,
                "data-test": "chat-message",
                children: [
                    /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($576e387ad0dff0a4$var$MessageTimestamp, {
                        "data-test": "chat-message-timestamp",
                        dateTime: message.sentDate,
                        children: formatter.format(date)
                    }),
                    /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($576e387ad0dff0a4$var$MessageBody, {
                        "data-local": writtenByMe,
                        "data-test": "chat-message-body",
                        children: message.body
                    })
                ]
            }, message.sentDate);
        };
        // As soon as it mounts, start at the bottom of the message list, then
        // scroll each message into view as you send it.
        this.setScrollTarget = (target)=>{
            this.scrollTarget = target;
            target?.scrollIntoView();
        };
    }
}
const $576e387ad0dff0a4$var$NoMessages = (0, $87bc0af96408f074$export$2e2bcd8739ae039).p`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  font-style: italic;
  opacity: 0.5;
  margin: 0;
`;
const $576e387ad0dff0a4$var$Container = (0, $87bc0af96408f074$export$2e2bcd8739ae039).ol.attrs({
    role: "log"
})`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  margin: 0;
  margin-top: auto;
  padding: 0.5rem;
  padding-bottom: 0;
  list-style-type: none;
`;
const $576e387ad0dff0a4$var$MessageBody = (0, $87bc0af96408f074$export$2e2bcd8739ae039).p`
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("white")};
  color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
  margin: 0;
  padding: 0.5rem;
  border-radius: ${$4d8c71437fe75bbf$export$872dd985a098dd45};
  white-space: pre-wrap;
  overflow-wrap: break-word;
  max-width: 75%;

  &[data-local='true'] {
    background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary")};
  }
`;
const $576e387ad0dff0a4$var$MessageTimestamp = (0, $87bc0af96408f074$export$2e2bcd8739ae039).time`
  padding: 0.5rem;
  opacity: 0.75;
  font-size: 0.75rem;
  text-transform: lowercase;
  visibility: hidden;
`;
const $576e387ad0dff0a4$var$Message = (0, $87bc0af96408f074$export$2e2bcd8739ae039).li`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;

  &[data-local='false'] {
    flex-direction: row-reverse;
  }

  :hover ${$576e387ad0dff0a4$var$MessageTimestamp}, :focus ${$576e387ad0dff0a4$var$MessageTimestamp} {
    visibility: visible;
  }

  :not(:last-child) {
    margin-bottom: 0.25rem;
  }

  &[data-local='false'] + &[data-local='true'],
  &[data-local='true'] + &[data-local='false'] {
    margin-top: 1rem;
  }
`;
function $576e387ad0dff0a4$export$c31df4bd766f9c35({ relay: relay, participants: participants, call: call }) {
    (0, $kBs7x.default)(relay, "Missing local ID.");
    (0, $kBs7x.default)(call, "No call in progress.");
    const participant = participants[call.peerId];
    (0, $kBs7x.default)(participant, `Participant ID is invalid (id=${call.peerId})`);
    return {
        localId: relay.localId,
        messages: participant.chat.history
    };
}
var $576e387ad0dff0a4$export$2e2bcd8739ae039 = (0, $a57cd4cdcb5e12e6$export$2e2bcd8739ae039)($576e387ad0dff0a4$export$c31df4bd766f9c35)($576e387ad0dff0a4$export$f456b8d111b9cfc3);




var $5vDX4 = parcelRequire("5vDX4");



var $kBs7x = parcelRequire("kBs7x");

parcelRequire("kSNfV");
var $9A9St = parcelRequire("9A9St");

var $kXV5G = parcelRequire("kXV5G");
/**
 * This supports a cheap implementation of an autosized multiline input
 * element. These constants provide an exact value for a line-based
 * `max-height` clamp.
 */ const $7b29f70a55c71c2a$var$BORDER_WIDTH = "1px";
const $7b29f70a55c71c2a$var$INPUT_PADDING = "0.5rem";
const $7b29f70a55c71c2a$var$FONT_SIZE = "14px";
const $7b29f70a55c71c2a$var$LINE_HEIGHT = "1.2";
// This is completely arbitrary.
const $7b29f70a55c71c2a$var$MAX_MESSAGE_SIZE = 2000;
class $7b29f70a55c71c2a$export$5a55f841287167a3 extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    render() {
        const { connectionState: connectionState } = this.props;
        const disconnected = connectionState !== (0, $kXV5G.ConnectionState).Connected;
        return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($7b29f70a55c71c2a$var$Container, {
            children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($7b29f70a55c71c2a$var$Input, {
                "data-test": "chat-message-composer",
                placeholder: disconnected ? "Disconnected" : "Type a message",
                onInput: this.autosize,
                onKeyDown: this.maybeSendMessage,
                value: this.state.message,
                rows: 1,
                maxLength: $7b29f70a55c71c2a$var$MAX_MESSAGE_SIZE,
                autoFocus: true,
                spellCheck: true,
                autoComplete: "off",
                disabled: disconnected
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            message: ""
        };
        this.autosize = (event)=>{
            const ref = event.currentTarget;
            ref.style.height = "auto"; // Handles resizing when lines are deleted.
            ref.style.height = `calc(${ref.scrollHeight}px + ${$7b29f70a55c71c2a$var$BORDER_WIDTH} * 2)`;
            this.setState({
                message: event.currentTarget.value
            });
        };
        this.maybeSendMessage = (event)=>{
            const { localId: localId, remoteId: remoteId } = this.props;
            const { message: message } = this.state;
            if (event.key !== "Enter" || event.shiftKey === true) return;
            // The message is pure whitespace.
            if (/^\s*$/.test(message)) return;
            // Don't input a newline.
            event.preventDefault();
            // Clear the input.
            this.setState({
                message: ""
            });
            this.props.sendMessage({
                remoteId: remoteId,
                msg: {
                    author: localId,
                    sentDate: new Date().toISOString(),
                    body: message
                }
            });
        };
    }
}
const $7b29f70a55c71c2a$var$Container = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  padding: 0.5rem;
`;
const $7b29f70a55c71c2a$var$Input = (0, $87bc0af96408f074$export$2e2bcd8739ae039).textarea`
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
  color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("text")};
  border: ${$7b29f70a55c71c2a$var$BORDER_WIDTH} solid ${$4d8c71437fe75bbf$export$35e9368ef982300f("foreground")};
  border-radius: ${$4d8c71437fe75bbf$export$872dd985a098dd45};
  margin: 0;
  resize: none;
  width: 100%;
  box-sizing: border-box;

  font-family: inherit;
  font-size: ${$7b29f70a55c71c2a$var$FONT_SIZE};
  line-height: ${$7b29f70a55c71c2a$var$LINE_HEIGHT};
  padding: ${$7b29f70a55c71c2a$var$INPUT_PADDING};

  // Max out at 5 lines of input, then scroll.
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(
    ${$7b29f70a55c71c2a$var$BORDER_WIDTH} * 2 + ${$7b29f70a55c71c2a$var$INPUT_PADDING} * 2 + ${$7b29f70a55c71c2a$var$FONT_SIZE} * ${$7b29f70a55c71c2a$var$LINE_HEIGHT} *
      5
  );

  :hover:not(:disabled),
  :focus:not(:disabled) {
    outline: none;
    border-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary")};
  }

  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
    border-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("white")};

    ::placeholder {
      font-style: italic;
    }
  }
`;
function $7b29f70a55c71c2a$export$c31df4bd766f9c35({ relay: relay, call: call, participants: participants }) {
    (0, $kBs7x.default)(relay, "Missing local peer ID.");
    (0, $kBs7x.default)(call, "We are not in a call.");
    return {
        localId: relay.localId,
        remoteId: call.peerId,
        connectionState: participants[call.peerId].connection.state
    };
}
const $7b29f70a55c71c2a$var$mapDispatchToProps = {
    sendMessage: $9A9St.sendMessage
};
var $7b29f70a55c71c2a$export$2e2bcd8739ae039 = (0, $a57cd4cdcb5e12e6$export$2e2bcd8739ae039)($7b29f70a55c71c2a$export$c31df4bd766f9c35, $7b29f70a55c71c2a$var$mapDispatchToProps)($7b29f70a55c71c2a$export$5a55f841287167a3);


class $f9cf3cfa3a827506$export$fce4baf3ef34624f extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    render() {
        return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($f9cf3cfa3a827506$var$Container, {
            id: this.props.panelId,
            children: [
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $576e387ad0dff0a4$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $7b29f70a55c71c2a$export$2e2bcd8739ae039), {})
            ]
        });
    }
}
const $f9cf3cfa3a827506$var$Container = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
`;
var $f9cf3cfa3a827506$export$2e2bcd8739ae039 = $f9cf3cfa3a827506$export$fce4baf3ef34624f;




var $5vDX4 = parcelRequire("5vDX4");




parcelRequire("kSNfV");
var $dfEa8 = parcelRequire("dfEa8");

var $kXV5G = parcelRequire("kXV5G");


var $5vDX4 = parcelRequire("5vDX4");


parcelRequire("kSNfV");
var $dJ6bv = parcelRequire("dJ6bv");

var $kXV5G = parcelRequire("kXV5G");


class $143e380a923a9619$export$7e2170692bb74bf1 extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    render() {
        const { customIceServers: customIceServers, forceTurnRelay: forceTurnRelay, disableDefaultIceServers: disableDefaultIceServers } = this.props;
        const defaultIceServers = disableDefaultIceServers ? [] : (0, $kXV5G.ICE_SERVERS);
        return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($143e380a923a9619$var$Disclosure, {
            "data-test": "advanced-settings",
            onToggle: this.loadSettingsWhenOpened,
            children: [
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($143e380a923a9619$var$Summary, {
                    children: "Advanced settings"
                }),
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $01cb4e49c552248c$export$2e2bcd8739ae039), {
                    "data-test": "toggle-turn-relay",
                    value: forceTurnRelay,
                    onChange: this.toggleTurnRelay,
                    children: "Force TURN relay"
                }),
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $01cb4e49c552248c$export$2e2bcd8739ae039), {
                    "data-test": "toggle-default-ice-servers",
                    value: disableDefaultIceServers,
                    onChange: this.toggleDefaultIceServers,
                    children: "Disable default ICE servers"
                }),
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($143e380a923a9619$var$OverflowCatch, {
                    children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($143e380a923a9619$var$IceServers, {
                        children: [
                            /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($143e380a923a9619$var$Subtitle, {
                                children: "ICE servers"
                            }),
                            /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($143e380a923a9619$var$TableHeader, {
                                            children: "Address"
                                        }),
                                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($143e380a923a9619$var$TableHeader, {
                                            children: "Type"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)("tbody", {
                                children: [
                                    defaultIceServers.map(this.renderIceServer(false)),
                                    customIceServers.map(this.renderIceServer(true)),
                                    /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($143e380a923a9619$var$WideCell, {
                                            children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $676c3e06695bc416$exports).Subtle, {
                                                "data-test": "add-ice-server",
                                                onClick: this.addIceServer,
                                                children: "Add server"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.toggleTurnRelay = (event)=>{
            return this.props.updateSettings({
                forceTurnRelay: event.currentTarget.checked
            });
        };
        this.toggleDefaultIceServers = (event)=>{
            return this.props.updateSettings({
                disableDefaultIceServers: event.currentTarget.checked
            });
        };
        this.addIceServer = ()=>{
            this.props.onEditIceServer({
                id: this.props.customIceServers.length
            });
        };
        this.loadSettingsWhenOpened = (event)=>{
            if (event.currentTarget.open) this.props.loadSettings();
        };
        this.renderIceServer = (custom)=>(server, index)=>{
                // Coerce all URLs to an array.
                const servers = [].concat(server.urls).map((addr)=>{
                    const [type, ...rest] = addr.split(":");
                    const url = rest.join(":");
                    return {
                        type: type,
                        url: url
                    };
                });
                return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Fragment, {
                    children: servers.map((server)=>/*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($143e380a923a9619$var$TableCell, {
                                    "data-test": "ice-server-address",
                                    children: custom ? /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $676c3e06695bc416$exports).Subtle, {
                                        "data-test": "edit-ice-server",
                                        "data-id": index,
                                        onClick: this.editIceServer,
                                        title: "Edit server",
                                        children: server.url
                                    }) : server.url
                                }),
                                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($143e380a923a9619$var$IceServerType, {
                                    children: server.type
                                })
                            ]
                        }, `${index}:${server.type}:${server.url}`))
                }, index);
            };
        this.editIceServer = (event)=>{
            this.props.onEditIceServer({
                id: Number(event.currentTarget.dataset.id)
            });
        };
    }
}
const $143e380a923a9619$var$Disclosure = (0, $87bc0af96408f074$export$2e2bcd8739ae039).details`
  width: 100%;
  overflow: hidden;
`;
const $143e380a923a9619$var$Summary = (0, $87bc0af96408f074$export$2e2bcd8739ae039).summary`
  cursor: default;
`;
// <table> elements are finicky about horizontal scroll.
const $143e380a923a9619$var$OverflowCatch = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  width: 100%;
  overflow: auto;
`;
const $143e380a923a9619$var$IceServers = (0, $87bc0af96408f074$export$2e2bcd8739ae039).table`
  width: 100%;
  border-collapse: collapse;
  overflow: auto;
`;
const $143e380a923a9619$var$Subtitle = (0, $87bc0af96408f074$export$2e2bcd8739ae039).caption`
  text-align: left;
  margin: 1rem 0;
  font-weight: bold;
  font-size: 120%;
`;
const $143e380a923a9619$var$TableHeader = (0, $87bc0af96408f074$export$2e2bcd8739ae039).th`
  border: 1px solid ${$4d8c71437fe75bbf$export$35e9368ef982300f("foreground")};
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("foreground")};
  color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
  padding: 0.5rem;
`;
const $143e380a923a9619$var$TableCell = (0, $87bc0af96408f074$export$2e2bcd8739ae039).td`
  padding: 0.5rem;
  border: 1px solid ${$4d8c71437fe75bbf$export$35e9368ef982300f("white")};
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
`;
const $143e380a923a9619$var$IceServerType = (0, $87bc0af96408f074$export$2e2bcd8739ae039)($143e380a923a9619$var$TableCell)`
  text-align: center;
  text-transform: uppercase;
`;
const $143e380a923a9619$var$WideCell = (0, $87bc0af96408f074$export$2e2bcd8739ae039)($143e380a923a9619$var$TableCell).attrs({
    colSpan: 2
})`
  text-align: center;
`;
function $143e380a923a9619$export$c31df4bd766f9c35(state) {
    return state.settings.webrtc;
}
const $143e380a923a9619$var$mapDispatchToProps = {
    loadSettings: $dJ6bv.load,
    updateSettings: $dJ6bv.update
};
var $143e380a923a9619$export$2e2bcd8739ae039 = (0, $a57cd4cdcb5e12e6$export$2e2bcd8739ae039)($143e380a923a9619$export$c31df4bd766f9c35, $143e380a923a9619$var$mapDispatchToProps)($143e380a923a9619$export$7e2170692bb74bf1);




var $5vDX4 = parcelRequire("5vDX4");




parcelRequire("kSNfV");
var $dJ6bv = parcelRequire("dJ6bv");
class $e970bee4f6fc6e43$export$e8de6aa0202a5be8 extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    render() {
        const { serverType: serverType, url: url, username: username, credential: credential } = this.state;
        return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($e970bee4f6fc6e43$var$Form, {
            "data-test": "form",
            onSubmit: this.submit,
            children: [
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($e970bee4f6fc6e43$var$InputGroup, {
                    children: [
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($e970bee4f6fc6e43$var$InputName, {
                            htmlFor: this.urlInputId,
                            children: "Server URL"
                        }),
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($e970bee4f6fc6e43$var$PrefixedInput, {
                            children: [
                                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($e970bee4f6fc6e43$var$ServerTypeDropdown, {
                                    value: serverType,
                                    "data-test": "server-type",
                                    onChange: this.updateServerType,
                                    children: [
                                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($e970bee4f6fc6e43$var$ServerTypeOption, {
                                            value: $e970bee4f6fc6e43$export$48f7dfd24a46cd47.Stun,
                                            children: "stun"
                                        }),
                                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($e970bee4f6fc6e43$var$ServerTypeOption, {
                                            value: $e970bee4f6fc6e43$export$48f7dfd24a46cd47.Turn,
                                            children: "turn"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($e970bee4f6fc6e43$var$ServerUrlInput, {
                                    "data-test": "url-input",
                                    id: this.urlInputId,
                                    placeholder: "example.com:3478",
                                    onInput: this.updateUrlInput,
                                    value: url,
                                    required: true
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($e970bee4f6fc6e43$var$InputGroup, {
                    children: [
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($e970bee4f6fc6e43$var$InputName, {
                            htmlFor: this.usernameInputId,
                            children: "Username"
                        }),
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $8d6d0d76d4dd3c2b$export$2e2bcd8739ae039), {
                            placeholder: "User (optional)",
                            id: this.usernameInputId,
                            "data-test": "username-input",
                            onInput: this.updateUsername,
                            value: username
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($e970bee4f6fc6e43$var$InputGroup, {
                    children: [
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($e970bee4f6fc6e43$var$InputName, {
                            htmlFor: this.passwordInputId,
                            children: "Password"
                        }),
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $8d6d0d76d4dd3c2b$export$2e2bcd8739ae039), {
                            placeholder: "Secret (optional)",
                            id: this.passwordInputId,
                            "data-test": "password-input",
                            onInput: this.updateToken,
                            value: credential,
                            type: "password"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($e970bee4f6fc6e43$var$Buttons, {
                    children: [
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $676c3e06695bc416$exports).Primary, {
                            type: "submit",
                            children: "Save"
                        }),
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $676c3e06695bc416$exports).Subtle, {
                            "data-test": "cancel-button",
                            onClick: this.props.onClose,
                            children: "Cancel"
                        })
                    ]
                })
            ]
        });
    }
    loadState() {
        const { iceServers: iceServers, id: id } = this.props;
        const server = iceServers[id];
        const [protocol, ...rest] = String(server?.urls ?? "").split(":");
        const url = rest.join(":");
        return {
            serverType: protocol === "turn" ? $e970bee4f6fc6e43$export$48f7dfd24a46cd47.Turn : $e970bee4f6fc6e43$export$48f7dfd24a46cd47.Stun,
            url: url,
            username: server?.username ?? "",
            credential: server?.credential ?? ""
        };
    }
    constructor(...args){
        super(...args);
        this.urlInputId = (0, $f61e091c015ba9e0$export$2e2bcd8739ae039)();
        this.passwordInputId = (0, $f61e091c015ba9e0$export$2e2bcd8739ae039)();
        this.usernameInputId = (0, $f61e091c015ba9e0$export$2e2bcd8739ae039)();
        this.state = this.loadState();
        this.updateUrlInput = (event)=>{
            this.setState({
                url: event.currentTarget.value
            });
        };
        this.updateServerType = (event)=>{
            this.setState({
                serverType: event.currentTarget.value
            });
        };
        this.updateUsername = (event)=>{
            this.setState({
                username: event.currentTarget.value
            });
        };
        this.updateToken = (event)=>{
            this.setState({
                credential: event.currentTarget.value
            });
        };
        this.submit = async (event)=>{
            const { iceServers: iceServers, id: id } = this.props;
            const { serverType: serverType, url: url, username: username, credential: credential } = this.state;
            const customIceServers = iceServers.slice();
            event.preventDefault();
            event.stopPropagation();
            const server = {
                urls: `${serverType}:${url}`
            };
            if (username || credential) {
                server.credentialType = "password";
                server.username = username;
                server.credential = credential;
            }
            customIceServers.splice(id, 1, server);
            await this.props.updateSettings({
                customIceServers: customIceServers
            });
            this.props.onClose();
        };
    }
}
var $e970bee4f6fc6e43$export$48f7dfd24a46cd47;
(function(ServerType) {
    ServerType["Stun"] = "stun";
    ServerType["Turn"] = "turn";
})($e970bee4f6fc6e43$export$48f7dfd24a46cd47 || ($e970bee4f6fc6e43$export$48f7dfd24a46cd47 = {}));
const $e970bee4f6fc6e43$var$Form = (0, $87bc0af96408f074$export$2e2bcd8739ae039).form`
  display: grid;
  padding: 1rem;
  gap: 1rem;
`;
const $e970bee4f6fc6e43$var$InputGroup = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 0.5rem;
`;
const $e970bee4f6fc6e43$var$InputName = (0, $87bc0af96408f074$export$2e2bcd8739ae039).label`
  font-weight: bold;
  width: max-content;
`;
const $e970bee4f6fc6e43$var$PrefixedInput = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: flex;
`;
const $e970bee4f6fc6e43$var$ServerTypeDropdown = (0, $87bc0af96408f074$export$2e2bcd8739ae039)((0, $74fd50b6f7a2fb19$export$2e2bcd8739ae039))`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 0;
`;
const $e970bee4f6fc6e43$var$ServerTypeOption = (0, $87bc0af96408f074$export$2e2bcd8739ae039).option`
  text-transform: uppercase;
`;
const $e970bee4f6fc6e43$var$ServerUrlInput = (0, $87bc0af96408f074$export$2e2bcd8739ae039)((0, $8d6d0d76d4dd3c2b$export$2e2bcd8739ae039))`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  flex-grow: 1;
`;
const $e970bee4f6fc6e43$var$Buttons = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content;
  justify-content: start;
  direction: rtl;
  gap: 1rem;
`;
function $e970bee4f6fc6e43$export$c31df4bd766f9c35(state) {
    return {
        iceServers: state.settings.webrtc.customIceServers
    };
}
const $e970bee4f6fc6e43$var$mapDispatchToProps = {
    updateSettings: $dJ6bv.update
};
var $e970bee4f6fc6e43$export$2e2bcd8739ae039 = (0, $a57cd4cdcb5e12e6$export$2e2bcd8739ae039)($e970bee4f6fc6e43$export$c31df4bd766f9c35, $e970bee4f6fc6e43$var$mapDispatchToProps)($e970bee4f6fc6e43$export$e8de6aa0202a5be8);



const $15f4f8d5945a5454$var$NO_DEVICE_SELECTED = "no-device-selected";
class $15f4f8d5945a5454$export$fef7159a5e479b3c extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    render() {
        const { panelId: panelId, audioSources: audioSources, videoSources: videoSources, selectedAudioDeviceId: selectedAudioDeviceId, selectedVideoDeviceId: selectedVideoDeviceId } = this.props;
        if (this.state.activeIceServerEditId !== null) return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $e970bee4f6fc6e43$export$2e2bcd8739ae039), {
            onClose: this.finishEditingIceServer,
            id: this.state.activeIceServerEditId,
            "data-test": "edit-ice-server"
        });
        return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($15f4f8d5945a5454$var$Container, {
            id: panelId,
            children: [
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($15f4f8d5945a5454$var$InputGroup, {
                    children: [
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($15f4f8d5945a5454$var$InputTitle, {
                            htmlFor: this.videoInputId,
                            children: "Cameras"
                        }),
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)((0, $74fd50b6f7a2fb19$export$2e2bcd8739ae039), {
                            "data-test": "choose-video-source",
                            id: this.videoInputId,
                            disabled: videoSources.length === 0,
                            onChange: this.chooseVideoTrack,
                            value: selectedVideoDeviceId,
                            children: [
                                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)("option", {
                                    value: $15f4f8d5945a5454$var$NO_DEVICE_SELECTED,
                                    disabled: true,
                                    children: "Choose a camera"
                                }),
                                this.props.videoSources.map(this.renderVideoOption)
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($15f4f8d5945a5454$var$InputGroup, {
                    children: [
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($15f4f8d5945a5454$var$InputTitle, {
                            htmlFor: this.audioInputId,
                            children: "Microphones"
                        }),
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)((0, $74fd50b6f7a2fb19$export$2e2bcd8739ae039), {
                            "data-test": "choose-audio-source",
                            id: this.audioInputId,
                            disabled: audioSources.length === 0,
                            onChange: this.chooseAudioTrack,
                            value: selectedAudioDeviceId,
                            children: [
                                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)("option", {
                                    value: $15f4f8d5945a5454$var$NO_DEVICE_SELECTED,
                                    disabled: true,
                                    children: "Choose a microphone"
                                }),
                                this.props.audioSources.map(this.renderAudioOption)
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $143e380a923a9619$export$2e2bcd8739ae039), {
                    "data-test": "advanced-settings",
                    onEditIceServer: this.showIceServer
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            activeIceServerEditId: null
        };
        this.audioInputId = (0, $f61e091c015ba9e0$export$2e2bcd8739ae039)();
        this.videoInputId = (0, $f61e091c015ba9e0$export$2e2bcd8739ae039)();
        this.showIceServer = ({ id: id })=>{
            this.setState({
                activeIceServerEditId: id
            });
        };
        this.finishEditingIceServer = ()=>{
            this.setState({
                activeIceServerEditId: null
            });
        };
        this.createRenderer = (kind)=>(device)=>{
                return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)("option", {
                    value: device.deviceId,
                    "data-test": `${kind}-source-option`,
                    children: device.label
                }, device.deviceId);
            };
        this.renderVideoOption = this.createRenderer((0, $kXV5G.TrackKind).Video);
        this.renderAudioOption = this.createRenderer((0, $kXV5G.TrackKind).Audio);
        this.buildTrackQuery = (kind)=>(event)=>{
                const { value: value } = event.currentTarget;
                this.props.changeDevice({
                    [kind]: {
                        deviceId: {
                            exact: value
                        }
                    }
                });
            };
        this.chooseAudioTrack = this.buildTrackQuery((0, $kXV5G.TrackKind).Audio);
        this.chooseVideoTrack = this.buildTrackQuery((0, $kXV5G.TrackKind).Video);
    }
}
const $15f4f8d5945a5454$var$Container = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: grid;
  grid-row-gap: 2rem;
  grid-auto-rows: max-content;
  padding: 1rem;
  box-sizing: border-box;
  overflow: auto;
  flex-grow: 1;

  @media screen and (max-width: ${$4d8c71437fe75bbf$export$b5ef74bd35083b44.mobile}) {
    max-width: 100%;
  }
`;
const $15f4f8d5945a5454$var$InputGroup = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
const $15f4f8d5945a5454$var$InputTitle = (0, $87bc0af96408f074$export$2e2bcd8739ae039).label`
  width: max-content;
  font-weight: bold;
  margin-bottom: 0.5rem;
`;
function $15f4f8d5945a5454$export$c31df4bd766f9c35(state) {
    const { audio: audio, video: video } = state.sources.available;
    const localTracksByDeviceId = state.participants[0, $kXV5G.MY_PARTICIPANT_ID].trackIds.map((id)=>state.tracks[id]).reduce((tracks, track)=>{
        tracks.set(track.deviceId, track);
        return tracks;
    }, new Map());
    const selectedAudioDeviceId = audio.find((device)=>localTracksByDeviceId.has(device.deviceId))?.deviceId ?? $15f4f8d5945a5454$var$NO_DEVICE_SELECTED;
    const selectedVideoDeviceId = video.find((device)=>localTracksByDeviceId.has(device.deviceId))?.deviceId ?? $15f4f8d5945a5454$var$NO_DEVICE_SELECTED;
    return {
        audioSources: audio,
        videoSources: video,
        activeTracks: state.participants[0, $kXV5G.MY_PARTICIPANT_ID].trackIds,
        selectedAudioDeviceId: selectedAudioDeviceId,
        selectedVideoDeviceId: selectedVideoDeviceId
    };
}
const $15f4f8d5945a5454$var$mapDispatchToProps = {
    changeDevice: $dfEa8.requestMediaDevices
};
var $15f4f8d5945a5454$export$2e2bcd8739ae039 = (0, $a57cd4cdcb5e12e6$export$2e2bcd8739ae039)($15f4f8d5945a5454$export$c31df4bd766f9c35, $15f4f8d5945a5454$var$mapDispatchToProps)($15f4f8d5945a5454$export$fef7159a5e479b3c);



parcelRequire("kSNfV");
var $g25kO = parcelRequire("g25kO");

class $6c1d1276efaee554$export$2ddb90ad54e5f587 extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    render() {
        const { view: view, callActive: callActive } = this.props;
        const child = this.renderSubView();
        return child ? /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($6c1d1276efaee554$var$Container, {
            children: [
                callActive ? /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($6c1d1276efaee554$var$Tabs, {
                    children: [
                        callActive && /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($6c1d1276efaee554$var$Tab, {
                            "data-test": "show-chat",
                            "aria-selected": view === (0, $gM2lt.PanelView).Chat,
                            onClick: this.switchToChat,
                            "aria-controls": this.chatPanelId,
                            onFocus: this.switchToChat,
                            children: "Chat"
                        }),
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($6c1d1276efaee554$var$Tab, {
                            "data-test": "show-settings",
                            "aria-selected": view === (0, $gM2lt.PanelView).Settings,
                            onClick: this.switchToSettings,
                            "aria-controls": this.settingsPanelId,
                            onFocus: this.switchToSettings,
                            children: "Settings"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($6c1d1276efaee554$var$Header, {
                    children: [
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($6c1d1276efaee554$var$Title, {
                            children: "Settings"
                        }),
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($6c1d1276efaee554$var$CloseButton, {
                            "data-test": "close-panel",
                            onClick: this.props.close,
                            title: "Close panel",
                            children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $fce1e8bd42f10abc$export$c7222af9b49907b4), {})
                        })
                    ]
                }),
                child
            ]
        }) : null;
    }
    renderSubView() {
        switch(this.props.view){
            case (0, $gM2lt.PanelView).Chat:
                return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $f9cf3cfa3a827506$export$2e2bcd8739ae039), {
                    panelId: this.chatPanelId
                });
            case (0, $gM2lt.PanelView).Settings:
                return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $15f4f8d5945a5454$export$2e2bcd8739ae039), {
                    panelId: this.settingsPanelId
                });
            default:
                return null;
        }
    }
    constructor(...args){
        super(...args);
        this.chatPanelId = (0, $f61e091c015ba9e0$export$2e2bcd8739ae039)();
        this.settingsPanelId = (0, $f61e091c015ba9e0$export$2e2bcd8739ae039)();
        this.switchToChat = ()=>{
            if (this.props.view !== (0, $gM2lt.PanelView).Chat) this.props.showChat();
        };
        this.switchToSettings = ()=>{
            if (this.props.view !== (0, $gM2lt.PanelView).Settings) this.props.showSettings();
        };
    }
}
const $6c1d1276efaee554$var$Container = (0, $87bc0af96408f074$export$2e2bcd8739ae039).aside.attrs({
    role: "complementary"
})`
  display: flex;
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
  flex-direction: column;
  min-width: 22rem;
  max-width: 32rem;
  width: 25%;
  box-shadow: inset 0 -4px 4px -4px rgba(0, 0, 0, 0.4);

  @media screen and (max-width: ${$4d8c71437fe75bbf$export$b5ef74bd35083b44.mobile}) {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("overlay")};
    min-width: 0;
    max-width: none;
    width: auto;
    box-shadow: none;
  }
`;
const $6c1d1276efaee554$var$Header = (0, $87bc0af96408f074$export$2e2bcd8739ae039).header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;
const $6c1d1276efaee554$var$Title = (0, $87bc0af96408f074$export$2e2bcd8739ae039).h2`
  margin: 0;
`;
const $6c1d1276efaee554$var$Tabs = (0, $87bc0af96408f074$export$2e2bcd8739ae039).nav.attrs({
    role: "tablist"
})`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
`;
const $6c1d1276efaee554$var$Tab = (0, $87bc0af96408f074$export$2e2bcd8739ae039)((0, $676c3e06695bc416$exports).Base).attrs({
    role: "tab"
})`
  display: flex;
  justify-content: center;
  padding: 1rem 0;
  border-bottom: 3px solid transparent;
  font-weight: bold;
  transition-timing-function: ease-out;
  transition-property: color, background-color;
  transition-duration: 100ms;
  font-size: 100%;

  :hover,
  :focus {
    outline: none;
    background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary-overlay")};
  }

  &[aria-selected='true'] {
    border-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary")};
    color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary")};
    background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary-overlay")};
  }

  &[aria-selected='false'] {
    border-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("primary-overlay")};
  }
`;
const $6c1d1276efaee554$var$CloseButton = (0, $87bc0af96408f074$export$2e2bcd8739ae039)((0, $676c3e06695bc416$exports).Base)`
  display: flex;
  font-size: 1.5rem;
`;
function $6c1d1276efaee554$export$c31df4bd766f9c35(state) {
    return {
        view: state.panel.view,
        callActive: state.call !== null
    };
}
const $6c1d1276efaee554$var$mapDispatchToProps = {
    showChat: $g25kO.showChat,
    showSettings: $g25kO.showSettings,
    close: $g25kO.close
};
var $6c1d1276efaee554$export$2e2bcd8739ae039 = (0, $a57cd4cdcb5e12e6$export$2e2bcd8739ae039)($6c1d1276efaee554$export$c31df4bd766f9c35, $6c1d1276efaee554$var$mapDispatchToProps)($6c1d1276efaee554$export$2ddb90ad54e5f587);


class $8ccfc2c5cf1ff91c$export$626a4e62a18da2e4 extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    render() {
        const { participantIds: participantIds } = this.props;
        return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($8ccfc2c5cf1ff91c$var$FullScreen, {
            children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($8ccfc2c5cf1ff91c$var$Column, {
                children: [
                    /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($8ccfc2c5cf1ff91c$var$Row, {
                        children: [
                            /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($8ccfc2c5cf1ff91c$var$VideoLayout, {
                                children: [
                                    participantIds.length > 1 ? this.renderMeetingRoom() : /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $1d7a8c577a5f4bbf$export$2e2bcd8739ae039), {
                                        id: (0, $kXV5G.MY_PARTICIPANT_ID)
                                    }),
                                    /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $ed501738b80bb644$export$2e2bcd8739ae039), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $6c1d1276efaee554$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $1d5a385fc9ba0528$export$2e2bcd8739ae039), {})
                ]
            })
        });
    }
    constructor(...args){
        super(...args);
        this.renderMeetingRoom = ()=>{
            const { participantIds: participantIds, showRemoteDisplay: showRemoteDisplay } = this.props;
            const [otherPeer] = participantIds.filter((id)=>id !== (0, $kXV5G.MY_PARTICIPANT_ID));
            return showRemoteDisplay ? /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)((0, $33a4b0efc5f73897$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $1d7a8c577a5f4bbf$export$2e2bcd8739ae039), {
                        id: otherPeer,
                        sourceType: (0, $kXV5G.TrackSource).Display
                    }),
                    /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($8ccfc2c5cf1ff91c$var$FloatingVideo, {
                        children: [
                            /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $1d7a8c577a5f4bbf$export$2e2bcd8739ae039), {
                                id: (0, $kXV5G.MY_PARTICIPANT_ID)
                            }),
                            /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $1d7a8c577a5f4bbf$export$2e2bcd8739ae039), {
                                id: otherPeer
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)((0, $33a4b0efc5f73897$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $1d7a8c577a5f4bbf$export$2e2bcd8739ae039), {
                        id: otherPeer
                    }),
                    /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($8ccfc2c5cf1ff91c$var$FloatingVideo, {
                        children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $1d7a8c577a5f4bbf$export$2e2bcd8739ae039), {
                            id: (0, $kXV5G.MY_PARTICIPANT_ID)
                        })
                    })
                ]
            });
        };
    }
}
const $8ccfc2c5cf1ff91c$var$FullScreen = (0, $87bc0af96408f074$export$2e2bcd8739ae039).main.attrs({
    role: "main"
})`
  max-height: 100vh;
  max-width: 100%;
  display: flex;
  flex-grow: 1;
`;
const $8ccfc2c5cf1ff91c$var$Column = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  flex-direction: column;
`;
const $8ccfc2c5cf1ff91c$var$Row = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  position: relative;

  // Used for <ChatPanel> stack order.
  flex-direction: row-reverse;
`;
const $8ccfc2c5cf1ff91c$var$VideoLayout = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  position: relative;
`;
const $8ccfc2c5cf1ff91c$var$FloatingVideo = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 2rem;
  right: 2rem;
  width: 15rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border: 1px solid ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
  max-width: 30%;
  transition: opacity 100ms ease-out;

  :hover {
    opacity: 0.25;
  }
`;
const $8ccfc2c5cf1ff91c$var$getParticipantIds = (0, $e60ee05ae62896b1$export$2e2bcd8739ae039)(Object.keys);
function $8ccfc2c5cf1ff91c$export$c31df4bd766f9c35(state) {
    const showRemoteDisplay = Object.values(state.tracks).some((track)=>{
        return track.source === (0, $kXV5G.TrackSource).Display && !track.local;
    });
    return {
        participantIds: $8ccfc2c5cf1ff91c$var$getParticipantIds(state.participants),
        showRemoteDisplay: showRemoteDisplay
    };
}
var $8ccfc2c5cf1ff91c$export$2e2bcd8739ae039 = (0, $a57cd4cdcb5e12e6$export$2e2bcd8739ae039)($8ccfc2c5cf1ff91c$export$c31df4bd766f9c35)($8ccfc2c5cf1ff91c$export$626a4e62a18da2e4);



var $kXV5G = parcelRequire("kXV5G");

var $5vDX4 = parcelRequire("5vDX4");

parcelRequire("kSNfV");
var $bqADM = parcelRequire("bqADM");

var $kXV5G = parcelRequire("kXV5G");
class $9f66f0f7f1f65fa0$export$e01206ada8a50a1c extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    componentDidUpdate(prevProps) {
        if (!this.readyToCall(prevProps) && this.readyToCall(this.props)) {
            const { peerId: peerId } = this.props.route.params;
            this.props.dial(`${this.props.relayServer}/p2p-circuit/p2p/${peerId}`);
        }
    }
    render() {
        return this.props.children;
    }
    readyToCall(props) {
        return props.route.id === (0, $kXV5G.Routes).Call && props.relayServer !== null && props.hasLocalTracks;
    }
}
function $9f66f0f7f1f65fa0$export$c31df4bd766f9c35(state) {
    return {
        route: state.route,
        relayServer: state.relay?.server ?? null,
        hasLocalTracks: state.participants[0, $kXV5G.MY_PARTICIPANT_ID].trackIds.length > 0
    };
}
const $9f66f0f7f1f65fa0$var$mapDispatchToProps = {
    dial: $bqADM.dial
};
var $9f66f0f7f1f65fa0$export$2e2bcd8739ae039 = (0, $a57cd4cdcb5e12e6$export$2e2bcd8739ae039)($9f66f0f7f1f65fa0$export$c31df4bd766f9c35, $9f66f0f7f1f65fa0$var$mapDispatchToProps)($9f66f0f7f1f65fa0$export$e01206ada8a50a1c);



var $5vDX4 = parcelRequire("5vDX4");

parcelRequire("kSNfV");
var $i2IU1 = parcelRequire("i2IU1");

var $kXV5G = parcelRequire("kXV5G");
class $0f46508c94d1cab7$export$4b98e81bc48f81ec extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    componentDidMount() {
        document.body.addEventListener("keydown", this.checkForKeybinding);
    }
    componentWillUnmount() {
        document.body.removeEventListener("keydown", this.checkForKeybinding);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.checkForKeybinding = (event)=>{
            const code = [
                event.metaKey && "meta",
                event.ctrlKey && "ctrl",
                event.altKey && "alt",
                event.shiftKey && "shift",
                event.key
            ].filter(Boolean).join("+");
            if (this.keybindings.has(code)) {
                event.preventDefault();
                this.keybindings.get(code)();
            }
        };
        this.toggleMic = ()=>{
            const { audioTrackId: audioTrackId } = this.props;
            if (!audioTrackId) return;
            this.props.toggleTrack(audioTrackId);
        };
        this.toggleCam = ()=>{
            const { videoTrackId: videoTrackId } = this.props;
            if (!videoTrackId) return;
            this.props.toggleTrack(videoTrackId);
        };
        this.keybindings = new Map([
            [
                "ctrl+e",
                this.toggleCam
            ],
            [
                "ctrl+d",
                this.toggleMic
            ]
        ]);
    }
}
function $0f46508c94d1cab7$export$c31df4bd766f9c35(state) {
    const participant = state.participants[0, $kXV5G.MY_PARTICIPANT_ID];
    const audioTrackId = participant.trackIds.find((trackId)=>{
        return state.tracks[trackId].kind === (0, $kXV5G.TrackKind).Audio;
    });
    const videoTrackId = participant.trackIds.find((trackId)=>{
        return state.tracks[trackId].kind === (0, $kXV5G.TrackKind).Video;
    });
    return {
        audioTrackId: audioTrackId || null,
        videoTrackId: videoTrackId || null
    };
}
const $0f46508c94d1cab7$var$mapDispatchToProps = {
    toggleTrack: $i2IU1.toggle
};
var $0f46508c94d1cab7$export$2e2bcd8739ae039 = (0, $a57cd4cdcb5e12e6$export$2e2bcd8739ae039)($0f46508c94d1cab7$export$c31df4bd766f9c35, $0f46508c94d1cab7$var$mapDispatchToProps)($0f46508c94d1cab7$export$4b98e81bc48f81ec);




var $5vDX4 = parcelRequire("5vDX4");




var $kXV5G = parcelRequire("kXV5G");


parcelRequire("kSNfV");
var $dfEa8 = parcelRequire("dfEa8");

var $5vDX4 = parcelRequire("5vDX4");
class $a9e954c25d542036$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    componentDidMount() {
        this.attachListener();
    }
    componentWillUnmount() {
        this.detachListener(this.props);
    }
    componentDidUpdate(prev) {
        this.detachListener(prev);
        this.attachListener();
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.attachListener = ()=>{
            this.props.target.addEventListener(this.props.eventName, this.handleEvent);
        };
        this.detachListener = (props)=>{
            props.target.removeEventListener(props.eventName, this.handleEvent);
        };
        this.handleEvent = (event)=>{
            this.props.onEvent(event);
        };
    }
}


class $bda596c8deb42a2e$export$874a0b98194fbe7a extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    render() {
        const { deviceError: deviceError } = this.props;
        if (deviceError === null) return null;
        return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $a9e954c25d542036$export$2e2bcd8739ae039), {
            eventName: "keydown",
            onEvent: this.detectEscape,
            target: document.body,
            "data-test": "event-observer",
            children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($bda596c8deb42a2e$var$Backdrop, {
                children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($bda596c8deb42a2e$var$Dialog, {
                    children: [
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($bda596c8deb42a2e$var$Title, {
                            children: [
                                "Media Error ",
                                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $fce1e8bd42f10abc$export$e155fac140286da3), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($bda596c8deb42a2e$var$Content, {
                            children: [
                                this.renderErrorText(),
                                /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($bda596c8deb42a2e$var$CloseButton, {
                                    autoFocus: true,
                                    "data-test": "close-button",
                                    onClick: this.props.close,
                                    children: "Close"
                                })
                            ]
                        })
                    ]
                })
            })
        });
    }
    renderErrorText() {
        switch(this.props.deviceError){
            case (0, $kXV5G.DeviceError).NotAllowed:
                return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($bda596c8deb42a2e$var$Description, {
                    "data-test": "error-text",
                    children: "Your browser won't let us have access to the microphone or camera."
                });
            default:
                return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($bda596c8deb42a2e$var$Description, {
                    "data-test": "error-text",
                    children: "Huh. Something went wrong while trying to get camera/microphone access."
                });
        }
    }
    constructor(...args){
        super(...args);
        this.detectEscape = (event)=>{
            if (event.key === "Escape") this.props.close();
        };
    }
}
const $bda596c8deb42a2e$var$Backdrop = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("overlay")};
`;
const $bda596c8deb42a2e$var$Dialog = (0, $87bc0af96408f074$export$2e2bcd8739ae039).section`
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
  min-width: 30%;
  max-width: 50%;
  overflow: hidden;
  border-radius: ${$4d8c71437fe75bbf$export$872dd985a098dd45};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  @media screen and (max-width: ${$4d8c71437fe75bbf$export$b5ef74bd35083b44.mobile}) {
    max-width: none;
    width: 90%;
  }
`;
const $bda596c8deb42a2e$var$Title = (0, $87bc0af96408f074$export$2e2bcd8739ae039).h2`
  background-color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("secondary")};
  color: ${$4d8c71437fe75bbf$export$35e9368ef982300f("background")};
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 1rem;
`;
const $bda596c8deb42a2e$var$Content = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 1rem;
  padding: 1rem;
`;
const $bda596c8deb42a2e$var$Description = (0, $87bc0af96408f074$export$2e2bcd8739ae039).p`
  margin: 0;
`;
const $bda596c8deb42a2e$var$CloseButton = (0, $87bc0af96408f074$export$2e2bcd8739ae039)((0, $676c3e06695bc416$exports).Primary)`
  justify-self: end;
`;
function $bda596c8deb42a2e$export$c31df4bd766f9c35(state) {
    return {
        deviceError: state.sources.error
    };
}
const $bda596c8deb42a2e$var$mapDispatchToProps = {
    close: $dfEa8.closeErrorModal
};
var $bda596c8deb42a2e$export$2e2bcd8739ae039 = (0, $a57cd4cdcb5e12e6$export$2e2bcd8739ae039)($bda596c8deb42a2e$export$c31df4bd766f9c35, $bda596c8deb42a2e$var$mapDispatchToProps)($bda596c8deb42a2e$export$874a0b98194fbe7a);


class $aeb822ff39ba5368$export$86fbec116b87613f extends (0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).Component {
    async componentDidMount() {
        // The only time this happens is during development, when the `<App>`
        // component is hot reloaded. Trying to initialize the app again messes
        // everything up and can cause errors.
        if (this.props.appInitialized) return;
        await Promise.allSettled([
            this.props.requestMediaDevices({
                audio: true,
                video: true
            }),
            // Opens a connection to the relay server.
            this.props.connectToServer((0, $kXV5G.SERVER_ADDRESS))
        ]);
        // If GUM is successful, the output of `loadDeviceList()` might be
        // different as browsers reveal more device information after the first
        // successful query. But we still want to grab them even if it fails.
        //
        // Similarly, `enumerateDeviceList()` can fail for unexpected and
        // nonsensical reasons. That's okay. It will correct itself after the next
        // device change event, courtesy of `observe()`.
        await Promise.allSettled([
            this.props.loadDeviceList()
        ]);
        this.props.observeDeviceList();
    }
    render() {
        return /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $0f46508c94d1cab7$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $9f66f0f7f1f65fa0$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsxs)($aeb822ff39ba5368$var$Container, {
                    children: [
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $8ccfc2c5cf1ff91c$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $bda596c8deb42a2e$export$2e2bcd8739ae039), {})
                    ]
                })
            })
        });
    }
}
const $aeb822ff39ba5368$var$Container = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: flex;
  flex-grow: 1;
`;
function $aeb822ff39ba5368$export$c31df4bd766f9c35(state) {
    return {
        // This is a good approximation.
        appInitialized: state.relay !== null
    };
}
const $aeb822ff39ba5368$var$mapDispatchToProps = {
    requestMediaDevices: $dfEa8.requestMediaDevices,
    connectToServer: $bqADM.listen,
    loadDeviceList: $dfEa8.list,
    observeDeviceList: $dfEa8.observe
};
var $aeb822ff39ba5368$export$2e2bcd8739ae039 = (0, $a57cd4cdcb5e12e6$export$2e2bcd8739ae039)($aeb822ff39ba5368$export$c31df4bd766f9c35, $aeb822ff39ba5368$var$mapDispatchToProps)($aeb822ff39ba5368$export$86fbec116b87613f);



var $kBs7x = parcelRequire("kBs7x");
parcelRequire("kSNfV");
var $fTsmx = parcelRequire("fTsmx");
class $a1dd997125913da6$export$2e2bcd8739ae039 {
    /**
   * Transform `location.hash` into a consistent path name.
   *
   * #path/to/route/ -> /path/to/route
   */ static normalizePath(hash) {
        return hash.replace(/^#/, "") // No leading hash signs.
        .replace(/^([^/])/, "/$1") // No trailing slashes.
        .replace(/\/$/, "") // Force leading slashes.
        .replace(/^$/, "/"); // Redirect '' to '/'.
    }
    /**
   * Observes the browser URL and clamps it to the given routes. Changes are
   * dispatched to redux.
   */ static init(config) {
        const router = new $a1dd997125913da6$export$2e2bcd8739ae039(config);
        router.updateUrl();
        window.onhashchange = router.updateUrl;
        return router;
    }
    constructor({ routes: routes, store: store }){
        this.dynamicRoutes = [];
        this.staticRoutes = new Set();
        this.updateUrl = ()=>{
            const state = this.store.getState();
            const route = this.getRoute();
            // Clamp the browser's URL to a known route.
            if (location.hash.slice(1) !== route.pathName) {
                const url = new URL(String(location));
                url.hash = route.pathName;
                history.replaceState({}, "", url);
            }
            if (state.route.pathName !== route.pathName) this.store.dispatch($fTsmx.change(route));
        };
        this.store = store;
        // Put paths with `:id` matchers in a different collection.
        routes.forEach((id)=>{
            if (/:/.test(id)) {
                const parts = this.getParts(id);
                this.dynamicRoutes.push({
                    parts: parts,
                    id: id
                });
            } else this.staticRoutes.add(id);
        });
    }
    getRoute() {
        const pathName = $a1dd997125913da6$export$2e2bcd8739ae039.normalizePath(location.hash);
        if (this.staticRoutes.has(pathName)) return {
            id: pathName,
            pathName: pathName,
            params: {}
        };
        return this.resolveDynamicRoute(pathName);
    }
    resolveDynamicRoute(pathName) {
        const parts = this.getParts(pathName);
        function matchesRoute(matcher) {
            return matcher.parts.every((part, index)=>{
                const isMatcher = part[0] === ":"; // :someIdentifier
                return isMatcher ? true : parts[index] === part;
            });
        }
        const matchingRoutes = this.dynamicRoutes.filter((matcher)=>parts.length === matcher.parts.length).filter(matchesRoute);
        // Each path should match exactly one route.
        (0, $kBs7x.default)(matchingRoutes.length <= 1, `Ambiguous route: ${pathName}`);
        return this.fillDynamicRoute(matchingRoutes[0], pathName, parts);
    }
    fillDynamicRoute(route, pathName, parts) {
        if (!route) return {
            id: "/",
            pathName: "/",
            params: {}
        };
        const params = {};
        route.parts.forEach((part, index)=>{
            if (part[0] === ":") params[part.slice(1)] = parts[index];
        });
        return {
            id: route.id,
            pathName: pathName,
            params: params
        };
    }
    // '/path/to/resource' -> ['path', 'to', 'resource']
    getParts(pathName) {
        return pathName.split("/").filter(Boolean);
    }
}





var $kXV5G = parcelRequire("kXV5G");
(0, $a1dd997125913da6$export$2e2bcd8739ae039).init({
    store: $kEzJs.default,
    routes: Object.values((0, $kXV5G.Routes))
});
/**
 * First, let me say that yes, I'm insane. But the insanity has reason.
 * Content should always fill available space, and the body's default styles
 * don't lend well. This essentially redefines the body container to be
 * perfectly sized to the available space.
 *
 * If this ends up causing trouble, it may be preferable to add flex displays
 * at every parent element.
 */ const $aed0bfc6ffd293e9$var$Viewport = (0, $87bc0af96408f074$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  position: fixed;
  overflow: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-family: sans-serif;

  // App-wide theme settings.
  ${(0, $e3d2f960b7adbb55$export$8e6c2fd52e77e91)((0, $e3d2f960b7adbb55$export$4b610b199ad29569))}

  @media (prefers-color-scheme: light) {
    ${(0, $e3d2f960b7adbb55$export$8e6c2fd52e77e91)((0, $e3d2f960b7adbb55$export$d393aa634cc9c07))}
  }

  background-color: var(--color-background);
  color: var(--color-text);
`;
(0, $9653adc0814ac645$export$882461b6382ed46c)(document.getElementById("root")).render(/*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5vDX4))).StrictMode, {
    children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $45449cf8cc6ac673$export$2e2bcd8739ae039), {
        store: (0, $kEzJs.default),
        children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)($aed0bfc6ffd293e9$var$Viewport, {
            children: /*#__PURE__*/ (0, $33a4b0efc5f73897$exports.jsx)((0, $aeb822ff39ba5368$export$2e2bcd8739ae039), {})
        })
    })
}));


//# sourceMappingURL=index.70ed9bc3.js.map
